/*
 * GENERATED FILE — DO NOT EDIT BY HAND.
 *
 * Primary sources:
 *   semantic-mappings.production.v1.jsonl
 *   semantic-mappings.recovered.v1.jsonl
 *
 * Fallback source:
 *   semantic-alignment-input.v8.jsonl
 *   lidLearning.ts TERM_RAW lexical cues
 *
 * Policy:
 *   validated production semantic mappings first
 *   translated:null units are intentionally omitted
 *   lexical fallback only outside production universe
 */

import type {
  LidSemanticTranslationPair,
} from './lidSemanticOverrides';

export const GENERATED_QUESTION_TRANSLATION_PAIRS:
  Record<string, LidSemanticTranslationPair[]> = {
  "lid:general:DE:100|ar": [
    {
      german: "Was",
      translated: "أي",
      tone: 'semantic',
    },
    {
      german: "gehört nicht",
      translated: "لا يندرج",
      tone: 'semantic',
    },
    {
      german: "zur",
      translated: "ضمن",
      tone: 'semantic',
    },
    {
      german: "gesetzlichen Sozialversicherung",
      translated: "التأمين الاجتماعي القانوني",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:100|bg": [
    {
      german: "Was",
      translated: "Кое",
      tone: 'semantic',
    },
    {
      german: "gehört nicht",
      translated: "НЕ е",
      tone: 'semantic',
    },
    {
      german: "zur",
      translated: "от",
      tone: 'semantic',
    },
    {
      german: "gesetzlichen Sozialversicherung",
      translated: "задължителното социално осигуряване",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:100|bs": [
    {
      german: "Was",
      translated: "Što",
      tone: 'semantic',
    },
    {
      german: "gehört nicht",
      translated: "NE pripada",
      tone: 'semantic',
    },
    {
      german: "gesetzlichen Sozialversicherung",
      translated: "obveznim socijalnim osiguranjima",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:100|el": [
    {
      german: "Was",
      translated: "Ποια",
      tone: 'semantic',
    },
    {
      german: "gehört nicht",
      translated: "ΔΕΝ ανήκει",
      tone: 'semantic',
    },
    {
      german: "zur",
      translated: "στις",
      tone: 'semantic',
    },
    {
      german: "gesetzlichen Sozialversicherung",
      translated: "υποχρεωτικές κοινωνικές ασφαλίσεις",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:100|en": [
    {
      german: "Was",
      translated: "What",
      tone: 'semantic',
    },
    {
      german: "gehört nicht",
      translated: "does NOT belong",
      tone: 'semantic',
    },
    {
      german: "zur",
      translated: "to",
      tone: 'semantic',
    },
    {
      german: "gesetzlichen Sozialversicherung",
      translated: "statutory social insurance",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:100|es": [
    {
      german: "Was",
      translated: "Cuál",
      tone: 'semantic',
    },
    {
      german: "gehört nicht",
      translated: "NO forma parte",
      tone: 'semantic',
    },
    {
      german: "zur",
      translated: "de la",
      tone: 'semantic',
    },
    {
      german: "gesetzlichen Sozialversicherung",
      translated: "seguridad social obligatoria",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:100|fa": [
    {
      german: "Was",
      translated: "کدام",
      tone: 'semantic',
    },
    {
      german: "gehört nicht",
      translated: "نیست",
      tone: 'semantic',
    },
    {
      german: "gesetzlichen Sozialversicherung",
      translated: "بیمهٔ اجتماعی قانونی",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:100|fr": [
    {
      german: "Was",
      translated: "Lequel",
      tone: 'semantic',
    },
    {
      german: "gehört nicht",
      translated: "ne fait pas partie",
      tone: 'semantic',
    },
    {
      german: "zur",
      translated: "de",
      tone: 'semantic',
    },
    {
      german: "gesetzlichen Sozialversicherung",
      translated: "l’assurance sociale légale",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:100|hr": [
    {
      german: "Was",
      translated: "Što",
      tone: 'semantic',
    },
    {
      german: "gehört nicht",
      translated: "NE pripada",
      tone: 'semantic',
    },
    {
      german: "gesetzlichen Sozialversicherung",
      translated: "obveznim socijalnim osiguranjima",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:100|it": [
    {
      german: "Was",
      translated: "Quale",
      tone: 'semantic',
    },
    {
      german: "gehört nicht",
      translated: "NON fa parte",
      tone: 'semantic',
    },
    {
      german: "zur",
      translated: "delle",
      tone: 'semantic',
    },
    {
      german: "gesetzlichen Sozialversicherung",
      translated: "assicurazioni sociali obbligatorie",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:100|kmr": [
    {
      german: "Was",
      translated: "Kîjan",
      tone: 'semantic',
    },
    {
      german: "gehört nicht",
      translated: "ji van ne",
      tone: 'semantic',
    },
    {
      german: "zur",
      translated: "beşek",
      tone: 'semantic',
    },
    {
      german: "gesetzlichen Sozialversicherung",
      translated: "bîmeya civakî ya qanûnî",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:100|pl": [
    {
      german: "Was",
      translated: "Które",
      tone: 'semantic',
    },
    {
      german: "gehört nicht",
      translated: "NIE należy",
      tone: 'semantic',
    },
    {
      german: "zur",
      translated: "do",
      tone: 'semantic',
    },
    {
      german: "gesetzlichen Sozialversicherung",
      translated: "obowiązkowych ubezpieczeń społecznych",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:100|prs": [
    {
      german: "Was",
      translated: "کدام",
      tone: 'semantic',
    },
    {
      german: "gehört nicht",
      translated: "نیست",
      tone: 'semantic',
    },
    {
      german: "zur",
      translated: "جزو",
      tone: 'semantic',
    },
    {
      german: "gesetzlichen Sozialversicherung",
      translated: "بیمهٔ اجتماعی قانونی",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:100|ro": [
    {
      german: "Was",
      translated: "Care",
      tone: 'semantic',
    },
    {
      german: "gehört nicht",
      translated: "NU face parte",
      tone: 'semantic',
    },
    {
      german: "zur",
      translated: "din",
      tone: 'semantic',
    },
    {
      german: "gesetzlichen Sozialversicherung",
      translated: "asigurările sociale obligatorii",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:100|ru": [
    {
      german: "Was",
      translated: "Что",
      tone: 'semantic',
    },
    {
      german: "gehört nicht",
      translated: "не входит",
      tone: 'semantic',
    },
    {
      german: "zur",
      translated: "в",
      tone: 'semantic',
    },
    {
      german: "gesetzlichen Sozialversicherung",
      translated: "обязательное социальное страхование",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:100|sq": [
    {
      german: "Was",
      translated: "Cila",
      tone: 'semantic',
    },
    {
      german: "gehört nicht",
      translated: "NUK bën pjesë",
      tone: 'semantic',
    },
    {
      german: "zur",
      translated: "në",
      tone: 'semantic',
    },
    {
      german: "gesetzlichen Sozialversicherung",
      translated: "sigurimet shoqërore të detyrueshme",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:100|sr": [
    {
      german: "Was",
      translated: "Šta",
      tone: 'semantic',
    },
    {
      german: "gehört nicht",
      translated: "NE pripada",
      tone: 'semantic',
    },
    {
      german: "gesetzlichen Sozialversicherung",
      translated: "obveznim socijalnim osiguranjima",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:100|tr": [
    {
      german: "Was",
      translated: "hangisi",
      tone: 'semantic',
    },
    {
      german: "gehört nicht",
      translated: "dahil değildir",
      tone: 'semantic',
    },
    {
      german: "gesetzlichen Sozialversicherung",
      translated: "yasal sosyal sigorta",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:100|uk": [
    {
      german: "Was",
      translated: "Що",
      tone: 'semantic',
    },
    {
      german: "gehört nicht",
      translated: "не належить",
      tone: 'semantic',
    },
    {
      german: "zur",
      translated: "до",
      tone: 'semantic',
    },
    {
      german: "gesetzlichen Sozialversicherung",
      translated: "обов’язкового державного соціального страхування",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:100|vi": [
    {
      german: "Was",
      translated: "Loại nào",
      tone: 'semantic',
    },
    {
      german: "gehört nicht",
      translated: "KHÔNG thuộc",
      tone: 'semantic',
    },
    {
      german: "gesetzlichen Sozialversicherung",
      translated: "hệ thống bảo hiểm xã hội bắt buộc",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:101|ar": [
    {
      german: "Gewerkschaften",
      translated: "النقابات العمالية",
      tone: 'semantic',
    },
    {
      german: "sind",
      translated: "هي",
      tone: 'semantic',
    },
    {
      german: "Interessenverbände",
      translated: "جمعيات مصالح",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:101|bg": [
    {
      german: "Gewerkschaften",
      translated: "Профсъюзите",
      tone: 'semantic',
    },
    {
      german: "sind",
      translated: "са",
      tone: 'semantic',
    },
    {
      german: "Interessenverbände",
      translated: "групи по интереси",
      tone: 'semantic',
    },
    {
      german: "der",
      translated: "на",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:101|bs": [
    {
      german: "Gewerkschaften",
      translated: "Sindikati",
      tone: 'semantic',
    },
    {
      german: "sind",
      translated: "su",
      tone: 'semantic',
    },
    {
      german: "Interessenverbände",
      translated: "interesne skupine",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:101|el": [
    {
      german: "Gewerkschaften",
      translated: "συνδικάτα",
      tone: 'semantic',
    },
    {
      german: "sind",
      translated: "είναι",
      tone: 'semantic',
    },
    {
      german: "Interessenverbände",
      translated: "ομάδες συμφερόντων",
      tone: 'semantic',
    },
    {
      german: "der",
      translated: "των",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:101|en": [
    {
      german: "Gewerkschaften",
      translated: "Trade unions",
      tone: 'semantic',
    },
    {
      german: "sind",
      translated: "are",
      tone: 'semantic',
    },
    {
      german: "Interessenverbände",
      translated: "interest groups",
      tone: 'semantic',
    },
    {
      german: "der",
      translated: "of",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:101|es": [
    {
      german: "Gewerkschaften",
      translated: "sindicatos",
      tone: 'semantic',
    },
    {
      german: "sind",
      translated: "son",
      tone: 'semantic',
    },
    {
      german: "Interessenverbände",
      translated: "grupos de interés",
      tone: 'semantic',
    },
    {
      german: "der",
      translated: "de",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:101|fa": [
    {
      german: "Gewerkschaften",
      translated: "اتحادیه‌های کارگری",
      tone: 'semantic',
    },
    {
      german: "sind",
      translated: "هستند",
      tone: 'semantic',
    },
    {
      german: "Interessenverbände",
      translated: "گروه‌های ذی‌نفعِ",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:101|fr": [
    {
      german: "Gewerkschaften",
      translated: "Les syndicats",
      tone: 'semantic',
    },
    {
      german: "sind",
      translated: "sont",
      tone: 'semantic',
    },
    {
      german: "Interessenverbände",
      translated: "groupes d’intérêt",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:101|hr": [
    {
      german: "Gewerkschaften",
      translated: "Sindikati",
      tone: 'semantic',
    },
    {
      german: "sind",
      translated: "su",
      tone: 'semantic',
    },
    {
      german: "Interessenverbände",
      translated: "interesne skupine",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:101|it": [
    {
      german: "Gewerkschaften",
      translated: "sindacati",
      tone: 'semantic',
    },
    {
      german: "sind",
      translated: "rappresentano",
      tone: 'semantic',
    },
    {
      german: "Interessenverbände",
      translated: "gli interessi",
      tone: 'semantic',
    },
    {
      german: "der",
      translated: "dei",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:101|kmr": [
    {
      german: "Gewerkschaften",
      translated: "Sendîka",
      tone: 'semantic',
    },
    {
      german: "Interessenverbände",
      translated: "nûneriya berjewendiyên",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:101|pl": [
    {
      german: "Gewerkschaften",
      translated: "Związki zawodowe",
      tone: 'semantic',
    },
    {
      german: "sind",
      translated: "są",
      tone: 'semantic',
    },
    {
      german: "Interessenverbände",
      translated: "grupami interesu",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:101|prs": [
    {
      german: "Gewerkschaften",
      translated: "اتحادیه‌های کارگری",
      tone: 'semantic',
    },
    {
      german: "sind",
      translated: "هستند",
      tone: 'semantic',
    },
    {
      german: "Interessenverbände",
      translated: "گروه‌های ذی‌نفعِ",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:101|ro": [
    {
      german: "Gewerkschaften",
      translated: "Sindicatele",
      tone: 'semantic',
    },
    {
      german: "sind",
      translated: "sunt",
      tone: 'semantic',
    },
    {
      german: "Interessenverbände",
      translated: "grupuri de interese",
      tone: 'semantic',
    },
    {
      german: "der",
      translated: "ale",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:101|ru": [
    {
      german: "Gewerkschaften",
      translated: "Профсоюзы",
      tone: 'semantic',
    },
    {
      german: "sind",
      translated: "это",
      tone: 'semantic',
    },
    {
      german: "Interessenverbände",
      translated: "объединения по интересам",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:101|sq": [
    {
      german: "Gewerkschaften",
      translated: "Sindikatat",
      tone: 'semantic',
    },
    {
      german: "sind",
      translated: "përfaqësojnë",
      tone: 'semantic',
    },
    {
      german: "Interessenverbände",
      translated: "interesat",
      tone: 'semantic',
    },
    {
      german: "der",
      translated: "e",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:101|sr": [
    {
      german: "Gewerkschaften",
      translated: "Sindikati",
      tone: 'semantic',
    },
    {
      german: "sind",
      translated: "su",
      tone: 'semantic',
    },
    {
      german: "Interessenverbände",
      translated: "interesne skupine",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:101|tr": [
    {
      german: "Gewerkschaften",
      translated: "Sendikalar",
      tone: 'semantic',
    },
    {
      german: "Interessenverbände",
      translated: "çıkarlarını temsil eden",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:101|uk": [
    {
      german: "Gewerkschaften",
      translated: "Профспілки",
      tone: 'semantic',
    },
    {
      german: "sind",
      translated: "є",
      tone: 'semantic',
    },
    {
      german: "Interessenverbände",
      translated: "об’єднаннями",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:101|vi": [
    {
      german: "Gewerkschaften",
      translated: "công đoàn",
      tone: 'semantic',
    },
    {
      german: "Interessenverbände",
      translated: "lợi ích",
      tone: 'semantic',
    },
    {
      german: "der",
      translated: "của",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:102|ar": [
    {
      german: "Womit kann man",
      translated: "بماذا يمكن",
      tone: 'semantic',
    },
    {
      german: "in der Bundesrepublik Deutschland",
      translated: "في جمهورية ألمانيا الاتحادية",
      tone: 'semantic',
    },
    {
      german: "geehrt werden",
      translated: "تكريم",
      tone: 'semantic',
    },
    {
      german: "wenn man",
      translated: "إذا",
      tone: 'semantic',
    },
    {
      german: "auf politischem, wirtschaftlichem, kulturellem, geistigem oder sozialem Gebiet",
      translated: "في المجال السياسي أو الاقتصادي أو الثقافي أو الفكري أو الاجتماعي",
      tone: 'semantic',
    },
    {
      german: "eine besondere Leistung",
      translated: "إنجازًا مميزًا",
      tone: 'semantic',
    },
    {
      german: "erbracht hat",
      translated: "قدم",
      tone: 'semantic',
    },
    {
      german: "Mit dem",
      translated: "بـ",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:102|bg": [
    {
      german: "Womit kann man",
      translated: "Какво отличие може",
      tone: 'semantic',
    },
    {
      german: "in der Bundesrepublik Deutschland",
      translated: "във Федерална република Германия",
      tone: 'semantic',
    },
    {
      german: "geehrt werden",
      translated: "да бъде присъдено",
      tone: 'semantic',
    },
    {
      german: "auf politischem, wirtschaftlichem, kulturellem, geistigem oder sozialem Gebiet",
      translated: "в политическата, икономическата, културната, духовната или социалната област",
      tone: 'semantic',
    },
    {
      german: "eine besondere Leistung",
      translated: "особени заслуги",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:102|bs": [
    {
      german: "Womit kann man",
      translated: "Koje se odlikovanje",
      tone: 'semantic',
    },
    {
      german: "in der Bundesrepublik Deutschland",
      translated: "u Saveznoj Republici Njemačkoj",
      tone: 'semantic',
    },
    {
      german: "geehrt werden",
      translated: "može dodijeliti",
      tone: 'semantic',
    },
    {
      german: "auf politischem, wirtschaftlichem, kulturellem, geistigem oder sozialem Gebiet",
      translated: "na političkom, privrednom, kulturnom, intelektualnom ili društvenom području",
      tone: 'semantic',
    },
    {
      german: "eine besondere Leistung",
      translated: "posebne zasluge",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:102|el": [
    {
      german: "Womit kann man",
      translated: "Ποια διάκριση",
      tone: 'semantic',
    },
    {
      german: "in der Bundesrepublik Deutschland",
      translated: "στην Ομοσπονδιακή Δημοκρατία της Γερμανίας",
      tone: 'semantic',
    },
    {
      german: "geehrt werden",
      translated: "να απονεμηθεί",
      tone: 'semantic',
    },
    {
      german: "auf politischem, wirtschaftlichem, kulturellem, geistigem oder sozialem Gebiet",
      translated: "στον πολιτικό, οικονομικό, πολιτιστικό, πνευματικό ή κοινωνικό τομέα",
      tone: 'semantic',
    },
    {
      german: "eine besondere Leistung",
      translated: "ιδιαίτερες υπηρεσίες",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:102|en": [
    {
      german: "Womit kann man",
      translated: "What can you",
      tone: 'semantic',
    },
    {
      german: "in der Bundesrepublik Deutschland",
      translated: "in the Federal Republic of Germany",
      tone: 'semantic',
    },
    {
      german: "geehrt werden",
      translated: "be honored",
      tone: 'semantic',
    },
    {
      german: "wenn man",
      translated: "if you",
      tone: 'semantic',
    },
    {
      german: "auf politischem, wirtschaftlichem, kulturellem, geistigem oder sozialem Gebiet",
      translated: "in political, economic, cultural, intellectual, or social fields",
      tone: 'semantic',
    },
    {
      german: "eine besondere Leistung",
      translated: "outstanding performance",
      tone: 'semantic',
    },
    {
      german: "erbracht hat",
      translated: "have achieved",
      tone: 'semantic',
    },
    {
      german: "Mit dem",
      translated: "With the",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:102|es": [
    {
      german: "Womit kann man",
      translated: "¿Con qué se puede",
      tone: 'semantic',
    },
    {
      german: "in der Bundesrepublik Deutschland",
      translated: "en la República Federal de Alemania",
      tone: 'semantic',
    },
    {
      german: "geehrt werden",
      translated: "distinguir",
      tone: 'semantic',
    },
    {
      german: "wenn man",
      translated: "por",
      tone: 'semantic',
    },
    {
      german: "auf politischem, wirtschaftlichem, kulturellem, geistigem oder sozialem Gebiet",
      translated: "en los ámbitos político, económico, cultural, intelectual o social",
      tone: 'semantic',
    },
    {
      german: "eine besondere Leistung",
      translated: "logros destacados",
      tone: 'semantic',
    },
    {
      german: "Mit dem",
      translated: "Con la",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:102|fa": [
    {
      german: "Womit kann man",
      translated: "چه",
      tone: 'semantic',
    },
    {
      german: "in der Bundesrepublik Deutschland",
      translated: "در جمهوری فدرال آلمان",
      tone: 'semantic',
    },
    {
      german: "geehrt werden",
      translated: "دریافت شود",
      tone: 'semantic',
    },
    {
      german: "auf politischem, wirtschaftlichem, kulturellem, geistigem oder sozialem Gebiet",
      translated: "در زمینه‌های سیاسی، اقتصادی، فرهنگی، فکری یا اجتماعی",
      tone: 'semantic',
    },
    {
      german: "eine besondere Leistung",
      translated: "دستاوردهای ویژه",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:102|fr": [
    {
      german: "Womit kann man",
      translated: "Par quoi peut-on",
      tone: 'semantic',
    },
    {
      german: "in der Bundesrepublik Deutschland",
      translated: "en République fédérale d’Allemagne",
      tone: 'semantic',
    },
    {
      german: "geehrt werden",
      translated: "être honoré",
      tone: 'semantic',
    },
    {
      german: "wenn man",
      translated: "lorsqu’on",
      tone: 'semantic',
    },
    {
      german: "auf politischem, wirtschaftlichem, kulturellem, geistigem oder sozialem Gebiet",
      translated: "dans le domaine politique, économique, culturel, intellectuel ou social",
      tone: 'semantic',
    },
    {
      german: "eine besondere Leistung",
      translated: "quelque chose d’exceptionnel",
      tone: 'semantic',
    },
    {
      german: "erbracht hat",
      translated: "a accompli",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:102|hr": [
    {
      german: "Womit kann man",
      translated: "Koje se odlikovanje",
      tone: 'semantic',
    },
    {
      german: "in der Bundesrepublik Deutschland",
      translated: "u Saveznoj Republici Njemačkoj",
      tone: 'semantic',
    },
    {
      german: "geehrt werden",
      translated: "može dodijeliti",
      tone: 'semantic',
    },
    {
      german: "wenn man",
      translated: "za",
      tone: 'semantic',
    },
    {
      german: "auf politischem, wirtschaftlichem, kulturellem, geistigem oder sozialem Gebiet",
      translated: "na političkom, gospodarskom, kulturnom, intelektualnom ili društvenom području",
      tone: 'semantic',
    },
    {
      german: "eine besondere Leistung",
      translated: "posebne zasluge",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:102|it": [
    {
      german: "Womit kann man",
      translated: "Quale onorificenza può essere",
      tone: 'semantic',
    },
    {
      german: "in der Bundesrepublik Deutschland",
      translated: "nella Repubblica Federale di Germania",
      tone: 'semantic',
    },
    {
      german: "geehrt werden",
      translated: "conferita",
      tone: 'semantic',
    },
    {
      german: "auf politischem, wirtschaftlichem, kulturellem, geistigem oder sozialem Gebiet",
      translated: "in ambito politico, economico, culturale, intellettuale o sociale",
      tone: 'semantic',
    },
    {
      german: "eine besondere Leistung",
      translated: "meriti particolari",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:102|kmr": [
    {
      german: "Womit kann man",
      translated: "bi çi were",
      tone: 'semantic',
    },
    {
      german: "in der Bundesrepublik Deutschland",
      translated: "Li Komara Federal a Almanyayê",
      tone: 'semantic',
    },
    {
      german: "geehrt werden",
      translated: "rêzgirtin",
      tone: 'semantic',
    },
    {
      german: "wenn man",
      translated: "kesek ku",
      tone: 'semantic',
    },
    {
      german: "auf politischem, wirtschaftlichem, kulturellem, geistigem oder sozialem Gebiet",
      translated: "di warê siyasî, aborî, çandî, fikrî an civakî de",
      tone: 'semantic',
    },
    {
      german: "eine besondere Leistung",
      translated: "serkeftinek taybet",
      tone: 'semantic',
    },
    {
      german: "erbracht hat",
      translated: "kiriye dikare",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:102|pl": [
    {
      german: "Womit kann man",
      translated: "Jakie odznaczenie może",
      tone: 'semantic',
    },
    {
      german: "in der Bundesrepublik Deutschland",
      translated: "w Republice Federalnej Niemiec",
      tone: 'semantic',
    },
    {
      german: "geehrt werden",
      translated: "zostać przyznane",
      tone: 'semantic',
    },
    {
      german: "wenn man",
      translated: "za",
      tone: 'semantic',
    },
    {
      german: "auf politischem, wirtschaftlichem, kulturellem, geistigem oder sozialem Gebiet",
      translated: "w dziedzinie politycznej, gospodarczej, kulturalnej, intelektualnej lub społecznej",
      tone: 'semantic',
    },
    {
      german: "eine besondere Leistung",
      translated: "szczególne zasługi",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:102|prs": [
    {
      german: "Womit kann man",
      translated: "ممکن است چه",
      tone: 'semantic',
    },
    {
      german: "in der Bundesrepublik Deutschland",
      translated: "در جمهوری فدرال آلمان",
      tone: 'semantic',
    },
    {
      german: "geehrt werden",
      translated: "نشان افتخاری",
      tone: 'semantic',
    },
    {
      german: "auf politischem, wirtschaftlichem, kulturellem, geistigem oder sozialem Gebiet",
      translated: "در زمینه‌های سیاسی، اقتصادی، فرهنگی، فکری یا اجتماعی",
      tone: 'semantic',
    },
    {
      german: "eine besondere Leistung",
      translated: "دستاوردهای ویژه",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:102|ro": [
    {
      german: "Womit kann man",
      translated: "Ce distincție",
      tone: 'semantic',
    },
    {
      german: "in der Bundesrepublik Deutschland",
      translated: "în Republica Federală Germania",
      tone: 'semantic',
    },
    {
      german: "geehrt werden",
      translated: "poate fi acordată",
      tone: 'semantic',
    },
    {
      german: "auf politischem, wirtschaftlichem, kulturellem, geistigem oder sozialem Gebiet",
      translated: "în domeniul politic, economic, cultural, intelectual sau social",
      tone: 'semantic',
    },
    {
      german: "eine besondere Leistung",
      translated: "merite deosebite",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:102|ru": [
    {
      german: "Womit kann man",
      translated: "Чем можно",
      tone: 'semantic',
    },
    {
      german: "in der Bundesrepublik Deutschland",
      translated: "в Германии",
      tone: 'semantic',
    },
    {
      german: "geehrt werden",
      translated: "быть награждённым",
      tone: 'semantic',
    },
    {
      german: "auf politischem, wirtschaftlichem, kulturellem, geistigem oder sozialem Gebiet",
      translated: "в политической, экономической, культурной, духовной или социальной сфере",
      tone: 'semantic',
    },
    {
      german: "eine besondere Leistung",
      translated: "особые заслуги",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:102|sq": [
    {
      german: "Womit kann man",
      translated: "Cila dekoratë mund",
      tone: 'semantic',
    },
    {
      german: "in der Bundesrepublik Deutschland",
      translated: "në Republikën Federale të Gjermanisë",
      tone: 'semantic',
    },
    {
      german: "geehrt werden",
      translated: "të jepet",
      tone: 'semantic',
    },
    {
      german: "auf politischem, wirtschaftlichem, kulturellem, geistigem oder sozialem Gebiet",
      translated: "në fushën politike, ekonomike, kulturore, intelektuale ose sociale",
      tone: 'semantic',
    },
    {
      german: "eine besondere Leistung",
      translated: "merita të veçanta",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:102|sr": [
    {
      german: "Womit kann man",
      translated: "Koje se odlikovanje",
      tone: 'semantic',
    },
    {
      german: "in der Bundesrepublik Deutschland",
      translated: "u Saveznoj Republici Nemačkoj",
      tone: 'semantic',
    },
    {
      german: "geehrt werden",
      translated: "može dodijeliti",
      tone: 'semantic',
    },
    {
      german: "wenn man",
      translated: "za",
      tone: 'semantic',
    },
    {
      german: "auf politischem, wirtschaftlichem, kulturellem, geistigem oder sozialem Gebiet",
      translated: "na političkom, privrednom, kulturnom, intelektualnom ili društvenom oblasti?",
      tone: 'semantic',
    },
    {
      german: "eine besondere Leistung",
      translated: "posebne zasluge",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:102|tr": [
    {
      german: "Womit kann man",
      translated: "hangi ödülle",
      tone: 'semantic',
    },
    {
      german: "in der Bundesrepublik Deutschland",
      translated: "Almanya Federal Cumhuriyeti'nde",
      tone: 'semantic',
    },
    {
      german: "geehrt werden",
      translated: "onurlandırılabilir",
      tone: 'semantic',
    },
    {
      german: "wenn man",
      translated: "gösteren kişi",
      tone: 'semantic',
    },
    {
      german: "auf politischem, wirtschaftlichem, kulturellem, geistigem oder sozialem Gebiet",
      translated: "siyasi, ekonomik, kültürel, düşünsel veya sosyal alanda",
      tone: 'semantic',
    },
    {
      german: "eine besondere Leistung",
      translated: "özel bir başarı",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:102|uk": [
    {
      german: "Womit kann man",
      translated: "Чим",
      tone: 'semantic',
    },
    {
      german: "in der Bundesrepublik Deutschland",
      translated: "у Федеративній Республіці Німеччина",
      tone: 'semantic',
    },
    {
      german: "geehrt werden",
      translated: "нагородити",
      tone: 'semantic',
    },
    {
      german: "auf politischem, wirtschaftlichem, kulturellem, geistigem oder sozialem Gebiet",
      translated: "в політичній, економічній, культурній, інтелектуальній або соціальній сфері",
      tone: 'semantic',
    },
    {
      german: "eine besondere Leistung",
      translated: "особливі заслуги",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:102|vi": [
    {
      german: "Womit kann man",
      translated: "phần thưởng nào",
      tone: 'semantic',
    },
    {
      german: "in der Bundesrepublik Deutschland",
      translated: "Ở Cộng hòa Liên bang Đức",
      tone: 'semantic',
    },
    {
      german: "geehrt werden",
      translated: "có thể được trao",
      tone: 'semantic',
    },
    {
      german: "auf politischem, wirtschaftlichem, kulturellem, geistigem oder sozialem Gebiet",
      translated: "trong lĩnh vực chính trị, kinh tế, văn hóa, trí tuệ hoặc xã hội",
      tone: 'semantic',
    },
    {
      german: "eine besondere Leistung",
      translated: "những đóng góp đặc biệt",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:103|ar": [
    {
      german: "Was",
      translated: "ما",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "في ألمانيا",
      tone: 'semantic',
    },
    {
      german: "als",
      translated: "بـ",
      tone: 'semantic',
    },
    {
      german: "Ampelkoalition",
      translated: "ائتلاف إشارة المرور",
      tone: 'semantic',
    },
    {
      german: "bezeichnet",
      translated: "المقصود",
      tone: 'semantic',
    },
    {
      german: "Die Zusammenarbeit",
      translated: "تعاون",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:103|bg": [
    {
      german: "Was",
      translated: "какво",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:103|bs": [
    {
      german: "Was",
      translated: "Što",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "u Njemačkoj",
      tone: 'semantic',
    },
    {
      german: "Ampelkoalition",
      translated: "(Ampelkoalition)",
      tone: 'semantic',
    },
    {
      german: "bezeichnet",
      translated: "znači",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:103|el": [
    {
      german: "Was",
      translated: "Τι",
      tone: 'semantic',
    },
    {
      german: "wird",
      translated: "σημαίνει",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "στη Γερμανία",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:103|en": [
    {
      german: "Was",
      translated: "What",
      tone: 'semantic',
    },
    {
      german: "wird",
      translated: "is",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "in Germany",
      tone: 'semantic',
    },
    {
      german: "als",
      translated: "as",
      tone: 'semantic',
    },
    {
      german: "Ampelkoalition",
      translated: "traffic light coalition",
      tone: 'semantic',
    },
    {
      german: "bezeichnet",
      translated: "referred",
      tone: 'semantic',
    },
    {
      german: "Die Zusammenarbeit",
      translated: "The cooperation",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:103|es": [
    {
      german: "Was",
      translated: "Qué",
      tone: 'semantic',
    },
    {
      german: "wird",
      translated: "se",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "en Alemania",
      tone: 'semantic',
    },
    {
      german: "als",
      translated: "por",
      tone: 'semantic',
    },
    {
      german: "Ampelkoalition",
      translated: "coalición semáforo",
      tone: 'semantic',
    },
    {
      german: "bezeichnet",
      translated: "entiende",
      tone: 'semantic',
    },
    {
      german: "Die Zusammenarbeit",
      translated: "La cooperación",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:103|fa": [
    {
      german: "Was",
      translated: "چه",
      tone: 'semantic',
    },
    {
      german: "wird",
      translated: "می‌شود",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "در آلمان",
      tone: 'semantic',
    },
    {
      german: "als",
      translated: "به",
      tone: 'semantic',
    },
    {
      german: "Ampelkoalition",
      translated: "Ampelkoalition",
      tone: 'semantic',
    },
    {
      german: "bezeichnet",
      translated: "گفته",
      tone: 'semantic',
    },
    {
      german: "Die Zusammenarbeit",
      translated: "همکاری‌ای",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:103|fr": [
    {
      german: "in Deutschland",
      translated: "en Allemagne",
      tone: 'semantic',
    },
    {
      german: "Ampelkoalition",
      translated: "coalition feu tricolore",
      tone: 'semantic',
    },
    {
      german: "Die Zusammenarbeit",
      translated: "La coopération",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:103|hr": [
    {
      german: "Was",
      translated: "što",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:103|it": [
    {
      german: "Was",
      translated: "cosa",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:103|kmr": [
    {
      german: "Was",
      translated: "çi",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:103|pl": [
    {
      german: "Was",
      translated: "co",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:103|prs": [
    {
      german: "Was",
      translated: "چه",
      tone: 'semantic',
    },
    {
      german: "wird",
      translated: "می‌شود",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "در آلمان",
      tone: 'semantic',
    },
    {
      german: "Ampelkoalition",
      translated: "Ampelkoalition",
      tone: 'semantic',
    },
    {
      german: "bezeichnet",
      translated: "گفته",
      tone: 'semantic',
    },
    {
      german: "Die Zusammenarbeit",
      translated: "همکاری‌ای",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:103|ro": [
    {
      german: "Was",
      translated: "ce",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:103|ru": [
    {
      german: "Was",
      translated: "Что",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "в Германии",
      tone: 'semantic',
    },
    {
      german: "Ampelkoalition",
      translated: "«светофорной коалицией»",
      tone: 'semantic',
    },
    {
      german: "bezeichnet",
      translated: "называют",
      tone: 'semantic',
    },
    {
      german: "Die Zusammenarbeit",
      translated: "Сотрудничество",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:103|sq": [
    {
      german: "Was",
      translated: "çfarë",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:103|sr": [
    {
      german: "Was",
      translated: "šta",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:103|uk": [
    {
      german: "Was",
      translated: "Що",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "в Німеччині",
      tone: 'semantic',
    },
    {
      german: "Ampelkoalition",
      translated: "(Ampelkoalition)",
      tone: 'semantic',
    },
    {
      german: "bezeichnet",
      translated: "називають",
      tone: 'semantic',
    },
    {
      german: "Die Zusammenarbeit",
      translated: "Співпрацю",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:103|vi": [
    {
      german: "Was",
      translated: "gì?",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:104|ar": [
    {
      german: "Eine Frau",
      translated: "امرأة",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "في ألمانيا",
      tone: 'semantic',
    },
    {
      german: "Was darf nicht",
      translated: "لا يجوز",
      tone: 'semantic',
    },
    {
      german: "der Grund",
      translated: "سبب",
      tone: 'semantic',
    },
    {
      german: "für diese Entlassung",
      translated: "لفصلها",
      tone: 'semantic',
    },
    {
      german: "sein",
      translated: "أن يكون",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:104|bg": [
    {
      german: "Eine Frau",
      translated: "Жена",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "в Германия",
      tone: 'semantic',
    },
    {
      german: "verliert ihre Arbeit",
      translated: "губи работата си",
      tone: 'semantic',
    },
    {
      german: "Was darf nicht",
      translated: "НЕ може",
      tone: 'semantic',
    },
    {
      german: "der Grund",
      translated: "причина",
      tone: 'semantic',
    },
    {
      german: "für diese Entlassung",
      translated: "уволнението",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:104|bs": [
    {
      german: "Eine Frau",
      translated: "Žena",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "u Njemačkoj",
      tone: 'semantic',
    },
    {
      german: "verliert ihre Arbeit",
      translated: "gubi posao",
      tone: 'semantic',
    },
    {
      german: "Was darf nicht",
      translated: "Koji razlog NE smije",
      tone: 'semantic',
    },
    {
      german: "der Grund",
      translated: "razlog",
      tone: 'semantic',
    },
    {
      german: "für diese Entlassung",
      translated: "za otkaz?",
      tone: 'semantic',
    },
    {
      german: "sein",
      translated: "biti",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:104|el": [
    {
      german: "Eine Frau",
      translated: "Μια γυναίκα",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "στη Γερμανία",
      tone: 'semantic',
    },
    {
      german: "verliert ihre Arbeit",
      translated: "χάνει τη δουλειά της",
      tone: 'semantic',
    },
    {
      german: "Was darf nicht",
      translated: "ΔΕΝ μπορεί",
      tone: 'semantic',
    },
    {
      german: "der Grund",
      translated: "λόγος",
      tone: 'semantic',
    },
    {
      german: "für diese Entlassung",
      translated: "την απόλυσή της",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:104|en": [
    {
      german: "Eine Frau",
      translated: "A woman",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "in Germany",
      tone: 'semantic',
    },
    {
      german: "verliert ihre Arbeit",
      translated: "loses her job",
      tone: 'semantic',
    },
    {
      german: "Was darf nicht",
      translated: "What must NOT",
      tone: 'semantic',
    },
    {
      german: "der Grund",
      translated: "the reason",
      tone: 'semantic',
    },
    {
      german: "für diese Entlassung",
      translated: "for this dismissal",
      tone: 'semantic',
    },
    {
      german: "sein",
      translated: "be",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:104|es": [
    {
      german: "Eine Frau",
      translated: "Una mujer",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "en Alemania",
      tone: 'semantic',
    },
    {
      german: "verliert ihre Arbeit",
      translated: "pierde su empleo",
      tone: 'semantic',
    },
    {
      german: "Was darf nicht",
      translated: "¿Cuál NO puede",
      tone: 'semantic',
    },
    {
      german: "der Grund",
      translated: "el motivo",
      tone: 'semantic',
    },
    {
      german: "für diese Entlassung",
      translated: "de su despido",
      tone: 'semantic',
    },
    {
      german: "sein",
      translated: "ser",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:104|fa": [
    {
      german: "Eine Frau",
      translated: "زنی",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "در آلمان",
      tone: 'semantic',
    },
    {
      german: "verliert ihre Arbeit",
      translated: "شغل خود را از دست می‌دهد",
      tone: 'semantic',
    },
    {
      german: "Was darf nicht",
      translated: "نمی‌تواند",
      tone: 'semantic',
    },
    {
      german: "der Grund",
      translated: "دلیل",
      tone: 'semantic',
    },
    {
      german: "für diese Entlassung",
      translated: "مبنای اخراج",
      tone: 'semantic',
    },
    {
      german: "sein",
      translated: "باشد",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:104|fr": [
    {
      german: "Eine Frau",
      translated: "Une femme",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "en Allemagne",
      tone: 'semantic',
    },
    {
      german: "verliert ihre Arbeit",
      translated: "perd son emploi",
      tone: 'semantic',
    },
    {
      german: "Was darf nicht",
      translated: "ne peut pas",
      tone: 'semantic',
    },
    {
      german: "der Grund",
      translated: "Lequel des motifs suivants",
      tone: 'semantic',
    },
    {
      german: "für diese Entlassung",
      translated: "son licenciement",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:104|hr": [
    {
      german: "Eine Frau",
      translated: "Žena",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "u Njemačkoj",
      tone: 'semantic',
    },
    {
      german: "verliert ihre Arbeit",
      translated: "gubi posao",
      tone: 'semantic',
    },
    {
      german: "Was darf nicht",
      translated: "Koji razlog NE smije",
      tone: 'semantic',
    },
    {
      german: "der Grund",
      translated: "razlog",
      tone: 'semantic',
    },
    {
      german: "für diese Entlassung",
      translated: "za otkaz",
      tone: 'semantic',
    },
    {
      german: "sein",
      translated: "biti",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:104|it": [
    {
      german: "Eine Frau",
      translated: "Una donna",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "in Germania",
      tone: 'semantic',
    },
    {
      german: "verliert ihre Arbeit",
      translated: "perde il lavoro",
      tone: 'semantic',
    },
    {
      german: "Was darf nicht",
      translated: "NON può",
      tone: 'semantic',
    },
    {
      german: "der Grund",
      translated: "motivo",
      tone: 'semantic',
    },
    {
      german: "für diese Entlassung",
      translated: "il licenziamento",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:104|kmr": [
    {
      german: "Eine Frau",
      translated: "Jinek",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "li Almanyayê",
      tone: 'semantic',
    },
    {
      german: "verliert ihre Arbeit",
      translated: "karê xwe winda dike",
      tone: 'semantic',
    },
    {
      german: "Was darf nicht",
      translated: "Kîjan sedem nikare",
      tone: 'semantic',
    },
    {
      german: "der Grund",
      translated: "sedema",
      tone: 'semantic',
    },
    {
      german: "für diese Entlassung",
      translated: "derxistina wê ji kar",
      tone: 'semantic',
    },
    {
      german: "sein",
      translated: "be",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:104|pl": [
    {
      german: "Eine Frau",
      translated: "Kobieta",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "w Niemczech",
      tone: 'semantic',
    },
    {
      german: "verliert ihre Arbeit",
      translated: "traci pracę",
      tone: 'semantic',
    },
    {
      german: "Was darf nicht",
      translated: "NIE może",
      tone: 'semantic',
    },
    {
      german: "der Grund",
      translated: "powód",
      tone: 'semantic',
    },
    {
      german: "für diese Entlassung",
      translated: "uzasadniać zwolnienia",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:104|prs": [
    {
      german: "Eine Frau",
      translated: "زنی",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "در آلمان",
      tone: 'semantic',
    },
    {
      german: "verliert ihre Arbeit",
      translated: "شغل خود را از دست می‌دهد",
      tone: 'semantic',
    },
    {
      german: "Was darf nicht",
      translated: "نمی‌تواند",
      tone: 'semantic',
    },
    {
      german: "der Grund",
      translated: "کدام دلیل",
      tone: 'semantic',
    },
    {
      german: "für diese Entlassung",
      translated: "مبنای اخراج او",
      tone: 'semantic',
    },
    {
      german: "sein",
      translated: "باشد",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:104|ro": [
    {
      german: "Eine Frau",
      translated: "O femeie",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "în Germania",
      tone: 'semantic',
    },
    {
      german: "verliert ihre Arbeit",
      translated: "pierde locul de muncă",
      tone: 'semantic',
    },
    {
      german: "Was darf nicht",
      translated: "Care motiv NU",
      tone: 'semantic',
    },
    {
      german: "für diese Entlassung",
      translated: "concedierea",
      tone: 'semantic',
    },
    {
      german: "sein",
      translated: "poate justifica",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:104|ru": [
    {
      german: "Eine Frau",
      translated: "Женщина",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "в Германии",
      tone: 'semantic',
    },
    {
      german: "verliert ihre Arbeit",
      translated: "теряет работу",
      tone: 'semantic',
    },
    {
      german: "Was darf nicht",
      translated: "Что не может",
      tone: 'semantic',
    },
    {
      german: "der Grund",
      translated: "причиной",
      tone: 'semantic',
    },
    {
      german: "für diese Entlassung",
      translated: "увольнения",
      tone: 'semantic',
    },
    {
      german: "sein",
      translated: "быть",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:104|sq": [
    {
      german: "Eine Frau",
      translated: "Një grua",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "në Gjermani",
      tone: 'semantic',
    },
    {
      german: "verliert ihre Arbeit",
      translated: "humbet punën",
      tone: 'semantic',
    },
    {
      german: "Was darf nicht",
      translated: "NUK mund",
      tone: 'semantic',
    },
    {
      german: "der Grund",
      translated: "Cili shkak",
      tone: 'semantic',
    },
    {
      german: "für diese Entlassung",
      translated: "pushimin nga puna",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:104|sr": [
    {
      german: "Eine Frau",
      translated: "Žena",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "u Nemačkoj",
      tone: 'semantic',
    },
    {
      german: "verliert ihre Arbeit",
      translated: "gubi posao",
      tone: 'semantic',
    },
    {
      german: "Was darf nicht",
      translated: "Koji razlog NE sme",
      tone: 'semantic',
    },
    {
      german: "der Grund",
      translated: "razlog",
      tone: 'semantic',
    },
    {
      german: "für diese Entlassung",
      translated: "za otkaz",
      tone: 'semantic',
    },
    {
      german: "sein",
      translated: "biti",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:104|tr": [
    {
      german: "Eine Frau",
      translated: "bir kadın",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "Almanya'da",
      tone: 'semantic',
    },
    {
      german: "verliert ihre Arbeit",
      translated: "işini kaybediyor",
      tone: 'semantic',
    },
    {
      german: "Was darf nicht",
      translated: "olamaz",
      tone: 'semantic',
    },
    {
      german: "der Grund",
      translated: "nedeni",
      tone: 'semantic',
    },
    {
      german: "für diese Entlassung",
      translated: "İşten çıkarılmasının",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:104|uk": [
    {
      german: "Eine Frau",
      translated: "Жінка",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "в Німеччині",
      tone: 'semantic',
    },
    {
      german: "verliert ihre Arbeit",
      translated: "втрачає роботу",
      tone: 'semantic',
    },
    {
      german: "Was darf nicht",
      translated: "Що не може",
      tone: 'semantic',
    },
    {
      german: "der Grund",
      translated: "причиною",
      tone: 'semantic',
    },
    {
      german: "für diese Entlassung",
      translated: "її звільнення",
      tone: 'semantic',
    },
    {
      german: "sein",
      translated: "бути",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:104|vi": [
    {
      german: "Eine Frau",
      translated: "Một phụ nữ",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "ở Đức",
      tone: 'semantic',
    },
    {
      german: "verliert ihre Arbeit",
      translated: "mất việc",
      tone: 'semantic',
    },
    {
      german: "Was darf nicht",
      translated: "KHÔNG thể",
      tone: 'semantic',
    },
    {
      german: "der Grund",
      translated: "Lý do",
      tone: 'semantic',
    },
    {
      german: "für diese Entlassung",
      translated: "cho việc sa thải",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:105|ar": [
    {
      german: "Was ist",
      translated: "ما",
      tone: 'semantic',
    },
    {
      german: "eine Aufgabe von Wahlhelferinnen/Wahlhelfern",
      translated: "إحدى مهام العاملين المتطوعين",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "في ألمانيا",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:105|bg": [
    {
      german: "Was ist",
      translated: "Коя е",
      tone: 'semantic',
    },
    {
      german: "eine Aufgabe von Wahlhelferinnen/Wahlhelfern",
      translated: "една от задачите на доброволните членове на избирателната комисия",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "в Германия",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:105|bs": [
    {
      german: "Was ist",
      translated: "Što je",
      tone: 'semantic',
    },
    {
      german: "eine Aufgabe von Wahlhelferinnen/Wahlhelfern",
      translated: "jedna od zadaća dobrovoljnih izbornih pomagača",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "u Njemačkoj",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:105|el": [
    {
      german: "Was ist",
      translated: "Ποιο είναι",
      tone: 'semantic',
    },
    {
      german: "eine Aufgabe von Wahlhelferinnen/Wahlhelfern",
      translated: "ένα από τα καθήκοντα των εθελοντών μελών της εφορευτικής επιτροπής",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "στη Γερμανία",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:105|en": [
    {
      german: "Was ist",
      translated: "What is",
      tone: 'semantic',
    },
    {
      german: "eine Aufgabe von Wahlhelferinnen/Wahlhelfern",
      translated: "a task of election helpers",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "in Germany",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:105|es": [
    {
      german: "Was ist",
      translated: "¿Cuál es",
      tone: 'semantic',
    },
    {
      german: "eine Aufgabe von Wahlhelferinnen/Wahlhelfern",
      translated: "una tarea de los ayudantes electorales",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "en Alemania",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:105|fa": [
    {
      german: "Was ist",
      translated: "چیست؟",
      tone: 'semantic',
    },
    {
      german: "eine Aufgabe von Wahlhelferinnen/Wahlhelfern",
      translated: "وظایف اعضای داوطلب هیئت انتخابات",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "در آلمان",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:105|fr": [
    {
      german: "Was ist",
      translated: "Quelle est",
      tone: 'semantic',
    },
    {
      german: "eine Aufgabe von Wahlhelferinnen/Wahlhelfern",
      translated: "l’une des tâches des assesseurs électoraux",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "en Allemagne",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:105|hr": [
    {
      german: "Was ist",
      translated: "Što je",
      tone: 'semantic',
    },
    {
      german: "eine Aufgabe von Wahlhelferinnen/Wahlhelfern",
      translated: "jedna od zadaća dobrovoljnih izbornih pomagača",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "u Njemačkoj",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:105|it": [
    {
      german: "Was ist",
      translated: "Qual è",
      tone: 'semantic',
    },
    {
      german: "eine Aufgabe von Wahlhelferinnen/Wahlhelfern",
      translated: "uno dei compiti degli scrutatori volontari",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "in Germania",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:105|kmr": [
    {
      german: "Was ist",
      translated: "çi ye?",
      tone: 'semantic',
    },
    {
      german: "eine Aufgabe von Wahlhelferinnen/Wahlhelfern",
      translated: "Yek ji erkên alîkarên hilbijartinê",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "li Almanyayê",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:105|pl": [
    {
      german: "Was ist",
      translated: "Które z poniższych jest",
      tone: 'semantic',
    },
    {
      german: "eine Aufgabe von Wahlhelferinnen/Wahlhelfern",
      translated: "jednym z zadań wolontariuszy komisji wyborczej",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "w Niemczech",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:105|prs": [
    {
      german: "Was ist",
      translated: "چیست؟",
      tone: 'semantic',
    },
    {
      german: "eine Aufgabe von Wahlhelferinnen/Wahlhelfern",
      translated: "یکی از وظایف",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "در آلمان",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:105|ro": [
    {
      german: "Was ist",
      translated: "Care este",
      tone: 'semantic',
    },
    {
      german: "eine Aufgabe von Wahlhelferinnen/Wahlhelfern",
      translated: "una dintre sarcinile membrilor voluntari ai biroului electoral",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "în Germania",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:105|ru": [
    {
      german: "Was ist",
      translated: "Что",
      tone: 'semantic',
    },
    {
      german: "eine Aufgabe von Wahlhelferinnen/Wahlhelfern",
      translated: "задачи помощников",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "в Германии",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:105|sq": [
    {
      german: "Was ist",
      translated: "Cila është",
      tone: 'semantic',
    },
    {
      german: "eine Aufgabe von Wahlhelferinnen/Wahlhelfern",
      translated: "një nga detyrat e ndihmësve vullnetarë të zgjedhjeve",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "në Gjermani",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:105|sr": [
    {
      german: "Was ist",
      translated: "Šta je",
      tone: 'semantic',
    },
    {
      german: "eine Aufgabe von Wahlhelferinnen/Wahlhelfern",
      translated: "jedna od zadaća dobrovoljnih izbornih pomagača",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "u Nemačkoj",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:105|tr": [
    {
      german: "Was ist",
      translated: "nedir",
      tone: 'semantic',
    },
    {
      german: "eine Aufgabe von Wahlhelferinnen/Wahlhelfern",
      translated: "seçim görevlilerinin görevlerinden biri",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "Almanya'da",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:105|uk": [
    {
      german: "Was ist",
      translated: "Яке",
      tone: 'semantic',
    },
    {
      german: "eine Aufgabe von Wahlhelferinnen/Wahlhelfern",
      translated: "завдання",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "у Німеччині",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:105|vi": [
    {
      german: "Was ist",
      translated: "là gì",
      tone: 'semantic',
    },
    {
      german: "eine Aufgabe von Wahlhelferinnen/Wahlhelfern",
      translated: "Một nhiệm vụ của các tình nguyện viên hỗ trợ bầu cử",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "ở Đức",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:106|ar": [
    {
      german: "In Deutschland",
      translated: "في ألمانيا",
      tone: 'semantic',
    },
    {
      german: "helfen",
      translated: "يساعد",
      tone: 'semantic',
    },
    {
      german: "ehrenamtliche Wahlhelferinnen und Wahlhelfer",
      translated: "متطوعون",
      tone: 'semantic',
    },
    {
      german: "bei den Wahlen",
      translated: "في الانتخابات",
      tone: 'semantic',
    },
    {
      german: "Was ist eine Aufgabe",
      translated: "ما إحدى مهامهم",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:106|bg": [
    {
      german: "In Deutschland",
      translated: "В Германия",
      tone: 'semantic',
    },
    {
      german: "helfen",
      translated: "помагат",
      tone: 'semantic',
    },
    {
      german: "ehrenamtliche Wahlhelferinnen und Wahlhelfer",
      translated: "доброволци",
      tone: 'semantic',
    },
    {
      german: "bei den Wahlen",
      translated: "при провеждането на избори",
      tone: 'semantic',
    },
    {
      german: "Was ist eine Aufgabe",
      translated: "Коя е една от задачите",
      tone: 'semantic',
    },
    {
      german: "von Wahlhelferinnen/Wahlhelfern",
      translated: "им",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:106|bs": [
    {
      german: "In Deutschland",
      translated: "U Njemačkoj",
      tone: 'semantic',
    },
    {
      german: "helfen",
      translated: "pomažu",
      tone: 'semantic',
    },
    {
      german: "ehrenamtliche Wahlhelferinnen und Wahlhelfer",
      translated: "dobrovoljni pomagači",
      tone: 'semantic',
    },
    {
      german: "bei den Wahlen",
      translated: "pri provođenju izbora",
      tone: 'semantic',
    },
    {
      german: "Was ist eine Aufgabe",
      translated: "Što je jedna od",
      tone: 'semantic',
    },
    {
      german: "von Wahlhelferinnen/Wahlhelfern",
      translated: "njihovih",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:106|el": [
    {
      german: "In Deutschland",
      translated: "Στη Γερμανία",
      tone: 'semantic',
    },
    {
      german: "helfen",
      translated: "βοηθούν",
      tone: 'semantic',
    },
    {
      german: "ehrenamtliche Wahlhelferinnen und Wahlhelfer",
      translated: "εθελοντές",
      tone: 'semantic',
    },
    {
      german: "bei den Wahlen",
      translated: "στη διεξαγωγή των εκλογών",
      tone: 'semantic',
    },
    {
      german: "Was ist eine Aufgabe",
      translated: "Ποιο είναι ένα από",
      tone: 'semantic',
    },
    {
      german: "von Wahlhelferinnen/Wahlhelfern",
      translated: "τους",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:106|en": [
    {
      german: "In Deutschland",
      translated: "In Germany",
      tone: 'semantic',
    },
    {
      german: "helfen",
      translated: "assist",
      tone: 'semantic',
    },
    {
      german: "ehrenamtliche Wahlhelferinnen und Wahlhelfer",
      translated: "volunteer election helpers",
      tone: 'semantic',
    },
    {
      german: "bei den Wahlen",
      translated: "with elections",
      tone: 'semantic',
    },
    {
      german: "Was ist eine Aufgabe",
      translated: "What is a task",
      tone: 'semantic',
    },
    {
      german: "von Wahlhelferinnen/Wahlhelfern",
      translated: "of election helpers",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:106|es": [
    {
      german: "In Deutschland",
      translated: "En Alemania",
      tone: 'semantic',
    },
    {
      german: "helfen",
      translated: "ayudan",
      tone: 'semantic',
    },
    {
      german: "ehrenamtliche Wahlhelferinnen und Wahlhelfer",
      translated: "voluntarios",
      tone: 'semantic',
    },
    {
      german: "bei den Wahlen",
      translated: "en las elecciones",
      tone: 'semantic',
    },
    {
      german: "Was ist eine Aufgabe",
      translated: "¿Cuál es una tarea",
      tone: 'semantic',
    },
    {
      german: "von Wahlhelferinnen/Wahlhelfern",
      translated: "de los ayudantes electorales",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:106|fa": [
    {
      german: "In Deutschland",
      translated: "در آلمان",
      tone: 'semantic',
    },
    {
      german: "helfen",
      translated: "کمک می‌کنند",
      tone: 'semantic',
    },
    {
      german: "ehrenamtliche Wahlhelferinnen und Wahlhelfer",
      translated: "داوطلبان",
      tone: 'semantic',
    },
    {
      german: "bei den Wahlen",
      translated: "در برگزاری انتخابات",
      tone: 'semantic',
    },
    {
      german: "Was ist eine Aufgabe",
      translated: "یکی از وظایف",
      tone: 'semantic',
    },
    {
      german: "von Wahlhelferinnen/Wahlhelfern",
      translated: "آنان چیست؟",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:106|fr": [
    {
      german: "In Deutschland",
      translated: "En Allemagne",
      tone: 'semantic',
    },
    {
      german: "helfen",
      translated: "aident",
      tone: 'semantic',
    },
    {
      german: "ehrenamtliche Wahlhelferinnen und Wahlhelfer",
      translated: "des bénévoles",
      tone: 'semantic',
    },
    {
      german: "bei den Wahlen",
      translated: "lors des élections",
      tone: 'semantic',
    },
    {
      german: "Was ist eine Aufgabe",
      translated: "Quelle est l’une",
      tone: 'semantic',
    },
    {
      german: "von Wahlhelferinnen/Wahlhelfern",
      translated: "de leurs tâches",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:106|hr": [
    {
      german: "In Deutschland",
      translated: "U Njemačkoj",
      tone: 'semantic',
    },
    {
      german: "helfen",
      translated: "pomažu",
      tone: 'semantic',
    },
    {
      german: "ehrenamtliche Wahlhelferinnen und Wahlhelfer",
      translated: "dobrovoljni pomagači",
      tone: 'semantic',
    },
    {
      german: "bei den Wahlen",
      translated: "pri provedbi izbora",
      tone: 'semantic',
    },
    {
      german: "Was ist eine Aufgabe",
      translated: "Što je jedna od",
      tone: 'semantic',
    },
    {
      german: "von Wahlhelferinnen/Wahlhelfern",
      translated: "njihovih",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:106|it": [
    {
      german: "In Deutschland",
      translated: "In Germania",
      tone: 'semantic',
    },
    {
      german: "helfen",
      translated: "aiutano",
      tone: 'semantic',
    },
    {
      german: "ehrenamtliche Wahlhelferinnen und Wahlhelfer",
      translated: "dei volontari",
      tone: 'semantic',
    },
    {
      german: "bei den Wahlen",
      translated: "durante le elezioni",
      tone: 'semantic',
    },
    {
      german: "Was ist eine Aufgabe",
      translated: "Qual è uno",
      tone: 'semantic',
    },
    {
      german: "von Wahlhelferinnen/Wahlhelfern",
      translated: "dei loro",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:106|kmr": [
    {
      german: "In Deutschland",
      translated: "Li Almanyayê",
      tone: 'semantic',
    },
    {
      german: "helfen",
      translated: "dikin",
      tone: 'semantic',
    },
    {
      german: "ehrenamtliche Wahlhelferinnen und Wahlhelfer",
      translated: "alîkarên dilxwaz",
      tone: 'semantic',
    },
    {
      german: "bei den Wahlen",
      translated: "di hilbijartinan de",
      tone: 'semantic',
    },
    {
      german: "Was ist eine Aufgabe",
      translated: "Erka wan çi ye?",
      tone: 'semantic',
    },
    {
      german: "von Wahlhelferinnen/Wahlhelfern",
      translated: "alîkarî",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:106|pl": [
    {
      german: "In Deutschland",
      translated: "W Niemczech",
      tone: 'semantic',
    },
    {
      german: "helfen",
      translated: "pomagają",
      tone: 'semantic',
    },
    {
      german: "ehrenamtliche Wahlhelferinnen und Wahlhelfer",
      translated: "wolontariusze",
      tone: 'semantic',
    },
    {
      german: "bei den Wahlen",
      translated: "przy przeprowadzaniu wyborów",
      tone: 'semantic',
    },
    {
      german: "Was ist eine Aufgabe",
      translated: "Które z poniższych jest jednym",
      tone: 'semantic',
    },
    {
      german: "von Wahlhelferinnen/Wahlhelfern",
      translated: "z ich zadań",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:106|prs": [
    {
      german: "In Deutschland",
      translated: "در آلمان",
      tone: 'semantic',
    },
    {
      german: "helfen",
      translated: "کمک می‌کنند",
      tone: 'semantic',
    },
    {
      german: "ehrenamtliche Wahlhelferinnen und Wahlhelfer",
      translated: "داوطلبان",
      tone: 'semantic',
    },
    {
      german: "bei den Wahlen",
      translated: "در برگزاری انتخابات",
      tone: 'semantic',
    },
    {
      german: "Was ist eine Aufgabe",
      translated: "یکی از وظایف",
      tone: 'semantic',
    },
    {
      german: "von Wahlhelferinnen/Wahlhelfern",
      translated: "آنان",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:106|ro": [
    {
      german: "In Deutschland",
      translated: "În Germania",
      tone: 'semantic',
    },
    {
      german: "helfen",
      translated: "ajută",
      tone: 'semantic',
    },
    {
      german: "ehrenamtliche Wahlhelferinnen und Wahlhelfer",
      translated: "voluntarii",
      tone: 'semantic',
    },
    {
      german: "bei den Wahlen",
      translated: "la desfășurarea alegerilor",
      tone: 'semantic',
    },
    {
      german: "Was ist eine Aufgabe",
      translated: "Care este una dintre sarcinile lor?",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:106|ru": [
    {
      german: "In Deutschland",
      translated: "В Германии",
      tone: 'semantic',
    },
    {
      german: "helfen",
      translated: "помогают",
      tone: 'semantic',
    },
    {
      german: "ehrenamtliche Wahlhelferinnen und Wahlhelfer",
      translated: "добровольные помощники",
      tone: 'semantic',
    },
    {
      german: "bei den Wahlen",
      translated: "на выборах",
      tone: 'semantic',
    },
    {
      german: "Was ist eine Aufgabe",
      translated: "Что входит",
      tone: 'semantic',
    },
    {
      german: "von Wahlhelferinnen/Wahlhelfern",
      translated: "их",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:106|sq": [
    {
      german: "In Deutschland",
      translated: "Në Gjermani",
      tone: 'semantic',
    },
    {
      german: "helfen",
      translated: "ndihmojnë",
      tone: 'semantic',
    },
    {
      german: "ehrenamtliche Wahlhelferinnen und Wahlhelfer",
      translated: "vullnetarët",
      tone: 'semantic',
    },
    {
      german: "bei den Wahlen",
      translated: "në zhvillimin e zgjedhjeve",
      tone: 'semantic',
    },
    {
      german: "Was ist eine Aufgabe",
      translated: "Cila është një nga detyrat",
      tone: 'semantic',
    },
    {
      german: "von Wahlhelferinnen/Wahlhelfern",
      translated: "e tyre",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:106|sr": [
    {
      german: "In Deutschland",
      translated: "U Nemačkoj",
      tone: 'semantic',
    },
    {
      german: "helfen",
      translated: "pomažu",
      tone: 'semantic',
    },
    {
      german: "ehrenamtliche Wahlhelferinnen und Wahlhelfer",
      translated: "dobrovoljni pomagači",
      tone: 'semantic',
    },
    {
      german: "bei den Wahlen",
      translated: "pri sprovođenju izbora",
      tone: 'semantic',
    },
    {
      german: "Was ist eine Aufgabe",
      translated: "Šta je jedna od",
      tone: 'semantic',
    },
    {
      german: "von Wahlhelferinnen/Wahlhelfern",
      translated: "njihovih",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:106|tr": [
    {
      german: "In Deutschland",
      translated: "Almanya'da",
      tone: 'semantic',
    },
    {
      german: "helfen",
      translated: "yardımcı olur",
      tone: 'semantic',
    },
    {
      german: "ehrenamtliche Wahlhelferinnen und Wahlhelfer",
      translated: "gönüllü seçim görevlileri",
      tone: 'semantic',
    },
    {
      german: "bei den Wahlen",
      translated: "seçimlerde",
      tone: 'semantic',
    },
    {
      german: "Was ist eine Aufgabe",
      translated: "Görevlerinden biri",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:106|uk": [
    {
      german: "In Deutschland",
      translated: "У Німеччині",
      tone: 'semantic',
    },
    {
      german: "helfen",
      translated: "допомагають",
      tone: 'semantic',
    },
    {
      german: "ehrenamtliche Wahlhelferinnen und Wahlhelfer",
      translated: "помічники",
      tone: 'semantic',
    },
    {
      german: "bei den Wahlen",
      translated: "під час виборів",
      tone: 'semantic',
    },
    {
      german: "Was ist eine Aufgabe",
      translated: "Яке завдання",
      tone: 'semantic',
    },
    {
      german: "von Wahlhelferinnen/Wahlhelfern",
      translated: "вони",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:106|vi": [
    {
      german: "In Deutschland",
      translated: "Ở Đức",
      tone: 'semantic',
    },
    {
      german: "helfen",
      translated: "giúp",
      tone: 'semantic',
    },
    {
      german: "ehrenamtliche Wahlhelferinnen und Wahlhelfer",
      translated: "các tình nguyện viên",
      tone: 'semantic',
    },
    {
      german: "bei den Wahlen",
      translated: "bầu cử",
      tone: 'semantic',
    },
    {
      german: "Was ist eine Aufgabe",
      translated: "Một nhiệm vụ",
      tone: 'semantic',
    },
    {
      german: "von Wahlhelferinnen/Wahlhelfern",
      translated: "của họ",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:107|ar": [
    {
      german: "Für wie viele Jahre",
      translated: "لمدة كم سنة",
      tone: 'semantic',
    },
    {
      german: "der Bundestag",
      translated: "البوندستاغ",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "في ألمانيا",
      tone: 'semantic',
    },
    {
      german: "gewählt",
      translated: "يُنتخب",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:107|bg": [
    {
      german: "Für wie viele Jahre",
      translated: "За колко години",
      tone: 'semantic',
    },
    {
      german: "der Bundestag",
      translated: "Бундестагът",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "в Германия",
      tone: 'semantic',
    },
    {
      german: "gewählt",
      translated: "се избира",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:107|bs": [
    {
      german: "Für wie viele Jahre",
      translated: "Na koliko se godina",
      tone: 'semantic',
    },
    {
      german: "der Bundestag",
      translated: "Bundestag",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "u Njemačkoj",
      tone: 'semantic',
    },
    {
      german: "gewählt",
      translated: "bira",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:107|el": [
    {
      german: "Für wie viele Jahre",
      translated: "Για πόσα χρόνια",
      tone: 'semantic',
    },
    {
      german: "der Bundestag",
      translated: "το Bundestag",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "στη Γερμανία",
      tone: 'semantic',
    },
    {
      german: "gewählt",
      translated: "εκλέγεται",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:107|en": [
    {
      german: "Für wie viele Jahre",
      translated: "For how many years",
      tone: 'semantic',
    },
    {
      german: "der Bundestag",
      translated: "the Bundestag",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "in Germany",
      tone: 'semantic',
    },
    {
      german: "gewählt",
      translated: "elected",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:107|es": [
    {
      german: "Für wie viele Jahre",
      translated: "Por cuántos años",
      tone: 'semantic',
    },
    {
      german: "der Bundestag",
      translated: "el Bundestag",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "en Alemania",
      tone: 'semantic',
    },
    {
      german: "gewählt",
      translated: "elige",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:107|fa": [
    {
      german: "Für wie viele Jahre",
      translated: "برای چند سال",
      tone: 'semantic',
    },
    {
      german: "der Bundestag",
      translated: "بوندستاگ",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "در آلمان",
      tone: 'semantic',
    },
    {
      german: "gewählt",
      translated: "انتخاب می‌شود",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:107|fr": [
    {
      german: "Für wie viele Jahre",
      translated: "Pour combien d’années",
      tone: 'semantic',
    },
    {
      german: "der Bundestag",
      translated: "le Bundestag",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "en Allemagne",
      tone: 'semantic',
    },
    {
      german: "gewählt",
      translated: "élu",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:107|hr": [
    {
      german: "Für wie viele Jahre",
      translated: "Na koliko se godina",
      tone: 'semantic',
    },
    {
      german: "der Bundestag",
      translated: "Bundestag",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "u Njemačkoj",
      tone: 'semantic',
    },
    {
      german: "gewählt",
      translated: "bira",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:107|it": [
    {
      german: "Für wie viele Jahre",
      translated: "Per quanti anni",
      tone: 'semantic',
    },
    {
      german: "der Bundestag",
      translated: "il Bundestag",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "in Germania",
      tone: 'semantic',
    },
    {
      german: "gewählt",
      translated: "eletto",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:107|kmr": [
    {
      german: "Für wie viele Jahre",
      translated: "ji bo çend salan",
      tone: 'semantic',
    },
    {
      german: "der Bundestag",
      translated: "Bundestag",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "li Almanyayê",
      tone: 'semantic',
    },
    {
      german: "gewählt",
      translated: "tê hilbijartin?",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:107|pl": [
    {
      german: "Für wie viele Jahre",
      translated: "Na ile lat",
      tone: 'semantic',
    },
    {
      german: "der Bundestag",
      translated: "Bundestag",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "w Niemczech",
      tone: 'semantic',
    },
    {
      german: "gewählt",
      translated: "wybierany",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:107|prs": [
    {
      german: "Für wie viele Jahre",
      translated: "چند سال",
      tone: 'semantic',
    },
    {
      german: "der Bundestag",
      translated: "بوندستاگ",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "در آلمان",
      tone: 'semantic',
    },
    {
      german: "gewählt",
      translated: "انتخاب می‌شود",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:107|ro": [
    {
      german: "Für wie viele Jahre",
      translated: "Pentru câți ani",
      tone: 'semantic',
    },
    {
      german: "der Bundestag",
      translated: "Bundestagul",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "în Germania",
      tone: 'semantic',
    },
    {
      german: "gewählt",
      translated: "ales",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:107|ru": [
    {
      german: "Für wie viele Jahre",
      translated: "На сколько лет",
      tone: 'semantic',
    },
    {
      german: "der Bundestag",
      translated: "Бундестаг",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "в Германии",
      tone: 'semantic',
    },
    {
      german: "gewählt",
      translated: "избирается",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:107|sq": [
    {
      german: "Für wie viele Jahre",
      translated: "Për sa vjet",
      tone: 'semantic',
    },
    {
      german: "der Bundestag",
      translated: "Bundestagu",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "në Gjermani",
      tone: 'semantic',
    },
    {
      german: "gewählt",
      translated: "zgjidhet",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:107|sr": [
    {
      german: "Für wie viele Jahre",
      translated: "Na koliko se godina",
      tone: 'semantic',
    },
    {
      german: "der Bundestag",
      translated: "Bundestag",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "u Nemačkoj",
      tone: 'semantic',
    },
    {
      german: "gewählt",
      translated: "bira",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:107|tr": [
    {
      german: "Für wie viele Jahre",
      translated: "kaç yıllığına",
      tone: 'semantic',
    },
    {
      german: "der Bundestag",
      translated: "Federal Meclis",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "Almanya'da",
      tone: 'semantic',
    },
    {
      german: "gewählt",
      translated: "seçilir",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:107|uk": [
    {
      german: "Für wie viele Jahre",
      translated: "На скільки років",
      tone: 'semantic',
    },
    {
      german: "der Bundestag",
      translated: "Бундестаг",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "у Німеччині",
      tone: 'semantic',
    },
    {
      german: "gewählt",
      translated: "обирають",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:107|vi": [
    {
      german: "Für wie viele Jahre",
      translated: "nhiệm kỳ bao nhiêu năm",
      tone: 'semantic',
    },
    {
      german: "der Bundestag",
      translated: "Bundestag",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "ở Đức",
      tone: 'semantic',
    },
    {
      german: "gewählt",
      translated: "được bầu",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:108|ar": [
    {
      german: "Bei einer Bundestagswahl",
      translated: "في انتخابات البوندستاغ",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "في ألمانيا",
      tone: 'semantic',
    },
    {
      german: "darf jede/jeder",
      translated: "يحق",
      tone: 'semantic',
    },
    {
      german: "wählen",
      translated: "التصويت",
      tone: 'semantic',
    },
    {
      german: "die/der",
      translated: "من",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:108|bg": [
    {
      german: "Bei einer Bundestagswahl",
      translated: "на изборите за Бундестаг",
      tone: 'semantic',
    },
    {
      german: "darf jede/jeder",
      translated: "има право",
      tone: 'semantic',
    },
    {
      german: "wählen",
      translated: "гласува",
      tone: 'semantic',
    },
    {
      german: "die/der",
      translated: "който",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:108|bs": [
    {
      german: "Bei einer Bundestagswahl",
      translated: "na izborima za Bundestag",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "u Njemačkoj",
      tone: 'semantic',
    },
    {
      german: "darf jede/jeder",
      translated: "ima pravo",
      tone: 'semantic',
    },
    {
      german: "wählen",
      translated: "glasovati",
      tone: 'semantic',
    },
    {
      german: "die/der",
      translated: "koja",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:108|el": [
    {
      german: "Bei einer Bundestagswahl",
      translated: "στις εκλογές του Bundestag",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "στη Γερμανία",
      tone: 'semantic',
    },
    {
      german: "wählen",
      translated: "ψήφου",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:108|en": [
    {
      german: "Bei einer Bundestagswahl",
      translated: "In a federal election",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "in Germany",
      tone: 'semantic',
    },
    {
      german: "darf jede/jeder",
      translated: "everyone may",
      tone: 'semantic',
    },
    {
      german: "wählen",
      translated: "vote",
      tone: 'semantic',
    },
    {
      german: "die/der",
      translated: "who",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:108|es": [
    {
      german: "Bei einer Bundestagswahl",
      translated: "En unas elecciones federales",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "en Alemania",
      tone: 'semantic',
    },
    {
      german: "darf jede/jeder",
      translated: "puede votar toda persona",
      tone: 'semantic',
    },
    {
      german: "die/der",
      translated: "que",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:108|fa": [
    {
      german: "Bei einer Bundestagswahl",
      translated: "در انتخابات بوندستاگ",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "آلمان",
      tone: 'semantic',
    },
    {
      german: "darf jede/jeder",
      translated: "چه کسی",
      tone: 'semantic',
    },
    {
      german: "wählen",
      translated: "حق رأی دارد",
      tone: 'semantic',
    },
    {
      german: "die/der",
      translated: "که",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:108|fr": [
    {
      german: "Bei einer Bundestagswahl",
      translated: "Lors d’une élection au Bundestag",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "en Allemagne",
      tone: 'semantic',
    },
    {
      german: "darf jede/jeder",
      translated: "peut",
      tone: 'semantic',
    },
    {
      german: "wählen",
      translated: "voter",
      tone: 'semantic',
    },
    {
      german: "die/der",
      translated: "qui",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:108|hr": [
    {
      german: "Bei einer Bundestagswahl",
      translated: "na izborima za Bundestag",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "u Njemačkoj",
      tone: 'semantic',
    },
    {
      german: "darf jede/jeder",
      translated: "Tko ima pravo",
      tone: 'semantic',
    },
    {
      german: "wählen",
      translated: "glasovati",
      tone: 'semantic',
    },
    {
      german: "die/der",
      translated: "koja",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:108|it": [
    {
      german: "Bei einer Bundestagswahl",
      translated: "alle elezioni del Bundestag",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "in Germania",
      tone: 'semantic',
    },
    {
      german: "darf jede/jeder",
      translated: "Chi può",
      tone: 'semantic',
    },
    {
      german: "wählen",
      translated: "votare",
      tone: 'semantic',
    },
    {
      german: "die/der",
      translated: "che",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:108|kmr": [
    {
      german: "Bei einer Bundestagswahl",
      translated: "Di hilbijartina Bundestagê",
      tone: 'semantic',
    },
    {
      german: "darf jede/jeder",
      translated: "her kes dikare",
      tone: 'semantic',
    },
    {
      german: "wählen",
      translated: "deng",
      tone: 'semantic',
    },
    {
      german: "die/der",
      translated: "ku",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:108|pl": [
    {
      german: "Bei einer Bundestagswahl",
      translated: "w wyborach do Bundestagu",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "w Niemczech",
      tone: 'semantic',
    },
    {
      german: "darf jede/jeder",
      translated: "Kto ma prawo",
      tone: 'semantic',
    },
    {
      german: "wählen",
      translated: "głosować",
      tone: 'semantic',
    },
    {
      german: "die/der",
      translated: "która",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:108|prs": [
    {
      german: "Bei einer Bundestagswahl",
      translated: "در انتخابات بوندستاگ",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "آلمان",
      tone: 'semantic',
    },
    {
      german: "darf jede/jeder",
      translated: "چه کسی",
      tone: 'semantic',
    },
    {
      german: "wählen",
      translated: "رأی",
      tone: 'semantic',
    },
    {
      german: "die/der",
      translated: "که",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:108|ro": [
    {
      german: "Bei einer Bundestagswahl",
      translated: "la alegerile pentru Bundestag",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "în Germania",
      tone: 'semantic',
    },
    {
      german: "darf jede/jeder",
      translated: "Cine are",
      tone: 'semantic',
    },
    {
      german: "wählen",
      translated: "drept de vot",
      tone: 'semantic',
    },
    {
      german: "die/der",
      translated: "care",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:108|ru": [
    {
      german: "Bei einer Bundestagswahl",
      translated: "На выборах",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "Германии",
      tone: 'semantic',
    },
    {
      german: "darf jede/jeder",
      translated: "может каждый",
      tone: 'semantic',
    },
    {
      german: "wählen",
      translated: "голосовать",
      tone: 'semantic',
    },
    {
      german: "die/der",
      translated: "кто",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:108|sq": [
    {
      german: "Bei einer Bundestagswahl",
      translated: "në zgjedhjet e Bundestagut",
      tone: 'semantic',
    },
    {
      german: "darf jede/jeder",
      translated: "ka të drejtë",
      tone: 'semantic',
    },
    {
      german: "wählen",
      translated: "të votojë",
      tone: 'semantic',
    },
    {
      german: "die/der",
      translated: "që",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:108|sr": [
    {
      german: "Bei einer Bundestagswahl",
      translated: "na izborima za Bundestag",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "u Nemačkoj",
      tone: 'semantic',
    },
    {
      german: "darf jede/jeder",
      translated: "ima pravo",
      tone: 'semantic',
    },
    {
      german: "wählen",
      translated: "glasati",
      tone: 'semantic',
    },
    {
      german: "die/der",
      translated: "koja",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:108|tr": [
    {
      german: "Bei einer Bundestagswahl",
      translated: "Almanya'daki Federal Meclis seçiminde",
      tone: 'semantic',
    },
    {
      german: "darf jede/jeder",
      translated: "kim",
      tone: 'semantic',
    },
    {
      german: "wählen",
      translated: "oy kullanabilir",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:108|uk": [
    {
      german: "Bei einer Bundestagswahl",
      translated: "На виборах до Бундестагу",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "в Німеччині",
      tone: 'semantic',
    },
    {
      german: "darf jede/jeder",
      translated: "може кожен",
      tone: 'semantic',
    },
    {
      german: "wählen",
      translated: "голосувати",
      tone: 'semantic',
    },
    {
      german: "die/der",
      translated: "хто",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:108|vi": [
    {
      german: "Bei einer Bundestagswahl",
      translated: "trong bầu cử Bundestag",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "ở Đức",
      tone: 'semantic',
    },
    {
      german: "darf jede/jeder",
      translated: "Ai có quyền",
      tone: 'semantic',
    },
    {
      german: "wählen",
      translated: "bỏ phiếu",
      tone: 'semantic',
    },
    {
      german: "die/der",
      translated: "người",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:109|ar": [
    {
      german: "Wie oft",
      translated: "كم مرة",
      tone: 'semantic',
    },
    {
      german: "gibt es",
      translated: "تُجرى",
      tone: 'semantic',
    },
    {
      german: "normalerweise",
      translated: "عادةً",
      tone: 'semantic',
    },
    {
      german: "Bundestagswahlen",
      translated: "انتخابات البوندستاغ",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "في ألمانيا",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:109|bg": [
    {
      german: "Wie oft",
      translated: "През какъв период",
      tone: 'semantic',
    },
    {
      german: "gibt es",
      translated: "се провеждат",
      tone: 'semantic',
    },
    {
      german: "normalerweise",
      translated: "обикновено",
      tone: 'semantic',
    },
    {
      german: "Bundestagswahlen",
      translated: "избори за Бундестаг",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "в Германия",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:109|bs": [
    {
      german: "Wie oft",
      translated: "Koliko",
      tone: 'semantic',
    },
    {
      german: "gibt es",
      translated: "održavaju",
      tone: 'semantic',
    },
    {
      german: "normalerweise",
      translated: "u pravilu",
      tone: 'semantic',
    },
    {
      german: "Bundestagswahlen",
      translated: "Bundestag",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "u Njemačkoj",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:109|el": [
    {
      german: "Wie oft",
      translated: "Κάθε πόσα χρόνια",
      tone: 'semantic',
    },
    {
      german: "gibt es",
      translated: "διεξάγονται",
      tone: 'semantic',
    },
    {
      german: "normalerweise",
      translated: "συνήθως",
      tone: 'semantic',
    },
    {
      german: "Bundestagswahlen",
      translated: "εκλογές για το Bundestag",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "στη Γερμανία",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:109|en": [
    {
      german: "Wie oft",
      translated: "How often",
      tone: 'semantic',
    },
    {
      german: "gibt es",
      translated: "are",
      tone: 'semantic',
    },
    {
      german: "normalerweise",
      translated: "normally",
      tone: 'semantic',
    },
    {
      german: "Bundestagswahlen",
      translated: "federal elections",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "in Germany",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:109|es": [
    {
      german: "Wie oft",
      translated: "Con qué frecuencia",
      tone: 'semantic',
    },
    {
      german: "gibt es",
      translated: "se celebran",
      tone: 'semantic',
    },
    {
      german: "normalerweise",
      translated: "normalmente",
      tone: 'semantic',
    },
    {
      german: "Bundestagswahlen",
      translated: "elecciones federales",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "en Alemania",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:109|fa": [
    {
      german: "Wie oft",
      translated: "هر چند وقت یک‌بار",
      tone: 'semantic',
    },
    {
      german: "normalerweise",
      translated: "معمولاً",
      tone: 'semantic',
    },
    {
      german: "Bundestagswahlen",
      translated: "انتخابات بوندستاگ",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "در آلمان",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:109|fr": [
    {
      german: "Wie oft",
      translated: "À quelle fréquence",
      tone: 'semantic',
    },
    {
      german: "normalerweise",
      translated: "normalement",
      tone: 'semantic',
    },
    {
      german: "Bundestagswahlen",
      translated: "les élections du Bundestag",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "en Allemagne",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:109|hr": [
    {
      german: "Wie oft",
      translated: "Koliko",
      tone: 'semantic',
    },
    {
      german: "normalerweise",
      translated: "u pravilu",
      tone: 'semantic',
    },
    {
      german: "Bundestagswahlen",
      translated: "izbori za Bundestag",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "u Njemačkoj",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:109|it": [
    {
      german: "Wie oft",
      translated: "Con quale frequenza",
      tone: 'semantic',
    },
    {
      german: "gibt es",
      translated: "si svolgono",
      tone: 'semantic',
    },
    {
      german: "normalerweise",
      translated: "normalmente",
      tone: 'semantic',
    },
    {
      german: "Bundestagswahlen",
      translated: "elezioni del Bundestag",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "in Germania",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:109|kmr": [
    {
      german: "Wie oft",
      translated: "çend caran",
      tone: 'semantic',
    },
    {
      german: "gibt es",
      translated: "tê kirin",
      tone: 'semantic',
    },
    {
      german: "normalerweise",
      translated: "Bi gelemperî",
      tone: 'semantic',
    },
    {
      german: "Bundestagswahlen",
      translated: "hilbijartina Bundestagê",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:109|pl": [
    {
      german: "Wie",
      translated: "jak",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:109|prs": [
    {
      german: "Wie oft",
      translated: "هر چند وقت یک‌بار",
      tone: 'semantic',
    },
    {
      german: "normalerweise",
      translated: "معمولاً",
      tone: 'semantic',
    },
    {
      german: "Bundestagswahlen",
      translated: "انتخابات بوندستاگ",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "در آلمان",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:109|ro": [
    {
      german: "Wie oft",
      translated: "La ce interval",
      tone: 'semantic',
    },
    {
      german: "gibt es",
      translated: "au loc",
      tone: 'semantic',
    },
    {
      german: "normalerweise",
      translated: "de regulă",
      tone: 'semantic',
    },
    {
      german: "Bundestagswahlen",
      translated: "alegerile pentru Bundestag",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "în Germania",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:109|ru": [
    {
      german: "Wie oft",
      translated: "Как часто",
      tone: 'semantic',
    },
    {
      german: "gibt es",
      translated: "проходят",
      tone: 'semantic',
    },
    {
      german: "normalerweise",
      translated: "обычно",
      tone: 'semantic',
    },
    {
      german: "Bundestagswahlen",
      translated: "выборы в Бундестаг",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "в Германии",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:109|sq": [
    {
      german: "Wie oft",
      translated: "Sa shpesh",
      tone: 'semantic',
    },
    {
      german: "gibt es",
      translated: "zhvillohen",
      tone: 'semantic',
    },
    {
      german: "normalerweise",
      translated: "zakonisht",
      tone: 'semantic',
    },
    {
      german: "Bundestagswahlen",
      translated: "zgjedhjet për Bundestagun",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "në Gjermani",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:109|sr": [
    {
      german: "Wie oft",
      translated: "Koliko se često",
      tone: 'semantic',
    },
    {
      german: "gibt es",
      translated: "održavaju",
      tone: 'semantic',
    },
    {
      german: "normalerweise",
      translated: "po pravilu",
      tone: 'semantic',
    },
    {
      german: "Bundestagswahlen",
      translated: "izbori za Bundestag",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "u Nemačkoj",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:109|tr": [
    {
      german: "Wie oft",
      translated: "ne sıklıkla",
      tone: 'semantic',
    },
    {
      german: "normalerweise",
      translated: "normalde",
      tone: 'semantic',
    },
    {
      german: "Bundestagswahlen",
      translated: "Federal Meclis seçimleri",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "Almanya'da",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:109|uk": [
    {
      german: "Wie oft",
      translated: "Як часто",
      tone: 'semantic',
    },
    {
      german: "gibt es",
      translated: "відбуваються",
      tone: 'semantic',
    },
    {
      german: "normalerweise",
      translated: "зазвичай",
      tone: 'semantic',
    },
    {
      german: "Bundestagswahlen",
      translated: "вибори до Бундестагу",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "в Німеччині",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:109|vi": [
    {
      german: "Wie oft",
      translated: "bao lâu",
      tone: 'semantic',
    },
    {
      german: "normalerweise",
      translated: "Thông thường",
      tone: 'semantic',
    },
    {
      german: "Bundestagswahlen",
      translated: "bầu cử Bundestag",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "ở Đức",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:10|ar": [
    {
      german: "Was ist",
      translated: "أي",
      tone: 'semantic',
    },
    {
      german: "mit dem deutschen Grundgesetz",
      translated: "مع القانون الأساسي الألماني",
      tone: 'semantic',
    },
    {
      german: "vereinbar?",
      translated: "يتوافق",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:10|bg": [
    {
      german: "Was ist",
      translated: "Кое е",
      tone: 'semantic',
    },
    {
      german: "mit dem deutschen Grundgesetz",
      translated: "с германския Основен закон",
      tone: 'semantic',
    },
    {
      german: "vereinbar?",
      translated: "съвместимо",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:10|bs": [
    {
      german: "Was ist",
      translated: "Što je",
      tone: 'semantic',
    },
    {
      german: "mit dem deutschen Grundgesetz",
      translated: "s njemačkim Temeljnim zakonom",
      tone: 'semantic',
    },
    {
      german: "vereinbar?",
      translated: "u skladu",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:10|el": [
    {
      german: "Was ist",
      translated: "Ποιο από τα παρακάτω είναι",
      tone: 'semantic',
    },
    {
      german: "mit dem deutschen Grundgesetz",
      translated: "με τον γερμανικό Θεμελιώδη Νόμο",
      tone: 'semantic',
    },
    {
      german: "vereinbar?",
      translated: "συμβατό",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:10|en": [
    {
      german: "Was ist",
      translated: "What is",
      tone: 'semantic',
    },
    {
      german: "mit dem deutschen Grundgesetz",
      translated: "with the German Basic Law",
      tone: 'semantic',
    },
    {
      german: "vereinbar?",
      translated: "compatible",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:10|es": [
    {
      german: "Was ist",
      translated: "¿Qué es",
      tone: 'semantic',
    },
    {
      german: "mit dem deutschen Grundgesetz",
      translated: "con la Ley Fundamental alemana",
      tone: 'semantic',
    },
    {
      german: "vereinbar?",
      translated: "compatible",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:10|fa": [
    {
      german: "Was ist",
      translated: "کدام",
      tone: 'semantic',
    },
    {
      german: "mit dem deutschen Grundgesetz",
      translated: "با قانون اساسی آلمان",
      tone: 'semantic',
    },
    {
      german: "vereinbar?",
      translated: "سازگار",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:10|fr": [
    {
      german: "Was ist",
      translated: "Lequel",
      tone: 'semantic',
    },
    {
      german: "mit dem deutschen Grundgesetz",
      translated: "avec la Loi fondamentale allemande",
      tone: 'semantic',
    },
    {
      german: "vereinbar?",
      translated: "compatible",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:10|hr": [
    {
      german: "Was ist",
      translated: "Što je",
      tone: 'semantic',
    },
    {
      german: "mit dem deutschen Grundgesetz",
      translated: "s njemačkim Temeljnim zakonom",
      tone: 'semantic',
    },
    {
      german: "vereinbar?",
      translated: "u skladu",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:10|it": [
    {
      german: "Was ist",
      translated: "Quale dei seguenti è",
      tone: 'semantic',
    },
    {
      german: "mit dem deutschen Grundgesetz",
      translated: "con la Legge fondamentale tedesca",
      tone: 'semantic',
    },
    {
      german: "vereinbar?",
      translated: "compatibile",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:10|kmr": [
    {
      german: "Was ist",
      translated: "Kîjan ji van",
      tone: 'semantic',
    },
    {
      german: "mit dem deutschen Grundgesetz",
      translated: "bi Qanûna Bingehîn a Almanyayê",
      tone: 'semantic',
    },
    {
      german: "vereinbar?",
      translated: "re li hev tê?",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:10|pl": [
    {
      german: "Was ist",
      translated: "Które z poniższych jest",
      tone: 'semantic',
    },
    {
      german: "mit dem deutschen Grundgesetz",
      translated: "z niemiecką Ustawą Zasadniczą",
      tone: 'semantic',
    },
    {
      german: "vereinbar?",
      translated: "zgodne",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:10|prs": [
    {
      german: "Was ist",
      translated: "کدام مورد",
      tone: 'semantic',
    },
    {
      german: "mit dem deutschen Grundgesetz",
      translated: "با قانون اساسی آلمان",
      tone: 'semantic',
    },
    {
      german: "vereinbar?",
      translated: "سازگار است؟",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:10|ro": [
    {
      german: "Was ist",
      translated: "Ce este",
      tone: 'semantic',
    },
    {
      german: "mit dem deutschen Grundgesetz",
      translated: "cu Legea fundamentală germană",
      tone: 'semantic',
    },
    {
      german: "vereinbar?",
      translated: "compatibil",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:10|ru": [
    {
      german: "Was ist",
      translated: "Что",
      tone: 'semantic',
    },
    {
      german: "mit dem deutschen Grundgesetz",
      translated: "с Основным законом Германии",
      tone: 'semantic',
    },
    {
      german: "vereinbar?",
      translated: "совместимо",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:10|sq": [
    {
      german: "Was ist",
      translated: "Cila nga këto",
      tone: 'semantic',
    },
    {
      german: "mit dem deutschen Grundgesetz",
      translated: "me Ligjin Themelor gjerman",
      tone: 'semantic',
    },
    {
      german: "vereinbar?",
      translated: "përputhje",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:10|sr": [
    {
      german: "Was ist",
      translated: "Šta je",
      tone: 'semantic',
    },
    {
      german: "mit dem deutschen Grundgesetz",
      translated: "u skladu s nemačkim Osnovnim zakonom",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:10|tr": [
    {
      german: "Was ist",
      translated: "hangisi",
      tone: 'semantic',
    },
    {
      german: "mit dem deutschen Grundgesetz",
      translated: "Alman Anayasası ile",
      tone: 'semantic',
    },
    {
      german: "vereinbar?",
      translated: "bağdaşır?",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:10|uk": [
    {
      german: "Was ist",
      translated: "Що",
      tone: 'semantic',
    },
    {
      german: "mit dem deutschen Grundgesetz",
      translated: "Основному закону Німеччини",
      tone: 'semantic',
    },
    {
      german: "vereinbar?",
      translated: "відповідає",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:10|vi": [
    {
      german: "Was ist",
      translated: "Điều nào",
      tone: 'semantic',
    },
    {
      german: "mit dem deutschen Grundgesetz",
      translated: "với Luật Cơ bản của Đức",
      tone: 'semantic',
    },
    {
      german: "vereinbar?",
      translated: "phù hợp",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:110|ar": [
    {
      german: "Für wie viele Jahre",
      translated: "لمدة كم سنة",
      tone: 'semantic',
    },
    {
      german: "der Bundestag",
      translated: "البوندستاغ",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "في ألمانيا",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:110|bg": [
    {
      german: "Für wie viele Jahre",
      translated: "За колко години",
      tone: 'semantic',
    },
    {
      german: "wird",
      translated: "се",
      tone: 'semantic',
    },
    {
      german: "der Bundestag",
      translated: "Бундестагът",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "в Германия?",
      tone: 'semantic',
    },
    {
      german: "gewählt",
      translated: "избира",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:110|bs": [
    {
      german: "Für wie viele Jahre",
      translated: "Na koliko se godina",
      tone: 'semantic',
    },
    {
      german: "der Bundestag",
      translated: "Bundestag",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "u Njemačkoj?",
      tone: 'semantic',
    },
    {
      german: "gewählt",
      translated: "bira",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:110|el": [
    {
      german: "Für wie viele Jahre",
      translated: "Για πόσα χρόνια",
      tone: 'semantic',
    },
    {
      german: "der Bundestag",
      translated: "το Bundestag",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "στη Γερμανία",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:110|en": [
    {
      german: "Für wie viele Jahre",
      translated: "For how many years",
      tone: 'semantic',
    },
    {
      german: "wird",
      translated: "is",
      tone: 'semantic',
    },
    {
      german: "der Bundestag",
      translated: "the Bundestag",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "in Germany",
      tone: 'semantic',
    },
    {
      german: "gewählt",
      translated: "elected",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:110|es": [
    {
      german: "Für wie viele Jahre",
      translated: "Por cuántos años",
      tone: 'semantic',
    },
    {
      german: "wird",
      translated: "se",
      tone: 'semantic',
    },
    {
      german: "der Bundestag",
      translated: "el Bundestag",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "en Alemania",
      tone: 'semantic',
    },
    {
      german: "gewählt",
      translated: "elige",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:110|fa": [
    {
      german: "Für wie viele Jahre",
      translated: "برای چند سال",
      tone: 'semantic',
    },
    {
      german: "wird",
      translated: "می‌شود",
      tone: 'semantic',
    },
    {
      german: "der Bundestag",
      translated: "بوندستاگ",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "در آلمان",
      tone: 'semantic',
    },
    {
      german: "gewählt",
      translated: "انتخاب",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:110|fr": [
    {
      german: "Für wie viele Jahre",
      translated: "Pour combien d’années",
      tone: 'semantic',
    },
    {
      german: "wird",
      translated: "est-il",
      tone: 'semantic',
    },
    {
      german: "der Bundestag",
      translated: "le Bundestag",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "en Allemagne",
      tone: 'semantic',
    },
    {
      german: "gewählt",
      translated: "élu",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:110|hr": [
    {
      german: "Für wie viele Jahre",
      translated: "Na koliko se godina",
      tone: 'semantic',
    },
    {
      german: "der Bundestag",
      translated: "Bundestag",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "u Njemačkoj",
      tone: 'semantic',
    },
    {
      german: "gewählt",
      translated: "bira",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:110|it": [
    {
      german: "Für wie viele Jahre",
      translated: "Per quanti anni",
      tone: 'semantic',
    },
    {
      german: "wird",
      translated: "viene",
      tone: 'semantic',
    },
    {
      german: "der Bundestag",
      translated: "il Bundestag",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "in Germania",
      tone: 'semantic',
    },
    {
      german: "gewählt",
      translated: "eletto",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:110|kmr": [
    {
      german: "Für wie viele Jahre",
      translated: "ji bo çend salan",
      tone: 'semantic',
    },
    {
      german: "wird",
      translated: "tê",
      tone: 'semantic',
    },
    {
      german: "der Bundestag",
      translated: "Bundestag",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "li Almanyayê",
      tone: 'semantic',
    },
    {
      german: "gewählt",
      translated: "hilbijartin",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:110|pl": [
    {
      german: "Für wie viele Jahre",
      translated: "Na ile lat",
      tone: 'semantic',
    },
    {
      german: "wird",
      translated: "jest",
      tone: 'semantic',
    },
    {
      german: "der Bundestag",
      translated: "Bundestag",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "w Niemczech",
      tone: 'semantic',
    },
    {
      german: "gewählt",
      translated: "wybierany",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:110|prs": [
    {
      german: "Für wie viele Jahre",
      translated: "چند سال",
      tone: 'semantic',
    },
    {
      german: "wird",
      translated: "می‌شود",
      tone: 'semantic',
    },
    {
      german: "der Bundestag",
      translated: "بوندستاگ",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "در آلمان",
      tone: 'semantic',
    },
    {
      german: "gewählt",
      translated: "انتخاب",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:110|ro": [
    {
      german: "Für wie viele Jahre",
      translated: "Pentru câți ani",
      tone: 'semantic',
    },
    {
      german: "wird",
      translated: "este",
      tone: 'semantic',
    },
    {
      german: "der Bundestag",
      translated: "Bundestagul",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "în Germania",
      tone: 'semantic',
    },
    {
      german: "gewählt",
      translated: "ales",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:110|ru": [
    {
      german: "Für wie viele Jahre",
      translated: "На сколько лет",
      tone: 'semantic',
    },
    {
      german: "der Bundestag",
      translated: "Бундестаг",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "в Германии",
      tone: 'semantic',
    },
    {
      german: "gewählt",
      translated: "избирается",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:110|sq": [
    {
      german: "Für wie viele Jahre",
      translated: "Për sa vjet",
      tone: 'semantic',
    },
    {
      german: "der Bundestag",
      translated: "Bundestagu",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "në Gjermani",
      tone: 'semantic',
    },
    {
      german: "gewählt",
      translated: "zgjidhet",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:110|sr": [
    {
      german: "Für wie viele Jahre",
      translated: "Na koliko se godina",
      tone: 'semantic',
    },
    {
      german: "wird",
      translated: "bira",
      tone: 'semantic',
    },
    {
      german: "der Bundestag",
      translated: "Bundestag",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "u Nemačkoj",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:110|tr": [
    {
      german: "Für wie viele Jahre",
      translated: "kaç yıllığına",
      tone: 'semantic',
    },
    {
      german: "der Bundestag",
      translated: "Federal Meclis",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "Almanya'da",
      tone: 'semantic',
    },
    {
      german: "gewählt",
      translated: "seçilir",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:110|uk": [
    {
      german: "Für wie viele Jahre",
      translated: "На скільки років",
      tone: 'semantic',
    },
    {
      german: "der Bundestag",
      translated: "Бундестаг",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "у Німеччині",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:110|vi": [
    {
      german: "Für wie viele Jahre",
      translated: "bao nhiêu năm?",
      tone: 'semantic',
    },
    {
      german: "wird",
      translated: "được",
      tone: 'semantic',
    },
    {
      german: "der Bundestag",
      translated: "Bundestag",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "ở Đức",
      tone: 'semantic',
    },
    {
      german: "gewählt",
      translated: "bầu",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:111|ar": [
    {
      german: "Welche Handlungen",
      translated: "أي تصرف",
      tone: 'semantic',
    },
    {
      german: "den Staat Israel",
      translated: "متعلق بدولة إسرائيل",
      tone: 'semantic',
    },
    {
      german: "sind in Deutschland",
      translated: "في ألمانيا",
      tone: 'semantic',
    },
    {
      german: "verboten",
      translated: "محظور",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:111|bg": [
    {
      german: "Welche Handlungen",
      translated: "Кое действие",
      tone: 'semantic',
    },
    {
      german: "mit Bezug auf",
      translated: "по отношение на",
      tone: 'semantic',
    },
    {
      german: "den Staat Israel",
      translated: "държавата Израел",
      tone: 'semantic',
    },
    {
      german: "sind in Deutschland",
      translated: "в Германия",
      tone: 'semantic',
    },
    {
      german: "verboten",
      translated: "забранено",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:111|bs": [
    {
      german: "Welche Handlungen",
      translated: "Koje je postupanje",
      tone: 'semantic',
    },
    {
      german: "mit Bezug auf",
      translated: "prema",
      tone: 'semantic',
    },
    {
      german: "den Staat Israel",
      translated: "državi Izrael",
      tone: 'semantic',
    },
    {
      german: "sind in Deutschland",
      translated: "u Njemačkoj",
      tone: 'semantic',
    },
    {
      german: "verboten",
      translated: "zabranjeno",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:111|el": [
    {
      german: "Welche Handlungen",
      translated: "Ποια ενέργεια",
      tone: 'semantic',
    },
    {
      german: "mit Bezug auf",
      translated: "σχετικά με",
      tone: 'semantic',
    },
    {
      german: "den Staat Israel",
      translated: "το κράτος του Ισραήλ",
      tone: 'semantic',
    },
    {
      german: "verboten",
      translated: "απαγορεύεται",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:111|en": [
    {
      german: "Welche Handlungen",
      translated: "Which action",
      tone: 'semantic',
    },
    {
      german: "mit Bezug auf",
      translated: "related to",
      tone: 'semantic',
    },
    {
      german: "den Staat Israel",
      translated: "the state of Israel",
      tone: 'semantic',
    },
    {
      german: "sind in Deutschland",
      translated: "in Germany",
      tone: 'semantic',
    },
    {
      german: "verboten",
      translated: "prohibited",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:111|es": [
    {
      german: "Welche Handlungen",
      translated: "¿Qué acción",
      tone: 'semantic',
    },
    {
      german: "mit Bezug auf",
      translated: "relacionada con",
      tone: 'semantic',
    },
    {
      german: "den Staat Israel",
      translated: "el Estado de Israel",
      tone: 'semantic',
    },
    {
      german: "sind in Deutschland",
      translated: "en Alemania",
      tone: 'semantic',
    },
    {
      german: "verboten",
      translated: "prohibida",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:111|fa": [
    {
      german: "Welche Handlungen",
      translated: "کدام اقدام",
      tone: 'semantic',
    },
    {
      german: "mit Bezug auf",
      translated: "در ارتباط با",
      tone: 'semantic',
    },
    {
      german: "den Staat Israel",
      translated: "کشور اسرائیل",
      tone: 'semantic',
    },
    {
      german: "sind in Deutschland",
      translated: "در آلمان",
      tone: 'semantic',
    },
    {
      german: "verboten",
      translated: "ممنوع است",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:111|fr": [
    {
      german: "Welche Handlungen",
      translated: "Quels actes",
      tone: 'semantic',
    },
    {
      german: "mit Bezug auf",
      translated: "liés à",
      tone: 'semantic',
    },
    {
      german: "den Staat Israel",
      translated: "l’État d’Israël",
      tone: 'semantic',
    },
    {
      german: "sind in Deutschland",
      translated: "en Allemagne",
      tone: 'semantic',
    },
    {
      german: "verboten",
      translated: "interdits",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:111|hr": [
    {
      german: "Welche Handlungen",
      translated: "Koje je postupanje",
      tone: 'semantic',
    },
    {
      german: "mit Bezug auf",
      translated: "prema",
      tone: 'semantic',
    },
    {
      german: "den Staat Israel",
      translated: "državi Izrael",
      tone: 'semantic',
    },
    {
      german: "sind in Deutschland",
      translated: "u Njemačkoj",
      tone: 'semantic',
    },
    {
      german: "verboten",
      translated: "zabranjeno",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:111|it": [
    {
      german: "Welche Handlungen",
      translated: "Quale azione",
      tone: 'semantic',
    },
    {
      german: "mit Bezug auf",
      translated: "relativa allo",
      tone: 'semantic',
    },
    {
      german: "den Staat Israel",
      translated: "Stato di Israele",
      tone: 'semantic',
    },
    {
      german: "sind in Deutschland",
      translated: "in Germania?",
      tone: 'semantic',
    },
    {
      german: "verboten",
      translated: "vietata",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:111|kmr": [
    {
      german: "Welche Handlungen",
      translated: "Kîjan kiryarên",
      tone: 'semantic',
    },
    {
      german: "mit Bezug auf",
      translated: "girêdayî",
      tone: 'semantic',
    },
    {
      german: "den Staat Israel",
      translated: "dewleta Îsraîl",
      tone: 'semantic',
    },
    {
      german: "sind in Deutschland",
      translated: "li Almanyayê",
      tone: 'semantic',
    },
    {
      german: "verboten",
      translated: "qedexe",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:111|pl": [
    {
      german: "Welche Handlungen",
      translated: "Które działanie",
      tone: 'semantic',
    },
    {
      german: "mit Bezug auf",
      translated: "dotyczące",
      tone: 'semantic',
    },
    {
      german: "den Staat Israel",
      translated: "państwa Izrael",
      tone: 'semantic',
    },
    {
      german: "sind in Deutschland",
      translated: "jest w Niemczech",
      tone: 'semantic',
    },
    {
      german: "verboten",
      translated: "zabronione",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:111|prs": [
    {
      german: "Welche Handlungen",
      translated: "کدام اقدام",
      tone: 'semantic',
    },
    {
      german: "mit Bezug auf",
      translated: "در ارتباط با",
      tone: 'semantic',
    },
    {
      german: "den Staat Israel",
      translated: "کشور اسرائیل",
      tone: 'semantic',
    },
    {
      german: "sind in Deutschland",
      translated: "در آلمان",
      tone: 'semantic',
    },
    {
      german: "verboten",
      translated: "ممنوع",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:111|ro": [
    {
      german: "Welche Handlungen",
      translated: "Care acțiune",
      tone: 'semantic',
    },
    {
      german: "mit Bezug auf",
      translated: "referitoare la",
      tone: 'semantic',
    },
    {
      german: "den Staat Israel",
      translated: "statul Israel",
      tone: 'semantic',
    },
    {
      german: "sind in Deutschland",
      translated: "în Germania",
      tone: 'semantic',
    },
    {
      german: "verboten",
      translated: "interzisă",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:111|ru": [
    {
      german: "Welche Handlungen",
      translated: "Какие действия",
      tone: 'semantic',
    },
    {
      german: "mit Bezug auf",
      translated: "связанные с",
      tone: 'semantic',
    },
    {
      german: "den Staat Israel",
      translated: "государством Израиль",
      tone: 'semantic',
    },
    {
      german: "sind in Deutschland",
      translated: "в Германии",
      tone: 'semantic',
    },
    {
      german: "verboten",
      translated: "запрещены",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:111|sq": [
    {
      german: "Welche Handlungen",
      translated: "Cili veprim",
      tone: 'semantic',
    },
    {
      german: "mit Bezug auf",
      translated: "në lidhje me",
      tone: 'semantic',
    },
    {
      german: "den Staat Israel",
      translated: "shtetin e Izraelit",
      tone: 'semantic',
    },
    {
      german: "sind in Deutschland",
      translated: "në Gjermani",
      tone: 'semantic',
    },
    {
      german: "verboten",
      translated: "është i ndaluar",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:111|sr": [
    {
      german: "Welche Handlungen",
      translated: "Koje je postupanje",
      tone: 'semantic',
    },
    {
      german: "mit Bezug auf",
      translated: "prema",
      tone: 'semantic',
    },
    {
      german: "den Staat Israel",
      translated: "državi Izrael",
      tone: 'semantic',
    },
    {
      german: "sind in Deutschland",
      translated: "u Nemačkoj",
      tone: 'semantic',
    },
    {
      german: "verboten",
      translated: "zabranjeno",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:111|tr": [
    {
      german: "Welche Handlungen",
      translated: "hangi eylem",
      tone: 'semantic',
    },
    {
      german: "mit Bezug auf",
      translated: "ilgili",
      tone: 'semantic',
    },
    {
      german: "den Staat Israel",
      translated: "İsrail devletiyle",
      tone: 'semantic',
    },
    {
      german: "sind in Deutschland",
      translated: "Almanya'da",
      tone: 'semantic',
    },
    {
      german: "verboten",
      translated: "yasaktır",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:111|uk": [
    {
      german: "Welche Handlungen",
      translated: "Які дії",
      tone: 'semantic',
    },
    {
      german: "mit Bezug auf",
      translated: "пов’язані з",
      tone: 'semantic',
    },
    {
      german: "den Staat Israel",
      translated: "державою Ізраїль",
      tone: 'semantic',
    },
    {
      german: "sind in Deutschland",
      translated: "в Німеччині",
      tone: 'semantic',
    },
    {
      german: "verboten",
      translated: "заборонені",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:111|vi": [
    {
      german: "Welche Handlungen",
      translated: "Hành động nào",
      tone: 'semantic',
    },
    {
      german: "mit Bezug auf",
      translated: "liên quan đến",
      tone: 'semantic',
    },
    {
      german: "den Staat Israel",
      translated: "Nhà nước Israel",
      tone: 'semantic',
    },
    {
      german: "sind in Deutschland",
      translated: "ở Đức",
      tone: 'semantic',
    },
    {
      german: "verboten",
      translated: "bị cấm",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:112|ar": [
    {
      german: "Die Wahlen",
      translated: "الانتخابات",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "في ألمانيا",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:112|bg": [
    {
      german: "Die Wahlen",
      translated: "Изборите",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "в Германия",
      tone: 'semantic',
    },
    {
      german: "sind",
      translated: "са",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:112|bs": [
    {
      german: "Die Wahlen",
      translated: "Izbori",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "u Njemačkoj",
      tone: 'semantic',
    },
    {
      german: "sind",
      translated: "su",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:112|el": [
    {
      german: "Die Wahlen",
      translated: "Οι εκλογές",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "στη Γερμανία",
      tone: 'semantic',
    },
    {
      german: "sind",
      translated: "είναι",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:112|en": [
    {
      german: "Die Wahlen",
      translated: "Elections",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "in Germany",
      tone: 'semantic',
    },
    {
      german: "sind",
      translated: "are",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:112|es": [
    {
      german: "Die Wahlen",
      translated: "Las elecciones",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "en Alemania",
      tone: 'semantic',
    },
    {
      german: "sind",
      translated: "son",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:112|fa": [
    {
      german: "Die Wahlen",
      translated: "انتخابات",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "در آلمان",
      tone: 'semantic',
    },
    {
      german: "sind",
      translated: "است.",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:112|fr": [
    {
      german: "Die Wahlen",
      translated: "Les élections",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "en Allemagne",
      tone: 'semantic',
    },
    {
      german: "sind",
      translated: "sont",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:112|hr": [
    {
      german: "Die Wahlen",
      translated: "Izbori",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "u Njemačkoj",
      tone: 'semantic',
    },
    {
      german: "sind",
      translated: "su",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:112|it": [
    {
      german: "Die Wahlen",
      translated: "Le elezioni",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "in Germania",
      tone: 'semantic',
    },
    {
      german: "sind",
      translated: "sono",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:112|kmr": [
    {
      german: "Die Wahlen",
      translated: "Hilbijartinên",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "Almanyayê",
      tone: 'semantic',
    },
    {
      german: "sind",
      translated: "in",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:112|pl": [
    {
      german: "Die Wahlen",
      translated: "Wybory",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "w Niemczech",
      tone: 'semantic',
    },
    {
      german: "sind",
      translated: "są",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:112|prs": [
    {
      german: "Die Wahlen",
      translated: "انتخابات",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "در آلمان",
      tone: 'semantic',
    },
    {
      german: "sind",
      translated: "است.",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:112|ro": [
    {
      german: "Die Wahlen",
      translated: "Alegerile",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "în Germania",
      tone: 'semantic',
    },
    {
      german: "sind",
      translated: "sunt",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:112|ru": [
    {
      german: "Die Wahlen",
      translated: "Выборы",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "в Германии",
      tone: 'semantic',
    },
    {
      german: "sind",
      translated: "являются",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:112|sq": [
    {
      german: "Die Wahlen",
      translated: "Zgjedhjet",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "në Gjermani",
      tone: 'semantic',
    },
    {
      german: "sind",
      translated: " janë",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:112|sr": [
    {
      german: "Die Wahlen",
      translated: "Izbori",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "u Nemačkoj",
      tone: 'semantic',
    },
    {
      german: "sind",
      translated: "su",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:112|tr": [
    {
      german: "Die Wahlen",
      translated: "seçimler",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "Almanya'daki",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:112|uk": [
    {
      german: "Die Wahlen",
      translated: "Вибори",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "в Німеччині",
      tone: 'semantic',
    },
    {
      german: "sind",
      translated: "є",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:112|vi": [
    {
      german: "Die Wahlen",
      translated: "Các cuộc bầu cử",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "ở Đức",
      tone: 'semantic',
    },
    {
      german: "sind",
      translated: "là",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:113|ar": [
    {
      german: "Wahlen",
      translated: "الانتخابات",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "في ألمانيا",
      tone: 'semantic',
    },
    {
      german: "gewinnt",
      translated: "يفوز",
      tone: 'semantic',
    },
    {
      german: "die Partei",
      translated: "الحزب",
      tone: 'semantic',
    },
    {
      german: "die",
      translated: "الذي",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:113|bg": [
    {
      german: "Wahlen",
      translated: "изборите",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "В Германия",
      tone: 'semantic',
    },
    {
      german: "gewinnt",
      translated: "печели",
      tone: 'semantic',
    },
    {
      german: "die Partei",
      translated: "една партия",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:113|bs": [
    {
      german: "Wahlen",
      translated: "izborima",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "u Njemačkoj",
      tone: 'semantic',
    },
    {
      german: "gewinnt",
      translated: "pobjeđuje",
      tone: 'semantic',
    },
    {
      german: "die Partei",
      translated: "stranka",
      tone: 'semantic',
    },
    {
      german: "die",
      translated: "koja",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:113|el": [
    {
      german: "Wahlen",
      translated: "τις εκλογές",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "Στη Γερμανία",
      tone: 'semantic',
    },
    {
      german: "gewinnt",
      translated: "κερδίζει",
      tone: 'semantic',
    },
    {
      german: "die Partei",
      translated: "ένα κόμμα",
      tone: 'semantic',
    },
    {
      german: "die",
      translated: "που",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:113|en": [
    {
      german: "Wahlen",
      translated: "Elections",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "in Germany",
      tone: 'semantic',
    },
    {
      german: "gewinnt",
      translated: "are won",
      tone: 'semantic',
    },
    {
      german: "die Partei",
      translated: "the party",
      tone: 'semantic',
    },
    {
      german: "die",
      translated: "that",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:113|es": [
    {
      german: "Wahlen",
      translated: "las elecciones",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "En Alemania",
      tone: 'semantic',
    },
    {
      german: "gewinnt",
      translated: "gana",
      tone: 'semantic',
    },
    {
      german: "die Partei",
      translated: "el partido",
      tone: 'semantic',
    },
    {
      german: "die",
      translated: "que",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:113|fa": [
    {
      german: "Wahlen",
      translated: "انتخابات",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "در آلمان",
      tone: 'semantic',
    },
    {
      german: "gewinnt",
      translated: "برندهٔ",
      tone: 'semantic',
    },
    {
      german: "die Partei",
      translated: "حزبی",
      tone: 'semantic',
    },
    {
      german: "die",
      translated: "که",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:113|fr": [
    {
      german: "Wahlen",
      translated: "une élection",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "En Allemagne",
      tone: 'semantic',
    },
    {
      german: "gewinnt",
      translated: "est remportée",
      tone: 'semantic',
    },
    {
      german: "die Partei",
      translated: "le parti",
      tone: 'semantic',
    },
    {
      german: "die",
      translated: "qui",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:113|hr": [
    {
      german: "Wahlen",
      translated: "izborima",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "u Njemačkoj",
      tone: 'semantic',
    },
    {
      german: "gewinnt",
      translated: "pobjeđuje",
      tone: 'semantic',
    },
    {
      german: "die Partei",
      translated: "stranka",
      tone: 'semantic',
    },
    {
      german: "die",
      translated: "koja",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:113|it": [
    {
      german: "Wahlen",
      translated: "elezioni",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "In Germania",
      tone: 'semantic',
    },
    {
      german: "gewinnt",
      translated: "vince",
      tone: 'semantic',
    },
    {
      german: "die Partei",
      translated: "il partito",
      tone: 'semantic',
    },
    {
      german: "die",
      translated: "che",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:113|kmr": [
    {
      german: "in Deutschland",
      translated: "Li Almanyayê",
      tone: 'semantic',
    },
    {
      german: "gewinnt",
      translated: "hilbijartinê",
      tone: 'semantic',
    },
    {
      german: "die Partei",
      translated: "partiya",
      tone: 'semantic',
    },
    {
      german: "die",
      translated: "ew",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:113|pl": [
    {
      german: "Wahlen",
      translated: "wybory",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "W Niemczech",
      tone: 'semantic',
    },
    {
      german: "gewinnt",
      translated: "wygrywa",
      tone: 'semantic',
    },
    {
      german: "die Partei",
      translated: "partia",
      tone: 'semantic',
    },
    {
      german: "die",
      translated: "która",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:113|prs": [
    {
      german: "Wahlen",
      translated: "انتخابات",
      tone: 'semantic',
    },
    {
      german: "gewinnt",
      translated: "برندهٔ",
      tone: 'semantic',
    },
    {
      german: "die Partei",
      translated: "حزبی",
      tone: 'semantic',
    },
    {
      german: "die",
      translated: "که",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:113|ro": [
    {
      german: "Wahlen",
      translated: "alegerile",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "În Germania",
      tone: 'semantic',
    },
    {
      german: "gewinnt",
      translated: "câștigă",
      tone: 'semantic',
    },
    {
      german: "die Partei",
      translated: "un partid",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:113|ru": [
    {
      german: "Wahlen",
      translated: "выборах",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "в Германии",
      tone: 'semantic',
    },
    {
      german: "gewinnt",
      translated: "побеждает",
      tone: 'semantic',
    },
    {
      german: "die Partei",
      translated: "партия",
      tone: 'semantic',
    },
    {
      german: "die",
      translated: "которая",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:113|sq": [
    {
      german: "Wahlen",
      translated: "zgjedhjet",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "Në Gjermani",
      tone: 'semantic',
    },
    {
      german: "gewinnt",
      translated: "fiton",
      tone: 'semantic',
    },
    {
      german: "die Partei",
      translated: "një parti",
      tone: 'semantic',
    },
    {
      german: "die",
      translated: "kur",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:113|sr": [
    {
      german: "Wahlen",
      translated: "izborima",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "u Nemačkoj",
      tone: 'semantic',
    },
    {
      german: "gewinnt",
      translated: "pobjeđuje",
      tone: 'semantic',
    },
    {
      german: "die Partei",
      translated: "stranka",
      tone: 'semantic',
    },
    {
      german: "die",
      translated: "koja",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:113|tr": [
    {
      german: "Wahlen",
      translated: "seçimleri",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "Almanya'da",
      tone: 'semantic',
    },
    {
      german: "gewinnt",
      translated: "kazanır",
      tone: 'semantic',
    },
    {
      german: "die Partei",
      translated: "parti",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:113|uk": [
    {
      german: "Wahlen",
      translated: "Вибори",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "в Німеччині",
      tone: 'semantic',
    },
    {
      german: "gewinnt",
      translated: "виграє",
      tone: 'semantic',
    },
    {
      german: "die Partei",
      translated: "партія",
      tone: 'semantic',
    },
    {
      german: "die",
      translated: "яка",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:113|vi": [
    {
      german: "Wahlen",
      translated: "cử",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "Ở Đức",
      tone: 'semantic',
    },
    {
      german: "gewinnt",
      translated: "thắng",
      tone: 'semantic',
    },
    {
      german: "die Partei",
      translated: "một đảng",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:114|ar": [
    {
      german: "An demokratischen Wahlen in Deutschland teilzunehmen",
      translated: "المشاركة في الانتخابات الديمقراطية في ألمانيا",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "هي",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:114|bg": [
    {
      german: "An demokratischen Wahlen in Deutschland teilzunehmen",
      translated: "Участието в демократични избори в Германия",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "е",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:114|bs": [
    {
      german: "An demokratischen Wahlen in Deutschland teilzunehmen",
      translated: "Sudjelovanje na demokratskim izborima u Njemačkoj",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "je",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:114|el": [
    {
      german: "An demokratischen Wahlen in Deutschland teilzunehmen",
      translated: "Η συμμετοχή σε δημοκρατικές εκλογές στη Γερμανία",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "είναι",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:114|en": [
    {
      german: "An demokratischen Wahlen in Deutschland teilzunehmen",
      translated: "Participating in democratic elections in Germany",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "is",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:114|es": [
    {
      german: "An demokratischen Wahlen in Deutschland teilzunehmen",
      translated: "Participar en elecciones democráticas en Alemania",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "es",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:114|fa": [
    {
      german: "An demokratischen Wahlen in Deutschland teilzunehmen",
      translated: "شرکت در انتخابات دموکراتیک در آلمان",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "است",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:114|fr": [
    {
      german: "An demokratischen Wahlen in Deutschland teilzunehmen",
      translated: "Participer aux élections démocratiques en Allemagne",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "est",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:114|hr": [
    {
      german: "An demokratischen Wahlen in Deutschland teilzunehmen",
      translated: "Sudjelovanje na demokratskim izborima u Njemačkoj",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "je",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:114|it": [
    {
      german: "An demokratischen Wahlen in Deutschland teilzunehmen",
      translated: "Partecipare alle elezioni democratiche in Germania",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "è",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:114|kmr": [
    {
      german: "An demokratischen Wahlen in Deutschland teilzunehmen",
      translated: "Beşdarî hilbijartinên demokratîk li Almanyayê",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "e",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:114|pl": [
    {
      german: "An demokratischen Wahlen in Deutschland teilzunehmen",
      translated: "Udział w demokratycznych wyborach w Niemczech",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "jest",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:114|prs": [
    {
      german: "An demokratischen Wahlen in Deutschland teilzunehmen",
      translated: "شرکت در انتخابات دموکراتیک در آلمان",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "است",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:114|ro": [
    {
      german: "An demokratischen Wahlen in Deutschland teilzunehmen",
      translated: "Participarea la alegeri democratice în Germania",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "este",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:114|ru": [
    {
      german: "An demokratischen Wahlen in Deutschland teilzunehmen",
      translated: "Участие в демократических выборах в Германии",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "является",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:114|sq": [
    {
      german: "An demokratischen Wahlen in Deutschland teilzunehmen",
      translated: "Pjesëmarrja në zgjedhje demokratike në Gjermani",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "është",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:114|sr": [
    {
      german: "An demokratischen Wahlen in Deutschland teilzunehmen",
      translated: "Sudjelovanje na demokratskim izborima u Nemačkoj",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "je",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:114|tr": [
    {
      german: "An demokratischen Wahlen in Deutschland teilzunehmen",
      translated: "Almanya'da demokratik seçimlere katılmak",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:114|uk": [
    {
      german: "An demokratischen Wahlen in Deutschland teilzunehmen",
      translated: "Участь у демократичних виборах у Німеччині",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "це",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:114|vi": [
    {
      german: "An demokratischen Wahlen in Deutschland teilzunehmen",
      translated: "Tham gia bầu cử dân chủ ở Đức",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "là",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:115|ar": [
    {
      german: "Was bedeutet",
      translated: "ماذا يعني",
      tone: 'semantic',
    },
    {
      german: "aktives Wahlrecht",
      translated: "حق التصويت الفعّال",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "في ألمانيا",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:115|bg": [
    {
      german: "Was bedeutet",
      translated: "Какво означава",
      tone: 'semantic',
    },
    {
      german: "aktives Wahlrecht",
      translated: "активно избирателно право",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:115|bs": [
    {
      german: "aktives Wahlrecht",
      translated: "aktivno biračko pravo",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "u Njemačkoj",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:115|el": [
    {
      german: "Was bedeutet",
      translated: "Τι σημαίνει",
      tone: 'semantic',
    },
    {
      german: "aktives Wahlrecht",
      translated: "ενεργητικό εκλογικό δικαίωμα",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "στη Γερμανία",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:115|en": [
    {
      german: "Was bedeutet",
      translated: "What does",
      tone: 'semantic',
    },
    {
      german: "aktives Wahlrecht",
      translated: "active suffrage",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "in Germany",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:115|es": [
    {
      german: "Was bedeutet",
      translated: "¿Qué significa",
      tone: 'semantic',
    },
    {
      german: "aktives Wahlrecht",
      translated: "«sufragio activo»",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "en Alemania",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:115|fa": [
    {
      german: "Was bedeutet",
      translated: "یعنی چه",
      tone: 'semantic',
    },
    {
      german: "aktives Wahlrecht",
      translated: "حق رأی فعال",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "در آلمان",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:115|fr": [
    {
      german: "Was bedeutet",
      translated: "Que signifie",
      tone: 'semantic',
    },
    {
      german: "aktives Wahlrecht",
      translated: "droit de vote actif",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "en Allemagne",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:115|hr": [
    {
      german: "Was bedeutet",
      translated: "Što",
      tone: 'semantic',
    },
    {
      german: "aktives Wahlrecht",
      translated: "aktivno biračko pravo",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "u Njemačkoj",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:115|it": [
    {
      german: "Was bedeutet",
      translated: "Che cosa significa",
      tone: 'semantic',
    },
    {
      german: "aktives Wahlrecht",
      translated: "diritto di voto attivo",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "in Germania",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:115|kmr": [
    {
      german: "Was bedeutet",
      translated: "tê çi wateyê",
      tone: 'semantic',
    },
    {
      german: "aktives Wahlrecht",
      translated: "Mafê dengdanê yê aktîf",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "li Almanyayê",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:115|pl": [
    {
      german: "Was bedeutet",
      translated: "Co oznacza",
      tone: 'semantic',
    },
    {
      german: "aktives Wahlrecht",
      translated: "czynne prawo wyborcze",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "w Niemczech",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:115|prs": [
    {
      german: "Was bedeutet",
      translated: "یعنی چه",
      tone: 'semantic',
    },
    {
      german: "aktives Wahlrecht",
      translated: "حق رأی فعال",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "در آلمان",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:115|ro": [
    {
      german: "Was bedeutet",
      translated: "Ce înseamnă",
      tone: 'semantic',
    },
    {
      german: "aktives Wahlrecht",
      translated: "drept de vot activ",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "în Germania",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:115|ru": [
    {
      german: "Was bedeutet",
      translated: "Что означает",
      tone: 'semantic',
    },
    {
      german: "aktives Wahlrecht",
      translated: "активное избирательное право",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "в Германии",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:115|sq": [
    {
      german: "Was",
      translated: "çfarë",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:115|sr": [
    {
      german: "Was bedeutet",
      translated: "Šta u Nemačkoj znači",
      tone: 'semantic',
    },
    {
      german: "aktives Wahlrecht",
      translated: "„aktivno biračko pravo“",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:115|tr": [
    {
      german: "Was bedeutet",
      translated: "ne demektir",
      tone: 'semantic',
    },
    {
      german: "aktives Wahlrecht",
      translated: "\"aktif seçme hakkı\"",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "Almanya'da",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:115|uk": [
    {
      german: "Was bedeutet",
      translated: "Що означає",
      tone: 'semantic',
    },
    {
      german: "aktives Wahlrecht",
      translated: "активне виборче право",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "в Німеччині",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:115|vi": [
    {
      german: "Was bedeutet",
      translated: "có nghĩa là gì?",
      tone: 'semantic',
    },
    {
      german: "aktives Wahlrecht",
      translated: "“Quyền bầu cử chủ động”",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "ở Đức",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:116|ar": [
    {
      german: "Wenn Sie",
      translated: "إذا كان يحق لك",
      tone: 'semantic',
    },
    {
      german: "bei einer Bundestagswahl",
      translated: "في انتخابات البوندستاغ",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "في ألمانيا",
      tone: 'semantic',
    },
    {
      german: "wählen dürfen",
      translated: "،",
      tone: 'semantic',
    },
    {
      german: "heißt das",
      translated: "فهذا يسمى",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:116|bg": [
    {
      german: "Wenn Sie",
      translated: "Ако",
      tone: 'semantic',
    },
    {
      german: "bei einer Bundestagswahl",
      translated: "на избори за Бундестаг",
      tone: 'semantic',
    },
    {
      german: "wählen dürfen",
      translated: "право да гласувате",
      tone: 'semantic',
    },
    {
      german: "heißt das",
      translated: "това се нарича",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:116|bs": [
    {
      german: "Wenn Sie",
      translated: "Ako",
      tone: 'semantic',
    },
    {
      german: "bei einer Bundestagswahl",
      translated: "na izborima za Bundestag",
      tone: 'semantic',
    },
    {
      german: "wählen dürfen",
      translated: "pravo glasovati",
      tone: 'semantic',
    },
    {
      german: "heißt das",
      translated: "to se naziva",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:116|el": [
    {
      german: "Wenn Sie",
      translated: "Αν έχετε",
      tone: 'semantic',
    },
    {
      german: "bei einer Bundestagswahl",
      translated: "στις εκλογές του Bundestag",
      tone: 'semantic',
    },
    {
      german: "wählen dürfen",
      translated: "δικαίωμα ψήφου",
      tone: 'semantic',
    },
    {
      german: "heißt das",
      translated: "αυτό ονομάζεται",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:116|en": [
    {
      german: "Wenn Sie",
      translated: "If you",
      tone: 'semantic',
    },
    {
      german: "bei einer Bundestagswahl",
      translated: "in a federal election",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "in Germany",
      tone: 'semantic',
    },
    {
      german: "wählen dürfen",
      translated: "are allowed to vote",
      tone: 'semantic',
    },
    {
      german: "heißt das",
      translated: "that is called",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:116|es": [
    {
      german: "Wenn Sie",
      translated: "Si",
      tone: 'semantic',
    },
    {
      german: "bei einer Bundestagswahl",
      translated: "en unas elecciones federales",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "en Alemania",
      tone: 'semantic',
    },
    {
      german: "wählen dürfen",
      translated: "tiene derecho a votar",
      tone: 'semantic',
    },
    {
      german: "heißt das",
      translated: "eso se llama",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:116|fa": [
    {
      german: "Wenn Sie",
      translated: "اگر",
      tone: 'semantic',
    },
    {
      german: "bei einer Bundestagswahl",
      translated: "در انتخابات بوندستاگ",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "آلمان",
      tone: 'semantic',
    },
    {
      german: "wählen dürfen",
      translated: "حق رأی داشته باشید",
      tone: 'semantic',
    },
    {
      german: "heißt das",
      translated: "به آن … گفته می‌شود",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:116|fr": [
    {
      german: "Wenn Sie",
      translated: "Si vous",
      tone: 'semantic',
    },
    {
      german: "bei einer Bundestagswahl",
      translated: "lors d’une élection du Bundestag",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "en Allemagne",
      tone: 'semantic',
    },
    {
      german: "wählen dürfen",
      translated: "avez le droit de voter",
      tone: 'semantic',
    },
    {
      german: "heißt das",
      translated: "cela s’appelle",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:116|hr": [
    {
      german: "Wenn Sie",
      translated: "Ako",
      tone: 'semantic',
    },
    {
      german: "bei einer Bundestagswahl",
      translated: "na izborima za Bundestag",
      tone: 'semantic',
    },
    {
      german: "wählen dürfen",
      translated: "pravo glasovati",
      tone: 'semantic',
    },
    {
      german: "heißt das",
      translated: "to se naziva",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:116|it": [
    {
      german: "Wenn Sie",
      translated: "Se avete",
      tone: 'semantic',
    },
    {
      german: "bei einer Bundestagswahl",
      translated: "alle elezioni del Bundestag",
      tone: 'semantic',
    },
    {
      german: "wählen dürfen",
      translated: "diritto di votare",
      tone: 'semantic',
    },
    {
      german: "heißt das",
      translated: "questo si chiama",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:116|kmr": [
    {
      german: "Wenn Sie",
      translated: "Heke tu",
      tone: 'semantic',
    },
    {
      german: "bei einer Bundestagswahl",
      translated: "di hilbijartina Bundestagê",
      tone: 'semantic',
    },
    {
      german: "wählen dürfen",
      translated: "dikarî deng bidî",
      tone: 'semantic',
    },
    {
      german: "heißt das",
      translated: "ev tê gotin",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:116|pl": [
    {
      german: "Wenn Sie",
      translated: "Jeżeli macie",
      tone: 'semantic',
    },
    {
      german: "bei einer Bundestagswahl",
      translated: "w wyborach do Bundestagu",
      tone: 'semantic',
    },
    {
      german: "wählen dürfen",
      translated: "prawo głosować",
      tone: 'semantic',
    },
    {
      german: "heißt das",
      translated: "nazywa się to",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:116|prs": [
    {
      german: "Wenn Sie",
      translated: "اگر",
      tone: 'semantic',
    },
    {
      german: "bei einer Bundestagswahl",
      translated: "در انتخابات بوندستاگ",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "آلمان",
      tone: 'semantic',
    },
    {
      german: "wählen dürfen",
      translated: "حق رأی داشته باشید",
      tone: 'semantic',
    },
    {
      german: "heißt das",
      translated: "، به آن … گفته می‌شود",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:116|ro": [
    {
      german: "Wenn Sie",
      translated: "Dacă",
      tone: 'semantic',
    },
    {
      german: "bei einer Bundestagswahl",
      translated: "la alegerile pentru Bundestag",
      tone: 'semantic',
    },
    {
      german: "wählen dürfen",
      translated: "aveți drept de vot",
      tone: 'semantic',
    },
    {
      german: "heißt das",
      translated: "aceasta se numește",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:116|ru": [
    {
      german: "Wenn Sie",
      translated: "Если вы",
      tone: 'semantic',
    },
    {
      german: "bei einer Bundestagswahl",
      translated: "на выборах в Бундестаг",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "Германии",
      tone: 'semantic',
    },
    {
      german: "wählen dürfen",
      translated: "имеете право голосовать",
      tone: 'semantic',
    },
    {
      german: "heißt das",
      translated: "это называется",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:116|sq": [
    {
      german: "Wenn Sie",
      translated: "Nëse ke",
      tone: 'semantic',
    },
    {
      german: "bei einer Bundestagswahl",
      translated: "në zgjedhjet e Bundestagut",
      tone: 'semantic',
    },
    {
      german: "wählen dürfen",
      translated: "të drejtë të votosh",
      tone: 'semantic',
    },
    {
      german: "heißt das",
      translated: "kjo quhet",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:116|sr": [
    {
      german: "Wenn Sie",
      translated: "Ako",
      tone: 'semantic',
    },
    {
      german: "bei einer Bundestagswahl",
      translated: "na izborima za Bundestag",
      tone: 'semantic',
    },
    {
      german: "wählen dürfen",
      translated: "pravo glasati",
      tone: 'semantic',
    },
    {
      german: "heißt das",
      translated: "to se naziva",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:116|tr": [
    {
      german: "bei einer Bundestagswahl",
      translated: "Federal Meclis seçiminde",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "Almanya'da",
      tone: 'semantic',
    },
    {
      german: "wählen dürfen",
      translated: "oy kullanma hakkınız",
      tone: 'semantic',
    },
    {
      german: "heißt das",
      translated: "buna … denir",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:116|uk": [
    {
      german: "Wenn Sie",
      translated: "Якщо ви",
      tone: 'semantic',
    },
    {
      german: "bei einer Bundestagswahl",
      translated: "на виборах до Бундестагу",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "в Німеччині",
      tone: 'semantic',
    },
    {
      german: "wählen dürfen",
      translated: "маєте право голосувати",
      tone: 'semantic',
    },
    {
      german: "heißt das",
      translated: "це називається",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:116|vi": [
    {
      german: "Wenn Sie",
      translated: "Nếu bạn",
      tone: 'semantic',
    },
    {
      german: "bei einer Bundestagswahl",
      translated: "trong bầu cử Bundestag",
      tone: 'semantic',
    },
    {
      german: "wählen dürfen",
      translated: "có quyền bỏ phiếu",
      tone: 'semantic',
    },
    {
      german: "heißt das",
      translated: "điều đó được gọi là",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:117|ar": [
    {
      german: "Wie viel Prozent",
      translated: "ما النسبة",
      tone: 'semantic',
    },
    {
      german: "der Zweitstimmen",
      translated: "من «الأصوات الثانية»",
      tone: 'semantic',
    },
    {
      german: "müssen Parteien",
      translated: "التي",
      tone: 'semantic',
    },
    {
      german: "mindestens bekommen",
      translated: "يجب أن تحصل عليها",
      tone: 'semantic',
    },
    {
      german: "um in den Deutschen Bundestag",
      translated: "لكي تدخل البوندستاغ الألماني",
      tone: 'semantic',
    },
    {
      german: "gewählt zu werden",
      translated: "؟",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:117|bg": [
    {
      german: "Wie viel Prozent",
      translated: "Какъв минимален процент",
      tone: 'semantic',
    },
    {
      german: "der Zweitstimmen",
      translated: "от вторите гласове",
      tone: 'semantic',
    },
    {
      german: "müssen Parteien",
      translated: "трябва да получи партия",
      tone: 'semantic',
    },
    {
      german: "um in den Deutschen Bundestag",
      translated: "за да влезе в Бундестага?",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:117|bs": [
    {
      german: "Wie viel Prozent",
      translated: "Koliki minimalni udio",
      tone: 'semantic',
    },
    {
      german: "der Zweitstimmen",
      translated: "drugih glasova",
      tone: 'semantic',
    },
    {
      german: "müssen Parteien",
      translated: "stranka",
      tone: 'semantic',
    },
    {
      german: "mindestens bekommen",
      translated: "mora dobiti",
      tone: 'semantic',
    },
    {
      german: "um in den Deutschen Bundestag",
      translated: "u Bundestag",
      tone: 'semantic',
    },
    {
      german: "gewählt zu werden",
      translated: "ušla",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:117|el": [
    {
      german: "Wie viel Prozent",
      translated: "Τι ελάχιστο ποσοστό",
      tone: 'semantic',
    },
    {
      german: "der Zweitstimmen",
      translated: "δεύτερων ψήφων",
      tone: 'semantic',
    },
    {
      german: "müssen Parteien",
      translated: "πρέπει",
      tone: 'semantic',
    },
    {
      german: "mindestens bekommen",
      translated: "να λάβει",
      tone: 'semantic',
    },
    {
      german: "um in den Deutschen Bundestag",
      translated: "για να εισέλθει στο",
      tone: 'semantic',
    },
    {
      german: "gewählt zu werden",
      translated: "Bundestag",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:117|en": [
    {
      german: "Wie viel Prozent",
      translated: "What minimum percentage",
      tone: 'semantic',
    },
    {
      german: "der Zweitstimmen",
      translated: "of second votes",
      tone: 'semantic',
    },
    {
      german: "müssen Parteien",
      translated: "must parties",
      tone: 'semantic',
    },
    {
      german: "mindestens bekommen",
      translated: "receive",
      tone: 'semantic',
    },
    {
      german: "um in den Deutschen Bundestag",
      translated: "to the German Bundestag",
      tone: 'semantic',
    },
    {
      german: "gewählt zu werden",
      translated: "to be elected",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:117|es": [
    {
      german: "Wie viel Prozent",
      translated: "Qué porcentaje",
      tone: 'semantic',
    },
    {
      german: "der Zweitstimmen",
      translated: "de segundos votos",
      tone: 'semantic',
    },
    {
      german: "müssen Parteien",
      translated: "deben obtener los partidos",
      tone: 'semantic',
    },
    {
      german: "mindestens bekommen",
      translated: "mínimo",
      tone: 'semantic',
    },
    {
      german: "um in den Deutschen Bundestag",
      translated: "para entrar en el Bundestag alemán",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:117|fa": [
    {
      german: "Wie viel Prozent",
      translated: "چند درصد",
      tone: 'semantic',
    },
    {
      german: "der Zweitstimmen",
      translated: "رأی دوم",
      tone: 'semantic',
    },
    {
      german: "müssen Parteien",
      translated: "احزاب",
      tone: 'semantic',
    },
    {
      german: "mindestens bekommen",
      translated: "حداقل",
      tone: 'semantic',
    },
    {
      german: "um in den Deutschen Bundestag",
      translated: "ورود به بوندستاگ آلمان",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:117|fr": [
    {
      german: "Wie viel Prozent",
      translated: "Quel pourcentage",
      tone: 'semantic',
    },
    {
      german: "der Zweitstimmen",
      translated: "de secondes voix",
      tone: 'semantic',
    },
    {
      german: "müssen Parteien",
      translated: "les partis doivent-ils",
      tone: 'semantic',
    },
    {
      german: "mindestens bekommen",
      translated: "minimum",
      tone: 'semantic',
    },
    {
      german: "um in den Deutschen Bundestag",
      translated: "au Bundestag allemand",
      tone: 'semantic',
    },
    {
      german: "gewählt zu werden",
      translated: "entrer",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:117|hr": [
    {
      german: "Wie viel Prozent",
      translated: "Koliki",
      tone: 'semantic',
    },
    {
      german: "der Zweitstimmen",
      translated: "drugih glasova",
      tone: 'semantic',
    },
    {
      german: "müssen Parteien",
      translated: "stranka",
      tone: 'semantic',
    },
    {
      german: "mindestens bekommen",
      translated: "minimalni",
      tone: 'semantic',
    },
    {
      german: "um in den Deutschen Bundestag",
      translated: "da bi ušla u Bundestag",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:117|it": [
    {
      german: "Wie viel Prozent",
      translated: "Quale percentuale",
      tone: 'semantic',
    },
    {
      german: "der Zweitstimmen",
      translated: "di secondi voti",
      tone: 'semantic',
    },
    {
      german: "müssen Parteien",
      translated: "deve ottenere un partito",
      tone: 'semantic',
    },
    {
      german: "mindestens bekommen",
      translated: "minima",
      tone: 'semantic',
    },
    {
      german: "um in den Deutschen Bundestag",
      translated: "per entrare nel Bundestag",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:117|kmr": [
    {
      german: "Wie viel Prozent",
      translated: "çend ji sedî",
      tone: 'semantic',
    },
    {
      german: "der Zweitstimmen",
      translated: "dengên duyemîn",
      tone: 'semantic',
    },
    {
      german: "müssen Parteien",
      translated: "Partiyek divê",
      tone: 'semantic',
    },
    {
      german: "mindestens bekommen",
      translated: "herî kêm",
      tone: 'semantic',
    },
    {
      german: "um in den Deutschen Bundestag",
      translated: "da ku bikeve Bundestagê",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:117|pl": [
    {
      german: "Wie viel Prozent",
      translated: "procent",
      tone: 'semantic',
    },
    {
      german: "der Zweitstimmen",
      translated: "drugich głosów",
      tone: 'semantic',
    },
    {
      german: "müssen Parteien",
      translated: "musi uzyskać partia",
      tone: 'semantic',
    },
    {
      german: "mindestens bekommen",
      translated: "minimalny",
      tone: 'semantic',
    },
    {
      german: "um in den Deutschen Bundestag",
      translated: "do Bundestagu",
      tone: 'semantic',
    },
    {
      german: "gewählt zu werden",
      translated: "wejść",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:117|prs": [
    {
      german: "Wie viel Prozent",
      translated: "چند درصد",
      tone: 'semantic',
    },
    {
      german: "der Zweitstimmen",
      translated: "رأی دوم",
      tone: 'semantic',
    },
    {
      german: "müssen Parteien",
      translated: "احزاب",
      tone: 'semantic',
    },
    {
      german: "mindestens bekommen",
      translated: "حداقل",
      tone: 'semantic',
    },
    {
      german: "um in den Deutschen Bundestag",
      translated: "برای ورود به بوندستاگ آلمان",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:117|ro": [
    {
      german: "Wie viel Prozent",
      translated: "Ce procent",
      tone: 'semantic',
    },
    {
      german: "der Zweitstimmen",
      translated: "voturile secunde",
      tone: 'semantic',
    },
    {
      german: "müssen Parteien",
      translated: "trebuie să",
      tone: 'semantic',
    },
    {
      german: "mindestens bekommen",
      translated: "minim",
      tone: 'semantic',
    },
    {
      german: "um in den Deutschen Bundestag",
      translated: "pentru a intra în Bundestag",
      tone: 'semantic',
    },
    {
      german: "gewählt zu werden",
      translated: "de regulă",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:117|ru": [
    {
      german: "Wie viel Prozent",
      translated: "Какой минимальный процент",
      tone: 'semantic',
    },
    {
      german: "der Zweitstimmen",
      translated: "вторых голосов",
      tone: 'semantic',
    },
    {
      german: "müssen Parteien",
      translated: "партия",
      tone: 'semantic',
    },
    {
      german: "mindestens bekommen",
      translated: "должна получить",
      tone: 'semantic',
    },
    {
      german: "um in den Deutschen Bundestag",
      translated: "в Бундестаг Германии",
      tone: 'semantic',
    },
    {
      german: "gewählt zu werden",
      translated: "пройти",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:117|sq": [
    {
      german: "Wie viel Prozent",
      translated: "Sa për qind",
      tone: 'semantic',
    },
    {
      german: "der Zweitstimmen",
      translated: "të votave të dyta",
      tone: 'semantic',
    },
    {
      german: "müssen Parteien",
      translated: "duhet të marrë një parti",
      tone: 'semantic',
    },
    {
      german: "mindestens bekommen",
      translated: "të paktën",
      tone: 'semantic',
    },
    {
      german: "um in den Deutschen Bundestag",
      translated: "në Bundestag",
      tone: 'semantic',
    },
    {
      german: "gewählt zu werden",
      translated: "për të hyrë",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:117|sr": [
    {
      german: "Wie viel Prozent",
      translated: "Koliki",
      tone: 'semantic',
    },
    {
      german: "der Zweitstimmen",
      translated: "drugih glasova",
      tone: 'semantic',
    },
    {
      german: "müssen Parteien",
      translated: "stranka po pravilu mora",
      tone: 'semantic',
    },
    {
      german: "mindestens bekommen",
      translated: "minimalni udio",
      tone: 'semantic',
    },
    {
      german: "um in den Deutschen Bundestag",
      translated: "da bi ušla u Bundestag",
      tone: 'semantic',
    },
    {
      german: "gewählt zu werden",
      translated: "dobiti",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:117|tr": [
    {
      german: "Wie viel Prozent",
      translated: "yüzde kaçını",
      tone: 'semantic',
    },
    {
      german: "der Zweitstimmen",
      translated: "ikinci oyların",
      tone: 'semantic',
    },
    {
      german: "müssen Parteien",
      translated: "Bir siyasi partinin",
      tone: 'semantic',
    },
    {
      german: "mindestens bekommen",
      translated: "en az",
      tone: 'semantic',
    },
    {
      german: "um in den Deutschen Bundestag",
      translated: "Alman Federal Meclisine girebilmesi için",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:117|uk": [
    {
      german: "Wie viel Prozent",
      translated: "Який мінімальний відсоток",
      tone: 'semantic',
    },
    {
      german: "der Zweitstimmen",
      translated: "других голосів (Zweitstimmen)",
      tone: 'semantic',
    },
    {
      german: "müssen Parteien",
      translated: "партія",
      tone: 'semantic',
    },
    {
      german: "mindestens bekommen",
      translated: "повинна отримати",
      tone: 'semantic',
    },
    {
      german: "um in den Deutschen Bundestag",
      translated: "щоб пройти до німецького Бундестагу",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:117|vi": [
    {
      german: "Wie viel Prozent",
      translated: "bao nhiêu phần trăm",
      tone: 'semantic',
    },
    {
      german: "der Zweitstimmen",
      translated: "phiếu thứ hai",
      tone: 'semantic',
    },
    {
      german: "müssen Parteien",
      translated: "một đảng phải",
      tone: 'semantic',
    },
    {
      german: "mindestens bekommen",
      translated: "nhận ít nhất",
      tone: 'semantic',
    },
    {
      german: "um in den Deutschen Bundestag",
      translated: "để vào Bundestag",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:118|ar": [
    {
      german: "Wer",
      translated: "من",
      tone: 'semantic',
    },
    {
      german: "darf",
      translated: "يمكنه",
      tone: 'semantic',
    },
    {
      german: "bei den rund 40 jüdischen Makkabi-Sportvereinen",
      translated: "في نحو 40 ناديًا رياضيًا يهوديًا تابعًا لمكابي",
      tone: 'semantic',
    },
    {
      german: "Mitglied werden",
      translated: "أن يصبح عضوًا",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:118|bg": [
    {
      german: "Wer",
      translated: "Кой",
      tone: 'semantic',
    },
    {
      german: "darf",
      translated: "може",
      tone: 'semantic',
    },
    {
      german: "bei den rund 40 jüdischen Makkabi-Sportvereinen",
      translated: "на един от приблизително 40-те еврейски спортни клуба „Makkabi“",
      tone: 'semantic',
    },
    {
      german: "Mitglied werden",
      translated: "да стане член",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:118|bs": [
    {
      german: "Wer",
      translated: "Tko",
      tone: 'semantic',
    },
    {
      german: "darf",
      translated: "može",
      tone: 'semantic',
    },
    {
      german: "bei den rund 40 jüdischen Makkabi-Sportvereinen",
      translated: "jednog od približno 40 jevrejskih sportskih klubova „Makkabi“",
      tone: 'semantic',
    },
    {
      german: "Mitglied werden",
      translated: "postati član",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:118|el": [
    {
      german: "Wer",
      translated: "Ποιος",
      tone: 'semantic',
    },
    {
      german: "darf",
      translated: "μπορεί",
      tone: 'semantic',
    },
    {
      german: "bei den rund 40 jüdischen Makkabi-Sportvereinen",
      translated: "ενός από τους περίπου 40 εβραϊκούς αθλητικούς συλλόγους «Makkabi»",
      tone: 'semantic',
    },
    {
      german: "Mitglied werden",
      translated: "να γίνει μέλος",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:118|en": [
    {
      german: "Wer",
      translated: "Who",
      tone: 'semantic',
    },
    {
      german: "darf",
      translated: "can",
      tone: 'semantic',
    },
    {
      german: "bei den rund 40 jüdischen Makkabi-Sportvereinen",
      translated: "of the approximately 40 Jewish Maccabi sports clubs",
      tone: 'semantic',
    },
    {
      german: "Mitglied werden",
      translated: "become a member",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:118|es": [
    {
      german: "Wer",
      translated: "Quién",
      tone: 'semantic',
    },
    {
      german: "darf",
      translated: "puede",
      tone: 'semantic',
    },
    {
      german: "bei den rund 40 jüdischen Makkabi-Sportvereinen",
      translated: "de los aproximadamente 40 clubes deportivos judíos Maccabi",
      tone: 'semantic',
    },
    {
      german: "Mitglied werden",
      translated: "hacerse miembro",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:118|fa": [
    {
      german: "Wer",
      translated: "چه کسانی",
      tone: 'semantic',
    },
    {
      german: "darf",
      translated: "می‌توانند",
      tone: 'semantic',
    },
    {
      german: "bei den rund 40 jüdischen Makkabi-Sportvereinen",
      translated: "عضو یکی از حدود ۴۰ باشگاه ورزشی یهودی «مکابی»",
      tone: 'semantic',
    },
    {
      german: "Mitglied werden",
      translated: "شوند",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:118|fr": [
    {
      german: "Wer",
      translated: "Qui",
      tone: 'semantic',
    },
    {
      german: "darf",
      translated: "peut",
      tone: 'semantic',
    },
    {
      german: "bei den rund 40 jüdischen Makkabi-Sportvereinen",
      translated: "de l’un des quelque 40 clubs sportifs juifs Makkabi",
      tone: 'semantic',
    },
    {
      german: "Mitglied werden",
      translated: "devenir membre",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:118|hr": [
    {
      german: "Wer",
      translated: "Tko",
      tone: 'semantic',
    },
    {
      german: "darf",
      translated: "može",
      tone: 'semantic',
    },
    {
      german: "bei den rund 40 jüdischen Makkabi-Sportvereinen",
      translated: "jednog od približno 40 židovskih sportskih klubova „Makkabi“",
      tone: 'semantic',
    },
    {
      german: "Mitglied werden",
      translated: "postati član",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:118|it": [
    {
      german: "Wer",
      translated: "Chi",
      tone: 'semantic',
    },
    {
      german: "darf",
      translated: "può",
      tone: 'semantic',
    },
    {
      german: "bei den rund 40 jüdischen Makkabi-Sportvereinen",
      translated: "di uno dei circa 40 club sportivi ebraici Makkabi",
      tone: 'semantic',
    },
    {
      german: "Mitglied werden",
      translated: "diventare membro",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:118|kmr": [
    {
      german: "Wer",
      translated: "Kî",
      tone: 'semantic',
    },
    {
      german: "darf",
      translated: "dikare",
      tone: 'semantic',
    },
    {
      german: "bei den rund 40 jüdischen Makkabi-Sportvereinen",
      translated: "nêzîkî 40 klûbên sporê yên Cihûyan Makkabi",
      tone: 'semantic',
    },
    {
      german: "Mitglied werden",
      translated: "bibe endamê",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:118|pl": [
    {
      german: "Wer",
      translated: "Kto",
      tone: 'semantic',
    },
    {
      german: "darf",
      translated: "może",
      tone: 'semantic',
    },
    {
      german: "bei den rund 40 jüdischen Makkabi-Sportvereinen",
      translated: "jednego z około 40 żydowskich klubów sportowych „Makkabi”",
      tone: 'semantic',
    },
    {
      german: "Mitglied werden",
      translated: "zostać członkiem",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:118|prs": [
    {
      german: "Wer",
      translated: "چه کسانی",
      tone: 'semantic',
    },
    {
      german: "darf",
      translated: "می‌توانند",
      tone: 'semantic',
    },
    {
      german: "bei den rund 40 jüdischen Makkabi-Sportvereinen",
      translated: "عضو یکی از حدود ۴۰ باشگاه ورزشی یهودی «مکابی»",
      tone: 'semantic',
    },
    {
      german: "Mitglied werden",
      translated: "شوند",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:118|ro": [
    {
      german: "Wer",
      translated: "Cine",
      tone: 'semantic',
    },
    {
      german: "darf",
      translated: "poate",
      tone: 'semantic',
    },
    {
      german: "bei den rund 40 jüdischen Makkabi-Sportvereinen",
      translated: "al unuia dintre cele aproximativ 40 de cluburi sportive evreiești „Makkabi”",
      tone: 'semantic',
    },
    {
      german: "Mitglied werden",
      translated: "deveni membru",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:118|ru": [
    {
      german: "Wer",
      translated: "Кто",
      tone: 'semantic',
    },
    {
      german: "darf",
      translated: "может",
      tone: 'semantic',
    },
    {
      german: "bei den rund 40 jüdischen Makkabi-Sportvereinen",
      translated: "примерно 40 еврейских спортивных клубов «Маккаби»",
      tone: 'semantic',
    },
    {
      german: "Mitglied werden",
      translated: "стать членом",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:118|sq": [
    {
      german: "Wer",
      translated: "Kush",
      tone: 'semantic',
    },
    {
      german: "darf",
      translated: "mund",
      tone: 'semantic',
    },
    {
      german: "bei den rund 40 jüdischen Makkabi-Sportvereinen",
      translated: "rreth 40 klubeve sportive hebreje «Makkabi»",
      tone: 'semantic',
    },
    {
      german: "Mitglied werden",
      translated: "të bëhet anëtar",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:118|sr": [
    {
      german: "Wer",
      translated: "Ko",
      tone: 'semantic',
    },
    {
      german: "darf",
      translated: "može",
      tone: 'semantic',
    },
    {
      german: "bei den rund 40 jüdischen Makkabi-Sportvereinen",
      translated: "jednog od otprilike 40 jevrejskih sportskih klubova „Makkabi“",
      tone: 'semantic',
    },
    {
      german: "Mitglied werden",
      translated: "postati član",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:118|tr": [
    {
      german: "Wer",
      translated: "kimler",
      tone: 'semantic',
    },
    {
      german: "darf",
      translated: "olabilir?",
      tone: 'semantic',
    },
    {
      german: "bei den rund 40 jüdischen Makkabi-Sportvereinen",
      translated: "Yaklaşık 40 Yahudi Makkabi spor kulübüne",
      tone: 'semantic',
    },
    {
      german: "Mitglied werden",
      translated: "üye",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:118|uk": [
    {
      german: "Wer",
      translated: "Хто",
      tone: 'semantic',
    },
    {
      german: "darf",
      translated: "може",
      tone: 'semantic',
    },
    {
      german: "bei den rund 40 jüdischen Makkabi-Sportvereinen",
      translated: "приблизно 40 єврейських спортивних клубів Makkabi",
      tone: 'semantic',
    },
    {
      german: "Mitglied werden",
      translated: "стати членом",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:118|vi": [
    {
      german: "Wer",
      translated: "Ai",
      tone: 'semantic',
    },
    {
      german: "darf",
      translated: "có thể",
      tone: 'semantic',
    },
    {
      german: "bei den rund 40 jüdischen Makkabi-Sportvereinen",
      translated: "một trong khoảng 40 câu lạc bộ thể thao Do Thái “Makkabi”",
      tone: 'semantic',
    },
    {
      german: "Mitglied werden",
      translated: "trở thành thành viên",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:119|ar": [
    {
      german: "Wahlen in Deutschland",
      translated: "الانتخابات في ألمانيا",
      tone: 'semantic',
    },
    {
      german: "sind frei",
      translated: "حرة",
      tone: 'semantic',
    },
    {
      german: "Was bedeutet das",
      translated: "ماذا يعني ذلك؟",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:119|bg": [
    {
      german: "Wahlen in Deutschland",
      translated: "Изборите в Германия",
      tone: 'semantic',
    },
    {
      german: "sind frei",
      translated: "са свободни",
      tone: 'semantic',
    },
    {
      german: "Was bedeutet das",
      translated: "Какво означава това",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:119|bs": [
    {
      german: "Wahlen in Deutschland",
      translated: "Izbori u Njemačkoj",
      tone: 'semantic',
    },
    {
      german: "sind frei",
      translated: "su slobodni",
      tone: 'semantic',
    },
    {
      german: "Was bedeutet das",
      translated: "Što to znači",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:119|el": [
    {
      german: "Wahlen in Deutschland",
      translated: "Οι εκλογές στη Γερμανία",
      tone: 'semantic',
    },
    {
      german: "sind frei",
      translated: "είναι ελεύθερες",
      tone: 'semantic',
    },
    {
      german: "Was bedeutet das",
      translated: "Τι σημαίνει αυτό",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:119|en": [
    {
      german: "Wahlen in Deutschland",
      translated: "Elections in Germany",
      tone: 'semantic',
    },
    {
      german: "sind frei",
      translated: "are free",
      tone: 'semantic',
    },
    {
      german: "Was bedeutet das",
      translated: "What does that mean?",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:119|es": [
    {
      german: "Wahlen in Deutschland",
      translated: "Las elecciones en Alemania",
      tone: 'semantic',
    },
    {
      german: "sind frei",
      translated: "son libres",
      tone: 'semantic',
    },
    {
      german: "Was bedeutet das",
      translated: "¿Qué significa eso?",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:119|fa": [
    {
      german: "Wahlen in Deutschland",
      translated: "انتخابات در آلمان",
      tone: 'semantic',
    },
    {
      german: "sind frei",
      translated: "آزاد است",
      tone: 'semantic',
    },
    {
      german: "Was bedeutet das",
      translated: "این یعنی چه",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:119|fr": [
    {
      german: "Wahlen in Deutschland",
      translated: "Les élections en Allemagne",
      tone: 'semantic',
    },
    {
      german: "sind frei",
      translated: "sont libres",
      tone: 'semantic',
    },
    {
      german: "Was bedeutet das",
      translated: "Qu’est-ce que cela signifie",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:119|hr": [
    {
      german: "Wahlen in Deutschland",
      translated: "Izbori u Njemačkoj",
      tone: 'semantic',
    },
    {
      german: "sind frei",
      translated: "su slobodni",
      tone: 'semantic',
    },
    {
      german: "Was bedeutet das",
      translated: "Što to znači?",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:119|it": [
    {
      german: "Wahlen in Deutschland",
      translated: "Le elezioni in Germania",
      tone: 'semantic',
    },
    {
      german: "sind frei",
      translated: "sono libere",
      tone: 'semantic',
    },
    {
      german: "Was bedeutet das",
      translated: "Che cosa significa?",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:119|kmr": [
    {
      german: "Wahlen in Deutschland",
      translated: "Hilbijartinên Almanyayê",
      tone: 'semantic',
    },
    {
      german: "sind frei",
      translated: "azad in",
      tone: 'semantic',
    },
    {
      german: "Was bedeutet das",
      translated: "Ev tê çi wateyê?",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:119|pl": [
    {
      german: "Wahlen in Deutschland",
      translated: "Wybory w Niemczech",
      tone: 'semantic',
    },
    {
      german: "sind frei",
      translated: "są wolne",
      tone: 'semantic',
    },
    {
      german: "Was bedeutet das",
      translated: "Co to oznacza",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:119|prs": [
    {
      german: "Wahlen in Deutschland",
      translated: "انتخابات در آلمان",
      tone: 'semantic',
    },
    {
      german: "sind frei",
      translated: "آزاد است",
      tone: 'semantic',
    },
    {
      german: "Was bedeutet das",
      translated: "این یعنی چه؟",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:119|ro": [
    {
      german: "Wahlen in Deutschland",
      translated: "Alegerile în Germania",
      tone: 'semantic',
    },
    {
      german: "sind frei",
      translated: "sunt libere",
      tone: 'semantic',
    },
    {
      german: "Was bedeutet das",
      translated: "Ce înseamnă aceasta",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:119|ru": [
    {
      german: "Wahlen in Deutschland",
      translated: "Выборы в Германии",
      tone: 'semantic',
    },
    {
      german: "sind frei",
      translated: "свободные",
      tone: 'semantic',
    },
    {
      german: "Was bedeutet das",
      translated: "Что это значит?",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:119|sq": [
    {
      german: "Wahlen in Deutschland",
      translated: "Zgjedhjet në Gjermani",
      tone: 'semantic',
    },
    {
      german: "sind frei",
      translated: "të lira",
      tone: 'semantic',
    },
    {
      german: "Was bedeutet das",
      translated: "Çfarë do të thotë kjo",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:119|sr": [
    {
      german: "Wahlen in Deutschland",
      translated: "Izbori u Nemačkoj",
      tone: 'semantic',
    },
    {
      german: "sind frei",
      translated: "su slobodni",
      tone: 'semantic',
    },
    {
      german: "Was bedeutet das",
      translated: "Šta to znači?",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:119|tr": [
    {
      german: "Wahlen in Deutschland",
      translated: "Almanya'da seçimler",
      tone: 'semantic',
    },
    {
      german: "sind frei",
      translated: "özgürdür",
      tone: 'semantic',
    },
    {
      german: "Was bedeutet das",
      translated: "Bu ne anlama gelir?",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:119|uk": [
    {
      german: "Wahlen in Deutschland",
      translated: "Вибори в Німеччині",
      tone: 'semantic',
    },
    {
      german: "sind frei",
      translated: "є вільними",
      tone: 'semantic',
    },
    {
      german: "Was bedeutet das",
      translated: "Що це означає?",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:119|vi": [
    {
      german: "Wahlen in Deutschland",
      translated: "Các cuộc bầu cử ở Đức",
      tone: 'semantic',
    },
    {
      german: "sind frei",
      translated: "là tự do",
      tone: 'semantic',
    },
    {
      german: "Was bedeutet das",
      translated: "Điều đó có nghĩa là gì?",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:11|ar": [
    {
      german: "Wie wird",
      translated: "بماذا",
      tone: 'semantic',
    },
    {
      german: "die Verfassung",
      translated: "دستور",
      tone: 'semantic',
    },
    {
      german: "der Bundesrepublik Deutschland",
      translated: "جمهورية ألمانيا الاتحادية",
      tone: 'semantic',
    },
    {
      german: "genannt",
      translated: "يُسمى",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:11|bg": [
    {
      german: "Wie wird",
      translated: "Как се",
      tone: 'semantic',
    },
    {
      german: "die Verfassung",
      translated: "конституцията",
      tone: 'semantic',
    },
    {
      german: "der Bundesrepublik Deutschland",
      translated: "на Федерална република Германия",
      tone: 'semantic',
    },
    {
      german: "genannt",
      translated: "нарича",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:11|bs": [
    {
      german: "Wie wird",
      translated: "Kako se",
      tone: 'semantic',
    },
    {
      german: "die Verfassung",
      translated: "ustav",
      tone: 'semantic',
    },
    {
      german: "der Bundesrepublik Deutschland",
      translated: "Savezne Republike Njemačke",
      tone: 'semantic',
    },
    {
      german: "genannt",
      translated: "zove",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:11|el": [
    {
      german: "Wie wird",
      translated: "Πώς",
      tone: 'semantic',
    },
    {
      german: "die Verfassung",
      translated: "το Σύνταγμα",
      tone: 'semantic',
    },
    {
      german: "der Bundesrepublik Deutschland",
      translated: "της Ομοσπονδιακής Δημοκρατίας της Γερμανίας",
      tone: 'semantic',
    },
    {
      german: "genannt",
      translated: "ονομάζεται",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:11|en": [
    {
      german: "Wie wird",
      translated: "What is",
      tone: 'semantic',
    },
    {
      german: "die Verfassung",
      translated: "the constitution",
      tone: 'semantic',
    },
    {
      german: "der Bundesrepublik Deutschland",
      translated: "of the Federal Republic of Germany",
      tone: 'semantic',
    },
    {
      german: "genannt",
      translated: "called",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:11|es": [
    {
      german: "Wie wird",
      translated: "¿Cómo",
      tone: 'semantic',
    },
    {
      german: "die Verfassung",
      translated: "la Constitución",
      tone: 'semantic',
    },
    {
      german: "der Bundesrepublik Deutschland",
      translated: "de la República Federal de Alemania",
      tone: 'semantic',
    },
    {
      german: "genannt",
      translated: "llama",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:11|fa": [
    {
      german: "Wie wird",
      translated: "چه",
      tone: 'semantic',
    },
    {
      german: "die Verfassung",
      translated: "قانون اساسی",
      tone: 'semantic',
    },
    {
      german: "der Bundesrepublik Deutschland",
      translated: "جمهوری فدرال آلمان",
      tone: 'semantic',
    },
    {
      german: "genannt",
      translated: "نام دارد",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:11|fr": [
    {
      german: "Wie wird",
      translated: "Comment",
      tone: 'semantic',
    },
    {
      german: "die Verfassung",
      translated: "la Constitution",
      tone: 'semantic',
    },
    {
      german: "der Bundesrepublik Deutschland",
      translated: "de la République fédérale d’Allemagne",
      tone: 'semantic',
    },
    {
      german: "genannt",
      translated: "s’appelle",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:11|hr": [
    {
      german: "Wie wird",
      translated: "Kako se",
      tone: 'semantic',
    },
    {
      german: "die Verfassung",
      translated: "ustav",
      tone: 'semantic',
    },
    {
      german: "der Bundesrepublik Deutschland",
      translated: "Savezne Republike Njemačke",
      tone: 'semantic',
    },
    {
      german: "genannt",
      translated: "zove",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:11|it": [
    {
      german: "Wie wird",
      translated: "Come si",
      tone: 'semantic',
    },
    {
      german: "die Verfassung",
      translated: "la Costituzione",
      tone: 'semantic',
    },
    {
      german: "der Bundesrepublik Deutschland",
      translated: "della Repubblica Federale di Germania",
      tone: 'semantic',
    },
    {
      german: "genannt",
      translated: "chiama",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:11|kmr": [
    {
      german: "Wie wird",
      translated: "çi ye?",
      tone: 'semantic',
    },
    {
      german: "die Verfassung",
      translated: "destûra",
      tone: 'semantic',
    },
    {
      german: "der Bundesrepublik Deutschland",
      translated: "Komara Federal a Almanyayê",
      tone: 'semantic',
    },
    {
      german: "genannt",
      translated: "Navê",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:11|pl": [
    {
      german: "Wie wird",
      translated: "Jak",
      tone: 'semantic',
    },
    {
      german: "die Verfassung",
      translated: "konstytucja",
      tone: 'semantic',
    },
    {
      german: "der Bundesrepublik Deutschland",
      translated: "Republiki Federalnej Niemiec",
      tone: 'semantic',
    },
    {
      german: "genannt",
      translated: "nazywa się",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:11|prs": [
    {
      german: "Wie wird",
      translated: "چه",
      tone: 'semantic',
    },
    {
      german: "die Verfassung",
      translated: "قانون اساسی",
      tone: 'semantic',
    },
    {
      german: "der Bundesrepublik Deutschland",
      translated: "جمهوری فدرال آلمان",
      tone: 'semantic',
    },
    {
      german: "genannt",
      translated: "نام",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:11|ro": [
    {
      german: "Wie wird",
      translated: "Cum se",
      tone: 'semantic',
    },
    {
      german: "die Verfassung",
      translated: "constituția",
      tone: 'semantic',
    },
    {
      german: "der Bundesrepublik Deutschland",
      translated: "Republicii Federale Germania",
      tone: 'semantic',
    },
    {
      german: "genannt",
      translated: "numește",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:11|ru": [
    {
      german: "Wie wird",
      translated: "Как",
      tone: 'semantic',
    },
    {
      german: "die Verfassung",
      translated: "конституция",
      tone: 'semantic',
    },
    {
      german: "der Bundesrepublik Deutschland",
      translated: "Федеративной Республики Германия",
      tone: 'semantic',
    },
    {
      german: "genannt",
      translated: "называется",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:11|sq": [
    {
      german: "Wie wird",
      translated: "Si quhet",
      tone: 'semantic',
    },
    {
      german: "die Verfassung",
      translated: "Kushtetuta",
      tone: 'semantic',
    },
    {
      german: "der Bundesrepublik Deutschland",
      translated: "e Republikës Federale të Gjermanisë?",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:11|sr": [
    {
      german: "Wie wird",
      translated: "Kako se",
      tone: 'semantic',
    },
    {
      german: "die Verfassung",
      translated: "ustav",
      tone: 'semantic',
    },
    {
      german: "der Bundesrepublik Deutschland",
      translated: "Savezne Republike Nemačke",
      tone: 'semantic',
    },
    {
      german: "genannt",
      translated: "zove",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:11|tr": [
    {
      german: "Wie wird",
      translated: "ne",
      tone: 'semantic',
    },
    {
      german: "die Verfassung",
      translated: "anayasasına",
      tone: 'semantic',
    },
    {
      german: "der Bundesrepublik Deutschland",
      translated: "Almanya Federal Cumhuriyeti'nin",
      tone: 'semantic',
    },
    {
      german: "genannt",
      translated: "ad verilir?",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:11|uk": [
    {
      german: "Wie wird",
      translated: "Як",
      tone: 'semantic',
    },
    {
      german: "die Verfassung",
      translated: "Конституція",
      tone: 'semantic',
    },
    {
      german: "der Bundesrepublik Deutschland",
      translated: "Федеративної Республіки Німеччина",
      tone: 'semantic',
    },
    {
      german: "genannt",
      translated: "називається",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:11|vi": [
    {
      german: "Wie wird",
      translated: "được",
      tone: 'semantic',
    },
    {
      german: "die Verfassung",
      translated: "Hiến pháp",
      tone: 'semantic',
    },
    {
      german: "der Bundesrepublik Deutschland",
      translated: "Cộng hòa Liên bang Đức",
      tone: 'semantic',
    },
    {
      german: "genannt",
      translated: "gọi là",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:120|ar": [
    {
      german: "Das Wahlsystem",
      translated: "نظام الانتخابات",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "في ألمانيا",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "هو",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:120|bg": [
    {
      german: "Das Wahlsystem",
      translated: "избирателна система",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "Германската",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "е",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:120|bs": [
    {
      german: "Das Wahlsystem",
      translated: "izborni sustav",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "Njemački",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "je",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:120|el": [
    {
      german: "Das Wahlsystem",
      translated: "Το γερμανικό εκλογικό σύστημα",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "είναι",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:120|en": [
    {
      german: "Das Wahlsystem",
      translated: "The electoral system",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "in Germany",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "is",
      tone: 'semantic',
    },
    {
      german: "ein",
      translated: "a",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:120|es": [
    {
      german: "Das Wahlsystem",
      translated: "El sistema electoral",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "en Alemania",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "es",
      tone: 'semantic',
    },
    {
      german: "ein",
      translated: "un",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:120|fa": [
    {
      german: "Das Wahlsystem",
      translated: "نظام انتخاباتی",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "آلمان",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "است",
      tone: 'semantic',
    },
    {
      german: "ein",
      translated: "یک",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:120|fr": [
    {
      german: "Das Wahlsystem",
      translated: "Le système électoral",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "allemand",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "est",
      tone: 'semantic',
    },
    {
      german: "ein",
      translated: "un",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:120|hr": [
    {
      german: "Das Wahlsystem",
      translated: "izborni sustav",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "Njemački",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "je",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:120|it": [
    {
      german: "Das Wahlsystem",
      translated: "Il sistema elettorale",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "tedesco",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "è",
      tone: 'semantic',
    },
    {
      german: "ein",
      translated: "un",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:120|kmr": [
    {
      german: "Das Wahlsystem",
      translated: "Pergala hilbijartinê",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "ya Almanyayê",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "e",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:120|pl": [
    {
      german: "Das Wahlsystem",
      translated: "Niemiecki system wyborczy",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "jest",
      tone: 'semantic',
    },
    {
      german: "ein",
      translated: "systemem",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:120|prs": [
    {
      german: "Das Wahlsystem",
      translated: "نظام انتخاباتی",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "آلمان",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "است",
      tone: 'semantic',
    },
    {
      german: "ein",
      translated: "یک",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:120|ro": [
    {
      german: "Das Wahlsystem",
      translated: "Sistemul electoral",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "german",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "este",
      tone: 'semantic',
    },
    {
      german: "ein",
      translated: "un",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:120|ru": [
    {
      german: "Das Wahlsystem",
      translated: "Избирательная система",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "Германии",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "это",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:120|sq": [
    {
      german: "Das Wahlsystem",
      translated: "Sistemi zgjedhor",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "gjerman",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "është",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:120|sr": [
    {
      german: "Das Wahlsystem",
      translated: "izborni sistem",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "Nemački",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "je",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:120|tr": [
    {
      german: "Das Wahlsystem",
      translated: "Almanya'daki seçim sistemi",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:120|uk": [
    {
      german: "Das Wahlsystem",
      translated: "Виборча система",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "Німеччини",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "є",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:120|vi": [
    {
      german: "Das Wahlsystem",
      translated: "Hệ thống bầu cử",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "của Đức",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "là",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:121|ar": [
    {
      german: "Eine Partei",
      translated: "حزب",
      tone: 'semantic',
    },
    {
      german: "möchte in den Deutschen Bundestag",
      translated: "دخول البوندستاغ الألماني",
      tone: 'semantic',
    },
    {
      german: "Sie muss aber",
      translated: "لكنه",
      tone: 'semantic',
    },
    {
      german: "einen Mindestanteil an Wählerstimmen",
      translated: "حد أدنى من أصوات الناخبين",
      tone: 'semantic',
    },
    {
      german: "Das heißt",
      translated: "يسمى ذلك",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:121|bg": [
    {
      german: "Eine Partei",
      translated: "Партия",
      tone: 'semantic',
    },
    {
      german: "möchte in den Deutschen Bundestag",
      translated: "иска да влезе в Бундестага",
      tone: 'semantic',
    },
    {
      german: "Sie muss aber",
      translated: "но трябва",
      tone: 'semantic',
    },
    {
      german: "einen Mindestanteil an Wählerstimmen",
      translated: "минимален дял от гласовете",
      tone: 'semantic',
    },
    {
      german: "haben",
      translated: "да получи",
      tone: 'semantic',
    },
    {
      german: "Das heißt",
      translated: "Как се нарича",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:121|bs": [
    {
      german: "Eine Partei",
      translated: "Stranka",
      tone: 'semantic',
    },
    {
      german: "möchte in den Deutschen Bundestag",
      translated: "želi ući u Bundestag",
      tone: 'semantic',
    },
    {
      german: "Sie muss aber",
      translated: "ali mora",
      tone: 'semantic',
    },
    {
      german: "einen Mindestanteil an Wählerstimmen",
      translated: "minimalni udio glasova",
      tone: 'semantic',
    },
    {
      german: "haben",
      translated: "dobiti",
      tone: 'semantic',
    },
    {
      german: "Das heißt",
      translated: "Kako se zove",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:121|el": [
    {
      german: "Eine Partei",
      translated: "Ένα κόμμα",
      tone: 'semantic',
    },
    {
      german: "möchte in den Deutschen Bundestag",
      translated: "θέλει να μπει στο Bundestag",
      tone: 'semantic',
    },
    {
      german: "Sie muss aber",
      translated: "αλλά πρέπει",
      tone: 'semantic',
    },
    {
      german: "einen Mindestanteil an Wählerstimmen",
      translated: "ένα ελάχιστο ποσοστό ψήφων",
      tone: 'semantic',
    },
    {
      german: "haben",
      translated: "λάβει",
      tone: 'semantic',
    },
    {
      german: "Das heißt",
      translated: "Πώς ονομάζεται",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:121|en": [
    {
      german: "Eine Partei",
      translated: "A party",
      tone: 'semantic',
    },
    {
      german: "möchte in den Deutschen Bundestag",
      translated: "wants to enter the German Bundestag",
      tone: 'semantic',
    },
    {
      german: "Sie muss aber",
      translated: "But it must",
      tone: 'semantic',
    },
    {
      german: "einen Mindestanteil an Wählerstimmen",
      translated: "a minimum share of voter votes",
      tone: 'semantic',
    },
    {
      german: "haben",
      translated: "have",
      tone: 'semantic',
    },
    {
      german: "Das heißt",
      translated: "This is called",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:121|es": [
    {
      german: "Eine Partei",
      translated: "Un partido",
      tone: 'semantic',
    },
    {
      german: "möchte in den Deutschen Bundestag",
      translated: "quiere entrar en el Bundestag alemán",
      tone: 'semantic',
    },
    {
      german: "Sie muss aber",
      translated: "pero necesita",
      tone: 'semantic',
    },
    {
      german: "einen Mindestanteil an Wählerstimmen",
      translated: "una proporción mínima de votos",
      tone: 'semantic',
    },
    {
      german: "Das heißt",
      translated: "Esto se llama",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:121|fa": [
    {
      german: "Eine Partei",
      translated: "یک حزب",
      tone: 'semantic',
    },
    {
      german: "möchte in den Deutschen Bundestag",
      translated: "می‌خواهد وارد بوندستاگ آلمان شود",
      tone: 'semantic',
    },
    {
      german: "Sie muss aber",
      translated: "اما باید",
      tone: 'semantic',
    },
    {
      german: "einen Mindestanteil an Wählerstimmen",
      translated: "حداقل سهمی از آرا",
      tone: 'semantic',
    },
    {
      german: "haben",
      translated: "کسب کند",
      tone: 'semantic',
    },
    {
      german: "Das heißt",
      translated: "این شرط چه نام دارد؟",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:121|fr": [
    {
      german: "Eine Partei",
      translated: "Un parti",
      tone: 'semantic',
    },
    {
      german: "möchte in den Deutschen Bundestag",
      translated: "veut entrer au Bundestag allemand",
      tone: 'semantic',
    },
    {
      german: "Sie muss aber",
      translated: "Il doit toutefois",
      tone: 'semantic',
    },
    {
      german: "einen Mindestanteil an Wählerstimmen",
      translated: "une part minimale des voix",
      tone: 'semantic',
    },
    {
      german: "Das heißt",
      translated: "Cela s’appelle",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:121|hr": [
    {
      german: "Eine Partei",
      translated: "Stranka",
      tone: 'semantic',
    },
    {
      german: "möchte in den Deutschen Bundestag",
      translated: "želi ući u Bundestag",
      tone: 'semantic',
    },
    {
      german: "Sie muss aber",
      translated: "ali mora",
      tone: 'semantic',
    },
    {
      german: "einen Mindestanteil an Wählerstimmen",
      translated: "minimalni udio glasova",
      tone: 'semantic',
    },
    {
      german: "haben",
      translated: "dobiti",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:121|it": [
    {
      german: "Eine Partei",
      translated: "Un partito",
      tone: 'semantic',
    },
    {
      german: "möchte in den Deutschen Bundestag",
      translated: "vuole entrare nel Bundestag",
      tone: 'semantic',
    },
    {
      german: "Sie muss aber",
      translated: "ma deve",
      tone: 'semantic',
    },
    {
      german: "einen Mindestanteil an Wählerstimmen",
      translated: "una quota minima di voti",
      tone: 'semantic',
    },
    {
      german: "haben",
      translated: "ottenere",
      tone: 'semantic',
    },
    {
      german: "Das heißt",
      translated: "Come si chiama",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:121|kmr": [
    {
      german: "Eine Partei",
      translated: "Partiyek",
      tone: 'semantic',
    },
    {
      german: "möchte in den Deutschen Bundestag",
      translated: "dixwaze bikeve Bundestagê",
      tone: 'semantic',
    },
    {
      german: "Sie muss aber",
      translated: "Divê herî",
      tone: 'semantic',
    },
    {
      german: "einen Mindestanteil an Wählerstimmen",
      translated: "kêm rêjeyek deng",
      tone: 'semantic',
    },
    {
      german: "haben",
      translated: "bistîne",
      tone: 'semantic',
    },
    {
      german: "Das heißt",
      translated: "Ev tê gotin",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:121|pl": [
    {
      german: "Eine Partei",
      translated: "Partia",
      tone: 'semantic',
    },
    {
      german: "möchte in den Deutschen Bundestag",
      translated: "chce wejść do Bundestagu",
      tone: 'semantic',
    },
    {
      german: "Sie muss aber",
      translated: "ale musi",
      tone: 'semantic',
    },
    {
      german: "einen Mindestanteil an Wählerstimmen",
      translated: "minimalny udział głosów",
      tone: 'semantic',
    },
    {
      german: "Das heißt",
      translated: "Jak nazywa się",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:121|prs": [
    {
      german: "Eine Partei",
      translated: "یک حزب",
      tone: 'semantic',
    },
    {
      german: "möchte in den Deutschen Bundestag",
      translated: "می‌خواهد وارد بوندستاگ آلمان شود",
      tone: 'semantic',
    },
    {
      german: "Sie muss aber",
      translated: "اما باید",
      tone: 'semantic',
    },
    {
      german: "einen Mindestanteil an Wählerstimmen",
      translated: "حداقل سهمی از آرا",
      tone: 'semantic',
    },
    {
      german: "haben",
      translated: "کسب کند",
      tone: 'semantic',
    },
    {
      german: "Das heißt",
      translated: "این شرط چه نام دارد؟",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:121|ro": [
    {
      german: "Eine Partei",
      translated: "Un partid",
      tone: 'semantic',
    },
    {
      german: "möchte in den Deutschen Bundestag",
      translated: "vrea să intre în Bundestag",
      tone: 'semantic',
    },
    {
      german: "Sie muss aber",
      translated: "dar trebuie",
      tone: 'semantic',
    },
    {
      german: "einen Mindestanteil an Wählerstimmen",
      translated: "o cotă minimă de voturi",
      tone: 'semantic',
    },
    {
      german: "haben",
      translated: "obțină",
      tone: 'semantic',
    },
    {
      german: "Das heißt",
      translated: "Cum se numește",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:121|ru": [
    {
      german: "Eine Partei",
      translated: "Партия",
      tone: 'semantic',
    },
    {
      german: "möchte in den Deutschen Bundestag",
      translated: "хочет пройти в Бундестаг Германии",
      tone: 'semantic',
    },
    {
      german: "Sie muss aber",
      translated: "Но для этого она должна",
      tone: 'semantic',
    },
    {
      german: "einen Mindestanteil an Wählerstimmen",
      translated: "минимальную долю голосов избирателей",
      tone: 'semantic',
    },
    {
      german: "haben",
      translated: "получить",
      tone: 'semantic',
    },
    {
      german: "Das heißt",
      translated: "Это называется",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:121|sq": [
    {
      german: "Eine Partei",
      translated: "Një parti",
      tone: 'semantic',
    },
    {
      german: "möchte in den Deutschen Bundestag",
      translated: "dëshiron të hyjë në Bundestag",
      tone: 'semantic',
    },
    {
      german: "Sie muss aber",
      translated: "por duhet",
      tone: 'semantic',
    },
    {
      german: "einen Mindestanteil an Wählerstimmen",
      translated: "një përqindje minimale votash",
      tone: 'semantic',
    },
    {
      german: "haben",
      translated: "të marrë",
      tone: 'semantic',
    },
    {
      german: "Das heißt",
      translated: "Si quhet",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:121|sr": [
    {
      german: "Eine Partei",
      translated: "Stranka",
      tone: 'semantic',
    },
    {
      german: "möchte in den Deutschen Bundestag",
      translated: "želi ući u Bundestag",
      tone: 'semantic',
    },
    {
      german: "Sie muss aber",
      translated: "ali mora",
      tone: 'semantic',
    },
    {
      german: "einen Mindestanteil an Wählerstimmen",
      translated: "minimalni udio glasova",
      tone: 'semantic',
    },
    {
      german: "haben",
      translated: "dobiti",
      tone: 'semantic',
    },
    {
      german: "Das heißt",
      translated: "Kako se zove to pravilo",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:121|tr": [
    {
      german: "Eine Partei",
      translated: "Bir parti",
      tone: 'semantic',
    },
    {
      german: "möchte in den Deutschen Bundestag",
      translated: "Alman Federal Meclisine girmek istiyor",
      tone: 'semantic',
    },
    {
      german: "Sie muss aber",
      translated: "ancak",
      tone: 'semantic',
    },
    {
      german: "einen Mindestanteil an Wählerstimmen",
      translated: "asgari bir oy oranına",
      tone: 'semantic',
    },
    {
      german: "haben",
      translated: "gerekiyor",
      tone: 'semantic',
    },
    {
      german: "Das heißt",
      translated: "Buna … denir.",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:121|uk": [
    {
      german: "Eine Partei",
      translated: "Партія",
      tone: 'semantic',
    },
    {
      german: "möchte in den Deutschen Bundestag",
      translated: "хоче потрапити до німецького Бундестагу",
      tone: 'semantic',
    },
    {
      german: "Sie muss aber",
      translated: "але для цього повинна",
      tone: 'semantic',
    },
    {
      german: "einen Mindestanteil an Wählerstimmen",
      translated: "мінімальну частку голосів виборців",
      tone: 'semantic',
    },
    {
      german: "haben",
      translated: "отримати",
      tone: 'semantic',
    },
    {
      german: "Das heißt",
      translated: "Це називається",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:121|vi": [
    {
      german: "Eine Partei",
      translated: "Một đảng",
      tone: 'semantic',
    },
    {
      german: "möchte in den Deutschen Bundestag",
      translated: "muốn vào Bundestag",
      tone: 'semantic',
    },
    {
      german: "Sie muss aber",
      translated: "nhưng phải",
      tone: 'semantic',
    },
    {
      german: "einen Mindestanteil an Wählerstimmen",
      translated: "một tỷ lệ phiếu tối thiểu",
      tone: 'semantic',
    },
    {
      german: "haben",
      translated: "đạt",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:122|ar": [
    {
      german: "Welchem Grundsatz",
      translated: "لأي مبدأ",
      tone: 'semantic',
    },
    {
      german: "unterliegen",
      translated: "تخضع",
      tone: 'semantic',
    },
    {
      german: "Wahlen in Deutschland",
      translated: "الانتخابات في ألمانيا",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:122|bg": [
    {
      german: "Welchem Grundsatz",
      translated: "Кой принцип",
      tone: 'semantic',
    },
    {
      german: "unterliegen",
      translated: "важи",
      tone: 'semantic',
    },
    {
      german: "Wahlen in Deutschland",
      translated: "изборите в Германия",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:122|bs": [
    {
      german: "Welchem Grundsatz",
      translated: "Koje načelo",
      tone: 'semantic',
    },
    {
      german: "unterliegen",
      translated: "vrijedi za",
      tone: 'semantic',
    },
    {
      german: "Wahlen in Deutschland",
      translated: "izbore u Njemačkoj",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:122|el": [
    {
      german: "Welchem Grundsatz",
      translated: "Σε ποια αρχή",
      tone: 'semantic',
    },
    {
      german: "unterliegen",
      translated: "υπόκεινται",
      tone: 'semantic',
    },
    {
      german: "Wahlen in Deutschland",
      translated: "οι εκλογές στη Γερμανία",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:122|en": [
    {
      german: "Welchem Grundsatz",
      translated: "What principle",
      tone: 'semantic',
    },
    {
      german: "unterliegen",
      translated: "follow",
      tone: 'semantic',
    },
    {
      german: "Wahlen in Deutschland",
      translated: "elections in Germany",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:122|es": [
    {
      german: "Welchem Grundsatz",
      translated: "¿Qué principio",
      tone: 'semantic',
    },
    {
      german: "unterliegen",
      translated: "siguen",
      tone: 'semantic',
    },
    {
      german: "Wahlen in Deutschland",
      translated: "las elecciones en Alemania",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:122|fa": [
    {
      german: "Welchem Grundsatz",
      translated: "کدام اصل",
      tone: 'semantic',
    },
    {
      german: "unterliegen",
      translated: "تابع",
      tone: 'semantic',
    },
    {
      german: "Wahlen in Deutschland",
      translated: "انتخابات در آلمان",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:122|fr": [
    {
      german: "Welchem Grundsatz",
      translated: "À quel principe",
      tone: 'semantic',
    },
    {
      german: "unterliegen",
      translated: "sont soumises",
      tone: 'semantic',
    },
    {
      german: "Wahlen in Deutschland",
      translated: "les élections en Allemagne",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:122|hr": [
    {
      german: "Welchem Grundsatz",
      translated: "Koje načelo",
      tone: 'semantic',
    },
    {
      german: "unterliegen",
      translated: "vrijedi za",
      tone: 'semantic',
    },
    {
      german: "Wahlen in Deutschland",
      translated: "izbore u Njemačkoj",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:122|it": [
    {
      german: "Welchem Grundsatz",
      translated: "A quale principio",
      tone: 'semantic',
    },
    {
      german: "unterliegen",
      translated: "sono soggette",
      tone: 'semantic',
    },
    {
      german: "Wahlen in Deutschland",
      translated: "elezioni in Germania",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:122|kmr": [
    {
      german: "Welchem Grundsatz",
      translated: "kîjan prensîbê",
      tone: 'semantic',
    },
    {
      german: "unterliegen",
      translated: "li gor",
      tone: 'semantic',
    },
    {
      german: "Wahlen in Deutschland",
      translated: "Hilbijartinên Almanyayê",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:122|pl": [
    {
      german: "Welchem Grundsatz",
      translated: "Jaka zasada",
      tone: 'semantic',
    },
    {
      german: "unterliegen",
      translated: "obowiązuje",
      tone: 'semantic',
    },
    {
      german: "Wahlen in Deutschland",
      translated: "wyborach w Niemczech",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:122|prs": [
    {
      german: "Welchem Grundsatz",
      translated: "کدام اصل",
      tone: 'semantic',
    },
    {
      german: "unterliegen",
      translated: "تابع",
      tone: 'semantic',
    },
    {
      german: "Wahlen in Deutschland",
      translated: "انتخابات در آلمان",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:122|ro": [
    {
      german: "Welchem Grundsatz",
      translated: "Ce principiu",
      tone: 'semantic',
    },
    {
      german: "unterliegen",
      translated: "se aplică",
      tone: 'semantic',
    },
    {
      german: "Wahlen in Deutschland",
      translated: "alegerilor din Germania",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:122|ru": [
    {
      german: "Welchem Grundsatz",
      translated: "Какому принципу",
      tone: 'semantic',
    },
    {
      german: "unterliegen",
      translated: "подчиняются",
      tone: 'semantic',
    },
    {
      german: "Wahlen in Deutschland",
      translated: "выборы в Германии",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:122|sq": [
    {
      german: "Welchem Grundsatz",
      translated: "Cili parim",
      tone: 'semantic',
    },
    {
      german: "unterliegen",
      translated: "vlen",
      tone: 'semantic',
    },
    {
      german: "Wahlen in Deutschland",
      translated: "zgjedhjet në Gjermani",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:122|sr": [
    {
      german: "Welchem Grundsatz",
      translated: "Koje načelo",
      tone: 'semantic',
    },
    {
      german: "unterliegen",
      translated: "vrijedi",
      tone: 'semantic',
    },
    {
      german: "Wahlen in Deutschland",
      translated: "izbore u Nemačkoj",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:122|tr": [
    {
      german: "Welchem Grundsatz",
      translated: "hangi ilkelere",
      tone: 'semantic',
    },
    {
      german: "unterliegen",
      translated: "tabidir",
      tone: 'semantic',
    },
    {
      german: "Wahlen in Deutschland",
      translated: "Almanya'daki seçimler",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:122|uk": [
    {
      german: "Welchem Grundsatz",
      translated: "Якому принципу",
      tone: 'semantic',
    },
    {
      german: "unterliegen",
      translated: "підпорядковуються",
      tone: 'semantic',
    },
    {
      german: "Wahlen in Deutschland",
      translated: "вибори в Німеччині",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:122|vi": [
    {
      german: "Welchem Grundsatz",
      translated: "Nguyên tắc nào",
      tone: 'semantic',
    },
    {
      german: "unterliegen",
      translated: "áp dụng cho",
      tone: 'semantic',
    },
    {
      german: "Wahlen in Deutschland",
      translated: "bầu cử ở Đức",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:123|ar": [
    {
      german: "Was",
      translated: "ما",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "هي",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "في ألمانيا",
      tone: 'semantic',
    },
    {
      german: "5%-Hürde",
      translated: "«عتبة 5٪»",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:123|bg": [
    {
      german: "Was",
      translated: "Какво",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "представлява",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "в Германия",
      tone: 'semantic',
    },
    {
      german: "5%-Hürde",
      translated: "„5-процентната бариера“",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:123|bs": [
    {
      german: "Was",
      translated: "Što",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "je",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "u Njemačkoj",
      tone: 'semantic',
    },
    {
      german: "5%-Hürde",
      translated: "prag od 5 %",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:123|el": [
    {
      german: "Was",
      translated: "Τι",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "είναι",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "στη Γερμανία",
      tone: 'semantic',
    },
    {
      german: "5%-Hürde",
      translated: "«όριο του 5%»",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:123|en": [
    {
      german: "Was",
      translated: "What",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "is",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "in Germany",
      tone: 'semantic',
    },
    {
      german: "5%-Hürde",
      translated: "'5% threshold'",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:123|es": [
    {
      german: "Was",
      translated: "Qué",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "es",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "en Alemania",
      tone: 'semantic',
    },
    {
      german: "5%-Hürde",
      translated: "barrera del 5 %",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:123|fa": [
    {
      german: "Was",
      translated: "چیست",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "در آلمان",
      tone: 'semantic',
    },
    {
      german: "5%-Hürde",
      translated: "حد نصاب پنج‌درصدی",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:123|fr": [
    {
      german: "Was",
      translated: "Qu’est-ce",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "en Allemagne",
      tone: 'semantic',
    },
    {
      german: "5%-Hürde",
      translated: "« seuil des 5 % »",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:123|hr": [
    {
      german: "Was",
      translated: "Što",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "je",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "u Njemačkoj",
      tone: 'semantic',
    },
    {
      german: "5%-Hürde",
      translated: "„prag od 5 %“",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:123|it": [
    {
      german: "Was",
      translated: "Che",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "è",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "in Germania",
      tone: 'semantic',
    },
    {
      german: "5%-Hürde",
      translated: "5%",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:123|kmr": [
    {
      german: "Was",
      translated: "çi",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "ye",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "li Almanyayê",
      tone: 'semantic',
    },
    {
      german: "5%-Hürde",
      translated: "Astengiya 5%",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:123|pl": [
    {
      german: "Was",
      translated: "Czym",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "jest",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "w Niemczech",
      tone: 'semantic',
    },
    {
      german: "5%-Hürde",
      translated: "próg 5%",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:123|prs": [
    {
      german: "in Deutschland",
      translated: "در آلمان",
      tone: 'semantic',
    },
    {
      german: "5%-Hürde",
      translated: "«حد نصاب پنج‌درصدی»",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:123|ro": [
    {
      german: "Was",
      translated: "Ce",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "este",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "în Germania",
      tone: 'semantic',
    },
    {
      german: "5%-Hürde",
      translated: "pragul de 5%",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:123|ru": [
    {
      german: "Was",
      translated: "Что",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "в Германии",
      tone: 'semantic',
    },
    {
      german: "5%-Hürde",
      translated: "«5-процентный барьер»",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:123|sq": [
    {
      german: "Was",
      translated: "Çfarë",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "është",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "në Gjermani",
      tone: 'semantic',
    },
    {
      german: "5%-Hürde",
      translated: "«pragu 5%»",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:123|sr": [
    {
      german: "Was",
      translated: "Šta",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "je",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "u Nemačkoj",
      tone: 'semantic',
    },
    {
      german: "5%-Hürde",
      translated: "„prag od 5 %“",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:123|tr": [
    {
      german: "Was",
      translated: "nedir",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "Almanya'da",
      tone: 'semantic',
    },
    {
      german: "5%-Hürde",
      translated: "%5 barajı",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:123|uk": [
    {
      german: "Was",
      translated: "Що",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "таке",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "у Німеччині",
      tone: 'semantic',
    },
    {
      german: "5%-Hürde",
      translated: "«5-відсотковий бар’єр»",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:123|vi": [
    {
      german: "Was",
      translated: "gì",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "là",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "ở Đức",
      tone: 'semantic',
    },
    {
      german: "5%-Hürde",
      translated: "“Ngưỡng 5%”",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:124|ar": [
    {
      german: "Die Bundestagswahl",
      translated: "انتخابات",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "في ألمانيا",
      tone: 'semantic',
    },
    {
      german: "die Wahl",
      translated: "انتخابات",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:124|bg": [
    {
      german: "Die Bundestagswahl",
      translated: "Изборите за Бундестаг",
      tone: 'semantic',
    },
    {
      german: "die Wahl",
      translated: "избори",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:124|bs": [
    {
      german: "Die Bundestagswahl",
      translated: "Izbori za Bundestag",
      tone: 'semantic',
    },
    {
      german: "die Wahl",
      translated: "izbori",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:124|el": [
    {
      german: "Die Bundestagswahl",
      translated: "Οι εκλογές του Bundestag",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "στη Γερμανία",
      tone: 'semantic',
    },
    {
      german: "die Wahl",
      translated: "οι εκλογές",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:124|en": [
    {
      german: "Die Bundestagswahl",
      translated: "The federal election",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "in Germany",
      tone: 'semantic',
    },
    {
      german: "die Wahl",
      translated: "the election",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:124|es": [
    {
      german: "Die Bundestagswahl",
      translated: "Las elecciones federales",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "en Alemania",
      tone: 'semantic',
    },
    {
      german: "die Wahl",
      translated: "las elecciones",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:124|fa": [
    {
      german: "Die Bundestagswahl",
      translated: "انتخابات بوندستاگ",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "در آلمان",
      tone: 'semantic',
    },
    {
      german: "die Wahl",
      translated: "انتخاباتِ",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:124|fr": [
    {
      german: "Die Bundestagswahl",
      translated: "Les élections",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "en Allemagne",
      tone: 'semantic',
    },
    {
      german: "die Wahl",
      translated: "l’élection",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:124|hr": [
    {
      german: "Die Bundestagswahl",
      translated: "Izbori za Bundestag",
      tone: 'semantic',
    },
    {
      german: "die Wahl",
      translated: "izbori",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:124|it": [
    {
      german: "Die Bundestagswahl",
      translated: "Le elezioni del Bundestag",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "in Germania",
      tone: 'semantic',
    },
    {
      german: "die Wahl",
      translated: "le elezioni",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:124|kmr": [
    {
      german: "Die Bundestagswahl",
      translated: "Hilbijartina Bundestagê",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "li Almanyayê",
      tone: 'semantic',
    },
    {
      german: "die Wahl",
      translated: "hilbijartina",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:124|pl": [
    {
      german: "Die Bundestagswahl",
      translated: "Wybory do Bundestagu",
      tone: 'semantic',
    },
    {
      german: "die Wahl",
      translated: "wyborami",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:124|prs": [
    {
      german: "Die Bundestagswahl",
      translated: "انتخابات بوندستاگ",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "در آلمان",
      tone: 'semantic',
    },
    {
      german: "die Wahl",
      translated: "انتخاباتِ …",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:124|ro": [
    {
      german: "Die Bundestagswahl",
      translated: "Alegerile pentru Bundestag",
      tone: 'semantic',
    },
    {
      german: "die Wahl",
      translated: "alegeri",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:124|ru": [
    {
      german: "Die Bundestagswahl",
      translated: "Выборы в Бундестаг Германии",
      tone: 'semantic',
    },
    {
      german: "die Wahl",
      translated: "выборы",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:124|sq": [
    {
      german: "Die Bundestagswahl",
      translated: "Zgjedhjet për Bundestagun",
      tone: 'semantic',
    },
    {
      german: "die Wahl",
      translated: "zgjedhje",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:124|sr": [
    {
      german: "Die Bundestagswahl",
      translated: "Izbori za Bundestag",
      tone: 'semantic',
    },
    {
      german: "die Wahl",
      translated: "izbori",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:124|tr": [
    {
      german: "Die Bundestagswahl",
      translated: "Federal Meclis seçimi",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "Almanya'daki",
      tone: 'semantic',
    },
    {
      german: "die Wahl",
      translated: "seçimidir",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:124|uk": [
    {
      german: "Die Bundestagswahl",
      translated: "Вибори до Бундестагу",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "в Німеччині",
      tone: 'semantic',
    },
    {
      german: "die Wahl",
      translated: "вибори",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:124|vi": [
    {
      german: "Die Bundestagswahl",
      translated: "Bầu cử Bundestag",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "ở Đức",
      tone: 'semantic',
    },
    {
      german: "die Wahl",
      translated: "bầu cử",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:125|ar": [
    {
      german: "In einer Demokratie",
      translated: "في الديمقراطية",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "هي",
      tone: 'semantic',
    },
    {
      german: "eine Funktion von regelmäßigen Wahlen",
      translated: "إحدى وظائف الانتخابات المنتظمة",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:125|bg": [
    {
      german: "In einer Demokratie",
      translated: "в демокрацията",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "е",
      tone: 'semantic',
    },
    {
      german: "eine Funktion von regelmäßigen Wahlen",
      translated: "една от функциите на редовните избори",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:125|bs": [
    {
      german: "In einer Demokratie",
      translated: "u demokraciji",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "imaju",
      tone: 'semantic',
    },
    {
      german: "eine Funktion von regelmäßigen Wahlen",
      translated: "Koju funkciju",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:125|el": [
    {
      german: "In einer Demokratie",
      translated: "σε μια δημοκρατία",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "είναι",
      tone: 'semantic',
    },
    {
      german: "eine Funktion von regelmäßigen Wahlen",
      translated: "τις λειτουργίες των τακτικών εκλογών",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:125|en": [
    {
      german: "In einer Demokratie",
      translated: "In a democracy",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "is",
      tone: 'semantic',
    },
    {
      german: "eine Funktion von regelmäßigen Wahlen",
      translated: "one function of regular elections",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:125|es": [
    {
      german: "In einer Demokratie",
      translated: "En una democracia",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "es",
      tone: 'semantic',
    },
    {
      german: "eine Funktion von regelmäßigen Wahlen",
      translated: "una función de las elecciones periódicas",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:125|fa": [
    {
      german: "In einer Demokratie",
      translated: "در یک دموکراسی",
      tone: 'semantic',
    },
    {
      german: "eine Funktion von regelmäßigen Wahlen",
      translated: "یکی از کارکردهای انتخابات منظم",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:125|fr": [
    {
      german: "In einer Demokratie",
      translated: "Dans une démocratie",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "est",
      tone: 'semantic',
    },
    {
      german: "eine Funktion von regelmäßigen Wahlen",
      translated: "l’une des fonctions d’élections régulières",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:125|hr": [
    {
      german: "In einer Demokratie",
      translated: "u demokraciji",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "imaju",
      tone: 'semantic',
    },
    {
      german: "eine Funktion von regelmäßigen Wahlen",
      translated: "Koju funkciju",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:125|it": [
    {
      german: "In einer Demokratie",
      translated: "in una democrazia",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "è",
      tone: 'semantic',
    },
    {
      german: "eine Funktion von regelmäßigen Wahlen",
      translated: "una funzione delle elezioni regolari",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:125|kmr": [
    {
      german: "In einer Demokratie",
      translated: "Di demokrasiyê de",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "e",
      tone: 'semantic',
    },
    {
      german: "eine Funktion von regelmäßigen Wahlen",
      translated: "yek ji erkên hilbijartinên rêkûpêk",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:125|pl": [
    {
      german: "In einer Demokratie",
      translated: "w demokracji",
      tone: 'semantic',
    },
    {
      german: "eine Funktion von regelmäßigen Wahlen",
      translated: "Jaką funkcję pełnią regularne wybory",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:125|prs": [
    {
      german: "In einer Demokratie",
      translated: "در یک دموکراسی",
      tone: 'semantic',
    },
    {
      german: "eine Funktion von regelmäßigen Wahlen",
      translated: "یکی از کارکردهای انتخابات منظم",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:125|ro": [
    {
      german: "In einer Demokratie",
      translated: "într-o democrație",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "este",
      tone: 'semantic',
    },
    {
      german: "eine Funktion von regelmäßigen Wahlen",
      translated: "una dintre funcțiile alegerilor regulate",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:125|ru": [
    {
      german: "In einer Demokratie",
      translated: "В демократии",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "заключается",
      tone: 'semantic',
    },
    {
      german: "eine Funktion von regelmäßigen Wahlen",
      translated: "одна из функций регулярных выборов",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:125|sq": [
    {
      german: "In einer Demokratie",
      translated: "në demokraci",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "është",
      tone: 'semantic',
    },
    {
      german: "eine Funktion von regelmäßigen Wahlen",
      translated: "një nga funksionet e zgjedhjeve të rregullta",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:125|sr": [
    {
      german: "In einer Demokratie",
      translated: "u demokraciji",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "imaju",
      tone: 'semantic',
    },
    {
      german: "eine Funktion von regelmäßigen Wahlen",
      translated: "Koju funkciju",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:125|tr": [
    {
      german: "In einer Demokratie",
      translated: "Demokraside",
      tone: 'semantic',
    },
    {
      german: "eine Funktion von regelmäßigen Wahlen",
      translated: "düzenli seçimlerin işlevlerinden biri",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:125|uk": [
    {
      german: "In einer Demokratie",
      translated: "У демократії",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "є",
      tone: 'semantic',
    },
    {
      german: "eine Funktion von regelmäßigen Wahlen",
      translated: "однією з функцій регулярних виборів",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:125|vi": [
    {
      german: "In einer Demokratie",
      translated: "trong nền dân chủ",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "là",
      tone: 'semantic',
    },
    {
      german: "eine Funktion von regelmäßigen Wahlen",
      translated: "Một chức năng của các cuộc bầu cử định kỳ",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:126|ar": [
    {
      german: "Was",
      translated: "ماذا",
      tone: 'semantic',
    },
    {
      german: "bekommen",
      translated: "يتلقى",
      tone: 'semantic',
    },
    {
      german: "wahlberechtigte",
      translated: "الذين يحق لهم التصويت",
      tone: 'semantic',
    },
    {
      german: "Bürgerinnen und Bürger",
      translated: "المواطنون",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "في ألمانيا",
      tone: 'semantic',
    },
    {
      german: "vor einer Wahl",
      translated: "قبل الانتخابات",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:126|bg": [
    {
      german: "Was",
      translated: "Какво",
      tone: 'semantic',
    },
    {
      german: "bekommen",
      translated: "получават",
      tone: 'semantic',
    },
    {
      german: "wahlberechtigte",
      translated: "с право на глас",
      tone: 'semantic',
    },
    {
      german: "Bürgerinnen und Bürger",
      translated: "гражданите",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "в Германия",
      tone: 'semantic',
    },
    {
      german: "vor einer Wahl",
      translated: "преди избори",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:126|bs": [
    {
      german: "Was",
      translated: "Što",
      tone: 'semantic',
    },
    {
      german: "bekommen",
      translated: "dobivaju",
      tone: 'semantic',
    },
    {
      german: "wahlberechtigte",
      translated: "s pravom glasa",
      tone: 'semantic',
    },
    {
      german: "Bürgerinnen und Bürger",
      translated: "građani",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "u Njemačkoj",
      tone: 'semantic',
    },
    {
      german: "vor einer Wahl",
      translated: "prije izbora",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:126|el": [
    {
      german: "Was",
      translated: "Τι",
      tone: 'semantic',
    },
    {
      german: "bekommen",
      translated: "λαμβάνουν",
      tone: 'semantic',
    },
    {
      german: "wahlberechtigte",
      translated: "με δικαίωμα ψήφου",
      tone: 'semantic',
    },
    {
      german: "Bürgerinnen und Bürger",
      translated: "οι πολίτες",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "στη Γερμανία",
      tone: 'semantic',
    },
    {
      german: "vor einer Wahl",
      translated: "πριν από τις εκλογές",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:126|en": [
    {
      german: "Was",
      translated: "What",
      tone: 'semantic',
    },
    {
      german: "bekommen",
      translated: "receive",
      tone: 'semantic',
    },
    {
      german: "wahlberechtigte",
      translated: "eligible",
      tone: 'semantic',
    },
    {
      german: "Bürgerinnen und Bürger",
      translated: "voters",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "in Germany",
      tone: 'semantic',
    },
    {
      german: "vor einer Wahl",
      translated: "before an election",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:126|es": [
    {
      german: "Was",
      translated: "¿Qué",
      tone: 'semantic',
    },
    {
      german: "bekommen",
      translated: "reciben",
      tone: 'semantic',
    },
    {
      german: "wahlberechtigte",
      translated: "con derecho a voto",
      tone: 'semantic',
    },
    {
      german: "Bürgerinnen und Bürger",
      translated: "los ciudadanos",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "en Alemania",
      tone: 'semantic',
    },
    {
      german: "vor einer Wahl",
      translated: "antes de unas elecciones?",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:126|fa": [
    {
      german: "Was",
      translated: "چه چیزی",
      tone: 'semantic',
    },
    {
      german: "bekommen",
      translated: "دریافت",
      tone: 'semantic',
    },
    {
      german: "wahlberechtigte",
      translated: "دارای حق رأی",
      tone: 'semantic',
    },
    {
      german: "Bürgerinnen und Bürger",
      translated: "شهروندان",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "در آلمان",
      tone: 'semantic',
    },
    {
      german: "vor einer Wahl",
      translated: "پیش از انتخابات",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:126|fr": [
    {
      german: "Was",
      translated: "Que",
      tone: 'semantic',
    },
    {
      german: "bekommen",
      translated: "reçoivent",
      tone: 'semantic',
    },
    {
      german: "wahlberechtigte",
      translated: "ayant le droit de vote",
      tone: 'semantic',
    },
    {
      german: "Bürgerinnen und Bürger",
      translated: "citoyens",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "en Allemagne",
      tone: 'semantic',
    },
    {
      german: "vor einer Wahl",
      translated: "avant une élection",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:126|hr": [
    {
      german: "Was",
      translated: "Što",
      tone: 'semantic',
    },
    {
      german: "bekommen",
      translated: "dobivaju",
      tone: 'semantic',
    },
    {
      german: "wahlberechtigte",
      translated: "s pravom glasa",
      tone: 'semantic',
    },
    {
      german: "Bürgerinnen und Bürger",
      translated: "građani",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "u Njemačkoj",
      tone: 'semantic',
    },
    {
      german: "vor einer Wahl",
      translated: "prije izbora?",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:126|it": [
    {
      german: "Was",
      translated: "Che cosa",
      tone: 'semantic',
    },
    {
      german: "bekommen",
      translated: "ricevono",
      tone: 'semantic',
    },
    {
      german: "wahlberechtigte",
      translated: "con diritto di voto",
      tone: 'semantic',
    },
    {
      german: "Bürgerinnen und Bürger",
      translated: "i cittadini",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "in Germania",
      tone: 'semantic',
    },
    {
      german: "vor einer Wahl",
      translated: "prima delle elezioni",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:126|kmr": [
    {
      german: "Was",
      translated: "çi",
      tone: 'semantic',
    },
    {
      german: "bekommen",
      translated: "distînin",
      tone: 'semantic',
    },
    {
      german: "wahlberechtigte",
      translated: "mafê dengdanê hene",
      tone: 'semantic',
    },
    {
      german: "Bürgerinnen und Bürger",
      translated: "Welatiyên",
      tone: 'semantic',
    },
    {
      german: "vor einer Wahl",
      translated: "berî hilbijartinê",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:126|pl": [
    {
      german: "Was",
      translated: "Co",
      tone: 'semantic',
    },
    {
      german: "bekommen",
      translated: "otrzymują",
      tone: 'semantic',
    },
    {
      german: "wahlberechtigte",
      translated: "uprawnieni do głosowania",
      tone: 'semantic',
    },
    {
      german: "Bürgerinnen und Bürger",
      translated: "obywatele",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "w Niemczech",
      tone: 'semantic',
    },
    {
      german: "vor einer Wahl",
      translated: "przed wyborami",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:126|prs": [
    {
      german: "Was",
      translated: "چه چیزی",
      tone: 'semantic',
    },
    {
      german: "bekommen",
      translated: "دریافت می‌کنند",
      tone: 'semantic',
    },
    {
      german: "wahlberechtigte",
      translated: "دارای حق رأی",
      tone: 'semantic',
    },
    {
      german: "Bürgerinnen und Bürger",
      translated: "شهروندان",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "در آلمان",
      tone: 'semantic',
    },
    {
      german: "vor einer Wahl",
      translated: "پیش از انتخابات",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:126|ro": [
    {
      german: "Was",
      translated: "Ce",
      tone: 'semantic',
    },
    {
      german: "bekommen",
      translated: "primesc",
      tone: 'semantic',
    },
    {
      german: "wahlberechtigte",
      translated: "cu drept de vot",
      tone: 'semantic',
    },
    {
      german: "Bürgerinnen und Bürger",
      translated: "cetățenii",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "în Germania",
      tone: 'semantic',
    },
    {
      german: "vor einer Wahl",
      translated: "înainte de alegeri",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:126|ru": [
    {
      german: "Was",
      translated: "Что",
      tone: 'semantic',
    },
    {
      german: "bekommen",
      translated: "получают",
      tone: 'semantic',
    },
    {
      german: "wahlberechtigte",
      translated: "имеющие право голоса",
      tone: 'semantic',
    },
    {
      german: "Bürgerinnen und Bürger",
      translated: "граждане",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "Германии",
      tone: 'semantic',
    },
    {
      german: "vor einer Wahl",
      translated: "перед выборами",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:126|sq": [
    {
      german: "Was",
      translated: "Çfarë",
      tone: 'semantic',
    },
    {
      german: "bekommen",
      translated: "marrin",
      tone: 'semantic',
    },
    {
      german: "wahlberechtigte",
      translated: "me të drejtë vote",
      tone: 'semantic',
    },
    {
      german: "Bürgerinnen und Bürger",
      translated: "qytetarët",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "në Gjermani",
      tone: 'semantic',
    },
    {
      german: "vor einer Wahl",
      translated: "para zgjedhjeve",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:126|sr": [
    {
      german: "Was",
      translated: "Šta",
      tone: 'semantic',
    },
    {
      german: "bekommen",
      translated: "dobivaju",
      tone: 'semantic',
    },
    {
      german: "wahlberechtigte",
      translated: "s pravom glasa",
      tone: 'semantic',
    },
    {
      german: "Bürgerinnen und Bürger",
      translated: "građani",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "u Nemačkoj",
      tone: 'semantic',
    },
    {
      german: "vor einer Wahl",
      translated: "pre izbora",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:126|tr": [
    {
      german: "Was",
      translated: "ne",
      tone: 'semantic',
    },
    {
      german: "bekommen",
      translated: "alır",
      tone: 'semantic',
    },
    {
      german: "wahlberechtigte",
      translated: "oy kullanma hakkı olan",
      tone: 'semantic',
    },
    {
      german: "Bürgerinnen und Bürger",
      translated: "vatandaşlar",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "Almanya'da",
      tone: 'semantic',
    },
    {
      german: "vor einer Wahl",
      translated: "seçimden önce",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:126|uk": [
    {
      german: "Was",
      translated: "Що",
      tone: 'semantic',
    },
    {
      german: "bekommen",
      translated: "отримують",
      tone: 'semantic',
    },
    {
      german: "wahlberechtigte",
      translated: "які мають право голосу",
      tone: 'semantic',
    },
    {
      german: "Bürgerinnen und Bürger",
      translated: "громадяни",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "Німеччини",
      tone: 'semantic',
    },
    {
      german: "vor einer Wahl",
      translated: "перед виборами",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:126|vi": [
    {
      german: "Was",
      translated: "gì",
      tone: 'semantic',
    },
    {
      german: "bekommen",
      translated: "nhận được",
      tone: 'semantic',
    },
    {
      german: "wahlberechtigte",
      translated: "có quyền bầu cử",
      tone: 'semantic',
    },
    {
      german: "Bürgerinnen und Bürger",
      translated: "Công dân",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "ở Đức",
      tone: 'semantic',
    },
    {
      german: "vor einer Wahl",
      translated: "trước cuộc bầu cử",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:127|ar": [
    {
      german: "Warum",
      translated: "لماذا",
      tone: 'semantic',
    },
    {
      german: "gibt es",
      translated: "توجد",
      tone: 'semantic',
    },
    {
      german: "die 5%-Hürde",
      translated: "عتبة 5٪",
      tone: 'semantic',
    },
    {
      german: "im Wahlgesetz",
      translated: "في قانون الانتخابات",
      tone: 'semantic',
    },
    {
      german: "der Bundesrepublik Deutschland",
      translated: "في جمهورية ألمانيا الاتحادية",
      tone: 'semantic',
    },
    {
      german: "weil",
      translated: "لأنها",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:127|bg": [
    {
      german: "Warum",
      translated: "Защо",
      tone: 'semantic',
    },
    {
      german: "gibt es",
      translated: "има",
      tone: 'semantic',
    },
    {
      german: "die 5%-Hürde",
      translated: "5-процентна бариера",
      tone: 'semantic',
    },
    {
      german: "im Wahlgesetz",
      translated: "избирателно право",
      tone: 'semantic',
    },
    {
      german: "der Bundesrepublik Deutschland",
      translated: "германското",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:127|bs": [
    {
      german: "Warum",
      translated: "zašto",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:127|el": [
    {
      german: "Warum",
      translated: "Γιατί",
      tone: 'semantic',
    },
    {
      german: "gibt es",
      translated: "υπάρχει",
      tone: 'semantic',
    },
    {
      german: "die 5%-Hürde",
      translated: "το όριο του 5%",
      tone: 'semantic',
    },
    {
      german: "im Wahlgesetz",
      translated: "στο",
      tone: 'semantic',
    },
    {
      german: "der Bundesrepublik Deutschland",
      translated: "γερμανικό εκλογικό δίκαιο",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:127|en": [
    {
      german: "Warum",
      translated: "Why",
      tone: 'semantic',
    },
    {
      german: "gibt es",
      translated: "is there",
      tone: 'semantic',
    },
    {
      german: "die 5%-Hürde",
      translated: "a 5% threshold",
      tone: 'semantic',
    },
    {
      german: "im Wahlgesetz",
      translated: "in the electoral law",
      tone: 'semantic',
    },
    {
      german: "der Bundesrepublik Deutschland",
      translated: "of the Federal Republic of Germany",
      tone: 'semantic',
    },
    {
      german: "Es gibt sie",
      translated: "It exists",
      tone: 'semantic',
    },
    {
      german: "weil",
      translated: "because",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:127|es": [
    {
      german: "Warum",
      translated: "¿Por qué",
      tone: 'semantic',
    },
    {
      german: "gibt es",
      translated: "existe",
      tone: 'semantic',
    },
    {
      german: "die 5%-Hürde",
      translated: "una barrera del 5 %",
      tone: 'semantic',
    },
    {
      german: "im Wahlgesetz",
      translated: "en la ley electoral",
      tone: 'semantic',
    },
    {
      german: "der Bundesrepublik Deutschland",
      translated: "de la República Federal de Alemania",
      tone: 'semantic',
    },
    {
      german: "weil",
      translated: "Porque",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:127|fa": [
    {
      german: "Warum",
      translated: "چرا",
      tone: 'semantic',
    },
    {
      german: "gibt es",
      translated: "وجود دارد",
      tone: 'semantic',
    },
    {
      german: "die 5%-Hürde",
      translated: "حد نصاب پنج‌درصدی",
      tone: 'semantic',
    },
    {
      german: "im Wahlgesetz",
      translated: "در قانون انتخابات",
      tone: 'semantic',
    },
    {
      german: "der Bundesrepublik Deutschland",
      translated: "جمهوری فدرال آلمان",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:127|fr": [
    {
      german: "Warum",
      translated: "Pourquoi",
      tone: 'semantic',
    },
    {
      german: "gibt es",
      translated: "existe-t-il",
      tone: 'semantic',
    },
    {
      german: "die 5%-Hürde",
      translated: "un seuil de 5 %",
      tone: 'semantic',
    },
    {
      german: "im Wahlgesetz",
      translated: "dans le droit électoral",
      tone: 'semantic',
    },
    {
      german: "der Bundesrepublik Deutschland",
      translated: "de la République fédérale d’Allemagne",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:127|hr": [
    {
      german: "Warum",
      translated: "Zašto",
      tone: 'semantic',
    },
    {
      german: "gibt es",
      translated: "postoji",
      tone: 'semantic',
    },
    {
      german: "die 5%-Hürde",
      translated: "prag od 5 %",
      tone: 'semantic',
    },
    {
      german: "im Wahlgesetz",
      translated: "izbornom pravu",
      tone: 'semantic',
    },
    {
      german: "der Bundesrepublik Deutschland",
      translated: "njemačkom",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:127|it": [
    {
      german: "Warum",
      translated: "Perché",
      tone: 'semantic',
    },
    {
      german: "gibt es",
      translated: "esiste",
      tone: 'semantic',
    },
    {
      german: "die 5%-Hürde",
      translated: "la soglia del 5%",
      tone: 'semantic',
    },
    {
      german: "im Wahlgesetz",
      translated: "nel diritto elettorale",
      tone: 'semantic',
    },
    {
      german: "der Bundesrepublik Deutschland",
      translated: "tedesco",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:127|kmr": [
    {
      german: "Warum",
      translated: "Çima",
      tone: 'semantic',
    },
    {
      german: "gibt es",
      translated: "heye?",
      tone: 'semantic',
    },
    {
      german: "die 5%-Hürde",
      translated: "astengiya 5%",
      tone: 'semantic',
    },
    {
      german: "im Wahlgesetz",
      translated: "di qanûna hilbijartinê",
      tone: 'semantic',
    },
    {
      german: "der Bundesrepublik Deutschland",
      translated: "ya Komara Federal a Almanyayê",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:127|pl": [
    {
      german: "Warum",
      translated: "dlaczego",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:127|prs": [
    {
      german: "Warum",
      translated: "چرا",
      tone: 'semantic',
    },
    {
      german: "gibt es",
      translated: "وجود دارد",
      tone: 'semantic',
    },
    {
      german: "die 5%-Hürde",
      translated: "حد نصاب پنج‌درصدی",
      tone: 'semantic',
    },
    {
      german: "im Wahlgesetz",
      translated: "در قانون انتخابات",
      tone: 'semantic',
    },
    {
      german: "der Bundesrepublik Deutschland",
      translated: "جمهوری فدرال آلمان",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:127|ro": [
    {
      german: "Warum",
      translated: "De ce",
      tone: 'semantic',
    },
    {
      german: "gibt es",
      translated: "există",
      tone: 'semantic',
    },
    {
      german: "die 5%-Hürde",
      translated: "pragul de 5%",
      tone: 'semantic',
    },
    {
      german: "im Wahlgesetz",
      translated: "în legea electorală",
      tone: 'semantic',
    },
    {
      german: "der Bundesrepublik Deutschland",
      translated: "germană",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:127|ru": [
    {
      german: "Warum",
      translated: "Почему",
      tone: 'semantic',
    },
    {
      german: "gibt es",
      translated: "существует",
      tone: 'semantic',
    },
    {
      german: "die 5%-Hürde",
      translated: "5-процентный барьер",
      tone: 'semantic',
    },
    {
      german: "im Wahlgesetz",
      translated: "в избирательном законодательстве",
      tone: 'semantic',
    },
    {
      german: "der Bundesrepublik Deutschland",
      translated: "Германии",
      tone: 'semantic',
    },
    {
      german: "Es gibt sie",
      translated: "Он существует",
      tone: 'semantic',
    },
    {
      german: "weil",
      translated: "потому что",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:127|sq": [
    {
      german: "Warum",
      translated: "Pse",
      tone: 'semantic',
    },
    {
      german: "gibt es",
      translated: "ekziston",
      tone: 'semantic',
    },
    {
      german: "die 5%-Hürde",
      translated: "pragu 5%",
      tone: 'semantic',
    },
    {
      german: "im Wahlgesetz",
      translated: "në të drejtën zgjedhore",
      tone: 'semantic',
    },
    {
      german: "der Bundesrepublik Deutschland",
      translated: "gjermane",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:127|sr": [
    {
      german: "Warum",
      translated: "Zašta",
      tone: 'semantic',
    },
    {
      german: "gibt es",
      translated: "postoji",
      tone: 'semantic',
    },
    {
      german: "die 5%-Hürde",
      translated: "prag od 5 %",
      tone: 'semantic',
    },
    {
      german: "im Wahlgesetz",
      translated: "izbornom pravu",
      tone: 'semantic',
    },
    {
      german: "der Bundesrepublik Deutschland",
      translated: "nemačkom",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:127|tr": [
    {
      german: "Warum",
      translated: "neden",
      tone: 'semantic',
    },
    {
      german: "gibt es",
      translated: "vardır",
      tone: 'semantic',
    },
    {
      german: "die 5%-Hürde",
      translated: "%5 barajı",
      tone: 'semantic',
    },
    {
      german: "im Wahlgesetz",
      translated: "seçim yasasında",
      tone: 'semantic',
    },
    {
      german: "der Bundesrepublik Deutschland",
      translated: "Almanya Federal Cumhuriyeti",
      tone: 'semantic',
    },
    {
      german: "weil",
      translated: "Çünkü",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:127|uk": [
    {
      german: "Warum",
      translated: "Чому",
      tone: 'semantic',
    },
    {
      german: "gibt es",
      translated: "існує",
      tone: 'semantic',
    },
    {
      german: "die 5%-Hürde",
      translated: "5-відсотковий бар’єр",
      tone: 'semantic',
    },
    {
      german: "im Wahlgesetz",
      translated: "у виборчому законодавстві",
      tone: 'semantic',
    },
    {
      german: "der Bundesrepublik Deutschland",
      translated: "Федеративної Республіки Німеччина",
      tone: 'semantic',
    },
    {
      german: "Es gibt sie",
      translated: "Він існує",
      tone: 'semantic',
    },
    {
      german: "weil",
      translated: "тому, що",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:127|vi": [
    {
      german: "Warum",
      translated: "Tại sao",
      tone: 'semantic',
    },
    {
      german: "gibt es",
      translated: "có",
      tone: 'semantic',
    },
    {
      german: "die 5%-Hürde",
      translated: "ngưỡng 5%",
      tone: 'semantic',
    },
    {
      german: "im Wahlgesetz",
      translated: "luật bầu cử",
      tone: 'semantic',
    },
    {
      german: "der Bundesrepublik Deutschland",
      translated: "Đức",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:128|ar": [
    {
      german: "Parlamentsmitglieder",
      translated: "أعضاء البرلمان",
      tone: 'semantic',
    },
    {
      german: "die von den Bürgerinnen und Bürgern gewählt werden",
      translated: "الذين ينتخبهم المواطنون",
      tone: 'semantic',
    },
    {
      german: "nennt man",
      translated: "يُسمى",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:128|bg": [
    {
      german: "Parlamentsmitglieder",
      translated: "членовете на парламента",
      tone: 'semantic',
    },
    {
      german: "die von den Bürgerinnen und Bürgern gewählt werden",
      translated: "избрани от гражданите",
      tone: 'semantic',
    },
    {
      german: "nennt man",
      translated: "Как се наричат",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:128|bs": [
    {
      german: "Parlamentsmitglieder",
      translated: "članovi parlamenta",
      tone: 'semantic',
    },
    {
      german: "die von den Bürgerinnen und Bürgern gewählt werden",
      translated: "koje su izabrali građani",
      tone: 'semantic',
    },
    {
      german: "nennt man",
      translated: "Kako se nazivaju",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:128|el": [
    {
      german: "Parlamentsmitglieder",
      translated: "τα μέλη του κοινοβουλίου",
      tone: 'semantic',
    },
    {
      german: "die von den Bürgerinnen und Bürgern gewählt werden",
      translated: "που εκλέγονται από τους πολίτες",
      tone: 'semantic',
    },
    {
      german: "nennt man",
      translated: "ονομάζονται",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:128|en": [
    {
      german: "Parlamentsmitglieder",
      translated: "Members of parliament",
      tone: 'semantic',
    },
    {
      german: "die von den Bürgerinnen und Bürgern gewählt werden",
      translated: "who are elected by citizens",
      tone: 'semantic',
    },
    {
      german: "nennt man",
      translated: "are called",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:128|es": [
    {
      german: "Parlamentsmitglieder",
      translated: "Los miembros del Parlamento",
      tone: 'semantic',
    },
    {
      german: "die von den Bürgerinnen und Bürgern gewählt werden",
      translated: "elegidos por los ciudadanos",
      tone: 'semantic',
    },
    {
      german: "nennt man",
      translated: "se llaman",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:128|fa": [
    {
      german: "Parlamentsmitglieder",
      translated: "اعضای پارلمان",
      tone: 'semantic',
    },
    {
      german: "die von den Bürgerinnen und Bürgern gewählt werden",
      translated: "که توسط شهروندان انتخاب می‌شوند",
      tone: 'semantic',
    },
    {
      german: "nennt man",
      translated: "چه نام دارند",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:128|fr": [
    {
      german: "Parlamentsmitglieder",
      translated: "les membres du Parlement",
      tone: 'semantic',
    },
    {
      german: "die von den Bürgerinnen und Bürgern gewählt werden",
      translated: "élus par les citoyens",
      tone: 'semantic',
    },
    {
      german: "nennt man",
      translated: "Comment appelle-t-on",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:128|hr": [
    {
      german: "Parlamentsmitglieder",
      translated: "članovi parlamenta",
      tone: 'semantic',
    },
    {
      german: "die von den Bürgerinnen und Bürgern gewählt werden",
      translated: "koje su izabrali građani",
      tone: 'semantic',
    },
    {
      german: "nennt man",
      translated: "Kako se nazivaju",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:128|it": [
    {
      german: "Parlamentsmitglieder",
      translated: "membri del Parlamento",
      tone: 'semantic',
    },
    {
      german: "die von den Bürgerinnen und Bürgern gewählt werden",
      translated: "eletti dai cittadini",
      tone: 'semantic',
    },
    {
      german: "nennt man",
      translated: "Come si chiamano",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:128|kmr": [
    {
      german: "Parlamentsmitglieder",
      translated: "Endamên parlamentoyê",
      tone: 'semantic',
    },
    {
      german: "die von den Bürgerinnen und Bürgern gewählt werden",
      translated: "yên ku welatî hildibijêrin",
      tone: 'semantic',
    },
    {
      german: "nennt man",
      translated: "çi têne gotin?",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:128|pl": [
    {
      german: "Parlamentsmitglieder",
      translated: "członków parlamentu",
      tone: 'semantic',
    },
    {
      german: "die von den Bürgerinnen und Bürgern gewählt werden",
      translated: "wybranych przez obywateli",
      tone: 'semantic',
    },
    {
      german: "nennt man",
      translated: "Jak nazywa się",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:128|prs": [
    {
      german: "Parlamentsmitglieder",
      translated: "اعضای پارلمان",
      tone: 'semantic',
    },
    {
      german: "die von den Bürgerinnen und Bürgern gewählt werden",
      translated: "که توسط شهروندان انتخاب می‌شوند",
      tone: 'semantic',
    },
    {
      german: "nennt man",
      translated: "چه نام دارند؟",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:128|ro": [
    {
      german: "Parlamentsmitglieder",
      translated: "membrii parlamentului",
      tone: 'semantic',
    },
    {
      german: "die von den Bürgerinnen und Bürgern gewählt werden",
      translated: "aleși de cetățeni",
      tone: 'semantic',
    },
    {
      german: "nennt man",
      translated: "se numesc",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:128|ru": [
    {
      german: "Parlamentsmitglieder",
      translated: "Членов парламента",
      tone: 'semantic',
    },
    {
      german: "die von den Bürgerinnen und Bürgern gewählt werden",
      translated: "избираемых гражданами",
      tone: 'semantic',
    },
    {
      german: "nennt man",
      translated: "называют",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:128|sq": [
    {
      german: "Parlamentsmitglieder",
      translated: "anëtarët e parlamentit",
      tone: 'semantic',
    },
    {
      german: "die von den Bürgerinnen und Bürgern gewählt werden",
      translated: "të zgjedhur nga qytetarët",
      tone: 'semantic',
    },
    {
      german: "nennt man",
      translated: "quhen",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:128|sr": [
    {
      german: "Parlamentsmitglieder",
      translated: "članovi parlamenta",
      tone: 'semantic',
    },
    {
      german: "die von den Bürgerinnen und Bürgern gewählt werden",
      translated: "koje su izabrali građani",
      tone: 'semantic',
    },
    {
      german: "nennt man",
      translated: "se nazivaju",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:128|tr": [
    {
      german: "Parlamentsmitglieder",
      translated: "parlamento üyelerine",
      tone: 'semantic',
    },
    {
      german: "die von den Bürgerinnen und Bürgern gewählt werden",
      translated: "Vatandaşlar tarafından seçilen",
      tone: 'semantic',
    },
    {
      german: "nennt man",
      translated: "denir",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:128|uk": [
    {
      german: "Parlamentsmitglieder",
      translated: "Членів парламенту",
      tone: 'semantic',
    },
    {
      german: "die von den Bürgerinnen und Bürgern gewählt werden",
      translated: "яких обирають громадяни",
      tone: 'semantic',
    },
    {
      german: "nennt man",
      translated: "називають",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:128|vi": [
    {
      german: "Parlamentsmitglieder",
      translated: "Các thành viên nghị viện",
      tone: 'semantic',
    },
    {
      german: "die von den Bürgerinnen und Bürgern gewählt werden",
      translated: "do công dân bầu",
      tone: 'semantic',
    },
    {
      german: "nennt man",
      translated: "được gọi là",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:129|ar": [
    {
      german: "Vom Volk gewählt",
      translated: "الذي ينتخبه الشعب",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "في ألمانيا",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:129|bg": [
    {
      german: "Vom Volk gewählt",
      translated: "избира пряко от народа",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:129|bs": [
    {
      german: "Vom Volk gewählt",
      translated: "narod bira",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "u Njemačkoj",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:129|el": [
    {
      german: "Vom Volk gewählt",
      translated: "άμεσα από τον λαό",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "στη Γερμανία",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:129|en": [
    {
      german: "Vom Volk gewählt",
      translated: "the people directly elect",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "In Germany",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:129|es": [
    {
      german: "Vom Volk gewählt",
      translated: "el pueblo elige",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "En Alemania",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:129|fa": [
    {
      german: "Vom Volk gewählt",
      translated: "توسط مردم انتخاب می‌شود",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "در آلمان",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:129|fr": [
    {
      german: "Vom Volk gewählt",
      translated: "élu directement par le peuple",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "En Allemagne",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:129|hr": [
    {
      german: "Vom Volk gewählt",
      translated: "narod bira",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "u Njemačkoj",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:129|it": [
    {
      german: "Vom Volk gewählt",
      translated: "eletto direttamente dal popolo",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "in Germania",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:129|kmr": [
    {
      german: "Vom Volk gewählt",
      translated: "kî rasterast ji hêla gel",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "Li Almanyayê",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:129|pl": [
    {
      german: "Vom Volk gewählt",
      translated: "wybierany bezpośrednio przez naród",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "w Niemczech",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:129|prs": [
    {
      german: "Vom Volk gewählt",
      translated: "توسط مردم انتخاب",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "در آلمان",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:129|ro": [
    {
      german: "Vom Volk gewählt",
      translated: "ales direct de popor",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "în Germania",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:129|ru": [
    {
      german: "Vom Volk gewählt",
      translated: "Народом",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "в Германии",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:129|sq": [
    {
      german: "Vom Volk gewählt",
      translated: "zgjidhet drejtpërdrejt nga populli",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "në Gjermani",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:129|sr": [
    {
      german: "Vom Volk gewählt",
      translated: "narod bira",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "u Nemačkoj",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:129|tr": [
    {
      german: "Vom Volk gewählt",
      translated: "halk tarafından",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "Almanya'da",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:129|uk": [
    {
      german: "Vom Volk gewählt",
      translated: "Безпосередньо народом",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "у Німеччині",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:129|vi": [
    {
      german: "Vom Volk gewählt",
      translated: "được nhân dân Đức bầu",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:12|ar": [
    {
      german: "Eine Partei im Deutschen Bundestag",
      translated: "حزب في البوندستاغ الألماني",
      tone: 'semantic',
    },
    {
      german: "will die Pressefreiheit abschaffen",
      translated: "إلغاء حرية الصحافة",
      tone: 'semantic',
    },
    {
      german: "Ist das möglich",
      translated: "هل هذا ممكن",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:12|bg": [
    {
      german: "Eine Partei im Deutschen Bundestag",
      translated: "Партия в германския Бундестаг",
      tone: 'semantic',
    },
    {
      german: "will die Pressefreiheit abschaffen",
      translated: "иска да премахне свободата на печата",
      tone: 'semantic',
    },
    {
      german: "Ist das möglich",
      translated: "Възможно ли е това?",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:12|bs": [
    {
      german: "Eine Partei im Deutschen Bundestag",
      translated: "Stranka u njemačkom Bundestagu",
      tone: 'semantic',
    },
    {
      german: "will die Pressefreiheit abschaffen",
      translated: "želi ukinuti slobodu štampe",
      tone: 'semantic',
    },
    {
      german: "Ist das möglich",
      translated: "Je li to moguće",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:12|el": [
    {
      german: "Eine Partei im Deutschen Bundestag",
      translated: "Ένα κόμμα στο γερμανικό Bundestag",
      tone: 'semantic',
    },
    {
      german: "will die Pressefreiheit abschaffen",
      translated: "θέλει να καταργήσει την ελευθερία του Τύπου",
      tone: 'semantic',
    },
    {
      german: "Ist das möglich",
      translated: "Είναι δυνατόν",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:12|en": [
    {
      german: "Eine Partei im Deutschen Bundestag",
      translated: "A party in the German Bundestag",
      tone: 'semantic',
    },
    {
      german: "will die Pressefreiheit abschaffen",
      translated: "wants to abolish freedom of the press",
      tone: 'semantic',
    },
    {
      german: "Ist das möglich",
      translated: "Is that possible",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:12|es": [
    {
      german: "Eine Partei im Deutschen Bundestag",
      translated: "Un partido del Bundestag alemán",
      tone: 'semantic',
    },
    {
      german: "will die Pressefreiheit abschaffen",
      translated: "quiere abolir la libertad de prensa",
      tone: 'semantic',
    },
    {
      german: "Ist das möglich",
      translated: "¿Es posible?",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:12|fa": [
    {
      german: "Eine Partei im Deutschen Bundestag",
      translated: "یک حزب در بوندستاگ آلمان",
      tone: 'semantic',
    },
    {
      german: "will die Pressefreiheit abschaffen",
      translated: "می‌خواهد آزادی مطبوعات را لغو کند",
      tone: 'semantic',
    },
    {
      german: "Ist das möglich",
      translated: "آیا این امکان‌پذیر است",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:12|fr": [
    {
      german: "Eine Partei im Deutschen Bundestag",
      translated: "Un parti au Bundestag allemand",
      tone: 'semantic',
    },
    {
      german: "will die Pressefreiheit abschaffen",
      translated: "veut abolir la liberté de la presse",
      tone: 'semantic',
    },
    {
      german: "Ist das möglich",
      translated: "Est-ce possible ?",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:12|hr": [
    {
      german: "Eine Partei im Deutschen Bundestag",
      translated: "Stranka u njemačkom Bundestagu",
      tone: 'semantic',
    },
    {
      german: "will die Pressefreiheit abschaffen",
      translated: "želi ukinuti slobodu tiska",
      tone: 'semantic',
    },
    {
      german: "Ist das möglich",
      translated: "Je li to moguće",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:12|it": [
    {
      german: "Eine Partei im Deutschen Bundestag",
      translated: "Un partito nel Bundestag tedesco",
      tone: 'semantic',
    },
    {
      german: "will die Pressefreiheit abschaffen",
      translated: "vuole abolire la libertà di stampa",
      tone: 'semantic',
    },
    {
      german: "Ist das möglich",
      translated: "È possibile?",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:12|kmr": [
    {
      german: "Eine Partei im Deutschen Bundestag",
      translated: "Partiyek di Bundestagê Alman de",
      tone: 'semantic',
    },
    {
      german: "will die Pressefreiheit abschaffen",
      translated: "dixwaze azadiya çapemeniyê betal bike",
      tone: 'semantic',
    },
    {
      german: "Ist das möglich",
      translated: "Ma ev gengaz e",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:12|pl": [
    {
      german: "Eine Partei im Deutschen Bundestag",
      translated: "Partia w niemieckim Bundestagu",
      tone: 'semantic',
    },
    {
      german: "will die Pressefreiheit abschaffen",
      translated: "chce znieść wolność prasy",
      tone: 'semantic',
    },
    {
      german: "Ist das möglich",
      translated: "Czy jest to możliwe?",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:12|prs": [
    {
      german: "Eine Partei im Deutschen Bundestag",
      translated: "یک حزب در بوندستاگ آلمان",
      tone: 'semantic',
    },
    {
      german: "will die Pressefreiheit abschaffen",
      translated: "می‌خواهد آزادی مطبوعات را لغو کند",
      tone: 'semantic',
    },
    {
      german: "Ist das möglich",
      translated: "آیا این امکان‌پذیر است",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:12|ro": [
    {
      german: "Eine Partei im Deutschen Bundestag",
      translated: "Un partid din Bundestagul german",
      tone: 'semantic',
    },
    {
      german: "will die Pressefreiheit abschaffen",
      translated: "vrea să desființeze libertatea presei",
      tone: 'semantic',
    },
    {
      german: "Ist das möglich",
      translated: "Este posibil?",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:12|ru": [
    {
      german: "Eine Partei im Deutschen Bundestag",
      translated: "Одна из партий в немецком Бундестаге",
      tone: 'semantic',
    },
    {
      german: "will die Pressefreiheit abschaffen",
      translated: "хочет отменить свободу прессы",
      tone: 'semantic',
    },
    {
      german: "Ist das möglich",
      translated: "Возможно ли это?",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:12|sq": [
    {
      german: "Eine Partei im Deutschen Bundestag",
      translated: "Një parti në Bundestagun gjerman",
      tone: 'semantic',
    },
    {
      german: "will die Pressefreiheit abschaffen",
      translated: "dëshiron të heqë lirinë e shtypit",
      tone: 'semantic',
    },
    {
      german: "Ist das möglich",
      translated: "A është e mundur kjo?",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:12|sr": [
    {
      german: "Eine Partei im Deutschen Bundestag",
      translated: "Stranka u nemačkom Bundestagu",
      tone: 'semantic',
    },
    {
      german: "will die Pressefreiheit abschaffen",
      translated: "želi ukinuti slobodu štampe",
      tone: 'semantic',
    },
    {
      german: "Ist das möglich",
      translated: "Je li to moguće?",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:12|tr": [
    {
      german: "Eine Partei im Deutschen Bundestag",
      translated: "Federal Meclis'teki bir parti",
      tone: 'semantic',
    },
    {
      german: "will die Pressefreiheit abschaffen",
      translated: "basın özgürlüğünü kaldırmak",
      tone: 'semantic',
    },
    {
      german: "Ist das möglich",
      translated: "Bu mümkün müdür?",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:12|uk": [
    {
      german: "Eine Partei im Deutschen Bundestag",
      translated: "Партія в німецькому Бундестазі",
      tone: 'semantic',
    },
    {
      german: "will die Pressefreiheit abschaffen",
      translated: "хоче скасувати свободу преси",
      tone: 'semantic',
    },
    {
      german: "Ist das möglich",
      translated: "Чи можливо це?",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:12|vi": [
    {
      german: "Eine Partei im Deutschen Bundestag",
      translated: "Một đảng trong Bundestag Đức",
      tone: 'semantic',
    },
    {
      german: "will die Pressefreiheit abschaffen",
      translated: "muốn bãi bỏ tự do báo chí",
      tone: 'semantic',
    },
    {
      german: "Ist das möglich",
      translated: "Điều này có thể thực hiện được không?",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:130|ar": [
    {
      german: "Welcher Stimmzettel",
      translated: "أي ورقة اقتراع",
      tone: 'semantic',
    },
    {
      german: "bei einer Bundestagswahl",
      translated: "في انتخابات البوندستاغ",
      tone: 'semantic',
    },
    {
      german: "gültig",
      translated: "صالحة",
      tone: 'semantic',
    },
    {
      german: "In Anlehnung an",
      translated: "استنادًا إلى",
      tone: 'semantic',
    },
    {
      german: "Bundeswahlordnung (BWO)",
      translated: "لائحة الانتخابات الاتحادية (BWO)",
      tone: 'semantic',
    },
    {
      german: "Anlage 26",
      translated: "الملحق 26",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:130|bg": [
    {
      german: "Welcher Stimmzettel",
      translated: "Коя бюлетина",
      tone: 'semantic',
    },
    {
      german: "bei einer Bundestagswahl",
      translated: "при изборите за Бундестаг",
      tone: 'semantic',
    },
    {
      german: "gültig",
      translated: "валидна",
      tone: 'semantic',
    },
    {
      german: "In Anlehnung an",
      translated: "Съгласно",
      tone: 'semantic',
    },
    {
      german: "Bundeswahlordnung (BWO)",
      translated: "BWO",
      tone: 'semantic',
    },
    {
      german: "Anlage 26",
      translated: "приложение 26",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:130|bs": [
    {
      german: "Welcher Stimmzettel",
      translated: "Koji je glasački listić",
      tone: 'semantic',
    },
    {
      german: "bei einer Bundestagswahl",
      translated: "na izborima za Bundestag",
      tone: 'semantic',
    },
    {
      german: "gültig",
      translated: "valjan",
      tone: 'semantic',
    },
    {
      german: "In Anlehnung an",
      translated: "Prema",
      tone: 'semantic',
    },
    {
      german: "Bundeswahlordnung (BWO)",
      translated: "BWO-u",
      tone: 'semantic',
    },
    {
      german: "Anlage 26",
      translated: "prilog 26",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:130|el": [
    {
      german: "Welcher Stimmzettel",
      translated: "Ποιο ψηφοδέλτιο",
      tone: 'semantic',
    },
    {
      german: "bei einer Bundestagswahl",
      translated: "στις εκλογές του Bundestag",
      tone: 'semantic',
    },
    {
      german: "gültig",
      translated: "έγκυρο",
      tone: 'semantic',
    },
    {
      german: "In Anlehnung an",
      translated: "Σύμφωνα με",
      tone: 'semantic',
    },
    {
      german: "Bundeswahlordnung (BWO)",
      translated: "τον ομοσπονδιακό εκλογικό κανονισμό (BWO)",
      tone: 'semantic',
    },
    {
      german: "Anlage 26",
      translated: "παράρτημα 26",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:130|en": [
    {
      german: "Welcher Stimmzettel",
      translated: "Which ballot",
      tone: 'semantic',
    },
    {
      german: "bei einer Bundestagswahl",
      translated: "in a Bundestag election",
      tone: 'semantic',
    },
    {
      german: "gültig",
      translated: "valid",
      tone: 'semantic',
    },
    {
      german: "In Anlehnung an",
      translated: "Based on the",
      tone: 'semantic',
    },
    {
      german: "Bundeswahlordnung (BWO)",
      translated: "Federal Electoral Regulations (BWO)",
      tone: 'semantic',
    },
    {
      german: "Anlage 26",
      translated: "Annex 26",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:130|es": [
    {
      german: "Welcher Stimmzettel",
      translated: "¿Qué papeleta",
      tone: 'semantic',
    },
    {
      german: "bei einer Bundestagswahl",
      translated: "en unas elecciones al Bundestag",
      tone: 'semantic',
    },
    {
      german: "gültig",
      translated: "válida",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:130|fa": [
    {
      german: "Welcher Stimmzettel",
      translated: "کدام برگهٔ رأی",
      tone: 'semantic',
    },
    {
      german: "bei einer Bundestagswahl",
      translated: "در انتخابات بوندستاگ",
      tone: 'semantic',
    },
    {
      german: "gültig",
      translated: "معتبر",
      tone: 'semantic',
    },
    {
      german: "In Anlehnung an",
      translated: "بر اساس",
      tone: 'semantic',
    },
    {
      german: "Bundeswahlordnung (BWO)",
      translated: "مقررات انتخابات فدرال (BWO)",
      tone: 'semantic',
    },
    {
      german: "Anlage 26",
      translated: "پیوست ۲۶",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:130|fr": [
    {
      german: "Welcher Stimmzettel",
      translated: "Quel bulletin de vote",
      tone: 'semantic',
    },
    {
      german: "bei einer Bundestagswahl",
      translated: "lors d’une élection au Bundestag",
      tone: 'semantic',
    },
    {
      german: "gültig",
      translated: "valable",
      tone: 'semantic',
    },
    {
      german: "In Anlehnung an",
      translated: "D’après",
      tone: 'semantic',
    },
    {
      german: "Bundeswahlordnung (BWO)",
      translated: "règlement électoral fédéral (BWO)",
      tone: 'semantic',
    },
    {
      german: "Anlage 26",
      translated: "annexe 26",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:130|hr": [
    {
      german: "Welcher Stimmzettel",
      translated: "Koji je glasački listić",
      tone: 'semantic',
    },
    {
      german: "bei einer Bundestagswahl",
      translated: "na izborima za Bundestag",
      tone: 'semantic',
    },
    {
      german: "gültig",
      translated: "valjan",
      tone: 'semantic',
    },
    {
      german: "In Anlehnung an",
      translated: "Prema",
      tone: 'semantic',
    },
    {
      german: "Bundeswahlordnung (BWO)",
      translated: "BWO-u",
      tone: 'semantic',
    },
    {
      german: "Anlage 26",
      translated: "prilog 26",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:130|it": [
    {
      german: "Welcher Stimmzettel",
      translated: "Quale scheda elettorale",
      tone: 'semantic',
    },
    {
      german: "bei einer Bundestagswahl",
      translated: "alle elezioni del Bundestag",
      tone: 'semantic',
    },
    {
      german: "gültig",
      translated: "valida",
      tone: 'semantic',
    },
    {
      german: "In Anlehnung an",
      translated: "Secondo il",
      tone: 'semantic',
    },
    {
      german: "Bundeswahlordnung (BWO)",
      translated: "regolamento elettorale federale (BWO)",
      tone: 'semantic',
    },
    {
      german: "Anlage 26",
      translated: "allegato 26",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:130|kmr": [
    {
      german: "Welcher",
      translated: "kîjan",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:130|pl": [
    {
      german: "Welcher Stimmzettel",
      translated: "Która karta do głosowania",
      tone: 'semantic',
    },
    {
      german: "bei einer Bundestagswahl",
      translated: "w wyborach do Bundestagu",
      tone: 'semantic',
    },
    {
      german: "gültig",
      translated: "ważna",
      tone: 'semantic',
    },
    {
      german: "In Anlehnung an",
      translated: "Zgodnie z",
      tone: 'semantic',
    },
    {
      german: "Bundeswahlordnung (BWO)",
      translated: "BWO",
      tone: 'semantic',
    },
    {
      german: "Anlage 26",
      translated: "załącznik 26",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:130|prs": [
    {
      german: "Welcher Stimmzettel",
      translated: "کدام برگهٔ رأی",
      tone: 'semantic',
    },
    {
      german: "bei einer Bundestagswahl",
      translated: "در انتخابات بوندستاگ",
      tone: 'semantic',
    },
    {
      german: "gültig",
      translated: "معتبر",
      tone: 'semantic',
    },
    {
      german: "In Anlehnung an",
      translated: "بر اساس",
      tone: 'semantic',
    },
    {
      german: "Bundeswahlordnung (BWO)",
      translated: "مقررات انتخابات فدرال (BWO)",
      tone: 'semantic',
    },
    {
      german: "Anlage 26",
      translated: "پیوست ۲۶",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:130|ro": [
    {
      german: "Welcher Stimmzettel",
      translated: "Care buletin de vot",
      tone: 'semantic',
    },
    {
      german: "bei einer Bundestagswahl",
      translated: "la alegerile pentru Bundestag",
      tone: 'semantic',
    },
    {
      german: "gültig",
      translated: "valabil",
      tone: 'semantic',
    },
    {
      german: "In Anlehnung an",
      translated: "Conform",
      tone: 'semantic',
    },
    {
      german: "Bundeswahlordnung (BWO)",
      translated: "BWO",
      tone: 'semantic',
    },
    {
      german: "Anlage 26",
      translated: "anexa 26",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:130|ru": [
    {
      german: "Welcher Stimmzettel",
      translated: "Какой избирательный бюллетень",
      tone: 'semantic',
    },
    {
      german: "bei einer Bundestagswahl",
      translated: "на выборах в Бундестаг",
      tone: 'semantic',
    },
    {
      german: "gültig",
      translated: "действительным",
      tone: 'semantic',
    },
    {
      german: "In Anlehnung an",
      translated: "По образцу",
      tone: 'semantic',
    },
    {
      german: "Bundeswahlordnung (BWO)",
      translated: "Федерального положения о выборах (BWO)",
      tone: 'semantic',
    },
    {
      german: "Anlage 26",
      translated: "приложение 26",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:130|sq": [
    {
      german: "Welcher Stimmzettel",
      translated: "Cila fletëvotim",
      tone: 'semantic',
    },
    {
      german: "bei einer Bundestagswahl",
      translated: "në zgjedhjet e Bundestagut",
      tone: 'semantic',
    },
    {
      german: "gültig",
      translated: "e vlefshme",
      tone: 'semantic',
    },
    {
      german: "In Anlehnung an",
      translated: "Sipas",
      tone: 'semantic',
    },
    {
      german: "Bundeswahlordnung (BWO)",
      translated: "BWO",
      tone: 'semantic',
    },
    {
      german: "Anlage 26",
      translated: "shtojca 26",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:130|sr": [
    {
      german: "Welcher Stimmzettel",
      translated: "Koji je glasački listić",
      tone: 'semantic',
    },
    {
      german: "bei einer Bundestagswahl",
      translated: "na izborima za Bundestag",
      tone: 'semantic',
    },
    {
      german: "gültig",
      translated: "valjan",
      tone: 'semantic',
    },
    {
      german: "In Anlehnung an",
      translated: "Prema",
      tone: 'semantic',
    },
    {
      german: "Bundeswahlordnung (BWO)",
      translated: "BWO-u",
      tone: 'semantic',
    },
    {
      german: "Anlage 26",
      translated: "prilog 26",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:130|tr": [
    {
      german: "Welcher Stimmzettel",
      translated: "hangi oy pusulası",
      tone: 'semantic',
    },
    {
      german: "bei einer Bundestagswahl",
      translated: "Federal Meclis seçiminde",
      tone: 'semantic',
    },
    {
      german: "gültig",
      translated: "geçerli",
      tone: 'semantic',
    },
    {
      german: "In Anlehnung an",
      translated: "göre",
      tone: 'semantic',
    },
    {
      german: "Bundeswahlordnung (BWO)",
      translated: "Federal Seçim Yönetmeliği (BWO)",
      tone: 'semantic',
    },
    {
      german: "Anlage 26",
      translated: "Ek 26'ya",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:130|uk": [
    {
      german: "Welcher Stimmzettel",
      translated: "Який виборчий бюлетень",
      tone: 'semantic',
    },
    {
      german: "bei einer Bundestagswahl",
      translated: "на виборах до Бундестагу",
      tone: 'semantic',
    },
    {
      german: "gültig",
      translated: "дійсним",
      tone: 'semantic',
    },
    {
      german: "In Anlehnung an",
      translated: "За зразком",
      tone: 'semantic',
    },
    {
      german: "Bundeswahlordnung (BWO)",
      translated: "Федерального положення про вибори (BWO)",
      tone: 'semantic',
    },
    {
      german: "Anlage 26",
      translated: "додаток 26",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:130|vi": [
    {
      german: "Welcher Stimmzettel",
      translated: "Phiếu nào",
      tone: 'semantic',
    },
    {
      german: "bei einer Bundestagswahl",
      translated: "trong bầu cử Bundestag",
      tone: 'semantic',
    },
    {
      german: "gültig",
      translated: "hợp lệ",
      tone: 'semantic',
    },
    {
      german: "In Anlehnung an",
      translated: "Theo",
      tone: 'semantic',
    },
    {
      german: "Bundeswahlordnung (BWO)",
      translated: "BWO",
      tone: 'semantic',
    },
    {
      german: "Anlage 26",
      translated: "Phụ lục 26",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:131|ar": [
    {
      german: "In Deutschland",
      translated: "في ألمانيا",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "هو",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:131|bg": [
    {
      german: "In Deutschland",
      translated: "В Германия",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "е",
      tone: 'semantic',
    },
    {
      german: "ein Bürgermeister",
      translated: "кметът",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:131|bs": [
    {
      german: "In Deutschland",
      translated: "U Njemačkoj",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "je",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:131|el": [
    {
      german: "In Deutschland",
      translated: "Στη Γερμανία",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "είναι",
      tone: 'semantic',
    },
    {
      german: "ein Bürgermeister",
      translated: "ο δήμαρχος",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:131|en": [
    {
      german: "In Deutschland",
      translated: "In Germany",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "is",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:131|es": [
    {
      german: "In Deutschland",
      translated: "En Alemania",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "es",
      tone: 'semantic',
    },
    {
      german: "ein Bürgermeister",
      translated: "un alcalde",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:131|fa": [
    {
      german: "In Deutschland",
      translated: "در آلمان",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "است",
      tone: 'semantic',
    },
    {
      german: "eine Bürgermeisterin",
      translated: "شهردار",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:131|fr": [
    {
      german: "In Deutschland",
      translated: "En Allemagne",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "est",
      tone: 'semantic',
    },
    {
      german: "eine Bürgermeisterin",
      translated: "une maire",
      tone: 'semantic',
    },
    {
      german: "ein Bürgermeister",
      translated: "un maire",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:131|hr": [
    {
      german: "In Deutschland",
      translated: "U Njemačkoj",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "je",
      tone: 'semantic',
    },
    {
      german: "ein Bürgermeister",
      translated: "gradonačelnik",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:131|it": [
    {
      german: "In Deutschland",
      translated: "In Germania",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "è",
      tone: 'semantic',
    },
    {
      german: "ein Bürgermeister",
      translated: "un sindaco",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:131|kmr": [
    {
      german: "In Deutschland",
      translated: "Li Almanyayê",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "e",
      tone: 'semantic',
    },
    {
      german: "ein Bürgermeister",
      translated: "Bürgermeister",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:131|pl": [
    {
      german: "In Deutschland",
      translated: "W Niemczech",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "jest",
      tone: 'semantic',
    },
    {
      german: "ein Bürgermeister",
      translated: "burmistrz",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:131|prs": [
    {
      german: "In Deutschland",
      translated: "در آلمان",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "است",
      tone: 'semantic',
    },
    {
      german: "eine Bürgermeisterin",
      translated: "شهردار",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:131|ro": [
    {
      german: "In Deutschland",
      translated: "În Germania",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "este",
      tone: 'semantic',
    },
    {
      german: "ein Bürgermeister",
      translated: "primarul",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:131|ru": [
    {
      german: "In Deutschland",
      translated: "В Германии",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "— это",
      tone: 'semantic',
    },
    {
      german: "ein Bürgermeister",
      translated: "бургомистр",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:131|sq": [
    {
      german: "In Deutschland",
      translated: "Në Gjermani",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "është",
      tone: 'semantic',
    },
    {
      german: "ein Bürgermeister",
      translated: "kryetari i bashkisë",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:131|sr": [
    {
      german: "In Deutschland",
      translated: "U Nemačkoj",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "je",
      tone: 'semantic',
    },
    {
      german: "eine Bürgermeisterin",
      translated: "gradonačelnica",
      tone: 'semantic',
    },
    {
      german: "ein Bürgermeister",
      translated: "gradonačelnik",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:131|tr": [
    {
      german: "In Deutschland",
      translated: "Almanya'da",
      tone: 'semantic',
    },
    {
      german: "eine Bürgermeisterin",
      translated: "belediye başkanı",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:131|uk": [
    {
      german: "In Deutschland",
      translated: "У Німеччині",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "це",
      tone: 'semantic',
    },
    {
      german: "eine Bürgermeisterin",
      translated: "бургомістерка",
      tone: 'semantic',
    },
    {
      german: "ein Bürgermeister",
      translated: "бургомістр",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:131|vi": [
    {
      german: "In Deutschland",
      translated: "Ở Đức",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "là",
      tone: 'semantic',
    },
    {
      german: "eine Bürgermeisterin",
      translated: "thị trưởng",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:132|ar": [
    {
      german: "Viele Menschen",
      translated: "كثير من الناس",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "في ألمانيا",
      tone: 'semantic',
    },
    {
      german: "arbeiten",
      translated: "يعمل",
      tone: 'semantic',
    },
    {
      german: "in ihrer Freizeit",
      translated: "في أوقات فراغهم",
      tone: 'semantic',
    },
    {
      german: "ehrenamtlich",
      translated: "تطوعًا",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:132|bg": [
    {
      german: "Viele Menschen",
      translated: "Много хора",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "в Германия",
      tone: 'semantic',
    },
    {
      german: "arbeiten",
      translated: "извършват",
      tone: 'semantic',
    },
    {
      german: "in ihrer Freizeit",
      translated: "през свободното си време",
      tone: 'semantic',
    },
    {
      german: "ehrenamtlich",
      translated: "доброволна",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:132|bs": [
    {
      german: "Viele Menschen",
      translated: "Mnogi ljudi",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "u Njemačkoj",
      tone: 'semantic',
    },
    {
      german: "arbeiten",
      translated: "obavljaju",
      tone: 'semantic',
    },
    {
      german: "in ihrer Freizeit",
      translated: "u slobodno vrijeme",
      tone: 'semantic',
    },
    {
      german: "ehrenamtlich",
      translated: "volonterski",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:132|el": [
    {
      german: "Viele Menschen",
      translated: "Πολλοί άνθρωποι",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "στη Γερμανία",
      tone: 'semantic',
    },
    {
      german: "arbeiten",
      translated: "προσφέρουν",
      tone: 'semantic',
    },
    {
      german: "in ihrer Freizeit",
      translated: "στον ελεύθερο χρόνο τους",
      tone: 'semantic',
    },
    {
      german: "ehrenamtlich",
      translated: "εθελοντική",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:132|en": [
    {
      german: "Viele Menschen",
      translated: "Many people",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "in Germany",
      tone: 'semantic',
    },
    {
      german: "arbeiten",
      translated: "work",
      tone: 'semantic',
    },
    {
      german: "in ihrer Freizeit",
      translated: "in their free time",
      tone: 'semantic',
    },
    {
      german: "ehrenamtlich",
      translated: "volunteer",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:132|es": [
    {
      german: "Viele Menschen",
      translated: "Muchas personas",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "en Alemania",
      tone: 'semantic',
    },
    {
      german: "arbeiten",
      translated: "realizan",
      tone: 'semantic',
    },
    {
      german: "in ihrer Freizeit",
      translated: "en su tiempo libre",
      tone: 'semantic',
    },
    {
      german: "ehrenamtlich",
      translated: "voluntario",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:132|fa": [
    {
      german: "Viele Menschen",
      translated: "بسیاری از مردم",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "در آلمان",
      tone: 'semantic',
    },
    {
      german: "arbeiten",
      translated: "فعالیت می‌کنند",
      tone: 'semantic',
    },
    {
      german: "in ihrer Freizeit",
      translated: "در اوقات فراغت خود",
      tone: 'semantic',
    },
    {
      german: "ehrenamtlich",
      translated: "به‌صورت داوطلبانه",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:132|fr": [
    {
      german: "Viele Menschen",
      translated: "Beaucoup de personnes",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "en Allemagne",
      tone: 'semantic',
    },
    {
      german: "arbeiten",
      translated: "travaillent",
      tone: 'semantic',
    },
    {
      german: "in ihrer Freizeit",
      translated: "pendant leur temps libre",
      tone: 'semantic',
    },
    {
      german: "ehrenamtlich",
      translated: "bénévolement",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:132|hr": [
    {
      german: "Viele Menschen",
      translated: "Mnogi ljudi",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "u Njemačkoj",
      tone: 'semantic',
    },
    {
      german: "arbeiten",
      translated: "obavljaju",
      tone: 'semantic',
    },
    {
      german: "in ihrer Freizeit",
      translated: "u slobodno vrijeme",
      tone: 'semantic',
    },
    {
      german: "ehrenamtlich",
      translated: "volonterski",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:132|it": [
    {
      german: "Viele Menschen",
      translated: "Molte persone",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "in Germania",
      tone: 'semantic',
    },
    {
      german: "arbeiten",
      translated: "svolgono attività",
      tone: 'semantic',
    },
    {
      german: "in ihrer Freizeit",
      translated: "nel tempo libero",
      tone: 'semantic',
    },
    {
      german: "ehrenamtlich",
      translated: "di volontariato",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:132|kmr": [
    {
      german: "Viele Menschen",
      translated: "Gelek kes",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "li Almanyayê",
      tone: 'semantic',
    },
    {
      german: "arbeiten",
      translated: "dixebitin",
      tone: 'semantic',
    },
    {
      german: "in ihrer Freizeit",
      translated: "di dema xwe",
      tone: 'semantic',
    },
    {
      german: "ehrenamtlich",
      translated: "bi dilxwazî",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:132|pl": [
    {
      german: "Viele Menschen",
      translated: "Wiele osób",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "w Niemczech",
      tone: 'semantic',
    },
    {
      german: "arbeiten",
      translated: "wykonuje",
      tone: 'semantic',
    },
    {
      german: "in ihrer Freizeit",
      translated: "w czasie wolnym",
      tone: 'semantic',
    },
    {
      german: "ehrenamtlich",
      translated: "pracę społeczną",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:132|prs": [
    {
      german: "Viele Menschen",
      translated: "بسیاری از مردم",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "در آلمان",
      tone: 'semantic',
    },
    {
      german: "arbeiten",
      translated: "فعالیت می‌کنند",
      tone: 'semantic',
    },
    {
      german: "in ihrer Freizeit",
      translated: "در اوقات فراغت خود",
      tone: 'semantic',
    },
    {
      german: "ehrenamtlich",
      translated: "به‌صورت داوطلبانه",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:132|ro": [
    {
      german: "Viele Menschen",
      translated: "Mulți oameni",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "din Germania",
      tone: 'semantic',
    },
    {
      german: "arbeiten",
      translated: "desfășoară",
      tone: 'semantic',
    },
    {
      german: "in ihrer Freizeit",
      translated: "în timpul liber",
      tone: 'semantic',
    },
    {
      german: "ehrenamtlich",
      translated: "voluntare",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:132|ru": [
    {
      german: "Viele Menschen",
      translated: "Многие люди",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "в Германии",
      tone: 'semantic',
    },
    {
      german: "arbeiten",
      translated: "занимаются",
      tone: 'semantic',
    },
    {
      german: "in ihrer Freizeit",
      translated: "в свободное время",
      tone: 'semantic',
    },
    {
      german: "ehrenamtlich",
      translated: "добровольческой",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:132|sq": [
    {
      german: "Viele Menschen",
      translated: "Shumë njerëz",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "në Gjermani",
      tone: 'semantic',
    },
    {
      german: "arbeiten",
      translated: "bëjnë punë",
      tone: 'semantic',
    },
    {
      german: "in ihrer Freizeit",
      translated: "në kohën e lirë",
      tone: 'semantic',
    },
    {
      german: "ehrenamtlich",
      translated: "vullnetare",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:132|sr": [
    {
      german: "Viele Menschen",
      translated: "Mnogi ljudi",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "u Nemačkoj",
      tone: 'semantic',
    },
    {
      german: "arbeiten",
      translated: "obavljaju",
      tone: 'semantic',
    },
    {
      german: "in ihrer Freizeit",
      translated: "u slobodno vrijeme",
      tone: 'semantic',
    },
    {
      german: "ehrenamtlich",
      translated: "volonterski",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:132|tr": [
    {
      german: "Viele Menschen",
      translated: "birçok kişi",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "Almanya'da",
      tone: 'semantic',
    },
    {
      german: "arbeiten",
      translated: "çalışır",
      tone: 'semantic',
    },
    {
      german: "in ihrer Freizeit",
      translated: "boş zamanında",
      tone: 'semantic',
    },
    {
      german: "ehrenamtlich",
      translated: "gönüllü olarak",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:132|uk": [
    {
      german: "Viele Menschen",
      translated: "Багато людей",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "у Німеччині",
      tone: 'semantic',
    },
    {
      german: "arbeiten",
      translated: "займаються",
      tone: 'semantic',
    },
    {
      german: "in ihrer Freizeit",
      translated: "у вільний час",
      tone: 'semantic',
    },
    {
      german: "ehrenamtlich",
      translated: "волонтерською",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:132|vi": [
    {
      german: "Viele Menschen",
      translated: "Nhiều người",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "ở Đức",
      tone: 'semantic',
    },
    {
      german: "arbeiten",
      translated: "làm",
      tone: 'semantic',
    },
    {
      german: "in ihrer Freizeit",
      translated: "trong thời gian rảnh",
      tone: 'semantic',
    },
    {
      german: "ehrenamtlich",
      translated: "tình nguyện",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:133|ar": [
    {
      german: "Was ist",
      translated: "ما",
      tone: 'semantic',
    },
    {
      german: "bei",
      translated: "في",
      tone: 'semantic',
    },
    {
      german: "Bundestags- und Landtagswahlen",
      translated: "انتخابات البوندستاغ وانتخابات برلمانات الولايات",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "في ألمانيا",
      tone: 'semantic',
    },
    {
      german: "erlaubt?",
      translated: "المسموح به",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:133|bg": [
    {
      german: "Was",
      translated: "какво",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:133|bs": [
    {
      german: "Was ist",
      translated: "Što je",
      tone: 'semantic',
    },
    {
      german: "bei",
      translated: "na",
      tone: 'semantic',
    },
    {
      german: "Bundestags- und Landtagswahlen",
      translated: "izborima za Bundestag i parlamente saveznih zemalja",
      tone: 'semantic',
    },
    {
      german: "erlaubt?",
      translated: "dopušteno",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:133|el": [
    {
      german: "Was ist",
      translated: "Τι",
      tone: 'semantic',
    },
    {
      german: "bei",
      translated: "στις",
      tone: 'semantic',
    },
    {
      german: "Bundestags- und Landtagswahlen",
      translated: "Bundestag και τα Landtage",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "στη Γερμανία",
      tone: 'semantic',
    },
    {
      german: "erlaubt?",
      translated: "επιτρέπεται",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:133|en": [
    {
      german: "Was ist",
      translated: "What is",
      tone: 'semantic',
    },
    {
      german: "bei",
      translated: "in",
      tone: 'semantic',
    },
    {
      german: "Bundestags- und Landtagswahlen",
      translated: "federal and state elections",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "in Germany",
      tone: 'semantic',
    },
    {
      german: "erlaubt?",
      translated: "allowed",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:133|es": [
    {
      german: "Was ist",
      translated: "¿Qué está",
      tone: 'semantic',
    },
    {
      german: "bei",
      translated: "en",
      tone: 'semantic',
    },
    {
      german: "Bundestags- und Landtagswahlen",
      translated: "elecciones federales y regionales",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "en Alemania?",
      tone: 'semantic',
    },
    {
      german: "erlaubt?",
      translated: "permitido",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:133|fa": [
    {
      german: "Was ist",
      translated: "کدام",
      tone: 'semantic',
    },
    {
      german: "bei",
      translated: "در",
      tone: 'semantic',
    },
    {
      german: "Bundestags- und Landtagswahlen",
      translated: "انتخابات بوندستاگ و پارلمان‌های ایالتی",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "آلمان",
      tone: 'semantic',
    },
    {
      german: "erlaubt?",
      translated: "مجاز",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:133|fr": [
    {
      german: "Was ist",
      translated: "Qu’est-ce qui est",
      tone: 'semantic',
    },
    {
      german: "bei",
      translated: "lors des",
      tone: 'semantic',
    },
    {
      german: "Bundestags- und Landtagswahlen",
      translated: "du Bundestag et des Landtage",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "en Allemagne",
      tone: 'semantic',
    },
    {
      german: "erlaubt?",
      translated: "autorisé",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:133|hr": [
    {
      german: "Was",
      translated: "što",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:133|it": [
    {
      german: "Was ist",
      translated: "Che cosa è",
      tone: 'semantic',
    },
    {
      german: "bei",
      translated: "alle",
      tone: 'semantic',
    },
    {
      german: "Bundestags- und Landtagswahlen",
      translated: "elezioni del Bundestag e dei Landtage",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "in Germania",
      tone: 'semantic',
    },
    {
      german: "erlaubt?",
      translated: "consentito",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:133|kmr": [
    {
      german: "Was ist",
      translated: "çi",
      tone: 'semantic',
    },
    {
      german: "bei",
      translated: "Di",
      tone: 'semantic',
    },
    {
      german: "Bundestags- und Landtagswahlen",
      translated: "hilbijartinên Bundestag û Landtagê",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "de",
      tone: 'semantic',
    },
    {
      german: "erlaubt?",
      translated: "destûr e?",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:133|pl": [
    {
      german: "Was",
      translated: "co",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:133|prs": [
    {
      german: "Was ist",
      translated: "کدام مورد",
      tone: 'semantic',
    },
    {
      german: "bei",
      translated: "در",
      tone: 'semantic',
    },
    {
      german: "Bundestags- und Landtagswahlen",
      translated: "انتخابات بوندستاگ و پارلمان‌های ایالتی",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "آلمان",
      tone: 'semantic',
    },
    {
      german: "erlaubt?",
      translated: "مجاز است؟",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:133|ro": [
    {
      german: "Was",
      translated: "ce",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:133|ru": [
    {
      german: "Was ist",
      translated: "Что",
      tone: 'semantic',
    },
    {
      german: "bei",
      translated: "на",
      tone: 'semantic',
    },
    {
      german: "Bundestags- und Landtagswahlen",
      translated: "выборах в Бундестаг и ландтаг",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "в Германии",
      tone: 'semantic',
    },
    {
      german: "erlaubt?",
      translated: "разрешено",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:133|sq": [
    {
      german: "Was ist",
      translated: "Çfarë",
      tone: 'semantic',
    },
    {
      german: "bei",
      translated: "në",
      tone: 'semantic',
    },
    {
      german: "Bundestags- und Landtagswahlen",
      translated: "zgjedhjet për Bundestag dhe Landtag",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "në Gjermani",
      tone: 'semantic',
    },
    {
      german: "erlaubt?",
      translated: "lejohet",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:133|sr": [
    {
      german: "Was",
      translated: "šta",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:133|tr": [
    {
      german: "Was ist",
      translated: "hangisine",
      tone: 'semantic',
    },
    {
      german: "Bundestags- und Landtagswahlen",
      translated: "Federal Meclis ve eyalet meclisi",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "Almanya'da",
      tone: 'semantic',
    },
    {
      german: "erlaubt?",
      translated: "izin verilir?",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:133|uk": [
    {
      german: "Was ist",
      translated: "Що",
      tone: 'semantic',
    },
    {
      german: "bei",
      translated: "на",
      tone: 'semantic',
    },
    {
      german: "Bundestags- und Landtagswahlen",
      translated: "виборах до Бундестагу та земельних парламентів",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "у Німеччині",
      tone: 'semantic',
    },
    {
      german: "erlaubt?",
      translated: "дозволено",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:133|vi": [
    {
      german: "Was ist",
      translated: "Điều gì",
      tone: 'semantic',
    },
    {
      german: "bei",
      translated: "trong",
      tone: 'semantic',
    },
    {
      german: "Bundestags- und Landtagswahlen",
      translated: "bầu cử Bundestag và nghị viện bang",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "ở Đức",
      tone: 'semantic',
    },
    {
      german: "erlaubt?",
      translated: "được phép",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:134|ar": [
    {
      german: "Man will",
      translated: "يُراد",
      tone: 'semantic',
    },
    {
      german: "die Buslinie abschaffen",
      translated: "إلغاء خط الحافلة",
      tone: 'semantic',
    },
    {
      german: "Sie immer zur Arbeit fahren",
      translated: "تستخدمه دائمًا للذهاب إلى العمل",
      tone: 'semantic',
    },
    {
      german: "Was können Sie machen",
      translated: "ماذا يمكنك أن تفعل",
      tone: 'semantic',
    },
    {
      german: "um die Buslinie zu erhalten",
      translated: "للمحافظة على الخط",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:134|bg": [
    {
      german: "Man will",
      translated: "трябва да",
      tone: 'semantic',
    },
    {
      german: "die Buslinie abschaffen",
      translated: "бъде закрита",
      tone: 'semantic',
    },
    {
      german: "mit der",
      translated: "с която",
      tone: 'semantic',
    },
    {
      german: "Sie immer zur Arbeit fahren",
      translated: "ходите на работа",
      tone: 'semantic',
    },
    {
      german: "Was können Sie machen",
      translated: "Какво можете да направите",
      tone: 'semantic',
    },
    {
      german: "um die Buslinie zu erhalten",
      translated: "за да бъде запазена",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:134|bs": [
    {
      german: "Man will",
      translated: "treba biti",
      tone: 'semantic',
    },
    {
      german: "die Buslinie abschaffen",
      translated: "ukinuta",
      tone: 'semantic',
    },
    {
      german: "mit der",
      translated: "kojom",
      tone: 'semantic',
    },
    {
      german: "Sie immer zur Arbeit fahren",
      translated: "putujete na posao",
      tone: 'semantic',
    },
    {
      german: "Was können Sie machen",
      translated: "Što možete učiniti",
      tone: 'semantic',
    },
    {
      german: "um die Buslinie zu erhalten",
      translated: "da se zadrži",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:134|el": [
    {
      german: "die Buslinie abschaffen",
      translated: "να καταργηθεί",
      tone: 'semantic',
    },
    {
      german: "mit der",
      translated: "που",
      tone: 'semantic',
    },
    {
      german: "Sie immer zur Arbeit fahren",
      translated: "να πάτε στη δουλειά",
      tone: 'semantic',
    },
    {
      german: "Was können Sie machen",
      translated: "Τι μπορείτε να κάνετε",
      tone: 'semantic',
    },
    {
      german: "um die Buslinie zu erhalten",
      translated: "για να διατηρηθεί",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:134|en": [
    {
      german: "Man will",
      translated: "They want",
      tone: 'semantic',
    },
    {
      german: "die Buslinie abschaffen",
      translated: "abolish the bus line",
      tone: 'semantic',
    },
    {
      german: "Sie immer zur Arbeit fahren",
      translated: "you always take to work",
      tone: 'semantic',
    },
    {
      german: "Was können Sie machen",
      translated: "What can you do",
      tone: 'semantic',
    },
    {
      german: "um die Buslinie zu erhalten",
      translated: "to preserve the bus line",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:134|es": [
    {
      german: "Man will",
      translated: "Se quiere",
      tone: 'semantic',
    },
    {
      german: "die Buslinie abschaffen",
      translated: "eliminar la línea de autobús",
      tone: 'semantic',
    },
    {
      german: "mit der",
      translated: "que",
      tone: 'semantic',
    },
    {
      german: "Sie immer zur Arbeit fahren",
      translated: "utilizas siempre para ir al trabajo",
      tone: 'semantic',
    },
    {
      german: "Was können Sie machen",
      translated: "¿Qué puedes hacer",
      tone: 'semantic',
    },
    {
      german: "um die Buslinie zu erhalten",
      translated: "para conservarla",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:134|fa": [
    {
      german: "Man will",
      translated: "قرار است",
      tone: 'semantic',
    },
    {
      german: "die Buslinie abschaffen",
      translated: "حذف شود",
      tone: 'semantic',
    },
    {
      german: "Sie immer zur Arbeit fahren",
      translated: "همیشه برای رفتن به محل کار استفاده می‌کنید",
      tone: 'semantic',
    },
    {
      german: "Was können Sie machen",
      translated: "چه می‌توانید بکنید",
      tone: 'semantic',
    },
    {
      german: "um die Buslinie zu erhalten",
      translated: "برای حفظ آن",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:134|fr": [
    {
      german: "Man will",
      translated: "On veut",
      tone: 'semantic',
    },
    {
      german: "die Buslinie abschaffen",
      translated: "supprimer la ligne de bus",
      tone: 'semantic',
    },
    {
      german: "mit der",
      translated: "que",
      tone: 'semantic',
    },
    {
      german: "Sie immer zur Arbeit fahren",
      translated: "vous utilisez toujours pour aller travailler",
      tone: 'semantic',
    },
    {
      german: "Was können Sie machen",
      translated: "Que pouvez-vous faire",
      tone: 'semantic',
    },
    {
      german: "um die Buslinie zu erhalten",
      translated: "pour la conserver",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:134|hr": [
    {
      german: "Man will",
      translated: "treba",
      tone: 'semantic',
    },
    {
      german: "die Buslinie abschaffen",
      translated: "ukinuta.",
      tone: 'semantic',
    },
    {
      german: "mit der",
      translated: "kojom",
      tone: 'semantic',
    },
    {
      german: "Sie immer zur Arbeit fahren",
      translated: "putujete na posao",
      tone: 'semantic',
    },
    {
      german: "Was können Sie machen",
      translated: "Što možete učiniti",
      tone: 'semantic',
    },
    {
      german: "um die Buslinie zu erhalten",
      translated: "da se zadrži",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:134|it": [
    {
      german: "Man will",
      translated: "deve essere",
      tone: 'semantic',
    },
    {
      german: "die Buslinie abschaffen",
      translated: "soppressa",
      tone: 'semantic',
    },
    {
      german: "mit der",
      translated: "che",
      tone: 'semantic',
    },
    {
      german: "Sie immer zur Arbeit fahren",
      translated: "usate per andare al lavoro",
      tone: 'semantic',
    },
    {
      german: "Was können Sie machen",
      translated: "Che cosa potete fare",
      tone: 'semantic',
    },
    {
      german: "um die Buslinie zu erhalten",
      translated: "per conservarla",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:134|kmr": [
    {
      german: "Was",
      translated: "çi",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:134|pl": [
    {
      german: "die Buslinie abschaffen",
      translated: "zostać zlikwidowana",
      tone: 'semantic',
    },
    {
      german: "mit der",
      translated: "którą",
      tone: 'semantic',
    },
    {
      german: "Sie immer zur Arbeit fahren",
      translated: "dojeżdżacie do pracy",
      tone: 'semantic',
    },
    {
      german: "Was können Sie machen",
      translated: "Co możecie zrobić",
      tone: 'semantic',
    },
    {
      german: "um die Buslinie zu erhalten",
      translated: "aby ją zachować",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:134|prs": [
    {
      german: "Man will",
      translated: "قرار است",
      tone: 'semantic',
    },
    {
      german: "die Buslinie abschaffen",
      translated: "حذف شود",
      tone: 'semantic',
    },
    {
      german: "mit der",
      translated: "که",
      tone: 'semantic',
    },
    {
      german: "Sie immer zur Arbeit fahren",
      translated: "همیشه برای رفتن به محل کار استفاده می‌کنید",
      tone: 'semantic',
    },
    {
      german: "Was können Sie machen",
      translated: "چه می‌توانید بکنید",
      tone: 'semantic',
    },
    {
      german: "um die Buslinie zu erhalten",
      translated: "برای حفظ آن",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:134|ro": [
    {
      german: "Man will",
      translated: "urmează să fie",
      tone: 'semantic',
    },
    {
      german: "die Buslinie abschaffen",
      translated: "desființată",
      tone: 'semantic',
    },
    {
      german: "mit der",
      translated: "pe care",
      tone: 'semantic',
    },
    {
      german: "Sie immer zur Arbeit fahren",
      translated: "o folosiți pentru a merge la serviciu",
      tone: 'semantic',
    },
    {
      german: "Was können Sie machen",
      translated: "Ce puteți face",
      tone: 'semantic',
    },
    {
      german: "um die Buslinie zu erhalten",
      translated: "pentru a o păstra",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:134|ru": [
    {
      german: "Man will",
      translated: "Хотят",
      tone: 'semantic',
    },
    {
      german: "die Buslinie abschaffen",
      translated: "отменить автобусный маршрут",
      tone: 'semantic',
    },
    {
      german: "mit der",
      translated: "по которому",
      tone: 'semantic',
    },
    {
      german: "Sie immer zur Arbeit fahren",
      translated: "вы всегда ездите на работу",
      tone: 'semantic',
    },
    {
      german: "Was können Sie machen",
      translated: "Что вы можете сделать",
      tone: 'semantic',
    },
    {
      german: "um die Buslinie zu erhalten",
      translated: "чтобы сохранить этот маршрут",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:134|sq": [
    {
      german: "die Buslinie abschaffen",
      translated: "duhet të mbyllet",
      tone: 'semantic',
    },
    {
      german: "mit der",
      translated: "me të cilën",
      tone: 'semantic',
    },
    {
      german: "Sie immer zur Arbeit fahren",
      translated: "shkoni në punë",
      tone: 'semantic',
    },
    {
      german: "Was können Sie machen",
      translated: "Çfarë mund të bëni",
      tone: 'semantic',
    },
    {
      german: "um die Buslinie zu erhalten",
      translated: "që të ruhet",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:134|sr": [
    {
      german: "Man will",
      translated: "treba",
      tone: 'semantic',
    },
    {
      german: "die Buslinie abschaffen",
      translated: "biti ukinuta",
      tone: 'semantic',
    },
    {
      german: "mit der",
      translated: "kojom",
      tone: 'semantic',
    },
    {
      german: "Sie immer zur Arbeit fahren",
      translated: "putujete na posao",
      tone: 'semantic',
    },
    {
      german: "Was können Sie machen",
      translated: "Šta možete da uradite",
      tone: 'semantic',
    },
    {
      german: "um die Buslinie zu erhalten",
      translated: "da se zadrži",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:134|tr": [
    {
      german: "Man will",
      translated: "isteniyor",
      tone: 'semantic',
    },
    {
      german: "die Buslinie abschaffen",
      translated: "otobüs hattı kaldırılmak",
      tone: 'semantic',
    },
    {
      german: "Sie immer zur Arbeit fahren",
      translated: "Her zaman işe giderken",
      tone: 'semantic',
    },
    {
      german: "Was können Sie machen",
      translated: "ne yapabilirsiniz",
      tone: 'semantic',
    },
    {
      german: "um die Buslinie zu erhalten",
      translated: "Hattın korunması için",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:134|uk": [
    {
      german: "Man will",
      translated: "планують",
      tone: 'semantic',
    },
    {
      german: "die Buslinie abschaffen",
      translated: "скасувати",
      tone: 'semantic',
    },
    {
      german: "mit der",
      translated: "яким",
      tone: 'semantic',
    },
    {
      german: "Sie immer zur Arbeit fahren",
      translated: "ви завжди їздите на роботу",
      tone: 'semantic',
    },
    {
      german: "Was können Sie machen",
      translated: "Що ви можете зробити",
      tone: 'semantic',
    },
    {
      german: "um die Buslinie zu erhalten",
      translated: "щоб зберегти цей маршрут",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:134|vi": [
    {
      german: "die Buslinie abschaffen",
      translated: "sắp bị hủy",
      tone: 'semantic',
    },
    {
      german: "Sie immer zur Arbeit fahren",
      translated: "bạn dùng để đi làm",
      tone: 'semantic',
    },
    {
      german: "Was können Sie machen",
      translated: "Bạn có thể làm gì",
      tone: 'semantic',
    },
    {
      german: "um die Buslinie zu erhalten",
      translated: "để giữ tuyến xe",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:135|ar": [
    {
      german: "Wen",
      translated: "من",
      tone: 'semantic',
    },
    {
      german: "vertreten",
      translated: "تمثل",
      tone: 'semantic',
    },
    {
      german: "die Gewerkschaften",
      translated: "النقابات العمالية",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "في ألمانيا",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:135|bg": [
    {
      german: "Wen",
      translated: "Чии",
      tone: 'semantic',
    },
    {
      german: "vertreten",
      translated: "представляват",
      tone: 'semantic',
    },
    {
      german: "die Gewerkschaften",
      translated: "профсъюзите",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "в Германия",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:135|bs": [
    {
      german: "Wen",
      translated: "Čije",
      tone: 'semantic',
    },
    {
      german: "vertreten",
      translated: "zastupaju",
      tone: 'semantic',
    },
    {
      german: "die Gewerkschaften",
      translated: "sindikati",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "u Njemačkoj",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:135|el": [
    {
      german: "Wen",
      translated: "Των συμφερόντων ποιων",
      tone: 'semantic',
    },
    {
      german: "vertreten",
      translated: "είναι εκπρόσωποι",
      tone: 'semantic',
    },
    {
      german: "die Gewerkschaften",
      translated: "τα συνδικάτα",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "στη Γερμανία",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:135|en": [
    {
      german: "Wen",
      translated: "Who",
      tone: 'semantic',
    },
    {
      german: "vertreten",
      translated: "represent",
      tone: 'semantic',
    },
    {
      german: "die Gewerkschaften",
      translated: "trade unions",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "in Germany",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:135|es": [
    {
      german: "Wen",
      translated: "A quién",
      tone: 'semantic',
    },
    {
      german: "vertreten",
      translated: "representan",
      tone: 'semantic',
    },
    {
      german: "die Gewerkschaften",
      translated: "los sindicatos",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "en Alemania",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:135|fa": [
    {
      german: "Wen",
      translated: "چه کسانی",
      tone: 'semantic',
    },
    {
      german: "vertreten",
      translated: "نمایندهٔ",
      tone: 'semantic',
    },
    {
      german: "die Gewerkschaften",
      translated: "اتحادیه‌های کارگری",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "در آلمان",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:135|fr": [
    {
      german: "Wen",
      translated: "Qui",
      tone: 'semantic',
    },
    {
      german: "vertreten",
      translated: "représentent-ils",
      tone: 'semantic',
    },
    {
      german: "die Gewerkschaften",
      translated: "les syndicats",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "en Allemagne",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:135|hr": [
    {
      german: "Wen",
      translated: "Čije",
      tone: 'semantic',
    },
    {
      german: "vertreten",
      translated: "zastupaju",
      tone: 'semantic',
    },
    {
      german: "die Gewerkschaften",
      translated: "sindikati",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "u Njemačkoj",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:135|it": [
    {
      german: "Wen",
      translated: "Di chi",
      tone: 'semantic',
    },
    {
      german: "vertreten",
      translated: "rappresentano",
      tone: 'semantic',
    },
    {
      german: "die Gewerkschaften",
      translated: "i sindacati",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "in Germania",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:135|kmr": [
    {
      german: "Wen",
      translated: "kê",
      tone: 'semantic',
    },
    {
      german: "vertreten",
      translated: "nûneriya",
      tone: 'semantic',
    },
    {
      german: "die Gewerkschaften",
      translated: "Sendîka",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "li Almanyayê",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:135|pl": [
    {
      german: "Wen",
      translated: "Czyje",
      tone: 'semantic',
    },
    {
      german: "vertreten",
      translated: "reprezentują",
      tone: 'semantic',
    },
    {
      german: "die Gewerkschaften",
      translated: "związki zawodowe",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "w Niemczech",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:135|prs": [
    {
      german: "Wen",
      translated: "چه کسانی",
      tone: 'semantic',
    },
    {
      german: "vertreten",
      translated: "نمایندهٔ",
      tone: 'semantic',
    },
    {
      german: "die Gewerkschaften",
      translated: "اتحادیه‌های کارگری",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "در آلمان",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:135|ro": [
    {
      german: "Wen",
      translated: "cui",
      tone: 'semantic',
    },
    {
      german: "vertreten",
      translated: "reprezintă",
      tone: 'semantic',
    },
    {
      german: "die Gewerkschaften",
      translated: "sindicatele",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "în Germania",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:135|ru": [
    {
      german: "Wen",
      translated: "Кого",
      tone: 'semantic',
    },
    {
      german: "vertreten",
      translated: "представляют",
      tone: 'semantic',
    },
    {
      german: "die Gewerkschaften",
      translated: "профсоюзы",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "в Германии",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:135|sq": [
    {
      german: "Wen",
      translated: "kujt",
      tone: 'semantic',
    },
    {
      german: "vertreten",
      translated: "përfaqësojnë",
      tone: 'semantic',
    },
    {
      german: "die Gewerkschaften",
      translated: "sindikatat",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "në Gjermani",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:135|sr": [
    {
      german: "Wen",
      translated: "Čije",
      tone: 'semantic',
    },
    {
      german: "vertreten",
      translated: "zastupaju",
      tone: 'semantic',
    },
    {
      german: "die Gewerkschaften",
      translated: "sindikati",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "u Nemačkoj",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:135|tr": [
    {
      german: "Wen",
      translated: "kimleri",
      tone: 'semantic',
    },
    {
      german: "vertreten",
      translated: "temsil eder",
      tone: 'semantic',
    },
    {
      german: "die Gewerkschaften",
      translated: "sendikalar",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "Almanya'da",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:135|uk": [
    {
      german: "Wen",
      translated: "Чиї",
      tone: 'semantic',
    },
    {
      german: "vertreten",
      translated: "представляють",
      tone: 'semantic',
    },
    {
      german: "die Gewerkschaften",
      translated: "профспілки",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "в Німеччині",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:135|vi": [
    {
      german: "Wen",
      translated: "ai",
      tone: 'semantic',
    },
    {
      german: "vertreten",
      translated: "đại diện",
      tone: 'semantic',
    },
    {
      german: "die Gewerkschaften",
      translated: "Các công đoàn",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "ở Đức",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:136|ar": [
    {
      german: "gehen ",
      translated: "تتوجه",
      tone: 'semantic',
    },
    {
      german: "in ",
      translated: "في",
      tone: 'semantic',
    },
    {
      german: "Deutschland ",
      translated: "ألمانيا",
      tone: 'semantic',
    },
    {
      german: "zum ",
      translated: "إلى",
      tone: 'semantic',
    },
    {
      german: "Arbeitsgericht ",
      translated: "محكمة العمل",
      tone: 'semantic',
    },
    {
      german: "bei ",
      translated: "في حالة",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:136|bg": [
    {
      german: "gehen ",
      translated: "обръщате",
      tone: 'semantic',
    },
    {
      german: "in ",
      translated: "в",
      tone: 'semantic',
    },
    {
      german: "Deutschland ",
      translated: "Германия",
      tone: 'semantic',
    },
    {
      german: "zum ",
      translated: "към",
      tone: 'semantic',
    },
    {
      german: "Arbeitsgericht ",
      translated: "трудовия съд",
      tone: 'semantic',
    },
    {
      german: "bei ",
      translated: "За",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:136|bs": [
    {
      german: "in ",
      translated: "u",
      tone: 'semantic',
    },
    {
      german: "Deutschland ",
      translated: "Njemačkoj",
      tone: 'semantic',
    },
    {
      german: "Arbeitsgericht ",
      translated: "radnom sudu",
      tone: 'semantic',
    },
    {
      german: "bei ",
      translated: "problemom",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:136|el": [
    {
      german: "Deutschland ",
      translated: "Γερμανία",
      tone: 'semantic',
    },
    {
      german: "zum ",
      translated: "στο",
      tone: 'semantic',
    },
    {
      german: "Arbeitsgericht ",
      translated: "εργατικό δικαστήριο",
      tone: 'semantic',
    },
    {
      german: "bei ",
      translated: "Για",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:136|en": [
    {
      german: "Sie ",
      translated: "You ",
      tone: 'semantic',
    },
    {
      german: "gehen ",
      translated: "go ",
      tone: 'semantic',
    },
    {
      german: "in ",
      translated: "in ",
      tone: 'semantic',
    },
    {
      german: "Deutschland ",
      translated: "Germany ",
      tone: 'semantic',
    },
    {
      german: "zum ",
      translated: "to the ",
      tone: 'semantic',
    },
    {
      german: "Arbeitsgericht ",
      translated: "labor court ",
      tone: 'semantic',
    },
    {
      german: "bei ",
      translated: "for ",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:136|es": [
    {
      german: "gehen ",
      translated: "acude",
      tone: 'semantic',
    },
    {
      german: "in ",
      translated: "En",
      tone: 'semantic',
    },
    {
      german: "Deutschland ",
      translated: "Alemania",
      tone: 'semantic',
    },
    {
      german: "zum ",
      translated: "al",
      tone: 'semantic',
    },
    {
      german: "Arbeitsgericht ",
      translated: "tribunal laboral",
      tone: 'semantic',
    },
    {
      german: "bei ",
      translated: "en caso de",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:136|fa": [
    {
      german: "gehen ",
      translated: "مراجعه می‌کنید",
      tone: 'semantic',
    },
    {
      german: "Deutschland ",
      translated: "در آلمان",
      tone: 'semantic',
    },
    {
      german: "Arbeitsgericht ",
      translated: "دادگاه کار",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:136|fr": [
    {
      german: "Sie ",
      translated: "vous ",
      tone: 'semantic',
    },
    {
      german: "in ",
      translated: "En ",
      tone: 'semantic',
    },
    {
      german: "Deutschland ",
      translated: "Allemagne",
      tone: 'semantic',
    },
    {
      german: "zum ",
      translated: "au ",
      tone: 'semantic',
    },
    {
      german: "Arbeitsgericht ",
      translated: "tribunal du travail",
      tone: 'semantic',
    },
    {
      german: "bei ",
      translated: "en cas de ",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:136|hr": [
    {
      german: "gehen ",
      translated: "obraćate",
      tone: 'semantic',
    },
    {
      german: "in ",
      translated: "u",
      tone: 'semantic',
    },
    {
      german: "Deutschland ",
      translated: "Njemačkoj",
      tone: 'semantic',
    },
    {
      german: "Arbeitsgericht ",
      translated: "radnom sudu",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:136|it": [
    {
      german: "Sie ",
      translated: "ci si ",
      tone: 'semantic',
    },
    {
      german: "gehen ",
      translated: "rivolge ",
      tone: 'semantic',
    },
    {
      german: "in ",
      translated: "in ",
      tone: 'semantic',
    },
    {
      german: "Deutschland ",
      translated: "Germania?",
      tone: 'semantic',
    },
    {
      german: "zum ",
      translated: "al ",
      tone: 'semantic',
    },
    {
      german: "Arbeitsgericht ",
      translated: "tribunale del lavoro ",
      tone: 'semantic',
    },
    {
      german: "bei ",
      translated: "Per quale problema ",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:136|kmr": [
    {
      german: "Sie ",
      translated: "tu ",
      tone: 'semantic',
    },
    {
      german: "gehen ",
      translated: "diçî ",
      tone: 'semantic',
    },
    {
      german: "in ",
      translated: "Li ",
      tone: 'semantic',
    },
    {
      german: "Deutschland ",
      translated: "Almanyayê ",
      tone: 'semantic',
    },
    {
      german: "Arbeitsgericht ",
      translated: "Dadgeha Kar",
      tone: 'semantic',
    },
    {
      german: "bei ",
      translated: "ji bo ",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:136|pl": [
    {
      german: "gehen ",
      translated: "zwracacie się",
      tone: 'semantic',
    },
    {
      german: "in ",
      translated: "w",
      tone: 'semantic',
    },
    {
      german: "Deutschland ",
      translated: "Niemczech?",
      tone: 'semantic',
    },
    {
      german: "zum ",
      translated: "do",
      tone: 'semantic',
    },
    {
      german: "Arbeitsgericht ",
      translated: "sądu pracy",
      tone: 'semantic',
    },
    {
      german: "bei ",
      translated: "Z jakim problemem",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:136|prs": [
    {
      german: "gehen ",
      translated: "مراجعه",
      tone: 'semantic',
    },
    {
      german: "in ",
      translated: "در",
      tone: 'semantic',
    },
    {
      german: "Deutschland ",
      translated: "آلمان",
      tone: 'semantic',
    },
    {
      german: "zum ",
      translated: "به",
      tone: 'semantic',
    },
    {
      german: "Arbeitsgericht ",
      translated: "محکمه کار",
      tone: 'semantic',
    },
    {
      german: "bei ",
      translated: "برای",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:136|ro": [
    {
      german: "in ",
      translated: "în",
      tone: 'semantic',
    },
    {
      german: "Deutschland ",
      translated: "Germania",
      tone: 'semantic',
    },
    {
      german: "Arbeitsgericht ",
      translated: "instanței de muncă",
      tone: 'semantic',
    },
    {
      german: "bei ",
      translated: "Pentru",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:136|ru": [
    {
      german: "Sie ",
      translated: "Вы",
      tone: 'semantic',
    },
    {
      german: "gehen ",
      translated: "обращаетесь",
      tone: 'semantic',
    },
    {
      german: "Deutschland ",
      translated: "Германии",
      tone: 'semantic',
    },
    {
      german: "zum ",
      translated: "в",
      tone: 'semantic',
    },
    {
      german: "Arbeitsgericht ",
      translated: "трудовой суд",
      tone: 'semantic',
    },
    {
      german: "bei ",
      translated: "в случае",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:136|sq": [
    {
      german: "gehen ",
      translated: "drejtoheni",
      tone: 'semantic',
    },
    {
      german: "in ",
      translated: "në",
      tone: 'semantic',
    },
    {
      german: "Deutschland ",
      translated: "Gjermani",
      tone: 'semantic',
    },
    {
      german: "Arbeitsgericht ",
      translated: "gjykatës së punës",
      tone: 'semantic',
    },
    {
      german: "bei ",
      translated: "Për",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:136|sr": [
    {
      german: "gehen ",
      translated: "obraćate",
      tone: 'semantic',
    },
    {
      german: "in ",
      translated: "u",
      tone: 'semantic',
    },
    {
      german: "Deutschland ",
      translated: "Nemačkoj",
      tone: 'semantic',
    },
    {
      german: "Arbeitsgericht ",
      translated: "radnom sudu",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:136|tr": [
    {
      german: "gehen ",
      translated: "gidersiniz",
      tone: 'semantic',
    },
    {
      german: "in ",
      translated: "Almanya'da",
      tone: 'semantic',
    },
    {
      german: "Arbeitsgericht ",
      translated: "iş mahkemesine",
      tone: 'semantic',
    },
    {
      german: "bei ",
      translated: "hangi durumda",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:136|uk": [
    {
      german: "Sie ",
      translated: "ви",
      tone: 'semantic',
    },
    {
      german: "gehen ",
      translated: "звертаєтеся",
      tone: 'semantic',
    },
    {
      german: "in ",
      translated: "У",
      tone: 'semantic',
    },
    {
      german: "Deutschland ",
      translated: "Німеччині",
      tone: 'semantic',
    },
    {
      german: "zum ",
      translated: "до",
      tone: 'semantic',
    },
    {
      german: "Arbeitsgericht ",
      translated: "трудового суду",
      tone: 'semantic',
    },
    {
      german: "bei ",
      translated: "у випадку",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:136|vi": [
    {
      german: "Sie ",
      translated: "bạn",
      tone: 'semantic',
    },
    {
      german: "gehen ",
      translated: "đến",
      tone: 'semantic',
    },
    {
      german: "in ",
      translated: "ở",
      tone: 'semantic',
    },
    {
      german: "Deutschland ",
      translated: "Đức?",
      tone: 'semantic',
    },
    {
      german: "Arbeitsgericht ",
      translated: "tòa án lao động",
      tone: 'semantic',
    },
    {
      german: "bei ",
      translated: "Với vấn đề nào",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:137|ar": [
    {
      german: "Welches Gericht",
      translated: "أي محكمة",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "في ألمانيا",
      tone: 'semantic',
    },
    {
      german: "bei Konflikten",
      translated: "بالنزاعات",
      tone: 'semantic',
    },
    {
      german: "in der Arbeitswelt",
      translated: "في عالم العمل",
      tone: 'semantic',
    },
    {
      german: "zuständig",
      translated: "مختصة",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:137|bg": [
    {
      german: "Welches Gericht",
      translated: "Кой съд",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "е",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "в Германия",
      tone: 'semantic',
    },
    {
      german: "bei Konflikten",
      translated: "за спорове",
      tone: 'semantic',
    },
    {
      german: "in der Arbeitswelt",
      translated: "на работното място",
      tone: 'semantic',
    },
    {
      german: "zuständig",
      translated: "компетентен",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:137|bs": [
    {
      german: "Welches Gericht",
      translated: "Koji je sud",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "u Njemačkoj",
      tone: 'semantic',
    },
    {
      german: "bei Konflikten",
      translated: "za sporove",
      tone: 'semantic',
    },
    {
      german: "in der Arbeitswelt",
      translated: "povezane s radnim mjestom?",
      tone: 'semantic',
    },
    {
      german: "zuständig",
      translated: "nadležan",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:137|el": [
    {
      german: "Welches Gericht",
      translated: "Ποιο δικαστήριο",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "είναι",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "στη Γερμανία",
      tone: 'semantic',
    },
    {
      german: "bei Konflikten",
      translated: "για διαφορές",
      tone: 'semantic',
    },
    {
      german: "in der Arbeitswelt",
      translated: "στον χώρο εργασίας",
      tone: 'semantic',
    },
    {
      german: "zuständig",
      translated: "αρμόδιο",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:137|en": [
    {
      german: "Welches Gericht",
      translated: "Which court",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "is",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "in Germany",
      tone: 'semantic',
    },
    {
      german: "bei Konflikten",
      translated: "conflicts",
      tone: 'semantic',
    },
    {
      german: "in der Arbeitswelt",
      translated: "workplace",
      tone: 'semantic',
    },
    {
      german: "zuständig",
      translated: "responsible",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:137|es": [
    {
      german: "Welches Gericht",
      translated: "¿Qué tribunal",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "es",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "en Alemania",
      tone: 'semantic',
    },
    {
      german: "bei Konflikten",
      translated: "para los conflictos",
      tone: 'semantic',
    },
    {
      german: "in der Arbeitswelt",
      translated: "laborales",
      tone: 'semantic',
    },
    {
      german: "zuständig",
      translated: "competente",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:137|fa": [
    {
      german: "Welches Gericht",
      translated: "کدام دادگاه",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "است",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "در آلمان",
      tone: 'semantic',
    },
    {
      german: "bei Konflikten",
      translated: "اختلافات",
      tone: 'semantic',
    },
    {
      german: "in der Arbeitswelt",
      translated: "محیط کار",
      tone: 'semantic',
    },
    {
      german: "zuständig",
      translated: "مسئول",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:137|fr": [
    {
      german: "Welches Gericht",
      translated: "Quel tribunal",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "est",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "en Allemagne",
      tone: 'semantic',
    },
    {
      german: "bei Konflikten",
      translated: "pour les conflits",
      tone: 'semantic',
    },
    {
      german: "in der Arbeitswelt",
      translated: "du monde du travail",
      tone: 'semantic',
    },
    {
      german: "zuständig",
      translated: "compétent",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:137|hr": [
    {
      german: "Welches Gericht",
      translated: "Koji je sud",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "u Njemačkoj",
      tone: 'semantic',
    },
    {
      german: "bei Konflikten",
      translated: "za sporove",
      tone: 'semantic',
    },
    {
      german: "in der Arbeitswelt",
      translated: "povezane s radnim mjestom",
      tone: 'semantic',
    },
    {
      german: "zuständig",
      translated: "nadležan",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:137|it": [
    {
      german: "Welches Gericht",
      translated: "Quale tribunale",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "è",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "in Germania",
      tone: 'semantic',
    },
    {
      german: "bei Konflikten",
      translated: "per le controversie",
      tone: 'semantic',
    },
    {
      german: "in der Arbeitswelt",
      translated: "di lavoro",
      tone: 'semantic',
    },
    {
      german: "zuständig",
      translated: "competente",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:137|kmr": [
    {
      german: "Welches Gericht",
      translated: "Kîjan dadgeh",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "e",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "li Almanyayê",
      tone: 'semantic',
    },
    {
      german: "bei Konflikten",
      translated: "ji bo nakokiyên",
      tone: 'semantic',
    },
    {
      german: "in der Arbeitswelt",
      translated: "kar berpirsiyar",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:137|pl": [
    {
      german: "Welches Gericht",
      translated: "Który sąd",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "jest",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "w Niemczech",
      tone: 'semantic',
    },
    {
      german: "bei Konflikten",
      translated: "w sporach",
      tone: 'semantic',
    },
    {
      german: "in der Arbeitswelt",
      translated: "dotyczących miejsca pracy",
      tone: 'semantic',
    },
    {
      german: "zuständig",
      translated: "właściwy",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:137|prs": [
    {
      german: "Welches Gericht",
      translated: "کدام محکمه",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "است",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "در آلمان",
      tone: 'semantic',
    },
    {
      german: "bei Konflikten",
      translated: "اختلافات",
      tone: 'semantic',
    },
    {
      german: "in der Arbeitswelt",
      translated: "محیط کار",
      tone: 'semantic',
    },
    {
      german: "zuständig",
      translated: "مسئول",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:137|ro": [
    {
      german: "Welches Gericht",
      translated: "Care instanță",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "este",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "în Germania",
      tone: 'semantic',
    },
    {
      german: "bei Konflikten",
      translated: "pentru conflictele",
      tone: 'semantic',
    },
    {
      german: "in der Arbeitswelt",
      translated: "de la locul de muncă",
      tone: 'semantic',
    },
    {
      german: "zuständig",
      translated: "competentă",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:137|ru": [
    {
      german: "Welches",
      translated: "какой",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:137|sq": [
    {
      german: "Welches Gericht",
      translated: "Cila gjykatë",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "është",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "në Gjermani",
      tone: 'semantic',
    },
    {
      german: "bei Konflikten",
      translated: "për mosmarrëveshjet",
      tone: 'semantic',
    },
    {
      german: "in der Arbeitswelt",
      translated: "në vendin e punës",
      tone: 'semantic',
    },
    {
      german: "zuständig",
      translated: "përgjegjëse",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:137|sr": [
    {
      german: "Welches Gericht",
      translated: "Koji je sud",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "u Nemačkoj",
      tone: 'semantic',
    },
    {
      german: "bei Konflikten",
      translated: "za sporove",
      tone: 'semantic',
    },
    {
      german: "in der Arbeitswelt",
      translated: "povezane s radnim mjestom",
      tone: 'semantic',
    },
    {
      german: "zuständig",
      translated: "nadležan",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:137|tr": [
    {
      german: "Welches Gericht",
      translated: "hangi mahkeme",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "Almanya'da",
      tone: 'semantic',
    },
    {
      german: "bei Konflikten",
      translated: "uyuşmazlıklardan",
      tone: 'semantic',
    },
    {
      german: "in der Arbeitswelt",
      translated: "çalışma hayatındaki",
      tone: 'semantic',
    },
    {
      german: "zuständig",
      translated: "sorumludur",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:137|uk": [
    {
      german: "Welches Gericht",
      translated: "Який суд",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "у Німеччині",
      tone: 'semantic',
    },
    {
      german: "bei Konflikten",
      translated: "за конфлікти",
      tone: 'semantic',
    },
    {
      german: "in der Arbeitswelt",
      translated: "у сфері трудових відносин",
      tone: 'semantic',
    },
    {
      german: "zuständig",
      translated: "відповідає",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:137|vi": [
    {
      german: "Welches Gericht",
      translated: "Tòa án nào",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "có",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "ở Đức",
      tone: 'semantic',
    },
    {
      german: "bei Konflikten",
      translated: "đối với tranh chấp",
      tone: 'semantic',
    },
    {
      german: "in der Arbeitswelt",
      translated: "tại nơi làm việc",
      tone: 'semantic',
    },
    {
      german: "zuständig",
      translated: "thẩm quyền",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:138|ar": [
    {
      german: "wenn",
      translated: "إذا",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:138|bg": [
    {
      german: "Was",
      translated: "какво",
      tone: 'semantic',
    },
    {
      german: "wenn",
      translated: "ако",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:138|bs": [
    {
      german: "wenn",
      translated: "ako",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:138|el": [
    {
      german: "wenn",
      translated: "αν",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:138|en": [
    {
      german: "Was",
      translated: "what",
      tone: 'semantic',
    },
    {
      german: "wenn",
      translated: "if",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:138|es": [
    {
      german: "Was",
      translated: "¿qué",
      tone: 'semantic',
    },
    {
      german: "wenn",
      translated: "si",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:138|fa": [
    {
      german: "wenn",
      translated: "اگر",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:138|fr": [
    {
      german: "wenn",
      translated: "si",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:138|hr": [
    {
      german: "Was",
      translated: "što",
      tone: 'semantic',
    },
    {
      german: "wenn",
      translated: "ako",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:138|it": [
    {
      german: "Was",
      translated: "cosa",
      tone: 'semantic',
    },
    {
      german: "wenn",
      translated: "se",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:138|kmr": [
    {
      german: "Was",
      translated: "çi",
      tone: 'semantic',
    },
    {
      german: "wenn",
      translated: "heke",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:138|pl": [
    {
      german: "Was",
      translated: "co",
      tone: 'semantic',
    },
    {
      german: "wenn",
      translated: "jeśli",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:138|prs": [
    {
      german: "wenn",
      translated: "اگر",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:138|ro": [
    {
      german: "Was",
      translated: "ce",
      tone: 'semantic',
    },
    {
      german: "wenn",
      translated: "dacă",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:138|ru": [
    {
      german: "Was",
      translated: "что",
      tone: 'semantic',
    },
    {
      german: "wenn",
      translated: "если",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:138|sq": [
    {
      german: "Was",
      translated: "çfarë",
      tone: 'semantic',
    },
    {
      german: "wenn",
      translated: "nëse",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:138|sr": [
    {
      german: "Was",
      translated: "šta",
      tone: 'semantic',
    },
    {
      german: "wenn",
      translated: "ako",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:138|tr": [
    {
      german: "Was",
      translated: "ne",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:138|uk": [
    {
      german: "Was",
      translated: "що",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:138|vi": [
    {
      german: "Was",
      translated: "gì?",
      tone: 'semantic',
    },
    {
      german: "wenn",
      translated: "nếu",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:139|ar": [
    {
      german: "Wann kommt es",
      translated: "متى تُقام",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "في ألمانيا",
      tone: 'semantic',
    },
    {
      german: "zu einem Prozess",
      translated: "محاكمة",
      tone: 'semantic',
    },
    {
      german: "vor Gericht",
      translated: "أمام المحكمة",
      tone: 'semantic',
    },
    {
      german: "Wenn jemand",
      translated: "عندما",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:139|bg": [
    {
      german: "Wann kommt es",
      translated: "Кога се провежда",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "в Германия",
      tone: 'semantic',
    },
    {
      german: "zu einem Prozess",
      translated: "съдебен процес",
      tone: 'semantic',
    },
    {
      german: "Wenn jemand",
      translated: "Когато човек",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:139|bs": [
    {
      german: "Wann kommt es",
      translated: "Kada se",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "u Njemačkoj",
      tone: 'semantic',
    },
    {
      german: "zu einem Prozess",
      translated: "sudski postupak",
      tone: 'semantic',
    },
    {
      german: "Wenn jemand",
      translated: "Kada osoba",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:139|el": [
    {
      german: "Wann kommt es",
      translated: "Πότε διεξάγεται",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "στη Γερμανία",
      tone: 'semantic',
    },
    {
      german: "zu einem Prozess",
      translated: "δίκη",
      tone: 'semantic',
    },
    {
      german: "vor Gericht",
      translated: "σε δικαστήριο",
      tone: 'semantic',
    },
    {
      german: "Wenn jemand",
      translated: "Όταν ένα άτομο",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:139|en": [
    {
      german: "Wann kommt es",
      translated: "When does",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "in Germany",
      tone: 'semantic',
    },
    {
      german: "zu einem Prozess",
      translated: "a court case",
      tone: 'semantic',
    },
    {
      german: "vor Gericht",
      translated: "occur",
      tone: 'semantic',
    },
    {
      german: "Wenn jemand",
      translated: "When someone",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:139|es": [
    {
      german: "Wann kommt es",
      translated: "¿Cuándo se celebra",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "en Alemania",
      tone: 'semantic',
    },
    {
      german: "zu einem Prozess",
      translated: "un proceso",
      tone: 'semantic',
    },
    {
      german: "vor Gericht",
      translated: "judicial",
      tone: 'semantic',
    },
    {
      german: "Wenn jemand",
      translated: "Cuando alguien",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:139|fa": [
    {
      german: "Wann kommt es",
      translated: "چه زمانی",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "در آلمان",
      tone: 'semantic',
    },
    {
      german: "zu einem Prozess",
      translated: "محاکمه",
      tone: 'semantic',
    },
    {
      german: "vor Gericht",
      translated: "در دادگاه",
      tone: 'semantic',
    },
    {
      german: "Wenn jemand",
      translated: "وقتی شخصی",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:139|fr": [
    {
      german: "Wann kommt es",
      translated: "Quand y a-t-il",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "en Allemagne",
      tone: 'semantic',
    },
    {
      german: "zu einem Prozess",
      translated: "un procès",
      tone: 'semantic',
    },
    {
      german: "vor Gericht",
      translated: "devant un tribunal",
      tone: 'semantic',
    },
    {
      german: "Wenn jemand",
      translated: "Lorsqu’une personne",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:139|hr": [
    {
      german: "Wann kommt es",
      translated: "Kada se",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "u Njemačkoj",
      tone: 'semantic',
    },
    {
      german: "zu einem Prozess",
      translated: "postupak",
      tone: 'semantic',
    },
    {
      german: "vor Gericht",
      translated: "sudski",
      tone: 'semantic',
    },
    {
      german: "Wenn jemand",
      translated: "Kada osoba",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:139|it": [
    {
      german: "Wann kommt es",
      translated: "Quando si svolge",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "in Germania",
      tone: 'semantic',
    },
    {
      german: "zu einem Prozess",
      translated: "un processo",
      tone: 'semantic',
    },
    {
      german: "vor Gericht",
      translated: "davanti a un tribunale",
      tone: 'semantic',
    },
    {
      german: "Wenn jemand",
      translated: "Quando una persona",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:139|kmr": [
    {
      german: "Wann kommt es",
      translated: "kengê dozek",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "Li Almanyayê",
      tone: 'semantic',
    },
    {
      german: "zu einem Prozess",
      translated: "dadgehê",
      tone: 'semantic',
    },
    {
      german: "vor Gericht",
      translated: "çêdibe?",
      tone: 'semantic',
    },
    {
      german: "Wenn jemand",
      translated: "Dema ku kesek",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:139|pl": [
    {
      german: "Wann kommt es",
      translated: "Kiedy",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "w Niemczech",
      tone: 'semantic',
    },
    {
      german: "zu einem Prozess",
      translated: "proces",
      tone: 'semantic',
    },
    {
      german: "vor Gericht",
      translated: "sądowy",
      tone: 'semantic',
    },
    {
      german: "Wenn jemand",
      translated: "Gdy osoba",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:139|prs": [
    {
      german: "Wann kommt es",
      translated: "چه زمانی",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "در آلمان",
      tone: 'semantic',
    },
    {
      german: "zu einem Prozess",
      translated: "محاکمه",
      tone: 'semantic',
    },
    {
      german: "vor Gericht",
      translated: "در محکمه",
      tone: 'semantic',
    },
    {
      german: "Wenn jemand",
      translated: "وقتی شخصی",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:139|ro": [
    {
      german: "Wann kommt es",
      translated: "Când are loc",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "în Germania",
      tone: 'semantic',
    },
    {
      german: "zu einem Prozess",
      translated: "un proces",
      tone: 'semantic',
    },
    {
      german: "vor Gericht",
      translated: "în instanță",
      tone: 'semantic',
    },
    {
      german: "Wenn jemand",
      translated: "Când o persoană",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:139|ru": [
    {
      german: "Wann kommt es",
      translated: "Когда",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "в Германии",
      tone: 'semantic',
    },
    {
      german: "zu einem Prozess",
      translated: "до судебного процесса",
      tone: 'semantic',
    },
    {
      german: "Wenn jemand",
      translated: "Когда кто-то",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:139|sq": [
    {
      german: "Wann kommt es",
      translated: "Kur zhvillohet",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "në Gjermani",
      tone: 'semantic',
    },
    {
      german: "zu einem Prozess",
      translated: "një proces",
      tone: 'semantic',
    },
    {
      german: "vor Gericht",
      translated: "gjyqësor",
      tone: 'semantic',
    },
    {
      german: "Wenn jemand",
      translated: "Kur një person",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:139|sr": [
    {
      german: "Wann kommt es",
      translated: "Kada se",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "u Nemačkoj",
      tone: 'semantic',
    },
    {
      german: "zu einem Prozess",
      translated: "postupak",
      tone: 'semantic',
    },
    {
      german: "vor Gericht",
      translated: "sudski",
      tone: 'semantic',
    },
    {
      german: "Wenn jemand",
      translated: "Kada osoba",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:139|tr": [
    {
      german: "Wann kommt es",
      translated: "hangi durumda",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "Almanya'da",
      tone: 'semantic',
    },
    {
      german: "zu einem Prozess",
      translated: "dava",
      tone: 'semantic',
    },
    {
      german: "vor Gericht",
      translated: "mahkemede",
      tone: 'semantic',
    },
    {
      german: "Wenn jemand",
      translated: "Bir kişi",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:139|uk": [
    {
      german: "Wann kommt es",
      translated: "Коли",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "в Німеччині",
      tone: 'semantic',
    },
    {
      german: "zu einem Prozess",
      translated: "процесу",
      tone: 'semantic',
    },
    {
      german: "vor Gericht",
      translated: "судового",
      tone: 'semantic',
    },
    {
      german: "Wenn jemand",
      translated: "Коли хтось",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:139|vi": [
    {
      german: "Wann kommt es",
      translated: "Khi nào",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "ở Đức",
      tone: 'semantic',
    },
    {
      german: "zu einem Prozess",
      translated: "một phiên tòa",
      tone: 'semantic',
    },
    {
      german: "vor Gericht",
      translated: "được tiến hành",
      tone: 'semantic',
    },
    {
      german: "Wenn jemand",
      translated: "Khi một người",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:13|ar": [
    {
      german: "Im Parlament",
      translated: "في البرلمان",
      tone: 'semantic',
    },
    {
      german: "steht",
      translated: "يشير",
      tone: 'semantic',
    },
    {
      german: "der Begriff",
      translated: "مصطلح",
      tone: 'semantic',
    },
    {
      german: "\"Opposition\"",
      translated: "«المعارضة»",
      tone: 'semantic',
    },
    {
      german: "für",
      translated: "إلى",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:13|bg": [
    {
      german: "Im Parlament",
      translated: "в парламента",
      tone: 'semantic',
    },
    {
      german: "steht",
      translated: "означава",
      tone: 'semantic',
    },
    {
      german: "der Begriff",
      translated: "понятието",
      tone: 'semantic',
    },
    {
      german: "\"Opposition\"",
      translated: "„опозиция“",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:13|bs": [
    {
      german: "Im Parlament",
      translated: "u parlamentu",
      tone: 'semantic',
    },
    {
      german: "steht",
      translated: "znači",
      tone: 'semantic',
    },
    {
      german: "der Begriff",
      translated: "pojam",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:13|el": [
    {
      german: "Im Parlament",
      translated: "στο κοινοβούλιο",
      tone: 'semantic',
    },
    {
      german: "steht",
      translated: "σημαίνει",
      tone: 'semantic',
    },
    {
      german: "der Begriff",
      translated: "ο όρος",
      tone: 'semantic',
    },
    {
      german: "\"Opposition\"",
      translated: "«αντιπολίτευση»",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:13|en": [
    {
      german: "Im Parlament",
      translated: "In parliament",
      tone: 'semantic',
    },
    {
      german: "steht",
      translated: "refers",
      tone: 'semantic',
    },
    {
      german: "der Begriff",
      translated: "the term",
      tone: 'semantic',
    },
    {
      german: "\"Opposition\"",
      translated: "'opposition'",
      tone: 'semantic',
    },
    {
      german: "für",
      translated: "to",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:13|es": [
    {
      german: "Im Parlament",
      translated: "En el Parlamento",
      tone: 'semantic',
    },
    {
      german: "steht",
      translated: "se refiere",
      tone: 'semantic',
    },
    {
      german: "der Begriff",
      translated: "el término",
      tone: 'semantic',
    },
    {
      german: "\"Opposition\"",
      translated: "\"oposición\"",
      tone: 'semantic',
    },
    {
      german: "für",
      translated: "a",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:13|fa": [
    {
      german: "Im Parlament",
      translated: "در پارلمان",
      tone: 'semantic',
    },
    {
      german: "steht",
      translated: "معناست",
      tone: 'semantic',
    },
    {
      german: "der Begriff",
      translated: "اصطلاح",
      tone: 'semantic',
    },
    {
      german: "\"Opposition\"",
      translated: "اپوزیسیون",
      tone: 'semantic',
    },
    {
      german: "für",
      translated: "به چه",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:13|fr": [
    {
      german: "Im Parlament",
      translated: "Au Parlement",
      tone: 'semantic',
    },
    {
      german: "der Begriff",
      translated: "le terme",
      tone: 'semantic',
    },
    {
      german: "\"Opposition\"",
      translated: "« opposition »",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:13|hr": [
    {
      german: "Im Parlament",
      translated: "u parlamentu",
      tone: 'semantic',
    },
    {
      german: "steht",
      translated: "znači",
      tone: 'semantic',
    },
    {
      german: "der Begriff",
      translated: "pojam",
      tone: 'semantic',
    },
    {
      german: "\"Opposition\"",
      translated: "„oporba“",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:13|it": [
    {
      german: "Im Parlament",
      translated: "in Parlamento",
      tone: 'semantic',
    },
    {
      german: "steht",
      translated: "significa",
      tone: 'semantic',
    },
    {
      german: "der Begriff",
      translated: "il termine",
      tone: 'semantic',
    },
    {
      german: "\"Opposition\"",
      translated: "«opposizione»",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:13|kmr": [
    {
      german: "Im Parlament",
      translated: "Di parlamentoyê de",
      tone: 'semantic',
    },
    {
      german: "steht",
      translated: "tê",
      tone: 'semantic',
    },
    {
      german: "der Begriff",
      translated: "peyva",
      tone: 'semantic',
    },
    {
      german: "\"Opposition\"",
      translated: "«opozîsyon»",
      tone: 'semantic',
    },
    {
      german: "für",
      translated: "çi wateyê",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:13|pl": [
    {
      german: "Im Parlament",
      translated: "w parlamencie",
      tone: 'semantic',
    },
    {
      german: "steht",
      translated: "oznacza",
      tone: 'semantic',
    },
    {
      german: "der Begriff",
      translated: "pojęcie",
      tone: 'semantic',
    },
    {
      german: "\"Opposition\"",
      translated: "opozycja",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:13|prs": [
    {
      german: "Im Parlament",
      translated: "در پارلمان",
      tone: 'semantic',
    },
    {
      german: "steht",
      translated: "معناست",
      tone: 'semantic',
    },
    {
      german: "der Begriff",
      translated: "اصطلاح",
      tone: 'semantic',
    },
    {
      german: "\"Opposition\"",
      translated: "«اپوزیسیون»",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:13|ro": [
    {
      german: "Im Parlament",
      translated: "în parlament",
      tone: 'semantic',
    },
    {
      german: "steht",
      translated: "înseamnă",
      tone: 'semantic',
    },
    {
      german: "der Begriff",
      translated: "termenul",
      tone: 'semantic',
    },
    {
      german: "\"Opposition\"",
      translated: "opoziție",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:13|ru": [
    {
      german: "Im Parlament",
      translated: "В парламенте",
      tone: 'semantic',
    },
    {
      german: "steht",
      translated: "обозначает",
      tone: 'semantic',
    },
    {
      german: "der Begriff",
      translated: "понятие",
      tone: 'semantic',
    },
    {
      german: "\"Opposition\"",
      translated: "«оппозиция»",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:13|sq": [
    {
      german: "Im Parlament",
      translated: "në parlament",
      tone: 'semantic',
    },
    {
      german: "steht",
      translated: "do të thotë",
      tone: 'semantic',
    },
    {
      german: "der Begriff",
      translated: "termi",
      tone: 'semantic',
    },
    {
      german: "\"Opposition\"",
      translated: "«opozitë»",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:13|sr": [
    {
      german: "Im Parlament",
      translated: "u parlamentu",
      tone: 'semantic',
    },
    {
      german: "steht",
      translated: "znači",
      tone: 'semantic',
    },
    {
      german: "der Begriff",
      translated: "pojam",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:13|tr": [
    {
      german: "Im Parlament",
      translated: "Parlamentoda",
      tone: 'semantic',
    },
    {
      german: "steht",
      translated: "ifade",
      tone: 'semantic',
    },
    {
      german: "der Begriff",
      translated: "kavramı",
      tone: 'semantic',
    },
    {
      german: "\"Opposition\"",
      translated: "(Opposition)",
      tone: 'semantic',
    },
    {
      german: "für",
      translated: "eder",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:13|uk": [
    {
      german: "Im Parlament",
      translated: "в парламенті",
      tone: 'semantic',
    },
    {
      german: "steht",
      translated: "означає",
      tone: 'semantic',
    },
    {
      german: "der Begriff",
      translated: "поняття",
      tone: 'semantic',
    },
    {
      german: "\"Opposition\"",
      translated: "«опозиція»",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:13|vi": [
    {
      german: "Im Parlament",
      translated: "trong nghị viện",
      tone: 'semantic',
    },
    {
      german: "steht",
      translated: "có nghĩa",
      tone: 'semantic',
    },
    {
      german: "der Begriff",
      translated: "Thuật ngữ",
      tone: 'semantic',
    },
    {
      german: "\"Opposition\"",
      translated: "“phe đối lập”",
      tone: 'semantic',
    },
    {
      german: "für",
      translated: "là",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:140|ar": [
    {
      german: "Was macht",
      translated: "ماذا يفعل",
      tone: 'semantic',
    },
    {
      german: "eine Schöffin/ein Schöffe",
      translated: "القاضي الشعبي (Schöffe)",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "في ألمانيا",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:140|bg": [
    {
      german: "Was macht",
      translated: "Какво прави",
      tone: 'semantic',
    },
    {
      german: "eine Schöffin/ein Schöffe",
      translated: "съдебен заседател",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "в Германия",
      tone: 'semantic',
    },
    {
      german: "Sie/Er",
      translated: "Той",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:140|bs": [
    {
      german: "Was macht",
      translated: "Šta radi",
      tone: 'semantic',
    },
    {
      german: "eine Schöffin/ein Schöffe",
      translated: "sudija porotnik (Schöffe)",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "u Njemačkoj",
      tone: 'semantic',
    },
    {
      german: "Sie/Er",
      translated: "Ona/On",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:140|el": [
    {
      german: "Was macht",
      translated: "Τι κάνει",
      tone: 'semantic',
    },
    {
      german: "eine Schöffin/ein Schöffe",
      translated: "ένας λαϊκός δικαστής (Schöffe)",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "στη Γερμανία",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:140|en": [
    {
      german: "Was macht",
      translated: "What does",
      tone: 'semantic',
    },
    {
      german: "eine Schöffin/ein Schöffe",
      translated: "a lay judge",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "in Germany",
      tone: 'semantic',
    },
    {
      german: "Sie/Er",
      translated: "He/She",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:140|es": [
    {
      german: "Was macht",
      translated: "¿Qué hace",
      tone: 'semantic',
    },
    {
      german: "eine Schöffin/ein Schöffe",
      translated: "un juez lego (Schöffe)",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "en Alemania",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:140|fa": [
    {
      german: "Was macht",
      translated: "چه کاری انجام می‌دهد؟",
      tone: 'semantic',
    },
    {
      german: "eine Schöffin/ein Schöffe",
      translated: "یک قاضی افتخاری (Schöffe)",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "در آلمان",
      tone: 'semantic',
    },
    {
      german: "Sie/Er",
      translated: "او",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:140|fr": [
    {
      german: "Was macht",
      translated: "Que fait",
      tone: 'semantic',
    },
    {
      german: "eine Schöffin/ein Schöffe",
      translated: "un juge non professionnel (Schöffe)",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "en Allemagne",
      tone: 'semantic',
    },
    {
      german: "Sie/Er",
      translated: "Il ou elle",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:140|hr": [
    {
      german: "Was macht",
      translated: "Što radi",
      tone: 'semantic',
    },
    {
      german: "eine Schöffin/ein Schöffe",
      translated: "sudac porotnik (Schöffe)",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "u Njemačkoj",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:140|it": [
    {
      german: "Was macht",
      translated: "Che cosa fa",
      tone: 'semantic',
    },
    {
      german: "eine Schöffin/ein Schöffe",
      translated: "un giudice laico (Schöffe)",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "in Germania",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:140|kmr": [
    {
      german: "Was macht",
      translated: "çi dike?",
      tone: 'semantic',
    },
    {
      german: "eine Schöffin/ein Schöffe",
      translated: "Schöffe",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "li Almanyayê",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:140|pl": [
    {
      german: "Was macht",
      translated: "Co robi",
      tone: 'semantic',
    },
    {
      german: "eine Schöffin/ein Schöffe",
      translated: "ławnik (Schöffe)",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "w Niemczech",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:140|prs": [
    {
      german: "Was macht",
      translated: "چه کاری انجام می‌دهد؟",
      tone: 'semantic',
    },
    {
      german: "eine Schöffin/ein Schöffe",
      translated: "یک قاضی افتخاری (Schöffe)",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "در آلمان",
      tone: 'semantic',
    },
    {
      german: "Sie/Er",
      translated: "او",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:140|ro": [
    {
      german: "Was macht",
      translated: "Ce face",
      tone: 'semantic',
    },
    {
      german: "eine Schöffin/ein Schöffe",
      translated: "un judecător laic (Schöffe)",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "în Germania",
      tone: 'semantic',
    },
    {
      german: "Sie/Er",
      translated: "El",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:140|ru": [
    {
      german: "Was macht",
      translated: "Что делает",
      tone: 'semantic',
    },
    {
      german: "eine Schöffin/ein Schöffe",
      translated: "шеффен (народный заседатель)",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "в Германии",
      tone: 'semantic',
    },
    {
      german: "Sie/Er",
      translated: "Он/она",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:140|sq": [
    {
      german: "Was macht",
      translated: "Çfarë bën",
      tone: 'semantic',
    },
    {
      german: "eine Schöffin/ein Schöffe",
      translated: "një gjyqtar laik",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "në Gjermani",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:140|sr": [
    {
      german: "Was macht",
      translated: "Šta radi",
      tone: 'semantic',
    },
    {
      german: "eine Schöffin/ein Schöffe",
      translated: "porotnik",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "u Nemačkoj?",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:140|tr": [
    {
      german: "Was macht",
      translated: "ne yapar?",
      tone: 'semantic',
    },
    {
      german: "eine Schöffin/ein Schöffe",
      translated: "fahri hâkim (Schöffe)",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "Almanya'da",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:140|uk": [
    {
      german: "Was macht",
      translated: "Що робить",
      tone: 'semantic',
    },
    {
      german: "eine Schöffin/ein Schöffe",
      translated: "шеффен/шеффенка (Schöffe)",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "в Німеччині",
      tone: 'semantic',
    },
    {
      german: "Sie/Er",
      translated: "Він/вона",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:140|vi": [
    {
      german: "Was macht",
      translated: "làm gì?",
      tone: 'semantic',
    },
    {
      german: "eine Schöffin/ein Schöffe",
      translated: "Một thẩm phán nhân dân (Schöffe)",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "ở Đức",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:141|ar": [
    {
      german: "Wer",
      translated: "من",
      tone: 'semantic',
    },
    {
      german: "berät",
      translated: "يقدم",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "في ألمانيا",
      tone: 'semantic',
    },
    {
      german: "Personen",
      translated: "للأشخاص",
      tone: 'semantic',
    },
    {
      german: "bei Rechtsfragen",
      translated: "في المسائل القانونية",
      tone: 'semantic',
    },
    {
      german: "vor Gericht",
      translated: "أمام المحكمة؟",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:141|bg": [
    {
      german: "in Deutschland",
      translated: "в Германия",
      tone: 'semantic',
    },
    {
      german: "bei Rechtsfragen",
      translated: "по правни въпроси",
      tone: 'semantic',
    },
    {
      german: "vor Gericht",
      translated: "пред съда",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:141|bs": [
    {
      german: "Wer",
      translated: "Ko",
      tone: 'semantic',
    },
    {
      german: "berät",
      translated: "savjetuje",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "u Njemačkoj",
      tone: 'semantic',
    },
    {
      german: "Personen",
      translated: "osobe",
      tone: 'semantic',
    },
    {
      german: "bei Rechtsfragen",
      translated: "o pravnim pitanjima",
      tone: 'semantic',
    },
    {
      german: "und",
      translated: "i",
      tone: 'semantic',
    },
    {
      german: "vertritt",
      translated: "zastupa",
      tone: 'semantic',
    },
    {
      german: "sie",
      translated: "ih",
      tone: 'semantic',
    },
    {
      german: "vor Gericht",
      translated: "pred sudom",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:141|el": [
    {
      german: "Wer",
      translated: "Ποιος",
      tone: 'semantic',
    },
    {
      german: "berät",
      translated: "συμβουλεύει",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "στη Γερμανία",
      tone: 'semantic',
    },
    {
      german: "Personen",
      translated: "ανθρώπους",
      tone: 'semantic',
    },
    {
      german: "bei Rechtsfragen",
      translated: "για νομικά ζητήματα",
      tone: 'semantic',
    },
    {
      german: "und",
      translated: "και",
      tone: 'semantic',
    },
    {
      german: "vertritt",
      translated: "εκπροσωπεί",
      tone: 'semantic',
    },
    {
      german: "sie",
      translated: "τους",
      tone: 'semantic',
    },
    {
      german: "vor Gericht",
      translated: "ενώπιον δικαστηρίου;",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:141|en": [
    {
      german: "Wer",
      translated: "who",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:141|es": [
    {
      german: "Wer",
      translated: "¿quién",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:141|fa": [
    {
      german: "Wer",
      translated: "چه کسی",
      tone: 'semantic',
    },
    {
      german: "berät",
      translated: "مشاوره می‌دهد",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "در آلمان",
      tone: 'semantic',
    },
    {
      german: "Personen",
      translated: "افراد",
      tone: 'semantic',
    },
    {
      german: "bei Rechtsfragen",
      translated: "دربارهٔ مسائل حقوقی",
      tone: 'semantic',
    },
    {
      german: "und",
      translated: "و",
      tone: 'semantic',
    },
    {
      german: "vertritt",
      translated: "نمایندگی می‌کند؟",
      tone: 'semantic',
    },
    {
      german: "sie",
      translated: "آن‌ها",
      tone: 'semantic',
    },
    {
      german: "vor Gericht",
      translated: "در دادگاه",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:141|fr": [
    {
      german: "Wer",
      translated: "qui",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:141|hr": [
    {
      german: "Wer",
      translated: "Tko",
      tone: 'semantic',
    },
    {
      german: "berät",
      translated: "savjetuje",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "u Njemačkoj",
      tone: 'semantic',
    },
    {
      german: "Personen",
      translated: "osobe",
      tone: 'semantic',
    },
    {
      german: "bei Rechtsfragen",
      translated: "o pravnim pitanjima",
      tone: 'semantic',
    },
    {
      german: "vertritt",
      translated: "zastupa",
      tone: 'semantic',
    },
    {
      german: "sie",
      translated: "ih",
      tone: 'semantic',
    },
    {
      german: "vor Gericht",
      translated: "pred sudom",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:141|it": [
    {
      german: "Wer",
      translated: "Chi",
      tone: 'semantic',
    },
    {
      german: "berät",
      translated: "fornisce consulenza",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "in Germania",
      tone: 'semantic',
    },
    {
      german: "Personen",
      translated: "alle persone",
      tone: 'semantic',
    },
    {
      german: "bei Rechtsfragen",
      translated: "su questioni giuridiche",
      tone: 'semantic',
    },
    {
      german: "und",
      translated: "e",
      tone: 'semantic',
    },
    {
      german: "vertritt",
      translated: "rappresenta",
      tone: 'semantic',
    },
    {
      german: "sie",
      translated: "le",
      tone: 'semantic',
    },
    {
      german: "vor Gericht",
      translated: "davanti a un tribunale",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:141|kmr": [
    {
      german: "Wer",
      translated: "kî",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:141|pl": [
    {
      german: "Wer",
      translated: "Kto",
      tone: 'semantic',
    },
    {
      german: "berät",
      translated: "doradza",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "w Niemczech",
      tone: 'semantic',
    },
    {
      german: "Personen",
      translated: "osobom",
      tone: 'semantic',
    },
    {
      german: "bei Rechtsfragen",
      translated: "w kwestiach prawnych",
      tone: 'semantic',
    },
    {
      german: "und",
      translated: "i",
      tone: 'semantic',
    },
    {
      german: "vertritt",
      translated: "reprezentuje",
      tone: 'semantic',
    },
    {
      german: "sie",
      translated: "je",
      tone: 'semantic',
    },
    {
      german: "vor Gericht",
      translated: "przed sądem",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:141|prs": [
    {
      german: "Wer",
      translated: "چه کسی",
      tone: 'semantic',
    },
    {
      german: "berät",
      translated: "مشوره می‌دهد",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "در آلمان",
      tone: 'semantic',
    },
    {
      german: "Personen",
      translated: "افراد",
      tone: 'semantic',
    },
    {
      german: "bei Rechtsfragen",
      translated: "مسائل حقوقی",
      tone: 'semantic',
    },
    {
      german: "vertritt",
      translated: "نمایندگی می‌کند",
      tone: 'semantic',
    },
    {
      german: "sie",
      translated: "آنان",
      tone: 'semantic',
    },
    {
      german: "vor Gericht",
      translated: "در محکمه",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:141|ro": [
    {
      german: "Wer",
      translated: "Cine",
      tone: 'semantic',
    },
    {
      german: "berät",
      translated: "consiliază",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "în Germania",
      tone: 'semantic',
    },
    {
      german: "Personen",
      translated: "persoanele",
      tone: 'semantic',
    },
    {
      german: "bei Rechtsfragen",
      translated: "în probleme juridice",
      tone: 'semantic',
    },
    {
      german: "und",
      translated: "și",
      tone: 'semantic',
    },
    {
      german: "vertritt",
      translated: "le reprezintă",
      tone: 'semantic',
    },
    {
      german: "vor Gericht",
      translated: "în fața instanței",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:141|ru": [
    {
      german: "Wer",
      translated: "кто",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:141|sq": [
    {
      german: "Wer",
      translated: "Kush",
      tone: 'semantic',
    },
    {
      german: "berät",
      translated: "këshillon",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "në Gjermani",
      tone: 'semantic',
    },
    {
      german: "Personen",
      translated: "persona",
      tone: 'semantic',
    },
    {
      german: "bei Rechtsfragen",
      translated: "për çështje juridike",
      tone: 'semantic',
    },
    {
      german: "und",
      translated: "dhe",
      tone: 'semantic',
    },
    {
      german: "vertritt",
      translated: "përfaqëson",
      tone: 'semantic',
    },
    {
      german: "sie",
      translated: "ata",
      tone: 'semantic',
    },
    {
      german: "vor Gericht",
      translated: "para gjykatës",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:141|sr": [
    {
      german: "Wer",
      translated: "ko",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:141|tr": [
    {
      german: "Wer",
      translated: "kimdir?",
      tone: 'semantic',
    },
    {
      german: "berät",
      translated: "danışmanlık yapan",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "Almanya'da",
      tone: 'semantic',
    },
    {
      german: "Personen",
      translated: "kişilere",
      tone: 'semantic',
    },
    {
      german: "bei Rechtsfragen",
      translated: "hukuki konularda",
      tone: 'semantic',
    },
    {
      german: "und",
      translated: "ve",
      tone: 'semantic',
    },
    {
      german: "vertritt",
      translated: "temsil eden",
      tone: 'semantic',
    },
    {
      german: "sie",
      translated: "onları",
      tone: 'semantic',
    },
    {
      german: "vor Gericht",
      translated: "mahkemede",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:141|uk": [
    {
      german: "Wer",
      translated: "хто",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:141|vi": [
    {
      german: "Wer",
      translated: "ai",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:142|ar": [
    {
      german: "Was ist die Hauptaufgabe",
      translated: "ما المهمة الرئيسية",
      tone: 'semantic',
    },
    {
      german: "einer Richterin/eines Richters",
      translated: "للقاضي",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "في ألمانيا",
      tone: 'semantic',
    },
    {
      german: "Eine Richterin/ein Richter",
      translated: "القاضي",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:142|bg": [
    {
      german: "in Deutschland",
      translated: "в Германия",
      tone: 'semantic',
    },
    {
      german: "Eine Richterin/ein Richter",
      translated: "Съдията",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:142|bs": [
    {
      german: "Was ist die Hauptaufgabe",
      translated: "Koji je glavni zadatak",
      tone: 'semantic',
    },
    {
      german: "einer Richterin/eines Richters",
      translated: "sutkinje/sudije",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "u Njemačkoj",
      tone: 'semantic',
    },
    {
      german: "Eine Richterin/ein Richter",
      translated: "Sutkinja/sudija",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:142|el": [
    {
      german: "Was ist die Hauptaufgabe",
      translated: "Ποιο είναι το κύριο καθήκον",
      tone: 'semantic',
    },
    {
      german: "einer Richterin/eines Richters",
      translated: "μιας δικαστού/ενός δικαστή",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "στη Γερμανία",
      tone: 'semantic',
    },
    {
      german: "Eine Richterin/ein Richter",
      translated: "Μια δικαστής/ένας δικαστής",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:142|en": [
    {
      german: "Was ist die Hauptaufgabe",
      translated: "What is the main task",
      tone: 'semantic',
    },
    {
      german: "einer Richterin/eines Richters",
      translated: "of a judge",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "in Germany",
      tone: 'semantic',
    },
    {
      german: "Eine Richterin/ein Richter",
      translated: "A judge",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:142|es": [
    {
      german: "Was ist die Hauptaufgabe",
      translated: "¿Cuál es la principal tarea",
      tone: 'semantic',
    },
    {
      german: "einer Richterin/eines Richters",
      translated: "de un juez",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "en Alemania",
      tone: 'semantic',
    },
    {
      german: "Eine Richterin/ein Richter",
      translated: "Un juez",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:142|fa": [
    {
      german: "in Deutschland",
      translated: "در آلمان",
      tone: 'semantic',
    },
    {
      german: "Eine Richterin/ein Richter",
      translated: "یک قاضی",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:142|fr": [
    {
      german: "Was ist die Hauptaufgabe",
      translated: "Quelle est la tâche principale",
      tone: 'semantic',
    },
    {
      german: "einer Richterin/eines Richters",
      translated: "d’un juge",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "en Allemagne",
      tone: 'semantic',
    },
    {
      german: "Eine Richterin/ein Richter",
      translated: "Un juge",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:142|hr": [
    {
      german: "Was ist die Hauptaufgabe",
      translated: "Koja je glavna zadaća",
      tone: 'semantic',
    },
    {
      german: "einer Richterin/eines Richters",
      translated: "sutkinje/suca",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "u Njemačkoj",
      tone: 'semantic',
    },
    {
      german: "Eine Richterin/ein Richter",
      translated: "Sutkinja/sudac",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:142|it": [
    {
      german: "Was ist die Hauptaufgabe",
      translated: "Qual è il compito principale",
      tone: 'semantic',
    },
    {
      german: "einer Richterin/eines Richters",
      translated: "di una giudice/un giudice",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "in Germania",
      tone: 'semantic',
    },
    {
      german: "Eine Richterin/ein Richter",
      translated: "Una giudice/un giudice",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:142|kmr": [
    {
      german: "Was",
      translated: "çi",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:142|pl": [
    {
      german: "in Deutschland",
      translated: "w Niemczech",
      tone: 'semantic',
    },
    {
      german: "Eine Richterin/ein Richter",
      translated: "Sędzia",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:142|prs": [
    {
      german: "Was ist die Hauptaufgabe",
      translated: "وظیفهٔ اصلی",
      tone: 'semantic',
    },
    {
      german: "einer Richterin/eines Richters",
      translated: "یک قاضی",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "در آلمان",
      tone: 'semantic',
    },
    {
      german: "Eine Richterin/ein Richter",
      translated: "یک قاضی",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:142|ro": [
    {
      german: "Was ist die Hauptaufgabe",
      translated: "Care este sarcina principală",
      tone: 'semantic',
    },
    {
      german: "einer Richterin/eines Richters",
      translated: "unei judecătoare/unui judecător",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "în Germania",
      tone: 'semantic',
    },
    {
      german: "Eine Richterin/ein Richter",
      translated: "O judecătoare/un judecător",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:142|ru": [
    {
      german: "Was ist die Hauptaufgabe",
      translated: "Какова главная задача",
      tone: 'semantic',
    },
    {
      german: "einer Richterin/eines Richters",
      translated: "судьи",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "в Германии",
      tone: 'semantic',
    },
    {
      german: "Eine Richterin/ein Richter",
      translated: "Судья",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:142|sq": [
    {
      german: "Was ist die Hauptaufgabe",
      translated: "Cila është detyra kryesore",
      tone: 'semantic',
    },
    {
      german: "einer Richterin/eines Richters",
      translated: "e një gjyqtareje/një gjyqtari",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "në Gjermani",
      tone: 'semantic',
    },
    {
      german: "Eine Richterin/ein Richter",
      translated: "Një gjyqtare/një gjyqtar",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:142|sr": [
    {
      german: "Was ist die Hauptaufgabe",
      translated: "Koji je glavni zadatak",
      tone: 'semantic',
    },
    {
      german: "einer Richterin/eines Richters",
      translated: "sutkinje/sudije",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "u Nemačkoj",
      tone: 'semantic',
    },
    {
      german: "Eine Richterin/ein Richter",
      translated: "Sutkinja/sudija",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:142|tr": [
    {
      german: "Was ist die Hauptaufgabe",
      translated: "temel görevi",
      tone: 'semantic',
    },
    {
      german: "einer Richterin/eines Richters",
      translated: "bir hâkimin",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "Almanya'da",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:142|uk": [
    {
      german: "Was ist die Hauptaufgabe",
      translated: "Яке головне завдання",
      tone: 'semantic',
    },
    {
      german: "einer Richterin/eines Richters",
      translated: "судді",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "в Німеччині",
      tone: 'semantic',
    },
    {
      german: "Eine Richterin/ein Richter",
      translated: "Суддя",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:142|vi": [
    {
      german: "in Deutschland",
      translated: "ở Đức",
      tone: 'semantic',
    },
    {
      german: "Eine Richterin/ein Richter",
      translated: "Một thẩm phán",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:143|ar": [
    {
      german: "Eine Richterin/ein Richter",
      translated: "القاضي",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "في ألمانيا",
      tone: 'semantic',
    },
    {
      german: "gehört zur",
      translated: "إلى",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:143|bg": [
    {
      german: "Eine Richterin/ein Richter",
      translated: "Съдията",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "в Германия",
      tone: 'semantic',
    },
    {
      german: "gehört zur",
      translated: "принадлежи към",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:143|bs": [
    {
      german: "Eine Richterin/ein Richter",
      translated: "Sutkinja/sudija",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "u Njemačkoj",
      tone: 'semantic',
    },
    {
      german: "gehört zur",
      translated: "pripada",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:143|el": [
    {
      german: "Eine Richterin/ein Richter",
      translated: "Μια δικαστής/ένας δικαστής",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "στη Γερμανία",
      tone: 'semantic',
    },
    {
      german: "gehört zur",
      translated: "ανήκει στη",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:143|en": [
    {
      german: "Eine Richterin/ein Richter",
      translated: "A judge",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "in Germany",
      tone: 'semantic',
    },
    {
      german: "gehört zur",
      translated: "belongs to the",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:143|es": [
    {
      german: "Eine Richterin/ein Richter",
      translated: "Un juez",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "en Alemania",
      tone: 'semantic',
    },
    {
      german: "gehört zur",
      translated: "pertenece al",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:143|fa": [
    {
      german: "Eine Richterin/ein Richter",
      translated: "یک قاضی",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "در آلمان",
      tone: 'semantic',
    },
    {
      german: "gehört zur",
      translated: "تعلق دارد",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:143|fr": [
    {
      german: "Eine Richterin/ein Richter",
      translated: "Un juge",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "en Allemagne",
      tone: 'semantic',
    },
    {
      german: "gehört zur",
      translated: "appartient au",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:143|hr": [
    {
      german: "Eine Richterin/ein Richter",
      translated: "Sutkinja/sudac",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "u Njemačkoj",
      tone: 'semantic',
    },
    {
      german: "gehört zur",
      translated: "pripada",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:143|it": [
    {
      german: "Eine Richterin/ein Richter",
      translated: "Una giudice/un giudice",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "in Germania",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:143|kmr": [
    {
      german: "Eine Richterin/ein Richter",
      translated: "Dadwer",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "li Almanyayê",
      tone: 'semantic',
    },
    {
      german: "gehört zur",
      translated: "ji hêza",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:143|pl": [
    {
      german: "Eine Richterin/ein Richter",
      translated: "Sędzia",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "w Niemczech",
      tone: 'semantic',
    },
    {
      german: "gehört zur",
      translated: "należy do",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:143|prs": [
    {
      german: "Eine Richterin/ein Richter",
      translated: "یک قاضی",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "در آلمان",
      tone: 'semantic',
    },
    {
      german: "gehört zur",
      translated: "تعلق دارد",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:143|ro": [
    {
      german: "Eine Richterin/ein Richter",
      translated: "O judecătoare/un judecător",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "din Germania",
      tone: 'semantic',
    },
    {
      german: "gehört zur",
      translated: "aparține",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:143|ru": [
    {
      german: "Eine Richterin/ein Richter",
      translated: "Судья",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "в Германии",
      tone: 'semantic',
    },
    {
      german: "gehört zur",
      translated: "относится к",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:143|sq": [
    {
      german: "Eine Richterin/ein Richter",
      translated: "Një gjyqtare/një gjyqtar",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "në Gjermani",
      tone: 'semantic',
    },
    {
      german: "gehört zur",
      translated: "i përket",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:143|sr": [
    {
      german: "Eine Richterin/ein Richter",
      translated: "Sutkinja/sudija",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "u Nemačkoj",
      tone: 'semantic',
    },
    {
      german: "gehört zur",
      translated: "pripada",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:143|tr": [
    {
      german: "Eine Richterin/ein Richter",
      translated: "bir hâkim",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "Almanya'da",
      tone: 'semantic',
    },
    {
      german: "gehört zur",
      translated: "erkine aittir",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:143|uk": [
    {
      german: "Eine Richterin/ein Richter",
      translated: "Суддя",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "в Німеччині",
      tone: 'semantic',
    },
    {
      german: "gehört zur",
      translated: "належить до",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:143|vi": [
    {
      german: "Eine Richterin/ein Richter",
      translated: "Một thẩm phán",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "ở Đức",
      tone: 'semantic',
    },
    {
      german: "gehört zur",
      translated: "thuộc",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:144|ar": [
    {
      german: "Eine Richterin/ein Richter",
      translated: "القاضي",
      tone: 'semantic',
    },
    {
      german: "gehört",
      translated: "ينتمي",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "في ألمانيا",
      tone: 'semantic',
    },
    {
      german: "zur",
      translated: "إلى",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:144|bg": [
    {
      german: "Eine Richterin/ein Richter",
      translated: "Съдията",
      tone: 'semantic',
    },
    {
      german: "gehört",
      translated: "принадлежи",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "в Германия",
      tone: 'semantic',
    },
    {
      german: "zur",
      translated: "към",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:144|bs": [
    {
      german: "Eine Richterin/ein Richter",
      translated: "Sutkinja/sudija",
      tone: 'semantic',
    },
    {
      german: "gehört",
      translated: "pripada",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "u Njemačkoj",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:144|el": [
    {
      german: "Eine Richterin/ein Richter",
      translated: "Μια δικαστής/ένας δικαστής",
      tone: 'semantic',
    },
    {
      german: "gehört",
      translated: "ανήκει",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "στη Γερμανία",
      tone: 'semantic',
    },
    {
      german: "zur",
      translated: "στη",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:144|en": [
    {
      german: "Eine Richterin/ein Richter",
      translated: "A judge",
      tone: 'semantic',
    },
    {
      german: "gehört",
      translated: "belongs",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "in Germany",
      tone: 'semantic',
    },
    {
      german: "zur",
      translated: "to the",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:144|es": [
    {
      german: "Eine Richterin/ein Richter",
      translated: "Un juez",
      tone: 'semantic',
    },
    {
      german: "gehört",
      translated: "pertenece",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "en Alemania",
      tone: 'semantic',
    },
    {
      german: "zur",
      translated: "al",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:144|fa": [
    {
      german: "Eine Richterin/ein Richter",
      translated: "یک قاضی",
      tone: 'semantic',
    },
    {
      german: "gehört",
      translated: "تعلق دارد",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "در آلمان",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:144|fr": [
    {
      german: "Eine Richterin/ein Richter",
      translated: "Un juge",
      tone: 'semantic',
    },
    {
      german: "gehört",
      translated: "appartient",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "en Allemagne",
      tone: 'semantic',
    },
    {
      german: "zur",
      translated: "au",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:144|hr": [
    {
      german: "Eine Richterin/ein Richter",
      translated: "Sutkinja/sudac",
      tone: 'semantic',
    },
    {
      german: "gehört",
      translated: "pripada",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "u Njemačkoj",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:144|it": [
    {
      german: "Eine Richterin/ein Richter",
      translated: "Una giudice/un giudice",
      tone: 'semantic',
    },
    {
      german: "gehört",
      translated: "appartiene",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "in Germania",
      tone: 'semantic',
    },
    {
      german: "zur",
      translated: "al",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:144|kmr": [
    {
      german: "Eine Richterin/ein Richter",
      translated: "Dadwer",
      tone: 'semantic',
    },
    {
      german: "gehört",
      translated: "ye",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "li Almanyayê",
      tone: 'semantic',
    },
    {
      german: "zur",
      translated: "ji hêza",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:144|pl": [
    {
      german: "Eine Richterin/ein Richter",
      translated: "Sędzia",
      tone: 'semantic',
    },
    {
      german: "gehört",
      translated: "należy",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "w Niemczech",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:144|prs": [
    {
      german: "Eine Richterin/ein Richter",
      translated: "یک قاضی",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "در آلمان",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:144|ro": [
    {
      german: "Eine Richterin/ein Richter",
      translated: "O judecătoare/un judecător",
      tone: 'semantic',
    },
    {
      german: "gehört",
      translated: "aparține",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "în Germania",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:144|ru": [
    {
      german: "Eine Richterin/ein Richter",
      translated: "Судья",
      tone: 'semantic',
    },
    {
      german: "gehört",
      translated: "относится",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "в Германии",
      tone: 'semantic',
    },
    {
      german: "zur",
      translated: "к",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:144|sq": [
    {
      german: "Eine Richterin/ein Richter",
      translated: "Një gjyqtare/një gjyqtar",
      tone: 'semantic',
    },
    {
      german: "gehört",
      translated: "i përket",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "në Gjermani",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:144|sr": [
    {
      german: "Eine Richterin/ein Richter",
      translated: "Sutkinja/sudija",
      tone: 'semantic',
    },
    {
      german: "gehört",
      translated: "pripada",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "u Nemačkoj",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:144|tr": [
    {
      german: "Eine Richterin/ein Richter",
      translated: "bir hâkim",
      tone: 'semantic',
    },
    {
      german: "gehört",
      translated: "aittir",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "Almanya'da",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:144|uk": [
    {
      german: "Eine Richterin/ein Richter",
      translated: "Суддя",
      tone: 'semantic',
    },
    {
      german: "gehört",
      translated: "належить",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "в Німеччині",
      tone: 'semantic',
    },
    {
      german: "zur",
      translated: "до",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:144|vi": [
    {
      german: "Eine Richterin/ein Richter",
      translated: "Một thẩm phán",
      tone: 'semantic',
    },
    {
      german: "gehört",
      translated: "thuộc",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "ở Đức",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:145|ar": [
    {
      german: "In Deutschland",
      translated: "في ألمانيا",
      tone: 'semantic',
    },
    {
      german: "wird die Staatsgewalt geteilt",
      translated: "تنقسم سلطة الدولة",
      tone: 'semantic',
    },
    {
      german: "Für welche Staatsgewalt",
      translated: "لأي سلطة",
      tone: 'semantic',
    },
    {
      german: "arbeitet eine Richterin/ein Richter",
      translated: "يعمل القاضي",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:145|bg": [
    {
      german: "In Deutschland",
      translated: "В Германия",
      tone: 'semantic',
    },
    {
      german: "wird die Staatsgewalt geteilt",
      translated: "държавната власт е разделена",
      tone: 'semantic',
    },
    {
      german: "Für welche Staatsgewalt",
      translated: "За коя държавна власт",
      tone: 'semantic',
    },
    {
      german: "arbeitet eine Richterin/ein Richter",
      translated: "работи съдията",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:145|bs": [
    {
      german: "In Deutschland",
      translated: "U Njemačkoj",
      tone: 'semantic',
    },
    {
      german: "wird die Staatsgewalt geteilt",
      translated: "državna vlast podijeljena",
      tone: 'semantic',
    },
    {
      german: "Für welche Staatsgewalt",
      translated: "Za koju državnu vlast",
      tone: 'semantic',
    },
    {
      german: "arbeitet eine Richterin/ein Richter",
      translated: "radi sutkinja/sudija",
      tone: 'semantic',
    },
    {
      german: "Für die",
      translated: "Za",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:145|el": [
    {
      german: "In Deutschland",
      translated: "Στη Γερμανία",
      tone: 'semantic',
    },
    {
      german: "wird die Staatsgewalt geteilt",
      translated: "η κρατική εξουσία είναι διαχωρισμένη",
      tone: 'semantic',
    },
    {
      german: "Für welche Staatsgewalt",
      translated: "Για ποια κρατική εξουσία",
      tone: 'semantic',
    },
    {
      german: "arbeitet eine Richterin/ein Richter",
      translated: "εργάζεται μια δικαστής/ένας δικαστής",
      tone: 'semantic',
    },
    {
      german: "Für die",
      translated: "Για τη",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:145|en": [
    {
      german: "In Deutschland",
      translated: "In Germany",
      tone: 'semantic',
    },
    {
      german: "wird die Staatsgewalt geteilt",
      translated: "state power is divided",
      tone: 'semantic',
    },
    {
      german: "Für welche Staatsgewalt",
      translated: "For which branch of government",
      tone: 'semantic',
    },
    {
      german: "arbeitet eine Richterin/ein Richter",
      translated: "does a judge work",
      tone: 'semantic',
    },
    {
      german: "Für die",
      translated: "For the",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:145|es": [
    {
      german: "In Deutschland",
      translated: "En Alemania",
      tone: 'semantic',
    },
    {
      german: "wird die Staatsgewalt geteilt",
      translated: "el poder del Estado está dividido",
      tone: 'semantic',
    },
    {
      german: "Für welche Staatsgewalt",
      translated: "Para qué poder",
      tone: 'semantic',
    },
    {
      german: "arbeitet eine Richterin/ein Richter",
      translated: "trabaja un juez",
      tone: 'semantic',
    },
    {
      german: "Für die",
      translated: "Para el",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:145|fa": [
    {
      german: "In Deutschland",
      translated: "در آلمان",
      tone: 'semantic',
    },
    {
      german: "wird die Staatsgewalt geteilt",
      translated: "قدرت حکومتی تقسیم شده است",
      tone: 'semantic',
    },
    {
      german: "Für welche Staatsgewalt",
      translated: "یک قاضی برای کدام قوهٔ حکومتی",
      tone: 'semantic',
    },
    {
      german: "arbeitet eine Richterin/ein Richter",
      translated: "کار می‌کند",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:145|fr": [
    {
      german: "In Deutschland",
      translated: "En Allemagne",
      tone: 'semantic',
    },
    {
      german: "wird die Staatsgewalt geteilt",
      translated: "le pouvoir de l’État est divisé",
      tone: 'semantic',
    },
    {
      german: "Für welche Staatsgewalt",
      translated: "Pour quel pouvoir",
      tone: 'semantic',
    },
    {
      german: "arbeitet eine Richterin/ein Richter",
      translated: "travaille un juge",
      tone: 'semantic',
    },
    {
      german: "Für die",
      translated: "Pour le",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:145|hr": [
    {
      german: "In Deutschland",
      translated: "U Njemačkoj",
      tone: 'semantic',
    },
    {
      german: "wird die Staatsgewalt geteilt",
      translated: "državna vlast podijeljena",
      tone: 'semantic',
    },
    {
      german: "Für welche Staatsgewalt",
      translated: "Za koju državnu vlast",
      tone: 'semantic',
    },
    {
      german: "arbeitet eine Richterin/ein Richter",
      translated: "radi sutkinja/sudac",
      tone: 'semantic',
    },
    {
      german: "Für die",
      translated: "Za",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:145|it": [
    {
      german: "In Deutschland",
      translated: "In Germania",
      tone: 'semantic',
    },
    {
      german: "wird die Staatsgewalt geteilt",
      translated: "il potere dello Stato è suddiviso",
      tone: 'semantic',
    },
    {
      german: "Für welche Staatsgewalt",
      translated: "Per quale potere dello Stato",
      tone: 'semantic',
    },
    {
      german: "arbeitet eine Richterin/ein Richter",
      translated: "lavora una giudice/un giudice",
      tone: 'semantic',
    },
    {
      german: "Für die",
      translated: "Per il",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:145|kmr": [
    {
      german: "In Deutschland",
      translated: "li Almanyayê",
      tone: 'semantic',
    },
    {
      german: "wird die Staatsgewalt geteilt",
      translated: "tê dabeşkirin",
      tone: 'semantic',
    },
    {
      german: "Für welche Staatsgewalt",
      translated: "ji bo kîjan hêzê",
      tone: 'semantic',
    },
    {
      german: "arbeitet eine Richterin/ein Richter",
      translated: "Dadwer",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:145|pl": [
    {
      german: "In Deutschland",
      translated: "W Niemczech",
      tone: 'semantic',
    },
    {
      german: "wird die Staatsgewalt geteilt",
      translated: "władza państwowa jest podzielona",
      tone: 'semantic',
    },
    {
      german: "Für welche Staatsgewalt",
      translated: "Dla której władzy państwowej",
      tone: 'semantic',
    },
    {
      german: "arbeitet eine Richterin/ein Richter",
      translated: "pracuje sędzia",
      tone: 'semantic',
    },
    {
      german: "Für die",
      translated: "Dla …",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:145|prs": [
    {
      german: "In Deutschland",
      translated: "در آلمان",
      tone: 'semantic',
    },
    {
      german: "wird die Staatsgewalt geteilt",
      translated: "قدرت دولتی تقسیم شده است",
      tone: 'semantic',
    },
    {
      german: "Für welche Staatsgewalt",
      translated: "برای کدام قوهٔ دولتی",
      tone: 'semantic',
    },
    {
      german: "Für die",
      translated: "برای …",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:145|ro": [
    {
      german: "In Deutschland",
      translated: "În Germania",
      tone: 'semantic',
    },
    {
      german: "wird die Staatsgewalt geteilt",
      translated: "puterea de stat este împărțită",
      tone: 'semantic',
    },
    {
      german: "Für welche Staatsgewalt",
      translated: "Pentru care putere de stat",
      tone: 'semantic',
    },
    {
      german: "arbeitet eine Richterin/ein Richter",
      translated: "lucrează o judecătoare/un judecător",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:145|ru": [
    {
      german: "In Deutschland",
      translated: "В Германии",
      tone: 'semantic',
    },
    {
      german: "wird die Staatsgewalt geteilt",
      translated: "государственная власть разделена",
      tone: 'semantic',
    },
    {
      german: "Für welche Staatsgewalt",
      translated: "К какой ветви власти",
      tone: 'semantic',
    },
    {
      german: "arbeitet eine Richterin/ein Richter",
      translated: "работа судьи",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:145|sq": [
    {
      german: "In Deutschland",
      translated: "Në Gjermani",
      tone: 'semantic',
    },
    {
      german: "wird die Staatsgewalt geteilt",
      translated: "pushteti shtetëror ndahet",
      tone: 'semantic',
    },
    {
      german: "Für welche Staatsgewalt",
      translated: "Për cilin pushtet shtetëror",
      tone: 'semantic',
    },
    {
      german: "arbeitet eine Richterin/ein Richter",
      translated: "punon një gjyqtare/një gjyqtar",
      tone: 'semantic',
    },
    {
      german: "Für die",
      translated: "Për",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:145|sr": [
    {
      german: "In Deutschland",
      translated: "U Nemačkoj",
      tone: 'semantic',
    },
    {
      german: "wird die Staatsgewalt geteilt",
      translated: "je državna vlast podeljena",
      tone: 'semantic',
    },
    {
      german: "Für welche Staatsgewalt",
      translated: "Za koju državnu vlast",
      tone: 'semantic',
    },
    {
      german: "arbeitet eine Richterin/ein Richter",
      translated: "radi sutkinja/sudija",
      tone: 'semantic',
    },
    {
      german: "Für die",
      translated: "Za",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:145|tr": [
    {
      german: "In Deutschland",
      translated: "Almanya'da",
      tone: 'semantic',
    },
    {
      german: "wird die Staatsgewalt geteilt",
      translated: "devlet yetkileri ayrılmıştır",
      tone: 'semantic',
    },
    {
      german: "Für welche Staatsgewalt",
      translated: "hangi devlet erki",
      tone: 'semantic',
    },
    {
      german: "arbeitet eine Richterin/ein Richter",
      translated: "Bir hâkim",
      tone: 'semantic',
    },
    {
      german: "Für die",
      translated: "için",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:145|uk": [
    {
      german: "In Deutschland",
      translated: "У Німеччині",
      tone: 'semantic',
    },
    {
      german: "wird die Staatsgewalt geteilt",
      translated: "державна влада поділена",
      tone: 'semantic',
    },
    {
      german: "Für welche Staatsgewalt",
      translated: "Для якої гілки державної влади",
      tone: 'semantic',
    },
    {
      german: "arbeitet eine Richterin/ein Richter",
      translated: "працює суддя",
      tone: 'semantic',
    },
    {
      german: "Für die",
      translated: "Для …",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:145|vi": [
    {
      german: "In Deutschland",
      translated: "Ở Đức",
      tone: 'semantic',
    },
    {
      german: "wird die Staatsgewalt geteilt",
      translated: "quyền lực nhà nước được phân chia",
      tone: 'semantic',
    },
    {
      german: "Für welche Staatsgewalt",
      translated: "nhánh quyền lực nhà nước nào",
      tone: 'semantic',
    },
    {
      german: "arbeitet eine Richterin/ein Richter",
      translated: "Một thẩm phán làm việc",
      tone: 'semantic',
    },
    {
      german: "Für die",
      translated: "Cho",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:146|ar": [
    {
      german: "Wie nennt man",
      translated: "ماذا يُسمى",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "في ألمانيا",
      tone: 'semantic',
    },
    {
      german: "ein Verfahren",
      translated: "الإجراء",
      tone: 'semantic',
    },
    {
      german: "vor einem Gericht",
      translated: "أمام المحكمة",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:146|bg": [
    {
      german: "Wie nennt man",
      translated: "Как се нарича",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "в Германия",
      tone: 'semantic',
    },
    {
      german: "ein Verfahren",
      translated: "производство",
      tone: 'semantic',
    },
    {
      german: "vor einem Gericht",
      translated: "пред съд",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:146|bs": [
    {
      german: "Wie nennt man",
      translated: "Kako se",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "u Njemačkoj",
      tone: 'semantic',
    },
    {
      german: "ein Verfahren",
      translated: "postupak",
      tone: 'semantic',
    },
    {
      german: "vor einem Gericht",
      translated: "pred sudom?",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:146|el": [
    {
      german: "Wie nennt man",
      translated: "Πώς ονομάζεται",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "στη Γερμανία",
      tone: 'semantic',
    },
    {
      german: "ein Verfahren",
      translated: "μια διαδικασία",
      tone: 'semantic',
    },
    {
      german: "vor einem Gericht",
      translated: "ενώπιον δικαστηρίου;",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:146|en": [
    {
      german: "Wie nennt man",
      translated: "What do you call",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "in Germany",
      tone: 'semantic',
    },
    {
      german: "ein Verfahren",
      translated: "a proceeding",
      tone: 'semantic',
    },
    {
      german: "vor einem Gericht",
      translated: "before a court",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:146|es": [
    {
      german: "Wie nennt man",
      translated: "¿Cómo se llama",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "en Alemania",
      tone: 'semantic',
    },
    {
      german: "ein Verfahren",
      translated: "un procedimiento",
      tone: 'semantic',
    },
    {
      german: "vor einem Gericht",
      translated: "ante un tribunal",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:146|fa": [
    {
      german: "in Deutschland",
      translated: "در آلمان",
      tone: 'semantic',
    },
    {
      german: "vor einem Gericht",
      translated: "دادگاه",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:146|fr": [
    {
      german: "Wie nennt man",
      translated: "Comment appelle-t-on",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "en Allemagne",
      tone: 'semantic',
    },
    {
      german: "ein Verfahren",
      translated: "une procédure",
      tone: 'semantic',
    },
    {
      german: "vor einem Gericht",
      translated: "devant un tribunal",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:146|hr": [
    {
      german: "Wie nennt man",
      translated: "Kako se",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "u Njemačkoj",
      tone: 'semantic',
    },
    {
      german: "ein Verfahren",
      translated: "postupak",
      tone: 'semantic',
    },
    {
      german: "vor einem Gericht",
      translated: "pred sudom",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:146|it": [
    {
      german: "Wie nennt man",
      translated: "Come si chiama",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "in Germania",
      tone: 'semantic',
    },
    {
      german: "ein Verfahren",
      translated: "un procedimento",
      tone: 'semantic',
    },
    {
      german: "vor einem Gericht",
      translated: "davanti a un tribunale",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:146|kmr": [
    {
      german: "Wie nennt man",
      translated: "çi tê gotin?",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "li Almanyayê",
      tone: 'semantic',
    },
    {
      german: "ein Verfahren",
      translated: "Prosedûra",
      tone: 'semantic',
    },
    {
      german: "vor einem Gericht",
      translated: "li pêş dadgehê",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:146|pl": [
    {
      german: "in Deutschland",
      translated: "w Niemczech",
      tone: 'semantic',
    },
    {
      german: "vor einem Gericht",
      translated: "przed sądem?",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:146|prs": [
    {
      german: "Wie nennt man",
      translated: "چه می‌گویند؟",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "در آلمان",
      tone: 'semantic',
    },
    {
      german: "ein Verfahren",
      translated: "یک رسیدگی",
      tone: 'semantic',
    },
    {
      german: "vor einem Gericht",
      translated: "در محکمه",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:146|ro": [
    {
      german: "Wie nennt man",
      translated: "Cum se numește",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "în Germania",
      tone: 'semantic',
    },
    {
      german: "ein Verfahren",
      translated: "o procedură",
      tone: 'semantic',
    },
    {
      german: "vor einem Gericht",
      translated: "în fața unei instanțe",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:146|ru": [
    {
      german: "Wie nennt man",
      translated: "Как называют",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "в Германии",
      tone: 'semantic',
    },
    {
      german: "ein Verfahren",
      translated: "разбирательство",
      tone: 'semantic',
    },
    {
      german: "vor einem Gericht",
      translated: "в суде",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:146|sq": [
    {
      german: "in Deutschland",
      translated: "në Gjermani",
      tone: 'semantic',
    },
    {
      german: "ein Verfahren",
      translated: "një procedurë",
      tone: 'semantic',
    },
    {
      german: "vor einem Gericht",
      translated: "para një gjykate",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:146|sr": [
    {
      german: "Wie",
      translated: "kako",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:146|tr": [
    {
      german: "Wie nennt man",
      translated: "ne denir?",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "Almanya'da",
      tone: 'semantic',
    },
    {
      german: "ein Verfahren",
      translated: "bir yargılama sürecine",
      tone: 'semantic',
    },
    {
      german: "vor einem Gericht",
      translated: "mahkeme önündeki",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:146|uk": [
    {
      german: "in Deutschland",
      translated: "у Німеччині",
      tone: 'semantic',
    },
    {
      german: "ein Verfahren",
      translated: "провадження",
      tone: 'semantic',
    },
    {
      german: "vor einem Gericht",
      translated: "в суді",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:146|vi": [
    {
      german: "Wie nennt man",
      translated: "được gọi là",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "Ở Đức",
      tone: 'semantic',
    },
    {
      german: "ein Verfahren",
      translated: "một thủ tục",
      tone: 'semantic',
    },
    {
      german: "vor einem Gericht",
      translated: "trước tòa án",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:147|ar": [
    {
      german: "Was ist",
      translated: "ما",
      tone: 'semantic',
    },
    {
      german: "die Arbeit",
      translated: "عمل",
      tone: 'semantic',
    },
    {
      german: "einer Richterin",
      translated: "القاضي",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "في ألمانيا",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:147|bg": [
    {
      german: "Was ist",
      translated: "Каква е",
      tone: 'semantic',
    },
    {
      german: "die Arbeit",
      translated: "работата на",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "в Германия",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:147|bs": [
    {
      german: "Was ist",
      translated: "Koji je",
      tone: 'semantic',
    },
    {
      german: "die Arbeit",
      translated: "posao",
      tone: 'semantic',
    },
    {
      german: "einer Richterin",
      translated: "sutkinje",
      tone: 'semantic',
    },
    {
      german: "eines Richters",
      translated: "sudije",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "u Njemačkoj",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:147|el": [
    {
      german: "Was ist",
      translated: "Ποια είναι",
      tone: 'semantic',
    },
    {
      german: "die Arbeit",
      translated: "η εργασία",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "στη Γερμανία;",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:147|en": [
    {
      german: "Was ist",
      translated: "What is",
      tone: 'semantic',
    },
    {
      german: "die Arbeit",
      translated: "the work",
      tone: 'semantic',
    },
    {
      german: "einer Richterin",
      translated: "of a judge",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "in Germany",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:147|es": [
    {
      german: "Was ist",
      translated: "¿Cuál es",
      tone: 'semantic',
    },
    {
      german: "die Arbeit",
      translated: "el trabajo",
      tone: 'semantic',
    },
    {
      german: "einer Richterin",
      translated: "de",
      tone: 'semantic',
    },
    {
      german: "eines Richters",
      translated: "un juez",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "en Alemania",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:147|fa": [
    {
      german: "einer Richterin",
      translated: "یک",
      tone: 'semantic',
    },
    {
      german: "eines Richters",
      translated: "قاضی",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "در آلمان",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:147|fr": [
    {
      german: "Was ist",
      translated: "Quel est",
      tone: 'semantic',
    },
    {
      german: "die Arbeit",
      translated: "le travail",
      tone: 'semantic',
    },
    {
      german: "einer Richterin",
      translated: "d’un",
      tone: 'semantic',
    },
    {
      german: "eines Richters",
      translated: "juge",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "en Allemagne",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:147|hr": [
    {
      german: "Was ist",
      translated: "Što je",
      tone: 'semantic',
    },
    {
      german: "die Arbeit",
      translated: "posao",
      tone: 'semantic',
    },
    {
      german: "einer Richterin",
      translated: "sutkinje",
      tone: 'semantic',
    },
    {
      german: "eines Richters",
      translated: "suca",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "u Njemačkoj",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:147|it": [
    {
      german: "Was ist",
      translated: "Qual è",
      tone: 'semantic',
    },
    {
      german: "die Arbeit",
      translated: "il lavoro",
      tone: 'semantic',
    },
    {
      german: "einer Richterin",
      translated: "di una giudice",
      tone: 'semantic',
    },
    {
      german: "eines Richters",
      translated: "un giudice",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "in Germania",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:147|kmr": [
    {
      german: "Was",
      translated: "çi",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:147|pl": [
    {
      german: "Was ist",
      translated: "Na czym polega",
      tone: 'semantic',
    },
    {
      german: "die Arbeit",
      translated: "praca",
      tone: 'semantic',
    },
    {
      german: "einer Richterin",
      translated: "sędziego",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "w Niemczech",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:147|prs": [
    {
      german: "Was ist",
      translated: "چیست",
      tone: 'semantic',
    },
    {
      german: "die Arbeit",
      translated: "کار",
      tone: 'semantic',
    },
    {
      german: "einer Richterin",
      translated: "یک قاضی",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "در آلمان",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:147|ro": [
    {
      german: "Was ist",
      translated: "Care este",
      tone: 'semantic',
    },
    {
      german: "die Arbeit",
      translated: "activitatea",
      tone: 'semantic',
    },
    {
      german: "einer Richterin",
      translated: "unei judecătoare",
      tone: 'semantic',
    },
    {
      german: "eines Richters",
      translated: "unui judecător",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "în Germania",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:147|ru": [
    {
      german: "Was ist",
      translated: "В чём",
      tone: 'semantic',
    },
    {
      german: "die Arbeit",
      translated: "работа",
      tone: 'semantic',
    },
    {
      german: "einer Richterin",
      translated: "судьи",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "в Германии?",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:147|sq": [
    {
      german: "Was ist",
      translated: "Cila është",
      tone: 'semantic',
    },
    {
      german: "die Arbeit",
      translated: "puna",
      tone: 'semantic',
    },
    {
      german: "einer Richterin",
      translated: "një gjyqtareje",
      tone: 'semantic',
    },
    {
      german: "eines Richters",
      translated: "një gjyqtari",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "në Gjermani",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:147|sr": [
    {
      german: "Was ist",
      translated: "Koji je",
      tone: 'semantic',
    },
    {
      german: "die Arbeit",
      translated: "posao",
      tone: 'semantic',
    },
    {
      german: "einer Richterin",
      translated: "sutkinje",
      tone: 'semantic',
    },
    {
      german: "eines Richters",
      translated: "sudije",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "u Nemačkoj",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:147|tr": [
    {
      german: "Was ist",
      translated: "nedir?",
      tone: 'semantic',
    },
    {
      german: "die Arbeit",
      translated: "işi",
      tone: 'semantic',
    },
    {
      german: "einer Richterin",
      translated: "bir hâkimin",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "Almanya'da",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:147|uk": [
    {
      german: "Was ist",
      translated: "У чому",
      tone: 'semantic',
    },
    {
      german: "die Arbeit",
      translated: "робота",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "в Німеччині",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:147|vi": [
    {
      german: "Was",
      translated: "gì?",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:148|ar": [
    {
      german: "Was ist",
      translated: "ما",
      tone: 'semantic',
    },
    {
      german: "eine Aufgabe",
      translated: "إحدى مهام",
      tone: 'semantic',
    },
    {
      german: "der Polizei",
      translated: "الشرطة",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "في ألمانيا",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:148|bg": [
    {
      german: "Was ist",
      translated: "Каква е",
      tone: 'semantic',
    },
    {
      german: "eine Aufgabe",
      translated: "една от задачите",
      tone: 'semantic',
    },
    {
      german: "der Polizei",
      translated: "на полицията",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "в Германия",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:148|bs": [
    {
      german: "Was ist",
      translated: "Koji je",
      tone: 'semantic',
    },
    {
      german: "eine Aufgabe",
      translated: "jedan od zadataka",
      tone: 'semantic',
    },
    {
      german: "der Polizei",
      translated: "policije",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "u Njemačkoj",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:148|el": [
    {
      german: "eine Aufgabe",
      translated: "ένα από",
      tone: 'semantic',
    },
    {
      german: "der Polizei",
      translated: "της αστυνομίας",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "στη Γερμανία;",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:148|en": [
    {
      german: "Was ist",
      translated: "What is",
      tone: 'semantic',
    },
    {
      german: "eine Aufgabe",
      translated: "a task",
      tone: 'semantic',
    },
    {
      german: "der Polizei",
      translated: "of the police",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "in Germany",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:148|es": [
    {
      german: "Was ist",
      translated: "¿Cuál es",
      tone: 'semantic',
    },
    {
      german: "eine Aufgabe",
      translated: "una tarea",
      tone: 'semantic',
    },
    {
      german: "der Polizei",
      translated: "de la policía",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "en Alemania",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:148|fa": [
    {
      german: "Was ist",
      translated: "چیست",
      tone: 'semantic',
    },
    {
      german: "eine Aufgabe",
      translated: "وظایف",
      tone: 'semantic',
    },
    {
      german: "der Polizei",
      translated: "پلیس",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "در آلمان",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:148|fr": [
    {
      german: "Was ist",
      translated: "Quelle est",
      tone: 'semantic',
    },
    {
      german: "eine Aufgabe",
      translated: "l’une des tâches",
      tone: 'semantic',
    },
    {
      german: "der Polizei",
      translated: "de la police",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "en Allemagne",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:148|hr": [
    {
      german: "Was ist",
      translated: "Koja je",
      tone: 'semantic',
    },
    {
      german: "eine Aufgabe",
      translated: "jedna od zadaća",
      tone: 'semantic',
    },
    {
      german: "der Polizei",
      translated: "policije",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "u Njemačkoj",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:148|it": [
    {
      german: "Was ist",
      translated: "Qual è",
      tone: 'semantic',
    },
    {
      german: "eine Aufgabe",
      translated: "uno dei compiti",
      tone: 'semantic',
    },
    {
      german: "der Polizei",
      translated: "della polizia",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "in Germania",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:148|kmr": [
    {
      german: "Was ist",
      translated: "çi ye?",
      tone: 'semantic',
    },
    {
      german: "eine Aufgabe",
      translated: "Erka",
      tone: 'semantic',
    },
    {
      german: "der Polizei",
      translated: "polîs",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "li Almanyayê",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:148|pl": [
    {
      german: "Was ist",
      translated: "Jakie jest",
      tone: 'semantic',
    },
    {
      german: "eine Aufgabe",
      translated: "jedno z zadań",
      tone: 'semantic',
    },
    {
      german: "der Polizei",
      translated: "policji",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "w Niemczech?",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:148|prs": [
    {
      german: "Was ist",
      translated: "چیست؟",
      tone: 'semantic',
    },
    {
      german: "eine Aufgabe",
      translated: "وظایف",
      tone: 'semantic',
    },
    {
      german: "der Polizei",
      translated: "پولیس",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "در آلمان",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:148|ro": [
    {
      german: "Was ist",
      translated: "Care este",
      tone: 'semantic',
    },
    {
      german: "eine Aufgabe",
      translated: "una dintre sarcinile",
      tone: 'semantic',
    },
    {
      german: "der Polizei",
      translated: "poliției",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "în Germania",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:148|ru": [
    {
      german: "Was ist",
      translated: "Что входит",
      tone: 'semantic',
    },
    {
      german: "eine Aufgabe",
      translated: "задачи",
      tone: 'semantic',
    },
    {
      german: "der Polizei",
      translated: "полиции",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "в Германии",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:148|sq": [
    {
      german: "Was ist",
      translated: "Cila është",
      tone: 'semantic',
    },
    {
      german: "eine Aufgabe",
      translated: "një nga detyrat",
      tone: 'semantic',
    },
    {
      german: "der Polizei",
      translated: "e policisë",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "në Gjermani",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:148|sr": [
    {
      german: "Was ist",
      translated: "Koji je",
      tone: 'semantic',
    },
    {
      german: "eine Aufgabe",
      translated: "jedan od zadataka",
      tone: 'semantic',
    },
    {
      german: "der Polizei",
      translated: "policije",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "u Nemačkoj",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:148|tr": [
    {
      german: "Was ist",
      translated: "nedir",
      tone: 'semantic',
    },
    {
      german: "eine Aufgabe",
      translated: "görevlerinden biri",
      tone: 'semantic',
    },
    {
      german: "der Polizei",
      translated: "polisin",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "Almanya'da",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:148|uk": [
    {
      german: "Was ist",
      translated: "Яке",
      tone: 'semantic',
    },
    {
      german: "eine Aufgabe",
      translated: "завдання",
      tone: 'semantic',
    },
    {
      german: "der Polizei",
      translated: "поліція",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "в Німеччині",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:148|vi": [
    {
      german: "Was",
      translated: "gì?",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:149|ar": [
    {
      german: "Was ist",
      translated: "أي مما يلي",
      tone: 'semantic',
    },
    {
      german: "ein Beispiel",
      translated: "مثال",
      tone: 'semantic',
    },
    {
      german: "für",
      translated: "على",
      tone: 'semantic',
    },
    {
      german: "antisemitisches Verhalten",
      translated: "سلوك معادٍ للسامية",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:149|bg": [
    {
      german: "Was ist",
      translated: "Кое е",
      tone: 'semantic',
    },
    {
      german: "ein Beispiel",
      translated: "пример",
      tone: 'semantic',
    },
    {
      german: "für",
      translated: "за",
      tone: 'semantic',
    },
    {
      german: "antisemitisches Verhalten",
      translated: "антисемитско поведение",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:149|bs": [
    {
      german: "Was ist",
      translated: "Šta je",
      tone: 'semantic',
    },
    {
      german: "ein Beispiel",
      translated: "primjer",
      tone: 'semantic',
    },
    {
      german: "antisemitisches Verhalten",
      translated: "antisemitskog ponašanja?",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:149|el": [
    {
      german: "Was ist",
      translated: "Ποιο είναι",
      tone: 'semantic',
    },
    {
      german: "ein Beispiel",
      translated: "παράδειγμα",
      tone: 'semantic',
    },
    {
      german: "antisemitisches Verhalten",
      translated: "αντισημιτικής συμπεριφοράς",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:149|en": [
    {
      german: "Was ist",
      translated: "What is",
      tone: 'semantic',
    },
    {
      german: "ein Beispiel",
      translated: "an example",
      tone: 'semantic',
    },
    {
      german: "für",
      translated: "of",
      tone: 'semantic',
    },
    {
      german: "antisemitisches Verhalten",
      translated: "antisemitic behavior",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:149|es": [
    {
      german: "Was ist",
      translated: "¿Cuál es",
      tone: 'semantic',
    },
    {
      german: "ein Beispiel",
      translated: "un ejemplo",
      tone: 'semantic',
    },
    {
      german: "für",
      translated: "de",
      tone: 'semantic',
    },
    {
      german: "antisemitisches Verhalten",
      translated: "comportamiento antisemita",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:149|fa": [
    {
      german: "Was ist",
      translated: "کدام",
      tone: 'semantic',
    },
    {
      german: "ein Beispiel",
      translated: "نمونه‌ای",
      tone: 'semantic',
    },
    {
      german: "antisemitisches Verhalten",
      translated: "رفتار یهودستیزانه",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:149|fr": [
    {
      german: "Was ist",
      translated: "Quel est",
      tone: 'semantic',
    },
    {
      german: "ein Beispiel",
      translated: "un exemple",
      tone: 'semantic',
    },
    {
      german: "für",
      translated: "de",
      tone: 'semantic',
    },
    {
      german: "antisemitisches Verhalten",
      translated: "comportement antisémite",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:149|hr": [
    {
      german: "Was ist",
      translated: "Što je",
      tone: 'semantic',
    },
    {
      german: "ein Beispiel",
      translated: "primjer",
      tone: 'semantic',
    },
    {
      german: "antisemitisches Verhalten",
      translated: "antisemitskog ponašanja",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:149|it": [
    {
      german: "Was ist",
      translated: "Qual è",
      tone: 'semantic',
    },
    {
      german: "ein Beispiel",
      translated: "un esempio",
      tone: 'semantic',
    },
    {
      german: "für",
      translated: "di",
      tone: 'semantic',
    },
    {
      german: "antisemitisches Verhalten",
      translated: "comportamento antisemita",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:149|kmr": [
    {
      german: "ein Beispiel",
      translated: "nimûne",
      tone: 'semantic',
    },
    {
      german: "für",
      translated: "reftarê",
      tone: 'semantic',
    },
    {
      german: "antisemitisches Verhalten",
      translated: "antisemitîk",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:149|pl": [
    {
      german: "Was ist",
      translated: "Co jest",
      tone: 'semantic',
    },
    {
      german: "ein Beispiel",
      translated: "przykładem",
      tone: 'semantic',
    },
    {
      german: "antisemitisches Verhalten",
      translated: "zachowania antysemickiego",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:149|prs": [
    {
      german: "ein Beispiel",
      translated: "نمونه‌ای",
      tone: 'semantic',
    },
    {
      german: "für",
      translated: "از",
      tone: 'semantic',
    },
    {
      german: "antisemitisches Verhalten",
      translated: "رفتار یهودستیزانه",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:149|ro": [
    {
      german: "Was ist",
      translated: "Care este",
      tone: 'semantic',
    },
    {
      german: "ein Beispiel",
      translated: "un exemplu",
      tone: 'semantic',
    },
    {
      german: "für",
      translated: "de",
      tone: 'semantic',
    },
    {
      german: "antisemitisches Verhalten",
      translated: "comportament antisemit",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:149|ru": [
    {
      german: "Was ist",
      translated: "Что является",
      tone: 'semantic',
    },
    {
      german: "ein Beispiel",
      translated: "примером",
      tone: 'semantic',
    },
    {
      german: "antisemitisches Verhalten",
      translated: "антисемитского поведения",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:149|sq": [
    {
      german: "Was ist",
      translated: "Cili është",
      tone: 'semantic',
    },
    {
      german: "ein Beispiel",
      translated: "një shembull",
      tone: 'semantic',
    },
    {
      german: "antisemitisches Verhalten",
      translated: "sjelljes antisemitike",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:149|sr": [
    {
      german: "Was",
      translated: "šta",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:149|tr": [
    {
      german: "Was ist",
      translated: "Aşağıdakilerden hangisi",
      tone: 'semantic',
    },
    {
      german: "ein Beispiel",
      translated: "örnektir",
      tone: 'semantic',
    },
    {
      german: "antisemitisches Verhalten",
      translated: "antisemitik davranışa",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:149|uk": [
    {
      german: "Was ist",
      translated: "Що є",
      tone: 'semantic',
    },
    {
      german: "ein Beispiel",
      translated: "прикладом",
      tone: 'semantic',
    },
    {
      german: "antisemitisches Verhalten",
      translated: "антисемітської поведінки",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:149|vi": [
    {
      german: "Was ist",
      translated: "Đâu là",
      tone: 'semantic',
    },
    {
      german: "ein Beispiel",
      translated: "một ví dụ",
      tone: 'semantic',
    },
    {
      german: "für",
      translated: "về",
      tone: 'semantic',
    },
    {
      german: "antisemitisches Verhalten",
      translated: "hành vi bài Do Thái",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:14|ar": [
    {
      german: "Meinungsfreiheit",
      translated: "حرية الرأي",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "في ألمانيا",
      tone: 'semantic',
    },
    {
      german: "heißt",
      translated: "تعني",
      tone: 'semantic',
    },
    {
      german: "dass ich",
      translated: "أنني",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:14|bg": [
    {
      german: "Meinungsfreiheit",
      translated: "Свободата на изразяване",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "в Германия",
      tone: 'semantic',
    },
    {
      german: "heißt",
      translated: "означава",
      tone: 'semantic',
    },
    {
      german: "dass ich",
      translated: "че аз",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:14|bs": [
    {
      german: "Meinungsfreiheit",
      translated: "Sloboda mišljenja",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "u Njemačkoj",
      tone: 'semantic',
    },
    {
      german: "heißt",
      translated: "znači",
      tone: 'semantic',
    },
    {
      german: "dass ich",
      translated: "da",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:14|el": [
    {
      german: "Meinungsfreiheit",
      translated: "Η ελευθερία έκφρασης",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "στη Γερμανία",
      tone: 'semantic',
    },
    {
      german: "heißt",
      translated: "σημαίνει",
      tone: 'semantic',
    },
    {
      german: "dass ich",
      translated: "ότι εγώ",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:14|en": [
    {
      german: "Meinungsfreiheit",
      translated: "Freedom of speech",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "in Germany",
      tone: 'semantic',
    },
    {
      german: "heißt",
      translated: "means",
      tone: 'semantic',
    },
    {
      german: "dass ich",
      translated: "that I",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:14|es": [
    {
      german: "Meinungsfreiheit",
      translated: "libertad de expresión",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "en Alemania",
      tone: 'semantic',
    },
    {
      german: "heißt",
      translated: "significa",
      tone: 'semantic',
    },
    {
      german: "dass ich",
      translated: "que yo",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:14|fa": [
    {
      german: "Meinungsfreiheit",
      translated: "آزادی بیان",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "در آلمان",
      tone: 'semantic',
    },
    {
      german: "heißt",
      translated: "یعنی",
      tone: 'semantic',
    },
    {
      german: "dass ich",
      translated: "اینکه من …",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:14|fr": [
    {
      german: "Meinungsfreiheit",
      translated: "La liberté d’expression",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "en Allemagne",
      tone: 'semantic',
    },
    {
      german: "heißt",
      translated: "signifie",
      tone: 'semantic',
    },
    {
      german: "dass ich",
      translated: "que je",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:14|hr": [
    {
      german: "Meinungsfreiheit",
      translated: "Sloboda mišljenja",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "u Njemačkoj",
      tone: 'semantic',
    },
    {
      german: "heißt",
      translated: "znači",
      tone: 'semantic',
    },
    {
      german: "dass ich",
      translated: "da",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:14|it": [
    {
      german: "Meinungsfreiheit",
      translated: "libertà di espressione",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "in Germania",
      tone: 'semantic',
    },
    {
      german: "heißt",
      translated: "significa",
      tone: 'semantic',
    },
    {
      german: "dass ich",
      translated: "che io",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:14|kmr": [
    {
      german: "Meinungsfreiheit",
      translated: "Azadiya gotinê",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "li Almanyayê",
      tone: 'semantic',
    },
    {
      german: "heißt",
      translated: "tê wê wateyê",
      tone: 'semantic',
    },
    {
      german: "dass ich",
      translated: "ku ez",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:14|pl": [
    {
      german: "Meinungsfreiheit",
      translated: "Wolność słowa",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "w Niemczech",
      tone: 'semantic',
    },
    {
      german: "heißt",
      translated: "oznacza",
      tone: 'semantic',
    },
    {
      german: "dass ich",
      translated: "że",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:14|prs": [
    {
      german: "Meinungsfreiheit",
      translated: "آزادی بیان",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "در آلمان",
      tone: 'semantic',
    },
    {
      german: "heißt",
      translated: "یعنی",
      tone: 'semantic',
    },
    {
      german: "dass ich",
      translated: "اینکه من …",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:14|ro": [
    {
      german: "Meinungsfreiheit",
      translated: "Libertatea de exprimare",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "în Germania",
      tone: 'semantic',
    },
    {
      german: "heißt",
      translated: "înseamnă",
      tone: 'semantic',
    },
    {
      german: "dass ich",
      translated: "că eu",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:14|ru": [
    {
      german: "Meinungsfreiheit",
      translated: "Свобода слова",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "в Германии",
      tone: 'semantic',
    },
    {
      german: "heißt",
      translated: "означает",
      tone: 'semantic',
    },
    {
      german: "dass ich",
      translated: "что я",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:14|sq": [
    {
      german: "Meinungsfreiheit",
      translated: "Liria e shprehjes",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "në Gjermani",
      tone: 'semantic',
    },
    {
      german: "heißt",
      translated: "do të thotë",
      tone: 'semantic',
    },
    {
      german: "dass ich",
      translated: "se unë",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:14|sr": [
    {
      german: "Meinungsfreiheit",
      translated: "Sloboda mišljenja",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "u Nemačkoj",
      tone: 'semantic',
    },
    {
      german: "heißt",
      translated: "znači",
      tone: 'semantic',
    },
    {
      german: "dass ich",
      translated: "da",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:14|tr": [
    {
      german: "Meinungsfreiheit",
      translated: "düşünce ve ifade özgürlüğü",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "Almanya'da",
      tone: 'semantic',
    },
    {
      german: "heißt",
      translated: "anlamına gelir",
      tone: 'semantic',
    },
    {
      german: "dass ich",
      translated: "benim",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:14|uk": [
    {
      german: "Meinungsfreiheit",
      translated: "Свобода слова",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "в Німеччині",
      tone: 'semantic',
    },
    {
      german: "heißt",
      translated: "означає",
      tone: 'semantic',
    },
    {
      german: "dass ich",
      translated: "що я",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:14|vi": [
    {
      german: "Meinungsfreiheit",
      translated: "Tự do ngôn luận",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "ở Đức",
      tone: 'semantic',
    },
    {
      german: "heißt",
      translated: "có nghĩa là",
      tone: 'semantic',
    },
    {
      german: "dass ich",
      translated: "tôi",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:150|ar": [
    {
      german: "Eine Gerichtsschöffin",
      translated: "القاضي الشعبي",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "في محكمة ألمانية",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "هو",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:150|bg": [
    {
      german: "in Deutschland",
      translated: "в Германия",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "е",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:150|bs": [
    {
      german: "in Deutschland",
      translated: "u Njemačkoj",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "je",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:150|el": [
    {
      german: "in Deutschland",
      translated: "στη Γερμανία",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "είναι",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:150|en": [
    {
      german: "Eine Gerichtsschöffin",
      translated: "A court lay judge",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "in Germany",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "is",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:150|es": [
    {
      german: "Eine Gerichtsschöffin",
      translated: "Un juez lego",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "en un tribunal alemán",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "es",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:150|fa": [
    {
      german: "in Deutschland",
      translated: "در آلمان",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:150|fr": [
    {
      german: "Eine Gerichtsschöffin",
      translated: "Un juge non professionnel",
      tone: 'semantic',
    },
    {
      german: "ein Gerichtsschöffe",
      translated: "(Gerichtsschöffe)",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "en Allemagne",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "est",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:150|hr": [
    {
      german: "in Deutschland",
      translated: "u Njemačkoj",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "je",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:150|it": [
    {
      german: "in Deutschland",
      translated: "in Germania",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "è",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:150|kmr": [
    {
      german: "ein Gerichtsschöffe",
      translated: "Gerichtsschöffe",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "li Almanyayê",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:150|pl": [
    {
      german: "Eine Gerichtsschöffin",
      translated: "Ławniczka/ławnik",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "w Niemczech",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "to",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:150|prs": [
    {
      german: "in Deutschland",
      translated: "در آلمان",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "است",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:150|ro": [
    {
      german: "in Deutschland",
      translated: "în Germania",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "este",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:150|ru": [
    {
      german: "Eine Gerichtsschöffin",
      translated: "Народный заседатель",
      tone: 'semantic',
    },
    {
      german: "ein Gerichtsschöffe",
      translated: "(шеффен)",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "в Германии",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "это",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:150|sq": [
    {
      german: "Eine Gerichtsschöffin",
      translated: "Një gjyqtare",
      tone: 'semantic',
    },
    {
      german: "ein Gerichtsschöffe",
      translated: "gjyqtar",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "në Gjermani",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "është",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:150|sr": [
    {
      german: "in Deutschland",
      translated: "u Nemačkoj",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "je",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:150|tr": [
    {
      german: "Eine Gerichtsschöffin",
      translated: "mahkeme fahri hâkimi",
      tone: 'semantic',
    },
    {
      german: "ein Gerichtsschöffe",
      translated: "(Schöffe)",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "Almanya'da",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:150|uk": [
    {
      german: "Eine Gerichtsschöffin",
      translated: "шеффенка",
      tone: 'semantic',
    },
    {
      german: "ein Gerichtsschöffe",
      translated: "шеффен",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "у Німеччині",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "це",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:150|vi": [
    {
      german: "in Deutschland",
      translated: "ở Đức",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "là",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:151|ar": [
    {
      german: "Wer baute",
      translated: "من بنى",
      tone: 'semantic',
    },
    {
      german: "die Mauer",
      translated: "جدار",
      tone: 'semantic',
    },
    {
      german: "in Berlin",
      translated: "برلين",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:151|bg": [
    {
      german: "Wer baute",
      translated: "Кой построи",
      tone: 'semantic',
    },
    {
      german: "die Mauer",
      translated: "Берлинската стена",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:151|bs": [
    {
      german: "Wer baute",
      translated: "Ko je izgradio",
      tone: 'semantic',
    },
    {
      german: "die Mauer",
      translated: "Berlinski zid",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:151|el": [
    {
      german: "Wer baute",
      translated: "Ποιος έχτισε",
      tone: 'semantic',
    },
    {
      german: "die Mauer",
      translated: "το Τείχος",
      tone: 'semantic',
    },
    {
      german: "in Berlin",
      translated: "του Βερολίνου",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:151|en": [
    {
      german: "Wer baute",
      translated: "Who built",
      tone: 'semantic',
    },
    {
      german: "die Mauer",
      translated: "Wall",
      tone: 'semantic',
    },
    {
      german: "in Berlin",
      translated: "Berlin",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:151|es": [
    {
      german: "Wer baute",
      translated: "¿Quién construyó",
      tone: 'semantic',
    },
    {
      german: "die Mauer",
      translated: "el Muro",
      tone: 'semantic',
    },
    {
      german: "in Berlin",
      translated: "de Berlín",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:151|fa": [
    {
      german: "Wer baute",
      translated: "چه کسی",
      tone: 'semantic',
    },
    {
      german: "die Mauer",
      translated: "دیوار برلین",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:151|fr": [
    {
      german: "Wer baute",
      translated: "Qui a construit",
      tone: 'semantic',
    },
    {
      german: "die Mauer",
      translated: "le mur",
      tone: 'semantic',
    },
    {
      german: "in Berlin",
      translated: "de Berlin",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:151|hr": [
    {
      german: "Wer baute",
      translated: "Tko je izgradio",
      tone: 'semantic',
    },
    {
      german: "die Mauer",
      translated: "Berlinski zid",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:151|it": [
    {
      german: "Wer baute",
      translated: "Chi costruì",
      tone: 'semantic',
    },
    {
      german: "die Mauer",
      translated: "il Muro",
      tone: 'semantic',
    },
    {
      german: "in Berlin",
      translated: "di Berlino",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:151|kmr": [
    {
      german: "Wer",
      translated: "kî",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:151|pl": [
    {
      german: "Wer baute",
      translated: "Kto zbudował",
      tone: 'semantic',
    },
    {
      german: "die Mauer",
      translated: "Mur",
      tone: 'semantic',
    },
    {
      german: "in Berlin",
      translated: "Berliński",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:151|prs": [
    {
      german: "Wer baute",
      translated: "چه کسی",
      tone: 'semantic',
    },
    {
      german: "die Mauer",
      translated: "دیوار",
      tone: 'semantic',
    },
    {
      german: "in Berlin",
      translated: "برلین",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:151|ro": [
    {
      german: "Wer baute",
      translated: "Cine a construit",
      tone: 'semantic',
    },
    {
      german: "die Mauer",
      translated: "Zidul Berlinului",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:151|ru": [
    {
      german: "Wer baute",
      translated: "Кто построил",
      tone: 'semantic',
    },
    {
      german: "die Mauer",
      translated: "стену",
      tone: 'semantic',
    },
    {
      german: "in Berlin",
      translated: "Берлинскую",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:151|sq": [
    {
      german: "Wer baute",
      translated: "Kush e ndërtoi",
      tone: 'semantic',
    },
    {
      german: "die Mauer",
      translated: "Murin",
      tone: 'semantic',
    },
    {
      german: "in Berlin",
      translated: "e Berlinit?",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:151|sr": [
    {
      german: "Wer",
      translated: "ko",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:151|tr": [
    {
      german: "Wer baute",
      translated: "kim",
      tone: 'semantic',
    },
    {
      german: "die Mauer",
      translated: "Duvarı'nı",
      tone: 'semantic',
    },
    {
      german: "in Berlin",
      translated: "Berlin",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:151|uk": [
    {
      german: "Wer baute",
      translated: "Хто побудував",
      tone: 'semantic',
    },
    {
      german: "die Mauer",
      translated: "мур",
      tone: 'semantic',
    },
    {
      german: "in Berlin",
      translated: "Берлінський",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:151|vi": [
    {
      german: "Wer baute",
      translated: "Ai đã xây",
      tone: 'semantic',
    },
    {
      german: "die Mauer",
      translated: "Bức tường",
      tone: 'semantic',
    },
    {
      german: "in Berlin",
      translated: "Berlin",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:152|ar": [
    {
      german: "Wann waren",
      translated: "متى كان",
      tone: 'semantic',
    },
    {
      german: "die Nationalsozialisten",
      translated: "الاشتراكيون القوميون",
      tone: 'semantic',
    },
    {
      german: "mit Adolf Hitler",
      translated: "بقيادة أدولف هتلر",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "في ألمانيا",
      tone: 'semantic',
    },
    {
      german: "an der Macht",
      translated: "في السلطة",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:152|bg": [
    {
      german: "Wann waren",
      translated: "Кога",
      tone: 'semantic',
    },
    {
      german: "die Nationalsozialisten",
      translated: "националсоциалистите",
      tone: 'semantic',
    },
    {
      german: "mit Adolf Hitler",
      translated: "с Адолф Хитлер",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "в Германия",
      tone: 'semantic',
    },
    {
      german: "an der Macht",
      translated: "на власт",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:152|bs": [
    {
      german: "Wann waren",
      translated: "Kada su",
      tone: 'semantic',
    },
    {
      german: "die Nationalsozialisten",
      translated: "nacionalsocijalisti",
      tone: 'semantic',
    },
    {
      german: "mit Adolf Hitler",
      translated: "s Adolfom Hitlerom",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "u Njemačkoj",
      tone: 'semantic',
    },
    {
      german: "an der Macht",
      translated: "bili na vlasti",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:152|el": [
    {
      german: "Wann waren",
      translated: "Πότε ήταν",
      tone: 'semantic',
    },
    {
      german: "die Nationalsozialisten",
      translated: "οι εθνικοσοσιαλιστές",
      tone: 'semantic',
    },
    {
      german: "mit Adolf Hitler",
      translated: "με τον Αδόλφο Χίτλερ",
      tone: 'semantic',
    },
    {
      german: "an der Macht",
      translated: "στην εξουσία",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:152|en": [
    {
      german: "Wann waren",
      translated: "When were",
      tone: 'semantic',
    },
    {
      german: "die Nationalsozialisten",
      translated: "the National Socialists",
      tone: 'semantic',
    },
    {
      german: "mit Adolf Hitler",
      translated: "with Adolf Hitler",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "in Germany?",
      tone: 'semantic',
    },
    {
      german: "an der Macht",
      translated: "in power",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:152|es": [
    {
      german: "Wann waren",
      translated: "¿Cuándo estuvieron",
      tone: 'semantic',
    },
    {
      german: "die Nationalsozialisten",
      translated: "los nacionalsocialistas",
      tone: 'semantic',
    },
    {
      german: "mit Adolf Hitler",
      translated: "con Adolf Hitler",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "en Alemania",
      tone: 'semantic',
    },
    {
      german: "an der Macht",
      translated: "en el poder",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:152|fa": [
    {
      german: "Wann waren",
      translated: "چه زمانی",
      tone: 'semantic',
    },
    {
      german: "die Nationalsozialisten",
      translated: "ناسیونال‌سوسیالیست‌ها",
      tone: 'semantic',
    },
    {
      german: "mit Adolf Hitler",
      translated: "به رهبری آدولف هیتلر",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "در آلمان",
      tone: 'semantic',
    },
    {
      german: "an der Macht",
      translated: "در قدرت بودند",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:152|fr": [
    {
      german: "die Nationalsozialisten",
      translated: "les nationaux-socialistes",
      tone: 'semantic',
    },
    {
      german: "mit Adolf Hitler",
      translated: "dirigés par Adolf Hitler",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "en Allemagne",
      tone: 'semantic',
    },
    {
      german: "an der Macht",
      translated: "au pouvoir",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:152|hr": [
    {
      german: "Wann waren",
      translated: "Kada su",
      tone: 'semantic',
    },
    {
      german: "die Nationalsozialisten",
      translated: "nacionalsocijalisti",
      tone: 'semantic',
    },
    {
      german: "mit Adolf Hitler",
      translated: "s Adolfom Hitlerom",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "u Njemačkoj",
      tone: 'semantic',
    },
    {
      german: "an der Macht",
      translated: "na vlasti",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:152|it": [
    {
      german: "Wann waren",
      translated: "Quando furono",
      tone: 'semantic',
    },
    {
      german: "die Nationalsozialisten",
      translated: "i nazionalsocialisti",
      tone: 'semantic',
    },
    {
      german: "mit Adolf Hitler",
      translated: "con Adolf Hitler",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "in Germania",
      tone: 'semantic',
    },
    {
      german: "an der Macht",
      translated: "al potere",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:152|kmr": [
    {
      german: "die Nationalsozialisten",
      translated: "Naziyên",
      tone: 'semantic',
    },
    {
      german: "mit Adolf Hitler",
      translated: "bi serokatiya Adolf Hitler",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "li Almanyayê",
      tone: 'semantic',
    },
    {
      german: "an der Macht",
      translated: "li desthilatê",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:152|pl": [
    {
      german: "die Nationalsozialisten",
      translated: "narodowi socjaliści",
      tone: 'semantic',
    },
    {
      german: "mit Adolf Hitler",
      translated: "z Adolfem Hitlerem",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "w Niemczech?",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:152|prs": [
    {
      german: "Wann waren",
      translated: "چه زمانی",
      tone: 'semantic',
    },
    {
      german: "die Nationalsozialisten",
      translated: "ناسیونال‌سوسیالیست‌ها",
      tone: 'semantic',
    },
    {
      german: "mit Adolf Hitler",
      translated: "به رهبری آدولف هیتلر",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "در آلمان",
      tone: 'semantic',
    },
    {
      german: "an der Macht",
      translated: "در قدرت بودند",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:152|ro": [
    {
      german: "Wann waren",
      translated: "Când au fost",
      tone: 'semantic',
    },
    {
      german: "die Nationalsozialisten",
      translated: "național-socialiștii",
      tone: 'semantic',
    },
    {
      german: "mit Adolf Hitler",
      translated: "cu Adolf Hitler",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "în Germania",
      tone: 'semantic',
    },
    {
      german: "an der Macht",
      translated: "la putere",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:152|ru": [
    {
      german: "Wann waren",
      translated: "Когда",
      tone: 'semantic',
    },
    {
      german: "die Nationalsozialisten",
      translated: "национал-социалисты",
      tone: 'semantic',
    },
    {
      german: "mit Adolf Hitler",
      translated: "во главе с Адольфом Гитлером",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "в Германии",
      tone: 'semantic',
    },
    {
      german: "an der Macht",
      translated: "были у власти",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:152|sq": [
    {
      german: "Wann waren",
      translated: "Kur ishin",
      tone: 'semantic',
    },
    {
      german: "die Nationalsozialisten",
      translated: "nacionalsocialistët",
      tone: 'semantic',
    },
    {
      german: "mit Adolf Hitler",
      translated: "me Adolf Hitlerin",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "në Gjermani",
      tone: 'semantic',
    },
    {
      german: "an der Macht",
      translated: "në pushtet",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:152|sr": [
    {
      german: "Wann",
      translated: "kada",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:152|tr": [
    {
      german: "Wann waren",
      translated: "hangi yıllar arasında",
      tone: 'semantic',
    },
    {
      german: "die Nationalsozialisten",
      translated: "Nasyonal Sosyalistler",
      tone: 'semantic',
    },
    {
      german: "mit Adolf Hitler",
      translated: "Adolf Hitler liderliğindeki",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "Almanya'da",
      tone: 'semantic',
    },
    {
      german: "an der Macht",
      translated: "iktidardaydı",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:152|uk": [
    {
      german: "Wann waren",
      translated: "Коли",
      tone: 'semantic',
    },
    {
      german: "die Nationalsozialisten",
      translated: "націонал-соціалісти",
      tone: 'semantic',
    },
    {
      german: "mit Adolf Hitler",
      translated: "на чолі з Адольфом Гітлером?",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "Німеччині",
      tone: 'semantic',
    },
    {
      german: "an der Macht",
      translated: "при владі",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:152|vi": [
    {
      german: "Wann waren",
      translated: "Khi nào",
      tone: 'semantic',
    },
    {
      german: "die Nationalsozialisten",
      translated: "những người Quốc xã",
      tone: 'semantic',
    },
    {
      german: "mit Adolf Hitler",
      translated: "Adolf Hitler",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "ở Đức",
      tone: 'semantic',
    },
    {
      german: "an der Macht",
      translated: "nắm quyền",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:153|ar": [
    {
      german: "Was war",
      translated: "ماذا حدث",
      tone: 'semantic',
    },
    {
      german: "am 8. Mai",
      translated: "في 8 مايو/أيار",
      tone: 'semantic',
    },
    {
      german: "1945",
      translated: "1945",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:153|bg": [
    {
      german: "Was war",
      translated: "Какво се случи",
      tone: 'semantic',
    },
    {
      german: "am 8. Mai",
      translated: "на 8 май",
      tone: 'semantic',
    },
    {
      german: "1945",
      translated: "1945",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:153|bs": [
    {
      german: "Was war",
      translated: "Šta se dogodilo",
      tone: 'semantic',
    },
    {
      german: "am 8. Mai",
      translated: "8. maja",
      tone: 'semantic',
    },
    {
      german: "1945",
      translated: "1945",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:153|el": [
    {
      german: "Was war",
      translated: "Τι συνέβη",
      tone: 'semantic',
    },
    {
      german: "am 8. Mai",
      translated: "στις 8 Μαΐου",
      tone: 'semantic',
    },
    {
      german: "1945",
      translated: "1945",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:153|en": [
    {
      german: "Was war",
      translated: "What happened",
      tone: 'semantic',
    },
    {
      german: "am 8. Mai",
      translated: "on May 8",
      tone: 'semantic',
    },
    {
      german: "1945",
      translated: "1945",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:153|es": [
    {
      german: "Was war",
      translated: "¿Qué ocurrió",
      tone: 'semantic',
    },
    {
      german: "am 8. Mai",
      translated: "el 8 de mayo",
      tone: 'semantic',
    },
    {
      german: "1945",
      translated: "1945",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:153|fa": [
    {
      german: "am 8. Mai",
      translated: "در ۸ مه",
      tone: 'semantic',
    },
    {
      german: "1945",
      translated: "۱۹۴۵",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:153|fr": [
    {
      german: "Was war",
      translated: "Que s’est-il passé",
      tone: 'semantic',
    },
    {
      german: "am 8. Mai",
      translated: "le 8 mai",
      tone: 'semantic',
    },
    {
      german: "1945",
      translated: "1945",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:153|hr": [
    {
      german: "Was war",
      translated: "Što se dogodilo",
      tone: 'semantic',
    },
    {
      german: "am 8. Mai",
      translated: "8. svibnja",
      tone: 'semantic',
    },
    {
      german: "1945",
      translated: "1945",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:153|it": [
    {
      german: "Was war",
      translated: "Che cosa accadde",
      tone: 'semantic',
    },
    {
      german: "am 8. Mai",
      translated: "l'8 maggio",
      tone: 'semantic',
    },
    {
      german: "1945",
      translated: "1945",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:153|kmr": [
    {
      german: "Was war",
      translated: "çi bû?",
      tone: 'semantic',
    },
    {
      german: "am 8. Mai",
      translated: "8ê Gulana",
      tone: 'semantic',
    },
    {
      german: "1945",
      translated: "1945",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:153|pl": [
    {
      german: "Was war",
      translated: "Co wydarzyło się",
      tone: 'semantic',
    },
    {
      german: "am 8. Mai",
      translated: "8 maja",
      tone: 'semantic',
    },
    {
      german: "1945",
      translated: "1945",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:153|prs": [
    {
      german: "am 8. Mai",
      translated: "در ۸ می",
      tone: 'semantic',
    },
    {
      german: "1945",
      translated: "۱۹۴۵",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:153|ro": [
    {
      german: "Was war",
      translated: "Ce s-a întâmplat",
      tone: 'semantic',
    },
    {
      german: "am 8. Mai",
      translated: "la 8 mai",
      tone: 'semantic',
    },
    {
      german: "1945",
      translated: "1945",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:153|ru": [
    {
      german: "Was war",
      translated: "Что произошло",
      tone: 'semantic',
    },
    {
      german: "am 8. Mai",
      translated: "8 мая",
      tone: 'semantic',
    },
    {
      german: "1945",
      translated: "1945 года",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:153|sq": [
    {
      german: "Was war",
      translated: "Çfarë ndodhi",
      tone: 'semantic',
    },
    {
      german: "am 8. Mai",
      translated: "më 8 maj",
      tone: 'semantic',
    },
    {
      german: "1945",
      translated: "1945",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:153|sr": [
    {
      german: "Was war",
      translated: "Šta se dogodilo",
      tone: 'semantic',
    },
    {
      german: "am 8. Mai",
      translated: "8. maja",
      tone: 'semantic',
    },
    {
      german: "1945",
      translated: "1945",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:153|tr": [
    {
      german: "Was war",
      translated: "ne oldu?",
      tone: 'semantic',
    },
    {
      german: "am 8. Mai",
      translated: "8 Mayıs",
      tone: 'semantic',
    },
    {
      german: "1945",
      translated: "1945",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:153|uk": [
    {
      german: "Was war",
      translated: "Що сталося",
      tone: 'semantic',
    },
    {
      german: "am 8. Mai",
      translated: "8 травня",
      tone: 'semantic',
    },
    {
      german: "1945",
      translated: "1945",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:153|vi": [
    {
      german: "Was war",
      translated: "Điều gì đã xảy ra",
      tone: 'semantic',
    },
    {
      german: "am 8. Mai",
      translated: "vào ngày 8 tháng 5",
      tone: 'semantic',
    },
    {
      german: "1945",
      translated: "năm 1945",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:154|ar": [
    {
      german: "Wann",
      translated: "متى",
      tone: 'semantic',
    },
    {
      german: "der Zweite Weltkrieg",
      translated: "الحرب العالمية الثانية",
      tone: 'semantic',
    },
    {
      german: "zu Ende",
      translated: "انتهت",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:154|bg": [
    {
      german: "Wann",
      translated: "Кога",
      tone: 'semantic',
    },
    {
      german: "war",
      translated: "приключи",
      tone: 'semantic',
    },
    {
      german: "der Zweite Weltkrieg",
      translated: "Втората световна война",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:154|bs": [
    {
      german: "Wann",
      translated: "Kada",
      tone: 'semantic',
    },
    {
      german: "war",
      translated: "je",
      tone: 'semantic',
    },
    {
      german: "der Zweite Weltkrieg",
      translated: "Drugi svjetski rat",
      tone: 'semantic',
    },
    {
      german: "zu Ende",
      translated: "završen",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:154|el": [
    {
      german: "Wann",
      translated: "Πότε",
      tone: 'semantic',
    },
    {
      german: "der Zweite Weltkrieg",
      translated: "Δεύτερος Παγκόσμιος Πόλεμος",
      tone: 'semantic',
    },
    {
      german: "zu Ende",
      translated: "τελείωσε",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:154|en": [
    {
      german: "Wann",
      translated: "When",
      tone: 'semantic',
    },
    {
      german: "war",
      translated: "did",
      tone: 'semantic',
    },
    {
      german: "der Zweite Weltkrieg",
      translated: "World War II",
      tone: 'semantic',
    },
    {
      german: "zu Ende",
      translated: "end",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:154|es": [
    {
      german: "Wann",
      translated: "¿cuándo",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:154|fa": [
    {
      german: "Wann",
      translated: "چه زمانی",
      tone: 'semantic',
    },
    {
      german: "der Zweite Weltkrieg",
      translated: "جنگ جهانی دوم",
      tone: 'semantic',
    },
    {
      german: "zu Ende",
      translated: "پایان یافت",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:154|fr": [
    {
      german: "Wann",
      translated: "Quand",
      tone: 'semantic',
    },
    {
      german: "der Zweite Weltkrieg",
      translated: "la Seconde Guerre mondiale",
      tone: 'semantic',
    },
    {
      german: "zu Ende",
      translated: "pris fin",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:154|hr": [
    {
      german: "Wann",
      translated: "Kada",
      tone: 'semantic',
    },
    {
      german: "war",
      translated: "je",
      tone: 'semantic',
    },
    {
      german: "der Zweite Weltkrieg",
      translated: "Drugi svjetski rat",
      tone: 'semantic',
    },
    {
      german: "zu Ende",
      translated: "završio",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:154|it": [
    {
      german: "Wann",
      translated: "Quando",
      tone: 'semantic',
    },
    {
      german: "war",
      translated: "terminò",
      tone: 'semantic',
    },
    {
      german: "der Zweite Weltkrieg",
      translated: "la Seconda guerra mondiale",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:154|kmr": [
    {
      german: "Wann",
      translated: "Şerê",
      tone: 'semantic',
    },
    {
      german: "war",
      translated: "Cîhanê",
      tone: 'semantic',
    },
    {
      german: "der Zweite Weltkrieg",
      translated: "yê Duyemîn",
      tone: 'semantic',
    },
    {
      german: "zu Ende",
      translated: "kengê qediya",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:154|pl": [
    {
      german: "Wann",
      translated: "Kiedy",
      tone: 'semantic',
    },
    {
      german: "war",
      translated: "zakończyła się",
      tone: 'semantic',
    },
    {
      german: "der Zweite Weltkrieg",
      translated: "II wojna światowa",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:154|prs": [
    {
      german: "Wann",
      translated: "چه زمانی",
      tone: 'semantic',
    },
    {
      german: "der Zweite Weltkrieg",
      translated: "جنگ جهانی دوم",
      tone: 'semantic',
    },
    {
      german: "zu Ende",
      translated: "پایان یافت",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:154|ro": [
    {
      german: "Wann",
      translated: "Când",
      tone: 'semantic',
    },
    {
      german: "war",
      translated: "s-a",
      tone: 'semantic',
    },
    {
      german: "der Zweite Weltkrieg",
      translated: "cel de-al Doilea Război Mondial",
      tone: 'semantic',
    },
    {
      german: "zu Ende",
      translated: "încheiat",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:154|ru": [
    {
      german: "Wann",
      translated: "Когда",
      tone: 'semantic',
    },
    {
      german: "der Zweite Weltkrieg",
      translated: "Вторая мировая война",
      tone: 'semantic',
    },
    {
      german: "zu Ende",
      translated: "закончилась",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:154|sq": [
    {
      german: "Wann",
      translated: "Kur",
      tone: 'semantic',
    },
    {
      german: "war",
      translated: "përfundoi",
      tone: 'semantic',
    },
    {
      german: "der Zweite Weltkrieg",
      translated: "Lufta e Dytë Botërore",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:154|sr": [
    {
      german: "Wann",
      translated: "Kada",
      tone: 'semantic',
    },
    {
      german: "war",
      translated: "je",
      tone: 'semantic',
    },
    {
      german: "der Zweite Weltkrieg",
      translated: "Drugi svetski rat",
      tone: 'semantic',
    },
    {
      german: "zu Ende",
      translated: "završen",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:154|tr": [
    {
      german: "Wann",
      translated: "ne zaman",
      tone: 'semantic',
    },
    {
      german: "der Zweite Weltkrieg",
      translated: "İkinci Dünya Savaşı",
      tone: 'semantic',
    },
    {
      german: "zu Ende",
      translated: "sona",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:154|uk": [
    {
      german: "Wann",
      translated: "коли",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:154|vi": [
    {
      german: "Wann",
      translated: "khi nào",
      tone: 'semantic',
    },
    {
      german: "der Zweite Weltkrieg",
      translated: "Chiến tranh thế giới thứ hai",
      tone: 'semantic',
    },
    {
      german: "zu Ende",
      translated: "kết thúc",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:155|ar": [
    {
      german: "Wann",
      translated: "متى",
      tone: 'semantic',
    },
    {
      german: "waren",
      translated: "كان",
      tone: 'semantic',
    },
    {
      german: "die Nationalsozialisten",
      translated: "الاشتراكيون القوميون",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "في ألمانيا",
      tone: 'semantic',
    },
    {
      german: "an der Macht",
      translated: "؟",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:155|bg": [
    {
      german: "Wann",
      translated: "Кога",
      tone: 'semantic',
    },
    {
      german: "waren",
      translated: "са били",
      tone: 'semantic',
    },
    {
      german: "die Nationalsozialisten",
      translated: "националсоциалистите",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "в Германия",
      tone: 'semantic',
    },
    {
      german: "an der Macht",
      translated: "на власт",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:155|bs": [
    {
      german: "Wann",
      translated: "Kada",
      tone: 'semantic',
    },
    {
      german: "waren",
      translated: "su",
      tone: 'semantic',
    },
    {
      german: "die Nationalsozialisten",
      translated: "nacionalsocijalisti",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "u Njemačkoj",
      tone: 'semantic',
    },
    {
      german: "an der Macht",
      translated: "na vlasti",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:155|el": [
    {
      german: "Wann",
      translated: "Πότε",
      tone: 'semantic',
    },
    {
      german: "waren",
      translated: "ήταν",
      tone: 'semantic',
    },
    {
      german: "die Nationalsozialisten",
      translated: "οι εθνικοσοσιαλιστές",
      tone: 'semantic',
    },
    {
      german: "an der Macht",
      translated: "εξουσία",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:155|en": [
    {
      german: "Wann",
      translated: "When",
      tone: 'semantic',
    },
    {
      german: "waren",
      translated: "were",
      tone: 'semantic',
    },
    {
      german: "die Nationalsozialisten",
      translated: "the National Socialists",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "in Germany",
      tone: 'semantic',
    },
    {
      german: "an der Macht",
      translated: "in power",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:155|es": [
    {
      german: "Wann",
      translated: "¿Cuándo",
      tone: 'semantic',
    },
    {
      german: "waren",
      translated: "estuvieron",
      tone: 'semantic',
    },
    {
      german: "die Nationalsozialisten",
      translated: "los nacionalsocialistas",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "en Alemania",
      tone: 'semantic',
    },
    {
      german: "an der Macht",
      translated: "en el poder",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:155|fa": [
    {
      german: "Wann",
      translated: "چه زمانی",
      tone: 'semantic',
    },
    {
      german: "waren",
      translated: "بودند",
      tone: 'semantic',
    },
    {
      german: "die Nationalsozialisten",
      translated: "ناسیونال‌سوسیالیست‌ها",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "در آلمان",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:155|fr": [
    {
      german: "Wann",
      translated: "Quand",
      tone: 'semantic',
    },
    {
      german: "waren",
      translated: "étaient-ils",
      tone: 'semantic',
    },
    {
      german: "die Nationalsozialisten",
      translated: "les nationaux-socialistes",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "en Allemagne",
      tone: 'semantic',
    },
    {
      german: "an der Macht",
      translated: "au pouvoir",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:155|hr": [
    {
      german: "Wann",
      translated: "Kada",
      tone: 'semantic',
    },
    {
      german: "waren",
      translated: "su",
      tone: 'semantic',
    },
    {
      german: "die Nationalsozialisten",
      translated: "nacionalsocijalisti",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "u Njemačkoj",
      tone: 'semantic',
    },
    {
      german: "an der Macht",
      translated: "na vlasti",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:155|it": [
    {
      german: "Wann",
      translated: "Quando",
      tone: 'semantic',
    },
    {
      german: "waren",
      translated: "furono",
      tone: 'semantic',
    },
    {
      german: "die Nationalsozialisten",
      translated: "i nazionalsocialisti",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "in Germania",
      tone: 'semantic',
    },
    {
      german: "an der Macht",
      translated: "al potere",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:155|kmr": [
    {
      german: "Wann",
      translated: "kengê",
      tone: 'semantic',
    },
    {
      german: "waren",
      translated: "bûn",
      tone: 'semantic',
    },
    {
      german: "die Nationalsozialisten",
      translated: "Nazî",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "li Almanyayê",
      tone: 'semantic',
    },
    {
      german: "an der Macht",
      translated: "li desthilatê",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:155|pl": [
    {
      german: "Wann",
      translated: "Kiedy",
      tone: 'semantic',
    },
    {
      german: "waren",
      translated: "byli",
      tone: 'semantic',
    },
    {
      german: "die Nationalsozialisten",
      translated: "narodowi socjaliści",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "w Niemczech",
      tone: 'semantic',
    },
    {
      german: "an der Macht",
      translated: "u władzy",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:155|prs": [
    {
      german: "Wann",
      translated: "چه زمانی",
      tone: 'semantic',
    },
    {
      german: "waren",
      translated: "بودند؟",
      tone: 'semantic',
    },
    {
      german: "die Nationalsozialisten",
      translated: "ناسیونال‌سوسیالیست‌ها",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "در آلمان",
      tone: 'semantic',
    },
    {
      german: "an der Macht",
      translated: "در قدرت",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:155|ro": [
    {
      german: "Wann",
      translated: "Când",
      tone: 'semantic',
    },
    {
      german: "waren",
      translated: "au fost",
      tone: 'semantic',
    },
    {
      german: "die Nationalsozialisten",
      translated: "național-socialiștii",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "în Germania?",
      tone: 'semantic',
    },
    {
      german: "an der Macht",
      translated: "la putere",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:155|ru": [
    {
      german: "Wann",
      translated: "Когда",
      tone: 'semantic',
    },
    {
      german: "waren",
      translated: "были",
      tone: 'semantic',
    },
    {
      german: "die Nationalsozialisten",
      translated: "национал-социалисты",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "в Германии",
      tone: 'semantic',
    },
    {
      german: "an der Macht",
      translated: "у власти",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:155|sq": [
    {
      german: "Wann",
      translated: "Kur",
      tone: 'semantic',
    },
    {
      german: "waren",
      translated: "ishin",
      tone: 'semantic',
    },
    {
      german: "die Nationalsozialisten",
      translated: "nacionalsocialistët",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "në Gjermani",
      tone: 'semantic',
    },
    {
      german: "an der Macht",
      translated: "në pushtet",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:155|sr": [
    {
      german: "Wann",
      translated: "kada",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:155|tr": [
    {
      german: "Wann",
      translated: "hangi yıllar arasında",
      tone: 'semantic',
    },
    {
      german: "die Nationalsozialisten",
      translated: "Nasyonal Sosyalistler",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "Almanya'da",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:155|uk": [
    {
      german: "Wann",
      translated: "Коли",
      tone: 'semantic',
    },
    {
      german: "waren",
      translated: "були",
      tone: 'semantic',
    },
    {
      german: "die Nationalsozialisten",
      translated: "націонал-соціалісти",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "в Німеччині",
      tone: 'semantic',
    },
    {
      german: "an der Macht",
      translated: "при владі",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:155|vi": [
    {
      german: "Wann",
      translated: "Khi nào",
      tone: 'semantic',
    },
    {
      german: "die Nationalsozialisten",
      translated: "những người Quốc xã",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "ở Đức",
      tone: 'semantic',
    },
    {
      german: "an der Macht",
      translated: "nắm quyền",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:156|ar": [
    {
      german: "In welchem Jahr",
      translated: "في أي سنة",
      tone: 'semantic',
    },
    {
      german: "wurde",
      translated: "أصبح",
      tone: 'semantic',
    },
    {
      german: "Hitler",
      translated: "هتلر",
      tone: 'semantic',
    },
    {
      german: "Reichskanzler",
      translated: "مستشار الرايخ",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:156|bg": [
    {
      german: "In welchem Jahr",
      translated: "През коя година",
      tone: 'semantic',
    },
    {
      german: "Hitler",
      translated: "Хитлер",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:156|bs": [
    {
      german: "In welchem Jahr",
      translated: "Koje godine",
      tone: 'semantic',
    },
    {
      german: "wurde",
      translated: "je",
      tone: 'semantic',
    },
    {
      german: "Hitler",
      translated: "Hitler",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:156|el": [
    {
      german: "In welchem Jahr",
      translated: "Σε ποιο έτος",
      tone: 'semantic',
    },
    {
      german: "wurde",
      translated: "έγινε",
      tone: 'semantic',
    },
    {
      german: "Hitler",
      translated: "ο Χίτλερ",
      tone: 'semantic',
    },
    {
      german: "Reichskanzler",
      translated: "καγκελάριος του Ράιχ",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:156|en": [
    {
      german: "In welchem Jahr",
      translated: "In what year",
      tone: 'semantic',
    },
    {
      german: "Hitler",
      translated: "Hitler",
      tone: 'semantic',
    },
    {
      german: "Reichskanzler",
      translated: "Reich Chancellor",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:156|es": [
    {
      german: "In welchem Jahr",
      translated: "¿En qué año",
      tone: 'semantic',
    },
    {
      german: "wurde",
      translated: "se convirtió",
      tone: 'semantic',
    },
    {
      german: "Hitler",
      translated: "Hitler",
      tone: 'semantic',
    },
    {
      german: "Reichskanzler",
      translated: "en Canciller del Reich",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:156|fa": [
    {
      german: "In welchem Jahr",
      translated: "در چه سالی",
      tone: 'semantic',
    },
    {
      german: "Hitler",
      translated: "هیتلر",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:156|fr": [
    {
      german: "In welchem Jahr",
      translated: "En quelle année",
      tone: 'semantic',
    },
    {
      german: "wurde",
      translated: "devenu",
      tone: 'semantic',
    },
    {
      german: "Hitler",
      translated: "Hitler",
      tone: 'semantic',
    },
    {
      german: "Reichskanzler",
      translated: "chancelier du Reich",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:156|hr": [
    {
      german: "In welchem Jahr",
      translated: "Koje je godine",
      tone: 'semantic',
    },
    {
      german: "Hitler",
      translated: "Hitler",
      tone: 'semantic',
    },
    {
      german: "Reichskanzler",
      translated: "kancelar Reicha",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:156|it": [
    {
      german: "In welchem Jahr",
      translated: "In quale anno",
      tone: 'semantic',
    },
    {
      german: "Hitler",
      translated: "Hitler",
      tone: 'semantic',
    },
    {
      german: "Reichskanzler",
      translated: "cancelliere del Reich",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:156|kmr": [
    {
      german: "In welchem Jahr",
      translated: "di kîjan salê",
      tone: 'semantic',
    },
    {
      german: "wurde",
      translated: "bû",
      tone: 'semantic',
    },
    {
      german: "Hitler",
      translated: "Hitler",
      tone: 'semantic',
    },
    {
      german: "Reichskanzler",
      translated: "Reichskanzler",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:156|pl": [
    {
      german: "In welchem Jahr",
      translated: "W którym roku",
      tone: 'semantic',
    },
    {
      german: "wurde",
      translated: "został",
      tone: 'semantic',
    },
    {
      german: "Hitler",
      translated: "Hitler",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:156|prs": [
    {
      german: "In welchem Jahr",
      translated: "در کدام سال",
      tone: 'semantic',
    },
    {
      german: "wurde",
      translated: "شد",
      tone: 'semantic',
    },
    {
      german: "Hitler",
      translated: "هیتلر",
      tone: 'semantic',
    },
    {
      german: "Reichskanzler",
      translated: "صدراعظم رایش",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:156|ro": [
    {
      german: "In welchem Jahr",
      translated: "În ce an",
      tone: 'semantic',
    },
    {
      german: "wurde",
      translated: "a devenit",
      tone: 'semantic',
    },
    {
      german: "Hitler",
      translated: "Hitler",
      tone: 'semantic',
    },
    {
      german: "Reichskanzler",
      translated: "cancelar al Reichului",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:156|ru": [
    {
      german: "In welchem Jahr",
      translated: "В каком году",
      tone: 'semantic',
    },
    {
      german: "wurde",
      translated: "стал",
      tone: 'semantic',
    },
    {
      german: "Hitler",
      translated: "Гитлер",
      tone: 'semantic',
    },
    {
      german: "Reichskanzler",
      translated: "рейхсканцлером",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:156|sq": [
    {
      german: "In welchem Jahr",
      translated: "Në cilin vit",
      tone: 'semantic',
    },
    {
      german: "wurde",
      translated: "u bë",
      tone: 'semantic',
    },
    {
      german: "Hitler",
      translated: "Hitleri",
      tone: 'semantic',
    },
    {
      german: "Reichskanzler",
      translated: "kancelar i Rajhut",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:156|sr": [
    {
      german: "In welchem Jahr",
      translated: "Koje godine",
      tone: 'semantic',
    },
    {
      german: "wurde",
      translated: "je",
      tone: 'semantic',
    },
    {
      german: "Hitler",
      translated: "Hitler",
      tone: 'semantic',
    },
    {
      german: "Reichskanzler",
      translated: "kancelar Rajha",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:156|tr": [
    {
      german: "In welchem Jahr",
      translated: "hangi yıl",
      tone: 'semantic',
    },
    {
      german: "wurde",
      translated: "oldu",
      tone: 'semantic',
    },
    {
      german: "Hitler",
      translated: "Hitler",
      tone: 'semantic',
    },
    {
      german: "Reichskanzler",
      translated: "Reich Şansölyesi",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:156|uk": [
    {
      german: "In welchem Jahr",
      translated: "У якому році",
      tone: 'semantic',
    },
    {
      german: "wurde",
      translated: "став",
      tone: 'semantic',
    },
    {
      german: "Hitler",
      translated: "Гітлер",
      tone: 'semantic',
    },
    {
      german: "Reichskanzler",
      translated: "рейхсканцлером",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:156|vi": [
    {
      german: "In welchem Jahr",
      translated: "năm nào",
      tone: 'semantic',
    },
    {
      german: "wurde",
      translated: "trở thành",
      tone: 'semantic',
    },
    {
      german: "Hitler",
      translated: "Hitler",
      tone: 'semantic',
    },
    {
      german: "Reichskanzler",
      translated: "Thủ tướng Đế chế",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:157|ar": [
    {
      german: "Die Nationalsozialisten",
      translated: "الاشتراكيون القوميون",
      tone: 'semantic',
    },
    {
      german: "mit Adolf Hitler",
      translated: "بقيادة أدولف هتلر",
      tone: 'semantic',
    },
    {
      german: "errichteten 1933",
      translated: "عام 1933",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "في ألمانيا",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:157|bg": [
    {
      german: "in Deutschland",
      translated: "в Германия",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:157|bs": [
    {
      german: "in Deutschland",
      translated: "u Njemačkoj",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:157|el": [
    {
      german: "in Deutschland",
      translated: "στη Γερμανία",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:157|en": [
    {
      german: "Die Nationalsozialisten",
      translated: "The National Socialists",
      tone: 'semantic',
    },
    {
      german: "mit Adolf Hitler",
      translated: "with Adolf Hitler",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "in Germany",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:157|es": [
    {
      german: "Die Nationalsozialisten",
      translated: "Los nacionalsocialistas",
      tone: 'semantic',
    },
    {
      german: "mit Adolf Hitler",
      translated: "con Adolf Hitler",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "en Alemania",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:157|fa": [
    {
      german: "in Deutschland",
      translated: "در آلمان",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:157|fr": [
    {
      german: "Die Nationalsozialisten",
      translated: "les nationaux-socialistes",
      tone: 'semantic',
    },
    {
      german: "mit Adolf Hitler",
      translated: "dirigés par Adolf Hitler",
      tone: 'semantic',
    },
    {
      german: "errichteten 1933",
      translated: "ont instauré",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "en Allemagne",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:157|hr": [
    {
      german: "in Deutschland",
      translated: "u Njemačkoj",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:157|it": [
    {
      german: "in Deutschland",
      translated: "in Germania",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:157|kmr": [
    {
      german: "Die Nationalsozialisten",
      translated: "Naziyên",
      tone: 'semantic',
    },
    {
      german: "mit Adolf Hitler",
      translated: "bi Adolf Hitler",
      tone: 'semantic',
    },
    {
      german: "errichteten 1933",
      translated: "di 1933 de",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "li Almanyayê",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:157|pl": [
    {
      german: "in Deutschland",
      translated: "w Niemczech",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:157|prs": [
    {
      german: "Die Nationalsozialisten",
      translated: "ناسیونال‌سوسیالیست‌ها",
      tone: 'semantic',
    },
    {
      german: "mit Adolf Hitler",
      translated: "به رهبری آدولف هیتلر",
      tone: 'semantic',
    },
    {
      german: "errichteten 1933",
      translated: "در سال ۱۹۳۳",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "در آلمان",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:157|ro": [
    {
      german: "in Deutschland",
      translated: "Germania",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:157|ru": [
    {
      german: "Die Nationalsozialisten",
      translated: "Национал-социалисты",
      tone: 'semantic',
    },
    {
      german: "mit Adolf Hitler",
      translated: "во главе с Адольфом Гитлером",
      tone: 'semantic',
    },
    {
      german: "errichteten 1933",
      translated: "установили в Германии в 1933 году",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:157|sq": [
    {
      german: "in Deutschland",
      translated: "në Gjermani",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:157|sr": [
    {
      german: "in Deutschland",
      translated: "u Nemačkoj",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:157|tr": [
    {
      german: "Die Nationalsozialisten",
      translated: "Nasyonal Sosyalistler",
      tone: 'semantic',
    },
    {
      german: "mit Adolf Hitler",
      translated: "Adolf Hitler liderliğindeki",
      tone: 'semantic',
    },
    {
      german: "errichteten 1933",
      translated: "1933'te",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "Almanya'da",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:157|uk": [
    {
      german: "Die Nationalsozialisten",
      translated: "націонал-соціалісти",
      tone: 'semantic',
    },
    {
      german: "mit Adolf Hitler",
      translated: "на чолі з Адольфом Гітлером",
      tone: 'semantic',
    },
    {
      german: "errichteten 1933",
      translated: "У 1933 році",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "в Німеччині",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:157|vi": [
    {
      german: "in Deutschland",
      translated: "ở Đức",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:158|ar": [
    {
      german: "war",
      translated: "كان",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:158|bg": [
    {
      german: "\"Dritte Reich\"",
      translated: "„Третият райх“",
      tone: 'semantic',
    },
    {
      german: "war",
      translated: "беше",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:158|bs": [
    {
      german: "\"Dritte Reich\"",
      translated: "„Treći Reich“",
      tone: 'semantic',
    },
    {
      german: "war",
      translated: "bio",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:158|el": [
    {
      german: "Das",
      translated: "Το",
      tone: 'semantic',
    },
    {
      german: "\"Dritte Reich\"",
      translated: "«Τρίτο Ράιχ»",
      tone: 'semantic',
    },
    {
      german: "war",
      translated: "ήταν",
      tone: 'semantic',
    },
    {
      german: "eine",
      translated: "μια",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:158|en": [
    {
      german: "Das",
      translated: "The",
      tone: 'semantic',
    },
    {
      german: "\"Dritte Reich\"",
      translated: "'Third Reich'",
      tone: 'semantic',
    },
    {
      german: "war",
      translated: "was",
      tone: 'semantic',
    },
    {
      german: "eine",
      translated: "a",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:158|es": [
    {
      german: "Das",
      translated: "El",
      tone: 'semantic',
    },
    {
      german: "\"Dritte Reich\"",
      translated: "«Tercer Reich»",
      tone: 'semantic',
    },
    {
      german: "war",
      translated: "fue",
      tone: 'semantic',
    },
    {
      german: "eine",
      translated: "una",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:158|fa": [
    {
      german: "\"Dritte Reich\"",
      translated: "رایش سوم",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:158|fr": [
    {
      german: "Das",
      translated: "Le",
      tone: 'semantic',
    },
    {
      german: "\"Dritte Reich\"",
      translated: "« Troisième Reich »",
      tone: 'semantic',
    },
    {
      german: "war",
      translated: "était",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:158|hr": [
    {
      german: "\"Dritte Reich\"",
      translated: "„Treći Reich“",
      tone: 'semantic',
    },
    {
      german: "war",
      translated: "bio",
      tone: 'semantic',
    },
    {
      german: "eine",
      translated: "je",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:158|it": [
    {
      german: "Das",
      translated: "Il",
      tone: 'semantic',
    },
    {
      german: "\"Dritte Reich\"",
      translated: "«Terzo Reich»",
      tone: 'semantic',
    },
    {
      german: "war",
      translated: "era",
      tone: 'semantic',
    },
    {
      german: "eine",
      translated: "una",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:158|kmr": [
    {
      german: "\"Dritte Reich\"",
      translated: "Reicha Sêyemîn",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:158|pl": [
    {
      german: "\"Dritte Reich\"",
      translated: "„Trzecia Rzesza”",
      tone: 'semantic',
    },
    {
      german: "war",
      translated: "była",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:158|prs": [
    {
      german: "\"Dritte Reich\"",
      translated: "رایش سوم",
      tone: 'semantic',
    },
    {
      german: "war",
      translated: "بود",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:158|ro": [
    {
      german: "\"Dritte Reich\"",
      translated: "Al Treilea Reich",
      tone: 'semantic',
    },
    {
      german: "war",
      translated: "a fost",
      tone: 'semantic',
    },
    {
      german: "eine",
      translated: "o",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:158|ru": [
    {
      german: "\"Dritte Reich\"",
      translated: "«Третий рейх»",
      tone: 'semantic',
    },
    {
      german: "war",
      translated: "был",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:158|sq": [
    {
      german: "eine",
      translated: "një",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:158|sr": [
    {
      german: "\"Dritte Reich\"",
      translated: "„Treći rajh“",
      tone: 'semantic',
    },
    {
      german: "war",
      translated: "bio",
      tone: 'semantic',
    },
    {
      german: "eine",
      translated: "je",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:158|tr": [
    {
      german: "\"Dritte Reich\"",
      translated: "\"Üçüncü Reich\"",
      tone: 'semantic',
    },
    {
      german: "war",
      translated: "idi",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:158|uk": [
    {
      german: "\"Dritte Reich\"",
      translated: "«Третій рейх»",
      tone: 'semantic',
    },
    {
      german: "war",
      translated: "був",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:158|vi": [
    {
      german: "\"Dritte Reich\"",
      translated: "Đệ Tam Đế chế",
      tone: 'semantic',
    },
    {
      german: "war",
      translated: "là",
      tone: 'semantic',
    },
    {
      german: "eine",
      translated: "một",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:159|ar": [
    {
      german: "Was gab es",
      translated: "أي مما يلي لم يكن موجودًا",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "في ألمانيا",
      tone: 'semantic',
    },
    {
      german: "während der Zeit",
      translated: "خلال الحقبة",
      tone: 'semantic',
    },
    {
      german: "des Nationalsozialismus",
      translated: "النازية",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:159|bg": [
    {
      german: "Was gab es",
      translated: "Какво не е имало",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "в Германия",
      tone: 'semantic',
    },
    {
      german: "während der Zeit",
      translated: "по време на",
      tone: 'semantic',
    },
    {
      german: "des Nationalsozialismus",
      translated: "националсоциализма",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:159|bs": [
    {
      german: "Was gab es",
      translated: "Čega nije bilo",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "u Njemačkoj",
      tone: 'semantic',
    },
    {
      german: "während der Zeit",
      translated: "za vrijeme",
      tone: 'semantic',
    },
    {
      german: "des Nationalsozialismus",
      translated: "nacionalsocijalizma",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:159|el": [
    {
      german: "Was gab es",
      translated: "Τι δεν υπήρχε",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "στη Γερμανία",
      tone: 'semantic',
    },
    {
      german: "während der Zeit",
      translated: "κατά την περίοδο",
      tone: 'semantic',
    },
    {
      german: "des Nationalsozialismus",
      translated: "του εθνικοσοσιαλισμού;",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:159|en": [
    {
      german: "Was gab es",
      translated: "What did",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "in Germany",
      tone: 'semantic',
    },
    {
      german: "nicht",
      translated: "NOT",
      tone: 'semantic',
    },
    {
      german: "während der Zeit",
      translated: "during",
      tone: 'semantic',
    },
    {
      german: "des Nationalsozialismus",
      translated: "National Socialist",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:159|es": [
    {
      german: "Was gab es",
      translated: "¿Qué NO existía",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "en Alemania",
      tone: 'semantic',
    },
    {
      german: "während der Zeit",
      translated: "durante la época",
      tone: 'semantic',
    },
    {
      german: "des Nationalsozialismus",
      translated: "nacionalsocialista",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:159|fa": [
    {
      german: "Was gab es",
      translated: "کدام مورد",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "در آلمان",
      tone: 'semantic',
    },
    {
      german: "nicht",
      translated: "نداشت",
      tone: 'semantic',
    },
    {
      german: "während der Zeit",
      translated: "در دوران",
      tone: 'semantic',
    },
    {
      german: "des Nationalsozialismus",
      translated: "ناسیونال‌سوسیالیسم",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:159|fr": [
    {
      german: "Was gab es",
      translated: "Qu’est-ce qui",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "en Allemagne",
      tone: 'semantic',
    },
    {
      german: "nicht",
      translated: "pas",
      tone: 'semantic',
    },
    {
      german: "während der Zeit",
      translated: "pendant la période du",
      tone: 'semantic',
    },
    {
      german: "des Nationalsozialismus",
      translated: "national-socialisme",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:159|hr": [
    {
      german: "Was gab es",
      translated: "Čega nije bilo",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "u Njemačkoj",
      tone: 'semantic',
    },
    {
      german: "während der Zeit",
      translated: "tijekom",
      tone: 'semantic',
    },
    {
      german: "des Nationalsozialismus",
      translated: "nacionalsocijalizma?",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:159|it": [
    {
      german: "Was gab es",
      translated: "Che cosa non esisteva",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "in Germania",
      tone: 'semantic',
    },
    {
      german: "während der Zeit",
      translated: "durante il periodo",
      tone: 'semantic',
    },
    {
      german: "des Nationalsozialismus",
      translated: "del nazionalsocialismo",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:159|kmr": [
    {
      german: "Was gab es",
      translated: "de kîjan",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "li Almanyayê",
      tone: 'semantic',
    },
    {
      german: "nicht",
      translated: "tune",
      tone: 'semantic',
    },
    {
      german: "des Nationalsozialismus",
      translated: "Nazîtiyê",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:159|pl": [
    {
      german: "Was gab es",
      translated: "Czego nie było",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "w Niemczech",
      tone: 'semantic',
    },
    {
      german: "während der Zeit",
      translated: "w okresie",
      tone: 'semantic',
    },
    {
      german: "des Nationalsozialismus",
      translated: "narodowego socjalizmu",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:159|prs": [
    {
      german: "Was gab es",
      translated: "کدام مورد وجود نداشت",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "در آلمان",
      tone: 'semantic',
    },
    {
      german: "während der Zeit",
      translated: "در دوران",
      tone: 'semantic',
    },
    {
      german: "des Nationalsozialismus",
      translated: "ناسیونال‌سوسیالیسم",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:159|ro": [
    {
      german: "Was gab es",
      translated: "Ce nu a existat",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "în Germania",
      tone: 'semantic',
    },
    {
      german: "während der Zeit",
      translated: "în perioada",
      tone: 'semantic',
    },
    {
      german: "des Nationalsozialismus",
      translated: "național-socialismului",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:159|ru": [
    {
      german: "Was gab es",
      translated: "Чего не было",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "в Германии",
      tone: 'semantic',
    },
    {
      german: "während der Zeit",
      translated: "во времена",
      tone: 'semantic',
    },
    {
      german: "des Nationalsozialismus",
      translated: "национал-социализма",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:159|sq": [
    {
      german: "nicht",
      translated: "nuk",
      tone: 'semantic',
    },
    {
      german: "des Nationalsozialismus",
      translated: "nacionalsocializmit?",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:159|sr": [
    {
      german: "Was gab es",
      translated: "Čega nije bilo",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "u Nemačkoj",
      tone: 'semantic',
    },
    {
      german: "während der Zeit",
      translated: "za vreme",
      tone: 'semantic',
    },
    {
      german: "des Nationalsozialismus",
      translated: "nacionalsocijalizma",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:159|tr": [
    {
      german: "Was gab es",
      translated: "aşağıdakilerden hangisi",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "Almanya'da",
      tone: 'semantic',
    },
    {
      german: "nicht",
      translated: "yoktu",
      tone: 'semantic',
    },
    {
      german: "während der Zeit",
      translated: "döneminde",
      tone: 'semantic',
    },
    {
      german: "des Nationalsozialismus",
      translated: "Nasyonal Sosyalizm",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:159|uk": [
    {
      german: "Was gab es",
      translated: "Чого",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "в Німеччині",
      tone: 'semantic',
    },
    {
      german: "nicht",
      translated: "не",
      tone: 'semantic',
    },
    {
      german: "während der Zeit",
      translated: "за часів",
      tone: 'semantic',
    },
    {
      german: "des Nationalsozialismus",
      translated: "націонал-соціалізму?",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:159|vi": [
    {
      german: "Was",
      translated: "gì",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:15|ar": [
    {
      german: "Was verbietet",
      translated: "ماذا يحظر",
      tone: 'semantic',
    },
    {
      german: "das deutsche Grundgesetz",
      translated: "القانون الأساسي الألماني",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:15|bg": [
    {
      german: "Was verbietet",
      translated: "Какво забранява",
      tone: 'semantic',
    },
    {
      german: "das deutsche Grundgesetz",
      translated: "германският Основен закон",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:15|bs": [
    {
      german: "das deutsche Grundgesetz",
      translated: "njemački Temeljni zakon",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:15|el": [
    {
      german: "Was verbietet",
      translated: "Τι απαγορεύει",
      tone: 'semantic',
    },
    {
      german: "das deutsche Grundgesetz",
      translated: "ο γερμανικός Θεμελιώδης Νόμος",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:15|en": [
    {
      german: "Was verbietet",
      translated: "What does",
      tone: 'semantic',
    },
    {
      german: "das deutsche Grundgesetz",
      translated: "the German Basic Law",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:15|es": [
    {
      german: "Was verbietet",
      translated: "¿Qué prohíbe",
      tone: 'semantic',
    },
    {
      german: "das deutsche Grundgesetz",
      translated: "la Ley Fundamental alemana",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:15|fa": [
    {
      german: "Was verbietet",
      translated: "چه چیزی را ممنوع می‌کند",
      tone: 'semantic',
    },
    {
      german: "das deutsche Grundgesetz",
      translated: "قانون اساسی آلمان",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:15|fr": [
    {
      german: "Was verbietet",
      translated: "Que interdit",
      tone: 'semantic',
    },
    {
      german: "das deutsche Grundgesetz",
      translated: "la Loi fondamentale allemande",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:15|hr": [
    {
      german: "Was",
      translated: "što",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:15|it": [
    {
      german: "Was verbietet",
      translated: "Che cosa vieta",
      tone: 'semantic',
    },
    {
      german: "das deutsche Grundgesetz",
      translated: "la Legge fondamentale tedesca",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:15|kmr": [
    {
      german: "Was verbietet",
      translated: "çi qedexe dike",
      tone: 'semantic',
    },
    {
      german: "das deutsche Grundgesetz",
      translated: "Qanûna Bingehîn a Almanyayê",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:15|pl": [
    {
      german: "Was verbietet",
      translated: "Czego zabrania",
      tone: 'semantic',
    },
    {
      german: "das deutsche Grundgesetz",
      translated: "niemiecka Ustawa Zasadnicza",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:15|prs": [
    {
      german: "Was verbietet",
      translated: "چه چیزی را ممنوع می‌کند؟",
      tone: 'semantic',
    },
    {
      german: "das deutsche Grundgesetz",
      translated: "قانون اساسی آلمان",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:15|ro": [
    {
      german: "Was verbietet",
      translated: "Ce interzice",
      tone: 'semantic',
    },
    {
      german: "das deutsche Grundgesetz",
      translated: "Legea fundamentală germană",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:15|ru": [
    {
      german: "Was verbietet",
      translated: "Что запрещает",
      tone: 'semantic',
    },
    {
      german: "das deutsche Grundgesetz",
      translated: "Основной закон Германии",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:15|sq": [
    {
      german: "Was verbietet",
      translated: "Çfarë ndalon",
      tone: 'semantic',
    },
    {
      german: "das deutsche Grundgesetz",
      translated: "Ligji Themelor gjerman",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:15|sr": [
    {
      german: "Was verbietet",
      translated: "Šta",
      tone: 'semantic',
    },
    {
      german: "das deutsche Grundgesetz",
      translated: "Osnovni zakon",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:15|tr": [
    {
      german: "Was verbietet",
      translated: "hangisini yasaklar",
      tone: 'semantic',
    },
    {
      german: "das deutsche Grundgesetz",
      translated: "Alman Anayasası",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:15|uk": [
    {
      german: "Was verbietet",
      translated: "Що забороняє",
      tone: 'semantic',
    },
    {
      german: "das deutsche Grundgesetz",
      translated: "Основний закон Німеччини",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:15|vi": [
    {
      german: "Was verbietet",
      translated: "cấm điều gì?",
      tone: 'semantic',
    },
    {
      german: "das deutsche Grundgesetz",
      translated: "Luật Cơ bản của Đức",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:160|ar": [
    {
      german: "Welcher Krieg",
      translated: "أي حرب",
      tone: 'semantic',
    },
    {
      german: "dauerte",
      translated: "استمرت",
      tone: 'semantic',
    },
    {
      german: "von 1939",
      translated: "من عام 1939",
      tone: 'semantic',
    },
    {
      german: "bis 1945",
      translated: "إلى عام 1945",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:160|bg": [
    {
      german: "Welcher Krieg",
      translated: "Коя война",
      tone: 'semantic',
    },
    {
      german: "dauerte",
      translated: "продължи",
      tone: 'semantic',
    },
    {
      german: "von 1939",
      translated: "от 1939",
      tone: 'semantic',
    },
    {
      german: "bis 1945",
      translated: "до 1945",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:160|bs": [
    {
      german: "Welcher Krieg",
      translated: "Koji je rat",
      tone: 'semantic',
    },
    {
      german: "dauerte",
      translated: "trajao",
      tone: 'semantic',
    },
    {
      german: "von 1939",
      translated: "od 1939.",
      tone: 'semantic',
    },
    {
      german: "bis 1945",
      translated: "do 1945.",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:160|el": [
    {
      german: "Welcher Krieg",
      translated: "Ποιος πόλεμος",
      tone: 'semantic',
    },
    {
      german: "dauerte",
      translated: "διήρκεσε",
      tone: 'semantic',
    },
    {
      german: "von 1939",
      translated: "από το 1939",
      tone: 'semantic',
    },
    {
      german: "bis 1945",
      translated: "έως το 1945",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:160|en": [
    {
      german: "Welcher Krieg",
      translated: "Which war",
      tone: 'semantic',
    },
    {
      german: "dauerte",
      translated: "lasted",
      tone: 'semantic',
    },
    {
      german: "von 1939",
      translated: "from 1939",
      tone: 'semantic',
    },
    {
      german: "bis 1945",
      translated: "to 1945",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:160|es": [
    {
      german: "Welcher Krieg",
      translated: "¿Qué guerra",
      tone: 'semantic',
    },
    {
      german: "dauerte",
      translated: "duró",
      tone: 'semantic',
    },
    {
      german: "von 1939",
      translated: "de 1939",
      tone: 'semantic',
    },
    {
      german: "bis 1945",
      translated: "a 1945",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:160|fa": [
    {
      german: "Welcher Krieg",
      translated: "کدام جنگ",
      tone: 'semantic',
    },
    {
      german: "dauerte",
      translated: "ادامه داشت",
      tone: 'semantic',
    },
    {
      german: "von 1939",
      translated: "از سال ۱۹۳۹",
      tone: 'semantic',
    },
    {
      german: "bis 1945",
      translated: "تا ۱۹۴۵",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:160|fr": [
    {
      german: "Welcher Krieg",
      translated: "Quelle guerre",
      tone: 'semantic',
    },
    {
      german: "dauerte",
      translated: "a duré",
      tone: 'semantic',
    },
    {
      german: "von 1939",
      translated: "de 1939",
      tone: 'semantic',
    },
    {
      german: "bis 1945",
      translated: "à 1945",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:160|hr": [
    {
      german: "Welcher Krieg",
      translated: "Koji je rat",
      tone: 'semantic',
    },
    {
      german: "dauerte",
      translated: "trajao",
      tone: 'semantic',
    },
    {
      german: "von 1939",
      translated: "od 1939.",
      tone: 'semantic',
    },
    {
      german: "bis 1945",
      translated: "do 1945.",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:160|it": [
    {
      german: "Welcher Krieg",
      translated: "Quale guerra",
      tone: 'semantic',
    },
    {
      german: "dauerte",
      translated: "durò",
      tone: 'semantic',
    },
    {
      german: "von 1939",
      translated: "dal 1939",
      tone: 'semantic',
    },
    {
      german: "bis 1945",
      translated: "al 1945",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:160|kmr": [
    {
      german: "Welcher Krieg",
      translated: "Kîjan şer",
      tone: 'semantic',
    },
    {
      german: "dauerte",
      translated: "dom",
      tone: 'semantic',
    },
    {
      german: "von 1939",
      translated: "ji 1939",
      tone: 'semantic',
    },
    {
      german: "bis 1945",
      translated: "heta 1945",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:160|pl": [
    {
      german: "Welcher Krieg",
      translated: "Która wojna",
      tone: 'semantic',
    },
    {
      german: "dauerte",
      translated: "trwała",
      tone: 'semantic',
    },
    {
      german: "von 1939",
      translated: "od 1939",
      tone: 'semantic',
    },
    {
      german: "bis 1945",
      translated: "do 1945",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:160|prs": [
    {
      german: "Welcher Krieg",
      translated: "کدام جنگ",
      tone: 'semantic',
    },
    {
      german: "dauerte",
      translated: "ادامه داشت",
      tone: 'semantic',
    },
    {
      german: "von 1939",
      translated: "از سال ۱۹۳۹",
      tone: 'semantic',
    },
    {
      german: "bis 1945",
      translated: "تا ۱۹۴۵",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:160|ro": [
    {
      german: "Welcher Krieg",
      translated: "Care război",
      tone: 'semantic',
    },
    {
      german: "dauerte",
      translated: "a durat",
      tone: 'semantic',
    },
    {
      german: "von 1939",
      translated: "din 1939",
      tone: 'semantic',
    },
    {
      german: "bis 1945",
      translated: "până în 1945",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:160|ru": [
    {
      german: "Welcher Krieg",
      translated: "Какая война",
      tone: 'semantic',
    },
    {
      german: "dauerte",
      translated: "длилась",
      tone: 'semantic',
    },
    {
      german: "von 1939",
      translated: "с 1939",
      tone: 'semantic',
    },
    {
      german: "bis 1945",
      translated: "по 1945",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:160|sq": [
    {
      german: "Welcher Krieg",
      translated: "Cila luftë",
      tone: 'semantic',
    },
    {
      german: "dauerte",
      translated: "zgjati",
      tone: 'semantic',
    },
    {
      german: "von 1939",
      translated: "nga viti 1939",
      tone: 'semantic',
    },
    {
      german: "bis 1945",
      translated: "deri më 1945",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:160|sr": [
    {
      german: "Welcher Krieg",
      translated: "Koji je rat",
      tone: 'semantic',
    },
    {
      german: "dauerte",
      translated: "trajao",
      tone: 'semantic',
    },
    {
      german: "von 1939",
      translated: "od 1939.",
      tone: 'semantic',
    },
    {
      german: "bis 1945",
      translated: "do 1945.",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:160|tr": [
    {
      german: "Welcher Krieg",
      translated: "savaş hangisidir?",
      tone: 'semantic',
    },
    {
      german: "dauerte",
      translated: "süren",
      tone: 'semantic',
    },
    {
      german: "von 1939",
      translated: "1939'dan",
      tone: 'semantic',
    },
    {
      german: "bis 1945",
      translated: "1945'e",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:160|uk": [
    {
      german: "Welcher Krieg",
      translated: "Яка війна",
      tone: 'semantic',
    },
    {
      german: "dauerte",
      translated: "тривала",
      tone: 'semantic',
    },
    {
      german: "von 1939",
      translated: "з 1939",
      tone: 'semantic',
    },
    {
      german: "bis 1945",
      translated: "до 1945",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:160|vi": [
    {
      german: "Welcher Krieg",
      translated: "Cuộc chiến nào",
      tone: 'semantic',
    },
    {
      german: "dauerte",
      translated: "kéo dài",
      tone: 'semantic',
    },
    {
      german: "von 1939",
      translated: "từ năm 1939",
      tone: 'semantic',
    },
    {
      german: "bis 1945",
      translated: "đến năm 1945",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:161|ar": [
    {
      german: "Was kennzeichnete den NS-Staat",
      translated: "بماذا تميزت دولة النازية؟",
      tone: 'semantic',
    },
    {
      german: "Eine Politik",
      translated: "بسياسة",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:161|bg": [
    {
      german: "Was kennzeichnete den NS-Staat",
      translated: "Какво характеризира националсоциалистическата държава",
      tone: 'semantic',
    },
    {
      german: "Eine Politik",
      translated: "Политика",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:161|bs": [
    {
      german: "Was kennzeichnete den NS-Staat",
      translated: "Što je obilježavalo nacionalsocijalističku državu",
      tone: 'semantic',
    },
    {
      german: "Eine Politik",
      translated: "Politika",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:161|el": [
    {
      german: "Was kennzeichnete den NS-Staat",
      translated: "Τι χαρακτήριζε το εθνικοσοσιαλιστικό κράτος;",
      tone: 'semantic',
    },
    {
      german: "Eine Politik",
      translated: "Μια πολιτική",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:161|en": [
    {
      german: "Was kennzeichnete den NS-Staat",
      translated: "What characterized the Nazi state",
      tone: 'semantic',
    },
    {
      german: "Eine Politik",
      translated: "A policy",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:161|es": [
    {
      german: "Was kennzeichnete den NS-Staat",
      translated: "¿Qué caracterizaba al Estado nazi?",
      tone: 'semantic',
    },
    {
      german: "Eine Politik",
      translated: "Una política",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:161|fa": [
    {
      german: "Was kennzeichnete den NS-Staat",
      translated: "ویژگی دولت ناسیونال‌سوسیالیستی چه بود",
      tone: 'semantic',
    },
    {
      german: "Eine Politik",
      translated: "؟ سیاستِ …",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:161|fr": [
    {
      german: "Was kennzeichnete den NS-Staat",
      translated: "Qu’est-ce qui caractérisait l’État nazi ?",
      tone: 'semantic',
    },
    {
      german: "Eine Politik",
      translated: "Une politique",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:161|hr": [
    {
      german: "Was kennzeichnete den NS-Staat",
      translated: "Što je obilježavalo nacionalsocijalističku državu",
      tone: 'semantic',
    },
    {
      german: "Eine Politik",
      translated: "Politika",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:161|it": [
    {
      german: "Was kennzeichnete den NS-Staat",
      translated: "Che cosa caratterizzava lo Stato nazionalsocialista",
      tone: 'semantic',
    },
    {
      german: "Eine Politik",
      translated: "Una politica",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:161|kmr": [
    {
      german: "Was kennzeichnete den NS-Staat",
      translated: "Dewleta Nazî bi çi taybetmendî dihat naskirin",
      tone: 'semantic',
    },
    {
      german: "Eine Politik",
      translated: "Bi siyaseta",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:161|pl": [
    {
      german: "Was kennzeichnete den NS-Staat",
      translated: "Co charakteryzowało państwo narodowosocjalistyczne",
      tone: 'semantic',
    },
    {
      german: "Eine Politik",
      translated: "Polityka",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:161|prs": [
    {
      german: "Was kennzeichnete den NS-Staat",
      translated: "ویژگی دولت ناسیونال‌سوسیالیستی چه بود؟",
      tone: 'semantic',
    },
    {
      german: "Eine Politik",
      translated: "سیاستِ",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:161|ro": [
    {
      german: "Was kennzeichnete den NS-Staat",
      translated: "Ce a caracterizat statul național-socialist",
      tone: 'semantic',
    },
    {
      german: "Eine Politik",
      translated: "O politică",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:161|ru": [
    {
      german: "Was kennzeichnete den NS-Staat",
      translated: "Что было характерно для нацистского государства",
      tone: 'semantic',
    },
    {
      german: "Eine Politik",
      translated: "Политика",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:161|sq": [
    {
      german: "Was kennzeichnete den NS-Staat",
      translated: "Çfarë e karakterizonte shtetin nacionalsocialist",
      tone: 'semantic',
    },
    {
      german: "Eine Politik",
      translated: "Një politikë",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:161|sr": [
    {
      german: "Was kennzeichnete den NS-Staat",
      translated: "Šta je obilježavalo nacionalsocijalističku državu",
      tone: 'semantic',
    },
    {
      german: "Eine Politik",
      translated: "Politika",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:161|tr": [
    {
      german: "Was kennzeichnete den NS-Staat",
      translated: "Nazi devletini",
      tone: 'semantic',
    },
    {
      german: "Eine Politik",
      translated: "hangi politika",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:161|uk": [
    {
      german: "Was kennzeichnete den NS-Staat",
      translated: "Що характеризувало нацистську державу",
      tone: 'semantic',
    },
    {
      german: "Eine Politik",
      translated: "Політика",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:161|vi": [
    {
      german: "Was kennzeichnete den NS-Staat",
      translated: "Điều gì đặc trưng cho nhà nước Quốc xã",
      tone: 'semantic',
    },
    {
      german: "Eine Politik",
      translated: "Một chính sách",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:162|ar": [
    {
      german: "Claus Schenk",
      translated: "كلاوس شينك",
      tone: 'semantic',
    },
    {
      german: "Graf von Stauffenberg",
      translated: "غراف فون شتاوفنبرغ",
      tone: 'semantic',
    },
    {
      german: "wurde bekannt",
      translated: "اشتهر",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:162|bg": [
    {
      german: "Claus Schenk",
      translated: "Клаус Шенк",
      tone: 'semantic',
    },
    {
      german: "Graf von Stauffenberg",
      translated: "граф фон Щауфенберг",
      tone: 'semantic',
    },
    {
      german: "wurde bekannt",
      translated: "е известен",
      tone: 'semantic',
    },
    {
      german: "durch",
      translated: "С",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:162|bs": [
    {
      german: "Claus Schenk",
      translated: "Claus Schenk",
      tone: 'semantic',
    },
    {
      german: "Graf von Stauffenberg",
      translated: "Graf von Stauffenberg",
      tone: 'semantic',
    },
    {
      german: "wurde bekannt",
      translated: "je poznat",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:162|el": [
    {
      german: "Claus Schenk",
      translated: "Claus Schenk",
      tone: 'semantic',
    },
    {
      german: "Graf von Stauffenberg",
      translated: "Graf von Stauffenberg",
      tone: 'semantic',
    },
    {
      german: "wurde bekannt",
      translated: "είναι γνωστός",
      tone: 'semantic',
    },
    {
      german: "durch",
      translated: "Για ποιο λόγο",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:162|en": [
    {
      german: "Claus Schenk",
      translated: "Claus Schenk",
      tone: 'semantic',
    },
    {
      german: "Graf von Stauffenberg",
      translated: "Graf von Stauffenberg",
      tone: 'semantic',
    },
    {
      german: "wurde bekannt",
      translated: "became famous",
      tone: 'semantic',
    },
    {
      german: "durch",
      translated: "for",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:162|es": [
    {
      german: "Claus Schenk",
      translated: "Claus Schenk",
      tone: 'semantic',
    },
    {
      german: "Graf von Stauffenberg",
      translated: "Graf von Stauffenberg",
      tone: 'semantic',
    },
    {
      german: "wurde bekannt",
      translated: "se hizo famoso",
      tone: 'semantic',
    },
    {
      german: "durch",
      translated: "por",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:162|fa": [
    {
      german: "Claus Schenk",
      translated: "کلاوس شنک",
      tone: 'semantic',
    },
    {
      german: "Graf von Stauffenberg",
      translated: "گراف فون اشتاوفنبرگ",
      tone: 'semantic',
    },
    {
      german: "wurde bekannt",
      translated: "مشهور شد",
      tone: 'semantic',
    },
    {
      german: "durch",
      translated: "به",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:162|fr": [
    {
      german: "Claus Schenk",
      translated: "Claus Schenk",
      tone: 'semantic',
    },
    {
      german: "Graf von Stauffenberg",
      translated: "Graf von Stauffenberg",
      tone: 'semantic',
    },
    {
      german: "wurde bekannt",
      translated: "est devenu célèbre",
      tone: 'semantic',
    },
    {
      german: "durch",
      translated: "grâce à",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:162|hr": [
    {
      german: "Claus Schenk",
      translated: "Claus Schenk",
      tone: 'semantic',
    },
    {
      german: "Graf von Stauffenberg",
      translated: "Graf von Stauffenberg",
      tone: 'semantic',
    },
    {
      german: "wurde bekannt",
      translated: "poznat",
      tone: 'semantic',
    },
    {
      german: "durch",
      translated: "Po čemu",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:162|it": [
    {
      german: "Claus Schenk",
      translated: "Claus Schenk",
      tone: 'semantic',
    },
    {
      german: "Graf von Stauffenberg",
      translated: "Graf von Stauffenberg",
      tone: 'semantic',
    },
    {
      german: "wurde bekannt",
      translated: "è noto",
      tone: 'semantic',
    },
    {
      german: "durch",
      translated: "Per",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:162|kmr": [
    {
      german: "Claus Schenk",
      translated: "Claus Schenk",
      tone: 'semantic',
    },
    {
      german: "Graf von Stauffenberg",
      translated: "Graf von Stauffenberg",
      tone: 'semantic',
    },
    {
      german: "wurde bekannt",
      translated: "navdar bû?",
      tone: 'semantic',
    },
    {
      german: "durch",
      translated: "bi",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:162|pl": [
    {
      german: "Claus Schenk",
      translated: "Claus Schenk",
      tone: 'semantic',
    },
    {
      german: "Graf von Stauffenberg",
      translated: "Graf von Stauffenberg",
      tone: 'semantic',
    },
    {
      german: "wurde bekannt",
      translated: "znany jest",
      tone: 'semantic',
    },
    {
      german: "durch",
      translated: "Z",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:162|prs": [
    {
      german: "Claus Schenk",
      translated: "کلاوس شنک",
      tone: 'semantic',
    },
    {
      german: "Graf von Stauffenberg",
      translated: "گراف فون اشتاوفنبرگ",
      tone: 'semantic',
    },
    {
      german: "wurde bekannt",
      translated: "مشهور شد",
      tone: 'semantic',
    },
    {
      german: "durch",
      translated: "به چه دلیل",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:162|ro": [
    {
      german: "Claus Schenk",
      translated: "Claus Schenk",
      tone: 'semantic',
    },
    {
      german: "Graf von Stauffenberg",
      translated: "Graf von Stauffenberg",
      tone: 'semantic',
    },
    {
      german: "wurde bekannt",
      translated: "este cunoscut",
      tone: 'semantic',
    },
    {
      german: "durch",
      translated: "De ce",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:162|ru": [
    {
      german: "Claus Schenk",
      translated: "Клаус Шенк",
      tone: 'semantic',
    },
    {
      german: "Graf von Stauffenberg",
      translated: "граф фон Штауффенберг",
      tone: 'semantic',
    },
    {
      german: "wurde bekannt",
      translated: "стал известен",
      tone: 'semantic',
    },
    {
      german: "durch",
      translated: "благодаря",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:162|sq": [
    {
      german: "Claus Schenk",
      translated: "Claus Schenk",
      tone: 'semantic',
    },
    {
      german: "Graf von Stauffenberg",
      translated: "Graf von Stauffenberg",
      tone: 'semantic',
    },
    {
      german: "wurde bekannt",
      translated: "njihet",
      tone: 'semantic',
    },
    {
      german: "durch",
      translated: "Për",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:162|sr": [
    {
      german: "Claus Schenk",
      translated: "Claus Schenk",
      tone: 'semantic',
    },
    {
      german: "Graf von Stauffenberg",
      translated: "Graf von Stauffenberg",
      tone: 'semantic',
    },
    {
      german: "wurde bekannt",
      translated: "je poznat",
      tone: 'semantic',
    },
    {
      german: "durch",
      translated: "Po",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:162|tr": [
    {
      german: "Claus Schenk",
      translated: "Claus Schenk",
      tone: 'semantic',
    },
    {
      german: "Graf von Stauffenberg",
      translated: "Graf von Stauffenberg",
      tone: 'semantic',
    },
    {
      german: "wurde bekannt",
      translated: "tanınmıştır",
      tone: 'semantic',
    },
    {
      german: "durch",
      translated: "neyle",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:162|uk": [
    {
      german: "Claus Schenk",
      translated: "Клаус Шенк",
      tone: 'semantic',
    },
    {
      german: "Graf von Stauffenberg",
      translated: "граф фон Штауффенберг",
      tone: 'semantic',
    },
    {
      german: "wurde bekannt",
      translated: "став відомим",
      tone: 'semantic',
    },
    {
      german: "durch",
      translated: "завдяки",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:162|vi": [
    {
      german: "Claus Schenk",
      translated: "Claus Schenk",
      tone: 'semantic',
    },
    {
      german: "Graf von Stauffenberg",
      translated: "Graf von Stauffenberg",
      tone: 'semantic',
    },
    {
      german: "wurde bekannt",
      translated: "nổi tiếng",
      tone: 'semantic',
    },
    {
      german: "durch",
      translated: "vì",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:163|ar": [
    {
      german: "In welchem Jahr",
      translated: "في أي سنة",
      tone: 'semantic',
    },
    {
      german: "zerstörten",
      translated: "دمّر",
      tone: 'semantic',
    },
    {
      german: "die Nationalsozialisten",
      translated: "النازيون",
      tone: 'semantic',
    },
    {
      german: "Synagogen und jüdische Geschäfte",
      translated: "المعابد اليهودية والمتاجر اليهودية",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "في ألمانيا",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:163|bg": [
    {
      german: "In welchem Jahr",
      translated: "През коя година",
      tone: 'semantic',
    },
    {
      german: "zerstörten",
      translated: "разрушават",
      tone: 'semantic',
    },
    {
      german: "die Nationalsozialisten",
      translated: "националсоциалистите",
      tone: 'semantic',
    },
    {
      german: "Synagogen und jüdische Geschäfte",
      translated: "синагоги и еврейски магазини",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "в Германия",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:163|bs": [
    {
      german: "In welchem Jahr",
      translated: "Koje su godine",
      tone: 'semantic',
    },
    {
      german: "zerstörten",
      translated: "uništavali",
      tone: 'semantic',
    },
    {
      german: "die Nationalsozialisten",
      translated: "nacionalsocijalisti",
      tone: 'semantic',
    },
    {
      german: "Synagogen und jüdische Geschäfte",
      translated: "sinagoge i jevrejske trgovine",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "u Njemačkoj",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:163|el": [
    {
      german: "In welchem Jahr",
      translated: "Σε ποιο έτος",
      tone: 'semantic',
    },
    {
      german: "zerstörten",
      translated: "κατέστρεψαν",
      tone: 'semantic',
    },
    {
      german: "die Nationalsozialisten",
      translated: "οι εθνικοσοσιαλιστές",
      tone: 'semantic',
    },
    {
      german: "Synagogen und jüdische Geschäfte",
      translated: "συναγωγές και εβραϊκά καταστήματα",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "στη Γερμανία",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:163|en": [
    {
      german: "In welchem Jahr",
      translated: "In what year",
      tone: 'semantic',
    },
    {
      german: "zerstörten",
      translated: "destroy",
      tone: 'semantic',
    },
    {
      german: "die Nationalsozialisten",
      translated: "the National Socialists",
      tone: 'semantic',
    },
    {
      german: "Synagogen und jüdische Geschäfte",
      translated: "synagogues and Jewish businesses",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "in Germany",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:163|es": [
    {
      german: "In welchem Jahr",
      translated: "¿En qué año",
      tone: 'semantic',
    },
    {
      german: "zerstörten",
      translated: "destruyeron",
      tone: 'semantic',
    },
    {
      german: "die Nationalsozialisten",
      translated: "los nacionalsocialistas",
      tone: 'semantic',
    },
    {
      german: "Synagogen und jüdische Geschäfte",
      translated: "sinagogas y comercios judíos",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "en Alemania",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:163|fa": [
    {
      german: "In welchem Jahr",
      translated: "در چه سالی",
      tone: 'semantic',
    },
    {
      german: "zerstörten",
      translated: "ویران کردند",
      tone: 'semantic',
    },
    {
      german: "die Nationalsozialisten",
      translated: "ناسیونال‌سوسیالیست‌ها",
      tone: 'semantic',
    },
    {
      german: "Synagogen und jüdische Geschäfte",
      translated: "کنیسه‌ها و مغازه‌های یهودیان",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "در آلمان",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:163|fr": [
    {
      german: "In welchem Jahr",
      translated: "En quelle année",
      tone: 'semantic',
    },
    {
      german: "zerstörten",
      translated: "ont-ils détruit",
      tone: 'semantic',
    },
    {
      german: "die Nationalsozialisten",
      translated: "les nationaux-socialistes",
      tone: 'semantic',
    },
    {
      german: "Synagogen und jüdische Geschäfte",
      translated: "des synagogues et des commerces juifs",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "en Allemagne",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:163|hr": [
    {
      german: "In welchem Jahr",
      translated: "Koje su godine",
      tone: 'semantic',
    },
    {
      german: "zerstörten",
      translated: "uništavali",
      tone: 'semantic',
    },
    {
      german: "die Nationalsozialisten",
      translated: "nacionalsocijalisti",
      tone: 'semantic',
    },
    {
      german: "Synagogen und jüdische Geschäfte",
      translated: "sinagoge i židovske trgovine",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "u Njemačkoj",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:163|it": [
    {
      german: "In welchem Jahr",
      translated: "In quale anno",
      tone: 'semantic',
    },
    {
      german: "zerstörten",
      translated: "distrussero",
      tone: 'semantic',
    },
    {
      german: "die Nationalsozialisten",
      translated: "i nazionalsocialisti",
      tone: 'semantic',
    },
    {
      german: "Synagogen und jüdische Geschäfte",
      translated: "sinagoghe e negozi ebraici",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "in Germania",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:163|kmr": [
    {
      german: "In welchem Jahr",
      translated: "di kîjan salê de",
      tone: 'semantic',
    },
    {
      german: "zerstörten",
      translated: "xerab kirin",
      tone: 'semantic',
    },
    {
      german: "die Nationalsozialisten",
      translated: "Naziyan",
      tone: 'semantic',
    },
    {
      german: "Synagogen und jüdische Geschäfte",
      translated: "kenîse û dikanên Cihûyan",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "li Almanyayê",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:163|pl": [
    {
      german: "In welchem Jahr",
      translated: "W którym roku",
      tone: 'semantic',
    },
    {
      german: "zerstörten",
      translated: "niszczyli",
      tone: 'semantic',
    },
    {
      german: "die Nationalsozialisten",
      translated: "narodowi socjaliści",
      tone: 'semantic',
    },
    {
      german: "Synagogen und jüdische Geschäfte",
      translated: "synagogi i żydowskie sklepy",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "w Niemczech?",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:163|prs": [
    {
      german: "In welchem Jahr",
      translated: "در چه سالی",
      tone: 'semantic',
    },
    {
      german: "zerstörten",
      translated: " ویران کردند؟",
      tone: 'semantic',
    },
    {
      german: "die Nationalsozialisten",
      translated: "ناسیونال‌سوسیالیست‌ها",
      tone: 'semantic',
    },
    {
      german: "Synagogen und jüdische Geschäfte",
      translated: "کنیسه‌ها و مغازه‌های یهودیان",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "در آلمان",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:163|ro": [
    {
      german: "In welchem Jahr",
      translated: "În ce an",
      tone: 'semantic',
    },
    {
      german: "zerstörten",
      translated: "au distrus",
      tone: 'semantic',
    },
    {
      german: "die Nationalsozialisten",
      translated: "național-socialiștii",
      tone: 'semantic',
    },
    {
      german: "Synagogen und jüdische Geschäfte",
      translated: "sinagogi și magazine evreiești",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "în Germania",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:163|ru": [
    {
      german: "In welchem Jahr",
      translated: "В каком году",
      tone: 'semantic',
    },
    {
      german: "zerstörten",
      translated: "разрушили",
      tone: 'semantic',
    },
    {
      german: "die Nationalsozialisten",
      translated: "национал-социалисты",
      tone: 'semantic',
    },
    {
      german: "Synagogen und jüdische Geschäfte",
      translated: "синагоги и еврейские магазины",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "в Германии",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:163|sq": [
    {
      german: "In welchem Jahr",
      translated: "Në cilin vit",
      tone: 'semantic',
    },
    {
      german: "zerstörten",
      translated: "shkatërruan",
      tone: 'semantic',
    },
    {
      german: "die Nationalsozialisten",
      translated: "nacionalsocialistët",
      tone: 'semantic',
    },
    {
      german: "Synagogen und jüdische Geschäfte",
      translated: "sinagoga dhe dyqane hebreje",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "në Gjermani",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:163|sr": [
    {
      german: "In welchem Jahr",
      translated: "Koje su godine",
      tone: 'semantic',
    },
    {
      german: "zerstörten",
      translated: "uništavali",
      tone: 'semantic',
    },
    {
      german: "die Nationalsozialisten",
      translated: "nacionalsocijalisti",
      tone: 'semantic',
    },
    {
      german: "Synagogen und jüdische Geschäfte",
      translated: "sinagoge i jevrejske trgovine",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "u Nemačkoj",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:163|tr": [
    {
      german: "In welchem Jahr",
      translated: "hangi yıl",
      tone: 'semantic',
    },
    {
      german: "zerstörten",
      translated: "tahrip etti",
      tone: 'semantic',
    },
    {
      german: "die Nationalsozialisten",
      translated: "Nasyonal Sosyalistler",
      tone: 'semantic',
    },
    {
      german: "Synagogen und jüdische Geschäfte",
      translated: "sinagogları ve Yahudilere ait işyerlerini",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "Almanya'da",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:163|uk": [
    {
      german: "In welchem Jahr",
      translated: "У якому році",
      tone: 'semantic',
    },
    {
      german: "zerstörten",
      translated: "руйнували",
      tone: 'semantic',
    },
    {
      german: "die Nationalsozialisten",
      translated: "націонал-соціалісти",
      tone: 'semantic',
    },
    {
      german: "Synagogen und jüdische Geschäfte",
      translated: "синагоги та єврейські магазини",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "в Німеччині",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:163|vi": [
    {
      german: "In welchem Jahr",
      translated: "Năm nào",
      tone: 'semantic',
    },
    {
      german: "zerstörten",
      translated: "phá hủy",
      tone: 'semantic',
    },
    {
      german: "die Nationalsozialisten",
      translated: "Đức Quốc xã",
      tone: 'semantic',
    },
    {
      german: "Synagogen und jüdische Geschäfte",
      translated: "các giáo đường Do Thái và cửa hàng của người Do Thái",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "ở Đức",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:164|ar": [
    {
      german: "Was passierte",
      translated: "ماذا حدث",
      tone: 'semantic',
    },
    {
      german: "am 9. November 1938",
      translated: "في 9 نوفمبر/تشرين الثاني 1938",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "في ألمانيا",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:164|bg": [
    {
      german: "Was passierte",
      translated: "Какво се случва",
      tone: 'semantic',
    },
    {
      german: "am 9. November 1938",
      translated: "на 9 ноември 1938 г.",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "в Германия",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:164|bs": [
    {
      german: "Was passierte",
      translated: "Što se dogodilo",
      tone: 'semantic',
    },
    {
      german: "am 9. November 1938",
      translated: "9. novembra 1938.",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "u Njemačkoj",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:164|el": [
    {
      german: "Was passierte",
      translated: "Τι",
      tone: 'semantic',
    },
    {
      german: "am 9. November 1938",
      translated: "στις 9 Νοεμβρίου 1938",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "στη Γερμανία",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:164|en": [
    {
      german: "Was passierte",
      translated: "What happened",
      tone: 'semantic',
    },
    {
      german: "am 9. November 1938",
      translated: "on November 9, 1938",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "in Germany",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:164|es": [
    {
      german: "Was passierte",
      translated: "¿Qué ocurrió",
      tone: 'semantic',
    },
    {
      german: "am 9. November 1938",
      translated: "el 9 de noviembre de 1938",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "en Alemania",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:164|fa": [
    {
      german: "Was passierte",
      translated: "چه اتفاقی افتاد",
      tone: 'semantic',
    },
    {
      german: "am 9. November 1938",
      translated: "در ۹ نوامبر ۱۹۳۸",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "در آلمان",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:164|fr": [
    {
      german: "Was passierte",
      translated: "Que s’est-il passé",
      tone: 'semantic',
    },
    {
      german: "am 9. November 1938",
      translated: "le 9 novembre 1938",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "en Allemagne",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:164|hr": [
    {
      german: "Was passierte",
      translated: "Što se dogodilo",
      tone: 'semantic',
    },
    {
      german: "am 9. November 1938",
      translated: "9. studenoga 1938.",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "u Njemačkoj",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:164|it": [
    {
      german: "Was passierte",
      translated: "Che cosa accadde",
      tone: 'semantic',
    },
    {
      german: "am 9. November 1938",
      translated: "il 9 novembre 1938",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "in Germania",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:164|kmr": [
    {
      german: "Was passierte",
      translated: "çi qewimî",
      tone: 'semantic',
    },
    {
      german: "am 9. November 1938",
      translated: "9ê Mijdara 1938",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "li Almanyayê",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:164|pl": [
    {
      german: "Was passierte",
      translated: "Co wydarzyło się",
      tone: 'semantic',
    },
    {
      german: "am 9. November 1938",
      translated: "9 listopada 1938 r.",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "w Niemczech",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:164|prs": [
    {
      german: "Was passierte",
      translated: "چه اتفاقی افتاد",
      tone: 'semantic',
    },
    {
      german: "am 9. November 1938",
      translated: "در ۹ نوامبر ۱۹۳۸",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "در آلمان",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:164|ro": [
    {
      german: "Was passierte",
      translated: "Ce s-a întâmplat",
      tone: 'semantic',
    },
    {
      german: "am 9. November 1938",
      translated: "la 9 noiembrie 1938",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "în Germania",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:164|ru": [
    {
      german: "Was passierte",
      translated: "Что произошло",
      tone: 'semantic',
    },
    {
      german: "am 9. November 1938",
      translated: "9 ноября 1938 года",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "в Германии",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:164|sq": [
    {
      german: "Was passierte",
      translated: "Çfarë ndodhi",
      tone: 'semantic',
    },
    {
      german: "am 9. November 1938",
      translated: "më 9 nëntor 1938",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "në Gjermani",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:164|sr": [
    {
      german: "Was passierte",
      translated: "Šta se dogodilo",
      tone: 'semantic',
    },
    {
      german: "am 9. November 1938",
      translated: "9. novembra 1938.",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "u Nemačkoj",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:164|tr": [
    {
      german: "Was passierte",
      translated: "ne oldu",
      tone: 'semantic',
    },
    {
      german: "am 9. November 1938",
      translated: "9 Kasım 1938'de",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "Almanya'da",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:164|uk": [
    {
      german: "Was passierte",
      translated: "Що сталося",
      tone: 'semantic',
    },
    {
      german: "am 9. November 1938",
      translated: "9 листопада 1938 року",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "в Німеччині",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:164|vi": [
    {
      german: "Was passierte",
      translated: "Điều gì xảy ra",
      tone: 'semantic',
    },
    {
      german: "am 9. November 1938",
      translated: "ngày 9 tháng 11 năm 1938",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "ở Đức",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:165|ar": [
    {
      german: "Wie hieß",
      translated: "ما اسم",
      tone: 'semantic',
    },
    {
      german: "der erste Bundeskanzler",
      translated: "أول مستشار اتحادي",
      tone: 'semantic',
    },
    {
      german: "der Bundesrepublik Deutschland",
      translated: "لجمهورية ألمانيا الاتحادية",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:165|bg": [
    {
      german: "Wie hieß",
      translated: "Как се казва",
      tone: 'semantic',
    },
    {
      german: "der erste Bundeskanzler",
      translated: "първият федерален канцлер",
      tone: 'semantic',
    },
    {
      german: "der Bundesrepublik Deutschland",
      translated: "на Федерална република Германия",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:165|bs": [
    {
      german: "Wie hieß",
      translated: "Kako se zvao",
      tone: 'semantic',
    },
    {
      german: "der erste Bundeskanzler",
      translated: "prvi kancelar",
      tone: 'semantic',
    },
    {
      german: "der Bundesrepublik Deutschland",
      translated: "Savezne Republike Njemačke",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:165|el": [
    {
      german: "Wie hieß",
      translated: "Πώς ονομαζόταν",
      tone: 'semantic',
    },
    {
      german: "der erste Bundeskanzler",
      translated: "ο πρώτος Ομοσπονδιακός Καγκελάριος",
      tone: 'semantic',
    },
    {
      german: "der Bundesrepublik Deutschland",
      translated: "της Ομοσπονδιακής Δημοκρατίας της Γερμανίας",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:165|en": [
    {
      german: "Wie hieß",
      translated: "What was the name of",
      tone: 'semantic',
    },
    {
      german: "der erste Bundeskanzler",
      translated: "the first Federal Chancellor",
      tone: 'semantic',
    },
    {
      german: "der Bundesrepublik Deutschland",
      translated: "of the Federal Republic of Germany",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:165|es": [
    {
      german: "Wie hieß",
      translated: "¿Cómo se llamaba",
      tone: 'semantic',
    },
    {
      german: "der erste Bundeskanzler",
      translated: "el primer Canciller Federal",
      tone: 'semantic',
    },
    {
      german: "der Bundesrepublik Deutschland",
      translated: "de la República Federal de Alemania",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:165|fa": [
    {
      german: "Wie hieß",
      translated: "چه بود",
      tone: 'semantic',
    },
    {
      german: "der erste Bundeskanzler",
      translated: "نخستین صدراعظم",
      tone: 'semantic',
    },
    {
      german: "der Bundesrepublik Deutschland",
      translated: "جمهوری فدرال آلمان",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:165|fr": [
    {
      german: "Wie hieß",
      translated: "Comment s’appelait",
      tone: 'semantic',
    },
    {
      german: "der erste Bundeskanzler",
      translated: "le premier chancelier fédéral",
      tone: 'semantic',
    },
    {
      german: "der Bundesrepublik Deutschland",
      translated: "de la République fédérale d’Allemagne",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:165|hr": [
    {
      german: "Wie hieß",
      translated: "zvao",
      tone: 'semantic',
    },
    {
      german: "der erste Bundeskanzler",
      translated: "prvi kancelar",
      tone: 'semantic',
    },
    {
      german: "der Bundesrepublik Deutschland",
      translated: "Savezne Republike Njemačke",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:165|it": [
    {
      german: "Wie hieß",
      translated: "Come si chiamava",
      tone: 'semantic',
    },
    {
      german: "der erste Bundeskanzler",
      translated: "il primo cancelliere",
      tone: 'semantic',
    },
    {
      german: "der Bundesrepublik Deutschland",
      translated: "della Repubblica Federale di Germania",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:165|kmr": [
    {
      german: "Wie hieß",
      translated: "Navê",
      tone: 'semantic',
    },
    {
      german: "der erste Bundeskanzler",
      translated: "yekem Kanselerê",
      tone: 'semantic',
    },
    {
      german: "der Bundesrepublik Deutschland",
      translated: "Federal a Komara Federal a Almanyayê",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:165|pl": [
    {
      german: "Wie hieß",
      translated: "Jak nazywał się",
      tone: 'semantic',
    },
    {
      german: "der erste Bundeskanzler",
      translated: "pierwszy kanclerz",
      tone: 'semantic',
    },
    {
      german: "der Bundesrepublik Deutschland",
      translated: "Republiki Federalnej Niemiec",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:165|prs": [
    {
      german: "Wie hieß",
      translated: "چه بود",
      tone: 'semantic',
    },
    {
      german: "der erste Bundeskanzler",
      translated: "نخستین صدراعظم",
      tone: 'semantic',
    },
    {
      german: "der Bundesrepublik Deutschland",
      translated: "جمهوری فدرال آلمان",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:165|ro": [
    {
      german: "Wie hieß",
      translated: "Cum se numea",
      tone: 'semantic',
    },
    {
      german: "der erste Bundeskanzler",
      translated: "primul cancelar",
      tone: 'semantic',
    },
    {
      german: "der Bundesrepublik Deutschland",
      translated: "Republicii Federale Germania",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:165|ru": [
    {
      german: "Wie hieß",
      translated: "Как звали",
      tone: 'semantic',
    },
    {
      german: "der erste Bundeskanzler",
      translated: "первого федерального канцлера",
      tone: 'semantic',
    },
    {
      german: "der Bundesrepublik Deutschland",
      translated: "ФРГ",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:165|sq": [
    {
      german: "Wie hieß",
      translated: "Si quhej",
      tone: 'semantic',
    },
    {
      german: "der erste Bundeskanzler",
      translated: "kancelari i parë federal",
      tone: 'semantic',
    },
    {
      german: "der Bundesrepublik Deutschland",
      translated: "Republikës Federale të Gjermanisë",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:165|sr": [
    {
      german: "Wie hieß",
      translated: "Kako se zvao",
      tone: 'semantic',
    },
    {
      german: "der erste Bundeskanzler",
      translated: "prvi kancelar",
      tone: 'semantic',
    },
    {
      german: "der Bundesrepublik Deutschland",
      translated: "Savezne Republike Nemačke",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:165|tr": [
    {
      german: "Wie hieß",
      translated: "kimdi",
      tone: 'semantic',
    },
    {
      german: "der erste Bundeskanzler",
      translated: "ilk Federal Başbakanı",
      tone: 'semantic',
    },
    {
      german: "der Bundesrepublik Deutschland",
      translated: "Almanya Federal Cumhuriyeti",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:165|uk": [
    {
      german: "Wie hieß",
      translated: "Як звали",
      tone: 'semantic',
    },
    {
      german: "der erste Bundeskanzler",
      translated: "першого федерального канцлера",
      tone: 'semantic',
    },
    {
      german: "der Bundesrepublik Deutschland",
      translated: "Федеративної Республіки Німеччина",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:165|vi": [
    {
      german: "Wie hieß",
      translated: "tên là gì",
      tone: 'semantic',
    },
    {
      german: "der erste Bundeskanzler",
      translated: "Thủ tướng Liên bang đầu tiên",
      tone: 'semantic',
    },
    {
      german: "der Bundesrepublik Deutschland",
      translated: "Cộng hòa Liên bang Đức",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:166|ar": [
    {
      german: "Bei welchen Demonstrationen",
      translated: "في أي مظاهرات",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "في ألمانيا",
      tone: 'semantic',
    },
    {
      german: "riefen",
      translated: "هتف",
      tone: 'semantic',
    },
    {
      german: "die Menschen",
      translated: "الناس",
      tone: 'semantic',
    },
    {
      german: "Wir sind das Volk",
      translated: "نحن الشعب",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:166|bg": [
    {
      german: "Bei welchen Demonstrationen",
      translated: "На кои демонстрации",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "в Германия",
      tone: 'semantic',
    },
    {
      german: "riefen",
      translated: "скандират",
      tone: 'semantic',
    },
    {
      german: "die Menschen",
      translated: "хората",
      tone: 'semantic',
    },
    {
      german: "Wir sind das Volk",
      translated: "Wir sind das Volk",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:166|bs": [
    {
      german: "Bei welchen Demonstrationen",
      translated: "Na kojim su demonstracijama",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "u Njemačkoj",
      tone: 'semantic',
    },
    {
      german: "riefen",
      translated: "uzvikivali",
      tone: 'semantic',
    },
    {
      german: "die Menschen",
      translated: "ljudi",
      tone: 'semantic',
    },
    {
      german: "Wir sind das Volk",
      translated: "„Wir sind das Volk“",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:166|el": [
    {
      german: "Bei welchen Demonstrationen",
      translated: "Σε ποιες διαδηλώσεις",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "στη Γερμανία",
      tone: 'semantic',
    },
    {
      german: "riefen",
      translated: "φώναζαν",
      tone: 'semantic',
    },
    {
      german: "die Menschen",
      translated: "οι άνθρωποι",
      tone: 'semantic',
    },
    {
      german: "Wir sind das Volk",
      translated: "Wir sind das Volk",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:166|en": [
    {
      german: "Bei welchen Demonstrationen",
      translated: "At which demonstrations",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "in Germany",
      tone: 'semantic',
    },
    {
      german: "riefen",
      translated: "shout",
      tone: 'semantic',
    },
    {
      german: "die Menschen",
      translated: "people",
      tone: 'semantic',
    },
    {
      german: "Wir sind das Volk",
      translated: "'We are the people'",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:166|es": [
    {
      german: "Bei welchen Demonstrationen",
      translated: "¿En qué manifestaciones en Alemania",
      tone: 'semantic',
    },
    {
      german: "riefen",
      translated: "gritaba",
      tone: 'semantic',
    },
    {
      german: "die Menschen",
      translated: "la gente",
      tone: 'semantic',
    },
    {
      german: "Wir sind das Volk",
      translated: "Somos el pueblo",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:166|fa": [
    {
      german: "Bei welchen Demonstrationen",
      translated: "در کدام تظاهرات",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "در آلمان",
      tone: 'semantic',
    },
    {
      german: "riefen",
      translated: "سر دادند",
      tone: 'semantic',
    },
    {
      german: "die Menschen",
      translated: "مردم",
      tone: 'semantic',
    },
    {
      german: "Wir sind das Volk",
      translated: "«ما مردم هستیم»",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:166|fr": [
    {
      german: "Bei welchen Demonstrationen",
      translated: "Lors de quelles manifestations",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "en Allemagne",
      tone: 'semantic',
    },
    {
      german: "riefen",
      translated: "ont-ils crié",
      tone: 'semantic',
    },
    {
      german: "die Menschen",
      translated: "les gens",
      tone: 'semantic',
    },
    {
      german: "Wir sind das Volk",
      translated: "Nous sommes le peuple",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:166|hr": [
    {
      german: "Bei welchen Demonstrationen",
      translated: "Na kojim su demonstracijama",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "u Njemačkoj",
      tone: 'semantic',
    },
    {
      german: "riefen",
      translated: "uzvikivali",
      tone: 'semantic',
    },
    {
      german: "die Menschen",
      translated: "ljudi",
      tone: 'semantic',
    },
    {
      german: "Wir sind das Volk",
      translated: "Wir sind das Volk",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:166|it": [
    {
      german: "Bei welchen Demonstrationen",
      translated: "Durante quali manifestazioni",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "in Germania",
      tone: 'semantic',
    },
    {
      german: "riefen",
      translated: "gridarono",
      tone: 'semantic',
    },
    {
      german: "die Menschen",
      translated: "le persone",
      tone: 'semantic',
    },
    {
      german: "Wir sind das Volk",
      translated: "Wir sind das Volk",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:166|kmr": [
    {
      german: "Bei welchen Demonstrationen",
      translated: "Di kîjan xwepêşandanên",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "li Almanyayê",
      tone: 'semantic',
    },
    {
      german: "riefen",
      translated: "got",
      tone: 'semantic',
    },
    {
      german: "die Menschen",
      translated: "mirovan",
      tone: 'semantic',
    },
    {
      german: "Wir sind das Volk",
      translated: "Em gel in",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:166|pl": [
    {
      german: "Bei welchen Demonstrationen",
      translated: "Podczas których demonstracji",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "w Niemczech",
      tone: 'semantic',
    },
    {
      german: "riefen",
      translated: "skandowali",
      tone: 'semantic',
    },
    {
      german: "die Menschen",
      translated: "ludzie",
      tone: 'semantic',
    },
    {
      german: "Wir sind das Volk",
      translated: "Wir sind das Volk",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:166|prs": [
    {
      german: "Bei welchen Demonstrationen",
      translated: "مردم در کدام تظاهرات",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "در آلمان",
      tone: 'semantic',
    },
    {
      german: "Wir sind das Volk",
      translated: "«ما مردم هستیم» (Wir sind das Volk)",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:166|ro": [
    {
      german: "Bei welchen Demonstrationen",
      translated: "La ce demonstrații",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "din Germania",
      tone: 'semantic',
    },
    {
      german: "riefen",
      translated: "au scandat",
      tone: 'semantic',
    },
    {
      german: "die Menschen",
      translated: "oamenii",
      tone: 'semantic',
    },
    {
      german: "Wir sind das Volk",
      translated: "„Wir sind das Volk” („Noi suntem poporul”)",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:166|ru": [
    {
      german: "Bei welchen Demonstrationen",
      translated: "На каких демонстрациях",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "в Германии",
      tone: 'semantic',
    },
    {
      german: "riefen",
      translated: "скандировали",
      tone: 'semantic',
    },
    {
      german: "die Menschen",
      translated: "люди",
      tone: 'semantic',
    },
    {
      german: "Wir sind das Volk",
      translated: "Мы — народ",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:166|sq": [
    {
      german: "Bei welchen Demonstrationen",
      translated: "Në cilat demonstrata",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "në Gjermani",
      tone: 'semantic',
    },
    {
      german: "riefen",
      translated: "thërrisnin",
      tone: 'semantic',
    },
    {
      german: "die Menschen",
      translated: "njerëzit",
      tone: 'semantic',
    },
    {
      german: "Wir sind das Volk",
      translated: "Wir sind das Volk",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:166|sr": [
    {
      german: "Bei welchen Demonstrationen",
      translated: "Na kojim su demonstracijama",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "u Nemačkoj",
      tone: 'semantic',
    },
    {
      german: "riefen",
      translated: "uzvikivali",
      tone: 'semantic',
    },
    {
      german: "die Menschen",
      translated: "ljudi",
      tone: 'semantic',
    },
    {
      german: "Wir sind das Volk",
      translated: "Wir sind das Volk",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:166|tr": [
    {
      german: "Bei welchen Demonstrationen",
      translated: "hangi gösterilerde",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "Almanya'da",
      tone: 'semantic',
    },
    {
      german: "riefen",
      translated: "sloganını attı",
      tone: 'semantic',
    },
    {
      german: "die Menschen",
      translated: "insanlar",
      tone: 'semantic',
    },
    {
      german: "Wir sind das Volk",
      translated: "\"Biz halkız\" (Wir sind das Volk)",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:166|uk": [
    {
      german: "Bei welchen Demonstrationen",
      translated: "Під час яких демонстрацій",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "у Німеччині",
      tone: 'semantic',
    },
    {
      german: "riefen",
      translated: "скандували",
      tone: 'semantic',
    },
    {
      german: "die Menschen",
      translated: "люди",
      tone: 'semantic',
    },
    {
      german: "Wir sind das Volk",
      translated: "«Ми — народ» («Wir sind das Volk»)",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:166|vi": [
    {
      german: "Bei welchen Demonstrationen",
      translated: "Trong những cuộc biểu tình nào",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "ở Đức",
      tone: 'semantic',
    },
    {
      german: "riefen",
      translated: "hô",
      tone: 'semantic',
    },
    {
      german: "die Menschen",
      translated: "người dân",
      tone: 'semantic',
    },
    {
      german: "Wir sind das Volk",
      translated: "Wir sind das Volk",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:167|ar": [
    {
      german: "Welche Länder",
      translated: "أي دول",
      tone: 'semantic',
    },
    {
      german: "nach dem Zweiten Weltkrieg",
      translated: "بعد الحرب العالمية الثانية",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "في ألمانيا",
      tone: 'semantic',
    },
    {
      german: "Alliierte Besatzungsmächte",
      translated: "قوى الاحتلال المتحالفة",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:167|bg": [
    {
      german: "Welche Länder",
      translated: "Кои държави",
      tone: 'semantic',
    },
    {
      german: "nach dem Zweiten Weltkrieg",
      translated: "след Втората световна война",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "на Германия",
      tone: 'semantic',
    },
    {
      german: "Alliierte Besatzungsmächte",
      translated: "съюзнически окупационни сили",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:167|bs": [
    {
      german: "Welche Länder",
      translated: "Koje su države",
      tone: 'semantic',
    },
    {
      german: "nach dem Zweiten Weltkrieg",
      translated: "nakon Drugoga svjetskog rata",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "u Njemačkoj",
      tone: 'semantic',
    },
    {
      german: "Alliierte Besatzungsmächte",
      translated: "savezničkim okupacijskim silama",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:167|el": [
    {
      german: "Welche Länder",
      translated: "Ποιες χώρες",
      tone: 'semantic',
    },
    {
      german: "nach dem Zweiten Weltkrieg",
      translated: "μετά τον Β΄ Παγκόσμιο Πόλεμο",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "της Γερμανίας",
      tone: 'semantic',
    },
    {
      german: "Alliierte Besatzungsmächte",
      translated: "Συμμαχικές Δυνάμεις Κατοχής",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:167|en": [
    {
      german: "Welche Länder",
      translated: "Which countries",
      tone: 'semantic',
    },
    {
      german: "nach dem Zweiten Weltkrieg",
      translated: "after World War II",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "in Germany",
      tone: 'semantic',
    },
    {
      german: "Alliierte Besatzungsmächte",
      translated: "Allied Occupation Powers",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:167|es": [
    {
      german: "Welche Länder",
      translated: "¿Qué países",
      tone: 'semantic',
    },
    {
      german: "nach dem Zweiten Weltkrieg",
      translated: "después de la Segunda Guerra Mundial",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "en Alemania",
      tone: 'semantic',
    },
    {
      german: "Alliierte Besatzungsmächte",
      translated: "potencias aliadas de ocupación",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:167|fa": [
    {
      german: "Welche Länder",
      translated: "کدام کشورها",
      tone: 'semantic',
    },
    {
      german: "nach dem Zweiten Weltkrieg",
      translated: "پس از جنگ جهانی دوم",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "آلمان",
      tone: 'semantic',
    },
    {
      german: "Alliierte Besatzungsmächte",
      translated: "قدرت‌های متفق اشغالگر",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:167|fr": [
    {
      german: "Welche Länder",
      translated: "Quels pays",
      tone: 'semantic',
    },
    {
      german: "nach dem Zweiten Weltkrieg",
      translated: "après la Seconde Guerre mondiale",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "en Allemagne",
      tone: 'semantic',
    },
    {
      german: "Alliierte Besatzungsmächte",
      translated: "puissances alliées d’occupation",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:167|hr": [
    {
      german: "Welche Länder",
      translated: "Koje su države",
      tone: 'semantic',
    },
    {
      german: "nach dem Zweiten Weltkrieg",
      translated: "nakon Drugoga svjetskog rata",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "u Njemačkoj",
      tone: 'semantic',
    },
    {
      german: "Alliierte Besatzungsmächte",
      translated: "savezničkim okupacijskim silama",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:167|it": [
    {
      german: "Welche Länder",
      translated: "Quali Paesi",
      tone: 'semantic',
    },
    {
      german: "nach dem Zweiten Weltkrieg",
      translated: "dopo la Seconda guerra mondiale",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "in Germania",
      tone: 'semantic',
    },
    {
      german: "Alliierte Besatzungsmächte",
      translated: "potenze alleate di occupazione",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:167|kmr": [
    {
      german: "Welche Länder",
      translated: "kîjan welat",
      tone: 'semantic',
    },
    {
      german: "nach dem Zweiten Weltkrieg",
      translated: "Piştî Şerê Cîhanê yê Duyemîn",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "li Almanyayê",
      tone: 'semantic',
    },
    {
      german: "Alliierte Besatzungsmächte",
      translated: "hêzên dagirker ên hevalbend",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:167|pl": [
    {
      german: "Welche Länder",
      translated: "Które państwa",
      tone: 'semantic',
    },
    {
      german: "nach dem Zweiten Weltkrieg",
      translated: "po II wojnie światowej",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "Niemiec",
      tone: 'semantic',
    },
    {
      german: "Alliierte Besatzungsmächte",
      translated: "alianckimi mocarstwami okupacyjnymi",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:167|prs": [
    {
      german: "Welche Länder",
      translated: "کدام کشورها",
      tone: 'semantic',
    },
    {
      german: "nach dem Zweiten Weltkrieg",
      translated: "پس از جنگ جهانی دوم",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "آلمان",
      tone: 'semantic',
    },
    {
      german: "Alliierte Besatzungsmächte",
      translated: "قدرت‌های متفق اشغالگر",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:167|ro": [
    {
      german: "Welche Länder",
      translated: "Ce țări",
      tone: 'semantic',
    },
    {
      german: "nach dem Zweiten Weltkrieg",
      translated: "după Al Doilea Război Mondial",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "ale Germaniei",
      tone: 'semantic',
    },
    {
      german: "Alliierte Besatzungsmächte",
      translated: "puterile aliate de ocupație",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:167|ru": [
    {
      german: "Welche Länder",
      translated: "Какие страны",
      tone: 'semantic',
    },
    {
      german: "nach dem Zweiten Weltkrieg",
      translated: "после Второй мировой войны",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "в Германии",
      tone: 'semantic',
    },
    {
      german: "Alliierte Besatzungsmächte",
      translated: "союзными оккупационными державами",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:167|sq": [
    {
      german: "Welche Länder",
      translated: "Cilat shtete",
      tone: 'semantic',
    },
    {
      german: "nach dem Zweiten Weltkrieg",
      translated: "pas Luftës së Dytë Botërore",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "të Gjermanisë",
      tone: 'semantic',
    },
    {
      german: "Alliierte Besatzungsmächte",
      translated: "fuqitë aleate pushtuese",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:167|sr": [
    {
      german: "Welche Länder",
      translated: "Koje su države",
      tone: 'semantic',
    },
    {
      german: "nach dem Zweiten Weltkrieg",
      translated: "posle Drugoga svjetskog rata",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "u Nemačkoj",
      tone: 'semantic',
    },
    {
      german: "Alliierte Besatzungsmächte",
      translated: "savezničkim okupacijskim silama",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:167|tr": [
    {
      german: "Welche Länder",
      translated: "hangi ülkeler",
      tone: 'semantic',
    },
    {
      german: "nach dem Zweiten Weltkrieg",
      translated: "İkinci Dünya Savaşı'ndan sonra",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "Almanya'da",
      tone: 'semantic',
    },
    {
      german: "Alliierte Besatzungsmächte",
      translated: "Müttefik işgal güçleri",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:167|uk": [
    {
      german: "Welche Länder",
      translated: "Які країни",
      tone: 'semantic',
    },
    {
      german: "nach dem Zweiten Weltkrieg",
      translated: "після Другої світової війни",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "в Німеччині",
      tone: 'semantic',
    },
    {
      german: "Alliierte Besatzungsmächte",
      translated: "союзними окупаційними державами",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:167|vi": [
    {
      german: "Welche Länder",
      translated: "Những nước nào",
      tone: 'semantic',
    },
    {
      german: "nach dem Zweiten Weltkrieg",
      translated: "sau Chiến tranh thế giới thứ hai",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "Đức",
      tone: 'semantic',
    },
    {
      german: "Alliierte Besatzungsmächte",
      translated: "các cường quốc Đồng minh chiếm đóng",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:168|ar": [
    {
      german: "Welches Land",
      translated: "أي دولة",
      tone: 'semantic',
    },
    {
      german: "war keine",
      translated: "لم تكن",
      tone: 'semantic',
    },
    {
      german: "\"Alliierte Besatzungsmacht\"",
      translated: "«قوى الاحتلال المتحالفة»",
      tone: 'semantic',
    },
    {
      german: "Deutschland",
      translated: "في ألمانيا؟",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:168|bg": [
    {
      german: "Welches Land",
      translated: "Коя държава",
      tone: 'semantic',
    },
    {
      german: "war keine",
      translated: "НЕ е била",
      tone: 'semantic',
    },
    {
      german: "\"Alliierte Besatzungsmacht\"",
      translated: "съюзническа окупационна сила",
      tone: 'semantic',
    },
    {
      german: "Deutschland",
      translated: "Германия",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:168|bs": [
    {
      german: "Welches Land",
      translated: "Koja država",
      tone: 'semantic',
    },
    {
      german: "war keine",
      translated: "NIJE bila",
      tone: 'semantic',
    },
    {
      german: "\"Alliierte Besatzungsmacht\"",
      translated: "saveznička okupacijska sila",
      tone: 'semantic',
    },
    {
      german: "Deutschland",
      translated: "Njemačkoj",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:168|el": [
    {
      german: "Welches Land",
      translated: "Ποια χώρα",
      tone: 'semantic',
    },
    {
      german: "war keine",
      translated: "ΔΕΝ ήταν",
      tone: 'semantic',
    },
    {
      german: "\"Alliierte Besatzungsmacht\"",
      translated: "Συμμαχική Δύναμη Κατοχής",
      tone: 'semantic',
    },
    {
      german: "Deutschland",
      translated: "της Γερμανίας;",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:168|en": [
    {
      german: "Welches Land",
      translated: "Which country",
      tone: 'semantic',
    },
    {
      german: "war keine",
      translated: "was NOT",
      tone: 'semantic',
    },
    {
      german: "\"Alliierte Besatzungsmacht\"",
      translated: "'Allied Occupation Power'",
      tone: 'semantic',
    },
    {
      german: "Deutschland",
      translated: "Germany",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:168|es": [
    {
      german: "Welches Land",
      translated: "¿Qué país",
      tone: 'semantic',
    },
    {
      german: "war keine",
      translated: "NO fue",
      tone: 'semantic',
    },
    {
      german: "\"Alliierte Besatzungsmacht\"",
      translated: "«potencia aliada de ocupación»",
      tone: 'semantic',
    },
    {
      german: "Deutschland",
      translated: "Alemania",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:168|fa": [
    {
      german: "Welches Land",
      translated: "کدام کشور",
      tone: 'semantic',
    },
    {
      german: "war keine",
      translated: "نبود",
      tone: 'semantic',
    },
    {
      german: "\"Alliierte Besatzungsmacht\"",
      translated: "«قدرت‌های متفق اشغالگر»",
      tone: 'semantic',
    },
    {
      german: "Deutschland",
      translated: "آلمان",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:168|fr": [
    {
      german: "Welches Land",
      translated: "Quel pays",
      tone: 'semantic',
    },
    {
      german: "war keine",
      translated: "n’était pas",
      tone: 'semantic',
    },
    {
      german: "\"Alliierte Besatzungsmacht\"",
      translated: "« puissance alliée d’occupation »",
      tone: 'semantic',
    },
    {
      german: "Deutschland",
      translated: "Allemagne",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:168|hr": [
    {
      german: "Welches Land",
      translated: "Koja država",
      tone: 'semantic',
    },
    {
      german: "war keine",
      translated: "NIJE bila",
      tone: 'semantic',
    },
    {
      german: "\"Alliierte Besatzungsmacht\"",
      translated: "saveznička okupacijska sila",
      tone: 'semantic',
    },
    {
      german: "Deutschland",
      translated: "Njemačkoj",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:168|it": [
    {
      german: "Welches Land",
      translated: "Quale Paese",
      tone: 'semantic',
    },
    {
      german: "war keine",
      translated: "NON fu",
      tone: 'semantic',
    },
    {
      german: "\"Alliierte Besatzungsmacht\"",
      translated: "potenza alleata di occupazione",
      tone: 'semantic',
    },
    {
      german: "Deutschland",
      translated: "Germania",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:168|kmr": [
    {
      german: "Welches Land",
      translated: "Kîjan welat",
      tone: 'semantic',
    },
    {
      german: "war keine",
      translated: "ne",
      tone: 'semantic',
    },
    {
      german: "\"Alliierte Besatzungsmacht\"",
      translated: "«hêzek dagirker a hevalbend»",
      tone: 'semantic',
    },
    {
      german: "Deutschland",
      translated: "Almanyayê",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:168|pl": [
    {
      german: "Welches Land",
      translated: "Które państwo",
      tone: 'semantic',
    },
    {
      german: "war keine",
      translated: "NIE było",
      tone: 'semantic',
    },
    {
      german: "\"Alliierte Besatzungsmacht\"",
      translated: "alianckim mocarstwem okupacyjnym",
      tone: 'semantic',
    },
    {
      german: "Deutschland",
      translated: "Niemiec?",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:168|prs": [
    {
      german: "Welches Land",
      translated: "کدام کشور",
      tone: 'semantic',
    },
    {
      german: "war keine",
      translated: "جزو",
      tone: 'semantic',
    },
    {
      german: "\"Alliierte Besatzungsmacht\"",
      translated: "«قدرت‌های متفق اشغالگر»",
      tone: 'semantic',
    },
    {
      german: "Deutschland",
      translated: "آلمان",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:168|ro": [
    {
      german: "Welches Land",
      translated: "Care țară",
      tone: 'semantic',
    },
    {
      german: "war keine",
      translated: "NU a fost",
      tone: 'semantic',
    },
    {
      german: "\"Alliierte Besatzungsmacht\"",
      translated: "o putere aliată de ocupație",
      tone: 'semantic',
    },
    {
      german: "Deutschland",
      translated: "Germaniei",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:168|ru": [
    {
      german: "Welches Land",
      translated: "Какая страна",
      tone: 'semantic',
    },
    {
      german: "war keine",
      translated: "не была",
      tone: 'semantic',
    },
    {
      german: "\"Alliierte Besatzungsmacht\"",
      translated: "«союзной оккупационной державой»",
      tone: 'semantic',
    },
    {
      german: "Deutschland",
      translated: "в Германии",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:168|sq": [
    {
      german: "Welches Land",
      translated: "Cili shtet",
      tone: 'semantic',
    },
    {
      german: "war keine",
      translated: "NUK ishte",
      tone: 'semantic',
    },
    {
      german: "\"Alliierte Besatzungsmacht\"",
      translated: "fuqi aleate pushtuese",
      tone: 'semantic',
    },
    {
      german: "Deutschland",
      translated: "Gjermanisë",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:168|sr": [
    {
      german: "Welches Land",
      translated: "Koja država",
      tone: 'semantic',
    },
    {
      german: "war keine",
      translated: "NIJE bila",
      tone: 'semantic',
    },
    {
      german: "\"Alliierte Besatzungsmacht\"",
      translated: "saveznička okupacijska sila",
      tone: 'semantic',
    },
    {
      german: "Deutschland",
      translated: "Nemačkoj",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:168|tr": [
    {
      german: "Welches Land",
      translated: "Aşağıdaki ülkelerden hangisi",
      tone: 'semantic',
    },
    {
      german: "war keine",
      translated: "biri değildi",
      tone: 'semantic',
    },
    {
      german: "\"Alliierte Besatzungsmacht\"",
      translated: "\"Müttefik işgal güçlerinden\"",
      tone: 'semantic',
    },
    {
      german: "Deutschland",
      translated: "Almanya'daki",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:168|uk": [
    {
      german: "Welches Land",
      translated: "Яка країна",
      tone: 'semantic',
    },
    {
      german: "war keine",
      translated: "не була",
      tone: 'semantic',
    },
    {
      german: "\"Alliierte Besatzungsmacht\"",
      translated: "«союзною окупаційною державою» в",
      tone: 'semantic',
    },
    {
      german: "Deutschland",
      translated: "Німеччині",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:168|vi": [
    {
      german: "Welches Land",
      translated: "Nước nào",
      tone: 'semantic',
    },
    {
      german: "war keine",
      translated: "KHÔNG phải là",
      tone: 'semantic',
    },
    {
      german: "\"Alliierte Besatzungsmacht\"",
      translated: "cường quốc Đồng minh chiếm đóng",
      tone: 'semantic',
    },
    {
      german: "Deutschland",
      translated: "Đức",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:169|ar": [
    {
      german: "Wann",
      translated: "متى",
      tone: 'semantic',
    },
    {
      german: "die Bundesrepublik Deutschland",
      translated: "جمهورية ألمانيا الاتحادية",
      tone: 'semantic',
    },
    {
      german: "gegründet",
      translated: "تأسست",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:169|bg": [
    {
      german: "Wann",
      translated: "Кога",
      tone: 'semantic',
    },
    {
      german: "wurde",
      translated: "е",
      tone: 'semantic',
    },
    {
      german: "die Bundesrepublik Deutschland",
      translated: "Федерална република Германия",
      tone: 'semantic',
    },
    {
      german: "gegründet",
      translated: "основана",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:169|bs": [
    {
      german: "Wann",
      translated: "Kada",
      tone: 'semantic',
    },
    {
      german: "wurde",
      translated: "je",
      tone: 'semantic',
    },
    {
      german: "die Bundesrepublik Deutschland",
      translated: "Savezna Republika Njemačka",
      tone: 'semantic',
    },
    {
      german: "gegründet",
      translated: "osnovana",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:169|el": [
    {
      german: "Wann",
      translated: "Πότε",
      tone: 'semantic',
    },
    {
      german: "wurde",
      translated: "ιδρύθηκε",
      tone: 'semantic',
    },
    {
      german: "die Bundesrepublik Deutschland",
      translated: "η Ομοσπονδιακή Δημοκρατία της Γερμανίας",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:169|en": [
    {
      german: "Wann",
      translated: "When",
      tone: 'semantic',
    },
    {
      german: "wurde",
      translated: "was",
      tone: 'semantic',
    },
    {
      german: "die Bundesrepublik Deutschland",
      translated: "the Federal Republic of Germany",
      tone: 'semantic',
    },
    {
      german: "gegründet",
      translated: "founded",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:169|es": [
    {
      german: "Wann",
      translated: "¿Cuándo",
      tone: 'semantic',
    },
    {
      german: "die Bundesrepublik Deutschland",
      translated: "la República Federal de Alemania",
      tone: 'semantic',
    },
    {
      german: "gegründet",
      translated: "se fundó",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:169|fa": [
    {
      german: "Wann",
      translated: "چه زمانی",
      tone: 'semantic',
    },
    {
      german: "wurde",
      translated: "شد",
      tone: 'semantic',
    },
    {
      german: "die Bundesrepublik Deutschland",
      translated: "جمهوری فدرال آلمان",
      tone: 'semantic',
    },
    {
      german: "gegründet",
      translated: "تأسیس",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:169|fr": [
    {
      german: "Wann",
      translated: "Quand",
      tone: 'semantic',
    },
    {
      german: "wurde",
      translated: "a-t-elle été",
      tone: 'semantic',
    },
    {
      german: "die Bundesrepublik Deutschland",
      translated: "la République fédérale d’Allemagne",
      tone: 'semantic',
    },
    {
      german: "gegründet",
      translated: "fondée",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:169|hr": [
    {
      german: "Wann",
      translated: "Kada",
      tone: 'semantic',
    },
    {
      german: "wurde",
      translated: "je",
      tone: 'semantic',
    },
    {
      german: "die Bundesrepublik Deutschland",
      translated: "Savezna Republika Njemačka",
      tone: 'semantic',
    },
    {
      german: "gegründet",
      translated: "osnovana",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:169|it": [
    {
      german: "Wann",
      translated: "Quando",
      tone: 'semantic',
    },
    {
      german: "wurde",
      translated: "fu",
      tone: 'semantic',
    },
    {
      german: "die Bundesrepublik Deutschland",
      translated: "la Repubblica Federale di Germania",
      tone: 'semantic',
    },
    {
      german: "gegründet",
      translated: "fondata",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:169|kmr": [
    {
      german: "Wann",
      translated: "kengê",
      tone: 'semantic',
    },
    {
      german: "wurde",
      translated: "hate",
      tone: 'semantic',
    },
    {
      german: "die Bundesrepublik Deutschland",
      translated: "Komara Federal a Almanyayê",
      tone: 'semantic',
    },
    {
      german: "gegründet",
      translated: "damezrandin",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:169|pl": [
    {
      german: "Wann",
      translated: "Kiedy",
      tone: 'semantic',
    },
    {
      german: "die Bundesrepublik Deutschland",
      translated: "Republika Federalna Niemiec",
      tone: 'semantic',
    },
    {
      german: "gegründet",
      translated: "powstała",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:169|prs": [
    {
      german: "Wann",
      translated: "چه زمانی",
      tone: 'semantic',
    },
    {
      german: "die Bundesrepublik Deutschland",
      translated: "جمهوری فدرال آلمان",
      tone: 'semantic',
    },
    {
      german: "gegründet",
      translated: "تأسیس شد",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:169|ro": [
    {
      german: "Wann",
      translated: "Când",
      tone: 'semantic',
    },
    {
      german: "wurde",
      translated: "a fost",
      tone: 'semantic',
    },
    {
      german: "die Bundesrepublik Deutschland",
      translated: "Republica Federală Germania",
      tone: 'semantic',
    },
    {
      german: "gegründet",
      translated: "fondată",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:169|ru": [
    {
      german: "Wann",
      translated: "Когда",
      tone: 'semantic',
    },
    {
      german: "wurde",
      translated: "была",
      tone: 'semantic',
    },
    {
      german: "die Bundesrepublik Deutschland",
      translated: "Федеративная Республика Германия",
      tone: 'semantic',
    },
    {
      german: "gegründet",
      translated: "основана",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:169|sq": [
    {
      german: "Wann",
      translated: "Kur",
      tone: 'semantic',
    },
    {
      german: "wurde",
      translated: "u",
      tone: 'semantic',
    },
    {
      german: "die Bundesrepublik Deutschland",
      translated: "Republika Federale e Gjermanisë",
      tone: 'semantic',
    },
    {
      german: "gegründet",
      translated: "themelua",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:169|sr": [
    {
      german: "Wann",
      translated: "Kada",
      tone: 'semantic',
    },
    {
      german: "wurde",
      translated: "je",
      tone: 'semantic',
    },
    {
      german: "die Bundesrepublik Deutschland",
      translated: "Savezna Republika Nemačka",
      tone: 'semantic',
    },
    {
      german: "gegründet",
      translated: "osnovana",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:169|tr": [
    {
      german: "Wann",
      translated: "ne zaman",
      tone: 'semantic',
    },
    {
      german: "die Bundesrepublik Deutschland",
      translated: "Almanya Federal Cumhuriyeti",
      tone: 'semantic',
    },
    {
      german: "gegründet",
      translated: "kuruldu",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:169|uk": [
    {
      german: "Wann",
      translated: "Коли",
      tone: 'semantic',
    },
    {
      german: "wurde",
      translated: "була",
      tone: 'semantic',
    },
    {
      german: "die Bundesrepublik Deutschland",
      translated: "Федеративна Республіка Німеччина",
      tone: 'semantic',
    },
    {
      german: "gegründet",
      translated: "заснована",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:169|vi": [
    {
      german: "Wann",
      translated: "khi nào",
      tone: 'semantic',
    },
    {
      german: "wurde",
      translated: "được thành lập",
      tone: 'semantic',
    },
    {
      german: "die Bundesrepublik Deutschland",
      translated: "Cộng hòa Liên bang Đức",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:16|ar": [
    {
      german: "Wann",
      translated: "متى",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "تكون",
      tone: 'semantic',
    },
    {
      german: "die Meinungsfreiheit",
      translated: "حرية الرأي",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "في ألمانيا",
      tone: 'semantic',
    },
    {
      german: "eingeschränkt",
      translated: "مقيّدة",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:16|bg": [
    {
      german: "Wann",
      translated: "В кой случай",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "е",
      tone: 'semantic',
    },
    {
      german: "die Meinungsfreiheit",
      translated: "свободата на изразяване",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "в Германия",
      tone: 'semantic',
    },
    {
      german: "eingeschränkt",
      translated: "ограничена",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:16|bs": [
    {
      german: "Wann",
      translated: "Kada",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "je",
      tone: 'semantic',
    },
    {
      german: "die Meinungsfreiheit",
      translated: "sloboda mišljenja",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "u Njemačkoj",
      tone: 'semantic',
    },
    {
      german: "eingeschränkt",
      translated: "ograničena",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:16|el": [
    {
      german: "Wann",
      translated: "Πότε",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "περιορίζεται",
      tone: 'semantic',
    },
    {
      german: "die Meinungsfreiheit",
      translated: "η ελευθερία έκφρασης",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "στη Γερμανία",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:16|en": [
    {
      german: "Wann",
      translated: "When",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "is",
      tone: 'semantic',
    },
    {
      german: "die Meinungsfreiheit",
      translated: "freedom of speech",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "in Germany",
      tone: 'semantic',
    },
    {
      german: "eingeschränkt",
      translated: "restricted",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:16|es": [
    {
      german: "Wann",
      translated: "¿Cuándo",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "está",
      tone: 'semantic',
    },
    {
      german: "die Meinungsfreiheit",
      translated: "la libertad de expresión",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "en Alemania",
      tone: 'semantic',
    },
    {
      german: "eingeschränkt",
      translated: "limitada",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:16|fa": [
    {
      german: "Wann",
      translated: "در چه حالتی",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "می‌شود",
      tone: 'semantic',
    },
    {
      german: "die Meinungsfreiheit",
      translated: "آزادی بیان",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "در آلمان",
      tone: 'semantic',
    },
    {
      german: "eingeschränkt",
      translated: "محدود",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:16|fr": [
    {
      german: "Wann",
      translated: "Quand",
      tone: 'semantic',
    },
    {
      german: "die Meinungsfreiheit",
      translated: "la liberté d’expression",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "en Allemagne",
      tone: 'semantic',
    },
    {
      german: "eingeschränkt",
      translated: "limitée",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:16|hr": [
    {
      german: "Wann",
      translated: "Kada",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "je",
      tone: 'semantic',
    },
    {
      german: "die Meinungsfreiheit",
      translated: "sloboda mišljenja",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "u Njemačkoj",
      tone: 'semantic',
    },
    {
      german: "eingeschränkt",
      translated: "ograničena",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:16|it": [
    {
      german: "Wann",
      translated: "Quando",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "è",
      tone: 'semantic',
    },
    {
      german: "die Meinungsfreiheit",
      translated: "la libertà di espressione",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "in Germania",
      tone: 'semantic',
    },
    {
      german: "eingeschränkt",
      translated: "limitata",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:16|kmr": [
    {
      german: "Wann",
      translated: "sînordar",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "dibe",
      tone: 'semantic',
    },
    {
      german: "die Meinungsfreiheit",
      translated: "Azadiya gotinê",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "li Almanyayê",
      tone: 'semantic',
    },
    {
      german: "eingeschränkt",
      translated: "kengê",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:16|pl": [
    {
      german: "Wann",
      translated: "Kiedy",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "jest",
      tone: 'semantic',
    },
    {
      german: "die Meinungsfreiheit",
      translated: "wolność słowa",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "w Niemczech",
      tone: 'semantic',
    },
    {
      german: "eingeschränkt",
      translated: "ograniczona",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:16|prs": [
    {
      german: "Wann",
      translated: "چه",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "می‌شود؟",
      tone: 'semantic',
    },
    {
      german: "die Meinungsfreiheit",
      translated: "آزادی بیان",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "در آلمان",
      tone: 'semantic',
    },
    {
      german: "eingeschränkt",
      translated: "محدود",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:16|ro": [
    {
      german: "Wann",
      translated: "În ce situație",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "este",
      tone: 'semantic',
    },
    {
      german: "die Meinungsfreiheit",
      translated: "libertatea de exprimare",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "în Germania",
      tone: 'semantic',
    },
    {
      german: "eingeschränkt",
      translated: "limitată",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:16|ru": [
    {
      german: "Wann",
      translated: "Когда",
      tone: 'semantic',
    },
    {
      german: "die Meinungsfreiheit",
      translated: "свобода слова",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "в Германии",
      tone: 'semantic',
    },
    {
      german: "eingeschränkt",
      translated: "ограничена",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:16|sq": [
    {
      german: "Wann",
      translated: "Kur",
      tone: 'semantic',
    },
    {
      german: "die Meinungsfreiheit",
      translated: "liria e shprehjes",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "në Gjermani",
      tone: 'semantic',
    },
    {
      german: "eingeschränkt",
      translated: "kufizohet",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:16|sr": [
    {
      german: "Wann",
      translated: "Kada",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "je",
      tone: 'semantic',
    },
    {
      german: "die Meinungsfreiheit",
      translated: "sloboda mišljenja",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "u Nemačkoj",
      tone: 'semantic',
    },
    {
      german: "eingeschränkt",
      translated: "ograničena",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:16|tr": [
    {
      german: "Wann",
      translated: "hangi durumda",
      tone: 'semantic',
    },
    {
      german: "die Meinungsfreiheit",
      translated: "düşünce ve ifade özgürlüğü",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "Almanya'da",
      tone: 'semantic',
    },
    {
      german: "eingeschränkt",
      translated: "sınırlanır",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:16|uk": [
    {
      german: "Wann",
      translated: "Коли",
      tone: 'semantic',
    },
    {
      german: "die Meinungsfreiheit",
      translated: "свобода слова",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "в Німеччині",
      tone: 'semantic',
    },
    {
      german: "eingeschränkt",
      translated: "обмежується",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:16|vi": [
    {
      german: "Wann",
      translated: "Khi nào",
      tone: 'semantic',
    },
    {
      german: "die Meinungsfreiheit",
      translated: "quyền tự do ngôn luận",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "ở Đức",
      tone: 'semantic',
    },
    {
      german: "eingeschränkt",
      translated: "bị hạn chế",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:170|ar": [
    {
      german: "Was gab es",
      translated: "ماذا كان موجودًا",
      tone: 'semantic',
    },
    {
      german: "während der Zeit",
      translated: "خلال الحقبة",
      tone: 'semantic',
    },
    {
      german: "des Nationalsozialismus",
      translated: "النازية",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "في ألمانيا",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:170|bg": [
    {
      german: "Was gab es",
      translated: "Какво е имало",
      tone: 'semantic',
    },
    {
      german: "während der Zeit",
      translated: "по време на",
      tone: 'semantic',
    },
    {
      german: "des Nationalsozialismus",
      translated: "националсоциализма",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "в Германия",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:170|bs": [
    {
      german: "Was gab es",
      translated: "Što je postojalo",
      tone: 'semantic',
    },
    {
      german: "während der Zeit",
      translated: "za vrijeme",
      tone: 'semantic',
    },
    {
      german: "des Nationalsozialismus",
      translated: "nacionalsocijalizma",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "u Njemačkoj",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:170|el": [
    {
      german: "Was gab es",
      translated: "Τι υπήρχε",
      tone: 'semantic',
    },
    {
      german: "während der Zeit",
      translated: "κατά την περίοδο",
      tone: 'semantic',
    },
    {
      german: "des Nationalsozialismus",
      translated: "του εθνικοσοσιαλισμού",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "στη Γερμανία",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:170|en": [
    {
      german: "Was gab es",
      translated: "What existed",
      tone: 'semantic',
    },
    {
      german: "während der Zeit",
      translated: "during the",
      tone: 'semantic',
    },
    {
      german: "des Nationalsozialismus",
      translated: "National Socialist",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "in Germany",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:170|es": [
    {
      german: "Was gab es",
      translated: "¿Qué existía",
      tone: 'semantic',
    },
    {
      german: "während der Zeit",
      translated: "durante la época",
      tone: 'semantic',
    },
    {
      german: "des Nationalsozialismus",
      translated: "nacionalsocialista",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "en Alemania",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:170|fa": [
    {
      german: "Was gab es",
      translated: "کدام مورد وجود داشت",
      tone: 'semantic',
    },
    {
      german: "während der Zeit",
      translated: "در دوران",
      tone: 'semantic',
    },
    {
      german: "des Nationalsozialismus",
      translated: "ناسیونال‌سوسیالیسم",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "در آلمان",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:170|fr": [
    {
      german: "Was gab es",
      translated: "Qu’est-ce qui existait",
      tone: 'semantic',
    },
    {
      german: "während der Zeit",
      translated: "pendant la période",
      tone: 'semantic',
    },
    {
      german: "des Nationalsozialismus",
      translated: "du national-socialisme",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "en Allemagne",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:170|hr": [
    {
      german: "Was gab es",
      translated: "Što je postojalo",
      tone: 'semantic',
    },
    {
      german: "während der Zeit",
      translated: "za vrijeme",
      tone: 'semantic',
    },
    {
      german: "des Nationalsozialismus",
      translated: "nacionalsocijalizma",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "u Njemačkoj",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:170|it": [
    {
      german: "Was gab es",
      translated: "Che cosa esisteva",
      tone: 'semantic',
    },
    {
      german: "während der Zeit",
      translated: "durante",
      tone: 'semantic',
    },
    {
      german: "des Nationalsozialismus",
      translated: "il nazionalsocialismo",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "in Germania",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:170|kmr": [
    {
      german: "Was gab es",
      translated: "çi hebû",
      tone: 'semantic',
    },
    {
      german: "während der Zeit",
      translated: "Di dema",
      tone: 'semantic',
    },
    {
      german: "des Nationalsozialismus",
      translated: "Nazîtiyê",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "li Almanyayê",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:170|pl": [
    {
      german: "Was gab es",
      translated: "Co istniało",
      tone: 'semantic',
    },
    {
      german: "während der Zeit",
      translated: "w okresie",
      tone: 'semantic',
    },
    {
      german: "des Nationalsozialismus",
      translated: "narodowego socjalizmu",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "w Niemczech",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:170|prs": [
    {
      german: "Was gab es",
      translated: "کدام مورد وجود داشت",
      tone: 'semantic',
    },
    {
      german: "während der Zeit",
      translated: "در دوران",
      tone: 'semantic',
    },
    {
      german: "des Nationalsozialismus",
      translated: "ناسیونال‌سوسیالیسم",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "در آلمان",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:170|ro": [
    {
      german: "Was gab es",
      translated: "Ce a existat",
      tone: 'semantic',
    },
    {
      german: "während der Zeit",
      translated: "în perioada",
      tone: 'semantic',
    },
    {
      german: "des Nationalsozialismus",
      translated: "național-socialismului",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "în Germania",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:170|ru": [
    {
      german: "Was gab es",
      translated: "Что существовало",
      tone: 'semantic',
    },
    {
      german: "während der Zeit",
      translated: "во времена",
      tone: 'semantic',
    },
    {
      german: "des Nationalsozialismus",
      translated: "национал-социализма",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "в Германии",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:170|sq": [
    {
      german: "Was gab es",
      translated: "Çfarë kishte në",
      tone: 'semantic',
    },
    {
      german: "während der Zeit",
      translated: "gjatë",
      tone: 'semantic',
    },
    {
      german: "des Nationalsozialismus",
      translated: "nacionalsocializmit",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "Gjermani",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:170|sr": [
    {
      german: "Was gab es",
      translated: "Šta je postojalo",
      tone: 'semantic',
    },
    {
      german: "während der Zeit",
      translated: "za vrijeme",
      tone: 'semantic',
    },
    {
      german: "des Nationalsozialismus",
      translated: "nacionalsocijalizma",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "u Nemačkoj",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:170|tr": [
    {
      german: "Was gab es",
      translated: "vardı",
      tone: 'semantic',
    },
    {
      german: "während der Zeit",
      translated: "döneminde",
      tone: 'semantic',
    },
    {
      german: "des Nationalsozialismus",
      translated: "Nasyonal Sosyalizm",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "Almanya'da",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:170|uk": [
    {
      german: "Was gab es",
      translated: "Що існувало",
      tone: 'semantic',
    },
    {
      german: "während der Zeit",
      translated: "за часів",
      tone: 'semantic',
    },
    {
      german: "des Nationalsozialismus",
      translated: "націонал-соціалізму",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "в Німеччині",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:170|vi": [
    {
      german: "Was gab es",
      translated: "Điều gì tồn tại",
      tone: 'semantic',
    },
    {
      german: "während der Zeit",
      translated: "trong thời kỳ",
      tone: 'semantic',
    },
    {
      german: "des Nationalsozialismus",
      translated: "Quốc xã",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "ở Đức",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:171|ar": [
    {
      german: "Soziale Marktwirtschaft",
      translated: "اقتصاد السوق الاجتماعي",
      tone: 'semantic',
    },
    {
      german: "bedeutet",
      translated: "يعني",
      tone: 'semantic',
    },
    {
      german: "die Wirtschaft",
      translated: "الاقتصاد",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:171|bg": [
    {
      german: "Soziale Marktwirtschaft",
      translated: "Социалната пазарна икономика",
      tone: 'semantic',
    },
    {
      german: "bedeutet",
      translated: "означава",
      tone: 'semantic',
    },
    {
      german: "die Wirtschaft",
      translated: "икономика",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:171|bs": [
    {
      german: "Soziale Marktwirtschaft",
      translated: "Socijalno tržišna privreda",
      tone: 'semantic',
    },
    {
      german: "bedeutet",
      translated: "znači",
      tone: 'semantic',
    },
    {
      german: "die Wirtschaft",
      translated: "privreda",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:171|el": [
    {
      german: "Soziale Marktwirtschaft",
      translated: "κοινωνική οικονομία της αγοράς",
      tone: 'semantic',
    },
    {
      german: "bedeutet",
      translated: "σημαίνει",
      tone: 'semantic',
    },
    {
      german: "die Wirtschaft",
      translated: "μια οικονομία που",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:171|en": [
    {
      german: "Soziale Marktwirtschaft",
      translated: "Social market economy",
      tone: 'semantic',
    },
    {
      german: "bedeutet",
      translated: "means",
      tone: 'semantic',
    },
    {
      german: "die Wirtschaft",
      translated: "the economy",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:171|es": [
    {
      german: "Soziale Marktwirtschaft",
      translated: "economía social de mercado",
      tone: 'semantic',
    },
    {
      german: "bedeutet",
      translated: "significa",
      tone: 'semantic',
    },
    {
      german: "die Wirtschaft",
      translated: "la economía",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:171|fa": [
    {
      german: "Soziale Marktwirtschaft",
      translated: "اقتصاد اجتماعی بازار",
      tone: 'semantic',
    },
    {
      german: "bedeutet",
      translated: "یعنی",
      tone: 'semantic',
    },
    {
      german: "die Wirtschaft",
      translated: "اقتصاد",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:171|fr": [
    {
      german: "Soziale Marktwirtschaft",
      translated: "économie sociale de marché",
      tone: 'semantic',
    },
    {
      german: "bedeutet",
      translated: "signifie",
      tone: 'semantic',
    },
    {
      german: "die Wirtschaft",
      translated: "l’économie",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:171|hr": [
    {
      german: "Soziale Marktwirtschaft",
      translated: "Socijalno tržišno gospodarstvo",
      tone: 'semantic',
    },
    {
      german: "bedeutet",
      translated: "znači",
      tone: 'semantic',
    },
    {
      german: "die Wirtschaft",
      translated: "gospodarstvo",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:171|it": [
    {
      german: "Soziale Marktwirtschaft",
      translated: "L’economia sociale di mercato",
      tone: 'semantic',
    },
    {
      german: "bedeutet",
      translated: "significa",
      tone: 'semantic',
    },
    {
      german: "die Wirtschaft",
      translated: "un’economia",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:171|kmr": [
    {
      german: "Soziale Marktwirtschaft",
      translated: "Aboriya bazarê ya civakî tê",
      tone: 'semantic',
    },
    {
      german: "bedeutet",
      translated: "wê wateyê",
      tone: 'semantic',
    },
    {
      german: "die Wirtschaft",
      translated: "ku aborî …",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:171|pl": [
    {
      german: "Soziale Marktwirtschaft",
      translated: "Społeczna gospodarka rynkowa",
      tone: 'semantic',
    },
    {
      german: "bedeutet",
      translated: "oznacza",
      tone: 'semantic',
    },
    {
      german: "die Wirtschaft",
      translated: "gospodarkę",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:171|prs": [
    {
      german: "Soziale Marktwirtschaft",
      translated: "اقتصاد اجتماعی بازار",
      tone: 'semantic',
    },
    {
      german: "bedeutet",
      translated: "یعنی",
      tone: 'semantic',
    },
    {
      german: "die Wirtschaft",
      translated: "اقتصاد",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:171|ro": [
    {
      german: "Soziale Marktwirtschaft",
      translated: "Economia socială de piață",
      tone: 'semantic',
    },
    {
      german: "bedeutet",
      translated: "înseamnă",
      tone: 'semantic',
    },
    {
      german: "die Wirtschaft",
      translated: "o economie",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:171|ru": [
    {
      german: "Soziale Marktwirtschaft",
      translated: "Социальная рыночная экономика",
      tone: 'semantic',
    },
    {
      german: "bedeutet",
      translated: "означает",
      tone: 'semantic',
    },
    {
      german: "die Wirtschaft",
      translated: "экономика",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:171|sq": [
    {
      german: "Soziale Marktwirtschaft",
      translated: "Ekonomia sociale",
      tone: 'semantic',
    },
    {
      german: "bedeutet",
      translated: "do të thotë",
      tone: 'semantic',
    },
    {
      german: "die Wirtschaft",
      translated: "një ekonomi",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:171|sr": [
    {
      german: "Soziale Marktwirtschaft",
      translated: "Socijalno tržišna privreda",
      tone: 'semantic',
    },
    {
      german: "bedeutet",
      translated: "znači",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:171|tr": [
    {
      german: "Soziale Marktwirtschaft",
      translated: "Sosyal piyasa ekonomisi",
      tone: 'semantic',
    },
    {
      german: "bedeutet",
      translated: "anlamına gelir",
      tone: 'semantic',
    },
    {
      german: "die Wirtschaft",
      translated: "ekonominin",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:171|uk": [
    {
      german: "Soziale Marktwirtschaft",
      translated: "Соціальна ринкова економіка",
      tone: 'semantic',
    },
    {
      german: "bedeutet",
      translated: "означає",
      tone: 'semantic',
    },
    {
      german: "die Wirtschaft",
      translated: "що економіка",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:171|vi": [
    {
      german: "Soziale Marktwirtschaft",
      translated: "Kinh tế thị trường xã hội",
      tone: 'semantic',
    },
    {
      german: "bedeutet",
      translated: "là",
      tone: 'semantic',
    },
    {
      german: "die Wirtschaft",
      translated: "một nền kinh tế",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:172|ar": [
    {
      german: "In welcher Besatzungszone",
      translated: "في أي منطقة احتلال",
      tone: 'semantic',
    },
    {
      german: "wurde die DDR gegründet",
      translated: "تأسست جمهورية ألمانيا الديمقراطية (DDR)",
      tone: 'semantic',
    },
    {
      german: "In der",
      translated: "؟ في المنطقة …",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:172|bg": [
    {
      german: "In welcher Besatzungszone",
      translated: "В коя окупационна зона",
      tone: 'semantic',
    },
    {
      german: "wurde die DDR gegründet",
      translated: "е основана ГДР?",
      tone: 'semantic',
    },
    {
      german: "In der",
      translated: "В",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:172|bs": [
    {
      german: "In welcher Besatzungszone",
      translated: "U kojoj je okupacijskoj zoni",
      tone: 'semantic',
    },
    {
      german: "wurde die DDR gegründet",
      translated: "osnovan DDR",
      tone: 'semantic',
    },
    {
      german: "In der",
      translated: "U",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:172|el": [
    {
      german: "In welcher Besatzungszone",
      translated: "Σε ποια ζώνη κατοχής",
      tone: 'semantic',
    },
    {
      german: "wurde die DDR gegründet",
      translated: "ιδρύθηκε η ΛΔΓ",
      tone: 'semantic',
    },
    {
      german: "In der",
      translated: "Στη",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:172|en": [
    {
      german: "In welcher Besatzungszone",
      translated: "In which occupation zone",
      tone: 'semantic',
    },
    {
      german: "wurde die DDR gegründet",
      translated: "was the GDR founded",
      tone: 'semantic',
    },
    {
      german: "In der",
      translated: "In the",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:172|es": [
    {
      german: "In welcher Besatzungszone",
      translated: "En qué zona de ocupación",
      tone: 'semantic',
    },
    {
      german: "wurde die DDR gegründet",
      translated: "se fundó la RDA",
      tone: 'semantic',
    },
    {
      german: "In der",
      translated: "En la",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:172|fa": [
    {
      german: "In welcher Besatzungszone",
      translated: "در کدام منطقهٔ اشغالی",
      tone: 'semantic',
    },
    {
      german: "wurde die DDR gegründet",
      translated: "تأسیس شد؟",
      tone: 'semantic',
    },
    {
      german: "In der",
      translated: "منطقهٔ",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:172|fr": [
    {
      german: "In welcher Besatzungszone",
      translated: "Dans quelle zone d’occupation",
      tone: 'semantic',
    },
    {
      german: "wurde die DDR gegründet",
      translated: "la RDA a-t-elle été fondée",
      tone: 'semantic',
    },
    {
      german: "In der",
      translated: "Dans la zone",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:172|hr": [
    {
      german: "In welcher Besatzungszone",
      translated: "U kojoj je okupacijskoj zoni",
      tone: 'semantic',
    },
    {
      german: "wurde die DDR gegründet",
      translated: "osnovan DDR",
      tone: 'semantic',
    },
    {
      german: "In der",
      translated: "U",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:172|it": [
    {
      german: "In welcher Besatzungszone",
      translated: "In quale zona di occupazione",
      tone: 'semantic',
    },
    {
      german: "wurde die DDR gegründet",
      translated: "fu fondata la RDT",
      tone: 'semantic',
    },
    {
      german: "In der",
      translated: "Nella",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:172|kmr": [
    {
      german: "In welcher Besatzungszone",
      translated: "kîjan herêma dagirkeriyê",
      tone: 'semantic',
    },
    {
      german: "wurde die DDR gegründet",
      translated: "hate damezrandin",
      tone: 'semantic',
    },
    {
      german: "In der",
      translated: "Di",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:172|pl": [
    {
      german: "In welcher Besatzungszone",
      translated: "W której strefie okupacyjnej",
      tone: 'semantic',
    },
    {
      german: "wurde die DDR gegründet",
      translated: "powstała NRD",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:172|prs": [
    {
      german: "In welcher Besatzungszone",
      translated: "کدام منطقهٔ اشغالی",
      tone: 'semantic',
    },
    {
      german: "wurde die DDR gegründet",
      translated: "تأسیس شد",
      tone: 'semantic',
    },
    {
      german: "In der",
      translated: "منطقهٔ",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:172|ro": [
    {
      german: "In welcher Besatzungszone",
      translated: "În ce zonă de ocupație",
      tone: 'semantic',
    },
    {
      german: "wurde die DDR gegründet",
      translated: "a fost fondată RDG",
      tone: 'semantic',
    },
    {
      german: "In der",
      translated: "În zona",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:172|ru": [
    {
      german: "In welcher Besatzungszone",
      translated: "В какой оккупационной зоне",
      tone: 'semantic',
    },
    {
      german: "wurde die DDR gegründet",
      translated: "была основана ГДР",
      tone: 'semantic',
    },
    {
      german: "In der",
      translated: "В ",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:172|sq": [
    {
      german: "In welcher Besatzungszone",
      translated: "Në cilën zonë pushtimi",
      tone: 'semantic',
    },
    {
      german: "wurde die DDR gegründet",
      translated: "u themelua RDGJ-ja",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:172|sr": [
    {
      german: "In welcher Besatzungszone",
      translated: "U kojoj je okupacijskoj zoni",
      tone: 'semantic',
    },
    {
      german: "wurde die DDR gegründet",
      translated: "osnovan DDR",
      tone: 'semantic',
    },
    {
      german: "In der",
      translated: "U",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:172|tr": [
    {
      german: "In welcher Besatzungszone",
      translated: "hangi işgal bölgesinde",
      tone: 'semantic',
    },
    {
      german: "wurde die DDR gegründet",
      translated: "kuruldu",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:172|uk": [
    {
      german: "In welcher Besatzungszone",
      translated: "У якій окупаційній зоні",
      tone: 'semantic',
    },
    {
      german: "wurde die DDR gegründet",
      translated: "була заснована НДР",
      tone: 'semantic',
    },
    {
      german: "In der",
      translated: "У ",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:172|vi": [
    {
      german: "In welcher Besatzungszone",
      translated: "vùng chiếm đóng nào",
      tone: 'semantic',
    },
    {
      german: "wurde die DDR gegründet",
      translated: "CHDC Đức được thành lập",
      tone: 'semantic',
    },
    {
      german: "In der",
      translated: "Trong vùng",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:173|ar": [
    {
      german: "Die Bundesrepublik Deutschland",
      translated: "جمهورية ألمانيا الاتحادية",
      tone: 'semantic',
    },
    {
      german: "ein Gründungsmitglied",
      translated: "عضو مؤسس",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:173|bg": [
    {
      german: "Die Bundesrepublik Deutschland",
      translated: "Федерална република Германия",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "е",
      tone: 'semantic',
    },
    {
      german: "ein Gründungsmitglied",
      translated: "съосновател",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:173|bs": [
    {
      german: "Die Bundesrepublik Deutschland",
      translated: "Savezna Republika Njemačka",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "je",
      tone: 'semantic',
    },
    {
      german: "ein Gründungsmitglied",
      translated: "od država osnivačica",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:173|el": [
    {
      german: "Die Bundesrepublik Deutschland",
      translated: "Η Ομοσπονδιακή Δημοκρατία της Γερμανίας",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "είναι",
      tone: 'semantic',
    },
    {
      german: "ein Gründungsmitglied",
      translated: "ιδρυτικό μέλος",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:173|en": [
    {
      german: "Die Bundesrepublik Deutschland",
      translated: "The Federal Republic of Germany",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "is",
      tone: 'semantic',
    },
    {
      german: "ein Gründungsmitglied",
      translated: "a founding member",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:173|es": [
    {
      german: "Die Bundesrepublik Deutschland",
      translated: "La República Federal de Alemania",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "es",
      tone: 'semantic',
    },
    {
      german: "ein Gründungsmitglied",
      translated: "miembro fundador",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:173|fa": [
    {
      german: "Die Bundesrepublik Deutschland",
      translated: "جمهوری فدرال آلمان",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "است",
      tone: 'semantic',
    },
    {
      german: "ein Gründungsmitglied",
      translated: "عضو بنیان‌گذارِ",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:173|fr": [
    {
      german: "Die Bundesrepublik Deutschland",
      translated: "La République fédérale d’Allemagne",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "est",
      tone: 'semantic',
    },
    {
      german: "ein Gründungsmitglied",
      translated: "membre fondateur",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:173|hr": [
    {
      german: "Die Bundesrepublik Deutschland",
      translated: "Savezna Republika Njemačka",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "jedna je",
      tone: 'semantic',
    },
    {
      german: "ein Gründungsmitglied",
      translated: "od država osnivačica",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:173|it": [
    {
      german: "Die Bundesrepublik Deutschland",
      translated: "La Repubblica Federale di Germania",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "è",
      tone: 'semantic',
    },
    {
      german: "ein Gründungsmitglied",
      translated: "membro fondatore",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:173|kmr": [
    {
      german: "Die Bundesrepublik Deutschland",
      translated: "Komara Federal a Almanyayê",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "endamê",
      tone: 'semantic',
    },
    {
      german: "ein Gründungsmitglied",
      translated: "damezrîner",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:173|pl": [
    {
      german: "Die Bundesrepublik Deutschland",
      translated: "Republika Federalna Niemiec",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "jest",
      tone: 'semantic',
    },
    {
      german: "ein Gründungsmitglied",
      translated: "członkiem-założycielem",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:173|prs": [
    {
      german: "Die Bundesrepublik Deutschland",
      translated: "جمهوری فدرال آلمان",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "است.",
      tone: 'semantic',
    },
    {
      german: "ein Gründungsmitglied",
      translated: "عضو بنیان‌گذارِ",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:173|ro": [
    {
      german: "Die Bundesrepublik Deutschland",
      translated: "Republica Federală Germania",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "este",
      tone: 'semantic',
    },
    {
      german: "ein Gründungsmitglied",
      translated: "membru fondator",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:173|ru": [
    {
      german: "Die Bundesrepublik Deutschland",
      translated: "Федеративная Республика Германия",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "является",
      tone: 'semantic',
    },
    {
      german: "ein Gründungsmitglied",
      translated: "государством-основателем",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:173|sq": [
    {
      german: "Die Bundesrepublik Deutschland",
      translated: "Republika Federale e Gjermanisë",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "është",
      tone: 'semantic',
    },
    {
      german: "ein Gründungsmitglied",
      translated: "bashkëthemeluese",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:173|sr": [
    {
      german: "Die Bundesrepublik Deutschland",
      translated: "Savezna Republika Nemačka",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "jedna je",
      tone: 'semantic',
    },
    {
      german: "ein Gründungsmitglied",
      translated: "od država osnivačica",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:173|tr": [
    {
      german: "Die Bundesrepublik Deutschland",
      translated: "Almanya Federal Cumhuriyeti",
      tone: 'semantic',
    },
    {
      german: "ein Gründungsmitglied",
      translated: "kurucu üyesidir",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:173|uk": [
    {
      german: "Die Bundesrepublik Deutschland",
      translated: "Федеративна Республіка Німеччина",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "є",
      tone: 'semantic',
    },
    {
      german: "ein Gründungsmitglied",
      translated: "державою-засновницею",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:173|vi": [
    {
      german: "Die Bundesrepublik Deutschland",
      translated: "Cộng hòa Liên bang Đức",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "là",
      tone: 'semantic',
    },
    {
      german: "ein Gründungsmitglied",
      translated: "một trong những nước sáng lập",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:174|ar": [
    {
      german: "Wann",
      translated: "متى",
      tone: 'semantic',
    },
    {
      german: "die DDR",
      translated: "جمهورية ألمانيا الديمقراطية (DDR)",
      tone: 'semantic',
    },
    {
      german: "gegründet",
      translated: "تأسست",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:174|bg": [
    {
      german: "Wann",
      translated: "Кога",
      tone: 'semantic',
    },
    {
      german: "wurde",
      translated: "е",
      tone: 'semantic',
    },
    {
      german: "die DDR",
      translated: "ГДР",
      tone: 'semantic',
    },
    {
      german: "gegründet",
      translated: "основана",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:174|bs": [
    {
      german: "Wann",
      translated: "Kada",
      tone: 'semantic',
    },
    {
      german: "wurde",
      translated: "je",
      tone: 'semantic',
    },
    {
      german: "die DDR",
      translated: "DDR",
      tone: 'semantic',
    },
    {
      german: "gegründet",
      translated: "osnovan",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:174|el": [
    {
      german: "Wann",
      translated: "Πότε",
      tone: 'semantic',
    },
    {
      german: "die DDR",
      translated: "η ΛΔΓ",
      tone: 'semantic',
    },
    {
      german: "gegründet",
      translated: "ιδρύθηκε",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:174|en": [
    {
      german: "Wann",
      translated: "When",
      tone: 'semantic',
    },
    {
      german: "wurde",
      translated: "was",
      tone: 'semantic',
    },
    {
      german: "die DDR",
      translated: "the GDR",
      tone: 'semantic',
    },
    {
      german: "gegründet",
      translated: "founded",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:174|es": [
    {
      german: "Wann",
      translated: "¿Cuándo",
      tone: 'semantic',
    },
    {
      german: "wurde",
      translated: "se",
      tone: 'semantic',
    },
    {
      german: "die DDR",
      translated: "la RDA",
      tone: 'semantic',
    },
    {
      german: "gegründet",
      translated: "fundó",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:174|fa": [
    {
      german: "Wann",
      translated: "چه زمانی",
      tone: 'semantic',
    },
    {
      german: "wurde",
      translated: "شد",
      tone: 'semantic',
    },
    {
      german: "die DDR",
      translated: "جمهوری دموکراتیک آلمان",
      tone: 'semantic',
    },
    {
      german: "gegründet",
      translated: "تأسیس",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:174|fr": [
    {
      german: "Wann",
      translated: "Quand",
      tone: 'semantic',
    },
    {
      german: "wurde",
      translated: "a-t-elle été",
      tone: 'semantic',
    },
    {
      german: "die DDR",
      translated: "la RDA",
      tone: 'semantic',
    },
    {
      german: "gegründet",
      translated: "fondée",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:174|hr": [
    {
      german: "Wann",
      translated: "Kada",
      tone: 'semantic',
    },
    {
      german: "wurde",
      translated: "je",
      tone: 'semantic',
    },
    {
      german: "die DDR",
      translated: "DDR",
      tone: 'semantic',
    },
    {
      german: "gegründet",
      translated: "osnovan",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:174|it": [
    {
      german: "Wann",
      translated: "Quando",
      tone: 'semantic',
    },
    {
      german: "wurde",
      translated: "fu",
      tone: 'semantic',
    },
    {
      german: "die DDR",
      translated: "la RDT",
      tone: 'semantic',
    },
    {
      german: "gegründet",
      translated: "fondata",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:174|kmr": [
    {
      german: "Wann",
      translated: "kengê",
      tone: 'semantic',
    },
    {
      german: "wurde",
      translated: "hate",
      tone: 'semantic',
    },
    {
      german: "die DDR",
      translated: "DDR",
      tone: 'semantic',
    },
    {
      german: "gegründet",
      translated: "damezrandin",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:174|pl": [
    {
      german: "Wann",
      translated: "Kiedy",
      tone: 'semantic',
    },
    {
      german: "die DDR",
      translated: "NRD",
      tone: 'semantic',
    },
    {
      german: "gegründet",
      translated: "powstała",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:174|prs": [
    {
      german: "Wann",
      translated: "چه زمانی",
      tone: 'semantic',
    },
    {
      german: "die DDR",
      translated: "جمهوری دموکراتیک آلمان",
      tone: 'semantic',
    },
    {
      german: "gegründet",
      translated: "تأسیس شد",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:174|ro": [
    {
      german: "Wann",
      translated: "Când",
      tone: 'semantic',
    },
    {
      german: "wurde",
      translated: "a fost",
      tone: 'semantic',
    },
    {
      german: "die DDR",
      translated: "RDG",
      tone: 'semantic',
    },
    {
      german: "gegründet",
      translated: "fondată",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:174|ru": [
    {
      german: "Wann",
      translated: "Когда",
      tone: 'semantic',
    },
    {
      german: "wurde",
      translated: "была",
      tone: 'semantic',
    },
    {
      german: "die DDR",
      translated: "ГДР",
      tone: 'semantic',
    },
    {
      german: "gegründet",
      translated: "основана",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:174|sq": [
    {
      german: "Wann",
      translated: "Kur",
      tone: 'semantic',
    },
    {
      german: "wurde",
      translated: "u",
      tone: 'semantic',
    },
    {
      german: "die DDR",
      translated: "RDGJ-ja",
      tone: 'semantic',
    },
    {
      german: "gegründet",
      translated: "themelua",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:174|sr": [
    {
      german: "Wann",
      translated: "Kada",
      tone: 'semantic',
    },
    {
      german: "wurde",
      translated: "je",
      tone: 'semantic',
    },
    {
      german: "die DDR",
      translated: "DDR",
      tone: 'semantic',
    },
    {
      german: "gegründet",
      translated: "osnovan",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:174|tr": [
    {
      german: "Wann",
      translated: "ne zaman",
      tone: 'semantic',
    },
    {
      german: "die DDR",
      translated: "Doğu Almanya (DDR)",
      tone: 'semantic',
    },
    {
      german: "gegründet",
      translated: "kuruldu",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:174|uk": [
    {
      german: "Wann",
      translated: "Коли",
      tone: 'semantic',
    },
    {
      german: "wurde",
      translated: "була",
      tone: 'semantic',
    },
    {
      german: "die DDR",
      translated: "НДР",
      tone: 'semantic',
    },
    {
      german: "gegründet",
      translated: "заснована",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:174|vi": [
    {
      german: "Wann",
      translated: "khi nào",
      tone: 'semantic',
    },
    {
      german: "wurde",
      translated: "được",
      tone: 'semantic',
    },
    {
      german: "die DDR",
      translated: "Đức",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:175|ar": [
    {
      german: "Wie viele",
      translated: "كم عدد",
      tone: 'semantic',
    },
    {
      german: "Besatzungszonen",
      translated: "مناطق الاحتلال",
      tone: 'semantic',
    },
    {
      german: "gab es",
      translated: "التي كانت موجودة",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "في ألمانيا",
      tone: 'semantic',
    },
    {
      german: "nach dem Zweiten Weltkrieg",
      translated: "بعد الحرب العالمية الثانية",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:175|bg": [
    {
      german: "Wie viele",
      translated: "Колко",
      tone: 'semantic',
    },
    {
      german: "Besatzungszonen",
      translated: "окупационни зони",
      tone: 'semantic',
    },
    {
      german: "gab es",
      translated: "има",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "Германия",
      tone: 'semantic',
    },
    {
      german: "nach dem Zweiten Weltkrieg",
      translated: "след Втората световна война",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:175|bs": [
    {
      german: "Wie viele",
      translated: "Koliko je",
      tone: 'semantic',
    },
    {
      german: "Besatzungszonen",
      translated: "okupacijskih zona",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "Njemačka",
      tone: 'semantic',
    },
    {
      german: "nach dem Zweiten Weltkrieg",
      translated: "nakon Drugoga svjetskog rata",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:175|el": [
    {
      german: "Wie viele",
      translated: "Πόσες",
      tone: 'semantic',
    },
    {
      german: "Besatzungszonen",
      translated: "ζώνες κατοχής",
      tone: 'semantic',
    },
    {
      german: "gab es",
      translated: "είχε",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "η Γερμανία",
      tone: 'semantic',
    },
    {
      german: "nach dem Zweiten Weltkrieg",
      translated: "μετά τον Β΄ Παγκόσμιο Πόλεμο;",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:175|en": [
    {
      german: "Wie viele",
      translated: "How many",
      tone: 'semantic',
    },
    {
      german: "Besatzungszonen",
      translated: "occupation zones",
      tone: 'semantic',
    },
    {
      german: "gab es",
      translated: "were there",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "in Germany",
      tone: 'semantic',
    },
    {
      german: "nach dem Zweiten Weltkrieg",
      translated: "after World War II",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:175|es": [
    {
      german: "Wie viele",
      translated: "¿Cuántas",
      tone: 'semantic',
    },
    {
      german: "Besatzungszonen",
      translated: "zonas de ocupación",
      tone: 'semantic',
    },
    {
      german: "gab es",
      translated: "había",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "en Alemania",
      tone: 'semantic',
    },
    {
      german: "nach dem Zweiten Weltkrieg",
      translated: "después de la Segunda Guerra Mundial",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:175|fa": [
    {
      german: "Wie viele",
      translated: "چند",
      tone: 'semantic',
    },
    {
      german: "Besatzungszonen",
      translated: "منطقهٔ اشغالی",
      tone: 'semantic',
    },
    {
      german: "gab es",
      translated: "داشت",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "آلمان",
      tone: 'semantic',
    },
    {
      german: "nach dem Zweiten Weltkrieg",
      translated: "پس از جنگ جهانی دوم",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:175|fr": [
    {
      german: "Wie viele",
      translated: "Combien de",
      tone: 'semantic',
    },
    {
      german: "Besatzungszonen",
      translated: "zones d’occupation",
      tone: 'semantic',
    },
    {
      german: "gab es",
      translated: "y avait-il",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "en Allemagne",
      tone: 'semantic',
    },
    {
      german: "nach dem Zweiten Weltkrieg",
      translated: "après la Seconde Guerre mondiale",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:175|hr": [
    {
      german: "Wie viele",
      translated: "Koliko je",
      tone: 'semantic',
    },
    {
      german: "Besatzungszonen",
      translated: "okupacijskih zona",
      tone: 'semantic',
    },
    {
      german: "gab es",
      translated: "imala",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "Njemačka",
      tone: 'semantic',
    },
    {
      german: "nach dem Zweiten Weltkrieg",
      translated: "nakon Drugoga svjetskog rata",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:175|it": [
    {
      german: "Wie viele",
      translated: "Quante",
      tone: 'semantic',
    },
    {
      german: "Besatzungszonen",
      translated: "zone di occupazione",
      tone: 'semantic',
    },
    {
      german: "gab es",
      translated: "aveva",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "la Germania",
      tone: 'semantic',
    },
    {
      german: "nach dem Zweiten Weltkrieg",
      translated: "dopo la Seconda guerra mondiale",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:175|kmr": [
    {
      german: "Wie viele",
      translated: "çend",
      tone: 'semantic',
    },
    {
      german: "Besatzungszonen",
      translated: "herêmên dagirkeriyê",
      tone: 'semantic',
    },
    {
      german: "gab es",
      translated: "hebûn",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "li Almanyayê",
      tone: 'semantic',
    },
    {
      german: "nach dem Zweiten Weltkrieg",
      translated: "Piştî Şerê Cîhanê yê Duyemîn",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:175|pl": [
    {
      german: "Wie viele",
      translated: "Ile",
      tone: 'semantic',
    },
    {
      german: "Besatzungszonen",
      translated: "stref okupacyjnych",
      tone: 'semantic',
    },
    {
      german: "gab es",
      translated: "miały",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "Niemcy",
      tone: 'semantic',
    },
    {
      german: "nach dem Zweiten Weltkrieg",
      translated: "po II wojnie światowej?",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:175|prs": [
    {
      german: "Wie viele",
      translated: "چند",
      tone: 'semantic',
    },
    {
      german: "Besatzungszonen",
      translated: "منطقهٔ اشغالی",
      tone: 'semantic',
    },
    {
      german: "gab es",
      translated: "داشت",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "آلمان",
      tone: 'semantic',
    },
    {
      german: "nach dem Zweiten Weltkrieg",
      translated: "پس از جنگ جهانی دوم",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:175|ro": [
    {
      german: "Wie viele",
      translated: "Câte",
      tone: 'semantic',
    },
    {
      german: "Besatzungszonen",
      translated: "zone de ocupație",
      tone: 'semantic',
    },
    {
      german: "gab es",
      translated: "avea",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "Germania",
      tone: 'semantic',
    },
    {
      german: "nach dem Zweiten Weltkrieg",
      translated: "după Al Doilea Război Mondial",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:175|ru": [
    {
      german: "Wie viele",
      translated: "Сколько",
      tone: 'semantic',
    },
    {
      german: "Besatzungszonen",
      translated: "оккупационных зон",
      tone: 'semantic',
    },
    {
      german: "gab es",
      translated: "было",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "в Германии",
      tone: 'semantic',
    },
    {
      german: "nach dem Zweiten Weltkrieg",
      translated: "после Второй мировой войны",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:175|sq": [
    {
      german: "Wie viele",
      translated: "Sa",
      tone: 'semantic',
    },
    {
      german: "Besatzungszonen",
      translated: "zona pushtimi",
      tone: 'semantic',
    },
    {
      german: "gab es",
      translated: "kishte",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "Gjermania",
      tone: 'semantic',
    },
    {
      german: "nach dem Zweiten Weltkrieg",
      translated: "pas Luftës së Dytë Botërore",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:175|sr": [
    {
      german: "Wie viele",
      translated: "Koliko je",
      tone: 'semantic',
    },
    {
      german: "Besatzungszonen",
      translated: "okupacijskih zona",
      tone: 'semantic',
    },
    {
      german: "gab es",
      translated: "imala",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "Nemačka",
      tone: 'semantic',
    },
    {
      german: "nach dem Zweiten Weltkrieg",
      translated: "posle Drugoga svjetskog rata",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:175|tr": [
    {
      german: "Wie viele",
      translated: "kaç",
      tone: 'semantic',
    },
    {
      german: "Besatzungszonen",
      translated: "işgal bölgesi",
      tone: 'semantic',
    },
    {
      german: "gab es",
      translated: "vardı",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "Almanya'da",
      tone: 'semantic',
    },
    {
      german: "nach dem Zweiten Weltkrieg",
      translated: "İkinci Dünya Savaşı'ndan sonra",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:175|uk": [
    {
      german: "Wie viele",
      translated: "Скільки",
      tone: 'semantic',
    },
    {
      german: "Besatzungszonen",
      translated: "окупаційних зон",
      tone: 'semantic',
    },
    {
      german: "gab es",
      translated: "було",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "в Німеччині",
      tone: 'semantic',
    },
    {
      german: "nach dem Zweiten Weltkrieg",
      translated: "після Другої світової війни",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:175|vi": [
    {
      german: "Wie viele",
      translated: "bao nhiêu",
      tone: 'semantic',
    },
    {
      german: "Besatzungszonen",
      translated: "vùng chiếm đóng",
      tone: 'semantic',
    },
    {
      german: "gab es",
      translated: "có",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "Đức",
      tone: 'semantic',
    },
    {
      german: "nach dem Zweiten Weltkrieg",
      translated: "Sau Chiến tranh thế giới thứ hai",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:176|ar": [
    {
      german: "Wie waren",
      translated: "كيف كانت",
      tone: 'semantic',
    },
    {
      german: " die Besatzungszonen Deutschlands",
      translated: "مناطق الاحتلال في ألمانيا",
      tone: 'semantic',
    },
    {
      german: " nach 1945",
      translated: "بعد عام 1945",
      tone: 'semantic',
    },
    {
      german: " verteilt",
      translated: "موزعة",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:176|bg": [
    {
      german: "Wie waren",
      translated: "Как са",
      tone: 'semantic',
    },
    {
      german: " die Besatzungszonen Deutschlands",
      translated: " окупационните зони на Германия",
      tone: 'semantic',
    },
    {
      german: " nach 1945",
      translated: " след 1945 г.",
      tone: 'semantic',
    },
    {
      german: " verteilt",
      translated: " разпределени",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:176|bs": [
    {
      german: "Wie waren",
      translated: "Kako su",
      tone: 'semantic',
    },
    {
      german: " die Besatzungszonen Deutschlands",
      translated: " okupacijske zone Njemačke",
      tone: 'semantic',
    },
    {
      german: " nach 1945",
      translated: " nakon 1945.",
      tone: 'semantic',
    },
    {
      german: " verteilt",
      translated: " raspoređene",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:176|el": [
    {
      german: "Wie waren",
      translated: "Πώς ήταν",
      tone: 'semantic',
    },
    {
      german: " die Besatzungszonen Deutschlands",
      translated: " οι ζώνες κατοχής της Γερμανίας",
      tone: 'semantic',
    },
    {
      german: " nach 1945",
      translated: " μετά το 1945",
      tone: 'semantic',
    },
    {
      german: " verteilt",
      translated: "κατανεμημένες",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:176|en": [
    {
      german: "Wie waren",
      translated: "How were",
      tone: 'semantic',
    },
    {
      german: " die Besatzungszonen Deutschlands",
      translated: " Germany's occupation zones",
      tone: 'semantic',
    },
    {
      german: " nach 1945",
      translated: " after 1945",
      tone: 'semantic',
    },
    {
      german: " verteilt",
      translated: " distributed",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:176|es": [
    {
      german: "Wie waren",
      translated: "¿Cómo se",
      tone: 'semantic',
    },
    {
      german: " die Besatzungszonen Deutschlands",
      translated: " las zonas de ocupación de Alemania",
      tone: 'semantic',
    },
    {
      german: " nach 1945",
      translated: " después de 1945",
      tone: 'semantic',
    },
    {
      german: " verteilt",
      translated: " distribuyeron",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:176|fa": [
    {
      german: " die Besatzungszonen Deutschlands",
      translated: "مناطق اشغالی آلمان",
      tone: 'semantic',
    },
    {
      german: " nach 1945",
      translated: "پس از ۱۹۴۵",
      tone: 'semantic',
    },
    {
      german: " verteilt",
      translated: "تقسیم شده بودند",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:176|fr": [
    {
      german: "Wie waren",
      translated: "Comment",
      tone: 'semantic',
    },
    {
      german: " die Besatzungszonen Deutschlands",
      translated: "les zones d’occupation de l’Allemagne",
      tone: 'semantic',
    },
    {
      german: " nach 1945",
      translated: "après 1945",
      tone: 'semantic',
    },
    {
      german: " verteilt",
      translated: "étaient-elles",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:176|hr": [
    {
      german: "Wie waren",
      translated: "Kako su",
      tone: 'semantic',
    },
    {
      german: " die Besatzungszonen Deutschlands",
      translated: " okupacijske zone Njemačke",
      tone: 'semantic',
    },
    {
      german: " nach 1945",
      translated: " nakon 1945.",
      tone: 'semantic',
    },
    {
      german: " verteilt",
      translated: " raspoređene",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:176|it": [
    {
      german: "Wie waren",
      translated: "Come erano",
      tone: 'semantic',
    },
    {
      german: " die Besatzungszonen Deutschlands",
      translated: " le zone di occupazione della Germania",
      tone: 'semantic',
    },
    {
      german: " nach 1945",
      translated: " dopo il 1945",
      tone: 'semantic',
    },
    {
      german: " verteilt",
      translated: " suddivise",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:176|kmr": [
    {
      german: "Wie waren",
      translated: "çawa hatibûn",
      tone: 'semantic',
    },
    {
      german: " die Besatzungszonen Deutschlands",
      translated: "herêmên dagirkeriyê yên Almanyayê",
      tone: 'semantic',
    },
    {
      german: " nach 1945",
      translated: "Piştî 1945",
      tone: 'semantic',
    },
    {
      german: " verteilt",
      translated: "dabeşkirin",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:176|pl": [
    {
      german: "Wie waren",
      translated: "Jak były",
      tone: 'semantic',
    },
    {
      german: " die Besatzungszonen Deutschlands",
      translated: " strefy okupacyjne Niemiec",
      tone: 'semantic',
    },
    {
      german: " nach 1945",
      translated: " po 1945 r.",
      tone: 'semantic',
    },
    {
      german: " verteilt",
      translated: " podzielone",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:176|prs": [
    {
      german: "Wie waren",
      translated: "چگونه تقسیم شده بودند",
      tone: 'semantic',
    },
    {
      german: " die Besatzungszonen Deutschlands",
      translated: "مناطق اشغالی آلمان",
      tone: 'semantic',
    },
    {
      german: " nach 1945",
      translated: "پس از ۱۹۴۵",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:176|ro": [
    {
      german: "Wie waren",
      translated: "Cum erau",
      tone: 'semantic',
    },
    {
      german: " die Besatzungszonen Deutschlands",
      translated: " zonele de ocupație ale Germaniei",
      tone: 'semantic',
    },
    {
      german: " nach 1945",
      translated: " după 1945",
      tone: 'semantic',
    },
    {
      german: " verteilt",
      translated: " împărțite",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:176|ru": [
    {
      german: "Wie waren",
      translated: "Как были",
      tone: 'semantic',
    },
    {
      german: " die Besatzungszonen Deutschlands",
      translated: " оккупационные зоны Германии",
      tone: 'semantic',
    },
    {
      german: " nach 1945",
      translated: " после 1945 года",
      tone: 'semantic',
    },
    {
      german: " verteilt",
      translated: " распределены",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:176|sq": [
    {
      german: "Wie waren",
      translated: "Si ishin",
      tone: 'semantic',
    },
    {
      german: " die Besatzungszonen Deutschlands",
      translated: " zonat e pushtimit të Gjermanisë",
      tone: 'semantic',
    },
    {
      german: " nach 1945",
      translated: " pas vitit 1945",
      tone: 'semantic',
    },
    {
      german: " verteilt",
      translated: " ndarë",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:176|sr": [
    {
      german: "Wie waren",
      translated: "Kako su",
      tone: 'semantic',
    },
    {
      german: " die Besatzungszonen Deutschlands",
      translated: " okupacijske zone Nemačke",
      tone: 'semantic',
    },
    {
      german: " nach 1945",
      translated: " posle 1945.",
      tone: 'semantic',
    },
    {
      german: " verteilt",
      translated: " raspoređene",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:176|tr": [
    {
      german: "Wie waren",
      translated: "nasıl",
      tone: 'semantic',
    },
    {
      german: " die Besatzungszonen Deutschlands",
      translated: "Almanya'nın işgal bölgeleri",
      tone: 'semantic',
    },
    {
      german: " nach 1945",
      translated: "1945'ten sonra",
      tone: 'semantic',
    },
    {
      german: " verteilt",
      translated: "dağıtılmıştı",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:176|uk": [
    {
      german: "Wie waren",
      translated: "Як були",
      tone: 'semantic',
    },
    {
      german: " die Besatzungszonen Deutschlands",
      translated: " окупаційні зони Німеччини",
      tone: 'semantic',
    },
    {
      german: " nach 1945",
      translated: " після 1945 року",
      tone: 'semantic',
    },
    {
      german: " verteilt",
      translated: "розподілені",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:176|vi": [
    {
      german: "Wie waren",
      translated: "được phân chia",
      tone: 'semantic',
    },
    {
      german: " die Besatzungszonen Deutschlands",
      translated: "Các vùng chiếm đóng của Đức",
      tone: 'semantic',
    },
    {
      german: " nach 1945",
      translated: "sau năm 1945",
      tone: 'semantic',
    },
    {
      german: " verteilt",
      translated: "như thế nào",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:177|ar": [
    {
      german: "Welche deutsche Stadt",
      translated: "أي مدينة ألمانية",
      tone: 'semantic',
    },
    {
      german: "wurde",
      translated: "قُسمت",
      tone: 'semantic',
    },
    {
      german: "nach dem Zweiten Weltkrieg",
      translated: "بعد الحرب العالمية الثانية",
      tone: 'semantic',
    },
    {
      german: "in vier Sektoren",
      translated: "إلى أربعة قطاعات",
      tone: 'semantic',
    },
    {
      german: "aufgeteilt",
      translated: "؟",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:177|bg": [
    {
      german: "Welche deutsche Stadt",
      translated: "Кой германски град",
      tone: 'semantic',
    },
    {
      german: "wurde",
      translated: "е",
      tone: 'semantic',
    },
    {
      german: "nach dem Zweiten Weltkrieg",
      translated: "след Втората световна война",
      tone: 'semantic',
    },
    {
      german: "in vier Sektoren",
      translated: "на четири сектора",
      tone: 'semantic',
    },
    {
      german: "aufgeteilt",
      translated: "разделен",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:177|bs": [
    {
      german: "Welche deutsche Stadt",
      translated: "Koji je njemački grad",
      tone: 'semantic',
    },
    {
      german: "wurde",
      translated: "bio",
      tone: 'semantic',
    },
    {
      german: "nach dem Zweiten Weltkrieg",
      translated: "nakon Drugoga svjetskog rata",
      tone: 'semantic',
    },
    {
      german: "in vier Sektoren",
      translated: "na četiri sektora",
      tone: 'semantic',
    },
    {
      german: "aufgeteilt",
      translated: "podijeljen",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:177|el": [
    {
      german: "Welche deutsche Stadt",
      translated: "Ποια γερμανική πόλη",
      tone: 'semantic',
    },
    {
      german: "wurde",
      translated: "χωρίστηκε",
      tone: 'semantic',
    },
    {
      german: "nach dem Zweiten Weltkrieg",
      translated: "μετά τον Β΄ Παγκόσμιο Πόλεμο",
      tone: 'semantic',
    },
    {
      german: "in vier Sektoren",
      translated: "σε τέσσερις τομείς",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:177|en": [
    {
      german: "Welche deutsche Stadt",
      translated: "Which German city",
      tone: 'semantic',
    },
    {
      german: "wurde",
      translated: "was",
      tone: 'semantic',
    },
    {
      german: "nach dem Zweiten Weltkrieg",
      translated: "after World War II",
      tone: 'semantic',
    },
    {
      german: "in vier Sektoren",
      translated: "into four sectors",
      tone: 'semantic',
    },
    {
      german: "aufgeteilt",
      translated: "divided",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:177|es": [
    {
      german: "Welche deutsche Stadt",
      translated: "¿Qué ciudad alemana",
      tone: 'semantic',
    },
    {
      german: "wurde",
      translated: "fue",
      tone: 'semantic',
    },
    {
      german: "nach dem Zweiten Weltkrieg",
      translated: "después de la Segunda Guerra Mundial",
      tone: 'semantic',
    },
    {
      german: "in vier Sektoren",
      translated: "en cuatro sectores",
      tone: 'semantic',
    },
    {
      german: "aufgeteilt",
      translated: "dividida",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:177|fa": [
    {
      german: "Welche deutsche Stadt",
      translated: "کدام شهر آلمان",
      tone: 'semantic',
    },
    {
      german: "nach dem Zweiten Weltkrieg",
      translated: "پس از جنگ جهانی دوم",
      tone: 'semantic',
    },
    {
      german: "in vier Sektoren",
      translated: "به چهار بخش",
      tone: 'semantic',
    },
    {
      german: "aufgeteilt",
      translated: "تقسیم شد",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:177|fr": [
    {
      german: "Welche deutsche Stadt",
      translated: "Quelle ville allemande",
      tone: 'semantic',
    },
    {
      german: "wurde",
      translated: "a été",
      tone: 'semantic',
    },
    {
      german: "nach dem Zweiten Weltkrieg",
      translated: "après la Seconde Guerre mondiale",
      tone: 'semantic',
    },
    {
      german: "in vier Sektoren",
      translated: "en quatre secteurs",
      tone: 'semantic',
    },
    {
      german: "aufgeteilt",
      translated: "divisée",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:177|hr": [
    {
      german: "Welche deutsche Stadt",
      translated: "Koji je njemački grad",
      tone: 'semantic',
    },
    {
      german: "wurde",
      translated: "bio",
      tone: 'semantic',
    },
    {
      german: "nach dem Zweiten Weltkrieg",
      translated: "nakon Drugoga svjetskog rata",
      tone: 'semantic',
    },
    {
      german: "in vier Sektoren",
      translated: "na četiri sektora",
      tone: 'semantic',
    },
    {
      german: "aufgeteilt",
      translated: "podijeljen",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:177|it": [
    {
      german: "Welche deutsche Stadt",
      translated: "Quale città tedesca",
      tone: 'semantic',
    },
    {
      german: "wurde",
      translated: "fu",
      tone: 'semantic',
    },
    {
      german: "nach dem Zweiten Weltkrieg",
      translated: "dopo la Seconda guerra mondiale",
      tone: 'semantic',
    },
    {
      german: "in vier Sektoren",
      translated: "in quattro settori",
      tone: 'semantic',
    },
    {
      german: "aufgeteilt",
      translated: "divisa",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:177|kmr": [
    {
      german: "Welche deutsche Stadt",
      translated: "Kîjan bajarê Alman",
      tone: 'semantic',
    },
    {
      german: "wurde",
      translated: "bû",
      tone: 'semantic',
    },
    {
      german: "nach dem Zweiten Weltkrieg",
      translated: "piştî Şerê Cîhanê yê Duyemîn",
      tone: 'semantic',
    },
    {
      german: "in vier Sektoren",
      translated: "çar sektor",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:177|pl": [
    {
      german: "Welche deutsche Stadt",
      translated: "Które niemieckie miasto",
      tone: 'semantic',
    },
    {
      german: "wurde",
      translated: "zostało",
      tone: 'semantic',
    },
    {
      german: "nach dem Zweiten Weltkrieg",
      translated: "po II wojnie światowej",
      tone: 'semantic',
    },
    {
      german: "in vier Sektoren",
      translated: "na cztery sektory",
      tone: 'semantic',
    },
    {
      german: "aufgeteilt",
      translated: "podzielone",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:177|prs": [
    {
      german: "Welche deutsche Stadt",
      translated: "کدام شهر آلمان",
      tone: 'semantic',
    },
    {
      german: "nach dem Zweiten Weltkrieg",
      translated: "پس از جنگ جهانی دوم",
      tone: 'semantic',
    },
    {
      german: "in vier Sektoren",
      translated: "به چهار بخش",
      tone: 'semantic',
    },
    {
      german: "aufgeteilt",
      translated: "تقسیم شد",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:177|ro": [
    {
      german: "Welche deutsche Stadt",
      translated: "Ce oraș german",
      tone: 'semantic',
    },
    {
      german: "wurde",
      translated: "a fost",
      tone: 'semantic',
    },
    {
      german: "nach dem Zweiten Weltkrieg",
      translated: "după Al Doilea Război Mondial",
      tone: 'semantic',
    },
    {
      german: "in vier Sektoren",
      translated: "în patru sectoare",
      tone: 'semantic',
    },
    {
      german: "aufgeteilt",
      translated: "împărțit",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:177|ru": [
    {
      german: "Welche deutsche Stadt",
      translated: "Какой немецкий город",
      tone: 'semantic',
    },
    {
      german: "wurde",
      translated: "был",
      tone: 'semantic',
    },
    {
      german: "nach dem Zweiten Weltkrieg",
      translated: "после Второй мировой войны",
      tone: 'semantic',
    },
    {
      german: "in vier Sektoren",
      translated: "на четыре сектора",
      tone: 'semantic',
    },
    {
      german: "aufgeteilt",
      translated: "разделён",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:177|sq": [
    {
      german: "Welche deutsche Stadt",
      translated: "Cili qytet gjerman",
      tone: 'semantic',
    },
    {
      german: "wurde",
      translated: "u",
      tone: 'semantic',
    },
    {
      german: "nach dem Zweiten Weltkrieg",
      translated: "pas Luftës së Dytë Botërore",
      tone: 'semantic',
    },
    {
      german: "in vier Sektoren",
      translated: "në katër sektorë",
      tone: 'semantic',
    },
    {
      german: "aufgeteilt",
      translated: "nda",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:177|sr": [
    {
      german: "Welche deutsche Stadt",
      translated: "Koji je nemački grad",
      tone: 'semantic',
    },
    {
      german: "wurde",
      translated: "bio",
      tone: 'semantic',
    },
    {
      german: "nach dem Zweiten Weltkrieg",
      translated: "posle Drugoga svjetskog rata",
      tone: 'semantic',
    },
    {
      german: "in vier Sektoren",
      translated: "na četiri sektora",
      tone: 'semantic',
    },
    {
      german: "aufgeteilt",
      translated: "podijeljen",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:177|tr": [
    {
      german: "Welche deutsche Stadt",
      translated: "hangi Alman şehri",
      tone: 'semantic',
    },
    {
      german: "nach dem Zweiten Weltkrieg",
      translated: "İkinci Dünya Savaşı'ndan sonra",
      tone: 'semantic',
    },
    {
      german: "in vier Sektoren",
      translated: "dört sektöre",
      tone: 'semantic',
    },
    {
      german: "aufgeteilt",
      translated: "ayrıldı",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:177|uk": [
    {
      german: "Welche deutsche Stadt",
      translated: "Яке німецьке місто",
      tone: 'semantic',
    },
    {
      german: "wurde",
      translated: "було",
      tone: 'semantic',
    },
    {
      german: "nach dem Zweiten Weltkrieg",
      translated: "після Другої світової війни",
      tone: 'semantic',
    },
    {
      german: "in vier Sektoren",
      translated: "на чотири сектори",
      tone: 'semantic',
    },
    {
      german: "aufgeteilt",
      translated: "поділене",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:177|vi": [
    {
      german: "Welche deutsche Stadt",
      translated: "Thành phố Đức nào",
      tone: 'semantic',
    },
    {
      german: "wurde",
      translated: "bị",
      tone: 'semantic',
    },
    {
      german: "nach dem Zweiten Weltkrieg",
      translated: "sau Chiến tranh thế giới thứ hai",
      tone: 'semantic',
    },
    {
      german: "in vier Sektoren",
      translated: "thành bốn khu vực",
      tone: 'semantic',
    },
    {
      german: "aufgeteilt",
      translated: "chia",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:178|ar": [
    {
      german: "Vom Juni 1948",
      translated: "من يونيو/حزيران 1948",
      tone: 'semantic',
    },
    {
      german: "bis zum Mai 1949",
      translated: "إلى مايو/أيار 1949",
      tone: 'semantic',
    },
    {
      german: "die Bürgerinnen und Bürger",
      translated: "سكان برلين الغربية",
      tone: 'semantic',
    },
    {
      german: "von West-Berlin",
      translated: "بالإمدادات",
      tone: 'semantic',
    },
    {
      german: "durch eine Luftbrücke",
      translated: "عبر جسر جوي",
      tone: 'semantic',
    },
    {
      german: "Welcher Umstand",
      translated: "ما السبب",
      tone: 'semantic',
    },
    {
      german: "war dafür verantwortlich",
      translated: "في ذلك؟",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:178|bg": [
    {
      german: "Vom Juni 1948",
      translated: "От юни 1948",
      tone: 'semantic',
    },
    {
      german: "bis zum Mai 1949",
      translated: "до май 1949 г.",
      tone: 'semantic',
    },
    {
      german: "die Bürgerinnen und Bürger",
      translated: "жителите",
      tone: 'semantic',
    },
    {
      german: "von West-Berlin",
      translated: "на Западен Берлин",
      tone: 'semantic',
    },
    {
      german: "durch eine Luftbrücke",
      translated: "чрез въздушен мост",
      tone: 'semantic',
    },
    {
      german: "versorgt",
      translated: "са снабдявани",
      tone: 'semantic',
    },
    {
      german: "Welcher Umstand",
      translated: "Защо",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:178|bs": [
    {
      german: "Vom Juni 1948",
      translated: "Od juna 1948",
      tone: 'semantic',
    },
    {
      german: "bis zum Mai 1949",
      translated: "do maja 1949",
      tone: 'semantic',
    },
    {
      german: "die Bürgerinnen und Bürger",
      translated: "stanovnici",
      tone: 'semantic',
    },
    {
      german: "von West-Berlin",
      translated: "Zapadnog Berlina",
      tone: 'semantic',
    },
    {
      german: "durch eine Luftbrücke",
      translated: "zračnim mostom",
      tone: 'semantic',
    },
    {
      german: "versorgt",
      translated: "opskrbljivani su",
      tone: 'semantic',
    },
    {
      german: "Welcher Umstand",
      translated: "Zašto",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:178|el": [
    {
      german: "Vom Juni 1948",
      translated: "Από τον Ιούνιο του 1948",
      tone: 'semantic',
    },
    {
      german: "bis zum Mai 1949",
      translated: "έως τον Μάιο του 1949",
      tone: 'semantic',
    },
    {
      german: "die Bürgerinnen und Bürger",
      translated: "οι κάτοικοι",
      tone: 'semantic',
    },
    {
      german: "von West-Berlin",
      translated: "του Δυτικού Βερολίνου",
      tone: 'semantic',
    },
    {
      german: "durch eine Luftbrücke",
      translated: "μέσω αερογέφυρας",
      tone: 'semantic',
    },
    {
      german: "versorgt",
      translated: "τροφοδοτούνταν",
      tone: 'semantic',
    },
    {
      german: "Welcher Umstand",
      translated: "Γιατί",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:178|en": [
    {
      german: "Vom Juni 1948",
      translated: "From June 1948",
      tone: 'semantic',
    },
    {
      german: "bis zum Mai 1949",
      translated: "to May 1949",
      tone: 'semantic',
    },
    {
      german: "die Bürgerinnen und Bürger",
      translated: "the citizens",
      tone: 'semantic',
    },
    {
      german: "von West-Berlin",
      translated: "of West Berlin",
      tone: 'semantic',
    },
    {
      german: "durch eine Luftbrücke",
      translated: "by an airlift",
      tone: 'semantic',
    },
    {
      german: "versorgt",
      translated: "were supplied",
      tone: 'semantic',
    },
    {
      german: "Welcher Umstand",
      translated: "What circumstance",
      tone: 'semantic',
    },
    {
      german: "war dafür verantwortlich",
      translated: "was responsible for this",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:178|es": [
    {
      german: "Vom Juni 1948",
      translated: "De junio de 1948",
      tone: 'semantic',
    },
    {
      german: "bis zum Mai 1949",
      translated: "a mayo de 1949",
      tone: 'semantic',
    },
    {
      german: "die Bürgerinnen und Bürger",
      translated: "los habitantes",
      tone: 'semantic',
    },
    {
      german: "von West-Berlin",
      translated: "de Berlín Occidental",
      tone: 'semantic',
    },
    {
      german: "durch eine Luftbrücke",
      translated: "mediante un puente aéreo",
      tone: 'semantic',
    },
    {
      german: "versorgt",
      translated: "abastecidos",
      tone: 'semantic',
    },
    {
      german: "Welcher Umstand",
      translated: "¿Cuál fue",
      tone: 'semantic',
    },
    {
      german: "war dafür verantwortlich",
      translated: "la causa",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:178|fa": [
    {
      german: "Vom Juni 1948",
      translated: "از ژوئن ۱۹۴۸",
      tone: 'semantic',
    },
    {
      german: "bis zum Mai 1949",
      translated: "تا مه ۱۹۴۹",
      tone: 'semantic',
    },
    {
      german: "die Bürgerinnen und Bürger",
      translated: "ساکنان",
      tone: 'semantic',
    },
    {
      german: "von West-Berlin",
      translated: "برلین غربی",
      tone: 'semantic',
    },
    {
      german: "durch eine Luftbrücke",
      translated: "از طریق پل هوایی",
      tone: 'semantic',
    },
    {
      german: "versorgt",
      translated: "تأمین می‌شدند",
      tone: 'semantic',
    },
    {
      german: "Welcher Umstand",
      translated: "دلیل",
      tone: 'semantic',
    },
    {
      german: "war dafür verantwortlich",
      translated: "آن چه بود؟",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:178|fr": [
    {
      german: "Vom Juni 1948",
      translated: "De juin 1948",
      tone: 'semantic',
    },
    {
      german: "bis zum Mai 1949",
      translated: "à mai 1949",
      tone: 'semantic',
    },
    {
      german: "die Bürgerinnen und Bürger",
      translated: "les habitants",
      tone: 'semantic',
    },
    {
      german: "von West-Berlin",
      translated: "de Berlin-Ouest",
      tone: 'semantic',
    },
    {
      german: "durch eine Luftbrücke",
      translated: "par un pont aérien",
      tone: 'semantic',
    },
    {
      german: "versorgt",
      translated: "ont été approvisionnés",
      tone: 'semantic',
    },
    {
      german: "Welcher Umstand",
      translated: "Quelle en",
      tone: 'semantic',
    },
    {
      german: "war dafür verantwortlich",
      translated: "était la raison",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:178|hr": [
    {
      german: "Vom Juni 1948",
      translated: "Od lipnja 1948.",
      tone: 'semantic',
    },
    {
      german: "bis zum Mai 1949",
      translated: "do svibnja 1949.",
      tone: 'semantic',
    },
    {
      german: "die Bürgerinnen und Bürger",
      translated: "stanovnici",
      tone: 'semantic',
    },
    {
      german: "von West-Berlin",
      translated: "Zapadnog Berlina",
      tone: 'semantic',
    },
    {
      german: "durch eine Luftbrücke",
      translated: "zračnim mostom",
      tone: 'semantic',
    },
    {
      german: "versorgt",
      translated: "opskrbljivani su",
      tone: 'semantic',
    },
    {
      german: "Welcher Umstand",
      translated: "Zašto",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:178|it": [
    {
      german: "Vom Juni 1948",
      translated: "Da giugno 1948",
      tone: 'semantic',
    },
    {
      german: "bis zum Mai 1949",
      translated: "a maggio 1949",
      tone: 'semantic',
    },
    {
      german: "die Bürgerinnen und Bürger",
      translated: "gli abitanti",
      tone: 'semantic',
    },
    {
      german: "von West-Berlin",
      translated: "di Berlino Ovest",
      tone: 'semantic',
    },
    {
      german: "durch eine Luftbrücke",
      translated: "tramite un ponte aereo",
      tone: 'semantic',
    },
    {
      german: "versorgt",
      translated: "furono riforniti",
      tone: 'semantic',
    },
    {
      german: "Welcher Umstand",
      translated: "Perché",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:178|kmr": [
    {
      german: "Vom Juni 1948",
      translated: "Ji Hezîrana 1948",
      tone: 'semantic',
    },
    {
      german: "bis zum Mai 1949",
      translated: "heta Gulana 1949",
      tone: 'semantic',
    },
    {
      german: "die Bürgerinnen und Bürger",
      translated: "niştecihên Berlîna Rojava",
      tone: 'semantic',
    },
    {
      german: "durch eine Luftbrücke",
      translated: "bi pira hewayî",
      tone: 'semantic',
    },
    {
      german: "versorgt",
      translated: "hatin dabînkirin",
      tone: 'semantic',
    },
    {
      german: "Welcher Umstand",
      translated: "Sedem çi",
      tone: 'semantic',
    },
    {
      german: "war dafür verantwortlich",
      translated: "bû",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:178|pl": [
    {
      german: "Vom Juni 1948",
      translated: "Od czerwca 1948 r.",
      tone: 'semantic',
    },
    {
      german: "bis zum Mai 1949",
      translated: "do maja 1949 r.",
      tone: 'semantic',
    },
    {
      german: "die Bürgerinnen und Bürger",
      translated: "mieszkańcy",
      tone: 'semantic',
    },
    {
      german: "von West-Berlin",
      translated: "Berlina Zachodniego",
      tone: 'semantic',
    },
    {
      german: "durch eine Luftbrücke",
      translated: "mostem powietrznym",
      tone: 'semantic',
    },
    {
      german: "versorgt",
      translated: "zaopatrywani",
      tone: 'semantic',
    },
    {
      german: "Welcher Umstand",
      translated: "Dlaczego",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:178|prs": [
    {
      german: "Vom Juni 1948",
      translated: "از ژوئن ۱۹۴۸",
      tone: 'semantic',
    },
    {
      german: "bis zum Mai 1949",
      translated: "تا مه ۱۹۴۹",
      tone: 'semantic',
    },
    {
      german: "die Bürgerinnen und Bürger",
      translated: "ساکنان",
      tone: 'semantic',
    },
    {
      german: "von West-Berlin",
      translated: "برلین غربی",
      tone: 'semantic',
    },
    {
      german: "durch eine Luftbrücke",
      translated: "از طریق پل هوایی",
      tone: 'semantic',
    },
    {
      german: "versorgt",
      translated: "تأمین می‌شدند",
      tone: 'semantic',
    },
    {
      german: "Welcher Umstand",
      translated: "دلیل آن",
      tone: 'semantic',
    },
    {
      german: "war dafür verantwortlich",
      translated: "چه بود",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:178|ro": [
    {
      german: "Vom Juni 1948",
      translated: "Din iunie 1948",
      tone: 'semantic',
    },
    {
      german: "bis zum Mai 1949",
      translated: "până în mai 1949",
      tone: 'semantic',
    },
    {
      german: "die Bürgerinnen und Bürger",
      translated: "locuitorii",
      tone: 'semantic',
    },
    {
      german: "von West-Berlin",
      translated: "Berlinului de Vest",
      tone: 'semantic',
    },
    {
      german: "durch eine Luftbrücke",
      translated: "printr-un pod aerian",
      tone: 'semantic',
    },
    {
      german: "versorgt",
      translated: "aprovizionați",
      tone: 'semantic',
    },
    {
      german: "Welcher Umstand",
      translated: "De ce",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:178|ru": [
    {
      german: "Vom Juni 1948",
      translated: "С июня 1948",
      tone: 'semantic',
    },
    {
      german: "bis zum Mai 1949",
      translated: "по май 1949 года",
      tone: 'semantic',
    },
    {
      german: "die Bürgerinnen und Bürger",
      translated: "жители",
      tone: 'semantic',
    },
    {
      german: "von West-Berlin",
      translated: "Западного Берлина",
      tone: 'semantic',
    },
    {
      german: "durch eine Luftbrücke",
      translated: "с помощью воздушного моста",
      tone: 'semantic',
    },
    {
      german: "versorgt",
      translated: "снабжались",
      tone: 'semantic',
    },
    {
      german: "Welcher Umstand",
      translated: "Чем",
      tone: 'semantic',
    },
    {
      german: "war dafür verantwortlich",
      translated: "было вызвано",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:178|sq": [
    {
      german: "Vom Juni 1948",
      translated: "Nga qershori 1948",
      tone: 'semantic',
    },
    {
      german: "bis zum Mai 1949",
      translated: "deri në maj 1949",
      tone: 'semantic',
    },
    {
      german: "die Bürgerinnen und Bürger",
      translated: "banorët e Berlinit Perëndimor",
      tone: 'semantic',
    },
    {
      german: "durch eine Luftbrücke",
      translated: "me urë ajrore",
      tone: 'semantic',
    },
    {
      german: "versorgt",
      translated: "furnizoheshin",
      tone: 'semantic',
    },
    {
      german: "Welcher Umstand",
      translated: "Pse",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:178|sr": [
    {
      german: "Vom Juni 1948",
      translated: "Od juna 1948.",
      tone: 'semantic',
    },
    {
      german: "bis zum Mai 1949",
      translated: "do maja 1949.",
      tone: 'semantic',
    },
    {
      german: "die Bürgerinnen und Bürger",
      translated: "stanovnici",
      tone: 'semantic',
    },
    {
      german: "von West-Berlin",
      translated: "Zapadnog Berlina",
      tone: 'semantic',
    },
    {
      german: "durch eine Luftbrücke",
      translated: "vazdušnim mostom",
      tone: 'semantic',
    },
    {
      german: "versorgt",
      translated: "opskrbljivani",
      tone: 'semantic',
    },
    {
      german: "Welcher Umstand",
      translated: "Zašto",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:178|tr": [
    {
      german: "Vom Juni 1948",
      translated: "Haziran 1948'den",
      tone: 'semantic',
    },
    {
      german: "bis zum Mai 1949",
      translated: "Mayıs 1949'a kadar",
      tone: 'semantic',
    },
    {
      german: "die Bürgerinnen und Bürger",
      translated: "halkına",
      tone: 'semantic',
    },
    {
      german: "von West-Berlin",
      translated: "Batı Berlin",
      tone: 'semantic',
    },
    {
      german: "durch eine Luftbrücke",
      translated: "hava köprüsüyle",
      tone: 'semantic',
    },
    {
      german: "versorgt",
      translated: "ikmal yapıldı",
      tone: 'semantic',
    },
    {
      german: "Welcher Umstand",
      translated: "Bunun nedeni",
      tone: 'semantic',
    },
    {
      german: "war dafür verantwortlich",
      translated: "neydi?",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:178|uk": [
    {
      german: "Vom Juni 1948",
      translated: "З червня 1948",
      tone: 'semantic',
    },
    {
      german: "bis zum Mai 1949",
      translated: "до травня 1949 року",
      tone: 'semantic',
    },
    {
      german: "die Bürgerinnen und Bürger",
      translated: "мешканців Західного Берліна",
      tone: 'semantic',
    },
    {
      german: "von West-Berlin",
      translated: "забезпечували",
      tone: 'semantic',
    },
    {
      german: "durch eine Luftbrücke",
      translated: "через повітряний міст",
      tone: 'semantic',
    },
    {
      german: "Welcher Umstand",
      translated: "Що стало",
      tone: 'semantic',
    },
    {
      german: "war dafür verantwortlich",
      translated: "причиною цього",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:178|vi": [
    {
      german: "Vom Juni 1948",
      translated: "Từ tháng 6 năm 1948",
      tone: 'semantic',
    },
    {
      german: "bis zum Mai 1949",
      translated: "đến tháng 5 năm 1949",
      tone: 'semantic',
    },
    {
      german: "die Bürgerinnen und Bürger",
      translated: "cư dân",
      tone: 'semantic',
    },
    {
      german: "von West-Berlin",
      translated: "Tây Berlin",
      tone: 'semantic',
    },
    {
      german: "durch eine Luftbrücke",
      translated: "bằng cầu hàng không",
      tone: 'semantic',
    },
    {
      german: "versorgt",
      translated: "được tiếp tế",
      tone: 'semantic',
    },
    {
      german: "Welcher Umstand",
      translated: "Tại sao",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:179|ar": [
    {
      german: "Wie",
      translated: "كيف",
      tone: 'semantic',
    },
    {
      german: "endete",
      translated: "انتهت",
      tone: 'semantic',
    },
    {
      german: "der Zweite Weltkrieg",
      translated: "الحرب العالمية الثانية",
      tone: 'semantic',
    },
    {
      german: "in Europa",
      translated: "في أوروبا",
      tone: 'semantic',
    },
    {
      german: "offiziell",
      translated: "رسميًا",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:179|bg": [
    {
      german: "Wie",
      translated: "Как",
      tone: 'semantic',
    },
    {
      german: "endete",
      translated: "завършва",
      tone: 'semantic',
    },
    {
      german: "der Zweite Weltkrieg",
      translated: "Втората световна война",
      tone: 'semantic',
    },
    {
      german: "in Europa",
      translated: "в Европа",
      tone: 'semantic',
    },
    {
      german: "offiziell",
      translated: "официално",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:179|bs": [
    {
      german: "Wie",
      translated: "Kako",
      tone: 'semantic',
    },
    {
      german: "endete",
      translated: "završio",
      tone: 'semantic',
    },
    {
      german: "der Zweite Weltkrieg",
      translated: "Drugi svjetski rat",
      tone: 'semantic',
    },
    {
      german: "in Europa",
      translated: "u Europi",
      tone: 'semantic',
    },
    {
      german: "offiziell",
      translated: "službeno",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:179|el": [
    {
      german: "Wie",
      translated: "Πώς",
      tone: 'semantic',
    },
    {
      german: "endete",
      translated: "έληξε",
      tone: 'semantic',
    },
    {
      german: "der Zweite Weltkrieg",
      translated: "ο Β΄ Παγκόσμιος Πόλεμος",
      tone: 'semantic',
    },
    {
      german: "in Europa",
      translated: "στην Ευρώπη",
      tone: 'semantic',
    },
    {
      german: "offiziell",
      translated: "επίσημα",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:179|en": [
    {
      german: "Wie",
      translated: "How",
      tone: 'semantic',
    },
    {
      german: "endete",
      translated: "end",
      tone: 'semantic',
    },
    {
      german: "der Zweite Weltkrieg",
      translated: "World War II",
      tone: 'semantic',
    },
    {
      german: "in Europa",
      translated: "in Europe",
      tone: 'semantic',
    },
    {
      german: "offiziell",
      translated: "officially",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:179|es": [
    {
      german: "Wie",
      translated: "¿Cómo",
      tone: 'semantic',
    },
    {
      german: "endete",
      translated: "terminó",
      tone: 'semantic',
    },
    {
      german: "der Zweite Weltkrieg",
      translated: "la Segunda Guerra Mundial",
      tone: 'semantic',
    },
    {
      german: "in Europa",
      translated: "en Europa",
      tone: 'semantic',
    },
    {
      german: "offiziell",
      translated: "oficialmente",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:179|fa": [
    {
      german: "Wie",
      translated: "چگونه",
      tone: 'semantic',
    },
    {
      german: "endete",
      translated: "پایان یافت",
      tone: 'semantic',
    },
    {
      german: "der Zweite Weltkrieg",
      translated: "جنگ جهانی دوم",
      tone: 'semantic',
    },
    {
      german: "in Europa",
      translated: "در اروپا",
      tone: 'semantic',
    },
    {
      german: "offiziell",
      translated: "رسماً",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:179|fr": [
    {
      german: "Wie",
      translated: "Comment",
      tone: 'semantic',
    },
    {
      german: "endete",
      translated: "terminée",
      tone: 'semantic',
    },
    {
      german: "der Zweite Weltkrieg",
      translated: "la Seconde Guerre mondiale",
      tone: 'semantic',
    },
    {
      german: "in Europa",
      translated: "en Europe",
      tone: 'semantic',
    },
    {
      german: "offiziell",
      translated: "officiellement",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:179|hr": [
    {
      german: "Wie",
      translated: "Kako",
      tone: 'semantic',
    },
    {
      german: "endete",
      translated: "završio",
      tone: 'semantic',
    },
    {
      german: "der Zweite Weltkrieg",
      translated: "Drugi svjetski rat",
      tone: 'semantic',
    },
    {
      german: "in Europa",
      translated: "u Europi",
      tone: 'semantic',
    },
    {
      german: "offiziell",
      translated: "službeno",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:179|it": [
    {
      german: "Wie",
      translated: "Come",
      tone: 'semantic',
    },
    {
      german: "endete",
      translated: "terminò",
      tone: 'semantic',
    },
    {
      german: "der Zweite Weltkrieg",
      translated: "Seconda guerra mondiale",
      tone: 'semantic',
    },
    {
      german: "in Europa",
      translated: "in Europa",
      tone: 'semantic',
    },
    {
      german: "offiziell",
      translated: "ufficialmente",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:179|kmr": [
    {
      german: "Wie",
      translated: "çawa",
      tone: 'semantic',
    },
    {
      german: "endete",
      translated: "qediya",
      tone: 'semantic',
    },
    {
      german: "der Zweite Weltkrieg",
      translated: "Şerê Cîhanê yê Duyemîn",
      tone: 'semantic',
    },
    {
      german: "in Europa",
      translated: "li Ewropayê",
      tone: 'semantic',
    },
    {
      german: "offiziell",
      translated: "bi awayekî fermî",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:179|pl": [
    {
      german: "Wie",
      translated: "Jak",
      tone: 'semantic',
    },
    {
      german: "endete",
      translated: "zakończyła się",
      tone: 'semantic',
    },
    {
      german: "der Zweite Weltkrieg",
      translated: "II wojna światowa",
      tone: 'semantic',
    },
    {
      german: "in Europa",
      translated: "w Europie",
      tone: 'semantic',
    },
    {
      german: "offiziell",
      translated: "oficjalnie",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:179|prs": [
    {
      german: "Wie",
      translated: "چگونه",
      tone: 'semantic',
    },
    {
      german: "endete",
      translated: "پایان یافت",
      tone: 'semantic',
    },
    {
      german: "der Zweite Weltkrieg",
      translated: "جنگ جهانی دوم",
      tone: 'semantic',
    },
    {
      german: "in Europa",
      translated: "در اروپا",
      tone: 'semantic',
    },
    {
      german: "offiziell",
      translated: "رسماً",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:179|ro": [
    {
      german: "Wie",
      translated: "Cum",
      tone: 'semantic',
    },
    {
      german: "endete",
      translated: "s-a încheiat",
      tone: 'semantic',
    },
    {
      german: "der Zweite Weltkrieg",
      translated: "Al Doilea Război Mondial",
      tone: 'semantic',
    },
    {
      german: "in Europa",
      translated: "în Europa",
      tone: 'semantic',
    },
    {
      german: "offiziell",
      translated: "oficial",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:179|ru": [
    {
      german: "Wie",
      translated: "Как",
      tone: 'semantic',
    },
    {
      german: "endete",
      translated: "закончилась",
      tone: 'semantic',
    },
    {
      german: "der Zweite Weltkrieg",
      translated: "Вторая мировая война",
      tone: 'semantic',
    },
    {
      german: "in Europa",
      translated: "в Европе",
      tone: 'semantic',
    },
    {
      german: "offiziell",
      translated: "официально",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:179|sq": [
    {
      german: "Wie",
      translated: "Si",
      tone: 'semantic',
    },
    {
      german: "endete",
      translated: "përfundoi",
      tone: 'semantic',
    },
    {
      german: "der Zweite Weltkrieg",
      translated: "Lufta e Dytë Botërore",
      tone: 'semantic',
    },
    {
      german: "in Europa",
      translated: "në Evropë",
      tone: 'semantic',
    },
    {
      german: "offiziell",
      translated: "zyrtarisht",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:179|sr": [
    {
      german: "Wie",
      translated: "Kako",
      tone: 'semantic',
    },
    {
      german: "endete",
      translated: "završio",
      tone: 'semantic',
    },
    {
      german: "der Zweite Weltkrieg",
      translated: "Drugi svjetski rat",
      tone: 'semantic',
    },
    {
      german: "in Europa",
      translated: "u Europi",
      tone: 'semantic',
    },
    {
      german: "offiziell",
      translated: "zvanično",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:179|tr": [
    {
      german: "Wie",
      translated: "nasıl",
      tone: 'semantic',
    },
    {
      german: "endete",
      translated: "sona erdi",
      tone: 'semantic',
    },
    {
      german: "der Zweite Weltkrieg",
      translated: "İkinci Dünya Savaşı",
      tone: 'semantic',
    },
    {
      german: "in Europa",
      translated: "Avrupa'da",
      tone: 'semantic',
    },
    {
      german: "offiziell",
      translated: "resmen",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:179|uk": [
    {
      german: "Wie",
      translated: "Як",
      tone: 'semantic',
    },
    {
      german: "endete",
      translated: "закінчилася",
      tone: 'semantic',
    },
    {
      german: "der Zweite Weltkrieg",
      translated: "Друга світова війна",
      tone: 'semantic',
    },
    {
      german: "in Europa",
      translated: "в Європі",
      tone: 'semantic',
    },
    {
      german: "offiziell",
      translated: "офіційно",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:179|vi": [
    {
      german: "Wie",
      translated: "như thế nào",
      tone: 'semantic',
    },
    {
      german: "endete",
      translated: "kết thúc",
      tone: 'semantic',
    },
    {
      german: "der Zweite Weltkrieg",
      translated: "Chiến tranh thế giới thứ hai",
      tone: 'semantic',
    },
    {
      german: "in Europa",
      translated: "ở châu Âu",
      tone: 'semantic',
    },
    {
      german: "offiziell",
      translated: "chính thức",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:17|ar": [
    {
      german: "Die deutschen Gesetze",
      translated: "القوانين الألمانية",
      tone: 'semantic',
    },
    {
      german: "verbieten",
      translated: "تحظر",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:17|bg": [
    {
      german: "Die deutschen Gesetze",
      translated: "законите в Германия",
      tone: 'semantic',
    },
    {
      german: "verbieten",
      translated: "забраняват",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:17|bs": [
    {
      german: "Die deutschen Gesetze",
      translated: "Njemačko pravo",
      tone: 'semantic',
    },
    {
      german: "verbieten",
      translated: "zabranjuje",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:17|el": [
    {
      german: "Die deutschen Gesetze",
      translated: "Οι νόμοι στη Γερμανία",
      tone: 'semantic',
    },
    {
      german: "verbieten",
      translated: "απαγορεύουν",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:17|en": [
    {
      german: "Die deutschen Gesetze",
      translated: "German laws",
      tone: 'semantic',
    },
    {
      german: "verbieten",
      translated: "prohibit",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:17|es": [
    {
      german: "Die deutschen Gesetze",
      translated: "Las leyes alemanas",
      tone: 'semantic',
    },
    {
      german: "verbieten",
      translated: "prohíben",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:17|fa": [
    {
      german: "Die deutschen Gesetze",
      translated: "قوانین آلمان",
      tone: 'semantic',
    },
    {
      german: "verbieten",
      translated: "ممنوع می‌کنند",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:17|fr": [
    {
      german: "Die deutschen Gesetze",
      translated: "Les lois allemandes",
      tone: 'semantic',
    },
    {
      german: "verbieten",
      translated: "interdisent",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:17|hr": [
    {
      german: "Die deutschen Gesetze",
      translated: "Njemačko pravo",
      tone: 'semantic',
    },
    {
      german: "verbieten",
      translated: "zabranjuje",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:17|it": [
    {
      german: "Die deutschen Gesetze",
      translated: "Le leggi tedesche",
      tone: 'semantic',
    },
    {
      german: "verbieten",
      translated: "vietano",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:17|kmr": [
    {
      german: "Die deutschen Gesetze",
      translated: "Qanûnên Alman",
      tone: 'semantic',
    },
    {
      german: "verbieten",
      translated: "dikin",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:17|pl": [
    {
      german: "Die deutschen Gesetze",
      translated: "Niemieckie prawo",
      tone: 'semantic',
    },
    {
      german: "verbieten",
      translated: "zabrania",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:17|prs": [
    {
      german: "Die deutschen Gesetze",
      translated: "قوانین آلمان",
      tone: 'semantic',
    },
    {
      german: "verbieten",
      translated: "ممنوع می‌کنند",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:17|ro": [
    {
      german: "Die deutschen Gesetze",
      translated: "legile din Germania",
      tone: 'semantic',
    },
    {
      german: "verbieten",
      translated: "interzic",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:17|ru": [
    {
      german: "Die deutschen Gesetze",
      translated: "Немецкие законы",
      tone: 'semantic',
    },
    {
      german: "verbieten",
      translated: "запрещают",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:17|sq": [
    {
      german: "Die deutschen Gesetze",
      translated: "Ligjet gjermane",
      tone: 'semantic',
    },
    {
      german: "verbieten",
      translated: "ndalojnë",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:17|sr": [
    {
      german: "Die deutschen Gesetze",
      translated: "Nemačko pravo",
      tone: 'semantic',
    },
    {
      german: "verbieten",
      translated: "zabranjuje",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:17|tr": [
    {
      german: "Die deutschen Gesetze",
      translated: "Alman yasaları",
      tone: 'semantic',
    },
    {
      german: "verbieten",
      translated: "yasaklar",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:17|uk": [
    {
      german: "Die deutschen Gesetze",
      translated: "Закони Німеччини",
      tone: 'semantic',
    },
    {
      german: "verbieten",
      translated: "забороняють",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:17|vi": [
    {
      german: "Die deutschen Gesetze",
      translated: "Pháp luật Đức",
      tone: 'semantic',
    },
    {
      german: "verbieten",
      translated: "cấm",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:180|ar": [
    {
      german: "Der erste Bundeskanzler",
      translated: "أول مستشار اتحادي",
      tone: 'semantic',
    },
    {
      german: "der Bundesrepublik Deutschland",
      translated: "لجمهورية ألمانيا الاتحادية",
      tone: 'semantic',
    },
    {
      german: "war",
      translated: "كان",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:180|bg": [
    {
      german: "Der erste Bundeskanzler",
      translated: "Първият федерален канцлер",
      tone: 'semantic',
    },
    {
      german: "der Bundesrepublik Deutschland",
      translated: "на Федерална република Германия",
      tone: 'semantic',
    },
    {
      german: "war",
      translated: "е",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:180|bs": [
    {
      german: "Der erste Bundeskanzler",
      translated: "Prvi kancelar",
      tone: 'semantic',
    },
    {
      german: "der Bundesrepublik Deutschland",
      translated: "Savezne Republike Njemačke",
      tone: 'semantic',
    },
    {
      german: "war",
      translated: "bio je",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:180|el": [
    {
      german: "Der erste Bundeskanzler",
      translated: "Ο πρώτος Ομοσπονδιακός Καγκελάριος",
      tone: 'semantic',
    },
    {
      german: "der Bundesrepublik Deutschland",
      translated: "της Ομοσπονδιακής Δημοκρατίας της Γερμανίας",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:180|en": [
    {
      german: "Der erste Bundeskanzler",
      translated: "The first Federal Chancellor",
      tone: 'semantic',
    },
    {
      german: "der Bundesrepublik Deutschland",
      translated: "of the Federal Republic of Germany",
      tone: 'semantic',
    },
    {
      german: "war",
      translated: "was",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:180|es": [
    {
      german: "Der erste Bundeskanzler",
      translated: "El primer Canciller Federal",
      tone: 'semantic',
    },
    {
      german: "der Bundesrepublik Deutschland",
      translated: "de la República Federal de Alemania",
      tone: 'semantic',
    },
    {
      german: "war",
      translated: "fue",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:180|fa": [
    {
      german: "Der erste Bundeskanzler",
      translated: "نخستین صدراعظم",
      tone: 'semantic',
    },
    {
      german: "der Bundesrepublik Deutschland",
      translated: "جمهوری فدرال آلمان",
      tone: 'semantic',
    },
    {
      german: "war",
      translated: "بود",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:180|fr": [
    {
      german: "Der erste Bundeskanzler",
      translated: "Le premier chancelier fédéral",
      tone: 'semantic',
    },
    {
      german: "der Bundesrepublik Deutschland",
      translated: "de la République fédérale d’Allemagne",
      tone: 'semantic',
    },
    {
      german: "war",
      translated: "était",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:180|hr": [
    {
      german: "Der erste Bundeskanzler",
      translated: "Prvi kancelar",
      tone: 'semantic',
    },
    {
      german: "der Bundesrepublik Deutschland",
      translated: "Savezne Republike Njemačke",
      tone: 'semantic',
    },
    {
      german: "war",
      translated: "bio je",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:180|it": [
    {
      german: "Der erste Bundeskanzler",
      translated: "Il primo cancelliere",
      tone: 'semantic',
    },
    {
      german: "der Bundesrepublik Deutschland",
      translated: "della Repubblica Federale di Germania",
      tone: 'semantic',
    },
    {
      german: "war",
      translated: "fu",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:180|kmr": [
    {
      german: "Der erste Bundeskanzler",
      translated: "Yekem Kanselerê Federal",
      tone: 'semantic',
    },
    {
      german: "der Bundesrepublik Deutschland",
      translated: "a Komara Federal a Almanyayê",
      tone: 'semantic',
    },
    {
      german: "war",
      translated: "bû",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:180|pl": [
    {
      german: "Der erste Bundeskanzler",
      translated: "Pierwszym kanclerzem",
      tone: 'semantic',
    },
    {
      german: "der Bundesrepublik Deutschland",
      translated: "Republiki Federalnej Niemiec",
      tone: 'semantic',
    },
    {
      german: "war",
      translated: "był",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:180|prs": [
    {
      german: "Der erste Bundeskanzler",
      translated: "نخستین صدراعظم",
      tone: 'semantic',
    },
    {
      german: "der Bundesrepublik Deutschland",
      translated: "جمهوری فدرال آلمان",
      tone: 'semantic',
    },
    {
      german: "war",
      translated: "بود",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:180|ro": [
    {
      german: "Der erste Bundeskanzler",
      translated: "Primul cancelar",
      tone: 'semantic',
    },
    {
      german: "der Bundesrepublik Deutschland",
      translated: "al Republicii Federale Germania",
      tone: 'semantic',
    },
    {
      german: "war",
      translated: "a fost",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:180|ru": [
    {
      german: "Der erste Bundeskanzler",
      translated: "Первым федеральным канцлером",
      tone: 'semantic',
    },
    {
      german: "der Bundesrepublik Deutschland",
      translated: "ФРГ",
      tone: 'semantic',
    },
    {
      german: "war",
      translated: "был",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:180|sq": [
    {
      german: "Der erste Bundeskanzler",
      translated: "Kancelari i parë federal",
      tone: 'semantic',
    },
    {
      german: "der Bundesrepublik Deutschland",
      translated: "Republikës Federale të Gjermanisë",
      tone: 'semantic',
    },
    {
      german: "war",
      translated: "ishte",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:180|sr": [
    {
      german: "Der erste Bundeskanzler",
      translated: "Prvi kancelar",
      tone: 'semantic',
    },
    {
      german: "der Bundesrepublik Deutschland",
      translated: "Savezne Republike Nemačke",
      tone: 'semantic',
    },
    {
      german: "war",
      translated: "bio je",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:180|tr": [
    {
      german: "Der erste Bundeskanzler",
      translated: "ilk Federal Başbakanı",
      tone: 'semantic',
    },
    {
      german: "der Bundesrepublik Deutschland",
      translated: "Almanya Federal Cumhuriyeti'nin",
      tone: 'semantic',
    },
    {
      german: "war",
      translated: "idi.",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:180|uk": [
    {
      german: "Der erste Bundeskanzler",
      translated: "Першим федеральним канцлером",
      tone: 'semantic',
    },
    {
      german: "der Bundesrepublik Deutschland",
      translated: "Федеративної Республіки Німеччина",
      tone: 'semantic',
    },
    {
      german: "war",
      translated: "був",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:180|vi": [
    {
      german: "Der erste Bundeskanzler",
      translated: "Thủ tướng Liên bang đầu tiên",
      tone: 'semantic',
    },
    {
      german: "der Bundesrepublik Deutschland",
      translated: "của Cộng hòa Liên bang Đức",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:181|ar": [
    {
      german: "Was wollte",
      translated: "ماذا أراد",
      tone: 'semantic',
    },
    {
      german: "Willy Brandt",
      translated: "فيلي برانت",
      tone: 'semantic',
    },
    {
      german: "mit seinem Kniefall",
      translated: "عندما جثا على ركبتيه",
      tone: 'semantic',
    },
    {
      german: "1970",
      translated: "عام 1970",
      tone: 'semantic',
    },
    {
      german: "im ehemaligen jüdischen Ghetto",
      translated: "في الحي اليهودي السابق",
      tone: 'semantic',
    },
    {
      german: "in Warschau",
      translated: "في وارسو",
      tone: 'semantic',
    },
    {
      german: "ausdrücken",
      translated: "أن يعبّر عنه",
      tone: 'semantic',
    },
    {
      german: "© Bundesregierung/Engelbert Reineke",
      translated: "© Bundesregierung/Engelbert Reineke",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:181|bg": [
    {
      german: "Was wollte",
      translated: "Какво иска",
      tone: 'semantic',
    },
    {
      german: "Willy Brandt",
      translated: "Вили Бранд",
      tone: 'semantic',
    },
    {
      german: "mit seinem Kniefall",
      translated: "с колениченето си",
      tone: 'semantic',
    },
    {
      german: "1970",
      translated: "1970 г.",
      tone: 'semantic',
    },
    {
      german: "im ehemaligen jüdischen Ghetto",
      translated: "в бившето еврейско гето",
      tone: 'semantic',
    },
    {
      german: "in Warschau",
      translated: "във Варшава",
      tone: 'semantic',
    },
    {
      german: "ausdrücken",
      translated: "изрази",
      tone: 'semantic',
    },
    {
      german: "© Bundesregierung/Engelbert Reineke",
      translated: "© Bundesregierung/Engelbert Reineke",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:181|bs": [
    {
      german: "Was wollte",
      translated: "Što je Willy Brandt želio",
      tone: 'semantic',
    },
    {
      german: "mit seinem Kniefall",
      translated: "kada je 1970. kleknuo pred spomenikom",
      tone: 'semantic',
    },
    {
      german: "im ehemaligen jüdischen Ghetto",
      translated: "nekadašnjem jevrejskom getu u Varšavi",
      tone: 'semantic',
    },
    {
      german: "ausdrücken",
      translated: "izraziti",
      tone: 'semantic',
    },
    {
      german: "© Bundesregierung/Engelbert Reineke",
      translated: "© Bundesregierung/Engelbert Reineke",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:181|el": [
    {
      german: "Was wollte",
      translated: "Τι ήθελε",
      tone: 'semantic',
    },
    {
      german: "Willy Brandt",
      translated: "ο Willy Brandt",
      tone: 'semantic',
    },
    {
      german: "mit seinem Kniefall",
      translated: "με τη γονυκλισία του",
      tone: 'semantic',
    },
    {
      german: "1970",
      translated: "το 1970",
      tone: 'semantic',
    },
    {
      german: "im ehemaligen jüdischen Ghetto",
      translated: "στο πρώην εβραϊκό γκέτο",
      tone: 'semantic',
    },
    {
      german: "in Warschau",
      translated: "της Βαρσοβίας",
      tone: 'semantic',
    },
    {
      german: "ausdrücken",
      translated: "εκφράσει",
      tone: 'semantic',
    },
    {
      german: "© Bundesregierung/Engelbert Reineke",
      translated: "© Bundesregierung/Engelbert Reineke",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:181|en": [
    {
      german: "Was wollte",
      translated: "What did",
      tone: 'semantic',
    },
    {
      german: "Willy Brandt",
      translated: "Willy Brandt",
      tone: 'semantic',
    },
    {
      german: "mit seinem Kniefall",
      translated: "with his kneeling",
      tone: 'semantic',
    },
    {
      german: "1970",
      translated: "in 1970",
      tone: 'semantic',
    },
    {
      german: "im ehemaligen jüdischen Ghetto",
      translated: "the former Jewish ghetto",
      tone: 'semantic',
    },
    {
      german: "in Warschau",
      translated: "in Warsaw",
      tone: 'semantic',
    },
    {
      german: "ausdrücken",
      translated: "express",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:181|es": [
    {
      german: "Was wollte",
      translated: "¿Qué quiso",
      tone: 'semantic',
    },
    {
      german: "Willy Brandt",
      translated: "Willy Brandt",
      tone: 'semantic',
    },
    {
      german: "mit seinem Kniefall",
      translated: "al arrodillarse",
      tone: 'semantic',
    },
    {
      german: "1970",
      translated: "1970",
      tone: 'semantic',
    },
    {
      german: "im ehemaligen jüdischen Ghetto",
      translated: "en el antiguo gueto judío",
      tone: 'semantic',
    },
    {
      german: "in Warschau",
      translated: "de Varsovia",
      tone: 'semantic',
    },
    {
      german: "ausdrücken",
      translated: "expresar",
      tone: 'semantic',
    },
    {
      german: "© Bundesregierung/Engelbert Reineke",
      translated: "© Bundesregierung/Engelbert Reineke",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:181|fa": [
    {
      german: "Was wollte",
      translated: "چه چیزی را می‌خواست",
      tone: 'semantic',
    },
    {
      german: "Willy Brandt",
      translated: "ویلی برانت",
      tone: 'semantic',
    },
    {
      german: "mit seinem Kniefall",
      translated: "زانو زدن",
      tone: 'semantic',
    },
    {
      german: "1970",
      translated: "سال ۱۹۷۰",
      tone: 'semantic',
    },
    {
      german: "im ehemaligen jüdischen Ghetto",
      translated: "محل گتوی سابق یهودیان",
      tone: 'semantic',
    },
    {
      german: "in Warschau",
      translated: "ورشو",
      tone: 'semantic',
    },
    {
      german: "ausdrücken",
      translated: "بیان کند",
      tone: 'semantic',
    },
    {
      german: "© Bundesregierung/Engelbert Reineke",
      translated: "© Bundesregierung/Engelbert Reineke",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:181|fr": [
    {
      german: "Was wollte",
      translated: "Que voulait",
      tone: 'semantic',
    },
    {
      german: "Willy Brandt",
      translated: "Willy Brandt",
      tone: 'semantic',
    },
    {
      german: "mit seinem Kniefall",
      translated: "lorsqu’il s’est agenouillé",
      tone: 'semantic',
    },
    {
      german: "1970",
      translated: "en 1970",
      tone: 'semantic',
    },
    {
      german: "im ehemaligen jüdischen Ghetto",
      translated: "dans l’ancien ghetto juif",
      tone: 'semantic',
    },
    {
      german: "in Warschau",
      translated: "de Varsovie",
      tone: 'semantic',
    },
    {
      german: "ausdrücken",
      translated: "exprimer",
      tone: 'semantic',
    },
    {
      german: "© Bundesregierung/Engelbert Reineke",
      translated: "© Bundesregierung/Engelbert Reineke",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:181|hr": [
    {
      german: "Was wollte",
      translated: "Što je",
      tone: 'semantic',
    },
    {
      german: "Willy Brandt",
      translated: "Willy Brandt",
      tone: 'semantic',
    },
    {
      german: "mit seinem Kniefall",
      translated: "kleknuo",
      tone: 'semantic',
    },
    {
      german: "1970",
      translated: "1970.",
      tone: 'semantic',
    },
    {
      german: "im ehemaligen jüdischen Ghetto",
      translated: "pred spomenikom nekadašnjem židovskom getu",
      tone: 'semantic',
    },
    {
      german: "in Warschau",
      translated: "u Varšavi",
      tone: 'semantic',
    },
    {
      german: "ausdrücken",
      translated: "želio izraziti",
      tone: 'semantic',
    },
    {
      german: "© Bundesregierung/Engelbert Reineke",
      translated: "© Bundesregierung/Engelbert Reineke",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:181|it": [
    {
      german: "Was wollte",
      translated: "Che cosa volle",
      tone: 'semantic',
    },
    {
      german: "Willy Brandt",
      translated: "Willy Brandt",
      tone: 'semantic',
    },
    {
      german: "mit seinem Kniefall",
      translated: "inginocchiandosi",
      tone: 'semantic',
    },
    {
      german: "1970",
      translated: "1970",
      tone: 'semantic',
    },
    {
      german: "im ehemaligen jüdischen Ghetto",
      translated: "nell’ex ghetto ebraico",
      tone: 'semantic',
    },
    {
      german: "in Warschau",
      translated: "di Varsavia",
      tone: 'semantic',
    },
    {
      german: "ausdrücken",
      translated: "esprimere",
      tone: 'semantic',
    },
    {
      german: "© Bundesregierung/Engelbert Reineke",
      translated: "© Bundesregierung/Engelbert Reineke",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:181|kmr": [
    {
      german: "Was wollte",
      translated: "dixwest",
      tone: 'semantic',
    },
    {
      german: "Willy Brandt",
      translated: "Willy Brandt",
      tone: 'semantic',
    },
    {
      german: "mit seinem Kniefall",
      translated: "bi çokdanîna xwe ya",
      tone: 'semantic',
    },
    {
      german: "1970",
      translated: "1970",
      tone: 'semantic',
    },
    {
      german: "im ehemaligen jüdischen Ghetto",
      translated: "li ghettoya Cihûyan a berê",
      tone: 'semantic',
    },
    {
      german: "in Warschau",
      translated: "li Varşovayê",
      tone: 'semantic',
    },
    {
      german: "ausdrücken",
      translated: "çi nîşan bide?",
      tone: 'semantic',
    },
    {
      german: "© Bundesregierung/Engelbert Reineke",
      translated: "© Bundesregierung/Engelbert Reineke",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:181|pl": [
    {
      german: "Was wollte",
      translated: "chciał",
      tone: 'semantic',
    },
    {
      german: "Willy Brandt",
      translated: "Willy Brandt",
      tone: 'semantic',
    },
    {
      german: "mit seinem Kniefall",
      translated: "klękając",
      tone: 'semantic',
    },
    {
      german: "1970",
      translated: "1970 r.",
      tone: 'semantic',
    },
    {
      german: "im ehemaligen jüdischen Ghetto",
      translated: "w dawnym getcie żydowskim",
      tone: 'semantic',
    },
    {
      german: "in Warschau",
      translated: "w Warszawie",
      tone: 'semantic',
    },
    {
      german: "ausdrücken",
      translated: "wyrazić",
      tone: 'semantic',
    },
    {
      german: "© Bundesregierung/Engelbert Reineke",
      translated: "© Bundesregierung/Engelbert Reineke",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:181|prs": [
    {
      german: "Was wollte",
      translated: "چه چیزی را می‌خواست",
      tone: 'semantic',
    },
    {
      german: "Willy Brandt",
      translated: "ویلی برانت",
      tone: 'semantic',
    },
    {
      german: "mit seinem Kniefall",
      translated: "زانو زدن",
      tone: 'semantic',
    },
    {
      german: "1970",
      translated: "سال ۱۹۷۰",
      tone: 'semantic',
    },
    {
      german: "im ehemaligen jüdischen Ghetto",
      translated: "محل گتوی سابق یهودیان",
      tone: 'semantic',
    },
    {
      german: "in Warschau",
      translated: "ورشو",
      tone: 'semantic',
    },
    {
      german: "ausdrücken",
      translated: "بیان کند",
      tone: 'semantic',
    },
    {
      german: "© Bundesregierung/Engelbert Reineke",
      translated: "© Bundesregierung/Engelbert Reineke",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:181|ro": [
    {
      german: "Was wollte",
      translated: "Ce a vrut să",
      tone: 'semantic',
    },
    {
      german: "Willy Brandt",
      translated: "Willy Brandt",
      tone: 'semantic',
    },
    {
      german: "mit seinem Kniefall",
      translated: "prin îngenuncherea sa din 1970",
      tone: 'semantic',
    },
    {
      german: "im ehemaligen jüdischen Ghetto",
      translated: "la fostul ghetou evreiesc din",
      tone: 'semantic',
    },
    {
      german: "in Warschau",
      translated: "Varșovia",
      tone: 'semantic',
    },
    {
      german: "ausdrücken",
      translated: "exprime",
      tone: 'semantic',
    },
    {
      german: "© Bundesregierung/Engelbert Reineke",
      translated: "© Bundesregierung/Engelbert Reineke",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:181|ru": [
    {
      german: "Was wollte",
      translated: "Что хотел",
      tone: 'semantic',
    },
    {
      german: "Willy Brandt",
      translated: "Вилли Брандт",
      tone: 'semantic',
    },
    {
      german: "mit seinem Kniefall",
      translated: "своим коленопреклонением",
      tone: 'semantic',
    },
    {
      german: "1970",
      translated: "1970",
      tone: 'semantic',
    },
    {
      german: "im ehemaligen jüdischen Ghetto",
      translated: "в бывшем еврейском гетто",
      tone: 'semantic',
    },
    {
      german: "in Warschau",
      translated: "в Варшаве",
      tone: 'semantic',
    },
    {
      german: "ausdrücken",
      translated: "выразить",
      tone: 'semantic',
    },
    {
      german: "© Bundesregierung/Engelbert Reineke",
      translated: "© Федеральное правительство/Энгельберт Райнике",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:181|sq": [
    {
      german: "Was wollte",
      translated: "Çfarë donte",
      tone: 'semantic',
    },
    {
      german: "Willy Brandt",
      translated: "Willy Brandt",
      tone: 'semantic',
    },
    {
      german: "mit seinem Kniefall",
      translated: "me gjunjëzimin e tij",
      tone: 'semantic',
    },
    {
      german: "1970",
      translated: "në vitin 1970",
      tone: 'semantic',
    },
    {
      german: "im ehemaligen jüdischen Ghetto",
      translated: "para monumentit të ish-getos hebreje",
      tone: 'semantic',
    },
    {
      german: "in Warschau",
      translated: "në Varshavë",
      tone: 'semantic',
    },
    {
      german: "ausdrücken",
      translated: "të shprehte",
      tone: 'semantic',
    },
    {
      german: "© Bundesregierung/Engelbert Reineke",
      translated: "© Bundesregierung/Engelbert Reineke",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:181|sr": [
    {
      german: "Was wollte",
      translated: "Šta je",
      tone: 'semantic',
    },
    {
      german: "Willy Brandt",
      translated: "Willy Brandt",
      tone: 'semantic',
    },
    {
      german: "mit seinem Kniefall",
      translated: "kleknuo",
      tone: 'semantic',
    },
    {
      german: "1970",
      translated: "1970.",
      tone: 'semantic',
    },
    {
      german: "im ehemaligen jüdischen Ghetto",
      translated: "pred spomenikom nekadašnjem jevrejskom getu",
      tone: 'semantic',
    },
    {
      german: "in Warschau",
      translated: "u Varšavi",
      tone: 'semantic',
    },
    {
      german: "ausdrücken",
      translated: "želio izraziti",
      tone: 'semantic',
    },
    {
      german: "© Bundesregierung/Engelbert Reineke",
      translated: "© Bundesregierung/Engelbert Reineke",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:181|tr": [
    {
      german: "Was wollte",
      translated: "ne",
      tone: 'semantic',
    },
    {
      german: "Willy Brandt",
      translated: "Willy Brandt",
      tone: 'semantic',
    },
    {
      german: "mit seinem Kniefall",
      translated: "diz çökerek",
      tone: 'semantic',
    },
    {
      german: "1970",
      translated: "1970'te",
      tone: 'semantic',
    },
    {
      german: "im ehemaligen jüdischen Ghetto",
      translated: "eski Yahudi gettosunda",
      tone: 'semantic',
    },
    {
      german: "in Warschau",
      translated: "Varşova'daki",
      tone: 'semantic',
    },
    {
      german: "ausdrücken",
      translated: "ifade etmek istedi",
      tone: 'semantic',
    },
    {
      german: "© Bundesregierung/Engelbert Reineke",
      translated: "© Bundesregierung/Engelbert Reineke",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:181|uk": [
    {
      german: "Was wollte",
      translated: "Що хотів",
      tone: 'semantic',
    },
    {
      german: "Willy Brandt",
      translated: "Віллі Брандт",
      tone: 'semantic',
    },
    {
      german: "mit seinem Kniefall",
      translated: "ставши навколішки",
      tone: 'semantic',
    },
    {
      german: "1970",
      translated: "1970",
      tone: 'semantic',
    },
    {
      german: "im ehemaligen jüdischen Ghetto",
      translated: "в колишньому єврейському гетто",
      tone: 'semantic',
    },
    {
      german: "in Warschau",
      translated: "у Варшаві",
      tone: 'semantic',
    },
    {
      german: "ausdrücken",
      translated: "висловити",
      tone: 'semantic',
    },
    {
      german: "© Bundesregierung/Engelbert Reineke",
      translated: "© Bundesregierung/Engelbert Reineke",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:181|vi": [
    {
      german: "Was wollte",
      translated: "muốn",
      tone: 'semantic',
    },
    {
      german: "Willy Brandt",
      translated: "Willy Brandt",
      tone: 'semantic',
    },
    {
      german: "mit seinem Kniefall",
      translated: "khi quỳ",
      tone: 'semantic',
    },
    {
      german: "1970",
      translated: "1970",
      tone: 'semantic',
    },
    {
      german: "im ehemaligen jüdischen Ghetto",
      translated: "tại khu Do Thái cũ",
      tone: 'semantic',
    },
    {
      german: "in Warschau",
      translated: "ở Warszawa",
      tone: 'semantic',
    },
    {
      german: "ausdrücken",
      translated: "thể hiện điều gì",
      tone: 'semantic',
    },
    {
      german: "© Bundesregierung/Engelbert Reineke",
      translated: "© Bundesregierung/Engelbert Reineke",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:182|ar": [
    {
      german: "Wie heißt",
      translated: "ماذا يُسمى",
      tone: 'semantic',
    },
    {
      german: "das jüdische Gebetshaus",
      translated: "مكان العبادة اليهودي",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:182|bg": [
    {
      german: "Wie heißt",
      translated: "Как се нарича",
      tone: 'semantic',
    },
    {
      german: "das jüdische Gebetshaus",
      translated: "молитвеният дом на евреите",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:182|bs": [
    {
      german: "Wie heißt",
      translated: "Kako se zove",
      tone: 'semantic',
    },
    {
      german: "das jüdische Gebetshaus",
      translated: "mjesto molitve Jevreja",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:182|el": [
    {
      german: "Wie heißt",
      translated: "Πώς ονομάζεται",
      tone: 'semantic',
    },
    {
      german: "das jüdische Gebetshaus",
      translated: "ο τόπος προσευχής των Εβραίων",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:182|en": [
    {
      german: "Wie heißt",
      translated: "What is",
      tone: 'semantic',
    },
    {
      german: "das jüdische Gebetshaus",
      translated: "the Jewish house of worship",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:182|es": [
    {
      german: "Wie heißt",
      translated: "¿Cómo se llama",
      tone: 'semantic',
    },
    {
      german: "das jüdische Gebetshaus",
      translated: "el lugar de culto judío",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:182|fa": [
    {
      german: "Wie heißt",
      translated: "چه نام دارد",
      tone: 'semantic',
    },
    {
      german: "das jüdische Gebetshaus",
      translated: "محل عبادت یهودیان",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:182|fr": [
    {
      german: "Wie heißt",
      translated: "Comment s’appelle",
      tone: 'semantic',
    },
    {
      german: "das jüdische Gebetshaus",
      translated: "le lieu de prière juif",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:182|hr": [
    {
      german: "Wie heißt",
      translated: "Kako se zove",
      tone: 'semantic',
    },
    {
      german: "das jüdische Gebetshaus",
      translated: "mjesto molitve Židova",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:182|it": [
    {
      german: "Wie heißt",
      translated: "Come si chiama",
      tone: 'semantic',
    },
    {
      german: "das jüdische Gebetshaus",
      translated: "il luogo di preghiera degli ebrei",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:182|kmr": [
    {
      german: "Wie heißt",
      translated: "Mala nimêja",
      tone: 'semantic',
    },
    {
      german: "das jüdische Gebetshaus",
      translated: "Cihûyan çi tê gotin",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:182|pl": [
    {
      german: "Wie heißt",
      translated: "Jak nazywa się",
      tone: 'semantic',
    },
    {
      german: "das jüdische Gebetshaus",
      translated: "miejsce modlitwy Żydów",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:182|prs": [
    {
      german: "Wie heißt",
      translated: "چه نام دارد",
      tone: 'semantic',
    },
    {
      german: "das jüdische Gebetshaus",
      translated: "محل عبادت یهودیان",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:182|ro": [
    {
      german: "Wie heißt",
      translated: "Cum se numește",
      tone: 'semantic',
    },
    {
      german: "das jüdische Gebetshaus",
      translated: "locul de rugăciune al evreilor",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:182|ru": [
    {
      german: "Wie heißt",
      translated: "Как называется",
      tone: 'semantic',
    },
    {
      german: "das jüdische Gebetshaus",
      translated: "еврейский молитвенный дом",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:182|sq": [
    {
      german: "Wie heißt",
      translated: "Si quhet",
      tone: 'semantic',
    },
    {
      german: "das jüdische Gebetshaus",
      translated: "i lutjes së hebrenjve",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:182|sr": [
    {
      german: "Wie heißt",
      translated: "Kako se zove",
      tone: 'semantic',
    },
    {
      german: "das jüdische Gebetshaus",
      translated: "mjesto molitve Jevreja",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:182|tr": [
    {
      german: "Wie heißt",
      translated: "ne denir",
      tone: 'semantic',
    },
    {
      german: "das jüdische Gebetshaus",
      translated: "Yahudilerin ibadethanesine",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:182|uk": [
    {
      german: "Wie heißt",
      translated: "Як називається",
      tone: 'semantic',
    },
    {
      german: "das jüdische Gebetshaus",
      translated: "єврейський молитовний будинок",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:182|vi": [
    {
      german: "Wie heißt",
      translated: "được gọi là gì",
      tone: 'semantic',
    },
    {
      german: "das jüdische Gebetshaus",
      translated: "Nơi cầu nguyện của người Do Thái",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:183|ar": [
    {
      german: "Wann",
      translated: "متى",
      tone: 'semantic',
    },
    {
      german: "war",
      translated: "حدثت",
      tone: 'semantic',
    },
    {
      german: "in der Bundesrepublik Deutschland",
      translated: "في جمهورية ألمانيا الاتحادية",
      tone: 'semantic',
    },
    {
      german: "Wirtschaftswunder",
      translated: "المعجزة الاقتصادية",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:183|bg": [
    {
      german: "Wann",
      translated: "Кога",
      tone: 'semantic',
    },
    {
      german: "war",
      translated: "е",
      tone: 'semantic',
    },
    {
      german: "in der Bundesrepublik Deutschland",
      translated: "във Федерална република Германия",
      tone: 'semantic',
    },
    {
      german: "Wirtschaftswunder",
      translated: "икономическото чудо",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:183|bs": [
    {
      german: "Wann",
      translated: "Kada",
      tone: 'semantic',
    },
    {
      german: "war",
      translated: "se dogodilo",
      tone: 'semantic',
    },
    {
      german: "in der Bundesrepublik Deutschland",
      translated: "u Saveznoj Republici Njemačkoj",
      tone: 'semantic',
    },
    {
      german: "Wirtschaftswunder",
      translated: "privredno čudo",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:183|el": [
    {
      german: "Wann",
      translated: "Πότε",
      tone: 'semantic',
    },
    {
      german: "war",
      translated: "συνέβη",
      tone: 'semantic',
    },
    {
      german: "in der Bundesrepublik Deutschland",
      translated: "στην Ομοσπονδιακή Δημοκρατία της Γερμανίας",
      tone: 'semantic',
    },
    {
      german: "Wirtschaftswunder",
      translated: "οικονομικό θαύμα",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:183|en": [
    {
      german: "Wann",
      translated: "When",
      tone: 'semantic',
    },
    {
      german: "war",
      translated: "was",
      tone: 'semantic',
    },
    {
      german: "in der Bundesrepublik Deutschland",
      translated: "in the Federal Republic of Germany",
      tone: 'semantic',
    },
    {
      german: "das",
      translated: "the",
      tone: 'semantic',
    },
    {
      german: "Wirtschaftswunder",
      translated: "economic miracle",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:183|es": [
    {
      german: "Wann",
      translated: "¿Cuándo",
      tone: 'semantic',
    },
    {
      german: "war",
      translated: "tuvo lugar",
      tone: 'semantic',
    },
    {
      german: "in der Bundesrepublik Deutschland",
      translated: "en la República Federal de Alemania",
      tone: 'semantic',
    },
    {
      german: "Wirtschaftswunder",
      translated: "«milagro económico»",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:183|fa": [
    {
      german: "Wann",
      translated: "چه زمانی",
      tone: 'semantic',
    },
    {
      german: "in der Bundesrepublik Deutschland",
      translated: "جمهوری فدرال آلمان",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:183|fr": [
    {
      german: "Wann",
      translated: "Quand",
      tone: 'semantic',
    },
    {
      german: "war",
      translated: "a eu lieu",
      tone: 'semantic',
    },
    {
      german: "in der Bundesrepublik Deutschland",
      translated: "en République fédérale d’Allemagne",
      tone: 'semantic',
    },
    {
      german: "Wirtschaftswunder",
      translated: "miracle économique",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:183|hr": [
    {
      german: "Wann",
      translated: "Kada",
      tone: 'semantic',
    },
    {
      german: "war",
      translated: "se dogodilo",
      tone: 'semantic',
    },
    {
      german: "in der Bundesrepublik Deutschland",
      translated: "u Saveznoj Republici Njemačkoj",
      tone: 'semantic',
    },
    {
      german: "Wirtschaftswunder",
      translated: "gospodarsko čudo",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:183|it": [
    {
      german: "Wann",
      translated: "Quando",
      tone: 'semantic',
    },
    {
      german: "war",
      translated: "ebbe luogo",
      tone: 'semantic',
    },
    {
      german: "in der Bundesrepublik Deutschland",
      translated: "nella Repubblica Federale di Germania",
      tone: 'semantic',
    },
    {
      german: "Wirtschaftswunder",
      translated: "miracolo economico",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:183|kmr": [
    {
      german: "Wann",
      translated: "kengê",
      tone: 'semantic',
    },
    {
      german: "war",
      translated: "bû",
      tone: 'semantic',
    },
    {
      german: "in der Bundesrepublik Deutschland",
      translated: "Komara Federal a Almanyayê",
      tone: 'semantic',
    },
    {
      german: "Wirtschaftswunder",
      translated: "«Mucîzeya aborî»",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:183|pl": [
    {
      german: "Wann",
      translated: "Kiedy",
      tone: 'semantic',
    },
    {
      german: "war",
      translated: "miał miejsce",
      tone: 'semantic',
    },
    {
      german: "in der Bundesrepublik Deutschland",
      translated: "w Republice Federalnej Niemiec",
      tone: 'semantic',
    },
    {
      german: "Wirtschaftswunder",
      translated: "cud gospodarczy",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:183|prs": [
    {
      german: "Wann",
      translated: "چه زمانی",
      tone: 'semantic',
    },
    {
      german: "war",
      translated: "رخ داد",
      tone: 'semantic',
    },
    {
      german: "in der Bundesrepublik Deutschland",
      translated: "جمهوری فدرال آلمان",
      tone: 'semantic',
    },
    {
      german: "Wirtschaftswunder",
      translated: "(Wirtschaftswunder)",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:183|ro": [
    {
      german: "Wann",
      translated: "Când",
      tone: 'semantic',
    },
    {
      german: "war",
      translated: "a avut loc",
      tone: 'semantic',
    },
    {
      german: "in der Bundesrepublik Deutschland",
      translated: "în Republica Federală Germania",
      tone: 'semantic',
    },
    {
      german: "Wirtschaftswunder",
      translated: "miracolul economic",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:183|ru": [
    {
      german: "Wann",
      translated: "Когда",
      tone: 'semantic',
    },
    {
      german: "war",
      translated: "было",
      tone: 'semantic',
    },
    {
      german: "in der Bundesrepublik Deutschland",
      translated: "в ФРГ",
      tone: 'semantic',
    },
    {
      german: "Wirtschaftswunder",
      translated: "экономическое чудо",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:183|sq": [
    {
      german: "Wann",
      translated: "Kur",
      tone: 'semantic',
    },
    {
      german: "war",
      translated: "ndodhi",
      tone: 'semantic',
    },
    {
      german: "in der Bundesrepublik Deutschland",
      translated: "në Republikën Federale të Gjermanisë",
      tone: 'semantic',
    },
    {
      german: "Wirtschaftswunder",
      translated: "«mrekullia ekonomike»",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:183|sr": [
    {
      german: "Wann",
      translated: "Kada",
      tone: 'semantic',
    },
    {
      german: "war",
      translated: "se dogodilo",
      tone: 'semantic',
    },
    {
      german: "in der Bundesrepublik Deutschland",
      translated: "u Saveznoj Republici Nemačkoj",
      tone: 'semantic',
    },
    {
      german: "Wirtschaftswunder",
      translated: "privredno čudo",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:183|tr": [
    {
      german: "Wann",
      translated: "hangi dönemde",
      tone: 'semantic',
    },
    {
      german: "war",
      translated: "yaşandı",
      tone: 'semantic',
    },
    {
      german: "in der Bundesrepublik Deutschland",
      translated: "Almanya Federal Cumhuriyeti'nde",
      tone: 'semantic',
    },
    {
      german: "Wirtschaftswunder",
      translated: "ekonomik mucize",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:183|uk": [
    {
      german: "Wann",
      translated: "Коли",
      tone: 'semantic',
    },
    {
      german: "war",
      translated: "було",
      tone: 'semantic',
    },
    {
      german: "in der Bundesrepublik Deutschland",
      translated: "у Федеративній Республіці Німеччина",
      tone: 'semantic',
    },
    {
      german: "Wirtschaftswunder",
      translated: "«економічне диво» (Wirtschaftswunder)",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:183|vi": [
    {
      german: "Wann",
      translated: "khi nào",
      tone: 'semantic',
    },
    {
      german: "war",
      translated: "diễn ra",
      tone: 'semantic',
    },
    {
      german: "in der Bundesrepublik Deutschland",
      translated: "ở Cộng hòa Liên bang Đức",
      tone: 'semantic',
    },
    {
      german: "Wirtschaftswunder",
      translated: "Phép màu kinh tế",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:184|ar": [
    {
      german: "Auf welcher rechtlichen Grundlage",
      translated: "على أي أساس قانوني",
      tone: 'semantic',
    },
    {
      german: "Staat Israel",
      translated: "دولة إسرائيل",
      tone: 'semantic',
    },
    {
      german: "gegründet",
      translated: "أُسست",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:184|bg": [
    {
      german: "Auf welcher rechtlichen Grundlage",
      translated: "На каква правна основа",
      tone: 'semantic',
    },
    {
      german: "Staat Israel",
      translated: "държавата Израел",
      tone: 'semantic',
    },
    {
      german: "gegründet",
      translated: "основана",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:184|bs": [
    {
      german: "Auf welcher rechtlichen Grundlage",
      translated: "Na kojoj je pravnoj osnovi",
      tone: 'semantic',
    },
    {
      german: "Staat Israel",
      translated: "država Izrael",
      tone: 'semantic',
    },
    {
      german: "gegründet",
      translated: "osnovana",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:184|el": [
    {
      german: "Auf welcher rechtlichen Grundlage",
      translated: "Σε ποια νομική βάση",
      tone: 'semantic',
    },
    {
      german: "Staat Israel",
      translated: "το κράτος του Ισραήλ",
      tone: 'semantic',
    },
    {
      german: "gegründet",
      translated: "ιδρύθηκε",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:184|en": [
    {
      german: "Auf welcher rechtlichen Grundlage",
      translated: "On what legal basis",
      tone: 'semantic',
    },
    {
      german: "Staat Israel",
      translated: "State of Israel",
      tone: 'semantic',
    },
    {
      german: "gegründet",
      translated: "founded",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:184|es": [
    {
      german: "Auf welcher rechtlichen Grundlage",
      translated: "Sobre qué base jurídica",
      tone: 'semantic',
    },
    {
      german: "Staat Israel",
      translated: "Estado de Israel",
      tone: 'semantic',
    },
    {
      german: "gegründet",
      translated: "se fundó",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:184|fa": [
    {
      german: "Auf welcher rechtlichen Grundlage",
      translated: "بر چه مبنای حقوقی",
      tone: 'semantic',
    },
    {
      german: "Staat Israel",
      translated: "کشور اسرائیل",
      tone: 'semantic',
    },
    {
      german: "gegründet",
      translated: "تأسیس شد",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:184|fr": [
    {
      german: "Auf welcher rechtlichen Grundlage",
      translated: "Sur quelle base juridique",
      tone: 'semantic',
    },
    {
      german: "Staat Israel",
      translated: "l’État d’Israël",
      tone: 'semantic',
    },
    {
      german: "gegründet",
      translated: "fondé",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:184|hr": [
    {
      german: "Auf welcher rechtlichen Grundlage",
      translated: "Na kojoj je pravnoj osnovi",
      tone: 'semantic',
    },
    {
      german: "Staat Israel",
      translated: "država Izrael",
      tone: 'semantic',
    },
    {
      german: "gegründet",
      translated: "osnovana",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:184|it": [
    {
      german: "Auf welcher rechtlichen Grundlage",
      translated: "Su quale base giuridica",
      tone: 'semantic',
    },
    {
      german: "Staat Israel",
      translated: "Stato di Israele",
      tone: 'semantic',
    },
    {
      german: "gegründet",
      translated: "fondato",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:184|kmr": [
    {
      german: "Auf welcher rechtlichen Grundlage",
      translated: "li ser kîjan bingeha hiqûqî",
      tone: 'semantic',
    },
    {
      german: "Staat Israel",
      translated: "Dewleta Îsraîl",
      tone: 'semantic',
    },
    {
      german: "gegründet",
      translated: "hate damezrandin",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:184|pl": [
    {
      german: "Auf welcher rechtlichen Grundlage",
      translated: "Na jakiej podstawie prawnej",
      tone: 'semantic',
    },
    {
      german: "Staat Israel",
      translated: "państwo Izrael",
      tone: 'semantic',
    },
    {
      german: "gegründet",
      translated: "powstało",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:184|prs": [
    {
      german: "Auf welcher rechtlichen Grundlage",
      translated: "بر چه مبنای حقوقی",
      tone: 'semantic',
    },
    {
      german: "Staat Israel",
      translated: "کشور اسرائیل",
      tone: 'semantic',
    },
    {
      german: "gegründet",
      translated: "تأسیس شد",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:184|ro": [
    {
      german: "Auf welcher rechtlichen Grundlage",
      translated: "Pe ce bază juridică",
      tone: 'semantic',
    },
    {
      german: "Staat Israel",
      translated: "statul Israel",
      tone: 'semantic',
    },
    {
      german: "gegründet",
      translated: "fondat",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:184|ru": [
    {
      german: "Auf welcher rechtlichen Grundlage",
      translated: "На какой правовой основе",
      tone: 'semantic',
    },
    {
      german: "Staat Israel",
      translated: "государство Израиль",
      tone: 'semantic',
    },
    {
      german: "gegründet",
      translated: "основано",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:184|sq": [
    {
      german: "Auf welcher rechtlichen Grundlage",
      translated: "Mbi çfarë baze juridike",
      tone: 'semantic',
    },
    {
      german: "Staat Israel",
      translated: "shteti i Izraelit",
      tone: 'semantic',
    },
    {
      german: "gegründet",
      translated: "u themelua",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:184|sr": [
    {
      german: "Auf welcher rechtlichen Grundlage",
      translated: "Na kojoj je pravnoj osnovi",
      tone: 'semantic',
    },
    {
      german: "Staat Israel",
      translated: "država Izrael",
      tone: 'semantic',
    },
    {
      german: "gegründet",
      translated: "osnovana",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:184|tr": [
    {
      german: "Auf welcher rechtlichen Grundlage",
      translated: "hangi hukuki temele",
      tone: 'semantic',
    },
    {
      german: "Staat Israel",
      translated: "İsrail devleti",
      tone: 'semantic',
    },
    {
      german: "gegründet",
      translated: "kuruldu",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:184|uk": [
    {
      german: "Auf welcher rechtlichen Grundlage",
      translated: "На якій правовій основі",
      tone: 'semantic',
    },
    {
      german: "Staat Israel",
      translated: "держава Ізраїль",
      tone: 'semantic',
    },
    {
      german: "gegründet",
      translated: "створена",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:184|vi": [
    {
      german: "Auf welcher rechtlichen Grundlage",
      translated: "trên cơ sở pháp lý nào",
      tone: 'semantic',
    },
    {
      german: "Staat Israel",
      translated: "Nhà nước Israel",
      tone: 'semantic',
    },
    {
      german: "gegründet",
      translated: "thành lập",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:185|ar": [
    {
      german: "der Ausdruck",
      translated: "تعبير",
      tone: 'semantic',
    },
    {
      german: "Eiserner Vorhang",
      translated: "الستار الحديدي",
      tone: 'semantic',
    },
    {
      german: "Für",
      translated: "»؟ إلى",
      tone: 'semantic',
    },
    {
      german: "die Abschottung",
      translated: "عزل",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:185|bg": [
    {
      german: "Wofür",
      translated: "За какво",
      tone: 'semantic',
    },
    {
      german: "stand",
      translated: "се отнася",
      tone: 'semantic',
    },
    {
      german: "der Ausdruck",
      translated: "понятието",
      tone: 'semantic',
    },
    {
      german: "Eiserner Vorhang",
      translated: "Желязна завеса",
      tone: 'semantic',
    },
    {
      german: "Für",
      translated: "За",
      tone: 'semantic',
    },
    {
      german: "die Abschottung",
      translated: "разделението …",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:185|bs": [
    {
      german: "Wofür",
      translated: "Na što",
      tone: 'semantic',
    },
    {
      german: "stand",
      translated: "se odnosio",
      tone: 'semantic',
    },
    {
      german: "der Ausdruck",
      translated: "pojam",
      tone: 'semantic',
    },
    {
      german: "Eiserner Vorhang",
      translated: "Željezna zavjesa",
      tone: 'semantic',
    },
    {
      german: "Für",
      translated: "Na",
      tone: 'semantic',
    },
    {
      german: "die Abschottung",
      translated: "odvajanje",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:185|el": [
    {
      german: "Wofür",
      translated: "Σε τι",
      tone: 'semantic',
    },
    {
      german: "stand",
      translated: "αναφερόταν",
      tone: 'semantic',
    },
    {
      german: "der Ausdruck",
      translated: "ο όρος",
      tone: 'semantic',
    },
    {
      german: "Eiserner Vorhang",
      translated: "«Σιδηρούν Παραπέτασμα»",
      tone: 'semantic',
    },
    {
      german: "Für",
      translated: "Στον",
      tone: 'semantic',
    },
    {
      german: "die Abschottung",
      translated: "διαχωρισμό",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:185|en": [
    {
      german: "Wofür",
      translated: "What",
      tone: 'semantic',
    },
    {
      german: "stand",
      translated: "did",
      tone: 'semantic',
    },
    {
      german: "der Ausdruck",
      translated: "the expression",
      tone: 'semantic',
    },
    {
      german: "Eiserner Vorhang",
      translated: "'Iron Curtain'",
      tone: 'semantic',
    },
    {
      german: "Für",
      translated: "For",
      tone: 'semantic',
    },
    {
      german: "die Abschottung",
      translated: "the isolation",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:185|es": [
    {
      german: "Wofür",
      translated: "¿Qué",
      tone: 'semantic',
    },
    {
      german: "stand",
      translated: "representaba",
      tone: 'semantic',
    },
    {
      german: "der Ausdruck",
      translated: "la expresión",
      tone: 'semantic',
    },
    {
      german: "Eiserner Vorhang",
      translated: "«Telón de Acero»",
      tone: 'semantic',
    },
    {
      german: "die Abschottung",
      translated: "El aislamiento",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:185|fa": [
    {
      german: "Wofür",
      translated: "به چه چیزی",
      tone: 'semantic',
    },
    {
      german: "stand",
      translated: "اشاره داشت",
      tone: 'semantic',
    },
    {
      german: "der Ausdruck",
      translated: "اصطلاح",
      tone: 'semantic',
    },
    {
      german: "Eiserner Vorhang",
      translated: "«پردهٔ آهنین»",
      tone: 'semantic',
    },
    {
      german: "die Abschottung",
      translated: "جداییِ",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:185|fr": [
    {
      german: "Wofür",
      translated: "Que",
      tone: 'semantic',
    },
    {
      german: "stand",
      translated: "désignait",
      tone: 'semantic',
    },
    {
      german: "der Ausdruck",
      translated: "l’expression",
      tone: 'semantic',
    },
    {
      german: "Eiserner Vorhang",
      translated: "Rideau de fer",
      tone: 'semantic',
    },
    {
      german: "die Abschottung",
      translated: "L’isolement",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:185|hr": [
    {
      german: "Wofür",
      translated: "Na što",
      tone: 'semantic',
    },
    {
      german: "stand",
      translated: "se odnosio",
      tone: 'semantic',
    },
    {
      german: "der Ausdruck",
      translated: "pojam",
      tone: 'semantic',
    },
    {
      german: "Eiserner Vorhang",
      translated: "Željezna zavjesa",
      tone: 'semantic',
    },
    {
      german: "Für",
      translated: "Na",
      tone: 'semantic',
    },
    {
      german: "die Abschottung",
      translated: "odvajanje",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:185|it": [
    {
      german: "Wofür",
      translated: "A che cosa",
      tone: 'semantic',
    },
    {
      german: "stand",
      translated: "si riferiva",
      tone: 'semantic',
    },
    {
      german: "der Ausdruck",
      translated: "il termine",
      tone: 'semantic',
    },
    {
      german: "Eiserner Vorhang",
      translated: "«Cortina di ferro»",
      tone: 'semantic',
    },
    {
      german: "Für",
      translated: "Alla",
      tone: 'semantic',
    },
    {
      german: "die Abschottung",
      translated: "separazione",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:185|kmr": [
    {
      german: "Wofür",
      translated: "çi wateyê",
      tone: 'semantic',
    },
    {
      german: "stand",
      translated: "tê",
      tone: 'semantic',
    },
    {
      german: "der Ausdruck",
      translated: "Peyva",
      tone: 'semantic',
    },
    {
      german: "Eiserner Vorhang",
      translated: "«Perdeya Hesinî»",
      tone: 'semantic',
    },
    {
      german: "Für",
      translated: "Ji bo",
      tone: 'semantic',
    },
    {
      german: "die Abschottung",
      translated: "veqetandinê",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:185|pl": [
    {
      german: "Wofür",
      translated: "Do czego",
      tone: 'semantic',
    },
    {
      german: "stand",
      translated: "odnosił się",
      tone: 'semantic',
    },
    {
      german: "der Ausdruck",
      translated: "termin",
      tone: 'semantic',
    },
    {
      german: "Eiserner Vorhang",
      translated: "„Żelazna kurtyna”",
      tone: 'semantic',
    },
    {
      german: "Für",
      translated: "Do",
      tone: 'semantic',
    },
    {
      german: "die Abschottung",
      translated: "oddzielenia",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:185|prs": [
    {
      german: "Wofür",
      translated: "به چه چیزی",
      tone: 'semantic',
    },
    {
      german: "stand",
      translated: "اشاره داشت",
      tone: 'semantic',
    },
    {
      german: "der Ausdruck",
      translated: "اصطلاح",
      tone: 'semantic',
    },
    {
      german: "Eiserner Vorhang",
      translated: "«پردهٔ آهنین»",
      tone: 'semantic',
    },
    {
      german: "die Abschottung",
      translated: "جداییِ",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:185|ro": [
    {
      german: "Wofür",
      translated: "La ce",
      tone: 'semantic',
    },
    {
      german: "stand",
      translated: "se referea",
      tone: 'semantic',
    },
    {
      german: "der Ausdruck",
      translated: "termenul",
      tone: 'semantic',
    },
    {
      german: "Eiserner Vorhang",
      translated: "Cortina de Fier",
      tone: 'semantic',
    },
    {
      german: "Für",
      translated: "La",
      tone: 'semantic',
    },
    {
      german: "die Abschottung",
      translated: "separarea",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:185|ru": [
    {
      german: "Wofür",
      translated: "Что",
      tone: 'semantic',
    },
    {
      german: "stand",
      translated: "означало",
      tone: 'semantic',
    },
    {
      german: "der Ausdruck",
      translated: "выражение",
      tone: 'semantic',
    },
    {
      german: "Eiserner Vorhang",
      translated: "железный занавес",
      tone: 'semantic',
    },
    {
      german: "die Abschottung",
      translated: "Отгораживание",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:185|sq": [
    {
      german: "Wofür",
      translated: "Me çfarë",
      tone: 'semantic',
    },
    {
      german: "stand",
      translated: "lidhej",
      tone: 'semantic',
    },
    {
      german: "der Ausdruck",
      translated: "termi",
      tone: 'semantic',
    },
    {
      german: "Eiserner Vorhang",
      translated: "«Perdja e Hekurt»",
      tone: 'semantic',
    },
    {
      german: "Für",
      translated: "Me",
      tone: 'semantic',
    },
    {
      german: "die Abschottung",
      translated: "ndarjen",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:185|sr": [
    {
      german: "Wofür",
      translated: "Na šta",
      tone: 'semantic',
    },
    {
      german: "stand",
      translated: "se odnosio",
      tone: 'semantic',
    },
    {
      german: "der Ausdruck",
      translated: "pojam",
      tone: 'semantic',
    },
    {
      german: "Eiserner Vorhang",
      translated: "Željezna zavjesa",
      tone: 'semantic',
    },
    {
      german: "Für",
      translated: "Na",
      tone: 'semantic',
    },
    {
      german: "die Abschottung",
      translated: "odvajanje",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:185|tr": [
    {
      german: "Wofür",
      translated: "neyi",
      tone: 'semantic',
    },
    {
      german: "stand",
      translated: "anlatıyordu",
      tone: 'semantic',
    },
    {
      german: "der Ausdruck",
      translated: "ifadesi",
      tone: 'semantic',
    },
    {
      german: "Eiserner Vorhang",
      translated: "Demir Perde",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:185|uk": [
    {
      german: "Wofür",
      translated: "Що",
      tone: 'semantic',
    },
    {
      german: "stand",
      translated: "означав",
      tone: 'semantic',
    },
    {
      german: "der Ausdruck",
      translated: "вислів",
      tone: 'semantic',
    },
    {
      german: "Eiserner Vorhang",
      translated: "«Залізна завіса»",
      tone: 'semantic',
    },
    {
      german: "die Abschottung",
      translated: "Ізоляцію",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:185|vi": [
    {
      german: "der Ausdruck",
      translated: "Thuật ngữ",
      tone: 'semantic',
    },
    {
      german: "Eiserner Vorhang",
      translated: "Bức màn Sắt",
      tone: 'semantic',
    },
    {
      german: "Für",
      translated: "đề cập đến",
      tone: 'semantic',
    },
    {
      german: "die Abschottung",
      translated: "sự phân chia",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:186|ar": [
    {
      german: "Im Jahr 1953",
      translated: "عام 1953",
      tone: 'semantic',
    },
    {
      german: "gab es",
      translated: "حدثت",
      tone: 'semantic',
    },
    {
      german: "in der DDR",
      translated: "في DDR",
      tone: 'semantic',
    },
    {
      german: "einen Aufstand",
      translated: "انتفاضة",
      tone: 'semantic',
    },
    {
      german: "lange Zeit",
      translated: "مدة طويلة",
      tone: 'semantic',
    },
    {
      german: "in der Bundesrepublik Deutschland",
      translated: "في جمهورية ألمانيا الاتحادية",
      tone: 'semantic',
    },
    {
      german: "ein Feiertag",
      translated: "مناسبة رسمية",
      tone: 'semantic',
    },
    {
      german: "Wann war das",
      translated: "متى كان ذلك؟",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:186|bg": [
    {
      german: "Im Jahr 1953",
      translated: "През 1953 г.",
      tone: 'semantic',
    },
    {
      german: "gab es",
      translated: "има",
      tone: 'semantic',
    },
    {
      german: "in der DDR",
      translated: "в ГДР",
      tone: 'semantic',
    },
    {
      german: "einen Aufstand",
      translated: "въстание",
      tone: 'semantic',
    },
    {
      german: "lange Zeit",
      translated: "дълго време",
      tone: 'semantic',
    },
    {
      german: "in der Bundesrepublik Deutschland",
      translated: "във ФРГ",
      tone: 'semantic',
    },
    {
      german: "ein Feiertag",
      translated: "официален празник",
      tone: 'semantic',
    },
    {
      german: "erinnerte",
      translated: "се отбелязва",
      tone: 'semantic',
    },
    {
      german: "Wann war das",
      translated: "Коя дата е това?",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:186|bs": [
    {
      german: "Im Jahr 1953",
      translated: "Godine 1953.",
      tone: 'semantic',
    },
    {
      german: "gab es",
      translated: "je došlo do",
      tone: 'semantic',
    },
    {
      german: "in der DDR",
      translated: "u DDR-u",
      tone: 'semantic',
    },
    {
      german: "einen Aufstand",
      translated: "ustanka",
      tone: 'semantic',
    },
    {
      german: "lange Zeit",
      translated: "dugo",
      tone: 'semantic',
    },
    {
      german: "in der Bundesrepublik Deutschland",
      translated: "u Saveznoj Republici Njemačkoj",
      tone: 'semantic',
    },
    {
      german: "ein Feiertag",
      translated: "državni praznik",
      tone: 'semantic',
    },
    {
      german: "erinnerte",
      translated: "obilježavao",
      tone: 'semantic',
    },
    {
      german: "Wann war das",
      translated: "Koji je to datum?",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:186|el": [
    {
      german: "Im Jahr 1953",
      translated: "Το 1953",
      tone: 'semantic',
    },
    {
      german: "gab es",
      translated: "έγινε",
      tone: 'semantic',
    },
    {
      german: "in der DDR",
      translated: "στη ΛΔΓ",
      tone: 'semantic',
    },
    {
      german: "einen Aufstand",
      translated: "εξέγερση",
      tone: 'semantic',
    },
    {
      german: "lange Zeit",
      translated: "για μεγάλο διάστημα",
      tone: 'semantic',
    },
    {
      german: "in der Bundesrepublik Deutschland",
      translated: "στη Δυτική Γερμανία",
      tone: 'semantic',
    },
    {
      german: "ein Feiertag",
      translated: "επίσημη αργία",
      tone: 'semantic',
    },
    {
      german: "erinnerte",
      translated: "τιμούνταν",
      tone: 'semantic',
    },
    {
      german: "Wann war das",
      translated: "Ποια ημερομηνία ήταν",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:186|en": [
    {
      german: "Im Jahr 1953",
      translated: "In 1953",
      tone: 'semantic',
    },
    {
      german: "gab es",
      translated: "there was",
      tone: 'semantic',
    },
    {
      german: "in der DDR",
      translated: "in the GDR",
      tone: 'semantic',
    },
    {
      german: "einen Aufstand",
      translated: "an uprising",
      tone: 'semantic',
    },
    {
      german: "lange Zeit",
      translated: "for a long time",
      tone: 'semantic',
    },
    {
      german: "in der Bundesrepublik Deutschland",
      translated: "in the Federal Republic of Germany",
      tone: 'semantic',
    },
    {
      german: "ein Feiertag",
      translated: "a public holiday",
      tone: 'semantic',
    },
    {
      german: "erinnerte",
      translated: "commemorated",
      tone: 'semantic',
    },
    {
      german: "Wann war das",
      translated: "When was that",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:186|es": [
    {
      german: "Im Jahr 1953",
      translated: "En 1953",
      tone: 'semantic',
    },
    {
      german: "gab es",
      translated: "hubo",
      tone: 'semantic',
    },
    {
      german: "in der DDR",
      translated: "en la RDA",
      tone: 'semantic',
    },
    {
      german: "einen Aufstand",
      translated: "un levantamiento",
      tone: 'semantic',
    },
    {
      german: "lange Zeit",
      translated: "durante mucho tiempo",
      tone: 'semantic',
    },
    {
      german: "in der Bundesrepublik Deutschland",
      translated: "en la República Federal de Alemania",
      tone: 'semantic',
    },
    {
      german: "ein Feiertag",
      translated: "un día festivo",
      tone: 'semantic',
    },
    {
      german: "Wann war das",
      translated: "¿Cuándo fue?",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:186|fa": [
    {
      german: "Im Jahr 1953",
      translated: "در سال ۱۹۵۳",
      tone: 'semantic',
    },
    {
      german: "gab es",
      translated: "در",
      tone: 'semantic',
    },
    {
      german: "in der DDR",
      translated: "جمهوری دموکراتیک آلمان",
      tone: 'semantic',
    },
    {
      german: "einen Aufstand",
      translated: "قیامی رخ داد",
      tone: 'semantic',
    },
    {
      german: "lange Zeit",
      translated: "برای مدت طولانی",
      tone: 'semantic',
    },
    {
      german: "in der Bundesrepublik Deutschland",
      translated: "جمهوری فدرال آلمان",
      tone: 'semantic',
    },
    {
      german: "Wann war das",
      translated: "چه روزی بود؟",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:186|fr": [
    {
      german: "Im Jahr 1953",
      translated: "En 1953",
      tone: 'semantic',
    },
    {
      german: "gab es",
      translated: "a eu lieu",
      tone: 'semantic',
    },
    {
      german: "in der DDR",
      translated: "en RDA",
      tone: 'semantic',
    },
    {
      german: "einen Aufstand",
      translated: "un soulèvement",
      tone: 'semantic',
    },
    {
      german: "lange Zeit",
      translated: "a longtemps",
      tone: 'semantic',
    },
    {
      german: "in der Bundesrepublik Deutschland",
      translated: "en République fédérale d’Allemagne",
      tone: 'semantic',
    },
    {
      german: "ein Feiertag",
      translated: "un jour férié",
      tone: 'semantic',
    },
    {
      german: "erinnerte",
      translated: "commémoré",
      tone: 'semantic',
    },
    {
      german: "Wann war das",
      translated: "Quand était-ce",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:186|hr": [
    {
      german: "Im Jahr 1953",
      translated: "Godine 1953.",
      tone: 'semantic',
    },
    {
      german: "gab es",
      translated: "je došlo do",
      tone: 'semantic',
    },
    {
      german: "in der DDR",
      translated: "u DDR-u",
      tone: 'semantic',
    },
    {
      german: "einen Aufstand",
      translated: "ustanka",
      tone: 'semantic',
    },
    {
      german: "lange Zeit",
      translated: "dugo",
      tone: 'semantic',
    },
    {
      german: "in der Bundesrepublik Deutschland",
      translated: "u Saveznoj Republici Njemačkoj",
      tone: 'semantic',
    },
    {
      german: "ein Feiertag",
      translated: "državni praznik",
      tone: 'semantic',
    },
    {
      german: "erinnerte",
      translated: "obilježavao",
      tone: 'semantic',
    },
    {
      german: "Wann war das",
      translated: "Koji je to datum?",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:186|it": [
    {
      german: "Im Jahr 1953",
      translated: "Nel 1953",
      tone: 'semantic',
    },
    {
      german: "gab es",
      translated: "vi fu",
      tone: 'semantic',
    },
    {
      german: "in der DDR",
      translated: "nella RDT",
      tone: 'semantic',
    },
    {
      german: "einen Aufstand",
      translated: "una rivolta",
      tone: 'semantic',
    },
    {
      german: "lange Zeit",
      translated: "a lungo",
      tone: 'semantic',
    },
    {
      german: "in der Bundesrepublik Deutschland",
      translated: "nella RFG",
      tone: 'semantic',
    },
    {
      german: "ein Feiertag",
      translated: "con una festa ufficiale",
      tone: 'semantic',
    },
    {
      german: "erinnerte",
      translated: "commemorata",
      tone: 'semantic',
    },
    {
      german: "Wann war das",
      translated: "Quale data era",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:186|kmr": [
    {
      german: "Im Jahr 1953",
      translated: "Di sala 1953 de",
      tone: 'semantic',
    },
    {
      german: "gab es",
      translated: "çêbû",
      tone: 'semantic',
    },
    {
      german: "in der DDR",
      translated: "li DDR",
      tone: 'semantic',
    },
    {
      german: "einen Aufstand",
      translated: "serhildanek",
      tone: 'semantic',
    },
    {
      german: "lange Zeit",
      translated: "demeke dirêj",
      tone: 'semantic',
    },
    {
      german: "in der Bundesrepublik Deutschland",
      translated: "li Komara Federal a Almanyayê",
      tone: 'semantic',
    },
    {
      german: "ein Feiertag",
      translated: "bi rojeke betlaneyê",
      tone: 'semantic',
    },
    {
      german: "erinnerte",
      translated: "dihat bibîranîn",
      tone: 'semantic',
    },
    {
      german: "Wann war das",
      translated: "Ew kengê bû",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:186|pl": [
    {
      german: "Im Jahr 1953",
      translated: "W 1953 r.",
      tone: 'semantic',
    },
    {
      german: "gab es",
      translated: "doszło do",
      tone: 'semantic',
    },
    {
      german: "in der DDR",
      translated: "w NRD",
      tone: 'semantic',
    },
    {
      german: "einen Aufstand",
      translated: "powstania",
      tone: 'semantic',
    },
    {
      german: "lange Zeit",
      translated: "przez długi czas",
      tone: 'semantic',
    },
    {
      german: "in der Bundesrepublik Deutschland",
      translated: "w RFN",
      tone: 'semantic',
    },
    {
      german: "ein Feiertag",
      translated: "święto państwowe",
      tone: 'semantic',
    },
    {
      german: "erinnerte",
      translated: "upamiętniano",
      tone: 'semantic',
    },
    {
      german: "Wann war das",
      translated: "Jaka to była data",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:186|prs": [
    {
      german: "Im Jahr 1953",
      translated: "در سال ۱۹۵۳",
      tone: 'semantic',
    },
    {
      german: "gab es",
      translated: "رخ داد",
      tone: 'semantic',
    },
    {
      german: "in der DDR",
      translated: "در جمهوری دموکراتیک آلمان",
      tone: 'semantic',
    },
    {
      german: "einen Aufstand",
      translated: "قیامی",
      tone: 'semantic',
    },
    {
      german: "lange Zeit",
      translated: "برای مدت طولانی",
      tone: 'semantic',
    },
    {
      german: "in der Bundesrepublik Deutschland",
      translated: "در جمهوری فدرال آلمان",
      tone: 'semantic',
    },
    {
      german: "ein Feiertag",
      translated: "یک روز تعطیل رسمی",
      tone: 'semantic',
    },
    {
      german: "erinnerte",
      translated: "یادبود آن",
      tone: 'semantic',
    },
    {
      german: "Wann war das",
      translated: "چه روزی بود؟",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:186|ro": [
    {
      german: "Im Jahr 1953",
      translated: "În 1953",
      tone: 'semantic',
    },
    {
      german: "gab es",
      translated: "a avut loc",
      tone: 'semantic',
    },
    {
      german: "in der DDR",
      translated: "în RDG",
      tone: 'semantic',
    },
    {
      german: "einen Aufstand",
      translated: "o revoltă",
      tone: 'semantic',
    },
    {
      german: "lange Zeit",
      translated: "mult timp",
      tone: 'semantic',
    },
    {
      german: "in der Bundesrepublik Deutschland",
      translated: "în RFG",
      tone: 'semantic',
    },
    {
      german: "ein Feiertag",
      translated: "printr-o sărbătoare oficială",
      tone: 'semantic',
    },
    {
      german: "erinnerte",
      translated: "comemorată",
      tone: 'semantic',
    },
    {
      german: "Wann war das",
      translated: "Ce dată era",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:186|ru": [
    {
      german: "Im Jahr 1953",
      translated: "В 1953 году",
      tone: 'semantic',
    },
    {
      german: "gab es",
      translated: "произошло",
      tone: 'semantic',
    },
    {
      german: "in der DDR",
      translated: "в ГДР",
      tone: 'semantic',
    },
    {
      german: "einen Aufstand",
      translated: "восстание",
      tone: 'semantic',
    },
    {
      german: "lange Zeit",
      translated: "долгое время",
      tone: 'semantic',
    },
    {
      german: "in der Bundesrepublik Deutschland",
      translated: "в ФРГ",
      tone: 'semantic',
    },
    {
      german: "ein Feiertag",
      translated: "праздник",
      tone: 'semantic',
    },
    {
      german: "erinnerte",
      translated: "отмечался",
      tone: 'semantic',
    },
    {
      german: "Wann war das",
      translated: "Когда это было",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:186|sq": [
    {
      german: "Im Jahr 1953",
      translated: "Në vitin 1953",
      tone: 'semantic',
    },
    {
      german: "gab es",
      translated: "pati",
      tone: 'semantic',
    },
    {
      german: "in der DDR",
      translated: "në RDGJ",
      tone: 'semantic',
    },
    {
      german: "einen Aufstand",
      translated: "kryengritje",
      tone: 'semantic',
    },
    {
      german: "lange Zeit",
      translated: "për shumë kohë",
      tone: 'semantic',
    },
    {
      german: "in der Bundesrepublik Deutschland",
      translated: "në RFGJ",
      tone: 'semantic',
    },
    {
      german: "ein Feiertag",
      translated: "festë zyrtare",
      tone: 'semantic',
    },
    {
      german: "erinnerte",
      translated: "përkujtohej",
      tone: 'semantic',
    },
    {
      german: "Wann war das",
      translated: "Cila datë ishte?",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:186|sr": [
    {
      german: "Im Jahr 1953",
      translated: "Godine 1953",
      tone: 'semantic',
    },
    {
      german: "gab es",
      translated: "je došlo do",
      tone: 'semantic',
    },
    {
      german: "in der DDR",
      translated: "u DDR-u",
      tone: 'semantic',
    },
    {
      german: "einen Aufstand",
      translated: "ustanka",
      tone: 'semantic',
    },
    {
      german: "lange Zeit",
      translated: "dugo",
      tone: 'semantic',
    },
    {
      german: "in der Bundesrepublik Deutschland",
      translated: "u Saveznoj Republici Nemačkoj",
      tone: 'semantic',
    },
    {
      german: "ein Feiertag",
      translated: "državni praznik",
      tone: 'semantic',
    },
    {
      german: "erinnerte",
      translated: "obilježavao",
      tone: 'semantic',
    },
    {
      german: "Wann war das",
      translated: "Koji je to datum",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:186|tr": [
    {
      german: "Im Jahr 1953",
      translated: "1953'te",
      tone: 'semantic',
    },
    {
      german: "in der DDR",
      translated: "Doğu Almanya'da",
      tone: 'semantic',
    },
    {
      german: "einen Aufstand",
      translated: "bir ayaklanma",
      tone: 'semantic',
    },
    {
      german: "lange Zeit",
      translated: "uzun süre",
      tone: 'semantic',
    },
    {
      german: "in der Bundesrepublik Deutschland",
      translated: "Batı Almanya'da",
      tone: 'semantic',
    },
    {
      german: "ein Feiertag",
      translated: "bir resmî günle",
      tone: 'semantic',
    },
    {
      german: "erinnerte",
      translated: "anıldı",
      tone: 'semantic',
    },
    {
      german: "Wann war das",
      translated: "Bu tarih hangisiydi",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:186|uk": [
    {
      german: "Im Jahr 1953",
      translated: "У 1953 році",
      tone: 'semantic',
    },
    {
      german: "gab es",
      translated: " відбулося",
      tone: 'semantic',
    },
    {
      german: "in der DDR",
      translated: " в НДР",
      tone: 'semantic',
    },
    {
      german: "einen Aufstand",
      translated: " повстання",
      tone: 'semantic',
    },
    {
      german: "lange Zeit",
      translated: " тривалий час",
      tone: 'semantic',
    },
    {
      german: "in der Bundesrepublik Deutschland",
      translated: " у Федеративній Республіці Німеччина",
      tone: 'semantic',
    },
    {
      german: "ein Feiertag",
      translated: " державне свято",
      tone: 'semantic',
    },
    {
      german: "erinnerte",
      translated: " нагадувало",
      tone: 'semantic',
    },
    {
      german: "Wann war das",
      translated: " Коли це було?",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:186|vi": [
    {
      german: "Im Jahr 1953",
      translated: "Năm 1953",
      tone: 'semantic',
    },
    {
      german: "gab es",
      translated: "có",
      tone: 'semantic',
    },
    {
      german: "in der DDR",
      translated: "ở CHDC Đức",
      tone: 'semantic',
    },
    {
      german: "einen Aufstand",
      translated: "một cuộc nổi dậy",
      tone: 'semantic',
    },
    {
      german: "lange Zeit",
      translated: "trong thời gian dài",
      tone: 'semantic',
    },
    {
      german: "in der Bundesrepublik Deutschland",
      translated: "Tây Đức",
      tone: 'semantic',
    },
    {
      german: "ein Feiertag",
      translated: "một ngày lễ chính thức",
      tone: 'semantic',
    },
    {
      german: "erinnerte",
      translated: "tưởng niệm",
      tone: 'semantic',
    },
    {
      german: "Wann war das",
      translated: "Đó là ngày nào?",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:187|ar": [
    {
      german: "Welcher deutsche Staat",
      translated: "أي دولة ألمانية",
      tone: 'semantic',
    },
    {
      german: "hatte",
      translated: "كان",
      tone: 'semantic',
    },
    {
      german: "schwarz-rot-goldene Flagge",
      translated: "علمها أسود-أحمر-ذهبيًا",
      tone: 'semantic',
    },
    {
      german: "Hammer",
      translated: "مطرقة",
      tone: 'semantic',
    },
    {
      german: "Zirkel",
      translated: "وفرجار",
      tone: 'semantic',
    },
    {
      german: "Ährenkranz",
      translated: "وإكليل من سنابل القمح",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:187|bg": [
    {
      german: "Welcher deutsche Staat",
      translated: "Коя германска държава",
      tone: 'semantic',
    },
    {
      german: "hatte",
      translated: "има",
      tone: 'semantic',
    },
    {
      german: "schwarz-rot-goldene Flagge",
      translated: "черно-червено-златно знаме",
      tone: 'semantic',
    },
    {
      german: "Hammer",
      translated: "чук",
      tone: 'semantic',
    },
    {
      german: "Zirkel",
      translated: "пергел",
      tone: 'semantic',
    },
    {
      german: "Ährenkranz",
      translated: "житен венец",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:187|bs": [
    {
      german: "Welcher deutsche Staat",
      translated: "Koja je",
      tone: 'semantic',
    },
    {
      german: "hatte",
      translated: "imala",
      tone: 'semantic',
    },
    {
      german: "schwarz-rot-goldene Flagge",
      translated: "crno-crveno-zlatnu zastavu",
      tone: 'semantic',
    },
    {
      german: "Hammer",
      translated: "čekićem",
      tone: 'semantic',
    },
    {
      german: "Zirkel",
      translated: "šestarom",
      tone: 'semantic',
    },
    {
      german: "Ährenkranz",
      translated: "vijencem od klasja",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:187|el": [
    {
      german: "Welcher deutsche Staat",
      translated: "Ποιο γερμανικό κράτος",
      tone: 'semantic',
    },
    {
      german: "hatte",
      translated: "είχε",
      tone: 'semantic',
    },
    {
      german: "schwarz-rot-goldene Flagge",
      translated: "μαύρη-κόκκινη-χρυσή σημαία",
      tone: 'semantic',
    },
    {
      german: "Hammer",
      translated: "σφυρί",
      tone: 'semantic',
    },
    {
      german: "Zirkel",
      translated: "διαβήτη",
      tone: 'semantic',
    },
    {
      german: "Ährenkranz",
      translated: "στεφάνι από στάχυα",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:187|en": [
    {
      german: "Welcher deutsche Staat",
      translated: "Which German state",
      tone: 'semantic',
    },
    {
      german: "hatte",
      translated: "had",
      tone: 'semantic',
    },
    {
      german: "schwarz-rot-goldene Flagge",
      translated: "black-red-gold flag",
      tone: 'semantic',
    },
    {
      german: "Hammer",
      translated: "hammer",
      tone: 'semantic',
    },
    {
      german: "Zirkel",
      translated: "compass",
      tone: 'semantic',
    },
    {
      german: "Ährenkranz",
      translated: "wheat wreath",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:187|es": [
    {
      german: "Welcher deutsche Staat",
      translated: "¿Qué Estado alemán",
      tone: 'semantic',
    },
    {
      german: "hatte",
      translated: "tenía",
      tone: 'semantic',
    },
    {
      german: "schwarz-rot-goldene Flagge",
      translated: "bandera negra-roja-dorada",
      tone: 'semantic',
    },
    {
      german: "Hammer",
      translated: "martillo",
      tone: 'semantic',
    },
    {
      german: "Zirkel",
      translated: "compás",
      tone: 'semantic',
    },
    {
      german: "Ährenkranz",
      translated: "corona de espigas",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:187|fa": [
    {
      german: "Welcher deutsche Staat",
      translated: "کدام دولت آلمانی",
      tone: 'semantic',
    },
    {
      german: "hatte",
      translated: "داشت",
      tone: 'semantic',
    },
    {
      german: "schwarz-rot-goldene Flagge",
      translated: "پرچم سیاه-قرمز-طلایی",
      tone: 'semantic',
    },
    {
      german: "Hammer",
      translated: "چکش",
      tone: 'semantic',
    },
    {
      german: "Zirkel",
      translated: "پرگار",
      tone: 'semantic',
    },
    {
      german: "Ährenkranz",
      translated: "حلقهٔ خوشه‌های غله",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:187|fr": [
    {
      german: "Welcher deutsche Staat",
      translated: "Quel État allemand",
      tone: 'semantic',
    },
    {
      german: "hatte",
      translated: "avait",
      tone: 'semantic',
    },
    {
      german: "schwarz-rot-goldene Flagge",
      translated: "drapeau noir-rouge-or",
      tone: 'semantic',
    },
    {
      german: "Hammer",
      translated: "un marteau",
      tone: 'semantic',
    },
    {
      german: "Zirkel",
      translated: "un compas",
      tone: 'semantic',
    },
    {
      german: "Ährenkranz",
      translated: "une couronne d’épis",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:187|hr": [
    {
      german: "Welcher deutsche Staat",
      translated: "Koja je njemačka država",
      tone: 'semantic',
    },
    {
      german: "hatte",
      translated: "imala",
      tone: 'semantic',
    },
    {
      german: "schwarz-rot-goldene Flagge",
      translated: "crno-crveno-zlatnu zastavu",
      tone: 'semantic',
    },
    {
      german: "Hammer",
      translated: "čekićem",
      tone: 'semantic',
    },
    {
      german: "Zirkel",
      translated: "šestarom",
      tone: 'semantic',
    },
    {
      german: "Ährenkranz",
      translated: "vijencem od klasja",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:187|it": [
    {
      german: "Welcher deutsche Staat",
      translated: "Quale Stato tedesco",
      tone: 'semantic',
    },
    {
      german: "hatte",
      translated: "aveva",
      tone: 'semantic',
    },
    {
      german: "schwarz-rot-goldene Flagge",
      translated: "bandiera nera-rossa-oro",
      tone: 'semantic',
    },
    {
      german: "Hammer",
      translated: "martello",
      tone: 'semantic',
    },
    {
      german: "Zirkel",
      translated: "compasso",
      tone: 'semantic',
    },
    {
      german: "Ährenkranz",
      translated: "corona di spighe",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:187|kmr": [
    {
      german: "Welcher deutsche Staat",
      translated: "Kîjan dewleta Alman",
      tone: 'semantic',
    },
    {
      german: "hatte",
      translated: "hebû",
      tone: 'semantic',
    },
    {
      german: "schwarz-rot-goldene Flagge",
      translated: "reş-sor-zêrîn",
      tone: 'semantic',
    },
    {
      german: "Hammer",
      translated: "çekiç",
      tone: 'semantic',
    },
    {
      german: "Zirkel",
      translated: "pergela",
      tone: 'semantic',
    },
    {
      german: "Ährenkranz",
      translated: "taca genim",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:187|pl": [
    {
      german: "Welcher deutsche Staat",
      translated: "Które państwo niemieckie",
      tone: 'semantic',
    },
    {
      german: "hatte",
      translated: "miało",
      tone: 'semantic',
    },
    {
      german: "schwarz-rot-goldene Flagge",
      translated: "czarno-czerwono-złotą flagę",
      tone: 'semantic',
    },
    {
      german: "Hammer",
      translated: "młotem",
      tone: 'semantic',
    },
    {
      german: "Zirkel",
      translated: "cyrklem",
      tone: 'semantic',
    },
    {
      german: "Ährenkranz",
      translated: "wieńcem z kłosów",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:187|prs": [
    {
      german: "Welcher deutsche Staat",
      translated: "کدام دولت آلمانی",
      tone: 'semantic',
    },
    {
      german: "hatte",
      translated: "داشت",
      tone: 'semantic',
    },
    {
      german: "schwarz-rot-goldene Flagge",
      translated: "پرچم سیاه-قرمز-طلایی",
      tone: 'semantic',
    },
    {
      german: "Hammer",
      translated: "چکش",
      tone: 'semantic',
    },
    {
      german: "Zirkel",
      translated: "پرگار",
      tone: 'semantic',
    },
    {
      german: "Ährenkranz",
      translated: "حلقهٔ خوشه‌های غله",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:187|ro": [
    {
      german: "Welcher deutsche Staat",
      translated: "Care stat german",
      tone: 'semantic',
    },
    {
      german: "hatte",
      translated: "avea",
      tone: 'semantic',
    },
    {
      german: "schwarz-rot-goldene Flagge",
      translated: "steagul negru-roșu-auriu",
      tone: 'semantic',
    },
    {
      german: "Hammer",
      translated: "ciocan",
      tone: 'semantic',
    },
    {
      german: "Zirkel",
      translated: "compas",
      tone: 'semantic',
    },
    {
      german: "Ährenkranz",
      translated: "cunună de spice",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:187|ru": [
    {
      german: "Welcher deutsche Staat",
      translated: "У какого немецкого государства",
      tone: 'semantic',
    },
    {
      german: "hatte",
      translated: "был",
      tone: 'semantic',
    },
    {
      german: "schwarz-rot-goldene Flagge",
      translated: "чёрно-красно-золотой флаг",
      tone: 'semantic',
    },
    {
      german: "Hammer",
      translated: "молотом",
      tone: 'semantic',
    },
    {
      german: "Zirkel",
      translated: "циркулем",
      tone: 'semantic',
    },
    {
      german: "Ährenkranz",
      translated: "венком из колосьев",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:187|sq": [
    {
      german: "Welcher deutsche Staat",
      translated: "Cili shtet gjerman",
      tone: 'semantic',
    },
    {
      german: "hatte",
      translated: "kishte",
      tone: 'semantic',
    },
    {
      german: "schwarz-rot-goldene Flagge",
      translated: "flamur zi-kuq-ar",
      tone: 'semantic',
    },
    {
      german: "Hammer",
      translated: "çekiç",
      tone: 'semantic',
    },
    {
      german: "Zirkel",
      translated: "kompas",
      tone: 'semantic',
    },
    {
      german: "Ährenkranz",
      translated: "dhe kurorë kallinjsh",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:187|sr": [
    {
      german: "Welcher deutsche Staat",
      translated: "Koja je nemačka država",
      tone: 'semantic',
    },
    {
      german: "hatte",
      translated: "imala",
      tone: 'semantic',
    },
    {
      german: "schwarz-rot-goldene Flagge",
      translated: "crno-crveno-zlatnu zastavu",
      tone: 'semantic',
    },
    {
      german: "Hammer",
      translated: "čekićem",
      tone: 'semantic',
    },
    {
      german: "Zirkel",
      translated: "šestarom",
      tone: 'semantic',
    },
    {
      german: "Ährenkranz",
      translated: "vijencem od klasja",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:187|tr": [
    {
      german: "Welcher deutsche Staat",
      translated: "Hangi Alman devletinin",
      tone: 'semantic',
    },
    {
      german: "hatte",
      translated: "vardı",
      tone: 'semantic',
    },
    {
      german: "schwarz-rot-goldene Flagge",
      translated: "siyah-kırmızı-altın renkli bayrağında",
      tone: 'semantic',
    },
    {
      german: "Hammer",
      translated: "çekiç",
      tone: 'semantic',
    },
    {
      german: "Zirkel",
      translated: "pergel",
      tone: 'semantic',
    },
    {
      german: "Ährenkranz",
      translated: "başak çelengi",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:187|uk": [
    {
      german: "Welcher deutsche Staat",
      translated: "Яка німецька держава",
      tone: 'semantic',
    },
    {
      german: "hatte",
      translated: "мала",
      tone: 'semantic',
    },
    {
      german: "schwarz-rot-goldene Flagge",
      translated: "чорно-червоно-золотий прапор",
      tone: 'semantic',
    },
    {
      german: "Hammer",
      translated: "молотом",
      tone: 'semantic',
    },
    {
      german: "Zirkel",
      translated: "циркулем",
      tone: 'semantic',
    },
    {
      german: "Ährenkranz",
      translated: "вінком із колосків",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:187|vi": [
    {
      german: "Welcher deutsche Staat",
      translated: "Nhà nước Đức nào",
      tone: 'semantic',
    },
    {
      german: "hatte",
      translated: "có",
      tone: 'semantic',
    },
    {
      german: "schwarz-rot-goldene Flagge",
      translated: "lá cờ đen-đỏ-vàng",
      tone: 'semantic',
    },
    {
      german: "Hammer",
      translated: "búa",
      tone: 'semantic',
    },
    {
      german: "Zirkel",
      translated: "compa",
      tone: 'semantic',
    },
    {
      german: "Ährenkranz",
      translated: "vòng lúa",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:188|ar": [
    {
      german: "In welchem Jahr",
      translated: "في أي سنة",
      tone: 'semantic',
    },
    {
      german: "die Mauer",
      translated: "جدار برلين",
      tone: 'semantic',
    },
    {
      german: "gebaut",
      translated: "بُني",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:188|bg": [
    {
      german: "In welchem Jahr",
      translated: "През коя година",
      tone: 'semantic',
    },
    {
      german: "wurde",
      translated: "е",
      tone: 'semantic',
    },
    {
      german: "die Mauer",
      translated: "Берлинската стена",
      tone: 'semantic',
    },
    {
      german: "gebaut",
      translated: "построена",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:188|bs": [
    {
      german: "In welchem Jahr",
      translated: "Koje je godine",
      tone: 'semantic',
    },
    {
      german: "die Mauer",
      translated: "zid",
      tone: 'semantic',
    },
    {
      german: "in Berlin",
      translated: "Berlinski",
      tone: 'semantic',
    },
    {
      german: "gebaut",
      translated: "izgrađen",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:188|el": [
    {
      german: "In welchem Jahr",
      translated: "Σε ποιο έτος",
      tone: 'semantic',
    },
    {
      german: "wurde",
      translated: "χτίστηκε",
      tone: 'semantic',
    },
    {
      german: "die Mauer",
      translated: "το Τείχος του Βερολίνου",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:188|en": [
    {
      german: "In welchem Jahr",
      translated: "In what year",
      tone: 'semantic',
    },
    {
      german: "wurde",
      translated: "was",
      tone: 'semantic',
    },
    {
      german: "die Mauer",
      translated: "Wall",
      tone: 'semantic',
    },
    {
      german: "in Berlin",
      translated: "Berlin",
      tone: 'semantic',
    },
    {
      german: "gebaut",
      translated: "built",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:188|es": [
    {
      german: "In welchem Jahr",
      translated: "¿En qué año",
      tone: 'semantic',
    },
    {
      german: "die Mauer",
      translated: "el Muro",
      tone: 'semantic',
    },
    {
      german: "in Berlin",
      translated: "de Berlín",
      tone: 'semantic',
    },
    {
      german: "gebaut",
      translated: "se construyó",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:188|fa": [
    {
      german: "In welchem Jahr",
      translated: "چه سالی",
      tone: 'semantic',
    },
    {
      german: "die Mauer",
      translated: "دیوار",
      tone: 'semantic',
    },
    {
      german: "in Berlin",
      translated: "برلین",
      tone: 'semantic',
    },
    {
      german: "gebaut",
      translated: "شد",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:188|fr": [
    {
      german: "In welchem Jahr",
      translated: "En quelle année",
      tone: 'semantic',
    },
    {
      german: "wurde",
      translated: "a-t-il été",
      tone: 'semantic',
    },
    {
      german: "die Mauer",
      translated: "le mur",
      tone: 'semantic',
    },
    {
      german: "in Berlin",
      translated: "de Berlin",
      tone: 'semantic',
    },
    {
      german: "gebaut",
      translated: "construit",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:188|hr": [
    {
      german: "In welchem Jahr",
      translated: "Koje je godine",
      tone: 'semantic',
    },
    {
      german: "die Mauer",
      translated: "zid",
      tone: 'semantic',
    },
    {
      german: "in Berlin",
      translated: "Berlinski",
      tone: 'semantic',
    },
    {
      german: "gebaut",
      translated: "izgrađen",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:188|it": [
    {
      german: "In welchem Jahr",
      translated: "In quale anno",
      tone: 'semantic',
    },
    {
      german: "wurde",
      translated: "fu",
      tone: 'semantic',
    },
    {
      german: "die Mauer",
      translated: "il Muro",
      tone: 'semantic',
    },
    {
      german: "in Berlin",
      translated: "di Berlino",
      tone: 'semantic',
    },
    {
      german: "gebaut",
      translated: "costruito",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:188|kmr": [
    {
      german: "In welchem Jahr",
      translated: "di kîjan salê",
      tone: 'semantic',
    },
    {
      german: "die Mauer",
      translated: "Dîwarê",
      tone: 'semantic',
    },
    {
      german: "in Berlin",
      translated: "Berlînê",
      tone: 'semantic',
    },
    {
      german: "gebaut",
      translated: "hate avakirin?",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:188|pl": [
    {
      german: "In welchem Jahr",
      translated: "W którym roku",
      tone: 'semantic',
    },
    {
      german: "die Mauer",
      translated: "Mur",
      tone: 'semantic',
    },
    {
      german: "in Berlin",
      translated: "Berliński",
      tone: 'semantic',
    },
    {
      german: "gebaut",
      translated: "zbudowano",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:188|prs": [
    {
      german: "In welchem Jahr",
      translated: "چه سالی",
      tone: 'semantic',
    },
    {
      german: "wurde",
      translated: "شد",
      tone: 'semantic',
    },
    {
      german: "die Mauer",
      translated: "دیوار",
      tone: 'semantic',
    },
    {
      german: "in Berlin",
      translated: "برلین",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:188|ro": [
    {
      german: "In welchem Jahr",
      translated: "În ce an",
      tone: 'semantic',
    },
    {
      german: "wurde",
      translated: "a fost",
      tone: 'semantic',
    },
    {
      german: "die Mauer",
      translated: "Zidul Berlinului",
      tone: 'semantic',
    },
    {
      german: "gebaut",
      translated: "construit",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:188|ru": [
    {
      german: "In welchem Jahr",
      translated: "В каком году",
      tone: 'semantic',
    },
    {
      german: "die Mauer",
      translated: "Берлинская стена",
      tone: 'semantic',
    },
    {
      german: "gebaut",
      translated: "построена",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:188|sq": [
    {
      german: "In welchem Jahr",
      translated: "Në cilin vit",
      tone: 'semantic',
    },
    {
      german: "wurde",
      translated: "u",
      tone: 'semantic',
    },
    {
      german: "die Mauer",
      translated: "Muri",
      tone: 'semantic',
    },
    {
      german: "in Berlin",
      translated: "i Berlinit",
      tone: 'semantic',
    },
    {
      german: "gebaut",
      translated: "ndërtua",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:188|sr": [
    {
      german: "In welchem Jahr",
      translated: "Koje je godine",
      tone: 'semantic',
    },
    {
      german: "die Mauer",
      translated: "zid",
      tone: 'semantic',
    },
    {
      german: "in Berlin",
      translated: "Berlinski",
      tone: 'semantic',
    },
    {
      german: "gebaut",
      translated: "izgrađen",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:188|tr": [
    {
      german: "In welchem Jahr",
      translated: "hangi yıl",
      tone: 'semantic',
    },
    {
      german: "wurde",
      translated: "edildi",
      tone: 'semantic',
    },
    {
      german: "die Mauer",
      translated: "Duvarı",
      tone: 'semantic',
    },
    {
      german: "in Berlin",
      translated: "Berlin",
      tone: 'semantic',
    },
    {
      german: "gebaut",
      translated: "inşa",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:188|uk": [
    {
      german: "In welchem Jahr",
      translated: "У якому році",
      tone: 'semantic',
    },
    {
      german: "wurde",
      translated: "був",
      tone: 'semantic',
    },
    {
      german: "die Mauer",
      translated: "мур",
      tone: 'semantic',
    },
    {
      german: "in Berlin",
      translated: "Берлінський",
      tone: 'semantic',
    },
    {
      german: "gebaut",
      translated: "побудований",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:188|vi": [
    {
      german: "In welchem Jahr",
      translated: "năm nào",
      tone: 'semantic',
    },
    {
      german: "wurde",
      translated: "được",
      tone: 'semantic',
    },
    {
      german: "die Mauer",
      translated: "Bức tường Berlin",
      tone: 'semantic',
    },
    {
      german: "gebaut",
      translated: "xây",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:189|ar": [
    {
      german: "Wann",
      translated: "متى",
      tone: 'semantic',
    },
    {
      german: "baute",
      translated: "بنت",
      tone: 'semantic',
    },
    {
      german: "die DDR",
      translated: "DDR",
      tone: 'semantic',
    },
    {
      german: "die Mauer",
      translated: "جدار",
      tone: 'semantic',
    },
    {
      german: "in Berlin",
      translated: "برلين",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:189|bg": [
    {
      german: "Wann",
      translated: "Кога",
      tone: 'semantic',
    },
    {
      german: "baute",
      translated: "построява",
      tone: 'semantic',
    },
    {
      german: "die DDR",
      translated: "ГДР",
      tone: 'semantic',
    },
    {
      german: "die Mauer",
      translated: "Берлинската стена",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:189|bs": [
    {
      german: "Wann",
      translated: "Kada",
      tone: 'semantic',
    },
    {
      german: "baute",
      translated: "izgradio",
      tone: 'semantic',
    },
    {
      german: "die DDR",
      translated: "DDR",
      tone: 'semantic',
    },
    {
      german: "die Mauer",
      translated: "Berlinski zid",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:189|el": [
    {
      german: "Wann",
      translated: "Πότε",
      tone: 'semantic',
    },
    {
      german: "baute",
      translated: "έχτισε",
      tone: 'semantic',
    },
    {
      german: "die DDR",
      translated: "η ΛΔΓ",
      tone: 'semantic',
    },
    {
      german: "die Mauer",
      translated: "το Τείχος",
      tone: 'semantic',
    },
    {
      german: "in Berlin",
      translated: "του Βερολίνου",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:189|en": [
    {
      german: "Wann",
      translated: "When",
      tone: 'semantic',
    },
    {
      german: "baute",
      translated: "build",
      tone: 'semantic',
    },
    {
      german: "die DDR",
      translated: "the GDR",
      tone: 'semantic',
    },
    {
      german: "die Mauer",
      translated: "Wall",
      tone: 'semantic',
    },
    {
      german: "in Berlin",
      translated: "Berlin",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:189|es": [
    {
      german: "Wann",
      translated: "¿Cuándo",
      tone: 'semantic',
    },
    {
      german: "baute",
      translated: "construyó",
      tone: 'semantic',
    },
    {
      german: "die DDR",
      translated: "la RDA",
      tone: 'semantic',
    },
    {
      german: "die Mauer",
      translated: "el Muro",
      tone: 'semantic',
    },
    {
      german: "in Berlin",
      translated: "de Berlín",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:189|fa": [
    {
      german: "Wann",
      translated: "چه زمانی",
      tone: 'semantic',
    },
    {
      german: "baute",
      translated: "ساخت",
      tone: 'semantic',
    },
    {
      german: "die DDR",
      translated: "جمهوری دموکراتیک آلمان",
      tone: 'semantic',
    },
    {
      german: "die Mauer",
      translated: " دیوار برلین را",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:189|fr": [
    {
      german: "Wann",
      translated: "Quand",
      tone: 'semantic',
    },
    {
      german: "baute",
      translated: "construit",
      tone: 'semantic',
    },
    {
      german: "die DDR",
      translated: "la RDA",
      tone: 'semantic',
    },
    {
      german: "die Mauer",
      translated: "le mur",
      tone: 'semantic',
    },
    {
      german: "in Berlin",
      translated: "de Berlin",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:189|hr": [
    {
      german: "Wann",
      translated: "Kada",
      tone: 'semantic',
    },
    {
      german: "baute",
      translated: "izgradio",
      tone: 'semantic',
    },
    {
      german: "die DDR",
      translated: "DDR",
      tone: 'semantic',
    },
    {
      german: "die Mauer",
      translated: "Berlinski zid",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:189|it": [
    {
      german: "Wann",
      translated: "Quando",
      tone: 'semantic',
    },
    {
      german: "baute",
      translated: "costruì",
      tone: 'semantic',
    },
    {
      german: "die DDR",
      translated: "la RDT",
      tone: 'semantic',
    },
    {
      german: "die Mauer",
      translated: "il Muro",
      tone: 'semantic',
    },
    {
      german: "in Berlin",
      translated: "di Berlino?",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:189|kmr": [
    {
      german: "Wann",
      translated: "kengê",
      tone: 'semantic',
    },
    {
      german: "baute",
      translated: "ava kir",
      tone: 'semantic',
    },
    {
      german: "die DDR",
      translated: "DDR",
      tone: 'semantic',
    },
    {
      german: "die Mauer",
      translated: "Dîwarê",
      tone: 'semantic',
    },
    {
      german: "in Berlin",
      translated: "Berlînê",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:189|pl": [
    {
      german: "Wann",
      translated: "Kiedy",
      tone: 'semantic',
    },
    {
      german: "baute",
      translated: "zbudowała",
      tone: 'semantic',
    },
    {
      german: "die DDR",
      translated: "NRD",
      tone: 'semantic',
    },
    {
      german: "die Mauer",
      translated: "Mur",
      tone: 'semantic',
    },
    {
      german: "in Berlin",
      translated: "Berliński",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:189|prs": [
    {
      german: "Wann",
      translated: "چه زمانی",
      tone: 'semantic',
    },
    {
      german: "baute",
      translated: "ساخت",
      tone: 'semantic',
    },
    {
      german: "die DDR",
      translated: "جمهوری دموکراتیک آلمان",
      tone: 'semantic',
    },
    {
      german: "die Mauer",
      translated: "دیوار برلین",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:189|ro": [
    {
      german: "Wann",
      translated: "Când",
      tone: 'semantic',
    },
    {
      german: "baute",
      translated: "a construit",
      tone: 'semantic',
    },
    {
      german: "die DDR",
      translated: "RDG",
      tone: 'semantic',
    },
    {
      german: "die Mauer",
      translated: "Zidul Berlinului",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:189|ru": [
    {
      german: "Wann",
      translated: "Когда",
      tone: 'semantic',
    },
    {
      german: "baute",
      translated: "построила",
      tone: 'semantic',
    },
    {
      german: "die DDR",
      translated: "ГДР",
      tone: 'semantic',
    },
    {
      german: "die Mauer",
      translated: "Берлинскую стену",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:189|sq": [
    {
      german: "Wann",
      translated: "Kur",
      tone: 'semantic',
    },
    {
      german: "baute",
      translated: "ndërtoi",
      tone: 'semantic',
    },
    {
      german: "die DDR",
      translated: "RDGJ-ja",
      tone: 'semantic',
    },
    {
      german: "die Mauer",
      translated: "Murin",
      tone: 'semantic',
    },
    {
      german: "in Berlin",
      translated: "e Berlinit",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:189|sr": [
    {
      german: "Wann",
      translated: "Kada",
      tone: 'semantic',
    },
    {
      german: "baute",
      translated: "izgradio",
      tone: 'semantic',
    },
    {
      german: "die DDR",
      translated: "DDR",
      tone: 'semantic',
    },
    {
      german: "die Mauer",
      translated: "Berlinski zid",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:189|tr": [
    {
      german: "Wann",
      translated: "ne zaman",
      tone: 'semantic',
    },
    {
      german: "baute",
      translated: "inşa etti",
      tone: 'semantic',
    },
    {
      german: "die DDR",
      translated: "Doğu Almanya",
      tone: 'semantic',
    },
    {
      german: "die Mauer",
      translated: "Berlin Duvarı'nı",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:189|uk": [
    {
      german: "Wann",
      translated: "Коли",
      tone: 'semantic',
    },
    {
      german: "baute",
      translated: "побудувала",
      tone: 'semantic',
    },
    {
      german: "die DDR",
      translated: "НДР",
      tone: 'semantic',
    },
    {
      german: "die Mauer",
      translated: "мур",
      tone: 'semantic',
    },
    {
      german: "in Berlin",
      translated: "Берлінський",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:189|vi": [
    {
      german: "Wann",
      translated: "khi nào",
      tone: 'semantic',
    },
    {
      german: "baute",
      translated: "xây",
      tone: 'semantic',
    },
    {
      german: "die DDR",
      translated: "Đức",
      tone: 'semantic',
    },
    {
      german: "die Mauer",
      translated: "Bức tường",
      tone: 'semantic',
    },
    {
      german: "in Berlin",
      translated: "Berlin",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:18|ar": [
    {
      german: "Welches Grundrecht",
      translated: "أي حق أساسي",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "تكفله",
      tone: 'semantic',
    },
    {
      german: "in Artikel 1",
      translated: "المادة الأولى",
      tone: 'semantic',
    },
    {
      german: "des Grundgesetzes der Bundesrepublik Deutschland",
      translated: "من القانون الأساسي لجمهورية ألمانيا الاتحادية",
      tone: 'semantic',
    },
    {
      german: "garantiert",
      translated: "؟",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:18|bg": [
    {
      german: "Welches Grundrecht",
      translated: "Кое основно право",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "е",
      tone: 'semantic',
    },
    {
      german: "in Artikel 1",
      translated: "от член 1",
      tone: 'semantic',
    },
    {
      german: "des Grundgesetzes der Bundesrepublik Deutschland",
      translated: "на Основния закон",
      tone: 'semantic',
    },
    {
      german: "garantiert",
      translated: "гарантирано",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:18|bs": [
    {
      german: "Welches Grundrecht",
      translated: "Koje temeljno pravo",
      tone: 'semantic',
    },
    {
      german: "in Artikel 1",
      translated: "članak 1",
      tone: 'semantic',
    },
    {
      german: "des Grundgesetzes der Bundesrepublik Deutschland",
      translated: "Temeljnog zakona Savezne Republike Njemačke",
      tone: 'semantic',
    },
    {
      german: "garantiert",
      translated: "jamči",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:18|el": [
    {
      german: "Welches Grundrecht",
      translated: "Ποιο θεμελιώδες δικαίωμα",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "κατοχυρώνεται",
      tone: 'semantic',
    },
    {
      german: "in Artikel 1",
      translated: "στο άρθρο 1",
      tone: 'semantic',
    },
    {
      german: "des Grundgesetzes der Bundesrepublik Deutschland",
      translated: "του Θεμελιώδους Νόμου της Ομοσπονδιακής Δημοκρατίας της Γερμανίας",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:18|en": [
    {
      german: "Welches Grundrecht",
      translated: "Which fundamental right",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "is",
      tone: 'semantic',
    },
    {
      german: "in Artikel 1",
      translated: "in Article 1",
      tone: 'semantic',
    },
    {
      german: "des Grundgesetzes der Bundesrepublik Deutschland",
      translated: "of the Basic Law of the Federal Republic of Germany",
      tone: 'semantic',
    },
    {
      german: "garantiert",
      translated: "guaranteed",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:18|es": [
    {
      german: "Welches Grundrecht",
      translated: "¿Qué derecho fundamental",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "está",
      tone: 'semantic',
    },
    {
      german: "in Artikel 1",
      translated: "en el artículo 1",
      tone: 'semantic',
    },
    {
      german: "des Grundgesetzes der Bundesrepublik Deutschland",
      translated: "de la Ley Fundamental de la República Federal de Alemania",
      tone: 'semantic',
    },
    {
      german: "garantiert",
      translated: "garantizado",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:18|fa": [
    {
      german: "Welches Grundrecht",
      translated: "کدام حق بنیادی",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "است",
      tone: 'semantic',
    },
    {
      german: "in Artikel 1",
      translated: "در مادهٔ ۱",
      tone: 'semantic',
    },
    {
      german: "des Grundgesetzes der Bundesrepublik Deutschland",
      translated: "قانون اساسی جمهوری فدرال آلمان",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:18|fr": [
    {
      german: "Welches Grundrecht",
      translated: "Quel droit fondamental",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "est",
      tone: 'semantic',
    },
    {
      german: "in Artikel 1",
      translated: "par l’article 1",
      tone: 'semantic',
    },
    {
      german: "des Grundgesetzes der Bundesrepublik Deutschland",
      translated: "de la Loi fondamentale de la République fédérale d’Allemagne",
      tone: 'semantic',
    },
    {
      german: "garantiert",
      translated: "garanti",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:18|hr": [
    {
      german: "Welches Grundrecht",
      translated: "Koje temeljno pravo",
      tone: 'semantic',
    },
    {
      german: "in Artikel 1",
      translated: "članak 1.",
      tone: 'semantic',
    },
    {
      german: "des Grundgesetzes der Bundesrepublik Deutschland",
      translated: "Temeljnog zakona Savezne Republike Njemačke",
      tone: 'semantic',
    },
    {
      german: "garantiert",
      translated: "jamči",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:18|it": [
    {
      german: "Welches Grundrecht",
      translated: "Quale diritto fondamentale",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "è",
      tone: 'semantic',
    },
    {
      german: "in Artikel 1",
      translated: "dall’articolo 1",
      tone: 'semantic',
    },
    {
      german: "des Grundgesetzes der Bundesrepublik Deutschland",
      translated: "della Legge fondamentale della Repubblica Federale di Germania",
      tone: 'semantic',
    },
    {
      german: "garantiert",
      translated: "garantito",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:18|kmr": [
    {
      german: "Welches Grundrecht",
      translated: "kîjan mafê bingehîn",
      tone: 'semantic',
    },
    {
      german: "in Artikel 1",
      translated: "Madda 1",
      tone: 'semantic',
    },
    {
      german: "des Grundgesetzes der Bundesrepublik Deutschland",
      translated: "a Qanûna Bingehîn a Komara Federal a Almanyayê",
      tone: 'semantic',
    },
    {
      german: "garantiert",
      translated: "garantî dike",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:18|pl": [
    {
      german: "Welches Grundrecht",
      translated: "Które prawo podstawowe",
      tone: 'semantic',
    },
    {
      german: "in Artikel 1",
      translated: "artykuł 1",
      tone: 'semantic',
    },
    {
      german: "des Grundgesetzes der Bundesrepublik Deutschland",
      translated: "Ustawy Zasadniczej Republiki Federalnej Niemiec",
      tone: 'semantic',
    },
    {
      german: "garantiert",
      translated: "gwarantuje",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:18|prs": [
    {
      german: "Welches Grundrecht",
      translated: "کدام حق بنیادی",
      tone: 'semantic',
    },
    {
      german: "in Artikel 1",
      translated: "در مادهٔ ۱",
      tone: 'semantic',
    },
    {
      german: "des Grundgesetzes der Bundesrepublik Deutschland",
      translated: "قانون اساسی جمهوری فدرال آلمان",
      tone: 'semantic',
    },
    {
      german: "garantiert",
      translated: "تضمین شده است",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:18|ro": [
    {
      german: "Welches Grundrecht",
      translated: "Ce drept fundamental",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "este",
      tone: 'semantic',
    },
    {
      german: "in Artikel 1",
      translated: "de articolul 1 al",
      tone: 'semantic',
    },
    {
      german: "des Grundgesetzes der Bundesrepublik Deutschland",
      translated: "Legii fundamentale a Republicii Federale Germania",
      tone: 'semantic',
    },
    {
      german: "garantiert",
      translated: "garantat",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:18|ru": [
    {
      german: "Welches Grundrecht",
      translated: "Какое основное право",
      tone: 'semantic',
    },
    {
      german: "in Artikel 1",
      translated: "статьёй 1",
      tone: 'semantic',
    },
    {
      german: "des Grundgesetzes der Bundesrepublik Deutschland",
      translated: "Основного закона ФРГ",
      tone: 'semantic',
    },
    {
      german: "garantiert",
      translated: "гарантировано",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:18|sq": [
    {
      german: "Welches Grundrecht",
      translated: "Cila e drejtë themelore",
      tone: 'semantic',
    },
    {
      german: "in Artikel 1",
      translated: "nga neni 1",
      tone: 'semantic',
    },
    {
      german: "des Grundgesetzes der Bundesrepublik Deutschland",
      translated: "i Ligjit Themelor të Republikës Federale të Gjermanisë",
      tone: 'semantic',
    },
    {
      german: "garantiert",
      translated: "garantohet",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:18|sr": [
    {
      german: "Welches Grundrecht",
      translated: "Koje osnovno pravo",
      tone: 'semantic',
    },
    {
      german: "in Artikel 1",
      translated: "članak 1",
      tone: 'semantic',
    },
    {
      german: "des Grundgesetzes der Bundesrepublik Deutschland",
      translated: "Osnovnog zakona Savezne Republike Nemačke",
      tone: 'semantic',
    },
    {
      german: "garantiert",
      translated: "jamči",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:18|tr": [
    {
      german: "Welches Grundrecht",
      translated: "hangi temel hak",
      tone: 'semantic',
    },
    {
      german: "in Artikel 1",
      translated: "1. maddesinde",
      tone: 'semantic',
    },
    {
      german: "des Grundgesetzes der Bundesrepublik Deutschland",
      translated: "Alman Anayasası'nın",
      tone: 'semantic',
    },
    {
      german: "garantiert",
      translated: "güvence altına alınmıştır",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:18|uk": [
    {
      german: "Welches Grundrecht",
      translated: "Яке основне право",
      tone: 'semantic',
    },
    {
      german: "in Artikel 1",
      translated: "стаття 1",
      tone: 'semantic',
    },
    {
      german: "des Grundgesetzes der Bundesrepublik Deutschland",
      translated: "Основного закону Федеративної Республіки Німеччина",
      tone: 'semantic',
    },
    {
      german: "garantiert",
      translated: "гарантує",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:18|vi": [
    {
      german: "Welches Grundrecht",
      translated: "Quyền cơ bản nào",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "được",
      tone: 'semantic',
    },
    {
      german: "in Artikel 1",
      translated: "Điều 1",
      tone: 'semantic',
    },
    {
      german: "des Grundgesetzes der Bundesrepublik Deutschland",
      translated: "của Luật Cơ bản Cộng hòa Liên bang Đức",
      tone: 'semantic',
    },
    {
      german: "garantiert",
      translated: "bảo đảm",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:190|ar": [
    {
      german: "Was bedeutet",
      translated: "ماذا يعني",
      tone: 'semantic',
    },
    {
      german: "die Abkürzung",
      translated: "الاختصار",
      tone: 'semantic',
    },
    {
      german: "DDR",
      translated: "DDR",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:190|bg": [
    {
      german: "Was bedeutet",
      translated: "Какво означава",
      tone: 'semantic',
    },
    {
      german: "die Abkürzung",
      translated: "съкращението",
      tone: 'semantic',
    },
    {
      german: "DDR",
      translated: "DDR",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:190|bs": [
    {
      german: "Was bedeutet",
      translated: "Što znači",
      tone: 'semantic',
    },
    {
      german: "die Abkürzung",
      translated: "kratica",
      tone: 'semantic',
    },
    {
      german: "DDR",
      translated: "DDR",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:190|el": [
    {
      german: "Was bedeutet",
      translated: "Τι σημαίνει",
      tone: 'semantic',
    },
    {
      german: "die Abkürzung",
      translated: "η συντομογραφία",
      tone: 'semantic',
    },
    {
      german: "DDR",
      translated: "DDR",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:190|en": [
    {
      german: "Was bedeutet",
      translated: "What does",
      tone: 'semantic',
    },
    {
      german: "die Abkürzung",
      translated: "the abbreviation",
      tone: 'semantic',
    },
    {
      german: "DDR",
      translated: "DDR",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:190|es": [
    {
      german: "Was bedeutet",
      translated: "¿Qué significa",
      tone: 'semantic',
    },
    {
      german: "die Abkürzung",
      translated: "la abreviatura",
      tone: 'semantic',
    },
    {
      german: "DDR",
      translated: "DDR",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:190|fa": [
    {
      german: "Was bedeutet",
      translated: "به چه معناست",
      tone: 'semantic',
    },
    {
      german: "die Abkürzung",
      translated: "مخفف",
      tone: 'semantic',
    },
    {
      german: "DDR",
      translated: "DDR",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:190|fr": [
    {
      german: "Was bedeutet",
      translated: "Que signifie",
      tone: 'semantic',
    },
    {
      german: "die Abkürzung",
      translated: "l’abréviation",
      tone: 'semantic',
    },
    {
      german: "DDR",
      translated: "DDR",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:190|hr": [
    {
      german: "Was bedeutet",
      translated: "Što znači",
      tone: 'semantic',
    },
    {
      german: "die Abkürzung",
      translated: "kratica",
      tone: 'semantic',
    },
    {
      german: "DDR",
      translated: "DDR",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:190|it": [
    {
      german: "Was bedeutet",
      translated: "Che cosa significa",
      tone: 'semantic',
    },
    {
      german: "die Abkürzung",
      translated: "l’abbreviazione",
      tone: 'semantic',
    },
    {
      german: "DDR",
      translated: "DDR",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:190|kmr": [
    {
      german: "Was bedeutet",
      translated: "tê çi wateyê",
      tone: 'semantic',
    },
    {
      german: "DDR",
      translated: "DDR",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:190|pl": [
    {
      german: "Was bedeutet",
      translated: "Co oznacza",
      tone: 'semantic',
    },
    {
      german: "die Abkürzung",
      translated: "skrót",
      tone: 'semantic',
    },
    {
      german: "DDR",
      translated: "DDR",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:190|prs": [
    {
      german: "Was bedeutet",
      translated: "به چه معناست",
      tone: 'semantic',
    },
    {
      german: "die Abkürzung",
      translated: "مخفف",
      tone: 'semantic',
    },
    {
      german: "DDR",
      translated: "DDR",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:190|ro": [
    {
      german: "Was bedeutet",
      translated: "Ce înseamnă",
      tone: 'semantic',
    },
    {
      german: "die Abkürzung",
      translated: "abrevierea",
      tone: 'semantic',
    },
    {
      german: "DDR",
      translated: "DDR",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:190|ru": [
    {
      german: "Was bedeutet",
      translated: "Что означает",
      tone: 'semantic',
    },
    {
      german: "die Abkürzung",
      translated: "аббревиатура",
      tone: 'semantic',
    },
    {
      german: "DDR",
      translated: "DDR",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:190|sq": [
    {
      german: "Was bedeutet",
      translated: "Çfarë do të thotë",
      tone: 'semantic',
    },
    {
      german: "die Abkürzung",
      translated: "shkurtesa",
      tone: 'semantic',
    },
    {
      german: "DDR",
      translated: "DDR",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:190|sr": [
    {
      german: "Was bedeutet",
      translated: "Šta znači",
      tone: 'semantic',
    },
    {
      german: "die Abkürzung",
      translated: "kratica",
      tone: 'semantic',
    },
    {
      german: "DDR",
      translated: "DDR",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:190|tr": [
    {
      german: "Was bedeutet",
      translated: "ne anlama gelir",
      tone: 'semantic',
    },
    {
      german: "die Abkürzung",
      translated: "kısaltması",
      tone: 'semantic',
    },
    {
      german: "DDR",
      translated: "DDR",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:190|uk": [
    {
      german: "Was bedeutet",
      translated: "Що означає",
      tone: 'semantic',
    },
    {
      german: "die Abkürzung",
      translated: "абревіатура",
      tone: 'semantic',
    },
    {
      german: "DDR",
      translated: "DDR",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:190|vi": [
    {
      german: "Was bedeutet",
      translated: "có nghĩa là",
      tone: 'semantic',
    },
    {
      german: "die Abkürzung",
      translated: "Chữ viết tắt",
      tone: 'semantic',
    },
    {
      german: "DDR",
      translated: "DDR",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:191|ar": [
    {
      german: "Wann",
      translated: "متى",
      tone: 'semantic',
    },
    {
      german: "wurde",
      translated: "فُتح",
      tone: 'semantic',
    },
    {
      german: "die Mauer",
      translated: "جدار برلين",
      tone: 'semantic',
    },
    {
      german: "für alle",
      translated: "أمام الجميع",
      tone: 'semantic',
    },
    {
      german: "geöffnet",
      translated: "؟",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:191|bg": [
    {
      german: "Wann",
      translated: "Кога",
      tone: 'semantic',
    },
    {
      german: "wurde",
      translated: "е",
      tone: 'semantic',
    },
    {
      german: "die Mauer",
      translated: "Берлинската стена",
      tone: 'semantic',
    },
    {
      german: "für alle",
      translated: "за всички",
      tone: 'semantic',
    },
    {
      german: "geöffnet",
      translated: "отворена",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:191|bs": [
    {
      german: "Wann",
      translated: "Kada",
      tone: 'semantic',
    },
    {
      german: "wurde",
      translated: "je",
      tone: 'semantic',
    },
    {
      german: "die Mauer",
      translated: "Berlinski zid",
      tone: 'semantic',
    },
    {
      german: "für alle",
      translated: "za sve",
      tone: 'semantic',
    },
    {
      german: "geöffnet",
      translated: "otvoren",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:191|el": [
    {
      german: "Wann",
      translated: "Πότε",
      tone: 'semantic',
    },
    {
      german: "wurde",
      translated: "άνοιξε",
      tone: 'semantic',
    },
    {
      german: "die Mauer",
      translated: "το Τείχος του Βερολίνου",
      tone: 'semantic',
    },
    {
      german: "für alle",
      translated: "για όλους",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:191|en": [
    {
      german: "Wann",
      translated: "When",
      tone: 'semantic',
    },
    {
      german: "wurde",
      translated: "was",
      tone: 'semantic',
    },
    {
      german: "die Mauer",
      translated: "Wall",
      tone: 'semantic',
    },
    {
      german: "in Berlin",
      translated: "Berlin",
      tone: 'semantic',
    },
    {
      german: "für alle",
      translated: "for everyone",
      tone: 'semantic',
    },
    {
      german: "geöffnet",
      translated: "opened",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:191|es": [
    {
      german: "Wann",
      translated: "¿Cuándo",
      tone: 'semantic',
    },
    {
      german: "die Mauer",
      translated: "el Muro",
      tone: 'semantic',
    },
    {
      german: "in Berlin",
      translated: "de Berlín",
      tone: 'semantic',
    },
    {
      german: "für alle",
      translated: "para todas las personas",
      tone: 'semantic',
    },
    {
      german: "geöffnet",
      translated: "se abrió",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:191|fa": [
    {
      german: "Wann",
      translated: "چه زمانی",
      tone: 'semantic',
    },
    {
      german: "die Mauer",
      translated: "دیوار برلین",
      tone: 'semantic',
    },
    {
      german: "für alle",
      translated: "برای همه",
      tone: 'semantic',
    },
    {
      german: "geöffnet",
      translated: "باز شد",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:191|fr": [
    {
      german: "Wann",
      translated: "Quand",
      tone: 'semantic',
    },
    {
      german: "wurde",
      translated: "a-t-il été",
      tone: 'semantic',
    },
    {
      german: "die Mauer",
      translated: "le mur",
      tone: 'semantic',
    },
    {
      german: "in Berlin",
      translated: "de Berlin",
      tone: 'semantic',
    },
    {
      german: "für alle",
      translated: "à tous",
      tone: 'semantic',
    },
    {
      german: "geöffnet",
      translated: "ouvert",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:191|hr": [
    {
      german: "Wann",
      translated: "Kada",
      tone: 'semantic',
    },
    {
      german: "wurde",
      translated: "je",
      tone: 'semantic',
    },
    {
      german: "die Mauer",
      translated: "Berlinski zid",
      tone: 'semantic',
    },
    {
      german: "für alle",
      translated: "za sve",
      tone: 'semantic',
    },
    {
      german: "geöffnet",
      translated: "otvoren",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:191|it": [
    {
      german: "Wann",
      translated: "Quando",
      tone: 'semantic',
    },
    {
      german: "wurde",
      translated: "fu",
      tone: 'semantic',
    },
    {
      german: "die Mauer",
      translated: "il Muro di Berlino",
      tone: 'semantic',
    },
    {
      german: "für alle",
      translated: "per tutti",
      tone: 'semantic',
    },
    {
      german: "geöffnet",
      translated: "aperto",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:191|kmr": [
    {
      german: "wurde",
      translated: "hate",
      tone: 'semantic',
    },
    {
      german: "die Mauer",
      translated: "Dîwarê Berlînê",
      tone: 'semantic',
    },
    {
      german: "für alle",
      translated: "ji bo hemû kesan",
      tone: 'semantic',
    },
    {
      german: "geöffnet",
      translated: "vekirin",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:191|pl": [
    {
      german: "Wann",
      translated: "Kiedy",
      tone: 'semantic',
    },
    {
      german: "wurde",
      translated: "został",
      tone: 'semantic',
    },
    {
      german: "die Mauer",
      translated: "Mur",
      tone: 'semantic',
    },
    {
      german: "in Berlin",
      translated: "Berliński",
      tone: 'semantic',
    },
    {
      german: "für alle",
      translated: "dla wszystkich",
      tone: 'semantic',
    },
    {
      german: "geöffnet",
      translated: "otwarty",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:191|prs": [
    {
      german: "Wann",
      translated: "چه زمانی",
      tone: 'semantic',
    },
    {
      german: "die Mauer",
      translated: "دیوار برلین",
      tone: 'semantic',
    },
    {
      german: "für alle",
      translated: "برای همه",
      tone: 'semantic',
    },
    {
      german: "geöffnet",
      translated: "باز شد",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:191|ro": [
    {
      german: "Wann",
      translated: "Când",
      tone: 'semantic',
    },
    {
      german: "wurde",
      translated: "a fost",
      tone: 'semantic',
    },
    {
      german: "die Mauer",
      translated: "Zidul Berlinului",
      tone: 'semantic',
    },
    {
      german: "für alle",
      translated: "pentru toată lumea",
      tone: 'semantic',
    },
    {
      german: "geöffnet",
      translated: "deschis",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:191|ru": [
    {
      german: "Wann",
      translated: "Когда",
      tone: 'semantic',
    },
    {
      german: "wurde",
      translated: "была",
      tone: 'semantic',
    },
    {
      german: "die Mauer",
      translated: "Берлинская стена",
      tone: 'semantic',
    },
    {
      german: "für alle",
      translated: "для всех",
      tone: 'semantic',
    },
    {
      german: "geöffnet",
      translated: "открыта",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:191|sq": [
    {
      german: "Wann",
      translated: "Kur",
      tone: 'semantic',
    },
    {
      german: "wurde",
      translated: "u hap",
      tone: 'semantic',
    },
    {
      german: "die Mauer",
      translated: "Muri",
      tone: 'semantic',
    },
    {
      german: "in Berlin",
      translated: "i Berlinit",
      tone: 'semantic',
    },
    {
      german: "für alle",
      translated: "për të gjithë",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:191|sr": [
    {
      german: "Wann",
      translated: "Kada",
      tone: 'semantic',
    },
    {
      german: "wurde",
      translated: "je",
      tone: 'semantic',
    },
    {
      german: "die Mauer",
      translated: "Berlinski zid",
      tone: 'semantic',
    },
    {
      german: "für alle",
      translated: "za sve",
      tone: 'semantic',
    },
    {
      german: "geöffnet",
      translated: "otvoren",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:191|tr": [
    {
      german: "Wann",
      translated: "ne zaman",
      tone: 'semantic',
    },
    {
      german: "die Mauer",
      translated: "Berlin Duvarı",
      tone: 'semantic',
    },
    {
      german: "für alle",
      translated: "herkes için",
      tone: 'semantic',
    },
    {
      german: "geöffnet",
      translated: "açıldı",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:191|uk": [
    {
      german: "Wann",
      translated: "Коли",
      tone: 'semantic',
    },
    {
      german: "die Mauer",
      translated: "Берлінський мур",
      tone: 'semantic',
    },
    {
      german: "für alle",
      translated: "для всіх",
      tone: 'semantic',
    },
    {
      german: "geöffnet",
      translated: "відкрили",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:191|vi": [
    {
      german: "Wann",
      translated: "Khi nào",
      tone: 'semantic',
    },
    {
      german: "wurde",
      translated: "được",
      tone: 'semantic',
    },
    {
      german: "die Mauer",
      translated: "Bức tường Berlin",
      tone: 'semantic',
    },
    {
      german: "für alle",
      translated: "cho tất cả mọi người",
      tone: 'semantic',
    },
    {
      german: "geöffnet",
      translated: "mở",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:192|ar": [
    {
      german: "Welches heutige deutsche Bundesland",
      translated: "أي ولاية اتحادية ألمانية حالية",
      tone: 'semantic',
    },
    {
      german: "gehörte früher",
      translated: "كانت سابقًا",
      tone: 'semantic',
    },
    {
      german: "zum Gebiet der DDR",
      translated: "ضمن أراضي DDR",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:192|bg": [
    {
      german: "Welches heutige deutsche Bundesland",
      translated: "Коя днешна германска федерална провинция",
      tone: 'semantic',
    },
    {
      german: "gehörte früher",
      translated: "е била",
      tone: 'semantic',
    },
    {
      german: "zum Gebiet der DDR",
      translated: "от ГДР?",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:192|bs": [
    {
      german: "Welches heutige deutsche Bundesland",
      translated: "Koja je današnja njemačka savezna zemlja",
      tone: 'semantic',
    },
    {
      german: "gehörte früher",
      translated: "prije pripadala",
      tone: 'semantic',
    },
    {
      german: "zum Gebiet der DDR",
      translated: "DDR-u",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:192|el": [
    {
      german: "Welches heutige deutsche Bundesland",
      translated: "Ποιο σημερινό γερμανικό κρατίδιο",
      tone: 'semantic',
    },
    {
      german: "gehörte früher",
      translated: "ανήκε παλαιότερα",
      tone: 'semantic',
    },
    {
      german: "zum Gebiet der DDR",
      translated: "στη ΛΔΓ;",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:192|en": [
    {
      german: "Welches heutige deutsche Bundesland",
      translated: "Which current German federal state",
      tone: 'semantic',
    },
    {
      german: "gehörte früher",
      translated: "formerly belonged to",
      tone: 'semantic',
    },
    {
      german: "zum Gebiet der DDR",
      translated: "the territory of the GDR",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:192|es": [
    {
      german: "Welches heutige deutsche Bundesland",
      translated: "¿Qué actual estado federado alemán",
      tone: 'semantic',
    },
    {
      german: "gehörte früher",
      translated: "pertenecía anteriormente",
      tone: 'semantic',
    },
    {
      german: "zum Gebiet der DDR",
      translated: "al territorio de la RDA",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:192|fa": [
    {
      german: "Welches heutige deutsche Bundesland",
      translated: "کدام ایالت امروزی آلمان",
      tone: 'semantic',
    },
    {
      german: "gehörte früher",
      translated: "پیش‌تر",
      tone: 'semantic',
    },
    {
      german: "zum Gebiet der DDR",
      translated: "بخشی از قلمرو جمهوری دموکراتیک آلمان",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:192|fr": [
    {
      german: "Welches heutige deutsche Bundesland",
      translated: "Quel Land allemand actuel",
      tone: 'semantic',
    },
    {
      german: "gehörte früher",
      translated: "faisait autrefois partie",
      tone: 'semantic',
    },
    {
      german: "zum Gebiet der DDR",
      translated: "du territoire de la RDA",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:192|hr": [
    {
      german: "Welches heutige deutsche Bundesland",
      translated: "Koja je današnja njemačka savezna zemlja",
      tone: 'semantic',
    },
    {
      german: "gehörte früher",
      translated: "prije pripadala",
      tone: 'semantic',
    },
    {
      german: "zum Gebiet der DDR",
      translated: "DDR-u",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:192|it": [
    {
      german: "Welches heutige deutsche Bundesland",
      translated: "Quale Land tedesco di oggi",
      tone: 'semantic',
    },
    {
      german: "gehörte früher",
      translated: "faceva in passato",
      tone: 'semantic',
    },
    {
      german: "zum Gebiet der DDR",
      translated: "parte della RDT",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:192|kmr": [
    {
      german: "Welches heutige deutsche Bundesland",
      translated: "Kîjan eyaleta federal a îro",
      tone: 'semantic',
    },
    {
      german: "gehörte früher",
      translated: "berê",
      tone: 'semantic',
    },
    {
      german: "zum Gebiet der DDR",
      translated: "di nav DDR de bû",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:192|pl": [
    {
      german: "Welches heutige deutsche Bundesland",
      translated: "Który dzisiejszy niemiecki kraj związkowy",
      tone: 'semantic',
    },
    {
      german: "gehörte früher",
      translated: "należał wcześniej",
      tone: 'semantic',
    },
    {
      german: "zum Gebiet der DDR",
      translated: "do NRD",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:192|prs": [
    {
      german: "Welches heutige deutsche Bundesland",
      translated: "کدام ایالت امروزی آلمان",
      tone: 'semantic',
    },
    {
      german: "gehörte früher",
      translated: "پیش‌تر",
      tone: 'semantic',
    },
    {
      german: "zum Gebiet der DDR",
      translated: "بخشی از قلمرو جمهوری دموکراتیک آلمان",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:192|ro": [
    {
      german: "Welches heutige deutsche Bundesland",
      translated: "Care land german de astăzi",
      tone: 'semantic',
    },
    {
      german: "gehörte früher",
      translated: "făcea parte anterior",
      tone: 'semantic',
    },
    {
      german: "zum Gebiet der DDR",
      translated: "din RDG",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:192|ru": [
    {
      german: "Welches heutige deutsche Bundesland",
      translated: "Какая из современных федеральных земель Германии",
      tone: 'semantic',
    },
    {
      german: "gehörte früher",
      translated: "раньше входила",
      tone: 'semantic',
    },
    {
      german: "zum Gebiet der DDR",
      translated: "в состав ГДР",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:192|sq": [
    {
      german: "Welches heutige deutsche Bundesland",
      translated: "Cili land i sotëm gjerman",
      tone: 'semantic',
    },
    {
      german: "gehörte früher",
      translated: "ishte pjesë e",
      tone: 'semantic',
    },
    {
      german: "zum Gebiet der DDR",
      translated: "RDGJ-së",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:192|sr": [
    {
      german: "Welches heutige deutsche Bundesland",
      translated: "Koja je današnja nemačka savezna pokrajina",
      tone: 'semantic',
    },
    {
      german: "gehörte früher",
      translated: "pre",
      tone: 'semantic',
    },
    {
      german: "zum Gebiet der DDR",
      translated: "DDR-u?",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:192|tr": [
    {
      german: "Welches heutige deutsche Bundesland",
      translated: "Günümüzdeki hangi Alman eyaleti",
      tone: 'semantic',
    },
    {
      german: "gehörte früher",
      translated: "eskiden",
      tone: 'semantic',
    },
    {
      german: "zum Gebiet der DDR",
      translated: "Doğu Almanya (DDR) topraklarındaydı",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:192|uk": [
    {
      german: "Welches heutige deutsche Bundesland",
      translated: "Яка сучасна федеральна земля Німеччини",
      tone: 'semantic',
    },
    {
      german: "gehörte früher",
      translated: "раніше входила",
      tone: 'semantic',
    },
    {
      german: "zum Gebiet der DDR",
      translated: "до території НДР",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:192|vi": [
    {
      german: "Welches heutige deutsche Bundesland",
      translated: "Bang nào của Đức ngày nay",
      tone: 'semantic',
    },
    {
      german: "gehörte früher",
      translated: "từng thuộc",
      tone: 'semantic',
    },
    {
      german: "zum Gebiet der DDR",
      translated: "CHDC Đức",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:193|ar": [
    {
      german: "Von 1961 bis 1989",
      translated: "من عام 1961 إلى عام 1989",
      tone: 'semantic',
    },
    {
      german: "war",
      translated: "كانت",
      tone: 'semantic',
    },
    {
      german: "Berlin",
      translated: "برلين",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:193|bg": [
    {
      german: "Von 1961 bis 1989",
      translated: "Между 1961 и 1989 г.",
      tone: 'semantic',
    },
    {
      german: "Berlin",
      translated: "Берлин",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:193|bs": [
    {
      german: "Von 1961 bis 1989",
      translated: "Od 1961. do 1989.",
      tone: 'semantic',
    },
    {
      german: "Berlin",
      translated: "Berlin",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:193|el": [
    {
      german: "Von 1961 bis 1989",
      translated: "Από το 1961 έως το 1989",
      tone: 'semantic',
    },
    {
      german: "war",
      translated: "το",
      tone: 'semantic',
    },
    {
      german: "Berlin",
      translated: "Βερολίνο",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:193|en": [
    {
      german: "Von 1961 bis 1989",
      translated: "From 1961 to 1989",
      tone: 'semantic',
    },
    {
      german: "war",
      translated: "was",
      tone: 'semantic',
    },
    {
      german: "Berlin",
      translated: "Berlin",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:193|es": [
    {
      german: "Von 1961 bis 1989",
      translated: "De 1961 a 1989",
      tone: 'semantic',
    },
    {
      german: "war",
      translated: "estuvo",
      tone: 'semantic',
    },
    {
      german: "Berlin",
      translated: "Berlín",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:193|fa": [
    {
      german: "Von 1961 bis 1989",
      translated: "از ۱۹۶۱ تا ۱۹۸۹",
      tone: 'semantic',
    },
    {
      german: "Berlin",
      translated: "برلین",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:193|fr": [
    {
      german: "Von 1961 bis 1989",
      translated: "De 1961 à 1989",
      tone: 'semantic',
    },
    {
      german: "Berlin",
      translated: "Berlin",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:193|hr": [
    {
      german: "Von 1961 bis 1989",
      translated: "Od 1961. do 1989.",
      tone: 'semantic',
    },
    {
      german: "Berlin",
      translated: "Berlin",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:193|it": [
    {
      german: "Von 1961 bis 1989",
      translated: "Dal 1961 al 1989",
      tone: 'semantic',
    },
    {
      german: "Berlin",
      translated: "Berlino",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:193|kmr": [
    {
      german: "Von 1961 bis 1989",
      translated: "Ji 1961 heta 1989",
      tone: 'semantic',
    },
    {
      german: "Berlin",
      translated: "Berlîn",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:193|pl": [
    {
      german: "Von 1961 bis 1989",
      translated: "W latach 1961–1989",
      tone: 'semantic',
    },
    {
      german: "Berlin",
      translated: "Berlin",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:193|prs": [
    {
      german: "Von 1961 bis 1989",
      translated: "از ۱۹۶۱ تا ۱۹۸۹",
      tone: 'semantic',
    },
    {
      german: "Berlin",
      translated: "برلین",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:193|ro": [
    {
      german: "Von 1961 bis 1989",
      translated: "Între 1961 și 1989",
      tone: 'semantic',
    },
    {
      german: "Berlin",
      translated: "Berlinul",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:193|ru": [
    {
      german: "Von 1961 bis 1989",
      translated: "С 1961 по 1989 год",
      tone: 'semantic',
    },
    {
      german: "war",
      translated: "был",
      tone: 'semantic',
    },
    {
      german: "Berlin",
      translated: "Берлин",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:193|sq": [
    {
      german: "Von 1961 bis 1989",
      translated: "Nga viti 1961 deri më 1989",
      tone: 'semantic',
    },
    {
      german: "Berlin",
      translated: "Berlini",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:193|sr": [
    {
      german: "Von 1961 bis 1989",
      translated: "Od 1961. do 1989.",
      tone: 'semantic',
    },
    {
      german: "Berlin",
      translated: "Berlin",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:193|tr": [
    {
      german: "Von 1961 bis 1989",
      translated: "1961-1989 yılları arasında",
      tone: 'semantic',
    },
    {
      german: "Berlin",
      translated: "Berlin",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:193|uk": [
    {
      german: "Von 1961 bis 1989",
      translated: "З 1961 до 1989 року",
      tone: 'semantic',
    },
    {
      german: "Berlin",
      translated: "Берлін",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:193|vi": [
    {
      german: "Von 1961 bis 1989",
      translated: "Từ năm 1961 đến 1989",
      tone: 'semantic',
    },
    {
      german: "Berlin",
      translated: "Berlin",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:194|ar": [
    {
      german: "Am 3. Oktober",
      translated: "في 3 أكتوبر/تشرين الأول",
      tone: 'semantic',
    },
    {
      german: "feiert man",
      translated: "تحتفل",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "ألمانيا",
      tone: 'semantic',
    },
    {
      german: "den Tag der Deutschen",
      translated: "بيوم … الألمانية",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:194|bg": [
    {
      german: "Am 3. Oktober",
      translated: "На 3 октомври",
      tone: 'semantic',
    },
    {
      german: "feiert man",
      translated: "празнува",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "Германия",
      tone: 'semantic',
    },
    {
      german: "den Tag der Deutschen",
      translated: "Деня на германското",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:194|bs": [
    {
      german: "Am 3. Oktober",
      translated: "3. oktobra",
      tone: 'semantic',
    },
    {
      german: "feiert man",
      translated: "slavi",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "Njemačka",
      tone: 'semantic',
    },
    {
      german: "den Tag der Deutschen",
      translated: "Dan njemačkog",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:194|el": [
    {
      german: "Am 3. Oktober",
      translated: "Στις 3 Οκτωβρίου",
      tone: 'semantic',
    },
    {
      german: "feiert man",
      translated: "γιορτάζει",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "η Γερμανία",
      tone: 'semantic',
    },
    {
      german: "den Tag der Deutschen",
      translated: "την Ημέρα της γερμανικής",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:194|en": [
    {
      german: "Am 3. Oktober",
      translated: "On October 3rd",
      tone: 'semantic',
    },
    {
      german: "feiert man",
      translated: "celebrates",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "Germany",
      tone: 'semantic',
    },
    {
      german: "den Tag der Deutschen",
      translated: "the Day of German",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:194|es": [
    {
      german: "Am 3. Oktober",
      translated: "El 3 de octubre",
      tone: 'semantic',
    },
    {
      german: "feiert man",
      translated: "celebra",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "Alemania",
      tone: 'semantic',
    },
    {
      german: "den Tag der Deutschen",
      translated: "Día de la … Alemana",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:194|fa": [
    {
      german: "Am 3. Oktober",
      translated: "در ۳ اکتبر،",
      tone: 'semantic',
    },
    {
      german: "feiert man",
      translated: " جشن می‌گیرد.",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "آلمان",
      tone: 'semantic',
    },
    {
      german: "den Tag der Deutschen",
      translated: "روز",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:194|fr": [
    {
      german: "Am 3. Oktober",
      translated: "Le 3 octobre,",
      tone: 'semantic',
    },
    {
      german: "feiert man",
      translated: "célèbre",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "l’Allemagne",
      tone: 'semantic',
    },
    {
      german: "den Tag der Deutschen",
      translated: "le Jour de l’… allemande.",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:194|hr": [
    {
      german: "Am 3. Oktober",
      translated: "3. listopada",
      tone: 'semantic',
    },
    {
      german: "feiert man",
      translated: "slavi",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "Njemačka",
      tone: 'semantic',
    },
    {
      german: "den Tag der Deutschen",
      translated: "Dan njemačkog",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:194|it": [
    {
      german: "Am 3. Oktober",
      translated: "Il 3 ottobre",
      tone: 'semantic',
    },
    {
      german: "feiert man",
      translated: "celebra",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "la Germania",
      tone: 'semantic',
    },
    {
      german: "den Tag der Deutschen",
      translated: "il Giorno dell’… tedesca.",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:194|kmr": [
    {
      german: "Am 3. Oktober",
      translated: "3ê Cotmehê",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "li Almanyayê",
      tone: 'semantic',
    },
    {
      german: "den Tag der Deutschen",
      translated: "Roja … ya Alman",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:194|pl": [
    {
      german: "Am 3. Oktober",
      translated: "3 października",
      tone: 'semantic',
    },
    {
      german: "feiert man",
      translated: "obchodzą",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "Niemcy",
      tone: 'semantic',
    },
    {
      german: "den Tag der Deutschen",
      translated: "Dzień Niemieckiej",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:194|prs": [
    {
      german: "Am 3. Oktober",
      translated: "در ۳ اکتبر،",
      tone: 'semantic',
    },
    {
      german: "feiert man",
      translated: "جشن می‌گیرد",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "آلمان",
      tone: 'semantic',
    },
    {
      german: "den Tag der Deutschen",
      translated: "روز … آلمان",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:194|ro": [
    {
      german: "Am 3. Oktober",
      translated: "La 3 octombrie,",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "Germania",
      tone: 'semantic',
    },
    {
      german: "den Tag der Deutschen",
      translated: "Ziua … Germane",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:194|ru": [
    {
      german: "Am 3. Oktober",
      translated: "3 октября",
      tone: 'semantic',
    },
    {
      german: "feiert man",
      translated: "празднуют",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "в Германии",
      tone: 'semantic',
    },
    {
      german: "den Tag der Deutschen",
      translated: "День немецкого",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:194|sq": [
    {
      german: "Am 3. Oktober",
      translated: "Më 3 tetor",
      tone: 'semantic',
    },
    {
      german: "feiert man",
      translated: "feston",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "Gjermania",
      tone: 'semantic',
    },
    {
      german: "den Tag der Deutschen",
      translated: "Ditën e … gjermane",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:194|sr": [
    {
      german: "Am 3. Oktober",
      translated: "3. oktobra",
      tone: 'semantic',
    },
    {
      german: "feiert man",
      translated: "slavi",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "Nemačka",
      tone: 'semantic',
    },
    {
      german: "den Tag der Deutschen",
      translated: "Dan nemačkog",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:194|tr": [
    {
      german: "Am 3. Oktober",
      translated: "3 Ekim'de",
      tone: 'semantic',
    },
    {
      german: "feiert man",
      translated: "kutlanır",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "Almanya'da",
      tone: 'semantic',
    },
    {
      german: "den Tag der Deutschen",
      translated: "Alman … Günü",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:194|uk": [
    {
      german: "Am 3. Oktober",
      translated: "3 жовтня",
      tone: 'semantic',
    },
    {
      german: "feiert man",
      translated: "відзначають",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "в Німеччині",
      tone: 'semantic',
    },
    {
      german: "den Tag der Deutschen",
      translated: "День німецької",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:194|vi": [
    {
      german: "Am 3. Oktober",
      translated: "Ngày 3 tháng 10",
      tone: 'semantic',
    },
    {
      german: "feiert man",
      translated: "kỷ niệm",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "Đức",
      tone: 'semantic',
    },
    {
      german: "den Tag der Deutschen",
      translated: "Ngày … của Đức",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:195|ar": [
    {
      german: "Welches heutige deutsche Bundesland",
      translated: "أي ولاية اتحادية ألمانية حالية",
      tone: 'semantic',
    },
    {
      german: "gehörte früher zum Gebiet der DDR",
      translated: "كانت سابقًا ضمن أراضي DDR",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:195|bg": [
    {
      german: "Welches heutige deutsche Bundesland",
      translated: "Коя днешна германска федерална провинция",
      tone: 'semantic',
    },
    {
      german: "gehörte früher zum Gebiet der DDR",
      translated: "е била част от ГДР",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:195|bs": [
    {
      german: "Welches heutige deutsche Bundesland",
      translated: "Koja je današnja njemačka savezna zemlja",
      tone: 'semantic',
    },
    {
      german: "gehörte früher zum Gebiet der DDR",
      translated: "prije pripadala DDR-u",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:195|el": [
    {
      german: "Welches heutige deutsche Bundesland",
      translated: "Ποιο σημερινό γερμανικό κρατίδιο",
      tone: 'semantic',
    },
    {
      german: "gehörte früher zum Gebiet der DDR",
      translated: "ανήκε παλαιότερα στη ΛΔΓ;",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:195|en": [
    {
      german: "Welches heutige deutsche Bundesland",
      translated: "Which current German federal state",
      tone: 'semantic',
    },
    {
      german: "gehörte früher zum Gebiet der DDR",
      translated: "formerly belonged to the territory of the GDR",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:195|es": [
    {
      german: "Welches heutige deutsche Bundesland",
      translated: "¿Qué actual estado federado alemán",
      tone: 'semantic',
    },
    {
      german: "gehörte früher zum Gebiet der DDR",
      translated: "pertenecía anteriormente al territorio de la RDA",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:195|fa": [
    {
      german: "Welches heutige deutsche Bundesland",
      translated: "کدام ایالت امروزی آلمان",
      tone: 'semantic',
    },
    {
      german: "gehörte früher zum Gebiet der DDR",
      translated: "پیش‌تر بخشی از قلمرو جمهوری دموکراتیک آلمان بود",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:195|fr": [
    {
      german: "Welches heutige deutsche Bundesland",
      translated: "Quel Land allemand actuel",
      tone: 'semantic',
    },
    {
      german: "gehörte früher zum Gebiet der DDR",
      translated: "faisait autrefois partie du territoire de la RDA",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:195|hr": [
    {
      german: "Welches heutige deutsche Bundesland",
      translated: "Koja je današnja njemačka savezna zemlja",
      tone: 'semantic',
    },
    {
      german: "gehörte früher zum Gebiet der DDR",
      translated: "prije pripadala DDR-u?",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:195|it": [
    {
      german: "Welches heutige deutsche Bundesland",
      translated: "Quale Land tedesco di oggi",
      tone: 'semantic',
    },
    {
      german: "gehörte früher zum Gebiet der DDR",
      translated: "faceva in passato parte della RDT",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:195|kmr": [
    {
      german: "Welches heutige deutsche Bundesland",
      translated: "Kîjan eyaleta federal a îro",
      tone: 'semantic',
    },
    {
      german: "gehörte früher zum Gebiet der DDR",
      translated: "berê di nav DDR de bû",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:195|pl": [
    {
      german: "Welches heutige deutsche Bundesland",
      translated: "Który dzisiejszy niemiecki kraj związkowy",
      tone: 'semantic',
    },
    {
      german: "gehörte früher zum Gebiet der DDR",
      translated: "należał wcześniej do NRD",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:195|prs": [
    {
      german: "Welches heutige deutsche Bundesland",
      translated: "کدام ایالت امروزی آلمان",
      tone: 'semantic',
    },
    {
      german: "gehörte früher zum Gebiet der DDR",
      translated: "پیش‌تر بخشی از قلمرو جمهوری دموکراتیک آلمان بود؟",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:195|ro": [
    {
      german: "Welches heutige deutsche Bundesland",
      translated: "Care land german de astăzi",
      tone: 'semantic',
    },
    {
      german: "gehörte früher zum Gebiet der DDR",
      translated: "făcea parte anterior din RDG?",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:195|ru": [
    {
      german: "Welches heutige deutsche Bundesland",
      translated: "Какая из современных федеральных земель Германии",
      tone: 'semantic',
    },
    {
      german: "gehörte früher zum Gebiet der DDR",
      translated: "раньше входила в состав ГДР",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:195|sq": [
    {
      german: "Welches heutige deutsche Bundesland",
      translated: "Cili land i sotëm gjerman",
      tone: 'semantic',
    },
    {
      german: "gehörte früher zum Gebiet der DDR",
      translated: "pjesë e RDGJ-së?",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:195|sr": [
    {
      german: "Welches heutige deutsche Bundesland",
      translated: "Koja je današnja nemačka savezna pokrajina",
      tone: 'semantic',
    },
    {
      german: "gehörte früher zum Gebiet der DDR",
      translated: "pre pripadala DDR-u",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:195|tr": [
    {
      german: "Welches heutige deutsche Bundesland",
      translated: "Günümüzdeki hangi Alman eyaleti",
      tone: 'semantic',
    },
    {
      german: "gehörte früher zum Gebiet der DDR",
      translated: "eskiden Doğu Almanya (DDR) topraklarındaydı",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:195|uk": [
    {
      german: "Welches heutige deutsche Bundesland",
      translated: "Яка сучасна федеральна земля Німеччини",
      tone: 'semantic',
    },
    {
      german: "gehörte früher zum Gebiet der DDR",
      translated: "раніше входила до території НДР",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:195|vi": [
    {
      german: "Welches heutige deutsche Bundesland",
      translated: "Bang nào của Đức ngày nay",
      tone: 'semantic',
    },
    {
      german: "gehörte früher zum Gebiet der DDR",
      translated: "từng thuộc CHDC Đức",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:196|ar": [
    {
      german: "Warum nennt man",
      translated: "لماذا يُسمى",
      tone: 'semantic',
    },
    {
      german: "die Zeit im Herbst 1989",
      translated: "خريف عام 1989",
      tone: 'semantic',
    },
    {
      german: "in der DDR",
      translated: "في DDR",
      tone: 'semantic',
    },
    {
      german: "\"Die Wende\"",
      translated: "«التحول» (Die Wende)",
      tone: 'semantic',
    },
    {
      german: "In dieser Zeit",
      translated: "خلال هذه الفترة",
      tone: 'semantic',
    },
    {
      german: "veränderte sich",
      translated: "تغير",
      tone: 'semantic',
    },
    {
      german: "die DDR",
      translated: "نظام DDR",
      tone: 'semantic',
    },
    {
      german: "politisch …",
      translated: "سياسيًا …",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:196|bg": [
    {
      german: "Warum nennt man",
      translated: "Защо",
      tone: 'semantic',
    },
    {
      german: "die Zeit im Herbst 1989",
      translated: "есента на 1989 г.",
      tone: 'semantic',
    },
    {
      german: "in der DDR",
      translated: "в ГДР",
      tone: 'semantic',
    },
    {
      german: "\"Die Wende\"",
      translated: "„Die Wende“",
      tone: 'semantic',
    },
    {
      german: "In dieser Zeit",
      translated: "През този период",
      tone: 'semantic',
    },
    {
      german: "veränderte sich",
      translated: "се променя",
      tone: 'semantic',
    },
    {
      german: "die DDR",
      translated: "ГДР",
      tone: 'semantic',
    },
    {
      german: "politisch …",
      translated: "политически …",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:196|bs": [
    {
      german: "Warum nennt man",
      translated: "Zašto se",
      tone: 'semantic',
    },
    {
      german: "die Zeit im Herbst 1989",
      translated: "jesen 1989",
      tone: 'semantic',
    },
    {
      german: "in der DDR",
      translated: "u DDR-u",
      tone: 'semantic',
    },
    {
      german: "\"Die Wende\"",
      translated: "„Die Wende“",
      tone: 'semantic',
    },
    {
      german: "In dieser Zeit",
      translated: "U to se vrijeme",
      tone: 'semantic',
    },
    {
      german: "veränderte sich",
      translated: "promijenio",
      tone: 'semantic',
    },
    {
      german: "die DDR",
      translated: "DDR",
      tone: 'semantic',
    },
    {
      german: "politisch …",
      translated: "politički",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:196|el": [
    {
      german: "Warum nennt man",
      translated: "Γιατί",
      tone: 'semantic',
    },
    {
      german: "die Zeit im Herbst 1989",
      translated: "το φθινόπωρο του 1989",
      tone: 'semantic',
    },
    {
      german: "in der DDR",
      translated: "στη ΛΔΓ",
      tone: 'semantic',
    },
    {
      german: "\"Die Wende\"",
      translated: "«Die Wende»",
      tone: 'semantic',
    },
    {
      german: "In dieser Zeit",
      translated: "Κατά την περίοδο αυτή",
      tone: 'semantic',
    },
    {
      german: "veränderte sich",
      translated: "μεταβλήθηκε",
      tone: 'semantic',
    },
    {
      german: "die DDR",
      translated: "η ΛΔΓ",
      tone: 'semantic',
    },
    {
      german: "politisch …",
      translated: "πολιτικά",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:196|en": [
    {
      german: "Warum nennt man",
      translated: "Why is",
      tone: 'semantic',
    },
    {
      german: "die Zeit im Herbst 1989",
      translated: "the period in autumn 1989",
      tone: 'semantic',
    },
    {
      german: "in der DDR",
      translated: "in the GDR",
      tone: 'semantic',
    },
    {
      german: "\"Die Wende\"",
      translated: "'Die Wende' (The Turn)",
      tone: 'semantic',
    },
    {
      german: "In dieser Zeit",
      translated: "During this time",
      tone: 'semantic',
    },
    {
      german: "veränderte sich",
      translated: "changed",
      tone: 'semantic',
    },
    {
      german: "die DDR",
      translated: "the GDR",
      tone: 'semantic',
    },
    {
      german: "politisch …",
      translated: "politically",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:196|es": [
    {
      german: "Warum nennt man",
      translated: "¿Por qué se llama",
      tone: 'semantic',
    },
    {
      german: "die Zeit im Herbst 1989",
      translated: "al período del otoño de 1989",
      tone: 'semantic',
    },
    {
      german: "in der DDR",
      translated: "en la RDA",
      tone: 'semantic',
    },
    {
      german: "\"Die Wende\"",
      translated: "«Die Wende» (el cambio)",
      tone: 'semantic',
    },
    {
      german: "In dieser Zeit",
      translated: "Durante ese tiempo",
      tone: 'semantic',
    },
    {
      german: "veränderte sich",
      translated: "cambió",
      tone: 'semantic',
    },
    {
      german: "die DDR",
      translated: "la RDA",
      tone: 'semantic',
    },
    {
      german: "politisch …",
      translated: "políticamente …",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:196|fa": [
    {
      german: "Warum nennt man",
      translated: "چرا",
      tone: 'semantic',
    },
    {
      german: "die Zeit im Herbst 1989",
      translated: "پاییز ۱۹۸۹",
      tone: 'semantic',
    },
    {
      german: "in der DDR",
      translated: "جمهوری دموکراتیک آلمان",
      tone: 'semantic',
    },
    {
      german: "\"Die Wende\"",
      translated: "«چرخش» (Die Wende)",
      tone: 'semantic',
    },
    {
      german: "In dieser Zeit",
      translated: "در این دوره",
      tone: 'semantic',
    },
    {
      german: "veränderte sich",
      translated: "تغییر کرد",
      tone: 'semantic',
    },
    {
      german: "die DDR",
      translated: "جمهوری دموکراتیک آلمان",
      tone: 'semantic',
    },
    {
      german: "politisch …",
      translated: "از نظر سیاسی",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:196|fr": [
    {
      german: "Warum nennt man",
      translated: "Pourquoi appelle-t-on",
      tone: 'semantic',
    },
    {
      german: "die Zeit im Herbst 1989",
      translated: "l’automne 1989",
      tone: 'semantic',
    },
    {
      german: "in der DDR",
      translated: "en RDA",
      tone: 'semantic',
    },
    {
      german: "\"Die Wende\"",
      translated: "« le tournant » (Die Wende)",
      tone: 'semantic',
    },
    {
      german: "In dieser Zeit",
      translated: "Pendant cette période",
      tone: 'semantic',
    },
    {
      german: "veränderte sich",
      translated: "a changé",
      tone: 'semantic',
    },
    {
      german: "die DDR",
      translated: "la RDA",
      tone: 'semantic',
    },
    {
      german: "politisch …",
      translated: "politiquement …",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:196|hr": [
    {
      german: "Warum nennt man",
      translated: "Zašto se",
      tone: 'semantic',
    },
    {
      german: "die Zeit im Herbst 1989",
      translated: "jesen 1989.",
      tone: 'semantic',
    },
    {
      german: "in der DDR",
      translated: "u DDR-u",
      tone: 'semantic',
    },
    {
      german: "\"Die Wende\"",
      translated: "„Die Wende“",
      tone: 'semantic',
    },
    {
      german: "In dieser Zeit",
      translated: "U to se vrijeme",
      tone: 'semantic',
    },
    {
      german: "veränderte sich",
      translated: "promijenio",
      tone: 'semantic',
    },
    {
      german: "die DDR",
      translated: "DDR",
      tone: 'semantic',
    },
    {
      german: "politisch …",
      translated: "politički",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:196|it": [
    {
      german: "Warum nennt man",
      translated: "Perché",
      tone: 'semantic',
    },
    {
      german: "die Zeit im Herbst 1989",
      translated: "l’autunno del 1989",
      tone: 'semantic',
    },
    {
      german: "in der DDR",
      translated: "nella RDT",
      tone: 'semantic',
    },
    {
      german: "\"Die Wende\"",
      translated: "«Die Wende»",
      tone: 'semantic',
    },
    {
      german: "In dieser Zeit",
      translated: "In quel periodo",
      tone: 'semantic',
    },
    {
      german: "veränderte sich",
      translated: "passò",
      tone: 'semantic',
    },
    {
      german: "die DDR",
      translated: "la RDT",
      tone: 'semantic',
    },
    {
      german: "politisch …",
      translated: "politicamente",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:196|kmr": [
    {
      german: "Warum nennt man",
      translated: "Çima",
      tone: 'semantic',
    },
    {
      german: "die Zeit im Herbst 1989",
      translated: "payîza 1989",
      tone: 'semantic',
    },
    {
      german: "in der DDR",
      translated: "li",
      tone: 'semantic',
    },
    {
      german: "\"Die Wende\"",
      translated: "«Die Wende»",
      tone: 'semantic',
    },
    {
      german: "die DDR",
      translated: "DDR",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:196|pl": [
    {
      german: "Warum nennt man",
      translated: "Dlaczego",
      tone: 'semantic',
    },
    {
      german: "die Zeit im Herbst 1989",
      translated: "jesień 1989 r.",
      tone: 'semantic',
    },
    {
      german: "in der DDR",
      translated: "w NRD",
      tone: 'semantic',
    },
    {
      german: "\"Die Wende\"",
      translated: "„Die Wende” (przełomem)",
      tone: 'semantic',
    },
    {
      german: "In dieser Zeit",
      translated: "W tym czasie",
      tone: 'semantic',
    },
    {
      german: "veränderte sich",
      translated: "zmieniła się",
      tone: 'semantic',
    },
    {
      german: "die DDR",
      translated: "NRD",
      tone: 'semantic',
    },
    {
      german: "politisch …",
      translated: "politycznie …",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:196|prs": [
    {
      german: "Warum nennt man",
      translated: "چرا",
      tone: 'semantic',
    },
    {
      german: "die Zeit im Herbst 1989",
      translated: "پاییز ۱۹۸۹",
      tone: 'semantic',
    },
    {
      german: "in der DDR",
      translated: "در جمهوری دموکراتیک آلمان",
      tone: 'semantic',
    },
    {
      german: "\"Die Wende\"",
      translated: "«چرخش» (Die Wende)",
      tone: 'semantic',
    },
    {
      german: "In dieser Zeit",
      translated: "در این دوره",
      tone: 'semantic',
    },
    {
      german: "veränderte sich",
      translated: "تغییر کرد",
      tone: 'semantic',
    },
    {
      german: "die DDR",
      translated: "جمهوری دموکراتیک آلمان",
      tone: 'semantic',
    },
    {
      german: "politisch …",
      translated: "از نظر سیاسی",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:196|ro": [
    {
      german: "Warum nennt man",
      translated: "De ce este numită",
      tone: 'semantic',
    },
    {
      german: "die Zeit im Herbst 1989",
      translated: "toamna anului 1989",
      tone: 'semantic',
    },
    {
      german: "in der DDR",
      translated: "în RDG",
      tone: 'semantic',
    },
    {
      german: "\"Die Wende\"",
      translated: "„Die Wende” (schimbarea)",
      tone: 'semantic',
    },
    {
      german: "In dieser Zeit",
      translated: "În această perioadă",
      tone: 'semantic',
    },
    {
      german: "veränderte sich",
      translated: "s-a schimbat",
      tone: 'semantic',
    },
    {
      german: "die DDR",
      translated: "RDG",
      tone: 'semantic',
    },
    {
      german: "politisch …",
      translated: "politic …",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:196|ru": [
    {
      german: "Warum nennt man",
      translated: "Почему",
      tone: 'semantic',
    },
    {
      german: "die Zeit im Herbst 1989",
      translated: "период осени 1989 года",
      tone: 'semantic',
    },
    {
      german: "in der DDR",
      translated: "в ГДР",
      tone: 'semantic',
    },
    {
      german: "\"Die Wende\"",
      translated: "«поворотом» (Wende)",
      tone: 'semantic',
    },
    {
      german: "In dieser Zeit",
      translated: "В это время",
      tone: 'semantic',
    },
    {
      german: "veränderte sich",
      translated: "изменилась",
      tone: 'semantic',
    },
    {
      german: "die DDR",
      translated: "ГДР",
      tone: 'semantic',
    },
    {
      german: "politisch …",
      translated: "политически",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:196|sq": [
    {
      german: "Warum nennt man",
      translated: "Pse vjeshta",
      tone: 'semantic',
    },
    {
      german: "die Zeit im Herbst 1989",
      translated: "e vitit 1989",
      tone: 'semantic',
    },
    {
      german: "in der DDR",
      translated: "në RDGJ",
      tone: 'semantic',
    },
    {
      german: "\"Die Wende\"",
      translated: "«Die Wende»",
      tone: 'semantic',
    },
    {
      german: "In dieser Zeit",
      translated: "Në këtë periudhë",
      tone: 'semantic',
    },
    {
      german: "veränderte sich",
      translated: "ndryshoi",
      tone: 'semantic',
    },
    {
      german: "die DDR",
      translated: "RDGJ-ja",
      tone: 'semantic',
    },
    {
      german: "politisch …",
      translated: "politikisht",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:196|sr": [
    {
      german: "Warum nennt man",
      translated: "Zašta se",
      tone: 'semantic',
    },
    {
      german: "die Zeit im Herbst 1989",
      translated: "jesen 1989",
      tone: 'semantic',
    },
    {
      german: "in der DDR",
      translated: "u DDR-u",
      tone: 'semantic',
    },
    {
      german: "\"Die Wende\"",
      translated: "„Die Wende“",
      tone: 'semantic',
    },
    {
      german: "In dieser Zeit",
      translated: "U to se vrijeme",
      tone: 'semantic',
    },
    {
      german: "veränderte sich",
      translated: "promijenio",
      tone: 'semantic',
    },
    {
      german: "die DDR",
      translated: "DDR",
      tone: 'semantic',
    },
    {
      german: "politisch …",
      translated: "politički",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:196|tr": [
    {
      german: "Warum nennt man",
      translated: "neden",
      tone: 'semantic',
    },
    {
      german: "die Zeit im Herbst 1989",
      translated: "1989 sonbaharındaki döneme",
      tone: 'semantic',
    },
    {
      german: "in der DDR",
      translated: "Doğu Almanya'da",
      tone: 'semantic',
    },
    {
      german: "\"Die Wende\"",
      translated: "\"Dönüşüm\" (Die Wende)",
      tone: 'semantic',
    },
    {
      german: "In dieser Zeit",
      translated: "Bu dönemde",
      tone: 'semantic',
    },
    {
      german: "veränderte sich",
      translated: "dönüştü",
      tone: 'semantic',
    },
    {
      german: "die DDR",
      translated: "Doğu Almanya",
      tone: 'semantic',
    },
    {
      german: "politisch …",
      translated: "siyasi olarak …",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:196|uk": [
    {
      german: "Warum nennt man",
      translated: "Чому",
      tone: 'semantic',
    },
    {
      german: "die Zeit im Herbst 1989",
      translated: "період восени 1989 року",
      tone: 'semantic',
    },
    {
      german: "in der DDR",
      translated: "в НДР",
      tone: 'semantic',
    },
    {
      german: "\"Die Wende\"",
      translated: "називають «поворотом» (Die Wende",
      tone: 'semantic',
    },
    {
      german: "In dieser Zeit",
      translated: "У цей час",
      tone: 'semantic',
    },
    {
      german: "veränderte sich",
      translated: "змінилася",
      tone: 'semantic',
    },
    {
      german: "die DDR",
      translated: "НДР",
      tone: 'semantic',
    },
    {
      german: "politisch …",
      translated: "політично",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:196|vi": [
    {
      german: "Warum nennt man",
      translated: "Tại sao",
      tone: 'semantic',
    },
    {
      german: "die Zeit im Herbst 1989",
      translated: "mùa thu năm 1989",
      tone: 'semantic',
    },
    {
      german: "in der DDR",
      translated: "ở CHDC Đức",
      tone: 'semantic',
    },
    {
      german: "\"Die Wende\"",
      translated: "“Die Wende”",
      tone: 'semantic',
    },
    {
      german: "In dieser Zeit",
      translated: "Trong thời gian này",
      tone: 'semantic',
    },
    {
      german: "veränderte sich",
      translated: "chuyển đổi",
      tone: 'semantic',
    },
    {
      german: "die DDR",
      translated: "CHDC Đức",
      tone: 'semantic',
    },
    {
      german: "politisch …",
      translated: "về chính trị",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:197|ar": [
    {
      german: "Welches",
      translated: "أي",
      tone: 'semantic',
    },
    {
      german: "heutige deutsche Bundesland",
      translated: "ولاية اتحادية ألمانية حالية",
      tone: 'semantic',
    },
    {
      german: "gehörte früher",
      translated: "كانت سابقًا",
      tone: 'semantic',
    },
    {
      german: "zum Gebiet der DDR",
      translated: "ضمن أراضي DDR؟",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:197|bg": [
    {
      german: "Welches",
      translated: "Коя",
      tone: 'semantic',
    },
    {
      german: "heutige deutsche Bundesland",
      translated: "днешна германска федерална провинция",
      tone: 'semantic',
    },
    {
      german: "gehörte früher",
      translated: "е била",
      tone: 'semantic',
    },
    {
      german: "zum Gebiet der DDR",
      translated: "част от ГДР?",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:197|bs": [
    {
      german: "Welches",
      translated: "Koja",
      tone: 'semantic',
    },
    {
      german: "heutige deutsche Bundesland",
      translated: "današnja njemačka savezna zemlja",
      tone: 'semantic',
    },
    {
      german: "gehörte früher",
      translated: "prije",
      tone: 'semantic',
    },
    {
      german: "zum Gebiet der DDR",
      translated: "pripadala DDR-u",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:197|el": [
    {
      german: "Welches",
      translated: "Ποιο",
      tone: 'semantic',
    },
    {
      german: "heutige deutsche Bundesland",
      translated: "σημερινό γερμανικό κρατίδιο",
      tone: 'semantic',
    },
    {
      german: "gehörte früher",
      translated: "ανήκε παλαιότερα",
      tone: 'semantic',
    },
    {
      german: "zum Gebiet der DDR",
      translated: "στη ΛΔΓ",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:197|en": [
    {
      german: "Welches",
      translated: "Which",
      tone: 'semantic',
    },
    {
      german: "heutige deutsche Bundesland",
      translated: "current German federal state",
      tone: 'semantic',
    },
    {
      german: "gehörte früher",
      translated: "formerly belonged to",
      tone: 'semantic',
    },
    {
      german: "zum Gebiet der DDR",
      translated: "the territory of the GDR?",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:197|es": [
    {
      german: "Welches",
      translated: "Qué",
      tone: 'semantic',
    },
    {
      german: "heutige deutsche Bundesland",
      translated: "actual estado federado alemán",
      tone: 'semantic',
    },
    {
      german: "gehörte früher",
      translated: "pertenecía anteriormente",
      tone: 'semantic',
    },
    {
      german: "zum Gebiet der DDR",
      translated: "al territorio de la RDA",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:197|fa": [
    {
      german: "Welches",
      translated: "کدام",
      tone: 'semantic',
    },
    {
      german: "heutige deutsche Bundesland",
      translated: "ایالت امروزی آلمان",
      tone: 'semantic',
    },
    {
      german: "gehörte früher",
      translated: "پیش‌تر",
      tone: 'semantic',
    },
    {
      german: "zum Gebiet der DDR",
      translated: "بخشی از قلمرو جمهوری دموکراتیک آلمان",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:197|fr": [
    {
      german: "Welches",
      translated: "Quel",
      tone: 'semantic',
    },
    {
      german: "heutige deutsche Bundesland",
      translated: "Land allemand actuel",
      tone: 'semantic',
    },
    {
      german: "gehörte früher",
      translated: "faisait autrefois partie",
      tone: 'semantic',
    },
    {
      german: "zum Gebiet der DDR",
      translated: "du territoire de la RDA",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:197|hr": [
    {
      german: "Welches",
      translated: "Koja",
      tone: 'semantic',
    },
    {
      german: "heutige deutsche Bundesland",
      translated: "današnja njemačka savezna zemlja",
      tone: 'semantic',
    },
    {
      german: "gehörte früher",
      translated: "prije pripadala",
      tone: 'semantic',
    },
    {
      german: "zum Gebiet der DDR",
      translated: "DDR-u?",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:197|it": [
    {
      german: "Welches",
      translated: "Quale",
      tone: 'semantic',
    },
    {
      german: "heutige deutsche Bundesland",
      translated: "Land tedesco di oggi",
      tone: 'semantic',
    },
    {
      german: "gehörte früher",
      translated: "faceva in passato",
      tone: 'semantic',
    },
    {
      german: "zum Gebiet der DDR",
      translated: "parte della RDT",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:197|kmr": [
    {
      german: "Welches",
      translated: "Kîjan",
      tone: 'semantic',
    },
    {
      german: "heutige deutsche Bundesland",
      translated: "eyaleta federal a îro berê",
      tone: 'semantic',
    },
    {
      german: "gehörte früher",
      translated: "de bû",
      tone: 'semantic',
    },
    {
      german: "zum Gebiet der DDR",
      translated: "di nav DDR",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:197|pl": [
    {
      german: "Welches",
      translated: "Który",
      tone: 'semantic',
    },
    {
      german: "heutige deutsche Bundesland",
      translated: "dzisiejszy niemiecki kraj związkowy",
      tone: 'semantic',
    },
    {
      german: "gehörte früher",
      translated: "należał wcześniej",
      tone: 'semantic',
    },
    {
      german: "zum Gebiet der DDR",
      translated: "do NRD",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:197|prs": [
    {
      german: "Welches",
      translated: "کدام",
      tone: 'semantic',
    },
    {
      german: "heutige deutsche Bundesland",
      translated: "ایالت امروزی آلمان",
      tone: 'semantic',
    },
    {
      german: "gehörte früher",
      translated: "پیش‌تر",
      tone: 'semantic',
    },
    {
      german: "zum Gebiet der DDR",
      translated: "بخشی از قلمرو جمهوری دموکراتیک آلمان",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:197|ro": [
    {
      german: "Welches",
      translated: "Care",
      tone: 'semantic',
    },
    {
      german: "heutige deutsche Bundesland",
      translated: "land german de astăzi",
      tone: 'semantic',
    },
    {
      german: "gehörte früher",
      translated: "făcea parte anterior",
      tone: 'semantic',
    },
    {
      german: "zum Gebiet der DDR",
      translated: "din RDG",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:197|ru": [
    {
      german: "Welches",
      translated: "Какая",
      tone: 'semantic',
    },
    {
      german: "heutige deutsche Bundesland",
      translated: "современных федеральных земель Германии",
      tone: 'semantic',
    },
    {
      german: "gehörte früher",
      translated: "раньше входила",
      tone: 'semantic',
    },
    {
      german: "zum Gebiet der DDR",
      translated: "в состав ГДР",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:197|sq": [
    {
      german: "Welches",
      translated: "Cili",
      tone: 'semantic',
    },
    {
      german: "heutige deutsche Bundesland",
      translated: "land i sotëm gjerman",
      tone: 'semantic',
    },
    {
      german: "gehörte früher",
      translated: "ishte pjesë e",
      tone: 'semantic',
    },
    {
      german: "zum Gebiet der DDR",
      translated: "RDGJ-së",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:197|sr": [
    {
      german: "Welches",
      translated: "Koja",
      tone: 'semantic',
    },
    {
      german: "heutige deutsche Bundesland",
      translated: "današnja nemačka savezna pokrajina",
      tone: 'semantic',
    },
    {
      german: "gehörte früher",
      translated: "pre pripadala",
      tone: 'semantic',
    },
    {
      german: "zum Gebiet der DDR",
      translated: "DDR-u",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:197|tr": [
    {
      german: "Welches",
      translated: "Günümüzdeki hangi",
      tone: 'semantic',
    },
    {
      german: "heutige deutsche Bundesland",
      translated: "Alman eyaleti",
      tone: 'semantic',
    },
    {
      german: "gehörte früher",
      translated: "eskiden",
      tone: 'semantic',
    },
    {
      german: "zum Gebiet der DDR",
      translated: "Doğu Almanya (DDR) topraklarındaydı",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:197|uk": [
    {
      german: "Welches",
      translated: "Яка",
      tone: 'semantic',
    },
    {
      german: "heutige deutsche Bundesland",
      translated: "сучасна федеральна земля Німеччини",
      tone: 'semantic',
    },
    {
      german: "gehörte früher",
      translated: "раніше входила",
      tone: 'semantic',
    },
    {
      german: "zum Gebiet der DDR",
      translated: "до території НДР",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:197|vi": [
    {
      german: "Welches",
      translated: "Bang nào",
      tone: 'semantic',
    },
    {
      german: "heutige deutsche Bundesland",
      translated: "Đức ngày nay",
      tone: 'semantic',
    },
    {
      german: "gehörte früher",
      translated: "từng thuộc",
      tone: 'semantic',
    },
    {
      german: "zum Gebiet der DDR",
      translated: "CHDC Đức",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:198|ar": [
    {
      german: "Welches heutige deutsche Bundesland",
      translated: "أي ولاية اتحادية ألمانية حالية",
      tone: 'semantic',
    },
    {
      german: "gehörte früher",
      translated: "كانت سابقًا",
      tone: 'semantic',
    },
    {
      german: "zum Gebiet der DDR",
      translated: "ضمن أراضي DDR",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:198|bg": [
    {
      german: "Welches heutige deutsche Bundesland",
      translated: "Коя днешна германска федерална провинция",
      tone: 'semantic',
    },
    {
      german: "gehörte früher",
      translated: "е била",
      tone: 'semantic',
    },
    {
      german: "zum Gebiet der DDR",
      translated: "част от ГДР",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:198|bs": [
    {
      german: "Welches heutige deutsche Bundesland",
      translated: "Koja je današnja njemačka savezna zemlja",
      tone: 'semantic',
    },
    {
      german: "gehörte früher",
      translated: "prije pripadala",
      tone: 'semantic',
    },
    {
      german: "zum Gebiet der DDR",
      translated: "DDR-u",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:198|el": [
    {
      german: "Welches heutige deutsche Bundesland",
      translated: "Ποιο σημερινό γερμανικό κρατίδιο",
      tone: 'semantic',
    },
    {
      german: "gehörte früher",
      translated: "ανήκε παλαιότερα",
      tone: 'semantic',
    },
    {
      german: "zum Gebiet der DDR",
      translated: "στη ΛΔΓ;",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:198|en": [
    {
      german: "Welches heutige deutsche Bundesland",
      translated: "Which current German federal state",
      tone: 'semantic',
    },
    {
      german: "gehörte früher",
      translated: "formerly belonged to",
      tone: 'semantic',
    },
    {
      german: "zum Gebiet der DDR",
      translated: "the territory of the GDR",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:198|es": [
    {
      german: "Welches heutige deutsche Bundesland",
      translated: "¿Qué actual estado federado alemán",
      tone: 'semantic',
    },
    {
      german: "gehörte früher",
      translated: "pertenecía anteriormente",
      tone: 'semantic',
    },
    {
      german: "zum Gebiet der DDR",
      translated: "al territorio de la RDA",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:198|fa": [
    {
      german: "Welches heutige deutsche Bundesland",
      translated: "کدام ایالت امروزی آلمان",
      tone: 'semantic',
    },
    {
      german: "gehörte früher",
      translated: "پیش‌تر",
      tone: 'semantic',
    },
    {
      german: "zum Gebiet der DDR",
      translated: "بخشی از قلمرو جمهوری دموکراتیک آلمان",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:198|fr": [
    {
      german: "Welches heutige deutsche Bundesland",
      translated: "Quel Land allemand actuel",
      tone: 'semantic',
    },
    {
      german: "gehörte früher",
      translated: "faisait autrefois",
      tone: 'semantic',
    },
    {
      german: "zum Gebiet der DDR",
      translated: "du territoire de la RDA",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:198|hr": [
    {
      german: "Welches heutige deutsche Bundesland",
      translated: "Koja je današnja njemačka savezna zemlja",
      tone: 'semantic',
    },
    {
      german: "gehörte früher",
      translated: "prije pripadala",
      tone: 'semantic',
    },
    {
      german: "zum Gebiet der DDR",
      translated: "DDR-u?",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:198|it": [
    {
      german: "Welches heutige deutsche Bundesland",
      translated: "Quale Land tedesco di oggi",
      tone: 'semantic',
    },
    {
      german: "gehörte früher",
      translated: "faceva in passato",
      tone: 'semantic',
    },
    {
      german: "zum Gebiet der DDR",
      translated: "parte della RDT",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:198|kmr": [
    {
      german: "Welches heutige deutsche Bundesland",
      translated: "Kîjan eyaleta federal a îro",
      tone: 'semantic',
    },
    {
      german: "gehörte früher",
      translated: "berê",
      tone: 'semantic',
    },
    {
      german: "zum Gebiet der DDR",
      translated: "di nav DDR de bû",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:198|pl": [
    {
      german: "Welches heutige deutsche Bundesland",
      translated: "Który dzisiejszy niemiecki kraj związkowy",
      tone: 'semantic',
    },
    {
      german: "gehörte früher",
      translated: "należał wcześniej",
      tone: 'semantic',
    },
    {
      german: "zum Gebiet der DDR",
      translated: "do NRD",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:198|prs": [
    {
      german: "Welches heutige deutsche Bundesland",
      translated: "کدام ایالت امروزی آلمان",
      tone: 'semantic',
    },
    {
      german: "gehörte früher",
      translated: "پیش‌تر",
      tone: 'semantic',
    },
    {
      german: "zum Gebiet der DDR",
      translated: "بخشی از قلمرو جمهوری دموکراتیک آلمان",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:198|ro": [
    {
      german: "Welches heutige deutsche Bundesland",
      translated: "Care land german de astăzi",
      tone: 'semantic',
    },
    {
      german: "gehörte früher",
      translated: "făcea parte anterior",
      tone: 'semantic',
    },
    {
      german: "zum Gebiet der DDR",
      translated: "din RDG",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:198|ru": [
    {
      german: "Welches heutige deutsche Bundesland",
      translated: "Какая из современных федеральных земель Германии",
      tone: 'semantic',
    },
    {
      german: "gehörte früher",
      translated: "раньше входила",
      tone: 'semantic',
    },
    {
      german: "zum Gebiet der DDR",
      translated: "в состав ГДР",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:198|sq": [
    {
      german: "Welches heutige deutsche Bundesland",
      translated: "Cili land i sotëm gjerman",
      tone: 'semantic',
    },
    {
      german: "gehörte früher",
      translated: "ishte pjesë e",
      tone: 'semantic',
    },
    {
      german: "zum Gebiet der DDR",
      translated: "RDGJ-së",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:198|sr": [
    {
      german: "Welches heutige deutsche Bundesland",
      translated: "Koja je današnja nemačka savezna pokrajina",
      tone: 'semantic',
    },
    {
      german: "gehörte früher",
      translated: "pre pripadala",
      tone: 'semantic',
    },
    {
      german: "zum Gebiet der DDR",
      translated: "DDR-u?",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:198|tr": [
    {
      german: "Welches heutige deutsche Bundesland",
      translated: "Günümüzdeki hangi Alman eyaleti",
      tone: 'semantic',
    },
    {
      german: "gehörte früher",
      translated: "eskiden",
      tone: 'semantic',
    },
    {
      german: "zum Gebiet der DDR",
      translated: "Doğu Almanya (DDR) topraklarındaydı",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:198|uk": [
    {
      german: "Welches heutige deutsche Bundesland",
      translated: "Яка сучасна федеральна земля Німеччини",
      tone: 'semantic',
    },
    {
      german: "gehörte früher",
      translated: "раніше входила",
      tone: 'semantic',
    },
    {
      german: "zum Gebiet der DDR",
      translated: "до території НДР",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:198|vi": [
    {
      german: "Welches heutige deutsche Bundesland",
      translated: "Bang nào của Đức ngày nay",
      tone: 'semantic',
    },
    {
      german: "gehörte früher",
      translated: "từng thuộc",
      tone: 'semantic',
    },
    {
      german: "zum Gebiet der DDR",
      translated: "CHDC Đức",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:199|ar": [
    {
      german: "Mit der Abkürzung",
      translated: "ماذا كان المقصود في DDR بالاختصار",
      tone: 'semantic',
    },
    {
      german: "\"Stasi\"",
      translated: "«Stasi»",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:199|bg": [
    {
      german: "Mit der Abkürzung",
      translated: "съкращението",
      tone: 'semantic',
    },
    {
      german: "\"Stasi\"",
      translated: "„Stasi“",
      tone: 'semantic',
    },
    {
      german: "meinte man",
      translated: "Какво означава",
      tone: 'semantic',
    },
    {
      german: "in der DDR",
      translated: "в ГДР",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:199|bs": [
    {
      german: "Mit der Abkürzung",
      translated: "Na što se",
      tone: 'semantic',
    },
    {
      german: "\"Stasi\"",
      translated: "„Stasi“",
      tone: 'semantic',
    },
    {
      german: "meinte man",
      translated: "odnosila",
      tone: 'semantic',
    },
    {
      german: "in der DDR",
      translated: "u DDR-u",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:199|el": [
    {
      german: "Mit der Abkürzung",
      translated: "η συντομογραφία",
      tone: 'semantic',
    },
    {
      german: "\"Stasi\"",
      translated: "«Stasi»",
      tone: 'semantic',
    },
    {
      german: "meinte man",
      translated: "Σε τι αναφερόταν",
      tone: 'semantic',
    },
    {
      german: "in der DDR",
      translated: "στη ΛΔΓ",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:199|en": [
    {
      german: "Mit der Abkürzung",
      translated: "The abbreviation",
      tone: 'semantic',
    },
    {
      german: "\"Stasi\"",
      translated: "'Stasi'",
      tone: 'semantic',
    },
    {
      german: "meinte man",
      translated: "referred to",
      tone: 'semantic',
    },
    {
      german: "in der DDR",
      translated: "in the GDR",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:199|es": [
    {
      german: "Mit der Abkürzung",
      translated: "la abreviatura",
      tone: 'semantic',
    },
    {
      german: "\"Stasi\"",
      translated: "«Stasi»",
      tone: 'semantic',
    },
    {
      german: "meinte man",
      translated: "se refería",
      tone: 'semantic',
    },
    {
      german: "in der DDR",
      translated: "En la RDA",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:199|fa": [
    {
      german: "Mit der Abkürzung",
      translated: "مخفف",
      tone: 'semantic',
    },
    {
      german: "\"Stasi\"",
      translated: "«Stasi»",
      tone: 'semantic',
    },
    {
      german: "meinte man",
      translated: "اشاره داشت",
      tone: 'semantic',
    },
    {
      german: "in der DDR",
      translated: "در جمهوری دموکراتیک آلمان",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:199|fr": [
    {
      german: "Mit der Abkürzung",
      translated: "l’abréviation",
      tone: 'semantic',
    },
    {
      german: "\"Stasi\"",
      translated: "« Stasi »",
      tone: 'semantic',
    },
    {
      german: "meinte man",
      translated: "désignait",
      tone: 'semantic',
    },
    {
      german: "in der DDR",
      translated: "En RDA",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:199|hr": [
    {
      german: "Mit der Abkürzung",
      translated: "Na što se odnosila kratica",
      tone: 'semantic',
    },
    {
      german: "\"Stasi\"",
      translated: "„Stasi“",
      tone: 'semantic',
    },
    {
      german: "in der DDR",
      translated: "u DDR-u",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:199|it": [
    {
      german: "Mit der Abkürzung",
      translated: "l’abbreviazione",
      tone: 'semantic',
    },
    {
      german: "\"Stasi\"",
      translated: "«Stasi»",
      tone: 'semantic',
    },
    {
      german: "meinte man",
      translated: "A che cosa si riferiva",
      tone: 'semantic',
    },
    {
      german: "in der DDR",
      translated: "nella RDT",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:199|kmr": [
    {
      german: "Mit der Abkürzung",
      translated: "kurteya",
      tone: 'semantic',
    },
    {
      german: "\"Stasi\"",
      translated: "«Stasi»",
      tone: 'semantic',
    },
    {
      german: "in der DDR",
      translated: "Li DDR",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:199|pl": [
    {
      german: "Mit der Abkürzung",
      translated: "skrót",
      tone: 'semantic',
    },
    {
      german: "\"Stasi\"",
      translated: "„Stasi”",
      tone: 'semantic',
    },
    {
      german: "meinte man",
      translated: "odnosił się",
      tone: 'semantic',
    },
    {
      german: "in der DDR",
      translated: "w NRD?",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:199|prs": [
    {
      german: "Mit der Abkürzung",
      translated: "مخفف",
      tone: 'semantic',
    },
    {
      german: "\"Stasi\"",
      translated: "«Stasi»",
      tone: 'semantic',
    },
    {
      german: "meinte man",
      translated: "اشاره داشت",
      tone: 'semantic',
    },
    {
      german: "in der DDR",
      translated: "جمهوری دموکراتیک آلمان",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:199|ro": [
    {
      german: "Mit der Abkürzung",
      translated: "abrevierea",
      tone: 'semantic',
    },
    {
      german: "\"Stasi\"",
      translated: "„Stasi”",
      tone: 'semantic',
    },
    {
      german: "meinte man",
      translated: "La ce se referea",
      tone: 'semantic',
    },
    {
      german: "in der DDR",
      translated: "în RDG",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:199|ru": [
    {
      german: "Mit der Abkürzung",
      translated: "Аббревиатурой",
      tone: 'semantic',
    },
    {
      german: "\"Stasi\"",
      translated: "«Штази»",
      tone: 'semantic',
    },
    {
      german: "meinte man",
      translated: "называли",
      tone: 'semantic',
    },
    {
      german: "in der DDR",
      translated: "в ГДР",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:199|sq": [
    {
      german: "Mit der Abkürzung",
      translated: "shkurtesa",
      tone: 'semantic',
    },
    {
      german: "\"Stasi\"",
      translated: "Stasi",
      tone: 'semantic',
    },
    {
      german: "meinte man",
      translated: "do të thoshte",
      tone: 'semantic',
    },
    {
      german: "in der DDR",
      translated: "në RDGJ",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:199|sr": [
    {
      german: "Mit der Abkürzung",
      translated: "Na šta se odnosila kratica",
      tone: 'semantic',
    },
    {
      german: "in der DDR",
      translated: "u DDR-u",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:199|tr": [
    {
      german: "Mit der Abkürzung",
      translated: "denildiğinde",
      tone: 'semantic',
    },
    {
      german: "\"Stasi\"",
      translated: "\"Stasi\"",
      tone: 'semantic',
    },
    {
      german: "meinte man",
      translated: "kastediliyordu",
      tone: 'semantic',
    },
    {
      german: "in der DDR",
      translated: "Doğu Almanya'da",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:199|uk": [
    {
      german: "Mit der Abkürzung",
      translated: "Під скороченням",
      tone: 'semantic',
    },
    {
      german: "\"Stasi\"",
      translated: "«Stasi»",
      tone: 'semantic',
    },
    {
      german: "meinte man",
      translated: "мали на увазі",
      tone: 'semantic',
    },
    {
      german: "in der DDR",
      translated: "у НДР",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:199|vi": [
    {
      german: "Mit der Abkürzung",
      translated: "chữ viết tắt",
      tone: 'semantic',
    },
    {
      german: "\"Stasi\"",
      translated: "“Stasi”",
      tone: 'semantic',
    },
    {
      german: "meinte man",
      translated: "chỉ gì",
      tone: 'semantic',
    },
    {
      german: "in der DDR",
      translated: "Ở CHDC Đức",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:19|ar": [
    {
      german: "Was versteht man",
      translated: "ماذا يُقصد",
      tone: 'semantic',
    },
    {
      german: "unter dem Recht",
      translated: "بحق",
      tone: 'semantic',
    },
    {
      german: "der \"Freizügigkeit\"",
      translated: "«حرية التنقل والإقامة» (Freizügigkeit)",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "في ألمانيا",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:19|bg": [
    {
      german: "Was versteht man",
      translated: "Какво означава",
      tone: 'semantic',
    },
    {
      german: "unter dem Recht",
      translated: "правото на",
      tone: 'semantic',
    },
    {
      german: "der \"Freizügigkeit\"",
      translated: "„свободно придвижване“ (Freizügigkeit)",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "в Германия",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:19|bs": [
    {
      german: "Was versteht man",
      translated: "Što",
      tone: 'semantic',
    },
    {
      german: "unter dem Recht",
      translated: "znači pravo na",
      tone: 'semantic',
    },
    {
      german: "der \"Freizügigkeit\"",
      translated: "„slobodu kretanja“ (Freizügigkeit)",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "u Njemačkoj",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:19|el": [
    {
      german: "Was versteht man",
      translated: "Τι σημαίνει",
      tone: 'semantic',
    },
    {
      german: "unter dem Recht",
      translated: "το δικαίωμα",
      tone: 'semantic',
    },
    {
      german: "der \"Freizügigkeit\"",
      translated: "της «ελεύθερης μετακίνησης» (Freizügigkeit)",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "στη Γερμανία",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:19|en": [
    {
      german: "Was versteht man",
      translated: "What is meant by",
      tone: 'semantic',
    },
    {
      german: "unter dem Recht",
      translated: "the right of",
      tone: 'semantic',
    },
    {
      german: "der \"Freizügigkeit\"",
      translated: "'freedom of movement'",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "in Germany?",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:19|es": [
    {
      german: "Was versteht man",
      translated: "¿Qué se entiende por",
      tone: 'semantic',
    },
    {
      german: "unter dem Recht",
      translated: "el derecho de",
      tone: 'semantic',
    },
    {
      german: "der \"Freizügigkeit\"",
      translated: "\"libre circulación\" (Freizügigkeit)",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "en Alemania",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:19|fa": [
    {
      german: "Was versteht man",
      translated: "به چه معناست",
      tone: 'semantic',
    },
    {
      german: "unter dem Recht",
      translated: "حق",
      tone: 'semantic',
    },
    {
      german: "der \"Freizügigkeit\"",
      translated: "«آزادی رفت‌وآمد و انتخاب محل اقامت» (Freizügigkeit)",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "در آلمان",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:19|fr": [
    {
      german: "Was versteht man",
      translated: "Que signifie",
      tone: 'semantic',
    },
    {
      german: "unter dem Recht",
      translated: "le droit à la",
      tone: 'semantic',
    },
    {
      german: "der \"Freizügigkeit\"",
      translated: "« libre circulation » (Freizügigkeit)",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "en Allemagne",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:19|hr": [
    {
      german: "Was versteht man",
      translated: "Što",
      tone: 'semantic',
    },
    {
      german: "unter dem Recht",
      translated: "znači pravo na",
      tone: 'semantic',
    },
    {
      german: "der \"Freizügigkeit\"",
      translated: "„slobodu kretanja“ (Freizügigkeit)",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "u Njemačkoj",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:19|it": [
    {
      german: "Was versteht man",
      translated: "Che cosa significa",
      tone: 'semantic',
    },
    {
      german: "unter dem Recht",
      translated: "il diritto alla",
      tone: 'semantic',
    },
    {
      german: "der \"Freizügigkeit\"",
      translated: "«libera circolazione» (Freizügigkeit)",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "in Germania",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:19|kmr": [
    {
      german: "Was versteht man",
      translated: "tê çi wateyê?",
      tone: 'semantic',
    },
    {
      german: "unter dem Recht",
      translated: "mafê",
      tone: 'semantic',
    },
    {
      german: "der \"Freizügigkeit\"",
      translated: "«azadiya tevgerê» (Freizügigkeit)",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "Li Almanyayê",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:19|pl": [
    {
      german: "Was versteht man",
      translated: "Co oznacza",
      tone: 'semantic',
    },
    {
      german: "unter dem Recht",
      translated: "prawo do",
      tone: 'semantic',
    },
    {
      german: "der \"Freizügigkeit\"",
      translated: "„swobodnego przemieszczania się” (Freizügigkeit)",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "w Niemczech",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:19|prs": [
    {
      german: "Was versteht man",
      translated: "به چه معناست",
      tone: 'semantic',
    },
    {
      german: "unter dem Recht",
      translated: "حق",
      tone: 'semantic',
    },
    {
      german: "der \"Freizügigkeit\"",
      translated: "«آزادی رفت‌وآمد و انتخاب محل اقامت» (Freizügigkeit)",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "در آلمان",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:19|ro": [
    {
      german: "Was versteht man",
      translated: "Ce înseamnă",
      tone: 'semantic',
    },
    {
      german: "unter dem Recht",
      translated: "dreptul la",
      tone: 'semantic',
    },
    {
      german: "der \"Freizügigkeit\"",
      translated: "„libera circulație” (Freizügigkeit)",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "în Germania",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:19|ru": [
    {
      german: "Was versteht man",
      translated: "Что понимается",
      tone: 'semantic',
    },
    {
      german: "unter dem Recht",
      translated: "под правом",
      tone: 'semantic',
    },
    {
      german: "der \"Freizügigkeit\"",
      translated: "на «свободу передвижения»",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "в Германии",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:19|sq": [
    {
      german: "Was versteht man",
      translated: "Çfarë do të thotë",
      tone: 'semantic',
    },
    {
      german: "unter dem Recht",
      translated: "e drejta",
      tone: 'semantic',
    },
    {
      german: "der \"Freizügigkeit\"",
      translated: "e «lëvizjes së lirë» (Freizügigkeit)",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "në Gjermani",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:19|sr": [
    {
      german: "unter dem Recht",
      translated: "znači pravo na",
      tone: 'semantic',
    },
    {
      german: "der \"Freizügigkeit\"",
      translated: "„slobodu kretanja“ (Freizügigkeit)",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "u Nemačkoj",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:19|tr": [
    {
      german: "Was versteht man",
      translated: "ne kastedilir",
      tone: 'semantic',
    },
    {
      german: "unter dem Recht",
      translated: "hakkıyla",
      tone: 'semantic',
    },
    {
      german: "der \"Freizügigkeit\"",
      translated: "\"serbest dolaşım ve yerleşme özgürlüğü\" (Freizügigkeit)",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "Almanya'da",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:19|uk": [
    {
      german: "Was versteht man",
      translated: "Що означає",
      tone: 'semantic',
    },
    {
      german: "unter dem Recht",
      translated: "право на «свободу пересування»",
      tone: 'semantic',
    },
    {
      german: "der \"Freizügigkeit\"",
      translated: "(Freizügigkeit)",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "у Німеччині",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:19|vi": [
    {
      german: "Was versteht man",
      translated: "có nghĩa là gì",
      tone: 'semantic',
    },
    {
      german: "unter dem Recht",
      translated: "quyền",
      tone: 'semantic',
    },
    {
      german: "der \"Freizügigkeit\"",
      translated: "“tự do cư trú và đi lại”",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "Ở Đức",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:1|ar": [
    {
      german: "weil",
      translated: "لأن",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:1|bg": [
    {
      german: "weil",
      translated: "защото",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:1|bs": [
    {
      german: "weil",
      translated: "jer",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:1|el": [
    {
      german: "weil",
      translated: "επειδή",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:1|en": [
    {
      german: "weil",
      translated: "because",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:1|es": [
    {
      german: "weil",
      translated: "porque",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:1|fa": [
    {
      german: "weil",
      translated: "زیرا",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:1|fr": [
    {
      german: "weil",
      translated: "parce que",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:1|hr": [
    {
      german: "weil",
      translated: "jer",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:1|it": [
    {
      german: "weil",
      translated: "perché",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:1|kmr": [
    {
      german: "weil",
      translated: "ji ber ku",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:1|pl": [
    {
      german: "weil",
      translated: "ponieważ",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:1|prs": [
    {
      german: "weil",
      translated: "زیرا",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:1|ro": [
    {
      german: "weil",
      translated: "deoarece",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:1|ru": [
    {
      german: "weil",
      translated: "потому что",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:1|sq": [
    {
      german: "weil",
      translated: "sepse",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:1|sr": [
    {
      german: "weil",
      translated: "jer",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:1|tr": [
    {
      german: "weil",
      translated: "çünkü",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:1|uk": [
    {
      german: "weil",
      translated: "тому що",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:200|ar": [
    {
      german: "Welches heutige deutsche Bundesland",
      translated: "أي ولاية اتحادية ألمانية حالية",
      tone: 'semantic',
    },
    {
      german: "gehörte früher",
      translated: "كانت سابقًا",
      tone: 'semantic',
    },
    {
      german: "zum Gebiet",
      translated: "ضمن أراضي",
      tone: 'semantic',
    },
    {
      german: "der DDR",
      translated: "DDR؟",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:200|bg": [
    {
      german: "Welches heutige deutsche Bundesland",
      translated: "Коя днешна германска федерална провинция",
      tone: 'semantic',
    },
    {
      german: "gehörte früher",
      translated: "е била",
      tone: 'semantic',
    },
    {
      german: "zum Gebiet",
      translated: "част",
      tone: 'semantic',
    },
    {
      german: "der DDR",
      translated: "от ГДР",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:200|bs": [
    {
      german: "Welches heutige deutsche Bundesland",
      translated: "Koja je današnja njemačka savezna zemlja",
      tone: 'semantic',
    },
    {
      german: "gehörte früher",
      translated: "prije pripadala",
      tone: 'semantic',
    },
    {
      german: "der DDR",
      translated: "DDR-u",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:200|el": [
    {
      german: "Welches heutige deutsche Bundesland",
      translated: "Ποιο σημερινό γερμανικό κρατίδιο",
      tone: 'semantic',
    },
    {
      german: "gehörte früher",
      translated: "ανήκε παλαιότερα",
      tone: 'semantic',
    },
    {
      german: "der DDR",
      translated: "στη ΛΔΓ;",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:200|en": [
    {
      german: "Welches heutige deutsche Bundesland",
      translated: "Which current German federal state",
      tone: 'semantic',
    },
    {
      german: "gehörte früher",
      translated: "formerly belonged",
      tone: 'semantic',
    },
    {
      german: "zum Gebiet",
      translated: "to the territory",
      tone: 'semantic',
    },
    {
      german: "der DDR",
      translated: "of the GDR?",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:200|es": [
    {
      german: "Welches heutige deutsche Bundesland",
      translated: "¿Qué actual estado federado alemán",
      tone: 'semantic',
    },
    {
      german: "gehörte früher",
      translated: "pertenecía anteriormente",
      tone: 'semantic',
    },
    {
      german: "zum Gebiet",
      translated: "al territorio",
      tone: 'semantic',
    },
    {
      german: "der DDR",
      translated: "de la RDA",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:200|fa": [
    {
      german: "Welches heutige deutsche Bundesland",
      translated: "کدام ایالت امروزی آلمان",
      tone: 'semantic',
    },
    {
      german: "gehörte früher",
      translated: "پیش‌تر",
      tone: 'semantic',
    },
    {
      german: "zum Gebiet",
      translated: "بخشی از قلمرو",
      tone: 'semantic',
    },
    {
      german: "der DDR",
      translated: "جمهوری دموکراتیک آلمان",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:200|fr": [
    {
      german: "Welches heutige deutsche Bundesland",
      translated: "Quel Land allemand actuel",
      tone: 'semantic',
    },
    {
      german: "gehörte früher",
      translated: "faisait autrefois",
      tone: 'semantic',
    },
    {
      german: "zum Gebiet",
      translated: "partie du territoire",
      tone: 'semantic',
    },
    {
      german: "der DDR",
      translated: "de la RDA",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:200|hr": [
    {
      german: "Welches heutige deutsche Bundesland",
      translated: "Koja je današnja njemačka savezna zemlja",
      tone: 'semantic',
    },
    {
      german: "gehörte früher",
      translated: "prije pripadala",
      tone: 'semantic',
    },
    {
      german: "der DDR",
      translated: "DDR-u?",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:200|it": [
    {
      german: "Welches heutige deutsche Bundesland",
      translated: "Quale Land tedesco di oggi",
      tone: 'semantic',
    },
    {
      german: "gehörte früher",
      translated: "faceva in passato",
      tone: 'semantic',
    },
    {
      german: "zum Gebiet",
      translated: "parte della",
      tone: 'semantic',
    },
    {
      german: "der DDR",
      translated: "RDT?",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:200|kmr": [
    {
      german: "Welches heutige deutsche Bundesland",
      translated: "Kîjan eyaleta federal a îro",
      tone: 'semantic',
    },
    {
      german: "gehörte früher",
      translated: "berê",
      tone: 'semantic',
    },
    {
      german: "zum Gebiet",
      translated: "di nav",
      tone: 'semantic',
    },
    {
      german: "der DDR",
      translated: "DDR",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:200|pl": [
    {
      german: "Welches heutige deutsche Bundesland",
      translated: "Który dzisiejszy niemiecki kraj związkowy",
      tone: 'semantic',
    },
    {
      german: "gehörte früher",
      translated: "należał wcześniej",
      tone: 'semantic',
    },
    {
      german: "zum Gebiet",
      translated: "do",
      tone: 'semantic',
    },
    {
      german: "der DDR",
      translated: "NRD",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:200|prs": [
    {
      german: "Welches heutige deutsche Bundesland",
      translated: "کدام ایالت امروزی آلمان",
      tone: 'semantic',
    },
    {
      german: "gehörte früher",
      translated: "پیش‌تر",
      tone: 'semantic',
    },
    {
      german: "zum Gebiet",
      translated: "بخشی از",
      tone: 'semantic',
    },
    {
      german: "der DDR",
      translated: "قلمرو جمهوری دموکراتیک آلمان",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:200|ro": [
    {
      german: "Welches heutige deutsche Bundesland",
      translated: "Care land german de astăzi",
      tone: 'semantic',
    },
    {
      german: "gehörte früher",
      translated: "făcea parte anterior",
      tone: 'semantic',
    },
    {
      german: "zum Gebiet",
      translated: "din",
      tone: 'semantic',
    },
    {
      german: "der DDR",
      translated: "RDG?",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:200|ru": [
    {
      german: "Welches heutige deutsche Bundesland",
      translated: "Какая из современных федеральных земель Германии",
      tone: 'semantic',
    },
    {
      german: "gehörte früher",
      translated: "раньше входила",
      tone: 'semantic',
    },
    {
      german: "zum Gebiet",
      translated: "в состав",
      tone: 'semantic',
    },
    {
      german: "der DDR",
      translated: "ГДР?",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:200|sq": [
    {
      german: "Welches heutige deutsche Bundesland",
      translated: "Cili land i sotëm gjerman",
      tone: 'semantic',
    },
    {
      german: "gehörte früher",
      translated: "ishte",
      tone: 'semantic',
    },
    {
      german: "zum Gebiet",
      translated: "pjesë e",
      tone: 'semantic',
    },
    {
      german: "der DDR",
      translated: "RDGJ-së",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:200|sr": [
    {
      german: "Welches heutige deutsche Bundesland",
      translated: "Koja je današnja nemačka savezna pokrajina",
      tone: 'semantic',
    },
    {
      german: "gehörte früher",
      translated: "pre",
      tone: 'semantic',
    },
    {
      german: "der DDR",
      translated: "DDR-u",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:200|tr": [
    {
      german: "Welches heutige deutsche Bundesland",
      translated: "Günümüzdeki hangi Alman eyaleti",
      tone: 'semantic',
    },
    {
      german: "gehörte früher",
      translated: "eskiden",
      tone: 'semantic',
    },
    {
      german: "zum Gebiet",
      translated: "topraklarındaydı",
      tone: 'semantic',
    },
    {
      german: "der DDR",
      translated: "Doğu Almanya (DDR)",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:200|uk": [
    {
      german: "Welches heutige deutsche Bundesland",
      translated: "Яка сучасна федеральна земля Німеччини",
      tone: 'semantic',
    },
    {
      german: "gehörte früher",
      translated: "раніше входила",
      tone: 'semantic',
    },
    {
      german: "zum Gebiet",
      translated: "до території",
      tone: 'semantic',
    },
    {
      german: "der DDR",
      translated: "НДР",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:200|vi": [
    {
      german: "Welches heutige deutsche Bundesland",
      translated: "Bang nào của Đức ngày nay",
      tone: 'semantic',
    },
    {
      german: "gehörte früher",
      translated: "từng thuộc",
      tone: 'semantic',
    },
    {
      german: "der DDR",
      translated: "CHDC Đức",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:201|ar": [
    {
      german: "Welche",
      translated: "أي",
      tone: 'semantic',
    },
    {
      german: "der folgenden Auflistungen",
      translated: "قائمة من القوائم التالية",
      tone: 'semantic',
    },
    {
      german: "enthält",
      translated: "تضم",
      tone: 'semantic',
    },
    {
      german: "nur Bundesländer",
      translated: "ولايات اتحادية",
      tone: 'semantic',
    },
    {
      german: "die zum Gebiet der früheren DDR gehörten",
      translated: "كانت ضمن أراضي DDR السابقة",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:201|bg": [
    {
      german: "Welche",
      translated: "Кой",
      tone: 'semantic',
    },
    {
      german: "der folgenden Auflistungen",
      translated: "списък",
      tone: 'semantic',
    },
    {
      german: "enthält",
      translated: "съдържа",
      tone: 'semantic',
    },
    {
      german: "nur Bundesländer",
      translated: "само федерални провинции",
      tone: 'semantic',
    },
    {
      german: "die zum Gebiet der früheren DDR gehörten",
      translated: "които са били част от бившата ГДР",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:201|bs": [
    {
      german: "Welche",
      translated: "Koji",
      tone: 'semantic',
    },
    {
      german: "der folgenden Auflistungen",
      translated: "popis",
      tone: 'semantic',
    },
    {
      german: "enthält",
      translated: "sadrži",
      tone: 'semantic',
    },
    {
      german: "nur Bundesländer",
      translated: "isključivo savezne zemlje",
      tone: 'semantic',
    },
    {
      german: "die zum Gebiet der früheren DDR gehörten",
      translated: "koje su pripadale bivšem DDR-u?",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:201|el": [
    {
      german: "Welche",
      translated: "Ποια",
      tone: 'semantic',
    },
    {
      german: "der folgenden Auflistungen",
      translated: "λίστα",
      tone: 'semantic',
    },
    {
      german: "enthält",
      translated: "περιέχει",
      tone: 'semantic',
    },
    {
      german: "nur Bundesländer",
      translated: "μόνο ομόσπονδα κρατίδια",
      tone: 'semantic',
    },
    {
      german: "die zum Gebiet der früheren DDR gehörten",
      translated: "που ανήκαν στην πρώην ΛΔΓ",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:201|en": [
    {
      german: "Welche",
      translated: "Which",
      tone: 'semantic',
    },
    {
      german: "der folgenden Auflistungen",
      translated: "of the following lists",
      tone: 'semantic',
    },
    {
      german: "enthält",
      translated: "contains",
      tone: 'semantic',
    },
    {
      german: "nur Bundesländer",
      translated: "only federal states",
      tone: 'semantic',
    },
    {
      german: "die zum Gebiet der früheren DDR gehörten",
      translated: "that belonged to the former GDR",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:201|es": [
    {
      german: "Welche",
      translated: "¿Cuál",
      tone: 'semantic',
    },
    {
      german: "der folgenden Auflistungen",
      translated: "de las siguientes listas",
      tone: 'semantic',
    },
    {
      german: "enthält",
      translated: "contiene",
      tone: 'semantic',
    },
    {
      german: "nur Bundesländer",
      translated: "únicamente estados federados",
      tone: 'semantic',
    },
    {
      german: "die zum Gebiet der früheren DDR gehörten",
      translated: "que pertenecían a la antigua RDA",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:201|fa": [
    {
      german: "Welche",
      translated: "کدام",
      tone: 'semantic',
    },
    {
      german: "der folgenden Auflistungen",
      translated: "فهرست فقط",
      tone: 'semantic',
    },
    {
      german: "enthält",
      translated: "شامل",
      tone: 'semantic',
    },
    {
      german: "nur Bundesländer",
      translated: "ایالت‌هایی",
      tone: 'semantic',
    },
    {
      german: "die zum Gebiet der früheren DDR gehörten",
      translated: "که بخشی از جمهوری دموکراتیک آلمان سابق بودند",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:201|fr": [
    {
      german: "Welche",
      translated: "Laquelle",
      tone: 'semantic',
    },
    {
      german: "der folgenden Auflistungen",
      translated: "des listes suivantes",
      tone: 'semantic',
    },
    {
      german: "enthält",
      translated: "contient",
      tone: 'semantic',
    },
    {
      german: "nur Bundesländer",
      translated: "uniquement des Länder",
      tone: 'semantic',
    },
    {
      german: "die zum Gebiet der früheren DDR gehörten",
      translated: "qui faisaient partie de l’ancienne RDA",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:201|hr": [
    {
      german: "Welche",
      translated: "Koji",
      tone: 'semantic',
    },
    {
      german: "der folgenden Auflistungen",
      translated: "popis",
      tone: 'semantic',
    },
    {
      german: "enthält",
      translated: "sadrži",
      tone: 'semantic',
    },
    {
      german: "nur Bundesländer",
      translated: "isključivo savezne zemlje",
      tone: 'semantic',
    },
    {
      german: "die zum Gebiet der früheren DDR gehörten",
      translated: "koje su pripadale bivšem DDR-u?",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:201|it": [
    {
      german: "Welche",
      translated: "Quale",
      tone: 'semantic',
    },
    {
      german: "der folgenden Auflistungen",
      translated: "elenco",
      tone: 'semantic',
    },
    {
      german: "enthält",
      translated: "contiene",
      tone: 'semantic',
    },
    {
      german: "nur Bundesländer",
      translated: "soltanto Länder",
      tone: 'semantic',
    },
    {
      german: "die zum Gebiet der früheren DDR gehörten",
      translated: "che facevano parte dell’ex RDT",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:201|kmr": [
    {
      german: "Welche",
      translated: "Kîjan",
      tone: 'semantic',
    },
    {
      german: "der folgenden Auflistungen",
      translated: "lîste",
      tone: 'semantic',
    },
    {
      german: "enthält",
      translated: "tenê",
      tone: 'semantic',
    },
    {
      german: "die zum Gebiet der früheren DDR gehörten",
      translated: "eyaletên ku di nav DDR ya berê de bûn hene",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:201|pl": [
    {
      german: "Welche",
      translated: "Która",
      tone: 'semantic',
    },
    {
      german: "der folgenden Auflistungen",
      translated: "lista",
      tone: 'semantic',
    },
    {
      german: "enthält",
      translated: "zawiera",
      tone: 'semantic',
    },
    {
      german: "nur Bundesländer",
      translated: "wyłącznie kraje związkowe",
      tone: 'semantic',
    },
    {
      german: "die zum Gebiet der früheren DDR gehörten",
      translated: "które należały do byłej NRD?",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:201|prs": [
    {
      german: "Welche",
      translated: "کدام",
      tone: 'semantic',
    },
    {
      german: "der folgenden Auflistungen",
      translated: "فهرست",
      tone: 'semantic',
    },
    {
      german: "enthält",
      translated: "شامل",
      tone: 'semantic',
    },
    {
      german: "nur Bundesländer",
      translated: "فقط",
      tone: 'semantic',
    },
    {
      german: "die zum Gebiet der früheren DDR gehörten",
      translated: "که بخشی از جمهوری دموکراتیک آلمان سابق بودند",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:201|ro": [
    {
      german: "Welche",
      translated: "Care",
      tone: 'semantic',
    },
    {
      german: "der folgenden Auflistungen",
      translated: "listă",
      tone: 'semantic',
    },
    {
      german: "enthält",
      translated: "conține",
      tone: 'semantic',
    },
    {
      german: "nur Bundesländer",
      translated: "numai landuri",
      tone: 'semantic',
    },
    {
      german: "die zum Gebiet der früheren DDR gehörten",
      translated: "care făceau parte din fosta RDG",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:201|ru": [
    {
      german: "Welche",
      translated: "Какой",
      tone: 'semantic',
    },
    {
      german: "der folgenden Auflistungen",
      translated: "из следующих перечней",
      tone: 'semantic',
    },
    {
      german: "enthält",
      translated: "содержит",
      tone: 'semantic',
    },
    {
      german: "nur Bundesländer",
      translated: "только федеральные земли",
      tone: 'semantic',
    },
    {
      german: "die zum Gebiet der früheren DDR gehörten",
      translated: "в состав бывшей ГДР",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:201|sq": [
    {
      german: "Welche",
      translated: "Cila",
      tone: 'semantic',
    },
    {
      german: "der folgenden Auflistungen",
      translated: " listë",
      tone: 'semantic',
    },
    {
      german: "enthält",
      translated: " përmban",
      tone: 'semantic',
    },
    {
      german: "nur Bundesländer",
      translated: " vetëm lande",
      tone: 'semantic',
    },
    {
      german: "die zum Gebiet der früheren DDR gehörten",
      translated: " që ishin pjesë e ish-RDGJ-së",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:201|sr": [
    {
      german: "Welche",
      translated: "Koji",
      tone: 'semantic',
    },
    {
      german: "der folgenden Auflistungen",
      translated: "popis",
      tone: 'semantic',
    },
    {
      german: "enthält",
      translated: "sadrži",
      tone: 'semantic',
    },
    {
      german: "nur Bundesländer",
      translated: "isključivo savezne pokrajine",
      tone: 'semantic',
    },
    {
      german: "die zum Gebiet der früheren DDR gehörten",
      translated: "koje su pripadale bivšem DDR-u?",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:201|tr": [
    {
      german: "Welche",
      translated: "hangisinde",
      tone: 'semantic',
    },
    {
      german: "der folgenden Auflistungen",
      translated: "Aşağıdaki listelerden",
      tone: 'semantic',
    },
    {
      german: "enthält",
      translated: "vardır",
      tone: 'semantic',
    },
    {
      german: "nur Bundesländer",
      translated: "eyaletler",
      tone: 'semantic',
    },
    {
      german: "die zum Gebiet der früheren DDR gehörten",
      translated: "eski Doğu Almanya (DDR) topraklarında yer alan",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:201|uk": [
    {
      german: "Welche",
      translated: "Який",
      tone: 'semantic',
    },
    {
      german: "der folgenden Auflistungen",
      translated: "із наведених списків",
      tone: 'semantic',
    },
    {
      german: "enthält",
      translated: "містить",
      tone: 'semantic',
    },
    {
      german: "nur Bundesländer",
      translated: "лише федеральні землі",
      tone: 'semantic',
    },
    {
      german: "die zum Gebiet der früheren DDR gehörten",
      translated: "що входили до території колишньої НДР",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:201|vi": [
    {
      german: "Welche",
      translated: "nào",
      tone: 'semantic',
    },
    {
      german: "der folgenden Auflistungen",
      translated: "Danh sách",
      tone: 'semantic',
    },
    {
      german: "enthält",
      translated: "chỉ gồm",
      tone: 'semantic',
    },
    {
      german: "nur Bundesländer",
      translated: "các bang",
      tone: 'semantic',
    },
    {
      german: "die zum Gebiet der früheren DDR gehörten",
      translated: "từng thuộc CHDC Đức cũ",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:202|ar": [
    {
      german: "Zu wem",
      translated: "إلى أي جهة",
      tone: 'semantic',
    },
    {
      german: "gehörte",
      translated: "كانت",
      tone: 'semantic',
    },
    {
      german: "die DDR",
      translated: "DDR",
      tone: 'semantic',
    },
    {
      german: "im \"Kalten Krieg\"",
      translated: "خلال «الحرب الباردة»",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:202|bg": [
    {
      german: "Zu wem",
      translated: "Към кой",
      tone: 'semantic',
    },
    {
      german: "gehörte",
      translated: "блок принадлежи",
      tone: 'semantic',
    },
    {
      german: "die DDR",
      translated: "ГДР",
      tone: 'semantic',
    },
    {
      german: "im \"Kalten Krieg\"",
      translated: "по време на „Студената война“",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:202|bs": [
    {
      german: "Zu wem",
      translated: "Kojem",
      tone: 'semantic',
    },
    {
      german: "gehörte",
      translated: "pripadao",
      tone: 'semantic',
    },
    {
      german: "die DDR",
      translated: "DDR",
      tone: 'semantic',
    },
    {
      german: "im \"Kalten Krieg\"",
      translated: "„Hladnog rata“",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:202|el": [
    {
      german: "Zu wem",
      translated: "Σε ποιο",
      tone: 'semantic',
    },
    {
      german: "gehörte",
      translated: "ανήκε",
      tone: 'semantic',
    },
    {
      german: "die DDR",
      translated: "η ΛΔΓ",
      tone: 'semantic',
    },
    {
      german: "im \"Kalten Krieg\"",
      translated: "κατά τον «Ψυχρό Πόλεμο»",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:202|en": [
    {
      german: "Zu wem",
      translated: "Who did",
      tone: 'semantic',
    },
    {
      german: "gehörte",
      translated: "belong to",
      tone: 'semantic',
    },
    {
      german: "die DDR",
      translated: "the GDR",
      tone: 'semantic',
    },
    {
      german: "im \"Kalten Krieg\"",
      translated: "during the 'Cold War'",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:202|es": [
    {
      german: "Zu wem",
      translated: "A qué",
      tone: 'semantic',
    },
    {
      german: "gehörte",
      translated: "pertenecía",
      tone: 'semantic',
    },
    {
      german: "die DDR",
      translated: "la RDA",
      tone: 'semantic',
    },
    {
      german: "im \"Kalten Krieg\"",
      translated: "durante la «Guerra Fría»",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:202|fa": [
    {
      german: "Zu wem",
      translated: "به کدام بلوک",
      tone: 'semantic',
    },
    {
      german: "gehörte",
      translated: "تعلق داشت",
      tone: 'semantic',
    },
    {
      german: "die DDR",
      translated: "جمهوری دموکراتیک آلمان",
      tone: 'semantic',
    },
    {
      german: "im \"Kalten Krieg\"",
      translated: "در دوران «جنگ سرد»",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:202|fr": [
    {
      german: "Zu wem",
      translated: "À quel",
      tone: 'semantic',
    },
    {
      german: "gehörte",
      translated: "appartenait",
      tone: 'semantic',
    },
    {
      german: "die DDR",
      translated: "la RDA",
      tone: 'semantic',
    },
    {
      german: "im \"Kalten Krieg\"",
      translated: "« guerre froide »",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:202|hr": [
    {
      german: "Zu wem",
      translated: "Kojem",
      tone: 'semantic',
    },
    {
      german: "gehörte",
      translated: "pripadao",
      tone: 'semantic',
    },
    {
      german: "die DDR",
      translated: "DDR",
      tone: 'semantic',
    },
    {
      german: "im \"Kalten Krieg\"",
      translated: "tijekom „Hladnog rata“",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:202|it": [
    {
      german: "Zu wem",
      translated: "A quale",
      tone: 'semantic',
    },
    {
      german: "gehörte",
      translated: "apparteneva",
      tone: 'semantic',
    },
    {
      german: "die DDR",
      translated: "la RDT",
      tone: 'semantic',
    },
    {
      german: "im \"Kalten Krieg\"",
      translated: "«Guerra fredda»",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:202|kmr": [
    {
      german: "Zu wem",
      translated: "de li kîjan",
      tone: 'semantic',
    },
    {
      german: "gehörte",
      translated: "alî",
      tone: 'semantic',
    },
    {
      german: "die DDR",
      translated: "DDR",
      tone: 'semantic',
    },
    {
      german: "im \"Kalten Krieg\"",
      translated: "«Şerê Sar»",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:202|pl": [
    {
      german: "Zu wem",
      translated: "Do którego bloku",
      tone: 'semantic',
    },
    {
      german: "gehörte",
      translated: "należała",
      tone: 'semantic',
    },
    {
      german: "die DDR",
      translated: "NRD",
      tone: 'semantic',
    },
    {
      german: "im \"Kalten Krieg\"",
      translated: "podczas „zimnej wojny”",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:202|prs": [
    {
      german: "Zu wem",
      translated: "به کدام بلوک",
      tone: 'semantic',
    },
    {
      german: "gehörte",
      translated: "تعلق داشت",
      tone: 'semantic',
    },
    {
      german: "die DDR",
      translated: "جمهوری دموکراتیک آلمان",
      tone: 'semantic',
    },
    {
      german: "im \"Kalten Krieg\"",
      translated: "در دوران «جنگ سرد»",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:202|ro": [
    {
      german: "Zu wem",
      translated: "Din ce bloc",
      tone: 'semantic',
    },
    {
      german: "gehörte",
      translated: "făcea parte",
      tone: 'semantic',
    },
    {
      german: "die DDR",
      translated: "RDG",
      tone: 'semantic',
    },
    {
      german: "im \"Kalten Krieg\"",
      translated: "în timpul „Războiului Rece”",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:202|ru": [
    {
      german: "Zu wem",
      translated: "К какому",
      tone: 'semantic',
    },
    {
      german: "gehörte",
      translated: "блоку принадлежала",
      tone: 'semantic',
    },
    {
      german: "die DDR",
      translated: "ГДР",
      tone: 'semantic',
    },
    {
      german: "im \"Kalten Krieg\"",
      translated: "во время «холодной войны»",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:202|sq": [
    {
      german: "Zu wem",
      translated: "Cilit bllok i përkiste",
      tone: 'semantic',
    },
    {
      german: "die DDR",
      translated: "RDGJ-ja",
      tone: 'semantic',
    },
    {
      german: "im \"Kalten Krieg\"",
      translated: "«Luftës së Ftohtë»",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:202|sr": [
    {
      german: "Zu wem",
      translated: "Kojem je bloku",
      tone: 'semantic',
    },
    {
      german: "gehörte",
      translated: "pripadao",
      tone: 'semantic',
    },
    {
      german: "die DDR",
      translated: "DDR",
      tone: 'semantic',
    },
    {
      german: "im \"Kalten Krieg\"",
      translated: "tokom „Hladnog rata“",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:202|tr": [
    {
      german: "Zu wem",
      translated: "hangi bloka",
      tone: 'semantic',
    },
    {
      german: "gehörte",
      translated: "dahildi",
      tone: 'semantic',
    },
    {
      german: "die DDR",
      translated: "Doğu Almanya (DDR)",
      tone: 'semantic',
    },
    {
      german: "im \"Kalten Krieg\"",
      translated: "Soğuk Savaş döneminde",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:202|uk": [
    {
      german: "Zu wem",
      translated: "До кого",
      tone: 'semantic',
    },
    {
      german: "gehörte",
      translated: "належала",
      tone: 'semantic',
    },
    {
      german: "die DDR",
      translated: "НДР",
      tone: 'semantic',
    },
    {
      german: "im \"Kalten Krieg\"",
      translated: "під час «холодної війни»",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:202|vi": [
    {
      german: "gehörte",
      translated: "thuộc",
      tone: 'semantic',
    },
    {
      german: "die DDR",
      translated: "CHDC Đức",
      tone: 'semantic',
    },
    {
      german: "im \"Kalten Krieg\"",
      translated: "Trong thời kỳ “Chiến tranh Lạnh”",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:203|ar": [
    {
      german: "Wie",
      translated: "ماذا",
      tone: 'semantic',
    },
    {
      german: "hieß",
      translated: "كان",
      tone: 'semantic',
    },
    {
      german: "das Wirtschaftssystem",
      translated: "النظام الاقتصادي",
      tone: 'semantic',
    },
    {
      german: "der DDR",
      translated: "DDR",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:203|bg": [
    {
      german: "Wie",
      translated: "Как",
      tone: 'semantic',
    },
    {
      german: "hieß",
      translated: "се нарича",
      tone: 'semantic',
    },
    {
      german: "das Wirtschaftssystem",
      translated: "икономическата система",
      tone: 'semantic',
    },
    {
      german: "der DDR",
      translated: "на ГДР",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:203|bs": [
    {
      german: "Wie",
      translated: "Kako",
      tone: 'semantic',
    },
    {
      german: "hieß",
      translated: "zvao",
      tone: 'semantic',
    },
    {
      german: "das Wirtschaftssystem",
      translated: "privredni sustav",
      tone: 'semantic',
    },
    {
      german: "der DDR",
      translated: "DDR-a",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:203|el": [
    {
      german: "Wie",
      translated: "Πώς",
      tone: 'semantic',
    },
    {
      german: "hieß",
      translated: "ονομαζόταν",
      tone: 'semantic',
    },
    {
      german: "das Wirtschaftssystem",
      translated: "το οικονομικό σύστημα",
      tone: 'semantic',
    },
    {
      german: "der DDR",
      translated: "της ΛΔΓ",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:203|en": [
    {
      german: "Wie",
      translated: "What",
      tone: 'semantic',
    },
    {
      german: "hieß",
      translated: "was",
      tone: 'semantic',
    },
    {
      german: "das Wirtschaftssystem",
      translated: "the economic system",
      tone: 'semantic',
    },
    {
      german: "der DDR",
      translated: "of the GDR",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:203|es": [
    {
      german: "Wie",
      translated: "Cómo",
      tone: 'semantic',
    },
    {
      german: "hieß",
      translated: "se llamaba",
      tone: 'semantic',
    },
    {
      german: "das Wirtschaftssystem",
      translated: "el sistema económico",
      tone: 'semantic',
    },
    {
      german: "der DDR",
      translated: "de la RDA",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:203|fa": [
    {
      german: "Wie",
      translated: "چه",
      tone: 'semantic',
    },
    {
      german: "hieß",
      translated: "نام داشت",
      tone: 'semantic',
    },
    {
      german: "das Wirtschaftssystem",
      translated: "نظام اقتصادی",
      tone: 'semantic',
    },
    {
      german: "der DDR",
      translated: "جمهوری دموکراتیک آلمان",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:203|fr": [
    {
      german: "Wie",
      translated: "Comment",
      tone: 'semantic',
    },
    {
      german: "hieß",
      translated: "s’appelait",
      tone: 'semantic',
    },
    {
      german: "das Wirtschaftssystem",
      translated: "le système économique",
      tone: 'semantic',
    },
    {
      german: "der DDR",
      translated: "la RDA",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:203|hr": [
    {
      german: "Wie",
      translated: "Kako",
      tone: 'semantic',
    },
    {
      german: "hieß",
      translated: "se zvao",
      tone: 'semantic',
    },
    {
      german: "das Wirtschaftssystem",
      translated: "gospodarski sustav",
      tone: 'semantic',
    },
    {
      german: "der DDR",
      translated: "DDR-a",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:203|it": [
    {
      german: "Wie",
      translated: "Come",
      tone: 'semantic',
    },
    {
      german: "hieß",
      translated: "si chiamava",
      tone: 'semantic',
    },
    {
      german: "das Wirtschaftssystem",
      translated: "il sistema economico",
      tone: 'semantic',
    },
    {
      german: "der DDR",
      translated: "della RDT",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:203|kmr": [
    {
      german: "Wie",
      translated: "Pergala",
      tone: 'semantic',
    },
    {
      german: "hieß",
      translated: "aborî ya",
      tone: 'semantic',
    },
    {
      german: "das Wirtschaftssystem",
      translated: "çi bû",
      tone: 'semantic',
    },
    {
      german: "der DDR",
      translated: "DDR",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:203|pl": [
    {
      german: "Wie",
      translated: "Jak",
      tone: 'semantic',
    },
    {
      german: "hieß",
      translated: "nazywał się",
      tone: 'semantic',
    },
    {
      german: "das Wirtschaftssystem",
      translated: "system gospodarczy",
      tone: 'semantic',
    },
    {
      german: "der DDR",
      translated: "NRD",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:203|prs": [
    {
      german: "Wie",
      translated: "چه نام",
      tone: 'semantic',
    },
    {
      german: "hieß",
      translated: "داشت؟",
      tone: 'semantic',
    },
    {
      german: "das Wirtschaftssystem",
      translated: "نظام اقتصادی جمهوری دموکراتیک آلمان",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:203|ro": [
    {
      german: "Wie",
      translated: "Cum",
      tone: 'semantic',
    },
    {
      german: "hieß",
      translated: "se numea",
      tone: 'semantic',
    },
    {
      german: "das Wirtschaftssystem",
      translated: "sistemul economic",
      tone: 'semantic',
    },
    {
      german: "der DDR",
      translated: "al RDG?",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:203|ru": [
    {
      german: "Wie",
      translated: "Как",
      tone: 'semantic',
    },
    {
      german: "hieß",
      translated: "называлась",
      tone: 'semantic',
    },
    {
      german: "das Wirtschaftssystem",
      translated: "экономическая система",
      tone: 'semantic',
    },
    {
      german: "der DDR",
      translated: "ГДР",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:203|sq": [
    {
      german: "Wie",
      translated: "Si",
      tone: 'semantic',
    },
    {
      german: "hieß",
      translated: "quhej",
      tone: 'semantic',
    },
    {
      german: "das Wirtschaftssystem",
      translated: "sistemi ekonomik",
      tone: 'semantic',
    },
    {
      german: "der DDR",
      translated: "RDGJ-së",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:203|sr": [
    {
      german: "Wie",
      translated: "Kako",
      tone: 'semantic',
    },
    {
      german: "hieß",
      translated: "zvao",
      tone: 'semantic',
    },
    {
      german: "das Wirtschaftssystem",
      translated: "privredni sistem",
      tone: 'semantic',
    },
    {
      german: "der DDR",
      translated: "DDR-a?",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:203|tr": [
    {
      german: "Wie",
      translated: "neydi",
      tone: 'semantic',
    },
    {
      german: "hieß",
      translated: "adı",
      tone: 'semantic',
    },
    {
      german: "das Wirtschaftssystem",
      translated: "ekonomik sisteminin",
      tone: 'semantic',
    },
    {
      german: "der DDR",
      translated: "Doğu Almanya'nın (DDR)",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:203|uk": [
    {
      german: "Wie",
      translated: "Як",
      tone: 'semantic',
    },
    {
      german: "hieß",
      translated: " називалася",
      tone: 'semantic',
    },
    {
      german: "das Wirtschaftssystem",
      translated: " економічна система",
      tone: 'semantic',
    },
    {
      german: "der DDR",
      translated: " НДР",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:203|vi": [
    {
      german: "Wie",
      translated: "được",
      tone: 'semantic',
    },
    {
      german: "hieß",
      translated: "gọi",
      tone: 'semantic',
    },
    {
      german: "das Wirtschaftssystem",
      translated: "Hệ thống kinh tế",
      tone: 'semantic',
    },
    {
      german: "der DDR",
      translated: "CHDC Đức",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:204|ar": [
    {
      german: "Wie wurden",
      translated: "كيف أصبحت",
      tone: 'semantic',
    },
    {
      german: "die Bundesrepublik Deutschland",
      translated: "جمهورية ألمانيا الاتحادية",
      tone: 'semantic',
    },
    {
      german: "die DDR",
      translated: "وDDR",
      tone: 'semantic',
    },
    {
      german: "Staat",
      translated: "دولة",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:204|bg": [
    {
      german: "Wie wurden",
      translated: "Как",
      tone: 'semantic',
    },
    {
      german: "die Bundesrepublik Deutschland",
      translated: "Федерална република Германия",
      tone: 'semantic',
    },
    {
      german: "die DDR",
      translated: "ГДР",
      tone: 'semantic',
    },
    {
      german: "Staat",
      translated: "държава",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:204|bs": [
    {
      german: "Wie wurden",
      translated: "Kako su",
      tone: 'semantic',
    },
    {
      german: "die Bundesrepublik Deutschland",
      translated: "Savezna Republika Njemačka",
      tone: 'semantic',
    },
    {
      german: "die DDR",
      translated: "DDR",
      tone: 'semantic',
    },
    {
      german: "Staat",
      translated: "država",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:204|el": [
    {
      german: "Wie wurden",
      translated: "Πώς έγιναν",
      tone: 'semantic',
    },
    {
      german: "die Bundesrepublik Deutschland",
      translated: "η Ομοσπονδιακή Δημοκρατία της Γερμανίας",
      tone: 'semantic',
    },
    {
      german: "die DDR",
      translated: "η ΛΔΓ",
      tone: 'semantic',
    },
    {
      german: "Staat",
      translated: "κράτος",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:204|en": [
    {
      german: "Wie wurden",
      translated: "How did",
      tone: 'semantic',
    },
    {
      german: "die Bundesrepublik Deutschland",
      translated: "the Federal Republic of Germany",
      tone: 'semantic',
    },
    {
      german: "die DDR",
      translated: "the GDR",
      tone: 'semantic',
    },
    {
      german: "Staat",
      translated: "state",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:204|es": [
    {
      german: "Wie wurden",
      translated: "¿Cómo se convirtieron",
      tone: 'semantic',
    },
    {
      german: "die Bundesrepublik Deutschland",
      translated: "la República Federal de Alemania",
      tone: 'semantic',
    },
    {
      german: "die DDR",
      translated: "la RDA",
      tone: 'semantic',
    },
    {
      german: "Staat",
      translated: "Estado",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:204|fa": [
    {
      german: "Wie wurden",
      translated: "چگونه",
      tone: 'semantic',
    },
    {
      german: "die Bundesrepublik Deutschland",
      translated: "جمهوری فدرال آلمان",
      tone: 'semantic',
    },
    {
      german: "die DDR",
      translated: "جمهوری دموکراتیک آلمان",
      tone: 'semantic',
    },
    {
      german: "Staat",
      translated: "کشور",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:204|fr": [
    {
      german: "Wie wurden",
      translated: "Comment",
      tone: 'semantic',
    },
    {
      german: "die Bundesrepublik Deutschland",
      translated: "la République fédérale d’Allemagne",
      tone: 'semantic',
    },
    {
      german: "die DDR",
      translated: "la RDA",
      tone: 'semantic',
    },
    {
      german: "Staat",
      translated: "un seul État",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:204|hr": [
    {
      german: "Wie wurden",
      translated: "Kako su",
      tone: 'semantic',
    },
    {
      german: "die Bundesrepublik Deutschland",
      translated: "Republika Njemačka",
      tone: 'semantic',
    },
    {
      german: "die DDR",
      translated: "DDR",
      tone: 'semantic',
    },
    {
      german: "Staat",
      translated: "država",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:204|it": [
    {
      german: "Wie wurden",
      translated: "Come diventarono",
      tone: 'semantic',
    },
    {
      german: "die Bundesrepublik Deutschland",
      translated: "la Repubblica Federale di Germania",
      tone: 'semantic',
    },
    {
      german: "die DDR",
      translated: "la RDT",
      tone: 'semantic',
    },
    {
      german: "Staat",
      translated: "Stato",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:204|kmr": [
    {
      german: "Wie wurden",
      translated: "çawa bûn",
      tone: 'semantic',
    },
    {
      german: "die Bundesrepublik Deutschland",
      translated: "Federal a Almanyayê",
      tone: 'semantic',
    },
    {
      german: "die DDR",
      translated: "DDR",
      tone: 'semantic',
    },
    {
      german: "Staat",
      translated: "dewlet",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:204|pl": [
    {
      german: "Wie wurden",
      translated: "Jak",
      tone: 'semantic',
    },
    {
      german: "die Bundesrepublik Deutschland",
      translated: "Republika Federalna Niemiec",
      tone: 'semantic',
    },
    {
      german: "die DDR",
      translated: "NRD",
      tone: 'semantic',
    },
    {
      german: "Staat",
      translated: "państwem",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:204|prs": [
    {
      german: "Wie wurden",
      translated: "چگونه",
      tone: 'semantic',
    },
    {
      german: "die Bundesrepublik Deutschland",
      translated: "جمهوری فدرال آلمان",
      tone: 'semantic',
    },
    {
      german: "die DDR",
      translated: "جمهوری دموکراتیک آلمان",
      tone: 'semantic',
    },
    {
      german: "Staat",
      translated: "کشور",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:204|ro": [
    {
      german: "Wie wurden",
      translated: "Cum au devenit",
      tone: 'semantic',
    },
    {
      german: "die Bundesrepublik Deutschland",
      translated: "Republica Federală",
      tone: 'semantic',
    },
    {
      german: "die DDR",
      translated: "RDG",
      tone: 'semantic',
    },
    {
      german: "Staat",
      translated: "stat?",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:204|ru": [
    {
      german: "Wie wurden",
      translated: "Как",
      tone: 'semantic',
    },
    {
      german: "die Bundesrepublik Deutschland",
      translated: "ФРГ",
      tone: 'semantic',
    },
    {
      german: "die DDR",
      translated: "ГДР",
      tone: 'semantic',
    },
    {
      german: "Staat",
      translated: "единым государством",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:204|sq": [
    {
      german: "Wie wurden",
      translated: "Si u bënë",
      tone: 'semantic',
    },
    {
      german: "die Bundesrepublik Deutschland",
      translated: "Republika Federale e Gjermanisë",
      tone: 'semantic',
    },
    {
      german: "die DDR",
      translated: "RDGJ-ja",
      tone: 'semantic',
    },
    {
      german: "Staat",
      translated: "shtet i vetëm",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:204|sr": [
    {
      german: "Wie wurden",
      translated: "Kako su",
      tone: 'semantic',
    },
    {
      german: "die Bundesrepublik Deutschland",
      translated: "Republika Nemačka",
      tone: 'semantic',
    },
    {
      german: "die DDR",
      translated: "DDR",
      tone: 'semantic',
    },
    {
      german: "Staat",
      translated: "država",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:204|tr": [
    {
      german: "Wie wurden",
      translated: "nasıl",
      tone: 'semantic',
    },
    {
      german: "die Bundesrepublik Deutschland",
      translated: "Almanya Federal Cumhuriyeti",
      tone: 'semantic',
    },
    {
      german: "die DDR",
      translated: "Doğu Almanya (DDR)",
      tone: 'semantic',
    },
    {
      german: "Staat",
      translated: "tek devlet",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:204|uk": [
    {
      german: "Wie wurden",
      translated: "Як",
      tone: 'semantic',
    },
    {
      german: "die Bundesrepublik Deutschland",
      translated: "Федеративна Республіка Німеччина",
      tone: 'semantic',
    },
    {
      german: "die DDR",
      translated: "НДР",
      tone: 'semantic',
    },
    {
      german: "Staat",
      translated: "державою",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:204|vi": [
    {
      german: "Wie wurden",
      translated: "như thế nào",
      tone: 'semantic',
    },
    {
      german: "die Bundesrepublik Deutschland",
      translated: "Cộng hòa Liên bang Đức",
      tone: 'semantic',
    },
    {
      german: "die DDR",
      translated: "CHDC Đức",
      tone: 'semantic',
    },
    {
      german: "Staat",
      translated: "quốc gia",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:205|ar": [
    {
      german: "Mit dem Beitritt der DDR zur Bundesrepublik Deutschland",
      translated: "بانضمام DDR إلى جمهورية ألمانيا الاتحادية",
      tone: 'semantic',
    },
    {
      german: "gehören die neuen Bundesländer nun auch",
      translated: "أصبحت الولايات الجديدة أيضًا أعضاء في …",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:205|bg": [
    {
      german: "Mit dem Beitritt der DDR zur Bundesrepublik Deutschland",
      translated: "С присъединяването на ГДР към ФРГ",
      tone: 'semantic',
    },
    {
      german: "gehören die neuen Bundesländer nun auch",
      translated: "новите федерални провинции стават членове и на",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:205|bs": [
    {
      german: "Mit dem Beitritt der DDR zur Bundesrepublik Deutschland",
      translated: "Pristupanjem DDR-a Saveznoj Republici Njemačkoj",
      tone: 'semantic',
    },
    {
      german: "gehören die neuen Bundesländer nun auch",
      translated: "nove savezne zemlje postale su i članice",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:205|el": [
    {
      german: "Mit dem Beitritt der DDR zur Bundesrepublik Deutschland",
      translated: "Με την προσχώρηση της ΛΔΓ στην ΟΔΓ",
      tone: 'semantic',
    },
    {
      german: "gehören die neuen Bundesländer nun auch",
      translated: "τα νέα κρατίδια έγιναν επίσης μέλη …",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:205|en": [
    {
      german: "Mit dem Beitritt der DDR zur Bundesrepublik Deutschland",
      translated: "With the GDR's accession to the Federal Republic of Germany",
      tone: 'semantic',
    },
    {
      german: "gehören die neuen Bundesländer nun auch",
      translated: "the new federal states now also belong to",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:205|es": [
    {
      german: "Mit dem Beitritt der DDR zur Bundesrepublik Deutschland",
      translated: "Con la incorporación de la RDA a la República Federal de Alemania",
      tone: 'semantic',
    },
    {
      german: "gehören die neuen Bundesländer nun auch",
      translated: "los nuevos estados federados pasaron también a formar parte de",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:205|fa": [
    {
      german: "Mit dem Beitritt der DDR zur Bundesrepublik Deutschland",
      translated: "با پیوستن جمهوری دموکراتیک آلمان به جمهوری فدرال آلمان",
      tone: 'semantic',
    },
    {
      german: "gehören die neuen Bundesländer nun auch",
      translated: "، ایالت‌های جدید اکنون همچنین عضو … شدند",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:205|fr": [
    {
      german: "Mit dem Beitritt der DDR zur Bundesrepublik Deutschland",
      translated: "Avec l’adhésion de la RDA à la République fédérale d’Allemagne",
      tone: 'semantic',
    },
    {
      german: "gehören die neuen Bundesländer nun auch",
      translated: "les nouveaux Länder appartiennent désormais aussi",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:205|hr": [
    {
      german: "Mit dem Beitritt der DDR zur Bundesrepublik Deutschland",
      translated: "Pristupanjem DDR-a Saveznoj Republici Njemačkoj",
      tone: 'semantic',
    },
    {
      german: "gehören die neuen Bundesländer nun auch",
      translated: "nove savezne zemlje postale su i članice …",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:205|it": [
    {
      german: "Mit dem Beitritt der DDR zur Bundesrepublik Deutschland",
      translated: "Con l’adesione della RDT alla RFG",
      tone: 'semantic',
    },
    {
      german: "gehören die neuen Bundesländer nun auch",
      translated: "i nuovi Länder divennero anche membri",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:205|kmr": [
    {
      german: "Mit dem Beitritt der DDR zur Bundesrepublik Deutschland",
      translated: "Bi tevlîbûna DDR ya Komara Federal",
      tone: 'semantic',
    },
    {
      german: "gehören die neuen Bundesländer nun auch",
      translated: "eyaletên nû jî bûn endamê ",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:205|pl": [
    {
      german: "Mit dem Beitritt der DDR zur Bundesrepublik Deutschland",
      translated: "Wraz z przystąpieniem NRD do RFN",
      tone: 'semantic',
    },
    {
      german: "gehören die neuen Bundesländer nun auch",
      translated: "nowe kraje związkowe stały się również członkami",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:205|prs": [
    {
      german: "Mit dem Beitritt der DDR zur Bundesrepublik Deutschland",
      translated: "با پیوستن جمهوری دموکراتیک آلمان به جمهوری فدرال آلمان",
      tone: 'semantic',
    },
    {
      german: "gehören die neuen Bundesländer nun auch",
      translated: "ایالت‌های جدید اکنون همچنین عضو … شدند.",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:205|ro": [
    {
      german: "Mit dem Beitritt der DDR zur Bundesrepublik Deutschland",
      translated: "Prin aderarea RDG la RFG",
      tone: 'semantic',
    },
    {
      german: "gehören die neuen Bundesländer nun auch",
      translated: "noile landuri au devenit și membre ale …",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:205|ru": [
    {
      german: "Mit dem Beitritt der DDR zur Bundesrepublik Deutschland",
      translated: "С присоединением ГДР к ФРГ",
      tone: 'semantic',
    },
    {
      german: "gehören die neuen Bundesländer nun auch",
      translated: "также входят",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:205|sq": [
    {
      german: "Mit dem Beitritt der DDR zur Bundesrepublik Deutschland",
      translated: "Me bashkimin e RDGJ-së me RFGJ-në",
      tone: 'semantic',
    },
    {
      german: "gehören die neuen Bundesländer nun auch",
      translated: "landet e reja u bënë gjithashtu anëtare të",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:205|sr": [
    {
      german: "Mit dem Beitritt der DDR zur Bundesrepublik Deutschland",
      translated: "Pristupanjem DDR-a Saveznoj Republici Nemačkoj",
      tone: 'semantic',
    },
    {
      german: "gehören die neuen Bundesländer nun auch",
      translated: "su i članice",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:205|tr": [
    {
      german: "Mit dem Beitritt der DDR zur Bundesrepublik Deutschland",
      translated: "Doğu Almanya'nın Almanya Federal Cumhuriyeti'ne katılmasıyla",
      tone: 'semantic',
    },
    {
      german: "gehören die neuen Bundesländer nun auch",
      translated: "yeni eyaletler artık … da üyesi oldu",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:205|uk": [
    {
      german: "Mit dem Beitritt der DDR zur Bundesrepublik Deutschland",
      translated: "Після приєднання НДР до Федеративної Республіки Німеччина",
      tone: 'semantic',
    },
    {
      german: "gehören die neuen Bundesländer nun auch",
      translated: "нові федеральні землі тепер також належать",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:205|vi": [
    {
      german: "Mit dem Beitritt der DDR zur Bundesrepublik Deutschland",
      translated: "Khi CHDC Đức gia nhập Cộng hòa Liên bang Đức",
      tone: 'semantic',
    },
    {
      german: "gehören die neuen Bundesländer nun auch",
      translated: "các bang mới cũng trở thành thành viên",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:206|ar": [
    {
      german: "Woran erinnern",
      translated: "بماذا تذكّر",
      tone: 'semantic',
    },
    {
      german: "die sogenannten „Stolpersteine“",
      translated: "«أحجار التعثر» (Stolpersteine)",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "في ألمانيا",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:206|bg": [
    {
      german: "Woran erinnern",
      translated: "Какво напомнят",
      tone: 'semantic',
    },
    {
      german: "die sogenannten „Stolpersteine“",
      translated: "„Stolpersteine“ (възпоменателните павета)",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "в Германия",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:206|bs": [
    {
      german: "Woran erinnern",
      translated: "Na što",
      tone: 'semantic',
    },
    {
      german: "die sogenannten „Stolpersteine“",
      translated: "„Stolpersteine“ (kameni spoticanja / kameni sjećanja)",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "u Njemačkoj",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:206|el": [
    {
      german: "Woran erinnern",
      translated: "Ποιους τιμούν",
      tone: 'semantic',
    },
    {
      german: "die sogenannten „Stolpersteine“",
      translated: "«Stolpersteine»",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "στη Γερμανία",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:206|en": [
    {
      german: "Woran erinnern",
      translated: "What",
      tone: 'semantic',
    },
    {
      german: "die sogenannten „Stolpersteine“",
      translated: "the so-called 'Stolpersteine'",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "in Germany",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:206|es": [
    {
      german: "Woran erinnern",
      translated: "¿A qué recuerdan",
      tone: 'semantic',
    },
    {
      german: "die sogenannten „Stolpersteine“",
      translated: "las llamadas «Stolpersteine»",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "en Alemania",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:206|fa": [
    {
      german: "Woran erinnern",
      translated: "یادآور چه چیزی هستند",
      tone: 'semantic',
    },
    {
      german: "die sogenannten „Stolpersteine“",
      translated: "«سنگ‌های یادبود» (Stolpersteine)",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "در آلمان",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:206|fr": [
    {
      german: "Woran erinnern",
      translated: "Que commémorent",
      tone: 'semantic',
    },
    {
      german: "die sogenannten „Stolpersteine“",
      translated: "« Stolpersteine »",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "en Allemagne",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:206|hr": [
    {
      german: "Woran erinnern",
      translated: "Na što",
      tone: 'semantic',
    },
    {
      german: "die sogenannten „Stolpersteine“",
      translated: "„Stolpersteine“ (kameni spoticanja / kameni sjećanja)",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "u Njemačkoj",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:206|it": [
    {
      german: "Woran erinnern",
      translated: "Che cosa commemorano",
      tone: 'semantic',
    },
    {
      german: "die sogenannten „Stolpersteine“",
      translated: "le «Stolpersteine» (pietre d’inciampo commemorative)",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "in Germania",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:206|kmr": [
    {
      german: "die sogenannten „Stolpersteine“",
      translated: "«Stolpersteine»",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "li Almanyayê",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:206|pl": [
    {
      german: "Woran erinnern",
      translated: "Kogo upamiętniają",
      tone: 'semantic',
    },
    {
      german: "die sogenannten „Stolpersteine“",
      translated: "„Stolpersteine” (kamienie pamięci)",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "w Niemczech",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:206|prs": [
    {
      german: "Woran erinnern",
      translated: "سنگ‌های یادبود",
      tone: 'semantic',
    },
    {
      german: "die sogenannten „Stolpersteine“",
      translated: "Stolpersteine",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "در آلمان",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:206|ro": [
    {
      german: "Woran erinnern",
      translated: "Pe cine comemorează",
      tone: 'semantic',
    },
    {
      german: "die sogenannten „Stolpersteine“",
      translated: "„Stolpersteine”",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "din Germania",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:206|ru": [
    {
      german: "Woran erinnern",
      translated: "О чём напоминают",
      tone: 'semantic',
    },
    {
      german: "die sogenannten „Stolpersteine“",
      translated: "так называемые «камни преткновения» (Stolpersteine)",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "в Германии?",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:206|sq": [
    {
      german: "Woran erinnern",
      translated: "Kë përkujtojnë",
      tone: 'semantic',
    },
    {
      german: "die sogenannten „Stolpersteine“",
      translated: "«Stolpersteine» (gurët përkujtimorë)",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "në Gjermani",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:206|sr": [
    {
      german: "Woran erinnern",
      translated: "Na šta",
      tone: 'semantic',
    },
    {
      german: "die sogenannten „Stolpersteine“",
      translated: "„Stolpersteine“ (kameni spoticanja / kameni sjećanja)",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "u Nemačkoj",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:206|tr": [
    {
      german: "Woran erinnern",
      translated: "neyi hatırlatır",
      tone: 'semantic',
    },
    {
      german: "die sogenannten „Stolpersteine“",
      translated: "\"Stolpersteine\" olarak adlandırılan tökezleme taşları",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "Almanya'da",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:206|uk": [
    {
      german: "Woran erinnern",
      translated: "нагадують",
      tone: 'semantic',
    },
    {
      german: "die sogenannten „Stolpersteine“",
      translated: "так звані «камені спотикання»",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "в Німеччині",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:206|vi": [
    {
      german: "Woran erinnern",
      translated: "nhắc nhớ điều gì",
      tone: 'semantic',
    },
    {
      german: "die sogenannten „Stolpersteine“",
      translated: "các “Stolpersteine” (đá tưởng niệm)",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "Ở Đức",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:207|ar": [
    {
      german: "In welchem Militärbündnis",
      translated: "في أي حلف عسكري",
      tone: 'semantic',
    },
    {
      german: "war",
      translated: "كانت",
      tone: 'semantic',
    },
    {
      german: "die DDR",
      translated: "DDR",
      tone: 'semantic',
    },
    {
      german: "Mitglied",
      translated: "عضوًا",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:207|bg": [
    {
      german: "In welchem Militärbündnis",
      translated: "Към кой военен съюз",
      tone: 'semantic',
    },
    {
      german: "war",
      translated: "принадлежи",
      tone: 'semantic',
    },
    {
      german: "die DDR",
      translated: "ГДР?",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:207|bs": [
    {
      german: "In welchem Militärbündnis",
      translated: "Kojem je vojnom savezu",
      tone: 'semantic',
    },
    {
      german: "die DDR",
      translated: "DDR",
      tone: 'semantic',
    },
    {
      german: "Mitglied",
      translated: "pripadao",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:207|el": [
    {
      german: "In welchem Militärbündnis",
      translated: "Σε ποια στρατιωτική συμμαχία",
      tone: 'semantic',
    },
    {
      german: "war",
      translated: "ανήκε",
      tone: 'semantic',
    },
    {
      german: "die DDR",
      translated: "η ΛΔΓ",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:207|en": [
    {
      german: "In welchem Militärbündnis",
      translated: "Which military alliance",
      tone: 'semantic',
    },
    {
      german: "war",
      translated: "was",
      tone: 'semantic',
    },
    {
      german: "die DDR",
      translated: "the GDR",
      tone: 'semantic',
    },
    {
      german: "Mitglied",
      translated: "member of",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:207|es": [
    {
      german: "In welchem Militärbündnis",
      translated: "¿De qué alianza militar",
      tone: 'semantic',
    },
    {
      german: "war",
      translated: "era",
      tone: 'semantic',
    },
    {
      german: "die DDR",
      translated: "la RDA",
      tone: 'semantic',
    },
    {
      german: "Mitglied",
      translated: "miembro",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:207|fa": [
    {
      german: "In welchem Militärbündnis",
      translated: "اتحاد نظامی",
      tone: 'semantic',
    },
    {
      german: "war",
      translated: "بود",
      tone: 'semantic',
    },
    {
      german: "die DDR",
      translated: "آلمان",
      tone: 'semantic',
    },
    {
      german: "Mitglied",
      translated: "عضو",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:207|fr": [
    {
      german: "In welchem Militärbündnis",
      translated: "De quelle alliance militaire",
      tone: 'semantic',
    },
    {
      german: "war",
      translated: "était-elle",
      tone: 'semantic',
    },
    {
      german: "die DDR",
      translated: "la RDA",
      tone: 'semantic',
    },
    {
      german: "Mitglied",
      translated: "membre",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:207|hr": [
    {
      german: "In welchem Militärbündnis",
      translated: "Kojem je vojnom savezu",
      tone: 'semantic',
    },
    {
      german: "die DDR",
      translated: "DDR",
      tone: 'semantic',
    },
    {
      german: "Mitglied",
      translated: "pripadao",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:207|it": [
    {
      german: "In welchem Militärbündnis",
      translated: "Di quale alleanza militare",
      tone: 'semantic',
    },
    {
      german: "war",
      translated: "faceva parte",
      tone: 'semantic',
    },
    {
      german: "die DDR",
      translated: "la RDT",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:207|kmr": [
    {
      german: "In welchem Militärbündnis",
      translated: "endamê kîjan peymana leşkerî",
      tone: 'semantic',
    },
    {
      german: "war",
      translated: "bû",
      tone: 'semantic',
    },
    {
      german: "die DDR",
      translated: "DDR",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:207|pl": [
    {
      german: "In welchem Militärbündnis",
      translated: "Do jakiego sojuszu wojskowego",
      tone: 'semantic',
    },
    {
      german: "die DDR",
      translated: "NRD",
      tone: 'semantic',
    },
    {
      german: "Mitglied",
      translated: "należała",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:207|prs": [
    {
      german: "In welchem Militärbündnis",
      translated: "کدام اتحاد نظامی",
      tone: 'semantic',
    },
    {
      german: "Mitglied",
      translated: "عضو",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:207|ro": [
    {
      german: "In welchem Militärbündnis",
      translated: "Din ce alianță militară",
      tone: 'semantic',
    },
    {
      german: "war",
      translated: "făcea",
      tone: 'semantic',
    },
    {
      german: "die DDR",
      translated: "RDG",
      tone: 'semantic',
    },
    {
      german: "Mitglied",
      translated: "parte",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:207|ru": [
    {
      german: "In welchem Militärbündnis",
      translated: "В каком военном союзе",
      tone: 'semantic',
    },
    {
      german: "die DDR",
      translated: "ГДР",
      tone: 'semantic',
    },
    {
      german: "Mitglied",
      translated: "состояла",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:207|sq": [
    {
      german: "In welchem Militärbündnis",
      translated: "Cilës aleancë ushtarake",
      tone: 'semantic',
    },
    {
      german: "war",
      translated: "i përkiste",
      tone: 'semantic',
    },
    {
      german: "die DDR",
      translated: "RDGJ-ja",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:207|sr": [
    {
      german: "In welchem Militärbündnis",
      translated: "je vojnom savezu",
      tone: 'semantic',
    },
    {
      german: "war",
      translated: "pripadao",
      tone: 'semantic',
    },
    {
      german: "die DDR",
      translated: "DDR",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:207|tr": [
    {
      german: "In welchem Militärbündnis",
      translated: "hangi askerî ittifakın",
      tone: 'semantic',
    },
    {
      german: "die DDR",
      translated: "Doğu Almanya (DDR)",
      tone: 'semantic',
    },
    {
      german: "Mitglied",
      translated: "üyesiydi",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:207|uk": [
    {
      german: "In welchem Militärbündnis",
      translated: "якого військового союзу",
      tone: 'semantic',
    },
    {
      german: "war",
      translated: "була",
      tone: 'semantic',
    },
    {
      german: "die DDR",
      translated: "НДР",
      tone: 'semantic',
    },
    {
      german: "Mitglied",
      translated: "Членом",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:207|vi": [
    {
      german: "In welchem Militärbündnis",
      translated: "liên minh quân sự nào",
      tone: 'semantic',
    },
    {
      german: "war",
      translated: "thuộc",
      tone: 'semantic',
    },
    {
      german: "die DDR",
      translated: "CHDC Đức",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:208|ar": [
    {
      german: "Was",
      translated: "ما",
      tone: 'semantic',
    },
    {
      german: "war",
      translated: "كانت",
      tone: 'semantic',
    },
    {
      german: "Stasi",
      translated: "Stasi",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:208|bg": [
    {
      german: "Was",
      translated: "Какво",
      tone: 'semantic',
    },
    {
      german: "war",
      translated: "е",
      tone: 'semantic',
    },
    {
      german: "Stasi",
      translated: "Stasi",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:208|bs": [
    {
      german: "Was",
      translated: "Što",
      tone: 'semantic',
    },
    {
      german: "war",
      translated: "bio",
      tone: 'semantic',
    },
    {
      german: "Stasi",
      translated: "„Stasi“",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:208|el": [
    {
      german: "Was",
      translated: "Τι",
      tone: 'semantic',
    },
    {
      german: "war",
      translated: "ήταν",
      tone: 'semantic',
    },
    {
      german: "die",
      translated: "η",
      tone: 'semantic',
    },
    {
      german: "Stasi",
      translated: "«Stasi»",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:208|en": [
    {
      german: "Was",
      translated: "What",
      tone: 'semantic',
    },
    {
      german: "war",
      translated: "was",
      tone: 'semantic',
    },
    {
      german: "die",
      translated: "the",
      tone: 'semantic',
    },
    {
      german: "Stasi",
      translated: "'Stasi'",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:208|es": [
    {
      german: "Was",
      translated: "¿Qué",
      tone: 'semantic',
    },
    {
      german: "war",
      translated: "era",
      tone: 'semantic',
    },
    {
      german: "die",
      translated: "la",
      tone: 'semantic',
    },
    {
      german: "Stasi",
      translated: "«Stasi»",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:208|fa": [
    {
      german: "Was",
      translated: "چه",
      tone: 'semantic',
    },
    {
      german: "war",
      translated: "بود",
      tone: 'semantic',
    },
    {
      german: "Stasi",
      translated: "«اشتازی»",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:208|fr": [
    {
      german: "Was",
      translated: "Qu’était",
      tone: 'semantic',
    },
    {
      german: "Stasi",
      translated: "Stasi",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:208|hr": [
    {
      german: "Was",
      translated: "Što",
      tone: 'semantic',
    },
    {
      german: "war",
      translated: "bio",
      tone: 'semantic',
    },
    {
      german: "Stasi",
      translated: "Stasi",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:208|it": [
    {
      german: "Was",
      translated: "Che",
      tone: 'semantic',
    },
    {
      german: "war",
      translated: "cos’era",
      tone: 'semantic',
    },
    {
      german: "die",
      translated: "la",
      tone: 'semantic',
    },
    {
      german: "Stasi",
      translated: "Stasi",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:208|kmr": [
    {
      german: "Was",
      translated: "çi",
      tone: 'semantic',
    },
    {
      german: "Stasi",
      translated: "Stasi",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:208|pl": [
    {
      german: "Was",
      translated: "Czym",
      tone: 'semantic',
    },
    {
      german: "war",
      translated: "była",
      tone: 'semantic',
    },
    {
      german: "Stasi",
      translated: "„Stasi”",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:208|prs": [
    {
      german: "Was",
      translated: "چه",
      tone: 'semantic',
    },
    {
      german: "war",
      translated: "بود",
      tone: 'semantic',
    },
    {
      german: "Stasi",
      translated: "اشتازی",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:208|ro": [
    {
      german: "Was",
      translated: "Ce",
      tone: 'semantic',
    },
    {
      german: "war",
      translated: "a fost",
      tone: 'semantic',
    },
    {
      german: "Stasi",
      translated: "„Stasi”",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:208|ru": [
    {
      german: "Was",
      translated: "Что",
      tone: 'semantic',
    },
    {
      german: "Stasi",
      translated: "«Штази»",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:208|sq": [
    {
      german: "Was",
      translated: "Çfarë",
      tone: 'semantic',
    },
    {
      german: "war",
      translated: "ishte",
      tone: 'semantic',
    },
    {
      german: "Stasi",
      translated: "Stasi",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:208|sr": [
    {
      german: "Was",
      translated: "Šta",
      tone: 'semantic',
    },
    {
      german: "war",
      translated: "bio",
      tone: 'semantic',
    },
    {
      german: "Stasi",
      translated: "Stasi",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:208|tr": [
    {
      german: "war",
      translated: "neydi",
      tone: 'semantic',
    },
    {
      german: "Stasi",
      translated: "Stasi",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:208|uk": [
    {
      german: "Was",
      translated: "Що",
      tone: 'semantic',
    },
    {
      german: "war",
      translated: "таке",
      tone: 'semantic',
    },
    {
      german: "Stasi",
      translated: "Stasi",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:208|vi": [
    {
      german: "Was",
      translated: "gì",
      tone: 'semantic',
    },
    {
      german: "war",
      translated: "là",
      tone: 'semantic',
    },
    {
      german: "Stasi",
      translated: "Stasi",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:209|ar": [
    {
      german: "Welches",
      translated: "أي",
      tone: 'semantic',
    },
    {
      german: "war",
      translated: "كان",
      tone: 'semantic',
    },
    {
      german: "das Wappen",
      translated: "شعار",
      tone: 'semantic',
    },
    {
      german: "Deutschen Demokratischen Republik",
      translated: "جمهورية ألمانيا الديمقراطية (DDR)",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:209|bg": [
    {
      german: "Welches",
      translated: "Кой",
      tone: 'semantic',
    },
    {
      german: "war",
      translated: "е",
      tone: 'semantic',
    },
    {
      german: "das Wappen",
      translated: "гербът",
      tone: 'semantic',
    },
    {
      german: "Deutschen Demokratischen Republik",
      translated: "ГДР",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:209|bs": [
    {
      german: "Welches",
      translated: "Koji",
      tone: 'semantic',
    },
    {
      german: "war",
      translated: "je",
      tone: 'semantic',
    },
    {
      german: "das Wappen",
      translated: "grb",
      tone: 'semantic',
    },
    {
      german: "Deutschen Demokratischen Republik",
      translated: "DDR-a",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:209|el": [
    {
      german: "Welches",
      translated: "Ποιο",
      tone: 'semantic',
    },
    {
      german: "war",
      translated: "ήταν",
      tone: 'semantic',
    },
    {
      german: "das Wappen",
      translated: "το έμβλημα",
      tone: 'semantic',
    },
    {
      german: "Deutschen Demokratischen Republik",
      translated: "της ΛΔΓ;",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:209|en": [
    {
      german: "Welches",
      translated: "Which",
      tone: 'semantic',
    },
    {
      german: "war",
      translated: "was",
      tone: 'semantic',
    },
    {
      german: "das Wappen",
      translated: "the coat of arms",
      tone: 'semantic',
    },
    {
      german: "Deutschen Demokratischen Republik",
      translated: "the German Democratic Republic",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:209|es": [
    {
      german: "Welches",
      translated: "¿Cuál",
      tone: 'semantic',
    },
    {
      german: "war",
      translated: "era",
      tone: 'semantic',
    },
    {
      german: "das Wappen",
      translated: "el escudo de armas",
      tone: 'semantic',
    },
    {
      german: "Deutschen Demokratischen Republik",
      translated: "la República Democrática Alemana (RDA)",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:209|fa": [
    {
      german: "Welches",
      translated: "کدام",
      tone: 'semantic',
    },
    {
      german: "war",
      translated: "بود",
      tone: 'semantic',
    },
    {
      german: "das Wappen",
      translated: "نشان",
      tone: 'semantic',
    },
    {
      german: "Deutschen Demokratischen Republik",
      translated: "جمهوری دموکراتیک آلمان",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:209|fr": [
    {
      german: "Welches",
      translated: "Quel",
      tone: 'semantic',
    },
    {
      german: "war",
      translated: "était",
      tone: 'semantic',
    },
    {
      german: "das Wappen",
      translated: "le blason",
      tone: 'semantic',
    },
    {
      german: "Deutschen Demokratischen Republik",
      translated: "République démocratique allemande",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:209|hr": [
    {
      german: "Welches",
      translated: "Koji",
      tone: 'semantic',
    },
    {
      german: "war",
      translated: "je",
      tone: 'semantic',
    },
    {
      german: "das Wappen",
      translated: "grb",
      tone: 'semantic',
    },
    {
      german: "Deutschen Demokratischen Republik",
      translated: "grb DDR-a",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:209|it": [
    {
      german: "Welches",
      translated: "Qual",
      tone: 'semantic',
    },
    {
      german: "war",
      translated: "era",
      tone: 'semantic',
    },
    {
      german: "das Wappen",
      translated: "lo stemma",
      tone: 'semantic',
    },
    {
      german: "Deutschen Demokratischen Republik",
      translated: "RDT",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:209|kmr": [
    {
      german: "Welches",
      translated: "Kîjan",
      tone: 'semantic',
    },
    {
      german: "war",
      translated: "bû",
      tone: 'semantic',
    },
    {
      german: "das Wappen",
      translated: "nîşana",
      tone: 'semantic',
    },
    {
      german: "Deutschen Demokratischen Republik",
      translated: "DDR",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:209|pl": [
    {
      german: "Welches",
      translated: "Który",
      tone: 'semantic',
    },
    {
      german: "war",
      translated: "był",
      tone: 'semantic',
    },
    {
      german: "das Wappen",
      translated: "herbem",
      tone: 'semantic',
    },
    {
      german: "Deutschen Demokratischen Republik",
      translated: "NRD",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:209|prs": [
    {
      german: "Welches",
      translated: "کدام",
      tone: 'semantic',
    },
    {
      german: "das Wappen",
      translated: "نشان",
      tone: 'semantic',
    },
    {
      german: "Deutschen Demokratischen Republik",
      translated: "جمهوری دموکراتیک آلمان",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:209|ro": [
    {
      german: "Welches",
      translated: "Care",
      tone: 'semantic',
    },
    {
      german: "war",
      translated: "era",
      tone: 'semantic',
    },
    {
      german: "das Wappen",
      translated: "stema",
      tone: 'semantic',
    },
    {
      german: "Deutschen Demokratischen Republik",
      translated: "RDG",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:209|ru": [
    {
      german: "Welches",
      translated: "Какой",
      tone: 'semantic',
    },
    {
      german: "war",
      translated: "был",
      tone: 'semantic',
    },
    {
      german: "das Wappen",
      translated: "герб",
      tone: 'semantic',
    },
    {
      german: "Deutschen Demokratischen Republik",
      translated: "Германской Демократической Республики",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:209|sq": [
    {
      german: "Welches",
      translated: "Cila",
      tone: 'semantic',
    },
    {
      german: "war",
      translated: " ishte",
      tone: 'semantic',
    },
    {
      german: "das Wappen",
      translated: "stema",
      tone: 'semantic',
    },
    {
      german: "Deutschen Demokratischen Republik",
      translated: "RDGJ-së",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:209|sr": [
    {
      german: "Welches",
      translated: "Koji",
      tone: 'semantic',
    },
    {
      german: "war",
      translated: "je",
      tone: 'semantic',
    },
    {
      german: "das Wappen",
      translated: "grb",
      tone: 'semantic',
    },
    {
      german: "Deutschen Demokratischen Republik",
      translated: "DDR-a",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:209|tr": [
    {
      german: "Welches",
      translated: "hangisiydi",
      tone: 'semantic',
    },
    {
      german: "das Wappen",
      translated: "arması",
      tone: 'semantic',
    },
    {
      german: "Deutschen Demokratischen Republik",
      translated: "Alman Demokratik Cumhuriyeti'nin (DDR)",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:209|uk": [
    {
      german: "Welches",
      translated: "Яким",
      tone: 'semantic',
    },
    {
      german: "war",
      translated: "був",
      tone: 'semantic',
    },
    {
      german: "das Wappen",
      translated: "герб",
      tone: 'semantic',
    },
    {
      german: "Deutschen Demokratischen Republik",
      translated: "Німецької Демократичної Республіки",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:209|vi": [
    {
      german: "Welches",
      translated: "hình nào",
      tone: 'semantic',
    },
    {
      german: "war",
      translated: "là",
      tone: 'semantic',
    },
    {
      german: "das Wappen",
      translated: "Quốc huy",
      tone: 'semantic',
    },
    {
      german: "Deutschen Demokratischen Republik",
      translated: "CHDC Đức",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:20|ar": [
    {
      german: "Eine Partei",
      translated: "حزب",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "في ألمانيا",
      tone: 'semantic',
    },
    {
      german: "verfolgt das Ziel",
      translated: "يسعى",
      tone: 'semantic',
    },
    {
      german: "eine Diktatur zu errichten",
      translated: "إقامة ديكتاتورية",
      tone: 'semantic',
    },
    {
      german: "Sie ist dann",
      translated: "عندئذ يكون هذا الحزب …",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:20|bg": [
    {
      german: "Eine Partei",
      translated: "Партия",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "в Германия",
      tone: 'semantic',
    },
    {
      german: "verfolgt das Ziel",
      translated: "иска",
      tone: 'semantic',
    },
    {
      german: "eine Diktatur zu errichten",
      translated: "да установи диктатура",
      tone: 'semantic',
    },
    {
      german: "Sie ist dann",
      translated: "Такава партия е …",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:20|bs": [
    {
      german: "Eine Partei",
      translated: "Stranka",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "u Njemačkoj",
      tone: 'semantic',
    },
    {
      german: "verfolgt das Ziel",
      translated: "želi",
      tone: 'semantic',
    },
    {
      german: "eine Diktatur zu errichten",
      translated: "uspostaviti diktaturu",
      tone: 'semantic',
    },
    {
      german: "Sie ist dann",
      translated: "Takva je stranka",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:20|el": [
    {
      german: "Eine Partei",
      translated: "Ένα κόμμα",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "στη Γερμανία",
      tone: 'semantic',
    },
    {
      german: "verfolgt das Ziel",
      translated: "θέλει να εγκαθιδρύσει",
      tone: 'semantic',
    },
    {
      german: "eine Diktatur zu errichten",
      translated: "δικτατορία",
      tone: 'semantic',
    },
    {
      german: "Sie ist dann",
      translated: "Ένα τέτοιο κόμμα είναι …",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:20|en": [
    {
      german: "Eine Partei",
      translated: "A party",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "in Germany",
      tone: 'semantic',
    },
    {
      german: "verfolgt das Ziel",
      translated: "pursues the goal",
      tone: 'semantic',
    },
    {
      german: "eine Diktatur zu errichten",
      translated: "establishing a dictatorship",
      tone: 'semantic',
    },
    {
      german: "Sie ist dann",
      translated: "It is then",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:20|es": [
    {
      german: "Eine Partei",
      translated: "Un partido",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "en Alemania",
      tone: 'semantic',
    },
    {
      german: "verfolgt das Ziel",
      translated: "persigue el objetivo",
      tone: 'semantic',
    },
    {
      german: "eine Diktatur zu errichten",
      translated: "establecer una dictadura",
      tone: 'semantic',
    },
    {
      german: "Sie ist dann",
      translated: "En ese caso es",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:20|fa": [
    {
      german: "Eine Partei",
      translated: "یک حزب",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "در آلمان",
      tone: 'semantic',
    },
    {
      german: "verfolgt das Ziel",
      translated: "می‌خواهد",
      tone: 'semantic',
    },
    {
      german: "eine Diktatur zu errichten",
      translated: "دیکتاتوری برقرار کند",
      tone: 'semantic',
    },
    {
      german: "Sie ist dann",
      translated: "چنین حزبی … است",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:20|fr": [
    {
      german: "Eine Partei",
      translated: "Un parti",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "en Allemagne",
      tone: 'semantic',
    },
    {
      german: "verfolgt das Ziel",
      translated: "veut",
      tone: 'semantic',
    },
    {
      german: "eine Diktatur zu errichten",
      translated: "instaurer une dictature",
      tone: 'semantic',
    },
    {
      german: "Sie ist dann",
      translated: "Ce parti est alors",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:20|hr": [
    {
      german: "Eine Partei",
      translated: "Stranka",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "u Njemačkoj",
      tone: 'semantic',
    },
    {
      german: "verfolgt das Ziel",
      translated: "želi",
      tone: 'semantic',
    },
    {
      german: "eine Diktatur zu errichten",
      translated: "uspostaviti diktaturu",
      tone: 'semantic',
    },
    {
      german: "Sie ist dann",
      translated: "Takva je stranka",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:20|it": [
    {
      german: "Eine Partei",
      translated: "Un partito",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "in Germania",
      tone: 'semantic',
    },
    {
      german: "verfolgt das Ziel",
      translated: "vuole",
      tone: 'semantic',
    },
    {
      german: "eine Diktatur zu errichten",
      translated: "instaurare una dittatura",
      tone: 'semantic',
    },
    {
      german: "Sie ist dann",
      translated: "Questo partito è",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:20|kmr": [
    {
      german: "Eine Partei",
      translated: "ev parti",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "li Almanyayê",
      tone: 'semantic',
    },
    {
      german: "verfolgt das Ziel",
      translated: "dixwaze",
      tone: 'semantic',
    },
    {
      german: "eine Diktatur zu errichten",
      translated: "dîktatoriyek ava bike",
      tone: 'semantic',
    },
    {
      german: "Sie ist dann",
      translated: "Wê demê",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:20|pl": [
    {
      german: "Eine Partei",
      translated: "Partia",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "w Niemczech",
      tone: 'semantic',
    },
    {
      german: "verfolgt das Ziel",
      translated: "chce ustanowić",
      tone: 'semantic',
    },
    {
      german: "eine Diktatur zu errichten",
      translated: "dyktaturę",
      tone: 'semantic',
    },
    {
      german: "Sie ist dann",
      translated: "Taka partia jest",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:20|prs": [
    {
      german: "Eine Partei",
      translated: "یک حزب",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "در آلمان",
      tone: 'semantic',
    },
    {
      german: "verfolgt das Ziel",
      translated: "می‌خواهد",
      tone: 'semantic',
    },
    {
      german: "eine Diktatur zu errichten",
      translated: "دیکتاتوری برقرار کند",
      tone: 'semantic',
    },
    {
      german: "Sie ist dann",
      translated: "چنین حزبی … است",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:20|ro": [
    {
      german: "Eine Partei",
      translated: "Un partid",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "din Germania",
      tone: 'semantic',
    },
    {
      german: "verfolgt das Ziel",
      translated: "vrea să instaureze",
      tone: 'semantic',
    },
    {
      german: "eine Diktatur zu errichten",
      translated: "o dictatură",
      tone: 'semantic',
    },
    {
      german: "Sie ist dann",
      translated: "Un astfel de partid este",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:20|ru": [
    {
      german: "Eine Partei",
      translated: "Одна из партий",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "в Германии",
      tone: 'semantic',
    },
    {
      german: "verfolgt das Ziel",
      translated: "преследует цель",
      tone: 'semantic',
    },
    {
      german: "eine Diktatur zu errichten",
      translated: "установить диктатуру",
      tone: 'semantic',
    },
    {
      german: "Sie ist dann",
      translated: "В этом случае она является",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:20|sq": [
    {
      german: "Eine Partei",
      translated: "Një parti",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "në Gjermani",
      tone: 'semantic',
    },
    {
      german: "verfolgt das Ziel",
      translated: "dëshiron të vendosë",
      tone: 'semantic',
    },
    {
      german: "eine Diktatur zu errichten",
      translated: "diktaturë",
      tone: 'semantic',
    },
    {
      german: "Sie ist dann",
      translated: "Kjo parti është …",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:20|sr": [
    {
      german: "Eine Partei",
      translated: "Stranka",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "u Nemačkoj",
      tone: 'semantic',
    },
    {
      german: "verfolgt das Ziel",
      translated: "želi",
      tone: 'semantic',
    },
    {
      german: "eine Diktatur zu errichten",
      translated: "uspostaviti diktaturu",
      tone: 'semantic',
    },
    {
      german: "Sie ist dann",
      translated: "Takva je stranka",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:20|tr": [
    {
      german: "Eine Partei",
      translated: "bir parti",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "Almanya'da",
      tone: 'semantic',
    },
    {
      german: "verfolgt das Ziel",
      translated: "amaçlıyorsa",
      tone: 'semantic',
    },
    {
      german: "eine Diktatur zu errichten",
      translated: "diktatörlük kurmayı",
      tone: 'semantic',
    },
    {
      german: "Sie ist dann",
      translated: "bu parti",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:20|uk": [
    {
      german: "Eine Partei",
      translated: "Партія",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "в Німеччині",
      tone: 'semantic',
    },
    {
      german: "verfolgt das Ziel",
      translated: "прагне",
      tone: 'semantic',
    },
    {
      german: "eine Diktatur zu errichten",
      translated: "встановити диктатуру",
      tone: 'semantic',
    },
    {
      german: "Sie ist dann",
      translated: "Тоді ця партія є",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:20|vi": [
    {
      german: "Eine Partei",
      translated: "Một đảng",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "ở Đức",
      tone: 'semantic',
    },
    {
      german: "verfolgt das Ziel",
      translated: "muốn thiết lập chế độ độc tài",
      tone: 'semantic',
    },
    {
      german: "Sie ist dann",
      translated: "Đảng đó là",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:210|ar": [
    {
      german: "Was ereignete sich",
      translated: "ماذا حدث",
      tone: 'semantic',
    },
    {
      german: "am 17. Juni 1953",
      translated: "في 17 يونيو/حزيران 1953",
      tone: 'semantic',
    },
    {
      german: "in der DDR?",
      translated: "في DDR",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:210|bg": [
    {
      german: "Was ereignete sich",
      translated: "Какво се случва",
      tone: 'semantic',
    },
    {
      german: "am 17. Juni 1953",
      translated: "на 17 юни 1953 г.",
      tone: 'semantic',
    },
    {
      german: "in der DDR?",
      translated: "в ГДР",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:210|bs": [
    {
      german: "Was ereignete sich",
      translated: "Što se dogodilo",
      tone: 'semantic',
    },
    {
      german: "am 17. Juni 1953",
      translated: "17. juna 1953.",
      tone: 'semantic',
    },
    {
      german: "in der DDR?",
      translated: "u DDR-u",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:210|el": [
    {
      german: "Was ereignete sich",
      translated: "Τι συνέβη",
      tone: 'semantic',
    },
    {
      german: "am 17. Juni 1953",
      translated: "στις 17 Ιουνίου 1953",
      tone: 'semantic',
    },
    {
      german: "in der DDR?",
      translated: "στη ΛΔΓ",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:210|en": [
    {
      german: "Was ereignete sich",
      translated: "What happened",
      tone: 'semantic',
    },
    {
      german: "am 17. Juni 1953",
      translated: "on June 17, 1953",
      tone: 'semantic',
    },
    {
      german: "in der DDR?",
      translated: "in the GDR?",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:210|es": [
    {
      german: "Was ereignete sich",
      translated: "¿Qué ocurrió el",
      tone: 'semantic',
    },
    {
      german: "am 17. Juni 1953",
      translated: "17 de junio de 1953",
      tone: 'semantic',
    },
    {
      german: "in der DDR?",
      translated: "en la RDA?",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:210|fa": [
    {
      german: "Was ereignete sich",
      translated: "چه اتفاقی افتاد",
      tone: 'semantic',
    },
    {
      german: "am 17. Juni 1953",
      translated: "در ۱۷ ژوئن ۱۹۵۳",
      tone: 'semantic',
    },
    {
      german: "in der DDR?",
      translated: "در جمهوری دموکراتیک آلمان",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:210|fr": [
    {
      german: "Was ereignete sich",
      translated: "Que s’est-il passé",
      tone: 'semantic',
    },
    {
      german: "am 17. Juni 1953",
      translated: "le 17 juin 1953",
      tone: 'semantic',
    },
    {
      german: "in der DDR?",
      translated: "en RDA ?",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:210|hr": [
    {
      german: "Was ereignete sich",
      translated: "Što se dogodilo",
      tone: 'semantic',
    },
    {
      german: "am 17. Juni 1953",
      translated: "17. lipnja 1953.",
      tone: 'semantic',
    },
    {
      german: "in der DDR?",
      translated: "u DDR-u",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:210|it": [
    {
      german: "Was ereignete sich",
      translated: "Che cosa accadde",
      tone: 'semantic',
    },
    {
      german: "am 17. Juni 1953",
      translated: "il 17 giugno 1953",
      tone: 'semantic',
    },
    {
      german: "in der DDR?",
      translated: "nella RDT",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:210|kmr": [
    {
      german: "Was ereignete sich",
      translated: "qewimî",
      tone: 'semantic',
    },
    {
      german: "am 17. Juni 1953",
      translated: "17ê Hezîrana 1953",
      tone: 'semantic',
    },
    {
      german: "in der DDR?",
      translated: "li DDR",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:210|pl": [
    {
      german: "Was ereignete sich",
      translated: "Co wydarzyło się",
      tone: 'semantic',
    },
    {
      german: "am 17. Juni 1953",
      translated: "17 czerwca 1953",
      tone: 'semantic',
    },
    {
      german: "in der DDR?",
      translated: "w NRD",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:210|prs": [
    {
      german: "Was ereignete sich",
      translated: "چه اتفاقی افتاد",
      tone: 'semantic',
    },
    {
      german: "am 17. Juni 1953",
      translated: "در ۱۷ ژوئن ۱۹۵۳",
      tone: 'semantic',
    },
    {
      german: "in der DDR?",
      translated: "در جمهوری دموکراتیک آلمان",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:210|ro": [
    {
      german: "Was ereignete sich",
      translated: "Ce s-a întâmplat",
      tone: 'semantic',
    },
    {
      german: "am 17. Juni 1953",
      translated: "la 17 iunie 1953",
      tone: 'semantic',
    },
    {
      german: "in der DDR?",
      translated: "în RDG",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:210|ru": [
    {
      german: "Was ereignete sich",
      translated: "Что произошло",
      tone: 'semantic',
    },
    {
      german: "am 17. Juni 1953",
      translated: "17 июня 1953 года",
      tone: 'semantic',
    },
    {
      german: "in der DDR?",
      translated: "в ГДР",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:210|sq": [
    {
      german: "Was ereignete sich",
      translated: "Çfarë ndodhi",
      tone: 'semantic',
    },
    {
      german: "am 17. Juni 1953",
      translated: "më 17 qershor 1953",
      tone: 'semantic',
    },
    {
      german: "in der DDR?",
      translated: "në RDGJ",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:210|sr": [
    {
      german: "Was ereignete sich",
      translated: "Šta se",
      tone: 'semantic',
    },
    {
      german: "am 17. Juni 1953",
      translated: "17. juna 1953",
      tone: 'semantic',
    },
    {
      german: "in der DDR?",
      translated: "u DDR-u",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:210|tr": [
    {
      german: "Was ereignete sich",
      translated: "ne oldu",
      tone: 'semantic',
    },
    {
      german: "am 17. Juni 1953",
      translated: "17 Haziran 1953'te",
      tone: 'semantic',
    },
    {
      german: "in der DDR?",
      translated: "Doğu Almanya'da",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:210|uk": [
    {
      german: "Was ereignete sich",
      translated: "Що сталося",
      tone: 'semantic',
    },
    {
      german: "am 17. Juni 1953",
      translated: "17 червня 1953",
      tone: 'semantic',
    },
    {
      german: "in der DDR?",
      translated: "в НДР?",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:210|vi": [
    {
      german: "Was ereignete sich",
      translated: "Điều gì xảy ra",
      tone: 'semantic',
    },
    {
      german: "am 17. Juni 1953",
      translated: "ngày 17 tháng 6 năm 1953",
      tone: 'semantic',
    },
    {
      german: "in der DDR?",
      translated: "ở CHDC Đức",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:211|ar": [
    {
      german: "Welcher Politiker",
      translated: "أي سياسي",
      tone: 'semantic',
    },
    {
      german: "steht für",
      translated: "يرتبط اسمه بـ",
      tone: 'semantic',
    },
    {
      german: "die \"Ostverträge\"",
      translated: "«المعاهدات الشرقية» (Ostverträge)",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:211|bg": [
    {
      german: "Welcher Politiker",
      translated: "Кой политик",
      tone: 'semantic',
    },
    {
      german: "steht für",
      translated: "се свързва с",
      tone: 'semantic',
    },
    {
      german: "die \"Ostverträge\"",
      translated: "„Ostverträge“",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:211|bs": [
    {
      german: "Welcher Politiker",
      translated: "Koji je političar",
      tone: 'semantic',
    },
    {
      german: "steht für",
      translated: "povezan s",
      tone: 'semantic',
    },
    {
      german: "die \"Ostverträge\"",
      translated: "„Ostverträge“ (istočnim ugovorima)",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:211|el": [
    {
      german: "Welcher Politiker",
      translated: "Ποιος πολιτικός",
      tone: 'semantic',
    },
    {
      german: "steht für",
      translated: "συνδέεται με",
      tone: 'semantic',
    },
    {
      german: "die \"Ostverträge\"",
      translated: "τις «Ostverträge»",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:211|en": [
    {
      german: "Welcher Politiker",
      translated: "Which politician",
      tone: 'semantic',
    },
    {
      german: "steht für",
      translated: "is associated with",
      tone: 'semantic',
    },
    {
      german: "die \"Ostverträge\"",
      translated: "the 'Ostverträge'",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:211|es": [
    {
      german: "Welcher Politiker",
      translated: "¿Qué político",
      tone: 'semantic',
    },
    {
      german: "steht für",
      translated: "está relacionado con",
      tone: 'semantic',
    },
    {
      german: "die \"Ostverträge\"",
      translated: "los «Tratados del Este»",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:211|fa": [
    {
      german: "Welcher Politiker",
      translated: "کدام سیاستمدار",
      tone: 'semantic',
    },
    {
      german: "steht für",
      translated: "مرتبط است",
      tone: 'semantic',
    },
    {
      german: "die \"Ostverträge\"",
      translated: "«پیمان‌های شرقی» (Ostverträge)",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:211|fr": [
    {
      german: "Welcher Politiker",
      translated: "Quel homme politique",
      tone: 'semantic',
    },
    {
      german: "steht für",
      translated: "est associé aux",
      tone: 'semantic',
    },
    {
      german: "die \"Ostverträge\"",
      translated: "« traités de l’Est » (Ostverträge)",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:211|hr": [
    {
      german: "Welcher Politiker",
      translated: "Koji je političar",
      tone: 'semantic',
    },
    {
      german: "steht für",
      translated: "povezan s",
      tone: 'semantic',
    },
    {
      german: "die \"Ostverträge\"",
      translated: "„Ostverträge“ (istočnim ugovorima)",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:211|it": [
    {
      german: "Welcher Politiker",
      translated: "Quale politico",
      tone: 'semantic',
    },
    {
      german: "steht für",
      translated: "è associato",
      tone: 'semantic',
    },
    {
      german: "die \"Ostverträge\"",
      translated: "agli «Ostverträge»",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:211|kmr": [
    {
      german: "Welcher Politiker",
      translated: "Kîjan siyasetmedar",
      tone: 'semantic',
    },
    {
      german: "steht für",
      translated: "tê girêdan",
      tone: 'semantic',
    },
    {
      german: "die \"Ostverträge\"",
      translated: "«Ostverträge»",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:211|pl": [
    {
      german: "Welcher Politiker",
      translated: "Który polityk",
      tone: 'semantic',
    },
    {
      german: "steht für",
      translated: "jest kojarzony z",
      tone: 'semantic',
    },
    {
      german: "die \"Ostverträge\"",
      translated: "„Ostverträge” (traktatami wschodnimi)",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:211|prs": [
    {
      german: "Welcher Politiker",
      translated: "کدام سیاستمدار",
      tone: 'semantic',
    },
    {
      german: "steht für",
      translated: "مرتبط است",
      tone: 'semantic',
    },
    {
      german: "die \"Ostverträge\"",
      translated: "«پیمان‌های شرقی» (Ostverträge)",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:211|ro": [
    {
      german: "Welcher Politiker",
      translated: "Ce politician",
      tone: 'semantic',
    },
    {
      german: "steht für",
      translated: "este asociat cu",
      tone: 'semantic',
    },
    {
      german: "die \"Ostverträge\"",
      translated: "„Ostverträge”",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:211|ru": [
    {
      german: "Welcher Politiker",
      translated: "Какой политик",
      tone: 'semantic',
    },
    {
      german: "steht für",
      translated: "ассоциируется с",
      tone: 'semantic',
    },
    {
      german: "die \"Ostverträge\"",
      translated: "«восточными договорами»",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:211|sq": [
    {
      german: "Welcher Politiker",
      translated: "Cili politikan",
      tone: 'semantic',
    },
    {
      german: "steht für",
      translated: "lidhet me",
      tone: 'semantic',
    },
    {
      german: "die \"Ostverträge\"",
      translated: "«Ostverträge»",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:211|sr": [
    {
      german: "Welcher Politiker",
      translated: "Koji je političar",
      tone: 'semantic',
    },
    {
      german: "steht für",
      translated: "povezan s",
      tone: 'semantic',
    },
    {
      german: "die \"Ostverträge\"",
      translated: "„Ostverträge“ (istočnim ugovorima)",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:211|tr": [
    {
      german: "Welcher Politiker",
      translated: "hangi siyasetçiyle",
      tone: 'semantic',
    },
    {
      german: "steht für",
      translated: "özdeşleşir",
      tone: 'semantic',
    },
    {
      german: "die \"Ostverträge\"",
      translated: "\"Doğu Antlaşmaları\"",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:211|uk": [
    {
      german: "Welcher Politiker",
      translated: "З яким політиком",
      tone: 'semantic',
    },
    {
      german: "steht für",
      translated: "пов’язані",
      tone: 'semantic',
    },
    {
      german: "die \"Ostverträge\"",
      translated: "«східні договори» (Ostverträge",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:211|vi": [
    {
      german: "Welcher Politiker",
      translated: "Chính trị gia nào",
      tone: 'semantic',
    },
    {
      german: "steht für",
      translated: "gắn với",
      tone: 'semantic',
    },
    {
      german: "die \"Ostverträge\"",
      translated: "các “Ostverträge” (Hiệp ước phía Đông)",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:212|ar": [
    {
      german: "Wie heißt",
      translated: "ما الاسم",
      tone: 'semantic',
    },
    {
      german: "Deutschland",
      translated: "لألمانيا",
      tone: 'semantic',
    },
    {
      german: "mit vollem Namen",
      translated: "الكامل",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:212|bg": [
    {
      german: "Wie heißt",
      translated: "Как е",
      tone: 'semantic',
    },
    {
      german: "Deutschland",
      translated: "Германия",
      tone: 'semantic',
    },
    {
      german: "mit vollem Namen",
      translated: "пълното наименование",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:212|bs": [
    {
      german: "Wie heißt",
      translated: "Koji je",
      tone: 'semantic',
    },
    {
      german: "Deutschland",
      translated: "Njemačke",
      tone: 'semantic',
    },
    {
      german: "mit vollem Namen",
      translated: "puni naziv",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:212|el": [
    {
      german: "Wie heißt",
      translated: "Ποια είναι",
      tone: 'semantic',
    },
    {
      german: "Deutschland",
      translated: " της Γερμανίας",
      tone: 'semantic',
    },
    {
      german: "mit vollem Namen",
      translated: "πλήρης ονομασία",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:212|en": [
    {
      german: "Wie heißt",
      translated: "What",
      tone: 'semantic',
    },
    {
      german: "Deutschland",
      translated: "Germany's",
      tone: 'semantic',
    },
    {
      german: "mit vollem Namen",
      translated: "full name",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:212|es": [
    {
      german: "Wie heißt",
      translated: "¿Cuál es",
      tone: 'semantic',
    },
    {
      german: "Deutschland",
      translated: "Alemania",
      tone: 'semantic',
    },
    {
      german: "mit vollem Namen",
      translated: "nombre completo",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:212|fa": [
    {
      german: "Wie heißt",
      translated: "نام",
      tone: 'semantic',
    },
    {
      german: "Deutschland",
      translated: "آلمان",
      tone: 'semantic',
    },
    {
      german: "mit vollem Namen",
      translated: "چیست؟",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:212|fr": [
    {
      german: "Wie heißt",
      translated: "Quel est",
      tone: 'semantic',
    },
    {
      german: "Deutschland",
      translated: "l’Allemagne",
      tone: 'semantic',
    },
    {
      german: "mit vollem Namen",
      translated: "nom complet",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:212|hr": [
    {
      german: "Wie heißt",
      translated: "Koji je",
      tone: 'semantic',
    },
    {
      german: "Deutschland",
      translated: "Njemačke",
      tone: 'semantic',
    },
    {
      german: "mit vollem Namen",
      translated: "puni naziv",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:212|it": [
    {
      german: "Wie heißt",
      translated: "Qual è",
      tone: 'semantic',
    },
    {
      german: "Deutschland",
      translated: "della Germania",
      tone: 'semantic',
    },
    {
      german: "mit vollem Namen",
      translated: "il nome completo",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:212|kmr": [
    {
      german: "Wie heißt",
      translated: "çi ye",
      tone: 'semantic',
    },
    {
      german: "Deutschland",
      translated: "Almanyayê",
      tone: 'semantic',
    },
    {
      german: "mit vollem Namen",
      translated: "Navê tevahî",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:212|pl": [
    {
      german: "Wie heißt",
      translated: "Jaka jest",
      tone: 'semantic',
    },
    {
      german: "Deutschland",
      translated: "Niemiec",
      tone: 'semantic',
    },
    {
      german: "mit vollem Namen",
      translated: "pełna nazwa",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:212|prs": [
    {
      german: "Wie heißt",
      translated: "چیست",
      tone: 'semantic',
    },
    {
      german: "Deutschland",
      translated: "آلمان",
      tone: 'semantic',
    },
    {
      german: "mit vollem Namen",
      translated: "نام کامل",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:212|ro": [
    {
      german: "Wie heißt",
      translated: "Care este",
      tone: 'semantic',
    },
    {
      german: "Deutschland",
      translated: "Germaniei",
      tone: 'semantic',
    },
    {
      german: "mit vollem Namen",
      translated: "denumirea completă",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:212|ru": [
    {
      german: "Wie heißt",
      translated: "Как называется",
      tone: 'semantic',
    },
    {
      german: "Deutschland",
      translated: "Германия",
      tone: 'semantic',
    },
    {
      german: "mit vollem Namen",
      translated: "полностью",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:212|sq": [
    {
      german: "Wie heißt",
      translated: "Cili është emri",
      tone: 'semantic',
    },
    {
      german: "Deutschland",
      translated: "Gjermanisë",
      tone: 'semantic',
    },
    {
      german: "mit vollem Namen",
      translated: "i plotë",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:212|sr": [
    {
      german: "Wie heißt",
      translated: "Koji je",
      tone: 'semantic',
    },
    {
      german: "Deutschland",
      translated: "Nemačke",
      tone: 'semantic',
    },
    {
      german: "mit vollem Namen",
      translated: "puni naziv",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:212|tr": [
    {
      german: "Wie heißt",
      translated: "nedir",
      tone: 'semantic',
    },
    {
      german: "Deutschland",
      translated: "Almanya'nın",
      tone: 'semantic',
    },
    {
      german: "mit vollem Namen",
      translated: "tam resmî adı",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:212|uk": [
    {
      german: "Wie heißt",
      translated: "Яка",
      tone: 'semantic',
    },
    {
      german: "Deutschland",
      translated: "Німеччини",
      tone: 'semantic',
    },
    {
      german: "mit vollem Namen",
      translated: "повна назва",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:212|vi": [
    {
      german: "Wie heißt",
      translated: "của",
      tone: 'semantic',
    },
    {
      german: "Deutschland",
      translated: "Đức",
      tone: 'semantic',
    },
    {
      german: "mit vollem Namen",
      translated: "Tên đầy đủ",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:213|ar": [
    {
      german: "Wie viele Einwohner",
      translated: "كم يبلغ عدد سكان",
      tone: 'semantic',
    },
    {
      german: "Deutschland",
      translated: "ألمانيا",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:213|bg": [
    {
      german: "Wie viele Einwohner",
      translated: "Приблизително колко",
      tone: 'semantic',
    },
    {
      german: "Deutschland",
      translated: "Германия",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:213|bs": [
    {
      german: "Wie viele Einwohner",
      translated: "Koliko stanovnika",
      tone: 'semantic',
    },
    {
      german: "Deutschland",
      translated: "Njemačka",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:213|el": [
    {
      german: "Wie viele Einwohner",
      translated: "Περίπου πόσους κατοίκους",
      tone: 'semantic',
    },
    {
      german: "Deutschland",
      translated: "Γερμανία",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:213|en": [
    {
      german: "Wie viele Einwohner",
      translated: "How many inhabitants",
      tone: 'semantic',
    },
    {
      german: "Deutschland",
      translated: "Germany",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:213|es": [
    {
      german: "Wie viele Einwohner",
      translated: "¿Cuántos habitantes tiene",
      tone: 'semantic',
    },
    {
      german: "Deutschland",
      translated: "Alemania",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:213|fa": [
    {
      german: "Wie viele Einwohner",
      translated: "چند نفر جمعیت",
      tone: 'semantic',
    },
    {
      german: "Deutschland",
      translated: "آلمان",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:213|fr": [
    {
      german: "Wie viele Einwohner",
      translated: "Combien d’habitants",
      tone: 'semantic',
    },
    {
      german: "Deutschland",
      translated: "l’Allemagne",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:213|hr": [
    {
      german: "Wie viele Einwohner",
      translated: "Koliko stanovnika",
      tone: 'semantic',
    },
    {
      german: "Deutschland",
      translated: "Njemačka",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:213|it": [
    {
      german: "Wie viele Einwohner",
      translated: "quanti abitanti",
      tone: 'semantic',
    },
    {
      german: "Deutschland",
      translated: "Germania",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:213|kmr": [
    {
      german: "Wie viele Einwohner",
      translated: "çend niştecih",
      tone: 'semantic',
    },
    {
      german: "Deutschland",
      translated: "Almanya",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:213|pl": [
    {
      german: "Wie viele Einwohner",
      translated: "Ilu mieszkańców",
      tone: 'semantic',
    },
    {
      german: "Deutschland",
      translated: "Niemcy",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:213|prs": [
    {
      german: "Wie viele Einwohner",
      translated: "تقریباً چند نفر",
      tone: 'semantic',
    },
    {
      german: "Deutschland",
      translated: "آلمان",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:213|ro": [
    {
      german: "Wie viele Einwohner",
      translated: "Aproximativ câți locuitori",
      tone: 'semantic',
    },
    {
      german: "Deutschland",
      translated: "Germania",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:213|ru": [
    {
      german: "Wie viele Einwohner",
      translated: "Сколько",
      tone: 'semantic',
    },
    {
      german: "Deutschland",
      translated: "в Германии",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:213|sq": [
    {
      german: "Wie viele Einwohner",
      translated: "Afërsisht sa banorë",
      tone: 'semantic',
    },
    {
      german: "Deutschland",
      translated: "Gjermania",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:213|sr": [
    {
      german: "Wie viele Einwohner",
      translated: "Koliko stanovnika",
      tone: 'semantic',
    },
    {
      german: "Deutschland",
      translated: "Nemačka",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:213|tr": [
    {
      german: "Wie viele Einwohner",
      translated: "yaklaşık kaç milyondur",
      tone: 'semantic',
    },
    {
      german: "Deutschland",
      translated: "Almanya'nın",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:213|uk": [
    {
      german: "Wie viele Einwohner",
      translated: "Скільки жителів",
      tone: 'semantic',
    },
    {
      german: "Deutschland",
      translated: "Німеччина",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:213|vi": [
    {
      german: "Wie viele Einwohner",
      translated: "bao nhiêu dân",
      tone: 'semantic',
    },
    {
      german: "Deutschland",
      translated: "Đức",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:214|ar": [
    {
      german: "Welche Farben",
      translated: "ما ألوان",
      tone: 'semantic',
    },
    {
      german: "deutsche Flagge",
      translated: "العلم الألماني؟",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:214|bg": [
    {
      german: "Welche Farben",
      translated: "Какви са",
      tone: 'semantic',
    },
    {
      german: "deutsche Flagge",
      translated: "германското знаме",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:214|bs": [
    {
      german: "Welche Farben",
      translated: "Koje su boje",
      tone: 'semantic',
    },
    {
      german: "deutsche Flagge",
      translated: "njemačke zastave",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:214|el": [
    {
      german: "Welche Farben",
      translated: "Ποια είναι τα χρώματα",
      tone: 'semantic',
    },
    {
      german: "deutsche Flagge",
      translated: "της γερμανικής σημαίας",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:214|en": [
    {
      german: "Welche Farben",
      translated: "What colors",
      tone: 'semantic',
    },
    {
      german: "deutsche Flagge",
      translated: "the German flag",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:214|es": [
    {
      german: "Welche Farben",
      translated: "¿Qué colores",
      tone: 'semantic',
    },
    {
      german: "deutsche Flagge",
      translated: "la bandera alemana",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:214|fa": [
    {
      german: "Welche Farben",
      translated: "رنگ‌های پرچم",
      tone: 'semantic',
    },
    {
      german: "deutsche Flagge",
      translated: "آلمان",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:214|fr": [
    {
      german: "Welche Farben",
      translated: "Quelles sont les couleurs",
      tone: 'semantic',
    },
    {
      german: "deutsche Flagge",
      translated: "drapeau allemand",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:214|hr": [
    {
      german: "Welche Farben",
      translated: "Koje su",
      tone: 'semantic',
    },
    {
      german: "deutsche Flagge",
      translated: "boje njemačke zastave",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:214|it": [
    {
      german: "Welche Farben",
      translated: "Quali sono i colori",
      tone: 'semantic',
    },
    {
      german: "deutsche Flagge",
      translated: "della bandiera tedesca",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:214|kmr": [
    {
      german: "Welche Farben",
      translated: "Rengên ala",
      tone: 'semantic',
    },
    {
      german: "deutsche Flagge",
      translated: "Almanyayê çi",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:214|pl": [
    {
      german: "Welche Farben",
      translated: "Jakie są kolory",
      tone: 'semantic',
    },
    {
      german: "deutsche Flagge",
      translated: "flagi Niemiec",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:214|prs": [
    {
      german: "Welche Farben",
      translated: "رنگ‌های",
      tone: 'semantic',
    },
    {
      german: "deutsche Flagge",
      translated: "پرچم آلمان کدام‌اند؟",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:214|ro": [
    {
      german: "Welche Farben",
      translated: "Care sunt",
      tone: 'semantic',
    },
    {
      german: "deutsche Flagge",
      translated: "drapelului Germaniei",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:214|ru": [
    {
      german: "Welche Farben",
      translated: "Какие цвета",
      tone: 'semantic',
    },
    {
      german: "deutsche Flagge",
      translated: "немецкого флага",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:214|sq": [
    {
      german: "Welche Farben",
      translated: "ngjyrat",
      tone: 'semantic',
    },
    {
      german: "deutsche Flagge",
      translated: "flamurit gjerman",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:214|sr": [
    {
      german: "Welche Farben",
      translated: "Koje",
      tone: 'semantic',
    },
    {
      german: "deutsche Flagge",
      translated: "nemačke zastave",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:214|tr": [
    {
      german: "Welche Farben",
      translated: "renkleri nelerdir",
      tone: 'semantic',
    },
    {
      german: "deutsche Flagge",
      translated: "Alman bayrağının",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:214|uk": [
    {
      german: "Welche Farben",
      translated: "Які кольори",
      tone: 'semantic',
    },
    {
      german: "deutsche Flagge",
      translated: "Німеччини",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:214|vi": [
    {
      german: "Welche Farben",
      translated: "của quốc kỳ Đức",
      tone: 'semantic',
    },
    {
      german: "deutsche Flagge",
      translated: "là gì",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:215|ar": [
    {
      german: "Wer",
      translated: "من",
      tone: 'semantic',
    },
    {
      german: "\"Kanzler der Deutschen Einheit\"",
      translated: "«مستشار الوحدة الألمانية»",
      tone: 'semantic',
    },
    {
      german: "bezeichnet?",
      translated: "؟",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:215|bg": [
    {
      german: "Wer",
      translated: "Кой",
      tone: 'semantic',
    },
    {
      german: "wird",
      translated: "е",
      tone: 'semantic',
    },
    {
      german: "als",
      translated: "наричан",
      tone: 'semantic',
    },
    {
      german: "\"Kanzler der Deutschen Einheit\"",
      translated: "„канцлерът на германското единство“",
      tone: 'semantic',
    },
    {
      german: "bezeichnet?",
      translated: "?",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:215|bs": [
    {
      german: "Wer",
      translated: "Koga",
      tone: 'semantic',
    },
    {
      german: "wird",
      translated: "nazivaju",
      tone: 'semantic',
    },
    {
      german: "als",
      translated: "„kancelarom",
      tone: 'semantic',
    },
    {
      german: "\"Kanzler der Deutschen Einheit\"",
      translated: "njemačkog jedinstva“",
      tone: 'semantic',
    },
    {
      german: "bezeichnet?",
      translated: "?",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:215|el": [
    {
      german: "Wer",
      translated: "Ποιος",
      tone: 'semantic',
    },
    {
      german: "wird",
      translated: "αποκαλείται",
      tone: 'semantic',
    },
    {
      german: "\"Kanzler der Deutschen Einheit\"",
      translated: "«καγκελάριος της γερμανικής ενότητας»",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:215|en": [
    {
      german: "Wer",
      translated: "Who",
      tone: 'semantic',
    },
    {
      german: "wird",
      translated: "is",
      tone: 'semantic',
    },
    {
      german: "\"Kanzler der Deutschen Einheit\"",
      translated: "'Chancellor of German Unity'",
      tone: 'semantic',
    },
    {
      german: "bezeichnet?",
      translated: "called",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:215|es": [
    {
      german: "Wer",
      translated: "¿A quién",
      tone: 'semantic',
    },
    {
      german: "wird",
      translated: "se",
      tone: 'semantic',
    },
    {
      german: "als",
      translated: "como",
      tone: 'semantic',
    },
    {
      german: "\"Kanzler der Deutschen Einheit\"",
      translated: "«Canciller de la Unidad Alemana»",
      tone: 'semantic',
    },
    {
      german: "bezeichnet?",
      translated: "conoce",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:215|fa": [
    {
      german: "Wer",
      translated: "چه کسی",
      tone: 'semantic',
    },
    {
      german: "wird",
      translated: "می‌شود",
      tone: 'semantic',
    },
    {
      german: "\"Kanzler der Deutschen Einheit\"",
      translated: "«صدراعظم وحدت آلمان»",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:215|fr": [
    {
      german: "Wer",
      translated: "Qui",
      tone: 'semantic',
    },
    {
      german: "wird",
      translated: "est",
      tone: 'semantic',
    },
    {
      german: "\"Kanzler der Deutschen Einheit\"",
      translated: "le « chancelier de l’unité allemande »",
      tone: 'semantic',
    },
    {
      german: "bezeichnet?",
      translated: "appelé",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:215|hr": [
    {
      german: "Wer",
      translated: "Koga",
      tone: 'semantic',
    },
    {
      german: "wird",
      translated: "nazivaju",
      tone: 'semantic',
    },
    {
      german: "als",
      translated: "„kancelarom",
      tone: 'semantic',
    },
    {
      german: "\"Kanzler der Deutschen Einheit\"",
      translated: "njemačkog jedinstva“",
      tone: 'semantic',
    },
    {
      german: "bezeichnet?",
      translated: "?",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:215|it": [
    {
      german: "Wer",
      translated: "Chi",
      tone: 'semantic',
    },
    {
      german: "wird",
      translated: "viene",
      tone: 'semantic',
    },
    {
      german: "\"Kanzler der Deutschen Einheit\"",
      translated: "«cancelliere dell’unità tedesca»",
      tone: 'semantic',
    },
    {
      german: "bezeichnet?",
      translated: "chiamato",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:215|kmr": [
    {
      german: "Wer",
      translated: "Kî",
      tone: 'semantic',
    },
    {
      german: "wird",
      translated: "tê",
      tone: 'semantic',
    },
    {
      german: "als",
      translated: "«",
      tone: 'semantic',
    },
    {
      german: "\"Kanzler der Deutschen Einheit\"",
      translated: "Kanselerê Yekîtiya Alman",
      tone: 'semantic',
    },
    {
      german: "bezeichnet?",
      translated: "naskirin?",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:215|pl": [
    {
      german: "Wer",
      translated: "Kogo",
      tone: 'semantic',
    },
    {
      german: "wird",
      translated: "się",
      tone: 'semantic',
    },
    {
      german: "\"Kanzler der Deutschen Einheit\"",
      translated: "„kanclerzem jedności niemieckiej”",
      tone: 'semantic',
    },
    {
      german: "bezeichnet?",
      translated: "nazywa",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:215|prs": [
    {
      german: "Wer",
      translated: "چه کسی",
      tone: 'semantic',
    },
    {
      german: "wird",
      translated: "می‌شود",
      tone: 'semantic',
    },
    {
      german: "\"Kanzler der Deutschen Einheit\"",
      translated: "«صدراعظم وحدت آلمان»",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:215|ro": [
    {
      german: "Wer",
      translated: "Cine",
      tone: 'semantic',
    },
    {
      german: "wird",
      translated: "este",
      tone: 'semantic',
    },
    {
      german: "\"Kanzler der Deutschen Einheit\"",
      translated: "„cancelarul unității germane”",
      tone: 'semantic',
    },
    {
      german: "bezeichnet?",
      translated: "numit",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:215|ru": [
    {
      german: "Wer",
      translated: "Кого",
      tone: 'semantic',
    },
    {
      german: "wird",
      translated: "называют",
      tone: 'semantic',
    },
    {
      german: "\"Kanzler der Deutschen Einheit\"",
      translated: "«канцлером немецкого единства»",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:215|sq": [
    {
      german: "Wer",
      translated: "Kush",
      tone: 'semantic',
    },
    {
      german: "wird",
      translated: "quhet",
      tone: 'semantic',
    },
    {
      german: "\"Kanzler der Deutschen Einheit\"",
      translated: "«kancelari i bashkimit gjerman»",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:215|sr": [
    {
      german: "Wer",
      translated: "Koga",
      tone: 'semantic',
    },
    {
      german: "\"Kanzler der Deutschen Einheit\"",
      translated: "„kancelarom nemačkog jedinstva“",
      tone: 'semantic',
    },
    {
      german: "bezeichnet?",
      translated: "nazivaju",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:215|tr": [
    {
      german: "Wer",
      translated: "kim",
      tone: 'semantic',
    },
    {
      german: "als",
      translated: "olarak",
      tone: 'semantic',
    },
    {
      german: "\"Kanzler der Deutschen Einheit\"",
      translated: "Alman Birliğinin Başbakanı",
      tone: 'semantic',
    },
    {
      german: "bezeichnet?",
      translated: "anılır",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:215|uk": [
    {
      german: "Wer",
      translated: "Кого",
      tone: 'semantic',
    },
    {
      german: "wird",
      translated: "називають",
      tone: 'semantic',
    },
    {
      german: "\"Kanzler der Deutschen Einheit\"",
      translated: "«канцлером німецької єдності»?",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:215|vi": [
    {
      german: "Wer",
      translated: "Ai",
      tone: 'semantic',
    },
    {
      german: "wird",
      translated: "được gọi",
      tone: 'semantic',
    },
    {
      german: "als",
      translated: "là",
      tone: 'semantic',
    },
    {
      german: "\"Kanzler der Deutschen Einheit\"",
      translated: "“Thủ tướng của sự thống nhất nước Đức”",
      tone: 'semantic',
    },
    {
      german: "bezeichnet?",
      translated: "?",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:216|ar": [
    {
      german: "Welches Symbol",
      translated: "أي رمز",
      tone: 'semantic',
    },
    {
      german: "ist im Plenarsaal",
      translated: "يظهر في القاعة العامة",
      tone: 'semantic',
    },
    {
      german: "des Deutschen Bundestages",
      translated: "للبوندستاغ الألماني",
      tone: 'semantic',
    },
    {
      german: "zu sehen?",
      translated: "؟",
      tone: 'semantic',
    },
    {
      german: "© Deutscher Bundestag/Janine Schmitz",
      translated: "© Deutscher Bundestag/Janine Schmitz",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:216|bg": [
    {
      german: "Welches Symbol",
      translated: "Кой символ",
      tone: 'semantic',
    },
    {
      german: "ist im Plenarsaal",
      translated: "се вижда в пленарната зала",
      tone: 'semantic',
    },
    {
      german: "des Deutschen Bundestages",
      translated: "на германския Бундестаг",
      tone: 'semantic',
    },
    {
      german: "zu sehen?",
      translated: "?",
      tone: 'semantic',
    },
    {
      german: "© Deutscher Bundestag/Janine Schmitz",
      translated: "© Deutscher Bundestag/Janine Schmitz",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:216|bs": [
    {
      german: "Welches Symbol",
      translated: "Koji se simbol",
      tone: 'semantic',
    },
    {
      german: "ist im Plenarsaal",
      translated: "vidi u plenarnoj dvorani",
      tone: 'semantic',
    },
    {
      german: "des Deutschen Bundestages",
      translated: "njemačkog Bundestaga",
      tone: 'semantic',
    },
    {
      german: "© Deutscher Bundestag/Janine Schmitz",
      translated: "© Deutscher Bundestag/Janine Schmitz",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:216|el": [
    {
      german: "Welches Symbol",
      translated: "Ποιο σύμβολο",
      tone: 'semantic',
    },
    {
      german: "ist im Plenarsaal",
      translated: "στην αίθουσα ολομέλειας",
      tone: 'semantic',
    },
    {
      german: "des Deutschen Bundestages",
      translated: "του γερμανικού Bundestag;",
      tone: 'semantic',
    },
    {
      german: "zu sehen?",
      translated: "φαίνεται",
      tone: 'semantic',
    },
    {
      german: "© Deutscher Bundestag/Janine Schmitz",
      translated: "© Deutscher Bundestag/Janine Schmitz",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:216|en": [
    {
      german: "Welches Symbol",
      translated: "Which symbol",
      tone: 'semantic',
    },
    {
      german: "ist im Plenarsaal",
      translated: "in the plenary hall",
      tone: 'semantic',
    },
    {
      german: "des Deutschen Bundestages",
      translated: "of the German Bundestag",
      tone: 'semantic',
    },
    {
      german: "zu sehen?",
      translated: "can be seen",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:216|es": [
    {
      german: "Welches Symbol",
      translated: "¿Qué símbolo",
      tone: 'semantic',
    },
    {
      german: "ist im Plenarsaal",
      translated: "se puede ver en el hemiciclo",
      tone: 'semantic',
    },
    {
      german: "des Deutschen Bundestages",
      translated: "del Bundestag alemán",
      tone: 'semantic',
    },
    {
      german: "© Deutscher Bundestag/Janine Schmitz",
      translated: "© Deutscher Bundestag/Janine Schmitz",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:216|fa": [
    {
      german: "Welches Symbol",
      translated: "کدام نماد",
      tone: 'semantic',
    },
    {
      german: "ist im Plenarsaal",
      translated: "در تالار عمومی",
      tone: 'semantic',
    },
    {
      german: "des Deutschen Bundestages",
      translated: "بوندستاگ آلمان",
      tone: 'semantic',
    },
    {
      german: "zu sehen?",
      translated: "دیده می‌شود؟",
      tone: 'semantic',
    },
    {
      german: "© Deutscher Bundestag/Janine Schmitz",
      translated: "© Deutscher Bundestag/Janine Schmitz",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:216|fr": [
    {
      german: "Welches Symbol",
      translated: "Quel symbole",
      tone: 'semantic',
    },
    {
      german: "ist im Plenarsaal",
      translated: "dans la salle plénière",
      tone: 'semantic',
    },
    {
      german: "des Deutschen Bundestages",
      translated: "du Bundestag allemand",
      tone: 'semantic',
    },
    {
      german: "zu sehen?",
      translated: "peut-on voir",
      tone: 'semantic',
    },
    {
      german: "© Deutscher Bundestag/Janine Schmitz",
      translated: "© Deutscher Bundestag/Janine Schmitz",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:216|hr": [
    {
      german: "Welches Symbol",
      translated: "Koji se simbol",
      tone: 'semantic',
    },
    {
      german: "ist im Plenarsaal",
      translated: "vidi u plenarnoj dvorani",
      tone: 'semantic',
    },
    {
      german: "des Deutschen Bundestages",
      translated: "njemačkog Bundestaga",
      tone: 'semantic',
    },
    {
      german: "© Deutscher Bundestag/Janine Schmitz",
      translated: "© Deutscher Bundestag/Janine Schmitz",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:216|it": [
    {
      german: "Welches Symbol",
      translated: "Quale simbolo",
      tone: 'semantic',
    },
    {
      german: "ist im Plenarsaal",
      translated: "nell’aula plenaria",
      tone: 'semantic',
    },
    {
      german: "des Deutschen Bundestages",
      translated: "del Bundestag tedesco",
      tone: 'semantic',
    },
    {
      german: "zu sehen?",
      translated: "si vede",
      tone: 'semantic',
    },
    {
      german: "© Deutscher Bundestag/Janine Schmitz",
      translated: "© Deutscher Bundestag/Janine Schmitz",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:216|kmr": [
    {
      german: "Welches Symbol",
      translated: "kîjan sembol",
      tone: 'semantic',
    },
    {
      german: "ist im Plenarsaal",
      translated: "Di salona giştî",
      tone: 'semantic',
    },
    {
      german: "des Deutschen Bundestages",
      translated: "ya Bundestagê",
      tone: 'semantic',
    },
    {
      german: "zu sehen?",
      translated: "tê dîtin",
      tone: 'semantic',
    },
    {
      german: "© Deutscher Bundestag/Janine Schmitz",
      translated: "© Deutscher Bundestag/Janine Schmitz",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:216|pl": [
    {
      german: "Welches Symbol",
      translated: "Jaki symbol",
      tone: 'semantic',
    },
    {
      german: "ist im Plenarsaal",
      translated: "w sali plenarnej",
      tone: 'semantic',
    },
    {
      german: "des Deutschen Bundestages",
      translated: "niemieckiego Bundestagu",
      tone: 'semantic',
    },
    {
      german: "zu sehen?",
      translated: "widać",
      tone: 'semantic',
    },
    {
      german: "© Deutscher Bundestag/Janine Schmitz",
      translated: "© Deutscher Bundestag/Janine Schmitz",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:216|prs": [
    {
      german: "Welches Symbol",
      translated: "نماد",
      tone: 'semantic',
    },
    {
      german: "ist im Plenarsaal",
      translated: "در تالار عمومی",
      tone: 'semantic',
    },
    {
      german: "des Deutschen Bundestages",
      translated: "بوندستاگ آلمان",
      tone: 'semantic',
    },
    {
      german: "zu sehen?",
      translated: "کدام",
      tone: 'semantic',
    },
    {
      german: "© Deutscher Bundestag/Janine Schmitz",
      translated: "© Deutscher Bundestag/Janine Schmitz",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:216|ro": [
    {
      german: "Welches Symbol",
      translated: "Ce simbol",
      tone: 'semantic',
    },
    {
      german: "ist im Plenarsaal",
      translated: "se vede în sala de plen",
      tone: 'semantic',
    },
    {
      german: "des Deutschen Bundestages",
      translated: "Bundestagului german",
      tone: 'semantic',
    },
    {
      german: "© Deutscher Bundestag/Janine Schmitz",
      translated: "© Deutscher Bundestag/Janine Schmitz",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:216|ru": [
    {
      german: "Welches Symbol",
      translated: "Какой символ",
      tone: 'semantic',
    },
    {
      german: "ist im Plenarsaal",
      translated: "можно увидеть в пленарном зале",
      tone: 'semantic',
    },
    {
      german: "des Deutschen Bundestages",
      translated: "Бундестага Германии",
      tone: 'semantic',
    },
    {
      german: "© Deutscher Bundestag/Janine Schmitz",
      translated: "© Германский Бундестаг/Янине Шмитц",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:216|sq": [
    {
      german: "Welches Symbol",
      translated: "Cili simbol",
      tone: 'semantic',
    },
    {
      german: "ist im Plenarsaal",
      translated: "në sallën plenare",
      tone: 'semantic',
    },
    {
      german: "des Deutschen Bundestages",
      translated: "të Bundestagut gjerman",
      tone: 'semantic',
    },
    {
      german: "zu sehen?",
      translated: "shihet",
      tone: 'semantic',
    },
    {
      german: "© Deutscher Bundestag/Janine Schmitz",
      translated: "© Deutscher Bundestag/Janine Schmitz",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:216|sr": [
    {
      german: "Welches Symbol",
      translated: "Koji se simbol",
      tone: 'semantic',
    },
    {
      german: "des Deutschen Bundestages",
      translated: "nemačkog Bundestaga",
      tone: 'semantic',
    },
    {
      german: "zu sehen?",
      translated: "vidi u plenarnoj dvorani",
      tone: 'semantic',
    },
    {
      german: "© Deutscher Bundestag/Janine Schmitz",
      translated: "© Deutscher Bundestag/Janine Schmitz",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:216|tr": [
    {
      german: "Welches Symbol",
      translated: "hangi sembol",
      tone: 'semantic',
    },
    {
      german: "ist im Plenarsaal",
      translated: "genel kurul salonunda",
      tone: 'semantic',
    },
    {
      german: "des Deutschen Bundestages",
      translated: "Alman Federal Meclisinin",
      tone: 'semantic',
    },
    {
      german: "zu sehen?",
      translated: "görülür?",
      tone: 'semantic',
    },
    {
      german: "© Deutscher Bundestag/Janine Schmitz",
      translated: "© Deutscher Bundestag/Janine Schmitz",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:216|uk": [
    {
      german: "Welches Symbol",
      translated: "Який символ",
      tone: 'semantic',
    },
    {
      german: "ist im Plenarsaal",
      translated: "можна побачити в залі пленарних засідань",
      tone: 'semantic',
    },
    {
      german: "des Deutschen Bundestages",
      translated: "німецького Бундестагу",
      tone: 'semantic',
    },
    {
      german: "© Deutscher Bundestag/Janine Schmitz",
      translated: "© Deutscher Bundestag/Janine Schmitz",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:216|vi": [
    {
      german: "Welches Symbol",
      translated: "Biểu tượng",
      tone: 'semantic',
    },
    {
      german: "ist im Plenarsaal",
      translated: "trong",
      tone: 'semantic',
    },
    {
      german: "des Deutschen Bundestages",
      translated: "phòng họp toàn thể của Bundestag Đức",
      tone: 'semantic',
    },
    {
      german: "zu sehen?",
      translated: "được thấy",
      tone: 'semantic',
    },
    {
      german: "© Deutscher Bundestag/Janine Schmitz",
      translated: "© Deutscher Bundestag/Janine Schmitz",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:217|ar": [
    {
      german: "In welchem Zeitraum",
      translated: "في أي فترة",
      tone: 'semantic',
    },
    {
      german: "gab es",
      translated: "كانت",
      tone: 'semantic',
    },
    {
      german: "die Deutsche Demokratische Republik",
      translated: "جمهورية ألمانيا الديمقراطية",
      tone: 'semantic',
    },
    {
      german: "(DDR)",
      translated: "(DDR)",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:217|bg": [
    {
      german: "In welchem Zeitraum",
      translated: "В кой период",
      tone: 'semantic',
    },
    {
      german: "gab es",
      translated: "съществува",
      tone: 'semantic',
    },
    {
      german: "die Deutsche Demokratische Republik",
      translated: "Германската демократична република",
      tone: 'semantic',
    },
    {
      german: "(DDR)",
      translated: "(ГДР)",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:217|bs": [
    {
      german: "In welchem Zeitraum",
      translated: "U kojem je razdoblju",
      tone: 'semantic',
    },
    {
      german: "gab es",
      translated: "postojala",
      tone: 'semantic',
    },
    {
      german: "die Deutsche Demokratische Republik",
      translated: "Njemačka Demokratska Republika",
      tone: 'semantic',
    },
    {
      german: "(DDR)",
      translated: "(DDR)",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:217|el": [
    {
      german: "In welchem Zeitraum",
      translated: "Σε ποια περίοδο",
      tone: 'semantic',
    },
    {
      german: "gab es",
      translated: " υπήρξε ",
      tone: 'semantic',
    },
    {
      german: "die Deutsche Demokratische Republik",
      translated: "η Λαοκρατική Δημοκρατία της Γερμανίας",
      tone: 'semantic',
    },
    {
      german: "(DDR)",
      translated: "(ΛΔΓ)",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:217|en": [
    {
      german: "In welchem Zeitraum",
      translated: "During",
      tone: 'semantic',
    },
    {
      german: "gab es",
      translated: "did",
      tone: 'semantic',
    },
    {
      german: "die Deutsche Demokratische Republik",
      translated: "the German Democratic Republic",
      tone: 'semantic',
    },
    {
      german: "(DDR)",
      translated: "(GDR)",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:217|es": [
    {
      german: "In welchem Zeitraum",
      translated: "Durante qué período",
      tone: 'semantic',
    },
    {
      german: "gab es",
      translated: "existió",
      tone: 'semantic',
    },
    {
      german: "die Deutsche Demokratische Republik",
      translated: "la República Democrática Alemana",
      tone: 'semantic',
    },
    {
      german: "(DDR)",
      translated: "(RDA)",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:217|fa": [
    {
      german: "In welchem Zeitraum",
      translated: "دوره‌ای",
      tone: 'semantic',
    },
    {
      german: "gab es",
      translated: "وجود داشت",
      tone: 'semantic',
    },
    {
      german: "die Deutsche Demokratische Republik",
      translated: "جمهوری دموکراتیک آلمان",
      tone: 'semantic',
    },
    {
      german: "(DDR)",
      translated: "(DDR)",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:217|fr": [
    {
      german: "In welchem Zeitraum",
      translated: "Pendant quelle période",
      tone: 'semantic',
    },
    {
      german: "gab es",
      translated: "a-t-elle existé",
      tone: 'semantic',
    },
    {
      german: "die Deutsche Demokratische Republik",
      translated: "la République démocratique allemande",
      tone: 'semantic',
    },
    {
      german: "(DDR)",
      translated: "(RDA)",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:217|hr": [
    {
      german: "In welchem Zeitraum",
      translated: "U kojem je razdoblju",
      tone: 'semantic',
    },
    {
      german: "gab es",
      translated: "postojala",
      tone: 'semantic',
    },
    {
      german: "die Deutsche Demokratische Republik",
      translated: "Njemačka Demokratska Republika",
      tone: 'semantic',
    },
    {
      german: "(DDR)",
      translated: "(DDR)",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:217|it": [
    {
      german: "In welchem Zeitraum",
      translated: "In quale periodo",
      tone: 'semantic',
    },
    {
      german: "gab es",
      translated: "esistette la",
      tone: 'semantic',
    },
    {
      german: "die Deutsche Demokratische Republik",
      translated: "Repubblica Democratica Tedesca",
      tone: 'semantic',
    },
    {
      german: "(DDR)",
      translated: "RDT",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:217|kmr": [
    {
      german: "In welchem Zeitraum",
      translated: "kîjan heyamê",
      tone: 'semantic',
    },
    {
      german: "gab es",
      translated: "hebû",
      tone: 'semantic',
    },
    {
      german: "die Deutsche Demokratische Republik",
      translated: "DDR",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:217|pl": [
    {
      german: "In welchem Zeitraum",
      translated: "W jakim okresie",
      tone: 'semantic',
    },
    {
      german: "gab es",
      translated: "istniała",
      tone: 'semantic',
    },
    {
      german: "die Deutsche Demokratische Republik",
      translated: "Niemiecka Republika Demokratyczna",
      tone: 'semantic',
    },
    {
      german: "(DDR)",
      translated: "(NRD)",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:217|prs": [
    {
      german: "In welchem Zeitraum",
      translated: "در چه دوره‌ای",
      tone: 'semantic',
    },
    {
      german: "gab es",
      translated: "وجود داشت",
      tone: 'semantic',
    },
    {
      german: "die Deutsche Demokratische Republik",
      translated: "جمهوری دموکراتیک آلمان",
      tone: 'semantic',
    },
    {
      german: "(DDR)",
      translated: "(DDR)",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:217|ro": [
    {
      german: "In welchem Zeitraum",
      translated: "În ce perioadă",
      tone: 'semantic',
    },
    {
      german: "gab es",
      translated: "a existat",
      tone: 'semantic',
    },
    {
      german: "die Deutsche Demokratische Republik",
      translated: "Republica Democrată Germană",
      tone: 'semantic',
    },
    {
      german: "(DDR)",
      translated: "(RDG)",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:217|ru": [
    {
      german: "In welchem Zeitraum",
      translated: "В какой период",
      tone: 'semantic',
    },
    {
      german: "gab es",
      translated: "существовала",
      tone: 'semantic',
    },
    {
      german: "die Deutsche Demokratische Republik",
      translated: "Германская Демократическая Республика",
      tone: 'semantic',
    },
    {
      german: "(DDR)",
      translated: "(ГДР)",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:217|sq": [
    {
      german: "In welchem Zeitraum",
      translated: "Në cilën periudhë",
      tone: 'semantic',
    },
    {
      german: "gab es",
      translated: "ekzistoi",
      tone: 'semantic',
    },
    {
      german: "die Deutsche Demokratische Republik",
      translated: "Republika Demokratike Gjermane (RDGJ)",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:217|sr": [
    {
      german: "In welchem Zeitraum",
      translated: "U kojem je razdoblju",
      tone: 'semantic',
    },
    {
      german: "gab es",
      translated: "postojala",
      tone: 'semantic',
    },
    {
      german: "die Deutsche Demokratische Republik",
      translated: "Nemačka Demokratska Republika",
      tone: 'semantic',
    },
    {
      german: "(DDR)",
      translated: "(DDR)",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:217|tr": [
    {
      german: "In welchem Zeitraum",
      translated: "hangi yıllar arasında",
      tone: 'semantic',
    },
    {
      german: "gab es",
      translated: "var oldu",
      tone: 'semantic',
    },
    {
      german: "die Deutsche Demokratische Republik",
      translated: "Alman Demokratik Cumhuriyeti",
      tone: 'semantic',
    },
    {
      german: "(DDR)",
      translated: "(DDR)",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:217|uk": [
    {
      german: "In welchem Zeitraum",
      translated: "У який період",
      tone: 'semantic',
    },
    {
      german: "gab es",
      translated: "існувала",
      tone: 'semantic',
    },
    {
      german: "die Deutsche Demokratische Republik",
      translated: "Німецька Демократична Республіка",
      tone: 'semantic',
    },
    {
      german: "(DDR)",
      translated: "(НДР)",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:217|vi": [
    {
      german: "In welchem Zeitraum",
      translated: "(",
      tone: 'semantic',
    },
    {
      german: "gab es",
      translated: "tồn tại trong",
      tone: 'semantic',
    },
    {
      german: "die Deutsche Demokratische Republik",
      translated: "Cộng hòa Dân chủ Đức",
      tone: 'semantic',
    },
    {
      german: "(DDR)",
      translated: "CHDC Đức",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:218|ar": [
    {
      german: "Wie viele",
      translated: "كم",
      tone: 'semantic',
    },
    {
      german: "Bundesländer",
      translated: "ولاية",
      tone: 'semantic',
    },
    {
      german: "bei der Wiedervereinigung 1990",
      translated: "عند إعادة التوحيد عام 1990",
      tone: 'semantic',
    },
    {
      german: "zur Bundesrepublik Deutschland",
      translated: "إلى جمهورية ألمانيا الاتحادية",
      tone: 'semantic',
    },
    {
      german: "hinzu",
      translated: "انضمت",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:218|bg": [
    {
      german: "Wie viele",
      translated: "Колко",
      tone: 'semantic',
    },
    {
      german: "Bundesländer",
      translated: "федерални провинции",
      tone: 'semantic',
    },
    {
      german: "bei der Wiedervereinigung 1990",
      translated: "при обединението през 1990 г.",
      tone: 'semantic',
    },
    {
      german: "zur Bundesrepublik Deutschland",
      translated: "към Федерална република Германия",
      tone: 'semantic',
    },
    {
      german: "hinzu",
      translated: "се присъединяват",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:218|bs": [
    {
      german: "Wie viele",
      translated: "Koliko je",
      tone: 'semantic',
    },
    {
      german: "Bundesländer",
      translated: "saveznih zemalja",
      tone: 'semantic',
    },
    {
      german: "kamen",
      translated: "pristupilo",
      tone: 'semantic',
    },
    {
      german: "bei der Wiedervereinigung 1990",
      translated: "tijekom ujedinjenja 1990",
      tone: 'semantic',
    },
    {
      german: "zur Bundesrepublik Deutschland",
      translated: "Saveznoj Republici Njemačkoj",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:218|el": [
    {
      german: "Wie viele",
      translated: "Πόσα",
      tone: 'semantic',
    },
    {
      german: "Bundesländer",
      translated: "ομόσπονδα κρατίδια",
      tone: 'semantic',
    },
    {
      german: "kamen",
      translated: "προσχώρησαν",
      tone: 'semantic',
    },
    {
      german: "bei der Wiedervereinigung 1990",
      translated: "την επανένωση του 1990",
      tone: 'semantic',
    },
    {
      german: "zur Bundesrepublik Deutschland",
      translated: "στην Ομοσπονδιακή Δημοκρατία της Γερμανίας",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:218|en": [
    {
      german: "Wie viele",
      translated: "How many",
      tone: 'semantic',
    },
    {
      german: "Bundesländer",
      translated: "federal states",
      tone: 'semantic',
    },
    {
      german: "kamen",
      translated: "were added",
      tone: 'semantic',
    },
    {
      german: "bei der Wiedervereinigung 1990",
      translated: "at reunification in 1990",
      tone: 'semantic',
    },
    {
      german: "zur Bundesrepublik Deutschland",
      translated: "to the Federal Republic of Germany",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:218|es": [
    {
      german: "Wie viele",
      translated: "¿Cuántos",
      tone: 'semantic',
    },
    {
      german: "Bundesländer",
      translated: "estados federados",
      tone: 'semantic',
    },
    {
      german: "kamen",
      translated: "se incorporaron",
      tone: 'semantic',
    },
    {
      german: "bei der Wiedervereinigung 1990",
      translated: "con la reunificación en 1990",
      tone: 'semantic',
    },
    {
      german: "zur Bundesrepublik Deutschland",
      translated: "a la República Federal de Alemania",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:218|fa": [
    {
      german: "Wie viele",
      translated: "چند",
      tone: 'semantic',
    },
    {
      german: "Bundesländer",
      translated: "ایالت",
      tone: 'semantic',
    },
    {
      german: "bei der Wiedervereinigung 1990",
      translated: "در اتحاد مجدد آلمان در سال ۱۹۹۰",
      tone: 'semantic',
    },
    {
      german: "zur Bundesrepublik Deutschland",
      translated: "به جمهوری فدرال آلمان",
      tone: 'semantic',
    },
    {
      german: "hinzu",
      translated: "پیوستند؟",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:218|fr": [
    {
      german: "Wie viele",
      translated: "Combien de",
      tone: 'semantic',
    },
    {
      german: "Bundesländer",
      translated: "Länder",
      tone: 'semantic',
    },
    {
      german: "kamen",
      translated: "ont rejoint",
      tone: 'semantic',
    },
    {
      german: "bei der Wiedervereinigung 1990",
      translated: "lors de la réunification en 1990",
      tone: 'semantic',
    },
    {
      german: "zur Bundesrepublik Deutschland",
      translated: "la République fédérale d’Allemagne",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:218|hr": [
    {
      german: "Wie viele",
      translated: "Koliko je",
      tone: 'semantic',
    },
    {
      german: "Bundesländer",
      translated: "saveznih zemalja",
      tone: 'semantic',
    },
    {
      german: "kamen",
      translated: "pristupilo",
      tone: 'semantic',
    },
    {
      german: "bei der Wiedervereinigung 1990",
      translated: "tijekom ujedinjenja 1990.",
      tone: 'semantic',
    },
    {
      german: "zur Bundesrepublik Deutschland",
      translated: "Saveznoj Republici Njemačkoj",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:218|it": [
    {
      german: "Wie viele",
      translated: "Quanti",
      tone: 'semantic',
    },
    {
      german: "Bundesländer",
      translated: "Länder",
      tone: 'semantic',
    },
    {
      german: "kamen",
      translated: "aderirono",
      tone: 'semantic',
    },
    {
      german: "bei der Wiedervereinigung 1990",
      translated: "con la riunificazione del 1990",
      tone: 'semantic',
    },
    {
      german: "zur Bundesrepublik Deutschland",
      translated: "alla Repubblica Federale di Germania",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:218|kmr": [
    {
      german: "Wie viele",
      translated: "çend",
      tone: 'semantic',
    },
    {
      german: "Bundesländer",
      translated: "eyalet",
      tone: 'semantic',
    },
    {
      german: "kamen",
      translated: "bûn",
      tone: 'semantic',
    },
    {
      german: "bei der Wiedervereinigung 1990",
      translated: "Di yekbûna 1990 de",
      tone: 'semantic',
    },
    {
      german: "zur Bundesrepublik Deutschland",
      translated: "Komara Federal",
      tone: 'semantic',
    },
    {
      german: "hinzu",
      translated: "tevlî",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:218|pl": [
    {
      german: "Wie viele",
      translated: "Ile",
      tone: 'semantic',
    },
    {
      german: "Bundesländer",
      translated: "krajów związkowych",
      tone: 'semantic',
    },
    {
      german: "kamen",
      translated: "przystąpiło",
      tone: 'semantic',
    },
    {
      german: "bei der Wiedervereinigung 1990",
      translated: "podczas zjednoczenia w 1990 r.",
      tone: 'semantic',
    },
    {
      german: "zur Bundesrepublik Deutschland",
      translated: "do Republiki Federalnej Niemiec",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:218|prs": [
    {
      german: "Wie viele",
      translated: "چند",
      tone: 'semantic',
    },
    {
      german: "Bundesländer",
      translated: "ایالت",
      tone: 'semantic',
    },
    {
      german: "bei der Wiedervereinigung 1990",
      translated: "در اتحاد مجدد آلمان در سال ۱۹۹۰",
      tone: 'semantic',
    },
    {
      german: "zur Bundesrepublik Deutschland",
      translated: "به جمهوری فدرال آلمان",
      tone: 'semantic',
    },
    {
      german: "hinzu",
      translated: "پیوستند؟",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:218|ro": [
    {
      german: "Wie viele",
      translated: "Câte",
      tone: 'semantic',
    },
    {
      german: "Bundesländer",
      translated: "landuri",
      tone: 'semantic',
    },
    {
      german: "kamen",
      translated: "au aderat",
      tone: 'semantic',
    },
    {
      german: "bei der Wiedervereinigung 1990",
      translated: "la reunificarea din 1990",
      tone: 'semantic',
    },
    {
      german: "zur Bundesrepublik Deutschland",
      translated: "la Republica Federală Germania",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:218|ru": [
    {
      german: "Wie viele",
      translated: "Сколько",
      tone: 'semantic',
    },
    {
      german: "Bundesländer",
      translated: "федеральных земель",
      tone: 'semantic',
    },
    {
      german: "kamen",
      translated: "присоединилось",
      tone: 'semantic',
    },
    {
      german: "bei der Wiedervereinigung 1990",
      translated: "воссоединении в 1990 году",
      tone: 'semantic',
    },
    {
      german: "zur Bundesrepublik Deutschland",
      translated: "к ФРГ",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:218|sq": [
    {
      german: "Wie viele",
      translated: "Sa",
      tone: 'semantic',
    },
    {
      german: "Bundesländer",
      translated: "lande",
      tone: 'semantic',
    },
    {
      german: "zur Bundesrepublik Deutschland",
      translated: "Republikës Federale të Gjermanisë",
      tone: 'semantic',
    },
    {
      german: "hinzu",
      translated: "gjatë ribashkimit në vitin 1990",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:218|sr": [
    {
      german: "Wie viele",
      translated: "Koliko je",
      tone: 'semantic',
    },
    {
      german: "Bundesländer",
      translated: "saveznih pokrajina",
      tone: 'semantic',
    },
    {
      german: "kamen",
      translated: "pristupilo",
      tone: 'semantic',
    },
    {
      german: "bei der Wiedervereinigung 1990",
      translated: "tokom ujedinjenja 1990.",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:218|tr": [
    {
      german: "Wie viele",
      translated: "kaç",
      tone: 'semantic',
    },
    {
      german: "Bundesländer",
      translated: "eyalet",
      tone: 'semantic',
    },
    {
      german: "kamen",
      translated: "eklendi",
      tone: 'semantic',
    },
    {
      german: "bei der Wiedervereinigung 1990",
      translated: "1990'daki yeniden birleşmeyle",
      tone: 'semantic',
    },
    {
      german: "zur Bundesrepublik Deutschland",
      translated: "Almanya Federal Cumhuriyeti'ne",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:218|uk": [
    {
      german: "Wie viele",
      translated: "Скільки",
      tone: 'semantic',
    },
    {
      german: "Bundesländer",
      translated: "федеральних земель",
      tone: 'semantic',
    },
    {
      german: "kamen",
      translated: "приєдналося",
      tone: 'semantic',
    },
    {
      german: "bei der Wiedervereinigung 1990",
      translated: "під час возз’єднання 1990 року",
      tone: 'semantic',
    },
    {
      german: "zur Bundesrepublik Deutschland",
      translated: "до Федеративної Республіки Німеччина",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:218|vi": [
    {
      german: "Wie viele",
      translated: "Có bao nhiêu",
      tone: 'semantic',
    },
    {
      german: "Bundesländer",
      translated: "bang",
      tone: 'semantic',
    },
    {
      german: "kamen",
      translated: "gia nhập",
      tone: 'semantic',
    },
    {
      german: "bei der Wiedervereinigung 1990",
      translated: "trong quá trình thống nhất năm 1990",
      tone: 'semantic',
    },
    {
      german: "zur Bundesrepublik Deutschland",
      translated: "Cộng hòa Liên bang Đức",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:219|ar": [
    {
      german: "Die Bundesrepublik Deutschland",
      translated: "جمهورية ألمانيا الاتحادية",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "تملك",
      tone: 'semantic',
    },
    {
      german: "die Grenzen von heute",
      translated: "حدودها الحالية",
      tone: 'semantic',
    },
    {
      german: "seit",
      translated: "منذ",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:219|bg": [
    {
      german: "Die Bundesrepublik Deutschland",
      translated: "Федерална република Германия",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "има",
      tone: 'semantic',
    },
    {
      german: "die Grenzen von heute",
      translated: "сегашните си граници",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:219|bs": [
    {
      german: "Die Bundesrepublik Deutschland",
      translated: "Savezna Republika Njemačka",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "ima",
      tone: 'semantic',
    },
    {
      german: "die Grenzen von heute",
      translated: "današnje granice",
      tone: 'semantic',
    },
    {
      german: "seit",
      translated: "Od koje godine",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:219|el": [
    {
      german: "Die Bundesrepublik Deutschland",
      translated: "Ομοσπονδιακή Δημοκρατία της Γερμανίας",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "έχει",
      tone: 'semantic',
    },
    {
      german: "die Grenzen von heute",
      translated: "τα σημερινά της σύνορα",
      tone: 'semantic',
    },
    {
      german: "seit",
      translated: "Από ποιο έτος",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:219|en": [
    {
      german: "Die Bundesrepublik Deutschland",
      translated: "The Federal Republic of Germany",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "has had",
      tone: 'semantic',
    },
    {
      german: "die Grenzen von heute",
      translated: "its current borders",
      tone: 'semantic',
    },
    {
      german: "seit",
      translated: "since",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:219|es": [
    {
      german: "Die Bundesrepublik Deutschland",
      translated: "La República Federal de Alemania",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "tiene",
      tone: 'semantic',
    },
    {
      german: "die Grenzen von heute",
      translated: "sus fronteras actuales",
      tone: 'semantic',
    },
    {
      german: "seit",
      translated: "desde",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:219|fa": [
    {
      german: "Die Bundesrepublik Deutschland",
      translated: "جمهوری فدرال آلمان",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "دارد",
      tone: 'semantic',
    },
    {
      german: "die Grenzen von heute",
      translated: "مرزهای کنونی",
      tone: 'semantic',
    },
    {
      german: "seit",
      translated: "از چه سالی",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:219|fr": [
    {
      german: "Die Bundesrepublik Deutschland",
      translated: "La République fédérale d’Allemagne",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "possède",
      tone: 'semantic',
    },
    {
      german: "die Grenzen von heute",
      translated: "ses frontières actuelles",
      tone: 'semantic',
    },
    {
      german: "seit",
      translated: "depuis",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:219|hr": [
    {
      german: "Die Bundesrepublik Deutschland",
      translated: "Savezna Republika Njemačka",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "ima",
      tone: 'semantic',
    },
    {
      german: "die Grenzen von heute",
      translated: "današnje granice",
      tone: 'semantic',
    },
    {
      german: "seit",
      translated: "Od koje godine",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:219|it": [
    {
      german: "Die Bundesrepublik Deutschland",
      translated: "la Repubblica Federale di Germania",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "ha",
      tone: 'semantic',
    },
    {
      german: "die Grenzen von heute",
      translated: "i suoi confini attuali",
      tone: 'semantic',
    },
    {
      german: "seit",
      translated: "Da quale anno",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:219|kmr": [
    {
      german: "Die Bundesrepublik Deutschland",
      translated: "Komara Federal a Almanyayê",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "e",
      tone: 'semantic',
    },
    {
      german: "die Grenzen von heute",
      translated: "sînorên îroyîn",
      tone: 'semantic',
    },
    {
      german: "seit",
      translated: "ve",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:219|pl": [
    {
      german: "Die Bundesrepublik Deutschland",
      translated: "Republika Federalna Niemiec",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "ma",
      tone: 'semantic',
    },
    {
      german: "die Grenzen von heute",
      translated: "obecne granice",
      tone: 'semantic',
    },
    {
      german: "seit",
      translated: "Od którego roku",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:219|prs": [
    {
      german: "Die Bundesrepublik Deutschland",
      translated: "جمهوری فدرال آلمان",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "دارد",
      tone: 'semantic',
    },
    {
      german: "die Grenzen von heute",
      translated: "مرزهای کنونی",
      tone: 'semantic',
    },
    {
      german: "seit",
      translated: "از چه سالی",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:219|ro": [
    {
      german: "Die Bundesrepublik Deutschland",
      translated: "Republica Federală Germania",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "are",
      tone: 'semantic',
    },
    {
      german: "die Grenzen von heute",
      translated: "frontierele actuale",
      tone: 'semantic',
    },
    {
      german: "seit",
      translated: "Din ce an",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:219|ru": [
    {
      german: "Die Bundesrepublik Deutschland",
      translated: "Германия",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "имеет свои",
      tone: 'semantic',
    },
    {
      german: "die Grenzen von heute",
      translated: "нынешние границы",
      tone: 'semantic',
    },
    {
      german: "seit",
      translated: "с …",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:219|sq": [
    {
      german: "Die Bundesrepublik Deutschland",
      translated: "Republika Federale e Gjermanisë",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "ka",
      tone: 'semantic',
    },
    {
      german: "die Grenzen von heute",
      translated: "kufijtë e saj të sotëm",
      tone: 'semantic',
    },
    {
      german: "seit",
      translated: "Që nga cili vit",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:219|sr": [
    {
      german: "Die Bundesrepublik Deutschland",
      translated: "Savezna Republika Nemačka",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "ima",
      tone: 'semantic',
    },
    {
      german: "die Grenzen von heute",
      translated: "današnje granice",
      tone: 'semantic',
    },
    {
      german: "seit",
      translated: "Od koje godine",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:219|tr": [
    {
      german: "Die Bundesrepublik Deutschland",
      translated: "Almanya Federal Cumhuriyeti",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "sahiptir",
      tone: 'semantic',
    },
    {
      german: "die Grenzen von heute",
      translated: "bugünkü sınırlarına",
      tone: 'semantic',
    },
    {
      german: "seit",
      translated: "… yılından beri",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:219|uk": [
    {
      german: "Die Bundesrepublik Deutschland",
      translated: "Федеративна Республіка Німеччина",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: " має",
      tone: 'semantic',
    },
    {
      german: "die Grenzen von heute",
      translated: "сучасні кордони",
      tone: 'semantic',
    },
    {
      german: "seit",
      translated: "з … року",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:219|vi": [
    {
      german: "Die Bundesrepublik Deutschland",
      translated: "Cộng hòa Liên bang Đức",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "có",
      tone: 'semantic',
    },
    {
      german: "die Grenzen von heute",
      translated: "đường biên giới như hiện nay",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:21|ar": [
    {
      german: "Welches ist",
      translated: "أي",
      tone: 'semantic',
    },
    {
      german: "das Wappen",
      translated: "شعار",
      tone: 'semantic',
    },
    {
      german: "der Bundesrepublik Deutschland",
      translated: "جمهورية ألمانيا الاتحادية",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:21|bg": [
    {
      german: "Welches ist",
      translated: "Кой",
      tone: 'semantic',
    },
    {
      german: "das Wappen",
      translated: "гербът",
      tone: 'semantic',
    },
    {
      german: "der Bundesrepublik Deutschland",
      translated: "на Федерална република Германия",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:21|bs": [
    {
      german: "Welches ist",
      translated: "Koji je",
      tone: 'semantic',
    },
    {
      german: "das Wappen",
      translated: "grb",
      tone: 'semantic',
    },
    {
      german: "der Bundesrepublik Deutschland",
      translated: "Savezne Republike Njemačke",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:21|el": [
    {
      german: "Welches ist",
      translated: "Ποιο από τα εικονιζόμενα εμβλήματα είναι",
      tone: 'semantic',
    },
    {
      german: "das Wappen",
      translated: "το έμβλημα",
      tone: 'semantic',
    },
    {
      german: "der Bundesrepublik Deutschland",
      translated: "της Ομοσπονδιακής Δημοκρατίας της Γερμανίας",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:21|en": [
    {
      german: "Welches ist",
      translated: "Which is",
      tone: 'semantic',
    },
    {
      german: "das Wappen",
      translated: "the coat of arms",
      tone: 'semantic',
    },
    {
      german: "der Bundesrepublik Deutschland",
      translated: "of the Federal Republic of Germany",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:21|es": [
    {
      german: "Welches ist",
      translated: "¿Cuál es",
      tone: 'semantic',
    },
    {
      german: "das Wappen",
      translated: "el escudo de armas",
      tone: 'semantic',
    },
    {
      german: "der Bundesrepublik Deutschland",
      translated: "de la República Federal de Alemania",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:21|fa": [
    {
      german: "Welches ist",
      translated: "کدام‌یک از",
      tone: 'semantic',
    },
    {
      german: "das Wappen",
      translated: "نشان‌های زیر",
      tone: 'semantic',
    },
    {
      german: "der Bundesrepublik Deutschland",
      translated: "جمهوری فدرال آلمان",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:21|fr": [
    {
      german: "Welches ist",
      translated: "Lequel des",
      tone: 'semantic',
    },
    {
      german: "das Wappen",
      translated: "blasons représentés",
      tone: 'semantic',
    },
    {
      german: "der Bundesrepublik Deutschland",
      translated: "la République fédérale d’Allemagne ",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:21|hr": [
    {
      german: "Welches ist",
      translated: "Koji je",
      tone: 'semantic',
    },
    {
      german: "das Wappen",
      translated: "grb",
      tone: 'semantic',
    },
    {
      german: "der Bundesrepublik Deutschland",
      translated: "Savezne Republike Njemačke",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:21|it": [
    {
      german: "Welches ist",
      translated: "Quale degli stemmi raffigurati",
      tone: 'semantic',
    },
    {
      german: "das Wappen",
      translated: "è quello",
      tone: 'semantic',
    },
    {
      german: "der Bundesrepublik Deutschland",
      translated: "della Repubblica Federale di Germania",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:21|kmr": [
    {
      german: "Welches ist",
      translated: "Kîjan",
      tone: 'semantic',
    },
    {
      german: "das Wappen",
      translated: "nîşana",
      tone: 'semantic',
    },
    {
      german: "der Bundesrepublik Deutschland",
      translated: "Komara Federal a Almanyayê",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:21|pl": [
    {
      german: "Welches ist",
      translated: "Który",
      tone: 'semantic',
    },
    {
      german: "das Wappen",
      translated: "z przedstawionych herbów",
      tone: 'semantic',
    },
    {
      german: "der Bundesrepublik Deutschland",
      translated: "Republiki Federalnej Niemiec",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:21|prs": [
    {
      german: "Welches ist",
      translated: "کدام‌یک از",
      tone: 'semantic',
    },
    {
      german: "das Wappen",
      translated: "نشان‌های زیر",
      tone: 'semantic',
    },
    {
      german: "der Bundesrepublik Deutschland",
      translated: "جمهوری فدرال آلمان",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:21|ro": [
    {
      german: "Welches ist",
      translated: "Care dintre",
      tone: 'semantic',
    },
    {
      german: "das Wappen",
      translated: "steme",
      tone: 'semantic',
    },
    {
      german: "der Bundesrepublik Deutschland",
      translated: "Republicii Federale Germania",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:21|ru": [
    {
      german: "Welches ist",
      translated: "Какой из",
      tone: 'semantic',
    },
    {
      german: "das Wappen",
      translated: "гербов",
      tone: 'semantic',
    },
    {
      german: "der Bundesrepublik Deutschland",
      translated: "гербом Федеративной Республики Германия",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:21|sq": [
    {
      german: "Welches ist",
      translated: "Cila nga",
      tone: 'semantic',
    },
    {
      german: "das Wappen",
      translated: "stema",
      tone: 'semantic',
    },
    {
      german: "der Bundesrepublik Deutschland",
      translated: "e Republikës Federale të Gjermanisë",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:21|sr": [
    {
      german: "Welches ist",
      translated: "Koji je od prikazanih",
      tone: 'semantic',
    },
    {
      german: "das Wappen",
      translated: "grb",
      tone: 'semantic',
    },
    {
      german: "der Bundesrepublik Deutschland",
      translated: "Savezne Republike Nemačke",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:21|tr": [
    {
      german: "Welches ist",
      translated: "hangisidir",
      tone: 'semantic',
    },
    {
      german: "das Wappen",
      translated: "arması",
      tone: 'semantic',
    },
    {
      german: "der Bundesrepublik Deutschland",
      translated: "Almanya Federal Cumhuriyeti’nin",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:21|uk": [
    {
      german: "Welches ist",
      translated: "Який із",
      tone: 'semantic',
    },
    {
      german: "das Wappen",
      translated: "гербів",
      tone: 'semantic',
    },
    {
      german: "der Bundesrepublik Deutschland",
      translated: "Федеративної Республіки Німеччина",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:21|vi": [
    {
      german: "Welches ist",
      translated: "Biểu tượng nào trong các hình được hiển thị là",
      tone: 'semantic',
    },
    {
      german: "das Wappen",
      translated: "quốc huy",
      tone: 'semantic',
    },
    {
      german: "der Bundesrepublik Deutschland",
      translated: "của Cộng hòa Liên bang Đức?",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:220|ar": [
    {
      german: "Der 27. Januar",
      translated: "27 يناير/كانون الثاني",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "يوم",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "في ألمانيا",
      tone: 'semantic',
    },
    {
      german: "ein offizieller Gedenktag",
      translated: "تذكاري رسمي",
      tone: 'semantic',
    },
    {
      german: "Woran",
      translated: "بماذا",
      tone: 'semantic',
    },
    {
      german: "erinnert",
      translated: "يذكّر",
      tone: 'semantic',
    },
    {
      german: "dieser Tag",
      translated: "هذا اليوم",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:220|bg": [
    {
      german: "Der 27. Januar",
      translated: "27 януари",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "е",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "в Германия",
      tone: 'semantic',
    },
    {
      german: "ein offizieller Gedenktag",
      translated: "официален ден за възпоменание",
      tone: 'semantic',
    },
    {
      german: "Woran",
      translated: "Какво",
      tone: 'semantic',
    },
    {
      german: "erinnert",
      translated: "се отбелязва",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:220|bs": [
    {
      german: "Der 27. Januar",
      translated: "27. januara",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "je",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "U Njemačkoj",
      tone: 'semantic',
    },
    {
      german: "ein offizieller Gedenktag",
      translated: "službeni dan sjećanja",
      tone: 'semantic',
    },
    {
      german: "Woran",
      translated: "Na što",
      tone: 'semantic',
    },
    {
      german: "erinnert",
      translated: "podsjeća",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:220|el": [
    {
      german: "Der 27. Januar",
      translated: "Η 27η Ιανουαρίου",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "είναι",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "στη Γερμανία",
      tone: 'semantic',
    },
    {
      german: "Woran",
      translated: "Τι",
      tone: 'semantic',
    },
    {
      german: "erinnert",
      translated: "θυμίζει",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:220|en": [
    {
      german: "Der 27. Januar",
      translated: "January 27",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "is",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "in Germany",
      tone: 'semantic',
    },
    {
      german: "ein offizieller Gedenktag",
      translated: "an official day of remembrance",
      tone: 'semantic',
    },
    {
      german: "Woran",
      translated: "What",
      tone: 'semantic',
    },
    {
      german: "erinnert",
      translated: "commemorate",
      tone: 'semantic',
    },
    {
      german: "dieser Tag",
      translated: "this day",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:220|es": [
    {
      german: "Der 27. Januar",
      translated: "El 27 de enero",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "es",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "en Alemania",
      tone: 'semantic',
    },
    {
      german: "ein offizieller Gedenktag",
      translated: "un día oficial de conmemoración",
      tone: 'semantic',
    },
    {
      german: "Woran",
      translated: "¿Qué",
      tone: 'semantic',
    },
    {
      german: "erinnert",
      translated: "se recuerda",
      tone: 'semantic',
    },
    {
      german: "dieser Tag",
      translated: "ese día",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:220|fa": [
    {
      german: "Der 27. Januar",
      translated: "۲۷ ژانویه",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "است",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "در آلمان",
      tone: 'semantic',
    },
    {
      german: "ein offizieller Gedenktag",
      translated: "روز رسمی یادبود",
      tone: 'semantic',
    },
    {
      german: "Woran",
      translated: "چیست",
      tone: 'semantic',
    },
    {
      german: "erinnert",
      translated: "یادآور",
      tone: 'semantic',
    },
    {
      german: "dieser Tag",
      translated: "این روز",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:220|fr": [
    {
      german: "Der 27. Januar",
      translated: "Le 27 janvier",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "est",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "en Allemagne",
      tone: 'semantic',
    },
    {
      german: "ein offizieller Gedenktag",
      translated: "un jour officiel de commémoration",
      tone: 'semantic',
    },
    {
      german: "Woran",
      translated: "Que",
      tone: 'semantic',
    },
    {
      german: "erinnert",
      translated: "rappelle",
      tone: 'semantic',
    },
    {
      german: "dieser Tag",
      translated: "cette date",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:220|hr": [
    {
      german: "Der 27. Januar",
      translated: "27. siječnja",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "je",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "U Njemačkoj",
      tone: 'semantic',
    },
    {
      german: "ein offizieller Gedenktag",
      translated: "službeni dan sjećanja",
      tone: 'semantic',
    },
    {
      german: "Woran",
      translated: "Na što",
      tone: 'semantic',
    },
    {
      german: "erinnert",
      translated: "podsjeća",
      tone: 'semantic',
    },
    {
      german: "dieser Tag",
      translated: "toga dana",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:220|it": [
    {
      german: "Der 27. Januar",
      translated: "Il 27 gennaio",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "in Germania",
      tone: 'semantic',
    },
    {
      german: "ein offizieller Gedenktag",
      translated: "è un giorno ufficiale della memoria",
      tone: 'semantic',
    },
    {
      german: "Woran",
      translated: "Che cosa",
      tone: 'semantic',
    },
    {
      german: "erinnert",
      translated: "ricorda",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:220|kmr": [
    {
      german: "Der 27. Januar",
      translated: "27ê Çile",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "ye",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "li Almanyayê",
      tone: 'semantic',
    },
    {
      german: "ein offizieller Gedenktag",
      translated: "roja fermî ya bîranînê",
      tone: 'semantic',
    },
    {
      german: "Woran",
      translated: "Bîra çi",
      tone: 'semantic',
    },
    {
      german: "erinnert",
      translated: "tîne",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:220|pl": [
    {
      german: "Der 27. Januar",
      translated: "27 stycznia",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "jest",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "w Niemczech",
      tone: 'semantic',
    },
    {
      german: "ein offizieller Gedenktag",
      translated: "oficjalnym dniem pamięci",
      tone: 'semantic',
    },
    {
      german: "Woran",
      translated: "Co",
      tone: 'semantic',
    },
    {
      german: "erinnert",
      translated: "upamiętnia",
      tone: 'semantic',
    },
    {
      german: "dieser Tag",
      translated: "wtedy",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:220|prs": [
    {
      german: "Der 27. Januar",
      translated: "۲۷ ژانویه",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "است",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "در آلمان",
      tone: 'semantic',
    },
    {
      german: "ein offizieller Gedenktag",
      translated: "روز رسمی یادبود",
      tone: 'semantic',
    },
    {
      german: "Woran",
      translated: "چیست",
      tone: 'semantic',
    },
    {
      german: "erinnert",
      translated: "یادآور",
      tone: 'semantic',
    },
    {
      german: "dieser Tag",
      translated: "این روز",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:220|ro": [
    {
      german: "Der 27. Januar",
      translated: "27 ianuarie",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "este",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "în Germania",
      tone: 'semantic',
    },
    {
      german: "ein offizieller Gedenktag",
      translated: "o zi oficială de comemorare",
      tone: 'semantic',
    },
    {
      german: "Woran",
      translated: "Ce",
      tone: 'semantic',
    },
    {
      german: "erinnert",
      translated: "comemorează",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:220|ru": [
    {
      german: "Der 27. Januar",
      translated: "27 января",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "—",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "в Германии",
      tone: 'semantic',
    },
    {
      german: "ein offizieller Gedenktag",
      translated: "официальный день памяти",
      tone: 'semantic',
    },
    {
      german: "Woran",
      translated: "О чём",
      tone: 'semantic',
    },
    {
      german: "erinnert",
      translated: "напоминает",
      tone: 'semantic',
    },
    {
      german: "dieser Tag",
      translated: "этот день",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:220|sq": [
    {
      german: "Der 27. Januar",
      translated: "27 janari",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "është",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "në Gjermani",
      tone: 'semantic',
    },
    {
      german: "ein offizieller Gedenktag",
      translated: "ditë zyrtare përkujtimore",
      tone: 'semantic',
    },
    {
      german: "Woran",
      translated: "Çfarë",
      tone: 'semantic',
    },
    {
      german: "erinnert",
      translated: "përkujtohet",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:220|sr": [
    {
      german: "Der 27. Januar",
      translated: "27. januara",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "U Nemačkoj",
      tone: 'semantic',
    },
    {
      german: "ein offizieller Gedenktag",
      translated: "zvanični dan sjećanja",
      tone: 'semantic',
    },
    {
      german: "Woran",
      translated: "Na šta",
      tone: 'semantic',
    },
    {
      german: "erinnert",
      translated: "podsjeća",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:220|tr": [
    {
      german: "Der 27. Januar",
      translated: "27 Ocak",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "Almanya'da",
      tone: 'semantic',
    },
    {
      german: "ein offizieller Gedenktag",
      translated: "resmî anma günüdür.",
      tone: 'semantic',
    },
    {
      german: "Woran",
      translated: "neyi",
      tone: 'semantic',
    },
    {
      german: "erinnert",
      translated: "anımsatır",
      tone: 'semantic',
    },
    {
      german: "dieser Tag",
      translated: "Bu gün",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:220|uk": [
    {
      german: "Der 27. Januar",
      translated: "27 січня",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "є",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "в Німеччині",
      tone: 'semantic',
    },
    {
      german: "ein offizieller Gedenktag",
      translated: "офіційним днем пам’яті",
      tone: 'semantic',
    },
    {
      german: "Woran",
      translated: "Про що",
      tone: 'semantic',
    },
    {
      german: "erinnert",
      translated: "нагадує",
      tone: 'semantic',
    },
    {
      german: "dieser Tag",
      translated: "цей день",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:220|vi": [
    {
      german: "Der 27. Januar",
      translated: "Ngày 27 tháng 1",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "là",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "ở Đức",
      tone: 'semantic',
    },
    {
      german: "ein offizieller Gedenktag",
      translated: "ngày tưởng niệm chính thức",
      tone: 'semantic',
    },
    {
      german: "Woran",
      translated: "điều gì",
      tone: 'semantic',
    },
    {
      german: "erinnert",
      translated: "tưởng nhớ",
      tone: 'semantic',
    },
    {
      german: "dieser Tag",
      translated: "Ngày này",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:221|ar": [
    {
      german: "Deutschland ist Mitglied",
      translated: "ألمانيا عضو",
      tone: 'semantic',
    },
    {
      german: "des Schengener Abkommens",
      translated: "في اتفاقية شنغن",
      tone: 'semantic',
    },
    {
      german: "Was bedeutet das",
      translated: "ماذا يعني ذلك",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:221|bg": [
    {
      german: "Deutschland ist Mitglied",
      translated: "Германия е член",
      tone: 'semantic',
    },
    {
      german: "des Schengener Abkommens",
      translated: "на Шенгенското споразумение",
      tone: 'semantic',
    },
    {
      german: "Was bedeutet das",
      translated: "Какво означава това",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:221|bs": [
    {
      german: "Deutschland ist Mitglied",
      translated: "Njemačka je članica",
      tone: 'semantic',
    },
    {
      german: "des Schengener Abkommens",
      translated: "Schengenskog sporazuma",
      tone: 'semantic',
    },
    {
      german: "Was bedeutet das",
      translated: "Što to znači",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:221|el": [
    {
      german: "Deutschland ist Mitglied",
      translated: "Η Γερμανία είναι μέλος",
      tone: 'semantic',
    },
    {
      german: "des Schengener Abkommens",
      translated: "της Συμφωνίας Σένγκεν",
      tone: 'semantic',
    },
    {
      german: "Was bedeutet das",
      translated: "Τι σημαίνει αυτό",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:221|en": [
    {
      german: "Deutschland ist Mitglied",
      translated: "Germany is a member",
      tone: 'semantic',
    },
    {
      german: "des Schengener Abkommens",
      translated: "of the Schengen Agreement",
      tone: 'semantic',
    },
    {
      german: "Was bedeutet das",
      translated: "What does that mean",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:221|es": [
    {
      german: "Deutschland ist Mitglied",
      translated: "Alemania forma parte",
      tone: 'semantic',
    },
    {
      german: "des Schengener Abkommens",
      translated: "Acuerdo de Schengen",
      tone: 'semantic',
    },
    {
      german: "Was bedeutet das",
      translated: "¿Qué significa eso",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:221|fa": [
    {
      german: "Deutschland ist Mitglied",
      translated: "آلمان عضو",
      tone: 'semantic',
    },
    {
      german: "des Schengener Abkommens",
      translated: "پیمان شنگن",
      tone: 'semantic',
    },
    {
      german: "Was bedeutet das",
      translated: "این یعنی چه؟",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:221|fr": [
    {
      german: "Deutschland ist Mitglied",
      translated: "L’Allemagne est membre de",
      tone: 'semantic',
    },
    {
      german: "des Schengener Abkommens",
      translated: "l’accord de Schengen",
      tone: 'semantic',
    },
    {
      german: "Was bedeutet das",
      translated: "Qu’est-ce que cela signifie",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:221|hr": [
    {
      german: "Deutschland ist Mitglied",
      translated: "Njemačka je članica",
      tone: 'semantic',
    },
    {
      german: "des Schengener Abkommens",
      translated: "Schengenskog sporazuma",
      tone: 'semantic',
    },
    {
      german: "Was bedeutet das",
      translated: "Što to znači",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:221|it": [
    {
      german: "Deutschland ist Mitglied",
      translated: "La Germania fa parte",
      tone: 'semantic',
    },
    {
      german: "des Schengener Abkommens",
      translated: "dell’Accordo di Schengen",
      tone: 'semantic',
    },
    {
      german: "Was bedeutet das",
      translated: "Che cosa significa",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:221|kmr": [
    {
      german: "Deutschland ist Mitglied",
      translated: "Almanya endamê",
      tone: 'semantic',
    },
    {
      german: "des Schengener Abkommens",
      translated: "Schengen e.",
      tone: 'semantic',
    },
    {
      german: "Was bedeutet das",
      translated: "Ev tê çi wateyê?",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:221|pl": [
    {
      german: "Deutschland ist Mitglied",
      translated: "Niemcy są",
      tone: 'semantic',
    },
    {
      german: "des Schengener Abkommens",
      translated: "układu z Schengen",
      tone: 'semantic',
    },
    {
      german: "Was bedeutet das",
      translated: "Co to oznacza?",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:221|prs": [
    {
      german: "Deutschland ist Mitglied",
      translated: "آلمان عضو",
      tone: 'semantic',
    },
    {
      german: "des Schengener Abkommens",
      translated: "پیمان شنگن",
      tone: 'semantic',
    },
    {
      german: "Was bedeutet das",
      translated: "این یعنی چه",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:221|ro": [
    {
      german: "Deutschland ist Mitglied",
      translated: "Germania este membră",
      tone: 'semantic',
    },
    {
      german: "des Schengener Abkommens",
      translated: "a Acordului Schengen",
      tone: 'semantic',
    },
    {
      german: "Was bedeutet das",
      translated: "Ce înseamnă aceasta?",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:221|ru": [
    {
      german: "Deutschland ist Mitglied",
      translated: "Германия является участником",
      tone: 'semantic',
    },
    {
      german: "des Schengener Abkommens",
      translated: "Шенгенского соглашения",
      tone: 'semantic',
    },
    {
      german: "Was bedeutet das",
      translated: "Что это значит?",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:221|sq": [
    {
      german: "Deutschland ist Mitglied",
      translated: "Gjermania është anëtare",
      tone: 'semantic',
    },
    {
      german: "des Schengener Abkommens",
      translated: "e Marrëveshjes së Shengenit",
      tone: 'semantic',
    },
    {
      german: "Was bedeutet das",
      translated: "Çfarë do të thotë kjo",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:221|sr": [
    {
      german: "Deutschland ist Mitglied",
      translated: "Nemačka je članica",
      tone: 'semantic',
    },
    {
      german: "des Schengener Abkommens",
      translated: "Schengenskog sporazuma",
      tone: 'semantic',
    },
    {
      german: "Was bedeutet das",
      translated: "Šta to znači",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:221|tr": [
    {
      german: "Deutschland ist Mitglied",
      translated: "Almanya",
      tone: 'semantic',
    },
    {
      german: "des Schengener Abkommens",
      translated: "Schengen Anlaşması'nın",
      tone: 'semantic',
    },
    {
      german: "Was bedeutet das",
      translated: "Bu ne anlama gelir?",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:221|uk": [
    {
      german: "Deutschland ist Mitglied",
      translated: "Німеччина є учасницею",
      tone: 'semantic',
    },
    {
      german: "des Schengener Abkommens",
      translated: "Шенгенської угоди",
      tone: 'semantic',
    },
    {
      german: "Was bedeutet das",
      translated: "Що це означає",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:221|vi": [
    {
      german: "Deutschland ist Mitglied",
      translated: "Đức là thành viên",
      tone: 'semantic',
    },
    {
      german: "des Schengener Abkommens",
      translated: "của Hiệp định Schengen",
      tone: 'semantic',
    },
    {
      german: "Was bedeutet das",
      translated: "Điều đó có nghĩa là gì",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:222|ar": [
    {
      german: "Welches Land",
      translated: "أي دولة",
      tone: 'semantic',
    },
    {
      german: "ist ein",
      translated: "من",
      tone: 'semantic',
    },
    {
      german: "Nachbarland",
      translated: "تجاور ألمانيا",
      tone: 'semantic',
    },
    {
      german: "von Deutschland",
      translated: "؟",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:222|bg": [
    {
      german: "Welches Land",
      translated: "Коя държава",
      tone: 'semantic',
    },
    {
      german: "Nachbarland",
      translated: "граничи с",
      tone: 'semantic',
    },
    {
      german: "von Deutschland",
      translated: "Германия?",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:222|bs": [
    {
      german: "Welches Land",
      translated: "Koja država",
      tone: 'semantic',
    },
    {
      german: "Nachbarland",
      translated: "graniči s",
      tone: 'semantic',
    },
    {
      german: "von Deutschland",
      translated: "Njemačkom?",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:222|el": [
    {
      german: "Welches Land",
      translated: "Ποια χώρα",
      tone: 'semantic',
    },
    {
      german: "Nachbarland",
      translated: "συνορεύει",
      tone: 'semantic',
    },
    {
      german: "von Deutschland",
      translated: "με τη Γερμανία",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:222|en": [
    {
      german: "Welches Land",
      translated: "Which country",
      tone: 'semantic',
    },
    {
      german: "ist ein",
      translated: "is a",
      tone: 'semantic',
    },
    {
      german: "Nachbarland",
      translated: "neighboring country",
      tone: 'semantic',
    },
    {
      german: "von Deutschland",
      translated: "of Germany",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:222|es": [
    {
      german: "Welches Land",
      translated: "¿Qué país",
      tone: 'semantic',
    },
    {
      german: "Nachbarland",
      translated: "limita con",
      tone: 'semantic',
    },
    {
      german: "von Deutschland",
      translated: "Alemania",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:222|fa": [
    {
      german: "Welches Land",
      translated: "کدام کشور",
      tone: 'semantic',
    },
    {
      german: "ist ein",
      translated: "است",
      tone: 'semantic',
    },
    {
      german: "Nachbarland",
      translated: "همسایهٔ",
      tone: 'semantic',
    },
    {
      german: "von Deutschland",
      translated: "آلمان",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:222|fr": [
    {
      german: "Welches Land",
      translated: "Quel pays",
      tone: 'semantic',
    },
    {
      german: "ist ein",
      translated: "est",
      tone: 'semantic',
    },
    {
      german: "Nachbarland",
      translated: "voisin",
      tone: 'semantic',
    },
    {
      german: "von Deutschland",
      translated: "de l’Allemagne",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:222|hr": [
    {
      german: "Welches Land",
      translated: "Koja država",
      tone: 'semantic',
    },
    {
      german: "Nachbarland",
      translated: "graniči",
      tone: 'semantic',
    },
    {
      german: "von Deutschland",
      translated: "s Njemačkom",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:222|it": [
    {
      german: "Welches Land",
      translated: "Quale Paese",
      tone: 'semantic',
    },
    {
      german: "Nachbarland",
      translated: "confina con la",
      tone: 'semantic',
    },
    {
      german: "von Deutschland",
      translated: "Germania",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:222|kmr": [
    {
      german: "Welches Land",
      translated: "Kîjan welat",
      tone: 'semantic',
    },
    {
      german: "ist ein",
      translated: "ye",
      tone: 'semantic',
    },
    {
      german: "Nachbarland",
      translated: "cîranê",
      tone: 'semantic',
    },
    {
      german: "von Deutschland",
      translated: "Almanyayê",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:222|pl": [
    {
      german: "Welches Land",
      translated: "Które państwo",
      tone: 'semantic',
    },
    {
      german: "Nachbarland",
      translated: "graniczy",
      tone: 'semantic',
    },
    {
      german: "von Deutschland",
      translated: "z Niemcami",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:222|prs": [
    {
      german: "Welches Land",
      translated: "کدام کشور",
      tone: 'semantic',
    },
    {
      german: "ist ein",
      translated: "است",
      tone: 'semantic',
    },
    {
      german: "Nachbarland",
      translated: "همسایهٔ",
      tone: 'semantic',
    },
    {
      german: "von Deutschland",
      translated: "آلمان",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:222|ro": [
    {
      german: "Welches Land",
      translated: "Care țară",
      tone: 'semantic',
    },
    {
      german: "ist ein",
      translated: "se",
      tone: 'semantic',
    },
    {
      german: "Nachbarland",
      translated: "învecinează",
      tone: 'semantic',
    },
    {
      german: "von Deutschland",
      translated: "cu Germania?",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:222|ru": [
    {
      german: "Welches Land",
      translated: "Какая страна",
      tone: 'semantic',
    },
    {
      german: "ist ein",
      translated: "является",
      tone: 'semantic',
    },
    {
      german: "Nachbarland",
      translated: "соседом",
      tone: 'semantic',
    },
    {
      german: "von Deutschland",
      translated: "Германии",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:222|sq": [
    {
      german: "Welches Land",
      translated: "Cili",
      tone: 'semantic',
    },
    {
      german: "Nachbarland",
      translated: "shtet kufizohet me",
      tone: 'semantic',
    },
    {
      german: "von Deutschland",
      translated: "Gjermaninë",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:222|sr": [
    {
      german: "Welches Land",
      translated: "Koja država",
      tone: 'semantic',
    },
    {
      german: "Nachbarland",
      translated: "graniči",
      tone: 'semantic',
    },
    {
      german: "von Deutschland",
      translated: "s Nemačkom",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:222|tr": [
    {
      german: "Welches Land",
      translated: "Aşağıdaki ülkelerden hangisi",
      tone: 'semantic',
    },
    {
      german: "Nachbarland",
      translated: "komşusudur",
      tone: 'semantic',
    },
    {
      german: "von Deutschland",
      translated: "Almanya'nın",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:222|uk": [
    {
      german: "Welches Land",
      translated: "Яка країна",
      tone: 'semantic',
    },
    {
      german: "ist ein",
      translated: "є",
      tone: 'semantic',
    },
    {
      german: "Nachbarland",
      translated: "сусідньою",
      tone: 'semantic',
    },
    {
      german: "von Deutschland",
      translated: "з Німеччиною",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:222|vi": [
    {
      german: "Welches Land",
      translated: "Quốc gia nào",
      tone: 'semantic',
    },
    {
      german: "Nachbarland",
      translated: "giáp",
      tone: 'semantic',
    },
    {
      german: "von Deutschland",
      translated: "Đức",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:223|ar": [
    {
      german: "Welches Land",
      translated: "أي دولة",
      tone: 'semantic',
    },
    {
      german: "ein Nachbarland",
      translated: "من الدول التالية",
      tone: 'semantic',
    },
    {
      german: "von Deutschland",
      translated: "ألمانيا",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:223|bg": [
    {
      german: "Welches Land",
      translated: "Коя държава",
      tone: 'semantic',
    },
    {
      german: "ein Nachbarland",
      translated: "граничи",
      tone: 'semantic',
    },
    {
      german: "von Deutschland",
      translated: "с Германия?",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:223|bs": [
    {
      german: "Welches Land",
      translated: "Koja država",
      tone: 'semantic',
    },
    {
      german: "ein Nachbarland",
      translated: "graniči",
      tone: 'semantic',
    },
    {
      german: "von Deutschland",
      translated: "s Njemačkom",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:223|el": [
    {
      german: "Welches Land",
      translated: "Ποια χώρα",
      tone: 'semantic',
    },
    {
      german: "ein Nachbarland",
      translated: "συνορεύει με τη",
      tone: 'semantic',
    },
    {
      german: "von Deutschland",
      translated: "Γερμανία",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:223|en": [
    {
      german: "Welches Land",
      translated: "Which country",
      tone: 'semantic',
    },
    {
      german: "ein Nachbarland",
      translated: "a neighboring country",
      tone: 'semantic',
    },
    {
      german: "von Deutschland",
      translated: "of Germany",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:223|es": [
    {
      german: "Welches Land",
      translated: "¿Qué país",
      tone: 'semantic',
    },
    {
      german: "ein Nachbarland",
      translated: "limita con",
      tone: 'semantic',
    },
    {
      german: "von Deutschland",
      translated: "Alemania",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:223|fa": [
    {
      german: "Welches Land",
      translated: "کدام کشور",
      tone: 'semantic',
    },
    {
      german: "ein Nachbarland",
      translated: "همسایهٔ",
      tone: 'semantic',
    },
    {
      german: "von Deutschland",
      translated: "آلمان",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:223|fr": [
    {
      german: "Welches Land",
      translated: "Quel pays",
      tone: 'semantic',
    },
    {
      german: "ein Nachbarland",
      translated: "voisin",
      tone: 'semantic',
    },
    {
      german: "von Deutschland",
      translated: "l’Allemagne",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:223|hr": [
    {
      german: "Welches Land",
      translated: "Koja država",
      tone: 'semantic',
    },
    {
      german: "ein Nachbarland",
      translated: "graniči s",
      tone: 'semantic',
    },
    {
      german: "von Deutschland",
      translated: "Njemačkom",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:223|it": [
    {
      german: "Welches Land",
      translated: "Quale Paese",
      tone: 'semantic',
    },
    {
      german: "ein Nachbarland",
      translated: "confina con",
      tone: 'semantic',
    },
    {
      german: "von Deutschland",
      translated: "la Germania",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:223|kmr": [
    {
      german: "Welches Land",
      translated: "Kîjan",
      tone: 'semantic',
    },
    {
      german: "ein Nachbarland",
      translated: "welat",
      tone: 'semantic',
    },
    {
      german: "von Deutschland",
      translated: "cîranê Almanyayê ye",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:223|pl": [
    {
      german: "Welches Land",
      translated: "Które państwo",
      tone: 'semantic',
    },
    {
      german: "ein Nachbarland",
      translated: "graniczy",
      tone: 'semantic',
    },
    {
      german: "von Deutschland",
      translated: "z Niemcami?",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:223|prs": [
    {
      german: "Welches Land",
      translated: "کدام کشور",
      tone: 'semantic',
    },
    {
      german: "ein Nachbarland",
      translated: "همسایهٔ",
      tone: 'semantic',
    },
    {
      german: "von Deutschland",
      translated: "آلمان",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:223|ro": [
    {
      german: "Welches Land",
      translated: "Care țară",
      tone: 'semantic',
    },
    {
      german: "ein Nachbarland",
      translated: "se învecinează",
      tone: 'semantic',
    },
    {
      german: "von Deutschland",
      translated: "cu Germania",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:223|ru": [
    {
      german: "Welches Land",
      translated: "Какая страна",
      tone: 'semantic',
    },
    {
      german: "ein Nachbarland",
      translated: "соседом",
      tone: 'semantic',
    },
    {
      german: "von Deutschland",
      translated: "Германии",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:223|sq": [
    {
      german: "Welches Land",
      translated: "Cili shtet",
      tone: 'semantic',
    },
    {
      german: "ein Nachbarland",
      translated: "kufizohet",
      tone: 'semantic',
    },
    {
      german: "von Deutschland",
      translated: "me Gjermaninë",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:223|sr": [
    {
      german: "Welches Land",
      translated: "Koja država",
      tone: 'semantic',
    },
    {
      german: "ein Nachbarland",
      translated: "se graniči",
      tone: 'semantic',
    },
    {
      german: "von Deutschland",
      translated: "s Nemačkom",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:223|tr": [
    {
      german: "Welches Land",
      translated: "Aşağıdaki ülkelerden hangisi",
      tone: 'semantic',
    },
    {
      german: "ein Nachbarland",
      translated: "komşusudur",
      tone: 'semantic',
    },
    {
      german: "von Deutschland",
      translated: "Almanya'nın",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:223|uk": [
    {
      german: "Welches Land",
      translated: "Яка країна",
      tone: 'semantic',
    },
    {
      german: "ein Nachbarland",
      translated: "сусідньою",
      tone: 'semantic',
    },
    {
      german: "von Deutschland",
      translated: "з Німеччиною",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:223|vi": [
    {
      german: "Welches Land",
      translated: "Quốc gia nào",
      tone: 'semantic',
    },
    {
      german: "ein Nachbarland",
      translated: "giáp",
      tone: 'semantic',
    },
    {
      german: "von Deutschland",
      translated: "Đức",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:224|ar": [
    {
      german: "Was bedeutet",
      translated: "ماذا يعني",
      tone: 'semantic',
    },
    {
      german: "die Abkürzung",
      translated: "الاختصار",
      tone: 'semantic',
    },
    {
      german: "EU",
      translated: "EU",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:224|bg": [
    {
      german: "Was bedeutet",
      translated: "Какво",
      tone: 'semantic',
    },
    {
      german: "die Abkürzung",
      translated: "съкращението",
      tone: 'semantic',
    },
    {
      german: "EU",
      translated: "EU",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:224|bs": [
    {
      german: "Was bedeutet",
      translated: "Što znači",
      tone: 'semantic',
    },
    {
      german: "die Abkürzung",
      translated: "kratica",
      tone: 'semantic',
    },
    {
      german: "EU",
      translated: "EU",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:224|el": [
    {
      german: "Was bedeutet",
      translated: "Τι σημαίνει",
      tone: 'semantic',
    },
    {
      german: "die Abkürzung",
      translated: "η συντομογραφία",
      tone: 'semantic',
    },
    {
      german: "EU",
      translated: "EU",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:224|en": [
    {
      german: "Was bedeutet",
      translated: "What does",
      tone: 'semantic',
    },
    {
      german: "die Abkürzung",
      translated: "the abbreviation",
      tone: 'semantic',
    },
    {
      german: "EU",
      translated: "EU",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:224|es": [
    {
      german: "Was bedeutet",
      translated: "¿Qué significa",
      tone: 'semantic',
    },
    {
      german: "die Abkürzung",
      translated: "la abreviatura",
      tone: 'semantic',
    },
    {
      german: "EU",
      translated: "UE",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:224|fa": [
    {
      german: "Was bedeutet",
      translated: "به چه معناست",
      tone: 'semantic',
    },
    {
      german: "die Abkürzung",
      translated: "مخفف",
      tone: 'semantic',
    },
    {
      german: "EU",
      translated: "EU",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:224|fr": [
    {
      german: "Was bedeutet",
      translated: "Que signifie",
      tone: 'semantic',
    },
    {
      german: "die Abkürzung",
      translated: "l’abréviation",
      tone: 'semantic',
    },
    {
      german: "EU",
      translated: "EU",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:224|hr": [
    {
      german: "Was bedeutet",
      translated: "Što znači",
      tone: 'semantic',
    },
    {
      german: "die Abkürzung",
      translated: "kratica",
      tone: 'semantic',
    },
    {
      german: "EU",
      translated: "EU",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:224|it": [
    {
      german: "Was bedeutet",
      translated: "Che cosa significa",
      tone: 'semantic',
    },
    {
      german: "die Abkürzung",
      translated: "l’abbreviazione",
      tone: 'semantic',
    },
    {
      german: "EU",
      translated: "UE",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:224|kmr": [
    {
      german: "Was bedeutet",
      translated: "Kurteya",
      tone: 'semantic',
    },
    {
      german: "die Abkürzung",
      translated: "tê çi wateyê",
      tone: 'semantic',
    },
    {
      german: "EU",
      translated: "EU",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:224|pl": [
    {
      german: "Was bedeutet",
      translated: "Co oznacza",
      tone: 'semantic',
    },
    {
      german: "die Abkürzung",
      translated: "skrót",
      tone: 'semantic',
    },
    {
      german: "EU",
      translated: "UE",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:224|prs": [
    {
      german: "Was bedeutet",
      translated: "به چه معناست",
      tone: 'semantic',
    },
    {
      german: "die Abkürzung",
      translated: "مخفف",
      tone: 'semantic',
    },
    {
      german: "EU",
      translated: "EU",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:224|ro": [
    {
      german: "Was bedeutet",
      translated: "Ce înseamnă",
      tone: 'semantic',
    },
    {
      german: "die Abkürzung",
      translated: "abrevierea",
      tone: 'semantic',
    },
    {
      german: "EU",
      translated: "UE",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:224|ru": [
    {
      german: "Was bedeutet",
      translated: "Что означает",
      tone: 'semantic',
    },
    {
      german: "die Abkürzung",
      translated: "аббревиатура",
      tone: 'semantic',
    },
    {
      german: "EU",
      translated: "EU (ЕС)",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:224|sq": [
    {
      german: "Was bedeutet",
      translated: "Çfarë do të thotë",
      tone: 'semantic',
    },
    {
      german: "die Abkürzung",
      translated: "shkurtesa",
      tone: 'semantic',
    },
    {
      german: "EU",
      translated: "EU",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:224|sr": [
    {
      german: "Was bedeutet",
      translated: "Šta znači",
      tone: 'semantic',
    },
    {
      german: "die Abkürzung",
      translated: "kratica",
      tone: 'semantic',
    },
    {
      german: "EU",
      translated: "EU",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:224|tr": [
    {
      german: "Was bedeutet",
      translated: "ne anlama gelir",
      tone: 'semantic',
    },
    {
      german: "die Abkürzung",
      translated: "kısaltması",
      tone: 'semantic',
    },
    {
      german: "EU",
      translated: "AB (EU)",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:224|uk": [
    {
      german: "Was bedeutet",
      translated: "Що означає",
      tone: 'semantic',
    },
    {
      german: "die Abkürzung",
      translated: "абревіатура",
      tone: 'semantic',
    },
    {
      german: "EU",
      translated: "EU",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:224|vi": [
    {
      german: "Was bedeutet",
      translated: "có nghĩa là gì",
      tone: 'semantic',
    },
    {
      german: "die Abkürzung",
      translated: "Chữ viết tắt",
      tone: 'semantic',
    },
    {
      german: "EU",
      translated: "EU",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:225|ar": [
    {
      german: "In welchem anderen Land",
      translated: "في أي دولة أخرى",
      tone: 'semantic',
    },
    {
      german: "gibt es",
      translated: "توجد",
      tone: 'semantic',
    },
    {
      german: "eine große deutschsprachige Bevölkerung",
      translated: "نسبة كبيرة من السكان الناطقين بالألمانية",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:225|bg": [
    {
      german: "In welchem anderen Land",
      translated: "В коя друга държава",
      tone: 'semantic',
    },
    {
      german: "gibt es",
      translated: "живее",
      tone: 'semantic',
    },
    {
      german: "eine große deutschsprachige Bevölkerung",
      translated: "значително немскоговорящо население",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:225|bs": [
    {
      german: "In welchem anderen Land",
      translated: "U kojoj drugoj državi",
      tone: 'semantic',
    },
    {
      german: "gibt es",
      translated: "živi",
      tone: 'semantic',
    },
    {
      german: "eine große deutschsprachige Bevölkerung",
      translated: "velik broj stanovnika koji govore njemački",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:225|el": [
    {
      german: "In welchem anderen Land",
      translated: "Σε ποια άλλη χώρα",
      tone: 'semantic',
    },
    {
      german: "gibt es",
      translated: "ζει σημαντικός",
      tone: 'semantic',
    },
    {
      german: "eine große deutschsprachige Bevölkerung",
      translated: "γερμανόφωνος πληθυσμός;",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:225|en": [
    {
      german: "In welchem anderen Land",
      translated: "In which other country",
      tone: 'semantic',
    },
    {
      german: "gibt es",
      translated: "is there",
      tone: 'semantic',
    },
    {
      german: "eine große deutschsprachige Bevölkerung",
      translated: "a large German-speaking population",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:225|es": [
    {
      german: "In welchem anderen Land",
      translated: "En qué otro país",
      tone: 'semantic',
    },
    {
      german: "gibt es",
      translated: "hay",
      tone: 'semantic',
    },
    {
      german: "eine große deutschsprachige Bevölkerung",
      translated: "una gran población de habla alemana",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:225|fa": [
    {
      german: "In welchem anderen Land",
      translated: "در کدام کشور دیگر",
      tone: 'semantic',
    },
    {
      german: "gibt es",
      translated: "زندگی می‌کنند",
      tone: 'semantic',
    },
    {
      german: "eine große deutschsprachige Bevölkerung",
      translated: "جمعیت قابل توجهی آلمانی‌زبان",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:225|fr": [
    {
      german: "In welchem anderen Land",
      translated: "Dans quel autre pays",
      tone: 'semantic',
    },
    {
      german: "gibt es",
      translated: "existe-t-il",
      tone: 'semantic',
    },
    {
      german: "eine große deutschsprachige Bevölkerung",
      translated: "une importante population germanophone",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:225|hr": [
    {
      german: "In welchem anderen Land",
      translated: "U kojoj drugoj državi",
      tone: 'semantic',
    },
    {
      german: "gibt es",
      translated: "živi",
      tone: 'semantic',
    },
    {
      german: "eine große deutschsprachige Bevölkerung",
      translated: "velik broj stanovnika koji govore njemački",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:225|it": [
    {
      german: "In welchem anderen Land",
      translated: "In quale altro Paese",
      tone: 'semantic',
    },
    {
      german: "gibt es",
      translated: "vive",
      tone: 'semantic',
    },
    {
      german: "eine große deutschsprachige Bevölkerung",
      translated: "una consistente popolazione di lingua tedesca",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:225|kmr": [
    {
      german: "In welchem anderen Land",
      translated: "Li kîjan welatê din",
      tone: 'semantic',
    },
    {
      german: "eine große deutschsprachige Bevölkerung",
      translated: "nifûseke mezin a Almanîaxêv heye",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:225|pl": [
    {
      german: "In welchem anderen Land",
      translated: "W którym innym państwie",
      tone: 'semantic',
    },
    {
      german: "gibt es",
      translated: "mieszka",
      tone: 'semantic',
    },
    {
      german: "eine große deutschsprachige Bevölkerung",
      translated: "znaczna ludność niemieckojęzyczna",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:225|prs": [
    {
      german: "In welchem anderen Land",
      translated: "در کدام کشور دیگر",
      tone: 'semantic',
    },
    {
      german: "eine große deutschsprachige Bevölkerung",
      translated: " جمعیت قابل توجهی آلمانی‌زبان",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:225|ro": [
    {
      german: "In welchem anderen Land",
      translated: "În ce altă țară",
      tone: 'semantic',
    },
    {
      german: "gibt es",
      translated: "trăiește",
      tone: 'semantic',
    },
    {
      german: "eine große deutschsprachige Bevölkerung",
      translated: "o populație importantă vorbitoare de germană",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:225|ru": [
    {
      german: "In welchem anderen Land",
      translated: "В какой ещё стране",
      tone: 'semantic',
    },
    {
      german: "gibt es",
      translated: "проживает",
      tone: 'semantic',
    },
    {
      german: "eine große deutschsprachige Bevölkerung",
      translated: "многочисленное немецкоязычное население",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:225|sq": [
    {
      german: "In welchem anderen Land",
      translated: "Në cilin shtet tjetër",
      tone: 'semantic',
    },
    {
      german: "gibt es",
      translated: "jeton",
      tone: 'semantic',
    },
    {
      german: "eine große deutschsprachige Bevölkerung",
      translated: "një popullsi e konsiderueshme gjermanishtfolëse",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:225|sr": [
    {
      german: "In welchem anderen Land",
      translated: "U kojoj drugoj državi",
      tone: 'semantic',
    },
    {
      german: "gibt es",
      translated: "živi",
      tone: 'semantic',
    },
    {
      german: "eine große deutschsprachige Bevölkerung",
      translated: "velik broj stanovnika koji govore nemački",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:225|tr": [
    {
      german: "In welchem anderen Land",
      translated: "Başka hangi ülkede",
      tone: 'semantic',
    },
    {
      german: "eine große deutschsprachige Bevölkerung",
      translated: "büyük bir Almanca konuşan nüfus vardır",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:225|uk": [
    {
      german: "In welchem anderen Land",
      translated: "У якій іншій країні",
      tone: 'semantic',
    },
    {
      german: "gibt es",
      translated: "проживає",
      tone: 'semantic',
    },
    {
      german: "eine große deutschsprachige Bevölkerung",
      translated: "велика німецькомовна частина населення",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:225|vi": [
    {
      german: "In welchem anderen Land",
      translated: "Ở quốc gia nào khác",
      tone: 'semantic',
    },
    {
      german: "gibt es",
      translated: "có",
      tone: 'semantic',
    },
    {
      german: "eine große deutschsprachige Bevölkerung",
      translated: "một cộng đồng nói tiếng Đức đáng kể",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:226|ar": [
    {
      german: "Welche",
      translated: "أي",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "علم",
      tone: 'semantic',
    },
    {
      german: "die Flagge",
      translated: "من الصور",
      tone: 'semantic',
    },
    {
      german: "der Europäischen Union",
      translated: "الاتحاد الأوروبي",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:226|bg": [
    {
      german: "Welche",
      translated: "Кое",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "принадлежи",
      tone: 'semantic',
    },
    {
      german: "die Flagge",
      translated: "знаме",
      tone: 'semantic',
    },
    {
      german: "der Europäischen Union",
      translated: "на Европейския съюз",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:226|bs": [
    {
      german: "Welche",
      translated: "Koja",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "pripada",
      tone: 'semantic',
    },
    {
      german: "die Flagge",
      translated: "zastava",
      tone: 'semantic',
    },
    {
      german: "der Europäischen Union",
      translated: "Evropskoj uniji?",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:226|el": [
    {
      german: "Welche",
      translated: "Ποια",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "ανήκει",
      tone: 'semantic',
    },
    {
      german: "die Flagge",
      translated: "σημαία",
      tone: 'semantic',
    },
    {
      german: "der Europäischen Union",
      translated: "στην Ευρωπαϊκή Ένωση",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:226|en": [
    {
      german: "Welche",
      translated: "Which",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "is",
      tone: 'semantic',
    },
    {
      german: "die Flagge",
      translated: "the flag",
      tone: 'semantic',
    },
    {
      german: "der Europäischen Union",
      translated: "of the European Union",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:226|es": [
    {
      german: "Welche",
      translated: "¿Cuál",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "es",
      tone: 'semantic',
    },
    {
      german: "die Flagge",
      translated: "la bandera",
      tone: 'semantic',
    },
    {
      german: "der Europäischen Union",
      translated: "de la Unión Europea",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:226|fa": [
    {
      german: "Welche",
      translated: "کدام",
      tone: 'semantic',
    },
    {
      german: "die Flagge",
      translated: "پرچم",
      tone: 'semantic',
    },
    {
      german: "der Europäischen Union",
      translated: "اتحادیهٔ اروپا",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:226|fr": [
    {
      german: "Welche",
      translated: "Quel",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "est",
      tone: 'semantic',
    },
    {
      german: "die Flagge",
      translated: "drapeau",
      tone: 'semantic',
    },
    {
      german: "der Europäischen Union",
      translated: "de l’Union européenne",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:226|hr": [
    {
      german: "Welche",
      translated: "Koja",
      tone: 'semantic',
    },
    {
      german: "die Flagge",
      translated: "zastava",
      tone: 'semantic',
    },
    {
      german: "der Europäischen Union",
      translated: "Europskoj uniji",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:226|it": [
    {
      german: "Welche",
      translated: "Quale",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "appartiene",
      tone: 'semantic',
    },
    {
      german: "die Flagge",
      translated: "bandiera",
      tone: 'semantic',
    },
    {
      german: "der Europäischen Union",
      translated: "all’Unione europea",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:226|kmr": [
    {
      german: "Welche",
      translated: "Kîjan",
      tone: 'semantic',
    },
    {
      german: "die Flagge",
      translated: "Yekîtiya",
      tone: 'semantic',
    },
    {
      german: "der Europäischen Union",
      translated: "Ewropî ye?",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:226|pl": [
    {
      german: "Welche",
      translated: "Która",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "należy do",
      tone: 'semantic',
    },
    {
      german: "die Flagge",
      translated: "flaga",
      tone: 'semantic',
    },
    {
      german: "der Europäischen Union",
      translated: "Unii Europejskiej",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:226|prs": [
    {
      german: "Welche",
      translated: "کدام",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "است",
      tone: 'semantic',
    },
    {
      german: "die Flagge",
      translated: "پرچم",
      tone: 'semantic',
    },
    {
      german: "der Europäischen Union",
      translated: "اتحادیه اروپا",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:226|ro": [
    {
      german: "Welche",
      translated: "Care",
      tone: 'semantic',
    },
    {
      german: "die Flagge",
      translated: "steag",
      tone: 'semantic',
    },
    {
      german: "der Europäischen Union",
      translated: "Uniunii Europene?",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:226|ru": [
    {
      german: "Welche",
      translated: "Какой",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "является",
      tone: 'semantic',
    },
    {
      german: "die Flagge",
      translated: "флаг",
      tone: 'semantic',
    },
    {
      german: "der Europäischen Union",
      translated: "Европейского союза",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:226|sq": [
    {
      german: "Welche",
      translated: "Cili",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "i përket",
      tone: 'semantic',
    },
    {
      german: "die Flagge",
      translated: "flamur",
      tone: 'semantic',
    },
    {
      german: "der Europäischen Union",
      translated: "Bashkimit Evropian",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:226|sr": [
    {
      german: "Welche",
      translated: "Koja",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "pripada",
      tone: 'semantic',
    },
    {
      german: "die Flagge",
      translated: "zastava",
      tone: 'semantic',
    },
    {
      german: "der Europäischen Union",
      translated: "Evropskoj uniji",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:226|tr": [
    {
      german: "ist",
      translated: "hangisidir",
      tone: 'semantic',
    },
    {
      german: "die Flagge",
      translated: "bayrağı",
      tone: 'semantic',
    },
    {
      german: "der Europäischen Union",
      translated: "Avrupa Birliği",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:226|uk": [
    {
      german: "Welche",
      translated: "Який",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "є",
      tone: 'semantic',
    },
    {
      german: "die Flagge",
      translated: "прапором",
      tone: 'semantic',
    },
    {
      german: "der Europäischen Union",
      translated: "Європейського Союзу",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:226|vi": [
    {
      german: "Welche",
      translated: "nào",
      tone: 'semantic',
    },
    {
      german: "die Flagge",
      translated: "Lá cờ",
      tone: 'semantic',
    },
    {
      german: "der Europäischen Union",
      translated: "Liên minh châu Âu",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:227|ar": [
    {
      german: "Welches Land",
      translated: "أي دولة",
      tone: 'semantic',
    },
    {
      german: "ist ein Nachbarland",
      translated: "تجاور",
      tone: 'semantic',
    },
    {
      german: "von Deutschland",
      translated: "ألمانيا؟",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:227|bg": [
    {
      german: "Welches Land",
      translated: "Коя държава",
      tone: 'semantic',
    },
    {
      german: "ist ein Nachbarland",
      translated: "граничи с",
      tone: 'semantic',
    },
    {
      german: "von Deutschland",
      translated: "Германия",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:227|bs": [
    {
      german: "Welches Land",
      translated: "Koja država",
      tone: 'semantic',
    },
    {
      german: "ist ein Nachbarland",
      translated: "graniči s",
      tone: 'semantic',
    },
    {
      german: "von Deutschland",
      translated: "Njemačkom",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:227|el": [
    {
      german: "Welches Land",
      translated: "Ποια χώρα",
      tone: 'semantic',
    },
    {
      german: "ist ein Nachbarland",
      translated: "συνορεύει με",
      tone: 'semantic',
    },
    {
      german: "von Deutschland",
      translated: "τη Γερμανία",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:227|en": [
    {
      german: "Welches Land",
      translated: "Which country",
      tone: 'semantic',
    },
    {
      german: "ist ein Nachbarland",
      translated: "is a neighboring country",
      tone: 'semantic',
    },
    {
      german: "von Deutschland",
      translated: "of Germany",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:227|es": [
    {
      german: "Welches Land",
      translated: "¿Qué país",
      tone: 'semantic',
    },
    {
      german: "ist ein Nachbarland",
      translated: "limita con",
      tone: 'semantic',
    },
    {
      german: "von Deutschland",
      translated: "Alemania",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:227|fa": [
    {
      german: "Welches Land",
      translated: "کدام کشور",
      tone: 'semantic',
    },
    {
      german: "ist ein Nachbarland",
      translated: "همسایهٔ",
      tone: 'semantic',
    },
    {
      german: "von Deutschland",
      translated: "آلمان",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:227|fr": [
    {
      german: "Welches Land",
      translated: "Quel pays",
      tone: 'semantic',
    },
    {
      german: "ist ein Nachbarland",
      translated: "est voisin",
      tone: 'semantic',
    },
    {
      german: "von Deutschland",
      translated: "de l’Allemagne",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:227|hr": [
    {
      german: "Welches Land",
      translated: "Koja država",
      tone: 'semantic',
    },
    {
      german: "ist ein Nachbarland",
      translated: "graniči s",
      tone: 'semantic',
    },
    {
      german: "von Deutschland",
      translated: "Njemačkom",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:227|it": [
    {
      german: "Welches Land",
      translated: "Quale Paese",
      tone: 'semantic',
    },
    {
      german: "ist ein Nachbarland",
      translated: "confina con",
      tone: 'semantic',
    },
    {
      german: "von Deutschland",
      translated: "la Germania",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:227|kmr": [
    {
      german: "Welches Land",
      translated: "Kîjan",
      tone: 'semantic',
    },
    {
      german: "ist ein Nachbarland",
      translated: "cîranê",
      tone: 'semantic',
    },
    {
      german: "von Deutschland",
      translated: "Almanyayê",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:227|pl": [
    {
      german: "Welches Land",
      translated: "Które państwo",
      tone: 'semantic',
    },
    {
      german: "ist ein Nachbarland",
      translated: "graniczy",
      tone: 'semantic',
    },
    {
      german: "von Deutschland",
      translated: "z Niemcami",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:227|prs": [
    {
      german: "Welches Land",
      translated: "کدام کشور",
      tone: 'semantic',
    },
    {
      german: "ist ein Nachbarland",
      translated: "همسایهٔ",
      tone: 'semantic',
    },
    {
      german: "von Deutschland",
      translated: "آلمان",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:227|ro": [
    {
      german: "Welches Land",
      translated: "Care țară",
      tone: 'semantic',
    },
    {
      german: "ist ein Nachbarland",
      translated: "se învecinează cu",
      tone: 'semantic',
    },
    {
      german: "von Deutschland",
      translated: "Germania",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:227|ru": [
    {
      german: "Welches Land",
      translated: "Какая страна",
      tone: 'semantic',
    },
    {
      german: "ist ein Nachbarland",
      translated: "является соседом",
      tone: 'semantic',
    },
    {
      german: "von Deutschland",
      translated: "Германии",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:227|sq": [
    {
      german: "Welches Land",
      translated: "Cili",
      tone: 'semantic',
    },
    {
      german: "ist ein Nachbarland",
      translated: "shtet kufizohet",
      tone: 'semantic',
    },
    {
      german: "von Deutschland",
      translated: "me Gjermaninë",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:227|sr": [
    {
      german: "Welches Land",
      translated: "Koja država",
      tone: 'semantic',
    },
    {
      german: "ist ein Nachbarland",
      translated: "se graniči",
      tone: 'semantic',
    },
    {
      german: "von Deutschland",
      translated: "s Nemačkom",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:227|tr": [
    {
      german: "Welches Land",
      translated: "hangisi",
      tone: 'semantic',
    },
    {
      german: "ist ein Nachbarland",
      translated: "komşusudur",
      tone: 'semantic',
    },
    {
      german: "von Deutschland",
      translated: "Almanya'nın",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:227|uk": [
    {
      german: "Welches Land",
      translated: "Яка країна",
      tone: 'semantic',
    },
    {
      german: "ist ein Nachbarland",
      translated: "є сусідньою",
      tone: 'semantic',
    },
    {
      german: "von Deutschland",
      translated: "з Німеччиною",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:227|vi": [
    {
      german: "Welches Land",
      translated: "Quốc gia",
      tone: 'semantic',
    },
    {
      german: "ist ein Nachbarland",
      translated: "nào giáp",
      tone: 'semantic',
    },
    {
      german: "von Deutschland",
      translated: " Đức",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:228|ar": [
    {
      german: "Beitritt der DDR zur Bundesrepublik Deutschland",
      translated: "انضمام DDR إلى جمهورية ألمانيا الاتحادية",
      tone: 'semantic',
    },
    {
      german: "im Jahr 1990",
      translated: "عام 1990",
      tone: 'semantic',
    },
    {
      german: "allgemein genannt",
      translated: "يُسمى عادةً",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:228|bg": [
    {
      german: "Beitritt der DDR zur Bundesrepublik Deutschland",
      translated: "присъединяването на ГДР към ФРГ",
      tone: 'semantic',
    },
    {
      german: "im Jahr 1990",
      translated: "през 1990 г.",
      tone: 'semantic',
    },
    {
      german: "allgemein genannt",
      translated: "обикновено се нарича",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:228|bs": [
    {
      german: "Beitritt der DDR zur Bundesrepublik Deutschland",
      translated: "pristupanje DDR-a Saveznoj Republici Njemačkoj",
      tone: 'semantic',
    },
    {
      german: "im Jahr 1990",
      translated: "1990.",
      tone: 'semantic',
    },
    {
      german: "allgemein genannt",
      translated: "Kako se obično naziva",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:228|el": [
    {
      german: "Beitritt der DDR zur Bundesrepublik Deutschland",
      translated: "προσχώρηση της ΛΔΓ στην ΟΔΓ",
      tone: 'semantic',
    },
    {
      german: "im Jahr 1990",
      translated: "το 1990",
      tone: 'semantic',
    },
    {
      german: "allgemein genannt",
      translated: "Πώς αποκαλείται συνήθως",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:228|en": [
    {
      german: "Beitritt der DDR zur Bundesrepublik Deutschland",
      translated: "accession of the GDR to the Federal Republic of Germany",
      tone: 'semantic',
    },
    {
      german: "im Jahr 1990",
      translated: "in 1990",
      tone: 'semantic',
    },
    {
      german: "allgemein genannt",
      translated: "generally called",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:228|es": [
    {
      german: "Beitritt der DDR zur Bundesrepublik Deutschland",
      translated: "incorporación de la RDA a la República Federal de Alemania",
      tone: 'semantic',
    },
    {
      german: "im Jahr 1990",
      translated: "en 1990",
      tone: 'semantic',
    },
    {
      german: "allgemein genannt",
      translated: "se denomina generalmente",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:228|fa": [
    {
      german: "Beitritt der DDR zur Bundesrepublik Deutschland",
      translated: "پیوستن جمهوری دموکراتیک آلمان به جمهوری فدرال آلمان",
      tone: 'semantic',
    },
    {
      german: "im Jahr 1990",
      translated: "در سال ۱۹۹۰",
      tone: 'semantic',
    },
    {
      german: "allgemein genannt",
      translated: "معمولاً چه نامیده می‌شود؟",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:228|fr": [
    {
      german: "Beitritt der DDR zur Bundesrepublik Deutschland",
      translated: "adhésion de la RDA à la République fédérale d’Allemagne",
      tone: 'semantic',
    },
    {
      german: "im Jahr 1990",
      translated: "en 1990",
      tone: 'semantic',
    },
    {
      german: "allgemein genannt",
      translated: "appelle-t-on généralement",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:228|hr": [
    {
      german: "Beitritt der DDR zur Bundesrepublik Deutschland",
      translated: "pristupanje DDR-a Saveznoj Republici Njemačkoj",
      tone: 'semantic',
    },
    {
      german: "im Jahr 1990",
      translated: "1990.",
      tone: 'semantic',
    },
    {
      german: "allgemein genannt",
      translated: "obično naziva",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:228|it": [
    {
      german: "Beitritt der DDR zur Bundesrepublik Deutschland",
      translated: "adesione della RDT alla RFG",
      tone: 'semantic',
    },
    {
      german: "im Jahr 1990",
      translated: "nel 1990",
      tone: 'semantic',
    },
    {
      german: "allgemein genannt",
      translated: "comunemente chiamata",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:228|kmr": [
    {
      german: "Beitritt der DDR zur Bundesrepublik Deutschland",
      translated: "Tevlîbûna DDR ya Komara Federal",
      tone: 'semantic',
    },
    {
      german: "im Jahr 1990",
      translated: "di 1990 de",
      tone: 'semantic',
    },
    {
      german: "allgemein genannt",
      translated: "bi gelemperî çi tê gotin",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:228|pl": [
    {
      german: "Beitritt der DDR zur Bundesrepublik Deutschland",
      translated: "przystąpienie NRD do RFN",
      tone: 'semantic',
    },
    {
      german: "im Jahr 1990",
      translated: "w 1990 r.",
      tone: 'semantic',
    },
    {
      german: "allgemein genannt",
      translated: "zwykle nazywa się",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:228|prs": [
    {
      german: "Beitritt der DDR zur Bundesrepublik Deutschland",
      translated: "پیوستن جمهوری دموکراتیک آلمان به جمهوری فدرال آلمان",
      tone: 'semantic',
    },
    {
      german: "im Jahr 1990",
      translated: "در سال ۱۹۹۰",
      tone: 'semantic',
    },
    {
      german: "allgemein genannt",
      translated: "معمولاً چه نامیده می‌شود؟",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:228|ro": [
    {
      german: "Beitritt der DDR zur Bundesrepublik Deutschland",
      translated: "aderarea RDG la RFG",
      tone: 'semantic',
    },
    {
      german: "im Jahr 1990",
      translated: "în 1990",
      tone: 'semantic',
    },
    {
      german: "allgemein genannt",
      translated: "numită de obicei",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:228|ru": [
    {
      german: "Beitritt der DDR zur Bundesrepublik Deutschland",
      translated: "присоединение ГДР к ФРГ",
      tone: 'semantic',
    },
    {
      german: "im Jahr 1990",
      translated: "1990 году",
      tone: 'semantic',
    },
    {
      german: "allgemein genannt",
      translated: "обычно называют",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:228|sq": [
    {
      german: "Beitritt der DDR zur Bundesrepublik Deutschland",
      translated: "RDGJ-së me RFGJ-në",
      tone: 'semantic',
    },
    {
      german: "im Jahr 1990",
      translated: "në vitin 1990",
      tone: 'semantic',
    },
    {
      german: "allgemein genannt",
      translated: "Si quhet zakonisht bashkimi i",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:228|sr": [
    {
      german: "Beitritt der DDR zur Bundesrepublik Deutschland",
      translated: "pristupanje DDR-a Saveznoj Republici Nemačkoj",
      tone: 'semantic',
    },
    {
      german: "im Jahr 1990",
      translated: "1990.",
      tone: 'semantic',
    },
    {
      german: "allgemein genannt",
      translated: "Kako se obično naziva",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:228|tr": [
    {
      german: "Beitritt der DDR zur Bundesrepublik Deutschland",
      translated: "Almanya Federal Cumhuriyeti'ne katılması",
      tone: 'semantic',
    },
    {
      german: "im Jahr 1990",
      translated: "1990'da",
      tone: 'semantic',
    },
    {
      german: "allgemein genannt",
      translated: "adlandırılır",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:228|uk": [
    {
      german: "Beitritt der DDR zur Bundesrepublik Deutschland",
      translated: "приєднання НДР до Федеративної Республіки Німеччина",
      tone: 'semantic',
    },
    {
      german: "im Jahr 1990",
      translated: "у 1990 році",
      tone: 'semantic',
    },
    {
      german: "allgemein genannt",
      translated: "зазвичай називають",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:228|vi": [
    {
      german: "Beitritt der DDR zur Bundesrepublik Deutschland",
      translated: "Việc CHDC Đức gia nhập Cộng hòa Liên bang Đức",
      tone: 'semantic',
    },
    {
      german: "im Jahr 1990",
      translated: "năm 1990",
      tone: 'semantic',
    },
    {
      german: "allgemein genannt",
      translated: "thường được gọi là gì?",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:229|ar": [
    {
      german: "Welches Land",
      translated: "أي دولة",
      tone: 'semantic',
    },
    {
      german: "Nachbarland",
      translated: "تجاور",
      tone: 'semantic',
    },
    {
      german: "Deutschland",
      translated: "ألمانيا",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:229|bg": [
    {
      german: "Welches Land",
      translated: "Коя държава",
      tone: 'semantic',
    },
    {
      german: "Nachbarland",
      translated: "граничи с",
      tone: 'semantic',
    },
    {
      german: "Deutschland",
      translated: "Германия",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:229|bs": [
    {
      german: "Welches Land",
      translated: "Koja država",
      tone: 'semantic',
    },
    {
      german: "Nachbarland",
      translated: "graniči s",
      tone: 'semantic',
    },
    {
      german: "Deutschland",
      translated: "Njemačkom",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:229|el": [
    {
      german: "Welches Land",
      translated: "Ποια χώρα",
      tone: 'semantic',
    },
    {
      german: "Nachbarland",
      translated: "συνορεύει",
      tone: 'semantic',
    },
    {
      german: "Deutschland",
      translated: "Γερμανία",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:229|en": [
    {
      german: "Welches Land",
      translated: "Which country",
      tone: 'semantic',
    },
    {
      german: "Nachbarland",
      translated: "neighboring country",
      tone: 'semantic',
    },
    {
      german: "Deutschland",
      translated: "Germany",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:229|es": [
    {
      german: "Welches Land",
      translated: "¿Qué país",
      tone: 'semantic',
    },
    {
      german: "Nachbarland",
      translated: "limita con",
      tone: 'semantic',
    },
    {
      german: "Deutschland",
      translated: "Alemania",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:229|fa": [
    {
      german: "Welches Land",
      translated: "کدام کشور",
      tone: 'semantic',
    },
    {
      german: "Nachbarland",
      translated: "همسایهٔ",
      tone: 'semantic',
    },
    {
      german: "Deutschland",
      translated: "آلمان",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:229|fr": [
    {
      german: "Welches Land",
      translated: "Quel pays",
      tone: 'semantic',
    },
    {
      german: "Nachbarland",
      translated: "voisin de",
      tone: 'semantic',
    },
    {
      german: "Deutschland",
      translated: "l’Allemagne",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:229|hr": [
    {
      german: "Welches Land",
      translated: "Koja država",
      tone: 'semantic',
    },
    {
      german: "Nachbarland",
      translated: "graniči s",
      tone: 'semantic',
    },
    {
      german: "Deutschland",
      translated: "Njemačkom",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:229|it": [
    {
      german: "Welches Land",
      translated: "Quale Paese",
      tone: 'semantic',
    },
    {
      german: "Nachbarland",
      translated: "confina con la",
      tone: 'semantic',
    },
    {
      german: "Deutschland",
      translated: "Germania",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:229|kmr": [
    {
      german: "Welches Land",
      translated: "Kîjan welat",
      tone: 'semantic',
    },
    {
      german: "Nachbarland",
      translated: "cîranê",
      tone: 'semantic',
    },
    {
      german: "Deutschland",
      translated: "Almanyayê",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:229|pl": [
    {
      german: "Welches Land",
      translated: "Które państwo",
      tone: 'semantic',
    },
    {
      german: "Nachbarland",
      translated: "graniczy",
      tone: 'semantic',
    },
    {
      german: "Deutschland",
      translated: "Niemcami",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:229|prs": [
    {
      german: "Welches Land",
      translated: "کدام کشور",
      tone: 'semantic',
    },
    {
      german: "Nachbarland",
      translated: "همسایهٔ",
      tone: 'semantic',
    },
    {
      german: "Deutschland",
      translated: "آلمان",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:229|ro": [
    {
      german: "Welches Land",
      translated: "Care țară",
      tone: 'semantic',
    },
    {
      german: "Nachbarland",
      translated: "se învecinează cu",
      tone: 'semantic',
    },
    {
      german: "Deutschland",
      translated: "Germania",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:229|ru": [
    {
      german: "Welches Land",
      translated: "Какая страна",
      tone: 'semantic',
    },
    {
      german: "Nachbarland",
      translated: "соседом",
      tone: 'semantic',
    },
    {
      german: "Deutschland",
      translated: "Германии",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:229|sq": [
    {
      german: "Welches Land",
      translated: "Cili",
      tone: 'semantic',
    },
    {
      german: "Nachbarland",
      translated: "shtet",
      tone: 'semantic',
    },
    {
      german: "Deutschland",
      translated: "Gjermaninë",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:229|sr": [
    {
      german: "Welches Land",
      translated: "Koja država",
      tone: 'semantic',
    },
    {
      german: "Nachbarland",
      translated: "graniči",
      tone: 'semantic',
    },
    {
      german: "Deutschland",
      translated: "Nemačkom",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:229|tr": [
    {
      german: "Welches Land",
      translated: "Aşağıdaki ülkelerden",
      tone: 'semantic',
    },
    {
      german: "Nachbarland",
      translated: "komşusudur",
      tone: 'semantic',
    },
    {
      german: "Deutschland",
      translated: "Almanya",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:229|uk": [
    {
      german: "Welches Land",
      translated: "Яка країна",
      tone: 'semantic',
    },
    {
      german: "Nachbarland",
      translated: "сусідньою",
      tone: 'semantic',
    },
    {
      german: "Deutschland",
      translated: "Німеччиною",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:229|vi": [
    {
      german: "Welches Land",
      translated: "Quốc gia nào",
      tone: 'semantic',
    },
    {
      german: "Nachbarland",
      translated: "giáp",
      tone: 'semantic',
    },
    {
      german: "Deutschland",
      translated: "Đức",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:22|ar": [
    {
      german: "Was für eine",
      translated: "ما شكل",
      tone: 'semantic',
    },
    {
      german: "Staatsform",
      translated: "نظام الحكم",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "في",
      tone: 'semantic',
    },
    {
      german: "Deutschland",
      translated: "ألمانيا",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:22|bg": [
    {
      german: "Was für eine",
      translated: "Каква е",
      tone: 'semantic',
    },
    {
      german: "Staatsform",
      translated: "формата",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "на",
      tone: 'semantic',
    },
    {
      german: "Deutschland",
      translated: "Германия",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:22|bs": [
    {
      german: "Was für eine",
      translated: "Koji",
      tone: 'semantic',
    },
    {
      german: "Staatsform",
      translated: "oblik",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "ima",
      tone: 'semantic',
    },
    {
      german: "Deutschland",
      translated: "Njemačka",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:22|el": [
    {
      german: "Was für eine",
      translated: "Ποια",
      tone: 'semantic',
    },
    {
      german: "Staatsform",
      translated: "μορφή κράτους",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "έχει",
      tone: 'semantic',
    },
    {
      german: "Deutschland",
      translated: "Γερμανία",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:22|en": [
    {
      german: "Was für eine",
      translated: "What form of",
      tone: 'semantic',
    },
    {
      german: "Staatsform",
      translated: "government",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "does",
      tone: 'semantic',
    },
    {
      german: "Deutschland",
      translated: "Germany",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:22|es": [
    {
      german: "Was für eine",
      translated: "Qué",
      tone: 'semantic',
    },
    {
      german: "Staatsform",
      translated: "forma de Estado",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "tiene",
      tone: 'semantic',
    },
    {
      german: "Deutschland",
      translated: "Alemania",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:22|fa": [
    {
      german: "Was für eine",
      translated: "نوع",
      tone: 'semantic',
    },
    {
      german: "Staatsform",
      translated: "حکومت",
      tone: 'semantic',
    },
    {
      german: "Deutschland",
      translated: "آلمان",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:22|fr": [
    {
      german: "Was für eine",
      translated: "Quelle",
      tone: 'semantic',
    },
    {
      german: "Staatsform",
      translated: "forme d’État",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "est",
      tone: 'semantic',
    },
    {
      german: "Deutschland",
      translated: "l’Allemagne",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:22|hr": [
    {
      german: "Was für eine",
      translated: "Koji oblik",
      tone: 'semantic',
    },
    {
      german: "Staatsform",
      translated: "države",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "ima",
      tone: 'semantic',
    },
    {
      german: "Deutschland",
      translated: "Njemačka",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:22|it": [
    {
      german: "Was für eine",
      translated: "Qual è la",
      tone: 'semantic',
    },
    {
      german: "Staatsform",
      translated: "forma di Stato",
      tone: 'semantic',
    },
    {
      german: "Deutschland",
      translated: "della Germania",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:22|kmr": [
    {
      german: "Was für eine",
      translated: "çi",
      tone: 'semantic',
    },
    {
      german: "Staatsform",
      translated: "Forma dewletê",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "ye",
      tone: 'semantic',
    },
    {
      german: "Deutschland",
      translated: "Almanyayê",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:22|pl": [
    {
      german: "Was für eine",
      translated: "Jaką",
      tone: 'semantic',
    },
    {
      german: "Staatsform",
      translated: "formę państwa",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "mają",
      tone: 'semantic',
    },
    {
      german: "Deutschland",
      translated: "Niemcy",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:22|prs": [
    {
      german: "Was für eine",
      translated: "نوع",
      tone: 'semantic',
    },
    {
      german: "Staatsform",
      translated: "حکومت",
      tone: 'semantic',
    },
    {
      german: "Deutschland",
      translated: "آلمان",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:22|ro": [
    {
      german: "Was für eine",
      translated: "Ce formă de",
      tone: 'semantic',
    },
    {
      german: "Staatsform",
      translated: "stat",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "are",
      tone: 'semantic',
    },
    {
      german: "Deutschland",
      translated: "Germania?",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:22|ru": [
    {
      german: "Was für eine",
      translated: "Какая",
      tone: 'semantic',
    },
    {
      german: "Staatsform",
      translated: "форма государственного правления",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "в",
      tone: 'semantic',
    },
    {
      german: "Deutschland",
      translated: "Германии",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:22|sq": [
    {
      german: "Was für eine",
      translated: "Cila është",
      tone: 'semantic',
    },
    {
      german: "Staatsform",
      translated: "forma shtetërore",
      tone: 'semantic',
    },
    {
      german: "Deutschland",
      translated: "Gjermanisë",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:22|sr": [
    {
      german: "Was für eine",
      translated: "Koji oblik",
      tone: 'semantic',
    },
    {
      german: "Staatsform",
      translated: "države",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "ima",
      tone: 'semantic',
    },
    {
      german: "Deutschland",
      translated: "Nemačka",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:22|tr": [
    {
      german: "Was für eine",
      translated: "nedir",
      tone: 'semantic',
    },
    {
      german: "Staatsform",
      translated: "yönetim biçimi",
      tone: 'semantic',
    },
    {
      german: "Deutschland",
      translated: "Almanya'nın",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:22|uk": [
    {
      german: "Was für eine",
      translated: "Яка",
      tone: 'semantic',
    },
    {
      german: "Staatsform",
      translated: "форма державного устрою",
      tone: 'semantic',
    },
    {
      german: "Deutschland",
      translated: "Німеччини",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:22|vi": [
    {
      german: "Was für eine",
      translated: "nào",
      tone: 'semantic',
    },
    {
      german: "Staatsform",
      translated: "hình thức nhà nước",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "có",
      tone: 'semantic',
    },
    {
      german: "Deutschland",
      translated: "Đức",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:230|ar": [
    {
      german: "Das Europäische Parlament",
      translated: "البرلمان الأوروبي",
      tone: 'semantic',
    },
    {
      german: "wird regelmäßig gewählt,",
      translated: "بانتظام",
      tone: 'semantic',
    },
    {
      german: "nämlich",
      translated: "كل",
      tone: 'semantic',
    },
    {
      german: "alle …",
      translated: "…",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:230|bg": [
    {
      german: "Das Europäische Parlament",
      translated: "Европейският парламент",
      tone: 'semantic',
    },
    {
      german: "wird regelmäßig gewählt,",
      translated: "се избира редовно",
      tone: 'semantic',
    },
    {
      german: "nämlich",
      translated: "на всеки",
      tone: 'semantic',
    },
    {
      german: "alle …",
      translated: "…",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:230|bs": [
    {
      german: "Das Europäische Parlament",
      translated: "Evropski parlament",
      tone: 'semantic',
    },
    {
      german: "wird regelmäßig gewählt,",
      translated: "redovno se bira",
      tone: 'semantic',
    },
    {
      german: "alle …",
      translated: "svakih",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:230|el": [
    {
      german: "Das Europäische Parlament",
      translated: "Το Ευρωπαϊκό Κοινοβούλιο",
      tone: 'semantic',
    },
    {
      german: "wird regelmäßig gewählt,",
      translated: "εκλέγεται",
      tone: 'semantic',
    },
    {
      german: "nämlich",
      translated: "τακτικά",
      tone: 'semantic',
    },
    {
      german: "alle …",
      translated: "κάθε …",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:230|en": [
    {
      german: "Das Europäische Parlament",
      translated: "The European Parliament",
      tone: 'semantic',
    },
    {
      german: "wird regelmäßig gewählt,",
      translated: "is elected regularly,",
      tone: 'semantic',
    },
    {
      german: "nämlich",
      translated: "namely",
      tone: 'semantic',
    },
    {
      german: "alle …",
      translated: "every …",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:230|es": [
    {
      german: "Das Europäische Parlament",
      translated: "El Parlamento Europeo",
      tone: 'semantic',
    },
    {
      german: "wird regelmäßig gewählt,",
      translated: "se elige regularmente,",
      tone: 'semantic',
    },
    {
      german: "nämlich",
      translated: "concretamente",
      tone: 'semantic',
    },
    {
      german: "alle …",
      translated: "cada …",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:230|fa": [
    {
      german: "Das Europäische Parlament",
      translated: "پارلمان اروپا",
      tone: 'semantic',
    },
    {
      german: "wird regelmäßig gewählt,",
      translated: "به‌طور منظم",
      tone: 'semantic',
    },
    {
      german: "alle …",
      translated: "هر …",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:230|fr": [
    {
      german: "Das Europäische Parlament",
      translated: "Le Parlement européen",
      tone: 'semantic',
    },
    {
      german: "wird regelmäßig gewählt,",
      translated: "est élu régulièrement,",
      tone: 'semantic',
    },
    {
      german: "alle …",
      translated: "tous les …",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:230|hr": [
    {
      german: "Das Europäische Parlament",
      translated: "Europski parlament",
      tone: 'semantic',
    },
    {
      german: "wird regelmäßig gewählt,",
      translated: "redovito se bira",
      tone: 'semantic',
    },
    {
      german: "alle …",
      translated: "svakih …",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:230|it": [
    {
      german: "Das Europäische Parlament",
      translated: "Il Parlamento europeo",
      tone: 'semantic',
    },
    {
      german: "wird regelmäßig gewählt,",
      translated: "viene eletto regolarmente",
      tone: 'semantic',
    },
    {
      german: "alle …",
      translated: "ogni …",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:230|kmr": [
    {
      german: "Das Europäische Parlament",
      translated: "Parlamentoya Ewropî",
      tone: 'semantic',
    },
    {
      german: "wird regelmäßig gewählt,",
      translated: "tê hilbijartin",
      tone: 'semantic',
    },
    {
      german: "alle …",
      translated: "her … salan",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:230|pl": [
    {
      german: "Das Europäische Parlament",
      translated: "Parlament Europejski",
      tone: 'semantic',
    },
    {
      german: "wird regelmäßig gewählt,",
      translated: "jest wybierany regularnie",
      tone: 'semantic',
    },
    {
      german: "alle …",
      translated: "co …",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:230|prs": [
    {
      german: "Das Europäische Parlament",
      translated: "پارلمان اروپا",
      tone: 'semantic',
    },
    {
      german: "wird regelmäßig gewählt,",
      translated: "به‌طور منظم",
      tone: 'semantic',
    },
    {
      german: "alle …",
      translated: "هر …",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:230|ro": [
    {
      german: "Das Europäische Parlament",
      translated: "Parlamentul European",
      tone: 'semantic',
    },
    {
      german: "wird regelmäßig gewählt,",
      translated: "este ales în mod regulat",
      tone: 'semantic',
    },
    {
      german: "alle …",
      translated: "la fiecare …",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:230|ru": [
    {
      german: "Das Europäische Parlament",
      translated: "Европейский парламент",
      tone: 'semantic',
    },
    {
      german: "wird regelmäßig gewählt,",
      translated: "регулярно избирается",
      tone: 'semantic',
    },
    {
      german: "alle …",
      translated: "каждые …",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:230|sq": [
    {
      german: "Das Europäische Parlament",
      translated: "Parlamenti Evropian",
      tone: 'semantic',
    },
    {
      german: "wird regelmäßig gewählt,",
      translated: "zgjidhet rregullisht",
      tone: 'semantic',
    },
    {
      german: "nämlich",
      translated: "çdo",
      tone: 'semantic',
    },
    {
      german: "alle …",
      translated: "…",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:230|sr": [
    {
      german: "Das Europäische Parlament",
      translated: "Evropski parlament",
      tone: 'semantic',
    },
    {
      german: "wird regelmäßig gewählt,",
      translated: "redovno se bira",
      tone: 'semantic',
    },
    {
      german: "alle …",
      translated: "svakih …",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:230|tr": [
    {
      german: "Das Europäische Parlament",
      translated: "Avrupa Parlamentosu",
      tone: 'semantic',
    },
    {
      german: "wird regelmäßig gewählt,",
      translated: "düzenli olarak",
      tone: 'semantic',
    },
    {
      german: "alle …",
      translated: "kaç yılda bir seçilir",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:230|uk": [
    {
      german: "Das Europäische Parlament",
      translated: "Європейський парламент",
      tone: 'semantic',
    },
    {
      german: "wird regelmäßig gewählt,",
      translated: "обирають регулярно,",
      tone: 'semantic',
    },
    {
      german: "nämlich",
      translated: "а саме",
      tone: 'semantic',
    },
    {
      german: "alle …",
      translated: "кожні …",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:230|vi": [
    {
      german: "Das Europäische Parlament",
      translated: "Nghị viện châu Âu",
      tone: 'semantic',
    },
    {
      german: "wird regelmäßig gewählt,",
      translated: "được bầu",
      tone: 'semantic',
    },
    {
      german: "nämlich",
      translated: "định kỳ",
      tone: 'semantic',
    },
    {
      german: "alle …",
      translated: "mỗi …",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:231|ar": [
    {
      german: "Was bedeutet",
      translated: "ماذا يعني",
      tone: 'semantic',
    },
    {
      german: "der Begriff",
      translated: "مصطلح",
      tone: 'semantic',
    },
    {
      german: "\"europäische Integration\"",
      translated: "«التكامل الأوروبي»؟",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:231|bg": [
    {
      german: "Was bedeutet",
      translated: "Какво означава",
      tone: 'semantic',
    },
    {
      german: "der Begriff",
      translated: "понятието",
      tone: 'semantic',
    },
    {
      german: "\"europäische Integration\"",
      translated: "„европейска интеграция“",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:231|bs": [
    {
      german: "Was bedeutet",
      translated: "Što znači",
      tone: 'semantic',
    },
    {
      german: "der Begriff",
      translated: "pojam",
      tone: 'semantic',
    },
    {
      german: "\"europäische Integration\"",
      translated: "„europska integracija“",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:231|el": [
    {
      german: "Was bedeutet",
      translated: "Τι σημαίνει",
      tone: 'semantic',
    },
    {
      german: "der Begriff",
      translated: "ο όρος",
      tone: 'semantic',
    },
    {
      german: "\"europäische Integration\"",
      translated: "«ευρωπαϊκή ολοκλήρωση»",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:231|en": [
    {
      german: "Was bedeutet",
      translated: "What does",
      tone: 'semantic',
    },
    {
      german: "der Begriff",
      translated: "the term",
      tone: 'semantic',
    },
    {
      german: "\"europäische Integration\"",
      translated: "'European integration'",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:231|es": [
    {
      german: "Was bedeutet",
      translated: "¿Qué significa",
      tone: 'semantic',
    },
    {
      german: "der Begriff",
      translated: "el término",
      tone: 'semantic',
    },
    {
      german: "\"europäische Integration\"",
      translated: "«integración europea»",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:231|fa": [
    {
      german: "Was bedeutet",
      translated: "به چه معناست",
      tone: 'semantic',
    },
    {
      german: "der Begriff",
      translated: "اصطلاح",
      tone: 'semantic',
    },
    {
      german: "\"europäische Integration\"",
      translated: "«یکپارچگی اروپایی»",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:231|fr": [
    {
      german: "Was bedeutet",
      translated: "Que signifie",
      tone: 'semantic',
    },
    {
      german: "der Begriff",
      translated: "le terme",
      tone: 'semantic',
    },
    {
      german: "\"europäische Integration\"",
      translated: "intégration européenne",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:231|hr": [
    {
      german: "Was bedeutet",
      translated: "Što znači",
      tone: 'semantic',
    },
    {
      german: "der Begriff",
      translated: "pojam",
      tone: 'semantic',
    },
    {
      german: "\"europäische Integration\"",
      translated: "„europska integracija“",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:231|it": [
    {
      german: "Was bedeutet",
      translated: "Che cosa significa",
      tone: 'semantic',
    },
    {
      german: "der Begriff",
      translated: "il termine",
      tone: 'semantic',
    },
    {
      german: "\"europäische Integration\"",
      translated: "«integrazione europea»",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:231|kmr": [
    {
      german: "Was bedeutet",
      translated: "tê çi wateyê",
      tone: 'semantic',
    },
    {
      german: "\"europäische Integration\"",
      translated: "«Entegrasyona Ewropî»",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:231|pl": [
    {
      german: "Was bedeutet",
      translated: "Co oznacza",
      tone: 'semantic',
    },
    {
      german: "der Begriff",
      translated: "pojęcie",
      tone: 'semantic',
    },
    {
      german: "\"europäische Integration\"",
      translated: "„integracja europejska”",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:231|prs": [
    {
      german: "Was bedeutet",
      translated: "به چه معناست",
      tone: 'semantic',
    },
    {
      german: "der Begriff",
      translated: "اصطلاح",
      tone: 'semantic',
    },
    {
      german: "\"europäische Integration\"",
      translated: "«یکپارچگی اروپایی»",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:231|ro": [
    {
      german: "Was bedeutet",
      translated: "Ce înseamnă",
      tone: 'semantic',
    },
    {
      german: "der Begriff",
      translated: "termenul",
      tone: 'semantic',
    },
    {
      german: "\"europäische Integration\"",
      translated: "„integrare europeană”",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:231|ru": [
    {
      german: "Was bedeutet",
      translated: "Что означает",
      tone: 'semantic',
    },
    {
      german: "der Begriff",
      translated: "понятие",
      tone: 'semantic',
    },
    {
      german: "\"europäische Integration\"",
      translated: "«европейская интеграция»",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:231|sq": [
    {
      german: "Was bedeutet",
      translated: "Çfarë do të thotë",
      tone: 'semantic',
    },
    {
      german: "der Begriff",
      translated: "termi",
      tone: 'semantic',
    },
    {
      german: "\"europäische Integration\"",
      translated: "«integrim evropian»",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:231|sr": [
    {
      german: "Was bedeutet",
      translated: "Šta znači",
      tone: 'semantic',
    },
    {
      german: "der Begriff",
      translated: "pojam",
      tone: 'semantic',
    },
    {
      german: "\"europäische Integration\"",
      translated: "„europska integracija“",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:231|tr": [
    {
      german: "Was bedeutet",
      translated: "ne anlama gelir",
      tone: 'semantic',
    },
    {
      german: "der Begriff",
      translated: "kavramı",
      tone: 'semantic',
    },
    {
      german: "\"europäische Integration\"",
      translated: "\"Avrupa bütünleşmesi\"",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:231|uk": [
    {
      german: "Was bedeutet",
      translated: "Що означає",
      tone: 'semantic',
    },
    {
      german: "der Begriff",
      translated: "поняття",
      tone: 'semantic',
    },
    {
      german: "\"europäische Integration\"",
      translated: "«європейська інтеграція»",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:231|vi": [
    {
      german: "Was bedeutet",
      translated: "có nghĩa là gì?",
      tone: 'semantic',
    },
    {
      german: "der Begriff",
      translated: "Thuật ngữ",
      tone: 'semantic',
    },
    {
      german: "\"europäische Integration\"",
      translated: "“hội nhập châu Âu”",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:232|ar": [
    {
      german: "Wer",
      translated: "من",
      tone: 'semantic',
    },
    {
      german: "bei der Europawahl",
      translated: "في الانتخابات الأوروبية",
      tone: 'semantic',
    },
    {
      german: "gewählt",
      translated: "يُنتخب",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:232|bg": [
    {
      german: "Wer",
      translated: "Кой",
      tone: 'semantic',
    },
    {
      german: "wird",
      translated: "се",
      tone: 'semantic',
    },
    {
      german: "bei der Europawahl",
      translated: "на европейските избори",
      tone: 'semantic',
    },
    {
      german: "gewählt",
      translated: "избира",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:232|bs": [
    {
      german: "Wer",
      translated: "Tko",
      tone: 'semantic',
    },
    {
      german: "wird",
      translated: "se",
      tone: 'semantic',
    },
    {
      german: "bei der Europawahl",
      translated: "na evropskim izborima",
      tone: 'semantic',
    },
    {
      german: "gewählt",
      translated: "bira",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:232|el": [
    {
      german: "Wer",
      translated: "Ποιος",
      tone: 'semantic',
    },
    {
      german: "bei der Europawahl",
      translated: "στις ευρωπαϊκές εκλογές",
      tone: 'semantic',
    },
    {
      german: "gewählt",
      translated: "εκλέγεται",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:232|en": [
    {
      german: "Wer",
      translated: "Who",
      tone: 'semantic',
    },
    {
      german: "wird",
      translated: "is",
      tone: 'semantic',
    },
    {
      german: "bei der Europawahl",
      translated: "in the European election",
      tone: 'semantic',
    },
    {
      german: "gewählt",
      translated: "elected",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:232|es": [
    {
      german: "Wer",
      translated: "Quién",
      tone: 'semantic',
    },
    {
      german: "bei der Europawahl",
      translated: "en las elecciones europeas",
      tone: 'semantic',
    },
    {
      german: "gewählt",
      translated: "es elegido",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:232|fa": [
    {
      german: "Wer",
      translated: "چه کسانی",
      tone: 'semantic',
    },
    {
      german: "bei der Europawahl",
      translated: "در انتخابات اروپا",
      tone: 'semantic',
    },
    {
      german: "gewählt",
      translated: "انتخاب می‌شوند",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:232|fr": [
    {
      german: "Wer",
      translated: "Qui",
      tone: 'semantic',
    },
    {
      german: "wird",
      translated: "est",
      tone: 'semantic',
    },
    {
      german: "bei der Europawahl",
      translated: "lors des élections européennes",
      tone: 'semantic',
    },
    {
      german: "gewählt",
      translated: "élu",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:232|hr": [
    {
      german: "Wer",
      translated: "Tko",
      tone: 'semantic',
    },
    {
      german: "wird",
      translated: "se",
      tone: 'semantic',
    },
    {
      german: "bei der Europawahl",
      translated: "na europskim izborima",
      tone: 'semantic',
    },
    {
      german: "gewählt",
      translated: "bira",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:232|it": [
    {
      german: "Wer",
      translated: "Che cosa",
      tone: 'semantic',
    },
    {
      german: "wird",
      translated: "si",
      tone: 'semantic',
    },
    {
      german: "bei der Europawahl",
      translated: "alle elezioni europee",
      tone: 'semantic',
    },
    {
      german: "gewählt",
      translated: "elegge",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:232|kmr": [
    {
      german: "Wer",
      translated: "Di hilbijartina",
      tone: 'semantic',
    },
    {
      german: "wird",
      translated: "kî",
      tone: 'semantic',
    },
    {
      german: "bei der Europawahl",
      translated: "Ewropî",
      tone: 'semantic',
    },
    {
      german: "gewählt",
      translated: "hilbijartin",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:232|pl": [
    {
      german: "Wer",
      translated: "Co",
      tone: 'semantic',
    },
    {
      german: "wird",
      translated: "wybiera",
      tone: 'semantic',
    },
    {
      german: "bei der Europawahl",
      translated: "w wyborach europejskich",
      tone: 'semantic',
    },
    {
      german: "gewählt",
      translated: "się",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:232|prs": [
    {
      german: "bei der Europawahl",
      translated: "در انتخابات اروپا",
      tone: 'semantic',
    },
    {
      german: "gewählt",
      translated: "انتخاب می‌شوند",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:232|ro": [
    {
      german: "Wer",
      translated: "Cine",
      tone: 'semantic',
    },
    {
      german: "wird",
      translated: "este",
      tone: 'semantic',
    },
    {
      german: "bei der Europawahl",
      translated: "la alegerile europene",
      tone: 'semantic',
    },
    {
      german: "gewählt",
      translated: "ales",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:232|ru": [
    {
      german: "Wer",
      translated: "Кого",
      tone: 'semantic',
    },
    {
      german: "bei der Europawahl",
      translated: "на европейских выборах",
      tone: 'semantic',
    },
    {
      german: "gewählt",
      translated: "избирают",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:232|sq": [
    {
      german: "Wer",
      translated: "Kush",
      tone: 'semantic',
    },
    {
      german: "bei der Europawahl",
      translated: "në zgjedhjet evropiane",
      tone: 'semantic',
    },
    {
      german: "gewählt",
      translated: "zgjidhet",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:232|sr": [
    {
      german: "Wer",
      translated: "Ko",
      tone: 'semantic',
    },
    {
      german: "wird",
      translated: "se",
      tone: 'semantic',
    },
    {
      german: "bei der Europawahl",
      translated: "na evropskim izborima",
      tone: 'semantic',
    },
    {
      german: "gewählt",
      translated: "bira",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:232|tr": [
    {
      german: "Wer",
      translated: "kimler",
      tone: 'semantic',
    },
    {
      german: "bei der Europawahl",
      translated: "Avrupa Parlamentosu seçiminde",
      tone: 'semantic',
    },
    {
      german: "gewählt",
      translated: "seçilir",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:232|uk": [
    {
      german: "Wer",
      translated: "Кого",
      tone: 'semantic',
    },
    {
      german: "bei der Europawahl",
      translated: "на виборах до Європейського парламенту",
      tone: 'semantic',
    },
    {
      german: "gewählt",
      translated: "обирають",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:232|vi": [
    {
      german: "Wer",
      translated: "Ai",
      tone: 'semantic',
    },
    {
      german: "wird",
      translated: "được",
      tone: 'semantic',
    },
    {
      german: "bei der Europawahl",
      translated: "trong cuộc bầu cử châu Âu",
      tone: 'semantic',
    },
    {
      german: "gewählt",
      translated: "bầu",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:233|ar": [
    {
      german: "Welches Land",
      translated: "أي دولة",
      tone: 'semantic',
    },
    {
      german: "Nachbarland",
      translated: "تجاور",
      tone: 'semantic',
    },
    {
      german: "von Deutschland",
      translated: "ألمانيا",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:233|bg": [
    {
      german: "Welches Land",
      translated: "Коя държава",
      tone: 'semantic',
    },
    {
      german: "Nachbarland",
      translated: "граничи",
      tone: 'semantic',
    },
    {
      german: "von Deutschland",
      translated: "Германия?",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:233|bs": [
    {
      german: "Welches Land",
      translated: "Koja država",
      tone: 'semantic',
    },
    {
      german: "Nachbarland",
      translated: "graniči s",
      tone: 'semantic',
    },
    {
      german: "von Deutschland",
      translated: "Njemačkom",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:233|el": [
    {
      german: "Welches Land",
      translated: "Ποια χώρα",
      tone: 'semantic',
    },
    {
      german: "Nachbarland",
      translated: "συνορεύει",
      tone: 'semantic',
    },
    {
      german: "von Deutschland",
      translated: "με τη Γερμανία;",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:233|en": [
    {
      german: "Welches Land",
      translated: "Which country",
      tone: 'semantic',
    },
    {
      german: "Nachbarland",
      translated: "neighboring country",
      tone: 'semantic',
    },
    {
      german: "von Deutschland",
      translated: "of Germany",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:233|es": [
    {
      german: "Welches Land",
      translated: "¿Qué país",
      tone: 'semantic',
    },
    {
      german: "Nachbarland",
      translated: "limita con",
      tone: 'semantic',
    },
    {
      german: "von Deutschland",
      translated: "Alemania",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:233|fa": [
    {
      german: "Welches Land",
      translated: "کدام کشور",
      tone: 'semantic',
    },
    {
      german: "Nachbarland",
      translated: "همسایهٔ",
      tone: 'semantic',
    },
    {
      german: "von Deutschland",
      translated: "آلمان است؟",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:233|fr": [
    {
      german: "Welches Land",
      translated: "Quel pays",
      tone: 'semantic',
    },
    {
      german: "Nachbarland",
      translated: "voisin",
      tone: 'semantic',
    },
    {
      german: "von Deutschland",
      translated: "de l’Allemagne",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:233|hr": [
    {
      german: "Welches Land",
      translated: "Koja država",
      tone: 'semantic',
    },
    {
      german: "Nachbarland",
      translated: "graniči s",
      tone: 'semantic',
    },
    {
      german: "von Deutschland",
      translated: "Njemačkom",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:233|it": [
    {
      german: "Welches Land",
      translated: "Quale Paese",
      tone: 'semantic',
    },
    {
      german: "Nachbarland",
      translated: "confina con",
      tone: 'semantic',
    },
    {
      german: "von Deutschland",
      translated: "la Germania",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:233|kmr": [
    {
      german: "Welches Land",
      translated: "Kîjan welat",
      tone: 'semantic',
    },
    {
      german: "Nachbarland",
      translated: "cîranê",
      tone: 'semantic',
    },
    {
      german: "von Deutschland",
      translated: "Almanyayê ye?",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:233|pl": [
    {
      german: "Welches Land",
      translated: "Które państwo",
      tone: 'semantic',
    },
    {
      german: "Nachbarland",
      translated: "graniczy",
      tone: 'semantic',
    },
    {
      german: "von Deutschland",
      translated: "z Niemcami",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:233|prs": [
    {
      german: "Welches Land",
      translated: "کدام کشور",
      tone: 'semantic',
    },
    {
      german: "Nachbarland",
      translated: "همسایهٔ",
      tone: 'semantic',
    },
    {
      german: "von Deutschland",
      translated: "آلمان",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:233|ro": [
    {
      german: "Welches Land",
      translated: "Care țară",
      tone: 'semantic',
    },
    {
      german: "Nachbarland",
      translated: "se învecinează",
      tone: 'semantic',
    },
    {
      german: "von Deutschland",
      translated: "cu Germania?",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:233|ru": [
    {
      german: "Welches Land",
      translated: "Какая страна",
      tone: 'semantic',
    },
    {
      german: "Nachbarland",
      translated: "является соседом",
      tone: 'semantic',
    },
    {
      german: "von Deutschland",
      translated: "Германии",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:233|sq": [
    {
      german: "Welches Land",
      translated: "Cili",
      tone: 'semantic',
    },
    {
      german: "Nachbarland",
      translated: "shtet kufizohet",
      tone: 'semantic',
    },
    {
      german: "von Deutschland",
      translated: "me Gjermaninë",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:233|sr": [
    {
      german: "Welches Land",
      translated: "Koja država",
      tone: 'semantic',
    },
    {
      german: "Nachbarland",
      translated: "graniči s",
      tone: 'semantic',
    },
    {
      german: "von Deutschland",
      translated: "Nemačkom",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:233|tr": [
    {
      german: "Welches Land",
      translated: "Aşağıdaki ülkelerden hangisi",
      tone: 'semantic',
    },
    {
      german: "Nachbarland",
      translated: "komşusudur",
      tone: 'semantic',
    },
    {
      german: "von Deutschland",
      translated: "Almanya'nın",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:233|uk": [
    {
      german: "Welches Land",
      translated: "Яка країна",
      tone: 'semantic',
    },
    {
      german: "Nachbarland",
      translated: "сусідньою",
      tone: 'semantic',
    },
    {
      german: "von Deutschland",
      translated: "з Німеччиною",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:233|vi": [
    {
      german: "Welches Land",
      translated: "Quốc gia nào",
      tone: 'semantic',
    },
    {
      german: "Nachbarland",
      translated: "giáp",
      tone: 'semantic',
    },
    {
      german: "von Deutschland",
      translated: "Đức",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:234|ar": [
    {
      german: "Wo ist",
      translated: "أين يوجد",
      tone: 'semantic',
    },
    {
      german: "ein Sitz",
      translated: "أحد مقار",
      tone: 'semantic',
    },
    {
      german: "des Europäischen Parlaments",
      translated: "البرلمان الأوروبي؟",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:234|bg": [
    {
      german: "Wo ist",
      translated: "В кой град се намира",
      tone: 'semantic',
    },
    {
      german: "ein Sitz",
      translated: "едно от седалищата",
      tone: 'semantic',
    },
    {
      german: "des Europäischen Parlaments",
      translated: "на Европейския парламент",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:234|bs": [
    {
      german: "Wo ist",
      translated: "U kojem se gradu nalazi",
      tone: 'semantic',
    },
    {
      german: "ein Sitz",
      translated: "jedno od sjedišta",
      tone: 'semantic',
    },
    {
      german: "des Europäischen Parlaments",
      translated: "Evropskog parlamenta",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:234|el": [
    {
      german: "Wo ist",
      translated: "Σε ποια πόλη βρίσκεται",
      tone: 'semantic',
    },
    {
      german: "ein Sitz",
      translated: "μία από τις έδρες",
      tone: 'semantic',
    },
    {
      german: "des Europäischen Parlaments",
      translated: "του Ευρωπαϊκού Κοινοβουλίου",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:234|en": [
    {
      german: "Wo ist",
      translated: "Where is",
      tone: 'semantic',
    },
    {
      german: "ein Sitz",
      translated: "the seat",
      tone: 'semantic',
    },
    {
      german: "des Europäischen Parlaments",
      translated: "of the European Parliament",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:234|es": [
    {
      german: "Wo ist",
      translated: "¿Dónde se encuentra",
      tone: 'semantic',
    },
    {
      german: "ein Sitz",
      translated: "una de las sedes",
      tone: 'semantic',
    },
    {
      german: "des Europäischen Parlaments",
      translated: "del Parlamento Europeo",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:234|fa": [
    {
      german: "Wo ist",
      translated: "یکی از",
      tone: 'semantic',
    },
    {
      german: "ein Sitz",
      translated: "پارلمان اروپا",
      tone: 'semantic',
    },
    {
      german: "des Europäischen Parlaments",
      translated: "در کدام شهر است؟",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:234|fr": [
    {
      german: "Wo ist",
      translated: "Où se trouve",
      tone: 'semantic',
    },
    {
      german: "ein Sitz",
      translated: "l’un des sièges",
      tone: 'semantic',
    },
    {
      german: "des Europäischen Parlaments",
      translated: "du Parlement européen ?",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:234|hr": [
    {
      german: "Wo ist",
      translated: "U kojem",
      tone: 'semantic',
    },
    {
      german: "ein Sitz",
      translated: "jedno od sjedišta",
      tone: 'semantic',
    },
    {
      german: "des Europäischen Parlaments",
      translated: "Europskog parlamenta",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:234|it": [
    {
      german: "Wo ist",
      translated: "In",
      tone: 'semantic',
    },
    {
      german: "ein Sitz",
      translated: "una delle sedi",
      tone: 'semantic',
    },
    {
      german: "des Europäischen Parlaments",
      translated: "del Parlamento europeo",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:234|kmr": [
    {
      german: "Wo ist",
      translated: "li ku ye",
      tone: 'semantic',
    },
    {
      german: "ein Sitz",
      translated: "Yek ji cihên",
      tone: 'semantic',
    },
    {
      german: "des Europäischen Parlaments",
      translated: "Parlamentoya Ewropî",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:234|pl": [
    {
      german: "Wo ist",
      translated: "W którym",
      tone: 'semantic',
    },
    {
      german: "ein Sitz",
      translated: "jedna z siedzib",
      tone: 'semantic',
    },
    {
      german: "des Europäischen Parlaments",
      translated: "Parlamentu Europejskiego",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:234|prs": [
    {
      german: "Wo ist",
      translated: "یکی از",
      tone: 'semantic',
    },
    {
      german: "ein Sitz",
      translated: "مقرهای پارلمان اروپا",
      tone: 'semantic',
    },
    {
      german: "des Europäischen Parlaments",
      translated: "در کدام شهر",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:234|ro": [
    {
      german: "Wo ist",
      translated: "În ce",
      tone: 'semantic',
    },
    {
      german: "ein Sitz",
      translated: "unul dintre",
      tone: 'semantic',
    },
    {
      german: "des Europäischen Parlaments",
      translated: "Parlamentului European",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:234|ru": [
    {
      german: "Wo ist",
      translated: "Где",
      tone: 'semantic',
    },
    {
      german: "ein Sitz",
      translated: "одна из резиденций",
      tone: 'semantic',
    },
    {
      german: "des Europäischen Parlaments",
      translated: "Европейского парламента",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:234|sq": [
    {
      german: "Wo ist",
      translated: "Në cilin qytet ndodhet",
      tone: 'semantic',
    },
    {
      german: "ein Sitz",
      translated: "një nga selitë",
      tone: 'semantic',
    },
    {
      german: "des Europäischen Parlaments",
      translated: "e Parlamentit Evropian",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:234|sr": [
    {
      german: "Wo ist",
      translated: "U kojem se gradu nalazi",
      tone: 'semantic',
    },
    {
      german: "ein Sitz",
      translated: "jedno od sjedišta",
      tone: 'semantic',
    },
    {
      german: "des Europäischen Parlaments",
      translated: "Evropskog parlamenta",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:234|tr": [
    {
      german: "Wo ist",
      translated: "nerededir",
      tone: 'semantic',
    },
    {
      german: "ein Sitz",
      translated: "merkezlerinden biri",
      tone: 'semantic',
    },
    {
      german: "des Europäischen Parlaments",
      translated: "Avrupa Parlamentosunun",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:234|uk": [
    {
      german: "Wo ist",
      translated: "Де розташоване",
      tone: 'semantic',
    },
    {
      german: "ein Sitz",
      translated: "одне з місць роботи",
      tone: 'semantic',
    },
    {
      german: "des Europäischen Parlaments",
      translated: "Європейського парламенту",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:234|vi": [
    {
      german: "Wo ist",
      translated: "Một trong các",
      tone: 'semantic',
    },
    {
      german: "ein Sitz",
      translated: "trụ sở",
      tone: 'semantic',
    },
    {
      german: "des Europäischen Parlaments",
      translated: "của Nghị viện châu Âu",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:235|ar": [
    {
      german: "Der damalige französische Staatspräsident François Mitterrand und der damalige deutsche Bundeskanzler Helmut Kohl",
      translated: "أحيا الرئيس الفرنسي آنذاك فرانسوا ميتران والمستشار الألماني آنذاك هيلموت كول",
      tone: 'semantic',
    },
    {
      german: "gedenken in Verdun gemeinsam der Toten beider Weltkriege",
      translated: "في فردان ذكرى قتلى الحربين العالميتين معًا",
      tone: 'semantic',
    },
    {
      german: "Welches Ziel der Europäischen Union wird bei diesem Treffen deutlich",
      translated: "أي هدف من أهداف الاتحاد الأوروبي يظهر في هذا اللقاء",
      tone: 'semantic',
    },
    {
      german: "© Bundesregierung/Richard Schulze-Vorberg",
      translated: "© Bundesregierung/Richard Schulze-Vorberg",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:235|bg": [
    {
      german: "Der damalige französische Staatspräsident François Mitterrand und der damalige deutsche Bundeskanzler Helmut Kohl",
      translated: "Тогавашният френски президент Франсоа Митеран и тогавашният германски федерален канцлер Хелмут Кол",
      tone: 'semantic',
    },
    {
      german: "gedenken in Verdun gemeinsam der Toten beider Weltkriege",
      translated: "заедно почитат във Вердюн жертвите на двете световни войни",
      tone: 'semantic',
    },
    {
      german: "Welches Ziel der Europäischen Union wird bei diesem Treffen deutlich",
      translated: "Коя цел на Европейския съюз става ясна при тази среща?",
      tone: 'semantic',
    },
    {
      german: "© Bundesregierung/Richard Schulze-Vorberg",
      translated: "© Bundesregierung/Richard Schulze-Vorberg",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:235|bs": [
    {
      german: "Der damalige französische Staatspräsident François Mitterrand und der damalige deutsche Bundeskanzler Helmut Kohl",
      translated: "Tadašnji francuski predsjednik François Mitterrand i tadašnji njemački savezni kancelar Helmut Kohl",
      tone: 'semantic',
    },
    {
      german: "gedenken in Verdun gemeinsam der Toten beider Weltkriege",
      translated: "zajedno u Verdunu odaju počast žrtvama obaju svjetskih ratova",
      tone: 'semantic',
    },
    {
      german: "Welches Ziel der Europäischen Union wird bei diesem Treffen deutlich",
      translated: "Koji se cilj EU-a ovdje vidi",
      tone: 'semantic',
    },
    {
      german: "© Bundesregierung/Richard Schulze-Vorberg",
      translated: "© Bundesregierung/Richard Schulze-Vorberg",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:235|el": [
    {
      german: "Der damalige französische Staatspräsident François Mitterrand und der damalige deutsche Bundeskanzler Helmut Kohl",
      translated: "Ο τότε Γάλλος Πρόεδρος της Δημοκρατίας François Mitterrand και ο τότε Γερμανός Ομοσπονδιακός Καγκελάριος Helmut Kohl",
      tone: 'semantic',
    },
    {
      german: "gedenken in Verdun gemeinsam der Toten beider Weltkriege",
      translated: "τιμούν μαζί στο Verdun τους νεκρούς των δύο παγκοσμίων πολέμων",
      tone: 'semantic',
    },
    {
      german: "Welches Ziel der Europäischen Union wird bei diesem Treffen deutlich",
      translated: "Ποιος στόχος της Ευρωπαϊκής Ένωσης γίνεται εμφανής σε αυτή τη συνάντηση;",
      tone: 'semantic',
    },
    {
      german: "© Bundesregierung/Richard Schulze-Vorberg",
      translated: "© Bundesregierung/Richard Schulze-Vorberg",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:235|en": [
    {
      german: "Der damalige französische Staatspräsident François Mitterrand und der damalige deutsche Bundeskanzler Helmut Kohl",
      translated: "French President François Mitterrand and German Chancellor Helmut Kohl",
      tone: 'semantic',
    },
    {
      german: "gedenken in Verdun gemeinsam der Toten beider Weltkriege",
      translated: "commemorate the dead of both World Wars together in Verdun",
      tone: 'semantic',
    },
    {
      german: "Welches Ziel der Europäischen Union wird bei diesem Treffen deutlich",
      translated: "What goal of the European Union becomes clear at this meeting",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:235|es": [
    {
      german: "Der damalige französische Staatspräsident François Mitterrand und der damalige deutsche Bundeskanzler Helmut Kohl",
      translated: "El entonces presidente francés François Mitterrand y el entonces canciller alemán Helmut Kohl",
      tone: 'semantic',
    },
    {
      german: "gedenken in Verdun gemeinsam der Toten beider Weltkriege",
      translated: "conmemoraron juntos en Verdún a los muertos de ambas guerras mundiales",
      tone: 'semantic',
    },
    {
      german: "Welches Ziel der Europäischen Union wird bei diesem Treffen deutlich",
      translated: "Qué objetivo de la Unión Europea se refleja en este encuentro",
      tone: 'semantic',
    },
    {
      german: "© Bundesregierung/Richard Schulze-Vorberg",
      translated: "© Bundesregierung/Richard Schulze-Vorberg",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:235|fa": [
    {
      german: "Der damalige französische Staatspräsident François Mitterrand und der damalige deutsche Bundeskanzler Helmut Kohl",
      translated: "فرانسوا میتران، رئیس‌جمهور پیشین فرانسه، و هلموت کوهل، صدراعظم پیشین آلمان",
      tone: 'semantic',
    },
    {
      german: "gedenken in Verdun gemeinsam der Toten beider Weltkriege",
      translated: "در وردن مشترکاً یاد کشته‌شدگان دو جنگ جهانی را گرامی می‌دارند",
      tone: 'semantic',
    },
    {
      german: "Welches Ziel der Europäischen Union wird bei diesem Treffen deutlich",
      translated: "کدام هدف اتحادیهٔ اروپا در این دیدار آشکار است",
      tone: 'semantic',
    },
    {
      german: "© Bundesregierung/Richard Schulze-Vorberg",
      translated: "© Bundesregierung/Richard Schulze-Vorberg",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:235|fr": [
    {
      german: "Der damalige französische Staatspräsident François Mitterrand und der damalige deutsche Bundeskanzler Helmut Kohl",
      translated: "L’ancien président français François Mitterrand et l’ancien chancelier allemand Helmut Kohl",
      tone: 'semantic',
    },
    {
      german: "gedenken in Verdun gemeinsam der Toten beider Weltkriege",
      translated: "commémorent ensemble à Verdun les morts des deux guerres mondiales",
      tone: 'semantic',
    },
    {
      german: "Welches Ziel der Europäischen Union wird bei diesem Treffen deutlich",
      translated: "Quel objectif de l’Union européenne apparaît lors de cette rencontre",
      tone: 'semantic',
    },
    {
      german: "© Bundesregierung/Richard Schulze-Vorberg",
      translated: "© Bundesregierung/Richard Schulze-Vorberg",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:235|hr": [
    {
      german: "Der damalige französische Staatspräsident François Mitterrand und der damalige deutsche Bundeskanzler Helmut Kohl",
      translated: "Tadašnji francuski predsjednik François Mitterrand i tadašnji njemački savezni kancelar Helmut Kohl",
      tone: 'semantic',
    },
    {
      german: "gedenken in Verdun gemeinsam der Toten beider Weltkriege",
      translated: "zajedno u Verdunu odaju počast poginulima u oba svjetska rata",
      tone: 'semantic',
    },
    {
      german: "Welches Ziel der Europäischen Union wird bei diesem Treffen deutlich",
      translated: "Koji cilj Europske unije postaje jasan na ovom susretu",
      tone: 'semantic',
    },
    {
      german: "© Bundesregierung/Richard Schulze-Vorberg",
      translated: "© Bundesregierung/Richard Schulze-Vorberg",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:235|it": [
    {
      german: "Der damalige französische Staatspräsident François Mitterrand und der damalige deutsche Bundeskanzler Helmut Kohl",
      translated: "L’allora presidente francese François Mitterrand e l’allora cancelliere tedesco Helmut Kohl",
      tone: 'semantic',
    },
    {
      german: "gedenken in Verdun gemeinsam der Toten beider Weltkriege",
      translated: "commemorano insieme a Verdun i morti delle due guerre mondiali",
      tone: 'semantic',
    },
    {
      german: "Welches Ziel der Europäischen Union wird bei diesem Treffen deutlich",
      translated: "Quale obiettivo dell’Unione europea emerge da questo incontro",
      tone: 'semantic',
    },
    {
      german: "© Bundesregierung/Richard Schulze-Vorberg",
      translated: "© Bundesregierung/Richard Schulze-Vorberg",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:235|kmr": [
    {
      german: "Der damalige französische Staatspräsident François Mitterrand und der damalige deutsche Bundeskanzler Helmut Kohl",
      translated: "Serokomarê Frensî yê wê demê François Mitterrand û Kanselerê Federal ê Alman yê wê demê Helmut Kohl",
      tone: 'semantic',
    },
    {
      german: "gedenken in Verdun gemeinsam der Toten beider Weltkriege",
      translated: "li Verdun qurbanên her du şerên cîhanê bi hev re bîr anîn",
      tone: 'semantic',
    },
    {
      german: "Welches Ziel der Europäischen Union wird bei diesem Treffen deutlich",
      translated: "Kîjan armanca Yekîtiya Ewropî di vê civînê de xuya dibe",
      tone: 'semantic',
    },
    {
      german: "© Bundesregierung/Richard Schulze-Vorberg",
      translated: "© Bundesregierung/Richard Schulze-Vorberg",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:235|pl": [
    {
      german: "Der damalige französische Staatspräsident François Mitterrand und der damalige deutsche Bundeskanzler Helmut Kohl",
      translated: "François Mitterrand i Helmut Kohl",
      tone: 'semantic',
    },
    {
      german: "gedenken in Verdun gemeinsam der Toten beider Weltkriege",
      translated: "wspólnie upamiętniają w Verdun ofiary obu wojen światowych",
      tone: 'semantic',
    },
    {
      german: "Welches Ziel der Europäischen Union wird bei diesem Treffen deutlich",
      translated: "Jaki cel UE jest tu widoczny",
      tone: 'semantic',
    },
    {
      german: "© Bundesregierung/Richard Schulze-Vorberg",
      translated: "© Bundesregierung/Richard Schulze-Vorberg",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:235|prs": [
    {
      german: "Der damalige französische Staatspräsident François Mitterrand und der damalige deutsche Bundeskanzler Helmut Kohl",
      translated: "فرانسوا میتران، رئیس‌جمهور پیشین فرانسه، و هلموت کوهل، صدراعظم پیشین آلمان",
      tone: 'semantic',
    },
    {
      german: "gedenken in Verdun gemeinsam der Toten beider Weltkriege",
      translated: "در وردن مشترکاً یاد کشته‌شدگان دو جنگ جهانی را گرامی می‌دارند",
      tone: 'semantic',
    },
    {
      german: "Welches Ziel der Europäischen Union wird bei diesem Treffen deutlich",
      translated: "کدام هدف اتحادیه اروپا در این دیدار آشکار است",
      tone: 'semantic',
    },
    {
      german: "© Bundesregierung/Richard Schulze-Vorberg",
      translated: "© Bundesregierung/Richard Schulze-Vorberg",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:235|ro": [
    {
      german: "Der damalige französische Staatspräsident François Mitterrand und der damalige deutsche Bundeskanzler Helmut Kohl",
      translated: "Fostul președinte francez François Mitterrand și fostul cancelar federal german Helmut Kohl",
      tone: 'semantic',
    },
    {
      german: "gedenken in Verdun gemeinsam der Toten beider Weltkriege",
      translated: "comemorează împreună la Verdun victimele celor două războaie mondiale",
      tone: 'semantic',
    },
    {
      german: "Welches Ziel der Europäischen Union wird bei diesem Treffen deutlich",
      translated: "Ce obiectiv al Uniunii Europene este ilustrat de această întâlnire",
      tone: 'semantic',
    },
    {
      german: "© Bundesregierung/Richard Schulze-Vorberg",
      translated: "© Bundesregierung/Richard Schulze-Vorberg",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:235|ru": [
    {
      german: "Der damalige französische Staatspräsident François Mitterrand und der damalige deutsche Bundeskanzler Helmut Kohl",
      translated: "Тогдашний президент Франции Франсуа Миттеран и тогдашний федеральный канцлер Германии Гельмут Коль",
      tone: 'semantic',
    },
    {
      german: "gedenken in Verdun gemeinsam der Toten beider Weltkriege",
      translated: "совместно почтили в Вердене память погибших в обеих мировых войнах",
      tone: 'semantic',
    },
    {
      german: "Welches Ziel der Europäischen Union wird bei diesem Treffen deutlich",
      translated: "Какая цель Европейского союза становится очевидной на этой встрече",
      tone: 'semantic',
    },
    {
      german: "© Bundesregierung/Richard Schulze-Vorberg",
      translated: "© Федеральное правительство/Рихард Шульце-Форберг",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:235|sq": [
    {
      german: "Der damalige französische Staatspräsident François Mitterrand und der damalige deutsche Bundeskanzler Helmut Kohl",
      translated: "Presidenti i atëhershëm francez François Mitterrand dhe kancelari i atëhershëm gjerman Helmut Kohl",
      tone: 'semantic',
    },
    {
      german: "gedenken in Verdun gemeinsam der Toten beider Weltkriege",
      translated: "përkujtojnë së bashku në Verdun viktimat e dy luftërave botërore",
      tone: 'semantic',
    },
    {
      german: "Welches Ziel der Europäischen Union wird bei diesem Treffen deutlich",
      translated: "Cilin qëllim të Bashkimit Evropian tregon ky takim?",
      tone: 'semantic',
    },
    {
      german: "© Bundesregierung/Richard Schulze-Vorberg",
      translated: "© Bundesregierung/Richard Schulze-Vorberg",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:235|sr": [
    {
      german: "Der damalige französische Staatspräsident François Mitterrand und der damalige deutsche Bundeskanzler Helmut Kohl",
      translated: "Tadašnji francuski predsednik François Mitterrand i tadašnji nemački savezni kancelar Helmut Kohl",
      tone: 'semantic',
    },
    {
      german: "gedenken in Verdun gemeinsam der Toten beider Weltkriege",
      translated: "zajedno u Verdunu odaju počast žrtvama oba svetska rata",
      tone: 'semantic',
    },
    {
      german: "Welches Ziel der Europäischen Union wird bei diesem Treffen deutlich",
      translated: "Koji cilj Evropske unije postaje jasan na ovom susretu",
      tone: 'semantic',
    },
    {
      german: "© Bundesregierung/Richard Schulze-Vorberg",
      translated: "© Bundesregierung/Richard Schulze-Vorberg",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:235|tr": [
    {
      german: "Der damalige französische Staatspräsident François Mitterrand und der damalige deutsche Bundeskanzler Helmut Kohl",
      translated: "Dönemin Fransa Cumhurbaşkanı François Mitterrand ile Almanya Federal Başbakanı Helmut Kohl",
      tone: 'semantic',
    },
    {
      german: "gedenken in Verdun gemeinsam der Toten beider Weltkriege",
      translated: "Verdun'da iki dünya savaşında ölenleri birlikte anıyor",
      tone: 'semantic',
    },
    {
      german: "Welches Ziel der Europäischen Union wird bei diesem Treffen deutlich",
      translated: "Avrupa Birliği'nin hangi amacı görülür?",
      tone: 'semantic',
    },
    {
      german: "© Bundesregierung/Richard Schulze-Vorberg",
      translated: "© Bundesregierung/Richard Schulze-Vorberg",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:235|uk": [
    {
      german: "Der damalige französische Staatspräsident François Mitterrand und der damalige deutsche Bundeskanzler Helmut Kohl",
      translated: "Тодішній президент Франції Франсуа Міттеран і тодішній федеральний канцлер Німеччини Гельмут Коль",
      tone: 'semantic',
    },
    {
      german: "gedenken in Verdun gemeinsam der Toten beider Weltkriege",
      translated: " разом вшановують у Вердені пам’ять загиблих в обох світових війнах",
      tone: 'semantic',
    },
    {
      german: "Welches Ziel der Europäischen Union wird bei diesem Treffen deutlich",
      translated: "Яка мета Європейського Союзу проявляється під час цієї зустрічі",
      tone: 'semantic',
    },
    {
      german: "© Bundesregierung/Richard Schulze-Vorberg",
      translated: "© Bundesregierung/Richard Schulze-Vorberg",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:235|vi": [
    {
      german: "Der damalige französische Staatspräsident François Mitterrand und der damalige deutsche Bundeskanzler Helmut Kohl",
      translated: "Tổng thống Pháp khi đó François Mitterrand và Thủ tướng Liên bang Đức khi đó Helmut Kohl",
      tone: 'semantic',
    },
    {
      german: "gedenken in Verdun gemeinsam der Toten beider Weltkriege",
      translated: "cùng tưởng niệm những người đã chết trong hai cuộc thế chiến tại Verdun",
      tone: 'semantic',
    },
    {
      german: "Welches Ziel der Europäischen Union wird bei diesem Treffen deutlich",
      translated: "Mục tiêu nào của Liên minh châu Âu được thể hiện qua cuộc gặp này?",
      tone: 'semantic',
    },
    {
      german: "© Bundesregierung/Richard Schulze-Vorberg",
      translated: "© Bundesregierung/Richard Schulze-Vorberg",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:236|ar": [
    {
      german: "Wie viele",
      translated: "كم عدد",
      tone: 'semantic',
    },
    {
      german: "Mitgliedstaaten",
      translated: "الدول الأعضاء",
      tone: 'semantic',
    },
    {
      german: "die EU",
      translated: "الاتحاد الأوروبي",
      tone: 'semantic',
    },
    {
      german: "heute",
      translated: "حاليًا",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:236|bg": [
    {
      german: "Wie viele",
      translated: "Колко",
      tone: 'semantic',
    },
    {
      german: "Mitgliedstaaten",
      translated: "държави",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "членуват",
      tone: 'semantic',
    },
    {
      german: "die EU",
      translated: "в Европейския съюз",
      tone: 'semantic',
    },
    {
      german: "heute",
      translated: "днес",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:236|bs": [
    {
      german: "Wie viele",
      translated: "Koliko",
      tone: 'semantic',
    },
    {
      german: "Mitgliedstaaten",
      translated: "država članica",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "ima",
      tone: 'semantic',
    },
    {
      german: "die EU",
      translated: "Evropska unija",
      tone: 'semantic',
    },
    {
      german: "heute",
      translated: "trenutno",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:236|el": [
    {
      german: "Wie viele",
      translated: "Πόσα",
      tone: 'semantic',
    },
    {
      german: "Mitgliedstaaten",
      translated: "κράτη μέλη",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "έχει",
      tone: 'semantic',
    },
    {
      german: "die EU",
      translated: "η Ευρωπαϊκή Ένωση",
      tone: 'semantic',
    },
    {
      german: "heute",
      translated: "σήμερα",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:236|en": [
    {
      german: "Wie viele",
      translated: "How many",
      tone: 'semantic',
    },
    {
      german: "Mitgliedstaaten",
      translated: "member states",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "does",
      tone: 'semantic',
    },
    {
      german: "die EU",
      translated: "the EU",
      tone: 'semantic',
    },
    {
      german: "heute",
      translated: "today",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:236|es": [
    {
      german: "Wie viele",
      translated: "¿Cuántos",
      tone: 'semantic',
    },
    {
      german: "Mitgliedstaaten",
      translated: "Estados miembros",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "tiene",
      tone: 'semantic',
    },
    {
      german: "die EU",
      translated: "la Unión Europea",
      tone: 'semantic',
    },
    {
      german: "heute",
      translated: "actualmente",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:236|fa": [
    {
      german: "Wie viele",
      translated: "چند",
      tone: 'semantic',
    },
    {
      german: "Mitgliedstaaten",
      translated: "کشور عضو",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: " دارد",
      tone: 'semantic',
    },
    {
      german: "die EU",
      translated: "اتحادیهٔ اروپا",
      tone: 'semantic',
    },
    {
      german: "heute",
      translated: "امروزه",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:236|fr": [
    {
      german: "Wie viele",
      translated: "Combien",
      tone: 'semantic',
    },
    {
      german: "Mitgliedstaaten",
      translated: "d’États membres",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "compte-t-elle",
      tone: 'semantic',
    },
    {
      german: "die EU",
      translated: "l’Union européenne",
      tone: 'semantic',
    },
    {
      german: "heute",
      translated: "aujourd’hui",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:236|hr": [
    {
      german: "Wie viele",
      translated: "Koliko",
      tone: 'semantic',
    },
    {
      german: "Mitgliedstaaten",
      translated: "država članica",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "ima",
      tone: 'semantic',
    },
    {
      german: "die EU",
      translated: "Europska unija",
      tone: 'semantic',
    },
    {
      german: "heute",
      translated: "trenutačno",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:236|it": [
    {
      german: "Wie viele",
      translated: "Quanti",
      tone: 'semantic',
    },
    {
      german: "Mitgliedstaaten",
      translated: "Stati membri",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "ha",
      tone: 'semantic',
    },
    {
      german: "die EU",
      translated: "l’Unione europea",
      tone: 'semantic',
    },
    {
      german: "heute",
      translated: "oggi",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:236|kmr": [
    {
      german: "Mitgliedstaaten",
      translated: "çend",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "îro",
      tone: 'semantic',
    },
    {
      german: "die EU",
      translated: "endam",
      tone: 'semantic',
    },
    {
      german: "heute",
      translated: "hene?",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:236|pl": [
    {
      german: "Wie viele",
      translated: "Ile",
      tone: 'semantic',
    },
    {
      german: "Mitgliedstaaten",
      translated: "państw członkowskich",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "ma",
      tone: 'semantic',
    },
    {
      german: "die EU",
      translated: "Unia Europejska",
      tone: 'semantic',
    },
    {
      german: "heute",
      translated: "obecnie",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:236|prs": [
    {
      german: "Wie viele",
      translated: "چند",
      tone: 'semantic',
    },
    {
      german: "Mitgliedstaaten",
      translated: "کشور عضو",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "دارد",
      tone: 'semantic',
    },
    {
      german: "die EU",
      translated: "اتحادیه اروپا",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:236|ro": [
    {
      german: "Wie viele",
      translated: "Câte",
      tone: 'semantic',
    },
    {
      german: "Mitgliedstaaten",
      translated: "state membre",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "are",
      tone: 'semantic',
    },
    {
      german: "die EU",
      translated: "Uniunea Europeană",
      tone: 'semantic',
    },
    {
      german: "heute",
      translated: "astăzi",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:236|ru": [
    {
      german: "Wie viele",
      translated: "Сколько",
      tone: 'semantic',
    },
    {
      german: "Mitgliedstaaten",
      translated: "государств-членов",
      tone: 'semantic',
    },
    {
      german: "die EU",
      translated: "в ЕС",
      tone: 'semantic',
    },
    {
      german: "heute",
      translated: "сегодня",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:236|sq": [
    {
      german: "Wie viele",
      translated: "Sa",
      tone: 'semantic',
    },
    {
      german: "Mitgliedstaaten",
      translated: "shtete",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "ka",
      tone: 'semantic',
    },
    {
      german: "die EU",
      translated: "Bashkimi Evropian",
      tone: 'semantic',
    },
    {
      german: "heute",
      translated: "sot",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:236|sr": [
    {
      german: "Wie viele",
      translated: "Koliko",
      tone: 'semantic',
    },
    {
      german: "Mitgliedstaaten",
      translated: "država članica",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "ima",
      tone: 'semantic',
    },
    {
      german: "die EU",
      translated: "Evropska unija",
      tone: 'semantic',
    },
    {
      german: "heute",
      translated: "trenutno",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:236|tr": [
    {
      german: "Wie viele",
      translated: "kaç",
      tone: 'semantic',
    },
    {
      german: "Mitgliedstaaten",
      translated: "üye devleti",
      tone: 'semantic',
    },
    {
      german: "die EU",
      translated: "Avrupa Birliği",
      tone: 'semantic',
    },
    {
      german: "heute",
      translated: "bugün",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:236|uk": [
    {
      german: "Wie viele",
      translated: "Скільки",
      tone: 'semantic',
    },
    {
      german: "Mitgliedstaaten",
      translated: "держав-членів",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "має",
      tone: 'semantic',
    },
    {
      german: "die EU",
      translated: "ЄС",
      tone: 'semantic',
    },
    {
      german: "heute",
      translated: "сьогодні",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:236|vi": [
    {
      german: "Wie viele",
      translated: "bao nhiêu",
      tone: 'semantic',
    },
    {
      german: "Mitgliedstaaten",
      translated: "quốc gia thành viên",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "có",
      tone: 'semantic',
    },
    {
      german: "die EU",
      translated: "Liên minh châu Âu",
      tone: 'semantic',
    },
    {
      german: "heute",
      translated: "hiện",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:237|ar": [
    {
      german: "2007",
      translated: "2007",
      tone: 'semantic',
    },
    {
      german: "50-jährige Jubiläum",
      translated: "جرى الاحتفال بالذكرى الخمسين لـ«",
      tone: 'semantic',
    },
    {
      german: "Römischen Verträge",
      translated: "معاهدات روما",
      tone: 'semantic',
    },
    {
      german: "gefeiert",
      translated: "»",
      tone: 'semantic',
    },
    {
      german: "Was war der Inhalt",
      translated: "ماذا كان مضمون",
      tone: 'semantic',
    },
    {
      german: "der Verträge",
      translated: "هذه المعاهدات",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:237|bg": [
    {
      german: "2007",
      translated: "През 2007 г.",
      tone: 'semantic',
    },
    {
      german: "50-jährige Jubiläum",
      translated: "50 години",
      tone: 'semantic',
    },
    {
      german: "Römischen Verträge",
      translated: "„Римските договори“",
      tone: 'semantic',
    },
    {
      german: "gefeiert",
      translated: "се отбелязват",
      tone: 'semantic',
    },
    {
      german: "Was war der Inhalt",
      translated: "Какво е съдържанието",
      tone: 'semantic',
    },
    {
      german: "der Verträge",
      translated: "на договорите",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:237|bs": [
    {
      german: "2007",
      translated: "2007",
      tone: 'semantic',
    },
    {
      german: "50-jährige Jubiläum",
      translated: "50. obljetnica",
      tone: 'semantic',
    },
    {
      german: "Römischen Verträge",
      translated: "„Rimskih ugovora“",
      tone: 'semantic',
    },
    {
      german: "gefeiert",
      translated: "obilježena je",
      tone: 'semantic',
    },
    {
      german: "Was war der Inhalt",
      translated: "Koji je bio sadržaj",
      tone: 'semantic',
    },
    {
      german: "der Verträge",
      translated: "ugovora",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:237|el": [
    {
      german: "2007",
      translated: "2007",
      tone: 'semantic',
    },
    {
      german: "50-jährige Jubiläum",
      translated: "50 χρόνια",
      tone: 'semantic',
    },
    {
      german: "Römischen Verträge",
      translated: "Συνθήκες της Ρώμης",
      tone: 'semantic',
    },
    {
      german: "gefeiert",
      translated: "γιορτάστηκαν",
      tone: 'semantic',
    },
    {
      german: "Was war der Inhalt",
      translated: "Τι προέβλεπαν",
      tone: 'semantic',
    },
    {
      german: "der Verträge",
      translated: "αυτές οι συνθήκες",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:237|en": [
    {
      german: "2007",
      translated: "2007",
      tone: 'semantic',
    },
    {
      german: "50-jährige Jubiläum",
      translated: "50th anniversary",
      tone: 'semantic',
    },
    {
      german: "Römischen Verträge",
      translated: "'Treaties of Rome'",
      tone: 'semantic',
    },
    {
      german: "gefeiert",
      translated: "was celebrated",
      tone: 'semantic',
    },
    {
      german: "Was war der Inhalt",
      translated: "What was the content",
      tone: 'semantic',
    },
    {
      german: "der Verträge",
      translated: "of the treaties",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:237|es": [
    {
      german: "2007",
      translated: "En 2007",
      tone: 'semantic',
    },
    {
      german: "50-jährige Jubiläum",
      translated: "el 50.º aniversario",
      tone: 'semantic',
    },
    {
      german: "Römischen Verträge",
      translated: "«Tratados de Roma»",
      tone: 'semantic',
    },
    {
      german: "gefeiert",
      translated: "se celebró",
      tone: 'semantic',
    },
    {
      german: "Was war der Inhalt",
      translated: "¿Cuál era el contenido",
      tone: 'semantic',
    },
    {
      german: "der Verträge",
      translated: "de esos tratados",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:237|fa": [
    {
      german: "2007",
      translated: "۲۰۰۷",
      tone: 'semantic',
    },
    {
      german: "50-jährige Jubiläum",
      translated: "پنجاهمین سالگرد",
      tone: 'semantic',
    },
    {
      german: "Römischen Verträge",
      translated: "پیمان‌های رم",
      tone: 'semantic',
    },
    {
      german: "gefeiert",
      translated: " جشن گرفته شد",
      tone: 'semantic',
    },
    {
      german: "Was war der Inhalt",
      translated: "محتوای این پیمان‌ها چه بود",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:237|fr": [
    {
      german: "2007",
      translated: "2007",
      tone: 'semantic',
    },
    {
      german: "50-jährige Jubiläum",
      translated: "50e anniversaire",
      tone: 'semantic',
    },
    {
      german: "Römischen Verträge",
      translated: "« traités de Rome »",
      tone: 'semantic',
    },
    {
      german: "gefeiert",
      translated: "célébré",
      tone: 'semantic',
    },
    {
      german: "Was war der Inhalt",
      translated: "Quel était le contenu",
      tone: 'semantic',
    },
    {
      german: "der Verträge",
      translated: "ces traités ?",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:237|hr": [
    {
      german: "2007",
      translated: "2007",
      tone: 'semantic',
    },
    {
      german: "50-jährige Jubiläum",
      translated: "50. obljetnica",
      tone: 'semantic',
    },
    {
      german: "Römischen Verträge",
      translated: "„Rimskih ugovora“.",
      tone: 'semantic',
    },
    {
      german: "gefeiert",
      translated: "obilježena je",
      tone: 'semantic',
    },
    {
      german: "Was war der Inhalt",
      translated: "Koji je bio sadržaj",
      tone: 'semantic',
    },
    {
      german: "der Verträge",
      translated: "ugovora",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:237|it": [
    {
      german: "2007",
      translated: "Nel 2007",
      tone: 'semantic',
    },
    {
      german: "50-jährige Jubiläum",
      translated: "i 50 anni",
      tone: 'semantic',
    },
    {
      german: "Römischen Verträge",
      translated: "«Trattati di Roma»",
      tone: 'semantic',
    },
    {
      german: "gefeiert",
      translated: "si celebrarono",
      tone: 'semantic',
    },
    {
      german: "Was war der Inhalt",
      translated: "Che cosa stabilivano?",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:237|kmr": [
    {
      german: "2007",
      translated: "2007",
      tone: 'semantic',
    },
    {
      german: "50-jährige Jubiläum",
      translated: "50 saliya",
      tone: 'semantic',
    },
    {
      german: "Römischen Verträge",
      translated: "«Peymanên Romayê» hate",
      tone: 'semantic',
    },
    {
      german: "gefeiert",
      translated: "pîrozkirin",
      tone: 'semantic',
    },
    {
      german: "Was war der Inhalt",
      translated: "Naveroka wan çi bû",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:237|pl": [
    {
      german: "2007",
      translated: "W 2007 r.",
      tone: 'semantic',
    },
    {
      german: "50-jährige Jubiläum",
      translated: "50-lecie",
      tone: 'semantic',
    },
    {
      german: "Römischen Verträge",
      translated: "„Traktatów Rzymskich”",
      tone: 'semantic',
    },
    {
      german: "gefeiert",
      translated: "obchodzono",
      tone: 'semantic',
    },
    {
      german: "Was war der Inhalt",
      translated: "Jaka była treść",
      tone: 'semantic',
    },
    {
      german: "der Verträge",
      translated: "tych traktatów",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:237|prs": [
    {
      german: "2007",
      translated: "۲۰۰۷",
      tone: 'semantic',
    },
    {
      german: "50-jährige Jubiläum",
      translated: "پنجاهمین سالگرد",
      tone: 'semantic',
    },
    {
      german: "Römischen Verträge",
      translated: "«پیمان‌های رم»",
      tone: 'semantic',
    },
    {
      german: "gefeiert",
      translated: " جشن گرفته شد",
      tone: 'semantic',
    },
    {
      german: "Was war der Inhalt",
      translated: "محتوای این پیمان‌ها چه بود",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:237|ro": [
    {
      german: "2007",
      translated: "2007",
      tone: 'semantic',
    },
    {
      german: "50-jährige Jubiläum",
      translated: "50 de ani",
      tone: 'semantic',
    },
    {
      german: "Römischen Verträge",
      translated: "Tratatele de la Roma",
      tone: 'semantic',
    },
    {
      german: "gefeiert",
      translated: "s-au sărbătorit",
      tone: 'semantic',
    },
    {
      german: "Was war der Inhalt",
      translated: "Ce au stabilit",
      tone: 'semantic',
    },
    {
      german: "der Verträge",
      translated: "aceste tratate",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:237|ru": [
    {
      german: "2007",
      translated: "2007",
      tone: 'semantic',
    },
    {
      german: "50-jährige Jubiläum",
      translated: "50-летие",
      tone: 'semantic',
    },
    {
      german: "Römischen Verträge",
      translated: "«Римских договоров»",
      tone: 'semantic',
    },
    {
      german: "gefeiert",
      translated: "отмечалось",
      tone: 'semantic',
    },
    {
      german: "Was war der Inhalt",
      translated: "В чём заключалось",
      tone: 'semantic',
    },
    {
      german: "der Verträge",
      translated: "их",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:237|sq": [
    {
      german: "2007",
      translated: "Në vitin 2007",
      tone: 'semantic',
    },
    {
      german: "50-jährige Jubiläum",
      translated: "50 vjet",
      tone: 'semantic',
    },
    {
      german: "Römischen Verträge",
      translated: "«Traktatet e Romës»",
      tone: 'semantic',
    },
    {
      german: "gefeiert",
      translated: "u festuan",
      tone: 'semantic',
    },
    {
      german: "Was war der Inhalt",
      translated: "Çfarë themeluan",
      tone: 'semantic',
    },
    {
      german: "der Verträge",
      translated: "këto traktate",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:237|sr": [
    {
      german: "2007",
      translated: "2007",
      tone: 'semantic',
    },
    {
      german: "50-jährige Jubiläum",
      translated: "50. obljetnica",
      tone: 'semantic',
    },
    {
      german: "Römischen Verträge",
      translated: "„Rimskih ugovora“.",
      tone: 'semantic',
    },
    {
      german: "gefeiert",
      translated: "obilježena je",
      tone: 'semantic',
    },
    {
      german: "Was war der Inhalt",
      translated: "Koji je bio sadržaj",
      tone: 'semantic',
    },
    {
      german: "der Verträge",
      translated: "ugovora",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:237|tr": [
    {
      german: "2007",
      translated: "2007",
      tone: 'semantic',
    },
    {
      german: "50-jährige Jubiläum",
      translated: "50. yılı",
      tone: 'semantic',
    },
    {
      german: "Römischen Verträge",
      translated: "Roma Antlaşmaları",
      tone: 'semantic',
    },
    {
      german: "gefeiert",
      translated: "kutlandı",
      tone: 'semantic',
    },
    {
      german: "Was war der Inhalt",
      translated: "konusu neydi",
      tone: 'semantic',
    },
    {
      german: "der Verträge",
      translated: "Bu antlaşmaların",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:237|uk": [
    {
      german: "2007",
      translated: "У 2007",
      tone: 'semantic',
    },
    {
      german: "50-jährige Jubiläum",
      translated: "50-річчя",
      tone: 'semantic',
    },
    {
      german: "Römischen Verträge",
      translated: "«Римських договорів»",
      tone: 'semantic',
    },
    {
      german: "gefeiert",
      translated: "відзначали",
      tone: 'semantic',
    },
    {
      german: "Was war der Inhalt",
      translated: "Що було змістом",
      tone: 'semantic',
    },
    {
      german: "der Verträge",
      translated: "цих договорів",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:237|vi": [
    {
      german: "2007",
      translated: "2007",
      tone: 'semantic',
    },
    {
      german: "50-jährige Jubiläum",
      translated: "kỷ niệm 50 năm",
      tone: 'semantic',
    },
    {
      german: "Römischen Verträge",
      translated: "Hiệp ước Rome",
      tone: 'semantic',
    },
    {
      german: "gefeiert",
      translated: "Các hiệp ước này",
      tone: 'semantic',
    },
    {
      german: "Was war der Inhalt",
      translated: "đã thiết lập điều gì",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:238|ar": [
    {
      german: "An welchen Orten",
      translated: "في أي مدن",
      tone: 'semantic',
    },
    {
      german: "arbeitet",
      translated: "يعمل",
      tone: 'semantic',
    },
    {
      german: "das Europäische Parlament?",
      translated: "البرلمان الأوروبي؟",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:238|bg": [
    {
      german: "An welchen Orten",
      translated: "В кои градове",
      tone: 'semantic',
    },
    {
      german: "arbeitet",
      translated: "работи",
      tone: 'semantic',
    },
    {
      german: "das Europäische Parlament?",
      translated: "Европейският парламент?",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:238|bs": [
    {
      german: "An welchen Orten",
      translated: "U kojim gradovima",
      tone: 'semantic',
    },
    {
      german: "arbeitet",
      translated: "radi",
      tone: 'semantic',
    },
    {
      german: "das Europäische Parlament?",
      translated: "Evropski parlament?",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:238|el": [
    {
      german: "An welchen Orten",
      translated: "Σε ποιες πόλεις",
      tone: 'semantic',
    },
    {
      german: "arbeitet",
      translated: "εργάζεται",
      tone: 'semantic',
    },
    {
      german: "das Europäische Parlament?",
      translated: "το Ευρωπαϊκό Κοινοβούλιο;",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:238|en": [
    {
      german: "An welchen Orten",
      translated: "In which locations",
      tone: 'semantic',
    },
    {
      german: "arbeitet",
      translated: "work",
      tone: 'semantic',
    },
    {
      german: "das Europäische Parlament?",
      translated: "the European Parliament",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:238|es": [
    {
      german: "An welchen Orten",
      translated: "qué ciudades",
      tone: 'semantic',
    },
    {
      german: "arbeitet",
      translated: "trabaja",
      tone: 'semantic',
    },
    {
      german: "das Europäische Parlament?",
      translated: "el Parlamento Europeo",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:238|fa": [
    {
      german: "An welchen Orten",
      translated: "در کدام مکان‌ها",
      tone: 'semantic',
    },
    {
      german: "arbeitet",
      translated: "فعالیت می‌کند",
      tone: 'semantic',
    },
    {
      german: "das Europäische Parlament?",
      translated: "پارلمان اروپا",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:238|fr": [
    {
      german: "An welchen Orten",
      translated: "Dans quelles villes",
      tone: 'semantic',
    },
    {
      german: "arbeitet",
      translated: "travaille-t-il",
      tone: 'semantic',
    },
    {
      german: "das Europäische Parlament?",
      translated: "le Parlement européen",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:238|hr": [
    {
      german: "An welchen Orten",
      translated: "U kojim gradovima",
      tone: 'semantic',
    },
    {
      german: "arbeitet",
      translated: "radi",
      tone: 'semantic',
    },
    {
      german: "das Europäische Parlament?",
      translated: "Europski parlament?",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:238|it": [
    {
      german: "An welchen Orten",
      translated: "In quali città",
      tone: 'semantic',
    },
    {
      german: "arbeitet",
      translated: "lavora",
      tone: 'semantic',
    },
    {
      german: "das Europäische Parlament?",
      translated: "il Parlamento europeo?",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:238|kmr": [
    {
      german: "An welchen Orten",
      translated: "li kîjan bajaran",
      tone: 'semantic',
    },
    {
      german: "arbeitet",
      translated: "dixebite",
      tone: 'semantic',
    },
    {
      german: "das Europäische Parlament?",
      translated: "Parlamentoya Ewropî",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:238|pl": [
    {
      german: "An welchen Orten",
      translated: "W których miastach",
      tone: 'semantic',
    },
    {
      german: "arbeitet",
      translated: "pracuje",
      tone: 'semantic',
    },
    {
      german: "das Europäische Parlament?",
      translated: "Parlament Europejski?",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:238|prs": [
    {
      german: "An welchen Orten",
      translated: "در کدام شهرها",
      tone: 'semantic',
    },
    {
      german: "arbeitet",
      translated: "فعالیت می‌کند",
      tone: 'semantic',
    },
    {
      german: "das Europäische Parlament?",
      translated: "پارلمان اروپا",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:238|ro": [
    {
      german: "An welchen Orten",
      translated: "În ce locuri",
      tone: 'semantic',
    },
    {
      german: "arbeitet",
      translated: "lucrează",
      tone: 'semantic',
    },
    {
      german: "das Europäische Parlament?",
      translated: "Parlamentul European",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:238|ru": [
    {
      german: "An welchen Orten",
      translated: "В каких городах",
      tone: 'semantic',
    },
    {
      german: "arbeitet",
      translated: "работает",
      tone: 'semantic',
    },
    {
      german: "das Europäische Parlament?",
      translated: "Европейский парламент?",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:238|sq": [
    {
      german: "An welchen Orten",
      translated: "Në cilat qytete",
      tone: 'semantic',
    },
    {
      german: "arbeitet",
      translated: "punon",
      tone: 'semantic',
    },
    {
      german: "das Europäische Parlament?",
      translated: "Parlamenti Evropian?",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:238|sr": [
    {
      german: "An welchen Orten",
      translated: "U kojim gradovima",
      tone: 'semantic',
    },
    {
      german: "arbeitet",
      translated: "radi",
      tone: 'semantic',
    },
    {
      german: "das Europäische Parlament?",
      translated: "Evropski parlament?",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:238|tr": [
    {
      german: "An welchen Orten",
      translated: "hangi şehirlerde",
      tone: 'semantic',
    },
    {
      german: "arbeitet",
      translated: "çalışır",
      tone: 'semantic',
    },
    {
      german: "das Europäische Parlament?",
      translated: "Avrupa Parlamentosu",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:238|uk": [
    {
      german: "An welchen Orten",
      translated: "У яких містах",
      tone: 'semantic',
    },
    {
      german: "arbeitet",
      translated: "працює",
      tone: 'semantic',
    },
    {
      german: "das Europäische Parlament?",
      translated: "Європейський парламент?",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:238|vi": [
    {
      german: "An welchen Orten",
      translated: "tại những thành phố nào?",
      tone: 'semantic',
    },
    {
      german: "das Europäische Parlament?",
      translated: "Nghị viện châu Âu làm việc",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:239|ar": [
    {
      german: "Durch welche Verträge",
      translated: "بموجب أي معاهدات",
      tone: 'semantic',
    },
    {
      german: "schloss sich",
      translated: "انضمت",
      tone: 'semantic',
    },
    {
      german: "die Bundesrepublik Deutschland",
      translated: "جمهورية ألمانيا الاتحادية",
      tone: 'semantic',
    },
    {
      german: "mit anderen Staaten",
      translated: "مع دول أخرى",
      tone: 'semantic',
    },
    {
      german: "zur Europäischen Wirtschaftsgemeinschaft",
      translated: "لتشكيل الجماعة الاقتصادية الأوروبية",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:239|bg": [
    {
      german: "Durch welche Verträge",
      translated: "С кои договори",
      tone: 'semantic',
    },
    {
      german: "schloss sich",
      translated: "създава",
      tone: 'semantic',
    },
    {
      german: "die Bundesrepublik Deutschland",
      translated: "Федерална република Германия",
      tone: 'semantic',
    },
    {
      german: "mit anderen Staaten",
      translated: "с други държави",
      tone: 'semantic',
    },
    {
      german: "zur Europäischen Wirtschaftsgemeinschaft",
      translated: "Европейската икономическа общност",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:239|bs": [
    {
      german: "Durch welche Verträge",
      translated: "Kojim je ugovorima",
      tone: 'semantic',
    },
    {
      german: "schloss sich",
      translated: "osnovala",
      tone: 'semantic',
    },
    {
      german: "die Bundesrepublik Deutschland",
      translated: "Savezna Republika Njemačka",
      tone: 'semantic',
    },
    {
      german: "mit anderen Staaten",
      translated: "zajedno s drugim državama",
      tone: 'semantic',
    },
    {
      german: "zur Europäischen Wirtschaftsgemeinschaft",
      translated: "Evropsku ekonomsku zajednicu",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:239|el": [
    {
      german: "Durch welche Verträge",
      translated: "Με ποιες συνθήκες",
      tone: 'semantic',
    },
    {
      german: "schloss sich",
      translated: "ίδρυσε",
      tone: 'semantic',
    },
    {
      german: "die Bundesrepublik Deutschland",
      translated: "η Ομοσπονδιακή Δημοκρατία της Γερμανίας",
      tone: 'semantic',
    },
    {
      german: "mit anderen Staaten",
      translated: "μαζί με άλλες χώρες",
      tone: 'semantic',
    },
    {
      german: "zur Europäischen Wirtschaftsgemeinschaft",
      translated: "την Ευρωπαϊκή Οικονομική Κοινότητα",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:239|en": [
    {
      german: "Durch welche Verträge",
      translated: "Through which treaties",
      tone: 'semantic',
    },
    {
      german: "schloss sich",
      translated: "unite",
      tone: 'semantic',
    },
    {
      german: "die Bundesrepublik Deutschland",
      translated: "the Federal Republic of Germany",
      tone: 'semantic',
    },
    {
      german: "mit anderen Staaten",
      translated: "with other states",
      tone: 'semantic',
    },
    {
      german: "zur Europäischen Wirtschaftsgemeinschaft",
      translated: "to form the European Economic Community",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:239|es": [
    {
      german: "Durch welche Verträge",
      translated: "¿Mediante qué tratados",
      tone: 'semantic',
    },
    {
      german: "schloss sich",
      translated: "se unió",
      tone: 'semantic',
    },
    {
      german: "die Bundesrepublik Deutschland",
      translated: "la República Federal de Alemania",
      tone: 'semantic',
    },
    {
      german: "mit anderen Staaten",
      translated: "con otros Estados",
      tone: 'semantic',
    },
    {
      german: "zur Europäischen Wirtschaftsgemeinschaft",
      translated: "para formar la Comunidad Económica Europea",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:239|fa": [
    {
      german: "Durch welche Verträge",
      translated: "کدام پیمان‌ها",
      tone: 'semantic',
    },
    {
      german: "die Bundesrepublik Deutschland",
      translated: "جمهوری فدرال آلمان",
      tone: 'semantic',
    },
    {
      german: "mit anderen Staaten",
      translated: "همراه کشورهای دیگر",
      tone: 'semantic',
    },
    {
      german: "zur Europäischen Wirtschaftsgemeinschaft",
      translated: "جامعهٔ اقتصادی اروپا را",
      tone: 'semantic',
    },
    {
      german: "zusammen",
      translated: "تشکیل داد؟",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:239|fr": [
    {
      german: "Durch welche Verträge",
      translated: "Par quels traités",
      tone: 'semantic',
    },
    {
      german: "schloss sich",
      translated: "s’est-elle associée",
      tone: 'semantic',
    },
    {
      german: "die Bundesrepublik Deutschland",
      translated: "la République fédérale d’Allemagne",
      tone: 'semantic',
    },
    {
      german: "mit anderen Staaten",
      translated: "à d’autres États",
      tone: 'semantic',
    },
    {
      german: "zur Europäischen Wirtschaftsgemeinschaft",
      translated: "la Communauté économique européenne",
      tone: 'semantic',
    },
    {
      german: "zusammen",
      translated: "pour former",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:239|hr": [
    {
      german: "Durch welche Verträge",
      translated: "Kojim je ugovorima",
      tone: 'semantic',
    },
    {
      german: "schloss sich",
      translated: "osnovala",
      tone: 'semantic',
    },
    {
      german: "die Bundesrepublik Deutschland",
      translated: "Savezna Republika Njemačka",
      tone: 'semantic',
    },
    {
      german: "mit anderen Staaten",
      translated: "zajedno s drugim državama",
      tone: 'semantic',
    },
    {
      german: "zur Europäischen Wirtschaftsgemeinschaft",
      translated: "Europsku ekonomsku zajednicu",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:239|it": [
    {
      german: "Durch welche Verträge",
      translated: "Con quali trattati",
      tone: 'semantic',
    },
    {
      german: "die Bundesrepublik Deutschland",
      translated: "Repubblica Federale di Germania",
      tone: 'semantic',
    },
    {
      german: "mit anderen Staaten",
      translated: "insieme ad altri Stati",
      tone: 'semantic',
    },
    {
      german: "zur Europäischen Wirtschaftsgemeinschaft",
      translated: "la Comunità Economica Europea",
      tone: 'semantic',
    },
    {
      german: "zusammen",
      translated: "formò",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:239|kmr": [
    {
      german: "Durch welche Verträge",
      translated: "bi kîjan peymanan",
      tone: 'semantic',
    },
    {
      german: "schloss sich",
      translated: "tevlî",
      tone: 'semantic',
    },
    {
      german: "die Bundesrepublik Deutschland",
      translated: "Komara Federal",
      tone: 'semantic',
    },
    {
      german: "zur Europäischen Wirtschaftsgemeinschaft",
      translated: "Civata Aborî ya Ewropî",
      tone: 'semantic',
    },
    {
      german: "zusammen",
      translated: "bû",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:239|pl": [
    {
      german: "Durch welche Verträge",
      translated: "Na mocy jakich traktatów",
      tone: 'semantic',
    },
    {
      german: "schloss sich",
      translated: "utworzyła",
      tone: 'semantic',
    },
    {
      german: "die Bundesrepublik Deutschland",
      translated: "Republika Federalna Niemiec",
      tone: 'semantic',
    },
    {
      german: "mit anderen Staaten",
      translated: "wraz z innymi państwami",
      tone: 'semantic',
    },
    {
      german: "zur Europäischen Wirtschaftsgemeinschaft",
      translated: "Europejską Wspólnotę Gospodarczą",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:239|prs": [
    {
      german: "Durch welche Verträge",
      translated: "با کدام پیمان‌ها",
      tone: 'semantic',
    },
    {
      german: "die Bundesrepublik Deutschland",
      translated: "جمهوری فدرال آلمان",
      tone: 'semantic',
    },
    {
      german: "mit anderen Staaten",
      translated: "همراه کشورهای دیگر",
      tone: 'semantic',
    },
    {
      german: "zur Europäischen Wirtschaftsgemeinschaft",
      translated: "جامعهٔ اقتصادی اروپا را",
      tone: 'semantic',
    },
    {
      german: "zusammen",
      translated: "تشکیل داد؟",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:239|ro": [
    {
      german: "Durch welche Verträge",
      translated: "Prin ce tratate",
      tone: 'semantic',
    },
    {
      german: "schloss sich",
      translated: "a format",
      tone: 'semantic',
    },
    {
      german: "die Bundesrepublik Deutschland",
      translated: "Republica Federală Germania",
      tone: 'semantic',
    },
    {
      german: "mit anderen Staaten",
      translated: "cu alte țări",
      tone: 'semantic',
    },
    {
      german: "zur Europäischen Wirtschaftsgemeinschaft",
      translated: "Comunitatea Economică Europeană",
      tone: 'semantic',
    },
    {
      german: "zusammen",
      translated: "împreună",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:239|ru": [
    {
      german: "Durch welche Verträge",
      translated: "На основании каких договоров",
      tone: 'semantic',
    },
    {
      german: "schloss sich",
      translated: "образовала",
      tone: 'semantic',
    },
    {
      german: "die Bundesrepublik Deutschland",
      translated: "ФРГ",
      tone: 'semantic',
    },
    {
      german: "mit anderen Staaten",
      translated: "вместе с другими государствами",
      tone: 'semantic',
    },
    {
      german: "zur Europäischen Wirtschaftsgemeinschaft",
      translated: "Европейское экономическое сообщество",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:239|sq": [
    {
      german: "Durch welche Verträge",
      translated: "Me cilat traktate",
      tone: 'semantic',
    },
    {
      german: "schloss sich",
      translated: "themeloi",
      tone: 'semantic',
    },
    {
      german: "die Bundesrepublik Deutschland",
      translated: "Republika Federale e Gjermanisë",
      tone: 'semantic',
    },
    {
      german: "mit anderen Staaten",
      translated: "bashkë me shtete të tjera",
      tone: 'semantic',
    },
    {
      german: "zur Europäischen Wirtschaftsgemeinschaft",
      translated: "Komunitetin Ekonomik Evropian",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:239|sr": [
    {
      german: "Durch welche Verträge",
      translated: "Kojim je ugovorima",
      tone: 'semantic',
    },
    {
      german: "schloss sich",
      translated: "osnovala",
      tone: 'semantic',
    },
    {
      german: "die Bundesrepublik Deutschland",
      translated: "Savezna Republika Nemačka",
      tone: 'semantic',
    },
    {
      german: "mit anderen Staaten",
      translated: "zajedno s drugim državama",
      tone: 'semantic',
    },
    {
      german: "zur Europäischen Wirtschaftsgemeinschaft",
      translated: "Evropsku ekonomsku zajednicu",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:239|tr": [
    {
      german: "Durch welche Verträge",
      translated: "hangi antlaşmalarla",
      tone: 'semantic',
    },
    {
      german: "schloss sich",
      translated: "kurdu",
      tone: 'semantic',
    },
    {
      german: "die Bundesrepublik Deutschland",
      translated: "Almanya Federal Cumhuriyeti",
      tone: 'semantic',
    },
    {
      german: "mit anderen Staaten",
      translated: "diğer devletlerle birlikte",
      tone: 'semantic',
    },
    {
      german: "zur Europäischen Wirtschaftsgemeinschaft",
      translated: "Avrupa Ekonomik Topluluğunu",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:239|uk": [
    {
      german: "Durch welche Verträge",
      translated: "За допомогою яких договорів",
      tone: 'semantic',
    },
    {
      german: "schloss sich",
      translated: "об’єдналася",
      tone: 'semantic',
    },
    {
      german: "die Bundesrepublik Deutschland",
      translated: "Федеративна Республіка Німеччина",
      tone: 'semantic',
    },
    {
      german: "mit anderen Staaten",
      translated: "з іншими державами",
      tone: 'semantic',
    },
    {
      german: "zur Europäischen Wirtschaftsgemeinschaft",
      translated: "в Європейське економічне співтовариство",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:239|vi": [
    {
      german: "Durch welche Verträge",
      translated: "các hiệp ước nào",
      tone: 'semantic',
    },
    {
      german: "schloss sich",
      translated: "thành lập",
      tone: 'semantic',
    },
    {
      german: "die Bundesrepublik Deutschland",
      translated: "Cộng hòa Liên bang Đức",
      tone: 'semantic',
    },
    {
      german: "mit anderen Staaten",
      translated: "cùng các quốc gia khác",
      tone: 'semantic',
    },
    {
      german: "zur Europäischen Wirtschaftsgemeinschaft",
      translated: "Cộng đồng Kinh tế châu Âu",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:23|ar": [
    {
      german: "In Deutschland",
      translated: "في ألمانيا",
      tone: 'semantic',
    },
    {
      german: "die meisten Erwerbstätigen",
      translated: "معظم العاملين",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:23|bg": [
    {
      german: "In Deutschland",
      translated: "В Германия",
      tone: 'semantic',
    },
    {
      german: "die meisten Erwerbstätigen",
      translated: "повечето работещи хора",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:23|bs": [
    {
      german: "In Deutschland",
      translated: "u Njemačkoj",
      tone: 'semantic',
    },
    {
      german: "die meisten Erwerbstätigen",
      translated: "Većina zaposlenih ljudi",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:23|el": [
    {
      german: "In Deutschland",
      translated: "στη Γερμανία",
      tone: 'semantic',
    },
    {
      german: "die meisten Erwerbstätigen",
      translated: "Οι περισσότεροι εργαζόμενοι",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:23|en": [
    {
      german: "In Deutschland",
      translated: "In Germany",
      tone: 'semantic',
    },
    {
      german: "sind",
      translated: "are",
      tone: 'semantic',
    },
    {
      german: "die meisten Erwerbstätigen",
      translated: "most employed people",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:23|es": [
    {
      german: "In Deutschland",
      translated: "En Alemania",
      tone: 'semantic',
    },
    {
      german: "die meisten Erwerbstätigen",
      translated: "la mayoría de las personas que trabajan",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:23|fa": [
    {
      german: "In Deutschland",
      translated: "در آلمان",
      tone: 'semantic',
    },
    {
      german: "sind",
      translated: "شاغل‌اند",
      tone: 'semantic',
    },
    {
      german: "die meisten Erwerbstätigen",
      translated: "بیشتر افرادی که",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:23|fr": [
    {
      german: "In Deutschland",
      translated: "en Allemagne",
      tone: 'semantic',
    },
    {
      german: "die meisten Erwerbstätigen",
      translated: "La plupart des personnes qui travaillent",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:23|hr": [
    {
      german: "In Deutschland",
      translated: "u Njemačkoj",
      tone: 'semantic',
    },
    {
      german: "die meisten Erwerbstätigen",
      translated: "Većina zaposlenih ljudi",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:23|it": [
    {
      german: "In Deutschland",
      translated: "in Germania",
      tone: 'semantic',
    },
    {
      german: "die meisten Erwerbstätigen",
      translated: "La maggior parte delle persone che lavorano",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:23|kmr": [
    {
      german: "In Deutschland",
      translated: "li Almanyayê",
      tone: 'semantic',
    },
    {
      german: "sind",
      translated: "dixebitin",
      tone: 'semantic',
    },
    {
      german: "die meisten Erwerbstätigen",
      translated: "Piraniya kesên",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:23|pl": [
    {
      german: "In Deutschland",
      translated: "w Niemczech",
      tone: 'semantic',
    },
    {
      german: "die meisten Erwerbstätigen",
      translated: "Większość osób pracujących",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:23|prs": [
    {
      german: "In Deutschland",
      translated: "در آلمان",
      tone: 'semantic',
    },
    {
      german: "sind",
      translated: "شاغل‌اند",
      tone: 'semantic',
    },
    {
      german: "die meisten Erwerbstätigen",
      translated: "بیشتر افرادی",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:23|ro": [
    {
      german: "In Deutschland",
      translated: "În Germania",
      tone: 'semantic',
    },
    {
      german: "die meisten Erwerbstätigen",
      translated: "majoritatea persoanelor active profesional",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:23|ru": [
    {
      german: "In Deutschland",
      translated: "В Германии",
      tone: 'semantic',
    },
    {
      german: "die meisten Erwerbstätigen",
      translated: "большинство работающих людей",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:23|sq": [
    {
      german: "In Deutschland",
      translated: "në Gjermani",
      tone: 'semantic',
    },
    {
      german: "sind",
      translated: "janë",
      tone: 'semantic',
    },
    {
      german: "die meisten Erwerbstätigen",
      translated: "Shumica e njerëzve që punojnë",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:23|sr": [
    {
      german: "In Deutschland",
      translated: "u Nemačkoj",
      tone: 'semantic',
    },
    {
      german: "die meisten Erwerbstätigen",
      translated: "Većina zaposlenih ljudi",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:23|tr": [
    {
      german: "In Deutschland",
      translated: "Almanya'da",
      tone: 'semantic',
    },
    {
      german: "die meisten Erwerbstätigen",
      translated: "çalışan insanların çoğu",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:23|uk": [
    {
      german: "In Deutschland",
      translated: "у Німеччині",
      tone: 'semantic',
    },
    {
      german: "die meisten Erwerbstätigen",
      translated: "Більшість працівників",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:23|vi": [
    {
      german: "In Deutschland",
      translated: "ở Đức",
      tone: 'semantic',
    },
    {
      german: "die meisten Erwerbstätigen",
      translated: "Phần lớn người đang làm việc",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:240|ar": [
    {
      german: "Seit wann",
      translated: "منذ متى",
      tone: 'semantic',
    },
    {
      german: "bezahlt man",
      translated: "يُستخدم",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "في ألمانيا",
      tone: 'semantic',
    },
    {
      german: "mit dem Euro",
      translated: "اليورو",
      tone: 'semantic',
    },
    {
      german: "in bar",
      translated: "نقدًا",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:240|bg": [
    {
      german: "Seit wann",
      translated: "От коя година",
      tone: 'semantic',
    },
    {
      german: "bezahlt man",
      translated: "се плаща",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "в Германия",
      tone: 'semantic',
    },
    {
      german: "mit dem Euro",
      translated: "с евро",
      tone: 'semantic',
    },
    {
      german: "in bar",
      translated: "в брой",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:240|bs": [
    {
      german: "Seit wann",
      translated: "Od koje se godine",
      tone: 'semantic',
    },
    {
      german: "bezahlt man",
      translated: "plaća",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "u Njemačkoj",
      tone: 'semantic',
    },
    {
      german: "mit dem Euro",
      translated: "u eurima",
      tone: 'semantic',
    },
    {
      german: "in bar",
      translated: "gotovinom",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:240|el": [
    {
      german: "Seit wann",
      translated: "Από ποιο έτος",
      tone: 'semantic',
    },
    {
      german: "bezahlt man",
      translated: "πληρώνει κανείς",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "στη Γερμανία",
      tone: 'semantic',
    },
    {
      german: "mit dem Euro",
      translated: "σε ευρώ",
      tone: 'semantic',
    },
    {
      german: "in bar",
      translated: "με μετρητά",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:240|en": [
    {
      german: "Seit wann",
      translated: "Since when",
      tone: 'semantic',
    },
    {
      german: "bezahlt man",
      translated: "have people",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "in Germany",
      tone: 'semantic',
    },
    {
      german: "mit dem Euro",
      translated: "with the euro",
      tone: 'semantic',
    },
    {
      german: "in bar",
      translated: "in cash",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:240|es": [
    {
      german: "Seit wann",
      translated: "Desde cuándo",
      tone: 'semantic',
    },
    {
      german: "bezahlt man",
      translated: "se utiliza",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "en Alemania",
      tone: 'semantic',
    },
    {
      german: "mit dem Euro",
      translated: "el euro",
      tone: 'semantic',
    },
    {
      german: "in bar",
      translated: "en efectivo",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:240|fa": [
    {
      german: "Seit wann",
      translated: "از چه زمانی",
      tone: 'semantic',
    },
    {
      german: "bezahlt man",
      translated: "پرداخت",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "در آلمان",
      tone: 'semantic',
    },
    {
      german: "mit dem Euro",
      translated: "با یورو",
      tone: 'semantic',
    },
    {
      german: "in bar",
      translated: "انجام می‌شود؟",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:240|fr": [
    {
      german: "Seit wann",
      translated: "Depuis quand",
      tone: 'semantic',
    },
    {
      german: "bezahlt man",
      translated: "paie-t-on",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "en Allemagne",
      tone: 'semantic',
    },
    {
      german: "mit dem Euro",
      translated: "avec l’euro",
      tone: 'semantic',
    },
    {
      german: "in bar",
      translated: "en espèces",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:240|hr": [
    {
      german: "Seit wann",
      translated: "Od koje",
      tone: 'semantic',
    },
    {
      german: "bezahlt man",
      translated: "plaća",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "u Njemačkoj",
      tone: 'semantic',
    },
    {
      german: "mit dem Euro",
      translated: "u eurima",
      tone: 'semantic',
    },
    {
      german: "in bar",
      translated: "gotovinom",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:240|it": [
    {
      german: "Seit wann",
      translated: "Da quale anno",
      tone: 'semantic',
    },
    {
      german: "bezahlt man",
      translated: "si paga",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "in Germania",
      tone: 'semantic',
    },
    {
      german: "mit dem Euro",
      translated: "con l’euro",
      tone: 'semantic',
    },
    {
      german: "in bar",
      translated: "in contanti",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:240|kmr": [
    {
      german: "Seit wann",
      translated: "Ji kîjan",
      tone: 'semantic',
    },
    {
      german: "bezahlt man",
      translated: "salê ve",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "li Almanyayê",
      tone: 'semantic',
    },
    {
      german: "mit dem Euro",
      translated: "euro",
      tone: 'semantic',
    },
    {
      german: "in bar",
      translated: "bi pereya destan tê bikaranîn",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:240|pl": [
    {
      german: "Seit wann",
      translated: "Od którego roku",
      tone: 'semantic',
    },
    {
      german: "bezahlt man",
      translated: "płaci się",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "w Niemczech",
      tone: 'semantic',
    },
    {
      german: "mit dem Euro",
      translated: "w euro",
      tone: 'semantic',
    },
    {
      german: "in bar",
      translated: "gotówką",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:240|prs": [
    {
      german: "Seit wann",
      translated: "از چه زمانی",
      tone: 'semantic',
    },
    {
      german: "bezahlt man",
      translated: "انجام می‌شود",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "در آلمان",
      tone: 'semantic',
    },
    {
      german: "mit dem Euro",
      translated: "با یورو",
      tone: 'semantic',
    },
    {
      german: "in bar",
      translated: "پرداخت نقدی",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:240|ro": [
    {
      german: "Seit wann",
      translated: "Din ce",
      tone: 'semantic',
    },
    {
      german: "bezahlt man",
      translated: "an se plătește",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "în Germania",
      tone: 'semantic',
    },
    {
      german: "mit dem Euro",
      translated: "cu euro",
      tone: 'semantic',
    },
    {
      german: "in bar",
      translated: "în numerar",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:240|ru": [
    {
      german: "Seit wann",
      translated: "С какого года",
      tone: 'semantic',
    },
    {
      german: "bezahlt man",
      translated: "расплачиваются",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "в Германии",
      tone: 'semantic',
    },
    {
      german: "mit dem Euro",
      translated: "евро",
      tone: 'semantic',
    },
    {
      german: "in bar",
      translated: "наличными",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:240|sq": [
    {
      german: "Seit wann",
      translated: "Që nga cili vit",
      tone: 'semantic',
    },
    {
      german: "bezahlt man",
      translated: "paguhet me para në dorë",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "në Gjermani",
      tone: 'semantic',
    },
    {
      german: "mit dem Euro",
      translated: "në euro",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:240|sr": [
    {
      german: "Seit wann",
      translated: "Od koje se godine",
      tone: 'semantic',
    },
    {
      german: "bezahlt man",
      translated: "plaća",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "u Nemačkoj",
      tone: 'semantic',
    },
    {
      german: "mit dem Euro",
      translated: "u evrima",
      tone: 'semantic',
    },
    {
      german: "in bar",
      translated: "gotovinom",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:240|tr": [
    {
      german: "Seit wann",
      translated: "ne zamandan beri",
      tone: 'semantic',
    },
    {
      german: "bezahlt man",
      translated: "ödeme yapılıyor",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "Almanya'da",
      tone: 'semantic',
    },
    {
      german: "mit dem Euro",
      translated: "Euro banknot ve madeni paralarıyla",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:240|uk": [
    {
      german: "Seit wann",
      translated: "З якого року",
      tone: 'semantic',
    },
    {
      german: "bezahlt man",
      translated: "розраховуються",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "в Німеччині",
      tone: 'semantic',
    },
    {
      german: "mit dem Euro",
      translated: "євро",
      tone: 'semantic',
    },
    {
      german: "in bar",
      translated: "готівковими",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:240|vi": [
    {
      german: "Seit wann",
      translated: "Từ năm nào",
      tone: 'semantic',
    },
    {
      german: "bezahlt man",
      translated: "sử dụng",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "ở Đức",
      tone: 'semantic',
    },
    {
      german: "mit dem Euro",
      translated: "euro",
      tone: 'semantic',
    },
    {
      german: "in bar",
      translated: "tiền mặt",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:241|ar": [
    {
      german: "Frau Seger",
      translated: "السيدة زيغر",
      tone: 'semantic',
    },
    {
      german: "bekommt",
      translated: "ستُنجب",
      tone: 'semantic',
    },
    {
      german: "ein Kind",
      translated: "طفلًا",
      tone: 'semantic',
    },
    {
      german: "Was",
      translated: "ماذا",
      tone: 'semantic',
    },
    {
      german: "muss sie tun",
      translated: "يجب أن تفعل",
      tone: 'semantic',
    },
    {
      german: "um Elterngeld zu erhalten",
      translated: "للحصول على بدل الوالدين (Elterngeld)",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:241|bg": [
    {
      german: "Frau Seger",
      translated: "Г-жа Зегер",
      tone: 'semantic',
    },
    {
      german: "bekommt",
      translated: "очаква",
      tone: 'semantic',
    },
    {
      german: "ein Kind",
      translated: "дете",
      tone: 'semantic',
    },
    {
      german: "Was",
      translated: "Какво",
      tone: 'semantic',
    },
    {
      german: "muss sie tun",
      translated: "трябва да направи",
      tone: 'semantic',
    },
    {
      german: "um Elterngeld zu erhalten",
      translated: "за да получава родителски помощи (Elterngeld)",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:241|bs": [
    {
      german: "Frau Seger",
      translated: "Gospođa Seger",
      tone: 'semantic',
    },
    {
      german: "bekommt",
      translated: "očekuje",
      tone: 'semantic',
    },
    {
      german: "ein Kind",
      translated: "dijete",
      tone: 'semantic',
    },
    {
      german: "Was",
      translated: "Što",
      tone: 'semantic',
    },
    {
      german: "muss sie tun",
      translated: "mora učiniti",
      tone: 'semantic',
    },
    {
      german: "um Elterngeld zu erhalten",
      translated: "kako bi primala roditeljsku naknadu (Elterngeld)",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:241|el": [
    {
      german: "Frau Seger",
      translated: "Η κυρία Seger",
      tone: 'semantic',
    },
    {
      german: "bekommt",
      translated: "περιμένει",
      tone: 'semantic',
    },
    {
      german: "ein Kind",
      translated: "παιδί",
      tone: 'semantic',
    },
    {
      german: "Was",
      translated: "Τι",
      tone: 'semantic',
    },
    {
      german: "muss sie tun",
      translated: "πρέπει να κάνει",
      tone: 'semantic',
    },
    {
      german: "um Elterngeld zu erhalten",
      translated: "για να λάβει γονικό επίδομα (Elterngeld);",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:241|en": [
    {
      german: "Frau Seger",
      translated: "Mrs. Seger",
      tone: 'semantic',
    },
    {
      german: "bekommt",
      translated: "is having",
      tone: 'semantic',
    },
    {
      german: "ein Kind",
      translated: "a child",
      tone: 'semantic',
    },
    {
      german: "Was",
      translated: "What",
      tone: 'semantic',
    },
    {
      german: "muss sie tun",
      translated: "must she do",
      tone: 'semantic',
    },
    {
      german: "um Elterngeld zu erhalten",
      translated: "to receive parental allowance",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:241|es": [
    {
      german: "Frau Seger",
      translated: "La señora Seger",
      tone: 'semantic',
    },
    {
      german: "bekommt",
      translated: "va a tener",
      tone: 'semantic',
    },
    {
      german: "ein Kind",
      translated: "un hijo",
      tone: 'semantic',
    },
    {
      german: "Was",
      translated: "¿Qué",
      tone: 'semantic',
    },
    {
      german: "muss sie tun",
      translated: "debe hacer",
      tone: 'semantic',
    },
    {
      german: "um Elterngeld zu erhalten",
      translated: "para recibir la prestación parental (Elterngeld)",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:241|fa": [
    {
      german: "Frau Seger",
      translated: "خانم زِگر",
      tone: 'semantic',
    },
    {
      german: "bekommt",
      translated: "در انتظار",
      tone: 'semantic',
    },
    {
      german: "ein Kind",
      translated: "تولد فرزند",
      tone: 'semantic',
    },
    {
      german: "Was",
      translated: "برای",
      tone: 'semantic',
    },
    {
      german: "muss sie tun",
      translated: "چه باید بکند",
      tone: 'semantic',
    },
    {
      german: "um Elterngeld zu erhalten",
      translated: "کمک‌هزینهٔ والدین (Elterngeld)",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:241|fr": [
    {
      german: "Frau Seger",
      translated: "Mme Seger",
      tone: 'semantic',
    },
    {
      german: "bekommt",
      translated: "va avoir",
      tone: 'semantic',
    },
    {
      german: "ein Kind",
      translated: "un enfant",
      tone: 'semantic',
    },
    {
      german: "Was",
      translated: "Que",
      tone: 'semantic',
    },
    {
      german: "muss sie tun",
      translated: "doit-elle faire",
      tone: 'semantic',
    },
    {
      german: "um Elterngeld zu erhalten",
      translated: "pour recevoir l’allocation parentale (Elterngeld) ",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:241|hr": [
    {
      german: "Frau Seger",
      translated: "Gospođa Seger",
      tone: 'semantic',
    },
    {
      german: "bekommt",
      translated: "očekuje",
      tone: 'semantic',
    },
    {
      german: "ein Kind",
      translated: "dijete",
      tone: 'semantic',
    },
    {
      german: "Was",
      translated: "Što",
      tone: 'semantic',
    },
    {
      german: "muss sie tun",
      translated: "mora učiniti",
      tone: 'semantic',
    },
    {
      german: "um Elterngeld zu erhalten",
      translated: "kako bi primala roditeljsku naknadu (Elterngeld)",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:241|it": [
    {
      german: "Frau Seger",
      translated: "La signora Seger",
      tone: 'semantic',
    },
    {
      german: "bekommt",
      translated: "aspetta",
      tone: 'semantic',
    },
    {
      german: "ein Kind",
      translated: "un bambino",
      tone: 'semantic',
    },
    {
      german: "Was",
      translated: "Che cosa",
      tone: 'semantic',
    },
    {
      german: "muss sie tun",
      translated: "deve fare",
      tone: 'semantic',
    },
    {
      german: "um Elterngeld zu erhalten",
      translated: "per ricevere l’indennità parentale (Elterngeld)",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:241|kmr": [
    {
      german: "Frau Seger",
      translated: "Xanim Seger",
      tone: 'semantic',
    },
    {
      german: "bekommt",
      translated: "tîne dinyayê",
      tone: 'semantic',
    },
    {
      german: "ein Kind",
      translated: "zarokek",
      tone: 'semantic',
    },
    {
      german: "Was",
      translated: "çi",
      tone: 'semantic',
    },
    {
      german: "muss sie tun",
      translated: "divê bike",
      tone: 'semantic',
    },
    {
      german: "um Elterngeld zu erhalten",
      translated: "Ji bo Elterngeld",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:241|pl": [
    {
      german: "Frau Seger",
      translated: "Pani Seger",
      tone: 'semantic',
    },
    {
      german: "bekommt",
      translated: "spodziewa się",
      tone: 'semantic',
    },
    {
      german: "ein Kind",
      translated: "dziecka",
      tone: 'semantic',
    },
    {
      german: "Was",
      translated: "Co",
      tone: 'semantic',
    },
    {
      german: "muss sie tun",
      translated: "musi zrobić",
      tone: 'semantic',
    },
    {
      german: "um Elterngeld zu erhalten",
      translated: "aby otrzymywać zasiłek rodzicielski (Elterngeld)",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:241|prs": [
    {
      german: "Frau Seger",
      translated: "خانم زِگر",
      tone: 'semantic',
    },
    {
      german: "bekommt",
      translated: "در انتظار تولد",
      tone: 'semantic',
    },
    {
      german: "ein Kind",
      translated: "فرزند",
      tone: 'semantic',
    },
    {
      german: "Was",
      translated: "چه",
      tone: 'semantic',
    },
    {
      german: "muss sie tun",
      translated: "باید بکند",
      tone: 'semantic',
    },
    {
      german: "um Elterngeld zu erhalten",
      translated: "برای دریافت کمک‌هزینهٔ والدین (Elterngeld)",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:241|ro": [
    {
      german: "Frau Seger",
      translated: "Doamna Seger",
      tone: 'semantic',
    },
    {
      german: "bekommt",
      translated: "așteaptă",
      tone: 'semantic',
    },
    {
      german: "ein Kind",
      translated: "un copil",
      tone: 'semantic',
    },
    {
      german: "Was",
      translated: "Ce",
      tone: 'semantic',
    },
    {
      german: "muss sie tun",
      translated: "trebuie să facă",
      tone: 'semantic',
    },
    {
      german: "um Elterngeld zu erhalten",
      translated: "pentru a primi indemnizația parentală (Elterngeld)",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:241|ru": [
    {
      german: "Frau Seger",
      translated: "У госпожи Зегер",
      tone: 'semantic',
    },
    {
      german: "bekommt",
      translated: "рождается",
      tone: 'semantic',
    },
    {
      german: "ein Kind",
      translated: "ребёнок",
      tone: 'semantic',
    },
    {
      german: "Was",
      translated: "Что",
      tone: 'semantic',
    },
    {
      german: "muss sie tun",
      translated: "она должна сделать",
      tone: 'semantic',
    },
    {
      german: "um Elterngeld zu erhalten",
      translated: "чтобы получать родительское пособие",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:241|sq": [
    {
      german: "Frau Seger",
      translated: "Zonja Seger",
      tone: 'semantic',
    },
    {
      german: "bekommt",
      translated: "pret",
      tone: 'semantic',
    },
    {
      german: "ein Kind",
      translated: "një fëmijë",
      tone: 'semantic',
    },
    {
      german: "Was",
      translated: "Çfarë",
      tone: 'semantic',
    },
    {
      german: "muss sie tun",
      translated: "duhet të bëjë",
      tone: 'semantic',
    },
    {
      german: "um Elterngeld zu erhalten",
      translated: "për të marrë Elterngeld?",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:241|sr": [
    {
      german: "Frau Seger",
      translated: "Gospođa Seger",
      tone: 'semantic',
    },
    {
      german: "bekommt",
      translated: "očekuje",
      tone: 'semantic',
    },
    {
      german: "ein Kind",
      translated: "dete",
      tone: 'semantic',
    },
    {
      german: "Was",
      translated: "Šta",
      tone: 'semantic',
    },
    {
      german: "muss sie tun",
      translated: "mora da uradi",
      tone: 'semantic',
    },
    {
      german: "um Elterngeld zu erhalten",
      translated: "kako bi primala roditeljsku naknadu (Elterngeld)",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:241|tr": [
    {
      german: "Frau Seger",
      translated: "Bayan Seger'in",
      tone: 'semantic',
    },
    {
      german: "bekommt",
      translated: "oluyor",
      tone: 'semantic',
    },
    {
      german: "ein Kind",
      translated: "bir çocuğu",
      tone: 'semantic',
    },
    {
      german: "Was",
      translated: "ne",
      tone: 'semantic',
    },
    {
      german: "muss sie tun",
      translated: "yapmalıdır",
      tone: 'semantic',
    },
    {
      german: "um Elterngeld zu erhalten",
      translated: "Ebeveyn parası (Elterngeld) alabilmek için",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:241|uk": [
    {
      german: "Frau Seger",
      translated: "Пані Зегер",
      tone: 'semantic',
    },
    {
      german: "bekommt",
      translated: "народжує",
      tone: 'semantic',
    },
    {
      german: "ein Kind",
      translated: "дитину",
      tone: 'semantic',
    },
    {
      german: "Was",
      translated: "Що",
      tone: 'semantic',
    },
    {
      german: "muss sie tun",
      translated: "вона повинна зробити",
      tone: 'semantic',
    },
    {
      german: "um Elterngeld zu erhalten",
      translated: "щоб отримувати батьківську допомогу (Elterngeld)",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:241|vi": [
    {
      german: "Frau Seger",
      translated: "Bà Seger",
      tone: 'semantic',
    },
    {
      german: "bekommt",
      translated: "đang mang thai",
      tone: 'semantic',
    },
    {
      german: "muss sie tun",
      translated: "phải làm gì",
      tone: 'semantic',
    },
    {
      german: "um Elterngeld zu erhalten",
      translated: "để nhận trợ cấp cha mẹ (Elterngeld)",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:242|ar": [
    {
      german: "Wer",
      translated: "من",
      tone: 'semantic',
    },
    {
      german: "entscheidet",
      translated: "يقرر",
      tone: 'semantic',
    },
    {
      german: "ob",
      translated: "ما إذا",
      tone: 'semantic',
    },
    {
      german: "ein Kind",
      translated: "الطفل",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "في ألمانيا",
      tone: 'semantic',
    },
    {
      german: "in den Kindergarten",
      translated: "إلى روضة الأطفال",
      tone: 'semantic',
    },
    {
      german: "geht",
      translated: "يذهب",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:242|bg": [
    {
      german: "Wer",
      translated: "Кой",
      tone: 'semantic',
    },
    {
      german: "entscheidet",
      translated: "решава",
      tone: 'semantic',
    },
    {
      german: "ob",
      translated: "дали",
      tone: 'semantic',
    },
    {
      german: "ein Kind",
      translated: "едно дете",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "в Германия",
      tone: 'semantic',
    },
    {
      german: "in den Kindergarten",
      translated: "детска градина",
      tone: 'semantic',
    },
    {
      german: "geht",
      translated: "посещава",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:242|bs": [
    {
      german: "Wer",
      translated: "Tko",
      tone: 'semantic',
    },
    {
      german: "entscheidet",
      translated: "odlučuje",
      tone: 'semantic',
    },
    {
      german: "ob",
      translated: "hoće li",
      tone: 'semantic',
    },
    {
      german: "ein Kind",
      translated: "dijete",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "u Njemačkoj",
      tone: 'semantic',
    },
    {
      german: "in den Kindergarten",
      translated: "u dječji vrtić",
      tone: 'semantic',
    },
    {
      german: "geht",
      translated: "ići",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:242|el": [
    {
      german: "Wer",
      translated: "Ποιος",
      tone: 'semantic',
    },
    {
      german: "entscheidet",
      translated: "αποφασίζει",
      tone: 'semantic',
    },
    {
      german: "ob",
      translated: "αν",
      tone: 'semantic',
    },
    {
      german: "ein Kind",
      translated: "ένα παιδί",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "στη Γερμανία",
      tone: 'semantic',
    },
    {
      german: "in den Kindergarten",
      translated: "σε παιδικό σταθμό",
      tone: 'semantic',
    },
    {
      german: "geht",
      translated: "θα πάει",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:242|en": [
    {
      german: "Wer",
      translated: "Who",
      tone: 'semantic',
    },
    {
      german: "entscheidet",
      translated: "decides",
      tone: 'semantic',
    },
    {
      german: "ob",
      translated: "whether",
      tone: 'semantic',
    },
    {
      german: "ein Kind",
      translated: "a child",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "in Germany",
      tone: 'semantic',
    },
    {
      german: "in den Kindergarten",
      translated: "to kindergarten",
      tone: 'semantic',
    },
    {
      german: "geht",
      translated: "goes",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:242|es": [
    {
      german: "Wer",
      translated: "Quién",
      tone: 'semantic',
    },
    {
      german: "entscheidet",
      translated: "decide",
      tone: 'semantic',
    },
    {
      german: "ob",
      translated: "si",
      tone: 'semantic',
    },
    {
      german: "ein Kind",
      translated: "un niño",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "en Alemania",
      tone: 'semantic',
    },
    {
      german: "in den Kindergarten",
      translated: "a la guardería",
      tone: 'semantic',
    },
    {
      german: "geht",
      translated: "va",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:242|fa": [
    {
      german: "Wer",
      translated: "چه کسی",
      tone: 'semantic',
    },
    {
      german: "entscheidet",
      translated: "تصمیم می‌گیرد",
      tone: 'semantic',
    },
    {
      german: "ein Kind",
      translated: "یک کودک",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "در آلمان",
      tone: 'semantic',
    },
    {
      german: "in den Kindergarten",
      translated: "به مهدکودک",
      tone: 'semantic',
    },
    {
      german: "geht",
      translated: "برود؟",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:242|fr": [
    {
      german: "Wer",
      translated: "Qui",
      tone: 'semantic',
    },
    {
      german: "entscheidet",
      translated: "décide",
      tone: 'semantic',
    },
    {
      german: "ob",
      translated: "si",
      tone: 'semantic',
    },
    {
      german: "ein Kind",
      translated: "un enfant",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "en Allemagne",
      tone: 'semantic',
    },
    {
      german: "in den Kindergarten",
      translated: "au jardin d’enfants",
      tone: 'semantic',
    },
    {
      german: "geht",
      translated: "va",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:242|hr": [
    {
      german: "Wer",
      translated: "Tko",
      tone: 'semantic',
    },
    {
      german: "entscheidet",
      translated: "odlučuje",
      tone: 'semantic',
    },
    {
      german: "ob",
      translated: "hoće li",
      tone: 'semantic',
    },
    {
      german: "ein Kind",
      translated: "dijete",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "u Njemačkoj",
      tone: 'semantic',
    },
    {
      german: "in den Kindergarten",
      translated: "u dječji vrtić",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:242|it": [
    {
      german: "Wer",
      translated: "Chi",
      tone: 'semantic',
    },
    {
      german: "entscheidet",
      translated: "decide",
      tone: 'semantic',
    },
    {
      german: "ob",
      translated: "se",
      tone: 'semantic',
    },
    {
      german: "ein Kind",
      translated: "un bambino",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "in Germania",
      tone: 'semantic',
    },
    {
      german: "in den Kindergarten",
      translated: "all’asilo",
      tone: 'semantic',
    },
    {
      german: "geht",
      translated: "va",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:242|kmr": [
    {
      german: "Wer",
      translated: "Kî",
      tone: 'semantic',
    },
    {
      german: "entscheidet",
      translated: "dide",
      tone: 'semantic',
    },
    {
      german: "ob",
      translated: "ka",
      tone: 'semantic',
    },
    {
      german: "ein Kind",
      translated: "zarok",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "li Almanyayê",
      tone: 'semantic',
    },
    {
      german: "in den Kindergarten",
      translated: "biçe baxçeyê",
      tone: 'semantic',
    },
    {
      german: "geht",
      translated: "zarokan",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:242|pl": [
    {
      german: "Wer",
      translated: "Kto",
      tone: 'semantic',
    },
    {
      german: "entscheidet",
      translated: "decyduje",
      tone: 'semantic',
    },
    {
      german: "ob",
      translated: "czy",
      tone: 'semantic',
    },
    {
      german: "ein Kind",
      translated: "dziecko",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "Niemczech",
      tone: 'semantic',
    },
    {
      german: "in den Kindergarten",
      translated: "do przedszkola",
      tone: 'semantic',
    },
    {
      german: "geht",
      translated: "chodzi",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:242|prs": [
    {
      german: "Wer",
      translated: "چه کسی",
      tone: 'semantic',
    },
    {
      german: "entscheidet",
      translated: "تصمیم می‌گیرد",
      tone: 'semantic',
    },
    {
      german: "ein Kind",
      translated: "یک کودک",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "در آلمان",
      tone: 'semantic',
    },
    {
      german: "in den Kindergarten",
      translated: "به کودکستان",
      tone: 'semantic',
    },
    {
      german: "geht",
      translated: "برود",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:242|ro": [
    {
      german: "Wer",
      translated: "Cine",
      tone: 'semantic',
    },
    {
      german: "entscheidet",
      translated: "decide",
      tone: 'semantic',
    },
    {
      german: "ob",
      translated: "dacă",
      tone: 'semantic',
    },
    {
      german: "ein Kind",
      translated: "un copil",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "în Germania",
      tone: 'semantic',
    },
    {
      german: "in den Kindergarten",
      translated: "la grădiniță",
      tone: 'semantic',
    },
    {
      german: "geht",
      translated: "merge",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:242|ru": [
    {
      german: "Wer",
      translated: "Кто",
      tone: 'semantic',
    },
    {
      german: "entscheidet",
      translated: "решает",
      tone: 'semantic',
    },
    {
      german: "ob",
      translated: "будет ли",
      tone: 'semantic',
    },
    {
      german: "ein Kind",
      translated: "ребёнок",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "в Германии",
      tone: 'semantic',
    },
    {
      german: "in den Kindergarten",
      translated: "детский сад",
      tone: 'semantic',
    },
    {
      german: "geht",
      translated: "посещать",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:242|sq": [
    {
      german: "Wer",
      translated: "Kush",
      tone: 'semantic',
    },
    {
      german: "entscheidet",
      translated: "vendos",
      tone: 'semantic',
    },
    {
      german: "ob",
      translated: "nëse",
      tone: 'semantic',
    },
    {
      german: "ein Kind",
      translated: "një fëmijë",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "në Gjermani",
      tone: 'semantic',
    },
    {
      german: "in den Kindergarten",
      translated: "në kopsht",
      tone: 'semantic',
    },
    {
      german: "geht",
      translated: "shkon",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:242|sr": [
    {
      german: "Wer",
      translated: "Ko",
      tone: 'semantic',
    },
    {
      german: "entscheidet",
      translated: "odlučuje",
      tone: 'semantic',
    },
    {
      german: "ob",
      translated: "da li",
      tone: 'semantic',
    },
    {
      german: "ein Kind",
      translated: "dete",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "u Nemačkoj",
      tone: 'semantic',
    },
    {
      german: "in den Kindergarten",
      translated: "u dečji vrtić",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:242|tr": [
    {
      german: "Wer",
      translated: "kim",
      tone: 'semantic',
    },
    {
      german: "entscheidet",
      translated: "karar verir",
      tone: 'semantic',
    },
    {
      german: "ein Kind",
      translated: "bir çocuğun",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "Almanya'da",
      tone: 'semantic',
    },
    {
      german: "in den Kindergarten",
      translated: "anaokuluna",
      tone: 'semantic',
    },
    {
      german: "geht",
      translated: "gidip gitmeyeceğine",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:242|uk": [
    {
      german: "Wer",
      translated: "Хто",
      tone: 'semantic',
    },
    {
      german: "entscheidet",
      translated: " вирішує",
      tone: 'semantic',
    },
    {
      german: "ob",
      translated: "чи",
      tone: 'semantic',
    },
    {
      german: "ein Kind",
      translated: "дитина",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "в Німеччині",
      tone: 'semantic',
    },
    {
      german: "in den Kindergarten",
      translated: "до дитячого садка",
      tone: 'semantic',
    },
    {
      german: "geht",
      translated: "ходитиме",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:242|vi": [
    {
      german: "Wer",
      translated: "Ai",
      tone: 'semantic',
    },
    {
      german: "entscheidet",
      translated: "quyết định",
      tone: 'semantic',
    },
    {
      german: "ob",
      translated: "có",
      tone: 'semantic',
    },
    {
      german: "ein Kind",
      translated: "một đứa trẻ",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "ở Đức",
      tone: 'semantic',
    },
    {
      german: "in den Kindergarten",
      translated: "nhà trẻ",
      tone: 'semantic',
    },
    {
      german: "geht",
      translated: "đi",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:243|ar": [
    {
      german: "Maik und Sybille",
      translated: "مايك وسيبيله",
      tone: 'semantic',
    },
    {
      german: "mit Freunden",
      translated: "مع أصدقائهما",
      tone: 'semantic',
    },
    {
      german: "an ihrem deutschen Wohnort",
      translated: "في مكان سكنهما بألمانيا",
      tone: 'semantic',
    },
    {
      german: "eine Demonstration",
      translated: "مظاهرة",
      tone: 'semantic',
    },
    {
      german: "auf der Straße",
      translated: "في الشارع",
      tone: 'semantic',
    },
    {
      german: "abhalten",
      translated: "تنظيم",
      tone: 'semantic',
    },
    {
      german: "Was müssen sie",
      translated: "ماذا يجب عليهما",
      tone: 'semantic',
    },
    {
      german: "vorher",
      translated: "مسبقًا",
      tone: 'semantic',
    },
    {
      german: "tun",
      translated: "يفعلا",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:243|bg": [
    {
      german: "Maik und Sybille",
      translated: "Майк и Сибиле",
      tone: 'semantic',
    },
    {
      german: "wollen",
      translated: "искат",
      tone: 'semantic',
    },
    {
      german: "mit Freunden",
      translated: "с приятели",
      tone: 'semantic',
    },
    {
      german: "an ihrem deutschen Wohnort",
      translated: "по местоживеенето си в Германия",
      tone: 'semantic',
    },
    {
      german: "eine Demonstration",
      translated: "демонстрация",
      tone: 'semantic',
    },
    {
      german: "auf der Straße",
      translated: "на улицата",
      tone: 'semantic',
    },
    {
      german: "abhalten",
      translated: "да проведат",
      tone: 'semantic',
    },
    {
      german: "Was müssen sie",
      translated: "Какво трябва да направят",
      tone: 'semantic',
    },
    {
      german: "vorher",
      translated: "предварително",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:243|bs": [
    {
      german: "Maik und Sybille",
      translated: "Maik i Sybille",
      tone: 'semantic',
    },
    {
      german: "wollen",
      translated: "žele",
      tone: 'semantic',
    },
    {
      german: "mit Freunden",
      translated: "s prijateljima",
      tone: 'semantic',
    },
    {
      german: "an ihrem deutschen Wohnort",
      translated: "u svom mjestu stanovanja u Njemačkoj",
      tone: 'semantic',
    },
    {
      german: "eine Demonstration",
      translated: "demonstraciju",
      tone: 'semantic',
    },
    {
      german: "auf der Straße",
      translated: "na ulici",
      tone: 'semantic',
    },
    {
      german: "abhalten",
      translated: "održati",
      tone: 'semantic',
    },
    {
      german: "Was müssen sie",
      translated: "Što moraju",
      tone: 'semantic',
    },
    {
      german: "vorher",
      translated: "prethodno",
      tone: 'semantic',
    },
    {
      german: "tun",
      translated: "učiniti",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:243|el": [
    {
      german: "Maik und Sybille",
      translated: "Ο Maik και η Sybille",
      tone: 'semantic',
    },
    {
      german: "wollen",
      translated: "θέλουν",
      tone: 'semantic',
    },
    {
      german: "mit Freunden",
      translated: "με φίλους",
      tone: 'semantic',
    },
    {
      german: "an ihrem deutschen Wohnort",
      translated: "στον γερμανικό τόπο κατοικίας τους",
      tone: 'semantic',
    },
    {
      german: "eine Demonstration",
      translated: "μια διαδήλωση",
      tone: 'semantic',
    },
    {
      german: "auf der Straße",
      translated: "στον δρόμο",
      tone: 'semantic',
    },
    {
      german: "abhalten",
      translated: "να οργανώσουν",
      tone: 'semantic',
    },
    {
      german: "Was müssen sie",
      translated: "Τι πρέπει να κάνουν",
      tone: 'semantic',
    },
    {
      german: "vorher",
      translated: "προηγουμένως",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:243|en": [
    {
      german: "Maik und Sybille",
      translated: "Maik and Sybille",
      tone: 'semantic',
    },
    {
      german: "wollen",
      translated: "want to",
      tone: 'semantic',
    },
    {
      german: "mit Freunden",
      translated: "with friends",
      tone: 'semantic',
    },
    {
      german: "an ihrem deutschen Wohnort",
      translated: "at their German residence",
      tone: 'semantic',
    },
    {
      german: "eine Demonstration",
      translated: "demonstration",
      tone: 'semantic',
    },
    {
      german: "auf der Straße",
      translated: "street",
      tone: 'semantic',
    },
    {
      german: "abhalten",
      translated: "hold",
      tone: 'semantic',
    },
    {
      german: "Was müssen sie",
      translated: "What must they",
      tone: 'semantic',
    },
    {
      german: "vorher",
      translated: "beforehand",
      tone: 'semantic',
    },
    {
      german: "tun",
      translated: "do",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:243|es": [
    {
      german: "Maik und Sybille",
      translated: "Maik y Sybille",
      tone: 'semantic',
    },
    {
      german: "wollen",
      translated: "quieren",
      tone: 'semantic',
    },
    {
      german: "mit Freunden",
      translated: "con amigos",
      tone: 'semantic',
    },
    {
      german: "an ihrem deutschen Wohnort",
      translated: "en su lugar de residencia en Alemania",
      tone: 'semantic',
    },
    {
      german: "eine Demonstration",
      translated: "una manifestación",
      tone: 'semantic',
    },
    {
      german: "auf der Straße",
      translated: "en la calle",
      tone: 'semantic',
    },
    {
      german: "abhalten",
      translated: "organizar",
      tone: 'semantic',
    },
    {
      german: "Was müssen sie",
      translated: "¿Qué deben",
      tone: 'semantic',
    },
    {
      german: "vorher",
      translated: "previamente",
      tone: 'semantic',
    },
    {
      german: "tun",
      translated: "hacer",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:243|fa": [
    {
      german: "Maik und Sybille",
      translated: "مایک و زیبیله",
      tone: 'semantic',
    },
    {
      german: "wollen",
      translated: "می‌خواهند",
      tone: 'semantic',
    },
    {
      german: "mit Freunden",
      translated: "همراه دوستانشان",
      tone: 'semantic',
    },
    {
      german: "an ihrem deutschen Wohnort",
      translated: "محل زندگی خود در آلمان",
      tone: 'semantic',
    },
    {
      german: "eine Demonstration",
      translated: "تظاهراتی",
      tone: 'semantic',
    },
    {
      german: "auf der Straße",
      translated: "در خیابان",
      tone: 'semantic',
    },
    {
      german: "abhalten",
      translated: "برگزار کنند",
      tone: 'semantic',
    },
    {
      german: "vorher",
      translated: "پیش از آن",
      tone: 'semantic',
    },
    {
      german: "tun",
      translated: "بکنند",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:243|fr": [
    {
      german: "Maik und Sybille",
      translated: "Maik et Sybille",
      tone: 'semantic',
    },
    {
      german: "wollen",
      translated: "veulent",
      tone: 'semantic',
    },
    {
      german: "mit Freunden",
      translated: "avec des amis",
      tone: 'semantic',
    },
    {
      german: "an ihrem deutschen Wohnort",
      translated: "dans leur lieu de résidence en Allemagne",
      tone: 'semantic',
    },
    {
      german: "eine Demonstration",
      translated: "une manifestation",
      tone: 'semantic',
    },
    {
      german: "auf der Straße",
      translated: "dans la rue",
      tone: 'semantic',
    },
    {
      german: "abhalten",
      translated: "organiser",
      tone: 'semantic',
    },
    {
      german: "Was müssen sie",
      translated: "Que doivent-ils",
      tone: 'semantic',
    },
    {
      german: "vorher",
      translated: "auparavant",
      tone: 'semantic',
    },
    {
      german: "tun",
      translated: "faire",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:243|hr": [
    {
      german: "Maik und Sybille",
      translated: "Maik i Sybille",
      tone: 'semantic',
    },
    {
      german: "wollen",
      translated: "žele",
      tone: 'semantic',
    },
    {
      german: "mit Freunden",
      translated: "s prijateljima",
      tone: 'semantic',
    },
    {
      german: "an ihrem deutschen Wohnort",
      translated: "u svom mjestu stanovanja u Njemačkoj",
      tone: 'semantic',
    },
    {
      german: "eine Demonstration",
      translated: "demonstraciju",
      tone: 'semantic',
    },
    {
      german: "auf der Straße",
      translated: "na ulici",
      tone: 'semantic',
    },
    {
      german: "abhalten",
      translated: "održati",
      tone: 'semantic',
    },
    {
      german: "Was müssen sie",
      translated: "Što moraju",
      tone: 'semantic',
    },
    {
      german: "vorher",
      translated: "prethodno",
      tone: 'semantic',
    },
    {
      german: "tun",
      translated: "učiniti",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:243|it": [
    {
      german: "Maik und Sybille",
      translated: "Maik e Sybille",
      tone: 'semantic',
    },
    {
      german: "wollen",
      translated: "vogliono",
      tone: 'semantic',
    },
    {
      german: "mit Freunden",
      translated: "con amici",
      tone: 'semantic',
    },
    {
      german: "an ihrem deutschen Wohnort",
      translated: "nel loro luogo di residenza in Germania",
      tone: 'semantic',
    },
    {
      german: "eine Demonstration",
      translated: "una manifestazione",
      tone: 'semantic',
    },
    {
      german: "auf der Straße",
      translated: "per strada",
      tone: 'semantic',
    },
    {
      german: "abhalten",
      translated: "organizzare",
      tone: 'semantic',
    },
    {
      german: "Was müssen sie",
      translated: "Che cosa devono",
      tone: 'semantic',
    },
    {
      german: "vorher",
      translated: "prima",
      tone: 'semantic',
    },
    {
      german: "tun",
      translated: "fare",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:243|kmr": [
    {
      german: "Maik und Sybille",
      translated: "Maik û Sybille",
      tone: 'semantic',
    },
    {
      german: "wollen",
      translated: "dixwazin",
      tone: 'semantic',
    },
    {
      german: "mit Freunden",
      translated: "bi hevalan",
      tone: 'semantic',
    },
    {
      german: "an ihrem deutschen Wohnort",
      translated: "li cihê rûniştina xwe ya li Almanyayê",
      tone: 'semantic',
    },
    {
      german: "eine Demonstration",
      translated: "xwepêşandanek",
      tone: 'semantic',
    },
    {
      german: "auf der Straße",
      translated: "li kolanê",
      tone: 'semantic',
    },
    {
      german: "abhalten",
      translated: "bikin",
      tone: 'semantic',
    },
    {
      german: "Was müssen sie",
      translated: "çi divê bikin",
      tone: 'semantic',
    },
    {
      german: "vorher",
      translated: "Berî wê",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:243|pl": [
    {
      german: "Maik und Sybille",
      translated: "Maik i Sybille",
      tone: 'semantic',
    },
    {
      german: "wollen",
      translated: "chcą",
      tone: 'semantic',
    },
    {
      german: "mit Freunden",
      translated: "z przyjaciółmi",
      tone: 'semantic',
    },
    {
      german: "an ihrem deutschen Wohnort",
      translated: "w swoim miejscu zamieszkania w Niemczech",
      tone: 'semantic',
    },
    {
      german: "eine Demonstration",
      translated: "demonstrację",
      tone: 'semantic',
    },
    {
      german: "auf der Straße",
      translated: "na ulicy",
      tone: 'semantic',
    },
    {
      german: "abhalten",
      translated: "zorganizować",
      tone: 'semantic',
    },
    {
      german: "Was müssen sie",
      translated: "Co muszą",
      tone: 'semantic',
    },
    {
      german: "vorher",
      translated: "wcześniej",
      tone: 'semantic',
    },
    {
      german: "tun",
      translated: "zrobić",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:243|prs": [
    {
      german: "Maik und Sybille",
      translated: "مایک و زیبیله",
      tone: 'semantic',
    },
    {
      german: "wollen",
      translated: "می‌خواهند",
      tone: 'semantic',
    },
    {
      german: "mit Freunden",
      translated: "همراه دوستانشان",
      tone: 'semantic',
    },
    {
      german: "an ihrem deutschen Wohnort",
      translated: "محل زندگی خود در آلمان",
      tone: 'semantic',
    },
    {
      german: "eine Demonstration",
      translated: "تظاهراتی",
      tone: 'semantic',
    },
    {
      german: "auf der Straße",
      translated: "در خیابان",
      tone: 'semantic',
    },
    {
      german: "abhalten",
      translated: "برگزار کنند",
      tone: 'semantic',
    },
    {
      german: "Was müssen sie",
      translated: "چه باید",
      tone: 'semantic',
    },
    {
      german: "vorher",
      translated: "پیش از آن",
      tone: 'semantic',
    },
    {
      german: "tun",
      translated: "بکنند",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:243|ro": [
    {
      german: "Maik und Sybille",
      translated: "Maik și Sybille",
      tone: 'semantic',
    },
    {
      german: "wollen",
      translated: "vor să",
      tone: 'semantic',
    },
    {
      german: "mit Freunden",
      translated: "cu prietenii",
      tone: 'semantic',
    },
    {
      german: "an ihrem deutschen Wohnort",
      translated: "în localitatea lor de domiciliu din Germania",
      tone: 'semantic',
    },
    {
      german: "eine Demonstration",
      translated: "o demonstrație",
      tone: 'semantic',
    },
    {
      german: "auf der Straße",
      translated: "pe stradă",
      tone: 'semantic',
    },
    {
      german: "abhalten",
      translated: "organizeze",
      tone: 'semantic',
    },
    {
      german: "Was müssen sie",
      translated: "Ce trebuie",
      tone: 'semantic',
    },
    {
      german: "vorher",
      translated: "înainte",
      tone: 'semantic',
    },
    {
      german: "tun",
      translated: "să facă",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:243|ru": [
    {
      german: "Maik und Sybille",
      translated: "Майк и Зибилле",
      tone: 'semantic',
    },
    {
      german: "wollen",
      translated: "хотят",
      tone: 'semantic',
    },
    {
      german: "mit Freunden",
      translated: "с друзьями",
      tone: 'semantic',
    },
    {
      german: "an ihrem deutschen Wohnort",
      translated: "по месту жительства в Германии",
      tone: 'semantic',
    },
    {
      german: "eine Demonstration",
      translated: "демонстрацию",
      tone: 'semantic',
    },
    {
      german: "auf der Straße",
      translated: "на улице",
      tone: 'semantic',
    },
    {
      german: "abhalten",
      translated: "провести",
      tone: 'semantic',
    },
    {
      german: "Was müssen sie",
      translated: "Что они должны",
      tone: 'semantic',
    },
    {
      german: "vorher",
      translated: "заранее",
      tone: 'semantic',
    },
    {
      german: "tun",
      translated: "сделать",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:243|sq": [
    {
      german: "Maik und Sybille",
      translated: "Maik dhe Sybille",
      tone: 'semantic',
    },
    {
      german: "wollen",
      translated: "duan",
      tone: 'semantic',
    },
    {
      german: "mit Freunden",
      translated: "me miqtë",
      tone: 'semantic',
    },
    {
      german: "an ihrem deutschen Wohnort",
      translated: "në vendbanimin e tyre në Gjermani",
      tone: 'semantic',
    },
    {
      german: "eine Demonstration",
      translated: "një demonstratë",
      tone: 'semantic',
    },
    {
      german: "auf der Straße",
      translated: "në rrugë",
      tone: 'semantic',
    },
    {
      german: "abhalten",
      translated: "të organizojnë",
      tone: 'semantic',
    },
    {
      german: "Was müssen sie",
      translated: "Çfarë duhet të bëjnë",
      tone: 'semantic',
    },
    {
      german: "vorher",
      translated: "paraprakisht",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:243|sr": [
    {
      german: "Maik und Sybille",
      translated: "Maik i Sybille",
      tone: 'semantic',
    },
    {
      german: "wollen",
      translated: "žele",
      tone: 'semantic',
    },
    {
      german: "mit Freunden",
      translated: "s prijateljima",
      tone: 'semantic',
    },
    {
      german: "an ihrem deutschen Wohnort",
      translated: "u svom mestu stanovanja u Nemačkoj",
      tone: 'semantic',
    },
    {
      german: "eine Demonstration",
      translated: "demonstraciju",
      tone: 'semantic',
    },
    {
      german: "auf der Straße",
      translated: "na ulici",
      tone: 'semantic',
    },
    {
      german: "abhalten",
      translated: "održati",
      tone: 'semantic',
    },
    {
      german: "Was müssen sie",
      translated: "Šta moraju",
      tone: 'semantic',
    },
    {
      german: "vorher",
      translated: "prethodno",
      tone: 'semantic',
    },
    {
      german: "tun",
      translated: "urade",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:243|tr": [
    {
      german: "Maik und Sybille",
      translated: "Maik ve Sybille",
      tone: 'semantic',
    },
    {
      german: "wollen",
      translated: "istiyor",
      tone: 'semantic',
    },
    {
      german: "mit Freunden",
      translated: "arkadaşlarıyla birlikte",
      tone: 'semantic',
    },
    {
      german: "an ihrem deutschen Wohnort",
      translated: "yaşadıkları Alman kentinde",
      tone: 'semantic',
    },
    {
      german: "eine Demonstration",
      translated: "bir gösteri",
      tone: 'semantic',
    },
    {
      german: "auf der Straße",
      translated: "sokakta",
      tone: 'semantic',
    },
    {
      german: "abhalten",
      translated: "yapmak",
      tone: 'semantic',
    },
    {
      german: "Was müssen sie",
      translated: "ne yapmaları gerekir",
      tone: 'semantic',
    },
    {
      german: "vorher",
      translated: "Önceden",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:243|uk": [
    {
      german: "Maik und Sybille",
      translated: "Майк і Сибілле",
      tone: 'semantic',
    },
    {
      german: "wollen",
      translated: " хочуть",
      tone: 'semantic',
    },
    {
      german: "mit Freunden",
      translated: " разом із друзями",
      tone: 'semantic',
    },
    {
      german: "an ihrem deutschen Wohnort",
      translated: " за місцем проживання в Німеччині",
      tone: 'semantic',
    },
    {
      german: "eine Demonstration",
      translated: "демонстрацію",
      tone: 'semantic',
    },
    {
      german: "auf der Straße",
      translated: "вуличну",
      tone: 'semantic',
    },
    {
      german: "abhalten",
      translated: " провести",
      tone: 'semantic',
    },
    {
      german: "Was müssen sie",
      translated: " Що вони повинні",
      tone: 'semantic',
    },
    {
      german: "vorher",
      translated: " заздалегідь",
      tone: 'semantic',
    },
    {
      german: "tun",
      translated: " зробити",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:243|vi": [
    {
      german: "Maik und Sybille",
      translated: "Maik và Sybille",
      tone: 'semantic',
    },
    {
      german: "wollen",
      translated: "muốn",
      tone: 'semantic',
    },
    {
      german: "mit Freunden",
      translated: "cùng bạn bè",
      tone: 'semantic',
    },
    {
      german: "an ihrem deutschen Wohnort",
      translated: "tại nơi cư trú của họ ở Đức",
      tone: 'semantic',
    },
    {
      german: "eine Demonstration",
      translated: "một cuộc biểu tình",
      tone: 'semantic',
    },
    {
      german: "auf der Straße",
      translated: "trên đường phố",
      tone: 'semantic',
    },
    {
      german: "abhalten",
      translated: "tổ chức",
      tone: 'semantic',
    },
    {
      german: "Was müssen sie",
      translated: "Họ phải",
      tone: 'semantic',
    },
    {
      german: "vorher",
      translated: "trước",
      tone: 'semantic',
    },
    {
      german: "tun",
      translated: "làm gì",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:244|ar": [
    {
      german: "Welchen Schulabschluss",
      translated: "أي شهادة مدرسية",
      tone: 'semantic',
    },
    {
      german: "braucht man",
      translated: "تحتاجها",
      tone: 'semantic',
    },
    {
      german: "normalerweise",
      translated: "عادةً",
      tone: 'semantic',
    },
    {
      german: "an einer Universität",
      translated: "في جامعة",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "ألمانية",
      tone: 'semantic',
    },
    {
      german: "ein Studium zu beginnen",
      translated: "لبدء الدراسة",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:244|bg": [
    {
      german: "Welchen Schulabschluss",
      translated: "Каква училищна диплома",
      tone: 'semantic',
    },
    {
      german: "braucht man",
      translated: "е необходима",
      tone: 'semantic',
    },
    {
      german: "normalerweise",
      translated: "обикновено",
      tone: 'semantic',
    },
    {
      german: "an einer Universität",
      translated: "университет",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "германски",
      tone: 'semantic',
    },
    {
      german: "ein Studium zu beginnen",
      translated: "за започване на обучение",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:244|bs": [
    {
      german: "Welchen Schulabschluss",
      translated: "Koja je školska svjedodžba",
      tone: 'semantic',
    },
    {
      german: "braucht man",
      translated: "u pravilu",
      tone: 'semantic',
    },
    {
      german: "normalerweise",
      translated: "potrebna",
      tone: 'semantic',
    },
    {
      german: "an einer Universität",
      translated: "na njemačkom univerzitetu",
      tone: 'semantic',
    },
    {
      german: "ein Studium zu beginnen",
      translated: "za početak studija",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:244|el": [
    {
      german: "Welchen Schulabschluss",
      translated: "Ποιο σχολικό απολυτήριο",
      tone: 'semantic',
    },
    {
      german: "braucht man",
      translated: "απαιτείται",
      tone: 'semantic',
    },
    {
      german: "normalerweise",
      translated: "συνήθως",
      tone: 'semantic',
    },
    {
      german: "an einer Universität",
      translated: "σε γερμανικό πανεπιστήμιο",
      tone: 'semantic',
    },
    {
      german: "ein Studium zu beginnen",
      translated: "για την έναρξη σπουδών",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:244|en": [
    {
      german: "Welchen Schulabschluss",
      translated: "What school diploma",
      tone: 'semantic',
    },
    {
      german: "braucht man",
      translated: "needed",
      tone: 'semantic',
    },
    {
      german: "normalerweise",
      translated: "normally",
      tone: 'semantic',
    },
    {
      german: "an einer Universität",
      translated: "at a university",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "in Germany",
      tone: 'semantic',
    },
    {
      german: "ein Studium zu beginnen",
      translated: "to begin studying",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:244|es": [
    {
      german: "Welchen Schulabschluss",
      translated: "título escolar",
      tone: 'semantic',
    },
    {
      german: "braucht man",
      translated: "se necesita",
      tone: 'semantic',
    },
    {
      german: "normalerweise",
      translated: "normalmente",
      tone: 'semantic',
    },
    {
      german: "an einer Universität",
      translated: "una universidad",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "alemana",
      tone: 'semantic',
    },
    {
      german: "ein Studium zu beginnen",
      translated: "comenzar estudios",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:244|fa": [
    {
      german: "Welchen Schulabschluss",
      translated: "چه مدرک مدرسه‌ای",
      tone: 'semantic',
    },
    {
      german: "braucht man",
      translated: "لازم است",
      tone: 'semantic',
    },
    {
      german: "normalerweise",
      translated: "معمولاً",
      tone: 'semantic',
    },
    {
      german: "an einer Universität",
      translated: "در یک دانشگاه",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "آلمان",
      tone: 'semantic',
    },
    {
      german: "ein Studium zu beginnen",
      translated: "برای آغاز تحصیل",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:244|fr": [
    {
      german: "Welchen Schulabschluss",
      translated: "Quel diplôme scolaire",
      tone: 'semantic',
    },
    {
      german: "braucht man",
      translated: "faut-il",
      tone: 'semantic',
    },
    {
      german: "normalerweise",
      translated: "normalement",
      tone: 'semantic',
    },
    {
      german: "an einer Universität",
      translated: "dans une université",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "allemande",
      tone: 'semantic',
    },
    {
      german: "ein Studium zu beginnen",
      translated: "commencer des études",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:244|hr": [
    {
      german: "Welchen Schulabschluss",
      translated: "Koja je školska svjedodžba",
      tone: 'semantic',
    },
    {
      german: "normalerweise",
      translated: "u pravilu",
      tone: 'semantic',
    },
    {
      german: "an einer Universität",
      translated: "na njemačkom sveučilištu",
      tone: 'semantic',
    },
    {
      german: "ein Studium zu beginnen",
      translated: "za početak studija",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:244|it": [
    {
      german: "Welchen Schulabschluss",
      translated: "Quale diploma scolastico",
      tone: 'semantic',
    },
    {
      german: "braucht man",
      translated: "necessario",
      tone: 'semantic',
    },
    {
      german: "normalerweise",
      translated: "normalmente",
      tone: 'semantic',
    },
    {
      german: "an einer Universität",
      translated: "in un’università",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "tedesca",
      tone: 'semantic',
    },
    {
      german: "ein Studium zu beginnen",
      translated: "iniziare gli studi",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:244|kmr": [
    {
      german: "Welchen Schulabschluss",
      translated: "kîjan belgeya dibistanê",
      tone: 'semantic',
    },
    {
      german: "braucht man",
      translated: "pêwîst e",
      tone: 'semantic',
    },
    {
      german: "normalerweise",
      translated: "bi gelemperî",
      tone: 'semantic',
    },
    {
      german: "an einer Universität",
      translated: "zanîngehê",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "li Almanyayê",
      tone: 'semantic',
    },
    {
      german: "ein Studium zu beginnen",
      translated: "Ji bo destpêkirina xwendina",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:244|pl": [
    {
      german: "Welchen Schulabschluss",
      translated: "Jakie świadectwo szkolne",
      tone: 'semantic',
    },
    {
      german: "braucht man",
      translated: "wymagane",
      tone: 'semantic',
    },
    {
      german: "normalerweise",
      translated: "zazwyczaj",
      tone: 'semantic',
    },
    {
      german: "an einer Universität",
      translated: "uniwersytecie",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "niemieckim",
      tone: 'semantic',
    },
    {
      german: "ein Studium zu beginnen",
      translated: "rozpocząć studia",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:244|prs": [
    {
      german: "Welchen Schulabschluss",
      translated: "چه مدرک مکتب‌ای",
      tone: 'semantic',
    },
    {
      german: "braucht man",
      translated: "لازم است",
      tone: 'semantic',
    },
    {
      german: "normalerweise",
      translated: "معمولاً",
      tone: 'semantic',
    },
    {
      german: "an einer Universität",
      translated: "در یک پوهنتون",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "آلمان",
      tone: 'semantic',
    },
    {
      german: "ein Studium zu beginnen",
      translated: "برای آغاز تحصیل",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:244|ro": [
    {
      german: "Welchen Schulabschluss",
      translated: "Ce diplomă școlară",
      tone: 'semantic',
    },
    {
      german: "braucht man",
      translated: "necesară",
      tone: 'semantic',
    },
    {
      german: "normalerweise",
      translated: "de regulă",
      tone: 'semantic',
    },
    {
      german: "an einer Universität",
      translated: "la o universitate",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "germană",
      tone: 'semantic',
    },
    {
      german: "ein Studium zu beginnen",
      translated: "pentru a începe studiile",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:244|ru": [
    {
      german: "Welchen Schulabschluss",
      translated: "Какой аттестат",
      tone: 'semantic',
    },
    {
      german: "braucht man",
      translated: "нужен",
      tone: 'semantic',
    },
    {
      german: "normalerweise",
      translated: "обычно",
      tone: 'semantic',
    },
    {
      german: "an einer Universität",
      translated: "в университет",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "в Германии",
      tone: 'semantic',
    },
    {
      german: "ein Studium zu beginnen",
      translated: "чтобы поступить",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:244|sq": [
    {
      german: "Welchen Schulabschluss",
      translated: "Cila diplomë shkollore",
      tone: 'semantic',
    },
    {
      german: "braucht man",
      translated: "nevojitet",
      tone: 'semantic',
    },
    {
      german: "normalerweise",
      translated: "zakonisht",
      tone: 'semantic',
    },
    {
      german: "an einer Universität",
      translated: "në një universitet",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "gjerman",
      tone: 'semantic',
    },
    {
      german: "ein Studium zu beginnen",
      translated: "për të filluar studimet",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:244|sr": [
    {
      german: "Welchen Schulabschluss",
      translated: "Koja je školska svjedodžba",
      tone: 'semantic',
    },
    {
      german: "braucht man",
      translated: "po pravilu",
      tone: 'semantic',
    },
    {
      german: "an einer Universität",
      translated: "na nemačkom univerzitetu",
      tone: 'semantic',
    },
    {
      german: "ein Studium zu beginnen",
      translated: "za početak studija",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:244|tr": [
    {
      german: "Welchen Schulabschluss",
      translated: "hangi okul diploması",
      tone: 'semantic',
    },
    {
      german: "braucht man",
      translated: "gerekir",
      tone: 'semantic',
    },
    {
      german: "normalerweise",
      translated: "normalde",
      tone: 'semantic',
    },
    {
      german: "an einer Universität",
      translated: "bir üniversitede",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "Almanya'da",
      tone: 'semantic',
    },
    {
      german: "ein Studium zu beginnen",
      translated: "öğrenime başlamak",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:244|uk": [
    {
      german: "Welchen Schulabschluss",
      translated: "Який шкільний атестат",
      tone: 'semantic',
    },
    {
      german: "normalerweise",
      translated: "зазвичай",
      tone: 'semantic',
    },
    {
      german: "an einer Universität",
      translated: "потрібен, щоб",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "Німеччини",
      tone: 'semantic',
    },
    {
      german: "ein Studium zu beginnen",
      translated: "розпочати навчання в університеті",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:244|vi": [
    {
      german: "Welchen Schulabschluss",
      translated: "bằng tốt nghiệp nào",
      tone: 'semantic',
    },
    {
      german: "normalerweise",
      translated: "Thông thường",
      tone: 'semantic',
    },
    {
      german: "an einer Universität",
      translated: "tại một trường đại học",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "Đức",
      tone: 'semantic',
    },
    {
      german: "ein Studium zu beginnen",
      translated: "để bắt đầu học",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:245|ar": [
    {
      german: "Wer",
      translated: "أي شخصين",
      tone: 'semantic',
    },
    {
      german: "darf",
      translated: "يجوز لهما",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "في ألمانيا",
      tone: 'semantic',
    },
    {
      german: "nicht",
      translated: "لا",
      tone: 'semantic',
    },
    {
      german: "als Paar",
      translated: "كزوجين",
      tone: 'semantic',
    },
    {
      german: "zusammenleben",
      translated: "العيش معًا",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:245|bg": [
    {
      german: "Wer",
      translated: "Кои двама души",
      tone: 'semantic',
    },
    {
      german: "darf",
      translated: "могат",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "в Германия",
      tone: 'semantic',
    },
    {
      german: "nicht",
      translated: "НЕ",
      tone: 'semantic',
    },
    {
      german: "als Paar",
      translated: "като двойка",
      tone: 'semantic',
    },
    {
      german: "zusammenleben",
      translated: "да живеят",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:245|bs": [
    {
      german: "Wer",
      translated: "Koje dvije osobe",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "u Njemačkoj",
      tone: 'semantic',
    },
    {
      german: "nicht",
      translated: "NE",
      tone: 'semantic',
    },
    {
      german: "als Paar",
      translated: "kao par",
      tone: 'semantic',
    },
    {
      german: "zusammenleben",
      translated: "živjeti zajedno",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:245|el": [
    {
      german: "Wer",
      translated: "Ποια δύο άτομα",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "στη Γερμανία",
      tone: 'semantic',
    },
    {
      german: "nicht",
      translated: "ΔΕΝ",
      tone: 'semantic',
    },
    {
      german: "zusammenleben",
      translated: "ζήσουν μαζί ως ζευγάρι",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:245|en": [
    {
      german: "Wer",
      translated: "Who",
      tone: 'semantic',
    },
    {
      german: "darf",
      translated: "is",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "in Germany",
      tone: 'semantic',
    },
    {
      german: "nicht",
      translated: "not",
      tone: 'semantic',
    },
    {
      german: "als Paar",
      translated: "as a couple",
      tone: 'semantic',
    },
    {
      german: "zusammenleben",
      translated: "live together",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:245|es": [
    {
      german: "Wer",
      translated: "personas",
      tone: 'semantic',
    },
    {
      german: "darf",
      translated: "pueden",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "en Alemania",
      tone: 'semantic',
    },
    {
      german: "nicht",
      translated: "NO",
      tone: 'semantic',
    },
    {
      german: "als Paar",
      translated: "como pareja",
      tone: 'semantic',
    },
    {
      german: "zusammenleben",
      translated: "vivir juntas",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:245|fa": [
    {
      german: "Wer",
      translated: "کدام",
      tone: 'semantic',
    },
    {
      german: "darf",
      translated: "دو نفر",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "در آلمان",
      tone: 'semantic',
    },
    {
      german: "nicht",
      translated: "نمی",
      tone: 'semantic',
    },
    {
      german: "als Paar",
      translated: "به‌عنوان زوج",
      tone: 'semantic',
    },
    {
      german: "zusammenleben",
      translated: "زندگی کنند",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:245|fr": [
    {
      german: "Wer",
      translated: "Qui",
      tone: 'semantic',
    },
    {
      german: "darf",
      translated: "peut",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "en Allemagne",
      tone: 'semantic',
    },
    {
      german: "nicht",
      translated: "pas",
      tone: 'semantic',
    },
    {
      german: "als Paar",
      translated: "en couple",
      tone: 'semantic',
    },
    {
      german: "zusammenleben",
      translated: "vivre ensemble",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:245|hr": [
    {
      german: "Wer",
      translated: "Koje dvije osobe",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "u Njemačkoj",
      tone: 'semantic',
    },
    {
      german: "nicht",
      translated: "NE",
      tone: 'semantic',
    },
    {
      german: "als Paar",
      translated: "kao par",
      tone: 'semantic',
    },
    {
      german: "zusammenleben",
      translated: "živjeti zajedno",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:245|it": [
    {
      german: "Wer",
      translated: "Quali due persone",
      tone: 'semantic',
    },
    {
      german: "darf",
      translated: "possono",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "in Germania",
      tone: 'semantic',
    },
    {
      german: "nicht",
      translated: "NON",
      tone: 'semantic',
    },
    {
      german: "als Paar",
      translated: "come coppia",
      tone: 'semantic',
    },
    {
      german: "zusammenleben",
      translated: "vivere insieme",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:245|kmr": [
    {
      german: "Wer",
      translated: "Kî",
      tone: 'semantic',
    },
    {
      german: "darf",
      translated: "li",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "Almanyayê",
      tone: 'semantic',
    },
    {
      german: "nicht",
      translated: "nikare",
      tone: 'semantic',
    },
    {
      german: "als Paar",
      translated: "wek",
      tone: 'semantic',
    },
    {
      german: "zusammenleben",
      translated: "cotek bi hev re bijî",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:245|pl": [
    {
      german: "Wer",
      translated: "Które",
      tone: 'semantic',
    },
    {
      german: "darf",
      translated: "NIE mogą",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "w Niemczech?",
      tone: 'semantic',
    },
    {
      german: "als Paar",
      translated: "jako para",
      tone: 'semantic',
    },
    {
      german: "zusammenleben",
      translated: "żyć razem",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:245|prs": [
    {
      german: "darf",
      translated: "کدام",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "در آلمان",
      tone: 'semantic',
    },
    {
      german: "nicht",
      translated: "نمی‌توانند",
      tone: 'semantic',
    },
    {
      german: "als Paar",
      translated: "به‌عنوان زوج",
      tone: 'semantic',
    },
    {
      german: "zusammenleben",
      translated: "زندگی کنند؟",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:245|ro": [
    {
      german: "Wer",
      translated: "Care două",
      tone: 'semantic',
    },
    {
      german: "darf",
      translated: "pot",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "în Germania",
      tone: 'semantic',
    },
    {
      german: "nicht",
      translated: "NU",
      tone: 'semantic',
    },
    {
      german: "als Paar",
      translated: "ca un cuplu",
      tone: 'semantic',
    },
    {
      german: "zusammenleben",
      translated: "trăi împreună",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:245|ru": [
    {
      german: "Wer",
      translated: "Кому",
      tone: 'semantic',
    },
    {
      german: "darf",
      translated: "нельзя",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "в Германии",
      tone: 'semantic',
    },
    {
      german: "als Paar",
      translated: "как паре",
      tone: 'semantic',
    },
    {
      german: "zusammenleben",
      translated: "проживать вместе",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:245|sq": [
    {
      german: "Wer",
      translated: "Cilët",
      tone: 'semantic',
    },
    {
      german: "darf",
      translated: "mund",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "në Gjermani",
      tone: 'semantic',
    },
    {
      german: "nicht",
      translated: "NUK",
      tone: 'semantic',
    },
    {
      german: "als Paar",
      translated: "si çift",
      tone: 'semantic',
    },
    {
      german: "zusammenleben",
      translated: "jetojnë",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:245|sr": [
    {
      german: "darf",
      translated: "smeju",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "u Nemačkoj",
      tone: 'semantic',
    },
    {
      german: "nicht",
      translated: "NE",
      tone: 'semantic',
    },
    {
      german: "als Paar",
      translated: "kao par",
      tone: 'semantic',
    },
    {
      german: "zusammenleben",
      translated: "živjeti zajedno",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:245|tr": [
    {
      german: "Wer",
      translated: "aşağıdaki çiftlerden hangisinin",
      tone: 'semantic',
    },
    {
      german: "darf",
      translated: "izin",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "Almanya'da",
      tone: 'semantic',
    },
    {
      german: "nicht",
      translated: "verilmez",
      tone: 'semantic',
    },
    {
      german: "zusammenleben",
      translated: "birlikte yaşamasına",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:245|uk": [
    {
      german: "Wer",
      translated: "Хто",
      tone: 'semantic',
    },
    {
      german: "darf",
      translated: "має права",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "в Німеччині",
      tone: 'semantic',
    },
    {
      german: "nicht",
      translated: "не",
      tone: 'semantic',
    },
    {
      german: "als Paar",
      translated: "як пара",
      tone: 'semantic',
    },
    {
      german: "zusammenleben",
      translated: "жити разом",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:245|vi": [
    {
      german: "Wer",
      translated: "Hai người nào",
      tone: 'semantic',
    },
    {
      german: "darf",
      translated: "được phép",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "ở Đức",
      tone: 'semantic',
    },
    {
      german: "nicht",
      translated: "KHÔNG",
      tone: 'semantic',
    },
    {
      german: "als Paar",
      translated: "như một cặp đôi",
      tone: 'semantic',
    },
    {
      german: "zusammenleben",
      translated: "sống chung",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:246|ar": [
    {
      german: "Ab welchem Alter",
      translated: "ابتداءً من أي سن",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "في ألمانيا",
      tone: 'semantic',
    },
    {
      german: "volljährig",
      translated: "بالغًا قانونيًا",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:246|bg": [
    {
      german: "Ab welchem Alter",
      translated: "От каква",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "в Германия",
      tone: 'semantic',
    },
    {
      german: "volljährig",
      translated: "пълнолетен",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:246|bs": [
    {
      german: "Ab welchem Alter",
      translated: "Od koje je dobi",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "u Njemačkoj",
      tone: 'semantic',
    },
    {
      german: "volljährig",
      translated: "punoljetna",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:246|el": [
    {
      german: "Ab welchem Alter",
      translated: "Από ποια ηλικία",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "στη Γερμανία",
      tone: 'semantic',
    },
    {
      german: "volljährig",
      translated: "ενήλικο",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:246|en": [
    {
      german: "Ab welchem Alter",
      translated: "At what age",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "in Germany",
      tone: 'semantic',
    },
    {
      german: "volljährig",
      translated: "an adult",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:246|es": [
    {
      german: "Ab welchem Alter",
      translated: "¿A partir de qué edad",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "en Alemania",
      tone: 'semantic',
    },
    {
      german: "volljährig",
      translated: "legalmente adulto",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:246|fa": [
    {
      german: "Ab welchem Alter",
      translated: "از چه سنی",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "در آلمان",
      tone: 'semantic',
    },
    {
      german: "volljährig",
      translated: "به سن قانونی",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:246|fr": [
    {
      german: "Ab welchem Alter",
      translated: "À partir de quel âge",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "en Allemagne",
      tone: 'semantic',
    },
    {
      german: "volljährig",
      translated: "majeur",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:246|hr": [
    {
      german: "Ab welchem Alter",
      translated: "Od koje je dobi",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "u Njemačkoj",
      tone: 'semantic',
    },
    {
      german: "volljährig",
      translated: "punoljetna",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:246|it": [
    {
      german: "Ab welchem Alter",
      translated: "Da quale",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "in Germania",
      tone: 'semantic',
    },
    {
      german: "volljährig",
      translated: "maggiorenne",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:246|kmr": [
    {
      german: "Ab welchem Alter",
      translated: "Ji kîjan temenê",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "li Almanyayê",
      tone: 'semantic',
    },
    {
      german: "volljährig",
      translated: "mirov mezin tê hesibandin",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:246|pl": [
    {
      german: "Ab welchem Alter",
      translated: "Od jakiego wieku",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "w Niemczech",
      tone: 'semantic',
    },
    {
      german: "volljährig",
      translated: "pełnoletnia",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:246|prs": [
    {
      german: "Ab welchem Alter",
      translated: "از چه سنی",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "در آلمان",
      tone: 'semantic',
    },
    {
      german: "volljährig",
      translated: "به سن قانونی می‌رسد",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:246|ro": [
    {
      german: "Ab welchem Alter",
      translated: "De la ce vârstă",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "în Germania",
      tone: 'semantic',
    },
    {
      german: "volljährig",
      translated: "majoră",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:246|ru": [
    {
      german: "Ab welchem Alter",
      translated: "С какого возраста",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "в Германии",
      tone: 'semantic',
    },
    {
      german: "volljährig",
      translated: "совершеннолетие",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:246|sq": [
    {
      german: "Ab welchem Alter",
      translated: "Nga cila moshë",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "në Gjermani",
      tone: 'semantic',
    },
    {
      german: "volljährig",
      translated: "madhor",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:246|sr": [
    {
      german: "Ab welchem Alter",
      translated: "Od koje je dobi",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "u Nemačkoj",
      tone: 'semantic',
    },
    {
      german: "volljährig",
      translated: "punoljetna",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:246|tr": [
    {
      german: "Ab welchem Alter",
      translated: "kaç yaşından itibaren",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "Almanya'da",
      tone: 'semantic',
    },
    {
      german: "volljährig",
      translated: "reşit",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:246|uk": [
    {
      german: "Ab welchem Alter",
      translated: "З якого віку",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "в Німеччині",
      tone: 'semantic',
    },
    {
      german: "volljährig",
      translated: "повнолітньою",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:246|vi": [
    {
      german: "Ab welchem Alter",
      translated: "từ bao nhiêu tuổi",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "Ở Đức",
      tone: 'semantic',
    },
    {
      german: "volljährig",
      translated: "thành niên",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:247|ar": [
    {
      german: "Eine Frau",
      translated: "امرأة",
      tone: 'semantic',
    },
    {
      german: "schwanger",
      translated: "حامل",
      tone: 'semantic',
    },
    {
      german: "kurz vor und nach der Geburt",
      translated: "قبل ولادة",
      tone: 'semantic',
    },
    {
      german: "ihres Kindes",
      translated: "طفلها",
      tone: 'semantic',
    },
    {
      german: "vom Gesetz besonders beschützt",
      translated: "ويحميها القانون بصورة خاصة",
      tone: 'semantic',
    },
    {
      german: "Wie heißt dieser Schutz",
      translated: "ماذا تُسمى هذه الحماية",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:247|bg": [
    {
      german: "Eine Frau",
      translated: "Жена е",
      tone: 'semantic',
    },
    {
      german: "schwanger",
      translated: "бременна",
      tone: 'semantic',
    },
    {
      german: "kurz vor und nach der Geburt",
      translated: "Малко преди и след раждането",
      tone: 'semantic',
    },
    {
      german: "ihres Kindes",
      translated: "тя се ползва със",
      tone: 'semantic',
    },
    {
      german: "vom Gesetz besonders beschützt",
      translated: "специална законова защита",
      tone: 'semantic',
    },
    {
      german: "Wie heißt dieser Schutz",
      translated: "Как се нарича тя",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:247|bs": [
    {
      german: "Eine Frau",
      translated: "Žena",
      tone: 'semantic',
    },
    {
      german: "schwanger",
      translated: "trudna",
      tone: 'semantic',
    },
    {
      german: "kurz vor und nach der Geburt",
      translated: "Neposredno prije i nakon poroda",
      tone: 'semantic',
    },
    {
      german: "vom Gesetz besonders beschützt",
      translated: "uživa posebnu zakonsku zaštitu",
      tone: 'semantic',
    },
    {
      german: "Wie heißt dieser Schutz",
      translated: "Kako se ona zove",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:247|el": [
    {
      german: "Eine Frau",
      translated: "Μια γυναίκα",
      tone: 'semantic',
    },
    {
      german: "schwanger",
      translated: "έγκυος",
      tone: 'semantic',
    },
    {
      german: "kurz vor und nach der Geburt",
      translated: "Λίγο πριν και μετά τον τοκετό",
      tone: 'semantic',
    },
    {
      german: "ihres Kindes",
      translated: "απολαμβάνει",
      tone: 'semantic',
    },
    {
      german: "vom Gesetz besonders beschützt",
      translated: "ειδική νομική προστασία",
      tone: 'semantic',
    },
    {
      german: "Wie heißt dieser Schutz",
      translated: "Πώς ονομάζεται αυτή",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:247|en": [
    {
      german: "Eine Frau",
      translated: "A woman",
      tone: 'semantic',
    },
    {
      german: "schwanger",
      translated: "pregnant",
      tone: 'semantic',
    },
    {
      german: "kurz vor und nach der Geburt",
      translated: "shortly before and after the birth",
      tone: 'semantic',
    },
    {
      german: "ihres Kindes",
      translated: "of her child",
      tone: 'semantic',
    },
    {
      german: "vom Gesetz besonders beschützt",
      translated: "specially protected by law",
      tone: 'semantic',
    },
    {
      german: "Wie heißt dieser Schutz",
      translated: "What is this protection called",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:247|es": [
    {
      german: "Eine Frau",
      translated: "Una mujer",
      tone: 'semantic',
    },
    {
      german: "schwanger",
      translated: "embarazada",
      tone: 'semantic',
    },
    {
      german: "kurz vor und nach der Geburt",
      translated: "poco antes y poco después del nacimiento",
      tone: 'semantic',
    },
    {
      german: "ihres Kindes",
      translated: "de su hijo",
      tone: 'semantic',
    },
    {
      german: "vom Gesetz besonders beschützt",
      translated: "La ley la protege especialmente",
      tone: 'semantic',
    },
    {
      german: "Wie heißt dieser Schutz",
      translated: "¿Cómo se llama esta protección?",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:247|fa": [
    {
      german: "Eine Frau",
      translated: "یک زن",
      tone: 'semantic',
    },
    {
      german: "schwanger",
      translated: "باردار",
      tone: 'semantic',
    },
    {
      german: "kurz vor und nach der Geburt",
      translated: "کمی پیش و پس از تولد",
      tone: 'semantic',
    },
    {
      german: "ihres Kindes",
      translated: "فرزند",
      tone: 'semantic',
    },
    {
      german: "vom Gesetz besonders beschützt",
      translated: "حمایت قانونی ویژه‌ای",
      tone: 'semantic',
    },
    {
      german: "Wie heißt dieser Schutz",
      translated: "این حمایت چه نام دارد؟",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:247|fr": [
    {
      german: "Eine Frau",
      translated: "Une femme",
      tone: 'semantic',
    },
    {
      german: "schwanger",
      translated: "enceinte",
      tone: 'semantic',
    },
    {
      german: "kurz vor und nach der Geburt",
      translated: "Peu avant et après la naissance",
      tone: 'semantic',
    },
    {
      german: "ihres Kindes",
      translated: "de son enfant",
      tone: 'semantic',
    },
    {
      german: "vom Gesetz besonders beschützt",
      translated: "bénéficie d’une protection légale particulière",
      tone: 'semantic',
    },
    {
      german: "Wie heißt dieser Schutz",
      translated: "Comment s’appelle cette protection",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:247|hr": [
    {
      german: "Eine Frau",
      translated: "Žena",
      tone: 'semantic',
    },
    {
      german: "schwanger",
      translated: "trudna",
      tone: 'semantic',
    },
    {
      german: "kurz vor und nach der Geburt",
      translated: "Neposredno prije i nakon poroda",
      tone: 'semantic',
    },
    {
      german: "vom Gesetz besonders beschützt",
      translated: "uživa posebnu zakonsku zaštitu",
      tone: 'semantic',
    },
    {
      german: "Wie heißt dieser Schutz",
      translated: "Kako se ona zove",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:247|it": [
    {
      german: "Eine Frau",
      translated: "Una donna",
      tone: 'semantic',
    },
    {
      german: "schwanger",
      translated: "incinta",
      tone: 'semantic',
    },
    {
      german: "kurz vor und nach der Geburt",
      translated: "Poco prima e dopo il parto",
      tone: 'semantic',
    },
    {
      german: "vom Gesetz besonders beschützt",
      translated: "gode di una particolare protezione legale",
      tone: 'semantic',
    },
    {
      german: "Wie heißt dieser Schutz",
      translated: "Come si chiama",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:247|kmr": [
    {
      german: "Eine Frau",
      translated: "Jinek",
      tone: 'semantic',
    },
    {
      german: "schwanger",
      translated: "hamîle",
      tone: 'semantic',
    },
    {
      german: "kurz vor und nach der Geburt",
      translated: "Berî û piştî zayînê",
      tone: 'semantic',
    },
    {
      german: "vom Gesetz besonders beschützt",
      translated: "bi qanûnê taybet tê parastin",
      tone: 'semantic',
    },
    {
      german: "Wie heißt dieser Schutz",
      translated: "Navê vê parastinê çi ye",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:247|pl": [
    {
      german: "Eine Frau",
      translated: "Kobieta",
      tone: 'semantic',
    },
    {
      german: "schwanger",
      translated: "w ciąży",
      tone: 'semantic',
    },
    {
      german: "kurz vor und nach der Geburt",
      translated: "Krótko przed i po porodzie",
      tone: 'semantic',
    },
    {
      german: "vom Gesetz besonders beschützt",
      translated: "korzysta ze szczególnej ochrony prawnej",
      tone: 'semantic',
    },
    {
      german: "Wie heißt dieser Schutz",
      translated: "Jak się ona nazywa",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:247|prs": [
    {
      german: "Eine Frau",
      translated: "یک زن",
      tone: 'semantic',
    },
    {
      german: "schwanger",
      translated: "باردار",
      tone: 'semantic',
    },
    {
      german: "kurz vor und nach der Geburt",
      translated: "کمی پیش و پس از تولد",
      tone: 'semantic',
    },
    {
      german: "ihres Kindes",
      translated: "فرزند",
      tone: 'semantic',
    },
    {
      german: "vom Gesetz besonders beschützt",
      translated: "از حمایت قانونی ویژه‌ای",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:247|ro": [
    {
      german: "Eine Frau",
      translated: "O femeie",
      tone: 'semantic',
    },
    {
      german: "schwanger",
      translated: "este însărcinată",
      tone: 'semantic',
    },
    {
      german: "kurz vor und nach der Geburt",
      translated: "Cu puțin timp înainte și după naștere",
      tone: 'semantic',
    },
    {
      german: "vom Gesetz besonders beschützt",
      translated: "beneficiază de protecție legală specială",
      tone: 'semantic',
    },
    {
      german: "Wie heißt dieser Schutz",
      translated: "Cum se numește aceasta",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:247|ru": [
    {
      german: "Eine Frau",
      translated: "Женщина",
      tone: 'semantic',
    },
    {
      german: "schwanger",
      translated: "беременна",
      tone: 'semantic',
    },
    {
      german: "kurz vor und nach der Geburt",
      translated: "Незадолго до и после рождения",
      tone: 'semantic',
    },
    {
      german: "ihres Kindes",
      translated: "ребёнка",
      tone: 'semantic',
    },
    {
      german: "vom Gesetz besonders beschützt",
      translated: "особо защищена законом",
      tone: 'semantic',
    },
    {
      german: "Wie heißt dieser Schutz",
      translated: "Как называется эта защита",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:247|sq": [
    {
      german: "Eine Frau",
      translated: "Një grua",
      tone: 'semantic',
    },
    {
      german: "schwanger",
      translated: "shtatzënë",
      tone: 'semantic',
    },
    {
      german: "kurz vor und nach der Geburt",
      translated: "Pak para dhe pas lindjes",
      tone: 'semantic',
    },
    {
      german: "ihres Kindes",
      translated: "ajo",
      tone: 'semantic',
    },
    {
      german: "vom Gesetz besonders beschützt",
      translated: "mbrojtje të veçantë ligjore",
      tone: 'semantic',
    },
    {
      german: "Wie heißt dieser Schutz",
      translated: "Si quhet kjo",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:247|sr": [
    {
      german: "Eine Frau",
      translated: "Žena",
      tone: 'semantic',
    },
    {
      german: "schwanger",
      translated: "trudna",
      tone: 'semantic',
    },
    {
      german: "kurz vor und nach der Geburt",
      translated: "Neposredno pre i posle poroda",
      tone: 'semantic',
    },
    {
      german: "vom Gesetz besonders beschützt",
      translated: "uživa posebnu zakonsku zaštitu",
      tone: 'semantic',
    },
    {
      german: "Wie heißt dieser Schutz",
      translated: "Kako se ona zove",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:247|tr": [
    {
      german: "Eine Frau",
      translated: "Hamile bir kadın",
      tone: 'semantic',
    },
    {
      german: "kurz vor und nach der Geburt",
      translated: "doğumdan kısa süre önce ve sonra",
      tone: 'semantic',
    },
    {
      german: "vom Gesetz besonders beschützt",
      translated: "yasalarla özel olarak korunur",
      tone: 'semantic',
    },
    {
      german: "Wie heißt dieser Schutz",
      translated: "Bu korumanın adı nedir?",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:247|uk": [
    {
      german: "Eine Frau",
      translated: "Жінка",
      tone: 'semantic',
    },
    {
      german: "schwanger",
      translated: "вагітна",
      tone: 'semantic',
    },
    {
      german: "kurz vor und nach der Geburt",
      translated: "Незадовго до та після народження",
      tone: 'semantic',
    },
    {
      german: "ihres Kindes",
      translated: "дитини",
      tone: 'semantic',
    },
    {
      german: "vom Gesetz besonders beschützt",
      translated: "під особливим правовим захистом",
      tone: 'semantic',
    },
    {
      german: "Wie heißt dieser Schutz",
      translated: "Як називається цей захист",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:247|vi": [
    {
      german: "Eine Frau",
      translated: "Một phụ nữ",
      tone: 'semantic',
    },
    {
      german: "schwanger",
      translated: "đang mang thai",
      tone: 'semantic',
    },
    {
      german: "kurz vor und nach der Geburt",
      translated: "Ngay trước và sau khi sinh",
      tone: 'semantic',
    },
    {
      german: "ihres Kindes",
      translated: "cô ấy",
      tone: 'semantic',
    },
    {
      german: "vom Gesetz besonders beschützt",
      translated: "được pháp luật bảo vệ đặc biệt",
      tone: 'semantic',
    },
    {
      german: "Wie heißt dieser Schutz",
      translated: "Điều này gọi là gì",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:248|ar": [
    {
      german: "Die Erziehung der Kinder",
      translated: "تربية الأطفال",
      tone: 'semantic',
    },
    {
      german: "ist in Deutschland",
      translated: "في ألمانيا",
      tone: 'semantic',
    },
    {
      german: "vor allem",
      translated: "هي",
      tone: 'semantic',
    },
    {
      german: "Aufgabe",
      translated: "مهمة",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:248|bg": [
    {
      german: "Die Erziehung der Kinder",
      translated: "възпитанието на децата",
      tone: 'semantic',
    },
    {
      german: "ist in Deutschland",
      translated: "В Германия",
      tone: 'semantic',
    },
    {
      german: "vor allem",
      translated: "преди всичко",
      tone: 'semantic',
    },
    {
      german: "Aufgabe",
      translated: "отговорност",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:248|bs": [
    {
      german: "Die Erziehung der Kinder",
      translated: "odgoj djece",
      tone: 'semantic',
    },
    {
      german: "ist in Deutschland",
      translated: "U Njemačkoj je",
      tone: 'semantic',
    },
    {
      german: "vor allem",
      translated: "prvenstveno",
      tone: 'semantic',
    },
    {
      german: "Aufgabe",
      translated: "zadaća",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:248|el": [
    {
      german: "Die Erziehung der Kinder",
      translated: "η ανατροφή των παιδιών",
      tone: 'semantic',
    },
    {
      german: "ist in Deutschland",
      translated: "Στη Γερμανία",
      tone: 'semantic',
    },
    {
      german: "vor allem",
      translated: "πρωτίστως",
      tone: 'semantic',
    },
    {
      german: "Aufgabe",
      translated: "ευθύνη",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:248|en": [
    {
      german: "Die Erziehung der Kinder",
      translated: "Raising children",
      tone: 'semantic',
    },
    {
      german: "ist in Deutschland",
      translated: "in Germany",
      tone: 'semantic',
    },
    {
      german: "vor allem",
      translated: "primarily",
      tone: 'semantic',
    },
    {
      german: "Aufgabe",
      translated: "task of …",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:248|es": [
    {
      german: "Die Erziehung der Kinder",
      translated: "La educación de los hijos",
      tone: 'semantic',
    },
    {
      german: "ist in Deutschland",
      translated: "en Alemania",
      tone: 'semantic',
    },
    {
      german: "vor allem",
      translated: "principalmente",
      tone: 'semantic',
    },
    {
      german: "Aufgabe",
      translated: "responsabilidad de …",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:248|fa": [
    {
      german: "Die Erziehung der Kinder",
      translated: "تربیت کودکان",
      tone: 'semantic',
    },
    {
      german: "ist in Deutschland",
      translated: "در آلمان",
      tone: 'semantic',
    },
    {
      german: "vor allem",
      translated: "در درجهٔ اول",
      tone: 'semantic',
    },
    {
      german: "Aufgabe",
      translated: "وظیفهٔ",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:248|fr": [
    {
      german: "Die Erziehung der Kinder",
      translated: "l’éducation des enfants",
      tone: 'semantic',
    },
    {
      german: "ist in Deutschland",
      translated: "En Allemagne",
      tone: 'semantic',
    },
    {
      german: "vor allem",
      translated: "avant tout",
      tone: 'semantic',
    },
    {
      german: "Aufgabe",
      translated: "la responsabilité",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:248|hr": [
    {
      german: "Die Erziehung der Kinder",
      translated: "odgoj djece",
      tone: 'semantic',
    },
    {
      german: "ist in Deutschland",
      translated: "U Njemačkoj je",
      tone: 'semantic',
    },
    {
      german: "vor allem",
      translated: "prvenstveno",
      tone: 'semantic',
    },
    {
      german: "Aufgabe",
      translated: "zadaća",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:248|it": [
    {
      german: "Die Erziehung der Kinder",
      translated: "l’educazione dei figli",
      tone: 'semantic',
    },
    {
      german: "ist in Deutschland",
      translated: "In Germania",
      tone: 'semantic',
    },
    {
      german: "vor allem",
      translated: "soprattutto",
      tone: 'semantic',
    },
    {
      german: "Aufgabe",
      translated: "responsabilità",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:248|kmr": [
    {
      german: "Die Erziehung der Kinder",
      translated: "Perwerdehiya",
      tone: 'semantic',
    },
    {
      german: "ist in Deutschland",
      translated: "zarokan li Almanyayê",
      tone: 'semantic',
    },
    {
      german: "vor allem",
      translated: "bi taybetî",
      tone: 'semantic',
    },
    {
      german: "Aufgabe",
      translated: "erka",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:248|pl": [
    {
      german: "Die Erziehung der Kinder",
      translated: "wychowanie dzieci",
      tone: 'semantic',
    },
    {
      german: "ist in Deutschland",
      translated: "W Niemczech",
      tone: 'semantic',
    },
    {
      german: "vor allem",
      translated: "przede wszystkim",
      tone: 'semantic',
    },
    {
      german: "Aufgabe",
      translated: "obowiązkiem",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:248|prs": [
    {
      german: "Die Erziehung der Kinder",
      translated: "در آلمان تربیت کودکان",
      tone: 'semantic',
    },
    {
      german: "ist in Deutschland",
      translated: "در درجهٔ اول",
      tone: 'semantic',
    },
    {
      german: "vor allem",
      translated: "وظیفهٔ",
      tone: 'semantic',
    },
    {
      german: "Aufgabe",
      translated: "است.",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:248|ro": [
    {
      german: "Die Erziehung der Kinder",
      translated: "educarea copiilor",
      tone: 'semantic',
    },
    {
      german: "ist in Deutschland",
      translated: "În Germania",
      tone: 'semantic',
    },
    {
      german: "vor allem",
      translated: "în primul rând",
      tone: 'semantic',
    },
    {
      german: "Aufgabe",
      translated: "responsabilitatea",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:248|ru": [
    {
      german: "Die Erziehung der Kinder",
      translated: "Воспитание детей",
      tone: 'semantic',
    },
    {
      german: "ist in Deutschland",
      translated: "в Германии — это",
      tone: 'semantic',
    },
    {
      german: "vor allem",
      translated: "в первую очередь",
      tone: 'semantic',
    },
    {
      german: "Aufgabe",
      translated: "задача",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:248|sq": [
    {
      german: "Die Erziehung der Kinder",
      translated: "edukimi i fëmijëve",
      tone: 'semantic',
    },
    {
      german: "ist in Deutschland",
      translated: "Në Gjermani",
      tone: 'semantic',
    },
    {
      german: "vor allem",
      translated: "para së gjithash",
      tone: 'semantic',
    },
    {
      german: "Aufgabe",
      translated: "përgjegjësi",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:248|sr": [
    {
      german: "Die Erziehung der Kinder",
      translated: "Nemačkoj je vaspitanje dece",
      tone: 'semantic',
    },
    {
      german: "ist in Deutschland",
      translated: "U",
      tone: 'semantic',
    },
    {
      german: "vor allem",
      translated: "prvenstveno",
      tone: 'semantic',
    },
    {
      german: "Aufgabe",
      translated: "zadaća",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:248|tr": [
    {
      german: "Die Erziehung der Kinder",
      translated: "çocukların yetiştirilmesi",
      tone: 'semantic',
    },
    {
      german: "ist in Deutschland",
      translated: "Almanya'da",
      tone: 'semantic',
    },
    {
      german: "vor allem",
      translated: "öncelikle",
      tone: 'semantic',
    },
    {
      german: "Aufgabe",
      translated: "görevidir",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:248|uk": [
    {
      german: "Die Erziehung der Kinder",
      translated: "Виховання дітей",
      tone: 'semantic',
    },
    {
      german: "ist in Deutschland",
      translated: "у Німеччині",
      tone: 'semantic',
    },
    {
      german: "vor allem",
      translated: "передусім",
      tone: 'semantic',
    },
    {
      german: "Aufgabe",
      translated: "завданням",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:248|vi": [
    {
      german: "Die Erziehung der Kinder",
      translated: "nuôi dạy con cái",
      tone: 'semantic',
    },
    {
      german: "ist in Deutschland",
      translated: "Ở Đức",
      tone: 'semantic',
    },
    {
      german: "vor allem",
      translated: "chủ yếu",
      tone: 'semantic',
    },
    {
      german: "Aufgabe",
      translated: "trách nhiệm",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:249|ar": [
    {
      german: "Wer ist",
      translated: "من",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "في ألمانيا",
      tone: 'semantic',
    },
    {
      german: "hauptsächlich",
      translated: "أساسًا",
      tone: 'semantic',
    },
    {
      german: "verantwortlich",
      translated: "المسؤول",
      tone: 'semantic',
    },
    {
      german: "für die Kindererziehung",
      translated: "عن تربية الأطفال",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:249|bg": [
    {
      german: "Wer ist",
      translated: "Кой е",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "в Германия",
      tone: 'semantic',
    },
    {
      german: "hauptsächlich",
      translated: "преди всичко",
      tone: 'semantic',
    },
    {
      german: "verantwortlich",
      translated: "отговорен",
      tone: 'semantic',
    },
    {
      german: "für die Kindererziehung",
      translated: "възпитанието на децата",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:249|bs": [
    {
      german: "Wer ist",
      translated: "Tko je",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "u Njemačkoj",
      tone: 'semantic',
    },
    {
      german: "hauptsächlich",
      translated: "prvenstveno",
      tone: 'semantic',
    },
    {
      german: "verantwortlich",
      translated: "odgovoran",
      tone: 'semantic',
    },
    {
      german: "für die Kindererziehung",
      translated: "za odgoj djece?",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:249|el": [
    {
      german: "Wer ist",
      translated: "Ποιος είναι",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "στη Γερμανία",
      tone: 'semantic',
    },
    {
      german: "hauptsächlich",
      translated: "πρωτίστως",
      tone: 'semantic',
    },
    {
      german: "verantwortlich",
      translated: "υπεύθυνος",
      tone: 'semantic',
    },
    {
      german: "für die Kindererziehung",
      translated: "για την ανατροφή των παιδιών",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:249|en": [
    {
      german: "Wer ist",
      translated: "Who is",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "in Germany",
      tone: 'semantic',
    },
    {
      german: "hauptsächlich",
      translated: "primarily",
      tone: 'semantic',
    },
    {
      german: "verantwortlich",
      translated: "responsible",
      tone: 'semantic',
    },
    {
      german: "für die Kindererziehung",
      translated: "for raising children",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:249|es": [
    {
      german: "Wer ist",
      translated: "¿Quién es",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "en Alemania",
      tone: 'semantic',
    },
    {
      german: "hauptsächlich",
      translated: "principalmente",
      tone: 'semantic',
    },
    {
      german: "verantwortlich",
      translated: "responsable",
      tone: 'semantic',
    },
    {
      german: "für die Kindererziehung",
      translated: "de la educación de los hijos",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:249|fa": [
    {
      german: "Wer ist",
      translated: "چه کسانی",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "در آلمان",
      tone: 'semantic',
    },
    {
      german: "hauptsächlich",
      translated: "در درجهٔ اول",
      tone: 'semantic',
    },
    {
      german: "verantwortlich",
      translated: "مسئول",
      tone: 'semantic',
    },
    {
      german: "für die Kindererziehung",
      translated: "تربیت کودکان",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:249|fr": [
    {
      german: "Wer ist",
      translated: "Qui est",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "en Allemagne",
      tone: 'semantic',
    },
    {
      german: "hauptsächlich",
      translated: "principalement",
      tone: 'semantic',
    },
    {
      german: "verantwortlich",
      translated: "responsable",
      tone: 'semantic',
    },
    {
      german: "für die Kindererziehung",
      translated: "de l’éducation des enfants",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:249|hr": [
    {
      german: "Wer ist",
      translated: "Tko je",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "u Njemačkoj",
      tone: 'semantic',
    },
    {
      german: "hauptsächlich",
      translated: "prvenstveno",
      tone: 'semantic',
    },
    {
      german: "verantwortlich",
      translated: "odgovoran",
      tone: 'semantic',
    },
    {
      german: "für die Kindererziehung",
      translated: "za odgoj djece",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:249|it": [
    {
      german: "Wer ist",
      translated: "Chi è",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "in Germania",
      tone: 'semantic',
    },
    {
      german: "hauptsächlich",
      translated: "principalmente",
      tone: 'semantic',
    },
    {
      german: "verantwortlich",
      translated: "responsabile",
      tone: 'semantic',
    },
    {
      german: "für die Kindererziehung",
      translated: "dell’educazione dei figli",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:249|kmr": [
    {
      german: "Wer ist",
      translated: "kî",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "Li Almanyayê",
      tone: 'semantic',
    },
    {
      german: "hauptsächlich",
      translated: "bi taybetî",
      tone: 'semantic',
    },
    {
      german: "verantwortlich",
      translated: "berpirsiyar",
      tone: 'semantic',
    },
    {
      german: "für die Kindererziehung",
      translated: "ji perwerdehiya zarokan",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:249|pl": [
    {
      german: "Wer ist",
      translated: "Kto",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "w Niemczech",
      tone: 'semantic',
    },
    {
      german: "hauptsächlich",
      translated: "przede wszystkim",
      tone: 'semantic',
    },
    {
      german: "verantwortlich",
      translated: "odpowiedzialny",
      tone: 'semantic',
    },
    {
      german: "für die Kindererziehung",
      translated: "za wychowanie dzieci",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:249|prs": [
    {
      german: "Wer ist",
      translated: "چه کسانی",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "در آلمان",
      tone: 'semantic',
    },
    {
      german: "hauptsächlich",
      translated: "در درجهٔ اول",
      tone: 'semantic',
    },
    {
      german: "verantwortlich",
      translated: "مسئول",
      tone: 'semantic',
    },
    {
      german: "für die Kindererziehung",
      translated: "تربیت کودکان",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:249|ro": [
    {
      german: "Wer ist",
      translated: "Cine este",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "în Germania",
      tone: 'semantic',
    },
    {
      german: "hauptsächlich",
      translated: "în primul rând",
      tone: 'semantic',
    },
    {
      german: "verantwortlich",
      translated: "responsabil",
      tone: 'semantic',
    },
    {
      german: "für die Kindererziehung",
      translated: "pentru educarea copiilor",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:249|ru": [
    {
      german: "Wer ist",
      translated: "Кто",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "в Германии",
      tone: 'semantic',
    },
    {
      german: "hauptsächlich",
      translated: "основную",
      tone: 'semantic',
    },
    {
      german: "verantwortlich",
      translated: "ответственность",
      tone: 'semantic',
    },
    {
      german: "für die Kindererziehung",
      translated: "за воспитание детей",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:249|sq": [
    {
      german: "Wer ist",
      translated: "Kush është",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "në Gjermani",
      tone: 'semantic',
    },
    {
      german: "verantwortlich",
      translated: "para",
      tone: 'semantic',
    },
    {
      german: "für die Kindererziehung",
      translated: "për edukimin e fëmijëve",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:249|sr": [
    {
      german: "Wer ist",
      translated: "Ko je",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "u Nemačkoj",
      tone: 'semantic',
    },
    {
      german: "hauptsächlich",
      translated: "prvenstveno",
      tone: 'semantic',
    },
    {
      german: "verantwortlich",
      translated: "odgovoran",
      tone: 'semantic',
    },
    {
      german: "für die Kindererziehung",
      translated: "za vaspitanje dece",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:249|tr": [
    {
      german: "Wer ist",
      translated: "kim",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "Almanya'da",
      tone: 'semantic',
    },
    {
      german: "hauptsächlich",
      translated: "esas olarak",
      tone: 'semantic',
    },
    {
      german: "verantwortlich",
      translated: "sorumludur",
      tone: 'semantic',
    },
    {
      german: "für die Kindererziehung",
      translated: "çocukların yetiştirilmesinden",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:249|uk": [
    {
      german: "Wer ist",
      translated: "Хто",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "в Німеччині",
      tone: 'semantic',
    },
    {
      german: "hauptsächlich",
      translated: "головним чином",
      tone: 'semantic',
    },
    {
      german: "verantwortlich",
      translated: "відповідає",
      tone: 'semantic',
    },
    {
      german: "für die Kindererziehung",
      translated: "за виховання дітей",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:249|vi": [
    {
      german: "Wer ist",
      translated: "Ai",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "ở Đức",
      tone: 'semantic',
    },
    {
      german: "hauptsächlich",
      translated: "chủ yếu",
      tone: 'semantic',
    },
    {
      german: "verantwortlich",
      translated: "chịu trách nhiệm",
      tone: 'semantic',
    },
    {
      german: "für die Kindererziehung",
      translated: "nuôi dạy con cái",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:24|ar": [
    {
      german: "Wie viele",
      translated: "كم عدد",
      tone: 'semantic',
    },
    {
      german: "Bundesländer",
      translated: "الولايات الاتحادية",
      tone: 'semantic',
    },
    {
      german: "Bundesrepublik Deutschland",
      translated: "جمهورية ألمانيا الاتحادية",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:24|bg": [
    {
      german: "Wie viele",
      translated: "Колко",
      tone: 'semantic',
    },
    {
      german: "Bundesländer",
      translated: "федерални провинции",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "има",
      tone: 'semantic',
    },
    {
      german: "Bundesrepublik Deutschland",
      translated: "Федерална република Германия",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:24|bs": [
    {
      german: "Wie viele",
      translated: "Koliko",
      tone: 'semantic',
    },
    {
      german: "Bundesländer",
      translated: "saveznih zemalja",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "ima",
      tone: 'semantic',
    },
    {
      german: "Bundesrepublik Deutschland",
      translated: "Savezna Republika Njemačka",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:24|el": [
    {
      german: "Wie viele",
      translated: "Πόσα",
      tone: 'semantic',
    },
    {
      german: "Bundesländer",
      translated: "ομόσπονδα κρατίδια",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "έχει",
      tone: 'semantic',
    },
    {
      german: "die",
      translated: "η",
      tone: 'semantic',
    },
    {
      german: "Bundesrepublik Deutschland",
      translated: "Ομοσπονδιακή Δημοκρατία της Γερμανίας",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:24|en": [
    {
      german: "Wie viele",
      translated: "How many",
      tone: 'semantic',
    },
    {
      german: "Bundesländer",
      translated: "federal states",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "have",
      tone: 'semantic',
    },
    {
      german: "die",
      translated: "the",
      tone: 'semantic',
    },
    {
      german: "Bundesrepublik Deutschland",
      translated: "Federal Republic of Germany",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:24|es": [
    {
      german: "Wie viele",
      translated: "¿Cuántos",
      tone: 'semantic',
    },
    {
      german: "Bundesländer",
      translated: "estados federados",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "tiene",
      tone: 'semantic',
    },
    {
      german: "die",
      translated: "la",
      tone: 'semantic',
    },
    {
      german: "Bundesrepublik Deutschland",
      translated: "República Federal de Alemania",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:24|fa": [
    {
      german: "Wie viele",
      translated: "چند",
      tone: 'semantic',
    },
    {
      german: "Bundesländer",
      translated: "ایالت",
      tone: 'semantic',
    },
    {
      german: "Bundesrepublik Deutschland",
      translated: "جمهوری فدرال آلمان",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:24|fr": [
    {
      german: "Wie viele",
      translated: "Combien de",
      tone: 'semantic',
    },
    {
      german: "Bundesländer",
      translated: "Länder",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "compte",
      tone: 'semantic',
    },
    {
      german: "Bundesrepublik Deutschland",
      translated: "République fédérale d’Allemagne",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:24|hr": [
    {
      german: "Wie viele",
      translated: "Koliko",
      tone: 'semantic',
    },
    {
      german: "Bundesländer",
      translated: "zemalja",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "ima",
      tone: 'semantic',
    },
    {
      german: "die",
      translated: "Savezna",
      tone: 'semantic',
    },
    {
      german: "Bundesrepublik Deutschland",
      translated: "Republika Njemačka",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:24|it": [
    {
      german: "Wie viele",
      translated: "Quanti",
      tone: 'semantic',
    },
    {
      german: "Bundesländer",
      translated: "Länder",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "ha",
      tone: 'semantic',
    },
    {
      german: "die",
      translated: "la",
      tone: 'semantic',
    },
    {
      german: "Bundesrepublik Deutschland",
      translated: "Repubblica Federale di Germania",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:24|kmr": [
    {
      german: "Wie viele",
      translated: "çend",
      tone: 'semantic',
    },
    {
      german: "Bundesländer",
      translated: "eyaletên federal",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "hene",
      tone: 'semantic',
    },
    {
      german: "Bundesrepublik Deutschland",
      translated: "Komara Federal a Almanyayê",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:24|pl": [
    {
      german: "Wie viele",
      translated: "Ile",
      tone: 'semantic',
    },
    {
      german: "Bundesländer",
      translated: "krajów związkowych",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "ma",
      tone: 'semantic',
    },
    {
      german: "Bundesrepublik Deutschland",
      translated: "Republika Federalna Niemiec",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:24|prs": [
    {
      german: "Wie viele",
      translated: "چند",
      tone: 'semantic',
    },
    {
      german: "Bundesländer",
      translated: "ایالت",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "دارد",
      tone: 'semantic',
    },
    {
      german: "Bundesrepublik Deutschland",
      translated: "جمهوری فدرال آلمان",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:24|ro": [
    {
      german: "Wie viele",
      translated: "Câte",
      tone: 'semantic',
    },
    {
      german: "Bundesländer",
      translated: "landuri",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "are",
      tone: 'semantic',
    },
    {
      german: "Bundesrepublik Deutschland",
      translated: "Republica Federală Germania",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:24|ru": [
    {
      german: "Wie viele",
      translated: "Сколько",
      tone: 'semantic',
    },
    {
      german: "Bundesländer",
      translated: "федеральных земель",
      tone: 'semantic',
    },
    {
      german: "Bundesrepublik Deutschland",
      translated: "Федеративной Республике Германия",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:24|sq": [
    {
      german: "Wie viele",
      translated: "Sa",
      tone: 'semantic',
    },
    {
      german: "Bundesländer",
      translated: "lande",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "ka",
      tone: 'semantic',
    },
    {
      german: "die",
      translated: "Republika",
      tone: 'semantic',
    },
    {
      german: "Bundesrepublik Deutschland",
      translated: "Federale e Gjermanisë",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:24|sr": [
    {
      german: "Wie viele",
      translated: "Koliko",
      tone: 'semantic',
    },
    {
      german: "Bundesländer",
      translated: "saveznih pokrajina",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "ima",
      tone: 'semantic',
    },
    {
      german: "Bundesrepublik Deutschland",
      translated: "Savezna Republika Nemačka",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:24|tr": [
    {
      german: "Wie viele",
      translated: "kaç",
      tone: 'semantic',
    },
    {
      german: "Bundesländer",
      translated: "eyalet (Bundesland)",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "vardır",
      tone: 'semantic',
    },
    {
      german: "Bundesrepublik Deutschland",
      translated: "Almanya Federal Cumhuriyeti'nde",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:24|uk": [
    {
      german: "Wie viele",
      translated: "Скільки",
      tone: 'semantic',
    },
    {
      german: "Bundesländer",
      translated: "федеральних земель",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "має",
      tone: 'semantic',
    },
    {
      german: "Bundesrepublik Deutschland",
      translated: "Федеративна Республіка Німеччина",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:24|vi": [
    {
      german: "Wie viele",
      translated: "bao nhiêu",
      tone: 'semantic',
    },
    {
      german: "Bundesländer",
      translated: "bang",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "có",
      tone: 'semantic',
    },
    {
      german: "Bundesrepublik Deutschland",
      translated: "Cộng hòa Liên bang Đức",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:250|ar": [
    {
      german: "In Deutschland",
      translated: "في ألمانيا",
      tone: 'semantic',
    },
    {
      german: "hat man",
      translated: "تكون",
      tone: 'semantic',
    },
    {
      german: "die besten Chancen",
      translated: "أفضل",
      tone: 'semantic',
    },
    {
      german: "auf einen gut bezahlten Arbeitsplatz",
      translated: "الحصول على وظيفة جيدة الأجر",
      tone: 'semantic',
    },
    {
      german: "wenn man",
      translated: "عندما يكون الشخص",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:250|bg": [
    {
      german: "In Deutschland",
      translated: "В Германия",
      tone: 'semantic',
    },
    {
      german: "hat man",
      translated: "имате",
      tone: 'semantic',
    },
    {
      german: "die besten Chancen",
      translated: "най-добри шансове",
      tone: 'semantic',
    },
    {
      german: "auf einen gut bezahlten Arbeitsplatz",
      translated: "за добре платена работа",
      tone: 'semantic',
    },
    {
      german: "wenn man",
      translated: "ако",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:250|bs": [
    {
      german: "In Deutschland",
      translated: "U Njemačkoj",
      tone: 'semantic',
    },
    {
      german: "die besten Chancen",
      translated: "najbolje izglede",
      tone: 'semantic',
    },
    {
      german: "auf einen gut bezahlten Arbeitsplatz",
      translated: "za dobro platen posao",
      tone: 'semantic',
    },
    {
      german: "wenn man",
      translated: "ima osoba koja",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:250|el": [
    {
      german: "In Deutschland",
      translated: "Στη Γερμανία",
      tone: 'semantic',
    },
    {
      german: "hat man",
      translated: "έχει κανείς",
      tone: 'semantic',
    },
    {
      german: "die besten Chancen",
      translated: "τις καλύτερες πιθανότητες",
      tone: 'semantic',
    },
    {
      german: "auf einen gut bezahlten Arbeitsplatz",
      translated: "για καλά αμειβόμενη εργασία",
      tone: 'semantic',
    },
    {
      german: "wenn man",
      translated: "όταν",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:250|en": [
    {
      german: "In Deutschland",
      translated: "In Germany,",
      tone: 'semantic',
    },
    {
      german: "hat man",
      translated: "you have",
      tone: 'semantic',
    },
    {
      german: "die besten Chancen",
      translated: "the best chances",
      tone: 'semantic',
    },
    {
      german: "auf einen gut bezahlten Arbeitsplatz",
      translated: "for a well-paid job",
      tone: 'semantic',
    },
    {
      german: "wenn man",
      translated: "if you …",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:250|es": [
    {
      german: "In Deutschland",
      translated: "En Alemania",
      tone: 'semantic',
    },
    {
      german: "hat man",
      translated: "se tienen",
      tone: 'semantic',
    },
    {
      german: "die besten Chancen",
      translated: "mejores oportunidades",
      tone: 'semantic',
    },
    {
      german: "auf einen gut bezahlten Arbeitsplatz",
      translated: "de conseguir un trabajo bien remunerado",
      tone: 'semantic',
    },
    {
      german: "wenn man",
      translated: "si se",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:250|fa": [
    {
      german: "In Deutschland",
      translated: "در آلمان",
      tone: 'semantic',
    },
    {
      german: "hat man",
      translated: "فرد",
      tone: 'semantic',
    },
    {
      german: "die besten Chancen",
      translated: "بهترین شانس",
      tone: 'semantic',
    },
    {
      german: "auf einen gut bezahlten Arbeitsplatz",
      translated: "برای یافتن شغلی با درآمد خوب",
      tone: 'semantic',
    },
    {
      german: "wenn man",
      translated: "زمانی است که",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:250|fr": [
    {
      german: "In Deutschland",
      translated: "En Allemagne",
      tone: 'semantic',
    },
    {
      german: "hat man",
      translated: "on a",
      tone: 'semantic',
    },
    {
      german: "die besten Chancen",
      translated: "les meilleures chances",
      tone: 'semantic',
    },
    {
      german: "auf einen gut bezahlten Arbeitsplatz",
      translated: "d’obtenir un emploi bien rémunéré",
      tone: 'semantic',
    },
    {
      german: "wenn man",
      translated: "lorsqu’on",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:250|hr": [
    {
      german: "In Deutschland",
      translated: "U Njemačkoj",
      tone: 'semantic',
    },
    {
      german: "die besten Chancen",
      translated: "najbolje izglede",
      tone: 'semantic',
    },
    {
      german: "auf einen gut bezahlten Arbeitsplatz",
      translated: "za dobro plaćen posao",
      tone: 'semantic',
    },
    {
      german: "wenn man",
      translated: "osoba koja",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:250|it": [
    {
      german: "In Deutschland",
      translated: "In Germania",
      tone: 'semantic',
    },
    {
      german: "hat man",
      translated: "si hanno",
      tone: 'semantic',
    },
    {
      german: "die besten Chancen",
      translated: "le migliori possibilità",
      tone: 'semantic',
    },
    {
      german: "auf einen gut bezahlten Arbeitsplatz",
      translated: "di ottenere un lavoro ben retribuito",
      tone: 'semantic',
    },
    {
      german: "wenn man",
      translated: "se",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:250|kmr": [
    {
      german: "In Deutschland",
      translated: "Li Almanyayê",
      tone: 'semantic',
    },
    {
      german: "hat man",
      translated: "e",
      tone: 'semantic',
    },
    {
      german: "die besten Chancen",
      translated: "şansê",
      tone: 'semantic',
    },
    {
      german: "auf einen gut bezahlten Arbeitsplatz",
      translated: "karê bi mûçeya baş",
      tone: 'semantic',
    },
    {
      german: "wenn man",
      translated: "heke kes",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:250|pl": [
    {
      german: "In Deutschland",
      translated: "W Niemczech",
      tone: 'semantic',
    },
    {
      german: "hat man",
      translated: "ma",
      tone: 'semantic',
    },
    {
      german: "die besten Chancen",
      translated: "największe szanse",
      tone: 'semantic',
    },
    {
      german: "auf einen gut bezahlten Arbeitsplatz",
      translated: "na dobrze płatną pracę",
      tone: 'semantic',
    },
    {
      german: "wenn man",
      translated: "która",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:250|prs": [
    {
      german: "In Deutschland",
      translated: "در آلمان",
      tone: 'semantic',
    },
    {
      german: "hat man",
      translated: "فرد",
      tone: 'semantic',
    },
    {
      german: "die besten Chancen",
      translated: "بهترین شانس",
      tone: 'semantic',
    },
    {
      german: "auf einen gut bezahlten Arbeitsplatz",
      translated: "برای یافتن شغلی با درآمد خوب",
      tone: 'semantic',
    },
    {
      german: "wenn man",
      translated: "زمانی است که",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:250|ro": [
    {
      german: "In Deutschland",
      translated: "În Germania",
      tone: 'semantic',
    },
    {
      german: "hat man",
      translated: "ai",
      tone: 'semantic',
    },
    {
      german: "die besten Chancen",
      translated: "cele mai bune șanse",
      tone: 'semantic',
    },
    {
      german: "auf einen gut bezahlten Arbeitsplatz",
      translated: "la un loc de muncă bine plătit",
      tone: 'semantic',
    },
    {
      german: "wenn man",
      translated: "dacă",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:250|ru": [
    {
      german: "In Deutschland",
      translated: "В Германии",
      tone: 'semantic',
    },
    {
      german: "die besten Chancen",
      translated: "наилучшие шансы",
      tone: 'semantic',
    },
    {
      german: "auf einen gut bezahlten Arbeitsplatz",
      translated: "получить хорошо оплачиваемую работу",
      tone: 'semantic',
    },
    {
      german: "wenn man",
      translated: "у того, кто",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:250|sq": [
    {
      german: "In Deutschland",
      translated: "Në Gjermani",
      tone: 'semantic',
    },
    {
      german: "hat man",
      translated: "keni",
      tone: 'semantic',
    },
    {
      german: "die besten Chancen",
      translated: "shanset më të mira",
      tone: 'semantic',
    },
    {
      german: "auf einen gut bezahlten Arbeitsplatz",
      translated: "për një punë të paguar mirë",
      tone: 'semantic',
    },
    {
      german: "wenn man",
      translated: "nëse",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:250|sr": [
    {
      german: "In Deutschland",
      translated: "U Nemačkoj",
      tone: 'semantic',
    },
    {
      german: "hat man",
      translated: "ima osoba koja",
      tone: 'semantic',
    },
    {
      german: "die besten Chancen",
      translated: "najbolje izglede",
      tone: 'semantic',
    },
    {
      german: "auf einen gut bezahlten Arbeitsplatz",
      translated: "za dobro platen posao",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:250|tr": [
    {
      german: "In Deutschland",
      translated: "Almanya'da",
      tone: 'semantic',
    },
    {
      german: "hat man",
      translated: "olan kişi",
      tone: 'semantic',
    },
    {
      german: "die besten Chancen",
      translated: "şansı en yüksek",
      tone: 'semantic',
    },
    {
      german: "auf einen gut bezahlten Arbeitsplatz",
      translated: "iyi ücretli bir iş bulma",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:250|uk": [
    {
      german: "In Deutschland",
      translated: "У Німеччині",
      tone: 'semantic',
    },
    {
      german: "hat man",
      translated: "має людина",
      tone: 'semantic',
    },
    {
      german: "die besten Chancen",
      translated: "найкращі шанси",
      tone: 'semantic',
    },
    {
      german: "auf einen gut bezahlten Arbeitsplatz",
      translated: "добре оплачувану роботу",
      tone: 'semantic',
    },
    {
      german: "wenn man",
      translated: "якщо вона",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:250|vi": [
    {
      german: "In Deutschland",
      translated: "Ở Đức",
      tone: 'semantic',
    },
    {
      german: "die besten Chancen",
      translated: "cơ hội có",
      tone: 'semantic',
    },
    {
      german: "auf einen gut bezahlten Arbeitsplatz",
      translated: "một công việc lương tốt",
      tone: 'semantic',
    },
    {
      german: "wenn man",
      translated: "nếu",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:251|ar": [
    {
      german: "Wenn man",
      translated: "إذا",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "في ألمانيا",
      tone: 'semantic',
    },
    {
      german: "ein Kind",
      translated: "طفلًا",
      tone: 'semantic',
    },
    {
      german: "schlägt",
      translated: "ضرب",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:251|bg": [
    {
      german: "Wenn man",
      translated: "Ако някой",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "в Германия",
      tone: 'semantic',
    },
    {
      german: "ein Kind",
      translated: "дете",
      tone: 'semantic',
    },
    {
      german: "schlägt",
      translated: "удари",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:251|bs": [
    {
      german: "Wenn man",
      translated: "Ako neko",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "u Njemačkoj",
      tone: 'semantic',
    },
    {
      german: "ein Kind",
      translated: "dijete",
      tone: 'semantic',
    },
    {
      german: "schlägt",
      translated: "tuče",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:251|el": [
    {
      german: "Wenn man",
      translated: "Αν κάποιος",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "στη Γερμανία",
      tone: 'semantic',
    },
    {
      german: "ein Kind",
      translated: "ένα παιδί",
      tone: 'semantic',
    },
    {
      german: "schlägt",
      translated: "χτυπήσει",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:251|en": [
    {
      german: "Wenn man",
      translated: "If you",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "in Germany",
      tone: 'semantic',
    },
    {
      german: "ein Kind",
      translated: "a child",
      tone: 'semantic',
    },
    {
      german: "schlägt",
      translated: "hit",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:251|es": [
    {
      german: "Wenn man",
      translated: "Si alguien",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "en Alemania",
      tone: 'semantic',
    },
    {
      german: "ein Kind",
      translated: "un niño",
      tone: 'semantic',
    },
    {
      german: "schlägt",
      translated: "pega",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:251|fa": [
    {
      german: "Wenn man",
      translated: "اگر کسی",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "در آلمان",
      tone: 'semantic',
    },
    {
      german: "ein Kind",
      translated: "کودکی",
      tone: 'semantic',
    },
    {
      german: "schlägt",
      translated: "کتک بزند",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:251|fr": [
    {
      german: "Wenn man",
      translated: "Si quelqu’un",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "en Allemagne",
      tone: 'semantic',
    },
    {
      german: "ein Kind",
      translated: "un enfant",
      tone: 'semantic',
    },
    {
      german: "schlägt",
      translated: "frappe",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:251|hr": [
    {
      german: "Wenn man",
      translated: "Ako netko",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "u Njemačkoj",
      tone: 'semantic',
    },
    {
      german: "ein Kind",
      translated: "dijete",
      tone: 'semantic',
    },
    {
      german: "schlägt",
      translated: "tuče",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:251|it": [
    {
      german: "Wenn man",
      translated: "Se qualcuno",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "in Germania",
      tone: 'semantic',
    },
    {
      german: "ein Kind",
      translated: "un bambino",
      tone: 'semantic',
    },
    {
      german: "schlägt",
      translated: "picchia",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:251|kmr": [
    {
      german: "Wenn man",
      translated: "Heke",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "li Almanyayê",
      tone: 'semantic',
    },
    {
      german: "ein Kind",
      translated: "kesek zarokek",
      tone: 'semantic',
    },
    {
      german: "schlägt",
      translated: "bide",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:251|pl": [
    {
      german: "Wenn man",
      translated: "Jeżeli ktoś",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "w Niemczech",
      tone: 'semantic',
    },
    {
      german: "ein Kind",
      translated: "dziecko",
      tone: 'semantic',
    },
    {
      german: "schlägt",
      translated: "bije",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:251|prs": [
    {
      german: "Wenn man",
      translated: "اگر کسی",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "در آلمان",
      tone: 'semantic',
    },
    {
      german: "ein Kind",
      translated: "کودکی",
      tone: 'semantic',
    },
    {
      german: "schlägt",
      translated: "کتک بزند",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:251|ro": [
    {
      german: "Wenn man",
      translated: "Dacă cineva",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "în Germania",
      tone: 'semantic',
    },
    {
      german: "ein Kind",
      translated: "un copil",
      tone: 'semantic',
    },
    {
      german: "schlägt",
      translated: "lovește",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:251|ru": [
    {
      german: "Wenn man",
      translated: "Если",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "в Германии",
      tone: 'semantic',
    },
    {
      german: "ein Kind",
      translated: "ребёнка",
      tone: 'semantic',
    },
    {
      german: "schlägt",
      translated: "…",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:251|sq": [
    {
      german: "Wenn man",
      translated: "Nëse dikush",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "në Gjermani",
      tone: 'semantic',
    },
    {
      german: "ein Kind",
      translated: "një fëmijë",
      tone: 'semantic',
    },
    {
      german: "schlägt",
      translated: "godet",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:251|sr": [
    {
      german: "Wenn man",
      translated: "Ako neko",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "u Nemačkoj",
      tone: 'semantic',
    },
    {
      german: "ein Kind",
      translated: "dete",
      tone: 'semantic',
    },
    {
      german: "schlägt",
      translated: "tuče",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:251|tr": [
    {
      german: "in Deutschland",
      translated: "Almanya'da",
      tone: 'semantic',
    },
    {
      german: "ein Kind",
      translated: "bir çocuğa",
      tone: 'semantic',
    },
    {
      german: "schlägt",
      translated: "vurursanız",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:251|uk": [
    {
      german: "Wenn man",
      translated: "Якщо",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "в Німеччині",
      tone: 'semantic',
    },
    {
      german: "ein Kind",
      translated: "дитину",
      tone: 'semantic',
    },
    {
      german: "schlägt",
      translated: "вдарити",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:251|vi": [
    {
      german: "Wenn man",
      translated: "Nếu ai đó",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "ở Đức",
      tone: 'semantic',
    },
    {
      german: "ein Kind",
      translated: "một đứa trẻ",
      tone: 'semantic',
    },
    {
      german: "schlägt",
      translated: "đánh",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:252|ar": [
    {
      german: "In",
      translated: "في",
      tone: 'semantic',
    },
    {
      german: "Deutschland",
      translated: "ألمانيا",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:252|bg": [
    {
      german: "In",
      translated: "В",
      tone: 'semantic',
    },
    {
      german: "Deutschland",
      translated: "Германия",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:252|bs": [
    {
      german: "In",
      translated: "U",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:252|el": [
    {
      german: "In",
      translated: "Στη",
      tone: 'semantic',
    },
    {
      german: "Deutschland",
      translated: "Γερμανία",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:252|en": [
    {
      german: "In",
      translated: "In",
      tone: 'semantic',
    },
    {
      german: "Deutschland",
      translated: "Germany",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:252|es": [
    {
      german: "In",
      translated: "En",
      tone: 'semantic',
    },
    {
      german: "Deutschland",
      translated: "Alemania",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:252|fa": [
    {
      german: "In",
      translated: "در",
      tone: 'semantic',
    },
    {
      german: "Deutschland",
      translated: "آلمان",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:252|fr": [
    {
      german: "In",
      translated: "En",
      tone: 'semantic',
    },
    {
      german: "Deutschland",
      translated: "Allemagne",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:252|hr": [
    {
      german: "In",
      translated: "U",
      tone: 'semantic',
    },
    {
      german: "Deutschland",
      translated: "Njemačkoj",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:252|it": [
    {
      german: "In",
      translated: "In",
      tone: 'semantic',
    },
    {
      german: "Deutschland",
      translated: "Germania",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:252|kmr": [
    {
      german: "In",
      translated: "Li",
      tone: 'semantic',
    },
    {
      german: "Deutschland",
      translated: "Almanyayê",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:252|pl": [
    {
      german: "In",
      translated: "W",
      tone: 'semantic',
    },
    {
      german: "Deutschland",
      translated: "Niemczech",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:252|prs": [
    {
      german: "In",
      translated: "در",
      tone: 'semantic',
    },
    {
      german: "Deutschland",
      translated: "آلمان",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:252|ro": [
    {
      german: "In",
      translated: "În",
      tone: 'semantic',
    },
    {
      german: "Deutschland",
      translated: "Germania",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:252|ru": [
    {
      german: "In",
      translated: "В",
      tone: 'semantic',
    },
    {
      german: "Deutschland",
      translated: "Германии",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:252|sq": [
    {
      german: "In",
      translated: "Në",
      tone: 'semantic',
    },
    {
      german: "Deutschland",
      translated: "Gjermani …",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:252|sr": [
    {
      german: "In",
      translated: "U",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:252|tr": [
    {
      german: "In",
      translated: "Almanya'da",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:252|uk": [
    {
      german: "In",
      translated: "У",
      tone: 'semantic',
    },
    {
      german: "Deutschland",
      translated: "Німеччині",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:252|vi": [
    {
      german: "In",
      translated: "Ở",
      tone: 'semantic',
    },
    {
      german: "Deutschland",
      translated: "Đức",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:253|ar": [
    {
      german: "Wo",
      translated: "أين",
      tone: 'semantic',
    },
    {
      german: "müssen Sie",
      translated: "يجب أن",
      tone: 'semantic',
    },
    {
      german: "sich anmelden",
      translated: "تسجل عنوانك",
      tone: 'semantic',
    },
    {
      german: "wenn Sie",
      translated: "عندما تنتقل",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "في ألمانيا",
      tone: 'semantic',
    },
    {
      german: "umziehen",
      translated: "؟",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:253|bg": [
    {
      german: "Wo",
      translated: "Къде",
      tone: 'semantic',
    },
    {
      german: "müssen Sie",
      translated: "трябва да",
      tone: 'semantic',
    },
    {
      german: "sich anmelden",
      translated: "регистрирате",
      tone: 'semantic',
    },
    {
      german: "wenn Sie",
      translated: "когато се",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "в Германия",
      tone: 'semantic',
    },
    {
      german: "umziehen",
      translated: "преместите",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:253|bs": [
    {
      german: "Wo",
      translated: "Gdje",
      tone: 'semantic',
    },
    {
      german: "müssen Sie",
      translated: "morate",
      tone: 'semantic',
    },
    {
      german: "sich anmelden",
      translated: "prijaviti",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "u Njemačkoj",
      tone: 'semantic',
    },
    {
      german: "umziehen",
      translated: "nakon preseljenja",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:253|el": [
    {
      german: "Wo",
      translated: "Πού",
      tone: 'semantic',
    },
    {
      german: "müssen Sie",
      translated: "πρέπει",
      tone: 'semantic',
    },
    {
      german: "sich anmelden",
      translated: "να δηλωθείτε",
      tone: 'semantic',
    },
    {
      german: "wenn Sie",
      translated: "όταν",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "στη Γερμανία",
      tone: 'semantic',
    },
    {
      german: "umziehen",
      translated: "αλλάζετε κατοικία",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:253|en": [
    {
      german: "Wo",
      translated: "Where",
      tone: 'semantic',
    },
    {
      german: "müssen Sie",
      translated: "must you",
      tone: 'semantic',
    },
    {
      german: "sich anmelden",
      translated: "register",
      tone: 'semantic',
    },
    {
      german: "wenn Sie",
      translated: "if you",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "in Germany",
      tone: 'semantic',
    },
    {
      german: "umziehen",
      translated: "move",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:253|es": [
    {
      german: "Wo",
      translated: "¿Dónde",
      tone: 'semantic',
    },
    {
      german: "müssen Sie",
      translated: "debe",
      tone: 'semantic',
    },
    {
      german: "sich anmelden",
      translated: "registrarse",
      tone: 'semantic',
    },
    {
      german: "wenn Sie",
      translated: "cuando",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "en Alemania",
      tone: 'semantic',
    },
    {
      german: "umziehen",
      translated: "se muda",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:253|fa": [
    {
      german: "Wo",
      translated: "وقتی",
      tone: 'semantic',
    },
    {
      german: "müssen Sie",
      translated: "باید",
      tone: 'semantic',
    },
    {
      german: "sich anmelden",
      translated: "ثبت‌نام کنید",
      tone: 'semantic',
    },
    {
      german: "wenn Sie",
      translated: "در آلمان",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "نقل مکان",
      tone: 'semantic',
    },
    {
      german: "umziehen",
      translated: "می‌کنید",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:253|fr": [
    {
      german: "Wo",
      translated: "Où",
      tone: 'semantic',
    },
    {
      german: "müssen Sie",
      translated: "devez-vous vous",
      tone: 'semantic',
    },
    {
      german: "sich anmelden",
      translated: "enregistrer",
      tone: 'semantic',
    },
    {
      german: "wenn Sie",
      translated: "lorsque vous",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "en Allemagne",
      tone: 'semantic',
    },
    {
      german: "umziehen",
      translated: "déménagez",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:253|hr": [
    {
      german: "Wo",
      translated: "Gdje",
      tone: 'semantic',
    },
    {
      german: "müssen Sie",
      translated: "morate",
      tone: 'semantic',
    },
    {
      german: "sich anmelden",
      translated: "prijaviti",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "u Njemačkoj",
      tone: 'semantic',
    },
    {
      german: "umziehen",
      translated: "nakon preseljenja",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:253|it": [
    {
      german: "Wo",
      translated: "Dove",
      tone: 'semantic',
    },
    {
      german: "müssen Sie",
      translated: "bisogna",
      tone: 'semantic',
    },
    {
      german: "sich anmelden",
      translated: "registrarsi",
      tone: 'semantic',
    },
    {
      german: "wenn Sie",
      translated: "quando",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "in Germania",
      tone: 'semantic',
    },
    {
      german: "umziehen",
      translated: "si cambia residenza",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:253|kmr": [
    {
      german: "Wo",
      translated: "li ku",
      tone: 'semantic',
    },
    {
      german: "müssen Sie",
      translated: "divê",
      tone: 'semantic',
    },
    {
      german: "sich anmelden",
      translated: "xwe tomar bikî",
      tone: 'semantic',
    },
    {
      german: "wenn Sie",
      translated: "Dema ku",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "li Almanyayê",
      tone: 'semantic',
    },
    {
      german: "umziehen",
      translated: "bar dikevî mala nû",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:253|pl": [
    {
      german: "Wo",
      translated: "Gdzie",
      tone: 'semantic',
    },
    {
      german: "müssen Sie",
      translated: "trzeba",
      tone: 'semantic',
    },
    {
      german: "sich anmelden",
      translated: "zameldować",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "w Niemczech",
      tone: 'semantic',
    },
    {
      german: "umziehen",
      translated: "po przeprowadzce",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:253|prs": [
    {
      german: "Wo",
      translated: "کجا",
      tone: 'semantic',
    },
    {
      german: "müssen Sie",
      translated: "باید",
      tone: 'semantic',
    },
    {
      german: "sich anmelden",
      translated: "ثبت‌نام کنید",
      tone: 'semantic',
    },
    {
      german: "wenn Sie",
      translated: "وقتی",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "در آلمان",
      tone: 'semantic',
    },
    {
      german: "umziehen",
      translated: "نقل مکان می‌کنید",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:253|ro": [
    {
      german: "Wo",
      translated: "Unde",
      tone: 'semantic',
    },
    {
      german: "müssen Sie",
      translated: "trebuie să vă",
      tone: 'semantic',
    },
    {
      german: "sich anmelden",
      translated: "înregistrați",
      tone: 'semantic',
    },
    {
      german: "wenn Sie",
      translated: "când vă",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "în Germania",
      tone: 'semantic',
    },
    {
      german: "umziehen",
      translated: "mutați",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:253|ru": [
    {
      german: "Wo",
      translated: "Где",
      tone: 'semantic',
    },
    {
      german: "müssen Sie",
      translated: "нужно",
      tone: 'semantic',
    },
    {
      german: "sich anmelden",
      translated: "зарегистрироваться",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "в Германии",
      tone: 'semantic',
    },
    {
      german: "umziehen",
      translated: "при переезде",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:253|sq": [
    {
      german: "Wo",
      translated: "Ku",
      tone: 'semantic',
    },
    {
      german: "müssen Sie",
      translated: "duhet të",
      tone: 'semantic',
    },
    {
      german: "sich anmelden",
      translated: "regjistroheni",
      tone: 'semantic',
    },
    {
      german: "wenn Sie",
      translated: "kur",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "në Gjermani",
      tone: 'semantic',
    },
    {
      german: "umziehen",
      translated: "ndryshoni vendbanim",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:253|sr": [
    {
      german: "Wo",
      translated: "Gdje",
      tone: 'semantic',
    },
    {
      german: "müssen Sie",
      translated: "se u",
      tone: 'semantic',
    },
    {
      german: "sich anmelden",
      translated: "Nemačkoj morate prijaviti",
      tone: 'semantic',
    },
    {
      german: "wenn Sie",
      translated: "posle preseljenja",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:253|tr": [
    {
      german: "Wo",
      translated: "nereye",
      tone: 'semantic',
    },
    {
      german: "müssen Sie",
      translated: "gerekir",
      tone: 'semantic',
    },
    {
      german: "sich anmelden",
      translated: "kaydettirmeniz",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "Almanya'da",
      tone: 'semantic',
    },
    {
      german: "umziehen",
      translated: "taşındığınızda",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:253|uk": [
    {
      german: "Wo",
      translated: "Де",
      tone: 'semantic',
    },
    {
      german: "müssen Sie",
      translated: "потрібно",
      tone: 'semantic',
    },
    {
      german: "sich anmelden",
      translated: "зареєструватися",
      tone: 'semantic',
    },
    {
      german: "wenn Sie",
      translated: "якщо ви",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "в Німеччині",
      tone: 'semantic',
    },
    {
      german: "umziehen",
      translated: "переїжджаєте",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:253|vi": [
    {
      german: "Wo",
      translated: "đâu",
      tone: 'semantic',
    },
    {
      german: "müssen Sie",
      translated: "bạn phải",
      tone: 'semantic',
    },
    {
      german: "sich anmelden",
      translated: "đăng ký",
      tone: 'semantic',
    },
    {
      german: "wenn Sie",
      translated: "Khi",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "tại Đức",
      tone: 'semantic',
    },
    {
      german: "umziehen",
      translated: "chuyển chỗ ở",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:254|ar": [
    {
      german: "In Deutschland",
      translated: "في ألمانيا",
      tone: 'semantic',
    },
    {
      german: "dürfen Ehepaare",
      translated: "يُسمح للزوجين",
      tone: 'semantic',
    },
    {
      german: "sich scheiden lassen",
      translated: "بالطلاق",
      tone: 'semantic',
    },
    {
      german: "Meistens",
      translated: "وفي معظم الحالات",
      tone: 'semantic',
    },
    {
      german: "müssen sie",
      translated: "يجب",
      tone: 'semantic',
    },
    {
      german: "das \"Trennungsjahr\"",
      translated: "«سنة الانفصال»",
      tone: 'semantic',
    },
    {
      german: "einhalten",
      translated: "الالتزام",
      tone: 'semantic',
    },
    {
      german: "Was bedeutet das",
      translated: "ماذا يعني ذلك؟",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:254|bg": [
    {
      german: "In Deutschland",
      translated: "в Германия",
      tone: 'semantic',
    },
    {
      german: "dürfen Ehepaare",
      translated: "Съпрузите могат",
      tone: 'semantic',
    },
    {
      german: "sich scheiden lassen",
      translated: "да се разведат",
      tone: 'semantic',
    },
    {
      german: "Meistens",
      translated: "Обикновено",
      tone: 'semantic',
    },
    {
      german: "müssen sie",
      translated: "трябва",
      tone: 'semantic',
    },
    {
      german: "das \"Trennungsjahr\"",
      translated: "„годината на раздяла“ (Trennungsjahr)",
      tone: 'semantic',
    },
    {
      german: "einhalten",
      translated: "да се спази",
      tone: 'semantic',
    },
    {
      german: "Was bedeutet das",
      translated: "Какво означава това",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:254|bs": [
    {
      german: "In Deutschland",
      translated: "u Njemačkoj",
      tone: 'semantic',
    },
    {
      german: "dürfen Ehepaare",
      translated: "Bračni se partneri",
      tone: 'semantic',
    },
    {
      german: "sich scheiden lassen",
      translated: "mogu razvesti",
      tone: 'semantic',
    },
    {
      german: "Meistens",
      translated: "U pravilu se",
      tone: 'semantic',
    },
    {
      german: "müssen sie",
      translated: "mora",
      tone: 'semantic',
    },
    {
      german: "das \"Trennungsjahr\"",
      translated: "„Trennungsjahr“",
      tone: 'semantic',
    },
    {
      german: "einhalten",
      translated: "poštovati",
      tone: 'semantic',
    },
    {
      german: "Was bedeutet das",
      translated: "Što to znači",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:254|el": [
    {
      german: "In Deutschland",
      translated: "στη Γερμανία",
      tone: 'semantic',
    },
    {
      german: "Meistens",
      translated: "Συνήθως",
      tone: 'semantic',
    },
    {
      german: "müssen sie",
      translated: "πρέπει",
      tone: 'semantic',
    },
    {
      german: "dazu",
      translated: "να",
      tone: 'semantic',
    },
    {
      german: "das \"Trennungsjahr\"",
      translated: "το «Trennungsjahr»",
      tone: 'semantic',
    },
    {
      german: "einhalten",
      translated: "τηρείται",
      tone: 'semantic',
    },
    {
      german: "Was bedeutet das",
      translated: "Τι σημαίνει αυτό",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:254|en": [
    {
      german: "In Deutschland",
      translated: "In Germany",
      tone: 'semantic',
    },
    {
      german: "dürfen Ehepaare",
      translated: "married couples are allowed",
      tone: 'semantic',
    },
    {
      german: "sich scheiden lassen",
      translated: "to divorce",
      tone: 'semantic',
    },
    {
      german: "Meistens",
      translated: "Usually",
      tone: 'semantic',
    },
    {
      german: "müssen sie",
      translated: "they must",
      tone: 'semantic',
    },
    {
      german: "das \"Trennungsjahr\"",
      translated: "the 'separation year'",
      tone: 'semantic',
    },
    {
      german: "einhalten",
      translated: "observe",
      tone: 'semantic',
    },
    {
      german: "Was bedeutet das",
      translated: "What does that mean",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:254|es": [
    {
      german: "In Deutschland",
      translated: "En Alemania",
      tone: 'semantic',
    },
    {
      german: "dürfen Ehepaare",
      translated: "los matrimonios pueden",
      tone: 'semantic',
    },
    {
      german: "sich scheiden lassen",
      translated: "divorciarse",
      tone: 'semantic',
    },
    {
      german: "Meistens",
      translated: "Normalmente",
      tone: 'semantic',
    },
    {
      german: "müssen sie",
      translated: "deben",
      tone: 'semantic',
    },
    {
      german: "das \"Trennungsjahr\"",
      translated: "el «año de separación»",
      tone: 'semantic',
    },
    {
      german: "einhalten",
      translated: "respetar",
      tone: 'semantic',
    },
    {
      german: "Was bedeutet das",
      translated: "¿Qué significa eso?",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:254|fa": [
    {
      german: "In Deutschland",
      translated: "در آلمان",
      tone: 'semantic',
    },
    {
      german: "dürfen Ehepaare",
      translated: "می‌توانند",
      tone: 'semantic',
    },
    {
      german: "sich scheiden lassen",
      translated: "طلاق بگیرند",
      tone: 'semantic',
    },
    {
      german: "Meistens",
      translated: "معمولاً",
      tone: 'semantic',
    },
    {
      german: "müssen sie",
      translated: "باید",
      tone: 'semantic',
    },
    {
      german: "einhalten",
      translated: "رعایت کنند",
      tone: 'semantic',
    },
    {
      german: "Was bedeutet das",
      translated: "این یعنی چه",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:254|fr": [
    {
      german: "In Deutschland",
      translated: "En Allemagne",
      tone: 'semantic',
    },
    {
      german: "dürfen Ehepaare",
      translated: "les couples mariés peuvent",
      tone: 'semantic',
    },
    {
      german: "sich scheiden lassen",
      translated: "divorcer",
      tone: 'semantic',
    },
    {
      german: "Meistens",
      translated: "La plupart du temps",
      tone: 'semantic',
    },
    {
      german: "müssen sie",
      translated: "ils doivent",
      tone: 'semantic',
    },
    {
      german: "das \"Trennungsjahr\"",
      translated: "« l’année de séparation » (Trennungsjahr)",
      tone: 'semantic',
    },
    {
      german: "einhalten",
      translated: "respecter",
      tone: 'semantic',
    },
    {
      german: "Was bedeutet das",
      translated: "Qu’est-ce que cela signifie",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:254|hr": [
    {
      german: "In Deutschland",
      translated: "u Njemačkoj",
      tone: 'semantic',
    },
    {
      german: "dürfen Ehepaare",
      translated: "Bračni se partneri",
      tone: 'semantic',
    },
    {
      german: "sich scheiden lassen",
      translated: "mogu razvesti",
      tone: 'semantic',
    },
    {
      german: "Meistens",
      translated: "U pravilu",
      tone: 'semantic',
    },
    {
      german: "müssen sie",
      translated: "se mora",
      tone: 'semantic',
    },
    {
      german: "das \"Trennungsjahr\"",
      translated: "„Trennungsjahr“",
      tone: 'semantic',
    },
    {
      german: "einhalten",
      translated: "poštovati",
      tone: 'semantic',
    },
    {
      german: "Was bedeutet das",
      translated: "Što to znači",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:254|it": [
    {
      german: "In Deutschland",
      translated: "in Germania",
      tone: 'semantic',
    },
    {
      german: "dürfen Ehepaare",
      translated: "I coniugi possono",
      tone: 'semantic',
    },
    {
      german: "sich scheiden lassen",
      translated: "divorziare",
      tone: 'semantic',
    },
    {
      german: "Meistens",
      translated: "Di norma",
      tone: 'semantic',
    },
    {
      german: "müssen sie",
      translated: "devono",
      tone: 'semantic',
    },
    {
      german: "das \"Trennungsjahr\"",
      translated: "«Trennungsjahr»",
      tone: 'semantic',
    },
    {
      german: "einhalten",
      translated: "rispettare",
      tone: 'semantic',
    },
    {
      german: "Was bedeutet das",
      translated: "Che cosa significa",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:254|kmr": [
    {
      german: "In Deutschland",
      translated: "Li Almanyayê",
      tone: 'semantic',
    },
    {
      german: "dürfen Ehepaare",
      translated: "cot dikarin",
      tone: 'semantic',
    },
    {
      german: "sich scheiden lassen",
      translated: "bela bibin",
      tone: 'semantic',
    },
    {
      german: "Meistens",
      translated: "Bi gelemperî",
      tone: 'semantic',
    },
    {
      german: "müssen sie",
      translated: "divê",
      tone: 'semantic',
    },
    {
      german: "das \"Trennungsjahr\"",
      translated: "«Trennungsjahr»",
      tone: 'semantic',
    },
    {
      german: "einhalten",
      translated: "derbas bikin",
      tone: 'semantic',
    },
    {
      german: "Was bedeutet das",
      translated: "Ev tê çi wateyê?",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:254|pl": [
    {
      german: "In Deutschland",
      translated: "w Niemczech",
      tone: 'semantic',
    },
    {
      german: "dürfen Ehepaare",
      translated: "Małżonkowie mogą",
      tone: 'semantic',
    },
    {
      german: "sich scheiden lassen",
      translated: "rozwieść się",
      tone: 'semantic',
    },
    {
      german: "Meistens",
      translated: "Zwykle",
      tone: 'semantic',
    },
    {
      german: "müssen sie",
      translated: "trzeba",
      tone: 'semantic',
    },
    {
      german: "das \"Trennungsjahr\"",
      translated: "„Trennungsjahr”",
      tone: 'semantic',
    },
    {
      german: "einhalten",
      translated: "zachować",
      tone: 'semantic',
    },
    {
      german: "Was bedeutet das",
      translated: "Co to oznacza",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:254|prs": [
    {
      german: "In Deutschland",
      translated: "در آلمان",
      tone: 'semantic',
    },
    {
      german: "dürfen Ehepaare",
      translated: "می‌توانند",
      tone: 'semantic',
    },
    {
      german: "sich scheiden lassen",
      translated: "طلاق بگیرند",
      tone: 'semantic',
    },
    {
      german: "Meistens",
      translated: "معمولاً",
      tone: 'semantic',
    },
    {
      german: "müssen sie",
      translated: "باید",
      tone: 'semantic',
    },
    {
      german: "Was bedeutet das",
      translated: "این یعنی چه؟",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:254|ro": [
    {
      german: "In Deutschland",
      translated: "în Germania",
      tone: 'semantic',
    },
    {
      german: "dürfen Ehepaare",
      translated: "Soții se pot",
      tone: 'semantic',
    },
    {
      german: "sich scheiden lassen",
      translated: "divorța",
      tone: 'semantic',
    },
    {
      german: "Meistens",
      translated: "De regulă",
      tone: 'semantic',
    },
    {
      german: "müssen sie",
      translated: "trebuie",
      tone: 'semantic',
    },
    {
      german: "das \"Trennungsjahr\"",
      translated: "„anul de separare” (Trennungsjahr)",
      tone: 'semantic',
    },
    {
      german: "einhalten",
      translated: "respectat",
      tone: 'semantic',
    },
    {
      german: "Was bedeutet das",
      translated: "Ce înseamnă?",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:254|ru": [
    {
      german: "In Deutschland",
      translated: "В Германии",
      tone: 'semantic',
    },
    {
      german: "dürfen Ehepaare",
      translated: "супруги могут",
      tone: 'semantic',
    },
    {
      german: "sich scheiden lassen",
      translated: "развестись",
      tone: 'semantic',
    },
    {
      german: "Meistens",
      translated: "Обычно",
      tone: 'semantic',
    },
    {
      german: "müssen sie",
      translated: "нужно",
      tone: 'semantic',
    },
    {
      german: "dazu",
      translated: "для этого",
      tone: 'semantic',
    },
    {
      german: "das \"Trennungsjahr\"",
      translated: "«год раздельного проживания»",
      tone: 'semantic',
    },
    {
      german: "einhalten",
      translated: "соблюсти",
      tone: 'semantic',
    },
    {
      german: "Was bedeutet das",
      translated: "Что это значит",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:254|sq": [
    {
      german: "In Deutschland",
      translated: "në Gjermani",
      tone: 'semantic',
    },
    {
      german: "dürfen Ehepaare",
      translated: "Bashkëshortët mund",
      tone: 'semantic',
    },
    {
      german: "sich scheiden lassen",
      translated: "të divorcohen",
      tone: 'semantic',
    },
    {
      german: "Meistens",
      translated: "Zakonisht",
      tone: 'semantic',
    },
    {
      german: "müssen sie",
      translated: "duhet",
      tone: 'semantic',
    },
    {
      german: "das \"Trennungsjahr\"",
      translated: "«Trennungsjahr»",
      tone: 'semantic',
    },
    {
      german: "einhalten",
      translated: "respektuar",
      tone: 'semantic',
    },
    {
      german: "Was bedeutet das",
      translated: "Çfarë do të thotë kjo",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:254|sr": [
    {
      german: "In Deutschland",
      translated: "Nemačkoj",
      tone: 'semantic',
    },
    {
      german: "dürfen Ehepaare",
      translated: "Bračni se partneri u",
      tone: 'semantic',
    },
    {
      german: "sich scheiden lassen",
      translated: "mogu razvesti",
      tone: 'semantic',
    },
    {
      german: "Meistens",
      translated: "U pravilu",
      tone: 'semantic',
    },
    {
      german: "müssen sie",
      translated: "se mora",
      tone: 'semantic',
    },
    {
      german: "einhalten",
      translated: "da poštuje",
      tone: 'semantic',
    },
    {
      german: "Was bedeutet das",
      translated: "Šta to znači",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:254|tr": [
    {
      german: "In Deutschland",
      translated: "Almanya'da",
      tone: 'semantic',
    },
    {
      german: "dürfen Ehepaare",
      translated: "evli çiftler",
      tone: 'semantic',
    },
    {
      german: "sich scheiden lassen",
      translated: "boşanabilir",
      tone: 'semantic',
    },
    {
      german: "Meistens",
      translated: "Genellikle",
      tone: 'semantic',
    },
    {
      german: "müssen sie",
      translated: "gerekir",
      tone: 'semantic',
    },
    {
      german: "dazu",
      translated: "için",
      tone: 'semantic',
    },
    {
      german: "das \"Trennungsjahr\"",
      translated: "\"ayrılık yılına\" (Trennungsjahr)",
      tone: 'semantic',
    },
    {
      german: "einhalten",
      translated: "uymaları",
      tone: 'semantic',
    },
    {
      german: "Was bedeutet das",
      translated: "Bu ne demektir",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:254|uk": [
    {
      german: "In Deutschland",
      translated: "У Німеччині",
      tone: 'semantic',
    },
    {
      german: "dürfen Ehepaare",
      translated: "подружжя може",
      tone: 'semantic',
    },
    {
      german: "sich scheiden lassen",
      translated: "розлучитися",
      tone: 'semantic',
    },
    {
      german: "Meistens",
      translated: "Зазвичай",
      tone: 'semantic',
    },
    {
      german: "müssen sie",
      translated: "потрібно",
      tone: 'semantic',
    },
    {
      german: "dazu",
      translated: "для цього",
      tone: 'semantic',
    },
    {
      german: "das \"Trennungsjahr\"",
      translated: "«року окремого проживання» (Trennungsjahr)",
      tone: 'semantic',
    },
    {
      german: "einhalten",
      translated: "дотриматися",
      tone: 'semantic',
    },
    {
      german: "Was bedeutet das",
      translated: "Що це означає",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:254|vi": [
    {
      german: "In Deutschland",
      translated: "ở Đức",
      tone: 'semantic',
    },
    {
      german: "dürfen Ehepaare",
      translated: "Vợ chồng có thể",
      tone: 'semantic',
    },
    {
      german: "sich scheiden lassen",
      translated: "ly hôn",
      tone: 'semantic',
    },
    {
      german: "Meistens",
      translated: "Thông thường",
      tone: 'semantic',
    },
    {
      german: "müssen sie",
      translated: "họ phải",
      tone: 'semantic',
    },
    {
      german: "das \"Trennungsjahr\"",
      translated: "“Trennungsjahr”",
      tone: 'semantic',
    },
    {
      german: "einhalten",
      translated: "tuân thủ",
      tone: 'semantic',
    },
    {
      german: "Was bedeutet das",
      translated: "Điều đó có nghĩa là gì",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:255|ar": [
    {
      german: "Bei Erziehungsproblemen",
      translated: "عند وجود مشكلات في تربية الأطفال",
      tone: 'semantic',
    },
    {
      german: "können",
      translated: "يمكن",
      tone: 'semantic',
    },
    {
      german: "Eltern in Deutschland",
      translated: "للوالدين في ألمانيا",
      tone: 'semantic',
    },
    {
      german: "Hilfe erhalten vom …",
      translated: "الحصول على مساعدة من …",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:255|bg": [
    {
      german: "Bei Erziehungsproblemen",
      translated: "При проблеми с възпитанието",
      tone: 'semantic',
    },
    {
      german: "können",
      translated: "могат",
      tone: 'semantic',
    },
    {
      german: "Eltern in Deutschland",
      translated: "родителите в Германия",
      tone: 'semantic',
    },
    {
      german: "Hilfe erhalten vom …",
      translated: "да получат помощ от …",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:255|bs": [
    {
      german: "Bei Erziehungsproblemen",
      translated: "Kod problema s odgojem",
      tone: 'semantic',
    },
    {
      german: "können",
      translated: "mogu",
      tone: 'semantic',
    },
    {
      german: "Eltern in Deutschland",
      translated: "roditelji u Njemačkoj",
      tone: 'semantic',
    },
    {
      german: "Hilfe erhalten vom …",
      translated: "dobiti pomoć od …",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:255|el": [
    {
      german: "Bei Erziehungsproblemen",
      translated: "για προβλήματα ανατροφής",
      tone: 'semantic',
    },
    {
      german: "können",
      translated: "μπορούν",
      tone: 'semantic',
    },
    {
      german: "Eltern in Deutschland",
      translated: "οι γονείς στη Γερμανία",
      tone: 'semantic',
    },
    {
      german: "Hilfe erhalten vom …",
      translated: "να λάβουν βοήθεια",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:255|en": [
    {
      german: "Bei Erziehungsproblemen",
      translated: "For parenting problems",
      tone: 'semantic',
    },
    {
      german: "können",
      translated: "can",
      tone: 'semantic',
    },
    {
      german: "Eltern in Deutschland",
      translated: "parents in Germany",
      tone: 'semantic',
    },
    {
      german: "Hilfe erhalten vom …",
      translated: "get help from the …",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:255|es": [
    {
      german: "Bei Erziehungsproblemen",
      translated: "Si hay problemas con la educación de los hijos",
      tone: 'semantic',
    },
    {
      german: "können",
      translated: "pueden",
      tone: 'semantic',
    },
    {
      german: "Eltern in Deutschland",
      translated: "los padres en Alemania",
      tone: 'semantic',
    },
    {
      german: "Hilfe erhalten vom …",
      translated: "recibir ayuda de …",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:255|fa": [
    {
      german: "Bei Erziehungsproblemen",
      translated: "در صورت مشکلات تربیتی",
      tone: 'semantic',
    },
    {
      german: "können",
      translated: "می‌توانند",
      tone: 'semantic',
    },
    {
      german: "Eltern in Deutschland",
      translated: "والدین در آلمان",
      tone: 'semantic',
    },
    {
      german: "Hilfe erhalten vom …",
      translated: "از کجا کمک بگیرند؟",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:255|fr": [
    {
      german: "Bei Erziehungsproblemen",
      translated: "En cas de problèmes éducatifs",
      tone: 'semantic',
    },
    {
      german: "können",
      translated: "peuvent",
      tone: 'semantic',
    },
    {
      german: "Eltern in Deutschland",
      translated: "les parents",
      tone: 'semantic',
    },
    {
      german: "Hilfe erhalten vom …",
      translated: "obtenir de l’aide",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:255|hr": [
    {
      german: "Bei Erziehungsproblemen",
      translated: "Kod problema s odgojem",
      tone: 'semantic',
    },
    {
      german: "können",
      translated: "mogu",
      tone: 'semantic',
    },
    {
      german: "Eltern in Deutschland",
      translated: "roditelji u Njemačkoj",
      tone: 'semantic',
    },
    {
      german: "Hilfe erhalten vom …",
      translated: "dobiti pomoć od …",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:255|it": [
    {
      german: "Bei Erziehungsproblemen",
      translated: "per problemi educativi",
      tone: 'semantic',
    },
    {
      german: "können",
      translated: "possono",
      tone: 'semantic',
    },
    {
      german: "Eltern in Deutschland",
      translated: "i genitori in Germania",
      tone: 'semantic',
    },
    {
      german: "Hilfe erhalten vom …",
      translated: "ricevere aiuto",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:255|kmr": [
    {
      german: "Bei Erziehungsproblemen",
      translated: "ji bo pirsgirêkên perwerdehiyê",
      tone: 'semantic',
    },
    {
      german: "können",
      translated: "dikarin",
      tone: 'semantic',
    },
    {
      german: "Eltern in Deutschland",
      translated: "Dêûbav li Almanyayê",
      tone: 'semantic',
    },
    {
      german: "Hilfe erhalten vom …",
      translated: "alîkarî ji … bistînin",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:255|pl": [
    {
      german: "Bei Erziehungsproblemen",
      translated: "w problemach wychowawczych",
      tone: 'semantic',
    },
    {
      german: "können",
      translated: "mogą",
      tone: 'semantic',
    },
    {
      german: "Eltern in Deutschland",
      translated: "rodzice w Niemczech",
      tone: 'semantic',
    },
    {
      german: "Hilfe erhalten vom …",
      translated: "uzyskać pomoc",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:255|prs": [
    {
      german: "Bei Erziehungsproblemen",
      translated: "در صورت مشکلات تربیتی",
      tone: 'semantic',
    },
    {
      german: "können",
      translated: "می‌توانند",
      tone: 'semantic',
    },
    {
      german: "Eltern in Deutschland",
      translated: "والدین در آلمان",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:255|ro": [
    {
      german: "Bei Erziehungsproblemen",
      translated: "Pentru probleme de educație a copiilor",
      tone: 'semantic',
    },
    {
      german: "können",
      translated: "pot",
      tone: 'semantic',
    },
    {
      german: "Eltern in Deutschland",
      translated: "părinții din Germania",
      tone: 'semantic',
    },
    {
      german: "Hilfe erhalten vom …",
      translated: "primi ajutor de la …",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:255|ru": [
    {
      german: "Bei Erziehungsproblemen",
      translated: "При проблемах с воспитанием",
      tone: 'semantic',
    },
    {
      german: "können",
      translated: "могут",
      tone: 'semantic',
    },
    {
      german: "Eltern in Deutschland",
      translated: "родители в Германии",
      tone: 'semantic',
    },
    {
      german: "Hilfe erhalten vom …",
      translated: "получить помощь от",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:255|sq": [
    {
      german: "Bei Erziehungsproblemen",
      translated: "për probleme me edukimin",
      tone: 'semantic',
    },
    {
      german: "können",
      translated: "mund të",
      tone: 'semantic',
    },
    {
      german: "Eltern in Deutschland",
      translated: "prindërit në Gjermani",
      tone: 'semantic',
    },
    {
      german: "Hilfe erhalten vom …",
      translated: "marrin ndihmë",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:255|sr": [
    {
      german: "Bei Erziehungsproblemen",
      translated: "Kod problema s vaspitanjem",
      tone: 'semantic',
    },
    {
      german: "können",
      translated: "mogu",
      tone: 'semantic',
    },
    {
      german: "Eltern in Deutschland",
      translated: "roditelji u Nemačkoj",
      tone: 'semantic',
    },
    {
      german: "Hilfe erhalten vom …",
      translated: "dobiti pomoć od …",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:255|tr": [
    {
      german: "Bei Erziehungsproblemen",
      translated: "çocuk yetiştirmeyle ilgili sorunlarda",
      tone: 'semantic',
    },
    {
      german: "Eltern in Deutschland",
      translated: "Almanya'da anne-babalar",
      tone: 'semantic',
    },
    {
      german: "Hilfe erhalten vom …",
      translated: "nereden yardım alabilir?",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:255|uk": [
    {
      german: "Bei Erziehungsproblemen",
      translated: "У разі проблем із вихованням дітей",
      tone: 'semantic',
    },
    {
      german: "können",
      translated: "можуть",
      tone: 'semantic',
    },
    {
      german: "Eltern in Deutschland",
      translated: "батьки в Німеччині",
      tone: 'semantic',
    },
    {
      german: "Hilfe erhalten vom …",
      translated: "отримати допомогу від …",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:255|vi": [
    {
      german: "Bei Erziehungsproblemen",
      translated: "về vấn đề nuôi dạy con",
      tone: 'semantic',
    },
    {
      german: "können",
      translated: "có thể",
      tone: 'semantic',
    },
    {
      german: "Eltern in Deutschland",
      translated: "Cha mẹ ở Đức",
      tone: 'semantic',
    },
    {
      german: "Hilfe erhalten vom …",
      translated: "nhận hỗ trợ",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:256|ar": [
    {
      german: "Ein Ehepaar",
      translated: "زوجان",
      tone: 'semantic',
    },
    {
      german: "möchte",
      translated: "يريد",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "في ألمانيا",
      tone: 'semantic',
    },
    {
      german: "ein Restaurant",
      translated: "مطعم",
      tone: 'semantic',
    },
    {
      german: "eröffnen",
      translated: "فتح",
      tone: 'semantic',
    },
    {
      german: "Was braucht es",
      translated: "ما الذي يحتاجان إليه",
      tone: 'semantic',
    },
    {
      german: "unbedingt",
      translated: "بالضرورة",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:256|bg": [
    {
      german: "Ein Ehepaar",
      translated: "Двойка",
      tone: 'semantic',
    },
    {
      german: "möchte",
      translated: "иска",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "в Германия",
      tone: 'semantic',
    },
    {
      german: "ein Restaurant",
      translated: "ресторант",
      tone: 'semantic',
    },
    {
      german: "eröffnen",
      translated: "да отвори",
      tone: 'semantic',
    },
    {
      german: "Was braucht es",
      translated: "От какво",
      tone: 'semantic',
    },
    {
      german: "dazu",
      translated: "се нуждае",
      tone: 'semantic',
    },
    {
      german: "unbedingt",
      translated: "задължително",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:256|bs": [
    {
      german: "Ein Ehepaar",
      translated: "Par",
      tone: 'semantic',
    },
    {
      german: "möchte",
      translated: "želi",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "u Njemačkoj",
      tone: 'semantic',
    },
    {
      german: "ein Restaurant",
      translated: "restoran",
      tone: 'semantic',
    },
    {
      german: "eröffnen",
      translated: "otvoriti",
      tone: 'semantic',
    },
    {
      german: "Was braucht es",
      translated: "potrebno",
      tone: 'semantic',
    },
    {
      german: "unbedingt",
      translated: "svakako",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:256|el": [
    {
      german: "Ein Ehepaar",
      translated: "Ένα ζευγάρι",
      tone: 'semantic',
    },
    {
      german: "möchte",
      translated: "θέλει",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "στη Γερμανία",
      tone: 'semantic',
    },
    {
      german: "ein Restaurant",
      translated: "εστιατόριο",
      tone: 'semantic',
    },
    {
      german: "eröffnen",
      translated: "να ανοίξει",
      tone: 'semantic',
    },
    {
      german: "Was braucht es",
      translated: "Τι χρειάζεται",
      tone: 'semantic',
    },
    {
      german: "unbedingt",
      translated: "οπωσδήποτε",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:256|en": [
    {
      german: "Ein Ehepaar",
      translated: "A married couple",
      tone: 'semantic',
    },
    {
      german: "möchte",
      translated: "wants",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "in Germany",
      tone: 'semantic',
    },
    {
      german: "ein Restaurant",
      translated: "a restaurant",
      tone: 'semantic',
    },
    {
      german: "eröffnen",
      translated: "to open",
      tone: 'semantic',
    },
    {
      german: "Was braucht es",
      translated: "need",
      tone: 'semantic',
    },
    {
      german: "unbedingt",
      translated: "absolutely",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:256|es": [
    {
      german: "Ein Ehepaar",
      translated: "Un matrimonio",
      tone: 'semantic',
    },
    {
      german: "möchte",
      translated: "quiere",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "en Alemania",
      tone: 'semantic',
    },
    {
      german: "ein Restaurant",
      translated: "un restaurante",
      tone: 'semantic',
    },
    {
      german: "eröffnen",
      translated: "abrir",
      tone: 'semantic',
    },
    {
      german: "Was braucht es",
      translated: "¿Qué necesita",
      tone: 'semantic',
    },
    {
      german: "unbedingt",
      translated: "obligatoriamente",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:256|fa": [
    {
      german: "Ein Ehepaar",
      translated: "یک زوج",
      tone: 'semantic',
    },
    {
      german: "möchte",
      translated: "می‌خواهند",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "در آلمان",
      tone: 'semantic',
    },
    {
      german: "ein Restaurant",
      translated: "رستوران",
      tone: 'semantic',
    },
    {
      german: "eröffnen",
      translated: "باز کنند",
      tone: 'semantic',
    },
    {
      german: "Was braucht es",
      translated: "به چه چیزی نیاز دارند",
      tone: 'semantic',
    },
    {
      german: "unbedingt",
      translated: "حتماً",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:256|fr": [
    {
      german: "Ein Ehepaar",
      translated: "Un couple",
      tone: 'semantic',
    },
    {
      german: "möchte",
      translated: "souhaite",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "en Allemagne",
      tone: 'semantic',
    },
    {
      german: "ein Restaurant",
      translated: "un restaurant",
      tone: 'semantic',
    },
    {
      german: "eröffnen",
      translated: "ouvrir",
      tone: 'semantic',
    },
    {
      german: "Was braucht es",
      translated: "besoin",
      tone: 'semantic',
    },
    {
      german: "unbedingt",
      translated: "absolument",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:256|hr": [
    {
      german: "Ein Ehepaar",
      translated: "Par",
      tone: 'semantic',
    },
    {
      german: "möchte",
      translated: "želi",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "u Njemačkoj",
      tone: 'semantic',
    },
    {
      german: "ein Restaurant",
      translated: "restoran",
      tone: 'semantic',
    },
    {
      german: "eröffnen",
      translated: "otvoriti",
      tone: 'semantic',
    },
    {
      german: "Was braucht es",
      translated: "potrebno",
      tone: 'semantic',
    },
    {
      german: "unbedingt",
      translated: "svakako",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:256|it": [
    {
      german: "Ein Ehepaar",
      translated: "Una coppia",
      tone: 'semantic',
    },
    {
      german: "möchte",
      translated: "vuole",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "in Germania",
      tone: 'semantic',
    },
    {
      german: "ein Restaurant",
      translated: "un ristorante",
      tone: 'semantic',
    },
    {
      german: "eröffnen",
      translated: "aprire",
      tone: 'semantic',
    },
    {
      german: "Was braucht es",
      translated: "Di che cosa ha",
      tone: 'semantic',
    },
    {
      german: "unbedingt",
      translated: "assolutamente",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:256|kmr": [
    {
      german: "Ein Ehepaar",
      translated: "Coteke zewicî",
      tone: 'semantic',
    },
    {
      german: "möchte",
      translated: "dixwaze",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "li Almanyayê",
      tone: 'semantic',
    },
    {
      german: "ein Restaurant",
      translated: "restoranek veke",
      tone: 'semantic',
    },
    {
      german: "eröffnen",
      translated: "Pêdiviya sereke",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:256|pl": [
    {
      german: "Ein Ehepaar",
      translated: "Para",
      tone: 'semantic',
    },
    {
      german: "möchte",
      translated: "chce",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "w Niemczech",
      tone: 'semantic',
    },
    {
      german: "ein Restaurant",
      translated: "restaurację",
      tone: 'semantic',
    },
    {
      german: "eröffnen",
      translated: "otworzyć",
      tone: 'semantic',
    },
    {
      german: "Was braucht es",
      translated: "potrzebuje",
      tone: 'semantic',
    },
    {
      german: "unbedingt",
      translated: "bezwzględnie",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:256|prs": [
    {
      german: "Ein Ehepaar",
      translated: "یک زوج",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "در آلمان",
      tone: 'semantic',
    },
    {
      german: "ein Restaurant",
      translated: "رستوران",
      tone: 'semantic',
    },
    {
      german: "eröffnen",
      translated: "باز کنند",
      tone: 'semantic',
    },
    {
      german: "Was braucht es",
      translated: "به چه چیزی نیاز",
      tone: 'semantic',
    },
    {
      german: "unbedingt",
      translated: "حتماً",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:256|ro": [
    {
      german: "Ein Ehepaar",
      translated: "Un cuplu",
      tone: 'semantic',
    },
    {
      german: "möchte",
      translated: "vrea",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "în Germania",
      tone: 'semantic',
    },
    {
      german: "ein Restaurant",
      translated: "un restaurant",
      tone: 'semantic',
    },
    {
      german: "eröffnen",
      translated: "deschidă",
      tone: 'semantic',
    },
    {
      german: "Was braucht es",
      translated: "De ce are",
      tone: 'semantic',
    },
    {
      german: "unbedingt",
      translated: "neapărat",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:256|ru": [
    {
      german: "Ein Ehepaar",
      translated: "Супружеская пара",
      tone: 'semantic',
    },
    {
      german: "möchte",
      translated: "хочет",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "в Германии",
      tone: 'semantic',
    },
    {
      german: "ein Restaurant",
      translated: "ресторан",
      tone: 'semantic',
    },
    {
      german: "eröffnen",
      translated: "открыть",
      tone: 'semantic',
    },
    {
      german: "Was braucht es",
      translated: "Что",
      tone: 'semantic',
    },
    {
      german: "dazu",
      translated: "для этого",
      tone: 'semantic',
    },
    {
      german: "unbedingt",
      translated: "обязательно",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:256|sq": [
    {
      german: "Ein Ehepaar",
      translated: "Një çift",
      tone: 'semantic',
    },
    {
      german: "möchte",
      translated: "dëshiron",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "në Gjermani",
      tone: 'semantic',
    },
    {
      german: "ein Restaurant",
      translated: "një restorant",
      tone: 'semantic',
    },
    {
      german: "eröffnen",
      translated: "hapë",
      tone: 'semantic',
    },
    {
      german: "Was braucht es",
      translated: "Për çfarë ka",
      tone: 'semantic',
    },
    {
      german: "unbedingt",
      translated: "patjetër",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:256|sr": [
    {
      german: "Ein Ehepaar",
      translated: "Par",
      tone: 'semantic',
    },
    {
      german: "möchte",
      translated: "želi",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "u Nemačkoj",
      tone: 'semantic',
    },
    {
      german: "ein Restaurant",
      translated: "restoran",
      tone: 'semantic',
    },
    {
      german: "eröffnen",
      translated: "otvoriti",
      tone: 'semantic',
    },
    {
      german: "Was braucht es",
      translated: "potrebno",
      tone: 'semantic',
    },
    {
      german: "unbedingt",
      translated: "svakako",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:256|tr": [
    {
      german: "Ein Ehepaar",
      translated: "Bir çift",
      tone: 'semantic',
    },
    {
      german: "möchte",
      translated: "istiyor",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "Almanya'da",
      tone: 'semantic',
    },
    {
      german: "ein Restaurant",
      translated: "restoran",
      tone: 'semantic',
    },
    {
      german: "eröffnen",
      translated: "açmak",
      tone: 'semantic',
    },
    {
      german: "Was braucht es",
      translated: "ne gerekir",
      tone: 'semantic',
    },
    {
      german: "dazu",
      translated: "Bunun için",
      tone: 'semantic',
    },
    {
      german: "unbedingt",
      translated: "mutlaka",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:256|uk": [
    {
      german: "Ein Ehepaar",
      translated: "Подружжя",
      tone: 'semantic',
    },
    {
      german: "möchte",
      translated: "хоче",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "у Німеччині",
      tone: 'semantic',
    },
    {
      german: "ein Restaurant",
      translated: "ресторан",
      tone: 'semantic',
    },
    {
      german: "eröffnen",
      translated: "відкрити",
      tone: 'semantic',
    },
    {
      german: "Was braucht es",
      translated: "Що для цього",
      tone: 'semantic',
    },
    {
      german: "dazu",
      translated: "обов’язково",
      tone: 'semantic',
    },
    {
      german: "unbedingt",
      translated: "потрібно",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:256|vi": [
    {
      german: "Ein Ehepaar",
      translated: "Một cặp đôi",
      tone: 'semantic',
    },
    {
      german: "möchte",
      translated: "muốn",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "ở Đức",
      tone: 'semantic',
    },
    {
      german: "ein Restaurant",
      translated: "nhà hàng",
      tone: 'semantic',
    },
    {
      german: "eröffnen",
      translated: "mở",
      tone: 'semantic',
    },
    {
      german: "Was braucht es",
      translated: "cần gì",
      tone: 'semantic',
    },
    {
      german: "unbedingt",
      translated: "nhất thiết",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:257|ar": [
    {
      german: "Eine erwachsene Frau",
      translated: "امرأة بالغة",
      tone: 'semantic',
    },
    {
      german: "möchte",
      translated: "تريد",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "في ألمانيا",
      tone: 'semantic',
    },
    {
      german: "das Abitur nachholen",
      translated: "الحصول على شهادة Abitur لاحقًا",
      tone: 'semantic',
    },
    {
      german: "Das",
      translated: "ذلك",
      tone: 'semantic',
    },
    {
      german: "kann sie",
      translated: "يمكنها",
      tone: 'semantic',
    },
    {
      german: "an …",
      translated: "في …",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:257|bg": [
    {
      german: "Eine erwachsene Frau",
      translated: "Пълнолетна жена",
      tone: 'semantic',
    },
    {
      german: "möchte",
      translated: "иска",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "в Германия",
      tone: 'semantic',
    },
    {
      german: "das Abitur nachholen",
      translated: "да получи Abitur",
      tone: 'semantic',
    },
    {
      german: "Das",
      translated: "Може",
      tone: 'semantic',
    },
    {
      german: "kann sie",
      translated: "да направи това",
      tone: 'semantic',
    },
    {
      german: "an …",
      translated: "в …",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:257|bs": [
    {
      german: "Eine erwachsene Frau",
      translated: "Odrasla žena",
      tone: 'semantic',
    },
    {
      german: "möchte",
      translated: "želi",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "u Njemačkoj",
      tone: 'semantic',
    },
    {
      german: "das Abitur nachholen",
      translated: "naknadno steći Abitur",
      tone: 'semantic',
    },
    {
      german: "Das",
      translated: "To",
      tone: 'semantic',
    },
    {
      german: "kann sie",
      translated: "može učiniti",
      tone: 'semantic',
    },
    {
      german: "an …",
      translated: "u",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:257|el": [
    {
      german: "Eine erwachsene Frau",
      translated: "Μια ενήλικη γυναίκα",
      tone: 'semantic',
    },
    {
      german: "möchte",
      translated: "θέλει",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "στη Γερμανία",
      tone: 'semantic',
    },
    {
      german: "das Abitur nachholen",
      translated: "να αποκτήσει αργότερα Abitur",
      tone: 'semantic',
    },
    {
      german: "Das",
      translated: "Μπορεί να το κάνει",
      tone: 'semantic',
    },
    {
      german: "an …",
      translated: "σε …",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:257|en": [
    {
      german: "Eine erwachsene Frau",
      translated: "An adult woman",
      tone: 'semantic',
    },
    {
      german: "möchte",
      translated: "wants",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "in Germany",
      tone: 'semantic',
    },
    {
      german: "das Abitur nachholen",
      translated: "complete her Abitur",
      tone: 'semantic',
    },
    {
      german: "Das",
      translated: "She",
      tone: 'semantic',
    },
    {
      german: "kann sie",
      translated: "can do this",
      tone: 'semantic',
    },
    {
      german: "an …",
      translated: "at …",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:257|es": [
    {
      german: "Eine erwachsene Frau",
      translated: "Una mujer adulta",
      tone: 'semantic',
    },
    {
      german: "möchte",
      translated: "quiere",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "en Alemania",
      tone: 'semantic',
    },
    {
      german: "das Abitur nachholen",
      translated: "obtener posteriormente el Abitur",
      tone: 'semantic',
    },
    {
      german: "Das",
      translated: "hacerlo",
      tone: 'semantic',
    },
    {
      german: "kann sie",
      translated: "Puede",
      tone: 'semantic',
    },
    {
      german: "an …",
      translated: "en …",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:257|fa": [
    {
      german: "Eine erwachsene Frau",
      translated: "یک زن بزرگسال",
      tone: 'semantic',
    },
    {
      german: "möchte",
      translated: "می‌خواهد",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "در آلمان",
      tone: 'semantic',
    },
    {
      german: "das Abitur nachholen",
      translated: "مدرک Abitur بگیرد",
      tone: 'semantic',
    },
    {
      german: "Das",
      translated: "این کار",
      tone: 'semantic',
    },
    {
      german: "kann sie",
      translated: "می‌تواند",
      tone: 'semantic',
    },
    {
      german: "an …",
      translated: "در …",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:257|fr": [
    {
      german: "Eine erwachsene Frau",
      translated: "Une femme adulte",
      tone: 'semantic',
    },
    {
      german: "möchte",
      translated: "souhaite",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "en Allemagne",
      tone: 'semantic',
    },
    {
      german: "das Abitur nachholen",
      translated: "obtenir plus tard l’Abitur",
      tone: 'semantic',
    },
    {
      german: "Das",
      translated: "Elle",
      tone: 'semantic',
    },
    {
      german: "kann sie",
      translated: "peut le faire",
      tone: 'semantic',
    },
    {
      german: "an …",
      translated: "dans …",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:257|hr": [
    {
      german: "Eine erwachsene Frau",
      translated: "Odrasla žena",
      tone: 'semantic',
    },
    {
      german: "möchte",
      translated: "želi",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "u Njemačkoj",
      tone: 'semantic',
    },
    {
      german: "das Abitur nachholen",
      translated: "naknadno steći Abitur",
      tone: 'semantic',
    },
    {
      german: "Das",
      translated: "To",
      tone: 'semantic',
    },
    {
      german: "kann sie",
      translated: "može učiniti",
      tone: 'semantic',
    },
    {
      german: "an …",
      translated: "u …",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:257|it": [
    {
      german: "Eine erwachsene Frau",
      translated: "Una donna adulta",
      tone: 'semantic',
    },
    {
      german: "möchte",
      translated: "vuole",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "in Germania",
      tone: 'semantic',
    },
    {
      german: "das Abitur nachholen",
      translated: "conseguire successivamente l’Abitur",
      tone: 'semantic',
    },
    {
      german: "Das",
      translated: "farlo",
      tone: 'semantic',
    },
    {
      german: "kann sie",
      translated: "Può",
      tone: 'semantic',
    },
    {
      german: "an …",
      translated: "in …",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:257|kmr": [
    {
      german: "Eine erwachsene Frau",
      translated: "Jineke mezin",
      tone: 'semantic',
    },
    {
      german: "möchte",
      translated: "dixwaze",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "li Almanyayê",
      tone: 'semantic',
    },
    {
      german: "das Abitur nachholen",
      translated: "Abitur paşê bistîne",
      tone: 'semantic',
    },
    {
      german: "kann sie",
      translated: "Dikare",
      tone: 'semantic',
    },
    {
      german: "an …",
      translated: "li …",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:257|pl": [
    {
      german: "Eine erwachsene Frau",
      translated: "Dorosła kobieta",
      tone: 'semantic',
    },
    {
      german: "möchte",
      translated: "chce",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "w Niemczech",
      tone: 'semantic',
    },
    {
      german: "das Abitur nachholen",
      translated: "uzyskać Abitur",
      tone: 'semantic',
    },
    {
      german: "Das",
      translated: "to",
      tone: 'semantic',
    },
    {
      german: "kann sie",
      translated: "Może",
      tone: 'semantic',
    },
    {
      german: "an …",
      translated: "w …",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:257|prs": [
    {
      german: "Eine erwachsene Frau",
      translated: "یک زن بزرگسال",
      tone: 'semantic',
    },
    {
      german: "möchte",
      translated: "می‌خواهد",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "در آلمان",
      tone: 'semantic',
    },
    {
      german: "das Abitur nachholen",
      translated: "مدرک Abitur بگیرد",
      tone: 'semantic',
    },
    {
      german: "Das",
      translated: "این کار",
      tone: 'semantic',
    },
    {
      german: "kann sie",
      translated: "می‌تواند",
      tone: 'semantic',
    },
    {
      german: "an …",
      translated: "در …",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:257|ro": [
    {
      german: "Eine erwachsene Frau",
      translated: "O femeie adultă",
      tone: 'semantic',
    },
    {
      german: "möchte",
      translated: "vrea",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "în Germania",
      tone: 'semantic',
    },
    {
      german: "das Abitur nachholen",
      translated: "să obțină ulterior Abiturul",
      tone: 'semantic',
    },
    {
      german: "Das",
      translated: "acest lucru",
      tone: 'semantic',
    },
    {
      german: "kann sie",
      translated: "Poate",
      tone: 'semantic',
    },
    {
      german: "an …",
      translated: "la …",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:257|ru": [
    {
      german: "Eine erwachsene Frau",
      translated: "Взрослая женщина",
      tone: 'semantic',
    },
    {
      german: "möchte",
      translated: "хочет",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "в Германии",
      tone: 'semantic',
    },
    {
      german: "das Abitur nachholen",
      translated: "получить аттестат зрелости позднее",
      tone: 'semantic',
    },
    {
      german: "Das",
      translated: "Она",
      tone: 'semantic',
    },
    {
      german: "kann sie",
      translated: "может сделать",
      tone: 'semantic',
    },
    {
      german: "an …",
      translated: "это в",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:257|sq": [
    {
      german: "Eine erwachsene Frau",
      translated: "Një grua madhore",
      tone: 'semantic',
    },
    {
      german: "möchte",
      translated: "dëshiron",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "në Gjermani",
      tone: 'semantic',
    },
    {
      german: "das Abitur nachholen",
      translated: "Abitur-in më vonë",
      tone: 'semantic',
    },
    {
      german: "Das",
      translated: "Mund",
      tone: 'semantic',
    },
    {
      german: "kann sie",
      translated: "ta bëjë",
      tone: 'semantic',
    },
    {
      german: "an …",
      translated: "në …",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:257|sr": [
    {
      german: "Eine erwachsene Frau",
      translated: "Odrasla žena",
      tone: 'semantic',
    },
    {
      german: "möchte",
      translated: "želi",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "u Nemačkoj",
      tone: 'semantic',
    },
    {
      german: "das Abitur nachholen",
      translated: "naknadno steći Abitur",
      tone: 'semantic',
    },
    {
      german: "Das",
      translated: "To",
      tone: 'semantic',
    },
    {
      german: "kann sie",
      translated: "može uraditi",
      tone: 'semantic',
    },
    {
      german: "an …",
      translated: "u",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:257|tr": [
    {
      german: "Eine erwachsene Frau",
      translated: "Yetişkin bir kadın",
      tone: 'semantic',
    },
    {
      german: "möchte",
      translated: "istiyor",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "Almanya'da",
      tone: 'semantic',
    },
    {
      german: "das Abitur nachholen",
      translated: "sonradan Abitur almak",
      tone: 'semantic',
    },
    {
      german: "Das",
      translated: "Bunu",
      tone: 'semantic',
    },
    {
      german: "kann sie",
      translated: "yapabilir",
      tone: 'semantic',
    },
    {
      german: "an …",
      translated: "nerede",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:257|uk": [
    {
      german: "Eine erwachsene Frau",
      translated: "Доросла жінка",
      tone: 'semantic',
    },
    {
      german: "möchte",
      translated: "хоче",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "в Німеччині",
      tone: 'semantic',
    },
    {
      german: "das Abitur nachholen",
      translated: "пізніше отримати Abitur",
      tone: 'semantic',
    },
    {
      german: "Das",
      translated: "Вона",
      tone: 'semantic',
    },
    {
      german: "kann sie",
      translated: "може зробити",
      tone: 'semantic',
    },
    {
      german: "an …",
      translated: "це в …",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:257|vi": [
    {
      german: "Eine erwachsene Frau",
      translated: "Một phụ nữ trưởng thành",
      tone: 'semantic',
    },
    {
      german: "möchte",
      translated: "muốn",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "ở Đức",
      tone: 'semantic',
    },
    {
      german: "das Abitur nachholen",
      translated: "lấy Abitur sau này",
      tone: 'semantic',
    },
    {
      german: "kann sie",
      translated: "Cô ấy có thể",
      tone: 'semantic',
    },
    {
      german: "an …",
      translated: "làm điều đó tại …",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:258|ar": [
    {
      german: "das Jugendamt",
      translated: "لمكتب رعاية الشباب (Jugendamt)",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "في ألمانيا",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:258|bg": [
    {
      german: "Was",
      translated: "Какво",
      tone: 'semantic',
    },
    {
      german: "darf",
      translated: "може да направи",
      tone: 'semantic',
    },
    {
      german: "das Jugendamt",
      translated: "Jugendamt",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "в Германия",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:258|bs": [
    {
      german: "Was",
      translated: "Što",
      tone: 'semantic',
    },
    {
      german: "darf",
      translated: "može",
      tone: 'semantic',
    },
    {
      german: "das Jugendamt",
      translated: "Jugendamt",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "u Njemačkoj",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:258|el": [
    {
      german: "Was",
      translated: "Τι",
      tone: 'semantic',
    },
    {
      german: "darf",
      translated: "μπορεί",
      tone: 'semantic',
    },
    {
      german: "das Jugendamt",
      translated: "να κάνει το",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "στη Γερμανία",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:258|en": [
    {
      german: "Was",
      translated: "What",
      tone: 'semantic',
    },
    {
      german: "darf",
      translated: "is the",
      tone: 'semantic',
    },
    {
      german: "das Jugendamt",
      translated: "youth welfare office",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "in Germany",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:258|es": [
    {
      german: "Was",
      translated: "¿Qué",
      tone: 'semantic',
    },
    {
      german: "darf",
      translated: "puede hacer",
      tone: 'semantic',
    },
    {
      german: "das Jugendamt",
      translated: "la oficina de bienestar juvenil (Jugendamt)",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "en Alemania",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:258|fa": [
    {
      german: "Was",
      translated: "چه",
      tone: 'semantic',
    },
    {
      german: "darf",
      translated: "می‌تواند",
      tone: 'semantic',
    },
    {
      german: "das Jugendamt",
      translated: "ادارهٔ جوانان",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "در آلمان",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:258|fr": [
    {
      german: "Was",
      translated: "Que",
      tone: 'semantic',
    },
    {
      german: "darf",
      translated: "peut faire",
      tone: 'semantic',
    },
    {
      german: "das Jugendamt",
      translated: "le Jugendamt",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "en Allemagne",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:258|hr": [
    {
      german: "Was",
      translated: "Što",
      tone: 'semantic',
    },
    {
      german: "darf",
      translated: "može",
      tone: 'semantic',
    },
    {
      german: "das Jugendamt",
      translated: "Jugendamt",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "u Njemačkoj",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:258|it": [
    {
      german: "Was",
      translated: "Che cosa",
      tone: 'semantic',
    },
    {
      german: "darf",
      translated: "può fare",
      tone: 'semantic',
    },
    {
      german: "das Jugendamt",
      translated: "lo Jugendamt",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "in Germania",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:258|kmr": [
    {
      german: "Was",
      translated: "çi",
      tone: 'semantic',
    },
    {
      german: "darf",
      translated: "li",
      tone: 'semantic',
    },
    {
      german: "das Jugendamt",
      translated: "Jugendamt",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "Almanyayê",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:258|pl": [
    {
      german: "Was",
      translated: "Co",
      tone: 'semantic',
    },
    {
      german: "darf",
      translated: "może",
      tone: 'semantic',
    },
    {
      german: "das Jugendamt",
      translated: " Jugendamt",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "w Niemczech",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:258|prs": [
    {
      german: "Was",
      translated: "چه کاری",
      tone: 'semantic',
    },
    {
      german: "darf",
      translated: "می‌تواند",
      tone: 'semantic',
    },
    {
      german: "das Jugendamt",
      translated: "ادارهٔ جوانان (Jugendamt)",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "در آلمان",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:258|ro": [
    {
      german: "Was",
      translated: "Ce",
      tone: 'semantic',
    },
    {
      german: "darf",
      translated: "poate",
      tone: 'semantic',
    },
    {
      german: "das Jugendamt",
      translated: "Jugendamt",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "în Germania",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:258|ru": [
    {
      german: "Was",
      translated: "Что",
      tone: 'semantic',
    },
    {
      german: "darf",
      translated: "может делать",
      tone: 'semantic',
    },
    {
      german: "das Jugendamt",
      translated: "управление по делам молодёжи",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "в Германии",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:258|sq": [
    {
      german: "Was",
      translated: "Çfarë",
      tone: 'semantic',
    },
    {
      german: "darf",
      translated: "mund të bëjë",
      tone: 'semantic',
    },
    {
      german: "das Jugendamt",
      translated: "Jugendamt-i",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "në Gjermani?",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:258|sr": [
    {
      german: "Was",
      translated: "Šta",
      tone: 'semantic',
    },
    {
      german: "darf",
      translated: "može",
      tone: 'semantic',
    },
    {
      german: "das Jugendamt",
      translated: "Jugendamt",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "u Nemačkoj",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:258|tr": [
    {
      german: "Was",
      translated: "hangi",
      tone: 'semantic',
    },
    {
      german: "darf",
      translated: "yetkisi vardır",
      tone: 'semantic',
    },
    {
      german: "das Jugendamt",
      translated: "Jugendamt'ın",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "Almanya'da",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:258|uk": [
    {
      german: "Was",
      translated: "Що",
      tone: 'semantic',
    },
    {
      german: "darf",
      translated: "має право",
      tone: 'semantic',
    },
    {
      german: "das Jugendamt",
      translated: "робити Jugendamt",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "у Німеччині",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:258|vi": [
    {
      german: "Was",
      translated: "gì",
      tone: 'semantic',
    },
    {
      german: "das Jugendamt",
      translated: "Jugendamt",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "ở Đức",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:259|ar": [
    {
      german: "Berufsinformationszentrum BIZ",
      translated: "مركز معلومات المهن BIZ",
      tone: 'semantic',
    },
    {
      german: "bei der Bundesagentur für Arbeit",
      translated: "التابع للوكالة الاتحادية للعمل",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "في ألمانيا",
      tone: 'semantic',
    },
    {
      german: "hilft",
      translated: "يساعد",
      tone: 'semantic',
    },
    {
      german: "bei der …",
      translated: "في …",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:259|bg": [
    {
      german: "Berufsinformationszentrum BIZ",
      translated: "Центърът за професионална информация (BIZ)",
      tone: 'semantic',
    },
    {
      german: "bei der Bundesagentur für Arbeit",
      translated: "на Федералната агенция по заетостта",
      tone: 'semantic',
    },
    {
      german: "hilft",
      translated: "помага",
      tone: 'semantic',
    },
    {
      german: "bei der …",
      translated: "В коя област",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:259|bs": [
    {
      german: "Berufsinformationszentrum BIZ",
      translated: "Centar za profesionalno informiranje (BIZ)",
      tone: 'semantic',
    },
    {
      german: "bei der Bundesagentur für Arbeit",
      translated: "Savezne agencije za rad",
      tone: 'semantic',
    },
    {
      german: "hilft",
      translated: "pomaže",
      tone: 'semantic',
    },
    {
      german: "bei der …",
      translated: "U kojem području",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:259|el": [
    {
      german: "Berufsinformationszentrum BIZ",
      translated: "Κέντρο Επαγγελματικής Πληροφόρησης (BIZ)",
      tone: 'semantic',
    },
    {
      german: "bei der Bundesagentur für Arbeit",
      translated: "της Ομοσπονδιακής Υπηρεσίας Εργασίας",
      tone: 'semantic',
    },
    {
      german: "hilft",
      translated: "βοηθά",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:259|en": [
    {
      german: "Berufsinformationszentrum BIZ",
      translated: "The Career Information Center (BIZ)",
      tone: 'semantic',
    },
    {
      german: "bei der Bundesagentur für Arbeit",
      translated: "at the Federal Employment Agency",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "in Germany",
      tone: 'semantic',
    },
    {
      german: "hilft",
      translated: "helps",
      tone: 'semantic',
    },
    {
      german: "bei der …",
      translated: "with …",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:259|es": [
    {
      german: "Berufsinformationszentrum BIZ",
      translated: "El Centro de Información Profesional (BIZ)",
      tone: 'semantic',
    },
    {
      german: "bei der Bundesagentur für Arbeit",
      translated: "de la Agencia Federal de Empleo",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "en Alemania",
      tone: 'semantic',
    },
    {
      german: "hilft",
      translated: "ayuda",
      tone: 'semantic',
    },
    {
      german: "bei der …",
      translated: "con …",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:259|fa": [
    {
      german: "Berufsinformationszentrum BIZ",
      translated: "مرکز اطلاعات شغلی BIZ",
      tone: 'semantic',
    },
    {
      german: "bei der Bundesagentur für Arbeit",
      translated: "وابسته به آژانس فدرال کار",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "در آلمان",
      tone: 'semantic',
    },
    {
      german: "hilft",
      translated: "کمک می‌کند؟",
      tone: 'semantic',
    },
    {
      german: "bei der …",
      translated: "در چه زمینه‌ای",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:259|fr": [
    {
      german: "Berufsinformationszentrum BIZ",
      translated: "Le centre d’information professionnelle BIZ",
      tone: 'semantic',
    },
    {
      german: "bei der Bundesagentur für Arbeit",
      translated: "de l’Agence fédérale pour l’emploi",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "en Allemagne",
      tone: 'semantic',
    },
    {
      german: "hilft",
      translated: "aide",
      tone: 'semantic',
    },
    {
      german: "bei der …",
      translated: "à …",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:259|hr": [
    {
      german: "Berufsinformationszentrum BIZ",
      translated: "Centar za profesionalno informiranje (BIZ)",
      tone: 'semantic',
    },
    {
      german: "bei der Bundesagentur für Arbeit",
      translated: "Savezne agencije za rad",
      tone: 'semantic',
    },
    {
      german: "hilft",
      translated: "pomaže",
      tone: 'semantic',
    },
    {
      german: "bei der …",
      translated: "U kojem području",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:259|it": [
    {
      german: "Berufsinformationszentrum BIZ",
      translated: "Centro di informazione professionale (BIZ)",
      tone: 'semantic',
    },
    {
      german: "bei der Bundesagentur für Arbeit",
      translated: "dell’Agenzia federale per il lavoro",
      tone: 'semantic',
    },
    {
      german: "hilft",
      translated: "aiuta",
      tone: 'semantic',
    },
    {
      german: "bei der …",
      translated: "In quale ambito",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:259|kmr": [
    {
      german: "Berufsinformationszentrum BIZ",
      translated: "BIZ",
      tone: 'semantic',
    },
    {
      german: "bei der Bundesagentur für Arbeit",
      translated: "ya Bundesagentur für Arbeit",
      tone: 'semantic',
    },
    {
      german: "hilft",
      translated: "alîkarî dike.",
      tone: 'semantic',
    },
    {
      german: "bei der …",
      translated: "ji bo …",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:259|pl": [
    {
      german: "Berufsinformationszentrum BIZ",
      translated: "Centrum Informacji Zawodowej (BIZ)",
      tone: 'semantic',
    },
    {
      german: "bei der Bundesagentur für Arbeit",
      translated: "Federalnej Agencji Pracy",
      tone: 'semantic',
    },
    {
      german: "hilft",
      translated: "pomaga",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:259|prs": [
    {
      german: "Berufsinformationszentrum BIZ",
      translated: "مرکز اطلاعات شغلی BIZ",
      tone: 'semantic',
    },
    {
      german: "bei der Bundesagentur für Arbeit",
      translated: "وابسته به آژانس فدرال کار",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "در آلمان",
      tone: 'semantic',
    },
    {
      german: "hilft",
      translated: "کمک می‌کند",
      tone: 'semantic',
    },
    {
      german: "bei der …",
      translated: "در چه زمینه‌ای",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:259|ro": [
    {
      german: "Berufsinformationszentrum BIZ",
      translated: "Centrul de Informare Profesională (BIZ)",
      tone: 'semantic',
    },
    {
      german: "bei der Bundesagentur für Arbeit",
      translated: "al Agenției Federale pentru Ocuparea Forței de Muncă",
      tone: 'semantic',
    },
    {
      german: "hilft",
      translated: "ajută",
      tone: 'semantic',
    },
    {
      german: "bei der …",
      translated: "În ce domeniu",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:259|ru": [
    {
      german: "Berufsinformationszentrum BIZ",
      translated: "Центр профессиональной информации (BIZ)",
      tone: 'semantic',
    },
    {
      german: "bei der Bundesagentur für Arbeit",
      translated: "при Федеральном агентстве занятости Германии",
      tone: 'semantic',
    },
    {
      german: "hilft",
      translated: "помогает",
      tone: 'semantic',
    },
    {
      german: "bei der …",
      translated: "в …",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:259|sq": [
    {
      german: "Berufsinformationszentrum BIZ",
      translated: "Qendra e Informacionit Profesional (BIZ)",
      tone: 'semantic',
    },
    {
      german: "bei der Bundesagentur für Arbeit",
      translated: "e Agjencisë Federale të Punës",
      tone: 'semantic',
    },
    {
      german: "hilft",
      translated: "ndihmon",
      tone: 'semantic',
    },
    {
      german: "bei der …",
      translated: "Në cilën fushë",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:259|sr": [
    {
      german: "Berufsinformationszentrum BIZ",
      translated: "Centar za profesionalno informiranje (BIZ)",
      tone: 'semantic',
    },
    {
      german: "bei der Bundesagentur für Arbeit",
      translated: "Savezne agencije za rad",
      tone: 'semantic',
    },
    {
      german: "hilft",
      translated: "pomaže",
      tone: 'semantic',
    },
    {
      german: "bei der …",
      translated: "U kojem oblasti",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:259|tr": [
    {
      german: "Berufsinformationszentrum BIZ",
      translated: "Meslek Bilgi Merkezi (BIZ)",
      tone: 'semantic',
    },
    {
      german: "bei der Bundesagentur für Arbeit",
      translated: "Federal İş Ajansındaki",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "Almanya",
      tone: 'semantic',
    },
    {
      german: "hilft",
      translated: "yardımcı olur",
      tone: 'semantic',
    },
    {
      german: "bei der …",
      translated: "hangi konuda",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:259|uk": [
    {
      german: "Berufsinformationszentrum BIZ",
      translated: "BIZ",
      tone: 'semantic',
    },
    {
      german: "bei der Bundesagentur für Arbeit",
      translated: "при Федеральному агентстві зайнятості",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "Німеччини",
      tone: 'semantic',
    },
    {
      german: "hilft",
      translated: "допомагає",
      tone: 'semantic',
    },
    {
      german: "bei der …",
      translated: "з …",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:259|vi": [
    {
      german: "Berufsinformationszentrum BIZ",
      translated: "Trung tâm Thông tin Nghề nghiệp (BIZ)",
      tone: 'semantic',
    },
    {
      german: "bei der Bundesagentur für Arbeit",
      translated: "của Cơ quan Lao động Liên bang",
      tone: 'semantic',
    },
    {
      german: "hilft",
      translated: "hỗ trợ",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:25|ar": [
    {
      german: "Was ist",
      translated: "أي مما يلي",
      tone: 'semantic',
    },
    {
      german: "kein Bundesland",
      translated: "ليس ولاية اتحادية في",
      tone: 'semantic',
    },
    {
      german: "Bundesrepublik Deutschland",
      translated: "جمهورية ألمانيا الاتحادية",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:25|bg": [
    {
      german: "Was ist",
      translated: "Кое",
      tone: 'semantic',
    },
    {
      german: "kein Bundesland",
      translated: "НЕ е",
      tone: 'semantic',
    },
    {
      german: "Bundesrepublik Deutschland",
      translated: "на Германия?",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:25|bs": [
    {
      german: "Was ist",
      translated: "Što",
      tone: 'semantic',
    },
    {
      german: "kein Bundesland",
      translated: "NIJE savezna zemlja",
      tone: 'semantic',
    },
    {
      german: "Bundesrepublik Deutschland",
      translated: "Savezne Republike Njemačke",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:25|el": [
    {
      german: "Was ist",
      translated: "Ποιο από τα παρακάτω",
      tone: 'semantic',
    },
    {
      german: "kein Bundesland",
      translated: "ΔΕΝ είναι ομόσπονδο κρατίδιο",
      tone: 'semantic',
    },
    {
      german: "Bundesrepublik Deutschland",
      translated: "της Γερμανίας",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:25|en": [
    {
      german: "Was ist",
      translated: "What is",
      tone: 'semantic',
    },
    {
      german: "kein Bundesland",
      translated: "NOT a federal state",
      tone: 'semantic',
    },
    {
      german: "Bundesrepublik Deutschland",
      translated: "Federal Republic of Germany",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:25|es": [
    {
      german: "Was ist",
      translated: "¿Cuál de los siguientes",
      tone: 'semantic',
    },
    {
      german: "kein Bundesland",
      translated: "NO es un estado federado",
      tone: 'semantic',
    },
    {
      german: "Bundesrepublik Deutschland",
      translated: "República Federal de Alemania",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:25|fa": [
    {
      german: "Was ist",
      translated: "کدام مورد",
      tone: 'semantic',
    },
    {
      german: "kein Bundesland",
      translated: "یکی از ایالت‌های",
      tone: 'semantic',
    },
    {
      german: "Bundesrepublik Deutschland",
      translated: "جمهوری فدرال آلمان",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:25|fr": [
    {
      german: "Was ist",
      translated: "Lequel",
      tone: 'semantic',
    },
    {
      german: "kein Bundesland",
      translated: "n’est pas un Land",
      tone: 'semantic',
    },
    {
      german: "Bundesrepublik Deutschland",
      translated: "de la République fédérale d’Allemagne",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:25|hr": [
    {
      german: "Was ist",
      translated: "Što od navedenoga",
      tone: 'semantic',
    },
    {
      german: "kein Bundesland",
      translated: "NIJE savezna zemlja",
      tone: 'semantic',
    },
    {
      german: "Bundesrepublik Deutschland",
      translated: "Savezne Republike Njemačke",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:25|it": [
    {
      german: "Was ist",
      translated: "Quale dei seguenti",
      tone: 'semantic',
    },
    {
      german: "kein Bundesland",
      translated: "NON è un Land",
      tone: 'semantic',
    },
    {
      german: "Bundesrepublik Deutschland",
      translated: "della Repubblica Federale di Germania",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:25|kmr": [
    {
      german: "Was ist",
      translated: "Kîjan",
      tone: 'semantic',
    },
    {
      german: "kein Bundesland",
      translated: "ne eyaleteke federal",
      tone: 'semantic',
    },
    {
      german: "Bundesrepublik Deutschland",
      translated: "a Komara Federal a Almanyayê",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:25|pl": [
    {
      german: "Was ist",
      translated: "Który z poniższych",
      tone: 'semantic',
    },
    {
      german: "kein Bundesland",
      translated: "NIE jest krajem związkowym",
      tone: 'semantic',
    },
    {
      german: "Bundesrepublik Deutschland",
      translated: "Republiki Federalnej Niemiec",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:25|prs": [
    {
      german: "Was ist",
      translated: "کدام مورد یکی",
      tone: 'semantic',
    },
    {
      german: "kein Bundesland",
      translated: "از ایالت‌های",
      tone: 'semantic',
    },
    {
      german: "Bundesrepublik Deutschland",
      translated: "جمهوری فدرال آلمان",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:25|ro": [
    {
      german: "Was ist",
      translated: "Care",
      tone: 'semantic',
    },
    {
      german: "kein Bundesland",
      translated: "NU este un land",
      tone: 'semantic',
    },
    {
      german: "Bundesrepublik Deutschland",
      translated: "Republicii Federale Germania",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:25|ru": [
    {
      german: "Was ist",
      translated: "Что",
      tone: 'semantic',
    },
    {
      german: "kein Bundesland",
      translated: "не является федеральной землёй",
      tone: 'semantic',
    },
    {
      german: "Bundesrepublik Deutschland",
      translated: "Германии",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:25|sq": [
    {
      german: "Was ist",
      translated: "Cila nga këto",
      tone: 'semantic',
    },
    {
      german: "kein Bundesland",
      translated: "NUK është land",
      tone: 'semantic',
    },
    {
      german: "Bundesrepublik Deutschland",
      translated: "Republikës Federale të Gjermanisë",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:25|sr": [
    {
      german: "Was ist",
      translated: "Šta od navedenoga",
      tone: 'semantic',
    },
    {
      german: "kein Bundesland",
      translated: "NIJE savezna",
      tone: 'semantic',
    },
    {
      german: "Bundesrepublik Deutschland",
      translated: "Savezne Republike Nemačke",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:25|tr": [
    {
      german: "Was ist",
      translated: "Aşağıdakilerden hangisi",
      tone: 'semantic',
    },
    {
      german: "kein Bundesland",
      translated: "bir eyaleti değildir",
      tone: 'semantic',
    },
    {
      german: "Bundesrepublik Deutschland",
      translated: "Almanya Federal Cumhuriyeti'nin",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:25|uk": [
    {
      german: "Was ist",
      translated: "Що",
      tone: 'semantic',
    },
    {
      german: "kein Bundesland",
      translated: "не є федеральною землею",
      tone: 'semantic',
    },
    {
      german: "Bundesrepublik Deutschland",
      translated: "Федеративної Республіки Німеччина",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:25|vi": [
    {
      german: "Was ist",
      translated: "Điều nào sau đây",
      tone: 'semantic',
    },
    {
      german: "kein Bundesland",
      translated: "KHÔNG phải là một bang",
      tone: 'semantic',
    },
    {
      german: "Bundesrepublik Deutschland",
      translated: "Cộng hòa Liên bang Đức",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:260|ar": [
    {
      german: "In Deutschland",
      translated: "في ألمانيا",
      tone: 'semantic',
    },
    {
      german: "ein Kind",
      translated: "على الطفل",
      tone: 'semantic',
    },
    {
      german: "in der Schule",
      translated: "في المدرسة",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:260|bg": [
    {
      german: "In Deutschland",
      translated: "В Германия",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "има",
      tone: 'semantic',
    },
    {
      german: "ein Kind",
      translated: "дете",
      tone: 'semantic',
    },
    {
      german: "in der Schule",
      translated: "в училище",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:260|bs": [
    {
      german: "In Deutschland",
      translated: "U Njemačkoj",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "ima",
      tone: 'semantic',
    },
    {
      german: "ein Kind",
      translated: "dijete",
      tone: 'semantic',
    },
    {
      german: "in der Schule",
      translated: "u školi",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:260|el": [
    {
      german: "In Deutschland",
      translated: "Στη Γερμανία",
      tone: 'semantic',
    },
    {
      german: "ein Kind",
      translated: "ένα παιδί",
      tone: 'semantic',
    },
    {
      german: "in der Schule",
      translated: "στο σχολείο",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:260|en": [
    {
      german: "In Deutschland",
      translated: "In Germany,",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "has",
      tone: 'semantic',
    },
    {
      german: "ein Kind",
      translated: "a child",
      tone: 'semantic',
    },
    {
      german: "in der Schule",
      translated: "in school",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:260|es": [
    {
      german: "In Deutschland",
      translated: "En Alemania",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "tiene",
      tone: 'semantic',
    },
    {
      german: "ein Kind",
      translated: "un niño",
      tone: 'semantic',
    },
    {
      german: "in der Schule",
      translated: "en la escuela",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:260|fa": [
    {
      german: "In Deutschland",
      translated: "در آلمان",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "دارد",
      tone: 'semantic',
    },
    {
      german: "ein Kind",
      translated: "یک کودک",
      tone: 'semantic',
    },
    {
      german: "in der Schule",
      translated: "در مدرسه",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:260|fr": [
    {
      german: "In Deutschland",
      translated: "En Allemagne",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "a",
      tone: 'semantic',
    },
    {
      german: "ein Kind",
      translated: "un enfant",
      tone: 'semantic',
    },
    {
      german: "in der Schule",
      translated: "à l’école",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:260|hr": [
    {
      german: "In Deutschland",
      translated: "U Njemačkoj",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "ima",
      tone: 'semantic',
    },
    {
      german: "ein Kind",
      translated: "dijete",
      tone: 'semantic',
    },
    {
      german: "in der Schule",
      translated: "u školi",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:260|it": [
    {
      german: "In Deutschland",
      translated: "In Germania",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "ha",
      tone: 'semantic',
    },
    {
      german: "ein Kind",
      translated: "un bambino",
      tone: 'semantic',
    },
    {
      german: "in der Schule",
      translated: "a scuola",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:260|kmr": [
    {
      german: "In Deutschland",
      translated: "li Almanyayê",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "heye",
      tone: 'semantic',
    },
    {
      german: "ein Kind",
      translated: "Zarok",
      tone: 'semantic',
    },
    {
      german: "in der Schule",
      translated: "li dibistanê",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:260|pl": [
    {
      german: "In Deutschland",
      translated: "W Niemczech",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "ma",
      tone: 'semantic',
    },
    {
      german: "ein Kind",
      translated: "dziecko",
      tone: 'semantic',
    },
    {
      german: "in der Schule",
      translated: "w szkole",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:260|prs": [
    {
      german: "In Deutschland",
      translated: "در آلمان",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "دارد",
      tone: 'semantic',
    },
    {
      german: "ein Kind",
      translated: "یک کودک",
      tone: 'semantic',
    },
    {
      german: "in der Schule",
      translated: "در مکتب",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:260|ro": [
    {
      german: "In Deutschland",
      translated: "În Germania",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "are",
      tone: 'semantic',
    },
    {
      german: "ein Kind",
      translated: "un copil",
      tone: 'semantic',
    },
    {
      german: "in der Schule",
      translated: "la școală",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:260|ru": [
    {
      german: "In Deutschland",
      translated: "В Германии",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "имеет",
      tone: 'semantic',
    },
    {
      german: "ein Kind",
      translated: "ребёнок",
      tone: 'semantic',
    },
    {
      german: "in der Schule",
      translated: "в школе",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:260|sq": [
    {
      german: "In Deutschland",
      translated: "Në Gjermani",
      tone: 'semantic',
    },
    {
      german: "ein Kind",
      translated: "një fëmijë",
      tone: 'semantic',
    },
    {
      german: "in der Schule",
      translated: "në shkollë",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:260|sr": [
    {
      german: "In Deutschland",
      translated: "U Nemačkoj",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "ima",
      tone: 'semantic',
    },
    {
      german: "ein Kind",
      translated: "dete",
      tone: 'semantic',
    },
    {
      german: "in der Schule",
      translated: "u školi",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:260|tr": [
    {
      german: "In Deutschland",
      translated: "Almanya'da",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "vardır",
      tone: 'semantic',
    },
    {
      german: "ein Kind",
      translated: "bir öğrencinin",
      tone: 'semantic',
    },
    {
      german: "in der Schule",
      translated: "okulda",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:260|uk": [
    {
      german: "In Deutschland",
      translated: "У Німеччині",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: " має",
      tone: 'semantic',
    },
    {
      german: "ein Kind",
      translated: "дитина",
      tone: 'semantic',
    },
    {
      german: "in der Schule",
      translated: "в школі",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:260|vi": [
    {
      german: "In Deutschland",
      translated: "Ở Đức",
      tone: 'semantic',
    },
    {
      german: "ein Kind",
      translated: "một đứa trẻ",
      tone: 'semantic',
    },
    {
      german: "in der Schule",
      translated: "ở trường",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:261|ar": [
    {
      german: "möchte",
      translated: "يريد",
      tone: 'semantic',
    },
    {
      german: "mit 30 Jahren",
      translated: "رجل في الثلاثين من عمره",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "في ألمانيا",
      tone: 'semantic',
    },
    {
      german: "sein Abitur nachholen",
      translated: "الحصول على شهادة Abitur لاحقًا",
      tone: 'semantic',
    },
    {
      german: "Wo",
      translated: "أين",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:261|bg": [
    {
      german: "Ein Mann",
      translated: "Мъж",
      tone: 'semantic',
    },
    {
      german: "möchte",
      translated: "иска",
      tone: 'semantic',
    },
    {
      german: "mit 30 Jahren",
      translated: "на 30-годишна възраст",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "в Германия",
      tone: 'semantic',
    },
    {
      german: "sein Abitur nachholen",
      translated: "да получи Abitur",
      tone: 'semantic',
    },
    {
      german: "Wo",
      translated: "Къде",
      tone: 'semantic',
    },
    {
      german: "kann er",
      translated: "може да",
      tone: 'semantic',
    },
    {
      german: "das tun",
      translated: "направи това",
      tone: 'semantic',
    },
    {
      german: "An",
      translated: "В",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:261|bs": [
    {
      german: "Ein Mann",
      translated: "Muškarac",
      tone: 'semantic',
    },
    {
      german: "möchte",
      translated: "želi",
      tone: 'semantic',
    },
    {
      german: "mit 30 Jahren",
      translated: "s 30 godina",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "u Njemačkoj",
      tone: 'semantic',
    },
    {
      german: "sein Abitur nachholen",
      translated: "steći Abitur",
      tone: 'semantic',
    },
    {
      german: "Wo",
      translated: "Gdje",
      tone: 'semantic',
    },
    {
      german: "kann er",
      translated: "može",
      tone: 'semantic',
    },
    {
      german: "das tun",
      translated: "učiniti",
      tone: 'semantic',
    },
    {
      german: "An",
      translated: "Na",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:261|el": [
    {
      german: "Ein Mann",
      translated: "Ένας άνδρας",
      tone: 'semantic',
    },
    {
      german: "möchte",
      translated: "θέλει",
      tone: 'semantic',
    },
    {
      german: "mit 30 Jahren",
      translated: "στα 30 του",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "στη Γερμανία",
      tone: 'semantic',
    },
    {
      german: "sein Abitur nachholen",
      translated: "να αποκτήσει Abitur",
      tone: 'semantic',
    },
    {
      german: "Wo",
      translated: "Πού",
      tone: 'semantic',
    },
    {
      german: "kann er",
      translated: "μπορεί να",
      tone: 'semantic',
    },
    {
      german: "das tun",
      translated: "το κάνει",
      tone: 'semantic',
    },
    {
      german: "An",
      translated: "Σε",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:261|en": [
    {
      german: "Ein Mann",
      translated: "A man",
      tone: 'semantic',
    },
    {
      german: "möchte",
      translated: "wants",
      tone: 'semantic',
    },
    {
      german: "mit 30 Jahren",
      translated: "at age 30",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "in Germany",
      tone: 'semantic',
    },
    {
      german: "sein Abitur nachholen",
      translated: "complete his Abitur",
      tone: 'semantic',
    },
    {
      german: "Wo",
      translated: "Where",
      tone: 'semantic',
    },
    {
      german: "kann er",
      translated: "can he",
      tone: 'semantic',
    },
    {
      german: "das tun",
      translated: "do this",
      tone: 'semantic',
    },
    {
      german: "An",
      translated: "At",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:261|es": [
    {
      german: "Ein Mann",
      translated: "Un hombre",
      tone: 'semantic',
    },
    {
      german: "möchte",
      translated: "quiere",
      tone: 'semantic',
    },
    {
      german: "mit 30 Jahren",
      translated: "de 30 años",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "en Alemania",
      tone: 'semantic',
    },
    {
      german: "sein Abitur nachholen",
      translated: "obtener posteriormente el Abitur",
      tone: 'semantic',
    },
    {
      german: "Wo",
      translated: "¿Dónde",
      tone: 'semantic',
    },
    {
      german: "kann er",
      translated: "puede",
      tone: 'semantic',
    },
    {
      german: "das tun",
      translated: "hacerlo",
      tone: 'semantic',
    },
    {
      german: "An",
      translated: "En",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:261|fa": [
    {
      german: "Ein Mann",
      translated: "مردی",
      tone: 'semantic',
    },
    {
      german: "möchte",
      translated: "می‌خواهد",
      tone: 'semantic',
    },
    {
      german: "mit 30 Jahren",
      translated: "در ۳۰سالگی",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "در آلمان",
      tone: 'semantic',
    },
    {
      german: "sein Abitur nachholen",
      translated: "مدرک Abitur بگیرد",
      tone: 'semantic',
    },
    {
      german: "Wo",
      translated: "کجا",
      tone: 'semantic',
    },
    {
      german: "kann er",
      translated: "می‌تواند",
      tone: 'semantic',
    },
    {
      german: "das tun",
      translated: "این کار را انجام دهد",
      tone: 'semantic',
    },
    {
      german: "An",
      translated: "در",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:261|fr": [
    {
      german: "Ein Mann",
      translated: "Un homme",
      tone: 'semantic',
    },
    {
      german: "möchte",
      translated: "souhaite",
      tone: 'semantic',
    },
    {
      german: "mit 30 Jahren",
      translated: "de 30 ans",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "en Allemagne",
      tone: 'semantic',
    },
    {
      german: "sein Abitur nachholen",
      translated: "obtenir plus tard l’Abitur",
      tone: 'semantic',
    },
    {
      german: "Wo",
      translated: "Où",
      tone: 'semantic',
    },
    {
      german: "kann er",
      translated: "peut-il",
      tone: 'semantic',
    },
    {
      german: "das tun",
      translated: "le faire",
      tone: 'semantic',
    },
    {
      german: "An",
      translated: "Dans …",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:261|hr": [
    {
      german: "Ein Mann",
      translated: "Muškarac",
      tone: 'semantic',
    },
    {
      german: "möchte",
      translated: "želi",
      tone: 'semantic',
    },
    {
      german: "mit 30 Jahren",
      translated: "s 30 godina",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "u Njemačkoj",
      tone: 'semantic',
    },
    {
      german: "sein Abitur nachholen",
      translated: "steći Abitur",
      tone: 'semantic',
    },
    {
      german: "Wo",
      translated: "Gdje",
      tone: 'semantic',
    },
    {
      german: "kann er",
      translated: "može",
      tone: 'semantic',
    },
    {
      german: "das tun",
      translated: "učiniti",
      tone: 'semantic',
    },
    {
      german: "An",
      translated: "Na",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:261|it": [
    {
      german: "Ein Mann",
      translated: "Un uomo",
      tone: 'semantic',
    },
    {
      german: "möchte",
      translated: "vuole",
      tone: 'semantic',
    },
    {
      german: "mit 30 Jahren",
      translated: "a 30 anni",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "in Germania",
      tone: 'semantic',
    },
    {
      german: "sein Abitur nachholen",
      translated: "conseguire il suo Abitur",
      tone: 'semantic',
    },
    {
      german: "Wo",
      translated: "Dove",
      tone: 'semantic',
    },
    {
      german: "kann er",
      translated: "può",
      tone: 'semantic',
    },
    {
      german: "das tun",
      translated: "farlo",
      tone: 'semantic',
    },
    {
      german: "An",
      translated: "Presso",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:261|kmr": [
    {
      german: "Ein Mann",
      translated: "Mêrek",
      tone: 'semantic',
    },
    {
      german: "möchte",
      translated: "dixwaze",
      tone: 'semantic',
    },
    {
      german: "mit 30 Jahren",
      translated: "30 salî",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "li Almanyayê",
      tone: 'semantic',
    },
    {
      german: "sein Abitur nachholen",
      translated: "Abitur paşê bistîne",
      tone: 'semantic',
    },
    {
      german: "Wo",
      translated: "Li ku",
      tone: 'semantic',
    },
    {
      german: "kann er",
      translated: "dikare",
      tone: 'semantic',
    },
    {
      german: "das tun",
      translated: "vê bike",
      tone: 'semantic',
    },
    {
      german: "An",
      translated: "Li",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:261|pl": [
    {
      german: "Ein Mann",
      translated: "Mężczyzna",
      tone: 'semantic',
    },
    {
      german: "möchte",
      translated: "chce",
      tone: 'semantic',
    },
    {
      german: "mit 30 Jahren",
      translated: "w wieku 30 lat",
      tone: 'semantic',
    },
    {
      german: "sein Abitur nachholen",
      translated: "uzyskać Abitur",
      tone: 'semantic',
    },
    {
      german: "Wo",
      translated: "Gdzie",
      tone: 'semantic',
    },
    {
      german: "kann er",
      translated: "może",
      tone: 'semantic',
    },
    {
      german: "das tun",
      translated: "to zrobić",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:261|prs": [
    {
      german: "Ein Mann",
      translated: "مردی",
      tone: 'semantic',
    },
    {
      german: "möchte",
      translated: "می‌خواهد",
      tone: 'semantic',
    },
    {
      german: "mit 30 Jahren",
      translated: "در ۳۰سالگی",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "در آلمان",
      tone: 'semantic',
    },
    {
      german: "Wo",
      translated: "کجا",
      tone: 'semantic',
    },
    {
      german: "kann er",
      translated: "می‌تواند",
      tone: 'semantic',
    },
    {
      german: "das tun",
      translated: "این کار را انجام دهد",
      tone: 'semantic',
    },
    {
      german: "An",
      translated: "در",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:261|ro": [
    {
      german: "Ein Mann",
      translated: "Un bărbat",
      tone: 'semantic',
    },
    {
      german: "möchte",
      translated: "vrea",
      tone: 'semantic',
    },
    {
      german: "mit 30 Jahren",
      translated: "la 30 de ani",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "în Germania",
      tone: 'semantic',
    },
    {
      german: "sein Abitur nachholen",
      translated: "să își completeze Abiturul",
      tone: 'semantic',
    },
    {
      german: "Wo",
      translated: "Unde",
      tone: 'semantic',
    },
    {
      german: "kann er",
      translated: "poate",
      tone: 'semantic',
    },
    {
      german: "das tun",
      translated: "face acest lucru",
      tone: 'semantic',
    },
    {
      german: "An",
      translated: "La …",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:261|ru": [
    {
      german: "Ein Mann",
      translated: "Мужчина",
      tone: 'semantic',
    },
    {
      german: "möchte",
      translated: "хочет",
      tone: 'semantic',
    },
    {
      german: "mit 30 Jahren",
      translated: "в 30 лет",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "в Германии",
      tone: 'semantic',
    },
    {
      german: "sein Abitur nachholen",
      translated: "получить аттестат зрелости",
      tone: 'semantic',
    },
    {
      german: "Wo",
      translated: "Где",
      tone: 'semantic',
    },
    {
      german: "kann er",
      translated: "он может",
      tone: 'semantic',
    },
    {
      german: "das tun",
      translated: "это сделать",
      tone: 'semantic',
    },
    {
      german: "An",
      translated: "В",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:261|sq": [
    {
      german: "Ein Mann",
      translated: "Një burrë",
      tone: 'semantic',
    },
    {
      german: "möchte",
      translated: "dëshiron",
      tone: 'semantic',
    },
    {
      german: "mit 30 Jahren",
      translated: "në moshën 30 vjeç",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "në Gjermani",
      tone: 'semantic',
    },
    {
      german: "sein Abitur nachholen",
      translated: "të marrë Abitur-in",
      tone: 'semantic',
    },
    {
      german: "Wo",
      translated: "Ku",
      tone: 'semantic',
    },
    {
      german: "kann er",
      translated: "mund ta",
      tone: 'semantic',
    },
    {
      german: "das tun",
      translated: "bëjë këtë",
      tone: 'semantic',
    },
    {
      german: "An",
      translated: "Në …",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:261|sr": [
    {
      german: "Ein Mann",
      translated: "Muškarac",
      tone: 'semantic',
    },
    {
      german: "möchte",
      translated: "želi",
      tone: 'semantic',
    },
    {
      german: "mit 30 Jahren",
      translated: "s 30 godina",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "u Nemačkoj",
      tone: 'semantic',
    },
    {
      german: "sein Abitur nachholen",
      translated: "steći Abitur",
      tone: 'semantic',
    },
    {
      german: "Wo",
      translated: "Gde",
      tone: 'semantic',
    },
    {
      german: "kann er",
      translated: "može",
      tone: 'semantic',
    },
    {
      german: "das tun",
      translated: "uraditi",
      tone: 'semantic',
    },
    {
      german: "An",
      translated: "Na",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:261|tr": [
    {
      german: "Ein Mann",
      translated: "bir erkek",
      tone: 'semantic',
    },
    {
      german: "möchte",
      translated: "istiyor",
      tone: 'semantic',
    },
    {
      german: "mit 30 Jahren",
      translated: "30 yaşındaki",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "Almanya'da",
      tone: 'semantic',
    },
    {
      german: "sein Abitur nachholen",
      translated: "sonradan Abitur almak",
      tone: 'semantic',
    },
    {
      german: "Wo",
      translated: "nerede",
      tone: 'semantic',
    },
    {
      german: "kann er",
      translated: "yapabilir",
      tone: 'semantic',
    },
    {
      german: "das tun",
      translated: "Bunu",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:261|uk": [
    {
      german: "Ein Mann",
      translated: "Чоловік",
      tone: 'semantic',
    },
    {
      german: "möchte",
      translated: "хоче",
      tone: 'semantic',
    },
    {
      german: "mit 30 Jahren",
      translated: "у віці 30 років",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "в Німеччині",
      tone: 'semantic',
    },
    {
      german: "sein Abitur nachholen",
      translated: "пізніше отримати Abitur",
      tone: 'semantic',
    },
    {
      german: "Wo",
      translated: "Де",
      tone: 'semantic',
    },
    {
      german: "kann er",
      translated: "може",
      tone: 'semantic',
    },
    {
      german: "das tun",
      translated: "зробити",
      tone: 'semantic',
    },
    {
      german: "An",
      translated: "У",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:261|vi": [
    {
      german: "Ein Mann",
      translated: "Một người đàn ông",
      tone: 'semantic',
    },
    {
      german: "möchte",
      translated: "muốn",
      tone: 'semantic',
    },
    {
      german: "mit 30 Jahren",
      translated: "khi 30 tuổi",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "ở Đức",
      tone: 'semantic',
    },
    {
      german: "sein Abitur nachholen",
      translated: "lấy Abitur",
      tone: 'semantic',
    },
    {
      german: "Wo",
      translated: "ở đâu",
      tone: 'semantic',
    },
    {
      german: "kann er",
      translated: "Anh ấy có thể",
      tone: 'semantic',
    },
    {
      german: "das tun",
      translated: "làm điều đó",
      tone: 'semantic',
    },
    {
      german: "An",
      translated: "Tại",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:262|ar": [
    {
      german: "Was bedeutet",
      translated: "ماذا يعني",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "في ألمانيا",
      tone: 'semantic',
    },
    {
      german: "der Grundsatz der Gleichbehandlung",
      translated: "مبدأ المساواة في المعاملة",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:262|bg": [
    {
      german: "Was bedeutet",
      translated: "Какво",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "в Германия",
      tone: 'semantic',
    },
    {
      german: "der Grundsatz der Gleichbehandlung",
      translated: "принципът на равно третиране",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:262|bs": [
    {
      german: "Was bedeutet",
      translated: "Što",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "u Njemačkoj",
      tone: 'semantic',
    },
    {
      german: "der Grundsatz der Gleichbehandlung",
      translated: "načelo jednakog postupanja",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:262|el": [
    {
      german: "Was bedeutet",
      translated: "Τι σημαίνει",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "στη Γερμανία",
      tone: 'semantic',
    },
    {
      german: "der Grundsatz der Gleichbehandlung",
      translated: "η αρχή της ίσης μεταχείρισης",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:262|en": [
    {
      german: "Was bedeutet",
      translated: "What does",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "in Germany",
      tone: 'semantic',
    },
    {
      german: "der Grundsatz der Gleichbehandlung",
      translated: "the principle of equal treatment",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:262|es": [
    {
      german: "Was bedeutet",
      translated: "¿Qué significa",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "en Alemania",
      tone: 'semantic',
    },
    {
      german: "der Grundsatz der Gleichbehandlung",
      translated: "el principio de igualdad de trato",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:262|fa": [
    {
      german: "Was bedeutet",
      translated: "اصل",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "در آلمان",
      tone: 'semantic',
    },
    {
      german: "der Grundsatz der Gleichbehandlung",
      translated: "به چه معناست",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:262|fr": [
    {
      german: "Was bedeutet",
      translated: "Que signifie",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "en Allemagne",
      tone: 'semantic',
    },
    {
      german: "der Grundsatz der Gleichbehandlung",
      translated: "le principe d’égalité de traitement",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:262|hr": [
    {
      german: "Was bedeutet",
      translated: "Što",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "u Njemačkoj",
      tone: 'semantic',
    },
    {
      german: "der Grundsatz der Gleichbehandlung",
      translated: "načelo jednakog postupanja",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:262|it": [
    {
      german: "Was bedeutet",
      translated: "Che cosa significa il",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "in Germania",
      tone: 'semantic',
    },
    {
      german: "der Grundsatz der Gleichbehandlung",
      translated: "principio della parità di trattamento",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:262|kmr": [
    {
      german: "Was bedeutet",
      translated: "tê çi wateyê",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "li Almanyayê",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:262|pl": [
    {
      german: "Was bedeutet",
      translated: "Co oznacza",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "w Niemczech",
      tone: 'semantic',
    },
    {
      german: "der Grundsatz der Gleichbehandlung",
      translated: "zasada równego traktowania",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:262|prs": [
    {
      german: "Was bedeutet",
      translated: "به چه معناست",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "در آلمان",
      tone: 'semantic',
    },
    {
      german: "der Grundsatz der Gleichbehandlung",
      translated: "اصل رفتار برابر",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:262|ro": [
    {
      german: "Was bedeutet",
      translated: "Ce înseamnă",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "în Germania",
      tone: 'semantic',
    },
    {
      german: "der Grundsatz der Gleichbehandlung",
      translated: "principiul egalității de tratament",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:262|ru": [
    {
      german: "Was bedeutet",
      translated: "Что означает",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "в Германии",
      tone: 'semantic',
    },
    {
      german: "der Grundsatz der Gleichbehandlung",
      translated: "принцип равного обращения",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:262|sq": [
    {
      german: "Was bedeutet",
      translated: "Çfarë do të thotë",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "në Gjermani",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:262|sr": [
    {
      german: "Was bedeutet",
      translated: "znači",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "u Nemačkoj",
      tone: 'semantic',
    },
    {
      german: "der Grundsatz der Gleichbehandlung",
      translated: "načelo jednakog postupanja",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:262|tr": [
    {
      german: "Was bedeutet",
      translated: "ne anlama gelir",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "Almanya'da",
      tone: 'semantic',
    },
    {
      german: "der Grundsatz der Gleichbehandlung",
      translated: "eşit muamele ilkesi",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:262|uk": [
    {
      german: "Was bedeutet",
      translated: "Що",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "в Німеччині",
      tone: 'semantic',
    },
    {
      german: "der Grundsatz der Gleichbehandlung",
      translated: "принцип рівного ставлення",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:262|vi": [
    {
      german: "Was bedeutet",
      translated: "có nghĩa là gì?",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "ở Đức",
      tone: 'semantic',
    },
    {
      german: "der Grundsatz der Gleichbehandlung",
      translated: "Nguyên tắc đối xử bình đẳng",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:263|ar": [
    {
      german: "In Deutschland",
      translated: "في ألمانيا",
      tone: 'semantic',
    },
    {
      german: "sind Jugendliche",
      translated: "للشباب",
      tone: 'semantic',
    },
    {
      german: "ab 14 Jahren",
      translated: "من سن 14 عامًا",
      tone: 'semantic',
    },
    {
      german: "strafmündig",
      translated: "المسؤولية الجنائية",
      tone: 'semantic',
    },
    {
      german: "Das bedeutet:",
      translated: "ماذا يعني ذلك؟",
      tone: 'semantic',
    },
    {
      german: "Jugendliche, die 14 Jahre und älter sind",
      translated: "الشباب الذين يبلغون 14 عامًا أو أكثر",
      tone: 'semantic',
    },
    {
      german: "und gegen Strafgesetze verstoßen",
      translated: "ويخالفون القوانين الجنائية",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:263|bg": [
    {
      german: "In Deutschland",
      translated: "В Германия",
      tone: 'semantic',
    },
    {
      german: "sind Jugendliche",
      translated: "младежите носят",
      tone: 'semantic',
    },
    {
      german: "ab 14 Jahren",
      translated: "от 14-годишна",
      tone: 'semantic',
    },
    {
      german: "strafmündig",
      translated: "наказателна отговорност",
      tone: 'semantic',
    },
    {
      german: "Das bedeutet:",
      translated: "Това означава, че",
      tone: 'semantic',
    },
    {
      german: "Jugendliche, die 14 Jahre und älter sind",
      translated: "младежи на 14 и повече години",
      tone: 'semantic',
    },
    {
      german: "und gegen Strafgesetze verstoßen",
      translated: "които нарушат наказателния закон",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:263|bs": [
    {
      german: "In Deutschland",
      translated: "U Njemačkoj",
      tone: 'semantic',
    },
    {
      german: "sind Jugendliche",
      translated: "mladi",
      tone: 'semantic',
    },
    {
      german: "ab 14 Jahren",
      translated: "od 14. godine",
      tone: 'semantic',
    },
    {
      german: "strafmündig",
      translated: "krivično odgovaraju",
      tone: 'semantic',
    },
    {
      german: "Das bedeutet:",
      translated: "To znači da",
      tone: 'semantic',
    },
    {
      german: "Jugendliche, die 14 Jahre und älter sind",
      translated: "osobe od 14 godina",
      tone: 'semantic',
    },
    {
      german: "und gegen Strafgesetze verstoßen",
      translated: "koje prekrše krivični zakon",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:263|el": [
    {
      german: "In Deutschland",
      translated: "Στη Γερμανία",
      tone: 'semantic',
    },
    {
      german: "sind Jugendliche",
      translated: "οι νέοι",
      tone: 'semantic',
    },
    {
      german: "ab 14 Jahren",
      translated: "από 14 ετών",
      tone: 'semantic',
    },
    {
      german: "strafmündig",
      translated: "έχουν ποινική ευθύνη",
      tone: 'semantic',
    },
    {
      german: "Das bedeutet:",
      translated: "Αυτό σημαίνει ότι",
      tone: 'semantic',
    },
    {
      german: "Jugendliche, die 14 Jahre und älter sind",
      translated: "οι νέοι 14 ετών και άνω",
      tone: 'semantic',
    },
    {
      german: "und gegen Strafgesetze verstoßen",
      translated: "που παραβιάζουν το ποινικό δίκαιο",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:263|en": [
    {
      german: "In Deutschland",
      translated: "In Germany,",
      tone: 'semantic',
    },
    {
      german: "sind Jugendliche",
      translated: "young people are",
      tone: 'semantic',
    },
    {
      german: "ab 14 Jahren",
      translated: "from the age of 14",
      tone: 'semantic',
    },
    {
      german: "strafmündig",
      translated: "criminally responsible",
      tone: 'semantic',
    },
    {
      german: "Das bedeutet:",
      translated: "This means:",
      tone: 'semantic',
    },
    {
      german: "Jugendliche, die 14 Jahre und älter sind",
      translated: "young people who are 14 years and older",
      tone: 'semantic',
    },
    {
      german: "und gegen Strafgesetze verstoßen",
      translated: "and violate criminal laws …",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:263|es": [
    {
      german: "In Deutschland",
      translated: "En Alemania",
      tone: 'semantic',
    },
    {
      german: "sind Jugendliche",
      translated: "los jóvenes son",
      tone: 'semantic',
    },
    {
      german: "ab 14 Jahren",
      translated: "a partir de los 14 años",
      tone: 'semantic',
    },
    {
      german: "strafmündig",
      translated: "penalmente responsables",
      tone: 'semantic',
    },
    {
      german: "Das bedeutet:",
      translated: "Esto significa que",
      tone: 'semantic',
    },
    {
      german: "Jugendliche, die 14 Jahre und älter sind",
      translated: "los jóvenes de 14 años o más",
      tone: 'semantic',
    },
    {
      german: "und gegen Strafgesetze verstoßen",
      translated: "que infringen las leyes penales",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:263|fa": [
    {
      german: "In Deutschland",
      translated: "در آلمان",
      tone: 'semantic',
    },
    {
      german: "sind Jugendliche",
      translated: "نوجوانان",
      tone: 'semantic',
    },
    {
      german: "ab 14 Jahren",
      translated: "از ۱۴سالگی",
      tone: 'semantic',
    },
    {
      german: "strafmündig",
      translated: "مسئولیت کیفری",
      tone: 'semantic',
    },
    {
      german: "Das bedeutet:",
      translated: "یعنی",
      tone: 'semantic',
    },
    {
      german: "Jugendliche, die 14 Jahre und älter sind",
      translated: "نوجوانان ۱۴ساله و بالاتر",
      tone: 'semantic',
    },
    {
      german: "und gegen Strafgesetze verstoßen",
      translated: "که قوانین کیفری را نقض کنند",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:263|fr": [
    {
      german: "In Deutschland",
      translated: "En Allemagne",
      tone: 'semantic',
    },
    {
      german: "sind Jugendliche",
      translated: "les jeunes",
      tone: 'semantic',
    },
    {
      german: "ab 14 Jahren",
      translated: "à partir de 14 ans",
      tone: 'semantic',
    },
    {
      german: "strafmündig",
      translated: "pénalement responsables",
      tone: 'semantic',
    },
    {
      german: "Das bedeutet:",
      translated: "Cela signifie que",
      tone: 'semantic',
    },
    {
      german: "Jugendliche, die 14 Jahre und älter sind",
      translated: "les jeunes de 14 ans et plus",
      tone: 'semantic',
    },
    {
      german: "und gegen Strafgesetze verstoßen",
      translated: "qui enfreignent les lois pénales",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:263|hr": [
    {
      german: "In Deutschland",
      translated: "U Njemačkoj",
      tone: 'semantic',
    },
    {
      german: "sind Jugendliche",
      translated: "mladi",
      tone: 'semantic',
    },
    {
      german: "ab 14 Jahren",
      translated: "od 14. godine",
      tone: 'semantic',
    },
    {
      german: "strafmündig",
      translated: "kazneno odgovaraju",
      tone: 'semantic',
    },
    {
      german: "Das bedeutet:",
      translated: "To znači",
      tone: 'semantic',
    },
    {
      german: "Jugendliche, die 14 Jahre und älter sind",
      translated: "osobe od 14 godina",
      tone: 'semantic',
    },
    {
      german: "und gegen Strafgesetze verstoßen",
      translated: "koje prekrše kazneni zakon",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:263|it": [
    {
      german: "In Deutschland",
      translated: "In Germania",
      tone: 'semantic',
    },
    {
      german: "sind Jugendliche",
      translated: "i giovani sono",
      tone: 'semantic',
    },
    {
      german: "ab 14 Jahren",
      translated: "dai 14 anni",
      tone: 'semantic',
    },
    {
      german: "strafmündig",
      translated: "penalmente responsabili",
      tone: 'semantic',
    },
    {
      german: "Das bedeutet:",
      translated: "Ciò significa",
      tone: 'semantic',
    },
    {
      german: "Jugendliche, die 14 Jahre und älter sind",
      translated: "i giovani di 14 anni o più",
      tone: 'semantic',
    },
    {
      german: "und gegen Strafgesetze verstoßen",
      translated: "che violano il diritto penale",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:263|kmr": [
    {
      german: "In Deutschland",
      translated: "Li Almanyayê",
      tone: 'semantic',
    },
    {
      german: "sind Jugendliche",
      translated: "ciwan",
      tone: 'semantic',
    },
    {
      german: "ab 14 Jahren",
      translated: "ji 14 salî",
      tone: 'semantic',
    },
    {
      german: "strafmündig",
      translated: "berpirsiyariya ceza",
      tone: 'semantic',
    },
    {
      german: "Das bedeutet:",
      translated: "Ev tê çi wateyê",
      tone: 'semantic',
    },
    {
      german: "Jugendliche, die 14 Jahre und älter sind",
      translated: "Ciwanên ku 14 salî û mezintir in",
      tone: 'semantic',
    },
    {
      german: "und gegen Strafgesetze verstoßen",
      translated: "û qanûnên ceza binpê dikin",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:263|pl": [
    {
      german: "In Deutschland",
      translated: "W Niemczech",
      tone: 'semantic',
    },
    {
      german: "sind Jugendliche",
      translated: "młodzież",
      tone: 'semantic',
    },
    {
      german: "ab 14 Jahren",
      translated: "od 14. roku życia",
      tone: 'semantic',
    },
    {
      german: "strafmündig",
      translated: "ponosi odpowiedzialność karną",
      tone: 'semantic',
    },
    {
      german: "Das bedeutet:",
      translated: "Oznacza to,",
      tone: 'semantic',
    },
    {
      german: "Jugendliche, die 14 Jahre und älter sind",
      translated: "osoby od 14 lat",
      tone: 'semantic',
    },
    {
      german: "und gegen Strafgesetze verstoßen",
      translated: "które naruszają prawo karne",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:263|prs": [
    {
      german: "In Deutschland",
      translated: "در آلمان",
      tone: 'semantic',
    },
    {
      german: "sind Jugendliche",
      translated: "نوجوانان",
      tone: 'semantic',
    },
    {
      german: "ab 14 Jahren",
      translated: "از ۱۴سالگی",
      tone: 'semantic',
    },
    {
      german: "strafmündig",
      translated: "مسئولیت کیفری دارند",
      tone: 'semantic',
    },
    {
      german: "Das bedeutet:",
      translated: "یعنی",
      tone: 'semantic',
    },
    {
      german: "Jugendliche, die 14 Jahre und älter sind",
      translated: "نوجوانان ۱۴ساله و بالاتر",
      tone: 'semantic',
    },
    {
      german: "und gegen Strafgesetze verstoßen",
      translated: "که قوانین کیفری را نقض کنند",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:263|ro": [
    {
      german: "In Deutschland",
      translated: "În Germania",
      tone: 'semantic',
    },
    {
      german: "sind Jugendliche",
      translated: "tinerii",
      tone: 'semantic',
    },
    {
      german: "ab 14 Jahren",
      translated: "de la 14 ani",
      tone: 'semantic',
    },
    {
      german: "strafmündig",
      translated: "răspund penal",
      tone: 'semantic',
    },
    {
      german: "Das bedeutet:",
      translated: "Aceasta înseamnă că",
      tone: 'semantic',
    },
    {
      german: "Jugendliche, die 14 Jahre und älter sind",
      translated: "tinerii de 14 ani și peste",
      tone: 'semantic',
    },
    {
      german: "und gegen Strafgesetze verstoßen",
      translated: "care încalcă legea penală",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:263|ru": [
    {
      german: "In Deutschland",
      translated: "В Германии",
      tone: 'semantic',
    },
    {
      german: "sind Jugendliche",
      translated: "подростки",
      tone: 'semantic',
    },
    {
      german: "ab 14 Jahren",
      translated: "с 14 лет",
      tone: 'semantic',
    },
    {
      german: "strafmündig",
      translated: "несут уголовную ответственность",
      tone: 'semantic',
    },
    {
      german: "Das bedeutet:",
      translated: "Это означает:",
      tone: 'semantic',
    },
    {
      german: "Jugendliche, die 14 Jahre und älter sind",
      translated: "подростки от 14 лет и старше",
      tone: 'semantic',
    },
    {
      german: "und gegen Strafgesetze verstoßen",
      translated: "нарушившие уголовный закон",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:263|sq": [
    {
      german: "In Deutschland",
      translated: "Në Gjermani",
      tone: 'semantic',
    },
    {
      german: "sind Jugendliche",
      translated: "të rinjtë mbajnë",
      tone: 'semantic',
    },
    {
      german: "ab 14 Jahren",
      translated: "nga mosha 14 vjeç",
      tone: 'semantic',
    },
    {
      german: "strafmündig",
      translated: "përgjegjësi penale",
      tone: 'semantic',
    },
    {
      german: "Das bedeutet:",
      translated: "Kjo do të thotë se",
      tone: 'semantic',
    },
    {
      german: "Jugendliche, die 14 Jahre und älter sind",
      translated: "të rinjtë 14 vjeç e lart",
      tone: 'semantic',
    },
    {
      german: "und gegen Strafgesetze verstoßen",
      translated: "që shkelin ligjin penal",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:263|sr": [
    {
      german: "In Deutschland",
      translated: "U Nemačkoj",
      tone: 'semantic',
    },
    {
      german: "sind Jugendliche",
      translated: "mladi",
      tone: 'semantic',
    },
    {
      german: "ab 14 Jahren",
      translated: "od 14. godine",
      tone: 'semantic',
    },
    {
      german: "strafmündig",
      translated: "krivično odgovaraju",
      tone: 'semantic',
    },
    {
      german: "Das bedeutet:",
      translated: "To znači",
      tone: 'semantic',
    },
    {
      german: "Jugendliche, die 14 Jahre und älter sind",
      translated: "osobe od 14 godina",
      tone: 'semantic',
    },
    {
      german: "und gegen Strafgesetze verstoßen",
      translated: "koje prekrše krivični zakon",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:263|tr": [
    {
      german: "In Deutschland",
      translated: "Almanya'da",
      tone: 'semantic',
    },
    {
      german: "sind Jugendliche",
      translated: "gençler",
      tone: 'semantic',
    },
    {
      german: "ab 14 Jahren",
      translated: "14 yaşından itibaren",
      tone: 'semantic',
    },
    {
      german: "strafmündig",
      translated: "ceza sorumluluğuna sahiptir",
      tone: 'semantic',
    },
    {
      german: "Das bedeutet:",
      translated: "Bu ne demektir?",
      tone: 'semantic',
    },
    {
      german: "Jugendliche, die 14 Jahre und älter sind",
      translated: "14 yaş ve üzerindeki gençler",
      tone: 'semantic',
    },
    {
      german: "und gegen Strafgesetze verstoßen",
      translated: "Ceza yasasını ihlal eden",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:263|uk": [
    {
      german: "In Deutschland",
      translated: "У Німеччині",
      tone: 'semantic',
    },
    {
      german: "sind Jugendliche",
      translated: "підлітки",
      tone: 'semantic',
    },
    {
      german: "ab 14 Jahren",
      translated: "з 14 років",
      tone: 'semantic',
    },
    {
      german: "strafmündig",
      translated: "несуть кримінальну відповідальність",
      tone: 'semantic',
    },
    {
      german: "Das bedeutet:",
      translated: "Це означає:",
      tone: 'semantic',
    },
    {
      german: "Jugendliche, die 14 Jahre und älter sind",
      translated: "підлітки віком від 14 років",
      tone: 'semantic',
    },
    {
      german: "und gegen Strafgesetze verstoßen",
      translated: "які порушують кримінальні закони",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:263|vi": [
    {
      german: "In Deutschland",
      translated: "Ở Đức",
      tone: 'semantic',
    },
    {
      german: "sind Jugendliche",
      translated: "thanh thiếu niên",
      tone: 'semantic',
    },
    {
      german: "ab 14 Jahren",
      translated: "từ 14 tuổi",
      tone: 'semantic',
    },
    {
      german: "strafmündig",
      translated: "chịu trách nhiệm hình sự",
      tone: 'semantic',
    },
    {
      german: "Das bedeutet:",
      translated: "Điều đó có nghĩa là",
      tone: 'semantic',
    },
    {
      german: "Jugendliche, die 14 Jahre und älter sind",
      translated: "người từ 14 tuổi trở lên",
      tone: 'semantic',
    },
    {
      german: "und gegen Strafgesetze verstoßen",
      translated: "vi phạm luật hình sự",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:264|ar": [
    {
      german: "Zu welchem Fest",
      translated: "في أي مناسبة",
      tone: 'semantic',
    },
    {
      german: "tragen",
      translated: "يرتدي",
      tone: 'semantic',
    },
    {
      german: "Menschen",
      translated: "الناس",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "في ألمانيا",
      tone: 'semantic',
    },
    {
      german: "bunte Kostüme und Masken",
      translated: "أزياء وأقنعة ملونة",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:264|bg": [
    {
      german: "Zu welchem Fest",
      translated: "На кой празник",
      tone: 'semantic',
    },
    {
      german: "tragen",
      translated: "носят",
      tone: 'semantic',
    },
    {
      german: "Menschen",
      translated: "хората",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "в Германия",
      tone: 'semantic',
    },
    {
      german: "bunte Kostüme und Masken",
      translated: "цветни костюми и маски",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:264|bs": [
    {
      german: "Zu welchem Fest",
      translated: "Na koji se praznik",
      tone: 'semantic',
    },
    {
      german: "tragen",
      translated: "odijevaju",
      tone: 'semantic',
    },
    {
      german: "Menschen",
      translated: "ljudi",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "u Njemačkoj",
      tone: 'semantic',
    },
    {
      german: "bunte Kostüme und Masken",
      translated: "u šarene kostime i nose maske",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:264|el": [
    {
      german: "Zu welchem Fest",
      translated: "Σε ποια γιορτή",
      tone: 'semantic',
    },
    {
      german: "tragen",
      translated: "φορούν",
      tone: 'semantic',
    },
    {
      german: "Menschen",
      translated: "οι άνθρωποι",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "στη Γερμανία",
      tone: 'semantic',
    },
    {
      german: "bunte Kostüme und Masken",
      translated: "πολύχρωμες στολές και μάσκες",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:264|en": [
    {
      german: "Zu welchem Fest",
      translated: "At which festival",
      tone: 'semantic',
    },
    {
      german: "tragen",
      translated: "do",
      tone: 'semantic',
    },
    {
      german: "Menschen",
      translated: "people",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "in Germany",
      tone: 'semantic',
    },
    {
      german: "bunte Kostüme und Masken",
      translated: "colorful costumes and masks",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:264|es": [
    {
      german: "Zu welchem Fest",
      translated: "¿En qué celebración",
      tone: 'semantic',
    },
    {
      german: "tragen",
      translated: "llevan",
      tone: 'semantic',
    },
    {
      german: "Menschen",
      translated: "las personas",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "en Alemania",
      tone: 'semantic',
    },
    {
      german: "bunte Kostüme und Masken",
      translated: "disfraces y máscaras de colores",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:264|fa": [
    {
      german: "Zu welchem Fest",
      translated: "در کدام جشن",
      tone: 'semantic',
    },
    {
      german: "tragen",
      translated: "می‌پوشند",
      tone: 'semantic',
    },
    {
      german: "Menschen",
      translated: "مردم",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "در آلمان",
      tone: 'semantic',
    },
    {
      german: "bunte Kostüme und Masken",
      translated: "لباس‌های رنگارنگ و ماسک",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:264|fr": [
    {
      german: "Zu welchem Fest",
      translated: "À quelle fête",
      tone: 'semantic',
    },
    {
      german: "tragen",
      translated: "portent-ils",
      tone: 'semantic',
    },
    {
      german: "Menschen",
      translated: "les gens",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "en Allemagne",
      tone: 'semantic',
    },
    {
      german: "bunte Kostüme und Masken",
      translated: "des costumes colorés et des masques",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:264|hr": [
    {
      german: "Zu welchem Fest",
      translated: "Na koji se blagdan",
      tone: 'semantic',
    },
    {
      german: "tragen",
      translated: "odijevaju",
      tone: 'semantic',
    },
    {
      german: "Menschen",
      translated: "ljudi",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "u Njemačkoj",
      tone: 'semantic',
    },
    {
      german: "bunte Kostüme und Masken",
      translated: "šarene kostime i nose maske",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:264|it": [
    {
      german: "Zu welchem Fest",
      translated: "In quale festa",
      tone: 'semantic',
    },
    {
      german: "tragen",
      translated: "indossano",
      tone: 'semantic',
    },
    {
      german: "Menschen",
      translated: "le persone",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "in Germania",
      tone: 'semantic',
    },
    {
      german: "bunte Kostüme und Masken",
      translated: "costumi colorati e maschere",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:264|kmr": [
    {
      german: "Zu welchem Fest",
      translated: "Di kîjan cejnê",
      tone: 'semantic',
    },
    {
      german: "tragen",
      translated: "dikin",
      tone: 'semantic',
    },
    {
      german: "Menschen",
      translated: "mirov",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "li Almanyayê",
      tone: 'semantic',
    },
    {
      german: "bunte Kostüme und Masken",
      translated: "cil û maskeyên rengîn",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:264|pl": [
    {
      german: "Zu welchem Fest",
      translated: "Podczas którego święta",
      tone: 'semantic',
    },
    {
      german: "tragen",
      translated: "noszą",
      tone: 'semantic',
    },
    {
      german: "Menschen",
      translated: "ludzie",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "w Niemczech",
      tone: 'semantic',
    },
    {
      german: "bunte Kostüme und Masken",
      translated: "kolorowe kostiumy i maski",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:264|prs": [
    {
      german: "Zu welchem Fest",
      translated: "در کدام جشن",
      tone: 'semantic',
    },
    {
      german: "tragen",
      translated: "می‌پوشند",
      tone: 'semantic',
    },
    {
      german: "Menschen",
      translated: "مردم",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "در آلمان",
      tone: 'semantic',
    },
    {
      german: "bunte Kostüme und Masken",
      translated: "لباس‌های رنگارنگ و ماسک",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:264|ro": [
    {
      german: "Zu welchem Fest",
      translated: "La ce sărbătoare",
      tone: 'semantic',
    },
    {
      german: "tragen",
      translated: "poartă",
      tone: 'semantic',
    },
    {
      german: "Menschen",
      translated: "oamenii",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "din Germania",
      tone: 'semantic',
    },
    {
      german: "bunte Kostüme und Masken",
      translated: "costume colorate și măști",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:264|ru": [
    {
      german: "Zu welchem Fest",
      translated: "На каком празднике",
      tone: 'semantic',
    },
    {
      german: "tragen",
      translated: "носят",
      tone: 'semantic',
    },
    {
      german: "Menschen",
      translated: "люди",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "в Германии",
      tone: 'semantic',
    },
    {
      german: "bunte Kostüme und Masken",
      translated: "яркие костюмы и маски",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:264|sq": [
    {
      german: "Zu welchem Fest",
      translated: "Në cilën festë",
      tone: 'semantic',
    },
    {
      german: "tragen",
      translated: "veshin",
      tone: 'semantic',
    },
    {
      german: "Menschen",
      translated: "njerëzit",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "në Gjermani",
      tone: 'semantic',
    },
    {
      german: "bunte Kostüme und Masken",
      translated: "kostume shumëngjyrëshe dhe maska",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:264|sr": [
    {
      german: "Zu welchem Fest",
      translated: "Na koji se praznik",
      tone: 'semantic',
    },
    {
      german: "tragen",
      translated: "odijevaju",
      tone: 'semantic',
    },
    {
      german: "Menschen",
      translated: "ljudi",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "u Nemačkoj",
      tone: 'semantic',
    },
    {
      german: "bunte Kostüme und Masken",
      translated: "u šarene kostime i nose maske",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:264|tr": [
    {
      german: "Zu welchem Fest",
      translated: "hangi bayramda",
      tone: 'semantic',
    },
    {
      german: "tragen",
      translated: "giyer",
      tone: 'semantic',
    },
    {
      german: "Menschen",
      translated: "insanlar",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "Almanya'da",
      tone: 'semantic',
    },
    {
      german: "bunte Kostüme und Masken",
      translated: "renkli kostüm ve maskeler",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:264|uk": [
    {
      german: "Zu welchem Fest",
      translated: "На яке свято",
      tone: 'semantic',
    },
    {
      german: "tragen",
      translated: "вдягають",
      tone: 'semantic',
    },
    {
      german: "Menschen",
      translated: "люди",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "в Німеччині",
      tone: 'semantic',
    },
    {
      german: "bunte Kostüme und Masken",
      translated: "барвисті костюми й маски",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:264|vi": [
    {
      german: "Zu welchem Fest",
      translated: "Trong ngày lễ nào",
      tone: 'semantic',
    },
    {
      german: "tragen",
      translated: "mặc",
      tone: 'semantic',
    },
    {
      german: "Menschen",
      translated: "người ta",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "ở Đức",
      tone: 'semantic',
    },
    {
      german: "bunte Kostüme und Masken",
      translated: "trang phục sặc sỡ và đeo mặt nạ",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:265|ar": [
    {
      german: "Wohin",
      translated: "إلى أين",
      tone: 'semantic',
    },
    {
      german: "muss man",
      translated: "يجب",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "في ألمانيا",
      tone: 'semantic',
    },
    {
      german: "zuerst gehen",
      translated: "أولًا",
      tone: 'semantic',
    },
    {
      german: "wenn man heiraten möchte",
      translated: "إذا أراد شخص الزواج",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:265|bg": [
    {
      german: "Wohin",
      translated: "къде",
      tone: 'semantic',
    },
    {
      german: "muss man",
      translated: "трябва",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "в Германия",
      tone: 'semantic',
    },
    {
      german: "zuerst gehen",
      translated: "да отидете първо",
      tone: 'semantic',
    },
    {
      german: "wenn man heiraten möchte",
      translated: "Ако искате да сключите брак",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:265|bs": [
    {
      german: "Wohin",
      translated: "kamo",
      tone: 'semantic',
    },
    {
      german: "muss man",
      translated: "biste",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "u Njemačkoj",
      tone: 'semantic',
    },
    {
      german: "zuerst gehen",
      translated: "najprije trebali otići",
      tone: 'semantic',
    },
    {
      german: "wenn man heiraten möchte",
      translated: "Ako se želite vjenčati",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:265|el": [
    {
      german: "Wohin",
      translated: "πού",
      tone: 'semantic',
    },
    {
      german: "muss man",
      translated: "πρέπει",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "στη Γερμανία",
      tone: 'semantic',
    },
    {
      german: "zuerst gehen",
      translated: "να πάτε πρώτα",
      tone: 'semantic',
    },
    {
      german: "wenn man heiraten möchte",
      translated: "Αν θέλετε να παντρευτείτε",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:265|en": [
    {
      german: "Wohin",
      translated: "Where",
      tone: 'semantic',
    },
    {
      german: "muss man",
      translated: "must you",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "in Germany",
      tone: 'semantic',
    },
    {
      german: "zuerst gehen",
      translated: "go first",
      tone: 'semantic',
    },
    {
      german: "wenn man heiraten möchte",
      translated: "if you want to get married",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:265|es": [
    {
      german: "Wohin",
      translated: "¿A dónde",
      tone: 'semantic',
    },
    {
      german: "muss man",
      translated: "hay que",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "en Alemania",
      tone: 'semantic',
    },
    {
      german: "zuerst gehen",
      translated: "dirigirse primero",
      tone: 'semantic',
    },
    {
      german: "wenn man heiraten möchte",
      translated: "si se quiere contraer matrimonio",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:265|fa": [
    {
      german: "Wohin",
      translated: "به کجا",
      tone: 'semantic',
    },
    {
      german: "muss man",
      translated: "باید",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "در آلمان",
      tone: 'semantic',
    },
    {
      german: "zuerst gehen",
      translated: "مراجعه کنید",
      tone: 'semantic',
    },
    {
      german: "wenn man heiraten möchte",
      translated: "بخواهید ازدواج کنید،",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:265|fr": [
    {
      german: "Wohin",
      translated: "Où",
      tone: 'semantic',
    },
    {
      german: "muss man",
      translated: "faut-il",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "en Allemagne",
      tone: 'semantic',
    },
    {
      german: "zuerst gehen",
      translated: "d’abord aller",
      tone: 'semantic',
    },
    {
      german: "wenn man heiraten möchte",
      translated: "lorsqu’on veut se marier",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:265|hr": [
    {
      german: "Wohin",
      translated: "kamo",
      tone: 'semantic',
    },
    {
      german: "muss man",
      translated: "biste",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "u Njemačkoj",
      tone: 'semantic',
    },
    {
      german: "zuerst gehen",
      translated: "najprije trebali otići",
      tone: 'semantic',
    },
    {
      german: "wenn man heiraten möchte",
      translated: "Ako se želite vjenčati",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:265|it": [
    {
      german: "Wohin",
      translated: "dove",
      tone: 'semantic',
    },
    {
      german: "muss man",
      translated: "dovete",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "in Germania",
      tone: 'semantic',
    },
    {
      german: "zuerst gehen",
      translated: "andare prima",
      tone: 'semantic',
    },
    {
      german: "wenn man heiraten möchte",
      translated: "Se volete sposarvi",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:265|kmr": [
    {
      german: "Wohin",
      translated: "Heke",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "li Almanyayê",
      tone: 'semantic',
    },
    {
      german: "zuerst gehen",
      translated: "pêşî diçe",
      tone: 'semantic',
    },
    {
      german: "wenn man heiraten möchte",
      translated: "kes dixwaze bizewice",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:265|pl": [
    {
      german: "Wohin",
      translated: "dokąd",
      tone: 'semantic',
    },
    {
      german: "muss man",
      translated: "powinniście",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "w Niemczech",
      tone: 'semantic',
    },
    {
      german: "zuerst gehen",
      translated: "najpierw pójść",
      tone: 'semantic',
    },
    {
      german: "wenn man heiraten möchte",
      translated: "Jeśli chcecie zawrzeć małżeństwo",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:265|prs": [
    {
      german: "in Deutschland",
      translated: "در آلمان",
      tone: 'semantic',
    },
    {
      german: "zuerst gehen",
      translated: "ابتدا باید",
      tone: 'semantic',
    },
    {
      german: "wenn man heiraten möchte",
      translated: "به کجا مراجعه کنید؟",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:265|ro": [
    {
      german: "Wohin",
      translated: "unde",
      tone: 'semantic',
    },
    {
      german: "muss man",
      translated: "trebuie",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "în Germania",
      tone: 'semantic',
    },
    {
      german: "zuerst gehen",
      translated: "să mergeți mai întâi",
      tone: 'semantic',
    },
    {
      german: "wenn man heiraten möchte",
      translated: "Dacă vreți să vă căsătoriți",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:265|ru": [
    {
      german: "Wohin",
      translated: "Куда",
      tone: 'semantic',
    },
    {
      german: "muss man",
      translated: "нужно",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "в Германии",
      tone: 'semantic',
    },
    {
      german: "zuerst gehen",
      translated: "сначала",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:265|sq": [
    {
      german: "Wohin",
      translated: "Nëse",
      tone: 'semantic',
    },
    {
      german: "muss man",
      translated: "dëshironi",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "në Gjermani",
      tone: 'semantic',
    },
    {
      german: "zuerst gehen",
      translated: "duhet të shkoni fillimisht",
      tone: 'semantic',
    },
    {
      german: "wenn man heiraten möchte",
      translated: "të martoheni",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:265|sr": [
    {
      german: "Wohin",
      translated: "kamo",
      tone: 'semantic',
    },
    {
      german: "muss man",
      translated: "biste",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "u Nemačkoj",
      tone: 'semantic',
    },
    {
      german: "zuerst gehen",
      translated: "najpre trebali otići",
      tone: 'semantic',
    },
    {
      german: "wenn man heiraten möchte",
      translated: "Ako se želite vjenčati",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:265|tr": [
    {
      german: "Wohin",
      translated: "nereye",
      tone: 'semantic',
    },
    {
      german: "muss man",
      translated: "gitmeniz gerekir",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "Almanya'da",
      tone: 'semantic',
    },
    {
      german: "zuerst gehen",
      translated: "önce",
      tone: 'semantic',
    },
    {
      german: "wenn man heiraten möchte",
      translated: "evlenmek istediğinizde",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:265|uk": [
    {
      german: "Wohin",
      translated: "Куди",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "в Німеччині",
      tone: 'semantic',
    },
    {
      german: "zuerst gehen",
      translated: "потрібно звернутися насамперед",
      tone: 'semantic',
    },
    {
      german: "wenn man heiraten möchte",
      translated: "якщо ви хочете одружитися",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:265|vi": [
    {
      german: "Wohin",
      translated: "đến đâu",
      tone: 'semantic',
    },
    {
      german: "muss man",
      translated: "bạn phải",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "ở Đức",
      tone: 'semantic',
    },
    {
      german: "zuerst gehen",
      translated: "trước tiên",
      tone: 'semantic',
    },
    {
      german: "wenn man heiraten möchte",
      translated: "Nếu muốn kết hôn",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:266|ar": [
    {
      german: "Wann",
      translated: "متى",
      tone: 'semantic',
    },
    {
      german: "beginnt",
      translated: "يبدأ",
      tone: 'semantic',
    },
    {
      german: "gesetzliche Nachtruhe",
      translated: "وقت الهدوء الليلي القانوني",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "في ألمانيا",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:266|bg": [
    {
      german: "Wann",
      translated: "От колко часа",
      tone: 'semantic',
    },
    {
      german: "beginnt",
      translated: "започва",
      tone: 'semantic',
    },
    {
      german: "gesetzliche Nachtruhe",
      translated: "законово установената нощна тишина",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "в Германия",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:266|bs": [
    {
      german: "Wann",
      translated: "Od",
      tone: 'semantic',
    },
    {
      german: "beginnt",
      translated: "sati",
      tone: 'semantic',
    },
    {
      german: "gesetzliche Nachtruhe",
      translated: "zakonski noćni mir",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "u Njemačkoj",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:266|el": [
    {
      german: "Wann",
      translated: "Από ποια ώρα",
      tone: 'semantic',
    },
    {
      german: "beginnt",
      translated: "αρχίζει",
      tone: 'semantic',
    },
    {
      german: "gesetzliche Nachtruhe",
      translated: "νόμιμη νυχτερινή κοινή ησυχία",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "στη Γερμανία",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:266|en": [
    {
      german: "Wann",
      translated: "When",
      tone: 'semantic',
    },
    {
      german: "beginnt",
      translated: "begin",
      tone: 'semantic',
    },
    {
      german: "gesetzliche Nachtruhe",
      translated: "the legal night quiet time",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "in Germany",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:266|es": [
    {
      german: "Wann",
      translated: "¿Cuándo",
      tone: 'semantic',
    },
    {
      german: "beginnt",
      translated: "comienza",
      tone: 'semantic',
    },
    {
      german: "gesetzliche Nachtruhe",
      translated: "horario legal de descanso nocturno",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "en Alemania",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:266|fa": [
    {
      german: "Wann",
      translated: "از چه زمانی",
      tone: 'semantic',
    },
    {
      german: "beginnt",
      translated: "آغاز می‌شود",
      tone: 'semantic',
    },
    {
      german: "gesetzliche Nachtruhe",
      translated: "ساعات قانونی سکوت شبانه",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "در آلمان",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:266|fr": [
    {
      german: "Wann",
      translated: "À quelle heure",
      tone: 'semantic',
    },
    {
      german: "beginnt",
      translated: "commence",
      tone: 'semantic',
    },
    {
      german: "gesetzliche Nachtruhe",
      translated: "le repos nocturne légal",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "en Allemagne",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:266|hr": [
    {
      german: "Wann",
      translated: "Od koliko sati",
      tone: 'semantic',
    },
    {
      german: "beginnt",
      translated: "počinje",
      tone: 'semantic',
    },
    {
      german: "gesetzliche Nachtruhe",
      translated: "zakonski noćni mir",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "u Njemačkoj",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:266|it": [
    {
      german: "Wann",
      translated: "A che ora",
      tone: 'semantic',
    },
    {
      german: "beginnt",
      translated: "inizia",
      tone: 'semantic',
    },
    {
      german: "gesetzliche Nachtruhe",
      translated: "periodo legale di quiete notturna",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "in Germania",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:266|kmr": [
    {
      german: "Wann",
      translated: "Dema",
      tone: 'semantic',
    },
    {
      german: "beginnt",
      translated: "bêdengiya",
      tone: 'semantic',
    },
    {
      german: "gesetzliche Nachtruhe",
      translated: "şevê ya qanûnî",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "li Almanyayê",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:266|pl": [
    {
      german: "Wann",
      translated: "Od której godziny",
      tone: 'semantic',
    },
    {
      german: "beginnt",
      translated: "zaczyna się",
      tone: 'semantic',
    },
    {
      german: "gesetzliche Nachtruhe",
      translated: "ustawowa cisza nocna",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "w Niemczech",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:266|prs": [
    {
      german: "Wann",
      translated: "از چه زمانی",
      tone: 'semantic',
    },
    {
      german: "beginnt",
      translated: "می‌شود",
      tone: 'semantic',
    },
    {
      german: "gesetzliche Nachtruhe",
      translated: "ساعات قانونی سکوت شبانه",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "در آلمان",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:266|ro": [
    {
      german: "Wann",
      translated: "De la ce oră",
      tone: 'semantic',
    },
    {
      german: "beginnt",
      translated: "începe",
      tone: 'semantic',
    },
    {
      german: "gesetzliche Nachtruhe",
      translated: "perioada legală de liniște nocturnă",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "în Germania",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:266|ru": [
    {
      german: "Wann",
      translated: "Когда",
      tone: 'semantic',
    },
    {
      german: "beginnt",
      translated: "начинается",
      tone: 'semantic',
    },
    {
      german: "gesetzliche Nachtruhe",
      translated: "установленный законом ночной покой",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "в Германии",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:266|sq": [
    {
      german: "Wann",
      translated: "Në çfarë ore",
      tone: 'semantic',
    },
    {
      german: "beginnt",
      translated: "fillon",
      tone: 'semantic',
    },
    {
      german: "gesetzliche Nachtruhe",
      translated: "qetësia e natës e përcaktuar me ligj",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "në Gjermani",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:266|sr": [
    {
      german: "Wann",
      translated: "Od koliko sati",
      tone: 'semantic',
    },
    {
      german: "beginnt",
      translated: "počinje",
      tone: 'semantic',
    },
    {
      german: "gesetzliche Nachtruhe",
      translated: "zakonski noćni mir",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "u Nemačkoj",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:266|tr": [
    {
      german: "Wann",
      translated: "kaçta",
      tone: 'semantic',
    },
    {
      german: "beginnt",
      translated: "başlar",
      tone: 'semantic',
    },
    {
      german: "gesetzliche Nachtruhe",
      translated: "yasal gece sessizliği",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "Almanya'da",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:266|uk": [
    {
      german: "Wann",
      translated: "Коли",
      tone: 'semantic',
    },
    {
      german: "beginnt",
      translated: "починається",
      tone: 'semantic',
    },
    {
      german: "gesetzliche Nachtruhe",
      translated: "встановлений законом нічний час тиші",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "в Німеччині",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:266|vi": [
    {
      german: "Wann",
      translated: "mấy giờ?",
      tone: 'semantic',
    },
    {
      german: "beginnt",
      translated: "bắt đầu",
      tone: 'semantic',
    },
    {
      german: "gesetzliche Nachtruhe",
      translated: "giờ yên tĩnh ban đêm theo luật",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "Ở Đức",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:267|ar": [
    {
      german: "Eine junge Frau",
      translated: "امرأة شابة",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "في ألمانيا",
      tone: 'semantic',
    },
    {
      german: "22 Jahre alt",
      translated: "عمرها 22 عامًا",
      tone: 'semantic',
    },
    {
      german: "lebt mit ihrem Freund zusammen",
      translated: "تعيش مع صديقها",
      tone: 'semantic',
    },
    {
      german: "Die Eltern der Frau",
      translated: "والديها",
      tone: 'semantic',
    },
    {
      german: "finden das nicht gut",
      translated: "لا يعجب ذلك",
      tone: 'semantic',
    },
    {
      german: "weil ihnen der Freund nicht gefällt",
      translated: "لأنهما لا يحبان صديقها",
      tone: 'semantic',
    },
    {
      german: "Was können die Eltern tun",
      translated: "ماذا يستطيع الوالدان أن يفعلا؟",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:267|bg": [
    {
      german: "Eine junge Frau",
      translated: "млада жена",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "в Германия",
      tone: 'semantic',
    },
    {
      german: "22 Jahre alt",
      translated: "22-годишна",
      tone: 'semantic',
    },
    {
      german: "lebt mit ihrem Freund zusammen",
      translated: "живее с приятеля си",
      tone: 'semantic',
    },
    {
      german: "Die Eltern der Frau",
      translated: "Родителите ѝ",
      tone: 'semantic',
    },
    {
      german: "finden das nicht gut",
      translated: "не одобряват това",
      tone: 'semantic',
    },
    {
      german: "weil ihnen der Freund nicht gefällt",
      translated: "защото не харесват приятеля ѝ",
      tone: 'semantic',
    },
    {
      german: "Was können die Eltern tun",
      translated: "Какво могат да направят родителите",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:267|bs": [
    {
      german: "Eine junge Frau",
      translated: "Mlada žena",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "u Njemačkoj",
      tone: 'semantic',
    },
    {
      german: "22 Jahre alt",
      translated: "stara 22 godine",
      tone: 'semantic',
    },
    {
      german: "lebt mit ihrem Freund zusammen",
      translated: "živi sa svojim partnerom",
      tone: 'semantic',
    },
    {
      german: "Die Eltern der Frau",
      translated: "Njezinim roditeljima",
      tone: 'semantic',
    },
    {
      german: "finden das nicht gut",
      translated: "to se ne sviđa",
      tone: 'semantic',
    },
    {
      german: "weil ihnen der Freund nicht gefällt",
      translated: "jer im se partner ne sviđa",
      tone: 'semantic',
    },
    {
      german: "Was können die Eltern tun",
      translated: "Što roditelji mogu učiniti",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:267|el": [
    {
      german: "Eine junge Frau",
      translated: "Μια γυναίκα",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "στη Γερμανία",
      tone: 'semantic',
    },
    {
      german: "22 Jahre alt",
      translated: "22 ετών",
      tone: 'semantic',
    },
    {
      german: "lebt mit ihrem Freund zusammen",
      translated: "ζει με τον σύντροφό της",
      tone: 'semantic',
    },
    {
      german: "Die Eltern der Frau",
      translated: "Οι γονείς της",
      tone: 'semantic',
    },
    {
      german: "finden das nicht gut",
      translated: "δεν το εγκρίνουν",
      tone: 'semantic',
    },
    {
      german: "weil ihnen der Freund nicht gefällt",
      translated: "επειδή δεν τους αρέσει ο σύντροφός της",
      tone: 'semantic',
    },
    {
      german: "Was können die Eltern tun",
      translated: "Τι μπορούν να κάνουν;",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:267|en": [
    {
      german: "Eine junge Frau",
      translated: "A young woman",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "in Germany",
      tone: 'semantic',
    },
    {
      german: "22 Jahre alt",
      translated: "22 years old",
      tone: 'semantic',
    },
    {
      german: "lebt mit ihrem Freund zusammen",
      translated: "lives with her boyfriend",
      tone: 'semantic',
    },
    {
      german: "Die Eltern der Frau",
      translated: "The woman's parents",
      tone: 'semantic',
    },
    {
      german: "finden das nicht gut",
      translated: "don't like it",
      tone: 'semantic',
    },
    {
      german: "weil ihnen der Freund nicht gefällt",
      translated: "because they don't like the boyfriend",
      tone: 'semantic',
    },
    {
      german: "Was können die Eltern tun",
      translated: "What can the parents do",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:267|es": [
    {
      german: "Eine junge Frau",
      translated: "Una mujer joven",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "en Alemania",
      tone: 'semantic',
    },
    {
      german: "22 Jahre alt",
      translated: "de 22 años",
      tone: 'semantic',
    },
    {
      german: "lebt mit ihrem Freund zusammen",
      translated: "vive con su novio",
      tone: 'semantic',
    },
    {
      german: "Die Eltern der Frau",
      translated: "A sus padres",
      tone: 'semantic',
    },
    {
      german: "finden das nicht gut",
      translated: "no les gusta",
      tone: 'semantic',
    },
    {
      german: "weil ihnen der Freund nicht gefällt",
      translated: "porque no les agrada el novio",
      tone: 'semantic',
    },
    {
      german: "Was können die Eltern tun",
      translated: "¿Qué pueden hacer los padres?",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:267|fa": [
    {
      german: "Eine junge Frau",
      translated: "زن جوانی",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "در آلمان",
      tone: 'semantic',
    },
    {
      german: "22 Jahre alt",
      translated: "۲۲ساله",
      tone: 'semantic',
    },
    {
      german: "lebt mit ihrem Freund zusammen",
      translated: "با دوست‌پسرش زندگی می‌کند",
      tone: 'semantic',
    },
    {
      german: "Die Eltern der Frau",
      translated: "والدین زن",
      tone: 'semantic',
    },
    {
      german: "finden das nicht gut",
      translated: "این موضوع را نمی‌پسندند",
      tone: 'semantic',
    },
    {
      german: "weil ihnen der Freund nicht gefällt",
      translated: "زیرا دوست‌پسر او را نمی‌پسندند",
      tone: 'semantic',
    },
    {
      german: "Was können die Eltern tun",
      translated: "والدین چه می‌توانند بکنند",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:267|fr": [
    {
      german: "Eine junge Frau",
      translated: "Une jeune femme",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "en Allemagne",
      tone: 'semantic',
    },
    {
      german: "22 Jahre alt",
      translated: "de 22 ans",
      tone: 'semantic',
    },
    {
      german: "lebt mit ihrem Freund zusammen",
      translated: "avec son petit ami",
      tone: 'semantic',
    },
    {
      german: "Die Eltern der Frau",
      translated: "Ses parents",
      tone: 'semantic',
    },
    {
      german: "finden das nicht gut",
      translated: "n’apprécient pas cette situation",
      tone: 'semantic',
    },
    {
      german: "weil ihnen der Freund nicht gefällt",
      translated: "parce qu’ils n’aiment pas son petit ami",
      tone: 'semantic',
    },
    {
      german: "Was können die Eltern tun",
      translated: "Que peuvent faire les parents",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:267|hr": [
    {
      german: "Eine junge Frau",
      translated: "Mlada žena",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "u Njemačkoj",
      tone: 'semantic',
    },
    {
      german: "22 Jahre alt",
      translated: "stara 22 godine",
      tone: 'semantic',
    },
    {
      german: "lebt mit ihrem Freund zusammen",
      translated: "živi sa svojim partnerom",
      tone: 'semantic',
    },
    {
      german: "Die Eltern der Frau",
      translated: "Njezinim roditeljima",
      tone: 'semantic',
    },
    {
      german: "finden das nicht gut",
      translated: "to se ne sviđa",
      tone: 'semantic',
    },
    {
      german: "weil ihnen der Freund nicht gefällt",
      translated: "jer im se partner ne sviđa",
      tone: 'semantic',
    },
    {
      german: "Was können die Eltern tun",
      translated: "Što roditelji mogu učiniti",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:267|it": [
    {
      german: "Eine junge Frau",
      translated: "Una giovane donna",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "in Germania",
      tone: 'semantic',
    },
    {
      german: "22 Jahre alt",
      translated: "22 anni",
      tone: 'semantic',
    },
    {
      german: "lebt mit ihrem Freund zusammen",
      translated: "vive con il suo compagno",
      tone: 'semantic',
    },
    {
      german: "Die Eltern der Frau",
      translated: "I genitori della donna",
      tone: 'semantic',
    },
    {
      german: "finden das nicht gut",
      translated: "non lo approvano",
      tone: 'semantic',
    },
    {
      german: "weil ihnen der Freund nicht gefällt",
      translated: "perché il compagno non piace loro",
      tone: 'semantic',
    },
    {
      german: "Was können die Eltern tun",
      translated: "Che cosa possono fare i genitori",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:267|kmr": [
    {
      german: "Eine junge Frau",
      translated: "Jineke ciwan",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "li Almanyayê",
      tone: 'semantic',
    },
    {
      german: "22 Jahre alt",
      translated: "22 salî",
      tone: 'semantic',
    },
    {
      german: "lebt mit ihrem Freund zusammen",
      translated: "bi hevalê xwe re dijî",
      tone: 'semantic',
    },
    {
      german: "Die Eltern der Frau",
      translated: "Dêûbavê wê",
      tone: 'semantic',
    },
    {
      german: "finden das nicht gut",
      translated: "vê yekê baş nabînin",
      tone: 'semantic',
    },
    {
      german: "weil ihnen der Freund nicht gefällt",
      translated: "ji ber ku ji hevalê wê hez nakin",
      tone: 'semantic',
    },
    {
      german: "Was können die Eltern tun",
      translated: "Dêûbav dikarin çi bikin",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:267|pl": [
    {
      german: "Eine junge Frau",
      translated: "Młoda kobieta",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "w Niemczech",
      tone: 'semantic',
    },
    {
      german: "22 Jahre alt",
      translated: "ma 22 lata",
      tone: 'semantic',
    },
    {
      german: "lebt mit ihrem Freund zusammen",
      translated: "mieszka ze swoim chłopakiem",
      tone: 'semantic',
    },
    {
      german: "Die Eltern der Frau",
      translated: "Rodzicom kobiety",
      tone: 'semantic',
    },
    {
      german: "finden das nicht gut",
      translated: "się to nie podoba",
      tone: 'semantic',
    },
    {
      german: "weil ihnen der Freund nicht gefällt",
      translated: "ponieważ nie podoba im się jej chłopak",
      tone: 'semantic',
    },
    {
      german: "Was können die Eltern tun",
      translated: "Co mogą zrobić rodzice",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:267|prs": [
    {
      german: "Eine junge Frau",
      translated: "زنی",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "در آلمان",
      tone: 'semantic',
    },
    {
      german: "22 Jahre alt",
      translated: "۲۲ساله",
      tone: 'semantic',
    },
    {
      german: "lebt mit ihrem Freund zusammen",
      translated: "با دوست‌پسرش زندگی می‌کند",
      tone: 'semantic',
    },
    {
      german: "Die Eltern der Frau",
      translated: "والدین زن",
      tone: 'semantic',
    },
    {
      german: "finden das nicht gut",
      translated: "این موضوع را نمی‌پسندند",
      tone: 'semantic',
    },
    {
      german: "weil ihnen der Freund nicht gefällt",
      translated: "زیرا از دوست‌پسر او خوششان نمی‌آید",
      tone: 'semantic',
    },
    {
      german: "Was können die Eltern tun",
      translated: "والدین چه می‌توانند بکنند",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:267|ro": [
    {
      german: "Eine junge Frau",
      translated: "O tânără",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "din Germania",
      tone: 'semantic',
    },
    {
      german: "22 Jahre alt",
      translated: "are 22 de ani",
      tone: 'semantic',
    },
    {
      german: "lebt mit ihrem Freund zusammen",
      translated: "locuiește cu prietenul ei",
      tone: 'semantic',
    },
    {
      german: "Die Eltern der Frau",
      translated: "Părinților femeii",
      tone: 'semantic',
    },
    {
      german: "finden das nicht gut",
      translated: "nu le place acest lucru",
      tone: 'semantic',
    },
    {
      german: "weil ihnen der Freund nicht gefällt",
      translated: "deoarece nu le place prietenul ei",
      tone: 'semantic',
    },
    {
      german: "Was können die Eltern tun",
      translated: "Ce pot face părinții",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:267|ru": [
    {
      german: "Eine junge Frau",
      translated: "Молодая женщина",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "в Германии",
      tone: 'semantic',
    },
    {
      german: "22 Jahre alt",
      translated: "22 года",
      tone: 'semantic',
    },
    {
      german: "lebt mit ihrem Freund zusammen",
      translated: "живёт со своим парнем",
      tone: 'semantic',
    },
    {
      german: "Die Eltern der Frau",
      translated: "Родителям",
      tone: 'semantic',
    },
    {
      german: "finden das nicht gut",
      translated: "это не нравится",
      tone: 'semantic',
    },
    {
      german: "weil ihnen der Freund nicht gefällt",
      translated: "потому что парень им не по душе",
      tone: 'semantic',
    },
    {
      german: "Was können die Eltern tun",
      translated: "Что могут сделать родители",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:267|sq": [
    {
      german: "Eine junge Frau",
      translated: "Një grua e re",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "në Gjermani",
      tone: 'semantic',
    },
    {
      german: "22 Jahre alt",
      translated: "22-vjeçare",
      tone: 'semantic',
    },
    {
      german: "lebt mit ihrem Freund zusammen",
      translated: "jeton me të dashurin e saj",
      tone: 'semantic',
    },
    {
      german: "Die Eltern der Frau",
      translated: "Prindërit e saj",
      tone: 'semantic',
    },
    {
      german: "finden das nicht gut",
      translated: "nuk e miratojnë këtë",
      tone: 'semantic',
    },
    {
      german: "weil ihnen der Freund nicht gefällt",
      translated: "sepse nuk u pëlqen i dashuri i saj",
      tone: 'semantic',
    },
    {
      german: "Was können die Eltern tun",
      translated: "Çfarë mund të bëjnë prindërit?",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:267|sr": [
    {
      german: "Eine junge Frau",
      translated: "Mlada žena",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "u Nemačkoj",
      tone: 'semantic',
    },
    {
      german: "22 Jahre alt",
      translated: "stara 22 godine",
      tone: 'semantic',
    },
    {
      german: "lebt mit ihrem Freund zusammen",
      translated: "živi sa svojim partnerom",
      tone: 'semantic',
    },
    {
      german: "Die Eltern der Frau",
      translated: "Njezinim roditeljima",
      tone: 'semantic',
    },
    {
      german: "finden das nicht gut",
      translated: "to se ne sviđa",
      tone: 'semantic',
    },
    {
      german: "weil ihnen der Freund nicht gefällt",
      translated: "jer im se partner ne sviđa",
      tone: 'semantic',
    },
    {
      german: "Was können die Eltern tun",
      translated: "Šta roditelji mogu da urade",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:267|tr": [
    {
      german: "Eine junge Frau",
      translated: "genç bir kadın",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "Almanya'da",
      tone: 'semantic',
    },
    {
      german: "22 Jahre alt",
      translated: "22 yaşındaki",
      tone: 'semantic',
    },
    {
      german: "lebt mit ihrem Freund zusammen",
      translated: "erkek arkadaşıyla birlikte yaşıyor",
      tone: 'semantic',
    },
    {
      german: "Die Eltern der Frau",
      translated: "Anne-babası",
      tone: 'semantic',
    },
    {
      german: "finden das nicht gut",
      translated: "onaylamıyor",
      tone: 'semantic',
    },
    {
      german: "weil ihnen der Freund nicht gefällt",
      translated: "erkek arkadaşını sevmediği için",
      tone: 'semantic',
    },
    {
      german: "Was können die Eltern tun",
      translated: "Anne-baba ne yapabilir?",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:267|uk": [
    {
      german: "Eine junge Frau",
      translated: "молода жінка",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "в Німеччині",
      tone: 'semantic',
    },
    {
      german: "22 Jahre alt",
      translated: "22-річна",
      tone: 'semantic',
    },
    {
      german: "lebt mit ihrem Freund zusammen",
      translated: "живе разом зі своїм хлопцем",
      tone: 'semantic',
    },
    {
      german: "Die Eltern der Frau",
      translated: "Її батькам",
      tone: 'semantic',
    },
    {
      german: "finden das nicht gut",
      translated: "це не подобається",
      tone: 'semantic',
    },
    {
      german: "weil ihnen der Freund nicht gefällt",
      translated: "бо їм не подобається хлопець",
      tone: 'semantic',
    },
    {
      german: "Was können die Eltern tun",
      translated: "Що можуть зробити батьки",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:267|vi": [
    {
      german: "Eine junge Frau",
      translated: "Một phụ nữ",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "ở Đức",
      tone: 'semantic',
    },
    {
      german: "22 Jahre alt",
      translated: "22 tuổi",
      tone: 'semantic',
    },
    {
      german: "lebt mit ihrem Freund zusammen",
      translated: "sống cùng bạn trai",
      tone: 'semantic',
    },
    {
      german: "Die Eltern der Frau",
      translated: "Cha mẹ cô",
      tone: 'semantic',
    },
    {
      german: "finden das nicht gut",
      translated: "không đồng ý",
      tone: 'semantic',
    },
    {
      german: "weil ihnen der Freund nicht gefällt",
      translated: "vì họ không thích người bạn trai",
      tone: 'semantic',
    },
    {
      german: "Was können die Eltern tun",
      translated: "Họ có thể làm gì?",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:268|ar": [
    {
      german: "Eine junge Frau",
      translated: "امرأة شابة",
      tone: 'semantic',
    },
    {
      german: "will den Führerschein machen.",
      translated: "الحصول على رخصة قيادة.",
      tone: 'semantic',
    },
    {
      german: "Sie hat Angst",
      translated: "وهي تخشى",
      tone: 'semantic',
    },
    {
      german: "weil ihre Muttersprache nicht Deutsch ist.",
      translated: "لأن لغتها الأم ليست الألمانية.",
      tone: 'semantic',
    },
    {
      german: "Was ist richtig?",
      translated: "ما الصحيح؟",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:268|bg": [
    {
      german: "Eine junge Frau",
      translated: "Млада жена",
      tone: 'semantic',
    },
    {
      german: "will den Führerschein machen.",
      translated: "иска шофьорска книжка",
      tone: 'semantic',
    },
    {
      german: "Sie hat Angst",
      translated: "се страхува",
      tone: 'semantic',
    },
    {
      german: "vor der Prüfung,",
      translated: "от изпита,",
      tone: 'semantic',
    },
    {
      german: "weil ihre Muttersprache nicht Deutsch ist.",
      translated: "защото немският не е майчиният ѝ език",
      tone: 'semantic',
    },
    {
      german: "Was ist richtig?",
      translated: "Кое е вярно?",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:268|bs": [
    {
      german: "Eine junge Frau",
      translated: "Mlada žena",
      tone: 'semantic',
    },
    {
      german: "will den Führerschein machen.",
      translated: "želi dobiti vozačku dozvolu,",
      tone: 'semantic',
    },
    {
      german: "Sie hat Angst",
      translated: "se boji",
      tone: 'semantic',
    },
    {
      german: "weil ihre Muttersprache nicht Deutsch ist.",
      translated: "jer njemački nije njezin materinski jezik.",
      tone: 'semantic',
    },
    {
      german: "Was ist richtig?",
      translated: "Koja je tvrdnja točna",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:268|el": [
    {
      german: "Eine junge Frau",
      translated: "Μια νεαρή γυναίκα",
      tone: 'semantic',
    },
    {
      german: "will den Führerschein machen.",
      translated: "θέλει δίπλωμα οδήγησης",
      tone: 'semantic',
    },
    {
      german: "Sie hat Angst",
      translated: "φοβάται",
      tone: 'semantic',
    },
    {
      german: "vor der Prüfung,",
      translated: "την εξέταση",
      tone: 'semantic',
    },
    {
      german: "weil ihre Muttersprache nicht Deutsch ist.",
      translated: " επειδή τα γερμανικά δεν είναι η μητρική της γλώσσα",
      tone: 'semantic',
    },
    {
      german: "Was ist richtig?",
      translated: "Ποια δήλωση είναι σωστή;",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:268|en": [
    {
      german: "Eine junge Frau",
      translated: "A young woman",
      tone: 'semantic',
    },
    {
      german: "will den Führerschein machen.",
      translated: "wants to get her driver's license.",
      tone: 'semantic',
    },
    {
      german: "Sie hat Angst",
      translated: "She is afraid",
      tone: 'semantic',
    },
    {
      german: "vor der Prüfung,",
      translated: "of the exam",
      tone: 'semantic',
    },
    {
      german: "weil ihre Muttersprache nicht Deutsch ist.",
      translated: "because her native language is not German.",
      tone: 'semantic',
    },
    {
      german: "Was ist richtig?",
      translated: "What is correct?",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:268|es": [
    {
      german: "Eine junge Frau",
      translated: "Una mujer joven",
      tone: 'semantic',
    },
    {
      german: "will den Führerschein machen.",
      translated: "quiere obtener el permiso de conducir.",
      tone: 'semantic',
    },
    {
      german: "Sie hat Angst",
      translated: "Le preocupa",
      tone: 'semantic',
    },
    {
      german: "vor der Prüfung,",
      translated: "el examen",
      tone: 'semantic',
    },
    {
      german: "weil ihre Muttersprache nicht Deutsch ist.",
      translated: "porque su lengua materna no es el alemán.",
      tone: 'semantic',
    },
    {
      german: "Was ist richtig?",
      translated: "¿Qué es correcto?",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:268|fa": [
    {
      german: "Eine junge Frau",
      translated: "زن جوانی",
      tone: 'semantic',
    },
    {
      german: "will den Führerschein machen.",
      translated: "می‌خواهد گواهینامه بگیرد",
      tone: 'semantic',
    },
    {
      german: "Sie hat Angst",
      translated: "می‌ترسد",
      tone: 'semantic',
    },
    {
      german: "vor der Prüfung,",
      translated: "از آزمون",
      tone: 'semantic',
    },
    {
      german: "weil ihre Muttersprache nicht Deutsch ist.",
      translated: "چون زبان مادری‌اش آلمانی نیست",
      tone: 'semantic',
    },
    {
      german: "Was ist richtig?",
      translated: "کدام درست است؟",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:268|fr": [
    {
      german: "Eine junge Frau",
      translated: "Une jeune femme",
      tone: 'semantic',
    },
    {
      german: "will den Führerschein machen.",
      translated: "veut passer le permis de conduire.",
      tone: 'semantic',
    },
    {
      german: "Sie hat Angst",
      translated: "Elle a peur",
      tone: 'semantic',
    },
    {
      german: "vor der Prüfung,",
      translated: "de l’examen",
      tone: 'semantic',
    },
    {
      german: "weil ihre Muttersprache nicht Deutsch ist.",
      translated: "parce que sa langue maternelle n’est pas l’allemand.",
      tone: 'semantic',
    },
    {
      german: "Was ist richtig?",
      translated: "Qu’est-ce qui est correct ?",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:268|hr": [
    {
      german: "Eine junge Frau",
      translated: "Mlada žena",
      tone: 'semantic',
    },
    {
      german: "will den Führerschein machen.",
      translated: "želi dobiti vozačku dozvolu",
      tone: 'semantic',
    },
    {
      german: "Sie hat Angst",
      translated: "se boji",
      tone: 'semantic',
    },
    {
      german: "vor der Prüfung,",
      translated: "ispita",
      tone: 'semantic',
    },
    {
      german: "weil ihre Muttersprache nicht Deutsch ist.",
      translated: "jer njemački nije njezin materinski jezik.",
      tone: 'semantic',
    },
    {
      german: "Was ist richtig?",
      translated: "Koja je tvrdnja točna",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:268|it": [
    {
      german: "Eine junge Frau",
      translated: "Una giovane donna",
      tone: 'semantic',
    },
    {
      german: "will den Führerschein machen.",
      translated: "vuole prendere la patente,",
      tone: 'semantic',
    },
    {
      german: "Sie hat Angst",
      translated: "teme",
      tone: 'semantic',
    },
    {
      german: "vor der Prüfung,",
      translated: "l’esame",
      tone: 'semantic',
    },
    {
      german: "weil ihre Muttersprache nicht Deutsch ist.",
      translated: "perché il tedesco non è la sua lingua madre.",
      tone: 'semantic',
    },
    {
      german: "Was ist richtig?",
      translated: "Quale affermazione è corretta",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:268|kmr": [
    {
      german: "Eine junge Frau",
      translated: "Jineke ciwan",
      tone: 'semantic',
    },
    {
      german: "will den Führerschein machen.",
      translated: "dixwaze ehliyeta ajotinê bistîne",
      tone: 'semantic',
    },
    {
      german: "Sie hat Angst",
      translated: "ditirse",
      tone: 'semantic',
    },
    {
      german: "vor der Prüfung,",
      translated: "ji ezmûnê",
      tone: 'semantic',
    },
    {
      german: "weil ihre Muttersprache nicht Deutsch ist.",
      translated: "ji ber ku zimanê dayikê wê ne Almanî ye",
      tone: 'semantic',
    },
    {
      german: "Was ist richtig?",
      translated: "Kîjan rast e?",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:268|pl": [
    {
      german: "Eine junge Frau",
      translated: "Młoda kobieta",
      tone: 'semantic',
    },
    {
      german: "will den Führerschein machen.",
      translated: "chce uzyskać prawo jazdy",
      tone: 'semantic',
    },
    {
      german: "Sie hat Angst",
      translated: "ale boi się",
      tone: 'semantic',
    },
    {
      german: "vor der Prüfung,",
      translated: " egzaminu",
      tone: 'semantic',
    },
    {
      german: "weil ihre Muttersprache nicht Deutsch ist.",
      translated: "ponieważ niemiecki nie jest jej językiem ojczystym",
      tone: 'semantic',
    },
    {
      german: "Was ist richtig?",
      translated: "Które stwierdzenie jest prawidłowe?",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:268|prs": [
    {
      german: "Eine junge Frau",
      translated: "زن جوانی",
      tone: 'semantic',
    },
    {
      german: "will den Führerschein machen.",
      translated: "می‌خواهد گواهینامه بگیرد",
      tone: 'semantic',
    },
    {
      german: "Sie hat Angst",
      translated: "از آزمون می‌ترسد",
      tone: 'semantic',
    },
    {
      german: "weil ihre Muttersprache nicht Deutsch ist.",
      translated: "چون زبان مادری‌اش آلمانی نیست",
      tone: 'semantic',
    },
    {
      german: "Was ist richtig?",
      translated: "کدام درست است؟",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:268|ro": [
    {
      german: "Eine junge Frau",
      translated: "O tânără",
      tone: 'semantic',
    },
    {
      german: "will den Führerschein machen.",
      translated: "vrea permis de conducere",
      tone: 'semantic',
    },
    {
      german: "Sie hat Angst",
      translated: "se teme",
      tone: 'semantic',
    },
    {
      german: "vor der Prüfung,",
      translated: "de examen",
      tone: 'semantic',
    },
    {
      german: "weil ihre Muttersprache nicht Deutsch ist.",
      translated: "deoarece germana nu este limba ei maternă",
      tone: 'semantic',
    },
    {
      german: "Was ist richtig?",
      translated: "Care afirmație este corectă",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:268|ru": [
    {
      german: "Eine junge Frau",
      translated: "Молодая женщина",
      tone: 'semantic',
    },
    {
      german: "will den Führerschein machen.",
      translated: "хочет получить водительские права.",
      tone: 'semantic',
    },
    {
      german: "Sie hat Angst",
      translated: "Она боится",
      tone: 'semantic',
    },
    {
      german: "vor der Prüfung,",
      translated: "экзамена,",
      tone: 'semantic',
    },
    {
      german: "weil ihre Muttersprache nicht Deutsch ist.",
      translated: "потому что немецкий язык не является её родным.",
      tone: 'semantic',
    },
    {
      german: "Was ist richtig?",
      translated: "Что верно",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:268|sq": [
    {
      german: "Eine junge Frau",
      translated: "Një grua e re",
      tone: 'semantic',
    },
    {
      german: "Sie hat Angst",
      translated: "ka frikë",
      tone: 'semantic',
    },
    {
      german: "vor der Prüfung,",
      translated: "nga provimi",
      tone: 'semantic',
    },
    {
      german: "weil ihre Muttersprache nicht Deutsch ist.",
      translated: "sepse gjermanishtja nuk është gjuha e saj amtare",
      tone: 'semantic',
    },
    {
      german: "Was ist richtig?",
      translated: "Cili pohim është i saktë?",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:268|sr": [
    {
      german: "Eine junge Frau",
      translated: "Mlada žena",
      tone: 'semantic',
    },
    {
      german: "will den Führerschein machen.",
      translated: "želi dobiti vozačku dozvolu",
      tone: 'semantic',
    },
    {
      german: "Sie hat Angst",
      translated: "se boji",
      tone: 'semantic',
    },
    {
      german: "vor der Prüfung,",
      translated: "ispita jer",
      tone: 'semantic',
    },
    {
      german: "weil ihre Muttersprache nicht Deutsch ist.",
      translated: "nemački nije njezin materinski jezik",
      tone: 'semantic',
    },
    {
      german: "Was ist richtig?",
      translated: "Koja je tvrdnja točna?",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:268|tr": [
    {
      german: "Eine junge Frau",
      translated: "Genç bir kadın",
      tone: 'semantic',
    },
    {
      german: "will den Führerschein machen.",
      translated: "ehliyet almak istiyor",
      tone: 'semantic',
    },
    {
      german: "Sie hat Angst",
      translated: "korkuyor",
      tone: 'semantic',
    },
    {
      german: "vor der Prüfung,",
      translated: "sınavdan",
      tone: 'semantic',
    },
    {
      german: "weil ihre Muttersprache nicht Deutsch ist.",
      translated: "Ana dili Almanca olmadığı için",
      tone: 'semantic',
    },
    {
      german: "Was ist richtig?",
      translated: "Hangisi doğrudur?",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:268|uk": [
    {
      german: "Eine junge Frau",
      translated: "Молода жінка",
      tone: 'semantic',
    },
    {
      german: "will den Führerschein machen.",
      translated: "хоче отримати водійське посвідчення.",
      tone: 'semantic',
    },
    {
      german: "Sie hat Angst",
      translated: "Вона боїться",
      tone: 'semantic',
    },
    {
      german: "vor der Prüfung,",
      translated: "іспиту,",
      tone: 'semantic',
    },
    {
      german: "weil ihre Muttersprache nicht Deutsch ist.",
      translated: "бо її рідна мова не німецька.",
      tone: 'semantic',
    },
    {
      german: "Was ist richtig?",
      translated: "Що правильно?",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:268|vi": [
    {
      german: "Eine junge Frau",
      translated: "Một phụ nữ trẻ",
      tone: 'semantic',
    },
    {
      german: "will den Führerschein machen.",
      translated: "muốn lấy bằng lái xe",
      tone: 'semantic',
    },
    {
      german: "Sie hat Angst",
      translated: "sợ",
      tone: 'semantic',
    },
    {
      german: "vor der Prüfung,",
      translated: "kỳ thi",
      tone: 'semantic',
    },
    {
      german: "weil ihre Muttersprache nicht Deutsch ist.",
      translated: "vì tiếng Đức không phải tiếng mẹ đẻ.",
      tone: 'semantic',
    },
    {
      german: "Was ist richtig?",
      translated: "Phát biểu nào đúng?",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:269|ar": [
    {
      german: "In Deutschland",
      translated: "في ألمانيا،",
      tone: 'semantic',
    },
    {
      german: "Kinder",
      translated: "للأطفال",
      tone: 'semantic',
    },
    {
      german: "ab dem Alter von drei Jahren",
      translated: "من سن ثلاث سنوات",
      tone: 'semantic',
    },
    {
      german: "bis zur Ersteinschulung",
      translated: "وحتى دخول المدرسة",
      tone: 'semantic',
    },
    {
      german: "einen Anspruch auf",
      translated: "حق في",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:269|bg": [
    {
      german: "In Deutschland",
      translated: "В Германия",
      tone: 'semantic',
    },
    {
      german: "haben",
      translated: "имат",
      tone: 'semantic',
    },
    {
      german: "Kinder",
      translated: "децата",
      tone: 'semantic',
    },
    {
      german: "ab dem Alter von drei Jahren",
      translated: "от тригодишна възраст",
      tone: 'semantic',
    },
    {
      german: "bis zur Ersteinschulung",
      translated: "до започването на училище",
      tone: 'semantic',
    },
    {
      german: "einen Anspruch auf",
      translated: "право на",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:269|bs": [
    {
      german: "In Deutschland",
      translated: "U Njemačkoj",
      tone: 'semantic',
    },
    {
      german: "Kinder",
      translated: "djeca",
      tone: 'semantic',
    },
    {
      german: "ab dem Alter von drei Jahren",
      translated: "od treće godine života",
      tone: 'semantic',
    },
    {
      german: "bis zur Ersteinschulung",
      translated: "do polaska u školu",
      tone: 'semantic',
    },
    {
      german: "einen Anspruch auf",
      translated: "imaju pravo na",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:269|el": [
    {
      german: "In Deutschland",
      translated: "Στη Γερμανία",
      tone: 'semantic',
    },
    {
      german: "Kinder",
      translated: "τα παιδιά",
      tone: 'semantic',
    },
    {
      german: "ab dem Alter von drei Jahren",
      translated: "από τριών ετών",
      tone: 'semantic',
    },
    {
      german: "bis zur Ersteinschulung",
      translated: "μέχρι την έναρξη του σχολείου",
      tone: 'semantic',
    },
    {
      german: "einen Anspruch auf",
      translated: "έχουν δικαίωμα σε …",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:269|en": [
    {
      german: "In Deutschland",
      translated: "In Germany",
      tone: 'semantic',
    },
    {
      german: "haben",
      translated: "have",
      tone: 'semantic',
    },
    {
      german: "Kinder",
      translated: "children",
      tone: 'semantic',
    },
    {
      german: "ab dem Alter von drei Jahren",
      translated: "from the age of three",
      tone: 'semantic',
    },
    {
      german: "bis zur Ersteinschulung",
      translated: "until they start school",
      tone: 'semantic',
    },
    {
      german: "einen Anspruch auf",
      translated: "a right to",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:269|es": [
    {
      german: "In Deutschland",
      translated: "En Alemania",
      tone: 'semantic',
    },
    {
      german: "Kinder",
      translated: "los niños",
      tone: 'semantic',
    },
    {
      german: "ab dem Alter von drei Jahren",
      translated: "desde los tres años",
      tone: 'semantic',
    },
    {
      german: "bis zur Ersteinschulung",
      translated: "hasta que empiezan la escuela",
      tone: 'semantic',
    },
    {
      german: "einen Anspruch auf",
      translated: "tienen derecho a",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:269|fa": [
    {
      german: "In Deutschland",
      translated: "در آلمان",
      tone: 'semantic',
    },
    {
      german: "haben",
      translated: "دارند",
      tone: 'semantic',
    },
    {
      german: "Kinder",
      translated: "کودکان",
      tone: 'semantic',
    },
    {
      german: "ab dem Alter von drei Jahren",
      translated: "از سه‌سالگی",
      tone: 'semantic',
    },
    {
      german: "bis zur Ersteinschulung",
      translated: "تا ورود نخست به مدرسه",
      tone: 'semantic',
    },
    {
      german: "einen Anspruch auf",
      translated: "حق برخورداری از",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:269|fr": [
    {
      german: "In Deutschland",
      translated: "En Allemagne",
      tone: 'semantic',
    },
    {
      german: "haben",
      translated: "ont",
      tone: 'semantic',
    },
    {
      german: "Kinder",
      translated: "les enfants",
      tone: 'semantic',
    },
    {
      german: "ab dem Alter von drei Jahren",
      translated: "à partir de trois ans",
      tone: 'semantic',
    },
    {
      german: "bis zur Ersteinschulung",
      translated: "jusqu’à leur première entrée à l’école",
      tone: 'semantic',
    },
    {
      german: "einen Anspruch auf",
      translated: "droit à",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:269|hr": [
    {
      german: "In Deutschland",
      translated: "U Njemačkoj",
      tone: 'semantic',
    },
    {
      german: "Kinder",
      translated: "djeca",
      tone: 'semantic',
    },
    {
      german: "ab dem Alter von drei Jahren",
      translated: "od treće godine života",
      tone: 'semantic',
    },
    {
      german: "bis zur Ersteinschulung",
      translated: "do polaska u školu",
      tone: 'semantic',
    },
    {
      german: "einen Anspruch auf",
      translated: "imaju pravo na",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:269|it": [
    {
      german: "In Deutschland",
      translated: "In Germania",
      tone: 'semantic',
    },
    {
      german: "haben",
      translated: "hanno",
      tone: 'semantic',
    },
    {
      german: "Kinder",
      translated: "bambini",
      tone: 'semantic',
    },
    {
      german: "ab dem Alter von drei Jahren",
      translated: "dai tre anni",
      tone: 'semantic',
    },
    {
      german: "bis zur Ersteinschulung",
      translated: "fino all’ingresso a scuola",
      tone: 'semantic',
    },
    {
      german: "einen Anspruch auf",
      translated: "diritto a ",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:269|kmr": [
    {
      german: "In Deutschland",
      translated: "Li Almanyayê",
      tone: 'semantic',
    },
    {
      german: "Kinder",
      translated: "zarok",
      tone: 'semantic',
    },
    {
      german: "ab dem Alter von drei Jahren",
      translated: "ji 3 salî heta",
      tone: 'semantic',
    },
    {
      german: "bis zur Ersteinschulung",
      translated: "destpêka dibistanê",
      tone: 'semantic',
    },
    {
      german: "einen Anspruch auf",
      translated: "mafê …",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:269|pl": [
    {
      german: "In Deutschland",
      translated: "W Niemczech",
      tone: 'semantic',
    },
    {
      german: "haben",
      translated: "mają",
      tone: 'semantic',
    },
    {
      german: "Kinder",
      translated: "dzieci",
      tone: 'semantic',
    },
    {
      german: "ab dem Alter von drei Jahren",
      translated: "od trzeciego roku życia",
      tone: 'semantic',
    },
    {
      german: "bis zur Ersteinschulung",
      translated: "do rozpoczęcia szkoły",
      tone: 'semantic',
    },
    {
      german: "einen Anspruch auf",
      translated: "prawo do …",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:269|prs": [
    {
      german: "In Deutschland",
      translated: "در آلمان",
      tone: 'semantic',
    },
    {
      german: "haben",
      translated: "دارند",
      tone: 'semantic',
    },
    {
      german: "Kinder",
      translated: "کودکان",
      tone: 'semantic',
    },
    {
      german: "ab dem Alter von drei Jahren",
      translated: "از سه‌سالگی",
      tone: 'semantic',
    },
    {
      german: "bis zur Ersteinschulung",
      translated: "تا ورود نخست به مکتب",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:269|ro": [
    {
      german: "In Deutschland",
      translated: "În Germania",
      tone: 'semantic',
    },
    {
      german: "Kinder",
      translated: "copiii",
      tone: 'semantic',
    },
    {
      german: "ab dem Alter von drei Jahren",
      translated: "de la vârsta de trei ani",
      tone: 'semantic',
    },
    {
      german: "bis zur Ersteinschulung",
      translated: "până la începerea școlii",
      tone: 'semantic',
    },
    {
      german: "einen Anspruch auf",
      translated: "au dreptul la",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:269|ru": [
    {
      german: "In Deutschland",
      translated: "В Германии",
      tone: 'semantic',
    },
    {
      german: "haben",
      translated: "имеют",
      tone: 'semantic',
    },
    {
      german: "Kinder",
      translated: "дети",
      tone: 'semantic',
    },
    {
      german: "ab dem Alter von drei Jahren",
      translated: "с трёх лет",
      tone: 'semantic',
    },
    {
      german: "bis zur Ersteinschulung",
      translated: "до поступления в школу",
      tone: 'semantic',
    },
    {
      german: "einen Anspruch auf",
      translated: "право на",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:269|sq": [
    {
      german: "In Deutschland",
      translated: "Në Gjermani",
      tone: 'semantic',
    },
    {
      german: "Kinder",
      translated: "fëmijët",
      tone: 'semantic',
    },
    {
      german: "ab dem Alter von drei Jahren",
      translated: "nga mosha tre vjeç",
      tone: 'semantic',
    },
    {
      german: "bis zur Ersteinschulung",
      translated: "deri në fillimin e shkollës",
      tone: 'semantic',
    },
    {
      german: "einen Anspruch auf",
      translated: "të drejtë për",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:269|sr": [
    {
      german: "In Deutschland",
      translated: "U Nemačkoj",
      tone: 'semantic',
    },
    {
      german: "Kinder",
      translated: "djeca",
      tone: 'semantic',
    },
    {
      german: "ab dem Alter von drei Jahren",
      translated: "od treće godine života",
      tone: 'semantic',
    },
    {
      german: "einen Anspruch auf",
      translated: "imaju pravo na",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:269|tr": [
    {
      german: "In Deutschland",
      translated: "Almanya'da",
      tone: 'semantic',
    },
    {
      german: "haben",
      translated: "vardır",
      tone: 'semantic',
    },
    {
      german: "Kinder",
      translated: "çocukların",
      tone: 'semantic',
    },
    {
      german: "ab dem Alter von drei Jahren",
      translated: "üç yaşından",
      tone: 'semantic',
    },
    {
      german: "bis zur Ersteinschulung",
      translated: "ilkokula başlayana kadar",
      tone: 'semantic',
    },
    {
      german: "einen Anspruch auf",
      translated: "hakkı",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:269|uk": [
    {
      german: "In Deutschland",
      translated: "У Німеччині",
      tone: 'semantic',
    },
    {
      german: "Kinder",
      translated: "діти",
      tone: 'semantic',
    },
    {
      german: "ab dem Alter von drei Jahren",
      translated: "від трьох років",
      tone: 'semantic',
    },
    {
      german: "bis zur Ersteinschulung",
      translated: "до першого вступу до школи",
      tone: 'semantic',
    },
    {
      german: "einen Anspruch auf",
      translated: "мають право на …",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:269|vi": [
    {
      german: "In Deutschland",
      translated: "Ở Đức",
      tone: 'semantic',
    },
    {
      german: "haben",
      translated: "có",
      tone: 'semantic',
    },
    {
      german: "Kinder",
      translated: "trẻ",
      tone: 'semantic',
    },
    {
      german: "ab dem Alter von drei Jahren",
      translated: "từ ba tuổi",
      tone: 'semantic',
    },
    {
      german: "bis zur Ersteinschulung",
      translated: "đến khi bắt đầu đi học",
      tone: 'semantic',
    },
    {
      german: "einen Anspruch auf",
      translated: "quyền",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:26|ar": [
    {
      german: "Deutschland",
      translated: "ألمانيا",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:26|bg": [
    {
      german: "Deutschland",
      translated: "Германия",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:26|bs": [
    {
      german: "Deutschland",
      translated: "Njemačka",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "je",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:26|el": [
    {
      german: "Deutschland",
      translated: "Η Γερμανία",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "είναι",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:26|en": [
    {
      german: "Deutschland",
      translated: "Germany",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "is",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:26|es": [
    {
      german: "Deutschland",
      translated: "Alemania",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "es",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:26|fa": [
    {
      german: "Deutschland",
      translated: "آلمان",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:26|fr": [
    {
      german: "Deutschland",
      translated: "L’Allemagne",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "est",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:26|hr": [
    {
      german: "Deutschland",
      translated: "Njemačka",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "je",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:26|it": [
    {
      german: "Deutschland",
      translated: "La Germania",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "è",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:26|kmr": [
    {
      german: "Deutschland",
      translated: "Almanya",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:26|pl": [
    {
      german: "Deutschland",
      translated: "Niemcy",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "są",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:26|prs": [
    {
      german: "Deutschland",
      translated: "آلمان",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "است",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:26|ro": [
    {
      german: "Deutschland",
      translated: "Germania",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:26|ru": [
    {
      german: "Deutschland",
      translated: "Германия",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:26|sq": [
    {
      german: "Deutschland",
      translated: "Gjermania",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "është",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:26|sr": [
    {
      german: "Deutschland",
      translated: "Nemačka",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "je",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:26|tr": [
    {
      german: "Deutschland",
      translated: "Almanya",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:26|uk": [
    {
      german: "Deutschland",
      translated: "Німеччина",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "є",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:26|vi": [
    {
      german: "Deutschland",
      translated: "Đức",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "là",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:270|ar": [
    {
      german: "Die Volkshochschule",
      translated: "مدرسة تعليم الكبار (Volkshochschule)",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "في ألمانيا",
      tone: 'semantic',
    },
    {
      german: "ist eine Einrichtung",
      translated: "هي مؤسسة …",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:270|bg": [
    {
      german: "Die Volkshochschule",
      translated: "Volkshochschule",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "в Германия",
      tone: 'semantic',
    },
    {
      german: "ist eine Einrichtung",
      translated: "е институция …",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:270|bs": [
    {
      german: "Die Volkshochschule",
      translated: "Volkshochschule",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "u Njemačkoj",
      tone: 'semantic',
    },
    {
      german: "ist eine Einrichtung",
      translated: "ustanova je",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:270|el": [
    {
      german: "Die Volkshochschule",
      translated: "Η Volkshochschule",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "στη Γερμανία",
      tone: 'semantic',
    },
    {
      german: "ist eine Einrichtung",
      translated: "είναι ίδρυμα …",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:270|en": [
    {
      german: "Die Volkshochschule",
      translated: "The adult education center (Volkshochschule)",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "in Germany",
      tone: 'semantic',
    },
    {
      german: "ist eine Einrichtung",
      translated: "is an institution",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:270|es": [
    {
      german: "Die Volkshochschule",
      translated: "La Volkshochschule",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "en Alemania",
      tone: 'semantic',
    },
    {
      german: "ist eine Einrichtung",
      translated: "es una institución",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:270|fa": [
    {
      german: "Die Volkshochschule",
      translated: "Volkshochschule",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "در آلمان",
      tone: 'semantic',
    },
    {
      german: "ist eine Einrichtung",
      translated: "مؤسسه‌ای است …",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:270|fr": [
    {
      german: "Die Volkshochschule",
      translated: "La Volkshochschule",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "en Allemagne",
      tone: 'semantic',
    },
    {
      german: "ist eine Einrichtung",
      translated: "est un établissement",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:270|hr": [
    {
      german: "Die Volkshochschule",
      translated: "Volkshochschule",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "u Njemačkoj",
      tone: 'semantic',
    },
    {
      german: "ist eine Einrichtung",
      translated: "ustanova je",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:270|it": [
    {
      german: "Die Volkshochschule",
      translated: "La Volkshochschule",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "in Germania",
      tone: 'semantic',
    },
    {
      german: "ist eine Einrichtung",
      translated: "è un’istituzione",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:270|kmr": [
    {
      german: "Die Volkshochschule",
      translated: "Volkshochschule",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "Almanyayê",
      tone: 'semantic',
    },
    {
      german: "ist eine Einrichtung",
      translated: "saziyek",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:270|pl": [
    {
      german: "Die Volkshochschule",
      translated: "Volkshochschule",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "Niemczech",
      tone: 'semantic',
    },
    {
      german: "ist eine Einrichtung",
      translated: "jest instytucją",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:270|prs": [
    {
      german: "Die Volkshochschule",
      translated: "Volkshochschule",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "در آلمان",
      tone: 'semantic',
    },
    {
      german: "ist eine Einrichtung",
      translated: "مؤسسه‌ای است",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:270|ro": [
    {
      german: "Die Volkshochschule",
      translated: "Volkshochschule",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "în Germania",
      tone: 'semantic',
    },
    {
      german: "ist eine Einrichtung",
      translated: "este o instituție",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:270|ru": [
    {
      german: "Die Volkshochschule",
      translated: "Народный университет (Volkshochschule)",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "в Германии",
      tone: 'semantic',
    },
    {
      german: "ist eine Einrichtung",
      translated: "— это учреждение …",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:270|sq": [
    {
      german: "Die Volkshochschule",
      translated: "Volkshochschule",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "në Gjermani",
      tone: 'semantic',
    },
    {
      german: "ist eine Einrichtung",
      translated: "është një institucion",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:270|sr": [
    {
      german: "Die Volkshochschule",
      translated: "Volkshochschule",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "u Nemačkoj",
      tone: 'semantic',
    },
    {
      german: "ist eine Einrichtung",
      translated: "ustanova je",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:270|tr": [
    {
      german: "Die Volkshochschule",
      translated: "Volkshochschule",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "Almanya'daki",
      tone: 'semantic',
    },
    {
      german: "ist eine Einrichtung",
      translated: "kurumudur",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:270|uk": [
    {
      german: "Die Volkshochschule",
      translated: "Народний університет (Volkshochschule)",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "у Німеччині",
      tone: 'semantic',
    },
    {
      german: "ist eine Einrichtung",
      translated: "— це заклад …",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:270|vi": [
    {
      german: "Die Volkshochschule",
      translated: "Volkshochschule",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "ở Đức",
      tone: 'semantic',
    },
    {
      german: "ist eine Einrichtung",
      translated: "là một cơ sở …",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:271|ar": [
    {
      german: "Was ist",
      translated: "ما",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "في ألمانيا",
      tone: 'semantic',
    },
    {
      german: "ein Brauch",
      translated: "العادة",
      tone: 'semantic',
    },
    {
      german: "zu Weihnachten",
      translated: "بعيد الميلاد",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:271|bg": [
    {
      german: "Was ist",
      translated: "Кой",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "в Германия",
      tone: 'semantic',
    },
    {
      german: "ein Brauch",
      translated: "обичай",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:271|bs": [
    {
      german: "Was ist",
      translated: "Koji",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "u Njemačkoj",
      tone: 'semantic',
    },
    {
      german: "ein Brauch",
      translated: "običaj",
      tone: 'semantic',
    },
    {
      german: "zu Weihnachten",
      translated: "povezan s Božićem",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:271|el": [
    {
      german: "Was ist",
      translated: "Ποιο είναι",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "στη Γερμανία",
      tone: 'semantic',
    },
    {
      german: "ein Brauch",
      translated: "έθιμο",
      tone: 'semantic',
    },
    {
      german: "zu Weihnachten",
      translated: "χριστουγεννιάτικο",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:271|en": [
    {
      german: "Was ist",
      translated: "What is",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "in Germany",
      tone: 'semantic',
    },
    {
      german: "ein Brauch",
      translated: "tradition",
      tone: 'semantic',
    },
    {
      german: "zu Weihnachten",
      translated: "Christmas",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:271|es": [
    {
      german: "Was ist",
      translated: "¿Qué",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "en Alemania",
      tone: 'semantic',
    },
    {
      german: "ein Brauch",
      translated: "tradición",
      tone: 'semantic',
    },
    {
      german: "zu Weihnachten",
      translated: "Navidad",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:271|fa": [
    {
      german: "Was ist",
      translated: "کدام مورد",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "در آلمان",
      tone: 'semantic',
    },
    {
      german: "ein Brauch",
      translated: "یکی از رسوم",
      tone: 'semantic',
    },
    {
      german: "zu Weihnachten",
      translated: "کریسمس",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:271|fr": [
    {
      german: "Was ist",
      translated: "Quelle",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "en Allemagne",
      tone: 'semantic',
    },
    {
      german: "ein Brauch",
      translated: "coutume",
      tone: 'semantic',
    },
    {
      german: "zu Weihnachten",
      translated: "à Noël",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:271|hr": [
    {
      german: "Was ist",
      translated: "Koji je",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "u Njemačkoj",
      tone: 'semantic',
    },
    {
      german: "ein Brauch",
      translated: "običaj",
      tone: 'semantic',
    },
    {
      german: "zu Weihnachten",
      translated: "s Božićem",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:271|it": [
    {
      german: "Was ist",
      translated: "Qual è",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "in Germania",
      tone: 'semantic',
    },
    {
      german: "ein Brauch",
      translated: "una tradizione",
      tone: 'semantic',
    },
    {
      german: "zu Weihnachten",
      translated: "natalizia",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:271|kmr": [
    {
      german: "Was ist",
      translated: "çi ye",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "Li Almanyayê",
      tone: 'semantic',
    },
    {
      german: "ein Brauch",
      translated: "adeteke",
      tone: 'semantic',
    },
    {
      german: "zu Weihnachten",
      translated: "Noelê",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:271|pl": [
    {
      german: "Was ist",
      translated: "Który",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "w Niemczech",
      tone: 'semantic',
    },
    {
      german: "ein Brauch",
      translated: "zwyczaj",
      tone: 'semantic',
    },
    {
      german: "zu Weihnachten",
      translated: "z Bożym Narodzeniem",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:271|prs": [
    {
      german: "Was ist",
      translated: "کدام",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "در آلمان",
      tone: 'semantic',
    },
    {
      german: "ein Brauch",
      translated: "یکی از رسوم",
      tone: 'semantic',
    },
    {
      german: "zu Weihnachten",
      translated: "کریسمس",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:271|ro": [
    {
      german: "Was ist",
      translated: "Care este",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "în Germania",
      tone: 'semantic',
    },
    {
      german: "ein Brauch",
      translated: "un obicei",
      tone: 'semantic',
    },
    {
      german: "zu Weihnachten",
      translated: "de Crăciun",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:271|ru": [
    {
      german: "Was ist",
      translated: "Что является",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "в Германии",
      tone: 'semantic',
    },
    {
      german: "ein Brauch",
      translated: "обычаем",
      tone: 'semantic',
    },
    {
      german: "zu Weihnachten",
      translated: "на Рождество",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:271|sq": [
    {
      german: "Was ist",
      translated: "Cili është",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "në Gjermani",
      tone: 'semantic',
    },
    {
      german: "ein Brauch",
      translated: "një zakon i",
      tone: 'semantic',
    },
    {
      german: "zu Weihnachten",
      translated: "Krishtlindjeve",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:271|sr": [
    {
      german: "Was ist",
      translated: "Koji je",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "u Nemačkoj",
      tone: 'semantic',
    },
    {
      german: "ein Brauch",
      translated: "običaj",
      tone: 'semantic',
    },
    {
      german: "zu Weihnachten",
      translated: "povezan s Božićem",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:271|tr": [
    {
      german: "Was ist",
      translated: "hangisidir",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "Almanya'da",
      tone: 'semantic',
    },
    {
      german: "ein Brauch",
      translated: "geleneklerden biri",
      tone: 'semantic',
    },
    {
      german: "zu Weihnachten",
      translated: "Noel'de yapılan",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:271|uk": [
    {
      german: "Was ist",
      translated: "Який",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "в Німеччині",
      tone: 'semantic',
    },
    {
      german: "ein Brauch",
      translated: "звичай",
      tone: 'semantic',
    },
    {
      german: "zu Weihnachten",
      translated: "на Різдво?",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:271|vi": [
    {
      german: "Was ist",
      translated: "Một phong tục",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "ở Đức",
      tone: 'semantic',
    },
    {
      german: "ein Brauch",
      translated: "là gì",
      tone: 'semantic',
    },
    {
      german: "zu Weihnachten",
      translated: "Giáng sinh",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:272|ar": [
    {
      german: "Welche Lebensform",
      translated: "أي شكل من أشكال الحياة الأسرية",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "في ألمانيا",
      tone: 'semantic',
    },
    {
      german: "nicht erlaubt",
      translated: "غير مسموح به",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:272|bg": [
    {
      german: "Welche Lebensform",
      translated: "Коя форма на съвместен живот",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "в Германия",
      tone: 'semantic',
    },
    {
      german: "nicht erlaubt",
      translated: "НЕ е разрешена",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:272|bs": [
    {
      german: "Welche Lebensform",
      translated: "Koji oblik",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "u Njemačkoj",
      tone: 'semantic',
    },
    {
      german: "nicht erlaubt",
      translated: "NIJE dopušten",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:272|el": [
    {
      german: "Welche Lebensform",
      translated: "Ποια μορφή συμβίωσης",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "ΔΕΝ",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "στη Γερμανία",
      tone: 'semantic',
    },
    {
      german: "nicht erlaubt",
      translated: "επιτρέπεται",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:272|en": [
    {
      german: "Welche Lebensform",
      translated: "Which way of life",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "is",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "in Germany",
      tone: 'semantic',
    },
    {
      german: "nicht erlaubt",
      translated: "not allowed",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:272|es": [
    {
      german: "Welche Lebensform",
      translated: "Qué forma de convivencia",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "en Alemania",
      tone: 'semantic',
    },
    {
      german: "nicht erlaubt",
      translated: "NO está permitida",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:272|fa": [
    {
      german: "Welche Lebensform",
      translated: "کدام شکل زندگی مشترک",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "در",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "آلمان",
      tone: 'semantic',
    },
    {
      german: "nicht erlaubt",
      translated: "مجاز نیست",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:272|fr": [
    {
      german: "Welche Lebensform",
      translated: "Quel mode de vie",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "en Allemagne",
      tone: 'semantic',
    },
    {
      german: "nicht erlaubt",
      translated: "n’est pas autorisé",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:272|hr": [
    {
      german: "Welche Lebensform",
      translated: "Koji oblik",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "u Njemačkoj",
      tone: 'semantic',
    },
    {
      german: "nicht erlaubt",
      translated: "NIJE dopušten",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:272|it": [
    {
      german: "Welche Lebensform",
      translated: "Quale forma di convivenza",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "in Germania",
      tone: 'semantic',
    },
    {
      german: "nicht erlaubt",
      translated: "NON è consentita",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:272|kmr": [
    {
      german: "Welche Lebensform",
      translated: "Kîjan awayê jiyanê",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "li Almanyayê",
      tone: 'semantic',
    },
    {
      german: "nicht erlaubt",
      translated: "qedexe ye?",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:272|pl": [
    {
      german: "Welche Lebensform",
      translated: "Która forma wspólnego życia",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "w Niemczech",
      tone: 'semantic',
    },
    {
      german: "nicht erlaubt",
      translated: "NIE jest dozwolona",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:272|prs": [
    {
      german: "Welche Lebensform",
      translated: "کدام شکل زندگی مشترک",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "در آلمان",
      tone: 'semantic',
    },
    {
      german: "nicht erlaubt",
      translated: "مجاز نیست؟",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:272|ro": [
    {
      german: "Welche Lebensform",
      translated: "Care formă de conviețuire",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "în Germania",
      tone: 'semantic',
    },
    {
      german: "nicht erlaubt",
      translated: "NU este permisă",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:272|ru": [
    {
      german: "Welche Lebensform",
      translated: "Какая форма",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "совместной жизни",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "в Германии",
      tone: 'semantic',
    },
    {
      german: "nicht erlaubt",
      translated: "не разрешена",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:272|sq": [
    {
      german: "Welche Lebensform",
      translated: "Cila formë bashkëjetese",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "NUK",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "në Gjermani",
      tone: 'semantic',
    },
    {
      german: "nicht erlaubt",
      translated: "lejohet",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:272|sr": [
    {
      german: "Welche Lebensform",
      translated: "Koji oblik",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "u Nemačkoj",
      tone: 'semantic',
    },
    {
      german: "nicht erlaubt",
      translated: "NIJE dozvoljen",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:272|tr": [
    {
      german: "Welche Lebensform",
      translated: "hangi yaşam biçimine",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "Almanya'da",
      tone: 'semantic',
    },
    {
      german: "nicht erlaubt",
      translated: "izin verilmez",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:272|uk": [
    {
      german: "Welche Lebensform",
      translated: "Яка форма спільного життя",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "в Німеччині",
      tone: 'semantic',
    },
    {
      german: "nicht erlaubt",
      translated: "не дозволена",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:272|vi": [
    {
      german: "Welche Lebensform",
      translated: "Hình thức chung sống nào",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "ở Đức",
      tone: 'semantic',
    },
    {
      german: "nicht erlaubt",
      translated: "KHÔNG được phép",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:273|ar": [
    {
      german: "Bei Erziehungsproblemen",
      translated: "عند وجود مشكلات في تربية الأطفال",
      tone: 'semantic',
    },
    {
      german: "gehen",
      translated: "تتوجه",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "في ألمانيا",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:273|bg": [
    {
      german: "Bei Erziehungsproblemen",
      translated: "При проблеми с възпитанието",
      tone: 'semantic',
    },
    {
      german: "gehen",
      translated: "обръщате",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "в Германия",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:273|bs": [
    {
      german: "Bei Erziehungsproblemen",
      translated: "Kod pitanja povezanih s odgojem djece",
      tone: 'semantic',
    },
    {
      german: "gehen",
      translated: "obraćate se",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "u Njemačkoj",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:273|el": [
    {
      german: "Bei Erziehungsproblemen",
      translated: "Για προβλήματα ανατροφής",
      tone: 'semantic',
    },
    {
      german: "gehen",
      translated: "απευθύνεστε",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "στη Γερμανία",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:273|en": [
    {
      german: "Bei Erziehungsproblemen",
      translated: "For parenting problems",
      tone: 'semantic',
    },
    {
      german: "gehen",
      translated: "go",
      tone: 'semantic',
    },
    {
      german: "Sie",
      translated: "you",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "in Germany",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:273|es": [
    {
      german: "Bei Erziehungsproblemen",
      translated: "Si hay problemas con la educación de los hijos",
      tone: 'semantic',
    },
    {
      german: "gehen",
      translated: "se acude a",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "en Alemania",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:273|fa": [
    {
      german: "Bei Erziehungsproblemen",
      translated: "برای مشکلات تربیتی",
      tone: 'semantic',
    },
    {
      german: "gehen",
      translated: "مراجعه می‌کنید",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "در آلمان",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:273|fr": [
    {
      german: "Bei Erziehungsproblemen",
      translated: "En cas de problèmes éducatifs",
      tone: 'semantic',
    },
    {
      german: "gehen",
      translated: "vous vous adressez",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "en Allemagne",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:273|hr": [
    {
      german: "Bei Erziehungsproblemen",
      translated: "Kod pitanja povezanih s odgojem djece",
      tone: 'semantic',
    },
    {
      german: "gehen",
      translated: "obraćate se",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "u Njemačkoj",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:273|it": [
    {
      german: "Bei Erziehungsproblemen",
      translated: "Per problemi educativi",
      tone: 'semantic',
    },
    {
      german: "gehen",
      translated: "ci si rivolge",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "in Germania",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:273|kmr": [
    {
      german: "Bei Erziehungsproblemen",
      translated: "Ji bo pirsgirêkên perwerdehiyê",
      tone: 'semantic',
    },
    {
      german: "gehen",
      translated: "diçî",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "li Almanyayê",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:273|pl": [
    {
      german: "Bei Erziehungsproblemen",
      translated: "W sprawach związanych z wychowaniem dzieci",
      tone: 'semantic',
    },
    {
      german: "gehen",
      translated: "zwracacie się",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "w Niemczech",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:273|prs": [
    {
      german: "Bei Erziehungsproblemen",
      translated: "برای مشکلات تربیتی",
      tone: 'semantic',
    },
    {
      german: "gehen",
      translated: "مراجعه می‌کنید",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "در آلمان",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:273|ro": [
    {
      german: "Bei Erziehungsproblemen",
      translated: "Pentru probleme legate de educarea copiilor",
      tone: 'semantic',
    },
    {
      german: "gehen",
      translated: "adresați",
      tone: 'semantic',
    },
    {
      german: "Sie",
      translated: "vă",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "în Germania",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:273|ru": [
    {
      german: "Bei Erziehungsproblemen",
      translated: "При проблемах с воспитанием детей",
      tone: 'semantic',
    },
    {
      german: "gehen",
      translated: "обращаетесь",
      tone: 'semantic',
    },
    {
      german: "Sie",
      translated: "вы",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "в Германии",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:273|sq": [
    {
      german: "Bei Erziehungsproblemen",
      translated: "Për probleme me edukimin",
      tone: 'semantic',
    },
    {
      german: "Sie",
      translated: "i drejtoheni",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "në Gjermani",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:273|sr": [
    {
      german: "Bei Erziehungsproblemen",
      translated: "Kod pitanja povezanih s vaspitanjem dece",
      tone: 'semantic',
    },
    {
      german: "gehen",
      translated: "obraćate se",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "u Nemačkoj",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:273|tr": [
    {
      german: "Bei Erziehungsproblemen",
      translated: "Almanya'da çocuk yetiştirmeyle ilgili sorunlarda",
      tone: 'semantic',
    },
    {
      german: "gehen",
      translated: "gidersiniz",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:273|uk": [
    {
      german: "Bei Erziehungsproblemen",
      translated: "У разі проблем із вихованням дітей",
      tone: 'semantic',
    },
    {
      german: "gehen",
      translated: "звертаєтеся",
      tone: 'semantic',
    },
    {
      german: "Sie",
      translated: "ви",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "у Німеччині",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:273|vi": [
    {
      german: "Bei Erziehungsproblemen",
      translated: "Khi có vấn đề về nuôi dạy con",
      tone: 'semantic',
    },
    {
      german: "gehen",
      translated: "nên liên hệ",
      tone: 'semantic',
    },
    {
      german: "Sie",
      translated: "bạn",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "ở Đức",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:274|ar": [
    {
      german: "Sie haben",
      translated: "فتحت",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "في ألمانيا",
      tone: 'semantic',
    },
    {
      german: "absichtlich",
      translated: "عمدًا",
      tone: 'semantic',
    },
    {
      german: "einen Brief geöffnet",
      translated: "رسالة موجّهة",
      tone: 'semantic',
    },
    {
      german: "der an eine andere Person adressiert ist",
      translated: "إلى شخص آخر",
      tone: 'semantic',
    },
    {
      german: "Was haben Sie nicht beachtet?",
      translated: "أي حق لم تحترمه؟",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:274|bg": [
    {
      german: "absichtlich",
      translated: "Умишлено",
      tone: 'semantic',
    },
    {
      german: "einen Brief geöffnet",
      translated: "сте отворили писмо",
      tone: 'semantic',
    },
    {
      german: "der an eine andere Person adressiert ist",
      translated: "адресирано до друг човек",
      tone: 'semantic',
    },
    {
      german: "Was haben Sie nicht beachtet?",
      translated: "Кой принцип не сте спазили?",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:274|bs": [
    {
      german: "absichtlich",
      translated: "Namjerno",
      tone: 'semantic',
    },
    {
      german: "einen Brief geöffnet",
      translated: "otvorili pismo",
      tone: 'semantic',
    },
    {
      german: "der an eine andere Person adressiert ist",
      translated: "adresirano na drugu osobu.",
      tone: 'semantic',
    },
    {
      german: "Was haben Sie nicht beachtet?",
      translated: "Koje načelo niste poštovali",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:274|el": [
    {
      german: "Sie haben",
      translated: "Ανοίξατε",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "στη Γερμανία",
      tone: 'semantic',
    },
    {
      german: "absichtlich",
      translated: "σκόπιμα",
      tone: 'semantic',
    },
    {
      german: "einen Brief geöffnet",
      translated: "μια επιστολή",
      tone: 'semantic',
    },
    {
      german: "der an eine andere Person adressiert ist",
      translated: "που απευθυνόταν σε άλλο άτομο",
      tone: 'semantic',
    },
    {
      german: "Was haben Sie nicht beachtet?",
      translated: "Τι δεν σεβαστήκατε;",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:274|en": [
    {
      german: "Sie haben",
      translated: "You",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "in Germany",
      tone: 'semantic',
    },
    {
      german: "absichtlich",
      translated: "deliberately",
      tone: 'semantic',
    },
    {
      german: "einen Brief geöffnet",
      translated: "opened a letter",
      tone: 'semantic',
    },
    {
      german: "der an eine andere Person adressiert ist",
      translated: "that was addressed to another person",
      tone: 'semantic',
    },
    {
      german: "Was haben Sie nicht beachtet?",
      translated: "What did you not observe?",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:274|es": [
    {
      german: "Sie haben",
      translated: "has",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "En Alemania",
      tone: 'semantic',
    },
    {
      german: "absichtlich",
      translated: "deliberadamente",
      tone: 'semantic',
    },
    {
      german: "einen Brief geöffnet",
      translated: "abierto",
      tone: 'semantic',
    },
    {
      german: "der an eine andere Person adressiert ist",
      translated: "dirigida a otra persona",
      tone: 'semantic',
    },
    {
      german: "Was haben Sie nicht beachtet?",
      translated: "¿Qué derecho no has respetado?",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:274|fa": [
    {
      german: "in Deutschland",
      translated: "در آلمان",
      tone: 'semantic',
    },
    {
      german: "absichtlich",
      translated: "عمداً",
      tone: 'semantic',
    },
    {
      german: "der an eine andere Person adressiert ist",
      translated: "خطاب به شخص دیگری بوده",
      tone: 'semantic',
    },
    {
      german: "Was haben Sie nicht beachtet?",
      translated: "کدام اصل را رعایت نکرده‌اید؟",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:274|fr": [
    {
      german: "Sie haben",
      translated: "vous avez",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "En Allemagne",
      tone: 'semantic',
    },
    {
      german: "absichtlich",
      translated: "volontairement",
      tone: 'semantic',
    },
    {
      german: "einen Brief geöffnet",
      translated: "ouvert une lettre",
      tone: 'semantic',
    },
    {
      german: "der an eine andere Person adressiert ist",
      translated: "adressée à une autre personne",
      tone: 'semantic',
    },
    {
      german: "Was haben Sie nicht beachtet?",
      translated: "Quel droit n’avez-vous pas respecté ?",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:274|hr": [
    {
      german: "Sie haben",
      translated: "ste",
      tone: 'semantic',
    },
    {
      german: "absichtlich",
      translated: "Namjerno",
      tone: 'semantic',
    },
    {
      german: "einen Brief geöffnet",
      translated: "otvorili pismo",
      tone: 'semantic',
    },
    {
      german: "der an eine andere Person adressiert ist",
      translated: "adresirano na drugu osobu",
      tone: 'semantic',
    },
    {
      german: "Was haben Sie nicht beachtet?",
      translated: "Koje načelo niste poštovali",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:274|it": [
    {
      german: "Sie haben",
      translated: "Avete",
      tone: 'semantic',
    },
    {
      german: "absichtlich",
      translated: "intenzionalmente",
      tone: 'semantic',
    },
    {
      german: "einen Brief geöffnet",
      translated: "aperto",
      tone: 'semantic',
    },
    {
      german: "der an eine andere Person adressiert ist",
      translated: "una lettera indirizzata a un’altra persona",
      tone: 'semantic',
    },
    {
      german: "Was haben Sie nicht beachtet?",
      translated: "Quale principio non avete rispettato",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:274|kmr": [
    {
      german: "Sie haben",
      translated: "Te",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "li Almanyayê",
      tone: 'semantic',
    },
    {
      german: "absichtlich",
      translated: "bi zanebûn",
      tone: 'semantic',
    },
    {
      german: "einen Brief geöffnet",
      translated: "nameyek",
      tone: 'semantic',
    },
    {
      german: "der an eine andere Person adressiert ist",
      translated: "ku ji bo kesek din hatiye navnîşankirin",
      tone: 'semantic',
    },
    {
      german: "Was haben Sie nicht beachtet?",
      translated: "Te çi li ber çavan negirt?",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:274|pl": [
    {
      german: "in Deutschland",
      translated: "W Niemczech",
      tone: 'semantic',
    },
    {
      german: "absichtlich",
      translated: "celowo",
      tone: 'semantic',
    },
    {
      german: "einen Brief geöffnet",
      translated: "otworzyliście list",
      tone: 'semantic',
    },
    {
      german: "der an eine andere Person adressiert ist",
      translated: "adresowany do innej osoby",
      tone: 'semantic',
    },
    {
      german: "Was haben Sie nicht beachtet?",
      translated: "Której zasady nie przestrzegaliście",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:274|prs": [
    {
      german: "in Deutschland",
      translated: "در آلمان",
      tone: 'semantic',
    },
    {
      german: "absichtlich",
      translated: "عمداً",
      tone: 'semantic',
    },
    {
      german: "der an eine andere Person adressiert ist",
      translated: "خطاب به شخص دیگری بوده",
      tone: 'semantic',
    },
    {
      german: "Was haben Sie nicht beachtet?",
      translated: "کدام اصل را رعایت نکرده‌اید؟",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:274|ro": [
    {
      german: "Sie haben",
      translated: "Ați deschis",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "în Germania",
      tone: 'semantic',
    },
    {
      german: "absichtlich",
      translated: "intenționat",
      tone: 'semantic',
    },
    {
      german: "einen Brief geöffnet",
      translated: "o scrisoare",
      tone: 'semantic',
    },
    {
      german: "der an eine andere Person adressiert ist",
      translated: "adresată altei persoane",
      tone: 'semantic',
    },
    {
      german: "Was haben Sie nicht beachtet?",
      translated: "Ce principiu nu ați respectat?",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:274|ru": [
    {
      german: "in Deutschland",
      translated: "в Германии",
      tone: 'semantic',
    },
    {
      german: "absichtlich",
      translated: "намеренно",
      tone: 'semantic',
    },
    {
      german: "einen Brief geöffnet",
      translated: "вскрыли",
      tone: 'semantic',
    },
    {
      german: "der an eine andere Person adressiert ist",
      translated: "адресованное другому человеку",
      tone: 'semantic',
    },
    {
      german: "Was haben Sie nicht beachtet?",
      translated: "Что вы нарушили",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:274|sq": [
    {
      german: "Sie haben",
      translated: "Keni",
      tone: 'semantic',
    },
    {
      german: "einen Brief geöffnet",
      translated: "hapur me dashje një letër",
      tone: 'semantic',
    },
    {
      german: "der an eine andere Person adressiert ist",
      translated: "drejtuar një personi tjetër",
      tone: 'semantic',
    },
    {
      german: "Was haben Sie nicht beachtet?",
      translated: "Cilin parim nuk keni respektuar?",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:274|sr": [
    {
      german: "Sie haben",
      translated: "ste",
      tone: 'semantic',
    },
    {
      german: "absichtlich",
      translated: "Namjerno",
      tone: 'semantic',
    },
    {
      german: "einen Brief geöffnet",
      translated: "otvorili pismo",
      tone: 'semantic',
    },
    {
      german: "der an eine andere Person adressiert ist",
      translated: "adresirano na drugu osobu",
      tone: 'semantic',
    },
    {
      german: "Was haben Sie nicht beachtet?",
      translated: "Koje načelo niste poštovali",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:274|tr": [
    {
      german: "in Deutschland",
      translated: "Almanya'da",
      tone: 'semantic',
    },
    {
      german: "absichtlich",
      translated: "bilerek",
      tone: 'semantic',
    },
    {
      german: "einen Brief geöffnet",
      translated: "açtınız",
      tone: 'semantic',
    },
    {
      german: "der an eine andere Person adressiert ist",
      translated: "başka bir kişiye gönderilmiş",
      tone: 'semantic',
    },
    {
      german: "Was haben Sie nicht beachtet?",
      translated: "Hangi hakkı ihlal ettiniz?",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:274|uk": [
    {
      german: "Sie haben",
      translated: "ви",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "У Німеччині",
      tone: 'semantic',
    },
    {
      german: "absichtlich",
      translated: "навмисно",
      tone: 'semantic',
    },
    {
      german: "einen Brief geöffnet",
      translated: "відкрили лист",
      tone: 'semantic',
    },
    {
      german: "der an eine andere Person adressiert ist",
      translated: "адресований іншій людині",
      tone: 'semantic',
    },
    {
      german: "Was haben Sie nicht beachtet?",
      translated: "Яке право ви порушили?",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:274|vi": [
    {
      german: "Sie haben",
      translated: "Bạn",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "ở Đức",
      tone: 'semantic',
    },
    {
      german: "absichtlich",
      translated: "cố ý",
      tone: 'semantic',
    },
    {
      german: "einen Brief geöffnet",
      translated: "mở",
      tone: 'semantic',
    },
    {
      german: "der an eine andere Person adressiert ist",
      translated: "gửi cho người khác",
      tone: 'semantic',
    },
    {
      german: "Was haben Sie nicht beachtet?",
      translated: "Bạn đã không tôn trọng điều gì?",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:275|ar": [
    {
      german: "Was braucht man",
      translated: "ما الذي يحتاج إليه الشخص",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "في ألمانيا",
      tone: 'semantic',
    },
    {
      german: "für eine Ehescheidung",
      translated: "من أجل الطلاق",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:275|bg": [
    {
      german: "Was braucht man",
      translated: "От какво се нуждаете",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "в Германия",
      tone: 'semantic',
    },
    {
      german: "für eine Ehescheidung",
      translated: "за развод",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:275|bs": [
    {
      german: "Was braucht man",
      translated: "Što vam je potrebno",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "u Njemačkoj",
      tone: 'semantic',
    },
    {
      german: "für eine Ehescheidung",
      translated: "za razvod",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:275|el": [
    {
      german: "Was braucht man",
      translated: "Τι χρειάζεστε",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "στη Γερμανία",
      tone: 'semantic',
    },
    {
      german: "für eine Ehescheidung",
      translated: "για ένα διαζύγιο",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:275|en": [
    {
      german: "Was braucht man",
      translated: "What do you need",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "in Germany",
      tone: 'semantic',
    },
    {
      german: "für eine Ehescheidung",
      translated: "for a divorce",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:275|es": [
    {
      german: "Was braucht man",
      translated: "¿Qué se necesita",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "en Alemania",
      tone: 'semantic',
    },
    {
      german: "für eine Ehescheidung",
      translated: "para divorciarse",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:275|fa": [
    {
      german: "Was braucht man",
      translated: "برای طلاق",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "در آلمان",
      tone: 'semantic',
    },
    {
      german: "für eine Ehescheidung",
      translated: "به چه چیزی نیاز است",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:275|fr": [
    {
      german: "Was braucht man",
      translated: "De quoi a-t-on besoin",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "en Allemagne",
      tone: 'semantic',
    },
    {
      german: "für eine Ehescheidung",
      translated: "pour divorcer ?",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:275|hr": [
    {
      german: "Was braucht man",
      translated: "Što vam je",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "u Njemačkoj",
      tone: 'semantic',
    },
    {
      german: "für eine Ehescheidung",
      translated: "za razvod",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:275|it": [
    {
      german: "Was braucht man",
      translated: "Di che cosa avete bisogno",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "in Germania",
      tone: 'semantic',
    },
    {
      german: "für eine Ehescheidung",
      translated: "per divorziare",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:275|kmr": [
    {
      german: "Was braucht man",
      translated: "çi pêwîst e",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "li Almanyayê",
      tone: 'semantic',
    },
    {
      german: "für eine Ehescheidung",
      translated: "Ji bo bela bûna zewacê",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:275|pl": [
    {
      german: "Was braucht man",
      translated: "Czego potrzebujecie",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "w Niemczech",
      tone: 'semantic',
    },
    {
      german: "für eine Ehescheidung",
      translated: "do rozwodu",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:275|prs": [
    {
      german: "Was braucht man",
      translated: "به چه چیزی نیاز است",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "در آلمان",
      tone: 'semantic',
    },
    {
      german: "für eine Ehescheidung",
      translated: "برای طلاق",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:275|ro": [
    {
      german: "Was braucht man",
      translated: "De ce aveți nevoie",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "în Germania",
      tone: 'semantic',
    },
    {
      german: "für eine Ehescheidung",
      translated: "pentru un divorț",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:275|ru": [
    {
      german: "Was braucht man",
      translated: "Что нужно",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "в Германии",
      tone: 'semantic',
    },
    {
      german: "für eine Ehescheidung",
      translated: "для развода",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:275|sq": [
    {
      german: "Was braucht man",
      translated: "Për çfarë keni nevojë",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "në Gjermani",
      tone: 'semantic',
    },
    {
      german: "für eine Ehescheidung",
      translated: "për një divorc",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:275|sr": [
    {
      german: "Was braucht man",
      translated: "Šta vam je potrebno",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "u Nemačkoj",
      tone: 'semantic',
    },
    {
      german: "für eine Ehescheidung",
      translated: "za razvod",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:275|tr": [
    {
      german: "Was braucht man",
      translated: "ne gerekir",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "Almanya'da",
      tone: 'semantic',
    },
    {
      german: "für eine Ehescheidung",
      translated: "boşanmak için",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:275|uk": [
    {
      german: "Was braucht man",
      translated: "Що потрібно",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "в Німеччині",
      tone: 'semantic',
    },
    {
      german: "für eine Ehescheidung",
      translated: "для розлучення",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:275|vi": [
    {
      german: "Was braucht man",
      translated: "bạn cần gì",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "ở Đức",
      tone: 'semantic',
    },
    {
      german: "für eine Ehescheidung",
      translated: "Để ly hôn",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:276|ar": [
    {
      german: "Was sollten Sie tun",
      translated: "ماذا ينبغي أن تفعل",
      tone: 'semantic',
    },
    {
      german: "wenn Sie",
      translated: "إذا",
      tone: 'semantic',
    },
    {
      german: "von Ihrer Ansprechpartnerin/Ihrem Ansprechpartner",
      translated: "موظف الاتصال",
      tone: 'semantic',
    },
    {
      german: "in einer deutschen Behörde",
      translated: "في جهة حكومية ألمانية",
      tone: 'semantic',
    },
    {
      german: "schlecht behandelt werden",
      translated: "معاملة سيئة؟",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:276|bg": [
    {
      german: "Was sollten Sie tun",
      translated: "Какво трябва да направите",
      tone: 'semantic',
    },
    {
      german: "wenn Sie",
      translated: "ако",
      tone: 'semantic',
    },
    {
      german: "von Ihrer Ansprechpartnerin/Ihrem Ansprechpartner",
      translated: "вашето лице за контакт",
      tone: 'semantic',
    },
    {
      german: "in einer deutschen Behörde",
      translated: "в германска институция",
      tone: 'semantic',
    },
    {
      german: "schlecht behandelt werden",
      translated: "се държи лошо с вас",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:276|bs": [
    {
      german: "Was sollten Sie tun",
      translated: "Što biste trebali učiniti",
      tone: 'semantic',
    },
    {
      german: "wenn Sie",
      translated: "ako",
      tone: 'semantic',
    },
    {
      german: "von Ihrer Ansprechpartnerin/Ihrem Ansprechpartner",
      translated: "vaša kontaktna osoba",
      tone: 'semantic',
    },
    {
      german: "in einer deutschen Behörde",
      translated: "u njemačkoj službi",
      tone: 'semantic',
    },
    {
      german: "schlecht behandelt werden",
      translated: "prema vama loše ponaša",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:276|el": [
    {
      german: "Was sollten Sie tun",
      translated: "Τι πρέπει να κάνετε",
      tone: 'semantic',
    },
    {
      german: "wenn Sie",
      translated: "αν",
      tone: 'semantic',
    },
    {
      german: "von Ihrer Ansprechpartnerin/Ihrem Ansprechpartner",
      translated: "η υπεύθυνη ή ο υπεύθυνος επικοινωνίας σας",
      tone: 'semantic',
    },
    {
      german: "in einer deutschen Behörde",
      translated: "σε μια γερμανική δημόσια υπηρεσία",
      tone: 'semantic',
    },
    {
      german: "schlecht behandelt werden",
      translated: "σας φερθεί άσχημα",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:276|en": [
    {
      german: "Was sollten Sie tun",
      translated: "What should you do",
      tone: 'semantic',
    },
    {
      german: "wenn Sie",
      translated: "if you",
      tone: 'semantic',
    },
    {
      german: "von Ihrer Ansprechpartnerin/Ihrem Ansprechpartner",
      translated: "by your contact person",
      tone: 'semantic',
    },
    {
      german: "in einer deutschen Behörde",
      translated: "at a German authority",
      tone: 'semantic',
    },
    {
      german: "schlecht behandelt werden",
      translated: "treated badly",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:276|es": [
    {
      german: "Was sollten Sie tun",
      translated: "¿Qué deberías hacer",
      tone: 'semantic',
    },
    {
      german: "wenn Sie",
      translated: "si",
      tone: 'semantic',
    },
    {
      german: "von Ihrer Ansprechpartnerin/Ihrem Ansprechpartner",
      translated: "tu persona de contacto",
      tone: 'semantic',
    },
    {
      german: "in einer deutschen Behörde",
      translated: "en una autoridad alemana",
      tone: 'semantic',
    },
    {
      german: "schlecht behandelt werden",
      translated: "te trata mal",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:276|fa": [
    {
      german: "Was sollten Sie tun",
      translated: "چه باید بکنید",
      tone: 'semantic',
    },
    {
      german: "wenn Sie",
      translated: "اگر",
      tone: 'semantic',
    },
    {
      german: "von Ihrer Ansprechpartnerin/Ihrem Ansprechpartner",
      translated: "مسئول تماس شما",
      tone: 'semantic',
    },
    {
      german: "in einer deutschen Behörde",
      translated: "در یک ادارهٔ آلمانی",
      tone: 'semantic',
    },
    {
      german: "schlecht behandelt werden",
      translated: "با شما بدرفتاری کند",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:276|fr": [
    {
      german: "Was sollten Sie tun",
      translated: "Que devriez-vous faire",
      tone: 'semantic',
    },
    {
      german: "wenn Sie",
      translated: "si",
      tone: 'semantic',
    },
    {
      german: "von Ihrer Ansprechpartnerin/Ihrem Ansprechpartner",
      translated: "votre interlocuteur",
      tone: 'semantic',
    },
    {
      german: "in einer deutschen Behörde",
      translated: "dans une administration allemande",
      tone: 'semantic',
    },
    {
      german: "schlecht behandelt werden",
      translated: "vous traite mal",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:276|hr": [
    {
      german: "Was sollten Sie tun",
      translated: "Što biste trebali učiniti",
      tone: 'semantic',
    },
    {
      german: "wenn Sie",
      translated: "ako",
      tone: 'semantic',
    },
    {
      german: "von Ihrer Ansprechpartnerin/Ihrem Ansprechpartner",
      translated: "vaša kontaktna osoba",
      tone: 'semantic',
    },
    {
      german: "in einer deutschen Behörde",
      translated: "u njemačkom tijelu vlasti",
      tone: 'semantic',
    },
    {
      german: "schlecht behandelt werden",
      translated: "prema vama loše ponaša",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:276|it": [
    {
      german: "Was sollten Sie tun",
      translated: "Che cosa dovreste fare",
      tone: 'semantic',
    },
    {
      german: "wenn Sie",
      translated: "se",
      tone: 'semantic',
    },
    {
      german: "von Ihrer Ansprechpartnerin/Ihrem Ansprechpartner",
      translated: "la vostra referente o il vostro referente",
      tone: 'semantic',
    },
    {
      german: "in einer deutschen Behörde",
      translated: "in un’autorità tedesca",
      tone: 'semantic',
    },
    {
      german: "schlecht behandelt werden",
      translated: "vi tratta male",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:276|kmr": [
    {
      german: "Was sollten Sie tun",
      translated: "çi divê bikî",
      tone: 'semantic',
    },
    {
      german: "wenn Sie",
      translated: "Heke",
      tone: 'semantic',
    },
    {
      german: "von Ihrer Ansprechpartnerin/Ihrem Ansprechpartner",
      translated: "kesê têkiliyê yê te",
      tone: 'semantic',
    },
    {
      german: "in einer deutschen Behörde",
      translated: "li saziyek dewletî ya Alman",
      tone: 'semantic',
    },
    {
      german: "schlecht behandelt werden",
      translated: "bi te re xirab reftar bike",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:276|pl": [
    {
      german: "Was sollten Sie tun",
      translated: "co możecie zrobić",
      tone: 'semantic',
    },
    {
      german: "von Ihrer Ansprechpartnerin/Ihrem Ansprechpartner",
      translated: "pracownik niemieckiego urzędu",
      tone: 'semantic',
    },
    {
      german: "schlecht behandelt werden",
      translated: "źle was traktuje",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:276|prs": [
    {
      german: "Was sollten Sie tun",
      translated: "چه باید بکنید",
      tone: 'semantic',
    },
    {
      german: "wenn Sie",
      translated: "اگر",
      tone: 'semantic',
    },
    {
      german: "von Ihrer Ansprechpartnerin/Ihrem Ansprechpartner",
      translated: "مسئول تماس شما",
      tone: 'semantic',
    },
    {
      german: "in einer deutschen Behörde",
      translated: "در یک ادارهٔ آلمانی",
      tone: 'semantic',
    },
    {
      german: "schlecht behandelt werden",
      translated: "با شما بدرفتاری کند",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:276|ro": [
    {
      german: "Was sollten Sie tun",
      translated: "ce puteți face",
      tone: 'semantic',
    },
    {
      german: "wenn Sie",
      translated: "Dacă",
      tone: 'semantic',
    },
    {
      german: "von Ihrer Ansprechpartnerin/Ihrem Ansprechpartner",
      translated: "un angajat",
      tone: 'semantic',
    },
    {
      german: "in einer deutschen Behörde",
      translated: "al unei autorități germane",
      tone: 'semantic',
    },
    {
      german: "schlecht behandelt werden",
      translated: "vă tratează necorespunzător",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:276|ru": [
    {
      german: "Was sollten Sie tun",
      translated: "Что вам следует сделать",
      tone: 'semantic',
    },
    {
      german: "wenn Sie",
      translated: "если",
      tone: 'semantic',
    },
    {
      german: "von Ihrer Ansprechpartnerin/Ihrem Ansprechpartner",
      translated: "ваше контактное лицо",
      tone: 'semantic',
    },
    {
      german: "in einer deutschen Behörde",
      translated: "в немецком учреждении",
      tone: 'semantic',
    },
    {
      german: "schlecht behandelt werden",
      translated: "плохо с вами обращается",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:276|sq": [
    {
      german: "Was sollten Sie tun",
      translated: "Çfarë duhet të bëni",
      tone: 'semantic',
    },
    {
      german: "wenn Sie",
      translated: "nëse",
      tone: 'semantic',
    },
    {
      german: "von Ihrer Ansprechpartnerin/Ihrem Ansprechpartner",
      translated: "personi juaj i kontaktit",
      tone: 'semantic',
    },
    {
      german: "in einer deutschen Behörde",
      translated: "në një institucion gjerman",
      tone: 'semantic',
    },
    {
      german: "schlecht behandelt werden",
      translated: "ju trajton keq",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:276|sr": [
    {
      german: "Was sollten Sie tun",
      translated: "Šta biste trebali da uradite",
      tone: 'semantic',
    },
    {
      german: "wenn Sie",
      translated: "ako",
      tone: 'semantic',
    },
    {
      german: "von Ihrer Ansprechpartnerin/Ihrem Ansprechpartner",
      translated: "vaša kontaktna osoba",
      tone: 'semantic',
    },
    {
      german: "in einer deutschen Behörde",
      translated: "u nemačkoj službi",
      tone: 'semantic',
    },
    {
      german: "schlecht behandelt werden",
      translated: "prema vama loše ponaša",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:276|tr": [
    {
      german: "Was sollten Sie tun",
      translated: "ne yapmalısınız",
      tone: 'semantic',
    },
    {
      german: "von Ihrer Ansprechpartnerin/Ihrem Ansprechpartner",
      translated: "muhatabınız olan görevli",
      tone: 'semantic',
    },
    {
      german: "in einer deutschen Behörde",
      translated: "Almanya'daki bir kamu kurumunda",
      tone: 'semantic',
    },
    {
      german: "schlecht behandelt werden",
      translated: "size kötü davranırsa",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:276|uk": [
    {
      german: "Was sollten Sie tun",
      translated: "Що слід зробити",
      tone: 'semantic',
    },
    {
      german: "wenn Sie",
      translated: "якщо",
      tone: 'semantic',
    },
    {
      german: "von Ihrer Ansprechpartnerin/Ihrem Ansprechpartner",
      translated: "ваша контактна особа",
      tone: 'semantic',
    },
    {
      german: "in einer deutschen Behörde",
      translated: "в німецькому державному органі",
      tone: 'semantic',
    },
    {
      german: "schlecht behandelt werden",
      translated: "погано з вами поводиться",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:276|vi": [
    {
      german: "Was sollten Sie tun",
      translated: "bạn có thể làm gì?",
      tone: 'semantic',
    },
    {
      german: "wenn Sie",
      translated: "Nếu",
      tone: 'semantic',
    },
    {
      german: "von Ihrer Ansprechpartnerin/Ihrem Ansprechpartner",
      translated: "một nhân viên",
      tone: 'semantic',
    },
    {
      german: "in einer deutschen Behörde",
      translated: "của cơ quan Đức",
      tone: 'semantic',
    },
    {
      german: "schlecht behandelt werden",
      translated: "đối xử tệ với bạn",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:277|ar": [
    {
      german: "Eine Frau",
      translated: "امرأة",
      tone: 'semantic',
    },
    {
      german: "bewirbt sich",
      translated: "تتقدم",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "في ألمانيا",
      tone: 'semantic',
    },
    {
      german: "Was ist ein Beispiel für Diskriminierung?",
      translated: "ما مثال على التمييز؟",
      tone: 'semantic',
    },
    {
      german: "weil sie",
      translated: "لأنها",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:277|bg": [
    {
      german: "Eine Frau",
      translated: "Жена",
      tone: 'semantic',
    },
    {
      german: "die ein zweijähriges Kind hat",
      translated: "с двегодишно дете",
      tone: 'semantic',
    },
    {
      german: "bewirbt sich",
      translated: "кандидатства",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "в Германия",
      tone: 'semantic',
    },
    {
      german: "um eine Stelle",
      translated: "за работа",
      tone: 'semantic',
    },
    {
      german: "Was ist ein Beispiel für Diskriminierung?",
      translated: "Кое е пример за дискриминация?",
      tone: 'semantic',
    },
    {
      german: "Sie bekommt die Stelle",
      translated: "Не получава работата",
      tone: 'semantic',
    },
    {
      german: "nur deshalb nicht",
      translated: "само",
      tone: 'semantic',
    },
    {
      german: "weil sie",
      translated: "защото",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:277|bs": [
    {
      german: "Eine Frau",
      translated: "Žena",
      tone: 'semantic',
    },
    {
      german: "die ein zweijähriges Kind hat",
      translated: "s dvogodišnjim djetetom",
      tone: 'semantic',
    },
    {
      german: "bewirbt sich",
      translated: "prijavljuje se",
      tone: 'semantic',
    },
    {
      german: "um eine Stelle",
      translated: "za posao",
      tone: 'semantic',
    },
    {
      german: "Was ist ein Beispiel für Diskriminierung?",
      translated: "Koja je situacija diskriminacija?",
      tone: 'semantic',
    },
    {
      german: "Sie bekommt die Stelle",
      translated: "Ne dobiva posao",
      tone: 'semantic',
    },
    {
      german: "nur deshalb nicht",
      translated: "isključivo zato što",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:277|el": [
    {
      german: "Eine Frau",
      translated: "Μια γυναίκα",
      tone: 'semantic',
    },
    {
      german: "die ein zweijähriges Kind hat",
      translated: "με παιδί δύο ετών",
      tone: 'semantic',
    },
    {
      german: "bewirbt sich",
      translated: "κάνει αίτηση",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "στη Γερμανία",
      tone: 'semantic',
    },
    {
      german: "um eine Stelle",
      translated: "για εργασία",
      tone: 'semantic',
    },
    {
      german: "Was ist ein Beispiel für Diskriminierung?",
      translated: "Ποια περίπτωση είναι διάκριση;",
      tone: 'semantic',
    },
    {
      german: "Sie bekommt die Stelle",
      translated: "Δεν παίρνει τη δουλειά",
      tone: 'semantic',
    },
    {
      german: "nur deshalb nicht",
      translated: "μόνο",
      tone: 'semantic',
    },
    {
      german: "weil sie",
      translated: "επειδή",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:277|en": [
    {
      german: "Eine Frau",
      translated: "A woman",
      tone: 'semantic',
    },
    {
      german: "die ein zweijähriges Kind hat",
      translated: "with a two-year-old child",
      tone: 'semantic',
    },
    {
      german: "bewirbt sich",
      translated: "applies for",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "in Germany",
      tone: 'semantic',
    },
    {
      german: "um eine Stelle",
      translated: "a job",
      tone: 'semantic',
    },
    {
      german: "Was ist ein Beispiel für Diskriminierung?",
      translated: "What is an example of discrimination?",
      tone: 'semantic',
    },
    {
      german: "Sie bekommt die Stelle",
      translated: "get the job",
      tone: 'semantic',
    },
    {
      german: "nur deshalb nicht",
      translated: "doesn't",
      tone: 'semantic',
    },
    {
      german: "weil sie",
      translated: "because she",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:277|es": [
    {
      german: "Eine Frau",
      translated: "Una mujer",
      tone: 'semantic',
    },
    {
      german: "die ein zweijähriges Kind hat",
      translated: "con un hijo de dos años",
      tone: 'semantic',
    },
    {
      german: "bewirbt sich",
      translated: "solicita",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "en Alemania",
      tone: 'semantic',
    },
    {
      german: "um eine Stelle",
      translated: "un empleo",
      tone: 'semantic',
    },
    {
      german: "Was ist ein Beispiel für Diskriminierung?",
      translated: "¿Qué sería un ejemplo de discriminación?",
      tone: 'semantic',
    },
    {
      german: "Sie bekommt die Stelle",
      translated: "No obtiene el empleo",
      tone: 'semantic',
    },
    {
      german: "nur deshalb nicht",
      translated: "únicamente porque",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:277|fa": [
    {
      german: "Eine Frau",
      translated: "زنی",
      tone: 'semantic',
    },
    {
      german: "die ein zweijähriges Kind hat",
      translated: "که فرزند دوساله دارد",
      tone: 'semantic',
    },
    {
      german: "bewirbt sich",
      translated: "درخواست می‌دهد",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "در آلمان",
      tone: 'semantic',
    },
    {
      german: "um eine Stelle",
      translated: "برای شغلی",
      tone: 'semantic',
    },
    {
      german: "Was ist ein Beispiel für Diskriminierung?",
      translated: "کدام مورد نمونهٔ تبعیض است؟",
      tone: 'semantic',
    },
    {
      german: "nur deshalb nicht",
      translated: "فقط به این دلیل",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:277|fr": [
    {
      german: "Eine Frau",
      translated: "Une femme",
      tone: 'semantic',
    },
    {
      german: "die ein zweijähriges Kind hat",
      translated: "ayant un enfant de deux ans",
      tone: 'semantic',
    },
    {
      german: "bewirbt sich",
      translated: "postule",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "en Allemagne",
      tone: 'semantic',
    },
    {
      german: "um eine Stelle",
      translated: "à un emploi",
      tone: 'semantic',
    },
    {
      german: "Was ist ein Beispiel für Diskriminierung?",
      translated: "Quel serait un exemple de discrimination ?",
      tone: 'semantic',
    },
    {
      german: "Sie bekommt die Stelle",
      translated: "Elle n’obtient pas le poste",
      tone: 'semantic',
    },
    {
      german: "nur deshalb nicht",
      translated: "uniquement",
      tone: 'semantic',
    },
    {
      german: "weil sie",
      translated: "parce qu’elle",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:277|hr": [
    {
      german: "Eine Frau",
      translated: "Žena",
      tone: 'semantic',
    },
    {
      german: "die ein zweijähriges Kind hat",
      translated: "s dvogodišnjim djetetom",
      tone: 'semantic',
    },
    {
      german: "bewirbt sich",
      translated: "prijavljuje se",
      tone: 'semantic',
    },
    {
      german: "um eine Stelle",
      translated: "za posao",
      tone: 'semantic',
    },
    {
      german: "Was ist ein Beispiel für Diskriminierung?",
      translated: "Koja je situacija diskriminacija?",
      tone: 'semantic',
    },
    {
      german: "Sie bekommt die Stelle",
      translated: "Ne dobiva posao",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:277|it": [
    {
      german: "Eine Frau",
      translated: "Una donna",
      tone: 'semantic',
    },
    {
      german: "die ein zweijähriges Kind hat",
      translated: "con un figlio di due anni",
      tone: 'semantic',
    },
    {
      german: "bewirbt sich",
      translated: "si candida",
      tone: 'semantic',
    },
    {
      german: "um eine Stelle",
      translated: "per un lavoro",
      tone: 'semantic',
    },
    {
      german: "Was ist ein Beispiel für Diskriminierung?",
      translated: "Quale situazione è discriminazione?",
      tone: 'semantic',
    },
    {
      german: "Sie bekommt die Stelle",
      translated: "Non ottiene il posto",
      tone: 'semantic',
    },
    {
      german: "nur deshalb nicht",
      translated: "solo perché",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:277|kmr": [
    {
      german: "Eine Frau",
      translated: "Jinek",
      tone: 'semantic',
    },
    {
      german: "die ein zweijähriges Kind hat",
      translated: "bi zarokê 2 salî",
      tone: 'semantic',
    },
    {
      german: "bewirbt sich",
      translated: "serlêdide",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "li Almanyayê",
      tone: 'semantic',
    },
    {
      german: "um eine Stelle",
      translated: "ji bo kar",
      tone: 'semantic',
    },
    {
      german: "Was ist ein Beispiel für Diskriminierung?",
      translated: "Kîjan mînak cudakarî ye",
      tone: 'semantic',
    },
    {
      german: "Sie bekommt die Stelle",
      translated: "Karê nastîne",
      tone: 'semantic',
    },
    {
      german: "nur deshalb nicht",
      translated: "tenê",
      tone: 'semantic',
    },
    {
      german: "weil sie",
      translated: "ji ber ku",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:277|pl": [
    {
      german: "Eine Frau",
      translated: "Kobieta",
      tone: 'semantic',
    },
    {
      german: "die ein zweijähriges Kind hat",
      translated: "z dwuletnim dzieckiem",
      tone: 'semantic',
    },
    {
      german: "bewirbt sich",
      translated: "ubiega się",
      tone: 'semantic',
    },
    {
      german: "um eine Stelle",
      translated: "o pracę",
      tone: 'semantic',
    },
    {
      german: "Was ist ein Beispiel für Diskriminierung?",
      translated: "Która sytuacja jest dyskryminacją?",
      tone: 'semantic',
    },
    {
      german: "Sie bekommt die Stelle",
      translated: "Nie otrzymuje pracy",
      tone: 'semantic',
    },
    {
      german: "nur deshalb nicht",
      translated: "wyłącznie dlatego, że",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:277|prs": [
    {
      german: "Eine Frau",
      translated: "زنی",
      tone: 'semantic',
    },
    {
      german: "die ein zweijähriges Kind hat",
      translated: "که فرزند دوساله دارد",
      tone: 'semantic',
    },
    {
      german: "bewirbt sich",
      translated: "درخواست می‌دهد",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "در آلمان",
      tone: 'semantic',
    },
    {
      german: "Was ist ein Beispiel für Diskriminierung?",
      translated: "کدام مورد نمونهٔ تبعیض است؟",
      tone: 'semantic',
    },
    {
      german: "Sie bekommt die Stelle",
      translated: "شغل را نمی‌گیرد",
      tone: 'semantic',
    },
    {
      german: "nur deshalb nicht",
      translated: "فقط به این دلیل",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:277|ro": [
    {
      german: "Eine Frau",
      translated: "O femeie",
      tone: 'semantic',
    },
    {
      german: "die ein zweijähriges Kind hat",
      translated: "cu un copil de doi ani",
      tone: 'semantic',
    },
    {
      german: "bewirbt sich",
      translated: "candidează",
      tone: 'semantic',
    },
    {
      german: "um eine Stelle",
      translated: "pentru un loc de muncă",
      tone: 'semantic',
    },
    {
      german: "Was ist ein Beispiel für Diskriminierung?",
      translated: "Care situație este discriminare?",
      tone: 'semantic',
    },
    {
      german: "Sie bekommt die Stelle",
      translated: "Nu primește postul",
      tone: 'semantic',
    },
    {
      german: "nur deshalb nicht",
      translated: "numai pentru că",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:277|ru": [
    {
      german: "Eine Frau",
      translated: "Женщина",
      tone: 'semantic',
    },
    {
      german: "die ein zweijähriges Kind hat",
      translated: "с двухлетним ребёнком",
      tone: 'semantic',
    },
    {
      german: "bewirbt sich",
      translated: "подаёт заявку",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "в Германии",
      tone: 'semantic',
    },
    {
      german: "um eine Stelle",
      translated: "на работу",
      tone: 'semantic',
    },
    {
      german: "Was ist ein Beispiel für Diskriminierung?",
      translated: "Что является примером дискриминации?",
      tone: 'semantic',
    },
    {
      german: "Sie bekommt die Stelle",
      translated: "Ей отказывают в должности",
      tone: 'semantic',
    },
    {
      german: "nur deshalb nicht",
      translated: "только потому",
      tone: 'semantic',
    },
    {
      german: "weil sie",
      translated: "что она",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:277|sq": [
    {
      german: "Eine Frau",
      translated: "Një grua",
      tone: 'semantic',
    },
    {
      german: "die ein zweijähriges Kind hat",
      translated: "me një fëmijë dyvjeçar",
      tone: 'semantic',
    },
    {
      german: "bewirbt sich",
      translated: "aplikon",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "për punë",
      tone: 'semantic',
    },
    {
      german: "um eine Stelle",
      translated: "Cila situatë",
      tone: 'semantic',
    },
    {
      german: "Was ist ein Beispiel für Diskriminierung?",
      translated: "diskriminim",
      tone: 'semantic',
    },
    {
      german: "Sie bekommt die Stelle",
      translated: "Nuk e merr vendin vetëm",
      tone: 'semantic',
    },
    {
      german: "nur deshalb nicht",
      translated: "sepse",
      tone: 'semantic',
    },
    {
      german: "weil sie",
      translated: "…",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:277|sr": [
    {
      german: "Eine Frau",
      translated: "Žena",
      tone: 'semantic',
    },
    {
      german: "die ein zweijähriges Kind hat",
      translated: "s dvogodišnjim djetetom",
      tone: 'semantic',
    },
    {
      german: "bewirbt sich",
      translated: "prijavljuje se",
      tone: 'semantic',
    },
    {
      german: "um eine Stelle",
      translated: "za posao",
      tone: 'semantic',
    },
    {
      german: "Was ist ein Beispiel für Diskriminierung?",
      translated: "Koja je situacija diskriminacija?",
      tone: 'semantic',
    },
    {
      german: "Sie bekommt die Stelle",
      translated: "Ne dobiva posao",
      tone: 'semantic',
    },
    {
      german: "nur deshalb nicht",
      translated: "isključivo zato šta",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:277|tr": [
    {
      german: "Eine Frau",
      translated: "bir kadın",
      tone: 'semantic',
    },
    {
      german: "die ein zweijähriges Kind hat",
      translated: "İki yaşında çocuğu olan",
      tone: 'semantic',
    },
    {
      german: "bewirbt sich",
      translated: "başvuruyor",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "Almanya'da",
      tone: 'semantic',
    },
    {
      german: "um eine Stelle",
      translated: "işe",
      tone: 'semantic',
    },
    {
      german: "Was ist ein Beispiel für Diskriminierung?",
      translated: "Aşağıdakilerden hangisi ayrımcılığa örnektir?",
      tone: 'semantic',
    },
    {
      german: "Sie bekommt die Stelle",
      translated: "alınmıyor",
      tone: 'semantic',
    },
    {
      german: "nur deshalb nicht",
      translated: "yalnızca",
      tone: 'semantic',
    },
    {
      german: "weil sie",
      translated: "olduğu için",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:277|uk": [
    {
      german: "Eine Frau",
      translated: "Жінка",
      tone: 'semantic',
    },
    {
      german: "die ein zweijähriges Kind hat",
      translated: "яка має дворічну дитину",
      tone: 'semantic',
    },
    {
      german: "bewirbt sich",
      translated: "подає",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "в Німеччині",
      tone: 'semantic',
    },
    {
      german: "um eine Stelle",
      translated: "заявку на роботу",
      tone: 'semantic',
    },
    {
      german: "Was ist ein Beispiel für Diskriminierung?",
      translated: "Що є прикладом дискримінації?",
      tone: 'semantic',
    },
    {
      german: "Sie bekommt die Stelle",
      translated: "Вона не отримує роботу",
      tone: 'semantic',
    },
    {
      german: "nur deshalb nicht",
      translated: "лише тому",
      tone: 'semantic',
    },
    {
      german: "weil sie",
      translated: "що …",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:277|vi": [
    {
      german: "Eine Frau",
      translated: "Một phụ nữ",
      tone: 'semantic',
    },
    {
      german: "die ein zweijähriges Kind hat",
      translated: "có con hai tuổi",
      tone: 'semantic',
    },
    {
      german: "bewirbt sich",
      translated: "xin việc",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "ở Đức",
      tone: 'semantic',
    },
    {
      german: "Was ist ein Beispiel für Diskriminierung?",
      translated: "Trường hợp nào là phân biệt đối xử?",
      tone: 'semantic',
    },
    {
      german: "Sie bekommt die Stelle",
      translated: "Cô không được nhận",
      tone: 'semantic',
    },
    {
      german: "nur deshalb nicht",
      translated: "chỉ vì",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:278|ar": [
    {
      german: "Ein Mann im Rollstuhl",
      translated: "تقدم رجل يستخدم كرسيًا متحركًا",
      tone: 'semantic',
    },
    {
      german: "hat sich auf eine Stelle als Buchhalter beworben",
      translated: "لوظيفة محاسب",
      tone: 'semantic',
    },
    {
      german: "Was ist ein Beispiel für Diskriminierung",
      translated: "ما مثال على التمييز",
      tone: 'semantic',
    },
    {
      german: "Er bekommt die Stelle nur deshalb nicht",
      translated: "لا يحصل على الوظيفة",
      tone: 'semantic',
    },
    {
      german: "weil er",
      translated: "فقط لأنه …",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:278|bg": [
    {
      german: "Ein Mann im Rollstuhl",
      translated: "Мъж в инвалидна количка",
      tone: 'semantic',
    },
    {
      german: "hat sich auf eine Stelle als Buchhalter beworben",
      translated: "кандидатства за работа като счетоводител",
      tone: 'semantic',
    },
    {
      german: "Was ist ein Beispiel für Diskriminierung",
      translated: "Кое е дискриминация?",
      tone: 'semantic',
    },
    {
      german: "Er bekommt die Stelle nur deshalb nicht",
      translated: "Не получава работата само защото",
      tone: 'semantic',
    },
    {
      german: "weil er",
      translated: "…",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:278|bs": [
    {
      german: "Ein Mann im Rollstuhl",
      translated: "Muškarac u invalidskim kolicima",
      tone: 'semantic',
    },
    {
      german: "hat sich auf eine Stelle als Buchhalter beworben",
      translated: "prijavljuje se za posao knjigovođe",
      tone: 'semantic',
    },
    {
      german: "Was ist ein Beispiel für Diskriminierung",
      translated: "Koja je situacija diskriminacija",
      tone: 'semantic',
    },
    {
      german: "Er bekommt die Stelle nur deshalb nicht",
      translated: "Ne dobiva posao isključivo zato što",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:278|el": [
    {
      german: "Ein Mann im Rollstuhl",
      translated: "Ένας άνδρας σε αναπηρικό αμαξίδιο",
      tone: 'semantic',
    },
    {
      german: "hat sich auf eine Stelle als Buchhalter beworben",
      translated: "κάνει αίτηση για θέση λογιστή",
      tone: 'semantic',
    },
    {
      german: "Was ist ein Beispiel für Diskriminierung",
      translated: " Ποια περίπτωση είναι διάκριση;",
      tone: 'semantic',
    },
    {
      german: "Er bekommt die Stelle nur deshalb nicht",
      translated: "Δεν παίρνει τη δουλειά μόνο επειδή",
      tone: 'semantic',
    },
    {
      german: "weil er",
      translated: "…",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:278|en": [
    {
      german: "Ein Mann im Rollstuhl",
      translated: "A man in a wheelchair",
      tone: 'semantic',
    },
    {
      german: "hat sich auf eine Stelle als Buchhalter beworben",
      translated: "has applied for a job as an accountant",
      tone: 'semantic',
    },
    {
      german: "Was ist ein Beispiel für Diskriminierung",
      translated: "What is an example of discrimination",
      tone: 'semantic',
    },
    {
      german: "Er bekommt die Stelle nur deshalb nicht",
      translated: "He doesn't get the job only",
      tone: 'semantic',
    },
    {
      german: "weil er",
      translated: "because he",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:278|es": [
    {
      german: "Ein Mann im Rollstuhl",
      translated: "Un hombre que utiliza silla de ruedas",
      tone: 'semantic',
    },
    {
      german: "hat sich auf eine Stelle als Buchhalter beworben",
      translated: "solicita un empleo como contable",
      tone: 'semantic',
    },
    {
      german: "Was ist ein Beispiel für Diskriminierung",
      translated: "¿Qué sería un ejemplo de discriminación?",
      tone: 'semantic',
    },
    {
      german: "Er bekommt die Stelle nur deshalb nicht",
      translated: "No obtiene el empleo únicamente porque …",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:278|fa": [
    {
      german: "Ein Mann im Rollstuhl",
      translated: "مردی که از ویلچر استفاده می‌کند",
      tone: 'semantic',
    },
    {
      german: "hat sich auf eine Stelle als Buchhalter beworben",
      translated: "برای شغل حسابداری درخواست داده است",
      tone: 'semantic',
    },
    {
      german: "Was ist ein Beispiel für Diskriminierung",
      translated: "کدام مورد نمونهٔ تبعیض است",
      tone: 'semantic',
    },
    {
      german: "Er bekommt die Stelle nur deshalb nicht",
      translated: "فقط به این دلیل شغل را نمی‌گیرد",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:278|fr": [
    {
      german: "Ein Mann im Rollstuhl",
      translated: "Un homme en fauteuil roulant",
      tone: 'semantic',
    },
    {
      german: "hat sich auf eine Stelle als Buchhalter beworben",
      translated: "postule à un poste de comptable",
      tone: 'semantic',
    },
    {
      german: "Was ist ein Beispiel für Diskriminierung",
      translated: "Quel serait un exemple de discrimination",
      tone: 'semantic',
    },
    {
      german: "Er bekommt die Stelle nur deshalb nicht",
      translated: "Il n’obtient pas le poste uniquement",
      tone: 'semantic',
    },
    {
      german: "weil er",
      translated: "parce qu’il",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:278|hr": [
    {
      german: "Ein Mann im Rollstuhl",
      translated: "Muškarac u invalidskim kolicima",
      tone: 'semantic',
    },
    {
      german: "hat sich auf eine Stelle als Buchhalter beworben",
      translated: "prijavljuje se za posao knjigovođe",
      tone: 'semantic',
    },
    {
      german: "Was ist ein Beispiel für Diskriminierung",
      translated: "Koja je situacija diskriminacija",
      tone: 'semantic',
    },
    {
      german: "Er bekommt die Stelle nur deshalb nicht",
      translated: "Ne dobiva posao isključivo zato što",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:278|it": [
    {
      german: "Ein Mann im Rollstuhl",
      translated: "Un uomo in sedia a rotelle",
      tone: 'semantic',
    },
    {
      german: "hat sich auf eine Stelle als Buchhalter beworben",
      translated: "si candida come contabile",
      tone: 'semantic',
    },
    {
      german: "Was ist ein Beispiel für Diskriminierung",
      translated: "Quale situazione è discriminazione",
      tone: 'semantic',
    },
    {
      german: "Er bekommt die Stelle nur deshalb nicht",
      translated: "Non ottiene il posto solo perché",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:278|kmr": [
    {
      german: "Ein Mann im Rollstuhl",
      translated: "Mêrek li kursiya tekerlekî",
      tone: 'semantic',
    },
    {
      german: "hat sich auf eine Stelle als Buchhalter beworben",
      translated: "ji bo karê muhasebecî serlêdide",
      tone: 'semantic',
    },
    {
      german: "Was ist ein Beispiel für Diskriminierung",
      translated: "Kîjan mînak cudakarî ye",
      tone: 'semantic',
    },
    {
      german: "Er bekommt die Stelle nur deshalb nicht",
      translated: "Ew karê tenê",
      tone: 'semantic',
    },
    {
      german: "weil er",
      translated: "ji ber ku",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:278|pl": [
    {
      german: "Ein Mann im Rollstuhl",
      translated: "Mężczyzna poruszający się na wózku inwalidzkim",
      tone: 'semantic',
    },
    {
      german: "hat sich auf eine Stelle als Buchhalter beworben",
      translated: "ubiega się o pracę księgowego",
      tone: 'semantic',
    },
    {
      german: "Was ist ein Beispiel für Diskriminierung",
      translated: "Która sytuacja jest dyskryminacją",
      tone: 'semantic',
    },
    {
      german: "Er bekommt die Stelle nur deshalb nicht",
      translated: "Nie otrzymuje pracy wyłącznie dlatego, że",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:278|prs": [
    {
      german: "Ein Mann im Rollstuhl",
      translated: "مردی که از ویلچر استفاده می‌کند",
      tone: 'semantic',
    },
    {
      german: "hat sich auf eine Stelle als Buchhalter beworben",
      translated: "برای شغل حسابداری درخواست داده است",
      tone: 'semantic',
    },
    {
      german: "Was ist ein Beispiel für Diskriminierung",
      translated: "کدام مورد نمونهٔ تبعیض است",
      tone: 'semantic',
    },
    {
      german: "Er bekommt die Stelle nur deshalb nicht",
      translated: "شغل را نمی‌گیرد که",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:278|ro": [
    {
      german: "Ein Mann im Rollstuhl",
      translated: "Un bărbat în scaun cu rotile",
      tone: 'semantic',
    },
    {
      german: "hat sich auf eine Stelle als Buchhalter beworben",
      translated: "candidează pentru un post de contabil",
      tone: 'semantic',
    },
    {
      german: "Was ist ein Beispiel für Diskriminierung",
      translated: "Care situație este discriminare?",
      tone: 'semantic',
    },
    {
      german: "Er bekommt die Stelle nur deshalb nicht",
      translated: "Nu primește postul numai",
      tone: 'semantic',
    },
    {
      german: "weil er",
      translated: "pentru că …",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:278|ru": [
    {
      german: "Ein Mann im Rollstuhl",
      translated: "Мужчина в инвалидной коляске",
      tone: 'semantic',
    },
    {
      german: "hat sich auf eine Stelle als Buchhalter beworben",
      translated: "подал заявку на должность бухгалтера",
      tone: 'semantic',
    },
    {
      german: "Was ist ein Beispiel für Diskriminierung",
      translated: "Что является примером дискриминации",
      tone: 'semantic',
    },
    {
      german: "Er bekommt die Stelle nur deshalb nicht",
      translated: "Ему отказывают в должности только потому, что",
      tone: 'semantic',
    },
    {
      german: "weil er",
      translated: "он …",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:278|sq": [
    {
      german: "Ein Mann im Rollstuhl",
      translated: "Një burrë në karrige me rrota",
      tone: 'semantic',
    },
    {
      german: "hat sich auf eine Stelle als Buchhalter beworben",
      translated: "si kontabilist",
      tone: 'semantic',
    },
    {
      german: "Was ist ein Beispiel für Diskriminierung",
      translated: "Cila situatë është diskriminim",
      tone: 'semantic',
    },
    {
      german: "Er bekommt die Stelle nur deshalb nicht",
      translated: "Nuk e merr vendin vetëm sepse",
      tone: 'semantic',
    },
    {
      german: "weil er",
      translated: "…",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:278|sr": [
    {
      german: "Ein Mann im Rollstuhl",
      translated: "Muškarac u invalidskim kolicima",
      tone: 'semantic',
    },
    {
      german: "hat sich auf eine Stelle als Buchhalter beworben",
      translated: "prijavljuje se za posao knjigovođe",
      tone: 'semantic',
    },
    {
      german: "Was ist ein Beispiel für Diskriminierung",
      translated: "Koja je situacija diskriminacija",
      tone: 'semantic',
    },
    {
      german: "Er bekommt die Stelle nur deshalb nicht",
      translated: "Ne dobiva posao isključivo zato šta",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:278|tr": [
    {
      german: "Ein Mann im Rollstuhl",
      translated: "Tekerlekli sandalye kullanan bir erkek",
      tone: 'semantic',
    },
    {
      german: "hat sich auf eine Stelle als Buchhalter beworben",
      translated: "muhasebecilik işine başvuruyor",
      tone: 'semantic',
    },
    {
      german: "Was ist ein Beispiel für Diskriminierung",
      translated: "Aşağıdakilerden hangisi ayrımcılığa örnektir",
      tone: 'semantic',
    },
    {
      german: "weil er",
      translated: "olduğu için",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:278|uk": [
    {
      german: "Ein Mann im Rollstuhl",
      translated: "Чоловік у кріслі колісному",
      tone: 'semantic',
    },
    {
      german: "hat sich auf eine Stelle als Buchhalter beworben",
      translated: "подав заявку на посаду бухгалтера",
      tone: 'semantic',
    },
    {
      german: "Was ist ein Beispiel für Diskriminierung",
      translated: "Що є прикладом дискримінації?",
      tone: 'semantic',
    },
    {
      german: "Er bekommt die Stelle nur deshalb nicht",
      translated: "Він не отримує роботу лише тому,",
      tone: 'semantic',
    },
    {
      german: "weil er",
      translated: "що …",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:278|vi": [
    {
      german: "Ein Mann im Rollstuhl",
      translated: "Một người đàn ông ngồi xe lăn",
      tone: 'semantic',
    },
    {
      german: "hat sich auf eine Stelle als Buchhalter beworben",
      translated: "xin việc kế toán",
      tone: 'semantic',
    },
    {
      german: "Was ist ein Beispiel für Diskriminierung",
      translated: "Trường hợp nào là phân biệt đối xử",
      tone: 'semantic',
    },
    {
      german: "Er bekommt die Stelle nur deshalb nicht",
      translated: "Anh không được nhận",
      tone: 'semantic',
    },
    {
      german: "weil er",
      translated: "chỉ vì …",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:279|ar": [
    {
      german: "In den meisten Mietshäusern in Deutschland",
      translated: "في معظم المباني السكنية المؤجرة في ألمانيا",
      tone: 'semantic',
    },
    {
      german: "gibt es eine \"Hausordnung\"",
      translated: "توجد «لائحة منزلية» (Hausordnung)",
      tone: 'semantic',
    },
    {
      german: "Was steht in einer solchen \"Hausordnung\"?",
      translated: "ماذا تتضمن هذه اللائحة؟",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:279|bg": [
    {
      german: "In den meisten Mietshäusern in Deutschland",
      translated: "В повечето жилищни сгради под наем има",
      tone: 'semantic',
    },
    {
      german: "gibt es eine \"Hausordnung\"",
      translated: "„Hausordnung“.",
      tone: 'semantic',
    },
    {
      german: "Was steht in einer solchen \"Hausordnung\"?",
      translated: "Какво съдържа той?",
      tone: 'semantic',
    },
    {
      german: "Sie nennt …",
      translated: "Той посочва …",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:279|bs": [
    {
      german: "In den meisten Mietshäusern in Deutschland",
      translated: "U većini stambenih zgrada za najam u Njemačkoj",
      tone: 'semantic',
    },
    {
      german: "gibt es eine \"Hausordnung\"",
      translated: "postoji „Hausordnung“",
      tone: 'semantic',
    },
    {
      german: "Was steht in einer solchen \"Hausordnung\"?",
      translated: "Što ona sadrži",
      tone: 'semantic',
    },
    {
      german: "Sie nennt …",
      translated: "Ona navodi …",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:279|el": [
    {
      german: "In den meisten Mietshäusern in Deutschland",
      translated: "Στα περισσότερα ενοικιαζόμενα κτίρια στη Γερμανία",
      tone: 'semantic',
    },
    {
      german: "gibt es eine \"Hausordnung\"",
      translated: "υπάρχει «Hausordnung»",
      tone: 'semantic',
    },
    {
      german: "Was steht in einer solchen \"Hausordnung\"?",
      translated: "Τι περιλαμβάνει;",
      tone: 'semantic',
    },
    {
      german: "Sie nennt …",
      translated: "Αναφέρει …",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:279|en": [
    {
      german: "In den meisten Mietshäusern in Deutschland",
      translated: "In most apartment buildings in Germany",
      tone: 'semantic',
    },
    {
      german: "gibt es eine \"Hausordnung\"",
      translated: "there is a 'house rules' document",
      tone: 'semantic',
    },
    {
      german: "Was steht in einer solchen \"Hausordnung\"?",
      translated: "What does such a 'house rules' document contain",
      tone: 'semantic',
    },
    {
      german: "Sie nennt …",
      translated: "It lists …",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:279|es": [
    {
      german: "In den meisten Mietshäusern in Deutschland",
      translated: "En la mayoría de los edificios de viviendas de alquiler en Alemania",
      tone: 'semantic',
    },
    {
      german: "gibt es eine \"Hausordnung\"",
      translated: "hay un «reglamento de la casa»",
      tone: 'semantic',
    },
    {
      german: "Was steht in einer solchen \"Hausordnung\"?",
      translated: "¿Qué contiene?",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:279|fa": [
    {
      german: "In den meisten Mietshäusern in Deutschland",
      translated: "در بیشتر ساختمان‌های اجاره‌ای آلمان",
      tone: 'semantic',
    },
    {
      german: "gibt es eine \"Hausordnung\"",
      translated: "«Hausordnung» وجود دارد",
      tone: 'semantic',
    },
    {
      german: "Was steht in einer solchen \"Hausordnung\"?",
      translated: "در آن چه نوشته می‌شود؟",
      tone: 'semantic',
    },
    {
      german: "Sie nennt …",
      translated: "این مقررات شامل … است",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:279|fr": [
    {
      german: "In den meisten Mietshäusern in Deutschland",
      translated: "Dans la plupart des immeubles locatifs en Allemagne",
      tone: 'semantic',
    },
    {
      german: "gibt es eine \"Hausordnung\"",
      translated: "il existe un « règlement intérieur » (Hausordnung)",
      tone: 'semantic',
    },
    {
      german: "Was steht in einer solchen \"Hausordnung\"?",
      translated: "Que contient-il ?",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:279|hr": [
    {
      german: "In den meisten Mietshäusern in Deutschland",
      translated: "U većini stambenih zgrada za najam u Njemačkoj",
      tone: 'semantic',
    },
    {
      german: "gibt es eine \"Hausordnung\"",
      translated: "postoji „Hausordnung“",
      tone: 'semantic',
    },
    {
      german: "Was steht in einer solchen \"Hausordnung\"?",
      translated: "Što ona sadrži",
      tone: 'semantic',
    },
    {
      german: "Sie nennt …",
      translated: "Ona navodi …",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:279|it": [
    {
      german: "In den meisten Mietshäusern in Deutschland",
      translated: "Nella maggior parte degli edifici in affitto in Germania",
      tone: 'semantic',
    },
    {
      german: "gibt es eine \"Hausordnung\"",
      translated: "esiste un «Hausordnung»",
      tone: 'semantic',
    },
    {
      german: "Was steht in einer solchen \"Hausordnung\"?",
      translated: "Che cosa contiene?",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:279|kmr": [
    {
      german: "In den meisten Mietshäusern in Deutschland",
      translated: "Di piraniya malên kirê li Almanyayê",
      tone: 'semantic',
    },
    {
      german: "gibt es eine \"Hausordnung\"",
      translated: "«Hausordnung» heye",
      tone: 'semantic',
    },
    {
      german: "Was steht in einer solchen \"Hausordnung\"?",
      translated: "Di wê de çi heye",
      tone: 'semantic',
    },
    {
      german: "Sie nennt …",
      translated: "Ew … destnîşan dike",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:279|pl": [
    {
      german: "In den meisten Mietshäusern in Deutschland",
      translated: "W większości wynajmowanych budynków mieszkalnych",
      tone: 'semantic',
    },
    {
      german: "gibt es eine \"Hausordnung\"",
      translated: "„Hausordnung”",
      tone: 'semantic',
    },
    {
      german: "Was steht in einer solchen \"Hausordnung\"?",
      translated: "Co zawiera?",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:279|prs": [
    {
      german: "In den meisten Mietshäusern in Deutschland",
      translated: "در بیشتر ساختمان‌های اجاره‌ای آلمان",
      tone: 'semantic',
    },
    {
      german: "gibt es eine \"Hausordnung\"",
      translated: "«Hausordnung» وجود دارد",
      tone: 'semantic',
    },
    {
      german: "Was steht in einer solchen \"Hausordnung\"?",
      translated: "در آن چه نوشته می‌شود؟",
      tone: 'semantic',
    },
    {
      german: "Sie nennt …",
      translated: "در آن … ذکر می‌شود",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:279|ro": [
    {
      german: "In den meisten Mietshäusern in Deutschland",
      translated: "În majoritatea clădirilor de locuințe închiriate din Germania",
      tone: 'semantic',
    },
    {
      german: "gibt es eine \"Hausordnung\"",
      translated: "există un „Hausordnung”",
      tone: 'semantic',
    },
    {
      german: "Was steht in einer solchen \"Hausordnung\"?",
      translated: "Ce conține un astfel de „Hausordnung”",
      tone: 'semantic',
    },
    {
      german: "Sie nennt …",
      translated: "Acesta menționează …",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:279|ru": [
    {
      german: "In den meisten Mietshäusern in Deutschland",
      translated: "В большинстве съёмных домов в Германии",
      tone: 'semantic',
    },
    {
      german: "gibt es eine \"Hausordnung\"",
      translated: "«домовой распорядок»",
      tone: 'semantic',
    },
    {
      german: "Was steht in einer solchen \"Hausordnung\"?",
      translated: "Что в нём указано?",
      tone: 'semantic',
    },
    {
      german: "Sie nennt …",
      translated: "Он определяет …",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:279|sq": [
    {
      german: "In den meisten Mietshäusern in Deutschland",
      translated: "Në shumicën e ndërtesave me qira në Gjermani",
      tone: 'semantic',
    },
    {
      german: "gibt es eine \"Hausordnung\"",
      translated: "ka një «Hausordnung»",
      tone: 'semantic',
    },
    {
      german: "Was steht in einer solchen \"Hausordnung\"?",
      translated: "Çfarë",
      tone: 'semantic',
    },
    {
      german: "Sie nennt …",
      translated: "përmban ai",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:279|sr": [
    {
      german: "In den meisten Mietshäusern in Deutschland",
      translated: "U većini stambenih zgrada za najam u Nemačkoj",
      tone: 'semantic',
    },
    {
      german: "gibt es eine \"Hausordnung\"",
      translated: "postoji „Hausordnung“",
      tone: 'semantic',
    },
    {
      german: "Was steht in einer solchen \"Hausordnung\"?",
      translated: "Šta ona sadrži",
      tone: 'semantic',
    },
    {
      german: "Sie nennt …",
      translated: "Ona navodi …",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:279|tr": [
    {
      german: "In den meisten Mietshäusern in Deutschland",
      translated: "Almanya'daki çoğu kiralık apartmanda",
      tone: 'semantic',
    },
    {
      german: "gibt es eine \"Hausordnung\"",
      translated: "bir \"bina düzeni\" (Hausordnung) vardır",
      tone: 'semantic',
    },
    {
      german: "Was steht in einer solchen \"Hausordnung\"?",
      translated: "Burada ne yazar?",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:279|uk": [
    {
      german: "In den meisten Mietshäusern in Deutschland",
      translated: "У більшості орендних будинків Німеччини",
      tone: 'semantic',
    },
    {
      german: "gibt es eine \"Hausordnung\"",
      translated: "існують «правила будинку»",
      tone: 'semantic',
    },
    {
      german: "Was steht in einer solchen \"Hausordnung\"?",
      translated: "Що містять такі правила?",
      tone: 'semantic',
    },
    {
      german: "Sie nennt …",
      translated: "Вони визначають …",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:279|vi": [
    {
      german: "In den meisten Mietshäusern in Deutschland",
      translated: "Trong phần lớn các tòa nhà cho thuê ở Đức",
      tone: 'semantic',
    },
    {
      german: "gibt es eine \"Hausordnung\"",
      translated: "có “Hausordnung”",
      tone: 'semantic',
    },
    {
      german: "Was steht in einer solchen \"Hausordnung\"?",
      translated: "Trong đó có gì?",
      tone: 'semantic',
    },
    {
      german: "Sie nennt …",
      translated: "Nó quy định …",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:27|ar": [
    {
      german: "Deutschland",
      translated: "ألمانيا",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:27|bg": [
    {
      german: "Deutschland",
      translated: "Германия",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:27|bs": [
    {
      german: "Deutschland",
      translated: "Njemačka",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "je",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:27|el": [
    {
      german: "Deutschland",
      translated: "Η Γερμανία",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "είναι",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:27|en": [
    {
      german: "Deutschland",
      translated: "Germany",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "is",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:27|es": [
    {
      german: "Deutschland",
      translated: "Alemania",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "es",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:27|fa": [
    {
      german: "Deutschland",
      translated: "آلمان",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:27|fr": [
    {
      german: "Deutschland",
      translated: "L’Allemagne",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:27|hr": [
    {
      german: "Deutschland",
      translated: "Njemačka",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "je",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:27|it": [
    {
      german: "Deutschland",
      translated: "La Germania",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "è",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:27|kmr": [
    {
      german: "Deutschland",
      translated: "Almanya",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:27|pl": [
    {
      german: "Deutschland",
      translated: "Niemcy",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "są",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:27|prs": [
    {
      german: "Deutschland",
      translated: "آلمان",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "است",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:27|ro": [
    {
      german: "Deutschland",
      translated: "Germania",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:27|ru": [
    {
      german: "Deutschland",
      translated: "Германия",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:27|sq": [
    {
      german: "Deutschland",
      translated: "Gjermania",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "është",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:27|sr": [
    {
      german: "Deutschland",
      translated: "Nemačka",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "je",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:27|tr": [
    {
      german: "Deutschland",
      translated: "Almanya",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:27|uk": [
    {
      german: "Deutschland",
      translated: "Німеччина",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "є",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:27|vi": [
    {
      german: "Deutschland",
      translated: "Đức",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "là",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:280|ar": [
    {
      german: "Wenn Sie sich",
      translated: "إذا أردت",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "في ألمانيا",
      tone: 'semantic',
    },
    {
      german: "gegen einen falschen Steuerbescheid",
      translated: "على قرار ضريبي خاطئ",
      tone: 'semantic',
    },
    {
      german: "wehren wollen",
      translated: "الاعتراض",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:280|bg": [
    {
      german: "Wenn Sie sich",
      translated: "Ако искате",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "в Германия",
      tone: 'semantic',
    },
    {
      german: "gegen einen falschen Steuerbescheid",
      translated: "да оспорите неправилно данъчно решение",
      tone: 'semantic',
    },
    {
      german: "müssen Sie",
      translated: "трябва да",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:280|bs": [
    {
      german: "Wenn Sie sich",
      translated: "Ako želite",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "u Njemačkoj",
      tone: 'semantic',
    },
    {
      german: "gegen einen falschen Steuerbescheid",
      translated: "pogrešno porezno rješenje",
      tone: 'semantic',
    },
    {
      german: "wehren wollen",
      translated: "osporiti",
      tone: 'semantic',
    },
    {
      german: "müssen Sie",
      translated: "morate",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:280|el": [
    {
      german: "Wenn Sie sich",
      translated: "Αν θέλετε",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "στη Γερμανία",
      tone: 'semantic',
    },
    {
      german: "gegen einen falschen Steuerbescheid",
      translated: "να προσβάλετε μια λανθασμένη φορολογική απόφαση",
      tone: 'semantic',
    },
    {
      german: "müssen Sie",
      translated: "πρέπει να",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:280|en": [
    {
      german: "Wenn Sie sich",
      translated: "If you",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "in Germany",
      tone: 'semantic',
    },
    {
      german: "gegen einen falschen Steuerbescheid",
      translated: "an incorrect tax assessment",
      tone: 'semantic',
    },
    {
      german: "wehren wollen",
      translated: "want to dispute",
      tone: 'semantic',
    },
    {
      german: "müssen Sie",
      translated: "you must",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:280|es": [
    {
      german: "Wenn Sie sich",
      translated: "Si",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "en Alemania",
      tone: 'semantic',
    },
    {
      german: "gegen einen falschen Steuerbescheid",
      translated: "una liquidación fiscal incorrecta",
      tone: 'semantic',
    },
    {
      german: "wehren wollen",
      translated: "quieres impugnar",
      tone: 'semantic',
    },
    {
      german: "müssen Sie",
      translated: "debes",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:280|fa": [
    {
      german: "Wenn Sie sich",
      translated: "اگر",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "در آلمان",
      tone: 'semantic',
    },
    {
      german: "müssen Sie",
      translated: "باید",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:280|fr": [
    {
      german: "Wenn Sie sich",
      translated: "Si vous voulez",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "en Allemagne",
      tone: 'semantic',
    },
    {
      german: "gegen einen falschen Steuerbescheid",
      translated: "un avis d’imposition erroné",
      tone: 'semantic',
    },
    {
      german: "wehren wollen",
      translated: "contester",
      tone: 'semantic',
    },
    {
      german: "müssen Sie",
      translated: "vous devez",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:280|hr": [
    {
      german: "Wenn Sie sich",
      translated: "Ako",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "u Njemačkoj",
      tone: 'semantic',
    },
    {
      german: "gegen einen falschen Steuerbescheid",
      translated: "pogrešno porezno rješenje",
      tone: 'semantic',
    },
    {
      german: "wehren wollen",
      translated: "želite osporiti",
      tone: 'semantic',
    },
    {
      german: "müssen Sie",
      translated: "morate",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:280|it": [
    {
      german: "Wenn Sie sich",
      translated: "Se volete",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "in Germania",
      tone: 'semantic',
    },
    {
      german: "gegen einen falschen Steuerbescheid",
      translated: "un avviso fiscale errato",
      tone: 'semantic',
    },
    {
      german: "wehren wollen",
      translated: "contestare",
      tone: 'semantic',
    },
    {
      german: "müssen Sie",
      translated: "dovete",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:280|kmr": [
    {
      german: "Wenn Sie sich",
      translated: "Heke dixwazî",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "li dijî biryara",
      tone: 'semantic',
    },
    {
      german: "gegen einen falschen Steuerbescheid",
      translated: "bacê ya xelet derkevî",
      tone: 'semantic',
    },
    {
      german: "wehren wollen",
      translated: "divê",
      tone: 'semantic',
    },
    {
      german: "müssen Sie",
      translated: "…",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:280|pl": [
    {
      german: "Wenn Sie sich",
      translated: "Jeżeli",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "w Niemczech",
      tone: 'semantic',
    },
    {
      german: "gegen einen falschen Steuerbescheid",
      translated: "błędną decyzję podatkową",
      tone: 'semantic',
    },
    {
      german: "wehren wollen",
      translated: "chcecie zaskarżyć",
      tone: 'semantic',
    },
    {
      german: "müssen Sie",
      translated: "musicie",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:280|prs": [
    {
      german: "Wenn Sie sich",
      translated: "اگر",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "در آلمان",
      tone: 'semantic',
    },
    {
      german: "gegen einen falschen Steuerbescheid",
      translated: "به برگهٔ مالیاتی اشتباه",
      tone: 'semantic',
    },
    {
      german: "wehren wollen",
      translated: "اعتراض کنید",
      tone: 'semantic',
    },
    {
      german: "müssen Sie",
      translated: "باید",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:280|ro": [
    {
      german: "Wenn Sie sich",
      translated: "Dacă vreți",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "în Germania",
      tone: 'semantic',
    },
    {
      german: "gegen einen falschen Steuerbescheid",
      translated: "o decizie fiscală greșită",
      tone: 'semantic',
    },
    {
      german: "wehren wollen",
      translated: "să contestați",
      tone: 'semantic',
    },
    {
      german: "müssen Sie",
      translated: "trebuie să",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:280|ru": [
    {
      german: "Wenn Sie sich",
      translated: "Если вы",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "в Германии",
      tone: 'semantic',
    },
    {
      german: "gegen einen falschen Steuerbescheid",
      translated: "оспорить неверное налоговое уведомление",
      tone: 'semantic',
    },
    {
      german: "wehren wollen",
      translated: "хотите",
      tone: 'semantic',
    },
    {
      german: "müssen Sie",
      translated: "вы должны",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:280|sq": [
    {
      german: "Wenn Sie sich",
      translated: "Nëse",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "në Gjermani",
      tone: 'semantic',
    },
    {
      german: "gegen einen falschen Steuerbescheid",
      translated: "një vendim tatimor të gabuar",
      tone: 'semantic',
    },
    {
      german: "wehren wollen",
      translated: "dëshironi të kundërshtoni",
      tone: 'semantic',
    },
    {
      german: "müssen Sie",
      translated: "duhet të",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:280|sr": [
    {
      german: "Wenn Sie sich",
      translated: "Ako",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "u Nemačkoj",
      tone: 'semantic',
    },
    {
      german: "gegen einen falschen Steuerbescheid",
      translated: "pogrešno poresko rješenje",
      tone: 'semantic',
    },
    {
      german: "wehren wollen",
      translated: "želite osporiti",
      tone: 'semantic',
    },
    {
      german: "müssen Sie",
      translated: "morate",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:280|tr": [
    {
      german: "in Deutschland",
      translated: "Almanya'da",
      tone: 'semantic',
    },
    {
      german: "gegen einen falschen Steuerbescheid",
      translated: "hatalı bir vergi kararına",
      tone: 'semantic',
    },
    {
      german: "wehren wollen",
      translated: "itiraz etmek istiyorsanız",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:280|uk": [
    {
      german: "Wenn Sie sich",
      translated: "Якщо ви",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "в Німеччині",
      tone: 'semantic',
    },
    {
      german: "gegen einen falschen Steuerbescheid",
      translated: "неправильне податкове рішення",
      tone: 'semantic',
    },
    {
      german: "wehren wollen",
      translated: "хочете оскаржити",
      tone: 'semantic',
    },
    {
      german: "müssen Sie",
      translated: "ви повинні",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:280|vi": [
    {
      german: "Wenn Sie sich",
      translated: "Nếu muốn",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "ở Đức",
      tone: 'semantic',
    },
    {
      german: "gegen einen falschen Steuerbescheid",
      translated: "phản đối một quyết định thuế sai",
      tone: 'semantic',
    },
    {
      german: "müssen Sie",
      translated: "bạn phải",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:281|ar": [
    {
      german: "Zwei Freunde",
      translated: "صديقان",
      tone: 'semantic',
    },
    {
      german: "wollen in ein öffentliches Schwimmbad",
      translated: "دخول مسبح عام",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "في ألمانيا",
      tone: 'semantic',
    },
    {
      german: "Welches Recht wird in dieser Situation verletzt",
      translated: "أي حق انتُهك",
      tone: 'semantic',
    },
    {
      german: "Das Recht auf",
      translated: "الحق في",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:281|bg": [
    {
      german: "Zwei Freunde",
      translated: "Двама приятели",
      tone: 'semantic',
    },
    {
      german: "wollen in ein öffentliches Schwimmbad",
      translated: "искат да отидат на обществен басейн",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "в Германия",
      tone: 'semantic',
    },
    {
      german: "Beide haben eine dunkle Hautfarbe",
      translated: "И двамата са с тъмна кожа",
      tone: 'semantic',
    },
    {
      german: "und werden deshalb nicht hineingelassen",
      translated: "и затова не са допуснати",
      tone: 'semantic',
    },
    {
      german: "Welches Recht wird in dieser Situation verletzt",
      translated: "Кое право е нарушено в тази ситуация",
      tone: 'semantic',
    },
    {
      german: "Das Recht auf",
      translated: "Правото на",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:281|bs": [
    {
      german: "Zwei Freunde",
      translated: "Dva prijatelja",
      tone: 'semantic',
    },
    {
      german: "wollen in ein öffentliches Schwimmbad",
      translated: "žele ići na javni bazen",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "u Njemačkoj",
      tone: 'semantic',
    },
    {
      german: "Beide haben eine dunkle Hautfarbe",
      translated: "Obojica imaju tamnu boju kože",
      tone: 'semantic',
    },
    {
      german: "und werden deshalb nicht hineingelassen",
      translated: "i zato im nije dopušten ulazak",
      tone: 'semantic',
    },
    {
      german: "Welches Recht wird in dieser Situation verletzt",
      translated: "Koje je pravo povrijeđeno u ovoj situaciji",
      tone: 'semantic',
    },
    {
      german: "Das Recht auf",
      translated: "Pravo na …",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:281|el": [
    {
      german: "Zwei Freunde",
      translated: "Δύο φίλοι",
      tone: 'semantic',
    },
    {
      german: "wollen in ein öffentliches Schwimmbad",
      translated: "θέλουν να πάνε σε δημόσια πισίνα",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "στη Γερμανία",
      tone: 'semantic',
    },
    {
      german: "Beide haben eine dunkle Hautfarbe",
      translated: "Και οι δύο έχουν σκούρο δέρμα",
      tone: 'semantic',
    },
    {
      german: "und werden deshalb nicht hineingelassen",
      translated: "γι’ αυτό δεν τους επιτρέπεται η είσοδος",
      tone: 'semantic',
    },
    {
      german: "Welches Recht wird in dieser Situation verletzt",
      translated: "Ποιο δικαίωμα παραβιάζεται σε αυτή την περίπτωση",
      tone: 'semantic',
    },
    {
      german: "Das Recht auf",
      translated: "Το δικαίωμα στην …",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:281|en": [
    {
      german: "Zwei Freunde",
      translated: "Two friends",
      tone: 'semantic',
    },
    {
      german: "wollen in ein öffentliches Schwimmbad",
      translated: "want to go to a public swimming pool",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "in Germany",
      tone: 'semantic',
    },
    {
      german: "Beide haben eine dunkle Hautfarbe",
      translated: "Both have dark skin",
      tone: 'semantic',
    },
    {
      german: "und werden deshalb nicht hineingelassen",
      translated: "and are therefore not allowed in",
      tone: 'semantic',
    },
    {
      german: "Welches Recht wird in dieser Situation verletzt",
      translated: "Which right is violated in this situation?",
      tone: 'semantic',
    },
    {
      german: "Das Recht auf",
      translated: "The right to",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:281|es": [
    {
      german: "Zwei Freunde",
      translated: "Dos amigos",
      tone: 'semantic',
    },
    {
      german: "wollen in ein öffentliches Schwimmbad",
      translated: "quieren entrar en una piscina pública",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "en Alemania",
      tone: 'semantic',
    },
    {
      german: "Beide haben eine dunkle Hautfarbe",
      translated: "Ambos tienen la piel oscura",
      tone: 'semantic',
    },
    {
      german: "und werden deshalb nicht hineingelassen",
      translated: "y por eso no se les permite entrar",
      tone: 'semantic',
    },
    {
      german: "Welches Recht wird in dieser Situation verletzt",
      translated: "¿Qué derecho se vulnera?",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:281|fa": [
    {
      german: "Zwei Freunde",
      translated: "دو دوست",
      tone: 'semantic',
    },
    {
      german: "wollen in ein öffentliches Schwimmbad",
      translated: "می‌خواهند وارد یک استخر عمومی",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "در آلمان",
      tone: 'semantic',
    },
    {
      german: "Beide haben eine dunkle Hautfarbe",
      translated: "با پوست تیره",
      tone: 'semantic',
    },
    {
      german: "und werden deshalb nicht hineingelassen",
      translated: "فقط به‌دلیل رنگ پوستشان اجازهٔ ورود نمی‌گیرند",
      tone: 'semantic',
    },
    {
      german: "Welches Recht wird in dieser Situation verletzt",
      translated: "کدام حق نقض شده است",
      tone: 'semantic',
    },
    {
      german: "Das Recht auf",
      translated: "حقِ …",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:281|fr": [
    {
      german: "Zwei Freunde",
      translated: "Deux amis",
      tone: 'semantic',
    },
    {
      german: "wollen in ein öffentliches Schwimmbad",
      translated: "veulent entrer dans une piscine publique",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "en Allemagne",
      tone: 'semantic',
    },
    {
      german: "Beide haben eine dunkle Hautfarbe",
      translated: "Tous deux ont la peau foncée",
      tone: 'semantic',
    },
    {
      german: "und werden deshalb nicht hineingelassen",
      translated: "et on leur refuse l’entrée pour cette raison",
      tone: 'semantic',
    },
    {
      german: "Welches Recht wird in dieser Situation verletzt",
      translated: "Quel droit est violé ?",
      tone: 'semantic',
    },
    {
      german: "Das Recht auf",
      translated: "Le droit à …",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:281|hr": [
    {
      german: "Zwei Freunde",
      translated: "Dva prijatelja",
      tone: 'semantic',
    },
    {
      german: "wollen in ein öffentliches Schwimmbad",
      translated: "žele ići na javni bazen",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "u Njemačkoj",
      tone: 'semantic',
    },
    {
      german: "Beide haben eine dunkle Hautfarbe",
      translated: "Obojica imaju tamnu boju kože",
      tone: 'semantic',
    },
    {
      german: "und werden deshalb nicht hineingelassen",
      translated: "i zato im nije dopušten ulazak",
      tone: 'semantic',
    },
    {
      german: "Welches Recht wird in dieser Situation verletzt",
      translated: "Koje je pravo povrijeđeno u ovoj situaciji",
      tone: 'semantic',
    },
    {
      german: "Das Recht auf",
      translated: "Pravo na …",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:281|it": [
    {
      german: "Zwei Freunde",
      translated: "Due amici",
      tone: 'semantic',
    },
    {
      german: "wollen in ein öffentliches Schwimmbad",
      translated: "in una piscina pubblica",
      tone: 'semantic',
    },
    {
      german: "Beide haben eine dunkle Hautfarbe",
      translated: "con la pelle scura",
      tone: 'semantic',
    },
    {
      german: "und werden deshalb nicht hineingelassen",
      translated: "non vengono fatti entrare",
      tone: 'semantic',
    },
    {
      german: "Welches Recht wird in dieser Situation verletzt",
      translated: "Quale diritto viene violato",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:281|kmr": [
    {
      german: "Zwei Freunde",
      translated: "Du heval",
      tone: 'semantic',
    },
    {
      german: "wollen in ein öffentliches Schwimmbad",
      translated: "biçin hewzeke giştî",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "li Almanyayê",
      tone: 'semantic',
    },
    {
      german: "Beide haben eine dunkle Hautfarbe",
      translated: "Her du jî çermê tarî hene",
      tone: 'semantic',
    },
    {
      german: "und werden deshalb nicht hineingelassen",
      translated: "û ji ber vê yekê nayên hiştin hundir",
      tone: 'semantic',
    },
    {
      german: "Welches Recht wird in dieser Situation verletzt",
      translated: "Di vê rewşê de kîjan maf tê binpêkirin",
      tone: 'semantic',
    },
    {
      german: "Das Recht auf",
      translated: "Mafê",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:281|pl": [
    {
      german: "Zwei Freunde",
      translated: "Dwóch przyjaciół",
      tone: 'semantic',
    },
    {
      german: "wollen in ein öffentliches Schwimmbad",
      translated: "chce pójść na publiczny basen",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "w Niemczech",
      tone: 'semantic',
    },
    {
      german: "Beide haben eine dunkle Hautfarbe",
      translated: "Obaj mają ciemną skórę",
      tone: 'semantic',
    },
    {
      german: "und werden deshalb nicht hineingelassen",
      translated: "i dlatego nie zostają wpuszczeni",
      tone: 'semantic',
    },
    {
      german: "Welches Recht wird in dieser Situation verletzt",
      translated: "Jakie prawo zostało naruszone w tej sytuacji",
      tone: 'semantic',
    },
    {
      german: "Das Recht auf",
      translated: "Prawo do …",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:281|prs": [
    {
      german: "Zwei Freunde",
      translated: "دو دوست",
      tone: 'semantic',
    },
    {
      german: "wollen in ein öffentliches Schwimmbad",
      translated: "می‌خواهند وارد یک استخر عمومی",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "در آلمان",
      tone: 'semantic',
    },
    {
      german: "Beide haben eine dunkle Hautfarbe",
      translated: "با پوست تیره",
      tone: 'semantic',
    },
    {
      german: "und werden deshalb nicht hineingelassen",
      translated: "فقط به‌دلیل رنگ پوستشان اجازهٔ ورود نمی‌گیرند",
      tone: 'semantic',
    },
    {
      german: "Welches Recht wird in dieser Situation verletzt",
      translated: "کدام حق نقض شده است",
      tone: 'semantic',
    },
    {
      german: "Das Recht auf",
      translated: "حقِ",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:281|ro": [
    {
      german: "Zwei Freunde",
      translated: "Doi prieteni",
      tone: 'semantic',
    },
    {
      german: "wollen in ein öffentliches Schwimmbad",
      translated: "într-o piscină publică",
      tone: 'semantic',
    },
    {
      german: "Beide haben eine dunkle Hautfarbe",
      translated: "cu pielea închisă la culoare",
      tone: 'semantic',
    },
    {
      german: "und werden deshalb nicht hineingelassen",
      translated: "nu sunt lăsați să intre",
      tone: 'semantic',
    },
    {
      german: "Welches Recht wird in dieser Situation verletzt",
      translated: "Ce drept este încălcat",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:281|ru": [
    {
      german: "Zwei Freunde",
      translated: "Два друга",
      tone: 'semantic',
    },
    {
      german: "wollen in ein öffentliches Schwimmbad",
      translated: "хотят пойти в общественный бассейн",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "в Германии",
      tone: 'semantic',
    },
    {
      german: "Beide haben eine dunkle Hautfarbe",
      translated: "У обоих тёмный цвет кожи",
      tone: 'semantic',
    },
    {
      german: "und werden deshalb nicht hineingelassen",
      translated: "из-за чего их туда не пускают",
      tone: 'semantic',
    },
    {
      german: "Welches Recht wird in dieser Situation verletzt",
      translated: "Какое право нарушается в этой ситуации?",
      tone: 'semantic',
    },
    {
      german: "Das Recht auf",
      translated: "Право на …",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:281|sq": [
    {
      german: "Zwei Freunde",
      translated: "Dy miq",
      tone: 'semantic',
    },
    {
      german: "wollen in ein öffentliches Schwimmbad",
      translated: "në një pishinë publike",
      tone: 'semantic',
    },
    {
      german: "Beide haben eine dunkle Hautfarbe",
      translated: "me lëkurë të errët",
      tone: 'semantic',
    },
    {
      german: "und werden deshalb nicht hineingelassen",
      translated: "nuk lejohen",
      tone: 'semantic',
    },
    {
      german: "Welches Recht wird in dieser Situation verletzt",
      translated: "Cila e drejtë shkelet?",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:281|sr": [
    {
      german: "Zwei Freunde",
      translated: "Dva prijatelja",
      tone: 'semantic',
    },
    {
      german: "wollen in ein öffentliches Schwimmbad",
      translated: "žele ići na javni bazen",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "u Nemačkoj",
      tone: 'semantic',
    },
    {
      german: "Beide haben eine dunkle Hautfarbe",
      translated: "Obojica imaju tamnu boju kože",
      tone: 'semantic',
    },
    {
      german: "und werden deshalb nicht hineingelassen",
      translated: "i zato im nije dozvoljen ulazak",
      tone: 'semantic',
    },
    {
      german: "Welches Recht wird in dieser Situation verletzt",
      translated: "Koje je pravo povrijeđeno u ovoj situaciji",
      tone: 'semantic',
    },
    {
      german: "Das Recht auf",
      translated: "Pravo na …",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:281|tr": [
    {
      german: "Zwei Freunde",
      translated: "İki arkadaş",
      tone: 'semantic',
    },
    {
      german: "wollen in ein öffentliches Schwimmbad",
      translated: "halka açık bir yüzme havuzuna gitmek istiyor",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "Almanya'da",
      tone: 'semantic',
    },
    {
      german: "Beide haben eine dunkle Hautfarbe",
      translated: "İkisinin de teni koyu",
      tone: 'semantic',
    },
    {
      german: "und werden deshalb nicht hineingelassen",
      translated: "olduğu için içeri alınmıyorlar",
      tone: 'semantic',
    },
    {
      german: "Welches Recht wird in dieser Situation verletzt",
      translated: "Hangi hak ihlal edilmiştir",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:281|uk": [
    {
      german: "Zwei Freunde",
      translated: "Двоє друзів",
      tone: 'semantic',
    },
    {
      german: "wollen in ein öffentliches Schwimmbad",
      translated: "хочуть піти до громадського басейну",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "в Німеччині",
      tone: 'semantic',
    },
    {
      german: "Beide haben eine dunkle Hautfarbe",
      translated: "Обидва мають темний колір шкіри",
      tone: 'semantic',
    },
    {
      german: "und werden deshalb nicht hineingelassen",
      translated: "і саме тому їх не пускають",
      tone: 'semantic',
    },
    {
      german: "Welches Recht wird in dieser Situation verletzt",
      translated: "Яке право порушено?",
      tone: 'semantic',
    },
    {
      german: "Das Recht auf",
      translated: "Право на",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:281|vi": [
    {
      german: "Zwei Freunde",
      translated: "Hai người bạn",
      tone: 'semantic',
    },
    {
      german: "wollen in ein öffentliches Schwimmbad",
      translated: "muốn vào một bể bơi công cộng",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "ở Đức",
      tone: 'semantic',
    },
    {
      german: "Beide haben eine dunkle Hautfarbe",
      translated: "Cả hai có làn da sẫm màu",
      tone: 'semantic',
    },
    {
      german: "und werden deshalb nicht hineingelassen",
      translated: "vì thế không được cho vào",
      tone: 'semantic',
    },
    {
      german: "Welches Recht wird in dieser Situation verletzt",
      translated: "Quyền nào bị vi phạm trong tình huống này",
      tone: 'semantic',
    },
    {
      german: "Das Recht auf",
      translated: "Quyền …",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:282|ar": [
    {
      german: "Welches Ehrenamt",
      translated: "أي عمل تطوعي",
      tone: 'semantic',
    },
    {
      german: "müssen",
      translated: "يجب على",
      tone: 'semantic',
    },
    {
      german: "deutsche Staatsbürgerinnen und Staatsbürger",
      translated: "المواطنين",
      tone: 'semantic',
    },
    {
      german: "übernehmen",
      translated: "القيام به",
      tone: 'semantic',
    },
    {
      german: "wenn sie dazu aufgefordert werden",
      translated: "إذا طُلب منهم ذلك",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:282|bg": [
    {
      german: "Welches Ehrenamt",
      translated: "Коя доброволна обществена дейност",
      tone: 'semantic',
    },
    {
      german: "müssen",
      translated: "трябва",
      tone: 'semantic',
    },
    {
      german: "deutsche Staatsbürgerinnen und Staatsbürger",
      translated: "германските граждани",
      tone: 'semantic',
    },
    {
      german: "übernehmen",
      translated: "да приемат",
      tone: 'semantic',
    },
    {
      german: "wenn sie dazu aufgefordert werden",
      translated: "ако бъдат определени за нея",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:282|bs": [
    {
      german: "Welches Ehrenamt",
      translated: "Koju počasnu javnu dužnost",
      tone: 'semantic',
    },
    {
      german: "müssen",
      translated: "moraju",
      tone: 'semantic',
    },
    {
      german: "deutsche Staatsbürgerinnen und Staatsbürger",
      translated: "njemački građani",
      tone: 'semantic',
    },
    {
      german: "übernehmen",
      translated: "prihvatiti",
      tone: 'semantic',
    },
    {
      german: "wenn sie dazu aufgefordert werden",
      translated: "ako budu imenovani",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:282|el": [
    {
      german: "Welches Ehrenamt",
      translated: "Ποιο εθελοντικό δημόσιο καθήκον",
      tone: 'semantic',
    },
    {
      german: "müssen",
      translated: "πρέπει",
      tone: 'semantic',
    },
    {
      german: "deutsche Staatsbürgerinnen und Staatsbürger",
      translated: "οι Γερμανοί πολίτες",
      tone: 'semantic',
    },
    {
      german: "übernehmen",
      translated: "να αναλάβουν",
      tone: 'semantic',
    },
    {
      german: "wenn sie dazu aufgefordert werden",
      translated: "αν οριστούν",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:282|en": [
    {
      german: "Welches Ehrenamt",
      translated: "Which voluntary office",
      tone: 'semantic',
    },
    {
      german: "müssen",
      translated: "must",
      tone: 'semantic',
    },
    {
      german: "deutsche Staatsbürgerinnen und Staatsbürger",
      translated: "German citizens",
      tone: 'semantic',
    },
    {
      german: "übernehmen",
      translated: "take on",
      tone: 'semantic',
    },
    {
      german: "wenn sie dazu aufgefordert werden",
      translated: "when asked to do so",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:282|es": [
    {
      german: "Welches Ehrenamt",
      translated: "¿Qué cargo voluntario",
      tone: 'semantic',
    },
    {
      german: "müssen",
      translated: "deben",
      tone: 'semantic',
    },
    {
      german: "deutsche Staatsbürgerinnen und Staatsbürger",
      translated: "los ciudadanos alemanes",
      tone: 'semantic',
    },
    {
      german: "übernehmen",
      translated: "asumir",
      tone: 'semantic',
    },
    {
      german: "wenn sie dazu aufgefordert werden",
      translated: "si se les solicita",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:282|fa": [
    {
      german: "Welches Ehrenamt",
      translated: "کدام فعالیت افتخاری",
      tone: 'semantic',
    },
    {
      german: "müssen",
      translated: "باید",
      tone: 'semantic',
    },
    {
      german: "deutsche Staatsbürgerinnen und Staatsbürger",
      translated: "شهروندان آلمانی",
      tone: 'semantic',
    },
    {
      german: "übernehmen",
      translated: "بپذیرند",
      tone: 'semantic',
    },
    {
      german: "wenn sie dazu aufgefordert werden",
      translated: "؟",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:282|fr": [
    {
      german: "Welches Ehrenamt",
      translated: "Quelle fonction bénévole",
      tone: 'semantic',
    },
    {
      german: "müssen",
      translated: "doivent",
      tone: 'semantic',
    },
    {
      german: "deutsche Staatsbürgerinnen und Staatsbürger",
      translated: "les citoyens allemands",
      tone: 'semantic',
    },
    {
      german: "übernehmen",
      translated: "exercer",
      tone: 'semantic',
    },
    {
      german: "wenn sie dazu aufgefordert werden",
      translated: "s’ils sont appelés à le faire",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:282|hr": [
    {
      german: "Welches Ehrenamt",
      translated: "Koju",
      tone: 'semantic',
    },
    {
      german: "müssen",
      translated: "moraju",
      tone: 'semantic',
    },
    {
      german: "deutsche Staatsbürgerinnen und Staatsbürger",
      translated: "javnu dužnost",
      tone: 'semantic',
    },
    {
      german: "übernehmen",
      translated: "prihvatiti",
      tone: 'semantic',
    },
    {
      german: "wenn sie dazu aufgefordert werden",
      translated: "ako budu imenovani",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:282|it": [
    {
      german: "Welches Ehrenamt",
      translated: "Quale attività volontaria",
      tone: 'semantic',
    },
    {
      german: "müssen",
      translated: "devono",
      tone: 'semantic',
    },
    {
      german: "deutsche Staatsbürgerinnen und Staatsbürger",
      translated: "i cittadini tedeschi",
      tone: 'semantic',
    },
    {
      german: "übernehmen",
      translated: "accettare",
      tone: 'semantic',
    },
    {
      german: "wenn sie dazu aufgefordert werden",
      translated: "se vengono nominati",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:282|kmr": [
    {
      german: "Welches Ehrenamt",
      translated: "Kîjan karê dilxwaz",
      tone: 'semantic',
    },
    {
      german: "deutsche Staatsbürgerinnen und Staatsbürger",
      translated: "welatiyên Alman",
      tone: 'semantic',
    },
    {
      german: "übernehmen",
      translated: "divê bikin",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:282|pl": [
    {
      german: "Welches Ehrenamt",
      translated: "Jaką honorową funkcję publiczną",
      tone: 'semantic',
    },
    {
      german: "müssen",
      translated: "muszą",
      tone: 'semantic',
    },
    {
      german: "deutsche Staatsbürgerinnen und Staatsbürger",
      translated: "obywatele Niemiec",
      tone: 'semantic',
    },
    {
      german: "übernehmen",
      translated: "przyjąć",
      tone: 'semantic',
    },
    {
      german: "wenn sie dazu aufgefordert werden",
      translated: "jeśli zostaną do niej wyznaczeni",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:282|prs": [
    {
      german: "Welches Ehrenamt",
      translated: "کدام فعالیت افتخاری",
      tone: 'semantic',
    },
    {
      german: "müssen",
      translated: "باید",
      tone: 'semantic',
    },
    {
      german: "deutsche Staatsbürgerinnen und Staatsbürger",
      translated: "شهروندان آلمانی",
      tone: 'semantic',
    },
    {
      german: "übernehmen",
      translated: "بپذیرند",
      tone: 'semantic',
    },
    {
      german: "wenn sie dazu aufgefordert werden",
      translated: "در صورت درخواست",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:282|ro": [
    {
      german: "Welches Ehrenamt",
      translated: "Ce activitate voluntară",
      tone: 'semantic',
    },
    {
      german: "deutsche Staatsbürgerinnen und Staatsbürger",
      translated: "cetățenii germani",
      tone: 'semantic',
    },
    {
      german: "übernehmen",
      translated: "trebuie să accepte",
      tone: 'semantic',
    },
    {
      german: "wenn sie dazu aufgefordert werden",
      translated: "dacă sunt desemnați",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:282|ru": [
    {
      german: "Welches Ehrenamt",
      translated: "Какую общественную должность",
      tone: 'semantic',
    },
    {
      german: "müssen",
      translated: "должны",
      tone: 'semantic',
    },
    {
      german: "deutsche Staatsbürgerinnen und Staatsbürger",
      translated: "граждане Германии",
      tone: 'semantic',
    },
    {
      german: "übernehmen",
      translated: "взять на себя",
      tone: 'semantic',
    },
    {
      german: "wenn sie dazu aufgefordert werden",
      translated: "если их об этом попросят",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:282|sq": [
    {
      german: "Welches Ehrenamt",
      translated: "Cilën detyrë publike vullnetare",
      tone: 'semantic',
    },
    {
      german: "müssen",
      translated: "duhet",
      tone: 'semantic',
    },
    {
      german: "deutsche Staatsbürgerinnen und Staatsbürger",
      translated: "shtetasit gjermanë",
      tone: 'semantic',
    },
    {
      german: "übernehmen",
      translated: "ta pranojnë",
      tone: 'semantic',
    },
    {
      german: "wenn sie dazu aufgefordert werden",
      translated: "nëse emërohen për të",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:282|sr": [
    {
      german: "Welches Ehrenamt",
      translated: "Koju",
      tone: 'semantic',
    },
    {
      german: "müssen",
      translated: "moraju",
      tone: 'semantic',
    },
    {
      german: "deutsche Staatsbürgerinnen und Staatsbürger",
      translated: "nemački građani",
      tone: 'semantic',
    },
    {
      german: "übernehmen",
      translated: "prihvatiti",
      tone: 'semantic',
    },
    {
      german: "wenn sie dazu aufgefordert werden",
      translated: "ako budu imenovani",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:282|tr": [
    {
      german: "Welches Ehrenamt",
      translated: "hangi gönüllü kamu görevini",
      tone: 'semantic',
    },
    {
      german: "müssen",
      translated: "zorundadır",
      tone: 'semantic',
    },
    {
      german: "deutsche Staatsbürgerinnen und Staatsbürger",
      translated: "Alman vatandaşları",
      tone: 'semantic',
    },
    {
      german: "übernehmen",
      translated: "üstlenmek",
      tone: 'semantic',
    },
    {
      german: "wenn sie dazu aufgefordert werden",
      translated: "çağrıldıklarında",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:282|uk": [
    {
      german: "Welches Ehrenamt",
      translated: "Який почесний громадський обов’язок",
      tone: 'semantic',
    },
    {
      german: "müssen",
      translated: "повинні",
      tone: 'semantic',
    },
    {
      german: "deutsche Staatsbürgerinnen und Staatsbürger",
      translated: "громадяни Німеччини",
      tone: 'semantic',
    },
    {
      german: "übernehmen",
      translated: "виконувати",
      tone: 'semantic',
    },
    {
      german: "wenn sie dazu aufgefordert werden",
      translated: "якщо їх до цього залучать",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:282|vi": [
    {
      german: "Welches Ehrenamt",
      translated: "nhiệm vụ công ích tình nguyện nào",
      tone: 'semantic',
    },
    {
      german: "müssen",
      translated: "phải",
      tone: 'semantic',
    },
    {
      german: "deutsche Staatsbürgerinnen und Staatsbürger",
      translated: "Công dân Đức",
      tone: 'semantic',
    },
    {
      german: "übernehmen",
      translated: "nhận",
      tone: 'semantic',
    },
    {
      german: "wenn sie dazu aufgefordert werden",
      translated: "khi được yêu cầu làm như vậy",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:283|ar": [
    {
      german: "Was tun Sie",
      translated: "ماذا تفعل",
      tone: 'semantic',
    },
    {
      german: "wenn Sie",
      translated: "إذا تلقيت",
      tone: 'semantic',
    },
    {
      german: "eine falsche Rechnung",
      translated: "فاتورة خاطئة",
      tone: 'semantic',
    },
    {
      german: "von einer deutschen Behörde",
      translated: "من جهة حكومية ألمانية",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:283|bg": [
    {
      german: "Was tun Sie",
      translated: "Какво правите",
      tone: 'semantic',
    },
    {
      german: "wenn Sie",
      translated: "ако",
      tone: 'semantic',
    },
    {
      german: "eine falsche Rechnung",
      translated: "неправилна сметка",
      tone: 'semantic',
    },
    {
      german: "von einer deutschen Behörde",
      translated: "от германска институция",
      tone: 'semantic',
    },
    {
      german: "bekommen",
      translated: "получите",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:283|bs": [
    {
      german: "Was tun Sie",
      translated: "Što činite",
      tone: 'semantic',
    },
    {
      german: "wenn Sie",
      translated: "ako dobijete",
      tone: 'semantic',
    },
    {
      german: "eine falsche Rechnung",
      translated: "pogrešan račun",
      tone: 'semantic',
    },
    {
      german: "von einer deutschen Behörde",
      translated: "od njemačkog ureda",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:283|el": [
    {
      german: "Was tun Sie",
      translated: "Τι κάνετε",
      tone: 'semantic',
    },
    {
      german: "wenn Sie",
      translated: "αν",
      tone: 'semantic',
    },
    {
      german: "eine falsche Rechnung",
      translated: "λανθασμένο λογαριασμό",
      tone: 'semantic',
    },
    {
      german: "von einer deutschen Behörde",
      translated: "από γερμανική αρχή",
      tone: 'semantic',
    },
    {
      german: "bekommen",
      translated: "λάβετε",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:283|en": [
    {
      german: "Was tun Sie",
      translated: "What do you do",
      tone: 'semantic',
    },
    {
      german: "wenn Sie",
      translated: "if you",
      tone: 'semantic',
    },
    {
      german: "eine falsche Rechnung",
      translated: "an incorrect bill",
      tone: 'semantic',
    },
    {
      german: "von einer deutschen Behörde",
      translated: "from a German authority",
      tone: 'semantic',
    },
    {
      german: "bekommen",
      translated: "receive",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:283|es": [
    {
      german: "Was tun Sie",
      translated: "¿Qué haces",
      tone: 'semantic',
    },
    {
      german: "wenn Sie",
      translated: "si",
      tone: 'semantic',
    },
    {
      german: "eine falsche Rechnung",
      translated: "una factura incorrecta",
      tone: 'semantic',
    },
    {
      german: "von einer deutschen Behörde",
      translated: "de una autoridad alemana",
      tone: 'semantic',
    },
    {
      german: "bekommen",
      translated: "recibes",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:283|fa": [
    {
      german: "Was tun Sie",
      translated: "اگر از یک ادارهٔ",
      tone: 'semantic',
    },
    {
      german: "wenn Sie",
      translated: "آلمانی",
      tone: 'semantic',
    },
    {
      german: "eine falsche Rechnung",
      translated: "صورتحساب اشتباهی",
      tone: 'semantic',
    },
    {
      german: "von einer deutschen Behörde",
      translated: "دریافت کنید",
      tone: 'semantic',
    },
    {
      german: "bekommen",
      translated: "چه می‌کنید",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:283|fr": [
    {
      german: "Was tun Sie",
      translated: "Que faites-vous",
      tone: 'semantic',
    },
    {
      german: "wenn Sie",
      translated: "si vous",
      tone: 'semantic',
    },
    {
      german: "eine falsche Rechnung",
      translated: "une facture erronée",
      tone: 'semantic',
    },
    {
      german: "von einer deutschen Behörde",
      translated: "d’une administration allemande",
      tone: 'semantic',
    },
    {
      german: "bekommen",
      translated: "recevez",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:283|hr": [
    {
      german: "Was tun Sie",
      translated: "Što činite",
      tone: 'semantic',
    },
    {
      german: "wenn Sie",
      translated: "ako dobijete",
      tone: 'semantic',
    },
    {
      german: "eine falsche Rechnung",
      translated: "pogrešan račun",
      tone: 'semantic',
    },
    {
      german: "von einer deutschen Behörde",
      translated: "od njemačkog ureda",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:283|it": [
    {
      german: "Was tun Sie",
      translated: "Che cosa fate",
      tone: 'semantic',
    },
    {
      german: "wenn Sie",
      translated: "se",
      tone: 'semantic',
    },
    {
      german: "eine falsche Rechnung",
      translated: "una fattura errata",
      tone: 'semantic',
    },
    {
      german: "von einer deutschen Behörde",
      translated: "da un’autorità tedesca",
      tone: 'semantic',
    },
    {
      german: "bekommen",
      translated: "ricevete",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:283|kmr": [
    {
      german: "Was tun Sie",
      translated: "çi dikî",
      tone: 'semantic',
    },
    {
      german: "wenn Sie",
      translated: "Heke",
      tone: 'semantic',
    },
    {
      german: "eine falsche Rechnung",
      translated: "faturayeke xelet",
      tone: 'semantic',
    },
    {
      german: "von einer deutschen Behörde",
      translated: "ji saziyeke dewletî ya Alman",
      tone: 'semantic',
    },
    {
      german: "bekommen",
      translated: "bistînî",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:283|pl": [
    {
      german: "Was tun Sie",
      translated: "Co robicie",
      tone: 'semantic',
    },
    {
      german: "wenn Sie",
      translated: "jeśli",
      tone: 'semantic',
    },
    {
      german: "eine falsche Rechnung",
      translated: "błędny rachunek",
      tone: 'semantic',
    },
    {
      german: "von einer deutschen Behörde",
      translated: "od niemieckiego urzędu",
      tone: 'semantic',
    },
    {
      german: "bekommen",
      translated: "otrzymacie",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:283|prs": [
    {
      german: "Was tun Sie",
      translated: "چه می‌کنید",
      tone: 'semantic',
    },
    {
      german: "wenn Sie",
      translated: "اگر",
      tone: 'semantic',
    },
    {
      german: "eine falsche Rechnung",
      translated: "صورتحساب اشتباهی",
      tone: 'semantic',
    },
    {
      german: "von einer deutschen Behörde",
      translated: "از یک ادارهٔ آلمانی",
      tone: 'semantic',
    },
    {
      german: "bekommen",
      translated: "دریافت کنید",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:283|ro": [
    {
      german: "Was tun Sie",
      translated: "Ce faceți",
      tone: 'semantic',
    },
    {
      german: "wenn Sie",
      translated: "dacă",
      tone: 'semantic',
    },
    {
      german: "eine falsche Rechnung",
      translated: "o factură greșită",
      tone: 'semantic',
    },
    {
      german: "von einer deutschen Behörde",
      translated: "de la o autoritate germană",
      tone: 'semantic',
    },
    {
      german: "bekommen",
      translated: "primiți",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:283|ru": [
    {
      german: "Was tun Sie",
      translated: "Что вы делаете",
      tone: 'semantic',
    },
    {
      german: "wenn Sie",
      translated: "если",
      tone: 'semantic',
    },
    {
      german: "eine falsche Rechnung",
      translated: "неверный счёт",
      tone: 'semantic',
    },
    {
      german: "von einer deutschen Behörde",
      translated: "от немецкого учреждения",
      tone: 'semantic',
    },
    {
      german: "bekommen",
      translated: "получили",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:283|sq": [
    {
      german: "Was tun Sie",
      translated: "Çfarë bëni",
      tone: 'semantic',
    },
    {
      german: "wenn Sie",
      translated: "nëse",
      tone: 'semantic',
    },
    {
      german: "eine falsche Rechnung",
      translated: "faturë të gabuar",
      tone: 'semantic',
    },
    {
      german: "von einer deutschen Behörde",
      translated: "nga një institucion gjerman",
      tone: 'semantic',
    },
    {
      german: "bekommen",
      translated: "merrni",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:283|sr": [
    {
      german: "Was tun Sie",
      translated: "Šta činite",
      tone: 'semantic',
    },
    {
      german: "wenn Sie",
      translated: "ako",
      tone: 'semantic',
    },
    {
      german: "eine falsche Rechnung",
      translated: "pogrešan račun",
      tone: 'semantic',
    },
    {
      german: "von einer deutschen Behörde",
      translated: "od nemačkog službe",
      tone: 'semantic',
    },
    {
      german: "bekommen",
      translated: "dobijete",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:283|tr": [
    {
      german: "Was tun Sie",
      translated: "ne yaparsınız",
      tone: 'semantic',
    },
    {
      german: "eine falsche Rechnung",
      translated: "hatalı bir fatura",
      tone: 'semantic',
    },
    {
      german: "von einer deutschen Behörde",
      translated: "Almanya'daki bir kamu kurumundan",
      tone: 'semantic',
    },
    {
      german: "bekommen",
      translated: "alırsanız",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:283|uk": [
    {
      german: "Was tun Sie",
      translated: "Що ви робите",
      tone: 'semantic',
    },
    {
      german: "wenn Sie",
      translated: "якщо",
      tone: 'semantic',
    },
    {
      german: "eine falsche Rechnung",
      translated: "неправильний рахунок",
      tone: 'semantic',
    },
    {
      german: "von einer deutschen Behörde",
      translated: "від німецького державного органу",
      tone: 'semantic',
    },
    {
      german: "bekommen",
      translated: "отримали",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:283|vi": [
    {
      german: "Was tun Sie",
      translated: "Bạn làm gì",
      tone: 'semantic',
    },
    {
      german: "wenn Sie",
      translated: "nếu",
      tone: 'semantic',
    },
    {
      german: "eine falsche Rechnung",
      translated: "một hóa đơn sai",
      tone: 'semantic',
    },
    {
      german: "von einer deutschen Behörde",
      translated: "từ một cơ quan Đức",
      tone: 'semantic',
    },
    {
      german: "bekommen",
      translated: "nhận",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:284|ar": [
    {
      german: "Was man für die Arbeit können muss",
      translated: "المهارات المطلوبة للعمل",
      tone: 'semantic',
    },
    {
      german: "ändert sich",
      translated: "تتغير",
      tone: 'semantic',
    },
    {
      german: "in Zukunft",
      translated: "في المستقبل",
      tone: 'semantic',
    },
    {
      german: "sehr schnell",
      translated: "بسرعة كبيرة",
      tone: 'semantic',
    },
    {
      german: "Was kann man tun",
      translated: "ماذا يمكن أن يفعل الإنسان",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:284|bg": [
    {
      german: "Was man für die Arbeit können muss",
      translated: "Уменията, необходими за работа",
      tone: 'semantic',
    },
    {
      german: "ändert sich",
      translated: "се променят",
      tone: 'semantic',
    },
    {
      german: "in Zukunft",
      translated: "в бъдеще",
      tone: 'semantic',
    },
    {
      german: "sehr schnell",
      translated: "много бързо",
      tone: 'semantic',
    },
    {
      german: "Was kann man tun",
      translated: "Какво може да се направи",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:284|bs": [
    {
      german: "Was man für die Arbeit können muss",
      translated: "Vještine potrebne za rad",
      tone: 'semantic',
    },
    {
      german: "ändert sich",
      translated: "mijenjaju",
      tone: 'semantic',
    },
    {
      german: "in Zukunft",
      translated: "u budućnosti",
      tone: 'semantic',
    },
    {
      german: "sehr schnell",
      translated: "vrlo se brzo",
      tone: 'semantic',
    },
    {
      german: "Was kann man tun",
      translated: "Što se može učiniti",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:284|el": [
    {
      german: "Was man für die Arbeit können muss",
      translated: "Οι δεξιότητες που απαιτούνται για την εργασία",
      tone: 'semantic',
    },
    {
      german: "ändert sich",
      translated: "θα αλλάζουν",
      tone: 'semantic',
    },
    {
      german: "in Zukunft",
      translated: "στο μέλλον",
      tone: 'semantic',
    },
    {
      german: "sehr schnell",
      translated: "πολύ γρήγορα",
      tone: 'semantic',
    },
    {
      german: "Was kann man tun",
      translated: "Τι μπορεί να γίνει;",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:284|en": [
    {
      german: "Was man für die Arbeit können muss",
      translated: "What you need to know for work",
      tone: 'semantic',
    },
    {
      german: "ändert sich",
      translated: "changes",
      tone: 'semantic',
    },
    {
      german: "in Zukunft",
      translated: "in the future",
      tone: 'semantic',
    },
    {
      german: "sehr schnell",
      translated: "very quickly",
      tone: 'semantic',
    },
    {
      german: "Was kann man tun",
      translated: "What can you do",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:284|es": [
    {
      german: "Was man für die Arbeit können muss",
      translated: "Los conocimientos necesarios para el trabajo",
      tone: 'semantic',
    },
    {
      german: "ändert sich",
      translated: "cambiarán",
      tone: 'semantic',
    },
    {
      german: "in Zukunft",
      translated: "en el futuro",
      tone: 'semantic',
    },
    {
      german: "sehr schnell",
      translated: "muy rápidamente",
      tone: 'semantic',
    },
    {
      german: "Was kann man tun",
      translated: "¿Qué se puede hacer?",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:284|fa": [
    {
      german: "Was man für die Arbeit können muss",
      translated: "مهارت‌های لازم برای کار",
      tone: 'semantic',
    },
    {
      german: "ändert sich",
      translated: "تغییر می‌کنند",
      tone: 'semantic',
    },
    {
      german: "in Zukunft",
      translated: "در آینده",
      tone: 'semantic',
    },
    {
      german: "sehr schnell",
      translated: "بسیار سریع",
      tone: 'semantic',
    },
    {
      german: "Was kann man tun",
      translated: "چه می‌توان کرد",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:284|fr": [
    {
      german: "Was man für die Arbeit können muss",
      translated: "Les compétences nécessaires au travail",
      tone: 'semantic',
    },
    {
      german: "ändert sich",
      translated: "évoluent",
      tone: 'semantic',
    },
    {
      german: "in Zukunft",
      translated: "à l’avenir",
      tone: 'semantic',
    },
    {
      german: "sehr schnell",
      translated: "très rapidement",
      tone: 'semantic',
    },
    {
      german: "Was kann man tun",
      translated: "Que peut-on faire",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:284|hr": [
    {
      german: "Was man für die Arbeit können muss",
      translated: "Vještine potrebne za rad",
      tone: 'semantic',
    },
    {
      german: "ändert sich",
      translated: "mijenjaju",
      tone: 'semantic',
    },
    {
      german: "in Zukunft",
      translated: "u budućnosti",
      tone: 'semantic',
    },
    {
      german: "sehr schnell",
      translated: "vrlo se brzo",
      tone: 'semantic',
    },
    {
      german: "Was kann man tun",
      translated: "Što se može učiniti",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:284|it": [
    {
      german: "Was man für die Arbeit können muss",
      translated: "Le competenze necessarie per il lavoro",
      tone: 'semantic',
    },
    {
      german: "ändert sich",
      translated: "cambieranno",
      tone: 'semantic',
    },
    {
      german: "in Zukunft",
      translated: "in futuro",
      tone: 'semantic',
    },
    {
      german: "sehr schnell",
      translated: "molto rapidamente",
      tone: 'semantic',
    },
    {
      german: "Was kann man tun",
      translated: "Che cosa si può fare",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:284|kmr": [
    {
      german: "Was man für die Arbeit können muss",
      translated: "Pêdiviyên karê",
      tone: 'semantic',
    },
    {
      german: "ändert sich",
      translated: "diguherin",
      tone: 'semantic',
    },
    {
      german: "in Zukunft",
      translated: "di pêşerojê de",
      tone: 'semantic',
    },
    {
      german: "sehr schnell",
      translated: "pir zû",
      tone: 'semantic',
    },
    {
      german: "Was kann man tun",
      translated: "Çi dikare were kirin",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:284|pl": [
    {
      german: "Was man für die Arbeit können muss",
      translated: "co trzeba umieć w pracy",
      tone: 'semantic',
    },
    {
      german: "ändert sich",
      translated: "zmieni się",
      tone: 'semantic',
    },
    {
      german: "in Zukunft",
      translated: "w przyszłości",
      tone: 'semantic',
    },
    {
      german: "sehr schnell",
      translated: "bardzo szybko",
      tone: 'semantic',
    },
    {
      german: "Was kann man tun",
      translated: "Co można zrobić",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:284|prs": [
    {
      german: "Was man für die Arbeit können muss",
      translated: "مهارت‌های لازم برای کار",
      tone: 'semantic',
    },
    {
      german: "ändert sich",
      translated: "تغییر می‌کنند",
      tone: 'semantic',
    },
    {
      german: "in Zukunft",
      translated: "در آینده",
      tone: 'semantic',
    },
    {
      german: "sehr schnell",
      translated: "بسیار سریع",
      tone: 'semantic',
    },
    {
      german: "Was kann man tun",
      translated: "چه می‌توان کرد",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:284|ro": [
    {
      german: "Was man für die Arbeit können muss",
      translated: "Competențele necesare pentru muncă",
      tone: 'semantic',
    },
    {
      german: "ändert sich",
      translated: "se schimbă",
      tone: 'semantic',
    },
    {
      german: "in Zukunft",
      translated: "în viitor",
      tone: 'semantic',
    },
    {
      german: "sehr schnell",
      translated: "foarte repede",
      tone: 'semantic',
    },
    {
      german: "Was kann man tun",
      translated: "Ce se poate face",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:284|ru": [
    {
      german: "Was man für die Arbeit können muss",
      translated: "То, что нужно уметь для работы",
      tone: 'semantic',
    },
    {
      german: "ändert sich",
      translated: "меняться",
      tone: 'semantic',
    },
    {
      german: "in Zukunft",
      translated: "в будущем",
      tone: 'semantic',
    },
    {
      german: "sehr schnell",
      translated: "быстро",
      tone: 'semantic',
    },
    {
      german: "Was kann man tun",
      translated: "Что можно сделать",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:284|sq": [
    {
      german: "Was man für die Arbeit können muss",
      translated: "Aftësitë e nevojshme për punë",
      tone: 'semantic',
    },
    {
      german: "ändert sich",
      translated: "ndryshojnë",
      tone: 'semantic',
    },
    {
      german: "in Zukunft",
      translated: "në të ardhmen",
      tone: 'semantic',
    },
    {
      german: "sehr schnell",
      translated: "shumë shpejt",
      tone: 'semantic',
    },
    {
      german: "Was kann man tun",
      translated: "Çfarë mund të bëhet?",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:284|sr": [
    {
      german: "Was man für die Arbeit können muss",
      translated: "Vještine potrebne za rad",
      tone: 'semantic',
    },
    {
      german: "ändert sich",
      translated: "mijenjaju",
      tone: 'semantic',
    },
    {
      german: "in Zukunft",
      translated: "u budućnosti",
      tone: 'semantic',
    },
    {
      german: "sehr schnell",
      translated: "vrlo se brzo",
      tone: 'semantic',
    },
    {
      german: "Was kann man tun",
      translated: "Šta se može uraditi",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:284|tr": [
    {
      german: "Was man für die Arbeit können muss",
      translated: "İş için gereken beceriler",
      tone: 'semantic',
    },
    {
      german: "ändert sich",
      translated: "değişecektir",
      tone: 'semantic',
    },
    {
      german: "in Zukunft",
      translated: "gelecekte",
      tone: 'semantic',
    },
    {
      german: "sehr schnell",
      translated: "çok hızlı",
      tone: 'semantic',
    },
    {
      german: "Was kann man tun",
      translated: "Ne yapılabilir?",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:284|uk": [
    {
      german: "Was man für die Arbeit können muss",
      translated: "Вимоги до професійних навичок",
      tone: 'semantic',
    },
    {
      german: "ändert sich",
      translated: "змінюються",
      tone: 'semantic',
    },
    {
      german: "in Zukunft",
      translated: "у майбутньому",
      tone: 'semantic',
    },
    {
      german: "sehr schnell",
      translated: "дуже швидко",
      tone: 'semantic',
    },
    {
      german: "Was kann man tun",
      translated: "Що можна робити",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:284|vi": [
    {
      german: "Was man für die Arbeit können muss",
      translated: "Những kỹ năng cần cho công việc",
      tone: 'semantic',
    },
    {
      german: "ändert sich",
      translated: "sẽ thay đổi",
      tone: 'semantic',
    },
    {
      german: "in Zukunft",
      translated: "trong tương lai",
      tone: 'semantic',
    },
    {
      german: "sehr schnell",
      translated: "rất nhanh",
      tone: 'semantic',
    },
    {
      german: "Was kann man tun",
      translated: "Có thể làm gì?",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:285|ar": [
    {
      german: "Frau Frost",
      translated: "السيدة فروست",
      tone: 'semantic',
    },
    {
      german: "arbeitet",
      translated: "تعمل",
      tone: 'semantic',
    },
    {
      german: "als fest angestellte Mitarbeiterin",
      translated: "موظفة ثابتة",
      tone: 'semantic',
    },
    {
      german: "in einem Büro",
      translated: "في مكتب",
      tone: 'semantic',
    },
    {
      german: "Was",
      translated: "أي مما يلي",
      tone: 'semantic',
    },
    {
      german: "muss sie nicht",
      translated: "لا تدفعه",
      tone: 'semantic',
    },
    {
      german: "von ihrem Gehalt",
      translated: "من راتبها",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:285|bg": [
    {
      german: "Frau Frost",
      translated: "Г-жа Фрост",
      tone: 'semantic',
    },
    {
      german: "arbeitet",
      translated: "е постоянно назначена",
      tone: 'semantic',
    },
    {
      german: "in einem Büro",
      translated: "в офис",
      tone: 'semantic',
    },
    {
      german: "Was",
      translated: "Кое",
      tone: 'semantic',
    },
    {
      german: "muss sie nicht",
      translated: "НЕ трябва",
      tone: 'semantic',
    },
    {
      german: "von ihrem Gehalt",
      translated: "от заплатата си",
      tone: 'semantic',
    },
    {
      german: "bezahlen",
      translated: "да плаща",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:285|bs": [
    {
      german: "Frau Frost",
      translated: "Gospođa Frost",
      tone: 'semantic',
    },
    {
      german: "arbeitet",
      translated: "stalno je zaposlena",
      tone: 'semantic',
    },
    {
      german: "als fest angestellte Mitarbeiterin",
      translated: "u uredu",
      tone: 'semantic',
    },
    {
      german: "Was",
      translated: "Što",
      tone: 'semantic',
    },
    {
      german: "muss sie nicht",
      translated: "NE mora",
      tone: 'semantic',
    },
    {
      german: "von ihrem Gehalt",
      translated: "iz svoje plate",
      tone: 'semantic',
    },
    {
      german: "bezahlen",
      translated: "platati",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:285|el": [
    {
      german: "Frau Frost",
      translated: "Η κυρία Frost",
      tone: 'semantic',
    },
    {
      german: "arbeitet",
      translated: "εργάζεται",
      tone: 'semantic',
    },
    {
      german: "als fest angestellte Mitarbeiterin",
      translated: "μόνιμα",
      tone: 'semantic',
    },
    {
      german: "in einem Büro",
      translated: "σε γραφείο",
      tone: 'semantic',
    },
    {
      german: "Was",
      translated: "Τι",
      tone: 'semantic',
    },
    {
      german: "muss sie nicht",
      translated: "ΔΕΝ χρειάζεται να",
      tone: 'semantic',
    },
    {
      german: "von ihrem Gehalt",
      translated: "από τον μισθό της",
      tone: 'semantic',
    },
    {
      german: "bezahlen",
      translated: "πληρώνει",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:285|en": [
    {
      german: "Frau Frost",
      translated: "Mrs. Frost",
      tone: 'semantic',
    },
    {
      german: "arbeitet",
      translated: "works",
      tone: 'semantic',
    },
    {
      german: "als fest angestellte Mitarbeiterin",
      translated: "as a permanent employee",
      tone: 'semantic',
    },
    {
      german: "in einem Büro",
      translated: "in an office",
      tone: 'semantic',
    },
    {
      german: "Was",
      translated: "What",
      tone: 'semantic',
    },
    {
      german: "muss sie nicht",
      translated: "does she not have to",
      tone: 'semantic',
    },
    {
      german: "von ihrem Gehalt",
      translated: "from her salary",
      tone: 'semantic',
    },
    {
      german: "bezahlen",
      translated: "pay",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:285|es": [
    {
      german: "Frau Frost",
      translated: "La señora Frost",
      tone: 'semantic',
    },
    {
      german: "arbeitet",
      translated: "trabaja",
      tone: 'semantic',
    },
    {
      german: "als fest angestellte Mitarbeiterin",
      translated: "como empleada fija",
      tone: 'semantic',
    },
    {
      german: "in einem Büro",
      translated: "en una oficina",
      tone: 'semantic',
    },
    {
      german: "Was",
      translated: "¿Qué",
      tone: 'semantic',
    },
    {
      german: "muss sie nicht",
      translated: "NO",
      tone: 'semantic',
    },
    {
      german: "von ihrem Gehalt",
      translated: "de su salario",
      tone: 'semantic',
    },
    {
      german: "bezahlen",
      translated: "paga",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:285|fa": [
    {
      german: "Frau Frost",
      translated: "خانم فروست",
      tone: 'semantic',
    },
    {
      german: "als fest angestellte Mitarbeiterin",
      translated: "کارمند دائمی یک دفتر",
      tone: 'semantic',
    },
    {
      german: "Was",
      translated: "کدام",
      tone: 'semantic',
    },
    {
      german: "muss sie nicht",
      translated: "لازم نیست",
      tone: 'semantic',
    },
    {
      german: "von ihrem Gehalt",
      translated: "از حقوق خود",
      tone: 'semantic',
    },
    {
      german: "bezahlen",
      translated: "بپردازد؟",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:285|fr": [
    {
      german: "Frau Frost",
      translated: "Mme Frost",
      tone: 'semantic',
    },
    {
      german: "arbeitet",
      translated: "travaille",
      tone: 'semantic',
    },
    {
      german: "als fest angestellte Mitarbeiterin",
      translated: "comme salariée permanente",
      tone: 'semantic',
    },
    {
      german: "in einem Büro",
      translated: "dans un bureau",
      tone: 'semantic',
    },
    {
      german: "Was",
      translated: "Que",
      tone: 'semantic',
    },
    {
      german: "muss sie nicht",
      translated: "ne doit-elle pas",
      tone: 'semantic',
    },
    {
      german: "von ihrem Gehalt",
      translated: "sur son salaire",
      tone: 'semantic',
    },
    {
      german: "bezahlen",
      translated: "payer",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:285|hr": [
    {
      german: "Frau Frost",
      translated: "Gospođa Frost",
      tone: 'semantic',
    },
    {
      german: "arbeitet",
      translated: "stalno je zaposlena",
      tone: 'semantic',
    },
    {
      german: "in einem Büro",
      translated: "u uredu",
      tone: 'semantic',
    },
    {
      german: "Was",
      translated: "Što",
      tone: 'semantic',
    },
    {
      german: "muss sie nicht",
      translated: "NE mora",
      tone: 'semantic',
    },
    {
      german: "von ihrem Gehalt",
      translated: "iz svoje plaće",
      tone: 'semantic',
    },
    {
      german: "bezahlen",
      translated: "plaćati",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:285|it": [
    {
      german: "Frau Frost",
      translated: "La signora Frost",
      tone: 'semantic',
    },
    {
      german: "arbeitet",
      translated: "è dipendente",
      tone: 'semantic',
    },
    {
      german: "als fest angestellte Mitarbeiterin",
      translated: "a tempo indeterminato",
      tone: 'semantic',
    },
    {
      german: "in einem Büro",
      translated: "in un ufficio",
      tone: 'semantic',
    },
    {
      german: "Was",
      translated: "Che cosa",
      tone: 'semantic',
    },
    {
      german: "muss sie nicht",
      translated: "NON deve",
      tone: 'semantic',
    },
    {
      german: "von ihrem Gehalt",
      translated: "dal proprio stipendio",
      tone: 'semantic',
    },
    {
      german: "bezahlen",
      translated: "pagare",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:285|kmr": [
    {
      german: "Frau Frost",
      translated: "Frau Frost",
      tone: 'semantic',
    },
    {
      german: "arbeitet",
      translated: "dixebite",
      tone: 'semantic',
    },
    {
      german: "als fest angestellte Mitarbeiterin",
      translated: "wek karmendeke domdar",
      tone: 'semantic',
    },
    {
      german: "in einem Büro",
      translated: "li nivîsgehekê",
      tone: 'semantic',
    },
    {
      german: "Was",
      translated: "çi",
      tone: 'semantic',
    },
    {
      german: "muss sie nicht",
      translated: "divê",
      tone: 'semantic',
    },
    {
      german: "von ihrem Gehalt",
      translated: "Ji mûçeya xwe",
      tone: 'semantic',
    },
    {
      german: "bezahlen",
      translated: "nedê",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:285|pl": [
    {
      german: "Frau Frost",
      translated: "Pani Frost",
      tone: 'semantic',
    },
    {
      german: "arbeitet",
      translated: "jest",
      tone: 'semantic',
    },
    {
      german: "als fest angestellte Mitarbeiterin",
      translated: "zatrudniona na stałe",
      tone: 'semantic',
    },
    {
      german: "in einem Büro",
      translated: "w biurze",
      tone: 'semantic',
    },
    {
      german: "Was",
      translated: "Czego",
      tone: 'semantic',
    },
    {
      german: "muss sie nicht",
      translated: "NIE musi",
      tone: 'semantic',
    },
    {
      german: "von ihrem Gehalt",
      translated: "ze swojego wynagrodzenia",
      tone: 'semantic',
    },
    {
      german: "bezahlen",
      translated: "płacić",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:285|prs": [
    {
      german: "Frau Frost",
      translated: "خانم فروست",
      tone: 'semantic',
    },
    {
      german: "arbeitet",
      translated: "کارمند",
      tone: 'semantic',
    },
    {
      german: "als fest angestellte Mitarbeiterin",
      translated: "دائمی",
      tone: 'semantic',
    },
    {
      german: "in einem Büro",
      translated: "یک دفتر",
      tone: 'semantic',
    },
    {
      german: "Was",
      translated: "کدام مورد",
      tone: 'semantic',
    },
    {
      german: "muss sie nicht",
      translated: "لازم نیست",
      tone: 'semantic',
    },
    {
      german: "von ihrem Gehalt",
      translated: "از حقوق خود",
      tone: 'semantic',
    },
    {
      german: "bezahlen",
      translated: "بپردازد؟",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:285|ro": [
    {
      german: "Frau Frost",
      translated: "Doamna Frost",
      tone: 'semantic',
    },
    {
      german: "arbeitet",
      translated: "este angajată",
      tone: 'semantic',
    },
    {
      german: "als fest angestellte Mitarbeiterin",
      translated: "permanent",
      tone: 'semantic',
    },
    {
      german: "in einem Büro",
      translated: "într-un birou",
      tone: 'semantic',
    },
    {
      german: "Was",
      translated: "Ce",
      tone: 'semantic',
    },
    {
      german: "muss sie nicht",
      translated: "NU trebuie să plătească",
      tone: 'semantic',
    },
    {
      german: "von ihrem Gehalt",
      translated: "din salariul ei",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:285|ru": [
    {
      german: "Frau Frost",
      translated: "Госпожа Фрост",
      tone: 'semantic',
    },
    {
      german: "arbeitet",
      translated: "работает",
      tone: 'semantic',
    },
    {
      german: "als fest angestellte Mitarbeiterin",
      translated: "штатным сотрудником",
      tone: 'semantic',
    },
    {
      german: "in einem Büro",
      translated: "в офисе",
      tone: 'semantic',
    },
    {
      german: "Was",
      translated: "Что",
      tone: 'semantic',
    },
    {
      german: "muss sie nicht",
      translated: "ей не нужно",
      tone: 'semantic',
    },
    {
      german: "von ihrem Gehalt",
      translated: "со своей зарплаты",
      tone: 'semantic',
    },
    {
      german: "bezahlen",
      translated: "платить",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:285|sq": [
    {
      german: "Frau Frost",
      translated: "Zonja Frost",
      tone: 'semantic',
    },
    {
      german: "arbeitet",
      translated: "është",
      tone: 'semantic',
    },
    {
      german: "als fest angestellte Mitarbeiterin",
      translated: "e punësuar me kontratë të përhershme",
      tone: 'semantic',
    },
    {
      german: "in einem Büro",
      translated: "në një zyrë",
      tone: 'semantic',
    },
    {
      german: "Was",
      translated: "Çfarë",
      tone: 'semantic',
    },
    {
      german: "muss sie nicht",
      translated: "NUK duhet",
      tone: 'semantic',
    },
    {
      german: "von ihrem Gehalt",
      translated: "nga paga e saj",
      tone: 'semantic',
    },
    {
      german: "bezahlen",
      translated: "paguajë",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:285|sr": [
    {
      german: "Frau Frost",
      translated: "Gospođa Frost",
      tone: 'semantic',
    },
    {
      german: "arbeitet",
      translated: "stalno je zaposlena",
      tone: 'semantic',
    },
    {
      german: "in einem Büro",
      translated: "u službi",
      tone: 'semantic',
    },
    {
      german: "Was",
      translated: "Šta",
      tone: 'semantic',
    },
    {
      german: "muss sie nicht",
      translated: "NE mora",
      tone: 'semantic',
    },
    {
      german: "von ihrem Gehalt",
      translated: "iz svoje plate",
      tone: 'semantic',
    },
    {
      german: "bezahlen",
      translated: "plaćati",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:285|tr": [
    {
      german: "Frau Frost",
      translated: "Bayan Frost",
      tone: 'semantic',
    },
    {
      german: "arbeitet",
      translated: "çalışıyor",
      tone: 'semantic',
    },
    {
      german: "als fest angestellte Mitarbeiterin",
      translated: "kadrolu çalışan olarak",
      tone: 'semantic',
    },
    {
      german: "in einem Büro",
      translated: "bir büroda",
      tone: 'semantic',
    },
    {
      german: "Was",
      translated: "aşağıdakilerden hangisini",
      tone: 'semantic',
    },
    {
      german: "muss sie nicht",
      translated: "zorunda değildir",
      tone: 'semantic',
    },
    {
      german: "von ihrem Gehalt",
      translated: "Maaşından",
      tone: 'semantic',
    },
    {
      german: "bezahlen",
      translated: "ödemek",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:285|uk": [
    {
      german: "Frau Frost",
      translated: "Пані Фрост",
      tone: 'semantic',
    },
    {
      german: "arbeitet",
      translated: "працює",
      tone: 'semantic',
    },
    {
      german: "als fest angestellte Mitarbeiterin",
      translated: "штатною співробітницею",
      tone: 'semantic',
    },
    {
      german: "in einem Büro",
      translated: "в офісі",
      tone: 'semantic',
    },
    {
      german: "Was",
      translated: "Що",
      tone: 'semantic',
    },
    {
      german: "muss sie nicht",
      translated: "вона не повинна",
      tone: 'semantic',
    },
    {
      german: "von ihrem Gehalt",
      translated: "зі своєї зарплати",
      tone: 'semantic',
    },
    {
      german: "bezahlen",
      translated: "сплачувати",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:285|vi": [
    {
      german: "Frau Frost",
      translated: "Bà Frost",
      tone: 'semantic',
    },
    {
      german: "als fest angestellte Mitarbeiterin",
      translated: "là nhân viên lâu dài",
      tone: 'semantic',
    },
    {
      german: "in einem Büro",
      translated: "trong một văn phòng",
      tone: 'semantic',
    },
    {
      german: "Was",
      translated: "Khoản nào",
      tone: 'semantic',
    },
    {
      german: "muss sie nicht",
      translated: "bà KHÔNG phải",
      tone: 'semantic',
    },
    {
      german: "von ihrem Gehalt",
      translated: "từ lương của mình",
      tone: 'semantic',
    },
    {
      german: "bezahlen",
      translated: "trả",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:286|ar": [
    {
      german: "Welche Organisation",
      translated: "أي جهة",
      tone: 'semantic',
    },
    {
      german: "in einer Firma",
      translated: "في الشركة",
      tone: 'semantic',
    },
    {
      german: "hilft",
      translated: "تساعد",
      tone: 'semantic',
    },
    {
      german: "den Arbeitnehmerinnen und Arbeitnehmern",
      translated: "العاملين",
      tone: 'semantic',
    },
    {
      german: "bei Problemen",
      translated: "عند وجود مشكلات",
      tone: 'semantic',
    },
    {
      german: "mit der Arbeitgeberin/dem Arbeitgeber?",
      translated: "مع صاحب العمل",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:286|bg": [
    {
      german: "Welche Organisation",
      translated: "Коя институция",
      tone: 'semantic',
    },
    {
      german: "in einer Firma",
      translated: "в предприятие",
      tone: 'semantic',
    },
    {
      german: "hilft",
      translated: "помага",
      tone: 'semantic',
    },
    {
      german: "den Arbeitnehmerinnen und Arbeitnehmern",
      translated: "на служителите",
      tone: 'semantic',
    },
    {
      german: "bei Problemen",
      translated: "при проблеми",
      tone: 'semantic',
    },
    {
      german: "mit der Arbeitgeberin/dem Arbeitgeber?",
      translated: "с работодателя?",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:286|bs": [
    {
      german: "Welche Organisation",
      translated: "Koje tijelo",
      tone: 'semantic',
    },
    {
      german: "in einer Firma",
      translated: "u preduzeću",
      tone: 'semantic',
    },
    {
      german: "hilft",
      translated: "pomaže",
      tone: 'semantic',
    },
    {
      german: "den Arbeitnehmerinnen und Arbeitnehmern",
      translated: "zaposlenicima",
      tone: 'semantic',
    },
    {
      german: "bei Problemen",
      translated: "kod problema",
      tone: 'semantic',
    },
    {
      german: "mit der Arbeitgeberin/dem Arbeitgeber?",
      translated: "s poslodavcem?",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:286|el": [
    {
      german: "Welche Organisation",
      translated: "Ποιο όργανο",
      tone: 'semantic',
    },
    {
      german: "in einer Firma",
      translated: "σε μια επιχείρηση",
      tone: 'semantic',
    },
    {
      german: "hilft",
      translated: "βοηθά",
      tone: 'semantic',
    },
    {
      german: "den Arbeitnehmerinnen und Arbeitnehmern",
      translated: "τους εργαζόμενους",
      tone: 'semantic',
    },
    {
      german: "bei Problemen",
      translated: "σε προβλήματα",
      tone: 'semantic',
    },
    {
      german: "mit der Arbeitgeberin/dem Arbeitgeber?",
      translated: "με τον εργοδότη;",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:286|en": [
    {
      german: "Welche Organisation",
      translated: "Which organization",
      tone: 'semantic',
    },
    {
      german: "in einer Firma",
      translated: "in a company",
      tone: 'semantic',
    },
    {
      german: "hilft",
      translated: "helps",
      tone: 'semantic',
    },
    {
      german: "den Arbeitnehmerinnen und Arbeitnehmern",
      translated: "employees",
      tone: 'semantic',
    },
    {
      german: "bei Problemen",
      translated: "with problems",
      tone: 'semantic',
    },
    {
      german: "mit der Arbeitgeberin/dem Arbeitgeber?",
      translated: "with the employer?",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:286|es": [
    {
      german: "Welche Organisation",
      translated: "¿Qué órgano",
      tone: 'semantic',
    },
    {
      german: "in einer Firma",
      translated: "de una empresa",
      tone: 'semantic',
    },
    {
      german: "hilft",
      translated: "ayuda",
      tone: 'semantic',
    },
    {
      german: "den Arbeitnehmerinnen und Arbeitnehmern",
      translated: "a los trabajadores",
      tone: 'semantic',
    },
    {
      german: "bei Problemen",
      translated: "cuando tienen problemas",
      tone: 'semantic',
    },
    {
      german: "mit der Arbeitgeberin/dem Arbeitgeber?",
      translated: "con el empleador?",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:286|fa": [
    {
      german: "Welche Organisation",
      translated: "کدام نهاد",
      tone: 'semantic',
    },
    {
      german: "in einer Firma",
      translated: "در یک شرکت",
      tone: 'semantic',
    },
    {
      german: "hilft",
      translated: "کمک می‌کند",
      tone: 'semantic',
    },
    {
      german: "den Arbeitnehmerinnen und Arbeitnehmern",
      translated: "به کارکنان",
      tone: 'semantic',
    },
    {
      german: "bei Problemen",
      translated: "در مشکلات",
      tone: 'semantic',
    },
    {
      german: "mit der Arbeitgeberin/dem Arbeitgeber?",
      translated: "با کارفرما",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:286|fr": [
    {
      german: "Welche Organisation",
      translated: "Quelle organisation",
      tone: 'semantic',
    },
    {
      german: "in einer Firma",
      translated: "dans une entreprise",
      tone: 'semantic',
    },
    {
      german: "hilft",
      translated: "aide",
      tone: 'semantic',
    },
    {
      german: "den Arbeitnehmerinnen und Arbeitnehmern",
      translated: "les salariés",
      tone: 'semantic',
    },
    {
      german: "bei Problemen",
      translated: "en cas de problèmes",
      tone: 'semantic',
    },
    {
      german: "mit der Arbeitgeberin/dem Arbeitgeber?",
      translated: "l’employeur ?",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:286|hr": [
    {
      german: "Welche Organisation",
      translated: "Koje tijelo",
      tone: 'semantic',
    },
    {
      german: "in einer Firma",
      translated: "u poduzeću",
      tone: 'semantic',
    },
    {
      german: "hilft",
      translated: "pomaže",
      tone: 'semantic',
    },
    {
      german: "den Arbeitnehmerinnen und Arbeitnehmern",
      translated: "zaposlenicima",
      tone: 'semantic',
    },
    {
      german: "bei Problemen",
      translated: "kod problema",
      tone: 'semantic',
    },
    {
      german: "mit der Arbeitgeberin/dem Arbeitgeber?",
      translated: "s poslodavcem?",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:286|it": [
    {
      german: "Welche Organisation",
      translated: "Quale istituzione",
      tone: 'semantic',
    },
    {
      german: "in einer Firma",
      translated: "in un’azienda",
      tone: 'semantic',
    },
    {
      german: "hilft",
      translated: "aiuta",
      tone: 'semantic',
    },
    {
      german: "den Arbeitnehmerinnen und Arbeitnehmern",
      translated: "i dipendenti",
      tone: 'semantic',
    },
    {
      german: "bei Problemen",
      translated: "in caso di problemi",
      tone: 'semantic',
    },
    {
      german: "mit der Arbeitgeberin/dem Arbeitgeber?",
      translated: "con il datore di lavoro?",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:286|kmr": [
    {
      german: "Welche Organisation",
      translated: "Kîjan organ",
      tone: 'semantic',
    },
    {
      german: "in einer Firma",
      translated: "di şirketê de",
      tone: 'semantic',
    },
    {
      german: "hilft",
      translated: "alîkarî dike",
      tone: 'semantic',
    },
    {
      german: "den Arbeitnehmerinnen und Arbeitnehmern",
      translated: "ji karkeran re",
      tone: 'semantic',
    },
    {
      german: "bei Problemen",
      translated: "di pirsgirêkên",
      tone: 'semantic',
    },
    {
      german: "mit der Arbeitgeberin/dem Arbeitgeber?",
      translated: "patronê de",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:286|pl": [
    {
      german: "Welche Organisation",
      translated: "Która instytucja",
      tone: 'semantic',
    },
    {
      german: "in einer Firma",
      translated: "w zakładzie pracy",
      tone: 'semantic',
    },
    {
      german: "hilft",
      translated: "pomaga",
      tone: 'semantic',
    },
    {
      german: "den Arbeitnehmerinnen und Arbeitnehmern",
      translated: "pracownikom",
      tone: 'semantic',
    },
    {
      german: "bei Problemen",
      translated: "w problemach",
      tone: 'semantic',
    },
    {
      german: "mit der Arbeitgeberin/dem Arbeitgeber?",
      translated: "z pracodawcą?",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:286|prs": [
    {
      german: "Welche Organisation",
      translated: "کدام نهاد",
      tone: 'semantic',
    },
    {
      german: "in einer Firma",
      translated: "در یک شرکت",
      tone: 'semantic',
    },
    {
      german: "den Arbeitnehmerinnen und Arbeitnehmern",
      translated: "به کارمندان",
      tone: 'semantic',
    },
    {
      german: "bei Problemen",
      translated: "در مشکلات",
      tone: 'semantic',
    },
    {
      german: "mit der Arbeitgeberin/dem Arbeitgeber?",
      translated: "با کارفرما",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:286|ro": [
    {
      german: "Welche Organisation",
      translated: "Ce instituție",
      tone: 'semantic',
    },
    {
      german: "in einer Firma",
      translated: "dintr-o întreprindere",
      tone: 'semantic',
    },
    {
      german: "hilft",
      translated: "îi ajută",
      tone: 'semantic',
    },
    {
      german: "den Arbeitnehmerinnen und Arbeitnehmern",
      translated: "pe angajați",
      tone: 'semantic',
    },
    {
      german: "bei Problemen",
      translated: "în probleme",
      tone: 'semantic',
    },
    {
      german: "mit der Arbeitgeberin/dem Arbeitgeber?",
      translated: "cu angajatorul?",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:286|ru": [
    {
      german: "Welche Organisation",
      translated: "Какая организация",
      tone: 'semantic',
    },
    {
      german: "in einer Firma",
      translated: "на предприятии",
      tone: 'semantic',
    },
    {
      german: "hilft",
      translated: "помогает",
      tone: 'semantic',
    },
    {
      german: "den Arbeitnehmerinnen und Arbeitnehmern",
      translated: "работникам",
      tone: 'semantic',
    },
    {
      german: "bei Problemen",
      translated: "при проблемах",
      tone: 'semantic',
    },
    {
      german: "mit der Arbeitgeberin/dem Arbeitgeber?",
      translated: "с работодателем?",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:286|sq": [
    {
      german: "Welche Organisation",
      translated: "Cili institucion",
      tone: 'semantic',
    },
    {
      german: "in einer Firma",
      translated: "një ndërmarrje",
      tone: 'semantic',
    },
    {
      german: "hilft",
      translated: "i ndihmon",
      tone: 'semantic',
    },
    {
      german: "den Arbeitnehmerinnen und Arbeitnehmern",
      translated: "punonjësit",
      tone: 'semantic',
    },
    {
      german: "bei Problemen",
      translated: "në probleme",
      tone: 'semantic',
    },
    {
      german: "mit der Arbeitgeberin/dem Arbeitgeber?",
      translated: "me punëdhënësin?",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:286|sr": [
    {
      german: "Welche Organisation",
      translated: "Koje tijelo",
      tone: 'semantic',
    },
    {
      german: "in einer Firma",
      translated: "u preduzeću",
      tone: 'semantic',
    },
    {
      german: "hilft",
      translated: "pomaže",
      tone: 'semantic',
    },
    {
      german: "den Arbeitnehmerinnen und Arbeitnehmern",
      translated: "zaposlenima",
      tone: 'semantic',
    },
    {
      german: "bei Problemen",
      translated: "kod problema",
      tone: 'semantic',
    },
    {
      german: "mit der Arbeitgeberin/dem Arbeitgeber?",
      translated: "s poslodavcem?",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:286|tr": [
    {
      german: "Welche Organisation",
      translated: "hangi kuruluş",
      tone: 'semantic',
    },
    {
      german: "in einer Firma",
      translated: "Bir şirkette",
      tone: 'semantic',
    },
    {
      german: "hilft",
      translated: "yardımcı olur",
      tone: 'semantic',
    },
    {
      german: "den Arbeitnehmerinnen und Arbeitnehmern",
      translated: "çalışanlara",
      tone: 'semantic',
    },
    {
      german: "bei Problemen",
      translated: "sorunlarda",
      tone: 'semantic',
    },
    {
      german: "mit der Arbeitgeberin/dem Arbeitgeber?",
      translated: "işverenle",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:286|uk": [
    {
      german: "Welche Organisation",
      translated: "Який орган",
      tone: 'semantic',
    },
    {
      german: "in einer Firma",
      translated: "у компанії",
      tone: 'semantic',
    },
    {
      german: "hilft",
      translated: "допомагає",
      tone: 'semantic',
    },
    {
      german: "den Arbeitnehmerinnen und Arbeitnehmern",
      translated: "працівникам",
      tone: 'semantic',
    },
    {
      german: "bei Problemen",
      translated: "у разі проблем",
      tone: 'semantic',
    },
    {
      german: "mit der Arbeitgeberin/dem Arbeitgeber?",
      translated: "із роботодавцем?",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:286|vi": [
    {
      german: "Welche Organisation",
      translated: "Cơ quan nào",
      tone: 'semantic',
    },
    {
      german: "in einer Firma",
      translated: "trong một doanh nghiệp",
      tone: 'semantic',
    },
    {
      german: "hilft",
      translated: "giúp",
      tone: 'semantic',
    },
    {
      german: "den Arbeitnehmerinnen und Arbeitnehmern",
      translated: "người lao động",
      tone: 'semantic',
    },
    {
      german: "bei Problemen",
      translated: "khi có vấn đề",
      tone: 'semantic',
    },
    {
      german: "mit der Arbeitgeberin/dem Arbeitgeber?",
      translated: "với người sử dụng lao động?",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:287|ar": [
    {
      german: "Sie möchten",
      translated: "تريد",
      tone: 'semantic',
    },
    {
      german: "bei einer Firma",
      translated: "لدى شركة",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "في ألمانيا",
      tone: 'semantic',
    },
    {
      german: "ihr Arbeitsverhältnis",
      translated: "علاقة عملك",
      tone: 'semantic',
    },
    {
      german: "beenden",
      translated: "إنهاء",
      tone: 'semantic',
    },
    {
      german: "Was müssen Sie",
      translated: "ما الذي يجب",
      tone: 'semantic',
    },
    {
      german: "beachten",
      translated: "مراعاته",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:287|bg": [
    {
      german: "Sie möchten",
      translated: "Искате",
      tone: 'semantic',
    },
    {
      german: "bei einer Firma",
      translated: "с фирма",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "в Германия",
      tone: 'semantic',
    },
    {
      german: "ihr Arbeitsverhältnis",
      translated: "трудовото си правоотношение",
      tone: 'semantic',
    },
    {
      german: "beenden",
      translated: "прекратите",
      tone: 'semantic',
    },
    {
      german: "Was müssen Sie",
      translated: "На какво трябва",
      tone: 'semantic',
    },
    {
      german: "beachten",
      translated: "обърнете внимание",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:287|bs": [
    {
      german: "Sie möchten",
      translated: "Želite",
      tone: 'semantic',
    },
    {
      german: "bei einer Firma",
      translated: "s preduzećem",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "u Njemačkoj",
      tone: 'semantic',
    },
    {
      german: "ihr Arbeitsverhältnis",
      translated: "radni odnos",
      tone: 'semantic',
    },
    {
      german: "beenden",
      translated: "prekinuti",
      tone: 'semantic',
    },
    {
      german: "Was müssen Sie",
      translated: "Na što morate",
      tone: 'semantic',
    },
    {
      german: "beachten",
      translated: "paziti",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:287|el": [
    {
      german: "Sie möchten",
      translated: "Θέλετε να",
      tone: 'semantic',
    },
    {
      german: "bei einer Firma",
      translated: " μια εταιρεία",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "στη Γερμανία",
      tone: 'semantic',
    },
    {
      german: "ihr Arbeitsverhältnis",
      translated: " τη σχέση εργασίας σας",
      tone: 'semantic',
    },
    {
      german: "beenden",
      translated: "τερματίσετε",
      tone: 'semantic',
    },
    {
      german: "Was müssen Sie",
      translated: " Σε τι πρέπει να προσέξετε",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:287|en": [
    {
      german: "Sie möchten",
      translated: "You want",
      tone: 'semantic',
    },
    {
      german: "bei einer Firma",
      translated: "at a company",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "in Germany",
      tone: 'semantic',
    },
    {
      german: "ihr Arbeitsverhältnis",
      translated: "your employment",
      tone: 'semantic',
    },
    {
      german: "beenden",
      translated: "end",
      tone: 'semantic',
    },
    {
      german: "Was müssen Sie",
      translated: "What must you",
      tone: 'semantic',
    },
    {
      german: "beachten",
      translated: "observe",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:287|es": [
    {
      german: "Sie möchten",
      translated: "Quieres",
      tone: 'semantic',
    },
    {
      german: "bei einer Firma",
      translated: "con una empresa",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "en Alemania",
      tone: 'semantic',
    },
    {
      german: "ihr Arbeitsverhältnis",
      translated: "tu relación laboral",
      tone: 'semantic',
    },
    {
      german: "beenden",
      translated: "terminar",
      tone: 'semantic',
    },
    {
      german: "Was müssen Sie",
      translated: "¿Qué debes",
      tone: 'semantic',
    },
    {
      german: "beachten",
      translated: "tener en cuenta",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:287|fa": [
    {
      german: "Sie möchten",
      translated: "می‌خواهید",
      tone: 'semantic',
    },
    {
      german: "bei einer Firma",
      translated: "با یک شرکت",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "در آلمان",
      tone: 'semantic',
    },
    {
      german: "ihr Arbeitsverhältnis",
      translated: "رابطهٔ کاری خود را",
      tone: 'semantic',
    },
    {
      german: "Was müssen Sie",
      translated: "باید به چه چیزی توجه کنید",
      tone: 'semantic',
    },
    {
      german: "beachten",
      translated: "؟",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:287|fr": [
    {
      german: "Sie möchten",
      translated: "Vous souhaitez",
      tone: 'semantic',
    },
    {
      german: "bei einer Firma",
      translated: "dans une entreprise",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "allemande",
      tone: 'semantic',
    },
    {
      german: "ihr Arbeitsverhältnis",
      translated: "votre contrat de travail",
      tone: 'semantic',
    },
    {
      german: "beenden",
      translated: "mettre fin à",
      tone: 'semantic',
    },
    {
      german: "Was müssen Sie",
      translated: "Que devez-vous",
      tone: 'semantic',
    },
    {
      german: "beachten",
      translated: "respecter",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:287|hr": [
    {
      german: "Sie möchten",
      translated: "Želite",
      tone: 'semantic',
    },
    {
      german: "bei einer Firma",
      translated: "s poduzećem",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "u Njemačkoj",
      tone: 'semantic',
    },
    {
      german: "ihr Arbeitsverhältnis",
      translated: "radni odnos",
      tone: 'semantic',
    },
    {
      german: "beenden",
      translated: "prekinuti",
      tone: 'semantic',
    },
    {
      german: "Was müssen Sie",
      translated: "Na što morate",
      tone: 'semantic',
    },
    {
      german: "beachten",
      translated: "paziti",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:287|it": [
    {
      german: "Sie möchten",
      translated: "Volete",
      tone: 'semantic',
    },
    {
      german: "bei einer Firma",
      translated: "con un’azienda",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "in Germania",
      tone: 'semantic',
    },
    {
      german: "ihr Arbeitsverhältnis",
      translated: "il rapporto di lavoro",
      tone: 'semantic',
    },
    {
      german: "beenden",
      translated: "terminare",
      tone: 'semantic',
    },
    {
      german: "Was müssen Sie",
      translated: "A che cosa dovete",
      tone: 'semantic',
    },
    {
      german: "beachten",
      translated: "fare attenzione",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:287|kmr": [
    {
      german: "bei einer Firma",
      translated: "li şirkete",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "Almanyayê",
      tone: 'semantic',
    },
    {
      german: "ihr Arbeitsverhältnis",
      translated: "peymana karê xwe",
      tone: 'semantic',
    },
    {
      german: "beenden",
      translated: "biqedînî",
      tone: 'semantic',
    },
    {
      german: "Was müssen Sie",
      translated: "Divê çi",
      tone: 'semantic',
    },
    {
      german: "beachten",
      translated: "biparêzî",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:287|pl": [
    {
      german: "Sie möchten",
      translated: "Chcecie",
      tone: 'semantic',
    },
    {
      german: "bei einer Firma",
      translated: "z firmą",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "w Niemczech",
      tone: 'semantic',
    },
    {
      german: "ihr Arbeitsverhältnis",
      translated: "stosunek pracy",
      tone: 'semantic',
    },
    {
      german: "beenden",
      translated: "zakończyć",
      tone: 'semantic',
    },
    {
      german: "Was müssen Sie",
      translated: "Na co trzeba",
      tone: 'semantic',
    },
    {
      german: "beachten",
      translated: "zwrócić uwagę",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:287|prs": [
    {
      german: "Sie möchten",
      translated: "می‌خواهید",
      tone: 'semantic',
    },
    {
      german: "bei einer Firma",
      translated: "شرکت",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "در آلمان",
      tone: 'semantic',
    },
    {
      german: "ihr Arbeitsverhältnis",
      translated: "رابطهٔ کاری خود",
      tone: 'semantic',
    },
    {
      german: "beenden",
      translated: "پایان دهید",
      tone: 'semantic',
    },
    {
      german: "Was müssen Sie",
      translated: "باید",
      tone: 'semantic',
    },
    {
      german: "beachten",
      translated: "به چه چیزی توجه کنید",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:287|ro": [
    {
      german: "Sie möchten",
      translated: "Vreți să",
      tone: 'semantic',
    },
    {
      german: "bei einer Firma",
      translated: "cu o firmă",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "în Germania",
      tone: 'semantic',
    },
    {
      german: "ihr Arbeitsverhältnis",
      translated: "raportul de muncă",
      tone: 'semantic',
    },
    {
      german: "beenden",
      translated: "încheiați",
      tone: 'semantic',
    },
    {
      german: "Was müssen Sie",
      translated: "La ce trebuie să",
      tone: 'semantic',
    },
    {
      german: "beachten",
      translated: "fiți atent",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:287|ru": [
    {
      german: "Sie möchten",
      translated: "Вы хотите",
      tone: 'semantic',
    },
    {
      german: "bei einer Firma",
      translated: "с фирмой",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "в Германии",
      tone: 'semantic',
    },
    {
      german: "ihr Arbeitsverhältnis",
      translated: "трудовые отношения",
      tone: 'semantic',
    },
    {
      german: "beenden",
      translated: "прекратить",
      tone: 'semantic',
    },
    {
      german: "Was müssen Sie",
      translated: "Что вам нужно",
      tone: 'semantic',
    },
    {
      german: "beachten",
      translated: "учитывать",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:287|sq": [
    {
      german: "Sie möchten",
      translated: "Dëshironi",
      tone: 'semantic',
    },
    {
      german: "bei einer Firma",
      translated: "me një kompani",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "në Gjermani",
      tone: 'semantic',
    },
    {
      german: "ihr Arbeitsverhältnis",
      translated: "marrëdhënien e punës",
      tone: 'semantic',
    },
    {
      german: "beenden",
      translated: "përfundoni",
      tone: 'semantic',
    },
    {
      german: "Was müssen Sie",
      translated: "Për çfarë duhet të keni",
      tone: 'semantic',
    },
    {
      german: "beachten",
      translated: "kujdes",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:287|sr": [
    {
      german: "Sie möchten",
      translated: "Želite",
      tone: 'semantic',
    },
    {
      german: "bei einer Firma",
      translated: "s preduzećem",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "u Nemačkoj",
      tone: 'semantic',
    },
    {
      german: "ihr Arbeitsverhältnis",
      translated: "radni odnos",
      tone: 'semantic',
    },
    {
      german: "beenden",
      translated: "prekinuti",
      tone: 'semantic',
    },
    {
      german: "Was müssen Sie",
      translated: "Na šta morate",
      tone: 'semantic',
    },
    {
      german: "beachten",
      translated: "paziti",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:287|tr": [
    {
      german: "Sie möchten",
      translated: "istiyorsunuz",
      tone: 'semantic',
    },
    {
      german: "bei einer Firma",
      translated: "şirketteki",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "Almanya'da",
      tone: 'semantic',
    },
    {
      german: "ihr Arbeitsverhältnis",
      translated: "iş ilişkinizi",
      tone: 'semantic',
    },
    {
      german: "beenden",
      translated: "sona erdirmek",
      tone: 'semantic',
    },
    {
      german: "Was müssen Sie",
      translated: "Neye",
      tone: 'semantic',
    },
    {
      german: "beachten",
      translated: "dikkat etmeniz gerekir",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:287|uk": [
    {
      german: "Sie möchten",
      translated: "Ви хочете",
      tone: 'semantic',
    },
    {
      german: "bei einer Firma",
      translated: "з компанією",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "в Німеччині",
      tone: 'semantic',
    },
    {
      german: "ihr Arbeitsverhältnis",
      translated: "трудові відносини",
      tone: 'semantic',
    },
    {
      german: "beenden",
      translated: "припинити",
      tone: 'semantic',
    },
    {
      german: "Was müssen Sie",
      translated: "Що потрібно",
      tone: 'semantic',
    },
    {
      german: "beachten",
      translated: "врахувати",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:287|vi": [
    {
      german: "Sie möchten",
      translated: "Bạn muốn",
      tone: 'semantic',
    },
    {
      german: "bei einer Firma",
      translated: "với một công ty",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "ở Đức",
      tone: 'semantic',
    },
    {
      german: "ihr Arbeitsverhältnis",
      translated: "quan hệ lao động",
      tone: 'semantic',
    },
    {
      german: "beenden",
      translated: "chấm dứt",
      tone: 'semantic',
    },
    {
      german: "Was müssen Sie",
      translated: "Bạn phải chú ý",
      tone: 'semantic',
    },
    {
      german: "beachten",
      translated: "điều gì",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:288|ar": [
    {
      german: "Woraus",
      translated: "على ماذا",
      tone: 'semantic',
    },
    {
      german: "begründet sich",
      translated: "تقوم",
      tone: 'semantic',
    },
    {
      german: "Deutschlands besondere Verantwortung",
      translated: "المسؤولية الخاصة لألمانيا",
      tone: 'semantic',
    },
    {
      german: "für Israel",
      translated: "تجاه إسرائيل",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:288|bg": [
    {
      german: "Woraus",
      translated: "От какво",
      tone: 'semantic',
    },
    {
      german: "begründet sich",
      translated: "произтича",
      tone: 'semantic',
    },
    {
      german: "Deutschlands besondere Verantwortung",
      translated: "специалната отговорност на Германия",
      tone: 'semantic',
    },
    {
      german: "für Israel",
      translated: "към Израел",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:288|bs": [
    {
      german: "Woraus",
      translated: "Iz čega",
      tone: 'semantic',
    },
    {
      german: "begründet sich",
      translated: "proizlazi",
      tone: 'semantic',
    },
    {
      german: "Deutschlands besondere Verantwortung",
      translated: "posebna odgovornost Njemačke",
      tone: 'semantic',
    },
    {
      german: "für Israel",
      translated: "prema Izraelu?",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:288|el": [
    {
      german: "Woraus",
      translated: "Από τι",
      tone: 'semantic',
    },
    {
      german: "begründet sich",
      translated: "προκύπτει",
      tone: 'semantic',
    },
    {
      german: "Deutschlands besondere Verantwortung",
      translated: "η ιδιαίτερη ευθύνη της Γερμανίας",
      tone: 'semantic',
    },
    {
      german: "für Israel",
      translated: "απέναντι στο Ισραήλ;",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:288|en": [
    {
      german: "Woraus",
      translated: "What is",
      tone: 'semantic',
    },
    {
      german: "begründet sich",
      translated: "based on",
      tone: 'semantic',
    },
    {
      german: "Deutschlands besondere Verantwortung",
      translated: "Germany's special responsibility",
      tone: 'semantic',
    },
    {
      german: "für Israel",
      translated: "for Israel",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:288|es": [
    {
      german: "Woraus",
      translated: "¿En qué",
      tone: 'semantic',
    },
    {
      german: "begründet sich",
      translated: "se basa",
      tone: 'semantic',
    },
    {
      german: "Deutschlands besondere Verantwortung",
      translated: "la responsabilidad especial de Alemania",
      tone: 'semantic',
    },
    {
      german: "für Israel",
      translated: "hacia Israel",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:288|fa": [
    {
      german: "Woraus",
      translated: "از چه چیزی",
      tone: 'semantic',
    },
    {
      german: "begründet sich",
      translated: "ناشی می‌شود",
      tone: 'semantic',
    },
    {
      german: "Deutschlands besondere Verantwortung",
      translated: "مسئولیت ویژهٔ آلمان در قبال",
      tone: 'semantic',
    },
    {
      german: "für Israel",
      translated: "اسرائیل",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:288|fr": [
    {
      german: "Woraus",
      translated: "Sur quoi",
      tone: 'semantic',
    },
    {
      german: "begründet sich",
      translated: "repose",
      tone: 'semantic',
    },
    {
      german: "Deutschlands besondere Verantwortung",
      translated: "la responsabilité particulière de l’Allemagne",
      tone: 'semantic',
    },
    {
      german: "für Israel",
      translated: "envers Israël",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:288|hr": [
    {
      german: "Woraus",
      translated: "Iz čega",
      tone: 'semantic',
    },
    {
      german: "begründet sich",
      translated: "proizlazi",
      tone: 'semantic',
    },
    {
      german: "Deutschlands besondere Verantwortung",
      translated: "posebna odgovornost Njemačke",
      tone: 'semantic',
    },
    {
      german: "für Israel",
      translated: "prema Izraelu?",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:288|it": [
    {
      german: "Woraus",
      translated: "Da che cosa",
      tone: 'semantic',
    },
    {
      german: "begründet sich",
      translated: "deriva",
      tone: 'semantic',
    },
    {
      german: "Deutschlands besondere Verantwortung",
      translated: "la particolare responsabilità della Germania",
      tone: 'semantic',
    },
    {
      german: "für Israel",
      translated: "nei confronti di Israele",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:288|kmr": [
    {
      german: "Woraus",
      translated: "Berpirsiyariya",
      tone: 'semantic',
    },
    {
      german: "begründet sich",
      translated: "taybet a Almanyayê",
      tone: 'semantic',
    },
    {
      german: "Deutschlands besondere Verantwortung",
      translated: "li hember Îsraîl",
      tone: 'semantic',
    },
    {
      german: "für Israel",
      translated: "ji çi tê",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:288|pl": [
    {
      german: "Woraus",
      translated: "Z czego",
      tone: 'semantic',
    },
    {
      german: "begründet sich",
      translated: "wynika",
      tone: 'semantic',
    },
    {
      german: "Deutschlands besondere Verantwortung",
      translated: "szczególna odpowiedzialność Niemiec",
      tone: 'semantic',
    },
    {
      german: "für Israel",
      translated: "wobec Izraela",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:288|prs": [
    {
      german: "Woraus",
      translated: "از چه چیزی",
      tone: 'semantic',
    },
    {
      german: "begründet sich",
      translated: "ناشی می‌شود",
      tone: 'semantic',
    },
    {
      german: "Deutschlands besondere Verantwortung",
      translated: "مسئولیت ویژهٔ آلمان",
      tone: 'semantic',
    },
    {
      german: "für Israel",
      translated: "در قبال اسرائیل",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:288|ro": [
    {
      german: "Woraus",
      translated: "Din ce",
      tone: 'semantic',
    },
    {
      german: "begründet sich",
      translated: "rezultă",
      tone: 'semantic',
    },
    {
      german: "Deutschlands besondere Verantwortung",
      translated: "responsabilitatea specială a Germaniei",
      tone: 'semantic',
    },
    {
      german: "für Israel",
      translated: "față de Israel",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:288|ru": [
    {
      german: "Woraus",
      translated: "Чем",
      tone: 'semantic',
    },
    {
      german: "begründet sich",
      translated: "обоснована",
      tone: 'semantic',
    },
    {
      german: "Deutschlands besondere Verantwortung",
      translated: "особая ответственность Германии",
      tone: 'semantic',
    },
    {
      german: "für Israel",
      translated: "перед Израилем",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:288|sq": [
    {
      german: "Woraus",
      translated: "Nga",
      tone: 'semantic',
    },
    {
      german: "begründet sich",
      translated: "buron",
      tone: 'semantic',
    },
    {
      german: "Deutschlands besondere Verantwortung",
      translated: "përgjegjësia e veçantë e Gjermanisë",
      tone: 'semantic',
    },
    {
      german: "für Israel",
      translated: "ndaj Izraelit",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:288|sr": [
    {
      german: "Woraus",
      translated: "Iz čega",
      tone: 'semantic',
    },
    {
      german: "begründet sich",
      translated: "proizlazi",
      tone: 'semantic',
    },
    {
      german: "Deutschlands besondere Verantwortung",
      translated: "posebna odgovornost Nemačke",
      tone: 'semantic',
    },
    {
      german: "für Israel",
      translated: "prema Izraelu",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:288|tr": [
    {
      german: "Woraus",
      translated: "neden",
      tone: 'semantic',
    },
    {
      german: "begründet sich",
      translated: "kaynaklanır",
      tone: 'semantic',
    },
    {
      german: "Deutschlands besondere Verantwortung",
      translated: "Almanya'nın İsrail'e karşı özel sorumluluğu",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:288|uk": [
    {
      german: "Woraus",
      translated: "Чим",
      tone: 'semantic',
    },
    {
      german: "begründet sich",
      translated: "обґрунтовується",
      tone: 'semantic',
    },
    {
      german: "Deutschlands besondere Verantwortung",
      translated: "особлива відповідальність",
      tone: 'semantic',
    },
    {
      german: "für Israel",
      translated: "Німеччини перед Ізраїлем",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:288|vi": [
    {
      german: "Woraus",
      translated: "từ đâu?",
      tone: 'semantic',
    },
    {
      german: "begründet sich",
      translated: "bắt nguồn",
      tone: 'semantic',
    },
    {
      german: "Deutschlands besondere Verantwortung",
      translated: "Trách nhiệm đặc biệt của Đức",
      tone: 'semantic',
    },
    {
      german: "für Israel",
      translated: "đối với Israel",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:289|ar": [
    {
      german: "Ein Mann mit dunkler Hautfarbe",
      translated: "رجل ذو بشرة داكنة",
      tone: 'semantic',
    },
    {
      german: "in einem Restaurant",
      translated: "في مطعم",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "بألمانيا",
      tone: 'semantic',
    },
    {
      german: "Was ist ein Beispiel für Diskriminierung",
      translated: "ما مثال على التمييز",
      tone: 'semantic',
    },
    {
      german: "Er bekommt die Stelle",
      translated: "لا يحصل على الوظيفة",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:289|bg": [
    {
      german: "Ein Mann mit dunkler Hautfarbe",
      translated: "Мъж с тъмна кожа",
      tone: 'semantic',
    },
    {
      german: "bewirbt sich um eine Stelle",
      translated: "кандидатства за работа",
      tone: 'semantic',
    },
    {
      german: "als Kellner",
      translated: "като сервитьор",
      tone: 'semantic',
    },
    {
      german: "in einem Restaurant",
      translated: "в ресторант",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "в Германия",
      tone: 'semantic',
    },
    {
      german: "Was ist ein Beispiel für Diskriminierung",
      translated: "Кое е дискриминация?",
      tone: 'semantic',
    },
    {
      german: "Er bekommt die Stelle",
      translated: "Не получава работата",
      tone: 'semantic',
    },
    {
      german: "nur deshalb nicht",
      translated: "само",
      tone: 'semantic',
    },
    {
      german: "weil",
      translated: "защото",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:289|bs": [
    {
      german: "Ein Mann mit dunkler Hautfarbe",
      translated: "Muškarac tamne boje kože",
      tone: 'semantic',
    },
    {
      german: "bewirbt sich um eine Stelle",
      translated: "prijavljuje se za posao",
      tone: 'semantic',
    },
    {
      german: "als Kellner",
      translated: "konobara",
      tone: 'semantic',
    },
    {
      german: "in einem Restaurant",
      translated: "u restoranu",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "u Njemačkoj",
      tone: 'semantic',
    },
    {
      german: "Was ist ein Beispiel für Diskriminierung",
      translated: "Koja je situacija diskriminacija",
      tone: 'semantic',
    },
    {
      german: "Er bekommt die Stelle",
      translated: "Ne dobiva posao",
      tone: 'semantic',
    },
    {
      german: "nur deshalb nicht",
      translated: "isključivo",
      tone: 'semantic',
    },
    {
      german: "weil",
      translated: "zato što",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:289|el": [
    {
      german: "Ein Mann mit dunkler Hautfarbe",
      translated: "Ένας άνδρας με σκούρο δέρμα",
      tone: 'semantic',
    },
    {
      german: "bewirbt sich um eine Stelle",
      translated: "κάνει αίτηση για θέση",
      tone: 'semantic',
    },
    {
      german: "als Kellner",
      translated: "σερβιτόρου",
      tone: 'semantic',
    },
    {
      german: "in einem Restaurant",
      translated: "σε εστιατόριο",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "στη Γερμανία",
      tone: 'semantic',
    },
    {
      german: "Was ist ein Beispiel für Diskriminierung",
      translated: "Ποια περίπτωση είναι διάκριση",
      tone: 'semantic',
    },
    {
      german: "Er bekommt die Stelle",
      translated: "Δεν παίρνει τη δουλειά",
      tone: 'semantic',
    },
    {
      german: "nur deshalb nicht",
      translated: "μόνο επειδή",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:289|en": [
    {
      german: "Ein Mann mit dunkler Hautfarbe",
      translated: "A man with dark skin",
      tone: 'semantic',
    },
    {
      german: "bewirbt sich um eine Stelle",
      translated: "applies for a job",
      tone: 'semantic',
    },
    {
      german: "als Kellner",
      translated: "as a waiter",
      tone: 'semantic',
    },
    {
      german: "in einem Restaurant",
      translated: "in a restaurant",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "in Germany",
      tone: 'semantic',
    },
    {
      german: "Was ist ein Beispiel für Diskriminierung",
      translated: "What is an example of discrimination",
      tone: 'semantic',
    },
    {
      german: "Er bekommt die Stelle",
      translated: "get the job",
      tone: 'semantic',
    },
    {
      german: "nur deshalb nicht",
      translated: "doesn't",
      tone: 'semantic',
    },
    {
      german: "weil",
      translated: "because",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:289|es": [
    {
      german: "Ein Mann mit dunkler Hautfarbe",
      translated: "Un hombre de piel oscura",
      tone: 'semantic',
    },
    {
      german: "bewirbt sich um eine Stelle",
      translated: "solicita un empleo",
      tone: 'semantic',
    },
    {
      german: "als Kellner",
      translated: "como camarero",
      tone: 'semantic',
    },
    {
      german: "in einem Restaurant",
      translated: "en un restaurante",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "en Alemania",
      tone: 'semantic',
    },
    {
      german: "Was ist ein Beispiel für Diskriminierung",
      translated: "¿Qué sería un ejemplo de discriminación?",
      tone: 'semantic',
    },
    {
      german: "Er bekommt die Stelle",
      translated: "No obtiene el empleo",
      tone: 'semantic',
    },
    {
      german: "nur deshalb nicht",
      translated: "únicamente porque",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:289|fa": [
    {
      german: "Ein Mann mit dunkler Hautfarbe",
      translated: "مردی با پوست تیره",
      tone: 'semantic',
    },
    {
      german: "bewirbt sich um eine Stelle",
      translated: "برای شغل",
      tone: 'semantic',
    },
    {
      german: "als Kellner",
      translated: "پیشخدمت",
      tone: 'semantic',
    },
    {
      german: "in einem Restaurant",
      translated: "در رستورانی",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "در آلمان",
      tone: 'semantic',
    },
    {
      german: "Was ist ein Beispiel für Diskriminierung",
      translated: "کدام مورد نمونهٔ تبعیض است؟",
      tone: 'semantic',
    },
    {
      german: "Er bekommt die Stelle",
      translated: "شغل را نمی‌گیرد",
      tone: 'semantic',
    },
    {
      german: "nur deshalb nicht",
      translated: "فقط به این دلیل",
      tone: 'semantic',
    },
    {
      german: "weil",
      translated: "که …",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:289|fr": [
    {
      german: "Ein Mann mit dunkler Hautfarbe",
      translated: "Un homme à la peau foncée",
      tone: 'semantic',
    },
    {
      german: "bewirbt sich um eine Stelle",
      translated: "postule",
      tone: 'semantic',
    },
    {
      german: "als Kellner",
      translated: "comme serveur",
      tone: 'semantic',
    },
    {
      german: "in einem Restaurant",
      translated: "dans un restaurant",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "en Allemagne",
      tone: 'semantic',
    },
    {
      german: "Was ist ein Beispiel für Diskriminierung",
      translated: "Quel serait un exemple de discrimination",
      tone: 'semantic',
    },
    {
      german: "Er bekommt die Stelle",
      translated: "Il n’obtient le poste",
      tone: 'semantic',
    },
    {
      german: "nur deshalb nicht",
      translated: "uniquement",
      tone: 'semantic',
    },
    {
      german: "weil",
      translated: "parce que",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:289|hr": [
    {
      german: "Ein Mann mit dunkler Hautfarbe",
      translated: "Muškarac tamne boje kože",
      tone: 'semantic',
    },
    {
      german: "bewirbt sich um eine Stelle",
      translated: "prijavljuje se za posao",
      tone: 'semantic',
    },
    {
      german: "als Kellner",
      translated: "konobara",
      tone: 'semantic',
    },
    {
      german: "in einem Restaurant",
      translated: "u restoranu",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "u Njemačkoj",
      tone: 'semantic',
    },
    {
      german: "Was ist ein Beispiel für Diskriminierung",
      translated: "Koja je situacija diskriminacija",
      tone: 'semantic',
    },
    {
      german: "Er bekommt die Stelle",
      translated: "Ne dobiva posao",
      tone: 'semantic',
    },
    {
      german: "nur deshalb nicht",
      translated: "isključivo",
      tone: 'semantic',
    },
    {
      german: "weil",
      translated: "zato što",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:289|it": [
    {
      german: "Ein Mann mit dunkler Hautfarbe",
      translated: "Un uomo con la pelle scura",
      tone: 'semantic',
    },
    {
      german: "bewirbt sich um eine Stelle",
      translated: "si candida per un posto",
      tone: 'semantic',
    },
    {
      german: "als Kellner",
      translated: "da cameriere",
      tone: 'semantic',
    },
    {
      german: "in einem Restaurant",
      translated: "in un ristorante",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "in Germania",
      tone: 'semantic',
    },
    {
      german: "Was ist ein Beispiel für Diskriminierung",
      translated: "Quale situazione è discriminazione?",
      tone: 'semantic',
    },
    {
      german: "Er bekommt die Stelle",
      translated: "ottiene il posto",
      tone: 'semantic',
    },
    {
      german: "nur deshalb nicht",
      translated: "Non",
      tone: 'semantic',
    },
    {
      german: "weil",
      translated: "perché",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:289|kmr": [
    {
      german: "Ein Mann mit dunkler Hautfarbe",
      translated: "Mêrek bi çermê tarî",
      tone: 'semantic',
    },
    {
      german: "bewirbt sich um eine Stelle",
      translated: "ji bo karekî",
      tone: 'semantic',
    },
    {
      german: "als Kellner",
      translated: "wek garson",
      tone: 'semantic',
    },
    {
      german: "in einem Restaurant",
      translated: "li restorantekê",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "li Almanyayê",
      tone: 'semantic',
    },
    {
      german: "Was ist ein Beispiel für Diskriminierung",
      translated: "Kîjan mînak cudakarî ye",
      tone: 'semantic',
    },
    {
      german: "Er bekommt die Stelle",
      translated: "Ew karê",
      tone: 'semantic',
    },
    {
      german: "nur deshalb nicht",
      translated: "tenê",
      tone: 'semantic',
    },
    {
      german: "weil",
      translated: "ji ber ku",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:289|pl": [
    {
      german: "Ein Mann mit dunkler Hautfarbe",
      translated: "Mężczyzna o ciemnej skórze",
      tone: 'semantic',
    },
    {
      german: "bewirbt sich um eine Stelle",
      translated: "ubiega się o pracę",
      tone: 'semantic',
    },
    {
      german: "als Kellner",
      translated: "kelnera",
      tone: 'semantic',
    },
    {
      german: "Was ist ein Beispiel für Diskriminierung",
      translated: "Która sytuacja jest dyskryminacją?",
      tone: 'semantic',
    },
    {
      german: "Er bekommt die Stelle",
      translated: "Nie otrzymuje pracy",
      tone: 'semantic',
    },
    {
      german: "nur deshalb nicht",
      translated: "wyłącznie dlatego, że",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:289|prs": [
    {
      german: "Ein Mann mit dunkler Hautfarbe",
      translated: "مردی با پوست تیره",
      tone: 'semantic',
    },
    {
      german: "als Kellner",
      translated: "پیشخدمت",
      tone: 'semantic',
    },
    {
      german: "in einem Restaurant",
      translated: "در رستورانی",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "در آلمان",
      tone: 'semantic',
    },
    {
      german: "Was ist ein Beispiel für Diskriminierung",
      translated: "کدام مورد نمونهٔ تبعیض است؟",
      tone: 'semantic',
    },
    {
      german: "weil",
      translated: "که",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:289|ro": [
    {
      german: "Ein Mann mit dunkler Hautfarbe",
      translated: "Un bărbat cu pielea închisă la culoare",
      tone: 'semantic',
    },
    {
      german: "bewirbt sich um eine Stelle",
      translated: "candidează pentru un post",
      tone: 'semantic',
    },
    {
      german: "als Kellner",
      translated: "de ospătar",
      tone: 'semantic',
    },
    {
      german: "in einem Restaurant",
      translated: "într-un restaurant",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "din Germania",
      tone: 'semantic',
    },
    {
      german: "Was ist ein Beispiel für Diskriminierung",
      translated: "Care situație este discriminare",
      tone: 'semantic',
    },
    {
      german: "Er bekommt die Stelle",
      translated: "Nu primește postul",
      tone: 'semantic',
    },
    {
      german: "nur deshalb nicht",
      translated: "numai",
      tone: 'semantic',
    },
    {
      german: "weil",
      translated: "pentru că …",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:289|ru": [
    {
      german: "Ein Mann mit dunkler Hautfarbe",
      translated: "Мужчина с тёмным цветом кожи",
      tone: 'semantic',
    },
    {
      german: "bewirbt sich um eine Stelle",
      translated: "подаёт заявку",
      tone: 'semantic',
    },
    {
      german: "als Kellner",
      translated: "на должность официанта",
      tone: 'semantic',
    },
    {
      german: "in einem Restaurant",
      translated: "в ресторане",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "в Германии",
      tone: 'semantic',
    },
    {
      german: "Was ist ein Beispiel für Diskriminierung",
      translated: "Что является примером дискриминации",
      tone: 'semantic',
    },
    {
      german: "Er bekommt die Stelle",
      translated: "Он не получает должность",
      tone: 'semantic',
    },
    {
      german: "nur deshalb nicht",
      translated: "только потому что",
      tone: 'semantic',
    },
    {
      german: "weil",
      translated: "…",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:289|sq": [
    {
      german: "Ein Mann mit dunkler Hautfarbe",
      translated: "Një burrë me lëkurë të errët",
      tone: 'semantic',
    },
    {
      german: "bewirbt sich um eine Stelle",
      translated: "aplikon si kamerier",
      tone: 'semantic',
    },
    {
      german: "Was ist ein Beispiel für Diskriminierung",
      translated: "Cila situatë është diskriminim",
      tone: 'semantic',
    },
    {
      german: "Er bekommt die Stelle",
      translated: "Nuk e merr vendin",
      tone: 'semantic',
    },
    {
      german: "nur deshalb nicht",
      translated: "vetëm sepse",
      tone: 'semantic',
    },
    {
      german: "weil",
      translated: "…",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:289|sr": [
    {
      german: "Ein Mann mit dunkler Hautfarbe",
      translated: "Muškarac tamne boje kože",
      tone: 'semantic',
    },
    {
      german: "bewirbt sich um eine Stelle",
      translated: "prijavljuje se za posao",
      tone: 'semantic',
    },
    {
      german: "als Kellner",
      translated: "konobara",
      tone: 'semantic',
    },
    {
      german: "in einem Restaurant",
      translated: "u restoranu",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "u Nemačkoj",
      tone: 'semantic',
    },
    {
      german: "Was ist ein Beispiel für Diskriminierung",
      translated: "Koja je situacija diskriminacija",
      tone: 'semantic',
    },
    {
      german: "Er bekommt die Stelle",
      translated: "Ne dobiva posao",
      tone: 'semantic',
    },
    {
      german: "nur deshalb nicht",
      translated: "isključivo",
      tone: 'semantic',
    },
    {
      german: "weil",
      translated: "zato što",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:289|tr": [
    {
      german: "Ein Mann mit dunkler Hautfarbe",
      translated: "Koyu tenli bir erkek",
      tone: 'semantic',
    },
    {
      german: "bewirbt sich um eine Stelle",
      translated: "işine başvuruyor",
      tone: 'semantic',
    },
    {
      german: "als Kellner",
      translated: "garsonluk",
      tone: 'semantic',
    },
    {
      german: "in einem Restaurant",
      translated: "bir restoranda",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "Almanya'da",
      tone: 'semantic',
    },
    {
      german: "Was ist ein Beispiel für Diskriminierung",
      translated: "Aşağıdakilerden hangisi ayrımcılığa örnektir?",
      tone: 'semantic',
    },
    {
      german: "Er bekommt die Stelle",
      translated: "İşe",
      tone: 'semantic',
    },
    {
      german: "nur deshalb nicht",
      translated: "yalnızca",
      tone: 'semantic',
    },
    {
      german: "weil",
      translated: "nedeniyle",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:289|uk": [
    {
      german: "Ein Mann mit dunkler Hautfarbe",
      translated: "Чоловік із темним кольором шкіри",
      tone: 'semantic',
    },
    {
      german: "bewirbt sich um eine Stelle",
      translated: "подає заявку на роботу",
      tone: 'semantic',
    },
    {
      german: "als Kellner",
      translated: " офіціантом ",
      tone: 'semantic',
    },
    {
      german: "in einem Restaurant",
      translated: "у ресторані",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "в Німеччині",
      tone: 'semantic',
    },
    {
      german: "Was ist ein Beispiel für Diskriminierung",
      translated: "Що є прикладом дискримінації",
      tone: 'semantic',
    },
    {
      german: "Er bekommt die Stelle",
      translated: "Він не отримує роботу",
      tone: 'semantic',
    },
    {
      german: "nur deshalb nicht",
      translated: "лише тому",
      tone: 'semantic',
    },
    {
      german: "weil",
      translated: "що",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:289|vi": [
    {
      german: "Ein Mann mit dunkler Hautfarbe",
      translated: "Một người đàn ông da sẫm màu",
      tone: 'semantic',
    },
    {
      german: "bewirbt sich um eine Stelle",
      translated: "xin việc",
      tone: 'semantic',
    },
    {
      german: "als Kellner",
      translated: "phục vụ bàn",
      tone: 'semantic',
    },
    {
      german: "in einem Restaurant",
      translated: "tại một nhà hàng",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "ở Đức",
      tone: 'semantic',
    },
    {
      german: "Was ist ein Beispiel für Diskriminierung",
      translated: "Trường hợp nào là phân biệt đối xử?",
      tone: 'semantic',
    },
    {
      german: "Er bekommt die Stelle",
      translated: "Anh không được nhận",
      tone: 'semantic',
    },
    {
      german: "nur deshalb nicht",
      translated: "chỉ vì",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:28|ar": [
    {
      german: "Wer",
      translated: "من",
      tone: 'semantic',
    },
    {
      german: "wählt",
      translated: "ينتخب",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "في ألمانيا",
      tone: 'semantic',
    },
    {
      german: "die Abgeordneten",
      translated: "أعضاء",
      tone: 'semantic',
    },
    {
      german: "zum Bundestag",
      translated: "البوندستاغ",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:28|bg": [
    {
      german: "Wer",
      translated: "Кой",
      tone: 'semantic',
    },
    {
      german: "wählt",
      translated: "избира",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "в германския",
      tone: 'semantic',
    },
    {
      german: "die Abgeordneten",
      translated: "депутатите",
      tone: 'semantic',
    },
    {
      german: "zum Bundestag",
      translated: "Бундестаг?",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:28|bs": [
    {
      german: "Wer",
      translated: "Tko",
      tone: 'semantic',
    },
    {
      german: "wählt",
      translated: "bira",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "njemačkog",
      tone: 'semantic',
    },
    {
      german: "die Abgeordneten",
      translated: "zastupnike",
      tone: 'semantic',
    },
    {
      german: "zum Bundestag",
      translated: "Bundestaga",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:28|el": [
    {
      german: "Wer",
      translated: "Ποιος",
      tone: 'semantic',
    },
    {
      german: "wählt",
      translated: "εκλέγει",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "στη Γερμανία",
      tone: 'semantic',
    },
    {
      german: "die Abgeordneten",
      translated: "τους βουλευτές",
      tone: 'semantic',
    },
    {
      german: "zum Bundestag",
      translated: "του Bundestag",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:28|en": [
    {
      german: "Wer",
      translated: "Who",
      tone: 'semantic',
    },
    {
      german: "wählt",
      translated: "elects",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "in Germany",
      tone: 'semantic',
    },
    {
      german: "die Abgeordneten",
      translated: "the members",
      tone: 'semantic',
    },
    {
      german: "zum Bundestag",
      translated: "of the Bundestag",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:28|es": [
    {
      german: "Wer",
      translated: "¿Quién",
      tone: 'semantic',
    },
    {
      german: "wählt",
      translated: "elige",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "en Alemania",
      tone: 'semantic',
    },
    {
      german: "die Abgeordneten",
      translated: "a los diputados",
      tone: 'semantic',
    },
    {
      german: "zum Bundestag",
      translated: "del Bundestag",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:28|fa": [
    {
      german: "Wer",
      translated: "چه کسانی",
      tone: 'semantic',
    },
    {
      german: "wählt",
      translated: "انتخاب می‌کنند",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "آلمان",
      tone: 'semantic',
    },
    {
      german: "die Abgeordneten",
      translated: "نمایندگان",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:28|fr": [
    {
      german: "Wer",
      translated: "Qui",
      tone: 'semantic',
    },
    {
      german: "wählt",
      translated: "élit",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "en Allemagne",
      tone: 'semantic',
    },
    {
      german: "die Abgeordneten",
      translated: "les députés",
      tone: 'semantic',
    },
    {
      german: "zum Bundestag",
      translated: "du Bundestag",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:28|hr": [
    {
      german: "Wer",
      translated: "Tko",
      tone: 'semantic',
    },
    {
      german: "wählt",
      translated: "bira",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "njemačkog",
      tone: 'semantic',
    },
    {
      german: "die Abgeordneten",
      translated: "zastupnike",
      tone: 'semantic',
    },
    {
      german: "zum Bundestag",
      translated: "Bundestaga",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:28|it": [
    {
      german: "Wer",
      translated: "Chi",
      tone: 'semantic',
    },
    {
      german: "wählt",
      translated: "elegge",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "in Germania",
      tone: 'semantic',
    },
    {
      german: "die Abgeordneten",
      translated: "i deputati",
      tone: 'semantic',
    },
    {
      german: "zum Bundestag",
      translated: "del Bundestag",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:28|kmr": [
    {
      german: "Wer",
      translated: "Li Almanyayê",
      tone: 'semantic',
    },
    {
      german: "wählt",
      translated: "kî",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "endamên",
      tone: 'semantic',
    },
    {
      german: "die Abgeordneten",
      translated: "hildibijêre",
      tone: 'semantic',
    },
    {
      german: "zum Bundestag",
      translated: "Bundestagê",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:28|pl": [
    {
      german: "Wer",
      translated: "Kto",
      tone: 'semantic',
    },
    {
      german: "wählt",
      translated: "wybiera",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "do niemieckiego",
      tone: 'semantic',
    },
    {
      german: "die Abgeordneten",
      translated: "posłów",
      tone: 'semantic',
    },
    {
      german: "zum Bundestag",
      translated: "Bundestagu",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:28|prs": [
    {
      german: "Wer",
      translated: "چه کسانی",
      tone: 'semantic',
    },
    {
      german: "wählt",
      translated: "انتخاب می‌کنند",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "آلمان",
      tone: 'semantic',
    },
    {
      german: "die Abgeordneten",
      translated: "نمایندگان",
      tone: 'semantic',
    },
    {
      german: "zum Bundestag",
      translated: "بوندستاگ",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:28|ro": [
    {
      german: "Wer",
      translated: "Cine",
      tone: 'semantic',
    },
    {
      german: "wählt",
      translated: "îi alege",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "în Germania",
      tone: 'semantic',
    },
    {
      german: "die Abgeordneten",
      translated: "pe deputații",
      tone: 'semantic',
    },
    {
      german: "zum Bundestag",
      translated: "Bundestagului",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:28|ru": [
    {
      german: "Wer",
      translated: "Кто",
      tone: 'semantic',
    },
    {
      german: "wählt",
      translated: "избирает",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "в Германии",
      tone: 'semantic',
    },
    {
      german: "die Abgeordneten",
      translated: "депутатов",
      tone: 'semantic',
    },
    {
      german: "zum Bundestag",
      translated: "Бундестага",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:28|sq": [
    {
      german: "Wer",
      translated: "Kush",
      tone: 'semantic',
    },
    {
      german: "wählt",
      translated: "zgjedh",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "në Gjermani",
      tone: 'semantic',
    },
    {
      german: "die Abgeordneten",
      translated: "deputetët e",
      tone: 'semantic',
    },
    {
      german: "zum Bundestag",
      translated: "Bundestagut",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:28|sr": [
    {
      german: "Wer",
      translated: "Ko",
      tone: 'semantic',
    },
    {
      german: "wählt",
      translated: "bira",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "nemačkog",
      tone: 'semantic',
    },
    {
      german: "die Abgeordneten",
      translated: "poslanike",
      tone: 'semantic',
    },
    {
      german: "zum Bundestag",
      translated: "Bundestaga",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:28|tr": [
    {
      german: "Wer",
      translated: "kim",
      tone: 'semantic',
    },
    {
      german: "wählt",
      translated: "seçer",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "Almanya'da",
      tone: 'semantic',
    },
    {
      german: "die Abgeordneten",
      translated: "milletvekillerini",
      tone: 'semantic',
    },
    {
      german: "zum Bundestag",
      translated: "Federal Meclis (Bundestag)",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:28|uk": [
    {
      german: "Wer",
      translated: "Хто",
      tone: 'semantic',
    },
    {
      german: "wählt",
      translated: "обирає",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "в Німеччині",
      tone: 'semantic',
    },
    {
      german: "die Abgeordneten",
      translated: "депутатів",
      tone: 'semantic',
    },
    {
      german: "zum Bundestag",
      translated: "Бундестагу",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:28|vi": [
    {
      german: "Wer",
      translated: "Ai",
      tone: 'semantic',
    },
    {
      german: "wählt",
      translated: "bầu",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "ở Đức",
      tone: 'semantic',
    },
    {
      german: "die Abgeordneten",
      translated: "các nghị sĩ",
      tone: 'semantic',
    },
    {
      german: "zum Bundestag",
      translated: "Bundestag",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:290|ar": [
    {
      german: "Sie haben",
      translated: "اشتريت",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "في ألمانيا",
      tone: 'semantic',
    },
    {
      german: "einen Fernseher gekauft",
      translated: "، وعندما",
      tone: 'semantic',
    },
    {
      german: "Zu Hause",
      translated: "في المنزل",
      tone: 'semantic',
    },
    {
      german: "packen Sie den Fernseher aus",
      translated: "فتحته",
      tone: 'semantic',
    },
    {
      german: "doch er funktioniert nicht",
      translated: "وجدته لا يعمل",
      tone: 'semantic',
    },
    {
      german: "Was können Sie machen",
      translated: "ماذا يمكنك أن تفعل",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:290|bg": [
    {
      german: "Sie haben",
      translated: "сте",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "В Германия",
      tone: 'semantic',
    },
    {
      german: "einen Fernseher gekauft",
      translated: "купили телевизор",
      tone: 'semantic',
    },
    {
      german: "Zu Hause",
      translated: "У дома",
      tone: 'semantic',
    },
    {
      german: "packen Sie den Fernseher aus",
      translated: "го разопаковате",
      tone: 'semantic',
    },
    {
      german: "doch er funktioniert nicht",
      translated: "но той не работи",
      tone: 'semantic',
    },
    {
      german: "Der Fernseher ist kaputt",
      translated: "Телевизорът е повреден",
      tone: 'semantic',
    },
    {
      german: "Was können Sie machen",
      translated: "Какво можете да направите",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:290|bs": [
    {
      german: "Sie haben",
      translated: "ste",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "U Njemačkoj",
      tone: 'semantic',
    },
    {
      german: "einen Fernseher gekauft",
      translated: "kupili televizor",
      tone: 'semantic',
    },
    {
      german: "Zu Hause",
      translated: "Kod kuće",
      tone: 'semantic',
    },
    {
      german: "packen Sie den Fernseher aus",
      translated: "ga raspakirate",
      tone: 'semantic',
    },
    {
      german: "doch er funktioniert nicht",
      translated: "ali ne radi",
      tone: 'semantic',
    },
    {
      german: "Der Fernseher ist kaputt",
      translated: "Televizor je pokvaren",
      tone: 'semantic',
    },
    {
      german: "Was können Sie machen",
      translated: "Što možete učiniti",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:290|el": [
    {
      german: "in Deutschland",
      translated: "στη Γερμανία",
      tone: 'semantic',
    },
    {
      german: "einen Fernseher gekauft",
      translated: "Αγοράσατε μια τηλεόραση",
      tone: 'semantic',
    },
    {
      german: "Zu Hause",
      translated: "Στο σπίτι",
      tone: 'semantic',
    },
    {
      german: "packen Sie den Fernseher aus",
      translated: "την αποσυσκευάζετε",
      tone: 'semantic',
    },
    {
      german: "doch er funktioniert nicht",
      translated: "αλλά δεν λειτουργεί",
      tone: 'semantic',
    },
    {
      german: "Der Fernseher ist kaputt",
      translated: "η τηλεόραση είναι χαλασμένη",
      tone: 'semantic',
    },
    {
      german: "Was können Sie machen",
      translated: "Τι μπορείτε να κάνετε;",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:290|en": [
    {
      german: "Sie haben",
      translated: "You bought",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "in Germany",
      tone: 'semantic',
    },
    {
      german: "einen Fernseher gekauft",
      translated: "a television",
      tone: 'semantic',
    },
    {
      german: "Zu Hause",
      translated: "At home",
      tone: 'semantic',
    },
    {
      german: "packen Sie den Fernseher aus",
      translated: "you unpack the television",
      tone: 'semantic',
    },
    {
      german: "doch er funktioniert nicht",
      translated: "but it doesn't work",
      tone: 'semantic',
    },
    {
      german: "Der Fernseher ist kaputt",
      translated: "The television is broken",
      tone: 'semantic',
    },
    {
      german: "Was können Sie machen",
      translated: "What can you do",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:290|es": [
    {
      german: "Sie haben",
      translated: "Has",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "en Alemania",
      tone: 'semantic',
    },
    {
      german: "einen Fernseher gekauft",
      translated: "comprado un televisor",
      tone: 'semantic',
    },
    {
      german: "Zu Hause",
      translated: "en casa",
      tone: 'semantic',
    },
    {
      german: "packen Sie den Fernseher aus",
      translated: "Al abrirlo",
      tone: 'semantic',
    },
    {
      german: "doch er funktioniert nicht",
      translated: "no funciona",
      tone: 'semantic',
    },
    {
      german: "Der Fernseher ist kaputt",
      translated: "El televisor está averiado",
      tone: 'semantic',
    },
    {
      german: "Was können Sie machen",
      translated: "¿Qué puedes hacer?",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:290|fa": [
    {
      german: "in Deutschland",
      translated: "در آلمان",
      tone: 'semantic',
    },
    {
      german: "einen Fernseher gekauft",
      translated: "تلویزیونی خریده‌اید",
      tone: 'semantic',
    },
    {
      german: "Zu Hause",
      translated: "در خانه",
      tone: 'semantic',
    },
    {
      german: "doch er funktioniert nicht",
      translated: "متوجه می‌شوید خراب است",
      tone: 'semantic',
    },
    {
      german: "Was können Sie machen",
      translated: "چه می‌توانید بکنید؟",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:290|fr": [
    {
      german: "Sie haben",
      translated: "Vous avez",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "en Allemagne",
      tone: 'semantic',
    },
    {
      german: "einen Fernseher gekauft",
      translated: "acheté un téléviseur",
      tone: 'semantic',
    },
    {
      german: "Zu Hause",
      translated: "À la maison",
      tone: 'semantic',
    },
    {
      german: "packen Sie den Fernseher aus",
      translated: "vous le déballez",
      tone: 'semantic',
    },
    {
      german: "doch er funktioniert nicht",
      translated: "mais il ne fonctionne pas",
      tone: 'semantic',
    },
    {
      german: "Der Fernseher ist kaputt",
      translated: "Le téléviseur est cassé",
      tone: 'semantic',
    },
    {
      german: "Was können Sie machen",
      translated: "Que pouvez-vous faire",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:290|hr": [
    {
      german: "Sie haben",
      translated: "ste",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "U Njemačkoj",
      tone: 'semantic',
    },
    {
      german: "einen Fernseher gekauft",
      translated: "kupili televizor",
      tone: 'semantic',
    },
    {
      german: "Zu Hause",
      translated: "Kod kuće",
      tone: 'semantic',
    },
    {
      german: "packen Sie den Fernseher aus",
      translated: "ga raspakirate",
      tone: 'semantic',
    },
    {
      german: "doch er funktioniert nicht",
      translated: "ali ne radi",
      tone: 'semantic',
    },
    {
      german: "Der Fernseher ist kaputt",
      translated: "Televizor je pokvaren",
      tone: 'semantic',
    },
    {
      german: "Was können Sie machen",
      translated: "Što možete učiniti",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:290|it": [
    {
      german: "Sie haben",
      translated: "Avete",
      tone: 'semantic',
    },
    {
      german: "einen Fernseher gekauft",
      translated: "comprato un televisore",
      tone: 'semantic',
    },
    {
      german: "Zu Hause",
      translated: "a casa",
      tone: 'semantic',
    },
    {
      german: "packen Sie den Fernseher aus",
      translated: "scoprite",
      tone: 'semantic',
    },
    {
      german: "doch er funktioniert nicht",
      translated: "è difettoso",
      tone: 'semantic',
    },
    {
      german: "Was können Sie machen",
      translated: "Che cosa potete fare",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:290|kmr": [
    {
      german: "Sie haben",
      translated: "Te",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "li Almanyayê",
      tone: 'semantic',
    },
    {
      german: "einen Fernseher gekauft",
      translated: "televîzyonek kirî",
      tone: 'semantic',
    },
    {
      german: "Zu Hause",
      translated: "Li malê",
      tone: 'semantic',
    },
    {
      german: "packen Sie den Fernseher aus",
      translated: "televîzyonê ji qutiyê derdixî",
      tone: 'semantic',
    },
    {
      german: "doch er funktioniert nicht",
      translated: "lê ew kar nake",
      tone: 'semantic',
    },
    {
      german: "Der Fernseher ist kaputt",
      translated: "Televîzyon xerab e",
      tone: 'semantic',
    },
    {
      german: "Was können Sie machen",
      translated: "Çi dikarî bikî",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:290|pl": [
    {
      german: "einen Fernseher gekauft",
      translated: "Kupiliście telewizor",
      tone: 'semantic',
    },
    {
      german: "Zu Hause",
      translated: "w domu",
      tone: 'semantic',
    },
    {
      german: "doch er funktioniert nicht",
      translated: "okazuje się, że jest uszkodzony",
      tone: 'semantic',
    },
    {
      german: "Was können Sie machen",
      translated: "Co możecie zrobić",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:290|prs": [
    {
      german: "in Deutschland",
      translated: "در آلمان",
      tone: 'semantic',
    },
    {
      german: "einen Fernseher gekauft",
      translated: "تلویزیونی خریده‌اید",
      tone: 'semantic',
    },
    {
      german: "Der Fernseher ist kaputt",
      translated: "متوجه می‌شوید خراب است",
      tone: 'semantic',
    },
    {
      german: "Was können Sie machen",
      translated: "چه می‌توانید بکنید؟",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:290|ro": [
    {
      german: "Sie haben",
      translated: "Ați",
      tone: 'semantic',
    },
    {
      german: "einen Fernseher gekauft",
      translated: "cumpărat un televizor",
      tone: 'semantic',
    },
    {
      german: "Zu Hause",
      translated: "acasă",
      tone: 'semantic',
    },
    {
      german: "Der Fernseher ist kaputt",
      translated: "este defect",
      tone: 'semantic',
    },
    {
      german: "Was können Sie machen",
      translated: "Ce puteți face",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:290|ru": [
    {
      german: "Sie haben",
      translated: "Вы купили",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "в Германии",
      tone: 'semantic',
    },
    {
      german: "einen Fernseher gekauft",
      translated: "телевизор",
      tone: 'semantic',
    },
    {
      german: "Zu Hause",
      translated: "Дома",
      tone: 'semantic',
    },
    {
      german: "packen Sie den Fernseher aus",
      translated: "распаковав его",
      tone: 'semantic',
    },
    {
      german: "doch er funktioniert nicht",
      translated: "что он не работает",
      tone: 'semantic',
    },
    {
      german: "Der Fernseher ist kaputt",
      translated: "Телевизор сломан",
      tone: 'semantic',
    },
    {
      german: "Was können Sie machen",
      translated: "Что вы можете сделать",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:290|sq": [
    {
      german: "Sie haben",
      translated: "Keni",
      tone: 'semantic',
    },
    {
      german: "einen Fernseher gekauft",
      translated: "blerë një televizor",
      tone: 'semantic',
    },
    {
      german: "Zu Hause",
      translated: "në shtëpi",
      tone: 'semantic',
    },
    {
      german: "doch er funktioniert nicht",
      translated: "zbuloni",
      tone: 'semantic',
    },
    {
      german: "Der Fernseher ist kaputt",
      translated: "është me defekt",
      tone: 'semantic',
    },
    {
      german: "Was können Sie machen",
      translated: "Çfarë mund të bëni?",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:290|sr": [
    {
      german: "Sie haben",
      translated: "ste",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "U Nemačkoj",
      tone: 'semantic',
    },
    {
      german: "einen Fernseher gekauft",
      translated: "kupili televizor",
      tone: 'semantic',
    },
    {
      german: "Zu Hause",
      translated: "Kod kuće",
      tone: 'semantic',
    },
    {
      german: "packen Sie den Fernseher aus",
      translated: "ga raspakujete",
      tone: 'semantic',
    },
    {
      german: "doch er funktioniert nicht",
      translated: "ali ne radi",
      tone: 'semantic',
    },
    {
      german: "Der Fernseher ist kaputt",
      translated: "Televizor je pokvaren",
      tone: 'semantic',
    },
    {
      german: "Was können Sie machen",
      translated: "Šta možete da uradite",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:290|tr": [
    {
      german: "in Deutschland",
      translated: "Almanya'da",
      tone: 'semantic',
    },
    {
      german: "einen Fernseher gekauft",
      translated: "bir televizyon satın aldınız",
      tone: 'semantic',
    },
    {
      german: "Zu Hause",
      translated: "Eve geldiğinizde",
      tone: 'semantic',
    },
    {
      german: "doch er funktioniert nicht",
      translated: "cihazın çalışmadığını",
      tone: 'semantic',
    },
    {
      german: "Was können Sie machen",
      translated: "Ne yapabilirsiniz?",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:290|uk": [
    {
      german: "Sie haben",
      translated: "Ви купили",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "в Німеччині",
      tone: 'semantic',
    },
    {
      german: "einen Fernseher gekauft",
      translated: "телевізор",
      tone: 'semantic',
    },
    {
      german: "Zu Hause",
      translated: "Удома",
      tone: 'semantic',
    },
    {
      german: "packen Sie den Fernseher aus",
      translated: "ви його розпакували",
      tone: 'semantic',
    },
    {
      german: "doch er funktioniert nicht",
      translated: "але він не працює",
      tone: 'semantic',
    },
    {
      german: "Der Fernseher ist kaputt",
      translated: "Телевізор несправний",
      tone: 'semantic',
    },
    {
      german: "Was können Sie machen",
      translated: "Що можна зробити",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:290|vi": [
    {
      german: "Sie haben",
      translated: "Bạn",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "ở Đức",
      tone: 'semantic',
    },
    {
      german: "einen Fernseher gekauft",
      translated: "mua một chiếc tivi",
      tone: 'semantic',
    },
    {
      german: "Zu Hause",
      translated: "Về nhà",
      tone: 'semantic',
    },
    {
      german: "packen Sie den Fernseher aus",
      translated: "bạn mở hộp",
      tone: 'semantic',
    },
    {
      german: "doch er funktioniert nicht",
      translated: "nhưng tivi không hoạt động",
      tone: 'semantic',
    },
    {
      german: "Der Fernseher ist kaputt",
      translated: "nó bị hỏng",
      tone: 'semantic',
    },
    {
      german: "Was können Sie machen",
      translated: "Bạn có thể làm gì?",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:291|ar": [
    {
      german: "Warum muss man",
      translated: "لماذا يجب",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "في ألمانيا",
      tone: 'semantic',
    },
    {
      german: "bei der Steuererklärung",
      translated: "في الإقرار الضريبي",
      tone: 'semantic',
    },
    {
      german: "aufschreiben",
      translated: "ذكر",
      tone: 'semantic',
    },
    {
      german: "ob man",
      translated: "ما إذا كنت",
      tone: 'semantic',
    },
    {
      german: "zu einer Kirche",
      translated: "إلى كنيسة",
      tone: 'semantic',
    },
    {
      german: "gehört",
      translated: "تنتمي",
      tone: 'semantic',
    },
    {
      german: "Weil",
      translated: "لأن",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:291|bg": [
    {
      german: "Warum muss man",
      translated: "Защо",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "в Германия",
      tone: 'semantic',
    },
    {
      german: "bei der Steuererklärung",
      translated: "в данъчната декларация",
      tone: 'semantic',
    },
    {
      german: "aufschreiben",
      translated: "трябва да се посочи",
      tone: 'semantic',
    },
    {
      german: "ob man",
      translated: "дали сте",
      tone: 'semantic',
    },
    {
      german: "zu einer Kirche",
      translated: "член на църква",
      tone: 'semantic',
    },
    {
      german: "oder nicht",
      translated: "или не",
      tone: 'semantic',
    },
    {
      german: "Weil",
      translated: "Защото",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:291|bs": [
    {
      german: "Warum muss man",
      translated: "Zašto se",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "u Njemačkoj",
      tone: 'semantic',
    },
    {
      german: "bei der Steuererklärung",
      translated: "u poreznoj prijavi",
      tone: 'semantic',
    },
    {
      german: "aufschreiben",
      translated: "mora navesti",
      tone: 'semantic',
    },
    {
      german: "ob man",
      translated: "li osoba",
      tone: 'semantic',
    },
    {
      german: "zu einer Kirche",
      translated: "Crkvi",
      tone: 'semantic',
    },
    {
      german: "gehört",
      translated: "pripada",
      tone: 'semantic',
    },
    {
      german: "oder nicht",
      translated: "ili ne",
      tone: 'semantic',
    },
    {
      german: "Weil",
      translated: "Zato što",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:291|el": [
    {
      german: "Warum muss man",
      translated: "Γιατί",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "στη Γερμανία",
      tone: 'semantic',
    },
    {
      german: "bei der Steuererklärung",
      translated: "στη φορολογική δήλωση",
      tone: 'semantic',
    },
    {
      german: "aufschreiben",
      translated: "πρέπει να δηλώνεται",
      tone: 'semantic',
    },
    {
      german: "ob man",
      translated: "αν",
      tone: 'semantic',
    },
    {
      german: "zu einer Kirche",
      translated: "σε εκκλησία",
      tone: 'semantic',
    },
    {
      german: "gehört",
      translated: "ανήκετε",
      tone: 'semantic',
    },
    {
      german: "oder nicht",
      translated: "ή όχι",
      tone: 'semantic',
    },
    {
      german: "Weil",
      translated: "Επειδή",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:291|en": [
    {
      german: "Warum muss man",
      translated: "Why do you have to",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "in Germany",
      tone: 'semantic',
    },
    {
      german: "bei der Steuererklärung",
      translated: "in your tax return",
      tone: 'semantic',
    },
    {
      german: "aufschreiben",
      translated: "state",
      tone: 'semantic',
    },
    {
      german: "ob man",
      translated: "whether you",
      tone: 'semantic',
    },
    {
      german: "zu einer Kirche",
      translated: "to a church",
      tone: 'semantic',
    },
    {
      german: "gehört",
      translated: "belong",
      tone: 'semantic',
    },
    {
      german: "oder nicht",
      translated: "or not",
      tone: 'semantic',
    },
    {
      german: "Weil",
      translated: "Because",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:291|es": [
    {
      german: "Warum muss man",
      translated: "¿Por qué hay que",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "alemana",
      tone: 'semantic',
    },
    {
      german: "bei der Steuererklärung",
      translated: "en la declaración de impuestos",
      tone: 'semantic',
    },
    {
      german: "aufschreiben",
      translated: "indicar",
      tone: 'semantic',
    },
    {
      german: "ob man",
      translated: "si se",
      tone: 'semantic',
    },
    {
      german: "zu einer Kirche",
      translated: "a una iglesia",
      tone: 'semantic',
    },
    {
      german: "gehört",
      translated: "pertenece",
      tone: 'semantic',
    },
    {
      german: "Weil",
      translated: "Porque",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:291|fa": [
    {
      german: "Warum muss man",
      translated: "چرا در اظهارنامهٔ مالیاتی",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "آلمان",
      tone: 'semantic',
    },
    {
      german: "bei der Steuererklärung",
      translated: "باید",
      tone: 'semantic',
    },
    {
      german: "aufschreiben",
      translated: "مشخص شود",
      tone: 'semantic',
    },
    {
      german: "zu einer Kirche",
      translated: "عضو کلیسا",
      tone: 'semantic',
    },
    {
      german: "gehört",
      translated: "هستید",
      tone: 'semantic',
    },
    {
      german: "oder nicht",
      translated: "یا نه",
      tone: 'semantic',
    },
    {
      german: "Weil",
      translated: "؟ زیرا …",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:291|fr": [
    {
      german: "Warum muss man",
      translated: "Pourquoi faut-il",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "en Allemagne",
      tone: 'semantic',
    },
    {
      german: "bei der Steuererklärung",
      translated: "dans la déclaration fiscale",
      tone: 'semantic',
    },
    {
      german: "aufschreiben",
      translated: "indiquer",
      tone: 'semantic',
    },
    {
      german: "ob man",
      translated: "si l’on",
      tone: 'semantic',
    },
    {
      german: "zu einer Kirche",
      translated: "à une Église",
      tone: 'semantic',
    },
    {
      german: "gehört",
      translated: "appartient",
      tone: 'semantic',
    },
    {
      german: "oder nicht",
      translated: "ou non",
      tone: 'semantic',
    },
    {
      german: "Weil",
      translated: "Parce que",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:291|hr": [
    {
      german: "Warum muss man",
      translated: "Zašto se",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "u Njemačkoj",
      tone: 'semantic',
    },
    {
      german: "bei der Steuererklärung",
      translated: "u poreznoj prijavi",
      tone: 'semantic',
    },
    {
      german: "aufschreiben",
      translated: "mora navesti",
      tone: 'semantic',
    },
    {
      german: "ob man",
      translated: "li osoba",
      tone: 'semantic',
    },
    {
      german: "zu einer Kirche",
      translated: "Crkvi",
      tone: 'semantic',
    },
    {
      german: "gehört",
      translated: "pripada",
      tone: 'semantic',
    },
    {
      german: "oder nicht",
      translated: "ili ne",
      tone: 'semantic',
    },
    {
      german: "Weil",
      translated: "Zato što",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:291|it": [
    {
      german: "bei der Steuererklärung",
      translated: "nella dichiarazione dei redditi",
      tone: 'semantic',
    },
    {
      german: "aufschreiben",
      translated: "indicare",
      tone: 'semantic',
    },
    {
      german: "ob man",
      translated: "se si",
      tone: 'semantic',
    },
    {
      german: "zu einer Kirche",
      translated: "a una Chiesa",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:291|kmr": [
    {
      german: "Warum muss man",
      translated: "Çima",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "li Almanyayê",
      tone: 'semantic',
    },
    {
      german: "bei der Steuererklärung",
      translated: "di daxuyaniya bacê de",
      tone: 'semantic',
    },
    {
      german: "aufschreiben",
      translated: "divê binivîsî",
      tone: 'semantic',
    },
    {
      german: "ob man",
      translated: "ka",
      tone: 'semantic',
    },
    {
      german: "zu einer Kirche",
      translated: "dêrê",
      tone: 'semantic',
    },
    {
      german: "gehört",
      translated: "endamê",
      tone: 'semantic',
    },
    {
      german: "oder nicht",
      translated: "an na",
      tone: 'semantic',
    },
    {
      german: "Weil",
      translated: "Ji ber ku",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:291|pl": [
    {
      german: "Warum muss man",
      translated: "Dlaczego",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "w Niemczech",
      tone: 'semantic',
    },
    {
      german: "bei der Steuererklärung",
      translated: "w deklaracji podatkowej",
      tone: 'semantic',
    },
    {
      german: "aufschreiben",
      translated: "trzeba podać",
      tone: 'semantic',
    },
    {
      german: "ob man",
      translated: "czy",
      tone: 'semantic',
    },
    {
      german: "zu einer Kirche",
      translated: "do Kościoła",
      tone: 'semantic',
    },
    {
      german: "gehört",
      translated: "należy się",
      tone: 'semantic',
    },
    {
      german: "oder nicht",
      translated: "czy nie",
      tone: 'semantic',
    },
    {
      german: "Weil",
      translated: "Ponieważ",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:291|prs": [
    {
      german: "Warum muss man",
      translated: "چرا",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "آلمان",
      tone: 'semantic',
    },
    {
      german: "bei der Steuererklärung",
      translated: "در اظهارنامهٔ مالیاتی",
      tone: 'semantic',
    },
    {
      german: "aufschreiben",
      translated: "مشخص شود",
      tone: 'semantic',
    },
    {
      german: "zu einer Kirche",
      translated: "عضو کلیسا",
      tone: 'semantic',
    },
    {
      german: "gehört",
      translated: "هستید",
      tone: 'semantic',
    },
    {
      german: "oder nicht",
      translated: "یا نه؟",
      tone: 'semantic',
    },
    {
      german: "Weil",
      translated: "زیرا …",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:291|ro": [
    {
      german: "Warum muss man",
      translated: "De ce trebuie",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "în Germania",
      tone: 'semantic',
    },
    {
      german: "bei der Steuererklärung",
      translated: "în declarația fiscală",
      tone: 'semantic',
    },
    {
      german: "aufschreiben",
      translated: "indicat",
      tone: 'semantic',
    },
    {
      german: "ob man",
      translated: "dacă",
      tone: 'semantic',
    },
    {
      german: "zu einer Kirche",
      translated: "al unei biserici",
      tone: 'semantic',
    },
    {
      german: "gehört",
      translated: "membru",
      tone: 'semantic',
    },
    {
      german: "oder nicht",
      translated: "sau nu",
      tone: 'semantic',
    },
    {
      german: "Weil",
      translated: "Pentru că",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:291|ru": [
    {
      german: "Warum muss man",
      translated: "Почему",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "в Германии",
      tone: 'semantic',
    },
    {
      german: "bei der Steuererklärung",
      translated: "в налоговой декларации",
      tone: 'semantic',
    },
    {
      german: "aufschreiben",
      translated: "нужно указывать",
      tone: 'semantic',
    },
    {
      german: "zu einer Kirche",
      translated: "состоите ли вы в церкви",
      tone: 'semantic',
    },
    {
      german: "Weil",
      translated: "Потому что",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:291|sq": [
    {
      german: "Warum muss man",
      translated: "Pse",
      tone: 'semantic',
    },
    {
      german: "bei der Steuererklärung",
      translated: "në deklaratën tatimore",
      tone: 'semantic',
    },
    {
      german: "aufschreiben",
      translated: "shënohet",
      tone: 'semantic',
    },
    {
      german: "ob man",
      translated: "nëse jeni",
      tone: 'semantic',
    },
    {
      german: "zu einer Kirche",
      translated: "i një kishe",
      tone: 'semantic',
    },
    {
      german: "gehört",
      translated: "anëtar",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:291|sr": [
    {
      german: "Warum muss man",
      translated: "Zašto se",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "u Nemačkoj",
      tone: 'semantic',
    },
    {
      german: "bei der Steuererklärung",
      translated: "u poreskoj prijavi",
      tone: 'semantic',
    },
    {
      german: "aufschreiben",
      translated: "mora navesti",
      tone: 'semantic',
    },
    {
      german: "ob man",
      translated: "li osoba",
      tone: 'semantic',
    },
    {
      german: "zu einer Kirche",
      translated: "Crkvi",
      tone: 'semantic',
    },
    {
      german: "gehört",
      translated: "pripada",
      tone: 'semantic',
    },
    {
      german: "oder nicht",
      translated: "ili ne",
      tone: 'semantic',
    },
    {
      german: "Weil",
      translated: "Zato što",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:291|tr": [
    {
      german: "Warum muss man",
      translated: "neden",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "Almanya'da",
      tone: 'semantic',
    },
    {
      german: "bei der Steuererklärung",
      translated: "vergi beyannamesinde",
      tone: 'semantic',
    },
    {
      german: "aufschreiben",
      translated: "belirtmeniz gerekir",
      tone: 'semantic',
    },
    {
      german: "ob man",
      translated: "olup",
      tone: 'semantic',
    },
    {
      german: "zu einer Kirche",
      translated: "bir kiliseye bağlı",
      tone: 'semantic',
    },
    {
      german: "oder nicht",
      translated: "olmadığınızı",
      tone: 'semantic',
    },
    {
      german: "Weil",
      translated: "Çünkü",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:291|uk": [
    {
      german: "Warum muss man",
      translated: "Чому",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "в Німеччині",
      tone: 'semantic',
    },
    {
      german: "bei der Steuererklärung",
      translated: "в податковій декларації",
      tone: 'semantic',
    },
    {
      german: "aufschreiben",
      translated: "зазначати",
      tone: 'semantic',
    },
    {
      german: "ob man",
      translated: "чи",
      tone: 'semantic',
    },
    {
      german: "zu einer Kirche",
      translated: "ви до церкви",
      tone: 'semantic',
    },
    {
      german: "Weil",
      translated: "Тому що",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:291|vi": [
    {
      german: "Warum muss man",
      translated: "Tại sao",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "ở Đức",
      tone: 'semantic',
    },
    {
      german: "bei der Steuererklärung",
      translated: "trong tờ khai thuế",
      tone: 'semantic',
    },
    {
      german: "aufschreiben",
      translated: "phải ghi",
      tone: 'semantic',
    },
    {
      german: "ob man",
      translated: "bạn có",
      tone: 'semantic',
    },
    {
      german: "zu einer Kirche",
      translated: "một nhà thờ",
      tone: 'semantic',
    },
    {
      german: "gehört",
      translated: "thuộc",
      tone: 'semantic',
    },
    {
      german: "oder nicht",
      translated: "hay không",
      tone: 'semantic',
    },
    {
      german: "Weil",
      translated: "Vì",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:292|ar": [
    {
      german: "Die Menschen in Deutschland",
      translated: "الناس في ألمانيا",
      tone: 'semantic',
    },
    {
      german: "leben nach dem Grundsatz",
      translated: "وفق مبدأ",
      tone: 'semantic',
    },
    {
      german: "der religiösen Toleranz",
      translated: "التسامح الديني",
      tone: 'semantic',
    },
    {
      german: "Was bedeutet das",
      translated: "ماذا يعني ذلك",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:292|bg": [
    {
      german: "Die Menschen in Deutschland",
      translated: "Хората в Германия",
      tone: 'semantic',
    },
    {
      german: "leben nach dem Grundsatz",
      translated: "живеят според принципа",
      tone: 'semantic',
    },
    {
      german: "der religiösen Toleranz",
      translated: "на религиозната толерантност",
      tone: 'semantic',
    },
    {
      german: "Was bedeutet das",
      translated: "Какво означава това",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:292|bs": [
    {
      german: "Die Menschen in Deutschland",
      translated: "Ljudi u Njemačkoj",
      tone: 'semantic',
    },
    {
      german: "leben nach dem Grundsatz",
      translated: "žive prema načelu",
      tone: 'semantic',
    },
    {
      german: "der religiösen Toleranz",
      translated: "vjerske tolerancije",
      tone: 'semantic',
    },
    {
      german: "Was bedeutet das",
      translated: "Što to znači",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:292|el": [
    {
      german: "Die Menschen in Deutschland",
      translated: "Οι άνθρωποι στη Γερμανία",
      tone: 'semantic',
    },
    {
      german: "leben nach dem Grundsatz",
      translated: "ζουν σύμφωνα με την αρχή",
      tone: 'semantic',
    },
    {
      german: "der religiösen Toleranz",
      translated: "της θρησκευτικής ανεκτικότητας",
      tone: 'semantic',
    },
    {
      german: "Was bedeutet das",
      translated: "Τι σημαίνει αυτό",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:292|en": [
    {
      german: "Die Menschen in Deutschland",
      translated: "People in Germany",
      tone: 'semantic',
    },
    {
      german: "leben nach dem Grundsatz",
      translated: "live according to the principle",
      tone: 'semantic',
    },
    {
      german: "der religiösen Toleranz",
      translated: "of religious tolerance",
      tone: 'semantic',
    },
    {
      german: "Was bedeutet das",
      translated: "What does that mean",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:292|es": [
    {
      german: "Die Menschen in Deutschland",
      translated: "En Alemania",
      tone: 'semantic',
    },
    {
      german: "leben nach dem Grundsatz",
      translated: "las personas viven según el principio",
      tone: 'semantic',
    },
    {
      german: "der religiösen Toleranz",
      translated: "tolerancia religiosa",
      tone: 'semantic',
    },
    {
      german: "Was bedeutet das",
      translated: "¿Qué significa eso",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:292|fa": [
    {
      german: "Die Menschen in Deutschland",
      translated: "مردم در آلمان",
      tone: 'semantic',
    },
    {
      german: "leben nach dem Grundsatz",
      translated: "بر اساس اصل تساهل دینی زندگی می‌کنند",
      tone: 'semantic',
    },
    {
      german: "Was bedeutet das",
      translated: "این یعنی چه",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:292|fr": [
    {
      german: "Die Menschen in Deutschland",
      translated: "Les gens en Allemagne",
      tone: 'semantic',
    },
    {
      german: "leben nach dem Grundsatz",
      translated: "vivent selon le principe",
      tone: 'semantic',
    },
    {
      german: "der religiösen Toleranz",
      translated: "de la tolérance religieuse",
      tone: 'semantic',
    },
    {
      german: "Was bedeutet das",
      translated: "Qu’est-ce que cela signifie",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:292|hr": [
    {
      german: "Die Menschen in Deutschland",
      translated: "Ljudi u Njemačkoj",
      tone: 'semantic',
    },
    {
      german: "leben nach dem Grundsatz",
      translated: "žive prema načelu",
      tone: 'semantic',
    },
    {
      german: "der religiösen Toleranz",
      translated: "vjerske tolerancije",
      tone: 'semantic',
    },
    {
      german: "Was bedeutet das",
      translated: "Što to znači",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:292|it": [
    {
      german: "Die Menschen in Deutschland",
      translated: "Le persone in Germania",
      tone: 'semantic',
    },
    {
      german: "leben nach dem Grundsatz",
      translated: "vivono secondo il principio",
      tone: 'semantic',
    },
    {
      german: "der religiösen Toleranz",
      translated: "della tolleranza religiosa",
      tone: 'semantic',
    },
    {
      german: "Was bedeutet das",
      translated: "Che cosa significa",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:292|kmr": [
    {
      german: "Die Menschen in Deutschland",
      translated: "li Almanyayê",
      tone: 'semantic',
    },
    {
      german: "der religiösen Toleranz",
      translated: "Toleransa olî",
      tone: 'semantic',
    },
    {
      german: "Was bedeutet das",
      translated: "tê çi wateyê",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:292|pl": [
    {
      german: "Die Menschen in Deutschland",
      translated: "Ludzie w Niemczech",
      tone: 'semantic',
    },
    {
      german: "leben nach dem Grundsatz",
      translated: "zgodnie z zasadą",
      tone: 'semantic',
    },
    {
      german: "der religiösen Toleranz",
      translated: "tolerancji religijnej",
      tone: 'semantic',
    },
    {
      german: "Was bedeutet das",
      translated: "Co to oznacza",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:292|prs": [
    {
      german: "Die Menschen in Deutschland",
      translated: "مردم در آلمان",
      tone: 'semantic',
    },
    {
      german: "leben nach dem Grundsatz",
      translated: "بر اساس اصل",
      tone: 'semantic',
    },
    {
      german: "der religiösen Toleranz",
      translated: "تساهل دینی",
      tone: 'semantic',
    },
    {
      german: "Was bedeutet das",
      translated: "این یعنی چه؟",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:292|ro": [
    {
      german: "Die Menschen in Deutschland",
      translated: "Oamenii din Germania",
      tone: 'semantic',
    },
    {
      german: "leben nach dem Grundsatz",
      translated: "trăiesc conform principiului",
      tone: 'semantic',
    },
    {
      german: "der religiösen Toleranz",
      translated: "toleranței religioase",
      tone: 'semantic',
    },
    {
      german: "Was bedeutet das",
      translated: "Ce înseamnă",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:292|ru": [
    {
      german: "Die Menschen in Deutschland",
      translated: "Люди в Германии",
      tone: 'semantic',
    },
    {
      german: "leben nach dem Grundsatz",
      translated: "живут по принципу",
      tone: 'semantic',
    },
    {
      german: "der religiösen Toleranz",
      translated: "религиозной терпимости",
      tone: 'semantic',
    },
    {
      german: "Was bedeutet das",
      translated: "Что это значит",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:292|sq": [
    {
      german: "Die Menschen in Deutschland",
      translated: "Njerëzit në Gjermani",
      tone: 'semantic',
    },
    {
      german: "leben nach dem Grundsatz",
      translated: "jetojnë sipas parimit",
      tone: 'semantic',
    },
    {
      german: "der religiösen Toleranz",
      translated: "tolerancës fetare",
      tone: 'semantic',
    },
    {
      german: "Was bedeutet das",
      translated: "Çfarë do të thotë kjo",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:292|sr": [
    {
      german: "Die Menschen in Deutschland",
      translated: "Ljudi u Nemačkoj",
      tone: 'semantic',
    },
    {
      german: "leben nach dem Grundsatz",
      translated: "žive prema načelu",
      tone: 'semantic',
    },
    {
      german: "der religiösen Toleranz",
      translated: "verske tolerancije",
      tone: 'semantic',
    },
    {
      german: "Was bedeutet das",
      translated: "Šta to znači",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:292|tr": [
    {
      german: "Die Menschen in Deutschland",
      translated: "Almanya'da insanlar",
      tone: 'semantic',
    },
    {
      german: "leben nach dem Grundsatz",
      translated: "ilkesine göre yaşar",
      tone: 'semantic',
    },
    {
      german: "der religiösen Toleranz",
      translated: "dinî hoşgörü",
      tone: 'semantic',
    },
    {
      german: "Was bedeutet das",
      translated: "Bu ne demektir?",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:292|uk": [
    {
      german: "Die Menschen in Deutschland",
      translated: "Люди в Німеччині",
      tone: 'semantic',
    },
    {
      german: "leben nach dem Grundsatz",
      translated: "живуть за принципом",
      tone: 'semantic',
    },
    {
      german: "der religiösen Toleranz",
      translated: "релігійної толерантності",
      tone: 'semantic',
    },
    {
      german: "Was bedeutet das",
      translated: "Що це означає?",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:292|vi": [
    {
      german: "Die Menschen in Deutschland",
      translated: "Người dân ở Đức",
      tone: 'semantic',
    },
    {
      german: "leben nach dem Grundsatz",
      translated: "sống theo nguyên tắc",
      tone: 'semantic',
    },
    {
      german: "der religiösen Toleranz",
      translated: "khoan dung tôn giáo",
      tone: 'semantic',
    },
    {
      german: "Was bedeutet das",
      translated: "Điều đó có nghĩa là gì",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:293|ar": [
    {
      german: "Was ist",
      translated: "بعيد الفصح",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "في ألمانيا",
      tone: 'semantic',
    },
    {
      german: "ein Brauch",
      translated: "العادة المرتبطة",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:293|bg": [
    {
      german: "Was ist",
      translated: "Кой е",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "в Германия",
      tone: 'semantic',
    },
    {
      german: "ein Brauch",
      translated: "великденски обичай",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:293|bs": [
    {
      german: "Was ist",
      translated: "Koji je",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "u Njemačkoj",
      tone: 'semantic',
    },
    {
      german: "ein Brauch",
      translated: "običaj",
      tone: 'semantic',
    },
    {
      german: "zu Ostern",
      translated: "s Uskrsom",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:293|el": [
    {
      german: "Was ist",
      translated: "Ποιο είναι",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "στη Γερμανία",
      tone: 'semantic',
    },
    {
      german: "ein Brauch",
      translated: "έθιμο",
      tone: 'semantic',
    },
    {
      german: "zu Ostern",
      translated: "πασχαλινό",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:293|en": [
    {
      german: "Was ist",
      translated: "What is",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "in Germany",
      tone: 'semantic',
    },
    {
      german: "ein Brauch",
      translated: "tradition",
      tone: 'semantic',
    },
    {
      german: "zu Ostern",
      translated: "Easter",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:293|es": [
    {
      german: "Was ist",
      translated: "¿Qué",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "en Alemania",
      tone: 'semantic',
    },
    {
      german: "ein Brauch",
      translated: "tradición",
      tone: 'semantic',
    },
    {
      german: "zu Ostern",
      translated: "relacionada con la Pascua",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:293|fa": [
    {
      german: "Was ist",
      translated: "کدام مورد",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "در آلمان",
      tone: 'semantic',
    },
    {
      german: "ein Brauch",
      translated: "یکی از رسوم",
      tone: 'semantic',
    },
    {
      german: "zu Ostern",
      translated: "عید پاک",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:293|fr": [
    {
      german: "Was ist",
      translated: "Quelle",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "en Allemagne",
      tone: 'semantic',
    },
    {
      german: "ein Brauch",
      translated: "coutume existe",
      tone: 'semantic',
    },
    {
      german: "zu Ostern",
      translated: "à Pâques",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:293|hr": [
    {
      german: "Was ist",
      translated: "Koji je",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "u Njemačkoj",
      tone: 'semantic',
    },
    {
      german: "ein Brauch",
      translated: "običaj",
      tone: 'semantic',
    },
    {
      german: "zu Ostern",
      translated: "Uskrsom",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:293|it": [
    {
      german: "Was ist",
      translated: "Qual è",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "in Germania",
      tone: 'semantic',
    },
    {
      german: "ein Brauch",
      translated: "una tradizione",
      tone: 'semantic',
    },
    {
      german: "zu Ostern",
      translated: "pasquale",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:293|kmr": [
    {
      german: "Was ist",
      translated: "Adeteke Paskalyayê",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "li Almanyayê",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:293|pl": [
    {
      german: "Was ist",
      translated: "Który",
      tone: 'semantic',
    },
    {
      german: "ein Brauch",
      translated: "zwyczaj",
      tone: 'semantic',
    },
    {
      german: "zu Ostern",
      translated: "z Wielkanocą",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:293|prs": [
    {
      german: "Was ist",
      translated: "کدام مورد یکی",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "در آلمان",
      tone: 'semantic',
    },
    {
      german: "ein Brauch",
      translated: "رسوم عید پاک",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:293|ro": [
    {
      german: "Was ist",
      translated: "Care este",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "în Germania",
      tone: 'semantic',
    },
    {
      german: "ein Brauch",
      translated: "un obicei",
      tone: 'semantic',
    },
    {
      german: "zu Ostern",
      translated: "de Paște",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:293|ru": [
    {
      german: "Was ist",
      translated: "Что",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "в Германии",
      tone: 'semantic',
    },
    {
      german: "ein Brauch",
      translated: "обычаем",
      tone: 'semantic',
    },
    {
      german: "zu Ostern",
      translated: "на Пасху",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:293|sq": [
    {
      german: "Was ist",
      translated: "Cili është",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "në Gjermani",
      tone: 'semantic',
    },
    {
      german: "ein Brauch",
      translated: "një zakon",
      tone: 'semantic',
    },
    {
      german: "zu Ostern",
      translated: "i Pashkëve",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:293|sr": [
    {
      german: "Was ist",
      translated: "Koji je",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "u Nemačkoj",
      tone: 'semantic',
    },
    {
      german: "ein Brauch",
      translated: "običaj",
      tone: 'semantic',
    },
    {
      german: "zu Ostern",
      translated: "s Uskrsom",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:293|tr": [
    {
      german: "Was ist",
      translated: "hangisidir",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "Almanya'da",
      tone: 'semantic',
    },
    {
      german: "ein Brauch",
      translated: "geleneklerden biri",
      tone: 'semantic',
    },
    {
      german: "zu Ostern",
      translated: "Paskalya'da",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:293|uk": [
    {
      german: "Was ist",
      translated: "Який",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "в Німеччині",
      tone: 'semantic',
    },
    {
      german: "ein Brauch",
      translated: "звичай",
      tone: 'semantic',
    },
    {
      german: "zu Ostern",
      translated: "на Великдень",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:293|vi": [
    {
      german: "Was ist",
      translated: "là gì",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "ở Đức",
      tone: 'semantic',
    },
    {
      german: "ein Brauch",
      translated: "Một phong tục",
      tone: 'semantic',
    },
    {
      german: "zu Ostern",
      translated: "Phục sinh",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:294|ar": [
    {
      german: "Pfingsten",
      translated: "عيد العنصرة (Pfingsten)",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "هو",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:294|bg": [
    {
      german: "Pfingsten",
      translated: "Петдесетница",
      tone: 'semantic',
    },
    {
      german: "ein",
      translated: "е",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:294|bs": [
    {
      german: "Pfingsten",
      translated: "Duhovi (Pfingsten)",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "su",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:294|el": [
    {
      german: "Pfingsten",
      translated: "Pfingsten",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "είναι",
      tone: 'semantic',
    },
    {
      german: "ein",
      translated: "…",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:294|en": [
    {
      german: "Pfingsten",
      translated: "Pentecost",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "is",
      tone: 'semantic',
    },
    {
      german: "ein",
      translated: "a",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:294|es": [
    {
      german: "Pfingsten",
      translated: "Pentecostés",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "es",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:294|fa": [
    {
      german: "Pfingsten",
      translated: "پنطیکاست (Pfingsten)",
      tone: 'semantic',
    },
    {
      german: "ein",
      translated: "یک",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:294|fr": [
    {
      german: "Pfingsten",
      translated: "Pentecôte",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "est",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:294|hr": [
    {
      german: "Pfingsten",
      translated: "Duhovi (Pfingsten)",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "su",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:294|it": [
    {
      german: "Pfingsten",
      translated: "La Pentecoste (Pfingsten)",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "è",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:294|kmr": [
    {
      german: "Pfingsten",
      translated: "Pfingsten",
      tone: 'semantic',
    },
    {
      german: "ein",
      translated: "e",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:294|pl": [
    {
      german: "Pfingsten",
      translated: "Zielone Świątki (Pfingsten)",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "są",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:294|prs": [
    {
      german: "Pfingsten",
      translated: "پنطیکاست",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "است",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:294|ro": [
    {
      german: "Pfingsten",
      translated: "Rusaliile",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:294|ru": [
    {
      german: "Pfingsten",
      translated: "Троица (Пятидесятница)",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "это",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:294|sq": [
    {
      german: "Pfingsten",
      translated: "Rrëshajët",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:294|sr": [
    {
      german: "Pfingsten",
      translated: "Duhovi (Pfingsten)",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "su",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:294|tr": [
    {
      german: "Pfingsten",
      translated: "Pfingsten (Pentekost)",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:294|uk": [
    {
      german: "Pfingsten",
      translated: "П’ятидесятниця",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "це",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:294|vi": [
    {
      german: "Pfingsten",
      translated: "Pfingsten",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "là",
      tone: 'semantic',
    },
    {
      german: "ein",
      translated: "Lễ Hiện xuống",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:295|ar": [
    {
      german: "Welche Religion",
      translated: "أي ديانة",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "أثرت في",
      tone: 'semantic',
    },
    {
      german: "die europäische und deutsche Kultur",
      translated: "الثقافة الأوروبية والألمانية",
      tone: 'semantic',
    },
    {
      german: "geprägt",
      translated: "؟",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:295|bg": [
    {
      german: "Welche Religion",
      translated: "Коя религия",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "е оказала",
      tone: 'semantic',
    },
    {
      german: "die europäische und deutsche Kultur",
      translated: "културата на Европа и Германия",
      tone: 'semantic',
    },
    {
      german: "geprägt",
      translated: "влияние",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:295|bs": [
    {
      german: "Welche Religion",
      translated: "Koja je religija",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "snažno utjecala",
      tone: 'semantic',
    },
    {
      german: "die europäische und deutsche Kultur",
      translated: "na kulturu Europe i Njemačke",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:295|el": [
    {
      german: "Welche Religion",
      translated: "Ποια θρησκεία",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "έχει",
      tone: 'semantic',
    },
    {
      german: "die europäische und deutsche Kultur",
      translated: "τον πολιτισμό της Ευρώπης και της Γερμανίας",
      tone: 'semantic',
    },
    {
      german: "geprägt",
      translated: "επηρεάσει βαθιά",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:295|en": [
    {
      german: "Welche Religion",
      translated: "Which religion",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "has",
      tone: 'semantic',
    },
    {
      german: "die europäische und deutsche Kultur",
      translated: "European and German culture",
      tone: 'semantic',
    },
    {
      german: "geprägt",
      translated: "shaped",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:295|es": [
    {
      german: "Welche Religion",
      translated: "¿Qué religión",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "ha",
      tone: 'semantic',
    },
    {
      german: "die europäische und deutsche Kultur",
      translated: "la cultura europea y alemana",
      tone: 'semantic',
    },
    {
      german: "geprägt",
      translated: "influido",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:295|fa": [
    {
      german: "Welche Religion",
      translated: "کدام دین",
      tone: 'semantic',
    },
    {
      german: "die europäische und deutsche Kultur",
      translated: "فرهنگ اروپا و آلمان",
      tone: 'semantic',
    },
    {
      german: "geprägt",
      translated: "تأثیر عمیقی گذاشته",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:295|fr": [
    {
      german: "Welche Religion",
      translated: "Quelle religion",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "a",
      tone: 'semantic',
    },
    {
      german: "die europäische und deutsche Kultur",
      translated: "la culture européenne et allemande",
      tone: 'semantic',
    },
    {
      german: "geprägt",
      translated: "marqué",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:295|hr": [
    {
      german: "Welche Religion",
      translated: "Koja je religija",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "snažno utjecala",
      tone: 'semantic',
    },
    {
      german: "die europäische und deutsche Kultur",
      translated: "na kulturu Europe i Njemačke",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:295|it": [
    {
      german: "Welche Religion",
      translated: "Quale religione",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "ha",
      tone: 'semantic',
    },
    {
      german: "die europäische und deutsche Kultur",
      translated: "la cultura europea e tedesca",
      tone: 'semantic',
    },
    {
      german: "geprägt",
      translated: "influenzato profondamente",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:295|kmr": [
    {
      german: "Welche Religion",
      translated: "Kîjan",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "ol",
      tone: 'semantic',
    },
    {
      german: "die europäische und deutsche Kultur",
      translated: "çanda Ewropî û Alman bandor",
      tone: 'semantic',
    },
    {
      german: "geprägt",
      translated: "kiriye",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:295|pl": [
    {
      german: "Welche Religion",
      translated: "Która religia",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "wywarła",
      tone: 'semantic',
    },
    {
      german: "die europäische und deutsche Kultur",
      translated: "kulturę Europy i Niemiec",
      tone: 'semantic',
    },
    {
      german: "geprägt",
      translated: "silny wpływ",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:295|prs": [
    {
      german: "Welche Religion",
      translated: "کدام دین",
      tone: 'semantic',
    },
    {
      german: "die europäische und deutsche Kultur",
      translated: "فرهنگ اروپا و آلمان",
      tone: 'semantic',
    },
    {
      german: "geprägt",
      translated: "تأثیر عمیقی گذاشته است",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:295|ro": [
    {
      german: "Welche Religion",
      translated: "Care religie",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "a",
      tone: 'semantic',
    },
    {
      german: "die europäische und deutsche Kultur",
      translated: "cultura Europei și a Germaniei",
      tone: 'semantic',
    },
    {
      german: "geprägt",
      translated: "influențat profund",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:295|ru": [
    {
      german: "Welche Religion",
      translated: "Какая религия",
      tone: 'semantic',
    },
    {
      german: "die europäische und deutsche Kultur",
      translated: "европейскую и немецкую культуру",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:295|sq": [
    {
      german: "Welche Religion",
      translated: "Cila fe",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "ka",
      tone: 'semantic',
    },
    {
      german: "die europäische und deutsche Kultur",
      translated: "kulturën e Evropës dhe Gjermanisë",
      tone: 'semantic',
    },
    {
      german: "geprägt",
      translated: "ndikuar fuqishëm",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:295|sr": [
    {
      german: "Welche Religion",
      translated: "Koja je religija",
      tone: 'semantic',
    },
    {
      german: "die europäische und deutsche Kultur",
      translated: "kulturu Europe i Nemačke",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:295|tr": [
    {
      german: "Welche Religion",
      translated: "hangi din",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "etkilemiştir",
      tone: 'semantic',
    },
    {
      german: "die europäische und deutsche Kultur",
      translated: "Avrupa ve Alman kültürünü",
      tone: 'semantic',
    },
    {
      german: "geprägt",
      translated: "güçlü biçimde",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:295|uk": [
    {
      german: "Welche Religion",
      translated: "Яка релігія",
      tone: 'semantic',
    },
    {
      german: "die europäische und deutsche Kultur",
      translated: "європейську та німецьку культуру",
      tone: 'semantic',
    },
    {
      german: "geprägt",
      translated: "сформувала",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:295|vi": [
    {
      german: "Welche Religion",
      translated: "Tôn giáo nào",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "đã",
      tone: 'semantic',
    },
    {
      german: "die europäische und deutsche Kultur",
      translated: "văn hóa châu Âu và Đức",
      tone: 'semantic',
    },
    {
      german: "geprägt",
      translated: "ảnh hưởng sâu sắc",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:296|ar": [
    {
      german: "In Deutschland",
      translated: "في ألمانيا",
      tone: 'semantic',
    },
    {
      german: "nennt man",
      translated: "تُسمى",
      tone: 'semantic',
    },
    {
      german: "die letzten vier Wochen",
      translated: "الأسابيع الأربعة الأخيرة",
      tone: 'semantic',
    },
    {
      german: "vor Weihnachten",
      translated: "قبل عيد الميلاد",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:296|bg": [
    {
      german: "In Deutschland",
      translated: "В Германия",
      tone: 'semantic',
    },
    {
      german: "nennt man",
      translated: "се наричат",
      tone: 'semantic',
    },
    {
      german: "die letzten vier Wochen",
      translated: "последните четири седмици",
      tone: 'semantic',
    },
    {
      german: "vor Weihnachten",
      translated: "преди Коледа",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:296|bs": [
    {
      german: "In Deutschland",
      translated: "U Njemačkoj",
      tone: 'semantic',
    },
    {
      german: "nennt man",
      translated: "nazivaju",
      tone: 'semantic',
    },
    {
      german: "die letzten vier Wochen",
      translated: "posljednja četiri sedmice",
      tone: 'semantic',
    },
    {
      german: "vor Weihnachten",
      translated: "prije Božića",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:296|el": [
    {
      german: "In Deutschland",
      translated: "Στη Γερμανία",
      tone: 'semantic',
    },
    {
      german: "nennt man",
      translated: "ονομάζονται",
      tone: 'semantic',
    },
    {
      german: "die letzten vier Wochen",
      translated: "οι τελευταίες τέσσερις εβδομάδες",
      tone: 'semantic',
    },
    {
      german: "vor Weihnachten",
      translated: "πριν από τα Χριστούγεννα",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:296|en": [
    {
      german: "In Deutschland",
      translated: "In Germany",
      tone: 'semantic',
    },
    {
      german: "nennt man",
      translated: "are called",
      tone: 'semantic',
    },
    {
      german: "die letzten vier Wochen",
      translated: "the last four weeks",
      tone: 'semantic',
    },
    {
      german: "vor Weihnachten",
      translated: "before Christmas",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:296|es": [
    {
      german: "In Deutschland",
      translated: "En Alemania",
      tone: 'semantic',
    },
    {
      german: "nennt man",
      translated: "se llaman",
      tone: 'semantic',
    },
    {
      german: "die letzten vier Wochen",
      translated: "las cuatro últimas semanas",
      tone: 'semantic',
    },
    {
      german: "vor Weihnachten",
      translated: "antes de Navidad",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:296|fa": [
    {
      german: "In Deutschland",
      translated: "در آلمان",
      tone: 'semantic',
    },
    {
      german: "nennt man",
      translated: "می‌نامند",
      tone: 'semantic',
    },
    {
      german: "die letzten vier Wochen",
      translated: "چهار هفتهٔ آخر",
      tone: 'semantic',
    },
    {
      german: "vor Weihnachten",
      translated: "پیش از کریسمس",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:296|fr": [
    {
      german: "In Deutschland",
      translated: "En Allemagne",
      tone: 'semantic',
    },
    {
      german: "nennt man",
      translated: "s’appellent",
      tone: 'semantic',
    },
    {
      german: "die letzten vier Wochen",
      translated: "les quatre dernières semaines",
      tone: 'semantic',
    },
    {
      german: "vor Weihnachten",
      translated: "avant Noël",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:296|hr": [
    {
      german: "In Deutschland",
      translated: "U Njemačkoj",
      tone: 'semantic',
    },
    {
      german: "nennt man",
      translated: "nazivaju",
      tone: 'semantic',
    },
    {
      german: "die letzten vier Wochen",
      translated: "posljednja četiri tjedna",
      tone: 'semantic',
    },
    {
      german: "vor Weihnachten",
      translated: "prije Božića",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:296|it": [
    {
      german: "In Deutschland",
      translated: "In Germania",
      tone: 'semantic',
    },
    {
      german: "nennt man",
      translated: "si chiamano",
      tone: 'semantic',
    },
    {
      german: "die letzten vier Wochen",
      translated: "le ultime quattro settimane",
      tone: 'semantic',
    },
    {
      german: "vor Weihnachten",
      translated: "prima di Natale",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:296|kmr": [
    {
      german: "In Deutschland",
      translated: "li Almanyayê",
      tone: 'semantic',
    },
    {
      german: "nennt man",
      translated: "çi tê gotin",
      tone: 'semantic',
    },
    {
      german: "die letzten vier Wochen",
      translated: "Çar hefteyên dawî",
      tone: 'semantic',
    },
    {
      german: "vor Weihnachten",
      translated: "berî Noelê",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:296|pl": [
    {
      german: "In Deutschland",
      translated: "W Niemczech",
      tone: 'semantic',
    },
    {
      german: "nennt man",
      translated: "nazywa się",
      tone: 'semantic',
    },
    {
      german: "die letzten vier Wochen",
      translated: "ostatnie cztery tygodnie",
      tone: 'semantic',
    },
    {
      german: "vor Weihnachten",
      translated: "przed Bożym Narodzeniem",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:296|prs": [
    {
      german: "In Deutschland",
      translated: "در آلمان",
      tone: 'semantic',
    },
    {
      german: "nennt man",
      translated: "می‌نامند",
      tone: 'semantic',
    },
    {
      german: "die letzten vier Wochen",
      translated: "چهار هفتهٔ آخر",
      tone: 'semantic',
    },
    {
      german: "vor Weihnachten",
      translated: "پیش از کریسمس",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:296|ro": [
    {
      german: "In Deutschland",
      translated: "În Germania,",
      tone: 'semantic',
    },
    {
      german: "nennt man",
      translated: "se numesc",
      tone: 'semantic',
    },
    {
      german: "die letzten vier Wochen",
      translated: " ultimele patru săptămâni",
      tone: 'semantic',
    },
    {
      german: "vor Weihnachten",
      translated: " înainte de Crăciun",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:296|ru": [
    {
      german: "In Deutschland",
      translated: "в Германии",
      tone: 'semantic',
    },
    {
      german: "nennt man",
      translated: "называют",
      tone: 'semantic',
    },
    {
      german: "die letzten vier Wochen",
      translated: "Последние четыре недели",
      tone: 'semantic',
    },
    {
      german: "vor Weihnachten",
      translated: "перед Рождеством",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:296|sq": [
    {
      german: "In Deutschland",
      translated: "Në Gjermani",
      tone: 'semantic',
    },
    {
      german: "nennt man",
      translated: "quhen",
      tone: 'semantic',
    },
    {
      german: "die letzten vier Wochen",
      translated: "katër javët e fundit",
      tone: 'semantic',
    },
    {
      german: "vor Weihnachten",
      translated: "para Krishtlindjeve",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:296|sr": [
    {
      german: "In Deutschland",
      translated: "U Nemačkoj",
      tone: 'semantic',
    },
    {
      german: "nennt man",
      translated: "se",
      tone: 'semantic',
    },
    {
      german: "die letzten vier Wochen",
      translated: "posljednja četiri nedelje",
      tone: 'semantic',
    },
    {
      german: "vor Weihnachten",
      translated: "pre Božića",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:296|tr": [
    {
      german: "In Deutschland",
      translated: "Almanya'da",
      tone: 'semantic',
    },
    {
      german: "nennt man",
      translated: "denir",
      tone: 'semantic',
    },
    {
      german: "die letzten vier Wochen",
      translated: "son dört haftaya",
      tone: 'semantic',
    },
    {
      german: "vor Weihnachten",
      translated: "Noel'den önceki",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:296|uk": [
    {
      german: "In Deutschland",
      translated: "у Німеччині",
      tone: 'semantic',
    },
    {
      german: "nennt man",
      translated: " називають",
      tone: 'semantic',
    },
    {
      german: "die letzten vier Wochen",
      translated: "Останні чотири тижні",
      tone: 'semantic',
    },
    {
      german: "vor Weihnachten",
      translated: "перед Різдвом",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:296|vi": [
    {
      german: "In Deutschland",
      translated: "Ở Đức",
      tone: 'semantic',
    },
    {
      german: "nennt man",
      translated: "được gọi là",
      tone: 'semantic',
    },
    {
      german: "die letzten vier Wochen",
      translated: "bốn tuần cuối",
      tone: 'semantic',
    },
    {
      german: "vor Weihnachten",
      translated: "trước Giáng sinh",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:297|ar": [
    {
      german: "Aus welchem Land",
      translated: "من أي دولة",
      tone: 'semantic',
    },
    {
      german: "sind",
      translated: "جاء",
      tone: 'semantic',
    },
    {
      german: "die meisten",
      translated: "أكبر عدد",
      tone: 'semantic',
    },
    {
      german: "Migrantinnen und Migranten",
      translated: "المهاجرين",
      tone: 'semantic',
    },
    {
      german: "nach Deutschland",
      translated: "إلى ألمانيا",
      tone: 'semantic',
    },
    {
      german: "gekommen",
      translated: "؟",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:297|bg": [
    {
      german: "Aus welchem Land",
      translated: "От коя държава",
      tone: 'semantic',
    },
    {
      german: "die meisten",
      translated: "най-много",
      tone: 'semantic',
    },
    {
      german: "Migrantinnen und Migranten",
      translated: "мигранти",
      tone: 'semantic',
    },
    {
      german: "nach Deutschland",
      translated: "в Германия",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:297|bs": [
    {
      german: "Aus welchem Land",
      translated: "Iz koje je države",
      tone: 'semantic',
    },
    {
      german: "die meisten",
      translated: "najviše",
      tone: 'semantic',
    },
    {
      german: "Migrantinnen und Migranten",
      translated: "migranata",
      tone: 'semantic',
    },
    {
      german: "nach Deutschland",
      translated: "u Njemačku",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:297|el": [
    {
      german: "Aus welchem Land",
      translated: "Από ποια χώρα",
      tone: 'semantic',
    },
    {
      german: "die meisten",
      translated: "οι περισσότεροι",
      tone: 'semantic',
    },
    {
      german: "Migrantinnen und Migranten",
      translated: "μετανάστες",
      tone: 'semantic',
    },
    {
      german: "nach Deutschland",
      translated: "στη Γερμανία",
      tone: 'semantic',
    },
    {
      german: "gekommen",
      translated: "προέρχονται",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:297|en": [
    {
      german: "Aus welchem Land",
      translated: "From which country",
      tone: 'semantic',
    },
    {
      german: "sind",
      translated: "have",
      tone: 'semantic',
    },
    {
      german: "die meisten",
      translated: "most",
      tone: 'semantic',
    },
    {
      german: "Migrantinnen und Migranten",
      translated: "migrants",
      tone: 'semantic',
    },
    {
      german: "nach Deutschland",
      translated: "to Germany",
      tone: 'semantic',
    },
    {
      german: "gekommen",
      translated: "come",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:297|es": [
    {
      german: "Aus welchem Land",
      translated: "¿De qué país",
      tone: 'semantic',
    },
    {
      german: "sind",
      translated: "han",
      tone: 'semantic',
    },
    {
      german: "die meisten",
      translated: "el mayor número de",
      tone: 'semantic',
    },
    {
      german: "Migrantinnen und Migranten",
      translated: "inmigrantes",
      tone: 'semantic',
    },
    {
      german: "nach Deutschland",
      translated: "a Alemania",
      tone: 'semantic',
    },
    {
      german: "gekommen",
      translated: "llegado",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:297|fa": [
    {
      german: "Aus welchem Land",
      translated: "از کدام کشور",
      tone: 'semantic',
    },
    {
      german: "die meisten",
      translated: "بیشترین تعداد",
      tone: 'semantic',
    },
    {
      german: "Migrantinnen und Migranten",
      translated: "مهاجران",
      tone: 'semantic',
    },
    {
      german: "nach Deutschland",
      translated: "به آلمان",
      tone: 'semantic',
    },
    {
      german: "gekommen",
      translated: "آمده‌اند",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:297|fr": [
    {
      german: "Aus welchem Land",
      translated: "De quel pays",
      tone: 'semantic',
    },
    {
      german: "sind",
      translated: "sont",
      tone: 'semantic',
    },
    {
      german: "die meisten",
      translated: "le plus de",
      tone: 'semantic',
    },
    {
      german: "Migrantinnen und Migranten",
      translated: "migrants",
      tone: 'semantic',
    },
    {
      german: "nach Deutschland",
      translated: "en Allemagne",
      tone: 'semantic',
    },
    {
      german: "gekommen",
      translated: "venus",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:297|hr": [
    {
      german: "Aus welchem Land",
      translated: "Iz koje je države",
      tone: 'semantic',
    },
    {
      german: "die meisten",
      translated: "najviše",
      tone: 'semantic',
    },
    {
      german: "Migrantinnen und Migranten",
      translated: "migranata",
      tone: 'semantic',
    },
    {
      german: "nach Deutschland",
      translated: "u Njemačku",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:297|it": [
    {
      german: "Aus welchem Land",
      translated: "Da quale Paese",
      tone: 'semantic',
    },
    {
      german: "die meisten",
      translated: "il maggior numero",
      tone: 'semantic',
    },
    {
      german: "Migrantinnen und Migranten",
      translated: "di migranti",
      tone: 'semantic',
    },
    {
      german: "nach Deutschland",
      translated: "in Germania",
      tone: 'semantic',
    },
    {
      german: "gekommen",
      translated: "proviene",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:297|kmr": [
    {
      german: "Aus welchem Land",
      translated: "ji kîjan welatê",
      tone: 'semantic',
    },
    {
      german: "die meisten",
      translated: "Piraniya",
      tone: 'semantic',
    },
    {
      german: "Migrantinnen und Migranten",
      translated: "koçberan",
      tone: 'semantic',
    },
    {
      german: "nach Deutschland",
      translated: "Almanyayê",
      tone: 'semantic',
    },
    {
      german: "gekommen",
      translated: "hatine",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:297|pl": [
    {
      german: "Aus welchem Land",
      translated: "Z którego państwa",
      tone: 'semantic',
    },
    {
      german: "die meisten",
      translated: "najwięcej",
      tone: 'semantic',
    },
    {
      german: "Migrantinnen und Migranten",
      translated: "migrantów",
      tone: 'semantic',
    },
    {
      german: "nach Deutschland",
      translated: "do Niemiec",
      tone: 'semantic',
    },
    {
      german: "gekommen",
      translated: "przybyło",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:297|prs": [
    {
      german: "die meisten",
      translated: "بیشترین تعداد",
      tone: 'semantic',
    },
    {
      german: "Migrantinnen und Migranten",
      translated: "مهاجران",
      tone: 'semantic',
    },
    {
      german: "nach Deutschland",
      translated: "به آلمان",
      tone: 'semantic',
    },
    {
      german: "gekommen",
      translated: "آمده‌اند",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:297|ro": [
    {
      german: "Aus welchem Land",
      translated: "Din ce țară",
      tone: 'semantic',
    },
    {
      german: "sind",
      translated: "au venit",
      tone: 'semantic',
    },
    {
      german: "die meisten",
      translated: "cei mai mulți",
      tone: 'semantic',
    },
    {
      german: "Migrantinnen und Migranten",
      translated: "migranți",
      tone: 'semantic',
    },
    {
      german: "nach Deutschland",
      translated: "în Germania",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:297|ru": [
    {
      german: "Aus welchem Land",
      translated: "Из какой страны",
      tone: 'semantic',
    },
    {
      german: "die meisten",
      translated: "больше всего",
      tone: 'semantic',
    },
    {
      german: "Migrantinnen und Migranten",
      translated: "мигрантов",
      tone: 'semantic',
    },
    {
      german: "nach Deutschland",
      translated: "в Германию",
      tone: 'semantic',
    },
    {
      german: "gekommen",
      translated: "приехало",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:297|sq": [
    {
      german: "Aus welchem Land",
      translated: "Nga cili shtet",
      tone: 'semantic',
    },
    {
      german: "sind",
      translated: "kanë ardhur",
      tone: 'semantic',
    },
    {
      german: "die meisten",
      translated: "më shumë",
      tone: 'semantic',
    },
    {
      german: "Migrantinnen und Migranten",
      translated: "migrantë",
      tone: 'semantic',
    },
    {
      german: "nach Deutschland",
      translated: "në Gjermani",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:297|sr": [
    {
      german: "Aus welchem Land",
      translated: "Iz koje je države",
      tone: 'semantic',
    },
    {
      german: "die meisten",
      translated: "najviše",
      tone: 'semantic',
    },
    {
      german: "Migrantinnen und Migranten",
      translated: "migranata",
      tone: 'semantic',
    },
    {
      german: "nach Deutschland",
      translated: "u Nemačku",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:297|tr": [
    {
      german: "Aus welchem Land",
      translated: "hangi ülkeden",
      tone: 'semantic',
    },
    {
      german: "die meisten",
      translated: "en fazla",
      tone: 'semantic',
    },
    {
      german: "Migrantinnen und Migranten",
      translated: "göçmen",
      tone: 'semantic',
    },
    {
      german: "nach Deutschland",
      translated: "Almanya'ya",
      tone: 'semantic',
    },
    {
      german: "gekommen",
      translated: "gelmiştir",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:297|uk": [
    {
      german: "Aus welchem Land",
      translated: "З якої країни",
      tone: 'semantic',
    },
    {
      german: "die meisten",
      translated: "найбільше",
      tone: 'semantic',
    },
    {
      german: "Migrantinnen und Migranten",
      translated: "мігрантів",
      tone: 'semantic',
    },
    {
      german: "nach Deutschland",
      translated: "до Німеччини",
      tone: 'semantic',
    },
    {
      german: "gekommen",
      translated: "приїхало",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:297|vi": [
    {
      german: "Aus welchem Land",
      translated: "từ quốc gia nào",
      tone: 'semantic',
    },
    {
      german: "die meisten",
      translated: "Phần lớn",
      tone: 'semantic',
    },
    {
      german: "Migrantinnen und Migranten",
      translated: "người nhập cư",
      tone: 'semantic',
    },
    {
      german: "nach Deutschland",
      translated: "ở Đức",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:298|ar": [
    {
      german: "In der DDR",
      translated: "في DDR",
      tone: 'semantic',
    },
    {
      german: "lebten",
      translated: "عاشوا",
      tone: 'semantic',
    },
    {
      german: "vor allem",
      translated: "معظم",
      tone: 'semantic',
    },
    {
      german: "Migrantinnen und Migranten",
      translated: "المهاجرين",
      tone: 'semantic',
    },
    {
      german: "aus",
      translated: "من",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:298|bg": [
    {
      german: "In der DDR",
      translated: "В ГДР",
      tone: 'semantic',
    },
    {
      german: "lebten",
      translated: "живееха",
      tone: 'semantic',
    },
    {
      german: "vor allem",
      translated: "предимно",
      tone: 'semantic',
    },
    {
      german: "Migrantinnen und Migranten",
      translated: "мигранти",
      tone: 'semantic',
    },
    {
      german: "aus",
      translated: "от",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:298|bs": [
    {
      german: "In der DDR",
      translated: "U DDR-u",
      tone: 'semantic',
    },
    {
      german: "lebten",
      translated: "živjeli",
      tone: 'semantic',
    },
    {
      german: "vor allem",
      translated: "uglavnom",
      tone: 'semantic',
    },
    {
      german: "Migrantinnen und Migranten",
      translated: "migranti",
      tone: 'semantic',
    },
    {
      german: "aus",
      translated: "iz …",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:298|el": [
    {
      german: "In der DDR",
      translated: "Στη ΛΔΓ",
      tone: 'semantic',
    },
    {
      german: "lebten",
      translated: "ζούσαν",
      tone: 'semantic',
    },
    {
      german: "vor allem",
      translated: "κυρίως",
      tone: 'semantic',
    },
    {
      german: "Migrantinnen und Migranten",
      translated: "μετανάστες",
      tone: 'semantic',
    },
    {
      german: "aus",
      translated: "από",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:298|en": [
    {
      german: "In der DDR",
      translated: "In the GDR",
      tone: 'semantic',
    },
    {
      german: "vor allem",
      translated: "mainly",
      tone: 'semantic',
    },
    {
      german: "Migrantinnen und Migranten",
      translated: "migrants",
      tone: 'semantic',
    },
    {
      german: "aus",
      translated: "came from",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:298|es": [
    {
      german: "In der DDR",
      translated: "En la RDA",
      tone: 'semantic',
    },
    {
      german: "lebten",
      translated: "procedían",
      tone: 'semantic',
    },
    {
      german: "vor allem",
      translated: "principalmente",
      tone: 'semantic',
    },
    {
      german: "Migrantinnen und Migranten",
      translated: "los inmigrantes",
      tone: 'semantic',
    },
    {
      german: "aus",
      translated: "de",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:298|fa": [
    {
      german: "In der DDR",
      translated: "در جمهوری دموکراتیک آلمان",
      tone: 'semantic',
    },
    {
      german: "lebten",
      translated: "زندگی می‌کردند",
      tone: 'semantic',
    },
    {
      german: "vor allem",
      translated: "عمدتاً",
      tone: 'semantic',
    },
    {
      german: "Migrantinnen und Migranten",
      translated: "مهاجرانی",
      tone: 'semantic',
    },
    {
      german: "aus",
      translated: "از …",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:298|fr": [
    {
      german: "In der DDR",
      translated: "En RDA",
      tone: 'semantic',
    },
    {
      german: "lebten",
      translated: "venaient",
      tone: 'semantic',
    },
    {
      german: "vor allem",
      translated: "principalement",
      tone: 'semantic',
    },
    {
      german: "Migrantinnen und Migranten",
      translated: "les migrants",
      tone: 'semantic',
    },
    {
      german: "aus",
      translated: "de",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:298|hr": [
    {
      german: "In der DDR",
      translated: "U DDR-u",
      tone: 'semantic',
    },
    {
      german: "lebten",
      translated: "živjeli",
      tone: 'semantic',
    },
    {
      german: "vor allem",
      translated: "uglavnom",
      tone: 'semantic',
    },
    {
      german: "Migrantinnen und Migranten",
      translated: "migranti",
      tone: 'semantic',
    },
    {
      german: "aus",
      translated: "iz …",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:298|it": [
    {
      german: "In der DDR",
      translated: "Nella RDT",
      tone: 'semantic',
    },
    {
      german: "lebten",
      translated: "provenivano",
      tone: 'semantic',
    },
    {
      german: "vor allem",
      translated: "principalmente",
      tone: 'semantic',
    },
    {
      german: "Migrantinnen und Migranten",
      translated: "migranti",
      tone: 'semantic',
    },
    {
      german: "aus",
      translated: "da",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:298|kmr": [
    {
      german: "In der DDR",
      translated: "Li DDR",
      tone: 'semantic',
    },
    {
      german: "lebten",
      translated: "dijiyan",
      tone: 'semantic',
    },
    {
      german: "vor allem",
      translated: "bi taybetî",
      tone: 'semantic',
    },
    {
      german: "Migrantinnen und Migranten",
      translated: "koçberên",
      tone: 'semantic',
    },
    {
      german: "aus",
      translated: "ji",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:298|pl": [
    {
      german: "In der DDR",
      translated: "W NRD",
      tone: 'semantic',
    },
    {
      german: "lebten",
      translated: "pochodzili",
      tone: 'semantic',
    },
    {
      german: "vor allem",
      translated: "głównie",
      tone: 'semantic',
    },
    {
      german: "Migrantinnen und Migranten",
      translated: "migranci",
      tone: 'semantic',
    },
    {
      german: "aus",
      translated: "z",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:298|prs": [
    {
      german: "In der DDR",
      translated: "در جمهوری دموکراتیک آلمان",
      tone: 'semantic',
    },
    {
      german: "lebten",
      translated: "زندگی می‌کردند",
      tone: 'semantic',
    },
    {
      german: "vor allem",
      translated: "عمدتاً",
      tone: 'semantic',
    },
    {
      german: "Migrantinnen und Migranten",
      translated: "مهاجرانی",
      tone: 'semantic',
    },
    {
      german: "aus",
      translated: "از",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:298|ro": [
    {
      german: "In der DDR",
      translated: "În RDG",
      tone: 'semantic',
    },
    {
      german: "lebten",
      translated: "proveneau",
      tone: 'semantic',
    },
    {
      german: "vor allem",
      translated: "în principal",
      tone: 'semantic',
    },
    {
      german: "Migrantinnen und Migranten",
      translated: "migranții",
      tone: 'semantic',
    },
    {
      german: "aus",
      translated: "din",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:298|ru": [
    {
      german: "In der DDR",
      translated: "В ГДР",
      tone: 'semantic',
    },
    {
      german: "lebten",
      translated: "жили",
      tone: 'semantic',
    },
    {
      german: "vor allem",
      translated: "в основном",
      tone: 'semantic',
    },
    {
      german: "Migrantinnen und Migranten",
      translated: "мигранты",
      tone: 'semantic',
    },
    {
      german: "aus",
      translated: "из",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:298|sq": [
    {
      german: "In der DDR",
      translated: "Në RDGJ",
      tone: 'semantic',
    },
    {
      german: "lebten",
      translated: "vinin",
      tone: 'semantic',
    },
    {
      german: "vor allem",
      translated: "kryesisht",
      tone: 'semantic',
    },
    {
      german: "Migrantinnen und Migranten",
      translated: "migrantët",
      tone: 'semantic',
    },
    {
      german: "aus",
      translated: "nga",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:298|sr": [
    {
      german: "In der DDR",
      translated: "U DDR-u",
      tone: 'semantic',
    },
    {
      german: "lebten",
      translated: "živjeli",
      tone: 'semantic',
    },
    {
      german: "vor allem",
      translated: "uglavnom",
      tone: 'semantic',
    },
    {
      german: "Migrantinnen und Migranten",
      translated: "migranti",
      tone: 'semantic',
    },
    {
      german: "aus",
      translated: "iz …",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:298|tr": [
    {
      german: "In der DDR",
      translated: "Doğu Almanya'da (DDR)",
      tone: 'semantic',
    },
    {
      german: "lebten",
      translated: "yaşayan",
      tone: 'semantic',
    },
    {
      german: "vor allem",
      translated: "önemli bir bölümü",
      tone: 'semantic',
    },
    {
      german: "Migrantinnen und Migranten",
      translated: "göçmenlerin",
      tone: 'semantic',
    },
    {
      german: "aus",
      translated: "ülkelerinden",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:298|uk": [
    {
      german: "In der DDR",
      translated: "У НДР",
      tone: 'semantic',
    },
    {
      german: "lebten",
      translated: "походили",
      tone: 'semantic',
    },
    {
      german: "vor allem",
      translated: "переважно",
      tone: 'semantic',
    },
    {
      german: "Migrantinnen und Migranten",
      translated: "мігранти",
      tone: 'semantic',
    },
    {
      german: "aus",
      translated: "з",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:298|vi": [
    {
      german: "In der DDR",
      translated: "Ở CHDC Đức",
      tone: 'semantic',
    },
    {
      german: "lebten",
      translated: "sinh sống",
      tone: 'semantic',
    },
    {
      german: "vor allem",
      translated: "chủ yếu",
      tone: 'semantic',
    },
    {
      german: "Migrantinnen und Migranten",
      translated: "người nhập cư",
      tone: 'semantic',
    },
    {
      german: "aus",
      translated: "từ",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:299|ar": [
    {
      german: "Ausländische",
      translated: "الأجانب",
      tone: 'semantic',
    },
    {
      german: "Arbeitnehmerinnen und Arbeitnehmer",
      translated: "العمال",
      tone: 'semantic',
    },
    {
      german: "in den 50er und 60er Jahren",
      translated: "في خمسينيات وستينيات القرن العشرين",
      tone: 'semantic',
    },
    {
      german: "von der Bundesrepublik Deutschland",
      translated: "جمهورية ألمانيا الاتحادية",
      tone: 'semantic',
    },
    {
      german: "angeworben wurden",
      translated: "استقدمتهم",
      tone: 'semantic',
    },
    {
      german: "nannte man",
      translated: "ماذا كان يُسمى",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:299|bg": [
    {
      german: "Ausländische",
      translated: "чуждестранните",
      tone: 'semantic',
    },
    {
      german: "Arbeitnehmerinnen und Arbeitnehmer",
      translated: "работници",
      tone: 'semantic',
    },
    {
      german: "in den 50er und 60er Jahren",
      translated: "през 50-те и 60-те години",
      tone: 'semantic',
    },
    {
      german: "von der Bundesrepublik Deutschland",
      translated: "във ФРГ",
      tone: 'semantic',
    },
    {
      german: "angeworben wurden",
      translated: "привлечени",
      tone: 'semantic',
    },
    {
      german: "nannte man",
      translated: "Как са наричани",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:299|bs": [
    {
      german: "Ausländische",
      translated: "strani",
      tone: 'semantic',
    },
    {
      german: "Arbeitnehmerinnen und Arbeitnehmer",
      translated: "radnici",
      tone: 'semantic',
    },
    {
      german: "in den 50er und 60er Jahren",
      translated: "1950-ih i 1960-ih",
      tone: 'semantic',
    },
    {
      german: "von der Bundesrepublik Deutschland",
      translated: "Savezna Republika Njemačka",
      tone: 'semantic',
    },
    {
      german: "angeworben wurden",
      translated: "regrutirala",
      tone: 'semantic',
    },
    {
      german: "nannte man",
      translated: "nazivali",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:299|el": [
    {
      german: "Ausländische",
      translated: "ξένοι",
      tone: 'semantic',
    },
    {
      german: "Arbeitnehmerinnen und Arbeitnehmer",
      translated: "εργαζόμενοι",
      tone: 'semantic',
    },
    {
      german: "in den 50er und 60er Jahren",
      translated: "τις δεκαετίες 1950 και 1960",
      tone: 'semantic',
    },
    {
      german: "von der Bundesrepublik Deutschland",
      translated: "στη Δυτική Γερμανία",
      tone: 'semantic',
    },
    {
      german: "angeworben wurden",
      translated: "προσλήφθηκαν",
      tone: 'semantic',
    },
    {
      german: "nannte man",
      translated: "Πώς ονομάζονταν",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:299|en": [
    {
      german: "Ausländische",
      translated: "Foreign",
      tone: 'semantic',
    },
    {
      german: "Arbeitnehmerinnen und Arbeitnehmer",
      translated: "workers",
      tone: 'semantic',
    },
    {
      german: "in den 50er und 60er Jahren",
      translated: "in the 1950s and 1960s",
      tone: 'semantic',
    },
    {
      german: "von der Bundesrepublik Deutschland",
      translated: "by the Federal Republic of Germany",
      tone: 'semantic',
    },
    {
      german: "angeworben wurden",
      translated: "were recruited",
      tone: 'semantic',
    },
    {
      german: "nannte man",
      translated: "were called",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:299|es": [
    {
      german: "Ausländische",
      translated: "extranjeros",
      tone: 'semantic',
    },
    {
      german: "Arbeitnehmerinnen und Arbeitnehmer",
      translated: "trabajadores",
      tone: 'semantic',
    },
    {
      german: "in den 50er und 60er Jahren",
      translated: "en las décadas de 1950 y 1960",
      tone: 'semantic',
    },
    {
      german: "von der Bundesrepublik Deutschland",
      translated: "por la República Federal de Alemania",
      tone: 'semantic',
    },
    {
      german: "angeworben wurden",
      translated: "fueron contratados",
      tone: 'semantic',
    },
    {
      german: "nannte man",
      translated: "se llamaba",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:299|fa": [
    {
      german: "Ausländische",
      translated: "خارجی",
      tone: 'semantic',
    },
    {
      german: "Arbeitnehmerinnen und Arbeitnehmer",
      translated: "کارگران",
      tone: 'semantic',
    },
    {
      german: "in den 50er und 60er Jahren",
      translated: "در دهه‌های ۱۹۵۰ و ۱۹۶۰",
      tone: 'semantic',
    },
    {
      german: "von der Bundesrepublik Deutschland",
      translated: "توسط جمهوری فدرال آلمان",
      tone: 'semantic',
    },
    {
      german: "angeworben wurden",
      translated: "جذب شدند",
      tone: 'semantic',
    },
    {
      german: "nannte man",
      translated: "چه نامیده می‌شدند؟",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:299|fr": [
    {
      german: "Ausländische",
      translated: "étrangers",
      tone: 'semantic',
    },
    {
      german: "Arbeitnehmerinnen und Arbeitnehmer",
      translated: "travailleurs",
      tone: 'semantic',
    },
    {
      german: "in den 50er und 60er Jahren",
      translated: "dans les années 1950 et 1960",
      tone: 'semantic',
    },
    {
      german: "von der Bundesrepublik Deutschland",
      translated: "par la République fédérale d’Allemagne",
      tone: 'semantic',
    },
    {
      german: "angeworben wurden",
      translated: "recrutés",
      tone: 'semantic',
    },
    {
      german: "nannte man",
      translated: "Comment appelait-on",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:299|hr": [
    {
      german: "Ausländische",
      translated: "strani",
      tone: 'semantic',
    },
    {
      german: "Arbeitnehmerinnen und Arbeitnehmer",
      translated: "radnici",
      tone: 'semantic',
    },
    {
      german: "in den 50er und 60er Jahren",
      translated: "1950-ih i 1960-ih",
      tone: 'semantic',
    },
    {
      german: "von der Bundesrepublik Deutschland",
      translated: "Savezna Republika Njemačka",
      tone: 'semantic',
    },
    {
      german: "angeworben wurden",
      translated: "regrutirala",
      tone: 'semantic',
    },
    {
      german: "nannte man",
      translated: "nazivali",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:299|it": [
    {
      german: "Ausländische",
      translated: "stranieri",
      tone: 'semantic',
    },
    {
      german: "Arbeitnehmerinnen und Arbeitnehmer",
      translated: "lavoratori",
      tone: 'semantic',
    },
    {
      german: "in den 50er und 60er Jahren",
      translated: "anni 1950 e 1960",
      tone: 'semantic',
    },
    {
      german: "von der Bundesrepublik Deutschland",
      translated: "nella RFG",
      tone: 'semantic',
    },
    {
      german: "angeworben wurden",
      translated: "reclutati",
      tone: 'semantic',
    },
    {
      german: "nannte man",
      translated: "Come venivano chiamati",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:299|kmr": [
    {
      german: "Ausländische",
      translated: "biyanî",
      tone: 'semantic',
    },
    {
      german: "Arbeitnehmerinnen und Arbeitnehmer",
      translated: "Karkerên",
      tone: 'semantic',
    },
    {
      german: "in den 50er und 60er Jahren",
      translated: "di salên 1950 û 1960 de",
      tone: 'semantic',
    },
    {
      german: "von der Bundesrepublik Deutschland",
      translated: "ji aliyê Komara Federal a Almanyayê ve",
      tone: 'semantic',
    },
    {
      german: "angeworben wurden",
      translated: "hatin vexwendin",
      tone: 'semantic',
    },
    {
      german: "nannte man",
      translated: "çi dihatin gotin",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:299|pl": [
    {
      german: "Ausländische",
      translated: "zagranicznych",
      tone: 'semantic',
    },
    {
      german: "Arbeitnehmerinnen und Arbeitnehmer",
      translated: "pracowników",
      tone: 'semantic',
    },
    {
      german: "in den 50er und 60er Jahren",
      translated: "w latach 50. i 60.",
      tone: 'semantic',
    },
    {
      german: "von der Bundesrepublik Deutschland",
      translated: "w RFN",
      tone: 'semantic',
    },
    {
      german: "angeworben wurden",
      translated: "rekrutowanych",
      tone: 'semantic',
    },
    {
      german: "nannte man",
      translated: "Jak nazywano",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:299|prs": [
    {
      german: "Ausländische",
      translated: "خارجی",
      tone: 'semantic',
    },
    {
      german: "Arbeitnehmerinnen und Arbeitnehmer",
      translated: "کارگران",
      tone: 'semantic',
    },
    {
      german: "in den 50er und 60er Jahren",
      translated: "در دهه‌های ۱۹۵۰ و ۱۹۶۰",
      tone: 'semantic',
    },
    {
      german: "von der Bundesrepublik Deutschland",
      translated: "توسط جمهوری فدرال آلمان",
      tone: 'semantic',
    },
    {
      german: "angeworben wurden",
      translated: "جذب شدند",
      tone: 'semantic',
    },
    {
      german: "nannte man",
      translated: "چه نامیده می‌شدند؟",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:299|ro": [
    {
      german: "Ausländische",
      translated: "străini",
      tone: 'semantic',
    },
    {
      german: "Arbeitnehmerinnen und Arbeitnehmer",
      translated: "muncitorii",
      tone: 'semantic',
    },
    {
      german: "in den 50er und 60er Jahren",
      translated: "în anii 1950 și 1960",
      tone: 'semantic',
    },
    {
      german: "von der Bundesrepublik Deutschland",
      translated: "de RFG",
      tone: 'semantic',
    },
    {
      german: "angeworben wurden",
      translated: "recrutați",
      tone: 'semantic',
    },
    {
      german: "nannte man",
      translated: "Cum erau numiți",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:299|ru": [
    {
      german: "Ausländische",
      translated: "Иностранных",
      tone: 'semantic',
    },
    {
      german: "Arbeitnehmerinnen und Arbeitnehmer",
      translated: "работников",
      tone: 'semantic',
    },
    {
      german: "in den 50er und 60er Jahren",
      translated: "1950-х и 1960-х годах",
      tone: 'semantic',
    },
    {
      german: "von der Bundesrepublik Deutschland",
      translated: "ФРГ",
      tone: 'semantic',
    },
    {
      german: "angeworben wurden",
      translated: "нанимала",
      tone: 'semantic',
    },
    {
      german: "nannte man",
      translated: "называли",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:299|sq": [
    {
      german: "Ausländische",
      translated: "e huaj",
      tone: 'semantic',
    },
    {
      german: "Arbeitnehmerinnen und Arbeitnehmer",
      translated: "punëtorët",
      tone: 'semantic',
    },
    {
      german: "in den 50er und 60er Jahren",
      translated: "në vitet 1950 dhe 1960",
      tone: 'semantic',
    },
    {
      german: "von der Bundesrepublik Deutschland",
      translated: "në RFGJ",
      tone: 'semantic',
    },
    {
      german: "angeworben wurden",
      translated: "rekrutuar",
      tone: 'semantic',
    },
    {
      german: "nannte man",
      translated: "Si quheshin",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:299|sr": [
    {
      german: "Ausländische",
      translated: "strani",
      tone: 'semantic',
    },
    {
      german: "Arbeitnehmerinnen und Arbeitnehmer",
      translated: "radnici",
      tone: 'semantic',
    },
    {
      german: "in den 50er und 60er Jahren",
      translated: "1950-ih i 1960-ih",
      tone: 'semantic',
    },
    {
      german: "von der Bundesrepublik Deutschland",
      translated: "Savezna Republika Nemačka",
      tone: 'semantic',
    },
    {
      german: "angeworben wurden",
      translated: "regrutirala",
      tone: 'semantic',
    },
    {
      german: "nannte man",
      translated: "nazivali",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:299|tr": [
    {
      german: "Arbeitnehmerinnen und Arbeitnehmer",
      translated: "yabancı işçilere",
      tone: 'semantic',
    },
    {
      german: "in den 50er und 60er Jahren",
      translated: "1950'li ve 1960'lı yıllarda",
      tone: 'semantic',
    },
    {
      german: "von der Bundesrepublik Deutschland",
      translated: "Almanya Federal Cumhuriyeti tarafından",
      tone: 'semantic',
    },
    {
      german: "angeworben wurden",
      translated: "çalışmak üzere getirilen",
      tone: 'semantic',
    },
    {
      german: "nannte man",
      translated: "ne denirdi",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:299|uk": [
    {
      german: "Ausländische",
      translated: "Іноземних",
      tone: 'semantic',
    },
    {
      german: "Arbeitnehmerinnen und Arbeitnehmer",
      translated: "працівників",
      tone: 'semantic',
    },
    {
      german: "in den 50er und 60er Jahren",
      translated: "у 1950-х і 1960-х роках",
      tone: 'semantic',
    },
    {
      german: "von der Bundesrepublik Deutschland",
      translated: "Федеративна Республіка Німеччина",
      tone: 'semantic',
    },
    {
      german: "angeworben wurden",
      translated: "залучала",
      tone: 'semantic',
    },
    {
      german: "nannte man",
      translated: "називали",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:299|vi": [
    {
      german: "Ausländische",
      translated: "Những",
      tone: 'semantic',
    },
    {
      german: "Arbeitnehmerinnen und Arbeitnehmer",
      translated: "lao động nước ngoài",
      tone: 'semantic',
    },
    {
      german: "in den 50er und 60er Jahren",
      translated: "trong thập niên 1950 và 1960",
      tone: 'semantic',
    },
    {
      german: "von der Bundesrepublik Deutschland",
      translated: "Tây Đức",
      tone: 'semantic',
    },
    {
      german: "angeworben wurden",
      translated: "được tuyển dụng",
      tone: 'semantic',
    },
    {
      german: "nannte man",
      translated: "được gọi là gì?",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:29|ar": [
    {
      german: "Welches Tier",
      translated: "ما الحيوان",
      tone: 'semantic',
    },
    {
      german: "das Wappentier",
      translated: "الذي يمثل شعار",
      tone: 'semantic',
    },
    {
      german: "der Bundesrepublik Deutschland",
      translated: "جمهورية ألمانيا الاتحادية",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:29|bg": [
    {
      german: "Welches Tier",
      translated: "Кое животно",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "е",
      tone: 'semantic',
    },
    {
      german: "das Wappentier",
      translated: "на герба",
      tone: 'semantic',
    },
    {
      german: "der Bundesrepublik Deutschland",
      translated: "на Федерална република Германия",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:29|bs": [
    {
      german: "Welches Tier",
      translated: "Koja se životinja",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "nalazi",
      tone: 'semantic',
    },
    {
      german: "das Wappentier",
      translated: "na grbu",
      tone: 'semantic',
    },
    {
      german: "der Bundesrepublik Deutschland",
      translated: "Savezne Republike Njemačke",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:29|el": [
    {
      german: "Welches Tier",
      translated: "Ποιο ζώο",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "εμφανίζεται",
      tone: 'semantic',
    },
    {
      german: "das Wappentier",
      translated: "έμβλημα",
      tone: 'semantic',
    },
    {
      german: "der Bundesrepublik Deutschland",
      translated: "της Ομοσπονδιακής Δημοκρατίας της Γερμανίας",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:29|en": [
    {
      german: "Welches Tier",
      translated: "Which animal",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "is",
      tone: 'semantic',
    },
    {
      german: "das Wappentier",
      translated: "the heraldic animal",
      tone: 'semantic',
    },
    {
      german: "der Bundesrepublik Deutschland",
      translated: "of the Federal Republic of Germany",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:29|es": [
    {
      german: "Welches Tier",
      translated: "¿Qué animal",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "representa",
      tone: 'semantic',
    },
    {
      german: "das Wappentier",
      translated: "en su escudo",
      tone: 'semantic',
    },
    {
      german: "der Bundesrepublik Deutschland",
      translated: "a la República Federal de Alemania",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:29|fa": [
    {
      german: "Welches Tier",
      translated: "کدام حیوان",
      tone: 'semantic',
    },
    {
      german: "das Wappentier",
      translated: "در نشان",
      tone: 'semantic',
    },
    {
      german: "der Bundesrepublik Deutschland",
      translated: "جمهوری فدرال آلمان",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:29|fr": [
    {
      german: "Welches Tier",
      translated: "Quel animal",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "figure",
      tone: 'semantic',
    },
    {
      german: "das Wappentier",
      translated: "les armoiries",
      tone: 'semantic',
    },
    {
      german: "der Bundesrepublik Deutschland",
      translated: "de la République fédérale d’Allemagne",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:29|hr": [
    {
      german: "Welches Tier",
      translated: "Koja se životinja",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "nalazi",
      tone: 'semantic',
    },
    {
      german: "das Wappentier",
      translated: "na grbu",
      tone: 'semantic',
    },
    {
      german: "der Bundesrepublik Deutschland",
      translated: "Savezne Republike Njemačke",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:29|it": [
    {
      german: "Welches Tier",
      translated: "Quale animale",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "compare",
      tone: 'semantic',
    },
    {
      german: "das Wappentier",
      translated: "sullo stemma",
      tone: 'semantic',
    },
    {
      german: "der Bundesrepublik Deutschland",
      translated: "della Repubblica Federale di Germania",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:29|kmr": [
    {
      german: "Welches Tier",
      translated: "Kîjan heywan",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "ye",
      tone: 'semantic',
    },
    {
      german: "das Wappentier",
      translated: "li nîşana",
      tone: 'semantic',
    },
    {
      german: "der Bundesrepublik Deutschland",
      translated: "Komara Federal a Almanyayê",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:29|pl": [
    {
      german: "Welches Tier",
      translated: "Jakie zwierzę",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "widnieje",
      tone: 'semantic',
    },
    {
      german: "das Wappentier",
      translated: "w herbie",
      tone: 'semantic',
    },
    {
      german: "der Bundesrepublik Deutschland",
      translated: "Republiki Federalnej Niemiec",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:29|prs": [
    {
      german: "Welches Tier",
      translated: "کدام حیوان",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "در",
      tone: 'semantic',
    },
    {
      german: "das Wappentier",
      translated: "نشان",
      tone: 'semantic',
    },
    {
      german: "der Bundesrepublik Deutschland",
      translated: "جمهوری فدرال آلمان",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:29|ro": [
    {
      german: "Welches Tier",
      translated: "Ce animal",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "apare",
      tone: 'semantic',
    },
    {
      german: "das Wappentier",
      translated: "pe stema",
      tone: 'semantic',
    },
    {
      german: "der Bundesrepublik Deutschland",
      translated: "Republicii Federale Germania?",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:29|ru": [
    {
      german: "Welches Tier",
      translated: "Какое животное",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "изображено",
      tone: 'semantic',
    },
    {
      german: "das Wappentier",
      translated: "на гербе",
      tone: 'semantic',
    },
    {
      german: "der Bundesrepublik Deutschland",
      translated: "Федеративной Республики Германия",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:29|sq": [
    {
      german: "Welches Tier",
      translated: "Cila kafshë",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "gjendet",
      tone: 'semantic',
    },
    {
      german: "das Wappentier",
      translated: "stemën",
      tone: 'semantic',
    },
    {
      german: "der Bundesrepublik Deutschland",
      translated: "e Republikës Federale të Gjermanisë",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:29|sr": [
    {
      german: "Welches Tier",
      translated: "Koja se životinja",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "nalazi",
      tone: 'semantic',
    },
    {
      german: "das Wappentier",
      translated: "grbu",
      tone: 'semantic',
    },
    {
      german: "der Bundesrepublik Deutschland",
      translated: "Savezne Republike Nemačke",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:29|tr": [
    {
      german: "Welches Tier",
      translated: "hangisidir",
      tone: 'semantic',
    },
    {
      german: "das Wappentier",
      translated: "armasındaki hayvan",
      tone: 'semantic',
    },
    {
      german: "der Bundesrepublik Deutschland",
      translated: "Almanya Federal Cumhuriyeti'nin",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:29|uk": [
    {
      german: "Welches Tier",
      translated: "Яка тварина",
      tone: 'semantic',
    },
    {
      german: "das Wappentier",
      translated: "на гербі",
      tone: 'semantic',
    },
    {
      german: "der Bundesrepublik Deutschland",
      translated: "Федеративної Республіки Німеччина",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:29|vi": [
    {
      german: "Welches Tier",
      translated: "Con vật nào",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "xuất hiện",
      tone: 'semantic',
    },
    {
      german: "das Wappentier",
      translated: "quốc huy",
      tone: 'semantic',
    },
    {
      german: "der Bundesrepublik Deutschland",
      translated: "của Cộng hòa Liên bang Đức",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:2|ar": [
    {
      german: "In Deutschland",
      translated: "في ألمانيا",
      tone: 'semantic',
    },
    {
      german: "können Eltern",
      translated: "يمكن للوالدين",
      tone: 'semantic',
    },
    {
      german: "bis zum 14. Lebensjahr",
      translated: "حتى بلوغ طفلهم سن الرابعة عشرة",
      tone: 'semantic',
    },
    {
      german: "entscheiden",
      translated: "أن يقررا",
      tone: 'semantic',
    },
    {
      german: "ob es",
      translated: "ما إذا كان سيشارك",
      tone: 'semantic',
    },
    {
      german: "in der Schule",
      translated: "في المدرسة",
      tone: 'semantic',
    },
    {
      german: "am …",
      translated: "في …",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:2|bg": [
    {
      german: "In Deutschland",
      translated: "В Германия",
      tone: 'semantic',
    },
    {
      german: "können Eltern",
      translated: "родителите могат",
      tone: 'semantic',
    },
    {
      german: "bis zum 14. Lebensjahr",
      translated: "до 14-годишна възраст",
      tone: 'semantic',
    },
    {
      german: "ihres Kindes",
      translated: "на детето",
      tone: 'semantic',
    },
    {
      german: "entscheiden",
      translated: "да решават",
      tone: 'semantic',
    },
    {
      german: "ob es",
      translated: "дали то",
      tone: 'semantic',
    },
    {
      german: "in der Schule",
      translated: "в училищните часове по",
      tone: 'semantic',
    },
    {
      german: "am …",
      translated: "…",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:2|bs": [
    {
      german: "In Deutschland",
      translated: "U Njemačkoj",
      tone: 'semantic',
    },
    {
      german: "können Eltern",
      translated: "roditelji",
      tone: 'semantic',
    },
    {
      german: "bis zum 14. Lebensjahr",
      translated: "do 14. godine",
      tone: 'semantic',
    },
    {
      german: "ihres Kindes",
      translated: "djeteta",
      tone: 'semantic',
    },
    {
      german: "entscheiden",
      translated: "mogu odlučiti",
      tone: 'semantic',
    },
    {
      german: "ob es",
      translated: "hoće li",
      tone: 'semantic',
    },
    {
      german: "in der Schule",
      translated: "u školi",
      tone: 'semantic',
    },
    {
      german: "am …",
      translated: "na nastavi",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:2|el": [
    {
      german: "In Deutschland",
      translated: "Στη Γερμανία",
      tone: 'semantic',
    },
    {
      german: "können Eltern",
      translated: "οι γονείς μπορούν",
      tone: 'semantic',
    },
    {
      german: "bis zum 14. Lebensjahr",
      translated: "μέχρι το παιδί να γίνει 14 ετών",
      tone: 'semantic',
    },
    {
      german: "entscheiden",
      translated: "να αποφασίζουν",
      tone: 'semantic',
    },
    {
      german: "ob es",
      translated: "αν το παιδί",
      tone: 'semantic',
    },
    {
      german: "in der Schule",
      translated: "στο σχολικό μάθημα",
      tone: 'semantic',
    },
    {
      german: "am …",
      translated: "των …",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:2|en": [
    {
      german: "In Deutschland",
      translated: "In Germany",
      tone: 'semantic',
    },
    {
      german: "können Eltern",
      translated: "parents can",
      tone: 'semantic',
    },
    {
      german: "bis zum 14. Lebensjahr",
      translated: "14th birthday",
      tone: 'semantic',
    },
    {
      german: "ihres Kindes",
      translated: "their child's",
      tone: 'semantic',
    },
    {
      german: "entscheiden",
      translated: "decide",
      tone: 'semantic',
    },
    {
      german: "ob es",
      translated: "whether they",
      tone: 'semantic',
    },
    {
      german: "in der Schule",
      translated: "at school",
      tone: 'semantic',
    },
    {
      german: "am …",
      translated: "in …",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:2|es": [
    {
      german: "In Deutschland",
      translated: "En Alemania",
      tone: 'semantic',
    },
    {
      german: "können Eltern",
      translated: "los padres pueden",
      tone: 'semantic',
    },
    {
      german: "bis zum 14. Lebensjahr",
      translated: "hasta que su hijo cumpla 14 años",
      tone: 'semantic',
    },
    {
      german: "entscheiden",
      translated: "decidir",
      tone: 'semantic',
    },
    {
      german: "ob es",
      translated: "si",
      tone: 'semantic',
    },
    {
      german: "in der Schule",
      translated: "en la escuela",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:2|fa": [
    {
      german: "In Deutschland",
      translated: "در آلمان",
      tone: 'semantic',
    },
    {
      german: "können Eltern",
      translated: "والدین",
      tone: 'semantic',
    },
    {
      german: "bis zum 14. Lebensjahr",
      translated: "تا ۱۴ سالگی",
      tone: 'semantic',
    },
    {
      german: "ihres Kindes",
      translated: "فرزندشان",
      tone: 'semantic',
    },
    {
      german: "entscheiden",
      translated: "می‌توانند تصمیم بگیرند",
      tone: 'semantic',
    },
    {
      german: "ob es",
      translated: "که او",
      tone: 'semantic',
    },
    {
      german: "in der Schule",
      translated: "در مدرسه",
      tone: 'semantic',
    },
    {
      german: "am …",
      translated: "…",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:2|fr": [
    {
      german: "In Deutschland",
      translated: "En Allemagne",
      tone: 'semantic',
    },
    {
      german: "können Eltern",
      translated: "les parents peuvent",
      tone: 'semantic',
    },
    {
      german: "bis zum 14. Lebensjahr",
      translated: "jusqu’aux 14 ans",
      tone: 'semantic',
    },
    {
      german: "ihres Kindes",
      translated: "de leur enfant",
      tone: 'semantic',
    },
    {
      german: "entscheiden",
      translated: "décider",
      tone: 'semantic',
    },
    {
      german: "ob es",
      translated: "s’il",
      tone: 'semantic',
    },
    {
      german: "in der Schule",
      translated: "à l’école",
      tone: 'semantic',
    },
    {
      german: "am …",
      translated: "au cours de …",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:2|hr": [
    {
      german: "In Deutschland",
      translated: "U Njemačkoj",
      tone: 'semantic',
    },
    {
      german: "können Eltern",
      translated: "roditelji",
      tone: 'semantic',
    },
    {
      german: "bis zum 14. Lebensjahr",
      translated: "do 14. godine",
      tone: 'semantic',
    },
    {
      german: "ihres Kindes",
      translated: "djeteta",
      tone: 'semantic',
    },
    {
      german: "entscheiden",
      translated: "mogu odlučiti",
      tone: 'semantic',
    },
    {
      german: "ob es",
      translated: "hoće li",
      tone: 'semantic',
    },
    {
      german: "in der Schule",
      translated: "u školi",
      tone: 'semantic',
    },
    {
      german: "am …",
      translated: "na nastavi …",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:2|it": [
    {
      german: "In Deutschland",
      translated: "In Germania",
      tone: 'semantic',
    },
    {
      german: "können Eltern",
      translated: "i genitori possono",
      tone: 'semantic',
    },
    {
      german: "bis zum 14. Lebensjahr",
      translated: "fino ai 14 anni",
      tone: 'semantic',
    },
    {
      german: "ihres Kindes",
      translated: "del figlio",
      tone: 'semantic',
    },
    {
      german: "entscheiden",
      translated: "decidere",
      tone: 'semantic',
    },
    {
      german: "ob es",
      translated: "se il figlio",
      tone: 'semantic',
    },
    {
      german: "in der Schule",
      translated: "a scuola",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:2|kmr": [
    {
      german: "In Deutschland",
      translated: "Li Almanyayê",
      tone: 'semantic',
    },
    {
      german: "können Eltern",
      translated: "dikarin biryar bidin",
      tone: 'semantic',
    },
    {
      german: "bis zum 14. Lebensjahr",
      translated: "heta ku zarok 14 salî dibe",
      tone: 'semantic',
    },
    {
      german: "in der Schule",
      translated: "li dibistanê",
      tone: 'semantic',
    },
    {
      german: "am …",
      translated: "beşdarî … bibe an na",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:2|pl": [
    {
      german: "In Deutschland",
      translated: "W Niemczech",
      tone: 'semantic',
    },
    {
      german: "können Eltern",
      translated: "rodzice",
      tone: 'semantic',
    },
    {
      german: "bis zum 14. Lebensjahr",
      translated: "do 14. roku życia",
      tone: 'semantic',
    },
    {
      german: "ihres Kindes",
      translated: "dziecka",
      tone: 'semantic',
    },
    {
      german: "entscheiden",
      translated: "decydować",
      tone: 'semantic',
    },
    {
      german: "ob es",
      translated: "czy dziecko",
      tone: 'semantic',
    },
    {
      german: "in der Schule",
      translated: "szkolnych",
      tone: 'semantic',
    },
    {
      german: "am …",
      translated: "lekcjach …",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:2|prs": [
    {
      german: "In Deutschland",
      translated: "در آلمان",
      tone: 'semantic',
    },
    {
      german: "können Eltern",
      translated: "والدین تا",
      tone: 'semantic',
    },
    {
      german: "bis zum 14. Lebensjahr",
      translated: "۱۴ سالگی",
      tone: 'semantic',
    },
    {
      german: "ihres Kindes",
      translated: " فرزندشان",
      tone: 'semantic',
    },
    {
      german: "entscheiden",
      translated: "می‌توانند تصمیم بگیرند",
      tone: 'semantic',
    },
    {
      german: "ob es",
      translated: "که او",
      tone: 'semantic',
    },
    {
      german: "in der Schule",
      translated: "در مکتب",
      tone: 'semantic',
    },
    {
      german: "am …",
      translated: "در کلاسِ …",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:2|ro": [
    {
      german: "In Deutschland",
      translated: "În Germania",
      tone: 'semantic',
    },
    {
      german: "können Eltern",
      translated: "părinții pot",
      tone: 'semantic',
    },
    {
      german: "bis zum 14. Lebensjahr",
      translated: "până la vârsta de 14 ani",
      tone: 'semantic',
    },
    {
      german: "ihres Kindes",
      translated: "a copilului",
      tone: 'semantic',
    },
    {
      german: "entscheiden",
      translated: "decide",
      tone: 'semantic',
    },
    {
      german: "ob es",
      translated: "dacă acesta",
      tone: 'semantic',
    },
    {
      german: "in der Schule",
      translated: "participă la școală",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:2|ru": [
    {
      german: "In Deutschland",
      translated: "В Германии",
      tone: 'semantic',
    },
    {
      german: "können Eltern",
      translated: "родители могут",
      tone: 'semantic',
    },
    {
      german: "bis zum 14. Lebensjahr",
      translated: "до достижения ребёнком 14 лет",
      tone: 'semantic',
    },
    {
      german: "entscheiden",
      translated: "решать",
      tone: 'semantic',
    },
    {
      german: "ob es",
      translated: "будет ли он",
      tone: 'semantic',
    },
    {
      german: "in der Schule",
      translated: "посещать в школе",
      tone: 'semantic',
    },
    {
      german: "am …",
      translated: "…",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:2|sq": [
    {
      german: "In Deutschland",
      translated: "Në Gjermani",
      tone: 'semantic',
    },
    {
      german: "können Eltern",
      translated: "prindërit mund",
      tone: 'semantic',
    },
    {
      german: "bis zum 14. Lebensjahr",
      translated: "deri në moshën 14 vjeç",
      tone: 'semantic',
    },
    {
      german: "ihres Kindes",
      translated: "të fëmijës",
      tone: 'semantic',
    },
    {
      german: "entscheiden",
      translated: "të vendosin",
      tone: 'semantic',
    },
    {
      german: "ob es",
      translated: "nëse fëmija",
      tone: 'semantic',
    },
    {
      german: "in der Schule",
      translated: "në shkollë",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:2|sr": [
    {
      german: "In Deutschland",
      translated: "U Nemačkoj",
      tone: 'semantic',
    },
    {
      german: "können Eltern",
      translated: "roditelji",
      tone: 'semantic',
    },
    {
      german: "bis zum 14. Lebensjahr",
      translated: "do 14. godine",
      tone: 'semantic',
    },
    {
      german: "ihres Kindes",
      translated: "deteta",
      tone: 'semantic',
    },
    {
      german: "entscheiden",
      translated: "mogu odlučiti",
      tone: 'semantic',
    },
    {
      german: "ob es",
      translated: "da li će dete",
      tone: 'semantic',
    },
    {
      german: "in der Schule",
      translated: "u školi",
      tone: 'semantic',
    },
    {
      german: "am …",
      translated: "na nastavi",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:2|tr": [
    {
      german: "In Deutschland",
      translated: "Almanya'da",
      tone: 'semantic',
    },
    {
      german: "können Eltern",
      translated: "anne ve babalar",
      tone: 'semantic',
    },
    {
      german: "bis zum 14. Lebensjahr",
      translated: "14 yaşına gelene kadar",
      tone: 'semantic',
    },
    {
      german: "ihres Kindes",
      translated: "çocukları",
      tone: 'semantic',
    },
    {
      german: "entscheiden",
      translated: "karar verebilir",
      tone: 'semantic',
    },
    {
      german: "ob es",
      translated: "katılıp katılmayacağına",
      tone: 'semantic',
    },
    {
      german: "in der Schule",
      translated: "okulda",
      tone: 'semantic',
    },
    {
      german: "am …",
      translated: "hangi derse",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:2|uk": [
    {
      german: "In Deutschland",
      translated: "У Німеччині",
      tone: 'semantic',
    },
    {
      german: "können Eltern",
      translated: "батьки",
      tone: 'semantic',
    },
    {
      german: "bis zum 14. Lebensjahr",
      translated: "до 14-річчя",
      tone: 'semantic',
    },
    {
      german: "ihres Kindes",
      translated: "своєї дитини",
      tone: 'semantic',
    },
    {
      german: "entscheiden",
      translated: "можуть вирішувати",
      tone: 'semantic',
    },
    {
      german: "ob es",
      translated: "чи братиме вона",
      tone: 'semantic',
    },
    {
      german: "in der Schule",
      translated: "в школі",
      tone: 'semantic',
    },
    {
      german: "am …",
      translated: "у …",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:2|vi": [
    {
      german: "In Deutschland",
      translated: "Ở Đức",
      tone: 'semantic',
    },
    {
      german: "können Eltern",
      translated: "cha mẹ có thể",
      tone: 'semantic',
    },
    {
      german: "bis zum 14. Lebensjahr",
      translated: "cho đến khi trẻ 14 tuổi",
      tone: 'semantic',
    },
    {
      german: "entscheiden",
      translated: "quyết định",
      tone: 'semantic',
    },
    {
      german: "ob es",
      translated: "trẻ có",
      tone: 'semantic',
    },
    {
      german: "in der Schule",
      translated: "ở trường",
      tone: 'semantic',
    },
    {
      german: "am …",
      translated: "giờ học",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:300|ar": [
    {
      german: "Aus welchem Land kamen",
      translated: "من أي دولة",
      tone: 'semantic',
    },
    {
      german: "die ersten Gastarbeiterinnen und Gastarbeiter",
      translated: "أول العمال الضيوف",
      tone: 'semantic',
    },
    {
      german: "in die Bundesrepublik Deutschland",
      translated: "إلى جمهورية ألمانيا الاتحادية",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:300|bg": [
    {
      german: "Aus welchem Land kamen",
      translated: "От коя държава",
      tone: 'semantic',
    },
    {
      german: "die ersten Gastarbeiterinnen und Gastarbeiter",
      translated: "Gastarbeiter",
      tone: 'semantic',
    },
    {
      german: "in die Bundesrepublik Deutschland",
      translated: "във Федерална република Германия",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:300|bs": [
    {
      german: "Aus welchem Land kamen",
      translated: "Iz koje su države došli",
      tone: 'semantic',
    },
    {
      german: "die ersten Gastarbeiterinnen und Gastarbeiter",
      translated: "prvi Gastarbeiter",
      tone: 'semantic',
    },
    {
      german: "in die Bundesrepublik Deutschland",
      translated: "u Saveznu Republiku Njemačku",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:300|el": [
    {
      german: "Aus welchem Land kamen",
      translated: "Από ποια χώρα ήρθαν οι πρώτοι",
      tone: 'semantic',
    },
    {
      german: "die ersten Gastarbeiterinnen und Gastarbeiter",
      translated: "Gastarbeiter",
      tone: 'semantic',
    },
    {
      german: "in die Bundesrepublik Deutschland",
      translated: "στην Ομοσπονδιακή Δημοκρατία της Γερμανίας",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:300|en": [
    {
      german: "Aus welchem Land kamen",
      translated: "From which country",
      tone: 'semantic',
    },
    {
      german: "die ersten Gastarbeiterinnen und Gastarbeiter",
      translated: "the first guest workers",
      tone: 'semantic',
    },
    {
      german: "in die Bundesrepublik Deutschland",
      translated: "to the Federal Republic of Germany",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:300|es": [
    {
      german: "Aus welchem Land kamen",
      translated: "¿De qué país procedían",
      tone: 'semantic',
    },
    {
      german: "die ersten Gastarbeiterinnen und Gastarbeiter",
      translated: "los primeros trabajadores invitados",
      tone: 'semantic',
    },
    {
      german: "in die Bundesrepublik Deutschland",
      translated: "a la República Federal de Alemania",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:300|fa": [
    {
      german: "Aus welchem Land kamen",
      translated: "نخستین کارگران مهمان",
      tone: 'semantic',
    },
    {
      german: "die ersten Gastarbeiterinnen und Gastarbeiter",
      translated: "به جمهوری فدرال آلمان",
      tone: 'semantic',
    },
    {
      german: "in die Bundesrepublik Deutschland",
      translated: "از کدام کشور آمدند",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:300|fr": [
    {
      german: "Aus welchem Land kamen",
      translated: "De quel pays venaient",
      tone: 'semantic',
    },
    {
      german: "die ersten Gastarbeiterinnen und Gastarbeiter",
      translated: "les premiers travailleurs invités (Gastarbeiter)",
      tone: 'semantic',
    },
    {
      german: "in die Bundesrepublik Deutschland",
      translated: "en République fédérale d’Allemagne",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:300|hr": [
    {
      german: "Aus welchem Land kamen",
      translated: "Iz koje su države došli",
      tone: 'semantic',
    },
    {
      german: "die ersten Gastarbeiterinnen und Gastarbeiter",
      translated: "prvi Gastarbeiter",
      tone: 'semantic',
    },
    {
      german: "in die Bundesrepublik Deutschland",
      translated: "u Saveznu Republiku Njemačku",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:300|it": [
    {
      german: "Aus welchem Land kamen",
      translated: "Da quale Paese provenivano",
      tone: 'semantic',
    },
    {
      german: "die ersten Gastarbeiterinnen und Gastarbeiter",
      translated: "i primi Gastarbeiter",
      tone: 'semantic',
    },
    {
      german: "in die Bundesrepublik Deutschland",
      translated: "nella Repubblica Federale di Germania",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:300|kmr": [
    {
      german: "Aus welchem Land kamen",
      translated: "ji kîjan welatê hatin",
      tone: 'semantic',
    },
    {
      german: "die ersten Gastarbeiterinnen und Gastarbeiter",
      translated: "Yekem Gastarbeiter",
      tone: 'semantic',
    },
    {
      german: "in die Bundesrepublik Deutschland",
      translated: "Komara Federal",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:300|pl": [
    {
      german: "Aus welchem Land kamen",
      translated: "Z którego państwa",
      tone: 'semantic',
    },
    {
      german: "die ersten Gastarbeiterinnen und Gastarbeiter",
      translated: "Gastarbeiter",
      tone: 'semantic',
    },
    {
      german: "in die Bundesrepublik Deutschland",
      translated: "do Republiki Federalnej Niemiec",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:300|prs": [
    {
      german: "Aus welchem Land kamen",
      translated: "از کدام کشور آمدند؟",
      tone: 'semantic',
    },
    {
      german: "die ersten Gastarbeiterinnen und Gastarbeiter",
      translated: "نخستین کارگران مهمان",
      tone: 'semantic',
    },
    {
      german: "in die Bundesrepublik Deutschland",
      translated: "به جمهوری فدرال آلمان",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:300|ro": [
    {
      german: "Aus welchem Land kamen",
      translated: "Din ce țară",
      tone: 'semantic',
    },
    {
      german: "die ersten Gastarbeiterinnen und Gastarbeiter",
      translated: "primii Gastarbeiter",
      tone: 'semantic',
    },
    {
      german: "in die Bundesrepublik Deutschland",
      translated: "în Republica Federală Germania",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:300|ru": [
    {
      german: "Aus welchem Land kamen",
      translated: "Из какой страны прибыли",
      tone: 'semantic',
    },
    {
      german: "die ersten Gastarbeiterinnen und Gastarbeiter",
      translated: "первые гастарбайтеры",
      tone: 'semantic',
    },
    {
      german: "in die Bundesrepublik Deutschland",
      translated: "в ФРГ",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:300|sq": [
    {
      german: "Aus welchem Land kamen",
      translated: "Nga cili shtet erdhën",
      tone: 'semantic',
    },
    {
      german: "die ersten Gastarbeiterinnen und Gastarbeiter",
      translated: "Gastarbeiter-ët e parë",
      tone: 'semantic',
    },
    {
      german: "in die Bundesrepublik Deutschland",
      translated: "në Republikën Federale të Gjermanisë",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:300|sr": [
    {
      german: "Aus welchem Land kamen",
      translated: "Iz koje su države došli",
      tone: 'semantic',
    },
    {
      german: "die ersten Gastarbeiterinnen und Gastarbeiter",
      translated: "prvi Gastarbeiter",
      tone: 'semantic',
    },
    {
      german: "in die Bundesrepublik Deutschland",
      translated: "u Saveznu Republiku Nemačku",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:300|tr": [
    {
      german: "Aus welchem Land kamen",
      translated: "hangi ülkedendi",
      tone: 'semantic',
    },
    {
      german: "die ersten Gastarbeiterinnen und Gastarbeiter",
      translated: "ilk misafir işçiler",
      tone: 'semantic',
    },
    {
      german: "in die Bundesrepublik Deutschland",
      translated: "Almanya Federal Cumhuriyeti'ne gelen",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:300|uk": [
    {
      german: "Aus welchem Land kamen",
      translated: "З якої країни",
      tone: 'semantic',
    },
    {
      german: "die ersten Gastarbeiterinnen und Gastarbeiter",
      translated: "перші гастарбайтери",
      tone: 'semantic',
    },
    {
      german: "in die Bundesrepublik Deutschland",
      translated: "до Федеративної Республіки Німеччина",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:300|vi": [
    {
      german: "Aus welchem Land kamen",
      translated: "từ quốc gia nào",
      tone: 'semantic',
    },
    {
      german: "die ersten Gastarbeiterinnen und Gastarbeiter",
      translated: "Những Gastarbeiter đầu tiên",
      tone: 'semantic',
    },
    {
      german: "in die Bundesrepublik Deutschland",
      translated: "đến Cộng hòa Liên bang Đức",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:30|ar": [
    {
      german: "Was ist",
      translated: "أي مما يلي",
      tone: 'semantic',
    },
    {
      german: "kein Merkmal",
      translated: "ليس من سمات",
      tone: 'semantic',
    },
    {
      german: "unserer Demokratie",
      translated: "ديمقراطيتنا؟",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:30|bg": [
    {
      german: "Was ist",
      translated: "Кое",
      tone: 'semantic',
    },
    {
      german: "kein Merkmal",
      translated: "НЕ е",
      tone: 'semantic',
    },
    {
      german: "unserer Demokratie",
      translated: "нашата демокрация",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:30|bs": [
    {
      german: "Was ist",
      translated: "Što",
      tone: 'semantic',
    },
    {
      german: "kein Merkmal",
      translated: "od navedenoga NIJE obilježje",
      tone: 'semantic',
    },
    {
      german: "unserer Demokratie",
      translated: "naše demokracije",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:30|el": [
    {
      german: "Was ist",
      translated: "Ποιο από τα παρακάτω",
      tone: 'semantic',
    },
    {
      german: "kein Merkmal",
      translated: "ΔΕΝ είναι χαρακτηριστικό",
      tone: 'semantic',
    },
    {
      german: "unserer Demokratie",
      translated: "δημοκρατίας μας",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:30|en": [
    {
      german: "Was ist",
      translated: "What is",
      tone: 'semantic',
    },
    {
      german: "kein Merkmal",
      translated: "NOT a characteristic",
      tone: 'semantic',
    },
    {
      german: "unserer Demokratie",
      translated: "our democracy",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:30|es": [
    {
      german: "Was ist",
      translated: "¿Cuál",
      tone: 'semantic',
    },
    {
      german: "kein Merkmal",
      translated: "NO es una característica",
      tone: 'semantic',
    },
    {
      german: "unserer Demokratie",
      translated: "nuestra democracia",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:30|fa": [
    {
      german: "Was ist",
      translated: "کدام",
      tone: 'semantic',
    },
    {
      german: "kein Merkmal",
      translated: "نیست",
      tone: 'semantic',
    },
    {
      german: "unserer Demokratie",
      translated: "؟",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:30|fr": [
    {
      german: "Was ist",
      translated: "Lequel des",
      tone: 'semantic',
    },
    {
      german: "kein Merkmal",
      translated: "n’est pas une",
      tone: 'semantic',
    },
    {
      german: "unserer Demokratie",
      translated: "notre démocratie",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:30|hr": [
    {
      german: "Was ist",
      translated: "Što",
      tone: 'semantic',
    },
    {
      german: "kein Merkmal",
      translated: "od navedenoga NIJE obilježje",
      tone: 'semantic',
    },
    {
      german: "unserer Demokratie",
      translated: "naše demokracije",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:30|it": [
    {
      german: "Was ist",
      translated: "Quale dei",
      tone: 'semantic',
    },
    {
      german: "kein Merkmal",
      translated: "NON",
      tone: 'semantic',
    },
    {
      german: "unserer Demokratie",
      translated: "della nostra democrazia",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:30|kmr": [
    {
      german: "Was ist",
      translated: "Kîjan ji",
      tone: 'semantic',
    },
    {
      german: "kein Merkmal",
      translated: "van ne taybetmendiya",
      tone: 'semantic',
    },
    {
      german: "unserer Demokratie",
      translated: "demokrasiya me ye",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:30|pl": [
    {
      german: "Was ist",
      translated: "Które z poniższych",
      tone: 'semantic',
    },
    {
      german: "kein Merkmal",
      translated: "NIE jest cechą",
      tone: 'semantic',
    },
    {
      german: "unserer Demokratie",
      translated: "naszej demokracji",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:30|prs": [
    {
      german: "Was ist",
      translated: "کدام مورد",
      tone: 'semantic',
    },
    {
      german: "kein Merkmal",
      translated: "نیست",
      tone: 'semantic',
    },
    {
      german: "unserer Demokratie",
      translated: "دموکراسی ما",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:30|ro": [
    {
      german: "Was ist",
      translated: "Care",
      tone: 'semantic',
    },
    {
      german: "kein Merkmal",
      translated: "NU este o caracteristică",
      tone: 'semantic',
    },
    {
      german: "unserer Demokratie",
      translated: "democrației noastre?",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:30|ru": [
    {
      german: "Was ist",
      translated: "Что",
      tone: 'semantic',
    },
    {
      german: "kein Merkmal",
      translated: "не является признаком",
      tone: 'semantic',
    },
    {
      german: "unserer Demokratie",
      translated: "нашей демократии",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:30|sq": [
    {
      german: "Was ist",
      translated: "Cila nga",
      tone: 'semantic',
    },
    {
      german: "kein Merkmal",
      translated: "NUK është karakteristikë",
      tone: 'semantic',
    },
    {
      german: "unserer Demokratie",
      translated: "demokracisë sonë",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:30|sr": [
    {
      german: "Was ist",
      translated: "Šta od navedenoga",
      tone: 'semantic',
    },
    {
      german: "kein Merkmal",
      translated: "NIJE obilježje naše demokracije",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:30|tr": [
    {
      german: "Was ist",
      translated: "Aşağıdakilerden hangisi",
      tone: 'semantic',
    },
    {
      german: "kein Merkmal",
      translated: "bir özelliği değildir",
      tone: 'semantic',
    },
    {
      german: "unserer Demokratie",
      translated: "demokrasimizin",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:30|uk": [
    {
      german: "Was ist",
      translated: "Що з наведеного",
      tone: 'semantic',
    },
    {
      german: "kein Merkmal",
      translated: "не є ознакою",
      tone: 'semantic',
    },
    {
      german: "unserer Demokratie",
      translated: "нашої демократії",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:30|vi": [
    {
      german: "Was ist",
      translated: "Điều nào sau đây",
      tone: 'semantic',
    },
    {
      german: "kein Merkmal",
      translated: "KHÔNG phải là đặc điểm",
      tone: 'semantic',
    },
    {
      german: "unserer Demokratie",
      translated: "nền dân chủ của chúng ta",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:31|ar": [
    {
      german: "Zusammenarbeit von Parteien",
      translated: "تعاون عدة أحزاب",
      tone: 'semantic',
    },
    {
      german: "Bildung einer Regierung",
      translated: "لتشكيل حكومة",
      tone: 'semantic',
    },
    {
      german: "nennt man in Deutschland",
      translated: "؟",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:31|bg": [
    {
      german: "Zusammenarbeit von Parteien",
      translated: "сътрудничеството между няколко партии",
      tone: 'semantic',
    },
    {
      german: "Bildung einer Regierung",
      translated: "съставяне на правителство",
      tone: 'semantic',
    },
    {
      german: "nennt man in Deutschland",
      translated: "Как се нарича",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:31|bs": [
    {
      german: "Zusammenarbeit von Parteien",
      translated: "saradnja više stranaka",
      tone: 'semantic',
    },
    {
      german: "Bildung einer Regierung",
      translated: "formiranja vlade",
      tone: 'semantic',
    },
    {
      german: "nennt man in Deutschland",
      translated: "Kako se u Njemačkoj naziva",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:31|el": [
    {
      german: "Zusammenarbeit von Parteien",
      translated: "συνεργασία πολλών κομμάτων",
      tone: 'semantic',
    },
    {
      german: "Bildung einer Regierung",
      translated: "σχηματισμό κυβέρνησης",
      tone: 'semantic',
    },
    {
      german: "nennt man in Deutschland",
      translated: "Πώς ονομάζεται στη Γερμανία",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:31|en": [
    {
      german: "Zusammenarbeit von Parteien",
      translated: "The cooperation of parties",
      tone: 'semantic',
    },
    {
      german: "Bildung einer Regierung",
      translated: "to form a government",
      tone: 'semantic',
    },
    {
      german: "nennt man in Deutschland",
      translated: "is called in Germany",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:31|es": [
    {
      german: "Zusammenarbeit von Parteien",
      translated: "la cooperación entre partidos",
      tone: 'semantic',
    },
    {
      german: "Bildung einer Regierung",
      translated: "para formar un gobierno",
      tone: 'semantic',
    },
    {
      german: "nennt man in Deutschland",
      translated: "se llama",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:31|fa": [
    {
      german: "Zusammenarbeit von Parteien",
      translated: " همکاری چند حزب ",
      tone: 'semantic',
    },
    {
      german: "Bildung einer Regierung",
      translated: " تشکیل دولت ",
      tone: 'semantic',
    },
    {
      german: "nennt man in Deutschland",
      translated: "چه نام دارد؟",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:31|fr": [
    {
      german: "Zusammenarbeit von Parteien",
      translated: "la coopération de plusieurs partis",
      tone: 'semantic',
    },
    {
      german: "Bildung einer Regierung",
      translated: "pour former un gouvernement",
      tone: 'semantic',
    },
    {
      german: "nennt man in Deutschland",
      translated: "appelle-t-on en Allemagne",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:31|hr": [
    {
      german: "Zusammenarbeit von Parteien",
      translated: "suradnja više stranaka",
      tone: 'semantic',
    },
    {
      german: "Bildung einer Regierung",
      translated: "formiranja vlade",
      tone: 'semantic',
    },
    {
      german: "nennt man in Deutschland",
      translated: "Kako se u Njemačkoj naziva",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:31|it": [
    {
      german: "Zusammenarbeit von Parteien",
      translated: "collaborazione di più partiti",
      tone: 'semantic',
    },
    {
      german: "Bildung einer Regierung",
      translated: "formare un governo",
      tone: 'semantic',
    },
    {
      german: "nennt man in Deutschland",
      translated: "si chiama in Germania",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:31|kmr": [
    {
      german: "Zusammenarbeit von Parteien",
      translated: "hevkariya çend partiyan",
      tone: 'semantic',
    },
    {
      german: "Bildung einer Regierung",
      translated: "avakirina hukûmetê",
      tone: 'semantic',
    },
    {
      german: "nennt man in Deutschland",
      translated: "çi tê gotin",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:31|pl": [
    {
      german: "Zusammenarbeit von Parteien",
      translated: "współpraca kilku partii",
      tone: 'semantic',
    },
    {
      german: "Bildung einer Regierung",
      translated: "w celu utworzenia rządu",
      tone: 'semantic',
    },
    {
      german: "nennt man in Deutschland",
      translated: "nazywa się w Niemczech",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:31|prs": [
    {
      german: "Zusammenarbeit von Parteien",
      translated: "همکاری چند حزب",
      tone: 'semantic',
    },
    {
      german: "Bildung einer Regierung",
      translated: "تشکیل دولت",
      tone: 'semantic',
    },
    {
      german: "nennt man in Deutschland",
      translated: "چه نام دارد؟",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:31|ro": [
    {
      german: "Zusammenarbeit von Parteien",
      translated: "colaborarea mai multor partide",
      tone: 'semantic',
    },
    {
      german: "Bildung einer Regierung",
      translated: "formarea guvernului",
      tone: 'semantic',
    },
    {
      german: "nennt man in Deutschland",
      translated: "Cum se numește în Germania",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:31|ru": [
    {
      german: "Zusammenarbeit von Parteien",
      translated: "Сотрудничество партий",
      tone: 'semantic',
    },
    {
      german: "Bildung einer Regierung",
      translated: "формирования правительства",
      tone: 'semantic',
    },
    {
      german: "nennt man in Deutschland",
      translated: "называют в Германии …",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:31|sq": [
    {
      german: "Zusammenarbeit von Parteien",
      translated: "bashkëpunimi i disa partive",
      tone: 'semantic',
    },
    {
      german: "Bildung einer Regierung",
      translated: "të formuar qeverinë",
      tone: 'semantic',
    },
    {
      german: "nennt man in Deutschland",
      translated: "Si quhet në Gjermani",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:31|sr": [
    {
      german: "Zusammenarbeit von Parteien",
      translated: "saradnja više stranaka",
      tone: 'semantic',
    },
    {
      german: "Bildung einer Regierung",
      translated: "formiranja vlade",
      tone: 'semantic',
    },
    {
      german: "nennt man in Deutschland",
      translated: "Kako se u Nemačkoj naziva",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:31|tr": [
    {
      german: "Zusammenarbeit von Parteien",
      translated: "birlikte çalışmasına",
      tone: 'semantic',
    },
    {
      german: "Bildung einer Regierung",
      translated: "hükümet kurmak için",
      tone: 'semantic',
    },
    {
      german: "nennt man in Deutschland",
      translated: "ne ad verilir",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:31|uk": [
    {
      german: "Zusammenarbeit von Parteien",
      translated: "об’єднання кількох партій",
      tone: 'semantic',
    },
    {
      german: "Bildung einer Regierung",
      translated: "для формування уряду",
      tone: 'semantic',
    },
    {
      german: "nennt man in Deutschland",
      translated: "Як у Німеччині називається",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:31|vi": [
    {
      german: "Zusammenarbeit von Parteien",
      translated: "sự hợp tác của nhiều đảng",
      tone: 'semantic',
    },
    {
      german: "Bildung einer Regierung",
      translated: "để thành lập chính phủ",
      tone: 'semantic',
    },
    {
      german: "nennt man in Deutschland",
      translated: "được gọi là gì?",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:32|ar": [
    {
      german: "Was ist",
      translated: "أي",
      tone: 'semantic',
    },
    {
      german: "keine",
      translated: "ليس",
      tone: 'semantic',
    },
    {
      german: "staatliche Gewalt",
      translated: "سلطة من سلطات الدولة",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "في ألمانيا",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:32|bg": [
    {
      german: "Was ist",
      translated: "Кое",
      tone: 'semantic',
    },
    {
      german: "keine",
      translated: "НЕ",
      tone: 'semantic',
    },
    {
      german: "staatliche Gewalt",
      translated: "е една от държавните власти",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "в Германия",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:32|bs": [
    {
      german: "Was ist",
      translated: "Što",
      tone: 'semantic',
    },
    {
      german: "keine",
      translated: "od navedenoga",
      tone: 'semantic',
    },
    {
      german: "staatliche Gewalt",
      translated: "NIJE jedna od državnih vlasti",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "u Njemačkoj",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:32|el": [
    {
      german: "Was ist",
      translated: "Ποιο από τα",
      tone: 'semantic',
    },
    {
      german: "keine",
      translated: "ΔΕΝ",
      tone: 'semantic',
    },
    {
      german: "staatliche Gewalt",
      translated: "κρατικές εξουσίες",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "στη Γερμανία",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:32|en": [
    {
      german: "Was ist",
      translated: "What is",
      tone: 'semantic',
    },
    {
      german: "keine",
      translated: "NOT",
      tone: 'semantic',
    },
    {
      german: "staatliche Gewalt",
      translated: "state power",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "in Germany",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:32|es": [
    {
      german: "Was ist",
      translated: "¿Cuál de los siguientes",
      tone: 'semantic',
    },
    {
      german: "keine",
      translated: "NO",
      tone: 'semantic',
    },
    {
      german: "staatliche Gewalt",
      translated: "poder del Estado",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "en Alemania",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:32|fa": [
    {
      german: "Was ist",
      translated: "کدام مورد",
      tone: 'semantic',
    },
    {
      german: "keine",
      translated: "یکی از",
      tone: 'semantic',
    },
    {
      german: "staatliche Gewalt",
      translated: "قوای حکومتی",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "در آلمان نیست؟",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:32|fr": [
    {
      german: "Was ist",
      translated: "Lequel des",
      tone: 'semantic',
    },
    {
      german: "keine",
      translated: "n’est pas un",
      tone: 'semantic',
    },
    {
      german: "staatliche Gewalt",
      translated: "pouvoir de l’État",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "en Allemagne ?",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:32|hr": [
    {
      german: "Was ist",
      translated: "Što",
      tone: 'semantic',
    },
    {
      german: "keine",
      translated: "od navedenoga",
      tone: 'semantic',
    },
    {
      german: "staatliche Gewalt",
      translated: "NIJE jedna od državnih vlasti",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "u Njemačkoj",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:32|it": [
    {
      german: "Was ist",
      translated: "Quale dei seguenti",
      tone: 'semantic',
    },
    {
      german: "keine",
      translated: "NON",
      tone: 'semantic',
    },
    {
      german: "staatliche Gewalt",
      translated: "poteri dello Stato",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "in Germania",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:32|kmr": [
    {
      german: "Was ist",
      translated: "Kîjan ji van",
      tone: 'semantic',
    },
    {
      german: "keine",
      translated: "ne",
      tone: 'semantic',
    },
    {
      german: "staatliche Gewalt",
      translated: "hêzeke dewletê",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "li Almanyayê ye",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:32|pl": [
    {
      german: "Was ist",
      translated: "Które z poniższych",
      tone: 'semantic',
    },
    {
      german: "keine",
      translated: "NIE jest",
      tone: 'semantic',
    },
    {
      german: "staatliche Gewalt",
      translated: "jedną z władz państwowych",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "w Niemczech",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:32|prs": [
    {
      german: "Was ist",
      translated: "کدام مورد",
      tone: 'semantic',
    },
    {
      german: "keine",
      translated: "نیست",
      tone: 'semantic',
    },
    {
      german: "staatliche Gewalt",
      translated: "قوای حکومتی",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "در آلمان",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:32|ro": [
    {
      german: "Was ist",
      translated: "Care",
      tone: 'semantic',
    },
    {
      german: "keine",
      translated: "NU",
      tone: 'semantic',
    },
    {
      german: "staatliche Gewalt",
      translated: "puterile statului",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "în Germania",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:32|ru": [
    {
      german: "Was ist",
      translated: "Что",
      tone: 'semantic',
    },
    {
      german: "keine",
      translated: "не является",
      tone: 'semantic',
    },
    {
      german: "staatliche Gewalt",
      translated: "ветвью государственной власти",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "в Германии",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:32|sq": [
    {
      german: "Was ist",
      translated: "Cila nga këto",
      tone: 'semantic',
    },
    {
      german: "keine",
      translated: "NUK",
      tone: 'semantic',
    },
    {
      german: "staatliche Gewalt",
      translated: "pushtetet shtetërore",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "në Gjermani",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:32|sr": [
    {
      german: "Was ist",
      translated: "Šta",
      tone: 'semantic',
    },
    {
      german: "keine",
      translated: "od navedenoga",
      tone: 'semantic',
    },
    {
      german: "staatliche Gewalt",
      translated: "NIJE jedna od državnih vlasti",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "u Nemačkoj",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:32|tr": [
    {
      german: "Was ist",
      translated: "Aşağıdakilerden hangisi",
      tone: 'semantic',
    },
    {
      german: "keine",
      translated: "değildir",
      tone: 'semantic',
    },
    {
      german: "staatliche Gewalt",
      translated: "devlet erklerinden biri",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "Almanya'daki",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:32|uk": [
    {
      german: "Was ist",
      translated: "Що з",
      tone: 'semantic',
    },
    {
      german: "keine",
      translated: "не",
      tone: 'semantic',
    },
    {
      german: "staatliche Gewalt",
      translated: "наведеного",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "в Німеччині",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:32|vi": [
    {
      german: "Was ist",
      translated: "Điều nào sau đây",
      tone: 'semantic',
    },
    {
      german: "keine",
      translated: "KHÔNG phải là",
      tone: 'semantic',
    },
    {
      german: "staatliche Gewalt",
      translated: "một nhánh quyền lực nhà nước",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "ở Đức",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:33|ar": [
    {
      german: "Welche Aussage",
      translated: "أي عبارة",
      tone: 'semantic',
    },
    {
      german: "ist richtig",
      translated: "صحيحة",
      tone: 'semantic',
    },
    {
      german: "In Deutschland",
      translated: "في ألمانيا",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:33|bg": [
    {
      german: "Welche Aussage",
      translated: "Кое твърдение",
      tone: 'semantic',
    },
    {
      german: "ist richtig",
      translated: "е вярно",
      tone: 'semantic',
    },
    {
      german: "In Deutschland",
      translated: "В Германия",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:33|bs": [
    {
      german: "Welche Aussage",
      translated: "Koja je",
      tone: 'semantic',
    },
    {
      german: "ist richtig",
      translated: "točna",
      tone: 'semantic',
    },
    {
      german: "In Deutschland",
      translated: "U Njemačkoj",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:33|el": [
    {
      german: "Welche Aussage",
      translated: "Ποια δήλωση",
      tone: 'semantic',
    },
    {
      german: "ist richtig",
      translated: "είναι σωστή",
      tone: 'semantic',
    },
    {
      german: "In Deutschland",
      translated: "Στη Γερμανία",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:33|en": [
    {
      german: "Welche Aussage",
      translated: "Which statement",
      tone: 'semantic',
    },
    {
      german: "ist richtig",
      translated: "is correct",
      tone: 'semantic',
    },
    {
      german: "In Deutschland",
      translated: "In Germany",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:33|es": [
    {
      german: "Welche Aussage",
      translated: "Qué afirmación",
      tone: 'semantic',
    },
    {
      german: "ist richtig",
      translated: "es correcta",
      tone: 'semantic',
    },
    {
      german: "In Deutschland",
      translated: "En Alemania",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:33|fa": [
    {
      german: "Welche Aussage",
      translated: "کدام عبارت",
      tone: 'semantic',
    },
    {
      german: "ist richtig",
      translated: "درست است",
      tone: 'semantic',
    },
    {
      german: "In Deutschland",
      translated: "در آلمان",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:33|fr": [
    {
      german: "Welche Aussage",
      translated: "Quelle affirmation",
      tone: 'semantic',
    },
    {
      german: "ist richtig",
      translated: "correcte",
      tone: 'semantic',
    },
    {
      german: "In Deutschland",
      translated: "En Allemagne",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:33|hr": [
    {
      german: "Welche Aussage",
      translated: "Koja je tvrdnja",
      tone: 'semantic',
    },
    {
      german: "ist richtig",
      translated: "točna",
      tone: 'semantic',
    },
    {
      german: "In Deutschland",
      translated: "U Njemačkoj",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:33|it": [
    {
      german: "Welche Aussage",
      translated: "Quale affermazione",
      tone: 'semantic',
    },
    {
      german: "ist richtig",
      translated: "è corretta",
      tone: 'semantic',
    },
    {
      german: "In Deutschland",
      translated: "In Germania",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:33|kmr": [
    {
      german: "Welche Aussage",
      translated: "Kîjan",
      tone: 'semantic',
    },
    {
      german: "ist richtig",
      translated: "gotin rast e?",
      tone: 'semantic',
    },
    {
      german: "In Deutschland",
      translated: "Li Almanyayê",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:33|pl": [
    {
      german: "Welche Aussage",
      translated: "Które stwierdzenie",
      tone: 'semantic',
    },
    {
      german: "ist richtig",
      translated: "jest prawidłowe",
      tone: 'semantic',
    },
    {
      german: "In Deutschland",
      translated: "W Niemczech",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:33|prs": [
    {
      german: "Welche Aussage",
      translated: "کدام عبارت",
      tone: 'semantic',
    },
    {
      german: "ist richtig",
      translated: "درست است",
      tone: 'semantic',
    },
    {
      german: "In Deutschland",
      translated: "در آلمان",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:33|ro": [
    {
      german: "Welche Aussage",
      translated: "Care afirmație",
      tone: 'semantic',
    },
    {
      german: "ist richtig",
      translated: "este corectă",
      tone: 'semantic',
    },
    {
      german: "In Deutschland",
      translated: "În Germania …",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:33|ru": [
    {
      german: "Welche Aussage",
      translated: "Какое утверждение",
      tone: 'semantic',
    },
    {
      german: "ist richtig",
      translated: "верно",
      tone: 'semantic',
    },
    {
      german: "In Deutschland",
      translated: "В Германии",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:33|sq": [
    {
      german: "Welche Aussage",
      translated: "Cili pohim",
      tone: 'semantic',
    },
    {
      german: "ist richtig",
      translated: " është i saktë?",
      tone: 'semantic',
    },
    {
      german: "In Deutschland",
      translated: "Në Gjermani",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:33|sr": [
    {
      german: "Welche Aussage",
      translated: "Koja je tvrdnja",
      tone: 'semantic',
    },
    {
      german: "ist richtig",
      translated: "točna",
      tone: 'semantic',
    },
    {
      german: "In Deutschland",
      translated: "U Nemačkoj",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:33|tr": [
    {
      german: "Welche Aussage",
      translated: "Hangi ifade",
      tone: 'semantic',
    },
    {
      german: "ist richtig",
      translated: "doğrudur",
      tone: 'semantic',
    },
    {
      german: "In Deutschland",
      translated: "Almanya'da",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:33|uk": [
    {
      german: "Welche Aussage",
      translated: "Яке твердження",
      tone: 'semantic',
    },
    {
      german: "ist richtig",
      translated: "правильне",
      tone: 'semantic',
    },
    {
      german: "In Deutschland",
      translated: "У Німеччині",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:33|vi": [
    {
      german: "Welche Aussage",
      translated: "Phát biểu nào",
      tone: 'semantic',
    },
    {
      german: "ist richtig",
      translated: "đúng",
      tone: 'semantic',
    },
    {
      german: "In Deutschland",
      translated: "Ở Đức",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:34|ar": [
    {
      german: "Was ist",
      translated: "ما الذي",
      tone: 'semantic',
    },
    {
      german: "Deutschland",
      translated: "ألمانيا",
      tone: 'semantic',
    },
    {
      german: "nicht",
      translated: "ليست",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:34|bg": [
    {
      german: "Was ist",
      translated: "Какво",
      tone: 'semantic',
    },
    {
      german: "Deutschland",
      translated: "Германия",
      tone: 'semantic',
    },
    {
      german: "nicht",
      translated: "НЕ",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:34|bs": [
    {
      german: "Was ist",
      translated: "Što",
      tone: 'semantic',
    },
    {
      german: "Deutschland",
      translated: "Njemačka",
      tone: 'semantic',
    },
    {
      german: "nicht",
      translated: "NIJE",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:34|el": [
    {
      german: "Was ist",
      translated: "Τι",
      tone: 'semantic',
    },
    {
      german: "Deutschland",
      translated: "η Γερμανία",
      tone: 'semantic',
    },
    {
      german: "nicht",
      translated: "ΔΕΝ",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:34|en": [
    {
      german: "Was ist",
      translated: "What is",
      tone: 'semantic',
    },
    {
      german: "Deutschland",
      translated: "Germany",
      tone: 'semantic',
    },
    {
      german: "nicht",
      translated: "NOT",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:34|es": [
    {
      german: "Was ist",
      translated: "¿Qué",
      tone: 'semantic',
    },
    {
      german: "Deutschland",
      translated: "Alemania",
      tone: 'semantic',
    },
    {
      german: "nicht",
      translated: "NO",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:34|fa": [
    {
      german: "Was ist",
      translated: "کدام",
      tone: 'semantic',
    },
    {
      german: "Deutschland",
      translated: "آلمان",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:34|fr": [
    {
      german: "Was ist",
      translated: "Qu’est-ce que",
      tone: 'semantic',
    },
    {
      german: "Deutschland",
      translated: "l’Allemagne",
      tone: 'semantic',
    },
    {
      german: "nicht",
      translated: "n’est pas",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:34|hr": [
    {
      german: "Was ist",
      translated: "Što",
      tone: 'semantic',
    },
    {
      german: "Deutschland",
      translated: "Njemačka",
      tone: 'semantic',
    },
    {
      german: "nicht",
      translated: "NIJE",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:34|it": [
    {
      german: "Was ist",
      translated: "Che cosa",
      tone: 'semantic',
    },
    {
      german: "Deutschland",
      translated: "la Germania",
      tone: 'semantic',
    },
    {
      german: "nicht",
      translated: "NON",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:34|kmr": [
    {
      german: "Was ist",
      translated: "çi",
      tone: 'semantic',
    },
    {
      german: "Deutschland",
      translated: "Almanya",
      tone: 'semantic',
    },
    {
      german: "nicht",
      translated: "nîne",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:34|pl": [
    {
      german: "Was ist",
      translated: "Czym",
      tone: 'semantic',
    },
    {
      german: "Deutschland",
      translated: "Niemcy",
      tone: 'semantic',
    },
    {
      german: "nicht",
      translated: "NIE",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:34|prs": [
    {
      german: "Was ist",
      translated: "کدام‌یک",
      tone: 'semantic',
    },
    {
      german: "Deutschland",
      translated: "آلمان",
      tone: 'semantic',
    },
    {
      german: "nicht",
      translated: "نیست",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:34|ro": [
    {
      german: "Was ist",
      translated: "Ce",
      tone: 'semantic',
    },
    {
      german: "Deutschland",
      translated: "Germania",
      tone: 'semantic',
    },
    {
      german: "nicht",
      translated: "NU",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:34|ru": [
    {
      german: "Was ist",
      translated: "Чем",
      tone: 'semantic',
    },
    {
      german: "Deutschland",
      translated: "Германия",
      tone: 'semantic',
    },
    {
      german: "nicht",
      translated: "не является",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:34|sq": [
    {
      german: "Was ist",
      translated: "Çfarë",
      tone: 'semantic',
    },
    {
      german: "Deutschland",
      translated: "Gjermania",
      tone: 'semantic',
    },
    {
      german: "nicht",
      translated: "NUK",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:34|sr": [
    {
      german: "Was ist",
      translated: "Šta",
      tone: 'semantic',
    },
    {
      german: "Deutschland",
      translated: "Nemačka",
      tone: 'semantic',
    },
    {
      german: "nicht",
      translated: "NIJE",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:34|tr": [
    {
      german: "Was ist",
      translated: "aşağıdakilerden hangisi",
      tone: 'semantic',
    },
    {
      german: "Deutschland",
      translated: "Almanya",
      tone: 'semantic',
    },
    {
      german: "nicht",
      translated: "değildir",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:34|uk": [
    {
      german: "Was ist",
      translated: "Чим",
      tone: 'semantic',
    },
    {
      german: "Deutschland",
      translated: "Німеччина",
      tone: 'semantic',
    },
    {
      german: "nicht",
      translated: "не",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:34|vi": [
    {
      german: "Was ist",
      translated: "là gì?",
      tone: 'semantic',
    },
    {
      german: "Deutschland",
      translated: "Đức",
      tone: 'semantic',
    },
    {
      german: "nicht",
      translated: "KHÔNG phải",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:35|ar": [
    {
      german: "Womit",
      translated: "بماذا",
      tone: 'semantic',
    },
    {
      german: "finanziert",
      translated: "تموّل",
      tone: 'semantic',
    },
    {
      german: "der deutsche Staat",
      translated: "الدولة الألمانية",
      tone: 'semantic',
    },
    {
      german: "die Sozialversicherung",
      translated: "نظام التأمين الاجتماعي",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:35|bg": [
    {
      german: "Womit",
      translated: "Как",
      tone: 'semantic',
    },
    {
      german: "finanziert",
      translated: "финансира",
      tone: 'semantic',
    },
    {
      german: "der deutsche Staat",
      translated: "германската държава",
      tone: 'semantic',
    },
    {
      german: "die Sozialversicherung",
      translated: "системата за социално осигуряване",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:35|bs": [
    {
      german: "Womit",
      translated: "Kako",
      tone: 'semantic',
    },
    {
      german: "finanziert",
      translated: "financira",
      tone: 'semantic',
    },
    {
      german: "der deutsche Staat",
      translated: " država",
      tone: 'semantic',
    },
    {
      german: "die Sozialversicherung",
      translated: "sustav socijalne sigurnosti",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:35|el": [
    {
      german: "Womit",
      translated: "Πώς",
      tone: 'semantic',
    },
    {
      german: "finanziert",
      translated: "χρηματοδοτεί",
      tone: 'semantic',
    },
    {
      german: "der deutsche Staat",
      translated: "το γερμανικό κράτος",
      tone: 'semantic',
    },
    {
      german: "die Sozialversicherung",
      translated: "το σύστημα κοινωνικής ασφάλισης",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:35|en": [
    {
      german: "Womit",
      translated: "How",
      tone: 'semantic',
    },
    {
      german: "finanziert",
      translated: "does",
      tone: 'semantic',
    },
    {
      german: "der deutsche Staat",
      translated: "the German state",
      tone: 'semantic',
    },
    {
      german: "die Sozialversicherung",
      translated: "social insurance",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:35|es": [
    {
      german: "Womit",
      translated: "¿Con qué",
      tone: 'semantic',
    },
    {
      german: "finanziert",
      translated: "financia",
      tone: 'semantic',
    },
    {
      german: "der deutsche Staat",
      translated: "el Estado alemán",
      tone: 'semantic',
    },
    {
      german: "die Sozialversicherung",
      translated: "la seguridad social",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:35|fa": [
    {
      german: "Womit",
      translated: "چگونه",
      tone: 'semantic',
    },
    {
      german: "finanziert",
      translated: "تأمین مالی می‌کند",
      tone: 'semantic',
    },
    {
      german: "der deutsche Staat",
      translated: "دولت آلمان",
      tone: 'semantic',
    },
    {
      german: "die Sozialversicherung",
      translated: "نظام تأمین اجتماعی",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:35|fr": [
    {
      german: "Womit",
      translated: "Comment",
      tone: 'semantic',
    },
    {
      german: "finanziert",
      translated: "finance",
      tone: 'semantic',
    },
    {
      german: "der deutsche Staat",
      translated: "l’État allemand",
      tone: 'semantic',
    },
    {
      german: "die Sozialversicherung",
      translated: "le système de sécurité sociale",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:35|hr": [
    {
      german: "Womit",
      translated: "Kako",
      tone: 'semantic',
    },
    {
      german: "finanziert",
      translated: "financira",
      tone: 'semantic',
    },
    {
      german: "der deutsche Staat",
      translated: "država",
      tone: 'semantic',
    },
    {
      german: "die Sozialversicherung",
      translated: "sustav socijalne sigurnosti",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:35|it": [
    {
      german: "Womit",
      translated: "Come",
      tone: 'semantic',
    },
    {
      german: "finanziert",
      translated: "finanzia",
      tone: 'semantic',
    },
    {
      german: "der deutsche Staat",
      translated: "lo Stato tedesco",
      tone: 'semantic',
    },
    {
      german: "die Sozialversicherung",
      translated: "il sistema di sicurezza sociale",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:35|kmr": [
    {
      german: "Womit",
      translated: "bi çi",
      tone: 'semantic',
    },
    {
      german: "finanziert",
      translated: "fînanse",
      tone: 'semantic',
    },
    {
      german: "der deutsche Staat",
      translated: "Alman pergala bîmeya",
      tone: 'semantic',
    },
    {
      german: "die Sozialversicherung",
      translated: "civakî",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:35|pl": [
    {
      german: "Womit",
      translated: "Jak",
      tone: 'semantic',
    },
    {
      german: "finanziert",
      translated: "finansuje",
      tone: 'semantic',
    },
    {
      german: "der deutsche Staat",
      translated: "państwo niemieckie",
      tone: 'semantic',
    },
    {
      german: "die Sozialversicherung",
      translated: "system zabezpieczenia społecznego",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:35|prs": [
    {
      german: "Womit",
      translated: "چگونه",
      tone: 'semantic',
    },
    {
      german: "finanziert",
      translated: "تأمین مالی می‌کند",
      tone: 'semantic',
    },
    {
      german: "der deutsche Staat",
      translated: "دولت آلمان",
      tone: 'semantic',
    },
    {
      german: "die Sozialversicherung",
      translated: "نظام تأمین اجتماعی",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:35|ro": [
    {
      german: "Womit",
      translated: "Cum",
      tone: 'semantic',
    },
    {
      german: "finanziert",
      translated: "finanțează",
      tone: 'semantic',
    },
    {
      german: "der deutsche Staat",
      translated: "statul german",
      tone: 'semantic',
    },
    {
      german: "die Sozialversicherung",
      translated: "sistemul de securitate socială",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:35|ru": [
    {
      german: "Womit",
      translated: "За счёт чего",
      tone: 'semantic',
    },
    {
      german: "finanziert",
      translated: "финансирует",
      tone: 'semantic',
    },
    {
      german: "der deutsche Staat",
      translated: "немецкое государство",
      tone: 'semantic',
    },
    {
      german: "die Sozialversicherung",
      translated: "социальное страхование",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:35|sq": [
    {
      german: "Womit",
      translated: "Si",
      tone: 'semantic',
    },
    {
      german: "finanziert",
      translated: "financon",
      tone: 'semantic',
    },
    {
      german: "der deutsche Staat",
      translated: "shteti gjerman sistemin",
      tone: 'semantic',
    },
    {
      german: "die Sozialversicherung",
      translated: "sigurimeve shoqërore",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:35|sr": [
    {
      german: "Womit",
      translated: "Kako",
      tone: 'semantic',
    },
    {
      german: "finanziert",
      translated: "financira",
      tone: 'semantic',
    },
    {
      german: "der deutsche Staat",
      translated: "nemačka država",
      tone: 'semantic',
    },
    {
      german: "die Sozialversicherung",
      translated: "sistem socijalne bezbednosti",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:35|tr": [
    {
      german: "Womit",
      translated: "hangi",
      tone: 'semantic',
    },
    {
      german: "finanziert",
      translated: "finanse eder",
      tone: 'semantic',
    },
    {
      german: "der deutsche Staat",
      translated: "Alman devleti",
      tone: 'semantic',
    },
    {
      german: "die Sozialversicherung",
      translated: "sosyal güvenlik sistemini",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:35|uk": [
    {
      german: "Womit",
      translated: "Чим",
      tone: 'semantic',
    },
    {
      german: "finanziert",
      translated: "фінансує",
      tone: 'semantic',
    },
    {
      german: "der deutsche Staat",
      translated: "німецька держава",
      tone: 'semantic',
    },
    {
      german: "die Sozialversicherung",
      translated: "систему соціального страхування",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:35|vi": [
    {
      german: "Womit",
      translated: "bằng cách nào",
      tone: 'semantic',
    },
    {
      german: "finanziert",
      translated: "tài trợ",
      tone: 'semantic',
    },
    {
      german: "der deutsche Staat",
      translated: "Nhà nước Đức",
      tone: 'semantic',
    },
    {
      german: "die Sozialversicherung",
      translated: "hệ thống an sinh xã hội",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:36|ar": [
    {
      german: "Welche Maßnahme",
      translated: "أي إجراء",
      tone: 'semantic',
    },
    {
      german: "schafft",
      translated: "يوفر",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "في ألمانيا",
      tone: 'semantic',
    },
    {
      german: "soziale Sicherheit",
      translated: "الأمن الاجتماعي",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:36|bg": [
    {
      german: "Welche Maßnahme",
      translated: "Коя мярка",
      tone: 'semantic',
    },
    {
      german: "schafft",
      translated: "създава",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "в Германия",
      tone: 'semantic',
    },
    {
      german: "soziale Sicherheit",
      translated: "социална сигурност",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:36|bs": [
    {
      german: "Welche Maßnahme",
      translated: "Što",
      tone: 'semantic',
    },
    {
      german: "schafft",
      translated: "pripada",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "u Njemačkoj",
      tone: 'semantic',
    },
    {
      german: "soziale Sicherheit",
      translated: "socijalnoj sigurnosti",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:36|el": [
    {
      german: "Welche Maßnahme",
      translated: "Ποιο από τα παρακάτω",
      tone: 'semantic',
    },
    {
      german: "schafft",
      translated: "συμβάλλει",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "στη Γερμανία",
      tone: 'semantic',
    },
    {
      german: "soziale Sicherheit",
      translated: "κοινωνική ασφάλιση",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:36|en": [
    {
      german: "Welche Maßnahme",
      translated: "Which measure",
      tone: 'semantic',
    },
    {
      german: "schafft",
      translated: "creates",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "in Germany",
      tone: 'semantic',
    },
    {
      german: "soziale Sicherheit",
      translated: "social security",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:36|es": [
    {
      german: "Welche Maßnahme",
      translated: "¿Qué medida",
      tone: 'semantic',
    },
    {
      german: "schafft",
      translated: "proporciona",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "en Alemania",
      tone: 'semantic',
    },
    {
      german: "soziale Sicherheit",
      translated: "seguridad social",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:36|fa": [
    {
      german: "Welche Maßnahme",
      translated: "کدام مورد",
      tone: 'semantic',
    },
    {
      german: "schafft",
      translated: "کمک می‌کند",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "در آلمان",
      tone: 'semantic',
    },
    {
      german: "soziale Sicherheit",
      translated: "به تأمین اجتماعی",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:36|fr": [
    {
      german: "Welche Maßnahme",
      translated: "Quelle mesure",
      tone: 'semantic',
    },
    {
      german: "schafft",
      translated: "assure",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "en Allemagne",
      tone: 'semantic',
    },
    {
      german: "soziale Sicherheit",
      translated: "la sécurité sociale",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:36|hr": [
    {
      german: "Welche Maßnahme",
      translated: "Koja mjera",
      tone: 'semantic',
    },
    {
      german: "schafft",
      translated: "stvara",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "u Njemačkoj",
      tone: 'semantic',
    },
    {
      german: "soziale Sicherheit",
      translated: "socijalnu sigurnost",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:36|it": [
    {
      german: "Welche Maßnahme",
      translated: "Quale misura",
      tone: 'semantic',
    },
    {
      german: "schafft",
      translated: "garantisce",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "in Germania",
      tone: 'semantic',
    },
    {
      german: "soziale Sicherheit",
      translated: "la sicurezza sociale",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:36|kmr": [
    {
      german: "Welche Maßnahme",
      translated: "Kîjan tedbîr",
      tone: 'semantic',
    },
    {
      german: "schafft",
      translated: "dabîn",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "li Almanyayê",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:36|pl": [
    {
      german: "Welche Maßnahme",
      translated: "Co należy do",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "w Niemczech",
      tone: 'semantic',
    },
    {
      german: "soziale Sicherheit",
      translated: "zabezpieczenia społecznego",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:36|prs": [
    {
      german: "Welche Maßnahme",
      translated: "کدام مورد",
      tone: 'semantic',
    },
    {
      german: "schafft",
      translated: "کمک می‌کند",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "در آلمان",
      tone: 'semantic',
    },
    {
      german: "soziale Sicherheit",
      translated: "تأمین اجتماعی",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:36|ro": [
    {
      german: "Welche Maßnahme",
      translated: "Care dintre următoarele",
      tone: 'semantic',
    },
    {
      german: "schafft",
      translated: "face parte din",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "în Germania",
      tone: 'semantic',
    },
    {
      german: "soziale Sicherheit",
      translated: "securitatea socială",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:36|ru": [
    {
      german: "Welche Maßnahme",
      translated: "Какая мера",
      tone: 'semantic',
    },
    {
      german: "schafft",
      translated: "обеспечивает",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "в Германии",
      tone: 'semantic',
    },
    {
      german: "soziale Sicherheit",
      translated: "социальную защищённость",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:36|sq": [
    {
      german: "Welche Maßnahme",
      translated: "Cila",
      tone: 'semantic',
    },
    {
      german: "schafft",
      translated: "masë",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "në Gjermani",
      tone: 'semantic',
    },
    {
      german: "soziale Sicherheit",
      translated: "siguron mbrojtjen sociale",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:36|sr": [
    {
      german: "Welche Maßnahme",
      translated: "Koja mjera",
      tone: 'semantic',
    },
    {
      german: "schafft",
      translated: "stvara",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "u Nemačkoj",
      tone: 'semantic',
    },
    {
      german: "soziale Sicherheit",
      translated: "socijalnu bezbednost",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:36|tr": [
    {
      german: "Welche Maßnahme",
      translated: "hangi önlem",
      tone: 'semantic',
    },
    {
      german: "schafft",
      translated: "sağlar",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "Almanya'da",
      tone: 'semantic',
    },
    {
      german: "soziale Sicherheit",
      translated: "sosyal güvenliği",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:36|uk": [
    {
      german: "Welche Maßnahme",
      translated: "Який захід",
      tone: 'semantic',
    },
    {
      german: "schafft",
      translated: "забезпечує",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "в Німеччині",
      tone: 'semantic',
    },
    {
      german: "soziale Sicherheit",
      translated: "соціальну безпеку",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:36|vi": [
    {
      german: "Welche Maßnahme",
      translated: "Biện pháp nào",
      tone: 'semantic',
    },
    {
      german: "schafft",
      translated: "góp phần bảo đảm",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "ở Đức",
      tone: 'semantic',
    },
    {
      german: "soziale Sicherheit",
      translated: "an sinh xã hội",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:37|ar": [
    {
      german: "die Regierungschefinnen/Regierungschefs",
      translated: "رؤساء حكومات",
      tone: 'semantic',
    },
    {
      german: "der meisten Bundesländer",
      translated: "معظم الولايات الاتحادية",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "في ألمانيا",
      tone: 'semantic',
    },
    {
      german: "genannt",
      translated: "؟",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:37|bg": [
    {
      german: "Wie",
      translated: "Как",
      tone: 'semantic',
    },
    {
      german: "werden",
      translated: "се",
      tone: 'semantic',
    },
    {
      german: "die Regierungschefinnen/Regierungschefs",
      translated: "ръководителят на правителството",
      tone: 'semantic',
    },
    {
      german: "der meisten Bundesländer",
      translated: "в повечето германски провинции",
      tone: 'semantic',
    },
    {
      german: "genannt",
      translated: "нарича",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:37|bs": [
    {
      german: "Wie",
      translated: "Kako",
      tone: 'semantic',
    },
    {
      german: "werden",
      translated: "se",
      tone: 'semantic',
    },
    {
      german: "die Regierungschefinnen/Regierungschefs",
      translated: "šefovi vlada",
      tone: 'semantic',
    },
    {
      german: "der meisten Bundesländer",
      translated: "većine",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "njemačkih saveznih zemalja",
      tone: 'semantic',
    },
    {
      german: "genannt",
      translated: "nazivaju",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:37|el": [
    {
      german: "Wie",
      translated: "Πώς",
      tone: 'semantic',
    },
    {
      german: "die Regierungschefinnen/Regierungschefs",
      translated: "ο επικεφαλής της κυβέρνησης",
      tone: 'semantic',
    },
    {
      german: "der meisten Bundesländer",
      translated: "στα περισσότερα γερμανικά ομόσπονδα κρατίδια",
      tone: 'semantic',
    },
    {
      german: "genannt",
      translated: "ονομάζεται",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:37|en": [
    {
      german: "Wie",
      translated: "What",
      tone: 'semantic',
    },
    {
      german: "werden",
      translated: "are",
      tone: 'semantic',
    },
    {
      german: "die Regierungschefinnen/Regierungschefs",
      translated: "the heads of government",
      tone: 'semantic',
    },
    {
      german: "der meisten Bundesländer",
      translated: "of most federal states",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "in Germany",
      tone: 'semantic',
    },
    {
      german: "genannt",
      translated: "called",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:37|es": [
    {
      german: "Wie",
      translated: "¿Cómo",
      tone: 'semantic',
    },
    {
      german: "die Regierungschefinnen/Regierungschefs",
      translated: "jefes de gobierno",
      tone: 'semantic',
    },
    {
      german: "der meisten Bundesländer",
      translated: "de la mayoría de los estados federados",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "de Alemania",
      tone: 'semantic',
    },
    {
      german: "genannt",
      translated: "se llama",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:37|fa": [
    {
      german: "Wie",
      translated: "چه",
      tone: 'semantic',
    },
    {
      german: "die Regierungschefinnen/Regierungschefs",
      translated: "رئیس دولت",
      tone: 'semantic',
    },
    {
      german: "der meisten Bundesländer",
      translated: "بیشتر ایالت‌های",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "آلمان",
      tone: 'semantic',
    },
    {
      german: "genannt",
      translated: "عنوانی دارد",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:37|fr": [
    {
      german: "Wie",
      translated: "Comment",
      tone: 'semantic',
    },
    {
      german: "die Regierungschefinnen/Regierungschefs",
      translated: "les chefs de gouvernement",
      tone: 'semantic',
    },
    {
      german: "der meisten Bundesländer",
      translated: "la plupart des Länder allemands",
      tone: 'semantic',
    },
    {
      german: "genannt",
      translated: "appelle-t-on",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:37|hr": [
    {
      german: "Wie",
      translated: "Kako",
      tone: 'semantic',
    },
    {
      german: "werden",
      translated: "se",
      tone: 'semantic',
    },
    {
      german: "die Regierungschefinnen/Regierungschefs",
      translated: "čelnici vlada",
      tone: 'semantic',
    },
    {
      german: "der meisten Bundesländer",
      translated: "većine",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "njemačkih saveznih zemalja",
      tone: 'semantic',
    },
    {
      german: "genannt",
      translated: "nazivaju",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:37|it": [
    {
      german: "Wie",
      translated: "Come",
      tone: 'semantic',
    },
    {
      german: "werden",
      translated: "si",
      tone: 'semantic',
    },
    {
      german: "die Regierungschefinnen/Regierungschefs",
      translated: "capi di governo",
      tone: 'semantic',
    },
    {
      german: "der meisten Bundesländer",
      translated: "della maggior parte dei Länder",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "tedeschi",
      tone: 'semantic',
    },
    {
      german: "genannt",
      translated: "chiamano",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:37|kmr": [
    {
      german: "Wie",
      translated: "Serokên",
      tone: 'semantic',
    },
    {
      german: "werden",
      translated: "hukûmetên",
      tone: 'semantic',
    },
    {
      german: "die Regierungschefinnen/Regierungschefs",
      translated: "piraniya eyaletên federal ên",
      tone: 'semantic',
    },
    {
      german: "der meisten Bundesländer",
      translated: "çi têne gotin",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "Almanyayê",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:37|pl": [
    {
      german: "Wie",
      translated: "Jak",
      tone: 'semantic',
    },
    {
      german: "die Regierungschefinnen/Regierungschefs",
      translated: "szefowie rządów",
      tone: 'semantic',
    },
    {
      german: "der meisten Bundesländer",
      translated: "większości niemieckich krajów związkowych",
      tone: 'semantic',
    },
    {
      german: "genannt",
      translated: "nazywają się",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:37|prs": [
    {
      german: "der meisten Bundesländer",
      translated: "بیشتر ایالت‌های",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "آلمان",
      tone: 'semantic',
    },
    {
      german: "genannt",
      translated: "چه عنوانی دارد؟",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:37|ro": [
    {
      german: "Wie",
      translated: "Cum",
      tone: 'semantic',
    },
    {
      german: "werden",
      translated: "se",
      tone: 'semantic',
    },
    {
      german: "die Regierungschefinnen/Regierungschefs",
      translated: "șeful guvernului",
      tone: 'semantic',
    },
    {
      german: "der meisten Bundesländer",
      translated: "în majoritatea landurilor germane",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:37|ru": [
    {
      german: "Wie",
      translated: "Как",
      tone: 'semantic',
    },
    {
      german: "die Regierungschefinnen/Regierungschefs",
      translated: "глав правительств",
      tone: 'semantic',
    },
    {
      german: "der meisten Bundesländer",
      translated: "большинства федеральных земель",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "Германии",
      tone: 'semantic',
    },
    {
      german: "genannt",
      translated: "называют",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:37|sq": [
    {
      german: "Wie",
      translated: "Si",
      tone: 'semantic',
    },
    {
      german: "die Regierungschefinnen/Regierungschefs",
      translated: "krerët e qeverive",
      tone: 'semantic',
    },
    {
      german: "der meisten Bundesländer",
      translated: "të shumicës së landeve",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "gjermane",
      tone: 'semantic',
    },
    {
      german: "genannt",
      translated: "quhen",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:37|sr": [
    {
      german: "Wie",
      translated: "Kako",
      tone: 'semantic',
    },
    {
      german: "werden",
      translated: "se",
      tone: 'semantic',
    },
    {
      german: "der meisten Bundesländer",
      translated: "većine",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "nemačkih saveznih pokrajina",
      tone: 'semantic',
    },
    {
      german: "genannt",
      translated: "nazivaju",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:37|tr": [
    {
      german: "Wie",
      translated: "ne",
      tone: 'semantic',
    },
    {
      german: "die Regierungschefinnen/Regierungschefs",
      translated: "hükümet başkanına",
      tone: 'semantic',
    },
    {
      german: "der meisten Bundesländer",
      translated: "Almanya'daki eyaletlerin çoğunda",
      tone: 'semantic',
    },
    {
      german: "genannt",
      translated: "ad verilir",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:37|uk": [
    {
      german: "Wie",
      translated: "Як",
      tone: 'semantic',
    },
    {
      german: "die Regierungschefinnen/Regierungschefs",
      translated: "глав урядів",
      tone: 'semantic',
    },
    {
      german: "der meisten Bundesländer",
      translated: "більшості федеральних земель",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "Німеччини",
      tone: 'semantic',
    },
    {
      german: "genannt",
      translated: "називають",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:37|vi": [
    {
      german: "die Regierungschefinnen/Regierungschefs",
      translated: "Người đứng đầu chính phủ",
      tone: 'semantic',
    },
    {
      german: "der meisten Bundesländer",
      translated: "phần lớn các bang Đức",
      tone: 'semantic',
    },
    {
      german: "genannt",
      translated: "được gọi là",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:38|ar": [
    {
      german: "Die Bundesrepublik Deutschland",
      translated: "جمهورية ألمانيا الاتحادية",
      tone: 'semantic',
    },
    {
      german: "demokratischer und sozialer",
      translated: "ديمقراطية واجتماعية",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:38|bg": [
    {
      german: "Die Bundesrepublik Deutschland",
      translated: "Федерална република Германия",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "е",
      tone: 'semantic',
    },
    {
      german: "demokratischer und sozialer",
      translated: "демократична и социална",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:38|bs": [
    {
      german: "Die Bundesrepublik Deutschland",
      translated: "Savezna Republika Njemačka",
      tone: 'semantic',
    },
    {
      german: "demokratischer und sozialer",
      translated: "demokratska je i socijalna",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:38|el": [
    {
      german: "Die Bundesrepublik Deutschland",
      translated: "Η Ομοσπονδιακή Δημοκρατία της Γερμανίας",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "είναι",
      tone: 'semantic',
    },
    {
      german: "demokratischer und sozialer",
      translated: "δημοκρατικό και κοινωνικό",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:38|en": [
    {
      german: "Die Bundesrepublik Deutschland",
      translated: "The Federal Republic of Germany",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "is",
      tone: 'semantic',
    },
    {
      german: "ein",
      translated: "a",
      tone: 'semantic',
    },
    {
      german: "demokratischer und sozialer",
      translated: "democratic and social …",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:38|es": [
    {
      german: "Die Bundesrepublik Deutschland",
      translated: "La República Federal de Alemania",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "es",
      tone: 'semantic',
    },
    {
      german: "ein",
      translated: "un …",
      tone: 'semantic',
    },
    {
      german: "demokratischer und sozialer",
      translated: "democrático y social",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:38|fa": [
    {
      german: "Die Bundesrepublik Deutschland",
      translated: "جمهوری فدرال آلمان",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "است.",
      tone: 'semantic',
    },
    {
      german: "demokratischer und sozialer",
      translated: "دموکراتیک و اجتماعیِ …",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:38|fr": [
    {
      german: "Die Bundesrepublik Deutschland",
      translated: "La République fédérale d’Allemagne",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "est",
      tone: 'semantic',
    },
    {
      german: "ein",
      translated: "un",
      tone: 'semantic',
    },
    {
      german: "demokratischer und sozialer",
      translated: "démocratique et social",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:38|hr": [
    {
      german: "Die Bundesrepublik Deutschland",
      translated: "Savezna Republika Njemačka",
      tone: 'semantic',
    },
    {
      german: "demokratischer und sozialer",
      translated: "demokratska je i socijalna",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:38|it": [
    {
      german: "Die Bundesrepublik Deutschland",
      translated: "La Repubblica Federale di Germania",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "è",
      tone: 'semantic',
    },
    {
      german: "ein",
      translated: "uno",
      tone: 'semantic',
    },
    {
      german: "demokratischer und sozialer",
      translated: "democratico e sociale",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:38|kmr": [
    {
      german: "Die Bundesrepublik Deutschland",
      translated: "Komara Federal a Almanyayê",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "e.",
      tone: 'semantic',
    },
    {
      german: "ein",
      translated: "dewleteke",
      tone: 'semantic',
    },
    {
      german: "demokratischer und sozialer",
      translated: "demokratîk û civakî",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:38|pl": [
    {
      german: "Die Bundesrepublik Deutschland",
      translated: "Republika Federalna Niemiec",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "jest",
      tone: 'semantic',
    },
    {
      german: "ein",
      translated: "państwem",
      tone: 'semantic',
    },
    {
      german: "demokratischer und sozialer",
      translated: "demokratycznym i socjalnym",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:38|prs": [
    {
      german: "Die Bundesrepublik Deutschland",
      translated: "جمهوری فدرال آلمان",
      tone: 'semantic',
    },
    {
      german: "ein",
      translated: "یک",
      tone: 'semantic',
    },
    {
      german: "demokratischer und sozialer",
      translated: "دموکراتیک و اجتماعیِ …",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:38|ro": [
    {
      german: "Die Bundesrepublik Deutschland",
      translated: "Republica Federală Germania",
      tone: 'semantic',
    },
    {
      german: "ein",
      translated: "un",
      tone: 'semantic',
    },
    {
      german: "demokratischer und sozialer",
      translated: " democratic și social …",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:38|ru": [
    {
      german: "Die Bundesrepublik Deutschland",
      translated: "Федеративная Республика Германия",
      tone: 'semantic',
    },
    {
      german: "demokratischer und sozialer",
      translated: "демократическим и социальным …",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:38|sq": [
    {
      german: "Die Bundesrepublik Deutschland",
      translated: "Republika Federale e Gjermanisë",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "është",
      tone: 'semantic',
    },
    {
      german: "demokratischer und sozialer",
      translated: "demokratik dhe social",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:38|sr": [
    {
      german: "Die Bundesrepublik Deutschland",
      translated: "Savezna Republika Nemačka",
      tone: 'semantic',
    },
    {
      german: "demokratischer und sozialer",
      translated: "demokratska je i socijalna …",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:38|tr": [
    {
      german: "Die Bundesrepublik Deutschland",
      translated: "Almanya Federal Cumhuriyeti",
      tone: 'semantic',
    },
    {
      german: "demokratischer und sozialer",
      translated: "demokratik ve sosyal",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:38|uk": [
    {
      german: "Die Bundesrepublik Deutschland",
      translated: "Федеративна Республіка Німеччина",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "є",
      tone: 'semantic',
    },
    {
      german: "demokratischer und sozialer",
      translated: "демократичною та соціальною",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:38|vi": [
    {
      german: "Die Bundesrepublik Deutschland",
      translated: "Cộng hòa Liên bang Đức",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "là",
      tone: 'semantic',
    },
    {
      german: "ein",
      translated: "một",
      tone: 'semantic',
    },
    {
      german: "demokratischer und sozialer",
      translated: "dân chủ và xã hội",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:39|ar": [
    {
      german: "Was hat",
      translated: "ماذا",
      tone: 'semantic',
    },
    {
      german: "jedes deutsche Bundesland",
      translated: "كل ولاية اتحادية ألمانية",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:39|bg": [
    {
      german: "Was hat",
      translated: "Какво има",
      tone: 'semantic',
    },
    {
      german: "jedes deutsche Bundesland",
      translated: "всяка германска федерална провинция",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:39|bs": [
    {
      german: "Was hat",
      translated: "Što ima",
      tone: 'semantic',
    },
    {
      german: "jedes deutsche Bundesland",
      translated: "svaka njemačka savezna zemlja",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:39|el": [
    {
      german: "Was hat",
      translated: "Τι διαθέτει κάθε",
      tone: 'semantic',
    },
    {
      german: "jedes deutsche Bundesland",
      translated: "γερμανικό ομόσπονδο κρατίδιο",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:39|en": [
    {
      german: "Was hat",
      translated: "What does",
      tone: 'semantic',
    },
    {
      german: "jedes deutsche Bundesland",
      translated: "every German federal state have",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:39|es": [
    {
      german: "Was hat",
      translated: "¿Qué tiene cada",
      tone: 'semantic',
    },
    {
      german: "jedes deutsche Bundesland",
      translated: "estado federado alemán",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:39|fa": [
    {
      german: "Was hat",
      translated: "چه چیزی دارد",
      tone: 'semantic',
    },
    {
      german: "jedes deutsche Bundesland",
      translated: "هر ایالت آلمان",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:39|fr": [
    {
      german: "Was hat",
      translated: "Que possède",
      tone: 'semantic',
    },
    {
      german: "jedes deutsche Bundesland",
      translated: "chaque Land allemand",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:39|hr": [
    {
      german: "Was hat",
      translated: "Što ima",
      tone: 'semantic',
    },
    {
      german: "jedes deutsche Bundesland",
      translated: "svaka njemačka savezna zemlja",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:39|it": [
    {
      german: "Was hat",
      translated: "Che cosa possiede",
      tone: 'semantic',
    },
    {
      german: "jedes deutsche Bundesland",
      translated: "ogni Land tedesco",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:39|kmr": [
    {
      german: "Was hat",
      translated: "Her eyaleteke",
      tone: 'semantic',
    },
    {
      german: "jedes deutsche Bundesland",
      translated: "Alman çi heye",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:39|pl": [
    {
      german: "Was hat",
      translated: "Co",
      tone: 'semantic',
    },
    {
      german: "jedes deutsche Bundesland",
      translated: "każdy niemiecki kraj związkowy",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:39|prs": [
    {
      german: "Was hat",
      translated: "هر",
      tone: 'semantic',
    },
    {
      german: "jedes deutsche Bundesland",
      translated: "ایالت آلمان چه چیزی دارد",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:39|ro": [
    {
      german: "Was hat",
      translated: "Ce are",
      tone: 'semantic',
    },
    {
      german: "jedes deutsche Bundesland",
      translated: "fiecare land german",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:39|ru": [
    {
      german: "Was hat",
      translated: "Что есть",
      tone: 'semantic',
    },
    {
      german: "jedes deutsche Bundesland",
      translated: "у каждой федеральной земли Германии",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:39|sq": [
    {
      german: "Was hat",
      translated: "Çfarë",
      tone: 'semantic',
    },
    {
      german: "jedes deutsche Bundesland",
      translated: "ka çdo land gjerman",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:39|sr": [
    {
      german: "Was hat",
      translated: "Šta ima",
      tone: 'semantic',
    },
    {
      german: "jedes deutsche Bundesland",
      translated: "svaka nemačka savezna pokrajina",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:39|tr": [
    {
      german: "Was hat",
      translated: "Her",
      tone: 'semantic',
    },
    {
      german: "jedes deutsche Bundesland",
      translated: "Alman eyaletinin kendisine ait neyi vardır",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:39|uk": [
    {
      german: "Was hat",
      translated: "Що",
      tone: 'semantic',
    },
    {
      german: "jedes deutsche Bundesland",
      translated: "кожна федеральна земля Німеччини",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:39|vi": [
    {
      german: "Was hat",
      translated: "có gì",
      tone: 'semantic',
    },
    {
      german: "jedes deutsche Bundesland",
      translated: "Mỗi bang của Đức",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:3|ar": [
    {
      german: "Deutschland ist",
      translated: "ألمانيا",
      tone: 'semantic',
    },
    {
      german: "ein Rechtsstaat",
      translated: "دولة قانون",
      tone: 'semantic',
    },
    {
      german: "Was",
      translated: "ماذا",
      tone: 'semantic',
    },
    {
      german: "ist damit gemeint",
      translated: "يعني ذلك",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:3|bg": [
    {
      german: "Deutschland ist",
      translated: "Германия е",
      tone: 'semantic',
    },
    {
      german: "ein Rechtsstaat",
      translated: "правова държава.",
      tone: 'semantic',
    },
    {
      german: "ist damit gemeint",
      translated: "Какво означава това?",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:3|bs": [
    {
      german: "Deutschland ist",
      translated: "Njemačka je",
      tone: 'semantic',
    },
    {
      german: "ein Rechtsstaat",
      translated: "pravna država",
      tone: 'semantic',
    },
    {
      german: "Was",
      translated: "Što",
      tone: 'semantic',
    },
    {
      german: "ist damit gemeint",
      translated: "to znači",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:3|el": [
    {
      german: "Deutschland ist",
      translated: "Η Γερμανία είναι",
      tone: 'semantic',
    },
    {
      german: "ein Rechtsstaat",
      translated: "κράτος δικαίου",
      tone: 'semantic',
    },
    {
      german: "Was",
      translated: "Τι",
      tone: 'semantic',
    },
    {
      german: "ist damit gemeint",
      translated: "σημαίνει αυτό",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:3|en": [
    {
      german: "Deutschland ist",
      translated: "Germany is",
      tone: 'semantic',
    },
    {
      german: "ein Rechtsstaat",
      translated: "a constitutional state (Rechtsstaat)",
      tone: 'semantic',
    },
    {
      german: "Was",
      translated: "What",
      tone: 'semantic',
    },
    {
      german: "ist damit gemeint",
      translated: "does this mean",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:3|es": [
    {
      german: "Deutschland ist",
      translated: "Alemania es",
      tone: 'semantic',
    },
    {
      german: "ein Rechtsstaat",
      translated: "un Estado de derecho",
      tone: 'semantic',
    },
    {
      german: "Was",
      translated: "¿Qué",
      tone: 'semantic',
    },
    {
      german: "ist damit gemeint",
      translated: "significa eso",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:3|fa": [
    {
      german: "Deutschland ist",
      translated: "آلمان",
      tone: 'semantic',
    },
    {
      german: "ein Rechtsstaat",
      translated: "یک کشور مبتنی بر حاکمیت قانون",
      tone: 'semantic',
    },
    {
      german: "Was",
      translated: "چه",
      tone: 'semantic',
    },
    {
      german: "ist damit gemeint",
      translated: "این یعنی",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:3|fr": [
    {
      german: "Deutschland ist",
      translated: "L’Allemagne est",
      tone: 'semantic',
    },
    {
      german: "ein Rechtsstaat",
      translated: "un État de droit",
      tone: 'semantic',
    },
    {
      german: "Was",
      translated: "Qu’est-ce que",
      tone: 'semantic',
    },
    {
      german: "ist damit gemeint",
      translated: "signifie",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:3|hr": [
    {
      german: "Deutschland ist",
      translated: "Njemačka je",
      tone: 'semantic',
    },
    {
      german: "ein Rechtsstaat",
      translated: "pravna država",
      tone: 'semantic',
    },
    {
      german: "Was",
      translated: "Što",
      tone: 'semantic',
    },
    {
      german: "ist damit gemeint",
      translated: "to znači",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:3|it": [
    {
      german: "Deutschland ist",
      translated: "La Germania è",
      tone: 'semantic',
    },
    {
      german: "ein Rechtsstaat",
      translated: "uno Stato di diritto",
      tone: 'semantic',
    },
    {
      german: "Was",
      translated: "Che cosa",
      tone: 'semantic',
    },
    {
      german: "ist damit gemeint",
      translated: "significa",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:3|kmr": [
    {
      german: "Deutschland ist",
      translated: "Almanya dewleteke",
      tone: 'semantic',
    },
    {
      german: "ein Rechtsstaat",
      translated: "hiqûqê",
      tone: 'semantic',
    },
    {
      german: "Was",
      translated: "Ev",
      tone: 'semantic',
    },
    {
      german: "ist damit gemeint",
      translated: "tê çi wateyê",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:3|pl": [
    {
      german: "Deutschland ist",
      translated: "Niemcy są",
      tone: 'semantic',
    },
    {
      german: "ein Rechtsstaat",
      translated: "państwem prawa",
      tone: 'semantic',
    },
    {
      german: "Was",
      translated: "Co",
      tone: 'semantic',
    },
    {
      german: "ist damit gemeint",
      translated: "oznacza",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:3|prs": [
    {
      german: "Deutschland ist",
      translated: "آلمان یک کشور",
      tone: 'semantic',
    },
    {
      german: "ein Rechtsstaat",
      translated: "مبتنی بر حاکمیت قانون",
      tone: 'semantic',
    },
    {
      german: "Was",
      translated: "این",
      tone: 'semantic',
    },
    {
      german: "ist damit gemeint",
      translated: "یعنی چه",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:3|ro": [
    {
      german: "Deutschland ist",
      translated: "Germania este",
      tone: 'semantic',
    },
    {
      german: "ein Rechtsstaat",
      translated: "un stat de drept",
      tone: 'semantic',
    },
    {
      german: "Was",
      translated: "Ce",
      tone: 'semantic',
    },
    {
      german: "ist damit gemeint",
      translated: "înseamnă aceasta",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:3|ru": [
    {
      german: "Deutschland ist",
      translated: "Германия",
      tone: 'semantic',
    },
    {
      german: "ein Rechtsstaat",
      translated: "правовое государство",
      tone: 'semantic',
    },
    {
      german: "Was",
      translated: "Что",
      tone: 'semantic',
    },
    {
      german: "ist damit gemeint",
      translated: "это означает?",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:3|sq": [
    {
      german: "Deutschland ist",
      translated: "Gjermania është",
      tone: 'semantic',
    },
    {
      german: "ein Rechtsstaat",
      translated: "shtet i së drejtës",
      tone: 'semantic',
    },
    {
      german: "Was",
      translated: "Çfarë",
      tone: 'semantic',
    },
    {
      german: "ist damit gemeint",
      translated: "do të thotë kjo",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:3|sr": [
    {
      german: "Deutschland ist",
      translated: "Nemačka je",
      tone: 'semantic',
    },
    {
      german: "ein Rechtsstaat",
      translated: "pravna država",
      tone: 'semantic',
    },
    {
      german: "Was",
      translated: "Šta",
      tone: 'semantic',
    },
    {
      german: "ist damit gemeint",
      translated: "to znači",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:3|tr": [
    {
      german: "Deutschland ist",
      translated: "Almanya bir",
      tone: 'semantic',
    },
    {
      german: "ein Rechtsstaat",
      translated: "hukuk devletidir.",
      tone: 'semantic',
    },
    {
      german: "Was",
      translated: "Bununla",
      tone: 'semantic',
    },
    {
      german: "ist damit gemeint",
      translated: "ne kastedilir?",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:3|uk": [
    {
      german: "Deutschland ist",
      translated: "Німеччина є",
      tone: 'semantic',
    },
    {
      german: "ein Rechtsstaat",
      translated: "правовою державою.",
      tone: 'semantic',
    },
    {
      german: "Was",
      translated: "Що",
      tone: 'semantic',
    },
    {
      german: "ist damit gemeint",
      translated: "це означає?",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:3|vi": [
    {
      german: "Deutschland ist",
      translated: "Đức là",
      tone: 'semantic',
    },
    {
      german: "ein Rechtsstaat",
      translated: "một nhà nước pháp quyền",
      tone: 'semantic',
    },
    {
      german: "Was",
      translated: "Điều đó",
      tone: 'semantic',
    },
    {
      german: "ist damit gemeint",
      translated: "có nghĩa là gì",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:40|ar": [
    {
      german: "Mit welchen Worten",
      translated: "بأي كلمات",
      tone: 'semantic',
    },
    {
      german: "beginnt",
      translated: "يبدأ",
      tone: 'semantic',
    },
    {
      german: "die deutsche Nationalhymne",
      translated: "النشيد الوطني الألماني",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:40|bg": [
    {
      german: "Mit welchen Worten",
      translated: "С кои думи",
      tone: 'semantic',
    },
    {
      german: "beginnt",
      translated: "започва",
      tone: 'semantic',
    },
    {
      german: "die deutsche Nationalhymne",
      translated: "националният химн на Германия",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:40|bs": [
    {
      german: "Mit welchen Worten",
      translated: "Kojim riječima",
      tone: 'semantic',
    },
    {
      german: "beginnt",
      translated: "počinje",
      tone: 'semantic',
    },
    {
      german: "die deutsche Nationalhymne",
      translated: "njemačka državna himna",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:40|el": [
    {
      german: "Mit welchen Worten",
      translated: "Με ποιες λέξεις",
      tone: 'semantic',
    },
    {
      german: "beginnt",
      translated: "αρχίζει",
      tone: 'semantic',
    },
    {
      german: "die deutsche Nationalhymne",
      translated: "ο εθνικός ύμνος της Γερμανίας",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:40|en": [
    {
      german: "Mit welchen Worten",
      translated: "With which words",
      tone: 'semantic',
    },
    {
      german: "beginnt",
      translated: "begin",
      tone: 'semantic',
    },
    {
      german: "die deutsche Nationalhymne",
      translated: "the German national anthem",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:40|es": [
    {
      german: "Mit welchen Worten",
      translated: "¿Con qué palabras",
      tone: 'semantic',
    },
    {
      german: "beginnt",
      translated: "comienza",
      tone: 'semantic',
    },
    {
      german: "die deutsche Nationalhymne",
      translated: "el himno nacional alemán",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:40|fa": [
    {
      german: "Mit welchen Worten",
      translated: "با کدام عبارت",
      tone: 'semantic',
    },
    {
      german: "beginnt",
      translated: "آغاز می‌شود",
      tone: 'semantic',
    },
    {
      german: "die deutsche Nationalhymne",
      translated: "سرود ملی آلمان",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:40|fr": [
    {
      german: "Mit welchen Worten",
      translated: "Par quels mots",
      tone: 'semantic',
    },
    {
      german: "beginnt",
      translated: "commence",
      tone: 'semantic',
    },
    {
      german: "die deutsche Nationalhymne",
      translated: "l’hymne national allemand",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:40|hr": [
    {
      german: "Mit welchen Worten",
      translated: "Kojim",
      tone: 'semantic',
    },
    {
      german: "beginnt",
      translated: "počinje",
      tone: 'semantic',
    },
    {
      german: "die deutsche Nationalhymne",
      translated: "njemačka državna himna",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:40|it": [
    {
      german: "Mit welchen Worten",
      translated: "Con quali parole",
      tone: 'semantic',
    },
    {
      german: "beginnt",
      translated: "inizia",
      tone: 'semantic',
    },
    {
      german: "die deutsche Nationalhymne",
      translated: "l’inno nazionale tedesco",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:40|kmr": [
    {
      german: "Mit welchen Worten",
      translated: "kîjan peyvan",
      tone: 'semantic',
    },
    {
      german: "beginnt",
      translated: "dest pê dike",
      tone: 'semantic',
    },
    {
      german: "die deutsche Nationalhymne",
      translated: "Strana neteweyî ya Alman",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:40|pl": [
    {
      german: "Mit welchen Worten",
      translated: "Jakimi słowami",
      tone: 'semantic',
    },
    {
      german: "beginnt",
      translated: "rozpoczyna się",
      tone: 'semantic',
    },
    {
      german: "die deutsche Nationalhymne",
      translated: "hymn narodowy Niemiec",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:40|prs": [
    {
      german: "Mit welchen Worten",
      translated: "با کدام عبارت",
      tone: 'semantic',
    },
    {
      german: "beginnt",
      translated: "آغاز می‌شود",
      tone: 'semantic',
    },
    {
      german: "die deutsche Nationalhymne",
      translated: "سرود ملی آلمان",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:40|ro": [
    {
      german: "Mit welchen Worten",
      translated: "Cu ce cuvinte",
      tone: 'semantic',
    },
    {
      german: "beginnt",
      translated: "începe",
      tone: 'semantic',
    },
    {
      german: "die deutsche Nationalhymne",
      translated: "imnul național al Germaniei",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:40|ru": [
    {
      german: "Mit welchen Worten",
      translated: "С каких слов",
      tone: 'semantic',
    },
    {
      german: "beginnt",
      translated: "начинается",
      tone: 'semantic',
    },
    {
      german: "die deutsche Nationalhymne",
      translated: "национальный гимн Германии",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:40|sq": [
    {
      german: "Mit welchen Worten",
      translated: "Me cilat fjalë",
      tone: 'semantic',
    },
    {
      german: "beginnt",
      translated: "fillon",
      tone: 'semantic',
    },
    {
      german: "die deutsche Nationalhymne",
      translated: "himni kombëtar gjerman?",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:40|sr": [
    {
      german: "Mit welchen Worten",
      translated: "Kojim riječima",
      tone: 'semantic',
    },
    {
      german: "beginnt",
      translated: "počinje",
      tone: 'semantic',
    },
    {
      german: "die deutsche Nationalhymne",
      translated: "nemačka državna himna",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:40|tr": [
    {
      german: "Mit welchen Worten",
      translated: "hangi sözlerle",
      tone: 'semantic',
    },
    {
      german: "beginnt",
      translated: "başlar",
      tone: 'semantic',
    },
    {
      german: "die deutsche Nationalhymne",
      translated: "Alman milli marşı",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:40|uk": [
    {
      german: "Mit welchen Worten",
      translated: "Якими словами",
      tone: 'semantic',
    },
    {
      german: "beginnt",
      translated: "починається",
      tone: 'semantic',
    },
    {
      german: "die deutsche Nationalhymne",
      translated: "державний гімн Німеччини",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:40|vi": [
    {
      german: "Mit welchen Worten",
      translated: "Quốc ca Đức",
      tone: 'semantic',
    },
    {
      german: "beginnt",
      translated: "bắt đầu",
      tone: 'semantic',
    },
    {
      german: "die deutsche Nationalhymne",
      translated: "bằng những từ nào",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:41|ar": [
    {
      german: "Warum",
      translated: "لماذا",
      tone: 'semantic',
    },
    {
      german: "gibt es",
      translated: "يوجد",
      tone: 'semantic',
    },
    {
      german: "in einer Demokratie",
      translated: "في الديمقراطية",
      tone: 'semantic',
    },
    {
      german: "mehr als",
      translated: "أكثر من",
      tone: 'semantic',
    },
    {
      german: "eine Partei?",
      translated: "حزب واحد؟",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:41|bg": [
    {
      german: "Warum",
      translated: "Защо",
      tone: 'semantic',
    },
    {
      german: "gibt es",
      translated: "има",
      tone: 'semantic',
    },
    {
      german: "in einer Demokratie",
      translated: "в една демокрация",
      tone: 'semantic',
    },
    {
      german: "mehr als",
      translated: "няколко",
      tone: 'semantic',
    },
    {
      german: "eine Partei?",
      translated: "партии?",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:41|bs": [
    {
      german: "Warum",
      translated: "Zašto",
      tone: 'semantic',
    },
    {
      german: "gibt es",
      translated: "postoji",
      tone: 'semantic',
    },
    {
      german: "in einer Demokratie",
      translated: "u demokraciji",
      tone: 'semantic',
    },
    {
      german: "mehr als",
      translated: "više",
      tone: 'semantic',
    },
    {
      german: "eine Partei?",
      translated: "stranaka",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:41|el": [
    {
      german: "Warum",
      translated: "Γιατί",
      tone: 'semantic',
    },
    {
      german: "gibt es",
      translated: "υπάρχουν",
      tone: 'semantic',
    },
    {
      german: "in einer Demokratie",
      translated: "σε μια δημοκρατία",
      tone: 'semantic',
    },
    {
      german: "mehr als",
      translated: "περισσότερα από",
      tone: 'semantic',
    },
    {
      german: "eine Partei?",
      translated: "ένα",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:41|en": [
    {
      german: "Warum",
      translated: "Why",
      tone: 'semantic',
    },
    {
      german: "gibt es",
      translated: "is there",
      tone: 'semantic',
    },
    {
      german: "in einer Demokratie",
      translated: "in a democracy",
      tone: 'semantic',
    },
    {
      german: "mehr als",
      translated: "more than",
      tone: 'semantic',
    },
    {
      german: "eine Partei?",
      translated: "one party",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:41|es": [
    {
      german: "Warum",
      translated: "¿Por qué",
      tone: 'semantic',
    },
    {
      german: "gibt es",
      translated: "hay",
      tone: 'semantic',
    },
    {
      german: "in einer Demokratie",
      translated: "en una democracia",
      tone: 'semantic',
    },
    {
      german: "mehr als",
      translated: "más de",
      tone: 'semantic',
    },
    {
      german: "eine Partei?",
      translated: "un partido",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:41|fa": [
    {
      german: "Warum",
      translated: "چرا",
      tone: 'semantic',
    },
    {
      german: "gibt es",
      translated: "وجود دارد",
      tone: 'semantic',
    },
    {
      german: "in einer Demokratie",
      translated: "در یک دموکراسی",
      tone: 'semantic',
    },
    {
      german: "mehr als",
      translated: "بیش از",
      tone: 'semantic',
    },
    {
      german: "eine Partei?",
      translated: "یک حزب",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:41|fr": [
    {
      german: "Warum",
      translated: "Pourquoi",
      tone: 'semantic',
    },
    {
      german: "gibt es",
      translated: "existe-t-il",
      tone: 'semantic',
    },
    {
      german: "in einer Demokratie",
      translated: "dans une démocratie",
      tone: 'semantic',
    },
    {
      german: "mehr als",
      translated: "plus d’un",
      tone: 'semantic',
    },
    {
      german: "eine Partei?",
      translated: "parti",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:41|hr": [
    {
      german: "Warum",
      translated: "Zašto",
      tone: 'semantic',
    },
    {
      german: "gibt es",
      translated: "postoji",
      tone: 'semantic',
    },
    {
      german: "in einer Demokratie",
      translated: "u demokraciji",
      tone: 'semantic',
    },
    {
      german: "mehr als",
      translated: "više",
      tone: 'semantic',
    },
    {
      german: "eine Partei?",
      translated: "stranaka?",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:41|it": [
    {
      german: "Warum",
      translated: "Perché",
      tone: 'semantic',
    },
    {
      german: "gibt es",
      translated: "esistono",
      tone: 'semantic',
    },
    {
      german: "in einer Demokratie",
      translated: "in una democrazia",
      tone: 'semantic',
    },
    {
      german: "mehr als",
      translated: "più",
      tone: 'semantic',
    },
    {
      german: "eine Partei?",
      translated: "partiti?",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:41|kmr": [
    {
      german: "Warum",
      translated: "Çima",
      tone: 'semantic',
    },
    {
      german: "gibt es",
      translated: "de",
      tone: 'semantic',
    },
    {
      german: "in einer Demokratie",
      translated: "demokrasiyê",
      tone: 'semantic',
    },
    {
      german: "mehr als",
      translated: "ji yekê zêdetir",
      tone: 'semantic',
    },
    {
      german: "eine Partei?",
      translated: "parti hene?",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:41|pl": [
    {
      german: "Warum",
      translated: "Dlaczego",
      tone: 'semantic',
    },
    {
      german: "gibt es",
      translated: "istnieje",
      tone: 'semantic',
    },
    {
      german: "in einer Demokratie",
      translated: "w demokracji",
      tone: 'semantic',
    },
    {
      german: "mehr als",
      translated: "kilka",
      tone: 'semantic',
    },
    {
      german: "eine Partei?",
      translated: "partii",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:41|prs": [
    {
      german: "Warum",
      translated: "چرا",
      tone: 'semantic',
    },
    {
      german: "gibt es",
      translated: "وجود دارد",
      tone: 'semantic',
    },
    {
      german: "in einer Demokratie",
      translated: "در یک دموکراسی",
      tone: 'semantic',
    },
    {
      german: "mehr als",
      translated: "بیش از",
      tone: 'semantic',
    },
    {
      german: "eine Partei?",
      translated: "یک حزب",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:41|ro": [
    {
      german: "Warum",
      translated: "De ce",
      tone: 'semantic',
    },
    {
      german: "gibt es",
      translated: "există",
      tone: 'semantic',
    },
    {
      german: "in einer Demokratie",
      translated: "într-o democrație",
      tone: 'semantic',
    },
    {
      german: "mehr als",
      translated: "mai multe",
      tone: 'semantic',
    },
    {
      german: "eine Partei?",
      translated: "partide",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:41|ru": [
    {
      german: "Warum",
      translated: "Почему",
      tone: 'semantic',
    },
    {
      german: "gibt es",
      translated: "существует",
      tone: 'semantic',
    },
    {
      german: "in einer Demokratie",
      translated: "в демократии",
      tone: 'semantic',
    },
    {
      german: "mehr als",
      translated: "больше",
      tone: 'semantic',
    },
    {
      german: "eine Partei?",
      translated: "одной партии?",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:41|sq": [
    {
      german: "Warum",
      translated: "Pse",
      tone: 'semantic',
    },
    {
      german: "gibt es",
      translated: "ka",
      tone: 'semantic',
    },
    {
      german: "in einer Demokratie",
      translated: "në një demokraci",
      tone: 'semantic',
    },
    {
      german: "mehr als",
      translated: "disa",
      tone: 'semantic',
    },
    {
      german: "eine Partei?",
      translated: "parti",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:41|sr": [
    {
      german: "Warum",
      translated: "Zašta",
      tone: 'semantic',
    },
    {
      german: "gibt es",
      translated: "postoji",
      tone: 'semantic',
    },
    {
      german: "in einer Demokratie",
      translated: "u demokraciji",
      tone: 'semantic',
    },
    {
      german: "mehr als",
      translated: "više",
      tone: 'semantic',
    },
    {
      german: "eine Partei?",
      translated: "stranaka",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:41|tr": [
    {
      german: "Warum",
      translated: "neden",
      tone: 'semantic',
    },
    {
      german: "gibt es",
      translated: "vardır",
      tone: 'semantic',
    },
    {
      german: "in einer Demokratie",
      translated: "Bir demokraside",
      tone: 'semantic',
    },
    {
      german: "mehr als",
      translated: "birden fazla",
      tone: 'semantic',
    },
    {
      german: "eine Partei?",
      translated: "siyasi parti",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:41|uk": [
    {
      german: "Warum",
      translated: "Чому",
      tone: 'semantic',
    },
    {
      german: "gibt es",
      translated: "існує",
      tone: 'semantic',
    },
    {
      german: "in einer Demokratie",
      translated: "в демократії",
      tone: 'semantic',
    },
    {
      german: "mehr als",
      translated: "більше ніж",
      tone: 'semantic',
    },
    {
      german: "eine Partei?",
      translated: "одна партія?",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:41|vi": [
    {
      german: "Warum",
      translated: "Tại sao",
      tone: 'semantic',
    },
    {
      german: "gibt es",
      translated: "trong một",
      tone: 'semantic',
    },
    {
      german: "in einer Demokratie",
      translated: "nền dân chủ",
      tone: 'semantic',
    },
    {
      german: "mehr als",
      translated: "lại có nhiều",
      tone: 'semantic',
    },
    {
      german: "eine Partei?",
      translated: "đảng?",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:42|ar": [
    {
      german: "Wer",
      translated: "من",
      tone: 'semantic',
    },
    {
      german: "beschließt",
      translated: "يقر",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "في ألمانيا",
      tone: 'semantic',
    },
    {
      german: "ein neues Gesetz",
      translated: "قانونًا جديدًا",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:42|bg": [
    {
      german: "Wer",
      translated: "Кой",
      tone: 'semantic',
    },
    {
      german: "beschließt",
      translated: "приема",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "в Германия",
      tone: 'semantic',
    },
    {
      german: "ein neues Gesetz",
      translated: "нов закон",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:42|bs": [
    {
      german: "Wer",
      translated: "Tko",
      tone: 'semantic',
    },
    {
      german: "beschließt",
      translated: "donosi",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "u Njemačkoj",
      tone: 'semantic',
    },
    {
      german: "ein neues Gesetz",
      translated: "novi zakon",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:42|el": [
    {
      german: "Wer",
      translated: "Ποιος",
      tone: 'semantic',
    },
    {
      german: "beschließt",
      translated: "ψηφίζει",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "στη Γερμανία",
      tone: 'semantic',
    },
    {
      german: "ein neues Gesetz",
      translated: "έναν νέο νόμο",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:42|en": [
    {
      german: "Wer",
      translated: "Who",
      tone: 'semantic',
    },
    {
      german: "beschließt",
      translated: "passes",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "in Germany",
      tone: 'semantic',
    },
    {
      german: "ein neues Gesetz",
      translated: "a new law",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:42|es": [
    {
      german: "Wer",
      translated: "¿Quién",
      tone: 'semantic',
    },
    {
      german: "beschließt",
      translated: "aprueba",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "en Alemania",
      tone: 'semantic',
    },
    {
      german: "ein neues Gesetz",
      translated: "una nueva ley",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:42|fa": [
    {
      german: "Wer",
      translated: "چه کسی",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "در آلمان",
      tone: 'semantic',
    },
    {
      german: "ein neues Gesetz",
      translated: "یک قانون جدید را تصویب می‌کند",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:42|fr": [
    {
      german: "Wer",
      translated: "Qui",
      tone: 'semantic',
    },
    {
      german: "beschließt",
      translated: "adopte",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "en Allemagne",
      tone: 'semantic',
    },
    {
      german: "ein neues Gesetz",
      translated: "une nouvelle loi",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:42|hr": [
    {
      german: "Wer",
      translated: "Tko",
      tone: 'semantic',
    },
    {
      german: "beschließt",
      translated: "donosi",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "u Njemačkoj",
      tone: 'semantic',
    },
    {
      german: "ein neues Gesetz",
      translated: "novi zakon",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:42|it": [
    {
      german: "Wer",
      translated: "Chi",
      tone: 'semantic',
    },
    {
      german: "beschließt",
      translated: "approva",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "in Germania",
      tone: 'semantic',
    },
    {
      german: "ein neues Gesetz",
      translated: "una nuova legge",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:42|kmr": [
    {
      german: "Wer",
      translated: "Li",
      tone: 'semantic',
    },
    {
      german: "beschließt",
      translated: "qanûnek nû kî",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "Almanyayê",
      tone: 'semantic',
    },
    {
      german: "ein neues Gesetz",
      translated: "qebûl dike?",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:42|pl": [
    {
      german: "Wer",
      translated: "Kto",
      tone: 'semantic',
    },
    {
      german: "beschließt",
      translated: "uchwala",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "w Niemczech",
      tone: 'semantic',
    },
    {
      german: "ein neues Gesetz",
      translated: "nową ustawę",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:42|prs": [
    {
      german: "beschließt",
      translated: "چه کسی",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "در آلمان",
      tone: 'semantic',
    },
    {
      german: "ein neues Gesetz",
      translated: "یک قانون جدید را تصویب می‌کند",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:42|ro": [
    {
      german: "Wer",
      translated: "Cine",
      tone: 'semantic',
    },
    {
      german: "beschließt",
      translated: "adoptă",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "în Germania",
      tone: 'semantic',
    },
    {
      german: "ein neues Gesetz",
      translated: "o lege nouă",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:42|ru": [
    {
      german: "Wer",
      translated: "Кто",
      tone: 'semantic',
    },
    {
      german: "beschließt",
      translated: "принимает",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "в Германии",
      tone: 'semantic',
    },
    {
      german: "ein neues Gesetz",
      translated: "новый закон",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:42|sq": [
    {
      german: "Wer",
      translated: "Kush",
      tone: 'semantic',
    },
    {
      german: "beschließt",
      translated: "miraton",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "në Gjermani",
      tone: 'semantic',
    },
    {
      german: "ein neues Gesetz",
      translated: "një ligj të ri",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:42|sr": [
    {
      german: "Wer",
      translated: "Ko",
      tone: 'semantic',
    },
    {
      german: "beschließt",
      translated: "donosi",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "u Nemačkoj",
      tone: 'semantic',
    },
    {
      german: "ein neues Gesetz",
      translated: "novi zakon",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:42|tr": [
    {
      german: "Wer",
      translated: "kim",
      tone: 'semantic',
    },
    {
      german: "beschließt",
      translated: "kabul eder",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "Almanya'da",
      tone: 'semantic',
    },
    {
      german: "ein neues Gesetz",
      translated: "yeni bir yasayı",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:42|uk": [
    {
      german: "Wer",
      translated: "Хто",
      tone: 'semantic',
    },
    {
      german: "beschließt",
      translated: "ухвалює",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "у Німеччині",
      tone: 'semantic',
    },
    {
      german: "ein neues Gesetz",
      translated: "новий закон",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:42|vi": [
    {
      german: "Wer",
      translated: "Ai",
      tone: 'semantic',
    },
    {
      german: "beschließt",
      translated: "thông qua",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "ở Đức",
      tone: 'semantic',
    },
    {
      german: "ein neues Gesetz",
      translated: "một đạo luật mới",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:43|ar": [
    {
      german: "Wann",
      translated: "متى",
      tone: 'semantic',
    },
    {
      german: "kann",
      translated: "يمكن",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "في ألمانيا",
      tone: 'semantic',
    },
    {
      german: "eine Partei",
      translated: "حزب",
      tone: 'semantic',
    },
    {
      german: "verboten werden",
      translated: "حظر",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:43|bg": [
    {
      german: "Wann",
      translated: "Кога",
      tone: 'semantic',
    },
    {
      german: "kann",
      translated: "може да бъде",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "в Германия",
      tone: 'semantic',
    },
    {
      german: "eine Partei",
      translated: "партия",
      tone: 'semantic',
    },
    {
      german: "verboten werden",
      translated: "забранена",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:43|bs": [
    {
      german: "Wann",
      translated: "Kada",
      tone: 'semantic',
    },
    {
      german: "kann",
      translated: "može",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "u Njemačkoj",
      tone: 'semantic',
    },
    {
      german: "eine Partei",
      translated: "stranka",
      tone: 'semantic',
    },
    {
      german: "verboten werden",
      translated: "biti zabranjena",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:43|el": [
    {
      german: "Wann",
      translated: "Πότε",
      tone: 'semantic',
    },
    {
      german: "kann",
      translated: "μπορεί",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "στη Γερμανία",
      tone: 'semantic',
    },
    {
      german: "eine Partei",
      translated: "ένα κόμμα",
      tone: 'semantic',
    },
    {
      german: "verboten werden",
      translated: "να απαγορευτεί",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:43|en": [
    {
      german: "Wann",
      translated: "When",
      tone: 'semantic',
    },
    {
      german: "kann",
      translated: "can",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "in Germany",
      tone: 'semantic',
    },
    {
      german: "eine Partei",
      translated: "a party",
      tone: 'semantic',
    },
    {
      german: "verboten werden",
      translated: "be banned",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:43|es": [
    {
      german: "Wann",
      translated: "¿Cuándo",
      tone: 'semantic',
    },
    {
      german: "kann",
      translated: "puede",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "en Alemania",
      tone: 'semantic',
    },
    {
      german: "eine Partei",
      translated: "un partido",
      tone: 'semantic',
    },
    {
      german: "verboten werden",
      translated: "prohibirse",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:43|fa": [
    {
      german: "Wann",
      translated: "چه زمانی",
      tone: 'semantic',
    },
    {
      german: "kann",
      translated: "ممکن است",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "در آلمان",
      tone: 'semantic',
    },
    {
      german: "eine Partei",
      translated: "یک حزب",
      tone: 'semantic',
    },
    {
      german: "verboten werden",
      translated: "ممنوع شود",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:43|fr": [
    {
      german: "Wann",
      translated: "Quand",
      tone: 'semantic',
    },
    {
      german: "kann",
      translated: "peut-il",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "en Allemagne",
      tone: 'semantic',
    },
    {
      german: "eine Partei",
      translated: "un parti",
      tone: 'semantic',
    },
    {
      german: "verboten werden",
      translated: "être interdit",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:43|hr": [
    {
      german: "Wann",
      translated: "Kada",
      tone: 'semantic',
    },
    {
      german: "kann",
      translated: "može",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "u Njemačkoj",
      tone: 'semantic',
    },
    {
      german: "eine Partei",
      translated: "stranka",
      tone: 'semantic',
    },
    {
      german: "verboten werden",
      translated: "zabranjena",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:43|it": [
    {
      german: "Wann",
      translated: "Quando",
      tone: 'semantic',
    },
    {
      german: "kann",
      translated: "può essere",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "in Germania",
      tone: 'semantic',
    },
    {
      german: "eine Partei",
      translated: "un partito",
      tone: 'semantic',
    },
    {
      german: "verboten werden",
      translated: "vietato",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:43|kmr": [
    {
      german: "Wann",
      translated: "Li Almanyayê",
      tone: 'semantic',
    },
    {
      german: "kann",
      translated: "kengê",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "bê qedexekirin",
      tone: 'semantic',
    },
    {
      german: "eine Partei",
      translated: "partiyek",
      tone: 'semantic',
    },
    {
      german: "verboten werden",
      translated: "dikare",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:43|pl": [
    {
      german: "Wann",
      translated: "Kiedy",
      tone: 'semantic',
    },
    {
      german: "kann",
      translated: "może",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "w Niemczech",
      tone: 'semantic',
    },
    {
      german: "eine Partei",
      translated: "partia",
      tone: 'semantic',
    },
    {
      german: "verboten werden",
      translated: "zostać zakazana",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:43|prs": [
    {
      german: "Wann",
      translated: "چه زمانی",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "در آلمان",
      tone: 'semantic',
    },
    {
      german: "eine Partei",
      translated: "یک حزب",
      tone: 'semantic',
    },
    {
      german: "verboten werden",
      translated: "ممنوع شود",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:43|ro": [
    {
      german: "Wann",
      translated: "Când",
      tone: 'semantic',
    },
    {
      german: "kann",
      translated: "poate",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "în Germania",
      tone: 'semantic',
    },
    {
      german: "eine Partei",
      translated: "un partid",
      tone: 'semantic',
    },
    {
      german: "verboten werden",
      translated: "interzis",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:43|ru": [
    {
      german: "Wann",
      translated: "Когда",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "в Германии",
      tone: 'semantic',
    },
    {
      german: "eine Partei",
      translated: "партия",
      tone: 'semantic',
    },
    {
      german: "verboten werden",
      translated: "запрещена",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:43|sq": [
    {
      german: "Wann",
      translated: "Kur",
      tone: 'semantic',
    },
    {
      german: "kann",
      translated: "të",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "në Gjermani",
      tone: 'semantic',
    },
    {
      german: "eine Partei",
      translated: "një parti",
      tone: 'semantic',
    },
    {
      german: "verboten werden",
      translated: "ndalohet",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:43|sr": [
    {
      german: "Wann",
      translated: "Kada",
      tone: 'semantic',
    },
    {
      german: "kann",
      translated: "može",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "u Nemačkoj",
      tone: 'semantic',
    },
    {
      german: "eine Partei",
      translated: "stranka",
      tone: 'semantic',
    },
    {
      german: "verboten werden",
      translated: "biti zabranjena",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:43|tr": [
    {
      german: "Wann",
      translated: "ne zaman",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "Almanya'da",
      tone: 'semantic',
    },
    {
      german: "eine Partei",
      translated: "bir siyasi parti",
      tone: 'semantic',
    },
    {
      german: "verboten werden",
      translated: "yasaklanabilir",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:43|uk": [
    {
      german: "Wann",
      translated: "Коли",
      tone: 'semantic',
    },
    {
      german: "kann",
      translated: "можуть",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "в Німеччині",
      tone: 'semantic',
    },
    {
      german: "eine Partei",
      translated: "партію",
      tone: 'semantic',
    },
    {
      german: "verboten werden",
      translated: "заборонити",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:43|vi": [
    {
      german: "Wann",
      translated: "Khi nào",
      tone: 'semantic',
    },
    {
      german: "kann",
      translated: "có thể",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "ở Đức",
      tone: 'semantic',
    },
    {
      german: "eine Partei",
      translated: "một đảng",
      tone: 'semantic',
    },
    {
      german: "verboten werden",
      translated: "bị cấm",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:44|ar": [
    {
      german: "Wen",
      translated: "من",
      tone: 'semantic',
    },
    {
      german: "als Bürgerin/Bürger",
      translated: "المواطن",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "في ألمانيا",
      tone: 'semantic',
    },
    {
      german: "nicht direkt",
      translated: "لا يستطيع",
      tone: 'semantic',
    },
    {
      german: "wählen",
      translated: " انتخابه مباشرة",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:44|bg": [
    {
      german: "Wen",
      translated: "Коя длъжност",
      tone: 'semantic',
    },
    {
      german: "kann man",
      translated: "може да бъде",
      tone: 'semantic',
    },
    {
      german: "als Bürgerin/Bürger",
      translated: "граждани",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "германските",
      tone: 'semantic',
    },
    {
      german: "nicht direkt",
      translated: "НЕ",
      tone: 'semantic',
    },
    {
      german: "wählen",
      translated: "избирана пряко",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:44|bs": [
    {
      german: "Wen",
      translated: "Koju funkciju",
      tone: 'semantic',
    },
    {
      german: "kann man",
      translated: "mogu",
      tone: 'semantic',
    },
    {
      german: "als Bürgerin/Bürger",
      translated: "građani",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "njemački",
      tone: 'semantic',
    },
    {
      german: "nicht direkt",
      translated: "NE",
      tone: 'semantic',
    },
    {
      german: "wählen",
      translated: "birati",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:44|el": [
    {
      german: "Wen",
      translated: "Ποια θέση",
      tone: 'semantic',
    },
    {
      german: "kann man",
      translated: "μπορούν",
      tone: 'semantic',
    },
    {
      german: "als Bürgerin/Bürger",
      translated: "οι Γερμανοί πολίτες",
      tone: 'semantic',
    },
    {
      german: "nicht direkt",
      translated: "ΔΕΝ",
      tone: 'semantic',
    },
    {
      german: "wählen",
      translated: "εκλέξουν",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:44|en": [
    {
      german: "Wen",
      translated: "Who",
      tone: 'semantic',
    },
    {
      german: "kann man",
      translated: "can",
      tone: 'semantic',
    },
    {
      german: "als Bürgerin/Bürger",
      translated: "citizens",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "in Germany",
      tone: 'semantic',
    },
    {
      german: "nicht direkt",
      translated: "NOT directly",
      tone: 'semantic',
    },
    {
      german: "wählen",
      translated: "elect",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:44|es": [
    {
      german: "Wen",
      translated: "A quién",
      tone: 'semantic',
    },
    {
      german: "kann man",
      translated: "puede",
      tone: 'semantic',
    },
    {
      german: "als Bürgerin/Bürger",
      translated: "un ciudadano",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "en Alemania",
      tone: 'semantic',
    },
    {
      german: "nicht direkt",
      translated: "NO",
      tone: 'semantic',
    },
    {
      german: "wählen",
      translated: "elegir",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:44|fa": [
    {
      german: "Wen",
      translated: "کدام مقام",
      tone: 'semantic',
    },
    {
      german: "als Bürgerin/Bürger",
      translated: "شهروندان",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "آلمان",
      tone: 'semantic',
    },
    {
      german: "nicht direkt",
      translated: "نمی‌توانند مستقیماً",
      tone: 'semantic',
    },
    {
      german: "wählen",
      translated: "انتخاب کنند",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:44|fr": [
    {
      german: "Wen",
      translated: "Qui",
      tone: 'semantic',
    },
    {
      german: "kann man",
      translated: "peuvent-ils",
      tone: 'semantic',
    },
    {
      german: "als Bürgerin/Bürger",
      translated: "les citoyens allemands",
      tone: 'semantic',
    },
    {
      german: "nicht direkt",
      translated: "directement",
      tone: 'semantic',
    },
    {
      german: "wählen",
      translated: "élire",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:44|hr": [
    {
      german: "Wen",
      translated: "Koju funkciju",
      tone: 'semantic',
    },
    {
      german: "kann man",
      translated: "mogu",
      tone: 'semantic',
    },
    {
      german: "als Bürgerin/Bürger",
      translated: "građani",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "njemački",
      tone: 'semantic',
    },
    {
      german: "nicht direkt",
      translated: "NE",
      tone: 'semantic',
    },
    {
      german: "wählen",
      translated: "birati",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:44|it": [
    {
      german: "Wen",
      translated: "Chi",
      tone: 'semantic',
    },
    {
      german: "kann man",
      translated: "può essere",
      tone: 'semantic',
    },
    {
      german: "als Bürgerin/Bürger",
      translated: "dai cittadini tedeschi",
      tone: 'semantic',
    },
    {
      german: "nicht direkt",
      translated: "NON",
      tone: 'semantic',
    },
    {
      german: "wählen",
      translated: "eletto",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:44|kmr": [
    {
      german: "Wen",
      translated: "Welatiyek",
      tone: 'semantic',
    },
    {
      german: "kann man",
      translated: "kî nikare",
      tone: 'semantic',
    },
    {
      german: "als Bürgerin/Bürger",
      translated: "li Almanyayê",
      tone: 'semantic',
    },
    {
      german: "nicht direkt",
      translated: "rasterast",
      tone: 'semantic',
    },
    {
      german: "wählen",
      translated: "hilbijêre?",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:44|pl": [
    {
      german: "Wen",
      translated: "Którego stanowiska",
      tone: 'semantic',
    },
    {
      german: "kann man",
      translated: "mogą",
      tone: 'semantic',
    },
    {
      german: "als Bürgerin/Bürger",
      translated: "obywatele",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "Niemiec",
      tone: 'semantic',
    },
    {
      german: "nicht direkt",
      translated: "NIE",
      tone: 'semantic',
    },
    {
      german: "wählen",
      translated: "wybrać bezpośrednio",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:44|prs": [
    {
      german: "Wen",
      translated: "کدام مقام",
      tone: 'semantic',
    },
    {
      german: "als Bürgerin/Bürger",
      translated: "شهروندان",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "آلمان",
      tone: 'semantic',
    },
    {
      german: "nicht direkt",
      translated: "نمی‌توانند مستقیماً",
      tone: 'semantic',
    },
    {
      german: "wählen",
      translated: "انتخاب کنند",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:44|ro": [
    {
      german: "Wen",
      translated: "Ce funcție",
      tone: 'semantic',
    },
    {
      german: "kann man",
      translated: "poate fi",
      tone: 'semantic',
    },
    {
      german: "als Bürgerin/Bürger",
      translated: "de cetățenii",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "germani",
      tone: 'semantic',
    },
    {
      german: "nicht direkt",
      translated: "NU",
      tone: 'semantic',
    },
    {
      german: "wählen",
      translated: "aleasă direct",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:44|ru": [
    {
      german: "Wen",
      translated: "Кого",
      tone: 'semantic',
    },
    {
      german: "kann man",
      translated: "может",
      tone: 'semantic',
    },
    {
      german: "als Bürgerin/Bürger",
      translated: "гражданин",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "Германии",
      tone: 'semantic',
    },
    {
      german: "nicht direkt",
      translated: "не",
      tone: 'semantic',
    },
    {
      german: "wählen",
      translated: "избрать",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:44|sq": [
    {
      german: "Wen",
      translated: "Kush",
      tone: 'semantic',
    },
    {
      german: "kann man",
      translated: "mund të",
      tone: 'semantic',
    },
    {
      german: "als Bürgerin/Bürger",
      translated: "nga qytetarët",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "gjermanë",
      tone: 'semantic',
    },
    {
      german: "nicht direkt",
      translated: "NUK",
      tone: 'semantic',
    },
    {
      german: "wählen",
      translated: "zgjidhet",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:44|sr": [
    {
      german: "Wen",
      translated: "Koju funkciju",
      tone: 'semantic',
    },
    {
      german: "kann man",
      translated: "mogu",
      tone: 'semantic',
    },
    {
      german: "als Bürgerin/Bürger",
      translated: "građani",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "nemački",
      tone: 'semantic',
    },
    {
      german: "nicht direkt",
      translated: "NE",
      tone: 'semantic',
    },
    {
      german: "wählen",
      translated: "birati",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:44|tr": [
    {
      german: "Wen",
      translated: "hangisini",
      tone: 'semantic',
    },
    {
      german: "als Bürgerin/Bürger",
      translated: "bir vatandaş",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "Almanya'da",
      tone: 'semantic',
    },
    {
      german: "nicht direkt",
      translated: "doğrudan",
      tone: 'semantic',
    },
    {
      german: "wählen",
      translated: "seçemez?",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:44|uk": [
    {
      german: "Wen",
      translated: "Кого",
      tone: 'semantic',
    },
    {
      german: "kann man",
      translated: "можуть",
      tone: 'semantic',
    },
    {
      german: "als Bürgerin/Bürger",
      translated: "громадяни",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "Німеччини",
      tone: 'semantic',
    },
    {
      german: "nicht direkt",
      translated: "безпосередньо",
      tone: 'semantic',
    },
    {
      german: "wählen",
      translated: "обирати",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:44|vi": [
    {
      german: "Wen",
      translated: "Ai",
      tone: 'semantic',
    },
    {
      german: "kann man",
      translated: "thể",
      tone: 'semantic',
    },
    {
      german: "als Bürgerin/Bürger",
      translated: "công dân",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "Đức",
      tone: 'semantic',
    },
    {
      german: "nicht direkt",
      translated: "trực tiếp",
      tone: 'semantic',
    },
    {
      german: "wählen",
      translated: "bầu",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:45|ar": [
    {
      german: "Zu welcher Versicherung",
      translated: "إلى أي نوع من التأمين",
      tone: 'semantic',
    },
    {
      german: "gehört",
      translated: "ينتمي",
      tone: 'semantic',
    },
    {
      german: "die Pflegeversicherung",
      translated: "تأمين الرعاية طويلة الأمد",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:45|bg": [
    {
      german: "gehört",
      translated: "принадлежи",
      tone: 'semantic',
    },
    {
      german: "die Pflegeversicherung",
      translated: "Осигуряването за дългосрочни грижи (Pflegeversicherung)",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:45|bs": [
    {
      german: "Zu welcher Versicherung",
      translated: "Kojoj vrsti osiguranja",
      tone: 'semantic',
    },
    {
      german: "gehört",
      translated: "pripada",
      tone: 'semantic',
    },
    {
      german: "die Pflegeversicherung",
      translated: "osiguranje za dugotrajnu njegu (Pflegeversicherung)",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:45|el": [
    {
      german: "Zu welcher Versicherung",
      translated: "Σε ποιο είδος ασφάλισης",
      tone: 'semantic',
    },
    {
      german: "gehört",
      translated: "ανήκει",
      tone: 'semantic',
    },
    {
      german: "die Pflegeversicherung",
      translated: "ασφάλιση μακροχρόνιας φροντίδας (Pflegeversicherung)",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:45|en": [
    {
      german: "Zu welcher Versicherung",
      translated: "To which type of insurance",
      tone: 'semantic',
    },
    {
      german: "gehört",
      translated: "does",
      tone: 'semantic',
    },
    {
      german: "die Pflegeversicherung",
      translated: "long-term care insurance",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:45|es": [
    {
      german: "Zu welcher Versicherung",
      translated: "¿A qué tipo de seguro",
      tone: 'semantic',
    },
    {
      german: "gehört",
      translated: "pertenece",
      tone: 'semantic',
    },
    {
      german: "die Pflegeversicherung",
      translated: "el seguro de cuidados de larga duración",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:45|fa": [
    {
      german: "Zu welcher Versicherung",
      translated: "بیمهٔ مراقبت و پرستاری (Pflegeversicherung",
      tone: 'semantic',
    },
    {
      german: "gehört",
      translated: "جزو",
      tone: 'semantic',
    },
    {
      german: "die Pflegeversicherung",
      translated: ")",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:45|fr": [
    {
      german: "Zu welcher Versicherung",
      translated: "À quel type d’assurance",
      tone: 'semantic',
    },
    {
      german: "gehört",
      translated: "appartient",
      tone: 'semantic',
    },
    {
      german: "die Pflegeversicherung",
      translated: "l’assurance dépendance (Pflegeversicherung)",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:45|hr": [
    {
      german: "Zu welcher Versicherung",
      translated: "Kojoj vrsti osiguranja",
      tone: 'semantic',
    },
    {
      german: "gehört",
      translated: "pripada",
      tone: 'semantic',
    },
    {
      german: "die Pflegeversicherung",
      translated: "osiguranje za dugotrajnu njegu (Pflegeversicherung)",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:45|it": [
    {
      german: "Zu welcher Versicherung",
      translated: "A quale tipo di assicurazione",
      tone: 'semantic',
    },
    {
      german: "gehört",
      translated: "appartiene",
      tone: 'semantic',
    },
    {
      german: "die Pflegeversicherung",
      translated: "l’assicurazione per l’assistenza a lungo termine (Pflegeversicherung)",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:45|kmr": [
    {
      german: "Zu welcher Versicherung",
      translated: "ji kîjan cure bîmeyê",
      tone: 'semantic',
    },
    {
      german: "gehört",
      translated: "ye",
      tone: 'semantic',
    },
    {
      german: "die Pflegeversicherung",
      translated: "Bîmeya lênêrînê (Pflegeversicherung)",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:45|pl": [
    {
      german: "Zu welcher Versicherung",
      translated: "Do jakiego rodzaju ubezpieczenia",
      tone: 'semantic',
    },
    {
      german: "gehört",
      translated: "należy",
      tone: 'semantic',
    },
    {
      german: "die Pflegeversicherung",
      translated: "ubezpieczenie pielęgnacyjne (Pflegeversicherung)",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:45|prs": [
    {
      german: "Zu welcher Versicherung",
      translated: "کدام نوع بیمه",
      tone: 'semantic',
    },
    {
      german: "gehört",
      translated: "جزو",
      tone: 'semantic',
    },
    {
      german: "die Pflegeversicherung",
      translated: "بیمهٔ مراقبت و پرستاری (Pflegeversicherung)",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:45|ro": [
    {
      german: "Zu welcher Versicherung",
      translated: "Asigurarea de îngrijire",
      tone: 'semantic',
    },
    {
      german: "gehört",
      translated: "aparține",
      tone: 'semantic',
    },
    {
      german: "die Pflegeversicherung",
      translated: "Pflegeversicherung",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:45|ru": [
    {
      german: "Zu welcher Versicherung",
      translated: "К какому виду страхования",
      tone: 'semantic',
    },
    {
      german: "gehört",
      translated: "относится",
      tone: 'semantic',
    },
    {
      german: "die Pflegeversicherung",
      translated: "страхование по уходу",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:45|sq": [
    {
      german: "Zu welcher Versicherung",
      translated: "Në cilin lloj sigurimi",
      tone: 'semantic',
    },
    {
      german: "gehört",
      translated: "bën pjesë",
      tone: 'semantic',
    },
    {
      german: "die Pflegeversicherung",
      translated: "sigurimi i kujdesit afatgjatë (Pflegeversicherung)",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:45|sr": [
    {
      german: "Zu welcher Versicherung",
      translated: "Kojoj vrsti osiguranja",
      tone: 'semantic',
    },
    {
      german: "gehört",
      translated: "pripada",
      tone: 'semantic',
    },
    {
      german: "die Pflegeversicherung",
      translated: "osiguranje za dugotrajnu njegu (Pflegeversicherung)",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:45|tr": [
    {
      german: "Zu welcher Versicherung",
      translated: "hangi sigorta sisteminin",
      tone: 'semantic',
    },
    {
      german: "gehört",
      translated: "parçasıdır",
      tone: 'semantic',
    },
    {
      german: "die Pflegeversicherung",
      translated: "Bakım sigortası (Pflegeversicherung)",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:45|uk": [
    {
      german: "Zu welcher Versicherung",
      translated: "До якого виду страхування",
      tone: 'semantic',
    },
    {
      german: "gehört",
      translated: "належить",
      tone: 'semantic',
    },
    {
      german: "die Pflegeversicherung",
      translated: "страхування на випадок потреби в догляді (Pflegeversicherung)",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:45|vi": [
    {
      german: "Zu welcher Versicherung",
      translated: "loại bảo hiểm nào?",
      tone: 'semantic',
    },
    {
      german: "gehört",
      translated: "thuộc",
      tone: 'semantic',
    },
    {
      german: "die Pflegeversicherung",
      translated: "Bảo hiểm chăm sóc dài hạn (Pflegeversicherung)",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:46|ar": [
    {
      german: "Der deutsche Staat",
      translated: "للدولة الألمانية",
      tone: 'semantic',
    },
    {
      german: "hat viele Aufgaben",
      translated: "مهام كثيرة",
      tone: 'semantic',
    },
    {
      german: "Welche Aufgabe",
      translated: "أي مهمة",
      tone: 'semantic',
    },
    {
      german: "gehört dazu",
      translated: "من التالية تقع ضمن مهامها؟",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:46|bg": [
    {
      german: "Der deutsche Staat",
      translated: "Германската държава",
      tone: 'semantic',
    },
    {
      german: "hat viele Aufgaben",
      translated: "има много задачи",
      tone: 'semantic',
    },
    {
      german: "Welche Aufgabe",
      translated: "Коя",
      tone: 'semantic',
    },
    {
      german: "gehört dazu",
      translated: "е една от тях",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:46|bs": [
    {
      german: "Der deutsche Staat",
      translated: "Njemačka država",
      tone: 'semantic',
    },
    {
      german: "hat viele Aufgaben",
      translated: "ima mnogo zadaća",
      tone: 'semantic',
    },
    {
      german: "Welche Aufgabe",
      translated: "Koja je od navedenih",
      tone: 'semantic',
    },
    {
      german: "gehört dazu",
      translated: "jedna od njih",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:46|el": [
    {
      german: "Der deutsche Staat",
      translated: "Το γερμανικό κράτος",
      tone: 'semantic',
    },
    {
      german: "hat viele Aufgaben",
      translated: "έχει πολλά καθήκοντα",
      tone: 'semantic',
    },
    {
      german: "Welche Aufgabe",
      translated: "Ποιο είναι ένα από αυτά",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:46|en": [
    {
      german: "Der deutsche Staat",
      translated: "The German state",
      tone: 'semantic',
    },
    {
      german: "hat viele Aufgaben",
      translated: "has many tasks",
      tone: 'semantic',
    },
    {
      german: "Welche Aufgabe",
      translated: "Which task",
      tone: 'semantic',
    },
    {
      german: "gehört dazu",
      translated: "is included",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:46|es": [
    {
      german: "Der deutsche Staat",
      translated: "El Estado alemán",
      tone: 'semantic',
    },
    {
      german: "hat viele Aufgaben",
      translated: "tiene muchas tareas",
      tone: 'semantic',
    },
    {
      german: "Welche Aufgabe",
      translated: "¿Cuál de las siguientes",
      tone: 'semantic',
    },
    {
      german: "gehört dazu",
      translated: "es una de ellas",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:46|fa": [
    {
      german: "Der deutsche Staat",
      translated: "دولت آلمان",
      tone: 'semantic',
    },
    {
      german: "hat viele Aufgaben",
      translated: "وظایف زیادی دارد",
      tone: 'semantic',
    },
    {
      german: "Welche Aufgabe",
      translated: "کدام مورد",
      tone: 'semantic',
    },
    {
      german: "gehört dazu",
      translated: "یکی از وظایف دولت است؟",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:46|fr": [
    {
      german: "Der deutsche Staat",
      translated: "L’État allemand",
      tone: 'semantic',
    },
    {
      german: "hat viele Aufgaben",
      translated: "a de nombreuses missions",
      tone: 'semantic',
    },
    {
      german: "Welche Aufgabe",
      translated: "Laquelle des tâches",
      tone: 'semantic',
    },
    {
      german: "gehört dazu",
      translated: "en fait partie ?",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:46|hr": [
    {
      german: "Der deutsche Staat",
      translated: "Njemačka država",
      tone: 'semantic',
    },
    {
      german: "hat viele Aufgaben",
      translated: "ima mnogo zadaća",
      tone: 'semantic',
    },
    {
      german: "Welche Aufgabe",
      translated: "Koja je od navedenih",
      tone: 'semantic',
    },
    {
      german: "gehört dazu",
      translated: "jedna od njih",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:46|it": [
    {
      german: "Der deutsche Staat",
      translated: "Lo Stato tedesco",
      tone: 'semantic',
    },
    {
      german: "hat viele Aufgaben",
      translated: "ha molti compiti",
      tone: 'semantic',
    },
    {
      german: "Welche Aufgabe",
      translated: "Quale dei seguenti",
      tone: 'semantic',
    },
    {
      german: "gehört dazu",
      translated: "è uno di essi",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:46|kmr": [
    {
      german: "Der deutsche Staat",
      translated: "Dewleta Alman",
      tone: 'semantic',
    },
    {
      german: "hat viele Aufgaben",
      translated: "gelek erk hene",
      tone: 'semantic',
    },
    {
      german: "Welche Aufgabe",
      translated: "Kîjan ji van erka",
      tone: 'semantic',
    },
    {
      german: "gehört dazu",
      translated: "wê ye",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:46|pl": [
    {
      german: "Der deutsche Staat",
      translated: "Państwo niemieckie",
      tone: 'semantic',
    },
    {
      german: "hat viele Aufgaben",
      translated: "ma wiele zadań",
      tone: 'semantic',
    },
    {
      german: "Welche Aufgabe",
      translated: "Które z poniższych",
      tone: 'semantic',
    },
    {
      german: "gehört dazu",
      translated: "jest jednym z nich",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:46|prs": [
    {
      german: "Der deutsche Staat",
      translated: "دولت آلمان",
      tone: 'semantic',
    },
    {
      german: "hat viele Aufgaben",
      translated: "وظایف زیادی دارد",
      tone: 'semantic',
    },
    {
      german: "Welche Aufgabe",
      translated: "کدام مورد",
      tone: 'semantic',
    },
    {
      german: "gehört dazu",
      translated: "یکی از وظایف دولت است",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:46|ro": [
    {
      german: "Der deutsche Staat",
      translated: "Statul german",
      tone: 'semantic',
    },
    {
      german: "hat viele Aufgaben",
      translated: "are multe atribuții",
      tone: 'semantic',
    },
    {
      german: "Welche Aufgabe",
      translated: "Care",
      tone: 'semantic',
    },
    {
      german: "gehört dazu",
      translated: "este una dintre ele",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:46|ru": [
    {
      german: "Der deutsche Staat",
      translated: "У немецкого государства",
      tone: 'semantic',
    },
    {
      german: "hat viele Aufgaben",
      translated: "много задач",
      tone: 'semantic',
    },
    {
      german: "Welche Aufgabe",
      translated: "Какая из них",
      tone: 'semantic',
    },
    {
      german: "gehört dazu",
      translated: "относится к их числу",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:46|sq": [
    {
      german: "Der deutsche Staat",
      translated: "Shteti gjerman",
      tone: 'semantic',
    },
    {
      german: "hat viele Aufgaben",
      translated: "ka shumë detyra",
      tone: 'semantic',
    },
    {
      german: "Welche Aufgabe",
      translated: "Cila nga këto është një",
      tone: 'semantic',
    },
    {
      german: "gehört dazu",
      translated: "prej tyre",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:46|sr": [
    {
      german: "Der deutsche Staat",
      translated: "Nemačka država",
      tone: 'semantic',
    },
    {
      german: "hat viele Aufgaben",
      translated: "ima mnogo zadaća",
      tone: 'semantic',
    },
    {
      german: "Welche Aufgabe",
      translated: "Koja je od navedenih",
      tone: 'semantic',
    },
    {
      german: "gehört dazu",
      translated: "jedna od njih?",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:46|tr": [
    {
      german: "Der deutsche Staat",
      translated: "Alman devletinin",
      tone: 'semantic',
    },
    {
      german: "hat viele Aufgaben",
      translated: "birçok görevi vardır",
      tone: 'semantic',
    },
    {
      german: "Welche Aufgabe",
      translated: "hangisi",
      tone: 'semantic',
    },
    {
      german: "gehört dazu",
      translated: "bunlardan biridir",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:46|uk": [
    {
      german: "Der deutsche Staat",
      translated: "Німецька держава",
      tone: 'semantic',
    },
    {
      german: "hat viele Aufgaben",
      translated: "має багато завдань",
      tone: 'semantic',
    },
    {
      german: "Welche Aufgabe",
      translated: "Яке з наведених завдань",
      tone: 'semantic',
    },
    {
      german: "gehört dazu",
      translated: "належить до її обов’язків",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:46|vi": [
    {
      german: "Der deutsche Staat",
      translated: "Nhà nước Đức",
      tone: 'semantic',
    },
    {
      german: "hat viele Aufgaben",
      translated: "có nhiều nhiệm vụ",
      tone: 'semantic',
    },
    {
      german: "Welche Aufgabe",
      translated: "Điều nào",
      tone: 'semantic',
    },
    {
      german: "gehört dazu",
      translated: "là một nhiệm vụ của nhà nước",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:47|ar": [
    {
      german: "Der deutsche Staat",
      translated: "للدولة الألمانية",
      tone: 'semantic',
    },
    {
      german: "hat viele Aufgaben",
      translated: "مهام كثيرة",
      tone: 'semantic',
    },
    {
      german: "Welche Aufgabe",
      translated: "أي مهمة",
      tone: 'semantic',
    },
    {
      german: "gehört nicht dazu",
      translated: "لا تقع ضمن مهامها",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:47|bg": [
    {
      german: "Der deutsche Staat",
      translated: "Германската държава",
      tone: 'semantic',
    },
    {
      german: "hat viele Aufgaben",
      translated: "има много задачи",
      tone: 'semantic',
    },
    {
      german: "Welche Aufgabe",
      translated: "Коя",
      tone: 'semantic',
    },
    {
      german: "gehört nicht dazu",
      translated: "НЕ е една от тях",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:47|bs": [
    {
      german: "Der deutsche Staat",
      translated: "Njemačka država",
      tone: 'semantic',
    },
    {
      german: "hat viele Aufgaben",
      translated: "ima mnogo zadaća",
      tone: 'semantic',
    },
    {
      german: "Welche Aufgabe",
      translated: "Što od navedenoga",
      tone: 'semantic',
    },
    {
      german: "gehört nicht dazu",
      translated: "NIJE njezina zadaća",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:47|el": [
    {
      german: "Der deutsche Staat",
      translated: "Το γερμανικό κράτος",
      tone: 'semantic',
    },
    {
      german: "hat viele Aufgaben",
      translated: "έχει πολλά καθήκοντα",
      tone: 'semantic',
    },
    {
      german: "Welche Aufgabe",
      translated: "Ποιο",
      tone: 'semantic',
    },
    {
      german: "gehört nicht dazu",
      translated: "ΔΕΝ είναι ένα από αυτά",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:47|en": [
    {
      german: "Der deutsche Staat",
      translated: "The German state",
      tone: 'semantic',
    },
    {
      german: "hat viele Aufgaben",
      translated: "has many tasks",
      tone: 'semantic',
    },
    {
      german: "Welche Aufgabe",
      translated: "Which task",
      tone: 'semantic',
    },
    {
      german: "gehört nicht dazu",
      translated: "is NOT included",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:47|es": [
    {
      german: "Der deutsche Staat",
      translated: "El Estado alemán",
      tone: 'semantic',
    },
    {
      german: "hat viele Aufgaben",
      translated: "tiene muchas tareas",
      tone: 'semantic',
    },
    {
      german: "Welche Aufgabe",
      translated: "¿Cuál de las siguientes",
      tone: 'semantic',
    },
    {
      german: "gehört nicht dazu",
      translated: "NO es una de ellas",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:47|fa": [
    {
      german: "Der deutsche Staat",
      translated: "دولت آلمان",
      tone: 'semantic',
    },
    {
      german: "hat viele Aufgaben",
      translated: "وظایف زیادی دارد",
      tone: 'semantic',
    },
    {
      german: "Welche Aufgabe",
      translated: "کدام مورد وظیفهٔ",
      tone: 'semantic',
    },
    {
      german: "gehört nicht dazu",
      translated: "نیست؟",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:47|fr": [
    {
      german: "Der deutsche Staat",
      translated: "L’État allemand",
      tone: 'semantic',
    },
    {
      german: "hat viele Aufgaben",
      translated: "a de nombreuses missions",
      tone: 'semantic',
    },
    {
      german: "Welche Aufgabe",
      translated: "Laquelle des tâches",
      tone: 'semantic',
    },
    {
      german: "gehört nicht dazu",
      translated: "n’en fait pas partie",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:47|hr": [
    {
      german: "Der deutsche Staat",
      translated: "Njemačka država",
      tone: 'semantic',
    },
    {
      german: "hat viele Aufgaben",
      translated: "ima mnogo zadaća",
      tone: 'semantic',
    },
    {
      german: "Welche Aufgabe",
      translated: "Što od navedenoga",
      tone: 'semantic',
    },
    {
      german: "gehört nicht dazu",
      translated: "NIJE njezina zadaća",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:47|it": [
    {
      german: "Der deutsche Staat",
      translated: "Lo Stato tedesco",
      tone: 'semantic',
    },
    {
      german: "hat viele Aufgaben",
      translated: "ha molti compiti",
      tone: 'semantic',
    },
    {
      german: "Welche Aufgabe",
      translated: "Quale dei seguenti",
      tone: 'semantic',
    },
    {
      german: "gehört nicht dazu",
      translated: "NON è uno di essi",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:47|kmr": [
    {
      german: "Der deutsche Staat",
      translated: "Dewleta Alman",
      tone: 'semantic',
    },
    {
      german: "hat viele Aufgaben",
      translated: "gelek erk hene",
      tone: 'semantic',
    },
    {
      german: "Welche Aufgabe",
      translated: "Kîjan ji van",
      tone: 'semantic',
    },
    {
      german: "gehört nicht dazu",
      translated: "ne erka wê ye",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:47|pl": [
    {
      german: "Der deutsche Staat",
      translated: "Państwo niemieckie",
      tone: 'semantic',
    },
    {
      german: "hat viele Aufgaben",
      translated: "ma wiele zadań",
      tone: 'semantic',
    },
    {
      german: "Welche Aufgabe",
      translated: "Które z poniższych",
      tone: 'semantic',
    },
    {
      german: "gehört nicht dazu",
      translated: "NIE jest jego zadaniem",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:47|prs": [
    {
      german: "Der deutsche Staat",
      translated: "دولت آلمان",
      tone: 'semantic',
    },
    {
      german: "hat viele Aufgaben",
      translated: "وظایف زیادی دارد",
      tone: 'semantic',
    },
    {
      german: "Welche Aufgabe",
      translated: "کدام مورد وظیفهٔ",
      tone: 'semantic',
    },
    {
      german: "gehört nicht dazu",
      translated: "نیست",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:47|ro": [
    {
      german: "Der deutsche Staat",
      translated: "Statul german",
      tone: 'semantic',
    },
    {
      german: "hat viele Aufgaben",
      translated: "are multe atribuții",
      tone: 'semantic',
    },
    {
      german: "Welche Aufgabe",
      translated: "Care",
      tone: 'semantic',
    },
    {
      german: "gehört nicht dazu",
      translated: "NU este una dintre ele",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:47|ru": [
    {
      german: "Der deutsche Staat",
      translated: "У немецкого государства",
      tone: 'semantic',
    },
    {
      german: "hat viele Aufgaben",
      translated: "много задач",
      tone: 'semantic',
    },
    {
      german: "Welche Aufgabe",
      translated: "Какая из них",
      tone: 'semantic',
    },
    {
      german: "gehört nicht dazu",
      translated: "к их числу не относится",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:47|sq": [
    {
      german: "Der deutsche Staat",
      translated: "Shteti gjerman",
      tone: 'semantic',
    },
    {
      german: "hat viele Aufgaben",
      translated: "ka shumë detyra",
      tone: 'semantic',
    },
    {
      german: "Welche Aufgabe",
      translated: "Cila nga këto",
      tone: 'semantic',
    },
    {
      german: "gehört nicht dazu",
      translated: "NUK është detyrë e tij",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:47|sr": [
    {
      german: "Der deutsche Staat",
      translated: "Nemačka država",
      tone: 'semantic',
    },
    {
      german: "hat viele Aufgaben",
      translated: "ima mnogo zadaća",
      tone: 'semantic',
    },
    {
      german: "Welche Aufgabe",
      translated: "Šta od navedenoga",
      tone: 'semantic',
    },
    {
      german: "gehört nicht dazu",
      translated: "NIJE njezina zadaća",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:47|tr": [
    {
      german: "Der deutsche Staat",
      translated: "Alman devletinin",
      tone: 'semantic',
    },
    {
      german: "hat viele Aufgaben",
      translated: "birçok görevi vardır",
      tone: 'semantic',
    },
    {
      german: "Welche Aufgabe",
      translated: "Aşağıdakilerden hangisi",
      tone: 'semantic',
    },
    {
      german: "gehört nicht dazu",
      translated: "bunlardan biri değildir",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:47|uk": [
    {
      german: "Der deutsche Staat",
      translated: "Німецька держава",
      tone: 'semantic',
    },
    {
      german: "hat viele Aufgaben",
      translated: "має багато завдань",
      tone: 'semantic',
    },
    {
      german: "Welche Aufgabe",
      translated: "Яке з наведених завдань",
      tone: 'semantic',
    },
    {
      german: "gehört nicht dazu",
      translated: "не належить до її обов’язків",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:47|vi": [
    {
      german: "Der deutsche Staat",
      translated: "Nhà nước Đức",
      tone: 'semantic',
    },
    {
      german: "hat viele Aufgaben",
      translated: "có nhiều nhiệm vụ",
      tone: 'semantic',
    },
    {
      german: "Welche Aufgabe",
      translated: "Điều nào sau đây",
      tone: 'semantic',
    },
    {
      german: "gehört nicht dazu",
      translated: "KHÔNG phải là nhiệm vụ của nhà nước",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:48|ar": [
    {
      german: "Welches Organ",
      translated: "أي هيئة",
      tone: 'semantic',
    },
    {
      german: "gehört nicht",
      translated: "لا تُعد",
      tone: 'semantic',
    },
    {
      german: "zu den Verfassungsorganen",
      translated: "من الهيئات الدستورية",
      tone: 'semantic',
    },
    {
      german: "Deutschlands",
      translated: "في ألمانيا؟",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:48|bg": [
    {
      german: "Welches Organ",
      translated: "Кое",
      tone: 'semantic',
    },
    {
      german: "gehört nicht",
      translated: " НЕ",
      tone: 'semantic',
    },
    {
      german: "zu den Verfassungsorganen",
      translated: " конституционен орган",
      tone: 'semantic',
    },
    {
      german: "Deutschlands",
      translated: " на Германия",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:48|bs": [
    {
      german: "Welches Organ",
      translated: "Što od navedenoga",
      tone: 'semantic',
    },
    {
      german: "gehört nicht",
      translated: "NIJE",
      tone: 'semantic',
    },
    {
      german: "zu den Verfassungsorganen",
      translated: "ustavni organ",
      tone: 'semantic',
    },
    {
      german: "Deutschlands",
      translated: "Njemačke",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:48|el": [
    {
      german: "Welches Organ",
      translated: "Ποιο",
      tone: 'semantic',
    },
    {
      german: "gehört nicht",
      translated: "ΔΕΝ",
      tone: 'semantic',
    },
    {
      german: "zu den Verfassungsorganen",
      translated: "συνταγματικό όργανο",
      tone: 'semantic',
    },
    {
      german: "Deutschlands",
      translated: "της Γερμανίας;",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:48|en": [
    {
      german: "Welches Organ",
      translated: "Which body",
      tone: 'semantic',
    },
    {
      german: "gehört nicht",
      translated: "is NOT one of",
      tone: 'semantic',
    },
    {
      german: "zu den Verfassungsorganen",
      translated: "constitutional organs",
      tone: 'semantic',
    },
    {
      german: "Deutschlands",
      translated: "Germany's",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:48|es": [
    {
      german: "Welches Organ",
      translated: "¿Qué órgano",
      tone: 'semantic',
    },
    {
      german: "gehört nicht",
      translated: "NO pertenece",
      tone: 'semantic',
    },
    {
      german: "zu den Verfassungsorganen",
      translated: "a los órganos constitucionales",
      tone: 'semantic',
    },
    {
      german: "Deutschlands",
      translated: "de Alemania",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:48|fa": [
    {
      german: "Welches Organ",
      translated: "کدام مورد",
      tone: 'semantic',
    },
    {
      german: "gehört nicht",
      translated: "نیست",
      tone: 'semantic',
    },
    {
      german: "zu den Verfassungsorganen",
      translated: "نهادهای قانون اساسی",
      tone: 'semantic',
    },
    {
      german: "Deutschlands",
      translated: "آلمان",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:48|fr": [
    {
      german: "Welches Organ",
      translated: "Quel organe",
      tone: 'semantic',
    },
    {
      german: "gehört nicht",
      translated: "ne fait pas partie",
      tone: 'semantic',
    },
    {
      german: "zu den Verfassungsorganen",
      translated: "des organes constitutionnels",
      tone: 'semantic',
    },
    {
      german: "Deutschlands",
      translated: "allemands",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:48|hr": [
    {
      german: "Welches Organ",
      translated: "Što od navedenoga",
      tone: 'semantic',
    },
    {
      german: "gehört nicht",
      translated: "NIJE",
      tone: 'semantic',
    },
    {
      german: "zu den Verfassungsorganen",
      translated: "ustavni organ",
      tone: 'semantic',
    },
    {
      german: "Deutschlands",
      translated: "Njemačke",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:48|it": [
    {
      german: "Welches Organ",
      translated: "Quale",
      tone: 'semantic',
    },
    {
      german: "gehört nicht",
      translated: "NON è un",
      tone: 'semantic',
    },
    {
      german: "zu den Verfassungsorganen",
      translated: "organo costituzionale della",
      tone: 'semantic',
    },
    {
      german: "Deutschlands",
      translated: "Germania",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:48|kmr": [
    {
      german: "Welches Organ",
      translated: "Kîjan organ",
      tone: 'semantic',
    },
    {
      german: "gehört nicht",
      translated: "ne",
      tone: 'semantic',
    },
    {
      german: "zu den Verfassungsorganen",
      translated: "organek destûrî ya Almanyayê",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:48|pl": [
    {
      german: "Welches Organ",
      translated: "Który",
      tone: 'semantic',
    },
    {
      german: "gehört nicht",
      translated: "NIE jest",
      tone: 'semantic',
    },
    {
      german: "zu den Verfassungsorganen",
      translated: "organem konstytucyjnym",
      tone: 'semantic',
    },
    {
      german: "Deutschlands",
      translated: "Niemiec?",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:48|prs": [
    {
      german: "Welches Organ",
      translated: "کدام مورد از",
      tone: 'semantic',
    },
    {
      german: "gehört nicht",
      translated: "نیست",
      tone: 'semantic',
    },
    {
      german: "zu den Verfassungsorganen",
      translated: "نهادهای قانون اساسی",
      tone: 'semantic',
    },
    {
      german: "Deutschlands",
      translated: "آلمان",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:48|ro": [
    {
      german: "Welches Organ",
      translated: "Care",
      tone: 'semantic',
    },
    {
      german: "gehört nicht",
      translated: "NU este",
      tone: 'semantic',
    },
    {
      german: "zu den Verfassungsorganen",
      translated: "un organ constituțional",
      tone: 'semantic',
    },
    {
      german: "Deutschlands",
      translated: "al Germaniei",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:48|ru": [
    {
      german: "Welches Organ",
      translated: "Какой орган",
      tone: 'semantic',
    },
    {
      german: "gehört nicht",
      translated: "не относится",
      tone: 'semantic',
    },
    {
      german: "zu den Verfassungsorganen",
      translated: "к конституционным органам",
      tone: 'semantic',
    },
    {
      german: "Deutschlands",
      translated: "Германии",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:48|sq": [
    {
      german: "Welches Organ",
      translated: "Cila",
      tone: 'semantic',
    },
    {
      german: "gehört nicht",
      translated: "NUK",
      tone: 'semantic',
    },
    {
      german: "zu den Verfassungsorganen",
      translated: "organ kushtetues",
      tone: 'semantic',
    },
    {
      german: "Deutschlands",
      translated: "i Gjermanisë",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:48|sr": [
    {
      german: "Welches Organ",
      translated: "Šta",
      tone: 'semantic',
    },
    {
      german: "gehört nicht",
      translated: "NIJE",
      tone: 'semantic',
    },
    {
      german: "zu den Verfassungsorganen",
      translated: "ustavni organ",
      tone: 'semantic',
    },
    {
      german: "Deutschlands",
      translated: "Nemačke",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:48|tr": [
    {
      german: "Welches Organ",
      translated: "hangisi",
      tone: 'semantic',
    },
    {
      german: "gehört nicht",
      translated: "değildir",
      tone: 'semantic',
    },
    {
      german: "zu den Verfassungsorganen",
      translated: "anayasal devlet organlarından",
      tone: 'semantic',
    },
    {
      german: "Deutschlands",
      translated: "Almanya'nın",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:48|uk": [
    {
      german: "Welches Organ",
      translated: "Який орган",
      tone: 'semantic',
    },
    {
      german: "gehört nicht",
      translated: "не належить",
      tone: 'semantic',
    },
    {
      german: "zu den Verfassungsorganen",
      translated: "до конституційних органів",
      tone: 'semantic',
    },
    {
      german: "Deutschlands",
      translated: "Німеччини",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:48|vi": [
    {
      german: "Welches Organ",
      translated: "Điều nào sau đây",
      tone: 'semantic',
    },
    {
      german: "gehört nicht",
      translated: "KHÔNG phải là",
      tone: 'semantic',
    },
    {
      german: "zu den Verfassungsorganen",
      translated: "một cơ quan hiến định",
      tone: 'semantic',
    },
    {
      german: "Deutschlands",
      translated: "Đức",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:49|ar": [
    {
      german: "Wer bestimmt",
      translated: "من يحدد",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "في ألمانيا",
      tone: 'semantic',
    },
    {
      german: "die Schulpolitik",
      translated: "سياسة التعليم المدرسي",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:49|bg": [
    {
      german: "Wer bestimmt",
      translated: "Кой определя",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "в Германия",
      tone: 'semantic',
    },
    {
      german: "die Schulpolitik",
      translated: "образователната политика за училищата",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:49|bs": [
    {
      german: "Wer bestimmt",
      translated: "Tko određuje",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "u Njemačkoj",
      tone: 'semantic',
    },
    {
      german: "die Schulpolitik",
      translated: "obrazovnu politiku škola",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:49|el": [
    {
      german: "Wer bestimmt",
      translated: "Ποιος αποφασίζει",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "στη Γερμανία",
      tone: 'semantic',
    },
    {
      german: "die Schulpolitik",
      translated: "των σχολείων",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:49|en": [
    {
      german: "Wer bestimmt",
      translated: "Who determines",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "in Germany",
      tone: 'semantic',
    },
    {
      german: "die Schulpolitik",
      translated: "education policy",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:49|es": [
    {
      german: "Wer bestimmt",
      translated: "¿Quién determina",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "en Alemania",
      tone: 'semantic',
    },
    {
      german: "die Schulpolitik",
      translated: "la política escolar",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:49|fa": [
    {
      german: "Wer bestimmt",
      translated: "چه کسی",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "در آلمان",
      tone: 'semantic',
    },
    {
      german: "die Schulpolitik",
      translated: "سیاست آموزشی مدارس",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:49|fr": [
    {
      german: "Wer bestimmt",
      translated: "Qui détermine",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "en Allemagne",
      tone: 'semantic',
    },
    {
      german: "die Schulpolitik",
      translated: "la politique scolaire",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:49|hr": [
    {
      german: "Wer bestimmt",
      translated: "Tko određuje",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "u Njemačkoj",
      tone: 'semantic',
    },
    {
      german: "die Schulpolitik",
      translated: "obrazovnu politiku škola",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:49|it": [
    {
      german: "Wer bestimmt",
      translated: "Chi stabilisce",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "in Germania",
      tone: 'semantic',
    },
    {
      german: "die Schulpolitik",
      translated: "la politica scolastica",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:49|kmr": [
    {
      german: "Wer bestimmt",
      translated: "kî",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "Li Almanyayê",
      tone: 'semantic',
    },
    {
      german: "die Schulpolitik",
      translated: "siyaseta dibistanê",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:49|pl": [
    {
      german: "Wer bestimmt",
      translated: "Kto",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "w Niemczech",
      tone: 'semantic',
    },
    {
      german: "die Schulpolitik",
      translated: "politykę edukacyjną szkół",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:49|prs": [
    {
      german: "Wer bestimmt",
      translated: "چه کسی",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "در آلمان",
      tone: 'semantic',
    },
    {
      german: "die Schulpolitik",
      translated: "سیاست آموزشی مکاتب",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:49|ro": [
    {
      german: "Wer bestimmt",
      translated: "Cine decide",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "în Germania",
      tone: 'semantic',
    },
    {
      german: "die Schulpolitik",
      translated: "politica educațională pentru școli",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:49|ru": [
    {
      german: "Wer bestimmt",
      translated: "Кто определяет",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "в Германии",
      tone: 'semantic',
    },
    {
      german: "die Schulpolitik",
      translated: "школьную политику",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:49|sq": [
    {
      german: "Wer bestimmt",
      translated: "Kush e përcakton",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "në Gjermani",
      tone: 'semantic',
    },
    {
      german: "die Schulpolitik",
      translated: "politikën shkollore",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:49|sr": [
    {
      german: "Wer bestimmt",
      translated: "Ko određuje",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "Nemačkoj",
      tone: 'semantic',
    },
    {
      german: "die Schulpolitik",
      translated: "obrazovnu politiku škola",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:49|tr": [
    {
      german: "Wer bestimmt",
      translated: "kim belirler",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "Almanya'da",
      tone: 'semantic',
    },
    {
      german: "die Schulpolitik",
      translated: "okul politikasını",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:49|uk": [
    {
      german: "Wer bestimmt",
      translated: "Хто визначає",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "в Німеччині",
      tone: 'semantic',
    },
    {
      german: "die Schulpolitik",
      translated: "шкільну політику",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:49|vi": [
    {
      german: "Wer bestimmt",
      translated: "Ai quyết định",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "ở Đức",
      tone: 'semantic',
    },
    {
      german: "die Schulpolitik",
      translated: "chính sách giáo dục phổ thông",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:4|ar": [
    {
      german: "Welches Recht",
      translated: "أي حق",
      tone: 'semantic',
    },
    {
      german: "gehört zu",
      translated: "يُعد",
      tone: 'semantic',
    },
    {
      german: "den Grundrechten",
      translated: "من الحقوق الأساسية",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "في ألمانيا",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:4|bg": [
    {
      german: "Welches Recht",
      translated: "Кое от следните",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "в Германия",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:4|bs": [
    {
      german: "Welches Recht",
      translated: "Što je od navedenoga",
      tone: 'semantic',
    },
    {
      german: "den Grundrechten",
      translated: "temeljno pravo",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "u Njemačkoj",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:4|el": [
    {
      german: "Welches Recht",
      translated: "Ποιο",
      tone: 'semantic',
    },
    {
      german: "gehört zu",
      translated: "είναι",
      tone: 'semantic',
    },
    {
      german: "den Grundrechten",
      translated: "θεμελιώδες δικαίωμα",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "στη Γερμανία",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:4|en": [
    {
      german: "Welches Recht",
      translated: "Which right",
      tone: 'semantic',
    },
    {
      german: "gehört zu",
      translated: "is one of",
      tone: 'semantic',
    },
    {
      german: "den Grundrechten",
      translated: "the fundamental rights",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "in Germany",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:4|es": [
    {
      german: "Welches Recht",
      translated: "¿Qué derecho",
      tone: 'semantic',
    },
    {
      german: "gehört zu",
      translated: "forma parte de",
      tone: 'semantic',
    },
    {
      german: "den Grundrechten",
      translated: "los derechos fundamentales",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "en Alemania",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:4|fa": [
    {
      german: "Welches Recht",
      translated: "کدام حق",
      tone: 'semantic',
    },
    {
      german: "gehört zu",
      translated: "جزو",
      tone: 'semantic',
    },
    {
      german: "den Grundrechten",
      translated: "حقوق اساسی",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "در آلمان",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:4|fr": [
    {
      german: "Welches Recht",
      translated: "Quel droit",
      tone: 'semantic',
    },
    {
      german: "gehört zu",
      translated: "fait partie des",
      tone: 'semantic',
    },
    {
      german: "den Grundrechten",
      translated: "droits fondamentaux",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "en Allemagne",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:4|hr": [
    {
      german: "Welches Recht",
      translated: "Što je",
      tone: 'semantic',
    },
    {
      german: "gehört zu",
      translated: "od navedenoga",
      tone: 'semantic',
    },
    {
      german: "den Grundrechten",
      translated: "temeljno pravo",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "u Njemačkoj",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:4|it": [
    {
      german: "Welches Recht",
      translated: "Quale",
      tone: 'semantic',
    },
    {
      german: "gehört zu",
      translated: "è",
      tone: 'semantic',
    },
    {
      german: "den Grundrechten",
      translated: "un diritto fondamentale",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "in Germania",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:4|kmr": [
    {
      german: "Welches Recht",
      translated: "Kîjan",
      tone: 'semantic',
    },
    {
      german: "gehört zu",
      translated: "maf ji",
      tone: 'semantic',
    },
    {
      german: "den Grundrechten",
      translated: "mafên bingehîn ên",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "Almanyayê ye",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:4|pl": [
    {
      german: "Welches Recht",
      translated: "Które z poniższych",
      tone: 'semantic',
    },
    {
      german: "gehört zu",
      translated: "jest",
      tone: 'semantic',
    },
    {
      german: "den Grundrechten",
      translated: "prawem podstawowym",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "w Niemczech",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:4|prs": [
    {
      german: "Welches Recht",
      translated: "کدام حق",
      tone: 'semantic',
    },
    {
      german: "gehört zu",
      translated: "جزو",
      tone: 'semantic',
    },
    {
      german: "den Grundrechten",
      translated: "حقوق اساسی",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "در آلمان",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:4|ro": [
    {
      german: "Welches Recht",
      translated: "Care",
      tone: 'semantic',
    },
    {
      german: "gehört zu",
      translated: "este",
      tone: 'semantic',
    },
    {
      german: "den Grundrechten",
      translated: "un drept fundamental",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "în Germania",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:4|ru": [
    {
      german: "Welches Recht",
      translated: "Какое право",
      tone: 'semantic',
    },
    {
      german: "gehört zu",
      translated: "относится к",
      tone: 'semantic',
    },
    {
      german: "den Grundrechten",
      translated: "основным правам",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "в Германии",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:4|sq": [
    {
      german: "Welches Recht",
      translated: "Cila nga këto",
      tone: 'semantic',
    },
    {
      german: "gehört zu",
      translated: "është",
      tone: 'semantic',
    },
    {
      german: "den Grundrechten",
      translated: "një e drejtë themelore",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "në Gjermani",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:4|sr": [
    {
      german: "Welches Recht",
      translated: "Šta je",
      tone: 'semantic',
    },
    {
      german: "gehört zu",
      translated: "od navedenoga",
      tone: 'semantic',
    },
    {
      german: "den Grundrechten",
      translated: "osnovno pravo",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "u Nemačkoj?",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:4|tr": [
    {
      german: "Welches Recht",
      translated: "Aşağıdaki haklardan hangisi",
      tone: 'semantic',
    },
    {
      german: "gehört zu",
      translated: "biridir",
      tone: 'semantic',
    },
    {
      german: "den Grundrechten",
      translated: "temel haklardan",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "Almanya'daki",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:4|uk": [
    {
      german: "Welches Recht",
      translated: "з наведених прав",
      tone: 'semantic',
    },
    {
      german: "gehört zu",
      translated: "належить до",
      tone: 'semantic',
    },
    {
      german: "den Grundrechten",
      translated: "основних прав",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "у Німеччині",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:4|vi": [
    {
      german: "Welches Recht",
      translated: "Điều nào",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "ở Đức",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:50|ar": [
    {
      german: "Die Wirtschaftsform",
      translated: "ماذا",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "في ألمانيا",
      tone: 'semantic',
    },
    {
      german: "nennt man",
      translated: "؟",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:50|bg": [
    {
      german: "Die Wirtschaftsform",
      translated: "икономическата система",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "на Германия",
      tone: 'semantic',
    },
    {
      german: "nennt man",
      translated: "Как се нарича",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:50|bs": [
    {
      german: "Die Wirtschaftsform",
      translated: "njemački privredni sustav",
      tone: 'semantic',
    },
    {
      german: "nennt man",
      translated: "Kako se zove",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:50|el": [
    {
      german: "Die Wirtschaftsform",
      translated: "το οικονομικό σύστημα",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "της Γερμανίας",
      tone: 'semantic',
    },
    {
      german: "nennt man",
      translated: "Πώς ονομάζεται",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:50|en": [
    {
      german: "Die Wirtschaftsform",
      translated: "The economic system",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "in Germany",
      tone: 'semantic',
    },
    {
      german: "nennt man",
      translated: "is called",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:50|es": [
    {
      german: "Die Wirtschaftsform",
      translated: "El sistema económico",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "de Alemania",
      tone: 'semantic',
    },
    {
      german: "nennt man",
      translated: "se llama",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:50|fa": [
    {
      german: "Die Wirtschaftsform",
      translated: "نظام اقتصادی",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "آلمان",
      tone: 'semantic',
    },
    {
      german: "nennt man",
      translated: "چه نام دارد؟",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:50|fr": [
    {
      german: "Die Wirtschaftsform",
      translated: "le système économique",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "de l’Allemagne",
      tone: 'semantic',
    },
    {
      german: "nennt man",
      translated: "appelle-t-on",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:50|hr": [
    {
      german: "Die Wirtschaftsform",
      translated: "njemački gospodarski sustav",
      tone: 'semantic',
    },
    {
      german: "nennt man",
      translated: "Kako se zove",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:50|it": [
    {
      german: "Die Wirtschaftsform",
      translated: "il sistema economico",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "della Germania",
      tone: 'semantic',
    },
    {
      german: "nennt man",
      translated: "Come si chiama",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:50|kmr": [
    {
      german: "Die Wirtschaftsform",
      translated: "Pergala",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "Almanyayê",
      tone: 'semantic',
    },
    {
      german: "nennt man",
      translated: "çi tê gotin",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:50|pl": [
    {
      german: "Die Wirtschaftsform",
      translated: "system gospodarczy",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "Niemiec",
      tone: 'semantic',
    },
    {
      german: "nennt man",
      translated: "Jak nazywa się",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:50|prs": [
    {
      german: "Die Wirtschaftsform",
      translated: "نظام اقتصادی",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "آلمان",
      tone: 'semantic',
    },
    {
      german: "nennt man",
      translated: "نام دارد",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:50|ro": [
    {
      german: "Die Wirtschaftsform",
      translated: "sistemul economic",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "al Germaniei",
      tone: 'semantic',
    },
    {
      german: "nennt man",
      translated: "Cum se numește",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:50|ru": [
    {
      german: "Die Wirtschaftsform",
      translated: "Экономическую",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "Германии",
      tone: 'semantic',
    },
    {
      german: "nennt man",
      translated: "называют",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:50|sq": [
    {
      german: "Die Wirtschaftsform",
      translated: "sistemi ekonomik",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "i Gjermanisë",
      tone: 'semantic',
    },
    {
      german: "nennt man",
      translated: "Si quhet",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:50|sr": [
    {
      german: "Die Wirtschaftsform",
      translated: "nemački privredni sistem",
      tone: 'semantic',
    },
    {
      german: "nennt man",
      translated: "Kako se zove",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:50|tr": [
    {
      german: "Die Wirtschaftsform",
      translated: "ekonomik sistemin",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "Almanya'daki",
      tone: 'semantic',
    },
    {
      german: "nennt man",
      translated: "adı",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:50|uk": [
    {
      german: "Die Wirtschaftsform",
      translated: "економічна система",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "Німеччини",
      tone: 'semantic',
    },
    {
      german: "nennt man",
      translated: "називається",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:50|vi": [
    {
      german: "Die Wirtschaftsform",
      translated: "Hệ thống kinh tế",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "của Đức",
      tone: 'semantic',
    },
    {
      german: "nennt man",
      translated: "được gọi là",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:51|ar": [
    {
      german: "Zu einem",
      translated: "في",
      tone: 'semantic',
    },
    {
      german: "demokratischen Rechtsstaat",
      translated: "دولة قانون ديمقراطية",
      tone: 'semantic',
    },
    {
      german: "gehört",
      translated: "يُعد من المقبول",
      tone: 'semantic',
    },
    {
      german: "nicht",
      translated: "لا",
      tone: 'semantic',
    },
    {
      german: "dass",
      translated: "أن",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:51|bg": [
    {
      german: "demokratischen Rechtsstaat",
      translated: "демократична правова държава",
      tone: 'semantic',
    },
    {
      german: "gehört",
      translated: "Кое",
      tone: 'semantic',
    },
    {
      german: "nicht",
      translated: "НЕ",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:51|bs": [
    {
      german: "Zu einem",
      translated: "U",
      tone: 'semantic',
    },
    {
      german: "demokratischen Rechtsstaat",
      translated: "demokratskoj pravnoj državi",
      tone: 'semantic',
    },
    {
      german: "gehört",
      translated: "dopušteno",
      tone: 'semantic',
    },
    {
      german: "nicht",
      translated: "NIJE",
      tone: 'semantic',
    },
    {
      german: "dass",
      translated: "da",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:51|el": [
    {
      german: "Zu einem",
      translated: "Σε ένα",
      tone: 'semantic',
    },
    {
      german: "demokratischen Rechtsstaat",
      translated: "δημοκρατικό κράτος δικαίου",
      tone: 'semantic',
    },
    {
      german: "nicht",
      translated: "ΔΕΝ",
      tone: 'semantic',
    },
    {
      german: "dass",
      translated: "είναι αποδεκτό …",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:51|en": [
    {
      german: "Zu einem",
      translated: "part of a",
      tone: 'semantic',
    },
    {
      german: "demokratischen Rechtsstaat",
      translated: "democratic constitutional state",
      tone: 'semantic',
    },
    {
      german: "gehört",
      translated: "is",
      tone: 'semantic',
    },
    {
      german: "es",
      translated: "It",
      tone: 'semantic',
    },
    {
      german: "nicht",
      translated: "NOT",
      tone: 'semantic',
    },
    {
      german: "dass",
      translated: "that",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:51|es": [
    {
      german: "Zu einem",
      translated: "un",
      tone: 'semantic',
    },
    {
      german: "demokratischen Rechtsstaat",
      translated: "Estado de derecho democrático",
      tone: 'semantic',
    },
    {
      german: "gehört",
      translated: "forma parte de",
      tone: 'semantic',
    },
    {
      german: "nicht",
      translated: "No",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:51|fa": [
    {
      german: "Zu einem",
      translated: "در یک کشور",
      tone: 'semantic',
    },
    {
      german: "demokratischen Rechtsstaat",
      translated: "دموکراتیک مبتنی بر حاکمیت قانون",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:51|fr": [
    {
      german: "Zu einem",
      translated: "Dans un",
      tone: 'semantic',
    },
    {
      german: "demokratischen Rechtsstaat",
      translated: "État de droit démocratique",
      tone: 'semantic',
    },
    {
      german: "gehört",
      translated: "acceptable",
      tone: 'semantic',
    },
    {
      german: "es",
      translated: "il",
      tone: 'semantic',
    },
    {
      german: "nicht",
      translated: "n’est pas",
      tone: 'semantic',
    },
    {
      german: "dass",
      translated: "que",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:51|hr": [
    {
      german: "Zu einem",
      translated: "U",
      tone: 'semantic',
    },
    {
      german: "demokratischen Rechtsstaat",
      translated: "demokratskoj pravnoj državi",
      tone: 'semantic',
    },
    {
      german: "gehört",
      translated: "dopušteno",
      tone: 'semantic',
    },
    {
      german: "nicht",
      translated: "NIJE",
      tone: 'semantic',
    },
    {
      german: "dass",
      translated: "da",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:51|it": [
    {
      german: "Zu einem",
      translated: "In uno",
      tone: 'semantic',
    },
    {
      german: "demokratischen Rechtsstaat",
      translated: "Stato democratico di diritto",
      tone: 'semantic',
    },
    {
      german: "gehört",
      translated: "è accettabile",
      tone: 'semantic',
    },
    {
      german: "nicht",
      translated: "NON",
      tone: 'semantic',
    },
    {
      german: "dass",
      translated: "che",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:51|kmr": [
    {
      german: "Zu einem",
      translated: "Ji bo",
      tone: 'semantic',
    },
    {
      german: "demokratischen Rechtsstaat",
      translated: "dewleteke demokratîk a hiqûqê",
      tone: 'semantic',
    },
    {
      german: "gehört",
      translated: "rast",
      tone: 'semantic',
    },
    {
      german: "es",
      translated: "e",
      tone: 'semantic',
    },
    {
      german: "nicht",
      translated: "ne",
      tone: 'semantic',
    },
    {
      german: "dass",
      translated: "ku …",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:51|pl": [
    {
      german: "Zu einem",
      translated: "W",
      tone: 'semantic',
    },
    {
      german: "demokratischen Rechtsstaat",
      translated: "demokratycznym państwie prawa",
      tone: 'semantic',
    },
    {
      german: "gehört",
      translated: "jest",
      tone: 'semantic',
    },
    {
      german: "nicht",
      translated: "NIE",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:51|prs": [
    {
      german: "Zu einem",
      translated: "در یک",
      tone: 'semantic',
    },
    {
      german: "demokratischen Rechtsstaat",
      translated: "کشور دموکراتیک مبتنی بر حاکمیت قانون",
      tone: 'semantic',
    },
    {
      german: "gehört",
      translated: "قابل قبول",
      tone: 'semantic',
    },
    {
      german: "es",
      translated: "مورد",
      tone: 'semantic',
    },
    {
      german: "nicht",
      translated: "نیست",
      tone: 'semantic',
    },
    {
      german: "dass",
      translated: "کدام",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:51|ro": [
    {
      german: "Zu einem",
      translated: "într-un stat",
      tone: 'semantic',
    },
    {
      german: "demokratischen Rechtsstaat",
      translated: "democratic de drept",
      tone: 'semantic',
    },
    {
      german: "gehört",
      translated: "este acceptabil",
      tone: 'semantic',
    },
    {
      german: "nicht",
      translated: "NU",
      tone: 'semantic',
    },
    {
      german: "dass",
      translated: "Ce",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:51|ru": [
    {
      german: "Zu einem",
      translated: "К",
      tone: 'semantic',
    },
    {
      german: "demokratischen Rechtsstaat",
      translated: "демократическому правовому государству",
      tone: 'semantic',
    },
    {
      german: "gehört",
      translated: "относится",
      tone: 'semantic',
    },
    {
      german: "es",
      translated: "то",
      tone: 'semantic',
    },
    {
      german: "nicht",
      translated: "не",
      tone: 'semantic',
    },
    {
      german: "dass",
      translated: "что",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:51|sq": [
    {
      german: "Zu einem",
      translated: "Në një",
      tone: 'semantic',
    },
    {
      german: "demokratischen Rechtsstaat",
      translated: "shtet demokratik të së drejtës",
      tone: 'semantic',
    },
    {
      german: "gehört",
      translated: "është e pranueshme",
      tone: 'semantic',
    },
    {
      german: "nicht",
      translated: "NUK",
      tone: 'semantic',
    },
    {
      german: "dass",
      translated: "që",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:51|sr": [
    {
      german: "Zu einem",
      translated: "U",
      tone: 'semantic',
    },
    {
      german: "demokratischen Rechtsstaat",
      translated: "demokratskoj pravnoj državi",
      tone: 'semantic',
    },
    {
      german: "gehört",
      translated: "dozvoljeno",
      tone: 'semantic',
    },
    {
      german: "nicht",
      translated: "NIJE",
      tone: 'semantic',
    },
    {
      german: "dass",
      translated: "da",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:51|tr": [
    {
      german: "demokratischen Rechtsstaat",
      translated: "Demokratik bir hukuk devletinde",
      tone: 'semantic',
    },
    {
      german: "nicht",
      translated: "olmaz",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:51|uk": [
    {
      german: "Zu einem",
      translated: "До",
      tone: 'semantic',
    },
    {
      german: "demokratischen Rechtsstaat",
      translated: "демократичної правової держави",
      tone: 'semantic',
    },
    {
      german: "gehört",
      translated: "належить",
      tone: 'semantic',
    },
    {
      german: "es",
      translated: "те",
      tone: 'semantic',
    },
    {
      german: "nicht",
      translated: "не",
      tone: 'semantic',
    },
    {
      german: "dass",
      translated: "що",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:51|vi": [
    {
      german: "Zu einem",
      translated: "Trong một",
      tone: 'semantic',
    },
    {
      german: "demokratischen Rechtsstaat",
      translated: "nhà nước pháp quyền dân chủ",
      tone: 'semantic',
    },
    {
      german: "gehört",
      translated: "được chấp nhận",
      tone: 'semantic',
    },
    {
      german: "nicht",
      translated: "KHÔNG",
      tone: 'semantic',
    },
    {
      german: "dass",
      translated: "điều nào sau đây",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:52|ar": [
    {
      german: "Was bedeutet",
      translated: "ماذا تعني",
      tone: 'semantic',
    },
    {
      german: "Volkssouveränität",
      translated: "«سيادة الشعب»",
      tone: 'semantic',
    },
    {
      german: "Alle Staatsgewalt geht vom",
      translated: "كل سلطة الدولة تنبع من …",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:52|bg": [
    {
      german: "Was bedeutet",
      translated: "означава",
      tone: 'semantic',
    },
    {
      german: "Volkssouveränität",
      translated: "Народен суверенитет",
      tone: 'semantic',
    },
    {
      german: "Alle Staatsgewalt geht vom",
      translated: "цялата държавна власт произтича от",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:52|bs": [
    {
      german: "Was bedeutet",
      translated: "znači",
      tone: 'semantic',
    },
    {
      german: "Volkssouveränität",
      translated: "„Narodni suverenitet“",
      tone: 'semantic',
    },
    {
      german: "Alle Staatsgewalt geht vom",
      translated: "sva državna vlast proizlazi",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:52|el": [
    {
      german: "Volkssouveränität",
      translated: "«Λαϊκή κυριαρχία»",
      tone: 'semantic',
    },
    {
      german: "Alle Staatsgewalt geht vom",
      translated: "σημαίνει ότι όλη η κρατική εξουσία προέρχεται …",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:52|en": [
    {
      german: "Was bedeutet",
      translated: "What does",
      tone: 'semantic',
    },
    {
      german: "Volkssouveränität",
      translated: "popular sovereignty",
      tone: 'semantic',
    },
    {
      german: "Alle Staatsgewalt geht vom",
      translated: "All state power emanates from the",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:52|es": [
    {
      german: "Was bedeutet",
      translated: "¿Qué significa",
      tone: 'semantic',
    },
    {
      german: "Volkssouveränität",
      translated: "soberanía popular",
      tone: 'semantic',
    },
    {
      german: "Alle Staatsgewalt geht vom",
      translated: "Todo el poder del Estado emana del",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:52|fa": [
    {
      german: "Was bedeutet",
      translated: " یعنی چه",
      tone: 'semantic',
    },
    {
      german: "Volkssouveränität",
      translated: "حاکمیت مردم",
      tone: 'semantic',
    },
    {
      german: "Alle Staatsgewalt geht vom",
      translated: "همهٔ قدرت حکومتی از … سرچشمه می‌گیرد",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:52|fr": [
    {
      german: "Was bedeutet",
      translated: "Que signifie",
      tone: 'semantic',
    },
    {
      german: "Volkssouveränität",
      translated: "« souveraineté populaire »",
      tone: 'semantic',
    },
    {
      german: "Alle Staatsgewalt geht vom",
      translated: "Tout pouvoir de l’État émane …",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:52|hr": [
    {
      german: "Was bedeutet",
      translated: "znači",
      tone: 'semantic',
    },
    {
      german: "Volkssouveränität",
      translated: "Narodni suverenitet",
      tone: 'semantic',
    },
    {
      german: "Alle Staatsgewalt geht vom",
      translated: "sva državna vlast proizlazi …",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:52|it": [
    {
      german: "Was bedeutet",
      translated: "Che cosa significa",
      tone: 'semantic',
    },
    {
      german: "Volkssouveränität",
      translated: "sovranità popolare",
      tone: 'semantic',
    },
    {
      german: "Alle Staatsgewalt geht vom",
      translated: "Tutto il potere dello Stato deriva",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:52|kmr": [
    {
      german: "Was bedeutet",
      translated: "tê çi wateyê",
      tone: 'semantic',
    },
    {
      german: "Volkssouveränität",
      translated: "«Serweriya gel»",
      tone: 'semantic',
    },
    {
      german: "Alle Staatsgewalt geht vom",
      translated: "Hemû hêza dewletê ji … tê",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:52|pl": [
    {
      german: "Was bedeutet",
      translated: "oznacza",
      tone: 'semantic',
    },
    {
      german: "Volkssouveränität",
      translated: "Suwerenność ludu",
      tone: 'semantic',
    },
    {
      german: "Alle Staatsgewalt geht vom",
      translated: "cała władza państwowa pochodzi",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:52|prs": [
    {
      german: "Was bedeutet",
      translated: "یعنی چه",
      tone: 'semantic',
    },
    {
      german: "Volkssouveränität",
      translated: "حاکمیت مردم",
      tone: 'semantic',
    },
    {
      german: "Alle Staatsgewalt geht vom",
      translated: "همهٔ قدرت حکومتی از … سرچشمه می‌گیرد",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:52|ro": [
    {
      german: "Was bedeutet",
      translated: "înseamnă că",
      tone: 'semantic',
    },
    {
      german: "Volkssouveränität",
      translated: "Suveranitatea poporului",
      tone: 'semantic',
    },
    {
      german: "Alle Staatsgewalt geht vom",
      translated: "întreaga putere de stat provine de la",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:52|ru": [
    {
      german: "Was bedeutet",
      translated: "Что означает",
      tone: 'semantic',
    },
    {
      german: "Volkssouveränität",
      translated: "народный суверенитет",
      tone: 'semantic',
    },
    {
      german: "Alle Staatsgewalt geht vom",
      translated: "Вся государственная власть исходит от",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:52|sq": [
    {
      german: "Was bedeutet",
      translated: "Çfarë do të thotë",
      tone: 'semantic',
    },
    {
      german: "Volkssouveränität",
      translated: "sovraniteti i popullit",
      tone: 'semantic',
    },
    {
      german: "Alle Staatsgewalt geht vom",
      translated: "»? I gjithë pushteti shtetëror buron …",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:52|sr": [
    {
      german: "Was bedeutet",
      translated: "znači",
      tone: 'semantic',
    },
    {
      german: "Volkssouveränität",
      translated: "„Narodni suverenitet“",
      tone: 'semantic',
    },
    {
      german: "Alle Staatsgewalt geht vom",
      translated: "sva državna vlast proizlazi",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:52|tr": [
    {
      german: "Was bedeutet",
      translated: "ne demektir",
      tone: 'semantic',
    },
    {
      german: "Volkssouveränität",
      translated: "Halk egemenliği",
      tone: 'semantic',
    },
    {
      german: "Alle Staatsgewalt geht vom",
      translated: "Tüm devlet yetkisi … kaynaklanır",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:52|uk": [
    {
      german: "Was bedeutet",
      translated: "Що означає",
      tone: 'semantic',
    },
    {
      german: "Volkssouveränität",
      translated: "народний суверенітет",
      tone: 'semantic',
    },
    {
      german: "Alle Staatsgewalt geht vom",
      translated: "Уся державна влада походить від",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:52|vi": [
    {
      german: "Was bedeutet",
      translated: "có nghĩa là",
      tone: 'semantic',
    },
    {
      german: "Volkssouveränität",
      translated: "Chủ quyền nhân dân",
      tone: 'semantic',
    },
    {
      german: "Alle Staatsgewalt geht vom",
      translated: "toàn bộ quyền lực nhà nước xuất phát",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:53|ar": [
    {
      german: "Was bedeutet",
      translated: "ماذا",
      tone: 'semantic',
    },
    {
      german: "\"Rechtsstaat\"",
      translated: "«دولة القانون»",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "في ألمانيا",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:53|bg": [
    {
      german: "Was bedeutet",
      translated: "Какво означава",
      tone: 'semantic',
    },
    {
      german: "\"Rechtsstaat\"",
      translated: "„правова държава“",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "в Германия",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:53|bs": [
    {
      german: "Was bedeutet",
      translated: "Što",
      tone: 'semantic',
    },
    {
      german: "\"Rechtsstaat\"",
      translated: "„pravna država“",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "u Njemačkoj",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:53|el": [
    {
      german: "Was bedeutet",
      translated: "Τι σημαίνει",
      tone: 'semantic',
    },
    {
      german: "\"Rechtsstaat\"",
      translated: "«κράτος δικαίου»",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "στη Γερμανία",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:53|en": [
    {
      german: "Was bedeutet",
      translated: "What does",
      tone: 'semantic',
    },
    {
      german: "\"Rechtsstaat\"",
      translated: "'constitutional state'",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "in Germany",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:53|es": [
    {
      german: "Was bedeutet",
      translated: "¿Qué significa",
      tone: 'semantic',
    },
    {
      german: "\"Rechtsstaat\"",
      translated: "«Estado de derecho» (Rechtsstaat)",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "en Alemania",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:53|fa": [
    {
      german: "Was bedeutet",
      translated: "یعنی",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "در آلمان",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:53|fr": [
    {
      german: "Was bedeutet",
      translated: "Que signifie «",
      tone: 'semantic',
    },
    {
      german: "\"Rechtsstaat\"",
      translated: "État de droit »",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "en Allemagne ?",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:53|hr": [
    {
      german: "Was bedeutet",
      translated: "Što",
      tone: 'semantic',
    },
    {
      german: "\"Rechtsstaat\"",
      translated: "„pravna država“",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "u Njemačkoj",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:53|it": [
    {
      german: "Was bedeutet",
      translated: "Che cosa significa",
      tone: 'semantic',
    },
    {
      german: "\"Rechtsstaat\"",
      translated: "«Stato di diritto»",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "in Germania",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:53|kmr": [
    {
      german: "Was bedeutet",
      translated: "tê çi wateyê",
      tone: 'semantic',
    },
    {
      german: "\"Rechtsstaat\"",
      translated: "li Almanyayê",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:53|pl": [
    {
      german: "Was bedeutet",
      translated: "Co oznacza",
      tone: 'semantic',
    },
    {
      german: "\"Rechtsstaat\"",
      translated: "„państwo prawa”",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "w Niemczech",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:53|prs": [
    {
      german: "Was bedeutet",
      translated: "یعنی چه",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "در آلمان",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:53|ro": [
    {
      german: "Was bedeutet",
      translated: "Ce înseamnă",
      tone: 'semantic',
    },
    {
      german: "\"Rechtsstaat\"",
      translated: "„stat de drept”",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "în Germania",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:53|ru": [
    {
      german: "Was bedeutet",
      translated: "Что означает",
      tone: 'semantic',
    },
    {
      german: "\"Rechtsstaat\"",
      translated: "«правовое государство»",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "в Германии",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:53|sq": [
    {
      german: "Was bedeutet",
      translated: "Çfarë do të thotë",
      tone: 'semantic',
    },
    {
      german: "\"Rechtsstaat\"",
      translated: "shtet i së drejtës",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "në Gjermani",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:53|sr": [
    {
      german: "Was bedeutet",
      translated: "Šta u Nemačkoj znači",
      tone: 'semantic',
    },
    {
      german: "\"Rechtsstaat\"",
      translated: "„pravna država“",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:53|tr": [
    {
      german: "Was bedeutet",
      translated: "ne demektir",
      tone: 'semantic',
    },
    {
      german: "\"Rechtsstaat\"",
      translated: "hukuk devleti",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "Almanya'da",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:53|uk": [
    {
      german: "Was bedeutet",
      translated: "Що означає «",
      tone: 'semantic',
    },
    {
      german: "\"Rechtsstaat\"",
      translated: "правова держава»",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "в Німеччині",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:53|vi": [
    {
      german: "Was bedeutet",
      translated: "có nghĩa là",
      tone: 'semantic',
    },
    {
      german: "\"Rechtsstaat\"",
      translated: "“Nhà nước pháp quyền”",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "ở Đức",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:54|ar": [
    {
      german: "Was ist",
      translated: "أي مما يلي",
      tone: 'semantic',
    },
    {
      german: "keine staatliche Gewalt",
      translated: "ليس سلطة من سلطات الدولة",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "في ألمانيا",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:54|bg": [
    {
      german: "Was ist",
      translated: "Кое",
      tone: 'semantic',
    },
    {
      german: "keine staatliche Gewalt",
      translated: "НЕ е една от държавните власти",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "в Германия?",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:54|bs": [
    {
      german: "Was ist",
      translated: "Što od",
      tone: 'semantic',
    },
    {
      german: "keine staatliche Gewalt",
      translated: "navedenoga NIJE jedna od državnih vlasti",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "u Njemačkoj",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:54|el": [
    {
      german: "Was ist",
      translated: "Ποιο από τα παρακάτω",
      tone: 'semantic',
    },
    {
      german: "keine staatliche Gewalt",
      translated: "ΔΕΝ είναι μία από τις κρατικές εξουσίες",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "στη Γερμανία",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:54|en": [
    {
      german: "Was ist",
      translated: "What is",
      tone: 'semantic',
    },
    {
      german: "keine staatliche Gewalt",
      translated: "NOT a state power",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "in Germany",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:54|es": [
    {
      german: "Was ist",
      translated: "¿Cuál",
      tone: 'semantic',
    },
    {
      german: "keine staatliche Gewalt",
      translated: "NO es un poder del Estado",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "en Alemania",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:54|fa": [
    {
      german: "Was ist",
      translated: "کدام",
      tone: 'semantic',
    },
    {
      german: "keine staatliche Gewalt",
      translated: "یکی از قوای حکومتی",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "در آلمان",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:54|fr": [
    {
      german: "Was ist",
      translated: "Lequel",
      tone: 'semantic',
    },
    {
      german: "keine staatliche Gewalt",
      translated: "n’est pas un pouvoir de l’État",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "en Allemagne",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:54|hr": [
    {
      german: "Was ist",
      translated: "Što od",
      tone: 'semantic',
    },
    {
      german: "keine staatliche Gewalt",
      translated: "navedenoga NIJE jedna od državnih vlasti",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "u Njemačkoj",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:54|it": [
    {
      german: "Was ist",
      translated: "Quale dei seguenti",
      tone: 'semantic',
    },
    {
      german: "keine staatliche Gewalt",
      translated: "NON è uno dei poteri dello Stato",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "in Germania",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:54|kmr": [
    {
      german: "Was ist",
      translated: "Kîjan ji van ne hêzeke",
      tone: 'semantic',
    },
    {
      german: "keine staatliche Gewalt",
      translated: "dewletê",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "li Almanyayê",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:54|pl": [
    {
      german: "Was ist",
      translated: "Które z",
      tone: 'semantic',
    },
    {
      german: "keine staatliche Gewalt",
      translated: "NIE jest jedną z",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "w Niemczech",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:54|prs": [
    {
      german: "Was ist",
      translated: "کدام مورد یکی",
      tone: 'semantic',
    },
    {
      german: "keine staatliche Gewalt",
      translated: "از قوای حکومتی",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "در آلمان",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:54|ro": [
    {
      german: "Was ist",
      translated: "Care",
      tone: 'semantic',
    },
    {
      german: "keine staatliche Gewalt",
      translated: "NU este una dintre puterile statului",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "în Germania",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:54|ru": [
    {
      german: "Was ist",
      translated: "Что",
      tone: 'semantic',
    },
    {
      german: "keine staatliche Gewalt",
      translated: "не является ветвью государственной власти",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "в Германии",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:54|sq": [
    {
      german: "Was ist",
      translated: "Cila nga këto",
      tone: 'semantic',
    },
    {
      german: "keine staatliche Gewalt",
      translated: "NUK është një nga pushtetet shtetërore",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "në Gjermani",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:54|sr": [
    {
      german: "keine staatliche Gewalt",
      translated: "Šta od navedenoga",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "u Nemačkoj",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:54|tr": [
    {
      german: "Was ist",
      translated: "Aşağıdakilerden hangisi",
      tone: 'semantic',
    },
    {
      german: "keine staatliche Gewalt",
      translated: "devlet erklerinden biri değildir",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "Almanya'daki",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:54|uk": [
    {
      german: "Was ist",
      translated: "Що",
      tone: 'semantic',
    },
    {
      german: "keine staatliche Gewalt",
      translated: "Німеччині",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "в",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:54|vi": [
    {
      german: "Was ist",
      translated: "Điều nào sau đây",
      tone: 'semantic',
    },
    {
      german: "keine staatliche Gewalt",
      translated: "KHÔNG phải là một nhánh quyền lực nhà nước",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "ở Đức",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:55|ar": [
    {
      german: "Was",
      translated: "ماذا",
      tone: 'semantic',
    },
    {
      german: "zeigt",
      translated: "تُظهر",
      tone: 'semantic',
    },
    {
      german: "dieses",
      translated: "هذه",
      tone: 'semantic',
    },
    {
      german: "Bild",
      translated: "الصورة",
      tone: 'semantic',
    },
    {
      german: "Deutscher Bundestag",
      translated: "Deutscher Bundestag",
      tone: 'semantic',
    },
    {
      german: "Achim Melde",
      translated: "Achim Melde",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:55|bg": [
    {
      german: "Was",
      translated: "Какво",
      tone: 'semantic',
    },
    {
      german: "zeigt",
      translated: "показва",
      tone: 'semantic',
    },
    {
      german: "dieses",
      translated: "това",
      tone: 'semantic',
    },
    {
      german: "Bild",
      translated: "изображение",
      tone: 'semantic',
    },
    {
      german: "Deutscher Bundestag",
      translated: "Deutscher Bundestag",
      tone: 'semantic',
    },
    {
      german: "Achim Melde",
      translated: "Achim Melde",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:55|bs": [
    {
      german: "Was",
      translated: "Što",
      tone: 'semantic',
    },
    {
      german: "zeigt",
      translated: "prikazuje",
      tone: 'semantic',
    },
    {
      german: "dieses",
      translated: "ova",
      tone: 'semantic',
    },
    {
      german: "Bild",
      translated: "slika",
      tone: 'semantic',
    },
    {
      german: "Deutscher Bundestag",
      translated: "Deutscher Bundestag",
      tone: 'semantic',
    },
    {
      german: "Achim Melde",
      translated: "Achim Melde",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:55|el": [
    {
      german: "Was",
      translated: "Τι",
      tone: 'semantic',
    },
    {
      german: "zeigt",
      translated: "δείχνει",
      tone: 'semantic',
    },
    {
      german: "dieses",
      translated: "αυτή",
      tone: 'semantic',
    },
    {
      german: "Bild",
      translated: "εικόνα",
      tone: 'semantic',
    },
    {
      german: "Deutscher Bundestag",
      translated: "Deutscher Bundestag",
      tone: 'semantic',
    },
    {
      german: "Achim Melde",
      translated: "Achim Melde",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:55|en": [
    {
      german: "Was",
      translated: "What",
      tone: 'semantic',
    },
    {
      german: "zeigt",
      translated: "show",
      tone: 'semantic',
    },
    {
      german: "dieses",
      translated: "this",
      tone: 'semantic',
    },
    {
      german: "Bild",
      translated: "picture",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:55|es": [
    {
      german: "Was",
      translated: "¿Qué",
      tone: 'semantic',
    },
    {
      german: "zeigt",
      translated: "muestra",
      tone: 'semantic',
    },
    {
      german: "dieses",
      translated: "esta",
      tone: 'semantic',
    },
    {
      german: "Bild",
      translated: "imagen",
      tone: 'semantic',
    },
    {
      german: "Deutscher Bundestag",
      translated: "Deutscher Bundestag",
      tone: 'semantic',
    },
    {
      german: "Achim Melde",
      translated: "Achim Melde",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:55|fa": [
    {
      german: "Was",
      translated: "چه چیزی",
      tone: 'semantic',
    },
    {
      german: "zeigt",
      translated: "نشان می‌دهد",
      tone: 'semantic',
    },
    {
      german: "dieses",
      translated: "این",
      tone: 'semantic',
    },
    {
      german: "Bild",
      translated: "تصویر",
      tone: 'semantic',
    },
    {
      german: "Deutscher Bundestag",
      translated: "Deutscher Bundestag",
      tone: 'semantic',
    },
    {
      german: "Achim Melde",
      translated: "Achim Melde",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:55|fr": [
    {
      german: "Was",
      translated: "Que",
      tone: 'semantic',
    },
    {
      german: "zeigt",
      translated: "montre",
      tone: 'semantic',
    },
    {
      german: "dieses",
      translated: "cette",
      tone: 'semantic',
    },
    {
      german: "Bild",
      translated: "photo",
      tone: 'semantic',
    },
    {
      german: "Deutscher Bundestag",
      translated: "Deutscher Bundestag",
      tone: 'semantic',
    },
    {
      german: "Achim Melde",
      translated: "Achim Melde",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:55|hr": [
    {
      german: "Was",
      translated: "Što",
      tone: 'semantic',
    },
    {
      german: "zeigt",
      translated: "prikazuje",
      tone: 'semantic',
    },
    {
      german: "dieses",
      translated: "ova",
      tone: 'semantic',
    },
    {
      german: "Bild",
      translated: "slika",
      tone: 'semantic',
    },
    {
      german: "Deutscher Bundestag",
      translated: "Deutscher Bundestag",
      tone: 'semantic',
    },
    {
      german: "Achim Melde",
      translated: "Achim Melde",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:55|it": [
    {
      german: "Was",
      translated: "Che",
      tone: 'semantic',
    },
    {
      german: "zeigt",
      translated: "mostra",
      tone: 'semantic',
    },
    {
      german: "dieses",
      translated: "questa",
      tone: 'semantic',
    },
    {
      german: "Bild",
      translated: "immagine",
      tone: 'semantic',
    },
    {
      german: "Deutscher Bundestag",
      translated: "Deutscher Bundestag",
      tone: 'semantic',
    },
    {
      german: "Achim Melde",
      translated: "Achim Melde",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:55|kmr": [
    {
      german: "Was",
      translated: "Di",
      tone: 'semantic',
    },
    {
      german: "zeigt",
      translated: "wêneyê",
      tone: 'semantic',
    },
    {
      german: "dieses",
      translated: "de",
      tone: 'semantic',
    },
    {
      german: "Bild",
      translated: "çi",
      tone: 'semantic',
    },
    {
      german: "Deutscher Bundestag",
      translated: "Deutscher Bundestag",
      tone: 'semantic',
    },
    {
      german: "Achim Melde",
      translated: "Achim Melde",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:55|pl": [
    {
      german: "Was",
      translated: "Co",
      tone: 'semantic',
    },
    {
      german: "zeigt",
      translated: "przedstawia",
      tone: 'semantic',
    },
    {
      german: "dieses",
      translated: "ten",
      tone: 'semantic',
    },
    {
      german: "Bild",
      translated: "obraz",
      tone: 'semantic',
    },
    {
      german: "Deutscher Bundestag",
      translated: "Deutscher Bundestag",
      tone: 'semantic',
    },
    {
      german: "Achim Melde",
      translated: "Achim Melde",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:55|prs": [
    {
      german: "dieses",
      translated: "این",
      tone: 'semantic',
    },
    {
      german: "Bild",
      translated: "تصویر",
      tone: 'semantic',
    },
    {
      german: "Deutscher Bundestag",
      translated: "Deutscher Bundestag",
      tone: 'semantic',
    },
    {
      german: "Achim Melde",
      translated: "Achim Melde",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:55|ro": [
    {
      german: "Was",
      translated: "Ce",
      tone: 'semantic',
    },
    {
      german: "zeigt",
      translated: "arată",
      tone: 'semantic',
    },
    {
      german: "dieses",
      translated: "această",
      tone: 'semantic',
    },
    {
      german: "Bild",
      translated: "imagine",
      tone: 'semantic',
    },
    {
      german: "Deutscher Bundestag",
      translated: "Deutscher Bundestag",
      tone: 'semantic',
    },
    {
      german: "Achim Melde",
      translated: "Achim Melde",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:55|ru": [
    {
      german: "Was",
      translated: "Что",
      tone: 'semantic',
    },
    {
      german: "zeigt",
      translated: "изображено",
      tone: 'semantic',
    },
    {
      german: "dieses",
      translated: "этой",
      tone: 'semantic',
    },
    {
      german: "Bild",
      translated: "картинке",
      tone: 'semantic',
    },
    {
      german: "Deutscher Bundestag",
      translated: "Германский Бундестаг",
      tone: 'semantic',
    },
    {
      german: "Achim Melde",
      translated: "Ахим Мельде",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:55|sq": [
    {
      german: "Was",
      translated: "Çfarë",
      tone: 'semantic',
    },
    {
      german: "zeigt",
      translated: "tregon",
      tone: 'semantic',
    },
    {
      german: "dieses",
      translated: "kjo",
      tone: 'semantic',
    },
    {
      german: "Bild",
      translated: "figurë",
      tone: 'semantic',
    },
    {
      german: "Deutscher Bundestag",
      translated: "© Deutscher Bundestag/",
      tone: 'semantic',
    },
    {
      german: "Achim Melde",
      translated: "Achim Melde",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:55|sr": [
    {
      german: "Was",
      translated: "Šta",
      tone: 'semantic',
    },
    {
      german: "zeigt",
      translated: "prikazuje",
      tone: 'semantic',
    },
    {
      german: "dieses",
      translated: "ova",
      tone: 'semantic',
    },
    {
      german: "Bild",
      translated: "slika",
      tone: 'semantic',
    },
    {
      german: "Deutscher Bundestag",
      translated: "Deutscher Bundestag",
      tone: 'semantic',
    },
    {
      german: "Achim Melde",
      translated: "Achim Melde",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:55|tr": [
    {
      german: "Was",
      translated: "ne",
      tone: 'semantic',
    },
    {
      german: "zeigt",
      translated: "görülüyor",
      tone: 'semantic',
    },
    {
      german: "dieses",
      translated: "Bu",
      tone: 'semantic',
    },
    {
      german: "Bild",
      translated: "resimde",
      tone: 'semantic',
    },
    {
      german: "Deutscher Bundestag",
      translated: "Deutscher Bundestag",
      tone: 'semantic',
    },
    {
      german: "Achim Melde",
      translated: "Achim Melde",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:55|uk": [
    {
      german: "Was",
      translated: "Що",
      tone: 'semantic',
    },
    {
      german: "zeigt",
      translated: "зображено",
      tone: 'semantic',
    },
    {
      german: "dieses",
      translated: "на цій",
      tone: 'semantic',
    },
    {
      german: "Bild",
      translated: "фотографії",
      tone: 'semantic',
    },
    {
      german: "Deutscher Bundestag",
      translated: "Deutscher Bundestag",
      tone: 'semantic',
    },
    {
      german: "Achim Melde",
      translated: "Achim Melde",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:55|vi": [
    {
      german: "Was",
      translated: "gì",
      tone: 'semantic',
    },
    {
      german: "zeigt",
      translated: "cho thấy",
      tone: 'semantic',
    },
    {
      german: "dieses",
      translated: "này",
      tone: 'semantic',
    },
    {
      german: "Bild",
      translated: "Hình",
      tone: 'semantic',
    },
    {
      german: "Deutscher Bundestag",
      translated: "Deutscher Bundestag",
      tone: 'semantic',
    },
    {
      german: "Achim Melde",
      translated: "Achim Melde",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:56|ar": [
    {
      german: "Welches Amt",
      translated: "أي دائرة",
      tone: 'semantic',
    },
    {
      german: "gehört",
      translated: "من الدوائر التالية تتبع إدارة البلدية",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "في ألمانيا",
      tone: 'semantic',
    },
    {
      german: "zur Gemeindeverwaltung",
      translated: "؟",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:56|bg": [
    {
      german: "Welches Amt",
      translated: "Коя институция",
      tone: 'semantic',
    },
    {
      german: "gehört",
      translated: "принадлежи",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "в Германия",
      tone: 'semantic',
    },
    {
      german: "zur Gemeindeverwaltung",
      translated: "към общинската администрация",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:56|bs": [
    {
      german: "Welches Amt",
      translated: "Koji ured",
      tone: 'semantic',
    },
    {
      german: "gehört",
      translated: " pripada",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: " u Njemačkoj",
      tone: 'semantic',
    },
    {
      german: "zur Gemeindeverwaltung",
      translated: "općinskoj upravi",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:56|el": [
    {
      german: "Welches Amt",
      translated: "Ποια υπηρεσία",
      tone: 'semantic',
    },
    {
      german: "gehört",
      translated: "ανήκει",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "στη Γερμανία",
      tone: 'semantic',
    },
    {
      german: "zur Gemeindeverwaltung",
      translated: "στη δημοτική διοίκηση",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:56|en": [
    {
      german: "Welches Amt",
      translated: "Which office",
      tone: 'semantic',
    },
    {
      german: "gehört",
      translated: "belongs",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "in Germany",
      tone: 'semantic',
    },
    {
      german: "zur Gemeindeverwaltung",
      translated: "local government administration",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:56|es": [
    {
      german: "Welches Amt",
      translated: "¿Qué oficina",
      tone: 'semantic',
    },
    {
      german: "gehört",
      translated: "pertenece",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "en Alemania",
      tone: 'semantic',
    },
    {
      german: "zur Gemeindeverwaltung",
      translated: "a la administración municipal",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:56|fa": [
    {
      german: "Welches Amt",
      translated: "کدام اداره",
      tone: 'semantic',
    },
    {
      german: "gehört",
      translated: "جزو",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "در آلمان",
      tone: 'semantic',
    },
    {
      german: "zur Gemeindeverwaltung",
      translated: "مدیریت شهری",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:56|fr": [
    {
      german: "Welches Amt",
      translated: "Quel service",
      tone: 'semantic',
    },
    {
      german: "gehört",
      translated: "fait partie",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "en Allemagne",
      tone: 'semantic',
    },
    {
      german: "zur Gemeindeverwaltung",
      translated: "de l’administration communale",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:56|hr": [
    {
      german: "Welches Amt",
      translated: "Koji ured",
      tone: 'semantic',
    },
    {
      german: "gehört",
      translated: "pripada",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "u Njemačkoj",
      tone: 'semantic',
    },
    {
      german: "zur Gemeindeverwaltung",
      translated: "općinskoj upravi",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:56|it": [
    {
      german: "Welches Amt",
      translated: "Quale ufficio",
      tone: 'semantic',
    },
    {
      german: "gehört",
      translated: "appartiene",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "in Germania",
      tone: 'semantic',
    },
    {
      german: "zur Gemeindeverwaltung",
      translated: "all’amministrazione comunale",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:56|kmr": [
    {
      german: "Welches Amt",
      translated: "kîjan ofîs",
      tone: 'semantic',
    },
    {
      german: "gehört",
      translated: "ye",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "Li Almanyayê",
      tone: 'semantic',
    },
    {
      german: "zur Gemeindeverwaltung",
      translated: "ji rêveberiya şaredariyê",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:56|pl": [
    {
      german: "Welches Amt",
      translated: "Który urząd",
      tone: 'semantic',
    },
    {
      german: "gehört",
      translated: "należy do",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "w Niemczech",
      tone: 'semantic',
    },
    {
      german: "zur Gemeindeverwaltung",
      translated: "administracji gminnej",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:56|prs": [
    {
      german: "Welches Amt",
      translated: "کدام اداره",
      tone: 'semantic',
    },
    {
      german: "gehört",
      translated: "جزو مدیریت شهری",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "در آلمان",
      tone: 'semantic',
    },
    {
      german: "zur Gemeindeverwaltung",
      translated: "است؟",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:56|ro": [
    {
      german: "Welches Amt",
      translated: "Care instituție",
      tone: 'semantic',
    },
    {
      german: "gehört",
      translated: "aparține",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "din Germania",
      tone: 'semantic',
    },
    {
      german: "zur Gemeindeverwaltung",
      translated: "administrației locale",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:56|ru": [
    {
      german: "Welches Amt",
      translated: "Какое учреждение",
      tone: 'semantic',
    },
    {
      german: "gehört",
      translated: "относится",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "в Германии",
      tone: 'semantic',
    },
    {
      german: "zur Gemeindeverwaltung",
      translated: "к муниципальному управлению",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:56|sq": [
    {
      german: "Welches Amt",
      translated: "Cila zyrë",
      tone: 'semantic',
    },
    {
      german: "gehört",
      translated: "i përket",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "në Gjermani",
      tone: 'semantic',
    },
    {
      german: "zur Gemeindeverwaltung",
      translated: "administratës komunale",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:56|sr": [
    {
      german: "Welches Amt",
      translated: "Koji služba",
      tone: 'semantic',
    },
    {
      german: "gehört",
      translated: "pripada",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "u Nemačkoj",
      tone: 'semantic',
    },
    {
      german: "zur Gemeindeverwaltung",
      translated: "opštinskoj upravi",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:56|tr": [
    {
      german: "Welches Amt",
      translated: "hangisi",
      tone: 'semantic',
    },
    {
      german: "gehört",
      translated: "bağlıdır",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "Almanya'da",
      tone: 'semantic',
    },
    {
      german: "zur Gemeindeverwaltung",
      translated: "belediye idaresine",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:56|uk": [
    {
      german: "Welches Amt",
      translated: "Яка установа",
      tone: 'semantic',
    },
    {
      german: "gehört",
      translated: "належить",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "в Німеччині",
      tone: 'semantic',
    },
    {
      german: "zur Gemeindeverwaltung",
      translated: "до муніципальної адміністрації",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:56|vi": [
    {
      german: "Welches Amt",
      translated: "Cơ quan nào",
      tone: 'semantic',
    },
    {
      german: "gehört",
      translated: "thuộc",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "ở Đức",
      tone: 'semantic',
    },
    {
      german: "zur Gemeindeverwaltung",
      translated: "chính quyền địa phương",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:57|ar": [
    {
      german: "Wer",
      translated: "من",
      tone: 'semantic',
    },
    {
      german: "meistens",
      translated: "عادةً",
      tone: 'semantic',
    },
    {
      german: "zur Präsidentin/zum Präsidenten",
      translated: "رئيسًا",
      tone: 'semantic',
    },
    {
      german: "des Deutschen Bundestages",
      translated: "للبوندستاغ الألماني",
      tone: 'semantic',
    },
    {
      german: "gewählt",
      translated: "يُنتخب",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:57|bg": [
    {
      german: "Wer",
      translated: "Кой",
      tone: 'semantic',
    },
    {
      german: "wird",
      translated: "обикновено",
      tone: 'semantic',
    },
    {
      german: "meistens",
      translated: "се",
      tone: 'semantic',
    },
    {
      german: "zur Präsidentin/zum Präsidenten",
      translated: "за председател",
      tone: 'semantic',
    },
    {
      german: "des Deutschen Bundestages",
      translated: "германския Бундестаг",
      tone: 'semantic',
    },
    {
      german: "gewählt",
      translated: "избира",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:57|bs": [
    {
      german: "Wer",
      translated: "Tko",
      tone: 'semantic',
    },
    {
      german: "wird",
      translated: "se",
      tone: 'semantic',
    },
    {
      german: "meistens",
      translated: "obično",
      tone: 'semantic',
    },
    {
      german: "zur Präsidentin/zum Präsidenten",
      translated: "za predsjednika",
      tone: 'semantic',
    },
    {
      german: "des Deutschen Bundestages",
      translated: "njemačkog Bundestaga",
      tone: 'semantic',
    },
    {
      german: "gewählt",
      translated: "bira",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:57|el": [
    {
      german: "Wer",
      translated: "Ποιος",
      tone: 'semantic',
    },
    {
      german: "meistens",
      translated: "συνήθως",
      tone: 'semantic',
    },
    {
      german: "zur Präsidentin/zum Präsidenten",
      translated: "πρόεδρος",
      tone: 'semantic',
    },
    {
      german: "des Deutschen Bundestages",
      translated: "του γερμανικού Bundestag",
      tone: 'semantic',
    },
    {
      german: "gewählt",
      translated: "εκλέγεται",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:57|en": [
    {
      german: "Wer",
      translated: "Who",
      tone: 'semantic',
    },
    {
      german: "wird",
      translated: "is",
      tone: 'semantic',
    },
    {
      german: "meistens",
      translated: "usually",
      tone: 'semantic',
    },
    {
      german: "zur Präsidentin/zum Präsidenten",
      translated: "President",
      tone: 'semantic',
    },
    {
      german: "des Deutschen Bundestages",
      translated: "of the German Bundestag",
      tone: 'semantic',
    },
    {
      german: "gewählt",
      translated: "elected",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:57|es": [
    {
      german: "Wer",
      translated: "Quién",
      tone: 'semantic',
    },
    {
      german: "wird",
      translated: "ser",
      tone: 'semantic',
    },
    {
      german: "meistens",
      translated: "suele",
      tone: 'semantic',
    },
    {
      german: "zur Präsidentin/zum Präsidenten",
      translated: "presidente",
      tone: 'semantic',
    },
    {
      german: "des Deutschen Bundestages",
      translated: "del Bundestag alemán",
      tone: 'semantic',
    },
    {
      german: "gewählt",
      translated: "elegido",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:57|fa": [
    {
      german: "Wer",
      translated: "چه کسی",
      tone: 'semantic',
    },
    {
      german: "wird",
      translated: "معمولاً",
      tone: 'semantic',
    },
    {
      german: "meistens",
      translated: "به",
      tone: 'semantic',
    },
    {
      german: "zur Präsidentin/zum Präsidenten",
      translated: "ریاست",
      tone: 'semantic',
    },
    {
      german: "des Deutschen Bundestages",
      translated: "بوندستاگ آلمان",
      tone: 'semantic',
    },
    {
      german: "gewählt",
      translated: "انتخاب می‌شود",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:57|fr": [
    {
      german: "Wer",
      translated: "Qui",
      tone: 'semantic',
    },
    {
      german: "wird",
      translated: "est",
      tone: 'semantic',
    },
    {
      german: "meistens",
      translated: "généralement",
      tone: 'semantic',
    },
    {
      german: "zur Präsidentin/zum Präsidenten",
      translated: "président ou présidente",
      tone: 'semantic',
    },
    {
      german: "des Deutschen Bundestages",
      translated: "du Bundestag allemand",
      tone: 'semantic',
    },
    {
      german: "gewählt",
      translated: "élu",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:57|hr": [
    {
      german: "Wer",
      translated: "Tko",
      tone: 'semantic',
    },
    {
      german: "wird",
      translated: "se",
      tone: 'semantic',
    },
    {
      german: "meistens",
      translated: "obično",
      tone: 'semantic',
    },
    {
      german: "zur Präsidentin/zum Präsidenten",
      translated: "za predsjednika",
      tone: 'semantic',
    },
    {
      german: "des Deutschen Bundestages",
      translated: "njemačkog Bundestaga",
      tone: 'semantic',
    },
    {
      german: "gewählt",
      translated: "bira",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:57|it": [
    {
      german: "Wer",
      translated: "Chi",
      tone: 'semantic',
    },
    {
      german: "wird",
      translated: "viene",
      tone: 'semantic',
    },
    {
      german: "meistens",
      translated: "di norma",
      tone: 'semantic',
    },
    {
      german: "zur Präsidentin/zum Präsidenten",
      translated: "presidente",
      tone: 'semantic',
    },
    {
      german: "des Deutschen Bundestages",
      translated: "del Bundestag tedesco",
      tone: 'semantic',
    },
    {
      german: "gewählt",
      translated: "eletto",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:57|kmr": [
    {
      german: "Wer",
      translated: "Bi",
      tone: 'semantic',
    },
    {
      german: "wird",
      translated: "gelemperî",
      tone: 'semantic',
    },
    {
      german: "meistens",
      translated: "wek",
      tone: 'semantic',
    },
    {
      german: "zur Präsidentin/zum Präsidenten",
      translated: "serokê Bundestagê",
      tone: 'semantic',
    },
    {
      german: "des Deutschen Bundestages",
      translated: "Alman",
      tone: 'semantic',
    },
    {
      german: "gewählt",
      translated: "hilbijartin?",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:57|pl": [
    {
      german: "Wer",
      translated: "Kto",
      tone: 'semantic',
    },
    {
      german: "wird",
      translated: "jest",
      tone: 'semantic',
    },
    {
      german: "meistens",
      translated: "zazwyczaj",
      tone: 'semantic',
    },
    {
      german: "zur Präsidentin/zum Präsidenten",
      translated: "na przewodniczącego",
      tone: 'semantic',
    },
    {
      german: "des Deutschen Bundestages",
      translated: "niemieckiego Bundestagu",
      tone: 'semantic',
    },
    {
      german: "gewählt",
      translated: "wybierany",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:57|prs": [
    {
      german: "Wer",
      translated: "چه کسی",
      tone: 'semantic',
    },
    {
      german: "meistens",
      translated: "معمولاً",
      tone: 'semantic',
    },
    {
      german: "zur Präsidentin/zum Präsidenten",
      translated: "ریاست",
      tone: 'semantic',
    },
    {
      german: "des Deutschen Bundestages",
      translated: "بوندستاگ آلمان",
      tone: 'semantic',
    },
    {
      german: "gewählt",
      translated: "انتخاب می‌شود",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:57|ro": [
    {
      german: "Wer",
      translated: "Cine",
      tone: 'semantic',
    },
    {
      german: "wird",
      translated: "este",
      tone: 'semantic',
    },
    {
      german: "meistens",
      translated: "de obicei",
      tone: 'semantic',
    },
    {
      german: "zur Präsidentin/zum Präsidenten",
      translated: "președinte",
      tone: 'semantic',
    },
    {
      german: "des Deutschen Bundestages",
      translated: "al Bundestagului german",
      tone: 'semantic',
    },
    {
      german: "gewählt",
      translated: "ales",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:57|ru": [
    {
      german: "Wer",
      translated: "Кто",
      tone: 'semantic',
    },
    {
      german: "meistens",
      translated: "чаще всего",
      tone: 'semantic',
    },
    {
      german: "zur Präsidentin/zum Präsidenten",
      translated: "председателем",
      tone: 'semantic',
    },
    {
      german: "des Deutschen Bundestages",
      translated: "Бундестага Германии",
      tone: 'semantic',
    },
    {
      german: "gewählt",
      translated: "избирается",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:57|sq": [
    {
      german: "Wer",
      translated: "Kush",
      tone: 'semantic',
    },
    {
      german: "meistens",
      translated: "zakonisht",
      tone: 'semantic',
    },
    {
      german: "zur Präsidentin/zum Präsidenten",
      translated: "president",
      tone: 'semantic',
    },
    {
      german: "des Deutschen Bundestages",
      translated: "i Bundestagut gjerman",
      tone: 'semantic',
    },
    {
      german: "gewählt",
      translated: "zgjidhet",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:57|sr": [
    {
      german: "Wer",
      translated: "Ko",
      tone: 'semantic',
    },
    {
      german: "wird",
      translated: "se",
      tone: 'semantic',
    },
    {
      german: "meistens",
      translated: "obično",
      tone: 'semantic',
    },
    {
      german: "zur Präsidentin/zum Präsidenten",
      translated: "za predsjednika",
      tone: 'semantic',
    },
    {
      german: "des Deutschen Bundestages",
      translated: "nemačkog Bundestaga",
      tone: 'semantic',
    },
    {
      german: "gewählt",
      translated: "bira",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:57|tr": [
    {
      german: "Wer",
      translated: "kim",
      tone: 'semantic',
    },
    {
      german: "meistens",
      translated: "genellikle",
      tone: 'semantic',
    },
    {
      german: "zur Präsidentin/zum Präsidenten",
      translated: "başkanı",
      tone: 'semantic',
    },
    {
      german: "des Deutschen Bundestages",
      translated: "Federal Meclisi'nin",
      tone: 'semantic',
    },
    {
      german: "gewählt",
      translated: "seçilir",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:57|uk": [
    {
      german: "Wer",
      translated: "Кого",
      tone: 'semantic',
    },
    {
      german: "meistens",
      translated: "зазвичай",
      tone: 'semantic',
    },
    {
      german: "zur Präsidentin/zum Präsidenten",
      translated: "президентом/президенткою",
      tone: 'semantic',
    },
    {
      german: "des Deutschen Bundestages",
      translated: "німецького Бундестагу",
      tone: 'semantic',
    },
    {
      german: "gewählt",
      translated: "обирають",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:57|vi": [
    {
      german: "Wer",
      translated: "Ai",
      tone: 'semantic',
    },
    {
      german: "wird",
      translated: "được",
      tone: 'semantic',
    },
    {
      german: "meistens",
      translated: "thường",
      tone: 'semantic',
    },
    {
      german: "zur Präsidentin/zum Präsidenten",
      translated: "làm Chủ tịch",
      tone: 'semantic',
    },
    {
      german: "des Deutschen Bundestages",
      translated: "Bundestag Đức",
      tone: 'semantic',
    },
    {
      german: "gewählt",
      translated: "bầu",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:58|ar": [
    {
      german: "Wer",
      translated: "من",
      tone: 'semantic',
    },
    {
      german: "ernennt",
      translated: "يعيّن",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "في ألمانيا",
      tone: 'semantic',
    },
    {
      german: "die Ministerinnen/die Minister",
      translated: "وزراء",
      tone: 'semantic',
    },
    {
      german: "der Bundesregierung",
      translated: "الحكومة الاتحادية",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:58|bg": [
    {
      german: "Wer",
      translated: "Кой",
      tone: 'semantic',
    },
    {
      german: "ernennt",
      translated: "назначава",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "германското",
      tone: 'semantic',
    },
    {
      german: "die Ministerinnen/die Minister",
      translated: "министрите",
      tone: 'semantic',
    },
    {
      german: "der Bundesregierung",
      translated: "федерално правителство",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:58|bs": [
    {
      german: "Wer",
      translated: "Tko",
      tone: 'semantic',
    },
    {
      german: "ernennt",
      translated: "imenuje",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "njemačke",
      tone: 'semantic',
    },
    {
      german: "die Ministerinnen/die Minister",
      translated: "ministre",
      tone: 'semantic',
    },
    {
      german: "der Bundesregierung",
      translated: "savezne vlade",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:58|el": [
    {
      german: "Wer",
      translated: "Ποιος",
      tone: 'semantic',
    },
    {
      german: "ernennt",
      translated: "διορίζει",
      tone: 'semantic',
    },
    {
      german: "die Ministerinnen/die Minister",
      translated: "τους υπουργούς",
      tone: 'semantic',
    },
    {
      german: "der Bundesregierung",
      translated: "γερμανικής ομοσπονδιακής κυβέρνησης",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:58|en": [
    {
      german: "Wer",
      translated: "Who",
      tone: 'semantic',
    },
    {
      german: "ernennt",
      translated: "appoints",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "in Germany",
      tone: 'semantic',
    },
    {
      german: "die Ministerinnen/die Minister",
      translated: "the ministers",
      tone: 'semantic',
    },
    {
      german: "der Bundesregierung",
      translated: "of the federal government",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:58|es": [
    {
      german: "Wer",
      translated: "¿Quién",
      tone: 'semantic',
    },
    {
      german: "ernennt",
      translated: "nombra",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "en Alemania",
      tone: 'semantic',
    },
    {
      german: "die Ministerinnen/die Minister",
      translated: "a los ministros",
      tone: 'semantic',
    },
    {
      german: "der Bundesregierung",
      translated: "del Gobierno Federal",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:58|fa": [
    {
      german: "Wer",
      translated: "چه کسی",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "آلمان",
      tone: 'semantic',
    },
    {
      german: "die Ministerinnen/die Minister",
      translated: "وزیران",
      tone: 'semantic',
    },
    {
      german: "der Bundesregierung",
      translated: "دولت فدرال",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:58|fr": [
    {
      german: "Wer",
      translated: "Qui",
      tone: 'semantic',
    },
    {
      german: "ernennt",
      translated: "nomme",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "en Allemagne",
      tone: 'semantic',
    },
    {
      german: "die Ministerinnen/die Minister",
      translated: "les ministres",
      tone: 'semantic',
    },
    {
      german: "der Bundesregierung",
      translated: "du gouvernement fédéral",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:58|hr": [
    {
      german: "Wer",
      translated: "Tko",
      tone: 'semantic',
    },
    {
      german: "ernennt",
      translated: "imenuje",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "njemačke",
      tone: 'semantic',
    },
    {
      german: "die Ministerinnen/die Minister",
      translated: "ministre",
      tone: 'semantic',
    },
    {
      german: "der Bundesregierung",
      translated: "savezne vlade",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:58|it": [
    {
      german: "Wer",
      translated: "Chi",
      tone: 'semantic',
    },
    {
      german: "ernennt",
      translated: "nomina",
      tone: 'semantic',
    },
    {
      german: "die Ministerinnen/die Minister",
      translated: "i ministri",
      tone: 'semantic',
    },
    {
      german: "der Bundesregierung",
      translated: "del governo federale tedesco",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:58|kmr": [
    {
      german: "Wer",
      translated: "Li",
      tone: 'semantic',
    },
    {
      german: "ernennt",
      translated: "wezîrên",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "Almanyayê",
      tone: 'semantic',
    },
    {
      german: "die Ministerinnen/die Minister",
      translated: "tayîn",
      tone: 'semantic',
    },
    {
      german: "der Bundesregierung",
      translated: "dike",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:58|pl": [
    {
      german: "Wer",
      translated: "Kto",
      tone: 'semantic',
    },
    {
      german: "ernennt",
      translated: "mianuje",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "niemieckiego",
      tone: 'semantic',
    },
    {
      german: "die Ministerinnen/die Minister",
      translated: "ministrów",
      tone: 'semantic',
    },
    {
      german: "der Bundesregierung",
      translated: "rządu federalnego",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:58|prs": [
    {
      german: "Wer",
      translated: "چه کسی",
      tone: 'semantic',
    },
    {
      german: "ernennt",
      translated: "منصوب می‌کند",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "آلمان",
      tone: 'semantic',
    },
    {
      german: "die Ministerinnen/die Minister",
      translated: "وزیران",
      tone: 'semantic',
    },
    {
      german: "der Bundesregierung",
      translated: "دولت فدرال",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:58|ro": [
    {
      german: "Wer",
      translated: "Cine",
      tone: 'semantic',
    },
    {
      german: "ernennt",
      translated: "numește",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "german",
      tone: 'semantic',
    },
    {
      german: "die Ministerinnen/die Minister",
      translated: "miniștrii",
      tone: 'semantic',
    },
    {
      german: "der Bundesregierung",
      translated: "guvernului federal",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:58|ru": [
    {
      german: "Wer",
      translated: "Кто",
      tone: 'semantic',
    },
    {
      german: "ernennt",
      translated: "назначает",
      tone: 'semantic',
    },
    {
      german: "die Ministerinnen/die Minister",
      translated: "министров",
      tone: 'semantic',
    },
    {
      german: "der Bundesregierung",
      translated: "федерального правительства Германии",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:58|sq": [
    {
      german: "Wer",
      translated: "Kush",
      tone: 'semantic',
    },
    {
      german: "ernennt",
      translated: "emëron",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "gjermane",
      tone: 'semantic',
    },
    {
      german: "die Ministerinnen/die Minister",
      translated: "ministrat",
      tone: 'semantic',
    },
    {
      german: "der Bundesregierung",
      translated: "qeverisë federale",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:58|sr": [
    {
      german: "Wer",
      translated: "Ko",
      tone: 'semantic',
    },
    {
      german: "ernennt",
      translated: "imenuje",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "nemačke",
      tone: 'semantic',
    },
    {
      german: "die Ministerinnen/die Minister",
      translated: "ministre",
      tone: 'semantic',
    },
    {
      german: "der Bundesregierung",
      translated: "savezne vlade",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:58|tr": [
    {
      german: "Wer",
      translated: "kim",
      tone: 'semantic',
    },
    {
      german: "ernennt",
      translated: "atar",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "Almanya'da",
      tone: 'semantic',
    },
    {
      german: "die Ministerinnen/die Minister",
      translated: "bakanlarını",
      tone: 'semantic',
    },
    {
      german: "der Bundesregierung",
      translated: "Federal Hükümetin",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:58|uk": [
    {
      german: "Wer",
      translated: "Хто",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "в Німеччині",
      tone: 'semantic',
    },
    {
      german: "die Ministerinnen/die Minister",
      translated: "міністрів",
      tone: 'semantic',
    },
    {
      german: "der Bundesregierung",
      translated: "федерального уряду",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:58|vi": [
    {
      german: "Wer",
      translated: "Ai",
      tone: 'semantic',
    },
    {
      german: "ernennt",
      translated: "bổ nhiệm",
      tone: 'semantic',
    },
    {
      german: "die Ministerinnen/die Minister",
      translated: "các bộ trưởng",
      tone: 'semantic',
    },
    {
      german: "der Bundesregierung",
      translated: "của Chính phủ Liên bang Đức?",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:59|ar": [
    {
      german: "Vor wie vielen Jahren",
      translated: "منذ كم سنة تقريبًا",
      tone: 'semantic',
    },
    {
      german: "gab es erstmals",
      translated: "وُجدت",
      tone: 'semantic',
    },
    {
      german: "eine jüdische Gemeinde",
      translated: "أول جماعة يهودية",
      tone: 'semantic',
    },
    {
      german: "des heutigen Deutschlands",
      translated: "في أراضي ألمانيا الحالية؟",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:59|bg": [
    {
      german: "Vor wie vielen Jahren",
      translated: "Преди приблизително колко години",
      tone: 'semantic',
    },
    {
      german: "gab es erstmals",
      translated: "е имало първа",
      tone: 'semantic',
    },
    {
      german: "eine jüdische Gemeinde",
      translated: "еврейска общност",
      tone: 'semantic',
    },
    {
      german: "auf dem Gebiet",
      translated: "на територията",
      tone: 'semantic',
    },
    {
      german: "des heutigen Deutschlands",
      translated: "на днешна Германия?",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:59|bs": [
    {
      german: "Vor wie vielen Jahren",
      translated: "Prije otprilike koliko godina",
      tone: 'semantic',
    },
    {
      german: "gab es erstmals",
      translated: "postojala je prva",
      tone: 'semantic',
    },
    {
      german: "eine jüdische Gemeinde",
      translated: "jevrejska zajednica",
      tone: 'semantic',
    },
    {
      german: "auf dem Gebiet",
      translated: "na području",
      tone: 'semantic',
    },
    {
      german: "des heutigen Deutschlands",
      translated: "današnje Njemačke",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:59|el": [
    {
      german: "Vor wie vielen Jahren",
      translated: "Πριν από περίπου πόσα χρόνια",
      tone: 'semantic',
    },
    {
      german: "gab es erstmals",
      translated: "υπήρχε η πρώτη",
      tone: 'semantic',
    },
    {
      german: "eine jüdische Gemeinde",
      translated: "εβραϊκή κοινότητα",
      tone: 'semantic',
    },
    {
      german: "auf dem Gebiet",
      translated: "στην επικράτεια",
      tone: 'semantic',
    },
    {
      german: "des heutigen Deutschlands",
      translated: "της σημερινής Γερμανίας",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:59|en": [
    {
      german: "Vor wie vielen Jahren",
      translated: "How many years ago",
      tone: 'semantic',
    },
    {
      german: "gab es erstmals",
      translated: "was there first",
      tone: 'semantic',
    },
    {
      german: "eine jüdische Gemeinde",
      translated: "a Jewish community",
      tone: 'semantic',
    },
    {
      german: "auf dem Gebiet",
      translated: "in the territory",
      tone: 'semantic',
    },
    {
      german: "des heutigen Deutschlands",
      translated: "of present-day Germany",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:59|es": [
    {
      german: "Vor wie vielen Jahren",
      translated: "¿Hace aproximadamente cuántos años",
      tone: 'semantic',
    },
    {
      german: "gab es erstmals",
      translated: "existió por primera vez",
      tone: 'semantic',
    },
    {
      german: "eine jüdische Gemeinde",
      translated: "una comunidad judía",
      tone: 'semantic',
    },
    {
      german: "auf dem Gebiet",
      translated: "en el territorio",
      tone: 'semantic',
    },
    {
      german: "des heutigen Deutschlands",
      translated: "de la actual Alemania",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:59|fa": [
    {
      german: "Vor wie vielen Jahren",
      translated: "چند سال پیش",
      tone: 'semantic',
    },
    {
      german: "gab es erstmals",
      translated: "نخستین",
      tone: 'semantic',
    },
    {
      german: "eine jüdische Gemeinde",
      translated: "جامعهٔ یهودی",
      tone: 'semantic',
    },
    {
      german: "auf dem Gebiet",
      translated: "در قلمرو",
      tone: 'semantic',
    },
    {
      german: "des heutigen Deutschlands",
      translated: "آلمان امروزی",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:59|fr": [
    {
      german: "Vor wie vielen Jahren",
      translated: "Il y a environ combien d’années",
      tone: 'semantic',
    },
    {
      german: "gab es erstmals",
      translated: "existait-elle",
      tone: 'semantic',
    },
    {
      german: "eine jüdische Gemeinde",
      translated: "communauté juive",
      tone: 'semantic',
    },
    {
      german: "auf dem Gebiet",
      translated: "sur le territoire",
      tone: 'semantic',
    },
    {
      german: "des heutigen Deutschlands",
      translated: "de l’Allemagne actuelle",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:59|hr": [
    {
      german: "Vor wie vielen Jahren",
      translated: "Prije otprilike koliko godina",
      tone: 'semantic',
    },
    {
      german: "gab es erstmals",
      translated: "postojala je prva",
      tone: 'semantic',
    },
    {
      german: "eine jüdische Gemeinde",
      translated: "židovska zajednica",
      tone: 'semantic',
    },
    {
      german: "auf dem Gebiet",
      translated: "na području",
      tone: 'semantic',
    },
    {
      german: "des heutigen Deutschlands",
      translated: "današnje Njemačke",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:59|it": [
    {
      german: "Vor wie vielen Jahren",
      translated: "Circa quanti anni fa",
      tone: 'semantic',
    },
    {
      german: "gab es erstmals",
      translated: "esisteva la prima",
      tone: 'semantic',
    },
    {
      german: "eine jüdische Gemeinde",
      translated: "comunità ebraica",
      tone: 'semantic',
    },
    {
      german: "auf dem Gebiet",
      translated: "sul territorio",
      tone: 'semantic',
    },
    {
      german: "des heutigen Deutschlands",
      translated: "dell’attuale Germania",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:59|kmr": [
    {
      german: "Vor wie vielen Jahren",
      translated: "Nêzîkî çend sal",
      tone: 'semantic',
    },
    {
      german: "gab es erstmals",
      translated: "berê yekem",
      tone: 'semantic',
    },
    {
      german: "eine jüdische Gemeinde",
      translated: "civata Cihûyan",
      tone: 'semantic',
    },
    {
      german: "auf dem Gebiet",
      translated: "li erdê Almanyaya",
      tone: 'semantic',
    },
    {
      german: "des heutigen Deutschlands",
      translated: "îroyîn hebû?",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:59|pl": [
    {
      german: "Vor wie vielen Jahren",
      translated: "Około ile lat temu",
      tone: 'semantic',
    },
    {
      german: "gab es erstmals",
      translated: "istniała",
      tone: 'semantic',
    },
    {
      german: "eine jüdische Gemeinde",
      translated: "gmina żydowska",
      tone: 'semantic',
    },
    {
      german: "auf dem Gebiet",
      translated: "na terenie",
      tone: 'semantic',
    },
    {
      german: "des heutigen Deutschlands",
      translated: "dzisiejszych Niemiec",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:59|prs": [
    {
      german: "Vor wie vielen Jahren",
      translated: "چند سال پیش",
      tone: 'semantic',
    },
    {
      german: "gab es erstmals",
      translated: "وجود داشته است",
      tone: 'semantic',
    },
    {
      german: "eine jüdische Gemeinde",
      translated: "جامعهٔ یهودی",
      tone: 'semantic',
    },
    {
      german: "auf dem Gebiet",
      translated: "در قلمرو",
      tone: 'semantic',
    },
    {
      german: "des heutigen Deutschlands",
      translated: "آلمان امروزی",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:59|ro": [
    {
      german: "Vor wie vielen Jahren",
      translated: "Cu aproximativ câți ani în urmă",
      tone: 'semantic',
    },
    {
      german: "gab es erstmals",
      translated: "exista prima",
      tone: 'semantic',
    },
    {
      german: "eine jüdische Gemeinde",
      translated: "comunitate evreiască",
      tone: 'semantic',
    },
    {
      german: "auf dem Gebiet",
      translated: "pe teritoriul",
      tone: 'semantic',
    },
    {
      german: "des heutigen Deutschlands",
      translated: "Germaniei de astăzi",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:59|ru": [
    {
      german: "Vor wie vielen Jahren",
      translated: "Сколько лет назад",
      tone: 'semantic',
    },
    {
      german: "gab es erstmals",
      translated: "впервые появилась",
      tone: 'semantic',
    },
    {
      german: "eine jüdische Gemeinde",
      translated: "еврейская община",
      tone: 'semantic',
    },
    {
      german: "auf dem Gebiet",
      translated: "на территории",
      tone: 'semantic',
    },
    {
      german: "des heutigen Deutschlands",
      translated: "современной Германии",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:59|sq": [
    {
      german: "Vor wie vielen Jahren",
      translated: "sa vjet më parë",
      tone: 'semantic',
    },
    {
      german: "gab es erstmals",
      translated: "ekzistonte",
      tone: 'semantic',
    },
    {
      german: "eine jüdische Gemeinde",
      translated: "komuniteti i parë hebre",
      tone: 'semantic',
    },
    {
      german: "auf dem Gebiet",
      translated: "në territorin e",
      tone: 'semantic',
    },
    {
      german: "des heutigen Deutschlands",
      translated: "Gjermanisë së sotme?",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:59|sr": [
    {
      german: "Vor wie vielen Jahren",
      translated: "Prije otprilike koliko godina",
      tone: 'semantic',
    },
    {
      german: "gab es erstmals",
      translated: "postojala je prva",
      tone: 'semantic',
    },
    {
      german: "eine jüdische Gemeinde",
      translated: "jevrejska zajednica",
      tone: 'semantic',
    },
    {
      german: "auf dem Gebiet",
      translated: "na oblasti",
      tone: 'semantic',
    },
    {
      german: "des heutigen Deutschlands",
      translated: "današnje Nemačke",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:59|tr": [
    {
      german: "Vor wie vielen Jahren",
      translated: "kaç yıl önce",
      tone: 'semantic',
    },
    {
      german: "gab es erstmals",
      translated: "ilk",
      tone: 'semantic',
    },
    {
      german: "eine jüdische Gemeinde",
      translated: "Yahudi cemaati",
      tone: 'semantic',
    },
    {
      german: "auf dem Gebiet",
      translated: "topraklarında",
      tone: 'semantic',
    },
    {
      german: "des heutigen Deutschlands",
      translated: "Bugünkü Almanya",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:59|uk": [
    {
      german: "Vor wie vielen Jahren",
      translated: "Скільки років тому",
      tone: 'semantic',
    },
    {
      german: "gab es erstmals",
      translated: "вперше існувала",
      tone: 'semantic',
    },
    {
      german: "eine jüdische Gemeinde",
      translated: "єврейська громада",
      tone: 'semantic',
    },
    {
      german: "auf dem Gebiet",
      translated: "на території",
      tone: 'semantic',
    },
    {
      german: "des heutigen Deutschlands",
      translated: "сучасної Німеччини",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:59|vi": [
    {
      german: "Vor wie vielen Jahren",
      translated: "cách đây khoảng bao nhiêu năm",
      tone: 'semantic',
    },
    {
      german: "gab es erstmals",
      translated: "đã tồn tại",
      tone: 'semantic',
    },
    {
      german: "eine jüdische Gemeinde",
      translated: "Cộng đồng Do Thái đầu tiên",
      tone: 'semantic',
    },
    {
      german: "auf dem Gebiet",
      translated: "trên lãnh thổ",
      tone: 'semantic',
    },
    {
      german: "des heutigen Deutschlands",
      translated: "nước Đức ngày nay",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:5|ar": [
    {
      german: "Wahlen",
      translated: "الانتخابات",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "في ألمانيا",
      tone: 'semantic',
    },
    {
      german: "sind frei",
      translated: "حرة",
      tone: 'semantic',
    },
    {
      german: "Was bedeutet",
      translated: "ماذا يعني",
      tone: 'semantic',
    },
    {
      german: "das",
      translated: "ذلك",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:5|bg": [
    {
      german: "Wahlen",
      translated: "Изборите",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "в Германия",
      tone: 'semantic',
    },
    {
      german: "sind frei",
      translated: "са свободни",
      tone: 'semantic',
    },
    {
      german: "Was bedeutet",
      translated: "Какво означава",
      tone: 'semantic',
    },
    {
      german: "das",
      translated: "това",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:5|bs": [
    {
      german: "Wahlen",
      translated: "Izbori",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "u Njemačkoj",
      tone: 'semantic',
    },
    {
      german: "sind frei",
      translated: "su slobodni",
      tone: 'semantic',
    },
    {
      german: "Was bedeutet",
      translated: "Što",
      tone: 'semantic',
    },
    {
      german: "das",
      translated: "to znači",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:5|el": [
    {
      german: "Wahlen",
      translated: "Οι εκλογές",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "στη Γερμανία",
      tone: 'semantic',
    },
    {
      german: "sind frei",
      translated: "είναι ελεύθερες",
      tone: 'semantic',
    },
    {
      german: "Was bedeutet",
      translated: "Τι σημαίνει",
      tone: 'semantic',
    },
    {
      german: "das",
      translated: "αυτό",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:5|en": [
    {
      german: "Wahlen",
      translated: "Elections",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "in Germany",
      tone: 'semantic',
    },
    {
      german: "sind frei",
      translated: "are free",
      tone: 'semantic',
    },
    {
      german: "Was bedeutet",
      translated: "What does",
      tone: 'semantic',
    },
    {
      german: "das",
      translated: "this",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:5|es": [
    {
      german: "Wahlen",
      translated: "Las elecciones",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "en Alemania",
      tone: 'semantic',
    },
    {
      german: "sind frei",
      translated: "son libres",
      tone: 'semantic',
    },
    {
      german: "Was bedeutet",
      translated: "¿Qué significa",
      tone: 'semantic',
    },
    {
      german: "das",
      translated: "eso",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:5|fa": [
    {
      german: "Wahlen",
      translated: "انتخابات",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "در آلمان",
      tone: 'semantic',
    },
    {
      german: "sind frei",
      translated: "آزاد",
      tone: 'semantic',
    },
    {
      german: "Was bedeutet",
      translated: " یعنی چه",
      tone: 'semantic',
    },
    {
      german: "das",
      translated: "است",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:5|fr": [
    {
      german: "Wahlen",
      translated: "Les élections",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "en Allemagne",
      tone: 'semantic',
    },
    {
      german: "sind frei",
      translated: "sont libres",
      tone: 'semantic',
    },
    {
      german: "Was bedeutet",
      translated: "Qu’est-ce que cela signifie",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:5|hr": [
    {
      german: "Wahlen",
      translated: "Izbori",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "u Njemačkoj",
      tone: 'semantic',
    },
    {
      german: "sind frei",
      translated: "su slobodni",
      tone: 'semantic',
    },
    {
      german: "Was bedeutet",
      translated: "Što",
      tone: 'semantic',
    },
    {
      german: "das",
      translated: "to znači",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:5|it": [
    {
      german: "Wahlen",
      translated: "Le elezioni",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "in Germania",
      tone: 'semantic',
    },
    {
      german: "sind frei",
      translated: "sono libere",
      tone: 'semantic',
    },
    {
      german: "Was bedeutet",
      translated: "Che cosa significa",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:5|kmr": [
    {
      german: "Wahlen",
      translated: "Hilbijartinên",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "Almanyayê",
      tone: 'semantic',
    },
    {
      german: "sind frei",
      translated: "azad in",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:5|pl": [
    {
      german: "Wahlen",
      translated: "Wybory",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "w Niemczech",
      tone: 'semantic',
    },
    {
      german: "sind frei",
      translated: "są wolne",
      tone: 'semantic',
    },
    {
      german: "Was bedeutet",
      translated: "Co to oznacza",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:5|prs": [
    {
      german: "Wahlen",
      translated: "انتخابات",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "در آلمان",
      tone: 'semantic',
    },
    {
      german: "sind frei",
      translated: "آزاد",
      tone: 'semantic',
    },
    {
      german: "Was bedeutet",
      translated: "این یعنی",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:5|ro": [
    {
      german: "Wahlen",
      translated: "Alegerile",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "din Germania",
      tone: 'semantic',
    },
    {
      german: "sind frei",
      translated: "sunt libere",
      tone: 'semantic',
    },
    {
      german: "Was bedeutet",
      translated: "Ce înseamnă",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:5|ru": [
    {
      german: "Wahlen",
      translated: "Выборы",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "в Германии",
      tone: 'semantic',
    },
    {
      german: "sind frei",
      translated: "свободные",
      tone: 'semantic',
    },
    {
      german: "Was bedeutet",
      translated: "Что это значит",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:5|sq": [
    {
      german: "Wahlen",
      translated: "Zgjedhjet",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "në Gjermani",
      tone: 'semantic',
    },
    {
      german: "sind frei",
      translated: "të lira",
      tone: 'semantic',
    },
    {
      german: "Was bedeutet",
      translated: "Çfarë do të thotë",
      tone: 'semantic',
    },
    {
      german: "das",
      translated: "kjo",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:5|sr": [
    {
      german: "Wahlen",
      translated: "Izbori",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "u Nemačkoj",
      tone: 'semantic',
    },
    {
      german: "sind frei",
      translated: "su slobodni",
      tone: 'semantic',
    },
    {
      german: "Was bedeutet",
      translated: "to",
      tone: 'semantic',
    },
    {
      german: "das",
      translated: "znači",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:5|tr": [
    {
      german: "Wahlen",
      translated: "seçimler",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "Almanya'da",
      tone: 'semantic',
    },
    {
      german: "sind frei",
      translated: "özgürdür",
      tone: 'semantic',
    },
    {
      german: "Was bedeutet",
      translated: "Bu ne anlama gelir",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:5|uk": [
    {
      german: "Wahlen",
      translated: "Вибори",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "в Німеччині",
      tone: 'semantic',
    },
    {
      german: "sind frei",
      translated: "є вільними",
      tone: 'semantic',
    },
    {
      german: "Was bedeutet",
      translated: "Що це означає",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:5|vi": [
    {
      german: "Wahlen",
      translated: "Các cuộc bầu cử",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "ở Đức",
      tone: 'semantic',
    },
    {
      german: "sind frei",
      translated: "là tự do",
      tone: 'semantic',
    },
    {
      german: "Was bedeutet",
      translated: "Điều đó có nghĩa là",
      tone: 'semantic',
    },
    {
      german: "das",
      translated: "gì",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:60|ar": [
    {
      german: "In Deutschland",
      translated: "في ألمانيا",
      tone: 'semantic',
    },
    {
      german: "gehören",
      translated: "ينتمي",
      tone: 'semantic',
    },
    {
      german: "der Bundestag und der Bundesrat",
      translated: "البوندستاغ والبوندسرات",
      tone: 'semantic',
    },
    {
      german: "zur",
      translated: "إلى السلطة …",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:60|bg": [
    {
      german: "In Deutschland",
      translated: "В Германия",
      tone: 'semantic',
    },
    {
      german: "der Bundestag und der Bundesrat",
      translated: "Бундестагът и Бундесратът",
      tone: 'semantic',
    },
    {
      german: "zur",
      translated: "към",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:60|bs": [
    {
      german: "In Deutschland",
      translated: "U Njemačkoj",
      tone: 'semantic',
    },
    {
      german: "gehören",
      translated: "pripadaju",
      tone: 'semantic',
    },
    {
      german: "der Bundestag und der Bundesrat",
      translated: "Bundestag i Bundesrat",
      tone: 'semantic',
    },
    {
      german: "zur",
      translated: "… vlasti",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:60|el": [
    {
      german: "In Deutschland",
      translated: "Στη Γερμανία",
      tone: 'semantic',
    },
    {
      german: "gehören",
      translated: "ανήκουν",
      tone: 'semantic',
    },
    {
      german: "der Bundestag und der Bundesrat",
      translated: "το Bundestag και το Bundesrat",
      tone: 'semantic',
    },
    {
      german: "zur",
      translated: "στη …",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:60|en": [
    {
      german: "In Deutschland",
      translated: "In Germany",
      tone: 'semantic',
    },
    {
      german: "gehören",
      translated: "belong",
      tone: 'semantic',
    },
    {
      german: "der Bundestag und der Bundesrat",
      translated: "the Bundestag and the Bundesrat",
      tone: 'semantic',
    },
    {
      german: "zur",
      translated: "to the",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:60|es": [
    {
      german: "In Deutschland",
      translated: "En Alemania",
      tone: 'semantic',
    },
    {
      german: "gehören",
      translated: "pertenecen",
      tone: 'semantic',
    },
    {
      german: "der Bundestag und der Bundesrat",
      translated: "el Bundestag y el Bundesrat",
      tone: 'semantic',
    },
    {
      german: "zur",
      translated: "al poder …",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:60|fa": [
    {
      german: "In Deutschland",
      translated: "در آلمان،",
      tone: 'semantic',
    },
    {
      german: "gehören",
      translated: "به قوهٔ",
      tone: 'semantic',
    },
    {
      german: "der Bundestag und der Bundesrat",
      translated: "بوندستاگ و بوندسرات",
      tone: 'semantic',
    },
    {
      german: "zur",
      translated: "…",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:60|fr": [
    {
      german: "In Deutschland",
      translated: "En Allemagne",
      tone: 'semantic',
    },
    {
      german: "gehören",
      translated: "appartiennent",
      tone: 'semantic',
    },
    {
      german: "der Bundestag und der Bundesrat",
      translated: "le Bundestag et le Bundesrat",
      tone: 'semantic',
    },
    {
      german: "zur",
      translated: "au pouvoir",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:60|hr": [
    {
      german: "In Deutschland",
      translated: "U Njemačkoj",
      tone: 'semantic',
    },
    {
      german: "gehören",
      translated: "pripadaju",
      tone: 'semantic',
    },
    {
      german: "der Bundestag und der Bundesrat",
      translated: "Bundestag i Bundesrat",
      tone: 'semantic',
    },
    {
      german: "zur",
      translated: "… vlasti",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:60|it": [
    {
      german: "In Deutschland",
      translated: "In Germania",
      tone: 'semantic',
    },
    {
      german: "gehören",
      translated: "appartengono",
      tone: 'semantic',
    },
    {
      german: "der Bundestag und der Bundesrat",
      translated: "Bundestag e Bundesrat",
      tone: 'semantic',
    },
    {
      german: "zur",
      translated: "al potere",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:60|kmr": [
    {
      german: "In Deutschland",
      translated: "Li Almanyayê",
      tone: 'semantic',
    },
    {
      german: "der Bundestag und der Bundesrat",
      translated: "Bundestag û Bundesrat",
      tone: 'semantic',
    },
    {
      german: "zur",
      translated: "ji hêza",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:60|pl": [
    {
      german: "In Deutschland",
      translated: "W Niemczech",
      tone: 'semantic',
    },
    {
      german: "gehören",
      translated: "należą",
      tone: 'semantic',
    },
    {
      german: "der Bundestag und der Bundesrat",
      translated: "Bundestag i Bundesrat",
      tone: 'semantic',
    },
    {
      german: "zur",
      translated: "do władzy …",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:60|prs": [
    {
      german: "In Deutschland",
      translated: "در آلمان",
      tone: 'semantic',
    },
    {
      german: "gehören",
      translated: "به قوهٔ",
      tone: 'semantic',
    },
    {
      german: "der Bundestag und der Bundesrat",
      translated: "بوندستاگ و بوندسرات",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:60|ro": [
    {
      german: "In Deutschland",
      translated: "În Germania",
      tone: 'semantic',
    },
    {
      german: "gehören",
      translated: "fac parte",
      tone: 'semantic',
    },
    {
      german: "der Bundestag und der Bundesrat",
      translated: "Bundestagul și Bundesratul",
      tone: 'semantic',
    },
    {
      german: "zur",
      translated: "din puterea …",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:60|ru": [
    {
      german: "In Deutschland",
      translated: "В Германии",
      tone: 'semantic',
    },
    {
      german: "der Bundestag und der Bundesrat",
      translated: "Бундестаг и Бундесрат",
      tone: 'semantic',
    },
    {
      german: "zur",
      translated: "относятся к …",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:60|sq": [
    {
      german: "In Deutschland",
      translated: "Në Gjermani",
      tone: 'semantic',
    },
    {
      german: "gehören",
      translated: "i përkasin",
      tone: 'semantic',
    },
    {
      german: "der Bundestag und der Bundesrat",
      translated: "Bundestagu dhe Bundesrati",
      tone: 'semantic',
    },
    {
      german: "zur",
      translated: "pushtetit",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:60|sr": [
    {
      german: "In Deutschland",
      translated: "U Nemačkoj",
      tone: 'semantic',
    },
    {
      german: "gehören",
      translated: "pripadaju",
      tone: 'semantic',
    },
    {
      german: "der Bundestag und der Bundesrat",
      translated: "Bundestag i Bundesrat",
      tone: 'semantic',
    },
    {
      german: "zur",
      translated: "… vlasti",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:60|tr": [
    {
      german: "In Deutschland",
      translated: "Almanya'da",
      tone: 'semantic',
    },
    {
      german: "der Bundestag und der Bundesrat",
      translated: "Federal Meclis ve Federal Konsey",
      tone: 'semantic',
    },
    {
      german: "zur",
      translated: "organlarıdır.",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:60|uk": [
    {
      german: "In Deutschland",
      translated: "У Німеччині",
      tone: 'semantic',
    },
    {
      german: "gehören",
      translated: "належать",
      tone: 'semantic',
    },
    {
      german: "der Bundestag und der Bundesrat",
      translated: "Бундестаг і Бундесрат",
      tone: 'semantic',
    },
    {
      german: "zur",
      translated: "до",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:60|vi": [
    {
      german: "In Deutschland",
      translated: "Ở Đức",
      tone: 'semantic',
    },
    {
      german: "gehören",
      translated: "thuộc",
      tone: 'semantic',
    },
    {
      german: "der Bundestag und der Bundesrat",
      translated: "Bundestag và Bundesrat",
      tone: 'semantic',
    },
    {
      german: "zur",
      translated: "quyền lực",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:61|ar": [
    {
      german: "Was",
      translated: "ماذا",
      tone: 'semantic',
    },
    {
      german: "bedeutet",
      translated: "تعني",
      tone: 'semantic',
    },
    {
      german: "Volkssouveränität",
      translated: "«سيادة الشعب»",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:61|bg": [
    {
      german: "Was",
      translated: "Какво",
      tone: 'semantic',
    },
    {
      german: "bedeutet",
      translated: "означава",
      tone: 'semantic',
    },
    {
      german: "Volkssouveränität",
      translated: "„народен суверенитет“",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:61|bs": [
    {
      german: "Was",
      translated: "Što",
      tone: 'semantic',
    },
    {
      german: "bedeutet",
      translated: "znači",
      tone: 'semantic',
    },
    {
      german: "Volkssouveränität",
      translated: "„narodni suverenitet“",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:61|el": [
    {
      german: "Was",
      translated: "Τι",
      tone: 'semantic',
    },
    {
      german: "bedeutet",
      translated: "σημαίνει",
      tone: 'semantic',
    },
    {
      german: "Volkssouveränität",
      translated: "λαϊκή κυριαρχία",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:61|en": [
    {
      german: "Was",
      translated: "What",
      tone: 'semantic',
    },
    {
      german: "bedeutet",
      translated: "does",
      tone: 'semantic',
    },
    {
      german: "Volkssouveränität",
      translated: "popular sovereignty",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:61|es": [
    {
      german: "Was",
      translated: "¿Qué",
      tone: 'semantic',
    },
    {
      german: "bedeutet",
      translated: "significa",
      tone: 'semantic',
    },
    {
      german: "Volkssouveränität",
      translated: "soberanía popular",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:61|fa": [
    {
      german: "Was",
      translated: "چه",
      tone: 'semantic',
    },
    {
      german: "bedeutet",
      translated: "یعنی",
      tone: 'semantic',
    },
    {
      german: "Volkssouveränität",
      translated: "«حاکمیت مردم»",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:61|fr": [
    {
      german: "Was",
      translated: "Que",
      tone: 'semantic',
    },
    {
      german: "bedeutet",
      translated: "signifie",
      tone: 'semantic',
    },
    {
      german: "Volkssouveränität",
      translated: "« souveraineté populaire »",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:61|hr": [
    {
      german: "Was",
      translated: "Što",
      tone: 'semantic',
    },
    {
      german: "bedeutet",
      translated: " znači",
      tone: 'semantic',
    },
    {
      german: "Volkssouveränität",
      translated: "„narodni suverenitet“",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:61|it": [
    {
      german: "Was",
      translated: "Che cosa",
      tone: 'semantic',
    },
    {
      german: "bedeutet",
      translated: "significa",
      tone: 'semantic',
    },
    {
      german: "Volkssouveränität",
      translated: "sovranità popolare",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:61|kmr": [
    {
      german: "bedeutet",
      translated: "«Serweriya gel»",
      tone: 'semantic',
    },
    {
      german: "Volkssouveränität",
      translated: "tê çi wateyê?",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:61|pl": [
    {
      german: "Was",
      translated: "Co",
      tone: 'semantic',
    },
    {
      german: "bedeutet",
      translated: "oznacza",
      tone: 'semantic',
    },
    {
      german: "Volkssouveränität",
      translated: "suwerenność ludu",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:61|prs": [
    {
      german: "Was",
      translated: "«حاکمیت مردم»",
      tone: 'semantic',
    },
    {
      german: "bedeutet",
      translated: "یعنی",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:61|ro": [
    {
      german: "Was",
      translated: "Ce",
      tone: 'semantic',
    },
    {
      german: "bedeutet",
      translated: "înseamnă",
      tone: 'semantic',
    },
    {
      german: "Volkssouveränität",
      translated: "„suveranitatea poporului”",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:61|ru": [
    {
      german: "Was",
      translated: "Что",
      tone: 'semantic',
    },
    {
      german: "bedeutet",
      translated: "означает",
      tone: 'semantic',
    },
    {
      german: "Volkssouveränität",
      translated: "народный суверенитет",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:61|sq": [
    {
      german: "Was",
      translated: "Çfarë",
      tone: 'semantic',
    },
    {
      german: "bedeutet",
      translated: "do të thotë",
      tone: 'semantic',
    },
    {
      german: "Volkssouveränität",
      translated: "sovraniteti i popullit",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:61|sr": [
    {
      german: "bedeutet",
      translated: "Šta znači",
      tone: 'semantic',
    },
    {
      german: "Volkssouveränität",
      translated: "narodni suverenitet",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:61|tr": [
    {
      german: "Was",
      translated: "ne",
      tone: 'semantic',
    },
    {
      german: "bedeutet",
      translated: "demektir",
      tone: 'semantic',
    },
    {
      german: "Volkssouveränität",
      translated: "Halk egemenliği",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:61|uk": [
    {
      german: "Was",
      translated: "Що",
      tone: 'semantic',
    },
    {
      german: "bedeutet",
      translated: "означає «",
      tone: 'semantic',
    },
    {
      german: "Volkssouveränität",
      translated: "народний суверенітет",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:61|vi": [
    {
      german: "bedeutet",
      translated: "có nghĩa là gì",
      tone: 'semantic',
    },
    {
      german: "Volkssouveränität",
      translated: "Chủ quyền nhân dân",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:62|ar": [
    {
      german: "Wenn das Parlament",
      translated: "برلمان",
      tone: 'semantic',
    },
    {
      german: "eines deutschen Bundeslandes",
      translated: "ولاية اتحادية ألمانية",
      tone: 'semantic',
    },
    {
      german: "gewählt wird",
      translated: "يُنتخب",
      tone: 'semantic',
    },
    {
      german: "nennt man das",
      translated: "تسمى هذه الانتخابات",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:62|bg": [
    {
      german: "Wenn das Parlament",
      translated: "парламента",
      tone: 'semantic',
    },
    {
      german: "eines deutschen Bundeslandes",
      translated: "на германска федерална провинция",
      tone: 'semantic',
    },
    {
      german: "gewählt wird",
      translated: "изборите",
      tone: 'semantic',
    },
    {
      german: "nennt man das",
      translated: "Как се наричат",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:62|bs": [
    {
      german: "Wenn das Parlament",
      translated: "parlament",
      tone: 'semantic',
    },
    {
      german: "eines deutschen Bundeslandes",
      translated: "njemačke savezne zemlje",
      tone: 'semantic',
    },
    {
      german: "gewählt wird",
      translated: "izbori",
      tone: 'semantic',
    },
    {
      german: "nennt man das",
      translated: "Kako se nazivaju",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:62|el": [
    {
      german: "Wenn das Parlament",
      translated: "το κοινοβούλιο",
      tone: 'semantic',
    },
    {
      german: "eines deutschen Bundeslandes",
      translated: "ενός γερμανικού κρατιδίου",
      tone: 'semantic',
    },
    {
      german: "gewählt wird",
      translated: "οι εκλογές",
      tone: 'semantic',
    },
    {
      german: "nennt man das",
      translated: "Πώς ονομάζονται",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:62|en": [
    {
      german: "Wenn das Parlament",
      translated: "When the parliament",
      tone: 'semantic',
    },
    {
      german: "eines deutschen Bundeslandes",
      translated: "of a German federal state",
      tone: 'semantic',
    },
    {
      german: "gewählt wird",
      translated: "is elected",
      tone: 'semantic',
    },
    {
      german: "nennt man das",
      translated: "it is called",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:62|es": [
    {
      german: "Wenn das Parlament",
      translated: "el parlamento",
      tone: 'semantic',
    },
    {
      german: "eines deutschen Bundeslandes",
      translated: "estado federado alemán",
      tone: 'semantic',
    },
    {
      german: "gewählt wird",
      translated: "se elige",
      tone: 'semantic',
    },
    {
      german: "nennt man das",
      translated: "esas elecciones se llaman",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:62|fa": [
    {
      german: "Wenn das Parlament",
      translated: "وقتی پارلمان",
      tone: 'semantic',
    },
    {
      german: "eines deutschen Bundeslandes",
      translated: "ایالت آلمان",
      tone: 'semantic',
    },
    {
      german: "gewählt wird",
      translated: "انتخاب می‌شود",
      tone: 'semantic',
    },
    {
      german: "nennt man das",
      translated: "این انتخابات چه نام دارد",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:62|fr": [
    {
      german: "Wenn das Parlament",
      translated: "le Parlement",
      tone: 'semantic',
    },
    {
      german: "eines deutschen Bundeslandes",
      translated: "d’un Land allemand",
      tone: 'semantic',
    },
    {
      german: "gewählt wird",
      translated: "élit",
      tone: 'semantic',
    },
    {
      german: "nennt man das",
      translated: "cette élection s’appelle …",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:62|hr": [
    {
      german: "Wenn das Parlament",
      translated: "parlament",
      tone: 'semantic',
    },
    {
      german: "eines deutschen Bundeslandes",
      translated: "njemačke savezne zemlje",
      tone: 'semantic',
    },
    {
      german: "gewählt wird",
      translated: "izbori",
      tone: 'semantic',
    },
    {
      german: "nennt man das",
      translated: "Kako se nazivaju",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:62|it": [
    {
      german: "Wenn das Parlament",
      translated: "il Parlamento",
      tone: 'semantic',
    },
    {
      german: "eines deutschen Bundeslandes",
      translated: "di un Land tedesco",
      tone: 'semantic',
    },
    {
      german: "gewählt wird",
      translated: "le elezioni",
      tone: 'semantic',
    },
    {
      german: "nennt man das",
      translated: "Come si chiamano",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:62|kmr": [
    {
      german: "Wenn das Parlament",
      translated: "Dema ku parlamentoya",
      tone: 'semantic',
    },
    {
      german: "eines deutschen Bundeslandes",
      translated: "eyaleteke federal a Alman",
      tone: 'semantic',
    },
    {
      german: "gewählt wird",
      translated: "hilbijartin",
      tone: 'semantic',
    },
    {
      german: "nennt man das",
      translated: "ev tê gotin",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:62|pl": [
    {
      german: "Wenn das Parlament",
      translated: "parlamentu",
      tone: 'semantic',
    },
    {
      german: "eines deutschen Bundeslandes",
      translated: "niemieckiego kraju związkowego",
      tone: 'semantic',
    },
    {
      german: "gewählt wird",
      translated: "wybory",
      tone: 'semantic',
    },
    {
      german: "nennt man das",
      translated: "Jak nazywają się",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:62|prs": [
    {
      german: "Wenn das Parlament",
      translated: "وقتی پارلمان",
      tone: 'semantic',
    },
    {
      german: "eines deutschen Bundeslandes",
      translated: "یک ایالت آلمان",
      tone: 'semantic',
    },
    {
      german: "gewählt wird",
      translated: " انتخاب می‌شود",
      tone: 'semantic',
    },
    {
      german: "nennt man das",
      translated: "، این انتخابات چه نام دارد؟",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:62|ro": [
    {
      german: "Wenn das Parlament",
      translated: "parlamentul",
      tone: 'semantic',
    },
    {
      german: "eines deutschen Bundeslandes",
      translated: "unui land german",
      tone: 'semantic',
    },
    {
      german: "gewählt wird",
      translated: "alegerile",
      tone: 'semantic',
    },
    {
      german: "nennt man das",
      translated: "Cum se numesc",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:62|ru": [
    {
      german: "Wenn das Parlament",
      translated: "Когда избирается парламент",
      tone: 'semantic',
    },
    {
      german: "eines deutschen Bundeslandes",
      translated: "одной из федеральных земель Германии",
      tone: 'semantic',
    },
    {
      german: "nennt man das",
      translated: "это называют",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:62|sq": [
    {
      german: "Wenn das Parlament",
      translated: "parlamentin",
      tone: 'semantic',
    },
    {
      german: "eines deutschen Bundeslandes",
      translated: "një landi gjerman",
      tone: 'semantic',
    },
    {
      german: "gewählt wird",
      translated: "zgjedhjet",
      tone: 'semantic',
    },
    {
      german: "nennt man das",
      translated: "Si quhen",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:62|sr": [
    {
      german: "Wenn das Parlament",
      translated: "parlament",
      tone: 'semantic',
    },
    {
      german: "eines deutschen Bundeslandes",
      translated: "nemačke savezne",
      tone: 'semantic',
    },
    {
      german: "gewählt wird",
      translated: "izbori",
      tone: 'semantic',
    },
    {
      german: "nennt man das",
      translated: "Kako se nazivaju",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:62|tr": [
    {
      german: "Wenn das Parlament",
      translated: "parlamentosu",
      tone: 'semantic',
    },
    {
      german: "eines deutschen Bundeslandes",
      translated: "Bir Alman eyaletinin",
      tone: 'semantic',
    },
    {
      german: "gewählt wird",
      translated: "seçildiğinde",
      tone: 'semantic',
    },
    {
      german: "nennt man das",
      translated: "bu seçime ne denir",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:62|uk": [
    {
      german: "Wenn das Parlament",
      translated: "Коли",
      tone: 'semantic',
    },
    {
      german: "eines deutschen Bundeslandes",
      translated: "федеральних земель Німеччини",
      tone: 'semantic',
    },
    {
      german: "gewählt wird",
      translated: "обирають",
      tone: 'semantic',
    },
    {
      german: "nennt man das",
      translated: "ці вибори називаються …",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:62|vi": [
    {
      german: "Wenn das Parlament",
      translated: "nghị viện của",
      tone: 'semantic',
    },
    {
      german: "eines deutschen Bundeslandes",
      translated: "một bang Đức",
      tone: 'semantic',
    },
    {
      german: "gewählt wird",
      translated: "bầu cử",
      tone: 'semantic',
    },
    {
      german: "nennt man das",
      translated: "được gọi là",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:63|ar": [
    {
      german: "Was",
      translated: "أي",
      tone: 'semantic',
    },
    {
      german: "gehört",
      translated: "ينتمي",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "في ألمانيا",
      tone: 'semantic',
    },
    {
      german: "nicht",
      translated: "لا",
      tone: 'semantic',
    },
    {
      german: "zur Exekutive",
      translated: "السلطة التنفيذية",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:63|bg": [
    {
      german: "Was",
      translated: "Кое",
      tone: 'semantic',
    },
    {
      german: "gehört",
      translated: "принадлежи",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "в Германия",
      tone: 'semantic',
    },
    {
      german: "nicht",
      translated: "НЕ",
      tone: 'semantic',
    },
    {
      german: "zur Exekutive",
      translated: "към изпълнителната власт",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:63|bs": [
    {
      german: "Was",
      translated: "Što",
      tone: 'semantic',
    },
    {
      german: "gehört",
      translated: "pripada",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "u Njemačkoj",
      tone: 'semantic',
    },
    {
      german: "nicht",
      translated: "NE",
      tone: 'semantic',
    },
    {
      german: "zur Exekutive",
      translated: "izvršnoj vlasti",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:63|el": [
    {
      german: "Was",
      translated: "Ποιο",
      tone: 'semantic',
    },
    {
      german: "gehört",
      translated: "ανήκει",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "στη Γερμανία",
      tone: 'semantic',
    },
    {
      german: "nicht",
      translated: "ΔΕΝ",
      tone: 'semantic',
    },
    {
      german: "zur Exekutive",
      translated: "στην εκτελεστική εξουσία",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:63|en": [
    {
      german: "Was",
      translated: "What",
      tone: 'semantic',
    },
    {
      german: "gehört",
      translated: "does",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "in Germany",
      tone: 'semantic',
    },
    {
      german: "nicht",
      translated: "NOT",
      tone: 'semantic',
    },
    {
      german: "zur Exekutive",
      translated: "to the executive branch",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:63|es": [
    {
      german: "Was",
      translated: "¿Qué",
      tone: 'semantic',
    },
    {
      german: "gehört",
      translated: "pertenece",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "en Alemania",
      tone: 'semantic',
    },
    {
      german: "nicht",
      translated: "NO",
      tone: 'semantic',
    },
    {
      german: "zur Exekutive",
      translated: "al poder ejecutivo",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:63|fa": [
    {
      german: "Was",
      translated: "کدام",
      tone: 'semantic',
    },
    {
      german: "gehört",
      translated: "مورد",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "در آلمان",
      tone: 'semantic',
    },
    {
      german: "nicht",
      translated: "ندارد",
      tone: 'semantic',
    },
    {
      german: "zur Exekutive",
      translated: "؟",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:63|fr": [
    {
      german: "Was",
      translated: "Lequel",
      tone: 'semantic',
    },
    {
      german: "gehört",
      translated: "appartient",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "en Allemagne",
      tone: 'semantic',
    },
    {
      german: "nicht",
      translated: "pas",
      tone: 'semantic',
    },
    {
      german: "zur Exekutive",
      translated: "au pouvoir exécutif",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:63|hr": [
    {
      german: "Was",
      translated: "Što",
      tone: 'semantic',
    },
    {
      german: "gehört",
      translated: "pripada",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "u Njemačkoj",
      tone: 'semantic',
    },
    {
      german: "nicht",
      translated: "NE",
      tone: 'semantic',
    },
    {
      german: "zur Exekutive",
      translated: "izvršnoj vlasti",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:63|it": [
    {
      german: "Was",
      translated: "Quale",
      tone: 'semantic',
    },
    {
      german: "gehört",
      translated: "appartiene",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "in Germania",
      tone: 'semantic',
    },
    {
      german: "nicht",
      translated: "NON",
      tone: 'semantic',
    },
    {
      german: "zur Exekutive",
      translated: "al potere esecutivo",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:63|kmr": [
    {
      german: "Was",
      translated: "kîjan",
      tone: 'semantic',
    },
    {
      german: "gehört",
      translated: "beşek",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "Li Almanyayê",
      tone: 'semantic',
    },
    {
      german: "nicht",
      translated: "ne",
      tone: 'semantic',
    },
    {
      german: "zur Exekutive",
      translated: "ji hêza cîbicîkar",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:63|pl": [
    {
      german: "Was",
      translated: "Które z poniższych",
      tone: 'semantic',
    },
    {
      german: "gehört",
      translated: "należy",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "w Niemczech",
      tone: 'semantic',
    },
    {
      german: "nicht",
      translated: "NIE",
      tone: 'semantic',
    },
    {
      german: "zur Exekutive",
      translated: "do władzy wykonawczej",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:63|prs": [
    {
      german: "in Deutschland",
      translated: "در آلمان",
      tone: 'semantic',
    },
    {
      german: "nicht",
      translated: "به قوهٔ مجریه تعلق ندارد",
      tone: 'semantic',
    },
    {
      german: "zur Exekutive",
      translated: "؟",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:63|ro": [
    {
      german: "Was",
      translated: "Care",
      tone: 'semantic',
    },
    {
      german: "gehört",
      translated: "aparține",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "în Germania",
      tone: 'semantic',
    },
    {
      german: "nicht",
      translated: "NU",
      tone: 'semantic',
    },
    {
      german: "zur Exekutive",
      translated: "puterii executive",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:63|ru": [
    {
      german: "Was",
      translated: "Что",
      tone: 'semantic',
    },
    {
      german: "gehört",
      translated: "относится",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "в Германии",
      tone: 'semantic',
    },
    {
      german: "nicht",
      translated: "не",
      tone: 'semantic',
    },
    {
      german: "zur Exekutive",
      translated: "к исполнительной власти",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:63|sq": [
    {
      german: "Was",
      translated: "Cila",
      tone: 'semantic',
    },
    {
      german: "gehört",
      translated: "i përket",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "në Gjermani",
      tone: 'semantic',
    },
    {
      german: "nicht",
      translated: "NUK",
      tone: 'semantic',
    },
    {
      german: "zur Exekutive",
      translated: "pushtetit ekzekutiv",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:63|sr": [
    {
      german: "Was",
      translated: "Šta",
      tone: 'semantic',
    },
    {
      german: "gehört",
      translated: "od navedenoga",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "u Nemačkoj",
      tone: 'semantic',
    },
    {
      german: "nicht",
      translated: "NE",
      tone: 'semantic',
    },
    {
      german: "zur Exekutive",
      translated: "izvršnoj vlasti",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:63|tr": [
    {
      german: "Was",
      translated: "hangisi",
      tone: 'semantic',
    },
    {
      german: "gehört",
      translated: "ait",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "Almanya'da",
      tone: 'semantic',
    },
    {
      german: "nicht",
      translated: "değildir",
      tone: 'semantic',
    },
    {
      german: "zur Exekutive",
      translated: "yürütme organına",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:63|uk": [
    {
      german: "Was",
      translated: "Що",
      tone: 'semantic',
    },
    {
      german: "gehört",
      translated: "належить",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "в Німеччині",
      tone: 'semantic',
    },
    {
      german: "nicht",
      translated: "не",
      tone: 'semantic',
    },
    {
      german: "zur Exekutive",
      translated: "до виконавчої влади",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:63|vi": [
    {
      german: "Was",
      translated: "Điều nào",
      tone: 'semantic',
    },
    {
      german: "gehört",
      translated: "thuộc",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "ở Đức",
      tone: 'semantic',
    },
    {
      german: "nicht",
      translated: "KHÔNG",
      tone: 'semantic',
    },
    {
      german: "zur Exekutive",
      translated: "quyền hành pháp",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:64|ar": [
    {
      german: "Die Bundesrepublik Deutschland",
      translated: "جمهورية ألمانيا الاتحادية",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "تنقسم",
      tone: 'semantic',
    },
    {
      german: "heute",
      translated: "اليوم",
      tone: 'semantic',
    },
    {
      german: "gegliedert in",
      translated: "إلى",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:64|bg": [
    {
      german: "Die Bundesrepublik Deutschland",
      translated: "Федерална република Германия",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "е",
      tone: 'semantic',
    },
    {
      german: "heute",
      translated: "днес",
      tone: 'semantic',
    },
    {
      german: "gegliedert in",
      translated: "административно разделена на",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:64|bs": [
    {
      german: "Die Bundesrepublik Deutschland",
      translated: "Savezna Republika Njemačka",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "je",
      tone: 'semantic',
    },
    {
      german: "heute",
      translated: "danas",
      tone: 'semantic',
    },
    {
      german: "gegliedert in",
      translated: "administrativno podijeljena na",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:64|el": [
    {
      german: "Die Bundesrepublik Deutschland",
      translated: "Η Ομοσπονδιακή Δημοκρατία της Γερμανίας",
      tone: 'semantic',
    },
    {
      german: "gegliedert in",
      translated: "χωρίζεται διοικητικά σε",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:64|en": [
    {
      german: "Die Bundesrepublik Deutschland",
      translated: "The Federal Republic of Germany",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "is",
      tone: 'semantic',
    },
    {
      german: "heute",
      translated: "today",
      tone: 'semantic',
    },
    {
      german: "gegliedert in",
      translated: "divided into",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:64|es": [
    {
      german: "Die Bundesrepublik Deutschland",
      translated: "la República Federal de Alemania",
      tone: 'semantic',
    },
    {
      german: "heute",
      translated: "Actualmente",
      tone: 'semantic',
    },
    {
      german: "gegliedert in",
      translated: "se divide en",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:64|fa": [
    {
      german: "Die Bundesrepublik Deutschland",
      translated: "جمهوری فدرال آلمان",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "است",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:64|fr": [
    {
      german: "Die Bundesrepublik Deutschland",
      translated: "la République fédérale d’Allemagne",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "est",
      tone: 'semantic',
    },
    {
      german: "heute",
      translated: "Aujourd’hui",
      tone: 'semantic',
    },
    {
      german: "gegliedert in",
      translated: "organisée en",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:64|hr": [
    {
      german: "Die Bundesrepublik Deutschland",
      translated: "Savezna Republika Njemačka",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "je",
      tone: 'semantic',
    },
    {
      german: "heute",
      translated: "danas",
      tone: 'semantic',
    },
    {
      german: "gegliedert in",
      translated: "administrativno podijeljena na",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:64|it": [
    {
      german: "Die Bundesrepublik Deutschland",
      translated: "Repubblica Federale di Germania",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "è",
      tone: 'semantic',
    },
    {
      german: "heute",
      translated: "Oggi",
      tone: 'semantic',
    },
    {
      german: "gegliedert in",
      translated: "suddivisa amministrativamente in",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:64|kmr": [
    {
      german: "Die Bundesrepublik Deutschland",
      translated: "Komara Federal a Almanyayê îro",
      tone: 'semantic',
    },
    {
      german: "gegliedert in",
      translated: "dabeş dibe bo …",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:64|pl": [
    {
      german: "Die Bundesrepublik Deutschland",
      translated: "Republika Federalna Niemiec",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "jest",
      tone: 'semantic',
    },
    {
      german: "heute",
      translated: "dziś",
      tone: 'semantic',
    },
    {
      german: "gegliedert in",
      translated: "administracyjnie podzielona na …",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:64|prs": [
    {
      german: "Die Bundesrepublik Deutschland",
      translated: "جمهوری فدرال آلمان",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "است",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:64|ro": [
    {
      german: "Die Bundesrepublik Deutschland",
      translated: "Republica Federală Germania",
      tone: 'semantic',
    },
    {
      german: "gegliedert in",
      translated: "împărțită administrativ în …",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:64|ru": [
    {
      german: "Die Bundesrepublik Deutschland",
      translated: "Федеративная Республика Германия",
      tone: 'semantic',
    },
    {
      german: "heute",
      translated: "Сегодня",
      tone: 'semantic',
    },
    {
      german: "gegliedert in",
      translated: "делится на",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:64|sq": [
    {
      german: "Die Bundesrepublik Deutschland",
      translated: "Republika Federale e Gjermanisë",
      tone: 'semantic',
    },
    {
      german: "gegliedert in",
      translated: "ndahet administrativisht në",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:64|sr": [
    {
      german: "Die Bundesrepublik Deutschland",
      translated: "Savezna Republika Nemačka",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "je",
      tone: 'semantic',
    },
    {
      german: "heute",
      translated: "danas",
      tone: 'semantic',
    },
    {
      german: "gegliedert in",
      translated: "administrativno podijeljena na",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:64|tr": [
    {
      german: "Die Bundesrepublik Deutschland",
      translated: "Almanya Federal Cumhuriyeti",
      tone: 'semantic',
    },
    {
      german: "heute",
      translated: "günümüzde",
      tone: 'semantic',
    },
    {
      german: "gegliedert in",
      translated: "şeklinde örgütlenmiştir",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:64|uk": [
    {
      german: "Die Bundesrepublik Deutschland",
      translated: "Федеративна Республіка Німеччина",
      tone: 'semantic',
    },
    {
      german: "heute",
      translated: "Сьогодні",
      tone: 'semantic',
    },
    {
      german: "gegliedert in",
      translated: "поділяється на",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:64|vi": [
    {
      german: "Die Bundesrepublik Deutschland",
      translated: "Cộng hòa Liên bang Đức",
      tone: 'semantic',
    },
    {
      german: "heute",
      translated: "Ngày nay",
      tone: 'semantic',
    },
    {
      german: "gegliedert in",
      translated: "chia về mặt hành chính thành …",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:65|ar": [
    {
      german: "Es",
      translated: "أي مما يلي",
      tone: 'semantic',
    },
    {
      german: "nicht",
      translated: "ليس",
      tone: 'semantic',
    },
    {
      german: "zu den Aufgaben",
      translated: "من مهام",
      tone: 'semantic',
    },
    {
      german: "des Deutschen Bundestages",
      translated: "البوندستاغ الألماني",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:65|bg": [
    {
      german: "gehört",
      translated: "Кое",
      tone: 'semantic',
    },
    {
      german: "nicht",
      translated: "НЕ",
      tone: 'semantic',
    },
    {
      german: "zu den Aufgaben",
      translated: "е задача",
      tone: 'semantic',
    },
    {
      german: "des Deutschen Bundestages",
      translated: "на германския Бундестаг?",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:65|bs": [
    {
      german: "Es",
      translated: "Što od navedenoga",
      tone: 'semantic',
    },
    {
      german: "nicht",
      translated: "NIJE",
      tone: 'semantic',
    },
    {
      german: "zu den Aufgaben",
      translated: "zadaća",
      tone: 'semantic',
    },
    {
      german: "des Deutschen Bundestages",
      translated: "njemačkog Bundestaga",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:65|el": [
    {
      german: "Es",
      translated: "Ποιο",
      tone: 'semantic',
    },
    {
      german: "gehört",
      translated: "είναι",
      tone: 'semantic',
    },
    {
      german: "nicht",
      translated: "ΔΕΝ",
      tone: 'semantic',
    },
    {
      german: "zu den Aufgaben",
      translated: "καθήκον",
      tone: 'semantic',
    },
    {
      german: "des Deutschen Bundestages",
      translated: "του γερμανικού Bundestag",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:65|en": [
    {
      german: "Es",
      translated: "It",
      tone: 'semantic',
    },
    {
      german: "gehört",
      translated: "is",
      tone: 'semantic',
    },
    {
      german: "nicht",
      translated: "NOT",
      tone: 'semantic',
    },
    {
      german: "zu den Aufgaben",
      translated: "one of the tasks",
      tone: 'semantic',
    },
    {
      german: "des Deutschen Bundestages",
      translated: "of the German Bundestag",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:65|es": [
    {
      german: "gehört",
      translated: "es",
      tone: 'semantic',
    },
    {
      german: "nicht",
      translated: "NO",
      tone: 'semantic',
    },
    {
      german: "zu den Aufgaben",
      translated: "una de las funciones",
      tone: 'semantic',
    },
    {
      german: "des Deutschen Bundestages",
      translated: "del Bundestag alemán",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:65|fa": [
    {
      german: "Es",
      translated: "کدام مورد",
      tone: 'semantic',
    },
    {
      german: "gehört",
      translated: "جزو",
      tone: 'semantic',
    },
    {
      german: "nicht",
      translated: "نیست",
      tone: 'semantic',
    },
    {
      german: "zu den Aufgaben",
      translated: "وظایف",
      tone: 'semantic',
    },
    {
      german: "des Deutschen Bundestages",
      translated: "بوندستاگ آلمان",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:65|fr": [
    {
      german: "Es",
      translated: "Laquelle",
      tone: 'semantic',
    },
    {
      german: "gehört",
      translated: "ne relève",
      tone: 'semantic',
    },
    {
      german: "nicht",
      translated: "pas",
      tone: 'semantic',
    },
    {
      german: "zu den Aufgaben",
      translated: "des tâches suivantes",
      tone: 'semantic',
    },
    {
      german: "des Deutschen Bundestages",
      translated: "du Bundestag allemand ?",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:65|hr": [
    {
      german: "Es",
      translated: "Što od navedenoga",
      tone: 'semantic',
    },
    {
      german: "nicht",
      translated: "NIJE",
      tone: 'semantic',
    },
    {
      german: "zu den Aufgaben",
      translated: "zadaća",
      tone: 'semantic',
    },
    {
      german: "des Deutschen Bundestages",
      translated: "njemačkog Bundestaga",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:65|it": [
    {
      german: "gehört",
      translated: "è",
      tone: 'semantic',
    },
    {
      german: "nicht",
      translated: "NON",
      tone: 'semantic',
    },
    {
      german: "zu den Aufgaben",
      translated: "un compito",
      tone: 'semantic',
    },
    {
      german: "des Deutschen Bundestages",
      translated: "del Bundestag tedesco",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:65|kmr": [
    {
      german: "Es",
      translated: "Kîjan",
      tone: 'semantic',
    },
    {
      german: "gehört",
      translated: "e?",
      tone: 'semantic',
    },
    {
      german: "nicht",
      translated: "ne",
      tone: 'semantic',
    },
    {
      german: "zu den Aufgaben",
      translated: "erka",
      tone: 'semantic',
    },
    {
      german: "des Deutschen Bundestages",
      translated: "Bundestagê Alman",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:65|pl": [
    {
      german: "Es",
      translated: "Które z poniższych",
      tone: 'semantic',
    },
    {
      german: "gehört",
      translated: "jest",
      tone: 'semantic',
    },
    {
      german: "nicht",
      translated: "NIE",
      tone: 'semantic',
    },
    {
      german: "zu den Aufgaben",
      translated: "zadaniem",
      tone: 'semantic',
    },
    {
      german: "des Deutschen Bundestages",
      translated: "niemieckiego Bundestagu",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:65|prs": [
    {
      german: "gehört",
      translated: "نیست",
      tone: 'semantic',
    },
    {
      german: "zu den Aufgaben",
      translated: "وظایف",
      tone: 'semantic',
    },
    {
      german: "des Deutschen Bundestages",
      translated: "بوندستاگ آلمان",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:65|ro": [
    {
      german: "Es",
      translated: "Care",
      tone: 'semantic',
    },
    {
      german: "gehört",
      translated: "NU",
      tone: 'semantic',
    },
    {
      german: "nicht",
      translated: "este",
      tone: 'semantic',
    },
    {
      german: "zu den Aufgaben",
      translated: "o atribuție",
      tone: 'semantic',
    },
    {
      german: "des Deutschen Bundestages",
      translated: "a Bundestagului german",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:65|ru": [
    {
      german: "gehört",
      translated: "входит",
      tone: 'semantic',
    },
    {
      german: "nicht",
      translated: "не",
      tone: 'semantic',
    },
    {
      german: "zu den Aufgaben",
      translated: "В задачи",
      tone: 'semantic',
    },
    {
      german: "des Deutschen Bundestages",
      translated: "Бундестага Германии",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:65|sq": [
    {
      german: "Es",
      translated: "Cila nga këto",
      tone: 'semantic',
    },
    {
      german: "gehört",
      translated: "detyrë",
      tone: 'semantic',
    },
    {
      german: "nicht",
      translated: "NUK",
      tone: 'semantic',
    },
    {
      german: "des Deutschen Bundestages",
      translated: "Bundestagut gjerman",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:65|sr": [
    {
      german: "Es",
      translated: "Šta",
      tone: 'semantic',
    },
    {
      german: "gehört",
      translated: "od navedenoga",
      tone: 'semantic',
    },
    {
      german: "nicht",
      translated: "NIJE",
      tone: 'semantic',
    },
    {
      german: "zu den Aufgaben",
      translated: "nemačkog",
      tone: 'semantic',
    },
    {
      german: "des Deutschen Bundestages",
      translated: "Bundestaga",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:65|tr": [
    {
      german: "Es",
      translated: "Aşağıdakilerden hangisi",
      tone: 'semantic',
    },
    {
      german: "nicht",
      translated: "değildir",
      tone: 'semantic',
    },
    {
      german: "zu den Aufgaben",
      translated: "görevlerinden",
      tone: 'semantic',
    },
    {
      german: "des Deutschen Bundestages",
      translated: "Alman Federal Meclisi'nin",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:65|uk": [
    {
      german: "gehört",
      translated: "належить",
      tone: 'semantic',
    },
    {
      german: "nicht",
      translated: "не",
      tone: 'semantic',
    },
    {
      german: "zu den Aufgaben",
      translated: "До завдань",
      tone: 'semantic',
    },
    {
      german: "des Deutschen Bundestages",
      translated: "німецького Бундестагу",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:65|vi": [
    {
      german: "Es",
      translated: "Điều nào sau đây",
      tone: 'semantic',
    },
    {
      german: "gehört",
      translated: "là",
      tone: 'semantic',
    },
    {
      german: "nicht",
      translated: "KHÔNG",
      tone: 'semantic',
    },
    {
      german: "zu den Aufgaben",
      translated: "nhiệm vụ của",
      tone: 'semantic',
    },
    {
      german: "des Deutschen Bundestages",
      translated: "Bundestag Đức",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:66|ar": [
    {
      german: "Welche Städte",
      translated: "أي مدينتين",
      tone: 'semantic',
    },
    {
      german: "haben",
      translated: "تضمان",
      tone: 'semantic',
    },
    {
      german: "die größten jüdischen Gemeinden",
      translated: "أكبر الجاليات اليهودية",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "ألمانيا",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:66|bg": [
    {
      german: "Welche Städte",
      translated: "В кои градове",
      tone: 'semantic',
    },
    {
      german: "die größten jüdischen Gemeinden",
      translated: "най-големите еврейски общности",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "в Германия",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:66|bs": [
    {
      german: "Welche Städte",
      translated: "kojim se gradovima",
      tone: 'semantic',
    },
    {
      german: "haben",
      translated: "nalaze",
      tone: 'semantic',
    },
    {
      german: "die größten jüdischen Gemeinden",
      translated: "najveće jevrejske zajednice",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "u Njemačkoj",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:66|el": [
    {
      german: "Welche Städte",
      translated: "Σε ποιες πόλεις",
      tone: 'semantic',
    },
    {
      german: "haben",
      translated: "βρίσκονται",
      tone: 'semantic',
    },
    {
      german: "die größten jüdischen Gemeinden",
      translated: "οι μεγαλύτερες εβραϊκές κοινότητες",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "στη Γερμανία",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:66|en": [
    {
      german: "Welche Städte",
      translated: "Which cities",
      tone: 'semantic',
    },
    {
      german: "haben",
      translated: "have",
      tone: 'semantic',
    },
    {
      german: "die größten jüdischen Gemeinden",
      translated: "the largest Jewish communities",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "in Germany",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:66|es": [
    {
      german: "Welche Städte",
      translated: "¿Qué ciudades",
      tone: 'semantic',
    },
    {
      german: "haben",
      translated: "tienen",
      tone: 'semantic',
    },
    {
      german: "die größten jüdischen Gemeinden",
      translated: "las comunidades judías más grandes",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "de Alemania",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:66|fa": [
    {
      german: "Welche Städte",
      translated: "کدام شهرها",
      tone: 'semantic',
    },
    {
      german: "die größten jüdischen Gemeinden",
      translated: "بزرگ‌ترین جوامع یهودی",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "آلمان",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:66|fr": [
    {
      german: "Welche Städte",
      translated: "quelles villes",
      tone: 'semantic',
    },
    {
      german: "haben",
      translated: "se trouvent",
      tone: 'semantic',
    },
    {
      german: "die größten jüdischen Gemeinden",
      translated: "les plus grandes communautés juives",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "d’Allemagne",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:66|hr": [
    {
      german: "Welche Städte",
      translated: "kojim se gradovima",
      tone: 'semantic',
    },
    {
      german: "haben",
      translated: "nalaze",
      tone: 'semantic',
    },
    {
      german: "die größten jüdischen Gemeinden",
      translated: "najveće židovske zajednice",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "u Njemačkoj",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:66|it": [
    {
      german: "Welche Städte",
      translated: "In quali città",
      tone: 'semantic',
    },
    {
      german: "haben",
      translated: "si trovano",
      tone: 'semantic',
    },
    {
      german: "die größten jüdischen Gemeinden",
      translated: "le più grandi comunità ebraiche",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "della Germania?",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:66|kmr": [
    {
      german: "Welche Städte",
      translated: "Kîjan bajar xwedî civatên",
      tone: 'semantic',
    },
    {
      german: "die größten jüdischen Gemeinden",
      translated: "herî mezin ên Cihûyan",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "li Almanyayê ne",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:66|pl": [
    {
      german: "Welche Städte",
      translated: "W których miastach",
      tone: 'semantic',
    },
    {
      german: "haben",
      translated: "znajdują się",
      tone: 'semantic',
    },
    {
      german: "die größten jüdischen Gemeinden",
      translated: "największe gminy żydowskie",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "w Niemczech",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:66|prs": [
    {
      german: "Welche Städte",
      translated: "بزرگ‌ترین جوامع یهودی آلمان",
      tone: 'semantic',
    },
    {
      german: "haben",
      translated: "در",
      tone: 'semantic',
    },
    {
      german: "die größten jüdischen Gemeinden",
      translated: "کدام شهرها هستند",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:66|ro": [
    {
      german: "Welche Städte",
      translated: "În ce orașe",
      tone: 'semantic',
    },
    {
      german: "haben",
      translated: "se află",
      tone: 'semantic',
    },
    {
      german: "die größten jüdischen Gemeinden",
      translated: "cele mai mari comunități evreiești",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "din Germania",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:66|ru": [
    {
      german: "Welche Städte",
      translated: "В каких городах",
      tone: 'semantic',
    },
    {
      german: "haben",
      translated: "находятся",
      tone: 'semantic',
    },
    {
      german: "die größten jüdischen Gemeinden",
      translated: "крупнейшие еврейские общины",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "Германии",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:66|sq": [
    {
      german: "Welche Städte",
      translated: "Në cilat qytete",
      tone: 'semantic',
    },
    {
      german: "haben",
      translated: "ndodhen",
      tone: 'semantic',
    },
    {
      german: "die größten jüdischen Gemeinden",
      translated: "komunitetet më të mëdha hebreje",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "në Gjermani?",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:66|sr": [
    {
      german: "Welche Städte",
      translated: "U kojim",
      tone: 'semantic',
    },
    {
      german: "haben",
      translated: "nalaze",
      tone: 'semantic',
    },
    {
      german: "die größten jüdischen Gemeinden",
      translated: "najveće jevrejske zajednice",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "u Nemačkoj",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:66|tr": [
    {
      german: "Welche Städte",
      translated: "hangi şehirlerdedir",
      tone: 'semantic',
    },
    {
      german: "die größten jüdischen Gemeinden",
      translated: "Almanya'daki en büyük Yahudi cemaatleri",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:66|uk": [
    {
      german: "Welche Städte",
      translated: "У яких містах",
      tone: 'semantic',
    },
    {
      german: "haben",
      translated: "розташовані",
      tone: 'semantic',
    },
    {
      german: "die größten jüdischen Gemeinden",
      translated: "найбільші єврейські громади",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "Німеччини",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:66|vi": [
    {
      german: "Welche Städte",
      translated: "những thành phố nào",
      tone: 'semantic',
    },
    {
      german: "haben",
      translated: "nằm tại",
      tone: 'semantic',
    },
    {
      german: "die größten jüdischen Gemeinden",
      translated: "Các cộng đồng Do Thái lớn nhất",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "ở Đức",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:67|ar": [
    {
      german: "Was",
      translated: "أي",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "من",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "في ألمانيا",
      tone: 'semantic',
    },
    {
      german: "vor allem",
      translated: "أساسًا",
      tone: 'semantic',
    },
    {
      german: "eine Aufgabe",
      translated: "مسؤولية",
      tone: 'semantic',
    },
    {
      german: "der Bundesländer",
      translated: "الولايات الاتحادية؟",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:67|bg": [
    {
      german: "Was",
      translated: "Коя",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "е",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "в Германия",
      tone: 'semantic',
    },
    {
      german: "vor allem",
      translated: "предимно",
      tone: 'semantic',
    },
    {
      german: "eine Aufgabe",
      translated: "отговорност",
      tone: 'semantic',
    },
    {
      german: "der Bundesländer",
      translated: "на федералните провинции",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:67|bs": [
    {
      german: "Was",
      translated: "Koje",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "je",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "u Njemačkoj",
      tone: 'semantic',
    },
    {
      german: "vor allem",
      translated: "prvenstveno",
      tone: 'semantic',
    },
    {
      german: "eine Aufgabe",
      translated: "područje",
      tone: 'semantic',
    },
    {
      german: "der Bundesländer",
      translated: "u nadležnosti saveznih zemalja",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:67|el": [
    {
      german: "Was",
      translated: "Ποιος",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "είναι",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "στη Γερμανία",
      tone: 'semantic',
    },
    {
      german: "der Bundesländer",
      translated: "των ομόσπονδων κρατιδίων",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:67|en": [
    {
      german: "Was",
      translated: "What",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "is",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "in Germany",
      tone: 'semantic',
    },
    {
      german: "vor allem",
      translated: "primarily",
      tone: 'semantic',
    },
    {
      german: "eine Aufgabe",
      translated: "a task",
      tone: 'semantic',
    },
    {
      german: "der Bundesländer",
      translated: "the federal states",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:67|es": [
    {
      german: "Was",
      translated: "¿Qué",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "es",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "en Alemania",
      tone: 'semantic',
    },
    {
      german: "vor allem",
      translated: "principalmente",
      tone: 'semantic',
    },
    {
      german: "eine Aufgabe",
      translated: "competencia",
      tone: 'semantic',
    },
    {
      german: "der Bundesländer",
      translated: "de los estados federados",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:67|fa": [
    {
      german: "Was",
      translated: "کدام حوزه",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "در آلمان",
      tone: 'semantic',
    },
    {
      german: "vor allem",
      translated: "عمدتاً",
      tone: 'semantic',
    },
    {
      german: "eine Aufgabe",
      translated: "در صلاحیت",
      tone: 'semantic',
    },
    {
      german: "der Bundesländer",
      translated: "ایالت‌هاست",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:67|fr": [
    {
      german: "Was",
      translated: "Quel",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "relève",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "en Allemagne",
      tone: 'semantic',
    },
    {
      german: "vor allem",
      translated: "principalement",
      tone: 'semantic',
    },
    {
      german: "eine Aufgabe",
      translated: "domaine",
      tone: 'semantic',
    },
    {
      german: "der Bundesländer",
      translated: "des Länder",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:67|hr": [
    {
      german: "Was",
      translated: "Koje",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "je",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "u Njemačkoj",
      tone: 'semantic',
    },
    {
      german: "vor allem",
      translated: "prvenstveno",
      tone: 'semantic',
    },
    {
      german: "eine Aufgabe",
      translated: "nadležnosti",
      tone: 'semantic',
    },
    {
      german: "der Bundesländer",
      translated: "saveznih zemalja",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:67|it": [
    {
      german: "Was",
      translated: "Quale",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "è",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "in Germania",
      tone: 'semantic',
    },
    {
      german: "vor allem",
      translated: "principalmente",
      tone: 'semantic',
    },
    {
      german: "eine Aufgabe",
      translated: "di competenza",
      tone: 'semantic',
    },
    {
      german: "der Bundesländer",
      translated: "dei Länder",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:67|kmr": [
    {
      german: "Was",
      translated: "kîjan",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "bi",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "Almanyayê",
      tone: 'semantic',
    },
    {
      german: "vor allem",
      translated: "taybetî",
      tone: 'semantic',
    },
    {
      german: "eine Aufgabe",
      translated: "mijar",
      tone: 'semantic',
    },
    {
      german: "der Bundesländer",
      translated: "eyaletên federal",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:67|pl": [
    {
      german: "Was",
      translated: "Która",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "jest",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "w Niemczech",
      tone: 'semantic',
    },
    {
      german: "vor allem",
      translated: "głównie",
      tone: 'semantic',
    },
    {
      german: "eine Aufgabe",
      translated: "odpowiedzialnością",
      tone: 'semantic',
    },
    {
      german: "der Bundesländer",
      translated: "krajów związkowych",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:67|prs": [
    {
      german: "in Deutschland",
      translated: "در آلمان",
      tone: 'semantic',
    },
    {
      german: "vor allem",
      translated: "عمدتاً",
      tone: 'semantic',
    },
    {
      german: "der Bundesländer",
      translated: "صلاحیت ایالت‌هاست",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:67|ro": [
    {
      german: "Was",
      translated: "Care domeniu",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "este",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "în Germania",
      tone: 'semantic',
    },
    {
      german: "vor allem",
      translated: "în principal",
      tone: 'semantic',
    },
    {
      german: "eine Aufgabe",
      translated: "responsabilitatea",
      tone: 'semantic',
    },
    {
      german: "der Bundesländer",
      translated: "landurilor",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:67|ru": [
    {
      german: "Was",
      translated: "Что",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "является",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "в Германии",
      tone: 'semantic',
    },
    {
      german: "vor allem",
      translated: "в первую очередь",
      tone: 'semantic',
    },
    {
      german: "eine Aufgabe",
      translated: "задачей",
      tone: 'semantic',
    },
    {
      german: "der Bundesländer",
      translated: "федеральных земель",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:67|sq": [
    {
      german: "Was",
      translated: "Cila",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "fushë",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "në Gjermani",
      tone: 'semantic',
    },
    {
      german: "vor allem",
      translated: "kryesisht",
      tone: 'semantic',
    },
    {
      german: "eine Aufgabe",
      translated: "përgjegjësi",
      tone: 'semantic',
    },
    {
      german: "der Bundesländer",
      translated: "landeve",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:67|sr": [
    {
      german: "in Deutschland",
      translated: "u Nemačkoj",
      tone: 'semantic',
    },
    {
      german: "vor allem",
      translated: "prvenstveno",
      tone: 'semantic',
    },
    {
      german: "eine Aufgabe",
      translated: "oblast",
      tone: 'semantic',
    },
    {
      german: "der Bundesländer",
      translated: "pokrajina",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:67|tr": [
    {
      german: "Was",
      translated: "hangisi",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "Almanya'da",
      tone: 'semantic',
    },
    {
      german: "vor allem",
      translated: "öncelikle",
      tone: 'semantic',
    },
    {
      german: "eine Aufgabe",
      translated: "görevidir",
      tone: 'semantic',
    },
    {
      german: "der Bundesländer",
      translated: "eyaletlerin",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:67|uk": [
    {
      german: "Was",
      translated: "Що",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "в Німеччині",
      tone: 'semantic',
    },
    {
      german: "vor allem",
      translated: "насамперед",
      tone: 'semantic',
    },
    {
      german: "eine Aufgabe",
      translated: "належить до завдань",
      tone: 'semantic',
    },
    {
      german: "der Bundesländer",
      translated: "федеральних земель",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:67|vi": [
    {
      german: "Was",
      translated: "Lĩnh vực",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "nào",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "ở Đức",
      tone: 'semantic',
    },
    {
      german: "vor allem",
      translated: "chủ yếu",
      tone: 'semantic',
    },
    {
      german: "eine Aufgabe",
      translated: "trách nhiệm",
      tone: 'semantic',
    },
    {
      german: "der Bundesländer",
      translated: "của các bang",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:68|ar": [
    {
      german: "Warum",
      translated: "لماذا",
      tone: 'semantic',
    },
    {
      german: "kontrolliert",
      translated: "تشرف",
      tone: 'semantic',
    },
    {
      german: "der Staat",
      translated: "الدولة",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "في ألمانيا",
      tone: 'semantic',
    },
    {
      german: "das Schulwesen",
      translated: "النظام المدرسي",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:68|bg": [
    {
      german: "Warum",
      translated: "Защо",
      tone: 'semantic',
    },
    {
      german: "kontrolliert",
      translated: "контролира",
      tone: 'semantic',
    },
    {
      german: "der Staat",
      translated: "държавата",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "в Германия",
      tone: 'semantic',
    },
    {
      german: "das Schulwesen",
      translated: "училищната система",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:68|bs": [
    {
      german: "Warum",
      translated: "Zašto",
      tone: 'semantic',
    },
    {
      german: "kontrolliert",
      translated: "nadzire",
      tone: 'semantic',
    },
    {
      german: "der Staat",
      translated: "država",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "u Njemačkoj",
      tone: 'semantic',
    },
    {
      german: "das Schulwesen",
      translated: "školski sustav",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:68|el": [
    {
      german: "Warum",
      translated: "Γιατί",
      tone: 'semantic',
    },
    {
      german: "kontrolliert",
      translated: "εποπτεύει",
      tone: 'semantic',
    },
    {
      german: "der Staat",
      translated: "το κράτος",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "στη Γερμανία",
      tone: 'semantic',
    },
    {
      german: "das Schulwesen",
      translated: "το σχολικό σύστημα",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:68|en": [
    {
      german: "Warum",
      translated: "Why",
      tone: 'semantic',
    },
    {
      german: "kontrolliert",
      translated: "control",
      tone: 'semantic',
    },
    {
      german: "der Staat",
      translated: "the state",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "in Germany",
      tone: 'semantic',
    },
    {
      german: "das Schulwesen",
      translated: "the school system",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:68|es": [
    {
      german: "Warum",
      translated: "¿Por qué",
      tone: 'semantic',
    },
    {
      german: "kontrolliert",
      translated: "supervisa",
      tone: 'semantic',
    },
    {
      german: "der Staat",
      translated: "el Estado",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "en Alemania",
      tone: 'semantic',
    },
    {
      german: "das Schulwesen",
      translated: "el sistema escolar",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:68|fa": [
    {
      german: "Warum",
      translated: "چرا",
      tone: 'semantic',
    },
    {
      german: "kontrolliert",
      translated: "نظارت دارد",
      tone: 'semantic',
    },
    {
      german: "der Staat",
      translated: "دولت",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "در آلمان",
      tone: 'semantic',
    },
    {
      german: "das Schulwesen",
      translated: "نظام مدارس",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:68|fr": [
    {
      german: "Warum",
      translated: "Pourquoi",
      tone: 'semantic',
    },
    {
      german: "kontrolliert",
      translated: "supervise-t-il",
      tone: 'semantic',
    },
    {
      german: "der Staat",
      translated: "l’État",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "en Allemagne",
      tone: 'semantic',
    },
    {
      german: "das Schulwesen",
      translated: "le système scolaire",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:68|hr": [
    {
      german: "Warum",
      translated: "Zašto",
      tone: 'semantic',
    },
    {
      german: "kontrolliert",
      translated: "država",
      tone: 'semantic',
    },
    {
      german: "der Staat",
      translated: "nadzire",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "u Njemačkoj",
      tone: 'semantic',
    },
    {
      german: "das Schulwesen",
      translated: "školski sustav",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:68|it": [
    {
      german: "Warum",
      translated: "Perché",
      tone: 'semantic',
    },
    {
      german: "kontrolliert",
      translated: "controlla",
      tone: 'semantic',
    },
    {
      german: "der Staat",
      translated: "lo Stato",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "in Germania",
      tone: 'semantic',
    },
    {
      german: "das Schulwesen",
      translated: "il sistema scolastico",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:68|kmr": [
    {
      german: "Warum",
      translated: "Çima",
      tone: 'semantic',
    },
    {
      german: "kontrolliert",
      translated: "kontrol dike",
      tone: 'semantic',
    },
    {
      german: "der Staat",
      translated: "dewlet",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "li Almanyayê",
      tone: 'semantic',
    },
    {
      german: "das Schulwesen",
      translated: "pergala dibistanê",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:68|pl": [
    {
      german: "Warum",
      translated: "Dlaczego",
      tone: 'semantic',
    },
    {
      german: "kontrolliert",
      translated: "nadzoruje",
      tone: 'semantic',
    },
    {
      german: "der Staat",
      translated: "państwo",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "w Niemczech",
      tone: 'semantic',
    },
    {
      german: "das Schulwesen",
      translated: "system szkolny",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:68|prs": [
    {
      german: "Warum",
      translated: "چرا",
      tone: 'semantic',
    },
    {
      german: "kontrolliert",
      translated: "نظارت دارد",
      tone: 'semantic',
    },
    {
      german: "der Staat",
      translated: "دولت",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "در آلمان",
      tone: 'semantic',
    },
    {
      german: "das Schulwesen",
      translated: "نظام مکاتب",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:68|ro": [
    {
      german: "Warum",
      translated: "De ce",
      tone: 'semantic',
    },
    {
      german: "kontrolliert",
      translated: "supraveghează",
      tone: 'semantic',
    },
    {
      german: "der Staat",
      translated: "statul",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "din Germania",
      tone: 'semantic',
    },
    {
      german: "das Schulwesen",
      translated: "sistemul școlar",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:68|ru": [
    {
      german: "Warum",
      translated: "Почему",
      tone: 'semantic',
    },
    {
      german: "kontrolliert",
      translated: "контролирует",
      tone: 'semantic',
    },
    {
      german: "der Staat",
      translated: "государство",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "в Германии",
      tone: 'semantic',
    },
    {
      german: "das Schulwesen",
      translated: "школьную систему",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:68|sq": [
    {
      german: "Warum",
      translated: "Pse",
      tone: 'semantic',
    },
    {
      german: "kontrolliert",
      translated: "mbikëqyr",
      tone: 'semantic',
    },
    {
      german: "der Staat",
      translated: "shteti",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "në Gjermani",
      tone: 'semantic',
    },
    {
      german: "das Schulwesen",
      translated: "sistemin shkollor",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:68|sr": [
    {
      german: "Warum",
      translated: "Zašta",
      tone: 'semantic',
    },
    {
      german: "kontrolliert",
      translated: "nadzire",
      tone: 'semantic',
    },
    {
      german: "der Staat",
      translated: "država",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "u Nemačkoj",
      tone: 'semantic',
    },
    {
      german: "das Schulwesen",
      translated: "školski sistem",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:68|tr": [
    {
      german: "Warum",
      translated: "neden",
      tone: 'semantic',
    },
    {
      german: "kontrolliert",
      translated: "denetler",
      tone: 'semantic',
    },
    {
      german: "der Staat",
      translated: "devlet",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "Almanya'da",
      tone: 'semantic',
    },
    {
      german: "das Schulwesen",
      translated: "okul sistemini",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:68|uk": [
    {
      german: "Warum",
      translated: "Чому",
      tone: 'semantic',
    },
    {
      german: "kontrolliert",
      translated: "контролює",
      tone: 'semantic',
    },
    {
      german: "der Staat",
      translated: "держава",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "в Німеччині",
      tone: 'semantic',
    },
    {
      german: "das Schulwesen",
      translated: "систему шкільної освіти",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:68|vi": [
    {
      german: "Warum",
      translated: "Tại sao",
      tone: 'semantic',
    },
    {
      german: "kontrolliert",
      translated: "giám sát",
      tone: 'semantic',
    },
    {
      german: "der Staat",
      translated: "nhà nước",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "ở Đức",
      tone: 'semantic',
    },
    {
      german: "das Schulwesen",
      translated: "hệ thống trường học",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:69|ar": [
    {
      german: "Die Bundesrepublik Deutschland",
      translated: "لجمهورية ألمانيا الاتحادية",
      tone: 'semantic',
    },
    {
      german: "dreistufigen Verwaltungsaufbau",
      translated: "هيكل إداري من ثلاث مستويات",
      tone: 'semantic',
    },
    {
      german: "Wie heißt",
      translated: "ما اسم",
      tone: 'semantic',
    },
    {
      german: "die unterste politische Stufe",
      translated: "أدنى مستوى سياسي",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:69|bg": [
    {
      german: "Die Bundesrepublik Deutschland",
      translated: "Федерална република Германия",
      tone: 'semantic',
    },
    {
      german: "dreistufigen Verwaltungsaufbau",
      translated: "три административни равнища",
      tone: 'semantic',
    },
    {
      german: "Wie heißt",
      translated: "Как се нарича",
      tone: 'semantic',
    },
    {
      german: "die unterste politische Stufe",
      translated: "най-ниското политическо равнище",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:69|bs": [
    {
      german: "Die Bundesrepublik Deutschland",
      translated: "Savezna Republika Njemačka",
      tone: 'semantic',
    },
    {
      german: "dreistufigen Verwaltungsaufbau",
      translated: "trostupanjsku upravnu strukturu",
      tone: 'semantic',
    },
    {
      german: "Wie heißt",
      translated: "Kako se zove",
      tone: 'semantic',
    },
    {
      german: "die unterste politische Stufe",
      translated: "najniža politička razina",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:69|el": [
    {
      german: "Die Bundesrepublik Deutschland",
      translated: "Η Ομοσπονδιακή Δημοκρατία της Γερμανίας",
      tone: 'semantic',
    },
    {
      german: "dreistufigen Verwaltungsaufbau",
      translated: "τριών επιπέδων",
      tone: 'semantic',
    },
    {
      german: "Wie heißt",
      translated: "Πώς ονομάζεται",
      tone: 'semantic',
    },
    {
      german: "die unterste politische Stufe",
      translated: "το χαμηλότερο πολιτικό επίπεδο",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:69|en": [
    {
      german: "Die Bundesrepublik Deutschland",
      translated: "The Federal Republic of Germany",
      tone: 'semantic',
    },
    {
      german: "dreistufigen Verwaltungsaufbau",
      translated: "three-tier administrative structure",
      tone: 'semantic',
    },
    {
      german: "Wie heißt",
      translated: "What is",
      tone: 'semantic',
    },
    {
      german: "die unterste politische Stufe",
      translated: "the lowest political level",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:69|es": [
    {
      german: "Die Bundesrepublik Deutschland",
      translated: "La República Federal de Alemania",
      tone: 'semantic',
    },
    {
      german: "dreistufigen Verwaltungsaufbau",
      translated: "estructura administrativa de tres niveles",
      tone: 'semantic',
    },
    {
      german: "Wie heißt",
      translated: "¿Cómo se llama",
      tone: 'semantic',
    },
    {
      german: "die unterste politische Stufe",
      translated: "el nivel político más bajo",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:69|fa": [
    {
      german: "Die Bundesrepublik Deutschland",
      translated: "جمهوری فدرال آلمان",
      tone: 'semantic',
    },
    {
      german: "dreistufigen Verwaltungsaufbau",
      translated: "ساختار اداری سه‌سطحی",
      tone: 'semantic',
    },
    {
      german: "Wie heißt",
      translated: "چه نام دارد",
      tone: 'semantic',
    },
    {
      german: "die unterste politische Stufe",
      translated: "پایین‌ترین سطح سیاسی",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:69|fr": [
    {
      german: "Die Bundesrepublik Deutschland",
      translated: "La République fédérale d’Allemagne",
      tone: 'semantic',
    },
    {
      german: "dreistufigen Verwaltungsaufbau",
      translated: "une structure administrative à trois niveaux",
      tone: 'semantic',
    },
    {
      german: "Wie heißt",
      translated: "Comment s’appelle",
      tone: 'semantic',
    },
    {
      german: "die unterste politische Stufe",
      translated: "le niveau politique le plus bas",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:69|hr": [
    {
      german: "Die Bundesrepublik Deutschland",
      translated: "Savezna Republika Njemačka",
      tone: 'semantic',
    },
    {
      german: "dreistufigen Verwaltungsaufbau",
      translated: "trostupanjsku upravnu strukturu",
      tone: 'semantic',
    },
    {
      german: "Wie heißt",
      translated: "Kako se zove",
      tone: 'semantic',
    },
    {
      german: "die unterste politische Stufe",
      translated: "najniža politička razina",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:69|it": [
    {
      german: "Die Bundesrepublik Deutschland",
      translated: "La Repubblica Federale di Germania",
      tone: 'semantic',
    },
    {
      german: "dreistufigen Verwaltungsaufbau",
      translated: "una struttura amministrativa a tre livelli",
      tone: 'semantic',
    },
    {
      german: "Wie heißt",
      translated: "Come si chiama",
      tone: 'semantic',
    },
    {
      german: "die unterste politische Stufe",
      translated: "il livello politico più basso",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:69|kmr": [
    {
      german: "Die Bundesrepublik Deutschland",
      translated: "Komara Federal a Almanyayê",
      tone: 'semantic',
    },
    {
      german: "dreistufigen Verwaltungsaufbau",
      translated: "rêveberiyeke sê astî",
      tone: 'semantic',
    },
    {
      german: "Wie heißt",
      translated: "çi tê gotin",
      tone: 'semantic',
    },
    {
      german: "die unterste politische Stufe",
      translated: "Asta siyasî ya herî jêr",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:69|pl": [
    {
      german: "Die Bundesrepublik Deutschland",
      translated: "Republika Federalna Niemiec",
      tone: 'semantic',
    },
    {
      german: "dreistufigen Verwaltungsaufbau",
      translated: "trzystopniową strukturę administracyjną",
      tone: 'semantic',
    },
    {
      german: "Wie heißt",
      translated: "Jak nazywa się",
      tone: 'semantic',
    },
    {
      german: "die unterste politische Stufe",
      translated: "najniższy poziom polityczny",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:69|prs": [
    {
      german: "Die Bundesrepublik Deutschland",
      translated: "جمهوری فدرال آلمان",
      tone: 'semantic',
    },
    {
      german: "dreistufigen Verwaltungsaufbau",
      translated: "ساختار اداری سه‌سطحی",
      tone: 'semantic',
    },
    {
      german: "Wie heißt",
      translated: "چه نام دارد",
      tone: 'semantic',
    },
    {
      german: "die unterste politische Stufe",
      translated: "پایین‌ترین سطح سیاسی",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:69|ro": [
    {
      german: "Die Bundesrepublik Deutschland",
      translated: "Republica Federală Germania",
      tone: 'semantic',
    },
    {
      german: "dreistufigen Verwaltungsaufbau",
      translated: "o structură administrativă pe trei niveluri",
      tone: 'semantic',
    },
    {
      german: "Wie heißt",
      translated: "Cum se numește",
      tone: 'semantic',
    },
    {
      german: "die unterste politische Stufe",
      translated: "cel mai de jos nivel politic",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:69|ru": [
    {
      german: "Die Bundesrepublik Deutschland",
      translated: "Германия",
      tone: 'semantic',
    },
    {
      german: "dreistufigen Verwaltungsaufbau",
      translated: "трёхуровневую систему управления",
      tone: 'semantic',
    },
    {
      german: "Wie heißt",
      translated: "Как называется",
      tone: 'semantic',
    },
    {
      german: "die unterste politische Stufe",
      translated: "низшая политическая ступень",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:69|sq": [
    {
      german: "Die Bundesrepublik Deutschland",
      translated: "Republika Federale e Gjermanisë",
      tone: 'semantic',
    },
    {
      german: "dreistufigen Verwaltungsaufbau",
      translated: "strukturë administrative me tri nivele",
      tone: 'semantic',
    },
    {
      german: "Wie heißt",
      translated: "Si quhet",
      tone: 'semantic',
    },
    {
      german: "die unterste politische Stufe",
      translated: "niveli më i ulët politik",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:69|sr": [
    {
      german: "Die Bundesrepublik Deutschland",
      translated: "Savezna Republika Nemačka",
      tone: 'semantic',
    },
    {
      german: "dreistufigen Verwaltungsaufbau",
      translated: "trostupanjsku upravnu strukturu",
      tone: 'semantic',
    },
    {
      german: "Wie heißt",
      translated: "Kako se zove",
      tone: 'semantic',
    },
    {
      german: "die unterste politische Stufe",
      translated: "najniža politička razina",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:69|tr": [
    {
      german: "Die Bundesrepublik Deutschland",
      translated: "Almanya Federal Cumhuriyeti",
      tone: 'semantic',
    },
    {
      german: "dreistufigen Verwaltungsaufbau",
      translated: "üç kademeli idari yapısında",
      tone: 'semantic',
    },
    {
      german: "Wie heißt",
      translated: "hangisidir",
      tone: 'semantic',
    },
    {
      german: "die unterste politische Stufe",
      translated: "en alt siyasi kademe",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:69|uk": [
    {
      german: "Die Bundesrepublik Deutschland",
      translated: "Федеративна Республіка Німеччина",
      tone: 'semantic',
    },
    {
      german: "dreistufigen Verwaltungsaufbau",
      translated: "трирівневу адміністративну структуру",
      tone: 'semantic',
    },
    {
      german: "Wie heißt",
      translated: "Як називається",
      tone: 'semantic',
    },
    {
      german: "die unterste politische Stufe",
      translated: "найнижчий політичний рівень",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:69|vi": [
    {
      german: "Die Bundesrepublik Deutschland",
      translated: "Cộng hòa Liên bang Đức",
      tone: 'semantic',
    },
    {
      german: "dreistufigen Verwaltungsaufbau",
      translated: "cơ cấu hành chính ba cấp",
      tone: 'semantic',
    },
    {
      german: "Wie heißt",
      translated: "được gọi là",
      tone: 'semantic',
    },
    {
      german: "die unterste politische Stufe",
      translated: "Cấp chính trị thấp nhất",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:6|ar": [
    {
      german: "Wie heißt",
      translated: "ما اسم",
      tone: 'semantic',
    },
    {
      german: "deutsche Verfassung",
      translated: "الدستور الألماني",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:6|bg": [
    {
      german: "Wie heißt",
      translated: "Как се",
      tone: 'semantic',
    },
    {
      german: "deutsche Verfassung",
      translated: "конституцията на Германия?",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:6|bs": [
    {
      german: "Wie heißt",
      translated: "Kako se zove",
      tone: 'semantic',
    },
    {
      german: "deutsche Verfassung",
      translated: "njemački ustav",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:6|el": [
    {
      german: "Wie heißt",
      translated: "Πώς ονομάζεται",
      tone: 'semantic',
    },
    {
      german: "deutsche Verfassung",
      translated: "το Σύνταγμα της Γερμανίας",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:6|en": [
    {
      german: "Wie heißt",
      translated: "What",
      tone: 'semantic',
    },
    {
      german: "deutsche Verfassung",
      translated: "the German constitution",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:6|es": [
    {
      german: "Wie heißt",
      translated: "¿Cómo se llama",
      tone: 'semantic',
    },
    {
      german: "deutsche Verfassung",
      translated: "la Constitución alemana",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:6|fa": [
    {
      german: "Wie heißt",
      translated: "چه نام دارد",
      tone: 'semantic',
    },
    {
      german: "deutsche Verfassung",
      translated: "قانون اساسی آلمان",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:6|fr": [
    {
      german: "Wie heißt",
      translated: "Comment s’appelle",
      tone: 'semantic',
    },
    {
      german: "deutsche Verfassung",
      translated: "la Constitution de l’Allemagne",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:6|hr": [
    {
      german: "Wie heißt",
      translated: "Kako se zove",
      tone: 'semantic',
    },
    {
      german: "deutsche Verfassung",
      translated: "njemački ustav",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:6|it": [
    {
      german: "Wie heißt",
      translated: "Come si chiama",
      tone: 'semantic',
    },
    {
      german: "deutsche Verfassung",
      translated: "la Costituzione della Germania",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:6|kmr": [
    {
      german: "Wie heißt",
      translated: "Navê",
      tone: 'semantic',
    },
    {
      german: "deutsche Verfassung",
      translated: "Almanyayê çi ye?",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:6|pl": [
    {
      german: "Wie heißt",
      translated: "Jak nazywa się",
      tone: 'semantic',
    },
    {
      german: "deutsche Verfassung",
      translated: "konstytucja Niemiec",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:6|prs": [
    {
      german: "Wie heißt",
      translated: "چه نام دارد",
      tone: 'semantic',
    },
    {
      german: "deutsche Verfassung",
      translated: "قانون اساسی",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:6|ro": [
    {
      german: "Wie heißt",
      translated: "Cum se numește",
      tone: 'semantic',
    },
    {
      german: "deutsche Verfassung",
      translated: "constituția Germaniei",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:6|ru": [
    {
      german: "Wie heißt",
      translated: "Как называется",
      tone: 'semantic',
    },
    {
      german: "deutsche Verfassung",
      translated: "конституция Германии",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:6|sq": [
    {
      german: "Wie heißt",
      translated: "Si quhet",
      tone: 'semantic',
    },
    {
      german: "deutsche Verfassung",
      translated: "Kushtetuta e Gjermanisë",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:6|sr": [
    {
      german: "Wie heißt",
      translated: "Kako se zove",
      tone: 'semantic',
    },
    {
      german: "deutsche Verfassung",
      translated: "nemački ustav",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:6|tr": [
    {
      german: "Wie heißt",
      translated: "adı nedir",
      tone: 'semantic',
    },
    {
      german: "deutsche Verfassung",
      translated: "Alman Anayasası'nın",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:6|uk": [
    {
      german: "Wie heißt",
      translated: "Як називається",
      tone: 'semantic',
    },
    {
      german: "deutsche Verfassung",
      translated: "Конституція Німеччини",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:6|vi": [
    {
      german: "Wie heißt",
      translated: "được gọi là gì?",
      tone: 'semantic',
    },
    {
      german: "deutsche Verfassung",
      translated: "Hiến pháp của Đức",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:70|ar": [
    {
      german: "Der deutsche Bundespräsident",
      translated: "الرئيس الاتحادي",
      tone: 'semantic',
    },
    {
      german: "Gustav Heinemann",
      translated: "غوستاف هاينمان",
      tone: 'semantic',
    },
    {
      german: "gibt",
      translated: "سلّم",
      tone: 'semantic',
    },
    {
      german: "Helmut Schmidt",
      translated: "هيلموت شميت",
      tone: 'semantic',
    },
    {
      german: "1974",
      translated: "عام 1974",
      tone: 'semantic',
    },
    {
      german: "die Ernennungsurkunde",
      translated: "وثيقة تعيينه",
      tone: 'semantic',
    },
    {
      german: "zum deutschen Bundeskanzler",
      translated: "مستشارًا اتحاديًا",
      tone: 'semantic',
    },
    {
      german: "Was gehört zu den Aufgaben der deutschen Bundespräsidentin/des deutschen Bundespräsidenten?",
      translated: "أي مما يلي من مهام رئيس جمهورية ألمانيا الاتحادية؟",
      tone: 'semantic',
    },
    {
      german: "© Bundesregierung/Engelbert Reineke",
      translated: "© Bundesregierung/Engelbert Reineke",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:70|bg": [
    {
      german: "Der deutsche Bundespräsident",
      translated: "федералният президент",
      tone: 'semantic',
    },
    {
      german: "Gustav Heinemann",
      translated: "Густав Хайнеман",
      tone: 'semantic',
    },
    {
      german: "gibt",
      translated: "връчва",
      tone: 'semantic',
    },
    {
      german: "Helmut Schmidt",
      translated: "Хелмут Шмид",
      tone: 'semantic',
    },
    {
      german: "1974",
      translated: "1974 г.",
      tone: 'semantic',
    },
    {
      german: "die Ernennungsurkunde",
      translated: "документа за назначаването му",
      tone: 'semantic',
    },
    {
      german: "zum deutschen Bundeskanzler",
      translated: "за канцлер",
      tone: 'semantic',
    },
    {
      german: "Was gehört zu den Aufgaben der deutschen Bundespräsidentin/des deutschen Bundespräsidenten?",
      translated: "Коя е една от задачите на федералния президент?",
      tone: 'semantic',
    },
    {
      german: "© Bundesregierung/Engelbert Reineke",
      translated: "© Bundesregierung/Engelbert Reineke",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:70|bs": [
    {
      german: "Der deutsche Bundespräsident",
      translated: "savezni predsjednik",
      tone: 'semantic',
    },
    {
      german: "Gustav Heinemann",
      translated: "Gustav Heinemann",
      tone: 'semantic',
    },
    {
      german: "Helmut Schmidt",
      translated: "Helmutu Schmidtu",
      tone: 'semantic',
    },
    {
      german: "1974",
      translated: "1974",
      tone: 'semantic',
    },
    {
      german: "die Ernennungsurkunde",
      translated: "ispravu o imenovanju",
      tone: 'semantic',
    },
    {
      german: "zum deutschen Bundeskanzler",
      translated: "za saveznog kancelara",
      tone: 'semantic',
    },
    {
      german: "Was gehört zu den Aufgaben der deutschen Bundespräsidentin/des deutschen Bundespräsidenten?",
      translated: "Koja je od navedenih zadaća saveznog predsjednika",
      tone: 'semantic',
    },
    {
      german: "© Bundesregierung/Engelbert Reineke",
      translated: "© Bundesregierung/Engelbert Reineke",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:70|el": [
    {
      german: "Der deutsche Bundespräsident",
      translated: "ο Ομοσπονδιακός Πρόεδρος",
      tone: 'semantic',
    },
    {
      german: "Gustav Heinemann",
      translated: "Gustav Heinemann",
      tone: 'semantic',
    },
    {
      german: "gibt",
      translated: "παραδίδει",
      tone: 'semantic',
    },
    {
      german: "1974",
      translated: "Το 1974",
      tone: 'semantic',
    },
    {
      german: "die Ernennungsurkunde",
      translated: "το έγγραφο διορισμού",
      tone: 'semantic',
    },
    {
      german: "zum deutschen Bundeskanzler",
      translated: "του ως καγκελαρίου",
      tone: 'semantic',
    },
    {
      german: "Was gehört zu den Aufgaben der deutschen Bundespräsidentin/des deutschen Bundespräsidenten?",
      translated: "Ποιο είναι ένα από τα καθήκοντα του Ομοσπονδιακού Προέδρου;",
      tone: 'semantic',
    },
    {
      german: "© Bundesregierung/Engelbert Reineke",
      translated: "© Bundesregierung/Engelbert Reineke",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:70|en": [
    {
      german: "Der deutsche Bundespräsident",
      translated: "German Federal President",
      tone: 'semantic',
    },
    {
      german: "Gustav Heinemann",
      translated: "Gustav Heinemann",
      tone: 'semantic',
    },
    {
      german: "gibt",
      translated: "hands",
      tone: 'semantic',
    },
    {
      german: "Helmut Schmidt",
      translated: "Helmut Schmidt",
      tone: 'semantic',
    },
    {
      german: "1974",
      translated: "1974",
      tone: 'semantic',
    },
    {
      german: "die Ernennungsurkunde",
      translated: "the certificate of appointment",
      tone: 'semantic',
    },
    {
      german: "zum deutschen Bundeskanzler",
      translated: "as German Federal Chancellor",
      tone: 'semantic',
    },
    {
      german: "Was gehört zu den Aufgaben der deutschen Bundespräsidentin/des deutschen Bundespräsidenten?",
      translated: "What is one of the duties of the German Federal President?",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:70|es": [
    {
      german: "Der deutsche Bundespräsident",
      translated: "Presidente Federal alemán",
      tone: 'semantic',
    },
    {
      german: "Gustav Heinemann",
      translated: "Gustav Heinemann",
      tone: 'semantic',
    },
    {
      german: "gibt",
      translated: "entrega",
      tone: 'semantic',
    },
    {
      german: "Helmut Schmidt",
      translated: "Helmut Schmidt",
      tone: 'semantic',
    },
    {
      german: "1974",
      translated: "1974",
      tone: 'semantic',
    },
    {
      german: "die Ernennungsurkunde",
      translated: "documento de nombramiento",
      tone: 'semantic',
    },
    {
      german: "zum deutschen Bundeskanzler",
      translated: "como Canciller Federal",
      tone: 'semantic',
    },
    {
      german: "Was gehört zu den Aufgaben der deutschen Bundespräsidentin/des deutschen Bundespräsidenten?",
      translated: "¿Cuál es una de las funciones del Presidente Federal?",
      tone: 'semantic',
    },
    {
      german: "© Bundesregierung/Engelbert Reineke",
      translated: "© Bundesregierung/Engelbert Reineke",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:70|fa": [
    {
      german: "Der deutsche Bundespräsident",
      translated: "رئیس‌جمهور فدرال",
      tone: 'semantic',
    },
    {
      german: "Gustav Heinemann",
      translated: "گوستاو هاینمان",
      tone: 'semantic',
    },
    {
      german: "gibt",
      translated: "تحویل می‌دهد",
      tone: 'semantic',
    },
    {
      german: "Helmut Schmidt",
      translated: "هلموت اشمیت",
      tone: 'semantic',
    },
    {
      german: "1974",
      translated: "در سال ۱۹۷۴",
      tone: 'semantic',
    },
    {
      german: "die Ernennungsurkunde",
      translated: "حکم انتصاب",
      tone: 'semantic',
    },
    {
      german: "zum deutschen Bundeskanzler",
      translated: "به صدراعظمی",
      tone: 'semantic',
    },
    {
      german: "Was gehört zu den Aufgaben der deutschen Bundespräsidentin/des deutschen Bundespräsidenten?",
      translated: "کدام مورد از وظایف رئیس‌جمهور فدرال است؟",
      tone: 'semantic',
    },
    {
      german: "© Bundesregierung/Engelbert Reineke",
      translated: "© Bundesregierung/Engelbert Reineke",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:70|fr": [
    {
      german: "Der deutsche Bundespräsident",
      translated: "le président fédéral",
      tone: 'semantic',
    },
    {
      german: "Gustav Heinemann",
      translated: "Gustav Heinemann",
      tone: 'semantic',
    },
    {
      german: "gibt",
      translated: "remet",
      tone: 'semantic',
    },
    {
      german: "Helmut Schmidt",
      translated: "Helmut Schmidt",
      tone: 'semantic',
    },
    {
      german: "1974",
      translated: "1974",
      tone: 'semantic',
    },
    {
      german: "die Ernennungsurkunde",
      translated: "son acte de nomination",
      tone: 'semantic',
    },
    {
      german: "zum deutschen Bundeskanzler",
      translated: "comme chancelier fédéral",
      tone: 'semantic',
    },
    {
      german: "Was gehört zu den Aufgaben der deutschen Bundespräsidentin/des deutschen Bundespräsidenten?",
      translated: "Laquelle des tâches suivantes relève du président fédéral",
      tone: 'semantic',
    },
    {
      german: "© Bundesregierung/Engelbert Reineke",
      translated: "© Bundesregierung/Engelbert Reineke",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:70|hr": [
    {
      german: "Der deutsche Bundespräsident",
      translated: "savezni predsjednik",
      tone: 'semantic',
    },
    {
      german: "Gustav Heinemann",
      translated: "Gustav Heinemann",
      tone: 'semantic',
    },
    {
      german: "Helmut Schmidt",
      translated: "Helmutu Schmidtu",
      tone: 'semantic',
    },
    {
      german: "1974",
      translated: "1974",
      tone: 'semantic',
    },
    {
      german: "die Ernennungsurkunde",
      translated: "ispravu o imenovanju",
      tone: 'semantic',
    },
    {
      german: "zum deutschen Bundeskanzler",
      translated: "za saveznog kancelara",
      tone: 'semantic',
    },
    {
      german: "Was gehört zu den Aufgaben der deutschen Bundespräsidentin/des deutschen Bundespräsidenten?",
      translated: "Koja je od navedenih zadaća saveznog predsjednika?",
      tone: 'semantic',
    },
    {
      german: "© Bundesregierung/Engelbert Reineke",
      translated: "© Bundesregierung/Engelbert Reineke",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:70|it": [
    {
      german: "Der deutsche Bundespräsident",
      translated: "il Presidente federale",
      tone: 'semantic',
    },
    {
      german: "Gustav Heinemann",
      translated: "Gustav Heinemann",
      tone: 'semantic',
    },
    {
      german: "gibt",
      translated: "consegna",
      tone: 'semantic',
    },
    {
      german: "Helmut Schmidt",
      translated: "Helmut Schmidt",
      tone: 'semantic',
    },
    {
      german: "1974",
      translated: "1974",
      tone: 'semantic',
    },
    {
      german: "die Ernennungsurkunde",
      translated: "l’atto di nomina",
      tone: 'semantic',
    },
    {
      german: "zum deutschen Bundeskanzler",
      translated: "a cancelliere federale",
      tone: 'semantic',
    },
    {
      german: "Was gehört zu den Aufgaben der deutschen Bundespräsidentin/des deutschen Bundespräsidenten?",
      translated: "Quale dei seguenti è un compito del Presidente federale?",
      tone: 'semantic',
    },
    {
      german: "© Bundesregierung/Engelbert Reineke",
      translated: "© Bundesregierung/Engelbert Reineke",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:70|kmr": [
    {
      german: "Der deutsche Bundespräsident",
      translated: "Serokê Federal",
      tone: 'semantic',
    },
    {
      german: "Gustav Heinemann",
      translated: "Gustav Heinemann",
      tone: 'semantic',
    },
    {
      german: "gibt",
      translated: "dide",
      tone: 'semantic',
    },
    {
      german: "Helmut Schmidt",
      translated: "Helmut Schmidt",
      tone: 'semantic',
    },
    {
      german: "1974",
      translated: "1974",
      tone: 'semantic',
    },
    {
      german: "die Ernennungsurkunde",
      translated: "belgeya tayînkirina",
      tone: 'semantic',
    },
    {
      german: "zum deutschen Bundeskanzler",
      translated: "wek kanselerê federal",
      tone: 'semantic',
    },
    {
      german: "Was gehört zu den Aufgaben der deutschen Bundespräsidentin/des deutschen Bundespräsidenten?",
      translated: "Kîjan ji van erka Serokê Federal e?",
      tone: 'semantic',
    },
    {
      german: "© Bundesregierung/Engelbert Reineke",
      translated: "© Bundesregierung/Engelbert Reineke",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:70|pl": [
    {
      german: "Der deutsche Bundespräsident",
      translated: "Prezydent Federalny",
      tone: 'semantic',
    },
    {
      german: "Gustav Heinemann",
      translated: "Gustav Heinemann",
      tone: 'semantic',
    },
    {
      german: "gibt",
      translated: "wręczył",
      tone: 'semantic',
    },
    {
      german: "Helmut Schmidt",
      translated: "Helmutowi Schmidtowi",
      tone: 'semantic',
    },
    {
      german: "1974",
      translated: "1974",
      tone: 'semantic',
    },
    {
      german: "die Ernennungsurkunde",
      translated: "dokument nominacji",
      tone: 'semantic',
    },
    {
      german: "zum deutschen Bundeskanzler",
      translated: "na kanclerza federalnego",
      tone: 'semantic',
    },
    {
      german: "Was gehört zu den Aufgaben der deutschen Bundespräsidentin/des deutschen Bundespräsidenten?",
      translated: "Które z poniższych jest zadaniem Prezydenta Federalnego?",
      tone: 'semantic',
    },
    {
      german: "© Bundesregierung/Engelbert Reineke",
      translated: "© Bundesregierung/Engelbert Reineke",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:70|prs": [
    {
      german: "Der deutsche Bundespräsident",
      translated: "رئیس‌جمهور فدرال",
      tone: 'semantic',
    },
    {
      german: "Gustav Heinemann",
      translated: "گوستاو هاینمان",
      tone: 'semantic',
    },
    {
      german: "gibt",
      translated: "تحویل می‌دهد",
      tone: 'semantic',
    },
    {
      german: "Helmut Schmidt",
      translated: "هلموت اشمیت",
      tone: 'semantic',
    },
    {
      german: "1974",
      translated: "در سال ۱۹۷۴",
      tone: 'semantic',
    },
    {
      german: "die Ernennungsurkunde",
      translated: "حکم انتصاب",
      tone: 'semantic',
    },
    {
      german: "zum deutschen Bundeskanzler",
      translated: "به صدراعظمی",
      tone: 'semantic',
    },
    {
      german: "Was gehört zu den Aufgaben der deutschen Bundespräsidentin/des deutschen Bundespräsidenten?",
      translated: "کدام مورد از وظایف رئیس‌جمهور فدرال است؟",
      tone: 'semantic',
    },
    {
      german: "© Bundesregierung/Engelbert Reineke",
      translated: "© Bundesregierung/Engelbert Reineke",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:70|ro": [
    {
      german: "Der deutsche Bundespräsident",
      translated: "președintele federal",
      tone: 'semantic',
    },
    {
      german: "Gustav Heinemann",
      translated: "Gustav Heinemann",
      tone: 'semantic',
    },
    {
      german: "gibt",
      translated: "îi înmânează",
      tone: 'semantic',
    },
    {
      german: "Helmut Schmidt",
      translated: "lui Helmut Schmidt",
      tone: 'semantic',
    },
    {
      german: "1974",
      translated: "1974",
      tone: 'semantic',
    },
    {
      german: "die Ernennungsurkunde",
      translated: "actul de numire",
      tone: 'semantic',
    },
    {
      german: "zum deutschen Bundeskanzler",
      translated: "ca cancelar",
      tone: 'semantic',
    },
    {
      german: "Was gehört zu den Aufgaben der deutschen Bundespräsidentin/des deutschen Bundespräsidenten?",
      translated: "Care este una dintre atribuțiile președintelui federal",
      tone: 'semantic',
    },
    {
      german: "© Bundesregierung/Engelbert Reineke",
      translated: "© Bundesregierung/Engelbert Reineke",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:70|ru": [
    {
      german: "Der deutsche Bundespräsident",
      translated: "Федеральный президент Германии",
      tone: 'semantic',
    },
    {
      german: "Gustav Heinemann",
      translated: "Густав Хайнеманн",
      tone: 'semantic',
    },
    {
      german: "gibt",
      translated: "вручает",
      tone: 'semantic',
    },
    {
      german: "Helmut Schmidt",
      translated: "Гельмуту Шмидту",
      tone: 'semantic',
    },
    {
      german: "1974",
      translated: "в 1974 году",
      tone: 'semantic',
    },
    {
      german: "die Ernennungsurkunde",
      translated: "грамоту о назначении",
      tone: 'semantic',
    },
    {
      german: "zum deutschen Bundeskanzler",
      translated: "федеральным канцлером Германии",
      tone: 'semantic',
    },
    {
      german: "Was gehört zu den Aufgaben der deutschen Bundespräsidentin/des deutschen Bundespräsidenten?",
      translated: "Что входит в задачи федерального президента Германии?",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:70|sq": [
    {
      german: "Der deutsche Bundespräsident",
      translated: "Presidenti Federal",
      tone: 'semantic',
    },
    {
      german: "Gustav Heinemann",
      translated: "Gustav Heinemann",
      tone: 'semantic',
    },
    {
      german: "gibt",
      translated: "i dorëzon",
      tone: 'semantic',
    },
    {
      german: "Helmut Schmidt",
      translated: "Helmut Schmidt",
      tone: 'semantic',
    },
    {
      german: "1974",
      translated: "1974",
      tone: 'semantic',
    },
    {
      german: "die Ernennungsurkunde",
      translated: "aktin e emërimit",
      tone: 'semantic',
    },
    {
      german: "zum deutschen Bundeskanzler",
      translated: "si kancelar federal",
      tone: 'semantic',
    },
    {
      german: "Was gehört zu den Aufgaben der deutschen Bundespräsidentin/des deutschen Bundespräsidenten?",
      translated: "Cila nga këto është detyrë e Presidentit Federal?",
      tone: 'semantic',
    },
    {
      german: "© Bundesregierung/Engelbert Reineke",
      translated: "© Bundesregierung/Engelbert Reineke",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:70|sr": [
    {
      german: "Der deutsche Bundespräsident",
      translated: "savezni predsjednik",
      tone: 'semantic',
    },
    {
      german: "Gustav Heinemann",
      translated: "Gustav Heinemann",
      tone: 'semantic',
    },
    {
      german: "gibt",
      translated: "predao je",
      tone: 'semantic',
    },
    {
      german: "Helmut Schmidt",
      translated: "Helmutu Schmidtu",
      tone: 'semantic',
    },
    {
      german: "1974",
      translated: "1974.",
      tone: 'semantic',
    },
    {
      german: "die Ernennungsurkunde",
      translated: "ispravu o imenovanju",
      tone: 'semantic',
    },
    {
      german: "zum deutschen Bundeskanzler",
      translated: "saveznog kancelara",
      tone: 'semantic',
    },
    {
      german: "Was gehört zu den Aufgaben der deutschen Bundespräsidentin/des deutschen Bundespräsidenten?",
      translated: "Koja je od navedenih zadaća saveznog predsjednika?",
      tone: 'semantic',
    },
    {
      german: "© Bundesregierung/Engelbert Reineke",
      translated: "© Bundesregierung/Engelbert Reineke",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:70|tr": [
    {
      german: "Der deutsche Bundespräsident",
      translated: "Alman Federal Cumhurbaşkanı",
      tone: 'semantic',
    },
    {
      german: "Gustav Heinemann",
      translated: "Gustav Heinemann",
      tone: 'semantic',
    },
    {
      german: "gibt",
      translated: "veriyor",
      tone: 'semantic',
    },
    {
      german: "Helmut Schmidt",
      translated: "Helmut Schmidt",
      tone: 'semantic',
    },
    {
      german: "1974",
      translated: "1974'te",
      tone: 'semantic',
    },
    {
      german: "die Ernennungsurkunde",
      translated: "atanma belgesini",
      tone: 'semantic',
    },
    {
      german: "zum deutschen Bundeskanzler",
      translated: "Federal Başbakan olarak",
      tone: 'semantic',
    },
    {
      german: "Was gehört zu den Aufgaben der deutschen Bundespräsidentin/des deutschen Bundespräsidenten?",
      translated: "Federal Cumhurbaşkanının görevlerinden biri hangisidir?",
      tone: 'semantic',
    },
    {
      german: "© Bundesregierung/Engelbert Reineke",
      translated: "© Bundesregierung/Engelbert Reineke",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:70|uk": [
    {
      german: "Der deutsche Bundespräsident",
      translated: "році федеральний президент Німеччини",
      tone: 'semantic',
    },
    {
      german: "Gustav Heinemann",
      translated: "Густав Гайнеманн",
      tone: 'semantic',
    },
    {
      german: "gibt",
      translated: "вручає",
      tone: 'semantic',
    },
    {
      german: "Helmut Schmidt",
      translated: "Гельмуту Шмідту",
      tone: 'semantic',
    },
    {
      german: "1974",
      translated: "1974",
      tone: 'semantic',
    },
    {
      german: "die Ernennungsurkunde",
      translated: "документ про призначення",
      tone: 'semantic',
    },
    {
      german: "zum deutschen Bundeskanzler",
      translated: "федеральним канцлером",
      tone: 'semantic',
    },
    {
      german: "Was gehört zu den Aufgaben der deutschen Bundespräsidentin/des deutschen Bundespräsidenten?",
      translated: "Що належить до завдань Федерального президента Німеччини?",
      tone: 'semantic',
    },
    {
      german: "© Bundesregierung/Engelbert Reineke",
      translated: "© Bundesregierung/Engelbert Reineke",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:70|vi": [
    {
      german: "Der deutsche Bundespräsident",
      translated: "Tổng thống Liên bang",
      tone: 'semantic',
    },
    {
      german: "Gustav Heinemann",
      translated: "Gustav Heinemann",
      tone: 'semantic',
    },
    {
      german: "gibt",
      translated: "trao cho",
      tone: 'semantic',
    },
    {
      german: "Helmut Schmidt",
      translated: "Helmut Schmidt",
      tone: 'semantic',
    },
    {
      german: "1974",
      translated: "1974",
      tone: 'semantic',
    },
    {
      german: "die Ernennungsurkunde",
      translated: "văn bản bổ nhiệm",
      tone: 'semantic',
    },
    {
      german: "zum deutschen Bundeskanzler",
      translated: "làm Thủ tướng Liên bang",
      tone: 'semantic',
    },
    {
      german: "Was gehört zu den Aufgaben der deutschen Bundespräsidentin/des deutschen Bundespräsidenten?",
      translated: "Điều nào sau đây là nhiệm vụ của Tổng thống Liên bang?",
      tone: 'semantic',
    },
    {
      german: "© Bundesregierung/Engelbert Reineke",
      translated: "© Bundesregierung/Engelbert Reineke",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:71|ar": [
    {
      german: "Wo",
      translated: "أين",
      tone: 'semantic',
    },
    {
      german: "hält sich",
      translated: "يقضي",
      tone: 'semantic',
    },
    {
      german: "die deutsche Bundeskanzlerin/der deutsche Bundeskanzler",
      translated: "المستشار الاتحادي الألماني",
      tone: 'semantic',
    },
    {
      german: "am häufigsten",
      translated: "معظم وقته",
      tone: 'semantic',
    },
    {
      german: "auf",
      translated: "؟",
      tone: 'semantic',
    },
    {
      german: "Am häufigsten",
      translated: "غالبًا ما",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "يكون",
      tone: 'semantic',
    },
    {
      german: "sie/er",
      translated: "…",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:71|bg": [
    {
      german: "Wo",
      translated: "Къде",
      tone: 'semantic',
    },
    {
      german: "hält sich",
      translated: "прекарва",
      tone: 'semantic',
    },
    {
      german: "die deutsche Bundeskanzlerin/der deutsche Bundeskanzler",
      translated: "германският федерален канцлер",
      tone: 'semantic',
    },
    {
      german: "am häufigsten",
      translated: "най-често",
      tone: 'semantic',
    },
    {
      german: "Am häufigsten",
      translated: "Най-често",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "е",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:71|bs": [
    {
      german: "Wo",
      translated: "Gdje",
      tone: 'semantic',
    },
    {
      german: "hält sich",
      translated: "provodi",
      tone: 'semantic',
    },
    {
      german: "die deutsche Bundeskanzlerin/der deutsche Bundeskanzler",
      translated: "njemački savezni kancelar",
      tone: 'semantic',
    },
    {
      german: "am häufigsten",
      translated: "najviše vremena",
      tone: 'semantic',
    },
    {
      german: "Am häufigsten",
      translated: "Najčešće",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "je",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:71|el": [
    {
      german: "Wo",
      translated: "Πού",
      tone: 'semantic',
    },
    {
      german: "hält sich",
      translated: "περνά",
      tone: 'semantic',
    },
    {
      german: "die deutsche Bundeskanzlerin/der deutsche Bundeskanzler",
      translated: "ο Γερμανός ομοσπονδιακός καγκελάριος",
      tone: 'semantic',
    },
    {
      german: "am häufigsten",
      translated: "το μεγαλύτερο μέρος του χρόνου του",
      tone: 'semantic',
    },
    {
      german: "Am häufigsten",
      translated: "Συνήθως",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:71|en": [
    {
      german: "Wo",
      translated: "Where",
      tone: 'semantic',
    },
    {
      german: "hält sich",
      translated: "spend",
      tone: 'semantic',
    },
    {
      german: "die deutsche Bundeskanzlerin/der deutsche Bundeskanzler",
      translated: "the German Federal Chancellor",
      tone: 'semantic',
    },
    {
      german: "am häufigsten",
      translated: "most of their time",
      tone: 'semantic',
    },
    {
      german: "Am häufigsten",
      translated: "Most often",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "are",
      tone: 'semantic',
    },
    {
      german: "sie/er",
      translated: "they",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:71|es": [
    {
      german: "Wo",
      translated: "¿Dónde",
      tone: 'semantic',
    },
    {
      german: "hält sich",
      translated: "pasa",
      tone: 'semantic',
    },
    {
      german: "die deutsche Bundeskanzlerin/der deutsche Bundeskanzler",
      translated: "el Canciller Federal alemán",
      tone: 'semantic',
    },
    {
      german: "am häufigsten",
      translated: "la mayor parte del tiempo",
      tone: 'semantic',
    },
    {
      german: "Am häufigsten",
      translated: "Normalmente",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "está",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:71|fa": [
    {
      german: "Wo",
      translated: "کجا",
      tone: 'semantic',
    },
    {
      german: "hält sich",
      translated: "می‌گذراند",
      tone: 'semantic',
    },
    {
      german: "die deutsche Bundeskanzlerin/der deutsche Bundeskanzler",
      translated: "صدراعظم فدرال آلمان",
      tone: 'semantic',
    },
    {
      german: "am häufigsten",
      translated: "بیشتر وقت خود را",
      tone: 'semantic',
    },
    {
      german: "Am häufigsten",
      translated: "معمولاً",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:71|fr": [
    {
      german: "Wo",
      translated: "Où",
      tone: 'semantic',
    },
    {
      german: "hält sich",
      translated: "passe-t-il",
      tone: 'semantic',
    },
    {
      german: "die deutsche Bundeskanzlerin/der deutsche Bundeskanzler",
      translated: "le chancelier fédéral allemand",
      tone: 'semantic',
    },
    {
      german: "am häufigsten",
      translated: "la plupart de son temps",
      tone: 'semantic',
    },
    {
      german: "Am häufigsten",
      translated: "Le plus souvent",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:71|hr": [
    {
      german: "Wo",
      translated: "Gdje",
      tone: 'semantic',
    },
    {
      german: "hält sich",
      translated: "provodi",
      tone: 'semantic',
    },
    {
      german: "die deutsche Bundeskanzlerin/der deutsche Bundeskanzler",
      translated: "njemački savezni kancelar",
      tone: 'semantic',
    },
    {
      german: "am häufigsten",
      translated: "najviše vremena",
      tone: 'semantic',
    },
    {
      german: "Am häufigsten",
      translated: "Najčešće",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "je",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:71|it": [
    {
      german: "Wo",
      translated: "Dove",
      tone: 'semantic',
    },
    {
      german: "hält sich",
      translated: "trascorre",
      tone: 'semantic',
    },
    {
      german: "die deutsche Bundeskanzlerin/der deutsche Bundeskanzler",
      translated: "il cancelliere federale tedesco",
      tone: 'semantic',
    },
    {
      german: "am häufigsten",
      translated: "la maggior parte del tempo",
      tone: 'semantic',
    },
    {
      german: "Am häufigsten",
      translated: "Di solito",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:71|kmr": [
    {
      german: "Wo",
      translated: "li ku derê",
      tone: 'semantic',
    },
    {
      german: "hält sich",
      translated: "dimîne",
      tone: 'semantic',
    },
    {
      german: "die deutsche Bundeskanzlerin/der deutsche Bundeskanzler",
      translated: "Kanselerê Federal a Alman",
      tone: 'semantic',
    },
    {
      german: "am häufigsten",
      translated: "herî zêde",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:71|pl": [
    {
      german: "Wo",
      translated: "Gdzie",
      tone: 'semantic',
    },
    {
      german: "hält sich",
      translated: "spędza",
      tone: 'semantic',
    },
    {
      german: "die deutsche Bundeskanzlerin/der deutsche Bundeskanzler",
      translated: "niemiecki kanclerz federalny",
      tone: 'semantic',
    },
    {
      german: "am häufigsten",
      translated: "większość czasu",
      tone: 'semantic',
    },
    {
      german: "Am häufigsten",
      translated: "Zazwyczaj",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:71|prs": [
    {
      german: "Wo",
      translated: "کجا",
      tone: 'semantic',
    },
    {
      german: "die deutsche Bundeskanzlerin/der deutsche Bundeskanzler",
      translated: "صدراعظم فدرال آلمان",
      tone: 'semantic',
    },
    {
      german: "am häufigsten",
      translated: "معمولاً",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:71|ro": [
    {
      german: "Wo",
      translated: "Unde",
      tone: 'semantic',
    },
    {
      german: "hält sich",
      translated: "își petrece",
      tone: 'semantic',
    },
    {
      german: "die deutsche Bundeskanzlerin/der deutsche Bundeskanzler",
      translated: "cancelarul federal german",
      tone: 'semantic',
    },
    {
      german: "am häufigsten",
      translated: "cea mai mare parte a timpului",
      tone: 'semantic',
    },
    {
      german: "Am häufigsten",
      translated: "De obicei",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:71|ru": [
    {
      german: "Wo",
      translated: "Где",
      tone: 'semantic',
    },
    {
      german: "hält sich",
      translated: "находится",
      tone: 'semantic',
    },
    {
      german: "die deutsche Bundeskanzlerin/der deutsche Bundeskanzler",
      translated: "федеральный канцлер Германии",
      tone: 'semantic',
    },
    {
      german: "am häufigsten",
      translated: "чаще всего",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:71|sq": [
    {
      german: "Wo",
      translated: "Ku",
      tone: 'semantic',
    },
    {
      german: "die deutsche Bundeskanzlerin/der deutsche Bundeskanzler",
      translated: "kancelari federal gjerman",
      tone: 'semantic',
    },
    {
      german: "am häufigsten",
      translated: "pjesën më të madhe të kohës",
      tone: 'semantic',
    },
    {
      german: "Am häufigsten",
      translated: "Zakonisht",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:71|sr": [
    {
      german: "Wo",
      translated: "Gdje",
      tone: 'semantic',
    },
    {
      german: "hält sich",
      translated: "provodi",
      tone: 'semantic',
    },
    {
      german: "die deutsche Bundeskanzlerin/der deutsche Bundeskanzler",
      translated: "nemački savezni kancelar",
      tone: 'semantic',
    },
    {
      german: "am häufigsten",
      translated: "najviše vremena",
      tone: 'semantic',
    },
    {
      german: "Am häufigsten",
      translated: "Najčešće",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "je",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:71|tr": [
    {
      german: "Wo",
      translated: "nerede",
      tone: 'semantic',
    },
    {
      german: "die deutsche Bundeskanzlerin/der deutsche Bundeskanzler",
      translated: "Alman Federal Başbakanı",
      tone: 'semantic',
    },
    {
      german: "am häufigsten",
      translated: "en sık",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:71|uk": [
    {
      german: "Wo",
      translated: "Де",
      tone: 'semantic',
    },
    {
      german: "hält sich",
      translated: "перебуває",
      tone: 'semantic',
    },
    {
      german: "die deutsche Bundeskanzlerin/der deutsche Bundeskanzler",
      translated: "федеральний канцлер Німеччини",
      tone: 'semantic',
    },
    {
      german: "am häufigsten",
      translated: "найчастіше",
      tone: 'semantic',
    },
    {
      german: "Am häufigsten",
      translated: "Найчастіше",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "перебуває",
      tone: 'semantic',
    },
    {
      german: "sie/er",
      translated: "він/вона",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:71|vi": [
    {
      german: "Wo",
      translated: "ở đâu",
      tone: 'semantic',
    },
    {
      german: "die deutsche Bundeskanzlerin/der deutsche Bundeskanzler",
      translated: "Thủ tướng Liên bang Đức",
      tone: 'semantic',
    },
    {
      german: "Am häufigsten",
      translated: "Thông thường",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:72|ar": [
    {
      german: "Wie heißt",
      translated: "ما اسم",
      tone: 'semantic',
    },
    {
      german: "der jetzige Bundeskanzler",
      translated: "المستشار الاتحادي الحالي",
      tone: 'semantic',
    },
    {
      german: "von Deutschland",
      translated: "لألمانيا",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:72|bg": [
    {
      german: "Wie heißt",
      translated: "Как се казва",
      tone: 'semantic',
    },
    {
      german: "der jetzige Bundeskanzler",
      translated: "настоящият федерален канцлер",
      tone: 'semantic',
    },
    {
      german: "von Deutschland",
      translated: "на Германия",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:72|bs": [
    {
      german: "Wie heißt",
      translated: "Kako se zove",
      tone: 'semantic',
    },
    {
      german: "der jetzige Bundeskanzler",
      translated: "sadašnji njemački savezni kancelar",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:72|el": [
    {
      german: "Wie heißt",
      translated: "Πώς ονομάζεται",
      tone: 'semantic',
    },
    {
      german: "die jetzige Bundeskanzlerin",
      translated: "ο σημερινός Ομοσπονδιακός Καγκελάριος",
      tone: 'semantic',
    },
    {
      german: "von Deutschland",
      translated: "της Γερμανίας",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:72|en": [
    {
      german: "Wie heißt",
      translated: "What is",
      tone: 'semantic',
    },
    {
      german: "die jetzige Bundeskanzlerin",
      translated: "the name of the current",
      tone: 'semantic',
    },
    {
      german: "der jetzige Bundeskanzler",
      translated: "Federal Chancellor",
      tone: 'semantic',
    },
    {
      german: "von Deutschland",
      translated: "of Germany",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:72|es": [
    {
      german: "Wie heißt",
      translated: "¿Cómo se llama",
      tone: 'semantic',
    },
    {
      german: "die jetzige Bundeskanzlerin",
      translated: "actual Canciller Federal",
      tone: 'semantic',
    },
    {
      german: "von Deutschland",
      translated: "de Alemania",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:72|fa": [
    {
      german: "Wie heißt",
      translated: "چه نام دارد",
      tone: 'semantic',
    },
    {
      german: "der jetzige Bundeskanzler",
      translated: "صدراعظم فدرال کنونی",
      tone: 'semantic',
    },
    {
      german: "von Deutschland",
      translated: "آلمان",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:72|fr": [
    {
      german: "Wie heißt",
      translated: "Comment",
      tone: 'semantic',
    },
    {
      german: "die jetzige Bundeskanzlerin",
      translated: "l’actuel",
      tone: 'semantic',
    },
    {
      german: "der jetzige Bundeskanzler",
      translated: "chancelier fédéral",
      tone: 'semantic',
    },
    {
      german: "von Deutschland",
      translated: "de l’Allemagne",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:72|hr": [
    {
      german: "Wie heißt",
      translated: "Kako se zove",
      tone: 'semantic',
    },
    {
      german: "der jetzige Bundeskanzler",
      translated: "sadašnji njemački savezni kancelar",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:72|it": [
    {
      german: "Wie heißt",
      translated: "Come si",
      tone: 'semantic',
    },
    {
      german: "die jetzige Bundeskanzlerin",
      translated: "l’attuale",
      tone: 'semantic',
    },
    {
      german: "der jetzige Bundeskanzler",
      translated: "cancelliere",
      tone: 'semantic',
    },
    {
      german: "von Deutschland",
      translated: "della Germania",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:72|kmr": [
    {
      german: "Wie heißt",
      translated: "Navê",
      tone: 'semantic',
    },
    {
      german: "die jetzige Bundeskanzlerin",
      translated: "kanselerê federal",
      tone: 'semantic',
    },
    {
      german: "der jetzige Bundeskanzler",
      translated: "niha yê Almanyayê çi",
      tone: 'semantic',
    },
    {
      german: "von Deutschland",
      translated: "ye",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:72|pl": [
    {
      german: "Wie heißt",
      translated: "Jak nazywa się",
      tone: 'semantic',
    },
    {
      german: "der jetzige Bundeskanzler",
      translated: "obecny kanclerz federalny",
      tone: 'semantic',
    },
    {
      german: "von Deutschland",
      translated: "Niemiec?",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:72|prs": [
    {
      german: "Wie heißt",
      translated: "چه نام دارد",
      tone: 'semantic',
    },
    {
      german: "der jetzige Bundeskanzler",
      translated: "صدراعظم فدرال کنونی",
      tone: 'semantic',
    },
    {
      german: "von Deutschland",
      translated: "آلمان",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:72|ro": [
    {
      german: "Wie heißt",
      translated: "Cum se numește",
      tone: 'semantic',
    },
    {
      german: "die jetzige Bundeskanzlerin",
      translated: "actualul cancelar federal",
      tone: 'semantic',
    },
    {
      german: "von Deutschland",
      translated: "al Germaniei",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:72|ru": [
    {
      german: "Wie heißt",
      translated: "Как зовут",
      tone: 'semantic',
    },
    {
      german: "der jetzige Bundeskanzler",
      translated: "нынешнего федерального канцлера",
      tone: 'semantic',
    },
    {
      german: "von Deutschland",
      translated: "Германии",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:72|sq": [
    {
      german: "Wie heißt",
      translated: "Si quhet",
      tone: 'semantic',
    },
    {
      german: "die jetzige Bundeskanzlerin",
      translated: "kancelari aktual",
      tone: 'semantic',
    },
    {
      german: "von Deutschland",
      translated: "i Gjermanisë",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:72|sr": [
    {
      german: "Wie heißt",
      translated: "Kako se zove",
      tone: 'semantic',
    },
    {
      german: "der jetzige Bundeskanzler",
      translated: "sadašnji nemački savezni kancelar",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:72|tr": [
    {
      german: "Wie heißt",
      translated: "kimdir",
      tone: 'semantic',
    },
    {
      german: "die jetzige Bundeskanzlerin",
      translated: "şu anki Federal Başbakanı",
      tone: 'semantic',
    },
    {
      german: "von Deutschland",
      translated: "Almanya'nın",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:72|uk": [
    {
      german: "Wie heißt",
      translated: "Як звати",
      tone: 'semantic',
    },
    {
      german: "der jetzige Bundeskanzler",
      translated: "нинішнього федерального канцлера",
      tone: 'semantic',
    },
    {
      german: "von Deutschland",
      translated: "Німеччини",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:72|vi": [
    {
      german: "Wie heißt",
      translated: "tên là gì",
      tone: 'semantic',
    },
    {
      german: "die jetzige Bundeskanzlerin",
      translated: "Thủ tướng",
      tone: 'semantic',
    },
    {
      german: "von Deutschland",
      translated: "Liên bang Đức",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:73|ar": [
    {
      german: "Die beiden größten Fraktionen",
      translated: "أكبر كتلتين",
      tone: 'semantic',
    },
    {
      german: "im Deutschen Bundestag",
      translated: "البوندستاغ الألماني",
      tone: 'semantic',
    },
    {
      german: "zurzeit",
      translated: "حاليًا",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:73|bg": [
    {
      german: "Die beiden größten Fraktionen",
      translated: "двете най-големи парламентарни групи",
      tone: 'semantic',
    },
    {
      german: "im Deutschen Bundestag",
      translated: "в германския Бундестаг",
      tone: 'semantic',
    },
    {
      german: "heißen",
      translated: "Как се наричат",
      tone: 'semantic',
    },
    {
      german: "zurzeit",
      translated: "в момента",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:73|bs": [
    {
      german: "Die beiden größten Fraktionen",
      translated: "dvije najveće parlamentarne skupine",
      tone: 'semantic',
    },
    {
      german: "im Deutschen Bundestag",
      translated: "u njemačkom Bundestagu",
      tone: 'semantic',
    },
    {
      german: "heißen",
      translated: "Koje su",
      tone: 'semantic',
    },
    {
      german: "zurzeit",
      translated: "trenutno",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:73|el": [
    {
      german: "Die beiden größten Fraktionen",
      translated: "οι δύο μεγαλύτερες κοινοβουλευτικές ομάδες",
      tone: 'semantic',
    },
    {
      german: "im Deutschen Bundestag",
      translated: "στο γερμανικό Bundestag",
      tone: 'semantic',
    },
    {
      german: "heißen",
      translated: "Ποιες είναι",
      tone: 'semantic',
    },
    {
      german: "zurzeit",
      translated: "σήμερα",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:73|en": [
    {
      german: "Die beiden größten Fraktionen",
      translated: "The two largest parliamentary groups",
      tone: 'semantic',
    },
    {
      german: "im Deutschen Bundestag",
      translated: "in the German Bundestag",
      tone: 'semantic',
    },
    {
      german: "heißen",
      translated: "called",
      tone: 'semantic',
    },
    {
      german: "zurzeit",
      translated: "currently",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:73|es": [
    {
      german: "Die beiden größten Fraktionen",
      translated: "Los dos grupos parlamentarios más grandes",
      tone: 'semantic',
    },
    {
      german: "im Deutschen Bundestag",
      translated: "del Bundestag alemán",
      tone: 'semantic',
    },
    {
      german: "heißen",
      translated: "se llaman",
      tone: 'semantic',
    },
    {
      german: "zurzeit",
      translated: "actualmente",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:73|fa": [
    {
      german: "Die beiden größten Fraktionen",
      translated: "دو فراکسیون بزرگ",
      tone: 'semantic',
    },
    {
      german: "im Deutschen Bundestag",
      translated: "در بوندستاگ آلمان",
      tone: 'semantic',
    },
    {
      german: "heißen",
      translated: "کدام‌اند",
      tone: 'semantic',
    },
    {
      german: "zurzeit",
      translated: "کنونی",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:73|fr": [
    {
      german: "Die beiden größten Fraktionen",
      translated: "Les deux plus grands groupes parlementaires",
      tone: 'semantic',
    },
    {
      german: "im Deutschen Bundestag",
      translated: "du Bundestag allemand",
      tone: 'semantic',
    },
    {
      german: "heißen",
      translated: "sont",
      tone: 'semantic',
    },
    {
      german: "zurzeit",
      translated: "actuellement",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:73|hr": [
    {
      german: "Die beiden größten Fraktionen",
      translated: "dvije najveće parlamentarne skupine",
      tone: 'semantic',
    },
    {
      german: "im Deutschen Bundestag",
      translated: "u njemačkom Bundestagu",
      tone: 'semantic',
    },
    {
      german: "heißen",
      translated: "Koje su",
      tone: 'semantic',
    },
    {
      german: "zurzeit",
      translated: "trenutačno",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:73|it": [
    {
      german: "Die beiden größten Fraktionen",
      translated: "i due maggiori gruppi parlamentari",
      tone: 'semantic',
    },
    {
      german: "im Deutschen Bundestag",
      translated: "nel Bundestag tedesco",
      tone: 'semantic',
    },
    {
      german: "heißen",
      translated: "Quali sono",
      tone: 'semantic',
    },
    {
      german: "zurzeit",
      translated: "attualmente",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:73|kmr": [
    {
      german: "Die beiden größten Fraktionen",
      translated: "Du fraksiyonên herî mezin",
      tone: 'semantic',
    },
    {
      german: "im Deutschen Bundestag",
      translated: "ên Bundestagê Alman",
      tone: 'semantic',
    },
    {
      german: "heißen",
      translated: "ne",
      tone: 'semantic',
    },
    {
      german: "zurzeit",
      translated: "niha",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:73|pl": [
    {
      german: "Die beiden größten Fraktionen",
      translated: "dwie największe frakcje parlamentarne",
      tone: 'semantic',
    },
    {
      german: "im Deutschen Bundestag",
      translated: "w niemieckim Bundestagu",
      tone: 'semantic',
    },
    {
      german: "heißen",
      translated: "Jakie są",
      tone: 'semantic',
    },
    {
      german: "zurzeit",
      translated: "obecnie",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:73|prs": [
    {
      german: "Die beiden größten Fraktionen",
      translated: "دو فراکسیون بزرگ",
      tone: 'semantic',
    },
    {
      german: "im Deutschen Bundestag",
      translated: "در بوندستاگ آلمان",
      tone: 'semantic',
    },
    {
      german: "zurzeit",
      translated: "کنونی",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:73|ro": [
    {
      german: "Die beiden größten Fraktionen",
      translated: "cele două grupuri parlamentare mari",
      tone: 'semantic',
    },
    {
      german: "im Deutschen Bundestag",
      translated: "din Bundestagul german",
      tone: 'semantic',
    },
    {
      german: "heißen",
      translated: "Care sunt",
      tone: 'semantic',
    },
    {
      german: "zurzeit",
      translated: "în prezent",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:73|ru": [
    {
      german: "Die beiden größten Fraktionen",
      translated: "Две самые крупные фракции",
      tone: 'semantic',
    },
    {
      german: "im Deutschen Bundestag",
      translated: "в Бундестаге Германии",
      tone: 'semantic',
    },
    {
      german: "heißen",
      translated: "называются",
      tone: 'semantic',
    },
    {
      german: "zurzeit",
      translated: "в настоящее время",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:73|sq": [
    {
      german: "Die beiden größten Fraktionen",
      translated: "dy grupet më të mëdha parlamentare",
      tone: 'semantic',
    },
    {
      german: "im Deutschen Bundestag",
      translated: "në Bundestagun gjerman",
      tone: 'semantic',
    },
    {
      german: "heißen",
      translated: "Cilat janë",
      tone: 'semantic',
    },
    {
      german: "zurzeit",
      translated: "aktualisht",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:73|sr": [
    {
      german: "Die beiden größten Fraktionen",
      translated: "Koje",
      tone: 'semantic',
    },
    {
      german: "im Deutschen Bundestag",
      translated: "u nemačkom Bundestagu",
      tone: 'semantic',
    },
    {
      german: "heißen",
      translated: "su",
      tone: 'semantic',
    },
    {
      german: "zurzeit",
      translated: "trenutno",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:73|tr": [
    {
      german: "Die beiden größten Fraktionen",
      translated: "en büyük iki meclis grubu",
      tone: 'semantic',
    },
    {
      german: "im Deutschen Bundestag",
      translated: "Alman Federal Meclisi'ndeki",
      tone: 'semantic',
    },
    {
      german: "zurzeit",
      translated: "şu anki",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:73|uk": [
    {
      german: "Die beiden größten Fraktionen",
      translated: "Дві найбільші фракції",
      tone: 'semantic',
    },
    {
      german: "im Deutschen Bundestag",
      translated: "в німецькому Бундестазі",
      tone: 'semantic',
    },
    {
      german: "heißen",
      translated: " називаються",
      tone: 'semantic',
    },
    {
      german: "zurzeit",
      translated: "зараз",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:73|vi": [
    {
      german: "Die beiden größten Fraktionen",
      translated: "Hai nhóm nghị sĩ lớn nhất",
      tone: 'semantic',
    },
    {
      german: "im Deutschen Bundestag",
      translated: "trong Bundestag Đức",
      tone: 'semantic',
    },
    {
      german: "heißen",
      translated: "là",
      tone: 'semantic',
    },
    {
      german: "zurzeit",
      translated: "hiện nay",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:74|ar": [
    {
      german: "Wie heißt",
      translated: "ما اسم",
      tone: 'semantic',
    },
    {
      german: "das Parlament",
      translated: "البرلمان",
      tone: 'semantic',
    },
    {
      german: "für ganz Deutschland",
      translated: "ألمانيا كلها",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:74|bg": [
    {
      german: "Wie heißt",
      translated: "Как се нарича",
      tone: 'semantic',
    },
    {
      german: "das Parlament",
      translated: "парламентът",
      tone: 'semantic',
    },
    {
      german: "für ganz Deutschland",
      translated: "на цяла Германия",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:74|bs": [
    {
      german: "Wie heißt",
      translated: "Kako se",
      tone: 'semantic',
    },
    {
      german: "das Parlament",
      translated: "parlament",
      tone: 'semantic',
    },
    {
      german: "für ganz Deutschland",
      translated: "cijele Njemačke",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:74|el": [
    {
      german: "Wie heißt",
      translated: "Πώς ονομάζεται",
      tone: 'semantic',
    },
    {
      german: "das Parlament",
      translated: "το κοινοβούλιο",
      tone: 'semantic',
    },
    {
      german: "für ganz Deutschland",
      translated: "ολόκληρης της Γερμανίας",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:74|en": [
    {
      german: "Wie heißt",
      translated: "What is",
      tone: 'semantic',
    },
    {
      german: "das Parlament",
      translated: "the parliament",
      tone: 'semantic',
    },
    {
      german: "für ganz Deutschland",
      translated: "all of Germany",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:74|es": [
    {
      german: "Wie heißt",
      translated: "Cómo se llama",
      tone: 'semantic',
    },
    {
      german: "das Parlament",
      translated: "el parlamento",
      tone: 'semantic',
    },
    {
      german: "für ganz Deutschland",
      translated: "de toda Alemania",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:74|fa": [
    {
      german: "Wie heißt",
      translated: "نام دارد",
      tone: 'semantic',
    },
    {
      german: "das Parlament",
      translated: "پارلمان",
      tone: 'semantic',
    },
    {
      german: "für ganz Deutschland",
      translated: "سراسر آلمان",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:74|fr": [
    {
      german: "Wie heißt",
      translated: "Comment s’appelle le",
      tone: 'semantic',
    },
    {
      german: "das Parlament",
      translated: "Parlement de",
      tone: 'semantic',
    },
    {
      german: "für ganz Deutschland",
      translated: "toute l’Allemagne",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:74|hr": [
    {
      german: "Wie heißt",
      translated: "Kako se zove",
      tone: 'semantic',
    },
    {
      german: "das Parlament",
      translated: "parlament",
      tone: 'semantic',
    },
    {
      german: "für ganz Deutschland",
      translated: "cijele Njemačke",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:74|it": [
    {
      german: "Wie heißt",
      translated: "Come si chiama",
      tone: 'semantic',
    },
    {
      german: "das Parlament",
      translated: "il Parlamento",
      tone: 'semantic',
    },
    {
      german: "für ganz Deutschland",
      translated: "di tutta la Germania",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:74|kmr": [
    {
      german: "Wie heißt",
      translated: "Navê",
      tone: 'semantic',
    },
    {
      german: "das Parlament",
      translated: "parlamentoya",
      tone: 'semantic',
    },
    {
      german: "für ganz Deutschland",
      translated: "Almanyayê çi ye",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:74|pl": [
    {
      german: "Wie heißt",
      translated: "Jak nazywa się",
      tone: 'semantic',
    },
    {
      german: "das Parlament",
      translated: "parlament",
      tone: 'semantic',
    },
    {
      german: "für ganz Deutschland",
      translated: "całych Niemiec",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:74|prs": [
    {
      german: "Wie heißt",
      translated: "چه نام دارد؟",
      tone: 'semantic',
    },
    {
      german: "das Parlament",
      translated: "پارلمان",
      tone: 'semantic',
    },
    {
      german: "für ganz Deutschland",
      translated: "سراسر آلمان",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:74|ro": [
    {
      german: "Wie heißt",
      translated: "Cum se numește",
      tone: 'semantic',
    },
    {
      german: "das Parlament",
      translated: "parlamentul",
      tone: 'semantic',
    },
    {
      german: "für ganz Deutschland",
      translated: "întregii Germanii",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:74|ru": [
    {
      german: "Wie heißt",
      translated: "Как называется",
      tone: 'semantic',
    },
    {
      german: "das Parlament",
      translated: "парламент",
      tone: 'semantic',
    },
    {
      german: "für ganz Deutschland",
      translated: "всей Германии",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:74|sq": [
    {
      german: "Wie heißt",
      translated: "Si quhet",
      tone: 'semantic',
    },
    {
      german: "das Parlament",
      translated: "parlamenti",
      tone: 'semantic',
    },
    {
      german: "für ganz Deutschland",
      translated: "i gjithë Gjermanisë",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:74|sr": [
    {
      german: "Wie heißt",
      translated: "Kako se zove",
      tone: 'semantic',
    },
    {
      german: "das Parlament",
      translated: "parlament",
      tone: 'semantic',
    },
    {
      german: "für ganz Deutschland",
      translated: "cijele Nemačke",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:74|tr": [
    {
      german: "Wie heißt",
      translated: "nedir",
      tone: 'semantic',
    },
    {
      german: "das Parlament",
      translated: "parlamentonun adı",
      tone: 'semantic',
    },
    {
      german: "für ganz Deutschland",
      translated: "Tüm Almanya'yı temsil eden",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:74|uk": [
    {
      german: "Wie heißt",
      translated: " називається",
      tone: 'semantic',
    },
    {
      german: "das Parlament",
      translated: "парламент",
      tone: 'semantic',
    },
    {
      german: "für ganz Deutschland",
      translated: "усієї Німеччини",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:74|vi": [
    {
      german: "Wie heißt",
      translated: "gọi là",
      tone: 'semantic',
    },
    {
      german: "das Parlament",
      translated: "Nghị viện",
      tone: 'semantic',
    },
    {
      german: "für ganz Deutschland",
      translated: "của toàn nước Đức",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:75|ar": [
    {
      german: "Wie heißt",
      translated: "ما اسم",
      tone: 'semantic',
    },
    {
      german: "Deutschlands",
      translated: "ألمانيا",
      tone: 'semantic',
    },
    {
      german: "heutiges Staatsoberhaupt",
      translated: "رئيس الدولة الحالي",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:75|bg": [
    {
      german: "Wie heißt",
      translated: "Как се",
      tone: 'semantic',
    },
    {
      german: "Deutschlands",
      translated: "настоящият държавен глава",
      tone: 'semantic',
    },
    {
      german: "heutiges Staatsoberhaupt",
      translated: "на Германия",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:75|bs": [
    {
      german: "Wie heißt",
      translated: "Kako se zove",
      tone: 'semantic',
    },
    {
      german: "Deutschlands",
      translated: "njemački",
      tone: 'semantic',
    },
    {
      german: "heutiges Staatsoberhaupt",
      translated: "šef države",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:75|el": [
    {
      german: "Wie heißt",
      translated: "Πώς ονομάζεται",
      tone: 'semantic',
    },
    {
      german: "Deutschlands",
      translated: "του γερμανικού",
      tone: 'semantic',
    },
    {
      german: "heutiges Staatsoberhaupt",
      translated: "κράτους",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:75|en": [
    {
      german: "Wie heißt",
      translated: "What is",
      tone: 'semantic',
    },
    {
      german: "Deutschlands",
      translated: "Germany's",
      tone: 'semantic',
    },
    {
      german: "heutiges Staatsoberhaupt",
      translated: "current head of state",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:75|es": [
    {
      german: "Wie heißt",
      translated: "¿Cómo se llama",
      tone: 'semantic',
    },
    {
      german: "Deutschlands",
      translated: "de Alemania",
      tone: 'semantic',
    },
    {
      german: "heutiges Staatsoberhaupt",
      translated: "actualmente el jefe de Estado",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:75|fa": [
    {
      german: "Wie heißt",
      translated: "رئیس کشور",
      tone: 'semantic',
    },
    {
      german: "Deutschlands",
      translated: "آلمان",
      tone: 'semantic',
    },
    {
      german: "heutiges Staatsoberhaupt",
      translated: "کنونی",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:75|fr": [
    {
      german: "Wie heißt",
      translated: "Comment s’appelle",
      tone: 'semantic',
    },
    {
      german: "Deutschlands",
      translated: "allemand",
      tone: 'semantic',
    },
    {
      german: "heutiges Staatsoberhaupt",
      translated: "l’actuel chef de l’État",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:75|hr": [
    {
      german: "Wie heißt",
      translated: "Kako se zove",
      tone: 'semantic',
    },
    {
      german: "Deutschlands",
      translated: "njemački",
      tone: 'semantic',
    },
    {
      german: "heutiges Staatsoberhaupt",
      translated: "šef države",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:75|it": [
    {
      german: "Wie heißt",
      translated: "Come si chiama",
      tone: 'semantic',
    },
    {
      german: "Deutschlands",
      translated: "tedesco",
      tone: 'semantic',
    },
    {
      german: "heutiges Staatsoberhaupt",
      translated: "l’attuale capo dello Stato",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:75|kmr": [
    {
      german: "Wie heißt",
      translated: "Navê serokê",
      tone: 'semantic',
    },
    {
      german: "Deutschlands",
      translated: "dewleta Almanyayê",
      tone: 'semantic',
    },
    {
      german: "heutiges Staatsoberhaupt",
      translated: "niha çi ye",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:75|pl": [
    {
      german: "Wie heißt",
      translated: "Jak nazywa się",
      tone: 'semantic',
    },
    {
      german: "Deutschlands",
      translated: "niemieckiego",
      tone: 'semantic',
    },
    {
      german: "heutiges Staatsoberhaupt",
      translated: "obecna głowa państwa",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:75|prs": [
    {
      german: "Wie heißt",
      translated: "رئیس",
      tone: 'semantic',
    },
    {
      german: "Deutschlands",
      translated: "کشور",
      tone: 'semantic',
    },
    {
      german: "heutiges Staatsoberhaupt",
      translated: "کنونی آلمان",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:75|ro": [
    {
      german: "Wie heißt",
      translated: "Cum se numește",
      tone: 'semantic',
    },
    {
      german: "Deutschlands",
      translated: "german",
      tone: 'semantic',
    },
    {
      german: "heutiges Staatsoberhaupt",
      translated: "actualul șef al statului",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:75|ru": [
    {
      german: "Wie heißt",
      translated: "Как зовут",
      tone: 'semantic',
    },
    {
      german: "Deutschlands",
      translated: "Германии",
      tone: 'semantic',
    },
    {
      german: "heutiges Staatsoberhaupt",
      translated: "нынешнего главу государства",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:75|sq": [
    {
      german: "Wie heißt",
      translated: "Si quhet",
      tone: 'semantic',
    },
    {
      german: "heutiges Staatsoberhaupt",
      translated: "aktual i shtetit gjerman",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:75|sr": [
    {
      german: "Wie heißt",
      translated: "Kako se zove",
      tone: 'semantic',
    },
    {
      german: "Deutschlands",
      translated: "nemački",
      tone: 'semantic',
    },
    {
      german: "heutiges Staatsoberhaupt",
      translated: "šef države",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:75|tr": [
    {
      german: "Wie heißt",
      translated: "kimdir",
      tone: 'semantic',
    },
    {
      german: "Deutschlands",
      translated: "Almanya'nın",
      tone: 'semantic',
    },
    {
      german: "heutiges Staatsoberhaupt",
      translated: "bugünkü devlet başkanı",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:75|uk": [
    {
      german: "Wie heißt",
      translated: "Як звати",
      tone: 'semantic',
    },
    {
      german: "Deutschlands",
      translated: "Німеччини",
      tone: 'semantic',
    },
    {
      german: "heutiges Staatsoberhaupt",
      translated: "нинішнього главу держави",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:75|vi": [
    {
      german: "Wie heißt",
      translated: "tên là gì",
      tone: 'semantic',
    },
    {
      german: "Deutschlands",
      translated: "của Đức",
      tone: 'semantic',
    },
    {
      german: "heutiges Staatsoberhaupt",
      translated: "Nguyên thủ quốc gia hiện nay",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:76|ar": [
    {
      german: "Was bedeutet",
      translated: "ماذا يعني",
      tone: 'semantic',
    },
    {
      german: "die Abkürzung",
      translated: "الاختصار",
      tone: 'semantic',
    },
    {
      german: "CDU",
      translated: "CDU",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "في ألمانيا",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:76|bg": [
    {
      german: "Was bedeutet",
      translated: "Какво означава",
      tone: 'semantic',
    },
    {
      german: "die Abkürzung",
      translated: "съкращението",
      tone: 'semantic',
    },
    {
      german: "CDU",
      translated: "CDU",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "в Германия",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:76|bs": [
    {
      german: "Was bedeutet",
      translated: "Što",
      tone: 'semantic',
    },
    {
      german: "die Abkürzung",
      translated: "kratica",
      tone: 'semantic',
    },
    {
      german: "CDU",
      translated: "CDU",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "u Njemačkoj",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:76|el": [
    {
      german: "Was bedeutet",
      translated: "Τι σημαίνει",
      tone: 'semantic',
    },
    {
      german: "die Abkürzung",
      translated: "η συντομογραφία",
      tone: 'semantic',
    },
    {
      german: "CDU",
      translated: "CDU",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "στη Γερμανία",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:76|en": [
    {
      german: "Was bedeutet",
      translated: "What does",
      tone: 'semantic',
    },
    {
      german: "die Abkürzung",
      translated: "the abbreviation",
      tone: 'semantic',
    },
    {
      german: "CDU",
      translated: "CDU",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "in Germany",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:76|es": [
    {
      german: "Was bedeutet",
      translated: "¿Qué significa",
      tone: 'semantic',
    },
    {
      german: "die Abkürzung",
      translated: "la abreviatura",
      tone: 'semantic',
    },
    {
      german: "CDU",
      translated: "CDU",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "en Alemania",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:76|fa": [
    {
      german: "Was bedeutet",
      translated: "به چه معناست",
      tone: 'semantic',
    },
    {
      german: "die Abkürzung",
      translated: "مخفف",
      tone: 'semantic',
    },
    {
      german: "CDU",
      translated: "CDU",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "در آلمان",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:76|fr": [
    {
      german: "Was bedeutet",
      translated: "Que signifie",
      tone: 'semantic',
    },
    {
      german: "die Abkürzung",
      translated: "l’abréviation",
      tone: 'semantic',
    },
    {
      german: "CDU",
      translated: "CDU",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "en Allemagne",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:76|hr": [
    {
      german: "Was bedeutet",
      translated: "Što",
      tone: 'semantic',
    },
    {
      german: "die Abkürzung",
      translated: "kratica",
      tone: 'semantic',
    },
    {
      german: "CDU",
      translated: "CDU",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "u Njemačkoj",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:76|it": [
    {
      german: "Was bedeutet",
      translated: "Che cosa significa",
      tone: 'semantic',
    },
    {
      german: "die Abkürzung",
      translated: "l’abbreviazione",
      tone: 'semantic',
    },
    {
      german: "CDU",
      translated: "CDU",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "in Germania",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:76|kmr": [
    {
      german: "Was bedeutet",
      translated: "tê çi wateyê",
      tone: 'semantic',
    },
    {
      german: "CDU",
      translated: "CDU",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "li Almanyayê",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:76|pl": [
    {
      german: "Was bedeutet",
      translated: "Co oznacza",
      tone: 'semantic',
    },
    {
      german: "die Abkürzung",
      translated: "skrót",
      tone: 'semantic',
    },
    {
      german: "CDU",
      translated: "CDU",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "w Niemczech",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:76|prs": [
    {
      german: "die Abkürzung",
      translated: "مخفف",
      tone: 'semantic',
    },
    {
      german: "CDU",
      translated: "CDU",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "در آلمان",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:76|ro": [
    {
      german: "Was bedeutet",
      translated: "Ce înseamnă",
      tone: 'semantic',
    },
    {
      german: "die Abkürzung",
      translated: "abrevierea",
      tone: 'semantic',
    },
    {
      german: "CDU",
      translated: "CDU",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "în Germania",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:76|ru": [
    {
      german: "Was bedeutet",
      translated: "Что означает",
      tone: 'semantic',
    },
    {
      german: "die Abkürzung",
      translated: "аббревиатура",
      tone: 'semantic',
    },
    {
      german: "CDU",
      translated: "CDU",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "в Германии",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:76|sq": [
    {
      german: "Was bedeutet",
      translated: "Çfarë do të thotë",
      tone: 'semantic',
    },
    {
      german: "die Abkürzung",
      translated: "shkurtesa",
      tone: 'semantic',
    },
    {
      german: "CDU",
      translated: "CDU",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "në Gjermani",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:76|sr": [
    {
      german: "die Abkürzung",
      translated: "kratica",
      tone: 'semantic',
    },
    {
      german: "CDU",
      translated: "CDU",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "u Nemačkoj",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:76|tr": [
    {
      german: "Was bedeutet",
      translated: "ne anlama gelir",
      tone: 'semantic',
    },
    {
      german: "die Abkürzung",
      translated: "kısaltması",
      tone: 'semantic',
    },
    {
      german: "CDU",
      translated: "CDU",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "Almanya'da",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:76|uk": [
    {
      german: "Was bedeutet",
      translated: "Що означає",
      tone: 'semantic',
    },
    {
      german: "die Abkürzung",
      translated: "абревіатура",
      tone: 'semantic',
    },
    {
      german: "CDU",
      translated: "CDU",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "в Німеччині",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:76|vi": [
    {
      german: "Was bedeutet",
      translated: "có nghĩa là",
      tone: 'semantic',
    },
    {
      german: "die Abkürzung",
      translated: "Chữ viết tắt",
      tone: 'semantic',
    },
    {
      german: "CDU",
      translated: "CDU",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "ở Đức",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:77|ar": [
    {
      german: "Was ist",
      translated: "ما هي",
      tone: 'semantic',
    },
    {
      german: "die Bundeswehr",
      translated: "البوندسفير (Bundeswehr)",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:77|bg": [
    {
      german: "Was ist",
      translated: "Какво е",
      tone: 'semantic',
    },
    {
      german: "die Bundeswehr",
      translated: "Bundeswehr",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:77|bs": [
    {
      german: "Was ist",
      translated: "Što je",
      tone: 'semantic',
    },
    {
      german: "die Bundeswehr",
      translated: "Bundeswehr",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:77|el": [
    {
      german: "Was ist",
      translated: "Τι είναι",
      tone: 'semantic',
    },
    {
      german: "die Bundeswehr",
      translated: "η Bundeswehr",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:77|en": [
    {
      german: "Was ist",
      translated: "What is",
      tone: 'semantic',
    },
    {
      german: "die Bundeswehr",
      translated: "the Bundeswehr",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:77|es": [
    {
      german: "Was ist",
      translated: "¿Qué es",
      tone: 'semantic',
    },
    {
      german: "die Bundeswehr",
      translated: "la Bundeswehr",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:77|fa": [
    {
      german: "Was ist",
      translated: "چیست",
      tone: 'semantic',
    },
    {
      german: "die Bundeswehr",
      translated: "بوندس‌وِر (Bundeswehr)",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:77|fr": [
    {
      german: "Was ist",
      translated: "Qu’est-ce que",
      tone: 'semantic',
    },
    {
      german: "die Bundeswehr",
      translated: "la Bundeswehr",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:77|hr": [
    {
      german: "Was ist",
      translated: "Što je",
      tone: 'semantic',
    },
    {
      german: "die Bundeswehr",
      translated: "Bundeswehr",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:77|it": [
    {
      german: "Was ist",
      translated: "Che cos’è",
      tone: 'semantic',
    },
    {
      german: "die Bundeswehr",
      translated: "la Bundeswehr",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:77|kmr": [
    {
      german: "Was ist",
      translated: "çi ye",
      tone: 'semantic',
    },
    {
      german: "die Bundeswehr",
      translated: "Bundeswehr",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:77|pl": [
    {
      german: "Was ist",
      translated: "Czym jest",
      tone: 'semantic',
    },
    {
      german: "die Bundeswehr",
      translated: "Bundeswehra",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:77|prs": [
    {
      german: "Was ist",
      translated: "چیست",
      tone: 'semantic',
    },
    {
      german: "die Bundeswehr",
      translated: "بوندس‌وِر",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:77|ro": [
    {
      german: "Was ist",
      translated: "Ce este",
      tone: 'semantic',
    },
    {
      german: "die Bundeswehr",
      translated: "Bundeswehr",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:77|ru": [
    {
      german: "Was ist",
      translated: "Что такое",
      tone: 'semantic',
    },
    {
      german: "die Bundeswehr",
      translated: "Бундесвер",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:77|sq": [
    {
      german: "Was ist",
      translated: "Çfarë është",
      tone: 'semantic',
    },
    {
      german: "die Bundeswehr",
      translated: "Bundeswehr-i",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:77|sr": [
    {
      german: "Was ist",
      translated: "Šta je",
      tone: 'semantic',
    },
    {
      german: "die Bundeswehr",
      translated: "Bundeswehr",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:77|tr": [
    {
      german: "Was ist",
      translated: "nedir",
      tone: 'semantic',
    },
    {
      german: "die Bundeswehr",
      translated: "Bundeswehr",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:77|uk": [
    {
      german: "Was ist",
      translated: "Що",
      tone: 'semantic',
    },
    {
      german: "die Bundeswehr",
      translated: "Бундесвер (Bundeswehr)",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:77|vi": [
    {
      german: "Was ist",
      translated: "là gì",
      tone: 'semantic',
    },
    {
      german: "die Bundeswehr",
      translated: "Bundeswehr",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:78|ar": [
    {
      german: "Was bedeutet",
      translated: "ماذا يعني",
      tone: 'semantic',
    },
    {
      german: "die Abkürzung",
      translated: "الاختصار",
      tone: 'semantic',
    },
    {
      german: "SPD",
      translated: "SPD",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:78|bg": [
    {
      german: "Was bedeutet",
      translated: "Какво означава",
      tone: 'semantic',
    },
    {
      german: "die Abkürzung",
      translated: "съкращението",
      tone: 'semantic',
    },
    {
      german: "SPD",
      translated: "SPD",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:78|bs": [
    {
      german: "Was bedeutet",
      translated: "Što znači",
      tone: 'semantic',
    },
    {
      german: "die Abkürzung",
      translated: "kratica",
      tone: 'semantic',
    },
    {
      german: "SPD",
      translated: "SPD",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:78|el": [
    {
      german: "Was bedeutet",
      translated: "Τι σημαίνει",
      tone: 'semantic',
    },
    {
      german: "die Abkürzung",
      translated: "η συντομογραφία",
      tone: 'semantic',
    },
    {
      german: "SPD",
      translated: "SPD",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:78|en": [
    {
      german: "Was bedeutet",
      translated: "What does",
      tone: 'semantic',
    },
    {
      german: "die Abkürzung",
      translated: "the abbreviation",
      tone: 'semantic',
    },
    {
      german: "SPD",
      translated: "SPD",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:78|es": [
    {
      german: "Was bedeutet",
      translated: "¿Qué significa",
      tone: 'semantic',
    },
    {
      german: "die Abkürzung",
      translated: "la abreviatura",
      tone: 'semantic',
    },
    {
      german: "SPD",
      translated: "SPD",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:78|fa": [
    {
      german: "Was bedeutet",
      translated: "به چه معناست",
      tone: 'semantic',
    },
    {
      german: "die Abkürzung",
      translated: "مخفف",
      tone: 'semantic',
    },
    {
      german: "SPD",
      translated: "SPD",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:78|fr": [
    {
      german: "Was bedeutet",
      translated: "Que signifie",
      tone: 'semantic',
    },
    {
      german: "die Abkürzung",
      translated: "l’abréviation",
      tone: 'semantic',
    },
    {
      german: "SPD",
      translated: "SPD",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:78|hr": [
    {
      german: "Was bedeutet",
      translated: "Što znači",
      tone: 'semantic',
    },
    {
      german: "die Abkürzung",
      translated: "kratica",
      tone: 'semantic',
    },
    {
      german: "SPD",
      translated: "SPD",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:78|it": [
    {
      german: "Was bedeutet",
      translated: "Che cosa significa",
      tone: 'semantic',
    },
    {
      german: "die Abkürzung",
      translated: "l’abbreviazione",
      tone: 'semantic',
    },
    {
      german: "SPD",
      translated: "SPD",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:78|kmr": [
    {
      german: "Was bedeutet",
      translated: "Kurteya",
      tone: 'semantic',
    },
    {
      german: "die Abkürzung",
      translated: "tê çi wateyê",
      tone: 'semantic',
    },
    {
      german: "SPD",
      translated: "SPD",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:78|pl": [
    {
      german: "Was bedeutet",
      translated: "Co oznacza",
      tone: 'semantic',
    },
    {
      german: "die Abkürzung",
      translated: "skrót",
      tone: 'semantic',
    },
    {
      german: "SPD",
      translated: "SPD",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:78|prs": [
    {
      german: "Was bedeutet",
      translated: "به چه معناست",
      tone: 'semantic',
    },
    {
      german: "die Abkürzung",
      translated: "مخفف",
      tone: 'semantic',
    },
    {
      german: "SPD",
      translated: "SPD",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:78|ro": [
    {
      german: "Was bedeutet",
      translated: "Ce înseamnă",
      tone: 'semantic',
    },
    {
      german: "die Abkürzung",
      translated: "abrevierea",
      tone: 'semantic',
    },
    {
      german: "SPD",
      translated: "SPD",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:78|ru": [
    {
      german: "Was bedeutet",
      translated: "Что означает",
      tone: 'semantic',
    },
    {
      german: "die Abkürzung",
      translated: "аббревиатура",
      tone: 'semantic',
    },
    {
      german: "SPD",
      translated: "SPD",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:78|sq": [
    {
      german: "Was bedeutet",
      translated: "Çfarë do të thotë",
      tone: 'semantic',
    },
    {
      german: "die Abkürzung",
      translated: "shkurtesa",
      tone: 'semantic',
    },
    {
      german: "SPD",
      translated: "SPD",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:78|sr": [
    {
      german: "Was bedeutet",
      translated: "Šta znači",
      tone: 'semantic',
    },
    {
      german: "die Abkürzung",
      translated: "kratica",
      tone: 'semantic',
    },
    {
      german: "SPD",
      translated: "SPD",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:78|tr": [
    {
      german: "Was bedeutet",
      translated: "ne anlama gelir",
      tone: 'semantic',
    },
    {
      german: "die Abkürzung",
      translated: "kısaltması",
      tone: 'semantic',
    },
    {
      german: "SPD",
      translated: "SPD",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:78|uk": [
    {
      german: "Was bedeutet",
      translated: "Що означає",
      tone: 'semantic',
    },
    {
      german: "die Abkürzung",
      translated: "абревіатура",
      tone: 'semantic',
    },
    {
      german: "SPD",
      translated: "SPD",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:78|vi": [
    {
      german: "Was bedeutet",
      translated: "có nghĩa là",
      tone: 'semantic',
    },
    {
      german: "die Abkürzung",
      translated: "Chữ viết tắt",
      tone: 'semantic',
    },
    {
      german: "SPD",
      translated: "SPD",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:79|ar": [
    {
      german: "Was bedeutet",
      translated: "ماذا يعني",
      tone: 'semantic',
    },
    {
      german: "die Abkürzung",
      translated: "الاختصار",
      tone: 'semantic',
    },
    {
      german: "FDP",
      translated: "FDP",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "في ألمانيا",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:79|bg": [
    {
      german: "Was bedeutet",
      translated: "Какво означава",
      tone: 'semantic',
    },
    {
      german: "die Abkürzung",
      translated: "съкращението",
      tone: 'semantic',
    },
    {
      german: "FDP",
      translated: "FDP",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "в Германия",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:79|bs": [
    {
      german: "Was bedeutet",
      translated: "Što",
      tone: 'semantic',
    },
    {
      german: "die Abkürzung",
      translated: "kratica",
      tone: 'semantic',
    },
    {
      german: "FDP",
      translated: "FDP",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "u Njemačkoj",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:79|el": [
    {
      german: "Was bedeutet",
      translated: "Τι σημαίνει",
      tone: 'semantic',
    },
    {
      german: "die Abkürzung",
      translated: "η συντομογραφία",
      tone: 'semantic',
    },
    {
      german: "FDP",
      translated: "FDP",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "στη Γερμανία",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:79|en": [
    {
      german: "Was bedeutet",
      translated: "What does",
      tone: 'semantic',
    },
    {
      german: "die Abkürzung",
      translated: "the abbreviation",
      tone: 'semantic',
    },
    {
      german: "FDP",
      translated: "FDP",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "in Germany",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:79|es": [
    {
      german: "Was bedeutet",
      translated: "¿Qué significa",
      tone: 'semantic',
    },
    {
      german: "die Abkürzung",
      translated: "la abreviatura",
      tone: 'semantic',
    },
    {
      german: "FDP",
      translated: "FDP",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "en Alemania",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:79|fa": [
    {
      german: "Was bedeutet",
      translated: "به چه معناست",
      tone: 'semantic',
    },
    {
      german: "die Abkürzung",
      translated: "مخفف",
      tone: 'semantic',
    },
    {
      german: "FDP",
      translated: "FDP",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "در آلمان",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:79|fr": [
    {
      german: "Was bedeutet",
      translated: "Que signifie",
      tone: 'semantic',
    },
    {
      german: "die Abkürzung",
      translated: "l’abréviation",
      tone: 'semantic',
    },
    {
      german: "FDP",
      translated: "FDP",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "en Allemagne",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:79|hr": [
    {
      german: "Was bedeutet",
      translated: "Što",
      tone: 'semantic',
    },
    {
      german: "die Abkürzung",
      translated: "kratica",
      tone: 'semantic',
    },
    {
      german: "FDP",
      translated: "FDP",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "u Njemačkoj",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:79|it": [
    {
      german: "Was bedeutet",
      translated: "Che cosa significa",
      tone: 'semantic',
    },
    {
      german: "die Abkürzung",
      translated: "l’abbreviazione",
      tone: 'semantic',
    },
    {
      german: "FDP",
      translated: "FDP",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "in Germania",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:79|kmr": [
    {
      german: "Was bedeutet",
      translated: "tê çi wateyê",
      tone: 'semantic',
    },
    {
      german: "die Abkürzung",
      translated: "Kurteya",
      tone: 'semantic',
    },
    {
      german: "FDP",
      translated: "FDP",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "li Almanyayê",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:79|pl": [
    {
      german: "Was bedeutet",
      translated: "Co oznacza",
      tone: 'semantic',
    },
    {
      german: "die Abkürzung",
      translated: "skrót",
      tone: 'semantic',
    },
    {
      german: "FDP",
      translated: "FDP",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "w Niemczech",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:79|prs": [
    {
      german: "Was bedeutet",
      translated: "به چه معناست",
      tone: 'semantic',
    },
    {
      german: "die Abkürzung",
      translated: "مخفف",
      tone: 'semantic',
    },
    {
      german: "FDP",
      translated: "FDP",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "در آلمان",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:79|ro": [
    {
      german: "Was bedeutet",
      translated: "Ce înseamnă",
      tone: 'semantic',
    },
    {
      german: "die Abkürzung",
      translated: "abrevierea",
      tone: 'semantic',
    },
    {
      german: "FDP",
      translated: "FDP",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "în Germania",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:79|ru": [
    {
      german: "Was bedeutet",
      translated: "Что означает",
      tone: 'semantic',
    },
    {
      german: "die Abkürzung",
      translated: "аббревиатура",
      tone: 'semantic',
    },
    {
      german: "FDP",
      translated: "FDP",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "в Германии",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:79|sq": [
    {
      german: "Was bedeutet",
      translated: "Çfarë do të thotë",
      tone: 'semantic',
    },
    {
      german: "die Abkürzung",
      translated: "shkurtesa",
      tone: 'semantic',
    },
    {
      german: "FDP",
      translated: "FDP",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "në Gjermani",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:79|sr": [
    {
      german: "Was bedeutet",
      translated: "znači",
      tone: 'semantic',
    },
    {
      german: "die Abkürzung",
      translated: "kratica",
      tone: 'semantic',
    },
    {
      german: "FDP",
      translated: "FDP",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "u Nemačkoj",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:79|tr": [
    {
      german: "Was bedeutet",
      translated: "ne anlama gelir",
      tone: 'semantic',
    },
    {
      german: "die Abkürzung",
      translated: "kısaltması",
      tone: 'semantic',
    },
    {
      german: "FDP",
      translated: "FDP",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "Almanya'da",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:79|uk": [
    {
      german: "Was bedeutet",
      translated: "Що означає",
      tone: 'semantic',
    },
    {
      german: "die Abkürzung",
      translated: "абревіатура",
      tone: 'semantic',
    },
    {
      german: "FDP",
      translated: "FDP",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "в Німеччині",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:79|vi": [
    {
      german: "Was bedeutet",
      translated: "có nghĩa là",
      tone: 'semantic',
    },
    {
      german: "die Abkürzung",
      translated: "Chữ viết tắt",
      tone: 'semantic',
    },
    {
      german: "FDP",
      translated: "FDP",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "ở Đức",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:7|ar": [
    {
      german: "Welches Recht",
      translated: "أي حق",
      tone: 'semantic',
    },
    {
      german: "gehört zu den Grundrechten",
      translated: "يُعد من الحقوق الأساسية",
      tone: 'semantic',
    },
    {
      german: "nach der deutschen Verfassung",
      translated: "التي يكفلها الدستور الألماني",
      tone: 'semantic',
    },
    {
      german: "garantiert werden",
      translated: "؟",
      tone: 'semantic',
    },
    {
      german: "Das Recht auf",
      translated: "الحق في",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:7|bg": [
    {
      german: "Welches Recht",
      translated: "Кое право",
      tone: 'semantic',
    },
    {
      german: "gehört zu den Grundrechten",
      translated: "е гарантирано като основно право",
      tone: 'semantic',
    },
    {
      german: "nach der deutschen Verfassung",
      translated: "от германската конституция",
      tone: 'semantic',
    },
    {
      german: "Das Recht auf",
      translated: "Правото на",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:7|bs": [
    {
      german: "Welches Recht",
      translated: "Koje je pravo",
      tone: 'semantic',
    },
    {
      german: "gehört zu den Grundrechten",
      translated: "kao temeljno pravo",
      tone: 'semantic',
    },
    {
      german: "nach der deutschen Verfassung",
      translated: "njemačkim ustavom",
      tone: 'semantic',
    },
    {
      german: "garantiert werden",
      translated: "zajamčeno",
      tone: 'semantic',
    },
    {
      german: "Das Recht auf",
      translated: "Pravo na",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:7|el": [
    {
      german: "Welches Recht",
      translated: "Ποιο δικαίωμα",
      tone: 'semantic',
    },
    {
      german: "gehört zu den Grundrechten",
      translated: "κατοχυρώνεται ως θεμελιώδες δικαίωμα",
      tone: 'semantic',
    },
    {
      german: "nach der deutschen Verfassung",
      translated: "από το γερμανικό Σύνταγμα",
      tone: 'semantic',
    },
    {
      german: "Das Recht auf",
      translated: "Το δικαίωμα στην",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:7|en": [
    {
      german: "Welches Recht",
      translated: "Which right",
      tone: 'semantic',
    },
    {
      german: "gehört zu den Grundrechten",
      translated: "among the fundamental rights",
      tone: 'semantic',
    },
    {
      german: "nach der deutschen Verfassung",
      translated: "by the German constitution",
      tone: 'semantic',
    },
    {
      german: "garantiert werden",
      translated: "guaranteed",
      tone: 'semantic',
    },
    {
      german: "Das Recht auf",
      translated: "The right to",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:7|es": [
    {
      german: "Welches Recht",
      translated: "¿Qué derecho",
      tone: 'semantic',
    },
    {
      german: "gehört zu den Grundrechten",
      translated: "pertenece a los derechos fundamentales",
      tone: 'semantic',
    },
    {
      german: "garantiert werden",
      translated: "garantizados por la Constitución alemana",
      tone: 'semantic',
    },
    {
      german: "Das Recht auf",
      translated: "El derecho a",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:7|fa": [
    {
      german: "Welches Recht",
      translated: "کدام حق",
      tone: 'semantic',
    },
    {
      german: "gehört zu den Grundrechten",
      translated: "به‌عنوان حق بنیادی",
      tone: 'semantic',
    },
    {
      german: "nach der deutschen Verfassung",
      translated: "در قانون اساسی آلمان",
      tone: 'semantic',
    },
    {
      german: "garantiert werden",
      translated: "تضمین شده است",
      tone: 'semantic',
    },
    {
      german: "Das Recht auf",
      translated: "حقِ …",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:7|fr": [
    {
      german: "Welches Recht",
      translated: "Quel droit",
      tone: 'semantic',
    },
    {
      german: "gehört zu den Grundrechten",
      translated: "fait partie des droits fondamentaux",
      tone: 'semantic',
    },
    {
      german: "nach der deutschen Verfassung",
      translated: "par la Constitution allemande",
      tone: 'semantic',
    },
    {
      german: "garantiert werden",
      translated: "garantis",
      tone: 'semantic',
    },
    {
      german: "Das Recht auf",
      translated: "Le droit à",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:7|hr": [
    {
      german: "Welches Recht",
      translated: "Koje je pravo",
      tone: 'semantic',
    },
    {
      german: "gehört zu den Grundrechten",
      translated: "kao temeljno pravo",
      tone: 'semantic',
    },
    {
      german: "nach der deutschen Verfassung",
      translated: "njemačkim ustavom",
      tone: 'semantic',
    },
    {
      german: "garantiert werden",
      translated: "zajamčeno",
      tone: 'semantic',
    },
    {
      german: "Das Recht auf",
      translated: "Pravo na …",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:7|it": [
    {
      german: "Welches Recht",
      translated: "Quale diritto",
      tone: 'semantic',
    },
    {
      german: "gehört zu den Grundrechten",
      translated: "come diritto fondamentale",
      tone: 'semantic',
    },
    {
      german: "nach der deutschen Verfassung",
      translated: "dalla Costituzione tedesca",
      tone: 'semantic',
    },
    {
      german: "garantiert werden",
      translated: "garantito",
      tone: 'semantic',
    },
    {
      german: "Das Recht auf",
      translated: "Il diritto alla",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:7|kmr": [
    {
      german: "Welches Recht",
      translated: "Kîjan maf",
      tone: 'semantic',
    },
    {
      german: "gehört zu den Grundrechten",
      translated: "ji mafên bingehîn e",
      tone: 'semantic',
    },
    {
      german: "nach der deutschen Verfassung",
      translated: "destûra Almanyayê",
      tone: 'semantic',
    },
    {
      german: "garantiert werden",
      translated: "garantî dike",
      tone: 'semantic',
    },
    {
      german: "Das Recht auf",
      translated: "Mafê",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:7|pl": [
    {
      german: "Welches Recht",
      translated: "Które prawo",
      tone: 'semantic',
    },
    {
      german: "gehört zu den Grundrechten",
      translated: "jako prawo podstawowe",
      tone: 'semantic',
    },
    {
      german: "nach der deutschen Verfassung",
      translated: "przez niemiecką konstytucję",
      tone: 'semantic',
    },
    {
      german: "garantiert werden",
      translated: "jest gwarantowane",
      tone: 'semantic',
    },
    {
      german: "Das Recht auf",
      translated: "Prawo do",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:7|prs": [
    {
      german: "Welches Recht",
      translated: "کدام حق",
      tone: 'semantic',
    },
    {
      german: "gehört zu den Grundrechten",
      translated: "در قانون اساسی آلمان",
      tone: 'semantic',
    },
    {
      german: "nach der deutschen Verfassung",
      translated: "به‌عنوان حق بنیادی",
      tone: 'semantic',
    },
    {
      german: "garantiert werden",
      translated: "تضمین شده است",
      tone: 'semantic',
    },
    {
      german: "Das Recht auf",
      translated: "؟ حقِ …",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:7|ro": [
    {
      german: "Welches Recht",
      translated: "Care drept",
      tone: 'semantic',
    },
    {
      german: "gehört zu den Grundrechten",
      translated: "garantat ca drept fundamental",
      tone: 'semantic',
    },
    {
      german: "nach der deutschen Verfassung",
      translated: "de constituția germană",
      tone: 'semantic',
    },
    {
      german: "Das Recht auf",
      translated: "Dreptul la",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:7|ru": [
    {
      german: "Welches Recht",
      translated: "Какое право",
      tone: 'semantic',
    },
    {
      german: "gehört zu den Grundrechten",
      translated: "относится к основным правам",
      tone: 'semantic',
    },
    {
      german: "nach der deutschen Verfassung",
      translated: "конституцией Германии",
      tone: 'semantic',
    },
    {
      german: "garantiert werden",
      translated: "гарантированным",
      tone: 'semantic',
    },
    {
      german: "Das Recht auf",
      translated: "Право на",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:7|sq": [
    {
      german: "Welches Recht",
      translated: "Cila e drejtë",
      tone: 'semantic',
    },
    {
      german: "gehört zu den Grundrechten",
      translated: "si e drejtë themelore",
      tone: 'semantic',
    },
    {
      german: "nach der deutschen Verfassung",
      translated: "nga Kushtetuta gjermane",
      tone: 'semantic',
    },
    {
      german: "garantiert werden",
      translated: "garantohet",
      tone: 'semantic',
    },
    {
      german: "Das Recht auf",
      translated: "E drejta për",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:7|sr": [
    {
      german: "Welches Recht",
      translated: "Koje je pravo",
      tone: 'semantic',
    },
    {
      german: "gehört zu den Grundrechten",
      translated: "kao osnovno pravo",
      tone: 'semantic',
    },
    {
      german: "nach der deutschen Verfassung",
      translated: "nemačkim ustavom",
      tone: 'semantic',
    },
    {
      german: "garantiert werden",
      translated: "zajamčeno",
      tone: 'semantic',
    },
    {
      german: "Das Recht auf",
      translated: "Pravo na",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:7|tr": [
    {
      german: "Welches Recht",
      translated: "hangisidir",
      tone: 'semantic',
    },
    {
      german: "gehört zu den Grundrechten",
      translated: "temel haklardan biri",
      tone: 'semantic',
    },
    {
      german: "nach der deutschen Verfassung",
      translated: "Alman Anayasası'nın",
      tone: 'semantic',
    },
    {
      german: "garantiert werden",
      translated: "güvence altına aldığı",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:7|uk": [
    {
      german: "Welches Recht",
      translated: "Яке з наведених прав",
      tone: 'semantic',
    },
    {
      german: "gehört zu den Grundrechten",
      translated: "є основним правом",
      tone: 'semantic',
    },
    {
      german: "nach der deutschen Verfassung",
      translated: "Конституцією Німеччини",
      tone: 'semantic',
    },
    {
      german: "garantiert werden",
      translated: "гарантованим",
      tone: 'semantic',
    },
    {
      german: "Das Recht auf",
      translated: "Право на …",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:7|vi": [
    {
      german: "Welches Recht",
      translated: "Quyền nào",
      tone: 'semantic',
    },
    {
      german: "gehört zu den Grundrechten",
      translated: "là quyền cơ bản",
      tone: 'semantic',
    },
    {
      german: "nach der deutschen Verfassung",
      translated: "Hiến pháp Đức",
      tone: 'semantic',
    },
    {
      german: "garantiert werden",
      translated: "bảo đảm",
      tone: 'semantic',
    },
    {
      german: "Das Recht auf",
      translated: "Quyền …",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:80|ar": [
    {
      german: "Welches Gericht",
      translated: "أي محكمة",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "في ألمانيا",
      tone: 'semantic',
    },
    {
      german: "ist zuständig",
      translated: "مسؤولة",
      tone: 'semantic',
    },
    {
      german: "die Auslegung",
      translated: "عن تفسير",
      tone: 'semantic',
    },
    {
      german: "des Grundgesetzes",
      translated: "القانون الأساسي",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:80|bg": [
    {
      german: "Welches Gericht",
      translated: "Кой съд",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "германския",
      tone: 'semantic',
    },
    {
      german: "ist zuständig",
      translated: "отговаря за",
      tone: 'semantic',
    },
    {
      german: "die Auslegung",
      translated: "тълкуването",
      tone: 'semantic',
    },
    {
      german: "des Grundgesetzes",
      translated: "Основен закон",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:80|bs": [
    {
      german: "Welches Gericht",
      translated: "Koji je sud",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "njemačkog",
      tone: 'semantic',
    },
    {
      german: "ist zuständig",
      translated: "nadležan",
      tone: 'semantic',
    },
    {
      german: "für",
      translated: "za",
      tone: 'semantic',
    },
    {
      german: "die Auslegung",
      translated: "tumačenje",
      tone: 'semantic',
    },
    {
      german: "des Grundgesetzes",
      translated: "Temeljnog zakona",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:80|el": [
    {
      german: "Welches Gericht",
      translated: "Ποιο δικαστήριο",
      tone: 'semantic',
    },
    {
      german: "ist zuständig",
      translated: "είναι αρμόδιο",
      tone: 'semantic',
    },
    {
      german: "für",
      translated: "για",
      tone: 'semantic',
    },
    {
      german: "die Auslegung",
      translated: "την ερμηνεία",
      tone: 'semantic',
    },
    {
      german: "des Grundgesetzes",
      translated: "του γερμανικού Θεμελιώδους Νόμου",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:80|en": [
    {
      german: "Welches Gericht",
      translated: "Which court",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "in Germany",
      tone: 'semantic',
    },
    {
      german: "ist zuständig",
      translated: "is responsible",
      tone: 'semantic',
    },
    {
      german: "für",
      translated: "for",
      tone: 'semantic',
    },
    {
      german: "die Auslegung",
      translated: "interpreting",
      tone: 'semantic',
    },
    {
      german: "des Grundgesetzes",
      translated: "the Basic Law",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:80|es": [
    {
      german: "Welches Gericht",
      translated: "¿Qué tribunal",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "de Alemania",
      tone: 'semantic',
    },
    {
      german: "ist zuständig",
      translated: "es responsable de",
      tone: 'semantic',
    },
    {
      german: "die Auslegung",
      translated: "interpretar",
      tone: 'semantic',
    },
    {
      german: "des Grundgesetzes",
      translated: "la Ley Fundamental",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:80|fa": [
    {
      german: "Welches Gericht",
      translated: "کدام دادگاه",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "آلمان",
      tone: 'semantic',
    },
    {
      german: "ist zuständig",
      translated: "مسئول",
      tone: 'semantic',
    },
    {
      german: "die Auslegung",
      translated: "تفسیر",
      tone: 'semantic',
    },
    {
      german: "des Grundgesetzes",
      translated: "قانون اساسی",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:80|fr": [
    {
      german: "Welches Gericht",
      translated: "Quel tribunal",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "en Allemagne",
      tone: 'semantic',
    },
    {
      german: "ist zuständig",
      translated: "est chargé",
      tone: 'semantic',
    },
    {
      german: "die Auslegung",
      translated: "d’interpréter",
      tone: 'semantic',
    },
    {
      german: "des Grundgesetzes",
      translated: "la Loi fondamentale",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:80|hr": [
    {
      german: "Welches Gericht",
      translated: "Koji je sud",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "njemačkog",
      tone: 'semantic',
    },
    {
      german: "ist zuständig",
      translated: "nadležan",
      tone: 'semantic',
    },
    {
      german: "für",
      translated: "za",
      tone: 'semantic',
    },
    {
      german: "die Auslegung",
      translated: "tumačenje",
      tone: 'semantic',
    },
    {
      german: "des Grundgesetzes",
      translated: "Temeljnog zakona",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:80|it": [
    {
      german: "Welches Gericht",
      translated: "Quale tribunale",
      tone: 'semantic',
    },
    {
      german: "ist zuständig",
      translated: "è competente",
      tone: 'semantic',
    },
    {
      german: "für",
      translated: "per",
      tone: 'semantic',
    },
    {
      german: "die Auslegung",
      translated: "interpretare",
      tone: 'semantic',
    },
    {
      german: "des Grundgesetzes",
      translated: "la Legge fondamentale tedesca",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:80|kmr": [
    {
      german: "Welches Gericht",
      translated: "Kîjan dadgeh",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "li Almanyayê",
      tone: 'semantic',
    },
    {
      german: "ist zuständig",
      translated: "berpirsiyar e",
      tone: 'semantic',
    },
    {
      german: "für",
      translated: "ji bo",
      tone: 'semantic',
    },
    {
      german: "die Auslegung",
      translated: "şîrovekirina",
      tone: 'semantic',
    },
    {
      german: "des Grundgesetzes",
      translated: "Qanûna Bingehîn",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:80|pl": [
    {
      german: "Welches Gericht",
      translated: "Który sąd",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "w Niemczech",
      tone: 'semantic',
    },
    {
      german: "ist zuständig",
      translated: "jest właściwy",
      tone: 'semantic',
    },
    {
      german: "für",
      translated: "do",
      tone: 'semantic',
    },
    {
      german: "die Auslegung",
      translated: "interpretowania",
      tone: 'semantic',
    },
    {
      german: "des Grundgesetzes",
      translated: "Ustawy Zasadniczej",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:80|prs": [
    {
      german: "Welches Gericht",
      translated: "کدام محکمه",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "آلمان",
      tone: 'semantic',
    },
    {
      german: "ist zuständig",
      translated: "مسئول",
      tone: 'semantic',
    },
    {
      german: "für",
      translated: "تفسیر",
      tone: 'semantic',
    },
    {
      german: "des Grundgesetzes",
      translated: "قانون اساسی",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:80|ro": [
    {
      german: "Welches Gericht",
      translated: "Care instanță",
      tone: 'semantic',
    },
    {
      german: "ist zuständig",
      translated: "este competentă",
      tone: 'semantic',
    },
    {
      german: "für",
      translated: "pentru",
      tone: 'semantic',
    },
    {
      german: "die Auslegung",
      translated: "interpretarea",
      tone: 'semantic',
    },
    {
      german: "des Grundgesetzes",
      translated: "Legii fundamentale germane",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:80|ru": [
    {
      german: "Welches Gericht",
      translated: "Какой суд",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "в Германии",
      tone: 'semantic',
    },
    {
      german: "ist zuständig",
      translated: "отвечает",
      tone: 'semantic',
    },
    {
      german: "für",
      translated: "за",
      tone: 'semantic',
    },
    {
      german: "die Auslegung",
      translated: "толкование",
      tone: 'semantic',
    },
    {
      german: "des Grundgesetzes",
      translated: "Основного закона",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:80|sq": [
    {
      german: "Welches Gericht",
      translated: "Cila gjykatë",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "është",
      tone: 'semantic',
    },
    {
      german: "ist zuständig",
      translated: "përgjegjëse",
      tone: 'semantic',
    },
    {
      german: "für",
      translated: "për",
      tone: 'semantic',
    },
    {
      german: "die Auslegung",
      translated: "interpretimin",
      tone: 'semantic',
    },
    {
      german: "des Grundgesetzes",
      translated: "e Ligjit Themelor gjerman",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:80|sr": [
    {
      german: "Welches Gericht",
      translated: "Koji je sud",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "nemačkog",
      tone: 'semantic',
    },
    {
      german: "ist zuständig",
      translated: "nadležan",
      tone: 'semantic',
    },
    {
      german: "für",
      translated: "za",
      tone: 'semantic',
    },
    {
      german: "die Auslegung",
      translated: "tumačenje",
      tone: 'semantic',
    },
    {
      german: "des Grundgesetzes",
      translated: "Osnovnog zakona",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:80|tr": [
    {
      german: "Welches Gericht",
      translated: "hangi mahkeme",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "Almanya'da",
      tone: 'semantic',
    },
    {
      german: "ist zuständig",
      translated: "sorumludur",
      tone: 'semantic',
    },
    {
      german: "die Auslegung",
      translated: "yorumlanmasından",
      tone: 'semantic',
    },
    {
      german: "des Grundgesetzes",
      translated: "Anayasa'nın (Grundgesetz)",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:80|uk": [
    {
      german: "Welches Gericht",
      translated: "Який суд",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "у Німеччині",
      tone: 'semantic',
    },
    {
      german: "ist zuständig",
      translated: "відповідає за",
      tone: 'semantic',
    },
    {
      german: "die Auslegung",
      translated: "тлумачення",
      tone: 'semantic',
    },
    {
      german: "des Grundgesetzes",
      translated: "Основного закону",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:80|vi": [
    {
      german: "Welches Gericht",
      translated: "Tòa án",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "Đức",
      tone: 'semantic',
    },
    {
      german: "ist zuständig",
      translated: "chịu trách nhiệm",
      tone: 'semantic',
    },
    {
      german: "für",
      translated: "giải thích",
      tone: 'semantic',
    },
    {
      german: "die Auslegung",
      translated: "Luật Cơ bản",
      tone: 'semantic',
    },
    {
      german: "des Grundgesetzes",
      translated: "của",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:81|ar": [
    {
      german: "Wer",
      translated: "من",
      tone: 'semantic',
    },
    {
      german: "wählt",
      translated: "ينتخب",
      tone: 'semantic',
    },
    {
      german: "die Bundeskanzlerin",
      translated: "المستشار",
      tone: 'semantic',
    },
    {
      german: "den Bundeskanzler",
      translated: "الاتحادي",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "في ألمانيا",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:81|bg": [
    {
      german: "Wer",
      translated: "Кой",
      tone: 'semantic',
    },
    {
      german: "wählt",
      translated: "избира",
      tone: 'semantic',
    },
    {
      german: "die Bundeskanzlerin",
      translated: "федералния канцлер",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "в Германия",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:81|bs": [
    {
      german: "Wer",
      translated: "Tko",
      tone: 'semantic',
    },
    {
      german: "wählt",
      translated: "bira",
      tone: 'semantic',
    },
    {
      german: "die Bundeskanzlerin",
      translated: "saveznog kancelara",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "u Njemačkoj",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:81|el": [
    {
      german: "Wer",
      translated: "Ποιος",
      tone: 'semantic',
    },
    {
      german: "wählt",
      translated: "εκλέγει",
      tone: 'semantic',
    },
    {
      german: "die Bundeskanzlerin",
      translated: "τον ομοσπονδιακό καγκελάριο",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "στη Γερμανία",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:81|en": [
    {
      german: "Wer",
      translated: "Who",
      tone: 'semantic',
    },
    {
      german: "wählt",
      translated: "elects",
      tone: 'semantic',
    },
    {
      german: "den Bundeskanzler",
      translated: "the Federal Chancellor",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "in Germany",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:81|es": [
    {
      german: "Wer",
      translated: "Quién",
      tone: 'semantic',
    },
    {
      german: "wählt",
      translated: "elige",
      tone: 'semantic',
    },
    {
      german: "den Bundeskanzler",
      translated: "al Canciller Federal",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "en Alemania?",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:81|fa": [
    {
      german: "Wer",
      translated: "چه کسی",
      tone: 'semantic',
    },
    {
      german: "wählt",
      translated: "انتخاب",
      tone: 'semantic',
    },
    {
      german: "die Bundeskanzlerin",
      translated: "صدراعظم فدرال",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "در آلمان",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:81|fr": [
    {
      german: "Wer",
      translated: "Qui",
      tone: 'semantic',
    },
    {
      german: "wählt",
      translated: "élit",
      tone: 'semantic',
    },
    {
      german: "die Bundeskanzlerin",
      translated: "le chancelier",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "en Allemagne",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:81|hr": [
    {
      german: "Wer",
      translated: "Tko",
      tone: 'semantic',
    },
    {
      german: "wählt",
      translated: "bira",
      tone: 'semantic',
    },
    {
      german: "den Bundeskanzler",
      translated: "saveznog kancelara",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "u Njemačkoj",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:81|it": [
    {
      german: "Wer",
      translated: "Chi",
      tone: 'semantic',
    },
    {
      german: "wählt",
      translated: "elegge",
      tone: 'semantic',
    },
    {
      german: "den Bundeskanzler",
      translated: "il cancelliere federale",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "in Germania",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:81|kmr": [
    {
      german: "Wer",
      translated: "kî",
      tone: 'semantic',
    },
    {
      german: "wählt",
      translated: "hildibijêre",
      tone: 'semantic',
    },
    {
      german: "die Bundeskanzlerin",
      translated: "kanselerê federal",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "Almanyayê",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:81|pl": [
    {
      german: "Wer",
      translated: "Kto",
      tone: 'semantic',
    },
    {
      german: "wählt",
      translated: "wybiera",
      tone: 'semantic',
    },
    {
      german: "die Bundeskanzlerin",
      translated: "kanclerza federalnego",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "w Niemczech",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:81|prs": [
    {
      german: "Wer",
      translated: "چه کسی",
      tone: 'semantic',
    },
    {
      german: "wählt",
      translated: "انتخاب می‌کند",
      tone: 'semantic',
    },
    {
      german: "die Bundeskanzlerin",
      translated: "صدراعظم فدرال",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "در آلمان",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:81|ro": [
    {
      german: "Wer",
      translated: "Cine",
      tone: 'semantic',
    },
    {
      german: "wählt",
      translated: "îl alege",
      tone: 'semantic',
    },
    {
      german: "den Bundeskanzler",
      translated: "cancelarul federal",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "în Germania",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:81|ru": [
    {
      german: "Wer",
      translated: "Кто",
      tone: 'semantic',
    },
    {
      german: "wählt",
      translated: "избирает",
      tone: 'semantic',
    },
    {
      german: "die Bundeskanzlerin",
      translated: "федерального канцлера",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "Германии",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:81|sq": [
    {
      german: "Wer",
      translated: "Kush",
      tone: 'semantic',
    },
    {
      german: "wählt",
      translated: "zgjedh",
      tone: 'semantic',
    },
    {
      german: "die Bundeskanzlerin",
      translated: "kancelarin",
      tone: 'semantic',
    },
    {
      german: "den Bundeskanzler",
      translated: "federal",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "në Gjermani",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:81|sr": [
    {
      german: "Wer",
      translated: "Ko",
      tone: 'semantic',
    },
    {
      german: "wählt",
      translated: "bira",
      tone: 'semantic',
    },
    {
      german: "die Bundeskanzlerin",
      translated: "saveznog kancelara",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "u Nemačkoj",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:81|tr": [
    {
      german: "Wer",
      translated: "kim",
      tone: 'semantic',
    },
    {
      german: "wählt",
      translated: "seçer",
      tone: 'semantic',
    },
    {
      german: "die Bundeskanzlerin",
      translated: "Federal Başbakanı",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "Almanya'da",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:81|uk": [
    {
      german: "Wer",
      translated: "Хто",
      tone: 'semantic',
    },
    {
      german: "wählt",
      translated: "обирає",
      tone: 'semantic',
    },
    {
      german: "die Bundeskanzlerin",
      translated: "федерального канцлера",
      tone: 'semantic',
    },
    {
      german: "den Bundeskanzler",
      translated: "Німеччини",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:81|vi": [
    {
      german: "Wer",
      translated: "Ai",
      tone: 'semantic',
    },
    {
      german: "wählt",
      translated: "bầu",
      tone: 'semantic',
    },
    {
      german: "die Bundeskanzlerin",
      translated: "Thủ tướng",
      tone: 'semantic',
    },
    {
      german: "den Bundeskanzler",
      translated: "Liên bang",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "ở Đức",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:82|ar": [
    {
      german: "Wer leitet",
      translated: "من",
      tone: 'semantic',
    },
    {
      german: "das deutsche Bundeskabinett",
      translated: "يرأس مجلس الوزراء الاتحادي الألماني؟",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:82|bg": [
    {
      german: "Wer leitet",
      translated: "Кой ръководи",
      tone: 'semantic',
    },
    {
      german: "das deutsche Bundeskabinett",
      translated: "германския федерален кабинет?",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:82|bs": [
    {
      german: "Wer leitet",
      translated: "Tko vodi",
      tone: 'semantic',
    },
    {
      german: "das deutsche Bundeskabinett",
      translated: "njemački savezni kabinet",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:82|el": [
    {
      german: "Wer leitet",
      translated: "Ποιος ηγείται",
      tone: 'semantic',
    },
    {
      german: "das deutsche Bundeskabinett",
      translated: "του γερμανικού ομοσπονδιακού υπουργικού συμβουλίου",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:82|en": [
    {
      german: "Wer leitet",
      translated: "heads",
      tone: 'semantic',
    },
    {
      german: "das deutsche Bundeskabinett",
      translated: "the German federal cabinet",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:82|es": [
    {
      german: "Wer leitet",
      translated: "¿Quién dirige",
      tone: 'semantic',
    },
    {
      german: "das deutsche Bundeskabinett",
      translated: "el Gabinete Federal alemán",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:82|fa": [
    {
      german: "Wer leitet",
      translated: "چه کسی",
      tone: 'semantic',
    },
    {
      german: "das deutsche Bundeskabinett",
      translated: "کابینهٔ فدرال آلمان",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:82|fr": [
    {
      german: "Wer leitet",
      translated: "Qui dirige",
      tone: 'semantic',
    },
    {
      german: "das deutsche Bundeskabinett",
      translated: "le cabinet fédéral allemand ?",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:82|hr": [
    {
      german: "Wer leitet",
      translated: "Tko vodi",
      tone: 'semantic',
    },
    {
      german: "das deutsche Bundeskabinett",
      translated: "njemački savezni kabinet",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:82|it": [
    {
      german: "Wer leitet",
      translated: "Chi dirige",
      tone: 'semantic',
    },
    {
      german: "das deutsche Bundeskabinett",
      translated: "il gabinetto federale tedesco",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:82|kmr": [
    {
      german: "Wer leitet",
      translated: "kî rêve dibe",
      tone: 'semantic',
    },
    {
      german: "das deutsche Bundeskabinett",
      translated: "Kabîneya Federal a Alman",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:82|pl": [
    {
      german: "Wer leitet",
      translated: "Kto kieruje",
      tone: 'semantic',
    },
    {
      german: "das deutsche Bundeskabinett",
      translated: "niemieckim gabinetem federalnym",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:82|prs": [
    {
      german: "Wer leitet",
      translated: "چه کسی",
      tone: 'semantic',
    },
    {
      german: "das deutsche Bundeskabinett",
      translated: "کابینهٔ فدرال آلمان",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:82|ro": [
    {
      german: "Wer leitet",
      translated: "Cine conduce",
      tone: 'semantic',
    },
    {
      german: "das deutsche Bundeskabinett",
      translated: "cabinetul federal german",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:82|ru": [
    {
      german: "Wer leitet",
      translated: "Кто возглавляет",
      tone: 'semantic',
    },
    {
      german: "das deutsche Bundeskabinett",
      translated: "федеральный кабинет министров Германии",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:82|sq": [
    {
      german: "Wer leitet",
      translated: "Kush e drejton",
      tone: 'semantic',
    },
    {
      german: "das deutsche Bundeskabinett",
      translated: "kabinetin federal gjerman?",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:82|sr": [
    {
      german: "Wer leitet",
      translated: "Ko",
      tone: 'semantic',
    },
    {
      german: "das deutsche Bundeskabinett",
      translated: "nemački savezni kabinet",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:82|tr": [
    {
      german: "Wer leitet",
      translated: "kim başkanlık eder",
      tone: 'semantic',
    },
    {
      german: "das deutsche Bundeskabinett",
      translated: "Alman federal kabinesine",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:82|uk": [
    {
      german: "Wer leitet",
      translated: "Хто",
      tone: 'semantic',
    },
    {
      german: "das deutsche Bundeskabinett",
      translated: "федеральний кабінет міністрів Німеччини",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:82|vi": [
    {
      german: "Wer leitet",
      translated: "Ai lãnh đạo",
      tone: 'semantic',
    },
    {
      german: "das deutsche Bundeskabinett",
      translated: "nội các liên bang Đức",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:83|ar": [
    {
      german: "Wer",
      translated: "من",
      tone: 'semantic',
    },
    {
      german: "wählt",
      translated: "ينتخب",
      tone: 'semantic',
    },
    {
      german: "die deutsche Bundeskanzlerin",
      translated: "المستشار الاتحادي الألماني",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:83|bg": [
    {
      german: "Wer",
      translated: "Кой",
      tone: 'semantic',
    },
    {
      german: "wählt",
      translated: "избира",
      tone: 'semantic',
    },
    {
      german: "die deutsche Bundeskanzlerin",
      translated: "германския федерален канцлер",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:83|bs": [
    {
      german: "Wer",
      translated: "Tko",
      tone: 'semantic',
    },
    {
      german: "wählt",
      translated: "bira",
      tone: 'semantic',
    },
    {
      german: "die deutsche Bundeskanzlerin",
      translated: "njemačkog saveznog kancelara",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:83|el": [
    {
      german: "Wer",
      translated: "Ποιος",
      tone: 'semantic',
    },
    {
      german: "wählt",
      translated: "εκλέγει",
      tone: 'semantic',
    },
    {
      german: "die deutsche Bundeskanzlerin",
      translated: "τον Γερμανό ομοσπονδιακό καγκελάριο",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:83|en": [
    {
      german: "Wer",
      translated: "Who",
      tone: 'semantic',
    },
    {
      german: "wählt",
      translated: "elects",
      tone: 'semantic',
    },
    {
      german: "den deutschen Bundeskanzler",
      translated: "the German Federal Chancellor",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:83|es": [
    {
      german: "Wer",
      translated: "¿Quién",
      tone: 'semantic',
    },
    {
      german: "wählt",
      translated: "elige",
      tone: 'semantic',
    },
    {
      german: "den deutschen Bundeskanzler",
      translated: "al Canciller Federal alemán",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:83|fa": [
    {
      german: "Wer",
      translated: "چه کسی",
      tone: 'semantic',
    },
    {
      german: "wählt",
      translated: "انتخاب می‌کند",
      tone: 'semantic',
    },
    {
      german: "die deutsche Bundeskanzlerin",
      translated: "صدراعظم فدرال آلمان",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:83|fr": [
    {
      german: "Wer",
      translated: "Qui",
      tone: 'semantic',
    },
    {
      german: "wählt",
      translated: "élit",
      tone: 'semantic',
    },
    {
      german: "die deutsche Bundeskanzlerin",
      translated: "le chancelier fédéral allemand",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:83|hr": [
    {
      german: "Wer",
      translated: "Tko",
      tone: 'semantic',
    },
    {
      german: "wählt",
      translated: "bira",
      tone: 'semantic',
    },
    {
      german: "den deutschen Bundeskanzler",
      translated: "njemačkog saveznog kancelara",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:83|it": [
    {
      german: "Wer",
      translated: "Chi",
      tone: 'semantic',
    },
    {
      german: "wählt",
      translated: "elegge",
      tone: 'semantic',
    },
    {
      german: "die deutsche Bundeskanzlerin",
      translated: "il cancelliere federale tedesco",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:83|kmr": [
    {
      german: "Wer",
      translated: "kî",
      tone: 'semantic',
    },
    {
      german: "wählt",
      translated: "hildibijêre",
      tone: 'semantic',
    },
    {
      german: "die deutsche Bundeskanzlerin",
      translated: "Kanselerê",
      tone: 'semantic',
    },
    {
      german: "den deutschen Bundeskanzler",
      translated: "Federal a Alman",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:83|pl": [
    {
      german: "Wer",
      translated: "Kto",
      tone: 'semantic',
    },
    {
      german: "wählt",
      translated: "wybiera",
      tone: 'semantic',
    },
    {
      german: "die deutsche Bundeskanzlerin",
      translated: "niemieckiego kanclerza federalnego",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:83|prs": [
    {
      german: "Wer",
      translated: "چه کسی",
      tone: 'semantic',
    },
    {
      german: "wählt",
      translated: "انتخاب می‌کند",
      tone: 'semantic',
    },
    {
      german: "die deutsche Bundeskanzlerin",
      translated: "صدراعظم فدرال آلمان",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:83|ro": [
    {
      german: "Wer",
      translated: "Cine",
      tone: 'semantic',
    },
    {
      german: "wählt",
      translated: "îl alege",
      tone: 'semantic',
    },
    {
      german: "den deutschen Bundeskanzler",
      translated: "cancelarul federal german",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:83|ru": [
    {
      german: "Wer",
      translated: "Кто",
      tone: 'semantic',
    },
    {
      german: "wählt",
      translated: "избирает",
      tone: 'semantic',
    },
    {
      german: "die deutsche Bundeskanzlerin",
      translated: "федерального канцлера Германии",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:83|sq": [
    {
      german: "Wer",
      translated: "Kush",
      tone: 'semantic',
    },
    {
      german: "wählt",
      translated: "zgjedh",
      tone: 'semantic',
    },
    {
      german: "die deutsche Bundeskanzlerin",
      translated: "kancelarin federal gjerman",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:83|sr": [
    {
      german: "Wer",
      translated: "Ko",
      tone: 'semantic',
    },
    {
      german: "wählt",
      translated: "bira",
      tone: 'semantic',
    },
    {
      german: "die deutsche Bundeskanzlerin",
      translated: "nemačkog saveznog kancelara",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:83|tr": [
    {
      german: "Wer",
      translated: "kim",
      tone: 'semantic',
    },
    {
      german: "wählt",
      translated: "seçer",
      tone: 'semantic',
    },
    {
      german: "die deutsche Bundeskanzlerin",
      translated: "Alman Federal Başbakanını",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:83|uk": [
    {
      german: "Wer",
      translated: "Хто",
      tone: 'semantic',
    },
    {
      german: "wählt",
      translated: "обирає",
      tone: 'semantic',
    },
    {
      german: "den deutschen Bundeskanzler",
      translated: "федерального канцлера Німеччини",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:83|vi": [
    {
      german: "Wer",
      translated: "Ai",
      tone: 'semantic',
    },
    {
      german: "wählt",
      translated: "bầu",
      tone: 'semantic',
    },
    {
      german: "die deutsche Bundeskanzlerin",
      translated: "Thủ tướng Liên bang Đức",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:84|ar": [
    {
      german: "Welche Hauptaufgabe hat die deutsche Bundespräsidentin/der deutsche Bundespräsident?",
      translated: "ما المهمة الرئيسية لرئيس جمهورية ألمانيا الاتحادية؟",
      tone: 'semantic',
    },
    {
      german: "Sie/Er",
      translated: "هو/هي …",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:84|bg": [
    {
      german: "Welche Hauptaufgabe hat die deutsche Bundespräsidentin/der deutsche Bundespräsident?",
      translated: "Коя е основната задача на федералния президент на Германия?",
      tone: 'semantic',
    },
    {
      german: "Sie/Er",
      translated: "Той …",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:84|bs": [
    {
      german: "Welche Hauptaufgabe hat die deutsche Bundespräsidentin/der deutsche Bundespräsident?",
      translated: "Koja je glavna zadaća njemačkog saveznog predsjednika?",
      tone: 'semantic',
    },
    {
      german: "Sie/Er",
      translated: "On",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:84|el": [
    {
      german: "Welche Hauptaufgabe hat die deutsche Bundespräsidentin/der deutsche Bundespräsident?",
      translated: "Ποιο είναι το κύριο καθήκον του Ομοσπονδιακού Προέδρου της Γερμανίας;",
      tone: 'semantic',
    },
    {
      german: "Sie/Er",
      translated: "Αυτός",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:84|en": [
    {
      german: "Welche Hauptaufgabe hat die deutsche Bundespräsidentin/der deutsche Bundespräsident?",
      translated: "What is the main task of the German Federal President?",
      tone: 'semantic',
    },
    {
      german: "Sie/Er",
      translated: "He/She",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:84|es": [
    {
      german: "Welche Hauptaufgabe hat die deutsche Bundespräsidentin/der deutsche Bundespräsident?",
      translated: "¿Cuál es la principal función del Presidente Federal alemán?",
      tone: 'semantic',
    },
    {
      german: "Sie/Er",
      translated: "Él o ella",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:84|fa": [
    {
      german: "Welche Hauptaufgabe hat die deutsche Bundespräsidentin/der deutsche Bundespräsident?",
      translated: "وظیفهٔ اصلی رئیس‌جمهور فدرال آلمان چیست؟",
      tone: 'semantic',
    },
    {
      german: "Sie/Er",
      translated: "او",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:84|fr": [
    {
      german: "Welche Hauptaufgabe hat die deutsche Bundespräsidentin/der deutsche Bundespräsident?",
      translated: "Quelle est la tâche principale du président fédéral allemand ?",
      tone: 'semantic',
    },
    {
      german: "Sie/Er",
      translated: "Il ou elle",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:84|hr": [
    {
      german: "Welche Hauptaufgabe hat die deutsche Bundespräsidentin/der deutsche Bundespräsident?",
      translated: "Koja je glavna zadaća njemačkog saveznog predsjednika?",
      tone: 'semantic',
    },
    {
      german: "Sie/Er",
      translated: "On …",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:84|it": [
    {
      german: "Welche Hauptaufgabe hat die deutsche Bundespräsidentin/der deutsche Bundespräsident?",
      translated: "Qual è il compito principale del Presidente federale tedesco?",
      tone: 'semantic',
    },
    {
      german: "Sie/Er",
      translated: "Egli",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:84|kmr": [
    {
      german: "Welche Hauptaufgabe hat die deutsche Bundespräsidentin/der deutsche Bundespräsident?",
      translated: "Erka sereke ya Serokê Federal a Alman çi ye?",
      tone: 'semantic',
    },
    {
      german: "Sie/Er",
      translated: "Ew",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:84|pl": [
    {
      german: "Welche Hauptaufgabe hat die deutsche Bundespräsidentin/der deutsche Bundespräsident?",
      translated: "Jakie jest główne zadanie Prezydenta Federalnego Niemiec?",
      tone: 'semantic',
    },
    {
      german: "Sie/Er",
      translated: "On",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:84|prs": [
    {
      german: "Welche Hauptaufgabe hat die deutsche Bundespräsidentin/der deutsche Bundespräsident?",
      translated: "وظیفهٔ اصلی رئیس‌جمهور فدرال آلمان چیست؟",
      tone: 'semantic',
    },
    {
      german: "Sie/Er",
      translated: "او",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:84|ro": [
    {
      german: "Welche Hauptaufgabe hat die deutsche Bundespräsidentin/der deutsche Bundespräsident?",
      translated: "Care este principala atribuție a președintelui federal al Germaniei?",
      tone: 'semantic',
    },
    {
      german: "Sie/Er",
      translated: "El",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:84|ru": [
    {
      german: "Welche Hauptaufgabe hat die deutsche Bundespräsidentin/der deutsche Bundespräsident?",
      translated: "Какова главная задача федерального президента Германии?",
      tone: 'semantic',
    },
    {
      german: "Sie/Er",
      translated: "Он/она …",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:84|sq": [
    {
      german: "Welche Hauptaufgabe hat die deutsche Bundespräsidentin/der deutsche Bundespräsident?",
      translated: "Cila është detyra kryesore e Presidentit Federal gjerman?",
      tone: 'semantic',
    },
    {
      german: "Sie/Er",
      translated: "Ai",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:84|sr": [
    {
      german: "Welche Hauptaufgabe hat die deutsche Bundespräsidentin/der deutsche Bundespräsident?",
      translated: "Koja je glavna zadaća nemačkog saveznog predsjednika?",
      tone: 'semantic',
    },
    {
      german: "Sie/Er",
      translated: "On",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:84|tr": [
    {
      german: "Welche Hauptaufgabe hat die deutsche Bundespräsidentin/der deutsche Bundespräsident?",
      translated: "Alman Federal Cumhurbaşkanının temel görevi",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:84|uk": [
    {
      german: "Welche Hauptaufgabe hat die deutsche Bundespräsidentin/der deutsche Bundespräsident?",
      translated: "Яке головне завдання Федерального президента Німеччини?",
      tone: 'semantic',
    },
    {
      german: "Sie/Er",
      translated: "Він/вона",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:84|vi": [
    {
      german: "Welche Hauptaufgabe hat die deutsche Bundespräsidentin/der deutsche Bundespräsident?",
      translated: "Nhiệm vụ chính của Tổng thống Liên bang Đức là gì?",
      tone: 'semantic',
    },
    {
      german: "Sie/Er",
      translated: "Ông/bà ấy …",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:85|ar": [
    {
      german: "Wer",
      translated: "ممن",
      tone: 'semantic',
    },
    {
      german: "bildet",
      translated: "يتكون",
      tone: 'semantic',
    },
    {
      german: "den deutschen Bundesrat",
      translated: "البوندسرات الألماني",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:85|bg": [
    {
      german: "Wer",
      translated: "От кого",
      tone: 'semantic',
    },
    {
      german: "bildet",
      translated: "се състои",
      tone: 'semantic',
    },
    {
      german: "den deutschen Bundesrat",
      translated: "германският Бундесрат",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:85|bs": [
    {
      german: "Wer",
      translated: "Od koga",
      tone: 'semantic',
    },
    {
      german: "bildet",
      translated: "se sastoji",
      tone: 'semantic',
    },
    {
      german: "den deutschen Bundesrat",
      translated: "njemački Bundesrat",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:85|el": [
    {
      german: "Wer",
      translated: "Από ποιους",
      tone: 'semantic',
    },
    {
      german: "bildet",
      translated: "αποτελείται",
      tone: 'semantic',
    },
    {
      german: "den deutschen Bundesrat",
      translated: "το γερμανικό Bundesrat",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:85|en": [
    {
      german: "Wer",
      translated: "Who",
      tone: 'semantic',
    },
    {
      german: "bildet",
      translated: "forms",
      tone: 'semantic',
    },
    {
      german: "den deutschen Bundesrat",
      translated: "the German Bundesrat",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:85|es": [
    {
      german: "Wer",
      translated: "¿Quién",
      tone: 'semantic',
    },
    {
      german: "bildet",
      translated: "forma",
      tone: 'semantic',
    },
    {
      german: "den deutschen Bundesrat",
      translated: "el Bundesrat alemán",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:85|fa": [
    {
      german: "Wer",
      translated: "از چه کسانی",
      tone: 'semantic',
    },
    {
      german: "bildet",
      translated: "تشکیل می‌شود",
      tone: 'semantic',
    },
    {
      german: "den deutschen Bundesrat",
      translated: "بوندسرات آلمان",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:85|fr": [
    {
      german: "Wer",
      translated: "De qui",
      tone: 'semantic',
    },
    {
      german: "bildet",
      translated: "se compose",
      tone: 'semantic',
    },
    {
      german: "den deutschen Bundesrat",
      translated: "le Bundesrat allemand",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:85|hr": [
    {
      german: "Wer",
      translated: "Od koga",
      tone: 'semantic',
    },
    {
      german: "bildet",
      translated: "se sastoji",
      tone: 'semantic',
    },
    {
      german: "den deutschen Bundesrat",
      translated: "njemački Bundesrat",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:85|it": [
    {
      german: "Wer",
      translated: "Da chi",
      tone: 'semantic',
    },
    {
      german: "bildet",
      translated: "è composto",
      tone: 'semantic',
    },
    {
      german: "den deutschen Bundesrat",
      translated: "Bundesrat tedesco",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:85|kmr": [
    {
      german: "Wer",
      translated: "Bundesratê",
      tone: 'semantic',
    },
    {
      german: "bildet",
      translated: "ji",
      tone: 'semantic',
    },
    {
      german: "den deutschen Bundesrat",
      translated: "Alman",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:85|pl": [
    {
      german: "Wer",
      translated: "Z kogo",
      tone: 'semantic',
    },
    {
      german: "bildet",
      translated: "składa się",
      tone: 'semantic',
    },
    {
      german: "den deutschen Bundesrat",
      translated: "niemiecki Bundesrat",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:85|prs": [
    {
      german: "Wer",
      translated: "از چه کسانی",
      tone: 'semantic',
    },
    {
      german: "bildet",
      translated: "تشکیل می‌شود",
      tone: 'semantic',
    },
    {
      german: "den deutschen Bundesrat",
      translated: "بوندسرات آلمان",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:85|ro": [
    {
      german: "Wer",
      translated: "Din cine",
      tone: 'semantic',
    },
    {
      german: "bildet",
      translated: "este alcătuit",
      tone: 'semantic',
    },
    {
      german: "den deutschen Bundesrat",
      translated: "Bundesratul german",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:85|ru": [
    {
      german: "Wer",
      translated: "Кто",
      tone: 'semantic',
    },
    {
      german: "bildet",
      translated: "входит в состав",
      tone: 'semantic',
    },
    {
      german: "den deutschen Bundesrat",
      translated: "Бундесрата Германии",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:85|sq": [
    {
      german: "Wer",
      translated: "Nga",
      tone: 'semantic',
    },
    {
      german: "bildet",
      translated: "kush përbëhet",
      tone: 'semantic',
    },
    {
      german: "den deutschen Bundesrat",
      translated: "Bundesrati gjerman?",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:85|sr": [
    {
      german: "Wer",
      translated: "Od koga",
      tone: 'semantic',
    },
    {
      german: "bildet",
      translated: "se sastoji",
      tone: 'semantic',
    },
    {
      german: "den deutschen Bundesrat",
      translated: "nemački Bundesrat",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:85|tr": [
    {
      german: "Wer",
      translated: "kim",
      tone: 'semantic',
    },
    {
      german: "bildet",
      translated: "oluşturur",
      tone: 'semantic',
    },
    {
      german: "den deutschen Bundesrat",
      translated: "Alman Federal Konseyini (Bundesrat)",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:85|uk": [
    {
      german: "Wer",
      translated: "Хто",
      tone: 'semantic',
    },
    {
      german: "bildet",
      translated: "формує",
      tone: 'semantic',
    },
    {
      german: "den deutschen Bundesrat",
      translated: "німецький Бундесрат",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:85|vi": [
    {
      german: "Wer",
      translated: "những ai",
      tone: 'semantic',
    },
    {
      german: "bildet",
      translated: "gồm",
      tone: 'semantic',
    },
    {
      german: "den deutschen Bundesrat",
      translated: "Bundesrat Đức",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:86|ar": [
    {
      german: "wählt",
      translated: "ينتخب",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "من",
      tone: 'semantic',
    },
    {
      german: "die Bundespräsidentin/den Bundespräsidenten",
      translated: "رئيس جمهورية ألمانيا الاتحادية",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:86|bg": [
    {
      german: "Wer",
      translated: "Кой",
      tone: 'semantic',
    },
    {
      german: "wählt",
      translated: "избира",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "на Германия",
      tone: 'semantic',
    },
    {
      german: "die Bundespräsidentin/den Bundespräsidenten",
      translated: "федералния президент",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:86|bs": [
    {
      german: "Wer",
      translated: "Tko",
      tone: 'semantic',
    },
    {
      german: "wählt",
      translated: "bira",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "u Njemačkoj",
      tone: 'semantic',
    },
    {
      german: "die Bundespräsidentin/den Bundespräsidenten",
      translated: "saveznog predsjednika",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:86|el": [
    {
      german: "Wer",
      translated: "Ποιος",
      tone: 'semantic',
    },
    {
      german: "wählt",
      translated: "εκλέγει",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "στη Γερμανία",
      tone: 'semantic',
    },
    {
      german: "die Bundespräsidentin/den Bundespräsidenten",
      translated: "τον Ομοσπονδιακό Πρόεδρο",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:86|en": [
    {
      german: "Wer",
      translated: "Who",
      tone: 'semantic',
    },
    {
      german: "wählt",
      translated: "elects",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "in Germany",
      tone: 'semantic',
    },
    {
      german: "die Bundespräsidentin/den Bundespräsidenten",
      translated: "the Federal President",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:86|es": [
    {
      german: "Wer",
      translated: "¿Quién",
      tone: 'semantic',
    },
    {
      german: "wählt",
      translated: "elige",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "en Alemania",
      tone: 'semantic',
    },
    {
      german: "die Bundespräsidentin/den Bundespräsidenten",
      translated: "al Presidente Federal",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:86|fa": [
    {
      german: "Wer",
      translated: "چه کسی",
      tone: 'semantic',
    },
    {
      german: "wählt",
      translated: "انتخاب می‌کند",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "فدرال آلمان",
      tone: 'semantic',
    },
    {
      german: "die Bundespräsidentin/den Bundespräsidenten",
      translated: "رئیس‌جمهور",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:86|fr": [
    {
      german: "Wer",
      translated: "Qui",
      tone: 'semantic',
    },
    {
      german: "wählt",
      translated: "élit",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "en Allemagne",
      tone: 'semantic',
    },
    {
      german: "die Bundespräsidentin/den Bundespräsidenten",
      translated: "le président fédéral",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:86|hr": [
    {
      german: "Wer",
      translated: "Tko",
      tone: 'semantic',
    },
    {
      german: "wählt",
      translated: "bira",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "u Njemačkoj",
      tone: 'semantic',
    },
    {
      german: "die Bundespräsidentin/den Bundespräsidenten",
      translated: "saveznog predsjednika",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:86|it": [
    {
      german: "Wer",
      translated: "Chi",
      tone: 'semantic',
    },
    {
      german: "wählt",
      translated: "elegge",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "in Germania",
      tone: 'semantic',
    },
    {
      german: "die Bundespräsidentin/den Bundespräsidenten",
      translated: "il Presidente federale",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:86|kmr": [
    {
      german: "Wer",
      translated: "kî",
      tone: 'semantic',
    },
    {
      german: "wählt",
      translated: "hildibijêre",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "Almanyayê",
      tone: 'semantic',
    },
    {
      german: "die Bundespräsidentin/den Bundespräsidenten",
      translated: "Serokê Federal",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:86|pl": [
    {
      german: "Wer",
      translated: "Kto",
      tone: 'semantic',
    },
    {
      german: "wählt",
      translated: "wybiera",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "w Niemczech",
      tone: 'semantic',
    },
    {
      german: "die Bundespräsidentin/den Bundespräsidenten",
      translated: "Prezydenta Federalnego",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:86|prs": [
    {
      german: "Wer",
      translated: "چه کسی",
      tone: 'semantic',
    },
    {
      german: "wählt",
      translated: "انتخاب می‌کند",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "آلمان",
      tone: 'semantic',
    },
    {
      german: "die Bundespräsidentin/den Bundespräsidenten",
      translated: "رئیس‌جمهور فدرال",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:86|ro": [
    {
      german: "Wer",
      translated: "Cine",
      tone: 'semantic',
    },
    {
      german: "wählt",
      translated: "alege",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "al Germaniei",
      tone: 'semantic',
    },
    {
      german: "die Bundespräsidentin/den Bundespräsidenten",
      translated: "președintele federal",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:86|ru": [
    {
      german: "Wer",
      translated: "Кто",
      tone: 'semantic',
    },
    {
      german: "wählt",
      translated: "избирает",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "в Германии",
      tone: 'semantic',
    },
    {
      german: "die Bundespräsidentin/den Bundespräsidenten",
      translated: "федерального президента",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:86|sq": [
    {
      german: "Wer",
      translated: "Kush",
      tone: 'semantic',
    },
    {
      german: "wählt",
      translated: "zgjedh",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "në Gjermani",
      tone: 'semantic',
    },
    {
      german: "die Bundespräsidentin/den Bundespräsidenten",
      translated: "Presidentin Federal",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:86|sr": [
    {
      german: "Wer",
      translated: "Ko",
      tone: 'semantic',
    },
    {
      german: "wählt",
      translated: "bira",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "u Nemačkoj",
      tone: 'semantic',
    },
    {
      german: "die Bundespräsidentin/den Bundespräsidenten",
      translated: "saveznog predsjednika",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:86|tr": [
    {
      german: "Wer",
      translated: "kim",
      tone: 'semantic',
    },
    {
      german: "wählt",
      translated: "seçer",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "Almanya'da",
      tone: 'semantic',
    },
    {
      german: "die Bundespräsidentin/den Bundespräsidenten",
      translated: "Federal Cumhurbaşkanını",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:86|uk": [
    {
      german: "Wer",
      translated: "Хто",
      tone: 'semantic',
    },
    {
      german: "wählt",
      translated: "обирає",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "в Німеччині",
      tone: 'semantic',
    },
    {
      german: "die Bundespräsidentin/den Bundespräsidenten",
      translated: "Федерального президента",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:86|vi": [
    {
      german: "Wer",
      translated: "Ai",
      tone: 'semantic',
    },
    {
      german: "wählt",
      translated: "bầu",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "ở Đức",
      tone: 'semantic',
    },
    {
      german: "die Bundespräsidentin/den Bundespräsidenten",
      translated: "Tổng thống Liên bang",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:87|ar": [
    {
      german: "Wer",
      translated: "من",
      tone: 'semantic',
    },
    {
      german: "das Staatsoberhaupt",
      translated: "رئيس الدولة",
      tone: 'semantic',
    },
    {
      german: "der Bundesrepublik Deutschland",
      translated: "في جمهورية ألمانيا الاتحادية",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:87|bg": [
    {
      german: "Wer",
      translated: "Кой",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "е",
      tone: 'semantic',
    },
    {
      german: "das Staatsoberhaupt",
      translated: "държавният глава",
      tone: 'semantic',
    },
    {
      german: "der Bundesrepublik Deutschland",
      translated: "във Федерална република Германия",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:87|bs": [
    {
      german: "Wer",
      translated: "Tko",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "je",
      tone: 'semantic',
    },
    {
      german: "das Staatsoberhaupt",
      translated: "šef države",
      tone: 'semantic',
    },
    {
      german: "der Bundesrepublik Deutschland",
      translated: "Savezne Republike Njemačke",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:87|el": [
    {
      german: "Wer",
      translated: "Ποιος",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "είναι",
      tone: 'semantic',
    },
    {
      german: "das Staatsoberhaupt",
      translated: "ο αρχηγός του κράτους",
      tone: 'semantic',
    },
    {
      german: "der Bundesrepublik Deutschland",
      translated: "της Ομοσπονδιακής Δημοκρατίας της Γερμανίας",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:87|en": [
    {
      german: "Wer",
      translated: "Who",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "is",
      tone: 'semantic',
    },
    {
      german: "das Staatsoberhaupt",
      translated: "the head of state",
      tone: 'semantic',
    },
    {
      german: "der Bundesrepublik Deutschland",
      translated: "the Federal Republic of Germany",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:87|es": [
    {
      german: "Wer",
      translated: "¿Quién",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "es",
      tone: 'semantic',
    },
    {
      german: "das Staatsoberhaupt",
      translated: "el jefe de Estado",
      tone: 'semantic',
    },
    {
      german: "der Bundesrepublik Deutschland",
      translated: "la República Federal de Alemania",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:87|fa": [
    {
      german: "Wer",
      translated: "چه کسی",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "است",
      tone: 'semantic',
    },
    {
      german: "das Staatsoberhaupt",
      translated: "رئیس کشور",
      tone: 'semantic',
    },
    {
      german: "der Bundesrepublik Deutschland",
      translated: "جمهوری فدرال آلمان",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:87|fr": [
    {
      german: "Wer",
      translated: "Qui",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "est",
      tone: 'semantic',
    },
    {
      german: "das Staatsoberhaupt",
      translated: "le chef de l’État",
      tone: 'semantic',
    },
    {
      german: "der Bundesrepublik Deutschland",
      translated: "de la République fédérale d’Allemagne",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:87|hr": [
    {
      german: "Wer",
      translated: "Tko",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "je",
      tone: 'semantic',
    },
    {
      german: "das Staatsoberhaupt",
      translated: "šef države",
      tone: 'semantic',
    },
    {
      german: "der Bundesrepublik Deutschland",
      translated: "Savezne Republike Njemačke",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:87|it": [
    {
      german: "Wer",
      translated: "Chi",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "è",
      tone: 'semantic',
    },
    {
      german: "das Staatsoberhaupt",
      translated: "il capo dello Stato",
      tone: 'semantic',
    },
    {
      german: "der Bundesrepublik Deutschland",
      translated: "della Repubblica Federale di Germania",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:87|kmr": [
    {
      german: "Wer",
      translated: "Serokê",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "ye",
      tone: 'semantic',
    },
    {
      german: "das Staatsoberhaupt",
      translated: "dewleta",
      tone: 'semantic',
    },
    {
      german: "der Bundesrepublik Deutschland",
      translated: "Komara Federal a Almanyayê kî",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:87|pl": [
    {
      german: "Wer",
      translated: "Kto",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "jest",
      tone: 'semantic',
    },
    {
      german: "das Staatsoberhaupt",
      translated: "głową państwa",
      tone: 'semantic',
    },
    {
      german: "der Bundesrepublik Deutschland",
      translated: "Republiki Federalnej Niemiec",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:87|prs": [
    {
      german: "Wer",
      translated: "چه کسی",
      tone: 'semantic',
    },
    {
      german: "das Staatsoberhaupt",
      translated: "رئیس کشور",
      tone: 'semantic',
    },
    {
      german: "der Bundesrepublik Deutschland",
      translated: "جمهوری فدرال آلمان",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:87|ro": [
    {
      german: "Wer",
      translated: "Cine",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "este",
      tone: 'semantic',
    },
    {
      german: "das Staatsoberhaupt",
      translated: "șeful statului",
      tone: 'semantic',
    },
    {
      german: "der Bundesrepublik Deutschland",
      translated: "în Republica Federală Germania?",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:87|ru": [
    {
      german: "Wer",
      translated: "Кто",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "является",
      tone: 'semantic',
    },
    {
      german: "das Staatsoberhaupt",
      translated: "главой государства",
      tone: 'semantic',
    },
    {
      german: "der Bundesrepublik Deutschland",
      translated: "Федеративной Республики Германия",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:87|sq": [
    {
      german: "Wer",
      translated: "Kush",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "është",
      tone: 'semantic',
    },
    {
      german: "das Staatsoberhaupt",
      translated: "kreu i",
      tone: 'semantic',
    },
    {
      german: "der Bundesrepublik Deutschland",
      translated: "shtetit të Republikës Federale të Gjermanisë",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:87|sr": [
    {
      german: "Wer",
      translated: "Ko",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "je",
      tone: 'semantic',
    },
    {
      german: "das Staatsoberhaupt",
      translated: "šef države",
      tone: 'semantic',
    },
    {
      german: "der Bundesrepublik Deutschland",
      translated: "Savezne Republike Nemačke",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:87|tr": [
    {
      german: "Wer",
      translated: "kimdir",
      tone: 'semantic',
    },
    {
      german: "das Staatsoberhaupt",
      translated: "devlet başkanı",
      tone: 'semantic',
    },
    {
      german: "der Bundesrepublik Deutschland",
      translated: "Almanya Federal Cumhuriyeti'nin",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:87|uk": [
    {
      german: "Wer",
      translated: "Хто",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "є",
      tone: 'semantic',
    },
    {
      german: "das Staatsoberhaupt",
      translated: "главою держави",
      tone: 'semantic',
    },
    {
      german: "der Bundesrepublik Deutschland",
      translated: "Федеративної Республіки Німеччина",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:87|vi": [
    {
      german: "Wer",
      translated: "Ai",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "là",
      tone: 'semantic',
    },
    {
      german: "das Staatsoberhaupt",
      translated: "nguyên thủ quốc gia",
      tone: 'semantic',
    },
    {
      german: "der Bundesrepublik Deutschland",
      translated: "Cộng hòa Liên bang Đức",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:88|ar": [
    {
      german: "parlamentarische Opposition",
      translated: "المعارضة البرلمانية",
      tone: 'semantic',
    },
    {
      german: "Deutschen Bundestag",
      translated: "البوندستاغ الألماني",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:88|bg": [
    {
      german: "parlamentarische Opposition",
      translated: "Парламентарната опозиция",
      tone: 'semantic',
    },
    {
      german: "Deutschen Bundestag",
      translated: "в германския Бундестаг …",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:88|bs": [
    {
      german: "parlamentarische Opposition",
      translated: "Parlamentarna oporba",
      tone: 'semantic',
    },
    {
      german: "Deutschen Bundestag",
      translated: "Bundestagu",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:88|el": [
    {
      german: "parlamentarische Opposition",
      translated: "Η κοινοβουλευτική αντιπολίτευση",
      tone: 'semantic',
    },
    {
      german: "Deutschen Bundestag",
      translated: "στο γερμανικό Bundestag",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:88|en": [
    {
      german: "parlamentarische Opposition",
      translated: "parliamentary opposition",
      tone: 'semantic',
    },
    {
      german: "Deutschen Bundestag",
      translated: "the German Bundestag",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:88|es": [
    {
      german: "parlamentarische Opposition",
      translated: "La oposición parlamentaria",
      tone: 'semantic',
    },
    {
      german: "Deutschen Bundestag",
      translated: "en el Bundestag alemán",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:88|fa": [
    {
      german: "parlamentarische Opposition",
      translated: "اپوزیسیون پارلمانی",
      tone: 'semantic',
    },
    {
      german: "Deutschen Bundestag",
      translated: "بوندستاگ آلمان",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:88|fr": [
    {
      german: "parlamentarische Opposition",
      translated: "L’opposition parlementaire",
      tone: 'semantic',
    },
    {
      german: "Deutschen Bundestag",
      translated: "au Bundestag allemand",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:88|hr": [
    {
      german: "parlamentarische Opposition",
      translated: "Parlamentarna",
      tone: 'semantic',
    },
    {
      german: "Deutschen Bundestag",
      translated: "Bundestagu",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:88|it": [
    {
      german: "parlamentarische Opposition",
      translated: "L’opposizione parlamentare",
      tone: 'semantic',
    },
    {
      german: "Deutschen Bundestag",
      translated: "Bundestag tedesco",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:88|kmr": [
    {
      german: "parlamentarische Opposition",
      translated: "Opozîsyona parlamenterî di",
      tone: 'semantic',
    },
    {
      german: "Deutschen Bundestag",
      translated: "Bundestagê Alman de",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:88|pl": [
    {
      german: "parlamentarische Opposition",
      translated: "Opozycja parlamentarna",
      tone: 'semantic',
    },
    {
      german: "Deutschen Bundestag",
      translated: "niemieckim Bundestagu",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:88|prs": [
    {
      german: "parlamentarische Opposition",
      translated: "اپوزیسیون پارلمانی",
      tone: 'semantic',
    },
    {
      german: "Deutschen Bundestag",
      translated: "بوندستاگ آلمان",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:88|ro": [
    {
      german: "parlamentarische Opposition",
      translated: "Opoziția parlamentară",
      tone: 'semantic',
    },
    {
      german: "Deutschen Bundestag",
      translated: "Bundestagul german",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:88|ru": [
    {
      german: "parlamentarische Opposition",
      translated: "Парламентская оппозиция",
      tone: 'semantic',
    },
    {
      german: "Deutschen Bundestag",
      translated: "в Бундестаге Германии",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:88|sq": [
    {
      german: "parlamentarische Opposition",
      translated: "Opozita parlamentare në",
      tone: 'semantic',
    },
    {
      german: "Deutschen Bundestag",
      translated: "Bundestagun gjerman",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:88|sr": [
    {
      german: "parlamentarische Opposition",
      translated: "Parlamentarna opozicija",
      tone: 'semantic',
    },
    {
      german: "Deutschen Bundestag",
      translated: "nemačkom Bundestagu",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:88|tr": [
    {
      german: "parlamentarische Opposition",
      translated: "parlamenter muhalefet",
      tone: 'semantic',
    },
    {
      german: "Deutschen Bundestag",
      translated: "Alman Federal Meclisi'ndeki",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:88|uk": [
    {
      german: "parlamentarische Opposition",
      translated: "Парламентська опозиція",
      tone: 'semantic',
    },
    {
      german: "Deutschen Bundestag",
      translated: "німецькому Бундестазі",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:88|vi": [
    {
      german: "parlamentarische Opposition",
      translated: "Phe",
      tone: 'semantic',
    },
    {
      german: "Deutschen Bundestag",
      translated: "đối lập trong Bundestag Đức …",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:89|ar": [
    {
      german: "Wie nennt man",
      translated: "ماذا",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "في ألمانيا",
      tone: 'semantic',
    },
    {
      german: "die Vereinigung",
      translated: "تجمع",
      tone: 'semantic',
    },
    {
      german: "von Abgeordneten",
      translated: "نواب",
      tone: 'semantic',
    },
    {
      german: "einer Partei",
      translated: "حزب واحد",
      tone: 'semantic',
    },
    {
      german: "im Parlament",
      translated: "داخل البرلمان",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:89|bg": [
    {
      german: "Wie nennt man",
      translated: "Как се нарича",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "в германския",
      tone: 'semantic',
    },
    {
      german: "die Vereinigung",
      translated: "групата",
      tone: 'semantic',
    },
    {
      german: "von Abgeordneten",
      translated: "депутати",
      tone: 'semantic',
    },
    {
      german: "einer Partei",
      translated: "от една партия",
      tone: 'semantic',
    },
    {
      german: "im Parlament",
      translated: "парламент",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:89|bs": [
    {
      german: "Wie nennt man",
      translated: "Kako se",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "u Njemačkoj",
      tone: 'semantic',
    },
    {
      german: "die Vereinigung",
      translated: "skupina",
      tone: 'semantic',
    },
    {
      german: "von Abgeordneten",
      translated: "zastupnika",
      tone: 'semantic',
    },
    {
      german: "einer Partei",
      translated: "iste stranke",
      tone: 'semantic',
    },
    {
      german: "im Parlament",
      translated: "u parlamentu",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:89|el": [
    {
      german: "Wie nennt man",
      translated: "Πώς ονομάζεται",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "στη Γερμανία",
      tone: 'semantic',
    },
    {
      german: "die Vereinigung",
      translated: "η ομάδα",
      tone: 'semantic',
    },
    {
      german: "von Abgeordneten",
      translated: "βουλευτών",
      tone: 'semantic',
    },
    {
      german: "einer Partei",
      translated: "του ίδιου κόμματος",
      tone: 'semantic',
    },
    {
      german: "im Parlament",
      translated: "στο κοινοβούλιο",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:89|en": [
    {
      german: "Wie nennt man",
      translated: "What is",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "in Germany",
      tone: 'semantic',
    },
    {
      german: "die Vereinigung",
      translated: "association",
      tone: 'semantic',
    },
    {
      german: "von Abgeordneten",
      translated: "of members",
      tone: 'semantic',
    },
    {
      german: "einer Partei",
      translated: "from one party",
      tone: 'semantic',
    },
    {
      german: "im Parlament",
      translated: "of parliament",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:89|es": [
    {
      german: "Wie nennt man",
      translated: "¿Cómo se llama",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "en Alemania",
      tone: 'semantic',
    },
    {
      german: "die Vereinigung",
      translated: "la agrupación",
      tone: 'semantic',
    },
    {
      german: "von Abgeordneten",
      translated: "de diputados",
      tone: 'semantic',
    },
    {
      german: "einer Partei",
      translated: "de un mismo partido",
      tone: 'semantic',
    },
    {
      german: "im Parlament",
      translated: "en el Parlamento",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:89|fa": [
    {
      german: "Wie nennt man",
      translated: "چه نام دارد",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "آلمان",
      tone: 'semantic',
    },
    {
      german: "die Vereinigung",
      translated: "گروه",
      tone: 'semantic',
    },
    {
      german: "von Abgeordneten",
      translated: "نمایندگان",
      tone: 'semantic',
    },
    {
      german: "einer Partei",
      translated: "یک حزب",
      tone: 'semantic',
    },
    {
      german: "im Parlament",
      translated: "در پارلمان",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:89|fr": [
    {
      german: "Wie nennt man",
      translated: "Comment appelle-t-on",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "en Allemagne",
      tone: 'semantic',
    },
    {
      german: "die Vereinigung",
      translated: "le regroupement",
      tone: 'semantic',
    },
    {
      german: "von Abgeordneten",
      translated: "des députés",
      tone: 'semantic',
    },
    {
      german: "einer Partei",
      translated: "d’un même parti",
      tone: 'semantic',
    },
    {
      german: "im Parlament",
      translated: "au Parlement",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:89|hr": [
    {
      german: "Wie nennt man",
      translated: "Kako se",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "u Njemačkoj",
      tone: 'semantic',
    },
    {
      german: "die Vereinigung",
      translated: "skupina",
      tone: 'semantic',
    },
    {
      german: "von Abgeordneten",
      translated: "zastupnika",
      tone: 'semantic',
    },
    {
      german: "einer Partei",
      translated: "iste stranke",
      tone: 'semantic',
    },
    {
      german: "im Parlament",
      translated: "u parlamentu",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:89|it": [
    {
      german: "Wie nennt man",
      translated: "Come si chiama",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "in Germania",
      tone: 'semantic',
    },
    {
      german: "die Vereinigung",
      translated: "il gruppo",
      tone: 'semantic',
    },
    {
      german: "von Abgeordneten",
      translated: "dei deputati",
      tone: 'semantic',
    },
    {
      german: "einer Partei",
      translated: "di uno stesso partito",
      tone: 'semantic',
    },
    {
      german: "im Parlament",
      translated: "in Parlamento",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:89|kmr": [
    {
      german: "Wie nennt man",
      translated: "Li",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "Almanyayê",
      tone: 'semantic',
    },
    {
      german: "die Vereinigung",
      translated: "koma",
      tone: 'semantic',
    },
    {
      german: "von Abgeordneten",
      translated: "parlamenterên",
      tone: 'semantic',
    },
    {
      german: "einer Partei",
      translated: "partiyekê",
      tone: 'semantic',
    },
    {
      german: "im Parlament",
      translated: "parlamentoyê de",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:89|pl": [
    {
      german: "Wie nennt man",
      translated: "Jak nazywa się",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "w Niemczech",
      tone: 'semantic',
    },
    {
      german: "die Vereinigung",
      translated: "grupa",
      tone: 'semantic',
    },
    {
      german: "von Abgeordneten",
      translated: "posłów",
      tone: 'semantic',
    },
    {
      german: "einer Partei",
      translated: "tej samej partii",
      tone: 'semantic',
    },
    {
      german: "im Parlament",
      translated: "w parlamencie",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:89|prs": [
    {
      german: "Wie nennt man",
      translated: "چه نام دارد",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "آلمان",
      tone: 'semantic',
    },
    {
      german: "die Vereinigung",
      translated: "گروه",
      tone: 'semantic',
    },
    {
      german: "von Abgeordneten",
      translated: "نمایندگان",
      tone: 'semantic',
    },
    {
      german: "einer Partei",
      translated: "یک حزب",
      tone: 'semantic',
    },
    {
      german: "im Parlament",
      translated: "در پارلمان",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:89|ro": [
    {
      german: "Wie nennt man",
      translated: "Cum se numește",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "german",
      tone: 'semantic',
    },
    {
      german: "die Vereinigung",
      translated: "grupul",
      tone: 'semantic',
    },
    {
      german: "von Abgeordneten",
      translated: "deputaților",
      tone: 'semantic',
    },
    {
      german: "einer Partei",
      translated: "unui partid",
      tone: 'semantic',
    },
    {
      german: "im Parlament",
      translated: "în parlamentul",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:89|ru": [
    {
      german: "Wie nennt man",
      translated: "Как называют",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "в Германии",
      tone: 'semantic',
    },
    {
      german: "die Vereinigung",
      translated: "объединение",
      tone: 'semantic',
    },
    {
      german: "von Abgeordneten",
      translated: "депутатов",
      tone: 'semantic',
    },
    {
      german: "einer Partei",
      translated: "одной партии",
      tone: 'semantic',
    },
    {
      german: "im Parlament",
      translated: "в парламенте",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:89|sq": [
    {
      german: "Wie nennt man",
      translated: "Si quhet",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "në Gjermani",
      tone: 'semantic',
    },
    {
      german: "die Vereinigung",
      translated: "grupi",
      tone: 'semantic',
    },
    {
      german: "von Abgeordneten",
      translated: "i deputetëve",
      tone: 'semantic',
    },
    {
      german: "einer Partei",
      translated: "të së njëjtës parti",
      tone: 'semantic',
    },
    {
      german: "im Parlament",
      translated: "në parlament",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:89|sr": [
    {
      german: "Wie nennt man",
      translated: "Kako se",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "u Nemačkoj",
      tone: 'semantic',
    },
    {
      german: "die Vereinigung",
      translated: "skupina",
      tone: 'semantic',
    },
    {
      german: "von Abgeordneten",
      translated: "poslanika",
      tone: 'semantic',
    },
    {
      german: "einer Partei",
      translated: "iste stranke",
      tone: 'semantic',
    },
    {
      german: "im Parlament",
      translated: "u parlamentu",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:89|tr": [
    {
      german: "Wie nennt man",
      translated: "ne denir",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "Almanya'da",
      tone: 'semantic',
    },
    {
      german: "die Vereinigung",
      translated: "gruba",
      tone: 'semantic',
    },
    {
      german: "von Abgeordneten",
      translated: "milletvekillerinin",
      tone: 'semantic',
    },
    {
      german: "einer Partei",
      translated: "aynı partiden",
      tone: 'semantic',
    },
    {
      german: "im Parlament",
      translated: "parlamentoda",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:89|uk": [
    {
      german: "Wie nennt man",
      translated: "Як",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "у Німеччині",
      tone: 'semantic',
    },
    {
      german: "die Vereinigung",
      translated: "об’єднання",
      tone: 'semantic',
    },
    {
      german: "von Abgeordneten",
      translated: "депутатів",
      tone: 'semantic',
    },
    {
      german: "einer Partei",
      translated: "однієї партії",
      tone: 'semantic',
    },
    {
      german: "im Parlament",
      translated: "в парламенті",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:89|vi": [
    {
      german: "Wie nennt man",
      translated: "được gọi là",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "Ở Đức",
      tone: 'semantic',
    },
    {
      german: "die Vereinigung",
      translated: "nhóm",
      tone: 'semantic',
    },
    {
      german: "von Abgeordneten",
      translated: "nghị sĩ",
      tone: 'semantic',
    },
    {
      german: "einer Partei",
      translated: "cùng một đảng",
      tone: 'semantic',
    },
    {
      german: "im Parlament",
      translated: "trong nghị viện",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:8|ar": [
    {
      german: "im Grundgesetz",
      translated: "في القانون الأساسي الألماني",
      tone: 'semantic',
    },
    {
      german: "von Deutschland",
      translated: "؟",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:8|bg": [
    {
      german: "Was",
      translated: "Кое",
      tone: 'semantic',
    },
    {
      german: "steht nicht",
      translated: "НЕ е",
      tone: 'semantic',
    },
    {
      german: "im Grundgesetz",
      translated: "в Основния закон",
      tone: 'semantic',
    },
    {
      german: "von Deutschland",
      translated: "на Германия",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:8|bs": [
    {
      german: "Was",
      translated: "Što",
      tone: 'semantic',
    },
    {
      german: "steht nicht",
      translated: "NIJE zapisano",
      tone: 'semantic',
    },
    {
      german: "im Grundgesetz",
      translated: "u njemačkom Temeljnom zakonu",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:8|el": [
    {
      german: "Was",
      translated: "Τι",
      tone: 'semantic',
    },
    {
      german: "steht nicht",
      translated: "ΔΕΝ αναφέρεται",
      tone: 'semantic',
    },
    {
      german: "im Grundgesetz",
      translated: "στον γερμανικό Θεμελιώδη Νόμο",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:8|en": [
    {
      german: "Was",
      translated: "What",
      tone: 'semantic',
    },
    {
      german: "steht nicht",
      translated: "is NOT",
      tone: 'semantic',
    },
    {
      german: "im Grundgesetz",
      translated: "Basic Law",
      tone: 'semantic',
    },
    {
      german: "von Deutschland",
      translated: "German",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:8|es": [
    {
      german: "Was",
      translated: "¿Qué",
      tone: 'semantic',
    },
    {
      german: "steht nicht",
      translated: "NO aparece",
      tone: 'semantic',
    },
    {
      german: "im Grundgesetz",
      translated: "la Ley Fundamental",
      tone: 'semantic',
    },
    {
      german: "von Deutschland",
      translated: "de Alemania",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:8|fa": [
    {
      german: "Was",
      translated: "کدام",
      tone: 'semantic',
    },
    {
      german: "steht nicht",
      translated: "مورد در",
      tone: 'semantic',
    },
    {
      german: "im Grundgesetz",
      translated: "قانون اساسی",
      tone: 'semantic',
    },
    {
      german: "von Deutschland",
      translated: "آلمان",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:8|fr": [
    {
      german: "Was",
      translated: "Qu’est-ce",
      tone: 'semantic',
    },
    {
      german: "steht nicht",
      translated: "qui ne figure pas",
      tone: 'semantic',
    },
    {
      german: "im Grundgesetz",
      translated: "dans la Loi fondamentale",
      tone: 'semantic',
    },
    {
      german: "von Deutschland",
      translated: "allemande",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:8|hr": [
    {
      german: "Was",
      translated: "Što",
      tone: 'semantic',
    },
    {
      german: "steht nicht",
      translated: "NIJE",
      tone: 'semantic',
    },
    {
      german: "im Grundgesetz",
      translated: "u njemačkom Temeljnom zakonu",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:8|it": [
    {
      german: "Was",
      translated: "Che cosa",
      tone: 'semantic',
    },
    {
      german: "steht nicht",
      translated: "NON è scritto",
      tone: 'semantic',
    },
    {
      german: "im Grundgesetz",
      translated: "nella Legge fondamentale",
      tone: 'semantic',
    },
    {
      german: "von Deutschland",
      translated: "tedesca?",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:8|kmr": [
    {
      german: "Was",
      translated: "Kîjan",
      tone: 'semantic',
    },
    {
      german: "steht nicht",
      translated: "gotin di",
      tone: 'semantic',
    },
    {
      german: "im Grundgesetz",
      translated: "Qanûna Bingehîn",
      tone: 'semantic',
    },
    {
      german: "von Deutschland",
      translated: "a Almanyayê de tune ye",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:8|pl": [
    {
      german: "Was",
      translated: "Czego",
      tone: 'semantic',
    },
    {
      german: "steht nicht",
      translated: "NIE zapisano",
      tone: 'semantic',
    },
    {
      german: "im Grundgesetz",
      translated: "Ustawie Zasadniczej",
      tone: 'semantic',
    },
    {
      german: "von Deutschland",
      translated: "niemieckiej",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:8|prs": [
    {
      german: "Was",
      translated: "کدام",
      tone: 'semantic',
    },
    {
      german: "steht nicht",
      translated: "وجود ندارد",
      tone: 'semantic',
    },
    {
      german: "im Grundgesetz",
      translated: "قانون اساسی",
      tone: 'semantic',
    },
    {
      german: "von Deutschland",
      translated: "آلمان",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:8|ro": [
    {
      german: "Was",
      translated: "Ce",
      tone: 'semantic',
    },
    {
      german: "steht nicht",
      translated: "NU este prevăzut",
      tone: 'semantic',
    },
    {
      german: "im Grundgesetz",
      translated: "în Legea fundamentală",
      tone: 'semantic',
    },
    {
      german: "von Deutschland",
      translated: "a Germaniei",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:8|ru": [
    {
      german: "Was",
      translated: "Чего",
      tone: 'semantic',
    },
    {
      german: "steht nicht",
      translated: "нет в",
      tone: 'semantic',
    },
    {
      german: "im Grundgesetz",
      translated: "Основном законе",
      tone: 'semantic',
    },
    {
      german: "von Deutschland",
      translated: "Германии",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:8|sq": [
    {
      german: "Was",
      translated: "Çfarë",
      tone: 'semantic',
    },
    {
      german: "steht nicht",
      translated: "NUK shkruhet në",
      tone: 'semantic',
    },
    {
      german: "im Grundgesetz",
      translated: "Ligjin Themelor",
      tone: 'semantic',
    },
    {
      german: "von Deutschland",
      translated: "gjerman",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:8|sr": [
    {
      german: "Was",
      translated: "Šta",
      tone: 'semantic',
    },
    {
      german: "steht nicht",
      translated: "NIJE",
      tone: 'semantic',
    },
    {
      german: "im Grundgesetz",
      translated: "u nemačkom Osnovnom zakonu",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:8|tr": [
    {
      german: "Was",
      translated: "Aşağıdakilerden",
      tone: 'semantic',
    },
    {
      german: "steht nicht",
      translated: "hangisi",
      tone: 'semantic',
    },
    {
      german: "im Grundgesetz",
      translated: "Alman Anayasası'nda (Grundgesetz)",
      tone: 'semantic',
    },
    {
      german: "von Deutschland",
      translated: "yer almaz",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:8|uk": [
    {
      german: "Was",
      translated: "Якого",
      tone: 'semantic',
    },
    {
      german: "steht nicht",
      translated: "немає",
      tone: 'semantic',
    },
    {
      german: "im Grundgesetz",
      translated: "в Основному законі",
      tone: 'semantic',
    },
    {
      german: "von Deutschland",
      translated: "Німеччини",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:8|vi": [
    {
      german: "Was",
      translated: "Điều gì",
      tone: 'semantic',
    },
    {
      german: "steht nicht",
      translated: "KHÔNG được ghi",
      tone: 'semantic',
    },
    {
      german: "im Grundgesetz",
      translated: "Luật Cơ bản",
      tone: 'semantic',
    },
    {
      german: "von Deutschland",
      translated: "của Đức",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:90|ar": [
    {
      german: "Die deutschen Bundesländer",
      translated: "الولايات الاتحادية الألمانية",
      tone: 'semantic',
    },
    {
      german: "wirken an der Gesetzgebung des Bundes",
      translated: "في التشريع الاتحادي",
      tone: 'semantic',
    },
    {
      german: "mit",
      translated: "من خلال",
      tone: 'semantic',
    },
    {
      german: "durch",
      translated: "…",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:90|bg": [
    {
      german: "Die deutschen Bundesländer",
      translated: "Германските федерални провинции",
      tone: 'semantic',
    },
    {
      german: "wirken an der Gesetzgebung des Bundes",
      translated: "участват във федералното законодателство",
      tone: 'semantic',
    },
    {
      german: "durch",
      translated: "чрез",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:90|bs": [
    {
      german: "Die deutschen Bundesländer",
      translated: "Njemačke savezne zemlje",
      tone: 'semantic',
    },
    {
      german: "wirken an der Gesetzgebung des Bundes",
      translated: "učestvuju u saveznom zakonodavstvu",
      tone: 'semantic',
    },
    {
      german: "durch",
      translated: "putem",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:90|el": [
    {
      german: "Die deutschen Bundesländer",
      translated: "Τα γερμανικά ομόσπονδα κρατίδια",
      tone: 'semantic',
    },
    {
      german: "wirken an der Gesetzgebung des Bundes",
      translated: "συμμετέχουν στην ομοσπονδιακή νομοθεσία",
      tone: 'semantic',
    },
    {
      german: "durch",
      translated: "μέσω",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:90|en": [
    {
      german: "Die deutschen Bundesländer",
      translated: "The German federal states",
      tone: 'semantic',
    },
    {
      german: "wirken an der Gesetzgebung des Bundes",
      translated: "participate in federal legislation",
      tone: 'semantic',
    },
    {
      german: "durch",
      translated: "through",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:90|es": [
    {
      german: "Die deutschen Bundesländer",
      translated: "Los estados federados alemanes",
      tone: 'semantic',
    },
    {
      german: "wirken an der Gesetzgebung des Bundes",
      translated: "participan en la legislación federal",
      tone: 'semantic',
    },
    {
      german: "durch",
      translated: "a través de …",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:90|fa": [
    {
      german: "Die deutschen Bundesländer",
      translated: "ایالت‌های آلمان",
      tone: 'semantic',
    },
    {
      german: "wirken an der Gesetzgebung des Bundes",
      translated: "در قانون‌گذاری فدرال مشارکت می‌کنند",
      tone: 'semantic',
    },
    {
      german: "durch",
      translated: "از طریق",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:90|fr": [
    {
      german: "Die deutschen Bundesländer",
      translated: "Les Länder allemands",
      tone: 'semantic',
    },
    {
      german: "wirken an der Gesetzgebung des Bundes",
      translated: "participent à la législation fédérale",
      tone: 'semantic',
    },
    {
      german: "durch",
      translated: "par l’intermédiaire",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:90|hr": [
    {
      german: "Die deutschen Bundesländer",
      translated: "Njemačke savezne zemlje",
      tone: 'semantic',
    },
    {
      german: "wirken an der Gesetzgebung des Bundes",
      translated: "sudjeluju u saveznom zakonodavstvu",
      tone: 'semantic',
    },
    {
      german: "durch",
      translated: "putem …",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:90|it": [
    {
      german: "Die deutschen Bundesländer",
      translated: "I Länder tedeschi",
      tone: 'semantic',
    },
    {
      german: "wirken an der Gesetzgebung des Bundes",
      translated: "partecipano alla legislazione federale",
      tone: 'semantic',
    },
    {
      german: "durch",
      translated: "tramite",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:90|kmr": [
    {
      german: "Die deutschen Bundesländer",
      translated: "Eyaletên federal ên Alman",
      tone: 'semantic',
    },
    {
      german: "wirken an der Gesetzgebung des Bundes",
      translated: "beşdar dibin",
      tone: 'semantic',
    },
    {
      german: "durch",
      translated: "bi rêya …",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:90|pl": [
    {
      german: "Die deutschen Bundesländer",
      translated: "Niemieckie kraje związkowe",
      tone: 'semantic',
    },
    {
      german: "wirken an der Gesetzgebung des Bundes",
      translated: "uczestniczą w ustawodawstwie federalnym",
      tone: 'semantic',
    },
    {
      german: "durch",
      translated: "poprzez …",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:90|prs": [
    {
      german: "Die deutschen Bundesländer",
      translated: "ایالت‌های آلمان",
      tone: 'semantic',
    },
    {
      german: "wirken an der Gesetzgebung des Bundes",
      translated: "در قانون‌گذاری فدرال مشارکت می‌کنند",
      tone: 'semantic',
    },
    {
      german: "durch",
      translated: "از طریق",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:90|ro": [
    {
      german: "Die deutschen Bundesländer",
      translated: "Landurile germane",
      tone: 'semantic',
    },
    {
      german: "wirken an der Gesetzgebung des Bundes",
      translated: "participă la legislația federală",
      tone: 'semantic',
    },
    {
      german: "durch",
      translated: "prin …",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:90|ru": [
    {
      german: "Die deutschen Bundesländer",
      translated: "Федеральные земли Германии",
      tone: 'semantic',
    },
    {
      german: "wirken an der Gesetzgebung des Bundes",
      translated: "участвуют в законодательном процессе на федеральном уровне",
      tone: 'semantic',
    },
    {
      german: "durch",
      translated: "через",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:90|sq": [
    {
      german: "Die deutschen Bundesländer",
      translated: "Landet gjermane marrin pjesë",
      tone: 'semantic',
    },
    {
      german: "wirken an der Gesetzgebung des Bundes",
      translated: "në legjislacionin federal",
      tone: 'semantic',
    },
    {
      german: "mit",
      translated: "nëpërmjet",
      tone: 'semantic',
    },
    {
      german: "durch",
      translated: "…",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:90|sr": [
    {
      german: "Die deutschen Bundesländer",
      translated: "Nemačke savezne",
      tone: 'semantic',
    },
    {
      german: "wirken an der Gesetzgebung des Bundes",
      translated: "učestvuju u saveznom zakonodavstvu",
      tone: 'semantic',
    },
    {
      german: "durch",
      translated: "putem",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:90|tr": [
    {
      german: "Die deutschen Bundesländer",
      translated: "Alman eyaletleri",
      tone: 'semantic',
    },
    {
      german: "wirken an der Gesetzgebung des Bundes",
      translated: "federal yasama sürecine",
      tone: 'semantic',
    },
    {
      german: "mit",
      translated: "katılır",
      tone: 'semantic',
    },
    {
      german: "durch",
      translated: "aracılığıyla",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:90|uk": [
    {
      german: "Die deutschen Bundesländer",
      translated: "Федеральні землі Німеччини",
      tone: 'semantic',
    },
    {
      german: "wirken an der Gesetzgebung des Bundes",
      translated: "беруть участь у федеральному законодавстві",
      tone: 'semantic',
    },
    {
      german: "durch",
      translated: "через",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:90|vi": [
    {
      german: "Die deutschen Bundesländer",
      translated: "Các bang Đức",
      tone: 'semantic',
    },
    {
      german: "wirken an der Gesetzgebung des Bundes",
      translated: "tham gia lập pháp liên bang",
      tone: 'semantic',
    },
    {
      german: "mit",
      translated: "thông qua",
      tone: 'semantic',
    },
    {
      german: "durch",
      translated: "…",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:91|ar": [
    {
      german: "In Deutschland",
      translated: "في ألمانيا",
      tone: 'semantic',
    },
    {
      german: "ein Regierungswechsel",
      translated: "تغيير الحكومة",
      tone: 'semantic',
    },
    {
      german: "in einem Bundesland",
      translated: "في إحدى الولايات الاتحادية",
      tone: 'semantic',
    },
    {
      german: "Auswirkungen auf die Bundespolitik",
      translated: "على السياسة الاتحادية",
      tone: 'semantic',
    },
    {
      german: "Das Regieren wird",
      translated: "يصبح الحكم",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:91|bg": [
    {
      german: "In Deutschland",
      translated: "германска",
      tone: 'semantic',
    },
    {
      german: "ein Regierungswechsel",
      translated: "Смяна на правителството",
      tone: 'semantic',
    },
    {
      german: "in einem Bundesland",
      translated: "провинция",
      tone: 'semantic',
    },
    {
      german: "Auswirkungen auf die Bundespolitik",
      translated: "може да повлияе на федералната политика",
      tone: 'semantic',
    },
    {
      german: "Das Regieren wird",
      translated: "Управлението",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:91|bs": [
    {
      german: "In Deutschland",
      translated: "njemačkoj",
      tone: 'semantic',
    },
    {
      german: "ein Regierungswechsel",
      translated: "Promjena vlade",
      tone: 'semantic',
    },
    {
      german: "in einem Bundesland",
      translated: "saveznoj zemlji",
      tone: 'semantic',
    },
    {
      german: "Auswirkungen auf die Bundespolitik",
      translated: "može utjecati na saveznu politiku",
      tone: 'semantic',
    },
    {
      german: "Das Regieren wird",
      translated: "Upravljanje",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:91|el": [
    {
      german: "ein Regierungswechsel",
      translated: "Μια αλλαγή κυβέρνησης",
      tone: 'semantic',
    },
    {
      german: "in einem Bundesland",
      translated: "σε γερμανικό κρατίδιο",
      tone: 'semantic',
    },
    {
      german: "Auswirkungen auf die Bundespolitik",
      translated: "να επηρεάσει την ομοσπονδιακή πολιτική",
      tone: 'semantic',
    },
    {
      german: "Das Regieren wird",
      translated: "Η διακυβέρνηση …",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:91|en": [
    {
      german: "In Deutschland",
      translated: "In Germany",
      tone: 'semantic',
    },
    {
      german: "ein Regierungswechsel",
      translated: "a change of government",
      tone: 'semantic',
    },
    {
      german: "in einem Bundesland",
      translated: "in a federal state",
      tone: 'semantic',
    },
    {
      german: "Auswirkungen auf die Bundespolitik",
      translated: "can have an impact on federal politics",
      tone: 'semantic',
    },
    {
      german: "Das Regieren wird",
      translated: "Governing becomes",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:91|es": [
    {
      german: "In Deutschland",
      translated: "En Alemania",
      tone: 'semantic',
    },
    {
      german: "ein Regierungswechsel",
      translated: "un cambio de gobierno",
      tone: 'semantic',
    },
    {
      german: "in einem Bundesland",
      translated: "en un estado federado",
      tone: 'semantic',
    },
    {
      german: "Auswirkungen auf die Bundespolitik",
      translated: "puede afectar a la política federal",
      tone: 'semantic',
    },
    {
      german: "Das Regieren wird",
      translated: "Gobernar se vuelve",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:91|fa": [
    {
      german: "In Deutschland",
      translated: "در یک ایالت آلمان",
      tone: 'semantic',
    },
    {
      german: "ein Regierungswechsel",
      translated: "تغییر دولت",
      tone: 'semantic',
    },
    {
      german: "Auswirkungen auf die Bundespolitik",
      translated: "بر سیاست فدرال اثر بگذارد",
      tone: 'semantic',
    },
    {
      german: "Das Regieren wird",
      translated: "حکومت کردن …",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:91|fr": [
    {
      german: "In Deutschland",
      translated: "En Allemagne",
      tone: 'semantic',
    },
    {
      german: "ein Regierungswechsel",
      translated: "un changement de gouvernement",
      tone: 'semantic',
    },
    {
      german: "in einem Bundesland",
      translated: "dans un Land",
      tone: 'semantic',
    },
    {
      german: "Auswirkungen auf die Bundespolitik",
      translated: "influencer la politique fédérale",
      tone: 'semantic',
    },
    {
      german: "Das Regieren wird",
      translated: "Gouverner devient",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:91|hr": [
    {
      german: "In Deutschland",
      translated: "njemačkoj",
      tone: 'semantic',
    },
    {
      german: "ein Regierungswechsel",
      translated: "Promjena vlade",
      tone: 'semantic',
    },
    {
      german: "in einem Bundesland",
      translated: "saveznoj zemlji",
      tone: 'semantic',
    },
    {
      german: "Auswirkungen auf die Bundespolitik",
      translated: "može utjecati na saveznu politiku",
      tone: 'semantic',
    },
    {
      german: "Das Regieren wird",
      translated: "Upravljanje …",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:91|it": [
    {
      german: "ein Regierungswechsel",
      translated: "Un cambio di governo",
      tone: 'semantic',
    },
    {
      german: "in einem Bundesland",
      translated: "in un Land tedesco",
      tone: 'semantic',
    },
    {
      german: "Auswirkungen auf die Bundespolitik",
      translated: "influenzare la politica federale",
      tone: 'semantic',
    },
    {
      german: "Das Regieren wird",
      translated: "Governare",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:91|kmr": [
    {
      german: "In Deutschland",
      translated: "Li Almanyayê",
      tone: 'semantic',
    },
    {
      german: "ein Regierungswechsel",
      translated: "guhertina hukûmetê",
      tone: 'semantic',
    },
    {
      german: "in einem Bundesland",
      translated: "di eyaletekê de",
      tone: 'semantic',
    },
    {
      german: "Auswirkungen auf die Bundespolitik",
      translated: "bandorê li siyaseta federal bike",
      tone: 'semantic',
    },
    {
      german: "Das Regieren wird",
      translated: "Rêvebirin",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:91|pl": [
    {
      german: "In Deutschland",
      translated: "W Niemczech",
      tone: 'semantic',
    },
    {
      german: "ein Regierungswechsel",
      translated: "zmiana rządu",
      tone: 'semantic',
    },
    {
      german: "in einem Bundesland",
      translated: "w kraju związkowym",
      tone: 'semantic',
    },
    {
      german: "Auswirkungen auf die Bundespolitik",
      translated: "może wpływać na politykę federalną",
      tone: 'semantic',
    },
    {
      german: "Das Regieren wird",
      translated: "Rządzenie",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:91|prs": [
    {
      german: "In Deutschland",
      translated: "در یک ایالت آلمان",
      tone: 'semantic',
    },
    {
      german: "ein Regierungswechsel",
      translated: "تغییر دولت",
      tone: 'semantic',
    },
    {
      german: "Auswirkungen auf die Bundespolitik",
      translated: "بر سیاست فدرال اثر بگذارد",
      tone: 'semantic',
    },
    {
      german: "Das Regieren wird",
      translated: "حکومت کردن …",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:91|ro": [
    {
      german: "In Deutschland",
      translated: "german",
      tone: 'semantic',
    },
    {
      german: "ein Regierungswechsel",
      translated: "O schimbare de guvern",
      tone: 'semantic',
    },
    {
      german: "in einem Bundesland",
      translated: "într-un land",
      tone: 'semantic',
    },
    {
      german: "Auswirkungen auf die Bundespolitik",
      translated: "poate influența politica federală",
      tone: 'semantic',
    },
    {
      german: "Das Regieren wird",
      translated: "Guvernarea …",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:91|ru": [
    {
      german: "In Deutschland",
      translated: "В Германии",
      tone: 'semantic',
    },
    {
      german: "ein Regierungswechsel",
      translated: "смена правительства",
      tone: 'semantic',
    },
    {
      german: "in einem Bundesland",
      translated: "в одной из федеральных земель",
      tone: 'semantic',
    },
    {
      german: "Auswirkungen auf die Bundespolitik",
      translated: "может влиять на федеральную политику",
      tone: 'semantic',
    },
    {
      german: "Das Regieren wird",
      translated: "Управление страной становится",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:91|sq": [
    {
      german: "In Deutschland",
      translated: "gjerman",
      tone: 'semantic',
    },
    {
      german: "ein Regierungswechsel",
      translated: "Një ndryshim qeverie",
      tone: 'semantic',
    },
    {
      german: "in einem Bundesland",
      translated: "një land",
      tone: 'semantic',
    },
    {
      german: "Auswirkungen auf die Bundespolitik",
      translated: "mund të ndikojë politikën federale",
      tone: 'semantic',
    },
    {
      german: "Das Regieren wird",
      translated: "Qeverisja",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:91|sr": [
    {
      german: "In Deutschland",
      translated: "nemačkoj",
      tone: 'semantic',
    },
    {
      german: "ein Regierungswechsel",
      translated: "Promena vlade",
      tone: 'semantic',
    },
    {
      german: "in einem Bundesland",
      translated: "saveznoj",
      tone: 'semantic',
    },
    {
      german: "Auswirkungen auf die Bundespolitik",
      translated: "može uticati na saveznu politiku",
      tone: 'semantic',
    },
    {
      german: "Das Regieren wird",
      translated: "Upravljanje",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:91|tr": [
    {
      german: "In Deutschland",
      translated: "Almanya'da",
      tone: 'semantic',
    },
    {
      german: "ein Regierungswechsel",
      translated: "hükümet değişikliği",
      tone: 'semantic',
    },
    {
      german: "in einem Bundesland",
      translated: "bir eyalette",
      tone: 'semantic',
    },
    {
      german: "Auswirkungen auf die Bundespolitik",
      translated: "federal siyaseti etkileyebilir",
      tone: 'semantic',
    },
    {
      german: "Das Regieren wird",
      translated: "Yönetmek",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:91|uk": [
    {
      german: "In Deutschland",
      translated: "У Німеччині",
      tone: 'semantic',
    },
    {
      german: "ein Regierungswechsel",
      translated: "зміна уряду",
      tone: 'semantic',
    },
    {
      german: "in einem Bundesland",
      translated: "в одній федеральній землі",
      tone: 'semantic',
    },
    {
      german: "Auswirkungen auf die Bundespolitik",
      translated: "може вплинути на федеральну політику",
      tone: 'semantic',
    },
    {
      german: "Das Regieren wird",
      translated: "Керувати стає",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:91|vi": [
    {
      german: "In Deutschland",
      translated: "Đức",
      tone: 'semantic',
    },
    {
      german: "ein Regierungswechsel",
      translated: "Một sự thay đổi chính phủ",
      tone: 'semantic',
    },
    {
      german: "in einem Bundesland",
      translated: "ở một bang",
      tone: 'semantic',
    },
    {
      german: "Auswirkungen auf die Bundespolitik",
      translated: "ảnh hưởng đến chính trị liên bang",
      tone: 'semantic',
    },
    {
      german: "Das Regieren wird",
      translated: "Việc điều hành",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:92|ar": [
    {
      german: "Was bedeutet",
      translated: "ماذا",
      tone: 'semantic',
    },
    {
      german: "die Abkürzung",
      translated: "الاختصار",
      tone: 'semantic',
    },
    {
      german: "CSU",
      translated: "CSU",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "في ألمانيا",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:92|bg": [
    {
      german: "Was bedeutet",
      translated: "Какво означава",
      tone: 'semantic',
    },
    {
      german: "die Abkürzung",
      translated: "съкращението",
      tone: 'semantic',
    },
    {
      german: "CSU",
      translated: "CSU",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "в Германия",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:92|bs": [
    {
      german: "Was bedeutet",
      translated: "Što",
      tone: 'semantic',
    },
    {
      german: "die Abkürzung",
      translated: "kratica",
      tone: 'semantic',
    },
    {
      german: "CSU",
      translated: "CSU",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "u Njemačkoj",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:92|el": [
    {
      german: "Was bedeutet",
      translated: "Τι σημαίνει",
      tone: 'semantic',
    },
    {
      german: "die Abkürzung",
      translated: "η συντομογραφία",
      tone: 'semantic',
    },
    {
      german: "CSU",
      translated: "CSU",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "στη Γερμανία",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:92|en": [
    {
      german: "Was bedeutet",
      translated: "What does",
      tone: 'semantic',
    },
    {
      german: "die Abkürzung",
      translated: "the abbreviation",
      tone: 'semantic',
    },
    {
      german: "CSU",
      translated: "CSU",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "in Germany?",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:92|es": [
    {
      german: "Was bedeutet",
      translated: "¿Qué significa",
      tone: 'semantic',
    },
    {
      german: "die Abkürzung",
      translated: "la abreviatura",
      tone: 'semantic',
    },
    {
      german: "CSU",
      translated: "CSU",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "en Alemania",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:92|fa": [
    {
      german: "Was bedeutet",
      translated: "به چه معناست",
      tone: 'semantic',
    },
    {
      german: "die Abkürzung",
      translated: "مخفف",
      tone: 'semantic',
    },
    {
      german: "CSU",
      translated: "CSU",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "در آلمان",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:92|fr": [
    {
      german: "Was bedeutet",
      translated: "Que signifie",
      tone: 'semantic',
    },
    {
      german: "die Abkürzung",
      translated: "l’abréviation",
      tone: 'semantic',
    },
    {
      german: "CSU",
      translated: "CSU",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "en Allemagne",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:92|hr": [
    {
      german: "Was bedeutet",
      translated: "znači",
      tone: 'semantic',
    },
    {
      german: "die Abkürzung",
      translated: "kratica",
      tone: 'semantic',
    },
    {
      german: "CSU",
      translated: "CSU",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "u Njemačkoj",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:92|it": [
    {
      german: "Was bedeutet",
      translated: "Che cosa significa",
      tone: 'semantic',
    },
    {
      german: "die Abkürzung",
      translated: "l’abbreviazione",
      tone: 'semantic',
    },
    {
      german: "CSU",
      translated: "CSU",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "in Germania",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:92|kmr": [
    {
      german: "Was bedeutet",
      translated: "tê çi wateyê",
      tone: 'semantic',
    },
    {
      german: "die Abkürzung",
      translated: "Kurteya",
      tone: 'semantic',
    },
    {
      german: "CSU",
      translated: "CSU",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "li Almanyayê",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:92|pl": [
    {
      german: "Was bedeutet",
      translated: "Co oznacza",
      tone: 'semantic',
    },
    {
      german: "die Abkürzung",
      translated: "skrót",
      tone: 'semantic',
    },
    {
      german: "CSU",
      translated: "CSU",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "w Niemczech",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:92|prs": [
    {
      german: "Was bedeutet",
      translated: "به چه معناست",
      tone: 'semantic',
    },
    {
      german: "die Abkürzung",
      translated: "مخفف",
      tone: 'semantic',
    },
    {
      german: "CSU",
      translated: "CSU",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "در آلمان",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:92|ro": [
    {
      german: "Was bedeutet",
      translated: "Ce înseamnă",
      tone: 'semantic',
    },
    {
      german: "die Abkürzung",
      translated: "abrevierea",
      tone: 'semantic',
    },
    {
      german: "CSU",
      translated: "CSU",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "în Germania",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:92|ru": [
    {
      german: "Was bedeutet",
      translated: "Что означает",
      tone: 'semantic',
    },
    {
      german: "die Abkürzung",
      translated: "аббревиатура",
      tone: 'semantic',
    },
    {
      german: "CSU",
      translated: "CSU",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "в Германии",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:92|sq": [
    {
      german: "Was bedeutet",
      translated: "Çfarë do të thotë",
      tone: 'semantic',
    },
    {
      german: "die Abkürzung",
      translated: "shkurtesa",
      tone: 'semantic',
    },
    {
      german: "CSU",
      translated: "CSU",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "në Gjermani",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:92|sr": [
    {
      german: "Was bedeutet",
      translated: "Šta",
      tone: 'semantic',
    },
    {
      german: "die Abkürzung",
      translated: "kratica",
      tone: 'semantic',
    },
    {
      german: "CSU",
      translated: "CSU",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "u Nemačkoj",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:92|tr": [
    {
      german: "Was bedeutet",
      translated: "ne anlama gelir",
      tone: 'semantic',
    },
    {
      german: "die Abkürzung",
      translated: "kısaltması",
      tone: 'semantic',
    },
    {
      german: "CSU",
      translated: "CSU",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "Almanya'da",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:92|uk": [
    {
      german: "Was bedeutet",
      translated: "Що означає",
      tone: 'semantic',
    },
    {
      german: "die Abkürzung",
      translated: "абревіатура",
      tone: 'semantic',
    },
    {
      german: "CSU",
      translated: "CSU",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "в Німеччині",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:92|vi": [
    {
      german: "Was bedeutet",
      translated: "có nghĩa là gì",
      tone: 'semantic',
    },
    {
      german: "die Abkürzung",
      translated: "Chữ viết tắt",
      tone: 'semantic',
    },
    {
      german: "CSU",
      translated: "CSU",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "ở Đức",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:93|ar": [
    {
      german: "Je mehr",
      translated: "كلما",
      tone: 'semantic',
    },
    {
      german: "Zweitstimmen",
      translated: "«الأصوات الثانية»",
      tone: 'semantic',
    },
    {
      german: "eine Partei",
      translated: "حزب",
      tone: 'semantic',
    },
    {
      german: "bei einer Bundestagswahl",
      translated: "في انتخابات البوندستاغ",
      tone: 'semantic',
    },
    {
      german: "bekommt",
      translated: "حصل",
      tone: 'semantic',
    },
    {
      german: "desto",
      translated: "…",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:93|bg": [
    {
      german: "Je mehr",
      translated: "Колкото повече",
      tone: 'semantic',
    },
    {
      german: "Zweitstimmen",
      translated: "„втори гласове“ (Zweitstimmen)",
      tone: 'semantic',
    },
    {
      german: "eine Partei",
      translated: "една партия",
      tone: 'semantic',
    },
    {
      german: "bei einer Bundestagswahl",
      translated: "на изборите за Бундестаг",
      tone: 'semantic',
    },
    {
      german: "bekommt",
      translated: "получи",
      tone: 'semantic',
    },
    {
      german: "desto",
      translated: "толкова …",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:93|bs": [
    {
      german: "Je mehr",
      translated: "Što više",
      tone: 'semantic',
    },
    {
      german: "Zweitstimmen",
      translated: "„drugih glasova“ (Zweitstimmen)",
      tone: 'semantic',
    },
    {
      german: "eine Partei",
      translated: "stranka",
      tone: 'semantic',
    },
    {
      german: "bei einer Bundestagswahl",
      translated: "na izborima za Bundestag",
      tone: 'semantic',
    },
    {
      german: "bekommt",
      translated: "dobije",
      tone: 'semantic',
    },
    {
      german: "desto",
      translated: "to …",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:93|el": [
    {
      german: "Je mehr",
      translated: "Όσο περισσότερες",
      tone: 'semantic',
    },
    {
      german: "Zweitstimmen",
      translated: "«δεύτερες ψήφους» (Zweitstimmen)",
      tone: 'semantic',
    },
    {
      german: "eine Partei",
      translated: "ένα κόμμα",
      tone: 'semantic',
    },
    {
      german: "bei einer Bundestagswahl",
      translated: "στις εκλογές του Bundestag",
      tone: 'semantic',
    },
    {
      german: "bekommt",
      translated: "λάβει",
      tone: 'semantic',
    },
    {
      german: "desto",
      translated: "τόσο",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:93|en": [
    {
      german: "Je mehr",
      translated: "The more",
      tone: 'semantic',
    },
    {
      german: "Zweitstimmen",
      translated: "second votes",
      tone: 'semantic',
    },
    {
      german: "eine Partei",
      translated: "a party",
      tone: 'semantic',
    },
    {
      german: "bei einer Bundestagswahl",
      translated: "in a federal election",
      tone: 'semantic',
    },
    {
      german: "bekommt",
      translated: "gets",
      tone: 'semantic',
    },
    {
      german: "desto",
      translated: "the …",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:93|es": [
    {
      german: "Je mehr",
      translated: "Cuantos más",
      tone: 'semantic',
    },
    {
      german: "Zweitstimmen",
      translated: "«segundos votos»",
      tone: 'semantic',
    },
    {
      german: "eine Partei",
      translated: "un partido",
      tone: 'semantic',
    },
    {
      german: "bei einer Bundestagswahl",
      translated: "en unas elecciones federales",
      tone: 'semantic',
    },
    {
      german: "bekommt",
      translated: "obtiene",
      tone: 'semantic',
    },
    {
      german: "desto",
      translated: "…",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:93|fa": [
    {
      german: "Je mehr",
      translated: "هرچه",
      tone: 'semantic',
    },
    {
      german: "Zweitstimmen",
      translated: "«رأی دوم» (Zweitstimmen)",
      tone: 'semantic',
    },
    {
      german: "eine Partei",
      translated: "یک حزب",
      tone: 'semantic',
    },
    {
      german: "bei einer Bundestagswahl",
      translated: "در انتخابات بوندستاگ",
      tone: 'semantic',
    },
    {
      german: "bekommt",
      translated: "به دست آورد",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:93|fr": [
    {
      german: "Je mehr",
      translated: "Plus",
      tone: 'semantic',
    },
    {
      german: "Zweitstimmen",
      translated: "« secondes voix » (Zweitstimmen)",
      tone: 'semantic',
    },
    {
      german: "eine Partei",
      translated: "un parti",
      tone: 'semantic',
    },
    {
      german: "bei einer Bundestagswahl",
      translated: "aux élections du Bundestag",
      tone: 'semantic',
    },
    {
      german: "bekommt",
      translated: "obtient de",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:93|hr": [
    {
      german: "Je mehr",
      translated: "Što više",
      tone: 'semantic',
    },
    {
      german: "Zweitstimmen",
      translated: "„drugih glasova“",
      tone: 'semantic',
    },
    {
      german: "eine Partei",
      translated: "stranka",
      tone: 'semantic',
    },
    {
      german: "bei einer Bundestagswahl",
      translated: "na izborima za Bundestag",
      tone: 'semantic',
    },
    {
      german: "bekommt",
      translated: "dobije",
      tone: 'semantic',
    },
    {
      german: "desto",
      translated: "to",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:93|it": [
    {
      german: "Je mehr",
      translated: "Più",
      tone: 'semantic',
    },
    {
      german: "Zweitstimmen",
      translated: "«secondi voti» (Zweitstimmen)",
      tone: 'semantic',
    },
    {
      german: "eine Partei",
      translated: "un partito",
      tone: 'semantic',
    },
    {
      german: "bei einer Bundestagswahl",
      translated: "alle elezioni del Bundestag",
      tone: 'semantic',
    },
    {
      german: "bekommt",
      translated: "riceve",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:93|kmr": [
    {
      german: "Je mehr",
      translated: "Her",
      tone: 'semantic',
    },
    {
      german: "Zweitstimmen",
      translated: "di hilbijartina",
      tone: 'semantic',
    },
    {
      german: "eine Partei",
      translated: "partiyek",
      tone: 'semantic',
    },
    {
      german: "bei einer Bundestagswahl",
      translated: "Bundestagê de",
      tone: 'semantic',
    },
    {
      german: "bekommt",
      translated: "zêdetir",
      tone: 'semantic',
    },
    {
      german: "desto",
      translated: "bistîne",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:93|pl": [
    {
      german: "Je mehr",
      translated: "Im więcej",
      tone: 'semantic',
    },
    {
      german: "Zweitstimmen",
      translated: "„drugich głosów” (Zweitstimmen)",
      tone: 'semantic',
    },
    {
      german: "eine Partei",
      translated: "partia",
      tone: 'semantic',
    },
    {
      german: "bei einer Bundestagswahl",
      translated: "w wyborach do Bundestagu",
      tone: 'semantic',
    },
    {
      german: "bekommt",
      translated: "otrzyma",
      tone: 'semantic',
    },
    {
      german: "desto",
      translated: "tym …",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:93|prs": [
    {
      german: "Je mehr",
      translated: "هرچه",
      tone: 'semantic',
    },
    {
      german: "Zweitstimmen",
      translated: "«رأی دوم»",
      tone: 'semantic',
    },
    {
      german: "eine Partei",
      translated: "یک حزب",
      tone: 'semantic',
    },
    {
      german: "bei einer Bundestagswahl",
      translated: "در انتخابات بوندستاگ",
      tone: 'semantic',
    },
    {
      german: "bekommt",
      translated: "به دست آورد",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:93|ro": [
    {
      german: "Je mehr",
      translated: "Cu cât",
      tone: 'semantic',
    },
    {
      german: "Zweitstimmen",
      translated: "„voturi secunde”",
      tone: 'semantic',
    },
    {
      german: "eine Partei",
      translated: "un partid",
      tone: 'semantic',
    },
    {
      german: "bei einer Bundestagswahl",
      translated: "la alegerile pentru Bundestag",
      tone: 'semantic',
    },
    {
      german: "bekommt",
      translated: "primește mai multe",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:93|ru": [
    {
      german: "Je mehr",
      translated: "Чем больше",
      tone: 'semantic',
    },
    {
      german: "Zweitstimmen",
      translated: "«вторых голосов»",
      tone: 'semantic',
    },
    {
      german: "eine Partei",
      translated: "партия",
      tone: 'semantic',
    },
    {
      german: "bei einer Bundestagswahl",
      translated: "на выборах в Бундестаг",
      tone: 'semantic',
    },
    {
      german: "bekommt",
      translated: "получает",
      tone: 'semantic',
    },
    {
      german: "desto",
      translated: "тем …",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:93|sq": [
    {
      german: "Je mehr",
      translated: "Sa më shumë",
      tone: 'semantic',
    },
    {
      german: "Zweitstimmen",
      translated: "«vota të dyta»",
      tone: 'semantic',
    },
    {
      german: "eine Partei",
      translated: "një parti",
      tone: 'semantic',
    },
    {
      german: "bei einer Bundestagswahl",
      translated: "në zgjedhjet e Bundestagut",
      tone: 'semantic',
    },
    {
      german: "bekommt",
      translated: "të marrë",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:93|sr": [
    {
      german: "Je mehr",
      translated: "Šta više",
      tone: 'semantic',
    },
    {
      german: "Zweitstimmen",
      translated: "„drugih glasova“",
      tone: 'semantic',
    },
    {
      german: "eine Partei",
      translated: "stranka",
      tone: 'semantic',
    },
    {
      german: "bei einer Bundestagswahl",
      translated: "na izborima za Bundestag",
      tone: 'semantic',
    },
    {
      german: "bekommt",
      translated: "dobije",
      tone: 'semantic',
    },
    {
      german: "desto",
      translated: "to …",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:93|tr": [
    {
      german: "Je mehr",
      translated: "ne kadar çok",
      tone: 'semantic',
    },
    {
      german: "Zweitstimmen",
      translated: "ikinci oy",
      tone: 'semantic',
    },
    {
      german: "eine Partei",
      translated: "Bir parti",
      tone: 'semantic',
    },
    {
      german: "bei einer Bundestagswahl",
      translated: "Federal Meclis seçiminde",
      tone: 'semantic',
    },
    {
      german: "bekommt",
      translated: "alırsa",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:93|uk": [
    {
      german: "Je mehr",
      translated: "Чим більше",
      tone: 'semantic',
    },
    {
      german: "Zweitstimmen",
      translated: "других голосів",
      tone: 'semantic',
    },
    {
      german: "eine Partei",
      translated: "партія",
      tone: 'semantic',
    },
    {
      german: "bei einer Bundestagswahl",
      translated: "на виборах до Бундестагу",
      tone: 'semantic',
    },
    {
      german: "bekommt",
      translated: "отримує",
      tone: 'semantic',
    },
    {
      german: "desto",
      translated: "тим",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:93|vi": [
    {
      german: "Je mehr",
      translated: "càng",
      tone: 'semantic',
    },
    {
      german: "Zweitstimmen",
      translated: "phiếu thứ hai",
      tone: 'semantic',
    },
    {
      german: "eine Partei",
      translated: "Zweitstimmen",
      tone: 'semantic',
    },
    {
      german: "bei einer Bundestagswahl",
      translated: "trong bầu cử Bundestag",
      tone: 'semantic',
    },
    {
      german: "bekommt",
      translated: "nhận được",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:94|ar": [
    {
      german: "Ab welchem Alter",
      translated: "ابتداءً من أي سن",
      tone: 'semantic',
    },
    {
      german: "darf man",
      translated: "يمكن",
      tone: 'semantic',
    },
    {
      german: "an der Wahl zum Deutschen Bundestag",
      translated: "في انتخابات البوندستاغ الألماني",
      tone: 'semantic',
    },
    {
      german: "teilnehmen",
      translated: "المشاركة",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:94|bg": [
    {
      german: "Ab welchem Alter",
      translated: "От каква възраст",
      tone: 'semantic',
    },
    {
      german: "darf man",
      translated: "може",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "в Германия",
      tone: 'semantic',
    },
    {
      german: "an der Wahl zum Deutschen Bundestag",
      translated: "за Бундестаг",
      tone: 'semantic',
    },
    {
      german: "teilnehmen",
      translated: "да се гласува",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:94|bs": [
    {
      german: "Ab welchem Alter",
      translated: "Od koje se dobi",
      tone: 'semantic',
    },
    {
      german: "darf man",
      translated: "može",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "u Njemačkoj",
      tone: 'semantic',
    },
    {
      german: "an der Wahl zum Deutschen Bundestag",
      translated: "na izborima za Bundestag",
      tone: 'semantic',
    },
    {
      german: "teilnehmen",
      translated: "glasovati",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:94|el": [
    {
      german: "Ab welchem Alter",
      translated: "Από ποια ηλικία",
      tone: 'semantic',
    },
    {
      german: "darf man",
      translated: "μπορεί κάποιος",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "στη Γερμανία",
      tone: 'semantic',
    },
    {
      german: "an der Wahl zum Deutschen Bundestag",
      translated: "να ψηφίσει στις εκλογές του Bundestag",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:94|en": [
    {
      german: "Ab welchem Alter",
      translated: "From what age",
      tone: 'semantic',
    },
    {
      german: "darf man",
      translated: "can you",
      tone: 'semantic',
    },
    {
      german: "an der Wahl zum Deutschen Bundestag",
      translated: "in the German Bundestag election",
      tone: 'semantic',
    },
    {
      german: "teilnehmen",
      translated: "vote",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:94|es": [
    {
      german: "Ab welchem Alter",
      translated: "¿A partir de qué edad",
      tone: 'semantic',
    },
    {
      german: "darf man",
      translated: "se puede",
      tone: 'semantic',
    },
    {
      german: "an der Wahl zum Deutschen Bundestag",
      translated: "en las elecciones al Bundestag alemán",
      tone: 'semantic',
    },
    {
      german: "teilnehmen",
      translated: "votar",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:94|fa": [
    {
      german: "Ab welchem Alter",
      translated: "از چه سنی",
      tone: 'semantic',
    },
    {
      german: "darf man",
      translated: "می‌توان",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "بوندستاگ آلمان",
      tone: 'semantic',
    },
    {
      german: "an der Wahl zum Deutschen Bundestag",
      translated: " انتخابات",
      tone: 'semantic',
    },
    {
      german: "teilnehmen",
      translated: "شرکت کرد؟",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:94|fr": [
    {
      german: "Ab welchem Alter",
      translated: "À partir de quel âge",
      tone: 'semantic',
    },
    {
      german: "darf man",
      translated: "peut-on",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "du Bundestag allemand",
      tone: 'semantic',
    },
    {
      german: "an der Wahl zum Deutschen Bundestag",
      translated: "aux élections",
      tone: 'semantic',
    },
    {
      german: "teilnehmen",
      translated: "participer",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:94|hr": [
    {
      german: "Ab welchem Alter",
      translated: "Od koje se dobi",
      tone: 'semantic',
    },
    {
      german: "darf man",
      translated: "može",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "u Njemačkoj",
      tone: 'semantic',
    },
    {
      german: "an der Wahl zum Deutschen Bundestag",
      translated: "na izborima za Bundestag",
      tone: 'semantic',
    },
    {
      german: "teilnehmen",
      translated: "glasovati",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:94|it": [
    {
      german: "Ab welchem Alter",
      translated: "Da quale età",
      tone: 'semantic',
    },
    {
      german: "darf man",
      translated: "si può",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "in Germania",
      tone: 'semantic',
    },
    {
      german: "an der Wahl zum Deutschen Bundestag",
      translated: "alle elezioni del Bundestag",
      tone: 'semantic',
    },
    {
      german: "teilnehmen",
      translated: "votare",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:94|kmr": [
    {
      german: "Ab welchem Alter",
      translated: "Ji kîjan temenê",
      tone: 'semantic',
    },
    {
      german: "darf man",
      translated: "dikare",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "li Almanyayê",
      tone: 'semantic',
    },
    {
      german: "an der Wahl zum Deutschen Bundestag",
      translated: "di hilbijartina Bundestagê de",
      tone: 'semantic',
    },
    {
      german: "teilnehmen",
      translated: "beşdar bibe",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:94|pl": [
    {
      german: "Ab welchem Alter",
      translated: "Od jakiego wieku",
      tone: 'semantic',
    },
    {
      german: "darf man",
      translated: "można",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "w Niemczech",
      tone: 'semantic',
    },
    {
      german: "an der Wahl zum Deutschen Bundestag",
      translated: "w wyborach do Bundestagu",
      tone: 'semantic',
    },
    {
      german: "teilnehmen",
      translated: "głosować",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:94|prs": [
    {
      german: "Ab welchem Alter",
      translated: "از چه سنی",
      tone: 'semantic',
    },
    {
      german: "darf man",
      translated: "می‌توان",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "آلمان",
      tone: 'semantic',
    },
    {
      german: "an der Wahl zum Deutschen Bundestag",
      translated: "انتخابات بوندستاگ",
      tone: 'semantic',
    },
    {
      german: "teilnehmen",
      translated: "شرکت کرد",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:94|ro": [
    {
      german: "Ab welchem Alter",
      translated: "De la ce vârstă",
      tone: 'semantic',
    },
    {
      german: "darf man",
      translated: "se poate",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "în Germania",
      tone: 'semantic',
    },
    {
      german: "an der Wahl zum Deutschen Bundestag",
      translated: "la alegerile pentru Bundestag",
      tone: 'semantic',
    },
    {
      german: "teilnehmen",
      translated: "vota",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:94|ru": [
    {
      german: "Ab welchem Alter",
      translated: "С какого возраста",
      tone: 'semantic',
    },
    {
      german: "darf man",
      translated: "можно",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "в Германии",
      tone: 'semantic',
    },
    {
      german: "an der Wahl zum Deutschen Bundestag",
      translated: "в выборах в Бундестаг",
      tone: 'semantic',
    },
    {
      german: "teilnehmen",
      translated: "участвовать",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:94|sq": [
    {
      german: "Ab welchem Alter",
      translated: "Nga cila moshë",
      tone: 'semantic',
    },
    {
      german: "darf man",
      translated: "mund të",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "në Gjermani",
      tone: 'semantic',
    },
    {
      german: "an der Wahl zum Deutschen Bundestag",
      translated: "zgjedhjet e Bundestagut",
      tone: 'semantic',
    },
    {
      german: "teilnehmen",
      translated: "votohet",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:94|sr": [
    {
      german: "Ab welchem Alter",
      translated: "Od koje se dobi",
      tone: 'semantic',
    },
    {
      german: "darf man",
      translated: "može",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "u Nemačkoj",
      tone: 'semantic',
    },
    {
      german: "an der Wahl zum Deutschen Bundestag",
      translated: "na izborima za Bundestag",
      tone: 'semantic',
    },
    {
      german: "teilnehmen",
      translated: "glasati",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:94|tr": [
    {
      german: "Ab welchem Alter",
      translated: "kaç yaşından itibaren",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "Almanya'da",
      tone: 'semantic',
    },
    {
      german: "an der Wahl zum Deutschen Bundestag",
      translated: "Federal Meclis seçimlerine",
      tone: 'semantic',
    },
    {
      german: "teilnehmen",
      translated: "katılınabilir?",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:94|uk": [
    {
      german: "Ab welchem Alter",
      translated: "З якого віку",
      tone: 'semantic',
    },
    {
      german: "darf man",
      translated: " можна",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "в Німеччині",
      tone: 'semantic',
    },
    {
      german: "an der Wahl zum Deutschen Bundestag",
      translated: "у виборах до Бундестагу",
      tone: 'semantic',
    },
    {
      german: "teilnehmen",
      translated: "брати участь",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:94|vi": [
    {
      german: "Ab welchem Alter",
      translated: "Từ bao nhiêu tuổi",
      tone: 'semantic',
    },
    {
      german: "darf man",
      translated: "có thể",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "ở Đức",
      tone: 'semantic',
    },
    {
      german: "an der Wahl zum Deutschen Bundestag",
      translated: "bầu cử Bundestag",
      tone: 'semantic',
    },
    {
      german: "teilnehmen",
      translated: "bỏ phiếu",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:95|ar": [
    {
      german: "Was gilt",
      translated: "ما",
      tone: 'semantic',
    },
    {
      german: "für die meisten Kinder",
      translated: "ينطبق على معظم الأطفال",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "في ألمانيا",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:95|bg": [
    {
      german: "Was gilt",
      translated: "Какво важи",
      tone: 'semantic',
    },
    {
      german: "für die meisten Kinder",
      translated: "за повечето деца",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "в Германия",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:95|bs": [
    {
      german: "Was gilt",
      translated: "Što",
      tone: 'semantic',
    },
    {
      german: "für die meisten Kinder",
      translated: "vrijedi za većinu djece",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "u Njemačkoj",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:95|el": [
    {
      german: "Was gilt",
      translated: "Τι ισχύει για",
      tone: 'semantic',
    },
    {
      german: "für die meisten Kinder",
      translated: "τα περισσότερα παιδιά",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "στη Γερμανία",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:95|en": [
    {
      german: "Was gilt",
      translated: "What applies",
      tone: 'semantic',
    },
    {
      german: "für die meisten Kinder",
      translated: "to most children",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "in Germany",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:95|es": [
    {
      german: "Was gilt",
      translated: "¿Qué se aplica",
      tone: 'semantic',
    },
    {
      german: "für die meisten Kinder",
      translated: "a la mayoría de los niños",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "en Alemania",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:95|fa": [
    {
      german: "Was gilt",
      translated: "کدام مورد",
      tone: 'semantic',
    },
    {
      german: "für die meisten Kinder",
      translated: "برای بیشتر کودکان",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "در آلمان",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:95|fr": [
    {
      german: "Was gilt",
      translated: "Qu’est-ce qui",
      tone: 'semantic',
    },
    {
      german: "für die meisten Kinder",
      translated: "s’applique à la plupart des enfants",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "en Allemagne",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:95|hr": [
    {
      german: "Was gilt",
      translated: "Što",
      tone: 'semantic',
    },
    {
      german: "für die meisten Kinder",
      translated: "vrijedi za većinu djece",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "u Njemačkoj",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:95|it": [
    {
      german: "Was gilt",
      translated: "Che cosa vale",
      tone: 'semantic',
    },
    {
      german: "für die meisten Kinder",
      translated: "per la maggior parte dei bambini",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "in Germania",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:95|kmr": [
    {
      german: "Was gilt",
      translated: "Ji bo piraniya",
      tone: 'semantic',
    },
    {
      german: "für die meisten Kinder",
      translated: "zarokan li Almanyayê çi",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "derbasdar e?",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:95|pl": [
    {
      german: "Was gilt",
      translated: "Co dotyczy",
      tone: 'semantic',
    },
    {
      german: "für die meisten Kinder",
      translated: "większości dzieci w",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "Niemczech",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:95|prs": [
    {
      german: "Was gilt",
      translated: "کدام مورد",
      tone: 'semantic',
    },
    {
      german: "für die meisten Kinder",
      translated: "برای بیشتر کودکان",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "در آلمان",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:95|ro": [
    {
      german: "Was gilt",
      translated: "Ce se aplică",
      tone: 'semantic',
    },
    {
      german: "für die meisten Kinder",
      translated: "majorității copiilor din Germania",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:95|ru": [
    {
      german: "Was gilt",
      translated: "Что действует",
      tone: 'semantic',
    },
    {
      german: "für die meisten Kinder",
      translated: "для большинства детей",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "в Германии",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:95|sq": [
    {
      german: "Was gilt",
      translated: "Çfarë vlen",
      tone: 'semantic',
    },
    {
      german: "für die meisten Kinder",
      translated: "për shumicën e fëmijëve",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "në Gjermani",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:95|sr": [
    {
      german: "Was gilt",
      translated: "Šta",
      tone: 'semantic',
    },
    {
      german: "für die meisten Kinder",
      translated: "vrijedi za većinu dece",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "u Nemačkoj",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:95|tr": [
    {
      german: "Was gilt",
      translated: "geçerlidir",
      tone: 'semantic',
    },
    {
      german: "für die meisten Kinder",
      translated: "çocukların çoğu için",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "Almanya'daki",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:95|uk": [
    {
      german: "Was gilt",
      translated: "Що стосується",
      tone: 'semantic',
    },
    {
      german: "für die meisten Kinder",
      translated: "більшості дітей",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "у Німеччині",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:95|vi": [
    {
      german: "Was gilt",
      translated: "Điều nào đúng",
      tone: 'semantic',
    },
    {
      german: "für die meisten Kinder",
      translated: "với phần lớn trẻ em",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "ở Đức",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:96|ar": [
    {
      german: "Wie kann jemand",
      translated: "كيف يمكن",
      tone: 'semantic',
    },
    {
      german: "der den Holocaust leugnet",
      translated: "شخص ينكر الهولوكوست",
      tone: 'semantic',
    },
    {
      german: "bestraft werden",
      translated: "معاقبة",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:96|bg": [
    {
      german: "Wie kann jemand",
      translated: "Как може да бъде",
      tone: 'semantic',
    },
    {
      german: "der den Holocaust leugnet",
      translated: "отрича Холокоста",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:96|bs": [
    {
      german: "Wie kann jemand",
      translated: "Kako može biti",
      tone: 'semantic',
    },
    {
      german: "der den Holocaust leugnet",
      translated: "osoba koja poriče Holokaust",
      tone: 'semantic',
    },
    {
      german: "bestraft werden",
      translated: "kažnjena",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:96|el": [
    {
      german: "Wie kann jemand",
      translated: "Πώς μπορεί",
      tone: 'semantic',
    },
    {
      german: "der den Holocaust leugnet",
      translated: "που αρνείται το Ολοκαύτωμα",
      tone: 'semantic',
    },
    {
      german: "bestraft werden",
      translated: "να τιμωρηθεί",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:96|en": [
    {
      german: "Wie kann jemand",
      translated: "How can someone",
      tone: 'semantic',
    },
    {
      german: "der den Holocaust leugnet",
      translated: "who denies the Holocaust",
      tone: 'semantic',
    },
    {
      german: "bestraft werden",
      translated: "be punished",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:96|es": [
    {
      german: "Wie kann jemand",
      translated: "¿Cómo puede ser",
      tone: 'semantic',
    },
    {
      german: "der den Holocaust leugnet",
      translated: "una persona que niega el Holocausto",
      tone: 'semantic',
    },
    {
      german: "bestraft werden",
      translated: "castigada",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:96|fa": [
    {
      german: "Wie kann jemand",
      translated: "فردی که",
      tone: 'semantic',
    },
    {
      german: "der den Holocaust leugnet",
      translated: "هولوکاست را انکار کند",
      tone: 'semantic',
    },
    {
      german: "bestraft werden",
      translated: "مجازات شود",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:96|fr": [
    {
      german: "Wie kann jemand",
      translated: "Comment une personne",
      tone: 'semantic',
    },
    {
      german: "der den Holocaust leugnet",
      translated: "qui nie l’Holocauste",
      tone: 'semantic',
    },
    {
      german: "bestraft werden",
      translated: "peut-elle être punie",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:96|hr": [
    {
      german: "Wie kann jemand",
      translated: "Kako može biti",
      tone: 'semantic',
    },
    {
      german: "der den Holocaust leugnet",
      translated: "koja poriče Holokaust",
      tone: 'semantic',
    },
    {
      german: "bestraft werden",
      translated: "kažnjena",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:96|it": [
    {
      german: "Wie kann jemand",
      translated: "Come può essere punita una persona",
      tone: 'semantic',
    },
    {
      german: "der den Holocaust leugnet",
      translated: "che nega l’Olocausto",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:96|kmr": [
    {
      german: "Wie kann jemand",
      translated: "Kesek ku",
      tone: 'semantic',
    },
    {
      german: "der den Holocaust leugnet",
      translated: "Holocaust înkar dike",
      tone: 'semantic',
    },
    {
      german: "bestraft werden",
      translated: "cezakirin?",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:96|pl": [
    {
      german: "Wie kann jemand",
      translated: "Jak może",
      tone: 'semantic',
    },
    {
      german: "der den Holocaust leugnet",
      translated: "która neguje Holokaust",
      tone: 'semantic',
    },
    {
      german: "bestraft werden",
      translated: "zostać ukarana",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:96|prs": [
    {
      german: "Wie kann jemand",
      translated: "فردی که",
      tone: 'semantic',
    },
    {
      german: "der den Holocaust leugnet",
      translated: "هولوکاست را انکار کند",
      tone: 'semantic',
    },
    {
      german: "bestraft werden",
      translated: "مجازات شود",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:96|ro": [
    {
      german: "Wie kann jemand",
      translated: "Cum poate fi",
      tone: 'semantic',
    },
    {
      german: "der den Holocaust leugnet",
      translated: "o persoană care neagă Holocaustul",
      tone: 'semantic',
    },
    {
      german: "bestraft werden",
      translated: "pedepsită",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:96|ru": [
    {
      german: "Wie kann jemand",
      translated: "Как может быть",
      tone: 'semantic',
    },
    {
      german: "der den Holocaust leugnet",
      translated: "человек, отрицающий Холокост",
      tone: 'semantic',
    },
    {
      german: "bestraft werden",
      translated: "наказан",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:96|sq": [
    {
      german: "Wie kann jemand",
      translated: "Si mund",
      tone: 'semantic',
    },
    {
      german: "der den Holocaust leugnet",
      translated: "një person që mohon Holokaustin",
      tone: 'semantic',
    },
    {
      german: "bestraft werden",
      translated: "të dënohet",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:96|sr": [
    {
      german: "Wie kann jemand",
      translated: "Kako može biti",
      tone: 'semantic',
    },
    {
      german: "der den Holocaust leugnet",
      translated: "osoba koja poriče Holokaust",
      tone: 'semantic',
    },
    {
      german: "bestraft werden",
      translated: "kažnjena",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:96|tr": [
    {
      german: "Wie kann jemand",
      translated: "biri",
      tone: 'semantic',
    },
    {
      german: "der den Holocaust leugnet",
      translated: "Holokost'u inkâr eden",
      tone: 'semantic',
    },
    {
      german: "bestraft werden",
      translated: "nasıl cezalandırılabilir?",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:96|uk": [
    {
      german: "Wie kann jemand",
      translated: "Як може бути",
      tone: 'semantic',
    },
    {
      german: "der den Holocaust leugnet",
      translated: "яка заперечує Голокост",
      tone: 'semantic',
    },
    {
      german: "bestraft werden",
      translated: "покарана",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:96|vi": [
    {
      german: "Wie kann jemand",
      translated: "Một người",
      tone: 'semantic',
    },
    {
      german: "der den Holocaust leugnet",
      translated: "phủ nhận Holocaust",
      tone: 'semantic',
    },
    {
      german: "bestraft werden",
      translated: "bị xử phạt",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:97|ar": [
    {
      german: "Was",
      translated: "ما الذي",
      tone: 'semantic',
    },
    {
      german: "bezahlt man",
      translated: "يدفعه",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "في ألمانيا",
      tone: 'semantic',
    },
    {
      german: "automatisch",
      translated: "تلقائيًا",
      tone: 'semantic',
    },
    {
      german: "wenn man",
      translated: "عندما يكون",
      tone: 'semantic',
    },
    {
      german: "fest angestellt",
      translated: "موظفًا بعقد عمل ثابت",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "؟",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:97|bg": [
    {
      german: "Was",
      translated: "Какво",
      tone: 'semantic',
    },
    {
      german: "bezahlt man",
      translated: "плаща човек",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "в Германия",
      tone: 'semantic',
    },
    {
      german: "automatisch",
      translated: "автоматично",
      tone: 'semantic',
    },
    {
      german: "fest angestellt",
      translated: "с постоянен трудов договор",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:97|bs": [
    {
      german: "Was",
      translated: "Šta",
      tone: 'semantic',
    },
    {
      german: "bezahlt man",
      translated: "plaća",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "u Njemačkoj",
      tone: 'semantic',
    },
    {
      german: "automatisch",
      translated: "automatski",
      tone: 'semantic',
    },
    {
      german: "wenn man",
      translated: "osoba koja je",
      tone: 'semantic',
    },
    {
      german: "fest angestellt",
      translated: "stalno zaposlena na osnovu ugovora o radu",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:97|el": [
    {
      german: "Was",
      translated: "Τι",
      tone: 'semantic',
    },
    {
      german: "bezahlt man",
      translated: "πληρώνει",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "στη Γερμανία",
      tone: 'semantic',
    },
    {
      german: "automatisch",
      translated: "αυτόματα",
      tone: 'semantic',
    },
    {
      german: "wenn man",
      translated: "κάποιος που",
      tone: 'semantic',
    },
    {
      german: "fest angestellt",
      translated: "εργάζεται μόνιμα με σύμβαση εργασίας",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:97|en": [
    {
      german: "Was",
      translated: "What",
      tone: 'semantic',
    },
    {
      german: "bezahlt man",
      translated: "pay",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "in Germany",
      tone: 'semantic',
    },
    {
      german: "automatisch",
      translated: "automatically",
      tone: 'semantic',
    },
    {
      german: "wenn man",
      translated: "when you",
      tone: 'semantic',
    },
    {
      german: "fest angestellt",
      translated: "permanently employed",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "are",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:97|es": [
    {
      german: "Was",
      translated: "¿Qué",
      tone: 'semantic',
    },
    {
      german: "bezahlt man",
      translated: "se paga",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "en Alemania",
      tone: 'semantic',
    },
    {
      german: "automatisch",
      translated: "automáticamente",
      tone: 'semantic',
    },
    {
      german: "wenn man",
      translated: "cuando se tiene",
      tone: 'semantic',
    },
    {
      german: "fest angestellt",
      translated: "un empleo fijo",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:97|fa": [
    {
      german: "Was",
      translated: "چه چیزی",
      tone: 'semantic',
    },
    {
      german: "bezahlt man",
      translated: "می‌پردازد",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "در آلمان",
      tone: 'semantic',
    },
    {
      german: "automatisch",
      translated: "به‌طور خودکار",
      tone: 'semantic',
    },
    {
      german: "wenn man",
      translated: "فردی که",
      tone: 'semantic',
    },
    {
      german: "fest angestellt",
      translated: "به‌طور دائم با قرارداد کار استخدام شده",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "است",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:97|fr": [
    {
      german: "Was",
      translated: "Que",
      tone: 'semantic',
    },
    {
      german: "bezahlt man",
      translated: "paie",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "en Allemagne",
      tone: 'semantic',
    },
    {
      german: "automatisch",
      translated: "automatiquement",
      tone: 'semantic',
    },
    {
      german: "wenn man",
      translated: "lorsqu’elle",
      tone: 'semantic',
    },
    {
      german: "fest angestellt",
      translated: "salariée avec un contrat de travail permanent",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "est",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:97|hr": [
    {
      german: "Was",
      translated: "Što",
      tone: 'semantic',
    },
    {
      german: "bezahlt man",
      translated: "plaća",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "u Njemačkoj",
      tone: 'semantic',
    },
    {
      german: "automatisch",
      translated: "automatski",
      tone: 'semantic',
    },
    {
      german: "wenn man",
      translated: "koja je",
      tone: 'semantic',
    },
    {
      german: "fest angestellt",
      translated: "stalno zaposlena",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:97|it": [
    {
      german: "Was",
      translated: "Che cosa",
      tone: 'semantic',
    },
    {
      german: "bezahlt man",
      translated: "paga",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "in Germania",
      tone: 'semantic',
    },
    {
      german: "automatisch",
      translated: "automaticamente",
      tone: 'semantic',
    },
    {
      german: "wenn man",
      translated: "una persona",
      tone: 'semantic',
    },
    {
      german: "fest angestellt",
      translated: "assunta stabilmente con un contratto di lavoro",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:97|kmr": [
    {
      german: "Was",
      translated: "çi",
      tone: 'semantic',
    },
    {
      german: "bezahlt man",
      translated: "didî",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "li Almanyayê",
      tone: 'semantic',
    },
    {
      german: "automatisch",
      translated: "bixwe",
      tone: 'semantic',
    },
    {
      german: "wenn man",
      translated: "Dema ku",
      tone: 'semantic',
    },
    {
      german: "fest angestellt",
      translated: "bi kontrata kar a domdar",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "dixebitî",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:97|pl": [
    {
      german: "Was",
      translated: "Co",
      tone: 'semantic',
    },
    {
      german: "bezahlt man",
      translated: "płaci",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "w Niemczech",
      tone: 'semantic',
    },
    {
      german: "automatisch",
      translated: "automatycznie",
      tone: 'semantic',
    },
    {
      german: "wenn man",
      translated: "osoba",
      tone: 'semantic',
    },
    {
      german: "fest angestellt",
      translated: "zatrudniona na stałe",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:97|prs": [
    {
      german: "bezahlt man",
      translated: "می‌پردازد",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "در آلمان",
      tone: 'semantic',
    },
    {
      german: "automatisch",
      translated: "به‌طور خودکار",
      tone: 'semantic',
    },
    {
      german: "fest angestellt",
      translated: "با قرارداد کار استخدام شده",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "است",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:97|ro": [
    {
      german: "Was",
      translated: "Ce",
      tone: 'semantic',
    },
    {
      german: "bezahlt man",
      translated: "plătește",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "în Germania",
      tone: 'semantic',
    },
    {
      german: "automatisch",
      translated: "automat",
      tone: 'semantic',
    },
    {
      german: "wenn man",
      translated: "o persoană",
      tone: 'semantic',
    },
    {
      german: "fest angestellt",
      translated: "angajată permanent cu contract de muncă",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:97|ru": [
    {
      german: "Was",
      translated: "Что",
      tone: 'semantic',
    },
    {
      german: "bezahlt man",
      translated: "платит человек",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "в Германии",
      tone: 'semantic',
    },
    {
      german: "automatisch",
      translated: "автоматически",
      tone: 'semantic',
    },
    {
      german: "wenn man",
      translated: "если он",
      tone: 'semantic',
    },
    {
      german: "fest angestellt",
      translated: "работает по трудовому договору",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:97|sq": [
    {
      german: "Was",
      translated: "Çfarë",
      tone: 'semantic',
    },
    {
      german: "bezahlt man",
      translated: "paguan",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "në Gjermani",
      tone: 'semantic',
    },
    {
      german: "automatisch",
      translated: "automatikisht",
      tone: 'semantic',
    },
    {
      german: "wenn man",
      translated: "një person",
      tone: 'semantic',
    },
    {
      german: "fest angestellt",
      translated: "i punësuar me kontratë të rregullt pune",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:97|sr": [
    {
      german: "Was",
      translated: "Šta",
      tone: 'semantic',
    },
    {
      german: "bezahlt man",
      translated: "plaća",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "u Nemačkoj",
      tone: 'semantic',
    },
    {
      german: "automatisch",
      translated: "automatski",
      tone: 'semantic',
    },
    {
      german: "wenn man",
      translated: "osoba koja",
      tone: 'semantic',
    },
    {
      german: "fest angestellt",
      translated: "stalno zaposlena na osnovu ugovora o radu",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "je",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:97|tr": [
    {
      german: "Was",
      translated: "hangisini",
      tone: 'semantic',
    },
    {
      german: "bezahlt man",
      translated: "ödersiniz",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "Almanya'da",
      tone: 'semantic',
    },
    {
      german: "automatisch",
      translated: "otomatik olarak",
      tone: 'semantic',
    },
    {
      german: "wenn man",
      translated: "çalışıyorsanız",
      tone: 'semantic',
    },
    {
      german: "fest angestellt",
      translated: "sürekli bir işte",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:97|uk": [
    {
      german: "Was",
      translated: "Що",
      tone: 'semantic',
    },
    {
      german: "bezahlt man",
      translated: "сплачує",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "в Німеччині",
      tone: 'semantic',
    },
    {
      german: "automatisch",
      translated: "автоматично",
      tone: 'semantic',
    },
    {
      german: "wenn man",
      translated: "людина, яка",
      tone: 'semantic',
    },
    {
      german: "fest angestellt",
      translated: "працює за постійним трудовим договором",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:97|vi": [
    {
      german: "Was",
      translated: "gì?",
      tone: 'semantic',
    },
    {
      german: "bezahlt man",
      translated: "phải đóng",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "ở Đức",
      tone: 'semantic',
    },
    {
      german: "automatisch",
      translated: "tự động",
      tone: 'semantic',
    },
    {
      german: "wenn man",
      translated: "Một người",
      tone: 'semantic',
    },
    {
      german: "fest angestellt",
      translated: "làm việc lâu dài theo hợp đồng lao động",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:98|ar": [
    {
      german: "Wenn",
      translated: "إذا",
      tone: 'semantic',
    },
    {
      german: "Abgeordnete",
      translated: "نواب",
      tone: 'semantic',
    },
    {
      german: "im Deutschen Bundestag",
      translated: "في البوندستاغ الألماني",
      tone: 'semantic',
    },
    {
      german: "ihre Fraktion",
      translated: "كتلتهم البرلمانية",
      tone: 'semantic',
    },
    {
      german: "wechseln",
      translated: "غيّر",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:98|bg": [
    {
      german: "Wenn",
      translated: "Ако",
      tone: 'semantic',
    },
    {
      german: "Abgeordnete",
      translated: "депутати",
      tone: 'semantic',
    },
    {
      german: "im Deutschen Bundestag",
      translated: "в германския Бундестаг",
      tone: 'semantic',
    },
    {
      german: "ihre Fraktion",
      translated: "парламентарната си група",
      tone: 'semantic',
    },
    {
      german: "wechseln",
      translated: "сменят",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:98|bs": [
    {
      german: "Wenn",
      translated: "Ako",
      tone: 'semantic',
    },
    {
      german: "Abgeordnete",
      translated: "zastupnici",
      tone: 'semantic',
    },
    {
      german: "im Deutschen Bundestag",
      translated: "njemačkog Bundestaga",
      tone: 'semantic',
    },
    {
      german: "ihre Fraktion",
      translated: "parlamentarnu skupinu",
      tone: 'semantic',
    },
    {
      german: "wechseln",
      translated: "promijene",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:98|el": [
    {
      german: "Wenn",
      translated: "Αν",
      tone: 'semantic',
    },
    {
      german: "Abgeordnete",
      translated: "βουλευτές",
      tone: 'semantic',
    },
    {
      german: "im Deutschen Bundestag",
      translated: "του γερμανικού Bundestag",
      tone: 'semantic',
    },
    {
      german: "ihre Fraktion",
      translated: "κοινοβουλευτική ομάδα",
      tone: 'semantic',
    },
    {
      german: "wechseln",
      translated: "…",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:98|en": [
    {
      german: "Wenn",
      translated: "When",
      tone: 'semantic',
    },
    {
      german: "Abgeordnete",
      translated: "members",
      tone: 'semantic',
    },
    {
      german: "im Deutschen Bundestag",
      translated: "of the German Bundestag",
      tone: 'semantic',
    },
    {
      german: "ihre Fraktion",
      translated: "their parliamentary group",
      tone: 'semantic',
    },
    {
      german: "wechseln",
      translated: "change",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:98|es": [
    {
      german: "Wenn",
      translated: "Cuando",
      tone: 'semantic',
    },
    {
      german: "Abgeordnete",
      translated: "los diputados",
      tone: 'semantic',
    },
    {
      german: "im Deutschen Bundestag",
      translated: "del Bundestag alemán",
      tone: 'semantic',
    },
    {
      german: "ihre Fraktion",
      translated: "de grupo parlamentario",
      tone: 'semantic',
    },
    {
      german: "wechseln",
      translated: "cambian",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:98|fa": [
    {
      german: "Wenn",
      translated: "اگر",
      tone: 'semantic',
    },
    {
      german: "Abgeordnete",
      translated: "نمایندگان",
      tone: 'semantic',
    },
    {
      german: "im Deutschen Bundestag",
      translated: "بوندستاگ آلمان",
      tone: 'semantic',
    },
    {
      german: "ihre Fraktion",
      translated: "فراکسیون خود",
      tone: 'semantic',
    },
    {
      german: "wechseln",
      translated: "تغییر دهند",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:98|fr": [
    {
      german: "Wenn",
      translated: "Si",
      tone: 'semantic',
    },
    {
      german: "Abgeordnete",
      translated: "députés",
      tone: 'semantic',
    },
    {
      german: "im Deutschen Bundestag",
      translated: "du Bundestag allemand",
      tone: 'semantic',
    },
    {
      german: "ihre Fraktion",
      translated: "de groupe parlementaire",
      tone: 'semantic',
    },
    {
      german: "wechseln",
      translated: "changent",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:98|hr": [
    {
      german: "Wenn",
      translated: "Ako",
      tone: 'semantic',
    },
    {
      german: "Abgeordnete",
      translated: "zastupnici",
      tone: 'semantic',
    },
    {
      german: "im Deutschen Bundestag",
      translated: "Bundestaga",
      tone: 'semantic',
    },
    {
      german: "ihre Fraktion",
      translated: "parlamentarnu skupinu",
      tone: 'semantic',
    },
    {
      german: "wechseln",
      translated: "promijene",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:98|it": [
    {
      german: "Wenn",
      translated: "Se",
      tone: 'semantic',
    },
    {
      german: "Abgeordnete",
      translated: "deputati",
      tone: 'semantic',
    },
    {
      german: "im Deutschen Bundestag",
      translated: "del Bundestag tedesco",
      tone: 'semantic',
    },
    {
      german: "ihre Fraktion",
      translated: "gruppo parlamentare",
      tone: 'semantic',
    },
    {
      german: "wechseln",
      translated: "cambiano",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:98|kmr": [
    {
      german: "Wenn",
      translated: "Heke",
      tone: 'semantic',
    },
    {
      german: "Abgeordnete",
      translated: "parlamenterên",
      tone: 'semantic',
    },
    {
      german: "im Deutschen Bundestag",
      translated: "Bundestagê",
      tone: 'semantic',
    },
    {
      german: "ihre Fraktion",
      translated: "fraksiyona",
      tone: 'semantic',
    },
    {
      german: "wechseln",
      translated: "xwe biguherînin",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:98|pl": [
    {
      german: "Wenn",
      translated: "Jeśli",
      tone: 'semantic',
    },
    {
      german: "Abgeordnete",
      translated: "posłowie",
      tone: 'semantic',
    },
    {
      german: "im Deutschen Bundestag",
      translated: "niemieckiego Bundestagu",
      tone: 'semantic',
    },
    {
      german: "ihre Fraktion",
      translated: "frakcję parlamentarną",
      tone: 'semantic',
    },
    {
      german: "wechseln",
      translated: "zmienią",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:98|prs": [
    {
      german: "Wenn",
      translated: "اگر",
      tone: 'semantic',
    },
    {
      german: "Abgeordnete",
      translated: "نمایندگان",
      tone: 'semantic',
    },
    {
      german: "im Deutschen Bundestag",
      translated: "بوندستاگ آلمان",
      tone: 'semantic',
    },
    {
      german: "ihre Fraktion",
      translated: "فراکسیون خود",
      tone: 'semantic',
    },
    {
      german: "wechseln",
      translated: "تغییر دهند",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:98|ro": [
    {
      german: "Wenn",
      translated: "Dacă",
      tone: 'semantic',
    },
    {
      german: "Abgeordnete",
      translated: "deputații",
      tone: 'semantic',
    },
    {
      german: "im Deutschen Bundestag",
      translated: "Bundestagului german",
      tone: 'semantic',
    },
    {
      german: "ihre Fraktion",
      translated: "grupul parlamentar",
      tone: 'semantic',
    },
    {
      german: "wechseln",
      translated: " își schimbă",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:98|ru": [
    {
      german: "Wenn",
      translated: "Если",
      tone: 'semantic',
    },
    {
      german: "Abgeordnete",
      translated: "депутаты",
      tone: 'semantic',
    },
    {
      german: "im Deutschen Bundestag",
      translated: "Бундестага",
      tone: 'semantic',
    },
    {
      german: "ihre Fraktion",
      translated: "фракцию",
      tone: 'semantic',
    },
    {
      german: "wechseln",
      translated: "меняют",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:98|sq": [
    {
      german: "Wenn",
      translated: "Nëse",
      tone: 'semantic',
    },
    {
      german: "Abgeordnete",
      translated: "deputetë",
      tone: 'semantic',
    },
    {
      german: "im Deutschen Bundestag",
      translated: "të Bundestagut gjerman",
      tone: 'semantic',
    },
    {
      german: "ihre Fraktion",
      translated: "grup parlamentar",
      tone: 'semantic',
    },
    {
      german: "wechseln",
      translated: "ndryshojnë",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:98|sr": [
    {
      german: "Wenn",
      translated: "Ako",
      tone: 'semantic',
    },
    {
      german: "Abgeordnete",
      translated: "poslanici",
      tone: 'semantic',
    },
    {
      german: "im Deutschen Bundestag",
      translated: "Bundestaga",
      tone: 'semantic',
    },
    {
      german: "ihre Fraktion",
      translated: "parlamentarnu skupinu",
      tone: 'semantic',
    },
    {
      german: "wechseln",
      translated: "promijene",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:98|tr": [
    {
      german: "Abgeordnete",
      translated: "milletvekilleri",
      tone: 'semantic',
    },
    {
      german: "im Deutschen Bundestag",
      translated: "Federal Meclis",
      tone: 'semantic',
    },
    {
      german: "ihre Fraktion",
      translated: "gruplarını",
      tone: 'semantic',
    },
    {
      german: "wechseln",
      translated: "değiştirirse",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:98|uk": [
    {
      german: "Wenn",
      translated: "Якщо",
      tone: 'semantic',
    },
    {
      german: "Abgeordnete",
      translated: "депутати",
      tone: 'semantic',
    },
    {
      german: "im Deutschen Bundestag",
      translated: " німецького Бундестагу",
      tone: 'semantic',
    },
    {
      german: "ihre Fraktion",
      translated: "до іншої фракції",
      tone: 'semantic',
    },
    {
      german: "wechseln",
      translated: "…",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:98|vi": [
    {
      german: "Wenn",
      translated: "Nếu",
      tone: 'semantic',
    },
    {
      german: "Abgeordnete",
      translated: "các nghị sĩ",
      tone: 'semantic',
    },
    {
      german: "im Deutschen Bundestag",
      translated: "Bundestag Đức",
      tone: 'semantic',
    },
    {
      german: "ihre Fraktion",
      translated: "một nhóm nghị sĩ khác",
      tone: 'semantic',
    },
    {
      german: "wechseln",
      translated: "chuyển sang",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:99|ar": [
    {
      german: "Wer",
      translated: "من",
      tone: 'semantic',
    },
    {
      german: "bezahlt",
      translated: "يدفع",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "في ألمانيا",
      tone: 'semantic',
    },
    {
      german: "die Sozialversicherungen",
      translated: "التأمينات الاجتماعية",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:99|bg": [
    {
      german: "Wer",
      translated: "Кой",
      tone: 'semantic',
    },
    {
      german: "bezahlt",
      translated: "плаща",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "в Германия",
      tone: 'semantic',
    },
    {
      german: "die Sozialversicherungen",
      translated: "социалноосигурителните вноски",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:99|bs": [
    {
      german: "Wer",
      translated: "Tko",
      tone: 'semantic',
    },
    {
      german: "bezahlt",
      translated: "plata",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "u Njemačkoj",
      tone: 'semantic',
    },
    {
      german: "die Sozialversicherungen",
      translated: "za socijalno osiguranje",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:99|el": [
    {
      german: "Wer",
      translated: "Ποιος",
      tone: 'semantic',
    },
    {
      german: "bezahlt",
      translated: "πληρώνει",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "στη Γερμανία",
      tone: 'semantic',
    },
    {
      german: "die Sozialversicherungen",
      translated: "τις εισφορές κοινωνικής ασφάλισης",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:99|en": [
    {
      german: "Wer",
      translated: "Who",
      tone: 'semantic',
    },
    {
      german: "bezahlt",
      translated: "pays",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "in Germany",
      tone: 'semantic',
    },
    {
      german: "die Sozialversicherungen",
      translated: "social insurance",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:99|es": [
    {
      german: "Wer",
      translated: "¿Quién",
      tone: 'semantic',
    },
    {
      german: "bezahlt",
      translated: "paga",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "en Alemania",
      tone: 'semantic',
    },
    {
      german: "die Sozialversicherungen",
      translated: "la seguridad social",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:99|fa": [
    {
      german: "Wer",
      translated: "چه کسانی",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "در آلمان",
      tone: 'semantic',
    },
    {
      german: "die Sozialversicherungen",
      translated: "سهم بیمه‌های اجتماعی را",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:99|fr": [
    {
      german: "Wer",
      translated: "Qui",
      tone: 'semantic',
    },
    {
      german: "bezahlt",
      translated: "paie",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "en Allemagne",
      tone: 'semantic',
    },
    {
      german: "die Sozialversicherungen",
      translated: "les cotisations sociales",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:99|hr": [
    {
      german: "Wer",
      translated: "Tko",
      tone: 'semantic',
    },
    {
      german: "bezahlt",
      translated: "plaća",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "u Njemačkoj",
      tone: 'semantic',
    },
    {
      german: "die Sozialversicherungen",
      translated: "doprinose za socijalno osiguranje",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:99|it": [
    {
      german: "Wer",
      translated: "Chi",
      tone: 'semantic',
    },
    {
      german: "bezahlt",
      translated: "paga",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "in Germania",
      tone: 'semantic',
    },
    {
      german: "die Sozialversicherungen",
      translated: "i contributi alle assicurazioni sociali",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:99|kmr": [
    {
      german: "Wer",
      translated: "Li",
      tone: 'semantic',
    },
    {
      german: "bezahlt",
      translated: "Almanyayê kî",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "bîmeya civakî",
      tone: 'semantic',
    },
    {
      german: "die Sozialversicherungen",
      translated: "dide?",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:99|pl": [
    {
      german: "Wer",
      translated: "Kto",
      tone: 'semantic',
    },
    {
      german: "bezahlt",
      translated: "płaci",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "w Niemczech",
      tone: 'semantic',
    },
    {
      german: "die Sozialversicherungen",
      translated: "składki na ubezpieczenia społeczne",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:99|prs": [
    {
      german: "Wer",
      translated: "چه کسانی",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "در آلمان",
      tone: 'semantic',
    },
    {
      german: "die Sozialversicherungen",
      translated: "سهم بیمه‌های اجتماعی",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:99|ro": [
    {
      german: "Wer",
      translated: "Cine",
      tone: 'semantic',
    },
    {
      german: "bezahlt",
      translated: "plătește",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "în Germania",
      tone: 'semantic',
    },
    {
      german: "die Sozialversicherungen",
      translated: "contribuțiile la asigurările sociale",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:99|ru": [
    {
      german: "Wer",
      translated: "Кто",
      tone: 'semantic',
    },
    {
      german: "bezahlt",
      translated: "оплачивает",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "в Германии",
      tone: 'semantic',
    },
    {
      german: "die Sozialversicherungen",
      translated: "социальное страхование",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:99|sq": [
    {
      german: "Wer",
      translated: "Kush",
      tone: 'semantic',
    },
    {
      german: "bezahlt",
      translated: "paguan",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "në Gjermani",
      tone: 'semantic',
    },
    {
      german: "die Sozialversicherungen",
      translated: "sigurimeve shoqërore",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:99|sr": [
    {
      german: "Wer",
      translated: "Ko",
      tone: 'semantic',
    },
    {
      german: "bezahlt",
      translated: "plaća",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "u Nemačkoj",
      tone: 'semantic',
    },
    {
      german: "die Sozialversicherungen",
      translated: "doprinose za socijalno osiguranje",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:99|tr": [
    {
      german: "Wer",
      translated: "kim",
      tone: 'semantic',
    },
    {
      german: "bezahlt",
      translated: "öder",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "Almanya'da",
      tone: 'semantic',
    },
    {
      german: "die Sozialversicherungen",
      translated: "sosyal sigortaları",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:99|uk": [
    {
      german: "Wer",
      translated: "Хто",
      tone: 'semantic',
    },
    {
      german: "bezahlt",
      translated: "сплачує",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "в Німеччині",
      tone: 'semantic',
    },
    {
      german: "die Sozialversicherungen",
      translated: "соціальне страхування",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:99|vi": [
    {
      german: "Wer",
      translated: "Ai",
      tone: 'semantic',
    },
    {
      german: "bezahlt",
      translated: "đóng",
      tone: 'semantic',
    },
    {
      german: "in Deutschland",
      translated: "ở Đức",
      tone: 'semantic',
    },
    {
      german: "die Sozialversicherungen",
      translated: "các khoản bảo hiểm xã hội",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:9|ar": [
    {
      german: "Welches Grundrecht",
      translated: "أي حق أساسي",
      tone: 'semantic',
    },
    {
      german: "gilt in Deutschland",
      translated: "في ألمانيا",
      tone: 'semantic',
    },
    {
      german: "nur für Ausländerinnen/Ausländer?",
      translated: "يخص الأجانب فقط؟",
      tone: 'semantic',
    },
    {
      german: "Das Grundrecht auf …",
      translated: "الحق في …",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:9|bg": [
    {
      german: "Welches Grundrecht",
      translated: "Кое основно право",
      tone: 'semantic',
    },
    {
      german: "gilt in Deutschland",
      translated: "в Германия",
      tone: 'semantic',
    },
    {
      german: "nur für Ausländerinnen/Ausländer?",
      translated: "само за чужденци",
      tone: 'semantic',
    },
    {
      german: "Das Grundrecht auf …",
      translated: "Правото на",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:9|bs": [
    {
      german: "Welches Grundrecht",
      translated: "Koje se temeljno pravo",
      tone: 'semantic',
    },
    {
      german: "gilt in Deutschland",
      translated: "u Njemačkoj",
      tone: 'semantic',
    },
    {
      german: "nur für Ausländerinnen/Ausländer?",
      translated: "samo na strance",
      tone: 'semantic',
    },
    {
      german: "Das Grundrecht auf …",
      translated: "Pravo na …",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:9|el": [
    {
      german: "Welches Grundrecht",
      translated: "Ποιο θεμελιώδες δικαίωμα",
      tone: 'semantic',
    },
    {
      german: "gilt in Deutschland",
      translated: "στη Γερμανία",
      tone: 'semantic',
    },
    {
      german: "nur für Ausländerinnen/Ausländer?",
      translated: "αφορά ειδικά τους αλλοδαπούς;",
      tone: 'semantic',
    },
    {
      german: "Das Grundrecht auf …",
      translated: "Το δικαίωμα …",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:9|en": [
    {
      german: "Welches Grundrecht",
      translated: "Which fundamental right",
      tone: 'semantic',
    },
    {
      german: "gilt in Deutschland",
      translated: "in Germany applies",
      tone: 'semantic',
    },
    {
      german: "nur für Ausländerinnen/Ausländer?",
      translated: "only to foreigners?",
      tone: 'semantic',
    },
    {
      german: "Das Grundrecht auf …",
      translated: "The fundamental right to …",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:9|es": [
    {
      german: "Welches Grundrecht",
      translated: "¿Qué derecho fundamental",
      tone: 'semantic',
    },
    {
      german: "gilt in Deutschland",
      translated: "en Alemania",
      tone: 'semantic',
    },
    {
      german: "nur für Ausländerinnen/Ausländer?",
      translated: "se aplica solo a las personas extranjeras?",
      tone: 'semantic',
    },
    {
      german: "Das Grundrecht auf …",
      translated: "El derecho a …",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:9|fa": [
    {
      german: "Welches Grundrecht",
      translated: "کدام حق بنیادی",
      tone: 'semantic',
    },
    {
      german: "gilt in Deutschland",
      translated: "در آلمان",
      tone: 'semantic',
    },
    {
      german: "nur für Ausländerinnen/Ausländer?",
      translated: "فقط برای خارجیان",
      tone: 'semantic',
    },
    {
      german: "Das Grundrecht auf …",
      translated: "مطرح است؟ حقِ …",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:9|fr": [
    {
      german: "Welches Grundrecht",
      translated: "Quel droit fondamental",
      tone: 'semantic',
    },
    {
      german: "gilt in Deutschland",
      translated: "en Allemagne",
      tone: 'semantic',
    },
    {
      german: "nur für Ausländerinnen/Ausländer?",
      translated: "ne s’applique qu’aux étrangers ?",
      tone: 'semantic',
    },
    {
      german: "Das Grundrecht auf …",
      translated: "Le droit à …",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:9|hr": [
    {
      german: "Welches Grundrecht",
      translated: "Koje se temeljno pravo",
      tone: 'semantic',
    },
    {
      german: "gilt in Deutschland",
      translated: "u Njemačkoj",
      tone: 'semantic',
    },
    {
      german: "nur für Ausländerinnen/Ausländer?",
      translated: "samo na strance",
      tone: 'semantic',
    },
    {
      german: "Das Grundrecht auf …",
      translated: "Temeljno pravo na …",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:9|it": [
    {
      german: "Welches Grundrecht",
      translated: "Quale diritto fondamentale",
      tone: 'semantic',
    },
    {
      german: "gilt in Deutschland",
      translated: "in Germania si applica",
      tone: 'semantic',
    },
    {
      german: "nur für Ausländerinnen/Ausländer?",
      translated: "solo agli stranieri",
      tone: 'semantic',
    },
    {
      german: "Das Grundrecht auf …",
      translated: "Il diritto fondamentale a …",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:9|kmr": [
    {
      german: "Welches Grundrecht",
      translated: "Kîjan mafê bingehîn",
      tone: 'semantic',
    },
    {
      german: "gilt in Deutschland",
      translated: "li Almanyayê tenê",
      tone: 'semantic',
    },
    {
      german: "nur für Ausländerinnen/Ausländer?",
      translated: "ji bo biyaniyan derbasdar e?",
      tone: 'semantic',
    },
    {
      german: "Das Grundrecht auf …",
      translated: "Mafê …",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:9|pl": [
    {
      german: "Welches Grundrecht",
      translated: "Które prawo podstawowe",
      tone: 'semantic',
    },
    {
      german: "gilt in Deutschland",
      translated: "w Niemczech dotyczy",
      tone: 'semantic',
    },
    {
      german: "nur für Ausländerinnen/Ausländer?",
      translated: "wyłącznie cudzoziemców?",
      tone: 'semantic',
    },
    {
      german: "Das Grundrecht auf …",
      translated: "Prawo podstawowe do …",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:9|prs": [
    {
      german: "Welches Grundrecht",
      translated: "کدام حق بنیادی",
      tone: 'semantic',
    },
    {
      german: "gilt in Deutschland",
      translated: "در آلمان",
      tone: 'semantic',
    },
    {
      german: "nur für Ausländerinnen/Ausländer?",
      translated: "فقط برای خارجیان",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:9|ro": [
    {
      german: "Welches Grundrecht",
      translated: "Care drept fundamental",
      tone: 'semantic',
    },
    {
      german: "gilt in Deutschland",
      translated: "din Germania se aplică",
      tone: 'semantic',
    },
    {
      german: "nur für Ausländerinnen/Ausländer?",
      translated: "numai străinilor",
      tone: 'semantic',
    },
    {
      german: "Das Grundrecht auf …",
      translated: "Dreptul la …",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:9|ru": [
    {
      german: "Welches Grundrecht",
      translated: "Какое основное право",
      tone: 'semantic',
    },
    {
      german: "gilt in Deutschland",
      translated: "в Германии",
      tone: 'semantic',
    },
    {
      german: "nur für Ausländerinnen/Ausländer?",
      translated: "только для иностранцев?",
      tone: 'semantic',
    },
    {
      german: "Das Grundrecht auf …",
      translated: "Право на …",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:9|sq": [
    {
      german: "Welches Grundrecht",
      translated: "Cila e drejtë themelore",
      tone: 'semantic',
    },
    {
      german: "gilt in Deutschland",
      translated: "në Gjermani vlen",
      tone: 'semantic',
    },
    {
      german: "nur für Ausländerinnen/Ausländer?",
      translated: "vetëm për të huajat/të huajt?",
      tone: 'semantic',
    },
    {
      german: "Das Grundrecht auf …",
      translated: "E drejta për …",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:9|sr": [
    {
      german: "Welches Grundrecht",
      translated: "Koje osnovno pravo",
      tone: 'semantic',
    },
    {
      german: "gilt in Deutschland",
      translated: "u Nemačkoj važi",
      tone: 'semantic',
    },
    {
      german: "nur für Ausländerinnen/Ausländer?",
      translated: "samo za strance?",
      tone: 'semantic',
    },
    {
      german: "Das Grundrecht auf …",
      translated: "Pravo na …",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:9|tr": [
    {
      german: "Welches Grundrecht",
      translated: "temel hak hangisidir",
      tone: 'semantic',
    },
    {
      german: "gilt in Deutschland",
      translated: "Almanya'da",
      tone: 'semantic',
    },
    {
      german: "nur für Ausländerinnen/Ausländer?",
      translated: "yalnızca yabancılar için",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:9|uk": [
    {
      german: "Welches Grundrecht",
      translated: "Яке основне право",
      tone: 'semantic',
    },
    {
      german: "gilt in Deutschland",
      translated: "в Німеччині стосується",
      tone: 'semantic',
    },
    {
      german: "nur für Ausländerinnen/Ausländer?",
      translated: "лише іноземців?",
      tone: 'semantic',
    },
    {
      german: "Das Grundrecht auf …",
      translated: "Право на …",
      tone: 'semantic',
    },
  ],
  "lid:general:DE:9|vi": [
    {
      german: "Welches Grundrecht",
      translated: "Quyền cơ bản nào",
      tone: 'semantic',
    },
    {
      german: "gilt in Deutschland",
      translated: "ở Đức",
      tone: 'semantic',
    },
    {
      german: "nur für Ausländerinnen/Ausländer?",
      translated: "chỉ áp dụng cho người nước ngoài",
      tone: 'semantic',
    },
    {
      german: "Das Grundrecht auf …",
      translated: "Quyền …",
      tone: 'semantic',
    },
  ],
  "lid:state:BB:10|ar": [
    {
      german: "Welche Ministerin",
      translated: "أي وزارة",
      tone: 'semantic',
    },
    {
      german: "welchen Minister",
      translated: "من الوزارات التالية",
      tone: 'semantic',
    },
    {
      german: "hat Brandenburg nicht",
      translated: "غير موجودة على مستوى ولاية Brandenburg",
      tone: 'semantic',
    },
  ],
  "lid:state:BB:10|bg": [
    {
      german: "Welche Ministerin",
      translated: "Кой",
      tone: 'semantic',
    },
    {
      german: "welchen Minister",
      translated: "министър",
      tone: 'semantic',
    },
    {
      german: "hat Brandenburg nicht",
      translated: "не съществува на ниво федерална провинция Бранденбург",
      tone: 'semantic',
    },
  ],
  "lid:state:BB:10|bs": [
    {
      german: "welchen Minister",
      translated: "Koji ministar",
      tone: 'semantic',
    },
    {
      german: "hat Brandenburg nicht",
      translated: "ne postoji na razini savezne zemlje Brandenburg?",
      tone: 'semantic',
    },
  ],
  "lid:state:BB:10|el": [
    {
      german: "Welche Ministerin",
      translated: "Ποιος",
      tone: 'semantic',
    },
    {
      german: "welchen Minister",
      translated: "υπουργός",
      tone: 'semantic',
    },
    {
      german: "hat Brandenburg nicht",
      translated: "δεν υπάρχει σε επίπεδο κρατιδίου στο Βρανδεμβούργο",
      tone: 'semantic',
    },
  ],
  "lid:state:BB:10|en": [
    {
      german: "Welche Ministerin",
      translated: "Which",
      tone: 'semantic',
    },
    {
      german: "welchen Minister",
      translated: "minister",
      tone: 'semantic',
    },
    {
      german: "hat Brandenburg nicht",
      translated: "does Brandenburg not have?",
      tone: 'semantic',
    },
  ],
  "lid:state:BB:10|es": [
    {
      german: "Welche Ministerin",
      translated: "¿Qué",
      tone: 'semantic',
    },
    {
      german: "welchen Minister",
      translated: "ministerio",
      tone: 'semantic',
    },
    {
      german: "hat Brandenburg nicht",
      translated: "NO existe a nivel regional en Brandeburgo",
      tone: 'semantic',
    },
  ],
  "lid:state:BB:10|fa": [
    {
      german: "Welche Ministerin",
      translated: "کدام",
      tone: 'semantic',
    },
    {
      german: "welchen Minister",
      translated: "وزیر",
      tone: 'semantic',
    },
    {
      german: "hat Brandenburg nicht",
      translated: "در سطح ایالت براندنبورگ وجود ندارد",
      tone: 'semantic',
    },
  ],
  "lid:state:BB:10|fr": [
    {
      german: "Welche Ministerin",
      translated: "quelle ministre",
      tone: 'semantic',
    },
    {
      german: "welchen Minister",
      translated: "ministre",
      tone: 'semantic',
    },
    {
      german: "hat Brandenburg nicht",
      translated: "n’existe pas au niveau du Land de Brandebourg",
      tone: 'semantic',
    },
  ],
  "lid:state:BB:10|hr": [
    {
      german: "Welche Ministerin",
      translated: "Koji ministar",
      tone: 'semantic',
    },
    {
      german: "hat Brandenburg nicht",
      translated: "ne postoji na razini savezne zemlje Brandenburg?",
      tone: 'semantic',
    },
  ],
  "lid:state:BB:10|it": [
    {
      german: "welchen Minister",
      translated: "ministro",
      tone: 'semantic',
    },
    {
      german: "hat Brandenburg nicht",
      translated: "non esiste a livello del Land di Brandeburgo",
      tone: 'semantic',
    },
  ],
  "lid:state:BB:10|kmr": [
    {
      german: "Welche Ministerin",
      translated: "Kîjan wezîr",
      tone: 'semantic',
    },
    {
      german: "hat Brandenburg nicht",
      translated: "tune ye",
      tone: 'semantic',
    },
  ],
  "lid:state:BB:10|pl": [
    {
      german: "welchen Minister",
      translated: "Którego ministra",
      tone: 'semantic',
    },
    {
      german: "hat Brandenburg nicht",
      translated: "nie ma na szczeblu kraju związkowego Brandenburgia?",
      tone: 'semantic',
    },
  ],
  "lid:state:BB:10|prs": [
    {
      german: "Welche Ministerin",
      translated: "کدام",
      tone: 'semantic',
    },
    {
      german: "welchen Minister",
      translated: "وزیر",
      tone: 'semantic',
    },
    {
      german: "hat Brandenburg nicht",
      translated: "در سطح ایالت براندنبورگ وجود ندارد",
      tone: 'semantic',
    },
  ],
  "lid:state:BB:10|ro": [
    {
      german: "Welche Ministerin",
      translated: "Care ministru",
      tone: 'semantic',
    },
    {
      german: "hat Brandenburg nicht",
      translated: "nu există la nivelul landului Brandenburg",
      tone: 'semantic',
    },
  ],
  "lid:state:BB:10|ru": [
    {
      german: "welchen Minister",
      translated: "Какого министра",
      tone: 'semantic',
    },
    {
      german: "hat Brandenburg nicht",
      translated: "нет в федеральной земле Бранденбург",
      tone: 'semantic',
    },
  ],
  "lid:state:BB:10|sq": [
    {
      german: "Welche Ministerin",
      translated: "Cili ministër",
      tone: 'semantic',
    },
    {
      german: "hat Brandenburg nicht",
      translated: "nuk ekziston në nivelin e landit Brandenburgu",
      tone: 'semantic',
    },
  ],
  "lid:state:BB:10|sr": [
    {
      german: "Welche Ministerin",
      translated: "Koji ministar",
      tone: 'semantic',
    },
    {
      german: "hat Brandenburg nicht",
      translated: "ne postoji na razini savezne pokrajine Brandenburg?",
      tone: 'semantic',
    },
  ],
  "lid:state:BB:10|tr": [
    {
      german: "Welche Ministerin",
      translated: "aşağıdaki bakanlıklardan hangisi",
      tone: 'semantic',
    },
    {
      german: "hat Brandenburg nicht",
      translated: "Brandenburg eyaletinde",
      tone: 'semantic',
    },
  ],
  "lid:state:BB:10|uk": [
    {
      german: "Welche Ministerin",
      translated: "міністерки",
      tone: 'semantic',
    },
    {
      german: "welchen Minister",
      translated: "міністра",
      tone: 'semantic',
    },
    {
      german: "hat Brandenburg nicht",
      translated: "немає у федеральній землі Бранденбург",
      tone: 'semantic',
    },
  ],
  "lid:state:BB:10|vi": [
    {
      german: "Welche Ministerin",
      translated: "Bộ trưởng nào",
      tone: 'semantic',
    },
    {
      german: "hat Brandenburg nicht",
      translated: "không tồn tại ở cấp bang Brandenburg",
      tone: 'semantic',
    },
  ],
  "lid:state:BB:1|ar": [
    {
      german: "Welches Wappen",
      translated: "أي شعار",
      tone: 'semantic',
    },
    {
      german: "gehört zum",
      translated: "من الصور",
      tone: 'semantic',
    },
    {
      german: "Bundesland Brandenburg",
      translated: "Brandenburg",
      tone: 'semantic',
    },
  ],
  "lid:state:BB:1|bg": [
    {
      german: "Welches Wappen",
      translated: "Кой герб",
      tone: 'semantic',
    },
    {
      german: "gehört zum",
      translated: "принадлежи",
      tone: 'semantic',
    },
    {
      german: "Bundesland Brandenburg",
      translated: "на федералната провинция Бранденбург",
      tone: 'semantic',
    },
  ],
  "lid:state:BB:1|bs": [
    {
      german: "Welches Wappen",
      translated: "Koji grb",
      tone: 'semantic',
    },
    {
      german: "gehört zum",
      translated: "pripada",
      tone: 'semantic',
    },
    {
      german: "Bundesland Brandenburg",
      translated: "saveznoj zemlji Brandenburg?",
      tone: 'semantic',
    },
  ],
  "lid:state:BB:1|el": [
    {
      german: "Welches Wappen",
      translated: "Ποιο έμβλημα",
      tone: 'semantic',
    },
    {
      german: "gehört zum",
      translated: "ανήκει στο",
      tone: 'semantic',
    },
    {
      german: "Bundesland Brandenburg",
      translated: "ομόσπονδο κρατίδιο Βρανδεμβούργο",
      tone: 'semantic',
    },
  ],
  "lid:state:BB:1|en": [
    {
      german: "Welches Wappen",
      translated: "Which coat of arms",
      tone: 'semantic',
    },
    {
      german: "gehört zum",
      translated: "belongs to",
      tone: 'semantic',
    },
    {
      german: "Bundesland Brandenburg",
      translated: "the federal state of Brandenburg",
      tone: 'semantic',
    },
  ],
  "lid:state:BB:1|es": [
    {
      german: "Welches Wappen",
      translated: "¿Qué escudo",
      tone: 'semantic',
    },
    {
      german: "gehört zum",
      translated: "pertenece al",
      tone: 'semantic',
    },
    {
      german: "Bundesland Brandenburg",
      translated: "estado federado de Brandeburgo",
      tone: 'semantic',
    },
  ],
  "lid:state:BB:1|fa": [
    {
      german: "Welches Wappen",
      translated: "کدام نشان",
      tone: 'semantic',
    },
    {
      german: "gehört zum",
      translated: "متعلق به",
      tone: 'semantic',
    },
    {
      german: "Bundesland Brandenburg",
      translated: "ایالت براندنبورگ",
      tone: 'semantic',
    },
  ],
  "lid:state:BB:1|fr": [
    {
      german: "Welches Wappen",
      translated: "Quel blason",
      tone: 'semantic',
    },
    {
      german: "gehört zum",
      translated: "appartient au",
      tone: 'semantic',
    },
    {
      german: "Bundesland Brandenburg",
      translated: "Land de Brandebourg",
      tone: 'semantic',
    },
  ],
  "lid:state:BB:1|hr": [
    {
      german: "Welches Wappen",
      translated: "Koji grb",
      tone: 'semantic',
    },
    {
      german: "gehört zum",
      translated: "pripada",
      tone: 'semantic',
    },
    {
      german: "Bundesland Brandenburg",
      translated: "saveznoj zemlji Brandenburg?",
      tone: 'semantic',
    },
  ],
  "lid:state:BB:1|it": [
    {
      german: "Welches Wappen",
      translated: "Quale stemma",
      tone: 'semantic',
    },
    {
      german: "gehört zum",
      translated: "appartiene al",
      tone: 'semantic',
    },
    {
      german: "Bundesland Brandenburg",
      translated: "Land di Brandeburgo",
      tone: 'semantic',
    },
  ],
  "lid:state:BB:1|kmr": [
    {
      german: "Welches Wappen",
      translated: "nîşan a eyaleta",
      tone: 'semantic',
    },
    {
      german: "gehört zum",
      translated: "ye?",
      tone: 'semantic',
    },
    {
      german: "Bundesland Brandenburg",
      translated: "Brandenburg",
      tone: 'semantic',
    },
  ],
  "lid:state:BB:1|pl": [
    {
      german: "Welches Wappen",
      translated: "Który herb",
      tone: 'semantic',
    },
    {
      german: "gehört zum",
      translated: "należy do",
      tone: 'semantic',
    },
    {
      german: "Bundesland Brandenburg",
      translated: "kraju związkowego Brandenburgia",
      tone: 'semantic',
    },
  ],
  "lid:state:BB:1|prs": [
    {
      german: "Welches Wappen",
      translated: "نشان",
      tone: 'semantic',
    },
    {
      german: "gehört zum",
      translated: "متعلق به",
      tone: 'semantic',
    },
    {
      german: "Bundesland Brandenburg",
      translated: "ایالت براندنبورگ",
      tone: 'semantic',
    },
  ],
  "lid:state:BB:1|ro": [
    {
      german: "Welches Wappen",
      translated: "Care stemă",
      tone: 'semantic',
    },
    {
      german: "gehört zum",
      translated: "aparține",
      tone: 'semantic',
    },
    {
      german: "Bundesland Brandenburg",
      translated: "landului Brandenburg",
      tone: 'semantic',
    },
  ],
  "lid:state:BB:1|ru": [
    {
      german: "Welches Wappen",
      translated: "Какой герб",
      tone: 'semantic',
    },
    {
      german: "gehört zum",
      translated: "принадлежит",
      tone: 'semantic',
    },
    {
      german: "Bundesland Brandenburg",
      translated: "федеральной земле Бранденбург",
      tone: 'semantic',
    },
  ],
  "lid:state:BB:1|sq": [
    {
      german: "Welches Wappen",
      translated: "Cila stemë",
      tone: 'semantic',
    },
    {
      german: "gehört zum",
      translated: "i përket",
      tone: 'semantic',
    },
    {
      german: "Bundesland Brandenburg",
      translated: "landit Brandenburgu",
      tone: 'semantic',
    },
  ],
  "lid:state:BB:1|sr": [
    {
      german: "Welches Wappen",
      translated: "Koji grb",
      tone: 'semantic',
    },
    {
      german: "gehört zum",
      translated: "pripada",
      tone: 'semantic',
    },
    {
      german: "Bundesland Brandenburg",
      translated: "saveznoj pokrajini Brandenburg?",
      tone: 'semantic',
    },
  ],
  "lid:state:BB:1|tr": [
    {
      german: "Welches Wappen",
      translated: "arması hangisidir",
      tone: 'semantic',
    },
    {
      german: "Bundesland Brandenburg",
      translated: "Brandenburg eyaletinin",
      tone: 'semantic',
    },
  ],
  "lid:state:BB:1|uk": [
    {
      german: "Welches Wappen",
      translated: "Який герб",
      tone: 'semantic',
    },
    {
      german: "gehört zum",
      translated: "належить",
      tone: 'semantic',
    },
    {
      german: "Bundesland Brandenburg",
      translated: "федеральній землі Бранденбург?",
      tone: 'semantic',
    },
  ],
  "lid:state:BB:1|vi": [
    {
      german: "Welches Wappen",
      translated: "Quốc huy",
      tone: 'semantic',
    },
    {
      german: "gehört zum",
      translated: "thuộc",
      tone: 'semantic',
    },
    {
      german: "Bundesland Brandenburg",
      translated: "bang Brandenburg",
      tone: 'semantic',
    },
  ],
  "lid:state:BB:2|ar": [
    {
      german: "Welches",
      translated: "أي",
      tone: 'semantic',
    },
    {
      german: "Landkreis",
      translated: "دائرة إدارية (Landkreis)",
      tone: 'semantic',
    },
    {
      german: "Brandenburg",
      translated: "Brandenburg",
      tone: 'semantic',
    },
  ],
  "lid:state:BB:2|bg": [
    {
      german: "Welches",
      translated: "Кое",
      tone: 'semantic',
    },
    {
      german: "Landkreis",
      translated: "окръг",
      tone: 'semantic',
    },
    {
      german: "Brandenburg",
      translated: "Бранденбург",
      tone: 'semantic',
    },
  ],
  "lid:state:BB:2|bs": [
    {
      german: "Welches",
      translated: "Što",
      tone: 'semantic',
    },
    {
      german: "Landkreis",
      translated: "okrug (Landkreis)",
      tone: 'semantic',
    },
    {
      german: "Brandenburg",
      translated: "Brandenburg",
      tone: 'semantic',
    },
  ],
  "lid:state:BB:2|el": [
    {
      german: "Welches",
      translated: "Ποιο από τα",
      tone: 'semantic',
    },
    {
      german: "Landkreis",
      translated: "διοικητική περιφέρεια (Landkreis)",
      tone: 'semantic',
    },
    {
      german: "Brandenburg",
      translated: "Βρανδεμβούργο",
      tone: 'semantic',
    },
  ],
  "lid:state:BB:2|en": [
    {
      german: "Welches",
      translated: "Which",
      tone: 'semantic',
    },
    {
      german: "Landkreis",
      translated: "district",
      tone: 'semantic',
    },
    {
      german: "Brandenburg",
      translated: "Brandenburg",
      tone: 'semantic',
    },
  ],
  "lid:state:BB:2|es": [
    {
      german: "Welches",
      translated: "¿Cuál de los siguientes es un",
      tone: 'semantic',
    },
    {
      german: "Landkreis",
      translated: "distrito (Landkreis)",
      tone: 'semantic',
    },
    {
      german: "Brandenburg",
      translated: "Brandeburgo",
      tone: 'semantic',
    },
  ],
  "lid:state:BB:2|fa": [
    {
      german: "Welches",
      translated: "کدام‌یک",
      tone: 'semantic',
    },
    {
      german: "Landkreis",
      translated: "شهرستان (Landkreis)",
      tone: 'semantic',
    },
    {
      german: "Brandenburg",
      translated: "براندنبورگ",
      tone: 'semantic',
    },
  ],
  "lid:state:BB:2|fr": [
    {
      german: "Welches",
      translated: "Lequel des éléments suivants est",
      tone: 'semantic',
    },
    {
      german: "Landkreis",
      translated: "arrondissement (Landkreis)",
      tone: 'semantic',
    },
    {
      german: "Brandenburg",
      translated: "Brandebourg",
      tone: 'semantic',
    },
  ],
  "lid:state:BB:2|hr": [
    {
      german: "Welches",
      translated: "Što",
      tone: 'semantic',
    },
    {
      german: "Landkreis",
      translated: "od navedenoga okrug (Landkreis)",
      tone: 'semantic',
    },
    {
      german: "Brandenburg",
      translated: "saveznoj zemlji Brandenburg?",
      tone: 'semantic',
    },
  ],
  "lid:state:BB:2|it": [
    {
      german: "Welches",
      translated: "Quale dei seguenti",
      tone: 'semantic',
    },
    {
      german: "Landkreis",
      translated: "distretto (Landkreis)",
      tone: 'semantic',
    },
    {
      german: "Brandenburg",
      translated: "di Brandeburgo",
      tone: 'semantic',
    },
  ],
  "lid:state:BB:2|kmr": [
    {
      german: "Welches",
      translated: "Kîjan",
      tone: 'semantic',
    },
    {
      german: "Landkreis",
      translated: "navçeyek (Landkreis)",
      tone: 'semantic',
    },
    {
      german: "Brandenburg",
      translated: "Brandenburg ye?",
      tone: 'semantic',
    },
  ],
  "lid:state:BB:2|pl": [
    {
      german: "Welches",
      translated: "Który",
      tone: 'semantic',
    },
    {
      german: "Landkreis",
      translated: "(Landkreis)",
      tone: 'semantic',
    },
    {
      german: "Brandenburg",
      translated: "Brandenburgia",
      tone: 'semantic',
    },
  ],
  "lid:state:BB:2|prs": [
    {
      german: "Welches",
      translated: "کدام",
      tone: 'semantic',
    },
    {
      german: "Landkreis",
      translated: "شهرستان",
      tone: 'semantic',
    },
    {
      german: "Brandenburg",
      translated: "Landkreis) در براندنبورگ است؟",
      tone: 'semantic',
    },
  ],
  "lid:state:BB:2|ro": [
    {
      german: "Welches",
      translated: "Care",
      tone: 'semantic',
    },
    {
      german: "Landkreis",
      translated: "district (Landkreis)",
      tone: 'semantic',
    },
    {
      german: "Brandenburg",
      translated: "Brandenburg",
      tone: 'semantic',
    },
  ],
  "lid:state:BB:2|ru": [
    {
      german: "Welches",
      translated: "Какой",
      tone: 'semantic',
    },
    {
      german: "Landkreis",
      translated: "районом",
      tone: 'semantic',
    },
    {
      german: "Brandenburg",
      translated: "Бранденбург",
      tone: 'semantic',
    },
  ],
  "lid:state:BB:2|sq": [
    {
      german: "Welches",
      translated: "Cila nga",
      tone: 'semantic',
    },
    {
      german: "Landkreis",
      translated: "një qark",
      tone: 'semantic',
    },
    {
      german: "Brandenburg",
      translated: "në Brandenburgu",
      tone: 'semantic',
    },
  ],
  "lid:state:BB:2|sr": [
    {
      german: "Welches",
      translated: "Šta",
      tone: 'semantic',
    },
    {
      german: "Landkreis",
      translated: "okrug",
      tone: 'semantic',
    },
    {
      german: "Brandenburg",
      translated: "Brandenburg",
      tone: 'semantic',
    },
  ],
  "lid:state:BB:2|tr": [
    {
      german: "Welches",
      translated: "Aşağıdakilerden hangisi",
      tone: 'semantic',
    },
    {
      german: "Landkreis",
      translated: "bir Landkreis (ilçe/idari bölge)dir",
      tone: 'semantic',
    },
    {
      german: "Brandenburg",
      translated: "Brandenburg eyaletinde bulunan",
      tone: 'semantic',
    },
  ],
  "lid:state:BB:2|uk": [
    {
      german: "Welches",
      translated: "Який",
      tone: 'semantic',
    },
    {
      german: "Landkreis",
      translated: "районів",
      tone: 'semantic',
    },
    {
      german: "Brandenburg",
      translated: "Бранденбург",
      tone: 'semantic',
    },
  ],
  "lid:state:BB:2|vi": [
    {
      german: "Welches",
      translated: "Địa danh nào sau đây",
      tone: 'semantic',
    },
    {
      german: "Landkreis",
      translated: "huyện",
      tone: 'semantic',
    },
    {
      german: "Brandenburg",
      translated: "bang Brandenburg",
      tone: 'semantic',
    },
  ],
  "lid:state:BB:3|ar": [
    {
      german: "Für wie viele Jahre",
      translated: "لمدة كم سنة",
      tone: 'semantic',
    },
    {
      german: "der Landtag",
      translated: "برلمان الولاية",
      tone: 'semantic',
    },
    {
      german: "in Brandenburg",
      translated: "في Brandenburg",
      tone: 'semantic',
    },
    {
      german: "gewählt",
      translated: "يُنتخب",
      tone: 'semantic',
    },
  ],
  "lid:state:BB:3|bg": [
    {
      german: "Für wie viele Jahre",
      translated: "За колко години",
      tone: 'semantic',
    },
    {
      german: "der Landtag",
      translated: "парламентът",
      tone: 'semantic',
    },
    {
      german: "in Brandenburg",
      translated: "на провинция Бранденбург",
      tone: 'semantic',
    },
    {
      german: "gewählt",
      translated: "се избира",
      tone: 'semantic',
    },
  ],
  "lid:state:BB:3|bs": [
    {
      german: "Für wie viele Jahre",
      translated: "Na koliko se godina",
      tone: 'semantic',
    },
    {
      german: "der Landtag",
      translated: "parlament",
      tone: 'semantic',
    },
    {
      german: "in Brandenburg",
      translated: "savezne zemlje Brandenburg",
      tone: 'semantic',
    },
    {
      german: "gewählt",
      translated: "bira",
      tone: 'semantic',
    },
  ],
  "lid:state:BB:3|el": [
    {
      german: "Für wie viele Jahre",
      translated: "Για πόσα χρόνια",
      tone: 'semantic',
    },
    {
      german: "der Landtag",
      translated: "το Landtag",
      tone: 'semantic',
    },
    {
      german: "in Brandenburg",
      translated: "του Βρανδεμβούργο",
      tone: 'semantic',
    },
    {
      german: "gewählt",
      translated: "εκλέγεται",
      tone: 'semantic',
    },
  ],
  "lid:state:BB:3|en": [
    {
      german: "Für wie viele Jahre",
      translated: "For how many years",
      tone: 'semantic',
    },
    {
      german: "der Landtag",
      translated: "the state parliament",
      tone: 'semantic',
    },
    {
      german: "in Brandenburg",
      translated: "in Brandenburg",
      tone: 'semantic',
    },
    {
      german: "gewählt",
      translated: "elected",
      tone: 'semantic',
    },
  ],
  "lid:state:BB:3|es": [
    {
      german: "Für wie viele Jahre",
      translated: "¿Por cuántos años",
      tone: 'semantic',
    },
    {
      german: "der Landtag",
      translated: "el parlamento regional",
      tone: 'semantic',
    },
    {
      german: "in Brandenburg",
      translated: "en Brandeburgo",
      tone: 'semantic',
    },
    {
      german: "gewählt",
      translated: "se elige",
      tone: 'semantic',
    },
  ],
  "lid:state:BB:3|fa": [
    {
      german: "Für wie viele Jahre",
      translated: "برای چند سال",
      tone: 'semantic',
    },
    {
      german: "der Landtag",
      translated: "پارلمان ایالتی",
      tone: 'semantic',
    },
    {
      german: "in Brandenburg",
      translated: "براندنبورگ",
      tone: 'semantic',
    },
    {
      german: "gewählt",
      translated: "می‌شود",
      tone: 'semantic',
    },
  ],
  "lid:state:BB:3|fr": [
    {
      german: "Für wie viele Jahre",
      translated: "Pour combien d’années",
      tone: 'semantic',
    },
    {
      german: "der Landtag",
      translated: "le Landtag",
      tone: 'semantic',
    },
    {
      german: "in Brandenburg",
      translated: "de Brandebourg",
      tone: 'semantic',
    },
    {
      german: "gewählt",
      translated: "est-il élu",
      tone: 'semantic',
    },
  ],
  "lid:state:BB:3|hr": [
    {
      german: "Für wie viele Jahre",
      translated: "Na koliko se godina",
      tone: 'semantic',
    },
    {
      german: "der Landtag",
      translated: "parlament",
      tone: 'semantic',
    },
    {
      german: "in Brandenburg",
      translated: "savezne zemlje Brandenburg",
      tone: 'semantic',
    },
    {
      german: "gewählt",
      translated: "bira",
      tone: 'semantic',
    },
  ],
  "lid:state:BB:3|it": [
    {
      german: "Für wie viele Jahre",
      translated: "Per quanti anni",
      tone: 'semantic',
    },
    {
      german: "der Landtag",
      translated: "il Landtag",
      tone: 'semantic',
    },
    {
      german: "in Brandenburg",
      translated: "di Brandeburgo",
      tone: 'semantic',
    },
    {
      german: "gewählt",
      translated: "eletto",
      tone: 'semantic',
    },
  ],
  "lid:state:BB:3|kmr": [
    {
      german: "Für wie viele Jahre",
      translated: "çend salan",
      tone: 'semantic',
    },
    {
      german: "der Landtag",
      translated: "Landtag",
      tone: 'semantic',
    },
    {
      german: "in Brandenburg",
      translated: "a Brandenburg",
      tone: 'semantic',
    },
    {
      german: "gewählt",
      translated: "hilbijartin",
      tone: 'semantic',
    },
  ],
  "lid:state:BB:3|pl": [
    {
      german: "Für wie viele Jahre",
      translated: "Na ile lat",
      tone: 'semantic',
    },
    {
      german: "der Landtag",
      translated: "parlament",
      tone: 'semantic',
    },
    {
      german: "in Brandenburg",
      translated: "kraju związkowego Brandenburgia",
      tone: 'semantic',
    },
    {
      german: "gewählt",
      translated: "wybierany jest",
      tone: 'semantic',
    },
  ],
  "lid:state:BB:3|prs": [
    {
      german: "Für wie viele Jahre",
      translated: "چند سال",
      tone: 'semantic',
    },
    {
      german: "der Landtag",
      translated: "پارلمان ایالتی",
      tone: 'semantic',
    },
    {
      german: "in Brandenburg",
      translated: "براندنبورگ",
      tone: 'semantic',
    },
    {
      german: "gewählt",
      translated: "انتخاب می‌شود",
      tone: 'semantic',
    },
  ],
  "lid:state:BB:3|ro": [
    {
      german: "Für wie viele Jahre",
      translated: "câți ani",
      tone: 'semantic',
    },
    {
      german: "der Landtag",
      translated: "parlamentul landului",
      tone: 'semantic',
    },
    {
      german: "in Brandenburg",
      translated: "Brandenburg",
      tone: 'semantic',
    },
    {
      german: "gewählt",
      translated: "este ales",
      tone: 'semantic',
    },
  ],
  "lid:state:BB:3|ru": [
    {
      german: "Für wie viele Jahre",
      translated: "На сколько лет",
      tone: 'semantic',
    },
    {
      german: "der Landtag",
      translated: "ландтаг",
      tone: 'semantic',
    },
    {
      german: "in Brandenburg",
      translated: "в федеральной земле Бранденбург",
      tone: 'semantic',
    },
    {
      german: "gewählt",
      translated: "избирается",
      tone: 'semantic',
    },
  ],
  "lid:state:BB:3|sq": [
    {
      german: "Für wie viele Jahre",
      translated: "Për sa vjet",
      tone: 'semantic',
    },
    {
      german: "der Landtag",
      translated: "Landtagu",
      tone: 'semantic',
    },
    {
      german: "in Brandenburg",
      translated: "i Brandenburgu",
      tone: 'semantic',
    },
    {
      german: "gewählt",
      translated: "zgjidhet",
      tone: 'semantic',
    },
  ],
  "lid:state:BB:3|sr": [
    {
      german: "Für wie viele Jahre",
      translated: "koliko se godina",
      tone: 'semantic',
    },
    {
      german: "der Landtag",
      translated: "parlament",
      tone: 'semantic',
    },
    {
      german: "in Brandenburg",
      translated: "savezne pokrajine Brandenburg",
      tone: 'semantic',
    },
    {
      german: "gewählt",
      translated: "bira",
      tone: 'semantic',
    },
  ],
  "lid:state:BB:3|tr": [
    {
      german: "Für wie viele Jahre",
      translated: "kaç yıllığına",
      tone: 'semantic',
    },
    {
      german: "der Landtag",
      translated: "eyalet parlamentosu",
      tone: 'semantic',
    },
    {
      german: "in Brandenburg",
      translated: "Brandenburg",
      tone: 'semantic',
    },
    {
      german: "gewählt",
      translated: "seçilir",
      tone: 'semantic',
    },
  ],
  "lid:state:BB:3|uk": [
    {
      german: "Für wie viele Jahre",
      translated: "На скільки років",
      tone: 'semantic',
    },
    {
      german: "der Landtag",
      translated: "земельний парламент",
      tone: 'semantic',
    },
    {
      german: "in Brandenburg",
      translated: "у федеральній землі Бранденбург",
      tone: 'semantic',
    },
    {
      german: "gewählt",
      translated: "обирають",
      tone: 'semantic',
    },
  ],
  "lid:state:BB:3|vi": [
    {
      german: "Für wie viele Jahre",
      translated: "bao nhiêu năm",
      tone: 'semantic',
    },
    {
      german: "der Landtag",
      translated: "Nghị viện bang (Landtag)",
      tone: 'semantic',
    },
    {
      german: "in Brandenburg",
      translated: "của Brandenburg",
      tone: 'semantic',
    },
    {
      german: "gewählt",
      translated: "được bầu",
      tone: 'semantic',
    },
  ],
  "lid:state:BB:4|ar": [
    {
      german: "Ab welchem Alter",
      translated: "ابتداءً من أي سن",
      tone: 'semantic',
    },
    {
      german: "darf man",
      translated: "يحق",
      tone: 'semantic',
    },
    {
      german: "in Brandenburg",
      translated: "في Brandenburg",
      tone: 'semantic',
    },
    {
      german: "bei Kommunalwahlen",
      translated: "في الانتخابات المحلية",
      tone: 'semantic',
    },
    {
      german: "wählen",
      translated: "التصويت",
      tone: 'semantic',
    },
  ],
  "lid:state:BB:4|bg": [
    {
      german: "Ab welchem Alter",
      translated: "От каква възраст",
      tone: 'semantic',
    },
    {
      german: "darf man",
      translated: "може да се",
      tone: 'semantic',
    },
    {
      german: "in Brandenburg",
      translated: "в Бранденбург",
      tone: 'semantic',
    },
    {
      german: "bei Kommunalwahlen",
      translated: "на общински избори",
      tone: 'semantic',
    },
    {
      german: "wählen",
      translated: "гласува",
      tone: 'semantic',
    },
  ],
  "lid:state:BB:4|bs": [
    {
      german: "Ab welchem Alter",
      translated: "Od koje se dobi",
      tone: 'semantic',
    },
    {
      german: "darf man",
      translated: "može",
      tone: 'semantic',
    },
    {
      german: "in Brandenburg",
      translated: "u saveznoj zemlji Brandenburg",
      tone: 'semantic',
    },
    {
      german: "bei Kommunalwahlen",
      translated: "na lokalnim izborima",
      tone: 'semantic',
    },
    {
      german: "wählen",
      translated: "glasovati",
      tone: 'semantic',
    },
  ],
  "lid:state:BB:4|el": [
    {
      german: "Ab welchem Alter",
      translated: "Από ποια ηλικία",
      tone: 'semantic',
    },
    {
      german: "darf man",
      translated: "μπορεί κάποιος",
      tone: 'semantic',
    },
    {
      german: "in Brandenburg",
      translated: "στο Βρανδεμβούργο",
      tone: 'semantic',
    },
    {
      german: "bei Kommunalwahlen",
      translated: "στις δημοτικές εκλογές",
      tone: 'semantic',
    },
    {
      german: "wählen",
      translated: "να ψηφίσει",
      tone: 'semantic',
    },
  ],
  "lid:state:BB:4|en": [
    {
      german: "Ab welchem Alter",
      translated: "From what age",
      tone: 'semantic',
    },
    {
      german: "darf man",
      translated: "can you",
      tone: 'semantic',
    },
    {
      german: "in Brandenburg",
      translated: "in Brandenburg",
      tone: 'semantic',
    },
    {
      german: "bei Kommunalwahlen",
      translated: "local elections",
      tone: 'semantic',
    },
    {
      german: "wählen",
      translated: "vote",
      tone: 'semantic',
    },
  ],
  "lid:state:BB:4|es": [
    {
      german: "Ab welchem Alter",
      translated: "A partir de qué edad",
      tone: 'semantic',
    },
    {
      german: "darf man",
      translated: "se puede",
      tone: 'semantic',
    },
    {
      german: "in Brandenburg",
      translated: "de Brandeburgo",
      tone: 'semantic',
    },
    {
      german: "bei Kommunalwahlen",
      translated: "en las elecciones municipales",
      tone: 'semantic',
    },
    {
      german: "wählen",
      translated: "votar",
      tone: 'semantic',
    },
  ],
  "lid:state:BB:4|fa": [
    {
      german: "Ab welchem Alter",
      translated: "از چه سنی",
      tone: 'semantic',
    },
    {
      german: "darf man",
      translated: "می‌توان",
      tone: 'semantic',
    },
    {
      german: "bei Kommunalwahlen",
      translated: "در انتخابات محلی",
      tone: 'semantic',
    },
    {
      german: "wählen",
      translated: "رأی داد",
      tone: 'semantic',
    },
  ],
  "lid:state:BB:4|fr": [
    {
      german: "Ab welchem Alter",
      translated: "À partir de quel âge",
      tone: 'semantic',
    },
    {
      german: "darf man",
      translated: "peut-on",
      tone: 'semantic',
    },
    {
      german: "in Brandenburg",
      translated: "en Brandebourg",
      tone: 'semantic',
    },
    {
      german: "bei Kommunalwahlen",
      translated: "aux élections municipales",
      tone: 'semantic',
    },
    {
      german: "wählen",
      translated: "voter",
      tone: 'semantic',
    },
  ],
  "lid:state:BB:4|hr": [
    {
      german: "Ab welchem Alter",
      translated: "Od koje se dobi",
      tone: 'semantic',
    },
    {
      german: "darf man",
      translated: "može",
      tone: 'semantic',
    },
    {
      german: "in Brandenburg",
      translated: "u saveznoj zemlji Brandenburg",
      tone: 'semantic',
    },
    {
      german: "bei Kommunalwahlen",
      translated: "na lokalnim izborima",
      tone: 'semantic',
    },
    {
      german: "wählen",
      translated: "glasovati",
      tone: 'semantic',
    },
  ],
  "lid:state:BB:4|it": [
    {
      german: "Ab welchem Alter",
      translated: "Da quale età",
      tone: 'semantic',
    },
    {
      german: "darf man",
      translated: "si può",
      tone: 'semantic',
    },
    {
      german: "in Brandenburg",
      translated: "in Brandeburgo",
      tone: 'semantic',
    },
    {
      german: "bei Kommunalwahlen",
      translated: "alle elezioni comunali",
      tone: 'semantic',
    },
    {
      german: "wählen",
      translated: "votare",
      tone: 'semantic',
    },
  ],
  "lid:state:BB:4|kmr": [
    {
      german: "Ab welchem Alter",
      translated: "kîjan",
      tone: 'semantic',
    },
    {
      german: "darf man",
      translated: "temenê",
      tone: 'semantic',
    },
    {
      german: "in Brandenburg",
      translated: "li Brandenburg",
      tone: 'semantic',
    },
    {
      german: "bei Kommunalwahlen",
      translated: "di hilbijartinên şaredariyê",
      tone: 'semantic',
    },
    {
      german: "wählen",
      translated: "deng were dayîn",
      tone: 'semantic',
    },
  ],
  "lid:state:BB:4|pl": [
    {
      german: "Ab welchem Alter",
      translated: "Od jakiego wieku",
      tone: 'semantic',
    },
    {
      german: "darf man",
      translated: "można",
      tone: 'semantic',
    },
    {
      german: "in Brandenburg",
      translated: "w Brandenburgii",
      tone: 'semantic',
    },
    {
      german: "bei Kommunalwahlen",
      translated: "w wyborach samorządowych",
      tone: 'semantic',
    },
    {
      german: "wählen",
      translated: "głosować",
      tone: 'semantic',
    },
  ],
  "lid:state:BB:4|prs": [
    {
      german: "Ab welchem Alter",
      translated: "از چه سنی",
      tone: 'semantic',
    },
    {
      german: "darf man",
      translated: "می‌توان",
      tone: 'semantic',
    },
    {
      german: "in Brandenburg",
      translated: "براندنبورگ",
      tone: 'semantic',
    },
    {
      german: "bei Kommunalwahlen",
      translated: "در انتخابات شاروالی",
      tone: 'semantic',
    },
    {
      german: "wählen",
      translated: "رأی داد",
      tone: 'semantic',
    },
  ],
  "lid:state:BB:4|ro": [
    {
      german: "Ab welchem Alter",
      translated: "De la ce vârstă",
      tone: 'semantic',
    },
    {
      german: "darf man",
      translated: "se poate",
      tone: 'semantic',
    },
    {
      german: "in Brandenburg",
      translated: "din Brandenburg",
      tone: 'semantic',
    },
    {
      german: "bei Kommunalwahlen",
      translated: "la alegerile locale",
      tone: 'semantic',
    },
    {
      german: "wählen",
      translated: "vota",
      tone: 'semantic',
    },
  ],
  "lid:state:BB:4|ru": [
    {
      german: "Ab welchem Alter",
      translated: "С какого возраста",
      tone: 'semantic',
    },
    {
      german: "darf man",
      translated: "можно",
      tone: 'semantic',
    },
    {
      german: "in Brandenburg",
      translated: "в федеральной земле Бранденбург",
      tone: 'semantic',
    },
    {
      german: "bei Kommunalwahlen",
      translated: "на муниципальных выборах",
      tone: 'semantic',
    },
    {
      german: "wählen",
      translated: "голосовать",
      tone: 'semantic',
    },
  ],
  "lid:state:BB:4|sq": [
    {
      german: "Ab welchem Alter",
      translated: "Nga cila moshë",
      tone: 'semantic',
    },
    {
      german: "darf man",
      translated: "mund të",
      tone: 'semantic',
    },
    {
      german: "in Brandenburg",
      translated: "në Brandenburgu",
      tone: 'semantic',
    },
    {
      german: "bei Kommunalwahlen",
      translated: "në zgjedhjet komunale",
      tone: 'semantic',
    },
    {
      german: "wählen",
      translated: "votohet",
      tone: 'semantic',
    },
  ],
  "lid:state:BB:4|sr": [
    {
      german: "Ab welchem Alter",
      translated: "Od koje se dobi",
      tone: 'semantic',
    },
    {
      german: "darf man",
      translated: "može",
      tone: 'semantic',
    },
    {
      german: "in Brandenburg",
      translated: "u saveznoj pokrajini Brandenburg",
      tone: 'semantic',
    },
    {
      german: "bei Kommunalwahlen",
      translated: "na lokalnim izborima",
      tone: 'semantic',
    },
    {
      german: "wählen",
      translated: "glasati",
      tone: 'semantic',
    },
  ],
  "lid:state:BB:4|tr": [
    {
      german: "Ab welchem Alter",
      translated: "kaç yaşından itibaren",
      tone: 'semantic',
    },
    {
      german: "darf man",
      translated: "oy kullanılabilir",
      tone: 'semantic',
    },
    {
      german: "in Brandenburg",
      translated: "Brandenburg eyaletinde",
      tone: 'semantic',
    },
    {
      german: "bei Kommunalwahlen",
      translated: "yerel seçimlerde",
      tone: 'semantic',
    },
  ],
  "lid:state:BB:4|uk": [
    {
      german: "Ab welchem Alter",
      translated: "З якого віку",
      tone: 'semantic',
    },
    {
      german: "darf man",
      translated: "у федеральній землі",
      tone: 'semantic',
    },
    {
      german: "in Brandenburg",
      translated: "Бранденбург",
      tone: 'semantic',
    },
    {
      german: "bei Kommunalwahlen",
      translated: "на муніципальних виборах",
      tone: 'semantic',
    },
    {
      german: "wählen",
      translated: "можна голосувати",
      tone: 'semantic',
    },
  ],
  "lid:state:BB:4|vi": [
    {
      german: "Ab welchem Alter",
      translated: "Từ bao nhiêu tuổi",
      tone: 'semantic',
    },
    {
      german: "darf man",
      translated: "có thể",
      tone: 'semantic',
    },
    {
      german: "in Brandenburg",
      translated: "ở bang Brandenburg",
      tone: 'semantic',
    },
    {
      german: "bei Kommunalwahlen",
      translated: "trong bầu cử địa phương",
      tone: 'semantic',
    },
    {
      german: "wählen",
      translated: "bỏ phiếu",
      tone: 'semantic',
    },
  ],
  "lid:state:BB:5|ar": [
    {
      german: "Welche Farben",
      translated: "ما",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "ألوان",
      tone: 'semantic',
    },
    {
      german: "die Landesflagge",
      translated: "علم ولاية",
      tone: 'semantic',
    },
    {
      german: "von Brandenburg",
      translated: "Brandenburg",
      tone: 'semantic',
    },
  ],
  "lid:state:BB:5|bg": [
    {
      german: "Welche Farben",
      translated: "Какви са",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "цветовете",
      tone: 'semantic',
    },
    {
      german: "die Landesflagge",
      translated: "знамето",
      tone: 'semantic',
    },
    {
      german: "von Brandenburg",
      translated: "на провинция Бранденбург",
      tone: 'semantic',
    },
  ],
  "lid:state:BB:5|bs": [
    {
      german: "Welche Farben",
      translated: "Koje su boje",
      tone: 'semantic',
    },
    {
      german: "die Landesflagge",
      translated: "zastave",
      tone: 'semantic',
    },
    {
      german: "von Brandenburg",
      translated: "savezne zemlje Brandenburg",
      tone: 'semantic',
    },
  ],
  "lid:state:BB:5|el": [
    {
      german: "Welche Farben",
      translated: "Ποια είναι τα χρώματα",
      tone: 'semantic',
    },
    {
      german: "die Landesflagge",
      translated: "της σημαίας του κρατιδίου Βρανδεμβούργο",
      tone: 'semantic',
    },
  ],
  "lid:state:BB:5|en": [
    {
      german: "Welche Farben",
      translated: "What colors",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "does",
      tone: 'semantic',
    },
    {
      german: "die Landesflagge",
      translated: "the state flag",
      tone: 'semantic',
    },
    {
      german: "von Brandenburg",
      translated: "of Brandenburg",
      tone: 'semantic',
    },
  ],
  "lid:state:BB:5|es": [
    {
      german: "Welche Farben",
      translated: "¿Qué colores",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "tiene",
      tone: 'semantic',
    },
    {
      german: "die Landesflagge",
      translated: "la bandera regional",
      tone: 'semantic',
    },
    {
      german: "von Brandenburg",
      translated: "de Brandeburgo",
      tone: 'semantic',
    },
  ],
  "lid:state:BB:5|fa": [
    {
      german: "Welche Farben",
      translated: "رنگ‌های",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "کدام‌اند",
      tone: 'semantic',
    },
    {
      german: "die Landesflagge",
      translated: "پرچم ایالت",
      tone: 'semantic',
    },
    {
      german: "von Brandenburg",
      translated: "براندنبورگ",
      tone: 'semantic',
    },
  ],
  "lid:state:BB:5|fr": [
    {
      german: "Welche Farben",
      translated: "Quelles sont les couleurs",
      tone: 'semantic',
    },
    {
      german: "die Landesflagge",
      translated: "du drapeau du Land",
      tone: 'semantic',
    },
    {
      german: "von Brandenburg",
      translated: "de Brandebourg",
      tone: 'semantic',
    },
  ],
  "lid:state:BB:5|hr": [
    {
      german: "Welche Farben",
      translated: "Koje su boje",
      tone: 'semantic',
    },
    {
      german: "die Landesflagge",
      translated: "zastave savezne zemlje",
      tone: 'semantic',
    },
    {
      german: "von Brandenburg",
      translated: "Brandenburg",
      tone: 'semantic',
    },
  ],
  "lid:state:BB:5|it": [
    {
      german: "Welche Farben",
      translated: "Quali sono i colori",
      tone: 'semantic',
    },
    {
      german: "die Landesflagge",
      translated: "della bandiera",
      tone: 'semantic',
    },
    {
      german: "von Brandenburg",
      translated: "del Land di Brandeburgo",
      tone: 'semantic',
    },
  ],
  "lid:state:BB:5|kmr": [
    {
      german: "Welche Farben",
      translated: "Rengên",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "çi ne",
      tone: 'semantic',
    },
    {
      german: "die Landesflagge",
      translated: "ala eyaleta",
      tone: 'semantic',
    },
    {
      german: "von Brandenburg",
      translated: "Brandenburg",
      tone: 'semantic',
    },
  ],
  "lid:state:BB:5|pl": [
    {
      german: "Welche Farben",
      translated: "Jakie są kolory",
      tone: 'semantic',
    },
    {
      german: "die Landesflagge",
      translated: "flagi kraju związkowego",
      tone: 'semantic',
    },
    {
      german: "von Brandenburg",
      translated: "Brandenburgia",
      tone: 'semantic',
    },
  ],
  "lid:state:BB:5|prs": [
    {
      german: "Welche Farben",
      translated: "رنگ‌های",
      tone: 'semantic',
    },
    {
      german: "die Landesflagge",
      translated: "پرچم ایالت",
      tone: 'semantic',
    },
    {
      german: "von Brandenburg",
      translated: "براندنبورگ",
      tone: 'semantic',
    },
  ],
  "lid:state:BB:5|ro": [
    {
      german: "Welche Farben",
      translated: "Care sunt culorile",
      tone: 'semantic',
    },
    {
      german: "die Landesflagge",
      translated: "drapelului landului",
      tone: 'semantic',
    },
    {
      german: "von Brandenburg",
      translated: "Brandenburg",
      tone: 'semantic',
    },
  ],
  "lid:state:BB:5|ru": [
    {
      german: "Welche Farben",
      translated: "Какие цвета",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "у",
      tone: 'semantic',
    },
    {
      german: "die Landesflagge",
      translated: "флага земли",
      tone: 'semantic',
    },
    {
      german: "von Brandenburg",
      translated: "Бранденбург",
      tone: 'semantic',
    },
  ],
  "lid:state:BB:5|sq": [
    {
      german: "Welche Farben",
      translated: "Cilat janë ngjyrat",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "e",
      tone: 'semantic',
    },
    {
      german: "die Landesflagge",
      translated: "flamurit",
      tone: 'semantic',
    },
    {
      german: "von Brandenburg",
      translated: "landit Brandenburgu",
      tone: 'semantic',
    },
  ],
  "lid:state:BB:5|sr": [
    {
      german: "Welche Farben",
      translated: "Koje su boje",
      tone: 'semantic',
    },
    {
      german: "die Landesflagge",
      translated: "zastave",
      tone: 'semantic',
    },
    {
      german: "von Brandenburg",
      translated: "savezne pokrajine Brandenburg",
      tone: 'semantic',
    },
  ],
  "lid:state:BB:5|tr": [
    {
      german: "Welche Farben",
      translated: "renkleri nelerdir",
      tone: 'semantic',
    },
    {
      german: "die Landesflagge",
      translated: "eyalet bayrağının",
      tone: 'semantic',
    },
    {
      german: "von Brandenburg",
      translated: "Brandenburg",
      tone: 'semantic',
    },
  ],
  "lid:state:BB:5|uk": [
    {
      german: "Welche Farben",
      translated: "Які кольори",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: " має",
      tone: 'semantic',
    },
    {
      german: "die Landesflagge",
      translated: "прапор федеральної землі",
      tone: 'semantic',
    },
    {
      german: "von Brandenburg",
      translated: "Бранденбург",
      tone: 'semantic',
    },
  ],
  "lid:state:BB:5|vi": [
    {
      german: "Welche Farben",
      translated: "Màu",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "là",
      tone: 'semantic',
    },
    {
      german: "die Landesflagge",
      translated: "cờ bang",
      tone: 'semantic',
    },
    {
      german: "von Brandenburg",
      translated: "Brandenburg",
      tone: 'semantic',
    },
  ],
  "lid:state:BB:6|ar": [
    {
      german: "Wo",
      translated: "أين",
      tone: 'semantic',
    },
    {
      german: "in Brandenburg",
      translated: "في Brandenburg",
      tone: 'semantic',
    },
    {
      german: "über politische Themen",
      translated: "عن القضايا السياسية",
      tone: 'semantic',
    },
    {
      german: "informieren",
      translated: "الحصول على معلومات",
      tone: 'semantic',
    },
  ],
  "lid:state:BB:6|bg": [
    {
      german: "Wo",
      translated: "Къде",
      tone: 'semantic',
    },
    {
      german: "können",
      translated: "можете",
      tone: 'semantic',
    },
    {
      german: "in Brandenburg",
      translated: "в Бранденбург",
      tone: 'semantic',
    },
    {
      german: "über politische Themen",
      translated: "по политически теми",
      tone: 'semantic',
    },
    {
      german: "informieren",
      translated: "получите информация",
      tone: 'semantic',
    },
  ],
  "lid:state:BB:6|bs": [
    {
      german: "Wo",
      translated: "Gdje",
      tone: 'semantic',
    },
    {
      german: "können",
      translated: "mogu",
      tone: 'semantic',
    },
    {
      german: "Sie",
      translated: "se",
      tone: 'semantic',
    },
    {
      german: "in Brandenburg",
      translated: "u saveznoj zemlji Brandenburg",
      tone: 'semantic',
    },
    {
      german: "über politische Themen",
      translated: "o političkim temama",
      tone: 'semantic',
    },
    {
      german: "informieren",
      translated: "dobiti informacije",
      tone: 'semantic',
    },
  ],
  "lid:state:BB:6|el": [
    {
      german: "Wo",
      translated: "Πού",
      tone: 'semantic',
    },
    {
      german: "können",
      translated: "μπορείτε",
      tone: 'semantic',
    },
    {
      german: "in Brandenburg",
      translated: "στο Βρανδεμβούργο",
      tone: 'semantic',
    },
    {
      german: "über politische Themen",
      translated: "για πολιτικά θέματα",
      tone: 'semantic',
    },
    {
      german: "informieren",
      translated: "ενημερωθείτε",
      tone: 'semantic',
    },
  ],
  "lid:state:BB:6|en": [
    {
      german: "Wo",
      translated: "Where",
      tone: 'semantic',
    },
    {
      german: "können",
      translated: "can",
      tone: 'semantic',
    },
    {
      german: "Sie",
      translated: "you",
      tone: 'semantic',
    },
    {
      german: "in Brandenburg",
      translated: "in Brandenburg",
      tone: 'semantic',
    },
    {
      german: "über politische Themen",
      translated: "about political topics",
      tone: 'semantic',
    },
    {
      german: "informieren",
      translated: "get information",
      tone: 'semantic',
    },
  ],
  "lid:state:BB:6|es": [
    {
      german: "Wo",
      translated: "¿Dónde",
      tone: 'semantic',
    },
    {
      german: "können",
      translated: "puede",
      tone: 'semantic',
    },
    {
      german: "in Brandenburg",
      translated: "en Brandeburgo",
      tone: 'semantic',
    },
    {
      german: "über politische Themen",
      translated: "sobre temas políticos",
      tone: 'semantic',
    },
    {
      german: "informieren",
      translated: "informarse",
      tone: 'semantic',
    },
  ],
  "lid:state:BB:6|fa": [
    {
      german: "Wo",
      translated: "کجا",
      tone: 'semantic',
    },
    {
      german: "können",
      translated: "می‌توانید",
      tone: 'semantic',
    },
    {
      german: "in Brandenburg",
      translated: "در براندنبورگ",
      tone: 'semantic',
    },
    {
      german: "über politische Themen",
      translated: "دربارهٔ موضوعات سیاسی",
      tone: 'semantic',
    },
    {
      german: "informieren",
      translated: "اطلاعات کسب کنید",
      tone: 'semantic',
    },
  ],
  "lid:state:BB:6|fr": [
    {
      german: "Wo",
      translated: "Où",
      tone: 'semantic',
    },
    {
      german: "können",
      translated: "pouvez",
      tone: 'semantic',
    },
    {
      german: "Sie",
      translated: "vous",
      tone: 'semantic',
    },
    {
      german: "sich",
      translated: "vous",
      tone: 'semantic',
    },
    {
      german: "in Brandenburg",
      translated: "en Brandebourg",
      tone: 'semantic',
    },
    {
      german: "über politische Themen",
      translated: "sur les questions politiques",
      tone: 'semantic',
    },
    {
      german: "informieren",
      translated: "informer",
      tone: 'semantic',
    },
  ],
  "lid:state:BB:6|hr": [
    {
      german: "Wo",
      translated: "Gdje",
      tone: 'semantic',
    },
    {
      german: "können",
      translated: "mogu",
      tone: 'semantic',
    },
    {
      german: "Sie",
      translated: "se",
      tone: 'semantic',
    },
    {
      german: "in Brandenburg",
      translated: "u saveznoj zemlji Brandenburg",
      tone: 'semantic',
    },
    {
      german: "über politische Themen",
      translated: "o političkim temama",
      tone: 'semantic',
    },
    {
      german: "informieren",
      translated: "dobiti informacije",
      tone: 'semantic',
    },
  ],
  "lid:state:BB:6|it": [
    {
      german: "Wo",
      translated: "Dove",
      tone: 'semantic',
    },
    {
      german: "können",
      translated: "può",
      tone: 'semantic',
    },
    {
      german: "sich",
      translated: "ci si",
      tone: 'semantic',
    },
    {
      german: "in Brandenburg",
      translated: "in Brandeburgo",
      tone: 'semantic',
    },
    {
      german: "über politische Themen",
      translated: "su temi politici",
      tone: 'semantic',
    },
    {
      german: "informieren",
      translated: "informare",
      tone: 'semantic',
    },
  ],
  "lid:state:BB:6|kmr": [
    {
      german: "Wo",
      translated: "Li",
      tone: 'semantic',
    },
    {
      german: "sich",
      translated: "dikarî",
      tone: 'semantic',
    },
    {
      german: "in Brandenburg",
      translated: "Brandenburg",
      tone: 'semantic',
    },
    {
      german: "über politische Themen",
      translated: "li ser mijarên siyasî",
      tone: 'semantic',
    },
    {
      german: "informieren",
      translated: "agahdarî bistînî",
      tone: 'semantic',
    },
  ],
  "lid:state:BB:6|pl": [
    {
      german: "Wo",
      translated: "Gdzie",
      tone: 'semantic',
    },
    {
      german: "können",
      translated: "można",
      tone: 'semantic',
    },
    {
      german: "in Brandenburg",
      translated: "w Brandenburgii",
      tone: 'semantic',
    },
    {
      german: "über politische Themen",
      translated: "na tematy polityczne",
      tone: 'semantic',
    },
    {
      german: "informieren",
      translated: "uzyskać informacje",
      tone: 'semantic',
    },
  ],
  "lid:state:BB:6|prs": [
    {
      german: "können",
      translated: "می‌توانید",
      tone: 'semantic',
    },
    {
      german: "in Brandenburg",
      translated: "در براندنبورگ",
      tone: 'semantic',
    },
    {
      german: "über politische Themen",
      translated: "دربارهٔ موضوعات سیاسی",
      tone: 'semantic',
    },
    {
      german: "informieren",
      translated: "اطلاعات کسب کنید",
      tone: 'semantic',
    },
  ],
  "lid:state:BB:6|ro": [
    {
      german: "Wo",
      translated: "Unde",
      tone: 'semantic',
    },
    {
      german: "können",
      translated: "puteți",
      tone: 'semantic',
    },
    {
      german: "Sie",
      translated: "vă",
      tone: 'semantic',
    },
    {
      german: "in Brandenburg",
      translated: "în Brandenburg",
      tone: 'semantic',
    },
    {
      german: "über politische Themen",
      translated: "despre teme politice",
      tone: 'semantic',
    },
    {
      german: "informieren",
      translated: "informa",
      tone: 'semantic',
    },
  ],
  "lid:state:BB:6|ru": [
    {
      german: "Wo",
      translated: "Где",
      tone: 'semantic',
    },
    {
      german: "können",
      translated: "можно",
      tone: 'semantic',
    },
    {
      german: "in Brandenburg",
      translated: "в федеральной земле Бранденбург",
      tone: 'semantic',
    },
    {
      german: "über politische Themen",
      translated: "о политических темах",
      tone: 'semantic',
    },
    {
      german: "informieren",
      translated: "получить информацию",
      tone: 'semantic',
    },
  ],
  "lid:state:BB:6|sq": [
    {
      german: "Wo",
      translated: "Ku",
      tone: 'semantic',
    },
    {
      german: "können",
      translated: "mund",
      tone: 'semantic',
    },
    {
      german: "in Brandenburg",
      translated: "në Brandenburgu",
      tone: 'semantic',
    },
    {
      german: "über politische Themen",
      translated: "për tema politike",
      tone: 'semantic',
    },
    {
      german: "informieren",
      translated: "informoheni",
      tone: 'semantic',
    },
  ],
  "lid:state:BB:6|sr": [
    {
      german: "können",
      translated: "mogu",
      tone: 'semantic',
    },
    {
      german: "sich",
      translated: "se",
      tone: 'semantic',
    },
    {
      german: "in Brandenburg",
      translated: "u saveznoj pokrajini Brandenburg",
      tone: 'semantic',
    },
    {
      german: "über politische Themen",
      translated: "o političkim temama",
      tone: 'semantic',
    },
    {
      german: "informieren",
      translated: "dobiti informacije",
      tone: 'semantic',
    },
  ],
  "lid:state:BB:6|tr": [
    {
      german: "Wo",
      translated: "nereden",
      tone: 'semantic',
    },
    {
      german: "in Brandenburg",
      translated: "Brandenburg eyaletinde",
      tone: 'semantic',
    },
    {
      german: "über politische Themen",
      translated: "siyasi konular hakkında",
      tone: 'semantic',
    },
    {
      german: "informieren",
      translated: "bilgi alabilirsiniz",
      tone: 'semantic',
    },
  ],
  "lid:state:BB:6|uk": [
    {
      german: "Wo",
      translated: "Де",
      tone: 'semantic',
    },
    {
      german: "können",
      translated: "можна",
      tone: 'semantic',
    },
    {
      german: "in Brandenburg",
      translated: "у федеральній землі Бранденбург",
      tone: 'semantic',
    },
    {
      german: "über politische Themen",
      translated: "про політичні питання",
      tone: 'semantic',
    },
    {
      german: "informieren",
      translated: "отримати інформацію",
      tone: 'semantic',
    },
  ],
  "lid:state:BB:6|vi": [
    {
      german: "Wo",
      translated: "ở đâu",
      tone: 'semantic',
    },
    {
      german: "können",
      translated: "có thể",
      tone: 'semantic',
    },
    {
      german: "in Brandenburg",
      translated: "bang Brandenburg",
      tone: 'semantic',
    },
    {
      german: "über politische Themen",
      translated: "về các chủ đề chính trị",
      tone: 'semantic',
    },
    {
      german: "informieren",
      translated: "tìm thông tin",
      tone: 'semantic',
    },
  ],
  "lid:state:BB:7|ar": [
    {
      german: "Die Landeshauptstadt",
      translated: "ما عاصمة",
      tone: 'semantic',
    },
    {
      german: "von Brandenburg",
      translated: "Brandenburg",
      tone: 'semantic',
    },
    {
      german: "heißt",
      translated: "؟",
      tone: 'semantic',
    },
  ],
  "lid:state:BB:7|bg": [
    {
      german: "Die Landeshauptstadt",
      translated: "Столицата",
      tone: 'semantic',
    },
    {
      german: "von Brandenburg",
      translated: "на федералната провинция Бранденбург",
      tone: 'semantic',
    },
    {
      german: "heißt",
      translated: "е",
      tone: 'semantic',
    },
  ],
  "lid:state:BB:7|bs": [
    {
      german: "Die Landeshauptstadt",
      translated: "Glavni grad",
      tone: 'semantic',
    },
    {
      german: "von Brandenburg",
      translated: "savezne zemlje Brandenburg",
      tone: 'semantic',
    },
    {
      german: "heißt",
      translated: "je",
      tone: 'semantic',
    },
  ],
  "lid:state:BB:7|el": [
    {
      german: "Die Landeshauptstadt",
      translated: "Η πρωτεύουσα",
      tone: 'semantic',
    },
    {
      german: "von Brandenburg",
      translated: "Βρανδεμβούργο",
      tone: 'semantic',
    },
    {
      german: "heißt",
      translated: "είναι",
      tone: 'semantic',
    },
  ],
  "lid:state:BB:7|en": [
    {
      german: "Die Landeshauptstadt",
      translated: "The state capital",
      tone: 'semantic',
    },
    {
      german: "von Brandenburg",
      translated: "of Brandenburg",
      tone: 'semantic',
    },
    {
      german: "heißt",
      translated: "is called",
      tone: 'semantic',
    },
  ],
  "lid:state:BB:7|es": [
    {
      german: "Die Landeshauptstadt",
      translated: "La capital",
      tone: 'semantic',
    },
    {
      german: "von Brandenburg",
      translated: "del estado federado de Brandeburgo",
      tone: 'semantic',
    },
    {
      german: "heißt",
      translated: "es",
      tone: 'semantic',
    },
  ],
  "lid:state:BB:7|fa": [
    {
      german: "Die Landeshauptstadt",
      translated: "مرکز ایالت",
      tone: 'semantic',
    },
    {
      german: "von Brandenburg",
      translated: "براندنبورگ",
      tone: 'semantic',
    },
  ],
  "lid:state:BB:7|fr": [
    {
      german: "Die Landeshauptstadt",
      translated: "La capitale du Land",
      tone: 'semantic',
    },
    {
      german: "von Brandenburg",
      translated: "de Brandebourg",
      tone: 'semantic',
    },
    {
      german: "heißt",
      translated: "s’appelle",
      tone: 'semantic',
    },
  ],
  "lid:state:BB:7|hr": [
    {
      german: "Die Landeshauptstadt",
      translated: "Glavni grad",
      tone: 'semantic',
    },
    {
      german: "von Brandenburg",
      translated: "savezne zemlje Brandenburg",
      tone: 'semantic',
    },
    {
      german: "heißt",
      translated: "je",
      tone: 'semantic',
    },
  ],
  "lid:state:BB:7|it": [
    {
      german: "Die Landeshauptstadt",
      translated: "La capitale del Land",
      tone: 'semantic',
    },
    {
      german: "von Brandenburg",
      translated: "di Brandeburgo",
      tone: 'semantic',
    },
    {
      german: "heißt",
      translated: "è",
      tone: 'semantic',
    },
  ],
  "lid:state:BB:7|kmr": [
    {
      german: "Die Landeshauptstadt",
      translated: "Paytexta eyaleta",
      tone: 'semantic',
    },
    {
      german: "von Brandenburg",
      translated: "Brandenburg",
      tone: 'semantic',
    },
    {
      german: "heißt",
      translated: "e.",
      tone: 'semantic',
    },
  ],
  "lid:state:BB:7|pl": [
    {
      german: "Die Landeshauptstadt",
      translated: "Stolicą kraju związkowego",
      tone: 'semantic',
    },
    {
      german: "von Brandenburg",
      translated: "Brandenburgia",
      tone: 'semantic',
    },
    {
      german: "heißt",
      translated: "jest",
      tone: 'semantic',
    },
  ],
  "lid:state:BB:7|prs": [
    {
      german: "Die Landeshauptstadt",
      translated: "مرکز ایالت",
      tone: 'semantic',
    },
    {
      german: "heißt",
      translated: "است.",
      tone: 'semantic',
    },
  ],
  "lid:state:BB:7|ro": [
    {
      german: "Die Landeshauptstadt",
      translated: "Capitala landului",
      tone: 'semantic',
    },
    {
      german: "von Brandenburg",
      translated: "Brandenburg",
      tone: 'semantic',
    },
  ],
  "lid:state:BB:7|ru": [
    {
      german: "Die Landeshauptstadt",
      translated: "Столица земли",
      tone: 'semantic',
    },
    {
      german: "von Brandenburg",
      translated: "Бранденбург",
      tone: 'semantic',
    },
    {
      german: "heißt",
      translated: "называется",
      tone: 'semantic',
    },
  ],
  "lid:state:BB:7|sq": [
    {
      german: "Die Landeshauptstadt",
      translated: "Kryeqyteti",
      tone: 'semantic',
    },
    {
      german: "von Brandenburg",
      translated: "landit Brandenburgu",
      tone: 'semantic',
    },
    {
      german: "heißt",
      translated: " është",
      tone: 'semantic',
    },
  ],
  "lid:state:BB:7|sr": [
    {
      german: "Die Landeshauptstadt",
      translated: "Glavni grad",
      tone: 'semantic',
    },
    {
      german: "von Brandenburg",
      translated: "savezne pokrajine Brandenburg",
      tone: 'semantic',
    },
  ],
  "lid:state:BB:7|tr": [
    {
      german: "Die Landeshauptstadt",
      translated: "başkenti",
      tone: 'semantic',
    },
    {
      german: "von Brandenburg",
      translated: "Brandenburg eyaletinin",
      tone: 'semantic',
    },
  ],
  "lid:state:BB:7|uk": [
    {
      german: "Die Landeshauptstadt",
      translated: "Столиця",
      tone: 'semantic',
    },
    {
      german: "von Brandenburg",
      translated: "федеральної землі Бранденбург",
      tone: 'semantic',
    },
    {
      german: "heißt",
      translated: "називається",
      tone: 'semantic',
    },
  ],
  "lid:state:BB:7|vi": [
    {
      german: "Die Landeshauptstadt",
      translated: "Thủ phủ của bang",
      tone: 'semantic',
    },
    {
      german: "von Brandenburg",
      translated: "Brandenburg",
      tone: 'semantic',
    },
    {
      german: "heißt",
      translated: "là …",
      tone: 'semantic',
    },
  ],
  "lid:state:BB:8|ar": [
    {
      german: "Welches Bundesland",
      translated: "أي صورة",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "تمثل موقع ولاية",
      tone: 'semantic',
    },
    {
      german: "Brandenburg",
      translated: "Brandenburg",
      tone: 'semantic',
    },
  ],
  "lid:state:BB:8|bg": [
    {
      german: "Welches Bundesland",
      translated: "Коя от показаните федерални провинции",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "е",
      tone: 'semantic',
    },
    {
      german: "Brandenburg",
      translated: "Бранденбург",
      tone: 'semantic',
    },
  ],
  "lid:state:BB:8|bs": [
    {
      german: "Welches Bundesland",
      translated: "Koja od prikazanih",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "je",
      tone: 'semantic',
    },
    {
      german: "Brandenburg",
      translated: "Brandenburg",
      tone: 'semantic',
    },
  ],
  "lid:state:BB:8|el": [
    {
      german: "Welches Bundesland",
      translated: "Ποιο από τα εικονιζόμενα κρατίδια",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "είναι",
      tone: 'semantic',
    },
    {
      german: "Brandenburg",
      translated: "Βρανδεμβούργο",
      tone: 'semantic',
    },
  ],
  "lid:state:BB:8|en": [
    {
      german: "Welches Bundesland",
      translated: "Which federal state",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "is",
      tone: 'semantic',
    },
    {
      german: "Brandenburg",
      translated: "Brandenburg",
      tone: 'semantic',
    },
  ],
  "lid:state:BB:8|es": [
    {
      german: "Welches Bundesland",
      translated: "¿Cuál de las imágenes corresponde al estado federado",
      tone: 'semantic',
    },
    {
      german: "Brandenburg",
      translated: "Brandeburgo",
      tone: 'semantic',
    },
  ],
  "lid:state:BB:8|fa": [
    {
      german: "Welches Bundesland",
      translated: "کدام ایالتِ",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "است",
      tone: 'semantic',
    },
    {
      german: "Brandenburg",
      translated: "براندنبورگ",
      tone: 'semantic',
    },
  ],
  "lid:state:BB:8|fr": [
    {
      german: "Welches Bundesland",
      translated: "Quel Land",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "est",
      tone: 'semantic',
    },
    {
      german: "Brandenburg",
      translated: "Brandebourg",
      tone: 'semantic',
    },
  ],
  "lid:state:BB:8|hr": [
    {
      german: "Welches Bundesland",
      translated: "Koja od prikazanih saveznih zemalja",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "je",
      tone: 'semantic',
    },
    {
      german: "Brandenburg",
      translated: "Brandenburg",
      tone: 'semantic',
    },
  ],
  "lid:state:BB:8|it": [
    {
      german: "Welches Bundesland",
      translated: "Quale Land rappresentato",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "è",
      tone: 'semantic',
    },
    {
      german: "Brandenburg",
      translated: "Brandeburgo",
      tone: 'semantic',
    },
  ],
  "lid:state:BB:8|kmr": [
    {
      german: "Welches Bundesland",
      translated: "Kîjan eyalet",
      tone: 'semantic',
    },
    {
      german: "Brandenburg",
      translated: "Brandenburg",
      tone: 'semantic',
    },
  ],
  "lid:state:BB:8|pl": [
    {
      german: "Welches Bundesland",
      translated: "Który z przedstawionych krajów związkowych",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "to",
      tone: 'semantic',
    },
    {
      german: "Brandenburg",
      translated: "Brandenburgia",
      tone: 'semantic',
    },
  ],
  "lid:state:BB:8|prs": [
    {
      german: "Welches Bundesland",
      translated: "کدام ایالتِ",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "است",
      tone: 'semantic',
    },
    {
      german: "Brandenburg",
      translated: "براندنبورگ",
      tone: 'semantic',
    },
  ],
  "lid:state:BB:8|ro": [
    {
      german: "Welches Bundesland",
      translated: "Care land reprezentat",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "este",
      tone: 'semantic',
    },
    {
      german: "Brandenburg",
      translated: "Brandenburg",
      tone: 'semantic',
    },
  ],
  "lid:state:BB:8|ru": [
    {
      german: "Welches Bundesland",
      translated: "Какая из этих земель",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "—",
      tone: 'semantic',
    },
    {
      german: "Brandenburg",
      translated: "Бранденбург",
      tone: 'semantic',
    },
  ],
  "lid:state:BB:8|sq": [
    {
      german: "Welches Bundesland",
      translated: "Cili nga landet e paraqitura",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "është",
      tone: 'semantic',
    },
    {
      german: "Brandenburg",
      translated: "Brandenburgu",
      tone: 'semantic',
    },
  ],
  "lid:state:BB:8|sr": [
    {
      german: "Welches Bundesland",
      translated: "Koja od prikazanih saveznih",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "je",
      tone: 'semantic',
    },
    {
      german: "Brandenburg",
      translated: "Brandenburg",
      tone: 'semantic',
    },
  ],
  "lid:state:BB:8|tr": [
    {
      german: "Welches Bundesland",
      translated: "hangi numarayla",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "gösterilmiştir",
      tone: 'semantic',
    },
    {
      german: "Brandenburg",
      translated: "Brandenburg",
      tone: 'semantic',
    },
  ],
  "lid:state:BB:8|uk": [
    {
      german: "Welches Bundesland",
      translated: "Яка з позначених федеральних земель",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "є",
      tone: 'semantic',
    },
    {
      german: "Brandenburg",
      translated: "Бранденбург",
      tone: 'semantic',
    },
  ],
  "lid:state:BB:8|vi": [
    {
      german: "Welches Bundesland",
      translated: "nào",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "được",
      tone: 'semantic',
    },
    {
      german: "Brandenburg",
      translated: "Brandenburg",
      tone: 'semantic',
    },
  ],
  "lid:state:BB:9|ar": [
    {
      german: "Wie nennt man",
      translated: "ماذا يُسمى",
      tone: 'semantic',
    },
    {
      german: "die Regierungschefin/den Regierungschef",
      translated: "رئيس/رئيسة حكومة",
      tone: 'semantic',
    },
    {
      german: "in Brandenburg",
      translated: "ولاية Brandenburg",
      tone: 'semantic',
    },
  ],
  "lid:state:BB:9|bg": [
    {
      german: "Wie nennt man",
      translated: "Как се нарича",
      tone: 'semantic',
    },
    {
      german: "die Regierungschefin/den Regierungschef",
      translated: "ръководителят",
      tone: 'semantic',
    },
    {
      german: "in Brandenburg",
      translated: "на правителството на провинция Бранденбург",
      tone: 'semantic',
    },
  ],
  "lid:state:BB:9|bs": [
    {
      german: "Wie nennt man",
      translated: "Kako se zove",
      tone: 'semantic',
    },
    {
      german: "die Regierungschefin/den Regierungschef",
      translated: "šef vlade",
      tone: 'semantic',
    },
    {
      german: "in Brandenburg",
      translated: "savezne zemlje Brandenburg",
      tone: 'semantic',
    },
  ],
  "lid:state:BB:9|el": [
    {
      german: "Wie nennt man",
      translated: "Πώς ονομάζεται",
      tone: 'semantic',
    },
    {
      german: "die Regierungschefin/den Regierungschef",
      translated: "ο επικεφαλής της κυβέρνησης",
      tone: 'semantic',
    },
    {
      german: "in Brandenburg",
      translated: "του κρατιδίου Βρανδεμβούργο",
      tone: 'semantic',
    },
  ],
  "lid:state:BB:9|en": [
    {
      german: "Wie nennt man",
      translated: "What is",
      tone: 'semantic',
    },
    {
      german: "die Regierungschefin/den Regierungschef",
      translated: "the head of government",
      tone: 'semantic',
    },
    {
      german: "in Brandenburg",
      translated: "in Brandenburg",
      tone: 'semantic',
    },
  ],
  "lid:state:BB:9|es": [
    {
      german: "Wie nennt man",
      translated: "¿Cómo se llama al",
      tone: 'semantic',
    },
    {
      german: "die Regierungschefin/den Regierungschef",
      translated: "jefe o la jefa de gobierno",
      tone: 'semantic',
    },
    {
      german: "in Brandenburg",
      translated: "de Brandeburgo",
      tone: 'semantic',
    },
  ],
  "lid:state:BB:9|fa": [
    {
      german: "Wie nennt man",
      translated: "ایالت",
      tone: 'semantic',
    },
    {
      german: "die Regierungschefin/den Regierungschef",
      translated: "رئیس دولت",
      tone: 'semantic',
    },
    {
      german: "in Brandenburg",
      translated: "براندنبورگ",
      tone: 'semantic',
    },
  ],
  "lid:state:BB:9|fr": [
    {
      german: "Wie nennt man",
      translated: "Comment appelle-t-on",
      tone: 'semantic',
    },
    {
      german: "die Regierungschefin/den Regierungschef",
      translated: "le chef ou la cheffe du gouvernement",
      tone: 'semantic',
    },
    {
      german: "in Brandenburg",
      translated: "de Brandebourg",
      tone: 'semantic',
    },
  ],
  "lid:state:BB:9|hr": [
    {
      german: "Wie nennt man",
      translated: "Kako se zove",
      tone: 'semantic',
    },
    {
      german: "die Regierungschefin/den Regierungschef",
      translated: "čelnik vlade",
      tone: 'semantic',
    },
    {
      german: "in Brandenburg",
      translated: "Brandenburg",
      tone: 'semantic',
    },
  ],
  "lid:state:BB:9|it": [
    {
      german: "Wie nennt man",
      translated: "Come si chiama",
      tone: 'semantic',
    },
    {
      german: "die Regierungschefin/den Regierungschef",
      translated: "il capo del governo",
      tone: 'semantic',
    },
    {
      german: "in Brandenburg",
      translated: "del Land di Brandeburgo",
      tone: 'semantic',
    },
  ],
  "lid:state:BB:9|kmr": [
    {
      german: "Wie nennt man",
      translated: "Serokê",
      tone: 'semantic',
    },
    {
      german: "die Regierungschefin/den Regierungschef",
      translated: "hukûmeta",
      tone: 'semantic',
    },
    {
      german: "in Brandenburg",
      translated: "Brandenburg çi tê gotin",
      tone: 'semantic',
    },
  ],
  "lid:state:BB:9|pl": [
    {
      german: "Wie nennt man",
      translated: "Jak nazywa się",
      tone: 'semantic',
    },
    {
      german: "die Regierungschefin/den Regierungschef",
      translated: "szef rządu",
      tone: 'semantic',
    },
    {
      german: "in Brandenburg",
      translated: "Brandenburgia",
      tone: 'semantic',
    },
  ],
  "lid:state:BB:9|prs": [
    {
      german: "Wie nennt man",
      translated: "رئیس دولت ایالت",
      tone: 'semantic',
    },
    {
      german: "die Regierungschefin/den Regierungschef",
      translated: "براندنبورگ",
      tone: 'semantic',
    },
    {
      german: "in Brandenburg",
      translated: "چه عنوانی دارد؟",
      tone: 'semantic',
    },
  ],
  "lid:state:BB:9|ro": [
    {
      german: "Wie nennt man",
      translated: "Cum se",
      tone: 'semantic',
    },
    {
      german: "die Regierungschefin/den Regierungschef",
      translated: "șeful guvernului landului",
      tone: 'semantic',
    },
    {
      german: "in Brandenburg",
      translated: "Brandenburg?",
      tone: 'semantic',
    },
  ],
  "lid:state:BB:9|ru": [
    {
      german: "Wie nennt man",
      translated: "Как называют",
      tone: 'semantic',
    },
    {
      german: "die Regierungschefin/den Regierungschef",
      translated: "главу правительства",
      tone: 'semantic',
    },
    {
      german: "in Brandenburg",
      translated: "в федеральной земле Бранденбург",
      tone: 'semantic',
    },
  ],
  "lid:state:BB:9|sq": [
    {
      german: "Wie nennt man",
      translated: "Si quhet",
      tone: 'semantic',
    },
    {
      german: "die Regierungschefin/den Regierungschef",
      translated: "kreu i qeverisë",
      tone: 'semantic',
    },
    {
      german: "in Brandenburg",
      translated: "së landit Brandenburgu",
      tone: 'semantic',
    },
  ],
  "lid:state:BB:9|sr": [
    {
      german: "Wie nennt man",
      translated: "Kako se zove",
      tone: 'semantic',
    },
    {
      german: "die Regierungschefin/den Regierungschef",
      translated: "šef vlade",
      tone: 'semantic',
    },
    {
      german: "in Brandenburg",
      translated: "savezne pokrajine Brandenburg",
      tone: 'semantic',
    },
  ],
  "lid:state:BB:9|tr": [
    {
      german: "Wie nennt man",
      translated: "ne ad verilir",
      tone: 'semantic',
    },
    {
      german: "die Regierungschefin/den Regierungschef",
      translated: "hükümetinin başındaki kişiye",
      tone: 'semantic',
    },
    {
      german: "in Brandenburg",
      translated: "Brandenburg",
      tone: 'semantic',
    },
  ],
  "lid:state:BB:9|uk": [
    {
      german: "Wie nennt man",
      translated: "Як називають",
      tone: 'semantic',
    },
    {
      german: "die Regierungschefin/den Regierungschef",
      translated: "главу уряду",
      tone: 'semantic',
    },
    {
      german: "in Brandenburg",
      translated: "федеральної землі Бранденбург",
      tone: 'semantic',
    },
  ],
  "lid:state:BB:9|vi": [
    {
      german: "Wie nennt man",
      translated: "được gọi là gì?",
      tone: 'semantic',
    },
    {
      german: "die Regierungschefin/den Regierungschef",
      translated: "Người đứng đầu chính phủ",
      tone: 'semantic',
    },
    {
      german: "in Brandenburg",
      translated: "bang Brandenburg",
      tone: 'semantic',
    },
  ],
  "lid:state:BE:10|ar": [
    {
      german: "Welche Senatorin",
      translated: "أي منصب",
      tone: 'semantic',
    },
    {
      german: "welchen Senator",
      translated: "أعضاء مجلس الشيوخ",
      tone: 'semantic',
    },
    {
      german: "Berlin",
      translated: "Berlin",
      tone: 'semantic',
    },
    {
      german: "nicht",
      translated: "غير موجود",
      tone: 'semantic',
    },
  ],
  "lid:state:BE:10|bg": [
    {
      german: "Welche Senatorin",
      translated: "Коя",
      tone: 'semantic',
    },
    {
      german: "welchen Senator",
      translated: "сенаторска",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "съществува",
      tone: 'semantic',
    },
    {
      german: "Berlin",
      translated: "Берлин",
      tone: 'semantic',
    },
    {
      german: "nicht",
      translated: "не",
      tone: 'semantic',
    },
  ],
  "lid:state:BE:10|bs": [
    {
      german: "Welche Senatorin",
      translated: "Koja",
      tone: 'semantic',
    },
    {
      german: "welchen Senator",
      translated: "senatorska funkcija",
      tone: 'semantic',
    },
    {
      german: "Berlin",
      translated: "Berlinu",
      tone: 'semantic',
    },
    {
      german: "nicht",
      translated: "ne postoji",
      tone: 'semantic',
    },
  ],
  "lid:state:BE:10|el": [
    {
      german: "Welche Senatorin",
      translated: "Ποια",
      tone: 'semantic',
    },
    {
      german: "welchen Senator",
      translated: "θέση γερουσιαστή",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "υπάρχει",
      tone: 'semantic',
    },
    {
      german: "Berlin",
      translated: "Βερολίνο",
      tone: 'semantic',
    },
    {
      german: "nicht",
      translated: "δεν",
      tone: 'semantic',
    },
  ],
  "lid:state:BE:10|en": [
    {
      german: "Welche Senatorin",
      translated: "Which",
      tone: 'semantic',
    },
    {
      german: "welchen Senator",
      translated: "senator",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "does",
      tone: 'semantic',
    },
    {
      german: "Berlin",
      translated: "Berlin",
      tone: 'semantic',
    },
    {
      german: "nicht",
      translated: "not",
      tone: 'semantic',
    },
  ],
  "lid:state:BE:10|es": [
    {
      german: "Welche Senatorin",
      translated: "¿Qué cargo de senador o senadora",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "existe",
      tone: 'semantic',
    },
    {
      german: "Berlin",
      translated: "en Berlín",
      tone: 'semantic',
    },
    {
      german: "nicht",
      translated: "NO",
      tone: 'semantic',
    },
  ],
  "lid:state:BE:10|fa": [
    {
      german: "Welche Senatorin",
      translated: "کدام مقام",
      tone: 'semantic',
    },
    {
      german: "welchen Senator",
      translated: "سناتوری",
      tone: 'semantic',
    },
    {
      german: "Berlin",
      translated: "برلین",
      tone: 'semantic',
    },
    {
      german: "nicht",
      translated: "وجود ندارد",
      tone: 'semantic',
    },
  ],
  "lid:state:BE:10|fr": [
    {
      german: "Welche Senatorin",
      translated: "quelle sénatrice",
      tone: 'semantic',
    },
    {
      german: "welchen Senator",
      translated: "Quel sénateur",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "existe",
      tone: 'semantic',
    },
    {
      german: "Berlin",
      translated: "Berlin",
      tone: 'semantic',
    },
    {
      german: "nicht",
      translated: "pas",
      tone: 'semantic',
    },
  ],
  "lid:state:BE:10|hr": [
    {
      german: "Welche Senatorin",
      translated: "Koja",
      tone: 'semantic',
    },
    {
      german: "welchen Senator",
      translated: "senatorska funkcija",
      tone: 'semantic',
    },
    {
      german: "Berlin",
      translated: "Berlinu",
      tone: 'semantic',
    },
    {
      german: "nicht",
      translated: "ne postoji",
      tone: 'semantic',
    },
  ],
  "lid:state:BE:10|it": [
    {
      german: "welchen Senator",
      translated: "senatore",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "esiste",
      tone: 'semantic',
    },
    {
      german: "Berlin",
      translated: "Berlino",
      tone: 'semantic',
    },
    {
      german: "nicht",
      translated: "non",
      tone: 'semantic',
    },
  ],
  "lid:state:BE:10|kmr": [
    {
      german: "Welche Senatorin",
      translated: "Kîjan",
      tone: 'semantic',
    },
    {
      german: "welchen Senator",
      translated: "senator li",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "tune",
      tone: 'semantic',
    },
    {
      german: "Berlin",
      translated: "Berlînê",
      tone: 'semantic',
    },
    {
      german: "nicht",
      translated: "ye",
      tone: 'semantic',
    },
  ],
  "lid:state:BE:10|pl": [
    {
      german: "Welche Senatorin",
      translated: "Które stanowisko senatorskie",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "nie istnieje",
      tone: 'semantic',
    },
    {
      german: "Berlin",
      translated: "w Berlin",
      tone: 'semantic',
    },
  ],
  "lid:state:BE:10|prs": [
    {
      german: "Welche Senatorin",
      translated: "کدام مقام",
      tone: 'semantic',
    },
    {
      german: "welchen Senator",
      translated: "سناتوری",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "وجود ندارد",
      tone: 'semantic',
    },
    {
      german: "Berlin",
      translated: "برلین",
      tone: 'semantic',
    },
  ],
  "lid:state:BE:10|ro": [
    {
      german: "Welche Senatorin",
      translated: "Ce funcție de senator",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "există",
      tone: 'semantic',
    },
    {
      german: "Berlin",
      translated: "în Berlin",
      tone: 'semantic',
    },
    {
      german: "nicht",
      translated: "nu",
      tone: 'semantic',
    },
  ],
  "lid:state:BE:10|ru": [
    {
      german: "welchen Senator",
      translated: "Какого сенатора",
      tone: 'semantic',
    },
    {
      german: "Berlin",
      translated: "Берлине",
      tone: 'semantic',
    },
    {
      german: "nicht",
      translated: "нет",
      tone: 'semantic',
    },
  ],
  "lid:state:BE:10|sq": [
    {
      german: "Welche Senatorin",
      translated: "Cila detyrë",
      tone: 'semantic',
    },
    {
      german: "welchen Senator",
      translated: "senatori",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "ekziston",
      tone: 'semantic',
    },
    {
      german: "Berlin",
      translated: "Berlini",
      tone: 'semantic',
    },
    {
      german: "nicht",
      translated: "nuk",
      tone: 'semantic',
    },
  ],
  "lid:state:BE:10|sr": [
    {
      german: "Welche Senatorin",
      translated: "Koja",
      tone: 'semantic',
    },
    {
      german: "welchen Senator",
      translated: "senatorska funkcija",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "ne postoji",
      tone: 'semantic',
    },
    {
      german: "Berlin",
      translated: "Berlinu",
      tone: 'semantic',
    },
  ],
  "lid:state:BE:10|tr": [
    {
      german: "Welche Senatorin",
      translated: "aşağıdaki senatörlüklerden hangisi",
      tone: 'semantic',
    },
    {
      german: "Berlin",
      translated: "Berlin şehir devletinde",
      tone: 'semantic',
    },
    {
      german: "nicht",
      translated: "yoktur",
      tone: 'semantic',
    },
  ],
  "lid:state:BE:10|uk": [
    {
      german: "Welche Senatorin",
      translated: "сенаторки",
      tone: 'semantic',
    },
    {
      german: "welchen Senator",
      translated: "сенатора",
      tone: 'semantic',
    },
    {
      german: "Berlin",
      translated: "Берліні",
      tone: 'semantic',
    },
    {
      german: "nicht",
      translated: "немає",
      tone: 'semantic',
    },
  ],
  "lid:state:BE:10|vi": [
    {
      german: "Welche Senatorin",
      translated: "Chức vụ thượng nghị sĩ nào",
      tone: 'semantic',
    },
    {
      german: "Berlin",
      translated: "Berlin",
      tone: 'semantic',
    },
    {
      german: "nicht",
      translated: "không tồn tại",
      tone: 'semantic',
    },
  ],
  "lid:state:BE:1|ar": [
    {
      german: "Welches Wappen",
      translated: "أي شعار من الصور",
      tone: 'semantic',
    },
    {
      german: "gehört zum",
      translated: "يعود إلى",
      tone: 'semantic',
    },
    {
      german: "Bundesland Berlin",
      translated: "ولاية Berlin",
      tone: 'semantic',
    },
  ],
  "lid:state:BE:1|bg": [
    {
      german: "Welches Wappen",
      translated: "Кой герб",
      tone: 'semantic',
    },
    {
      german: "gehört zum",
      translated: "принадлежи на",
      tone: 'semantic',
    },
    {
      german: "Bundesland Berlin",
      translated: "Берлин",
      tone: 'semantic',
    },
  ],
  "lid:state:BE:1|bs": [
    {
      german: "Welches Wappen",
      translated: "grb",
      tone: 'semantic',
    },
    {
      german: "gehört zum",
      translated: "pripada",
      tone: 'semantic',
    },
    {
      german: "Bundesland Berlin",
      translated: "saveznoj zemlji Berlin?",
      tone: 'semantic',
    },
  ],
  "lid:state:BE:1|el": [
    {
      german: "Welches Wappen",
      translated: "Ποιο έμβλημα",
      tone: 'semantic',
    },
    {
      german: "gehört zum",
      translated: "ανήκει στο",
      tone: 'semantic',
    },
    {
      german: "Bundesland Berlin",
      translated: "ομόσπονδο κρατίδιο Βερολίνο",
      tone: 'semantic',
    },
  ],
  "lid:state:BE:1|en": [
    {
      german: "Welches Wappen",
      translated: "Which coat of arms",
      tone: 'semantic',
    },
    {
      german: "gehört zum",
      translated: "belongs to the",
      tone: 'semantic',
    },
    {
      german: "Bundesland Berlin",
      translated: "federal state of Berlin",
      tone: 'semantic',
    },
  ],
  "lid:state:BE:1|es": [
    {
      german: "Welches Wappen",
      translated: "¿Qué escudo",
      tone: 'semantic',
    },
    {
      german: "gehört zum",
      translated: "pertenece al",
      tone: 'semantic',
    },
    {
      german: "Bundesland Berlin",
      translated: "estado federado de Berlín",
      tone: 'semantic',
    },
  ],
  "lid:state:BE:1|fa": [
    {
      german: "Welches Wappen",
      translated: "کدام نشان",
      tone: 'semantic',
    },
    {
      german: "gehört zum",
      translated: "متعلق به",
      tone: 'semantic',
    },
    {
      german: "Bundesland Berlin",
      translated: "ایالت برلین",
      tone: 'semantic',
    },
  ],
  "lid:state:BE:1|fr": [
    {
      german: "Welches Wappen",
      translated: "Quel blason",
      tone: 'semantic',
    },
    {
      german: "gehört zum",
      translated: "appartient au",
      tone: 'semantic',
    },
    {
      german: "Bundesland Berlin",
      translated: "Land de Berlin",
      tone: 'semantic',
    },
  ],
  "lid:state:BE:1|hr": [
    {
      german: "Welches Wappen",
      translated: "grb",
      tone: 'semantic',
    },
    {
      german: "gehört zum",
      translated: "pripada",
      tone: 'semantic',
    },
    {
      german: "Bundesland Berlin",
      translated: "saveznoj zemlji Berlin?",
      tone: 'semantic',
    },
  ],
  "lid:state:BE:1|it": [
    {
      german: "Welches Wappen",
      translated: "Quale stemma",
      tone: 'semantic',
    },
    {
      german: "gehört zum",
      translated: "appartiene",
      tone: 'semantic',
    },
    {
      german: "Bundesland Berlin",
      translated: "al Land di Berlino",
      tone: 'semantic',
    },
  ],
  "lid:state:BE:1|kmr": [
    {
      german: "Welches Wappen",
      translated: "Kîjan nîşan",
      tone: 'semantic',
    },
    {
      german: "Bundesland Berlin",
      translated: "Berlînê",
      tone: 'semantic',
    },
  ],
  "lid:state:BE:1|pl": [
    {
      german: "Welches Wappen",
      translated: "Który herb",
      tone: 'semantic',
    },
    {
      german: "gehört zum",
      translated: "należy do",
      tone: 'semantic',
    },
    {
      german: "Bundesland Berlin",
      translated: "kraju związkowego Berlin",
      tone: 'semantic',
    },
  ],
  "lid:state:BE:1|prs": [
    {
      german: "Welches Wappen",
      translated: "کدام نشان",
      tone: 'semantic',
    },
    {
      german: "gehört zum",
      translated: "متعلق به",
      tone: 'semantic',
    },
    {
      german: "Bundesland Berlin",
      translated: "ایالت برلین",
      tone: 'semantic',
    },
  ],
  "lid:state:BE:1|ro": [
    {
      german: "Welches Wappen",
      translated: "Care stemă",
      tone: 'semantic',
    },
    {
      german: "gehört zum",
      translated: "aparține",
      tone: 'semantic',
    },
    {
      german: "Bundesland Berlin",
      translated: "landului Berlin",
      tone: 'semantic',
    },
  ],
  "lid:state:BE:1|ru": [
    {
      german: "Welches Wappen",
      translated: "Какой герб",
      tone: 'semantic',
    },
    {
      german: "gehört zum",
      translated: "принадлежит",
      tone: 'semantic',
    },
    {
      german: "Bundesland Berlin",
      translated: "федеральной земле Берлин",
      tone: 'semantic',
    },
  ],
  "lid:state:BE:1|sq": [
    {
      german: "Welches Wappen",
      translated: "Cila stemë",
      tone: 'semantic',
    },
    {
      german: "gehört zum",
      translated: "i përket",
      tone: 'semantic',
    },
    {
      german: "Bundesland Berlin",
      translated: "landit Berlini",
      tone: 'semantic',
    },
  ],
  "lid:state:BE:1|sr": [
    {
      german: "Welches Wappen",
      translated: "Koji grb",
      tone: 'semantic',
    },
    {
      german: "gehört zum",
      translated: "pripada",
      tone: 'semantic',
    },
    {
      german: "Bundesland Berlin",
      translated: "saveznoj pokrajini Berlin?",
      tone: 'semantic',
    },
  ],
  "lid:state:BE:1|tr": [
    {
      german: "Welches Wappen",
      translated: "arması",
      tone: 'semantic',
    },
    {
      german: "gehört zum",
      translated: "hangisidir?",
      tone: 'semantic',
    },
    {
      german: "Bundesland Berlin",
      translated: "Berlin eyaletinin",
      tone: 'semantic',
    },
  ],
  "lid:state:BE:1|uk": [
    {
      german: "Welches Wappen",
      translated: "герб",
      tone: 'semantic',
    },
    {
      german: "gehört zum",
      translated: "належить",
      tone: 'semantic',
    },
    {
      german: "Bundesland Berlin",
      translated: "федеральній землі Берлін",
      tone: 'semantic',
    },
  ],
  "lid:state:BE:1|vi": [
    {
      german: "Welches Wappen",
      translated: "Quốc huy",
      tone: 'semantic',
    },
    {
      german: "gehört zum",
      translated: "thuộc",
      tone: 'semantic',
    },
    {
      german: "Bundesland Berlin",
      translated: "bang Berlin",
      tone: 'semantic',
    },
  ],
  "lid:state:BE:2|ar": [
    {
      german: "Welches",
      translated: "أي",
      tone: 'semantic',
    },
    {
      german: "Bezirk",
      translated: "منطقة إدارية (Bezirk)",
      tone: 'semantic',
    },
    {
      german: "von Berlin",
      translated: "في Berlin؟",
      tone: 'semantic',
    },
  ],
  "lid:state:BE:2|bg": [
    {
      german: "Welches",
      translated: "Кое",
      tone: 'semantic',
    },
    {
      german: "Bezirk",
      translated: "район/градски район",
      tone: 'semantic',
    },
    {
      german: "von Berlin",
      translated: "на Берлин",
      tone: 'semantic',
    },
  ],
  "lid:state:BE:2|bs": [
    {
      german: "Welches",
      translated: "Što",
      tone: 'semantic',
    },
    {
      german: "Bezirk",
      translated: "gradska četvrt/okrug",
      tone: 'semantic',
    },
    {
      german: "von Berlin",
      translated: "grada Berlin",
      tone: 'semantic',
    },
  ],
  "lid:state:BE:2|el": [
    {
      german: "Welches",
      translated: "Ποιο",
      tone: 'semantic',
    },
    {
      german: "Bezirk",
      translated: "διαμέρισμα/περιοχή",
      tone: 'semantic',
    },
    {
      german: "von Berlin",
      translated: "Βερολίνο",
      tone: 'semantic',
    },
  ],
  "lid:state:BE:2|en": [
    {
      german: "Welches",
      translated: "Which",
      tone: 'semantic',
    },
    {
      german: "Bezirk",
      translated: "a borough",
      tone: 'semantic',
    },
    {
      german: "von Berlin",
      translated: "of Berlin",
      tone: 'semantic',
    },
  ],
  "lid:state:BE:2|es": [
    {
      german: "Welches",
      translated: "¿Cuál",
      tone: 'semantic',
    },
    {
      german: "Bezirk",
      translated: "distrito",
      tone: 'semantic',
    },
    {
      german: "von Berlin",
      translated: "de Berlín",
      tone: 'semantic',
    },
  ],
  "lid:state:BE:2|fa": [
    {
      german: "Welches",
      translated: "کدام‌یک",
      tone: 'semantic',
    },
    {
      german: "Bezirk",
      translated: "ناحیه/بخش شهری",
      tone: 'semantic',
    },
    {
      german: "von Berlin",
      translated: "در برلین",
      tone: 'semantic',
    },
  ],
  "lid:state:BE:2|fr": [
    {
      german: "Welches",
      translated: "Lequel",
      tone: 'semantic',
    },
    {
      german: "Bezirk",
      translated: "arrondissement",
      tone: 'semantic',
    },
    {
      german: "von Berlin",
      translated: "de Berlin",
      tone: 'semantic',
    },
  ],
  "lid:state:BE:2|hr": [
    {
      german: "Welches",
      translated: "Što",
      tone: 'semantic',
    },
    {
      german: "Bezirk",
      translated: "gradska četvrt/okrug",
      tone: 'semantic',
    },
    {
      german: "von Berlin",
      translated: "grada Berlin",
      tone: 'semantic',
    },
  ],
  "lid:state:BE:2|it": [
    {
      german: "Welches",
      translated: "Quale dei seguenti",
      tone: 'semantic',
    },
    {
      german: "Bezirk",
      translated: "distretto/quartiere",
      tone: 'semantic',
    },
    {
      german: "von Berlin",
      translated: "di Berlino",
      tone: 'semantic',
    },
  ],
  "lid:state:BE:2|kmr": [
    {
      german: "Welches",
      translated: "Kîjan",
      tone: 'semantic',
    },
    {
      german: "Bezirk",
      translated: "navçeyek",
      tone: 'semantic',
    },
    {
      german: "von Berlin",
      translated: "a Berlînê ye?",
      tone: 'semantic',
    },
  ],
  "lid:state:BE:2|pl": [
    {
      german: "Welches",
      translated: "Które",
      tone: 'semantic',
    },
    {
      german: "Bezirk",
      translated: "dzielnicą/okręgiem",
      tone: 'semantic',
    },
    {
      german: "von Berlin",
      translated: "miasta Berlin",
      tone: 'semantic',
    },
  ],
  "lid:state:BE:2|prs": [
    {
      german: "Welches",
      translated: "کدام",
      tone: 'semantic',
    },
    {
      german: "Bezirk",
      translated: "ناحیه/بخش شهری",
      tone: 'semantic',
    },
    {
      german: "von Berlin",
      translated: "در برلین",
      tone: 'semantic',
    },
  ],
  "lid:state:BE:2|ro": [
    {
      german: "Welches",
      translated: "Care",
      tone: 'semantic',
    },
    {
      german: "Bezirk",
      translated: "district/sector",
      tone: 'semantic',
    },
    {
      german: "von Berlin",
      translated: "al orașului Berlin",
      tone: 'semantic',
    },
  ],
  "lid:state:BE:2|ru": [
    {
      german: "Welches",
      translated: "Какой",
      tone: 'semantic',
    },
    {
      german: "Bezirk",
      translated: "районом",
      tone: 'semantic',
    },
    {
      german: "von Berlin",
      translated: "Берлина",
      tone: 'semantic',
    },
  ],
  "lid:state:BE:2|sq": [
    {
      german: "Welches",
      translated: "Cila",
      tone: 'semantic',
    },
    {
      german: "Bezirk",
      translated: "lagje",
      tone: 'semantic',
    },
    {
      german: "von Berlin",
      translated: "i Berlini",
      tone: 'semantic',
    },
  ],
  "lid:state:BE:2|sr": [
    {
      german: "Welches",
      translated: "Šta",
      tone: 'semantic',
    },
    {
      german: "Bezirk",
      translated: "gradska četvrt/okrug",
      tone: 'semantic',
    },
    {
      german: "von Berlin",
      translated: "grada Berlin",
      tone: 'semantic',
    },
  ],
  "lid:state:BE:2|tr": [
    {
      german: "Welches",
      translated: "Aşağıdakilerden hangisi",
      tone: 'semantic',
    },
    {
      german: "Bezirk",
      translated: "bir ilçesidir (Bezirk)",
      tone: 'semantic',
    },
    {
      german: "von Berlin",
      translated: "Berlin’in",
      tone: 'semantic',
    },
  ],
  "lid:state:BE:2|uk": [
    {
      german: "Welches",
      translated: "Який",
      tone: 'semantic',
    },
    {
      german: "Bezirk",
      translated: "районів",
      tone: 'semantic',
    },
    {
      german: "von Berlin",
      translated: "є районом Берліна",
      tone: 'semantic',
    },
  ],
  "lid:state:BE:2|vi": [
    {
      german: "Welches",
      translated: "Địa danh nào sau đây",
      tone: 'semantic',
    },
    {
      german: "Bezirk",
      translated: "quận/khu vực",
      tone: 'semantic',
    },
    {
      german: "von Berlin",
      translated: "của Berlin",
      tone: 'semantic',
    },
  ],
  "lid:state:BE:3|ar": [
    {
      german: "Für wie viele Jahre",
      translated: "لمدة كم سنة",
      tone: 'semantic',
    },
    {
      german: "Landesparlament",
      translated: "برلمان الولاية",
      tone: 'semantic',
    },
    {
      german: "in Berlin",
      translated: "في Berlin",
      tone: 'semantic',
    },
    {
      german: "gewählt",
      translated: "يُنتخب",
      tone: 'semantic',
    },
  ],
  "lid:state:BE:3|bg": [
    {
      german: "Für wie viele Jahre",
      translated: "За колко години",
      tone: 'semantic',
    },
    {
      german: "Landesparlament",
      translated: "парламентът на провинция",
      tone: 'semantic',
    },
    {
      german: "in Berlin",
      translated: "Берлин",
      tone: 'semantic',
    },
  ],
  "lid:state:BE:3|bs": [
    {
      german: "Für wie viele Jahre",
      translated: "Na koliko se godina",
      tone: 'semantic',
    },
    {
      german: "Landesparlament",
      translated: "parlament",
      tone: 'semantic',
    },
    {
      german: "in Berlin",
      translated: "savezne zemlje Berlin",
      tone: 'semantic',
    },
    {
      german: "gewählt",
      translated: "bira",
      tone: 'semantic',
    },
  ],
  "lid:state:BE:3|el": [
    {
      german: "Für wie viele Jahre",
      translated: "Για πόσα χρόνια",
      tone: 'semantic',
    },
    {
      german: "Landesparlament",
      translated: "κοινοβούλιο",
      tone: 'semantic',
    },
    {
      german: "in Berlin",
      translated: "Βερολίνο",
      tone: 'semantic',
    },
    {
      german: "gewählt",
      translated: "εκλέγεται",
      tone: 'semantic',
    },
  ],
  "lid:state:BE:3|en": [
    {
      german: "Für wie viele Jahre",
      translated: "For how many years",
      tone: 'semantic',
    },
    {
      german: "Landesparlament",
      translated: "the state parliament",
      tone: 'semantic',
    },
    {
      german: "in Berlin",
      translated: "in Berlin",
      tone: 'semantic',
    },
    {
      german: "gewählt",
      translated: "elected",
      tone: 'semantic',
    },
  ],
  "lid:state:BE:3|es": [
    {
      german: "Für wie viele Jahre",
      translated: "¿Por cuántos años",
      tone: 'semantic',
    },
    {
      german: "Landesparlament",
      translated: "parlamento regional",
      tone: 'semantic',
    },
    {
      german: "in Berlin",
      translated: "en Berlín",
      tone: 'semantic',
    },
    {
      german: "gewählt",
      translated: "se elige",
      tone: 'semantic',
    },
  ],
  "lid:state:BE:3|fa": [
    {
      german: "Für wie viele Jahre",
      translated: "چند سال",
      tone: 'semantic',
    },
    {
      german: "Landesparlament",
      translated: "پارلمان ایالتی",
      tone: 'semantic',
    },
    {
      german: "in Berlin",
      translated: "برلین",
      tone: 'semantic',
    },
    {
      german: "gewählt",
      translated: "انتخاب می‌شود",
      tone: 'semantic',
    },
  ],
  "lid:state:BE:3|fr": [
    {
      german: "Für wie viele Jahre",
      translated: "Pour combien d’années",
      tone: 'semantic',
    },
    {
      german: "Landesparlament",
      translated: "Parlement du Land",
      tone: 'semantic',
    },
    {
      german: "in Berlin",
      translated: "de Berlin",
      tone: 'semantic',
    },
    {
      german: "gewählt",
      translated: "élu",
      tone: 'semantic',
    },
  ],
  "lid:state:BE:3|hr": [
    {
      german: "Für wie viele Jahre",
      translated: "Na koliko se godina",
      tone: 'semantic',
    },
    {
      german: "Landesparlament",
      translated: "parlament",
      tone: 'semantic',
    },
    {
      german: "in Berlin",
      translated: "Berlin",
      tone: 'semantic',
    },
    {
      german: "gewählt",
      translated: "bira",
      tone: 'semantic',
    },
  ],
  "lid:state:BE:3|it": [
    {
      german: "Für wie viele Jahre",
      translated: "Per quanti anni",
      tone: 'semantic',
    },
    {
      german: "Landesparlament",
      translated: "Parlamento del Land",
      tone: 'semantic',
    },
    {
      german: "in Berlin",
      translated: "di Berlino",
      tone: 'semantic',
    },
    {
      german: "gewählt",
      translated: "viene eletto",
      tone: 'semantic',
    },
  ],
  "lid:state:BE:3|kmr": [
    {
      german: "Für wie viele Jahre",
      translated: "çend salan",
      tone: 'semantic',
    },
    {
      german: "Landesparlament",
      translated: "Parlamentoya",
      tone: 'semantic',
    },
    {
      german: "in Berlin",
      translated: "ya Berlînê",
      tone: 'semantic',
    },
    {
      german: "gewählt",
      translated: "tê hilbijartin?",
      tone: 'semantic',
    },
  ],
  "lid:state:BE:3|pl": [
    {
      german: "Für wie viele Jahre",
      translated: "Na ile lat",
      tone: 'semantic',
    },
    {
      german: "Landesparlament",
      translated: "parlament kraju związkowego",
      tone: 'semantic',
    },
    {
      german: "in Berlin",
      translated: "Berlin",
      tone: 'semantic',
    },
    {
      german: "gewählt",
      translated: "wybierany jest",
      tone: 'semantic',
    },
  ],
  "lid:state:BE:3|prs": [
    {
      german: "Für wie viele Jahre",
      translated: "چند سال",
      tone: 'semantic',
    },
    {
      german: "Landesparlament",
      translated: "پارلمان ایالتی",
      tone: 'semantic',
    },
    {
      german: "in Berlin",
      translated: "برلین",
      tone: 'semantic',
    },
    {
      german: "gewählt",
      translated: "انتخاب می‌شود",
      tone: 'semantic',
    },
  ],
  "lid:state:BE:3|ro": [
    {
      german: "Für wie viele Jahre",
      translated: "Pentru câți ani",
      tone: 'semantic',
    },
    {
      german: "Landesparlament",
      translated: "parlamentul landului",
      tone: 'semantic',
    },
    {
      german: "in Berlin",
      translated: "Berlin",
      tone: 'semantic',
    },
    {
      german: "gewählt",
      translated: "ales",
      tone: 'semantic',
    },
  ],
  "lid:state:BE:3|ru": [
    {
      german: "Für wie viele Jahre",
      translated: "На сколько лет",
      tone: 'semantic',
    },
    {
      german: "Landesparlament",
      translated: "земельный парламент",
      tone: 'semantic',
    },
    {
      german: "in Berlin",
      translated: "в Берлине",
      tone: 'semantic',
    },
    {
      german: "gewählt",
      translated: "избирается",
      tone: 'semantic',
    },
  ],
  "lid:state:BE:3|sq": [
    {
      german: "Für wie viele Jahre",
      translated: "sa vjet",
      tone: 'semantic',
    },
    {
      german: "Landesparlament",
      translated: "parlamenti i landit",
      tone: 'semantic',
    },
    {
      german: "in Berlin",
      translated: "Berlini",
      tone: 'semantic',
    },
    {
      german: "gewählt",
      translated: "zgjidhet",
      tone: 'semantic',
    },
  ],
  "lid:state:BE:3|sr": [
    {
      german: "Für wie viele Jahre",
      translated: "koliko se godina",
      tone: 'semantic',
    },
    {
      german: "Landesparlament",
      translated: "parlament savezne pokrajine",
      tone: 'semantic',
    },
    {
      german: "in Berlin",
      translated: "Berlin",
      tone: 'semantic',
    },
    {
      german: "gewählt",
      translated: "bira",
      tone: 'semantic',
    },
  ],
  "lid:state:BE:3|tr": [
    {
      german: "Für wie viele Jahre",
      translated: "kaç yıllığına",
      tone: 'semantic',
    },
    {
      german: "Landesparlament",
      translated: "eyalet parlamentosu",
      tone: 'semantic',
    },
    {
      german: "in Berlin",
      translated: "Berlin",
      tone: 'semantic',
    },
    {
      german: "gewählt",
      translated: "seçilir",
      tone: 'semantic',
    },
  ],
  "lid:state:BE:3|uk": [
    {
      german: "Für wie viele Jahre",
      translated: "На скільки років",
      tone: 'semantic',
    },
    {
      german: "Landesparlament",
      translated: "земельний парламент",
      tone: 'semantic',
    },
    {
      german: "in Berlin",
      translated: "у Берлін",
      tone: 'semantic',
    },
    {
      german: "gewählt",
      translated: "обирають",
      tone: 'semantic',
    },
  ],
  "lid:state:BE:3|vi": [
    {
      german: "Für wie viele Jahre",
      translated: "bao nhiêu năm",
      tone: 'semantic',
    },
    {
      german: "Landesparlament",
      translated: "Nghị viện bang",
      tone: 'semantic',
    },
    {
      german: "in Berlin",
      translated: "Berlin",
      tone: 'semantic',
    },
    {
      german: "gewählt",
      translated: "được bầu",
      tone: 'semantic',
    },
  ],
  "lid:state:BE:4|ar": [
    {
      german: "Ab welchem Alter",
      translated: "ابتداءً من أي سن",
      tone: 'semantic',
    },
    {
      german: "darf man",
      translated: "يحق",
      tone: 'semantic',
    },
    {
      german: "in Berlin",
      translated: "في Berlin",
      tone: 'semantic',
    },
    {
      german: "bei Kommunalwahlen",
      translated: "في الانتخابات المحلية",
      tone: 'semantic',
    },
    {
      german: "Wahl der Bezirksverordnetenversammlung",
      translated: "انتخابات مجلس ممثلي الأحياء",
      tone: 'semantic',
    },
    {
      german: "wählen",
      translated: "التصويت",
      tone: 'semantic',
    },
  ],
  "lid:state:BE:4|bg": [
    {
      german: "Ab welchem Alter",
      translated: "От каква възраст",
      tone: 'semantic',
    },
    {
      german: "darf man",
      translated: "може да се",
      tone: 'semantic',
    },
    {
      german: "in Berlin",
      translated: "в Берлин",
      tone: 'semantic',
    },
    {
      german: "bei Kommunalwahlen",
      translated: "на общински избори",
      tone: 'semantic',
    },
    {
      german: "Wahl der Bezirksverordnetenversammlung",
      translated: "избор за районното събрание",
      tone: 'semantic',
    },
    {
      german: "wählen",
      translated: "гласува",
      tone: 'semantic',
    },
  ],
  "lid:state:BE:4|bs": [
    {
      german: "Ab welchem Alter",
      translated: "Od koje se dobi",
      tone: 'semantic',
    },
    {
      german: "darf man",
      translated: "može",
      tone: 'semantic',
    },
    {
      german: "in Berlin",
      translated: "u Berlinu",
      tone: 'semantic',
    },
    {
      german: "bei Kommunalwahlen",
      translated: "na lokalnim izborima",
      tone: 'semantic',
    },
    {
      german: "Wahl der Bezirksverordnetenversammlung",
      translated: "izborima za skupštinu gradskog okruga",
      tone: 'semantic',
    },
    {
      german: "wählen",
      translated: "glasovati",
      tone: 'semantic',
    },
  ],
  "lid:state:BE:4|el": [
    {
      german: "Ab welchem Alter",
      translated: "Από ποια ηλικία",
      tone: 'semantic',
    },
    {
      german: "darf man",
      translated: "μπορεί κάποιος",
      tone: 'semantic',
    },
    {
      german: "in Berlin",
      translated: "στο Βερολίνο",
      tone: 'semantic',
    },
    {
      german: "bei Kommunalwahlen",
      translated: "στις δημοτικές εκλογές",
      tone: 'semantic',
    },
    {
      german: "Wahl der Bezirksverordnetenversammlung",
      translated: "εκλογή της Bezirksverordnetenversammlung",
      tone: 'semantic',
    },
    {
      german: "wählen",
      translated: "να ψηφίσει",
      tone: 'semantic',
    },
  ],
  "lid:state:BE:4|en": [
    {
      german: "Ab welchem Alter",
      translated: "From what age",
      tone: 'semantic',
    },
    {
      german: "darf man",
      translated: "can you",
      tone: 'semantic',
    },
    {
      german: "in Berlin",
      translated: "in Berlin",
      tone: 'semantic',
    },
    {
      german: "bei Kommunalwahlen",
      translated: "in local elections",
      tone: 'semantic',
    },
    {
      german: "Wahl der Bezirksverordnetenversammlung",
      translated: "election of the district assembly",
      tone: 'semantic',
    },
    {
      german: "wählen",
      translated: "vote",
      tone: 'semantic',
    },
  ],
  "lid:state:BE:4|es": [
    {
      german: "Ab welchem Alter",
      translated: "¿A partir de qué edad",
      tone: 'semantic',
    },
    {
      german: "darf man",
      translated: "se puede",
      tone: 'semantic',
    },
    {
      german: "in Berlin",
      translated: "en Berlín",
      tone: 'semantic',
    },
    {
      german: "bei Kommunalwahlen",
      translated: "en las elecciones municipales",
      tone: 'semantic',
    },
    {
      german: "Wahl der Bezirksverordnetenversammlung",
      translated: "elección de las asambleas de distrito",
      tone: 'semantic',
    },
    {
      german: "wählen",
      translated: "votar",
      tone: 'semantic',
    },
  ],
  "lid:state:BE:4|fa": [
    {
      german: "Ab welchem Alter",
      translated: "از چه سنی",
      tone: 'semantic',
    },
    {
      german: "darf man",
      translated: "می‌توان",
      tone: 'semantic',
    },
    {
      german: "in Berlin",
      translated: "در برلین",
      tone: 'semantic',
    },
    {
      german: "bei Kommunalwahlen",
      translated: "در انتخابات محلی",
      tone: 'semantic',
    },
    {
      german: "Wahl der Bezirksverordnetenversammlung",
      translated: "انتخاب مجمع نمایندگان منطقه",
      tone: 'semantic',
    },
    {
      german: "wählen",
      translated: "رأی داد",
      tone: 'semantic',
    },
  ],
  "lid:state:BE:4|fr": [
    {
      german: "Ab welchem Alter",
      translated: "À partir de quel âge",
      tone: 'semantic',
    },
    {
      german: "darf man",
      translated: "peut-on",
      tone: 'semantic',
    },
    {
      german: "in Berlin",
      translated: "à Berlin",
      tone: 'semantic',
    },
    {
      german: "bei Kommunalwahlen",
      translated: "aux élections municipales",
      tone: 'semantic',
    },
    {
      german: "Wahl der Bezirksverordnetenversammlung",
      translated: "élection de l’assemblée d’arrondissement",
      tone: 'semantic',
    },
    {
      german: "wählen",
      translated: "voter",
      tone: 'semantic',
    },
  ],
  "lid:state:BE:4|hr": [
    {
      german: "Ab welchem Alter",
      translated: "Od koje se dobi",
      tone: 'semantic',
    },
    {
      german: "darf man",
      translated: "može",
      tone: 'semantic',
    },
    {
      german: "in Berlin",
      translated: "u Berlinu",
      tone: 'semantic',
    },
    {
      german: "bei Kommunalwahlen",
      translated: "na lokalnim izborima",
      tone: 'semantic',
    },
    {
      german: "Wahl der Bezirksverordnetenversammlung",
      translated: "izborima za skupštinu gradskog okruga",
      tone: 'semantic',
    },
    {
      german: "wählen",
      translated: "glasovati",
      tone: 'semantic',
    },
  ],
  "lid:state:BE:4|it": [
    {
      german: "Ab welchem Alter",
      translated: "Da quale età",
      tone: 'semantic',
    },
    {
      german: "darf man",
      translated: "si può",
      tone: 'semantic',
    },
    {
      german: "in Berlin",
      translated: "a Berlino",
      tone: 'semantic',
    },
    {
      german: "bei Kommunalwahlen",
      translated: "alle elezioni locali",
      tone: 'semantic',
    },
    {
      german: "Wahl der Bezirksverordnetenversammlung",
      translated: "elezione dell’assemblea dei rappresentanti distrettuali",
      tone: 'semantic',
    },
    {
      german: "wählen",
      translated: "votare",
      tone: 'semantic',
    },
  ],
  "lid:state:BE:4|kmr": [
    {
      german: "Ab welchem Alter",
      translated: "Ji kîjan temenê",
      tone: 'semantic',
    },
    {
      german: "darf man",
      translated: "dikare",
      tone: 'semantic',
    },
    {
      german: "in Berlin",
      translated: "li Berlînê",
      tone: 'semantic',
    },
    {
      german: "bei Kommunalwahlen",
      translated: "di hilbijartinên navçeyan de",
      tone: 'semantic',
    },
    {
      german: "Wahl der Bezirksverordnetenversammlung",
      translated: "hilbijartina meclîsa navçeyê",
      tone: 'semantic',
    },
    {
      german: "wählen",
      translated: "deng were dayîn",
      tone: 'semantic',
    },
  ],
  "lid:state:BE:4|pl": [
    {
      german: "Ab welchem Alter",
      translated: "Od jakiego wieku",
      tone: 'semantic',
    },
    {
      german: "darf man",
      translated: "można",
      tone: 'semantic',
    },
    {
      german: "in Berlin",
      translated: "w Berlin",
      tone: 'semantic',
    },
    {
      german: "bei Kommunalwahlen",
      translated: "w wyborach samorządowych",
      tone: 'semantic',
    },
    {
      german: "wählen",
      translated: "głosować",
      tone: 'semantic',
    },
  ],
  "lid:state:BE:4|prs": [
    {
      german: "Ab welchem Alter",
      translated: "از چه سنی",
      tone: 'semantic',
    },
    {
      german: "darf man",
      translated: "می‌توان",
      tone: 'semantic',
    },
    {
      german: "in Berlin",
      translated: "برلین",
      tone: 'semantic',
    },
    {
      german: "bei Kommunalwahlen",
      translated: "انتخابات شاروالی",
      tone: 'semantic',
    },
    {
      german: "Wahl der Bezirksverordnetenversammlung",
      translated: "انتخابات مجمع نمایندگان منطقه",
      tone: 'semantic',
    },
    {
      german: "wählen",
      translated: "رأی داد",
      tone: 'semantic',
    },
  ],
  "lid:state:BE:4|ro": [
    {
      german: "Ab welchem Alter",
      translated: "De la ce vârstă",
      tone: 'semantic',
    },
    {
      german: "darf man",
      translated: "se poate",
      tone: 'semantic',
    },
    {
      german: "in Berlin",
      translated: "din Berlin",
      tone: 'semantic',
    },
    {
      german: "bei Kommunalwahlen",
      translated: "la alegerile locale",
      tone: 'semantic',
    },
    {
      german: "Wahl der Bezirksverordnetenversammlung",
      translated: "alegerea adunării reprezentanților districtuali",
      tone: 'semantic',
    },
    {
      german: "wählen",
      translated: "vota",
      tone: 'semantic',
    },
  ],
  "lid:state:BE:4|ru": [
    {
      german: "Ab welchem Alter",
      translated: "С какого возраста",
      tone: 'semantic',
    },
    {
      german: "darf man",
      translated: "можно",
      tone: 'semantic',
    },
    {
      german: "in Berlin",
      translated: "в Берлине",
      tone: 'semantic',
    },
    {
      german: "bei Kommunalwahlen",
      translated: "на муниципальных выборах",
      tone: 'semantic',
    },
    {
      german: "Wahl der Bezirksverordnetenversammlung",
      translated: "(выборах собрания депутатов округа)",
      tone: 'semantic',
    },
    {
      german: "wählen",
      translated: "голосовать",
      tone: 'semantic',
    },
  ],
  "lid:state:BE:4|sq": [
    {
      german: "Ab welchem Alter",
      translated: "Nga cila moshë",
      tone: 'semantic',
    },
    {
      german: "darf man",
      translated: "mund të",
      tone: 'semantic',
    },
    {
      german: "in Berlin",
      translated: "në Berlin",
      tone: 'semantic',
    },
    {
      german: "bei Kommunalwahlen",
      translated: "në zgjedhjet komunale",
      tone: 'semantic',
    },
    {
      german: "Wahl der Bezirksverordnetenversammlung",
      translated: "zgjedhja e kuvendit të përfaqësuesve të distriktit",
      tone: 'semantic',
    },
    {
      german: "wählen",
      translated: "votohet",
      tone: 'semantic',
    },
  ],
  "lid:state:BE:4|sr": [
    {
      german: "Ab welchem Alter",
      translated: "Od koje se dobi",
      tone: 'semantic',
    },
    {
      german: "darf man",
      translated: "može",
      tone: 'semantic',
    },
    {
      german: "in Berlin",
      translated: "u Berlinu",
      tone: 'semantic',
    },
    {
      german: "bei Kommunalwahlen",
      translated: "na lokalnim izborima",
      tone: 'semantic',
    },
    {
      german: "Wahl der Bezirksverordnetenversammlung",
      translated: "izborima za skupštinu gradskog okruga",
      tone: 'semantic',
    },
    {
      german: "wählen",
      translated: "glasati",
      tone: 'semantic',
    },
  ],
  "lid:state:BE:4|tr": [
    {
      german: "Ab welchem Alter",
      translated: "kaç yaşından itibaren",
      tone: 'semantic',
    },
    {
      german: "darf man",
      translated: "oy kullanılabilir",
      tone: 'semantic',
    },
    {
      german: "in Berlin",
      translated: "Berlin’de",
      tone: 'semantic',
    },
    {
      german: "bei Kommunalwahlen",
      translated: "yerel seçimlerde",
      tone: 'semantic',
    },
    {
      german: "Wahl der Bezirksverordnetenversammlung",
      translated: "ilçe meclisi seçimlerinde",
      tone: 'semantic',
    },
  ],
  "lid:state:BE:4|uk": [
    {
      german: "Ab welchem Alter",
      translated: "З якого віку",
      tone: 'semantic',
    },
    {
      german: "darf man",
      translated: "можна",
      tone: 'semantic',
    },
    {
      german: "in Berlin",
      translated: "в Берлін",
      tone: 'semantic',
    },
    {
      german: "bei Kommunalwahlen",
      translated: "на муніципальних виборах",
      tone: 'semantic',
    },
    {
      german: "Wahl der Bezirksverordnetenversammlung",
      translated: "виборах районних зборів",
      tone: 'semantic',
    },
    {
      german: "wählen",
      translated: "голосувати",
      tone: 'semantic',
    },
  ],
  "lid:state:BE:4|vi": [
    {
      german: "Ab welchem Alter",
      translated: "Từ bao nhiêu tuổi",
      tone: 'semantic',
    },
    {
      german: "darf man",
      translated: "có thể",
      tone: 'semantic',
    },
    {
      german: "in Berlin",
      translated: "ở Berlin",
      tone: 'semantic',
    },
    {
      german: "bei Kommunalwahlen",
      translated: "trong bầu cử địa phương",
      tone: 'semantic',
    },
    {
      german: "Wahl der Bezirksverordnetenversammlung",
      translated: "bầu cử Bezirksverordnetenversammlung",
      tone: 'semantic',
    },
    {
      german: "wählen",
      translated: "bỏ phiếu",
      tone: 'semantic',
    },
  ],
  "lid:state:BE:5|ar": [
    {
      german: "Welche Farben",
      translated: "ما",
      tone: 'semantic',
    },
    {
      german: "Landesflagge",
      translated: "علم",
      tone: 'semantic',
    },
    {
      german: "von Berlin",
      translated: "ولاية Berlin",
      tone: 'semantic',
    },
  ],
  "lid:state:BE:5|bg": [
    {
      german: "Welche Farben",
      translated: "Какви са цветовете",
      tone: 'semantic',
    },
    {
      german: "Landesflagge",
      translated: "знамето",
      tone: 'semantic',
    },
    {
      german: "von Berlin",
      translated: "на провинция Берлин",
      tone: 'semantic',
    },
  ],
  "lid:state:BE:5|bs": [
    {
      german: "Welche Farben",
      translated: "Koje su boje",
      tone: 'semantic',
    },
    {
      german: "Landesflagge",
      translated: "zastave",
      tone: 'semantic',
    },
    {
      german: "von Berlin",
      translated: "savezne zemlje Berlin",
      tone: 'semantic',
    },
  ],
  "lid:state:BE:5|el": [
    {
      german: "Welche Farben",
      translated: "Ποια είναι τα χρώματα",
      tone: 'semantic',
    },
    {
      german: "Landesflagge",
      translated: "της σημαίας του κρατιδίου",
      tone: 'semantic',
    },
    {
      german: "von Berlin",
      translated: "Βερολίνο",
      tone: 'semantic',
    },
  ],
  "lid:state:BE:5|en": [
    {
      german: "Welche Farben",
      translated: "What colors",
      tone: 'semantic',
    },
    {
      german: "Landesflagge",
      translated: "the state flag",
      tone: 'semantic',
    },
    {
      german: "von Berlin",
      translated: "of Berlin",
      tone: 'semantic',
    },
  ],
  "lid:state:BE:5|es": [
    {
      german: "Welche Farben",
      translated: "colores",
      tone: 'semantic',
    },
    {
      german: "Landesflagge",
      translated: "bandera",
      tone: 'semantic',
    },
    {
      german: "von Berlin",
      translated: "de Berlín",
      tone: 'semantic',
    },
  ],
  "lid:state:BE:5|fa": [
    {
      german: "Welche Farben",
      translated: "رنگ‌های",
      tone: 'semantic',
    },
    {
      german: "Landesflagge",
      translated: "پرچم",
      tone: 'semantic',
    },
    {
      german: "von Berlin",
      translated: "ایالت برلین",
      tone: 'semantic',
    },
  ],
  "lid:state:BE:5|fr": [
    {
      german: "Welche Farben",
      translated: "Quelles sont les couleurs",
      tone: 'semantic',
    },
    {
      german: "Landesflagge",
      translated: "drapeau du Land",
      tone: 'semantic',
    },
    {
      german: "von Berlin",
      translated: "de Berlin",
      tone: 'semantic',
    },
  ],
  "lid:state:BE:5|hr": [
    {
      german: "Welche Farben",
      translated: "Koje su",
      tone: 'semantic',
    },
    {
      german: "Landesflagge",
      translated: "zastave",
      tone: 'semantic',
    },
    {
      german: "von Berlin",
      translated: "savezne zemlje Berlin",
      tone: 'semantic',
    },
  ],
  "lid:state:BE:5|it": [
    {
      german: "Welche Farben",
      translated: "Quali sono i colori",
      tone: 'semantic',
    },
    {
      german: "Landesflagge",
      translated: "bandiera",
      tone: 'semantic',
    },
    {
      german: "von Berlin",
      translated: "di Berlino",
      tone: 'semantic',
    },
  ],
  "lid:state:BE:5|kmr": [
    {
      german: "Welche Farben",
      translated: "Rengên ala",
      tone: 'semantic',
    },
    {
      german: "Landesflagge",
      translated: "eyaleta",
      tone: 'semantic',
    },
    {
      german: "von Berlin",
      translated: "Berlînê çi ne",
      tone: 'semantic',
    },
  ],
  "lid:state:BE:5|pl": [
    {
      german: "Welche Farben",
      translated: "Jakie są",
      tone: 'semantic',
    },
    {
      german: "Landesflagge",
      translated: "flagi kraju związkowego",
      tone: 'semantic',
    },
    {
      german: "von Berlin",
      translated: "Berlin?",
      tone: 'semantic',
    },
  ],
  "lid:state:BE:5|prs": [
    {
      german: "Welche Farben",
      translated: "رنگ‌های",
      tone: 'semantic',
    },
    {
      german: "Landesflagge",
      translated: "پرچم ایالت",
      tone: 'semantic',
    },
    {
      german: "von Berlin",
      translated: "برلین",
      tone: 'semantic',
    },
  ],
  "lid:state:BE:5|ro": [
    {
      german: "Welche Farben",
      translated: "Care sunt culorile",
      tone: 'semantic',
    },
    {
      german: "Landesflagge",
      translated: "drapelului landului",
      tone: 'semantic',
    },
    {
      german: "von Berlin",
      translated: "Berlin",
      tone: 'semantic',
    },
  ],
  "lid:state:BE:5|ru": [
    {
      german: "Welche Farben",
      translated: "Какие цвета",
      tone: 'semantic',
    },
    {
      german: "Landesflagge",
      translated: "флага",
      tone: 'semantic',
    },
    {
      german: "von Berlin",
      translated: "земли Берлин",
      tone: 'semantic',
    },
  ],
  "lid:state:BE:5|sq": [
    {
      german: "Welche Farben",
      translated: "ngjyrat",
      tone: 'semantic',
    },
    {
      german: "Landesflagge",
      translated: "flamurit",
      tone: 'semantic',
    },
    {
      german: "von Berlin",
      translated: "Berlini",
      tone: 'semantic',
    },
  ],
  "lid:state:BE:5|sr": [
    {
      german: "Welche Farben",
      translated: "Koje su boje",
      tone: 'semantic',
    },
    {
      german: "Landesflagge",
      translated: "zastave",
      tone: 'semantic',
    },
    {
      german: "von Berlin",
      translated: "savezne pokrajine Berlin",
      tone: 'semantic',
    },
  ],
  "lid:state:BE:5|tr": [
    {
      german: "Welche Farben",
      translated: "renkleri nelerdir",
      tone: 'semantic',
    },
    {
      german: "Landesflagge",
      translated: "eyalet bayrağının",
      tone: 'semantic',
    },
    {
      german: "von Berlin",
      translated: "Berlin",
      tone: 'semantic',
    },
  ],
  "lid:state:BE:5|uk": [
    {
      german: "Welche Farben",
      translated: "Які кольори",
      tone: 'semantic',
    },
    {
      german: "Landesflagge",
      translated: "прапор",
      tone: 'semantic',
    },
    {
      german: "von Berlin",
      translated: "федеральної землі Берлін",
      tone: 'semantic',
    },
  ],
  "lid:state:BE:5|vi": [
    {
      german: "Welche Farben",
      translated: "Màu của",
      tone: 'semantic',
    },
    {
      german: "Landesflagge",
      translated: "cờ bang Berlin",
      tone: 'semantic',
    },
    {
      german: "von Berlin",
      translated: "là gì",
      tone: 'semantic',
    },
  ],
  "lid:state:BE:6|ar": [
    {
      german: "Wo",
      translated: "أين",
      tone: 'semantic',
    },
    {
      german: "können Sie",
      translated: "يمكنك",
      tone: 'semantic',
    },
    {
      german: "in Berlin",
      translated: "في Berlin",
      tone: 'semantic',
    },
    {
      german: "über politische Themen",
      translated: "عن القضايا السياسية",
      tone: 'semantic',
    },
    {
      german: "informieren",
      translated: "الحصول على معلومات",
      tone: 'semantic',
    },
  ],
  "lid:state:BE:6|bg": [
    {
      german: "Wo",
      translated: "Къде",
      tone: 'semantic',
    },
    {
      german: "können Sie",
      translated: "можете",
      tone: 'semantic',
    },
    {
      german: "sich",
      translated: "в",
      tone: 'semantic',
    },
    {
      german: "in Berlin",
      translated: "Берлин",
      tone: 'semantic',
    },
    {
      german: "über politische Themen",
      translated: "по политически теми",
      tone: 'semantic',
    },
    {
      german: "informieren",
      translated: "да получите информация",
      tone: 'semantic',
    },
  ],
  "lid:state:BE:6|bs": [
    {
      german: "Wo",
      translated: "Gdje",
      tone: 'semantic',
    },
    {
      german: "können Sie",
      translated: "mogu",
      tone: 'semantic',
    },
    {
      german: "sich",
      translated: "se",
      tone: 'semantic',
    },
    {
      german: "in Berlin",
      translated: "u Berlinu",
      tone: 'semantic',
    },
    {
      german: "über politische Themen",
      translated: "o političkim temama",
      tone: 'semantic',
    },
    {
      german: "informieren",
      translated: "dobiti informacije",
      tone: 'semantic',
    },
  ],
  "lid:state:BE:6|el": [
    {
      german: "Wo",
      translated: "Πού",
      tone: 'semantic',
    },
    {
      german: "können Sie",
      translated: "μπορείτε",
      tone: 'semantic',
    },
    {
      german: "sich",
      translated: "να",
      tone: 'semantic',
    },
    {
      german: "in Berlin",
      translated: "στο Βερολίνο",
      tone: 'semantic',
    },
    {
      german: "über politische Themen",
      translated: "για πολιτικά θέματα",
      tone: 'semantic',
    },
    {
      german: "informieren",
      translated: "ενημερωθείτε",
      tone: 'semantic',
    },
  ],
  "lid:state:BE:6|en": [
    {
      german: "Wo",
      translated: "Where",
      tone: 'semantic',
    },
    {
      german: "können Sie",
      translated: "can you",
      tone: 'semantic',
    },
    {
      german: "in Berlin",
      translated: "in Berlin",
      tone: 'semantic',
    },
    {
      german: "über politische Themen",
      translated: "about political topics",
      tone: 'semantic',
    },
    {
      german: "informieren",
      translated: "get information",
      tone: 'semantic',
    },
  ],
  "lid:state:BE:6|es": [
    {
      german: "Wo",
      translated: "¿Dónde",
      tone: 'semantic',
    },
    {
      german: "können Sie",
      translated: "puede",
      tone: 'semantic',
    },
    {
      german: "in Berlin",
      translated: "en Berlín",
      tone: 'semantic',
    },
    {
      german: "über politische Themen",
      translated: "sobre temas políticos",
      tone: 'semantic',
    },
    {
      german: "informieren",
      translated: "informarse",
      tone: 'semantic',
    },
  ],
  "lid:state:BE:6|fa": [
    {
      german: "Wo",
      translated: "در",
      tone: 'semantic',
    },
    {
      german: "können Sie",
      translated: "از کجا می‌توانید",
      tone: 'semantic',
    },
    {
      german: "in Berlin",
      translated: "برلین",
      tone: 'semantic',
    },
    {
      german: "über politische Themen",
      translated: "دربارهٔ موضوعات سیاسی",
      tone: 'semantic',
    },
    {
      german: "informieren",
      translated: "اطلاعات کسب کنید",
      tone: 'semantic',
    },
  ],
  "lid:state:BE:6|fr": [
    {
      german: "Wo",
      translated: "Où",
      tone: 'semantic',
    },
    {
      german: "können Sie",
      translated: "pouvez-vous",
      tone: 'semantic',
    },
    {
      german: "sich",
      translated: "vous",
      tone: 'semantic',
    },
    {
      german: "in Berlin",
      translated: "à Berlin",
      tone: 'semantic',
    },
    {
      german: "über politische Themen",
      translated: "sur les questions politiques",
      tone: 'semantic',
    },
    {
      german: "informieren",
      translated: "informer",
      tone: 'semantic',
    },
  ],
  "lid:state:BE:6|hr": [
    {
      german: "Wo",
      translated: "Gdje",
      tone: 'semantic',
    },
    {
      german: "können Sie",
      translated: "mogu",
      tone: 'semantic',
    },
    {
      german: "sich",
      translated: "se",
      tone: 'semantic',
    },
    {
      german: "in Berlin",
      translated: "u Berlinu",
      tone: 'semantic',
    },
    {
      german: "über politische Themen",
      translated: "o političkim temama",
      tone: 'semantic',
    },
    {
      german: "informieren",
      translated: "dobiti informacije",
      tone: 'semantic',
    },
  ],
  "lid:state:BE:6|it": [
    {
      german: "Wo",
      translated: "Dove",
      tone: 'semantic',
    },
    {
      german: "können Sie",
      translated: "si può",
      tone: 'semantic',
    },
    {
      german: "sich",
      translated: "ci",
      tone: 'semantic',
    },
    {
      german: "in Berlin",
      translated: "a Berlino",
      tone: 'semantic',
    },
    {
      german: "über politische Themen",
      translated: "su temi politici",
      tone: 'semantic',
    },
    {
      german: "informieren",
      translated: "informare",
      tone: 'semantic',
    },
  ],
  "lid:state:BE:6|kmr": [
    {
      german: "Wo",
      translated: "Li",
      tone: 'semantic',
    },
    {
      german: "können Sie",
      translated: "li ku",
      tone: 'semantic',
    },
    {
      german: "sich",
      translated: "dikarî",
      tone: 'semantic',
    },
    {
      german: "in Berlin",
      translated: "Berlînê",
      tone: 'semantic',
    },
    {
      german: "über politische Themen",
      translated: "ser mijarên siyasî",
      tone: 'semantic',
    },
    {
      german: "informieren",
      translated: "agahdarî",
      tone: 'semantic',
    },
  ],
  "lid:state:BE:6|pl": [
    {
      german: "Wo",
      translated: "Gdzie",
      tone: 'semantic',
    },
    {
      german: "können Sie",
      translated: "można",
      tone: 'semantic',
    },
    {
      german: "in Berlin",
      translated: "w Berlin",
      tone: 'semantic',
    },
    {
      german: "über politische Themen",
      translated: "na tematy polityczne",
      tone: 'semantic',
    },
    {
      german: "informieren",
      translated: "uzyskać informacje",
      tone: 'semantic',
    },
  ],
  "lid:state:BE:6|prs": [
    {
      german: "Wo",
      translated: "از کجا",
      tone: 'semantic',
    },
    {
      german: "können Sie",
      translated: "می‌توانید",
      tone: 'semantic',
    },
    {
      german: "in Berlin",
      translated: "در برلین",
      tone: 'semantic',
    },
    {
      german: "über politische Themen",
      translated: " دربارهٔ موضوعات سیاسی",
      tone: 'semantic',
    },
    {
      german: "informieren",
      translated: "اطلاعات کسب کنید",
      tone: 'semantic',
    },
  ],
  "lid:state:BE:6|ro": [
    {
      german: "Wo",
      translated: "Unde",
      tone: 'semantic',
    },
    {
      german: "können Sie",
      translated: "vă puteți",
      tone: 'semantic',
    },
    {
      german: "in Berlin",
      translated: "în Berlin",
      tone: 'semantic',
    },
    {
      german: "über politische Themen",
      translated: "despre teme politice",
      tone: 'semantic',
    },
    {
      german: "informieren",
      translated: "informa",
      tone: 'semantic',
    },
  ],
  "lid:state:BE:6|ru": [
    {
      german: "Wo",
      translated: "Где",
      tone: 'semantic',
    },
    {
      german: "können Sie",
      translated: "можно",
      tone: 'semantic',
    },
    {
      german: "in Berlin",
      translated: "в Берлине",
      tone: 'semantic',
    },
    {
      german: "über politische Themen",
      translated: "о политических темах",
      tone: 'semantic',
    },
    {
      german: "informieren",
      translated: "получить информацию",
      tone: 'semantic',
    },
  ],
  "lid:state:BE:6|sq": [
    {
      german: "Wo",
      translated: "Ku",
      tone: 'semantic',
    },
    {
      german: "können Sie",
      translated: "mund të",
      tone: 'semantic',
    },
    {
      german: "in Berlin",
      translated: "në Berlini",
      tone: 'semantic',
    },
    {
      german: "über politische Themen",
      translated: "për tema politike",
      tone: 'semantic',
    },
    {
      german: "informieren",
      translated: "informoheni",
      tone: 'semantic',
    },
  ],
  "lid:state:BE:6|sr": [
    {
      german: "Wo",
      translated: "Gdje",
      tone: 'semantic',
    },
    {
      german: "können Sie",
      translated: "mogu",
      tone: 'semantic',
    },
    {
      german: "sich",
      translated: "se",
      tone: 'semantic',
    },
    {
      german: "in Berlin",
      translated: "u Berlinu",
      tone: 'semantic',
    },
    {
      german: "über politische Themen",
      translated: "o političkim temama",
      tone: 'semantic',
    },
    {
      german: "informieren",
      translated: "dobiti informacije",
      tone: 'semantic',
    },
  ],
  "lid:state:BE:6|tr": [
    {
      german: "Wo",
      translated: "nereden",
      tone: 'semantic',
    },
    {
      german: "können Sie",
      translated: "bilgi alabilirsiniz",
      tone: 'semantic',
    },
    {
      german: "in Berlin",
      translated: "Berlin eyaletinde",
      tone: 'semantic',
    },
    {
      german: "über politische Themen",
      translated: "siyasi konular hakkında",
      tone: 'semantic',
    },
  ],
  "lid:state:BE:6|uk": [
    {
      german: "Wo",
      translated: "Де",
      tone: 'semantic',
    },
    {
      german: "können Sie",
      translated: "можна",
      tone: 'semantic',
    },
    {
      german: "sich",
      translated: "в",
      tone: 'semantic',
    },
    {
      german: "in Berlin",
      translated: "Берлін",
      tone: 'semantic',
    },
    {
      german: "über politische Themen",
      translated: "про політичні питання",
      tone: 'semantic',
    },
    {
      german: "informieren",
      translated: "отримати інформацію",
      tone: 'semantic',
    },
  ],
  "lid:state:BE:6|vi": [
    {
      german: "Wo",
      translated: "ở đâu",
      tone: 'semantic',
    },
    {
      german: "können Sie",
      translated: "có thể",
      tone: 'semantic',
    },
    {
      german: "in Berlin",
      translated: "Ở Berlin",
      tone: 'semantic',
    },
    {
      german: "über politische Themen",
      translated: "về các chủ đề chính trị",
      tone: 'semantic',
    },
    {
      german: "informieren",
      translated: "tìm thông tin",
      tone: 'semantic',
    },
  ],
  "lid:state:BE:7|ar": [
    {
      german: "Welches",
      translated: "أي",
      tone: 'semantic',
    },
    {
      german: "Bundesland",
      translated: "ولاية",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "هي",
      tone: 'semantic',
    },
    {
      german: "ein",
      translated: "مدينة-ولاية",
      tone: 'semantic',
    },
    {
      german: "Stadtstaat",
      translated: "؟",
      tone: 'semantic',
    },
  ],
  "lid:state:BE:7|bg": [
    {
      german: "Welches",
      translated: "Коя",
      tone: 'semantic',
    },
    {
      german: "Bundesland",
      translated: "следните федерални провинции",
      tone: 'semantic',
    },
    {
      german: "ein",
      translated: "е",
      tone: 'semantic',
    },
    {
      german: "Stadtstaat",
      translated: "град-държава",
      tone: 'semantic',
    },
  ],
  "lid:state:BE:7|bs": [
    {
      german: "Welches",
      translated: "Koja",
      tone: 'semantic',
    },
    {
      german: "Bundesland",
      translated: "saveznih zemalja",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "je",
      tone: 'semantic',
    },
    {
      german: "ein",
      translated: "od",
      tone: 'semantic',
    },
    {
      german: "Stadtstaat",
      translated: "grad-država",
      tone: 'semantic',
    },
  ],
  "lid:state:BE:7|el": [
    {
      german: "Welches",
      translated: "Ποιο",
      tone: 'semantic',
    },
    {
      german: "Bundesland",
      translated: "ομόσπονδα κρατίδια",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "είναι",
      tone: 'semantic',
    },
    {
      german: "Stadtstaat",
      translated: "πόλη-κράτος;",
      tone: 'semantic',
    },
  ],
  "lid:state:BE:7|en": [
    {
      german: "Welches",
      translated: "Which",
      tone: 'semantic',
    },
    {
      german: "Bundesland",
      translated: "federal state",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "is",
      tone: 'semantic',
    },
    {
      german: "ein",
      translated: "a",
      tone: 'semantic',
    },
    {
      german: "Stadtstaat",
      translated: "city-state",
      tone: 'semantic',
    },
  ],
  "lid:state:BE:7|es": [
    {
      german: "Welches",
      translated: "Cuál de los siguientes",
      tone: 'semantic',
    },
    {
      german: "Bundesland",
      translated: "estados federados",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "es",
      tone: 'semantic',
    },
    {
      german: "ein",
      translated: "una",
      tone: 'semantic',
    },
    {
      german: "Stadtstaat",
      translated: "ciudad-estado",
      tone: 'semantic',
    },
  ],
  "lid:state:BE:7|fa": [
    {
      german: "Welches",
      translated: "کدام",
      tone: 'semantic',
    },
    {
      german: "Bundesland",
      translated: "از موارد زیر یک",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "است",
      tone: 'semantic',
    },
    {
      german: "ein",
      translated: "یک",
      tone: 'semantic',
    },
    {
      german: "Stadtstaat",
      translated: "شهر-ایالت",
      tone: 'semantic',
    },
  ],
  "lid:state:BE:7|fr": [
    {
      german: "Welches",
      translated: "Quel",
      tone: 'semantic',
    },
    {
      german: "Bundesland",
      translated: "Land",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "est",
      tone: 'semantic',
    },
    {
      german: "ein",
      translated: "une",
      tone: 'semantic',
    },
    {
      german: "Stadtstaat",
      translated: "ville-État",
      tone: 'semantic',
    },
  ],
  "lid:state:BE:7|hr": [
    {
      german: "Welches",
      translated: "Koja",
      tone: 'semantic',
    },
    {
      german: "Bundesland",
      translated: "saveznih zemalja",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "je",
      tone: 'semantic',
    },
    {
      german: "Stadtstaat",
      translated: "grad-država",
      tone: 'semantic',
    },
  ],
  "lid:state:BE:7|it": [
    {
      german: "Welches",
      translated: "Quale",
      tone: 'semantic',
    },
    {
      german: "Bundesland",
      translated: "dei seguenti Länder",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "è",
      tone: 'semantic',
    },
    {
      german: "ein",
      translated: "una",
      tone: 'semantic',
    },
    {
      german: "Stadtstaat",
      translated: "città-Stato",
      tone: 'semantic',
    },
  ],
  "lid:state:BE:7|kmr": [
    {
      german: "Welches",
      translated: "Kîjan",
      tone: 'semantic',
    },
    {
      german: "Bundesland",
      translated: "eyalet",
      tone: 'semantic',
    },
    {
      german: "ein",
      translated: "bajar-dewlet",
      tone: 'semantic',
    },
    {
      german: "Stadtstaat",
      translated: "e?",
      tone: 'semantic',
    },
  ],
  "lid:state:BE:7|pl": [
    {
      german: "Welches",
      translated: "Który",
      tone: 'semantic',
    },
    {
      german: "Bundesland",
      translated: "krajów związkowych",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "jest",
      tone: 'semantic',
    },
    {
      german: "Stadtstaat",
      translated: "miastem-państwem",
      tone: 'semantic',
    },
  ],
  "lid:state:BE:7|prs": [
    {
      german: "Welches",
      translated: "کدام‌یک",
      tone: 'semantic',
    },
    {
      german: "Stadtstaat",
      translated: "شهر-ایالت",
      tone: 'semantic',
    },
  ],
  "lid:state:BE:7|ro": [
    {
      german: "Welches",
      translated: "Care",
      tone: 'semantic',
    },
    {
      german: "Bundesland",
      translated: "landuri",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "este",
      tone: 'semantic',
    },
    {
      german: "ein",
      translated: "un",
      tone: 'semantic',
    },
    {
      german: "Stadtstaat",
      translated: "oraș-stat",
      tone: 'semantic',
    },
  ],
  "lid:state:BE:7|ru": [
    {
      german: "Welches",
      translated: "Какая",
      tone: 'semantic',
    },
    {
      german: "Bundesland",
      translated: "земель",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "является",
      tone: 'semantic',
    },
    {
      german: "ein",
      translated: "городом-землёй",
      tone: 'semantic',
    },
  ],
  "lid:state:BE:7|sq": [
    {
      german: "Welches",
      translated: "Cili",
      tone: 'semantic',
    },
    {
      german: "Bundesland",
      translated: "lande",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "është",
      tone: 'semantic',
    },
    {
      german: "Stadtstaat",
      translated: "qytet-shtet",
      tone: 'semantic',
    },
  ],
  "lid:state:BE:7|sr": [
    {
      german: "Welches",
      translated: "Koja",
      tone: 'semantic',
    },
    {
      german: "Bundesland",
      translated: "saveznih pokrajina",
      tone: 'semantic',
    },
    {
      german: "Stadtstaat",
      translated: "grad-država",
      tone: 'semantic',
    },
  ],
  "lid:state:BE:7|tr": [
    {
      german: "Welches",
      translated: "hangisi",
      tone: 'semantic',
    },
    {
      german: "Bundesland",
      translated: "Aşağıdaki eyaletlerden",
      tone: 'semantic',
    },
    {
      german: "Stadtstaat",
      translated: "şehir devletidir",
      tone: 'semantic',
    },
  ],
  "lid:state:BE:7|uk": [
    {
      german: "Welches",
      translated: "Яка",
      tone: 'semantic',
    },
    {
      german: "Bundesland",
      translated: "федеральна земля",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "є",
      tone: 'semantic',
    },
    {
      german: "ein",
      translated: "містом-землею",
      tone: 'semantic',
    },
  ],
  "lid:state:BE:7|vi": [
    {
      german: "Welches",
      translated: "nào sau đây",
      tone: 'semantic',
    },
    {
      german: "Bundesland",
      translated: "Bang",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "là",
      tone: 'semantic',
    },
    {
      german: "ein",
      translated: "một",
      tone: 'semantic',
    },
    {
      german: "Stadtstaat",
      translated: "thành phố-bang",
      tone: 'semantic',
    },
  ],
  "lid:state:BE:8|ar": [
    {
      german: "Welches Bundesland",
      translated: "أي صورة",
      tone: 'semantic',
    },
    {
      german: "Berlin",
      translated: "Berlin",
      tone: 'semantic',
    },
  ],
  "lid:state:BE:8|bg": [
    {
      german: "Welches Bundesland",
      translated: "Коя от показаните федерални провинции",
      tone: 'semantic',
    },
    {
      german: "Berlin",
      translated: "Берлин",
      tone: 'semantic',
    },
  ],
  "lid:state:BE:8|bs": [
    {
      german: "Welches Bundesland",
      translated: "Koja od prikazanih saveznih zemalja",
      tone: 'semantic',
    },
    {
      german: "Berlin",
      translated: "Berlin",
      tone: 'semantic',
    },
  ],
  "lid:state:BE:8|el": [
    {
      german: "Welches Bundesland",
      translated: "Ποιο από τα εικονιζόμενα κρατίδια",
      tone: 'semantic',
    },
    {
      german: "Berlin",
      translated: "το Βερολίνο",
      tone: 'semantic',
    },
  ],
  "lid:state:BE:8|en": [
    {
      german: "Welches Bundesland",
      translated: "Which federal state",
      tone: 'semantic',
    },
    {
      german: "Berlin",
      translated: "Berlin",
      tone: 'semantic',
    },
  ],
  "lid:state:BE:8|es": [
    {
      german: "Welches Bundesland",
      translated: "estado federado",
      tone: 'semantic',
    },
    {
      german: "Berlin",
      translated: "Berlín",
      tone: 'semantic',
    },
  ],
  "lid:state:BE:8|fa": [
    {
      german: "Welches Bundesland",
      translated: "کدام ایالتِ",
      tone: 'semantic',
    },
    {
      german: "Berlin",
      translated: "برلین",
      tone: 'semantic',
    },
  ],
  "lid:state:BE:8|fr": [
    {
      german: "Welches Bundesland",
      translated: "Quel",
      tone: 'semantic',
    },
    {
      german: "Berlin",
      translated: "Berlin",
      tone: 'semantic',
    },
  ],
  "lid:state:BE:8|hr": [
    {
      german: "Welches Bundesland",
      translated: "Koja od prikazanih",
      tone: 'semantic',
    },
    {
      german: "Berlin",
      translated: "Berlin",
      tone: 'semantic',
    },
  ],
  "lid:state:BE:8|it": [
    {
      german: "Welches Bundesland",
      translated: "Quale Land rappresentato",
      tone: 'semantic',
    },
    {
      german: "Berlin",
      translated: "Berlino",
      tone: 'semantic',
    },
  ],
  "lid:state:BE:8|kmr": [
    {
      german: "Welches Bundesland",
      translated: "Kîjan eyalet",
      tone: 'semantic',
    },
    {
      german: "Berlin",
      translated: "Berlîn",
      tone: 'semantic',
    },
  ],
  "lid:state:BE:8|pl": [
    {
      german: "Welches Bundesland",
      translated: "Który z przedstawionych krajów związkowych",
      tone: 'semantic',
    },
    {
      german: "Berlin",
      translated: "Berlin",
      tone: 'semantic',
    },
  ],
  "lid:state:BE:8|prs": [
    {
      german: "Welches Bundesland",
      translated: "کدام ایالتِ",
      tone: 'semantic',
    },
    {
      german: "Berlin",
      translated: "برلین",
      tone: 'semantic',
    },
  ],
  "lid:state:BE:8|ro": [
    {
      german: "Welches Bundesland",
      translated: "Care land",
      tone: 'semantic',
    },
    {
      german: "Berlin",
      translated: "Berlin",
      tone: 'semantic',
    },
  ],
  "lid:state:BE:8|ru": [
    {
      german: "Welches Bundesland",
      translated: "Какая из этих земель",
      tone: 'semantic',
    },
    {
      german: "Berlin",
      translated: "Берлин",
      tone: 'semantic',
    },
  ],
  "lid:state:BE:8|sq": [
    {
      german: "Welches Bundesland",
      translated: "Cili nga landet e paraqitura",
      tone: 'semantic',
    },
    {
      german: "Berlin",
      translated: "Berlini",
      tone: 'semantic',
    },
  ],
  "lid:state:BE:8|sr": [
    {
      german: "Welches Bundesland",
      translated: "Koja od",
      tone: 'semantic',
    },
    {
      german: "Berlin",
      translated: "Berlin",
      tone: 'semantic',
    },
  ],
  "lid:state:BE:8|tr": [
    {
      german: "Welches Bundesland",
      translated: "Haritada",
      tone: 'semantic',
    },
    {
      german: "Berlin",
      translated: "Berlin",
      tone: 'semantic',
    },
  ],
  "lid:state:BE:8|uk": [
    {
      german: "Welches Bundesland",
      translated: "федеральних земель",
      tone: 'semantic',
    },
    {
      german: "Berlin",
      translated: "Берлін",
      tone: 'semantic',
    },
  ],
  "lid:state:BE:8|vi": [
    {
      german: "Welches Bundesland",
      translated: "Bang nào trong các hình được hiển thị là",
      tone: 'semantic',
    },
    {
      german: "Berlin",
      translated: "Berlin",
      tone: 'semantic',
    },
  ],
  "lid:state:BE:9|ar": [
    {
      german: "Wie nennt man",
      translated: "ماذا يُسمى",
      tone: 'semantic',
    },
    {
      german: "die Regierungschefin/den Regierungschef",
      translated: "رئيس/رئيسة حكومة",
      tone: 'semantic',
    },
    {
      german: "des Stadtstaates Berlin",
      translated: "مدينة-ولاية Berlin",
      tone: 'semantic',
    },
  ],
  "lid:state:BE:9|bg": [
    {
      german: "Wie nennt man",
      translated: "Как се нарича",
      tone: 'semantic',
    },
    {
      german: "die Regierungschefin/den Regierungschef",
      translated: "ръководителят на правителството",
      tone: 'semantic',
    },
    {
      german: "des Stadtstaates Berlin",
      translated: "на град-държавата Берлин",
      tone: 'semantic',
    },
  ],
  "lid:state:BE:9|bs": [
    {
      german: "Wie nennt man",
      translated: "Kako se zove",
      tone: 'semantic',
    },
    {
      german: "die Regierungschefin/den Regierungschef",
      translated: "šef vlade",
      tone: 'semantic',
    },
    {
      german: "des Stadtstaates Berlin",
      translated: "grada-države Berlin",
      tone: 'semantic',
    },
  ],
  "lid:state:BE:9|el": [
    {
      german: "Wie nennt man",
      translated: "Πώς ονομάζεται",
      tone: 'semantic',
    },
    {
      german: "die Regierungschefin/den Regierungschef",
      translated: "ο επικεφαλής της κυβέρνησης",
      tone: 'semantic',
    },
    {
      german: "des Stadtstaates Berlin",
      translated: "της πόλης-κράτους Βερολίνο",
      tone: 'semantic',
    },
  ],
  "lid:state:BE:9|en": [
    {
      german: "Wie nennt man",
      translated: "What is",
      tone: 'semantic',
    },
    {
      german: "die Regierungschefin/den Regierungschef",
      translated: "the head of government",
      tone: 'semantic',
    },
    {
      german: "des Stadtstaates Berlin",
      translated: "in the city-state of Berlin",
      tone: 'semantic',
    },
  ],
  "lid:state:BE:9|es": [
    {
      german: "Wie nennt man",
      translated: "¿Cómo se llama al",
      tone: 'semantic',
    },
    {
      german: "die Regierungschefin/den Regierungschef",
      translated: "jefe o la jefa de gobierno",
      tone: 'semantic',
    },
    {
      german: "des Stadtstaates Berlin",
      translated: "la ciudad-estado de Berlín",
      tone: 'semantic',
    },
  ],
  "lid:state:BE:9|fa": [
    {
      german: "Wie nennt man",
      translated: "رئیس دولت شهر-ایالت برلین",
      tone: 'semantic',
    },
    {
      german: "die Regierungschefin/den Regierungschef",
      translated: "چه عنوانی دارد",
      tone: 'semantic',
    },
    {
      german: "des Stadtstaates Berlin",
      translated: "؟",
      tone: 'semantic',
    },
  ],
  "lid:state:BE:9|fr": [
    {
      german: "Wie nennt man",
      translated: "Comment appelle-t-on",
      tone: 'semantic',
    },
    {
      german: "die Regierungschefin/den Regierungschef",
      translated: "le chef ou la cheffe du gouvernement",
      tone: 'semantic',
    },
    {
      german: "des Stadtstaates Berlin",
      translated: "de la ville-État de Berlin",
      tone: 'semantic',
    },
  ],
  "lid:state:BE:9|hr": [
    {
      german: "Wie nennt man",
      translated: "Kako",
      tone: 'semantic',
    },
    {
      german: "die Regierungschefin/den Regierungschef",
      translated: "čelnik",
      tone: 'semantic',
    },
    {
      german: "des Stadtstaates Berlin",
      translated: "vlade grada-države Berlin",
      tone: 'semantic',
    },
  ],
  "lid:state:BE:9|it": [
    {
      german: "Wie nennt man",
      translated: "Come si chiama",
      tone: 'semantic',
    },
    {
      german: "die Regierungschefin/den Regierungschef",
      translated: "il capo del governo",
      tone: 'semantic',
    },
    {
      german: "des Stadtstaates Berlin",
      translated: "della città-Stato di Berlino",
      tone: 'semantic',
    },
  ],
  "lid:state:BE:9|kmr": [
    {
      german: "Wie nennt man",
      translated: "Serokê",
      tone: 'semantic',
    },
    {
      german: "die Regierungschefin/den Regierungschef",
      translated: "hukûmeta",
      tone: 'semantic',
    },
    {
      german: "des Stadtstaates Berlin",
      translated: "bajar-dewleta Berlînê",
      tone: 'semantic',
    },
  ],
  "lid:state:BE:9|pl": [
    {
      german: "Wie nennt man",
      translated: "Jak nazywa się",
      tone: 'semantic',
    },
    {
      german: "die Regierungschefin/den Regierungschef",
      translated: "szef rządu miasta-państwa",
      tone: 'semantic',
    },
    {
      german: "des Stadtstaates Berlin",
      translated: "Berlin",
      tone: 'semantic',
    },
  ],
  "lid:state:BE:9|prs": [
    {
      german: "Wie nennt man",
      translated: "چه عنوانی دارد",
      tone: 'semantic',
    },
    {
      german: "die Regierungschefin/den Regierungschef",
      translated: "رئیس دولت",
      tone: 'semantic',
    },
    {
      german: "des Stadtstaates Berlin",
      translated: "شهر-ایالت برلین",
      tone: 'semantic',
    },
  ],
  "lid:state:BE:9|ro": [
    {
      german: "Wie nennt man",
      translated: "Cum se numește",
      tone: 'semantic',
    },
    {
      german: "die Regierungschefin/den Regierungschef",
      translated: "șeful guvernului",
      tone: 'semantic',
    },
    {
      german: "des Stadtstaates Berlin",
      translated: "orașului-stat Berlin",
      tone: 'semantic',
    },
  ],
  "lid:state:BE:9|ru": [
    {
      german: "Wie nennt man",
      translated: "Как называют",
      tone: 'semantic',
    },
    {
      german: "die Regierungschefin/den Regierungschef",
      translated: "главу правительства",
      tone: 'semantic',
    },
    {
      german: "des Stadtstaates Berlin",
      translated: "Берлин",
      tone: 'semantic',
    },
  ],
  "lid:state:BE:9|sq": [
    {
      german: "Wie nennt man",
      translated: "Si quhet",
      tone: 'semantic',
    },
    {
      german: "die Regierungschefin/den Regierungschef",
      translated: "kreu i qeverisë së",
      tone: 'semantic',
    },
    {
      german: "des Stadtstaates Berlin",
      translated: "qytet-shtetit Berlini",
      tone: 'semantic',
    },
  ],
  "lid:state:BE:9|sr": [
    {
      german: "Wie nennt man",
      translated: "Kako se zove",
      tone: 'semantic',
    },
    {
      german: "die Regierungschefin/den Regierungschef",
      translated: "šef vlade",
      tone: 'semantic',
    },
    {
      german: "des Stadtstaates Berlin",
      translated: "grada-države Berlin",
      tone: 'semantic',
    },
  ],
  "lid:state:BE:9|tr": [
    {
      german: "Wie nennt man",
      translated: "ne ad verilir",
      tone: 'semantic',
    },
    {
      german: "die Regierungschefin/den Regierungschef",
      translated: "hükümetinin başındaki kişiye",
      tone: 'semantic',
    },
    {
      german: "des Stadtstaates Berlin",
      translated: "Berlin",
      tone: 'semantic',
    },
  ],
  "lid:state:BE:9|uk": [
    {
      german: "Wie nennt man",
      translated: "Як називають",
      tone: 'semantic',
    },
    {
      german: "die Regierungschefin/den Regierungschef",
      translated: "главу уряду",
      tone: 'semantic',
    },
    {
      german: "des Stadtstaates Berlin",
      translated: "міста-землі Берлін",
      tone: 'semantic',
    },
  ],
  "lid:state:BE:9|vi": [
    {
      german: "Wie nennt man",
      translated: "Người đứng đầu chính phủ",
      tone: 'semantic',
    },
    {
      german: "die Regierungschefin/den Regierungschef",
      translated: "của thành phố-bang Berlin",
      tone: 'semantic',
    },
    {
      german: "des Stadtstaates Berlin",
      translated: "được gọi là gì",
      tone: 'semantic',
    },
  ],
  "lid:state:BW:10|ar": [
    {
      german: "Welche Ministerin/welchen Minister",
      translated: "أي وزارة من الوزارات التالية",
      tone: 'semantic',
    },
    {
      german: "Baden-Württemberg",
      translated: "Baden-Württemberg",
      tone: 'semantic',
    },
    {
      german: "nicht",
      translated: "غير موجودة",
      tone: 'semantic',
    },
  ],
  "lid:state:BW:10|bg": [
    {
      german: "Welche Ministerin/welchen Minister",
      translated: "Кой министър",
      tone: 'semantic',
    },
    {
      german: "Baden-Württemberg",
      translated: "Баден-Вюртемберг",
      tone: 'semantic',
    },
    {
      german: "nicht",
      translated: "не съществува",
      tone: 'semantic',
    },
  ],
  "lid:state:BW:10|bs": [
    {
      german: "Welche Ministerin/welchen Minister",
      translated: "Koji ministar",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "ne postoji",
      tone: 'semantic',
    },
    {
      german: "Baden-Württemberg",
      translated: "Baden-Württemberg",
      tone: 'semantic',
    },
  ],
  "lid:state:BW:10|el": [
    {
      german: "Welche Ministerin/welchen Minister",
      translated: "Ποιος υπουργός",
      tone: 'semantic',
    },
    {
      german: "Baden-Württemberg",
      translated: "Βάδη-Βυρτεμβέργη",
      tone: 'semantic',
    },
    {
      german: "nicht",
      translated: "δεν υπάρχει",
      tone: 'semantic',
    },
  ],
  "lid:state:BW:10|en": [
    {
      german: "Welche Ministerin/welchen Minister",
      translated: "Which minister",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "does",
      tone: 'semantic',
    },
    {
      german: "Baden-Württemberg",
      translated: "Baden-Württemberg",
      tone: 'semantic',
    },
    {
      german: "nicht",
      translated: "not",
      tone: 'semantic',
    },
  ],
  "lid:state:BW:10|es": [
    {
      german: "Welche Ministerin/welchen Minister",
      translated: "¿Qué ministerio",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "existe",
      tone: 'semantic',
    },
    {
      german: "Baden-Württemberg",
      translated: "Baden-Wurtemberg",
      tone: 'semantic',
    },
    {
      german: "nicht",
      translated: "NO",
      tone: 'semantic',
    },
  ],
  "lid:state:BW:10|fa": [
    {
      german: "Welche Ministerin/welchen Minister",
      translated: "کدام وزیر",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "در",
      tone: 'semantic',
    },
    {
      german: "Baden-Württemberg",
      translated: "بادن-وورتمبرگ",
      tone: 'semantic',
    },
    {
      german: "nicht",
      translated: "وجود ندارد",
      tone: 'semantic',
    },
  ],
  "lid:state:BW:10|fr": [
    {
      german: "Welche Ministerin/welchen Minister",
      translated: "Quel ministre ou quelle ministre",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "n’existe pas",
      tone: 'semantic',
    },
    {
      german: "Baden-Württemberg",
      translated: "au niveau du Land de Bade-Wurtemberg",
      tone: 'semantic',
    },
  ],
  "lid:state:BW:10|hr": [
    {
      german: "Welche Ministerin/welchen Minister",
      translated: "Koji ministar",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "ne postoji",
      tone: 'semantic',
    },
    {
      german: "Baden-Württemberg",
      translated: "Baden-Württemberg",
      tone: 'semantic',
    },
  ],
  "lid:state:BW:10|it": [
    {
      german: "Welche Ministerin/welchen Minister",
      translated: "Quale ministro",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "esiste",
      tone: 'semantic',
    },
    {
      german: "Baden-Württemberg",
      translated: "Land di Baden-Württemberg",
      tone: 'semantic',
    },
    {
      german: "nicht",
      translated: "non",
      tone: 'semantic',
    },
  ],
  "lid:state:BW:10|kmr": [
    {
      german: "Welche Ministerin/welchen Minister",
      translated: "Kîjan wezîr",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "ye",
      tone: 'semantic',
    },
    {
      german: "Baden-Württemberg",
      translated: "Baden-Württemberg",
      tone: 'semantic',
    },
    {
      german: "nicht",
      translated: "tune",
      tone: 'semantic',
    },
  ],
  "lid:state:BW:10|pl": [
    {
      german: "Welche Ministerin/welchen Minister",
      translated: "Którego ministra",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "ma",
      tone: 'semantic',
    },
    {
      german: "Baden-Württemberg",
      translated: "Badenia-Wirtembergia",
      tone: 'semantic',
    },
    {
      german: "nicht",
      translated: "nie",
      tone: 'semantic',
    },
  ],
  "lid:state:BW:10|prs": [
    {
      german: "Welche Ministerin/welchen Minister",
      translated: "کدام وزیر در سطح ایالت",
      tone: 'semantic',
    },
    {
      german: "Baden-Württemberg",
      translated: "بادن-وورتمبرگ",
      tone: 'semantic',
    },
    {
      german: "nicht",
      translated: "وجود ندارد",
      tone: 'semantic',
    },
  ],
  "lid:state:BW:10|ro": [
    {
      german: "Welche Ministerin/welchen Minister",
      translated: "Care ministru",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "nu există",
      tone: 'semantic',
    },
    {
      german: "Baden-Württemberg",
      translated: "Baden-Württemberg",
      tone: 'semantic',
    },
    {
      german: "nicht",
      translated: "la nivelul landului",
      tone: 'semantic',
    },
  ],
  "lid:state:BW:10|ru": [
    {
      german: "Welche Ministerin/welchen Minister",
      translated: "Какого министра",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "нет",
      tone: 'semantic',
    },
    {
      german: "Baden-Württemberg",
      translated: "Баден-Вюртемберг",
      tone: 'semantic',
    },
    {
      german: "nicht",
      translated: "в федеральной земле",
      tone: 'semantic',
    },
  ],
  "lid:state:BW:10|sq": [
    {
      german: "Welche Ministerin/welchen Minister",
      translated: "Cili ministër",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "ekziston",
      tone: 'semantic',
    },
    {
      german: "Baden-Württemberg",
      translated: "Baden-Württemberg",
      tone: 'semantic',
    },
    {
      german: "nicht",
      translated: "nuk",
      tone: 'semantic',
    },
  ],
  "lid:state:BW:10|sr": [
    {
      german: "Welche Ministerin/welchen Minister",
      translated: "Koji ministar",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "ne postoji",
      tone: 'semantic',
    },
    {
      german: "Baden-Württemberg",
      translated: "Baden-Virtemberg",
      tone: 'semantic',
    },
  ],
  "lid:state:BW:10|tr": [
    {
      german: "Welche Ministerin/welchen Minister",
      translated: "aşağıdaki bakanlıklardan hangisi",
      tone: 'semantic',
    },
    {
      german: "Baden-Württemberg",
      translated: "Baden-Württemberg eyaletinde",
      tone: 'semantic',
    },
    {
      german: "nicht",
      translated: "yoktur",
      tone: 'semantic',
    },
  ],
  "lid:state:BW:10|uk": [
    {
      german: "Welche Ministerin/welchen Minister",
      translated: "Якого міністра/міністерки",
      tone: 'semantic',
    },
    {
      german: "Baden-Württemberg",
      translated: "Баден-Вюртемберг",
      tone: 'semantic',
    },
    {
      german: "nicht",
      translated: "немає",
      tone: 'semantic',
    },
  ],
  "lid:state:BW:10|vi": [
    {
      german: "Welche Ministerin/welchen Minister",
      translated: "Bộ trưởng nào",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "tồn tại",
      tone: 'semantic',
    },
    {
      german: "Baden-Württemberg",
      translated: "Baden-Württemberg",
      tone: 'semantic',
    },
    {
      german: "nicht",
      translated: "không",
      tone: 'semantic',
    },
  ],
  "lid:state:BW:1|ar": [
    {
      german: "Welches Wappen",
      translated: "أي شعار",
      tone: 'semantic',
    },
    {
      german: "gehört zum",
      translated: "يعود إلى",
      tone: 'semantic',
    },
    {
      german: "Bundesland",
      translated: "ولاية",
      tone: 'semantic',
    },
    {
      german: "Baden-Württemberg",
      translated: "Baden-Württemberg",
      tone: 'semantic',
    },
  ],
  "lid:state:BW:1|bg": [
    {
      german: "Welches Wappen",
      translated: "Кой герб",
      tone: 'semantic',
    },
    {
      german: "gehört zum",
      translated: "принадлежи на",
      tone: 'semantic',
    },
    {
      german: "Bundesland",
      translated: "федералната провинция",
      tone: 'semantic',
    },
    {
      german: "Baden-Württemberg",
      translated: "Баден-Вюртемберг?",
      tone: 'semantic',
    },
  ],
  "lid:state:BW:1|bs": [
    {
      german: "Welches Wappen",
      translated: "Koji grb",
      tone: 'semantic',
    },
    {
      german: "gehört zum",
      translated: "pripada",
      tone: 'semantic',
    },
    {
      german: "Bundesland",
      translated: "saveznoj zemlji",
      tone: 'semantic',
    },
    {
      german: "Baden-Württemberg",
      translated: "Baden-Württemberg",
      tone: 'semantic',
    },
  ],
  "lid:state:BW:1|el": [
    {
      german: "Welches Wappen",
      translated: "Ποιο έμβλημα",
      tone: 'semantic',
    },
    {
      german: "gehört zum",
      translated: "ανήκει στο",
      tone: 'semantic',
    },
    {
      german: "Bundesland",
      translated: "ομόσπονδο κρατίδιο",
      tone: 'semantic',
    },
    {
      german: "Baden-Württemberg",
      translated: "Βάδη-Βυρτεμβέργη",
      tone: 'semantic',
    },
  ],
  "lid:state:BW:1|en": [
    {
      german: "Welches Wappen",
      translated: "Which coat of arms",
      tone: 'semantic',
    },
    {
      german: "gehört zum",
      translated: "belongs to",
      tone: 'semantic',
    },
    {
      german: "Bundesland",
      translated: "federal state",
      tone: 'semantic',
    },
    {
      german: "Baden-Württemberg",
      translated: "Baden-Württemberg",
      tone: 'semantic',
    },
  ],
  "lid:state:BW:1|es": [
    {
      german: "Welches Wappen",
      translated: "¿Qué escudo",
      tone: 'semantic',
    },
    {
      german: "gehört zum",
      translated: "pertenece al",
      tone: 'semantic',
    },
    {
      german: "Bundesland",
      translated: "estado federado",
      tone: 'semantic',
    },
    {
      german: "Baden-Württemberg",
      translated: "Baden-Wurtemberg",
      tone: 'semantic',
    },
  ],
  "lid:state:BW:1|fa": [
    {
      german: "Welches Wappen",
      translated: "کدام نشان",
      tone: 'semantic',
    },
    {
      german: "gehört zum",
      translated: "متعلق به",
      tone: 'semantic',
    },
    {
      german: "Bundesland",
      translated: "ایالت",
      tone: 'semantic',
    },
    {
      german: "Baden-Württemberg",
      translated: "بادن-وورتمبرگ",
      tone: 'semantic',
    },
  ],
  "lid:state:BW:1|fr": [
    {
      german: "Welches Wappen",
      translated: "Quel blason",
      tone: 'semantic',
    },
    {
      german: "gehört zum",
      translated: "appartient au",
      tone: 'semantic',
    },
    {
      german: "Bundesland",
      translated: "Land de",
      tone: 'semantic',
    },
    {
      german: "Baden-Württemberg",
      translated: "Bade-Wurtemberg",
      tone: 'semantic',
    },
  ],
  "lid:state:BW:1|hr": [
    {
      german: "Welches Wappen",
      translated: "Koji grb",
      tone: 'semantic',
    },
    {
      german: "gehört zum",
      translated: "pripada",
      tone: 'semantic',
    },
    {
      german: "Bundesland",
      translated: "saveznoj zemlji",
      tone: 'semantic',
    },
    {
      german: "Baden-Württemberg",
      translated: "Baden-Württemberg",
      tone: 'semantic',
    },
  ],
  "lid:state:BW:1|it": [
    {
      german: "Welches Wappen",
      translated: "Quale stemma",
      tone: 'semantic',
    },
    {
      german: "gehört zum",
      translated: "appartiene al",
      tone: 'semantic',
    },
    {
      german: "Bundesland",
      translated: "Land",
      tone: 'semantic',
    },
    {
      german: "Baden-Württemberg",
      translated: "di Baden-Württemberg",
      tone: 'semantic',
    },
  ],
  "lid:state:BW:1|kmr": [
    {
      german: "Welches Wappen",
      translated: "Kîjan nîşan",
      tone: 'semantic',
    },
    {
      german: "Bundesland",
      translated: "eyaleta",
      tone: 'semantic',
    },
    {
      german: "Baden-Württemberg",
      translated: "Baden-Württemberg",
      tone: 'semantic',
    },
  ],
  "lid:state:BW:1|pl": [
    {
      german: "Welches Wappen",
      translated: "Który herb",
      tone: 'semantic',
    },
    {
      german: "gehört zum",
      translated: "należy do",
      tone: 'semantic',
    },
    {
      german: "Bundesland",
      translated: "kraju związkowego",
      tone: 'semantic',
    },
    {
      german: "Baden-Württemberg",
      translated: "Badenia-Wirtembergia",
      tone: 'semantic',
    },
  ],
  "lid:state:BW:1|prs": [
    {
      german: "Welches Wappen",
      translated: "کدام نشان",
      tone: 'semantic',
    },
    {
      german: "gehört zum",
      translated: "متعلق به",
      tone: 'semantic',
    },
    {
      german: "Bundesland",
      translated: "ایالت",
      tone: 'semantic',
    },
    {
      german: "Baden-Württemberg",
      translated: "بادن-وورتمبرگ",
      tone: 'semantic',
    },
  ],
  "lid:state:BW:1|ro": [
    {
      german: "Welches Wappen",
      translated: "Care stemă",
      tone: 'semantic',
    },
    {
      german: "gehört zum",
      translated: "aparține",
      tone: 'semantic',
    },
    {
      german: "Bundesland",
      translated: "landului",
      tone: 'semantic',
    },
    {
      german: "Baden-Württemberg",
      translated: "Baden-Württemberg",
      tone: 'semantic',
    },
  ],
  "lid:state:BW:1|ru": [
    {
      german: "Welches Wappen",
      translated: "Какой герб",
      tone: 'semantic',
    },
    {
      german: "gehört zum",
      translated: "принадлежит",
      tone: 'semantic',
    },
    {
      german: "Bundesland",
      translated: "федеральной земле",
      tone: 'semantic',
    },
    {
      german: "Baden-Württemberg",
      translated: "Баден-Вюртемберг",
      tone: 'semantic',
    },
  ],
  "lid:state:BW:1|sq": [
    {
      german: "Welches Wappen",
      translated: "Cila stemë",
      tone: 'semantic',
    },
    {
      german: "gehört zum",
      translated: "i përket",
      tone: 'semantic',
    },
    {
      german: "Bundesland",
      translated: "landit",
      tone: 'semantic',
    },
    {
      german: "Baden-Württemberg",
      translated: "Baden-Württemberg",
      tone: 'semantic',
    },
  ],
  "lid:state:BW:1|sr": [
    {
      german: "Welches Wappen",
      translated: "Koji grb",
      tone: 'semantic',
    },
    {
      german: "gehört zum",
      translated: "pripada",
      tone: 'semantic',
    },
    {
      german: "Bundesland",
      translated: "saveznoj pokrajini",
      tone: 'semantic',
    },
    {
      german: "Baden-Württemberg",
      translated: "Baden-Virtemberg",
      tone: 'semantic',
    },
  ],
  "lid:state:BW:1|tr": [
    {
      german: "Welches Wappen",
      translated: "arması hangisidir",
      tone: 'semantic',
    },
    {
      german: "Bundesland",
      translated: "eyaletinin",
      tone: 'semantic',
    },
    {
      german: "Baden-Württemberg",
      translated: "Baden-Württemberg",
      tone: 'semantic',
    },
  ],
  "lid:state:BW:1|uk": [
    {
      german: "Welches Wappen",
      translated: "герб",
      tone: 'semantic',
    },
    {
      german: "gehört zum",
      translated: "належить",
      tone: 'semantic',
    },
    {
      german: "Bundesland",
      translated: "землі",
      tone: 'semantic',
    },
    {
      german: "Baden-Württemberg",
      translated: "Баден-Вюртемберг",
      tone: 'semantic',
    },
  ],
  "lid:state:BW:1|vi": [
    {
      german: "Welches Wappen",
      translated: "Quốc huy",
      tone: 'semantic',
    },
    {
      german: "gehört zum",
      translated: "thuộc",
      tone: 'semantic',
    },
    {
      german: "Bundesland",
      translated: "bang",
      tone: 'semantic',
    },
    {
      german: "Baden-Württemberg",
      translated: "Baden-Württemberg",
      tone: 'semantic',
    },
  ],
  "lid:state:BW:2|ar": [
    {
      german: "Welches ist",
      translated: "أي",
      tone: 'semantic',
    },
    {
      german: "ein Landkreis",
      translated: "دائرة إدارية (Landkreis)",
      tone: 'semantic',
    },
    {
      german: "in Baden-Württemberg",
      translated: "في Baden-Württemberg",
      tone: 'semantic',
    },
  ],
  "lid:state:BW:2|bg": [
    {
      german: "Welches ist",
      translated: "Кое",
      tone: 'semantic',
    },
    {
      german: "ein Landkreis",
      translated: "от следните е окръг (Landkreis)",
      tone: 'semantic',
    },
    {
      german: "in Baden-Württemberg",
      translated: "в Баден-Вюртемберг?",
      tone: 'semantic',
    },
  ],
  "lid:state:BW:2|bs": [
    {
      german: "Welches ist",
      translated: "Što je",
      tone: 'semantic',
    },
    {
      german: "ein Landkreis",
      translated: "od navedenoga okrug (Landkreis)",
      tone: 'semantic',
    },
    {
      german: "in Baden-Württemberg",
      translated: "u saveznoj zemlji Baden-Württemberg",
      tone: 'semantic',
    },
  ],
  "lid:state:BW:2|el": [
    {
      german: "Welches ist",
      translated: "Ποιο από τα παρακάτω είναι",
      tone: 'semantic',
    },
    {
      german: "ein Landkreis",
      translated: "διοικητική περιφέρεια (Landkreis)",
      tone: 'semantic',
    },
    {
      german: "in Baden-Württemberg",
      translated: "στο Βάδη-Βυρτεμβέργη",
      tone: 'semantic',
    },
  ],
  "lid:state:BW:2|en": [
    {
      german: "Welches ist",
      translated: "Which",
      tone: 'semantic',
    },
    {
      german: "ein Landkreis",
      translated: "a district",
      tone: 'semantic',
    },
    {
      german: "in Baden-Württemberg",
      translated: "in Baden-Württemberg",
      tone: 'semantic',
    },
  ],
  "lid:state:BW:2|es": [
    {
      german: "Welches ist",
      translated: "¿Cuál de los siguientes es",
      tone: 'semantic',
    },
    {
      german: "ein Landkreis",
      translated: "un distrito (Landkreis)",
      tone: 'semantic',
    },
    {
      german: "in Baden-Württemberg",
      translated: "de Baden-Wurtemberg",
      tone: 'semantic',
    },
  ],
  "lid:state:BW:2|fa": [
    {
      german: "Welches ist",
      translated: "کدام‌یک از",
      tone: 'semantic',
    },
    {
      german: "ein Landkreis",
      translated: "شهرستان",
      tone: 'semantic',
    },
    {
      german: "in Baden-Württemberg",
      translated: "Landkreis) در بادن-وورتمبرگ است؟",
      tone: 'semantic',
    },
  ],
  "lid:state:BW:2|fr": [
    {
      german: "Welches ist",
      translated: "Lequel des",
      tone: 'semantic',
    },
    {
      german: "ein Landkreis",
      translated: "un arrondissement",
      tone: 'semantic',
    },
    {
      german: "in Baden-Württemberg",
      translated: "de Bade-Wurtemberg",
      tone: 'semantic',
    },
  ],
  "lid:state:BW:2|hr": [
    {
      german: "Welches ist",
      translated: "Što je",
      tone: 'semantic',
    },
    {
      german: "ein Landkreis",
      translated: "od navedenoga okrug (Landkreis)",
      tone: 'semantic',
    },
    {
      german: "in Baden-Württemberg",
      translated: "u saveznoj zemlji Baden-Württemberg",
      tone: 'semantic',
    },
  ],
  "lid:state:BW:2|it": [
    {
      german: "Welches ist",
      translated: "Quale dei seguenti è",
      tone: 'semantic',
    },
    {
      german: "ein Landkreis",
      translated: "distretto (Landkreis)",
      tone: 'semantic',
    },
    {
      german: "in Baden-Württemberg",
      translated: "di Baden-Württemberg",
      tone: 'semantic',
    },
  ],
  "lid:state:BW:2|kmr": [
    {
      german: "Welches ist",
      translated: "Kîjan",
      tone: 'semantic',
    },
    {
      german: "ein Landkreis",
      translated: "navçe",
      tone: 'semantic',
    },
    {
      german: "in Baden-Württemberg",
      translated: "li Baden-Württemberg",
      tone: 'semantic',
    },
  ],
  "lid:state:BW:2|pl": [
    {
      german: "Welches ist",
      translated: "Który",
      tone: 'semantic',
    },
    {
      german: "ein Landkreis",
      translated: "powiatem",
      tone: 'semantic',
    },
    {
      german: "in Baden-Württemberg",
      translated: "w Badenia-Wirtembergia?",
      tone: 'semantic',
    },
  ],
  "lid:state:BW:2|prs": [
    {
      german: "ein Landkreis",
      translated: "یک شهرستان (Landkreis)",
      tone: 'semantic',
    },
    {
      german: "in Baden-Württemberg",
      translated: "در بادن-وورتمبرگ",
      tone: 'semantic',
    },
  ],
  "lid:state:BW:2|ro": [
    {
      german: "Welches ist",
      translated: "Care dintre",
      tone: 'semantic',
    },
    {
      german: "ein Landkreis",
      translated: "un district (Landkreis)",
      tone: 'semantic',
    },
    {
      german: "in Baden-Württemberg",
      translated: "din Baden-Württemberg",
      tone: 'semantic',
    },
  ],
  "lid:state:BW:2|ru": [
    {
      german: "Welches ist",
      translated: "Какой из перечисленных",
      tone: 'semantic',
    },
    {
      german: "ein Landkreis",
      translated: "районом",
      tone: 'semantic',
    },
    {
      german: "in Baden-Württemberg",
      translated: "в федеральной земле Баден-Вюртемберг",
      tone: 'semantic',
    },
  ],
  "lid:state:BW:2|sq": [
    {
      german: "Welches ist",
      translated: "Cila nga këto",
      tone: 'semantic',
    },
    {
      german: "ein Landkreis",
      translated: "qark (Landkreis)",
      tone: 'semantic',
    },
    {
      german: "in Baden-Württemberg",
      translated: "në Baden-Württemberg",
      tone: 'semantic',
    },
  ],
  "lid:state:BW:2|sr": [
    {
      german: "Welches ist",
      translated: "Šta je",
      tone: 'semantic',
    },
    {
      german: "ein Landkreis",
      translated: "okrug (Landkreis)",
      tone: 'semantic',
    },
    {
      german: "in Baden-Württemberg",
      translated: "u saveznoj pokrajini Baden-Virtemberg",
      tone: 'semantic',
    },
  ],
  "lid:state:BW:2|tr": [
    {
      german: "Welches ist",
      translated: "Aşağıdakilerden hangisi",
      tone: 'semantic',
    },
    {
      german: "ein Landkreis",
      translated: "bir Landkreis (ilçe/idari bölge)dir",
      tone: 'semantic',
    },
    {
      german: "in Baden-Württemberg",
      translated: "Baden-Württemberg eyaletinde bulunan",
      tone: 'semantic',
    },
  ],
  "lid:state:BW:2|uk": [
    {
      german: "Welches ist",
      translated: "Який із",
      tone: 'semantic',
    },
    {
      german: "ein Landkreis",
      translated: "районів",
      tone: 'semantic',
    },
    {
      german: "in Baden-Württemberg",
      translated: "у Баден-Вюртемберг",
      tone: 'semantic',
    },
  ],
  "lid:state:BW:2|vi": [
    {
      german: "Welches ist",
      translated: "Địa danh nào sau đây là",
      tone: 'semantic',
    },
    {
      german: "ein Landkreis",
      translated: "một huyện (Landkreis)",
      tone: 'semantic',
    },
    {
      german: "in Baden-Württemberg",
      translated: "của bang Baden-Württemberg",
      tone: 'semantic',
    },
  ],
  "lid:state:BW:3|ar": [
    {
      german: "Für wie viele Jahre",
      translated: "لمدة كم سنة",
      tone: 'semantic',
    },
    {
      german: "der Landtag",
      translated: "برلمان الولاية",
      tone: 'semantic',
    },
    {
      german: "in Baden-Württemberg",
      translated: "في Baden-Württemberg",
      tone: 'semantic',
    },
    {
      german: "gewählt",
      translated: "يُنتخب",
      tone: 'semantic',
    },
  ],
  "lid:state:BW:3|bg": [
    {
      german: "Für wie viele Jahre",
      translated: "За колко години",
      tone: 'semantic',
    },
    {
      german: "der Landtag",
      translated: "парламентът",
      tone: 'semantic',
    },
    {
      german: "in Baden-Württemberg",
      translated: "на провинция Баден-Вюртемберг",
      tone: 'semantic',
    },
    {
      german: "gewählt",
      translated: "избира",
      tone: 'semantic',
    },
  ],
  "lid:state:BW:3|bs": [
    {
      german: "Für wie viele Jahre",
      translated: "Na koliko se godina",
      tone: 'semantic',
    },
    {
      german: "der Landtag",
      translated: "parlament savezne zemlje",
      tone: 'semantic',
    },
    {
      german: "in Baden-Württemberg",
      translated: "Baden-Württemberg",
      tone: 'semantic',
    },
    {
      german: "gewählt",
      translated: "bira",
      tone: 'semantic',
    },
  ],
  "lid:state:BW:3|el": [
    {
      german: "Für wie viele Jahre",
      translated: "Για πόσα χρόνια",
      tone: 'semantic',
    },
    {
      german: "der Landtag",
      translated: "το Landtag",
      tone: 'semantic',
    },
    {
      german: "in Baden-Württemberg",
      translated: "του Βάδη-Βυρτεμβέργη",
      tone: 'semantic',
    },
    {
      german: "gewählt",
      translated: "εκλέγεται",
      tone: 'semantic',
    },
  ],
  "lid:state:BW:3|en": [
    {
      german: "Für wie viele Jahre",
      translated: "For how many years",
      tone: 'semantic',
    },
    {
      german: "der Landtag",
      translated: "the state parliament",
      tone: 'semantic',
    },
    {
      german: "in Baden-Württemberg",
      translated: "in Baden-Württemberg",
      tone: 'semantic',
    },
    {
      german: "gewählt",
      translated: "elected",
      tone: 'semantic',
    },
  ],
  "lid:state:BW:3|es": [
    {
      german: "Für wie viele Jahre",
      translated: "¿Por cuántos años",
      tone: 'semantic',
    },
    {
      german: "der Landtag",
      translated: "el parlamento regional",
      tone: 'semantic',
    },
    {
      german: "in Baden-Württemberg",
      translated: "en Baden-Wurtemberg",
      tone: 'semantic',
    },
    {
      german: "gewählt",
      translated: "se elige",
      tone: 'semantic',
    },
  ],
  "lid:state:BW:3|fa": [
    {
      german: "Für wie viele Jahre",
      translated: "برای چند سال",
      tone: 'semantic',
    },
    {
      german: "der Landtag",
      translated: "پارلمان ایالتی",
      tone: 'semantic',
    },
    {
      german: "in Baden-Württemberg",
      translated: "بادن-وورتمبرگ",
      tone: 'semantic',
    },
    {
      german: "gewählt",
      translated: "انتخاب می‌شود",
      tone: 'semantic',
    },
  ],
  "lid:state:BW:3|fr": [
    {
      german: "Für wie viele Jahre",
      translated: "Pour combien d’années",
      tone: 'semantic',
    },
    {
      german: "der Landtag",
      translated: "le Landtag",
      tone: 'semantic',
    },
    {
      german: "in Baden-Württemberg",
      translated: "de Bade-Wurtemberg",
      tone: 'semantic',
    },
    {
      german: "gewählt",
      translated: "est-il élu",
      tone: 'semantic',
    },
  ],
  "lid:state:BW:3|hr": [
    {
      german: "Für wie viele Jahre",
      translated: "Na koliko se godina",
      tone: 'semantic',
    },
    {
      german: "der Landtag",
      translated: "parlament savezne zemlje",
      tone: 'semantic',
    },
    {
      german: "in Baden-Württemberg",
      translated: "Baden-Württemberg",
      tone: 'semantic',
    },
    {
      german: "gewählt",
      translated: "bira",
      tone: 'semantic',
    },
  ],
  "lid:state:BW:3|it": [
    {
      german: "Für wie viele Jahre",
      translated: "Per quanti anni",
      tone: 'semantic',
    },
    {
      german: "der Landtag",
      translated: "il Landtag",
      tone: 'semantic',
    },
    {
      german: "in Baden-Württemberg",
      translated: "di Baden-Württemberg",
      tone: 'semantic',
    },
    {
      german: "gewählt",
      translated: "viene eletto",
      tone: 'semantic',
    },
  ],
  "lid:state:BW:3|kmr": [
    {
      german: "Für wie viele Jahre",
      translated: "ji bo çend salan",
      tone: 'semantic',
    },
    {
      german: "der Landtag",
      translated: "Landtag",
      tone: 'semantic',
    },
    {
      german: "in Baden-Württemberg",
      translated: "a Baden-Württemberg",
      tone: 'semantic',
    },
    {
      german: "gewählt",
      translated: "hilbijartin",
      tone: 'semantic',
    },
  ],
  "lid:state:BW:3|pl": [
    {
      german: "Für wie viele Jahre",
      translated: "Na ile lat",
      tone: 'semantic',
    },
    {
      german: "der Landtag",
      translated: "parlament",
      tone: 'semantic',
    },
    {
      german: "in Baden-Württemberg",
      translated: "kraju związkowego Badenia-Wirtembergia",
      tone: 'semantic',
    },
    {
      german: "gewählt",
      translated: "wybierany",
      tone: 'semantic',
    },
  ],
  "lid:state:BW:3|prs": [
    {
      german: "Für wie viele Jahre",
      translated: "چند سال",
      tone: 'semantic',
    },
    {
      german: "der Landtag",
      translated: "پارلمان ایالتی",
      tone: 'semantic',
    },
    {
      german: "in Baden-Württemberg",
      translated: "بادن-وورتمبرگ",
      tone: 'semantic',
    },
    {
      german: "gewählt",
      translated: "انتخاب می‌شود",
      tone: 'semantic',
    },
  ],
  "lid:state:BW:3|ro": [
    {
      german: "Für wie viele Jahre",
      translated: "Pentru câți ani",
      tone: 'semantic',
    },
    {
      german: "der Landtag",
      translated: "parlamentul landului",
      tone: 'semantic',
    },
    {
      german: "in Baden-Württemberg",
      translated: "Baden-Württemberg",
      tone: 'semantic',
    },
    {
      german: "gewählt",
      translated: "ales",
      tone: 'semantic',
    },
  ],
  "lid:state:BW:3|ru": [
    {
      german: "Für wie viele Jahre",
      translated: "На сколько лет",
      tone: 'semantic',
    },
    {
      german: "der Landtag",
      translated: "ландтаг",
      tone: 'semantic',
    },
    {
      german: "in Baden-Württemberg",
      translated: "в федеральной земле Баден-Вюртемберг",
      tone: 'semantic',
    },
    {
      german: "gewählt",
      translated: "избирается",
      tone: 'semantic',
    },
  ],
  "lid:state:BW:3|sq": [
    {
      german: "Für wie viele Jahre",
      translated: "sa vjet",
      tone: 'semantic',
    },
    {
      german: "der Landtag",
      translated: "Landtagu",
      tone: 'semantic',
    },
    {
      german: "in Baden-Württemberg",
      translated: "i Baden-Württemberg",
      tone: 'semantic',
    },
    {
      german: "gewählt",
      translated: "zgjidhet",
      tone: 'semantic',
    },
  ],
  "lid:state:BW:3|sr": [
    {
      german: "Für wie viele Jahre",
      translated: "Na koliko se godina",
      tone: 'semantic',
    },
    {
      german: "der Landtag",
      translated: "parlament savezne",
      tone: 'semantic',
    },
    {
      german: "in Baden-Württemberg",
      translated: "Baden-Virtemberg",
      tone: 'semantic',
    },
    {
      german: "gewählt",
      translated: "bira",
      tone: 'semantic',
    },
  ],
  "lid:state:BW:3|tr": [
    {
      german: "Für wie viele Jahre",
      translated: "kaç yıllığına",
      tone: 'semantic',
    },
    {
      german: "der Landtag",
      translated: "eyalet parlamentosu",
      tone: 'semantic',
    },
    {
      german: "in Baden-Württemberg",
      translated: "Baden-Württemberg",
      tone: 'semantic',
    },
    {
      german: "gewählt",
      translated: "seçilir",
      tone: 'semantic',
    },
  ],
  "lid:state:BW:3|uk": [
    {
      german: "Für wie viele Jahre",
      translated: "На скільки років",
      tone: 'semantic',
    },
    {
      german: "der Landtag",
      translated: "земельний парламент",
      tone: 'semantic',
    },
    {
      german: "in Baden-Württemberg",
      translated: "у Баден-Вюртемберг",
      tone: 'semantic',
    },
    {
      german: "gewählt",
      translated: "обирають",
      tone: 'semantic',
    },
  ],
  "lid:state:BW:3|vi": [
    {
      german: "Für wie viele Jahre",
      translated: "bao nhiêu năm",
      tone: 'semantic',
    },
    {
      german: "der Landtag",
      translated: "Nghị viện bang (Landtag)",
      tone: 'semantic',
    },
    {
      german: "in Baden-Württemberg",
      translated: "của Baden-Württemberg",
      tone: 'semantic',
    },
    {
      german: "gewählt",
      translated: "được bầu",
      tone: 'semantic',
    },
  ],
  "lid:state:BW:4|ar": [
    {
      german: "Ab welchem Alter",
      translated: "ابتداءً من أي سن",
      tone: 'semantic',
    },
    {
      german: "darf man",
      translated: "يحق",
      tone: 'semantic',
    },
    {
      german: "in Baden-Württemberg",
      translated: "Baden-Württemberg",
      tone: 'semantic',
    },
    {
      german: "bei Kommunalwahlen",
      translated: "في الانتخابات المحلية",
      tone: 'semantic',
    },
    {
      german: "wählen",
      translated: "التصويت",
      tone: 'semantic',
    },
  ],
  "lid:state:BW:4|bg": [
    {
      german: "Ab welchem Alter",
      translated: "От каква възраст",
      tone: 'semantic',
    },
    {
      german: "darf man",
      translated: "може да",
      tone: 'semantic',
    },
    {
      german: "in Baden-Württemberg",
      translated: "в Баден-Вюртемберг",
      tone: 'semantic',
    },
    {
      german: "bei Kommunalwahlen",
      translated: "на общински избори",
      tone: 'semantic',
    },
    {
      german: "wählen",
      translated: "се гласува",
      tone: 'semantic',
    },
  ],
  "lid:state:BW:4|bs": [
    {
      german: "Ab welchem Alter",
      translated: "Od koje se dobi",
      tone: 'semantic',
    },
    {
      german: "darf man",
      translated: "može",
      tone: 'semantic',
    },
    {
      german: "in Baden-Württemberg",
      translated: "u saveznoj zemlji Baden-Württemberg",
      tone: 'semantic',
    },
    {
      german: "bei Kommunalwahlen",
      translated: "na lokalnim izborima",
      tone: 'semantic',
    },
    {
      german: "wählen",
      translated: "glasovati",
      tone: 'semantic',
    },
  ],
  "lid:state:BW:4|el": [
    {
      german: "Ab welchem Alter",
      translated: "Από ποια ηλικία",
      tone: 'semantic',
    },
    {
      german: "darf man",
      translated: "μπορεί κάποιος να",
      tone: 'semantic',
    },
    {
      german: "in Baden-Württemberg",
      translated: "στο Βάδη-Βυρτεμβέργη",
      tone: 'semantic',
    },
    {
      german: "bei Kommunalwahlen",
      translated: "στις δημοτικές εκλογές",
      tone: 'semantic',
    },
    {
      german: "wählen",
      translated: "ψηφίσει",
      tone: 'semantic',
    },
  ],
  "lid:state:BW:4|en": [
    {
      german: "Ab welchem Alter",
      translated: "From what age",
      tone: 'semantic',
    },
    {
      german: "darf man",
      translated: "can you",
      tone: 'semantic',
    },
    {
      german: "in Baden-Württemberg",
      translated: "in Baden-Württemberg",
      tone: 'semantic',
    },
    {
      german: "bei Kommunalwahlen",
      translated: "local elections",
      tone: 'semantic',
    },
    {
      german: "wählen",
      translated: "vote",
      tone: 'semantic',
    },
  ],
  "lid:state:BW:4|es": [
    {
      german: "Ab welchem Alter",
      translated: "¿A partir de qué edad",
      tone: 'semantic',
    },
    {
      german: "darf man",
      translated: "se puede",
      tone: 'semantic',
    },
    {
      german: "in Baden-Württemberg",
      translated: "de Baden-Wurtemberg",
      tone: 'semantic',
    },
    {
      german: "bei Kommunalwahlen",
      translated: "en las elecciones municipales",
      tone: 'semantic',
    },
    {
      german: "wählen",
      translated: "votar",
      tone: 'semantic',
    },
  ],
  "lid:state:BW:4|fa": [
    {
      german: "Ab welchem Alter",
      translated: "از چه سنی",
      tone: 'semantic',
    },
    {
      german: "darf man",
      translated: "می‌توان",
      tone: 'semantic',
    },
    {
      german: "in Baden-Württemberg",
      translated: "در انتخابات محلی بادن-وورتمبرگ",
      tone: 'semantic',
    },
    {
      german: "wählen",
      translated: "رأی داد",
      tone: 'semantic',
    },
  ],
  "lid:state:BW:4|fr": [
    {
      german: "Ab welchem Alter",
      translated: "À partir de quel âge",
      tone: 'semantic',
    },
    {
      german: "darf man",
      translated: "peut-on",
      tone: 'semantic',
    },
    {
      german: "in Baden-Württemberg",
      translated: "en Bade-Wurtemberg",
      tone: 'semantic',
    },
    {
      german: "bei Kommunalwahlen",
      translated: "aux élections municipales",
      tone: 'semantic',
    },
    {
      german: "wählen",
      translated: "voter",
      tone: 'semantic',
    },
  ],
  "lid:state:BW:4|hr": [
    {
      german: "Ab welchem Alter",
      translated: "Od koje se dobi",
      tone: 'semantic',
    },
    {
      german: "darf man",
      translated: "može",
      tone: 'semantic',
    },
    {
      german: "in Baden-Württemberg",
      translated: "u saveznoj zemlji Baden-Württemberg",
      tone: 'semantic',
    },
    {
      german: "bei Kommunalwahlen",
      translated: "na lokalnim izborima",
      tone: 'semantic',
    },
    {
      german: "wählen",
      translated: "glasovati",
      tone: 'semantic',
    },
  ],
  "lid:state:BW:4|it": [
    {
      german: "Ab welchem Alter",
      translated: "Da quale età",
      tone: 'semantic',
    },
    {
      german: "darf man",
      translated: "si può",
      tone: 'semantic',
    },
    {
      german: "in Baden-Württemberg",
      translated: "in Baden-Württemberg",
      tone: 'semantic',
    },
    {
      german: "bei Kommunalwahlen",
      translated: "alle elezioni comunali",
      tone: 'semantic',
    },
    {
      german: "wählen",
      translated: "votare",
      tone: 'semantic',
    },
  ],
  "lid:state:BW:4|kmr": [
    {
      german: "Ab welchem Alter",
      translated: "Ji kîjan temenê",
      tone: 'semantic',
    },
    {
      german: "darf man",
      translated: "dikare",
      tone: 'semantic',
    },
    {
      german: "in Baden-Württemberg",
      translated: "li Baden-Württemberg",
      tone: 'semantic',
    },
    {
      german: "bei Kommunalwahlen",
      translated: "di hilbijartinên şaredariyê de",
      tone: 'semantic',
    },
    {
      german: "wählen",
      translated: "deng were dayîn?",
      tone: 'semantic',
    },
  ],
  "lid:state:BW:4|pl": [
    {
      german: "Ab welchem Alter",
      translated: "Od jakiego wieku",
      tone: 'semantic',
    },
    {
      german: "darf man",
      translated: "można",
      tone: 'semantic',
    },
    {
      german: "in Baden-Württemberg",
      translated: "w Badenia-Wirtembergia",
      tone: 'semantic',
    },
    {
      german: "bei Kommunalwahlen",
      translated: "w wyborach samorządowych",
      tone: 'semantic',
    },
    {
      german: "wählen",
      translated: "głosować",
      tone: 'semantic',
    },
  ],
  "lid:state:BW:4|prs": [
    {
      german: "Ab welchem Alter",
      translated: "از چه سنی",
      tone: 'semantic',
    },
    {
      german: "darf man",
      translated: "می‌توان",
      tone: 'semantic',
    },
    {
      german: "in Baden-Württemberg",
      translated: "بادن-وورتمبرگ",
      tone: 'semantic',
    },
    {
      german: "bei Kommunalwahlen",
      translated: "در انتخابات شاروالی",
      tone: 'semantic',
    },
    {
      german: "wählen",
      translated: "رأی داد",
      tone: 'semantic',
    },
  ],
  "lid:state:BW:4|ro": [
    {
      german: "Ab welchem Alter",
      translated: "De la ce vârstă",
      tone: 'semantic',
    },
    {
      german: "darf man",
      translated: "se poate",
      tone: 'semantic',
    },
    {
      german: "in Baden-Württemberg",
      translated: "din Baden-Württemberg",
      tone: 'semantic',
    },
    {
      german: "bei Kommunalwahlen",
      translated: "la alegerile locale",
      tone: 'semantic',
    },
    {
      german: "wählen",
      translated: "vota",
      tone: 'semantic',
    },
  ],
  "lid:state:BW:4|ru": [
    {
      german: "Ab welchem Alter",
      translated: "С какого возраста",
      tone: 'semantic',
    },
    {
      german: "darf man",
      translated: "можно",
      tone: 'semantic',
    },
    {
      german: "in Baden-Württemberg",
      translated: "в федеральной земле Баден-Вюртемберг",
      tone: 'semantic',
    },
    {
      german: "bei Kommunalwahlen",
      translated: "на муниципальных выборах",
      tone: 'semantic',
    },
    {
      german: "wählen",
      translated: "голосовать",
      tone: 'semantic',
    },
  ],
  "lid:state:BW:4|sq": [
    {
      german: "Ab welchem Alter",
      translated: "Nga cila",
      tone: 'semantic',
    },
    {
      german: "darf man",
      translated: "mund të",
      tone: 'semantic',
    },
    {
      german: "in Baden-Württemberg",
      translated: "në Baden-Württemberg",
      tone: 'semantic',
    },
    {
      german: "bei Kommunalwahlen",
      translated: "në zgjedhjet komunale",
      tone: 'semantic',
    },
    {
      german: "wählen",
      translated: "votohet",
      tone: 'semantic',
    },
  ],
  "lid:state:BW:4|sr": [
    {
      german: "Ab welchem Alter",
      translated: "Od koje",
      tone: 'semantic',
    },
    {
      german: "darf man",
      translated: "se",
      tone: 'semantic',
    },
    {
      german: "in Baden-Württemberg",
      translated: "u saveznoj pokrajini Baden-Virtemberg",
      tone: 'semantic',
    },
    {
      german: "bei Kommunalwahlen",
      translated: "na lokalnim izborima",
      tone: 'semantic',
    },
    {
      german: "wählen",
      translated: "glasati",
      tone: 'semantic',
    },
  ],
  "lid:state:BW:4|tr": [
    {
      german: "Ab welchem Alter",
      translated: "kaç yaşından itibaren",
      tone: 'semantic',
    },
    {
      german: "darf man",
      translated: "oy kullanılabilir",
      tone: 'semantic',
    },
    {
      german: "in Baden-Württemberg",
      translated: "Baden-Württemberg eyaletinde",
      tone: 'semantic',
    },
    {
      german: "bei Kommunalwahlen",
      translated: "yerel seçimlerde",
      tone: 'semantic',
    },
  ],
  "lid:state:BW:4|uk": [
    {
      german: "Ab welchem Alter",
      translated: "З якого віку",
      tone: 'semantic',
    },
    {
      german: "in Baden-Württemberg",
      translated: "в Баден-Вюртемберг",
      tone: 'semantic',
    },
    {
      german: "bei Kommunalwahlen",
      translated: "на муніципальних виборах",
      tone: 'semantic',
    },
    {
      german: "wählen",
      translated: "можна голосувати",
      tone: 'semantic',
    },
  ],
  "lid:state:BW:4|vi": [
    {
      german: "Ab welchem Alter",
      translated: "Từ bao nhiêu tuổi",
      tone: 'semantic',
    },
    {
      german: "darf man",
      translated: "có thể",
      tone: 'semantic',
    },
    {
      german: "in Baden-Württemberg",
      translated: "địa phương ở bang Baden-Württemberg",
      tone: 'semantic',
    },
    {
      german: "bei Kommunalwahlen",
      translated: "trong bầu cử",
      tone: 'semantic',
    },
    {
      german: "wählen",
      translated: "bỏ phiếu",
      tone: 'semantic',
    },
  ],
  "lid:state:BW:5|ar": [
    {
      german: "Welche Farben",
      translated: "ما",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "ألوان",
      tone: 'semantic',
    },
    {
      german: "die Landesflagge",
      translated: "علم",
      tone: 'semantic',
    },
    {
      german: "von Baden-Württemberg",
      translated: "ولاية Baden-Württemberg",
      tone: 'semantic',
    },
  ],
  "lid:state:BW:5|bg": [
    {
      german: "Welche Farben",
      translated: "Какви са цветовете",
      tone: 'semantic',
    },
    {
      german: "die Landesflagge",
      translated: "знамето",
      tone: 'semantic',
    },
    {
      german: "von Baden-Württemberg",
      translated: "на провинция Баден-Вюртемберг",
      tone: 'semantic',
    },
  ],
  "lid:state:BW:5|bs": [
    {
      german: "Welche Farben",
      translated: "Koje su boje",
      tone: 'semantic',
    },
    {
      german: "die Landesflagge",
      translated: "zastave",
      tone: 'semantic',
    },
    {
      german: "von Baden-Württemberg",
      translated: "savezne zemlje Baden-Württemberg",
      tone: 'semantic',
    },
  ],
  "lid:state:BW:5|el": [
    {
      german: "Welche Farben",
      translated: "Ποια είναι τα χρώματα",
      tone: 'semantic',
    },
    {
      german: "die Landesflagge",
      translated: "της σημαίας του κρατιδίου",
      tone: 'semantic',
    },
    {
      german: "von Baden-Württemberg",
      translated: "Βάδη-Βυρτεμβέργη;",
      tone: 'semantic',
    },
  ],
  "lid:state:BW:5|en": [
    {
      german: "Welche Farben",
      translated: "What colors",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "does",
      tone: 'semantic',
    },
    {
      german: "die Landesflagge",
      translated: "the state flag",
      tone: 'semantic',
    },
    {
      german: "von Baden-Württemberg",
      translated: "of Baden-Württemberg",
      tone: 'semantic',
    },
  ],
  "lid:state:BW:5|es": [
    {
      german: "Welche Farben",
      translated: "¿Qué colores",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "tiene",
      tone: 'semantic',
    },
    {
      german: "die Landesflagge",
      translated: "la bandera regional",
      tone: 'semantic',
    },
    {
      german: "von Baden-Württemberg",
      translated: "de Baden-Wurtemberg",
      tone: 'semantic',
    },
  ],
  "lid:state:BW:5|fa": [
    {
      german: "Welche Farben",
      translated: "رنگ‌های",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "کدام‌اند",
      tone: 'semantic',
    },
    {
      german: "die Landesflagge",
      translated: "پرچم ایالت",
      tone: 'semantic',
    },
    {
      german: "von Baden-Württemberg",
      translated: "بادن-وورتمبرگ",
      tone: 'semantic',
    },
  ],
  "lid:state:BW:5|fr": [
    {
      german: "Welche Farben",
      translated: "Quelles sont les couleurs",
      tone: 'semantic',
    },
    {
      german: "die Landesflagge",
      translated: "du drapeau du Land",
      tone: 'semantic',
    },
    {
      german: "von Baden-Württemberg",
      translated: "de Bade-Wurtemberg",
      tone: 'semantic',
    },
  ],
  "lid:state:BW:5|hr": [
    {
      german: "Welche Farben",
      translated: "Koje su boje",
      tone: 'semantic',
    },
    {
      german: "die Landesflagge",
      translated: "zastave",
      tone: 'semantic',
    },
    {
      german: "von Baden-Württemberg",
      translated: "savezne zemlje Baden-Württemberg",
      tone: 'semantic',
    },
  ],
  "lid:state:BW:5|it": [
    {
      german: "Welche Farben",
      translated: "Quali sono i colori",
      tone: 'semantic',
    },
    {
      german: "die Landesflagge",
      translated: "della bandiera del Land",
      tone: 'semantic',
    },
    {
      german: "von Baden-Württemberg",
      translated: "di Baden-Württemberg",
      tone: 'semantic',
    },
  ],
  "lid:state:BW:5|kmr": [
    {
      german: "Welche Farben",
      translated: "Rengên",
      tone: 'semantic',
    },
    {
      german: "die Landesflagge",
      translated: "ala eyaleta",
      tone: 'semantic',
    },
    {
      german: "von Baden-Württemberg",
      translated: "Baden-Württemberg",
      tone: 'semantic',
    },
  ],
  "lid:state:BW:5|pl": [
    {
      german: "Welche Farben",
      translated: "Jakie są kolory",
      tone: 'semantic',
    },
    {
      german: "die Landesflagge",
      translated: "flagi kraju związkowego",
      tone: 'semantic',
    },
    {
      german: "von Baden-Württemberg",
      translated: "Badenia-Wirtembergia",
      tone: 'semantic',
    },
  ],
  "lid:state:BW:5|prs": [
    {
      german: "Welche Farben",
      translated: "رنگ‌های",
      tone: 'semantic',
    },
    {
      german: "die Landesflagge",
      translated: "پرچم ایالت",
      tone: 'semantic',
    },
    {
      german: "von Baden-Württemberg",
      translated: "بادن-وورتمبرگ",
      tone: 'semantic',
    },
  ],
  "lid:state:BW:5|ro": [
    {
      german: "Welche Farben",
      translated: "Care sunt culorile",
      tone: 'semantic',
    },
    {
      german: "die Landesflagge",
      translated: "drapelului",
      tone: 'semantic',
    },
    {
      german: "von Baden-Württemberg",
      translated: "landului Baden-Württemberg",
      tone: 'semantic',
    },
  ],
  "lid:state:BW:5|ru": [
    {
      german: "Welche Farben",
      translated: "Какие цвета",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "у",
      tone: 'semantic',
    },
    {
      german: "die Landesflagge",
      translated: "флага земли",
      tone: 'semantic',
    },
    {
      german: "von Baden-Württemberg",
      translated: "Баден-Вюртемберг",
      tone: 'semantic',
    },
  ],
  "lid:state:BW:5|sq": [
    {
      german: "Welche Farben",
      translated: "Cilat janë ngjyrat",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "e",
      tone: 'semantic',
    },
    {
      german: "die Landesflagge",
      translated: "flamurit të landit",
      tone: 'semantic',
    },
    {
      german: "von Baden-Württemberg",
      translated: "Baden-Württemberg",
      tone: 'semantic',
    },
  ],
  "lid:state:BW:5|sr": [
    {
      german: "Welche Farben",
      translated: "Koje su",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "boje",
      tone: 'semantic',
    },
    {
      german: "die Landesflagge",
      translated: "zastave",
      tone: 'semantic',
    },
    {
      german: "von Baden-Württemberg",
      translated: "savezne pokrajine Baden-Virtemberg",
      tone: 'semantic',
    },
  ],
  "lid:state:BW:5|tr": [
    {
      german: "Welche Farben",
      translated: "renkleri nelerdir",
      tone: 'semantic',
    },
    {
      german: "die Landesflagge",
      translated: "eyalet bayrağının",
      tone: 'semantic',
    },
    {
      german: "von Baden-Württemberg",
      translated: "Baden-Württemberg",
      tone: 'semantic',
    },
  ],
  "lid:state:BW:5|uk": [
    {
      german: "Welche Farben",
      translated: "Які кольори",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "має",
      tone: 'semantic',
    },
    {
      german: "die Landesflagge",
      translated: "прапор",
      tone: 'semantic',
    },
    {
      german: "von Baden-Württemberg",
      translated: "федеральної землі Баден-Вюртемберг",
      tone: 'semantic',
    },
  ],
  "lid:state:BW:5|vi": [
    {
      german: "Welche Farben",
      translated: "Màu",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "là",
      tone: 'semantic',
    },
    {
      german: "die Landesflagge",
      translated: "cờ bang",
      tone: 'semantic',
    },
    {
      german: "von Baden-Württemberg",
      translated: "Baden-Württemberg",
      tone: 'semantic',
    },
  ],
  "lid:state:BW:6|ar": [
    {
      german: "Wo",
      translated: "أين",
      tone: 'semantic',
    },
    {
      german: "können",
      translated: "يمكنك",
      tone: 'semantic',
    },
    {
      german: "Baden-Württemberg",
      translated: "Baden-Württemberg",
      tone: 'semantic',
    },
    {
      german: "über politische Themen",
      translated: "عن القضايا السياسية",
      tone: 'semantic',
    },
    {
      german: "informieren",
      translated: "الحصول على معلومات",
      tone: 'semantic',
    },
  ],
  "lid:state:BW:6|bg": [
    {
      german: "Wo",
      translated: "Къде",
      tone: 'semantic',
    },
    {
      german: "können",
      translated: "можете",
      tone: 'semantic',
    },
    {
      german: "sich",
      translated: "в",
      tone: 'semantic',
    },
    {
      german: "Baden-Württemberg",
      translated: "Баден-Вюртемберг",
      tone: 'semantic',
    },
    {
      german: "über politische Themen",
      translated: "по политически теми",
      tone: 'semantic',
    },
    {
      german: "informieren",
      translated: "да получите информация",
      tone: 'semantic',
    },
  ],
  "lid:state:BW:6|bs": [
    {
      german: "Wo",
      translated: "Gdje",
      tone: 'semantic',
    },
    {
      german: "können",
      translated: "mogu",
      tone: 'semantic',
    },
    {
      german: "sich",
      translated: "se",
      tone: 'semantic',
    },
    {
      german: "Baden-Württemberg",
      translated: "Baden-Württemberg",
      tone: 'semantic',
    },
    {
      german: "über politische Themen",
      translated: "o političkim temama",
      tone: 'semantic',
    },
    {
      german: "informieren",
      translated: "dobiti informacije",
      tone: 'semantic',
    },
  ],
  "lid:state:BW:6|el": [
    {
      german: "Wo",
      translated: "Πού",
      tone: 'semantic',
    },
    {
      german: "können",
      translated: "μπορείτε",
      tone: 'semantic',
    },
    {
      german: "sich",
      translated: "να",
      tone: 'semantic',
    },
    {
      german: "Baden-Württemberg",
      translated: "Βάδη-Βυρτεμβέργη",
      tone: 'semantic',
    },
    {
      german: "über politische Themen",
      translated: "για πολιτικά θέματα",
      tone: 'semantic',
    },
    {
      german: "informieren",
      translated: "ενημερωθείτε",
      tone: 'semantic',
    },
  ],
  "lid:state:BW:6|en": [
    {
      german: "Wo",
      translated: "Where",
      tone: 'semantic',
    },
    {
      german: "können",
      translated: "can",
      tone: 'semantic',
    },
    {
      german: "sich",
      translated: "you",
      tone: 'semantic',
    },
    {
      german: "Baden-Württemberg",
      translated: "Baden-Württemberg",
      tone: 'semantic',
    },
    {
      german: "über politische Themen",
      translated: "about political topics",
      tone: 'semantic',
    },
    {
      german: "informieren",
      translated: "get information",
      tone: 'semantic',
    },
  ],
  "lid:state:BW:6|es": [
    {
      german: "Wo",
      translated: "¿Dónde",
      tone: 'semantic',
    },
    {
      german: "können",
      translated: "puede",
      tone: 'semantic',
    },
    {
      german: "Baden-Württemberg",
      translated: "Baden-Wurtemberg",
      tone: 'semantic',
    },
    {
      german: "über politische Themen",
      translated: "sobre temas políticos",
      tone: 'semantic',
    },
    {
      german: "informieren",
      translated: "informarse",
      tone: 'semantic',
    },
  ],
  "lid:state:BW:6|fa": [
    {
      german: "Wo",
      translated: "کجا",
      tone: 'semantic',
    },
    {
      german: "können",
      translated: "می‌توانید",
      tone: 'semantic',
    },
    {
      german: "Baden-Württemberg",
      translated: "بادن-وورتمبرگ",
      tone: 'semantic',
    },
    {
      german: "über politische Themen",
      translated: "دربارهٔ موضوعات سیاسی",
      tone: 'semantic',
    },
    {
      german: "informieren",
      translated: "اطلاعات کسب کنید",
      tone: 'semantic',
    },
  ],
  "lid:state:BW:6|fr": [
    {
      german: "Wo",
      translated: "Où",
      tone: 'semantic',
    },
    {
      german: "können",
      translated: "pouvez-vous",
      tone: 'semantic',
    },
    {
      german: "sich",
      translated: "vous",
      tone: 'semantic',
    },
    {
      german: "Baden-Württemberg",
      translated: "Bade-Wurtemberg",
      tone: 'semantic',
    },
    {
      german: "über politische Themen",
      translated: "sur les questions politiques",
      tone: 'semantic',
    },
    {
      german: "informieren",
      translated: "informer",
      tone: 'semantic',
    },
  ],
  "lid:state:BW:6|hr": [
    {
      german: "Wo",
      translated: "Gdje",
      tone: 'semantic',
    },
    {
      german: "können",
      translated: "mogu",
      tone: 'semantic',
    },
    {
      german: "sich",
      translated: "se",
      tone: 'semantic',
    },
    {
      german: "Baden-Württemberg",
      translated: "Baden-Württemberg",
      tone: 'semantic',
    },
    {
      german: "über politische Themen",
      translated: "o političkim temama",
      tone: 'semantic',
    },
    {
      german: "informieren",
      translated: "dobiti informacije",
      tone: 'semantic',
    },
  ],
  "lid:state:BW:6|it": [
    {
      german: "Wo",
      translated: "Dove",
      tone: 'semantic',
    },
    {
      german: "können",
      translated: "può",
      tone: 'semantic',
    },
    {
      german: "sich",
      translated: "ci si",
      tone: 'semantic',
    },
    {
      german: "Baden-Württemberg",
      translated: "Baden-Württemberg",
      tone: 'semantic',
    },
    {
      german: "über politische Themen",
      translated: "su temi politici",
      tone: 'semantic',
    },
    {
      german: "informieren",
      translated: "informare",
      tone: 'semantic',
    },
  ],
  "lid:state:BW:6|kmr": [
    {
      german: "Wo",
      translated: "Li",
      tone: 'semantic',
    },
    {
      german: "können",
      translated: "li",
      tone: 'semantic',
    },
    {
      german: "sich",
      translated: "ku",
      tone: 'semantic',
    },
    {
      german: "Baden-Württemberg",
      translated: "Baden-Württemberg",
      tone: 'semantic',
    },
    {
      german: "über politische Themen",
      translated: "li ser mijarên siyasî",
      tone: 'semantic',
    },
    {
      german: "informieren",
      translated: "agahdarî bistînî",
      tone: 'semantic',
    },
  ],
  "lid:state:BW:6|pl": [
    {
      german: "Wo",
      translated: "Gdzie",
      tone: 'semantic',
    },
    {
      german: "können",
      translated: "można",
      tone: 'semantic',
    },
    {
      german: "Baden-Württemberg",
      translated: "Badenia-Wirtembergia",
      tone: 'semantic',
    },
    {
      german: "über politische Themen",
      translated: "na tematy polityczne",
      tone: 'semantic',
    },
    {
      german: "informieren",
      translated: "uzyskać informacje",
      tone: 'semantic',
    },
  ],
  "lid:state:BW:6|prs": [
    {
      german: "Wo",
      translated: "کجا",
      tone: 'semantic',
    },
    {
      german: "können",
      translated: "می‌توانید",
      tone: 'semantic',
    },
    {
      german: "Baden-Württemberg",
      translated: "بادن-وورتمبرگ",
      tone: 'semantic',
    },
    {
      german: "über politische Themen",
      translated: " دربارهٔ موضوعات سیاسی",
      tone: 'semantic',
    },
    {
      german: "informieren",
      translated: "اطلاعات کسب کنید",
      tone: 'semantic',
    },
  ],
  "lid:state:BW:6|ro": [
    {
      german: "Wo",
      translated: "Unde",
      tone: 'semantic',
    },
    {
      german: "können",
      translated: "puteți",
      tone: 'semantic',
    },
    {
      german: "sich",
      translated: "vă",
      tone: 'semantic',
    },
    {
      german: "Baden-Württemberg",
      translated: "Baden-Württemberg",
      tone: 'semantic',
    },
    {
      german: "über politische Themen",
      translated: "despre teme politice",
      tone: 'semantic',
    },
    {
      german: "informieren",
      translated: "informa",
      tone: 'semantic',
    },
  ],
  "lid:state:BW:6|ru": [
    {
      german: "Wo",
      translated: "Где",
      tone: 'semantic',
    },
    {
      german: "können",
      translated: "можно",
      tone: 'semantic',
    },
    {
      german: "Baden-Württemberg",
      translated: "Баден-Вюртемберг",
      tone: 'semantic',
    },
    {
      german: "über politische Themen",
      translated: "о политических темах",
      tone: 'semantic',
    },
    {
      german: "informieren",
      translated: "получить информацию",
      tone: 'semantic',
    },
  ],
  "lid:state:BW:6|sq": [
    {
      german: "Wo",
      translated: "Ku",
      tone: 'semantic',
    },
    {
      german: "können",
      translated: "të",
      tone: 'semantic',
    },
    {
      german: "Baden-Württemberg",
      translated: "Baden-Württemberg",
      tone: 'semantic',
    },
    {
      german: "über politische Themen",
      translated: "për tema politike",
      tone: 'semantic',
    },
    {
      german: "informieren",
      translated: "informoheni",
      tone: 'semantic',
    },
  ],
  "lid:state:BW:6|sr": [
    {
      german: "Wo",
      translated: "Gdje",
      tone: 'semantic',
    },
    {
      german: "können",
      translated: "mogu",
      tone: 'semantic',
    },
    {
      german: "sich",
      translated: "se",
      tone: 'semantic',
    },
    {
      german: "Baden-Württemberg",
      translated: "u saveznoj pokrajini Baden-Virtemberg",
      tone: 'semantic',
    },
    {
      german: "über politische Themen",
      translated: "o političkim temama",
      tone: 'semantic',
    },
    {
      german: "informieren",
      translated: "dobiti informacije",
      tone: 'semantic',
    },
  ],
  "lid:state:BW:6|tr": [
    {
      german: "Wo",
      translated: "nereden",
      tone: 'semantic',
    },
    {
      german: "können",
      translated: "alabilirsiniz",
      tone: 'semantic',
    },
    {
      german: "Baden-Württemberg",
      translated: "Baden-Württemberg eyaletinde",
      tone: 'semantic',
    },
    {
      german: "über politische Themen",
      translated: "siyasi konular hakkında",
      tone: 'semantic',
    },
    {
      german: "informieren",
      translated: "bilgi",
      tone: 'semantic',
    },
  ],
  "lid:state:BW:6|uk": [
    {
      german: "Wo",
      translated: "Де",
      tone: 'semantic',
    },
    {
      german: "können",
      translated: "можна",
      tone: 'semantic',
    },
    {
      german: "sich",
      translated: "в",
      tone: 'semantic',
    },
    {
      german: "Baden-Württemberg",
      translated: "Баден-Вюртемберг",
      tone: 'semantic',
    },
    {
      german: "über politische Themen",
      translated: "про політичні питання",
      tone: 'semantic',
    },
    {
      german: "informieren",
      translated: "отримати інформацію",
      tone: 'semantic',
    },
  ],
  "lid:state:BW:6|vi": [
    {
      german: "Wo",
      translated: "ở đâu",
      tone: 'semantic',
    },
    {
      german: "können",
      translated: "có thể",
      tone: 'semantic',
    },
    {
      german: "Baden-Württemberg",
      translated: "Baden-Württemberg",
      tone: 'semantic',
    },
    {
      german: "über politische Themen",
      translated: "về các chủ đề chính trị",
      tone: 'semantic',
    },
    {
      german: "informieren",
      translated: "tìm thông tin",
      tone: 'semantic',
    },
  ],
  "lid:state:BW:7|ar": [
    {
      german: "Die Landeshauptstadt",
      translated: "عاصمة",
      tone: 'semantic',
    },
    {
      german: "von Baden-Württemberg",
      translated: "ولاية Baden-Württemberg",
      tone: 'semantic',
    },
  ],
  "lid:state:BW:7|bg": [
    {
      german: "Die Landeshauptstadt",
      translated: "Столицата",
      tone: 'semantic',
    },
    {
      german: "von Baden-Württemberg",
      translated: "на федералната провинция Баден-Вюртемберг",
      tone: 'semantic',
    },
    {
      german: "heißt",
      translated: "е",
      tone: 'semantic',
    },
  ],
  "lid:state:BW:7|bs": [
    {
      german: "Die Landeshauptstadt",
      translated: "Glavni grad",
      tone: 'semantic',
    },
    {
      german: "von Baden-Württemberg",
      translated: "savezne zemlje Baden-Württemberg",
      tone: 'semantic',
    },
    {
      german: "heißt",
      translated: "je",
      tone: 'semantic',
    },
  ],
  "lid:state:BW:7|el": [
    {
      german: "Die Landeshauptstadt",
      translated: "Η πρωτεύουσα",
      tone: 'semantic',
    },
    {
      german: "von Baden-Württemberg",
      translated: "του ομόσπονδου κρατιδίου Βάδη-Βυρτεμβέργη",
      tone: 'semantic',
    },
    {
      german: "heißt",
      translated: "είναι",
      tone: 'semantic',
    },
  ],
  "lid:state:BW:7|en": [
    {
      german: "Die Landeshauptstadt",
      translated: "The state capital",
      tone: 'semantic',
    },
    {
      german: "von Baden-Württemberg",
      translated: "of Baden-Württemberg",
      tone: 'semantic',
    },
    {
      german: "heißt",
      translated: "is called",
      tone: 'semantic',
    },
  ],
  "lid:state:BW:7|es": [
    {
      german: "Die Landeshauptstadt",
      translated: "La capital",
      tone: 'semantic',
    },
    {
      german: "von Baden-Württemberg",
      translated: "del estado federado de Baden-Wurtemberg",
      tone: 'semantic',
    },
    {
      german: "heißt",
      translated: "es",
      tone: 'semantic',
    },
  ],
  "lid:state:BW:7|fa": [
    {
      german: "Die Landeshauptstadt",
      translated: "مرکز ایالت",
      tone: 'semantic',
    },
    {
      german: "von Baden-Württemberg",
      translated: "بادن-وورتمبرگ",
      tone: 'semantic',
    },
  ],
  "lid:state:BW:7|fr": [
    {
      german: "Die Landeshauptstadt",
      translated: "La capitale du Land",
      tone: 'semantic',
    },
    {
      german: "von Baden-Württemberg",
      translated: "de Bade-Wurtemberg",
      tone: 'semantic',
    },
    {
      german: "heißt",
      translated: "s’appelle …",
      tone: 'semantic',
    },
  ],
  "lid:state:BW:7|hr": [
    {
      german: "Die Landeshauptstadt",
      translated: "Glavni grad",
      tone: 'semantic',
    },
    {
      german: "von Baden-Württemberg",
      translated: "savezne zemlje Baden-Württemberg",
      tone: 'semantic',
    },
    {
      german: "heißt",
      translated: "je",
      tone: 'semantic',
    },
  ],
  "lid:state:BW:7|it": [
    {
      german: "Die Landeshauptstadt",
      translated: "La capitale del Land",
      tone: 'semantic',
    },
    {
      german: "von Baden-Württemberg",
      translated: "di Baden-Württemberg",
      tone: 'semantic',
    },
    {
      german: "heißt",
      translated: "è",
      tone: 'semantic',
    },
  ],
  "lid:state:BW:7|kmr": [
    {
      german: "Die Landeshauptstadt",
      translated: "Paytexta eyaleta",
      tone: 'semantic',
    },
    {
      german: "von Baden-Württemberg",
      translated: "Baden-Württemberg",
      tone: 'semantic',
    },
    {
      german: "heißt",
      translated: "e.",
      tone: 'semantic',
    },
  ],
  "lid:state:BW:7|pl": [
    {
      german: "Die Landeshauptstadt",
      translated: "Stolicą",
      tone: 'semantic',
    },
    {
      german: "von Baden-Württemberg",
      translated: "kraju związkowego Badenia-Wirtembergia",
      tone: 'semantic',
    },
    {
      german: "heißt",
      translated: "jest",
      tone: 'semantic',
    },
  ],
  "lid:state:BW:7|prs": [
    {
      german: "Die Landeshauptstadt",
      translated: "مرکز ایالت",
      tone: 'semantic',
    },
    {
      german: "von Baden-Württemberg",
      translated: "بادن-وورتمبرگ",
      tone: 'semantic',
    },
    {
      german: "heißt",
      translated: "است",
      tone: 'semantic',
    },
  ],
  "lid:state:BW:7|ro": [
    {
      german: "Die Landeshauptstadt",
      translated: "Capitala",
      tone: 'semantic',
    },
    {
      german: "von Baden-Württemberg",
      translated: "landului Baden-Württemberg",
      tone: 'semantic',
    },
    {
      german: "heißt",
      translated: "este",
      tone: 'semantic',
    },
  ],
  "lid:state:BW:7|ru": [
    {
      german: "Die Landeshauptstadt",
      translated: "Столица земли",
      tone: 'semantic',
    },
    {
      german: "von Baden-Württemberg",
      translated: "Баден-Вюртемберг",
      tone: 'semantic',
    },
    {
      german: "heißt",
      translated: "называется",
      tone: 'semantic',
    },
  ],
  "lid:state:BW:7|sq": [
    {
      german: "Die Landeshauptstadt",
      translated: "Kryeqyteti i landit",
      tone: 'semantic',
    },
    {
      german: "von Baden-Württemberg",
      translated: "Baden-Württemberg",
      tone: 'semantic',
    },
    {
      german: "heißt",
      translated: "është",
      tone: 'semantic',
    },
  ],
  "lid:state:BW:7|sr": [
    {
      german: "Die Landeshauptstadt",
      translated: "Glavni grad",
      tone: 'semantic',
    },
    {
      german: "von Baden-Württemberg",
      translated: "savezne pokrajine Baden-Virtemberg",
      tone: 'semantic',
    },
    {
      german: "heißt",
      translated: "je",
      tone: 'semantic',
    },
  ],
  "lid:state:BW:7|tr": [
    {
      german: "Die Landeshauptstadt",
      translated: "başkenti",
      tone: 'semantic',
    },
    {
      german: "von Baden-Württemberg",
      translated: "Baden-Württemberg eyaletinin",
      tone: 'semantic',
    },
  ],
  "lid:state:BW:7|uk": [
    {
      german: "Die Landeshauptstadt",
      translated: "Столиця",
      tone: 'semantic',
    },
    {
      german: "von Baden-Württemberg",
      translated: "федеральної землі Баден-Вюртемберг",
      tone: 'semantic',
    },
    {
      german: "heißt",
      translated: "називається",
      tone: 'semantic',
    },
  ],
  "lid:state:BW:7|vi": [
    {
      german: "Die Landeshauptstadt",
      translated: "Thủ phủ",
      tone: 'semantic',
    },
    {
      german: "von Baden-Württemberg",
      translated: "của bang Baden-Württemberg",
      tone: 'semantic',
    },
    {
      german: "heißt",
      translated: "là",
      tone: 'semantic',
    },
  ],
  "lid:state:BW:8|ar": [
    {
      german: "Welches",
      translated: "أي",
      tone: 'semantic',
    },
    {
      german: "Bundesland",
      translated: "ولاية",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "تمثل",
      tone: 'semantic',
    },
    {
      german: "Baden-Württemberg",
      translated: "Baden-Württemberg",
      tone: 'semantic',
    },
  ],
  "lid:state:BW:8|bg": [
    {
      german: "Welches",
      translated: "Коя",
      tone: 'semantic',
    },
    {
      german: "Bundesland",
      translated: "федерални провинции",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "е",
      tone: 'semantic',
    },
    {
      german: "Baden-Württemberg",
      translated: "Баден-Вюртемберг",
      tone: 'semantic',
    },
  ],
  "lid:state:BW:8|bs": [
    {
      german: "Welches",
      translated: "Koja",
      tone: 'semantic',
    },
    {
      german: "Bundesland",
      translated: "od prikazanih saveznih zemalja",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "je",
      tone: 'semantic',
    },
    {
      german: "Baden-Württemberg",
      translated: "Baden-Württemberg",
      tone: 'semantic',
    },
  ],
  "lid:state:BW:8|el": [
    {
      german: "Welches",
      translated: "Ποιο",
      tone: 'semantic',
    },
    {
      german: "Bundesland",
      translated: "κρατίδια",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "είναι",
      tone: 'semantic',
    },
    {
      german: "Baden-Württemberg",
      translated: "Βάδη-Βυρτεμβέργη",
      tone: 'semantic',
    },
  ],
  "lid:state:BW:8|en": [
    {
      german: "Welches",
      translated: "Which",
      tone: 'semantic',
    },
    {
      german: "Bundesland",
      translated: "federal state",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "is",
      tone: 'semantic',
    },
    {
      german: "Baden-Württemberg",
      translated: "Baden-Württemberg",
      tone: 'semantic',
    },
  ],
  "lid:state:BW:8|es": [
    {
      german: "Welches",
      translated: "¿Cuál",
      tone: 'semantic',
    },
    {
      german: "Bundesland",
      translated: "estado federado",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "corresponde al",
      tone: 'semantic',
    },
    {
      german: "Baden-Württemberg",
      translated: "Baden-Wurtemberg",
      tone: 'semantic',
    },
  ],
  "lid:state:BW:8|fa": [
    {
      german: "Welches",
      translated: "کدام",
      tone: 'semantic',
    },
    {
      german: "Bundesland",
      translated: "ایالتِ نشان‌داده‌شده",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "است",
      tone: 'semantic',
    },
    {
      german: "Baden-Württemberg",
      translated: "بادن-وورتمبرگ",
      tone: 'semantic',
    },
  ],
  "lid:state:BW:8|fr": [
    {
      german: "Welches",
      translated: "Quel",
      tone: 'semantic',
    },
    {
      german: "Bundesland",
      translated: "Land",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "est",
      tone: 'semantic',
    },
    {
      german: "Baden-Württemberg",
      translated: "Bade-Wurtemberg",
      tone: 'semantic',
    },
  ],
  "lid:state:BW:8|hr": [
    {
      german: "Welches",
      translated: "Koja",
      tone: 'semantic',
    },
    {
      german: "Bundesland",
      translated: "saveznih zemalja",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "je",
      tone: 'semantic',
    },
    {
      german: "Baden-Württemberg",
      translated: "Baden-Württemberg",
      tone: 'semantic',
    },
  ],
  "lid:state:BW:8|it": [
    {
      german: "Welches",
      translated: "Quale",
      tone: 'semantic',
    },
    {
      german: "Bundesland",
      translated: "Land rappresentato",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "è",
      tone: 'semantic',
    },
    {
      german: "Baden-Württemberg",
      translated: "Baden-Württemberg",
      tone: 'semantic',
    },
  ],
  "lid:state:BW:8|kmr": [
    {
      german: "Welches",
      translated: "Kîjan",
      tone: 'semantic',
    },
    {
      german: "Bundesland",
      translated: "eyalet",
      tone: 'semantic',
    },
    {
      german: "Baden-Württemberg",
      translated: "Baden-Württemberg",
      tone: 'semantic',
    },
  ],
  "lid:state:BW:8|pl": [
    {
      german: "Welches",
      translated: "Który",
      tone: 'semantic',
    },
    {
      german: "Bundesland",
      translated: "z przedstawionych krajów związkowych",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "to",
      tone: 'semantic',
    },
    {
      german: "Baden-Württemberg",
      translated: "Badenia-Wirtembergia",
      tone: 'semantic',
    },
  ],
  "lid:state:BW:8|prs": [
    {
      german: "Welches",
      translated: "کدام",
      tone: 'semantic',
    },
    {
      german: "Bundesland",
      translated: "ایالتِ نشان‌داده‌شده",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "است",
      tone: 'semantic',
    },
    {
      german: "Baden-Württemberg",
      translated: "بادن-وورتمبرگ",
      tone: 'semantic',
    },
  ],
  "lid:state:BW:8|ro": [
    {
      german: "Welches",
      translated: "Care",
      tone: 'semantic',
    },
    {
      german: "Bundesland",
      translated: "land",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "reprezentat",
      tone: 'semantic',
    },
    {
      german: "Baden-Württemberg",
      translated: "Baden-Württemberg",
      tone: 'semantic',
    },
  ],
  "lid:state:BW:8|ru": [
    {
      german: "Welches",
      translated: "Какая",
      tone: 'semantic',
    },
    {
      german: "Bundesland",
      translated: "земель",
      tone: 'semantic',
    },
    {
      german: "Baden-Württemberg",
      translated: "Баден-Вюртемберг",
      tone: 'semantic',
    },
  ],
  "lid:state:BW:8|sq": [
    {
      german: "Welches",
      translated: "Cili",
      tone: 'semantic',
    },
    {
      german: "Bundesland",
      translated: "nga",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "është",
      tone: 'semantic',
    },
    {
      german: "Baden-Württemberg",
      translated: "Baden-Württemberg",
      tone: 'semantic',
    },
  ],
  "lid:state:BW:8|sr": [
    {
      german: "Welches",
      translated: "Koja",
      tone: 'semantic',
    },
    {
      german: "Bundesland",
      translated: "saveznih pokrajina",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "je",
      tone: 'semantic',
    },
    {
      german: "Baden-Württemberg",
      translated: "Baden-Virtemberg",
      tone: 'semantic',
    },
  ],
  "lid:state:BW:8|tr": [
    {
      german: "Welches",
      translated: "hangi numarayla",
      tone: 'semantic',
    },
    {
      german: "Bundesland",
      translated: "eyaleti",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "gösterilmiştir",
      tone: 'semantic',
    },
    {
      german: "Baden-Württemberg",
      translated: "Baden-Württemberg",
      tone: 'semantic',
    },
  ],
  "lid:state:BW:8|uk": [
    {
      german: "Welches",
      translated: "Яка",
      tone: 'semantic',
    },
    {
      german: "Bundesland",
      translated: "федеральних земель",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "є",
      tone: 'semantic',
    },
    {
      german: "Baden-Württemberg",
      translated: "Баден-Вюртемберг",
      tone: 'semantic',
    },
  ],
  "lid:state:BW:8|vi": [
    {
      german: "Welches",
      translated: "Bang nào",
      tone: 'semantic',
    },
    {
      german: "Bundesland",
      translated: "trong các hình",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "được",
      tone: 'semantic',
    },
    {
      german: "Baden-Württemberg",
      translated: "Baden-Württemberg",
      tone: 'semantic',
    },
  ],
  "lid:state:BW:9|ar": [
    {
      german: "Wie nennt man",
      translated: "ماذا",
      tone: 'semantic',
    },
    {
      german: "die Regierungschefin/den Regierungschef",
      translated: "رئيس/رئيسة",
      tone: 'semantic',
    },
    {
      german: "in Baden-Württemberg",
      translated: "ولاية Baden-Württemberg",
      tone: 'semantic',
    },
  ],
  "lid:state:BW:9|bg": [
    {
      german: "Wie nennt man",
      translated: "Как се нарича",
      tone: 'semantic',
    },
    {
      german: "die Regierungschefin/den Regierungschef",
      translated: "ръководителят на правителството",
      tone: 'semantic',
    },
    {
      german: "in Baden-Württemberg",
      translated: "на провинция Баден-Вюртемберг",
      tone: 'semantic',
    },
  ],
  "lid:state:BW:9|bs": [
    {
      german: "Wie nennt man",
      translated: "Kako",
      tone: 'semantic',
    },
    {
      german: "die Regierungschefin/den Regierungschef",
      translated: "šef vlade",
      tone: 'semantic',
    },
    {
      german: "in Baden-Württemberg",
      translated: "savezne zemlje Baden-Württemberg",
      tone: 'semantic',
    },
  ],
  "lid:state:BW:9|el": [
    {
      german: "Wie nennt man",
      translated: "Πώς ονομάζεται",
      tone: 'semantic',
    },
    {
      german: "die Regierungschefin/den Regierungschef",
      translated: "ο επικεφαλής της κυβέρνησης",
      tone: 'semantic',
    },
    {
      german: "in Baden-Württemberg",
      translated: "του κρατιδίου Βάδη-Βυρτεμβέργη",
      tone: 'semantic',
    },
  ],
  "lid:state:BW:9|en": [
    {
      german: "Wie nennt man",
      translated: "What is",
      tone: 'semantic',
    },
    {
      german: "die Regierungschefin/den Regierungschef",
      translated: "the head of government",
      tone: 'semantic',
    },
    {
      german: "in Baden-Württemberg",
      translated: "in Baden-Württemberg",
      tone: 'semantic',
    },
  ],
  "lid:state:BW:9|es": [
    {
      german: "Wie nennt man",
      translated: "¿Cómo se llama",
      tone: 'semantic',
    },
    {
      german: "die Regierungschefin/den Regierungschef",
      translated: "al jefe o la jefa de gobierno",
      tone: 'semantic',
    },
    {
      german: "in Baden-Württemberg",
      translated: "de Baden-Wurtemberg",
      tone: 'semantic',
    },
  ],
  "lid:state:BW:9|fa": [
    {
      german: "Wie nennt man",
      translated: "ایالت",
      tone: 'semantic',
    },
    {
      german: "die Regierungschefin/den Regierungschef",
      translated: "رئیس دولت",
      tone: 'semantic',
    },
    {
      german: "in Baden-Württemberg",
      translated: "بادن-وورتمبرگ",
      tone: 'semantic',
    },
  ],
  "lid:state:BW:9|fr": [
    {
      german: "Wie nennt man",
      translated: "Comment appelle-t-on",
      tone: 'semantic',
    },
    {
      german: "die Regierungschefin/den Regierungschef",
      translated: "le chef ou la cheffe du gouvernement",
      tone: 'semantic',
    },
    {
      german: "in Baden-Württemberg",
      translated: "de Bade-Wurtemberg",
      tone: 'semantic',
    },
  ],
  "lid:state:BW:9|hr": [
    {
      german: "Wie nennt man",
      translated: "Kako se zove",
      tone: 'semantic',
    },
    {
      german: "die Regierungschefin/den Regierungschef",
      translated: "čelnik vlade",
      tone: 'semantic',
    },
    {
      german: "in Baden-Württemberg",
      translated: "savezne zemlje Baden-Württemberg",
      tone: 'semantic',
    },
  ],
  "lid:state:BW:9|it": [
    {
      german: "Wie nennt man",
      translated: "Come si chiama",
      tone: 'semantic',
    },
    {
      german: "die Regierungschefin/den Regierungschef",
      translated: "il capo del governo del Land",
      tone: 'semantic',
    },
    {
      german: "in Baden-Württemberg",
      translated: "di Baden-Württemberg",
      tone: 'semantic',
    },
  ],
  "lid:state:BW:9|kmr": [
    {
      german: "Wie nennt man",
      translated: "Serokê",
      tone: 'semantic',
    },
    {
      german: "die Regierungschefin/den Regierungschef",
      translated: "hukûmeta",
      tone: 'semantic',
    },
    {
      german: "in Baden-Württemberg",
      translated: "Baden-Württemberg",
      tone: 'semantic',
    },
  ],
  "lid:state:BW:9|pl": [
    {
      german: "Wie nennt man",
      translated: "Jak nazywa się",
      tone: 'semantic',
    },
    {
      german: "die Regierungschefin/den Regierungschef",
      translated: "szef rządu kraju związkowego",
      tone: 'semantic',
    },
    {
      german: "in Baden-Württemberg",
      translated: "Badenia-Wirtembergia",
      tone: 'semantic',
    },
  ],
  "lid:state:BW:9|prs": [
    {
      german: "Wie nennt man",
      translated: "رئیس دولت ایالت",
      tone: 'semantic',
    },
    {
      german: "die Regierungschefin/den Regierungschef",
      translated: "بادن-وورتمبرگ",
      tone: 'semantic',
    },
    {
      german: "in Baden-Württemberg",
      translated: "چه عنوانی دارد؟",
      tone: 'semantic',
    },
  ],
  "lid:state:BW:9|ro": [
    {
      german: "Wie nennt man",
      translated: "Cum se",
      tone: 'semantic',
    },
    {
      german: "die Regierungschefin/den Regierungschef",
      translated: "șeful guvernului landului",
      tone: 'semantic',
    },
    {
      german: "in Baden-Württemberg",
      translated: "Baden-Württemberg",
      tone: 'semantic',
    },
  ],
  "lid:state:BW:9|ru": [
    {
      german: "Wie nennt man",
      translated: "Как называют",
      tone: 'semantic',
    },
    {
      german: "die Regierungschefin/den Regierungschef",
      translated: "главу правительства",
      tone: 'semantic',
    },
    {
      german: "in Baden-Württemberg",
      translated: "в федеральной земле Баден-Вюртемберг",
      tone: 'semantic',
    },
  ],
  "lid:state:BW:9|sq": [
    {
      german: "Wie nennt man",
      translated: "Si quhet",
      tone: 'semantic',
    },
    {
      german: "die Regierungschefin/den Regierungschef",
      translated: "kreu i qeverisë së landit",
      tone: 'semantic',
    },
    {
      german: "in Baden-Württemberg",
      translated: "Baden-Württemberg",
      tone: 'semantic',
    },
  ],
  "lid:state:BW:9|sr": [
    {
      german: "Wie nennt man",
      translated: "Kako se zove",
      tone: 'semantic',
    },
    {
      german: "die Regierungschefin/den Regierungschef",
      translated: "šef vlade",
      tone: 'semantic',
    },
    {
      german: "in Baden-Württemberg",
      translated: "savezne pokrajine Baden-Virtemberg",
      tone: 'semantic',
    },
  ],
  "lid:state:BW:9|tr": [
    {
      german: "Wie nennt man",
      translated: "ne ad verilir",
      tone: 'semantic',
    },
    {
      german: "die Regierungschefin/den Regierungschef",
      translated: "hükümetinin başındaki kişiye",
      tone: 'semantic',
    },
    {
      german: "in Baden-Württemberg",
      translated: "Baden-Württemberg",
      tone: 'semantic',
    },
  ],
  "lid:state:BW:9|uk": [
    {
      german: "Wie nennt man",
      translated: "Як називають",
      tone: 'semantic',
    },
    {
      german: "die Regierungschefin/den Regierungschef",
      translated: "главу уряду",
      tone: 'semantic',
    },
    {
      german: "in Baden-Württemberg",
      translated: "в Баден-Вюртемберг",
      tone: 'semantic',
    },
  ],
  "lid:state:BW:9|vi": [
    {
      german: "Wie nennt man",
      translated: "được gọi là",
      tone: 'semantic',
    },
    {
      german: "die Regierungschefin/den Regierungschef",
      translated: "Người đứng đầu chính phủ",
      tone: 'semantic',
    },
    {
      german: "in Baden-Württemberg",
      translated: "bang Baden-Württemberg",
      tone: 'semantic',
    },
  ],
  "lid:state:BY:10|ar": [
    {
      german: "Welche Ministerin",
      translated: "أي وزارة",
      tone: 'semantic',
    },
    {
      german: "welchen Minister",
      translated: "الوزارات التالية",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "من",
      tone: 'semantic',
    },
    {
      german: "Bayern",
      translated: "Bayern",
      tone: 'semantic',
    },
    {
      german: "nicht",
      translated: "غير موجودة",
      tone: 'semantic',
    },
  ],
  "lid:state:BY:10|bg": [
    {
      german: "Welche Ministerin",
      translated: "Кой",
      tone: 'semantic',
    },
    {
      german: "welchen Minister",
      translated: "министър",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "съществува",
      tone: 'semantic',
    },
    {
      german: "Bayern",
      translated: "Бавария",
      tone: 'semantic',
    },
    {
      german: "nicht",
      translated: "не",
      tone: 'semantic',
    },
  ],
  "lid:state:BY:10|bs": [
    {
      german: "Welche Ministerin",
      translated: "Koji",
      tone: 'semantic',
    },
    {
      german: "welchen Minister",
      translated: "ministar",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "postoji",
      tone: 'semantic',
    },
    {
      german: "Bayern",
      translated: "na razini savezne zemlje Bavarska",
      tone: 'semantic',
    },
    {
      german: "nicht",
      translated: "ne",
      tone: 'semantic',
    },
  ],
  "lid:state:BY:10|el": [
    {
      german: "Welche Ministerin",
      translated: "Ποιος",
      tone: 'semantic',
    },
    {
      german: "welchen Minister",
      translated: "υπουργός",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "υπάρχει",
      tone: 'semantic',
    },
    {
      german: "Bayern",
      translated: "στο Βαυαρία",
      tone: 'semantic',
    },
    {
      german: "nicht",
      translated: "δεν",
      tone: 'semantic',
    },
  ],
  "lid:state:BY:10|en": [
    {
      german: "Welche Ministerin",
      translated: "Which minister",
      tone: 'semantic',
    },
    {
      german: "welchen Minister",
      translated: "does",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "have",
      tone: 'semantic',
    },
    {
      german: "Bayern",
      translated: "Bayern",
      tone: 'semantic',
    },
    {
      german: "nicht",
      translated: "not",
      tone: 'semantic',
    },
  ],
  "lid:state:BY:10|es": [
    {
      german: "Welche Ministerin",
      translated: "¿Qué",
      tone: 'semantic',
    },
    {
      german: "welchen Minister",
      translated: "ministerio",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "existe",
      tone: 'semantic',
    },
    {
      german: "Bayern",
      translated: "Baviera",
      tone: 'semantic',
    },
    {
      german: "nicht",
      translated: "NO",
      tone: 'semantic',
    },
  ],
  "lid:state:BY:10|fa": [
    {
      german: "Welche Ministerin",
      translated: "کدام",
      tone: 'semantic',
    },
    {
      german: "welchen Minister",
      translated: "وزیر",
      tone: 'semantic',
    },
    {
      german: "Bayern",
      translated: "بایرن",
      tone: 'semantic',
    },
    {
      german: "nicht",
      translated: "وجود ندارد",
      tone: 'semantic',
    },
  ],
  "lid:state:BY:10|fr": [
    {
      german: "Welche Ministerin",
      translated: "quelle ministre",
      tone: 'semantic',
    },
    {
      german: "welchen Minister",
      translated: "Quel ministre",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "existe",
      tone: 'semantic',
    },
    {
      german: "Bayern",
      translated: "Bavière",
      tone: 'semantic',
    },
    {
      german: "nicht",
      translated: "pas",
      tone: 'semantic',
    },
  ],
  "lid:state:BY:10|hr": [
    {
      german: "Welche Ministerin",
      translated: "Koji",
      tone: 'semantic',
    },
    {
      german: "welchen Minister",
      translated: "ministar",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "postoji",
      tone: 'semantic',
    },
    {
      german: "Bayern",
      translated: "na razini savezne zemlje Bavarska",
      tone: 'semantic',
    },
    {
      german: "nicht",
      translated: "ne",
      tone: 'semantic',
    },
  ],
  "lid:state:BY:10|it": [
    {
      german: "Welche Ministerin",
      translated: "Quale ministro",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "esiste",
      tone: 'semantic',
    },
    {
      german: "Bayern",
      translated: "Land di Baviera",
      tone: 'semantic',
    },
    {
      german: "nicht",
      translated: "non",
      tone: 'semantic',
    },
  ],
  "lid:state:BY:10|kmr": [
    {
      german: "welchen Minister",
      translated: "Kîjan wezîr",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "ye",
      tone: 'semantic',
    },
    {
      german: "Bayern",
      translated: "Bayern",
      tone: 'semantic',
    },
    {
      german: "nicht",
      translated: "tune",
      tone: 'semantic',
    },
  ],
  "lid:state:BY:10|pl": [
    {
      german: "welchen Minister",
      translated: "Którego ministra",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "nie ma",
      tone: 'semantic',
    },
    {
      german: "Bayern",
      translated: "Bawaria",
      tone: 'semantic',
    },
  ],
  "lid:state:BY:10|prs": [
    {
      german: "Welche Ministerin",
      translated: "کدام",
      tone: 'semantic',
    },
    {
      german: "welchen Minister",
      translated: "وزیر",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "وجود",
      tone: 'semantic',
    },
    {
      german: "Bayern",
      translated: "بایرن",
      tone: 'semantic',
    },
    {
      german: "nicht",
      translated: "ندارد",
      tone: 'semantic',
    },
  ],
  "lid:state:BY:10|ro": [
    {
      german: "Welche Ministerin",
      translated: "Care ministru",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "există",
      tone: 'semantic',
    },
    {
      german: "Bayern",
      translated: "landului Bavaria",
      tone: 'semantic',
    },
    {
      german: "nicht",
      translated: "nu",
      tone: 'semantic',
    },
  ],
  "lid:state:BY:10|ru": [
    {
      german: "welchen Minister",
      translated: "Какого министра",
      tone: 'semantic',
    },
    {
      german: "Bayern",
      translated: "Бавария",
      tone: 'semantic',
    },
    {
      german: "nicht",
      translated: "нет",
      tone: 'semantic',
    },
  ],
  "lid:state:BY:10|sq": [
    {
      german: "welchen Minister",
      translated: "Cili ministër",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "ekziston",
      tone: 'semantic',
    },
    {
      german: "Bayern",
      translated: "Bavaria",
      tone: 'semantic',
    },
    {
      german: "nicht",
      translated: "nuk",
      tone: 'semantic',
    },
  ],
  "lid:state:BY:10|sr": [
    {
      german: "Welche Ministerin",
      translated: "Koji",
      tone: 'semantic',
    },
    {
      german: "welchen Minister",
      translated: "ministar",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "postoji",
      tone: 'semantic',
    },
    {
      german: "Bayern",
      translated: "na razini savezne pokrajine Bavarska",
      tone: 'semantic',
    },
    {
      german: "nicht",
      translated: "ne",
      tone: 'semantic',
    },
  ],
  "lid:state:BY:10|tr": [
    {
      german: "Welche Ministerin",
      translated: "aşağıdaki bakanlıklardan hangisi",
      tone: 'semantic',
    },
    {
      german: "Bayern",
      translated: "Bayern eyaletinde",
      tone: 'semantic',
    },
    {
      german: "nicht",
      translated: "yoktur",
      tone: 'semantic',
    },
  ],
  "lid:state:BY:10|uk": [
    {
      german: "Welche Ministerin",
      translated: "міністерки",
      tone: 'semantic',
    },
    {
      german: "welchen Minister",
      translated: "міністра",
      tone: 'semantic',
    },
    {
      german: "Bayern",
      translated: "Баварія",
      tone: 'semantic',
    },
    {
      german: "nicht",
      translated: "немає",
      tone: 'semantic',
    },
  ],
  "lid:state:BY:10|vi": [
    {
      german: "welchen Minister",
      translated: "Bộ trưởng nào",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "tồn tại",
      tone: 'semantic',
    },
    {
      german: "Bayern",
      translated: "ở cấp bang Bayern",
      tone: 'semantic',
    },
    {
      german: "nicht",
      translated: "không",
      tone: 'semantic',
    },
  ],
  "lid:state:BY:1|ar": [
    {
      german: "Welches Wappen",
      translated: "شعار",
      tone: 'semantic',
    },
    {
      german: "gehört zum",
      translated: "من",
      tone: 'semantic',
    },
    {
      german: "Freistaat Bayern",
      translated: "Bayern",
      tone: 'semantic',
    },
  ],
  "lid:state:BY:1|bg": [
    {
      german: "Welches Wappen",
      translated: "Кой герб",
      tone: 'semantic',
    },
    {
      german: "gehört zum",
      translated: "принадлежи",
      tone: 'semantic',
    },
    {
      german: "Freistaat Bayern",
      translated: "Свободната държава Бавария",
      tone: 'semantic',
    },
  ],
  "lid:state:BY:1|bs": [
    {
      german: "Welches Wappen",
      translated: "Koji grb",
      tone: 'semantic',
    },
    {
      german: "gehört zum",
      translated: "pripada",
      tone: 'semantic',
    },
    {
      german: "Freistaat Bayern",
      translated: "Slobodnoj Državi Bavarskoj",
      tone: 'semantic',
    },
  ],
  "lid:state:BY:1|el": [
    {
      german: "Welches Wappen",
      translated: "Ποιο έμβλημα",
      tone: 'semantic',
    },
    {
      german: "gehört zum",
      translated: "ανήκει στο",
      tone: 'semantic',
    },
    {
      german: "Freistaat Bayern",
      translated: "ομόσπονδο κρατίδιο Βαυαρία",
      tone: 'semantic',
    },
  ],
  "lid:state:BY:1|en": [
    {
      german: "Welches Wappen",
      translated: "Which coat of arms",
      tone: 'semantic',
    },
    {
      german: "gehört zum",
      translated: "belongs to the",
      tone: 'semantic',
    },
    {
      german: "Freistaat Bayern",
      translated: "Free State of Bayern",
      tone: 'semantic',
    },
  ],
  "lid:state:BY:1|es": [
    {
      german: "Welches Wappen",
      translated: "¿Qué escudo",
      tone: 'semantic',
    },
    {
      german: "gehört zum",
      translated: "pertenece al estado federado de",
      tone: 'semantic',
    },
    {
      german: "Freistaat Bayern",
      translated: "Baviera",
      tone: 'semantic',
    },
  ],
  "lid:state:BY:1|fa": [
    {
      german: "Welches Wappen",
      translated: "کدام نشان",
      tone: 'semantic',
    },
    {
      german: "gehört zum",
      translated: "متعلق به",
      tone: 'semantic',
    },
    {
      german: "Freistaat Bayern",
      translated: "ایالت آزاد بایرن",
      tone: 'semantic',
    },
  ],
  "lid:state:BY:1|fr": [
    {
      german: "Welches Wappen",
      translated: "Quel blason",
      tone: 'semantic',
    },
    {
      german: "gehört zum",
      translated: "appartient au",
      tone: 'semantic',
    },
    {
      german: "Freistaat Bayern",
      translated: "Land de Bavière",
      tone: 'semantic',
    },
  ],
  "lid:state:BY:1|hr": [
    {
      german: "Welches Wappen",
      translated: "grb",
      tone: 'semantic',
    },
    {
      german: "gehört zum",
      translated: "pripada",
      tone: 'semantic',
    },
    {
      german: "Freistaat Bayern",
      translated: "Bavarska",
      tone: 'semantic',
    },
  ],
  "lid:state:BY:1|it": [
    {
      german: "Welches Wappen",
      translated: "Quale stemma",
      tone: 'semantic',
    },
    {
      german: "gehört zum",
      translated: "appartiene al",
      tone: 'semantic',
    },
    {
      german: "Freistaat Bayern",
      translated: "Land di Baviera",
      tone: 'semantic',
    },
  ],
  "lid:state:BY:1|kmr": [
    {
      german: "Welches Wappen",
      translated: "Kîjan nîşan",
      tone: 'semantic',
    },
    {
      german: "gehört zum",
      translated: "a",
      tone: 'semantic',
    },
    {
      german: "Freistaat Bayern",
      translated: "Dewleta Azad a Bayern",
      tone: 'semantic',
    },
  ],
  "lid:state:BY:1|pl": [
    {
      german: "Welches Wappen",
      translated: "Który herb",
      tone: 'semantic',
    },
    {
      german: "gehört zum",
      translated: "należy do",
      tone: 'semantic',
    },
    {
      german: "Freistaat Bayern",
      translated: "kraju związkowego Bawaria",
      tone: 'semantic',
    },
  ],
  "lid:state:BY:1|prs": [
    {
      german: "Welches Wappen",
      translated: "کدام نشان",
      tone: 'semantic',
    },
    {
      german: "gehört zum",
      translated: "متعلق به",
      tone: 'semantic',
    },
    {
      german: "Freistaat Bayern",
      translated: "ایالت آزاد بایرن",
      tone: 'semantic',
    },
  ],
  "lid:state:BY:1|ro": [
    {
      german: "Welches Wappen",
      translated: "Care stemă",
      tone: 'semantic',
    },
    {
      german: "gehört zum",
      translated: "aparține",
      tone: 'semantic',
    },
    {
      german: "Freistaat Bayern",
      translated: "landului Bavaria",
      tone: 'semantic',
    },
  ],
  "lid:state:BY:1|ru": [
    {
      german: "Welches Wappen",
      translated: "Какой герб",
      tone: 'semantic',
    },
    {
      german: "gehört zum",
      translated: "принадлежит свободному государству",
      tone: 'semantic',
    },
    {
      german: "Freistaat Bayern",
      translated: "Бавария",
      tone: 'semantic',
    },
  ],
  "lid:state:BY:1|sq": [
    {
      german: "Welches Wappen",
      translated: "Cila stemë",
      tone: 'semantic',
    },
    {
      german: "gehört zum",
      translated: "i përket",
      tone: 'semantic',
    },
    {
      german: "Freistaat Bayern",
      translated: "Shtetit të Lirë të Bavarisë",
      tone: 'semantic',
    },
  ],
  "lid:state:BY:1|sr": [
    {
      german: "Welches Wappen",
      translated: "Koji grb",
      tone: 'semantic',
    },
    {
      german: "gehört zum",
      translated: "pripada",
      tone: 'semantic',
    },
    {
      german: "Freistaat Bayern",
      translated: "Slobodnoj Državi Bavarskoj",
      tone: 'semantic',
    },
  ],
  "lid:state:BY:1|tr": [
    {
      german: "Welches Wappen",
      translated: "arması hangisidir",
      tone: 'semantic',
    },
    {
      german: "Freistaat Bayern",
      translated: "Bavyera Özgür Devleti'nin",
      tone: 'semantic',
    },
  ],
  "lid:state:BY:1|uk": [
    {
      german: "Welches Wappen",
      translated: "Який герб",
      tone: 'semantic',
    },
    {
      german: "gehört zum",
      translated: "належить",
      tone: 'semantic',
    },
    {
      german: "Freistaat Bayern",
      translated: "Вільній державі Баварія",
      tone: 'semantic',
    },
  ],
  "lid:state:BY:1|vi": [
    {
      german: "Welches Wappen",
      translated: "Quốc huy nào",
      tone: 'semantic',
    },
    {
      german: "gehört zum",
      translated: "thuộc",
      tone: 'semantic',
    },
    {
      german: "Freistaat Bayern",
      translated: "Bang Tự do Bayern",
      tone: 'semantic',
    },
  ],
  "lid:state:BY:2|ar": [
    {
      german: "Welches ist",
      translated: "أي",
      tone: 'semantic',
    },
    {
      german: "ein Landkreis",
      translated: "دائرة إدارية",
      tone: 'semantic',
    },
    {
      german: "in Bayern",
      translated: "في Bayern",
      tone: 'semantic',
    },
  ],
  "lid:state:BY:2|bg": [
    {
      german: "Welches ist",
      translated: "Кое",
      tone: 'semantic',
    },
    {
      german: "ein Landkreis",
      translated: "окръг (Landkreis)",
      tone: 'semantic',
    },
    {
      german: "in Bayern",
      translated: "в Бавария",
      tone: 'semantic',
    },
  ],
  "lid:state:BY:2|bs": [
    {
      german: "Welches ist",
      translated: "Što",
      tone: 'semantic',
    },
    {
      german: "ein Landkreis",
      translated: "od navedenoga okrug (Landkreis)",
      tone: 'semantic',
    },
    {
      german: "in Bayern",
      translated: "u saveznoj zemlji Bavarska?",
      tone: 'semantic',
    },
  ],
  "lid:state:BY:2|el": [
    {
      german: "Welches ist",
      translated: "Ποιο από τα παρακάτω είναι",
      tone: 'semantic',
    },
    {
      german: "ein Landkreis",
      translated: "διοικητική περιφέρεια (Landkreis)",
      tone: 'semantic',
    },
    {
      german: "in Bayern",
      translated: "στο Βαυαρία",
      tone: 'semantic',
    },
  ],
  "lid:state:BY:2|en": [
    {
      german: "Welches ist",
      translated: "Which is",
      tone: 'semantic',
    },
    {
      german: "ein Landkreis",
      translated: "a district",
      tone: 'semantic',
    },
    {
      german: "in Bayern",
      translated: "in Bayern",
      tone: 'semantic',
    },
  ],
  "lid:state:BY:2|es": [
    {
      german: "Welches ist",
      translated: "¿Cuál de los siguientes es",
      tone: 'semantic',
    },
    {
      german: "ein Landkreis",
      translated: "un distrito (Landkreis)",
      tone: 'semantic',
    },
    {
      german: "in Bayern",
      translated: "de Baviera",
      tone: 'semantic',
    },
  ],
  "lid:state:BY:2|fa": [
    {
      german: "Welches ist",
      translated: "کدام‌یک",
      tone: 'semantic',
    },
    {
      german: "ein Landkreis",
      translated: "شهرستان (Landkreis)",
      tone: 'semantic',
    },
    {
      german: "in Bayern",
      translated: "بایرن است",
      tone: 'semantic',
    },
  ],
  "lid:state:BY:2|fr": [
    {
      german: "Welches ist",
      translated: "Lequel des",
      tone: 'semantic',
    },
    {
      german: "ein Landkreis",
      translated: "arrondissement (Landkreis)",
      tone: 'semantic',
    },
    {
      german: "in Bayern",
      translated: "de Bavière",
      tone: 'semantic',
    },
  ],
  "lid:state:BY:2|hr": [
    {
      german: "Welches ist",
      translated: "Što je",
      tone: 'semantic',
    },
    {
      german: "ein Landkreis",
      translated: "od navedenoga okrug (Landkreis)",
      tone: 'semantic',
    },
    {
      german: "in Bayern",
      translated: "u saveznoj zemlji Bavarska",
      tone: 'semantic',
    },
  ],
  "lid:state:BY:2|it": [
    {
      german: "Welches ist",
      translated: "Quale dei seguenti è",
      tone: 'semantic',
    },
    {
      german: "ein Landkreis",
      translated: "un distretto (Landkreis)",
      tone: 'semantic',
    },
    {
      german: "in Bayern",
      translated: "di Baviera",
      tone: 'semantic',
    },
  ],
  "lid:state:BY:2|kmr": [
    {
      german: "Welches ist",
      translated: "Kîjan navçe",
      tone: 'semantic',
    },
    {
      german: "ein Landkreis",
      translated: "li",
      tone: 'semantic',
    },
    {
      german: "in Bayern",
      translated: "Bayern ye",
      tone: 'semantic',
    },
  ],
  "lid:state:BY:2|pl": [
    {
      german: "Welches ist",
      translated: "Który",
      tone: 'semantic',
    },
    {
      german: "ein Landkreis",
      translated: "powiatem (Landkreis)",
      tone: 'semantic',
    },
    {
      german: "in Bayern",
      translated: "w Bawaria?",
      tone: 'semantic',
    },
  ],
  "lid:state:BY:2|prs": [
    {
      german: "Welches ist",
      translated: "کدام‌یک",
      tone: 'semantic',
    },
    {
      german: "ein Landkreis",
      translated: "شهرستان",
      tone: 'semantic',
    },
    {
      german: "in Bayern",
      translated: "بایرن",
      tone: 'semantic',
    },
  ],
  "lid:state:BY:2|ro": [
    {
      german: "Welches ist",
      translated: "Care dintre următoarele",
      tone: 'semantic',
    },
    {
      german: "ein Landkreis",
      translated: "district (Landkreis)",
      tone: 'semantic',
    },
    {
      german: "in Bayern",
      translated: "din Bavaria",
      tone: 'semantic',
    },
  ],
  "lid:state:BY:2|ru": [
    {
      german: "Welches ist",
      translated: "Какой из перечисленных является",
      tone: 'semantic',
    },
    {
      german: "ein Landkreis",
      translated: "районом",
      tone: 'semantic',
    },
    {
      german: "in Bayern",
      translated: "в федеральной земле Бавария",
      tone: 'semantic',
    },
  ],
  "lid:state:BY:2|sq": [
    {
      german: "Welches ist",
      translated: "Cila nga këto",
      tone: 'semantic',
    },
    {
      german: "ein Landkreis",
      translated: "qark (Landkreis)",
      tone: 'semantic',
    },
    {
      german: "in Bayern",
      translated: "në Bavaria",
      tone: 'semantic',
    },
  ],
  "lid:state:BY:2|sr": [
    {
      german: "Welches ist",
      translated: "Šta je",
      tone: 'semantic',
    },
    {
      german: "ein Landkreis",
      translated: "okrug (Landkreis)",
      tone: 'semantic',
    },
    {
      german: "in Bayern",
      translated: "u saveznoj pokrajini Bavarska",
      tone: 'semantic',
    },
  ],
  "lid:state:BY:2|tr": [
    {
      german: "Welches ist",
      translated: "Aşağıdakilerden hangisi",
      tone: 'semantic',
    },
    {
      german: "ein Landkreis",
      translated: "bir Landkreis (ilçe/idari bölge)dir",
      tone: 'semantic',
    },
    {
      german: "in Bayern",
      translated: "Bayern eyaletinde bulunan",
      tone: 'semantic',
    },
  ],
  "lid:state:BY:2|uk": [
    {
      german: "Welches ist",
      translated: "Який із",
      tone: 'semantic',
    },
    {
      german: "ein Landkreis",
      translated: "наведених районів",
      tone: 'semantic',
    },
    {
      german: "in Bayern",
      translated: "у Баварія?",
      tone: 'semantic',
    },
  ],
  "lid:state:BY:2|vi": [
    {
      german: "Welches ist",
      translated: "Địa danh nào sau đây là",
      tone: 'semantic',
    },
    {
      german: "ein Landkreis",
      translated: "một huyện",
      tone: 'semantic',
    },
    {
      german: "in Bayern",
      translated: "của bang Bayern",
      tone: 'semantic',
    },
  ],
  "lid:state:BY:3|ar": [
    {
      german: "Für wie viele Jahre",
      translated: "كم سنة",
      tone: 'semantic',
    },
    {
      german: "der Landtag",
      translated: "برلمان الولاية",
      tone: 'semantic',
    },
    {
      german: "in Bayern",
      translated: "Bayern",
      tone: 'semantic',
    },
    {
      german: "gewählt",
      translated: "يُنتخب",
      tone: 'semantic',
    },
  ],
  "lid:state:BY:3|bg": [
    {
      german: "Für wie viele Jahre",
      translated: "За колко години",
      tone: 'semantic',
    },
    {
      german: "der Landtag",
      translated: "парламентът",
      tone: 'semantic',
    },
    {
      german: "in Bayern",
      translated: "на провинция Бавария",
      tone: 'semantic',
    },
    {
      german: "gewählt",
      translated: "се избира",
      tone: 'semantic',
    },
  ],
  "lid:state:BY:3|bs": [
    {
      german: "Für wie viele Jahre",
      translated: "Na koliko se godina",
      tone: 'semantic',
    },
    {
      german: "der Landtag",
      translated: "parlament",
      tone: 'semantic',
    },
    {
      german: "in Bayern",
      translated: "savezne zemlje Bavarska",
      tone: 'semantic',
    },
    {
      german: "gewählt",
      translated: "bira",
      tone: 'semantic',
    },
  ],
  "lid:state:BY:3|el": [
    {
      german: "Für wie viele Jahre",
      translated: "Για πόσα χρόνια",
      tone: 'semantic',
    },
    {
      german: "der Landtag",
      translated: "το Landtag",
      tone: 'semantic',
    },
    {
      german: "in Bayern",
      translated: "του Βαυαρία",
      tone: 'semantic',
    },
    {
      german: "gewählt",
      translated: "εκλέγεται",
      tone: 'semantic',
    },
  ],
  "lid:state:BY:3|en": [
    {
      german: "Für wie viele Jahre",
      translated: "For how many years",
      tone: 'semantic',
    },
    {
      german: "der Landtag",
      translated: "the state parliament",
      tone: 'semantic',
    },
    {
      german: "in Bayern",
      translated: "in Bayern",
      tone: 'semantic',
    },
    {
      german: "gewählt",
      translated: "elected",
      tone: 'semantic',
    },
  ],
  "lid:state:BY:3|es": [
    {
      german: "Für wie viele Jahre",
      translated: "¿Por cuántos años",
      tone: 'semantic',
    },
    {
      german: "der Landtag",
      translated: "el parlamento regional",
      tone: 'semantic',
    },
    {
      german: "in Bayern",
      translated: "en Baviera",
      tone: 'semantic',
    },
    {
      german: "gewählt",
      translated: "se elige",
      tone: 'semantic',
    },
  ],
  "lid:state:BY:3|fa": [
    {
      german: "Für wie viele Jahre",
      translated: "چند سال",
      tone: 'semantic',
    },
    {
      german: "der Landtag",
      translated: "پارلمان ایالتی",
      tone: 'semantic',
    },
    {
      german: "in Bayern",
      translated: "بایرن",
      tone: 'semantic',
    },
    {
      german: "gewählt",
      translated: "انتخاب می‌شود",
      tone: 'semantic',
    },
  ],
  "lid:state:BY:3|fr": [
    {
      german: "Für wie viele Jahre",
      translated: "Pour combien d’années",
      tone: 'semantic',
    },
    {
      german: "der Landtag",
      translated: "le Landtag",
      tone: 'semantic',
    },
    {
      german: "in Bayern",
      translated: "de Bavière",
      tone: 'semantic',
    },
    {
      german: "gewählt",
      translated: "est-il élu",
      tone: 'semantic',
    },
  ],
  "lid:state:BY:3|hr": [
    {
      german: "Für wie viele Jahre",
      translated: "Na koliko se godina",
      tone: 'semantic',
    },
    {
      german: "der Landtag",
      translated: "parlament",
      tone: 'semantic',
    },
    {
      german: "in Bayern",
      translated: "savezne zemlje Bavarska",
      tone: 'semantic',
    },
    {
      german: "gewählt",
      translated: "bira",
      tone: 'semantic',
    },
  ],
  "lid:state:BY:3|it": [
    {
      german: "Für wie viele Jahre",
      translated: "Per quanti anni",
      tone: 'semantic',
    },
    {
      german: "der Landtag",
      translated: "il Landtag",
      tone: 'semantic',
    },
    {
      german: "in Bayern",
      translated: "di Baviera",
      tone: 'semantic',
    },
    {
      german: "gewählt",
      translated: "eletto",
      tone: 'semantic',
    },
  ],
  "lid:state:BY:3|kmr": [
    {
      german: "Für wie viele Jahre",
      translated: "ji bo çend salan",
      tone: 'semantic',
    },
    {
      german: "der Landtag",
      translated: "Landtag",
      tone: 'semantic',
    },
    {
      german: "in Bayern",
      translated: "a Bayern",
      tone: 'semantic',
    },
    {
      german: "gewählt",
      translated: "tê hilbijartin",
      tone: 'semantic',
    },
  ],
  "lid:state:BY:3|pl": [
    {
      german: "Für wie viele Jahre",
      translated: "Na ile lat",
      tone: 'semantic',
    },
    {
      german: "der Landtag",
      translated: "parlament",
      tone: 'semantic',
    },
    {
      german: "in Bayern",
      translated: "kraju związkowego Bawaria",
      tone: 'semantic',
    },
    {
      german: "gewählt",
      translated: "wybierany",
      tone: 'semantic',
    },
  ],
  "lid:state:BY:3|prs": [
    {
      german: "Für wie viele Jahre",
      translated: "برای چند سال",
      tone: 'semantic',
    },
    {
      german: "der Landtag",
      translated: "پارلمان ایالتی",
      tone: 'semantic',
    },
    {
      german: "in Bayern",
      translated: "بایرن",
      tone: 'semantic',
    },
    {
      german: "gewählt",
      translated: "انتخاب می‌شود",
      tone: 'semantic',
    },
  ],
  "lid:state:BY:3|ro": [
    {
      german: "Für wie viele Jahre",
      translated: "Pentru câți ani",
      tone: 'semantic',
    },
    {
      german: "der Landtag",
      translated: "parlamentul landului",
      tone: 'semantic',
    },
    {
      german: "in Bayern",
      translated: "Bavaria",
      tone: 'semantic',
    },
    {
      german: "gewählt",
      translated: "ales",
      tone: 'semantic',
    },
  ],
  "lid:state:BY:3|ru": [
    {
      german: "Für wie viele Jahre",
      translated: "На сколько лет",
      tone: 'semantic',
    },
    {
      german: "der Landtag",
      translated: "ландтаг",
      tone: 'semantic',
    },
    {
      german: "in Bayern",
      translated: "в федеральной земле Бавария",
      tone: 'semantic',
    },
    {
      german: "gewählt",
      translated: "избирается",
      tone: 'semantic',
    },
  ],
  "lid:state:BY:3|sq": [
    {
      german: "Für wie viele Jahre",
      translated: "Për sa vjet",
      tone: 'semantic',
    },
    {
      german: "der Landtag",
      translated: "Landtagu",
      tone: 'semantic',
    },
    {
      german: "in Bayern",
      translated: "i Bavaria",
      tone: 'semantic',
    },
    {
      german: "gewählt",
      translated: "zgjidhet",
      tone: 'semantic',
    },
  ],
  "lid:state:BY:3|sr": [
    {
      german: "Für wie viele Jahre",
      translated: "Na koliko se godina",
      tone: 'semantic',
    },
    {
      german: "der Landtag",
      translated: "parlament",
      tone: 'semantic',
    },
    {
      german: "in Bayern",
      translated: "savezne pokrajine Bavarska",
      tone: 'semantic',
    },
    {
      german: "gewählt",
      translated: "bira",
      tone: 'semantic',
    },
  ],
  "lid:state:BY:3|tr": [
    {
      german: "Für wie viele Jahre",
      translated: "kaç yıllığına",
      tone: 'semantic',
    },
    {
      german: "der Landtag",
      translated: "eyalet parlamentosu",
      tone: 'semantic',
    },
    {
      german: "in Bayern",
      translated: "Bayern",
      tone: 'semantic',
    },
    {
      german: "gewählt",
      translated: "seçilir",
      tone: 'semantic',
    },
  ],
  "lid:state:BY:3|uk": [
    {
      german: "Für wie viele Jahre",
      translated: "На скільки років",
      tone: 'semantic',
    },
    {
      german: "der Landtag",
      translated: "земельний парламент",
      tone: 'semantic',
    },
    {
      german: "in Bayern",
      translated: "у Баварія",
      tone: 'semantic',
    },
    {
      german: "gewählt",
      translated: "обирають",
      tone: 'semantic',
    },
  ],
  "lid:state:BY:3|vi": [
    {
      german: "Für wie viele Jahre",
      translated: "bao nhiêu năm",
      tone: 'semantic',
    },
    {
      german: "der Landtag",
      translated: "Nghị viện bang (Landtag)",
      tone: 'semantic',
    },
    {
      german: "in Bayern",
      translated: "của Bayern",
      tone: 'semantic',
    },
    {
      german: "gewählt",
      translated: "được bầu",
      tone: 'semantic',
    },
  ],
  "lid:state:BY:4|ar": [
    {
      german: "Ab welchem Alter",
      translated: "ابتداءً من أي سن",
      tone: 'semantic',
    },
    {
      german: "darf man",
      translated: "يحق",
      tone: 'semantic',
    },
    {
      german: "in Bayern",
      translated: "في Bayern",
      tone: 'semantic',
    },
    {
      german: "bei Kommunalwahlen",
      translated: "في الانتخابات المحلية",
      tone: 'semantic',
    },
    {
      german: "wählen",
      translated: "التصويت",
      tone: 'semantic',
    },
  ],
  "lid:state:BY:4|bg": [
    {
      german: "Ab welchem Alter",
      translated: "От каква възраст",
      tone: 'semantic',
    },
    {
      german: "darf man",
      translated: "може да се",
      tone: 'semantic',
    },
    {
      german: "in Bayern",
      translated: "в Бавария",
      tone: 'semantic',
    },
    {
      german: "bei Kommunalwahlen",
      translated: "на общински избори",
      tone: 'semantic',
    },
    {
      german: "wählen",
      translated: "гласува",
      tone: 'semantic',
    },
  ],
  "lid:state:BY:4|bs": [
    {
      german: "Ab welchem Alter",
      translated: "Od koje se dobi",
      tone: 'semantic',
    },
    {
      german: "darf man",
      translated: "može",
      tone: 'semantic',
    },
    {
      german: "in Bayern",
      translated: "u saveznoj zemlji Bavarska",
      tone: 'semantic',
    },
    {
      german: "bei Kommunalwahlen",
      translated: "na lokalnim izborima",
      tone: 'semantic',
    },
    {
      german: "wählen",
      translated: "glasovati",
      tone: 'semantic',
    },
  ],
  "lid:state:BY:4|el": [
    {
      german: "Ab welchem Alter",
      translated: "Από ποια ηλικία",
      tone: 'semantic',
    },
    {
      german: "darf man",
      translated: "μπορεί κάποιος να",
      tone: 'semantic',
    },
    {
      german: "in Bayern",
      translated: "στο Βαυαρία",
      tone: 'semantic',
    },
    {
      german: "bei Kommunalwahlen",
      translated: "στις δημοτικές εκλογές",
      tone: 'semantic',
    },
    {
      german: "wählen",
      translated: "ψηφίσει",
      tone: 'semantic',
    },
  ],
  "lid:state:BY:4|en": [
    {
      german: "Ab welchem Alter",
      translated: "From what age",
      tone: 'semantic',
    },
    {
      german: "darf man",
      translated: "can you",
      tone: 'semantic',
    },
    {
      german: "in Bayern",
      translated: "in Bayern",
      tone: 'semantic',
    },
    {
      german: "bei Kommunalwahlen",
      translated: "local elections",
      tone: 'semantic',
    },
    {
      german: "wählen",
      translated: "vote",
      tone: 'semantic',
    },
  ],
  "lid:state:BY:4|es": [
    {
      german: "Ab welchem Alter",
      translated: "A partir de qué edad",
      tone: 'semantic',
    },
    {
      german: "darf man",
      translated: "se puede",
      tone: 'semantic',
    },
    {
      german: "in Bayern",
      translated: "de Baviera",
      tone: 'semantic',
    },
    {
      german: "bei Kommunalwahlen",
      translated: "en las elecciones municipales",
      tone: 'semantic',
    },
    {
      german: "wählen",
      translated: "votar",
      tone: 'semantic',
    },
  ],
  "lid:state:BY:4|fa": [
    {
      german: "Ab welchem Alter",
      translated: "از چه سنی",
      tone: 'semantic',
    },
    {
      german: "darf man",
      translated: "می‌توان",
      tone: 'semantic',
    },
    {
      german: "in Bayern",
      translated: "بایرن",
      tone: 'semantic',
    },
    {
      german: "bei Kommunalwahlen",
      translated: "در انتخابات محلی",
      tone: 'semantic',
    },
    {
      german: "wählen",
      translated: "رأی داد",
      tone: 'semantic',
    },
  ],
  "lid:state:BY:4|fr": [
    {
      german: "Ab welchem Alter",
      translated: "À partir de quel âge",
      tone: 'semantic',
    },
    {
      german: "darf man",
      translated: "peut-on",
      tone: 'semantic',
    },
    {
      german: "in Bayern",
      translated: "en Bavière",
      tone: 'semantic',
    },
    {
      german: "bei Kommunalwahlen",
      translated: "aux élections municipales",
      tone: 'semantic',
    },
    {
      german: "wählen",
      translated: "voter",
      tone: 'semantic',
    },
  ],
  "lid:state:BY:4|hr": [
    {
      german: "Ab welchem Alter",
      translated: "Od koje se dobi",
      tone: 'semantic',
    },
    {
      german: "darf man",
      translated: "može",
      tone: 'semantic',
    },
    {
      german: "in Bayern",
      translated: "u saveznoj zemlji Bavarska",
      tone: 'semantic',
    },
    {
      german: "bei Kommunalwahlen",
      translated: "na lokalnim izborima",
      tone: 'semantic',
    },
    {
      german: "wählen",
      translated: "glasovati",
      tone: 'semantic',
    },
  ],
  "lid:state:BY:4|it": [
    {
      german: "Ab welchem Alter",
      translated: "Da quale età",
      tone: 'semantic',
    },
    {
      german: "darf man",
      translated: "si può",
      tone: 'semantic',
    },
    {
      german: "in Bayern",
      translated: "in Baviera",
      tone: 'semantic',
    },
    {
      german: "bei Kommunalwahlen",
      translated: "alle elezioni comunali",
      tone: 'semantic',
    },
    {
      german: "wählen",
      translated: "votare",
      tone: 'semantic',
    },
  ],
  "lid:state:BY:4|kmr": [
    {
      german: "Ab welchem Alter",
      translated: "Ji kîjan temenê",
      tone: 'semantic',
    },
    {
      german: "darf man",
      translated: "dikare",
      tone: 'semantic',
    },
    {
      german: "in Bayern",
      translated: "li Bayern",
      tone: 'semantic',
    },
    {
      german: "bei Kommunalwahlen",
      translated: "di hilbijartinên şaredariyê de",
      tone: 'semantic',
    },
    {
      german: "wählen",
      translated: "deng were dayîn",
      tone: 'semantic',
    },
  ],
  "lid:state:BY:4|pl": [
    {
      german: "Ab welchem Alter",
      translated: "Od jakiego wieku",
      tone: 'semantic',
    },
    {
      german: "darf man",
      translated: "można",
      tone: 'semantic',
    },
    {
      german: "in Bayern",
      translated: "w Bawaria",
      tone: 'semantic',
    },
    {
      german: "bei Kommunalwahlen",
      translated: "w wyborach samorządowych",
      tone: 'semantic',
    },
    {
      german: "wählen",
      translated: "głosować",
      tone: 'semantic',
    },
  ],
  "lid:state:BY:4|prs": [
    {
      german: "Ab welchem Alter",
      translated: "از چه سنی",
      tone: 'semantic',
    },
    {
      german: "darf man",
      translated: "می‌توان",
      tone: 'semantic',
    },
    {
      german: "in Bayern",
      translated: "بایرن",
      tone: 'semantic',
    },
    {
      german: "bei Kommunalwahlen",
      translated: "در انتخابات شاروالی",
      tone: 'semantic',
    },
    {
      german: "wählen",
      translated: "رأی داد",
      tone: 'semantic',
    },
  ],
  "lid:state:BY:4|ro": [
    {
      german: "Ab welchem Alter",
      translated: "De la ce vârstă",
      tone: 'semantic',
    },
    {
      german: "darf man",
      translated: "se poate",
      tone: 'semantic',
    },
    {
      german: "in Bayern",
      translated: "din Bavaria",
      tone: 'semantic',
    },
    {
      german: "bei Kommunalwahlen",
      translated: "la alegerile locale",
      tone: 'semantic',
    },
    {
      german: "wählen",
      translated: "vota",
      tone: 'semantic',
    },
  ],
  "lid:state:BY:4|ru": [
    {
      german: "Ab welchem Alter",
      translated: "С какого возраста",
      tone: 'semantic',
    },
    {
      german: "darf man",
      translated: "можно",
      tone: 'semantic',
    },
    {
      german: "in Bayern",
      translated: "в федеральной земле Бавария",
      tone: 'semantic',
    },
    {
      german: "bei Kommunalwahlen",
      translated: "на муниципальных выборах",
      tone: 'semantic',
    },
    {
      german: "wählen",
      translated: "голосовать",
      tone: 'semantic',
    },
  ],
  "lid:state:BY:4|sq": [
    {
      german: "Ab welchem Alter",
      translated: "Nga cila moshë",
      tone: 'semantic',
    },
    {
      german: "darf man",
      translated: "mund të",
      tone: 'semantic',
    },
    {
      german: "in Bayern",
      translated: "në Bavaria",
      tone: 'semantic',
    },
    {
      german: "bei Kommunalwahlen",
      translated: "në zgjedhjet komunale",
      tone: 'semantic',
    },
    {
      german: "wählen",
      translated: "votohet",
      tone: 'semantic',
    },
  ],
  "lid:state:BY:4|sr": [
    {
      german: "Ab welchem Alter",
      translated: "Od koje se dobi",
      tone: 'semantic',
    },
    {
      german: "darf man",
      translated: "može",
      tone: 'semantic',
    },
    {
      german: "in Bayern",
      translated: "u saveznoj pokrajini Bavarska",
      tone: 'semantic',
    },
    {
      german: "bei Kommunalwahlen",
      translated: "na lokalnim izborima",
      tone: 'semantic',
    },
    {
      german: "wählen",
      translated: "glasati",
      tone: 'semantic',
    },
  ],
  "lid:state:BY:4|tr": [
    {
      german: "Ab welchem Alter",
      translated: "kaç yaşından itibaren",
      tone: 'semantic',
    },
    {
      german: "in Bayern",
      translated: "Bayern eyaletinde",
      tone: 'semantic',
    },
    {
      german: "bei Kommunalwahlen",
      translated: "yerel seçimlerde",
      tone: 'semantic',
    },
    {
      german: "wählen",
      translated: "oy kullanılabilir",
      tone: 'semantic',
    },
  ],
  "lid:state:BY:4|uk": [
    {
      german: "Ab welchem Alter",
      translated: "З якого віку",
      tone: 'semantic',
    },
    {
      german: "darf man",
      translated: "в",
      tone: 'semantic',
    },
    {
      german: "in Bayern",
      translated: "Баварія",
      tone: 'semantic',
    },
    {
      german: "bei Kommunalwahlen",
      translated: "на муніципальних виборах",
      tone: 'semantic',
    },
    {
      german: "wählen",
      translated: "можна голосувати",
      tone: 'semantic',
    },
  ],
  "lid:state:BY:4|vi": [
    {
      german: "Ab welchem Alter",
      translated: "Từ bao nhiêu tuổi",
      tone: 'semantic',
    },
    {
      german: "darf man",
      translated: "có thể",
      tone: 'semantic',
    },
    {
      german: "in Bayern",
      translated: "ở bang Bayern",
      tone: 'semantic',
    },
    {
      german: "bei Kommunalwahlen",
      translated: "trong bầu cử địa phương",
      tone: 'semantic',
    },
    {
      german: "wählen",
      translated: "bỏ phiếu",
      tone: 'semantic',
    },
  ],
  "lid:state:BY:5|ar": [
    {
      german: "Welche Farben",
      translated: "ما ألوان",
      tone: 'semantic',
    },
    {
      german: "die Landesflagge von Bayern",
      translated: "علم ولاية Bayern",
      tone: 'semantic',
    },
  ],
  "lid:state:BY:5|bg": [
    {
      german: "Welche Farben",
      translated: "Какви са цветовете",
      tone: 'semantic',
    },
    {
      german: "die Landesflagge von Bayern",
      translated: "на знамето на провинция Бавария",
      tone: 'semantic',
    },
  ],
  "lid:state:BY:5|bs": [
    {
      german: "Welche Farben",
      translated: "Koje su",
      tone: 'semantic',
    },
    {
      german: "die Landesflagge von Bayern",
      translated: "zastave savezne zemlje Bavarska",
      tone: 'semantic',
    },
  ],
  "lid:state:BY:5|el": [
    {
      german: "Welche Farben",
      translated: "Ποια",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "είναι",
      tone: 'semantic',
    },
    {
      german: "die Landesflagge von Bayern",
      translated: "τα χρώματα της σημαίας του κρατιδίου Βαυαρία",
      tone: 'semantic',
    },
  ],
  "lid:state:BY:5|en": [
    {
      german: "Welche Farben",
      translated: "What colors",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "does",
      tone: 'semantic',
    },
    {
      german: "die Landesflagge von Bayern",
      translated: "the state flag of Bayern",
      tone: 'semantic',
    },
  ],
  "lid:state:BY:5|es": [
    {
      german: "Welche Farben",
      translated: "¿Qué colores",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "tiene",
      tone: 'semantic',
    },
    {
      german: "die Landesflagge von Bayern",
      translated: "la bandera regional de Baviera",
      tone: 'semantic',
    },
  ],
  "lid:state:BY:5|fa": [
    {
      german: "Welche Farben",
      translated: "رنگ‌های",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "کدام‌اند",
      tone: 'semantic',
    },
    {
      german: "die Landesflagge von Bayern",
      translated: "ایالت بایرن",
      tone: 'semantic',
    },
  ],
  "lid:state:BY:5|fr": [
    {
      german: "Welche Farben",
      translated: "Quelles sont les couleurs",
      tone: 'semantic',
    },
    {
      german: "die Landesflagge von Bayern",
      translated: "du drapeau du Land de Bavière",
      tone: 'semantic',
    },
  ],
  "lid:state:BY:5|hr": [
    {
      german: "Welche Farben",
      translated: "Koje su boje",
      tone: 'semantic',
    },
    {
      german: "die Landesflagge von Bayern",
      translated: "zastave savezne zemlje Bavarska",
      tone: 'semantic',
    },
  ],
  "lid:state:BY:5|it": [
    {
      german: "Welche Farben",
      translated: "Quali sono i colori",
      tone: 'semantic',
    },
    {
      german: "die Landesflagge von Bayern",
      translated: "della bandiera del Land di Baviera",
      tone: 'semantic',
    },
  ],
  "lid:state:BY:5|kmr": [
    {
      german: "Welche Farben",
      translated: "Rengên ala",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "çi ne",
      tone: 'semantic',
    },
    {
      german: "die Landesflagge von Bayern",
      translated: "eyaleta Bayern",
      tone: 'semantic',
    },
  ],
  "lid:state:BY:5|pl": [
    {
      german: "Welche Farben",
      translated: "Jakie są kolory",
      tone: 'semantic',
    },
    {
      german: "die Landesflagge von Bayern",
      translated: "flagi kraju związkowego Bawaria",
      tone: 'semantic',
    },
  ],
  "lid:state:BY:5|prs": [
    {
      german: "Welche Farben",
      translated: "رنگ‌های",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "کدام‌اند؟",
      tone: 'semantic',
    },
    {
      german: "die Landesflagge von Bayern",
      translated: "پرچم ایالت بایرن",
      tone: 'semantic',
    },
  ],
  "lid:state:BY:5|ro": [
    {
      german: "Welche Farben",
      translated: "Care sunt culorile",
      tone: 'semantic',
    },
    {
      german: "die Landesflagge von Bayern",
      translated: "drapelului landului Bavaria",
      tone: 'semantic',
    },
  ],
  "lid:state:BY:5|ru": [
    {
      german: "Welche Farben",
      translated: "Какие цвета",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "у",
      tone: 'semantic',
    },
    {
      german: "die Landesflagge von Bayern",
      translated: "флага земли Бавария",
      tone: 'semantic',
    },
  ],
  "lid:state:BY:5|sq": [
    {
      german: "Welche Farben",
      translated: "Cilat janë ngjyrat",
      tone: 'semantic',
    },
    {
      german: "die Landesflagge von Bayern",
      translated: "e flamurit të landit Bavaria?",
      tone: 'semantic',
    },
  ],
  "lid:state:BY:5|sr": [
    {
      german: "Welche Farben",
      translated: "Koje su",
      tone: 'semantic',
    },
    {
      german: "die Landesflagge von Bayern",
      translated: "zastave savezne pokrajine Bavarska?",
      tone: 'semantic',
    },
  ],
  "lid:state:BY:5|tr": [
    {
      german: "Welche Farben",
      translated: "renkleri nelerdir",
      tone: 'semantic',
    },
    {
      german: "die Landesflagge von Bayern",
      translated: "Bayern eyalet bayrağının",
      tone: 'semantic',
    },
  ],
  "lid:state:BY:5|uk": [
    {
      german: "Welche Farben",
      translated: "Які кольори",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: " має",
      tone: 'semantic',
    },
    {
      german: "die Landesflagge von Bayern",
      translated: "прапор федеральної землі Баварія",
      tone: 'semantic',
    },
  ],
  "lid:state:BY:5|vi": [
    {
      german: "Welche Farben",
      translated: "cờ bang",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "là",
      tone: 'semantic',
    },
    {
      german: "die Landesflagge von Bayern",
      translated: "gì",
      tone: 'semantic',
    },
  ],
  "lid:state:BY:6|ar": [
    {
      german: "Wo",
      translated: "أين",
      tone: 'semantic',
    },
    {
      german: "können",
      translated: "يمكنك",
      tone: 'semantic',
    },
    {
      german: "in Bayern",
      translated: "في Bayern",
      tone: 'semantic',
    },
    {
      german: "über politische Themen",
      translated: "عن القضايا السياسية",
      tone: 'semantic',
    },
    {
      german: "informieren",
      translated: "الحصول على معلومات",
      tone: 'semantic',
    },
  ],
  "lid:state:BY:6|bg": [
    {
      german: "Wo",
      translated: "Къде",
      tone: 'semantic',
    },
    {
      german: "können",
      translated: "можете",
      tone: 'semantic',
    },
    {
      german: "in Bayern",
      translated: "в Бавария",
      tone: 'semantic',
    },
    {
      german: "über politische Themen",
      translated: "по политически теми",
      tone: 'semantic',
    },
    {
      german: "informieren",
      translated: "да получите информация",
      tone: 'semantic',
    },
  ],
  "lid:state:BY:6|bs": [
    {
      german: "Wo",
      translated: "Gdje",
      tone: 'semantic',
    },
    {
      german: "können",
      translated: "mogu",
      tone: 'semantic',
    },
    {
      german: "sich",
      translated: "se",
      tone: 'semantic',
    },
    {
      german: "in Bayern",
      translated: "u saveznoj zemlji Bavarska",
      tone: 'semantic',
    },
    {
      german: "über politische Themen",
      translated: "o političkim temama",
      tone: 'semantic',
    },
    {
      german: "informieren",
      translated: "dobiti informacije",
      tone: 'semantic',
    },
  ],
  "lid:state:BY:6|el": [
    {
      german: "Wo",
      translated: "Πού",
      tone: 'semantic',
    },
    {
      german: "können",
      translated: "μπορείτε",
      tone: 'semantic',
    },
    {
      german: "sich",
      translated: "να",
      tone: 'semantic',
    },
    {
      german: "in Bayern",
      translated: "στο Βαυαρία",
      tone: 'semantic',
    },
    {
      german: "über politische Themen",
      translated: "για πολιτικά θέματα",
      tone: 'semantic',
    },
    {
      german: "informieren",
      translated: "ενημερωθείτε",
      tone: 'semantic',
    },
  ],
  "lid:state:BY:6|en": [
    {
      german: "Wo",
      translated: "Where",
      tone: 'semantic',
    },
    {
      german: "können",
      translated: "can",
      tone: 'semantic',
    },
    {
      german: "Sie",
      translated: "you",
      tone: 'semantic',
    },
    {
      german: "in Bayern",
      translated: "in Bayern",
      tone: 'semantic',
    },
    {
      german: "über politische Themen",
      translated: "about political topics",
      tone: 'semantic',
    },
    {
      german: "informieren",
      translated: "get information",
      tone: 'semantic',
    },
  ],
  "lid:state:BY:6|es": [
    {
      german: "Wo",
      translated: "¿Dónde",
      tone: 'semantic',
    },
    {
      german: "können",
      translated: "puede",
      tone: 'semantic',
    },
    {
      german: "in Bayern",
      translated: "en Baviera",
      tone: 'semantic',
    },
    {
      german: "über politische Themen",
      translated: "sobre temas políticos",
      tone: 'semantic',
    },
    {
      german: "informieren",
      translated: "informarse",
      tone: 'semantic',
    },
  ],
  "lid:state:BY:6|fa": [
    {
      german: "Wo",
      translated: "کجا",
      tone: 'semantic',
    },
    {
      german: "können",
      translated: "می‌توانید",
      tone: 'semantic',
    },
    {
      german: "in Bayern",
      translated: "در بایرن",
      tone: 'semantic',
    },
    {
      german: "über politische Themen",
      translated: "دربارهٔ موضوعات سیاسی",
      tone: 'semantic',
    },
    {
      german: "informieren",
      translated: "اطلاعات کسب کنید",
      tone: 'semantic',
    },
  ],
  "lid:state:BY:6|fr": [
    {
      german: "Wo",
      translated: "Où",
      tone: 'semantic',
    },
    {
      german: "können",
      translated: "pouvez-vous",
      tone: 'semantic',
    },
    {
      german: "sich",
      translated: "vous",
      tone: 'semantic',
    },
    {
      german: "in Bayern",
      translated: "en Bavière",
      tone: 'semantic',
    },
    {
      german: "über politische Themen",
      translated: "sur les questions politiques",
      tone: 'semantic',
    },
    {
      german: "informieren",
      translated: "informer",
      tone: 'semantic',
    },
  ],
  "lid:state:BY:6|hr": [
    {
      german: "Wo",
      translated: "Gdje",
      tone: 'semantic',
    },
    {
      german: "können",
      translated: "mogu",
      tone: 'semantic',
    },
    {
      german: "sich",
      translated: "se",
      tone: 'semantic',
    },
    {
      german: "in Bayern",
      translated: "u saveznoj zemlji Bavarska",
      tone: 'semantic',
    },
    {
      german: "über politische Themen",
      translated: "o političkim temama",
      tone: 'semantic',
    },
    {
      german: "informieren",
      translated: "dobiti informacije",
      tone: 'semantic',
    },
  ],
  "lid:state:BY:6|it": [
    {
      german: "Wo",
      translated: "Dove",
      tone: 'semantic',
    },
    {
      german: "können",
      translated: "può",
      tone: 'semantic',
    },
    {
      german: "sich",
      translated: "ci si",
      tone: 'semantic',
    },
    {
      german: "in Bayern",
      translated: "in Baviera",
      tone: 'semantic',
    },
    {
      german: "über politische Themen",
      translated: "su temi politici",
      tone: 'semantic',
    },
    {
      german: "informieren",
      translated: "informare",
      tone: 'semantic',
    },
  ],
  "lid:state:BY:6|kmr": [
    {
      german: "Wo",
      translated: "li ku",
      tone: 'semantic',
    },
    {
      german: "können",
      translated: "dikarî",
      tone: 'semantic',
    },
    {
      german: "in Bayern",
      translated: "Li Bayern",
      tone: 'semantic',
    },
    {
      german: "über politische Themen",
      translated: "li ser mijarên siyasî",
      tone: 'semantic',
    },
    {
      german: "informieren",
      translated: "agahdarî bistînî",
      tone: 'semantic',
    },
  ],
  "lid:state:BY:6|pl": [
    {
      german: "Wo",
      translated: "Gdzie",
      tone: 'semantic',
    },
    {
      german: "können",
      translated: "można",
      tone: 'semantic',
    },
    {
      german: "in Bayern",
      translated: "w Bawaria",
      tone: 'semantic',
    },
    {
      german: "über politische Themen",
      translated: "na tematy polityczne",
      tone: 'semantic',
    },
    {
      german: "informieren",
      translated: "uzyskać informacje",
      tone: 'semantic',
    },
  ],
  "lid:state:BY:6|prs": [
    {
      german: "Wo",
      translated: "کجا",
      tone: 'semantic',
    },
    {
      german: "können",
      translated: "می‌توانید",
      tone: 'semantic',
    },
    {
      german: "in Bayern",
      translated: "در بایرن",
      tone: 'semantic',
    },
    {
      german: "über politische Themen",
      translated: " دربارهٔ موضوعات سیاسی",
      tone: 'semantic',
    },
    {
      german: "informieren",
      translated: "اطلاعات کسب کنید",
      tone: 'semantic',
    },
  ],
  "lid:state:BY:6|ro": [
    {
      german: "Wo",
      translated: "Unde",
      tone: 'semantic',
    },
    {
      german: "können",
      translated: "puteți",
      tone: 'semantic',
    },
    {
      german: "Sie",
      translated: "vă",
      tone: 'semantic',
    },
    {
      german: "in Bayern",
      translated: "în Bavaria",
      tone: 'semantic',
    },
    {
      german: "über politische Themen",
      translated: "despre teme politice",
      tone: 'semantic',
    },
    {
      german: "informieren",
      translated: "informa",
      tone: 'semantic',
    },
  ],
  "lid:state:BY:6|ru": [
    {
      german: "Wo",
      translated: "Где",
      tone: 'semantic',
    },
    {
      german: "können",
      translated: "можно",
      tone: 'semantic',
    },
    {
      german: "in Bayern",
      translated: "в федеральной земле Бавария",
      tone: 'semantic',
    },
    {
      german: "über politische Themen",
      translated: "о политических темах",
      tone: 'semantic',
    },
    {
      german: "informieren",
      translated: "получить информацию",
      tone: 'semantic',
    },
  ],
  "lid:state:BY:6|sq": [
    {
      german: "Wo",
      translated: "Ku",
      tone: 'semantic',
    },
    {
      german: "können",
      translated: "mund",
      tone: 'semantic',
    },
    {
      german: "Sie",
      translated: "të",
      tone: 'semantic',
    },
    {
      german: "in Bayern",
      translated: "në Bavaria",
      tone: 'semantic',
    },
    {
      german: "über politische Themen",
      translated: "për tema politike",
      tone: 'semantic',
    },
    {
      german: "informieren",
      translated: "informoheni",
      tone: 'semantic',
    },
  ],
  "lid:state:BY:6|sr": [
    {
      german: "Wo",
      translated: "Gdje",
      tone: 'semantic',
    },
    {
      german: "können",
      translated: "se",
      tone: 'semantic',
    },
    {
      german: "sich",
      translated: "u",
      tone: 'semantic',
    },
    {
      german: "in Bayern",
      translated: "pokrajini Bavarska",
      tone: 'semantic',
    },
    {
      german: "über politische Themen",
      translated: "o političkim temama",
      tone: 'semantic',
    },
    {
      german: "informieren",
      translated: "dobiti",
      tone: 'semantic',
    },
  ],
  "lid:state:BY:6|tr": [
    {
      german: "Wo",
      translated: "nereden",
      tone: 'semantic',
    },
    {
      german: "können",
      translated: "alabilirsiniz",
      tone: 'semantic',
    },
    {
      german: "in Bayern",
      translated: "Bayern eyaletinde",
      tone: 'semantic',
    },
    {
      german: "über politische Themen",
      translated: "siyasi konular hakkında",
      tone: 'semantic',
    },
    {
      german: "informieren",
      translated: "bilgi",
      tone: 'semantic',
    },
  ],
  "lid:state:BY:6|uk": [
    {
      german: "Wo",
      translated: "Де",
      tone: 'semantic',
    },
    {
      german: "können",
      translated: "можна",
      tone: 'semantic',
    },
    {
      german: "sich",
      translated: "в",
      tone: 'semantic',
    },
    {
      german: "in Bayern",
      translated: "Баварія",
      tone: 'semantic',
    },
    {
      german: "über politische Themen",
      translated: "про політичні питання",
      tone: 'semantic',
    },
    {
      german: "informieren",
      translated: "отримати інформацію",
      tone: 'semantic',
    },
  ],
  "lid:state:BY:6|vi": [
    {
      german: "Wo",
      translated: "ở đâu",
      tone: 'semantic',
    },
    {
      german: "können",
      translated: "có thể",
      tone: 'semantic',
    },
    {
      german: "in Bayern",
      translated: "Ở bang Bayern",
      tone: 'semantic',
    },
    {
      german: "über politische Themen",
      translated: "về các chủ đề chính trị",
      tone: 'semantic',
    },
    {
      german: "informieren",
      translated: "tìm thông tin",
      tone: 'semantic',
    },
  ],
  "lid:state:BY:7|ar": [
    {
      german: "Die Landeshauptstadt",
      translated: "ما عاصمة",
      tone: 'semantic',
    },
    {
      german: "von Bayern",
      translated: "Bayern",
      tone: 'semantic',
    },
    {
      german: "heißt",
      translated: "؟",
      tone: 'semantic',
    },
  ],
  "lid:state:BY:7|bg": [
    {
      german: "Die Landeshauptstadt",
      translated: "Столицата на федералната провинция",
      tone: 'semantic',
    },
    {
      german: "von Bayern",
      translated: "Бавария",
      tone: 'semantic',
    },
    {
      german: "heißt",
      translated: "е …",
      tone: 'semantic',
    },
  ],
  "lid:state:BY:7|bs": [
    {
      german: "Die Landeshauptstadt",
      translated: "Glavni grad",
      tone: 'semantic',
    },
    {
      german: "von Bayern",
      translated: "Bavarska",
      tone: 'semantic',
    },
    {
      german: "heißt",
      translated: "je",
      tone: 'semantic',
    },
  ],
  "lid:state:BY:7|el": [
    {
      german: "Die Landeshauptstadt",
      translated: "Η πρωτεύουσα του ομόσπονδου κρατιδίου",
      tone: 'semantic',
    },
    {
      german: "von Bayern",
      translated: "Βαυαρία",
      tone: 'semantic',
    },
    {
      german: "heißt",
      translated: "είναι …",
      tone: 'semantic',
    },
  ],
  "lid:state:BY:7|en": [
    {
      german: "Die Landeshauptstadt",
      translated: "The state capital",
      tone: 'semantic',
    },
    {
      german: "von Bayern",
      translated: "of Bayern",
      tone: 'semantic',
    },
    {
      german: "heißt",
      translated: "is called",
      tone: 'semantic',
    },
  ],
  "lid:state:BY:7|es": [
    {
      german: "Die Landeshauptstadt",
      translated: "La capital del estado federado",
      tone: 'semantic',
    },
    {
      german: "von Bayern",
      translated: "de Baviera",
      tone: 'semantic',
    },
    {
      german: "heißt",
      translated: "es …",
      tone: 'semantic',
    },
  ],
  "lid:state:BY:7|fa": [
    {
      german: "Die Landeshauptstadt",
      translated: "مرکز ایالت",
      tone: 'semantic',
    },
    {
      german: "von Bayern",
      translated: "بایرن",
      tone: 'semantic',
    },
    {
      german: "heißt",
      translated: "است.",
      tone: 'semantic',
    },
  ],
  "lid:state:BY:7|fr": [
    {
      german: "Die Landeshauptstadt",
      translated: "La capitale",
      tone: 'semantic',
    },
    {
      german: "von Bayern",
      translated: "du Land de Bavière",
      tone: 'semantic',
    },
    {
      german: "heißt",
      translated: "s’appelle",
      tone: 'semantic',
    },
  ],
  "lid:state:BY:7|hr": [
    {
      german: "Die Landeshauptstadt",
      translated: "Glavni grad",
      tone: 'semantic',
    },
    {
      german: "von Bayern",
      translated: "Bavarska",
      tone: 'semantic',
    },
    {
      german: "heißt",
      translated: "je",
      tone: 'semantic',
    },
  ],
  "lid:state:BY:7|it": [
    {
      german: "Die Landeshauptstadt",
      translated: "La capitale del Land",
      tone: 'semantic',
    },
    {
      german: "von Bayern",
      translated: "di Baviera",
      tone: 'semantic',
    },
    {
      german: "heißt",
      translated: "è",
      tone: 'semantic',
    },
  ],
  "lid:state:BY:7|kmr": [
    {
      german: "Die Landeshauptstadt",
      translated: "Paytexta eyaleta",
      tone: 'semantic',
    },
    {
      german: "von Bayern",
      translated: "Bayern",
      tone: 'semantic',
    },
  ],
  "lid:state:BY:7|pl": [
    {
      german: "Die Landeshauptstadt",
      translated: "Stolicą kraju związkowego",
      tone: 'semantic',
    },
    {
      german: "von Bayern",
      translated: "Bawaria",
      tone: 'semantic',
    },
    {
      german: "heißt",
      translated: "jest",
      tone: 'semantic',
    },
  ],
  "lid:state:BY:7|prs": [
    {
      german: "Die Landeshauptstadt",
      translated: "مرکز ایالت",
      tone: 'semantic',
    },
    {
      german: "von Bayern",
      translated: "بایرن",
      tone: 'semantic',
    },
    {
      german: "heißt",
      translated: "است.",
      tone: 'semantic',
    },
  ],
  "lid:state:BY:7|ro": [
    {
      german: "Die Landeshauptstadt",
      translated: "Capitala",
      tone: 'semantic',
    },
    {
      german: "von Bayern",
      translated: "Bavaria",
      tone: 'semantic',
    },
    {
      german: "heißt",
      translated: "este",
      tone: 'semantic',
    },
  ],
  "lid:state:BY:7|ru": [
    {
      german: "Die Landeshauptstadt",
      translated: "Столица земли",
      tone: 'semantic',
    },
    {
      german: "von Bayern",
      translated: "Бавария",
      tone: 'semantic',
    },
    {
      german: "heißt",
      translated: "называется",
      tone: 'semantic',
    },
  ],
  "lid:state:BY:7|sq": [
    {
      german: "Die Landeshauptstadt",
      translated: "Kryeqyteti i landit",
      tone: 'semantic',
    },
    {
      german: "von Bayern",
      translated: "Bavaria",
      tone: 'semantic',
    },
    {
      german: "heißt",
      translated: "është",
      tone: 'semantic',
    },
  ],
  "lid:state:BY:7|sr": [
    {
      german: "Die Landeshauptstadt",
      translated: "Glavni grad",
      tone: 'semantic',
    },
    {
      german: "von Bayern",
      translated: "savezne pokrajine Bavarska",
      tone: 'semantic',
    },
    {
      german: "heißt",
      translated: "je",
      tone: 'semantic',
    },
  ],
  "lid:state:BY:7|tr": [
    {
      german: "Die Landeshauptstadt",
      translated: "başkenti",
      tone: 'semantic',
    },
    {
      german: "von Bayern",
      translated: "Bayern eyaletinin",
      tone: 'semantic',
    },
  ],
  "lid:state:BY:7|uk": [
    {
      german: "Die Landeshauptstadt",
      translated: "Столиця федеральної землі",
      tone: 'semantic',
    },
    {
      german: "von Bayern",
      translated: "Баварія",
      tone: 'semantic',
    },
    {
      german: "heißt",
      translated: "називається",
      tone: 'semantic',
    },
  ],
  "lid:state:BY:7|vi": [
    {
      german: "Die Landeshauptstadt",
      translated: "Thủ phủ",
      tone: 'semantic',
    },
    {
      german: "von Bayern",
      translated: "của bang Bayern",
      tone: 'semantic',
    },
    {
      german: "heißt",
      translated: "là",
      tone: 'semantic',
    },
  ],
  "lid:state:BY:8|ar": [
    {
      german: "Welches",
      translated: "أي",
      tone: 'semantic',
    },
    {
      german: "Bundesland",
      translated: "ولاية",
      tone: 'semantic',
    },
    {
      german: "Bayern",
      translated: "Bayern",
      tone: 'semantic',
    },
  ],
  "lid:state:BY:8|bg": [
    {
      german: "Welches",
      translated: "Коя",
      tone: 'semantic',
    },
    {
      german: "Bundesland",
      translated: "от показаните федерални провинции",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "е",
      tone: 'semantic',
    },
    {
      german: "Bayern",
      translated: "Бавария",
      tone: 'semantic',
    },
  ],
  "lid:state:BY:8|bs": [
    {
      german: "Welches",
      translated: "Koja",
      tone: 'semantic',
    },
    {
      german: "Bundesland",
      translated: "prikazanih saveznih zemalja",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "je",
      tone: 'semantic',
    },
    {
      german: "Bayern",
      translated: "Bavarska",
      tone: 'semantic',
    },
  ],
  "lid:state:BY:8|el": [
    {
      german: "Welches",
      translated: "Ποιο",
      tone: 'semantic',
    },
    {
      german: "Bundesland",
      translated: "κρατίδια",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "είναι",
      tone: 'semantic',
    },
    {
      german: "Bayern",
      translated: "Βαυαρία",
      tone: 'semantic',
    },
  ],
  "lid:state:BY:8|en": [
    {
      german: "Welches",
      translated: "Which",
      tone: 'semantic',
    },
    {
      german: "Bundesland",
      translated: "federal state",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "is",
      tone: 'semantic',
    },
    {
      german: "Bayern",
      translated: "Bayern",
      tone: 'semantic',
    },
  ],
  "lid:state:BY:8|es": [
    {
      german: "Welches",
      translated: "¿Cuál",
      tone: 'semantic',
    },
    {
      german: "Bundesland",
      translated: "estado federado",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "corresponde",
      tone: 'semantic',
    },
    {
      german: "Bayern",
      translated: "Baviera",
      tone: 'semantic',
    },
  ],
  "lid:state:BY:8|fa": [
    {
      german: "Welches",
      translated: "کدام",
      tone: 'semantic',
    },
    {
      german: "Bundesland",
      translated: "ایالتِ نشان‌داده‌شده",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "است",
      tone: 'semantic',
    },
    {
      german: "Bayern",
      translated: "بایرن",
      tone: 'semantic',
    },
  ],
  "lid:state:BY:8|fr": [
    {
      german: "Welches",
      translated: "Quel",
      tone: 'semantic',
    },
    {
      german: "Bundesland",
      translated: "Land",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "représenté",
      tone: 'semantic',
    },
    {
      german: "Bayern",
      translated: "Bavière",
      tone: 'semantic',
    },
  ],
  "lid:state:BY:8|hr": [
    {
      german: "Welches",
      translated: "Koja",
      tone: 'semantic',
    },
    {
      german: "Bundesland",
      translated: "prikazanih saveznih zemalja",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "je",
      tone: 'semantic',
    },
    {
      german: "Bayern",
      translated: "Bavarska",
      tone: 'semantic',
    },
  ],
  "lid:state:BY:8|it": [
    {
      german: "Welches",
      translated: "Quale",
      tone: 'semantic',
    },
    {
      german: "Bundesland",
      translated: "Land rappresentato",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "è",
      tone: 'semantic',
    },
    {
      german: "Bayern",
      translated: "Baviera",
      tone: 'semantic',
    },
  ],
  "lid:state:BY:8|kmr": [
    {
      german: "Welches",
      translated: "Kîjan",
      tone: 'semantic',
    },
    {
      german: "Bundesland",
      translated: "eyalet",
      tone: 'semantic',
    },
    {
      german: "Bayern",
      translated: "Bayern",
      tone: 'semantic',
    },
  ],
  "lid:state:BY:8|pl": [
    {
      german: "Welches",
      translated: "Który",
      tone: 'semantic',
    },
    {
      german: "Bundesland",
      translated: "przedstawionych krajów związkowych",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "to",
      tone: 'semantic',
    },
    {
      german: "Bayern",
      translated: "Bawaria",
      tone: 'semantic',
    },
  ],
  "lid:state:BY:8|prs": [
    {
      german: "Welches",
      translated: "کدام",
      tone: 'semantic',
    },
    {
      german: "Bundesland",
      translated: "ایالتِ",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "است؟",
      tone: 'semantic',
    },
    {
      german: "Bayern",
      translated: "بایرن",
      tone: 'semantic',
    },
  ],
  "lid:state:BY:8|ro": [
    {
      german: "Welches",
      translated: "Care",
      tone: 'semantic',
    },
    {
      german: "Bundesland",
      translated: "land reprezentat",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "este",
      tone: 'semantic',
    },
    {
      german: "Bayern",
      translated: "Bavaria",
      tone: 'semantic',
    },
  ],
  "lid:state:BY:8|ru": [
    {
      german: "Welches",
      translated: "Какая",
      tone: 'semantic',
    },
    {
      german: "Bundesland",
      translated: "земель",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: " — ",
      tone: 'semantic',
    },
    {
      german: "Bayern",
      translated: "Бавария",
      tone: 'semantic',
    },
  ],
  "lid:state:BY:8|sq": [
    {
      german: "Welches",
      translated: "Cili",
      tone: 'semantic',
    },
    {
      german: "Bundesland",
      translated: "landet",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "është",
      tone: 'semantic',
    },
    {
      german: "Bayern",
      translated: "Bavaria",
      tone: 'semantic',
    },
  ],
  "lid:state:BY:8|sr": [
    {
      german: "Welches",
      translated: "Koja",
      tone: 'semantic',
    },
    {
      german: "Bayern",
      translated: "Bavarska",
      tone: 'semantic',
    },
  ],
  "lid:state:BY:8|tr": [
    {
      german: "Welches",
      translated: "hangi numarayla",
      tone: 'semantic',
    },
    {
      german: "Bundesland",
      translated: "eyaleti",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "gösterilmiştir",
      tone: 'semantic',
    },
    {
      german: "Bayern",
      translated: "Bayern",
      tone: 'semantic',
    },
  ],
  "lid:state:BY:8|uk": [
    {
      german: "Welches",
      translated: "Яка",
      tone: 'semantic',
    },
    {
      german: "Bundesland",
      translated: "федеральних земель",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "є",
      tone: 'semantic',
    },
    {
      german: "Bayern",
      translated: "Баварія",
      tone: 'semantic',
    },
  ],
  "lid:state:BY:8|vi": [
    {
      german: "Welches",
      translated: "nào",
      tone: 'semantic',
    },
    {
      german: "Bundesland",
      translated: "Bang",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "được hiển thị là",
      tone: 'semantic',
    },
    {
      german: "Bayern",
      translated: "Bayern",
      tone: 'semantic',
    },
  ],
  "lid:state:BY:9|ar": [
    {
      german: "die Regierungschefin/den Regierungschef",
      translated: "رئيس/رئيسة حكومة",
      tone: 'semantic',
    },
    {
      german: "in Bayern",
      translated: "ولاية Bayern؟",
      tone: 'semantic',
    },
  ],
  "lid:state:BY:9|bg": [
    {
      german: "Wie",
      translated: "Как",
      tone: 'semantic',
    },
    {
      german: "nennt",
      translated: "се нарича",
      tone: 'semantic',
    },
    {
      german: "die Regierungschefin/den Regierungschef",
      translated: "ръководителят на правителството",
      tone: 'semantic',
    },
    {
      german: "in Bayern",
      translated: "на провинция Бавария",
      tone: 'semantic',
    },
  ],
  "lid:state:BY:9|bs": [
    {
      german: "Wie",
      translated: "Kako",
      tone: 'semantic',
    },
    {
      german: "nennt",
      translated: "zove",
      tone: 'semantic',
    },
    {
      german: "man",
      translated: "se",
      tone: 'semantic',
    },
    {
      german: "die Regierungschefin/den Regierungschef",
      translated: "šef vlade",
      tone: 'semantic',
    },
    {
      german: "in Bayern",
      translated: "savezne zemlje Bavarska",
      tone: 'semantic',
    },
  ],
  "lid:state:BY:9|el": [
    {
      german: "Wie",
      translated: "Πώς",
      tone: 'semantic',
    },
    {
      german: "nennt",
      translated: "ονομάζεται",
      tone: 'semantic',
    },
    {
      german: "die Regierungschefin/den Regierungschef",
      translated: "ο επικεφαλής της κυβέρνησης",
      tone: 'semantic',
    },
    {
      german: "in Bayern",
      translated: "του κρατιδίου Βαυαρία",
      tone: 'semantic',
    },
  ],
  "lid:state:BY:9|en": [
    {
      german: "Wie",
      translated: "What",
      tone: 'semantic',
    },
    {
      german: "nennt",
      translated: "called",
      tone: 'semantic',
    },
    {
      german: "die Regierungschefin/den Regierungschef",
      translated: "the head of government",
      tone: 'semantic',
    },
    {
      german: "in Bayern",
      translated: "in Bayern",
      tone: 'semantic',
    },
  ],
  "lid:state:BY:9|es": [
    {
      german: "Wie",
      translated: "¿Cómo",
      tone: 'semantic',
    },
    {
      german: "nennt",
      translated: "se llama",
      tone: 'semantic',
    },
    {
      german: "man",
      translated: "al",
      tone: 'semantic',
    },
    {
      german: "die Regierungschefin/den Regierungschef",
      translated: "jefe o la jefa de gobierno",
      tone: 'semantic',
    },
    {
      german: "in Bayern",
      translated: "de Baviera",
      tone: 'semantic',
    },
  ],
  "lid:state:BY:9|fa": [
    {
      german: "Wie",
      translated: "چه",
      tone: 'semantic',
    },
    {
      german: "nennt",
      translated: "عنوانی",
      tone: 'semantic',
    },
    {
      german: "man",
      translated: "دارد",
      tone: 'semantic',
    },
    {
      german: "die Regierungschefin/den Regierungschef",
      translated: "رئیس دولت",
      tone: 'semantic',
    },
    {
      german: "in Bayern",
      translated: "ایالت بایرن",
      tone: 'semantic',
    },
  ],
  "lid:state:BY:9|fr": [
    {
      german: "Wie",
      translated: "Comment",
      tone: 'semantic',
    },
    {
      german: "nennt",
      translated: "appelle-t-on",
      tone: 'semantic',
    },
    {
      german: "die Regierungschefin/den Regierungschef",
      translated: "le chef ou la cheffe du gouvernement",
      tone: 'semantic',
    },
    {
      german: "in Bayern",
      translated: "de Bavière",
      tone: 'semantic',
    },
  ],
  "lid:state:BY:9|hr": [
    {
      german: "Wie",
      translated: "Kako",
      tone: 'semantic',
    },
    {
      german: "nennt",
      translated: "zove",
      tone: 'semantic',
    },
    {
      german: "man",
      translated: "se",
      tone: 'semantic',
    },
    {
      german: "die Regierungschefin/den Regierungschef",
      translated: "čelnik vlade",
      tone: 'semantic',
    },
    {
      german: "in Bayern",
      translated: "savezne zemlje Bavarska",
      tone: 'semantic',
    },
  ],
  "lid:state:BY:9|it": [
    {
      german: "Wie",
      translated: "Come",
      tone: 'semantic',
    },
    {
      german: "nennt",
      translated: "si chiama",
      tone: 'semantic',
    },
    {
      german: "die Regierungschefin/den Regierungschef",
      translated: "il capo del governo",
      tone: 'semantic',
    },
    {
      german: "in Bayern",
      translated: "del Land di Baviera",
      tone: 'semantic',
    },
  ],
  "lid:state:BY:9|kmr": [
    {
      german: "Wie",
      translated: "çi",
      tone: 'semantic',
    },
    {
      german: "nennt",
      translated: "tê gotin",
      tone: 'semantic',
    },
    {
      german: "die Regierungschefin/den Regierungschef",
      translated: "Serokê hukûmeta",
      tone: 'semantic',
    },
    {
      german: "in Bayern",
      translated: "Bayern",
      tone: 'semantic',
    },
  ],
  "lid:state:BY:9|pl": [
    {
      german: "Wie",
      translated: "Jak",
      tone: 'semantic',
    },
    {
      german: "nennt",
      translated: "nazywa",
      tone: 'semantic',
    },
    {
      german: "man",
      translated: "się",
      tone: 'semantic',
    },
    {
      german: "die Regierungschefin/den Regierungschef",
      translated: "szef rządu",
      tone: 'semantic',
    },
    {
      german: "in Bayern",
      translated: "kraju związkowego Bawaria",
      tone: 'semantic',
    },
  ],
  "lid:state:BY:9|prs": [
    {
      german: "Wie",
      translated: "چه",
      tone: 'semantic',
    },
    {
      german: "nennt",
      translated: "عنوانی دارد",
      tone: 'semantic',
    },
    {
      german: "die Regierungschefin/den Regierungschef",
      translated: "رئیس دولت",
      tone: 'semantic',
    },
    {
      german: "in Bayern",
      translated: "ایالت بایرن",
      tone: 'semantic',
    },
  ],
  "lid:state:BY:9|ro": [
    {
      german: "Wie",
      translated: "Cum",
      tone: 'semantic',
    },
    {
      german: "nennt",
      translated: "se numește",
      tone: 'semantic',
    },
    {
      german: "die Regierungschefin/den Regierungschef",
      translated: "șeful guvernului",
      tone: 'semantic',
    },
    {
      german: "in Bayern",
      translated: "landului Bavaria",
      tone: 'semantic',
    },
  ],
  "lid:state:BY:9|ru": [
    {
      german: "Wie",
      translated: "Как",
      tone: 'semantic',
    },
    {
      german: "nennt",
      translated: "называют",
      tone: 'semantic',
    },
    {
      german: "die Regierungschefin/den Regierungschef",
      translated: "главу правительства",
      tone: 'semantic',
    },
    {
      german: "in Bayern",
      translated: "в федеральной земле Бавария",
      tone: 'semantic',
    },
  ],
  "lid:state:BY:9|sq": [
    {
      german: "Wie",
      translated: "Si",
      tone: 'semantic',
    },
    {
      german: "nennt",
      translated: "quhet",
      tone: 'semantic',
    },
    {
      german: "die Regierungschefin/den Regierungschef",
      translated: "kreu i qeverisë",
      tone: 'semantic',
    },
    {
      german: "in Bayern",
      translated: "së landit Bavaria?",
      tone: 'semantic',
    },
  ],
  "lid:state:BY:9|sr": [
    {
      german: "Wie",
      translated: "Kako",
      tone: 'semantic',
    },
    {
      german: "nennt",
      translated: "zove",
      tone: 'semantic',
    },
    {
      german: "man",
      translated: "se",
      tone: 'semantic',
    },
    {
      german: "die Regierungschefin/den Regierungschef",
      translated: "šef vlade",
      tone: 'semantic',
    },
    {
      german: "in Bayern",
      translated: "savezne pokrajine Bavarska",
      tone: 'semantic',
    },
  ],
  "lid:state:BY:9|tr": [
    {
      german: "Wie",
      translated: "ne",
      tone: 'semantic',
    },
    {
      german: "nennt",
      translated: "ad",
      tone: 'semantic',
    },
    {
      german: "man",
      translated: "verilir",
      tone: 'semantic',
    },
    {
      german: "die Regierungschefin/den Regierungschef",
      translated: "başındaki kişiye",
      tone: 'semantic',
    },
    {
      german: "in Bayern",
      translated: "Bayern hükümetinin",
      tone: 'semantic',
    },
  ],
  "lid:state:BY:9|uk": [
    {
      german: "Wie",
      translated: "Як",
      tone: 'semantic',
    },
    {
      german: "nennt",
      translated: " називають",
      tone: 'semantic',
    },
    {
      german: "die Regierungschefin/den Regierungschef",
      translated: "главу уряду",
      tone: 'semantic',
    },
    {
      german: "in Bayern",
      translated: "в Баварія",
      tone: 'semantic',
    },
  ],
  "lid:state:BY:9|vi": [
    {
      german: "Wie",
      translated: "gì",
      tone: 'semantic',
    },
    {
      german: "nennt",
      translated: "được gọi là",
      tone: 'semantic',
    },
    {
      german: "die Regierungschefin/den Regierungschef",
      translated: "Người đứng đầu chính phủ",
      tone: 'semantic',
    },
    {
      german: "in Bayern",
      translated: "bang Bayern",
      tone: 'semantic',
    },
  ],
  "lid:state:HB:10|ar": [
    {
      german: "Welche Senatorin",
      translated: "أي منصب",
      tone: 'semantic',
    },
    {
      german: "welchen Senator",
      translated: "أعضاء مجلس الشيوخ",
      tone: 'semantic',
    },
    {
      german: "Bremen",
      translated: "Bremen",
      tone: 'semantic',
    },
    {
      german: "nicht",
      translated: "غير موجود",
      tone: 'semantic',
    },
  ],
  "lid:state:HB:10|bg": [
    {
      german: "welchen Senator",
      translated: "сенаторска длъжност",
      tone: 'semantic',
    },
    {
      german: "Bremen",
      translated: "Бремен",
      tone: 'semantic',
    },
    {
      german: "nicht",
      translated: "не съществува",
      tone: 'semantic',
    },
  ],
  "lid:state:HB:10|bs": [
    {
      german: "Welche Senatorin",
      translated: "Koja",
      tone: 'semantic',
    },
    {
      german: "welchen Senator",
      translated: "senatorska funkcija",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "postoji",
      tone: 'semantic',
    },
    {
      german: "Bremen",
      translated: "u Bremenu",
      tone: 'semantic',
    },
    {
      german: "nicht",
      translated: "ne",
      tone: 'semantic',
    },
  ],
  "lid:state:HB:10|el": [
    {
      german: "Welche Senatorin",
      translated: "Ποια",
      tone: 'semantic',
    },
    {
      german: "welchen Senator",
      translated: "θέση γερουσιαστή",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "υπάρχει",
      tone: 'semantic',
    },
    {
      german: "Bremen",
      translated: "Βρέμη",
      tone: 'semantic',
    },
    {
      german: "nicht",
      translated: "δεν",
      tone: 'semantic',
    },
  ],
  "lid:state:HB:10|en": [
    {
      german: "Welche Senatorin",
      translated: "Which senator",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "does",
      tone: 'semantic',
    },
    {
      german: "Bremen",
      translated: "Bremen",
      tone: 'semantic',
    },
    {
      german: "nicht",
      translated: "not",
      tone: 'semantic',
    },
  ],
  "lid:state:HB:10|es": [
    {
      german: "Welche Senatorin",
      translated: "senadora",
      tone: 'semantic',
    },
    {
      german: "welchen Senator",
      translated: "senador",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "existe",
      tone: 'semantic',
    },
    {
      german: "Bremen",
      translated: "en Bremen",
      tone: 'semantic',
    },
    {
      german: "nicht",
      translated: "NO",
      tone: 'semantic',
    },
  ],
  "lid:state:HB:10|fa": [
    {
      german: "Welche Senatorin",
      translated: "کدام",
      tone: 'semantic',
    },
    {
      german: "welchen Senator",
      translated: "مقام سناتوری",
      tone: 'semantic',
    },
    {
      german: "Bremen",
      translated: "برمن",
      tone: 'semantic',
    },
    {
      german: "nicht",
      translated: "وجود ندارد",
      tone: 'semantic',
    },
  ],
  "lid:state:HB:10|fr": [
    {
      german: "Welche Senatorin",
      translated: "quelle sénatrice",
      tone: 'semantic',
    },
    {
      german: "welchen Senator",
      translated: "Quel sénateur",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "existe",
      tone: 'semantic',
    },
    {
      german: "Bremen",
      translated: "Brême",
      tone: 'semantic',
    },
    {
      german: "nicht",
      translated: "pas",
      tone: 'semantic',
    },
  ],
  "lid:state:HB:10|hr": [
    {
      german: "Welche Senatorin",
      translated: "Koja",
      tone: 'semantic',
    },
    {
      german: "welchen Senator",
      translated: "senatorska funkcija",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "postoji",
      tone: 'semantic',
    },
    {
      german: "Bremen",
      translated: "u Bremenu",
      tone: 'semantic',
    },
    {
      german: "nicht",
      translated: "ne",
      tone: 'semantic',
    },
  ],
  "lid:state:HB:10|it": [
    {
      german: "Welche Senatorin",
      translated: "Quale carica di senatore",
      tone: 'semantic',
    },
    {
      german: "Bremen",
      translated: "Brema",
      tone: 'semantic',
    },
    {
      german: "nicht",
      translated: "non esiste",
      tone: 'semantic',
    },
  ],
  "lid:state:HB:10|kmr": [
    {
      german: "Welche Senatorin",
      translated: "Kîjan",
      tone: 'semantic',
    },
    {
      german: "welchen Senator",
      translated: "senator",
      tone: 'semantic',
    },
    {
      german: "Bremen",
      translated: "Bremen",
      tone: 'semantic',
    },
    {
      german: "nicht",
      translated: "tune ye",
      tone: 'semantic',
    },
  ],
  "lid:state:HB:10|pl": [
    {
      german: "Welche Senatorin",
      translated: "Które stanowisko senatorskie",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "istnieje",
      tone: 'semantic',
    },
    {
      german: "Bremen",
      translated: "Brema",
      tone: 'semantic',
    },
    {
      german: "nicht",
      translated: "nie",
      tone: 'semantic',
    },
  ],
  "lid:state:HB:10|prs": [
    {
      german: "Welche Senatorin",
      translated: "کدام مقام",
      tone: 'semantic',
    },
    {
      german: "welchen Senator",
      translated: "سناتوری",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "وجود",
      tone: 'semantic',
    },
    {
      german: "Bremen",
      translated: "برمن",
      tone: 'semantic',
    },
    {
      german: "nicht",
      translated: "ندارد",
      tone: 'semantic',
    },
  ],
  "lid:state:HB:10|ro": [
    {
      german: "Welche Senatorin",
      translated: "Ce funcție de senator",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "există",
      tone: 'semantic',
    },
    {
      german: "Bremen",
      translated: "Bremen",
      tone: 'semantic',
    },
    {
      german: "nicht",
      translated: "nu",
      tone: 'semantic',
    },
  ],
  "lid:state:HB:10|ru": [
    {
      german: "welchen Senator",
      translated: "Какого сенатора",
      tone: 'semantic',
    },
    {
      german: "Bremen",
      translated: "Бремене",
      tone: 'semantic',
    },
    {
      german: "nicht",
      translated: "нет",
      tone: 'semantic',
    },
  ],
  "lid:state:HB:10|sq": [
    {
      german: "Welche Senatorin",
      translated: "Cila",
      tone: 'semantic',
    },
    {
      german: "welchen Senator",
      translated: "senatori",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "ekziston",
      tone: 'semantic',
    },
    {
      german: "Bremen",
      translated: "në Bremeni",
      tone: 'semantic',
    },
    {
      german: "nicht",
      translated: "nuk",
      tone: 'semantic',
    },
  ],
  "lid:state:HB:10|sr": [
    {
      german: "Welche Senatorin",
      translated: "Koja",
      tone: 'semantic',
    },
    {
      german: "welchen Senator",
      translated: "senatorska funkcija",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "postoji",
      tone: 'semantic',
    },
    {
      german: "Bremen",
      translated: "u Bremenu",
      tone: 'semantic',
    },
    {
      german: "nicht",
      translated: "ne",
      tone: 'semantic',
    },
  ],
  "lid:state:HB:10|tr": [
    {
      german: "Welche Senatorin",
      translated: "aşağıdaki senatörlüklerden hangisi",
      tone: 'semantic',
    },
    {
      german: "Bremen",
      translated: "Bremen şehir devletinde",
      tone: 'semantic',
    },
    {
      german: "nicht",
      translated: "yoktur",
      tone: 'semantic',
    },
  ],
  "lid:state:HB:10|uk": [
    {
      german: "Welche Senatorin",
      translated: "Якого сенатора/сенаторки",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "немає",
      tone: 'semantic',
    },
    {
      german: "Bremen",
      translated: "в Бремені",
      tone: 'semantic',
    },
  ],
  "lid:state:HB:10|vi": [
    {
      german: "welchen Senator",
      translated: "Chức vụ thượng nghị sĩ",
      tone: 'semantic',
    },
    {
      german: "Bremen",
      translated: "Bremen",
      tone: 'semantic',
    },
    {
      german: "nicht",
      translated: "không",
      tone: 'semantic',
    },
  ],
  "lid:state:HB:1|ar": [
    {
      german: "Welches Wappen",
      translated: "أي شعار",
      tone: 'semantic',
    },
    {
      german: "gehört zur",
      translated: "يعود إلى",
      tone: 'semantic',
    },
    {
      german: "Freien Hansestadt Bremen",
      translated: "ولاية Bremen",
      tone: 'semantic',
    },
  ],
  "lid:state:HB:1|bg": [
    {
      german: "Welches Wappen",
      translated: "Кой герб",
      tone: 'semantic',
    },
    {
      german: "gehört zur",
      translated: "принадлежи",
      tone: 'semantic',
    },
    {
      german: "Freien Hansestadt Bremen",
      translated: "Свободния ханзейски град Бремен",
      tone: 'semantic',
    },
  ],
  "lid:state:HB:1|bs": [
    {
      german: "Welches Wappen",
      translated: "Koji grb",
      tone: 'semantic',
    },
    {
      german: "gehört zur",
      translated: "pripada",
      tone: 'semantic',
    },
    {
      german: "Freien Hansestadt Bremen",
      translated: "Slobodnom hanzeatskom gradu Bremenu",
      tone: 'semantic',
    },
  ],
  "lid:state:HB:1|el": [
    {
      german: "Welches Wappen",
      translated: "Ποιο έμβλημα",
      tone: 'semantic',
    },
    {
      german: "gehört zur",
      translated: "ανήκει στην",
      tone: 'semantic',
    },
    {
      german: "Freien Hansestadt Bremen",
      translated: "Ελεύθερη Χανσεατική Πόλη της Βρέμης",
      tone: 'semantic',
    },
  ],
  "lid:state:HB:1|en": [
    {
      german: "Welches Wappen",
      translated: "Which coat of arms",
      tone: 'semantic',
    },
    {
      german: "gehört zur",
      translated: "belongs to",
      tone: 'semantic',
    },
    {
      german: "Freien Hansestadt Bremen",
      translated: "the Free Hanseatic City of Bremen",
      tone: 'semantic',
    },
  ],
  "lid:state:HB:1|es": [
    {
      german: "Welches Wappen",
      translated: "¿Qué escudo",
      tone: 'semantic',
    },
    {
      german: "gehört zur",
      translated: "pertenece a la",
      tone: 'semantic',
    },
    {
      german: "Freien Hansestadt Bremen",
      translated: "Ciudad Hanseática Libre de Bremen",
      tone: 'semantic',
    },
  ],
  "lid:state:HB:1|fa": [
    {
      german: "Welches Wappen",
      translated: "کدام نشان",
      tone: 'semantic',
    },
    {
      german: "gehört zur",
      translated: "متعلق به",
      tone: 'semantic',
    },
    {
      german: "Freien Hansestadt Bremen",
      translated: "ایالت برمن",
      tone: 'semantic',
    },
  ],
  "lid:state:HB:1|fr": [
    {
      german: "Welches Wappen",
      translated: "Quel blason",
      tone: 'semantic',
    },
    {
      german: "gehört zur",
      translated: "appartient à",
      tone: 'semantic',
    },
    {
      german: "Freien Hansestadt Bremen",
      translated: "Ville libre hanséatique de Brême",
      tone: 'semantic',
    },
  ],
  "lid:state:HB:1|hr": [
    {
      german: "Welches Wappen",
      translated: "Koji grb",
      tone: 'semantic',
    },
    {
      german: "gehört zur",
      translated: "pripada",
      tone: 'semantic',
    },
    {
      german: "Freien Hansestadt Bremen",
      translated: "Slobodnom hanzeatskom gradu Bremenu",
      tone: 'semantic',
    },
  ],
  "lid:state:HB:1|it": [
    {
      german: "Welches Wappen",
      translated: "Quale stemma",
      tone: 'semantic',
    },
    {
      german: "gehört zur",
      translated: "appartiene al",
      tone: 'semantic',
    },
    {
      german: "Freien Hansestadt Bremen",
      translated: "di Brema",
      tone: 'semantic',
    },
  ],
  "lid:state:HB:1|kmr": [
    {
      german: "Welches Wappen",
      translated: "Kîjan nîşan",
      tone: 'semantic',
    },
    {
      german: "Freien Hansestadt Bremen",
      translated: "Bajarê Hanseatîk ê Azad Bremen",
      tone: 'semantic',
    },
  ],
  "lid:state:HB:1|pl": [
    {
      german: "Welches Wappen",
      translated: "Który herb",
      tone: 'semantic',
    },
    {
      german: "gehört zur",
      translated: "należy do",
      tone: 'semantic',
    },
    {
      german: "Freien Hansestadt Bremen",
      translated: "kraju związkowego Brema",
      tone: 'semantic',
    },
  ],
  "lid:state:HB:1|prs": [
    {
      german: "Welches Wappen",
      translated: "کدام نشان",
      tone: 'semantic',
    },
    {
      german: "gehört zur",
      translated: "متعلق به",
      tone: 'semantic',
    },
    {
      german: "Freien Hansestadt Bremen",
      translated: "شهر آزاد هانزایی برمن",
      tone: 'semantic',
    },
  ],
  "lid:state:HB:1|ro": [
    {
      german: "Welches Wappen",
      translated: "Care stemă",
      tone: 'semantic',
    },
    {
      german: "gehört zur",
      translated: "aparține",
      tone: 'semantic',
    },
    {
      german: "Freien Hansestadt Bremen",
      translated: "landului Bremen",
      tone: 'semantic',
    },
  ],
  "lid:state:HB:1|ru": [
    {
      german: "Welches Wappen",
      translated: "Какой герб",
      tone: 'semantic',
    },
    {
      german: "gehört zur",
      translated: "принадлежит",
      tone: 'semantic',
    },
    {
      german: "Freien Hansestadt Bremen",
      translated: "вольному ганзейскому городу Бремен",
      tone: 'semantic',
    },
  ],
  "lid:state:HB:1|sq": [
    {
      german: "Welches Wappen",
      translated: "Cila stemë",
      tone: 'semantic',
    },
    {
      german: "gehört zur",
      translated: "i përket",
      tone: 'semantic',
    },
    {
      german: "Freien Hansestadt Bremen",
      translated: "landit Bremeni",
      tone: 'semantic',
    },
  ],
  "lid:state:HB:1|sr": [
    {
      german: "Welches Wappen",
      translated: "Koji grb",
      tone: 'semantic',
    },
    {
      german: "gehört zur",
      translated: "pripada",
      tone: 'semantic',
    },
    {
      german: "Freien Hansestadt Bremen",
      translated: "Bremen",
      tone: 'semantic',
    },
  ],
  "lid:state:HB:1|tr": [
    {
      german: "Welches Wappen",
      translated: "arması hangisidir",
      tone: 'semantic',
    },
    {
      german: "Freien Hansestadt Bremen",
      translated: "Özgür Hansa Şehri Bremen'in",
      tone: 'semantic',
    },
  ],
  "lid:state:HB:1|uk": [
    {
      german: "Welches Wappen",
      translated: "Який герб",
      tone: 'semantic',
    },
    {
      german: "gehört zur",
      translated: "належить",
      tone: 'semantic',
    },
    {
      german: "Freien Hansestadt Bremen",
      translated: "Вільному ганзейському місту Бремен",
      tone: 'semantic',
    },
  ],
  "lid:state:HB:1|vi": [
    {
      german: "Welches Wappen",
      translated: "Quốc huy nào",
      tone: 'semantic',
    },
    {
      german: "gehört zur",
      translated: "thuộc",
      tone: 'semantic',
    },
    {
      german: "Freien Hansestadt Bremen",
      translated: "Thành phố Hanse Tự do Bremen",
      tone: 'semantic',
    },
  ],
  "lid:state:HB:2|ar": [
    {
      german: "Welches ist",
      translated: "أي",
      tone: 'semantic',
    },
    {
      german: "ein Stadtteil von Bremen",
      translated: "مما يلي حيّ في Bremen؟",
      tone: 'semantic',
    },
  ],
  "lid:state:HB:2|bg": [
    {
      german: "Welches ist",
      translated: "Кое",
      tone: 'semantic',
    },
    {
      german: "ein Stadtteil von Bremen",
      translated: "от следните е район/градски район на Бремен",
      tone: 'semantic',
    },
  ],
  "lid:state:HB:2|bs": [
    {
      german: "Welches ist",
      translated: "Što je",
      tone: 'semantic',
    },
    {
      german: "ein Stadtteil von Bremen",
      translated: "gradska četvrt/okrug grada Bremen",
      tone: 'semantic',
    },
  ],
  "lid:state:HB:2|el": [
    {
      german: "Welches ist",
      translated: "Ποιο από τα παρακάτω είναι",
      tone: 'semantic',
    },
    {
      german: "ein Stadtteil von Bremen",
      translated: "δημοτικό διαμέρισμα/περιοχή του Βρέμη;",
      tone: 'semantic',
    },
  ],
  "lid:state:HB:2|en": [
    {
      german: "Welches ist",
      translated: "Which is a",
      tone: 'semantic',
    },
    {
      german: "ein Stadtteil von Bremen",
      translated: "district of Bremen",
      tone: 'semantic',
    },
  ],
  "lid:state:HB:2|es": [
    {
      german: "Welches ist",
      translated: "¿Cuál de los siguientes es",
      tone: 'semantic',
    },
    {
      german: "ein Stadtteil von Bremen",
      translated: "un barrio de Bremen",
      tone: 'semantic',
    },
  ],
  "lid:state:HB:2|fa": [
    {
      german: "Welches ist",
      translated: "کدام‌یک",
      tone: 'semantic',
    },
    {
      german: "ein Stadtteil von Bremen",
      translated: "یک ناحیه/بخش شهری در برمن",
      tone: 'semantic',
    },
  ],
  "lid:state:HB:2|fr": [
    {
      german: "Welches ist",
      translated: "Lequel des",
      tone: 'semantic',
    },
    {
      german: "ein Stadtteil von Bremen",
      translated: "quartier de Brême",
      tone: 'semantic',
    },
  ],
  "lid:state:HB:2|hr": [
    {
      german: "Welches ist",
      translated: "Što je od navedenoga",
      tone: 'semantic',
    },
    {
      german: "ein Stadtteil von Bremen",
      translated: "gradska četvrt/okrug grada Bremen",
      tone: 'semantic',
    },
  ],
  "lid:state:HB:2|it": [
    {
      german: "Welches ist",
      translated: "Quale dei seguenti è",
      tone: 'semantic',
    },
    {
      german: "ein Stadtteil von Bremen",
      translated: "un distretto/quartiere di Brema",
      tone: 'semantic',
    },
  ],
  "lid:state:HB:2|kmr": [
    {
      german: "Welches ist",
      translated: "Kîjan ji van",
      tone: 'semantic',
    },
    {
      german: "ein Stadtteil von Bremen",
      translated: "a Bremen e?",
      tone: 'semantic',
    },
  ],
  "lid:state:HB:2|pl": [
    {
      german: "Welches ist",
      translated: "Które",
      tone: 'semantic',
    },
    {
      german: "ein Stadtteil von Bremen",
      translated: "dzielnicą/okręgiem miasta Brema",
      tone: 'semantic',
    },
  ],
  "lid:state:HB:2|prs": [
    {
      german: "Welches ist",
      translated: "کدام‌یک از موارد زیر",
      tone: 'semantic',
    },
    {
      german: "ein Stadtteil von Bremen",
      translated: "یک ناحیه/بخش شهری در برمن",
      tone: 'semantic',
    },
  ],
  "lid:state:HB:2|ro": [
    {
      german: "Welches ist",
      translated: "Care dintre următoarele este",
      tone: 'semantic',
    },
    {
      german: "ein Stadtteil von Bremen",
      translated: "un district/sector al orașului Bremen",
      tone: 'semantic',
    },
  ],
  "lid:state:HB:2|ru": [
    {
      german: "Welches ist",
      translated: "Какой из перечисленных является",
      tone: 'semantic',
    },
    {
      german: "ein Stadtteil von Bremen",
      translated: "Бремен",
      tone: 'semantic',
    },
  ],
  "lid:state:HB:2|sq": [
    {
      german: "Welches ist",
      translated: "Cila nga këto është",
      tone: 'semantic',
    },
    {
      german: "ein Stadtteil von Bremen",
      translated: "një lagje/rreth i Bremenit",
      tone: 'semantic',
    },
  ],
  "lid:state:HB:2|sr": [
    {
      german: "Welches ist",
      translated: "Šta je",
      tone: 'semantic',
    },
    {
      german: "ein Stadtteil von Bremen",
      translated: "od navedenoga gradska četvrt/okrug grada Bremen",
      tone: 'semantic',
    },
  ],
  "lid:state:HB:2|tr": [
    {
      german: "Welches ist",
      translated: "Aşağıdakilerden",
      tone: 'semantic',
    },
    {
      german: "ein Stadtteil von Bremen",
      translated: "Bremen’in bir semtidir (Stadtteil)",
      tone: 'semantic',
    },
  ],
  "lid:state:HB:2|uk": [
    {
      german: "Welches ist",
      translated: "Який із",
      tone: 'semantic',
    },
    {
      german: "ein Stadtteil von Bremen",
      translated: "наведених районів є районом Бремена",
      tone: 'semantic',
    },
  ],
  "lid:state:HB:2|vi": [
    {
      german: "Welches ist",
      translated: "Địa danh nào sau đây là",
      tone: 'semantic',
    },
    {
      german: "ein Stadtteil von Bremen",
      translated: "một quận/khu vực của Bremen?",
      tone: 'semantic',
    },
  ],
  "lid:state:HB:3|ar": [
    {
      german: "Für wie viele Jahre",
      translated: "لمدة كم سنة",
      tone: 'semantic',
    },
    {
      german: "das Landesparlament",
      translated: "برلمان الولاية",
      tone: 'semantic',
    },
    {
      german: "in Bremen",
      translated: "في Bremen",
      tone: 'semantic',
    },
    {
      german: "gewählt",
      translated: "يُنتخب",
      tone: 'semantic',
    },
  ],
  "lid:state:HB:3|bg": [
    {
      german: "Für wie viele Jahre",
      translated: "За колко години",
      tone: 'semantic',
    },
    {
      german: "wird",
      translated: "се",
      tone: 'semantic',
    },
    {
      german: "das Landesparlament",
      translated: "парламентът",
      tone: 'semantic',
    },
    {
      german: "in Bremen",
      translated: "на провинция Бремен",
      tone: 'semantic',
    },
    {
      german: "gewählt",
      translated: "избира",
      tone: 'semantic',
    },
  ],
  "lid:state:HB:3|bs": [
    {
      german: "Für wie viele Jahre",
      translated: "Na koliko se godina",
      tone: 'semantic',
    },
    {
      german: "das Landesparlament",
      translated: "parlament",
      tone: 'semantic',
    },
    {
      german: "in Bremen",
      translated: "savezne zemlje Bremen",
      tone: 'semantic',
    },
    {
      german: "gewählt",
      translated: "bira",
      tone: 'semantic',
    },
  ],
  "lid:state:HB:3|el": [
    {
      german: "Für wie viele Jahre",
      translated: "Για πόσα χρόνια",
      tone: 'semantic',
    },
    {
      german: "wird",
      translated: "εκλέγεται",
      tone: 'semantic',
    },
    {
      german: "das Landesparlament",
      translated: "το κοινοβούλιο",
      tone: 'semantic',
    },
    {
      german: "in Bremen",
      translated: "του κρατιδίου Βρέμη",
      tone: 'semantic',
    },
  ],
  "lid:state:HB:3|en": [
    {
      german: "Für wie viele Jahre",
      translated: "For how many years",
      tone: 'semantic',
    },
    {
      german: "wird",
      translated: "is",
      tone: 'semantic',
    },
    {
      german: "das Landesparlament",
      translated: "the state parliament",
      tone: 'semantic',
    },
    {
      german: "in Bremen",
      translated: "in Bremen",
      tone: 'semantic',
    },
    {
      german: "gewählt",
      translated: "elected",
      tone: 'semantic',
    },
  ],
  "lid:state:HB:3|es": [
    {
      german: "Für wie viele Jahre",
      translated: "¿Por cuántos años",
      tone: 'semantic',
    },
    {
      german: "das Landesparlament",
      translated: "el parlamento regional",
      tone: 'semantic',
    },
    {
      german: "in Bremen",
      translated: "en Bremen",
      tone: 'semantic',
    },
    {
      german: "gewählt",
      translated: "se elige",
      tone: 'semantic',
    },
  ],
  "lid:state:HB:3|fa": [
    {
      german: "Für wie viele Jahre",
      translated: "برای چند سال",
      tone: 'semantic',
    },
    {
      german: "wird",
      translated: "می‌شود",
      tone: 'semantic',
    },
    {
      german: "das Landesparlament",
      translated: "پارلمان ایالتی",
      tone: 'semantic',
    },
    {
      german: "in Bremen",
      translated: "برمن",
      tone: 'semantic',
    },
    {
      german: "gewählt",
      translated: "انتخاب",
      tone: 'semantic',
    },
  ],
  "lid:state:HB:3|fr": [
    {
      german: "Für wie viele Jahre",
      translated: "Pour combien d’années",
      tone: 'semantic',
    },
    {
      german: "wird",
      translated: "est-il",
      tone: 'semantic',
    },
    {
      german: "das Landesparlament",
      translated: "Parlement du Land",
      tone: 'semantic',
    },
    {
      german: "in Bremen",
      translated: "de Brême",
      tone: 'semantic',
    },
    {
      german: "gewählt",
      translated: "élu",
      tone: 'semantic',
    },
  ],
  "lid:state:HB:3|hr": [
    {
      german: "Für wie viele Jahre",
      translated: "Na koliko se godina",
      tone: 'semantic',
    },
    {
      german: "das Landesparlament",
      translated: "parlament",
      tone: 'semantic',
    },
    {
      german: "in Bremen",
      translated: "savezne zemlje Bremen",
      tone: 'semantic',
    },
    {
      german: "gewählt",
      translated: "bira",
      tone: 'semantic',
    },
  ],
  "lid:state:HB:3|it": [
    {
      german: "Für wie viele Jahre",
      translated: "Per quanti anni",
      tone: 'semantic',
    },
    {
      german: "wird",
      translated: "viene",
      tone: 'semantic',
    },
    {
      german: "das Landesparlament",
      translated: "il Parlamento del Land",
      tone: 'semantic',
    },
    {
      german: "in Bremen",
      translated: "di Brema",
      tone: 'semantic',
    },
    {
      german: "gewählt",
      translated: "eletto",
      tone: 'semantic',
    },
  ],
  "lid:state:HB:3|kmr": [
    {
      german: "Für wie viele Jahre",
      translated: "çend salan",
      tone: 'semantic',
    },
    {
      german: "wird",
      translated: "tê",
      tone: 'semantic',
    },
    {
      german: "das Landesparlament",
      translated: "Parlamentoya",
      tone: 'semantic',
    },
    {
      german: "in Bremen",
      translated: "ya Bremen",
      tone: 'semantic',
    },
    {
      german: "gewählt",
      translated: "hilbijartin",
      tone: 'semantic',
    },
  ],
  "lid:state:HB:3|pl": [
    {
      german: "Für wie viele Jahre",
      translated: "Na ile lat",
      tone: 'semantic',
    },
    {
      german: "wird",
      translated: "jest",
      tone: 'semantic',
    },
    {
      german: "das Landesparlament",
      translated: "parlament kraju związkowego",
      tone: 'semantic',
    },
    {
      german: "in Bremen",
      translated: "Brema",
      tone: 'semantic',
    },
    {
      german: "gewählt",
      translated: "wybierany",
      tone: 'semantic',
    },
  ],
  "lid:state:HB:3|prs": [
    {
      german: "Für wie viele Jahre",
      translated: "چند سال",
      tone: 'semantic',
    },
    {
      german: "wird",
      translated: "می‌شود",
      tone: 'semantic',
    },
    {
      german: "das Landesparlament",
      translated: "پارلمان ایالتی برمن",
      tone: 'semantic',
    },
    {
      german: "gewählt",
      translated: "انتخاب",
      tone: 'semantic',
    },
  ],
  "lid:state:HB:3|ro": [
    {
      german: "Für wie viele Jahre",
      translated: "Pentru câți ani",
      tone: 'semantic',
    },
    {
      german: "wird",
      translated: "este ales",
      tone: 'semantic',
    },
    {
      german: "das Landesparlament",
      translated: "parlamentul landului",
      tone: 'semantic',
    },
    {
      german: "in Bremen",
      translated: "Bremen",
      tone: 'semantic',
    },
  ],
  "lid:state:HB:3|ru": [
    {
      german: "Für wie viele Jahre",
      translated: "На сколько лет",
      tone: 'semantic',
    },
    {
      german: "das Landesparlament",
      translated: "земельный парламент",
      tone: 'semantic',
    },
    {
      german: "in Bremen",
      translated: "в Бремене",
      tone: 'semantic',
    },
    {
      german: "gewählt",
      translated: "избирается",
      tone: 'semantic',
    },
  ],
  "lid:state:HB:3|sq": [
    {
      german: "Für wie viele Jahre",
      translated: "Për sa vjet",
      tone: 'semantic',
    },
    {
      german: "das Landesparlament",
      translated: "parlamenti i landit",
      tone: 'semantic',
    },
    {
      german: "in Bremen",
      translated: "Bremeni",
      tone: 'semantic',
    },
    {
      german: "gewählt",
      translated: "zgjidhet",
      tone: 'semantic',
    },
  ],
  "lid:state:HB:3|sr": [
    {
      german: "Für wie viele Jahre",
      translated: "Na koliko se godina",
      tone: 'semantic',
    },
    {
      german: "das Landesparlament",
      translated: "parlament",
      tone: 'semantic',
    },
    {
      german: "in Bremen",
      translated: "savezne pokrajine Bremen",
      tone: 'semantic',
    },
    {
      german: "gewählt",
      translated: "bira",
      tone: 'semantic',
    },
  ],
  "lid:state:HB:3|tr": [
    {
      german: "Für wie viele Jahre",
      translated: "kaç yıllığına",
      tone: 'semantic',
    },
    {
      german: "das Landesparlament",
      translated: "eyalet parlamentosu",
      tone: 'semantic',
    },
    {
      german: "in Bremen",
      translated: "Bremen",
      tone: 'semantic',
    },
    {
      german: "gewählt",
      translated: "seçilir",
      tone: 'semantic',
    },
  ],
  "lid:state:HB:3|uk": [
    {
      german: "Für wie viele Jahre",
      translated: "На скільки років",
      tone: 'semantic',
    },
    {
      german: "das Landesparlament",
      translated: "земельний парламент",
      tone: 'semantic',
    },
    {
      german: "in Bremen",
      translated: "у Бремені",
      tone: 'semantic',
    },
    {
      german: "gewählt",
      translated: "обирають",
      tone: 'semantic',
    },
  ],
  "lid:state:HB:3|vi": [
    {
      german: "Für wie viele Jahre",
      translated: "bao nhiêu năm",
      tone: 'semantic',
    },
    {
      german: "das Landesparlament",
      translated: "Nghị viện bang Bremen",
      tone: 'semantic',
    },
    {
      german: "gewählt",
      translated: "được bầu",
      tone: 'semantic',
    },
  ],
  "lid:state:HB:4|ar": [
    {
      german: "Ab welchem Alter",
      translated: "ابتداءً من أي سن",
      tone: 'semantic',
    },
    {
      german: "darf man",
      translated: "يحق",
      tone: 'semantic',
    },
    {
      german: "in Bremen",
      translated: "في Bremen",
      tone: 'semantic',
    },
    {
      german: "bei den Wahlen",
      translated: "في انتخابات",
      tone: 'semantic',
    },
    {
      german: "wählen",
      translated: "التصويت",
      tone: 'semantic',
    },
  ],
  "lid:state:HB:4|bg": [
    {
      german: "Ab welchem Alter",
      translated: "От каква възраст",
      tone: 'semantic',
    },
    {
      german: "darf man",
      translated: "може да се",
      tone: 'semantic',
    },
    {
      german: "in Bremen",
      translated: "в Бремен",
      tone: 'semantic',
    },
    {
      german: "bei den Wahlen",
      translated: "на изборите",
      tone: 'semantic',
    },
    {
      german: "zur Bürgerschaft (Landtag)",
      translated: "за Bürgerschaft (Landtag)",
      tone: 'semantic',
    },
    {
      german: "wählen",
      translated: "гласува",
      tone: 'semantic',
    },
  ],
  "lid:state:HB:4|bs": [
    {
      german: "Ab welchem Alter",
      translated: "Od koje se dobi",
      tone: 'semantic',
    },
    {
      german: "darf man",
      translated: "može",
      tone: 'semantic',
    },
    {
      german: "in Bremen",
      translated: "u Bremenu",
      tone: 'semantic',
    },
    {
      german: "bei den Wahlen",
      translated: "na izborima",
      tone: 'semantic',
    },
    {
      german: "zur Bürgerschaft (Landtag)",
      translated: "za Bürgerschaft (Landtag)",
      tone: 'semantic',
    },
    {
      german: "wählen",
      translated: "glasovati",
      tone: 'semantic',
    },
  ],
  "lid:state:HB:4|el": [
    {
      german: "Ab welchem Alter",
      translated: "Από ποια ηλικία",
      tone: 'semantic',
    },
    {
      german: "darf man",
      translated: "μπορεί κάποιος",
      tone: 'semantic',
    },
    {
      german: "in Bremen",
      translated: "στη Βρέμη",
      tone: 'semantic',
    },
    {
      german: "bei den Wahlen",
      translated: "στις εκλογές",
      tone: 'semantic',
    },
    {
      german: "zur Bürgerschaft (Landtag)",
      translated: "για τη Bürgerschaft (Landtag)",
      tone: 'semantic',
    },
    {
      german: "wählen",
      translated: "ψηφίσει",
      tone: 'semantic',
    },
  ],
  "lid:state:HB:4|en": [
    {
      german: "Ab welchem Alter",
      translated: "From what age",
      tone: 'semantic',
    },
    {
      german: "darf man",
      translated: "can you",
      tone: 'semantic',
    },
    {
      german: "in Bremen",
      translated: "in Bremen",
      tone: 'semantic',
    },
    {
      german: "bei den Wahlen",
      translated: "in the elections",
      tone: 'semantic',
    },
    {
      german: "zur Bürgerschaft (Landtag)",
      translated: "to the Bürgerschaft (state parliament)",
      tone: 'semantic',
    },
    {
      german: "wählen",
      translated: "vote",
      tone: 'semantic',
    },
  ],
  "lid:state:HB:4|es": [
    {
      german: "Ab welchem Alter",
      translated: "¿A partir de qué edad",
      tone: 'semantic',
    },
    {
      german: "darf man",
      translated: "se puede",
      tone: 'semantic',
    },
    {
      german: "in Bremen",
      translated: "en Bremen",
      tone: 'semantic',
    },
    {
      german: "bei den Wahlen",
      translated: "en las elecciones",
      tone: 'semantic',
    },
    {
      german: "zur Bürgerschaft (Landtag)",
      translated: "a la Bürgerschaft (parlamento regional)",
      tone: 'semantic',
    },
    {
      german: "wählen",
      translated: "votar",
      tone: 'semantic',
    },
  ],
  "lid:state:HB:4|fa": [
    {
      german: "Ab welchem Alter",
      translated: "از چه سنی",
      tone: 'semantic',
    },
    {
      german: "darf man",
      translated: "می‌توان",
      tone: 'semantic',
    },
    {
      german: "in Bremen",
      translated: "برمن",
      tone: 'semantic',
    },
    {
      german: "bei den Wahlen",
      translated: "انتخابات",
      tone: 'semantic',
    },
    {
      german: "zur Bürgerschaft (Landtag)",
      translated: "محلی",
      tone: 'semantic',
    },
    {
      german: "wählen",
      translated: "داد",
      tone: 'semantic',
    },
  ],
  "lid:state:HB:4|fr": [
    {
      german: "Ab welchem Alter",
      translated: "À partir de quel âge",
      tone: 'semantic',
    },
    {
      german: "darf man",
      translated: "peut-on",
      tone: 'semantic',
    },
    {
      german: "in Bremen",
      translated: "à Brême",
      tone: 'semantic',
    },
    {
      german: "bei den Wahlen",
      translated: "aux élections",
      tone: 'semantic',
    },
    {
      german: "zur Bürgerschaft (Landtag)",
      translated: "de la Bürgerschaft (Landtag)",
      tone: 'semantic',
    },
    {
      german: "wählen",
      translated: "voter",
      tone: 'semantic',
    },
  ],
  "lid:state:HB:4|hr": [
    {
      german: "Ab welchem Alter",
      translated: "Od koje se dobi",
      tone: 'semantic',
    },
    {
      german: "darf man",
      translated: "može",
      tone: 'semantic',
    },
    {
      german: "in Bremen",
      translated: "u Bremenu",
      tone: 'semantic',
    },
    {
      german: "bei den Wahlen",
      translated: "na izborima",
      tone: 'semantic',
    },
    {
      german: "zur Bürgerschaft (Landtag)",
      translated: "za Bürgerschaft (Landtag)",
      tone: 'semantic',
    },
    {
      german: "wählen",
      translated: "glasovati",
      tone: 'semantic',
    },
  ],
  "lid:state:HB:4|it": [
    {
      german: "Ab welchem Alter",
      translated: "Da quale età",
      tone: 'semantic',
    },
    {
      german: "darf man",
      translated: "si può",
      tone: 'semantic',
    },
    {
      german: "in Bremen",
      translated: "a Brema",
      tone: 'semantic',
    },
    {
      german: "bei den Wahlen",
      translated: "alle elezioni",
      tone: 'semantic',
    },
    {
      german: "zur Bürgerschaft (Landtag)",
      translated: "per la Bürgerschaft (Landtag)",
      tone: 'semantic',
    },
    {
      german: "wählen",
      translated: "votare",
      tone: 'semantic',
    },
  ],
  "lid:state:HB:4|kmr": [
    {
      german: "Ab welchem Alter",
      translated: "Ji kîjan temenê",
      tone: 'semantic',
    },
    {
      german: "darf man",
      translated: "dikare",
      tone: 'semantic',
    },
    {
      german: "in Bremen",
      translated: "li Bremen",
      tone: 'semantic',
    },
    {
      german: "bei den Wahlen",
      translated: "di hilbijartina",
      tone: 'semantic',
    },
    {
      german: "zur Bürgerschaft (Landtag)",
      translated: "Bürgerschaftê (Landtag)",
      tone: 'semantic',
    },
    {
      german: "wählen",
      translated: "deng were dayîn",
      tone: 'semantic',
    },
  ],
  "lid:state:HB:4|pl": [
    {
      german: "Ab welchem Alter",
      translated: "Od jakiego wieku",
      tone: 'semantic',
    },
    {
      german: "darf man",
      translated: "można",
      tone: 'semantic',
    },
    {
      german: "in Bremen",
      translated: "w Bremie",
      tone: 'semantic',
    },
    {
      german: "bei den Wahlen",
      translated: "w wyborach",
      tone: 'semantic',
    },
    {
      german: "zur Bürgerschaft (Landtag)",
      translated: "do Bürgerschaft (Landtagu)",
      tone: 'semantic',
    },
    {
      german: "wählen",
      translated: "głosować",
      tone: 'semantic',
    },
  ],
  "lid:state:HB:4|prs": [
    {
      german: "Ab welchem Alter",
      translated: "از چه سنی",
      tone: 'semantic',
    },
    {
      german: "darf man",
      translated: "می‌توان",
      tone: 'semantic',
    },
    {
      german: "in Bremen",
      translated: "در برمن",
      tone: 'semantic',
    },
    {
      german: "bei den Wahlen",
      translated: "در انتخابات",
      tone: 'semantic',
    },
    {
      german: "zur Bürgerschaft (Landtag)",
      translated: "Bürgerschaft (Landtag)",
      tone: 'semantic',
    },
    {
      german: "wählen",
      translated: "رأی داد",
      tone: 'semantic',
    },
  ],
  "lid:state:HB:4|ro": [
    {
      german: "Ab welchem Alter",
      translated: "De la ce vârstă",
      tone: 'semantic',
    },
    {
      german: "darf man",
      translated: "se poate",
      tone: 'semantic',
    },
    {
      german: "in Bremen",
      translated: "în Bremen",
      tone: 'semantic',
    },
    {
      german: "bei den Wahlen",
      translated: "la alegerile",
      tone: 'semantic',
    },
    {
      german: "zur Bürgerschaft (Landtag)",
      translated: "pentru Bürgerschaft (Landtag)",
      tone: 'semantic',
    },
    {
      german: "wählen",
      translated: "vota",
      tone: 'semantic',
    },
  ],
  "lid:state:HB:4|ru": [
    {
      german: "Ab welchem Alter",
      translated: "С какого возраста",
      tone: 'semantic',
    },
    {
      german: "darf man",
      translated: "можно",
      tone: 'semantic',
    },
    {
      german: "in Bremen",
      translated: "в Бремене",
      tone: 'semantic',
    },
    {
      german: "bei den Wahlen",
      translated: "на выборах",
      tone: 'semantic',
    },
    {
      german: "zur Bürgerschaft (Landtag)",
      translated: "в бюргершафт (ландтаг)",
      tone: 'semantic',
    },
    {
      german: "wählen",
      translated: "голосовать",
      tone: 'semantic',
    },
  ],
  "lid:state:HB:4|sq": [
    {
      german: "Ab welchem Alter",
      translated: "Nga cila moshë",
      tone: 'semantic',
    },
    {
      german: "darf man",
      translated: "mund të",
      tone: 'semantic',
    },
    {
      german: "in Bremen",
      translated: "në Bremen",
      tone: 'semantic',
    },
    {
      german: "bei den Wahlen",
      translated: "në zgjedhjet",
      tone: 'semantic',
    },
    {
      german: "zur Bürgerschaft (Landtag)",
      translated: "për Bürgerschaft (Landtag)",
      tone: 'semantic',
    },
    {
      german: "wählen",
      translated: "votohet",
      tone: 'semantic',
    },
  ],
  "lid:state:HB:4|sr": [
    {
      german: "Ab welchem Alter",
      translated: "Od koje godine",
      tone: 'semantic',
    },
    {
      german: "darf man",
      translated: "može",
      tone: 'semantic',
    },
    {
      german: "in Bremen",
      translated: "u Bremenu",
      tone: 'semantic',
    },
    {
      german: "bei den Wahlen",
      translated: "na izborima",
      tone: 'semantic',
    },
    {
      german: "zur Bürgerschaft (Landtag)",
      translated: "za Bürgerschaft (Landtag)",
      tone: 'semantic',
    },
    {
      german: "wählen",
      translated: "glasati",
      tone: 'semantic',
    },
  ],
  "lid:state:HB:4|tr": [
    {
      german: "Ab welchem Alter",
      translated: "kaç yaşından itibaren",
      tone: 'semantic',
    },
    {
      german: "in Bremen",
      translated: "Bremen’de",
      tone: 'semantic',
    },
    {
      german: "bei den Wahlen",
      translated: "seçimlerinde",
      tone: 'semantic',
    },
    {
      german: "zur Bürgerschaft (Landtag)",
      translated: "Bürgerschaft (eyalet parlamentosu)",
      tone: 'semantic',
    },
    {
      german: "wählen",
      translated: "oy kullanılabilir",
      tone: 'semantic',
    },
  ],
  "lid:state:HB:4|uk": [
    {
      german: "Ab welchem Alter",
      translated: "З якого віку",
      tone: 'semantic',
    },
    {
      german: "in Bremen",
      translated: "в Бремені",
      tone: 'semantic',
    },
    {
      german: "bei den Wahlen",
      translated: "на виборах",
      tone: 'semantic',
    },
    {
      german: "zur Bürgerschaft (Landtag)",
      translated: "до Бюргершафту (земельного парламенту)",
      tone: 'semantic',
    },
    {
      german: "wählen",
      translated: "можна голосувати",
      tone: 'semantic',
    },
  ],
  "lid:state:HB:4|vi": [
    {
      german: "Ab welchem Alter",
      translated: "Từ bao nhiêu tuổi",
      tone: 'semantic',
    },
    {
      german: "darf man",
      translated: "có thể",
      tone: 'semantic',
    },
    {
      german: "in Bremen",
      translated: "ở Bremen",
      tone: 'semantic',
    },
    {
      german: "bei den Wahlen",
      translated: "trong cuộc bầu cử",
      tone: 'semantic',
    },
    {
      german: "zur Bürgerschaft (Landtag)",
      translated: "Bürgerschaft (Landtag)",
      tone: 'semantic',
    },
    {
      german: "wählen",
      translated: "bỏ phiếu",
      tone: 'semantic',
    },
  ],
  "lid:state:HB:5|ar": [
    {
      german: "Welche Farben",
      translated: "ما ألوان",
      tone: 'semantic',
    },
    {
      german: "die Landesflagge",
      translated: "علم ولاية",
      tone: 'semantic',
    },
    {
      german: "von Bremen",
      translated: "Bremen",
      tone: 'semantic',
    },
  ],
  "lid:state:HB:5|bg": [
    {
      german: "Welche Farben",
      translated: "Какви са",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "цветовете",
      tone: 'semantic',
    },
    {
      german: "die Landesflagge",
      translated: "на знамето",
      tone: 'semantic',
    },
    {
      german: "von Bremen",
      translated: "на провинция Бремен",
      tone: 'semantic',
    },
  ],
  "lid:state:HB:5|bs": [
    {
      german: "Welche Farben",
      translated: "Koje su boje",
      tone: 'semantic',
    },
    {
      german: "die Landesflagge",
      translated: "zastave",
      tone: 'semantic',
    },
    {
      german: "von Bremen",
      translated: "savezne zemlje Bremen",
      tone: 'semantic',
    },
  ],
  "lid:state:HB:5|el": [
    {
      german: "Welche Farben",
      translated: "Ποια είναι τα χρώματα",
      tone: 'semantic',
    },
    {
      german: "die Landesflagge",
      translated: "της σημαίας",
      tone: 'semantic',
    },
    {
      german: "von Bremen",
      translated: "του κρατιδίου Βρέμη",
      tone: 'semantic',
    },
  ],
  "lid:state:HB:5|en": [
    {
      german: "Welche Farben",
      translated: "What colors",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "does",
      tone: 'semantic',
    },
    {
      german: "die Landesflagge",
      translated: "the state flag",
      tone: 'semantic',
    },
    {
      german: "von Bremen",
      translated: "of Bremen",
      tone: 'semantic',
    },
  ],
  "lid:state:HB:5|es": [
    {
      german: "Welche Farben",
      translated: "¿Qué colores",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "tiene",
      tone: 'semantic',
    },
    {
      german: "die Landesflagge",
      translated: "la bandera regional",
      tone: 'semantic',
    },
    {
      german: "von Bremen",
      translated: "de Bremen",
      tone: 'semantic',
    },
  ],
  "lid:state:HB:5|fa": [
    {
      german: "Welche Farben",
      translated: "رنگ‌های",
      tone: 'semantic',
    },
    {
      german: "die Landesflagge",
      translated: "پرچم ایالت",
      tone: 'semantic',
    },
    {
      german: "von Bremen",
      translated: "برمن",
      tone: 'semantic',
    },
  ],
  "lid:state:HB:5|fr": [
    {
      german: "Welche Farben",
      translated: "Quelles sont les couleurs",
      tone: 'semantic',
    },
    {
      german: "die Landesflagge",
      translated: "du drapeau du Land",
      tone: 'semantic',
    },
    {
      german: "von Bremen",
      translated: "de Brême",
      tone: 'semantic',
    },
  ],
  "lid:state:HB:5|hr": [
    {
      german: "Welche Farben",
      translated: "Koje",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "su",
      tone: 'semantic',
    },
    {
      german: "die Landesflagge",
      translated: "boje zastave",
      tone: 'semantic',
    },
    {
      german: "von Bremen",
      translated: "savezne zemlje Bremen",
      tone: 'semantic',
    },
  ],
  "lid:state:HB:5|it": [
    {
      german: "Welche Farben",
      translated: "Quali sono i colori",
      tone: 'semantic',
    },
    {
      german: "die Landesflagge",
      translated: "bandiera del Land",
      tone: 'semantic',
    },
    {
      german: "von Bremen",
      translated: "di Brema",
      tone: 'semantic',
    },
  ],
  "lid:state:HB:5|kmr": [
    {
      german: "Welche Farben",
      translated: "Rengên",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "çi ne",
      tone: 'semantic',
    },
    {
      german: "die Landesflagge",
      translated: "ala",
      tone: 'semantic',
    },
    {
      german: "von Bremen",
      translated: "Bremen",
      tone: 'semantic',
    },
  ],
  "lid:state:HB:5|pl": [
    {
      german: "Welche Farben",
      translated: "Jakie są kolory",
      tone: 'semantic',
    },
    {
      german: "die Landesflagge",
      translated: "flagi kraju związkowego",
      tone: 'semantic',
    },
    {
      german: "von Bremen",
      translated: "Brema",
      tone: 'semantic',
    },
  ],
  "lid:state:HB:5|prs": [
    {
      german: "Welche Farben",
      translated: "رنگ‌های",
      tone: 'semantic',
    },
    {
      german: "die Landesflagge",
      translated: "پرچم ایالت",
      tone: 'semantic',
    },
    {
      german: "von Bremen",
      translated: "برمن",
      tone: 'semantic',
    },
  ],
  "lid:state:HB:5|ro": [
    {
      german: "Welche Farben",
      translated: "Care sunt culorile",
      tone: 'semantic',
    },
    {
      german: "die Landesflagge",
      translated: "drapelului landului",
      tone: 'semantic',
    },
    {
      german: "von Bremen",
      translated: "Bremen",
      tone: 'semantic',
    },
  ],
  "lid:state:HB:5|ru": [
    {
      german: "Welche Farben",
      translated: "Какие цвета",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "у",
      tone: 'semantic',
    },
    {
      german: "die Landesflagge",
      translated: "флага земли",
      tone: 'semantic',
    },
    {
      german: "von Bremen",
      translated: "Бремен",
      tone: 'semantic',
    },
  ],
  "lid:state:HB:5|sq": [
    {
      german: "Welche Farben",
      translated: "Cilat janë ngjyrat",
      tone: 'semantic',
    },
    {
      german: "die Landesflagge",
      translated: "flamurit",
      tone: 'semantic',
    },
    {
      german: "von Bremen",
      translated: "të landit Bremeni",
      tone: 'semantic',
    },
  ],
  "lid:state:HB:5|sr": [
    {
      german: "Welche Farben",
      translated: "Koje su boje",
      tone: 'semantic',
    },
    {
      german: "die Landesflagge",
      translated: "zastave savezne pokrajine",
      tone: 'semantic',
    },
    {
      german: "von Bremen",
      translated: "Bremen",
      tone: 'semantic',
    },
  ],
  "lid:state:HB:5|tr": [
    {
      german: "Welche Farben",
      translated: "renkleri nelerdir",
      tone: 'semantic',
    },
    {
      german: "die Landesflagge",
      translated: "eyalet bayrağının",
      tone: 'semantic',
    },
    {
      german: "von Bremen",
      translated: "Bremen",
      tone: 'semantic',
    },
  ],
  "lid:state:HB:5|uk": [
    {
      german: "Welche Farben",
      translated: "Які кольори",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "має",
      tone: 'semantic',
    },
    {
      german: "die Landesflagge",
      translated: "прапор федеральної землі",
      tone: 'semantic',
    },
    {
      german: "von Bremen",
      translated: "Бремен",
      tone: 'semantic',
    },
  ],
  "lid:state:HB:5|vi": [
    {
      german: "Welche Farben",
      translated: "Màu",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "là",
      tone: 'semantic',
    },
    {
      german: "die Landesflagge",
      translated: "cờ bang",
      tone: 'semantic',
    },
    {
      german: "von Bremen",
      translated: "Bremen",
      tone: 'semantic',
    },
  ],
  "lid:state:HB:6|ar": [
    {
      german: "Wo können Sie",
      translated: "أين يمكنك",
      tone: 'semantic',
    },
    {
      german: "in Bremen",
      translated: "في Bremen",
      tone: 'semantic',
    },
    {
      german: "über politische Themen",
      translated: "عن القضايا السياسية",
      tone: 'semantic',
    },
    {
      german: "informieren",
      translated: "الحصول على معلومات",
      tone: 'semantic',
    },
  ],
  "lid:state:HB:6|bg": [
    {
      german: "Wo können Sie",
      translated: "Къде",
      tone: 'semantic',
    },
    {
      german: "sich",
      translated: "в",
      tone: 'semantic',
    },
    {
      german: "in Bremen",
      translated: "Бремен",
      tone: 'semantic',
    },
    {
      german: "über politische Themen",
      translated: "по политически теми",
      tone: 'semantic',
    },
    {
      german: "informieren",
      translated: "да получите информация",
      tone: 'semantic',
    },
  ],
  "lid:state:HB:6|bs": [
    {
      german: "Wo können Sie",
      translated: "Gdje",
      tone: 'semantic',
    },
    {
      german: "sich",
      translated: "se",
      tone: 'semantic',
    },
    {
      german: "in Bremen",
      translated: "u Bremenu",
      tone: 'semantic',
    },
    {
      german: "über politische Themen",
      translated: "o političkim temama",
      tone: 'semantic',
    },
    {
      german: "informieren",
      translated: "mogu dobiti informacije",
      tone: 'semantic',
    },
  ],
  "lid:state:HB:6|el": [
    {
      german: "Wo können Sie",
      translated: "Πού μπορείτε",
      tone: 'semantic',
    },
    {
      german: "in Bremen",
      translated: "στο Βρέμη",
      tone: 'semantic',
    },
    {
      german: "über politische Themen",
      translated: "για πολιτικά θέματα",
      tone: 'semantic',
    },
    {
      german: "informieren",
      translated: "ενημερωθείτε",
      tone: 'semantic',
    },
  ],
  "lid:state:HB:6|en": [
    {
      german: "Wo können Sie",
      translated: "Where can you",
      tone: 'semantic',
    },
    {
      german: "in Bremen",
      translated: "in Bremen",
      tone: 'semantic',
    },
    {
      german: "über politische Themen",
      translated: "about political topics",
      tone: 'semantic',
    },
    {
      german: "informieren",
      translated: "get information",
      tone: 'semantic',
    },
  ],
  "lid:state:HB:6|es": [
    {
      german: "Wo können Sie",
      translated: "¿Dónde puede",
      tone: 'semantic',
    },
    {
      german: "in Bremen",
      translated: "en Bremen",
      tone: 'semantic',
    },
    {
      german: "über politische Themen",
      translated: "sobre temas políticos",
      tone: 'semantic',
    },
    {
      german: "informieren",
      translated: "informarse",
      tone: 'semantic',
    },
  ],
  "lid:state:HB:6|fa": [
    {
      german: "Wo können Sie",
      translated: "می‌توانید",
      tone: 'semantic',
    },
    {
      german: "in Bremen",
      translated: "در برمن",
      tone: 'semantic',
    },
    {
      german: "über politische Themen",
      translated: "دربارهٔ موضوعات سیاسی",
      tone: 'semantic',
    },
    {
      german: "informieren",
      translated: "اطلاعات کسب کنید",
      tone: 'semantic',
    },
  ],
  "lid:state:HB:6|fr": [
    {
      german: "Wo können Sie",
      translated: "Où pouvez-vous",
      tone: 'semantic',
    },
    {
      german: "sich",
      translated: "vous",
      tone: 'semantic',
    },
    {
      german: "in Bremen",
      translated: "à Brême",
      tone: 'semantic',
    },
    {
      german: "über politische Themen",
      translated: "sur les questions politiques",
      tone: 'semantic',
    },
    {
      german: "informieren",
      translated: "informer",
      tone: 'semantic',
    },
  ],
  "lid:state:HB:6|hr": [
    {
      german: "Wo können Sie",
      translated: "Gdje",
      tone: 'semantic',
    },
    {
      german: "sich",
      translated: "se",
      tone: 'semantic',
    },
    {
      german: "in Bremen",
      translated: "u Bremenu",
      tone: 'semantic',
    },
    {
      german: "über politische Themen",
      translated: "o političkim temama",
      tone: 'semantic',
    },
    {
      german: "informieren",
      translated: "mogu dobiti informacije",
      tone: 'semantic',
    },
  ],
  "lid:state:HB:6|it": [
    {
      german: "Wo können Sie",
      translated: "Dove",
      tone: 'semantic',
    },
    {
      german: "sich",
      translated: "ci",
      tone: 'semantic',
    },
    {
      german: "in Bremen",
      translated: "a Brema",
      tone: 'semantic',
    },
    {
      german: "über politische Themen",
      translated: "su temi politici",
      tone: 'semantic',
    },
    {
      german: "informieren",
      translated: "si può informare",
      tone: 'semantic',
    },
  ],
  "lid:state:HB:6|kmr": [
    {
      german: "Wo können Sie",
      translated: "Li Bremen li ku",
      tone: 'semantic',
    },
    {
      german: "sich",
      translated: "dikarî",
      tone: 'semantic',
    },
    {
      german: "in Bremen",
      translated: "li",
      tone: 'semantic',
    },
    {
      german: "über politische Themen",
      translated: "ser mijarên siyasî",
      tone: 'semantic',
    },
    {
      german: "informieren",
      translated: "agahdarî bistînî",
      tone: 'semantic',
    },
  ],
  "lid:state:HB:6|pl": [
    {
      german: "Wo können Sie",
      translated: "Gdzie",
      tone: 'semantic',
    },
    {
      german: "in Bremen",
      translated: "w Brema",
      tone: 'semantic',
    },
    {
      german: "über politische Themen",
      translated: "na tematy polityczne",
      tone: 'semantic',
    },
    {
      german: "informieren",
      translated: "uzyskać informacje",
      tone: 'semantic',
    },
  ],
  "lid:state:HB:6|prs": [
    {
      german: "Wo können Sie",
      translated: "کجا می‌توانید",
      tone: 'semantic',
    },
    {
      german: "über politische Themen",
      translated: " دربارهٔ موضوعات سیاسی",
      tone: 'semantic',
    },
    {
      german: "informieren",
      translated: "اطلاعات کسب کنید",
      tone: 'semantic',
    },
  ],
  "lid:state:HB:6|ro": [
    {
      german: "Wo können Sie",
      translated: "Unde",
      tone: 'semantic',
    },
    {
      german: "sich",
      translated: "vă",
      tone: 'semantic',
    },
    {
      german: "in Bremen",
      translated: "în Bremen",
      tone: 'semantic',
    },
    {
      german: "über politische Themen",
      translated: " despre teme politice",
      tone: 'semantic',
    },
    {
      german: "informieren",
      translated: "puteți informa",
      tone: 'semantic',
    },
  ],
  "lid:state:HB:6|ru": [
    {
      german: "Wo können Sie",
      translated: "Где",
      tone: 'semantic',
    },
    {
      german: "in Bremen",
      translated: "в Бремене",
      tone: 'semantic',
    },
    {
      german: "über politische Themen",
      translated: "о политических темах",
      tone: 'semantic',
    },
    {
      german: "informieren",
      translated: "получить информацию",
      tone: 'semantic',
    },
  ],
  "lid:state:HB:6|sq": [
    {
      german: "Wo können Sie",
      translated: "Ku mund",
      tone: 'semantic',
    },
    {
      german: "sich",
      translated: "të",
      tone: 'semantic',
    },
    {
      german: "in Bremen",
      translated: "në Bremeni",
      tone: 'semantic',
    },
    {
      german: "über politische Themen",
      translated: "për tema politike",
      tone: 'semantic',
    },
    {
      german: "informieren",
      translated: "informoheni",
      tone: 'semantic',
    },
  ],
  "lid:state:HB:6|sr": [
    {
      german: "Wo können Sie",
      translated: "Gdje",
      tone: 'semantic',
    },
    {
      german: "sich",
      translated: "se",
      tone: 'semantic',
    },
    {
      german: "in Bremen",
      translated: "u Bremenu",
      tone: 'semantic',
    },
    {
      german: "über politische Themen",
      translated: "o političkim temama",
      tone: 'semantic',
    },
    {
      german: "informieren",
      translated: "mogu dobiti informacije",
      tone: 'semantic',
    },
  ],
  "lid:state:HB:6|tr": [
    {
      german: "Wo können Sie",
      translated: "nereden",
      tone: 'semantic',
    },
    {
      german: "in Bremen",
      translated: "Bremen eyaletinde",
      tone: 'semantic',
    },
    {
      german: "über politische Themen",
      translated: "siyasi konular hakkında",
      tone: 'semantic',
    },
    {
      german: "informieren",
      translated: "bilgi alabilirsiniz",
      tone: 'semantic',
    },
  ],
  "lid:state:HB:6|uk": [
    {
      german: "Wo können Sie",
      translated: "Де",
      tone: 'semantic',
    },
    {
      german: "in Bremen",
      translated: "в Бремені",
      tone: 'semantic',
    },
    {
      german: "über politische Themen",
      translated: "про політичні питання",
      tone: 'semantic',
    },
    {
      german: "informieren",
      translated: "отримати інформацію",
      tone: 'semantic',
    },
  ],
  "lid:state:HB:6|vi": [
    {
      german: "Wo können Sie",
      translated: "ở đâu",
      tone: 'semantic',
    },
    {
      german: "in Bremen",
      translated: "Ở Bremen",
      tone: 'semantic',
    },
    {
      german: "über politische Themen",
      translated: "về các chủ đề chính trị",
      tone: 'semantic',
    },
    {
      german: "informieren",
      translated: "tìm thông tin",
      tone: 'semantic',
    },
  ],
  "lid:state:HB:7|ar": [
    {
      german: "Was ist",
      translated: "أي مما يلي",
      tone: 'semantic',
    },
    {
      german: "ein deutscher Stadtstaat",
      translated: "مدينة-ولاية ألمانية؟",
      tone: 'semantic',
    },
  ],
  "lid:state:HB:7|bg": [
    {
      german: "Was ist",
      translated: "Коя от следните федерални провинции е",
      tone: 'semantic',
    },
    {
      german: "ein deutscher Stadtstaat",
      translated: "град-държава",
      tone: 'semantic',
    },
  ],
  "lid:state:HB:7|bs": [
    {
      german: "Was ist",
      translated: "Koja je",
      tone: 'semantic',
    },
    {
      german: "ein deutscher Stadtstaat",
      translated: "od navedenih saveznih zemalja grad-država",
      tone: 'semantic',
    },
  ],
  "lid:state:HB:7|el": [
    {
      german: "Was ist",
      translated: "Ποιο από τα",
      tone: 'semantic',
    },
    {
      german: "ein deutscher Stadtstaat",
      translated: "παρακάτω ομόσπονδα κρατίδια είναι πόλη-κράτος",
      tone: 'semantic',
    },
  ],
  "lid:state:HB:7|en": [
    {
      german: "Was ist",
      translated: "What is",
      tone: 'semantic',
    },
    {
      german: "ein deutscher Stadtstaat",
      translated: "a German city-state",
      tone: 'semantic',
    },
  ],
  "lid:state:HB:7|es": [
    {
      german: "Was ist",
      translated: "¿Cuál de los siguientes es",
      tone: 'semantic',
    },
    {
      german: "ein deutscher Stadtstaat",
      translated: "una ciudad-estado alemana",
      tone: 'semantic',
    },
  ],
  "lid:state:HB:7|fa": [
    {
      german: "Was ist",
      translated: "کدام",
      tone: 'semantic',
    },
    {
      german: "ein deutscher Stadtstaat",
      translated: "شهر-ایالت آلمان",
      tone: 'semantic',
    },
  ],
  "lid:state:HB:7|fr": [
    {
      german: "Was ist",
      translated: "Lequel des",
      tone: 'semantic',
    },
    {
      german: "ein deutscher Stadtstaat",
      translated: "une ville-État allemande",
      tone: 'semantic',
    },
  ],
  "lid:state:HB:7|hr": [
    {
      german: "Was ist",
      translated: "Koja je",
      tone: 'semantic',
    },
    {
      german: "ein deutscher Stadtstaat",
      translated: "navedenih saveznih zemalja grad-država",
      tone: 'semantic',
    },
  ],
  "lid:state:HB:7|it": [
    {
      german: "Was ist",
      translated: "Quale dei seguenti",
      tone: 'semantic',
    },
    {
      german: "ein deutscher Stadtstaat",
      translated: "una città-Stato",
      tone: 'semantic',
    },
  ],
  "lid:state:HB:7|kmr": [
    {
      german: "Was ist",
      translated: "Kîjan ji van",
      tone: 'semantic',
    },
    {
      german: "ein deutscher Stadtstaat",
      translated: "bajar-dewleteke Alman",
      tone: 'semantic',
    },
  ],
  "lid:state:HB:7|pl": [
    {
      german: "Was ist",
      translated: "Który",
      tone: 'semantic',
    },
    {
      german: "ein deutscher Stadtstaat",
      translated: "miastem-państwem?",
      tone: 'semantic',
    },
  ],
  "lid:state:HB:7|prs": [
    {
      german: "Was ist",
      translated: "کدام‌یک از موارد زیر",
      tone: 'semantic',
    },
    {
      german: "ein deutscher Stadtstaat",
      translated: "شهر-ایالت آلمان",
      tone: 'semantic',
    },
  ],
  "lid:state:HB:7|ro": [
    {
      german: "Was ist",
      translated: "Care dintre următoarele",
      tone: 'semantic',
    },
    {
      german: "ein deutscher Stadtstaat",
      translated: "landuri este un oraș-stat",
      tone: 'semantic',
    },
  ],
  "lid:state:HB:7|ru": [
    {
      german: "Was ist",
      translated: "Что",
      tone: 'semantic',
    },
    {
      german: "ein deutscher Stadtstaat",
      translated: "является немецким городом-землёй",
      tone: 'semantic',
    },
  ],
  "lid:state:HB:7|sq": [
    {
      german: "Was ist",
      translated: "Cili nga këto lande është",
      tone: 'semantic',
    },
    {
      german: "ein deutscher Stadtstaat",
      translated: "një qytet-shtet gjerman",
      tone: 'semantic',
    },
  ],
  "lid:state:HB:7|sr": [
    {
      german: "Was ist",
      translated: "Koja je",
      tone: 'semantic',
    },
    {
      german: "ein deutscher Stadtstaat",
      translated: "grad-država",
      tone: 'semantic',
    },
  ],
  "lid:state:HB:7|tr": [
    {
      german: "Was ist",
      translated: "Aşağıdakilerden hangisi",
      tone: 'semantic',
    },
    {
      german: "ein deutscher Stadtstaat",
      translated: "Almanya’da bir şehir devletidir?",
      tone: 'semantic',
    },
  ],
  "lid:state:HB:7|uk": [
    {
      german: "Was ist",
      translated: "Яке з наведених",
      tone: 'semantic',
    },
    {
      german: "ein deutscher Stadtstaat",
      translated: "міст є німецьким містом-землею",
      tone: 'semantic',
    },
  ],
  "lid:state:HB:7|vi": [
    {
      german: "Was ist",
      translated: "Bang nào",
      tone: 'semantic',
    },
    {
      german: "ein deutscher Stadtstaat",
      translated: "sau đây là một thành phố-bang",
      tone: 'semantic',
    },
  ],
  "lid:state:HB:8|ar": [
    {
      german: "Welches Bundesland",
      translated: "أي صورة",
      tone: 'semantic',
    },
    {
      german: "ist Bremen",
      translated: "Bremen",
      tone: 'semantic',
    },
  ],
  "lid:state:HB:8|bg": [
    {
      german: "Welches Bundesland",
      translated: "Коя от показаните федерални провинции",
      tone: 'semantic',
    },
    {
      german: "ist Bremen",
      translated: "е Бремен",
      tone: 'semantic',
    },
  ],
  "lid:state:HB:8|bs": [
    {
      german: "Welches Bundesland",
      translated: "Koja od prikazanih saveznih zemalja",
      tone: 'semantic',
    },
    {
      german: "ist Bremen",
      translated: "je Bremen",
      tone: 'semantic',
    },
  ],
  "lid:state:HB:8|el": [
    {
      german: "Welches Bundesland",
      translated: "Ποιο από τα εικονιζόμενα κρατίδια",
      tone: 'semantic',
    },
    {
      german: "ist Bremen",
      translated: "είναι το Βρέμη",
      tone: 'semantic',
    },
  ],
  "lid:state:HB:8|en": [
    {
      german: "Welches Bundesland",
      translated: "Which",
      tone: 'semantic',
    },
    {
      german: "ist Bremen",
      translated: "is Bremen",
      tone: 'semantic',
    },
  ],
  "lid:state:HB:8|es": [
    {
      german: "Welches Bundesland",
      translated: "estado federado",
      tone: 'semantic',
    },
    {
      german: "ist Bremen",
      translated: "Bremen",
      tone: 'semantic',
    },
  ],
  "lid:state:HB:8|fa": [
    {
      german: "Welches Bundesland",
      translated: "کدام ایالتِ",
      tone: 'semantic',
    },
    {
      german: "ist Bremen",
      translated: "نشان‌داده‌شده برمن است",
      tone: 'semantic',
    },
  ],
  "lid:state:HB:8|fr": [
    {
      german: "Welches Bundesland",
      translated: "Quel Land représenté",
      tone: 'semantic',
    },
    {
      german: "ist Bremen",
      translated: "est Brême",
      tone: 'semantic',
    },
  ],
  "lid:state:HB:8|hr": [
    {
      german: "Welches Bundesland",
      translated: "Koja od prikazanih saveznih zemalja",
      tone: 'semantic',
    },
    {
      german: "ist Bremen",
      translated: "je Bremen",
      tone: 'semantic',
    },
  ],
  "lid:state:HB:8|it": [
    {
      german: "Welches Bundesland",
      translated: "Quale Land",
      tone: 'semantic',
    },
    {
      german: "ist Bremen",
      translated: "è Brema",
      tone: 'semantic',
    },
  ],
  "lid:state:HB:8|kmr": [
    {
      german: "Welches Bundesland",
      translated: "Kîjan eyalet",
      tone: 'semantic',
    },
    {
      german: "ist Bremen",
      translated: "Bremen e",
      tone: 'semantic',
    },
  ],
  "lid:state:HB:8|pl": [
    {
      german: "Welches Bundesland",
      translated: "Który z przedstawionych krajów związkowych",
      tone: 'semantic',
    },
    {
      german: "ist Bremen",
      translated: "to Brema",
      tone: 'semantic',
    },
  ],
  "lid:state:HB:8|prs": [
    {
      german: "Welches Bundesland",
      translated: "کدام ایالتِ",
      tone: 'semantic',
    },
    {
      german: "ist Bremen",
      translated: "برمن است",
      tone: 'semantic',
    },
  ],
  "lid:state:HB:8|ro": [
    {
      german: "Welches Bundesland",
      translated: "Care land",
      tone: 'semantic',
    },
    {
      german: "ist Bremen",
      translated: "este Bremen",
      tone: 'semantic',
    },
  ],
  "lid:state:HB:8|ru": [
    {
      german: "Welches Bundesland",
      translated: "Какая из этих земель",
      tone: 'semantic',
    },
    {
      german: "ist Bremen",
      translated: "Бремен",
      tone: 'semantic',
    },
  ],
  "lid:state:HB:8|sq": [
    {
      german: "Welches Bundesland",
      translated: "Cili nga landet e paraqitura",
      tone: 'semantic',
    },
    {
      german: "ist Bremen",
      translated: "është Bremeni?",
      tone: 'semantic',
    },
  ],
  "lid:state:HB:8|sr": [
    {
      german: "Welches Bundesland",
      translated: "Koja od prikazanih saveznih pokrajina",
      tone: 'semantic',
    },
    {
      german: "ist Bremen",
      translated: "je Bremen?",
      tone: 'semantic',
    },
  ],
  "lid:state:HB:8|tr": [
    {
      german: "Welches Bundesland",
      translated: "Haritada",
      tone: 'semantic',
    },
    {
      german: "ist Bremen",
      translated: "Bremen eyaleti",
      tone: 'semantic',
    },
  ],
  "lid:state:HB:8|uk": [
    {
      german: "Welches Bundesland",
      translated: "Яка з позначених федеральних земель",
      tone: 'semantic',
    },
    {
      german: "ist Bremen",
      translated: "є Бремен",
      tone: 'semantic',
    },
  ],
  "lid:state:HB:8|vi": [
    {
      german: "Welches Bundesland",
      translated: "Bang nào trong các hình được hiển thị",
      tone: 'semantic',
    },
    {
      german: "ist Bremen",
      translated: "là Bremen?",
      tone: 'semantic',
    },
  ],
  "lid:state:HB:9|ar": [
    {
      german: "Wie nennt man",
      translated: "ماذا يُسمى",
      tone: 'semantic',
    },
    {
      german: "die Regierungschefin/den Regierungschef",
      translated: "رئيس/رئيسة حكومة",
      tone: 'semantic',
    },
    {
      german: "des Stadtstaates",
      translated: "مدينة-ولاية",
      tone: 'semantic',
    },
    {
      german: "Bremen",
      translated: "Bremen",
      tone: 'semantic',
    },
  ],
  "lid:state:HB:9|bg": [
    {
      german: "Wie nennt man",
      translated: "Как се нарича",
      tone: 'semantic',
    },
    {
      german: "die Regierungschefin/den Regierungschef",
      translated: "ръководителят на правителството",
      tone: 'semantic',
    },
    {
      german: "des Stadtstaates",
      translated: "на град-държавата",
      tone: 'semantic',
    },
    {
      german: "Bremen",
      translated: "Бремен",
      tone: 'semantic',
    },
  ],
  "lid:state:HB:9|bs": [
    {
      german: "Wie nennt man",
      translated: "Kako se zove",
      tone: 'semantic',
    },
    {
      german: "die Regierungschefin/den Regierungschef",
      translated: "šef vlade",
      tone: 'semantic',
    },
    {
      german: "des Stadtstaates",
      translated: "grada-države",
      tone: 'semantic',
    },
    {
      german: "Bremen",
      translated: "Bremen",
      tone: 'semantic',
    },
  ],
  "lid:state:HB:9|el": [
    {
      german: "Wie nennt man",
      translated: "Πώς ονομάζεται",
      tone: 'semantic',
    },
    {
      german: "die Regierungschefin/den Regierungschef",
      translated: "ο επικεφαλής της κυβέρνησης",
      tone: 'semantic',
    },
    {
      german: "des Stadtstaates",
      translated: "της πόλης-κράτους",
      tone: 'semantic',
    },
    {
      german: "Bremen",
      translated: "Βρέμη",
      tone: 'semantic',
    },
  ],
  "lid:state:HB:9|en": [
    {
      german: "Wie nennt man",
      translated: "What is",
      tone: 'semantic',
    },
    {
      german: "die Regierungschefin/den Regierungschef",
      translated: "the head of government",
      tone: 'semantic',
    },
    {
      german: "des Stadtstaates",
      translated: "in the city-state of",
      tone: 'semantic',
    },
    {
      german: "Bremen",
      translated: "Bremen",
      tone: 'semantic',
    },
  ],
  "lid:state:HB:9|es": [
    {
      german: "Wie nennt man",
      translated: "¿Cómo se llama",
      tone: 'semantic',
    },
    {
      german: "die Regierungschefin/den Regierungschef",
      translated: "al jefe o la jefa de gobierno",
      tone: 'semantic',
    },
    {
      german: "des Stadtstaates",
      translated: "de la ciudad-estado",
      tone: 'semantic',
    },
    {
      german: "Bremen",
      translated: "de Bremen",
      tone: 'semantic',
    },
  ],
  "lid:state:HB:9|fa": [
    {
      german: "Wie nennt man",
      translated: "چه عنوانی دارد",
      tone: 'semantic',
    },
    {
      german: "die Regierungschefin/den Regierungschef",
      translated: "رئیس دولت",
      tone: 'semantic',
    },
    {
      german: "des Stadtstaates",
      translated: "شهر-ایالت",
      tone: 'semantic',
    },
    {
      german: "Bremen",
      translated: "برمن",
      tone: 'semantic',
    },
  ],
  "lid:state:HB:9|fr": [
    {
      german: "Wie nennt man",
      translated: "Comment appelle-t-on",
      tone: 'semantic',
    },
    {
      german: "die Regierungschefin/den Regierungschef",
      translated: "le chef ou la cheffe du gouvernement",
      tone: 'semantic',
    },
    {
      german: "des Stadtstaates",
      translated: "de la ville-État",
      tone: 'semantic',
    },
    {
      german: "Bremen",
      translated: "Brême",
      tone: 'semantic',
    },
  ],
  "lid:state:HB:9|hr": [
    {
      german: "Wie nennt man",
      translated: "Kako se zove",
      tone: 'semantic',
    },
    {
      german: "die Regierungschefin/den Regierungschef",
      translated: "čelnik vlade",
      tone: 'semantic',
    },
    {
      german: "des Stadtstaates",
      translated: "grada-države",
      tone: 'semantic',
    },
    {
      german: "Bremen",
      translated: "Bremen",
      tone: 'semantic',
    },
  ],
  "lid:state:HB:9|it": [
    {
      german: "Wie nennt man",
      translated: "Come si chiama",
      tone: 'semantic',
    },
    {
      german: "die Regierungschefin/den Regierungschef",
      translated: "il capo del governo",
      tone: 'semantic',
    },
    {
      german: "des Stadtstaates",
      translated: "della città-Stato",
      tone: 'semantic',
    },
    {
      german: "Bremen",
      translated: "di Brema",
      tone: 'semantic',
    },
  ],
  "lid:state:HB:9|kmr": [
    {
      german: "Wie nennt man",
      translated: "Serokê",
      tone: 'semantic',
    },
    {
      german: "die Regierungschefin/den Regierungschef",
      translated: "hukûmeta bajar-dewleta",
      tone: 'semantic',
    },
    {
      german: "Bremen",
      translated: "Bremen",
      tone: 'semantic',
    },
  ],
  "lid:state:HB:9|pl": [
    {
      german: "Wie nennt man",
      translated: "Jak nazywa się",
      tone: 'semantic',
    },
    {
      german: "die Regierungschefin/den Regierungschef",
      translated: "szef rządu",
      tone: 'semantic',
    },
    {
      german: "des Stadtstaates",
      translated: "miasta-państwa",
      tone: 'semantic',
    },
    {
      german: "Bremen",
      translated: "Brema",
      tone: 'semantic',
    },
  ],
  "lid:state:HB:9|prs": [
    {
      german: "Wie nennt man",
      translated: "چه عنوانی دارد",
      tone: 'semantic',
    },
    {
      german: "die Regierungschefin/den Regierungschef",
      translated: "رئیس دولت",
      tone: 'semantic',
    },
    {
      german: "Bremen",
      translated: "برمن",
      tone: 'semantic',
    },
  ],
  "lid:state:HB:9|ro": [
    {
      german: "Wie nennt man",
      translated: "Cum se numește",
      tone: 'semantic',
    },
    {
      german: "die Regierungschefin/den Regierungschef",
      translated: "șeful guvernului",
      tone: 'semantic',
    },
    {
      german: "des Stadtstaates",
      translated: "orașului-stat",
      tone: 'semantic',
    },
    {
      german: "Bremen",
      translated: "Bremen",
      tone: 'semantic',
    },
  ],
  "lid:state:HB:9|ru": [
    {
      german: "Wie nennt man",
      translated: "Как называют",
      tone: 'semantic',
    },
    {
      german: "die Regierungschefin/den Regierungschef",
      translated: "главу правительства",
      tone: 'semantic',
    },
    {
      german: "des Stadtstaates",
      translated: "города-земли",
      tone: 'semantic',
    },
    {
      german: "Bremen",
      translated: "Бремен",
      tone: 'semantic',
    },
  ],
  "lid:state:HB:9|sq": [
    {
      german: "Wie nennt man",
      translated: "Si quhet",
      tone: 'semantic',
    },
    {
      german: "die Regierungschefin/den Regierungschef",
      translated: "kreu i qeverisë",
      tone: 'semantic',
    },
    {
      german: "des Stadtstaates",
      translated: "qytet-shtetit",
      tone: 'semantic',
    },
    {
      german: "Bremen",
      translated: "Bremeni?",
      tone: 'semantic',
    },
  ],
  "lid:state:HB:9|sr": [
    {
      german: "Wie nennt man",
      translated: "Kako se zove",
      tone: 'semantic',
    },
    {
      german: "die Regierungschefin/den Regierungschef",
      translated: "šef vlade",
      tone: 'semantic',
    },
    {
      german: "des Stadtstaates",
      translated: "grada-države",
      tone: 'semantic',
    },
    {
      german: "Bremen",
      translated: "Bremen",
      tone: 'semantic',
    },
  ],
  "lid:state:HB:9|tr": [
    {
      german: "Wie nennt man",
      translated: "ne ad verilir",
      tone: 'semantic',
    },
    {
      german: "die Regierungschefin/den Regierungschef",
      translated: "başındaki kişiye",
      tone: 'semantic',
    },
    {
      german: "des Stadtstaates",
      translated: "hükümetinin",
      tone: 'semantic',
    },
    {
      german: "Bremen",
      translated: "Bremen",
      tone: 'semantic',
    },
  ],
  "lid:state:HB:9|uk": [
    {
      german: "Wie nennt man",
      translated: "Як називають",
      tone: 'semantic',
    },
    {
      german: "die Regierungschefin/den Regierungschef",
      translated: "главу уряду",
      tone: 'semantic',
    },
    {
      german: "des Stadtstaates",
      translated: "міста-землі",
      tone: 'semantic',
    },
    {
      german: "Bremen",
      translated: "Бремен",
      tone: 'semantic',
    },
  ],
  "lid:state:HB:9|vi": [
    {
      german: "Wie nennt man",
      translated: "được gọi là gì",
      tone: 'semantic',
    },
    {
      german: "die Regierungschefin/den Regierungschef",
      translated: "Người đứng đầu chính phủ",
      tone: 'semantic',
    },
    {
      german: "des Stadtstaates",
      translated: "thành phố-bang",
      tone: 'semantic',
    },
    {
      german: "Bremen",
      translated: "Bremen",
      tone: 'semantic',
    },
  ],
  "lid:state:HE:10|ar": [
    {
      german: "Welche Ministerin",
      translated: "أي وزارة",
      tone: 'semantic',
    },
    {
      german: "welchen Minister",
      translated: "من الوزارات التالية",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "على",
      tone: 'semantic',
    },
    {
      german: "Hessen",
      translated: "ولاية Hessen",
      tone: 'semantic',
    },
    {
      german: "nicht",
      translated: "غير موجودة",
      tone: 'semantic',
    },
  ],
  "lid:state:HE:10|bg": [
    {
      german: "Welche Ministerin",
      translated: "Кой",
      tone: 'semantic',
    },
    {
      german: "welchen Minister",
      translated: "министър",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "съществува",
      tone: 'semantic',
    },
    {
      german: "Hessen",
      translated: "Хесен",
      tone: 'semantic',
    },
    {
      german: "nicht",
      translated: "не",
      tone: 'semantic',
    },
  ],
  "lid:state:HE:10|bs": [
    {
      german: "Welche Ministerin",
      translated: "Koji",
      tone: 'semantic',
    },
    {
      german: "welchen Minister",
      translated: "ministar",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "postoji",
      tone: 'semantic',
    },
    {
      german: "Hessen",
      translated: "na razini savezne zemlje Hessen",
      tone: 'semantic',
    },
    {
      german: "nicht",
      translated: "ne",
      tone: 'semantic',
    },
  ],
  "lid:state:HE:10|el": [
    {
      german: "Welche Ministerin",
      translated: "Ποιος",
      tone: 'semantic',
    },
    {
      german: "welchen Minister",
      translated: "υπουργός",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "υπάρχει",
      tone: 'semantic',
    },
    {
      german: "nicht",
      translated: "δεν",
      tone: 'semantic',
    },
  ],
  "lid:state:HE:10|en": [
    {
      german: "Welche Ministerin",
      translated: "Which minister",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "does",
      tone: 'semantic',
    },
    {
      german: "Hessen",
      translated: "Hessen",
      tone: 'semantic',
    },
    {
      german: "nicht",
      translated: "not",
      tone: 'semantic',
    },
  ],
  "lid:state:HE:10|es": [
    {
      german: "welchen Minister",
      translated: "ministerio",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "existe",
      tone: 'semantic',
    },
    {
      german: "Hessen",
      translated: "Hesse",
      tone: 'semantic',
    },
    {
      german: "nicht",
      translated: "NO",
      tone: 'semantic',
    },
  ],
  "lid:state:HE:10|fa": [
    {
      german: "Welche Ministerin",
      translated: "کدام وزیر",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "در",
      tone: 'semantic',
    },
    {
      german: "Hessen",
      translated: "هسن",
      tone: 'semantic',
    },
    {
      german: "nicht",
      translated: "وجود ندارد",
      tone: 'semantic',
    },
  ],
  "lid:state:HE:10|fr": [
    {
      german: "Welche Ministerin",
      translated: "quelle ministre",
      tone: 'semantic',
    },
    {
      german: "welchen Minister",
      translated: "Quel ministre",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "existe",
      tone: 'semantic',
    },
    {
      german: "Hessen",
      translated: "Hesse",
      tone: 'semantic',
    },
    {
      german: "nicht",
      translated: "pas",
      tone: 'semantic',
    },
  ],
  "lid:state:HE:10|hr": [
    {
      german: "Welche Ministerin",
      translated: "Koji",
      tone: 'semantic',
    },
    {
      german: "welchen Minister",
      translated: "ministar",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "postoji",
      tone: 'semantic',
    },
    {
      german: "Hessen",
      translated: "na razini savezne zemlje Hessen",
      tone: 'semantic',
    },
    {
      german: "nicht",
      translated: "ne",
      tone: 'semantic',
    },
  ],
  "lid:state:HE:10|it": [
    {
      german: "Welche Ministerin",
      translated: "Quale ministro",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "esiste",
      tone: 'semantic',
    },
    {
      german: "Hessen",
      translated: "Land di Assia",
      tone: 'semantic',
    },
    {
      german: "nicht",
      translated: "non",
      tone: 'semantic',
    },
  ],
  "lid:state:HE:10|kmr": [
    {
      german: "Welche Ministerin",
      translated: "Kîjan",
      tone: 'semantic',
    },
    {
      german: "welchen Minister",
      translated: "wezîr",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "tune",
      tone: 'semantic',
    },
    {
      german: "Hessen",
      translated: "Hessen",
      tone: 'semantic',
    },
    {
      german: "nicht",
      translated: "ye",
      tone: 'semantic',
    },
  ],
  "lid:state:HE:10|pl": [
    {
      german: "welchen Minister",
      translated: "Którego ministra",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "ma",
      tone: 'semantic',
    },
    {
      german: "Hessen",
      translated: "Hesja",
      tone: 'semantic',
    },
    {
      german: "nicht",
      translated: "nie",
      tone: 'semantic',
    },
  ],
  "lid:state:HE:10|prs": [
    {
      german: "Welche Ministerin",
      translated: "کدام",
      tone: 'semantic',
    },
    {
      german: "welchen Minister",
      translated: "وزیر",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "وجود",
      tone: 'semantic',
    },
    {
      german: "Hessen",
      translated: "هسن",
      tone: 'semantic',
    },
    {
      german: "nicht",
      translated: "ندارد",
      tone: 'semantic',
    },
  ],
  "lid:state:HE:10|ro": [
    {
      german: "Welche Ministerin",
      translated: "Care ministru",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "există",
      tone: 'semantic',
    },
    {
      german: "Hessen",
      translated: "Hessa",
      tone: 'semantic',
    },
    {
      german: "nicht",
      translated: "nu",
      tone: 'semantic',
    },
  ],
  "lid:state:HE:10|ru": [
    {
      german: "Welche Ministerin",
      translated: "Какого министра",
      tone: 'semantic',
    },
    {
      german: "Hessen",
      translated: "Гессен",
      tone: 'semantic',
    },
    {
      german: "nicht",
      translated: "нет",
      tone: 'semantic',
    },
  ],
  "lid:state:HE:10|sq": [
    {
      german: "welchen Minister",
      translated: "Cili ministër",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "ekziston",
      tone: 'semantic',
    },
    {
      german: "Hessen",
      translated: "Hesseni",
      tone: 'semantic',
    },
    {
      german: "nicht",
      translated: "nuk",
      tone: 'semantic',
    },
  ],
  "lid:state:HE:10|sr": [
    {
      german: "Welche Ministerin",
      translated: "Koji",
      tone: 'semantic',
    },
    {
      german: "welchen Minister",
      translated: "ministar",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "postoji",
      tone: 'semantic',
    },
    {
      german: "Hessen",
      translated: "na razini savezne pokrajine Hesen",
      tone: 'semantic',
    },
    {
      german: "nicht",
      translated: "ne",
      tone: 'semantic',
    },
  ],
  "lid:state:HE:10|tr": [
    {
      german: "Welche Ministerin",
      translated: "aşağıdaki bakanlıklardan hangisi",
      tone: 'semantic',
    },
    {
      german: "Hessen",
      translated: "Hessen eyaletinde",
      tone: 'semantic',
    },
    {
      german: "nicht",
      translated: "yoktur",
      tone: 'semantic',
    },
  ],
  "lid:state:HE:10|uk": [
    {
      german: "Welche Ministerin",
      translated: "міністерки",
      tone: 'semantic',
    },
    {
      german: "welchen Minister",
      translated: "міністра",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "немає",
      tone: 'semantic',
    },
    {
      german: "Hessen",
      translated: "Гессен",
      tone: 'semantic',
    },
  ],
  "lid:state:HE:10|vi": [
    {
      german: "welchen Minister",
      translated: "Bộ trưởng nào",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "tồn tại",
      tone: 'semantic',
    },
    {
      german: "Hessen",
      translated: "Hessen",
      tone: 'semantic',
    },
    {
      german: "nicht",
      translated: "không",
      tone: 'semantic',
    },
  ],
  "lid:state:HE:1|ar": [
    {
      german: "Welches Wappen",
      translated: "أي شعار من الصور",
      tone: 'semantic',
    },
    {
      german: "gehört zum",
      translated: "يعود إلى",
      tone: 'semantic',
    },
    {
      german: "Bundesland Hessen",
      translated: "ولاية Hessen",
      tone: 'semantic',
    },
  ],
  "lid:state:HE:1|bg": [
    {
      german: "Welches Wappen",
      translated: "Кой герб",
      tone: 'semantic',
    },
    {
      german: "gehört zum",
      translated: "на",
      tone: 'semantic',
    },
    {
      german: "Bundesland Hessen",
      translated: "Хесен",
      tone: 'semantic',
    },
  ],
  "lid:state:HE:1|bs": [
    {
      german: "Welches Wappen",
      translated: "Koji grb",
      tone: 'semantic',
    },
    {
      german: "gehört zum",
      translated: "pripada",
      tone: 'semantic',
    },
    {
      german: "Bundesland Hessen",
      translated: "saveznoj zemlji Hessen?",
      tone: 'semantic',
    },
  ],
  "lid:state:HE:1|el": [
    {
      german: "Welches Wappen",
      translated: "Ποιο έμβλημα",
      tone: 'semantic',
    },
    {
      german: "gehört zum",
      translated: "ανήκει στο ομόσπονδο",
      tone: 'semantic',
    },
    {
      german: "Bundesland Hessen",
      translated: "κρατίδιο Έσση",
      tone: 'semantic',
    },
  ],
  "lid:state:HE:1|en": [
    {
      german: "Welches Wappen",
      translated: "Which coat of arms",
      tone: 'semantic',
    },
    {
      german: "gehört zum",
      translated: "belongs to",
      tone: 'semantic',
    },
    {
      german: "Bundesland Hessen",
      translated: "the federal state of Hessen",
      tone: 'semantic',
    },
  ],
  "lid:state:HE:1|es": [
    {
      german: "Welches Wappen",
      translated: "¿Qué escudo",
      tone: 'semantic',
    },
    {
      german: "gehört zum",
      translated: "pertenece al",
      tone: 'semantic',
    },
    {
      german: "Bundesland Hessen",
      translated: "estado federado de Hesse",
      tone: 'semantic',
    },
  ],
  "lid:state:HE:1|fa": [
    {
      german: "Welches Wappen",
      translated: "کدام نشان",
      tone: 'semantic',
    },
    {
      german: "gehört zum",
      translated: "متعلق به",
      tone: 'semantic',
    },
    {
      german: "Bundesland Hessen",
      translated: "ایالت هسن",
      tone: 'semantic',
    },
  ],
  "lid:state:HE:1|fr": [
    {
      german: "Welches Wappen",
      translated: "Quel blason",
      tone: 'semantic',
    },
    {
      german: "gehört zum",
      translated: "appartient au",
      tone: 'semantic',
    },
    {
      german: "Bundesland Hessen",
      translated: "Land de Hesse",
      tone: 'semantic',
    },
  ],
  "lid:state:HE:1|hr": [
    {
      german: "Welches Wappen",
      translated: "Koji grb",
      tone: 'semantic',
    },
    {
      german: "gehört zum",
      translated: "pripada",
      tone: 'semantic',
    },
    {
      german: "Bundesland Hessen",
      translated: "saveznoj zemlji Hessen?",
      tone: 'semantic',
    },
  ],
  "lid:state:HE:1|it": [
    {
      german: "Welches Wappen",
      translated: "Quale stemma",
      tone: 'semantic',
    },
    {
      german: "gehört zum",
      translated: "appartiene al Land di",
      tone: 'semantic',
    },
    {
      german: "Bundesland Hessen",
      translated: "Assia",
      tone: 'semantic',
    },
  ],
  "lid:state:HE:1|kmr": [
    {
      german: "Welches Wappen",
      translated: "Kîjan nîşan",
      tone: 'semantic',
    },
    {
      german: "gehört zum",
      translated: "a eyaleta",
      tone: 'semantic',
    },
    {
      german: "Bundesland Hessen",
      translated: "Hessen ye?",
      tone: 'semantic',
    },
  ],
  "lid:state:HE:1|pl": [
    {
      german: "Welches Wappen",
      translated: "Który herb",
      tone: 'semantic',
    },
    {
      german: "gehört zum",
      translated: "należy do",
      tone: 'semantic',
    },
    {
      german: "Bundesland Hessen",
      translated: "kraju związkowego Hesja",
      tone: 'semantic',
    },
  ],
  "lid:state:HE:1|prs": [
    {
      german: "Welches Wappen",
      translated: "کدام نشان",
      tone: 'semantic',
    },
    {
      german: "gehört zum",
      translated: "متعلق به",
      tone: 'semantic',
    },
    {
      german: "Bundesland Hessen",
      translated: "ایالت هسن",
      tone: 'semantic',
    },
  ],
  "lid:state:HE:1|ro": [
    {
      german: "Welches Wappen",
      translated: "Care stemă",
      tone: 'semantic',
    },
    {
      german: "gehört zum",
      translated: "aparține",
      tone: 'semantic',
    },
    {
      german: "Bundesland Hessen",
      translated: "landului Hessa",
      tone: 'semantic',
    },
  ],
  "lid:state:HE:1|ru": [
    {
      german: "Welches Wappen",
      translated: "Какой герб",
      tone: 'semantic',
    },
    {
      german: "gehört zum",
      translated: "принадлежит",
      tone: 'semantic',
    },
    {
      german: "Bundesland Hessen",
      translated: "федеральной земле Гессен",
      tone: 'semantic',
    },
  ],
  "lid:state:HE:1|sq": [
    {
      german: "Welches Wappen",
      translated: "Cila stemë",
      tone: 'semantic',
    },
    {
      german: "gehört zum",
      translated: "i përket",
      tone: 'semantic',
    },
    {
      german: "Bundesland Hessen",
      translated: "landit Hesseni",
      tone: 'semantic',
    },
  ],
  "lid:state:HE:1|sr": [
    {
      german: "Welches Wappen",
      translated: "Koji grb",
      tone: 'semantic',
    },
    {
      german: "gehört zum",
      translated: "pripada",
      tone: 'semantic',
    },
    {
      german: "Bundesland Hessen",
      translated: "saveznoj pokrajini Hesen",
      tone: 'semantic',
    },
  ],
  "lid:state:HE:1|tr": [
    {
      german: "Welches Wappen",
      translated: "arması",
      tone: 'semantic',
    },
    {
      german: "gehört zum",
      translated: "hangisidir",
      tone: 'semantic',
    },
    {
      german: "Bundesland Hessen",
      translated: "Hessen eyaletinin",
      tone: 'semantic',
    },
  ],
  "lid:state:HE:1|uk": [
    {
      german: "Welches Wappen",
      translated: "Який герб",
      tone: 'semantic',
    },
    {
      german: "gehört zum",
      translated: "належить",
      tone: 'semantic',
    },
    {
      german: "Bundesland Hessen",
      translated: "федеральній землі Гессен",
      tone: 'semantic',
    },
  ],
  "lid:state:HE:1|vi": [
    {
      german: "Welches Wappen",
      translated: "Quốc huy nào",
      tone: 'semantic',
    },
    {
      german: "gehört zum",
      translated: "thuộc",
      tone: 'semantic',
    },
    {
      german: "Bundesland Hessen",
      translated: "bang Hessen",
      tone: 'semantic',
    },
  ],
  "lid:state:HE:2|ar": [
    {
      german: "Welches ist",
      translated: "أي مما يلي",
      tone: 'semantic',
    },
    {
      german: "ein Landkreis",
      translated: "دائرة إدارية (Landkreis)",
      tone: 'semantic',
    },
    {
      german: "in Hessen",
      translated: "Hessen",
      tone: 'semantic',
    },
  ],
  "lid:state:HE:2|bg": [
    {
      german: "Welches ist",
      translated: "Кое",
      tone: 'semantic',
    },
    {
      german: "ein Landkreis",
      translated: "окръг (Landkreis)",
      tone: 'semantic',
    },
    {
      german: "in Hessen",
      translated: "в Хесен",
      tone: 'semantic',
    },
  ],
  "lid:state:HE:2|bs": [
    {
      german: "Welches ist",
      translated: "Što je od navedenoga",
      tone: 'semantic',
    },
    {
      german: "ein Landkreis",
      translated: "okrug (Landkreis)",
      tone: 'semantic',
    },
    {
      german: "in Hessen",
      translated: "u saveznoj zemlji Hessen",
      tone: 'semantic',
    },
  ],
  "lid:state:HE:2|el": [
    {
      german: "Welches ist",
      translated: "Ποιο",
      tone: 'semantic',
    },
    {
      german: "ein Landkreis",
      translated: "διοικητική περιφέρεια (Landkreis)",
      tone: 'semantic',
    },
    {
      german: "in Hessen",
      translated: "στο Έσση",
      tone: 'semantic',
    },
  ],
  "lid:state:HE:2|en": [
    {
      german: "Welches ist",
      translated: "Which",
      tone: 'semantic',
    },
    {
      german: "ein Landkreis",
      translated: "a district",
      tone: 'semantic',
    },
    {
      german: "in Hessen",
      translated: "in Hessen",
      tone: 'semantic',
    },
  ],
  "lid:state:HE:2|es": [
    {
      german: "Welches ist",
      translated: "¿Cuál de los siguientes es",
      tone: 'semantic',
    },
    {
      german: "ein Landkreis",
      translated: "un distrito (Landkreis)",
      tone: 'semantic',
    },
    {
      german: "in Hessen",
      translated: "de Hesse",
      tone: 'semantic',
    },
  ],
  "lid:state:HE:2|fa": [
    {
      german: "Welches ist",
      translated: "کدام‌یک",
      tone: 'semantic',
    },
    {
      german: "ein Landkreis",
      translated: "شهرستان (Landkreis)",
      tone: 'semantic',
    },
    {
      german: "in Hessen",
      translated: "در هسن",
      tone: 'semantic',
    },
  ],
  "lid:state:HE:2|fr": [
    {
      german: "Welches ist",
      translated: "Lequel",
      tone: 'semantic',
    },
    {
      german: "ein Landkreis",
      translated: "un arrondissement (Landkreis)",
      tone: 'semantic',
    },
    {
      german: "in Hessen",
      translated: "de Hesse",
      tone: 'semantic',
    },
  ],
  "lid:state:HE:2|hr": [
    {
      german: "Welches ist",
      translated: "Što je od navedenoga",
      tone: 'semantic',
    },
    {
      german: "ein Landkreis",
      translated: "okrug (Landkreis)",
      tone: 'semantic',
    },
    {
      german: "in Hessen",
      translated: "u saveznoj zemlji Hessen",
      tone: 'semantic',
    },
  ],
  "lid:state:HE:2|it": [
    {
      german: "Welches ist",
      translated: "Quale dei seguenti è",
      tone: 'semantic',
    },
    {
      german: "ein Landkreis",
      translated: "un distretto (Landkreis)",
      tone: 'semantic',
    },
    {
      german: "in Hessen",
      translated: "di Assia",
      tone: 'semantic',
    },
  ],
  "lid:state:HE:2|kmr": [
    {
      german: "Welches ist",
      translated: "Kîjan ji",
      tone: 'semantic',
    },
    {
      german: "ein Landkreis",
      translated: "van navçeyek (Landkreis)",
      tone: 'semantic',
    },
    {
      german: "in Hessen",
      translated: "li Hessen ye",
      tone: 'semantic',
    },
  ],
  "lid:state:HE:2|pl": [
    {
      german: "Welches ist",
      translated: "Który z",
      tone: 'semantic',
    },
    {
      german: "ein Landkreis",
      translated: "powiatem (Landkreis)",
      tone: 'semantic',
    },
    {
      german: "in Hessen",
      translated: "w Hesja",
      tone: 'semantic',
    },
  ],
  "lid:state:HE:2|prs": [
    {
      german: "Welches ist",
      translated: "کدام‌یک",
      tone: 'semantic',
    },
    {
      german: "ein Landkreis",
      translated: "یک شهرستان (Landkreis)",
      tone: 'semantic',
    },
    {
      german: "in Hessen",
      translated: "در هسن",
      tone: 'semantic',
    },
  ],
  "lid:state:HE:2|ro": [
    {
      german: "Welches ist",
      translated: "Care dintre următoarele",
      tone: 'semantic',
    },
    {
      german: "ein Landkreis",
      translated: "district",
      tone: 'semantic',
    },
    {
      german: "in Hessen",
      translated: "din Hessa",
      tone: 'semantic',
    },
  ],
  "lid:state:HE:2|ru": [
    {
      german: "Welches ist",
      translated: "Какой из",
      tone: 'semantic',
    },
    {
      german: "ein Landkreis",
      translated: "районом",
      tone: 'semantic',
    },
    {
      german: "in Hessen",
      translated: "в федеральной земле Гессен",
      tone: 'semantic',
    },
  ],
  "lid:state:HE:2|sq": [
    {
      german: "Welches ist",
      translated: "Cila nga këto është",
      tone: 'semantic',
    },
    {
      german: "ein Landkreis",
      translated: "qark (Landkreis)",
      tone: 'semantic',
    },
    {
      german: "in Hessen",
      translated: "në Hesseni",
      tone: 'semantic',
    },
  ],
  "lid:state:HE:2|sr": [
    {
      german: "Welches ist",
      translated: "Šta je od navedenoga",
      tone: 'semantic',
    },
    {
      german: "ein Landkreis",
      translated: "okrug (Landkreis)",
      tone: 'semantic',
    },
    {
      german: "in Hessen",
      translated: "u saveznoj pokrajini Hesen",
      tone: 'semantic',
    },
  ],
  "lid:state:HE:2|tr": [
    {
      german: "Welches ist",
      translated: "Aşağıdakilerden hangisi",
      tone: 'semantic',
    },
    {
      german: "ein Landkreis",
      translated: "bir Landkreis (ilçe/idari bölge)dir",
      tone: 'semantic',
    },
    {
      german: "in Hessen",
      translated: "Hessen eyaletinde bulunan",
      tone: 'semantic',
    },
  ],
  "lid:state:HE:2|uk": [
    {
      german: "Welches ist",
      translated: "Який із",
      tone: 'semantic',
    },
    {
      german: "ein Landkreis",
      translated: "районів",
      tone: 'semantic',
    },
    {
      german: "in Hessen",
      translated: "у федеральній землі Гессен",
      tone: 'semantic',
    },
  ],
  "lid:state:HE:2|vi": [
    {
      german: "Welches ist",
      translated: "Địa danh nào sau đây là",
      tone: 'semantic',
    },
    {
      german: "ein Landkreis",
      translated: "một huyện",
      tone: 'semantic',
    },
    {
      german: "in Hessen",
      translated: "của bang Hessen",
      tone: 'semantic',
    },
  ],
  "lid:state:HE:3|ar": [
    {
      german: "Für wie viele Jahre",
      translated: "لمدة كم سنة",
      tone: 'semantic',
    },
    {
      german: "Landtag",
      translated: "برلمان الولاية في",
      tone: 'semantic',
    },
    {
      german: "Hessen",
      translated: "Hessen",
      tone: 'semantic',
    },
    {
      german: "gewählt",
      translated: "يُنتخب",
      tone: 'semantic',
    },
  ],
  "lid:state:HE:3|bg": [
    {
      german: "Für wie viele Jahre",
      translated: "За колко години",
      tone: 'semantic',
    },
    {
      german: "Landtag",
      translated: "парламентът",
      tone: 'semantic',
    },
    {
      german: "Hessen",
      translated: "Хесен",
      tone: 'semantic',
    },
    {
      german: "gewählt",
      translated: "избира",
      tone: 'semantic',
    },
  ],
  "lid:state:HE:3|bs": [
    {
      german: "Für wie viele Jahre",
      translated: "koliko se godina",
      tone: 'semantic',
    },
    {
      german: "Landtag",
      translated: "parlament savezne zemlje",
      tone: 'semantic',
    },
    {
      german: "Hessen",
      translated: "Hessen",
      tone: 'semantic',
    },
    {
      german: "gewählt",
      translated: "bira",
      tone: 'semantic',
    },
  ],
  "lid:state:HE:3|el": [
    {
      german: "Für wie viele Jahre",
      translated: "Για πόσα χρόνια",
      tone: 'semantic',
    },
    {
      german: "Landtag",
      translated: "Landtag",
      tone: 'semantic',
    },
    {
      german: "Hessen",
      translated: "Έσση",
      tone: 'semantic',
    },
    {
      german: "gewählt",
      translated: "εκλέγεται",
      tone: 'semantic',
    },
  ],
  "lid:state:HE:3|en": [
    {
      german: "Für wie viele Jahre",
      translated: "how many years",
      tone: 'semantic',
    },
    {
      german: "Landtag",
      translated: "state parliament",
      tone: 'semantic',
    },
    {
      german: "Hessen",
      translated: "Hessen",
      tone: 'semantic',
    },
    {
      german: "gewählt",
      translated: "elected",
      tone: 'semantic',
    },
  ],
  "lid:state:HE:3|es": [
    {
      german: "Für wie viele Jahre",
      translated: "cuántos años",
      tone: 'semantic',
    },
    {
      german: "Landtag",
      translated: "parlamento regional",
      tone: 'semantic',
    },
    {
      german: "Hessen",
      translated: "Hesse",
      tone: 'semantic',
    },
    {
      german: "gewählt",
      translated: "se elige",
      tone: 'semantic',
    },
  ],
  "lid:state:HE:3|fa": [
    {
      german: "Für wie viele Jahre",
      translated: "چند سال",
      tone: 'semantic',
    },
    {
      german: "Landtag",
      translated: "پارلمان ایالتی",
      tone: 'semantic',
    },
    {
      german: "Hessen",
      translated: "هسن",
      tone: 'semantic',
    },
    {
      german: "gewählt",
      translated: "انتخاب می‌شود",
      tone: 'semantic',
    },
  ],
  "lid:state:HE:3|fr": [
    {
      german: "Für wie viele Jahre",
      translated: "Pour combien d’années",
      tone: 'semantic',
    },
    {
      german: "Landtag",
      translated: "le Landtag",
      tone: 'semantic',
    },
    {
      german: "Hessen",
      translated: "de Hesse",
      tone: 'semantic',
    },
    {
      german: "gewählt",
      translated: "est-il élu",
      tone: 'semantic',
    },
  ],
  "lid:state:HE:3|hr": [
    {
      german: "Für wie viele Jahre",
      translated: "Na koliko se godina",
      tone: 'semantic',
    },
    {
      german: "Landtag",
      translated: "parlament savezne zemlje",
      tone: 'semantic',
    },
    {
      german: "Hessen",
      translated: "Hessen",
      tone: 'semantic',
    },
    {
      german: "gewählt",
      translated: "bira",
      tone: 'semantic',
    },
  ],
  "lid:state:HE:3|it": [
    {
      german: "Für wie viele Jahre",
      translated: "Per quanti anni",
      tone: 'semantic',
    },
    {
      german: "Landtag",
      translated: "il Landtag",
      tone: 'semantic',
    },
    {
      german: "Hessen",
      translated: "Assia",
      tone: 'semantic',
    },
    {
      german: "gewählt",
      translated: "viene eletto",
      tone: 'semantic',
    },
  ],
  "lid:state:HE:3|kmr": [
    {
      german: "Für wie viele Jahre",
      translated: "ji bo çend salan",
      tone: 'semantic',
    },
    {
      german: "Landtag",
      translated: "Landtag",
      tone: 'semantic',
    },
    {
      german: "Hessen",
      translated: "a Hessen",
      tone: 'semantic',
    },
    {
      german: "gewählt",
      translated: "tê hilbijartin",
      tone: 'semantic',
    },
  ],
  "lid:state:HE:3|pl": [
    {
      german: "Für wie viele Jahre",
      translated: "ile lat",
      tone: 'semantic',
    },
    {
      german: "Landtag",
      translated: "parlament",
      tone: 'semantic',
    },
    {
      german: "Hessen",
      translated: "Hesja",
      tone: 'semantic',
    },
    {
      german: "gewählt",
      translated: "wybierany",
      tone: 'semantic',
    },
  ],
  "lid:state:HE:3|prs": [
    {
      german: "Für wie viele Jahre",
      translated: "چند سال",
      tone: 'semantic',
    },
    {
      german: "Landtag",
      translated: "پارلمان ایالتی",
      tone: 'semantic',
    },
    {
      german: "Hessen",
      translated: "هسن",
      tone: 'semantic',
    },
    {
      german: "gewählt",
      translated: "انتخاب می‌شود",
      tone: 'semantic',
    },
  ],
  "lid:state:HE:3|ro": [
    {
      german: "Für wie viele Jahre",
      translated: "Pentru câți ani",
      tone: 'semantic',
    },
    {
      german: "Landtag",
      translated: "parlamentul",
      tone: 'semantic',
    },
    {
      german: "Hessen",
      translated: "landului Hessa",
      tone: 'semantic',
    },
    {
      german: "gewählt",
      translated: "este ales",
      tone: 'semantic',
    },
  ],
  "lid:state:HE:3|ru": [
    {
      german: "Für wie viele Jahre",
      translated: "На сколько лет",
      tone: 'semantic',
    },
    {
      german: "Landtag",
      translated: "ландтаг",
      tone: 'semantic',
    },
    {
      german: "Hessen",
      translated: "Гессен",
      tone: 'semantic',
    },
    {
      german: "gewählt",
      translated: "избирается",
      tone: 'semantic',
    },
  ],
  "lid:state:HE:3|sq": [
    {
      german: "Für wie viele Jahre",
      translated: "Për sa vjet",
      tone: 'semantic',
    },
    {
      german: "Landtag",
      translated: "Landtagu",
      tone: 'semantic',
    },
    {
      german: "Hessen",
      translated: "Hesseni",
      tone: 'semantic',
    },
    {
      german: "gewählt",
      translated: "zgjidhet",
      tone: 'semantic',
    },
  ],
  "lid:state:HE:3|sr": [
    {
      german: "Für wie viele Jahre",
      translated: "Na koliko se godina",
      tone: 'semantic',
    },
    {
      german: "Landtag",
      translated: "parlament savezne",
      tone: 'semantic',
    },
    {
      german: "Hessen",
      translated: "Hesen",
      tone: 'semantic',
    },
    {
      german: "gewählt",
      translated: "bira",
      tone: 'semantic',
    },
  ],
  "lid:state:HE:3|tr": [
    {
      german: "Für wie viele Jahre",
      translated: "kaç yıllığına",
      tone: 'semantic',
    },
    {
      german: "Landtag",
      translated: "eyalet parlamentosu",
      tone: 'semantic',
    },
    {
      german: "Hessen",
      translated: "Hessen",
      tone: 'semantic',
    },
    {
      german: "gewählt",
      translated: "seçilir?",
      tone: 'semantic',
    },
  ],
  "lid:state:HE:3|uk": [
    {
      german: "Für wie viele Jahre",
      translated: "На скільки років",
      tone: 'semantic',
    },
    {
      german: "Landtag",
      translated: "земельний парламент",
      tone: 'semantic',
    },
    {
      german: "Hessen",
      translated: "Гессен",
      tone: 'semantic',
    },
    {
      german: "gewählt",
      translated: "обирають",
      tone: 'semantic',
    },
  ],
  "lid:state:HE:3|vi": [
    {
      german: "Für wie viele Jahre",
      translated: "nhiệm kỳ bao nhiêu năm",
      tone: 'semantic',
    },
    {
      german: "Landtag",
      translated: "Nghị viện bang (Landtag)",
      tone: 'semantic',
    },
    {
      german: "Hessen",
      translated: "Hessen",
      tone: 'semantic',
    },
    {
      german: "gewählt",
      translated: "được bầu",
      tone: 'semantic',
    },
  ],
  "lid:state:HE:4|ar": [
    {
      german: "Ab welchem Alter",
      translated: "ابتداءً من أي سن",
      tone: 'semantic',
    },
    {
      german: "darf man",
      translated: "يحق",
      tone: 'semantic',
    },
    {
      german: "in Hessen",
      translated: "في Hessen",
      tone: 'semantic',
    },
    {
      german: "bei Kommunalwahlen",
      translated: "في الانتخابات المحلية",
      tone: 'semantic',
    },
    {
      german: "wählen",
      translated: "التصويت",
      tone: 'semantic',
    },
  ],
  "lid:state:HE:4|bg": [
    {
      german: "Ab welchem Alter",
      translated: "От каква възраст",
      tone: 'semantic',
    },
    {
      german: "darf man",
      translated: "може да се",
      tone: 'semantic',
    },
    {
      german: "in Hessen",
      translated: "в Хесен",
      tone: 'semantic',
    },
    {
      german: "bei Kommunalwahlen",
      translated: "на общински избори",
      tone: 'semantic',
    },
    {
      german: "wählen",
      translated: "гласува",
      tone: 'semantic',
    },
  ],
  "lid:state:HE:4|bs": [
    {
      german: "Ab welchem Alter",
      translated: "Od koje se dobi",
      tone: 'semantic',
    },
    {
      german: "darf man",
      translated: "može",
      tone: 'semantic',
    },
    {
      german: "in Hessen",
      translated: "u saveznoj zemlji Hessen",
      tone: 'semantic',
    },
    {
      german: "bei Kommunalwahlen",
      translated: "na lokalnim izborima",
      tone: 'semantic',
    },
    {
      german: "wählen",
      translated: "glasovati",
      tone: 'semantic',
    },
  ],
  "lid:state:HE:4|el": [
    {
      german: "Ab welchem Alter",
      translated: "Από ποια ηλικία",
      tone: 'semantic',
    },
    {
      german: "darf man",
      translated: "μπορεί κάποιος",
      tone: 'semantic',
    },
    {
      german: "bei Kommunalwahlen",
      translated: "στις δημοτικές εκλογές",
      tone: 'semantic',
    },
    {
      german: "wählen",
      translated: "να ψηφίσει",
      tone: 'semantic',
    },
  ],
  "lid:state:HE:4|en": [
    {
      german: "Ab welchem Alter",
      translated: "From what age",
      tone: 'semantic',
    },
    {
      german: "darf man",
      translated: "can you",
      tone: 'semantic',
    },
    {
      german: "in Hessen",
      translated: "in Hessen",
      tone: 'semantic',
    },
    {
      german: "bei Kommunalwahlen",
      translated: "local elections",
      tone: 'semantic',
    },
    {
      german: "wählen",
      translated: "vote",
      tone: 'semantic',
    },
  ],
  "lid:state:HE:4|es": [
    {
      german: "Ab welchem Alter",
      translated: "¿A partir de qué edad",
      tone: 'semantic',
    },
    {
      german: "darf man",
      translated: "se puede",
      tone: 'semantic',
    },
    {
      german: "in Hessen",
      translated: "de Hesse",
      tone: 'semantic',
    },
    {
      german: "bei Kommunalwahlen",
      translated: "en las elecciones municipales",
      tone: 'semantic',
    },
    {
      german: "wählen",
      translated: "votar",
      tone: 'semantic',
    },
  ],
  "lid:state:HE:4|fa": [
    {
      german: "Ab welchem Alter",
      translated: "از چه سنی",
      tone: 'semantic',
    },
    {
      german: "darf man",
      translated: "می‌توان",
      tone: 'semantic',
    },
    {
      german: "in Hessen",
      translated: "هسن",
      tone: 'semantic',
    },
    {
      german: "bei Kommunalwahlen",
      translated: "انتخابات محلی",
      tone: 'semantic',
    },
    {
      german: "wählen",
      translated: "رأی داد",
      tone: 'semantic',
    },
  ],
  "lid:state:HE:4|fr": [
    {
      german: "Ab welchem Alter",
      translated: "À partir de quel âge",
      tone: 'semantic',
    },
    {
      german: "darf man",
      translated: "peut-on",
      tone: 'semantic',
    },
    {
      german: "in Hessen",
      translated: "en Hesse",
      tone: 'semantic',
    },
    {
      german: "bei Kommunalwahlen",
      translated: "aux élections municipales",
      tone: 'semantic',
    },
    {
      german: "wählen",
      translated: "voter",
      tone: 'semantic',
    },
  ],
  "lid:state:HE:4|hr": [
    {
      german: "Ab welchem Alter",
      translated: "Od koje se dobi",
      tone: 'semantic',
    },
    {
      german: "darf man",
      translated: "može",
      tone: 'semantic',
    },
    {
      german: "in Hessen",
      translated: "u saveznoj zemlji Hessen",
      tone: 'semantic',
    },
    {
      german: "bei Kommunalwahlen",
      translated: "na lokalnim izborima",
      tone: 'semantic',
    },
    {
      german: "wählen",
      translated: "glasovati",
      tone: 'semantic',
    },
  ],
  "lid:state:HE:4|it": [
    {
      german: "Ab welchem Alter",
      translated: "Da quale età",
      tone: 'semantic',
    },
    {
      german: "darf man",
      translated: "si può",
      tone: 'semantic',
    },
    {
      german: "in Hessen",
      translated: "in Assia",
      tone: 'semantic',
    },
    {
      german: "bei Kommunalwahlen",
      translated: "alle elezioni comunali",
      tone: 'semantic',
    },
    {
      german: "wählen",
      translated: "votare",
      tone: 'semantic',
    },
  ],
  "lid:state:HE:4|kmr": [
    {
      german: "Ab welchem Alter",
      translated: "Ji kîjan temenê",
      tone: 'semantic',
    },
    {
      german: "darf man",
      translated: "dikare",
      tone: 'semantic',
    },
    {
      german: "in Hessen",
      translated: "li Hessen",
      tone: 'semantic',
    },
    {
      german: "bei Kommunalwahlen",
      translated: "di hilbijartinên şaredariyê de",
      tone: 'semantic',
    },
    {
      german: "wählen",
      translated: "deng were",
      tone: 'semantic',
    },
  ],
  "lid:state:HE:4|pl": [
    {
      german: "Ab welchem Alter",
      translated: "Od jakiego wieku",
      tone: 'semantic',
    },
    {
      german: "darf man",
      translated: "można",
      tone: 'semantic',
    },
    {
      german: "in Hessen",
      translated: "w Hesja",
      tone: 'semantic',
    },
    {
      german: "bei Kommunalwahlen",
      translated: "w wyborach samorządowych",
      tone: 'semantic',
    },
    {
      german: "wählen",
      translated: "głosować",
      tone: 'semantic',
    },
  ],
  "lid:state:HE:4|prs": [
    {
      german: "Ab welchem Alter",
      translated: "از چه سنی",
      tone: 'semantic',
    },
    {
      german: "darf man",
      translated: "می‌توان",
      tone: 'semantic',
    },
    {
      german: "in Hessen",
      translated: "هسن",
      tone: 'semantic',
    },
    {
      german: "bei Kommunalwahlen",
      translated: "در انتخابات شاروالی",
      tone: 'semantic',
    },
    {
      german: "wählen",
      translated: "رأی داد",
      tone: 'semantic',
    },
  ],
  "lid:state:HE:4|ro": [
    {
      german: "Ab welchem Alter",
      translated: "De la ce vârstă",
      tone: 'semantic',
    },
    {
      german: "darf man",
      translated: "se poate",
      tone: 'semantic',
    },
    {
      german: "in Hessen",
      translated: "din Hessa",
      tone: 'semantic',
    },
    {
      german: "bei Kommunalwahlen",
      translated: "alegerile locale",
      tone: 'semantic',
    },
    {
      german: "wählen",
      translated: "vota",
      tone: 'semantic',
    },
  ],
  "lid:state:HE:4|ru": [
    {
      german: "Ab welchem Alter",
      translated: "С какого возраста",
      tone: 'semantic',
    },
    {
      german: "darf man",
      translated: "можно",
      tone: 'semantic',
    },
    {
      german: "in Hessen",
      translated: "в федеральной земле Гессен",
      tone: 'semantic',
    },
    {
      german: "bei Kommunalwahlen",
      translated: "на муниципальных выборах",
      tone: 'semantic',
    },
    {
      german: "wählen",
      translated: "голосовать",
      tone: 'semantic',
    },
  ],
  "lid:state:HE:4|sq": [
    {
      german: "Ab welchem Alter",
      translated: "cila moshë",
      tone: 'semantic',
    },
    {
      german: "darf man",
      translated: "mund të",
      tone: 'semantic',
    },
    {
      german: "in Hessen",
      translated: "në Hesseni",
      tone: 'semantic',
    },
    {
      german: "bei Kommunalwahlen",
      translated: "në zgjedhjet komunale",
      tone: 'semantic',
    },
    {
      german: "wählen",
      translated: "votohet",
      tone: 'semantic',
    },
  ],
  "lid:state:HE:4|sr": [
    {
      german: "Ab welchem Alter",
      translated: "Od koje se dobi",
      tone: 'semantic',
    },
    {
      german: "darf man",
      translated: "može",
      tone: 'semantic',
    },
    {
      german: "in Hessen",
      translated: "u saveznoj pokrajini Hesen",
      tone: 'semantic',
    },
    {
      german: "bei Kommunalwahlen",
      translated: "na lokalnim izborima",
      tone: 'semantic',
    },
    {
      german: "wählen",
      translated: "glasati",
      tone: 'semantic',
    },
  ],
  "lid:state:HE:4|tr": [
    {
      german: "Ab welchem Alter",
      translated: "kaç yaşından itibaren",
      tone: 'semantic',
    },
    {
      german: "darf man",
      translated: "oy kullanılabilir",
      tone: 'semantic',
    },
    {
      german: "in Hessen",
      translated: "Hessen eyaletinde",
      tone: 'semantic',
    },
    {
      german: "bei Kommunalwahlen",
      translated: "yerel seçimlerde",
      tone: 'semantic',
    },
  ],
  "lid:state:HE:4|uk": [
    {
      german: "Ab welchem Alter",
      translated: "З якого віку",
      tone: 'semantic',
    },
    {
      german: "darf man",
      translated: "можна",
      tone: 'semantic',
    },
    {
      german: "in Hessen",
      translated: "у федеральній землі Гессен",
      tone: 'semantic',
    },
    {
      german: "bei Kommunalwahlen",
      translated: "на муніципальних виборах",
      tone: 'semantic',
    },
    {
      german: "wählen",
      translated: "голосувати",
      tone: 'semantic',
    },
  ],
  "lid:state:HE:4|vi": [
    {
      german: "Ab welchem Alter",
      translated: "Từ bao nhiêu tuổi",
      tone: 'semantic',
    },
    {
      german: "darf man",
      translated: "có thể",
      tone: 'semantic',
    },
    {
      german: "in Hessen",
      translated: "ở bang Hessen",
      tone: 'semantic',
    },
    {
      german: "bei Kommunalwahlen",
      translated: "trong bầu cử địa phương",
      tone: 'semantic',
    },
    {
      german: "wählen",
      translated: "bỏ phiếu",
      tone: 'semantic',
    },
  ],
  "lid:state:HE:5|ar": [
    {
      german: "Welche Farben",
      translated: "ما ألوان",
      tone: 'semantic',
    },
    {
      german: "die Landesflagge",
      translated: "علم ولاية",
      tone: 'semantic',
    },
    {
      german: "von Hessen",
      translated: "Hessen",
      tone: 'semantic',
    },
  ],
  "lid:state:HE:5|bg": [
    {
      german: "Welche Farben",
      translated: "Какви са цветовете",
      tone: 'semantic',
    },
    {
      german: "die Landesflagge",
      translated: "знамето",
      tone: 'semantic',
    },
    {
      german: "von Hessen",
      translated: "на провинция Хесен",
      tone: 'semantic',
    },
  ],
  "lid:state:HE:5|bs": [
    {
      german: "Welche Farben",
      translated: "Koje su boje",
      tone: 'semantic',
    },
    {
      german: "die Landesflagge",
      translated: "zastave",
      tone: 'semantic',
    },
    {
      german: "von Hessen",
      translated: "savezne zemlje Hessen",
      tone: 'semantic',
    },
  ],
  "lid:state:HE:5|el": [
    {
      german: "Welche Farben",
      translated: "Ποια είναι τα χρώματα",
      tone: 'semantic',
    },
    {
      german: "die Landesflagge",
      translated: "της σημαίας του κρατιδίου",
      tone: 'semantic',
    },
    {
      german: "von Hessen",
      translated: "Έσση",
      tone: 'semantic',
    },
  ],
  "lid:state:HE:5|en": [
    {
      german: "Welche Farben",
      translated: "What colors",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "does",
      tone: 'semantic',
    },
    {
      german: "die Landesflagge",
      translated: "the state flag",
      tone: 'semantic',
    },
    {
      german: "von Hessen",
      translated: "of Hessen",
      tone: 'semantic',
    },
  ],
  "lid:state:HE:5|es": [
    {
      german: "Welche Farben",
      translated: "¿Qué colores",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "tiene",
      tone: 'semantic',
    },
    {
      german: "die Landesflagge",
      translated: "la bandera regional",
      tone: 'semantic',
    },
    {
      german: "von Hessen",
      translated: "de Hesse",
      tone: 'semantic',
    },
  ],
  "lid:state:HE:5|fa": [
    {
      german: "Welche Farben",
      translated: "رنگ‌های",
      tone: 'semantic',
    },
    {
      german: "die Landesflagge",
      translated: "پرچم ایالت",
      tone: 'semantic',
    },
    {
      german: "von Hessen",
      translated: "هسن",
      tone: 'semantic',
    },
  ],
  "lid:state:HE:5|fr": [
    {
      german: "Welche Farben",
      translated: "Quelles sont les couleurs",
      tone: 'semantic',
    },
    {
      german: "die Landesflagge",
      translated: "du drapeau du Land",
      tone: 'semantic',
    },
    {
      german: "von Hessen",
      translated: "de Hesse",
      tone: 'semantic',
    },
  ],
  "lid:state:HE:5|hr": [
    {
      german: "Welche Farben",
      translated: "Koje",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "su",
      tone: 'semantic',
    },
    {
      german: "die Landesflagge",
      translated: "boje zastave",
      tone: 'semantic',
    },
    {
      german: "von Hessen",
      translated: "savezne zemlje Hessen",
      tone: 'semantic',
    },
  ],
  "lid:state:HE:5|it": [
    {
      german: "Welche Farben",
      translated: "Quali sono i colori",
      tone: 'semantic',
    },
    {
      german: "die Landesflagge",
      translated: "della bandiera del Land",
      tone: 'semantic',
    },
    {
      german: "von Hessen",
      translated: "di Assia",
      tone: 'semantic',
    },
  ],
  "lid:state:HE:5|kmr": [
    {
      german: "Welche Farben",
      translated: "Rengên ala",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "çi ne",
      tone: 'semantic',
    },
    {
      german: "die Landesflagge",
      translated: "eyaleta",
      tone: 'semantic',
    },
    {
      german: "von Hessen",
      translated: "Hessen",
      tone: 'semantic',
    },
  ],
  "lid:state:HE:5|pl": [
    {
      german: "Welche Farben",
      translated: "Jakie są kolory",
      tone: 'semantic',
    },
    {
      german: "die Landesflagge",
      translated: "flagi kraju związkowego",
      tone: 'semantic',
    },
    {
      german: "von Hessen",
      translated: "Hesja",
      tone: 'semantic',
    },
  ],
  "lid:state:HE:5|prs": [
    {
      german: "Welche Farben",
      translated: "رنگ‌های",
      tone: 'semantic',
    },
    {
      german: "die Landesflagge",
      translated: "پرچم ایالت",
      tone: 'semantic',
    },
    {
      german: "von Hessen",
      translated: "کدام‌اند؟",
      tone: 'semantic',
    },
  ],
  "lid:state:HE:5|ro": [
    {
      german: "Welche Farben",
      translated: "Care sunt culorile",
      tone: 'semantic',
    },
    {
      german: "die Landesflagge",
      translated: "drapelului landului Hessa",
      tone: 'semantic',
    },
  ],
  "lid:state:HE:5|ru": [
    {
      german: "Welche Farben",
      translated: "Какие цвета",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "у",
      tone: 'semantic',
    },
    {
      german: "die Landesflagge",
      translated: "флага земли",
      tone: 'semantic',
    },
    {
      german: "von Hessen",
      translated: "Гессен",
      tone: 'semantic',
    },
  ],
  "lid:state:HE:5|sq": [
    {
      german: "Welche Farben",
      translated: "Cilat janë ngjyrat",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "e",
      tone: 'semantic',
    },
    {
      german: "die Landesflagge",
      translated: "flamurit",
      tone: 'semantic',
    },
    {
      german: "von Hessen",
      translated: "landit Hesseni",
      tone: 'semantic',
    },
  ],
  "lid:state:HE:5|sr": [
    {
      german: "Welche Farben",
      translated: "Koje su boje",
      tone: 'semantic',
    },
    {
      german: "die Landesflagge",
      translated: "zastave",
      tone: 'semantic',
    },
    {
      german: "von Hessen",
      translated: "savezne pokrajine Hesen",
      tone: 'semantic',
    },
  ],
  "lid:state:HE:5|tr": [
    {
      german: "Welche Farben",
      translated: "renkleri",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "nelerdir",
      tone: 'semantic',
    },
    {
      german: "die Landesflagge",
      translated: "bayrağının",
      tone: 'semantic',
    },
    {
      german: "von Hessen",
      translated: "Hessen",
      tone: 'semantic',
    },
  ],
  "lid:state:HE:5|uk": [
    {
      german: "Welche Farben",
      translated: "Які кольори",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "має",
      tone: 'semantic',
    },
    {
      german: "die Landesflagge",
      translated: "прапор федеральної землі",
      tone: 'semantic',
    },
    {
      german: "von Hessen",
      translated: "Гессен",
      tone: 'semantic',
    },
  ],
  "lid:state:HE:5|vi": [
    {
      german: "Welche Farben",
      translated: "Màu của",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "là",
      tone: 'semantic',
    },
    {
      german: "die Landesflagge",
      translated: "cờ bang",
      tone: 'semantic',
    },
    {
      german: "von Hessen",
      translated: "Hessen",
      tone: 'semantic',
    },
  ],
  "lid:state:HE:6|ar": [
    {
      german: "Wo",
      translated: "أين",
      tone: 'semantic',
    },
    {
      german: "können Sie",
      translated: "يمكنك",
      tone: 'semantic',
    },
    {
      german: "in Hessen",
      translated: "في Hessen",
      tone: 'semantic',
    },
    {
      german: "über politische Themen",
      translated: "عن القضايا السياسية",
      tone: 'semantic',
    },
    {
      german: "informieren",
      translated: "الحصول على معلومات",
      tone: 'semantic',
    },
  ],
  "lid:state:HE:6|bg": [
    {
      german: "Wo",
      translated: "Къде",
      tone: 'semantic',
    },
    {
      german: "können Sie",
      translated: "можете",
      tone: 'semantic',
    },
    {
      german: "sich",
      translated: "в",
      tone: 'semantic',
    },
    {
      german: "in Hessen",
      translated: "Хесен",
      tone: 'semantic',
    },
    {
      german: "über politische Themen",
      translated: "по политически теми",
      tone: 'semantic',
    },
    {
      german: "informieren",
      translated: "да получите информация",
      tone: 'semantic',
    },
  ],
  "lid:state:HE:6|bs": [
    {
      german: "Wo",
      translated: "Gdje",
      tone: 'semantic',
    },
    {
      german: "können Sie",
      translated: "mogu",
      tone: 'semantic',
    },
    {
      german: "sich",
      translated: "se",
      tone: 'semantic',
    },
    {
      german: "in Hessen",
      translated: "u saveznoj zemlji Hessen",
      tone: 'semantic',
    },
    {
      german: "über politische Themen",
      translated: "o političkim temama",
      tone: 'semantic',
    },
    {
      german: "informieren",
      translated: "dobiti informacije",
      tone: 'semantic',
    },
  ],
  "lid:state:HE:6|el": [
    {
      german: "Wo",
      translated: "Πού",
      tone: 'semantic',
    },
    {
      german: "können Sie",
      translated: "μπορείτε",
      tone: 'semantic',
    },
    {
      german: "sich",
      translated: "να",
      tone: 'semantic',
    },
    {
      german: "in Hessen",
      translated: "στο Έσση",
      tone: 'semantic',
    },
    {
      german: "über politische Themen",
      translated: "για πολιτικά θέματα",
      tone: 'semantic',
    },
    {
      german: "informieren",
      translated: "ενημερωθείτε",
      tone: 'semantic',
    },
  ],
  "lid:state:HE:6|en": [
    {
      german: "Wo",
      translated: "Where",
      tone: 'semantic',
    },
    {
      german: "können Sie",
      translated: "can you",
      tone: 'semantic',
    },
    {
      german: "sich",
      translated: "get",
      tone: 'semantic',
    },
    {
      german: "in Hessen",
      translated: "in Hessen",
      tone: 'semantic',
    },
    {
      german: "über politische Themen",
      translated: "about political topics",
      tone: 'semantic',
    },
    {
      german: "informieren",
      translated: "information",
      tone: 'semantic',
    },
  ],
  "lid:state:HE:6|es": [
    {
      german: "Wo",
      translated: "¿Dónde",
      tone: 'semantic',
    },
    {
      german: "in Hessen",
      translated: "en Hesse",
      tone: 'semantic',
    },
    {
      german: "über politische Themen",
      translated: "sobre temas políticos",
      tone: 'semantic',
    },
    {
      german: "informieren",
      translated: "puede informarse",
      tone: 'semantic',
    },
  ],
  "lid:state:HE:6|fa": [
    {
      german: "Wo",
      translated: "کجا",
      tone: 'semantic',
    },
    {
      german: "können Sie",
      translated: "می‌توانید",
      tone: 'semantic',
    },
    {
      german: "in Hessen",
      translated: "در هسن",
      tone: 'semantic',
    },
    {
      german: "über politische Themen",
      translated: "دربارهٔ موضوعات سیاسی",
      tone: 'semantic',
    },
    {
      german: "informieren",
      translated: "اطلاعات کسب کنید",
      tone: 'semantic',
    },
  ],
  "lid:state:HE:6|fr": [
    {
      german: "Wo",
      translated: "Où",
      tone: 'semantic',
    },
    {
      german: "können Sie",
      translated: "pouvez-vous",
      tone: 'semantic',
    },
    {
      german: "sich",
      translated: "vous",
      tone: 'semantic',
    },
    {
      german: "in Hessen",
      translated: "en Hesse",
      tone: 'semantic',
    },
    {
      german: "über politische Themen",
      translated: "sur les questions politiques",
      tone: 'semantic',
    },
    {
      german: "informieren",
      translated: "informer",
      tone: 'semantic',
    },
  ],
  "lid:state:HE:6|hr": [
    {
      german: "Wo",
      translated: "Gdje",
      tone: 'semantic',
    },
    {
      german: "können Sie",
      translated: "mogu",
      tone: 'semantic',
    },
    {
      german: "sich",
      translated: "se",
      tone: 'semantic',
    },
    {
      german: "in Hessen",
      translated: "u saveznoj zemlji Hessen",
      tone: 'semantic',
    },
    {
      german: "über politische Themen",
      translated: "o političkim temama",
      tone: 'semantic',
    },
    {
      german: "informieren",
      translated: "dobiti informacije",
      tone: 'semantic',
    },
  ],
  "lid:state:HE:6|it": [
    {
      german: "Wo",
      translated: "Dove",
      tone: 'semantic',
    },
    {
      german: "können Sie",
      translated: "si può",
      tone: 'semantic',
    },
    {
      german: "sich",
      translated: "ci",
      tone: 'semantic',
    },
    {
      german: "in Hessen",
      translated: "in Assia",
      tone: 'semantic',
    },
    {
      german: "über politische Themen",
      translated: "su temi politici",
      tone: 'semantic',
    },
    {
      german: "informieren",
      translated: "informare",
      tone: 'semantic',
    },
  ],
  "lid:state:HE:6|kmr": [
    {
      german: "Wo",
      translated: "Li",
      tone: 'semantic',
    },
    {
      german: "können Sie",
      translated: "ku dikarî",
      tone: 'semantic',
    },
    {
      german: "sich",
      translated: "li",
      tone: 'semantic',
    },
    {
      german: "in Hessen",
      translated: "Hessen",
      tone: 'semantic',
    },
    {
      german: "über politische Themen",
      translated: "li ser mijarên siyasî",
      tone: 'semantic',
    },
    {
      german: "informieren",
      translated: "agahdarî bistînî",
      tone: 'semantic',
    },
  ],
  "lid:state:HE:6|pl": [
    {
      german: "Wo",
      translated: "Gdzie",
      tone: 'semantic',
    },
    {
      german: "können Sie",
      translated: "można",
      tone: 'semantic',
    },
    {
      german: "in Hessen",
      translated: "w Hesja",
      tone: 'semantic',
    },
    {
      german: "über politische Themen",
      translated: "na tematy polityczne",
      tone: 'semantic',
    },
    {
      german: "informieren",
      translated: "uzyskać informacje",
      tone: 'semantic',
    },
  ],
  "lid:state:HE:6|prs": [
    {
      german: "Wo",
      translated: "کجا",
      tone: 'semantic',
    },
    {
      german: "können Sie",
      translated: "می‌توانید",
      tone: 'semantic',
    },
    {
      german: "in Hessen",
      translated: "در هسن",
      tone: 'semantic',
    },
    {
      german: "über politische Themen",
      translated: " دربارهٔ موضوعات سیاسی",
      tone: 'semantic',
    },
    {
      german: "informieren",
      translated: "اطلاعات کسب کنید",
      tone: 'semantic',
    },
  ],
  "lid:state:HE:6|ro": [
    {
      german: "Wo",
      translated: "Unde",
      tone: 'semantic',
    },
    {
      german: "können Sie",
      translated: "vă puteți",
      tone: 'semantic',
    },
    {
      german: "in Hessen",
      translated: "în Hessa",
      tone: 'semantic',
    },
    {
      german: "über politische Themen",
      translated: "despre teme politice",
      tone: 'semantic',
    },
    {
      german: "informieren",
      translated: "informa",
      tone: 'semantic',
    },
  ],
  "lid:state:HE:6|ru": [
    {
      german: "Wo",
      translated: "Где",
      tone: 'semantic',
    },
    {
      german: "können Sie",
      translated: "можно",
      tone: 'semantic',
    },
    {
      german: "in Hessen",
      translated: "в федеральной земле Гессен",
      tone: 'semantic',
    },
    {
      german: "über politische Themen",
      translated: "о политических темах",
      tone: 'semantic',
    },
    {
      german: "informieren",
      translated: "получить информацию",
      tone: 'semantic',
    },
  ],
  "lid:state:HE:6|sq": [
    {
      german: "Wo",
      translated: "Ku",
      tone: 'semantic',
    },
    {
      german: "können Sie",
      translated: "mund të",
      tone: 'semantic',
    },
    {
      german: "in Hessen",
      translated: "në Hesseni",
      tone: 'semantic',
    },
    {
      german: "über politische Themen",
      translated: "për tema politike",
      tone: 'semantic',
    },
    {
      german: "informieren",
      translated: "informoheni",
      tone: 'semantic',
    },
  ],
  "lid:state:HE:6|sr": [
    {
      german: "Wo",
      translated: "Gdje",
      tone: 'semantic',
    },
    {
      german: "können Sie",
      translated: "mogu",
      tone: 'semantic',
    },
    {
      german: "sich",
      translated: "se",
      tone: 'semantic',
    },
    {
      german: "in Hessen",
      translated: "u saveznoj pokrajini Hesen",
      tone: 'semantic',
    },
    {
      german: "über politische Themen",
      translated: "o političkim temama",
      tone: 'semantic',
    },
    {
      german: "informieren",
      translated: "dobiti informacije",
      tone: 'semantic',
    },
  ],
  "lid:state:HE:6|tr": [
    {
      german: "Wo",
      translated: "nereden",
      tone: 'semantic',
    },
    {
      german: "können Sie",
      translated: "alabilirsiniz",
      tone: 'semantic',
    },
    {
      german: "in Hessen",
      translated: "Hessen eyaletinde",
      tone: 'semantic',
    },
    {
      german: "über politische Themen",
      translated: "siyasi konular hakkında",
      tone: 'semantic',
    },
    {
      german: "informieren",
      translated: "bilgi",
      tone: 'semantic',
    },
  ],
  "lid:state:HE:6|uk": [
    {
      german: "Wo",
      translated: "Де",
      tone: 'semantic',
    },
    {
      german: "können Sie",
      translated: "можна",
      tone: 'semantic',
    },
    {
      german: "in Hessen",
      translated: "у федеральній землі Гессен",
      tone: 'semantic',
    },
    {
      german: "über politische Themen",
      translated: "про політичні питання",
      tone: 'semantic',
    },
    {
      german: "informieren",
      translated: "отримати інформацію",
      tone: 'semantic',
    },
  ],
  "lid:state:HE:6|vi": [
    {
      german: "Wo",
      translated: "ở đâu",
      tone: 'semantic',
    },
    {
      german: "können Sie",
      translated: "có thể",
      tone: 'semantic',
    },
    {
      german: "in Hessen",
      translated: "bang Hessen",
      tone: 'semantic',
    },
    {
      german: "über politische Themen",
      translated: "về các chủ đề chính trị",
      tone: 'semantic',
    },
    {
      german: "informieren",
      translated: "tìm thông tin",
      tone: 'semantic',
    },
  ],
  "lid:state:HE:7|ar": [
    {
      german: "Die Landeshauptstadt",
      translated: "عاصمة",
      tone: 'semantic',
    },
    {
      german: "von Hessen",
      translated: "ولاية Hessen",
      tone: 'semantic',
    },
  ],
  "lid:state:HE:7|bg": [
    {
      german: "Die Landeshauptstadt",
      translated: "Столицата",
      tone: 'semantic',
    },
    {
      german: "von Hessen",
      translated: "на федералната провинция",
      tone: 'semantic',
    },
    {
      german: "heißt",
      translated: "е",
      tone: 'semantic',
    },
  ],
  "lid:state:HE:7|bs": [
    {
      german: "Die Landeshauptstadt",
      translated: "Glavni grad",
      tone: 'semantic',
    },
    {
      german: "von Hessen",
      translated: "savezne zemlje Hessen",
      tone: 'semantic',
    },
    {
      german: "heißt",
      translated: "je",
      tone: 'semantic',
    },
  ],
  "lid:state:HE:7|el": [
    {
      german: "Die Landeshauptstadt",
      translated: "Η πρωτεύουσα του ομόσπονδου κρατιδίου",
      tone: 'semantic',
    },
    {
      german: "von Hessen",
      translated: "Έσση",
      tone: 'semantic',
    },
    {
      german: "heißt",
      translated: "είναι",
      tone: 'semantic',
    },
  ],
  "lid:state:HE:7|en": [
    {
      german: "Die Landeshauptstadt",
      translated: "The state capital",
      tone: 'semantic',
    },
    {
      german: "von Hessen",
      translated: "of Hessen",
      tone: 'semantic',
    },
    {
      german: "heißt",
      translated: "is called",
      tone: 'semantic',
    },
  ],
  "lid:state:HE:7|es": [
    {
      german: "Die Landeshauptstadt",
      translated: "La capital",
      tone: 'semantic',
    },
    {
      german: "von Hessen",
      translated: "del estado federado de Hesse",
      tone: 'semantic',
    },
    {
      german: "heißt",
      translated: "es",
      tone: 'semantic',
    },
  ],
  "lid:state:HE:7|fa": [
    {
      german: "Die Landeshauptstadt",
      translated: "مرکز ایالت",
      tone: 'semantic',
    },
    {
      german: "von Hessen",
      translated: "هسن",
      tone: 'semantic',
    },
    {
      german: "heißt",
      translated: "است.",
      tone: 'semantic',
    },
  ],
  "lid:state:HE:7|fr": [
    {
      german: "Die Landeshauptstadt",
      translated: "La capitale du Land",
      tone: 'semantic',
    },
    {
      german: "von Hessen",
      translated: "de Hesse",
      tone: 'semantic',
    },
    {
      german: "heißt",
      translated: "s’appelle",
      tone: 'semantic',
    },
  ],
  "lid:state:HE:7|hr": [
    {
      german: "Die Landeshauptstadt",
      translated: "Glavni grad",
      tone: 'semantic',
    },
    {
      german: "von Hessen",
      translated: "savezne zemlje Hessen",
      tone: 'semantic',
    },
    {
      german: "heißt",
      translated: "je",
      tone: 'semantic',
    },
  ],
  "lid:state:HE:7|it": [
    {
      german: "Die Landeshauptstadt",
      translated: "La capitale del Land",
      tone: 'semantic',
    },
    {
      german: "von Hessen",
      translated: "di Assia",
      tone: 'semantic',
    },
    {
      german: "heißt",
      translated: "è",
      tone: 'semantic',
    },
  ],
  "lid:state:HE:7|kmr": [
    {
      german: "Die Landeshauptstadt",
      translated: "Paytexta eyaleta",
      tone: 'semantic',
    },
    {
      german: "von Hessen",
      translated: "Hessen",
      tone: 'semantic',
    },
  ],
  "lid:state:HE:7|pl": [
    {
      german: "Die Landeshauptstadt",
      translated: "Stolicą kraju związkowego",
      tone: 'semantic',
    },
    {
      german: "von Hessen",
      translated: "Hesja",
      tone: 'semantic',
    },
    {
      german: "heißt",
      translated: "jest",
      tone: 'semantic',
    },
  ],
  "lid:state:HE:7|prs": [
    {
      german: "Die Landeshauptstadt",
      translated: "مرکز ایالت هسن",
      tone: 'semantic',
    },
    {
      german: "heißt",
      translated: "است",
      tone: 'semantic',
    },
  ],
  "lid:state:HE:7|ro": [
    {
      german: "Die Landeshauptstadt",
      translated: "Capitala",
      tone: 'semantic',
    },
    {
      german: "von Hessen",
      translated: "landului Hessa",
      tone: 'semantic',
    },
    {
      german: "heißt",
      translated: "este",
      tone: 'semantic',
    },
  ],
  "lid:state:HE:7|ru": [
    {
      german: "Die Landeshauptstadt",
      translated: "Столица земли",
      tone: 'semantic',
    },
    {
      german: "von Hessen",
      translated: "Гессен",
      tone: 'semantic',
    },
    {
      german: "heißt",
      translated: "называется",
      tone: 'semantic',
    },
  ],
  "lid:state:HE:7|sq": [
    {
      german: "Die Landeshauptstadt",
      translated: "Kryeqyteti",
      tone: 'semantic',
    },
    {
      german: "von Hessen",
      translated: "i landit Hesseni",
      tone: 'semantic',
    },
    {
      german: "heißt",
      translated: "është",
      tone: 'semantic',
    },
  ],
  "lid:state:HE:7|sr": [
    {
      german: "Die Landeshauptstadt",
      translated: "Glavni grad",
      tone: 'semantic',
    },
    {
      german: "von Hessen",
      translated: "savezne pokrajine Hesen",
      tone: 'semantic',
    },
    {
      german: "heißt",
      translated: "je",
      tone: 'semantic',
    },
  ],
  "lid:state:HE:7|tr": [
    {
      german: "Die Landeshauptstadt",
      translated: "başkenti",
      tone: 'semantic',
    },
    {
      german: "von Hessen",
      translated: "Hessen eyaletinin",
      tone: 'semantic',
    },
  ],
  "lid:state:HE:7|uk": [
    {
      german: "Die Landeshauptstadt",
      translated: "Столиця",
      tone: 'semantic',
    },
    {
      german: "von Hessen",
      translated: "федеральної землі Гессен",
      tone: 'semantic',
    },
    {
      german: "heißt",
      translated: "називається",
      tone: 'semantic',
    },
  ],
  "lid:state:HE:7|vi": [
    {
      german: "Die Landeshauptstadt",
      translated: "Thủ phủ",
      tone: 'semantic',
    },
    {
      german: "von Hessen",
      translated: "của bang Hessen",
      tone: 'semantic',
    },
    {
      german: "heißt",
      translated: "là …",
      tone: 'semantic',
    },
  ],
  "lid:state:HE:8|ar": [
    {
      german: "Welches Bundesland",
      translated: "أي صورة",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "تمثل موقع ولاية",
      tone: 'semantic',
    },
    {
      german: "Hessen",
      translated: "Hessen",
      tone: 'semantic',
    },
  ],
  "lid:state:HE:8|bg": [
    {
      german: "Welches Bundesland",
      translated: "Коя от показаните федерални провинции",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "е",
      tone: 'semantic',
    },
    {
      german: "Hessen",
      translated: "Хесен",
      tone: 'semantic',
    },
  ],
  "lid:state:HE:8|bs": [
    {
      german: "Welches Bundesland",
      translated: "Koja od prikazanih",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "je",
      tone: 'semantic',
    },
    {
      german: "Hessen",
      translated: "Hessen",
      tone: 'semantic',
    },
  ],
  "lid:state:HE:8|el": [
    {
      german: "Welches Bundesland",
      translated: "Ποιο από τα εικονιζόμενα κρατίδια",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "είναι",
      tone: 'semantic',
    },
    {
      german: "Hessen",
      translated: "το Έσση",
      tone: 'semantic',
    },
  ],
  "lid:state:HE:8|en": [
    {
      german: "Welches Bundesland",
      translated: "Which federal state",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "is",
      tone: 'semantic',
    },
    {
      german: "Hessen",
      translated: "Hessen",
      tone: 'semantic',
    },
  ],
  "lid:state:HE:8|es": [
    {
      german: "Welches Bundesland",
      translated: "¿Cuál de las imágenes corresponde al estado federado",
      tone: 'semantic',
    },
    {
      german: "Hessen",
      translated: "Hesse",
      tone: 'semantic',
    },
  ],
  "lid:state:HE:8|fa": [
    {
      german: "Welches Bundesland",
      translated: "کدام ایالتِ",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "است",
      tone: 'semantic',
    },
    {
      german: "Hessen",
      translated: "؟",
      tone: 'semantic',
    },
  ],
  "lid:state:HE:8|fr": [
    {
      german: "Welches Bundesland",
      translated: "Quel Land représenté",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "est",
      tone: 'semantic',
    },
    {
      german: "Hessen",
      translated: "Hesse",
      tone: 'semantic',
    },
  ],
  "lid:state:HE:8|hr": [
    {
      german: "Welches Bundesland",
      translated: "Koja od prikazanih",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "je",
      tone: 'semantic',
    },
    {
      german: "Hessen",
      translated: "Hessen",
      tone: 'semantic',
    },
  ],
  "lid:state:HE:8|it": [
    {
      german: "Welches Bundesland",
      translated: "Quale Land",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "è",
      tone: 'semantic',
    },
    {
      german: "Hessen",
      translated: "Assia",
      tone: 'semantic',
    },
  ],
  "lid:state:HE:8|kmr": [
    {
      german: "Welches Bundesland",
      translated: "Kîjan eyalet",
      tone: 'semantic',
    },
    {
      german: "Hessen",
      translated: "Hessen",
      tone: 'semantic',
    },
  ],
  "lid:state:HE:8|pl": [
    {
      german: "Welches Bundesland",
      translated: "Który z przedstawionych krajów związkowych",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "to",
      tone: 'semantic',
    },
    {
      german: "Hessen",
      translated: "Hesja",
      tone: 'semantic',
    },
  ],
  "lid:state:HE:8|prs": [
    {
      german: "Welches Bundesland",
      translated: "کدام ایالتِ",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "است",
      tone: 'semantic',
    },
    {
      german: "Hessen",
      translated: "هسن",
      tone: 'semantic',
    },
  ],
  "lid:state:HE:8|ro": [
    {
      german: "Welches Bundesland",
      translated: "Care land reprezentat",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "este",
      tone: 'semantic',
    },
    {
      german: "Hessen",
      translated: "Hessa",
      tone: 'semantic',
    },
  ],
  "lid:state:HE:8|ru": [
    {
      german: "Welches Bundesland",
      translated: "Какая из этих земель",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "—",
      tone: 'semantic',
    },
    {
      german: "Hessen",
      translated: "Гессен",
      tone: 'semantic',
    },
  ],
  "lid:state:HE:8|sq": [
    {
      german: "Welches Bundesland",
      translated: "Cili nga landet e paraqitura",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "është",
      tone: 'semantic',
    },
    {
      german: "Hessen",
      translated: "Hesseni?",
      tone: 'semantic',
    },
  ],
  "lid:state:HE:8|sr": [
    {
      german: "Welches Bundesland",
      translated: "Koja od prikazanih saveznih pokrajina",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "je",
      tone: 'semantic',
    },
    {
      german: "Hessen",
      translated: "Hesen",
      tone: 'semantic',
    },
  ],
  "lid:state:HE:8|tr": [
    {
      german: "Welches Bundesland",
      translated: "eyaleti",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "hangi numarayla gösterilmiştir",
      tone: 'semantic',
    },
    {
      german: "Hessen",
      translated: "Hessen",
      tone: 'semantic',
    },
  ],
  "lid:state:HE:8|uk": [
    {
      german: "Welches Bundesland",
      translated: "Яка з позначених федеральних земель",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "є",
      tone: 'semantic',
    },
    {
      german: "Hessen",
      translated: "Гессен",
      tone: 'semantic',
    },
  ],
  "lid:state:HE:8|vi": [
    {
      german: "Welches Bundesland",
      translated: "Bang nào trong các hình được hiển thị",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "là",
      tone: 'semantic',
    },
    {
      german: "Hessen",
      translated: "Hessen",
      tone: 'semantic',
    },
  ],
  "lid:state:HE:9|ar": [
    {
      german: "Wie nennt man",
      translated: "ماذا يُسمى",
      tone: 'semantic',
    },
    {
      german: "die Regierungschefin/den Regierungschef",
      translated: "رئيس/رئيسة حكومة",
      tone: 'semantic',
    },
    {
      german: "in Hessen",
      translated: "ولاية Hessen",
      tone: 'semantic',
    },
  ],
  "lid:state:HE:9|bg": [
    {
      german: "Wie nennt man",
      translated: "Как се нарича",
      tone: 'semantic',
    },
    {
      german: "die Regierungschefin/den Regierungschef",
      translated: "ръководителят на правителството",
      tone: 'semantic',
    },
    {
      german: "in Hessen",
      translated: "на провинция Хесен",
      tone: 'semantic',
    },
  ],
  "lid:state:HE:9|bs": [
    {
      german: "Wie nennt man",
      translated: "Kako se zove",
      tone: 'semantic',
    },
    {
      german: "die Regierungschefin/den Regierungschef",
      translated: "šef vlade",
      tone: 'semantic',
    },
    {
      german: "in Hessen",
      translated: "savezne zemlje Hessen",
      tone: 'semantic',
    },
  ],
  "lid:state:HE:9|el": [
    {
      german: "Wie nennt man",
      translated: "Πώς ονομάζεται",
      tone: 'semantic',
    },
    {
      german: "die Regierungschefin/den Regierungschef",
      translated: "ο επικεφαλής της κυβέρνησης",
      tone: 'semantic',
    },
    {
      german: "in Hessen",
      translated: "του κρατιδίου Έσση",
      tone: 'semantic',
    },
  ],
  "lid:state:HE:9|en": [
    {
      german: "Wie nennt man",
      translated: "What is",
      tone: 'semantic',
    },
    {
      german: "die Regierungschefin/den Regierungschef",
      translated: "the head of government",
      tone: 'semantic',
    },
    {
      german: "in Hessen",
      translated: "in Hessen",
      tone: 'semantic',
    },
  ],
  "lid:state:HE:9|es": [
    {
      german: "Wie nennt man",
      translated: "¿Cómo se llama al",
      tone: 'semantic',
    },
    {
      german: "die Regierungschefin/den Regierungschef",
      translated: "jefe o la jefa de gobierno",
      tone: 'semantic',
    },
    {
      german: "in Hessen",
      translated: "de Hesse",
      tone: 'semantic',
    },
  ],
  "lid:state:HE:9|fa": [
    {
      german: "Wie nennt man",
      translated: "چه عنوانی دارد",
      tone: 'semantic',
    },
    {
      german: "die Regierungschefin/den Regierungschef",
      translated: "رئیس دولت",
      tone: 'semantic',
    },
    {
      german: "in Hessen",
      translated: "ایالت هسن",
      tone: 'semantic',
    },
  ],
  "lid:state:HE:9|fr": [
    {
      german: "Wie nennt man",
      translated: "Comment appelle-t-on",
      tone: 'semantic',
    },
    {
      german: "die Regierungschefin/den Regierungschef",
      translated: "le chef ou la cheffe du gouvernement",
      tone: 'semantic',
    },
    {
      german: "in Hessen",
      translated: "de Hesse",
      tone: 'semantic',
    },
  ],
  "lid:state:HE:9|hr": [
    {
      german: "Wie nennt man",
      translated: "Kako se zove",
      tone: 'semantic',
    },
    {
      german: "die Regierungschefin/den Regierungschef",
      translated: "čelnik vlade",
      tone: 'semantic',
    },
    {
      german: "in Hessen",
      translated: "savezne zemlje Hessen",
      tone: 'semantic',
    },
  ],
  "lid:state:HE:9|it": [
    {
      german: "Wie nennt man",
      translated: "Come si chiama",
      tone: 'semantic',
    },
    {
      german: "die Regierungschefin/den Regierungschef",
      translated: "il capo del governo",
      tone: 'semantic',
    },
    {
      german: "in Hessen",
      translated: "di Assia",
      tone: 'semantic',
    },
  ],
  "lid:state:HE:9|kmr": [
    {
      german: "Wie nennt man",
      translated: "Serokê",
      tone: 'semantic',
    },
    {
      german: "die Regierungschefin/den Regierungschef",
      translated: "hukûmeta",
      tone: 'semantic',
    },
    {
      german: "in Hessen",
      translated: "Hessen",
      tone: 'semantic',
    },
  ],
  "lid:state:HE:9|pl": [
    {
      german: "Wie nennt man",
      translated: "Jak nazywa się",
      tone: 'semantic',
    },
    {
      german: "die Regierungschefin/den Regierungschef",
      translated: "szef rządu kraju związkowego",
      tone: 'semantic',
    },
    {
      german: "in Hessen",
      translated: "Hesja",
      tone: 'semantic',
    },
  ],
  "lid:state:HE:9|prs": [
    {
      german: "Wie nennt man",
      translated: "چه عنوانی دارد",
      tone: 'semantic',
    },
    {
      german: "die Regierungschefin/den Regierungschef",
      translated: "رئیس دولت",
      tone: 'semantic',
    },
    {
      german: "in Hessen",
      translated: "ایالت هسن",
      tone: 'semantic',
    },
  ],
  "lid:state:HE:9|ro": [
    {
      german: "Wie nennt man",
      translated: "Cum se numește",
      tone: 'semantic',
    },
    {
      german: "die Regierungschefin/den Regierungschef",
      translated: "șeful guvernului",
      tone: 'semantic',
    },
    {
      german: "in Hessen",
      translated: "landului Hessa",
      tone: 'semantic',
    },
  ],
  "lid:state:HE:9|ru": [
    {
      german: "Wie nennt man",
      translated: "Как называют",
      tone: 'semantic',
    },
    {
      german: "die Regierungschefin/den Regierungschef",
      translated: "главу правительства",
      tone: 'semantic',
    },
    {
      german: "in Hessen",
      translated: "в федеральной земле Гессен",
      tone: 'semantic',
    },
  ],
  "lid:state:HE:9|sq": [
    {
      german: "Wie nennt man",
      translated: "Si quhet",
      tone: 'semantic',
    },
    {
      german: "die Regierungschefin/den Regierungschef",
      translated: "kreu i qeverisë",
      tone: 'semantic',
    },
    {
      german: "in Hessen",
      translated: "së landit Hesseni",
      tone: 'semantic',
    },
  ],
  "lid:state:HE:9|sr": [
    {
      german: "Wie nennt man",
      translated: "Kako se zove",
      tone: 'semantic',
    },
    {
      german: "die Regierungschefin/den Regierungschef",
      translated: "šef vlade",
      tone: 'semantic',
    },
    {
      german: "in Hessen",
      translated: "savezne pokrajine Hesen",
      tone: 'semantic',
    },
  ],
  "lid:state:HE:9|tr": [
    {
      german: "Wie nennt man",
      translated: "ne ad verilir",
      tone: 'semantic',
    },
    {
      german: "die Regierungschefin/den Regierungschef",
      translated: "hükümetinin başındaki kişiye",
      tone: 'semantic',
    },
    {
      german: "in Hessen",
      translated: "Hessen",
      tone: 'semantic',
    },
  ],
  "lid:state:HE:9|uk": [
    {
      german: "Wie nennt man",
      translated: "Як називають",
      tone: 'semantic',
    },
    {
      german: "die Regierungschefin/den Regierungschef",
      translated: "главу уряду",
      tone: 'semantic',
    },
    {
      german: "in Hessen",
      translated: "федеральної землі Гессен",
      tone: 'semantic',
    },
  ],
  "lid:state:HE:9|vi": [
    {
      german: "Wie nennt man",
      translated: "được gọi là",
      tone: 'semantic',
    },
    {
      german: "die Regierungschefin/den Regierungschef",
      translated: "Người đứng đầu chính phủ bang",
      tone: 'semantic',
    },
    {
      german: "in Hessen",
      translated: "Hessen",
      tone: 'semantic',
    },
  ],
  "lid:state:HH:10|ar": [
    {
      german: "Welche Senatorin/welchen Senator",
      translated: "أي منصب من مناصب أعضاء مجلس الشيوخ التالية",
      tone: 'semantic',
    },
    {
      german: "hat Hamburg nicht?",
      translated: "غير موجود في Hamburg",
      tone: 'semantic',
    },
  ],
  "lid:state:HH:10|bg": [
    {
      german: "Welche Senatorin/welchen Senator",
      translated: "Коя сенаторска длъжност",
      tone: 'semantic',
    },
    {
      german: "hat Hamburg nicht?",
      translated: "не съществува в Хамбург?",
      tone: 'semantic',
    },
  ],
  "lid:state:HH:10|bs": [
    {
      german: "Welche Senatorin/welchen Senator",
      translated: "Koja senatorska funkcija",
      tone: 'semantic',
    },
    {
      german: "hat Hamburg nicht?",
      translated: "ne postoji u Hamburgu",
      tone: 'semantic',
    },
  ],
  "lid:state:HH:10|el": [
    {
      german: "Welche Senatorin/welchen Senator",
      translated: "Ποια θέση γερουσιαστή",
      tone: 'semantic',
    },
    {
      german: "hat Hamburg nicht?",
      translated: "δεν υπάρχει στο Αμβούργο",
      tone: 'semantic',
    },
  ],
  "lid:state:HH:10|en": [
    {
      german: "Welche Senatorin/welchen Senator",
      translated: "Which senator",
      tone: 'semantic',
    },
    {
      german: "hat Hamburg nicht?",
      translated: "does Hamburg not have",
      tone: 'semantic',
    },
  ],
  "lid:state:HH:10|es": [
    {
      german: "Welche Senatorin/welchen Senator",
      translated: "¿Qué cargo de senador o senadora",
      tone: 'semantic',
    },
    {
      german: "hat Hamburg nicht?",
      translated: "NO existe en Hamburgo?",
      tone: 'semantic',
    },
  ],
  "lid:state:HH:10|fa": [
    {
      german: "Welche Senatorin/welchen Senator",
      translated: "کدام مقام سناتوری در هامبورگ",
      tone: 'semantic',
    },
    {
      german: "hat Hamburg nicht?",
      translated: "وجود ندارد؟",
      tone: 'semantic',
    },
  ],
  "lid:state:HH:10|fr": [
    {
      german: "Welche Senatorin/welchen Senator",
      translated: "Quel sénateur ou quelle sénatrice",
      tone: 'semantic',
    },
    {
      german: "hat Hamburg nicht?",
      translated: "n’existe pas à Hambourg ?",
      tone: 'semantic',
    },
  ],
  "lid:state:HH:10|hr": [
    {
      german: "Welche Senatorin/welchen Senator",
      translated: "Koja senatorska funkcija",
      tone: 'semantic',
    },
    {
      german: "hat Hamburg nicht?",
      translated: "ne postoji u Hamburgu?",
      tone: 'semantic',
    },
  ],
  "lid:state:HH:10|it": [
    {
      german: "Welche Senatorin/welchen Senator",
      translated: "Quale carica di senatore",
      tone: 'semantic',
    },
    {
      german: "hat Hamburg nicht?",
      translated: "non esiste a Amburgo?",
      tone: 'semantic',
    },
  ],
  "lid:state:HH:10|kmr": [
    {
      german: "Welche Senatorin/welchen Senator",
      translated: "Kîjan senator",
      tone: 'semantic',
    },
    {
      german: "hat Hamburg nicht?",
      translated: "li Hamburg tune ye",
      tone: 'semantic',
    },
  ],
  "lid:state:HH:10|pl": [
    {
      german: "Welche Senatorin/welchen Senator",
      translated: "Które stanowisko senatorskie",
      tone: 'semantic',
    },
    {
      german: "hat Hamburg nicht?",
      translated: "nie istnieje w Hamburg?",
      tone: 'semantic',
    },
  ],
  "lid:state:HH:10|prs": [
    {
      german: "Welche Senatorin/welchen Senator",
      translated: "کدام مقام سناتوری",
      tone: 'semantic',
    },
    {
      german: "hat Hamburg nicht?",
      translated: "در هامبورگ وجود ندارد",
      tone: 'semantic',
    },
  ],
  "lid:state:HH:10|ro": [
    {
      german: "Welche Senatorin/welchen Senator",
      translated: "funcție de senator",
      tone: 'semantic',
    },
    {
      german: "hat Hamburg nicht?",
      translated: "nu există în Hamburg?",
      tone: 'semantic',
    },
  ],
  "lid:state:HH:10|ru": [
    {
      german: "Welche Senatorin/welchen Senator",
      translated: "Какого сенатора",
      tone: 'semantic',
    },
    {
      german: "hat Hamburg nicht?",
      translated: "нет в Гамбурге?",
      tone: 'semantic',
    },
  ],
  "lid:state:HH:10|sq": [
    {
      german: "Welche Senatorin/welchen Senator",
      translated: "Cila detyrë senatori",
      tone: 'semantic',
    },
    {
      german: "hat Hamburg nicht?",
      translated: "nuk ekziston në Hamburgu?",
      tone: 'semantic',
    },
  ],
  "lid:state:HH:10|sr": [
    {
      german: "Welche Senatorin/welchen Senator",
      translated: "Koja senatorska funkcija",
      tone: 'semantic',
    },
    {
      german: "hat Hamburg nicht?",
      translated: "ne postoji u Hamburgu?",
      tone: 'semantic',
    },
  ],
  "lid:state:HH:10|tr": [
    {
      german: "Welche Senatorin/welchen Senator",
      translated: "aşağıdaki senatörlüklerden hangisi",
      tone: 'semantic',
    },
    {
      german: "hat Hamburg nicht?",
      translated: "Hamburg şehir devletinde",
      tone: 'semantic',
    },
  ],
  "lid:state:HH:10|uk": [
    {
      german: "Welche Senatorin/welchen Senator",
      translated: "Якого сенатора/сенаторки",
      tone: 'semantic',
    },
    {
      german: "hat Hamburg nicht?",
      translated: "немає в Гамбурзі?",
      tone: 'semantic',
    },
  ],
  "lid:state:HH:10|vi": [
    {
      german: "Welche Senatorin/welchen Senator",
      translated: "Chức vụ thượng nghị sĩ nào",
      tone: 'semantic',
    },
    {
      german: "hat Hamburg nicht?",
      translated: "không tồn tại ở Hamburg?",
      tone: 'semantic',
    },
  ],
  "lid:state:HH:1|ar": [
    {
      german: "Welches Wappen",
      translated: "أي شعار",
      tone: 'semantic',
    },
    {
      german: "gehört",
      translated: "يعود",
      tone: 'semantic',
    },
    {
      german: "zur",
      translated: "إلى",
      tone: 'semantic',
    },
    {
      german: "Freien und Hansestadt",
      translated: "المدينة الحرة والهانية",
      tone: 'semantic',
    },
    {
      german: "Hamburg",
      translated: "Hamburg",
      tone: 'semantic',
    },
  ],
  "lid:state:HH:1|bg": [
    {
      german: "Welches Wappen",
      translated: "Кой герб",
      tone: 'semantic',
    },
    {
      german: "gehört",
      translated: "принадлежи",
      tone: 'semantic',
    },
    {
      german: "Freien und Hansestadt",
      translated: "Свободния и ханзейски град",
      tone: 'semantic',
    },
    {
      german: "Hamburg",
      translated: "Хамбург",
      tone: 'semantic',
    },
  ],
  "lid:state:HH:1|bs": [
    {
      german: "Welches Wappen",
      translated: "Koji grb",
      tone: 'semantic',
    },
    {
      german: "gehört",
      translated: "pripada",
      tone: 'semantic',
    },
    {
      german: "Freien und Hansestadt",
      translated: "Slobodnom i hanzeatskom gradu",
      tone: 'semantic',
    },
    {
      german: "Hamburg",
      translated: "Hamburgu",
      tone: 'semantic',
    },
  ],
  "lid:state:HH:1|el": [
    {
      german: "Welches Wappen",
      translated: "Ποιο έμβλημα",
      tone: 'semantic',
    },
    {
      german: "gehört",
      translated: "ανήκει",
      tone: 'semantic',
    },
    {
      german: "zur",
      translated: "στο",
      tone: 'semantic',
    },
    {
      german: "Freien und Hansestadt",
      translated: "ομόσπονδο κρατίδιο",
      tone: 'semantic',
    },
    {
      german: "Hamburg",
      translated: "Αμβούργο",
      tone: 'semantic',
    },
  ],
  "lid:state:HH:1|en": [
    {
      german: "Welches Wappen",
      translated: "coat of arms",
      tone: 'semantic',
    },
    {
      german: "gehört",
      translated: "belongs",
      tone: 'semantic',
    },
    {
      german: "zur",
      translated: "to",
      tone: 'semantic',
    },
    {
      german: "Freien und Hansestadt",
      translated: "Free and Hanseatic City",
      tone: 'semantic',
    },
    {
      german: "Hamburg",
      translated: "Hamburg",
      tone: 'semantic',
    },
  ],
  "lid:state:HH:1|es": [
    {
      german: "Welches Wappen",
      translated: "¿Qué escudo",
      tone: 'semantic',
    },
    {
      german: "gehört",
      translated: "pertenece",
      tone: 'semantic',
    },
    {
      german: "zur",
      translated: "a la",
      tone: 'semantic',
    },
    {
      german: "Freien und Hansestadt",
      translated: "Ciudad Libre y Hanseática",
      tone: 'semantic',
    },
    {
      german: "Hamburg",
      translated: "Hamburgo",
      tone: 'semantic',
    },
  ],
  "lid:state:HH:1|fa": [
    {
      german: "Welches Wappen",
      translated: "کدام نشان",
      tone: 'semantic',
    },
    {
      german: "gehört",
      translated: "متعلق",
      tone: 'semantic',
    },
    {
      german: "zur",
      translated: "به",
      tone: 'semantic',
    },
    {
      german: "Freien und Hansestadt",
      translated: "شهر آزاد و هانزایی",
      tone: 'semantic',
    },
    {
      german: "Hamburg",
      translated: "هامبورگ",
      tone: 'semantic',
    },
  ],
  "lid:state:HH:1|fr": [
    {
      german: "Welches Wappen",
      translated: "Quel blason",
      tone: 'semantic',
    },
    {
      german: "gehört",
      translated: "appartient",
      tone: 'semantic',
    },
    {
      german: "zur",
      translated: "à",
      tone: 'semantic',
    },
    {
      german: "Freien und Hansestadt",
      translated: "la Ville libre et hanséatique",
      tone: 'semantic',
    },
    {
      german: "Hamburg",
      translated: "de Hambourg",
      tone: 'semantic',
    },
  ],
  "lid:state:HH:1|hr": [
    {
      german: "Welches Wappen",
      translated: "Koji grb",
      tone: 'semantic',
    },
    {
      german: "gehört",
      translated: "pripada",
      tone: 'semantic',
    },
    {
      german: "Freien und Hansestadt",
      translated: "Slobodnom i hanzeatskom gradu",
      tone: 'semantic',
    },
    {
      german: "Hamburg",
      translated: "Hamburgu",
      tone: 'semantic',
    },
  ],
  "lid:state:HH:1|it": [
    {
      german: "Welches Wappen",
      translated: "Quale stemma",
      tone: 'semantic',
    },
    {
      german: "gehört",
      translated: "appartiene",
      tone: 'semantic',
    },
    {
      german: "zur",
      translated: "alla",
      tone: 'semantic',
    },
    {
      german: "Freien und Hansestadt",
      translated: "Città Libera e Anseatica",
      tone: 'semantic',
    },
    {
      german: "Hamburg",
      translated: "Amburgo",
      tone: 'semantic',
    },
  ],
  "lid:state:HH:1|kmr": [
    {
      german: "Welches Wappen",
      translated: "Kîjan nîşan",
      tone: 'semantic',
    },
    {
      german: "gehört",
      translated: "a",
      tone: 'semantic',
    },
    {
      german: "Freien und Hansestadt",
      translated: "Bajarê Azad û Hanseatîk",
      tone: 'semantic',
    },
    {
      german: "Hamburg",
      translated: "Hamburg",
      tone: 'semantic',
    },
  ],
  "lid:state:HH:1|pl": [
    {
      german: "Welches Wappen",
      translated: "Który herb",
      tone: 'semantic',
    },
    {
      german: "gehört",
      translated: "należy do",
      tone: 'semantic',
    },
    {
      german: "Freien und Hansestadt",
      translated: "kraju związkowego",
      tone: 'semantic',
    },
    {
      german: "Hamburg",
      translated: "Hamburg",
      tone: 'semantic',
    },
  ],
  "lid:state:HH:1|prs": [
    {
      german: "Welches Wappen",
      translated: "کدام نشان",
      tone: 'semantic',
    },
    {
      german: "gehört",
      translated: "متعلق",
      tone: 'semantic',
    },
    {
      german: "zur",
      translated: "به",
      tone: 'semantic',
    },
    {
      german: "Freien und Hansestadt",
      translated: "شهر آزاد و هانزایی",
      tone: 'semantic',
    },
    {
      german: "Hamburg",
      translated: "هامبورگ",
      tone: 'semantic',
    },
  ],
  "lid:state:HH:1|ro": [
    {
      german: "Welches Wappen",
      translated: "Care stemă",
      tone: 'semantic',
    },
    {
      german: "gehört",
      translated: "aparține",
      tone: 'semantic',
    },
    {
      german: "Freien und Hansestadt",
      translated: "Orașului Liber și Hanseatic",
      tone: 'semantic',
    },
    {
      german: "Hamburg",
      translated: "Hamburg",
      tone: 'semantic',
    },
  ],
  "lid:state:HH:1|ru": [
    {
      german: "Welches Wappen",
      translated: "Какой герб",
      tone: 'semantic',
    },
    {
      german: "gehört",
      translated: "принадлежит",
      tone: 'semantic',
    },
    {
      german: "zur",
      translated: "вольному",
      tone: 'semantic',
    },
    {
      german: "Freien und Hansestadt",
      translated: "ганзейскому городу",
      tone: 'semantic',
    },
    {
      german: "Hamburg",
      translated: "Гамбург",
      tone: 'semantic',
    },
  ],
  "lid:state:HH:1|sq": [
    {
      german: "Welches Wappen",
      translated: "Cila stemë",
      tone: 'semantic',
    },
    {
      german: "gehört",
      translated: "i përket",
      tone: 'semantic',
    },
    {
      german: "Freien und Hansestadt",
      translated: "Qytetit të Lirë dhe Hanseatik",
      tone: 'semantic',
    },
    {
      german: "Hamburg",
      translated: "të Hamburgut",
      tone: 'semantic',
    },
  ],
  "lid:state:HH:1|sr": [
    {
      german: "Welches Wappen",
      translated: "grb",
      tone: 'semantic',
    },
    {
      german: "gehört",
      translated: "pripada",
      tone: 'semantic',
    },
    {
      german: "zur",
      translated: "saveznoj",
      tone: 'semantic',
    },
    {
      german: "Freien und Hansestadt",
      translated: "pokrajini",
      tone: 'semantic',
    },
    {
      german: "Hamburg",
      translated: "Hamburg",
      tone: 'semantic',
    },
  ],
  "lid:state:HH:1|tr": [
    {
      german: "Welches Wappen",
      translated: "arması",
      tone: 'semantic',
    },
    {
      german: "gehört",
      translated: "hangisidir",
      tone: 'semantic',
    },
    {
      german: "Freien und Hansestadt",
      translated: "Özgür ve Hansa Şehri",
      tone: 'semantic',
    },
    {
      german: "Hamburg",
      translated: "Hamburg'un",
      tone: 'semantic',
    },
  ],
  "lid:state:HH:1|uk": [
    {
      german: "Welches Wappen",
      translated: "Який герб",
      tone: 'semantic',
    },
    {
      german: "gehört",
      translated: "належить",
      tone: 'semantic',
    },
    {
      german: "Freien und Hansestadt",
      translated: "Вільному і ганзейському місту",
      tone: 'semantic',
    },
    {
      german: "Hamburg",
      translated: "Гамбург",
      tone: 'semantic',
    },
  ],
  "lid:state:HH:1|vi": [
    {
      german: "Welches Wappen",
      translated: "Quốc huy nào",
      tone: 'semantic',
    },
    {
      german: "gehört",
      translated: "thuộc",
      tone: 'semantic',
    },
    {
      german: "Freien und Hansestadt",
      translated: "Thành phố Tự do và Hanse",
      tone: 'semantic',
    },
    {
      german: "Hamburg",
      translated: "Hamburg",
      tone: 'semantic',
    },
  ],
  "lid:state:HH:2|ar": [
    {
      german: "Welches",
      translated: "أي",
      tone: 'semantic',
    },
    {
      german: "ein Bezirk",
      translated: "منطقة إدارية (Bezirk)",
      tone: 'semantic',
    },
    {
      german: "von Hamburg",
      translated: "في Hamburg",
      tone: 'semantic',
    },
  ],
  "lid:state:HH:2|bg": [
    {
      german: "Welches",
      translated: "Кое",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "от",
      tone: 'semantic',
    },
    {
      german: "ein Bezirk",
      translated: "район/градски район",
      tone: 'semantic',
    },
    {
      german: "von Hamburg",
      translated: "на Хамбург",
      tone: 'semantic',
    },
  ],
  "lid:state:HH:2|bs": [
    {
      german: "Welches",
      translated: "Što",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "je",
      tone: 'semantic',
    },
    {
      german: "ein Bezirk",
      translated: "od navedenoga gradska četvrt/okrug",
      tone: 'semantic',
    },
    {
      german: "von Hamburg",
      translated: "grada Hamburg",
      tone: 'semantic',
    },
  ],
  "lid:state:HH:2|el": [
    {
      german: "Welches",
      translated: "Ποιο",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "είναι",
      tone: 'semantic',
    },
    {
      german: "ein Bezirk",
      translated: "δημοτικό διαμέρισμα/περιοχή",
      tone: 'semantic',
    },
    {
      german: "von Hamburg",
      translated: "του Αμβούργο",
      tone: 'semantic',
    },
  ],
  "lid:state:HH:2|en": [
    {
      german: "Welches",
      translated: "Which",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "is",
      tone: 'semantic',
    },
    {
      german: "ein Bezirk",
      translated: "a borough",
      tone: 'semantic',
    },
    {
      german: "von Hamburg",
      translated: "of Hamburg",
      tone: 'semantic',
    },
  ],
  "lid:state:HH:2|es": [
    {
      german: "Welches",
      translated: "¿Cuál",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "es",
      tone: 'semantic',
    },
    {
      german: "ein Bezirk",
      translated: "un distrito",
      tone: 'semantic',
    },
    {
      german: "von Hamburg",
      translated: "de Hamburgo",
      tone: 'semantic',
    },
  ],
  "lid:state:HH:2|fa": [
    {
      german: "Welches",
      translated: "کدام‌یک",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "است",
      tone: 'semantic',
    },
    {
      german: "ein Bezirk",
      translated: "یک ناحیه/بخش شهری",
      tone: 'semantic',
    },
    {
      german: "von Hamburg",
      translated: "در هامبورگ",
      tone: 'semantic',
    },
  ],
  "lid:state:HH:2|fr": [
    {
      german: "Welches",
      translated: "Lequel",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "est",
      tone: 'semantic',
    },
    {
      german: "ein Bezirk",
      translated: "un arrondissement",
      tone: 'semantic',
    },
    {
      german: "von Hamburg",
      translated: "de Hambourg",
      tone: 'semantic',
    },
  ],
  "lid:state:HH:2|hr": [
    {
      german: "Welches",
      translated: "Što",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "je",
      tone: 'semantic',
    },
    {
      german: "ein Bezirk",
      translated: "od navedenoga gradska četvrt/okrug",
      tone: 'semantic',
    },
    {
      german: "von Hamburg",
      translated: "grada Hamburg",
      tone: 'semantic',
    },
  ],
  "lid:state:HH:2|it": [
    {
      german: "Welches",
      translated: "Quale",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "è",
      tone: 'semantic',
    },
    {
      german: "ein Bezirk",
      translated: "un distretto",
      tone: 'semantic',
    },
    {
      german: "von Hamburg",
      translated: "di Amburgo",
      tone: 'semantic',
    },
  ],
  "lid:state:HH:2|kmr": [
    {
      german: "Welches",
      translated: "Kîjan",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "ji",
      tone: 'semantic',
    },
    {
      german: "ein Bezirk",
      translated: "van navçeyek (Bezirk)",
      tone: 'semantic',
    },
    {
      german: "von Hamburg",
      translated: "a Hamburg e",
      tone: 'semantic',
    },
  ],
  "lid:state:HH:2|pl": [
    {
      german: "Welches",
      translated: "Które",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "jest",
      tone: 'semantic',
    },
    {
      german: "ein Bezirk",
      translated: "dzielnicą/okręgiem",
      tone: 'semantic',
    },
    {
      german: "von Hamburg",
      translated: "miasta Hamburg",
      tone: 'semantic',
    },
  ],
  "lid:state:HH:2|prs": [
    {
      german: "Welches",
      translated: "کدام",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "است",
      tone: 'semantic',
    },
    {
      german: "ein Bezirk",
      translated: "یک ناحیه/بخش شهری",
      tone: 'semantic',
    },
    {
      german: "von Hamburg",
      translated: "در هامبورگ",
      tone: 'semantic',
    },
  ],
  "lid:state:HH:2|ro": [
    {
      german: "Welches",
      translated: "Care",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "este",
      tone: 'semantic',
    },
    {
      german: "ein Bezirk",
      translated: "un district/sector",
      tone: 'semantic',
    },
    {
      german: "von Hamburg",
      translated: "al orașului Hamburg",
      tone: 'semantic',
    },
  ],
  "lid:state:HH:2|ru": [
    {
      german: "Welches",
      translated: "Какой",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "является",
      tone: 'semantic',
    },
    {
      german: "ein Bezirk",
      translated: "районом",
      tone: 'semantic',
    },
    {
      german: "von Hamburg",
      translated: "Гамбурга",
      tone: 'semantic',
    },
  ],
  "lid:state:HH:2|sq": [
    {
      german: "Welches",
      translated: "Cila nga këto",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "është",
      tone: 'semantic',
    },
    {
      german: "ein Bezirk",
      translated: "një lagje/rreth",
      tone: 'semantic',
    },
    {
      german: "von Hamburg",
      translated: "i Hamburgu",
      tone: 'semantic',
    },
  ],
  "lid:state:HH:2|sr": [
    {
      german: "Welches",
      translated: "Šta",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "je",
      tone: 'semantic',
    },
    {
      german: "ein Bezirk",
      translated: "gradska četvrt/okrug",
      tone: 'semantic',
    },
    {
      german: "von Hamburg",
      translated: "grada Hamburg",
      tone: 'semantic',
    },
  ],
  "lid:state:HH:2|tr": [
    {
      german: "Welches",
      translated: "Aşağıdakilerden",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "hangisi",
      tone: 'semantic',
    },
    {
      german: "ein Bezirk",
      translated: "Hamburg’un bir ilçesidir",
      tone: 'semantic',
    },
  ],
  "lid:state:HH:2|uk": [
    {
      german: "Welches",
      translated: "Який",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "із",
      tone: 'semantic',
    },
    {
      german: "ein Bezirk",
      translated: "наведених районів",
      tone: 'semantic',
    },
    {
      german: "von Hamburg",
      translated: "Гамбурга",
      tone: 'semantic',
    },
  ],
  "lid:state:HH:2|vi": [
    {
      german: "Welches",
      translated: "Địa danh nào sau đây",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "là",
      tone: 'semantic',
    },
    {
      german: "ein Bezirk",
      translated: "khu vực",
      tone: 'semantic',
    },
    {
      german: "von Hamburg",
      translated: "của Hamburg",
      tone: 'semantic',
    },
  ],
  "lid:state:HH:3|ar": [
    {
      german: "Für wie viele Jahre",
      translated: "لمدة كم سنة",
      tone: 'semantic',
    },
    {
      german: "das Landesparlament",
      translated: "برلمان الولاية",
      tone: 'semantic',
    },
    {
      german: "in Hamburg",
      translated: "في Hamburg",
      tone: 'semantic',
    },
    {
      german: "gewählt",
      translated: "يُنتخب",
      tone: 'semantic',
    },
  ],
  "lid:state:HH:3|bg": [
    {
      german: "Für wie viele Jahre",
      translated: "За колко години",
      tone: 'semantic',
    },
    {
      german: "wird",
      translated: "се",
      tone: 'semantic',
    },
    {
      german: "das Landesparlament",
      translated: "парламентът",
      tone: 'semantic',
    },
    {
      german: "in Hamburg",
      translated: "на провинция Хамбург",
      tone: 'semantic',
    },
    {
      german: "gewählt",
      translated: "избира",
      tone: 'semantic',
    },
  ],
  "lid:state:HH:3|bs": [
    {
      german: "Für wie viele Jahre",
      translated: "Na koliko se godina",
      tone: 'semantic',
    },
    {
      german: "das Landesparlament",
      translated: "parlament savezne zemlje",
      tone: 'semantic',
    },
    {
      german: "in Hamburg",
      translated: "Hamburg",
      tone: 'semantic',
    },
    {
      german: "gewählt",
      translated: "bira",
      tone: 'semantic',
    },
  ],
  "lid:state:HH:3|el": [
    {
      german: "Für wie viele Jahre",
      translated: "Για πόσα χρόνια",
      tone: 'semantic',
    },
    {
      german: "wird",
      translated: "εκλέγεται",
      tone: 'semantic',
    },
    {
      german: "das Landesparlament",
      translated: "το κοινοβούλιο",
      tone: 'semantic',
    },
    {
      german: "in Hamburg",
      translated: "του κρατιδίου Αμβούργο",
      tone: 'semantic',
    },
  ],
  "lid:state:HH:3|en": [
    {
      german: "Für wie viele Jahre",
      translated: "For how many years",
      tone: 'semantic',
    },
    {
      german: "wird",
      translated: "is",
      tone: 'semantic',
    },
    {
      german: "das Landesparlament",
      translated: "the state parliament",
      tone: 'semantic',
    },
    {
      german: "in Hamburg",
      translated: "in Hamburg",
      tone: 'semantic',
    },
    {
      german: "gewählt",
      translated: "elected",
      tone: 'semantic',
    },
  ],
  "lid:state:HH:3|es": [
    {
      german: "Für wie viele Jahre",
      translated: "¿Por cuántos años",
      tone: 'semantic',
    },
    {
      german: "wird",
      translated: "se",
      tone: 'semantic',
    },
    {
      german: "das Landesparlament",
      translated: "el parlamento regional",
      tone: 'semantic',
    },
    {
      german: "in Hamburg",
      translated: "en Hamburgo",
      tone: 'semantic',
    },
    {
      german: "gewählt",
      translated: "elige",
      tone: 'semantic',
    },
  ],
  "lid:state:HH:3|fa": [
    {
      german: "Für wie viele Jahre",
      translated: "برای چند سال",
      tone: 'semantic',
    },
    {
      german: "wird",
      translated: "می‌شود",
      tone: 'semantic',
    },
    {
      german: "das Landesparlament",
      translated: "پارلمان ایالتی",
      tone: 'semantic',
    },
    {
      german: "in Hamburg",
      translated: "هامبورگ",
      tone: 'semantic',
    },
    {
      german: "gewählt",
      translated: "انتخاب",
      tone: 'semantic',
    },
  ],
  "lid:state:HH:3|fr": [
    {
      german: "Für wie viele Jahre",
      translated: "Pour combien d’années",
      tone: 'semantic',
    },
    {
      german: "wird",
      translated: "est-il",
      tone: 'semantic',
    },
    {
      german: "das Landesparlament",
      translated: "Parlement du Land",
      tone: 'semantic',
    },
    {
      german: "in Hamburg",
      translated: "de Hambourg",
      tone: 'semantic',
    },
    {
      german: "gewählt",
      translated: "élu",
      tone: 'semantic',
    },
  ],
  "lid:state:HH:3|hr": [
    {
      german: "Für wie viele Jahre",
      translated: "Na koliko",
      tone: 'semantic',
    },
    {
      german: "wird",
      translated: "se",
      tone: 'semantic',
    },
    {
      german: "das Landesparlament",
      translated: "parlament savezne zemlje",
      tone: 'semantic',
    },
    {
      german: "in Hamburg",
      translated: "Hamburg",
      tone: 'semantic',
    },
    {
      german: "gewählt",
      translated: "bira",
      tone: 'semantic',
    },
  ],
  "lid:state:HH:3|it": [
    {
      german: "Für wie viele Jahre",
      translated: "Per quanti anni",
      tone: 'semantic',
    },
    {
      german: "wird",
      translated: "viene",
      tone: 'semantic',
    },
    {
      german: "das Landesparlament",
      translated: "il Parlamento del Land",
      tone: 'semantic',
    },
    {
      german: "in Hamburg",
      translated: "di Amburgo",
      tone: 'semantic',
    },
    {
      german: "gewählt",
      translated: "eletto",
      tone: 'semantic',
    },
  ],
  "lid:state:HH:3|kmr": [
    {
      german: "Für wie viele Jahre",
      translated: "çend salan",
      tone: 'semantic',
    },
    {
      german: "wird",
      translated: "tê",
      tone: 'semantic',
    },
    {
      german: "das Landesparlament",
      translated: "Parlamentoya",
      tone: 'semantic',
    },
    {
      german: "in Hamburg",
      translated: "ya Hamburg",
      tone: 'semantic',
    },
    {
      german: "gewählt",
      translated: "hilbijartin",
      tone: 'semantic',
    },
  ],
  "lid:state:HH:3|pl": [
    {
      german: "Für wie viele Jahre",
      translated: "Na ile lat",
      tone: 'semantic',
    },
    {
      german: "wird",
      translated: "jest",
      tone: 'semantic',
    },
    {
      german: "das Landesparlament",
      translated: "parlament kraju związkowego",
      tone: 'semantic',
    },
    {
      german: "in Hamburg",
      translated: "Hamburg",
      tone: 'semantic',
    },
    {
      german: "gewählt",
      translated: "wybierany",
      tone: 'semantic',
    },
  ],
  "lid:state:HH:3|prs": [
    {
      german: "Für wie viele Jahre",
      translated: "برای چند سال",
      tone: 'semantic',
    },
    {
      german: "das Landesparlament",
      translated: "پارلمان ایالتی",
      tone: 'semantic',
    },
    {
      german: "in Hamburg",
      translated: "هامبورگ",
      tone: 'semantic',
    },
    {
      german: "gewählt",
      translated: "انتخاب می‌شود",
      tone: 'semantic',
    },
  ],
  "lid:state:HH:3|ro": [
    {
      german: "Für wie viele Jahre",
      translated: "câți ani",
      tone: 'semantic',
    },
    {
      german: "wird",
      translated: "este ales",
      tone: 'semantic',
    },
    {
      german: "das Landesparlament",
      translated: "parlamentul landului",
      tone: 'semantic',
    },
    {
      german: "in Hamburg",
      translated: "Hamburg",
      tone: 'semantic',
    },
  ],
  "lid:state:HH:3|ru": [
    {
      german: "Für wie viele Jahre",
      translated: "На сколько лет",
      tone: 'semantic',
    },
    {
      german: "das Landesparlament",
      translated: "земельный парламент",
      tone: 'semantic',
    },
    {
      german: "in Hamburg",
      translated: "в Гамбурге",
      tone: 'semantic',
    },
    {
      german: "gewählt",
      translated: "избирается",
      tone: 'semantic',
    },
  ],
  "lid:state:HH:3|sq": [
    {
      german: "Für wie viele Jahre",
      translated: "Për sa vjet",
      tone: 'semantic',
    },
    {
      german: "das Landesparlament",
      translated: "parlamenti i landit",
      tone: 'semantic',
    },
    {
      german: "in Hamburg",
      translated: "Hamburgu",
      tone: 'semantic',
    },
    {
      german: "gewählt",
      translated: "zgjidhet",
      tone: 'semantic',
    },
  ],
  "lid:state:HH:3|sr": [
    {
      german: "Für wie viele Jahre",
      translated: "Na koliko se godina",
      tone: 'semantic',
    },
    {
      german: "das Landesparlament",
      translated: "parlament savezne",
      tone: 'semantic',
    },
    {
      german: "in Hamburg",
      translated: "Hamburg",
      tone: 'semantic',
    },
    {
      german: "gewählt",
      translated: "bira",
      tone: 'semantic',
    },
  ],
  "lid:state:HH:3|tr": [
    {
      german: "Für wie viele Jahre",
      translated: "kaç yıllığına",
      tone: 'semantic',
    },
    {
      german: "wird",
      translated: "seçilir",
      tone: 'semantic',
    },
    {
      german: "das Landesparlament",
      translated: "eyalet parlamentosu",
      tone: 'semantic',
    },
    {
      german: "in Hamburg",
      translated: "Hamburg",
      tone: 'semantic',
    },
  ],
  "lid:state:HH:3|uk": [
    {
      german: "Für wie viele Jahre",
      translated: "На скільки років",
      tone: 'semantic',
    },
    {
      german: "wird",
      translated: "обирають",
      tone: 'semantic',
    },
    {
      german: "das Landesparlament",
      translated: "земельний парламент",
      tone: 'semantic',
    },
    {
      german: "in Hamburg",
      translated: "у Гамбурзі",
      tone: 'semantic',
    },
  ],
  "lid:state:HH:3|vi": [
    {
      german: "Für wie viele Jahre",
      translated: "bao nhiêu năm",
      tone: 'semantic',
    },
    {
      german: "das Landesparlament",
      translated: "Nghị viện bang Hamburg",
      tone: 'semantic',
    },
    {
      german: "gewählt",
      translated: "được bầu",
      tone: 'semantic',
    },
  ],
  "lid:state:HH:4|ar": [
    {
      german: "Ab welchem Alter",
      translated: "ابتداءً من أي سن",
      tone: 'semantic',
    },
    {
      german: "darf man",
      translated: "يحق",
      tone: 'semantic',
    },
    {
      german: "in Hamburg",
      translated: "في Hamburg",
      tone: 'semantic',
    },
    {
      german: "bei Kommunalwahlen",
      translated: "في الانتخابات المحلية",
      tone: 'semantic',
    },
    {
      german: "(Wahl der Bezirksversammlungen)",
      translated: "(انتخابات مجالس الأحياء)",
      tone: 'semantic',
    },
    {
      german: "wählen",
      translated: "التصويت",
      tone: 'semantic',
    },
  ],
  "lid:state:HH:4|bg": [
    {
      german: "Ab welchem Alter",
      translated: "От каква възраст",
      tone: 'semantic',
    },
    {
      german: "darf man",
      translated: "може да се",
      tone: 'semantic',
    },
    {
      german: "in Hamburg",
      translated: "в Хамбург",
      tone: 'semantic',
    },
    {
      german: "bei Kommunalwahlen",
      translated: "на общински избори",
      tone: 'semantic',
    },
    {
      german: "(Wahl der Bezirksversammlungen)",
      translated: "избор за районните събрания",
      tone: 'semantic',
    },
    {
      german: "wählen",
      translated: "гласува",
      tone: 'semantic',
    },
  ],
  "lid:state:HH:4|bs": [
    {
      german: "Ab welchem Alter",
      translated: "Od koje se dobi",
      tone: 'semantic',
    },
    {
      german: "darf man",
      translated: "može",
      tone: 'semantic',
    },
    {
      german: "in Hamburg",
      translated: "u Hamburgu",
      tone: 'semantic',
    },
    {
      german: "bei Kommunalwahlen",
      translated: "na lokalnim izborima",
      tone: 'semantic',
    },
    {
      german: "(Wahl der Bezirksversammlungen)",
      translated: "(izborima za skupštine gradskih okruga)",
      tone: 'semantic',
    },
    {
      german: "wählen",
      translated: "glasovati",
      tone: 'semantic',
    },
  ],
  "lid:state:HH:4|el": [
    {
      german: "Ab welchem Alter",
      translated: "Από ποια ηλικία",
      tone: 'semantic',
    },
    {
      german: "darf man",
      translated: "μπορεί κάποιος",
      tone: 'semantic',
    },
    {
      german: "in Hamburg",
      translated: "στο Αμβούργο",
      tone: 'semantic',
    },
    {
      german: "bei Kommunalwahlen",
      translated: "στις δημοτικές εκλογές",
      tone: 'semantic',
    },
    {
      german: "(Wahl der Bezirksversammlungen)",
      translated: "εκλογή των Bezirksversammlungen",
      tone: 'semantic',
    },
    {
      german: "wählen",
      translated: "να ψηφίσει",
      tone: 'semantic',
    },
  ],
  "lid:state:HH:4|en": [
    {
      german: "Ab welchem Alter",
      translated: "From what age",
      tone: 'semantic',
    },
    {
      german: "darf man",
      translated: "can you",
      tone: 'semantic',
    },
    {
      german: "in Hamburg",
      translated: "in Hamburg",
      tone: 'semantic',
    },
    {
      german: "bei Kommunalwahlen",
      translated: "in local elections",
      tone: 'semantic',
    },
    {
      german: "(Wahl der Bezirksversammlungen)",
      translated: "election of district assemblies",
      tone: 'semantic',
    },
    {
      german: "wählen",
      translated: "vote",
      tone: 'semantic',
    },
  ],
  "lid:state:HH:4|es": [
    {
      german: "Ab welchem Alter",
      translated: "¿A partir de qué edad",
      tone: 'semantic',
    },
    {
      german: "darf man",
      translated: "se puede",
      tone: 'semantic',
    },
    {
      german: "in Hamburg",
      translated: "en Hamburgo",
      tone: 'semantic',
    },
    {
      german: "bei Kommunalwahlen",
      translated: "en las elecciones municipales",
      tone: 'semantic',
    },
    {
      german: "(Wahl der Bezirksversammlungen)",
      translated: "(elección de las asambleas de distrito)",
      tone: 'semantic',
    },
    {
      german: "wählen",
      translated: "votar",
      tone: 'semantic',
    },
  ],
  "lid:state:HH:4|fa": [
    {
      german: "Ab welchem Alter",
      translated: "از چه سنی",
      tone: 'semantic',
    },
    {
      german: "darf man",
      translated: "می‌توان",
      tone: 'semantic',
    },
    {
      german: "in Hamburg",
      translated: "در هامبورگ",
      tone: 'semantic',
    },
    {
      german: "bei Kommunalwahlen",
      translated: "در انتخابات محلی",
      tone: 'semantic',
    },
    {
      german: "(Wahl der Bezirksversammlungen)",
      translated: "انتخاب مجامع مناطق",
      tone: 'semantic',
    },
    {
      german: "wählen",
      translated: "رأی داد",
      tone: 'semantic',
    },
  ],
  "lid:state:HH:4|fr": [
    {
      german: "Ab welchem Alter",
      translated: "À partir de quel âge",
      tone: 'semantic',
    },
    {
      german: "darf man",
      translated: "peut-on",
      tone: 'semantic',
    },
    {
      german: "in Hamburg",
      translated: "à Hambourg",
      tone: 'semantic',
    },
    {
      german: "bei Kommunalwahlen",
      translated: "aux élections municipales",
      tone: 'semantic',
    },
    {
      german: "(Wahl der Bezirksversammlungen)",
      translated: "élections des assemblées d’arrondissement",
      tone: 'semantic',
    },
    {
      german: "wählen",
      translated: "voter",
      tone: 'semantic',
    },
  ],
  "lid:state:HH:4|hr": [
    {
      german: "Ab welchem Alter",
      translated: "Od koje se dobi",
      tone: 'semantic',
    },
    {
      german: "darf man",
      translated: "može",
      tone: 'semantic',
    },
    {
      german: "in Hamburg",
      translated: "u Hamburgu",
      tone: 'semantic',
    },
    {
      german: "bei Kommunalwahlen",
      translated: "na lokalnim izborima",
      tone: 'semantic',
    },
    {
      german: "(Wahl der Bezirksversammlungen)",
      translated: "(izborima za skupštine gradskih okruga)",
      tone: 'semantic',
    },
    {
      german: "wählen",
      translated: "glasovati",
      tone: 'semantic',
    },
  ],
  "lid:state:HH:4|it": [
    {
      german: "Ab welchem Alter",
      translated: "Da quale età",
      tone: 'semantic',
    },
    {
      german: "darf man",
      translated: "si può",
      tone: 'semantic',
    },
    {
      german: "in Hamburg",
      translated: "a Amburgo",
      tone: 'semantic',
    },
    {
      german: "bei Kommunalwahlen",
      translated: "alle elezioni locali",
      tone: 'semantic',
    },
    {
      german: "(Wahl der Bezirksversammlungen)",
      translated: "elezione delle assemblee distrettuali",
      tone: 'semantic',
    },
    {
      german: "wählen",
      translated: "votare",
      tone: 'semantic',
    },
  ],
  "lid:state:HH:4|kmr": [
    {
      german: "Ab welchem Alter",
      translated: "Ji kîjan temenê",
      tone: 'semantic',
    },
    {
      german: "darf man",
      translated: "dikare",
      tone: 'semantic',
    },
    {
      german: "in Hamburg",
      translated: "li Hamburg",
      tone: 'semantic',
    },
    {
      german: "bei Kommunalwahlen",
      translated: "di hilbijartinên navçeyan de",
      tone: 'semantic',
    },
    {
      german: "(Wahl der Bezirksversammlungen)",
      translated: "hilbijartina meclîsên navçeyan",
      tone: 'semantic',
    },
    {
      german: "wählen",
      translated: "deng were dayîn",
      tone: 'semantic',
    },
  ],
  "lid:state:HH:4|pl": [
    {
      german: "Ab welchem Alter",
      translated: "Od jakiego wieku",
      tone: 'semantic',
    },
    {
      german: "darf man",
      translated: "można",
      tone: 'semantic',
    },
    {
      german: "in Hamburg",
      translated: "w Hamburg",
      tone: 'semantic',
    },
    {
      german: "bei Kommunalwahlen",
      translated: "w wyborach samorządowych",
      tone: 'semantic',
    },
    {
      german: "wählen",
      translated: "głosować",
      tone: 'semantic',
    },
  ],
  "lid:state:HH:4|prs": [
    {
      german: "Ab welchem Alter",
      translated: "از چه سنی",
      tone: 'semantic',
    },
    {
      german: "darf man",
      translated: "می‌توان",
      tone: 'semantic',
    },
    {
      german: "in Hamburg",
      translated: "هامبورگ",
      tone: 'semantic',
    },
    {
      german: "bei Kommunalwahlen",
      translated: "انتخابات شاروالی",
      tone: 'semantic',
    },
    {
      german: "(Wahl der Bezirksversammlungen)",
      translated: "انتخابات مجامع منطقه‌ای",
      tone: 'semantic',
    },
    {
      german: "wählen",
      translated: "رأی داد",
      tone: 'semantic',
    },
  ],
  "lid:state:HH:4|ro": [
    {
      german: "Ab welchem Alter",
      translated: "De la ce vârstă",
      tone: 'semantic',
    },
    {
      german: "darf man",
      translated: "se poate",
      tone: 'semantic',
    },
    {
      german: "in Hamburg",
      translated: "din Hamburg",
      tone: 'semantic',
    },
    {
      german: "bei Kommunalwahlen",
      translated: "la alegerile locale",
      tone: 'semantic',
    },
    {
      german: "(Wahl der Bezirksversammlungen)",
      translated: "alegerea adunărilor districtuale",
      tone: 'semantic',
    },
    {
      german: "wählen",
      translated: "vota",
      tone: 'semantic',
    },
  ],
  "lid:state:HH:4|ru": [
    {
      german: "Ab welchem Alter",
      translated: "С какого возраста",
      tone: 'semantic',
    },
    {
      german: "darf man",
      translated: "можно",
      tone: 'semantic',
    },
    {
      german: "in Hamburg",
      translated: "в Гамбурге",
      tone: 'semantic',
    },
    {
      german: "bei Kommunalwahlen",
      translated: "на муниципальных выборах",
      tone: 'semantic',
    },
    {
      german: "(Wahl der Bezirksversammlungen)",
      translated: "(выборах окружных собраний)",
      tone: 'semantic',
    },
    {
      german: "wählen",
      translated: "голосовать",
      tone: 'semantic',
    },
  ],
  "lid:state:HH:4|sq": [
    {
      german: "Ab welchem Alter",
      translated: "Nga cila moshë",
      tone: 'semantic',
    },
    {
      german: "darf man",
      translated: "mund të",
      tone: 'semantic',
    },
    {
      german: "in Hamburg",
      translated: "në Hamburg",
      tone: 'semantic',
    },
    {
      german: "bei Kommunalwahlen",
      translated: "në zgjedhjet komunale",
      tone: 'semantic',
    },
    {
      german: "(Wahl der Bezirksversammlungen)",
      translated: "zgjedhja e kuvendeve të distrikteve",
      tone: 'semantic',
    },
    {
      german: "wählen",
      translated: "votohet",
      tone: 'semantic',
    },
  ],
  "lid:state:HH:4|sr": [
    {
      german: "Ab welchem Alter",
      translated: "Od koje se dobi",
      tone: 'semantic',
    },
    {
      german: "darf man",
      translated: "može",
      tone: 'semantic',
    },
    {
      german: "in Hamburg",
      translated: "u Hamburgu",
      tone: 'semantic',
    },
    {
      german: "bei Kommunalwahlen",
      translated: "na lokalnim izborima",
      tone: 'semantic',
    },
    {
      german: "(Wahl der Bezirksversammlungen)",
      translated: "(izborima za skupštine gradskih okruga)",
      tone: 'semantic',
    },
    {
      german: "wählen",
      translated: "glasati",
      tone: 'semantic',
    },
  ],
  "lid:state:HH:4|tr": [
    {
      german: "Ab welchem Alter",
      translated: "kaç yaşından itibaren",
      tone: 'semantic',
    },
    {
      german: "in Hamburg",
      translated: "Hamburg’da",
      tone: 'semantic',
    },
    {
      german: "bei Kommunalwahlen",
      translated: "yerel seçimlerde",
      tone: 'semantic',
    },
    {
      german: "(Wahl der Bezirksversammlungen)",
      translated: "(ilçe meclisi seçimlerinde)",
      tone: 'semantic',
    },
    {
      german: "wählen",
      translated: "oy kullanılabilir",
      tone: 'semantic',
    },
  ],
  "lid:state:HH:4|uk": [
    {
      german: "Ab welchem Alter",
      translated: "З якого віку",
      tone: 'semantic',
    },
    {
      german: "darf man",
      translated: "можна",
      tone: 'semantic',
    },
    {
      german: "in Hamburg",
      translated: "в Гамбурзі",
      tone: 'semantic',
    },
    {
      german: "bei Kommunalwahlen",
      translated: "на муніципальних виборах",
      tone: 'semantic',
    },
    {
      german: "(Wahl der Bezirksversammlungen)",
      translated: "(виборах районних зборів)",
      tone: 'semantic',
    },
    {
      german: "wählen",
      translated: "голосувати",
      tone: 'semantic',
    },
  ],
  "lid:state:HH:4|vi": [
    {
      german: "Ab welchem Alter",
      translated: "Từ bao nhiêu tuổi",
      tone: 'semantic',
    },
    {
      german: "darf man",
      translated: "có thể",
      tone: 'semantic',
    },
    {
      german: "in Hamburg",
      translated: "ở Hamburg",
      tone: 'semantic',
    },
    {
      german: "bei Kommunalwahlen",
      translated: "trong bầu cử địa phương",
      tone: 'semantic',
    },
    {
      german: "(Wahl der Bezirksversammlungen)",
      translated: "bầu cử Bezirksversammlungen",
      tone: 'semantic',
    },
    {
      german: "wählen",
      translated: "bỏ phiếu",
      tone: 'semantic',
    },
  ],
  "lid:state:HH:5|ar": [
    {
      german: "Welche Farben",
      translated: "ما ألوان",
      tone: 'semantic',
    },
    {
      german: "die Landesflagge von Hamburg",
      translated: "علم ولاية Hamburg",
      tone: 'semantic',
    },
  ],
  "lid:state:HH:5|bg": [
    {
      german: "Welche Farben",
      translated: "Какви са цветовете",
      tone: 'semantic',
    },
    {
      german: "die Landesflagge von Hamburg",
      translated: "на знамето на провинция Хамбург",
      tone: 'semantic',
    },
  ],
  "lid:state:HH:5|bs": [
    {
      german: "Welche Farben",
      translated: "Koje su boje",
      tone: 'semantic',
    },
    {
      german: "die Landesflagge von Hamburg",
      translated: "zastave savezne zemlje Hamburg",
      tone: 'semantic',
    },
  ],
  "lid:state:HH:5|el": [
    {
      german: "Welche Farben",
      translated: "Ποια είναι τα χρώματα",
      tone: 'semantic',
    },
    {
      german: "die Landesflagge von Hamburg",
      translated: "της σημαίας του κρατιδίου Αμβούργο",
      tone: 'semantic',
    },
  ],
  "lid:state:HH:5|en": [
    {
      german: "Welche Farben",
      translated: "What colors",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "does",
      tone: 'semantic',
    },
    {
      german: "die Landesflagge von Hamburg",
      translated: "the state flag of Hamburg",
      tone: 'semantic',
    },
  ],
  "lid:state:HH:5|es": [
    {
      german: "Welche Farben",
      translated: "¿Qué colores",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "tiene",
      tone: 'semantic',
    },
    {
      german: "die Landesflagge von Hamburg",
      translated: "la bandera regional de Hamburgo",
      tone: 'semantic',
    },
  ],
  "lid:state:HH:5|fa": [
    {
      german: "Welche Farben",
      translated: "رنگ‌های",
      tone: 'semantic',
    },
    {
      german: "die Landesflagge von Hamburg",
      translated: "پرچم ایالت هامبورگ",
      tone: 'semantic',
    },
  ],
  "lid:state:HH:5|fr": [
    {
      german: "Welche Farben",
      translated: "Quelles sont les couleurs",
      tone: 'semantic',
    },
    {
      german: "die Landesflagge von Hamburg",
      translated: "du drapeau du Land de Hambourg",
      tone: 'semantic',
    },
  ],
  "lid:state:HH:5|hr": [
    {
      german: "Welche Farben",
      translated: "Koje su boje",
      tone: 'semantic',
    },
    {
      german: "die Landesflagge von Hamburg",
      translated: "zastave savezne zemlje Hamburg",
      tone: 'semantic',
    },
  ],
  "lid:state:HH:5|it": [
    {
      german: "Welche Farben",
      translated: "Quali sono i colori",
      tone: 'semantic',
    },
    {
      german: "die Landesflagge von Hamburg",
      translated: "della bandiera del Land di Amburgo",
      tone: 'semantic',
    },
  ],
  "lid:state:HH:5|kmr": [
    {
      german: "Welche Farben",
      translated: "Rengên",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "çi",
      tone: 'semantic',
    },
    {
      german: "die Landesflagge von Hamburg",
      translated: "ala Hamburg",
      tone: 'semantic',
    },
  ],
  "lid:state:HH:5|pl": [
    {
      german: "Welche Farben",
      translated: "Jakie są kolory",
      tone: 'semantic',
    },
    {
      german: "die Landesflagge von Hamburg",
      translated: "flagi kraju związkowego Hamburg",
      tone: 'semantic',
    },
  ],
  "lid:state:HH:5|prs": [
    {
      german: "Welche Farben",
      translated: "رنگ‌های پرچم ایالت",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "کدام‌اند",
      tone: 'semantic',
    },
    {
      german: "die Landesflagge von Hamburg",
      translated: "هامبورگ",
      tone: 'semantic',
    },
  ],
  "lid:state:HH:5|ro": [
    {
      german: "Welche Farben",
      translated: "Care sunt culorile",
      tone: 'semantic',
    },
    {
      german: "die Landesflagge von Hamburg",
      translated: "drapelului landului Hamburg",
      tone: 'semantic',
    },
  ],
  "lid:state:HH:5|ru": [
    {
      german: "Welche Farben",
      translated: "Какие цвета",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "у",
      tone: 'semantic',
    },
    {
      german: "die Landesflagge von Hamburg",
      translated: "флага земли Гамбург",
      tone: 'semantic',
    },
  ],
  "lid:state:HH:5|sq": [
    {
      german: "Welche Farben",
      translated: "Cilat janë ngjyrat",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "e",
      tone: 'semantic',
    },
    {
      german: "die Landesflagge von Hamburg",
      translated: "flamurit të landit Hamburgu",
      tone: 'semantic',
    },
  ],
  "lid:state:HH:5|sr": [
    {
      german: "Welche Farben",
      translated: "Koje",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "su",
      tone: 'semantic',
    },
    {
      german: "die Landesflagge von Hamburg",
      translated: "zastave savezne pokrajine Hamburg",
      tone: 'semantic',
    },
  ],
  "lid:state:HH:5|tr": [
    {
      german: "Welche Farben",
      translated: "renkleri nelerdir",
      tone: 'semantic',
    },
    {
      german: "die Landesflagge von Hamburg",
      translated: "Hamburg eyalet bayrağının",
      tone: 'semantic',
    },
  ],
  "lid:state:HH:5|uk": [
    {
      german: "Welche Farben",
      translated: "Які кольори",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: " має",
      tone: 'semantic',
    },
    {
      german: "die Landesflagge von Hamburg",
      translated: "прапор федеральної землі Гамбург",
      tone: 'semantic',
    },
  ],
  "lid:state:HH:5|vi": [
    {
      german: "Welche Farben",
      translated: "Màu của",
      tone: 'semantic',
    },
    {
      german: "die Landesflagge von Hamburg",
      translated: "cờ bang Hamburg là gì?",
      tone: 'semantic',
    },
  ],
  "lid:state:HH:6|ar": [
    {
      german: "Wo",
      translated: "أين",
      tone: 'semantic',
    },
    {
      german: "können Sie sich",
      translated: "يمكنك",
      tone: 'semantic',
    },
    {
      german: "in Hamburg",
      translated: "في Hamburg",
      tone: 'semantic',
    },
    {
      german: "über politische Themen",
      translated: "عن القضايا السياسية",
      tone: 'semantic',
    },
    {
      german: "informieren?",
      translated: "الحصول على معلومات",
      tone: 'semantic',
    },
  ],
  "lid:state:HH:6|bg": [
    {
      german: "Wo",
      translated: "Къде",
      tone: 'semantic',
    },
    {
      german: "können Sie sich",
      translated: "можете",
      tone: 'semantic',
    },
    {
      german: "in Hamburg",
      translated: "в Хамбург",
      tone: 'semantic',
    },
    {
      german: "über politische Themen",
      translated: "по политически теми",
      tone: 'semantic',
    },
    {
      german: "informieren?",
      translated: "получите информация",
      tone: 'semantic',
    },
  ],
  "lid:state:HH:6|bs": [
    {
      german: "Wo",
      translated: "Gdje",
      tone: 'semantic',
    },
    {
      german: "können Sie sich",
      translated: "mogu",
      tone: 'semantic',
    },
    {
      german: "in Hamburg",
      translated: "u Hamburgu",
      tone: 'semantic',
    },
    {
      german: "über politische Themen",
      translated: "o političkim temama",
      tone: 'semantic',
    },
    {
      german: "informieren?",
      translated: "dobiti informacije",
      tone: 'semantic',
    },
  ],
  "lid:state:HH:6|el": [
    {
      german: "Wo",
      translated: "Πού",
      tone: 'semantic',
    },
    {
      german: "können Sie sich",
      translated: "μπορείτε να ενημερωθείτε",
      tone: 'semantic',
    },
    {
      german: "in Hamburg",
      translated: "στο Αμβούργο",
      tone: 'semantic',
    },
    {
      german: "über politische Themen",
      translated: "για πολιτικά θέματα",
      tone: 'semantic',
    },
  ],
  "lid:state:HH:6|en": [
    {
      german: "Wo",
      translated: "Where",
      tone: 'semantic',
    },
    {
      german: "können Sie sich",
      translated: "can you",
      tone: 'semantic',
    },
    {
      german: "in Hamburg",
      translated: "in Hamburg",
      tone: 'semantic',
    },
    {
      german: "über politische Themen",
      translated: "about political topics",
      tone: 'semantic',
    },
    {
      german: "informieren?",
      translated: "get information",
      tone: 'semantic',
    },
  ],
  "lid:state:HH:6|es": [
    {
      german: "Wo",
      translated: "¿Dónde",
      tone: 'semantic',
    },
    {
      german: "können Sie sich",
      translated: "puede informarse",
      tone: 'semantic',
    },
    {
      german: "in Hamburg",
      translated: "en Hamburgo",
      tone: 'semantic',
    },
    {
      german: "über politische Themen",
      translated: "sobre temas políticos",
      tone: 'semantic',
    },
  ],
  "lid:state:HH:6|fa": [
    {
      german: "Wo",
      translated: "کجا",
      tone: 'semantic',
    },
    {
      german: "können Sie sich",
      translated: "می‌توانید",
      tone: 'semantic',
    },
    {
      german: "in Hamburg",
      translated: "در هامبورگ",
      tone: 'semantic',
    },
    {
      german: "über politische Themen",
      translated: " دربارهٔ موضوعات سیاسی",
      tone: 'semantic',
    },
    {
      german: "informieren?",
      translated: "اطلاعات کسب کنید؟",
      tone: 'semantic',
    },
  ],
  "lid:state:HH:6|fr": [
    {
      german: "Wo",
      translated: "Où",
      tone: 'semantic',
    },
    {
      german: "können Sie sich",
      translated: "pouvez-vous vous",
      tone: 'semantic',
    },
    {
      german: "in Hamburg",
      translated: "à Hambourg",
      tone: 'semantic',
    },
    {
      german: "über politische Themen",
      translated: "sur les questions politiques",
      tone: 'semantic',
    },
    {
      german: "informieren?",
      translated: "informer",
      tone: 'semantic',
    },
  ],
  "lid:state:HH:6|hr": [
    {
      german: "Wo",
      translated: "Gdje",
      tone: 'semantic',
    },
    {
      german: "können Sie sich",
      translated: "mogu",
      tone: 'semantic',
    },
    {
      german: "in Hamburg",
      translated: "u Hamburgu",
      tone: 'semantic',
    },
    {
      german: "über politische Themen",
      translated: "o političkim temama",
      tone: 'semantic',
    },
    {
      german: "informieren?",
      translated: "dobiti informacije",
      tone: 'semantic',
    },
  ],
  "lid:state:HH:6|it": [
    {
      german: "Wo",
      translated: "Dove",
      tone: 'semantic',
    },
    {
      german: "können Sie sich",
      translated: "ci si può",
      tone: 'semantic',
    },
    {
      german: "in Hamburg",
      translated: "a Amburgo",
      tone: 'semantic',
    },
    {
      german: "über politische Themen",
      translated: "su temi politici",
      tone: 'semantic',
    },
    {
      german: "informieren?",
      translated: "informare",
      tone: 'semantic',
    },
  ],
  "lid:state:HH:6|kmr": [
    {
      german: "Wo",
      translated: "Li",
      tone: 'semantic',
    },
    {
      german: "in Hamburg",
      translated: "Hamburg",
      tone: 'semantic',
    },
    {
      german: "über politische Themen",
      translated: "siyasî",
      tone: 'semantic',
    },
    {
      german: "informieren?",
      translated: "agahdarî bistînî",
      tone: 'semantic',
    },
  ],
  "lid:state:HH:6|pl": [
    {
      german: "Wo",
      translated: "Gdzie",
      tone: 'semantic',
    },
    {
      german: "können Sie sich",
      translated: "można",
      tone: 'semantic',
    },
    {
      german: "in Hamburg",
      translated: "w Hamburg",
      tone: 'semantic',
    },
    {
      german: "über politische Themen",
      translated: "na tematy polityczne",
      tone: 'semantic',
    },
    {
      german: "informieren?",
      translated: "uzyskać informacje",
      tone: 'semantic',
    },
  ],
  "lid:state:HH:6|prs": [
    {
      german: "Wo",
      translated: "کجا",
      tone: 'semantic',
    },
    {
      german: "können Sie sich",
      translated: "می‌توانید",
      tone: 'semantic',
    },
    {
      german: "in Hamburg",
      translated: "در هامبورگ",
      tone: 'semantic',
    },
    {
      german: "über politische Themen",
      translated: " دربارهٔ موضوعات سیاسی",
      tone: 'semantic',
    },
    {
      german: "informieren?",
      translated: "اطلاعات کسب کنید؟",
      tone: 'semantic',
    },
  ],
  "lid:state:HH:6|ro": [
    {
      german: "Wo",
      translated: "Unde",
      tone: 'semantic',
    },
    {
      german: "können Sie sich",
      translated: "vă puteți",
      tone: 'semantic',
    },
    {
      german: "in Hamburg",
      translated: "în Hamburg",
      tone: 'semantic',
    },
    {
      german: "über politische Themen",
      translated: "despre teme politice",
      tone: 'semantic',
    },
    {
      german: "informieren?",
      translated: "informa",
      tone: 'semantic',
    },
  ],
  "lid:state:HH:6|ru": [
    {
      german: "Wo",
      translated: "Где",
      tone: 'semantic',
    },
    {
      german: "können Sie sich",
      translated: "можно",
      tone: 'semantic',
    },
    {
      german: "in Hamburg",
      translated: "в Гамбурге",
      tone: 'semantic',
    },
    {
      german: "über politische Themen",
      translated: "о политических темах",
      tone: 'semantic',
    },
    {
      german: "informieren?",
      translated: "получить информацию",
      tone: 'semantic',
    },
  ],
  "lid:state:HH:6|sq": [
    {
      german: "Wo",
      translated: "Ku",
      tone: 'semantic',
    },
    {
      german: "können Sie sich",
      translated: "mund të informoheni",
      tone: 'semantic',
    },
    {
      german: "in Hamburg",
      translated: "në Hamburgu",
      tone: 'semantic',
    },
    {
      german: "über politische Themen",
      translated: "për tema politike",
      tone: 'semantic',
    },
  ],
  "lid:state:HH:6|sr": [
    {
      german: "Wo",
      translated: "Gdje",
      tone: 'semantic',
    },
    {
      german: "können Sie sich",
      translated: "mogu",
      tone: 'semantic',
    },
    {
      german: "in Hamburg",
      translated: "u Hamburgu",
      tone: 'semantic',
    },
    {
      german: "über politische Themen",
      translated: "o političkim temama",
      tone: 'semantic',
    },
    {
      german: "informieren?",
      translated: "dobiti informacije",
      tone: 'semantic',
    },
  ],
  "lid:state:HH:6|tr": [
    {
      german: "Wo",
      translated: "nereden",
      tone: 'semantic',
    },
    {
      german: "können Sie sich",
      translated: "bilgi alabilirsiniz",
      tone: 'semantic',
    },
    {
      german: "in Hamburg",
      translated: "Hamburg eyaletinde",
      tone: 'semantic',
    },
    {
      german: "über politische Themen",
      translated: "siyasi konular hakkında",
      tone: 'semantic',
    },
  ],
  "lid:state:HH:6|uk": [
    {
      german: "Wo",
      translated: "Де",
      tone: 'semantic',
    },
    {
      german: "können Sie sich",
      translated: "можна",
      tone: 'semantic',
    },
    {
      german: "in Hamburg",
      translated: "в Гамбурзі",
      tone: 'semantic',
    },
    {
      german: "über politische Themen",
      translated: "про політичні питання",
      tone: 'semantic',
    },
    {
      german: "informieren?",
      translated: "отримати інформацію",
      tone: 'semantic',
    },
  ],
  "lid:state:HH:6|vi": [
    {
      german: "Wo",
      translated: "ở đâu",
      tone: 'semantic',
    },
    {
      german: "können Sie sich",
      translated: "có thể tìm",
      tone: 'semantic',
    },
    {
      german: "in Hamburg",
      translated: "Hamburg,",
      tone: 'semantic',
    },
    {
      german: "über politische Themen",
      translated: "về các chủ đề chính trị",
      tone: 'semantic',
    },
    {
      german: "informieren?",
      translated: "thông tin",
      tone: 'semantic',
    },
  ],
  "lid:state:HH:7|ar": [
    {
      german: "Welches Bundesland",
      translated: "أي ولاية",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "من",
      tone: 'semantic',
    },
    {
      german: "ein Stadtstaat",
      translated: "مدينة-ولاية",
      tone: 'semantic',
    },
  ],
  "lid:state:HH:7|bg": [
    {
      german: "Welches Bundesland",
      translated: "Коя от следните федерални провинции",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "е",
      tone: 'semantic',
    },
    {
      german: "ein Stadtstaat",
      translated: "град-държава",
      tone: 'semantic',
    },
  ],
  "lid:state:HH:7|bs": [
    {
      german: "Welches Bundesland",
      translated: "Koja je od navedenih saveznih zemalja",
      tone: 'semantic',
    },
    {
      german: "ein Stadtstaat",
      translated: "grad-država",
      tone: 'semantic',
    },
  ],
  "lid:state:HH:7|el": [
    {
      german: "Welches Bundesland",
      translated: "Ποιο από τα παρακάτω ομόσπονδα κρατίδια",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "είναι",
      tone: 'semantic',
    },
    {
      german: "ein Stadtstaat",
      translated: "πόλη-κράτος",
      tone: 'semantic',
    },
  ],
  "lid:state:HH:7|en": [
    {
      german: "Welches Bundesland",
      translated: "Which federal state",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "is",
      tone: 'semantic',
    },
    {
      german: "ein Stadtstaat",
      translated: "a city-state",
      tone: 'semantic',
    },
  ],
  "lid:state:HH:7|es": [
    {
      german: "Welches Bundesland",
      translated: "¿Cuál de los siguientes estados federados",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "es",
      tone: 'semantic',
    },
    {
      german: "ein Stadtstaat",
      translated: "una ciudad-estado",
      tone: 'semantic',
    },
  ],
  "lid:state:HH:7|fa": [
    {
      german: "Welches Bundesland",
      translated: "کدام‌یک از موارد زیر",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "است",
      tone: 'semantic',
    },
    {
      german: "ein Stadtstaat",
      translated: "شهر-ایالت آلمان",
      tone: 'semantic',
    },
  ],
  "lid:state:HH:7|fr": [
    {
      german: "Welches Bundesland",
      translated: "Quel Land",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "est",
      tone: 'semantic',
    },
    {
      german: "ein Stadtstaat",
      translated: "une ville-État",
      tone: 'semantic',
    },
  ],
  "lid:state:HH:7|hr": [
    {
      german: "Welches Bundesland",
      translated: "Koja je od navedenih saveznih zemalja",
      tone: 'semantic',
    },
    {
      german: "ein Stadtstaat",
      translated: "grad-država",
      tone: 'semantic',
    },
  ],
  "lid:state:HH:7|it": [
    {
      german: "Welches Bundesland",
      translated: "Quale dei seguenti Länder",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "è",
      tone: 'semantic',
    },
    {
      german: "ein Stadtstaat",
      translated: "una città-Stato",
      tone: 'semantic',
    },
  ],
  "lid:state:HH:7|kmr": [
    {
      german: "Welches Bundesland",
      translated: "Kîjan eyalet",
      tone: 'semantic',
    },
    {
      german: "ein Stadtstaat",
      translated: "bajar-dewlet e?",
      tone: 'semantic',
    },
  ],
  "lid:state:HH:7|pl": [
    {
      german: "Welches Bundesland",
      translated: "Który z poniższych krajów związkowych",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "jest",
      tone: 'semantic',
    },
    {
      german: "ein Stadtstaat",
      translated: "miastem-państwem",
      tone: 'semantic',
    },
  ],
  "lid:state:HH:7|prs": [
    {
      german: "Welches Bundesland",
      translated: "کدام‌یک از موارد زیر",
      tone: 'semantic',
    },
    {
      german: "ein Stadtstaat",
      translated: "یک شهر-ایالت آلمان",
      tone: 'semantic',
    },
  ],
  "lid:state:HH:7|ro": [
    {
      german: "Welches Bundesland",
      translated: "Care dintre următoarele landuri",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "este",
      tone: 'semantic',
    },
    {
      german: "ein Stadtstaat",
      translated: "un oraș-stat",
      tone: 'semantic',
    },
  ],
  "lid:state:HH:7|ru": [
    {
      german: "Welches Bundesland",
      translated: "Какая из этих федеральных земель",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "является",
      tone: 'semantic',
    },
    {
      german: "ein Stadtstaat",
      translated: "городом-землёй",
      tone: 'semantic',
    },
  ],
  "lid:state:HH:7|sq": [
    {
      german: "Welches Bundesland",
      translated: "Cili nga",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "është",
      tone: 'semantic',
    },
    {
      german: "ein Stadtstaat",
      translated: "qytet-shtet",
      tone: 'semantic',
    },
  ],
  "lid:state:HH:7|sr": [
    {
      german: "Welches Bundesland",
      translated: "Koja je od navedenih saveznih",
      tone: 'semantic',
    },
    {
      german: "ein Stadtstaat",
      translated: "grad-država",
      tone: 'semantic',
    },
  ],
  "lid:state:HH:7|tr": [
    {
      german: "Welches Bundesland",
      translated: "Aşağıdaki eyaletlerden hangisi",
      tone: 'semantic',
    },
    {
      german: "ein Stadtstaat",
      translated: "şehir devletidir",
      tone: 'semantic',
    },
  ],
  "lid:state:HH:7|uk": [
    {
      german: "Welches Bundesland",
      translated: "Яка федеральна земля",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "є",
      tone: 'semantic',
    },
    {
      german: "ein Stadtstaat",
      translated: "містом-землею",
      tone: 'semantic',
    },
  ],
  "lid:state:HH:7|vi": [
    {
      german: "Welches Bundesland",
      translated: "Bang nào",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "là",
      tone: 'semantic',
    },
    {
      german: "ein Stadtstaat",
      translated: "thành phố-bang",
      tone: 'semantic',
    },
  ],
  "lid:state:HH:8|ar": [
    {
      german: "Welches",
      translated: "أي صورة",
      tone: 'semantic',
    },
    {
      german: "Bundesland",
      translated: "ولاية",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "تمثل موقع",
      tone: 'semantic',
    },
    {
      german: "Hamburg",
      translated: "Hamburg",
      tone: 'semantic',
    },
  ],
  "lid:state:HH:8|bg": [
    {
      german: "Welches",
      translated: "Коя",
      tone: 'semantic',
    },
    {
      german: "Bundesland",
      translated: "от показаните федерални провинции",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "е",
      tone: 'semantic',
    },
    {
      german: "Hamburg",
      translated: "Хамбург",
      tone: 'semantic',
    },
  ],
  "lid:state:HH:8|bs": [
    {
      german: "Welches",
      translated: "Koja",
      tone: 'semantic',
    },
    {
      german: "Bundesland",
      translated: "prikazanih saveznih zemalja",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "je",
      tone: 'semantic',
    },
    {
      german: "Hamburg",
      translated: "Hamburg",
      tone: 'semantic',
    },
  ],
  "lid:state:HH:8|el": [
    {
      german: "Welches",
      translated: "Ποιο",
      tone: 'semantic',
    },
    {
      german: "Bundesland",
      translated: "κρατίδια",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "είναι",
      tone: 'semantic',
    },
    {
      german: "Hamburg",
      translated: "Αμβούργο",
      tone: 'semantic',
    },
  ],
  "lid:state:HH:8|en": [
    {
      german: "Welches",
      translated: "Which",
      tone: 'semantic',
    },
    {
      german: "Bundesland",
      translated: "federal state",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "is",
      tone: 'semantic',
    },
    {
      german: "Hamburg",
      translated: "Hamburg",
      tone: 'semantic',
    },
  ],
  "lid:state:HH:8|es": [
    {
      german: "Welches",
      translated: "¿Cuál",
      tone: 'semantic',
    },
    {
      german: "Bundesland",
      translated: "estado federado",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "corresponde",
      tone: 'semantic',
    },
    {
      german: "Hamburg",
      translated: "Hamburgo",
      tone: 'semantic',
    },
  ],
  "lid:state:HH:8|fa": [
    {
      german: "Welches",
      translated: "کدام",
      tone: 'semantic',
    },
    {
      german: "Bundesland",
      translated: "ایالتِ نشان‌داده‌شده",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "است",
      tone: 'semantic',
    },
    {
      german: "Hamburg",
      translated: "هامبورگ",
      tone: 'semantic',
    },
  ],
  "lid:state:HH:8|fr": [
    {
      german: "Welches",
      translated: "Quel",
      tone: 'semantic',
    },
    {
      german: "Bundesland",
      translated: "Land",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "représenté",
      tone: 'semantic',
    },
    {
      german: "Hamburg",
      translated: "Hambourg",
      tone: 'semantic',
    },
  ],
  "lid:state:HH:8|hr": [
    {
      german: "Welches",
      translated: "Koja",
      tone: 'semantic',
    },
    {
      german: "Bundesland",
      translated: "prikazanih saveznih zemalja",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "je",
      tone: 'semantic',
    },
    {
      german: "Hamburg",
      translated: "Hamburg",
      tone: 'semantic',
    },
  ],
  "lid:state:HH:8|it": [
    {
      german: "Welches",
      translated: "Quale",
      tone: 'semantic',
    },
    {
      german: "Bundesland",
      translated: "Land",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "è",
      tone: 'semantic',
    },
    {
      german: "Hamburg",
      translated: "Amburgo",
      tone: 'semantic',
    },
  ],
  "lid:state:HH:8|kmr": [
    {
      german: "Welches",
      translated: "Kîjan",
      tone: 'semantic',
    },
    {
      german: "Bundesland",
      translated: "eyalet",
      tone: 'semantic',
    },
    {
      german: "Hamburg",
      translated: "Hamburg",
      tone: 'semantic',
    },
  ],
  "lid:state:HH:8|pl": [
    {
      german: "Welches",
      translated: "Który",
      tone: 'semantic',
    },
    {
      german: "Bundesland",
      translated: "przedstawionych krajów związkowych",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "to",
      tone: 'semantic',
    },
    {
      german: "Hamburg",
      translated: "Hamburg",
      tone: 'semantic',
    },
  ],
  "lid:state:HH:8|prs": [
    {
      german: "Welches",
      translated: "کدام",
      tone: 'semantic',
    },
    {
      german: "Bundesland",
      translated: "ایالتِ نشان‌داده‌شده",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "است",
      tone: 'semantic',
    },
    {
      german: "Hamburg",
      translated: "هامبورگ",
      tone: 'semantic',
    },
  ],
  "lid:state:HH:8|ro": [
    {
      german: "Welches",
      translated: "Care",
      tone: 'semantic',
    },
    {
      german: "Bundesland",
      translated: "land",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "este",
      tone: 'semantic',
    },
    {
      german: "Hamburg",
      translated: "Hamburg",
      tone: 'semantic',
    },
  ],
  "lid:state:HH:8|ru": [
    {
      german: "Welches",
      translated: "Какая",
      tone: 'semantic',
    },
    {
      german: "Bundesland",
      translated: "земель",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: " — ",
      tone: 'semantic',
    },
    {
      german: "Hamburg",
      translated: "Гамбург",
      tone: 'semantic',
    },
  ],
  "lid:state:HH:8|sq": [
    {
      german: "Welches",
      translated: "Cili",
      tone: 'semantic',
    },
    {
      german: "Bundesland",
      translated: "landet e paraqitura",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "është",
      tone: 'semantic',
    },
    {
      german: "Hamburg",
      translated: "Hamburgu",
      tone: 'semantic',
    },
  ],
  "lid:state:HH:8|sr": [
    {
      german: "Welches",
      translated: "Koja",
      tone: 'semantic',
    },
    {
      german: "Bundesland",
      translated: "prikazanih saveznih",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "je",
      tone: 'semantic',
    },
    {
      german: "Hamburg",
      translated: "Hamburg",
      tone: 'semantic',
    },
  ],
  "lid:state:HH:8|tr": [
    {
      german: "Welches",
      translated: "hangi numarayla",
      tone: 'semantic',
    },
    {
      german: "Bundesland",
      translated: "eyaleti",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "gösterilmiştir",
      tone: 'semantic',
    },
    {
      german: "Hamburg",
      translated: "Hamburg",
      tone: 'semantic',
    },
  ],
  "lid:state:HH:8|uk": [
    {
      german: "Welches",
      translated: "з",
      tone: 'semantic',
    },
    {
      german: "Bundesland",
      translated: "федеральних земель",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "є",
      tone: 'semantic',
    },
    {
      german: "Hamburg",
      translated: "Гамбург",
      tone: 'semantic',
    },
  ],
  "lid:state:HH:8|vi": [
    {
      german: "Welches",
      translated: "Bang nào",
      tone: 'semantic',
    },
    {
      german: "Bundesland",
      translated: "trong các hình",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "được",
      tone: 'semantic',
    },
    {
      german: "Hamburg",
      translated: "Hamburg",
      tone: 'semantic',
    },
  ],
  "lid:state:HH:9|ar": [
    {
      german: "Wie nennt man",
      translated: "ماذا",
      tone: 'semantic',
    },
    {
      german: "die Regierungschefin/den Regierungschef",
      translated: "رئيس/رئيسة",
      tone: 'semantic',
    },
    {
      german: "des Stadtstaates",
      translated: "مدينة-ولاية",
      tone: 'semantic',
    },
    {
      german: "Hamburg",
      translated: "Hamburg",
      tone: 'semantic',
    },
  ],
  "lid:state:HH:9|bg": [
    {
      german: "Wie nennt man",
      translated: "Как се нарича",
      tone: 'semantic',
    },
    {
      german: "die Regierungschefin/den Regierungschef",
      translated: "ръководителят",
      tone: 'semantic',
    },
    {
      german: "des Stadtstaates",
      translated: "на правителството на град-държавата",
      tone: 'semantic',
    },
    {
      german: "Hamburg",
      translated: "Хамбург",
      tone: 'semantic',
    },
  ],
  "lid:state:HH:9|bs": [
    {
      german: "Wie nennt man",
      translated: "Kako se zove",
      tone: 'semantic',
    },
    {
      german: "die Regierungschefin/den Regierungschef",
      translated: "šef vlade",
      tone: 'semantic',
    },
    {
      german: "des Stadtstaates",
      translated: "grada-države",
      tone: 'semantic',
    },
    {
      german: "Hamburg",
      translated: "Hamburg",
      tone: 'semantic',
    },
  ],
  "lid:state:HH:9|el": [
    {
      german: "Wie nennt man",
      translated: "Πώς ονομάζεται",
      tone: 'semantic',
    },
    {
      german: "die Regierungschefin/den Regierungschef",
      translated: "ο επικεφαλής της κυβέρνησης",
      tone: 'semantic',
    },
    {
      german: "des Stadtstaates",
      translated: "της πόλης-κράτους",
      tone: 'semantic',
    },
    {
      german: "Hamburg",
      translated: "Αμβούργο",
      tone: 'semantic',
    },
  ],
  "lid:state:HH:9|en": [
    {
      german: "Wie nennt man",
      translated: "What is",
      tone: 'semantic',
    },
    {
      german: "die Regierungschefin/den Regierungschef",
      translated: "the head of government",
      tone: 'semantic',
    },
    {
      german: "des Stadtstaates",
      translated: "in the city-state",
      tone: 'semantic',
    },
    {
      german: "Hamburg",
      translated: "of Hamburg",
      tone: 'semantic',
    },
  ],
  "lid:state:HH:9|es": [
    {
      german: "Wie nennt man",
      translated: "¿Cómo se llama al",
      tone: 'semantic',
    },
    {
      german: "die Regierungschefin/den Regierungschef",
      translated: "jefe o la jefa de gobierno",
      tone: 'semantic',
    },
    {
      german: "des Stadtstaates",
      translated: "de la ciudad-estado",
      tone: 'semantic',
    },
    {
      german: "Hamburg",
      translated: "de Hamburgo",
      tone: 'semantic',
    },
  ],
  "lid:state:HH:9|fa": [
    {
      german: "Wie nennt man",
      translated: "چه عنوانی دارد",
      tone: 'semantic',
    },
    {
      german: "die Regierungschefin/den Regierungschef",
      translated: "رئیس دولت",
      tone: 'semantic',
    },
    {
      german: "des Stadtstaates",
      translated: "شهر-ایالت",
      tone: 'semantic',
    },
    {
      german: "Hamburg",
      translated: "هامبورگ",
      tone: 'semantic',
    },
  ],
  "lid:state:HH:9|fr": [
    {
      german: "Wie nennt man",
      translated: "Comment appelle-t-on le",
      tone: 'semantic',
    },
    {
      german: "die Regierungschefin/den Regierungschef",
      translated: "chef ou la cheffe du gouvernement",
      tone: 'semantic',
    },
    {
      german: "des Stadtstaates",
      translated: "de la ville-État",
      tone: 'semantic',
    },
    {
      german: "Hamburg",
      translated: "de Hambourg",
      tone: 'semantic',
    },
  ],
  "lid:state:HH:9|hr": [
    {
      german: "Wie nennt man",
      translated: "Kako se",
      tone: 'semantic',
    },
    {
      german: "die Regierungschefin/den Regierungschef",
      translated: "čelnik",
      tone: 'semantic',
    },
    {
      german: "des Stadtstaates",
      translated: "vlade grada-države",
      tone: 'semantic',
    },
    {
      german: "Hamburg",
      translated: "Hamburg",
      tone: 'semantic',
    },
  ],
  "lid:state:HH:9|it": [
    {
      german: "Wie nennt man",
      translated: "Come si chiama",
      tone: 'semantic',
    },
    {
      german: "die Regierungschefin/den Regierungschef",
      translated: "il capo del governo",
      tone: 'semantic',
    },
    {
      german: "des Stadtstaates",
      translated: "della città-Stato",
      tone: 'semantic',
    },
    {
      german: "Hamburg",
      translated: "di Amburgo",
      tone: 'semantic',
    },
  ],
  "lid:state:HH:9|kmr": [
    {
      german: "Wie nennt man",
      translated: "Serokê",
      tone: 'semantic',
    },
    {
      german: "die Regierungschefin/den Regierungschef",
      translated: "hukûmeta",
      tone: 'semantic',
    },
    {
      german: "des Stadtstaates",
      translated: "bajar-dewleta",
      tone: 'semantic',
    },
    {
      german: "Hamburg",
      translated: "Hamburg",
      tone: 'semantic',
    },
  ],
  "lid:state:HH:9|pl": [
    {
      german: "Wie nennt man",
      translated: "Jak nazywa się",
      tone: 'semantic',
    },
    {
      german: "die Regierungschefin/den Regierungschef",
      translated: "szef rządu",
      tone: 'semantic',
    },
    {
      german: "des Stadtstaates",
      translated: "miasta-państwa",
      tone: 'semantic',
    },
    {
      german: "Hamburg",
      translated: "Hamburg",
      tone: 'semantic',
    },
  ],
  "lid:state:HH:9|prs": [
    {
      german: "Wie nennt man",
      translated: "چه عنوانی دارد",
      tone: 'semantic',
    },
    {
      german: "die Regierungschefin/den Regierungschef",
      translated: "رئیس دولت",
      tone: 'semantic',
    },
    {
      german: "Hamburg",
      translated: "هامبورگ",
      tone: 'semantic',
    },
  ],
  "lid:state:HH:9|ro": [
    {
      german: "Wie nennt man",
      translated: "Cum se numește",
      tone: 'semantic',
    },
    {
      german: "die Regierungschefin/den Regierungschef",
      translated: "șeful guvernului",
      tone: 'semantic',
    },
    {
      german: "des Stadtstaates",
      translated: "orașului-stat",
      tone: 'semantic',
    },
    {
      german: "Hamburg",
      translated: "Hamburg",
      tone: 'semantic',
    },
  ],
  "lid:state:HH:9|ru": [
    {
      german: "Wie nennt man",
      translated: "Как называют",
      tone: 'semantic',
    },
    {
      german: "die Regierungschefin/den Regierungschef",
      translated: "главу правительства",
      tone: 'semantic',
    },
    {
      german: "des Stadtstaates",
      translated: "города-земли",
      tone: 'semantic',
    },
    {
      german: "Hamburg",
      translated: "Гамбург?",
      tone: 'semantic',
    },
  ],
  "lid:state:HH:9|sq": [
    {
      german: "Wie nennt man",
      translated: "Si quhet",
      tone: 'semantic',
    },
    {
      german: "die Regierungschefin/den Regierungschef",
      translated: "kreu i qeverisë",
      tone: 'semantic',
    },
    {
      german: "des Stadtstaates",
      translated: "së qytet-shtetit",
      tone: 'semantic',
    },
    {
      german: "Hamburg",
      translated: "Hamburgu",
      tone: 'semantic',
    },
  ],
  "lid:state:HH:9|sr": [
    {
      german: "Wie nennt man",
      translated: "Kako se zove",
      tone: 'semantic',
    },
    {
      german: "die Regierungschefin/den Regierungschef",
      translated: "šef vlade",
      tone: 'semantic',
    },
    {
      german: "des Stadtstaates",
      translated: "grada-države",
      tone: 'semantic',
    },
    {
      german: "Hamburg",
      translated: "Hamburg",
      tone: 'semantic',
    },
  ],
  "lid:state:HH:9|tr": [
    {
      german: "Wie nennt man",
      translated: "ne ad verilir",
      tone: 'semantic',
    },
    {
      german: "die Regierungschefin/den Regierungschef",
      translated: "başındaki kişiye",
      tone: 'semantic',
    },
    {
      german: "des Stadtstaates",
      translated: "hükümetinin",
      tone: 'semantic',
    },
    {
      german: "Hamburg",
      translated: "Hamburg",
      tone: 'semantic',
    },
  ],
  "lid:state:HH:9|uk": [
    {
      german: "Wie nennt man",
      translated: "Як називають",
      tone: 'semantic',
    },
    {
      german: "die Regierungschefin/den Regierungschef",
      translated: "главу уряду",
      tone: 'semantic',
    },
    {
      german: "des Stadtstaates",
      translated: "міста-землі",
      tone: 'semantic',
    },
    {
      german: "Hamburg",
      translated: "Гамбург",
      tone: 'semantic',
    },
  ],
  "lid:state:HH:9|vi": [
    {
      german: "Wie nennt man",
      translated: "được gọi là gì",
      tone: 'semantic',
    },
    {
      german: "die Regierungschefin/den Regierungschef",
      translated: "Người đứng đầu chính phủ",
      tone: 'semantic',
    },
    {
      german: "des Stadtstaates",
      translated: "của thành phố-bang",
      tone: 'semantic',
    },
    {
      german: "Hamburg",
      translated: "Hamburg",
      tone: 'semantic',
    },
  ],
  "lid:state:MV:10|ar": [
    {
      german: "Welche Ministerin/welchen Minister",
      translated: "أي وزارة من الوزارات التالية",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "على مستوى ولاية",
      tone: 'semantic',
    },
    {
      german: "Mecklenburg-Vorpommern",
      translated: "Mecklenburg-Vorpommern",
      tone: 'semantic',
    },
    {
      german: "nicht?",
      translated: "غير موجودة",
      tone: 'semantic',
    },
  ],
  "lid:state:MV:10|bg": [
    {
      german: "Welche Ministerin/welchen Minister",
      translated: "Кой министър",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "не съществува на",
      tone: 'semantic',
    },
    {
      german: "Mecklenburg-Vorpommern",
      translated: "Мекленбург-Предна Померания",
      tone: 'semantic',
    },
    {
      german: "nicht?",
      translated: "?",
      tone: 'semantic',
    },
  ],
  "lid:state:MV:10|bs": [
    {
      german: "Welche Ministerin/welchen Minister",
      translated: "Koji ministar",
      tone: 'semantic',
    },
    {
      german: "Mecklenburg-Vorpommern",
      translated: "na razini savezne zemlje Mecklenburg-Zapadno Pomorje",
      tone: 'semantic',
    },
    {
      german: "nicht?",
      translated: "ne postoji",
      tone: 'semantic',
    },
  ],
  "lid:state:MV:10|el": [
    {
      german: "Welche Ministerin/welchen Minister",
      translated: "Ποιος υπουργός",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "υπάρχει",
      tone: 'semantic',
    },
    {
      german: "Mecklenburg-Vorpommern",
      translated: "Μεκλεμβούργο-Δυτική Πομερανία",
      tone: 'semantic',
    },
    {
      german: "nicht?",
      translated: "δεν",
      tone: 'semantic',
    },
  ],
  "lid:state:MV:10|en": [
    {
      german: "Welche Ministerin/welchen Minister",
      translated: "Which minister",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "does",
      tone: 'semantic',
    },
    {
      german: "Mecklenburg-Vorpommern",
      translated: "Mecklenburg-Vorpommern",
      tone: 'semantic',
    },
    {
      german: "nicht?",
      translated: "not have?",
      tone: 'semantic',
    },
  ],
  "lid:state:MV:10|es": [
    {
      german: "Welche Ministerin/welchen Minister",
      translated: "¿Qué ministerio",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "existe",
      tone: 'semantic',
    },
    {
      german: "Mecklenburg-Vorpommern",
      translated: "a nivel regional en Mecklemburgo-Pomerania Occidental",
      tone: 'semantic',
    },
    {
      german: "nicht?",
      translated: "NO",
      tone: 'semantic',
    },
  ],
  "lid:state:MV:10|fa": [
    {
      german: "Welche Ministerin/welchen Minister",
      translated: "کدام وزیر",
      tone: 'semantic',
    },
    {
      german: "Mecklenburg-Vorpommern",
      translated: "مکلنبورگ-فورپومرن",
      tone: 'semantic',
    },
    {
      german: "nicht?",
      translated: "وجود ندارد؟",
      tone: 'semantic',
    },
  ],
  "lid:state:MV:10|fr": [
    {
      german: "Welche Ministerin/welchen Minister",
      translated: "Quel ministre ou quelle ministre",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "n’existe",
      tone: 'semantic',
    },
    {
      german: "Mecklenburg-Vorpommern",
      translated: "au niveau du Land de Mecklembourg-Poméranie-Occidentale",
      tone: 'semantic',
    },
    {
      german: "nicht?",
      translated: "pas",
      tone: 'semantic',
    },
  ],
  "lid:state:MV:10|hr": [
    {
      german: "Welche Ministerin/welchen Minister",
      translated: "Koji ministar",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "ne postoji",
      tone: 'semantic',
    },
    {
      german: "Mecklenburg-Vorpommern",
      translated: "Mecklenburg-Zapadno Pomorje",
      tone: 'semantic',
    },
  ],
  "lid:state:MV:10|it": [
    {
      german: "Welche Ministerin/welchen Minister",
      translated: "Quale ministro",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "esiste",
      tone: 'semantic',
    },
    {
      german: "Mecklenburg-Vorpommern",
      translated: "a livello del Land di Meclemburgo-Pomerania Anteriore",
      tone: 'semantic',
    },
    {
      german: "nicht?",
      translated: "non",
      tone: 'semantic',
    },
  ],
  "lid:state:MV:10|kmr": [
    {
      german: "Welche Ministerin/welchen Minister",
      translated: "Kîjan wezîr li",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "tune",
      tone: 'semantic',
    },
    {
      german: "Mecklenburg-Vorpommern",
      translated: "Mecklenburg-Vorpommern",
      tone: 'semantic',
    },
    {
      german: "nicht?",
      translated: "ye?",
      tone: 'semantic',
    },
  ],
  "lid:state:MV:10|pl": [
    {
      german: "Welche Ministerin/welchen Minister",
      translated: "Którego ministra",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "ma",
      tone: 'semantic',
    },
    {
      german: "Mecklenburg-Vorpommern",
      translated: "Meklemburgia-Pomorze Przednie",
      tone: 'semantic',
    },
    {
      german: "nicht?",
      translated: "nie",
      tone: 'semantic',
    },
  ],
  "lid:state:MV:10|prs": [
    {
      german: "Welche Ministerin/welchen Minister",
      translated: "کدام وزیر در سطح ایالت",
      tone: 'semantic',
    },
    {
      german: "Mecklenburg-Vorpommern",
      translated: "مکلنبورگ-فورپومرن",
      tone: 'semantic',
    },
  ],
  "lid:state:MV:10|ro": [
    {
      german: "Welche Ministerin/welchen Minister",
      translated: "Care ministru",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "nu există",
      tone: 'semantic',
    },
    {
      german: "Mecklenburg-Vorpommern",
      translated: "la nivelul landului Mecklenburg-Pomerania Inferioară",
      tone: 'semantic',
    },
  ],
  "lid:state:MV:10|ru": [
    {
      german: "Welche Ministerin/welchen Minister",
      translated: "Какого министра",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "нет",
      tone: 'semantic',
    },
    {
      german: "Mecklenburg-Vorpommern",
      translated: "в федеральной земле Мекленбург-Передняя Померания",
      tone: 'semantic',
    },
  ],
  "lid:state:MV:10|sq": [
    {
      german: "Welche Ministerin/welchen Minister",
      translated: "Cili ministër",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "ekziston",
      tone: 'semantic',
    },
    {
      german: "Mecklenburg-Vorpommern",
      translated: "nivelin e landit Mecklenburg-Vorpommern",
      tone: 'semantic',
    },
  ],
  "lid:state:MV:10|sr": [
    {
      german: "Welche Ministerin/welchen Minister",
      translated: "Koji ministar",
      tone: 'semantic',
    },
    {
      german: "Mecklenburg-Vorpommern",
      translated: "Meklenburg-Zapadna Pomeranija",
      tone: 'semantic',
    },
    {
      german: "nicht?",
      translated: "ne postoji",
      tone: 'semantic',
    },
  ],
  "lid:state:MV:10|tr": [
    {
      german: "Welche Ministerin/welchen Minister",
      translated: "aşağıdaki bakanlıklardan hangisi",
      tone: 'semantic',
    },
    {
      german: "Mecklenburg-Vorpommern",
      translated: "Mecklenburg-Vorpommern",
      tone: 'semantic',
    },
    {
      german: "nicht?",
      translated: "yoktur?",
      tone: 'semantic',
    },
  ],
  "lid:state:MV:10|uk": [
    {
      german: "Welche Ministerin/welchen Minister",
      translated: "Якого міністра/міністерки",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "немає",
      tone: 'semantic',
    },
    {
      german: "Mecklenburg-Vorpommern",
      translated: "Мекленбург-Передня Померанія",
      tone: 'semantic',
    },
    {
      german: "nicht?",
      translated: "?",
      tone: 'semantic',
    },
  ],
  "lid:state:MV:10|vi": [
    {
      german: "Welche Ministerin/welchen Minister",
      translated: "Bộ trưởng nào",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "tồn tại",
      tone: 'semantic',
    },
    {
      german: "Mecklenburg-Vorpommern",
      translated: "Mecklenburg-Vorpommern",
      tone: 'semantic',
    },
    {
      german: "nicht?",
      translated: "không",
      tone: 'semantic',
    },
  ],
  "lid:state:MV:1|ar": [
    {
      german: "Welches Wappen",
      translated: "أي شعار",
      tone: 'semantic',
    },
    {
      german: "gehört zum",
      translated: "من الصور",
      tone: 'semantic',
    },
    {
      german: "Bundesland",
      translated: "ولاية",
      tone: 'semantic',
    },
    {
      german: "Mecklenburg-Vorpommern",
      translated: "Mecklenburg-Vorpommern",
      tone: 'semantic',
    },
  ],
  "lid:state:MV:1|bg": [
    {
      german: "Welches Wappen",
      translated: "Кой герб",
      tone: 'semantic',
    },
    {
      german: "gehört zum",
      translated: "принадлежи на",
      tone: 'semantic',
    },
    {
      german: "Bundesland",
      translated: "федералната провинция",
      tone: 'semantic',
    },
    {
      german: "Mecklenburg-Vorpommern",
      translated: "Мекленбург-Предна Померания",
      tone: 'semantic',
    },
  ],
  "lid:state:MV:1|bs": [
    {
      german: "Welches Wappen",
      translated: "Koji grb",
      tone: 'semantic',
    },
    {
      german: "gehört zum",
      translated: "pripada",
      tone: 'semantic',
    },
    {
      german: "Bundesland",
      translated: "saveznoj zemlji",
      tone: 'semantic',
    },
    {
      german: "Mecklenburg-Vorpommern",
      translated: "Mecklenburg-Zapadno Pomorje",
      tone: 'semantic',
    },
  ],
  "lid:state:MV:1|el": [
    {
      german: "Welches Wappen",
      translated: "Ποιο έμβλημα",
      tone: 'semantic',
    },
    {
      german: "gehört zum",
      translated: "ανήκει στο",
      tone: 'semantic',
    },
    {
      german: "Bundesland",
      translated: "ομόσπονδο κρατίδιο",
      tone: 'semantic',
    },
    {
      german: "Mecklenburg-Vorpommern",
      translated: "Μεκλεμβούργο-Δυτική Πομερανία",
      tone: 'semantic',
    },
  ],
  "lid:state:MV:1|en": [
    {
      german: "Welches Wappen",
      translated: "Which coat of arms",
      tone: 'semantic',
    },
    {
      german: "gehört zum",
      translated: "belongs to",
      tone: 'semantic',
    },
    {
      german: "Bundesland",
      translated: "the federal state",
      tone: 'semantic',
    },
    {
      german: "Mecklenburg-Vorpommern",
      translated: "Mecklenburg-Vorpommern",
      tone: 'semantic',
    },
  ],
  "lid:state:MV:1|es": [
    {
      german: "Welches Wappen",
      translated: "¿Qué escudo",
      tone: 'semantic',
    },
    {
      german: "gehört zum",
      translated: "pertenece al",
      tone: 'semantic',
    },
    {
      german: "Bundesland",
      translated: "estado federado",
      tone: 'semantic',
    },
    {
      german: "Mecklenburg-Vorpommern",
      translated: "Mecklemburgo-Pomerania Occidental",
      tone: 'semantic',
    },
  ],
  "lid:state:MV:1|fa": [
    {
      german: "Welches Wappen",
      translated: "کدام نشان",
      tone: 'semantic',
    },
    {
      german: "gehört zum",
      translated: "متعلق به",
      tone: 'semantic',
    },
    {
      german: "Bundesland",
      translated: "ایالت",
      tone: 'semantic',
    },
    {
      german: "Mecklenburg-Vorpommern",
      translated: "مکلنبورگ-فورپومرن",
      tone: 'semantic',
    },
  ],
  "lid:state:MV:1|fr": [
    {
      german: "Welches Wappen",
      translated: "Quel blason",
      tone: 'semantic',
    },
    {
      german: "gehört zum",
      translated: "appartient au",
      tone: 'semantic',
    },
    {
      german: "Bundesland",
      translated: "Land de",
      tone: 'semantic',
    },
    {
      german: "Mecklenburg-Vorpommern",
      translated: "Mecklembourg-Poméranie-Occidentale",
      tone: 'semantic',
    },
  ],
  "lid:state:MV:1|hr": [
    {
      german: "Welches Wappen",
      translated: "Koji grb",
      tone: 'semantic',
    },
    {
      german: "gehört zum",
      translated: "pripada",
      tone: 'semantic',
    },
    {
      german: "Bundesland",
      translated: "saveznoj zemlji",
      tone: 'semantic',
    },
    {
      german: "Mecklenburg-Vorpommern",
      translated: "Mecklenburg-Zapadno Pomorje",
      tone: 'semantic',
    },
  ],
  "lid:state:MV:1|it": [
    {
      german: "Welches Wappen",
      translated: "Quale stemma",
      tone: 'semantic',
    },
    {
      german: "gehört zum",
      translated: "appartiene al",
      tone: 'semantic',
    },
    {
      german: "Bundesland",
      translated: "Land di",
      tone: 'semantic',
    },
    {
      german: "Mecklenburg-Vorpommern",
      translated: "Meclemburgo-Pomerania Anteriore",
      tone: 'semantic',
    },
  ],
  "lid:state:MV:1|kmr": [
    {
      german: "Welches Wappen",
      translated: "Kîjan nîşan",
      tone: 'semantic',
    },
    {
      german: "gehört zum",
      translated: "a",
      tone: 'semantic',
    },
    {
      german: "Bundesland",
      translated: "eyaleta",
      tone: 'semantic',
    },
    {
      german: "Mecklenburg-Vorpommern",
      translated: "Mecklenburg-Vorpommern",
      tone: 'semantic',
    },
  ],
  "lid:state:MV:1|pl": [
    {
      german: "Welches Wappen",
      translated: "Który herb",
      tone: 'semantic',
    },
    {
      german: "gehört zum",
      translated: "należy do",
      tone: 'semantic',
    },
    {
      german: "Bundesland",
      translated: "kraju związkowego",
      tone: 'semantic',
    },
    {
      german: "Mecklenburg-Vorpommern",
      translated: "Meklemburgia-Pomorze Przednie",
      tone: 'semantic',
    },
  ],
  "lid:state:MV:1|prs": [
    {
      german: "Welches Wappen",
      translated: "کدام نشان",
      tone: 'semantic',
    },
    {
      german: "gehört zum",
      translated: "متعلق به",
      tone: 'semantic',
    },
    {
      german: "Bundesland",
      translated: "ایالت",
      tone: 'semantic',
    },
    {
      german: "Mecklenburg-Vorpommern",
      translated: "مکلنبورگ-فورپومرن",
      tone: 'semantic',
    },
  ],
  "lid:state:MV:1|ro": [
    {
      german: "Welches Wappen",
      translated: "Care stemă",
      tone: 'semantic',
    },
    {
      german: "gehört zum",
      translated: "aparține",
      tone: 'semantic',
    },
    {
      german: "Bundesland",
      translated: "landului",
      tone: 'semantic',
    },
    {
      german: "Mecklenburg-Vorpommern",
      translated: "Mecklenburg-Pomerania Inferioară",
      tone: 'semantic',
    },
  ],
  "lid:state:MV:1|ru": [
    {
      german: "Welches Wappen",
      translated: "Какой герб",
      tone: 'semantic',
    },
    {
      german: "gehört zum",
      translated: "принадлежит федеральной земле",
      tone: 'semantic',
    },
    {
      german: "Mecklenburg-Vorpommern",
      translated: "Мекленбург-Передняя Померания",
      tone: 'semantic',
    },
  ],
  "lid:state:MV:1|sq": [
    {
      german: "Welches Wappen",
      translated: "Cila stemë",
      tone: 'semantic',
    },
    {
      german: "gehört zum",
      translated: "i përket",
      tone: 'semantic',
    },
    {
      german: "Bundesland",
      translated: "landit",
      tone: 'semantic',
    },
    {
      german: "Mecklenburg-Vorpommern",
      translated: "Mecklenburg-Vorpommern",
      tone: 'semantic',
    },
  ],
  "lid:state:MV:1|sr": [
    {
      german: "Welches Wappen",
      translated: "grb",
      tone: 'semantic',
    },
    {
      german: "gehört zum",
      translated: "pripada",
      tone: 'semantic',
    },
    {
      german: "Bundesland",
      translated: "saveznoj pokrajini",
      tone: 'semantic',
    },
    {
      german: "Mecklenburg-Vorpommern",
      translated: "Meklenburg-Zapadna Pomeranija",
      tone: 'semantic',
    },
  ],
  "lid:state:MV:1|tr": [
    {
      german: "Welches Wappen",
      translated: "arması hangisidir",
      tone: 'semantic',
    },
    {
      german: "Bundesland",
      translated: "eyaletinin",
      tone: 'semantic',
    },
    {
      german: "Mecklenburg-Vorpommern",
      translated: "Mecklenburg-Vorpommern",
      tone: 'semantic',
    },
  ],
  "lid:state:MV:1|uk": [
    {
      german: "Welches Wappen",
      translated: "Який герб",
      tone: 'semantic',
    },
    {
      german: "gehört zum",
      translated: "належить",
      tone: 'semantic',
    },
    {
      german: "Bundesland",
      translated: "федеральній землі",
      tone: 'semantic',
    },
    {
      german: "Mecklenburg-Vorpommern",
      translated: "Мекленбург-Передня Померанія",
      tone: 'semantic',
    },
  ],
  "lid:state:MV:1|vi": [
    {
      german: "Welches Wappen",
      translated: "Quốc huy nào",
      tone: 'semantic',
    },
    {
      german: "gehört zum",
      translated: "thuộc",
      tone: 'semantic',
    },
    {
      german: "Bundesland",
      translated: "bang",
      tone: 'semantic',
    },
    {
      german: "Mecklenburg-Vorpommern",
      translated: "Mecklenburg-Vorpommern",
      tone: 'semantic',
    },
  ],
  "lid:state:MV:2|ar": [
    {
      german: "Welches",
      translated: "أي",
      tone: 'semantic',
    },
    {
      german: "ein Landkreis",
      translated: "دائرة إدارية (Landkreis)",
      tone: 'semantic',
    },
    {
      german: "in Mecklenburg-Vorpommern",
      translated: "في Mecklenburg-Vorpommern",
      tone: 'semantic',
    },
  ],
  "lid:state:MV:2|bg": [
    {
      german: "Welches",
      translated: "Кое",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "е",
      tone: 'semantic',
    },
    {
      german: "ein Landkreis",
      translated: "окръг (Landkreis)",
      tone: 'semantic',
    },
    {
      german: "in Mecklenburg-Vorpommern",
      translated: "в Мекленбург-Предна Померания",
      tone: 'semantic',
    },
  ],
  "lid:state:MV:2|bs": [
    {
      german: "Welches",
      translated: "Što",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "je",
      tone: 'semantic',
    },
    {
      german: "ein Landkreis",
      translated: "od navedenoga okrug (Landkreis)",
      tone: 'semantic',
    },
    {
      german: "in Mecklenburg-Vorpommern",
      translated: "u saveznoj zemlji Mecklenburg-Zapadno Pomorje",
      tone: 'semantic',
    },
  ],
  "lid:state:MV:2|el": [
    {
      german: "Welches",
      translated: "Ποιο",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "από τα",
      tone: 'semantic',
    },
    {
      german: "ein Landkreis",
      translated: "διοικητική περιφέρεια (Landkreis)",
      tone: 'semantic',
    },
    {
      german: "in Mecklenburg-Vorpommern",
      translated: "στο Μεκλεμβούργο-Δυτική Πομερανία",
      tone: 'semantic',
    },
  ],
  "lid:state:MV:2|en": [
    {
      german: "Welches",
      translated: "Which",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "is",
      tone: 'semantic',
    },
    {
      german: "ein Landkreis",
      translated: "a district",
      tone: 'semantic',
    },
    {
      german: "in Mecklenburg-Vorpommern",
      translated: "in Mecklenburg-Vorpommern",
      tone: 'semantic',
    },
  ],
  "lid:state:MV:2|es": [
    {
      german: "Welches",
      translated: "¿Cuál",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "de los siguientes",
      tone: 'semantic',
    },
    {
      german: "ein Landkreis",
      translated: "un distrito (Landkreis)",
      tone: 'semantic',
    },
    {
      german: "in Mecklenburg-Vorpommern",
      translated: "de Mecklemburgo-Pomerania Occidental?",
      tone: 'semantic',
    },
  ],
  "lid:state:MV:2|fa": [
    {
      german: "Welches",
      translated: "کدام",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "است",
      tone: 'semantic',
    },
    {
      german: "ein Landkreis",
      translated: "یک شهرستان (Landkreis)",
      tone: 'semantic',
    },
    {
      german: "in Mecklenburg-Vorpommern",
      translated: "در مکلنبورگ-فورپومرن",
      tone: 'semantic',
    },
  ],
  "lid:state:MV:2|fr": [
    {
      german: "Welches",
      translated: "Lequel des",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "est un",
      tone: 'semantic',
    },
    {
      german: "ein Landkreis",
      translated: "arrondissement (Landkreis)",
      tone: 'semantic',
    },
    {
      german: "in Mecklenburg-Vorpommern",
      translated: "de Mecklembourg-Poméranie-Occidentale ?",
      tone: 'semantic',
    },
  ],
  "lid:state:MV:2|hr": [
    {
      german: "Welches",
      translated: "Što",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "je",
      tone: 'semantic',
    },
    {
      german: "ein Landkreis",
      translated: "od navedenoga okrug (Landkreis)",
      tone: 'semantic',
    },
    {
      german: "in Mecklenburg-Vorpommern",
      translated: "u saveznoj zemlji Mecklenburg-Zapadno Pomorje",
      tone: 'semantic',
    },
  ],
  "lid:state:MV:2|it": [
    {
      german: "Welches",
      translated: "Quale",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "è",
      tone: 'semantic',
    },
    {
      german: "ein Landkreis",
      translated: "un distretto",
      tone: 'semantic',
    },
    {
      german: "in Mecklenburg-Vorpommern",
      translated: "di Meclemburgo-Pomerania Anteriore",
      tone: 'semantic',
    },
  ],
  "lid:state:MV:2|kmr": [
    {
      german: "Welches",
      translated: "Kîjan",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "ji",
      tone: 'semantic',
    },
    {
      german: "ein Landkreis",
      translated: "van navçeyek (Landkreis)",
      tone: 'semantic',
    },
    {
      german: "in Mecklenburg-Vorpommern",
      translated: "li Mecklenburg-Vorpommern ye?",
      tone: 'semantic',
    },
  ],
  "lid:state:MV:2|pl": [
    {
      german: "Welches",
      translated: "Który",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "jest",
      tone: 'semantic',
    },
    {
      german: "ein Landkreis",
      translated: "powiatem (Landkreis)",
      tone: 'semantic',
    },
    {
      german: "in Mecklenburg-Vorpommern",
      translated: "w Meklemburgia-Pomorze Przednie?",
      tone: 'semantic',
    },
  ],
  "lid:state:MV:2|prs": [
    {
      german: "Welches",
      translated: "کدام",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "است",
      tone: 'semantic',
    },
    {
      german: "ein Landkreis",
      translated: "یک شهرستان (Landkreis)",
      tone: 'semantic',
    },
    {
      german: "in Mecklenburg-Vorpommern",
      translated: "در مکلنبورگ-فورپومرن",
      tone: 'semantic',
    },
  ],
  "lid:state:MV:2|ro": [
    {
      german: "Welches",
      translated: "Care",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "este",
      tone: 'semantic',
    },
    {
      german: "ein Landkreis",
      translated: "un district (Landkreis)",
      tone: 'semantic',
    },
    {
      german: "in Mecklenburg-Vorpommern",
      translated: "din Mecklenburg-Pomerania Inferioară",
      tone: 'semantic',
    },
  ],
  "lid:state:MV:2|ru": [
    {
      german: "Welches",
      translated: "Какой",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "из",
      tone: 'semantic',
    },
    {
      german: "ein Landkreis",
      translated: "районом",
      tone: 'semantic',
    },
    {
      german: "in Mecklenburg-Vorpommern",
      translated: "в федеральной земле Мекленбург-Передняя Померания",
      tone: 'semantic',
    },
  ],
  "lid:state:MV:2|sq": [
    {
      german: "Welches",
      translated: "Cila nga",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "është",
      tone: 'semantic',
    },
    {
      german: "ein Landkreis",
      translated: "qark (Landkreis)",
      tone: 'semantic',
    },
    {
      german: "in Mecklenburg-Vorpommern",
      translated: "në Mecklenburg-Vorpommern",
      tone: 'semantic',
    },
  ],
  "lid:state:MV:2|sr": [
    {
      german: "Welches",
      translated: "Šta",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "je",
      tone: 'semantic',
    },
    {
      german: "ein Landkreis",
      translated: "od navedenoga okrug (Landkreis)",
      tone: 'semantic',
    },
    {
      german: "in Mecklenburg-Vorpommern",
      translated: "u saveznoj pokrajini Meklenburg-Zapadna Pomeranija",
      tone: 'semantic',
    },
  ],
  "lid:state:MV:2|tr": [
    {
      german: "Welches",
      translated: "Aşağıdakilerden hangisi",
      tone: 'semantic',
    },
    {
      german: "ein Landkreis",
      translated: "bir Landkreis (ilçe/idari bölge)dir",
      tone: 'semantic',
    },
    {
      german: "in Mecklenburg-Vorpommern",
      translated: "Mecklenburg-Vorpommern eyaletinde bulunan",
      tone: 'semantic',
    },
  ],
  "lid:state:MV:2|uk": [
    {
      german: "Welches",
      translated: "Який",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "розташований",
      tone: 'semantic',
    },
    {
      german: "ein Landkreis",
      translated: "районів",
      tone: 'semantic',
    },
    {
      german: "in Mecklenburg-Vorpommern",
      translated: "у федеральній землі Мекленбург-Передня Померанія",
      tone: 'semantic',
    },
  ],
  "lid:state:MV:2|vi": [
    {
      german: "Welches",
      translated: "Địa danh nào",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "là",
      tone: 'semantic',
    },
    {
      german: "ein Landkreis",
      translated: "một huyện (Landkreis)",
      tone: 'semantic',
    },
    {
      german: "in Mecklenburg-Vorpommern",
      translated: "của bang Mecklenburg-Vorpommern",
      tone: 'semantic',
    },
  ],
  "lid:state:MV:3|ar": [
    {
      german: "Für wie viele Jahre",
      translated: "لمدة كم سنة",
      tone: 'semantic',
    },
    {
      german: "der Landtag in Mecklenburg-Vorpommern",
      translated: "برلمان الولاية في Mecklenburg-Vorpommern",
      tone: 'semantic',
    },
    {
      german: "gewählt",
      translated: "يُنتخب",
      tone: 'semantic',
    },
  ],
  "lid:state:MV:3|bg": [
    {
      german: "Für wie viele Jahre",
      translated: "За колко години",
      tone: 'semantic',
    },
    {
      german: "wird",
      translated: "се",
      tone: 'semantic',
    },
    {
      german: "der Landtag in Mecklenburg-Vorpommern",
      translated: "парламентът на провинция Мекленбург-Предна Померания",
      tone: 'semantic',
    },
    {
      german: "gewählt",
      translated: "избира",
      tone: 'semantic',
    },
  ],
  "lid:state:MV:3|bs": [
    {
      german: "Für wie viele Jahre",
      translated: "Na koliko se godina",
      tone: 'semantic',
    },
    {
      german: "der Landtag in Mecklenburg-Vorpommern",
      translated: "parlament savezne zemlje Mecklenburg-Zapadno Pomorje",
      tone: 'semantic',
    },
    {
      german: "gewählt",
      translated: "bira",
      tone: 'semantic',
    },
  ],
  "lid:state:MV:3|el": [
    {
      german: "Für wie viele Jahre",
      translated: "Για πόσα χρόνια",
      tone: 'semantic',
    },
    {
      german: "der Landtag in Mecklenburg-Vorpommern",
      translated: "το Landtag του Μεκλεμβούργο-Δυτική Πομερανία",
      tone: 'semantic',
    },
    {
      german: "gewählt",
      translated: "εκλέγεται",
      tone: 'semantic',
    },
  ],
  "lid:state:MV:3|en": [
    {
      german: "Für wie viele Jahre",
      translated: "For how many years",
      tone: 'semantic',
    },
    {
      german: "wird",
      translated: "is",
      tone: 'semantic',
    },
    {
      german: "der Landtag in Mecklenburg-Vorpommern",
      translated: "the state parliament in Mecklenburg-Vorpommern",
      tone: 'semantic',
    },
    {
      german: "gewählt",
      translated: "elected",
      tone: 'semantic',
    },
  ],
  "lid:state:MV:3|es": [
    {
      german: "Für wie viele Jahre",
      translated: "¿Por cuántos años",
      tone: 'semantic',
    },
    {
      german: "wird",
      translated: "se",
      tone: 'semantic',
    },
    {
      german: "der Landtag in Mecklenburg-Vorpommern",
      translated: "el parlamento regional en Mecklemburgo-Pomerania Occidental",
      tone: 'semantic',
    },
    {
      german: "gewählt",
      translated: "elige",
      tone: 'semantic',
    },
  ],
  "lid:state:MV:3|fa": [
    {
      german: "Für wie viele Jahre",
      translated: "برای چند سال",
      tone: 'semantic',
    },
    {
      german: "der Landtag in Mecklenburg-Vorpommern",
      translated: "پارلمان ایالتی مکلنبورگ-فورپومرن",
      tone: 'semantic',
    },
    {
      german: "gewählt",
      translated: "انتخاب می‌شود؟",
      tone: 'semantic',
    },
  ],
  "lid:state:MV:3|fr": [
    {
      german: "Für wie viele Jahre",
      translated: "Pour combien d’années",
      tone: 'semantic',
    },
    {
      german: "wird",
      translated: "est-il",
      tone: 'semantic',
    },
    {
      german: "der Landtag in Mecklenburg-Vorpommern",
      translated: "le Landtag de Mecklembourg-Poméranie-Occidentale",
      tone: 'semantic',
    },
    {
      german: "gewählt",
      translated: "élu",
      tone: 'semantic',
    },
  ],
  "lid:state:MV:3|hr": [
    {
      german: "Für wie viele Jahre",
      translated: "Na koliko se godina",
      tone: 'semantic',
    },
    {
      german: "der Landtag in Mecklenburg-Vorpommern",
      translated: "parlament savezne zemlje Mecklenburg-Zapadno Pomorje",
      tone: 'semantic',
    },
    {
      german: "gewählt",
      translated: "bira",
      tone: 'semantic',
    },
  ],
  "lid:state:MV:3|it": [
    {
      german: "Für wie viele Jahre",
      translated: "Per quanti anni",
      tone: 'semantic',
    },
    {
      german: "wird",
      translated: "viene",
      tone: 'semantic',
    },
    {
      german: "der Landtag in Mecklenburg-Vorpommern",
      translated: "il Landtag di Meclemburgo-Pomerania Anteriore",
      tone: 'semantic',
    },
    {
      german: "gewählt",
      translated: "eletto",
      tone: 'semantic',
    },
  ],
  "lid:state:MV:3|kmr": [
    {
      german: "Für wie viele Jahre",
      translated: "ji bo çend salan",
      tone: 'semantic',
    },
    {
      german: "wird",
      translated: "tê",
      tone: 'semantic',
    },
    {
      german: "der Landtag in Mecklenburg-Vorpommern",
      translated: "Landtag a Mecklenburg-Vorpommern",
      tone: 'semantic',
    },
    {
      german: "gewählt",
      translated: "hilbijartin",
      tone: 'semantic',
    },
  ],
  "lid:state:MV:3|pl": [
    {
      german: "Für wie viele Jahre",
      translated: "Na ile lat",
      tone: 'semantic',
    },
    {
      german: "wird",
      translated: "jest",
      tone: 'semantic',
    },
    {
      german: "der Landtag in Mecklenburg-Vorpommern",
      translated: "parlament kraju związkowego Meklemburgia-Pomorze Przednie",
      tone: 'semantic',
    },
    {
      german: "gewählt",
      translated: "wybierany",
      tone: 'semantic',
    },
  ],
  "lid:state:MV:3|prs": [
    {
      german: "Für wie viele Jahre",
      translated: "برای چند سال",
      tone: 'semantic',
    },
    {
      german: "wird",
      translated: "می‌شود",
      tone: 'semantic',
    },
    {
      german: "der Landtag in Mecklenburg-Vorpommern",
      translated: "پارلمان ایالتی مکلنبورگ-فورپومرن",
      tone: 'semantic',
    },
  ],
  "lid:state:MV:3|ro": [
    {
      german: "Für wie viele Jahre",
      translated: "Pentru câți ani",
      tone: 'semantic',
    },
    {
      german: "wird",
      translated: "este",
      tone: 'semantic',
    },
    {
      german: "der Landtag in Mecklenburg-Vorpommern",
      translated: "parlamentul landului Mecklenburg-Pomerania Inferioară",
      tone: 'semantic',
    },
    {
      german: "gewählt",
      translated: "ales",
      tone: 'semantic',
    },
  ],
  "lid:state:MV:3|ru": [
    {
      german: "Für wie viele Jahre",
      translated: "На сколько лет",
      tone: 'semantic',
    },
    {
      german: "wird",
      translated: "избирается",
      tone: 'semantic',
    },
    {
      german: "der Landtag in Mecklenburg-Vorpommern",
      translated: "ландтаг в федеральной земле Мекленбург-Передняя Померания",
      tone: 'semantic',
    },
  ],
  "lid:state:MV:3|sq": [
    {
      german: "Für wie viele Jahre",
      translated: "Për sa vjet",
      tone: 'semantic',
    },
    {
      german: "der Landtag in Mecklenburg-Vorpommern",
      translated: "Landtagu i Mecklenburg-Vorpommern",
      tone: 'semantic',
    },
    {
      german: "gewählt",
      translated: "zgjidhet",
      tone: 'semantic',
    },
  ],
  "lid:state:MV:3|sr": [
    {
      german: "Für wie viele Jahre",
      translated: "Na koliko se godina",
      tone: 'semantic',
    },
    {
      german: "wird",
      translated: "bira",
      tone: 'semantic',
    },
    {
      german: "der Landtag in Mecklenburg-Vorpommern",
      translated: "parlament savezne pokrajine Meklenburg-Zapadna Pomeranija",
      tone: 'semantic',
    },
  ],
  "lid:state:MV:3|tr": [
    {
      german: "Für wie viele Jahre",
      translated: "kaç yıllığına",
      tone: 'semantic',
    },
    {
      german: "wird",
      translated: "seçilir",
      tone: 'semantic',
    },
    {
      german: "der Landtag in Mecklenburg-Vorpommern",
      translated: "Mecklenburg-Vorpommern eyalet parlamentosu",
      tone: 'semantic',
    },
  ],
  "lid:state:MV:3|uk": [
    {
      german: "Für wie viele Jahre",
      translated: "На скільки років",
      tone: 'semantic',
    },
    {
      german: "der Landtag in Mecklenburg-Vorpommern",
      translated: "земельний парламент у федеральній землі Мекленбург-Передня Померанія",
      tone: 'semantic',
    },
    {
      german: "gewählt",
      translated: "обирають",
      tone: 'semantic',
    },
  ],
  "lid:state:MV:3|vi": [
    {
      german: "Für wie viele Jahre",
      translated: "bao nhiêu năm",
      tone: 'semantic',
    },
    {
      german: "der Landtag in Mecklenburg-Vorpommern",
      translated: "Nghị viện bang (Landtag) của Mecklenburg-Vorpommern",
      tone: 'semantic',
    },
    {
      german: "gewählt",
      translated: "được bầu",
      tone: 'semantic',
    },
  ],
  "lid:state:MV:4|ar": [
    {
      german: "Ab welchem Alter",
      translated: "ابتداءً من أي سن",
      tone: 'semantic',
    },
    {
      german: "darf man",
      translated: "يحق",
      tone: 'semantic',
    },
    {
      german: "in Mecklenburg-Vorpommern",
      translated: "في Mecklenburg-Vorpommern",
      tone: 'semantic',
    },
    {
      german: "bei Kommunalwahlen",
      translated: "في الانتخابات المحلية",
      tone: 'semantic',
    },
    {
      german: "wählen",
      translated: "التصويت",
      tone: 'semantic',
    },
  ],
  "lid:state:MV:4|bg": [
    {
      german: "Ab welchem Alter",
      translated: "От каква възраст",
      tone: 'semantic',
    },
    {
      german: "darf man",
      translated: "може да се",
      tone: 'semantic',
    },
    {
      german: "in Mecklenburg-Vorpommern",
      translated: "в Мекленбург-Предна Померания",
      tone: 'semantic',
    },
    {
      german: "bei Kommunalwahlen",
      translated: "на общински избори",
      tone: 'semantic',
    },
    {
      german: "wählen",
      translated: "гласува",
      tone: 'semantic',
    },
  ],
  "lid:state:MV:4|bs": [
    {
      german: "Ab welchem Alter",
      translated: "Od koje se dobi",
      tone: 'semantic',
    },
    {
      german: "darf man",
      translated: "može",
      tone: 'semantic',
    },
    {
      german: "in Mecklenburg-Vorpommern",
      translated: "u saveznoj zemlji Mecklenburg-Zapadno Pomorje",
      tone: 'semantic',
    },
    {
      german: "bei Kommunalwahlen",
      translated: "na lokalnim izborima",
      tone: 'semantic',
    },
    {
      german: "wählen",
      translated: "glasovati",
      tone: 'semantic',
    },
  ],
  "lid:state:MV:4|el": [
    {
      german: "Ab welchem Alter",
      translated: "Από ποια ηλικία",
      tone: 'semantic',
    },
    {
      german: "darf man",
      translated: "μπορεί κάποιος",
      tone: 'semantic',
    },
    {
      german: "in Mecklenburg-Vorpommern",
      translated: "στο Μεκλεμβούργο-Δυτική Πομερανία",
      tone: 'semantic',
    },
    {
      german: "bei Kommunalwahlen",
      translated: "στις δημοτικές εκλογές",
      tone: 'semantic',
    },
    {
      german: "wählen",
      translated: "να ψηφίσει",
      tone: 'semantic',
    },
  ],
  "lid:state:MV:4|en": [
    {
      german: "Ab welchem Alter",
      translated: "From what age",
      tone: 'semantic',
    },
    {
      german: "darf man",
      translated: "can you",
      tone: 'semantic',
    },
    {
      german: "in Mecklenburg-Vorpommern",
      translated: "in Mecklenburg-Vorpommern",
      tone: 'semantic',
    },
    {
      german: "bei Kommunalwahlen",
      translated: "local elections",
      tone: 'semantic',
    },
    {
      german: "wählen",
      translated: "vote",
      tone: 'semantic',
    },
  ],
  "lid:state:MV:4|es": [
    {
      german: "Ab welchem Alter",
      translated: "¿A partir de qué edad",
      tone: 'semantic',
    },
    {
      german: "darf man",
      translated: "se puede",
      tone: 'semantic',
    },
    {
      german: "in Mecklenburg-Vorpommern",
      translated: "de Mecklemburgo-Pomerania Occidental",
      tone: 'semantic',
    },
    {
      german: "bei Kommunalwahlen",
      translated: "en las elecciones municipales",
      tone: 'semantic',
    },
    {
      german: "wählen",
      translated: "votar",
      tone: 'semantic',
    },
  ],
  "lid:state:MV:4|fa": [
    {
      german: "Ab welchem Alter",
      translated: "از چه سنی",
      tone: 'semantic',
    },
    {
      german: "darf man",
      translated: "می‌توان",
      tone: 'semantic',
    },
    {
      german: "in Mecklenburg-Vorpommern",
      translated: "در انتخابات محلی مکلنبورگ-فورپومرن",
      tone: 'semantic',
    },
    {
      german: "wählen",
      translated: "رأی داد",
      tone: 'semantic',
    },
  ],
  "lid:state:MV:4|fr": [
    {
      german: "Ab welchem Alter",
      translated: "À partir de quel âge",
      tone: 'semantic',
    },
    {
      german: "darf man",
      translated: "peut-on",
      tone: 'semantic',
    },
    {
      german: "in Mecklenburg-Vorpommern",
      translated: "en Mecklembourg-Poméranie-Occidentale",
      tone: 'semantic',
    },
    {
      german: "bei Kommunalwahlen",
      translated: "aux élections municipales",
      tone: 'semantic',
    },
    {
      german: "wählen",
      translated: "voter",
      tone: 'semantic',
    },
  ],
  "lid:state:MV:4|hr": [
    {
      german: "Ab welchem Alter",
      translated: "Od koje",
      tone: 'semantic',
    },
    {
      german: "darf man",
      translated: "se",
      tone: 'semantic',
    },
    {
      german: "in Mecklenburg-Vorpommern",
      translated: "u saveznoj zemlji",
      tone: 'semantic',
    },
    {
      german: "bei Kommunalwahlen",
      translated: "na lokalnim izborima",
      tone: 'semantic',
    },
    {
      german: "wählen",
      translated: "glasovati",
      tone: 'semantic',
    },
  ],
  "lid:state:MV:4|it": [
    {
      german: "Ab welchem Alter",
      translated: "Da quale età",
      tone: 'semantic',
    },
    {
      german: "darf man",
      translated: "si può",
      tone: 'semantic',
    },
    {
      german: "in Mecklenburg-Vorpommern",
      translated: "in Meclemburgo-Pomerania Anteriore",
      tone: 'semantic',
    },
    {
      german: "bei Kommunalwahlen",
      translated: "alle elezioni comunali",
      tone: 'semantic',
    },
    {
      german: "wählen",
      translated: "votare",
      tone: 'semantic',
    },
  ],
  "lid:state:MV:4|kmr": [
    {
      german: "Ab welchem Alter",
      translated: "Ji kîjan temenê",
      tone: 'semantic',
    },
    {
      german: "darf man",
      translated: "dikare",
      tone: 'semantic',
    },
    {
      german: "in Mecklenburg-Vorpommern",
      translated: "li Mecklenburg-Vorpommern",
      tone: 'semantic',
    },
    {
      german: "bei Kommunalwahlen",
      translated: "di hilbijartinên şaredariyê de",
      tone: 'semantic',
    },
    {
      german: "wählen",
      translated: "deng were dayîn",
      tone: 'semantic',
    },
  ],
  "lid:state:MV:4|pl": [
    {
      german: "Ab welchem Alter",
      translated: "Od jakiego wieku",
      tone: 'semantic',
    },
    {
      german: "darf man",
      translated: "można",
      tone: 'semantic',
    },
    {
      german: "in Mecklenburg-Vorpommern",
      translated: "w Meklemburgii-Pomorzu Przednim",
      tone: 'semantic',
    },
    {
      german: "bei Kommunalwahlen",
      translated: "w wyborach samorządowych",
      tone: 'semantic',
    },
    {
      german: "wählen",
      translated: "głosować",
      tone: 'semantic',
    },
  ],
  "lid:state:MV:4|prs": [
    {
      german: "Ab welchem Alter",
      translated: "از چه سنی",
      tone: 'semantic',
    },
    {
      german: "darf man",
      translated: "می‌توان",
      tone: 'semantic',
    },
    {
      german: "in Mecklenburg-Vorpommern",
      translated: "مکلنبورگ-فورپومرن",
      tone: 'semantic',
    },
    {
      german: "bei Kommunalwahlen",
      translated: "انتخابات شاروالی",
      tone: 'semantic',
    },
    {
      german: "wählen",
      translated: "رأی داد",
      tone: 'semantic',
    },
  ],
  "lid:state:MV:4|ro": [
    {
      german: "Ab welchem Alter",
      translated: "De la ce vârstă",
      tone: 'semantic',
    },
    {
      german: "darf man",
      translated: "se poate",
      tone: 'semantic',
    },
    {
      german: "in Mecklenburg-Vorpommern",
      translated: "din Mecklenburg-Pomerania Inferioară",
      tone: 'semantic',
    },
    {
      german: "bei Kommunalwahlen",
      translated: "alegerile locale",
      tone: 'semantic',
    },
    {
      german: "wählen",
      translated: "vota",
      tone: 'semantic',
    },
  ],
  "lid:state:MV:4|ru": [
    {
      german: "Ab welchem Alter",
      translated: "С какого возраста",
      tone: 'semantic',
    },
    {
      german: "darf man",
      translated: "можно",
      tone: 'semantic',
    },
    {
      german: "in Mecklenburg-Vorpommern",
      translated: "в федеральной земле Мекленбург-Передняя Померания",
      tone: 'semantic',
    },
    {
      german: "bei Kommunalwahlen",
      translated: "на муниципальных выборах",
      tone: 'semantic',
    },
    {
      german: "wählen",
      translated: "голосовать",
      tone: 'semantic',
    },
  ],
  "lid:state:MV:4|sq": [
    {
      german: "Ab welchem Alter",
      translated: "Nga cila moshë mund",
      tone: 'semantic',
    },
    {
      german: "darf man",
      translated: "të",
      tone: 'semantic',
    },
    {
      german: "in Mecklenburg-Vorpommern",
      translated: "në Mecklenburg-Vorpommern",
      tone: 'semantic',
    },
    {
      german: "bei Kommunalwahlen",
      translated: "në zgjedhjet komunale",
      tone: 'semantic',
    },
    {
      german: "wählen",
      translated: "votohet",
      tone: 'semantic',
    },
  ],
  "lid:state:MV:4|sr": [
    {
      german: "Ab welchem Alter",
      translated: "Od koje se dobi",
      tone: 'semantic',
    },
    {
      german: "darf man",
      translated: "može",
      tone: 'semantic',
    },
    {
      german: "in Mecklenburg-Vorpommern",
      translated: "u saveznoj pokrajini Meklenburg-Zapadna Pomeranija",
      tone: 'semantic',
    },
    {
      german: "bei Kommunalwahlen",
      translated: "na lokalnim izborima",
      tone: 'semantic',
    },
    {
      german: "wählen",
      translated: "glasati",
      tone: 'semantic',
    },
  ],
  "lid:state:MV:4|tr": [
    {
      german: "Ab welchem Alter",
      translated: "kaç yaşından itibaren",
      tone: 'semantic',
    },
    {
      german: "in Mecklenburg-Vorpommern",
      translated: "Mecklenburg-Vorpommern eyaletinde",
      tone: 'semantic',
    },
    {
      german: "bei Kommunalwahlen",
      translated: "yerel seçimlerde",
      tone: 'semantic',
    },
    {
      german: "wählen",
      translated: "oy kullanılabilir",
      tone: 'semantic',
    },
  ],
  "lid:state:MV:4|uk": [
    {
      german: "Ab welchem Alter",
      translated: "З якого віку",
      tone: 'semantic',
    },
    {
      german: "darf man",
      translated: "можна",
      tone: 'semantic',
    },
    {
      german: "in Mecklenburg-Vorpommern",
      translated: "у федеральній землі Мекленбург-Передня Померанія",
      tone: 'semantic',
    },
    {
      german: "bei Kommunalwahlen",
      translated: "на муніципальних виборах",
      tone: 'semantic',
    },
    {
      german: "wählen",
      translated: "голосувати",
      tone: 'semantic',
    },
  ],
  "lid:state:MV:4|vi": [
    {
      german: "Ab welchem Alter",
      translated: "Từ bao nhiêu tuổi",
      tone: 'semantic',
    },
    {
      german: "darf man",
      translated: "có thể",
      tone: 'semantic',
    },
    {
      german: "in Mecklenburg-Vorpommern",
      translated: "ở bang Mecklenburg-Vorpommern",
      tone: 'semantic',
    },
    {
      german: "bei Kommunalwahlen",
      translated: "trong bầu cử địa phương",
      tone: 'semantic',
    },
    {
      german: "wählen",
      translated: "bỏ phiếu",
      tone: 'semantic',
    },
  ],
  "lid:state:MV:5|ar": [
    {
      german: "Welche Farben",
      translated: "ما",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "ألوان",
      tone: 'semantic',
    },
    {
      german: "die Landesflagge",
      translated: "علم",
      tone: 'semantic',
    },
    {
      german: "von Mecklenburg-Vorpommern",
      translated: "ولاية Mecklenburg-Vorpommern",
      tone: 'semantic',
    },
  ],
  "lid:state:MV:5|bg": [
    {
      german: "Welche Farben",
      translated: "Какви са",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "цветовете",
      tone: 'semantic',
    },
    {
      german: "die Landesflagge",
      translated: "на знамето",
      tone: 'semantic',
    },
    {
      german: "von Mecklenburg-Vorpommern",
      translated: "на провинция Мекленбург-Предна Померания",
      tone: 'semantic',
    },
  ],
  "lid:state:MV:5|bs": [
    {
      german: "Welche Farben",
      translated: "Koje su boje",
      tone: 'semantic',
    },
    {
      german: "die Landesflagge",
      translated: "zastave",
      tone: 'semantic',
    },
    {
      german: "von Mecklenburg-Vorpommern",
      translated: "savezne zemlje Mecklenburg-Zapadno Pomorje",
      tone: 'semantic',
    },
  ],
  "lid:state:MV:5|el": [
    {
      german: "Welche Farben",
      translated: "Ποια είναι τα χρώματα",
      tone: 'semantic',
    },
    {
      german: "die Landesflagge",
      translated: "της σημαίας του κρατιδίου",
      tone: 'semantic',
    },
    {
      german: "von Mecklenburg-Vorpommern",
      translated: "Μεκλεμβούργο-Δυτική Πομερανία",
      tone: 'semantic',
    },
  ],
  "lid:state:MV:5|en": [
    {
      german: "Welche Farben",
      translated: "What colors",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "have",
      tone: 'semantic',
    },
    {
      german: "die Landesflagge",
      translated: "the state flag",
      tone: 'semantic',
    },
    {
      german: "von Mecklenburg-Vorpommern",
      translated: "of Mecklenburg-Vorpommern",
      tone: 'semantic',
    },
  ],
  "lid:state:MV:5|es": [
    {
      german: "Welche Farben",
      translated: "¿Qué colores",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "tiene",
      tone: 'semantic',
    },
    {
      german: "die Landesflagge",
      translated: "la bandera regional",
      tone: 'semantic',
    },
    {
      german: "von Mecklenburg-Vorpommern",
      translated: "de Mecklemburgo-Pomerania Occidental",
      tone: 'semantic',
    },
  ],
  "lid:state:MV:5|fa": [
    {
      german: "Welche Farben",
      translated: "رنگ‌های",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "کدام‌اند؟",
      tone: 'semantic',
    },
    {
      german: "die Landesflagge",
      translated: "پرچم ایالت",
      tone: 'semantic',
    },
    {
      german: "von Mecklenburg-Vorpommern",
      translated: "مکلنبورگ-فورپومرن",
      tone: 'semantic',
    },
  ],
  "lid:state:MV:5|fr": [
    {
      german: "Welche Farben",
      translated: "Quelles sont les couleurs",
      tone: 'semantic',
    },
    {
      german: "die Landesflagge",
      translated: "du drapeau du Land",
      tone: 'semantic',
    },
    {
      german: "von Mecklenburg-Vorpommern",
      translated: "de Mecklembourg-Poméranie-Occidentale",
      tone: 'semantic',
    },
  ],
  "lid:state:MV:5|hr": [
    {
      german: "Welche Farben",
      translated: "Koje su boje",
      tone: 'semantic',
    },
    {
      german: "die Landesflagge",
      translated: "zastave",
      tone: 'semantic',
    },
    {
      german: "von Mecklenburg-Vorpommern",
      translated: "savezne zemlje Mecklenburg-Zapadno Pomorje",
      tone: 'semantic',
    },
  ],
  "lid:state:MV:5|it": [
    {
      german: "Welche Farben",
      translated: "Quali sono i colori",
      tone: 'semantic',
    },
    {
      german: "die Landesflagge",
      translated: "bandiera del Land",
      tone: 'semantic',
    },
    {
      german: "von Mecklenburg-Vorpommern",
      translated: "di Meclemburgo-Pomerania Anteriore",
      tone: 'semantic',
    },
  ],
  "lid:state:MV:5|kmr": [
    {
      german: "Welche Farben",
      translated: "Rengên",
      tone: 'semantic',
    },
    {
      german: "die Landesflagge",
      translated: "ala eyaleta",
      tone: 'semantic',
    },
    {
      german: "von Mecklenburg-Vorpommern",
      translated: "Mecklenburg-Vorpommern",
      tone: 'semantic',
    },
  ],
  "lid:state:MV:5|pl": [
    {
      german: "Welche Farben",
      translated: "Jakie są kolory",
      tone: 'semantic',
    },
    {
      german: "die Landesflagge",
      translated: "flagi kraju związkowego",
      tone: 'semantic',
    },
    {
      german: "von Mecklenburg-Vorpommern",
      translated: "Meklemburgia-Pomorze Przednie",
      tone: 'semantic',
    },
  ],
  "lid:state:MV:5|prs": [
    {
      german: "Welche Farben",
      translated: "رنگ‌های",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "کدام‌اند",
      tone: 'semantic',
    },
    {
      german: "die Landesflagge",
      translated: "پرچم ایالت",
      tone: 'semantic',
    },
    {
      german: "von Mecklenburg-Vorpommern",
      translated: "مکلنبورگ-فورپومرن",
      tone: 'semantic',
    },
  ],
  "lid:state:MV:5|ro": [
    {
      german: "Welche Farben",
      translated: "Care sunt culorile",
      tone: 'semantic',
    },
    {
      german: "die Landesflagge",
      translated: "drapelului landului",
      tone: 'semantic',
    },
    {
      german: "von Mecklenburg-Vorpommern",
      translated: "Mecklenburg-Pomerania Inferioară",
      tone: 'semantic',
    },
  ],
  "lid:state:MV:5|ru": [
    {
      german: "Welche Farben",
      translated: "Какие цвета",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "у",
      tone: 'semantic',
    },
    {
      german: "die Landesflagge",
      translated: "флага земли",
      tone: 'semantic',
    },
    {
      german: "von Mecklenburg-Vorpommern",
      translated: "Мекленбург-Передняя Померания",
      tone: 'semantic',
    },
  ],
  "lid:state:MV:5|sq": [
    {
      german: "Welche Farben",
      translated: "ngjyrat",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: " janë",
      tone: 'semantic',
    },
    {
      german: "die Landesflagge",
      translated: "e flamurit të landit",
      tone: 'semantic',
    },
    {
      german: "von Mecklenburg-Vorpommern",
      translated: "Mecklenburg-Vorpommern",
      tone: 'semantic',
    },
  ],
  "lid:state:MV:5|sr": [
    {
      german: "Welche Farben",
      translated: "Koje su",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "boje",
      tone: 'semantic',
    },
    {
      german: "die Landesflagge",
      translated: "zastave savezne pokrajine",
      tone: 'semantic',
    },
    {
      german: "von Mecklenburg-Vorpommern",
      translated: "Meklenburg-Zapadna Pomeranija",
      tone: 'semantic',
    },
  ],
  "lid:state:MV:5|tr": [
    {
      german: "Welche Farben",
      translated: "renkleri nelerdir",
      tone: 'semantic',
    },
    {
      german: "die Landesflagge",
      translated: "eyalet bayrağının",
      tone: 'semantic',
    },
    {
      german: "von Mecklenburg-Vorpommern",
      translated: "Mecklenburg-Vorpommern",
      tone: 'semantic',
    },
  ],
  "lid:state:MV:5|uk": [
    {
      german: "Welche Farben",
      translated: "Які кольори",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: " має",
      tone: 'semantic',
    },
    {
      german: "die Landesflagge",
      translated: "прапор федеральної землі",
      tone: 'semantic',
    },
    {
      german: "von Mecklenburg-Vorpommern",
      translated: "Мекленбург-Передня Померанія",
      tone: 'semantic',
    },
  ],
  "lid:state:MV:5|vi": [
    {
      german: "Welche Farben",
      translated: "Màu của",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "là",
      tone: 'semantic',
    },
    {
      german: "die Landesflagge",
      translated: "cờ bang",
      tone: 'semantic',
    },
    {
      german: "von Mecklenburg-Vorpommern",
      translated: "Mecklenburg-Vorpommern",
      tone: 'semantic',
    },
  ],
  "lid:state:MV:6|ar": [
    {
      german: "Wo",
      translated: "أين",
      tone: 'semantic',
    },
    {
      german: "können",
      translated: "يمكنك",
      tone: 'semantic',
    },
    {
      german: "in Mecklenburg-Vorpommern",
      translated: "في Mecklenburg-Vorpommern",
      tone: 'semantic',
    },
    {
      german: "über politische Themen",
      translated: "عن القضايا السياسية",
      tone: 'semantic',
    },
    {
      german: "informieren",
      translated: "الحصول على معلومات",
      tone: 'semantic',
    },
  ],
  "lid:state:MV:6|bg": [
    {
      german: "Wo",
      translated: "Къде",
      tone: 'semantic',
    },
    {
      german: "können",
      translated: "можете",
      tone: 'semantic',
    },
    {
      german: "in Mecklenburg-Vorpommern",
      translated: "в Мекленбург-Предна Померания",
      tone: 'semantic',
    },
    {
      german: "über politische Themen",
      translated: "по политически теми",
      tone: 'semantic',
    },
    {
      german: "informieren",
      translated: "да получите информация",
      tone: 'semantic',
    },
  ],
  "lid:state:MV:6|bs": [
    {
      german: "Wo",
      translated: "Gdje",
      tone: 'semantic',
    },
    {
      german: "können",
      translated: "mogu",
      tone: 'semantic',
    },
    {
      german: "sich",
      translated: "se",
      tone: 'semantic',
    },
    {
      german: "in Mecklenburg-Vorpommern",
      translated: "u saveznoj zemlji Mecklenburg-Zapadno Pomorje",
      tone: 'semantic',
    },
    {
      german: "über politische Themen",
      translated: "o političkim temama",
      tone: 'semantic',
    },
    {
      german: "informieren",
      translated: "dobiti informacije",
      tone: 'semantic',
    },
  ],
  "lid:state:MV:6|el": [
    {
      german: "Wo",
      translated: "Πού",
      tone: 'semantic',
    },
    {
      german: "können",
      translated: "μπορείτε",
      tone: 'semantic',
    },
    {
      german: "in Mecklenburg-Vorpommern",
      translated: "στο Μεκλεμβούργο-Δυτική Πομερανία",
      tone: 'semantic',
    },
    {
      german: "über politische Themen",
      translated: "για πολιτικά θέματα",
      tone: 'semantic',
    },
    {
      german: "informieren",
      translated: "ενημερωθείτε",
      tone: 'semantic',
    },
  ],
  "lid:state:MV:6|en": [
    {
      german: "Wo",
      translated: "Where",
      tone: 'semantic',
    },
    {
      german: "können",
      translated: "can",
      tone: 'semantic',
    },
    {
      german: "Sie",
      translated: "you",
      tone: 'semantic',
    },
    {
      german: "in Mecklenburg-Vorpommern",
      translated: "in Mecklenburg-Vorpommern",
      tone: 'semantic',
    },
    {
      german: "über politische Themen",
      translated: "about political topics",
      tone: 'semantic',
    },
    {
      german: "informieren",
      translated: "get information",
      tone: 'semantic',
    },
  ],
  "lid:state:MV:6|es": [
    {
      german: "Wo",
      translated: "¿Dónde",
      tone: 'semantic',
    },
    {
      german: "können",
      translated: "puede",
      tone: 'semantic',
    },
    {
      german: "in Mecklenburg-Vorpommern",
      translated: "en Mecklemburgo-Pomerania Occidental",
      tone: 'semantic',
    },
    {
      german: "über politische Themen",
      translated: "sobre temas políticos",
      tone: 'semantic',
    },
    {
      german: "informieren",
      translated: "informarse",
      tone: 'semantic',
    },
  ],
  "lid:state:MV:6|fa": [
    {
      german: "Wo",
      translated: "کجا",
      tone: 'semantic',
    },
    {
      german: "können",
      translated: "می‌توانید",
      tone: 'semantic',
    },
    {
      german: "in Mecklenburg-Vorpommern",
      translated: "در مکلنبورگ-فورپومرن",
      tone: 'semantic',
    },
    {
      german: "über politische Themen",
      translated: "دربارهٔ موضوعات سیاسی",
      tone: 'semantic',
    },
    {
      german: "informieren",
      translated: "اطلاعات کسب کنید",
      tone: 'semantic',
    },
  ],
  "lid:state:MV:6|fr": [
    {
      german: "Wo",
      translated: "Où",
      tone: 'semantic',
    },
    {
      german: "können",
      translated: "pouvez",
      tone: 'semantic',
    },
    {
      german: "Sie",
      translated: "vous",
      tone: 'semantic',
    },
    {
      german: "sich",
      translated: "vous",
      tone: 'semantic',
    },
    {
      german: "in Mecklenburg-Vorpommern",
      translated: "en Mecklembourg-Poméranie-Occidentale",
      tone: 'semantic',
    },
    {
      german: "über politische Themen",
      translated: "sur les questions politiques",
      tone: 'semantic',
    },
    {
      german: "informieren",
      translated: "informer",
      tone: 'semantic',
    },
  ],
  "lid:state:MV:6|hr": [
    {
      german: "Wo",
      translated: "Gdje",
      tone: 'semantic',
    },
    {
      german: "können",
      translated: "mogu",
      tone: 'semantic',
    },
    {
      german: "sich",
      translated: "se",
      tone: 'semantic',
    },
    {
      german: "in Mecklenburg-Vorpommern",
      translated: "u saveznoj zemlji Mecklenburg-Zapadno Pomorje",
      tone: 'semantic',
    },
    {
      german: "über politische Themen",
      translated: "o političkim temama",
      tone: 'semantic',
    },
    {
      german: "informieren",
      translated: "dobiti informacije",
      tone: 'semantic',
    },
  ],
  "lid:state:MV:6|it": [
    {
      german: "Wo",
      translated: "Dove",
      tone: 'semantic',
    },
    {
      german: "können",
      translated: "può",
      tone: 'semantic',
    },
    {
      german: "sich",
      translated: "ci si",
      tone: 'semantic',
    },
    {
      german: "in Mecklenburg-Vorpommern",
      translated: "in Meclemburgo-Pomerania Anteriore",
      tone: 'semantic',
    },
    {
      german: "über politische Themen",
      translated: "su temi politici",
      tone: 'semantic',
    },
    {
      german: "informieren",
      translated: "informare",
      tone: 'semantic',
    },
  ],
  "lid:state:MV:6|kmr": [
    {
      german: "Wo",
      translated: "Li",
      tone: 'semantic',
    },
    {
      german: "sich",
      translated: "dikarî",
      tone: 'semantic',
    },
    {
      german: "in Mecklenburg-Vorpommern",
      translated: "Mecklenburg-Vorpommern",
      tone: 'semantic',
    },
    {
      german: "über politische Themen",
      translated: "ser mijarên siyasî",
      tone: 'semantic',
    },
    {
      german: "informieren",
      translated: "agahdarî bistînî",
      tone: 'semantic',
    },
  ],
  "lid:state:MV:6|pl": [
    {
      german: "Wo",
      translated: "Gdzie",
      tone: 'semantic',
    },
    {
      german: "können",
      translated: "można",
      tone: 'semantic',
    },
    {
      german: "in Mecklenburg-Vorpommern",
      translated: "w Meklemburgia-Pomorze Przednie",
      tone: 'semantic',
    },
    {
      german: "über politische Themen",
      translated: "na tematy polityczne",
      tone: 'semantic',
    },
    {
      german: "informieren",
      translated: "uzyskać informacje",
      tone: 'semantic',
    },
  ],
  "lid:state:MV:6|prs": [
    {
      german: "können",
      translated: "می‌توانید",
      tone: 'semantic',
    },
    {
      german: "in Mecklenburg-Vorpommern",
      translated: "در مکلنبورگ-فورپومرن",
      tone: 'semantic',
    },
    {
      german: "über politische Themen",
      translated: "دربارهٔ موضوعات سیاسی",
      tone: 'semantic',
    },
    {
      german: "informieren",
      translated: "اطلاعات کسب کنید",
      tone: 'semantic',
    },
  ],
  "lid:state:MV:6|ro": [
    {
      german: "Wo",
      translated: "Unde",
      tone: 'semantic',
    },
    {
      german: "können",
      translated: "puteți",
      tone: 'semantic',
    },
    {
      german: "Sie",
      translated: "vă",
      tone: 'semantic',
    },
    {
      german: "in Mecklenburg-Vorpommern",
      translated: "în Mecklenburg-Pomerania Inferioară",
      tone: 'semantic',
    },
    {
      german: "über politische Themen",
      translated: "despre teme politice",
      tone: 'semantic',
    },
    {
      german: "informieren",
      translated: "informa",
      tone: 'semantic',
    },
  ],
  "lid:state:MV:6|ru": [
    {
      german: "Wo",
      translated: "Где",
      tone: 'semantic',
    },
    {
      german: "können",
      translated: "можно",
      tone: 'semantic',
    },
    {
      german: "in Mecklenburg-Vorpommern",
      translated: "в федеральной земле Мекленбург-Передняя Померания",
      tone: 'semantic',
    },
    {
      german: "über politische Themen",
      translated: "о политических темах",
      tone: 'semantic',
    },
    {
      german: "informieren",
      translated: "получить информацию",
      tone: 'semantic',
    },
  ],
  "lid:state:MV:6|sq": [
    {
      german: "Wo",
      translated: "Ku",
      tone: 'semantic',
    },
    {
      german: "können",
      translated: "mund të",
      tone: 'semantic',
    },
    {
      german: "sich",
      translated: "informoheni",
      tone: 'semantic',
    },
    {
      german: "in Mecklenburg-Vorpommern",
      translated: "në Mecklenburg-Vorpommern",
      tone: 'semantic',
    },
    {
      german: "über politische Themen",
      translated: "për tema politike",
      tone: 'semantic',
    },
  ],
  "lid:state:MV:6|sr": [
    {
      german: "Wo",
      translated: "Gdje",
      tone: 'semantic',
    },
    {
      german: "können",
      translated: "mogu",
      tone: 'semantic',
    },
    {
      german: "sich",
      translated: "se",
      tone: 'semantic',
    },
    {
      german: "in Mecklenburg-Vorpommern",
      translated: "u saveznoj pokrajini Meklenburg-Zapadna Pomeranija",
      tone: 'semantic',
    },
    {
      german: "über politische Themen",
      translated: "o političkim temama",
      tone: 'semantic',
    },
    {
      german: "informieren",
      translated: "dobiti informacije",
      tone: 'semantic',
    },
  ],
  "lid:state:MV:6|tr": [
    {
      german: "Wo",
      translated: "nereden",
      tone: 'semantic',
    },
    {
      german: "können",
      translated: "alabilirsiniz",
      tone: 'semantic',
    },
    {
      german: "in Mecklenburg-Vorpommern",
      translated: "Mecklenburg-Vorpommern eyaletinde",
      tone: 'semantic',
    },
    {
      german: "über politische Themen",
      translated: "siyasi konular hakkında",
      tone: 'semantic',
    },
    {
      german: "informieren",
      translated: "bilgi",
      tone: 'semantic',
    },
  ],
  "lid:state:MV:6|uk": [
    {
      german: "Wo",
      translated: "Де",
      tone: 'semantic',
    },
    {
      german: "können",
      translated: "можна",
      tone: 'semantic',
    },
    {
      german: "in Mecklenburg-Vorpommern",
      translated: "у федеральній землі Мекленбург-Передня Померанія",
      tone: 'semantic',
    },
    {
      german: "über politische Themen",
      translated: "про політичні питання",
      tone: 'semantic',
    },
    {
      german: "informieren",
      translated: "отримати інформацію",
      tone: 'semantic',
    },
  ],
  "lid:state:MV:6|vi": [
    {
      german: "Wo",
      translated: "ở đâu",
      tone: 'semantic',
    },
    {
      german: "können",
      translated: "có thể",
      tone: 'semantic',
    },
    {
      german: "in Mecklenburg-Vorpommern",
      translated: "Ở bang Mecklenburg-Vorpommern",
      tone: 'semantic',
    },
    {
      german: "über politische Themen",
      translated: "về các chủ đề chính trị",
      tone: 'semantic',
    },
    {
      german: "informieren",
      translated: "tìm thông tin",
      tone: 'semantic',
    },
  ],
  "lid:state:MV:7|ar": [
    {
      german: "Die Landeshauptstadt",
      translated: "ما عاصمة",
      tone: 'semantic',
    },
    {
      german: "von Mecklenburg-Vorpommern",
      translated: "Mecklenburg-Vorpommern",
      tone: 'semantic',
    },
    {
      german: "heißt",
      translated: "؟",
      tone: 'semantic',
    },
  ],
  "lid:state:MV:7|bg": [
    {
      german: "Die Landeshauptstadt",
      translated: "Столицата на федералната провинция",
      tone: 'semantic',
    },
    {
      german: "von Mecklenburg-Vorpommern",
      translated: "Мекленбург-Предна Померания",
      tone: 'semantic',
    },
    {
      german: "heißt",
      translated: "е …",
      tone: 'semantic',
    },
  ],
  "lid:state:MV:7|bs": [
    {
      german: "Die Landeshauptstadt",
      translated: "Glavni grad",
      tone: 'semantic',
    },
    {
      german: "von Mecklenburg-Vorpommern",
      translated: "savezne zemlje Mecklenburg-Zapadno Pomorje",
      tone: 'semantic',
    },
    {
      german: "heißt",
      translated: "je",
      tone: 'semantic',
    },
  ],
  "lid:state:MV:7|el": [
    {
      german: "Die Landeshauptstadt",
      translated: "Η πρωτεύουσα",
      tone: 'semantic',
    },
    {
      german: "von Mecklenburg-Vorpommern",
      translated: "του ομόσπονδου κρατιδίου Μεκλεμβούργο-Δυτική Πομερανία",
      tone: 'semantic',
    },
    {
      german: "heißt",
      translated: "είναι",
      tone: 'semantic',
    },
  ],
  "lid:state:MV:7|en": [
    {
      german: "Die Landeshauptstadt",
      translated: "The state capital",
      tone: 'semantic',
    },
    {
      german: "von Mecklenburg-Vorpommern",
      translated: "of Mecklenburg-Vorpommern",
      tone: 'semantic',
    },
    {
      german: "heißt",
      translated: "is called",
      tone: 'semantic',
    },
  ],
  "lid:state:MV:7|es": [
    {
      german: "Die Landeshauptstadt",
      translated: "La capital del estado federado",
      tone: 'semantic',
    },
    {
      german: "von Mecklenburg-Vorpommern",
      translated: "de Mecklemburgo-Pomerania Occidental",
      tone: 'semantic',
    },
    {
      german: "heißt",
      translated: "es",
      tone: 'semantic',
    },
  ],
  "lid:state:MV:7|fa": [
    {
      german: "Die Landeshauptstadt",
      translated: "مرکز ایالت",
      tone: 'semantic',
    },
    {
      german: "von Mecklenburg-Vorpommern",
      translated: "مکلنبورگ-فورپومرن",
      tone: 'semantic',
    },
  ],
  "lid:state:MV:7|fr": [
    {
      german: "Die Landeshauptstadt",
      translated: "La capitale",
      tone: 'semantic',
    },
    {
      german: "von Mecklenburg-Vorpommern",
      translated: "du Land de Mecklembourg-Poméranie-Occidentale",
      tone: 'semantic',
    },
    {
      german: "heißt",
      translated: "s’appelle",
      tone: 'semantic',
    },
  ],
  "lid:state:MV:7|hr": [
    {
      german: "Die Landeshauptstadt",
      translated: "Glavni grad",
      tone: 'semantic',
    },
    {
      german: "von Mecklenburg-Vorpommern",
      translated: "savezne zemlje Mecklenburg-Zapadno Pomorje",
      tone: 'semantic',
    },
    {
      german: "heißt",
      translated: "je",
      tone: 'semantic',
    },
  ],
  "lid:state:MV:7|it": [
    {
      german: "Die Landeshauptstadt",
      translated: "La capitale del Land di",
      tone: 'semantic',
    },
    {
      german: "von Mecklenburg-Vorpommern",
      translated: "Meclemburgo-Pomerania Anteriore",
      tone: 'semantic',
    },
    {
      german: "heißt",
      translated: "è",
      tone: 'semantic',
    },
  ],
  "lid:state:MV:7|kmr": [
    {
      german: "Die Landeshauptstadt",
      translated: "Paytexta eyaleta",
      tone: 'semantic',
    },
    {
      german: "von Mecklenburg-Vorpommern",
      translated: "Mecklenburg-Vorpommern",
      tone: 'semantic',
    },
  ],
  "lid:state:MV:7|pl": [
    {
      german: "Die Landeshauptstadt",
      translated: "Stolicą kraju",
      tone: 'semantic',
    },
    {
      german: "von Mecklenburg-Vorpommern",
      translated: "Meklemburgia-Pomorze Przednie",
      tone: 'semantic',
    },
    {
      german: "heißt",
      translated: "jest",
      tone: 'semantic',
    },
  ],
  "lid:state:MV:7|prs": [
    {
      german: "Die Landeshauptstadt",
      translated: "مرکز ایالت",
      tone: 'semantic',
    },
    {
      german: "von Mecklenburg-Vorpommern",
      translated: "مکلنبورگ-فورپومرن",
      tone: 'semantic',
    },
  ],
  "lid:state:MV:7|ro": [
    {
      german: "Die Landeshauptstadt",
      translated: "Capitala",
      tone: 'semantic',
    },
    {
      german: "von Mecklenburg-Vorpommern",
      translated: "landului Mecklenburg-Pomerania",
      tone: 'semantic',
    },
    {
      german: "heißt",
      translated: "este",
      tone: 'semantic',
    },
  ],
  "lid:state:MV:7|ru": [
    {
      german: "Die Landeshauptstadt",
      translated: "Столица земли",
      tone: 'semantic',
    },
    {
      german: "von Mecklenburg-Vorpommern",
      translated: "Мекленбург-Передняя Померания",
      tone: 'semantic',
    },
    {
      german: "heißt",
      translated: "называется",
      tone: 'semantic',
    },
  ],
  "lid:state:MV:7|sq": [
    {
      german: "Die Landeshauptstadt",
      translated: "Kryeqyteti i landit",
      tone: 'semantic',
    },
    {
      german: "von Mecklenburg-Vorpommern",
      translated: "Mecklenburg-Vorpommern",
      tone: 'semantic',
    },
    {
      german: "heißt",
      translated: "është",
      tone: 'semantic',
    },
  ],
  "lid:state:MV:7|sr": [
    {
      german: "Die Landeshauptstadt",
      translated: "Glavni grad",
      tone: 'semantic',
    },
    {
      german: "von Mecklenburg-Vorpommern",
      translated: "savezne pokrajine Meklenburg-Zapadna Pomeranija",
      tone: 'semantic',
    },
    {
      german: "heißt",
      translated: "je",
      tone: 'semantic',
    },
  ],
  "lid:state:MV:7|tr": [
    {
      german: "Die Landeshauptstadt",
      translated: "başkenti",
      tone: 'semantic',
    },
    {
      german: "von Mecklenburg-Vorpommern",
      translated: "Mecklenburg-Vorpommern eyaletinin",
      tone: 'semantic',
    },
  ],
  "lid:state:MV:7|uk": [
    {
      german: "Die Landeshauptstadt",
      translated: "Столиця федеральної землі",
      tone: 'semantic',
    },
    {
      german: "von Mecklenburg-Vorpommern",
      translated: "Мекленбург-Передня Померанія",
      tone: 'semantic',
    },
    {
      german: "heißt",
      translated: "називається",
      tone: 'semantic',
    },
  ],
  "lid:state:MV:7|vi": [
    {
      german: "Die Landeshauptstadt",
      translated: "Thủ phủ",
      tone: 'semantic',
    },
    {
      german: "von Mecklenburg-Vorpommern",
      translated: "của bang Mecklenburg-Vorpommern",
      tone: 'semantic',
    },
    {
      german: "heißt",
      translated: "là",
      tone: 'semantic',
    },
  ],
  "lid:state:MV:8|ar": [
    {
      german: "Welches Bundesland",
      translated: "أي صورة",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "تمثل موقع ولاية",
      tone: 'semantic',
    },
    {
      german: "Mecklenburg-Vorpommern",
      translated: "Mecklenburg-Vorpommern",
      tone: 'semantic',
    },
  ],
  "lid:state:MV:8|bg": [
    {
      german: "Welches Bundesland",
      translated: "Коя от показаните федерални провинции",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "е",
      tone: 'semantic',
    },
    {
      german: "Mecklenburg-Vorpommern",
      translated: "Мекленбург-Предна Померания",
      tone: 'semantic',
    },
  ],
  "lid:state:MV:8|bs": [
    {
      german: "Welches Bundesland",
      translated: "Koja od prikazanih saveznih zemalja",
      tone: 'semantic',
    },
    {
      german: "Mecklenburg-Vorpommern",
      translated: "Mecklenburg-Zapadno Pomorje",
      tone: 'semantic',
    },
  ],
  "lid:state:MV:8|el": [
    {
      german: "Welches Bundesland",
      translated: "Ποιο από τα εικονιζόμενα κρατίδια",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "είναι",
      tone: 'semantic',
    },
    {
      german: "Mecklenburg-Vorpommern",
      translated: "Μεκλεμβούργο-Δυτική Πομερανία",
      tone: 'semantic',
    },
  ],
  "lid:state:MV:8|en": [
    {
      german: "Welches Bundesland",
      translated: "Which",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "is",
      tone: 'semantic',
    },
    {
      german: "Mecklenburg-Vorpommern",
      translated: "Mecklenburg-Vorpommern",
      tone: 'semantic',
    },
  ],
  "lid:state:MV:8|es": [
    {
      german: "Welches Bundesland",
      translated: "estado federado",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "corresponde al",
      tone: 'semantic',
    },
    {
      german: "Mecklenburg-Vorpommern",
      translated: "Mecklemburgo-Pomerania Occidental",
      tone: 'semantic',
    },
  ],
  "lid:state:MV:8|fa": [
    {
      german: "Welches Bundesland",
      translated: "ایالتِ نشان‌داده‌شده",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "است",
      tone: 'semantic',
    },
    {
      german: "Mecklenburg-Vorpommern",
      translated: "مکلنبورگ-فورپومرن",
      tone: 'semantic',
    },
  ],
  "lid:state:MV:8|fr": [
    {
      german: "Welches Bundesland",
      translated: "Quel Land",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "représenté",
      tone: 'semantic',
    },
    {
      german: "Mecklenburg-Vorpommern",
      translated: "Mecklembourg-Poméranie-Occidentale",
      tone: 'semantic',
    },
  ],
  "lid:state:MV:8|hr": [
    {
      german: "Welches Bundesland",
      translated: "Koja od prikazanih saveznih zemalja",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "je",
      tone: 'semantic',
    },
    {
      german: "Mecklenburg-Vorpommern",
      translated: "Mecklenburg-Zapadno Pomorje",
      tone: 'semantic',
    },
  ],
  "lid:state:MV:8|it": [
    {
      german: "Welches Bundesland",
      translated: "Quale Land rappresentato",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "è",
      tone: 'semantic',
    },
    {
      german: "Mecklenburg-Vorpommern",
      translated: "Meclemburgo-Pomerania Anteriore",
      tone: 'semantic',
    },
  ],
  "lid:state:MV:8|kmr": [
    {
      german: "Welches Bundesland",
      translated: "Kîjan eyalet",
      tone: 'semantic',
    },
    {
      german: "Mecklenburg-Vorpommern",
      translated: "Mecklenburg-Vorpommern",
      tone: 'semantic',
    },
  ],
  "lid:state:MV:8|pl": [
    {
      german: "Welches Bundesland",
      translated: "Który z przedstawionych krajów związkowych",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "to",
      tone: 'semantic',
    },
    {
      german: "Mecklenburg-Vorpommern",
      translated: "Meklemburgia-Pomorze Przednie",
      tone: 'semantic',
    },
  ],
  "lid:state:MV:8|prs": [
    {
      german: "Welches Bundesland",
      translated: "کدام ایالتِ",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "است",
      tone: 'semantic',
    },
    {
      german: "Mecklenburg-Vorpommern",
      translated: "مکلنبورگ-فورپومرن",
      tone: 'semantic',
    },
  ],
  "lid:state:MV:8|ro": [
    {
      german: "Welches Bundesland",
      translated: "Care land reprezentat",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "este",
      tone: 'semantic',
    },
    {
      german: "Mecklenburg-Vorpommern",
      translated: "Mecklenburg-Pomerania Inferioară",
      tone: 'semantic',
    },
  ],
  "lid:state:MV:8|ru": [
    {
      german: "Welches Bundesland",
      translated: "Какая из этих земель",
      tone: 'semantic',
    },
    {
      german: "Mecklenburg-Vorpommern",
      translated: "Мекленбург-Передняя Померания",
      tone: 'semantic',
    },
  ],
  "lid:state:MV:8|sq": [
    {
      german: "Welches Bundesland",
      translated: "Cili nga landet e paraqitura",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "është",
      tone: 'semantic',
    },
    {
      german: "Mecklenburg-Vorpommern",
      translated: "Mecklenburg-Vorpommern",
      tone: 'semantic',
    },
  ],
  "lid:state:MV:8|sr": [
    {
      german: "ist",
      translated: "je",
      tone: 'semantic',
    },
    {
      german: "Mecklenburg-Vorpommern",
      translated: "Meklenburg-Zapadna Pomeranija",
      tone: 'semantic',
    },
  ],
  "lid:state:MV:8|tr": [
    {
      german: "Welches Bundesland",
      translated: "hangi numarayla",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "gösterilmiştir",
      tone: 'semantic',
    },
    {
      german: "Mecklenburg-Vorpommern",
      translated: "Mecklenburg-Vorpommern",
      tone: 'semantic',
    },
  ],
  "lid:state:MV:8|uk": [
    {
      german: "Welches Bundesland",
      translated: "Яка з позначених федеральних земель",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "є",
      tone: 'semantic',
    },
    {
      german: "Mecklenburg-Vorpommern",
      translated: "Мекленбург-Передня Померанія",
      tone: 'semantic',
    },
  ],
  "lid:state:MV:8|vi": [
    {
      german: "Welches Bundesland",
      translated: "Bang nào trong các hình",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "được",
      tone: 'semantic',
    },
    {
      german: "Mecklenburg-Vorpommern",
      translated: "Mecklenburg-Vorpommern",
      tone: 'semantic',
    },
  ],
  "lid:state:MV:9|ar": [
    {
      german: "Wie nennt man",
      translated: "ماذا يُسمى",
      tone: 'semantic',
    },
    {
      german: "die Regierungschefin/den Regierungschef",
      translated: "رئيس/رئيسة حكومة",
      tone: 'semantic',
    },
    {
      german: "in Mecklenburg-Vorpommern",
      translated: "ولاية Mecklenburg-Vorpommern",
      tone: 'semantic',
    },
  ],
  "lid:state:MV:9|bg": [
    {
      german: "Wie nennt man",
      translated: "Как се нарича",
      tone: 'semantic',
    },
    {
      german: "die Regierungschefin/den Regierungschef",
      translated: "ръководителят на правителството",
      tone: 'semantic',
    },
    {
      german: "in Mecklenburg-Vorpommern",
      translated: "на провинция Мекленбург-Предна Померания",
      tone: 'semantic',
    },
  ],
  "lid:state:MV:9|bs": [
    {
      german: "Wie nennt man",
      translated: "Kako se zove",
      tone: 'semantic',
    },
    {
      german: "die Regierungschefin/den Regierungschef",
      translated: "šef vlade",
      tone: 'semantic',
    },
    {
      german: "in Mecklenburg-Vorpommern",
      translated: "savezne zemlje Mecklenburg-Zapadno Pomorje",
      tone: 'semantic',
    },
  ],
  "lid:state:MV:9|el": [
    {
      german: "Wie nennt man",
      translated: "Πώς ονομάζεται",
      tone: 'semantic',
    },
    {
      german: "die Regierungschefin/den Regierungschef",
      translated: "ο επικεφαλής της κυβέρνησης",
      tone: 'semantic',
    },
    {
      german: "in Mecklenburg-Vorpommern",
      translated: "του κρατιδίου Μεκλεμβούργο-Δυτική Πομερανία;",
      tone: 'semantic',
    },
  ],
  "lid:state:MV:9|en": [
    {
      german: "Wie nennt man",
      translated: "What is",
      tone: 'semantic',
    },
    {
      german: "die Regierungschefin/den Regierungschef",
      translated: "the head of government",
      tone: 'semantic',
    },
    {
      german: "in Mecklenburg-Vorpommern",
      translated: "in Mecklenburg-Vorpommern",
      tone: 'semantic',
    },
  ],
  "lid:state:MV:9|es": [
    {
      german: "Wie nennt man",
      translated: "¿Cómo se llama",
      tone: 'semantic',
    },
    {
      german: "die Regierungschefin/den Regierungschef",
      translated: "al jefe o la jefa de gobierno",
      tone: 'semantic',
    },
    {
      german: "in Mecklenburg-Vorpommern",
      translated: "de Mecklemburgo-Pomerania Occidental",
      tone: 'semantic',
    },
  ],
  "lid:state:MV:9|fa": [
    {
      german: "Wie nennt man",
      translated: "رئیس دولت ایالت",
      tone: 'semantic',
    },
    {
      german: "die Regierungschefin/den Regierungschef",
      translated: "مکلنبورگ-فورپومرن چه عنوانی دارد",
      tone: 'semantic',
    },
    {
      german: "in Mecklenburg-Vorpommern",
      translated: "؟",
      tone: 'semantic',
    },
  ],
  "lid:state:MV:9|fr": [
    {
      german: "Wie nennt man",
      translated: "Comment appelle-t-on",
      tone: 'semantic',
    },
    {
      german: "die Regierungschefin/den Regierungschef",
      translated: "le chef ou la cheffe du gouvernement",
      tone: 'semantic',
    },
    {
      german: "in Mecklenburg-Vorpommern",
      translated: "de Mecklembourg-Poméranie-Occidentale",
      tone: 'semantic',
    },
  ],
  "lid:state:MV:9|hr": [
    {
      german: "Wie nennt man",
      translated: "Kako se zove",
      tone: 'semantic',
    },
    {
      german: "die Regierungschefin/den Regierungschef",
      translated: "čelnik vlade",
      tone: 'semantic',
    },
    {
      german: "in Mecklenburg-Vorpommern",
      translated: "savezne zemlje Mecklenburg-Zapadno Pomorje",
      tone: 'semantic',
    },
  ],
  "lid:state:MV:9|it": [
    {
      german: "Wie nennt man",
      translated: "Come si chiama",
      tone: 'semantic',
    },
    {
      german: "die Regierungschefin/den Regierungschef",
      translated: "il capo del governo",
      tone: 'semantic',
    },
    {
      german: "in Mecklenburg-Vorpommern",
      translated: "del Land di Meclemburgo-Pomerania Anteriore",
      tone: 'semantic',
    },
  ],
  "lid:state:MV:9|kmr": [
    {
      german: "Wie nennt man",
      translated: "Serokê",
      tone: 'semantic',
    },
    {
      german: "die Regierungschefin/den Regierungschef",
      translated: "hukûmeta",
      tone: 'semantic',
    },
    {
      german: "in Mecklenburg-Vorpommern",
      translated: "Mecklenburg-Vorpommern",
      tone: 'semantic',
    },
  ],
  "lid:state:MV:9|pl": [
    {
      german: "Wie nennt man",
      translated: "Jak nazywa się",
      tone: 'semantic',
    },
    {
      german: "die Regierungschefin/den Regierungschef",
      translated: "szef rządu",
      tone: 'semantic',
    },
    {
      german: "in Mecklenburg-Vorpommern",
      translated: "Meklemburgia-Pomorze Przednie",
      tone: 'semantic',
    },
  ],
  "lid:state:MV:9|prs": [
    {
      german: "Wie nennt man",
      translated: "چه عنوانی دارد؟",
      tone: 'semantic',
    },
    {
      german: "die Regierungschefin/den Regierungschef",
      translated: "رئیس دولت",
      tone: 'semantic',
    },
    {
      german: "in Mecklenburg-Vorpommern",
      translated: "ایالت مکلنبورگ-فورپومرن",
      tone: 'semantic',
    },
  ],
  "lid:state:MV:9|ro": [
    {
      german: "Wie nennt man",
      translated: "Cum se numește",
      tone: 'semantic',
    },
    {
      german: "die Regierungschefin/den Regierungschef",
      translated: "șeful guvernului",
      tone: 'semantic',
    },
    {
      german: "in Mecklenburg-Vorpommern",
      translated: "landului Mecklenburg-Pomerania Inferioară",
      tone: 'semantic',
    },
  ],
  "lid:state:MV:9|ru": [
    {
      german: "Wie nennt man",
      translated: "Как называют",
      tone: 'semantic',
    },
    {
      german: "die Regierungschefin/den Regierungschef",
      translated: "главу правительства",
      tone: 'semantic',
    },
    {
      german: "in Mecklenburg-Vorpommern",
      translated: "в федеральной земле Мекленбург-Передняя Померания",
      tone: 'semantic',
    },
  ],
  "lid:state:MV:9|sq": [
    {
      german: "Wie nennt man",
      translated: "Si quhet",
      tone: 'semantic',
    },
    {
      german: "die Regierungschefin/den Regierungschef",
      translated: "kreu i qeverisë së landit",
      tone: 'semantic',
    },
    {
      german: "in Mecklenburg-Vorpommern",
      translated: "Mecklenburg-Vorpommern",
      tone: 'semantic',
    },
  ],
  "lid:state:MV:9|sr": [
    {
      german: "Wie nennt man",
      translated: "Kako se zove",
      tone: 'semantic',
    },
    {
      german: "die Regierungschefin/den Regierungschef",
      translated: "šef vlade",
      tone: 'semantic',
    },
    {
      german: "in Mecklenburg-Vorpommern",
      translated: "savezne pokrajine Meklenburg-Zapadna Pomeranija",
      tone: 'semantic',
    },
  ],
  "lid:state:MV:9|tr": [
    {
      german: "Wie nennt man",
      translated: "ne ad verilir",
      tone: 'semantic',
    },
    {
      german: "die Regierungschefin/den Regierungschef",
      translated: "hükümetinin başındaki kişiye",
      tone: 'semantic',
    },
    {
      german: "in Mecklenburg-Vorpommern",
      translated: "Mecklenburg-Vorpommern",
      tone: 'semantic',
    },
  ],
  "lid:state:MV:9|uk": [
    {
      german: "Wie nennt man",
      translated: "Як називають",
      tone: 'semantic',
    },
    {
      german: "die Regierungschefin/den Regierungschef",
      translated: "главу уряду",
      tone: 'semantic',
    },
    {
      german: "in Mecklenburg-Vorpommern",
      translated: "федеральної землі Мекленбург-Передня Померанія",
      tone: 'semantic',
    },
  ],
  "lid:state:MV:9|vi": [
    {
      german: "Wie nennt man",
      translated: "được gọi là",
      tone: 'semantic',
    },
    {
      german: "die Regierungschefin/den Regierungschef",
      translated: "Người đứng đầu chính phủ",
      tone: 'semantic',
    },
    {
      german: "in Mecklenburg-Vorpommern",
      translated: "bang Mecklenburg-Vorpommern",
      tone: 'semantic',
    },
  ],
  "lid:state:NI:10|ar": [
    {
      german: "Welche Ministerin",
      translated: "أي وزارة",
      tone: 'semantic',
    },
    {
      german: "welchen Minister",
      translated: "من الوزارات التالية",
      tone: 'semantic',
    },
    {
      german: "Niedersachsen",
      translated: "ولاية Niedersachsen",
      tone: 'semantic',
    },
    {
      german: "nicht",
      translated: "غير موجودة",
      tone: 'semantic',
    },
  ],
  "lid:state:NI:10|bg": [
    {
      german: "Welche Ministerin",
      translated: "Кой министър",
      tone: 'semantic',
    },
    {
      german: "Niedersachsen",
      translated: "Долна Саксония",
      tone: 'semantic',
    },
    {
      german: "nicht",
      translated: "не съществува",
      tone: 'semantic',
    },
  ],
  "lid:state:NI:10|bs": [
    {
      german: "welchen Minister",
      translated: "Koji ministar",
      tone: 'semantic',
    },
    {
      german: "Niedersachsen",
      translated: "na razini savezne zemlje Donja Saksonija",
      tone: 'semantic',
    },
    {
      german: "nicht",
      translated: "ne postoji",
      tone: 'semantic',
    },
  ],
  "lid:state:NI:10|el": [
    {
      german: "Welche Ministerin",
      translated: "Ποιος",
      tone: 'semantic',
    },
    {
      german: "welchen Minister",
      translated: "υπουργός",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "υπάρχει",
      tone: 'semantic',
    },
    {
      german: "Niedersachsen",
      translated: "Κάτω Σαξονία",
      tone: 'semantic',
    },
    {
      german: "nicht",
      translated: "δεν",
      tone: 'semantic',
    },
  ],
  "lid:state:NI:10|en": [
    {
      german: "Welche Ministerin",
      translated: "Which minister",
      tone: 'semantic',
    },
    {
      german: "welchen Minister",
      translated: "does",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "have",
      tone: 'semantic',
    },
    {
      german: "Niedersachsen",
      translated: "Niedersachsen",
      tone: 'semantic',
    },
    {
      german: "nicht",
      translated: "not",
      tone: 'semantic',
    },
  ],
  "lid:state:NI:10|es": [
    {
      german: "Welche Ministerin",
      translated: "¿Qué",
      tone: 'semantic',
    },
    {
      german: "welchen Minister",
      translated: "ministerio",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "existe",
      tone: 'semantic',
    },
    {
      german: "Niedersachsen",
      translated: "Baja Sajonia",
      tone: 'semantic',
    },
    {
      german: "nicht",
      translated: "NO",
      tone: 'semantic',
    },
  ],
  "lid:state:NI:10|fa": [
    {
      german: "Welche Ministerin",
      translated: "کدام",
      tone: 'semantic',
    },
    {
      german: "welchen Minister",
      translated: "وزیر",
      tone: 'semantic',
    },
    {
      german: "Niedersachsen",
      translated: "نیدرزاکسن",
      tone: 'semantic',
    },
    {
      german: "nicht",
      translated: "وجود ندارد",
      tone: 'semantic',
    },
  ],
  "lid:state:NI:10|fr": [
    {
      german: "Welche Ministerin",
      translated: "quelle ministre",
      tone: 'semantic',
    },
    {
      german: "welchen Minister",
      translated: "Quel ministre",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "existe",
      tone: 'semantic',
    },
    {
      german: "Niedersachsen",
      translated: "Basse-Saxe",
      tone: 'semantic',
    },
    {
      german: "nicht",
      translated: "pas",
      tone: 'semantic',
    },
  ],
  "lid:state:NI:10|hr": [
    {
      german: "Welche Ministerin",
      translated: "Koji",
      tone: 'semantic',
    },
    {
      german: "welchen Minister",
      translated: "ministar",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "postoji",
      tone: 'semantic',
    },
    {
      german: "Niedersachsen",
      translated: "na razini savezne zemlje Donja Saska",
      tone: 'semantic',
    },
    {
      german: "nicht",
      translated: "ne",
      tone: 'semantic',
    },
  ],
  "lid:state:NI:10|it": [
    {
      german: "welchen Minister",
      translated: "Quale ministro",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "non esiste",
      tone: 'semantic',
    },
    {
      german: "Niedersachsen",
      translated: "Bassa Sassonia",
      tone: 'semantic',
    },
  ],
  "lid:state:NI:10|kmr": [
    {
      german: "Welche Ministerin",
      translated: "Kîjan wezîr",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "ye",
      tone: 'semantic',
    },
    {
      german: "Niedersachsen",
      translated: "Niedersachsen",
      tone: 'semantic',
    },
    {
      german: "nicht",
      translated: "tune",
      tone: 'semantic',
    },
  ],
  "lid:state:NI:10|pl": [
    {
      german: "welchen Minister",
      translated: "Którego ministra",
      tone: 'semantic',
    },
    {
      german: "Niedersachsen",
      translated: "Dolna Saksonia",
      tone: 'semantic',
    },
    {
      german: "nicht",
      translated: "nie ma",
      tone: 'semantic',
    },
  ],
  "lid:state:NI:10|prs": [
    {
      german: "Welche Ministerin",
      translated: "کدام",
      tone: 'semantic',
    },
    {
      german: "welchen Minister",
      translated: "وزیر",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "وجود",
      tone: 'semantic',
    },
    {
      german: "Niedersachsen",
      translated: "نیدرزاکسن",
      tone: 'semantic',
    },
    {
      german: "nicht",
      translated: "ندارد",
      tone: 'semantic',
    },
  ],
  "lid:state:NI:10|ro": [
    {
      german: "Welche Ministerin",
      translated: "Care ministru",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "există",
      tone: 'semantic',
    },
    {
      german: "Niedersachsen",
      translated: "landului Saxonia Inferioară",
      tone: 'semantic',
    },
    {
      german: "nicht",
      translated: "nu",
      tone: 'semantic',
    },
  ],
  "lid:state:NI:10|ru": [
    {
      german: "Welche Ministerin",
      translated: "Какого министра",
      tone: 'semantic',
    },
    {
      german: "welchen Minister",
      translated: "в федеральной земле",
      tone: 'semantic',
    },
    {
      german: "Niedersachsen",
      translated: "Нижняя Саксония",
      tone: 'semantic',
    },
    {
      german: "nicht",
      translated: "нет",
      tone: 'semantic',
    },
  ],
  "lid:state:NI:10|sq": [
    {
      german: "welchen Minister",
      translated: "Cili ministër",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "ekziston",
      tone: 'semantic',
    },
    {
      german: "Niedersachsen",
      translated: "nivelin e landit Niedersachsen",
      tone: 'semantic',
    },
    {
      german: "nicht",
      translated: "nuk",
      tone: 'semantic',
    },
  ],
  "lid:state:NI:10|sr": [
    {
      german: "Welche Ministerin",
      translated: "Koji",
      tone: 'semantic',
    },
    {
      german: "welchen Minister",
      translated: "ministar",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "postoji",
      tone: 'semantic',
    },
    {
      german: "Niedersachsen",
      translated: "na razini savezne pokrajine Donja Saksonija",
      tone: 'semantic',
    },
    {
      german: "nicht",
      translated: "ne",
      tone: 'semantic',
    },
  ],
  "lid:state:NI:10|tr": [
    {
      german: "Welche Ministerin",
      translated: "aşağıdaki bakanlıklardan hangisi",
      tone: 'semantic',
    },
    {
      german: "Niedersachsen",
      translated: "Niedersachsen eyaletinde",
      tone: 'semantic',
    },
    {
      german: "nicht",
      translated: "yoktur",
      tone: 'semantic',
    },
  ],
  "lid:state:NI:10|uk": [
    {
      german: "Welche Ministerin",
      translated: "міністерки",
      tone: 'semantic',
    },
    {
      german: "welchen Minister",
      translated: "міністра",
      tone: 'semantic',
    },
    {
      german: "Niedersachsen",
      translated: "Нижня Саксонія",
      tone: 'semantic',
    },
    {
      german: "nicht",
      translated: "немає",
      tone: 'semantic',
    },
  ],
  "lid:state:NI:10|vi": [
    {
      german: "welchen Minister",
      translated: "Bộ trưởng nào",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "tồn tại",
      tone: 'semantic',
    },
    {
      german: "Niedersachsen",
      translated: "Niedersachsen",
      tone: 'semantic',
    },
    {
      german: "nicht",
      translated: "không",
      tone: 'semantic',
    },
  ],
  "lid:state:NI:1|ar": [
    {
      german: "Welches Wappen",
      translated: "أي شعار",
      tone: 'semantic',
    },
    {
      german: "gehört zum",
      translated: "يعود إلى",
      tone: 'semantic',
    },
    {
      german: "Bundesland Niedersachsen",
      translated: "ولاية Niedersachsen",
      tone: 'semantic',
    },
  ],
  "lid:state:NI:1|bg": [
    {
      german: "Welches Wappen",
      translated: "Кой герб",
      tone: 'semantic',
    },
    {
      german: "gehört zum",
      translated: "принадлежи на",
      tone: 'semantic',
    },
    {
      german: "Bundesland Niedersachsen",
      translated: "федералната провинция Долна Саксония",
      tone: 'semantic',
    },
  ],
  "lid:state:NI:1|bs": [
    {
      german: "Welches Wappen",
      translated: "Koji grb",
      tone: 'semantic',
    },
    {
      german: "gehört zum",
      translated: "pripada",
      tone: 'semantic',
    },
    {
      german: "Bundesland Niedersachsen",
      translated: "saveznoj zemlji Donja Saksonija",
      tone: 'semantic',
    },
  ],
  "lid:state:NI:1|el": [
    {
      german: "Welches Wappen",
      translated: "Ποιο έμβλημα",
      tone: 'semantic',
    },
    {
      german: "gehört zum",
      translated: "ανήκει στο",
      tone: 'semantic',
    },
    {
      german: "Bundesland Niedersachsen",
      translated: "Κάτω Σαξονία",
      tone: 'semantic',
    },
  ],
  "lid:state:NI:1|en": [
    {
      german: "Welches Wappen",
      translated: "Which coat of arms",
      tone: 'semantic',
    },
    {
      german: "gehört zum",
      translated: "belongs to",
      tone: 'semantic',
    },
    {
      german: "Bundesland Niedersachsen",
      translated: "the federal state of Niedersachsen",
      tone: 'semantic',
    },
  ],
  "lid:state:NI:1|es": [
    {
      german: "Welches Wappen",
      translated: "¿Qué escudo",
      tone: 'semantic',
    },
    {
      german: "gehört zum",
      translated: "pertenece al",
      tone: 'semantic',
    },
    {
      german: "Bundesland Niedersachsen",
      translated: "estado federado de Baja Sajonia",
      tone: 'semantic',
    },
  ],
  "lid:state:NI:1|fa": [
    {
      german: "Welches Wappen",
      translated: "کدام نشان",
      tone: 'semantic',
    },
    {
      german: "gehört zum",
      translated: "متعلق به",
      tone: 'semantic',
    },
    {
      german: "Bundesland Niedersachsen",
      translated: "ایالت نیدرزاکسن",
      tone: 'semantic',
    },
  ],
  "lid:state:NI:1|fr": [
    {
      german: "Welches Wappen",
      translated: "Quel blason",
      tone: 'semantic',
    },
    {
      german: "gehört zum",
      translated: "appartient au",
      tone: 'semantic',
    },
    {
      german: "Bundesland Niedersachsen",
      translated: "Land de Basse-Saxe",
      tone: 'semantic',
    },
  ],
  "lid:state:NI:1|hr": [
    {
      german: "Welches Wappen",
      translated: "Koji grb",
      tone: 'semantic',
    },
    {
      german: "gehört zum",
      translated: "pripada",
      tone: 'semantic',
    },
    {
      german: "Bundesland Niedersachsen",
      translated: "saveznoj zemlji Donja Saska?",
      tone: 'semantic',
    },
  ],
  "lid:state:NI:1|it": [
    {
      german: "Welches Wappen",
      translated: "Quale stemma",
      tone: 'semantic',
    },
    {
      german: "gehört zum",
      translated: "appartiene al",
      tone: 'semantic',
    },
    {
      german: "Bundesland Niedersachsen",
      translated: "Land di Bassa Sassonia",
      tone: 'semantic',
    },
  ],
  "lid:state:NI:1|kmr": [
    {
      german: "Welches Wappen",
      translated: "Kîjan nîşan",
      tone: 'semantic',
    },
    {
      german: "gehört zum",
      translated: "a",
      tone: 'semantic',
    },
    {
      german: "Bundesland Niedersachsen",
      translated: "Niedersachsen ye?",
      tone: 'semantic',
    },
  ],
  "lid:state:NI:1|pl": [
    {
      german: "Welches Wappen",
      translated: "Który herb",
      tone: 'semantic',
    },
    {
      german: "gehört zum",
      translated: "należy do",
      tone: 'semantic',
    },
    {
      german: "Bundesland Niedersachsen",
      translated: "kraju związkowego Dolna Saksonia",
      tone: 'semantic',
    },
  ],
  "lid:state:NI:1|prs": [
    {
      german: "Welches Wappen",
      translated: "کدام نشان",
      tone: 'semantic',
    },
    {
      german: "gehört zum",
      translated: "متعلق به",
      tone: 'semantic',
    },
    {
      german: "Bundesland Niedersachsen",
      translated: "ایالت نیدرزاکسن",
      tone: 'semantic',
    },
  ],
  "lid:state:NI:1|ro": [
    {
      german: "Welches Wappen",
      translated: "Care stemă",
      tone: 'semantic',
    },
    {
      german: "gehört zum",
      translated: "aparține",
      tone: 'semantic',
    },
    {
      german: "Bundesland Niedersachsen",
      translated: "landului Saxonia Inferioară",
      tone: 'semantic',
    },
  ],
  "lid:state:NI:1|ru": [
    {
      german: "Welches Wappen",
      translated: "Какой герб",
      tone: 'semantic',
    },
    {
      german: "gehört zum",
      translated: "принадлежит",
      tone: 'semantic',
    },
    {
      german: "Bundesland Niedersachsen",
      translated: "федеральной земле Нижняя Саксония",
      tone: 'semantic',
    },
  ],
  "lid:state:NI:1|sq": [
    {
      german: "Welches Wappen",
      translated: "Cila stemë",
      tone: 'semantic',
    },
    {
      german: "gehört zum",
      translated: "i përket",
      tone: 'semantic',
    },
    {
      german: "Bundesland Niedersachsen",
      translated: "landit Niedersachsen",
      tone: 'semantic',
    },
  ],
  "lid:state:NI:1|sr": [
    {
      german: "Welches Wappen",
      translated: "Koji grb",
      tone: 'semantic',
    },
    {
      german: "gehört zum",
      translated: "pripada",
      tone: 'semantic',
    },
    {
      german: "Bundesland Niedersachsen",
      translated: "saveznoj pokrajini Donja Saksonija",
      tone: 'semantic',
    },
  ],
  "lid:state:NI:1|tr": [
    {
      german: "Welches Wappen",
      translated: "arması hangisidir",
      tone: 'semantic',
    },
    {
      german: "Bundesland Niedersachsen",
      translated: "Niedersachsen eyaletinin",
      tone: 'semantic',
    },
  ],
  "lid:state:NI:1|uk": [
    {
      german: "Welches Wappen",
      translated: "Який герб",
      tone: 'semantic',
    },
    {
      german: "gehört zum",
      translated: "належить",
      tone: 'semantic',
    },
    {
      german: "Bundesland Niedersachsen",
      translated: "федеральній землі Нижня Саксонія",
      tone: 'semantic',
    },
  ],
  "lid:state:NI:1|vi": [
    {
      german: "Welches Wappen",
      translated: "Quốc huy nào",
      tone: 'semantic',
    },
    {
      german: "gehört zum",
      translated: "thuộc",
      tone: 'semantic',
    },
    {
      german: "Bundesland Niedersachsen",
      translated: "bang Niedersachsen",
      tone: 'semantic',
    },
  ],
  "lid:state:NI:2|ar": [
    {
      german: "Welches",
      translated: "أي",
      tone: 'semantic',
    },
    {
      german: "Landkreis",
      translated: "دائرة إدارية (Landkreis)",
      tone: 'semantic',
    },
    {
      german: "Niedersachsen",
      translated: "في Niedersachsen؟",
      tone: 'semantic',
    },
  ],
  "lid:state:NI:2|bg": [
    {
      german: "Welches",
      translated: "Кое",
      tone: 'semantic',
    },
    {
      german: "Landkreis",
      translated: "окръг",
      tone: 'semantic',
    },
    {
      german: "Niedersachsen",
      translated: "Долна Саксония",
      tone: 'semantic',
    },
  ],
  "lid:state:NI:2|bs": [
    {
      german: "Welches",
      translated: "Što",
      tone: 'semantic',
    },
    {
      german: "Landkreis",
      translated: "okrug",
      tone: 'semantic',
    },
    {
      german: "Niedersachsen",
      translated: "Donja Saksonija",
      tone: 'semantic',
    },
  ],
  "lid:state:NI:2|el": [
    {
      german: "Welches",
      translated: "Ποιο",
      tone: 'semantic',
    },
    {
      german: "Landkreis",
      translated: "διοικητική περιφέρεια",
      tone: 'semantic',
    },
    {
      german: "Niedersachsen",
      translated: "Κάτω Σαξονία",
      tone: 'semantic',
    },
  ],
  "lid:state:NI:2|en": [
    {
      german: "Welches",
      translated: "Which",
      tone: 'semantic',
    },
    {
      german: "Landkreis",
      translated: "district",
      tone: 'semantic',
    },
    {
      german: "Niedersachsen",
      translated: "Niedersachsen",
      tone: 'semantic',
    },
  ],
  "lid:state:NI:2|es": [
    {
      german: "Welches",
      translated: "¿Cuál",
      tone: 'semantic',
    },
    {
      german: "Landkreis",
      translated: "(Landkreis)",
      tone: 'semantic',
    },
    {
      german: "Niedersachsen",
      translated: "Baja Sajonia",
      tone: 'semantic',
    },
  ],
  "lid:state:NI:2|fa": [
    {
      german: "Welches",
      translated: "کدام‌یک",
      tone: 'semantic',
    },
    {
      german: "Landkreis",
      translated: "شهرستان",
      tone: 'semantic',
    },
    {
      german: "Niedersachsen",
      translated: "نیدرزاکسن",
      tone: 'semantic',
    },
  ],
  "lid:state:NI:2|fr": [
    {
      german: "Welches",
      translated: "Lequel des éléments suivants",
      tone: 'semantic',
    },
    {
      german: "Landkreis",
      translated: "arrondissement (Landkreis)",
      tone: 'semantic',
    },
    {
      german: "Niedersachsen",
      translated: "Basse-Saxe",
      tone: 'semantic',
    },
  ],
  "lid:state:NI:2|hr": [
    {
      german: "Welches",
      translated: "Što je od navedenoga",
      tone: 'semantic',
    },
    {
      german: "Landkreis",
      translated: "okrug (Landkreis)",
      tone: 'semantic',
    },
    {
      german: "Niedersachsen",
      translated: "u saveznoj zemlji Donja Saska",
      tone: 'semantic',
    },
  ],
  "lid:state:NI:2|it": [
    {
      german: "Welches",
      translated: "Quale",
      tone: 'semantic',
    },
    {
      german: "Landkreis",
      translated: "distretto",
      tone: 'semantic',
    },
    {
      german: "Niedersachsen",
      translated: "Bassa Sassonia",
      tone: 'semantic',
    },
  ],
  "lid:state:NI:2|kmr": [
    {
      german: "Welches",
      translated: "Kîjan",
      tone: 'semantic',
    },
    {
      german: "Landkreis",
      translated: "Landkreis",
      tone: 'semantic',
    },
    {
      german: "Niedersachsen",
      translated: "Niedersachsen",
      tone: 'semantic',
    },
  ],
  "lid:state:NI:2|pl": [
    {
      german: "Welches",
      translated: "Który",
      tone: 'semantic',
    },
    {
      german: "Landkreis",
      translated: "(Landkreis)",
      tone: 'semantic',
    },
    {
      german: "Niedersachsen",
      translated: "Dolna Saksonia",
      tone: 'semantic',
    },
  ],
  "lid:state:NI:2|prs": [
    {
      german: "Welches",
      translated: "کدام‌یک",
      tone: 'semantic',
    },
    {
      german: "Landkreis",
      translated: "شهرستان",
      tone: 'semantic',
    },
    {
      german: "Niedersachsen",
      translated: "نیدرزاکسن",
      tone: 'semantic',
    },
  ],
  "lid:state:NI:2|ro": [
    {
      german: "Welches",
      translated: "Care dintre",
      tone: 'semantic',
    },
    {
      german: "Landkreis",
      translated: "district (Landkreis)",
      tone: 'semantic',
    },
    {
      german: "Niedersachsen",
      translated: "Saxonia Inferioară",
      tone: 'semantic',
    },
  ],
  "lid:state:NI:2|ru": [
    {
      german: "Welches",
      translated: "Какой",
      tone: 'semantic',
    },
    {
      german: "Landkreis",
      translated: "районом",
      tone: 'semantic',
    },
    {
      german: "Niedersachsen",
      translated: "в федеральной земле Нижняя Саксония",
      tone: 'semantic',
    },
  ],
  "lid:state:NI:2|sq": [
    {
      german: "Welches",
      translated: "Cila nga",
      tone: 'semantic',
    },
    {
      german: "Landkreis",
      translated: "qark (Landkreis)",
      tone: 'semantic',
    },
    {
      german: "Niedersachsen",
      translated: "Niedersachsen",
      tone: 'semantic',
    },
  ],
  "lid:state:NI:2|sr": [
    {
      german: "Welches",
      translated: "Šta",
      tone: 'semantic',
    },
    {
      german: "Landkreis",
      translated: "okrug",
      tone: 'semantic',
    },
    {
      german: "Niedersachsen",
      translated: "Donja Saksonija",
      tone: 'semantic',
    },
  ],
  "lid:state:NI:2|tr": [
    {
      german: "Welches",
      translated: "Aşağıdakilerden hangisi",
      tone: 'semantic',
    },
    {
      german: "Landkreis",
      translated: "bir Landkreis (ilçe/idari bölge)dir",
      tone: 'semantic',
    },
    {
      german: "Niedersachsen",
      translated: "Niedersachsen eyaletinde bulunan",
      tone: 'semantic',
    },
  ],
  "lid:state:NI:2|uk": [
    {
      german: "Welches",
      translated: "Який",
      tone: 'semantic',
    },
    {
      german: "Landkreis",
      translated: "районів",
      tone: 'semantic',
    },
    {
      german: "Niedersachsen",
      translated: "Нижня Саксонія",
      tone: 'semantic',
    },
  ],
  "lid:state:NI:2|vi": [
    {
      german: "Welches",
      translated: "Địa danh nào",
      tone: 'semantic',
    },
    {
      german: "Landkreis",
      translated: "huyện",
      tone: 'semantic',
    },
    {
      german: "Niedersachsen",
      translated: "Niedersachsen",
      tone: 'semantic',
    },
  ],
  "lid:state:NI:3|ar": [
    {
      german: "Für wie viele Jahre",
      translated: "لمدة كم سنة",
      tone: 'semantic',
    },
    {
      german: "der Landtag in Niedersachsen",
      translated: "برلمان الولاية في Niedersachsen",
      tone: 'semantic',
    },
    {
      german: "gewählt",
      translated: "يُنتخب",
      tone: 'semantic',
    },
  ],
  "lid:state:NI:3|bg": [
    {
      german: "Für wie viele Jahre",
      translated: "За колко години",
      tone: 'semantic',
    },
    {
      german: "wird",
      translated: "се",
      tone: 'semantic',
    },
    {
      german: "der Landtag in Niedersachsen",
      translated: "парламентът на провинция Долна Саксония",
      tone: 'semantic',
    },
    {
      german: "gewählt",
      translated: "избира",
      tone: 'semantic',
    },
  ],
  "lid:state:NI:3|bs": [
    {
      german: "Für wie viele Jahre",
      translated: "Na koliko se godina",
      tone: 'semantic',
    },
    {
      german: "der Landtag in Niedersachsen",
      translated: "parlament savezne zemlje Donja Saksonija",
      tone: 'semantic',
    },
    {
      german: "gewählt",
      translated: "bira",
      tone: 'semantic',
    },
  ],
  "lid:state:NI:3|el": [
    {
      german: "Für wie viele Jahre",
      translated: "Για πόσα χρόνια",
      tone: 'semantic',
    },
    {
      german: "der Landtag in Niedersachsen",
      translated: "το Landtag του Κάτω Σαξονία",
      tone: 'semantic',
    },
    {
      german: "gewählt",
      translated: "εκλέγεται",
      tone: 'semantic',
    },
  ],
  "lid:state:NI:3|en": [
    {
      german: "Für wie viele Jahre",
      translated: "For how many years",
      tone: 'semantic',
    },
    {
      german: "wird",
      translated: "is",
      tone: 'semantic',
    },
    {
      german: "der Landtag in Niedersachsen",
      translated: "the state parliament in Niedersachsen",
      tone: 'semantic',
    },
    {
      german: "gewählt",
      translated: "elected",
      tone: 'semantic',
    },
  ],
  "lid:state:NI:3|es": [
    {
      german: "Für wie viele Jahre",
      translated: "¿Por cuántos años",
      tone: 'semantic',
    },
    {
      german: "wird",
      translated: "se",
      tone: 'semantic',
    },
    {
      german: "der Landtag in Niedersachsen",
      translated: "el parlamento regional en Baja Sajonia",
      tone: 'semantic',
    },
    {
      german: "gewählt",
      translated: "elige",
      tone: 'semantic',
    },
  ],
  "lid:state:NI:3|fa": [
    {
      german: "Für wie viele Jahre",
      translated: "چند سال",
      tone: 'semantic',
    },
    {
      german: "der Landtag in Niedersachsen",
      translated: "پارلمان ایالتی نیدرزاکسن",
      tone: 'semantic',
    },
    {
      german: "gewählt",
      translated: "انتخاب می‌شود",
      tone: 'semantic',
    },
  ],
  "lid:state:NI:3|fr": [
    {
      german: "Für wie viele Jahre",
      translated: "Pour combien d’années",
      tone: 'semantic',
    },
    {
      german: "wird",
      translated: "est-il",
      tone: 'semantic',
    },
    {
      german: "der Landtag in Niedersachsen",
      translated: "le Landtag de Basse-Saxe",
      tone: 'semantic',
    },
    {
      german: "gewählt",
      translated: "élu",
      tone: 'semantic',
    },
  ],
  "lid:state:NI:3|hr": [
    {
      german: "Für wie viele Jahre",
      translated: "Na koliko se godina",
      tone: 'semantic',
    },
    {
      german: "der Landtag in Niedersachsen",
      translated: "parlament savezne zemlje Donja Saska",
      tone: 'semantic',
    },
    {
      german: "gewählt",
      translated: "bira",
      tone: 'semantic',
    },
  ],
  "lid:state:NI:3|it": [
    {
      german: "Für wie viele Jahre",
      translated: "Per quanti anni",
      tone: 'semantic',
    },
    {
      german: "wird",
      translated: "viene",
      tone: 'semantic',
    },
    {
      german: "der Landtag in Niedersachsen",
      translated: "il Landtag di Bassa Sassonia",
      tone: 'semantic',
    },
    {
      german: "gewählt",
      translated: "eletto",
      tone: 'semantic',
    },
  ],
  "lid:state:NI:3|kmr": [
    {
      german: "Für wie viele Jahre",
      translated: "çend salan",
      tone: 'semantic',
    },
    {
      german: "wird",
      translated: "ji",
      tone: 'semantic',
    },
    {
      german: "der Landtag in Niedersachsen",
      translated: "Landtag a Niedersachsen",
      tone: 'semantic',
    },
    {
      german: "gewählt",
      translated: "tê hilbijartin",
      tone: 'semantic',
    },
  ],
  "lid:state:NI:3|pl": [
    {
      german: "Für wie viele Jahre",
      translated: "Na ile lat",
      tone: 'semantic',
    },
    {
      german: "wird",
      translated: "jest",
      tone: 'semantic',
    },
    {
      german: "der Landtag in Niedersachsen",
      translated: "parlament kraju związkowego Dolna Saksonia",
      tone: 'semantic',
    },
    {
      german: "gewählt",
      translated: "wybierany",
      tone: 'semantic',
    },
  ],
  "lid:state:NI:3|prs": [
    {
      german: "Für wie viele Jahre",
      translated: "چند سال",
      tone: 'semantic',
    },
    {
      german: "wird",
      translated: "می‌شود",
      tone: 'semantic',
    },
    {
      german: "der Landtag in Niedersachsen",
      translated: "پارلمان ایالتی نیدرزاکسن",
      tone: 'semantic',
    },
  ],
  "lid:state:NI:3|ro": [
    {
      german: "Für wie viele Jahre",
      translated: "Pentru câți ani",
      tone: 'semantic',
    },
    {
      german: "wird",
      translated: "este",
      tone: 'semantic',
    },
    {
      german: "der Landtag in Niedersachsen",
      translated: "parlamentul landului Saxonia Inferioară",
      tone: 'semantic',
    },
    {
      german: "gewählt",
      translated: "ales",
      tone: 'semantic',
    },
  ],
  "lid:state:NI:3|ru": [
    {
      german: "Für wie viele Jahre",
      translated: "На сколько лет",
      tone: 'semantic',
    },
    {
      german: "wird",
      translated: "избирается",
      tone: 'semantic',
    },
    {
      german: "der Landtag in Niedersachsen",
      translated: "ландтаг в федеральной земле Нижняя Саксония",
      tone: 'semantic',
    },
  ],
  "lid:state:NI:3|sq": [
    {
      german: "Für wie viele Jahre",
      translated: "Për sa vjet",
      tone: 'semantic',
    },
    {
      german: "der Landtag in Niedersachsen",
      translated: "Landtagu i Niedersachsen",
      tone: 'semantic',
    },
    {
      german: "gewählt",
      translated: "zgjidhet",
      tone: 'semantic',
    },
  ],
  "lid:state:NI:3|sr": [
    {
      german: "Für wie viele Jahre",
      translated: "Na koliko se godina",
      tone: 'semantic',
    },
    {
      german: "der Landtag in Niedersachsen",
      translated: "parlament savezne pokrajine Donja Saksonija",
      tone: 'semantic',
    },
    {
      german: "gewählt",
      translated: "bira",
      tone: 'semantic',
    },
  ],
  "lid:state:NI:3|tr": [
    {
      german: "Für wie viele Jahre",
      translated: "kaç yıllığına",
      tone: 'semantic',
    },
    {
      german: "der Landtag in Niedersachsen",
      translated: "Niedersachsen eyalet parlamentosu",
      tone: 'semantic',
    },
    {
      german: "gewählt",
      translated: "seçilir",
      tone: 'semantic',
    },
  ],
  "lid:state:NI:3|uk": [
    {
      german: "Für wie viele Jahre",
      translated: "На скільки років",
      tone: 'semantic',
    },
    {
      german: "der Landtag in Niedersachsen",
      translated: "земельний парламент у федеральній землі Нижня Саксонія",
      tone: 'semantic',
    },
    {
      german: "gewählt",
      translated: "обирають",
      tone: 'semantic',
    },
  ],
  "lid:state:NI:3|vi": [
    {
      german: "Für wie viele Jahre",
      translated: "bao nhiêu năm",
      tone: 'semantic',
    },
    {
      german: "der Landtag in Niedersachsen",
      translated: "Nghị viện bang (Landtag) của Niedersachsen",
      tone: 'semantic',
    },
    {
      german: "gewählt",
      translated: "được bầu",
      tone: 'semantic',
    },
  ],
  "lid:state:NI:4|ar": [
    {
      german: "Ab welchem Alter darf man",
      translated: "ابتداءً من أي سن يحق",
      tone: 'semantic',
    },
    {
      german: "in Niedersachsen bei Kommunalwahlen",
      translated: "في Niedersachsen",
      tone: 'semantic',
    },
    {
      german: "wählen",
      translated: "التصويت",
      tone: 'semantic',
    },
  ],
  "lid:state:NI:4|bg": [
    {
      german: "Ab welchem Alter darf man",
      translated: "От каква възраст може",
      tone: 'semantic',
    },
    {
      german: "in Niedersachsen bei Kommunalwahlen",
      translated: "в Долна Саксония",
      tone: 'semantic',
    },
    {
      german: "wählen",
      translated: "да се гласува",
      tone: 'semantic',
    },
  ],
  "lid:state:NI:4|bs": [
    {
      german: "Ab welchem Alter darf man",
      translated: "Od koje se dobi može glasovati",
      tone: 'semantic',
    },
    {
      german: "in Niedersachsen bei Kommunalwahlen",
      translated: "na lokalnim izborima u saveznoj zemlji Donja Saksonija",
      tone: 'semantic',
    },
  ],
  "lid:state:NI:4|el": [
    {
      german: "Ab welchem Alter darf man",
      translated: "Από ποια ηλικία μπορεί κάποιος",
      tone: 'semantic',
    },
    {
      german: "in Niedersachsen bei Kommunalwahlen",
      translated: "στις δημοτικές εκλογές στο Κάτω Σαξονία;",
      tone: 'semantic',
    },
    {
      german: "wählen",
      translated: "να ψηφίσει",
      tone: 'semantic',
    },
  ],
  "lid:state:NI:4|en": [
    {
      german: "Ab welchem Alter darf man",
      translated: "From what age can you",
      tone: 'semantic',
    },
    {
      german: "in Niedersachsen bei Kommunalwahlen",
      translated: "in Niedersachsen in local elections",
      tone: 'semantic',
    },
    {
      german: "wählen",
      translated: "vote",
      tone: 'semantic',
    },
  ],
  "lid:state:NI:4|es": [
    {
      german: "Ab welchem Alter darf man",
      translated: "¿A partir de qué edad se puede",
      tone: 'semantic',
    },
    {
      german: "in Niedersachsen bei Kommunalwahlen",
      translated: "en las elecciones municipales de Baja Sajonia",
      tone: 'semantic',
    },
    {
      german: "wählen",
      translated: "votar",
      tone: 'semantic',
    },
  ],
  "lid:state:NI:4|fa": [
    {
      german: "Ab welchem Alter darf man",
      translated: "از چه سنی می‌توان",
      tone: 'semantic',
    },
    {
      german: "in Niedersachsen bei Kommunalwahlen",
      translated: "در انتخابات محلی نیدرزاکسن",
      tone: 'semantic',
    },
    {
      german: "wählen",
      translated: "رأی داد",
      tone: 'semantic',
    },
  ],
  "lid:state:NI:4|fr": [
    {
      german: "Ab welchem Alter darf man",
      translated: "À partir de quel âge",
      tone: 'semantic',
    },
    {
      german: "in Niedersachsen bei Kommunalwahlen",
      translated: "en Basse-Saxe",
      tone: 'semantic',
    },
    {
      german: "wählen",
      translated: "voter",
      tone: 'semantic',
    },
  ],
  "lid:state:NI:4|hr": [
    {
      german: "Ab welchem Alter darf man",
      translated: "Od koje se dobi može",
      tone: 'semantic',
    },
    {
      german: "in Niedersachsen bei Kommunalwahlen",
      translated: "na lokalnim izborima u saveznoj zemlji Donja Saska",
      tone: 'semantic',
    },
    {
      german: "wählen",
      translated: "glasovati",
      tone: 'semantic',
    },
  ],
  "lid:state:NI:4|it": [
    {
      german: "Ab welchem Alter darf man",
      translated: "Da quale età",
      tone: 'semantic',
    },
    {
      german: "in Niedersachsen bei Kommunalwahlen",
      translated: "alle elezioni comunali in Bassa Sassonia",
      tone: 'semantic',
    },
    {
      german: "wählen",
      translated: "votare",
      tone: 'semantic',
    },
  ],
  "lid:state:NI:4|kmr": [
    {
      german: "Ab welchem Alter darf man",
      translated: "Ji kîjan temenê",
      tone: 'semantic',
    },
    {
      german: "in Niedersachsen bei Kommunalwahlen",
      translated: "li Niedersachsen di hilbijartinên şaredariyê de",
      tone: 'semantic',
    },
    {
      german: "wählen",
      translated: "deng were dayîn",
      tone: 'semantic',
    },
  ],
  "lid:state:NI:4|pl": [
    {
      german: "Ab welchem Alter darf man",
      translated: "Od jakiego wieku",
      tone: 'semantic',
    },
    {
      german: "in Niedersachsen bei Kommunalwahlen",
      translated: "w wyborach samorządowych w Dolna Saksonia",
      tone: 'semantic',
    },
    {
      german: "wählen",
      translated: "można głosować",
      tone: 'semantic',
    },
  ],
  "lid:state:NI:4|prs": [
    {
      german: "Ab welchem Alter darf man",
      translated: "از چه سنی می‌توان",
      tone: 'semantic',
    },
    {
      german: "in Niedersachsen bei Kommunalwahlen",
      translated: "در انتخابات شاروالی نیدرزاکسن",
      tone: 'semantic',
    },
    {
      german: "wählen",
      translated: "رأی داد",
      tone: 'semantic',
    },
  ],
  "lid:state:NI:4|ro": [
    {
      german: "Ab welchem Alter darf man",
      translated: "De la ce vârstă",
      tone: 'semantic',
    },
    {
      german: "in Niedersachsen bei Kommunalwahlen",
      translated: "la alegerile locale din Saxonia Inferioară",
      tone: 'semantic',
    },
    {
      german: "wählen",
      translated: "vota",
      tone: 'semantic',
    },
  ],
  "lid:state:NI:4|ru": [
    {
      german: "Ab welchem Alter darf man",
      translated: "С какого возраста",
      tone: 'semantic',
    },
    {
      german: "in Niedersachsen bei Kommunalwahlen",
      translated: "на муниципальных выборах в федеральной земле Нижняя Саксония",
      tone: 'semantic',
    },
    {
      german: "wählen",
      translated: "можно голосовать",
      tone: 'semantic',
    },
  ],
  "lid:state:NI:4|sq": [
    {
      german: "Ab welchem Alter darf man",
      translated: "Nga cila moshë mund",
      tone: 'semantic',
    },
    {
      german: "in Niedersachsen bei Kommunalwahlen",
      translated: "në zgjedhjet komunale në Niedersachsen",
      tone: 'semantic',
    },
    {
      german: "wählen",
      translated: "votohet",
      tone: 'semantic',
    },
  ],
  "lid:state:NI:4|sr": [
    {
      german: "Ab welchem Alter darf man",
      translated: "Od koje se dobi",
      tone: 'semantic',
    },
    {
      german: "in Niedersachsen bei Kommunalwahlen",
      translated: "na lokalnim izborima u saveznoj pokrajini Donja Saksonija",
      tone: 'semantic',
    },
    {
      german: "wählen",
      translated: "glasati",
      tone: 'semantic',
    },
  ],
  "lid:state:NI:4|tr": [
    {
      german: "Ab welchem Alter darf man",
      translated: "kaç yaşından itibaren",
      tone: 'semantic',
    },
    {
      german: "in Niedersachsen bei Kommunalwahlen",
      translated: "Niedersachsen eyaletinde yerel seçimlerde",
      tone: 'semantic',
    },
    {
      german: "wählen",
      translated: "oy kullanılabilir",
      tone: 'semantic',
    },
  ],
  "lid:state:NI:4|uk": [
    {
      german: "Ab welchem Alter darf man",
      translated: "З якого віку",
      tone: 'semantic',
    },
    {
      german: "in Niedersachsen bei Kommunalwahlen",
      translated: "у федеральній землі Нижня Саксонія можна голосувати на муніципальних виборах",
      tone: 'semantic',
    },
  ],
  "lid:state:NI:4|vi": [
    {
      german: "Ab welchem Alter darf man",
      translated: "Từ bao nhiêu tuổi",
      tone: 'semantic',
    },
    {
      german: "in Niedersachsen bei Kommunalwahlen",
      translated: "trong bầu cử địa phương ở bang Niedersachsen",
      tone: 'semantic',
    },
    {
      german: "wählen",
      translated: "bỏ phiếu",
      tone: 'semantic',
    },
  ],
  "lid:state:NI:5|ar": [
    {
      german: "Welche Farben",
      translated: "ما ألوان",
      tone: 'semantic',
    },
    {
      german: "die Landesflagge",
      translated: "علم",
      tone: 'semantic',
    },
    {
      german: "von Niedersachsen",
      translated: "ولاية Niedersachsen",
      tone: 'semantic',
    },
  ],
  "lid:state:NI:5|bg": [
    {
      german: "Welche Farben",
      translated: "Какви са",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "цветовете",
      tone: 'semantic',
    },
    {
      german: "die Landesflagge",
      translated: "на знамето",
      tone: 'semantic',
    },
    {
      german: "von Niedersachsen",
      translated: "на провинция Долна Саксония",
      tone: 'semantic',
    },
  ],
  "lid:state:NI:5|bs": [
    {
      german: "Welche Farben",
      translated: "Koje su boje",
      tone: 'semantic',
    },
    {
      german: "die Landesflagge",
      translated: "zastave",
      tone: 'semantic',
    },
    {
      german: "von Niedersachsen",
      translated: "savezne zemlje Donja Saksonija",
      tone: 'semantic',
    },
  ],
  "lid:state:NI:5|el": [
    {
      german: "Welche Farben",
      translated: "Ποια είναι τα χρώματα",
      tone: 'semantic',
    },
    {
      german: "die Landesflagge",
      translated: "της σημαίας του κρατιδίου",
      tone: 'semantic',
    },
    {
      german: "von Niedersachsen",
      translated: "Κάτω Σαξονία",
      tone: 'semantic',
    },
  ],
  "lid:state:NI:5|en": [
    {
      german: "Welche Farben",
      translated: "What colors",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "does",
      tone: 'semantic',
    },
    {
      german: "die Landesflagge",
      translated: "the state flag",
      tone: 'semantic',
    },
    {
      german: "von Niedersachsen",
      translated: "of Niedersachsen",
      tone: 'semantic',
    },
  ],
  "lid:state:NI:5|es": [
    {
      german: "Welche Farben",
      translated: "¿Qué colores",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "tiene",
      tone: 'semantic',
    },
    {
      german: "die Landesflagge",
      translated: "la bandera regional",
      tone: 'semantic',
    },
    {
      german: "von Niedersachsen",
      translated: "de Baja Sajonia",
      tone: 'semantic',
    },
  ],
  "lid:state:NI:5|fa": [
    {
      german: "Welche Farben",
      translated: "رنگ‌های",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "کدام‌اند",
      tone: 'semantic',
    },
    {
      german: "die Landesflagge",
      translated: "پرچم ایالت",
      tone: 'semantic',
    },
    {
      german: "von Niedersachsen",
      translated: "نیدرزاکسن",
      tone: 'semantic',
    },
  ],
  "lid:state:NI:5|fr": [
    {
      german: "Welche Farben",
      translated: "Quelles sont les couleurs",
      tone: 'semantic',
    },
    {
      german: "die Landesflagge",
      translated: "du drapeau du Land",
      tone: 'semantic',
    },
    {
      german: "von Niedersachsen",
      translated: "de Basse-Saxe",
      tone: 'semantic',
    },
  ],
  "lid:state:NI:5|hr": [
    {
      german: "Welche Farben",
      translated: "Koje su",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "boje",
      tone: 'semantic',
    },
    {
      german: "die Landesflagge",
      translated: "zastave",
      tone: 'semantic',
    },
    {
      german: "von Niedersachsen",
      translated: "savezne zemlje Donja Saska",
      tone: 'semantic',
    },
  ],
  "lid:state:NI:5|it": [
    {
      german: "Welche Farben",
      translated: "Quali sono i colori",
      tone: 'semantic',
    },
    {
      german: "die Landesflagge",
      translated: "bandiera",
      tone: 'semantic',
    },
    {
      german: "von Niedersachsen",
      translated: "del Land di Bassa Sassonia",
      tone: 'semantic',
    },
  ],
  "lid:state:NI:5|kmr": [
    {
      german: "Welche Farben",
      translated: "Rengên ala",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "çi ne",
      tone: 'semantic',
    },
    {
      german: "die Landesflagge",
      translated: "eyaleta",
      tone: 'semantic',
    },
    {
      german: "von Niedersachsen",
      translated: "Niedersachsen",
      tone: 'semantic',
    },
  ],
  "lid:state:NI:5|pl": [
    {
      german: "Welche Farben",
      translated: "Jakie są kolory",
      tone: 'semantic',
    },
    {
      german: "die Landesflagge",
      translated: "flagi",
      tone: 'semantic',
    },
    {
      german: "von Niedersachsen",
      translated: "kraju związkowego Dolna Saksonia",
      tone: 'semantic',
    },
  ],
  "lid:state:NI:5|prs": [
    {
      german: "Welche Farben",
      translated: "رنگ‌های",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "کدام‌اند",
      tone: 'semantic',
    },
    {
      german: "die Landesflagge",
      translated: "پرچم ایالت",
      tone: 'semantic',
    },
    {
      german: "von Niedersachsen",
      translated: "نیدرزاکسن",
      tone: 'semantic',
    },
  ],
  "lid:state:NI:5|ro": [
    {
      german: "Welche Farben",
      translated: "Care sunt culorile",
      tone: 'semantic',
    },
    {
      german: "die Landesflagge",
      translated: "drapelului",
      tone: 'semantic',
    },
    {
      german: "von Niedersachsen",
      translated: "landului Saxonia Inferioară",
      tone: 'semantic',
    },
  ],
  "lid:state:NI:5|ru": [
    {
      german: "Welche Farben",
      translated: "Какие цвета",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "у",
      tone: 'semantic',
    },
    {
      german: "die Landesflagge",
      translated: "флага земли",
      tone: 'semantic',
    },
    {
      german: "von Niedersachsen",
      translated: "Нижняя Саксония",
      tone: 'semantic',
    },
  ],
  "lid:state:NI:5|sq": [
    {
      german: "Welche Farben",
      translated: "Cilat janë ngjyrat",
      tone: 'semantic',
    },
    {
      german: "die Landesflagge",
      translated: "e flamurit",
      tone: 'semantic',
    },
    {
      german: "von Niedersachsen",
      translated: "të landit Niedersachsen",
      tone: 'semantic',
    },
  ],
  "lid:state:NI:5|sr": [
    {
      german: "Welche Farben",
      translated: "Koje",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "su",
      tone: 'semantic',
    },
    {
      german: "die Landesflagge",
      translated: "boje zastave",
      tone: 'semantic',
    },
    {
      german: "von Niedersachsen",
      translated: "savezne pokrajine Donja Saksonija",
      tone: 'semantic',
    },
  ],
  "lid:state:NI:5|tr": [
    {
      german: "Welche Farben",
      translated: "renkleri nelerdir",
      tone: 'semantic',
    },
    {
      german: "die Landesflagge",
      translated: "eyalet bayrağının",
      tone: 'semantic',
    },
    {
      german: "von Niedersachsen",
      translated: "Niedersachsen",
      tone: 'semantic',
    },
  ],
  "lid:state:NI:5|uk": [
    {
      german: "Welche Farben",
      translated: "Які кольори",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "має",
      tone: 'semantic',
    },
    {
      german: "die Landesflagge",
      translated: "прапор федеральної землі",
      tone: 'semantic',
    },
    {
      german: "von Niedersachsen",
      translated: "Нижня Саксонія",
      tone: 'semantic',
    },
  ],
  "lid:state:NI:5|vi": [
    {
      german: "Welche Farben",
      translated: "Màu của",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "là",
      tone: 'semantic',
    },
    {
      german: "die Landesflagge",
      translated: "cờ bang",
      tone: 'semantic',
    },
    {
      german: "von Niedersachsen",
      translated: "Niedersachsen",
      tone: 'semantic',
    },
  ],
  "lid:state:NI:6|ar": [
    {
      german: "Wo",
      translated: "أين",
      tone: 'semantic',
    },
    {
      german: "können Sie",
      translated: "يمكنك",
      tone: 'semantic',
    },
    {
      german: "sich",
      translated: "الحصول",
      tone: 'semantic',
    },
    {
      german: "in Niedersachsen",
      translated: "في Niedersachsen",
      tone: 'semantic',
    },
    {
      german: "über politische Themen",
      translated: "عن القضايا السياسية",
      tone: 'semantic',
    },
  ],
  "lid:state:NI:6|bg": [
    {
      german: "Wo",
      translated: "Къде",
      tone: 'semantic',
    },
    {
      german: "können Sie",
      translated: "можете",
      tone: 'semantic',
    },
    {
      german: "in Niedersachsen",
      translated: "в Долна Саксония",
      tone: 'semantic',
    },
    {
      german: "über politische Themen",
      translated: "по политически теми",
      tone: 'semantic',
    },
    {
      german: "informieren?",
      translated: "да получите информация",
      tone: 'semantic',
    },
  ],
  "lid:state:NI:6|bs": [
    {
      german: "Wo",
      translated: "Gdje",
      tone: 'semantic',
    },
    {
      german: "können Sie",
      translated: "se u",
      tone: 'semantic',
    },
    {
      german: "sich",
      translated: "mogu dobiti",
      tone: 'semantic',
    },
    {
      german: "in Niedersachsen",
      translated: "Donja Saksonija",
      tone: 'semantic',
    },
    {
      german: "über politische Themen",
      translated: "o političkim temama",
      tone: 'semantic',
    },
    {
      german: "informieren?",
      translated: "informacije",
      tone: 'semantic',
    },
  ],
  "lid:state:NI:6|el": [
    {
      german: "Wo",
      translated: "Πού",
      tone: 'semantic',
    },
    {
      german: "können Sie",
      translated: "μπορείτε",
      tone: 'semantic',
    },
    {
      german: "sich",
      translated: "να ενημερωθείτε",
      tone: 'semantic',
    },
    {
      german: "in Niedersachsen",
      translated: "στο Κάτω Σαξονία",
      tone: 'semantic',
    },
    {
      german: "über politische Themen",
      translated: "για πολιτικά θέματα",
      tone: 'semantic',
    },
  ],
  "lid:state:NI:6|en": [
    {
      german: "Wo",
      translated: "Where",
      tone: 'semantic',
    },
    {
      german: "können Sie",
      translated: "can you",
      tone: 'semantic',
    },
    {
      german: "in Niedersachsen",
      translated: "in Niedersachsen",
      tone: 'semantic',
    },
    {
      german: "über politische Themen",
      translated: "about political topics",
      tone: 'semantic',
    },
    {
      german: "informieren?",
      translated: "get information",
      tone: 'semantic',
    },
  ],
  "lid:state:NI:6|es": [
    {
      german: "Wo",
      translated: "¿Dónde",
      tone: 'semantic',
    },
    {
      german: "können Sie",
      translated: "puede",
      tone: 'semantic',
    },
    {
      german: "in Niedersachsen",
      translated: "en Baja Sajonia",
      tone: 'semantic',
    },
    {
      german: "über politische Themen",
      translated: "sobre temas políticos",
      tone: 'semantic',
    },
    {
      german: "informieren?",
      translated: "informarse",
      tone: 'semantic',
    },
  ],
  "lid:state:NI:6|fa": [
    {
      german: "Wo",
      translated: "کجا",
      tone: 'semantic',
    },
    {
      german: "können Sie",
      translated: "می‌توانید",
      tone: 'semantic',
    },
    {
      german: "in Niedersachsen",
      translated: "در نیدرزاکسن",
      tone: 'semantic',
    },
    {
      german: "über politische Themen",
      translated: "دربارهٔ موضوعات سیاسی",
      tone: 'semantic',
    },
    {
      german: "informieren?",
      translated: "اطلاعات کسب کنید؟",
      tone: 'semantic',
    },
  ],
  "lid:state:NI:6|fr": [
    {
      german: "Wo",
      translated: "Où",
      tone: 'semantic',
    },
    {
      german: "können Sie",
      translated: "pouvez-vous",
      tone: 'semantic',
    },
    {
      german: "sich",
      translated: "vous",
      tone: 'semantic',
    },
    {
      german: "in Niedersachsen",
      translated: "en Basse-Saxe",
      tone: 'semantic',
    },
    {
      german: "über politische Themen",
      translated: "sur les questions politiques",
      tone: 'semantic',
    },
    {
      german: "informieren?",
      translated: "informer",
      tone: 'semantic',
    },
  ],
  "lid:state:NI:6|hr": [
    {
      german: "Wo",
      translated: "Gdje",
      tone: 'semantic',
    },
    {
      german: "können Sie",
      translated: "mogu",
      tone: 'semantic',
    },
    {
      german: "in Niedersachsen",
      translated: "se",
      tone: 'semantic',
    },
    {
      german: "über politische Themen",
      translated: "u saveznoj zemlji Donja Saska",
      tone: 'semantic',
    },
    {
      german: "informieren?",
      translated: "dobiti informacije",
      tone: 'semantic',
    },
  ],
  "lid:state:NI:6|it": [
    {
      german: "Wo",
      translated: "Dove",
      tone: 'semantic',
    },
    {
      german: "können Sie",
      translated: "si può",
      tone: 'semantic',
    },
    {
      german: "sich",
      translated: "ci",
      tone: 'semantic',
    },
    {
      german: "in Niedersachsen",
      translated: "in Bassa Sassonia",
      tone: 'semantic',
    },
    {
      german: "über politische Themen",
      translated: "su temi politici",
      tone: 'semantic',
    },
    {
      german: "informieren?",
      translated: "informare",
      tone: 'semantic',
    },
  ],
  "lid:state:NI:6|kmr": [
    {
      german: "Wo",
      translated: "Li",
      tone: 'semantic',
    },
    {
      german: "können Sie",
      translated: "ku dikarî",
      tone: 'semantic',
    },
    {
      german: "sich",
      translated: "li",
      tone: 'semantic',
    },
    {
      german: "in Niedersachsen",
      translated: "li ser mijarên",
      tone: 'semantic',
    },
    {
      german: "über politische Themen",
      translated: "siyasî agahdarî",
      tone: 'semantic',
    },
    {
      german: "informieren?",
      translated: "bistînî?",
      tone: 'semantic',
    },
  ],
  "lid:state:NI:6|pl": [
    {
      german: "Wo",
      translated: "Gdzie",
      tone: 'semantic',
    },
    {
      german: "können Sie",
      translated: "można",
      tone: 'semantic',
    },
    {
      german: "in Niedersachsen",
      translated: "w Dolnej Saksonii",
      tone: 'semantic',
    },
    {
      german: "über politische Themen",
      translated: "na tematy polityczne",
      tone: 'semantic',
    },
    {
      german: "informieren?",
      translated: "uzyskać informacje",
      tone: 'semantic',
    },
  ],
  "lid:state:NI:6|prs": [
    {
      german: "Wo",
      translated: "کجا",
      tone: 'semantic',
    },
    {
      german: "können Sie",
      translated: "می‌توانید",
      tone: 'semantic',
    },
    {
      german: "in Niedersachsen",
      translated: "در نیدرزاکسن",
      tone: 'semantic',
    },
    {
      german: "über politische Themen",
      translated: "دربارهٔ موضوعات سیاسی",
      tone: 'semantic',
    },
    {
      german: "informieren?",
      translated: "اطلاعات کسب کنید؟",
      tone: 'semantic',
    },
  ],
  "lid:state:NI:6|ro": [
    {
      german: "Wo",
      translated: "Unde",
      tone: 'semantic',
    },
    {
      german: "können Sie",
      translated: "puteți",
      tone: 'semantic',
    },
    {
      german: "sich",
      translated: "vă",
      tone: 'semantic',
    },
    {
      german: "in Niedersachsen",
      translated: "în Saxonia Inferioară",
      tone: 'semantic',
    },
    {
      german: "über politische Themen",
      translated: "despre teme politice",
      tone: 'semantic',
    },
    {
      german: "informieren?",
      translated: "informa",
      tone: 'semantic',
    },
  ],
  "lid:state:NI:6|ru": [
    {
      german: "Wo",
      translated: "Где",
      tone: 'semantic',
    },
    {
      german: "können Sie",
      translated: "можно",
      tone: 'semantic',
    },
    {
      german: "in Niedersachsen",
      translated: "в федеральной земле Нижняя Саксония",
      tone: 'semantic',
    },
    {
      german: "über politische Themen",
      translated: "о политических темах",
      tone: 'semantic',
    },
  ],
  "lid:state:NI:6|sq": [
    {
      german: "Wo",
      translated: "Ku",
      tone: 'semantic',
    },
    {
      german: "können Sie",
      translated: "mund",
      tone: 'semantic',
    },
    {
      german: "sich",
      translated: "të informoheni",
      tone: 'semantic',
    },
    {
      german: "in Niedersachsen",
      translated: "në Niedersachsen",
      tone: 'semantic',
    },
    {
      german: "über politische Themen",
      translated: "për tema politike",
      tone: 'semantic',
    },
  ],
  "lid:state:NI:6|sr": [
    {
      german: "Wo",
      translated: "Gdje",
      tone: 'semantic',
    },
    {
      german: "können Sie",
      translated: "mogu",
      tone: 'semantic',
    },
    {
      german: "in Niedersachsen",
      translated: "se",
      tone: 'semantic',
    },
    {
      german: "über politische Themen",
      translated: "u saveznoj pokrajini Donja Saksonija",
      tone: 'semantic',
    },
    {
      german: "informieren?",
      translated: "dobiti informacije",
      tone: 'semantic',
    },
  ],
  "lid:state:NI:6|tr": [
    {
      german: "Wo",
      translated: "nereden",
      tone: 'semantic',
    },
    {
      german: "können Sie",
      translated: "bilgi alabilirsiniz",
      tone: 'semantic',
    },
    {
      german: "in Niedersachsen",
      translated: "Niedersachsen eyaletinde",
      tone: 'semantic',
    },
    {
      german: "über politische Themen",
      translated: "siyasi konular hakkında",
      tone: 'semantic',
    },
  ],
  "lid:state:NI:6|uk": [
    {
      german: "Wo",
      translated: "Де",
      tone: 'semantic',
    },
    {
      german: "können Sie",
      translated: "можна",
      tone: 'semantic',
    },
    {
      german: "in Niedersachsen",
      translated: "у федеральній землі Нижня Саксонія",
      tone: 'semantic',
    },
    {
      german: "über politische Themen",
      translated: "про політичні питання",
      tone: 'semantic',
    },
    {
      german: "informieren?",
      translated: "отримати інформацію",
      tone: 'semantic',
    },
  ],
  "lid:state:NI:6|vi": [
    {
      german: "Wo",
      translated: "ở đâu?",
      tone: 'semantic',
    },
    {
      german: "können Sie",
      translated: "có thể",
      tone: 'semantic',
    },
    {
      german: "in Niedersachsen",
      translated: "Ở bang Niedersachsen",
      tone: 'semantic',
    },
    {
      german: "über politische Themen",
      translated: "về các chủ đề chính trị",
      tone: 'semantic',
    },
    {
      german: "informieren?",
      translated: "tìm thông tin",
      tone: 'semantic',
    },
  ],
  "lid:state:NI:7|ar": [
    {
      german: "Die Landeshauptstadt",
      translated: "ما عاصمة",
      tone: 'semantic',
    },
    {
      german: "von Niedersachsen",
      translated: "ولاية Niedersachsen",
      tone: 'semantic',
    },
  ],
  "lid:state:NI:7|bg": [
    {
      german: "Die Landeshauptstadt",
      translated: "Столицата",
      tone: 'semantic',
    },
    {
      german: "von Niedersachsen",
      translated: "на федералната провинция Долна Саксония",
      tone: 'semantic',
    },
    {
      german: "heißt",
      translated: "е",
      tone: 'semantic',
    },
  ],
  "lid:state:NI:7|bs": [
    {
      german: "Die Landeshauptstadt",
      translated: "Glavni grad",
      tone: 'semantic',
    },
    {
      german: "von Niedersachsen",
      translated: "savezne zemlje Donja Saksonija",
      tone: 'semantic',
    },
    {
      german: "heißt",
      translated: "je",
      tone: 'semantic',
    },
  ],
  "lid:state:NI:7|el": [
    {
      german: "Die Landeshauptstadt",
      translated: "Η πρωτεύουσα",
      tone: 'semantic',
    },
    {
      german: "von Niedersachsen",
      translated: "Κάτω Σαξονία",
      tone: 'semantic',
    },
    {
      german: "heißt",
      translated: "είναι",
      tone: 'semantic',
    },
  ],
  "lid:state:NI:7|en": [
    {
      german: "Die Landeshauptstadt",
      translated: "The state capital",
      tone: 'semantic',
    },
    {
      german: "von Niedersachsen",
      translated: "of Niedersachsen",
      tone: 'semantic',
    },
    {
      german: "heißt",
      translated: "called",
      tone: 'semantic',
    },
  ],
  "lid:state:NI:7|es": [
    {
      german: "Die Landeshauptstadt",
      translated: "La capital del estado federado",
      tone: 'semantic',
    },
    {
      german: "von Niedersachsen",
      translated: "de Baja Sajonia",
      tone: 'semantic',
    },
    {
      german: "heißt",
      translated: "es …",
      tone: 'semantic',
    },
  ],
  "lid:state:NI:7|fa": [
    {
      german: "Die Landeshauptstadt",
      translated: "مرکز ایالت",
      tone: 'semantic',
    },
    {
      german: "von Niedersachsen",
      translated: "نیدرزاکسن",
      tone: 'semantic',
    },
  ],
  "lid:state:NI:7|fr": [
    {
      german: "Die Landeshauptstadt",
      translated: "La capitale du Land",
      tone: 'semantic',
    },
    {
      german: "von Niedersachsen",
      translated: "de Basse-Saxe",
      tone: 'semantic',
    },
    {
      german: "heißt",
      translated: "s’appelle",
      tone: 'semantic',
    },
  ],
  "lid:state:NI:7|hr": [
    {
      german: "Die Landeshauptstadt",
      translated: "Glavni grad",
      tone: 'semantic',
    },
    {
      german: "von Niedersachsen",
      translated: "savezne zemlje Donja Saska",
      tone: 'semantic',
    },
    {
      german: "heißt",
      translated: "je",
      tone: 'semantic',
    },
  ],
  "lid:state:NI:7|it": [
    {
      german: "Die Landeshauptstadt",
      translated: "La capitale del Land",
      tone: 'semantic',
    },
    {
      german: "von Niedersachsen",
      translated: "di Bassa Sassonia",
      tone: 'semantic',
    },
    {
      german: "heißt",
      translated: "è",
      tone: 'semantic',
    },
  ],
  "lid:state:NI:7|kmr": [
    {
      german: "Die Landeshauptstadt",
      translated: "Paytexta eyaleta",
      tone: 'semantic',
    },
    {
      german: "von Niedersachsen",
      translated: "Niedersachsen",
      tone: 'semantic',
    },
  ],
  "lid:state:NI:7|pl": [
    {
      german: "Die Landeshauptstadt",
      translated: "Stolicą kraju związkowego",
      tone: 'semantic',
    },
    {
      german: "von Niedersachsen",
      translated: "Dolna Saksonia",
      tone: 'semantic',
    },
    {
      german: "heißt",
      translated: "jest",
      tone: 'semantic',
    },
  ],
  "lid:state:NI:7|prs": [
    {
      german: "Die Landeshauptstadt",
      translated: "مرکز ایالت",
      tone: 'semantic',
    },
    {
      german: "von Niedersachsen",
      translated: "نیدرزاکسن",
      tone: 'semantic',
    },
    {
      german: "heißt",
      translated: "است",
      tone: 'semantic',
    },
  ],
  "lid:state:NI:7|ro": [
    {
      german: "Die Landeshauptstadt",
      translated: "Capitala landului",
      tone: 'semantic',
    },
    {
      german: "von Niedersachsen",
      translated: "Saxonia Inferioară",
      tone: 'semantic',
    },
    {
      german: "heißt",
      translated: "este",
      tone: 'semantic',
    },
  ],
  "lid:state:NI:7|ru": [
    {
      german: "Die Landeshauptstadt",
      translated: "Столица земли",
      tone: 'semantic',
    },
    {
      german: "von Niedersachsen",
      translated: "Нижняя Саксония",
      tone: 'semantic',
    },
    {
      german: "heißt",
      translated: "называется",
      tone: 'semantic',
    },
  ],
  "lid:state:NI:7|sq": [
    {
      german: "Die Landeshauptstadt",
      translated: "Kryeqyteti i landit",
      tone: 'semantic',
    },
    {
      german: "von Niedersachsen",
      translated: "Niedersachsen",
      tone: 'semantic',
    },
    {
      german: "heißt",
      translated: "është",
      tone: 'semantic',
    },
  ],
  "lid:state:NI:7|sr": [
    {
      german: "Die Landeshauptstadt",
      translated: "Glavni grad",
      tone: 'semantic',
    },
    {
      german: "von Niedersachsen",
      translated: "savezne pokrajine Donja Saksonija",
      tone: 'semantic',
    },
    {
      german: "heißt",
      translated: "je",
      tone: 'semantic',
    },
  ],
  "lid:state:NI:7|tr": [
    {
      german: "Die Landeshauptstadt",
      translated: "başkenti",
      tone: 'semantic',
    },
    {
      german: "von Niedersachsen",
      translated: "Niedersachsen eyaletinin",
      tone: 'semantic',
    },
  ],
  "lid:state:NI:7|uk": [
    {
      german: "Die Landeshauptstadt",
      translated: "Столиця",
      tone: 'semantic',
    },
    {
      german: "von Niedersachsen",
      translated: "федеральної землі Нижня Саксонія",
      tone: 'semantic',
    },
    {
      german: "heißt",
      translated: "називається",
      tone: 'semantic',
    },
  ],
  "lid:state:NI:7|vi": [
    {
      german: "Die Landeshauptstadt",
      translated: "Thủ phủ",
      tone: 'semantic',
    },
    {
      german: "von Niedersachsen",
      translated: "của bang Niedersachsen",
      tone: 'semantic',
    },
    {
      german: "heißt",
      translated: "là",
      tone: 'semantic',
    },
  ],
  "lid:state:NI:8|ar": [
    {
      german: "Welches Bundesland",
      translated: "أي صورة تمثل موقع ولاية",
      tone: 'semantic',
    },
    {
      german: "Niedersachsen",
      translated: "Niedersachsen",
      tone: 'semantic',
    },
  ],
  "lid:state:NI:8|bg": [
    {
      german: "Welches Bundesland",
      translated: "Коя от показаните федерални провинции",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "е",
      tone: 'semantic',
    },
    {
      german: "Niedersachsen",
      translated: "Долна Саксония?",
      tone: 'semantic',
    },
  ],
  "lid:state:NI:8|bs": [
    {
      german: "Welches Bundesland",
      translated: "Koja od prikazanih saveznih zemalja",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "je",
      tone: 'semantic',
    },
    {
      german: "Niedersachsen",
      translated: "Donja Saksonija",
      tone: 'semantic',
    },
  ],
  "lid:state:NI:8|el": [
    {
      german: "Welches Bundesland",
      translated: "Ποιο από τα εικονιζόμενα κρατίδια",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "είναι",
      tone: 'semantic',
    },
    {
      german: "Niedersachsen",
      translated: "Κάτω Σαξονία",
      tone: 'semantic',
    },
  ],
  "lid:state:NI:8|en": [
    {
      german: "Welches Bundesland",
      translated: "Which federal state",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "is",
      tone: 'semantic',
    },
    {
      german: "Niedersachsen",
      translated: "Niedersachsen",
      tone: 'semantic',
    },
  ],
  "lid:state:NI:8|es": [
    {
      german: "Welches Bundesland",
      translated: "¿Cuál de las imágenes corresponde al estado federado",
      tone: 'semantic',
    },
    {
      german: "Niedersachsen",
      translated: "Baja Sajonia",
      tone: 'semantic',
    },
  ],
  "lid:state:NI:8|fa": [
    {
      german: "Welches Bundesland",
      translated: "کدام ایالتِ نشان‌داده‌شده",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "است",
      tone: 'semantic',
    },
    {
      german: "Niedersachsen",
      translated: "نیدرزاکسن",
      tone: 'semantic',
    },
  ],
  "lid:state:NI:8|fr": [
    {
      german: "Welches Bundesland",
      translated: "Quel Land",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "est",
      tone: 'semantic',
    },
    {
      german: "Niedersachsen",
      translated: "Basse-Saxe",
      tone: 'semantic',
    },
  ],
  "lid:state:NI:8|hr": [
    {
      german: "Welches Bundesland",
      translated: "Koja od prikazanih saveznih zemalja",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "je",
      tone: 'semantic',
    },
    {
      german: "Niedersachsen",
      translated: "Donja Saska",
      tone: 'semantic',
    },
  ],
  "lid:state:NI:8|it": [
    {
      german: "Welches Bundesland",
      translated: "Quale Land rappresentato",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "è",
      tone: 'semantic',
    },
    {
      german: "Niedersachsen",
      translated: "Bassa Sassonia",
      tone: 'semantic',
    },
  ],
  "lid:state:NI:8|kmr": [
    {
      german: "Welches Bundesland",
      translated: "Kîjan eyalet",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "ye",
      tone: 'semantic',
    },
    {
      german: "Niedersachsen",
      translated: "Niedersachsen",
      tone: 'semantic',
    },
  ],
  "lid:state:NI:8|pl": [
    {
      german: "Welches Bundesland",
      translated: "Który z przedstawionych krajów związkowych",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "to",
      tone: 'semantic',
    },
    {
      german: "Niedersachsen",
      translated: "Dolna Saksonia",
      tone: 'semantic',
    },
  ],
  "lid:state:NI:8|prs": [
    {
      german: "Welches Bundesland",
      translated: "کدام ایالتِ",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "است",
      tone: 'semantic',
    },
    {
      german: "Niedersachsen",
      translated: "نیدرزاکسن",
      tone: 'semantic',
    },
  ],
  "lid:state:NI:8|ro": [
    {
      german: "Welches Bundesland",
      translated: "Care land reprezentat",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "este",
      tone: 'semantic',
    },
    {
      german: "Niedersachsen",
      translated: "Saxonia Inferioară",
      tone: 'semantic',
    },
  ],
  "lid:state:NI:8|ru": [
    {
      german: "Welches Bundesland",
      translated: "Какая из этих земель",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "—",
      tone: 'semantic',
    },
    {
      german: "Niedersachsen",
      translated: "Нижняя Саксония",
      tone: 'semantic',
    },
  ],
  "lid:state:NI:8|sq": [
    {
      german: "Welches Bundesland",
      translated: "Cili nga landet",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "është",
      tone: 'semantic',
    },
    {
      german: "Niedersachsen",
      translated: "Niedersachsen",
      tone: 'semantic',
    },
  ],
  "lid:state:NI:8|sr": [
    {
      german: "Welches Bundesland",
      translated: "Koja od prikazanih saveznih pokrajina",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "je",
      tone: 'semantic',
    },
    {
      german: "Niedersachsen",
      translated: "Donja Saksonija",
      tone: 'semantic',
    },
  ],
  "lid:state:NI:8|tr": [
    {
      german: "Welches Bundesland",
      translated: "hangi numarayla",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "gösterilmiştir",
      tone: 'semantic',
    },
    {
      german: "Niedersachsen",
      translated: "Niedersachsen",
      tone: 'semantic',
    },
  ],
  "lid:state:NI:8|uk": [
    {
      german: "Welches Bundesland",
      translated: "Яка з позначених федеральних земель",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "є",
      tone: 'semantic',
    },
    {
      german: "Niedersachsen",
      translated: "Нижня Саксонія",
      tone: 'semantic',
    },
  ],
  "lid:state:NI:8|vi": [
    {
      german: "Welches Bundesland",
      translated: "Niedersachsen",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "được",
      tone: 'semantic',
    },
  ],
  "lid:state:NI:9|ar": [
    {
      german: "Wie nennt man",
      translated: "ماذا",
      tone: 'semantic',
    },
    {
      german: "die Regierungschefin/den Regierungschef",
      translated: "رئيس/رئيسة حكومة",
      tone: 'semantic',
    },
    {
      german: "in Niedersachsen",
      translated: "ولاية Niedersachsen",
      tone: 'semantic',
    },
  ],
  "lid:state:NI:9|bg": [
    {
      german: "Wie nennt man",
      translated: "Как се нарича",
      tone: 'semantic',
    },
    {
      german: "die Regierungschefin/den Regierungschef",
      translated: "ръководителят на правителството",
      tone: 'semantic',
    },
    {
      german: "in Niedersachsen",
      translated: "на провинция Долна Саксония",
      tone: 'semantic',
    },
  ],
  "lid:state:NI:9|bs": [
    {
      german: "Wie nennt man",
      translated: "Kako se zove",
      tone: 'semantic',
    },
    {
      german: "die Regierungschefin/den Regierungschef",
      translated: "šef vlade",
      tone: 'semantic',
    },
    {
      german: "in Niedersachsen",
      translated: "savezne zemlje Donja Saksonija",
      tone: 'semantic',
    },
  ],
  "lid:state:NI:9|el": [
    {
      german: "Wie nennt man",
      translated: "Πώς ονομάζεται",
      tone: 'semantic',
    },
    {
      german: "die Regierungschefin/den Regierungschef",
      translated: "ο επικεφαλής της κυβέρνησης του κρατιδίου",
      tone: 'semantic',
    },
    {
      german: "in Niedersachsen",
      translated: "Κάτω Σαξονία",
      tone: 'semantic',
    },
  ],
  "lid:state:NI:9|en": [
    {
      german: "Wie nennt man",
      translated: "What",
      tone: 'semantic',
    },
    {
      german: "die Regierungschefin/den Regierungschef",
      translated: "the head of government",
      tone: 'semantic',
    },
    {
      german: "in Niedersachsen",
      translated: "in Niedersachsen",
      tone: 'semantic',
    },
  ],
  "lid:state:NI:9|es": [
    {
      german: "Wie nennt man",
      translated: "¿Cómo se llama al",
      tone: 'semantic',
    },
    {
      german: "die Regierungschefin/den Regierungschef",
      translated: "jefe o la jefa de gobierno",
      tone: 'semantic',
    },
    {
      german: "in Niedersachsen",
      translated: "de Baja Sajonia",
      tone: 'semantic',
    },
  ],
  "lid:state:NI:9|fa": [
    {
      german: "Wie nennt man",
      translated: "ایالت",
      tone: 'semantic',
    },
    {
      german: "die Regierungschefin/den Regierungschef",
      translated: "رئیس دولت",
      tone: 'semantic',
    },
    {
      german: "in Niedersachsen",
      translated: "نیدرزاکسن",
      tone: 'semantic',
    },
  ],
  "lid:state:NI:9|fr": [
    {
      german: "Wie nennt man",
      translated: "Comment appelle-t-on",
      tone: 'semantic',
    },
    {
      german: "die Regierungschefin/den Regierungschef",
      translated: "le chef ou la cheffe du gouvernement",
      tone: 'semantic',
    },
    {
      german: "in Niedersachsen",
      translated: "de Basse-Saxe",
      tone: 'semantic',
    },
  ],
  "lid:state:NI:9|hr": [
    {
      german: "Wie nennt man",
      translated: "Kako se zove",
      tone: 'semantic',
    },
    {
      german: "die Regierungschefin/den Regierungschef",
      translated: "čelnik vlade",
      tone: 'semantic',
    },
    {
      german: "in Niedersachsen",
      translated: "savezne zemlje Donja Saska",
      tone: 'semantic',
    },
  ],
  "lid:state:NI:9|it": [
    {
      german: "Wie nennt man",
      translated: "Come si chiama",
      tone: 'semantic',
    },
    {
      german: "die Regierungschefin/den Regierungschef",
      translated: "il capo del governo",
      tone: 'semantic',
    },
    {
      german: "in Niedersachsen",
      translated: "del Land di Bassa Sassonia",
      tone: 'semantic',
    },
  ],
  "lid:state:NI:9|kmr": [
    {
      german: "Wie nennt man",
      translated: "Serokê",
      tone: 'semantic',
    },
    {
      german: "die Regierungschefin/den Regierungschef",
      translated: "hukûmeta",
      tone: 'semantic',
    },
    {
      german: "in Niedersachsen",
      translated: "Niedersachsen",
      tone: 'semantic',
    },
  ],
  "lid:state:NI:9|pl": [
    {
      german: "Wie nennt man",
      translated: "Jak nazywa się",
      tone: 'semantic',
    },
    {
      german: "die Regierungschefin/den Regierungschef",
      translated: "szef rządu",
      tone: 'semantic',
    },
    {
      german: "in Niedersachsen",
      translated: "kraju związkowego Dolna Saksonia",
      tone: 'semantic',
    },
  ],
  "lid:state:NI:9|prs": [
    {
      german: "Wie nennt man",
      translated: "رئیس دولت",
      tone: 'semantic',
    },
    {
      german: "die Regierungschefin/den Regierungschef",
      translated: "ایالت",
      tone: 'semantic',
    },
    {
      german: "in Niedersachsen",
      translated: "نیدرزاکسن",
      tone: 'semantic',
    },
  ],
  "lid:state:NI:9|ro": [
    {
      german: "Wie nennt man",
      translated: "Cum se numește",
      tone: 'semantic',
    },
    {
      german: "die Regierungschefin/den Regierungschef",
      translated: "șeful guvernului landului Saxonia Inferioară",
      tone: 'semantic',
    },
  ],
  "lid:state:NI:9|ru": [
    {
      german: "Wie nennt man",
      translated: "Как называют",
      tone: 'semantic',
    },
    {
      german: "die Regierungschefin/den Regierungschef",
      translated: "главу правительства",
      tone: 'semantic',
    },
    {
      german: "in Niedersachsen",
      translated: "в федеральной земле Нижняя Саксония",
      tone: 'semantic',
    },
  ],
  "lid:state:NI:9|sq": [
    {
      german: "Wie nennt man",
      translated: "Si quhet",
      tone: 'semantic',
    },
    {
      german: "die Regierungschefin/den Regierungschef",
      translated: "kreu i qeverisë",
      tone: 'semantic',
    },
    {
      german: "in Niedersachsen",
      translated: "së landit Niedersachsen",
      tone: 'semantic',
    },
  ],
  "lid:state:NI:9|sr": [
    {
      german: "Wie nennt man",
      translated: "Kako se zove",
      tone: 'semantic',
    },
    {
      german: "die Regierungschefin/den Regierungschef",
      translated: "šef vlade",
      tone: 'semantic',
    },
    {
      german: "in Niedersachsen",
      translated: "savezne pokrajine Donja Saksonija",
      tone: 'semantic',
    },
  ],
  "lid:state:NI:9|tr": [
    {
      german: "Wie nennt man",
      translated: "ne ad verilir",
      tone: 'semantic',
    },
    {
      german: "die Regierungschefin/den Regierungschef",
      translated: "başındaki kişiye",
      tone: 'semantic',
    },
    {
      german: "in Niedersachsen",
      translated: "Niedersachsen hükümetinin",
      tone: 'semantic',
    },
  ],
  "lid:state:NI:9|uk": [
    {
      german: "Wie nennt man",
      translated: "Як називають",
      tone: 'semantic',
    },
    {
      german: "die Regierungschefin/den Regierungschef",
      translated: "главу уряду",
      tone: 'semantic',
    },
    {
      german: "in Niedersachsen",
      translated: "федеральної землі Нижня Саксонія",
      tone: 'semantic',
    },
  ],
  "lid:state:NI:9|vi": [
    {
      german: "Wie nennt man",
      translated: "được gọi là",
      tone: 'semantic',
    },
    {
      german: "die Regierungschefin/den Regierungschef",
      translated: "Người đứng đầu chính phủ",
      tone: 'semantic',
    },
    {
      german: "in Niedersachsen",
      translated: "bang Niedersachsen",
      tone: 'semantic',
    },
  ],
  "lid:state:NW:10|ar": [
    {
      german: "Welche Ministerin",
      translated: "أي وزارة",
      tone: 'semantic',
    },
    {
      german: "welchen Minister",
      translated: "الوزارات التالية",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "من",
      tone: 'semantic',
    },
    {
      german: "Nordrhein-Westfalen",
      translated: "Nordrhein-Westfalen",
      tone: 'semantic',
    },
    {
      german: "nicht",
      translated: "غير موجودة",
      tone: 'semantic',
    },
  ],
  "lid:state:NW:10|bg": [
    {
      german: "welchen Minister",
      translated: "Кой министър",
      tone: 'semantic',
    },
    {
      german: "Nordrhein-Westfalen",
      translated: "Северен Рейн-Вестфалия",
      tone: 'semantic',
    },
    {
      german: "nicht",
      translated: "не съществува",
      tone: 'semantic',
    },
  ],
  "lid:state:NW:10|bs": [
    {
      german: "Welche Ministerin",
      translated: "Koji ministar",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "ne postoji",
      tone: 'semantic',
    },
    {
      german: "Nordrhein-Westfalen",
      translated: "Sjeverna Rajna-Vestfalija",
      tone: 'semantic',
    },
  ],
  "lid:state:NW:10|el": [
    {
      german: "Welche Ministerin",
      translated: "Ποιος",
      tone: 'semantic',
    },
    {
      german: "welchen Minister",
      translated: "υπουργός",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "υπάρχει",
      tone: 'semantic',
    },
    {
      german: "Nordrhein-Westfalen",
      translated: "Βόρεια Ρηνανία-Βεστφαλία",
      tone: 'semantic',
    },
    {
      german: "nicht",
      translated: "δεν",
      tone: 'semantic',
    },
  ],
  "lid:state:NW:10|en": [
    {
      german: "Welche Ministerin",
      translated: "Which",
      tone: 'semantic',
    },
    {
      german: "welchen Minister",
      translated: "minister",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "does",
      tone: 'semantic',
    },
    {
      german: "Nordrhein-Westfalen",
      translated: "Nordrhein-Westfalen",
      tone: 'semantic',
    },
    {
      german: "nicht",
      translated: "not",
      tone: 'semantic',
    },
  ],
  "lid:state:NW:10|es": [
    {
      german: "Welche Ministerin",
      translated: "¿Qué",
      tone: 'semantic',
    },
    {
      german: "welchen Minister",
      translated: "ministerio",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "existe",
      tone: 'semantic',
    },
    {
      german: "Nordrhein-Westfalen",
      translated: "Renania del Norte-Westfalia",
      tone: 'semantic',
    },
    {
      german: "nicht",
      translated: "NO",
      tone: 'semantic',
    },
  ],
  "lid:state:NW:10|fa": [
    {
      german: "Welche Ministerin",
      translated: "کدام",
      tone: 'semantic',
    },
    {
      german: "welchen Minister",
      translated: "وزیر",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "وجود",
      tone: 'semantic',
    },
    {
      german: "Nordrhein-Westfalen",
      translated: "نوردراین-وستفالن",
      tone: 'semantic',
    },
    {
      german: "nicht",
      translated: "ندارد",
      tone: 'semantic',
    },
  ],
  "lid:state:NW:10|fr": [
    {
      german: "Welche Ministerin",
      translated: "quelle ministre",
      tone: 'semantic',
    },
    {
      german: "welchen Minister",
      translated: "Quel ministre",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "existe",
      tone: 'semantic',
    },
    {
      german: "Nordrhein-Westfalen",
      translated: "Rhénanie-du-Nord-Westphalie",
      tone: 'semantic',
    },
    {
      german: "nicht",
      translated: "pas",
      tone: 'semantic',
    },
  ],
  "lid:state:NW:10|hr": [
    {
      german: "Welche Ministerin",
      translated: "Koji ministar",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "ne postoji",
      tone: 'semantic',
    },
    {
      german: "Nordrhein-Westfalen",
      translated: "Sjeverna Rajna-Vestfalija",
      tone: 'semantic',
    },
  ],
  "lid:state:NW:10|it": [
    {
      german: "Welche Ministerin",
      translated: "Quale ministro",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "esiste",
      tone: 'semantic',
    },
    {
      german: "Nordrhein-Westfalen",
      translated: "Land di Renania Settentrionale-Vestfalia",
      tone: 'semantic',
    },
    {
      german: "nicht",
      translated: "non",
      tone: 'semantic',
    },
  ],
  "lid:state:NW:10|kmr": [
    {
      german: "hat",
      translated: "tune",
      tone: 'semantic',
    },
    {
      german: "Nordrhein-Westfalen",
      translated: "Nordrhein-Westfalen",
      tone: 'semantic',
    },
    {
      german: "nicht",
      translated: "Kîjan wezîr",
      tone: 'semantic',
    },
  ],
  "lid:state:NW:10|pl": [
    {
      german: "welchen Minister",
      translated: "Którego ministra",
      tone: 'semantic',
    },
    {
      german: "Nordrhein-Westfalen",
      translated: "Nadrenia Północna-Westfalia",
      tone: 'semantic',
    },
    {
      german: "nicht",
      translated: "nie ma",
      tone: 'semantic',
    },
  ],
  "lid:state:NW:10|prs": [
    {
      german: "Welche Ministerin",
      translated: "کدام",
      tone: 'semantic',
    },
    {
      german: "welchen Minister",
      translated: "وزیر",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "وجود",
      tone: 'semantic',
    },
    {
      german: "Nordrhein-Westfalen",
      translated: "نوردراین-وستفالن",
      tone: 'semantic',
    },
    {
      german: "nicht",
      translated: "ندارد",
      tone: 'semantic',
    },
  ],
  "lid:state:NW:10|ro": [
    {
      german: "Welche Ministerin",
      translated: "Care ministru",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "există",
      tone: 'semantic',
    },
    {
      german: "Nordrhein-Westfalen",
      translated: "landului Renania de Nord-Westfalia",
      tone: 'semantic',
    },
    {
      german: "nicht",
      translated: "nu",
      tone: 'semantic',
    },
  ],
  "lid:state:NW:10|ru": [
    {
      german: "welchen Minister",
      translated: "Какого министра",
      tone: 'semantic',
    },
    {
      german: "Nordrhein-Westfalen",
      translated: "Северный Рейн-Вестфалия",
      tone: 'semantic',
    },
    {
      german: "nicht",
      translated: "нет",
      tone: 'semantic',
    },
  ],
  "lid:state:NW:10|sq": [
    {
      german: "welchen Minister",
      translated: "Cili ministër",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "ekziston",
      tone: 'semantic',
    },
    {
      german: "Nordrhein-Westfalen",
      translated: "Nordrhein-Westfalen",
      tone: 'semantic',
    },
    {
      german: "nicht",
      translated: "nuk",
      tone: 'semantic',
    },
  ],
  "lid:state:NW:10|sr": [
    {
      german: "Welche Ministerin",
      translated: "Koji ministar",
      tone: 'semantic',
    },
    {
      german: "Nordrhein-Westfalen",
      translated: "Severna Rajna-Vestfalija",
      tone: 'semantic',
    },
    {
      german: "nicht",
      translated: "ne postoji",
      tone: 'semantic',
    },
  ],
  "lid:state:NW:10|tr": [
    {
      german: "Welche Ministerin",
      translated: "aşağıdaki bakanlıklardan hangisi",
      tone: 'semantic',
    },
    {
      german: "Nordrhein-Westfalen",
      translated: "Nordrhein-Westfalen eyaletinde",
      tone: 'semantic',
    },
    {
      german: "nicht",
      translated: "yoktur",
      tone: 'semantic',
    },
  ],
  "lid:state:NW:10|uk": [
    {
      german: "Welche Ministerin",
      translated: "міністерки",
      tone: 'semantic',
    },
    {
      german: "welchen Minister",
      translated: "міністра",
      tone: 'semantic',
    },
    {
      german: "Nordrhein-Westfalen",
      translated: "Північний Рейн-Вестфалія",
      tone: 'semantic',
    },
    {
      german: "nicht",
      translated: "немає",
      tone: 'semantic',
    },
  ],
  "lid:state:NW:10|vi": [
    {
      german: "Welche Ministerin",
      translated: "Bộ trưởng nào",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "tồn tại",
      tone: 'semantic',
    },
    {
      german: "Nordrhein-Westfalen",
      translated: "Nordrhein-Westfalen",
      tone: 'semantic',
    },
    {
      german: "nicht",
      translated: "không",
      tone: 'semantic',
    },
  ],
  "lid:state:NW:1|ar": [
    {
      german: "Welches Wappen",
      translated: "أي شعار",
      tone: 'semantic',
    },
    {
      german: "gehört zum",
      translated: "من الصور",
      tone: 'semantic',
    },
    {
      german: "Bundesland",
      translated: "ولاية",
      tone: 'semantic',
    },
    {
      german: "Nordrhein-Westfalen",
      translated: "Nordrhein-Westfalen",
      tone: 'semantic',
    },
  ],
  "lid:state:NW:1|bg": [
    {
      german: "Welches Wappen",
      translated: "Кой герб",
      tone: 'semantic',
    },
    {
      german: "gehört zum",
      translated: "принадлежи на",
      tone: 'semantic',
    },
    {
      german: "Bundesland",
      translated: "федералната провинция",
      tone: 'semantic',
    },
    {
      german: "Nordrhein-Westfalen",
      translated: "Северен Рейн-Вестфалия",
      tone: 'semantic',
    },
  ],
  "lid:state:NW:1|bs": [
    {
      german: "Welches Wappen",
      translated: "Koji grb",
      tone: 'semantic',
    },
    {
      german: "gehört zum",
      translated: "pripada",
      tone: 'semantic',
    },
    {
      german: "Bundesland",
      translated: "saveznoj zemlji",
      tone: 'semantic',
    },
    {
      german: "Nordrhein-Westfalen",
      translated: "Sjeverna Rajna-Vestfalija",
      tone: 'semantic',
    },
  ],
  "lid:state:NW:1|el": [
    {
      german: "Welches Wappen",
      translated: "Ποιο έμβλημα",
      tone: 'semantic',
    },
    {
      german: "gehört zum",
      translated: "ανήκει στο",
      tone: 'semantic',
    },
    {
      german: "Bundesland",
      translated: "ομόσπονδο κρατίδιο",
      tone: 'semantic',
    },
    {
      german: "Nordrhein-Westfalen",
      translated: "Βόρεια Ρηνανία-Βεστφαλία",
      tone: 'semantic',
    },
  ],
  "lid:state:NW:1|en": [
    {
      german: "Welches Wappen",
      translated: "Which coat of arms",
      tone: 'semantic',
    },
    {
      german: "gehört zum",
      translated: "belongs to",
      tone: 'semantic',
    },
    {
      german: "Bundesland",
      translated: "the federal state of",
      tone: 'semantic',
    },
    {
      german: "Nordrhein-Westfalen",
      translated: "Nordrhein-Westfalen",
      tone: 'semantic',
    },
  ],
  "lid:state:NW:1|es": [
    {
      german: "Welches Wappen",
      translated: "Qué escudo",
      tone: 'semantic',
    },
    {
      german: "gehört zum",
      translated: "pertenece al",
      tone: 'semantic',
    },
    {
      german: "Bundesland",
      translated: "estado federado",
      tone: 'semantic',
    },
    {
      german: "Nordrhein-Westfalen",
      translated: "Renania del Norte-Westfalia",
      tone: 'semantic',
    },
  ],
  "lid:state:NW:1|fa": [
    {
      german: "Welches Wappen",
      translated: "کدام نشان",
      tone: 'semantic',
    },
    {
      german: "gehört zum",
      translated: "متعلق به",
      tone: 'semantic',
    },
    {
      german: "Bundesland",
      translated: "ایالت",
      tone: 'semantic',
    },
    {
      german: "Nordrhein-Westfalen",
      translated: "نوردراین-وستفالن",
      tone: 'semantic',
    },
  ],
  "lid:state:NW:1|fr": [
    {
      german: "Welches Wappen",
      translated: "Quel blason",
      tone: 'semantic',
    },
    {
      german: "gehört zum",
      translated: "appartient au",
      tone: 'semantic',
    },
    {
      german: "Bundesland",
      translated: "Land de",
      tone: 'semantic',
    },
    {
      german: "Nordrhein-Westfalen",
      translated: "Rhénanie-du-Nord-Westphalie",
      tone: 'semantic',
    },
  ],
  "lid:state:NW:1|hr": [
    {
      german: "Welches Wappen",
      translated: "Koji grb",
      tone: 'semantic',
    },
    {
      german: "gehört zum",
      translated: "pripada",
      tone: 'semantic',
    },
    {
      german: "Bundesland",
      translated: "saveznoj zemlji",
      tone: 'semantic',
    },
    {
      german: "Nordrhein-Westfalen",
      translated: "Sjeverna Rajna-Vestfalija",
      tone: 'semantic',
    },
  ],
  "lid:state:NW:1|it": [
    {
      german: "Welches Wappen",
      translated: "Quale stemma",
      tone: 'semantic',
    },
    {
      german: "gehört zum",
      translated: "appartiene al",
      tone: 'semantic',
    },
    {
      german: "Bundesland",
      translated: "Land",
      tone: 'semantic',
    },
    {
      german: "Nordrhein-Westfalen",
      translated: "Renania Settentrionale-Vestfalia",
      tone: 'semantic',
    },
  ],
  "lid:state:NW:1|kmr": [
    {
      german: "Welches Wappen",
      translated: "Kîjan nîşan",
      tone: 'semantic',
    },
    {
      german: "gehört zum",
      translated: "a",
      tone: 'semantic',
    },
    {
      german: "Bundesland",
      translated: "eyaleta",
      tone: 'semantic',
    },
    {
      german: "Nordrhein-Westfalen",
      translated: "Nordrhein-Westfalen",
      tone: 'semantic',
    },
  ],
  "lid:state:NW:1|pl": [
    {
      german: "Welches Wappen",
      translated: "Który herb",
      tone: 'semantic',
    },
    {
      german: "gehört zum",
      translated: "należy do",
      tone: 'semantic',
    },
    {
      german: "Bundesland",
      translated: "kraju związkowego",
      tone: 'semantic',
    },
    {
      german: "Nordrhein-Westfalen",
      translated: "Nadrenia Północna-Westfalia",
      tone: 'semantic',
    },
  ],
  "lid:state:NW:1|prs": [
    {
      german: "Welches Wappen",
      translated: "کدام نشان",
      tone: 'semantic',
    },
    {
      german: "gehört zum",
      translated: "متعلق به",
      tone: 'semantic',
    },
    {
      german: "Bundesland",
      translated: "ایالت",
      tone: 'semantic',
    },
    {
      german: "Nordrhein-Westfalen",
      translated: "نوردراین-وستفالن",
      tone: 'semantic',
    },
  ],
  "lid:state:NW:1|ro": [
    {
      german: "Welches Wappen",
      translated: "Care stemă",
      tone: 'semantic',
    },
    {
      german: "gehört zum",
      translated: "aparține",
      tone: 'semantic',
    },
    {
      german: "Bundesland",
      translated: "landului",
      tone: 'semantic',
    },
    {
      german: "Nordrhein-Westfalen",
      translated: "Renania de Nord-Westfalia",
      tone: 'semantic',
    },
  ],
  "lid:state:NW:1|ru": [
    {
      german: "Welches Wappen",
      translated: "Какой герб",
      tone: 'semantic',
    },
    {
      german: "gehört zum",
      translated: "принадлежит",
      tone: 'semantic',
    },
    {
      german: "Bundesland",
      translated: "федеральной земле",
      tone: 'semantic',
    },
    {
      german: "Nordrhein-Westfalen",
      translated: "Северный Рейн-Вестфалия",
      tone: 'semantic',
    },
  ],
  "lid:state:NW:1|sq": [
    {
      german: "Welches Wappen",
      translated: "Cila stemë",
      tone: 'semantic',
    },
    {
      german: "gehört zum",
      translated: "i përket",
      tone: 'semantic',
    },
    {
      german: "Bundesland",
      translated: "landit",
      tone: 'semantic',
    },
    {
      german: "Nordrhein-Westfalen",
      translated: "Nordrhein-Westfalen",
      tone: 'semantic',
    },
  ],
  "lid:state:NW:1|sr": [
    {
      german: "Welches Wappen",
      translated: "Koji grb",
      tone: 'semantic',
    },
    {
      german: "gehört zum",
      translated: "pripada",
      tone: 'semantic',
    },
    {
      german: "Bundesland",
      translated: "saveznoj pokrajini",
      tone: 'semantic',
    },
    {
      german: "Nordrhein-Westfalen",
      translated: "Severna Rajna-Vestfalija",
      tone: 'semantic',
    },
  ],
  "lid:state:NW:1|tr": [
    {
      german: "Welches Wappen",
      translated: "arması hangisidir",
      tone: 'semantic',
    },
    {
      german: "Bundesland",
      translated: "eyaletinin",
      tone: 'semantic',
    },
    {
      german: "Nordrhein-Westfalen",
      translated: "Nordrhein-Westfalen",
      tone: 'semantic',
    },
  ],
  "lid:state:NW:1|uk": [
    {
      german: "Welches Wappen",
      translated: "Який герб",
      tone: 'semantic',
    },
    {
      german: "gehört zum",
      translated: "належить",
      tone: 'semantic',
    },
    {
      german: "Bundesland",
      translated: "землі",
      tone: 'semantic',
    },
    {
      german: "Nordrhein-Westfalen",
      translated: "Північний Рейн-Вестфалія",
      tone: 'semantic',
    },
  ],
  "lid:state:NW:1|vi": [
    {
      german: "Welches Wappen",
      translated: "Quốc huy nào",
      tone: 'semantic',
    },
    {
      german: "gehört zum",
      translated: "thuộc",
      tone: 'semantic',
    },
    {
      german: "Bundesland",
      translated: "bang",
      tone: 'semantic',
    },
    {
      german: "Nordrhein-Westfalen",
      translated: "Nordrhein-Westfalen",
      tone: 'semantic',
    },
  ],
  "lid:state:NW:2|ar": [
    {
      german: "Welches",
      translated: "أي",
      tone: 'semantic',
    },
    {
      german: "Landkreis",
      translated: "دائرة إدارية (Landkreis)",
      tone: 'semantic',
    },
    {
      german: "Nordrhein-Westfalen",
      translated: "Nordrhein-Westfalen",
      tone: 'semantic',
    },
  ],
  "lid:state:NW:2|bg": [
    {
      german: "Welches",
      translated: "Кое",
      tone: 'semantic',
    },
    {
      german: "Landkreis",
      translated: "окръг",
      tone: 'semantic',
    },
    {
      german: "Nordrhein-Westfalen",
      translated: "Северен Рейн-Вестфалия",
      tone: 'semantic',
    },
  ],
  "lid:state:NW:2|bs": [
    {
      german: "Welches",
      translated: "Što",
      tone: 'semantic',
    },
    {
      german: "Landkreis",
      translated: "okrug (Landkreis)",
      tone: 'semantic',
    },
    {
      german: "Nordrhein-Westfalen",
      translated: "Sjeverna Rajna-Vestfalija",
      tone: 'semantic',
    },
  ],
  "lid:state:NW:2|el": [
    {
      german: "Welches",
      translated: "Ποιο",
      tone: 'semantic',
    },
    {
      german: "Landkreis",
      translated: "διοικητική περιφέρεια",
      tone: 'semantic',
    },
    {
      german: "Nordrhein-Westfalen",
      translated: "Βόρεια Ρηνανία-Βεστφαλία",
      tone: 'semantic',
    },
  ],
  "lid:state:NW:2|en": [
    {
      german: "Welches",
      translated: "Which",
      tone: 'semantic',
    },
    {
      german: "Landkreis",
      translated: "district",
      tone: 'semantic',
    },
    {
      german: "Nordrhein-Westfalen",
      translated: "Nordrhein-Westfalen",
      tone: 'semantic',
    },
  ],
  "lid:state:NW:2|es": [
    {
      german: "Welches",
      translated: "¿Cuál de los siguientes es un",
      tone: 'semantic',
    },
    {
      german: "Landkreis",
      translated: "distrito",
      tone: 'semantic',
    },
    {
      german: "Nordrhein-Westfalen",
      translated: "Renania del Norte-Westfalia",
      tone: 'semantic',
    },
  ],
  "lid:state:NW:2|fa": [
    {
      german: "Welches",
      translated: "کدام",
      tone: 'semantic',
    },
    {
      german: "Landkreis",
      translated: "شهرستان",
      tone: 'semantic',
    },
    {
      german: "Nordrhein-Westfalen",
      translated: "Landkreis) در نوردراین-وستفالن است؟",
      tone: 'semantic',
    },
  ],
  "lid:state:NW:2|fr": [
    {
      german: "Welches",
      translated: "Lequel",
      tone: 'semantic',
    },
    {
      german: "Landkreis",
      translated: "arrondissement (Landkreis)",
      tone: 'semantic',
    },
    {
      german: "Nordrhein-Westfalen",
      translated: "Rhénanie-du-Nord-Westphalie",
      tone: 'semantic',
    },
  ],
  "lid:state:NW:2|hr": [
    {
      german: "Welches",
      translated: "Što je od navedenoga",
      tone: 'semantic',
    },
    {
      german: "Landkreis",
      translated: "okrug (Landkreis)",
      tone: 'semantic',
    },
    {
      german: "Nordrhein-Westfalen",
      translated: "u saveznoj zemlji Sjeverna Rajna-Vestfalija",
      tone: 'semantic',
    },
  ],
  "lid:state:NW:2|it": [
    {
      german: "Welches",
      translated: "Quale",
      tone: 'semantic',
    },
    {
      german: "Landkreis",
      translated: "distretto (Landkreis)",
      tone: 'semantic',
    },
    {
      german: "Nordrhein-Westfalen",
      translated: "Renania Settentrionale-Vestfalia",
      tone: 'semantic',
    },
  ],
  "lid:state:NW:2|kmr": [
    {
      german: "Welches",
      translated: "Kîjan",
      tone: 'semantic',
    },
    {
      german: "Landkreis",
      translated: "navçeyek",
      tone: 'semantic',
    },
    {
      german: "Nordrhein-Westfalen",
      translated: "Nordrhein-Westfalen",
      tone: 'semantic',
    },
  ],
  "lid:state:NW:2|pl": [
    {
      german: "Welches",
      translated: "Który",
      tone: 'semantic',
    },
    {
      german: "Landkreis",
      translated: "powiatem (Landkreis)",
      tone: 'semantic',
    },
    {
      german: "Nordrhein-Westfalen",
      translated: "Nadrenia Północna-Westfalia",
      tone: 'semantic',
    },
  ],
  "lid:state:NW:2|prs": [
    {
      german: "Welches",
      translated: "کدام",
      tone: 'semantic',
    },
    {
      german: "Landkreis",
      translated: "شهرستان (Landkreis)",
      tone: 'semantic',
    },
    {
      german: "Nordrhein-Westfalen",
      translated: "نوردراین-وستفالن",
      tone: 'semantic',
    },
  ],
  "lid:state:NW:2|ro": [
    {
      german: "Welches",
      translated: "Care dintre",
      tone: 'semantic',
    },
    {
      german: "Landkreis",
      translated: "district (Landkreis)",
      tone: 'semantic',
    },
    {
      german: "Nordrhein-Westfalen",
      translated: "Renania de Nord-Westfalia",
      tone: 'semantic',
    },
  ],
  "lid:state:NW:2|ru": [
    {
      german: "Welches",
      translated: "Какой",
      tone: 'semantic',
    },
    {
      german: "Landkreis",
      translated: "районом",
      tone: 'semantic',
    },
    {
      german: "Nordrhein-Westfalen",
      translated: "Северный Рейн-Вестфалия",
      tone: 'semantic',
    },
  ],
  "lid:state:NW:2|sq": [
    {
      german: "Welches",
      translated: "Cila",
      tone: 'semantic',
    },
    {
      german: "Landkreis",
      translated: "qark (Landkreis)",
      tone: 'semantic',
    },
    {
      german: "Nordrhein-Westfalen",
      translated: "Nordrhein-Westfalen",
      tone: 'semantic',
    },
  ],
  "lid:state:NW:2|sr": [
    {
      german: "Welches",
      translated: "Šta",
      tone: 'semantic',
    },
    {
      german: "Landkreis",
      translated: "okrug",
      tone: 'semantic',
    },
    {
      german: "Nordrhein-Westfalen",
      translated: "Severna Rajna-Vestfalija",
      tone: 'semantic',
    },
  ],
  "lid:state:NW:2|tr": [
    {
      german: "Welches",
      translated: "Aşağıdakilerden hangisi",
      tone: 'semantic',
    },
    {
      german: "Landkreis",
      translated: "bir Landkreis (ilçe/idari bölge)dir",
      tone: 'semantic',
    },
    {
      german: "Nordrhein-Westfalen",
      translated: "Nordrhein-Westfalen eyaletinde bulunan",
      tone: 'semantic',
    },
  ],
  "lid:state:NW:2|uk": [
    {
      german: "Welches",
      translated: "Який",
      tone: 'semantic',
    },
    {
      german: "Landkreis",
      translated: "районів",
      tone: 'semantic',
    },
    {
      german: "Nordrhein-Westfalen",
      translated: "Північний Рейн-Вестфалія",
      tone: 'semantic',
    },
  ],
  "lid:state:NW:2|vi": [
    {
      german: "Welches",
      translated: "Địa danh nào sau đây",
      tone: 'semantic',
    },
    {
      german: "Landkreis",
      translated: "huyện (Landkreis)",
      tone: 'semantic',
    },
    {
      german: "Nordrhein-Westfalen",
      translated: "bang Nordrhein-Westfalen",
      tone: 'semantic',
    },
  ],
  "lid:state:NW:3|ar": [
    {
      german: "Für wie viele Jahre",
      translated: "لمدة كم سنة",
      tone: 'semantic',
    },
    {
      german: "der Landtag",
      translated: "برلمان الولاية",
      tone: 'semantic',
    },
    {
      german: "in Nordrhein-Westfalen",
      translated: "في Nordrhein-Westfalen",
      tone: 'semantic',
    },
    {
      german: "gewählt",
      translated: "يُنتخب",
      tone: 'semantic',
    },
  ],
  "lid:state:NW:3|bg": [
    {
      german: "Für wie viele Jahre",
      translated: "За колко години",
      tone: 'semantic',
    },
    {
      german: "der Landtag",
      translated: "парламентът",
      tone: 'semantic',
    },
    {
      german: "in Nordrhein-Westfalen",
      translated: "на провинция Северен Рейн-Вестфалия",
      tone: 'semantic',
    },
    {
      german: "gewählt",
      translated: "избира",
      tone: 'semantic',
    },
  ],
  "lid:state:NW:3|bs": [
    {
      german: "Für wie viele Jahre",
      translated: "Na koliko se godina",
      tone: 'semantic',
    },
    {
      german: "der Landtag",
      translated: "parlament savezne zemlje",
      tone: 'semantic',
    },
    {
      german: "in Nordrhein-Westfalen",
      translated: "Sjeverna Rajna-Vestfalija",
      tone: 'semantic',
    },
    {
      german: "gewählt",
      translated: "bira",
      tone: 'semantic',
    },
  ],
  "lid:state:NW:3|el": [
    {
      german: "Für wie viele Jahre",
      translated: "Για πόσα χρόνια",
      tone: 'semantic',
    },
    {
      german: "der Landtag",
      translated: "το Landtag",
      tone: 'semantic',
    },
    {
      german: "in Nordrhein-Westfalen",
      translated: "του Βόρεια Ρηνανία-Βεστφαλία",
      tone: 'semantic',
    },
    {
      german: "gewählt",
      translated: "εκλέγεται",
      tone: 'semantic',
    },
  ],
  "lid:state:NW:3|en": [
    {
      german: "Für wie viele Jahre",
      translated: "For how many years",
      tone: 'semantic',
    },
    {
      german: "der Landtag",
      translated: "the state parliament",
      tone: 'semantic',
    },
    {
      german: "in Nordrhein-Westfalen",
      translated: "in Nordrhein-Westfalen",
      tone: 'semantic',
    },
    {
      german: "gewählt",
      translated: "elected",
      tone: 'semantic',
    },
  ],
  "lid:state:NW:3|es": [
    {
      german: "Für wie viele Jahre",
      translated: "¿Por cuántos años",
      tone: 'semantic',
    },
    {
      german: "der Landtag",
      translated: "el parlamento regional",
      tone: 'semantic',
    },
    {
      german: "in Nordrhein-Westfalen",
      translated: "en Renania del Norte-Westfalia",
      tone: 'semantic',
    },
    {
      german: "gewählt",
      translated: "se elige",
      tone: 'semantic',
    },
  ],
  "lid:state:NW:3|fa": [
    {
      german: "Für wie viele Jahre",
      translated: "چند سال",
      tone: 'semantic',
    },
    {
      german: "der Landtag",
      translated: "پارلمان ایالتی",
      tone: 'semantic',
    },
    {
      german: "in Nordrhein-Westfalen",
      translated: "نوردراین-وستفالن",
      tone: 'semantic',
    },
    {
      german: "gewählt",
      translated: "انتخاب می‌شود؟",
      tone: 'semantic',
    },
  ],
  "lid:state:NW:3|fr": [
    {
      german: "Für wie viele Jahre",
      translated: "Pour combien d’années",
      tone: 'semantic',
    },
    {
      german: "der Landtag",
      translated: "le Landtag",
      tone: 'semantic',
    },
    {
      german: "in Nordrhein-Westfalen",
      translated: "de Rhénanie-du-Nord-Westphalie",
      tone: 'semantic',
    },
    {
      german: "gewählt",
      translated: "est-il élu",
      tone: 'semantic',
    },
  ],
  "lid:state:NW:3|hr": [
    {
      german: "Für wie viele Jahre",
      translated: "Na koliko se godina",
      tone: 'semantic',
    },
    {
      german: "der Landtag",
      translated: "parlament savezne zemlje",
      tone: 'semantic',
    },
    {
      german: "in Nordrhein-Westfalen",
      translated: "Sjeverna Rajna-Vestfalija",
      tone: 'semantic',
    },
    {
      german: "gewählt",
      translated: "bira",
      tone: 'semantic',
    },
  ],
  "lid:state:NW:3|it": [
    {
      german: "Für wie viele Jahre",
      translated: "Per quanti anni",
      tone: 'semantic',
    },
    {
      german: "der Landtag",
      translated: "il Landtag",
      tone: 'semantic',
    },
    {
      german: "in Nordrhein-Westfalen",
      translated: "di Renania Settentrionale-Vestfalia",
      tone: 'semantic',
    },
    {
      german: "gewählt",
      translated: "viene eletto",
      tone: 'semantic',
    },
  ],
  "lid:state:NW:3|kmr": [
    {
      german: "Für wie viele Jahre",
      translated: "çend salan",
      tone: 'semantic',
    },
    {
      german: "der Landtag",
      translated: "Landtag",
      tone: 'semantic',
    },
    {
      german: "in Nordrhein-Westfalen",
      translated: "a Nordrhein-Westfalen",
      tone: 'semantic',
    },
    {
      german: "gewählt",
      translated: "hilbijartin",
      tone: 'semantic',
    },
  ],
  "lid:state:NW:3|pl": [
    {
      german: "Für wie viele Jahre",
      translated: "Na ile lat",
      tone: 'semantic',
    },
    {
      german: "der Landtag",
      translated: "parlament",
      tone: 'semantic',
    },
    {
      german: "in Nordrhein-Westfalen",
      translated: "kraju związkowego Nadrenia Północna-Westfalia",
      tone: 'semantic',
    },
    {
      german: "gewählt",
      translated: "wybierany",
      tone: 'semantic',
    },
  ],
  "lid:state:NW:3|prs": [
    {
      german: "Für wie viele Jahre",
      translated: "چند سال",
      tone: 'semantic',
    },
    {
      german: "der Landtag",
      translated: "پارلمان ایالتی",
      tone: 'semantic',
    },
    {
      german: "in Nordrhein-Westfalen",
      translated: "نوردراین-وستفالن",
      tone: 'semantic',
    },
    {
      german: "gewählt",
      translated: "انتخاب می‌شود؟",
      tone: 'semantic',
    },
  ],
  "lid:state:NW:3|ro": [
    {
      german: "Für wie viele Jahre",
      translated: "Pentru câți ani",
      tone: 'semantic',
    },
    {
      german: "der Landtag",
      translated: "parlamentul landului",
      tone: 'semantic',
    },
    {
      german: "in Nordrhein-Westfalen",
      translated: "Renania de Nord-Westfalia",
      tone: 'semantic',
    },
    {
      german: "gewählt",
      translated: "este ales",
      tone: 'semantic',
    },
  ],
  "lid:state:NW:3|ru": [
    {
      german: "Für wie viele Jahre",
      translated: "На сколько лет",
      tone: 'semantic',
    },
    {
      german: "der Landtag",
      translated: "ландтаг",
      tone: 'semantic',
    },
    {
      german: "in Nordrhein-Westfalen",
      translated: "в федеральной земле Северный Рейн-Вестфалия",
      tone: 'semantic',
    },
    {
      german: "gewählt",
      translated: "избирается",
      tone: 'semantic',
    },
  ],
  "lid:state:NW:3|sq": [
    {
      german: "Für wie viele Jahre",
      translated: "Për sa vjet",
      tone: 'semantic',
    },
    {
      german: "der Landtag",
      translated: "Landtagu",
      tone: 'semantic',
    },
    {
      german: "in Nordrhein-Westfalen",
      translated: "i Nordrhein-Westfalen",
      tone: 'semantic',
    },
    {
      german: "gewählt",
      translated: "zgjidhet",
      tone: 'semantic',
    },
  ],
  "lid:state:NW:3|sr": [
    {
      german: "Für wie viele Jahre",
      translated: "Na koliko se godina",
      tone: 'semantic',
    },
    {
      german: "der Landtag",
      translated: "parlament savezne",
      tone: 'semantic',
    },
    {
      german: "in Nordrhein-Westfalen",
      translated: "Severna Rajna-Vestfalija",
      tone: 'semantic',
    },
    {
      german: "gewählt",
      translated: "bira",
      tone: 'semantic',
    },
  ],
  "lid:state:NW:3|tr": [
    {
      german: "Für wie viele Jahre",
      translated: "kaç yıllığına",
      tone: 'semantic',
    },
    {
      german: "der Landtag",
      translated: "eyalet parlamentosu",
      tone: 'semantic',
    },
    {
      german: "in Nordrhein-Westfalen",
      translated: "Nordrhein-Westfalen",
      tone: 'semantic',
    },
    {
      german: "gewählt",
      translated: "seçilir",
      tone: 'semantic',
    },
  ],
  "lid:state:NW:3|uk": [
    {
      german: "Für wie viele Jahre",
      translated: "На скільки років",
      tone: 'semantic',
    },
    {
      german: "der Landtag",
      translated: "земельний парламент",
      tone: 'semantic',
    },
    {
      german: "in Nordrhein-Westfalen",
      translated: "у федеральній землі Північний Рейн-Вестфалія",
      tone: 'semantic',
    },
    {
      german: "gewählt",
      translated: "обирають",
      tone: 'semantic',
    },
  ],
  "lid:state:NW:3|vi": [
    {
      german: "Für wie viele Jahre",
      translated: "bao nhiêu năm",
      tone: 'semantic',
    },
    {
      german: "der Landtag",
      translated: "Nghị viện bang (Landtag)",
      tone: 'semantic',
    },
    {
      german: "in Nordrhein-Westfalen",
      translated: "của Nordrhein-Westfalen",
      tone: 'semantic',
    },
    {
      german: "gewählt",
      translated: "được bầu",
      tone: 'semantic',
    },
  ],
  "lid:state:NW:4|ar": [
    {
      german: "Ab welchem Alter",
      translated: "ابتداءً من أي سن",
      tone: 'semantic',
    },
    {
      german: "darf man",
      translated: "يحق",
      tone: 'semantic',
    },
    {
      german: "in Nordrhein-Westfalen",
      translated: "Nordrhein-Westfalen",
      tone: 'semantic',
    },
    {
      german: "bei Kommunalwahlen",
      translated: "الانتخابات المحلية",
      tone: 'semantic',
    },
    {
      german: "wählen",
      translated: "التصويت",
      tone: 'semantic',
    },
  ],
  "lid:state:NW:4|bg": [
    {
      german: "Ab welchem Alter",
      translated: "От каква възраст",
      tone: 'semantic',
    },
    {
      german: "darf man",
      translated: "може да се",
      tone: 'semantic',
    },
    {
      german: "in Nordrhein-Westfalen",
      translated: "в Северен Рейн-Вестфалия",
      tone: 'semantic',
    },
    {
      german: "bei Kommunalwahlen",
      translated: "на общински избори",
      tone: 'semantic',
    },
    {
      german: "wählen",
      translated: "гласува",
      tone: 'semantic',
    },
  ],
  "lid:state:NW:4|bs": [
    {
      german: "Ab welchem Alter",
      translated: "Od koje se dobi",
      tone: 'semantic',
    },
    {
      german: "darf man",
      translated: "može",
      tone: 'semantic',
    },
    {
      german: "in Nordrhein-Westfalen",
      translated: "u saveznoj zemlji Sjeverna Rajna-Vestfalija",
      tone: 'semantic',
    },
    {
      german: "bei Kommunalwahlen",
      translated: "na lokalnim izborima",
      tone: 'semantic',
    },
    {
      german: "wählen",
      translated: "glasovati",
      tone: 'semantic',
    },
  ],
  "lid:state:NW:4|el": [
    {
      german: "Ab welchem Alter",
      translated: "Από ποια ηλικία",
      tone: 'semantic',
    },
    {
      german: "darf man",
      translated: "μπορεί κάποιος",
      tone: 'semantic',
    },
    {
      german: "in Nordrhein-Westfalen",
      translated: "στο Βόρεια Ρηνανία-Βεστφαλία",
      tone: 'semantic',
    },
    {
      german: "bei Kommunalwahlen",
      translated: "στις δημοτικές εκλογές",
      tone: 'semantic',
    },
    {
      german: "wählen",
      translated: "να ψηφίσει",
      tone: 'semantic',
    },
  ],
  "lid:state:NW:4|en": [
    {
      german: "Ab welchem Alter",
      translated: "From what age",
      tone: 'semantic',
    },
    {
      german: "darf man",
      translated: "can you",
      tone: 'semantic',
    },
    {
      german: "in Nordrhein-Westfalen",
      translated: "in Nordrhein-Westfalen",
      tone: 'semantic',
    },
    {
      german: "bei Kommunalwahlen",
      translated: "in local elections",
      tone: 'semantic',
    },
    {
      german: "wählen",
      translated: "vote",
      tone: 'semantic',
    },
  ],
  "lid:state:NW:4|es": [
    {
      german: "Ab welchem Alter",
      translated: "¿A partir de qué edad",
      tone: 'semantic',
    },
    {
      german: "darf man",
      translated: "se puede",
      tone: 'semantic',
    },
    {
      german: "in Nordrhein-Westfalen",
      translated: "de Renania del Norte-Westfalia",
      tone: 'semantic',
    },
    {
      german: "bei Kommunalwahlen",
      translated: "en las elecciones municipales",
      tone: 'semantic',
    },
    {
      german: "wählen",
      translated: "votar",
      tone: 'semantic',
    },
  ],
  "lid:state:NW:4|fa": [
    {
      german: "Ab welchem Alter",
      translated: "از چه سنی",
      tone: 'semantic',
    },
    {
      german: "darf man",
      translated: "می‌توان",
      tone: 'semantic',
    },
    {
      german: "in Nordrhein-Westfalen",
      translated: "در انتخابات محلی نوردراین-وستفالن",
      tone: 'semantic',
    },
    {
      german: "wählen",
      translated: "رأی داد",
      tone: 'semantic',
    },
  ],
  "lid:state:NW:4|fr": [
    {
      german: "Ab welchem Alter",
      translated: "À partir de quel âge",
      tone: 'semantic',
    },
    {
      german: "darf man",
      translated: "peut-on",
      tone: 'semantic',
    },
    {
      german: "in Nordrhein-Westfalen",
      translated: "en Rhénanie-du-Nord-Westphalie",
      tone: 'semantic',
    },
    {
      german: "bei Kommunalwahlen",
      translated: "aux élections municipales",
      tone: 'semantic',
    },
    {
      german: "wählen",
      translated: "voter",
      tone: 'semantic',
    },
  ],
  "lid:state:NW:4|hr": [
    {
      german: "Ab welchem Alter",
      translated: "Od koje se dobi",
      tone: 'semantic',
    },
    {
      german: "darf man",
      translated: "može",
      tone: 'semantic',
    },
    {
      german: "in Nordrhein-Westfalen",
      translated: "u saveznoj zemlji Sjeverna Rajna-Vestfalija",
      tone: 'semantic',
    },
    {
      german: "bei Kommunalwahlen",
      translated: "na lokalnim izborima",
      tone: 'semantic',
    },
    {
      german: "wählen",
      translated: "glasovati",
      tone: 'semantic',
    },
  ],
  "lid:state:NW:4|it": [
    {
      german: "Ab welchem Alter",
      translated: "Da quale età",
      tone: 'semantic',
    },
    {
      german: "darf man",
      translated: "si può",
      tone: 'semantic',
    },
    {
      german: "in Nordrhein-Westfalen",
      translated: "in Renania Settentrionale-Vestfalia",
      tone: 'semantic',
    },
    {
      german: "bei Kommunalwahlen",
      translated: "alle elezioni comunali",
      tone: 'semantic',
    },
    {
      german: "wählen",
      translated: "votare",
      tone: 'semantic',
    },
  ],
  "lid:state:NW:4|kmr": [
    {
      german: "Ab welchem Alter",
      translated: "Ji kîjan temenê",
      tone: 'semantic',
    },
    {
      german: "in Nordrhein-Westfalen",
      translated: "li Nordrhein-Westfalen",
      tone: 'semantic',
    },
    {
      german: "bei Kommunalwahlen",
      translated: "di hilbijartinên şaredariyê de",
      tone: 'semantic',
    },
    {
      german: "wählen",
      translated: "deng were dayîn",
      tone: 'semantic',
    },
  ],
  "lid:state:NW:4|pl": [
    {
      german: "Ab welchem Alter",
      translated: "Od jakiego wieku",
      tone: 'semantic',
    },
    {
      german: "darf man",
      translated: "można",
      tone: 'semantic',
    },
    {
      german: "in Nordrhein-Westfalen",
      translated: "w Nadrenia Północna-Westfalia",
      tone: 'semantic',
    },
    {
      german: "bei Kommunalwahlen",
      translated: "w wyborach samorządowych",
      tone: 'semantic',
    },
    {
      german: "wählen",
      translated: "głosować",
      tone: 'semantic',
    },
  ],
  "lid:state:NW:4|prs": [
    {
      german: "Ab welchem Alter",
      translated: "از چه سنی",
      tone: 'semantic',
    },
    {
      german: "darf man",
      translated: "می‌توان",
      tone: 'semantic',
    },
    {
      german: "in Nordrhein-Westfalen",
      translated: "نوردراین-وستفالن",
      tone: 'semantic',
    },
    {
      german: "bei Kommunalwahlen",
      translated: "در انتخابات شاروالی",
      tone: 'semantic',
    },
    {
      german: "wählen",
      translated: "رأی داد",
      tone: 'semantic',
    },
  ],
  "lid:state:NW:4|ro": [
    {
      german: "Ab welchem Alter",
      translated: "De la ce vârstă",
      tone: 'semantic',
    },
    {
      german: "darf man",
      translated: "se poate",
      tone: 'semantic',
    },
    {
      german: "in Nordrhein-Westfalen",
      translated: "din Renania de Nord-Westfalia",
      tone: 'semantic',
    },
    {
      german: "bei Kommunalwahlen",
      translated: "la alegerile locale",
      tone: 'semantic',
    },
    {
      german: "wählen",
      translated: "vota",
      tone: 'semantic',
    },
  ],
  "lid:state:NW:4|ru": [
    {
      german: "Ab welchem Alter",
      translated: "С какого возраста",
      tone: 'semantic',
    },
    {
      german: "darf man",
      translated: "можно",
      tone: 'semantic',
    },
    {
      german: "in Nordrhein-Westfalen",
      translated: "в федеральной земле Северный Рейн-Вестфалия",
      tone: 'semantic',
    },
    {
      german: "bei Kommunalwahlen",
      translated: "на муниципальных выборах",
      tone: 'semantic',
    },
    {
      german: "wählen",
      translated: "голосовать",
      tone: 'semantic',
    },
  ],
  "lid:state:NW:4|sq": [
    {
      german: "Ab welchem Alter",
      translated: "Nga cila moshë",
      tone: 'semantic',
    },
    {
      german: "darf man",
      translated: "mund të",
      tone: 'semantic',
    },
    {
      german: "in Nordrhein-Westfalen",
      translated: "në Nordrhein-Westfalen",
      tone: 'semantic',
    },
    {
      german: "bei Kommunalwahlen",
      translated: "në zgjedhjet komunale",
      tone: 'semantic',
    },
    {
      german: "wählen",
      translated: "votohet",
      tone: 'semantic',
    },
  ],
  "lid:state:NW:4|sr": [
    {
      german: "darf man",
      translated: "može",
      tone: 'semantic',
    },
    {
      german: "in Nordrhein-Westfalen",
      translated: "u saveznoj pokrajini Severna Rajna-Vestfalija",
      tone: 'semantic',
    },
    {
      german: "bei Kommunalwahlen",
      translated: "na lokalnim izborima",
      tone: 'semantic',
    },
  ],
  "lid:state:NW:4|tr": [
    {
      german: "Ab welchem Alter",
      translated: "kaç yaşından itibaren",
      tone: 'semantic',
    },
    {
      german: "in Nordrhein-Westfalen",
      translated: "Nordrhein-Westfalen eyaletinde",
      tone: 'semantic',
    },
    {
      german: "bei Kommunalwahlen",
      translated: "yerel seçimlerde",
      tone: 'semantic',
    },
    {
      german: "wählen",
      translated: "oy kullanılabilir",
      tone: 'semantic',
    },
  ],
  "lid:state:NW:4|uk": [
    {
      german: "Ab welchem Alter",
      translated: "З якого віку",
      tone: 'semantic',
    },
    {
      german: "in Nordrhein-Westfalen",
      translated: "у федеральній землі Північний Рейн-Вестфалія",
      tone: 'semantic',
    },
    {
      german: "bei Kommunalwahlen",
      translated: "на муніципальних виборах",
      tone: 'semantic',
    },
    {
      german: "wählen",
      translated: "можна голосувати",
      tone: 'semantic',
    },
  ],
  "lid:state:NW:4|vi": [
    {
      german: "Ab welchem Alter",
      translated: "Từ bao nhiêu tuổi",
      tone: 'semantic',
    },
    {
      german: "darf man",
      translated: "có thể",
      tone: 'semantic',
    },
    {
      german: "in Nordrhein-Westfalen",
      translated: "bỏ phiếu",
      tone: 'semantic',
    },
    {
      german: "bei Kommunalwahlen",
      translated: "trong bầu cử địa phương",
      tone: 'semantic',
    },
  ],
  "lid:state:NW:5|ar": [
    {
      german: "Welche Farben",
      translated: "ما",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "ألوان",
      tone: 'semantic',
    },
    {
      german: "die Landesflagge",
      translated: "علم",
      tone: 'semantic',
    },
    {
      german: "von Nordrhein-Westfalen",
      translated: "ولاية Nordrhein-Westfalen",
      tone: 'semantic',
    },
  ],
  "lid:state:NW:5|bg": [
    {
      german: "Welche Farben",
      translated: "Какви са",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "цветовете",
      tone: 'semantic',
    },
    {
      german: "die Landesflagge",
      translated: "знамето",
      tone: 'semantic',
    },
    {
      german: "von Nordrhein-Westfalen",
      translated: "на провинция Северен Рейн-Вестфалия",
      tone: 'semantic',
    },
  ],
  "lid:state:NW:5|bs": [
    {
      german: "Welche Farben",
      translated: "Koje su boje",
      tone: 'semantic',
    },
    {
      german: "die Landesflagge",
      translated: "zastave",
      tone: 'semantic',
    },
    {
      german: "von Nordrhein-Westfalen",
      translated: "savezne zemlje Sjeverna Rajna-Vestfalija",
      tone: 'semantic',
    },
  ],
  "lid:state:NW:5|el": [
    {
      german: "Welche Farben",
      translated: "Ποια είναι τα χρώματα",
      tone: 'semantic',
    },
    {
      german: "die Landesflagge",
      translated: "της σημαίας του κρατιδίου",
      tone: 'semantic',
    },
    {
      german: "von Nordrhein-Westfalen",
      translated: "Βόρεια Ρηνανία-Βεστφαλία",
      tone: 'semantic',
    },
  ],
  "lid:state:NW:5|en": [
    {
      german: "Welche Farben",
      translated: "What colors",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "does",
      tone: 'semantic',
    },
    {
      german: "die Landesflagge",
      translated: "the state flag",
      tone: 'semantic',
    },
    {
      german: "von Nordrhein-Westfalen",
      translated: "of Nordrhein-Westfalen",
      tone: 'semantic',
    },
  ],
  "lid:state:NW:5|es": [
    {
      german: "Welche Farben",
      translated: "¿Qué colores",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "tiene",
      tone: 'semantic',
    },
    {
      german: "die Landesflagge",
      translated: "la bandera regional",
      tone: 'semantic',
    },
    {
      german: "von Nordrhein-Westfalen",
      translated: "de Renania del Norte-Westfalia",
      tone: 'semantic',
    },
  ],
  "lid:state:NW:5|fa": [
    {
      german: "Welche Farben",
      translated: "رنگ‌های",
      tone: 'semantic',
    },
    {
      german: "die Landesflagge",
      translated: "پرچم ایالت",
      tone: 'semantic',
    },
    {
      german: "von Nordrhein-Westfalen",
      translated: "نوردراین-وستفالن",
      tone: 'semantic',
    },
  ],
  "lid:state:NW:5|fr": [
    {
      german: "Welche Farben",
      translated: "Quelles sont les couleurs",
      tone: 'semantic',
    },
    {
      german: "die Landesflagge",
      translated: "du drapeau du Land",
      tone: 'semantic',
    },
    {
      german: "von Nordrhein-Westfalen",
      translated: "de Rhénanie-du-Nord-Westphalie",
      tone: 'semantic',
    },
  ],
  "lid:state:NW:5|hr": [
    {
      german: "Welche Farben",
      translated: "Koje su boje",
      tone: 'semantic',
    },
    {
      german: "die Landesflagge",
      translated: "zastave",
      tone: 'semantic',
    },
    {
      german: "von Nordrhein-Westfalen",
      translated: "savezne zemlje Sjeverna Rajna-Vestfalija",
      tone: 'semantic',
    },
  ],
  "lid:state:NW:5|it": [
    {
      german: "Welche Farben",
      translated: "Quali sono i colori",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "del Land",
      tone: 'semantic',
    },
    {
      german: "die Landesflagge",
      translated: "bandiera",
      tone: 'semantic',
    },
    {
      german: "von Nordrhein-Westfalen",
      translated: "di Renania Settentrionale-Vestfalia",
      tone: 'semantic',
    },
  ],
  "lid:state:NW:5|kmr": [
    {
      german: "Welche Farben",
      translated: "Rengên",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "çi ne",
      tone: 'semantic',
    },
    {
      german: "die Landesflagge",
      translated: "ala eyaleta",
      tone: 'semantic',
    },
    {
      german: "von Nordrhein-Westfalen",
      translated: "Nordrhein-Westfalen",
      tone: 'semantic',
    },
  ],
  "lid:state:NW:5|pl": [
    {
      german: "Welche Farben",
      translated: "Jakie są kolory",
      tone: 'semantic',
    },
    {
      german: "die Landesflagge",
      translated: "flagi kraju związkowego",
      tone: 'semantic',
    },
    {
      german: "von Nordrhein-Westfalen",
      translated: "Nadrenia Północna-Westfalia",
      tone: 'semantic',
    },
  ],
  "lid:state:NW:5|prs": [
    {
      german: "Welche Farben",
      translated: "رنگ‌های",
      tone: 'semantic',
    },
    {
      german: "die Landesflagge",
      translated: "پرچم ایالت",
      tone: 'semantic',
    },
    {
      german: "von Nordrhein-Westfalen",
      translated: "نوردراین-وستفالن",
      tone: 'semantic',
    },
  ],
  "lid:state:NW:5|ro": [
    {
      german: "Welche Farben",
      translated: "Care sunt culorile",
      tone: 'semantic',
    },
    {
      german: "die Landesflagge",
      translated: "drapelului landului",
      tone: 'semantic',
    },
    {
      german: "von Nordrhein-Westfalen",
      translated: "Renania de Nord-Westfalia",
      tone: 'semantic',
    },
  ],
  "lid:state:NW:5|ru": [
    {
      german: "Welche Farben",
      translated: "Какие цвета",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "у",
      tone: 'semantic',
    },
    {
      german: "die Landesflagge",
      translated: "флага земли",
      tone: 'semantic',
    },
    {
      german: "von Nordrhein-Westfalen",
      translated: "Северный Рейн-Вестфалия",
      tone: 'semantic',
    },
  ],
  "lid:state:NW:5|sq": [
    {
      german: "Welche Farben",
      translated: "ngjyrat",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: " janë",
      tone: 'semantic',
    },
    {
      german: "die Landesflagge",
      translated: "flamurit të landit",
      tone: 'semantic',
    },
    {
      german: "von Nordrhein-Westfalen",
      translated: "Nordrhein-Westfalen",
      tone: 'semantic',
    },
  ],
  "lid:state:NW:5|sr": [
    {
      german: "Welche Farben",
      translated: "Koje su boje",
      tone: 'semantic',
    },
    {
      german: "die Landesflagge",
      translated: "zastave savezne pokrajine",
      tone: 'semantic',
    },
    {
      german: "von Nordrhein-Westfalen",
      translated: "Severna Rajna-Vestfalija",
      tone: 'semantic',
    },
  ],
  "lid:state:NW:5|tr": [
    {
      german: "Welche Farben",
      translated: "renkleri nelerdir",
      tone: 'semantic',
    },
    {
      german: "die Landesflagge",
      translated: "eyalet bayrağının",
      tone: 'semantic',
    },
    {
      german: "von Nordrhein-Westfalen",
      translated: "Nordrhein-Westfalen",
      tone: 'semantic',
    },
  ],
  "lid:state:NW:5|uk": [
    {
      german: "Welche Farben",
      translated: "Які кольори",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: " має",
      tone: 'semantic',
    },
    {
      german: "die Landesflagge",
      translated: "прапор федеральної землі",
      tone: 'semantic',
    },
    {
      german: "von Nordrhein-Westfalen",
      translated: "Північний Рейн-Вестфалія",
      tone: 'semantic',
    },
  ],
  "lid:state:NW:5|vi": [
    {
      german: "Welche Farben",
      translated: "Màu của",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "là",
      tone: 'semantic',
    },
    {
      german: "die Landesflagge",
      translated: "cờ bang",
      tone: 'semantic',
    },
    {
      german: "von Nordrhein-Westfalen",
      translated: "Nordrhein-Westfalen",
      tone: 'semantic',
    },
  ],
  "lid:state:NW:6|ar": [
    {
      german: "Wo",
      translated: "أين",
      tone: 'semantic',
    },
    {
      german: "können Sie sich",
      translated: "يمكنك",
      tone: 'semantic',
    },
    {
      german: "in Nordrhein-Westfalen",
      translated: "في Nordrhein-Westfalen",
      tone: 'semantic',
    },
    {
      german: "über politische Themen",
      translated: "عن القضايا السياسية",
      tone: 'semantic',
    },
    {
      german: "informieren",
      translated: "الحصول على معلومات",
      tone: 'semantic',
    },
  ],
  "lid:state:NW:6|bg": [
    {
      german: "Wo",
      translated: "Къде",
      tone: 'semantic',
    },
    {
      german: "können Sie sich",
      translated: "в Северен Рейн-Вестфалия",
      tone: 'semantic',
    },
    {
      german: "in Nordrhein-Westfalen",
      translated: "можете",
      tone: 'semantic',
    },
    {
      german: "über politische Themen",
      translated: "по политически теми",
      tone: 'semantic',
    },
    {
      german: "informieren",
      translated: "да получите информация",
      tone: 'semantic',
    },
  ],
  "lid:state:NW:6|bs": [
    {
      german: "Wo",
      translated: "Gdje",
      tone: 'semantic',
    },
    {
      german: "können Sie sich",
      translated: "se u saveznoj zemlji",
      tone: 'semantic',
    },
    {
      german: "in Nordrhein-Westfalen",
      translated: "Sjeverna Rajna-Vestfalija",
      tone: 'semantic',
    },
    {
      german: "über politische Themen",
      translated: "o političkim temama",
      tone: 'semantic',
    },
    {
      german: "informieren",
      translated: "mogu dobiti",
      tone: 'semantic',
    },
  ],
  "lid:state:NW:6|el": [
    {
      german: "Wo",
      translated: "Πού",
      tone: 'semantic',
    },
    {
      german: "können Sie sich",
      translated: "μπορείτε να",
      tone: 'semantic',
    },
    {
      german: "in Nordrhein-Westfalen",
      translated: "στο Βόρεια Ρηνανία-Βεστφαλία",
      tone: 'semantic',
    },
    {
      german: "über politische Themen",
      translated: "για πολιτικά θέματα",
      tone: 'semantic',
    },
    {
      german: "informieren",
      translated: "ενημερωθείτε",
      tone: 'semantic',
    },
  ],
  "lid:state:NW:6|en": [
    {
      german: "Wo",
      translated: "Where",
      tone: 'semantic',
    },
    {
      german: "können Sie sich",
      translated: "can you",
      tone: 'semantic',
    },
    {
      german: "in Nordrhein-Westfalen",
      translated: "in Nordrhein-Westfalen",
      tone: 'semantic',
    },
    {
      german: "über politische Themen",
      translated: "about political topics",
      tone: 'semantic',
    },
    {
      german: "informieren",
      translated: "get information",
      tone: 'semantic',
    },
  ],
  "lid:state:NW:6|es": [
    {
      german: "Wo",
      translated: "¿Dónde",
      tone: 'semantic',
    },
    {
      german: "können Sie sich",
      translated: "puede",
      tone: 'semantic',
    },
    {
      german: "in Nordrhein-Westfalen",
      translated: "en Renania del Norte-Westfalia",
      tone: 'semantic',
    },
    {
      german: "über politische Themen",
      translated: "sobre temas políticos",
      tone: 'semantic',
    },
    {
      german: "informieren",
      translated: "informarse",
      tone: 'semantic',
    },
  ],
  "lid:state:NW:6|fa": [
    {
      german: "Wo",
      translated: "کجا",
      tone: 'semantic',
    },
    {
      german: "können Sie sich",
      translated: "می‌توانید",
      tone: 'semantic',
    },
    {
      german: "in Nordrhein-Westfalen",
      translated: "در نوردراین-وستفالن",
      tone: 'semantic',
    },
    {
      german: "über politische Themen",
      translated: " دربارهٔ موضوعات سیاسی",
      tone: 'semantic',
    },
    {
      german: "informieren",
      translated: "اطلاعات کسب کنید",
      tone: 'semantic',
    },
  ],
  "lid:state:NW:6|fr": [
    {
      german: "Wo",
      translated: "Où",
      tone: 'semantic',
    },
    {
      german: "können Sie sich",
      translated: "pouvez-vous vous",
      tone: 'semantic',
    },
    {
      german: "in Nordrhein-Westfalen",
      translated: "en Rhénanie-du-Nord-Westphalie",
      tone: 'semantic',
    },
    {
      german: "über politische Themen",
      translated: "sur les questions politiques",
      tone: 'semantic',
    },
    {
      german: "informieren",
      translated: "informer",
      tone: 'semantic',
    },
  ],
  "lid:state:NW:6|hr": [
    {
      german: "Wo",
      translated: "Gdje",
      tone: 'semantic',
    },
    {
      german: "können Sie sich",
      translated: "mogu",
      tone: 'semantic',
    },
    {
      german: "in Nordrhein-Westfalen",
      translated: "u saveznoj zemlji Sjeverna Rajna-Vestfalija",
      tone: 'semantic',
    },
    {
      german: "über politische Themen",
      translated: "o političkim temama",
      tone: 'semantic',
    },
    {
      german: "informieren",
      translated: "dobiti informacije",
      tone: 'semantic',
    },
  ],
  "lid:state:NW:6|it": [
    {
      german: "Wo",
      translated: "Dove",
      tone: 'semantic',
    },
    {
      german: "können Sie sich",
      translated: "ci si può",
      tone: 'semantic',
    },
    {
      german: "in Nordrhein-Westfalen",
      translated: "in Renania Settentrionale-Vestfalia",
      tone: 'semantic',
    },
    {
      german: "über politische Themen",
      translated: "su temi politici",
      tone: 'semantic',
    },
    {
      german: "informieren",
      translated: "informare",
      tone: 'semantic',
    },
  ],
  "lid:state:NW:6|kmr": [
    {
      german: "Wo",
      translated: "Li",
      tone: 'semantic',
    },
    {
      german: "können Sie sich",
      translated: "bistînî",
      tone: 'semantic',
    },
    {
      german: "in Nordrhein-Westfalen",
      translated: "Nordrhein-Westfalen li",
      tone: 'semantic',
    },
    {
      german: "über politische Themen",
      translated: "li ser mijarên siyasî",
      tone: 'semantic',
    },
    {
      german: "informieren",
      translated: "agahdarî",
      tone: 'semantic',
    },
  ],
  "lid:state:NW:6|pl": [
    {
      german: "Wo",
      translated: "Gdzie",
      tone: 'semantic',
    },
    {
      german: "können Sie sich",
      translated: "można",
      tone: 'semantic',
    },
    {
      german: "in Nordrhein-Westfalen",
      translated: "w Nadrenii Północnej-Westfalii",
      tone: 'semantic',
    },
    {
      german: "über politische Themen",
      translated: "na tematy polityczne",
      tone: 'semantic',
    },
    {
      german: "informieren",
      translated: "uzyskać informacje",
      tone: 'semantic',
    },
  ],
  "lid:state:NW:6|prs": [
    {
      german: "Wo",
      translated: "کجا",
      tone: 'semantic',
    },
    {
      german: "können Sie sich",
      translated: "می‌توانید",
      tone: 'semantic',
    },
    {
      german: "in Nordrhein-Westfalen",
      translated: "در نوردراین-وستفالن",
      tone: 'semantic',
    },
    {
      german: "über politische Themen",
      translated: " دربارهٔ موضوعات سیاسی",
      tone: 'semantic',
    },
    {
      german: "informieren",
      translated: "اطلاعات کسب کنید",
      tone: 'semantic',
    },
  ],
  "lid:state:NW:6|ro": [
    {
      german: "Wo",
      translated: "Unde",
      tone: 'semantic',
    },
    {
      german: "können Sie sich",
      translated: "vă puteți",
      tone: 'semantic',
    },
    {
      german: "in Nordrhein-Westfalen",
      translated: "în Renania de Nord-Westfalia",
      tone: 'semantic',
    },
    {
      german: "über politische Themen",
      translated: "despre teme politice",
      tone: 'semantic',
    },
    {
      german: "informieren",
      translated: "informa",
      tone: 'semantic',
    },
  ],
  "lid:state:NW:6|ru": [
    {
      german: "Wo",
      translated: "Где",
      tone: 'semantic',
    },
    {
      german: "können Sie sich",
      translated: "в федеральной земле",
      tone: 'semantic',
    },
    {
      german: "in Nordrhein-Westfalen",
      translated: "Северный Рейн-Вестфалия",
      tone: 'semantic',
    },
    {
      german: "über politische Themen",
      translated: "о политических темах",
      tone: 'semantic',
    },
    {
      german: "informieren",
      translated: "можно получить",
      tone: 'semantic',
    },
  ],
  "lid:state:NW:6|sq": [
    {
      german: "Wo",
      translated: "Ku",
      tone: 'semantic',
    },
    {
      german: "können Sie sich",
      translated: "mund të",
      tone: 'semantic',
    },
    {
      german: "in Nordrhein-Westfalen",
      translated: "në Nordrhein-Westfalen",
      tone: 'semantic',
    },
    {
      german: "über politische Themen",
      translated: "për tema politike",
      tone: 'semantic',
    },
    {
      german: "informieren",
      translated: "informoheni",
      tone: 'semantic',
    },
  ],
  "lid:state:NW:6|sr": [
    {
      german: "Wo",
      translated: "Gdje",
      tone: 'semantic',
    },
    {
      german: "können Sie sich",
      translated: "mogu",
      tone: 'semantic',
    },
    {
      german: "in Nordrhein-Westfalen",
      translated: "u saveznoj pokrajini Severna Rajna-Vestfalija",
      tone: 'semantic',
    },
    {
      german: "über politische Themen",
      translated: "o političkim temama",
      tone: 'semantic',
    },
  ],
  "lid:state:NW:6|tr": [
    {
      german: "Wo",
      translated: "nereden",
      tone: 'semantic',
    },
    {
      german: "können Sie sich",
      translated: "eyaletinde",
      tone: 'semantic',
    },
    {
      german: "in Nordrhein-Westfalen",
      translated: "Nordrhein-Westfalen",
      tone: 'semantic',
    },
    {
      german: "über politische Themen",
      translated: "siyasi konular hakkında",
      tone: 'semantic',
    },
    {
      german: "informieren",
      translated: "bilgi alabilirsiniz",
      tone: 'semantic',
    },
  ],
  "lid:state:NW:6|uk": [
    {
      german: "Wo",
      translated: "Де",
      tone: 'semantic',
    },
    {
      german: "können Sie sich",
      translated: "можна",
      tone: 'semantic',
    },
    {
      german: "in Nordrhein-Westfalen",
      translated: "у федеральній землі Північний Рейн-Вестфалія",
      tone: 'semantic',
    },
    {
      german: "über politische Themen",
      translated: "про політичні питання",
      tone: 'semantic',
    },
    {
      german: "informieren",
      translated: "отримати інформацію",
      tone: 'semantic',
    },
  ],
  "lid:state:NW:6|vi": [
    {
      german: "Wo",
      translated: "ở đâu",
      tone: 'semantic',
    },
    {
      german: "können Sie sich",
      translated: "có thể tìm",
      tone: 'semantic',
    },
    {
      german: "in Nordrhein-Westfalen",
      translated: "bang Nordrhein-Westfalen",
      tone: 'semantic',
    },
    {
      german: "über politische Themen",
      translated: "về các chủ đề chính trị",
      tone: 'semantic',
    },
    {
      german: "informieren",
      translated: "thông tin",
      tone: 'semantic',
    },
  ],
  "lid:state:NW:7|ar": [
    {
      german: "Die Landeshauptstadt",
      translated: "ما عاصمة",
      tone: 'semantic',
    },
    {
      german: "von Nordrhein-Westfalen",
      translated: "ولاية Nordrhein-Westfalen",
      tone: 'semantic',
    },
  ],
  "lid:state:NW:7|bg": [
    {
      german: "Die Landeshauptstadt",
      translated: "Столицата",
      tone: 'semantic',
    },
    {
      german: "von Nordrhein-Westfalen",
      translated: "на федералната провинция Северен Рейн-Вестфалия",
      tone: 'semantic',
    },
    {
      german: "heißt",
      translated: "е",
      tone: 'semantic',
    },
  ],
  "lid:state:NW:7|bs": [
    {
      german: "Die Landeshauptstadt",
      translated: "Glavni grad",
      tone: 'semantic',
    },
    {
      german: "von Nordrhein-Westfalen",
      translated: "savezne zemlje Sjeverna Rajna-Vestfalija",
      tone: 'semantic',
    },
    {
      german: "heißt",
      translated: "je",
      tone: 'semantic',
    },
  ],
  "lid:state:NW:7|el": [
    {
      german: "Die Landeshauptstadt",
      translated: "Η πρωτεύουσα του ομόσπονδου κρατιδίου",
      tone: 'semantic',
    },
    {
      german: "von Nordrhein-Westfalen",
      translated: "Βόρεια Ρηνανία-Βεστφαλία",
      tone: 'semantic',
    },
    {
      german: "heißt",
      translated: "είναι",
      tone: 'semantic',
    },
  ],
  "lid:state:NW:7|en": [
    {
      german: "Die Landeshauptstadt",
      translated: "The state capital",
      tone: 'semantic',
    },
    {
      german: "von Nordrhein-Westfalen",
      translated: "of Nordrhein-Westfalen",
      tone: 'semantic',
    },
    {
      german: "heißt",
      translated: "is called",
      tone: 'semantic',
    },
  ],
  "lid:state:NW:7|es": [
    {
      german: "Die Landeshauptstadt",
      translated: "La capital del estado federado",
      tone: 'semantic',
    },
    {
      german: "von Nordrhein-Westfalen",
      translated: "de Renania del Norte-Westfalia",
      tone: 'semantic',
    },
    {
      german: "heißt",
      translated: "es …",
      tone: 'semantic',
    },
  ],
  "lid:state:NW:7|fa": [
    {
      german: "Die Landeshauptstadt",
      translated: "مرکز ایالت",
      tone: 'semantic',
    },
    {
      german: "von Nordrhein-Westfalen",
      translated: "نوردراین-وستفالن",
      tone: 'semantic',
    },
    {
      german: "heißt",
      translated: "است",
      tone: 'semantic',
    },
  ],
  "lid:state:NW:7|fr": [
    {
      german: "Die Landeshauptstadt",
      translated: "La capitale du Land",
      tone: 'semantic',
    },
    {
      german: "von Nordrhein-Westfalen",
      translated: "de Rhénanie-du-Nord-Westphalie",
      tone: 'semantic',
    },
    {
      german: "heißt",
      translated: "s’appelle …",
      tone: 'semantic',
    },
  ],
  "lid:state:NW:7|hr": [
    {
      german: "Die Landeshauptstadt",
      translated: "Glavni grad",
      tone: 'semantic',
    },
    {
      german: "von Nordrhein-Westfalen",
      translated: "savezne zemlje Sjeverna Rajna-Vestfalija",
      tone: 'semantic',
    },
    {
      german: "heißt",
      translated: "je",
      tone: 'semantic',
    },
  ],
  "lid:state:NW:7|it": [
    {
      german: "Die Landeshauptstadt",
      translated: "La capitale del Land",
      tone: 'semantic',
    },
    {
      german: "von Nordrhein-Westfalen",
      translated: "di Renania Settentrionale-Vestfalia",
      tone: 'semantic',
    },
    {
      german: "heißt",
      translated: "è",
      tone: 'semantic',
    },
  ],
  "lid:state:NW:7|kmr": [
    {
      german: "Die Landeshauptstadt",
      translated: "Paytexta eyaleta",
      tone: 'semantic',
    },
    {
      german: "von Nordrhein-Westfalen",
      translated: "Nordrhein-Westfalen",
      tone: 'semantic',
    },
  ],
  "lid:state:NW:7|pl": [
    {
      german: "Die Landeshauptstadt",
      translated: "Stolicą kraju związkowego",
      tone: 'semantic',
    },
    {
      german: "von Nordrhein-Westfalen",
      translated: "Nadrenia Północna-Westfalia",
      tone: 'semantic',
    },
    {
      german: "heißt",
      translated: "jest",
      tone: 'semantic',
    },
  ],
  "lid:state:NW:7|prs": [
    {
      german: "Die Landeshauptstadt",
      translated: "مرکز ایالت",
      tone: 'semantic',
    },
    {
      german: "von Nordrhein-Westfalen",
      translated: "نوردراین-وستفالن",
      tone: 'semantic',
    },
    {
      german: "heißt",
      translated: "است",
      tone: 'semantic',
    },
  ],
  "lid:state:NW:7|ro": [
    {
      german: "Die Landeshauptstadt",
      translated: "Capitala",
      tone: 'semantic',
    },
    {
      german: "von Nordrhein-Westfalen",
      translated: "Renania de Nord-Westfalia",
      tone: 'semantic',
    },
    {
      german: "heißt",
      translated: "este",
      tone: 'semantic',
    },
  ],
  "lid:state:NW:7|ru": [
    {
      german: "Die Landeshauptstadt",
      translated: "Столица земли",
      tone: 'semantic',
    },
    {
      german: "von Nordrhein-Westfalen",
      translated: "Северный Рейн-Вестфалия",
      tone: 'semantic',
    },
    {
      german: "heißt",
      translated: "называется",
      tone: 'semantic',
    },
  ],
  "lid:state:NW:7|sq": [
    {
      german: "Die Landeshauptstadt",
      translated: "Kryeqyteti i landit",
      tone: 'semantic',
    },
    {
      german: "von Nordrhein-Westfalen",
      translated: "Nordrhein-Westfalen",
      tone: 'semantic',
    },
    {
      german: "heißt",
      translated: "është",
      tone: 'semantic',
    },
  ],
  "lid:state:NW:7|sr": [
    {
      german: "Die Landeshauptstadt",
      translated: "Glavni grad",
      tone: 'semantic',
    },
    {
      german: "von Nordrhein-Westfalen",
      translated: "savezne pokrajine Severna Rajna-Vestfalija",
      tone: 'semantic',
    },
    {
      german: "heißt",
      translated: "je",
      tone: 'semantic',
    },
  ],
  "lid:state:NW:7|tr": [
    {
      german: "Die Landeshauptstadt",
      translated: "başkenti",
      tone: 'semantic',
    },
    {
      german: "von Nordrhein-Westfalen",
      translated: "Nordrhein-Westfalen eyaletinin",
      tone: 'semantic',
    },
  ],
  "lid:state:NW:7|uk": [
    {
      german: "Die Landeshauptstadt",
      translated: "Столиця",
      tone: 'semantic',
    },
    {
      german: "von Nordrhein-Westfalen",
      translated: "федеральної землі Північний Рейн-Вестфалія",
      tone: 'semantic',
    },
    {
      german: "heißt",
      translated: " називається",
      tone: 'semantic',
    },
  ],
  "lid:state:NW:7|vi": [
    {
      german: "Die Landeshauptstadt",
      translated: "Thủ phủ",
      tone: 'semantic',
    },
    {
      german: "von Nordrhein-Westfalen",
      translated: "của bang Nordrhein-Westfalen",
      tone: 'semantic',
    },
    {
      german: "heißt",
      translated: "là",
      tone: 'semantic',
    },
  ],
  "lid:state:NW:8|ar": [
    {
      german: "Welches Bundesland",
      translated: "أي صورة",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "تمثل موقع ولاية",
      tone: 'semantic',
    },
    {
      german: "Nordrhein-Westfalen",
      translated: "Nordrhein-Westfalen",
      tone: 'semantic',
    },
  ],
  "lid:state:NW:8|bg": [
    {
      german: "Welches Bundesland",
      translated: "Коя от показаните федерални провинции",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "е",
      tone: 'semantic',
    },
    {
      german: "Nordrhein-Westfalen",
      translated: "Северен Рейн-Вестфалия",
      tone: 'semantic',
    },
  ],
  "lid:state:NW:8|bs": [
    {
      german: "Welches Bundesland",
      translated: "Koja od prikazanih saveznih zemalja",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "je",
      tone: 'semantic',
    },
    {
      german: "Nordrhein-Westfalen",
      translated: "Sjeverna Rajna-Vestfalija",
      tone: 'semantic',
    },
  ],
  "lid:state:NW:8|el": [
    {
      german: "Welches Bundesland",
      translated: "Ποιο από τα εικονιζόμενα κρατίδια",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "είναι",
      tone: 'semantic',
    },
    {
      german: "Nordrhein-Westfalen",
      translated: "Βόρεια Ρηνανία-Βεστφαλία",
      tone: 'semantic',
    },
  ],
  "lid:state:NW:8|en": [
    {
      german: "Welches Bundesland",
      translated: "Which federal state",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "is",
      tone: 'semantic',
    },
    {
      german: "Nordrhein-Westfalen",
      translated: "Nordrhein-Westfalen",
      tone: 'semantic',
    },
  ],
  "lid:state:NW:8|es": [
    {
      german: "Welches Bundesland",
      translated: "¿Cuál de las imágenes corresponde al estado federado",
      tone: 'semantic',
    },
    {
      german: "Nordrhein-Westfalen",
      translated: "Renania del Norte-Westfalia",
      tone: 'semantic',
    },
  ],
  "lid:state:NW:8|fa": [
    {
      german: "Welches Bundesland",
      translated: "کدام ایالتِ",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "است",
      tone: 'semantic',
    },
    {
      german: "Nordrhein-Westfalen",
      translated: "نوردراین-وستفالن",
      tone: 'semantic',
    },
  ],
  "lid:state:NW:8|fr": [
    {
      german: "Welches Bundesland",
      translated: "Quel",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "représenté",
      tone: 'semantic',
    },
    {
      german: "Nordrhein-Westfalen",
      translated: "Rhénanie-du-Nord-Westphalie",
      tone: 'semantic',
    },
  ],
  "lid:state:NW:8|hr": [
    {
      german: "Welches Bundesland",
      translated: "Koja od prikazanih saveznih zemalja",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "je",
      tone: 'semantic',
    },
    {
      german: "Nordrhein-Westfalen",
      translated: "Sjeverna Rajna-Vestfalija",
      tone: 'semantic',
    },
  ],
  "lid:state:NW:8|it": [
    {
      german: "Welches Bundesland",
      translated: "Quale Land rappresentato è",
      tone: 'semantic',
    },
    {
      german: "Nordrhein-Westfalen",
      translated: "Renania Settentrionale-Vestfalia",
      tone: 'semantic',
    },
  ],
  "lid:state:NW:8|kmr": [
    {
      german: "Welches Bundesland",
      translated: "Kîjan eyalet",
      tone: 'semantic',
    },
    {
      german: "Nordrhein-Westfalen",
      translated: "Nordrhein-Westfalen",
      tone: 'semantic',
    },
  ],
  "lid:state:NW:8|pl": [
    {
      german: "Welches Bundesland",
      translated: "Który z przedstawionych krajów związkowych",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "to",
      tone: 'semantic',
    },
    {
      german: "Nordrhein-Westfalen",
      translated: "Nadrenia Północna-Westfalia",
      tone: 'semantic',
    },
  ],
  "lid:state:NW:8|prs": [
    {
      german: "Welches Bundesland",
      translated: "کدام ایالتِ نشان‌داده‌شده",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "است",
      tone: 'semantic',
    },
    {
      german: "Nordrhein-Westfalen",
      translated: "نوردراین-وستفالن",
      tone: 'semantic',
    },
  ],
  "lid:state:NW:8|ro": [
    {
      german: "Welches Bundesland",
      translated: "Care land reprezentat",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "este",
      tone: 'semantic',
    },
    {
      german: "Nordrhein-Westfalen",
      translated: "Renania de Nord-Westfalia",
      tone: 'semantic',
    },
  ],
  "lid:state:NW:8|ru": [
    {
      german: "Welches Bundesland",
      translated: "Какая из этих земель",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "—",
      tone: 'semantic',
    },
    {
      german: "Nordrhein-Westfalen",
      translated: "Северный Рейн-Вестфалия",
      tone: 'semantic',
    },
  ],
  "lid:state:NW:8|sq": [
    {
      german: "Welches Bundesland",
      translated: "Cili nga landet e paraqitura",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "është",
      tone: 'semantic',
    },
    {
      german: "Nordrhein-Westfalen",
      translated: "Nordrhein-Westfalen",
      tone: 'semantic',
    },
  ],
  "lid:state:NW:8|sr": [
    {
      german: "Welches Bundesland",
      translated: "Koja od prikazanih saveznih",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "je",
      tone: 'semantic',
    },
    {
      german: "Nordrhein-Westfalen",
      translated: "Severna Rajna-Vestfalija",
      tone: 'semantic',
    },
  ],
  "lid:state:NW:8|tr": [
    {
      german: "Welches Bundesland",
      translated: "hangi numarayla",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "gösterilmiştir",
      tone: 'semantic',
    },
    {
      german: "Nordrhein-Westfalen",
      translated: "Nordrhein-Westfalen",
      tone: 'semantic',
    },
  ],
  "lid:state:NW:8|uk": [
    {
      german: "Welches Bundesland",
      translated: "Яка з позначених федеральних земель",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "є",
      tone: 'semantic',
    },
    {
      german: "Nordrhein-Westfalen",
      translated: "Північний Рейн-Вестфалія",
      tone: 'semantic',
    },
  ],
  "lid:state:NW:8|vi": [
    {
      german: "Welches Bundesland",
      translated: "Bang nào",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "được hiển thị là",
      tone: 'semantic',
    },
    {
      german: "Nordrhein-Westfalen",
      translated: "Nordrhein-Westfalen",
      tone: 'semantic',
    },
  ],
  "lid:state:NW:9|ar": [
    {
      german: "Wie nennt man",
      translated: "ماذا يُسمى",
      tone: 'semantic',
    },
    {
      german: "die Regierungschefin/den Regierungschef",
      translated: "رئيس/رئيسة حكومة",
      tone: 'semantic',
    },
    {
      german: "in Nordrhein-Westfalen",
      translated: "ولاية Nordrhein-Westfalen",
      tone: 'semantic',
    },
  ],
  "lid:state:NW:9|bg": [
    {
      german: "Wie nennt man",
      translated: "Как се нарича",
      tone: 'semantic',
    },
    {
      german: "die Regierungschefin/den Regierungschef",
      translated: "ръководителят на правителството",
      tone: 'semantic',
    },
    {
      german: "in Nordrhein-Westfalen",
      translated: "на провинция Северен Рейн-Вестфалия",
      tone: 'semantic',
    },
  ],
  "lid:state:NW:9|bs": [
    {
      german: "Wie nennt man",
      translated: "Kako se zove",
      tone: 'semantic',
    },
    {
      german: "die Regierungschefin/den Regierungschef",
      translated: "šef vlade",
      tone: 'semantic',
    },
    {
      german: "in Nordrhein-Westfalen",
      translated: "savezne zemlje Sjeverna Rajna-Vestfalija",
      tone: 'semantic',
    },
  ],
  "lid:state:NW:9|el": [
    {
      german: "Wie nennt man",
      translated: "Πώς ονομάζεται",
      tone: 'semantic',
    },
    {
      german: "die Regierungschefin/den Regierungschef",
      translated: "ο επικεφαλής της κυβέρνησης",
      tone: 'semantic',
    },
    {
      german: "in Nordrhein-Westfalen",
      translated: "του κρατιδίου Βόρεια Ρηνανία-Βεστφαλία",
      tone: 'semantic',
    },
  ],
  "lid:state:NW:9|en": [
    {
      german: "Wie nennt man",
      translated: "What is the head",
      tone: 'semantic',
    },
    {
      german: "die Regierungschefin/den Regierungschef",
      translated: "of government called in",
      tone: 'semantic',
    },
    {
      german: "in Nordrhein-Westfalen",
      translated: "Nordrhein-Westfalen?",
      tone: 'semantic',
    },
  ],
  "lid:state:NW:9|es": [
    {
      german: "Wie nennt man",
      translated: "¿Cómo se llama al",
      tone: 'semantic',
    },
    {
      german: "die Regierungschefin/den Regierungschef",
      translated: "jefe o la jefa de gobierno de",
      tone: 'semantic',
    },
    {
      german: "in Nordrhein-Westfalen",
      translated: "Renania del Norte-Westfalia",
      tone: 'semantic',
    },
  ],
  "lid:state:NW:9|fa": [
    {
      german: "Wie nennt man",
      translated: "رئیس دولت ایالت",
      tone: 'semantic',
    },
    {
      german: "die Regierungschefin/den Regierungschef",
      translated: "نوردراین-وستفالن چه عنوانی دارد",
      tone: 'semantic',
    },
    {
      german: "in Nordrhein-Westfalen",
      translated: "؟",
      tone: 'semantic',
    },
  ],
  "lid:state:NW:9|fr": [
    {
      german: "Wie nennt man",
      translated: "Comment appelle-t-on",
      tone: 'semantic',
    },
    {
      german: "die Regierungschefin/den Regierungschef",
      translated: "le chef ou la cheffe du gouvernement",
      tone: 'semantic',
    },
    {
      german: "in Nordrhein-Westfalen",
      translated: "de Rhénanie-du-Nord-Westphalie",
      tone: 'semantic',
    },
  ],
  "lid:state:NW:9|hr": [
    {
      german: "Wie nennt man",
      translated: "Kako se zove",
      tone: 'semantic',
    },
    {
      german: "die Regierungschefin/den Regierungschef",
      translated: "čelnik vlade savezne zemlje",
      tone: 'semantic',
    },
    {
      german: "in Nordrhein-Westfalen",
      translated: "Sjeverna Rajna-Vestfalija",
      tone: 'semantic',
    },
  ],
  "lid:state:NW:9|it": [
    {
      german: "Wie nennt man",
      translated: "Come si chiama",
      tone: 'semantic',
    },
    {
      german: "die Regierungschefin/den Regierungschef",
      translated: "il capo del governo",
      tone: 'semantic',
    },
    {
      german: "in Nordrhein-Westfalen",
      translated: "del Land di Renania Settentrionale-Vestfalia",
      tone: 'semantic',
    },
  ],
  "lid:state:NW:9|kmr": [
    {
      german: "Wie nennt man",
      translated: "Serokê",
      tone: 'semantic',
    },
    {
      german: "die Regierungschefin/den Regierungschef",
      translated: "hukûmeta",
      tone: 'semantic',
    },
    {
      german: "in Nordrhein-Westfalen",
      translated: "Nordrhein-Westfalen",
      tone: 'semantic',
    },
  ],
  "lid:state:NW:9|pl": [
    {
      german: "Wie nennt man",
      translated: "Jak nazywa się",
      tone: 'semantic',
    },
    {
      german: "die Regierungschefin/den Regierungschef",
      translated: "szef rządu kraju związkowego",
      tone: 'semantic',
    },
    {
      german: "in Nordrhein-Westfalen",
      translated: "Nadrenia Północna-Westfalia",
      tone: 'semantic',
    },
  ],
  "lid:state:NW:9|prs": [
    {
      german: "Wie nennt man",
      translated: "چه عنوانی دارد؟",
      tone: 'semantic',
    },
    {
      german: "die Regierungschefin/den Regierungschef",
      translated: "رئیس دولت",
      tone: 'semantic',
    },
    {
      german: "in Nordrhein-Westfalen",
      translated: "ایالت نوردراین-وستفالن",
      tone: 'semantic',
    },
  ],
  "lid:state:NW:9|ro": [
    {
      german: "Wie nennt man",
      translated: "Cum se numește",
      tone: 'semantic',
    },
    {
      german: "die Regierungschefin/den Regierungschef",
      translated: "șeful guvernului",
      tone: 'semantic',
    },
    {
      german: "in Nordrhein-Westfalen",
      translated: "landului Renania de Nord-Westfalia",
      tone: 'semantic',
    },
  ],
  "lid:state:NW:9|ru": [
    {
      german: "Wie nennt man",
      translated: "Как называют",
      tone: 'semantic',
    },
    {
      german: "die Regierungschefin/den Regierungschef",
      translated: "главу правительства",
      tone: 'semantic',
    },
    {
      german: "in Nordrhein-Westfalen",
      translated: "в федеральной земле Северный Рейн-Вестфалия",
      tone: 'semantic',
    },
  ],
  "lid:state:NW:9|sq": [
    {
      german: "Wie nennt man",
      translated: "Si quhet kreu",
      tone: 'semantic',
    },
    {
      german: "die Regierungschefin/den Regierungschef",
      translated: "i qeverisë së landit",
      tone: 'semantic',
    },
    {
      german: "in Nordrhein-Westfalen",
      translated: "Nordrhein-Westfalen",
      tone: 'semantic',
    },
  ],
  "lid:state:NW:9|sr": [
    {
      german: "Wie nennt man",
      translated: "Kako se zove",
      tone: 'semantic',
    },
    {
      german: "die Regierungschefin/den Regierungschef",
      translated: "šef vlade savezne pokrajine",
      tone: 'semantic',
    },
    {
      german: "in Nordrhein-Westfalen",
      translated: "Severna Rajna-Vestfalija",
      tone: 'semantic',
    },
  ],
  "lid:state:NW:9|tr": [
    {
      german: "Wie nennt man",
      translated: "ne ad verilir?",
      tone: 'semantic',
    },
    {
      german: "die Regierungschefin/den Regierungschef",
      translated: "hükümetinin başındaki kişiye",
      tone: 'semantic',
    },
    {
      german: "in Nordrhein-Westfalen",
      translated: "Nordrhein-Westfalen",
      tone: 'semantic',
    },
  ],
  "lid:state:NW:9|uk": [
    {
      german: "Wie nennt man",
      translated: "Як називають",
      tone: 'semantic',
    },
    {
      german: "die Regierungschefin/den Regierungschef",
      translated: "главу уряду",
      tone: 'semantic',
    },
    {
      german: "in Nordrhein-Westfalen",
      translated: "федеральної землі Північний Рейн-Вестфалія",
      tone: 'semantic',
    },
  ],
  "lid:state:NW:9|vi": [
    {
      german: "Wie nennt man",
      translated: "Người đứng đầu chính phủ",
      tone: 'semantic',
    },
    {
      german: "die Regierungschefin/den Regierungschef",
      translated: "bang",
      tone: 'semantic',
    },
    {
      german: "in Nordrhein-Westfalen",
      translated: "Nordrhein-Westfalen",
      tone: 'semantic',
    },
  ],
  "lid:state:RP:10|ar": [
    {
      german: "Welche Ministerin",
      translated: "أي وزارة",
      tone: 'semantic',
    },
    {
      german: "welchen Minister",
      translated: "من الوزارات التالية",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "غير موجودة",
      tone: 'semantic',
    },
    {
      german: "Rheinland-Pfalz",
      translated: "Rheinland-Pfalz",
      tone: 'semantic',
    },
    {
      german: "nicht",
      translated: "على مستوى ولاية",
      tone: 'semantic',
    },
  ],
  "lid:state:RP:10|bg": [
    {
      german: "Welche Ministerin",
      translated: "Кой министър",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "съществува",
      tone: 'semantic',
    },
    {
      german: "Rheinland-Pfalz",
      translated: "Райнланд-Пфалц",
      tone: 'semantic',
    },
    {
      german: "nicht",
      translated: "не",
      tone: 'semantic',
    },
  ],
  "lid:state:RP:10|bs": [
    {
      german: "Welche Ministerin",
      translated: "Koji ministar",
      tone: 'semantic',
    },
    {
      german: "Rheinland-Pfalz",
      translated: "savezne zemlje Porajnje-Falačka",
      tone: 'semantic',
    },
    {
      german: "nicht",
      translated: "ne postoji",
      tone: 'semantic',
    },
  ],
  "lid:state:RP:10|el": [
    {
      german: "welchen Minister",
      translated: "Ποιος υπουργός",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "δεν υπάρχει",
      tone: 'semantic',
    },
    {
      german: "Rheinland-Pfalz",
      translated: "σε επίπεδο κρατιδίου στο Ρηνανία-Παλατινάτο",
      tone: 'semantic',
    },
  ],
  "lid:state:RP:10|en": [
    {
      german: "welchen Minister",
      translated: "Which minister",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "does",
      tone: 'semantic',
    },
    {
      german: "Rheinland-Pfalz",
      translated: "Rheinland-Pfalz",
      tone: 'semantic',
    },
    {
      german: "nicht",
      translated: "not have",
      tone: 'semantic',
    },
  ],
  "lid:state:RP:10|es": [
    {
      german: "welchen Minister",
      translated: "ministerio",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "existe",
      tone: 'semantic',
    },
    {
      german: "Rheinland-Pfalz",
      translated: "Renania-Palatinado",
      tone: 'semantic',
    },
    {
      german: "nicht",
      translated: "NO",
      tone: 'semantic',
    },
  ],
  "lid:state:RP:10|fa": [
    {
      german: "Welche Ministerin",
      translated: "کدام",
      tone: 'semantic',
    },
    {
      german: "welchen Minister",
      translated: "وزیر",
      tone: 'semantic',
    },
    {
      german: "Rheinland-Pfalz",
      translated: "راینلاند-فالتس",
      tone: 'semantic',
    },
    {
      german: "nicht",
      translated: "وجود ندارد",
      tone: 'semantic',
    },
  ],
  "lid:state:RP:10|fr": [
    {
      german: "Welche Ministerin",
      translated: "quelle ministre",
      tone: 'semantic',
    },
    {
      german: "welchen Minister",
      translated: "Quel ministre",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "existe",
      tone: 'semantic',
    },
    {
      german: "Rheinland-Pfalz",
      translated: "Rhénanie-Palatinat",
      tone: 'semantic',
    },
    {
      german: "nicht",
      translated: "pas",
      tone: 'semantic',
    },
  ],
  "lid:state:RP:10|hr": [
    {
      german: "Welche Ministerin",
      translated: "Koji ministar",
      tone: 'semantic',
    },
    {
      german: "Rheinland-Pfalz",
      translated: "savezne zemlje Porajnje-Falačka",
      tone: 'semantic',
    },
    {
      german: "nicht",
      translated: "ne postoji",
      tone: 'semantic',
    },
  ],
  "lid:state:RP:10|it": [
    {
      german: "Welche Ministerin",
      translated: "Quale ministro",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "esiste",
      tone: 'semantic',
    },
    {
      german: "Rheinland-Pfalz",
      translated: "Land di Renania-Palatinato",
      tone: 'semantic',
    },
    {
      german: "nicht",
      translated: "non",
      tone: 'semantic',
    },
  ],
  "lid:state:RP:10|kmr": [
    {
      german: "Welche Ministerin",
      translated: "Kîjan wezîr",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "tune ye",
      tone: 'semantic',
    },
    {
      german: "Rheinland-Pfalz",
      translated: "Rheinland-Pfalz",
      tone: 'semantic',
    },
  ],
  "lid:state:RP:10|pl": [
    {
      german: "welchen Minister",
      translated: "Którego ministra",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "ma",
      tone: 'semantic',
    },
    {
      german: "Rheinland-Pfalz",
      translated: "Nadrenia-Palatynat",
      tone: 'semantic',
    },
    {
      german: "nicht",
      translated: "nie",
      tone: 'semantic',
    },
  ],
  "lid:state:RP:10|prs": [
    {
      german: "Welche Ministerin",
      translated: "کدام",
      tone: 'semantic',
    },
    {
      german: "welchen Minister",
      translated: "وزیر",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "وجود",
      tone: 'semantic',
    },
    {
      german: "Rheinland-Pfalz",
      translated: "راینلاند-فالتس",
      tone: 'semantic',
    },
    {
      german: "nicht",
      translated: "ندارد",
      tone: 'semantic',
    },
  ],
  "lid:state:RP:10|ro": [
    {
      german: "Welche Ministerin",
      translated: "Care ministru",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "există",
      tone: 'semantic',
    },
    {
      german: "Rheinland-Pfalz",
      translated: "Renania-Palatinat",
      tone: 'semantic',
    },
    {
      german: "nicht",
      translated: "nu",
      tone: 'semantic',
    },
  ],
  "lid:state:RP:10|ru": [
    {
      german: "Welche Ministerin",
      translated: "Какого",
      tone: 'semantic',
    },
    {
      german: "welchen Minister",
      translated: "министра",
      tone: 'semantic',
    },
    {
      german: "Rheinland-Pfalz",
      translated: "Рейнланд-Пфальц",
      tone: 'semantic',
    },
    {
      german: "nicht",
      translated: "нет",
      tone: 'semantic',
    },
  ],
  "lid:state:RP:10|sq": [
    {
      german: "Welche Ministerin",
      translated: "Cili ministër",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "ekziston",
      tone: 'semantic',
    },
    {
      german: "Rheinland-Pfalz",
      translated: "Rheinland-Pfalz",
      tone: 'semantic',
    },
    {
      german: "nicht",
      translated: "nuk",
      tone: 'semantic',
    },
  ],
  "lid:state:RP:10|sr": [
    {
      german: "welchen Minister",
      translated: "Koji ministar",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "ne postoji",
      tone: 'semantic',
    },
    {
      german: "Rheinland-Pfalz",
      translated: "na razini savezne pokrajine Rajna-Palatinat",
      tone: 'semantic',
    },
  ],
  "lid:state:RP:10|tr": [
    {
      german: "Welche Ministerin",
      translated: "aşağıdaki bakanlıklardan hangisi",
      tone: 'semantic',
    },
    {
      german: "Rheinland-Pfalz",
      translated: "Rheinland-Pfalz eyaletinde",
      tone: 'semantic',
    },
    {
      german: "nicht",
      translated: "yoktur",
      tone: 'semantic',
    },
  ],
  "lid:state:RP:10|uk": [
    {
      german: "Welche Ministerin",
      translated: "міністерки",
      tone: 'semantic',
    },
    {
      german: "welchen Minister",
      translated: "міністра",
      tone: 'semantic',
    },
    {
      german: "Rheinland-Pfalz",
      translated: "федеральній землі Рейнланд-Пфальц",
      tone: 'semantic',
    },
    {
      german: "nicht",
      translated: "немає",
      tone: 'semantic',
    },
  ],
  "lid:state:RP:10|vi": [
    {
      german: "Welche Ministerin",
      translated: "Bộ trưởng nào",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "tồn tại",
      tone: 'semantic',
    },
    {
      german: "Rheinland-Pfalz",
      translated: "Rheinland-Pfalz",
      tone: 'semantic',
    },
    {
      german: "nicht",
      translated: "không",
      tone: 'semantic',
    },
  ],
  "lid:state:RP:1|ar": [
    {
      german: "Welches Wappen",
      translated: "أي شعار من الصور",
      tone: 'semantic',
    },
    {
      german: "gehört zum",
      translated: "يعود إلى",
      tone: 'semantic',
    },
    {
      german: "Bundesland Rheinland-Pfalz",
      translated: "ولاية Rheinland-Pfalz؟",
      tone: 'semantic',
    },
  ],
  "lid:state:RP:1|bg": [
    {
      german: "Welches Wappen",
      translated: "Кой герб",
      tone: 'semantic',
    },
    {
      german: "gehört zum",
      translated: "принадлежи на",
      tone: 'semantic',
    },
    {
      german: "Bundesland Rheinland-Pfalz",
      translated: "федералната провинция Райнланд-Пфалц",
      tone: 'semantic',
    },
  ],
  "lid:state:RP:1|bs": [
    {
      german: "Welches Wappen",
      translated: "Koji grb",
      tone: 'semantic',
    },
    {
      german: "gehört zum",
      translated: "pripada",
      tone: 'semantic',
    },
    {
      german: "Bundesland Rheinland-Pfalz",
      translated: "saveznoj zemlji Porajnje-Falačka",
      tone: 'semantic',
    },
  ],
  "lid:state:RP:1|el": [
    {
      german: "Welches Wappen",
      translated: "Ποιο έμβλημα",
      tone: 'semantic',
    },
    {
      german: "gehört zum",
      translated: "ανήκει στο",
      tone: 'semantic',
    },
    {
      german: "Bundesland Rheinland-Pfalz",
      translated: "ομόσπονδο κρατίδιο Ρηνανία-Παλατινάτο",
      tone: 'semantic',
    },
  ],
  "lid:state:RP:1|en": [
    {
      german: "Welches Wappen",
      translated: "Which coat of arms",
      tone: 'semantic',
    },
    {
      german: "gehört zum",
      translated: "belongs to",
      tone: 'semantic',
    },
    {
      german: "Bundesland Rheinland-Pfalz",
      translated: "federal state of Rheinland-Pfalz",
      tone: 'semantic',
    },
  ],
  "lid:state:RP:1|es": [
    {
      german: "Welches Wappen",
      translated: "¿Qué escudo",
      tone: 'semantic',
    },
    {
      german: "gehört zum",
      translated: "pertenece al",
      tone: 'semantic',
    },
    {
      german: "Bundesland Rheinland-Pfalz",
      translated: "estado federado de Renania-Palatinado",
      tone: 'semantic',
    },
  ],
  "lid:state:RP:1|fa": [
    {
      german: "Welches Wappen",
      translated: "نشان",
      tone: 'semantic',
    },
    {
      german: "gehört zum",
      translated: "متعلق به",
      tone: 'semantic',
    },
    {
      german: "Bundesland Rheinland-Pfalz",
      translated: "ایالت راینلاند-فالتس",
      tone: 'semantic',
    },
  ],
  "lid:state:RP:1|fr": [
    {
      german: "Welches Wappen",
      translated: "Quel blason",
      tone: 'semantic',
    },
    {
      german: "gehört zum",
      translated: "appartient au",
      tone: 'semantic',
    },
    {
      german: "Bundesland Rheinland-Pfalz",
      translated: "Land de Rhénanie-Palatinat",
      tone: 'semantic',
    },
  ],
  "lid:state:RP:1|hr": [
    {
      german: "Welches Wappen",
      translated: "Koji grb",
      tone: 'semantic',
    },
    {
      german: "gehört zum",
      translated: "pripada",
      tone: 'semantic',
    },
    {
      german: "Bundesland Rheinland-Pfalz",
      translated: "saveznoj zemlji Porajnje-Falačka",
      tone: 'semantic',
    },
  ],
  "lid:state:RP:1|it": [
    {
      german: "Welches Wappen",
      translated: "Quale stemma",
      tone: 'semantic',
    },
    {
      german: "gehört zum",
      translated: "appartiene al",
      tone: 'semantic',
    },
    {
      german: "Bundesland Rheinland-Pfalz",
      translated: "Land di Renania-Palatinato",
      tone: 'semantic',
    },
  ],
  "lid:state:RP:1|kmr": [
    {
      german: "Welches Wappen",
      translated: "nîşan",
      tone: 'semantic',
    },
    {
      german: "gehört zum",
      translated: "ye?",
      tone: 'semantic',
    },
    {
      german: "Bundesland Rheinland-Pfalz",
      translated: "Rheinland-Pfalz",
      tone: 'semantic',
    },
  ],
  "lid:state:RP:1|pl": [
    {
      german: "Welches Wappen",
      translated: "Który herb",
      tone: 'semantic',
    },
    {
      german: "gehört zum",
      translated: "należy do",
      tone: 'semantic',
    },
    {
      german: "Bundesland Rheinland-Pfalz",
      translated: "Nadrenia-Palatynat",
      tone: 'semantic',
    },
  ],
  "lid:state:RP:1|prs": [
    {
      german: "Welches Wappen",
      translated: "کدام نشان",
      tone: 'semantic',
    },
    {
      german: "Bundesland Rheinland-Pfalz",
      translated: "ایالت راینلاند-فالتس",
      tone: 'semantic',
    },
  ],
  "lid:state:RP:1|ro": [
    {
      german: "Welches Wappen",
      translated: "Care stemă",
      tone: 'semantic',
    },
    {
      german: "gehört zum",
      translated: "aparține",
      tone: 'semantic',
    },
    {
      german: "Bundesland Rheinland-Pfalz",
      translated: "landului Renania-Palatinat",
      tone: 'semantic',
    },
  ],
  "lid:state:RP:1|ru": [
    {
      german: "Welches Wappen",
      translated: "Какой герб",
      tone: 'semantic',
    },
    {
      german: "gehört zum",
      translated: "принадлежит",
      tone: 'semantic',
    },
    {
      german: "Bundesland Rheinland-Pfalz",
      translated: "федеральной земле Рейнланд-Пфальц",
      tone: 'semantic',
    },
  ],
  "lid:state:RP:1|sq": [
    {
      german: "Welches Wappen",
      translated: "Cila stemë",
      tone: 'semantic',
    },
    {
      german: "gehört zum",
      translated: "i përket",
      tone: 'semantic',
    },
    {
      german: "Bundesland Rheinland-Pfalz",
      translated: "landit Rheinland-Pfalz",
      tone: 'semantic',
    },
  ],
  "lid:state:RP:1|sr": [
    {
      german: "Welches Wappen",
      translated: "Koji grb",
      tone: 'semantic',
    },
    {
      german: "gehört zum",
      translated: "pripada",
      tone: 'semantic',
    },
    {
      german: "Bundesland Rheinland-Pfalz",
      translated: "saveznoj pokrajini Rajna-Palatinat",
      tone: 'semantic',
    },
  ],
  "lid:state:RP:1|tr": [
    {
      german: "Welches Wappen",
      translated: "arması hangisidir",
      tone: 'semantic',
    },
    {
      german: "Bundesland Rheinland-Pfalz",
      translated: "Rheinland-Pfalz eyaletinin",
      tone: 'semantic',
    },
  ],
  "lid:state:RP:1|uk": [
    {
      german: "Welches Wappen",
      translated: "Який герб",
      tone: 'semantic',
    },
    {
      german: "gehört zum",
      translated: "належить",
      tone: 'semantic',
    },
    {
      german: "Bundesland Rheinland-Pfalz",
      translated: "федеральній землі Рейнланд-Пфальц",
      tone: 'semantic',
    },
  ],
  "lid:state:RP:1|vi": [
    {
      german: "Welches Wappen",
      translated: "Quốc huy nào",
      tone: 'semantic',
    },
    {
      german: "gehört zum",
      translated: "thuộc",
      tone: 'semantic',
    },
    {
      german: "Bundesland Rheinland-Pfalz",
      translated: "bang Rheinland-Pfalz",
      tone: 'semantic',
    },
  ],
  "lid:state:RP:2|ar": [
    {
      german: "Welches ist",
      translated: "أي مما يلي",
      tone: 'semantic',
    },
    {
      german: "ein Landkreis",
      translated: "دائرة إدارية (Landkreis)",
      tone: 'semantic',
    },
    {
      german: "in Rheinland-Pfalz",
      translated: "Rheinland-Pfalz",
      tone: 'semantic',
    },
  ],
  "lid:state:RP:2|bg": [
    {
      german: "Welches ist",
      translated: "Кое",
      tone: 'semantic',
    },
    {
      german: "ein Landkreis",
      translated: "от следните е окръг (Landkreis)",
      tone: 'semantic',
    },
    {
      german: "in Rheinland-Pfalz",
      translated: "в Райнланд-Пфалц?",
      tone: 'semantic',
    },
  ],
  "lid:state:RP:2|bs": [
    {
      german: "Welches ist",
      translated: "Što je",
      tone: 'semantic',
    },
    {
      german: "ein Landkreis",
      translated: "okrug (Landkreis)",
      tone: 'semantic',
    },
    {
      german: "in Rheinland-Pfalz",
      translated: "u saveznoj zemlji Porajnje-Falačka",
      tone: 'semantic',
    },
  ],
  "lid:state:RP:2|el": [
    {
      german: "Welches ist",
      translated: "Ποιο από τα παρακάτω",
      tone: 'semantic',
    },
    {
      german: "ein Landkreis",
      translated: "διοικητική περιφέρεια (Landkreis)",
      tone: 'semantic',
    },
    {
      german: "in Rheinland-Pfalz",
      translated: "στο Ρηνανία-Παλατινάτο",
      tone: 'semantic',
    },
  ],
  "lid:state:RP:2|en": [
    {
      german: "Welches ist",
      translated: "Which",
      tone: 'semantic',
    },
    {
      german: "ein Landkreis",
      translated: "a district",
      tone: 'semantic',
    },
    {
      german: "in Rheinland-Pfalz",
      translated: "Rheinland-Pfalz",
      tone: 'semantic',
    },
  ],
  "lid:state:RP:2|es": [
    {
      german: "Welches ist",
      translated: "¿Cuál de los siguientes es",
      tone: 'semantic',
    },
    {
      german: "ein Landkreis",
      translated: "un distrito (Landkreis)",
      tone: 'semantic',
    },
    {
      german: "in Rheinland-Pfalz",
      translated: "de Renania-Palatinado",
      tone: 'semantic',
    },
  ],
  "lid:state:RP:2|fa": [
    {
      german: "Welches ist",
      translated: "کدام‌یک از",
      tone: 'semantic',
    },
    {
      german: "ein Landkreis",
      translated: "شهرستان (Landkreis)",
      tone: 'semantic',
    },
    {
      german: "in Rheinland-Pfalz",
      translated: "در راینلاند-فالتس",
      tone: 'semantic',
    },
  ],
  "lid:state:RP:2|fr": [
    {
      german: "Welches ist",
      translated: "Lequel des",
      tone: 'semantic',
    },
    {
      german: "ein Landkreis",
      translated: "un arrondissement",
      tone: 'semantic',
    },
    {
      german: "in Rheinland-Pfalz",
      translated: "de Rhénanie-Palatinat",
      tone: 'semantic',
    },
  ],
  "lid:state:RP:2|hr": [
    {
      german: "Welches ist",
      translated: "Što je",
      tone: 'semantic',
    },
    {
      german: "ein Landkreis",
      translated: "okrug (Landkreis)",
      tone: 'semantic',
    },
    {
      german: "in Rheinland-Pfalz",
      translated: "u saveznoj zemlji Porajnje-Falačka",
      tone: 'semantic',
    },
  ],
  "lid:state:RP:2|it": [
    {
      german: "Welches ist",
      translated: "Quale dei seguenti è",
      tone: 'semantic',
    },
    {
      german: "ein Landkreis",
      translated: "un distretto (Landkreis)",
      tone: 'semantic',
    },
    {
      german: "in Rheinland-Pfalz",
      translated: "di Renania-Palatinato",
      tone: 'semantic',
    },
  ],
  "lid:state:RP:2|kmr": [
    {
      german: "Welches ist",
      translated: "Kîjan",
      tone: 'semantic',
    },
    {
      german: "ein Landkreis",
      translated: "ji van navçeyek (Landkreis)",
      tone: 'semantic',
    },
    {
      german: "in Rheinland-Pfalz",
      translated: "li Rheinland-Pfalz ye?",
      tone: 'semantic',
    },
  ],
  "lid:state:RP:2|pl": [
    {
      german: "Welches ist",
      translated: "Który z",
      tone: 'semantic',
    },
    {
      german: "ein Landkreis",
      translated: "powiatem (Landkreis)",
      tone: 'semantic',
    },
    {
      german: "in Rheinland-Pfalz",
      translated: "Nadrenia-Palatynat",
      tone: 'semantic',
    },
  ],
  "lid:state:RP:2|prs": [
    {
      german: "Welches ist",
      translated: "کدام‌یک از",
      tone: 'semantic',
    },
    {
      german: "ein Landkreis",
      translated: "شهرستان (Landkreis)",
      tone: 'semantic',
    },
    {
      german: "in Rheinland-Pfalz",
      translated: "در راینلاند-فالتس",
      tone: 'semantic',
    },
  ],
  "lid:state:RP:2|ro": [
    {
      german: "Welches ist",
      translated: "Care dintre următoarele este",
      tone: 'semantic',
    },
    {
      german: "ein Landkreis",
      translated: "un district",
      tone: 'semantic',
    },
    {
      german: "in Rheinland-Pfalz",
      translated: "din Renania-Palatinat",
      tone: 'semantic',
    },
  ],
  "lid:state:RP:2|ru": [
    {
      german: "Welches ist",
      translated: "Какой из перечисленных",
      tone: 'semantic',
    },
    {
      german: "ein Landkreis",
      translated: "районом",
      tone: 'semantic',
    },
    {
      german: "in Rheinland-Pfalz",
      translated: "в федеральной земле Рейнланд-Пфальц",
      tone: 'semantic',
    },
  ],
  "lid:state:RP:2|sq": [
    {
      german: "Welches ist",
      translated: "Cila nga këto është një",
      tone: 'semantic',
    },
    {
      german: "ein Landkreis",
      translated: "qark (Landkreis)",
      tone: 'semantic',
    },
    {
      german: "in Rheinland-Pfalz",
      translated: "në Rheinland-Pfalz",
      tone: 'semantic',
    },
  ],
  "lid:state:RP:2|sr": [
    {
      german: "Welches ist",
      translated: "Šta je",
      tone: 'semantic',
    },
    {
      german: "ein Landkreis",
      translated: "od navedenoga okrug (Landkreis)",
      tone: 'semantic',
    },
    {
      german: "in Rheinland-Pfalz",
      translated: "u saveznoj pokrajini Rajna-Palatinat?",
      tone: 'semantic',
    },
  ],
  "lid:state:RP:2|tr": [
    {
      german: "Welches ist",
      translated: "Aşağıdakilerden hangisi",
      tone: 'semantic',
    },
    {
      german: "ein Landkreis",
      translated: "bir Landkreis (ilçe/idari bölge)",
      tone: 'semantic',
    },
    {
      german: "in Rheinland-Pfalz",
      translated: "Rheinland-Pfalz eyaletinde bulunan",
      tone: 'semantic',
    },
  ],
  "lid:state:RP:2|uk": [
    {
      german: "Welches ist",
      translated: "Який із",
      tone: 'semantic',
    },
    {
      german: "ein Landkreis",
      translated: "районів",
      tone: 'semantic',
    },
    {
      german: "in Rheinland-Pfalz",
      translated: "у федеральній землі Рейнланд-Пфальц",
      tone: 'semantic',
    },
  ],
  "lid:state:RP:2|vi": [
    {
      german: "Welches ist",
      translated: "Địa danh nào sau đây là",
      tone: 'semantic',
    },
    {
      german: "ein Landkreis",
      translated: "một huyện",
      tone: 'semantic',
    },
    {
      german: "in Rheinland-Pfalz",
      translated: "của bang Rheinland-Pfalz",
      tone: 'semantic',
    },
  ],
  "lid:state:RP:3|ar": [
    {
      german: "Für wie viele Jahre",
      translated: "لمدة كم سنة",
      tone: 'semantic',
    },
    {
      german: "wird der Landtag",
      translated: "برلمان الولاية في",
      tone: 'semantic',
    },
    {
      german: "in Rheinland-Pfalz",
      translated: "Rheinland-Pfalz",
      tone: 'semantic',
    },
    {
      german: "gewählt",
      translated: "يُنتخب",
      tone: 'semantic',
    },
  ],
  "lid:state:RP:3|bg": [
    {
      german: "Für wie viele Jahre",
      translated: "За колко години",
      tone: 'semantic',
    },
    {
      german: "wird der Landtag",
      translated: "се избира парламентът",
      tone: 'semantic',
    },
    {
      german: "in Rheinland-Pfalz",
      translated: "на провинция Райнланд-Пфалц",
      tone: 'semantic',
    },
  ],
  "lid:state:RP:3|bs": [
    {
      german: "Für wie viele Jahre",
      translated: "Na koliko se godina",
      tone: 'semantic',
    },
    {
      german: "wird der Landtag",
      translated: "bira parlament",
      tone: 'semantic',
    },
    {
      german: "in Rheinland-Pfalz",
      translated: "savezne zemlje Porajnje-Falačka",
      tone: 'semantic',
    },
  ],
  "lid:state:RP:3|el": [
    {
      german: "Für wie viele Jahre",
      translated: "Για πόσα χρόνια",
      tone: 'semantic',
    },
    {
      german: "wird der Landtag",
      translated: "εκλέγεται το Landtag",
      tone: 'semantic',
    },
    {
      german: "in Rheinland-Pfalz",
      translated: "του Ρηνανία-Παλατινάτο",
      tone: 'semantic',
    },
  ],
  "lid:state:RP:3|en": [
    {
      german: "Für wie viele Jahre",
      translated: "For how many years",
      tone: 'semantic',
    },
    {
      german: "wird der Landtag",
      translated: "is the state parliament",
      tone: 'semantic',
    },
    {
      german: "in Rheinland-Pfalz",
      translated: "in Rheinland-Pfalz",
      tone: 'semantic',
    },
    {
      german: "gewählt",
      translated: "elected",
      tone: 'semantic',
    },
  ],
  "lid:state:RP:3|es": [
    {
      german: "Für wie viele Jahre",
      translated: "¿Por cuántos años",
      tone: 'semantic',
    },
    {
      german: "wird der Landtag",
      translated: "se elige el parlamento regional",
      tone: 'semantic',
    },
    {
      german: "in Rheinland-Pfalz",
      translated: "en Renania-Palatinado",
      tone: 'semantic',
    },
  ],
  "lid:state:RP:3|fa": [
    {
      german: "Für wie viele Jahre",
      translated: "چند سال",
      tone: 'semantic',
    },
    {
      german: "wird der Landtag",
      translated: "پارلمان ایالتی",
      tone: 'semantic',
    },
    {
      german: "in Rheinland-Pfalz",
      translated: "راینلاند-فالتس",
      tone: 'semantic',
    },
    {
      german: "gewählt",
      translated: "انتخاب می‌شود؟",
      tone: 'semantic',
    },
  ],
  "lid:state:RP:3|fr": [
    {
      german: "Für wie viele Jahre",
      translated: "Pour combien d’années",
      tone: 'semantic',
    },
    {
      german: "wird der Landtag",
      translated: "le Landtag",
      tone: 'semantic',
    },
    {
      german: "in Rheinland-Pfalz",
      translated: "de Rhénanie-Palatinat",
      tone: 'semantic',
    },
    {
      german: "gewählt",
      translated: "élu",
      tone: 'semantic',
    },
  ],
  "lid:state:RP:3|hr": [
    {
      german: "Für wie viele Jahre",
      translated: "Na koliko se godina bira",
      tone: 'semantic',
    },
    {
      german: "wird der Landtag",
      translated: "parlament savezne zemlje Porajnje-Falačka",
      tone: 'semantic',
    },
  ],
  "lid:state:RP:3|it": [
    {
      german: "Für wie viele Jahre",
      translated: "Per quanti anni",
      tone: 'semantic',
    },
    {
      german: "wird der Landtag",
      translated: "viene eletto il Landtag",
      tone: 'semantic',
    },
    {
      german: "in Rheinland-Pfalz",
      translated: "di Renania-Palatinato",
      tone: 'semantic',
    },
  ],
  "lid:state:RP:3|kmr": [
    {
      german: "Für wie viele Jahre",
      translated: "ji bo çend salan",
      tone: 'semantic',
    },
    {
      german: "wird der Landtag",
      translated: "Landtag",
      tone: 'semantic',
    },
    {
      german: "in Rheinland-Pfalz",
      translated: "a Rheinland-Pfalz",
      tone: 'semantic',
    },
    {
      german: "gewählt",
      translated: "tê hilbijartin",
      tone: 'semantic',
    },
  ],
  "lid:state:RP:3|pl": [
    {
      german: "Für wie viele Jahre",
      translated: "Na ile lat",
      tone: 'semantic',
    },
    {
      german: "wird der Landtag",
      translated: "wybierany jest parlament",
      tone: 'semantic',
    },
    {
      german: "in Rheinland-Pfalz",
      translated: "Nadrenia-Palatynat",
      tone: 'semantic',
    },
  ],
  "lid:state:RP:3|prs": [
    {
      german: "Für wie viele Jahre",
      translated: "چند سال",
      tone: 'semantic',
    },
    {
      german: "wird der Landtag",
      translated: "پارلمان ایالتی",
      tone: 'semantic',
    },
    {
      german: "in Rheinland-Pfalz",
      translated: "راینلاند-فالتس",
      tone: 'semantic',
    },
    {
      german: "gewählt",
      translated: "انتخاب می‌شود",
      tone: 'semantic',
    },
  ],
  "lid:state:RP:3|ro": [
    {
      german: "Für wie viele Jahre",
      translated: "Pentru câți ani",
      tone: 'semantic',
    },
    {
      german: "wird der Landtag",
      translated: "este ales parlamentul",
      tone: 'semantic',
    },
    {
      german: "in Rheinland-Pfalz",
      translated: "landului Renania-Palatinat",
      tone: 'semantic',
    },
  ],
  "lid:state:RP:3|ru": [
    {
      german: "Für wie viele Jahre",
      translated: "На сколько лет",
      tone: 'semantic',
    },
    {
      german: "wird der Landtag",
      translated: "избирается ландтаг",
      tone: 'semantic',
    },
    {
      german: "in Rheinland-Pfalz",
      translated: "в федеральной земле Рейнланд-Пфальц",
      tone: 'semantic',
    },
  ],
  "lid:state:RP:3|sq": [
    {
      german: "Für wie viele Jahre",
      translated: "Për sa vjet",
      tone: 'semantic',
    },
    {
      german: "wird der Landtag",
      translated: "Landtagu i",
      tone: 'semantic',
    },
    {
      german: "in Rheinland-Pfalz",
      translated: "Rheinland-Pfalz",
      tone: 'semantic',
    },
    {
      german: "gewählt",
      translated: "zgjidhet",
      tone: 'semantic',
    },
  ],
  "lid:state:RP:3|sr": [
    {
      german: "Für wie viele Jahre",
      translated: "Na koliko se godina",
      tone: 'semantic',
    },
    {
      german: "wird der Landtag",
      translated: "bira parlament",
      tone: 'semantic',
    },
    {
      german: "in Rheinland-Pfalz",
      translated: "savezne pokrajine Rajna-Palatinat",
      tone: 'semantic',
    },
  ],
  "lid:state:RP:3|tr": [
    {
      german: "Für wie viele Jahre",
      translated: "kaç yıllığına",
      tone: 'semantic',
    },
    {
      german: "wird der Landtag",
      translated: "eyalet parlamentosu",
      tone: 'semantic',
    },
    {
      german: "in Rheinland-Pfalz",
      translated: "Rheinland-Pfalz",
      tone: 'semantic',
    },
    {
      german: "gewählt",
      translated: "seçilir",
      tone: 'semantic',
    },
  ],
  "lid:state:RP:3|uk": [
    {
      german: "Für wie viele Jahre",
      translated: "На скільки років",
      tone: 'semantic',
    },
    {
      german: "wird der Landtag",
      translated: "обирають земельний парламент",
      tone: 'semantic',
    },
    {
      german: "in Rheinland-Pfalz",
      translated: "у федеральній землі Рейнланд-Пфальц",
      tone: 'semantic',
    },
  ],
  "lid:state:RP:3|vi": [
    {
      german: "Für wie viele Jahre",
      translated: "bao nhiêu năm",
      tone: 'semantic',
    },
    {
      german: "in Rheinland-Pfalz",
      translated: "của Rheinland-Pfalz",
      tone: 'semantic',
    },
    {
      german: "gewählt",
      translated: "được bầu",
      tone: 'semantic',
    },
  ],
  "lid:state:RP:4|ar": [
    {
      german: "Ab welchem Alter",
      translated: "ابتداءً من أي سن",
      tone: 'semantic',
    },
    {
      german: "darf man",
      translated: "يحق",
      tone: 'semantic',
    },
    {
      german: "in Rheinland-Pfalz",
      translated: "في Rheinland-Pfalz",
      tone: 'semantic',
    },
    {
      german: "bei Kommunalwahlen",
      translated: "في الانتخابات المحلية",
      tone: 'semantic',
    },
    {
      german: "wählen",
      translated: "التصويت",
      tone: 'semantic',
    },
  ],
  "lid:state:RP:4|bg": [
    {
      german: "Ab welchem Alter",
      translated: "От каква възраст",
      tone: 'semantic',
    },
    {
      german: "darf man",
      translated: "може да се",
      tone: 'semantic',
    },
    {
      german: "in Rheinland-Pfalz",
      translated: "в Райнланд-Пфалц",
      tone: 'semantic',
    },
    {
      german: "bei Kommunalwahlen",
      translated: "на общински избори",
      tone: 'semantic',
    },
    {
      german: "wählen",
      translated: "гласува",
      tone: 'semantic',
    },
  ],
  "lid:state:RP:4|bs": [
    {
      german: "Ab welchem Alter",
      translated: "Od koje se dobi",
      tone: 'semantic',
    },
    {
      german: "darf man",
      translated: "može",
      tone: 'semantic',
    },
    {
      german: "in Rheinland-Pfalz",
      translated: "u saveznoj zemlji Porajnje-Falačka",
      tone: 'semantic',
    },
    {
      german: "bei Kommunalwahlen",
      translated: "na lokalnim izborima",
      tone: 'semantic',
    },
    {
      german: "wählen",
      translated: "glasovati",
      tone: 'semantic',
    },
  ],
  "lid:state:RP:4|el": [
    {
      german: "Ab welchem Alter",
      translated: "Από ποια ηλικία",
      tone: 'semantic',
    },
    {
      german: "darf man",
      translated: "μπορεί κάποιος",
      tone: 'semantic',
    },
    {
      german: "in Rheinland-Pfalz",
      translated: "στο Ρηνανία-Παλατινάτο",
      tone: 'semantic',
    },
    {
      german: "bei Kommunalwahlen",
      translated: "στις δημοτικές εκλογές",
      tone: 'semantic',
    },
    {
      german: "wählen",
      translated: "να ψηφίσει",
      tone: 'semantic',
    },
  ],
  "lid:state:RP:4|en": [
    {
      german: "Ab welchem Alter",
      translated: "From what age",
      tone: 'semantic',
    },
    {
      german: "darf man",
      translated: "can you",
      tone: 'semantic',
    },
    {
      german: "in Rheinland-Pfalz",
      translated: "in Rheinland-Pfalz",
      tone: 'semantic',
    },
    {
      german: "bei Kommunalwahlen",
      translated: "in local elections",
      tone: 'semantic',
    },
    {
      german: "wählen",
      translated: "vote",
      tone: 'semantic',
    },
  ],
  "lid:state:RP:4|es": [
    {
      german: "Ab welchem Alter",
      translated: "¿A partir de qué edad",
      tone: 'semantic',
    },
    {
      german: "darf man",
      translated: "se puede",
      tone: 'semantic',
    },
    {
      german: "in Rheinland-Pfalz",
      translated: "de Renania-Palatinado",
      tone: 'semantic',
    },
    {
      german: "bei Kommunalwahlen",
      translated: "en las elecciones municipales",
      tone: 'semantic',
    },
    {
      german: "wählen",
      translated: "votar",
      tone: 'semantic',
    },
  ],
  "lid:state:RP:4|fa": [
    {
      german: "Ab welchem Alter",
      translated: "از چه سنی",
      tone: 'semantic',
    },
    {
      german: "darf man",
      translated: "می‌توان",
      tone: 'semantic',
    },
    {
      german: "bei Kommunalwahlen",
      translated: "در انتخابات محلی",
      tone: 'semantic',
    },
    {
      german: "wählen",
      translated: "رأی داد",
      tone: 'semantic',
    },
  ],
  "lid:state:RP:4|fr": [
    {
      german: "Ab welchem Alter",
      translated: "À partir de quel âge",
      tone: 'semantic',
    },
    {
      german: "darf man",
      translated: "peut-on",
      tone: 'semantic',
    },
    {
      german: "in Rheinland-Pfalz",
      translated: "en Rhénanie-Palatinat",
      tone: 'semantic',
    },
    {
      german: "bei Kommunalwahlen",
      translated: "aux élections municipales",
      tone: 'semantic',
    },
    {
      german: "wählen",
      translated: "voter",
      tone: 'semantic',
    },
  ],
  "lid:state:RP:4|hr": [
    {
      german: "Ab welchem Alter",
      translated: "Od koje se dobi",
      tone: 'semantic',
    },
    {
      german: "darf man",
      translated: "može",
      tone: 'semantic',
    },
    {
      german: "in Rheinland-Pfalz",
      translated: "u saveznoj zemlji Porajnje-Falačka",
      tone: 'semantic',
    },
    {
      german: "bei Kommunalwahlen",
      translated: "na lokalnim izborima",
      tone: 'semantic',
    },
    {
      german: "wählen",
      translated: "glasovati",
      tone: 'semantic',
    },
  ],
  "lid:state:RP:4|it": [
    {
      german: "Ab welchem Alter",
      translated: "Da quale età",
      tone: 'semantic',
    },
    {
      german: "darf man",
      translated: "si può",
      tone: 'semantic',
    },
    {
      german: "in Rheinland-Pfalz",
      translated: "in Renania-Palatinato",
      tone: 'semantic',
    },
    {
      german: "bei Kommunalwahlen",
      translated: "alle elezioni comunali",
      tone: 'semantic',
    },
    {
      german: "wählen",
      translated: "votare",
      tone: 'semantic',
    },
  ],
  "lid:state:RP:4|kmr": [
    {
      german: "Ab welchem Alter",
      translated: "Ji kîjan temenê",
      tone: 'semantic',
    },
    {
      german: "darf man",
      translated: "dikare",
      tone: 'semantic',
    },
    {
      german: "in Rheinland-Pfalz",
      translated: "li Rheinland-Pfalz",
      tone: 'semantic',
    },
    {
      german: "bei Kommunalwahlen",
      translated: "di hilbijartinên şaredariyê de",
      tone: 'semantic',
    },
    {
      german: "wählen",
      translated: "deng were dayîn",
      tone: 'semantic',
    },
  ],
  "lid:state:RP:4|pl": [
    {
      german: "Ab welchem Alter",
      translated: "Od jakiego wieku",
      tone: 'semantic',
    },
    {
      german: "darf man",
      translated: "można",
      tone: 'semantic',
    },
    {
      german: "in Rheinland-Pfalz",
      translated: "w Nadrenia-Palatynat",
      tone: 'semantic',
    },
    {
      german: "bei Kommunalwahlen",
      translated: "w wyborach samorządowych",
      tone: 'semantic',
    },
    {
      german: "wählen",
      translated: "głosować",
      tone: 'semantic',
    },
  ],
  "lid:state:RP:4|prs": [
    {
      german: "Ab welchem Alter",
      translated: "از چه سنی",
      tone: 'semantic',
    },
    {
      german: "darf man",
      translated: "می‌توان",
      tone: 'semantic',
    },
    {
      german: "in Rheinland-Pfalz",
      translated: "راینلاند-فالتس",
      tone: 'semantic',
    },
    {
      german: "bei Kommunalwahlen",
      translated: "انتخابات شاروالی",
      tone: 'semantic',
    },
    {
      german: "wählen",
      translated: "رأی داد",
      tone: 'semantic',
    },
  ],
  "lid:state:RP:4|ro": [
    {
      german: "Ab welchem Alter",
      translated: "De la ce vârstă",
      tone: 'semantic',
    },
    {
      german: "darf man",
      translated: "se poate",
      tone: 'semantic',
    },
    {
      german: "in Rheinland-Pfalz",
      translated: "din Renania-Palatinat",
      tone: 'semantic',
    },
    {
      german: "bei Kommunalwahlen",
      translated: "la alegerile locale",
      tone: 'semantic',
    },
    {
      german: "wählen",
      translated: "vota",
      tone: 'semantic',
    },
  ],
  "lid:state:RP:4|ru": [
    {
      german: "Ab welchem Alter",
      translated: "С какого возраста",
      tone: 'semantic',
    },
    {
      german: "darf man",
      translated: "можно",
      tone: 'semantic',
    },
    {
      german: "in Rheinland-Pfalz",
      translated: "в федеральной земле Рейнланд-Пфальц",
      tone: 'semantic',
    },
    {
      german: "bei Kommunalwahlen",
      translated: "на муниципальных выборах",
      tone: 'semantic',
    },
    {
      german: "wählen",
      translated: "голосовать",
      tone: 'semantic',
    },
  ],
  "lid:state:RP:4|sq": [
    {
      german: "Ab welchem Alter",
      translated: "Nga cila moshë",
      tone: 'semantic',
    },
    {
      german: "darf man",
      translated: "mund të",
      tone: 'semantic',
    },
    {
      german: "in Rheinland-Pfalz",
      translated: "në Rheinland-Pfalz",
      tone: 'semantic',
    },
    {
      german: "bei Kommunalwahlen",
      translated: "në zgjedhjet komunale",
      tone: 'semantic',
    },
    {
      german: "wählen",
      translated: "votohet",
      tone: 'semantic',
    },
  ],
  "lid:state:RP:4|sr": [
    {
      german: "Ab welchem Alter",
      translated: "Od koje se dobi",
      tone: 'semantic',
    },
    {
      german: "darf man",
      translated: "može",
      tone: 'semantic',
    },
    {
      german: "in Rheinland-Pfalz",
      translated: "u saveznoj pokrajini Rajna-Palatinat",
      tone: 'semantic',
    },
    {
      german: "bei Kommunalwahlen",
      translated: "na lokalnim izborima",
      tone: 'semantic',
    },
    {
      german: "wählen",
      translated: "glasati",
      tone: 'semantic',
    },
  ],
  "lid:state:RP:4|tr": [
    {
      german: "Ab welchem Alter",
      translated: "kaç yaşından itibaren",
      tone: 'semantic',
    },
    {
      german: "in Rheinland-Pfalz",
      translated: "Rheinland-Pfalz eyaletinde",
      tone: 'semantic',
    },
    {
      german: "bei Kommunalwahlen",
      translated: "yerel seçimlerde",
      tone: 'semantic',
    },
    {
      german: "wählen",
      translated: "oy kullanılabilir",
      tone: 'semantic',
    },
  ],
  "lid:state:RP:4|uk": [
    {
      german: "Ab welchem Alter",
      translated: "З якого віку",
      tone: 'semantic',
    },
    {
      german: "darf man",
      translated: "можна",
      tone: 'semantic',
    },
    {
      german: "in Rheinland-Pfalz",
      translated: "у федеральній землі Рейнланд-Пфальц",
      tone: 'semantic',
    },
    {
      german: "bei Kommunalwahlen",
      translated: "на муніципальних виборах",
      tone: 'semantic',
    },
    {
      german: "wählen",
      translated: "голосувати",
      tone: 'semantic',
    },
  ],
  "lid:state:RP:4|vi": [
    {
      german: "Ab welchem Alter",
      translated: "Từ bao nhiêu tuổi",
      tone: 'semantic',
    },
    {
      german: "darf man",
      translated: "có thể",
      tone: 'semantic',
    },
    {
      german: "in Rheinland-Pfalz",
      translated: "ở bang Rheinland-Pfalz",
      tone: 'semantic',
    },
    {
      german: "bei Kommunalwahlen",
      translated: "trong bầu cử địa phương",
      tone: 'semantic',
    },
    {
      german: "wählen",
      translated: "bỏ phiếu",
      tone: 'semantic',
    },
  ],
  "lid:state:RP:5|ar": [
    {
      german: "Welche Farben",
      translated: "ما",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "ألوان",
      tone: 'semantic',
    },
    {
      german: "die Landesflagge",
      translated: "علم",
      tone: 'semantic',
    },
    {
      german: "Rheinland-Pfalz",
      translated: "ولاية Rheinland-Pfalz",
      tone: 'semantic',
    },
  ],
  "lid:state:RP:5|bg": [
    {
      german: "Welche Farben",
      translated: "Какви са цветовете",
      tone: 'semantic',
    },
    {
      german: "die Landesflagge",
      translated: "знамето",
      tone: 'semantic',
    },
    {
      german: "von",
      translated: "на",
      tone: 'semantic',
    },
    {
      german: "Rheinland-Pfalz",
      translated: "Райнланд-Пфалц",
      tone: 'semantic',
    },
  ],
  "lid:state:RP:5|bs": [
    {
      german: "Welche Farben",
      translated: "Koje su boje",
      tone: 'semantic',
    },
    {
      german: "die Landesflagge",
      translated: "zastave",
      tone: 'semantic',
    },
    {
      german: "von",
      translated: "savezne zemlje",
      tone: 'semantic',
    },
    {
      german: "Rheinland-Pfalz",
      translated: "Porajnje-Falačka",
      tone: 'semantic',
    },
  ],
  "lid:state:RP:5|el": [
    {
      german: "Welche Farben",
      translated: "Ποια είναι τα χρώματα",
      tone: 'semantic',
    },
    {
      german: "die Landesflagge",
      translated: "της σημαίας",
      tone: 'semantic',
    },
    {
      german: "von",
      translated: "του",
      tone: 'semantic',
    },
    {
      german: "Rheinland-Pfalz",
      translated: " Ρηνανία-Παλατινάτο",
      tone: 'semantic',
    },
  ],
  "lid:state:RP:5|en": [
    {
      german: "Welche Farben",
      translated: "What colors",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "does",
      tone: 'semantic',
    },
    {
      german: "die Landesflagge",
      translated: "the state flag",
      tone: 'semantic',
    },
    {
      german: "von",
      translated: "of",
      tone: 'semantic',
    },
    {
      german: "Rheinland-Pfalz",
      translated: "Rheinland-Pfalz",
      tone: 'semantic',
    },
  ],
  "lid:state:RP:5|es": [
    {
      german: "Welche Farben",
      translated: "Qué colores",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "tiene",
      tone: 'semantic',
    },
    {
      german: "die Landesflagge",
      translated: "la bandera regional",
      tone: 'semantic',
    },
    {
      german: "Rheinland-Pfalz",
      translated: "Renania-Palatinado",
      tone: 'semantic',
    },
  ],
  "lid:state:RP:5|fa": [
    {
      german: "Welche Farben",
      translated: "رنگ‌های",
      tone: 'semantic',
    },
    {
      german: "die Landesflagge",
      translated: "پرچم ایالت",
      tone: 'semantic',
    },
    {
      german: "Rheinland-Pfalz",
      translated: "راینلاند-فالتس",
      tone: 'semantic',
    },
  ],
  "lid:state:RP:5|fr": [
    {
      german: "Welche Farben",
      translated: "Quelles sont les couleurs",
      tone: 'semantic',
    },
    {
      german: "die Landesflagge",
      translated: "du drapeau du Land",
      tone: 'semantic',
    },
    {
      german: "von",
      translated: "de",
      tone: 'semantic',
    },
    {
      german: "Rheinland-Pfalz",
      translated: "Rhénanie-Palatinat",
      tone: 'semantic',
    },
  ],
  "lid:state:RP:5|hr": [
    {
      german: "Welche Farben",
      translated: "Koje su boje",
      tone: 'semantic',
    },
    {
      german: "die Landesflagge",
      translated: "zastave",
      tone: 'semantic',
    },
    {
      german: "von",
      translated: "savezne zemlje",
      tone: 'semantic',
    },
    {
      german: "Rheinland-Pfalz",
      translated: "Porajnje-Falačka",
      tone: 'semantic',
    },
  ],
  "lid:state:RP:5|it": [
    {
      german: "Welche Farben",
      translated: "Quali sono i colori",
      tone: 'semantic',
    },
    {
      german: "die Landesflagge",
      translated: "bandiera del Land",
      tone: 'semantic',
    },
    {
      german: "von",
      translated: "di",
      tone: 'semantic',
    },
    {
      german: "Rheinland-Pfalz",
      translated: "Renania-Palatinato",
      tone: 'semantic',
    },
  ],
  "lid:state:RP:5|kmr": [
    {
      german: "Welche Farben",
      translated: "ne",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "çi",
      tone: 'semantic',
    },
    {
      german: "die Landesflagge",
      translated: "Rengên ala eyaleta",
      tone: 'semantic',
    },
    {
      german: "Rheinland-Pfalz",
      translated: "Rheinland-Pfalz",
      tone: 'semantic',
    },
  ],
  "lid:state:RP:5|pl": [
    {
      german: "Welche Farben",
      translated: "Jakie są kolory",
      tone: 'semantic',
    },
    {
      german: "die Landesflagge",
      translated: "flagi kraju związkowego",
      tone: 'semantic',
    },
    {
      german: "Rheinland-Pfalz",
      translated: "Nadrenia-Palatynat",
      tone: 'semantic',
    },
  ],
  "lid:state:RP:5|prs": [
    {
      german: "Welche Farben",
      translated: "رنگ‌های",
      tone: 'semantic',
    },
    {
      german: "die Landesflagge",
      translated: "پرچم ایالت",
      tone: 'semantic',
    },
    {
      german: "Rheinland-Pfalz",
      translated: "راینلاند-فالتس",
      tone: 'semantic',
    },
  ],
  "lid:state:RP:5|ro": [
    {
      german: "Welche Farben",
      translated: "Care sunt culorile",
      tone: 'semantic',
    },
    {
      german: "die Landesflagge",
      translated: "drapelului",
      tone: 'semantic',
    },
    {
      german: "von",
      translated: "landului",
      tone: 'semantic',
    },
    {
      german: "Rheinland-Pfalz",
      translated: "Renania-Palatinat",
      tone: 'semantic',
    },
  ],
  "lid:state:RP:5|ru": [
    {
      german: "Welche Farben",
      translated: "Какие цвета",
      tone: 'semantic',
    },
    {
      german: "die Landesflagge",
      translated: "у флага земли",
      tone: 'semantic',
    },
    {
      german: "Rheinland-Pfalz",
      translated: "Рейнланд-Пфальц",
      tone: 'semantic',
    },
  ],
  "lid:state:RP:5|sq": [
    {
      german: "Welche Farben",
      translated: "Cilat janë ngjyrat",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "e",
      tone: 'semantic',
    },
    {
      german: "die Landesflagge",
      translated: "flamurit",
      tone: 'semantic',
    },
    {
      german: "von",
      translated: "të landit",
      tone: 'semantic',
    },
    {
      german: "Rheinland-Pfalz",
      translated: "Rheinland-Pfalz",
      tone: 'semantic',
    },
  ],
  "lid:state:RP:5|sr": [
    {
      german: "Welche Farben",
      translated: "Koje su boje",
      tone: 'semantic',
    },
    {
      german: "die Landesflagge",
      translated: "zastave",
      tone: 'semantic',
    },
    {
      german: "von",
      translated: "savezne",
      tone: 'semantic',
    },
    {
      german: "Rheinland-Pfalz",
      translated: "Rajna-Palatinat",
      tone: 'semantic',
    },
  ],
  "lid:state:RP:5|tr": [
    {
      german: "Welche Farben",
      translated: "renkleri nelerdir",
      tone: 'semantic',
    },
    {
      german: "die Landesflagge",
      translated: "eyalet bayrağının",
      tone: 'semantic',
    },
    {
      german: "Rheinland-Pfalz",
      translated: "Rheinland-Pfalz",
      tone: 'semantic',
    },
  ],
  "lid:state:RP:5|uk": [
    {
      german: "Welche Farben",
      translated: "Які кольори",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: " має",
      tone: 'semantic',
    },
    {
      german: "die Landesflagge",
      translated: "прапор федеральної землі",
      tone: 'semantic',
    },
    {
      german: "Rheinland-Pfalz",
      translated: "Рейнланд-Пфальц",
      tone: 'semantic',
    },
  ],
  "lid:state:RP:5|vi": [
    {
      german: "Welche Farben",
      translated: "Màu",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "là gì",
      tone: 'semantic',
    },
    {
      german: "die Landesflagge",
      translated: "cờ bang",
      tone: 'semantic',
    },
    {
      german: "von",
      translated: "của",
      tone: 'semantic',
    },
    {
      german: "Rheinland-Pfalz",
      translated: "Rheinland-Pfalz",
      tone: 'semantic',
    },
  ],
  "lid:state:RP:6|ar": [
    {
      german: "Wo",
      translated: "أين",
      tone: 'semantic',
    },
    {
      german: "können Sie",
      translated: "يمكنك",
      tone: 'semantic',
    },
    {
      german: "in Rheinland-Pfalz",
      translated: "في Rheinland-Pfalz",
      tone: 'semantic',
    },
    {
      german: "über politische Themen",
      translated: "عن القضايا السياسية",
      tone: 'semantic',
    },
    {
      german: "informieren",
      translated: "الحصول على معلومات",
      tone: 'semantic',
    },
  ],
  "lid:state:RP:6|bg": [
    {
      german: "Wo",
      translated: "Къде",
      tone: 'semantic',
    },
    {
      german: "können Sie",
      translated: "можете",
      tone: 'semantic',
    },
    {
      german: "in Rheinland-Pfalz",
      translated: "в Райнланд-Пфалц",
      tone: 'semantic',
    },
    {
      german: "über politische Themen",
      translated: "по политически теми",
      tone: 'semantic',
    },
    {
      german: "informieren",
      translated: "да получите информация",
      tone: 'semantic',
    },
  ],
  "lid:state:RP:6|bs": [
    {
      german: "Wo",
      translated: "Gdje",
      tone: 'semantic',
    },
    {
      german: "können Sie",
      translated: "mogu",
      tone: 'semantic',
    },
    {
      german: "sich",
      translated: "se",
      tone: 'semantic',
    },
    {
      german: "in Rheinland-Pfalz",
      translated: "u saveznoj zemlji Porajnje-Falačka",
      tone: 'semantic',
    },
    {
      german: "über politische Themen",
      translated: "o političkim temama",
      tone: 'semantic',
    },
    {
      german: "informieren",
      translated: "dobiti informacije",
      tone: 'semantic',
    },
  ],
  "lid:state:RP:6|el": [
    {
      german: "Wo",
      translated: "Πού",
      tone: 'semantic',
    },
    {
      german: "können Sie",
      translated: "μπορείτε",
      tone: 'semantic',
    },
    {
      german: "in Rheinland-Pfalz",
      translated: "στο Ρηνανία-Παλατινάτο",
      tone: 'semantic',
    },
    {
      german: "über politische Themen",
      translated: "για πολιτικά θέματα",
      tone: 'semantic',
    },
    {
      german: "informieren",
      translated: "να ενημερωθείτε",
      tone: 'semantic',
    },
  ],
  "lid:state:RP:6|en": [
    {
      german: "Wo",
      translated: "Where",
      tone: 'semantic',
    },
    {
      german: "können Sie",
      translated: "can you",
      tone: 'semantic',
    },
    {
      german: "in Rheinland-Pfalz",
      translated: "in Rheinland-Pfalz",
      tone: 'semantic',
    },
    {
      german: "über politische Themen",
      translated: "about political topics",
      tone: 'semantic',
    },
    {
      german: "informieren",
      translated: "get information",
      tone: 'semantic',
    },
  ],
  "lid:state:RP:6|es": [
    {
      german: "Wo",
      translated: "¿Dónde",
      tone: 'semantic',
    },
    {
      german: "können Sie",
      translated: "puede",
      tone: 'semantic',
    },
    {
      german: "in Rheinland-Pfalz",
      translated: "en Renania-Palatinado",
      tone: 'semantic',
    },
    {
      german: "über politische Themen",
      translated: "sobre temas políticos",
      tone: 'semantic',
    },
    {
      german: "informieren",
      translated: "informarse",
      tone: 'semantic',
    },
  ],
  "lid:state:RP:6|fa": [
    {
      german: "Wo",
      translated: "کجا",
      tone: 'semantic',
    },
    {
      german: "können Sie",
      translated: "می‌توانید",
      tone: 'semantic',
    },
    {
      german: "in Rheinland-Pfalz",
      translated: "در راینلاند-فالتس",
      tone: 'semantic',
    },
    {
      german: "über politische Themen",
      translated: "دربارهٔ موضوعات سیاسی",
      tone: 'semantic',
    },
    {
      german: "informieren",
      translated: "اطلاعات کسب کنید",
      tone: 'semantic',
    },
  ],
  "lid:state:RP:6|fr": [
    {
      german: "Wo",
      translated: "Où",
      tone: 'semantic',
    },
    {
      german: "können Sie",
      translated: "pouvez-vous",
      tone: 'semantic',
    },
    {
      german: "sich",
      translated: "vous",
      tone: 'semantic',
    },
    {
      german: "in Rheinland-Pfalz",
      translated: "en Rhénanie-Palatinat",
      tone: 'semantic',
    },
    {
      german: "über politische Themen",
      translated: "sur les questions politiques",
      tone: 'semantic',
    },
    {
      german: "informieren",
      translated: "informer",
      tone: 'semantic',
    },
  ],
  "lid:state:RP:6|hr": [
    {
      german: "Wo",
      translated: "Gdje",
      tone: 'semantic',
    },
    {
      german: "können Sie",
      translated: "mogu",
      tone: 'semantic',
    },
    {
      german: "sich",
      translated: "se",
      tone: 'semantic',
    },
    {
      german: "in Rheinland-Pfalz",
      translated: "u saveznoj zemlji Porajnje-Falačka",
      tone: 'semantic',
    },
    {
      german: "über politische Themen",
      translated: "o političkim temama",
      tone: 'semantic',
    },
    {
      german: "informieren",
      translated: "dobiti informacije",
      tone: 'semantic',
    },
  ],
  "lid:state:RP:6|it": [
    {
      german: "Wo",
      translated: "Dove",
      tone: 'semantic',
    },
    {
      german: "können Sie",
      translated: "ci si può",
      tone: 'semantic',
    },
    {
      german: "in Rheinland-Pfalz",
      translated: "in Renania-Palatinato",
      tone: 'semantic',
    },
    {
      german: "über politische Themen",
      translated: "su temi politici",
      tone: 'semantic',
    },
    {
      german: "informieren",
      translated: "informare",
      tone: 'semantic',
    },
  ],
  "lid:state:RP:6|kmr": [
    {
      german: "Wo",
      translated: "Li",
      tone: 'semantic',
    },
    {
      german: "können Sie",
      translated: "ku",
      tone: 'semantic',
    },
    {
      german: "sich",
      translated: "dikarî",
      tone: 'semantic',
    },
    {
      german: "in Rheinland-Pfalz",
      translated: "Rheinland-Pfalz",
      tone: 'semantic',
    },
    {
      german: "über politische Themen",
      translated: "ser mijarên siyasî",
      tone: 'semantic',
    },
    {
      german: "informieren",
      translated: "agahdarî bistînî",
      tone: 'semantic',
    },
  ],
  "lid:state:RP:6|pl": [
    {
      german: "Wo",
      translated: "Gdzie",
      tone: 'semantic',
    },
    {
      german: "können Sie",
      translated: "można",
      tone: 'semantic',
    },
    {
      german: "in Rheinland-Pfalz",
      translated: "w Nadrenia-Palatynat",
      tone: 'semantic',
    },
    {
      german: "über politische Themen",
      translated: "na tematy polityczne",
      tone: 'semantic',
    },
    {
      german: "informieren",
      translated: "uzyskać informacje",
      tone: 'semantic',
    },
  ],
  "lid:state:RP:6|prs": [
    {
      german: "Wo",
      translated: "از کجا",
      tone: 'semantic',
    },
    {
      german: "können Sie",
      translated: "می‌توانید",
      tone: 'semantic',
    },
    {
      german: "in Rheinland-Pfalz",
      translated: "در راینلاند-فالتس",
      tone: 'semantic',
    },
    {
      german: "über politische Themen",
      translated: " دربارهٔ موضوعات سیاسی",
      tone: 'semantic',
    },
    {
      german: "informieren",
      translated: "اطلاعات کسب کنید",
      tone: 'semantic',
    },
  ],
  "lid:state:RP:6|ro": [
    {
      german: "Wo",
      translated: "Unde",
      tone: 'semantic',
    },
    {
      german: "können Sie",
      translated: "vă puteți",
      tone: 'semantic',
    },
    {
      german: "in Rheinland-Pfalz",
      translated: "în Renania-Palatinat",
      tone: 'semantic',
    },
    {
      german: "über politische Themen",
      translated: "despre teme politice",
      tone: 'semantic',
    },
    {
      german: "informieren",
      translated: "informa",
      tone: 'semantic',
    },
  ],
  "lid:state:RP:6|ru": [
    {
      german: "Wo",
      translated: "Где",
      tone: 'semantic',
    },
    {
      german: "können Sie",
      translated: "можно",
      tone: 'semantic',
    },
    {
      german: "in Rheinland-Pfalz",
      translated: "в федеральной земле Рейнланд-Пфальц",
      tone: 'semantic',
    },
    {
      german: "über politische Themen",
      translated: "о политических темах",
      tone: 'semantic',
    },
    {
      german: "informieren",
      translated: "получить информацию",
      tone: 'semantic',
    },
  ],
  "lid:state:RP:6|sq": [
    {
      german: "Wo",
      translated: "Ku",
      tone: 'semantic',
    },
    {
      german: "können Sie",
      translated: "mund të",
      tone: 'semantic',
    },
    {
      german: "in Rheinland-Pfalz",
      translated: "në Rheinland-Pfalz",
      tone: 'semantic',
    },
    {
      german: "über politische Themen",
      translated: "për tema politike",
      tone: 'semantic',
    },
    {
      german: "informieren",
      translated: "informoheni",
      tone: 'semantic',
    },
  ],
  "lid:state:RP:6|sr": [
    {
      german: "Wo",
      translated: "Gdje",
      tone: 'semantic',
    },
    {
      german: "können Sie",
      translated: "mogu",
      tone: 'semantic',
    },
    {
      german: "sich",
      translated: "se",
      tone: 'semantic',
    },
    {
      german: "in Rheinland-Pfalz",
      translated: "u saveznoj pokrajini Rajna-Palatinat",
      tone: 'semantic',
    },
    {
      german: "über politische Themen",
      translated: "o političkim temama",
      tone: 'semantic',
    },
    {
      german: "informieren",
      translated: "dobiti informacije",
      tone: 'semantic',
    },
  ],
  "lid:state:RP:6|tr": [
    {
      german: "Wo",
      translated: "nereden",
      tone: 'semantic',
    },
    {
      german: "können Sie",
      translated: "alabilirsiniz",
      tone: 'semantic',
    },
    {
      german: "in Rheinland-Pfalz",
      translated: "Rheinland-Pfalz eyaletinde",
      tone: 'semantic',
    },
    {
      german: "über politische Themen",
      translated: "siyasi konular hakkında",
      tone: 'semantic',
    },
    {
      german: "informieren",
      translated: "bilgi",
      tone: 'semantic',
    },
  ],
  "lid:state:RP:6|uk": [
    {
      german: "Wo",
      translated: "Де",
      tone: 'semantic',
    },
    {
      german: "können Sie",
      translated: "можна",
      tone: 'semantic',
    },
    {
      german: "in Rheinland-Pfalz",
      translated: "у федеральній землі Рейнланд-Пфальц",
      tone: 'semantic',
    },
    {
      german: "über politische Themen",
      translated: "про політичні питання",
      tone: 'semantic',
    },
    {
      german: "informieren",
      translated: "отримати інформацію",
      tone: 'semantic',
    },
  ],
  "lid:state:RP:6|vi": [
    {
      german: "Wo",
      translated: "ở đâu",
      tone: 'semantic',
    },
    {
      german: "können Sie",
      translated: "có thể",
      tone: 'semantic',
    },
    {
      german: "sich",
      translated: "tìm",
      tone: 'semantic',
    },
    {
      german: "in Rheinland-Pfalz",
      translated: "bang Rheinland-Pfalz",
      tone: 'semantic',
    },
    {
      german: "über politische Themen",
      translated: "về các chủ đề chính trị",
      tone: 'semantic',
    },
    {
      german: "informieren",
      translated: "thông tin",
      tone: 'semantic',
    },
  ],
  "lid:state:RP:7|ar": [
    {
      german: "Rheinland-Pfalz",
      translated: "Rheinland-Pfalz",
      tone: 'semantic',
    },
    {
      german: "heißt",
      translated: "؟",
      tone: 'semantic',
    },
  ],
  "lid:state:RP:7|bg": [
    {
      german: "Die",
      translated: "Столицата",
      tone: 'semantic',
    },
    {
      german: "Landeshauptstadt",
      translated: "на федералната провинция",
      tone: 'semantic',
    },
    {
      german: "Rheinland-Pfalz",
      translated: "Райнланд-Пфалц",
      tone: 'semantic',
    },
    {
      german: "heißt",
      translated: "е",
      tone: 'semantic',
    },
  ],
  "lid:state:RP:7|bs": [
    {
      german: "Die",
      translated: "Glavni",
      tone: 'semantic',
    },
    {
      german: "Landeshauptstadt",
      translated: "grad savezne zemlje",
      tone: 'semantic',
    },
    {
      german: "Rheinland-Pfalz",
      translated: "Porajnje-Falačka",
      tone: 'semantic',
    },
    {
      german: "heißt",
      translated: "je",
      tone: 'semantic',
    },
  ],
  "lid:state:RP:7|el": [
    {
      german: "Die",
      translated: "Η",
      tone: 'semantic',
    },
    {
      german: "Landeshauptstadt",
      translated: "πρωτεύουσα",
      tone: 'semantic',
    },
    {
      german: "von",
      translated: "του",
      tone: 'semantic',
    },
    {
      german: "Rheinland-Pfalz",
      translated: "Ρηνανία-Παλατινάτο",
      tone: 'semantic',
    },
    {
      german: "heißt",
      translated: "είναι",
      tone: 'semantic',
    },
  ],
  "lid:state:RP:7|en": [
    {
      german: "Landeshauptstadt",
      translated: "The state capital",
      tone: 'semantic',
    },
    {
      german: "von",
      translated: "of",
      tone: 'semantic',
    },
    {
      german: "Rheinland-Pfalz",
      translated: "Rheinland-Pfalz",
      tone: 'semantic',
    },
    {
      german: "heißt",
      translated: "is called",
      tone: 'semantic',
    },
  ],
  "lid:state:RP:7|es": [
    {
      german: "Die",
      translated: "La",
      tone: 'semantic',
    },
    {
      german: "Landeshauptstadt",
      translated: "capital",
      tone: 'semantic',
    },
    {
      german: "von",
      translated: "del estado federado de",
      tone: 'semantic',
    },
    {
      german: "Rheinland-Pfalz",
      translated: "Renania-Palatinado",
      tone: 'semantic',
    },
    {
      german: "heißt",
      translated: "es …",
      tone: 'semantic',
    },
  ],
  "lid:state:RP:7|fa": [
    {
      german: "Die",
      translated: "مرکز",
      tone: 'semantic',
    },
    {
      german: "Landeshauptstadt",
      translated: "ایالت",
      tone: 'semantic',
    },
    {
      german: "Rheinland-Pfalz",
      translated: "راینلاند-فالتس",
      tone: 'semantic',
    },
    {
      german: "heißt",
      translated: "… است.",
      tone: 'semantic',
    },
  ],
  "lid:state:RP:7|fr": [
    {
      german: "Die",
      translated: "La",
      tone: 'semantic',
    },
    {
      german: "Landeshauptstadt",
      translated: "capitale",
      tone: 'semantic',
    },
    {
      german: "von",
      translated: "du Land",
      tone: 'semantic',
    },
    {
      german: "Rheinland-Pfalz",
      translated: "Rhénanie-Palatinat",
      tone: 'semantic',
    },
    {
      german: "heißt",
      translated: "s’appelle",
      tone: 'semantic',
    },
  ],
  "lid:state:RP:7|hr": [
    {
      german: "Die",
      translated: "Glavni",
      tone: 'semantic',
    },
    {
      german: "Landeshauptstadt",
      translated: "grad savezne zemlje",
      tone: 'semantic',
    },
    {
      german: "Rheinland-Pfalz",
      translated: "Porajnje-Falačka",
      tone: 'semantic',
    },
    {
      german: "heißt",
      translated: "je",
      tone: 'semantic',
    },
  ],
  "lid:state:RP:7|it": [
    {
      german: "Die",
      translated: "La",
      tone: 'semantic',
    },
    {
      german: "Landeshauptstadt",
      translated: "capitale",
      tone: 'semantic',
    },
    {
      german: "von",
      translated: "di",
      tone: 'semantic',
    },
    {
      german: "Rheinland-Pfalz",
      translated: "Renania-Palatinato",
      tone: 'semantic',
    },
    {
      german: "heißt",
      translated: "è",
      tone: 'semantic',
    },
  ],
  "lid:state:RP:7|kmr": [
    {
      german: "Die",
      translated: "Paytexta",
      tone: 'semantic',
    },
    {
      german: "Landeshauptstadt",
      translated: "eyaleta",
      tone: 'semantic',
    },
    {
      german: "Rheinland-Pfalz",
      translated: "Rheinland-Pfalz",
      tone: 'semantic',
    },
    {
      german: "heißt",
      translated: "e.",
      tone: 'semantic',
    },
  ],
  "lid:state:RP:7|pl": [
    {
      german: "Die",
      translated: "Stolicą",
      tone: 'semantic',
    },
    {
      german: "Landeshauptstadt",
      translated: "kraju związkowego",
      tone: 'semantic',
    },
    {
      german: "Rheinland-Pfalz",
      translated: "Nadrenia-Palatynat",
      tone: 'semantic',
    },
    {
      german: "heißt",
      translated: "jest",
      tone: 'semantic',
    },
  ],
  "lid:state:RP:7|prs": [
    {
      german: "Landeshauptstadt",
      translated: "مرکز",
      tone: 'semantic',
    },
    {
      german: "Rheinland-Pfalz",
      translated: "راینلاند-فالتس",
      tone: 'semantic',
    },
    {
      german: "heißt",
      translated: "است",
      tone: 'semantic',
    },
  ],
  "lid:state:RP:7|ro": [
    {
      german: "Die",
      translated: "Capitala",
      tone: 'semantic',
    },
    {
      german: "Landeshauptstadt",
      translated: "landului",
      tone: 'semantic',
    },
    {
      german: "Rheinland-Pfalz",
      translated: "Renania-Palatinat",
      tone: 'semantic',
    },
    {
      german: "heißt",
      translated: "este",
      tone: 'semantic',
    },
  ],
  "lid:state:RP:7|ru": [
    {
      german: "Die",
      translated: "Столица",
      tone: 'semantic',
    },
    {
      german: "Landeshauptstadt",
      translated: "земли",
      tone: 'semantic',
    },
    {
      german: "Rheinland-Pfalz",
      translated: "Рейнланд-Пфальц",
      tone: 'semantic',
    },
    {
      german: "heißt",
      translated: "называется",
      tone: 'semantic',
    },
  ],
  "lid:state:RP:7|sq": [
    {
      german: "Landeshauptstadt",
      translated: "Kryeqyteti",
      tone: 'semantic',
    },
    {
      german: "von",
      translated: "i landit",
      tone: 'semantic',
    },
    {
      german: "Rheinland-Pfalz",
      translated: "Rheinland-Pfalz",
      tone: 'semantic',
    },
    {
      german: "heißt",
      translated: "është",
      tone: 'semantic',
    },
  ],
  "lid:state:RP:7|sr": [
    {
      german: "Landeshauptstadt",
      translated: "Glavni grad",
      tone: 'semantic',
    },
    {
      german: "von",
      translated: "savezne pokrajine",
      tone: 'semantic',
    },
    {
      german: "Rheinland-Pfalz",
      translated: "Rajna-Palatinat",
      tone: 'semantic',
    },
    {
      german: "heißt",
      translated: "je",
      tone: 'semantic',
    },
  ],
  "lid:state:RP:7|tr": [
    {
      german: "Landeshauptstadt",
      translated: "başkenti",
      tone: 'semantic',
    },
    {
      german: "von",
      translated: "eyaletinin",
      tone: 'semantic',
    },
    {
      german: "Rheinland-Pfalz",
      translated: "Rheinland-Pfalz",
      tone: 'semantic',
    },
  ],
  "lid:state:RP:7|uk": [
    {
      german: "Landeshauptstadt",
      translated: "Столиця",
      tone: 'semantic',
    },
    {
      german: "von",
      translated: "федеральної землі",
      tone: 'semantic',
    },
    {
      german: "Rheinland-Pfalz",
      translated: "Рейнланд-Пфальц",
      tone: 'semantic',
    },
    {
      german: "heißt",
      translated: "називається",
      tone: 'semantic',
    },
  ],
  "lid:state:RP:7|vi": [
    {
      german: "Landeshauptstadt",
      translated: "Thủ phủ",
      tone: 'semantic',
    },
    {
      german: "von",
      translated: "của bang",
      tone: 'semantic',
    },
    {
      german: "Rheinland-Pfalz",
      translated: "Rheinland-Pfalz",
      tone: 'semantic',
    },
    {
      german: "heißt",
      translated: "là",
      tone: 'semantic',
    },
  ],
  "lid:state:RP:8|ar": [
    {
      german: "Welches Bundesland",
      translated: "أي صورة",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "تمثل موقع ولاية",
      tone: 'semantic',
    },
    {
      german: "Rheinland-Pfalz",
      translated: "Rheinland-Pfalz",
      tone: 'semantic',
    },
  ],
  "lid:state:RP:8|bg": [
    {
      german: "Welches Bundesland",
      translated: "Коя от показаните федерални провинции",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "е",
      tone: 'semantic',
    },
    {
      german: "Rheinland-Pfalz",
      translated: "Райнланд-Пфалц",
      tone: 'semantic',
    },
  ],
  "lid:state:RP:8|bs": [
    {
      german: "Welches Bundesland",
      translated: "Koja od prikazanih saveznih zemalja",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "je",
      tone: 'semantic',
    },
    {
      german: "Rheinland-Pfalz",
      translated: "Porajnje-Falačka",
      tone: 'semantic',
    },
  ],
  "lid:state:RP:8|el": [
    {
      german: "Welches Bundesland",
      translated: "Ποιο από τα εικονιζόμενα κρατίδια",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "είναι",
      tone: 'semantic',
    },
    {
      german: "Rheinland-Pfalz",
      translated: "Ρηνανία-Παλατινάτο",
      tone: 'semantic',
    },
  ],
  "lid:state:RP:8|en": [
    {
      german: "Welches Bundesland",
      translated: "Which federal state",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "is",
      tone: 'semantic',
    },
    {
      german: "Rheinland-Pfalz",
      translated: "Rheinland-Pfalz",
      tone: 'semantic',
    },
  ],
  "lid:state:RP:8|es": [
    {
      german: "Welches Bundesland",
      translated: "estado federado",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "corresponde al",
      tone: 'semantic',
    },
    {
      german: "Rheinland-Pfalz",
      translated: "Renania-Palatinado",
      tone: 'semantic',
    },
  ],
  "lid:state:RP:8|fa": [
    {
      german: "Welches Bundesland",
      translated: "کدام ایالتِ",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "است",
      tone: 'semantic',
    },
    {
      german: "Rheinland-Pfalz",
      translated: "راینلاند-فالتس",
      tone: 'semantic',
    },
  ],
  "lid:state:RP:8|fr": [
    {
      german: "Welches Bundesland",
      translated: "Quel",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "est",
      tone: 'semantic',
    },
    {
      german: "Rheinland-Pfalz",
      translated: "Rhénanie-Palatinat",
      tone: 'semantic',
    },
  ],
  "lid:state:RP:8|hr": [
    {
      german: "Welches Bundesland",
      translated: "Koja od prikazanih saveznih zemalja",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "je",
      tone: 'semantic',
    },
    {
      german: "Rheinland-Pfalz",
      translated: "Porajnje-Falačka",
      tone: 'semantic',
    },
  ],
  "lid:state:RP:8|it": [
    {
      german: "Welches Bundesland",
      translated: "Quale Land",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "è",
      tone: 'semantic',
    },
    {
      german: "Rheinland-Pfalz",
      translated: "Renania-Palatinato",
      tone: 'semantic',
    },
  ],
  "lid:state:RP:8|kmr": [
    {
      german: "Welches Bundesland",
      translated: "Kîjan eyalet",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "ye?",
      tone: 'semantic',
    },
    {
      german: "Rheinland-Pfalz",
      translated: "Rheinland-Pfalz",
      tone: 'semantic',
    },
  ],
  "lid:state:RP:8|pl": [
    {
      german: "Welches Bundesland",
      translated: "Który z przedstawionych krajów związkowych",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "to",
      tone: 'semantic',
    },
    {
      german: "Rheinland-Pfalz",
      translated: "Nadrenia-Palatynat",
      tone: 'semantic',
    },
  ],
  "lid:state:RP:8|prs": [
    {
      german: "Welches Bundesland",
      translated: "کدام ایالتِ",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "است",
      tone: 'semantic',
    },
    {
      german: "Rheinland-Pfalz",
      translated: "راینلاند-فالتس",
      tone: 'semantic',
    },
  ],
  "lid:state:RP:8|ro": [
    {
      german: "Welches Bundesland",
      translated: "Care land reprezentat",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "este",
      tone: 'semantic',
    },
    {
      german: "Rheinland-Pfalz",
      translated: "Renania-Palatinat",
      tone: 'semantic',
    },
  ],
  "lid:state:RP:8|ru": [
    {
      german: "Welches Bundesland",
      translated: "Какая из этих земель",
      tone: 'semantic',
    },
    {
      german: "Rheinland-Pfalz",
      translated: "Рейнланд-Пфальц",
      tone: 'semantic',
    },
  ],
  "lid:state:RP:8|sq": [
    {
      german: "Welches Bundesland",
      translated: "Cili nga",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "është",
      tone: 'semantic',
    },
    {
      german: "Rheinland-Pfalz",
      translated: "Rheinland-Pfalz",
      tone: 'semantic',
    },
  ],
  "lid:state:RP:8|sr": [
    {
      german: "Welches Bundesland",
      translated: "Koja od prikazanih saveznih",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "je",
      tone: 'semantic',
    },
    {
      german: "Rheinland-Pfalz",
      translated: "Rajna-Palatinat",
      tone: 'semantic',
    },
  ],
  "lid:state:RP:8|tr": [
    {
      german: "Welches Bundesland",
      translated: "hangi numarayla",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "gösterilmiştir",
      tone: 'semantic',
    },
    {
      german: "Rheinland-Pfalz",
      translated: "Rheinland-Pfalz",
      tone: 'semantic',
    },
  ],
  "lid:state:RP:8|uk": [
    {
      german: "Welches Bundesland",
      translated: "Яка з позначених федеральних земель",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "є",
      tone: 'semantic',
    },
    {
      german: "Rheinland-Pfalz",
      translated: "Рейнланд-Пфальц",
      tone: 'semantic',
    },
  ],
  "lid:state:RP:8|vi": [
    {
      german: "Welches Bundesland",
      translated: "Bang nào trong các hình được hiển thị",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "là",
      tone: 'semantic',
    },
    {
      german: "Rheinland-Pfalz",
      translated: "Rheinland-Pfalz",
      tone: 'semantic',
    },
  ],
  "lid:state:RP:9|ar": [
    {
      german: "Wie nennt man",
      translated: "ماذا",
      tone: 'semantic',
    },
    {
      german: "die Regierungschefin/den Regierungschef",
      translated: "رئيس/رئيسة حكومة",
      tone: 'semantic',
    },
    {
      german: "in Rheinland-Pfalz",
      translated: "ولاية Rheinland-Pfalz",
      tone: 'semantic',
    },
  ],
  "lid:state:RP:9|bg": [
    {
      german: "Wie nennt man",
      translated: "Как се нарича",
      tone: 'semantic',
    },
    {
      german: "die Regierungschefin/den Regierungschef",
      translated: "ръководителят",
      tone: 'semantic',
    },
    {
      german: "in Rheinland-Pfalz",
      translated: "на правителството на провинция Райнланд-Пфалц",
      tone: 'semantic',
    },
  ],
  "lid:state:RP:9|bs": [
    {
      german: "Wie nennt man",
      translated: "Kako se zove",
      tone: 'semantic',
    },
    {
      german: "die Regierungschefin/den Regierungschef",
      translated: "šef vlade",
      tone: 'semantic',
    },
    {
      german: "in Rheinland-Pfalz",
      translated: "savezne zemlje Porajnje-Falačka",
      tone: 'semantic',
    },
  ],
  "lid:state:RP:9|el": [
    {
      german: "Wie nennt man",
      translated: "Πώς ονομάζεται",
      tone: 'semantic',
    },
    {
      german: "die Regierungschefin/den Regierungschef",
      translated: "ο επικεφαλής της κυβέρνησης",
      tone: 'semantic',
    },
    {
      german: "in Rheinland-Pfalz",
      translated: "του κρατιδίου Ρηνανία-Παλατινάτο",
      tone: 'semantic',
    },
  ],
  "lid:state:RP:9|en": [
    {
      german: "Wie nennt man",
      translated: "What is",
      tone: 'semantic',
    },
    {
      german: "die Regierungschefin/den Regierungschef",
      translated: "the head of government",
      tone: 'semantic',
    },
    {
      german: "in Rheinland-Pfalz",
      translated: "in Rheinland-Pfalz",
      tone: 'semantic',
    },
  ],
  "lid:state:RP:9|es": [
    {
      german: "Wie nennt man",
      translated: "¿Cómo se llama al",
      tone: 'semantic',
    },
    {
      german: "die Regierungschefin/den Regierungschef",
      translated: "jefe o la jefa de gobierno de",
      tone: 'semantic',
    },
    {
      german: "in Rheinland-Pfalz",
      translated: "Renania-Palatinado",
      tone: 'semantic',
    },
  ],
  "lid:state:RP:9|fa": [
    {
      german: "Wie nennt man",
      translated: "چه عنوانی دارد",
      tone: 'semantic',
    },
    {
      german: "die Regierungschefin/den Regierungschef",
      translated: "رئیس دولت",
      tone: 'semantic',
    },
    {
      german: "in Rheinland-Pfalz",
      translated: "ایالت راینلاند-فالتس",
      tone: 'semantic',
    },
  ],
  "lid:state:RP:9|fr": [
    {
      german: "Wie nennt man",
      translated: "Comment appelle-t-on",
      tone: 'semantic',
    },
    {
      german: "die Regierungschefin/den Regierungschef",
      translated: "le chef ou la cheffe du gouvernement",
      tone: 'semantic',
    },
    {
      german: "in Rheinland-Pfalz",
      translated: "de Rhénanie-Palatinat",
      tone: 'semantic',
    },
  ],
  "lid:state:RP:9|hr": [
    {
      german: "Wie nennt man",
      translated: "Kako se",
      tone: 'semantic',
    },
    {
      german: "die Regierungschefin/den Regierungschef",
      translated: "čelnik vlade",
      tone: 'semantic',
    },
    {
      german: "in Rheinland-Pfalz",
      translated: "Porajnje-Falačka",
      tone: 'semantic',
    },
  ],
  "lid:state:RP:9|it": [
    {
      german: "Wie nennt man",
      translated: "Come si chiama",
      tone: 'semantic',
    },
    {
      german: "die Regierungschefin/den Regierungschef",
      translated: "il capo del governo",
      tone: 'semantic',
    },
    {
      german: "in Rheinland-Pfalz",
      translated: "del Land di Renania-Palatinato",
      tone: 'semantic',
    },
  ],
  "lid:state:RP:9|kmr": [
    {
      german: "Wie nennt man",
      translated: "Serokê",
      tone: 'semantic',
    },
    {
      german: "die Regierungschefin/den Regierungschef",
      translated: "hukûmeta",
      tone: 'semantic',
    },
    {
      german: "in Rheinland-Pfalz",
      translated: "Rheinland-Pfalz",
      tone: 'semantic',
    },
  ],
  "lid:state:RP:9|pl": [
    {
      german: "Wie nennt man",
      translated: "Jak nazywa się",
      tone: 'semantic',
    },
    {
      german: "die Regierungschefin/den Regierungschef",
      translated: "szef rządu",
      tone: 'semantic',
    },
    {
      german: "in Rheinland-Pfalz",
      translated: "Nadrenia-Palatynat",
      tone: 'semantic',
    },
  ],
  "lid:state:RP:9|prs": [
    {
      german: "Wie nennt man",
      translated: "رئیس دولت ایالت",
      tone: 'semantic',
    },
    {
      german: "die Regierungschefin/den Regierungschef",
      translated: "چه عنوانی دارد",
      tone: 'semantic',
    },
    {
      german: "in Rheinland-Pfalz",
      translated: "راینلاند-فالتس",
      tone: 'semantic',
    },
  ],
  "lid:state:RP:9|ro": [
    {
      german: "Wie nennt man",
      translated: "Cum se numește",
      tone: 'semantic',
    },
    {
      german: "die Regierungschefin/den Regierungschef",
      translated: "șeful guvernului landului",
      tone: 'semantic',
    },
    {
      german: "in Rheinland-Pfalz",
      translated: "Renania-Palatinat",
      tone: 'semantic',
    },
  ],
  "lid:state:RP:9|ru": [
    {
      german: "Wie nennt man",
      translated: "Как называют",
      tone: 'semantic',
    },
    {
      german: "die Regierungschefin/den Regierungschef",
      translated: "главу правительства",
      tone: 'semantic',
    },
    {
      german: "in Rheinland-Pfalz",
      translated: "в федеральной земле Рейнланд-Пфальц",
      tone: 'semantic',
    },
  ],
  "lid:state:RP:9|sq": [
    {
      german: "Wie nennt man",
      translated: "Si quhet kreu",
      tone: 'semantic',
    },
    {
      german: "die Regierungschefin/den Regierungschef",
      translated: "i qeverisë së landit",
      tone: 'semantic',
    },
    {
      german: "in Rheinland-Pfalz",
      translated: "Rheinland-Pfalz",
      tone: 'semantic',
    },
  ],
  "lid:state:RP:9|sr": [
    {
      german: "Wie nennt man",
      translated: "Kako se zove",
      tone: 'semantic',
    },
    {
      german: "die Regierungschefin/den Regierungschef",
      translated: "šef vlade savezne pokrajine",
      tone: 'semantic',
    },
    {
      german: "in Rheinland-Pfalz",
      translated: "Rajna-Palatinat",
      tone: 'semantic',
    },
  ],
  "lid:state:RP:9|tr": [
    {
      german: "Wie nennt man",
      translated: "ne ad verilir",
      tone: 'semantic',
    },
    {
      german: "die Regierungschefin/den Regierungschef",
      translated: "hükümetinin başındaki kişiye",
      tone: 'semantic',
    },
    {
      german: "in Rheinland-Pfalz",
      translated: "Rheinland-Pfalz",
      tone: 'semantic',
    },
  ],
  "lid:state:RP:9|uk": [
    {
      german: "Wie nennt man",
      translated: "Як називають",
      tone: 'semantic',
    },
    {
      german: "die Regierungschefin/den Regierungschef",
      translated: "главу уряду",
      tone: 'semantic',
    },
    {
      german: "in Rheinland-Pfalz",
      translated: "федеральної землі Рейнланд-Пфальц",
      tone: 'semantic',
    },
  ],
  "lid:state:RP:9|vi": [
    {
      german: "Wie nennt man",
      translated: "được gọi là",
      tone: 'semantic',
    },
    {
      german: "die Regierungschefin/den Regierungschef",
      translated: "Người đứng đầu chính phủ",
      tone: 'semantic',
    },
    {
      german: "in Rheinland-Pfalz",
      translated: "bang Rheinland-Pfalz",
      tone: 'semantic',
    },
  ],
  "lid:state:SH:10|ar": [
    {
      german: "Welche Ministerin/welchen Minister",
      translated: "أي وزارة من الوزارات التالية",
      tone: 'semantic',
    },
    {
      german: "Schleswig-Holstein",
      translated: "ولاية Schleswig-Holstein",
      tone: 'semantic',
    },
    {
      german: "nicht",
      translated: "غير موجودة",
      tone: 'semantic',
    },
  ],
  "lid:state:SH:10|bg": [
    {
      german: "Welche Ministerin/welchen Minister",
      translated: "Кой министър",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "не съществува",
      tone: 'semantic',
    },
    {
      german: "Schleswig-Holstein",
      translated: "на ниво федерална провинция Шлезвиг-Холщайн",
      tone: 'semantic',
    },
  ],
  "lid:state:SH:10|bs": [
    {
      german: "Welche Ministerin/welchen Minister",
      translated: "Koji ministar",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "ne postoji",
      tone: 'semantic',
    },
    {
      german: "Schleswig-Holstein",
      translated: "Schleswig-Holstein",
      tone: 'semantic',
    },
  ],
  "lid:state:SH:10|el": [
    {
      german: "Welche Ministerin/welchen Minister",
      translated: "Ποιος υπουργός",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "υπάρχει",
      tone: 'semantic',
    },
    {
      german: "Schleswig-Holstein",
      translated: "Σλέσβιχ-Χόλσταϊν",
      tone: 'semantic',
    },
    {
      german: "nicht",
      translated: "δεν",
      tone: 'semantic',
    },
  ],
  "lid:state:SH:10|en": [
    {
      german: "Welche Ministerin/welchen Minister",
      translated: "Which minister",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "does",
      tone: 'semantic',
    },
    {
      german: "Schleswig-Holstein",
      translated: "Schleswig-Holstein",
      tone: 'semantic',
    },
    {
      german: "nicht",
      translated: "not",
      tone: 'semantic',
    },
  ],
  "lid:state:SH:10|es": [
    {
      german: "Welche Ministerin/welchen Minister",
      translated: "¿Qué ministerio",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "existe",
      tone: 'semantic',
    },
    {
      german: "Schleswig-Holstein",
      translated: "Schleswig-Holstein",
      tone: 'semantic',
    },
    {
      german: "nicht",
      translated: "NO",
      tone: 'semantic',
    },
  ],
  "lid:state:SH:10|fa": [
    {
      german: "Welche Ministerin/welchen Minister",
      translated: "کدام وزیر",
      tone: 'semantic',
    },
    {
      german: "Schleswig-Holstein",
      translated: "اشلسویگ-هولشتاین",
      tone: 'semantic',
    },
    {
      german: "nicht",
      translated: "وجود ندارد",
      tone: 'semantic',
    },
  ],
  "lid:state:SH:10|fr": [
    {
      german: "Welche Ministerin/welchen Minister",
      translated: "Quel ministre ou quelle ministre",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "existe",
      tone: 'semantic',
    },
    {
      german: "Schleswig-Holstein",
      translated: "Schleswig-Holstein",
      tone: 'semantic',
    },
    {
      german: "nicht",
      translated: "pas",
      tone: 'semantic',
    },
  ],
  "lid:state:SH:10|hr": [
    {
      german: "Welche Ministerin/welchen Minister",
      translated: "Koji ministar",
      tone: 'semantic',
    },
    {
      german: "Schleswig-Holstein",
      translated: "Schleswig-Holstein",
      tone: 'semantic',
    },
    {
      german: "nicht",
      translated: "ne postoji",
      tone: 'semantic',
    },
  ],
  "lid:state:SH:10|it": [
    {
      german: "Welche Ministerin/welchen Minister",
      translated: "Quale ministro",
      tone: 'semantic',
    },
    {
      german: "Schleswig-Holstein",
      translated: "Land di Schleswig-Holstein",
      tone: 'semantic',
    },
    {
      german: "nicht",
      translated: "non esiste",
      tone: 'semantic',
    },
  ],
  "lid:state:SH:10|kmr": [
    {
      german: "Welche Ministerin/welchen Minister",
      translated: "Kîjan wezîr li",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "tune",
      tone: 'semantic',
    },
    {
      german: "Schleswig-Holstein",
      translated: "Schleswig-Holstein",
      tone: 'semantic',
    },
    {
      german: "nicht",
      translated: "ye",
      tone: 'semantic',
    },
  ],
  "lid:state:SH:10|pl": [
    {
      german: "Welche Ministerin/welchen Minister",
      translated: "Którego ministra",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "ma",
      tone: 'semantic',
    },
    {
      german: "Schleswig-Holstein",
      translated: "Szlezwik-Holsztyn",
      tone: 'semantic',
    },
    {
      german: "nicht",
      translated: "nie",
      tone: 'semantic',
    },
  ],
  "lid:state:SH:10|prs": [
    {
      german: "Welche Ministerin/welchen Minister",
      translated: "کدام وزیر",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "وجود ندارد",
      tone: 'semantic',
    },
    {
      german: "Schleswig-Holstein",
      translated: "اشلسویگ-هولشتاین",
      tone: 'semantic',
    },
  ],
  "lid:state:SH:10|ro": [
    {
      german: "Welche Ministerin/welchen Minister",
      translated: "Care ministru",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "nu există",
      tone: 'semantic',
    },
    {
      german: "Schleswig-Holstein",
      translated: "la nivelul landului Schleswig-Holstein",
      tone: 'semantic',
    },
  ],
  "lid:state:SH:10|ru": [
    {
      german: "Welche Ministerin/welchen Minister",
      translated: "Какого министра",
      tone: 'semantic',
    },
    {
      german: "Schleswig-Holstein",
      translated: "Шлезвиг-Гольштейн",
      tone: 'semantic',
    },
    {
      german: "nicht",
      translated: "нет",
      tone: 'semantic',
    },
  ],
  "lid:state:SH:10|sq": [
    {
      german: "Welche Ministerin/welchen Minister",
      translated: "Cili ministër",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "ekziston",
      tone: 'semantic',
    },
    {
      german: "Schleswig-Holstein",
      translated: "Schleswig-Holstein",
      tone: 'semantic',
    },
    {
      german: "nicht",
      translated: "nuk",
      tone: 'semantic',
    },
  ],
  "lid:state:SH:10|sr": [
    {
      german: "Welche Ministerin/welchen Minister",
      translated: "Koji ministar",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "ne postoji",
      tone: 'semantic',
    },
    {
      german: "Schleswig-Holstein",
      translated: "na razini savezne pokrajine Šlezvig-Holštajn",
      tone: 'semantic',
    },
  ],
  "lid:state:SH:10|tr": [
    {
      german: "Welche Ministerin/welchen Minister",
      translated: "aşağıdaki bakanlıklardan hangisi",
      tone: 'semantic',
    },
    {
      german: "Schleswig-Holstein",
      translated: "Schleswig-Holstein'da",
      tone: 'semantic',
    },
    {
      german: "nicht",
      translated: "yoktur",
      tone: 'semantic',
    },
  ],
  "lid:state:SH:10|uk": [
    {
      german: "Welche Ministerin/welchen Minister",
      translated: "Якого міністра/міністерки",
      tone: 'semantic',
    },
    {
      german: "Schleswig-Holstein",
      translated: "Шлезвіг-Гольштейн",
      tone: 'semantic',
    },
    {
      german: "nicht",
      translated: "немає",
      tone: 'semantic',
    },
  ],
  "lid:state:SH:10|vi": [
    {
      german: "Welche Ministerin/welchen Minister",
      translated: "Bộ trưởng nào",
      tone: 'semantic',
    },
    {
      german: "Schleswig-Holstein",
      translated: "cấp bang Schleswig-Holstein",
      tone: 'semantic',
    },
    {
      german: "nicht",
      translated: "không tồn tại",
      tone: 'semantic',
    },
  ],
  "lid:state:SH:1|ar": [
    {
      german: "Welches Wappen",
      translated: "أي شعار من الصور",
      tone: 'semantic',
    },
    {
      german: "gehört zum",
      translated: "يعود إلى",
      tone: 'semantic',
    },
    {
      german: "Bundesland",
      translated: "ولاية",
      tone: 'semantic',
    },
    {
      german: "Schleswig-Holstein",
      translated: "Schleswig-Holstein",
      tone: 'semantic',
    },
  ],
  "lid:state:SH:1|bg": [
    {
      german: "Welches Wappen",
      translated: "Кой герб",
      tone: 'semantic',
    },
    {
      german: "gehört zum",
      translated: "принадлежи на",
      tone: 'semantic',
    },
    {
      german: "Bundesland",
      translated: "федералната провинция",
      tone: 'semantic',
    },
    {
      german: "Schleswig-Holstein",
      translated: "Шлезвиг-Холщайн",
      tone: 'semantic',
    },
  ],
  "lid:state:SH:1|bs": [
    {
      german: "Welches Wappen",
      translated: "Koji grb",
      tone: 'semantic',
    },
    {
      german: "gehört zum",
      translated: "pripada",
      tone: 'semantic',
    },
    {
      german: "Bundesland",
      translated: "saveznoj zemlji",
      tone: 'semantic',
    },
    {
      german: "Schleswig-Holstein",
      translated: "Schleswig-Holstein",
      tone: 'semantic',
    },
  ],
  "lid:state:SH:1|el": [
    {
      german: "Welches Wappen",
      translated: "Ποιο έμβλημα",
      tone: 'semantic',
    },
    {
      german: "gehört zum",
      translated: "ανήκει στο ομόσπονδο",
      tone: 'semantic',
    },
    {
      german: "Bundesland",
      translated: "κρατίδιο",
      tone: 'semantic',
    },
    {
      german: "Schleswig-Holstein",
      translated: "Σλέσβιχ-Χόλσταϊν",
      tone: 'semantic',
    },
  ],
  "lid:state:SH:1|en": [
    {
      german: "Welches Wappen",
      translated: "Which coat of arms",
      tone: 'semantic',
    },
    {
      german: "gehört zum",
      translated: "belongs to",
      tone: 'semantic',
    },
    {
      german: "Bundesland",
      translated: "the federal state of",
      tone: 'semantic',
    },
    {
      german: "Schleswig-Holstein",
      translated: "Schleswig-Holstein",
      tone: 'semantic',
    },
  ],
  "lid:state:SH:1|es": [
    {
      german: "Welches Wappen",
      translated: "¿Qué escudo",
      tone: 'semantic',
    },
    {
      german: "gehört zum",
      translated: "pertenece al",
      tone: 'semantic',
    },
    {
      german: "Bundesland",
      translated: "estado federado",
      tone: 'semantic',
    },
    {
      german: "Schleswig-Holstein",
      translated: "Schleswig-Holstein",
      tone: 'semantic',
    },
  ],
  "lid:state:SH:1|fa": [
    {
      german: "Welches Wappen",
      translated: "کدام نشان",
      tone: 'semantic',
    },
    {
      german: "gehört zum",
      translated: "متعلق به",
      tone: 'semantic',
    },
    {
      german: "Bundesland",
      translated: "ایالت",
      tone: 'semantic',
    },
    {
      german: "Schleswig-Holstein",
      translated: "اشلسویگ-هولشتاین",
      tone: 'semantic',
    },
  ],
  "lid:state:SH:1|fr": [
    {
      german: "Welches Wappen",
      translated: "Quel blason",
      tone: 'semantic',
    },
    {
      german: "gehört zum",
      translated: "appartient au",
      tone: 'semantic',
    },
    {
      german: "Bundesland",
      translated: "Land de",
      tone: 'semantic',
    },
    {
      german: "Schleswig-Holstein",
      translated: "Schleswig-Holstein",
      tone: 'semantic',
    },
  ],
  "lid:state:SH:1|hr": [
    {
      german: "Welches Wappen",
      translated: "Koji grb",
      tone: 'semantic',
    },
    {
      german: "gehört zum",
      translated: "pripada",
      tone: 'semantic',
    },
    {
      german: "Bundesland",
      translated: "saveznoj zemlji",
      tone: 'semantic',
    },
    {
      german: "Schleswig-Holstein",
      translated: "Schleswig-Holstein",
      tone: 'semantic',
    },
  ],
  "lid:state:SH:1|it": [
    {
      german: "Welches Wappen",
      translated: "Quale stemma",
      tone: 'semantic',
    },
    {
      german: "gehört zum",
      translated: "appartiene al",
      tone: 'semantic',
    },
    {
      german: "Bundesland",
      translated: "Land",
      tone: 'semantic',
    },
    {
      german: "Schleswig-Holstein",
      translated: "di Schleswig-Holstein",
      tone: 'semantic',
    },
  ],
  "lid:state:SH:1|kmr": [
    {
      german: "Welches Wappen",
      translated: "Kîjan nîşan",
      tone: 'semantic',
    },
    {
      german: "gehört zum",
      translated: "a",
      tone: 'semantic',
    },
    {
      german: "Bundesland",
      translated: "eyaleta",
      tone: 'semantic',
    },
    {
      german: "Schleswig-Holstein",
      translated: "Schleswig-Holstein",
      tone: 'semantic',
    },
  ],
  "lid:state:SH:1|pl": [
    {
      german: "Welches Wappen",
      translated: "Który herb",
      tone: 'semantic',
    },
    {
      german: "gehört zum",
      translated: "należy do",
      tone: 'semantic',
    },
    {
      german: "Bundesland",
      translated: "kraju związkowego",
      tone: 'semantic',
    },
    {
      german: "Schleswig-Holstein",
      translated: "Szlezwik-Holsztyn",
      tone: 'semantic',
    },
  ],
  "lid:state:SH:1|prs": [
    {
      german: "Welches Wappen",
      translated: "نشان",
      tone: 'semantic',
    },
    {
      german: "gehört zum",
      translated: "متعلق به",
      tone: 'semantic',
    },
    {
      german: "Bundesland",
      translated: "ایالت",
      tone: 'semantic',
    },
    {
      german: "Schleswig-Holstein",
      translated: "اشلسویگ-هولشتاین",
      tone: 'semantic',
    },
  ],
  "lid:state:SH:1|ro": [
    {
      german: "Welches Wappen",
      translated: "Care stemă",
      tone: 'semantic',
    },
    {
      german: "gehört zum",
      translated: "aparține",
      tone: 'semantic',
    },
    {
      german: "Bundesland",
      translated: "landului",
      tone: 'semantic',
    },
    {
      german: "Schleswig-Holstein",
      translated: "Schleswig-Holstein",
      tone: 'semantic',
    },
  ],
  "lid:state:SH:1|ru": [
    {
      german: "Welches Wappen",
      translated: "Какой герб",
      tone: 'semantic',
    },
    {
      german: "gehört zum",
      translated: "принадлежит",
      tone: 'semantic',
    },
    {
      german: "Bundesland",
      translated: "федеральной земле",
      tone: 'semantic',
    },
    {
      german: "Schleswig-Holstein",
      translated: "Шлезвиг-Гольштейн",
      tone: 'semantic',
    },
  ],
  "lid:state:SH:1|sq": [
    {
      german: "Welches Wappen",
      translated: "Cila stemë",
      tone: 'semantic',
    },
    {
      german: "gehört zum",
      translated: "i përket",
      tone: 'semantic',
    },
    {
      german: "Bundesland",
      translated: "landit",
      tone: 'semantic',
    },
    {
      german: "Schleswig-Holstein",
      translated: "Schleswig-Holstein",
      tone: 'semantic',
    },
  ],
  "lid:state:SH:1|sr": [
    {
      german: "Welches Wappen",
      translated: "grb",
      tone: 'semantic',
    },
    {
      german: "gehört zum",
      translated: "pripada",
      tone: 'semantic',
    },
    {
      german: "Bundesland",
      translated: "saveznoj pokrajini",
      tone: 'semantic',
    },
    {
      german: "Schleswig-Holstein",
      translated: "Šlezvig-Holštajn",
      tone: 'semantic',
    },
  ],
  "lid:state:SH:1|tr": [
    {
      german: "Welches Wappen",
      translated: "arması hangisidir",
      tone: 'semantic',
    },
    {
      german: "Bundesland",
      translated: "eyaletinin",
      tone: 'semantic',
    },
    {
      german: "Schleswig-Holstein",
      translated: "Schleswig-Holstein",
      tone: 'semantic',
    },
  ],
  "lid:state:SH:1|uk": [
    {
      german: "Welches Wappen",
      translated: "герб",
      tone: 'semantic',
    },
    {
      german: "gehört zum",
      translated: "належить",
      tone: 'semantic',
    },
    {
      german: "Bundesland",
      translated: "землі",
      tone: 'semantic',
    },
    {
      german: "Schleswig-Holstein",
      translated: "Шлезвіг-Гольштейн",
      tone: 'semantic',
    },
  ],
  "lid:state:SH:1|vi": [
    {
      german: "Welches Wappen",
      translated: "Quốc huy nào",
      tone: 'semantic',
    },
    {
      german: "gehört zum",
      translated: "thuộc",
      tone: 'semantic',
    },
    {
      german: "Bundesland",
      translated: "bang",
      tone: 'semantic',
    },
    {
      german: "Schleswig-Holstein",
      translated: "Schleswig-Holstein",
      tone: 'semantic',
    },
  ],
  "lid:state:SH:2|ar": [
    {
      german: "Welches ist",
      translated: "أي مما يلي",
      tone: 'semantic',
    },
    {
      german: "ein Landkreis",
      translated: "دائرة إدارية (Landkreis)",
      tone: 'semantic',
    },
    {
      german: "in Schleswig-Holstein",
      translated: "في Schleswig-Holstein",
      tone: 'semantic',
    },
  ],
  "lid:state:SH:2|bg": [
    {
      german: "Welches ist",
      translated: "Кое",
      tone: 'semantic',
    },
    {
      german: "ein Landkreis",
      translated: "от следните е окръг (Landkreis)",
      tone: 'semantic',
    },
    {
      german: "in Schleswig-Holstein",
      translated: "в Шлезвиг-Холщайн",
      tone: 'semantic',
    },
  ],
  "lid:state:SH:2|bs": [
    {
      german: "Welches ist",
      translated: "Što je",
      tone: 'semantic',
    },
    {
      german: "ein Landkreis",
      translated: "okrug (Landkreis)",
      tone: 'semantic',
    },
    {
      german: "in Schleswig-Holstein",
      translated: "u saveznoj zemlji Schleswig-Holstein",
      tone: 'semantic',
    },
  ],
  "lid:state:SH:2|el": [
    {
      german: "Welches ist",
      translated: "Ποιο",
      tone: 'semantic',
    },
    {
      german: "ein Landkreis",
      translated: "διοικητική περιφέρεια (Landkreis)",
      tone: 'semantic',
    },
    {
      german: "in Schleswig-Holstein",
      translated: "στο Σλέσβιχ-Χόλσταϊν",
      tone: 'semantic',
    },
  ],
  "lid:state:SH:2|en": [
    {
      german: "Welches ist",
      translated: "Which",
      tone: 'semantic',
    },
    {
      german: "ein Landkreis",
      translated: "a district",
      tone: 'semantic',
    },
    {
      german: "in Schleswig-Holstein",
      translated: "in Schleswig-Holstein",
      tone: 'semantic',
    },
  ],
  "lid:state:SH:2|es": [
    {
      german: "Welches ist",
      translated: "¿Cuál de los siguientes es",
      tone: 'semantic',
    },
    {
      german: "ein Landkreis",
      translated: "distrito (Landkreis)",
      tone: 'semantic',
    },
    {
      german: "in Schleswig-Holstein",
      translated: "de Schleswig-Holstein",
      tone: 'semantic',
    },
  ],
  "lid:state:SH:2|fa": [
    {
      german: "Welches ist",
      translated: "کدام‌یک از موارد زیر",
      tone: 'semantic',
    },
    {
      german: "ein Landkreis",
      translated: "یک شهرستان (Landkreis)",
      tone: 'semantic',
    },
    {
      german: "in Schleswig-Holstein",
      translated: "در اشلسویگ-هولشتاین",
      tone: 'semantic',
    },
  ],
  "lid:state:SH:2|fr": [
    {
      german: "Welches ist",
      translated: "Lequel des",
      tone: 'semantic',
    },
    {
      german: "ein Landkreis",
      translated: "arrondissement",
      tone: 'semantic',
    },
    {
      german: "in Schleswig-Holstein",
      translated: "de Schleswig-Holstein",
      tone: 'semantic',
    },
  ],
  "lid:state:SH:2|hr": [
    {
      german: "Welches ist",
      translated: "Što je",
      tone: 'semantic',
    },
    {
      german: "ein Landkreis",
      translated: "od navedenoga okrug (Landkreis)",
      tone: 'semantic',
    },
    {
      german: "in Schleswig-Holstein",
      translated: "u saveznoj zemlji Schleswig-Holstein",
      tone: 'semantic',
    },
  ],
  "lid:state:SH:2|it": [
    {
      german: "Welches ist",
      translated: "Quale dei seguenti",
      tone: 'semantic',
    },
    {
      german: "ein Landkreis",
      translated: "distretto (Landkreis)",
      tone: 'semantic',
    },
    {
      german: "in Schleswig-Holstein",
      translated: "di Schleswig-Holstein",
      tone: 'semantic',
    },
  ],
  "lid:state:SH:2|kmr": [
    {
      german: "Welches ist",
      translated: "Kîjan",
      tone: 'semantic',
    },
    {
      german: "ein Landkreis",
      translated: "ji van navçeyek (Landkreis",
      tone: 'semantic',
    },
    {
      german: "in Schleswig-Holstein",
      translated: "li Schleswig-Holstein ye?",
      tone: 'semantic',
    },
  ],
  "lid:state:SH:2|pl": [
    {
      german: "Welches ist",
      translated: "Który z poniższych",
      tone: 'semantic',
    },
    {
      german: "ein Landkreis",
      translated: "powiatem (Landkreis)",
      tone: 'semantic',
    },
    {
      german: "in Schleswig-Holstein",
      translated: "w Szlezwik-Holsztyn?",
      tone: 'semantic',
    },
  ],
  "lid:state:SH:2|prs": [
    {
      german: "Welches ist",
      translated: "کدام‌یک از",
      tone: 'semantic',
    },
    {
      german: "ein Landkreis",
      translated: "شهرستان",
      tone: 'semantic',
    },
    {
      german: "in Schleswig-Holstein",
      translated: "در اشلسویگ-هولشتاین",
      tone: 'semantic',
    },
  ],
  "lid:state:SH:2|ro": [
    {
      german: "Welches ist",
      translated: "Care dintre următoarele este",
      tone: 'semantic',
    },
    {
      german: "ein Landkreis",
      translated: "district (Landkreis)",
      tone: 'semantic',
    },
    {
      german: "in Schleswig-Holstein",
      translated: "din Schleswig-Holstein",
      tone: 'semantic',
    },
  ],
  "lid:state:SH:2|ru": [
    {
      german: "Welches ist",
      translated: "Какой из",
      tone: 'semantic',
    },
    {
      german: "ein Landkreis",
      translated: "районом",
      tone: 'semantic',
    },
    {
      german: "in Schleswig-Holstein",
      translated: "в федеральной земле Шлезвиг-Гольштейн",
      tone: 'semantic',
    },
  ],
  "lid:state:SH:2|sq": [
    {
      german: "Welches ist",
      translated: "Cila nga këto",
      tone: 'semantic',
    },
    {
      german: "ein Landkreis",
      translated: "qark (Landkreis)",
      tone: 'semantic',
    },
    {
      german: "in Schleswig-Holstein",
      translated: "në Schleswig-Holstein",
      tone: 'semantic',
    },
  ],
  "lid:state:SH:2|sr": [
    {
      german: "Welches ist",
      translated: "Šta je",
      tone: 'semantic',
    },
    {
      german: "ein Landkreis",
      translated: "od navedenoga okrug (Landkreis)",
      tone: 'semantic',
    },
    {
      german: "in Schleswig-Holstein",
      translated: "u saveznoj pokrajini Šlezvig-Holštajn?",
      tone: 'semantic',
    },
  ],
  "lid:state:SH:2|tr": [
    {
      german: "Welches ist",
      translated: "Aşağıdakilerden",
      tone: 'semantic',
    },
    {
      german: "ein Landkreis",
      translated: "ilçedir",
      tone: 'semantic',
    },
    {
      german: "in Schleswig-Holstein",
      translated: "Schleswig-Holstein'da bulunan bir",
      tone: 'semantic',
    },
  ],
  "lid:state:SH:2|uk": [
    {
      german: "Welches ist",
      translated: "Який із",
      tone: 'semantic',
    },
    {
      german: "ein Landkreis",
      translated: "районів",
      tone: 'semantic',
    },
    {
      german: "in Schleswig-Holstein",
      translated: "у федеральній землі Шлезвіг-Гольштейн",
      tone: 'semantic',
    },
  ],
  "lid:state:SH:2|vi": [
    {
      german: "Welches ist",
      translated: "Địa danh nào sau đây là",
      tone: 'semantic',
    },
    {
      german: "ein Landkreis",
      translated: "một huyện (Landkreis)",
      tone: 'semantic',
    },
    {
      german: "in Schleswig-Holstein",
      translated: "của bang Schleswig-Holstein",
      tone: 'semantic',
    },
  ],
  "lid:state:SH:3|ar": [
    {
      german: "Für wie viele Jahre",
      translated: "لمدة كم سنة",
      tone: 'semantic',
    },
    {
      german: "der Landtag",
      translated: "برلمان الولاية",
      tone: 'semantic',
    },
    {
      german: "in Schleswig-Holstein",
      translated: "في Schleswig-Holstein",
      tone: 'semantic',
    },
    {
      german: "gewählt",
      translated: "يُنتخب",
      tone: 'semantic',
    },
  ],
  "lid:state:SH:3|bg": [
    {
      german: "Für wie viele Jahre",
      translated: "За колко години",
      tone: 'semantic',
    },
    {
      german: "der Landtag",
      translated: "парламентът",
      tone: 'semantic',
    },
    {
      german: "in Schleswig-Holstein",
      translated: "на провинция Шлезвиг-Холщайн",
      tone: 'semantic',
    },
    {
      german: "gewählt",
      translated: "се избира",
      tone: 'semantic',
    },
  ],
  "lid:state:SH:3|bs": [
    {
      german: "Für wie viele Jahre",
      translated: "Na koliko se godina",
      tone: 'semantic',
    },
    {
      german: "der Landtag",
      translated: "parlament",
      tone: 'semantic',
    },
    {
      german: "in Schleswig-Holstein",
      translated: "savezne zemlje Schleswig-Holstein",
      tone: 'semantic',
    },
    {
      german: "gewählt",
      translated: "bira",
      tone: 'semantic',
    },
  ],
  "lid:state:SH:3|el": [
    {
      german: "Für wie viele Jahre",
      translated: "Για πόσα χρόνια",
      tone: 'semantic',
    },
    {
      german: "der Landtag",
      translated: "το Landtag",
      tone: 'semantic',
    },
    {
      german: "in Schleswig-Holstein",
      translated: "του Σλέσβιχ-Χόλσταϊν",
      tone: 'semantic',
    },
    {
      german: "gewählt",
      translated: "εκλέγεται",
      tone: 'semantic',
    },
  ],
  "lid:state:SH:3|en": [
    {
      german: "Für wie viele Jahre",
      translated: "For how many years",
      tone: 'semantic',
    },
    {
      german: "der Landtag",
      translated: "the state parliament",
      tone: 'semantic',
    },
    {
      german: "in Schleswig-Holstein",
      translated: "in Schleswig-Holstein",
      tone: 'semantic',
    },
    {
      german: "gewählt",
      translated: "elected",
      tone: 'semantic',
    },
  ],
  "lid:state:SH:3|es": [
    {
      german: "Für wie viele Jahre",
      translated: "¿Por cuántos años",
      tone: 'semantic',
    },
    {
      german: "der Landtag",
      translated: "el parlamento regional",
      tone: 'semantic',
    },
    {
      german: "in Schleswig-Holstein",
      translated: "en Schleswig-Holstein",
      tone: 'semantic',
    },
    {
      german: "gewählt",
      translated: "se elige",
      tone: 'semantic',
    },
  ],
  "lid:state:SH:3|fa": [
    {
      german: "Für wie viele Jahre",
      translated: "چند سال",
      tone: 'semantic',
    },
    {
      german: "der Landtag",
      translated: "پارلمان ایالتی",
      tone: 'semantic',
    },
    {
      german: "in Schleswig-Holstein",
      translated: "اشلسویگ-هولشتاین",
      tone: 'semantic',
    },
    {
      german: "gewählt",
      translated: "انتخاب می‌شود",
      tone: 'semantic',
    },
  ],
  "lid:state:SH:3|fr": [
    {
      german: "Für wie viele Jahre",
      translated: "Pour combien d’années",
      tone: 'semantic',
    },
    {
      german: "der Landtag",
      translated: "le Landtag",
      tone: 'semantic',
    },
    {
      german: "in Schleswig-Holstein",
      translated: "de Schleswig-Holstein",
      tone: 'semantic',
    },
    {
      german: "gewählt",
      translated: "élu",
      tone: 'semantic',
    },
  ],
  "lid:state:SH:3|hr": [
    {
      german: "Für wie viele Jahre",
      translated: "Na koliko se godina",
      tone: 'semantic',
    },
    {
      german: "der Landtag",
      translated: "parlament savezne zemlje",
      tone: 'semantic',
    },
    {
      german: "in Schleswig-Holstein",
      translated: "Schleswig-Holstein",
      tone: 'semantic',
    },
    {
      german: "gewählt",
      translated: "bira",
      tone: 'semantic',
    },
  ],
  "lid:state:SH:3|it": [
    {
      german: "Für wie viele Jahre",
      translated: "Per quanti anni",
      tone: 'semantic',
    },
    {
      german: "der Landtag",
      translated: "il Landtag",
      tone: 'semantic',
    },
    {
      german: "in Schleswig-Holstein",
      translated: "di Schleswig-Holstein",
      tone: 'semantic',
    },
    {
      german: "gewählt",
      translated: "viene eletto",
      tone: 'semantic',
    },
  ],
  "lid:state:SH:3|kmr": [
    {
      german: "Für wie viele Jahre",
      translated: "çend salan",
      tone: 'semantic',
    },
    {
      german: "der Landtag",
      translated: "Landtag",
      tone: 'semantic',
    },
    {
      german: "in Schleswig-Holstein",
      translated: "a Schleswig-Holstein",
      tone: 'semantic',
    },
    {
      german: "gewählt",
      translated: "hilbijartin",
      tone: 'semantic',
    },
  ],
  "lid:state:SH:3|pl": [
    {
      german: "Für wie viele Jahre",
      translated: "Na ile lat",
      tone: 'semantic',
    },
    {
      german: "der Landtag",
      translated: "parlament",
      tone: 'semantic',
    },
    {
      german: "in Schleswig-Holstein",
      translated: "kraju związkowego Szlezwik-Holsztyn",
      tone: 'semantic',
    },
    {
      german: "gewählt",
      translated: "wybierany",
      tone: 'semantic',
    },
  ],
  "lid:state:SH:3|prs": [
    {
      german: "Für wie viele Jahre",
      translated: "چند سال",
      tone: 'semantic',
    },
    {
      german: "der Landtag",
      translated: "پارلمان ایالتی",
      tone: 'semantic',
    },
    {
      german: "in Schleswig-Holstein",
      translated: "اشلسویگ-هولشتاین",
      tone: 'semantic',
    },
    {
      german: "gewählt",
      translated: "انتخاب می‌شود",
      tone: 'semantic',
    },
  ],
  "lid:state:SH:3|ro": [
    {
      german: "Für wie viele Jahre",
      translated: "Pentru câți ani",
      tone: 'semantic',
    },
    {
      german: "der Landtag",
      translated: "parlamentul",
      tone: 'semantic',
    },
    {
      german: "in Schleswig-Holstein",
      translated: "landului Schleswig-Holstein",
      tone: 'semantic',
    },
    {
      german: "gewählt",
      translated: "este ales",
      tone: 'semantic',
    },
  ],
  "lid:state:SH:3|ru": [
    {
      german: "Für wie viele Jahre",
      translated: "На сколько лет",
      tone: 'semantic',
    },
    {
      german: "der Landtag",
      translated: "ландтаг",
      tone: 'semantic',
    },
    {
      german: "in Schleswig-Holstein",
      translated: "в федеральной земле Шлезвиг-Гольштейн",
      tone: 'semantic',
    },
    {
      german: "gewählt",
      translated: "избирается",
      tone: 'semantic',
    },
  ],
  "lid:state:SH:3|sq": [
    {
      german: "Für wie viele Jahre",
      translated: "sa vjet",
      tone: 'semantic',
    },
    {
      german: "der Landtag",
      translated: "Landtagu",
      tone: 'semantic',
    },
    {
      german: "in Schleswig-Holstein",
      translated: "i Schleswig-Holstein",
      tone: 'semantic',
    },
    {
      german: "gewählt",
      translated: "zgjidhet",
      tone: 'semantic',
    },
  ],
  "lid:state:SH:3|sr": [
    {
      german: "Für wie viele Jahre",
      translated: "Na koliko se godina",
      tone: 'semantic',
    },
    {
      german: "der Landtag",
      translated: "parlament",
      tone: 'semantic',
    },
    {
      german: "in Schleswig-Holstein",
      translated: "savezne pokrajine Šlezvig-Holštajn",
      tone: 'semantic',
    },
    {
      german: "gewählt",
      translated: "bira",
      tone: 'semantic',
    },
  ],
  "lid:state:SH:3|tr": [
    {
      german: "Für wie viele Jahre",
      translated: "kaç yıllığına",
      tone: 'semantic',
    },
    {
      german: "der Landtag",
      translated: "(Landtag)",
      tone: 'semantic',
    },
    {
      german: "in Schleswig-Holstein",
      translated: "Schleswig-Holstein",
      tone: 'semantic',
    },
    {
      german: "gewählt",
      translated: "seçilir",
      tone: 'semantic',
    },
  ],
  "lid:state:SH:3|uk": [
    {
      german: "Für wie viele Jahre",
      translated: "На скільки років",
      tone: 'semantic',
    },
    {
      german: "der Landtag",
      translated: "земельний парламент",
      tone: 'semantic',
    },
    {
      german: "in Schleswig-Holstein",
      translated: "у федеральній землі Шлезвіг-Гольштейн",
      tone: 'semantic',
    },
    {
      german: "gewählt",
      translated: "обирають",
      tone: 'semantic',
    },
  ],
  "lid:state:SH:3|vi": [
    {
      german: "Für wie viele Jahre",
      translated: "bao nhiêu năm?",
      tone: 'semantic',
    },
    {
      german: "der Landtag",
      translated: "Nghị viện bang (Landtag)",
      tone: 'semantic',
    },
    {
      german: "in Schleswig-Holstein",
      translated: "của Schleswig-Holstein",
      tone: 'semantic',
    },
    {
      german: "gewählt",
      translated: "được bầu với nhiệm kỳ",
      tone: 'semantic',
    },
  ],
  "lid:state:SH:4|ar": [
    {
      german: "Ab welchem Alter",
      translated: "ابتداءً من أي سن",
      tone: 'semantic',
    },
    {
      german: "darf man",
      translated: "يحق",
      tone: 'semantic',
    },
    {
      german: "in Schleswig-Holstein",
      translated: "في Schleswig-Holstein",
      tone: 'semantic',
    },
    {
      german: "bei Kommunalwahlen",
      translated: "في الانتخابات المحلية",
      tone: 'semantic',
    },
    {
      german: "wählen",
      translated: "التصويت",
      tone: 'semantic',
    },
  ],
  "lid:state:SH:4|bg": [
    {
      german: "Ab welchem Alter",
      translated: "От каква възраст",
      tone: 'semantic',
    },
    {
      german: "in Schleswig-Holstein",
      translated: "в Шлезвиг-Холщайн",
      tone: 'semantic',
    },
    {
      german: "bei Kommunalwahlen",
      translated: "на общински избори",
      tone: 'semantic',
    },
    {
      german: "wählen",
      translated: "да се гласува",
      tone: 'semantic',
    },
  ],
  "lid:state:SH:4|bs": [
    {
      german: "Ab welchem Alter",
      translated: "Od koje se dobi",
      tone: 'semantic',
    },
    {
      german: "darf man",
      translated: "može",
      tone: 'semantic',
    },
    {
      german: "in Schleswig-Holstein",
      translated: "u saveznoj zemlji Schleswig-Holstein",
      tone: 'semantic',
    },
    {
      german: "bei Kommunalwahlen",
      translated: "na lokalnim izborima",
      tone: 'semantic',
    },
    {
      german: "wählen",
      translated: "glasovati",
      tone: 'semantic',
    },
  ],
  "lid:state:SH:4|el": [
    {
      german: "Ab welchem Alter",
      translated: "Από ποια ηλικία",
      tone: 'semantic',
    },
    {
      german: "darf man",
      translated: "μπορεί κάποιος",
      tone: 'semantic',
    },
    {
      german: "in Schleswig-Holstein",
      translated: "στο Σλέσβιχ-Χόλσταϊν",
      tone: 'semantic',
    },
    {
      german: "bei Kommunalwahlen",
      translated: "στις δημοτικές εκλογές",
      tone: 'semantic',
    },
    {
      german: "wählen",
      translated: "να ψηφίσει",
      tone: 'semantic',
    },
  ],
  "lid:state:SH:4|en": [
    {
      german: "Ab welchem Alter",
      translated: "From what age",
      tone: 'semantic',
    },
    {
      german: "darf man",
      translated: "can you",
      tone: 'semantic',
    },
    {
      german: "in Schleswig-Holstein",
      translated: "in Schleswig-Holstein",
      tone: 'semantic',
    },
    {
      german: "bei Kommunalwahlen",
      translated: "in local elections",
      tone: 'semantic',
    },
    {
      german: "wählen",
      translated: "vote",
      tone: 'semantic',
    },
  ],
  "lid:state:SH:4|es": [
    {
      german: "Ab welchem Alter",
      translated: "¿A partir de qué edad",
      tone: 'semantic',
    },
    {
      german: "darf man",
      translated: "se puede",
      tone: 'semantic',
    },
    {
      german: "in Schleswig-Holstein",
      translated: "de Schleswig-Holstein",
      tone: 'semantic',
    },
    {
      german: "bei Kommunalwahlen",
      translated: "en las elecciones municipales",
      tone: 'semantic',
    },
    {
      german: "wählen",
      translated: "votar",
      tone: 'semantic',
    },
  ],
  "lid:state:SH:4|fa": [
    {
      german: "Ab welchem Alter",
      translated: "از چه سنی",
      tone: 'semantic',
    },
    {
      german: "darf man",
      translated: "می‌توان",
      tone: 'semantic',
    },
    {
      german: "in Schleswig-Holstein",
      translated: "در انتخابات محلی اشلسویگ-هولشتاین",
      tone: 'semantic',
    },
    {
      german: "wählen",
      translated: "رأی داد",
      tone: 'semantic',
    },
  ],
  "lid:state:SH:4|fr": [
    {
      german: "Ab welchem Alter",
      translated: "À partir de quel âge",
      tone: 'semantic',
    },
    {
      german: "darf man",
      translated: "peut-on",
      tone: 'semantic',
    },
    {
      german: "in Schleswig-Holstein",
      translated: "en Schleswig-Holstein",
      tone: 'semantic',
    },
    {
      german: "bei Kommunalwahlen",
      translated: "aux élections municipales",
      tone: 'semantic',
    },
    {
      german: "wählen",
      translated: "voter",
      tone: 'semantic',
    },
  ],
  "lid:state:SH:4|hr": [
    {
      german: "Ab welchem Alter",
      translated: "Od koje se dobi",
      tone: 'semantic',
    },
    {
      german: "darf man",
      translated: "može",
      tone: 'semantic',
    },
    {
      german: "in Schleswig-Holstein",
      translated: "u saveznoj zemlji Schleswig-Holstein",
      tone: 'semantic',
    },
    {
      german: "bei Kommunalwahlen",
      translated: "na lokalnim izborima",
      tone: 'semantic',
    },
    {
      german: "wählen",
      translated: "glasovati",
      tone: 'semantic',
    },
  ],
  "lid:state:SH:4|it": [
    {
      german: "Ab welchem Alter",
      translated: "Da quale età",
      tone: 'semantic',
    },
    {
      german: "darf man",
      translated: "si può",
      tone: 'semantic',
    },
    {
      german: "in Schleswig-Holstein",
      translated: "in Schleswig-Holstein",
      tone: 'semantic',
    },
    {
      german: "bei Kommunalwahlen",
      translated: "alle elezioni comunali",
      tone: 'semantic',
    },
    {
      german: "wählen",
      translated: "votare",
      tone: 'semantic',
    },
  ],
  "lid:state:SH:4|kmr": [
    {
      german: "Ab welchem Alter",
      translated: "Ji kîjan temenê",
      tone: 'semantic',
    },
    {
      german: "darf man",
      translated: "dikare",
      tone: 'semantic',
    },
    {
      german: "in Schleswig-Holstein",
      translated: "li Schleswig-Holstein",
      tone: 'semantic',
    },
    {
      german: "bei Kommunalwahlen",
      translated: "di hilbijartinên şaredariyê de",
      tone: 'semantic',
    },
    {
      german: "wählen",
      translated: "deng were dayîn",
      tone: 'semantic',
    },
  ],
  "lid:state:SH:4|pl": [
    {
      german: "Ab welchem Alter",
      translated: "Od jakiego wieku",
      tone: 'semantic',
    },
    {
      german: "darf man",
      translated: "można",
      tone: 'semantic',
    },
    {
      german: "in Schleswig-Holstein",
      translated: "w Szlezwik-Holsztyn",
      tone: 'semantic',
    },
    {
      german: "bei Kommunalwahlen",
      translated: "w wyborach samorządowych",
      tone: 'semantic',
    },
    {
      german: "wählen",
      translated: "głosować",
      tone: 'semantic',
    },
  ],
  "lid:state:SH:4|prs": [
    {
      german: "Ab welchem Alter",
      translated: "از چه سنی",
      tone: 'semantic',
    },
    {
      german: "darf man",
      translated: "می‌توان",
      tone: 'semantic',
    },
    {
      german: "in Schleswig-Holstein",
      translated: "اشلسویگ-هولشتاین",
      tone: 'semantic',
    },
    {
      german: "bei Kommunalwahlen",
      translated: "در انتخابات شاروالی",
      tone: 'semantic',
    },
    {
      german: "wählen",
      translated: "رأی داد",
      tone: 'semantic',
    },
  ],
  "lid:state:SH:4|ro": [
    {
      german: "Ab welchem Alter",
      translated: "De la ce vârstă",
      tone: 'semantic',
    },
    {
      german: "darf man",
      translated: "se poate",
      tone: 'semantic',
    },
    {
      german: "in Schleswig-Holstein",
      translated: "din Schleswig-Holstein",
      tone: 'semantic',
    },
    {
      german: "bei Kommunalwahlen",
      translated: "la alegerile locale",
      tone: 'semantic',
    },
    {
      german: "wählen",
      translated: "vota",
      tone: 'semantic',
    },
  ],
  "lid:state:SH:4|ru": [
    {
      german: "Ab welchem Alter",
      translated: "С какого возраста",
      tone: 'semantic',
    },
    {
      german: "darf man",
      translated: "можно",
      tone: 'semantic',
    },
    {
      german: "in Schleswig-Holstein",
      translated: "в федеральной земле Шлезвиг-Гольштейн",
      tone: 'semantic',
    },
    {
      german: "bei Kommunalwahlen",
      translated: "на муниципальных выборах",
      tone: 'semantic',
    },
    {
      german: "wählen",
      translated: "голосовать",
      tone: 'semantic',
    },
  ],
  "lid:state:SH:4|sq": [
    {
      german: "Ab welchem Alter",
      translated: "Nga cila moshë",
      tone: 'semantic',
    },
    {
      german: "darf man",
      translated: "mund të",
      tone: 'semantic',
    },
    {
      german: "in Schleswig-Holstein",
      translated: "në Schleswig-Holstein",
      tone: 'semantic',
    },
    {
      german: "bei Kommunalwahlen",
      translated: "në zgjedhjet komunale",
      tone: 'semantic',
    },
    {
      german: "wählen",
      translated: "votohet",
      tone: 'semantic',
    },
  ],
  "lid:state:SH:4|sr": [
    {
      german: "Ab welchem Alter",
      translated: "Od koje se dobi",
      tone: 'semantic',
    },
    {
      german: "darf man",
      translated: "može",
      tone: 'semantic',
    },
    {
      german: "in Schleswig-Holstein",
      translated: "u saveznoj pokrajini Šlezvig-Holštajn",
      tone: 'semantic',
    },
    {
      german: "bei Kommunalwahlen",
      translated: "na lokalnim izborima",
      tone: 'semantic',
    },
    {
      german: "wählen",
      translated: "glasati",
      tone: 'semantic',
    },
  ],
  "lid:state:SH:4|tr": [
    {
      german: "Ab welchem Alter",
      translated: "kaç yaşından itibaren",
      tone: 'semantic',
    },
    {
      german: "in Schleswig-Holstein",
      translated: "Schleswig-Holstein'da",
      tone: 'semantic',
    },
    {
      german: "bei Kommunalwahlen",
      translated: "yerel seçimlerde",
      tone: 'semantic',
    },
    {
      german: "wählen",
      translated: "oy kullanılabilir",
      tone: 'semantic',
    },
  ],
  "lid:state:SH:4|uk": [
    {
      german: "Ab welchem Alter",
      translated: "З якого віку",
      tone: 'semantic',
    },
    {
      german: "darf man",
      translated: "можна",
      tone: 'semantic',
    },
    {
      german: "in Schleswig-Holstein",
      translated: "у федеральній землі Шлезвіг-Гольштейн",
      tone: 'semantic',
    },
    {
      german: "bei Kommunalwahlen",
      translated: "на муніципальних виборах",
      tone: 'semantic',
    },
    {
      german: "wählen",
      translated: "голосувати",
      tone: 'semantic',
    },
  ],
  "lid:state:SH:4|vi": [
    {
      german: "Ab welchem Alter",
      translated: "Từ bao nhiêu tuổi",
      tone: 'semantic',
    },
    {
      german: "darf man",
      translated: "có thể",
      tone: 'semantic',
    },
    {
      german: "in Schleswig-Holstein",
      translated: "ở bang Schleswig-Holstein",
      tone: 'semantic',
    },
    {
      german: "bei Kommunalwahlen",
      translated: "trong bầu cử địa phương",
      tone: 'semantic',
    },
    {
      german: "wählen",
      translated: "bỏ phiếu",
      tone: 'semantic',
    },
  ],
  "lid:state:SH:5|ar": [
    {
      german: "Welche Farben",
      translated: "ما",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "ألوان",
      tone: 'semantic',
    },
    {
      german: "die Landesflagge von Schleswig-Holstein",
      translated: "علم ولاية Schleswig-Holstein",
      tone: 'semantic',
    },
  ],
  "lid:state:SH:5|bg": [
    {
      german: "Welche Farben",
      translated: "Какви са",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "цветовете",
      tone: 'semantic',
    },
    {
      german: "die Landesflagge von Schleswig-Holstein",
      translated: "на знамето на провинция Шлезвиг-Холщайн",
      tone: 'semantic',
    },
  ],
  "lid:state:SH:5|bs": [
    {
      german: "Welche Farben",
      translated: "Koje su boje",
      tone: 'semantic',
    },
    {
      german: "die Landesflagge von Schleswig-Holstein",
      translated: "zastave savezne zemlje Schleswig-Holstein",
      tone: 'semantic',
    },
  ],
  "lid:state:SH:5|el": [
    {
      german: "Welche Farben",
      translated: "Ποια είναι τα χρώματα",
      tone: 'semantic',
    },
    {
      german: "die Landesflagge von Schleswig-Holstein",
      translated: "της σημαίας του κρατιδίου Σλέσβιχ-Χόλσταϊν",
      tone: 'semantic',
    },
  ],
  "lid:state:SH:5|en": [
    {
      german: "Welche Farben",
      translated: "What colors",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "does",
      tone: 'semantic',
    },
    {
      german: "die Landesflagge von Schleswig-Holstein",
      translated: "the state flag of Schleswig-Holstein",
      tone: 'semantic',
    },
  ],
  "lid:state:SH:5|es": [
    {
      german: "Welche Farben",
      translated: "¿Qué colores",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "tiene",
      tone: 'semantic',
    },
    {
      german: "die Landesflagge von Schleswig-Holstein",
      translated: "la bandera regional de Schleswig-Holstein",
      tone: 'semantic',
    },
  ],
  "lid:state:SH:5|fa": [
    {
      german: "Welche Farben",
      translated: "رنگ‌های",
      tone: 'semantic',
    },
    {
      german: "die Landesflagge von Schleswig-Holstein",
      translated: "پرچم ایالت اشلسویگ-هولشتاین",
      tone: 'semantic',
    },
  ],
  "lid:state:SH:5|fr": [
    {
      german: "Welche Farben",
      translated: "Quelles sont les couleurs",
      tone: 'semantic',
    },
    {
      german: "die Landesflagge von Schleswig-Holstein",
      translated: "du drapeau du Land de Schleswig-Holstein",
      tone: 'semantic',
    },
  ],
  "lid:state:SH:5|hr": [
    {
      german: "Welche Farben",
      translated: "Koje su boje",
      tone: 'semantic',
    },
    {
      german: "die Landesflagge von Schleswig-Holstein",
      translated: "zastave savezne zemlje Schleswig-Holstein",
      tone: 'semantic',
    },
  ],
  "lid:state:SH:5|it": [
    {
      german: "Welche Farben",
      translated: "Quali sono i colori",
      tone: 'semantic',
    },
    {
      german: "die Landesflagge von Schleswig-Holstein",
      translated: "della bandiera del Land di Schleswig-Holstein",
      tone: 'semantic',
    },
  ],
  "lid:state:SH:5|kmr": [
    {
      german: "Welche Farben",
      translated: "Rengên",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "çi ne",
      tone: 'semantic',
    },
    {
      german: "die Landesflagge von Schleswig-Holstein",
      translated: "ala eyaleta Schleswig-Holstein",
      tone: 'semantic',
    },
  ],
  "lid:state:SH:5|pl": [
    {
      german: "Welche Farben",
      translated: "Jakie są kolory",
      tone: 'semantic',
    },
    {
      german: "die Landesflagge von Schleswig-Holstein",
      translated: "flagi kraju związkowego Szlezwik-Holsztyn",
      tone: 'semantic',
    },
  ],
  "lid:state:SH:5|prs": [
    {
      german: "Welche Farben",
      translated: "رنگ‌های پرچم ایالت",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "کدام‌اند؟",
      tone: 'semantic',
    },
    {
      german: "die Landesflagge von Schleswig-Holstein",
      translated: "اشلسویگ-هولشتاین",
      tone: 'semantic',
    },
  ],
  "lid:state:SH:5|ro": [
    {
      german: "Welche Farben",
      translated: "Care sunt culorile",
      tone: 'semantic',
    },
    {
      german: "die Landesflagge von Schleswig-Holstein",
      translated: "drapelului landului Schleswig-Holstein",
      tone: 'semantic',
    },
  ],
  "lid:state:SH:5|ru": [
    {
      german: "Welche Farben",
      translated: "Какие цвета",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "у",
      tone: 'semantic',
    },
    {
      german: "die Landesflagge von Schleswig-Holstein",
      translated: "флага земли Шлезвиг-Гольштейн",
      tone: 'semantic',
    },
  ],
  "lid:state:SH:5|sq": [
    {
      german: "Welche Farben",
      translated: "Cilat janë ngjyrat",
      tone: 'semantic',
    },
    {
      german: "die Landesflagge von Schleswig-Holstein",
      translated: "flamurit të landit Schleswig-Holstein",
      tone: 'semantic',
    },
  ],
  "lid:state:SH:5|sr": [
    {
      german: "Welche Farben",
      translated: "Koje su",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "boje",
      tone: 'semantic',
    },
    {
      german: "die Landesflagge von Schleswig-Holstein",
      translated: "zastave savezne pokrajine Šlezvig-Holštajn?",
      tone: 'semantic',
    },
  ],
  "lid:state:SH:5|tr": [
    {
      german: "Welche Farben",
      translated: "renkleri nelerdir",
      tone: 'semantic',
    },
    {
      german: "die Landesflagge von Schleswig-Holstein",
      translated: "Schleswig-Holstein eyalet bayrağının",
      tone: 'semantic',
    },
  ],
  "lid:state:SH:5|uk": [
    {
      german: "Welche Farben",
      translated: "Які кольори",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: " має",
      tone: 'semantic',
    },
    {
      german: "die Landesflagge von Schleswig-Holstein",
      translated: "прапор федеральної землі Шлезвіг-Гольштейн",
      tone: 'semantic',
    },
  ],
  "lid:state:SH:5|vi": [
    {
      german: "Welche Farben",
      translated: "Màu của",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "là",
      tone: 'semantic',
    },
    {
      german: "die Landesflagge von Schleswig-Holstein",
      translated: "cờ bang Schleswig-Holstein",
      tone: 'semantic',
    },
  ],
  "lid:state:SH:6|ar": [
    {
      german: "Wo",
      translated: "أين",
      tone: 'semantic',
    },
    {
      german: "können Sie sich",
      translated: "يمكنك",
      tone: 'semantic',
    },
    {
      german: "in Schleswig-Holstein",
      translated: "في Schleswig-Holstein",
      tone: 'semantic',
    },
    {
      german: "über politische Themen",
      translated: "عن القضايا السياسية",
      tone: 'semantic',
    },
    {
      german: "informieren",
      translated: "الحصول على",
      tone: 'semantic',
    },
  ],
  "lid:state:SH:6|bg": [
    {
      german: "Wo",
      translated: "Къде",
      tone: 'semantic',
    },
    {
      german: "können Sie sich",
      translated: "можете да получите",
      tone: 'semantic',
    },
    {
      german: "in Schleswig-Holstein",
      translated: "в Шлезвиг-Холщайн",
      tone: 'semantic',
    },
    {
      german: "über politische Themen",
      translated: "по политически теми",
      tone: 'semantic',
    },
    {
      german: "informieren",
      translated: "информация",
      tone: 'semantic',
    },
  ],
  "lid:state:SH:6|bs": [
    {
      german: "Wo",
      translated: "Gdje",
      tone: 'semantic',
    },
    {
      german: "können Sie sich",
      translated: "u saveznoj zemlji",
      tone: 'semantic',
    },
    {
      german: "in Schleswig-Holstein",
      translated: "Schleswig-Holstein",
      tone: 'semantic',
    },
    {
      german: "über politische Themen",
      translated: "o političkim temama",
      tone: 'semantic',
    },
    {
      german: "informieren",
      translated: "dobiti informacije",
      tone: 'semantic',
    },
  ],
  "lid:state:SH:6|el": [
    {
      german: "Wo",
      translated: "Πού",
      tone: 'semantic',
    },
    {
      german: "können Sie sich",
      translated: "μπορείτε να",
      tone: 'semantic',
    },
    {
      german: "in Schleswig-Holstein",
      translated: "στο Σλέσβιχ-Χόλσταϊν",
      tone: 'semantic',
    },
    {
      german: "über politische Themen",
      translated: "για πολιτικά θέματα",
      tone: 'semantic',
    },
    {
      german: "informieren",
      translated: "ενημερωθείτε",
      tone: 'semantic',
    },
  ],
  "lid:state:SH:6|en": [
    {
      german: "Wo",
      translated: "Where",
      tone: 'semantic',
    },
    {
      german: "können Sie sich",
      translated: "can you",
      tone: 'semantic',
    },
    {
      german: "in Schleswig-Holstein",
      translated: "in Schleswig-Holstein",
      tone: 'semantic',
    },
    {
      german: "über politische Themen",
      translated: "about political topics",
      tone: 'semantic',
    },
    {
      german: "informieren",
      translated: "get information",
      tone: 'semantic',
    },
  ],
  "lid:state:SH:6|es": [
    {
      german: "Wo",
      translated: "¿Dónde",
      tone: 'semantic',
    },
    {
      german: "können Sie sich",
      translated: "puede",
      tone: 'semantic',
    },
    {
      german: "in Schleswig-Holstein",
      translated: "en Schleswig-Holstein",
      tone: 'semantic',
    },
    {
      german: "über politische Themen",
      translated: "sobre temas políticos",
      tone: 'semantic',
    },
    {
      german: "informieren",
      translated: "informarse",
      tone: 'semantic',
    },
  ],
  "lid:state:SH:6|fa": [
    {
      german: "Wo",
      translated: "از کجا",
      tone: 'semantic',
    },
    {
      german: "können Sie sich",
      translated: "می‌توانید",
      tone: 'semantic',
    },
    {
      german: "in Schleswig-Holstein",
      translated: "در اشلسویگ-هولشتاین",
      tone: 'semantic',
    },
    {
      german: "über politische Themen",
      translated: "دربارهٔ موضوعات سیاسی",
      tone: 'semantic',
    },
    {
      german: "informieren",
      translated: "اطلاعات کسب کنید؟",
      tone: 'semantic',
    },
  ],
  "lid:state:SH:6|fr": [
    {
      german: "Wo",
      translated: "Où",
      tone: 'semantic',
    },
    {
      german: "können Sie sich",
      translated: "pouvez-vous vous",
      tone: 'semantic',
    },
    {
      german: "in Schleswig-Holstein",
      translated: "en Schleswig-Holstein",
      tone: 'semantic',
    },
    {
      german: "über politische Themen",
      translated: "sur les questions politiques",
      tone: 'semantic',
    },
    {
      german: "informieren",
      translated: "informer",
      tone: 'semantic',
    },
  ],
  "lid:state:SH:6|hr": [
    {
      german: "Wo",
      translated: "Gdje",
      tone: 'semantic',
    },
    {
      german: "können Sie sich",
      translated: "u saveznoj zemlji",
      tone: 'semantic',
    },
    {
      german: "in Schleswig-Holstein",
      translated: "Schleswig-Holstein",
      tone: 'semantic',
    },
    {
      german: "über politische Themen",
      translated: "o političkim temama",
      tone: 'semantic',
    },
    {
      german: "informieren",
      translated: "dobiti informacije",
      tone: 'semantic',
    },
  ],
  "lid:state:SH:6|it": [
    {
      german: "Wo",
      translated: "Dove",
      tone: 'semantic',
    },
    {
      german: "können Sie sich",
      translated: "ci si può",
      tone: 'semantic',
    },
    {
      german: "in Schleswig-Holstein",
      translated: "in Schleswig-Holstein",
      tone: 'semantic',
    },
    {
      german: "über politische Themen",
      translated: "su temi politici",
      tone: 'semantic',
    },
    {
      german: "informieren",
      translated: "informare",
      tone: 'semantic',
    },
  ],
  "lid:state:SH:6|kmr": [
    {
      german: "Wo",
      translated: "Li",
      tone: 'semantic',
    },
    {
      german: "in Schleswig-Holstein",
      translated: "Schleswig-Holstein li",
      tone: 'semantic',
    },
    {
      german: "über politische Themen",
      translated: "dikarî li ser mijarên siyasî",
      tone: 'semantic',
    },
    {
      german: "informieren",
      translated: "agahdarî bistînî",
      tone: 'semantic',
    },
  ],
  "lid:state:SH:6|pl": [
    {
      german: "Wo",
      translated: "Gdzie",
      tone: 'semantic',
    },
    {
      german: "können Sie sich",
      translated: "można",
      tone: 'semantic',
    },
    {
      german: "in Schleswig-Holstein",
      translated: "w Szlezwik-Holsztyn",
      tone: 'semantic',
    },
    {
      german: "über politische Themen",
      translated: "na tematy polityczne",
      tone: 'semantic',
    },
    {
      german: "informieren",
      translated: "uzyskać informacje",
      tone: 'semantic',
    },
  ],
  "lid:state:SH:6|prs": [
    {
      german: "Wo",
      translated: "کجا",
      tone: 'semantic',
    },
    {
      german: "können Sie sich",
      translated: "می‌توانید",
      tone: 'semantic',
    },
    {
      german: "in Schleswig-Holstein",
      translated: "در اشلسویگ-هولشتاین",
      tone: 'semantic',
    },
    {
      german: "über politische Themen",
      translated: " دربارهٔ موضوعات سیاسی",
      tone: 'semantic',
    },
    {
      german: "informieren",
      translated: "اطلاعات کسب کنید",
      tone: 'semantic',
    },
  ],
  "lid:state:SH:6|ro": [
    {
      german: "Wo",
      translated: "Unde",
      tone: 'semantic',
    },
    {
      german: "können Sie sich",
      translated: "vă puteți",
      tone: 'semantic',
    },
    {
      german: "in Schleswig-Holstein",
      translated: "în Schleswig-Holstein",
      tone: 'semantic',
    },
    {
      german: "über politische Themen",
      translated: "despre teme politice",
      tone: 'semantic',
    },
    {
      german: "informieren",
      translated: "informa",
      tone: 'semantic',
    },
  ],
  "lid:state:SH:6|ru": [
    {
      german: "Wo",
      translated: "Где",
      tone: 'semantic',
    },
    {
      german: "können Sie sich",
      translated: "можно",
      tone: 'semantic',
    },
    {
      german: "in Schleswig-Holstein",
      translated: "в федеральной земле Шлезвиг-Гольштейн",
      tone: 'semantic',
    },
    {
      german: "über politische Themen",
      translated: "о политических темах",
      tone: 'semantic',
    },
    {
      german: "informieren",
      translated: "получить информацию",
      tone: 'semantic',
    },
  ],
  "lid:state:SH:6|sq": [
    {
      german: "Wo",
      translated: "Ku",
      tone: 'semantic',
    },
    {
      german: "können Sie sich",
      translated: "të",
      tone: 'semantic',
    },
    {
      german: "in Schleswig-Holstein",
      translated: "në Schleswig-Holstein",
      tone: 'semantic',
    },
    {
      german: "über politische Themen",
      translated: "për tema politike",
      tone: 'semantic',
    },
    {
      german: "informieren",
      translated: "informoheni",
      tone: 'semantic',
    },
  ],
  "lid:state:SH:6|sr": [
    {
      german: "Wo",
      translated: "Gdje",
      tone: 'semantic',
    },
    {
      german: "können Sie sich",
      translated: "mogu",
      tone: 'semantic',
    },
    {
      german: "in Schleswig-Holstein",
      translated: "u saveznoj pokrajini Šlezvig-Holštajn",
      tone: 'semantic',
    },
    {
      german: "über politische Themen",
      translated: "o političkim temama",
      tone: 'semantic',
    },
    {
      german: "informieren",
      translated: "dobiti informacije",
      tone: 'semantic',
    },
  ],
  "lid:state:SH:6|tr": [
    {
      german: "Wo",
      translated: "nereden",
      tone: 'semantic',
    },
    {
      german: "können Sie sich",
      translated: "bilgi alabilirsiniz",
      tone: 'semantic',
    },
    {
      german: "in Schleswig-Holstein",
      translated: "Schleswig-Holstein'da",
      tone: 'semantic',
    },
    {
      german: "über politische Themen",
      translated: "siyasi konular hakkında",
      tone: 'semantic',
    },
  ],
  "lid:state:SH:6|uk": [
    {
      german: "Wo",
      translated: "Де",
      tone: 'semantic',
    },
    {
      german: "können Sie sich",
      translated: "можна",
      tone: 'semantic',
    },
    {
      german: "in Schleswig-Holstein",
      translated: "у федеральній землі Шлезвіг-Гольштейн",
      tone: 'semantic',
    },
    {
      german: "über politische Themen",
      translated: "про політичні питання",
      tone: 'semantic',
    },
    {
      german: "informieren",
      translated: "отримати інформацію",
      tone: 'semantic',
    },
  ],
  "lid:state:SH:6|vi": [
    {
      german: "Wo",
      translated: "ở đâu",
      tone: 'semantic',
    },
    {
      german: "können Sie sich",
      translated: "có thể",
      tone: 'semantic',
    },
    {
      german: "in Schleswig-Holstein",
      translated: "Ở bang Schleswig-Holstein",
      tone: 'semantic',
    },
    {
      german: "über politische Themen",
      translated: "về các chủ đề chính trị",
      tone: 'semantic',
    },
    {
      german: "informieren",
      translated: "tìm thông tin",
      tone: 'semantic',
    },
  ],
  "lid:state:SH:7|ar": [
    {
      german: "Die Landeshauptstadt",
      translated: "عاصمة ولاية",
      tone: 'semantic',
    },
    {
      german: "von Schleswig-Holstein",
      translated: "Schleswig-Holstein",
      tone: 'semantic',
    },
  ],
  "lid:state:SH:7|bg": [
    {
      german: "Die Landeshauptstadt",
      translated: "Столицата",
      tone: 'semantic',
    },
    {
      german: "von Schleswig-Holstein",
      translated: "на федералната провинция Шлезвиг-Холщайн",
      tone: 'semantic',
    },
    {
      german: "heißt",
      translated: "е",
      tone: 'semantic',
    },
  ],
  "lid:state:SH:7|bs": [
    {
      german: "Die Landeshauptstadt",
      translated: "Glavni grad",
      tone: 'semantic',
    },
    {
      german: "von Schleswig-Holstein",
      translated: "savezne zemlje Schleswig-Holstein",
      tone: 'semantic',
    },
    {
      german: "heißt",
      translated: "je",
      tone: 'semantic',
    },
  ],
  "lid:state:SH:7|el": [
    {
      german: "Die Landeshauptstadt",
      translated: "Η πρωτεύουσα",
      tone: 'semantic',
    },
    {
      german: "von Schleswig-Holstein",
      translated: "του ομόσπονδου κρατιδίου Σλέσβιχ-Χόλσταϊν",
      tone: 'semantic',
    },
    {
      german: "heißt",
      translated: "είναι",
      tone: 'semantic',
    },
  ],
  "lid:state:SH:7|en": [
    {
      german: "Die Landeshauptstadt",
      translated: "The state capital",
      tone: 'semantic',
    },
    {
      german: "von Schleswig-Holstein",
      translated: "of Schleswig-Holstein",
      tone: 'semantic',
    },
    {
      german: "heißt",
      translated: "is called",
      tone: 'semantic',
    },
  ],
  "lid:state:SH:7|es": [
    {
      german: "Die Landeshauptstadt",
      translated: "La capital",
      tone: 'semantic',
    },
    {
      german: "von Schleswig-Holstein",
      translated: "del estado federado de Schleswig-Holstein",
      tone: 'semantic',
    },
    {
      german: "heißt",
      translated: "es",
      tone: 'semantic',
    },
  ],
  "lid:state:SH:7|fa": [
    {
      german: "Die Landeshauptstadt",
      translated: "مرکز ایالت",
      tone: 'semantic',
    },
    {
      german: "von Schleswig-Holstein",
      translated: "اشلسویگ-هولشتاین",
      tone: 'semantic',
    },
  ],
  "lid:state:SH:7|fr": [
    {
      german: "Die Landeshauptstadt",
      translated: "La capitale du Land",
      tone: 'semantic',
    },
    {
      german: "von Schleswig-Holstein",
      translated: "de Schleswig-Holstein",
      tone: 'semantic',
    },
    {
      german: "heißt",
      translated: "s’appelle",
      tone: 'semantic',
    },
  ],
  "lid:state:SH:7|hr": [
    {
      german: "Die Landeshauptstadt",
      translated: "Glavni grad",
      tone: 'semantic',
    },
    {
      german: "von Schleswig-Holstein",
      translated: "savezne zemlje Schleswig-Holstein",
      tone: 'semantic',
    },
    {
      german: "heißt",
      translated: "je",
      tone: 'semantic',
    },
  ],
  "lid:state:SH:7|it": [
    {
      german: "Die Landeshauptstadt",
      translated: "La capitale del Land",
      tone: 'semantic',
    },
    {
      german: "von Schleswig-Holstein",
      translated: "di Schleswig-Holstein",
      tone: 'semantic',
    },
    {
      german: "heißt",
      translated: "è",
      tone: 'semantic',
    },
  ],
  "lid:state:SH:7|kmr": [
    {
      german: "Die Landeshauptstadt",
      translated: "Paytexta eyaleta",
      tone: 'semantic',
    },
    {
      german: "von Schleswig-Holstein",
      translated: "Schleswig-Holstein",
      tone: 'semantic',
    },
    {
      german: "heißt",
      translated: "…",
      tone: 'semantic',
    },
  ],
  "lid:state:SH:7|pl": [
    {
      german: "Die Landeshauptstadt",
      translated: "Stolicą kraju związkowego",
      tone: 'semantic',
    },
    {
      german: "von Schleswig-Holstein",
      translated: "Szlezwik-Holsztyn",
      tone: 'semantic',
    },
    {
      german: "heißt",
      translated: "jest",
      tone: 'semantic',
    },
  ],
  "lid:state:SH:7|prs": [
    {
      german: "Die Landeshauptstadt",
      translated: "مرکز ایالت",
      tone: 'semantic',
    },
    {
      german: "von Schleswig-Holstein",
      translated: "اشلسویگ-هولشتاین",
      tone: 'semantic',
    },
  ],
  "lid:state:SH:7|ro": [
    {
      german: "Die Landeshauptstadt",
      translated: "Capitala",
      tone: 'semantic',
    },
    {
      german: "von Schleswig-Holstein",
      translated: "landului Schleswig-Holstein",
      tone: 'semantic',
    },
    {
      german: "heißt",
      translated: "este",
      tone: 'semantic',
    },
  ],
  "lid:state:SH:7|ru": [
    {
      german: "Die Landeshauptstadt",
      translated: "Столица земли",
      tone: 'semantic',
    },
    {
      german: "von Schleswig-Holstein",
      translated: "Шлезвиг-Гольштейн",
      tone: 'semantic',
    },
    {
      german: "heißt",
      translated: "называется",
      tone: 'semantic',
    },
  ],
  "lid:state:SH:7|sq": [
    {
      german: "Die Landeshauptstadt",
      translated: "Kryeqyteti i landit",
      tone: 'semantic',
    },
    {
      german: "von Schleswig-Holstein",
      translated: "Schleswig-Holstein",
      tone: 'semantic',
    },
    {
      german: "heißt",
      translated: "është",
      tone: 'semantic',
    },
  ],
  "lid:state:SH:7|sr": [
    {
      german: "Die Landeshauptstadt",
      translated: "Glavni grad",
      tone: 'semantic',
    },
    {
      german: "von Schleswig-Holstein",
      translated: "savezne pokrajine Šlezvig-Holštajn",
      tone: 'semantic',
    },
    {
      german: "heißt",
      translated: "je",
      tone: 'semantic',
    },
  ],
  "lid:state:SH:7|tr": [
    {
      german: "Die Landeshauptstadt",
      translated: "eyalet başkentinin",
      tone: 'semantic',
    },
    {
      german: "von Schleswig-Holstein",
      translated: "Schleswig-Holstein'ın",
      tone: 'semantic',
    },
    {
      german: "heißt",
      translated: "adı",
      tone: 'semantic',
    },
  ],
  "lid:state:SH:7|uk": [
    {
      german: "Die Landeshauptstadt",
      translated: "Столиця",
      tone: 'semantic',
    },
    {
      german: "von Schleswig-Holstein",
      translated: "федеральної землі Шлезвіг-Гольштейн",
      tone: 'semantic',
    },
    {
      german: "heißt",
      translated: "називається",
      tone: 'semantic',
    },
  ],
  "lid:state:SH:7|vi": [
    {
      german: "Die Landeshauptstadt",
      translated: "Thủ phủ",
      tone: 'semantic',
    },
    {
      german: "von Schleswig-Holstein",
      translated: "của bang Schleswig-Holstein",
      tone: 'semantic',
    },
    {
      german: "heißt",
      translated: "là",
      tone: 'semantic',
    },
  ],
  "lid:state:SH:8|ar": [
    {
      german: "Welches Bundesland",
      translated: "أي صورة",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "تمثل",
      tone: 'semantic',
    },
    {
      german: "Schleswig-Holstein",
      translated: "Schleswig-Holstein",
      tone: 'semantic',
    },
  ],
  "lid:state:SH:8|bg": [
    {
      german: "Welches Bundesland",
      translated: "Коя от показаните федерални провинции",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "е",
      tone: 'semantic',
    },
    {
      german: "Schleswig-Holstein",
      translated: "Шлезвиг-Холщайн",
      tone: 'semantic',
    },
  ],
  "lid:state:SH:8|bs": [
    {
      german: "Welches Bundesland",
      translated: "Koja od prikazanih",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "je",
      tone: 'semantic',
    },
    {
      german: "Schleswig-Holstein",
      translated: "Schleswig-Holstein",
      tone: 'semantic',
    },
  ],
  "lid:state:SH:8|el": [
    {
      german: "Welches Bundesland",
      translated: "Ποιο από τα εικονιζόμενα κρατίδια",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "είναι",
      tone: 'semantic',
    },
    {
      german: "Schleswig-Holstein",
      translated: "το Σλέσβιχ-Χόλσταϊν",
      tone: 'semantic',
    },
  ],
  "lid:state:SH:8|en": [
    {
      german: "Welches Bundesland",
      translated: "Which federal state",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "is",
      tone: 'semantic',
    },
    {
      german: "Schleswig-Holstein",
      translated: "Schleswig-Holstein",
      tone: 'semantic',
    },
  ],
  "lid:state:SH:8|es": [
    {
      german: "Welches Bundesland",
      translated: "¿Cuál de las imágenes corresponde al estado federado",
      tone: 'semantic',
    },
    {
      german: "Schleswig-Holstein",
      translated: "Schleswig-Holstein",
      tone: 'semantic',
    },
  ],
  "lid:state:SH:8|fa": [
    {
      german: "Welches Bundesland",
      translated: "کدام ایالتِ",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "است",
      tone: 'semantic',
    },
    {
      german: "Schleswig-Holstein",
      translated: "اشلسویگ-هولشتاین",
      tone: 'semantic',
    },
  ],
  "lid:state:SH:8|fr": [
    {
      german: "Welches Bundesland",
      translated: "Quel Land",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "représenté",
      tone: 'semantic',
    },
    {
      german: "Schleswig-Holstein",
      translated: "Schleswig-Holstein",
      tone: 'semantic',
    },
  ],
  "lid:state:SH:8|hr": [
    {
      german: "Welches Bundesland",
      translated: "Koja od prikazanih",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "je",
      tone: 'semantic',
    },
    {
      german: "Schleswig-Holstein",
      translated: "Schleswig-Holstein",
      tone: 'semantic',
    },
  ],
  "lid:state:SH:8|it": [
    {
      german: "Welches Bundesland",
      translated: "Quale Land rappresentato",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "è",
      tone: 'semantic',
    },
    {
      german: "Schleswig-Holstein",
      translated: "Schleswig-Holstein",
      tone: 'semantic',
    },
  ],
  "lid:state:SH:8|kmr": [
    {
      german: "Welches Bundesland",
      translated: "Kîjan eyalet",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "ye",
      tone: 'semantic',
    },
    {
      german: "Schleswig-Holstein",
      translated: "Schleswig-Holstein",
      tone: 'semantic',
    },
  ],
  "lid:state:SH:8|pl": [
    {
      german: "Welches Bundesland",
      translated: "Który z przedstawionych krajów związkowych",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "to",
      tone: 'semantic',
    },
    {
      german: "Schleswig-Holstein",
      translated: "Szlezwik-Holsztyn",
      tone: 'semantic',
    },
  ],
  "lid:state:SH:8|prs": [
    {
      german: "Welches Bundesland",
      translated: "کدام ایالتِ",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "است",
      tone: 'semantic',
    },
    {
      german: "Schleswig-Holstein",
      translated: "اشلسویگ-هولشتاین",
      tone: 'semantic',
    },
  ],
  "lid:state:SH:8|ro": [
    {
      german: "Welches Bundesland",
      translated: "Care land reprezentat",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "este",
      tone: 'semantic',
    },
    {
      german: "Schleswig-Holstein",
      translated: "Schleswig-Holstein",
      tone: 'semantic',
    },
  ],
  "lid:state:SH:8|ru": [
    {
      german: "Welches Bundesland",
      translated: "Какая из этих земель",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "—",
      tone: 'semantic',
    },
    {
      german: "Schleswig-Holstein",
      translated: "Шлезвиг-Гольштейн",
      tone: 'semantic',
    },
  ],
  "lid:state:SH:8|sq": [
    {
      german: "Welches Bundesland",
      translated: "Cili nga landet e paraqitura",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "është",
      tone: 'semantic',
    },
    {
      german: "Schleswig-Holstein",
      translated: "Schleswig-Holstein",
      tone: 'semantic',
    },
  ],
  "lid:state:SH:8|sr": [
    {
      german: "Welches Bundesland",
      translated: "Koja od prikazanih saveznih pokrajina",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "je",
      tone: 'semantic',
    },
    {
      german: "Schleswig-Holstein",
      translated: "Šlezvig-Holštajn",
      tone: 'semantic',
    },
  ],
  "lid:state:SH:8|tr": [
    {
      german: "Welches Bundesland",
      translated: "hangi numarayla",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "gösterilmiştir",
      tone: 'semantic',
    },
    {
      german: "Schleswig-Holstein",
      translated: "Schleswig-Holstein",
      tone: 'semantic',
    },
  ],
  "lid:state:SH:8|uk": [
    {
      german: "Welches Bundesland",
      translated: "Яка з позначених федеральних земель",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "є",
      tone: 'semantic',
    },
    {
      german: "Schleswig-Holstein",
      translated: "Шлезвіг-Гольштейн",
      tone: 'semantic',
    },
  ],
  "lid:state:SH:8|vi": [
    {
      german: "Welches Bundesland",
      translated: "Bang nào",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "trong",
      tone: 'semantic',
    },
    {
      german: "Schleswig-Holstein",
      translated: "Schleswig-Holstein",
      tone: 'semantic',
    },
  ],
  "lid:state:SH:9|ar": [
    {
      german: "Wie nennt man",
      translated: "ماذا يُسمى",
      tone: 'semantic',
    },
    {
      german: "die Regierungschefin/den Regierungschef",
      translated: "رئيس/رئيسة حكومة",
      tone: 'semantic',
    },
    {
      german: "in Schleswig-Holstein",
      translated: "ولاية Schleswig-Holstein",
      tone: 'semantic',
    },
  ],
  "lid:state:SH:9|bg": [
    {
      german: "Wie nennt man",
      translated: "Как се нарича",
      tone: 'semantic',
    },
    {
      german: "die Regierungschefin/den Regierungschef",
      translated: "ръководителят",
      tone: 'semantic',
    },
    {
      german: "in Schleswig-Holstein",
      translated: "на правителството на провинция Шлезвиг-Холщайн",
      tone: 'semantic',
    },
  ],
  "lid:state:SH:9|bs": [
    {
      german: "Wie nennt man",
      translated: "Kako se zove",
      tone: 'semantic',
    },
    {
      german: "die Regierungschefin/den Regierungschef",
      translated: "šef vlade",
      tone: 'semantic',
    },
    {
      german: "in Schleswig-Holstein",
      translated: "savezne zemlje Schleswig-Holstein",
      tone: 'semantic',
    },
  ],
  "lid:state:SH:9|el": [
    {
      german: "Wie nennt man",
      translated: "Πώς ονομάζεται",
      tone: 'semantic',
    },
    {
      german: "die Regierungschefin/den Regierungschef",
      translated: "ο επικεφαλής της κυβέρνησης",
      tone: 'semantic',
    },
    {
      german: "in Schleswig-Holstein",
      translated: "του κρατιδίου Σλέσβιχ-Χόλσταϊν",
      tone: 'semantic',
    },
  ],
  "lid:state:SH:9|en": [
    {
      german: "Wie nennt man",
      translated: "What is",
      tone: 'semantic',
    },
    {
      german: "die Regierungschefin/den Regierungschef",
      translated: "the head of government",
      tone: 'semantic',
    },
    {
      german: "in Schleswig-Holstein",
      translated: "in Schleswig-Holstein",
      tone: 'semantic',
    },
  ],
  "lid:state:SH:9|es": [
    {
      german: "Wie nennt man",
      translated: "¿Cómo se llama al",
      tone: 'semantic',
    },
    {
      german: "die Regierungschefin/den Regierungschef",
      translated: "jefe o la jefa de gobierno",
      tone: 'semantic',
    },
    {
      german: "in Schleswig-Holstein",
      translated: "de Schleswig-Holstein",
      tone: 'semantic',
    },
  ],
  "lid:state:SH:9|fa": [
    {
      german: "Wie nennt man",
      translated: "ایالت",
      tone: 'semantic',
    },
    {
      german: "die Regierungschefin/den Regierungschef",
      translated: "رئیس دولت",
      tone: 'semantic',
    },
    {
      german: "in Schleswig-Holstein",
      translated: "اشلسویگ-هولشتاین",
      tone: 'semantic',
    },
  ],
  "lid:state:SH:9|fr": [
    {
      german: "Wie nennt man",
      translated: "Comment appelle-t-on",
      tone: 'semantic',
    },
    {
      german: "die Regierungschefin/den Regierungschef",
      translated: "le chef ou la cheffe du gouvernement",
      tone: 'semantic',
    },
    {
      german: "in Schleswig-Holstein",
      translated: "de Schleswig-Holstein",
      tone: 'semantic',
    },
  ],
  "lid:state:SH:9|hr": [
    {
      german: "Wie nennt man",
      translated: "Kako",
      tone: 'semantic',
    },
    {
      german: "die Regierungschefin/den Regierungschef",
      translated: "čelnik vlade savezne zemlje",
      tone: 'semantic',
    },
    {
      german: "in Schleswig-Holstein",
      translated: "Schleswig-Holstein",
      tone: 'semantic',
    },
  ],
  "lid:state:SH:9|it": [
    {
      german: "Wie nennt man",
      translated: "Come si chiama",
      tone: 'semantic',
    },
    {
      german: "die Regierungschefin/den Regierungschef",
      translated: "il capo del governo",
      tone: 'semantic',
    },
    {
      german: "in Schleswig-Holstein",
      translated: "di Schleswig-Holstein",
      tone: 'semantic',
    },
  ],
  "lid:state:SH:9|kmr": [
    {
      german: "Wie nennt man",
      translated: "Serokê",
      tone: 'semantic',
    },
    {
      german: "die Regierungschefin/den Regierungschef",
      translated: "hukûmeta",
      tone: 'semantic',
    },
    {
      german: "in Schleswig-Holstein",
      translated: "Schleswig-Holstein",
      tone: 'semantic',
    },
  ],
  "lid:state:SH:9|pl": [
    {
      german: "Wie nennt man",
      translated: "Jak nazywa się",
      tone: 'semantic',
    },
    {
      german: "die Regierungschefin/den Regierungschef",
      translated: "szef rządu kraju związkowego",
      tone: 'semantic',
    },
    {
      german: "in Schleswig-Holstein",
      translated: "Szlezwik-Holsztyn",
      tone: 'semantic',
    },
  ],
  "lid:state:SH:9|prs": [
    {
      german: "Wie nennt man",
      translated: "چه عنوانی دارد",
      tone: 'semantic',
    },
    {
      german: "die Regierungschefin/den Regierungschef",
      translated: "رئیس دولت",
      tone: 'semantic',
    },
    {
      german: "in Schleswig-Holstein",
      translated: "ایالت اشلسویگ-هولشتاین",
      tone: 'semantic',
    },
  ],
  "lid:state:SH:9|ro": [
    {
      german: "Wie nennt man",
      translated: "Cum se numește",
      tone: 'semantic',
    },
    {
      german: "die Regierungschefin/den Regierungschef",
      translated: "șeful guvernului landului Schleswig-Holstein",
      tone: 'semantic',
    },
  ],
  "lid:state:SH:9|ru": [
    {
      german: "Wie nennt man",
      translated: "Как называют",
      tone: 'semantic',
    },
    {
      german: "die Regierungschefin/den Regierungschef",
      translated: "главу правительства",
      tone: 'semantic',
    },
    {
      german: "in Schleswig-Holstein",
      translated: "в федеральной земле Шлезвиг-Гольштейн",
      tone: 'semantic',
    },
  ],
  "lid:state:SH:9|sq": [
    {
      german: "Wie nennt man",
      translated: "Si quhet",
      tone: 'semantic',
    },
    {
      german: "die Regierungschefin/den Regierungschef",
      translated: "kreu i qeverisë së landit",
      tone: 'semantic',
    },
    {
      german: "in Schleswig-Holstein",
      translated: "Schleswig-Holstein",
      tone: 'semantic',
    },
  ],
  "lid:state:SH:9|sr": [
    {
      german: "Wie nennt man",
      translated: "Kako se zove",
      tone: 'semantic',
    },
    {
      german: "die Regierungschefin/den Regierungschef",
      translated: "šef vlade savezne pokrajine",
      tone: 'semantic',
    },
    {
      german: "in Schleswig-Holstein",
      translated: "Šlezvig-Holštajn",
      tone: 'semantic',
    },
  ],
  "lid:state:SH:9|tr": [
    {
      german: "Wie nennt man",
      translated: "ne ad verilir",
      tone: 'semantic',
    },
    {
      german: "die Regierungschefin/den Regierungschef",
      translated: "başındaki kişiye",
      tone: 'semantic',
    },
    {
      german: "in Schleswig-Holstein",
      translated: "Schleswig-Holstein eyalet hükümetinin",
      tone: 'semantic',
    },
  ],
  "lid:state:SH:9|uk": [
    {
      german: "Wie nennt man",
      translated: "Як називають",
      tone: 'semantic',
    },
    {
      german: "die Regierungschefin/den Regierungschef",
      translated: "главу уряду федеральної землі",
      tone: 'semantic',
    },
    {
      german: "in Schleswig-Holstein",
      translated: "Шлезвіг-Гольштейн",
      tone: 'semantic',
    },
  ],
  "lid:state:SH:9|vi": [
    {
      german: "Wie nennt man",
      translated: "được gọi là",
      tone: 'semantic',
    },
    {
      german: "die Regierungschefin/den Regierungschef",
      translated: "Người đứng đầu chính phủ",
      tone: 'semantic',
    },
    {
      german: "in Schleswig-Holstein",
      translated: "bang Schleswig-Holstein",
      tone: 'semantic',
    },
  ],
  "lid:state:SL:10|ar": [
    {
      german: "Welche",
      translated: "أي",
      tone: 'semantic',
    },
    {
      german: "Ministerin/welchen Minister",
      translated: "وزارة",
      tone: 'semantic',
    },
    {
      german: "Saarland",
      translated: "ولاية Saarland",
      tone: 'semantic',
    },
    {
      german: "nicht?",
      translated: "غير موجودة",
      tone: 'semantic',
    },
  ],
  "lid:state:SL:10|bg": [
    {
      german: "Welche",
      translated: "Кой",
      tone: 'semantic',
    },
    {
      german: "Ministerin/welchen Minister",
      translated: "министър",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "съществува",
      tone: 'semantic',
    },
    {
      german: "das",
      translated: "на ниво федерална провинция",
      tone: 'semantic',
    },
    {
      german: "Saarland",
      translated: "Саарланд",
      tone: 'semantic',
    },
    {
      german: "nicht?",
      translated: "не",
      tone: 'semantic',
    },
  ],
  "lid:state:SL:10|bs": [
    {
      german: "Welche",
      translated: "Koji",
      tone: 'semantic',
    },
    {
      german: "Ministerin/welchen Minister",
      translated: "ministar",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "ne postoji",
      tone: 'semantic',
    },
    {
      german: "das",
      translated: "na razini savezne zemlje",
      tone: 'semantic',
    },
    {
      german: "Saarland",
      translated: "Saarland",
      tone: 'semantic',
    },
  ],
  "lid:state:SL:10|el": [
    {
      german: "Welche",
      translated: "Ποιος",
      tone: 'semantic',
    },
    {
      german: "Ministerin/welchen Minister",
      translated: "υπουργός",
      tone: 'semantic',
    },
    {
      german: "das",
      translated: "σε επίπεδο κρατιδίου στο",
      tone: 'semantic',
    },
    {
      german: "Saarland",
      translated: "Σάαρλαντ;",
      tone: 'semantic',
    },
    {
      german: "nicht?",
      translated: "δεν υπάρχει",
      tone: 'semantic',
    },
  ],
  "lid:state:SL:10|en": [
    {
      german: "Welche",
      translated: "Which",
      tone: 'semantic',
    },
    {
      german: "Ministerin/welchen Minister",
      translated: "minister",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "does",
      tone: 'semantic',
    },
    {
      german: "Saarland",
      translated: "Saarland",
      tone: 'semantic',
    },
    {
      german: "nicht?",
      translated: "not have",
      tone: 'semantic',
    },
  ],
  "lid:state:SL:10|es": [
    {
      german: "Welche",
      translated: "¿Qué",
      tone: 'semantic',
    },
    {
      german: "Ministerin/welchen Minister",
      translated: "ministerio",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "existe",
      tone: 'semantic',
    },
    {
      german: "Saarland",
      translated: "Sarre",
      tone: 'semantic',
    },
    {
      german: "nicht?",
      translated: "NO",
      tone: 'semantic',
    },
  ],
  "lid:state:SL:10|fa": [
    {
      german: "Welche",
      translated: "کدام",
      tone: 'semantic',
    },
    {
      german: "Ministerin/welchen Minister",
      translated: "وزیر",
      tone: 'semantic',
    },
    {
      german: "Saarland",
      translated: "زارلاند",
      tone: 'semantic',
    },
    {
      german: "nicht?",
      translated: "وجود ندارد؟",
      tone: 'semantic',
    },
  ],
  "lid:state:SL:10|fr": [
    {
      german: "Welche",
      translated: "Quel",
      tone: 'semantic',
    },
    {
      german: "Ministerin/welchen Minister",
      translated: "ministre ou quelle ministre",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "n’existe",
      tone: 'semantic',
    },
    {
      german: "Saarland",
      translated: "Sarre",
      tone: 'semantic',
    },
    {
      german: "nicht?",
      translated: "pas",
      tone: 'semantic',
    },
  ],
  "lid:state:SL:10|hr": [
    {
      german: "Welche",
      translated: "Koji",
      tone: 'semantic',
    },
    {
      german: "Ministerin/welchen Minister",
      translated: "ministar",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "ne postoji",
      tone: 'semantic',
    },
    {
      german: "das",
      translated: "na razini savezne zemlje",
      tone: 'semantic',
    },
    {
      german: "Saarland",
      translated: "Saarland",
      tone: 'semantic',
    },
  ],
  "lid:state:SL:10|it": [
    {
      german: "Welche",
      translated: "Quale",
      tone: 'semantic',
    },
    {
      german: "Ministerin/welchen Minister",
      translated: "ministro",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "non esiste",
      tone: 'semantic',
    },
    {
      german: "das",
      translated: "a livello del",
      tone: 'semantic',
    },
    {
      german: "Saarland",
      translated: "di Saarland",
      tone: 'semantic',
    },
  ],
  "lid:state:SL:10|kmr": [
    {
      german: "Welche",
      translated: "Kîjan",
      tone: 'semantic',
    },
    {
      german: "Ministerin/welchen Minister",
      translated: "wezîr li",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "tune",
      tone: 'semantic',
    },
    {
      german: "Saarland",
      translated: "Saarland",
      tone: 'semantic',
    },
    {
      german: "nicht?",
      translated: "ye?",
      tone: 'semantic',
    },
  ],
  "lid:state:SL:10|pl": [
    {
      german: "Welche",
      translated: "Którego",
      tone: 'semantic',
    },
    {
      german: "Ministerin/welchen Minister",
      translated: "ministra",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "ma",
      tone: 'semantic',
    },
    {
      german: "Saarland",
      translated: "Saara",
      tone: 'semantic',
    },
    {
      german: "nicht?",
      translated: "nie",
      tone: 'semantic',
    },
  ],
  "lid:state:SL:10|prs": [
    {
      german: "Welche",
      translated: "کدام",
      tone: 'semantic',
    },
    {
      german: "Ministerin/welchen Minister",
      translated: "وزیر",
      tone: 'semantic',
    },
    {
      german: "Saarland",
      translated: "زارلاند",
      tone: 'semantic',
    },
    {
      german: "nicht?",
      translated: "وجود ندارد؟",
      tone: 'semantic',
    },
  ],
  "lid:state:SL:10|ro": [
    {
      german: "Welche",
      translated: "Care",
      tone: 'semantic',
    },
    {
      german: "Ministerin/welchen Minister",
      translated: "ministru",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "există",
      tone: 'semantic',
    },
    {
      german: "Saarland",
      translated: "landului Saarland",
      tone: 'semantic',
    },
    {
      german: "nicht?",
      translated: "nu",
      tone: 'semantic',
    },
  ],
  "lid:state:SL:10|ru": [
    {
      german: "Ministerin/welchen Minister",
      translated: "Какого министра",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "нет",
      tone: 'semantic',
    },
    {
      german: "das",
      translated: "в федеральной земле",
      tone: 'semantic',
    },
    {
      german: "Saarland",
      translated: "Саарланд",
      tone: 'semantic',
    },
  ],
  "lid:state:SL:10|sq": [
    {
      german: "Welche",
      translated: "Cili",
      tone: 'semantic',
    },
    {
      german: "Ministerin/welchen Minister",
      translated: "ministër",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "ekziston",
      tone: 'semantic',
    },
    {
      german: "das",
      translated: "në nivelin e",
      tone: 'semantic',
    },
    {
      german: "Saarland",
      translated: "landit Saarland",
      tone: 'semantic',
    },
    {
      german: "nicht?",
      translated: "?",
      tone: 'semantic',
    },
  ],
  "lid:state:SL:10|sr": [
    {
      german: "Welche",
      translated: "Koji",
      tone: 'semantic',
    },
    {
      german: "Ministerin/welchen Minister",
      translated: "ministar",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "ne postoji",
      tone: 'semantic',
    },
    {
      german: "Saarland",
      translated: "Saarland",
      tone: 'semantic',
    },
  ],
  "lid:state:SL:10|tr": [
    {
      german: "Welche",
      translated: "hangisi",
      tone: 'semantic',
    },
    {
      german: "Ministerin/welchen Minister",
      translated: "bakanlıklardan",
      tone: 'semantic',
    },
    {
      german: "Saarland",
      translated: "Saarland eyaletinde",
      tone: 'semantic',
    },
    {
      german: "nicht?",
      translated: "yoktur",
      tone: 'semantic',
    },
  ],
  "lid:state:SL:10|uk": [
    {
      german: "Welche",
      translated: "Якого",
      tone: 'semantic',
    },
    {
      german: "Ministerin/welchen Minister",
      translated: "міністра/міністерки",
      tone: 'semantic',
    },
    {
      german: "Saarland",
      translated: "землі Саар",
      tone: 'semantic',
    },
    {
      german: "nicht?",
      translated: "немає",
      tone: 'semantic',
    },
  ],
  "lid:state:SL:10|vi": [
    {
      german: "Welche",
      translated: "Bộ trưởng nào",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "không tồn tại",
      tone: 'semantic',
    },
    {
      german: "das",
      translated: "ở cấp bang",
      tone: 'semantic',
    },
    {
      german: "Saarland",
      translated: "Saarland",
      tone: 'semantic',
    },
  ],
  "lid:state:SL:1|ar": [
    {
      german: "Welches Wappen",
      translated: "أي شعار من الصور",
      tone: 'semantic',
    },
    {
      german: "gehört zum",
      translated: "يعود إلى",
      tone: 'semantic',
    },
    {
      german: "Bundesland Saarland",
      translated: "ولاية Saarland",
      tone: 'semantic',
    },
  ],
  "lid:state:SL:1|bg": [
    {
      german: "Welches Wappen",
      translated: "Кой герб",
      tone: 'semantic',
    },
    {
      german: "gehört zum",
      translated: "принадлежи на",
      tone: 'semantic',
    },
    {
      german: "Bundesland Saarland",
      translated: "федералната провинция Саарланд",
      tone: 'semantic',
    },
  ],
  "lid:state:SL:1|bs": [
    {
      german: "Welches Wappen",
      translated: "Koji grb",
      tone: 'semantic',
    },
    {
      german: "gehört zum",
      translated: "pripada",
      tone: 'semantic',
    },
    {
      german: "Bundesland Saarland",
      translated: "zemlji Saarland",
      tone: 'semantic',
    },
  ],
  "lid:state:SL:1|el": [
    {
      german: "Welches Wappen",
      translated: "Ποιο έμβλημα",
      tone: 'semantic',
    },
    {
      german: "gehört zum",
      translated: "ανήκει στο",
      tone: 'semantic',
    },
    {
      german: "Bundesland Saarland",
      translated: "ομόσπονδο κρατίδιο Σάαρλαντ",
      tone: 'semantic',
    },
  ],
  "lid:state:SL:1|en": [
    {
      german: "Welches Wappen",
      translated: "Which coat of arms",
      tone: 'semantic',
    },
    {
      german: "gehört zum",
      translated: "belongs to",
      tone: 'semantic',
    },
    {
      german: "Bundesland Saarland",
      translated: "the federal state of Saarland",
      tone: 'semantic',
    },
  ],
  "lid:state:SL:1|es": [
    {
      german: "Welches Wappen",
      translated: "¿Qué escudo",
      tone: 'semantic',
    },
    {
      german: "gehört zum",
      translated: "pertenece al",
      tone: 'semantic',
    },
    {
      german: "Bundesland Saarland",
      translated: "estado federado de Sarre",
      tone: 'semantic',
    },
  ],
  "lid:state:SL:1|fa": [
    {
      german: "Welches Wappen",
      translated: "نشان",
      tone: 'semantic',
    },
    {
      german: "gehört zum",
      translated: "متعلق به",
      tone: 'semantic',
    },
    {
      german: "Bundesland Saarland",
      translated: "زارلاند",
      tone: 'semantic',
    },
  ],
  "lid:state:SL:1|fr": [
    {
      german: "Welches Wappen",
      translated: "Quel blason",
      tone: 'semantic',
    },
    {
      german: "gehört zum",
      translated: "appartient au",
      tone: 'semantic',
    },
    {
      german: "Bundesland Saarland",
      translated: "Land de Sarre",
      tone: 'semantic',
    },
  ],
  "lid:state:SL:1|hr": [
    {
      german: "Welches Wappen",
      translated: "Koji grb",
      tone: 'semantic',
    },
    {
      german: "gehört zum",
      translated: "pripada",
      tone: 'semantic',
    },
    {
      german: "Bundesland Saarland",
      translated: "saveznoj zemlji Saarland",
      tone: 'semantic',
    },
  ],
  "lid:state:SL:1|it": [
    {
      german: "Welches Wappen",
      translated: "Quale stemma",
      tone: 'semantic',
    },
    {
      german: "gehört zum",
      translated: "appartiene al",
      tone: 'semantic',
    },
    {
      german: "Bundesland Saarland",
      translated: "Land di Saarland",
      tone: 'semantic',
    },
  ],
  "lid:state:SL:1|kmr": [
    {
      german: "Welches Wappen",
      translated: "Kîjan nîşan a",
      tone: 'semantic',
    },
    {
      german: "Bundesland Saarland",
      translated: "Saarland ye",
      tone: 'semantic',
    },
  ],
  "lid:state:SL:1|pl": [
    {
      german: "Welches Wappen",
      translated: "Który herb",
      tone: 'semantic',
    },
    {
      german: "gehört zum",
      translated: "należy do",
      tone: 'semantic',
    },
    {
      german: "Bundesland Saarland",
      translated: "kraju związkowego Saara",
      tone: 'semantic',
    },
  ],
  "lid:state:SL:1|prs": [
    {
      german: "Welches Wappen",
      translated: "کدام نشان",
      tone: 'semantic',
    },
    {
      german: "gehört zum",
      translated: "متعلق به",
      tone: 'semantic',
    },
    {
      german: "Bundesland Saarland",
      translated: "ایالت زارلاند",
      tone: 'semantic',
    },
  ],
  "lid:state:SL:1|ro": [
    {
      german: "Welches Wappen",
      translated: "Care stemă",
      tone: 'semantic',
    },
    {
      german: "gehört zum",
      translated: "aparține",
      tone: 'semantic',
    },
    {
      german: "Bundesland Saarland",
      translated: "landului Saarland",
      tone: 'semantic',
    },
  ],
  "lid:state:SL:1|ru": [
    {
      german: "Welches Wappen",
      translated: "Какой герб",
      tone: 'semantic',
    },
    {
      german: "gehört zum",
      translated: "принадлежит",
      tone: 'semantic',
    },
    {
      german: "Bundesland Saarland",
      translated: "федеральной земле Саарланд",
      tone: 'semantic',
    },
  ],
  "lid:state:SL:1|sq": [
    {
      german: "Welches Wappen",
      translated: "Cila stemë",
      tone: 'semantic',
    },
    {
      german: "gehört zum",
      translated: "i përket",
      tone: 'semantic',
    },
    {
      german: "Bundesland Saarland",
      translated: "landit Saarland",
      tone: 'semantic',
    },
  ],
  "lid:state:SL:1|sr": [
    {
      german: "Welches Wappen",
      translated: "grb",
      tone: 'semantic',
    },
    {
      german: "gehört zum",
      translated: "pripada",
      tone: 'semantic',
    },
    {
      german: "Bundesland Saarland",
      translated: "pokrajini Saarland",
      tone: 'semantic',
    },
  ],
  "lid:state:SL:1|tr": [
    {
      german: "Welches Wappen",
      translated: "arması hangisidir",
      tone: 'semantic',
    },
    {
      german: "Bundesland Saarland",
      translated: "Saarland eyaletinin",
      tone: 'semantic',
    },
  ],
  "lid:state:SL:1|uk": [
    {
      german: "Welches Wappen",
      translated: "Який герб",
      tone: 'semantic',
    },
    {
      german: "gehört zum",
      translated: "належить",
      tone: 'semantic',
    },
    {
      german: "Bundesland Saarland",
      translated: "федеральній землі Саар",
      tone: 'semantic',
    },
  ],
  "lid:state:SL:1|vi": [
    {
      german: "Welches Wappen",
      translated: "Quốc huy nào",
      tone: 'semantic',
    },
    {
      german: "gehört zum",
      translated: "thuộc",
      tone: 'semantic',
    },
    {
      german: "Bundesland Saarland",
      translated: "bang Saarland",
      tone: 'semantic',
    },
  ],
  "lid:state:SL:2|ar": [
    {
      german: "Welches",
      translated: "أي",
      tone: 'semantic',
    },
    {
      german: "ein Landkreis",
      translated: "دائرة إدارية (Landkreis)",
      tone: 'semantic',
    },
    {
      german: "im Saarland",
      translated: "في Saarland",
      tone: 'semantic',
    },
  ],
  "lid:state:SL:2|bg": [
    {
      german: "Welches",
      translated: "Кое",
      tone: 'semantic',
    },
    {
      german: "ein Landkreis",
      translated: "от следните е окръг (Landkreis)",
      tone: 'semantic',
    },
    {
      german: "im Saarland",
      translated: "в Саарланд",
      tone: 'semantic',
    },
  ],
  "lid:state:SL:2|bs": [
    {
      german: "Welches",
      translated: "Što",
      tone: 'semantic',
    },
    {
      german: "ein Landkreis",
      translated: "od navedenoga okrug (Landkreis)",
      tone: 'semantic',
    },
    {
      german: "im Saarland",
      translated: "u saveznoj zemlji Saarland?",
      tone: 'semantic',
    },
  ],
  "lid:state:SL:2|el": [
    {
      german: "Welches",
      translated: "Ποιο",
      tone: 'semantic',
    },
    {
      german: "ein Landkreis",
      translated: "διοικητική περιφέρεια (Landkreis)",
      tone: 'semantic',
    },
    {
      german: "im Saarland",
      translated: "στο Σάαρλαντ",
      tone: 'semantic',
    },
  ],
  "lid:state:SL:2|en": [
    {
      german: "Welches",
      translated: "Which",
      tone: 'semantic',
    },
    {
      german: "ein Landkreis",
      translated: "a district",
      tone: 'semantic',
    },
    {
      german: "im Saarland",
      translated: "in Saarland",
      tone: 'semantic',
    },
  ],
  "lid:state:SL:2|es": [
    {
      german: "Welches",
      translated: "¿Cuál de los siguientes es",
      tone: 'semantic',
    },
    {
      german: "ein Landkreis",
      translated: "un distrito (Landkreis)",
      tone: 'semantic',
    },
    {
      german: "im Saarland",
      translated: "de Sarre",
      tone: 'semantic',
    },
  ],
  "lid:state:SL:2|fa": [
    {
      german: "Welches",
      translated: "کدام",
      tone: 'semantic',
    },
    {
      german: "ein Landkreis",
      translated: "شهرستان",
      tone: 'semantic',
    },
    {
      german: "im Saarland",
      translated: "Landkreis) در زارلاند است؟",
      tone: 'semantic',
    },
  ],
  "lid:state:SL:2|fr": [
    {
      german: "Welches",
      translated: "Lequel des",
      tone: 'semantic',
    },
    {
      german: "ein Landkreis",
      translated: "un arrondissement",
      tone: 'semantic',
    },
    {
      german: "im Saarland",
      translated: "de Sarre",
      tone: 'semantic',
    },
  ],
  "lid:state:SL:2|hr": [
    {
      german: "Welches",
      translated: "Što",
      tone: 'semantic',
    },
    {
      german: "ein Landkreis",
      translated: "okrug (Landkreis)",
      tone: 'semantic',
    },
    {
      german: "im Saarland",
      translated: "u saveznoj zemlji Saarland",
      tone: 'semantic',
    },
  ],
  "lid:state:SL:2|it": [
    {
      german: "Welches",
      translated: "Quale",
      tone: 'semantic',
    },
    {
      german: "ein Landkreis",
      translated: "distretto (Landkreis)",
      tone: 'semantic',
    },
    {
      german: "im Saarland",
      translated: "di Saarland",
      tone: 'semantic',
    },
  ],
  "lid:state:SL:2|kmr": [
    {
      german: "Welches",
      translated: "Kîjan",
      tone: 'semantic',
    },
    {
      german: "ein Landkreis",
      translated: "ji van navçeyek (Landkreis)",
      tone: 'semantic',
    },
    {
      german: "im Saarland",
      translated: "li Saarland ye",
      tone: 'semantic',
    },
  ],
  "lid:state:SL:2|pl": [
    {
      german: "Welches",
      translated: "Który",
      tone: 'semantic',
    },
    {
      german: "ein Landkreis",
      translated: "powiatem (Landkreis)",
      tone: 'semantic',
    },
    {
      german: "im Saarland",
      translated: "w Saara?",
      tone: 'semantic',
    },
  ],
  "lid:state:SL:2|prs": [
    {
      german: "Welches",
      translated: "کدام‌یک",
      tone: 'semantic',
    },
    {
      german: "ein Landkreis",
      translated: "شهرستان (Landkreis)",
      tone: 'semantic',
    },
    {
      german: "im Saarland",
      translated: "زارلاند",
      tone: 'semantic',
    },
  ],
  "lid:state:SL:2|ro": [
    {
      german: "Welches",
      translated: "Care dintre următoarele",
      tone: 'semantic',
    },
    {
      german: "ein Landkreis",
      translated: "un district (Landkreis)",
      tone: 'semantic',
    },
    {
      german: "im Saarland",
      translated: "din Saarland",
      tone: 'semantic',
    },
  ],
  "lid:state:SL:2|ru": [
    {
      german: "Welches",
      translated: "Какой",
      tone: 'semantic',
    },
    {
      german: "ein Landkreis",
      translated: "районом",
      tone: 'semantic',
    },
    {
      german: "im Saarland",
      translated: "в федеральной земле Саарланд",
      tone: 'semantic',
    },
  ],
  "lid:state:SL:2|sq": [
    {
      german: "Welches",
      translated: "Cila",
      tone: 'semantic',
    },
    {
      german: "ein Landkreis",
      translated: "qark (Landkreis)",
      tone: 'semantic',
    },
    {
      german: "im Saarland",
      translated: "në Saarland",
      tone: 'semantic',
    },
  ],
  "lid:state:SL:2|sr": [
    {
      german: "Welches",
      translated: "Šta",
      tone: 'semantic',
    },
    {
      german: "ein Landkreis",
      translated: "od navedenoga okrug (Landkreis)",
      tone: 'semantic',
    },
    {
      german: "im Saarland",
      translated: "u saveznoj pokrajini Saarland?",
      tone: 'semantic',
    },
  ],
  "lid:state:SL:2|tr": [
    {
      german: "Welches",
      translated: "Aşağıdakilerden hangisi",
      tone: 'semantic',
    },
    {
      german: "ein Landkreis",
      translated: "bir Landkreis (ilçe/idari bölge)dir",
      tone: 'semantic',
    },
    {
      german: "im Saarland",
      translated: "Saarland eyaletinde bulunan",
      tone: 'semantic',
    },
  ],
  "lid:state:SL:2|uk": [
    {
      german: "Welches",
      translated: "Який",
      tone: 'semantic',
    },
    {
      german: "ein Landkreis",
      translated: "районів",
      tone: 'semantic',
    },
    {
      german: "im Saarland",
      translated: "у федеральній землі Саар",
      tone: 'semantic',
    },
  ],
  "lid:state:SL:2|vi": [
    {
      german: "Welches",
      translated: "Địa danh",
      tone: 'semantic',
    },
    {
      german: "ein Landkreis",
      translated: "một huyện",
      tone: 'semantic',
    },
    {
      german: "im Saarland",
      translated: "Landkreis) của bang Saarland",
      tone: 'semantic',
    },
  ],
  "lid:state:SL:3|ar": [
    {
      german: "Für wie viele Jahre",
      translated: "لمدة كم سنة",
      tone: 'semantic',
    },
    {
      german: "der Landtag",
      translated: "برلمان الولاية",
      tone: 'semantic',
    },
    {
      german: "des Saarlandes",
      translated: "Saarland",
      tone: 'semantic',
    },
    {
      german: "gewählt",
      translated: "يُنتخب",
      tone: 'semantic',
    },
  ],
  "lid:state:SL:3|bg": [
    {
      german: "Für wie viele Jahre",
      translated: "За колко години",
      tone: 'semantic',
    },
    {
      german: "der Landtag",
      translated: "парламентът",
      tone: 'semantic',
    },
    {
      german: "des Saarlandes",
      translated: "на провинция Саарланд",
      tone: 'semantic',
    },
    {
      german: "gewählt",
      translated: "се избира",
      tone: 'semantic',
    },
  ],
  "lid:state:SL:3|bs": [
    {
      german: "Für wie viele Jahre",
      translated: "Na koliko se godina",
      tone: 'semantic',
    },
    {
      german: "der Landtag",
      translated: "parlament",
      tone: 'semantic',
    },
    {
      german: "des Saarlandes",
      translated: "savezne zemlje Saarland",
      tone: 'semantic',
    },
    {
      german: "gewählt",
      translated: "bira",
      tone: 'semantic',
    },
  ],
  "lid:state:SL:3|el": [
    {
      german: "Für wie viele Jahre",
      translated: "Για πόσα χρόνια",
      tone: 'semantic',
    },
    {
      german: "der Landtag",
      translated: "το Landtag",
      tone: 'semantic',
    },
    {
      german: "gewählt",
      translated: "εκλέγεται",
      tone: 'semantic',
    },
  ],
  "lid:state:SL:3|en": [
    {
      german: "Für wie viele Jahre",
      translated: "For how many years",
      tone: 'semantic',
    },
    {
      german: "der Landtag",
      translated: "the state parliament",
      tone: 'semantic',
    },
    {
      german: "des Saarlandes",
      translated: "of Saarland",
      tone: 'semantic',
    },
    {
      german: "gewählt",
      translated: "elected",
      tone: 'semantic',
    },
  ],
  "lid:state:SL:3|es": [
    {
      german: "Für wie viele Jahre",
      translated: "¿Por cuántos años",
      tone: 'semantic',
    },
    {
      german: "der Landtag",
      translated: "el parlamento regional",
      tone: 'semantic',
    },
    {
      german: "des Saarlandes",
      translated: "Sarre",
      tone: 'semantic',
    },
    {
      german: "gewählt",
      translated: "se elige",
      tone: 'semantic',
    },
  ],
  "lid:state:SL:3|fa": [
    {
      german: "Für wie viele Jahre",
      translated: "برای چند سال",
      tone: 'semantic',
    },
    {
      german: "der Landtag",
      translated: "پارلمان ایالتی",
      tone: 'semantic',
    },
    {
      german: "des Saarlandes",
      translated: "زارلاند",
      tone: 'semantic',
    },
    {
      german: "gewählt",
      translated: "انتخاب می‌شود",
      tone: 'semantic',
    },
  ],
  "lid:state:SL:3|fr": [
    {
      german: "Für wie viele Jahre",
      translated: "Pour combien d’années",
      tone: 'semantic',
    },
    {
      german: "der Landtag",
      translated: "le Landtag",
      tone: 'semantic',
    },
    {
      german: "des Saarlandes",
      translated: "de Sarre",
      tone: 'semantic',
    },
    {
      german: "gewählt",
      translated: "élu",
      tone: 'semantic',
    },
  ],
  "lid:state:SL:3|hr": [
    {
      german: "Für wie viele Jahre",
      translated: "Na koliko se godina",
      tone: 'semantic',
    },
    {
      german: "der Landtag",
      translated: "parlament",
      tone: 'semantic',
    },
    {
      german: "des Saarlandes",
      translated: "savezne zemlje Saarland",
      tone: 'semantic',
    },
    {
      german: "gewählt",
      translated: "bira",
      tone: 'semantic',
    },
  ],
  "lid:state:SL:3|it": [
    {
      german: "Für wie viele Jahre",
      translated: "Per quanti anni",
      tone: 'semantic',
    },
    {
      german: "der Landtag",
      translated: "il Landtag",
      tone: 'semantic',
    },
    {
      german: "des Saarlandes",
      translated: "di Saarland",
      tone: 'semantic',
    },
    {
      german: "gewählt",
      translated: "viene eletto",
      tone: 'semantic',
    },
  ],
  "lid:state:SL:3|kmr": [
    {
      german: "Für wie viele Jahre",
      translated: "ji bo çend salan",
      tone: 'semantic',
    },
    {
      german: "der Landtag",
      translated: "Landtag",
      tone: 'semantic',
    },
    {
      german: "des Saarlandes",
      translated: "Saarland",
      tone: 'semantic',
    },
    {
      german: "gewählt",
      translated: "tê hilbijartin",
      tone: 'semantic',
    },
  ],
  "lid:state:SL:3|pl": [
    {
      german: "Für wie viele Jahre",
      translated: "Na ile lat",
      tone: 'semantic',
    },
    {
      german: "der Landtag",
      translated: "parlament",
      tone: 'semantic',
    },
    {
      german: "des Saarlandes",
      translated: "kraju związkowego Saara",
      tone: 'semantic',
    },
    {
      german: "gewählt",
      translated: "wybierany jest",
      tone: 'semantic',
    },
  ],
  "lid:state:SL:3|prs": [
    {
      german: "Für wie viele Jahre",
      translated: "برای چند سال",
      tone: 'semantic',
    },
    {
      german: "der Landtag",
      translated: "پارلمان ایالتی",
      tone: 'semantic',
    },
    {
      german: "des Saarlandes",
      translated: "زارلاند",
      tone: 'semantic',
    },
    {
      german: "gewählt",
      translated: "انتخاب می‌شود",
      tone: 'semantic',
    },
  ],
  "lid:state:SL:3|ro": [
    {
      german: "Für wie viele Jahre",
      translated: "Pentru câți ani",
      tone: 'semantic',
    },
    {
      german: "der Landtag",
      translated: "parlamentul landului Saarland",
      tone: 'semantic',
    },
    {
      german: "gewählt",
      translated: "este ales",
      tone: 'semantic',
    },
  ],
  "lid:state:SL:3|ru": [
    {
      german: "Für wie viele Jahre",
      translated: "На сколько лет",
      tone: 'semantic',
    },
    {
      german: "der Landtag",
      translated: "ландтаг",
      tone: 'semantic',
    },
    {
      german: "des Saarlandes",
      translated: "в федеральной земле Саарланд",
      tone: 'semantic',
    },
    {
      german: "gewählt",
      translated: "избирается",
      tone: 'semantic',
    },
  ],
  "lid:state:SL:3|sq": [
    {
      german: "Für wie viele Jahre",
      translated: "Për sa vjet",
      tone: 'semantic',
    },
    {
      german: "der Landtag",
      translated: "Landtagu",
      tone: 'semantic',
    },
    {
      german: "des Saarlandes",
      translated: "i Saarland",
      tone: 'semantic',
    },
    {
      german: "gewählt",
      translated: "zgjidhet",
      tone: 'semantic',
    },
  ],
  "lid:state:SL:3|sr": [
    {
      german: "Für wie viele Jahre",
      translated: "koliko se godina",
      tone: 'semantic',
    },
    {
      german: "der Landtag",
      translated: "parlament",
      tone: 'semantic',
    },
    {
      german: "des Saarlandes",
      translated: "savezne pokrajine Saarland",
      tone: 'semantic',
    },
    {
      german: "gewählt",
      translated: "bira",
      tone: 'semantic',
    },
  ],
  "lid:state:SL:3|tr": [
    {
      german: "Für wie viele Jahre",
      translated: "kaç yıllığına",
      tone: 'semantic',
    },
    {
      german: "der Landtag",
      translated: "eyalet parlamentosu",
      tone: 'semantic',
    },
    {
      german: "des Saarlandes",
      translated: "Saarland",
      tone: 'semantic',
    },
    {
      german: "gewählt",
      translated: "seçilir",
      tone: 'semantic',
    },
  ],
  "lid:state:SL:3|uk": [
    {
      german: "Für wie viele Jahre",
      translated: "На скільки років",
      tone: 'semantic',
    },
    {
      german: "der Landtag",
      translated: "земельний парламент",
      tone: 'semantic',
    },
    {
      german: "des Saarlandes",
      translated: "Саар",
      tone: 'semantic',
    },
    {
      german: "gewählt",
      translated: "обирають",
      tone: 'semantic',
    },
  ],
  "lid:state:SL:3|vi": [
    {
      german: "Für wie viele Jahre",
      translated: "bao nhiêu năm",
      tone: 'semantic',
    },
    {
      german: "der Landtag",
      translated: "Nghị viện bang (Landtag)",
      tone: 'semantic',
    },
    {
      german: "des Saarlandes",
      translated: "của Saarland",
      tone: 'semantic',
    },
    {
      german: "gewählt",
      translated: "được bầu",
      tone: 'semantic',
    },
  ],
  "lid:state:SL:4|ar": [
    {
      german: "Ab welchem Alter",
      translated: "ابتداءً من أي سن",
      tone: 'semantic',
    },
    {
      german: "darf man",
      translated: "يحق",
      tone: 'semantic',
    },
    {
      german: "im Saarland",
      translated: "في Saarland",
      tone: 'semantic',
    },
    {
      german: "bei Kommunalwahlen",
      translated: "في الانتخابات المحلية",
      tone: 'semantic',
    },
    {
      german: "wählen",
      translated: "التصويت",
      tone: 'semantic',
    },
  ],
  "lid:state:SL:4|bg": [
    {
      german: "Ab welchem Alter",
      translated: "От каква възраст",
      tone: 'semantic',
    },
    {
      german: "darf man",
      translated: "може да се",
      tone: 'semantic',
    },
    {
      german: "im Saarland",
      translated: "в Саарланд",
      tone: 'semantic',
    },
    {
      german: "bei Kommunalwahlen",
      translated: "на общински избори",
      tone: 'semantic',
    },
    {
      german: "wählen",
      translated: "гласува",
      tone: 'semantic',
    },
  ],
  "lid:state:SL:4|bs": [
    {
      german: "Ab welchem Alter",
      translated: "Od koje se dobi",
      tone: 'semantic',
    },
    {
      german: "darf man",
      translated: "može",
      tone: 'semantic',
    },
    {
      german: "im Saarland",
      translated: "u saveznoj zemlji Saarland",
      tone: 'semantic',
    },
    {
      german: "bei Kommunalwahlen",
      translated: "na lokalnim izborima",
      tone: 'semantic',
    },
    {
      german: "wählen",
      translated: "glasovati",
      tone: 'semantic',
    },
  ],
  "lid:state:SL:4|el": [
    {
      german: "Ab welchem Alter",
      translated: "Από ποια ηλικία",
      tone: 'semantic',
    },
    {
      german: "darf man",
      translated: "μπορεί κάποιος",
      tone: 'semantic',
    },
    {
      german: "im Saarland",
      translated: "στο Σάαρλαντ",
      tone: 'semantic',
    },
    {
      german: "bei Kommunalwahlen",
      translated: "στις δημοτικές εκλογές",
      tone: 'semantic',
    },
    {
      german: "wählen",
      translated: "να ψηφίσει",
      tone: 'semantic',
    },
  ],
  "lid:state:SL:4|en": [
    {
      german: "Ab welchem Alter",
      translated: "From what age",
      tone: 'semantic',
    },
    {
      german: "darf man",
      translated: "can you",
      tone: 'semantic',
    },
    {
      german: "im Saarland",
      translated: "in Saarland",
      tone: 'semantic',
    },
    {
      german: "bei Kommunalwahlen",
      translated: "in local elections",
      tone: 'semantic',
    },
    {
      german: "wählen",
      translated: "vote",
      tone: 'semantic',
    },
  ],
  "lid:state:SL:4|es": [
    {
      german: "Ab welchem Alter",
      translated: "¿A partir de qué edad",
      tone: 'semantic',
    },
    {
      german: "darf man",
      translated: "se puede",
      tone: 'semantic',
    },
    {
      german: "im Saarland",
      translated: "de Sarre",
      tone: 'semantic',
    },
    {
      german: "bei Kommunalwahlen",
      translated: "en las elecciones municipales",
      tone: 'semantic',
    },
    {
      german: "wählen",
      translated: "votar",
      tone: 'semantic',
    },
  ],
  "lid:state:SL:4|fa": [
    {
      german: "Ab welchem Alter",
      translated: "از چه سنی",
      tone: 'semantic',
    },
    {
      german: "darf man",
      translated: "می‌توان",
      tone: 'semantic',
    },
    {
      german: "im Saarland",
      translated: "زارلاند",
      tone: 'semantic',
    },
    {
      german: "bei Kommunalwahlen",
      translated: "در انتخابات محلی",
      tone: 'semantic',
    },
    {
      german: "wählen",
      translated: "رأی داد",
      tone: 'semantic',
    },
  ],
  "lid:state:SL:4|fr": [
    {
      german: "Ab welchem Alter",
      translated: "À partir de quel âge",
      tone: 'semantic',
    },
    {
      german: "darf man",
      translated: "peut-on",
      tone: 'semantic',
    },
    {
      german: "im Saarland",
      translated: "en Sarre",
      tone: 'semantic',
    },
    {
      german: "bei Kommunalwahlen",
      translated: "aux élections municipales",
      tone: 'semantic',
    },
    {
      german: "wählen",
      translated: "voter",
      tone: 'semantic',
    },
  ],
  "lid:state:SL:4|hr": [
    {
      german: "Ab welchem Alter",
      translated: "Od koje se dobi",
      tone: 'semantic',
    },
    {
      german: "darf man",
      translated: "može",
      tone: 'semantic',
    },
    {
      german: "im Saarland",
      translated: "u saveznoj zemlji Saarland",
      tone: 'semantic',
    },
    {
      german: "bei Kommunalwahlen",
      translated: "na lokalnim izborima",
      tone: 'semantic',
    },
    {
      german: "wählen",
      translated: "glasovati",
      tone: 'semantic',
    },
  ],
  "lid:state:SL:4|it": [
    {
      german: "Ab welchem Alter",
      translated: "Da quale età",
      tone: 'semantic',
    },
    {
      german: "darf man",
      translated: "si può",
      tone: 'semantic',
    },
    {
      german: "im Saarland",
      translated: "in Saarland",
      tone: 'semantic',
    },
    {
      german: "bei Kommunalwahlen",
      translated: "alle elezioni comunali",
      tone: 'semantic',
    },
    {
      german: "wählen",
      translated: "votare",
      tone: 'semantic',
    },
  ],
  "lid:state:SL:4|kmr": [
    {
      german: "Ab welchem Alter",
      translated: "Ji kîjan temenê",
      tone: 'semantic',
    },
    {
      german: "darf man",
      translated: "dikare",
      tone: 'semantic',
    },
    {
      german: "im Saarland",
      translated: "li Saarland",
      tone: 'semantic',
    },
    {
      german: "bei Kommunalwahlen",
      translated: "di hilbijartinên şaredariyê de",
      tone: 'semantic',
    },
    {
      german: "wählen",
      translated: "deng were dayîn",
      tone: 'semantic',
    },
  ],
  "lid:state:SL:4|pl": [
    {
      german: "Ab welchem Alter",
      translated: "Od jakiego wieku",
      tone: 'semantic',
    },
    {
      german: "darf man",
      translated: "można",
      tone: 'semantic',
    },
    {
      german: "im Saarland",
      translated: "w Saara",
      tone: 'semantic',
    },
    {
      german: "bei Kommunalwahlen",
      translated: "w wyborach samorządowych",
      tone: 'semantic',
    },
    {
      german: "wählen",
      translated: "głosować",
      tone: 'semantic',
    },
  ],
  "lid:state:SL:4|prs": [
    {
      german: "Ab welchem Alter",
      translated: "از چه سنی",
      tone: 'semantic',
    },
    {
      german: "darf man",
      translated: "می‌توان",
      tone: 'semantic',
    },
    {
      german: "im Saarland",
      translated: "شاروالی زارلاند",
      tone: 'semantic',
    },
    {
      german: "bei Kommunalwahlen",
      translated: "در انتخابات",
      tone: 'semantic',
    },
    {
      german: "wählen",
      translated: "رأی داد",
      tone: 'semantic',
    },
  ],
  "lid:state:SL:4|ro": [
    {
      german: "Ab welchem Alter",
      translated: "De la ce vârstă",
      tone: 'semantic',
    },
    {
      german: "darf man",
      translated: "se poate",
      tone: 'semantic',
    },
    {
      german: "im Saarland",
      translated: "din Saarland",
      tone: 'semantic',
    },
    {
      german: "bei Kommunalwahlen",
      translated: "la alegerile locale",
      tone: 'semantic',
    },
    {
      german: "wählen",
      translated: "vota",
      tone: 'semantic',
    },
  ],
  "lid:state:SL:4|ru": [
    {
      german: "Ab welchem Alter",
      translated: "С какого возраста",
      tone: 'semantic',
    },
    {
      german: "darf man",
      translated: "можно",
      tone: 'semantic',
    },
    {
      german: "im Saarland",
      translated: "в федеральной земле Саарланд",
      tone: 'semantic',
    },
    {
      german: "bei Kommunalwahlen",
      translated: "на муниципальных выборах",
      tone: 'semantic',
    },
    {
      german: "wählen",
      translated: "голосовать",
      tone: 'semantic',
    },
  ],
  "lid:state:SL:4|sq": [
    {
      german: "Ab welchem Alter",
      translated: "moshë",
      tone: 'semantic',
    },
    {
      german: "darf man",
      translated: "mund të",
      tone: 'semantic',
    },
    {
      german: "im Saarland",
      translated: "në Saarland",
      tone: 'semantic',
    },
    {
      german: "bei Kommunalwahlen",
      translated: "në zgjedhjet komunale",
      tone: 'semantic',
    },
    {
      german: "wählen",
      translated: "votohet",
      tone: 'semantic',
    },
  ],
  "lid:state:SL:4|sr": [
    {
      german: "Ab welchem Alter",
      translated: "Od koje",
      tone: 'semantic',
    },
    {
      german: "darf man",
      translated: "se",
      tone: 'semantic',
    },
    {
      german: "im Saarland",
      translated: "u saveznoj pokrajini Saarland",
      tone: 'semantic',
    },
    {
      german: "bei Kommunalwahlen",
      translated: "lokalnim izborima",
      tone: 'semantic',
    },
    {
      german: "wählen",
      translated: "glasati",
      tone: 'semantic',
    },
  ],
  "lid:state:SL:4|tr": [
    {
      german: "Ab welchem Alter",
      translated: "kaç yaşından itibaren",
      tone: 'semantic',
    },
    {
      german: "im Saarland",
      translated: "Saarland eyaletinde",
      tone: 'semantic',
    },
    {
      german: "bei Kommunalwahlen",
      translated: "yerel seçimlerde",
      tone: 'semantic',
    },
    {
      german: "wählen",
      translated: "oy kullanılabilir",
      tone: 'semantic',
    },
  ],
  "lid:state:SL:4|uk": [
    {
      german: "Ab welchem Alter",
      translated: "З якого віку",
      tone: 'semantic',
    },
    {
      german: "darf man",
      translated: "можна",
      tone: 'semantic',
    },
    {
      german: "im Saarland",
      translated: "у федеральній землі Саар",
      tone: 'semantic',
    },
    {
      german: "bei Kommunalwahlen",
      translated: "на муніципальних виборах",
      tone: 'semantic',
    },
    {
      german: "wählen",
      translated: "голосувати",
      tone: 'semantic',
    },
  ],
  "lid:state:SL:4|vi": [
    {
      german: "Ab welchem Alter",
      translated: "Từ bao nhiêu tuổi",
      tone: 'semantic',
    },
    {
      german: "darf man",
      translated: "có thể",
      tone: 'semantic',
    },
    {
      german: "im Saarland",
      translated: "ở bang Saarland",
      tone: 'semantic',
    },
    {
      german: "bei Kommunalwahlen",
      translated: "trong bầu cử địa phương",
      tone: 'semantic',
    },
    {
      german: "wählen",
      translated: "bỏ phiếu",
      tone: 'semantic',
    },
  ],
  "lid:state:SL:5|ar": [
    {
      german: "Welche Farben",
      translated: "ما",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "ألوان",
      tone: 'semantic',
    },
    {
      german: "die Landesflagge",
      translated: "علم ولاية",
      tone: 'semantic',
    },
    {
      german: "des Saarlandes",
      translated: "Saarland؟",
      tone: 'semantic',
    },
  ],
  "lid:state:SL:5|bg": [
    {
      german: "Welche Farben",
      translated: "Какви са цветовете",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "на",
      tone: 'semantic',
    },
    {
      german: "die Landesflagge",
      translated: "знамето",
      tone: 'semantic',
    },
    {
      german: "des Saarlandes",
      translated: "на провинция Саарланд",
      tone: 'semantic',
    },
  ],
  "lid:state:SL:5|bs": [
    {
      german: "Welche Farben",
      translated: "Koje su boje",
      tone: 'semantic',
    },
    {
      german: "die Landesflagge",
      translated: "zastave savezne zemlje",
      tone: 'semantic',
    },
    {
      german: "des Saarlandes",
      translated: "Saarland",
      tone: 'semantic',
    },
  ],
  "lid:state:SL:5|el": [
    {
      german: "Welche Farben",
      translated: "Ποια είναι τα χρώματα",
      tone: 'semantic',
    },
    {
      german: "die Landesflagge",
      translated: "της σημαίας του κρατιδίου Σάαρλαντ",
      tone: 'semantic',
    },
  ],
  "lid:state:SL:5|en": [
    {
      german: "Welche Farben",
      translated: "What colors",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "does",
      tone: 'semantic',
    },
    {
      german: "die Landesflagge",
      translated: "the state flag",
      tone: 'semantic',
    },
    {
      german: "des Saarlandes",
      translated: "of Saarland",
      tone: 'semantic',
    },
  ],
  "lid:state:SL:5|es": [
    {
      german: "Welche Farben",
      translated: "¿Qué colores",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "tiene",
      tone: 'semantic',
    },
    {
      german: "die Landesflagge",
      translated: "la bandera regional",
      tone: 'semantic',
    },
    {
      german: "des Saarlandes",
      translated: "de Sarre",
      tone: 'semantic',
    },
  ],
  "lid:state:SL:5|fa": [
    {
      german: "Welche Farben",
      translated: "رنگ‌های",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "کدام‌اند",
      tone: 'semantic',
    },
    {
      german: "die Landesflagge",
      translated: "پرچم",
      tone: 'semantic',
    },
    {
      german: "des Saarlandes",
      translated: "ایالت زارلاند",
      tone: 'semantic',
    },
  ],
  "lid:state:SL:5|fr": [
    {
      german: "Welche Farben",
      translated: "Quelles sont les couleurs",
      tone: 'semantic',
    },
    {
      german: "die Landesflagge",
      translated: "drapeau du Land",
      tone: 'semantic',
    },
    {
      german: "des Saarlandes",
      translated: "de Sarre",
      tone: 'semantic',
    },
  ],
  "lid:state:SL:5|hr": [
    {
      german: "Welche Farben",
      translated: "Koje su boje",
      tone: 'semantic',
    },
    {
      german: "die Landesflagge",
      translated: "zastave",
      tone: 'semantic',
    },
    {
      german: "des Saarlandes",
      translated: "savezne zemlje Saarland",
      tone: 'semantic',
    },
  ],
  "lid:state:SL:5|it": [
    {
      german: "Welche Farben",
      translated: "Quali sono i colori",
      tone: 'semantic',
    },
    {
      german: "die Landesflagge",
      translated: "bandiera",
      tone: 'semantic',
    },
    {
      german: "des Saarlandes",
      translated: "di Saarland",
      tone: 'semantic',
    },
  ],
  "lid:state:SL:5|kmr": [
    {
      german: "Welche Farben",
      translated: "ala eyaleta",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "ne",
      tone: 'semantic',
    },
    {
      german: "die Landesflagge",
      translated: "Rengên",
      tone: 'semantic',
    },
    {
      german: "des Saarlandes",
      translated: "Saarland",
      tone: 'semantic',
    },
  ],
  "lid:state:SL:5|pl": [
    {
      german: "Welche Farben",
      translated: "Jakie są kolory",
      tone: 'semantic',
    },
    {
      german: "die Landesflagge",
      translated: "flagi kraju związkowego",
      tone: 'semantic',
    },
    {
      german: "des Saarlandes",
      translated: "Saara",
      tone: 'semantic',
    },
  ],
  "lid:state:SL:5|prs": [
    {
      german: "Welche Farben",
      translated: "رنگ‌های",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "کدام‌اند",
      tone: 'semantic',
    },
    {
      german: "die Landesflagge",
      translated: "پرچم ایالت",
      tone: 'semantic',
    },
    {
      german: "des Saarlandes",
      translated: "زارلاند",
      tone: 'semantic',
    },
  ],
  "lid:state:SL:5|ro": [
    {
      german: "Welche Farben",
      translated: "Care sunt culorile",
      tone: 'semantic',
    },
    {
      german: "die Landesflagge",
      translated: "drapelului landului",
      tone: 'semantic',
    },
    {
      german: "des Saarlandes",
      translated: "Saarland?",
      tone: 'semantic',
    },
  ],
  "lid:state:SL:5|ru": [
    {
      german: "Welche Farben",
      translated: "Какие цвета",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "у",
      tone: 'semantic',
    },
    {
      german: "die Landesflagge",
      translated: "флага земли",
      tone: 'semantic',
    },
    {
      german: "des Saarlandes",
      translated: "Саарланд",
      tone: 'semantic',
    },
  ],
  "lid:state:SL:5|sq": [
    {
      german: "Welche Farben",
      translated: "Cilat janë ngjyrat",
      tone: 'semantic',
    },
    {
      german: "die Landesflagge",
      translated: "flamurit",
      tone: 'semantic',
    },
    {
      german: "des Saarlandes",
      translated: "të landit Saarland?",
      tone: 'semantic',
    },
  ],
  "lid:state:SL:5|sr": [
    {
      german: "Welche Farben",
      translated: "Koje su boje",
      tone: 'semantic',
    },
    {
      german: "die Landesflagge",
      translated: "zastave",
      tone: 'semantic',
    },
    {
      german: "des Saarlandes",
      translated: "savezne pokrajine Saarland",
      tone: 'semantic',
    },
  ],
  "lid:state:SL:5|tr": [
    {
      german: "Welche Farben",
      translated: "renkleri nelerdir",
      tone: 'semantic',
    },
    {
      german: "die Landesflagge",
      translated: "eyalet bayrağının",
      tone: 'semantic',
    },
    {
      german: "des Saarlandes",
      translated: "Saarland",
      tone: 'semantic',
    },
  ],
  "lid:state:SL:5|uk": [
    {
      german: "Welche Farben",
      translated: "Які кольори",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: " має",
      tone: 'semantic',
    },
    {
      german: "die Landesflagge",
      translated: "прапор федеральної землі",
      tone: 'semantic',
    },
    {
      german: "des Saarlandes",
      translated: "Саар",
      tone: 'semantic',
    },
  ],
  "lid:state:SL:5|vi": [
    {
      german: "Welche Farben",
      translated: "Màu của",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "là",
      tone: 'semantic',
    },
    {
      german: "die Landesflagge",
      translated: "cờ bang",
      tone: 'semantic',
    },
    {
      german: "des Saarlandes",
      translated: "Saarland",
      tone: 'semantic',
    },
  ],
  "lid:state:SL:6|ar": [
    {
      german: "Wo können Sie sich",
      translated: "أين يمكنك",
      tone: 'semantic',
    },
    {
      german: "im Saarland",
      translated: "في Saarland",
      tone: 'semantic',
    },
    {
      german: "über politische Themen",
      translated: "عن القضايا السياسية",
      tone: 'semantic',
    },
    {
      german: "informieren",
      translated: "الحصول على معلومات",
      tone: 'semantic',
    },
  ],
  "lid:state:SL:6|bg": [
    {
      german: "Wo können Sie sich",
      translated: "Къде в",
      tone: 'semantic',
    },
    {
      german: "im Saarland",
      translated: "Саарланд",
      tone: 'semantic',
    },
    {
      german: "über politische Themen",
      translated: "по политически теми",
      tone: 'semantic',
    },
    {
      german: "informieren",
      translated: "да получите информация",
      tone: 'semantic',
    },
  ],
  "lid:state:SL:6|bs": [
    {
      german: "Wo können Sie sich",
      translated: "Gdje se",
      tone: 'semantic',
    },
    {
      german: "im Saarland",
      translated: "u saveznoj zemlji Saarland",
      tone: 'semantic',
    },
    {
      german: "über politische Themen",
      translated: "o političkim temama",
      tone: 'semantic',
    },
    {
      german: "informieren",
      translated: "mogu dobiti informacije",
      tone: 'semantic',
    },
  ],
  "lid:state:SL:6|el": [
    {
      german: "Wo können Sie sich",
      translated: "Πού μπορείτε να",
      tone: 'semantic',
    },
    {
      german: "im Saarland",
      translated: "στο Σάαρλαντ",
      tone: 'semantic',
    },
    {
      german: "über politische Themen",
      translated: "για πολιτικά θέματα",
      tone: 'semantic',
    },
    {
      german: "informieren",
      translated: "ενημερωθείτε",
      tone: 'semantic',
    },
  ],
  "lid:state:SL:6|en": [
    {
      german: "Wo können Sie sich",
      translated: "Where can you",
      tone: 'semantic',
    },
    {
      german: "im Saarland",
      translated: "in Saarland",
      tone: 'semantic',
    },
    {
      german: "über politische Themen",
      translated: "about political topics",
      tone: 'semantic',
    },
    {
      german: "informieren",
      translated: "get information",
      tone: 'semantic',
    },
  ],
  "lid:state:SL:6|es": [
    {
      german: "Wo können Sie sich",
      translated: "¿Dónde",
      tone: 'semantic',
    },
    {
      german: "im Saarland",
      translated: "en Sarre",
      tone: 'semantic',
    },
    {
      german: "über politische Themen",
      translated: "sobre temas políticos",
      tone: 'semantic',
    },
    {
      german: "informieren",
      translated: "puede informarse",
      tone: 'semantic',
    },
  ],
  "lid:state:SL:6|fa": [
    {
      german: "Wo können Sie sich",
      translated: "می‌توانید",
      tone: 'semantic',
    },
    {
      german: "im Saarland",
      translated: "در زارلاند",
      tone: 'semantic',
    },
    {
      german: "über politische Themen",
      translated: "دربارهٔ موضوعات سیاسی",
      tone: 'semantic',
    },
    {
      german: "informieren",
      translated: "اطلاعات کسب کنید",
      tone: 'semantic',
    },
  ],
  "lid:state:SL:6|fr": [
    {
      german: "Wo können Sie sich",
      translated: "Où pouvez-vous",
      tone: 'semantic',
    },
    {
      german: "im Saarland",
      translated: "en Sarre",
      tone: 'semantic',
    },
    {
      german: "über politische Themen",
      translated: "les questions politiques",
      tone: 'semantic',
    },
    {
      german: "informieren",
      translated: "vous informer sur",
      tone: 'semantic',
    },
  ],
  "lid:state:SL:6|hr": [
    {
      german: "Wo können Sie sich",
      translated: "Gdje se",
      tone: 'semantic',
    },
    {
      german: "im Saarland",
      translated: "u saveznoj zemlji Saarland",
      tone: 'semantic',
    },
    {
      german: "über politische Themen",
      translated: "o političkim temama",
      tone: 'semantic',
    },
    {
      german: "informieren",
      translated: "mogu dobiti informacije",
      tone: 'semantic',
    },
  ],
  "lid:state:SL:6|it": [
    {
      german: "Wo können Sie sich",
      translated: "Dove ci si può",
      tone: 'semantic',
    },
    {
      german: "im Saarland",
      translated: "in Saarland",
      tone: 'semantic',
    },
    {
      german: "über politische Themen",
      translated: "su temi politici",
      tone: 'semantic',
    },
    {
      german: "informieren",
      translated: "informare",
      tone: 'semantic',
    },
  ],
  "lid:state:SL:6|kmr": [
    {
      german: "Wo können Sie sich",
      translated: "li ku dikarî",
      tone: 'semantic',
    },
    {
      german: "im Saarland",
      translated: "Li Saarland",
      tone: 'semantic',
    },
    {
      german: "über politische Themen",
      translated: "li ser mijarên siyasî",
      tone: 'semantic',
    },
    {
      german: "informieren",
      translated: "agahdarî bistînî",
      tone: 'semantic',
    },
  ],
  "lid:state:SL:6|pl": [
    {
      german: "Wo können Sie sich",
      translated: "Gdzie",
      tone: 'semantic',
    },
    {
      german: "im Saarland",
      translated: "w Saara",
      tone: 'semantic',
    },
    {
      german: "über politische Themen",
      translated: "na tematy polityczne",
      tone: 'semantic',
    },
    {
      german: "informieren",
      translated: "można uzyskać",
      tone: 'semantic',
    },
  ],
  "lid:state:SL:6|prs": [
    {
      german: "im Saarland",
      translated: "در زارلاند",
      tone: 'semantic',
    },
    {
      german: "über politische Themen",
      translated: " دربارهٔ موضوعات سیاسی",
      tone: 'semantic',
    },
    {
      german: "informieren",
      translated: "اطلاعات کسب کنید",
      tone: 'semantic',
    },
  ],
  "lid:state:SL:6|ro": [
    {
      german: "Wo können Sie sich",
      translated: "Unde vă puteți",
      tone: 'semantic',
    },
    {
      german: "im Saarland",
      translated: "în Saarland",
      tone: 'semantic',
    },
    {
      german: "über politische Themen",
      translated: "despre teme politice",
      tone: 'semantic',
    },
    {
      german: "informieren",
      translated: "informa",
      tone: 'semantic',
    },
  ],
  "lid:state:SL:6|ru": [
    {
      german: "Wo können Sie sich",
      translated: "Где",
      tone: 'semantic',
    },
    {
      german: "im Saarland",
      translated: "в федеральной земле Саарланд",
      tone: 'semantic',
    },
    {
      german: "über politische Themen",
      translated: "о политических темах",
      tone: 'semantic',
    },
    {
      german: "informieren",
      translated: "получить информацию",
      tone: 'semantic',
    },
  ],
  "lid:state:SL:6|sq": [
    {
      german: "Wo können Sie sich",
      translated: "Ku mund",
      tone: 'semantic',
    },
    {
      german: "im Saarland",
      translated: "në Saarland",
      tone: 'semantic',
    },
    {
      german: "über politische Themen",
      translated: "për tema politike",
      tone: 'semantic',
    },
    {
      german: "informieren",
      translated: "informoheni",
      tone: 'semantic',
    },
  ],
  "lid:state:SL:6|sr": [
    {
      german: "Wo können Sie sich",
      translated: "Gdje se u",
      tone: 'semantic',
    },
    {
      german: "im Saarland",
      translated: "pokrajini Saarland",
      tone: 'semantic',
    },
    {
      german: "über politische Themen",
      translated: "političkim temama",
      tone: 'semantic',
    },
    {
      german: "informieren",
      translated: "dobiti informacije",
      tone: 'semantic',
    },
  ],
  "lid:state:SL:6|tr": [
    {
      german: "Wo können Sie sich",
      translated: "nereden bilgi alabilirsiniz",
      tone: 'semantic',
    },
    {
      german: "im Saarland",
      translated: "Saarland eyaletinde",
      tone: 'semantic',
    },
    {
      german: "über politische Themen",
      translated: "siyasi konular hakkında",
      tone: 'semantic',
    },
  ],
  "lid:state:SL:6|uk": [
    {
      german: "Wo können Sie sich",
      translated: "Де",
      tone: 'semantic',
    },
    {
      german: "im Saarland",
      translated: "у федеральній землі Саар",
      tone: 'semantic',
    },
    {
      german: "über politische Themen",
      translated: "про політичні питання",
      tone: 'semantic',
    },
    {
      german: "informieren",
      translated: "отримати інформацію",
      tone: 'semantic',
    },
  ],
  "lid:state:SL:6|vi": [
    {
      german: "im Saarland",
      translated: "Ở bang Saarland",
      tone: 'semantic',
    },
    {
      german: "über politische Themen",
      translated: "về các chủ đề chính trị",
      tone: 'semantic',
    },
    {
      german: "informieren",
      translated: "tìm thông tin",
      tone: 'semantic',
    },
  ],
  "lid:state:SL:7|ar": [
    {
      german: "Die Landeshauptstadt",
      translated: "ما عاصمة",
      tone: 'semantic',
    },
    {
      german: "des Saarlandes",
      translated: "Saarland",
      tone: 'semantic',
    },
    {
      german: "heißt …",
      translated: "ولاية",
      tone: 'semantic',
    },
  ],
  "lid:state:SL:7|bg": [
    {
      german: "Die Landeshauptstadt",
      translated: "Столицата на федералната провинция",
      tone: 'semantic',
    },
    {
      german: "des Saarlandes",
      translated: "Саарланд",
      tone: 'semantic',
    },
    {
      german: "heißt …",
      translated: "е …",
      tone: 'semantic',
    },
  ],
  "lid:state:SL:7|bs": [
    {
      german: "Die Landeshauptstadt",
      translated: "Glavni grad",
      tone: 'semantic',
    },
    {
      german: "des Saarlandes",
      translated: "savezne zemlje Saarland",
      tone: 'semantic',
    },
    {
      german: "heißt …",
      translated: "je",
      tone: 'semantic',
    },
  ],
  "lid:state:SL:7|el": [
    {
      german: "Die Landeshauptstadt",
      translated: "Η πρωτεύουσα",
      tone: 'semantic',
    },
    {
      german: "des Saarlandes",
      translated: "του ομόσπονδου κρατιδίου Σάαρλαντ",
      tone: 'semantic',
    },
    {
      german: "heißt …",
      translated: "είναι …",
      tone: 'semantic',
    },
  ],
  "lid:state:SL:7|en": [
    {
      german: "Die Landeshauptstadt",
      translated: "The state capital",
      tone: 'semantic',
    },
    {
      german: "des Saarlandes",
      translated: "of Saarland",
      tone: 'semantic',
    },
    {
      german: "heißt …",
      translated: "is called ...",
      tone: 'semantic',
    },
  ],
  "lid:state:SL:7|es": [
    {
      german: "Die Landeshauptstadt",
      translated: "La capital",
      tone: 'semantic',
    },
    {
      german: "des Saarlandes",
      translated: "del estado federado de Sarre",
      tone: 'semantic',
    },
    {
      german: "heißt …",
      translated: "es …",
      tone: 'semantic',
    },
  ],
  "lid:state:SL:7|fa": [
    {
      german: "Die Landeshauptstadt",
      translated: "مرکز ایالت",
      tone: 'semantic',
    },
    {
      german: "des Saarlandes",
      translated: "زارلاند",
      tone: 'semantic',
    },
  ],
  "lid:state:SL:7|fr": [
    {
      german: "Die Landeshauptstadt",
      translated: "La capitale du Land",
      tone: 'semantic',
    },
    {
      german: "des Saarlandes",
      translated: "de Sarre",
      tone: 'semantic',
    },
    {
      german: "heißt …",
      translated: "s’appelle …",
      tone: 'semantic',
    },
  ],
  "lid:state:SL:7|hr": [
    {
      german: "Die Landeshauptstadt",
      translated: "Glavni grad",
      tone: 'semantic',
    },
    {
      german: "des Saarlandes",
      translated: "savezne zemlje Saarland",
      tone: 'semantic',
    },
    {
      german: "heißt …",
      translated: "je",
      tone: 'semantic',
    },
  ],
  "lid:state:SL:7|it": [
    {
      german: "Die Landeshauptstadt",
      translated: "La capitale del Land",
      tone: 'semantic',
    },
    {
      german: "des Saarlandes",
      translated: "di Saarland",
      tone: 'semantic',
    },
    {
      german: "heißt …",
      translated: "è …",
      tone: 'semantic',
    },
  ],
  "lid:state:SL:7|kmr": [
    {
      german: "Die Landeshauptstadt",
      translated: "Paytexta eyaleta",
      tone: 'semantic',
    },
    {
      german: "des Saarlandes",
      translated: "Saarland",
      tone: 'semantic',
    },
    {
      german: "heißt …",
      translated: "… e.",
      tone: 'semantic',
    },
  ],
  "lid:state:SL:7|pl": [
    {
      german: "Die Landeshauptstadt",
      translated: "Stolicą",
      tone: 'semantic',
    },
    {
      german: "des Saarlandes",
      translated: "kraju związkowego Saara",
      tone: 'semantic',
    },
    {
      german: "heißt …",
      translated: "jest …",
      tone: 'semantic',
    },
  ],
  "lid:state:SL:7|prs": [
    {
      german: "Die Landeshauptstadt",
      translated: "مرکز ایالت",
      tone: 'semantic',
    },
    {
      german: "des Saarlandes",
      translated: "زارلاند",
      tone: 'semantic',
    },
  ],
  "lid:state:SL:7|ro": [
    {
      german: "Die Landeshauptstadt",
      translated: "Capitala",
      tone: 'semantic',
    },
    {
      german: "des Saarlandes",
      translated: "landului Saarland",
      tone: 'semantic',
    },
    {
      german: "heißt …",
      translated: "este",
      tone: 'semantic',
    },
  ],
  "lid:state:SL:7|ru": [
    {
      german: "Die Landeshauptstadt",
      translated: "Столица земли",
      tone: 'semantic',
    },
    {
      german: "des Saarlandes",
      translated: "Саарланд",
      tone: 'semantic',
    },
    {
      german: "heißt …",
      translated: "называется …",
      tone: 'semantic',
    },
  ],
  "lid:state:SL:7|sq": [
    {
      german: "Die Landeshauptstadt",
      translated: "Kryeqyteti",
      tone: 'semantic',
    },
    {
      german: "des Saarlandes",
      translated: "landit Saarland",
      tone: 'semantic',
    },
    {
      german: "heißt …",
      translated: "është …",
      tone: 'semantic',
    },
  ],
  "lid:state:SL:7|sr": [
    {
      german: "Die Landeshauptstadt",
      translated: "Glavni grad",
      tone: 'semantic',
    },
    {
      german: "des Saarlandes",
      translated: "savezne pokrajine Saarland",
      tone: 'semantic',
    },
    {
      german: "heißt …",
      translated: "je",
      tone: 'semantic',
    },
  ],
  "lid:state:SL:7|tr": [
    {
      german: "Die Landeshauptstadt",
      translated: "başkenti",
      tone: 'semantic',
    },
    {
      german: "des Saarlandes",
      translated: "Saarland eyaletinin",
      tone: 'semantic',
    },
  ],
  "lid:state:SL:7|uk": [
    {
      german: "Die Landeshauptstadt",
      translated: "Столиця",
      tone: 'semantic',
    },
    {
      german: "des Saarlandes",
      translated: "федеральної землі Саар",
      tone: 'semantic',
    },
    {
      german: "heißt …",
      translated: "називається …",
      tone: 'semantic',
    },
  ],
  "lid:state:SL:7|vi": [
    {
      german: "Die Landeshauptstadt",
      translated: "Thủ phủ",
      tone: 'semantic',
    },
    {
      german: "des Saarlandes",
      translated: "của bang Saarland",
      tone: 'semantic',
    },
    {
      german: "heißt …",
      translated: "là …",
      tone: 'semantic',
    },
  ],
  "lid:state:SL:8|ar": [
    {
      german: "Welches Bundesland",
      translated: "أي صورة",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "تمثل موقع ولاية",
      tone: 'semantic',
    },
    {
      german: "das Saarland",
      translated: "Saarland",
      tone: 'semantic',
    },
  ],
  "lid:state:SL:8|bg": [
    {
      german: "Welches Bundesland",
      translated: "Коя от показаните федерални провинции",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "е",
      tone: 'semantic',
    },
    {
      german: "das Saarland",
      translated: "Саарланд",
      tone: 'semantic',
    },
  ],
  "lid:state:SL:8|bs": [
    {
      german: "Welches Bundesland",
      translated: "Koja od prikazanih saveznih zemalja",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "je",
      tone: 'semantic',
    },
    {
      german: "das Saarland",
      translated: "Saarland",
      tone: 'semantic',
    },
  ],
  "lid:state:SL:8|el": [
    {
      german: "Welches Bundesland",
      translated: "Ποιο από τα εικονιζόμενα κρατίδια",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "είναι",
      tone: 'semantic',
    },
    {
      german: "das Saarland",
      translated: "το Σάαρλαντ",
      tone: 'semantic',
    },
  ],
  "lid:state:SL:8|en": [
    {
      german: "Welches Bundesland",
      translated: "Which federal state",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "is",
      tone: 'semantic',
    },
    {
      german: "das Saarland",
      translated: "Saarland",
      tone: 'semantic',
    },
  ],
  "lid:state:SL:8|es": [
    {
      german: "Welches Bundesland",
      translated: "estado federado",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "corresponde",
      tone: 'semantic',
    },
    {
      german: "das Saarland",
      translated: "Sarre",
      tone: 'semantic',
    },
  ],
  "lid:state:SL:8|fa": [
    {
      german: "Welches Bundesland",
      translated: "کدام ایالتِ",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "است",
      tone: 'semantic',
    },
    {
      german: "das Saarland",
      translated: "نشان‌داده‌شده زارلاند",
      tone: 'semantic',
    },
  ],
  "lid:state:SL:8|fr": [
    {
      german: "Welches Bundesland",
      translated: "Quel",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "est",
      tone: 'semantic',
    },
    {
      german: "das Saarland",
      translated: "Sarre ",
      tone: 'semantic',
    },
  ],
  "lid:state:SL:8|hr": [
    {
      german: "Welches Bundesland",
      translated: "Koja od prikazanih",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "je",
      tone: 'semantic',
    },
    {
      german: "das Saarland",
      translated: "Saarland",
      tone: 'semantic',
    },
  ],
  "lid:state:SL:8|it": [
    {
      german: "Welches Bundesland",
      translated: "Quale Land rappresentato",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "è",
      tone: 'semantic',
    },
    {
      german: "das Saarland",
      translated: "Saarland",
      tone: 'semantic',
    },
  ],
  "lid:state:SL:8|kmr": [
    {
      german: "Welches Bundesland",
      translated: "Kîjan eyalet",
      tone: 'semantic',
    },
    {
      german: "das Saarland",
      translated: "Saarland ye?",
      tone: 'semantic',
    },
  ],
  "lid:state:SL:8|pl": [
    {
      german: "Welches Bundesland",
      translated: "Który z przedstawionych krajów związkowych",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "to",
      tone: 'semantic',
    },
    {
      german: "das Saarland",
      translated: "Saara",
      tone: 'semantic',
    },
  ],
  "lid:state:SL:8|prs": [
    {
      german: "Welches Bundesland",
      translated: "کدام ایالتِ نشان‌داده‌شده",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "است",
      tone: 'semantic',
    },
    {
      german: "das Saarland",
      translated: "زارلاند",
      tone: 'semantic',
    },
  ],
  "lid:state:SL:8|ro": [
    {
      german: "Welches Bundesland",
      translated: "Care land reprezentat",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "este",
      tone: 'semantic',
    },
    {
      german: "das Saarland",
      translated: "Saarland",
      tone: 'semantic',
    },
  ],
  "lid:state:SL:8|ru": [
    {
      german: "Welches Bundesland",
      translated: "Какая из этих земель",
      tone: 'semantic',
    },
    {
      german: "das Saarland",
      translated: "Саарланд",
      tone: 'semantic',
    },
  ],
  "lid:state:SL:8|sq": [
    {
      german: "Welches Bundesland",
      translated: "Cili nga landet e paraqitura",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "është",
      tone: 'semantic',
    },
    {
      german: "das Saarland",
      translated: "Saarland",
      tone: 'semantic',
    },
  ],
  "lid:state:SL:8|sr": [
    {
      german: "Welches Bundesland",
      translated: "Koja od prikazanih saveznih pokrajina",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "je",
      tone: 'semantic',
    },
    {
      german: "das Saarland",
      translated: "Saarland",
      tone: 'semantic',
    },
  ],
  "lid:state:SL:8|tr": [
    {
      german: "Welches Bundesland",
      translated: "hangi numarayla",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "gösterilmiştir",
      tone: 'semantic',
    },
    {
      german: "das Saarland",
      translated: "Saarland",
      tone: 'semantic',
    },
  ],
  "lid:state:SL:8|uk": [
    {
      german: "Welches Bundesland",
      translated: "Яка з позначених федеральних земель",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "є",
      tone: 'semantic',
    },
    {
      german: "das Saarland",
      translated: "Саар",
      tone: 'semantic',
    },
  ],
  "lid:state:SL:8|vi": [
    {
      german: "Welches Bundesland",
      translated: "Bang nào",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "được",
      tone: 'semantic',
    },
    {
      german: "das Saarland",
      translated: "Saarland",
      tone: 'semantic',
    },
  ],
  "lid:state:SL:9|ar": [
    {
      german: "Wie nennt man",
      translated: "ماذا يُسمى",
      tone: 'semantic',
    },
    {
      german: "die Regierungschefin/den Regierungschef",
      translated: "رئيس/رئيسة حكومة",
      tone: 'semantic',
    },
    {
      german: "des Saarlandes",
      translated: "Saarland",
      tone: 'semantic',
    },
  ],
  "lid:state:SL:9|bg": [
    {
      german: "Wie nennt man",
      translated: "Как се нарича",
      tone: 'semantic',
    },
    {
      german: "die Regierungschefin/den Regierungschef",
      translated: "ръководителят на правителството",
      tone: 'semantic',
    },
    {
      german: "des Saarlandes",
      translated: "на провинция Саарланд",
      tone: 'semantic',
    },
  ],
  "lid:state:SL:9|bs": [
    {
      german: "Wie nennt man",
      translated: "Kako",
      tone: 'semantic',
    },
    {
      german: "die Regierungschefin/den Regierungschef",
      translated: "šef vlade",
      tone: 'semantic',
    },
    {
      german: "des Saarlandes",
      translated: "savezne zemlje Saarland",
      tone: 'semantic',
    },
  ],
  "lid:state:SL:9|el": [
    {
      german: "Wie nennt man",
      translated: "Πώς ονομάζεται",
      tone: 'semantic',
    },
    {
      german: "die Regierungschefin/den Regierungschef",
      translated: "ο επικεφαλής της κυβέρνησης",
      tone: 'semantic',
    },
    {
      german: "des Saarlandes",
      translated: "του κρατιδίου Σάαρλαντ",
      tone: 'semantic',
    },
  ],
  "lid:state:SL:9|en": [
    {
      german: "Wie nennt man",
      translated: "What is",
      tone: 'semantic',
    },
    {
      german: "die Regierungschefin/den Regierungschef",
      translated: "the head of government",
      tone: 'semantic',
    },
    {
      german: "des Saarlandes",
      translated: "in Saarland?",
      tone: 'semantic',
    },
  ],
  "lid:state:SL:9|es": [
    {
      german: "Wie nennt man",
      translated: "¿Cómo se llama",
      tone: 'semantic',
    },
    {
      german: "die Regierungschefin/den Regierungschef",
      translated: "al jefe o la jefa de gobierno",
      tone: 'semantic',
    },
    {
      german: "des Saarlandes",
      translated: "de Sarre",
      tone: 'semantic',
    },
  ],
  "lid:state:SL:9|fa": [
    {
      german: "Wie nennt man",
      translated: "رئیس دولت ایالت",
      tone: 'semantic',
    },
    {
      german: "die Regierungschefin/den Regierungschef",
      translated: "چه عنوانی",
      tone: 'semantic',
    },
    {
      german: "des Saarlandes",
      translated: "زارلاند",
      tone: 'semantic',
    },
  ],
  "lid:state:SL:9|fr": [
    {
      german: "Wie nennt man",
      translated: "Comment appelle-t-on le",
      tone: 'semantic',
    },
    {
      german: "die Regierungschefin/den Regierungschef",
      translated: "chef ou la cheffe du gouvernement",
      tone: 'semantic',
    },
    {
      german: "des Saarlandes",
      translated: "Sarre",
      tone: 'semantic',
    },
  ],
  "lid:state:SL:9|hr": [
    {
      german: "Wie nennt man",
      translated: "Kako se zove",
      tone: 'semantic',
    },
    {
      german: "die Regierungschefin/den Regierungschef",
      translated: "čelnik vlade",
      tone: 'semantic',
    },
    {
      german: "des Saarlandes",
      translated: "savezne zemlje Saarland",
      tone: 'semantic',
    },
  ],
  "lid:state:SL:9|it": [
    {
      german: "Wie nennt man",
      translated: "Come si chiama",
      tone: 'semantic',
    },
    {
      german: "die Regierungschefin/den Regierungschef",
      translated: "il capo del governo",
      tone: 'semantic',
    },
    {
      german: "des Saarlandes",
      translated: "Land di Saarland",
      tone: 'semantic',
    },
  ],
  "lid:state:SL:9|kmr": [
    {
      german: "Wie nennt man",
      translated: "Serokê",
      tone: 'semantic',
    },
    {
      german: "die Regierungschefin/den Regierungschef",
      translated: "hukûmeta",
      tone: 'semantic',
    },
    {
      german: "des Saarlandes",
      translated: "Saarland",
      tone: 'semantic',
    },
  ],
  "lid:state:SL:9|pl": [
    {
      german: "Wie nennt man",
      translated: "Jak nazywa się",
      tone: 'semantic',
    },
    {
      german: "die Regierungschefin/den Regierungschef",
      translated: "szef rządu",
      tone: 'semantic',
    },
    {
      german: "des Saarlandes",
      translated: "kraju związkowego Saara",
      tone: 'semantic',
    },
  ],
  "lid:state:SL:9|prs": [
    {
      german: "Wie nennt man",
      translated: "چه عنوانی دارد",
      tone: 'semantic',
    },
    {
      german: "die Regierungschefin/den Regierungschef",
      translated: "رئیس دولت ایالت زارلاند",
      tone: 'semantic',
    },
  ],
  "lid:state:SL:9|ro": [
    {
      german: "Wie nennt man",
      translated: "Cum se numește",
      tone: 'semantic',
    },
    {
      german: "die Regierungschefin/den Regierungschef",
      translated: "șeful guvernului landului Saarland",
      tone: 'semantic',
    },
  ],
  "lid:state:SL:9|ru": [
    {
      german: "Wie nennt man",
      translated: "Как называют",
      tone: 'semantic',
    },
    {
      german: "die Regierungschefin/den Regierungschef",
      translated: "главу правительства",
      tone: 'semantic',
    },
    {
      german: "des Saarlandes",
      translated: "в федеральной земле Саарланд",
      tone: 'semantic',
    },
  ],
  "lid:state:SL:9|sq": [
    {
      german: "Wie nennt man",
      translated: "Si quhet",
      tone: 'semantic',
    },
    {
      german: "die Regierungschefin/den Regierungschef",
      translated: "kreu i qeverisë",
      tone: 'semantic',
    },
    {
      german: "des Saarlandes",
      translated: "Saarland",
      tone: 'semantic',
    },
  ],
  "lid:state:SL:9|sr": [
    {
      german: "Wie nennt man",
      translated: "Kako se zove",
      tone: 'semantic',
    },
    {
      german: "die Regierungschefin/den Regierungschef",
      translated: "šef vlade",
      tone: 'semantic',
    },
    {
      german: "des Saarlandes",
      translated: "savezne pokrajine Saarland?",
      tone: 'semantic',
    },
  ],
  "lid:state:SL:9|tr": [
    {
      german: "Wie nennt man",
      translated: "ne ad verilir",
      tone: 'semantic',
    },
    {
      german: "die Regierungschefin/den Regierungschef",
      translated: "başındaki",
      tone: 'semantic',
    },
    {
      german: "des Saarlandes",
      translated: "Saarland",
      tone: 'semantic',
    },
  ],
  "lid:state:SL:9|uk": [
    {
      german: "Wie nennt man",
      translated: "Як називають",
      tone: 'semantic',
    },
    {
      german: "die Regierungschefin/den Regierungschef",
      translated: "главу уряду",
      tone: 'semantic',
    },
    {
      german: "des Saarlandes",
      translated: "федеральної землі Саар",
      tone: 'semantic',
    },
  ],
  "lid:state:SL:9|vi": [
    {
      german: "Wie nennt man",
      translated: "được gọi là",
      tone: 'semantic',
    },
    {
      german: "die Regierungschefin/den Regierungschef",
      translated: "Người đứng đầu chính phủ",
      tone: 'semantic',
    },
    {
      german: "des Saarlandes",
      translated: "bang Saarland",
      tone: 'semantic',
    },
  ],
  "lid:state:SN:10|ar": [
    {
      german: "Welche Ministerin/welchen Minister",
      translated: "أي وزارة من الوزارات التالية",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "على مستوى ولاية",
      tone: 'semantic',
    },
    {
      german: "Sachsen",
      translated: "Sachsen",
      tone: 'semantic',
    },
    {
      german: "nicht",
      translated: "غير موجودة",
      tone: 'semantic',
    },
  ],
  "lid:state:SN:10|bg": [
    {
      german: "Welche Ministerin/welchen Minister",
      translated: "Кой министър",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "не съществува",
      tone: 'semantic',
    },
    {
      german: "Sachsen",
      translated: "Саксония",
      tone: 'semantic',
    },
  ],
  "lid:state:SN:10|bs": [
    {
      german: "Welche Ministerin/welchen Minister",
      translated: "Koji ministar",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "ne postoji",
      tone: 'semantic',
    },
    {
      german: "Sachsen",
      translated: "Saksonija",
      tone: 'semantic',
    },
  ],
  "lid:state:SN:10|el": [
    {
      german: "Welche Ministerin/welchen Minister",
      translated: "Ποιος υπουργός",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "υπάρχει",
      tone: 'semantic',
    },
    {
      german: "Sachsen",
      translated: "στο Σαξονία",
      tone: 'semantic',
    },
    {
      german: "nicht",
      translated: "δεν",
      tone: 'semantic',
    },
  ],
  "lid:state:SN:10|en": [
    {
      german: "Welche Ministerin/welchen Minister",
      translated: "Which minister",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "does",
      tone: 'semantic',
    },
    {
      german: "Sachsen",
      translated: "Sachsen",
      tone: 'semantic',
    },
    {
      german: "nicht",
      translated: "not",
      tone: 'semantic',
    },
  ],
  "lid:state:SN:10|es": [
    {
      german: "Welche Ministerin/welchen Minister",
      translated: "¿Qué ministerio",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "existe",
      tone: 'semantic',
    },
    {
      german: "Sachsen",
      translated: "Sajonia",
      tone: 'semantic',
    },
    {
      german: "nicht",
      translated: "NO",
      tone: 'semantic',
    },
  ],
  "lid:state:SN:10|fa": [
    {
      german: "Welche Ministerin/welchen Minister",
      translated: "کدام وزیر",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "وجود ندارد",
      tone: 'semantic',
    },
    {
      german: "Sachsen",
      translated: "زاکسن",
      tone: 'semantic',
    },
  ],
  "lid:state:SN:10|fr": [
    {
      german: "Welche Ministerin/welchen Minister",
      translated: "Quel ministre ou quelle ministre",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "n’existe",
      tone: 'semantic',
    },
    {
      german: "Sachsen",
      translated: "au niveau du Land de Saxe",
      tone: 'semantic',
    },
    {
      german: "nicht",
      translated: "pas",
      tone: 'semantic',
    },
  ],
  "lid:state:SN:10|hr": [
    {
      german: "Welche Ministerin/welchen Minister",
      translated: "Koji ministar",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "ne postoji",
      tone: 'semantic',
    },
    {
      german: "Sachsen",
      translated: "Saska",
      tone: 'semantic',
    },
  ],
  "lid:state:SN:10|it": [
    {
      german: "Welche Ministerin/welchen Minister",
      translated: "Quale ministro",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "esiste",
      tone: 'semantic',
    },
    {
      german: "Sachsen",
      translated: "Land di Sassonia",
      tone: 'semantic',
    },
    {
      german: "nicht",
      translated: "non",
      tone: 'semantic',
    },
  ],
  "lid:state:SN:10|kmr": [
    {
      german: "Welche Ministerin/welchen Minister",
      translated: "Kîjan wezîr",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "tune",
      tone: 'semantic',
    },
    {
      german: "Sachsen",
      translated: "Sachsen",
      tone: 'semantic',
    },
    {
      german: "nicht",
      translated: "ye",
      tone: 'semantic',
    },
  ],
  "lid:state:SN:10|pl": [
    {
      german: "Welche Ministerin/welchen Minister",
      translated: "Którego ministra",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "nie ma",
      tone: 'semantic',
    },
    {
      german: "Sachsen",
      translated: "Saksonia",
      tone: 'semantic',
    },
    {
      german: "nicht",
      translated: "na",
      tone: 'semantic',
    },
  ],
  "lid:state:SN:10|prs": [
    {
      german: "Welche Ministerin/welchen Minister",
      translated: "کدام وزیر",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "در",
      tone: 'semantic',
    },
    {
      german: "Sachsen",
      translated: "زاکسن",
      tone: 'semantic',
    },
    {
      german: "nicht",
      translated: "وجود ندارد",
      tone: 'semantic',
    },
  ],
  "lid:state:SN:10|ro": [
    {
      german: "Welche Ministerin/welchen Minister",
      translated: "Care ministru",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "există",
      tone: 'semantic',
    },
    {
      german: "Sachsen",
      translated: "Saxonia",
      tone: 'semantic',
    },
    {
      german: "nicht",
      translated: "nu",
      tone: 'semantic',
    },
  ],
  "lid:state:SN:10|ru": [
    {
      german: "Welche Ministerin/welchen Minister",
      translated: "Какого министра",
      tone: 'semantic',
    },
    {
      german: "Sachsen",
      translated: "Саксония",
      tone: 'semantic',
    },
    {
      german: "nicht",
      translated: "нет",
      tone: 'semantic',
    },
  ],
  "lid:state:SN:10|sq": [
    {
      german: "Welche Ministerin/welchen Minister",
      translated: "Cili ministër",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "ekziston",
      tone: 'semantic',
    },
    {
      german: "Sachsen",
      translated: "nivelin e landit Sachsen",
      tone: 'semantic',
    },
    {
      german: "nicht",
      translated: "nuk",
      tone: 'semantic',
    },
  ],
  "lid:state:SN:10|sr": [
    {
      german: "Welche Ministerin/welchen Minister",
      translated: "Koji ministar",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "ne postoji",
      tone: 'semantic',
    },
    {
      german: "Sachsen",
      translated: "Saksonija",
      tone: 'semantic',
    },
  ],
  "lid:state:SN:10|tr": [
    {
      german: "Welche Ministerin/welchen Minister",
      translated: "aşağıdaki bakanlıklardan hangisi",
      tone: 'semantic',
    },
    {
      german: "Sachsen",
      translated: "Sachsen eyaletinde",
      tone: 'semantic',
    },
    {
      german: "nicht",
      translated: "yoktur",
      tone: 'semantic',
    },
  ],
  "lid:state:SN:10|uk": [
    {
      german: "Welche Ministerin/welchen Minister",
      translated: "Якого міністра/міністерки",
      tone: 'semantic',
    },
    {
      german: "Sachsen",
      translated: "Саксонія",
      tone: 'semantic',
    },
    {
      german: "nicht",
      translated: "немає",
      tone: 'semantic',
    },
  ],
  "lid:state:SN:10|vi": [
    {
      german: "Welche Ministerin/welchen Minister",
      translated: "Bộ trưởng nào",
      tone: 'semantic',
    },
    {
      german: "Sachsen",
      translated: "ở cấp bang Sachsen",
      tone: 'semantic',
    },
    {
      german: "nicht",
      translated: "không tồn tại",
      tone: 'semantic',
    },
  ],
  "lid:state:SN:1|ar": [
    {
      german: "Welches Wappen",
      translated: "أي شعار",
      tone: 'semantic',
    },
    {
      german: "gehört zum",
      translated: "من الصور",
      tone: 'semantic',
    },
    {
      german: "Freistaat Sachsen",
      translated: "Sachsen",
      tone: 'semantic',
    },
  ],
  "lid:state:SN:1|bg": [
    {
      german: "Welches Wappen",
      translated: "Кой герб",
      tone: 'semantic',
    },
    {
      german: "gehört zum",
      translated: "принадлежи на",
      tone: 'semantic',
    },
    {
      german: "Freistaat Sachsen",
      translated: "Саксония",
      tone: 'semantic',
    },
  ],
  "lid:state:SN:1|bs": [
    {
      german: "Welches Wappen",
      translated: "Koji grb",
      tone: 'semantic',
    },
    {
      german: "gehört zum",
      translated: "pripada",
      tone: 'semantic',
    },
    {
      german: "Freistaat Sachsen",
      translated: "Slobodnoj Državi Saksoniji",
      tone: 'semantic',
    },
  ],
  "lid:state:SN:1|el": [
    {
      german: "Welches Wappen",
      translated: "Ποιο έμβλημα",
      tone: 'semantic',
    },
    {
      german: "gehört zum",
      translated: "ανήκει στο",
      tone: 'semantic',
    },
    {
      german: "Freistaat Sachsen",
      translated: "ομόσπονδο κρατίδιο Σαξονία",
      tone: 'semantic',
    },
  ],
  "lid:state:SN:1|en": [
    {
      german: "Welches Wappen",
      translated: "Which coat of arms",
      tone: 'semantic',
    },
    {
      german: "gehört zum",
      translated: "belongs to the",
      tone: 'semantic',
    },
    {
      german: "Freistaat Sachsen",
      translated: "Free State of Sachsen",
      tone: 'semantic',
    },
  ],
  "lid:state:SN:1|es": [
    {
      german: "Welches Wappen",
      translated: "¿Qué escudo",
      tone: 'semantic',
    },
    {
      german: "gehört zum",
      translated: "pertenece al",
      tone: 'semantic',
    },
    {
      german: "Freistaat Sachsen",
      translated: "estado federado de Sajonia",
      tone: 'semantic',
    },
  ],
  "lid:state:SN:1|fa": [
    {
      german: "Welches Wappen",
      translated: "نشان",
      tone: 'semantic',
    },
    {
      german: "gehört zum",
      translated: "متعلق به",
      tone: 'semantic',
    },
    {
      german: "Freistaat Sachsen",
      translated: "ایالت زاکسن",
      tone: 'semantic',
    },
  ],
  "lid:state:SN:1|fr": [
    {
      german: "Welches Wappen",
      translated: "Quel blason",
      tone: 'semantic',
    },
    {
      german: "gehört zum",
      translated: "appartient au",
      tone: 'semantic',
    },
    {
      german: "Freistaat Sachsen",
      translated: "Land de Saxe",
      tone: 'semantic',
    },
  ],
  "lid:state:SN:1|hr": [
    {
      german: "Welches Wappen",
      translated: "Koji grb",
      tone: 'semantic',
    },
    {
      german: "gehört zum",
      translated: "pripada",
      tone: 'semantic',
    },
    {
      german: "Freistaat Sachsen",
      translated: "saveznoj zemlji Saska",
      tone: 'semantic',
    },
  ],
  "lid:state:SN:1|it": [
    {
      german: "Welches Wappen",
      translated: "Quale stemma",
      tone: 'semantic',
    },
    {
      german: "gehört zum",
      translated: "appartiene al",
      tone: 'semantic',
    },
    {
      german: "Freistaat Sachsen",
      translated: "Land di Sassonia",
      tone: 'semantic',
    },
  ],
  "lid:state:SN:1|kmr": [
    {
      german: "Welches Wappen",
      translated: "Kîjan nîşan",
      tone: 'semantic',
    },
    {
      german: "gehört zum",
      translated: "a",
      tone: 'semantic',
    },
    {
      german: "Freistaat Sachsen",
      translated: "Dewleta Azad a Sachsen",
      tone: 'semantic',
    },
  ],
  "lid:state:SN:1|pl": [
    {
      german: "Welches Wappen",
      translated: "Który herb",
      tone: 'semantic',
    },
    {
      german: "gehört zum",
      translated: "należy do",
      tone: 'semantic',
    },
    {
      german: "Freistaat Sachsen",
      translated: "Saksonia",
      tone: 'semantic',
    },
  ],
  "lid:state:SN:1|prs": [
    {
      german: "Welches Wappen",
      translated: "کدام نشان",
      tone: 'semantic',
    },
    {
      german: "gehört zum",
      translated: "متعلق به",
      tone: 'semantic',
    },
    {
      german: "Freistaat Sachsen",
      translated: "ایالت زاکسن",
      tone: 'semantic',
    },
  ],
  "lid:state:SN:1|ro": [
    {
      german: "Welches Wappen",
      translated: "Care stemă",
      tone: 'semantic',
    },
    {
      german: "gehört zum",
      translated: "aparține",
      tone: 'semantic',
    },
    {
      german: "Freistaat Sachsen",
      translated: "landului Saxonia",
      tone: 'semantic',
    },
  ],
  "lid:state:SN:1|ru": [
    {
      german: "Welches Wappen",
      translated: "Какой герб",
      tone: 'semantic',
    },
    {
      german: "gehört zum",
      translated: "принадлежит свободному государству",
      tone: 'semantic',
    },
    {
      german: "Freistaat Sachsen",
      translated: "Саксония",
      tone: 'semantic',
    },
  ],
  "lid:state:SN:1|sq": [
    {
      german: "Welches Wappen",
      translated: "Cila stemë",
      tone: 'semantic',
    },
    {
      german: "gehört zum",
      translated: "i përket",
      tone: 'semantic',
    },
    {
      german: "Freistaat Sachsen",
      translated: "landit Sachsen",
      tone: 'semantic',
    },
  ],
  "lid:state:SN:1|sr": [
    {
      german: "Welches Wappen",
      translated: "Koji grb",
      tone: 'semantic',
    },
    {
      german: "gehört zum",
      translated: "pripada",
      tone: 'semantic',
    },
    {
      german: "Freistaat Sachsen",
      translated: "Slobodnoj Državi Saksoniji",
      tone: 'semantic',
    },
  ],
  "lid:state:SN:1|tr": [
    {
      german: "Welches Wappen",
      translated: "arması hangisidir",
      tone: 'semantic',
    },
    {
      german: "Freistaat Sachsen",
      translated: "Saksonya Özgür Devleti'nin",
      tone: 'semantic',
    },
  ],
  "lid:state:SN:1|uk": [
    {
      german: "Welches Wappen",
      translated: "Який герб",
      tone: 'semantic',
    },
    {
      german: "gehört zum",
      translated: "належить",
      tone: 'semantic',
    },
    {
      german: "Freistaat Sachsen",
      translated: "Вільній державі Саксонія?",
      tone: 'semantic',
    },
  ],
  "lid:state:SN:1|vi": [
    {
      german: "Welches Wappen",
      translated: "Quốc huy nào",
      tone: 'semantic',
    },
    {
      german: "gehört zum",
      translated: "thuộc",
      tone: 'semantic',
    },
    {
      german: "Freistaat Sachsen",
      translated: "Bang Tự do Sachsen",
      tone: 'semantic',
    },
  ],
  "lid:state:SN:2|ar": [
    {
      german: "Welches ist",
      translated: "أي مما يلي",
      tone: 'semantic',
    },
    {
      german: "ein Landkreis",
      translated: "دائرة إدارية (Landkreis)",
      tone: 'semantic',
    },
    {
      german: "in Sachsen",
      translated: "في Sachsen",
      tone: 'semantic',
    },
  ],
  "lid:state:SN:2|bg": [
    {
      german: "Welches ist",
      translated: "Кое",
      tone: 'semantic',
    },
    {
      german: "ein Landkreis",
      translated: "окръг",
      tone: 'semantic',
    },
    {
      german: "in Sachsen",
      translated: "в Саксония",
      tone: 'semantic',
    },
  ],
  "lid:state:SN:2|bs": [
    {
      german: "Welches ist",
      translated: "Što je",
      tone: 'semantic',
    },
    {
      german: "ein Landkreis",
      translated: "od navedenoga okrug (Landkreis)",
      tone: 'semantic',
    },
    {
      german: "in Sachsen",
      translated: "u saveznoj zemlji Saksonija",
      tone: 'semantic',
    },
  ],
  "lid:state:SN:2|el": [
    {
      german: "Welches ist",
      translated: "Ποιο",
      tone: 'semantic',
    },
    {
      german: "ein Landkreis",
      translated: "διοικητική περιφέρεια (Landkreis)",
      tone: 'semantic',
    },
    {
      german: "in Sachsen",
      translated: "στο Σαξονία",
      tone: 'semantic',
    },
  ],
  "lid:state:SN:2|en": [
    {
      german: "Welches ist",
      translated: "Which is",
      tone: 'semantic',
    },
    {
      german: "ein Landkreis",
      translated: "a district",
      tone: 'semantic',
    },
    {
      german: "in Sachsen",
      translated: "in Sachsen",
      tone: 'semantic',
    },
  ],
  "lid:state:SN:2|es": [
    {
      german: "Welches ist",
      translated: "¿Cuál de los siguientes es",
      tone: 'semantic',
    },
    {
      german: "ein Landkreis",
      translated: "un distrito (Landkreis)",
      tone: 'semantic',
    },
    {
      german: "in Sachsen",
      translated: "de Sajonia",
      tone: 'semantic',
    },
  ],
  "lid:state:SN:2|fa": [
    {
      german: "Welches ist",
      translated: "کدام‌یک از",
      tone: 'semantic',
    },
    {
      german: "ein Landkreis",
      translated: "یک شهرستان",
      tone: 'semantic',
    },
    {
      german: "in Sachsen",
      translated: "در زاکسن",
      tone: 'semantic',
    },
  ],
  "lid:state:SN:2|fr": [
    {
      german: "Welches ist",
      translated: "Lequel des",
      tone: 'semantic',
    },
    {
      german: "ein Landkreis",
      translated: "un arrondissement (Landkreis)",
      tone: 'semantic',
    },
    {
      german: "in Sachsen",
      translated: "de Saxe",
      tone: 'semantic',
    },
  ],
  "lid:state:SN:2|hr": [
    {
      german: "Welches ist",
      translated: "Što je od navedenoga",
      tone: 'semantic',
    },
    {
      german: "ein Landkreis",
      translated: "okrug (Landkreis)",
      tone: 'semantic',
    },
    {
      german: "in Sachsen",
      translated: "u saveznoj zemlji Saska",
      tone: 'semantic',
    },
  ],
  "lid:state:SN:2|it": [
    {
      german: "Welches ist",
      translated: "Quale dei seguenti è",
      tone: 'semantic',
    },
    {
      german: "ein Landkreis",
      translated: "un distretto (Landkreis)",
      tone: 'semantic',
    },
    {
      german: "in Sachsen",
      translated: "di Sassonia",
      tone: 'semantic',
    },
  ],
  "lid:state:SN:2|kmr": [
    {
      german: "Welches ist",
      translated: "Kîjan ji",
      tone: 'semantic',
    },
    {
      german: "ein Landkreis",
      translated: "van navçeyek (Landkreis)",
      tone: 'semantic',
    },
    {
      german: "in Sachsen",
      translated: "li Sachsen ye",
      tone: 'semantic',
    },
  ],
  "lid:state:SN:2|pl": [
    {
      german: "Welches ist",
      translated: "Który z poniższych jest",
      tone: 'semantic',
    },
    {
      german: "ein Landkreis",
      translated: "powiatem (Landkreis)",
      tone: 'semantic',
    },
    {
      german: "in Sachsen",
      translated: "w Saksonia",
      tone: 'semantic',
    },
  ],
  "lid:state:SN:2|prs": [
    {
      german: "Welches ist",
      translated: "کدام‌یک از",
      tone: 'semantic',
    },
    {
      german: "ein Landkreis",
      translated: "شهرستان",
      tone: 'semantic',
    },
    {
      german: "in Sachsen",
      translated: "زاکسن",
      tone: 'semantic',
    },
  ],
  "lid:state:SN:2|ro": [
    {
      german: "Welches ist",
      translated: "Care dintre următoarele este",
      tone: 'semantic',
    },
    {
      german: "ein Landkreis",
      translated: "district (Landkreis)",
      tone: 'semantic',
    },
    {
      german: "in Sachsen",
      translated: "din Saxonia?",
      tone: 'semantic',
    },
  ],
  "lid:state:SN:2|ru": [
    {
      german: "Welches ist",
      translated: "Какой из перечисленных",
      tone: 'semantic',
    },
    {
      german: "ein Landkreis",
      translated: "районом",
      tone: 'semantic',
    },
    {
      german: "in Sachsen",
      translated: "в федеральной земле Саксония",
      tone: 'semantic',
    },
  ],
  "lid:state:SN:2|sq": [
    {
      german: "Welches ist",
      translated: "Cila nga këto është",
      tone: 'semantic',
    },
    {
      german: "ein Landkreis",
      translated: "një qark (Landkreis)",
      tone: 'semantic',
    },
    {
      german: "in Sachsen",
      translated: "në Sachsen",
      tone: 'semantic',
    },
  ],
  "lid:state:SN:2|sr": [
    {
      german: "Welches ist",
      translated: "Šta je od navedenoga",
      tone: 'semantic',
    },
    {
      german: "ein Landkreis",
      translated: "okrug (Landkreis)",
      tone: 'semantic',
    },
    {
      german: "in Sachsen",
      translated: "u saveznoj pokrajini Saksonija",
      tone: 'semantic',
    },
  ],
  "lid:state:SN:2|tr": [
    {
      german: "Welches ist",
      translated: "Aşağıdakilerden hangisi",
      tone: 'semantic',
    },
    {
      german: "ein Landkreis",
      translated: "bir Landkreis (ilçe/idari bölge)dir",
      tone: 'semantic',
    },
    {
      german: "in Sachsen",
      translated: "Sachsen eyaletinde bulunan",
      tone: 'semantic',
    },
  ],
  "lid:state:SN:2|uk": [
    {
      german: "Welches ist",
      translated: "Який із",
      tone: 'semantic',
    },
    {
      german: "ein Landkreis",
      translated: "наведених районів",
      tone: 'semantic',
    },
    {
      german: "in Sachsen",
      translated: "у федеральній землі Саксонія",
      tone: 'semantic',
    },
  ],
  "lid:state:SN:2|vi": [
    {
      german: "Welches ist",
      translated: "Địa danh nào sau đây là",
      tone: 'semantic',
    },
    {
      german: "ein Landkreis",
      translated: "một huyện (Landkreis)",
      tone: 'semantic',
    },
    {
      german: "in Sachsen",
      translated: "của bang Sachsen",
      tone: 'semantic',
    },
  ],
  "lid:state:SN:3|ar": [
    {
      german: "Für wie viele Jahre",
      translated: "لمدة كم سنة",
      tone: 'semantic',
    },
    {
      german: "der Landtag",
      translated: "برلمان الولاية",
      tone: 'semantic',
    },
    {
      german: "in Sachsen",
      translated: "في Sachsen",
      tone: 'semantic',
    },
    {
      german: "gewählt",
      translated: "يُنتخب",
      tone: 'semantic',
    },
  ],
  "lid:state:SN:3|bg": [
    {
      german: "Für wie viele Jahre",
      translated: "За колко години",
      tone: 'semantic',
    },
    {
      german: "der Landtag",
      translated: "парламентът",
      tone: 'semantic',
    },
    {
      german: "in Sachsen",
      translated: "на провинция Саксония",
      tone: 'semantic',
    },
    {
      german: "gewählt",
      translated: "се избира",
      tone: 'semantic',
    },
  ],
  "lid:state:SN:3|bs": [
    {
      german: "Für wie viele Jahre",
      translated: "koliko se godina",
      tone: 'semantic',
    },
    {
      german: "der Landtag",
      translated: "parlament",
      tone: 'semantic',
    },
    {
      german: "in Sachsen",
      translated: "savezne zemlje Saksonija",
      tone: 'semantic',
    },
    {
      german: "gewählt",
      translated: "bira",
      tone: 'semantic',
    },
  ],
  "lid:state:SN:3|el": [
    {
      german: "Für wie viele Jahre",
      translated: "Για πόσα χρόνια",
      tone: 'semantic',
    },
    {
      german: "der Landtag",
      translated: "το Landtag",
      tone: 'semantic',
    },
    {
      german: "in Sachsen",
      translated: "του Σαξονία",
      tone: 'semantic',
    },
    {
      german: "gewählt",
      translated: "εκλέγεται",
      tone: 'semantic',
    },
  ],
  "lid:state:SN:3|en": [
    {
      german: "Für wie viele Jahre",
      translated: "For how many years",
      tone: 'semantic',
    },
    {
      german: "der Landtag",
      translated: "the state parliament",
      tone: 'semantic',
    },
    {
      german: "in Sachsen",
      translated: "in Sachsen",
      tone: 'semantic',
    },
    {
      german: "gewählt",
      translated: "elected",
      tone: 'semantic',
    },
  ],
  "lid:state:SN:3|es": [
    {
      german: "Für wie viele Jahre",
      translated: "Por cuántos años",
      tone: 'semantic',
    },
    {
      german: "der Landtag",
      translated: "el parlamento regional",
      tone: 'semantic',
    },
    {
      german: "in Sachsen",
      translated: "en Sajonia",
      tone: 'semantic',
    },
    {
      german: "gewählt",
      translated: "se elige",
      tone: 'semantic',
    },
  ],
  "lid:state:SN:3|fa": [
    {
      german: "Für wie viele Jahre",
      translated: "برای چند سال",
      tone: 'semantic',
    },
    {
      german: "der Landtag",
      translated: "پارلمان ایالتی زاکسن",
      tone: 'semantic',
    },
    {
      german: "gewählt",
      translated: "انتخاب می‌شود",
      tone: 'semantic',
    },
  ],
  "lid:state:SN:3|fr": [
    {
      german: "Für wie viele Jahre",
      translated: "Pour combien d’années",
      tone: 'semantic',
    },
    {
      german: "der Landtag",
      translated: "le Landtag",
      tone: 'semantic',
    },
    {
      german: "in Sachsen",
      translated: "de Saxe",
      tone: 'semantic',
    },
    {
      german: "gewählt",
      translated: "est-il élu",
      tone: 'semantic',
    },
  ],
  "lid:state:SN:3|hr": [
    {
      german: "Für wie viele Jahre",
      translated: "Na koliko se godina",
      tone: 'semantic',
    },
    {
      german: "der Landtag",
      translated: "parlament",
      tone: 'semantic',
    },
    {
      german: "in Sachsen",
      translated: "savezne zemlje Saska",
      tone: 'semantic',
    },
    {
      german: "gewählt",
      translated: "bira",
      tone: 'semantic',
    },
  ],
  "lid:state:SN:3|it": [
    {
      german: "Für wie viele Jahre",
      translated: "Per quanti anni",
      tone: 'semantic',
    },
    {
      german: "der Landtag",
      translated: "il Landtag",
      tone: 'semantic',
    },
    {
      german: "in Sachsen",
      translated: "di Sassonia",
      tone: 'semantic',
    },
    {
      german: "gewählt",
      translated: "viene eletto",
      tone: 'semantic',
    },
  ],
  "lid:state:SN:3|kmr": [
    {
      german: "Für wie viele Jahre",
      translated: "çend salan",
      tone: 'semantic',
    },
    {
      german: "der Landtag",
      translated: "Landtag",
      tone: 'semantic',
    },
    {
      german: "in Sachsen",
      translated: "a Sachsen",
      tone: 'semantic',
    },
    {
      german: "gewählt",
      translated: "hilbijartin",
      tone: 'semantic',
    },
  ],
  "lid:state:SN:3|pl": [
    {
      german: "Für wie viele Jahre",
      translated: "Na ile lat",
      tone: 'semantic',
    },
    {
      german: "der Landtag",
      translated: "parlament",
      tone: 'semantic',
    },
    {
      german: "in Sachsen",
      translated: "kraju związkowego Saksonia",
      tone: 'semantic',
    },
    {
      german: "gewählt",
      translated: "wybierany jest",
      tone: 'semantic',
    },
  ],
  "lid:state:SN:3|prs": [
    {
      german: "Für wie viele Jahre",
      translated: "چند سال",
      tone: 'semantic',
    },
    {
      german: "der Landtag",
      translated: "پارلمان ایالتی",
      tone: 'semantic',
    },
    {
      german: "in Sachsen",
      translated: "زاکسن",
      tone: 'semantic',
    },
    {
      german: "gewählt",
      translated: "انتخاب می‌شود",
      tone: 'semantic',
    },
  ],
  "lid:state:SN:3|ro": [
    {
      german: "Für wie viele Jahre",
      translated: "Pentru câți ani",
      tone: 'semantic',
    },
    {
      german: "der Landtag",
      translated: "parlamentul landului",
      tone: 'semantic',
    },
    {
      german: "in Sachsen",
      translated: "Saxonia",
      tone: 'semantic',
    },
    {
      german: "gewählt",
      translated: "ales",
      tone: 'semantic',
    },
  ],
  "lid:state:SN:3|ru": [
    {
      german: "Für wie viele Jahre",
      translated: "На сколько лет",
      tone: 'semantic',
    },
    {
      german: "der Landtag",
      translated: "ландтаг",
      tone: 'semantic',
    },
    {
      german: "in Sachsen",
      translated: "в федеральной земле Саксония",
      tone: 'semantic',
    },
    {
      german: "gewählt",
      translated: "избирается",
      tone: 'semantic',
    },
  ],
  "lid:state:SN:3|sq": [
    {
      german: "Für wie viele Jahre",
      translated: "Për sa vjet",
      tone: 'semantic',
    },
    {
      german: "der Landtag",
      translated: "Landtagu",
      tone: 'semantic',
    },
    {
      german: "in Sachsen",
      translated: "i Sachsen",
      tone: 'semantic',
    },
    {
      german: "gewählt",
      translated: "zgjidhet",
      tone: 'semantic',
    },
  ],
  "lid:state:SN:3|sr": [
    {
      german: "Für wie viele Jahre",
      translated: "koliko se godina",
      tone: 'semantic',
    },
    {
      german: "der Landtag",
      translated: "parlament savezne pokrajine",
      tone: 'semantic',
    },
    {
      german: "in Sachsen",
      translated: "Saksonija",
      tone: 'semantic',
    },
    {
      german: "gewählt",
      translated: "bira",
      tone: 'semantic',
    },
  ],
  "lid:state:SN:3|tr": [
    {
      german: "Für wie viele Jahre",
      translated: "kaç yıllığına",
      tone: 'semantic',
    },
    {
      german: "der Landtag",
      translated: "eyalet parlamentosu",
      tone: 'semantic',
    },
    {
      german: "in Sachsen",
      translated: "Sachsen",
      tone: 'semantic',
    },
    {
      german: "gewählt",
      translated: "seçilir",
      tone: 'semantic',
    },
  ],
  "lid:state:SN:3|uk": [
    {
      german: "Für wie viele Jahre",
      translated: "На скільки років",
      tone: 'semantic',
    },
    {
      german: "der Landtag",
      translated: "земельний парламент",
      tone: 'semantic',
    },
    {
      german: "in Sachsen",
      translated: "у федеральній землі Саксонія",
      tone: 'semantic',
    },
    {
      german: "gewählt",
      translated: "обирають",
      tone: 'semantic',
    },
  ],
  "lid:state:SN:3|vi": [
    {
      german: "Für wie viele Jahre",
      translated: "nhiệm kỳ bao nhiêu năm",
      tone: 'semantic',
    },
    {
      german: "der Landtag",
      translated: "Nghị viện bang (Landtag)",
      tone: 'semantic',
    },
    {
      german: "in Sachsen",
      translated: "của Sachsen",
      tone: 'semantic',
    },
    {
      german: "gewählt",
      translated: "được bầu",
      tone: 'semantic',
    },
  ],
  "lid:state:SN:4|ar": [
    {
      german: "Ab welchem Alter",
      translated: "ابتداءً من أي سن",
      tone: 'semantic',
    },
    {
      german: "darf man",
      translated: "يحق",
      tone: 'semantic',
    },
    {
      german: "in Sachsen",
      translated: "في Sachsen",
      tone: 'semantic',
    },
    {
      german: "bei Kommunalwahlen",
      translated: "في الانتخابات المحلية",
      tone: 'semantic',
    },
    {
      german: "wählen",
      translated: "التصويت",
      tone: 'semantic',
    },
  ],
  "lid:state:SN:4|bg": [
    {
      german: "Ab welchem Alter",
      translated: "От каква възраст",
      tone: 'semantic',
    },
    {
      german: "darf man",
      translated: "може да се",
      tone: 'semantic',
    },
    {
      german: "in Sachsen",
      translated: "в Саксония",
      tone: 'semantic',
    },
    {
      german: "bei Kommunalwahlen",
      translated: "на общински избори",
      tone: 'semantic',
    },
    {
      german: "wählen",
      translated: "гласува",
      tone: 'semantic',
    },
  ],
  "lid:state:SN:4|bs": [
    {
      german: "Ab welchem Alter",
      translated: "Od koje se dobi",
      tone: 'semantic',
    },
    {
      german: "darf man",
      translated: "može",
      tone: 'semantic',
    },
    {
      german: "in Sachsen",
      translated: "u saveznoj zemlji Saksonija",
      tone: 'semantic',
    },
    {
      german: "bei Kommunalwahlen",
      translated: "na lokalnim izborima",
      tone: 'semantic',
    },
    {
      german: "wählen",
      translated: "glasovati",
      tone: 'semantic',
    },
  ],
  "lid:state:SN:4|el": [
    {
      german: "Ab welchem Alter",
      translated: "Από ποια ηλικία",
      tone: 'semantic',
    },
    {
      german: "darf man",
      translated: "μπορεί κάποιος",
      tone: 'semantic',
    },
    {
      german: "in Sachsen",
      translated: "στο Σαξονία",
      tone: 'semantic',
    },
    {
      german: "bei Kommunalwahlen",
      translated: "στις δημοτικές εκλογές",
      tone: 'semantic',
    },
    {
      german: "wählen",
      translated: "να ψηφίσει",
      tone: 'semantic',
    },
  ],
  "lid:state:SN:4|en": [
    {
      german: "Ab welchem Alter",
      translated: "From what age",
      tone: 'semantic',
    },
    {
      german: "darf man",
      translated: "can you",
      tone: 'semantic',
    },
    {
      german: "in Sachsen",
      translated: "in Sachsen",
      tone: 'semantic',
    },
    {
      german: "bei Kommunalwahlen",
      translated: "in local elections",
      tone: 'semantic',
    },
    {
      german: "wählen",
      translated: "vote",
      tone: 'semantic',
    },
  ],
  "lid:state:SN:4|es": [
    {
      german: "Ab welchem Alter",
      translated: "A partir de qué edad",
      tone: 'semantic',
    },
    {
      german: "darf man",
      translated: "se puede",
      tone: 'semantic',
    },
    {
      german: "in Sachsen",
      translated: "de Sajonia",
      tone: 'semantic',
    },
    {
      german: "bei Kommunalwahlen",
      translated: "en las elecciones municipales",
      tone: 'semantic',
    },
    {
      german: "wählen",
      translated: "votar",
      tone: 'semantic',
    },
  ],
  "lid:state:SN:4|fa": [
    {
      german: "Ab welchem Alter",
      translated: "از چه سنی",
      tone: 'semantic',
    },
    {
      german: "darf man",
      translated: "می‌توان",
      tone: 'semantic',
    },
    {
      german: "in Sachsen",
      translated: "زاکسن",
      tone: 'semantic',
    },
    {
      german: "bei Kommunalwahlen",
      translated: "در انتخابات محلی",
      tone: 'semantic',
    },
    {
      german: "wählen",
      translated: "رأی داد",
      tone: 'semantic',
    },
  ],
  "lid:state:SN:4|fr": [
    {
      german: "Ab welchem Alter",
      translated: "À partir de quel âge",
      tone: 'semantic',
    },
    {
      german: "darf man",
      translated: "peut-on",
      tone: 'semantic',
    },
    {
      german: "in Sachsen",
      translated: "en Saxe",
      tone: 'semantic',
    },
    {
      german: "bei Kommunalwahlen",
      translated: "aux élections municipales",
      tone: 'semantic',
    },
    {
      german: "wählen",
      translated: "voter",
      tone: 'semantic',
    },
  ],
  "lid:state:SN:4|hr": [
    {
      german: "Ab welchem Alter",
      translated: "Od koje se dobi",
      tone: 'semantic',
    },
    {
      german: "darf man",
      translated: "može",
      tone: 'semantic',
    },
    {
      german: "in Sachsen",
      translated: "u saveznoj zemlji Saska",
      tone: 'semantic',
    },
    {
      german: "bei Kommunalwahlen",
      translated: "na lokalnim izborima",
      tone: 'semantic',
    },
    {
      german: "wählen",
      translated: "glasovati",
      tone: 'semantic',
    },
  ],
  "lid:state:SN:4|it": [
    {
      german: "Ab welchem Alter",
      translated: "Da quale età",
      tone: 'semantic',
    },
    {
      german: "darf man",
      translated: "si può",
      tone: 'semantic',
    },
    {
      german: "in Sachsen",
      translated: "in Sassonia",
      tone: 'semantic',
    },
    {
      german: "bei Kommunalwahlen",
      translated: "alle elezioni comunali",
      tone: 'semantic',
    },
    {
      german: "wählen",
      translated: "votare",
      tone: 'semantic',
    },
  ],
  "lid:state:SN:4|kmr": [
    {
      german: "Ab welchem Alter",
      translated: "Ji kîjan temenê",
      tone: 'semantic',
    },
    {
      german: "darf man",
      translated: "dikare",
      tone: 'semantic',
    },
    {
      german: "in Sachsen",
      translated: "li Sachsen",
      tone: 'semantic',
    },
    {
      german: "bei Kommunalwahlen",
      translated: "di hilbijartinên şaredariyê de",
      tone: 'semantic',
    },
    {
      german: "wählen",
      translated: "deng were dayîn",
      tone: 'semantic',
    },
  ],
  "lid:state:SN:4|pl": [
    {
      german: "Ab welchem Alter",
      translated: "Od jakiego wieku",
      tone: 'semantic',
    },
    {
      german: "darf man",
      translated: "można",
      tone: 'semantic',
    },
    {
      german: "in Sachsen",
      translated: "w Saksonia",
      tone: 'semantic',
    },
    {
      german: "bei Kommunalwahlen",
      translated: "w wyborach samorządowych",
      tone: 'semantic',
    },
    {
      german: "wählen",
      translated: "głosować",
      tone: 'semantic',
    },
  ],
  "lid:state:SN:4|prs": [
    {
      german: "Ab welchem Alter",
      translated: "از چه سنی",
      tone: 'semantic',
    },
    {
      german: "darf man",
      translated: "می‌توان",
      tone: 'semantic',
    },
    {
      german: "in Sachsen",
      translated: "زاکسن",
      tone: 'semantic',
    },
    {
      german: "bei Kommunalwahlen",
      translated: "در انتخابات شاروالی",
      tone: 'semantic',
    },
    {
      german: "wählen",
      translated: "رأی داد",
      tone: 'semantic',
    },
  ],
  "lid:state:SN:4|ro": [
    {
      german: "Ab welchem Alter",
      translated: "De la ce vârstă",
      tone: 'semantic',
    },
    {
      german: "darf man",
      translated: "se poate",
      tone: 'semantic',
    },
    {
      german: "in Sachsen",
      translated: "din Saxonia",
      tone: 'semantic',
    },
    {
      german: "bei Kommunalwahlen",
      translated: "la alegerile locale",
      tone: 'semantic',
    },
    {
      german: "wählen",
      translated: "vota",
      tone: 'semantic',
    },
  ],
  "lid:state:SN:4|ru": [
    {
      german: "Ab welchem Alter",
      translated: "С какого возраста",
      tone: 'semantic',
    },
    {
      german: "darf man",
      translated: "можно",
      tone: 'semantic',
    },
    {
      german: "in Sachsen",
      translated: "в федеральной земле Саксония",
      tone: 'semantic',
    },
    {
      german: "bei Kommunalwahlen",
      translated: "на муниципальных выборах",
      tone: 'semantic',
    },
    {
      german: "wählen",
      translated: "голосовать",
      tone: 'semantic',
    },
  ],
  "lid:state:SN:4|sq": [
    {
      german: "Ab welchem Alter",
      translated: "Nga cila moshë",
      tone: 'semantic',
    },
    {
      german: "darf man",
      translated: "mund të",
      tone: 'semantic',
    },
    {
      german: "in Sachsen",
      translated: "në Sachsen",
      tone: 'semantic',
    },
    {
      german: "bei Kommunalwahlen",
      translated: "në zgjedhjet komunale",
      tone: 'semantic',
    },
    {
      german: "wählen",
      translated: "votohet",
      tone: 'semantic',
    },
  ],
  "lid:state:SN:4|sr": [
    {
      german: "Ab welchem Alter",
      translated: "Od koje se dobi",
      tone: 'semantic',
    },
    {
      german: "darf man",
      translated: "može glasati",
      tone: 'semantic',
    },
    {
      german: "in Sachsen",
      translated: "u saveznoj pokrajini Saksonija",
      tone: 'semantic',
    },
    {
      german: "bei Kommunalwahlen",
      translated: "na lokalnim izborima",
      tone: 'semantic',
    },
  ],
  "lid:state:SN:4|tr": [
    {
      german: "Ab welchem Alter",
      translated: "kaç yaşından itibaren",
      tone: 'semantic',
    },
    {
      german: "darf man",
      translated: "oy kullanılabilir",
      tone: 'semantic',
    },
    {
      german: "in Sachsen",
      translated: "Sachsen eyaletinde",
      tone: 'semantic',
    },
    {
      german: "bei Kommunalwahlen",
      translated: "yerel seçimlerde",
      tone: 'semantic',
    },
  ],
  "lid:state:SN:4|uk": [
    {
      german: "Ab welchem Alter",
      translated: "З якого віку",
      tone: 'semantic',
    },
    {
      german: "in Sachsen",
      translated: "у федеральній землі Саксонія",
      tone: 'semantic',
    },
    {
      german: "bei Kommunalwahlen",
      translated: "на муніципальних виборах",
      tone: 'semantic',
    },
    {
      german: "wählen",
      translated: "можна голосувати",
      tone: 'semantic',
    },
  ],
  "lid:state:SN:4|vi": [
    {
      german: "Ab welchem Alter",
      translated: "Từ bao nhiêu tuổi",
      tone: 'semantic',
    },
    {
      german: "darf man",
      translated: "có thể",
      tone: 'semantic',
    },
    {
      german: "in Sachsen",
      translated: "ở bang Sachsen",
      tone: 'semantic',
    },
    {
      german: "bei Kommunalwahlen",
      translated: "trong bầu cử địa phương",
      tone: 'semantic',
    },
    {
      german: "wählen",
      translated: "bỏ phiếu",
      tone: 'semantic',
    },
  ],
  "lid:state:SN:5|ar": [
    {
      german: "Welche Farben",
      translated: "ما ألوان",
      tone: 'semantic',
    },
    {
      german: "die Landesflagge",
      translated: "علم",
      tone: 'semantic',
    },
    {
      german: "von Sachsen",
      translated: "ولاية Sachsen",
      tone: 'semantic',
    },
  ],
  "lid:state:SN:5|bg": [
    {
      german: "Welche Farben",
      translated: "Какви са цветовете",
      tone: 'semantic',
    },
    {
      german: "die Landesflagge",
      translated: "на знамето",
      tone: 'semantic',
    },
    {
      german: "von Sachsen",
      translated: "на провинция Саксония",
      tone: 'semantic',
    },
  ],
  "lid:state:SN:5|bs": [
    {
      german: "Welche Farben",
      translated: "Koje su boje",
      tone: 'semantic',
    },
    {
      german: "die Landesflagge",
      translated: "zastave",
      tone: 'semantic',
    },
    {
      german: "von Sachsen",
      translated: "savezne zemlje Saksonija",
      tone: 'semantic',
    },
  ],
  "lid:state:SN:5|el": [
    {
      german: "Welche Farben",
      translated: "Ποια είναι τα χρώματα",
      tone: 'semantic',
    },
    {
      german: "die Landesflagge",
      translated: "της σημαίας του κρατιδίου",
      tone: 'semantic',
    },
    {
      german: "von Sachsen",
      translated: "Σαξονία",
      tone: 'semantic',
    },
  ],
  "lid:state:SN:5|en": [
    {
      german: "Welche Farben",
      translated: "What colors",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "does",
      tone: 'semantic',
    },
    {
      german: "die Landesflagge",
      translated: "state flag",
      tone: 'semantic',
    },
    {
      german: "von Sachsen",
      translated: "of Sachsen",
      tone: 'semantic',
    },
  ],
  "lid:state:SN:5|es": [
    {
      german: "Welche Farben",
      translated: "¿Qué colores",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "tiene",
      tone: 'semantic',
    },
    {
      german: "die Landesflagge",
      translated: "bandera regional",
      tone: 'semantic',
    },
    {
      german: "von Sachsen",
      translated: "de Sajonia",
      tone: 'semantic',
    },
  ],
  "lid:state:SN:5|fa": [
    {
      german: "Welche Farben",
      translated: "رنگ‌های",
      tone: 'semantic',
    },
    {
      german: "die Landesflagge",
      translated: "پرچم ایالت",
      tone: 'semantic',
    },
    {
      german: "von Sachsen",
      translated: "زاکسن",
      tone: 'semantic',
    },
  ],
  "lid:state:SN:5|fr": [
    {
      german: "Welche Farben",
      translated: "Quelles sont les couleurs",
      tone: 'semantic',
    },
    {
      german: "die Landesflagge",
      translated: "du drapeau du Land",
      tone: 'semantic',
    },
    {
      german: "von Sachsen",
      translated: "de Saxe",
      tone: 'semantic',
    },
  ],
  "lid:state:SN:5|hr": [
    {
      german: "Welche Farben",
      translated: "Koje su boje",
      tone: 'semantic',
    },
    {
      german: "die Landesflagge",
      translated: "zastave",
      tone: 'semantic',
    },
    {
      german: "von Sachsen",
      translated: "savezne zemlje Saska",
      tone: 'semantic',
    },
  ],
  "lid:state:SN:5|it": [
    {
      german: "Welche Farben",
      translated: "Quali sono i colori",
      tone: 'semantic',
    },
    {
      german: "die Landesflagge",
      translated: "della bandiera",
      tone: 'semantic',
    },
    {
      german: "von Sachsen",
      translated: "del Land di Sassonia",
      tone: 'semantic',
    },
  ],
  "lid:state:SN:5|kmr": [
    {
      german: "Welche Farben",
      translated: "Rengên",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "çi ne",
      tone: 'semantic',
    },
    {
      german: "die Landesflagge",
      translated: "ala eyaleta",
      tone: 'semantic',
    },
    {
      german: "von Sachsen",
      translated: "Sachsen",
      tone: 'semantic',
    },
  ],
  "lid:state:SN:5|pl": [
    {
      german: "Welche Farben",
      translated: "Jakie są kolory",
      tone: 'semantic',
    },
    {
      german: "die Landesflagge",
      translated: "flagi kraju związkowego",
      tone: 'semantic',
    },
    {
      german: "von Sachsen",
      translated: "Saksonia",
      tone: 'semantic',
    },
  ],
  "lid:state:SN:5|prs": [
    {
      german: "Welche Farben",
      translated: "رنگ‌های",
      tone: 'semantic',
    },
    {
      german: "die Landesflagge",
      translated: "پرچم ایالت",
      tone: 'semantic',
    },
    {
      german: "von Sachsen",
      translated: "زاکسن",
      tone: 'semantic',
    },
  ],
  "lid:state:SN:5|ro": [
    {
      german: "Welche Farben",
      translated: "culorile",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "sunt",
      tone: 'semantic',
    },
    {
      german: "die Landesflagge",
      translated: "drapelului",
      tone: 'semantic',
    },
    {
      german: "von Sachsen",
      translated: "landului Saxonia",
      tone: 'semantic',
    },
  ],
  "lid:state:SN:5|ru": [
    {
      german: "Welche Farben",
      translated: "Какие цвета",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "у",
      tone: 'semantic',
    },
    {
      german: "die Landesflagge",
      translated: "флага земли",
      tone: 'semantic',
    },
    {
      german: "von Sachsen",
      translated: "Саксония",
      tone: 'semantic',
    },
  ],
  "lid:state:SN:5|sq": [
    {
      german: "Welche Farben",
      translated: "ngjyrat",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "të",
      tone: 'semantic',
    },
    {
      german: "die Landesflagge",
      translated: "flamurit",
      tone: 'semantic',
    },
    {
      german: "von Sachsen",
      translated: "Sachsen",
      tone: 'semantic',
    },
  ],
  "lid:state:SN:5|sr": [
    {
      german: "Welche Farben",
      translated: "Koje",
      tone: 'semantic',
    },
    {
      german: "die Landesflagge",
      translated: "zastave",
      tone: 'semantic',
    },
    {
      german: "von Sachsen",
      translated: "savezne pokrajine Saksonija",
      tone: 'semantic',
    },
  ],
  "lid:state:SN:5|tr": [
    {
      german: "Welche Farben",
      translated: "renkleri nelerdir",
      tone: 'semantic',
    },
    {
      german: "die Landesflagge",
      translated: "eyalet bayrağının",
      tone: 'semantic',
    },
    {
      german: "von Sachsen",
      translated: "Sachsen",
      tone: 'semantic',
    },
  ],
  "lid:state:SN:5|uk": [
    {
      german: "Welche Farben",
      translated: "Які кольори",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: " має",
      tone: 'semantic',
    },
    {
      german: "die Landesflagge",
      translated: "прапор федеральної землі",
      tone: 'semantic',
    },
    {
      german: "von Sachsen",
      translated: "Саксонія",
      tone: 'semantic',
    },
  ],
  "lid:state:SN:5|vi": [
    {
      german: "Welche Farben",
      translated: "Màu của",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "là",
      tone: 'semantic',
    },
    {
      german: "die Landesflagge",
      translated: "cờ bang Sachsen",
      tone: 'semantic',
    },
  ],
  "lid:state:SN:6|ar": [
    {
      german: "Wo",
      translated: "أين",
      tone: 'semantic',
    },
    {
      german: "können Sie",
      translated: "يمكنك",
      tone: 'semantic',
    },
    {
      german: "in Sachsen",
      translated: "في Sachsen",
      tone: 'semantic',
    },
    {
      german: "über politische Themen",
      translated: "عن القضايا السياسية",
      tone: 'semantic',
    },
    {
      german: "informieren",
      translated: "الحصول على معلومات",
      tone: 'semantic',
    },
  ],
  "lid:state:SN:6|bg": [
    {
      german: "Wo",
      translated: "Къде",
      tone: 'semantic',
    },
    {
      german: "können Sie",
      translated: "можете",
      tone: 'semantic',
    },
    {
      german: "in Sachsen",
      translated: "в Саксония",
      tone: 'semantic',
    },
    {
      german: "über politische Themen",
      translated: "по политически теми",
      tone: 'semantic',
    },
    {
      german: "informieren",
      translated: "да получите информация",
      tone: 'semantic',
    },
  ],
  "lid:state:SN:6|bs": [
    {
      german: "Wo",
      translated: "Gdje",
      tone: 'semantic',
    },
    {
      german: "sich",
      translated: "se",
      tone: 'semantic',
    },
    {
      german: "in Sachsen",
      translated: "u saveznoj zemlji Saksonija",
      tone: 'semantic',
    },
    {
      german: "über politische Themen",
      translated: "o političkim temama",
      tone: 'semantic',
    },
    {
      german: "informieren",
      translated: "mogu dobiti informacije",
      tone: 'semantic',
    },
  ],
  "lid:state:SN:6|el": [
    {
      german: "Wo",
      translated: "Πού",
      tone: 'semantic',
    },
    {
      german: "können Sie",
      translated: "μπορείτε",
      tone: 'semantic',
    },
    {
      german: "sich",
      translated: "να",
      tone: 'semantic',
    },
    {
      german: "in Sachsen",
      translated: "στο Σαξονία",
      tone: 'semantic',
    },
    {
      german: "über politische Themen",
      translated: "για πολιτικά θέματα",
      tone: 'semantic',
    },
    {
      german: "informieren",
      translated: "ενημερωθείτε",
      tone: 'semantic',
    },
  ],
  "lid:state:SN:6|en": [
    {
      german: "Wo",
      translated: "Where",
      tone: 'semantic',
    },
    {
      german: "können Sie",
      translated: "can you",
      tone: 'semantic',
    },
    {
      german: "in Sachsen",
      translated: "in Sachsen",
      tone: 'semantic',
    },
    {
      german: "über politische Themen",
      translated: "about political topics",
      tone: 'semantic',
    },
    {
      german: "informieren",
      translated: "get information",
      tone: 'semantic',
    },
  ],
  "lid:state:SN:6|es": [
    {
      german: "Wo",
      translated: "¿Dónde",
      tone: 'semantic',
    },
    {
      german: "können Sie",
      translated: "puede",
      tone: 'semantic',
    },
    {
      german: "in Sachsen",
      translated: "en Sajonia",
      tone: 'semantic',
    },
    {
      german: "über politische Themen",
      translated: "sobre temas políticos",
      tone: 'semantic',
    },
    {
      german: "informieren",
      translated: "informarse",
      tone: 'semantic',
    },
  ],
  "lid:state:SN:6|fa": [
    {
      german: "Wo",
      translated: "کجا",
      tone: 'semantic',
    },
    {
      german: "können Sie",
      translated: "می‌توانید",
      tone: 'semantic',
    },
    {
      german: "in Sachsen",
      translated: "در زاکسن",
      tone: 'semantic',
    },
    {
      german: "über politische Themen",
      translated: "دربارهٔ موضوعات سیاسی",
      tone: 'semantic',
    },
    {
      german: "informieren",
      translated: "اطلاعات کسب کنید",
      tone: 'semantic',
    },
  ],
  "lid:state:SN:6|fr": [
    {
      german: "Wo",
      translated: "Où",
      tone: 'semantic',
    },
    {
      german: "können Sie",
      translated: "pouvez-vous",
      tone: 'semantic',
    },
    {
      german: "sich",
      translated: "vous",
      tone: 'semantic',
    },
    {
      german: "in Sachsen",
      translated: "en Saxe",
      tone: 'semantic',
    },
    {
      german: "über politische Themen",
      translated: "sur les questions politiques",
      tone: 'semantic',
    },
    {
      german: "informieren",
      translated: "informer",
      tone: 'semantic',
    },
  ],
  "lid:state:SN:6|hr": [
    {
      german: "Wo",
      translated: "Gdje",
      tone: 'semantic',
    },
    {
      german: "können Sie",
      translated: "mogu",
      tone: 'semantic',
    },
    {
      german: "sich",
      translated: "se",
      tone: 'semantic',
    },
    {
      german: "in Sachsen",
      translated: "u saveznoj zemlji Saska",
      tone: 'semantic',
    },
    {
      german: "über politische Themen",
      translated: "o političkim temama",
      tone: 'semantic',
    },
    {
      german: "informieren",
      translated: "dobiti informacije",
      tone: 'semantic',
    },
  ],
  "lid:state:SN:6|it": [
    {
      german: "Wo",
      translated: "Dove",
      tone: 'semantic',
    },
    {
      german: "können Sie",
      translated: "ci si può",
      tone: 'semantic',
    },
    {
      german: "in Sachsen",
      translated: "in Sassonia",
      tone: 'semantic',
    },
    {
      german: "über politische Themen",
      translated: "su temi politici",
      tone: 'semantic',
    },
    {
      german: "informieren",
      translated: "informare",
      tone: 'semantic',
    },
  ],
  "lid:state:SN:6|kmr": [
    {
      german: "Wo",
      translated: "Li",
      tone: 'semantic',
    },
    {
      german: "können Sie",
      translated: "li ku",
      tone: 'semantic',
    },
    {
      german: "sich",
      translated: "dikarî",
      tone: 'semantic',
    },
    {
      german: "in Sachsen",
      translated: "Sachsen",
      tone: 'semantic',
    },
    {
      german: "über politische Themen",
      translated: "li ser mijarên siyasî",
      tone: 'semantic',
    },
    {
      german: "informieren",
      translated: "agahdarî bistînî?",
      tone: 'semantic',
    },
  ],
  "lid:state:SN:6|pl": [
    {
      german: "Wo",
      translated: "Gdzie",
      tone: 'semantic',
    },
    {
      german: "können Sie",
      translated: "można",
      tone: 'semantic',
    },
    {
      german: "in Sachsen",
      translated: "w Saksonia",
      tone: 'semantic',
    },
    {
      german: "über politische Themen",
      translated: "na tematy polityczne",
      tone: 'semantic',
    },
    {
      german: "informieren",
      translated: "uzyskać informacje",
      tone: 'semantic',
    },
  ],
  "lid:state:SN:6|prs": [
    {
      german: "können Sie",
      translated: "می‌توانید",
      tone: 'semantic',
    },
    {
      german: "in Sachsen",
      translated: "در زاکسن",
      tone: 'semantic',
    },
    {
      german: "über politische Themen",
      translated: " دربارهٔ موضوعات سیاسی",
      tone: 'semantic',
    },
    {
      german: "informieren",
      translated: "اطلاعات کسب کنید",
      tone: 'semantic',
    },
  ],
  "lid:state:SN:6|ro": [
    {
      german: "Wo",
      translated: "Unde",
      tone: 'semantic',
    },
    {
      german: "können Sie",
      translated: "puteți",
      tone: 'semantic',
    },
    {
      german: "sich",
      translated: "vă",
      tone: 'semantic',
    },
    {
      german: "in Sachsen",
      translated: "în Saxonia",
      tone: 'semantic',
    },
    {
      german: "über politische Themen",
      translated: "despre teme politice",
      tone: 'semantic',
    },
    {
      german: "informieren",
      translated: "informa",
      tone: 'semantic',
    },
  ],
  "lid:state:SN:6|ru": [
    {
      german: "Wo",
      translated: "Где",
      tone: 'semantic',
    },
    {
      german: "können Sie",
      translated: "можно",
      tone: 'semantic',
    },
    {
      german: "in Sachsen",
      translated: "в федеральной земле Саксония",
      tone: 'semantic',
    },
    {
      german: "über politische Themen",
      translated: "о политических темах",
      tone: 'semantic',
    },
    {
      german: "informieren",
      translated: "получить информацию",
      tone: 'semantic',
    },
  ],
  "lid:state:SN:6|sq": [
    {
      german: "Wo",
      translated: "Ku",
      tone: 'semantic',
    },
    {
      german: "können Sie",
      translated: "mund të",
      tone: 'semantic',
    },
    {
      german: "in Sachsen",
      translated: "në Sachsen",
      tone: 'semantic',
    },
    {
      german: "über politische Themen",
      translated: "për tema politike",
      tone: 'semantic',
    },
    {
      german: "informieren",
      translated: "informoheni",
      tone: 'semantic',
    },
  ],
  "lid:state:SN:6|sr": [
    {
      german: "Wo",
      translated: "Gdje",
      tone: 'semantic',
    },
    {
      german: "können Sie",
      translated: "mogu",
      tone: 'semantic',
    },
    {
      german: "sich",
      translated: "se",
      tone: 'semantic',
    },
    {
      german: "in Sachsen",
      translated: "u saveznoj pokrajini Saksonija",
      tone: 'semantic',
    },
    {
      german: "über politische Themen",
      translated: "o političkim temama",
      tone: 'semantic',
    },
    {
      german: "informieren",
      translated: "dobiti informacije",
      tone: 'semantic',
    },
  ],
  "lid:state:SN:6|tr": [
    {
      german: "Wo",
      translated: "nereden",
      tone: 'semantic',
    },
    {
      german: "können Sie",
      translated: "alabilirsiniz",
      tone: 'semantic',
    },
    {
      german: "in Sachsen",
      translated: "Sachsen eyaletinde",
      tone: 'semantic',
    },
    {
      german: "über politische Themen",
      translated: "siyasi konular hakkında",
      tone: 'semantic',
    },
    {
      german: "informieren",
      translated: "bilgi",
      tone: 'semantic',
    },
  ],
  "lid:state:SN:6|uk": [
    {
      german: "Wo",
      translated: "Де",
      tone: 'semantic',
    },
    {
      german: "können Sie",
      translated: "можна",
      tone: 'semantic',
    },
    {
      german: "in Sachsen",
      translated: "у федеральній землі Саксонія",
      tone: 'semantic',
    },
    {
      german: "über politische Themen",
      translated: "про політичні питання",
      tone: 'semantic',
    },
    {
      german: "informieren",
      translated: "отримати інформацію",
      tone: 'semantic',
    },
  ],
  "lid:state:SN:6|vi": [
    {
      german: "Wo",
      translated: "ở đâu",
      tone: 'semantic',
    },
    {
      german: "können Sie",
      translated: "có thể",
      tone: 'semantic',
    },
    {
      german: "in Sachsen",
      translated: "bang Sachsen",
      tone: 'semantic',
    },
    {
      german: "über politische Themen",
      translated: "về các chủ đề chính trị",
      tone: 'semantic',
    },
    {
      german: "informieren",
      translated: "tìm thông tin",
      tone: 'semantic',
    },
  ],
  "lid:state:SN:7|ar": [
    {
      german: "Die Landeshauptstadt",
      translated: "ما عاصمة",
      tone: 'semantic',
    },
    {
      german: "von Sachsen",
      translated: "Sachsen",
      tone: 'semantic',
    },
    {
      german: "heißt",
      translated: "؟",
      tone: 'semantic',
    },
  ],
  "lid:state:SN:7|bg": [
    {
      german: "Die Landeshauptstadt",
      translated: "Столицата",
      tone: 'semantic',
    },
    {
      german: "von Sachsen",
      translated: "Саксония",
      tone: 'semantic',
    },
    {
      german: "heißt",
      translated: "е",
      tone: 'semantic',
    },
  ],
  "lid:state:SN:7|bs": [
    {
      german: "Die Landeshauptstadt",
      translated: "Glavni grad",
      tone: 'semantic',
    },
    {
      german: "von Sachsen",
      translated: "savezne zemlje Saksonija",
      tone: 'semantic',
    },
  ],
  "lid:state:SN:7|el": [
    {
      german: "Die Landeshauptstadt",
      translated: "Η πρωτεύουσα",
      tone: 'semantic',
    },
    {
      german: "von Sachsen",
      translated: "του ομόσπονδου κρατιδίου Σαξονία",
      tone: 'semantic',
    },
    {
      german: "heißt",
      translated: "είναι",
      tone: 'semantic',
    },
  ],
  "lid:state:SN:7|en": [
    {
      german: "Die Landeshauptstadt",
      translated: "The state capital",
      tone: 'semantic',
    },
    {
      german: "von Sachsen",
      translated: "Sachsen",
      tone: 'semantic',
    },
    {
      german: "heißt",
      translated: "is called",
      tone: 'semantic',
    },
  ],
  "lid:state:SN:7|es": [
    {
      german: "Die Landeshauptstadt",
      translated: "La capital",
      tone: 'semantic',
    },
    {
      german: "von Sachsen",
      translated: "de Sajonia",
      tone: 'semantic',
    },
    {
      german: "heißt",
      translated: "es",
      tone: 'semantic',
    },
  ],
  "lid:state:SN:7|fa": [
    {
      german: "Die Landeshauptstadt",
      translated: "مرکز ایالت",
      tone: 'semantic',
    },
    {
      german: "von Sachsen",
      translated: "زاکسن",
      tone: 'semantic',
    },
  ],
  "lid:state:SN:7|fr": [
    {
      german: "Die Landeshauptstadt",
      translated: "capitale",
      tone: 'semantic',
    },
    {
      german: "von Sachsen",
      translated: "de Saxe",
      tone: 'semantic',
    },
    {
      german: "heißt",
      translated: "s’appelle",
      tone: 'semantic',
    },
  ],
  "lid:state:SN:7|hr": [
    {
      german: "Die Landeshauptstadt",
      translated: "Glavni grad",
      tone: 'semantic',
    },
    {
      german: "von Sachsen",
      translated: "savezne zemlje Saska",
      tone: 'semantic',
    },
    {
      german: "heißt",
      translated: "je",
      tone: 'semantic',
    },
  ],
  "lid:state:SN:7|it": [
    {
      german: "Die Landeshauptstadt",
      translated: "La capitale del Land",
      tone: 'semantic',
    },
    {
      german: "von Sachsen",
      translated: "di Sassonia",
      tone: 'semantic',
    },
    {
      german: "heißt",
      translated: "è",
      tone: 'semantic',
    },
  ],
  "lid:state:SN:7|kmr": [
    {
      german: "Die Landeshauptstadt",
      translated: "Paytexta eyaleta",
      tone: 'semantic',
    },
    {
      german: "von Sachsen",
      translated: "Sachsen",
      tone: 'semantic',
    },
    {
      german: "heißt",
      translated: "e.",
      tone: 'semantic',
    },
  ],
  "lid:state:SN:7|pl": [
    {
      german: "Die Landeshauptstadt",
      translated: "Stolicą kraju związkowego",
      tone: 'semantic',
    },
    {
      german: "von Sachsen",
      translated: "Saksonia",
      tone: 'semantic',
    },
    {
      german: "heißt",
      translated: "jest",
      tone: 'semantic',
    },
  ],
  "lid:state:SN:7|prs": [
    {
      german: "Die Landeshauptstadt",
      translated: "مرکز ایالت",
      tone: 'semantic',
    },
    {
      german: "von Sachsen",
      translated: "زاکسن",
      tone: 'semantic',
    },
    {
      german: "heißt",
      translated: "است",
      tone: 'semantic',
    },
  ],
  "lid:state:SN:7|ro": [
    {
      german: "Die Landeshauptstadt",
      translated: "Capitala",
      tone: 'semantic',
    },
    {
      german: "von Sachsen",
      translated: "Saxonia",
      tone: 'semantic',
    },
    {
      german: "heißt",
      translated: "este …",
      tone: 'semantic',
    },
  ],
  "lid:state:SN:7|ru": [
    {
      german: "Die Landeshauptstadt",
      translated: "Столица земли",
      tone: 'semantic',
    },
    {
      german: "von Sachsen",
      translated: "Саксония",
      tone: 'semantic',
    },
    {
      german: "heißt",
      translated: "называется",
      tone: 'semantic',
    },
  ],
  "lid:state:SN:7|sq": [
    {
      german: "Die Landeshauptstadt",
      translated: "Kryeqyteti i landit",
      tone: 'semantic',
    },
    {
      german: "von Sachsen",
      translated: "Sachsen",
      tone: 'semantic',
    },
    {
      german: "heißt",
      translated: "është",
      tone: 'semantic',
    },
  ],
  "lid:state:SN:7|sr": [
    {
      german: "Die Landeshauptstadt",
      translated: "Glavni grad",
      tone: 'semantic',
    },
    {
      german: "von Sachsen",
      translated: "savezne pokrajine Saksonija",
      tone: 'semantic',
    },
  ],
  "lid:state:SN:7|tr": [
    {
      german: "Die Landeshauptstadt",
      translated: "başkenti",
      tone: 'semantic',
    },
    {
      german: "von Sachsen",
      translated: "Sachsen eyaletinin",
      tone: 'semantic',
    },
  ],
  "lid:state:SN:7|uk": [
    {
      german: "Die Landeshauptstadt",
      translated: "Столиця федеральної землі",
      tone: 'semantic',
    },
    {
      german: "von Sachsen",
      translated: "Саксонія",
      tone: 'semantic',
    },
    {
      german: "heißt",
      translated: "називається",
      tone: 'semantic',
    },
  ],
  "lid:state:SN:7|vi": [
    {
      german: "Die Landeshauptstadt",
      translated: "Thủ phủ",
      tone: 'semantic',
    },
    {
      german: "von Sachsen",
      translated: "của bang Sachsen",
      tone: 'semantic',
    },
    {
      german: "heißt",
      translated: "là",
      tone: 'semantic',
    },
  ],
  "lid:state:SN:8|ar": [
    {
      german: "Welches Bundesland",
      translated: "أي صورة",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "تمثل",
      tone: 'semantic',
    },
    {
      german: "Sachsen",
      translated: "Sachsen",
      tone: 'semantic',
    },
  ],
  "lid:state:SN:8|bg": [
    {
      german: "Welches Bundesland",
      translated: "Коя от показаните федерални провинции",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "е",
      tone: 'semantic',
    },
    {
      german: "Sachsen",
      translated: "Саксония",
      tone: 'semantic',
    },
  ],
  "lid:state:SN:8|bs": [
    {
      german: "Welches Bundesland",
      translated: "Koja od prikazanih saveznih zemalja",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "je",
      tone: 'semantic',
    },
    {
      german: "Sachsen",
      translated: "Saksonija",
      tone: 'semantic',
    },
  ],
  "lid:state:SN:8|el": [
    {
      german: "Welches Bundesland",
      translated: "Ποιο από τα εικονιζόμενα κρατίδια",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "είναι",
      tone: 'semantic',
    },
    {
      german: "Sachsen",
      translated: "Σαξονία",
      tone: 'semantic',
    },
  ],
  "lid:state:SN:8|en": [
    {
      german: "Welches Bundesland",
      translated: "Which federal state",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "is",
      tone: 'semantic',
    },
    {
      german: "Sachsen",
      translated: "Sachsen",
      tone: 'semantic',
    },
  ],
  "lid:state:SN:8|es": [
    {
      german: "Welches Bundesland",
      translated: "¿Cuál de las imágenes corresponde al estado federado",
      tone: 'semantic',
    },
    {
      german: "Sachsen",
      translated: "Sajonia",
      tone: 'semantic',
    },
  ],
  "lid:state:SN:8|fa": [
    {
      german: "Welches Bundesland",
      translated: "کدام ایالتِ",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "است",
      tone: 'semantic',
    },
    {
      german: "Sachsen",
      translated: "زاکسن",
      tone: 'semantic',
    },
  ],
  "lid:state:SN:8|fr": [
    {
      german: "Welches Bundesland",
      translated: "Quel Land représenté",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "est",
      tone: 'semantic',
    },
    {
      german: "Sachsen",
      translated: "Saxe",
      tone: 'semantic',
    },
  ],
  "lid:state:SN:8|hr": [
    {
      german: "Welches Bundesland",
      translated: "Koja od prikazanih saveznih zemalja",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "je",
      tone: 'semantic',
    },
    {
      german: "Sachsen",
      translated: "Saska",
      tone: 'semantic',
    },
  ],
  "lid:state:SN:8|it": [
    {
      german: "Welches Bundesland",
      translated: "Quale Land",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "rappresentato è",
      tone: 'semantic',
    },
    {
      german: "Sachsen",
      translated: "Sassonia",
      tone: 'semantic',
    },
  ],
  "lid:state:SN:8|kmr": [
    {
      german: "Welches Bundesland",
      translated: "Kîjan eyalet",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "ye",
      tone: 'semantic',
    },
    {
      german: "Sachsen",
      translated: "Sachsen",
      tone: 'semantic',
    },
  ],
  "lid:state:SN:8|pl": [
    {
      german: "Welches Bundesland",
      translated: "Który z przedstawionych krajów związkowych",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "to",
      tone: 'semantic',
    },
    {
      german: "Sachsen",
      translated: "Saksonia",
      tone: 'semantic',
    },
  ],
  "lid:state:SN:8|prs": [
    {
      german: "Welches Bundesland",
      translated: "کدام ایالتِ نشان‌داده‌شده",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "است",
      tone: 'semantic',
    },
    {
      german: "Sachsen",
      translated: "زاکسن",
      tone: 'semantic',
    },
  ],
  "lid:state:SN:8|ro": [
    {
      german: "Welches Bundesland",
      translated: "Care land",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "este",
      tone: 'semantic',
    },
    {
      german: "Sachsen",
      translated: "Saxonia",
      tone: 'semantic',
    },
  ],
  "lid:state:SN:8|ru": [
    {
      german: "Welches Bundesland",
      translated: "Какая из этих земель",
      tone: 'semantic',
    },
    {
      german: "Sachsen",
      translated: "Саксония",
      tone: 'semantic',
    },
  ],
  "lid:state:SN:8|sq": [
    {
      german: "Welches Bundesland",
      translated: "Cili nga landet e paraqitura",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "është",
      tone: 'semantic',
    },
    {
      german: "Sachsen",
      translated: "Sachsen",
      tone: 'semantic',
    },
  ],
  "lid:state:SN:8|sr": [
    {
      german: "Welches Bundesland",
      translated: "Koja",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "je",
      tone: 'semantic',
    },
    {
      german: "Sachsen",
      translated: "Saksonija",
      tone: 'semantic',
    },
  ],
  "lid:state:SN:8|tr": [
    {
      german: "Welches Bundesland",
      translated: "hangi numarayla",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "gösterilmiştir",
      tone: 'semantic',
    },
    {
      german: "Sachsen",
      translated: "Sachsen",
      tone: 'semantic',
    },
  ],
  "lid:state:SN:8|uk": [
    {
      german: "Welches Bundesland",
      translated: "Яка з позначених федеральних земель",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "є",
      tone: 'semantic',
    },
    {
      german: "Sachsen",
      translated: "Саксонія",
      tone: 'semantic',
    },
  ],
  "lid:state:SN:8|vi": [
    {
      german: "Welches Bundesland",
      translated: "Bang nào",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "được hiển thị là",
      tone: 'semantic',
    },
    {
      german: "Sachsen",
      translated: "Sachsen",
      tone: 'semantic',
    },
  ],
  "lid:state:SN:9|ar": [
    {
      german: "Wie",
      translated: "ماذا",
      tone: 'semantic',
    },
    {
      german: "nennt man",
      translated: "يُسمى",
      tone: 'semantic',
    },
    {
      german: "die Regierungschefin/den Regierungschef",
      translated: "رئيس/رئيسة حكومة",
      tone: 'semantic',
    },
    {
      german: "in Sachsen",
      translated: "ولاية Sachsen",
      tone: 'semantic',
    },
  ],
  "lid:state:SN:9|bg": [
    {
      german: "Wie",
      translated: "Как",
      tone: 'semantic',
    },
    {
      german: "nennt man",
      translated: " се нарича",
      tone: 'semantic',
    },
    {
      german: "die Regierungschefin/den Regierungschef",
      translated: "ръководителят на правителството",
      tone: 'semantic',
    },
    {
      german: "in Sachsen",
      translated: "на провинция Саксония",
      tone: 'semantic',
    },
  ],
  "lid:state:SN:9|bs": [
    {
      german: "Wie",
      translated: "Kako",
      tone: 'semantic',
    },
    {
      german: "nennt man",
      translated: "se zove",
      tone: 'semantic',
    },
    {
      german: "die Regierungschefin/den Regierungschef",
      translated: "šef vlade",
      tone: 'semantic',
    },
    {
      german: "in Sachsen",
      translated: "savezne zemlje Saksonija",
      tone: 'semantic',
    },
  ],
  "lid:state:SN:9|el": [
    {
      german: "Wie",
      translated: "Πώς",
      tone: 'semantic',
    },
    {
      german: "nennt man",
      translated: "ονομάζεται ο",
      tone: 'semantic',
    },
    {
      german: "die Regierungschefin/den Regierungschef",
      translated: "επικεφαλής της κυβέρνησης του",
      tone: 'semantic',
    },
    {
      german: "in Sachsen",
      translated: "κρατιδίου Σαξονία",
      tone: 'semantic',
    },
  ],
  "lid:state:SN:9|en": [
    {
      german: "Wie",
      translated: "What",
      tone: 'semantic',
    },
    {
      german: "nennt man",
      translated: "is the head",
      tone: 'semantic',
    },
    {
      german: "die Regierungschefin/den Regierungschef",
      translated: "of government called",
      tone: 'semantic',
    },
    {
      german: "in Sachsen",
      translated: "in Sachsen",
      tone: 'semantic',
    },
  ],
  "lid:state:SN:9|es": [
    {
      german: "Wie",
      translated: "¿Cómo",
      tone: 'semantic',
    },
    {
      german: "nennt man",
      translated: "se llama",
      tone: 'semantic',
    },
    {
      german: "die Regierungschefin/den Regierungschef",
      translated: "al jefe o la jefa de gobierno",
      tone: 'semantic',
    },
    {
      german: "in Sachsen",
      translated: "de Sajonia",
      tone: 'semantic',
    },
  ],
  "lid:state:SN:9|fa": [
    {
      german: "Wie",
      translated: "چه",
      tone: 'semantic',
    },
    {
      german: "nennt man",
      translated: "عنوانی دارد",
      tone: 'semantic',
    },
    {
      german: "die Regierungschefin/den Regierungschef",
      translated: "رئیس دولت",
      tone: 'semantic',
    },
    {
      german: "in Sachsen",
      translated: "ایالت زاکسن",
      tone: 'semantic',
    },
  ],
  "lid:state:SN:9|fr": [
    {
      german: "Wie",
      translated: "Comment",
      tone: 'semantic',
    },
    {
      german: "nennt man",
      translated: "appelle-t-on",
      tone: 'semantic',
    },
    {
      german: "die Regierungschefin/den Regierungschef",
      translated: "le chef ou la cheffe du gouvernement",
      tone: 'semantic',
    },
    {
      german: "in Sachsen",
      translated: "de Saxe",
      tone: 'semantic',
    },
  ],
  "lid:state:SN:9|hr": [
    {
      german: "Wie",
      translated: "Kako",
      tone: 'semantic',
    },
    {
      german: "nennt man",
      translated: "se zove",
      tone: 'semantic',
    },
    {
      german: "die Regierungschefin/den Regierungschef",
      translated: "čelnik vlade",
      tone: 'semantic',
    },
    {
      german: "in Sachsen",
      translated: "Saska",
      tone: 'semantic',
    },
  ],
  "lid:state:SN:9|it": [
    {
      german: "Wie",
      translated: "Come",
      tone: 'semantic',
    },
    {
      german: "nennt man",
      translated: "si chiama",
      tone: 'semantic',
    },
    {
      german: "die Regierungschefin/den Regierungschef",
      translated: "il capo del governo",
      tone: 'semantic',
    },
    {
      german: "in Sachsen",
      translated: "del Land di Sassonia",
      tone: 'semantic',
    },
  ],
  "lid:state:SN:9|kmr": [
    {
      german: "nennt man",
      translated: "tê gotin",
      tone: 'semantic',
    },
    {
      german: "die Regierungschefin/den Regierungschef",
      translated: "hukûmeta",
      tone: 'semantic',
    },
    {
      german: "in Sachsen",
      translated: "Sachsen çi",
      tone: 'semantic',
    },
  ],
  "lid:state:SN:9|pl": [
    {
      german: "Wie",
      translated: "Jak",
      tone: 'semantic',
    },
    {
      german: "nennt man",
      translated: "nazywa się",
      tone: 'semantic',
    },
    {
      german: "die Regierungschefin/den Regierungschef",
      translated: "szef rządu",
      tone: 'semantic',
    },
    {
      german: "in Sachsen",
      translated: "kraju związkowego Saksonia",
      tone: 'semantic',
    },
  ],
  "lid:state:SN:9|prs": [
    {
      german: "die Regierungschefin/den Regierungschef",
      translated: "رئیس دولت",
      tone: 'semantic',
    },
    {
      german: "in Sachsen",
      translated: "زاکسن",
      tone: 'semantic',
    },
  ],
  "lid:state:SN:9|ro": [
    {
      german: "Wie",
      translated: "Cum",
      tone: 'semantic',
    },
    {
      german: "nennt man",
      translated: "se numește",
      tone: 'semantic',
    },
    {
      german: "die Regierungschefin/den Regierungschef",
      translated: "șeful guvernului",
      tone: 'semantic',
    },
    {
      german: "in Sachsen",
      translated: "landului Saxonia",
      tone: 'semantic',
    },
  ],
  "lid:state:SN:9|ru": [
    {
      german: "Wie",
      translated: "Как",
      tone: 'semantic',
    },
    {
      german: "nennt man",
      translated: "называют",
      tone: 'semantic',
    },
    {
      german: "die Regierungschefin/den Regierungschef",
      translated: "главу правительства",
      tone: 'semantic',
    },
    {
      german: "in Sachsen",
      translated: "в федеральной земле Саксония",
      tone: 'semantic',
    },
  ],
  "lid:state:SN:9|sq": [
    {
      german: "Wie",
      translated: "Si",
      tone: 'semantic',
    },
    {
      german: "nennt man",
      translated: "quhet kreu",
      tone: 'semantic',
    },
    {
      german: "die Regierungschefin/den Regierungschef",
      translated: "i qeverisë së",
      tone: 'semantic',
    },
    {
      german: "in Sachsen",
      translated: "Sachsen",
      tone: 'semantic',
    },
  ],
  "lid:state:SN:9|sr": [
    {
      german: "Wie",
      translated: "Kako",
      tone: 'semantic',
    },
    {
      german: "nennt man",
      translated: "se zove",
      tone: 'semantic',
    },
    {
      german: "die Regierungschefin/den Regierungschef",
      translated: "šef vlade",
      tone: 'semantic',
    },
    {
      german: "in Sachsen",
      translated: "savezne pokrajine Saksonija",
      tone: 'semantic',
    },
  ],
  "lid:state:SN:9|tr": [
    {
      german: "Wie",
      translated: "ne",
      tone: 'semantic',
    },
    {
      german: "nennt man",
      translated: "ad verilir",
      tone: 'semantic',
    },
    {
      german: "die Regierungschefin/den Regierungschef",
      translated: "hükümetinin başındaki kişiye",
      tone: 'semantic',
    },
    {
      german: "in Sachsen",
      translated: "Sachsen",
      tone: 'semantic',
    },
  ],
  "lid:state:SN:9|uk": [
    {
      german: "Wie",
      translated: "Як",
      tone: 'semantic',
    },
    {
      german: "nennt man",
      translated: " називають",
      tone: 'semantic',
    },
    {
      german: "die Regierungschefin/den Regierungschef",
      translated: "главу уряду",
      tone: 'semantic',
    },
    {
      german: "in Sachsen",
      translated: "Саксонія",
      tone: 'semantic',
    },
  ],
  "lid:state:SN:9|vi": [
    {
      german: "Wie",
      translated: "gì",
      tone: 'semantic',
    },
    {
      german: "nennt man",
      translated: "được gọi là",
      tone: 'semantic',
    },
    {
      german: "die Regierungschefin/den Regierungschef",
      translated: "Người đứng đầu chính phủ",
      tone: 'semantic',
    },
    {
      german: "in Sachsen",
      translated: "bang Sachsen",
      tone: 'semantic',
    },
  ],
  "lid:state:ST:10|ar": [
    {
      german: "Welche Ministerin",
      translated: "أي وزارة",
      tone: 'semantic',
    },
    {
      german: "welchen Minister",
      translated: "من الوزارات التالية",
      tone: 'semantic',
    },
    {
      german: "Sachsen-Anhalt",
      translated: "ولاية Sachsen-Anhalt",
      tone: 'semantic',
    },
    {
      german: "nicht",
      translated: "غير موجودة",
      tone: 'semantic',
    },
  ],
  "lid:state:ST:10|bg": [
    {
      german: "Welche Ministerin",
      translated: "Кой",
      tone: 'semantic',
    },
    {
      german: "welchen Minister",
      translated: "министър",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "съществува",
      tone: 'semantic',
    },
    {
      german: "Sachsen-Anhalt",
      translated: "Саксония-Анхалт",
      tone: 'semantic',
    },
    {
      german: "nicht",
      translated: "не",
      tone: 'semantic',
    },
  ],
  "lid:state:ST:10|bs": [
    {
      german: "Welche Ministerin",
      translated: "Koji ministar",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "postoji",
      tone: 'semantic',
    },
    {
      german: "Sachsen-Anhalt",
      translated: "savezne zemlje Saksonija-Anhalt",
      tone: 'semantic',
    },
    {
      german: "nicht",
      translated: "ne",
      tone: 'semantic',
    },
  ],
  "lid:state:ST:10|el": [
    {
      german: "Welche Ministerin",
      translated: "Ποιος",
      tone: 'semantic',
    },
    {
      german: "welchen Minister",
      translated: "υπουργός",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "υπάρχει",
      tone: 'semantic',
    },
    {
      german: "Sachsen-Anhalt",
      translated: "Σαξονία-Άνχαλτ",
      tone: 'semantic',
    },
    {
      german: "nicht",
      translated: "δεν",
      tone: 'semantic',
    },
  ],
  "lid:state:ST:10|en": [
    {
      german: "Welche Ministerin",
      translated: "Which minister",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "does",
      tone: 'semantic',
    },
    {
      german: "Sachsen-Anhalt",
      translated: "Sachsen-Anhalt",
      tone: 'semantic',
    },
    {
      german: "nicht",
      translated: "not have",
      tone: 'semantic',
    },
  ],
  "lid:state:ST:10|es": [
    {
      german: "Welche Ministerin",
      translated: "¿Qué",
      tone: 'semantic',
    },
    {
      german: "welchen Minister",
      translated: "ministerio",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "existe",
      tone: 'semantic',
    },
    {
      german: "Sachsen-Anhalt",
      translated: "Sajonia-Anhalt",
      tone: 'semantic',
    },
    {
      german: "nicht",
      translated: "NO",
      tone: 'semantic',
    },
  ],
  "lid:state:ST:10|fa": [
    {
      german: "Welche Ministerin",
      translated: "کدام",
      tone: 'semantic',
    },
    {
      german: "welchen Minister",
      translated: "وزیر",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "وجود",
      tone: 'semantic',
    },
    {
      german: "Sachsen-Anhalt",
      translated: "زاکسن-آنهالت",
      tone: 'semantic',
    },
    {
      german: "nicht",
      translated: "ندارد",
      tone: 'semantic',
    },
  ],
  "lid:state:ST:10|fr": [
    {
      german: "Welche Ministerin",
      translated: "quelle ministre",
      tone: 'semantic',
    },
    {
      german: "welchen Minister",
      translated: "Quel ministre",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "existe",
      tone: 'semantic',
    },
    {
      german: "Sachsen-Anhalt",
      translated: "Saxe-Anhalt",
      tone: 'semantic',
    },
    {
      german: "nicht",
      translated: "pas",
      tone: 'semantic',
    },
  ],
  "lid:state:ST:10|hr": [
    {
      german: "Welche Ministerin",
      translated: "Koji ministar",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "postoji",
      tone: 'semantic',
    },
    {
      german: "Sachsen-Anhalt",
      translated: "Saska-Anhalt",
      tone: 'semantic',
    },
    {
      german: "nicht",
      translated: "ne",
      tone: 'semantic',
    },
  ],
  "lid:state:ST:10|it": [
    {
      german: "Welche Ministerin",
      translated: "Quale ministro",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "esiste",
      tone: 'semantic',
    },
    {
      german: "Sachsen-Anhalt",
      translated: "Land di Sassonia-Anhalt",
      tone: 'semantic',
    },
    {
      german: "nicht",
      translated: "non",
      tone: 'semantic',
    },
  ],
  "lid:state:ST:10|kmr": [
    {
      german: "Welche Ministerin",
      translated: "Kîjan",
      tone: 'semantic',
    },
    {
      german: "welchen Minister",
      translated: "wezîr li",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "tune ye?",
      tone: 'semantic',
    },
    {
      german: "Sachsen-Anhalt",
      translated: "Sachsen-Anhalt",
      tone: 'semantic',
    },
  ],
  "lid:state:ST:10|pl": [
    {
      german: "welchen Minister",
      translated: "Którego ministra",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "ma",
      tone: 'semantic',
    },
    {
      german: "Sachsen-Anhalt",
      translated: "Saksonia-Anhalt",
      tone: 'semantic',
    },
    {
      german: "nicht",
      translated: "nie",
      tone: 'semantic',
    },
  ],
  "lid:state:ST:10|prs": [
    {
      german: "welchen Minister",
      translated: "وزیر",
      tone: 'semantic',
    },
    {
      german: "Sachsen-Anhalt",
      translated: "زاکسن-آنهالت",
      tone: 'semantic',
    },
  ],
  "lid:state:ST:10|ro": [
    {
      german: "Welche Ministerin",
      translated: "Care ministru",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "există",
      tone: 'semantic',
    },
    {
      german: "Sachsen-Anhalt",
      translated: "landului Saxonia-Anhalt",
      tone: 'semantic',
    },
    {
      german: "nicht",
      translated: "nu",
      tone: 'semantic',
    },
  ],
  "lid:state:ST:10|ru": [
    {
      german: "welchen Minister",
      translated: "Какого министра",
      tone: 'semantic',
    },
    {
      german: "Sachsen-Anhalt",
      translated: "Саксония-Анхальт",
      tone: 'semantic',
    },
    {
      german: "nicht",
      translated: "нет",
      tone: 'semantic',
    },
  ],
  "lid:state:ST:10|sq": [
    {
      german: "welchen Minister",
      translated: "Cili ministër",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "ekziston",
      tone: 'semantic',
    },
    {
      german: "Sachsen-Anhalt",
      translated: "nivelin e landit Sachsen-Anhalt",
      tone: 'semantic',
    },
    {
      german: "nicht",
      translated: "nuk",
      tone: 'semantic',
    },
  ],
  "lid:state:ST:10|sr": [
    {
      german: "Welche Ministerin",
      translated: "Koji ministar",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "postoji",
      tone: 'semantic',
    },
    {
      german: "Sachsen-Anhalt",
      translated: "Saksonija-Anhalt",
      tone: 'semantic',
    },
    {
      german: "nicht",
      translated: "ne",
      tone: 'semantic',
    },
  ],
  "lid:state:ST:10|tr": [
    {
      german: "Welche Ministerin",
      translated: "aşağıdaki bakanlıklardan hangisi",
      tone: 'semantic',
    },
    {
      german: "Sachsen-Anhalt",
      translated: "Sachsen-Anhalt eyaletinde",
      tone: 'semantic',
    },
    {
      german: "nicht",
      translated: "yoktur",
      tone: 'semantic',
    },
  ],
  "lid:state:ST:10|uk": [
    {
      german: "Welche Ministerin",
      translated: "міністерки",
      tone: 'semantic',
    },
    {
      german: "welchen Minister",
      translated: "міністра",
      tone: 'semantic',
    },
    {
      german: "Sachsen-Anhalt",
      translated: "Саксонія-Ангальт",
      tone: 'semantic',
    },
    {
      german: "nicht",
      translated: "немає",
      tone: 'semantic',
    },
  ],
  "lid:state:ST:10|vi": [
    {
      german: "welchen Minister",
      translated: "Bộ trưởng nào",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "tồn tại",
      tone: 'semantic',
    },
    {
      german: "Sachsen-Anhalt",
      translated: "Sachsen-Anhalt",
      tone: 'semantic',
    },
    {
      german: "nicht",
      translated: "không",
      tone: 'semantic',
    },
  ],
  "lid:state:ST:1|ar": [
    {
      german: "Welches Wappen",
      translated: "أي شعار",
      tone: 'semantic',
    },
    {
      german: "gehört zum",
      translated: "من الصور",
      tone: 'semantic',
    },
    {
      german: "Bundesland Sachsen-Anhalt",
      translated: "ولاية Sachsen-Anhalt",
      tone: 'semantic',
    },
  ],
  "lid:state:ST:1|bg": [
    {
      german: "Welches Wappen",
      translated: "Кой герб",
      tone: 'semantic',
    },
    {
      german: "gehört zum",
      translated: "принадлежи",
      tone: 'semantic',
    },
    {
      german: "Bundesland Sachsen-Anhalt",
      translated: "на федералната провинция Саксония-Анхалт",
      tone: 'semantic',
    },
  ],
  "lid:state:ST:1|bs": [
    {
      german: "Welches Wappen",
      translated: "Koji grb",
      tone: 'semantic',
    },
    {
      german: "gehört zum",
      translated: "pripada",
      tone: 'semantic',
    },
    {
      german: "Bundesland Sachsen-Anhalt",
      translated: "saveznoj zemlji Saksonija-Anhalt?",
      tone: 'semantic',
    },
  ],
  "lid:state:ST:1|el": [
    {
      german: "Welches Wappen",
      translated: "Ποιο έμβλημα",
      tone: 'semantic',
    },
    {
      german: "gehört zum",
      translated: "ανήκει στο",
      tone: 'semantic',
    },
    {
      german: "Bundesland Sachsen-Anhalt",
      translated: "ομόσπονδο κρατίδιο Σαξονία-Άνχαλτ;",
      tone: 'semantic',
    },
  ],
  "lid:state:ST:1|en": [
    {
      german: "Welches Wappen",
      translated: "Which coat of arms",
      tone: 'semantic',
    },
    {
      german: "gehört zum",
      translated: "belongs to the",
      tone: 'semantic',
    },
    {
      german: "Bundesland Sachsen-Anhalt",
      translated: "federal state of Sachsen-Anhalt",
      tone: 'semantic',
    },
  ],
  "lid:state:ST:1|es": [
    {
      german: "Welches Wappen",
      translated: "¿Qué escudo",
      tone: 'semantic',
    },
    {
      german: "gehört zum",
      translated: "pertenece al",
      tone: 'semantic',
    },
    {
      german: "Bundesland Sachsen-Anhalt",
      translated: "estado federado de Sajonia-Anhalt",
      tone: 'semantic',
    },
  ],
  "lid:state:ST:1|fa": [
    {
      german: "Welches Wappen",
      translated: "کدام نشان",
      tone: 'semantic',
    },
    {
      german: "gehört zum",
      translated: "متعلق به",
      tone: 'semantic',
    },
    {
      german: "Bundesland Sachsen-Anhalt",
      translated: "ایالت زاکسن-آنهالت",
      tone: 'semantic',
    },
  ],
  "lid:state:ST:1|fr": [
    {
      german: "Welches Wappen",
      translated: "Quel blason",
      tone: 'semantic',
    },
    {
      german: "gehört zum",
      translated: "appartient au",
      tone: 'semantic',
    },
    {
      german: "Bundesland Sachsen-Anhalt",
      translated: "Land de Saxe-Anhalt",
      tone: 'semantic',
    },
  ],
  "lid:state:ST:1|hr": [
    {
      german: "Welches Wappen",
      translated: "Koji grb",
      tone: 'semantic',
    },
    {
      german: "gehört zum",
      translated: "pripada",
      tone: 'semantic',
    },
    {
      german: "Bundesland Sachsen-Anhalt",
      translated: "saveznoj zemlji Saska-Anhalt",
      tone: 'semantic',
    },
  ],
  "lid:state:ST:1|it": [
    {
      german: "Welches Wappen",
      translated: "Quale stemma",
      tone: 'semantic',
    },
    {
      german: "gehört zum",
      translated: "appartiene al",
      tone: 'semantic',
    },
    {
      german: "Bundesland Sachsen-Anhalt",
      translated: "Land di Sassonia-Anhalt",
      tone: 'semantic',
    },
  ],
  "lid:state:ST:1|kmr": [
    {
      german: "Welches Wappen",
      translated: "Kîjan nîşan",
      tone: 'semantic',
    },
    {
      german: "gehört zum",
      translated: "a",
      tone: 'semantic',
    },
    {
      german: "Bundesland Sachsen-Anhalt",
      translated: "eyaleta Sachsen-Anhalt ye?",
      tone: 'semantic',
    },
  ],
  "lid:state:ST:1|pl": [
    {
      german: "Welches Wappen",
      translated: "Który herb",
      tone: 'semantic',
    },
    {
      german: "gehört zum",
      translated: "należy do",
      tone: 'semantic',
    },
    {
      german: "Bundesland Sachsen-Anhalt",
      translated: "kraju związkowego Saksonia-Anhalt",
      tone: 'semantic',
    },
  ],
  "lid:state:ST:1|prs": [
    {
      german: "Welches Wappen",
      translated: "کدام نشان",
      tone: 'semantic',
    },
    {
      german: "Bundesland Sachsen-Anhalt",
      translated: "ایالت زاکسن-آنهالت",
      tone: 'semantic',
    },
  ],
  "lid:state:ST:1|ro": [
    {
      german: "Welches Wappen",
      translated: "Care stemă",
      tone: 'semantic',
    },
    {
      german: "gehört zum",
      translated: "aparține",
      tone: 'semantic',
    },
    {
      german: "Bundesland Sachsen-Anhalt",
      translated: "landului Saxonia-Anhalt",
      tone: 'semantic',
    },
  ],
  "lid:state:ST:1|ru": [
    {
      german: "Welches Wappen",
      translated: "Какой герб",
      tone: 'semantic',
    },
    {
      german: "gehört zum",
      translated: "принадлежит",
      tone: 'semantic',
    },
    {
      german: "Bundesland Sachsen-Anhalt",
      translated: "федеральной земле Саксония-Анхальт",
      tone: 'semantic',
    },
  ],
  "lid:state:ST:1|sq": [
    {
      german: "Welches Wappen",
      translated: "Cila stemë",
      tone: 'semantic',
    },
    {
      german: "gehört zum",
      translated: "i përket",
      tone: 'semantic',
    },
    {
      german: "Bundesland Sachsen-Anhalt",
      translated: "landit Sachsen-Anhalt",
      tone: 'semantic',
    },
  ],
  "lid:state:ST:1|sr": [
    {
      german: "Welches Wappen",
      translated: "Koji grb",
      tone: 'semantic',
    },
    {
      german: "gehört zum",
      translated: "pripada",
      tone: 'semantic',
    },
    {
      german: "Bundesland Sachsen-Anhalt",
      translated: "saveznoj pokrajini Saksonija-Anhalt",
      tone: 'semantic',
    },
  ],
  "lid:state:ST:1|tr": [
    {
      german: "Welches Wappen",
      translated: "arması hangisidir",
      tone: 'semantic',
    },
    {
      german: "Bundesland Sachsen-Anhalt",
      translated: "Sachsen-Anhalt eyaletinin",
      tone: 'semantic',
    },
  ],
  "lid:state:ST:1|uk": [
    {
      german: "Welches Wappen",
      translated: "Який герб",
      tone: 'semantic',
    },
    {
      german: "gehört zum",
      translated: "належить",
      tone: 'semantic',
    },
    {
      german: "Bundesland Sachsen-Anhalt",
      translated: "федеральній землі Саксонія-Ангальт",
      tone: 'semantic',
    },
  ],
  "lid:state:ST:1|vi": [
    {
      german: "Welches Wappen",
      translated: "Quốc huy nào",
      tone: 'semantic',
    },
    {
      german: "gehört zum",
      translated: "thuộc",
      tone: 'semantic',
    },
    {
      german: "Bundesland Sachsen-Anhalt",
      translated: "bang Sachsen-Anhalt",
      tone: 'semantic',
    },
  ],
  "lid:state:ST:2|ar": [
    {
      german: "Welches ist",
      translated: "أي",
      tone: 'semantic',
    },
    {
      german: "ein Landkreis",
      translated: "دائرة إدارية",
      tone: 'semantic',
    },
    {
      german: "in Sachsen-Anhalt",
      translated: "في Sachsen-Anhalt",
      tone: 'semantic',
    },
  ],
  "lid:state:ST:2|bg": [
    {
      german: "Welches ist",
      translated: "Кое",
      tone: 'semantic',
    },
    {
      german: "ein Landkreis",
      translated: "от следните е окръг (Landkreis)",
      tone: 'semantic',
    },
    {
      german: "in Sachsen-Anhalt",
      translated: "в Саксония-Анхалт",
      tone: 'semantic',
    },
  ],
  "lid:state:ST:2|bs": [
    {
      german: "Welches ist",
      translated: "Što je",
      tone: 'semantic',
    },
    {
      german: "ein Landkreis",
      translated: "okrug (Landkreis)",
      tone: 'semantic',
    },
    {
      german: "in Sachsen-Anhalt",
      translated: "u saveznoj zemlji Saksonija-Anhalt?",
      tone: 'semantic',
    },
  ],
  "lid:state:ST:2|el": [
    {
      german: "Welches ist",
      translated: "Ποιο από τα παρακάτω είναι",
      tone: 'semantic',
    },
    {
      german: "ein Landkreis",
      translated: "διοικητική περιφέρεια",
      tone: 'semantic',
    },
    {
      german: "in Sachsen-Anhalt",
      translated: "στο Σαξονία-Άνχαλτ",
      tone: 'semantic',
    },
  ],
  "lid:state:ST:2|en": [
    {
      german: "Welches ist",
      translated: "Which",
      tone: 'semantic',
    },
    {
      german: "ein Landkreis",
      translated: "a district",
      tone: 'semantic',
    },
    {
      german: "in Sachsen-Anhalt",
      translated: "in Sachsen-Anhalt",
      tone: 'semantic',
    },
  ],
  "lid:state:ST:2|es": [
    {
      german: "Welches ist",
      translated: "¿Cuál de los siguientes es",
      tone: 'semantic',
    },
    {
      german: "ein Landkreis",
      translated: "un distrito (Landkreis)",
      tone: 'semantic',
    },
    {
      german: "in Sachsen-Anhalt",
      translated: "de Sajonia-Anhalt",
      tone: 'semantic',
    },
  ],
  "lid:state:ST:2|fa": [
    {
      german: "Welches ist",
      translated: "کدام‌یک از",
      tone: 'semantic',
    },
    {
      german: "ein Landkreis",
      translated: "شهرستان",
      tone: 'semantic',
    },
    {
      german: "in Sachsen-Anhalt",
      translated: "در زاکسن-آنهالت",
      tone: 'semantic',
    },
  ],
  "lid:state:ST:2|fr": [
    {
      german: "Welches ist",
      translated: "Lequel",
      tone: 'semantic',
    },
    {
      german: "ein Landkreis",
      translated: "arrondissement (Landkreis)",
      tone: 'semantic',
    },
    {
      german: "in Sachsen-Anhalt",
      translated: "de Saxe-Anhalt",
      tone: 'semantic',
    },
  ],
  "lid:state:ST:2|hr": [
    {
      german: "Welches ist",
      translated: "Što je",
      tone: 'semantic',
    },
    {
      german: "ein Landkreis",
      translated: "okrug (Landkreis)",
      tone: 'semantic',
    },
    {
      german: "in Sachsen-Anhalt",
      translated: "u saveznoj zemlji Saska-Anhalt?",
      tone: 'semantic',
    },
  ],
  "lid:state:ST:2|it": [
    {
      german: "Welches ist",
      translated: "Quale dei seguenti",
      tone: 'semantic',
    },
    {
      german: "ein Landkreis",
      translated: "un distretto (Landkreis)",
      tone: 'semantic',
    },
    {
      german: "in Sachsen-Anhalt",
      translated: "di Sassonia-Anhalt",
      tone: 'semantic',
    },
  ],
  "lid:state:ST:2|kmr": [
    {
      german: "Welches ist",
      translated: "Kîjan ji van navçeyek",
      tone: 'semantic',
    },
    {
      german: "ein Landkreis",
      translated: "(Landkreis)",
      tone: 'semantic',
    },
    {
      german: "in Sachsen-Anhalt",
      translated: "li Sachsen-Anhalt",
      tone: 'semantic',
    },
  ],
  "lid:state:ST:2|pl": [
    {
      german: "Welches ist",
      translated: "Który z",
      tone: 'semantic',
    },
    {
      german: "ein Landkreis",
      translated: "powiatem (Landkreis)",
      tone: 'semantic',
    },
    {
      german: "in Sachsen-Anhalt",
      translated: "w Saksonia-Anhalt?",
      tone: 'semantic',
    },
  ],
  "lid:state:ST:2|prs": [
    {
      german: "Welches ist",
      translated: "کدام‌یک از",
      tone: 'semantic',
    },
    {
      german: "ein Landkreis",
      translated: "شهرستان",
      tone: 'semantic',
    },
    {
      german: "in Sachsen-Anhalt",
      translated: "در زاکسن-آنهالت",
      tone: 'semantic',
    },
  ],
  "lid:state:ST:2|ro": [
    {
      german: "Welches ist",
      translated: "Care dintre următoarele",
      tone: 'semantic',
    },
    {
      german: "ein Landkreis",
      translated: "district (Landkreis)",
      tone: 'semantic',
    },
    {
      german: "in Sachsen-Anhalt",
      translated: "din Saxonia-Anhalt?",
      tone: 'semantic',
    },
  ],
  "lid:state:ST:2|ru": [
    {
      german: "Welches ist",
      translated: "Какой из",
      tone: 'semantic',
    },
    {
      german: "ein Landkreis",
      translated: "районом",
      tone: 'semantic',
    },
    {
      german: "in Sachsen-Anhalt",
      translated: "в федеральной земле Саксония-Анхальт",
      tone: 'semantic',
    },
  ],
  "lid:state:ST:2|sq": [
    {
      german: "Welches ist",
      translated: "Cila nga këto është",
      tone: 'semantic',
    },
    {
      german: "ein Landkreis",
      translated: "qark (Landkreis)",
      tone: 'semantic',
    },
    {
      german: "in Sachsen-Anhalt",
      translated: "në Sachsen-Anhalt",
      tone: 'semantic',
    },
  ],
  "lid:state:ST:2|sr": [
    {
      german: "Welches ist",
      translated: "Šta je od navedenoga",
      tone: 'semantic',
    },
    {
      german: "ein Landkreis",
      translated: "okrug",
      tone: 'semantic',
    },
    {
      german: "in Sachsen-Anhalt",
      translated: "u saveznoj pokrajini Saksonija-Anhalt?",
      tone: 'semantic',
    },
  ],
  "lid:state:ST:2|tr": [
    {
      german: "Welches ist",
      translated: "Aşağıdakilerden hangisi",
      tone: 'semantic',
    },
    {
      german: "ein Landkreis",
      translated: "Landkreis (ilçe/idari bölge)",
      tone: 'semantic',
    },
    {
      german: "in Sachsen-Anhalt",
      translated: "Sachsen-Anhalt eyaletinde bulunan",
      tone: 'semantic',
    },
  ],
  "lid:state:ST:2|uk": [
    {
      german: "Welches ist",
      translated: "Який із наведених",
      tone: 'semantic',
    },
    {
      german: "ein Landkreis",
      translated: "районів",
      tone: 'semantic',
    },
    {
      german: "in Sachsen-Anhalt",
      translated: "у федеральній землі Саксонія-Ангальт",
      tone: 'semantic',
    },
  ],
  "lid:state:ST:2|vi": [
    {
      german: "Welches ist",
      translated: "Địa danh nào sau đây là",
      tone: 'semantic',
    },
    {
      german: "ein Landkreis",
      translated: "một huyện",
      tone: 'semantic',
    },
    {
      german: "in Sachsen-Anhalt",
      translated: "bang Sachsen-Anhalt",
      tone: 'semantic',
    },
  ],
  "lid:state:ST:3|ar": [
    {
      german: "Für wie viele Jahre",
      translated: "لمدة كم سنة",
      tone: 'semantic',
    },
    {
      german: "der Landtag",
      translated: "برلمان الولاية",
      tone: 'semantic',
    },
    {
      german: "in Sachsen-Anhalt",
      translated: "في Sachsen-Anhalt",
      tone: 'semantic',
    },
    {
      german: "gewählt",
      translated: "يُنتخب",
      tone: 'semantic',
    },
  ],
  "lid:state:ST:3|bg": [
    {
      german: "Für wie viele Jahre",
      translated: "За колко години",
      tone: 'semantic',
    },
    {
      german: "der Landtag",
      translated: "парламентът",
      tone: 'semantic',
    },
    {
      german: "in Sachsen-Anhalt",
      translated: "на провинция Саксония-Анхалт",
      tone: 'semantic',
    },
    {
      german: "gewählt",
      translated: "се избира",
      tone: 'semantic',
    },
  ],
  "lid:state:ST:3|bs": [
    {
      german: "Für wie viele Jahre",
      translated: "Na koliko se godina",
      tone: 'semantic',
    },
    {
      german: "der Landtag",
      translated: "parlament savezne zemlje",
      tone: 'semantic',
    },
    {
      german: "in Sachsen-Anhalt",
      translated: "Saksonija-Anhalt",
      tone: 'semantic',
    },
    {
      german: "gewählt",
      translated: "bira",
      tone: 'semantic',
    },
  ],
  "lid:state:ST:3|el": [
    {
      german: "Für wie viele Jahre",
      translated: "Για πόσα χρόνια",
      tone: 'semantic',
    },
    {
      german: "der Landtag",
      translated: "το Landtag",
      tone: 'semantic',
    },
    {
      german: "in Sachsen-Anhalt",
      translated: "του Σαξονία-Άνχαλτ",
      tone: 'semantic',
    },
    {
      german: "gewählt",
      translated: "εκλέγεται",
      tone: 'semantic',
    },
  ],
  "lid:state:ST:3|en": [
    {
      german: "Für wie viele Jahre",
      translated: "how many years",
      tone: 'semantic',
    },
    {
      german: "der Landtag",
      translated: "state parliament",
      tone: 'semantic',
    },
    {
      german: "in Sachsen-Anhalt",
      translated: "Sachsen-Anhalt",
      tone: 'semantic',
    },
    {
      german: "gewählt",
      translated: "elected",
      tone: 'semantic',
    },
  ],
  "lid:state:ST:3|es": [
    {
      german: "Für wie viele Jahre",
      translated: "¿Por cuántos años",
      tone: 'semantic',
    },
    {
      german: "der Landtag",
      translated: "el parlamento regional",
      tone: 'semantic',
    },
    {
      german: "in Sachsen-Anhalt",
      translated: "en Sajonia-Anhalt",
      tone: 'semantic',
    },
    {
      german: "gewählt",
      translated: "se elige",
      tone: 'semantic',
    },
  ],
  "lid:state:ST:3|fa": [
    {
      german: "Für wie viele Jahre",
      translated: "چند سال",
      tone: 'semantic',
    },
    {
      german: "der Landtag",
      translated: "پارلمان ایالتی",
      tone: 'semantic',
    },
    {
      german: "in Sachsen-Anhalt",
      translated: "زاکسن-آنهالت",
      tone: 'semantic',
    },
    {
      german: "gewählt",
      translated: "انتخاب می‌شود",
      tone: 'semantic',
    },
  ],
  "lid:state:ST:3|fr": [
    {
      german: "Für wie viele Jahre",
      translated: "Pour combien d’années",
      tone: 'semantic',
    },
    {
      german: "der Landtag",
      translated: "le Landtag",
      tone: 'semantic',
    },
    {
      german: "in Sachsen-Anhalt",
      translated: "de Saxe-Anhalt",
      tone: 'semantic',
    },
    {
      german: "gewählt",
      translated: "est-il élu",
      tone: 'semantic',
    },
  ],
  "lid:state:ST:3|hr": [
    {
      german: "Für wie viele Jahre",
      translated: "Na koliko se godina",
      tone: 'semantic',
    },
    {
      german: "der Landtag",
      translated: "parlament savezne zemlje",
      tone: 'semantic',
    },
    {
      german: "in Sachsen-Anhalt",
      translated: "Saska-Anhalt",
      tone: 'semantic',
    },
    {
      german: "gewählt",
      translated: "bira",
      tone: 'semantic',
    },
  ],
  "lid:state:ST:3|it": [
    {
      german: "Für wie viele Jahre",
      translated: "Per quanti anni",
      tone: 'semantic',
    },
    {
      german: "der Landtag",
      translated: "il Landtag",
      tone: 'semantic',
    },
    {
      german: "in Sachsen-Anhalt",
      translated: "di Sassonia-Anhalt",
      tone: 'semantic',
    },
    {
      german: "gewählt",
      translated: "viene eletto",
      tone: 'semantic',
    },
  ],
  "lid:state:ST:3|kmr": [
    {
      german: "Für wie viele Jahre",
      translated: "çend salan",
      tone: 'semantic',
    },
    {
      german: "der Landtag",
      translated: "Landtag",
      tone: 'semantic',
    },
    {
      german: "in Sachsen-Anhalt",
      translated: "a Sachsen-Anhalt",
      tone: 'semantic',
    },
    {
      german: "gewählt",
      translated: "hilbijartin",
      tone: 'semantic',
    },
  ],
  "lid:state:ST:3|pl": [
    {
      german: "Für wie viele Jahre",
      translated: "Na ile lat",
      tone: 'semantic',
    },
    {
      german: "der Landtag",
      translated: "parlament",
      tone: 'semantic',
    },
    {
      german: "in Sachsen-Anhalt",
      translated: "kraju związkowego Saksonia-Anhalt",
      tone: 'semantic',
    },
    {
      german: "gewählt",
      translated: "wybierany",
      tone: 'semantic',
    },
  ],
  "lid:state:ST:3|prs": [
    {
      german: "Für wie viele Jahre",
      translated: "چند سال",
      tone: 'semantic',
    },
    {
      german: "der Landtag",
      translated: "پارلمان ایالتی",
      tone: 'semantic',
    },
    {
      german: "in Sachsen-Anhalt",
      translated: "زاکسن-آنهالت",
      tone: 'semantic',
    },
    {
      german: "gewählt",
      translated: "انتخاب می‌شود",
      tone: 'semantic',
    },
  ],
  "lid:state:ST:3|ro": [
    {
      german: "Für wie viele Jahre",
      translated: "Pentru câți ani",
      tone: 'semantic',
    },
    {
      german: "der Landtag",
      translated: "parlamentul",
      tone: 'semantic',
    },
    {
      german: "in Sachsen-Anhalt",
      translated: "landului Saxonia-Anhalt",
      tone: 'semantic',
    },
    {
      german: "gewählt",
      translated: "ales",
      tone: 'semantic',
    },
  ],
  "lid:state:ST:3|ru": [
    {
      german: "Für wie viele Jahre",
      translated: "На сколько лет",
      tone: 'semantic',
    },
    {
      german: "der Landtag",
      translated: "ландтаг",
      tone: 'semantic',
    },
    {
      german: "in Sachsen-Anhalt",
      translated: "в федеральной земле Саксония-Анхальт",
      tone: 'semantic',
    },
    {
      german: "gewählt",
      translated: "избирается",
      tone: 'semantic',
    },
  ],
  "lid:state:ST:3|sq": [
    {
      german: "Für wie viele Jahre",
      translated: "Për sa vjet",
      tone: 'semantic',
    },
    {
      german: "der Landtag",
      translated: "Landtagu i",
      tone: 'semantic',
    },
    {
      german: "in Sachsen-Anhalt",
      translated: "Sachsen-Anhalt",
      tone: 'semantic',
    },
    {
      german: "gewählt",
      translated: "zgjidhet",
      tone: 'semantic',
    },
  ],
  "lid:state:ST:3|sr": [
    {
      german: "Für wie viele Jahre",
      translated: "Na koliko se godina",
      tone: 'semantic',
    },
    {
      german: "der Landtag",
      translated: "parlament",
      tone: 'semantic',
    },
    {
      german: "in Sachsen-Anhalt",
      translated: "savezne pokrajine Saksonija-Anhalt",
      tone: 'semantic',
    },
    {
      german: "gewählt",
      translated: "bira",
      tone: 'semantic',
    },
  ],
  "lid:state:ST:3|tr": [
    {
      german: "Für wie viele Jahre",
      translated: "kaç yıllığına",
      tone: 'semantic',
    },
    {
      german: "der Landtag",
      translated: "eyalet parlamentosu",
      tone: 'semantic',
    },
    {
      german: "in Sachsen-Anhalt",
      translated: "Sachsen-Anhalt",
      tone: 'semantic',
    },
    {
      german: "gewählt",
      translated: "seçilir",
      tone: 'semantic',
    },
  ],
  "lid:state:ST:3|uk": [
    {
      german: "Für wie viele Jahre",
      translated: "На скільки років",
      tone: 'semantic',
    },
    {
      german: "der Landtag",
      translated: "земельний парламент",
      tone: 'semantic',
    },
    {
      german: "in Sachsen-Anhalt",
      translated: "у федеральній землі Саксонія-Ангальт",
      tone: 'semantic',
    },
    {
      german: "gewählt",
      translated: "обирають",
      tone: 'semantic',
    },
  ],
  "lid:state:ST:3|vi": [
    {
      german: "Für wie viele Jahre",
      translated: "bao nhiêu năm",
      tone: 'semantic',
    },
    {
      german: "der Landtag",
      translated: "Nghị viện bang (Landtag)",
      tone: 'semantic',
    },
    {
      german: "in Sachsen-Anhalt",
      translated: "của Sachsen-Anhalt",
      tone: 'semantic',
    },
    {
      german: "gewählt",
      translated: "được bầu",
      tone: 'semantic',
    },
  ],
  "lid:state:ST:4|ar": [
    {
      german: "Ab welchem Alter",
      translated: "ابتداءً من أي سن",
      tone: 'semantic',
    },
    {
      german: "darf man",
      translated: "يحق",
      tone: 'semantic',
    },
    {
      german: "in Sachsen-Anhalt",
      translated: "في Sachsen-Anhalt",
      tone: 'semantic',
    },
    {
      german: "bei Kommunalwahlen",
      translated: "في الانتخابات المحلية",
      tone: 'semantic',
    },
    {
      german: "wählen",
      translated: "التصويت",
      tone: 'semantic',
    },
  ],
  "lid:state:ST:4|bg": [
    {
      german: "Ab welchem Alter",
      translated: "От каква възраст",
      tone: 'semantic',
    },
    {
      german: "darf man",
      translated: "може да",
      tone: 'semantic',
    },
    {
      german: "in Sachsen-Anhalt",
      translated: "в Саксония-Анхалт",
      tone: 'semantic',
    },
    {
      german: "bei Kommunalwahlen",
      translated: "на общински избори",
      tone: 'semantic',
    },
    {
      german: "wählen",
      translated: "гласува",
      tone: 'semantic',
    },
  ],
  "lid:state:ST:4|bs": [
    {
      german: "Ab welchem Alter",
      translated: "Od koje se dobi",
      tone: 'semantic',
    },
    {
      german: "darf man",
      translated: "može",
      tone: 'semantic',
    },
    {
      german: "in Sachsen-Anhalt",
      translated: "u saveznoj zemlji Saksonija-Anhalt",
      tone: 'semantic',
    },
    {
      german: "bei Kommunalwahlen",
      translated: "na lokalnim izborima",
      tone: 'semantic',
    },
    {
      german: "wählen",
      translated: "glasovati",
      tone: 'semantic',
    },
  ],
  "lid:state:ST:4|el": [
    {
      german: "Ab welchem Alter",
      translated: "Από ποια ηλικία",
      tone: 'semantic',
    },
    {
      german: "darf man",
      translated: "μπορεί κάποιος να",
      tone: 'semantic',
    },
    {
      german: "in Sachsen-Anhalt",
      translated: "στο Σαξονία-Άνχαλτ",
      tone: 'semantic',
    },
    {
      german: "bei Kommunalwahlen",
      translated: "στις δημοτικές εκλογές",
      tone: 'semantic',
    },
    {
      german: "wählen",
      translated: "ψηφίσει",
      tone: 'semantic',
    },
  ],
  "lid:state:ST:4|en": [
    {
      german: "Ab welchem Alter",
      translated: "From what age",
      tone: 'semantic',
    },
    {
      german: "darf man",
      translated: "can you",
      tone: 'semantic',
    },
    {
      german: "in Sachsen-Anhalt",
      translated: "in Sachsen-Anhalt",
      tone: 'semantic',
    },
    {
      german: "bei Kommunalwahlen",
      translated: "in local elections",
      tone: 'semantic',
    },
    {
      german: "wählen",
      translated: "vote",
      tone: 'semantic',
    },
  ],
  "lid:state:ST:4|es": [
    {
      german: "Ab welchem Alter",
      translated: "¿A partir de qué edad",
      tone: 'semantic',
    },
    {
      german: "darf man",
      translated: "se puede",
      tone: 'semantic',
    },
    {
      german: "in Sachsen-Anhalt",
      translated: "de Sajonia-Anhalt",
      tone: 'semantic',
    },
    {
      german: "bei Kommunalwahlen",
      translated: "en las elecciones municipales",
      tone: 'semantic',
    },
    {
      german: "wählen",
      translated: "votar",
      tone: 'semantic',
    },
  ],
  "lid:state:ST:4|fa": [
    {
      german: "Ab welchem Alter",
      translated: "از چه سنی",
      tone: 'semantic',
    },
    {
      german: "darf man",
      translated: "می‌توان",
      tone: 'semantic',
    },
    {
      german: "bei Kommunalwahlen",
      translated: "در انتخابات محلی",
      tone: 'semantic',
    },
    {
      german: "wählen",
      translated: "رأی داد",
      tone: 'semantic',
    },
  ],
  "lid:state:ST:4|fr": [
    {
      german: "Ab welchem Alter",
      translated: "À partir de quel âge",
      tone: 'semantic',
    },
    {
      german: "darf man",
      translated: "peut-on",
      tone: 'semantic',
    },
    {
      german: "in Sachsen-Anhalt",
      translated: "en Saxe-Anhalt",
      tone: 'semantic',
    },
    {
      german: "bei Kommunalwahlen",
      translated: "aux élections municipales",
      tone: 'semantic',
    },
    {
      german: "wählen",
      translated: "voter",
      tone: 'semantic',
    },
  ],
  "lid:state:ST:4|hr": [
    {
      german: "Ab welchem Alter",
      translated: "Od koje se dobi",
      tone: 'semantic',
    },
    {
      german: "darf man",
      translated: "može",
      tone: 'semantic',
    },
    {
      german: "in Sachsen-Anhalt",
      translated: "u saveznoj zemlji Saska-Anhalt",
      tone: 'semantic',
    },
    {
      german: "bei Kommunalwahlen",
      translated: "na lokalnim izborima",
      tone: 'semantic',
    },
    {
      german: "wählen",
      translated: "glasovati",
      tone: 'semantic',
    },
  ],
  "lid:state:ST:4|it": [
    {
      german: "Ab welchem Alter",
      translated: "Da quale età",
      tone: 'semantic',
    },
    {
      german: "darf man",
      translated: "si può",
      tone: 'semantic',
    },
    {
      german: "in Sachsen-Anhalt",
      translated: "in Sassonia-Anhalt",
      tone: 'semantic',
    },
    {
      german: "bei Kommunalwahlen",
      translated: "alle elezioni comunali",
      tone: 'semantic',
    },
    {
      german: "wählen",
      translated: "votare",
      tone: 'semantic',
    },
  ],
  "lid:state:ST:4|kmr": [
    {
      german: "Ab welchem Alter",
      translated: "Ji kîjan temenê",
      tone: 'semantic',
    },
    {
      german: "darf man",
      translated: "dikare",
      tone: 'semantic',
    },
    {
      german: "in Sachsen-Anhalt",
      translated: "li Sachsen-Anhalt",
      tone: 'semantic',
    },
    {
      german: "bei Kommunalwahlen",
      translated: "di hilbijartinên şaredariyê de",
      tone: 'semantic',
    },
    {
      german: "wählen",
      translated: "deng were dayîn",
      tone: 'semantic',
    },
  ],
  "lid:state:ST:4|pl": [
    {
      german: "Ab welchem Alter",
      translated: "Od jakiego wieku",
      tone: 'semantic',
    },
    {
      german: "darf man",
      translated: "można",
      tone: 'semantic',
    },
    {
      german: "in Sachsen-Anhalt",
      translated: "w Saksonia-Anhalt",
      tone: 'semantic',
    },
    {
      german: "bei Kommunalwahlen",
      translated: "w wyborach samorządowych",
      tone: 'semantic',
    },
    {
      german: "wählen",
      translated: "głosować",
      tone: 'semantic',
    },
  ],
  "lid:state:ST:4|prs": [
    {
      german: "Ab welchem Alter",
      translated: "از چه سنی",
      tone: 'semantic',
    },
    {
      german: "darf man",
      translated: "می‌توان",
      tone: 'semantic',
    },
    {
      german: "in Sachsen-Anhalt",
      translated: "زاکسن-آنهالت",
      tone: 'semantic',
    },
    {
      german: "bei Kommunalwahlen",
      translated: "در انتخابات شاروالی",
      tone: 'semantic',
    },
    {
      german: "wählen",
      translated: "رأی داد",
      tone: 'semantic',
    },
  ],
  "lid:state:ST:4|ro": [
    {
      german: "Ab welchem Alter",
      translated: "De la ce vârstă",
      tone: 'semantic',
    },
    {
      german: "darf man",
      translated: "se poate",
      tone: 'semantic',
    },
    {
      german: "in Sachsen-Anhalt",
      translated: "din Saxonia-Anhalt",
      tone: 'semantic',
    },
    {
      german: "bei Kommunalwahlen",
      translated: "la alegerile locale",
      tone: 'semantic',
    },
    {
      german: "wählen",
      translated: "vota",
      tone: 'semantic',
    },
  ],
  "lid:state:ST:4|ru": [
    {
      german: "Ab welchem Alter",
      translated: "С какого возраста",
      tone: 'semantic',
    },
    {
      german: "darf man",
      translated: "можно",
      tone: 'semantic',
    },
    {
      german: "in Sachsen-Anhalt",
      translated: "в федеральной земле Саксония-Анхальт",
      tone: 'semantic',
    },
    {
      german: "bei Kommunalwahlen",
      translated: "на муниципальных выборах",
      tone: 'semantic',
    },
    {
      german: "wählen",
      translated: "голосовать",
      tone: 'semantic',
    },
  ],
  "lid:state:ST:4|sq": [
    {
      german: "Ab welchem Alter",
      translated: "Nga cila",
      tone: 'semantic',
    },
    {
      german: "darf man",
      translated: "mund të",
      tone: 'semantic',
    },
    {
      german: "in Sachsen-Anhalt",
      translated: "në Sachsen-Anhalt",
      tone: 'semantic',
    },
    {
      german: "bei Kommunalwahlen",
      translated: "votohet",
      tone: 'semantic',
    },
  ],
  "lid:state:ST:4|sr": [
    {
      german: "Ab welchem Alter",
      translated: "Od koje se dobi",
      tone: 'semantic',
    },
    {
      german: "darf man",
      translated: "može",
      tone: 'semantic',
    },
    {
      german: "in Sachsen-Anhalt",
      translated: "u saveznoj pokrajini Saksonija-Anhalt",
      tone: 'semantic',
    },
    {
      german: "bei Kommunalwahlen",
      translated: "na lokalnim izborima",
      tone: 'semantic',
    },
    {
      german: "wählen",
      translated: "glasati",
      tone: 'semantic',
    },
  ],
  "lid:state:ST:4|tr": [
    {
      german: "Ab welchem Alter",
      translated: "kaç yaşından itibaren",
      tone: 'semantic',
    },
    {
      german: "darf man",
      translated: "oy kullanılabilir",
      tone: 'semantic',
    },
    {
      german: "in Sachsen-Anhalt",
      translated: "Sachsen-Anhalt eyaletinde",
      tone: 'semantic',
    },
    {
      german: "bei Kommunalwahlen",
      translated: "yerel seçimlerde",
      tone: 'semantic',
    },
  ],
  "lid:state:ST:4|uk": [
    {
      german: "Ab welchem Alter",
      translated: "З якого віку",
      tone: 'semantic',
    },
    {
      german: "darf man",
      translated: "можна",
      tone: 'semantic',
    },
    {
      german: "in Sachsen-Anhalt",
      translated: "у федеральній землі Саксонія-Ангальт",
      tone: 'semantic',
    },
    {
      german: "bei Kommunalwahlen",
      translated: "на муніципальних виборах",
      tone: 'semantic',
    },
    {
      german: "wählen",
      translated: "голосувати",
      tone: 'semantic',
    },
  ],
  "lid:state:ST:4|vi": [
    {
      german: "Ab welchem Alter",
      translated: "Từ bao nhiêu tuổi",
      tone: 'semantic',
    },
    {
      german: "darf man",
      translated: "có thể",
      tone: 'semantic',
    },
    {
      german: "in Sachsen-Anhalt",
      translated: "ở bang Sachsen-Anhalt",
      tone: 'semantic',
    },
    {
      german: "bei Kommunalwahlen",
      translated: "trong bầu cử địa phương",
      tone: 'semantic',
    },
    {
      german: "wählen",
      translated: "bỏ phiếu",
      tone: 'semantic',
    },
  ],
  "lid:state:ST:5|ar": [
    {
      german: "Welche Farben",
      translated: "ما",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "ألوان",
      tone: 'semantic',
    },
    {
      german: "die Landesflagge",
      translated: "علم",
      tone: 'semantic',
    },
    {
      german: "von Sachsen-Anhalt",
      translated: "ولاية Sachsen-Anhalt",
      tone: 'semantic',
    },
  ],
  "lid:state:ST:5|bg": [
    {
      german: "Welche Farben",
      translated: "Какви са цветовете",
      tone: 'semantic',
    },
    {
      german: "die Landesflagge",
      translated: "знамето",
      tone: 'semantic',
    },
    {
      german: "von Sachsen-Anhalt",
      translated: "на провинция Саксония-Анхалт",
      tone: 'semantic',
    },
  ],
  "lid:state:ST:5|bs": [
    {
      german: "Welche Farben",
      translated: "Koje su boje",
      tone: 'semantic',
    },
    {
      german: "die Landesflagge",
      translated: "zastave",
      tone: 'semantic',
    },
    {
      german: "von Sachsen-Anhalt",
      translated: "savezne zemlje Saksonija-Anhalt",
      tone: 'semantic',
    },
  ],
  "lid:state:ST:5|el": [
    {
      german: "Welche Farben",
      translated: "Ποια είναι τα χρώματα",
      tone: 'semantic',
    },
    {
      german: "die Landesflagge",
      translated: "της σημαίας του κρατιδίου",
      tone: 'semantic',
    },
    {
      german: "von Sachsen-Anhalt",
      translated: "Σαξονία-Άνχαλτ",
      tone: 'semantic',
    },
  ],
  "lid:state:ST:5|en": [
    {
      german: "Welche Farben",
      translated: "What colors",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "does",
      tone: 'semantic',
    },
    {
      german: "die Landesflagge",
      translated: "state flag",
      tone: 'semantic',
    },
    {
      german: "von Sachsen-Anhalt",
      translated: "of Sachsen-Anhalt",
      tone: 'semantic',
    },
  ],
  "lid:state:ST:5|es": [
    {
      german: "Welche Farben",
      translated: "¿Qué colores",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "tiene",
      tone: 'semantic',
    },
    {
      german: "die Landesflagge",
      translated: "la bandera regional",
      tone: 'semantic',
    },
    {
      german: "von Sachsen-Anhalt",
      translated: "de Sajonia-Anhalt",
      tone: 'semantic',
    },
  ],
  "lid:state:ST:5|fa": [
    {
      german: "Welche Farben",
      translated: "رنگ‌های",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "کدام‌اند",
      tone: 'semantic',
    },
    {
      german: "die Landesflagge",
      translated: "پرچم",
      tone: 'semantic',
    },
    {
      german: "von Sachsen-Anhalt",
      translated: "ایالت زاکسن-آنهالت",
      tone: 'semantic',
    },
  ],
  "lid:state:ST:5|fr": [
    {
      german: "Welche Farben",
      translated: "Quelles sont les couleurs",
      tone: 'semantic',
    },
    {
      german: "die Landesflagge",
      translated: "du drapeau du Land",
      tone: 'semantic',
    },
    {
      german: "von Sachsen-Anhalt",
      translated: "de Saxe-Anhalt",
      tone: 'semantic',
    },
  ],
  "lid:state:ST:5|hr": [
    {
      german: "Welche Farben",
      translated: "Koje su boje",
      tone: 'semantic',
    },
    {
      german: "die Landesflagge",
      translated: "zastave",
      tone: 'semantic',
    },
    {
      german: "von Sachsen-Anhalt",
      translated: "savezne zemlje Saska-Anhalt",
      tone: 'semantic',
    },
  ],
  "lid:state:ST:5|it": [
    {
      german: "Welche Farben",
      translated: "Quali sono i colori",
      tone: 'semantic',
    },
    {
      german: "die Landesflagge",
      translated: "della bandiera del Land",
      tone: 'semantic',
    },
    {
      german: "von Sachsen-Anhalt",
      translated: "di Sassonia-Anhalt",
      tone: 'semantic',
    },
  ],
  "lid:state:ST:5|kmr": [
    {
      german: "Welche Farben",
      translated: "Rengên",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "çi ne",
      tone: 'semantic',
    },
    {
      german: "die Landesflagge",
      translated: "ala eyaleta",
      tone: 'semantic',
    },
    {
      german: "von Sachsen-Anhalt",
      translated: "Sachsen-Anhalt",
      tone: 'semantic',
    },
  ],
  "lid:state:ST:5|pl": [
    {
      german: "Welche Farben",
      translated: "Jakie są kolory",
      tone: 'semantic',
    },
    {
      german: "die Landesflagge",
      translated: "flagi kraju związkowego",
      tone: 'semantic',
    },
    {
      german: "von Sachsen-Anhalt",
      translated: "Saksonia-Anhalt",
      tone: 'semantic',
    },
  ],
  "lid:state:ST:5|prs": [
    {
      german: "Welche Farben",
      translated: "رنگ‌های",
      tone: 'semantic',
    },
    {
      german: "die Landesflagge",
      translated: "پرچم ایالت",
      tone: 'semantic',
    },
    {
      german: "von Sachsen-Anhalt",
      translated: "زاکسن-آنهالت",
      tone: 'semantic',
    },
  ],
  "lid:state:ST:5|ro": [
    {
      german: "Welche Farben",
      translated: "Care sunt culorile",
      tone: 'semantic',
    },
    {
      german: "die Landesflagge",
      translated: "drapelului landului",
      tone: 'semantic',
    },
    {
      german: "von Sachsen-Anhalt",
      translated: "Saxonia-Anhalt",
      tone: 'semantic',
    },
  ],
  "lid:state:ST:5|ru": [
    {
      german: "Welche Farben",
      translated: "Какие цвета",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "у",
      tone: 'semantic',
    },
    {
      german: "die Landesflagge",
      translated: "флага земли",
      tone: 'semantic',
    },
    {
      german: "von Sachsen-Anhalt",
      translated: "Саксония-Анхальт",
      tone: 'semantic',
    },
  ],
  "lid:state:ST:5|sq": [
    {
      german: "Welche Farben",
      translated: "Cilat janë ngjyrat",
      tone: 'semantic',
    },
    {
      german: "die Landesflagge",
      translated: "flamurit",
      tone: 'semantic',
    },
    {
      german: "von Sachsen-Anhalt",
      translated: "të landit Sachsen-Anhalt",
      tone: 'semantic',
    },
  ],
  "lid:state:ST:5|sr": [
    {
      german: "Welche Farben",
      translated: "Koje su boje",
      tone: 'semantic',
    },
    {
      german: "die Landesflagge",
      translated: "zastave",
      tone: 'semantic',
    },
    {
      german: "von Sachsen-Anhalt",
      translated: "savezne pokrajine Saksonija-Anhalt",
      tone: 'semantic',
    },
  ],
  "lid:state:ST:5|tr": [
    {
      german: "Welche Farben",
      translated: "renkleri nelerdir",
      tone: 'semantic',
    },
    {
      german: "die Landesflagge",
      translated: "eyalet bayrağının",
      tone: 'semantic',
    },
    {
      german: "von Sachsen-Anhalt",
      translated: "Sachsen-Anhalt",
      tone: 'semantic',
    },
  ],
  "lid:state:ST:5|uk": [
    {
      german: "Welche Farben",
      translated: "Які кольори",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "має",
      tone: 'semantic',
    },
    {
      german: "die Landesflagge",
      translated: "прапор федеральної землі",
      tone: 'semantic',
    },
    {
      german: "von Sachsen-Anhalt",
      translated: "Саксонія-Ангальт",
      tone: 'semantic',
    },
  ],
  "lid:state:ST:5|vi": [
    {
      german: "Welche Farben",
      translated: "Màu của",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "là",
      tone: 'semantic',
    },
    {
      german: "die Landesflagge",
      translated: "cờ bang",
      tone: 'semantic',
    },
    {
      german: "von Sachsen-Anhalt",
      translated: "Sachsen-Anhalt",
      tone: 'semantic',
    },
  ],
  "lid:state:ST:6|ar": [
    {
      german: "Wo",
      translated: "أين",
      tone: 'semantic',
    },
    {
      german: "können Sie",
      translated: "يمكنك",
      tone: 'semantic',
    },
    {
      german: "in Sachsen-Anhalt",
      translated: "في Sachsen-Anhalt",
      tone: 'semantic',
    },
    {
      german: "über politische Themen",
      translated: "عن القضايا السياسية",
      tone: 'semantic',
    },
    {
      german: "informieren",
      translated: "الحصول على معلومات",
      tone: 'semantic',
    },
  ],
  "lid:state:ST:6|bg": [
    {
      german: "Wo",
      translated: "Къде",
      tone: 'semantic',
    },
    {
      german: "können Sie",
      translated: "можете",
      tone: 'semantic',
    },
    {
      german: "über politische Themen",
      translated: "по политически теми",
      tone: 'semantic',
    },
    {
      german: "informieren",
      translated: "да получите информация",
      tone: 'semantic',
    },
  ],
  "lid:state:ST:6|bs": [
    {
      german: "Wo",
      translated: "Gdje",
      tone: 'semantic',
    },
    {
      german: "können Sie",
      translated: "mogu",
      tone: 'semantic',
    },
    {
      german: "sich",
      translated: "se",
      tone: 'semantic',
    },
    {
      german: "in Sachsen-Anhalt",
      translated: "u saveznoj zemlji Saksonija-Anhalt",
      tone: 'semantic',
    },
    {
      german: "über politische Themen",
      translated: "o političkim temama",
      tone: 'semantic',
    },
    {
      german: "informieren",
      translated: "dobiti informacije",
      tone: 'semantic',
    },
  ],
  "lid:state:ST:6|el": [
    {
      german: "Wo",
      translated: "Πού",
      tone: 'semantic',
    },
    {
      german: "können Sie",
      translated: "μπορείτε",
      tone: 'semantic',
    },
    {
      german: "sich",
      translated: "να",
      tone: 'semantic',
    },
    {
      german: "in Sachsen-Anhalt",
      translated: "στο Σαξονία-Άνχαλτ",
      tone: 'semantic',
    },
    {
      german: "über politische Themen",
      translated: "για πολιτικά θέματα",
      tone: 'semantic',
    },
    {
      german: "informieren",
      translated: "ενημερωθείτε",
      tone: 'semantic',
    },
  ],
  "lid:state:ST:6|en": [
    {
      german: "Wo",
      translated: "Where",
      tone: 'semantic',
    },
    {
      german: "können Sie",
      translated: "can you",
      tone: 'semantic',
    },
    {
      german: "sich",
      translated: "get",
      tone: 'semantic',
    },
    {
      german: "in Sachsen-Anhalt",
      translated: "in Sachsen-Anhalt",
      tone: 'semantic',
    },
    {
      german: "über politische Themen",
      translated: "about political topics",
      tone: 'semantic',
    },
    {
      german: "informieren",
      translated: "information",
      tone: 'semantic',
    },
  ],
  "lid:state:ST:6|es": [
    {
      german: "Wo",
      translated: "¿Dónde",
      tone: 'semantic',
    },
    {
      german: "können Sie",
      translated: "puede",
      tone: 'semantic',
    },
    {
      german: "in Sachsen-Anhalt",
      translated: "en Sajonia-Anhalt",
      tone: 'semantic',
    },
    {
      german: "über politische Themen",
      translated: "sobre temas políticos",
      tone: 'semantic',
    },
    {
      german: "informieren",
      translated: "informarse",
      tone: 'semantic',
    },
  ],
  "lid:state:ST:6|fa": [
    {
      german: "Wo",
      translated: "کجا",
      tone: 'semantic',
    },
    {
      german: "können Sie",
      translated: "می‌توانید",
      tone: 'semantic',
    },
    {
      german: "in Sachsen-Anhalt",
      translated: "در زاکسن-آنهالت",
      tone: 'semantic',
    },
    {
      german: "über politische Themen",
      translated: "دربارهٔ موضوعات سیاسی",
      tone: 'semantic',
    },
    {
      german: "informieren",
      translated: "اطلاعات کسب کنید",
      tone: 'semantic',
    },
  ],
  "lid:state:ST:6|fr": [
    {
      german: "Wo",
      translated: "Où",
      tone: 'semantic',
    },
    {
      german: "können Sie",
      translated: "pouvez-vous",
      tone: 'semantic',
    },
    {
      german: "sich",
      translated: "vous",
      tone: 'semantic',
    },
    {
      german: "in Sachsen-Anhalt",
      translated: "en Saxe-Anhalt",
      tone: 'semantic',
    },
    {
      german: "über politische Themen",
      translated: "sur les questions politiques",
      tone: 'semantic',
    },
    {
      german: "informieren",
      translated: "informer",
      tone: 'semantic',
    },
  ],
  "lid:state:ST:6|hr": [
    {
      german: "Wo",
      translated: "Gdje",
      tone: 'semantic',
    },
    {
      german: "können Sie",
      translated: "mogu",
      tone: 'semantic',
    },
    {
      german: "sich",
      translated: "se",
      tone: 'semantic',
    },
    {
      german: "in Sachsen-Anhalt",
      translated: "u saveznoj zemlji Saska-Anhalt",
      tone: 'semantic',
    },
    {
      german: "über politische Themen",
      translated: "o političkim temama",
      tone: 'semantic',
    },
    {
      german: "informieren",
      translated: "dobiti informacije",
      tone: 'semantic',
    },
  ],
  "lid:state:ST:6|it": [
    {
      german: "Wo",
      translated: "Dove",
      tone: 'semantic',
    },
    {
      german: "können Sie",
      translated: "ci si può",
      tone: 'semantic',
    },
    {
      german: "in Sachsen-Anhalt",
      translated: "in Sassonia-Anhalt",
      tone: 'semantic',
    },
    {
      german: "über politische Themen",
      translated: "su temi politici",
      tone: 'semantic',
    },
    {
      german: "informieren",
      translated: "informare",
      tone: 'semantic',
    },
  ],
  "lid:state:ST:6|kmr": [
    {
      german: "Wo",
      translated: "Li",
      tone: 'semantic',
    },
    {
      german: "können Sie",
      translated: "li ku",
      tone: 'semantic',
    },
    {
      german: "sich",
      translated: "dikarî",
      tone: 'semantic',
    },
    {
      german: "in Sachsen-Anhalt",
      translated: "Sachsen-Anhalt",
      tone: 'semantic',
    },
    {
      german: "über politische Themen",
      translated: "li ser mijarên siyasî",
      tone: 'semantic',
    },
    {
      german: "informieren",
      translated: "agahdarî bistînî",
      tone: 'semantic',
    },
  ],
  "lid:state:ST:6|pl": [
    {
      german: "Wo",
      translated: "Gdzie",
      tone: 'semantic',
    },
    {
      german: "können Sie",
      translated: "można",
      tone: 'semantic',
    },
    {
      german: "in Sachsen-Anhalt",
      translated: "w Saksonia-Anhalt",
      tone: 'semantic',
    },
    {
      german: "über politische Themen",
      translated: "na tematy polityczne",
      tone: 'semantic',
    },
    {
      german: "informieren",
      translated: "uzyskać informacje",
      tone: 'semantic',
    },
  ],
  "lid:state:ST:6|prs": [
    {
      german: "Wo",
      translated: "کجا",
      tone: 'semantic',
    },
    {
      german: "können Sie",
      translated: "می‌توانید",
      tone: 'semantic',
    },
    {
      german: "in Sachsen-Anhalt",
      translated: "در زاکسن-آنهالت",
      tone: 'semantic',
    },
    {
      german: "über politische Themen",
      translated: " دربارهٔ موضوعات سیاسی",
      tone: 'semantic',
    },
    {
      german: "informieren",
      translated: "اطلاعات کسب کنید",
      tone: 'semantic',
    },
  ],
  "lid:state:ST:6|ro": [
    {
      german: "Wo",
      translated: "Unde",
      tone: 'semantic',
    },
    {
      german: "können Sie",
      translated: "vă puteți",
      tone: 'semantic',
    },
    {
      german: "in Sachsen-Anhalt",
      translated: "în Saxonia-Anhalt",
      tone: 'semantic',
    },
    {
      german: "über politische Themen",
      translated: "despre teme politice",
      tone: 'semantic',
    },
    {
      german: "informieren",
      translated: "informa",
      tone: 'semantic',
    },
  ],
  "lid:state:ST:6|ru": [
    {
      german: "Wo",
      translated: "Где",
      tone: 'semantic',
    },
    {
      german: "können Sie",
      translated: "можно",
      tone: 'semantic',
    },
    {
      german: "in Sachsen-Anhalt",
      translated: "в федеральной земле Саксония-Анхальт",
      tone: 'semantic',
    },
    {
      german: "über politische Themen",
      translated: "о политических темах",
      tone: 'semantic',
    },
    {
      german: "informieren",
      translated: "получить информацию",
      tone: 'semantic',
    },
  ],
  "lid:state:ST:6|sq": [
    {
      german: "Wo",
      translated: "Ku",
      tone: 'semantic',
    },
    {
      german: "können Sie",
      translated: "mund të",
      tone: 'semantic',
    },
    {
      german: "in Sachsen-Anhalt",
      translated: "në Sachsen-Anhalt",
      tone: 'semantic',
    },
    {
      german: "über politische Themen",
      translated: "për tema politike",
      tone: 'semantic',
    },
    {
      german: "informieren",
      translated: "informoheni",
      tone: 'semantic',
    },
  ],
  "lid:state:ST:6|sr": [
    {
      german: "Wo",
      translated: "Gdje",
      tone: 'semantic',
    },
    {
      german: "können Sie",
      translated: "mogu",
      tone: 'semantic',
    },
    {
      german: "sich",
      translated: "se",
      tone: 'semantic',
    },
    {
      german: "in Sachsen-Anhalt",
      translated: "u saveznoj pokrajini Saksonija-Anhalt",
      tone: 'semantic',
    },
    {
      german: "über politische Themen",
      translated: "o političkim temama",
      tone: 'semantic',
    },
    {
      german: "informieren",
      translated: "dobiti informacije",
      tone: 'semantic',
    },
  ],
  "lid:state:ST:6|tr": [
    {
      german: "Wo",
      translated: "nereden",
      tone: 'semantic',
    },
    {
      german: "können Sie",
      translated: "alabilirsiniz",
      tone: 'semantic',
    },
    {
      german: "in Sachsen-Anhalt",
      translated: "Sachsen-Anhalt eyaletinde",
      tone: 'semantic',
    },
    {
      german: "über politische Themen",
      translated: "siyasi konular hakkında",
      tone: 'semantic',
    },
    {
      german: "informieren",
      translated: "bilgi",
      tone: 'semantic',
    },
  ],
  "lid:state:ST:6|uk": [
    {
      german: "Wo",
      translated: "Де",
      tone: 'semantic',
    },
    {
      german: "können Sie",
      translated: "можна",
      tone: 'semantic',
    },
    {
      german: "in Sachsen-Anhalt",
      translated: "у федеральній землі Саксонія-Ангальт",
      tone: 'semantic',
    },
    {
      german: "über politische Themen",
      translated: "про політичні питання",
      tone: 'semantic',
    },
    {
      german: "informieren",
      translated: "отримати інформацію",
      tone: 'semantic',
    },
  ],
  "lid:state:ST:6|vi": [
    {
      german: "Wo",
      translated: "ở đâu",
      tone: 'semantic',
    },
    {
      german: "können Sie",
      translated: "có thể",
      tone: 'semantic',
    },
    {
      german: "in Sachsen-Anhalt",
      translated: "bang Sachsen-Anhalt",
      tone: 'semantic',
    },
    {
      german: "über politische Themen",
      translated: "về các chủ đề chính trị",
      tone: 'semantic',
    },
    {
      german: "informieren",
      translated: "tìm thông tin",
      tone: 'semantic',
    },
  ],
  "lid:state:ST:7|ar": [
    {
      german: "Die Landeshauptstadt",
      translated: "ما عاصمة",
      tone: 'semantic',
    },
    {
      german: "von Sachsen-Anhalt",
      translated: "ولاية Sachsen-Anhalt",
      tone: 'semantic',
    },
  ],
  "lid:state:ST:7|bg": [
    {
      german: "Die Landeshauptstadt",
      translated: "Столицата",
      tone: 'semantic',
    },
    {
      german: "von Sachsen-Anhalt",
      translated: "на федералната провинция Саксония-Анхалт",
      tone: 'semantic',
    },
    {
      german: "heißt",
      translated: "е",
      tone: 'semantic',
    },
  ],
  "lid:state:ST:7|bs": [
    {
      german: "Die Landeshauptstadt",
      translated: "Glavni grad",
      tone: 'semantic',
    },
    {
      german: "von Sachsen-Anhalt",
      translated: "savezne zemlje Saksonija-Anhalt",
      tone: 'semantic',
    },
    {
      german: "heißt",
      translated: "je",
      tone: 'semantic',
    },
  ],
  "lid:state:ST:7|el": [
    {
      german: "Die Landeshauptstadt",
      translated: "Η πρωτεύουσα",
      tone: 'semantic',
    },
    {
      german: "von Sachsen-Anhalt",
      translated: "του ομόσπονδου κρατιδίου Σαξονία-Άνχαλτ",
      tone: 'semantic',
    },
    {
      german: "heißt",
      translated: "είναι",
      tone: 'semantic',
    },
  ],
  "lid:state:ST:7|en": [
    {
      german: "Die Landeshauptstadt",
      translated: "The state capital",
      tone: 'semantic',
    },
    {
      german: "von Sachsen-Anhalt",
      translated: "of Sachsen-Anhalt",
      tone: 'semantic',
    },
    {
      german: "heißt",
      translated: "is called",
      tone: 'semantic',
    },
  ],
  "lid:state:ST:7|es": [
    {
      german: "Die Landeshauptstadt",
      translated: "La capital del estado federado",
      tone: 'semantic',
    },
    {
      german: "von Sachsen-Anhalt",
      translated: "de Sajonia-Anhalt",
      tone: 'semantic',
    },
    {
      german: "heißt",
      translated: "es …",
      tone: 'semantic',
    },
  ],
  "lid:state:ST:7|fa": [
    {
      german: "Die Landeshauptstadt",
      translated: "مرکز ایالت",
      tone: 'semantic',
    },
    {
      german: "von Sachsen-Anhalt",
      translated: "زاکسن-آنهالت",
      tone: 'semantic',
    },
    {
      german: "heißt",
      translated: "است",
      tone: 'semantic',
    },
  ],
  "lid:state:ST:7|fr": [
    {
      german: "Die Landeshauptstadt",
      translated: "La capitale du Land",
      tone: 'semantic',
    },
    {
      german: "von Sachsen-Anhalt",
      translated: "de Saxe-Anhalt",
      tone: 'semantic',
    },
    {
      german: "heißt",
      translated: "s’appelle",
      tone: 'semantic',
    },
  ],
  "lid:state:ST:7|hr": [
    {
      german: "Die Landeshauptstadt",
      translated: "Glavni grad",
      tone: 'semantic',
    },
    {
      german: "von Sachsen-Anhalt",
      translated: "savezne zemlje Saska-Anhalt",
      tone: 'semantic',
    },
    {
      german: "heißt",
      translated: "je",
      tone: 'semantic',
    },
  ],
  "lid:state:ST:7|it": [
    {
      german: "Die Landeshauptstadt",
      translated: "La capitale del Land",
      tone: 'semantic',
    },
    {
      german: "von Sachsen-Anhalt",
      translated: "di Sassonia-Anhalt",
      tone: 'semantic',
    },
    {
      german: "heißt",
      translated: "è",
      tone: 'semantic',
    },
  ],
  "lid:state:ST:7|kmr": [
    {
      german: "Die Landeshauptstadt",
      translated: "Paytexta",
      tone: 'semantic',
    },
    {
      german: "von Sachsen-Anhalt",
      translated: "eyaleta Sachsen-Anhalt",
      tone: 'semantic',
    },
    {
      german: "heißt",
      translated: "e.",
      tone: 'semantic',
    },
  ],
  "lid:state:ST:7|pl": [
    {
      german: "Die Landeshauptstadt",
      translated: "Stolicą kraju związkowego",
      tone: 'semantic',
    },
    {
      german: "von Sachsen-Anhalt",
      translated: "Saksonia-Anhalt",
      tone: 'semantic',
    },
    {
      german: "heißt",
      translated: "jest",
      tone: 'semantic',
    },
  ],
  "lid:state:ST:7|prs": [
    {
      german: "Die Landeshauptstadt",
      translated: "مرکز ایالت",
      tone: 'semantic',
    },
    {
      german: "von Sachsen-Anhalt",
      translated: "زاکسن-آنهالت",
      tone: 'semantic',
    },
    {
      german: "heißt",
      translated: "است",
      tone: 'semantic',
    },
  ],
  "lid:state:ST:7|ro": [
    {
      german: "Die Landeshauptstadt",
      translated: "Capitala",
      tone: 'semantic',
    },
    {
      german: "von Sachsen-Anhalt",
      translated: "landului Saxonia-Anhalt",
      tone: 'semantic',
    },
    {
      german: "heißt",
      translated: "este",
      tone: 'semantic',
    },
  ],
  "lid:state:ST:7|ru": [
    {
      german: "Die Landeshauptstadt",
      translated: "Столица земли",
      tone: 'semantic',
    },
    {
      german: "von Sachsen-Anhalt",
      translated: "Саксония-Анхальт",
      tone: 'semantic',
    },
    {
      german: "heißt",
      translated: "называется",
      tone: 'semantic',
    },
  ],
  "lid:state:ST:7|sq": [
    {
      german: "Die Landeshauptstadt",
      translated: "Kryeqyteti",
      tone: 'semantic',
    },
    {
      german: "von Sachsen-Anhalt",
      translated: "i landit Sachsen-Anhalt",
      tone: 'semantic',
    },
    {
      german: "heißt",
      translated: "është",
      tone: 'semantic',
    },
  ],
  "lid:state:ST:7|sr": [
    {
      german: "Die Landeshauptstadt",
      translated: "Glavni grad",
      tone: 'semantic',
    },
    {
      german: "von Sachsen-Anhalt",
      translated: "savezne pokrajine Saksonija-Anhalt",
      tone: 'semantic',
    },
    {
      german: "heißt",
      translated: "je",
      tone: 'semantic',
    },
  ],
  "lid:state:ST:7|tr": [
    {
      german: "Die Landeshauptstadt",
      translated: "başkenti",
      tone: 'semantic',
    },
    {
      german: "von Sachsen-Anhalt",
      translated: "Sachsen-Anhalt eyaletinin",
      tone: 'semantic',
    },
  ],
  "lid:state:ST:7|uk": [
    {
      german: "Die Landeshauptstadt",
      translated: "Столиця федеральної землі",
      tone: 'semantic',
    },
    {
      german: "von Sachsen-Anhalt",
      translated: "Саксонія-Ангальт",
      tone: 'semantic',
    },
    {
      german: "heißt",
      translated: "називається",
      tone: 'semantic',
    },
  ],
  "lid:state:ST:7|vi": [
    {
      german: "Die Landeshauptstadt",
      translated: "Thủ phủ",
      tone: 'semantic',
    },
    {
      german: "von Sachsen-Anhalt",
      translated: "của bang Sachsen-Anhalt",
      tone: 'semantic',
    },
    {
      german: "heißt",
      translated: "là",
      tone: 'semantic',
    },
  ],
  "lid:state:ST:8|ar": [
    {
      german: "Welches Bundesland ist",
      translated: "أي صورة",
      tone: 'semantic',
    },
    {
      german: "Sachsen-Anhalt",
      translated: "Sachsen-Anhalt",
      tone: 'semantic',
    },
  ],
  "lid:state:ST:8|bg": [
    {
      german: "Welches Bundesland ist",
      translated: "Коя от показаните федерални",
      tone: 'semantic',
    },
    {
      german: "Sachsen-Anhalt",
      translated: "Саксония-Анхалт",
      tone: 'semantic',
    },
  ],
  "lid:state:ST:8|bs": [
    {
      german: "Welches Bundesland ist",
      translated: "Koja od prikazanih saveznih zemalja",
      tone: 'semantic',
    },
    {
      german: "Sachsen-Anhalt",
      translated: "Saksonija-Anhalt",
      tone: 'semantic',
    },
  ],
  "lid:state:ST:8|el": [
    {
      german: "Welches Bundesland ist",
      translated: "Ποιο από τα εικονιζόμενα κρατίδια είναι",
      tone: 'semantic',
    },
    {
      german: "Sachsen-Anhalt",
      translated: "το Σαξονία-Άνχαλτ;",
      tone: 'semantic',
    },
  ],
  "lid:state:ST:8|en": [
    {
      german: "Welches Bundesland ist",
      translated: "Which federal state is",
      tone: 'semantic',
    },
    {
      german: "Sachsen-Anhalt",
      translated: "Sachsen-Anhalt",
      tone: 'semantic',
    },
  ],
  "lid:state:ST:8|es": [
    {
      german: "Welches Bundesland ist",
      translated: "de las imágenes corresponde al estado federado",
      tone: 'semantic',
    },
    {
      german: "Sachsen-Anhalt",
      translated: "de Sajonia-Anhalt",
      tone: 'semantic',
    },
  ],
  "lid:state:ST:8|fa": [
    {
      german: "Welches Bundesland ist",
      translated: "کدام ایالتِ نشان‌داده‌شده",
      tone: 'semantic',
    },
    {
      german: "Sachsen-Anhalt",
      translated: "زاکسن-آنهالت",
      tone: 'semantic',
    },
  ],
  "lid:state:ST:8|fr": [
    {
      german: "Welches Bundesland ist",
      translated: "Quel Land représenté est",
      tone: 'semantic',
    },
    {
      german: "Sachsen-Anhalt",
      translated: "Saxe-Anhalt",
      tone: 'semantic',
    },
  ],
  "lid:state:ST:8|hr": [
    {
      german: "Welches Bundesland ist",
      translated: "Koja od prikazanih saveznih zemalja",
      tone: 'semantic',
    },
    {
      german: "Sachsen-Anhalt",
      translated: "Saska-Anhalt",
      tone: 'semantic',
    },
  ],
  "lid:state:ST:8|it": [
    {
      german: "Welches Bundesland ist",
      translated: "Quale Land rappresentato è",
      tone: 'semantic',
    },
    {
      german: "Sachsen-Anhalt",
      translated: "Sassonia-Anhalt",
      tone: 'semantic',
    },
  ],
  "lid:state:ST:8|kmr": [
    {
      german: "Welches Bundesland ist",
      translated: "Kîjan eyalet",
      tone: 'semantic',
    },
    {
      german: "Sachsen-Anhalt",
      translated: "Sachsen-Anhalt",
      tone: 'semantic',
    },
  ],
  "lid:state:ST:8|pl": [
    {
      german: "Welches Bundesland ist",
      translated: "Który z przedstawionych krajów związkowych",
      tone: 'semantic',
    },
    {
      german: "Sachsen-Anhalt",
      translated: "Saksonia-Anhalt",
      tone: 'semantic',
    },
  ],
  "lid:state:ST:8|prs": [
    {
      german: "Welches Bundesland ist",
      translated: "کدام ایالتِ نشان‌داده‌شده",
      tone: 'semantic',
    },
    {
      german: "Sachsen-Anhalt",
      translated: "زاکسن-آنهالت",
      tone: 'semantic',
    },
  ],
  "lid:state:ST:8|ro": [
    {
      german: "Welches Bundesland ist",
      translated: "Care land reprezentat este",
      tone: 'semantic',
    },
    {
      german: "Sachsen-Anhalt",
      translated: "Saxonia-Anhalt",
      tone: 'semantic',
    },
  ],
  "lid:state:ST:8|ru": [
    {
      german: "Welches Bundesland ist",
      translated: "Какая из этих земель",
      tone: 'semantic',
    },
    {
      german: "Sachsen-Anhalt",
      translated: "Саксония-Анхальт",
      tone: 'semantic',
    },
  ],
  "lid:state:ST:8|sq": [
    {
      german: "Welches Bundesland ist",
      translated: "Cili nga landet e paraqitura është",
      tone: 'semantic',
    },
    {
      german: "Sachsen-Anhalt",
      translated: "Sachsen-Anhalt",
      tone: 'semantic',
    },
  ],
  "lid:state:ST:8|sr": [
    {
      german: "Welches Bundesland ist",
      translated: "Koja od prikazanih",
      tone: 'semantic',
    },
    {
      german: "Sachsen-Anhalt",
      translated: "Saksonija-Anhalt",
      tone: 'semantic',
    },
  ],
  "lid:state:ST:8|tr": [
    {
      german: "Welches Bundesland ist",
      translated: "Haritada",
      tone: 'semantic',
    },
    {
      german: "Sachsen-Anhalt",
      translated: "Sachsen-Anhalt",
      tone: 'semantic',
    },
  ],
  "lid:state:ST:8|uk": [
    {
      german: "Welches Bundesland ist",
      translated: "Яка з позначених федеральних земель є",
      tone: 'semantic',
    },
    {
      german: "Sachsen-Anhalt",
      translated: "Саксонія-Ангальт",
      tone: 'semantic',
    },
  ],
  "lid:state:ST:8|vi": [
    {
      german: "Welches Bundesland ist",
      translated: "Bang nào trong các hình được hiển thị là",
      tone: 'semantic',
    },
    {
      german: "Sachsen-Anhalt",
      translated: "Sachsen-Anhalt",
      tone: 'semantic',
    },
  ],
  "lid:state:ST:9|ar": [
    {
      german: "Wie nennt man",
      translated: "ماذا",
      tone: 'semantic',
    },
    {
      german: "Regierungschefin/den Regierungschef",
      translated: "رئيس/رئيسة حكومة",
      tone: 'semantic',
    },
    {
      german: "in Sachsen-Anhalt",
      translated: "ولاية Sachsen-Anhalt",
      tone: 'semantic',
    },
  ],
  "lid:state:ST:9|bg": [
    {
      german: "Wie nennt man",
      translated: "Как се нарича",
      tone: 'semantic',
    },
    {
      german: "Regierungschefin/den Regierungschef",
      translated: "ръководителят на правителството",
      tone: 'semantic',
    },
    {
      german: "in Sachsen-Anhalt",
      translated: "на провинция Саксония-Анхалт",
      tone: 'semantic',
    },
  ],
  "lid:state:ST:9|bs": [
    {
      german: "Wie nennt man",
      translated: "Kako se zove",
      tone: 'semantic',
    },
    {
      german: "Regierungschefin/den Regierungschef",
      translated: "šef vlade",
      tone: 'semantic',
    },
    {
      german: "in Sachsen-Anhalt",
      translated: "savezne zemlje Saksonija-Anhalt",
      tone: 'semantic',
    },
  ],
  "lid:state:ST:9|el": [
    {
      german: "Wie nennt man",
      translated: "Πώς ονομάζεται",
      tone: 'semantic',
    },
    {
      german: "Regierungschefin/den Regierungschef",
      translated: "επικεφαλής της κυβέρνησης",
      tone: 'semantic',
    },
    {
      german: "in Sachsen-Anhalt",
      translated: "του κρατιδίου Σαξονία-Άνχαλτ",
      tone: 'semantic',
    },
  ],
  "lid:state:ST:9|en": [
    {
      german: "Wie nennt man",
      translated: "What is",
      tone: 'semantic',
    },
    {
      german: "Regierungschefin/den Regierungschef",
      translated: "the head of government",
      tone: 'semantic',
    },
    {
      german: "in Sachsen-Anhalt",
      translated: "in Sachsen-Anhalt",
      tone: 'semantic',
    },
  ],
  "lid:state:ST:9|es": [
    {
      german: "Wie nennt man",
      translated: "¿Cómo se llama al",
      tone: 'semantic',
    },
    {
      german: "Regierungschefin/den Regierungschef",
      translated: "jefe o la jefa de gobierno",
      tone: 'semantic',
    },
    {
      german: "in Sachsen-Anhalt",
      translated: "de Sajonia-Anhalt",
      tone: 'semantic',
    },
  ],
  "lid:state:ST:9|fa": [
    {
      german: "Wie nennt man",
      translated: "رئیس دولت ایالت",
      tone: 'semantic',
    },
    {
      german: "Regierungschefin/den Regierungschef",
      translated: "زاکسن-آنهالت",
      tone: 'semantic',
    },
    {
      german: "in Sachsen-Anhalt",
      translated: "چه عنوانی دارد؟",
      tone: 'semantic',
    },
  ],
  "lid:state:ST:9|fr": [
    {
      german: "Wie nennt man",
      translated: "Comment appelle-t-on",
      tone: 'semantic',
    },
    {
      german: "Regierungschefin/den Regierungschef",
      translated: "le chef ou la cheffe du gouvernement",
      tone: 'semantic',
    },
    {
      german: "in Sachsen-Anhalt",
      translated: "de Saxe-Anhalt",
      tone: 'semantic',
    },
  ],
  "lid:state:ST:9|hr": [
    {
      german: "Wie nennt man",
      translated: "Kako se zove",
      tone: 'semantic',
    },
    {
      german: "Regierungschefin/den Regierungschef",
      translated: "čelnik vlade",
      tone: 'semantic',
    },
    {
      german: "in Sachsen-Anhalt",
      translated: "Saska-Anhalt",
      tone: 'semantic',
    },
  ],
  "lid:state:ST:9|it": [
    {
      german: "Wie nennt man",
      translated: "Come si chiama",
      tone: 'semantic',
    },
    {
      german: "Regierungschefin/den Regierungschef",
      translated: "il capo del governo",
      tone: 'semantic',
    },
    {
      german: "in Sachsen-Anhalt",
      translated: "del Land di Sassonia-Anhalt",
      tone: 'semantic',
    },
  ],
  "lid:state:ST:9|kmr": [
    {
      german: "Wie nennt man",
      translated: "Serokê",
      tone: 'semantic',
    },
    {
      german: "Regierungschefin/den Regierungschef",
      translated: "hukûmeta",
      tone: 'semantic',
    },
    {
      german: "in Sachsen-Anhalt",
      translated: "Sachsen-Anhalt çi tê gotin",
      tone: 'semantic',
    },
  ],
  "lid:state:ST:9|pl": [
    {
      german: "Wie nennt man",
      translated: "Jak nazywa się",
      tone: 'semantic',
    },
    {
      german: "Regierungschefin/den Regierungschef",
      translated: "szef rządu kraju związkowego",
      tone: 'semantic',
    },
    {
      german: "in Sachsen-Anhalt",
      translated: "Saksonia-Anhalt",
      tone: 'semantic',
    },
  ],
  "lid:state:ST:9|prs": [
    {
      german: "Wie nennt man",
      translated: "چه عنوانی دارد",
      tone: 'semantic',
    },
    {
      german: "Regierungschefin/den Regierungschef",
      translated: "رئیس دولت ایالت",
      tone: 'semantic',
    },
    {
      german: "in Sachsen-Anhalt",
      translated: "زاکسن-آنهالت",
      tone: 'semantic',
    },
  ],
  "lid:state:ST:9|ro": [
    {
      german: "Wie nennt man",
      translated: "Cum se numește",
      tone: 'semantic',
    },
    {
      german: "Regierungschefin/den Regierungschef",
      translated: "șeful guvernului",
      tone: 'semantic',
    },
    {
      german: "in Sachsen-Anhalt",
      translated: "landului Saxonia-Anhalt",
      tone: 'semantic',
    },
  ],
  "lid:state:ST:9|ru": [
    {
      german: "Wie nennt man",
      translated: "Как называют",
      tone: 'semantic',
    },
    {
      german: "Regierungschefin/den Regierungschef",
      translated: "главу правительства",
      tone: 'semantic',
    },
    {
      german: "in Sachsen-Anhalt",
      translated: "в федеральной земле Саксония-Анхальт",
      tone: 'semantic',
    },
  ],
  "lid:state:ST:9|sq": [
    {
      german: "Wie nennt man",
      translated: "Si quhet kreu",
      tone: 'semantic',
    },
    {
      german: "Regierungschefin/den Regierungschef",
      translated: "qeverisë së landit",
      tone: 'semantic',
    },
    {
      german: "in Sachsen-Anhalt",
      translated: "Sachsen-Anhalt",
      tone: 'semantic',
    },
  ],
  "lid:state:ST:9|sr": [
    {
      german: "Wie nennt man",
      translated: "Kako se zove",
      tone: 'semantic',
    },
    {
      german: "Regierungschefin/den Regierungschef",
      translated: "šef vlade",
      tone: 'semantic',
    },
    {
      german: "in Sachsen-Anhalt",
      translated: "savezne pokrajine Saksonija-Anhalt",
      tone: 'semantic',
    },
  ],
  "lid:state:ST:9|tr": [
    {
      german: "Wie nennt man",
      translated: "ne ad verilir",
      tone: 'semantic',
    },
    {
      german: "Regierungschefin/den Regierungschef",
      translated: "başındaki kişiye",
      tone: 'semantic',
    },
    {
      german: "in Sachsen-Anhalt",
      translated: "Sachsen-Anhalt hükümetinin",
      tone: 'semantic',
    },
  ],
  "lid:state:ST:9|uk": [
    {
      german: "Wie nennt man",
      translated: "Як називають",
      tone: 'semantic',
    },
    {
      german: "Regierungschefin/den Regierungschef",
      translated: "главу уряду",
      tone: 'semantic',
    },
    {
      german: "in Sachsen-Anhalt",
      translated: "федеральної землі Саксонія-Ангальт",
      tone: 'semantic',
    },
  ],
  "lid:state:ST:9|vi": [
    {
      german: "Wie nennt man",
      translated: "được gọi là",
      tone: 'semantic',
    },
    {
      german: "Regierungschefin/den Regierungschef",
      translated: "Người đứng đầu chính phủ",
      tone: 'semantic',
    },
    {
      german: "in Sachsen-Anhalt",
      translated: "bang Sachsen-Anhalt",
      tone: 'semantic',
    },
  ],
  "lid:state:TH:10|ar": [
    {
      german: "Welche Ministerin",
      translated: "أي وزارة",
      tone: 'semantic',
    },
    {
      german: "welchen Minister",
      translated: "الوزارات التالية",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "من",
      tone: 'semantic',
    },
    {
      german: "Thüringen",
      translated: "Thüringen",
      tone: 'semantic',
    },
    {
      german: "nicht",
      translated: "غير موجودة",
      tone: 'semantic',
    },
  ],
  "lid:state:TH:10|bg": [
    {
      german: "Welche Ministerin",
      translated: "Кой министър",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "съществува",
      tone: 'semantic',
    },
    {
      german: "Thüringen",
      translated: "Тюрингия",
      tone: 'semantic',
    },
    {
      german: "nicht",
      translated: "не",
      tone: 'semantic',
    },
  ],
  "lid:state:TH:10|bs": [
    {
      german: "welchen Minister",
      translated: "Koji ministar",
      tone: 'semantic',
    },
    {
      german: "Thüringen",
      translated: "savezne zemlje Tiringija",
      tone: 'semantic',
    },
    {
      german: "nicht",
      translated: "ne postoji",
      tone: 'semantic',
    },
  ],
  "lid:state:TH:10|el": [
    {
      german: "Welche Ministerin",
      translated: "Ποιος",
      tone: 'semantic',
    },
    {
      german: "welchen Minister",
      translated: "υπουργός",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "δεν υπάρχει",
      tone: 'semantic',
    },
    {
      german: "Thüringen",
      translated: "σε επίπεδο κρατιδίου στο Θουριγγία",
      tone: 'semantic',
    },
  ],
  "lid:state:TH:10|en": [
    {
      german: "Welche Ministerin",
      translated: "Which",
      tone: 'semantic',
    },
    {
      german: "welchen Minister",
      translated: "minister",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "does",
      tone: 'semantic',
    },
    {
      german: "Thüringen",
      translated: "Thüringen",
      tone: 'semantic',
    },
    {
      german: "nicht",
      translated: "not",
      tone: 'semantic',
    },
  ],
  "lid:state:TH:10|es": [
    {
      german: "welchen Minister",
      translated: "ministerio",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "existe",
      tone: 'semantic',
    },
    {
      german: "Thüringen",
      translated: "Turingia",
      tone: 'semantic',
    },
    {
      german: "nicht",
      translated: "NO",
      tone: 'semantic',
    },
  ],
  "lid:state:TH:10|fa": [
    {
      german: "Welche Ministerin",
      translated: "کدام",
      tone: 'semantic',
    },
    {
      german: "welchen Minister",
      translated: "وزیر",
      tone: 'semantic',
    },
    {
      german: "Thüringen",
      translated: "تورینگن",
      tone: 'semantic',
    },
    {
      german: "nicht",
      translated: "وجود ندارد",
      tone: 'semantic',
    },
  ],
  "lid:state:TH:10|fr": [
    {
      german: "Welche Ministerin",
      translated: "quelle ministre",
      tone: 'semantic',
    },
    {
      german: "welchen Minister",
      translated: "Quel ministre",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "existe",
      tone: 'semantic',
    },
    {
      german: "Thüringen",
      translated: "Thuringe",
      tone: 'semantic',
    },
    {
      german: "nicht",
      translated: "pas",
      tone: 'semantic',
    },
  ],
  "lid:state:TH:10|hr": [
    {
      german: "welchen Minister",
      translated: "Koji ministar",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "ne postoji",
      tone: 'semantic',
    },
    {
      german: "Thüringen",
      translated: "savezne zemlje Tiringija",
      tone: 'semantic',
    },
  ],
  "lid:state:TH:10|it": [
    {
      german: "welchen Minister",
      translated: "Quale ministro",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "esiste",
      tone: 'semantic',
    },
    {
      german: "Thüringen",
      translated: "Turingia",
      tone: 'semantic',
    },
    {
      german: "nicht",
      translated: "non",
      tone: 'semantic',
    },
  ],
  "lid:state:TH:10|kmr": [
    {
      german: "welchen Minister",
      translated: "Kîjan wezîr",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "ye",
      tone: 'semantic',
    },
    {
      german: "Thüringen",
      translated: "Thüringen",
      tone: 'semantic',
    },
    {
      german: "nicht",
      translated: "tune",
      tone: 'semantic',
    },
  ],
  "lid:state:TH:10|pl": [
    {
      german: "welchen Minister",
      translated: "Którego ministra",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "ma",
      tone: 'semantic',
    },
    {
      german: "Thüringen",
      translated: "Turyngia",
      tone: 'semantic',
    },
    {
      german: "nicht",
      translated: "nie",
      tone: 'semantic',
    },
  ],
  "lid:state:TH:10|prs": [
    {
      german: "welchen Minister",
      translated: "وزیر",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "وجود ندارد",
      tone: 'semantic',
    },
    {
      german: "Thüringen",
      translated: "تورینگن",
      tone: 'semantic',
    },
  ],
  "lid:state:TH:10|ro": [
    {
      german: "Welche Ministerin",
      translated: "Care ministru",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "există",
      tone: 'semantic',
    },
    {
      german: "Thüringen",
      translated: "Turingia",
      tone: 'semantic',
    },
    {
      german: "nicht",
      translated: "nu",
      tone: 'semantic',
    },
  ],
  "lid:state:TH:10|ru": [
    {
      german: "welchen Minister",
      translated: "Какого министра",
      tone: 'semantic',
    },
    {
      german: "Thüringen",
      translated: "Тюрингия",
      tone: 'semantic',
    },
    {
      german: "nicht",
      translated: "нет",
      tone: 'semantic',
    },
  ],
  "lid:state:TH:10|sq": [
    {
      german: "Welche Ministerin",
      translated: "Cili ministër",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "ekziston",
      tone: 'semantic',
    },
    {
      german: "Thüringen",
      translated: "Thüringen",
      tone: 'semantic',
    },
    {
      german: "nicht",
      translated: "nuk",
      tone: 'semantic',
    },
  ],
  "lid:state:TH:10|sr": [
    {
      german: "Welche Ministerin",
      translated: "Koji ministar",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "ne postoji",
      tone: 'semantic',
    },
    {
      german: "Thüringen",
      translated: "Tiringija",
      tone: 'semantic',
    },
  ],
  "lid:state:TH:10|tr": [
    {
      german: "Welche Ministerin",
      translated: "aşağıdaki bakanlıklardan hangisi",
      tone: 'semantic',
    },
    {
      german: "Thüringen",
      translated: "Thüringen eyaletinde",
      tone: 'semantic',
    },
    {
      german: "nicht",
      translated: "yoktur",
      tone: 'semantic',
    },
  ],
  "lid:state:TH:10|uk": [
    {
      german: "Welche Ministerin",
      translated: "міністерки",
      tone: 'semantic',
    },
    {
      german: "welchen Minister",
      translated: "міністра",
      tone: 'semantic',
    },
    {
      german: "Thüringen",
      translated: "Тюрингія",
      tone: 'semantic',
    },
    {
      german: "nicht",
      translated: "немає",
      tone: 'semantic',
    },
  ],
  "lid:state:TH:10|vi": [
    {
      german: "welchen Minister",
      translated: "Bộ trưởng nào",
      tone: 'semantic',
    },
    {
      german: "hat",
      translated: "tồn tại",
      tone: 'semantic',
    },
    {
      german: "Thüringen",
      translated: "Thüringen",
      tone: 'semantic',
    },
    {
      german: "nicht",
      translated: "không",
      tone: 'semantic',
    },
  ],
  "lid:state:TH:1|ar": [
    {
      german: "Welches Wappen",
      translated: "أي شعار",
      tone: 'semantic',
    },
    {
      german: "gehört zum",
      translated: "يعود إلى",
      tone: 'semantic',
    },
    {
      german: "Freistaat Thüringen",
      translated: "ولاية Thüringen",
      tone: 'semantic',
    },
  ],
  "lid:state:TH:1|bg": [
    {
      german: "Welches Wappen",
      translated: "Кой герб",
      tone: 'semantic',
    },
    {
      german: "gehört zum",
      translated: "принадлежи на",
      tone: 'semantic',
    },
    {
      german: "Freistaat Thüringen",
      translated: "федералната провинция Тюрингия",
      tone: 'semantic',
    },
  ],
  "lid:state:TH:1|bs": [
    {
      german: "Welches Wappen",
      translated: "grb",
      tone: 'semantic',
    },
    {
      german: "gehört zum",
      translated: "pripada",
      tone: 'semantic',
    },
    {
      german: "Freistaat Thüringen",
      translated: "Tiringija",
      tone: 'semantic',
    },
  ],
  "lid:state:TH:1|el": [
    {
      german: "Welches Wappen",
      translated: "Ποιο έμβλημα",
      tone: 'semantic',
    },
    {
      german: "gehört zum",
      translated: "ανήκει στο",
      tone: 'semantic',
    },
    {
      german: "Freistaat Thüringen",
      translated: "Θουριγγία",
      tone: 'semantic',
    },
  ],
  "lid:state:TH:1|en": [
    {
      german: "Welches Wappen",
      translated: "Which coat of arms",
      tone: 'semantic',
    },
    {
      german: "gehört zum",
      translated: "belongs to",
      tone: 'semantic',
    },
    {
      german: "Freistaat Thüringen",
      translated: "Free State of Thüringen",
      tone: 'semantic',
    },
  ],
  "lid:state:TH:1|es": [
    {
      german: "Welches Wappen",
      translated: "¿Qué escudo",
      tone: 'semantic',
    },
    {
      german: "gehört zum",
      translated: "pertenece al",
      tone: 'semantic',
    },
    {
      german: "Freistaat Thüringen",
      translated: "estado federado de Turingia",
      tone: 'semantic',
    },
  ],
  "lid:state:TH:1|fa": [
    {
      german: "Welches Wappen",
      translated: "نشان",
      tone: 'semantic',
    },
    {
      german: "gehört zum",
      translated: "متعلق به",
      tone: 'semantic',
    },
    {
      german: "Freistaat Thüringen",
      translated: "ایالت تورینگن",
      tone: 'semantic',
    },
  ],
  "lid:state:TH:1|fr": [
    {
      german: "Welches Wappen",
      translated: "Quel blason",
      tone: 'semantic',
    },
    {
      german: "gehört zum",
      translated: "appartient au",
      tone: 'semantic',
    },
    {
      german: "Freistaat Thüringen",
      translated: "Land de Thuringe",
      tone: 'semantic',
    },
  ],
  "lid:state:TH:1|hr": [
    {
      german: "Welches Wappen",
      translated: "Koji grb",
      tone: 'semantic',
    },
    {
      german: "gehört zum",
      translated: "pripada",
      tone: 'semantic',
    },
    {
      german: "Freistaat Thüringen",
      translated: "Slobodnoj Državi Tiringiji",
      tone: 'semantic',
    },
  ],
  "lid:state:TH:1|it": [
    {
      german: "Welches Wappen",
      translated: "Quale stemma",
      tone: 'semantic',
    },
    {
      german: "gehört zum",
      translated: "appartiene al",
      tone: 'semantic',
    },
    {
      german: "Freistaat Thüringen",
      translated: "Land di Turingia",
      tone: 'semantic',
    },
  ],
  "lid:state:TH:1|kmr": [
    {
      german: "Welches Wappen",
      translated: "Kîjan nîşan",
      tone: 'semantic',
    },
    {
      german: "gehört zum",
      translated: "a eyaleta",
      tone: 'semantic',
    },
    {
      german: "Freistaat Thüringen",
      translated: "Thüringen ye",
      tone: 'semantic',
    },
  ],
  "lid:state:TH:1|pl": [
    {
      german: "Welches Wappen",
      translated: "Który herb",
      tone: 'semantic',
    },
    {
      german: "gehört zum",
      translated: "należy do",
      tone: 'semantic',
    },
    {
      german: "Freistaat Thüringen",
      translated: "kraju związkowego Turyngia",
      tone: 'semantic',
    },
  ],
  "lid:state:TH:1|prs": [
    {
      german: "Welches Wappen",
      translated: "کدام نشان",
      tone: 'semantic',
    },
    {
      german: "gehört zum",
      translated: "متعلق به",
      tone: 'semantic',
    },
    {
      german: "Freistaat Thüringen",
      translated: "ایالت تورینگن",
      tone: 'semantic',
    },
  ],
  "lid:state:TH:1|ro": [
    {
      german: "Welches Wappen",
      translated: "Care stemă",
      tone: 'semantic',
    },
    {
      german: "gehört zum",
      translated: "aparține",
      tone: 'semantic',
    },
    {
      german: "Freistaat Thüringen",
      translated: "landului Turingia",
      tone: 'semantic',
    },
  ],
  "lid:state:TH:1|ru": [
    {
      german: "Welches Wappen",
      translated: "Какой герб",
      tone: 'semantic',
    },
    {
      german: "gehört zum",
      translated: "принадлежит свободному государству",
      tone: 'semantic',
    },
    {
      german: "Freistaat Thüringen",
      translated: "Тюрингия",
      tone: 'semantic',
    },
  ],
  "lid:state:TH:1|sq": [
    {
      german: "Welches Wappen",
      translated: "Cila stemë",
      tone: 'semantic',
    },
    {
      german: "gehört zum",
      translated: "i përket",
      tone: 'semantic',
    },
    {
      german: "Freistaat Thüringen",
      translated: "landit Thüringen",
      tone: 'semantic',
    },
  ],
  "lid:state:TH:1|sr": [
    {
      german: "Welches Wappen",
      translated: "Koji grb",
      tone: 'semantic',
    },
    {
      german: "gehört zum",
      translated: "pripada",
      tone: 'semantic',
    },
    {
      german: "Freistaat Thüringen",
      translated: "Slobodnoj Državi Tiringiji",
      tone: 'semantic',
    },
  ],
  "lid:state:TH:1|tr": [
    {
      german: "Welches Wappen",
      translated: "arması hangisidir",
      tone: 'semantic',
    },
    {
      german: "Freistaat Thüringen",
      translated: "Türingiya Özgür Devleti'nin",
      tone: 'semantic',
    },
  ],
  "lid:state:TH:1|uk": [
    {
      german: "Welches Wappen",
      translated: "Який герб",
      tone: 'semantic',
    },
    {
      german: "gehört zum",
      translated: "належить",
      tone: 'semantic',
    },
    {
      german: "Freistaat Thüringen",
      translated: "Вільній державі Тюрингія",
      tone: 'semantic',
    },
  ],
  "lid:state:TH:1|vi": [
    {
      german: "Welches Wappen",
      translated: "Quốc huy nào",
      tone: 'semantic',
    },
    {
      german: "gehört zum",
      translated: "thuộc",
      tone: 'semantic',
    },
    {
      german: "Freistaat Thüringen",
      translated: "Bang Tự do Thüringen",
      tone: 'semantic',
    },
  ],
  "lid:state:TH:2|ar": [
    {
      german: "Welches ist",
      translated: "أي مما يلي",
      tone: 'semantic',
    },
    {
      german: "ein Landkreis",
      translated: "دائرة إدارية (Landkreis)",
      tone: 'semantic',
    },
    {
      german: "in Thüringen",
      translated: "في Thüringen؟",
      tone: 'semantic',
    },
  ],
  "lid:state:TH:2|bg": [
    {
      german: "Welches ist",
      translated: "Кое",
      tone: 'semantic',
    },
    {
      german: "ein Landkreis",
      translated: "от следните е окръг",
      tone: 'semantic',
    },
    {
      german: "in Thüringen",
      translated: "в Тюрингия",
      tone: 'semantic',
    },
  ],
  "lid:state:TH:2|bs": [
    {
      german: "Welches ist",
      translated: "Što je od navedenoga",
      tone: 'semantic',
    },
    {
      german: "ein Landkreis",
      translated: "okrug (Landkreis)",
      tone: 'semantic',
    },
    {
      german: "in Thüringen",
      translated: "u saveznoj zemlji Tiringija",
      tone: 'semantic',
    },
  ],
  "lid:state:TH:2|el": [
    {
      german: "Welches ist",
      translated: "Ποιο από τα παρακάτω είναι",
      tone: 'semantic',
    },
    {
      german: "ein Landkreis",
      translated: "διοικητική περιφέρεια (Landkreis)",
      tone: 'semantic',
    },
    {
      german: "in Thüringen",
      translated: "στο Θουριγγία",
      tone: 'semantic',
    },
  ],
  "lid:state:TH:2|en": [
    {
      german: "Welches ist",
      translated: "Which",
      tone: 'semantic',
    },
    {
      german: "ein Landkreis",
      translated: "a district",
      tone: 'semantic',
    },
    {
      german: "in Thüringen",
      translated: "in Thüringen",
      tone: 'semantic',
    },
  ],
  "lid:state:TH:2|es": [
    {
      german: "Welches ist",
      translated: "¿Cuál de los siguientes es",
      tone: 'semantic',
    },
    {
      german: "ein Landkreis",
      translated: "un distrito (Landkreis)",
      tone: 'semantic',
    },
    {
      german: "in Thüringen",
      translated: "de Turingia",
      tone: 'semantic',
    },
  ],
  "lid:state:TH:2|fa": [
    {
      german: "Welches ist",
      translated: "کدام‌یک از",
      tone: 'semantic',
    },
    {
      german: "ein Landkreis",
      translated: "شهرستان (Landkreis)",
      tone: 'semantic',
    },
    {
      german: "in Thüringen",
      translated: "در تورینگن",
      tone: 'semantic',
    },
  ],
  "lid:state:TH:2|fr": [
    {
      german: "Welches ist",
      translated: "Lequel des",
      tone: 'semantic',
    },
    {
      german: "ein Landkreis",
      translated: "arrondissement (Landkreis)",
      tone: 'semantic',
    },
    {
      german: "in Thüringen",
      translated: "de Thuringe",
      tone: 'semantic',
    },
  ],
  "lid:state:TH:2|hr": [
    {
      german: "Welches ist",
      translated: "Što je od navedenoga",
      tone: 'semantic',
    },
    {
      german: "ein Landkreis",
      translated: "okrug (Landkreis)",
      tone: 'semantic',
    },
    {
      german: "in Thüringen",
      translated: "u saveznoj zemlji Tiringija",
      tone: 'semantic',
    },
  ],
  "lid:state:TH:2|it": [
    {
      german: "Welches ist",
      translated: "Quale dei seguenti è",
      tone: 'semantic',
    },
    {
      german: "ein Landkreis",
      translated: "un distretto (Landkreis)",
      tone: 'semantic',
    },
    {
      german: "in Thüringen",
      translated: "di Turingia",
      tone: 'semantic',
    },
  ],
  "lid:state:TH:2|kmr": [
    {
      german: "Welches ist",
      translated: "Kîjan ji van",
      tone: 'semantic',
    },
    {
      german: "ein Landkreis",
      translated: "navçeyek (Landkreis)",
      tone: 'semantic',
    },
    {
      german: "in Thüringen",
      translated: "li Thüringen",
      tone: 'semantic',
    },
  ],
  "lid:state:TH:2|pl": [
    {
      german: "Welches ist",
      translated: "Który",
      tone: 'semantic',
    },
    {
      german: "ein Landkreis",
      translated: "powiatem (Landkreis)",
      tone: 'semantic',
    },
    {
      german: "in Thüringen",
      translated: "w Turyngia?",
      tone: 'semantic',
    },
  ],
  "lid:state:TH:2|prs": [
    {
      german: "Welches ist",
      translated: "کدام‌یک از",
      tone: 'semantic',
    },
    {
      german: "ein Landkreis",
      translated: "یک شهرستان (Landkreis)",
      tone: 'semantic',
    },
    {
      german: "in Thüringen",
      translated: "در تورینگن است",
      tone: 'semantic',
    },
  ],
  "lid:state:TH:2|ro": [
    {
      german: "Welches ist",
      translated: "Care dintre următoarele este",
      tone: 'semantic',
    },
    {
      german: "ein Landkreis",
      translated: "district (Landkreis)",
      tone: 'semantic',
    },
    {
      german: "in Thüringen",
      translated: "din Turingia",
      tone: 'semantic',
    },
  ],
  "lid:state:TH:2|ru": [
    {
      german: "Welches ist",
      translated: "Какой из перечисленных",
      tone: 'semantic',
    },
    {
      german: "ein Landkreis",
      translated: "районом",
      tone: 'semantic',
    },
    {
      german: "in Thüringen",
      translated: "в федеральной земле Тюрингия",
      tone: 'semantic',
    },
  ],
  "lid:state:TH:2|sq": [
    {
      german: "Welches ist",
      translated: "Cila nga këto është",
      tone: 'semantic',
    },
    {
      german: "ein Landkreis",
      translated: "qark (Landkreis)",
      tone: 'semantic',
    },
    {
      german: "in Thüringen",
      translated: "në Thüringen",
      tone: 'semantic',
    },
  ],
  "lid:state:TH:2|sr": [
    {
      german: "Welches ist",
      translated: "Šta je od navedenoga",
      tone: 'semantic',
    },
    {
      german: "ein Landkreis",
      translated: "okrug (Landkreis)",
      tone: 'semantic',
    },
    {
      german: "in Thüringen",
      translated: "u saveznoj pokrajini Tiringija",
      tone: 'semantic',
    },
  ],
  "lid:state:TH:2|tr": [
    {
      german: "Welches ist",
      translated: "Aşağıdakilerden hangisi",
      tone: 'semantic',
    },
    {
      german: "ein Landkreis",
      translated: "bir Landkreis (ilçe/idari bölge)",
      tone: 'semantic',
    },
    {
      german: "in Thüringen",
      translated: "Thüringen eyaletinde bulunan",
      tone: 'semantic',
    },
  ],
  "lid:state:TH:2|uk": [
    {
      german: "Welches ist",
      translated: "Який із",
      tone: 'semantic',
    },
    {
      german: "ein Landkreis",
      translated: "наведених районів",
      tone: 'semantic',
    },
    {
      german: "in Thüringen",
      translated: "у федеральній землі Тюрингія",
      tone: 'semantic',
    },
  ],
  "lid:state:TH:2|vi": [
    {
      german: "Welches ist",
      translated: "Địa danh nào sau đây là",
      tone: 'semantic',
    },
    {
      german: "ein Landkreis",
      translated: "một huyện",
      tone: 'semantic',
    },
    {
      german: "in Thüringen",
      translated: "của bang Thüringen",
      tone: 'semantic',
    },
  ],
  "lid:state:TH:3|ar": [
    {
      german: "Für wie viele Jahre",
      translated: "لمدة كم سنة",
      tone: 'semantic',
    },
    {
      german: "der Landtag in Thüringen",
      translated: "برلمان الولاية في Thüringen",
      tone: 'semantic',
    },
    {
      german: "gewählt",
      translated: "يُنتخب",
      tone: 'semantic',
    },
  ],
  "lid:state:TH:3|bg": [
    {
      german: "Für wie viele Jahre",
      translated: "За колко години",
      tone: 'semantic',
    },
    {
      german: "der Landtag in Thüringen",
      translated: "парламентът на провинция Тюрингия",
      tone: 'semantic',
    },
    {
      german: "gewählt",
      translated: "се избира",
      tone: 'semantic',
    },
  ],
  "lid:state:TH:3|bs": [
    {
      german: "Für wie viele Jahre",
      translated: "Na koliko se godina bira",
      tone: 'semantic',
    },
    {
      german: "der Landtag in Thüringen",
      translated: "parlament savezne zemlje Tiringija",
      tone: 'semantic',
    },
  ],
  "lid:state:TH:3|el": [
    {
      german: "Für wie viele Jahre",
      translated: "Για πόσα χρόνια",
      tone: 'semantic',
    },
    {
      german: "der Landtag in Thüringen",
      translated: "το Landtag του Θουριγγία",
      tone: 'semantic',
    },
    {
      german: "gewählt",
      translated: "εκλέγεται",
      tone: 'semantic',
    },
  ],
  "lid:state:TH:3|en": [
    {
      german: "Für wie viele Jahre",
      translated: "For how many years",
      tone: 'semantic',
    },
    {
      german: "der Landtag in Thüringen",
      translated: "the state parliament in Thüringen",
      tone: 'semantic',
    },
    {
      german: "gewählt",
      translated: "elected",
      tone: 'semantic',
    },
  ],
  "lid:state:TH:3|es": [
    {
      german: "Für wie viele Jahre",
      translated: "¿Por cuántos años",
      tone: 'semantic',
    },
    {
      german: "der Landtag in Thüringen",
      translated: "parlamento regional en Turingia",
      tone: 'semantic',
    },
    {
      german: "gewählt",
      translated: "se elige",
      tone: 'semantic',
    },
  ],
  "lid:state:TH:3|fa": [
    {
      german: "Für wie viele Jahre",
      translated: "برای چند سال",
      tone: 'semantic',
    },
    {
      german: "der Landtag in Thüringen",
      translated: "پارلمان ایالتی تورینگن",
      tone: 'semantic',
    },
    {
      german: "gewählt",
      translated: "انتخاب می‌شود",
      tone: 'semantic',
    },
  ],
  "lid:state:TH:3|fr": [
    {
      german: "Für wie viele Jahre",
      translated: "Pour combien d’années",
      tone: 'semantic',
    },
    {
      german: "der Landtag in Thüringen",
      translated: "le Landtag de Thuringe",
      tone: 'semantic',
    },
    {
      german: "gewählt",
      translated: "élu",
      tone: 'semantic',
    },
  ],
  "lid:state:TH:3|hr": [
    {
      german: "Für wie viele Jahre",
      translated: "Na koliko se godina bira",
      tone: 'semantic',
    },
    {
      german: "der Landtag in Thüringen",
      translated: "parlament savezne zemlje Tiringija",
      tone: 'semantic',
    },
  ],
  "lid:state:TH:3|it": [
    {
      german: "Für wie viele Jahre",
      translated: "Per quanti anni",
      tone: 'semantic',
    },
    {
      german: "der Landtag in Thüringen",
      translated: "il Landtag di Turingia",
      tone: 'semantic',
    },
    {
      german: "gewählt",
      translated: "viene eletto",
      tone: 'semantic',
    },
  ],
  "lid:state:TH:3|kmr": [
    {
      german: "Für wie viele Jahre",
      translated: "çend salan",
      tone: 'semantic',
    },
    {
      german: "der Landtag in Thüringen",
      translated: "Landtag a Thüringen",
      tone: 'semantic',
    },
    {
      german: "gewählt",
      translated: "hilbijartin",
      tone: 'semantic',
    },
  ],
  "lid:state:TH:3|pl": [
    {
      german: "Für wie viele Jahre",
      translated: "Na ile lat",
      tone: 'semantic',
    },
    {
      german: "der Landtag in Thüringen",
      translated: "parlament kraju związkowego Turyngia",
      tone: 'semantic',
    },
    {
      german: "gewählt",
      translated: "wybierany jest",
      tone: 'semantic',
    },
  ],
  "lid:state:TH:3|prs": [
    {
      german: "Für wie viele Jahre",
      translated: "چند سال",
      tone: 'semantic',
    },
    {
      german: "der Landtag in Thüringen",
      translated: "پارلمان ایالتی تورینگن",
      tone: 'semantic',
    },
  ],
  "lid:state:TH:3|ro": [
    {
      german: "Für wie viele Jahre",
      translated: "Pentru câți ani",
      tone: 'semantic',
    },
    {
      german: "der Landtag in Thüringen",
      translated: "parlamentul landului Turingia",
      tone: 'semantic',
    },
    {
      german: "gewählt",
      translated: "ales",
      tone: 'semantic',
    },
  ],
  "lid:state:TH:3|ru": [
    {
      german: "Für wie viele Jahre",
      translated: "На сколько лет",
      tone: 'semantic',
    },
    {
      german: "der Landtag in Thüringen",
      translated: "ландтаг в федеральной земле Тюрингия",
      tone: 'semantic',
    },
    {
      german: "gewählt",
      translated: "избирается",
      tone: 'semantic',
    },
  ],
  "lid:state:TH:3|sq": [
    {
      german: "Für wie viele Jahre",
      translated: "Për sa vjet",
      tone: 'semantic',
    },
    {
      german: "der Landtag in Thüringen",
      translated: "Landtagu i Thüringen",
      tone: 'semantic',
    },
    {
      german: "gewählt",
      translated: "zgjidhet",
      tone: 'semantic',
    },
  ],
  "lid:state:TH:3|sr": [
    {
      german: "Für wie viele Jahre",
      translated: "Na koliko se godina",
      tone: 'semantic',
    },
    {
      german: "der Landtag in Thüringen",
      translated: "parlament savezne pokrajine Tiringija",
      tone: 'semantic',
    },
    {
      german: "gewählt",
      translated: "bira",
      tone: 'semantic',
    },
  ],
  "lid:state:TH:3|tr": [
    {
      german: "Für wie viele Jahre",
      translated: "kaç yıllığına",
      tone: 'semantic',
    },
    {
      german: "der Landtag in Thüringen",
      translated: "Thüringen eyalet parlamentosu",
      tone: 'semantic',
    },
    {
      german: "gewählt",
      translated: "seçilir",
      tone: 'semantic',
    },
  ],
  "lid:state:TH:3|uk": [
    {
      german: "Für wie viele Jahre",
      translated: "На скільки років",
      tone: 'semantic',
    },
    {
      german: "der Landtag in Thüringen",
      translated: "земельний парламент у федеральній землі Тюрингія",
      tone: 'semantic',
    },
    {
      german: "gewählt",
      translated: "обирають",
      tone: 'semantic',
    },
  ],
  "lid:state:TH:3|vi": [
    {
      german: "Für wie viele Jahre",
      translated: "bao nhiêu năm",
      tone: 'semantic',
    },
    {
      german: "der Landtag in Thüringen",
      translated: "Nghị viện bang (Landtag) của Thüringen",
      tone: 'semantic',
    },
    {
      german: "gewählt",
      translated: "được bầu",
      tone: 'semantic',
    },
  ],
  "lid:state:TH:4|ar": [
    {
      german: "Ab welchem Alter",
      translated: "ابتداءً من أي سن",
      tone: 'semantic',
    },
    {
      german: "darf man",
      translated: "يحق",
      tone: 'semantic',
    },
    {
      german: "bei Kommunalwahlen",
      translated: "في الانتخابات المحلية",
      tone: 'semantic',
    },
    {
      german: "wählen",
      translated: "التصويت",
      tone: 'semantic',
    },
  ],
  "lid:state:TH:4|bg": [
    {
      german: "Ab welchem Alter",
      translated: "От каква възраст",
      tone: 'semantic',
    },
    {
      german: "darf man",
      translated: "може да",
      tone: 'semantic',
    },
    {
      german: "in Thüringen",
      translated: "в Тюрингия",
      tone: 'semantic',
    },
    {
      german: "bei Kommunalwahlen",
      translated: "на общински избори",
      tone: 'semantic',
    },
    {
      german: "wählen",
      translated: "се гласува",
      tone: 'semantic',
    },
  ],
  "lid:state:TH:4|bs": [
    {
      german: "Ab welchem Alter",
      translated: "Od koje se dobi",
      tone: 'semantic',
    },
    {
      german: "darf man",
      translated: "može",
      tone: 'semantic',
    },
    {
      german: "in Thüringen",
      translated: "u saveznoj zemlji Tiringija",
      tone: 'semantic',
    },
    {
      german: "bei Kommunalwahlen",
      translated: "na lokalnim izborima",
      tone: 'semantic',
    },
    {
      german: "wählen",
      translated: "glasovati",
      tone: 'semantic',
    },
  ],
  "lid:state:TH:4|el": [
    {
      german: "Ab welchem Alter",
      translated: "Από ποια ηλικία",
      tone: 'semantic',
    },
    {
      german: "darf man",
      translated: "μπορεί κάποιος",
      tone: 'semantic',
    },
    {
      german: "in Thüringen",
      translated: "στο Θουριγγία",
      tone: 'semantic',
    },
    {
      german: "bei Kommunalwahlen",
      translated: "στις δημοτικές εκλογές",
      tone: 'semantic',
    },
    {
      german: "wählen",
      translated: "να ψηφίσει",
      tone: 'semantic',
    },
  ],
  "lid:state:TH:4|en": [
    {
      german: "Ab welchem Alter",
      translated: "From what age",
      tone: 'semantic',
    },
    {
      german: "darf man",
      translated: "can you",
      tone: 'semantic',
    },
    {
      german: "in Thüringen",
      translated: "in Thüringen",
      tone: 'semantic',
    },
    {
      german: "bei Kommunalwahlen",
      translated: "in local elections",
      tone: 'semantic',
    },
    {
      german: "wählen",
      translated: "vote",
      tone: 'semantic',
    },
  ],
  "lid:state:TH:4|es": [
    {
      german: "Ab welchem Alter",
      translated: "A partir de qué edad",
      tone: 'semantic',
    },
    {
      german: "darf man",
      translated: "se puede",
      tone: 'semantic',
    },
    {
      german: "in Thüringen",
      translated: "de Turingia",
      tone: 'semantic',
    },
    {
      german: "bei Kommunalwahlen",
      translated: "en las elecciones municipales",
      tone: 'semantic',
    },
    {
      german: "wählen",
      translated: "votar",
      tone: 'semantic',
    },
  ],
  "lid:state:TH:4|fa": [
    {
      german: "Ab welchem Alter",
      translated: "از چه سنی",
      tone: 'semantic',
    },
    {
      german: "darf man",
      translated: "می‌توان",
      tone: 'semantic',
    },
    {
      german: "in Thüringen",
      translated: "تورینگن",
      tone: 'semantic',
    },
    {
      german: "bei Kommunalwahlen",
      translated: "در انتخابات محلی",
      tone: 'semantic',
    },
    {
      german: "wählen",
      translated: "رأی داد",
      tone: 'semantic',
    },
  ],
  "lid:state:TH:4|fr": [
    {
      german: "Ab welchem Alter",
      translated: "À partir de quel âge",
      tone: 'semantic',
    },
    {
      german: "darf man",
      translated: "peut-on",
      tone: 'semantic',
    },
    {
      german: "in Thüringen",
      translated: "en Thuringe",
      tone: 'semantic',
    },
    {
      german: "bei Kommunalwahlen",
      translated: "aux élections municipales",
      tone: 'semantic',
    },
    {
      german: "wählen",
      translated: "voter",
      tone: 'semantic',
    },
  ],
  "lid:state:TH:4|hr": [
    {
      german: "Ab welchem Alter",
      translated: "Od koje se dobi",
      tone: 'semantic',
    },
    {
      german: "darf man",
      translated: "može",
      tone: 'semantic',
    },
    {
      german: "in Thüringen",
      translated: "u saveznoj zemlji Tiringija",
      tone: 'semantic',
    },
    {
      german: "bei Kommunalwahlen",
      translated: "na lokalnim izborima",
      tone: 'semantic',
    },
    {
      german: "wählen",
      translated: "glasovati",
      tone: 'semantic',
    },
  ],
  "lid:state:TH:4|it": [
    {
      german: "Ab welchem Alter",
      translated: "Da quale età",
      tone: 'semantic',
    },
    {
      german: "darf man",
      translated: "si può",
      tone: 'semantic',
    },
    {
      german: "in Thüringen",
      translated: "in Turingia",
      tone: 'semantic',
    },
    {
      german: "bei Kommunalwahlen",
      translated: "alle elezioni comunali",
      tone: 'semantic',
    },
    {
      german: "wählen",
      translated: "votare",
      tone: 'semantic',
    },
  ],
  "lid:state:TH:4|kmr": [
    {
      german: "Ab welchem Alter",
      translated: "Ji kîjan temenê",
      tone: 'semantic',
    },
    {
      german: "darf man",
      translated: "dikare",
      tone: 'semantic',
    },
    {
      german: "in Thüringen",
      translated: "Thüringen",
      tone: 'semantic',
    },
    {
      german: "bei Kommunalwahlen",
      translated: "di hilbijartinên şaredariyê de",
      tone: 'semantic',
    },
    {
      german: "wählen",
      translated: "deng were dayîn",
      tone: 'semantic',
    },
  ],
  "lid:state:TH:4|pl": [
    {
      german: "Ab welchem Alter",
      translated: "Od jakiego wieku",
      tone: 'semantic',
    },
    {
      german: "darf man",
      translated: "można",
      tone: 'semantic',
    },
    {
      german: "in Thüringen",
      translated: "w Turyngia",
      tone: 'semantic',
    },
    {
      german: "bei Kommunalwahlen",
      translated: "wyborach samorządowych",
      tone: 'semantic',
    },
    {
      german: "wählen",
      translated: "głosować",
      tone: 'semantic',
    },
  ],
  "lid:state:TH:4|prs": [
    {
      german: "Ab welchem Alter",
      translated: "از چه سنی",
      tone: 'semantic',
    },
    {
      german: "darf man",
      translated: "می‌توان",
      tone: 'semantic',
    },
    {
      german: "in Thüringen",
      translated: "تورینگن",
      tone: 'semantic',
    },
    {
      german: "bei Kommunalwahlen",
      translated: "در انتخابات شاروالی",
      tone: 'semantic',
    },
    {
      german: "wählen",
      translated: "رأی داد",
      tone: 'semantic',
    },
  ],
  "lid:state:TH:4|ro": [
    {
      german: "Ab welchem Alter",
      translated: "De la ce vârstă",
      tone: 'semantic',
    },
    {
      german: "darf man",
      translated: "se poate",
      tone: 'semantic',
    },
    {
      german: "in Thüringen",
      translated: "din Turingia",
      tone: 'semantic',
    },
    {
      german: "bei Kommunalwahlen",
      translated: "locale",
      tone: 'semantic',
    },
    {
      german: "wählen",
      translated: "vota",
      tone: 'semantic',
    },
  ],
  "lid:state:TH:4|ru": [
    {
      german: "Ab welchem Alter",
      translated: "С какого возраста",
      tone: 'semantic',
    },
    {
      german: "darf man",
      translated: "можно",
      tone: 'semantic',
    },
    {
      german: "in Thüringen",
      translated: "в федеральной земле Тюрингия",
      tone: 'semantic',
    },
    {
      german: "bei Kommunalwahlen",
      translated: "на муниципальных выборах",
      tone: 'semantic',
    },
    {
      german: "wählen",
      translated: "голосовать",
      tone: 'semantic',
    },
  ],
  "lid:state:TH:4|sq": [
    {
      german: "Ab welchem Alter",
      translated: "Nga cila",
      tone: 'semantic',
    },
    {
      german: "darf man",
      translated: "moshë",
      tone: 'semantic',
    },
    {
      german: "in Thüringen",
      translated: "në Thüringen",
      tone: 'semantic',
    },
    {
      german: "bei Kommunalwahlen",
      translated: "në zgjedhjet komunale",
      tone: 'semantic',
    },
    {
      german: "wählen",
      translated: "votohet",
      tone: 'semantic',
    },
  ],
  "lid:state:TH:4|sr": [
    {
      german: "Ab welchem Alter",
      translated: "Od koje",
      tone: 'semantic',
    },
    {
      german: "darf man",
      translated: "se dobi može",
      tone: 'semantic',
    },
    {
      german: "in Thüringen",
      translated: "u saveznoj pokrajini Tiringija",
      tone: 'semantic',
    },
    {
      german: "bei Kommunalwahlen",
      translated: "na lokalnim izborima",
      tone: 'semantic',
    },
    {
      german: "wählen",
      translated: "glasati",
      tone: 'semantic',
    },
  ],
  "lid:state:TH:4|tr": [
    {
      german: "Ab welchem Alter",
      translated: "kaç yaşından itibaren",
      tone: 'semantic',
    },
    {
      german: "in Thüringen",
      translated: "Thüringen eyaletinde",
      tone: 'semantic',
    },
    {
      german: "bei Kommunalwahlen",
      translated: "yerel seçimlerde",
      tone: 'semantic',
    },
    {
      german: "wählen",
      translated: "oy kullanılabilir",
      tone: 'semantic',
    },
  ],
  "lid:state:TH:4|uk": [
    {
      german: "Ab welchem Alter",
      translated: "З якого віку",
      tone: 'semantic',
    },
    {
      german: "in Thüringen",
      translated: "у федеральній землі Тюрингія",
      tone: 'semantic',
    },
    {
      german: "bei Kommunalwahlen",
      translated: "на муніципальних виборах",
      tone: 'semantic',
    },
    {
      german: "wählen",
      translated: "можна голосувати",
      tone: 'semantic',
    },
  ],
  "lid:state:TH:4|vi": [
    {
      german: "Ab welchem Alter",
      translated: "Từ bao nhiêu tuổi",
      tone: 'semantic',
    },
    {
      german: "darf man",
      translated: "có thể",
      tone: 'semantic',
    },
    {
      german: "in Thüringen",
      translated: "ở bang Thüringen",
      tone: 'semantic',
    },
    {
      german: "bei Kommunalwahlen",
      translated: "trong bầu cử địa phương",
      tone: 'semantic',
    },
    {
      german: "wählen",
      translated: "bỏ phiếu",
      tone: 'semantic',
    },
  ],
  "lid:state:TH:5|ar": [
    {
      german: "Welche Farben",
      translated: "ما ألوان",
      tone: 'semantic',
    },
    {
      german: "Landesflagge von Thüringen",
      translated: "علم ولاية Thüringen",
      tone: 'semantic',
    },
  ],
  "lid:state:TH:5|bg": [
    {
      german: "Welche Farben",
      translated: "Какви са цветовете",
      tone: 'semantic',
    },
    {
      german: "Landesflagge von Thüringen",
      translated: "на знамето на провинция Тюрингия",
      tone: 'semantic',
    },
  ],
  "lid:state:TH:5|bs": [
    {
      german: "Welche Farben",
      translated: "Koje su boje",
      tone: 'semantic',
    },
    {
      german: "Landesflagge von Thüringen",
      translated: "zastave savezne zemlje Tiringija",
      tone: 'semantic',
    },
  ],
  "lid:state:TH:5|el": [
    {
      german: "Welche Farben",
      translated: "Ποια είναι τα χρώματα",
      tone: 'semantic',
    },
    {
      german: "Landesflagge von Thüringen",
      translated: "της σημαίας του κρατιδίου Θουριγγία",
      tone: 'semantic',
    },
  ],
  "lid:state:TH:5|en": [
    {
      german: "Welche Farben",
      translated: "What colors",
      tone: 'semantic',
    },
    {
      german: "Landesflagge von Thüringen",
      translated: "the state flag of Thüringen",
      tone: 'semantic',
    },
  ],
  "lid:state:TH:5|es": [
    {
      german: "Welche Farben",
      translated: "colores",
      tone: 'semantic',
    },
    {
      german: "Landesflagge von Thüringen",
      translated: "bandera regional de Turingia",
      tone: 'semantic',
    },
  ],
  "lid:state:TH:5|fa": [
    {
      german: "Welche Farben",
      translated: "رنگ‌های",
      tone: 'semantic',
    },
    {
      german: "Landesflagge von Thüringen",
      translated: "پرچم ایالت تورینگن",
      tone: 'semantic',
    },
  ],
  "lid:state:TH:5|fr": [
    {
      german: "Welche Farben",
      translated: "Quelles sont les couleurs",
      tone: 'semantic',
    },
    {
      german: "Landesflagge von Thüringen",
      translated: "du drapeau du Land de Thuringe",
      tone: 'semantic',
    },
  ],
  "lid:state:TH:5|hr": [
    {
      german: "Welche Farben",
      translated: "Koje su boje",
      tone: 'semantic',
    },
    {
      german: "Landesflagge von Thüringen",
      translated: "zastave savezne zemlje Tiringija",
      tone: 'semantic',
    },
  ],
  "lid:state:TH:5|it": [
    {
      german: "Welche Farben",
      translated: "Quali sono i colori",
      tone: 'semantic',
    },
    {
      german: "Landesflagge von Thüringen",
      translated: "della bandiera del Land di Turingia",
      tone: 'semantic',
    },
  ],
  "lid:state:TH:5|kmr": [
    {
      german: "Welche Farben",
      translated: "Rengên",
      tone: 'semantic',
    },
    {
      german: "Landesflagge von Thüringen",
      translated: "ala eyaleta Thüringen",
      tone: 'semantic',
    },
  ],
  "lid:state:TH:5|pl": [
    {
      german: "Welche Farben",
      translated: "Jakie są kolory",
      tone: 'semantic',
    },
    {
      german: "Landesflagge von Thüringen",
      translated: "flagi kraju związkowego Turyngia",
      tone: 'semantic',
    },
  ],
  "lid:state:TH:5|prs": [
    {
      german: "Welche Farben",
      translated: "رنگ‌های",
      tone: 'semantic',
    },
    {
      german: "Landesflagge von Thüringen",
      translated: "پرچم ایالت تورینگن",
      tone: 'semantic',
    },
  ],
  "lid:state:TH:5|ro": [
    {
      german: "Welche Farben",
      translated: "Care sunt",
      tone: 'semantic',
    },
    {
      german: "Landesflagge von Thüringen",
      translated: "drapelului landului Turingia",
      tone: 'semantic',
    },
  ],
  "lid:state:TH:5|ru": [
    {
      german: "Welche Farben",
      translated: "Какие цвета",
      tone: 'semantic',
    },
    {
      german: "Landesflagge von Thüringen",
      translated: "у флага земли Тюрингия",
      tone: 'semantic',
    },
  ],
  "lid:state:TH:5|sq": [
    {
      german: "Welche Farben",
      translated: "ngjyrat",
      tone: 'semantic',
    },
    {
      german: "Landesflagge von Thüringen",
      translated: "flamurit të landit Thüringen",
      tone: 'semantic',
    },
  ],
  "lid:state:TH:5|sr": [
    {
      german: "Welche Farben",
      translated: "Koje su boje",
      tone: 'semantic',
    },
    {
      german: "Landesflagge von Thüringen",
      translated: "zastave savezne pokrajine Tiringija",
      tone: 'semantic',
    },
  ],
  "lid:state:TH:5|tr": [
    {
      german: "Welche Farben",
      translated: "renkleri nelerdir",
      tone: 'semantic',
    },
    {
      german: "Landesflagge von Thüringen",
      translated: "Thüringen eyalet bayrağının",
      tone: 'semantic',
    },
  ],
  "lid:state:TH:5|uk": [
    {
      german: "Welche Farben",
      translated: "кольори",
      tone: 'semantic',
    },
    {
      german: "Landesflagge von Thüringen",
      translated: "прапор федеральної землі Тюрингія",
      tone: 'semantic',
    },
  ],
  "lid:state:TH:5|vi": [
    {
      german: "Welche Farben",
      translated: "Màu",
      tone: 'semantic',
    },
    {
      german: "Landesflagge von Thüringen",
      translated: "cờ bang Thüringen",
      tone: 'semantic',
    },
  ],
  "lid:state:TH:6|ar": [
    {
      german: "Wo",
      translated: "أين",
      tone: 'semantic',
    },
    {
      german: "können Sie",
      translated: "يمكنك",
      tone: 'semantic',
    },
    {
      german: "in Thüringen",
      translated: "في Thüringen",
      tone: 'semantic',
    },
    {
      german: "über politische Themen",
      translated: "عن القضايا السياسية",
      tone: 'semantic',
    },
    {
      german: "informieren",
      translated: "الحصول على معلومات",
      tone: 'semantic',
    },
  ],
  "lid:state:TH:6|bg": [
    {
      german: "Wo",
      translated: "Къде",
      tone: 'semantic',
    },
    {
      german: "können Sie",
      translated: "можете",
      tone: 'semantic',
    },
    {
      german: "sich",
      translated: "в",
      tone: 'semantic',
    },
    {
      german: "in Thüringen",
      translated: "Тюрингия",
      tone: 'semantic',
    },
    {
      german: "über politische Themen",
      translated: "по политически теми",
      tone: 'semantic',
    },
    {
      german: "informieren",
      translated: "да получите информация",
      tone: 'semantic',
    },
  ],
  "lid:state:TH:6|bs": [
    {
      german: "Wo",
      translated: "Gdje",
      tone: 'semantic',
    },
    {
      german: "können Sie",
      translated: "mogu",
      tone: 'semantic',
    },
    {
      german: "sich",
      translated: "se",
      tone: 'semantic',
    },
    {
      german: "in Thüringen",
      translated: "u saveznoj zemlji Tiringija",
      tone: 'semantic',
    },
    {
      german: "über politische Themen",
      translated: "o političkim temama",
      tone: 'semantic',
    },
    {
      german: "informieren",
      translated: "dobiti informacije",
      tone: 'semantic',
    },
  ],
  "lid:state:TH:6|el": [
    {
      german: "Wo",
      translated: "Πού",
      tone: 'semantic',
    },
    {
      german: "können Sie",
      translated: "μπορείτε",
      tone: 'semantic',
    },
    {
      german: "in Thüringen",
      translated: "στο Θουριγγία",
      tone: 'semantic',
    },
    {
      german: "über politische Themen",
      translated: "για πολιτικά θέματα",
      tone: 'semantic',
    },
    {
      german: "informieren",
      translated: "να ενημερωθείτε",
      tone: 'semantic',
    },
  ],
  "lid:state:TH:6|en": [
    {
      german: "Wo",
      translated: "Where",
      tone: 'semantic',
    },
    {
      german: "können Sie",
      translated: "can you",
      tone: 'semantic',
    },
    {
      german: "sich",
      translated: "get",
      tone: 'semantic',
    },
    {
      german: "in Thüringen",
      translated: "in Thüringen",
      tone: 'semantic',
    },
    {
      german: "über politische Themen",
      translated: "about political topics",
      tone: 'semantic',
    },
    {
      german: "informieren",
      translated: "information",
      tone: 'semantic',
    },
  ],
  "lid:state:TH:6|es": [
    {
      german: "Wo",
      translated: "¿Dónde",
      tone: 'semantic',
    },
    {
      german: "können Sie",
      translated: "puede",
      tone: 'semantic',
    },
    {
      german: "sich",
      translated: "informarse",
      tone: 'semantic',
    },
    {
      german: "in Thüringen",
      translated: "en Turingia",
      tone: 'semantic',
    },
    {
      german: "über politische Themen",
      translated: "sobre temas políticos",
      tone: 'semantic',
    },
  ],
  "lid:state:TH:6|fa": [
    {
      german: "Wo",
      translated: "کجا",
      tone: 'semantic',
    },
    {
      german: "können Sie",
      translated: "می‌توانید",
      tone: 'semantic',
    },
    {
      german: "in Thüringen",
      translated: "در تورینگن",
      tone: 'semantic',
    },
    {
      german: "über politische Themen",
      translated: " دربارهٔ موضوعات سیاسی",
      tone: 'semantic',
    },
    {
      german: "informieren",
      translated: "اطلاعات کسب کنید",
      tone: 'semantic',
    },
  ],
  "lid:state:TH:6|fr": [
    {
      german: "Wo",
      translated: "Où",
      tone: 'semantic',
    },
    {
      german: "können Sie",
      translated: "pouvez-vous",
      tone: 'semantic',
    },
    {
      german: "sich",
      translated: "vous",
      tone: 'semantic',
    },
    {
      german: "in Thüringen",
      translated: "en Thuringe",
      tone: 'semantic',
    },
    {
      german: "über politische Themen",
      translated: "sur les questions politiques",
      tone: 'semantic',
    },
    {
      german: "informieren",
      translated: "informer",
      tone: 'semantic',
    },
  ],
  "lid:state:TH:6|hr": [
    {
      german: "Wo",
      translated: "Gdje",
      tone: 'semantic',
    },
    {
      german: "können Sie",
      translated: "mogu",
      tone: 'semantic',
    },
    {
      german: "sich",
      translated: "se",
      tone: 'semantic',
    },
    {
      german: "in Thüringen",
      translated: "u saveznoj zemlji Tiringija",
      tone: 'semantic',
    },
    {
      german: "über politische Themen",
      translated: "o političkim temama",
      tone: 'semantic',
    },
    {
      german: "informieren",
      translated: "dobiti informacije",
      tone: 'semantic',
    },
  ],
  "lid:state:TH:6|it": [
    {
      german: "Wo",
      translated: "Dove",
      tone: 'semantic',
    },
    {
      german: "können Sie",
      translated: "si può",
      tone: 'semantic',
    },
    {
      german: "sich",
      translated: "ci",
      tone: 'semantic',
    },
    {
      german: "in Thüringen",
      translated: "in Turingia",
      tone: 'semantic',
    },
    {
      german: "über politische Themen",
      translated: "su temi politici",
      tone: 'semantic',
    },
    {
      german: "informieren",
      translated: "informare",
      tone: 'semantic',
    },
  ],
  "lid:state:TH:6|kmr": [
    {
      german: "Wo",
      translated: "Li",
      tone: 'semantic',
    },
    {
      german: "können Sie",
      translated: "li ku",
      tone: 'semantic',
    },
    {
      german: "sich",
      translated: "dikarî",
      tone: 'semantic',
    },
    {
      german: "in Thüringen",
      translated: "Thüringen",
      tone: 'semantic',
    },
    {
      german: "über politische Themen",
      translated: "li ser mijarên siyasî",
      tone: 'semantic',
    },
    {
      german: "informieren",
      translated: "agahdarî bistînî",
      tone: 'semantic',
    },
  ],
  "lid:state:TH:6|pl": [
    {
      german: "Wo",
      translated: "Gdzie",
      tone: 'semantic',
    },
    {
      german: "können Sie",
      translated: "można",
      tone: 'semantic',
    },
    {
      german: "in Thüringen",
      translated: "w Turyngia",
      tone: 'semantic',
    },
    {
      german: "über politische Themen",
      translated: "na tematy polityczne",
      tone: 'semantic',
    },
    {
      german: "informieren",
      translated: "uzyskać informacje",
      tone: 'semantic',
    },
  ],
  "lid:state:TH:6|prs": [
    {
      german: "Wo",
      translated: "کجا",
      tone: 'semantic',
    },
    {
      german: "können Sie",
      translated: "می‌توانید",
      tone: 'semantic',
    },
    {
      german: "in Thüringen",
      translated: "در تورینگن",
      tone: 'semantic',
    },
    {
      german: "über politische Themen",
      translated: " دربارهٔ موضوعات سیاسی",
      tone: 'semantic',
    },
    {
      german: "informieren",
      translated: "اطلاعات کسب کنید",
      tone: 'semantic',
    },
  ],
  "lid:state:TH:6|ro": [
    {
      german: "Wo",
      translated: "Unde",
      tone: 'semantic',
    },
    {
      german: "können Sie",
      translated: "vă puteți",
      tone: 'semantic',
    },
    {
      german: "in Thüringen",
      translated: "în Turingia",
      tone: 'semantic',
    },
    {
      german: "über politische Themen",
      translated: "despre teme politice",
      tone: 'semantic',
    },
    {
      german: "informieren",
      translated: "informa",
      tone: 'semantic',
    },
  ],
  "lid:state:TH:6|ru": [
    {
      german: "Wo",
      translated: "Где",
      tone: 'semantic',
    },
    {
      german: "können Sie",
      translated: "можно",
      tone: 'semantic',
    },
    {
      german: "in Thüringen",
      translated: "в федеральной земле Тюрингия",
      tone: 'semantic',
    },
    {
      german: "über politische Themen",
      translated: "о политических темах",
      tone: 'semantic',
    },
    {
      german: "informieren",
      translated: "получить информацию",
      tone: 'semantic',
    },
  ],
  "lid:state:TH:6|sq": [
    {
      german: "Wo",
      translated: "Ku",
      tone: 'semantic',
    },
    {
      german: "können Sie",
      translated: "mund të",
      tone: 'semantic',
    },
    {
      german: "in Thüringen",
      translated: "në Thüringen",
      tone: 'semantic',
    },
    {
      german: "über politische Themen",
      translated: "për tema politike",
      tone: 'semantic',
    },
    {
      german: "informieren",
      translated: "informoheni",
      tone: 'semantic',
    },
  ],
  "lid:state:TH:6|sr": [
    {
      german: "Wo",
      translated: "Gdje",
      tone: 'semantic',
    },
    {
      german: "können Sie",
      translated: "mogu",
      tone: 'semantic',
    },
    {
      german: "sich",
      translated: "se",
      tone: 'semantic',
    },
    {
      german: "in Thüringen",
      translated: "u saveznoj pokrajini Tiringija",
      tone: 'semantic',
    },
    {
      german: "über politische Themen",
      translated: "o političkim temama",
      tone: 'semantic',
    },
    {
      german: "informieren",
      translated: "dobiti informacije",
      tone: 'semantic',
    },
  ],
  "lid:state:TH:6|tr": [
    {
      german: "Wo",
      translated: "nereden",
      tone: 'semantic',
    },
    {
      german: "können Sie",
      translated: "alabilirsiniz",
      tone: 'semantic',
    },
    {
      german: "in Thüringen",
      translated: "Thüringen eyaletinde",
      tone: 'semantic',
    },
    {
      german: "über politische Themen",
      translated: "siyasi konular hakkında",
      tone: 'semantic',
    },
    {
      german: "informieren",
      translated: "bilgi",
      tone: 'semantic',
    },
  ],
  "lid:state:TH:6|uk": [
    {
      german: "Wo",
      translated: "Де",
      tone: 'semantic',
    },
    {
      german: "können Sie",
      translated: "можна",
      tone: 'semantic',
    },
    {
      german: "in Thüringen",
      translated: "у федеральній землі Тюрингія",
      tone: 'semantic',
    },
    {
      german: "über politische Themen",
      translated: "про політичні питання",
      tone: 'semantic',
    },
    {
      german: "informieren",
      translated: "отримати інформацію",
      tone: 'semantic',
    },
  ],
  "lid:state:TH:6|vi": [
    {
      german: "Wo",
      translated: "đâu",
      tone: 'semantic',
    },
    {
      german: "können Sie",
      translated: "có thể",
      tone: 'semantic',
    },
    {
      german: "in Thüringen",
      translated: "Ở bang Thüringen",
      tone: 'semantic',
    },
    {
      german: "über politische Themen",
      translated: "về các chủ đề chính trị",
      tone: 'semantic',
    },
    {
      german: "informieren",
      translated: "tìm thông tin",
      tone: 'semantic',
    },
  ],
  "lid:state:TH:7|ar": [
    {
      german: "Die Landeshauptstadt",
      translated: "ما عاصمة",
      tone: 'semantic',
    },
    {
      german: "von",
      translated: "ولاية",
      tone: 'semantic',
    },
    {
      german: "Thüringen",
      translated: "Thüringen",
      tone: 'semantic',
    },
    {
      german: "heißt",
      translated: "؟",
      tone: 'semantic',
    },
  ],
  "lid:state:TH:7|bg": [
    {
      german: "Die Landeshauptstadt",
      translated: "Столицата",
      tone: 'semantic',
    },
    {
      german: "von",
      translated: "на",
      tone: 'semantic',
    },
    {
      german: "Thüringen",
      translated: "Тюрингия",
      tone: 'semantic',
    },
    {
      german: "heißt",
      translated: "е",
      tone: 'semantic',
    },
  ],
  "lid:state:TH:7|bs": [
    {
      german: "Die Landeshauptstadt",
      translated: "Glavni grad",
      tone: 'semantic',
    },
    {
      german: "Thüringen",
      translated: "Tiringija",
      tone: 'semantic',
    },
    {
      german: "heißt",
      translated: "je",
      tone: 'semantic',
    },
  ],
  "lid:state:TH:7|el": [
    {
      german: "Die Landeshauptstadt",
      translated: "Η πρωτεύουσα",
      tone: 'semantic',
    },
    {
      german: "von",
      translated: "του",
      tone: 'semantic',
    },
    {
      german: "Thüringen",
      translated: "Θουριγγία",
      tone: 'semantic',
    },
    {
      german: "heißt",
      translated: "είναι",
      tone: 'semantic',
    },
  ],
  "lid:state:TH:7|en": [
    {
      german: "Die Landeshauptstadt",
      translated: "The state capital",
      tone: 'semantic',
    },
    {
      german: "von",
      translated: "of",
      tone: 'semantic',
    },
    {
      german: "Thüringen",
      translated: "Thüringen",
      tone: 'semantic',
    },
    {
      german: "heißt",
      translated: "is called",
      tone: 'semantic',
    },
  ],
  "lid:state:TH:7|es": [
    {
      german: "Die Landeshauptstadt",
      translated: "La capital del estado federado",
      tone: 'semantic',
    },
    {
      german: "von",
      translated: "de",
      tone: 'semantic',
    },
    {
      german: "Thüringen",
      translated: "Turingia",
      tone: 'semantic',
    },
    {
      german: "heißt",
      translated: "es",
      tone: 'semantic',
    },
  ],
  "lid:state:TH:7|fa": [
    {
      german: "Die Landeshauptstadt",
      translated: "مرکز ایالت",
      tone: 'semantic',
    },
    {
      german: "Thüringen",
      translated: "تورینگن",
      tone: 'semantic',
    },
    {
      german: "heißt",
      translated: "است.",
      tone: 'semantic',
    },
  ],
  "lid:state:TH:7|fr": [
    {
      german: "Die Landeshauptstadt",
      translated: "La capitale du Land",
      tone: 'semantic',
    },
    {
      german: "von",
      translated: "de",
      tone: 'semantic',
    },
    {
      german: "Thüringen",
      translated: "Thuringe",
      tone: 'semantic',
    },
    {
      german: "heißt",
      translated: "s’appelle",
      tone: 'semantic',
    },
  ],
  "lid:state:TH:7|hr": [
    {
      german: "Die Landeshauptstadt",
      translated: "Glavni grad",
      tone: 'semantic',
    },
    {
      german: "von",
      translated: "savezne zemlje",
      tone: 'semantic',
    },
    {
      german: "Thüringen",
      translated: "Tiringija",
      tone: 'semantic',
    },
    {
      german: "heißt",
      translated: "je",
      tone: 'semantic',
    },
  ],
  "lid:state:TH:7|it": [
    {
      german: "Die Landeshauptstadt",
      translated: "La capitale",
      tone: 'semantic',
    },
    {
      german: "von",
      translated: "del Land di",
      tone: 'semantic',
    },
    {
      german: "Thüringen",
      translated: "Turingia",
      tone: 'semantic',
    },
    {
      german: "heißt",
      translated: "è",
      tone: 'semantic',
    },
  ],
  "lid:state:TH:7|kmr": [
    {
      german: "Die Landeshauptstadt",
      translated: "Paytexta eyaleta",
      tone: 'semantic',
    },
    {
      german: "Thüringen",
      translated: "Thüringen",
      tone: 'semantic',
    },
    {
      german: "heißt",
      translated: "e.",
      tone: 'semantic',
    },
  ],
  "lid:state:TH:7|pl": [
    {
      german: "Die Landeshauptstadt",
      translated: "Stolicą kraju związkowego",
      tone: 'semantic',
    },
    {
      german: "Thüringen",
      translated: "Turyngia",
      tone: 'semantic',
    },
    {
      german: "heißt",
      translated: "jest",
      tone: 'semantic',
    },
  ],
  "lid:state:TH:7|prs": [
    {
      german: "Die Landeshauptstadt",
      translated: "مرکز ایالت",
      tone: 'semantic',
    },
    {
      german: "Thüringen",
      translated: "تورینگن",
      tone: 'semantic',
    },
    {
      german: "heißt",
      translated: "است",
      tone: 'semantic',
    },
  ],
  "lid:state:TH:7|ro": [
    {
      german: "Die Landeshauptstadt",
      translated: "Capitala",
      tone: 'semantic',
    },
    {
      german: "von",
      translated: "landului",
      tone: 'semantic',
    },
    {
      german: "Thüringen",
      translated: "Turingia",
      tone: 'semantic',
    },
    {
      german: "heißt",
      translated: "este",
      tone: 'semantic',
    },
  ],
  "lid:state:TH:7|ru": [
    {
      german: "Die Landeshauptstadt",
      translated: "Столица",
      tone: 'semantic',
    },
    {
      german: "von",
      translated: "земли",
      tone: 'semantic',
    },
    {
      german: "Thüringen",
      translated: "Тюрингия",
      tone: 'semantic',
    },
    {
      german: "heißt",
      translated: "называется",
      tone: 'semantic',
    },
  ],
  "lid:state:TH:7|sq": [
    {
      german: "Die Landeshauptstadt",
      translated: "Kryeqyteti",
      tone: 'semantic',
    },
    {
      german: "von",
      translated: "i landit",
      tone: 'semantic',
    },
    {
      german: "Thüringen",
      translated: "Thüringen",
      tone: 'semantic',
    },
    {
      german: "heißt",
      translated: "është",
      tone: 'semantic',
    },
  ],
  "lid:state:TH:7|sr": [
    {
      german: "Die Landeshauptstadt",
      translated: "Glavni grad",
      tone: 'semantic',
    },
    {
      german: "Thüringen",
      translated: "Tiringija",
      tone: 'semantic',
    },
    {
      german: "heißt",
      translated: "je",
      tone: 'semantic',
    },
  ],
  "lid:state:TH:7|tr": [
    {
      german: "Die Landeshauptstadt",
      translated: "başkenti",
      tone: 'semantic',
    },
    {
      german: "von",
      translated: "eyaletinin",
      tone: 'semantic',
    },
    {
      german: "Thüringen",
      translated: "Thüringen",
      tone: 'semantic',
    },
  ],
  "lid:state:TH:7|uk": [
    {
      german: "Die Landeshauptstadt",
      translated: "Столиця федеральної землі",
      tone: 'semantic',
    },
    {
      german: "Thüringen",
      translated: "Тюрингія",
      tone: 'semantic',
    },
    {
      german: "heißt",
      translated: " називається",
      tone: 'semantic',
    },
  ],
  "lid:state:TH:7|vi": [
    {
      german: "Die Landeshauptstadt",
      translated: "Thủ phủ",
      tone: 'semantic',
    },
    {
      german: "von",
      translated: "của bang",
      tone: 'semantic',
    },
    {
      german: "Thüringen",
      translated: "Thüringen",
      tone: 'semantic',
    },
    {
      german: "heißt",
      translated: "là",
      tone: 'semantic',
    },
  ],
  "lid:state:TH:8|ar": [
    {
      german: "Welches Bundesland",
      translated: "أي صورة",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "تمثل موقع ولاية",
      tone: 'semantic',
    },
    {
      german: "Thüringen",
      translated: "Thüringen",
      tone: 'semantic',
    },
  ],
  "lid:state:TH:8|bg": [
    {
      german: "Welches Bundesland",
      translated: "Коя от показаните федерални провинции",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "е",
      tone: 'semantic',
    },
    {
      german: "Thüringen",
      translated: "Тюрингия",
      tone: 'semantic',
    },
  ],
  "lid:state:TH:8|bs": [
    {
      german: "Welches Bundesland",
      translated: "Koja od prikazanih saveznih zemalja",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "je",
      tone: 'semantic',
    },
    {
      german: "Thüringen",
      translated: "Tiringija",
      tone: 'semantic',
    },
  ],
  "lid:state:TH:8|el": [
    {
      german: "Welches Bundesland",
      translated: "Ποιο από τα εικονιζόμενα κρατίδια",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "είναι",
      tone: 'semantic',
    },
    {
      german: "Thüringen",
      translated: "Θουριγγία",
      tone: 'semantic',
    },
  ],
  "lid:state:TH:8|en": [
    {
      german: "Welches Bundesland",
      translated: "Which federal state",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "is",
      tone: 'semantic',
    },
    {
      german: "Thüringen",
      translated: "Thüringen",
      tone: 'semantic',
    },
  ],
  "lid:state:TH:8|es": [
    {
      german: "Welches Bundesland",
      translated: "¿Cuál de las imágenes corresponde al estado federado",
      tone: 'semantic',
    },
    {
      german: "Thüringen",
      translated: "Turingia",
      tone: 'semantic',
    },
  ],
  "lid:state:TH:8|fa": [
    {
      german: "Welches Bundesland",
      translated: "کدام ایالتِ",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "است",
      tone: 'semantic',
    },
    {
      german: "Thüringen",
      translated: "تورینگن",
      tone: 'semantic',
    },
  ],
  "lid:state:TH:8|fr": [
    {
      german: "Welches Bundesland",
      translated: "Quel Land représenté",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "est",
      tone: 'semantic',
    },
    {
      german: "Thüringen",
      translated: "Thuringe",
      tone: 'semantic',
    },
  ],
  "lid:state:TH:8|hr": [
    {
      german: "Welches Bundesland",
      translated: "Koja od prikazanih saveznih zemalja",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "je",
      tone: 'semantic',
    },
    {
      german: "Thüringen",
      translated: "Tiringija",
      tone: 'semantic',
    },
  ],
  "lid:state:TH:8|it": [
    {
      german: "Welches Bundesland",
      translated: "Quale Land rappresentato",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "è",
      tone: 'semantic',
    },
    {
      german: "Thüringen",
      translated: "Turingia",
      tone: 'semantic',
    },
  ],
  "lid:state:TH:8|kmr": [
    {
      german: "Welches Bundesland",
      translated: "Kîjan eyalet",
      tone: 'semantic',
    },
    {
      german: "Thüringen",
      translated: "Thüringen",
      tone: 'semantic',
    },
  ],
  "lid:state:TH:8|pl": [
    {
      german: "Welches Bundesland",
      translated: "Który z przedstawionych krajów związkowych",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "to",
      tone: 'semantic',
    },
    {
      german: "Thüringen",
      translated: "Turyngia",
      tone: 'semantic',
    },
  ],
  "lid:state:TH:8|prs": [
    {
      german: "Welches Bundesland",
      translated: "کدام ایالتِ",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "است؟",
      tone: 'semantic',
    },
    {
      german: "Thüringen",
      translated: "تورینگن",
      tone: 'semantic',
    },
  ],
  "lid:state:TH:8|ro": [
    {
      german: "Welches Bundesland",
      translated: "Care land reprezentat",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "este",
      tone: 'semantic',
    },
    {
      german: "Thüringen",
      translated: "Turingia",
      tone: 'semantic',
    },
  ],
  "lid:state:TH:8|ru": [
    {
      german: "Welches Bundesland",
      translated: "Какая из этих земель",
      tone: 'semantic',
    },
    {
      german: "Thüringen",
      translated: "Тюрингия",
      tone: 'semantic',
    },
  ],
  "lid:state:TH:8|sq": [
    {
      german: "Welches Bundesland",
      translated: "Cili nga landet e paraqitura",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "është",
      tone: 'semantic',
    },
    {
      german: "Thüringen",
      translated: "Thüringen",
      tone: 'semantic',
    },
  ],
  "lid:state:TH:8|sr": [
    {
      german: "Welches Bundesland",
      translated: "Koja od prikazanih saveznih pokrajina",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "je",
      tone: 'semantic',
    },
    {
      german: "Thüringen",
      translated: "Tiringija",
      tone: 'semantic',
    },
  ],
  "lid:state:TH:8|tr": [
    {
      german: "Welches Bundesland",
      translated: "hangi numarayla",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "gösterilmiştir",
      tone: 'semantic',
    },
    {
      german: "Thüringen",
      translated: "Thüringen",
      tone: 'semantic',
    },
  ],
  "lid:state:TH:8|uk": [
    {
      german: "Welches Bundesland",
      translated: "Яка з позначених федеральних земель",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "є",
      tone: 'semantic',
    },
    {
      german: "Thüringen",
      translated: "Тюрингія",
      tone: 'semantic',
    },
  ],
  "lid:state:TH:8|vi": [
    {
      german: "Welches Bundesland",
      translated: "Bang nào trong các hình được hiển thị",
      tone: 'semantic',
    },
    {
      german: "ist",
      translated: "là",
      tone: 'semantic',
    },
    {
      german: "Thüringen",
      translated: "Thüringen",
      tone: 'semantic',
    },
  ],
  "lid:state:TH:9|ar": [
    {
      german: "Wie nennt man",
      translated: "ماذا يُسمى",
      tone: 'semantic',
    },
    {
      german: "die Regierungschefin/den Regierungschef",
      translated: "رئيس/رئيسة حكومة",
      tone: 'semantic',
    },
    {
      german: "in Thüringen",
      translated: "ولاية Thüringen",
      tone: 'semantic',
    },
  ],
  "lid:state:TH:9|bg": [
    {
      german: "Wie nennt man",
      translated: "Как се нарича",
      tone: 'semantic',
    },
    {
      german: "die Regierungschefin/den Regierungschef",
      translated: "ръководителят на правителството",
      tone: 'semantic',
    },
    {
      german: "in Thüringen",
      translated: "на провинция Тюрингия",
      tone: 'semantic',
    },
  ],
  "lid:state:TH:9|bs": [
    {
      german: "Wie nennt man",
      translated: "Kako se zove",
      tone: 'semantic',
    },
    {
      german: "die Regierungschefin/den Regierungschef",
      translated: "šef vlade",
      tone: 'semantic',
    },
    {
      german: "in Thüringen",
      translated: "savezne zemlje Tiringija",
      tone: 'semantic',
    },
  ],
  "lid:state:TH:9|el": [
    {
      german: "Wie nennt man",
      translated: "Πώς ονομάζεται ο",
      tone: 'semantic',
    },
    {
      german: "die Regierungschefin/den Regierungschef",
      translated: "επικεφαλής της κυβέρνησης",
      tone: 'semantic',
    },
    {
      german: "in Thüringen",
      translated: "του κρατιδίου Θουριγγία",
      tone: 'semantic',
    },
  ],
  "lid:state:TH:9|en": [
    {
      german: "Wie nennt man",
      translated: "What is",
      tone: 'semantic',
    },
    {
      german: "die Regierungschefin/den Regierungschef",
      translated: "the head of government",
      tone: 'semantic',
    },
    {
      german: "in Thüringen",
      translated: "in Thüringen",
      tone: 'semantic',
    },
  ],
  "lid:state:TH:9|es": [
    {
      german: "Wie nennt man",
      translated: "¿Cómo se llama al",
      tone: 'semantic',
    },
    {
      german: "die Regierungschefin/den Regierungschef",
      translated: "jefe o la jefa de gobierno",
      tone: 'semantic',
    },
    {
      german: "in Thüringen",
      translated: "de Turingia",
      tone: 'semantic',
    },
  ],
  "lid:state:TH:9|fa": [
    {
      german: "Wie nennt man",
      translated: "رئیس دولت ایالت تورینگن",
      tone: 'semantic',
    },
    {
      german: "die Regierungschefin/den Regierungschef",
      translated: "چه عنوانی دارد",
      tone: 'semantic',
    },
    {
      german: "in Thüringen",
      translated: "؟",
      tone: 'semantic',
    },
  ],
  "lid:state:TH:9|fr": [
    {
      german: "Wie nennt man",
      translated: "Comment appelle-t-on",
      tone: 'semantic',
    },
    {
      german: "die Regierungschefin/den Regierungschef",
      translated: "le chef ou la cheffe du gouvernement",
      tone: 'semantic',
    },
    {
      german: "in Thüringen",
      translated: "de Thuringe",
      tone: 'semantic',
    },
  ],
  "lid:state:TH:9|hr": [
    {
      german: "Wie nennt man",
      translated: "Kako se",
      tone: 'semantic',
    },
    {
      german: "die Regierungschefin/den Regierungschef",
      translated: "čelnik vlade savezne zemlje",
      tone: 'semantic',
    },
    {
      german: "in Thüringen",
      translated: "Tiringija",
      tone: 'semantic',
    },
  ],
  "lid:state:TH:9|it": [
    {
      german: "Wie nennt man",
      translated: "Come si chiama",
      tone: 'semantic',
    },
    {
      german: "die Regierungschefin/den Regierungschef",
      translated: "il capo del governo",
      tone: 'semantic',
    },
    {
      german: "in Thüringen",
      translated: "del Land di Turingia",
      tone: 'semantic',
    },
  ],
  "lid:state:TH:9|kmr": [
    {
      german: "Wie nennt man",
      translated: "Serokê",
      tone: 'semantic',
    },
    {
      german: "die Regierungschefin/den Regierungschef",
      translated: "hukûmeta",
      tone: 'semantic',
    },
    {
      german: "in Thüringen",
      translated: "Thüringen çi tê gotin",
      tone: 'semantic',
    },
  ],
  "lid:state:TH:9|pl": [
    {
      german: "Wie nennt man",
      translated: "Jak nazywa się",
      tone: 'semantic',
    },
    {
      german: "die Regierungschefin/den Regierungschef",
      translated: "szef rządu kraju związkowego",
      tone: 'semantic',
    },
    {
      german: "in Thüringen",
      translated: "Turyngia",
      tone: 'semantic',
    },
  ],
  "lid:state:TH:9|prs": [
    {
      german: "Wie nennt man",
      translated: "رئیس دولت ایالت تورینگن",
      tone: 'semantic',
    },
    {
      german: "die Regierungschefin/den Regierungschef",
      translated: "چه عنوانی دارد",
      tone: 'semantic',
    },
    {
      german: "in Thüringen",
      translated: "؟",
      tone: 'semantic',
    },
  ],
  "lid:state:TH:9|ro": [
    {
      german: "Wie nennt man",
      translated: "Cum se numește",
      tone: 'semantic',
    },
    {
      german: "die Regierungschefin/den Regierungschef",
      translated: "șeful guvernului landului Turingia",
      tone: 'semantic',
    },
  ],
  "lid:state:TH:9|ru": [
    {
      german: "Wie nennt man",
      translated: "Как называют",
      tone: 'semantic',
    },
    {
      german: "die Regierungschefin/den Regierungschef",
      translated: "главу правительства",
      tone: 'semantic',
    },
    {
      german: "in Thüringen",
      translated: "в федеральной земле Тюрингия",
      tone: 'semantic',
    },
  ],
  "lid:state:TH:9|sq": [
    {
      german: "Wie nennt man",
      translated: "Si quhet",
      tone: 'semantic',
    },
    {
      german: "die Regierungschefin/den Regierungschef",
      translated: "kreu i qeverisë",
      tone: 'semantic',
    },
    {
      german: "in Thüringen",
      translated: "landit Thüringen",
      tone: 'semantic',
    },
  ],
  "lid:state:TH:9|sr": [
    {
      german: "Wie nennt man",
      translated: "Kako se zove",
      tone: 'semantic',
    },
    {
      german: "die Regierungschefin/den Regierungschef",
      translated: "šef vlade savezne pokrajine",
      tone: 'semantic',
    },
    {
      german: "in Thüringen",
      translated: "Tiringija",
      tone: 'semantic',
    },
  ],
  "lid:state:TH:9|tr": [
    {
      german: "Wie nennt man",
      translated: "ne ad verilir",
      tone: 'semantic',
    },
    {
      german: "die Regierungschefin/den Regierungschef",
      translated: "hükümetinin başındaki kişiye",
      tone: 'semantic',
    },
    {
      german: "in Thüringen",
      translated: "Thüringen",
      tone: 'semantic',
    },
  ],
  "lid:state:TH:9|uk": [
    {
      german: "Wie nennt man",
      translated: "Як називають",
      tone: 'semantic',
    },
    {
      german: "die Regierungschefin/den Regierungschef",
      translated: "главу уряду федеральної землі",
      tone: 'semantic',
    },
    {
      german: "in Thüringen",
      translated: "Тюрингія",
      tone: 'semantic',
    },
  ],
  "lid:state:TH:9|vi": [
    {
      german: "Wie nennt man",
      translated: "được gọi là",
      tone: 'semantic',
    },
    {
      german: "die Regierungschefin/den Regierungschef",
      translated: "Người đứng đầu chính phủ",
      tone: 'semantic',
    },
    {
      german: "in Thüringen",
      translated: "bang Thüringen",
      tone: 'semantic',
    },
  ],
};
